import * as i0 from '@angular/core';
import { Component, EventEmitter, Directive, Input, Output, HostListener, InjectionToken, Inject, HostBinding, Optional, Injectable, forwardRef, NgModule, ChangeDetectionStrategy, Pipe, ViewChild, Self, SkipSelf, ElementRef, ContentChildren, Host, ContentChild, ViewChildren, TemplateRef, SecurityContext, ChangeDetectorRef, ViewEncapsulation, isDevMode, ANIMATION_MODULE_TYPE } from '@angular/core';
import * as i1$5 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$6 from '@angular/forms';
import { Validators, NG_VALIDATORS, NG_VALUE_ACCESSOR, FormGroup, FormGroupDirective, FormsModule, UntypedFormControl, ReactiveFormsModule, FormControlName, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import * as i1$9 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3$1 from '@angular/material/menu';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import * as i2$3 from 'angular-split';
import { AngularSplitModule } from 'angular-split';
import { NgChartsModule } from 'ng2-charts';
import * as i10 from 'ngx-autofocus-fix';
import { AutofocusFixConfig, AutofocusFixModule } from 'ngx-autofocus-fix';
import * as i4 from '@angular/material/tooltip';
import { MatTooltip, MAT_TOOLTIP_SCROLL_STRATEGY, MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import * as i1 from '@angular/cdk/overlay';
import { OverlayContainer, Overlay } from '@angular/cdk/overlay';
import * as i2 from '@angular/cdk/platform';
import { _isTestEnvironment } from '@angular/cdk/platform';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i2$1 from '@angular/cdk/bidi';
import _, { defer, noop, escape, isNil, isEmpty, throttle, debounce, omit, isEqual, cloneDeep, uniqBy } from 'lodash';
import * as i1$3 from 'rxjs';
import { Subscription, Subject, BehaviorSubject, ReplaySubject, of, map as map$1, merge, startWith, filter as filter$1, EMPTY, take, tap as tap$1, mergeMap, forkJoin, iif, defer as defer$1, throwError, timer, delay, empty, combineLatest, pipe } from 'rxjs';
import * as i1$1 from '@angular/material/checkbox';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import * as i6 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularResizableDirective, AngularDraggableModule } from 'angular2-draggable';
import * as i1$4 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import GraphemeSplitter from 'grapheme-splitter';
import * as i2$2 from '@angular/platform-browser';
import { map, filter, switchMap, first, debounceTime, tap, startWith as startWith$1, catchError, finalize, takeUntil, delay as delay$1, mergeMap as mergeMap$1, take as take$1, concatMap } from 'rxjs/operators';
import * as i1$b from '@angular/animations';
import { trigger, state, style, transition, animate, AUTO_STYLE, query } from '@angular/animations';
import moment from 'moment';
import { __decorate } from 'tslib';
import * as i3$2 from '@angular/router';
import { RouterModule, RouterLink } from '@angular/router';
import * as i1$7 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import * as i1$8 from '@angular/common/http';
import * as i5 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i6$1 from '@angular/material/core';
import { MatRippleModule, MAT_DATE_LOCALE, DateAdapter, MatNativeDateModule } from '@angular/material/core';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3$3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { TAB } from '@angular/cdk/keycodes';
import * as i8 from '@angular/material/radio';
import { MatRadioModule, MatRadioButton } from '@angular/material/radio';
import * as i1$a from '@swimlane/ngx-charts';
import { AreaChartComponent, BarVerticalComponent, BubbleChartComponent, LineChartComponent, PieChartComponent, PolarChartComponent, NgxChartsModule } from '@swimlane/ngx-charts';
import momentJDate from 'moment-jdateformatparser';
import * as i2$4 from '@angular-material-components/datetime-picker';
import { NgxMatDateAdapter, NGX_MAT_DATE_FORMATS, NgxMatNativeDateModule, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import * as i9 from 'ngx-autosize-input';
import { AutoSizeInputModule } from 'ngx-autosize-input';
import * as i10$1 from 'ngx-autosize';
import { AutosizeModule } from 'ngx-autosize';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import * as i15 from '@angular/cdk/drag-drop';
import { DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import scrollIntoView from 'scroll-into-view-if-needed';
import * as i23 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i2$7 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i2$5 from 'ngx-file-drop';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MatSelectModule } from '@angular/material/select';
import FroalaEditor from 'froala-editor';
import * as i6$2 from 'angular-froala-wysiwyg';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import * as i2$6 from '@angular/material/tabs';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import * as i2$8 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkTableModule } from '@angular/cdk/table';
import { MatDividerModule } from '@angular/material/divider';
import * as i3$4 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTreeNestedDataSource, MatTreeModule } from '@angular/material/tree';
import * as i6$3 from '@angular/cdk/tree';
import { NestedTreeControl, CdkNestedTreeNode, CdkTreeModule } from '@angular/cdk/tree';
import * as i4$1 from '@angular/cdk/scrolling';
import * as i4$2 from '@angular/cdk/clipboard';
import { ClipboardModule } from '@angular/cdk/clipboard';
import * as ace from 'ace-builds';
import beautify from 'ace-builds/src-noconflict/ext-beautify';
import 'ace-builds/src-noconflict/ace';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';

class CoreUiComponent {
    /**
     * @ignore
     */
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function CoreUiComponent_Factory(t) { return new (t || CoreUiComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoreUiComponent, selectors: [["lib-ex-ui"]], decls: 2, vars: 0, template: function CoreUiComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, " core-ui works! ");
            i0.ɵɵelementEnd();
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoreUiComponent, [{
        type: Component,
        args: [{ selector: 'lib-ex-ui', template: `
    <p>
      core-ui works!
    </p>
  ` }]
    }], function () { return []; }, null); })();

class ExClickOutsideDirective {
    /**
     * @ignore
     */
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        /**
        * If true, will not emit event when an element with class 'cdk-overlay-backdrop' exists;
        * (for example, when a mat-menu is open)
        */
        this.ignoreIfCdkOverlayExists = false;
        /**
        * list of classes to ignore, as css selector ('.' before class name)
        */
        this.ignore = "";
        this.ignoreClassList = [];
        /**
         * event fired when a click event is detected outside of the component
         */
        this.clickOutside = new EventEmitter();
    }
    ngOnInit() {
        this.ignoreClassList = this.ignore.split(".");
        if (this.ignoreClassList.length == 1 && this.ignoreClassList[0].length == 0) {
            this.ignoreClassList = [];
        }
        this.ignoreClassList.forEach(c => c = c.trim());
    }
    onClick(targetElement) {
        let cdkOverlayBackdropElement = null;
        if (this.ignoreIfCdkOverlayExists) {
            cdkOverlayBackdropElement = document.querySelector('.cdk-overlay-backdrop');
        }
        if (!cdkOverlayBackdropElement) {
            const clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                let ignoreClassFound = false;
                for (let i = 0; i < this.ignoreClassList.length; i++) {
                    for (let j = 0; j < targetElement.classList.length; j++) {
                        if (targetElement.classList[j] === this.ignoreClassList[i]) {
                            ignoreClassFound = true;
                            break;
                        }
                    }
                    if (ignoreClassFound) {
                        break;
                    }
                }
                if (!ignoreClassFound) {
                    this.clickOutside.emit();
                }
            }
        }
    }
    static { this.ɵfac = function ExClickOutsideDirective_Factory(t) { return new (t || ExClickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExClickOutsideDirective, selectors: [["", "clickOutside", ""]], hostBindings: function ExClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function ExClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { ignoreIfCdkOverlayExists: "ignoreIfCdkOverlayExists", ignore: "ignore" }, outputs: { clickOutside: "clickOutside" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { ignoreIfCdkOverlayExists: [{
            type: Input
        }], ignore: [{
            type: Input
        }], clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

const WINDOW = new InjectionToken('WINDOW', {
    providedIn: 'root',
    factory: () => window
});
// @dynamic
class ExInViewportDirective {
    get isInViewport() {
        return this.inViewport;
    }
    get isNotInViewport() {
        return !this.inViewport;
    }
    /**
     * @ignore
     */
    constructor(el, window) {
        this.el = el;
        this.window = window;
        /**
         * event fired when the element enter or exit the viewport
         */
        this.snInViewport = new EventEmitter();
    }
    ngAfterViewInit() {
        const IntersectionObserver = this.window['IntersectionObserver'];
        if (typeof IntersectionObserver !== 'undefined') {
            this.observer = new IntersectionObserver(this.intersectionObserverCallback.bind(this));
            this.observer.observe(this.el.nativeElement);
        }
    }
    ngOnDestroy() {
        this.observer?.unobserve(this.el.nativeElement);
    }
    intersectionObserverCallback(entries) {
        entries.forEach(entry => {
            if (this.inViewport === entry.isIntersecting) {
                return;
            }
            this.inViewport = entry.isIntersecting;
            this.snInViewport.emit(this.inViewport);
        });
    }
    static { this.ɵfac = function ExInViewportDirective_Factory(t) { return new (t || ExInViewportDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(WINDOW)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExInViewportDirective, selectors: [["", "snInViewport", ""]], hostVars: 4, hostBindings: function ExInViewportDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("sn-viewport--in", ctx.isInViewport)("sn-viewport--out", ctx.isNotInViewport);
        } }, outputs: { snInViewport: "snInViewport" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInViewportDirective, [{
        type: Directive,
        args: [{
                selector: '[snInViewport]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }]; }, { snInViewport: [{
            type: Output
        }], isInViewport: [{
            type: HostBinding,
            args: ['class.sn-viewport--in']
        }], isNotInViewport: [{
            type: HostBinding,
            args: ['class.sn-viewport--out']
        }] }); })();

class ExTooltipDirective extends MatTooltip {
    get exTooltip() {
        return this.message;
    }
    set exTooltip(value) {
        this.message = value;
    }
    constructor(el, overlay, elementRef, scrollDispatcher, viewContainerRef, ngZone, platform, ariaDescriber, focusMonitor, scrollStrategy, dir, defaultOptions, document) {
        super(overlay, elementRef, scrollDispatcher, viewContainerRef, ngZone, platform, ariaDescriber, focusMonitor, scrollStrategy, dir, defaultOptions, document);
        this.el = el;
        this.document = document;
        this.keydownListenerAdded = false;
        this.escapeListener = (event) => {
            if (event.key === "Escape") {
                event.stopPropagation();
                event.preventDefault();
                this.hide();
                this.removeMouseLeaveListener();
            }
        };
        this.mouseLeaveListener = () => {
            this.removeEscapeListener();
            this.removeMouseLeaveListener();
        };
        this.handleEscape = (event) => {
            if (event.key?.toLowerCase() === 'escape') {
                event.stopImmediatePropagation();
                event.stopPropagation();
                event.preventDefault();
                this.hide();
            }
        };
        el.nativeElement.addEventListener('mouseenter', () => {
            el.nativeElement.addEventListener('mouseleave', this.mouseLeaveListener);
            this.document.addEventListener('keydown', this.escapeListener);
            this.keydownListenerAdded = true;
        });
    }
    show(delay) {
        super.show(delay);
        this.addEscapeListener();
    }
    hide(delay) {
        super.hide(delay);
        this._removeEscapeListener();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.removeEscapeListener();
    }
    removeEscapeListener() {
        this._removeEscapeListener();
        if (this.keydownListenerAdded) {
            this.document.removeEventListener('keydown', this.escapeListener);
            this.keydownListenerAdded = false;
        }
    }
    removeMouseLeaveListener() {
        this.el.nativeElement.removeEventListener('mouseleave', this.mouseLeaveListener);
    }
    addEscapeListener() {
        document.addEventListener('keydown', this.handleEscape, true);
    }
    _removeEscapeListener() {
        document.removeEventListener('keydown', this.handleEscape, true);
    }
    static { this.ɵfac = function ExTooltipDirective_Factory(t) { return new (t || ExTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.ScrollDispatcher), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.Platform), i0.ɵɵdirectiveInject(i3.AriaDescriber), i0.ɵɵdirectiveInject(i3.FocusMonitor), i0.ɵɵdirectiveInject(MAT_TOOLTIP_SCROLL_STRATEGY), i0.ɵɵdirectiveInject(i2$1.Directionality, 8), i0.ɵɵdirectiveInject(MAT_TOOLTIP_DEFAULT_OPTIONS, 8), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExTooltipDirective, selectors: [["", "exTooltip", ""]], inputs: { exTooltip: "exTooltip" }, exportAs: ["exTooltip"], features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[exTooltip]',
                exportAs: 'exTooltip'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.Overlay }, { type: i0.ElementRef }, { type: i1.ScrollDispatcher }, { type: i0.ViewContainerRef }, { type: i0.NgZone }, { type: i2.Platform }, { type: i3.AriaDescriber }, { type: i3.FocusMonitor }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_TOOLTIP_SCROLL_STRATEGY]
            }] }, { type: i2$1.Directionality, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_TOOLTIP_DEFAULT_OPTIONS]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { exTooltip: [{
            type: Input
        }] }); })();

class EditModeComponentDirective {
    constructor() { }
    static { this.ɵfac = function EditModeComponentDirective_Factory(t) { return new (t || EditModeComponentDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EditModeComponentDirective, selectors: [["", "editModeComponent", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditModeComponentDirective, [{
        type: Directive,
        args: [{
                selector: '[editModeComponent]'
            }]
    }], function () { return []; }, null); })();

class ViewModeComponentDirective {
    constructor() { }
    static { this.ɵfac = function ViewModeComponentDirective_Factory(t) { return new (t || ViewModeComponentDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ViewModeComponentDirective, selectors: [["", "viewModeComponent", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewModeComponentDirective, [{
        type: Directive,
        args: [{
                selector: '[viewModeComponent]'
            }]
    }], function () { return []; }, null); })();

const EX_SECTION_IDENTIFIER = new InjectionToken('EX_SECTION_IDENTIFIER');
class ExSectionIdentifierDirective {
    set headerTemplate(template) {
        this.header = template;
    }
    constructor(template) {
        this.template = template;
        this.expanded = true;
        this.hasCollapse = true;
        this.isCustomizable = true;
        this.isHidden = false;
        this.isHiddenByDefault = false;
        this.isMandatory = false;
        this.hasRequired = false;
        this.title = '';
        this.icon = undefined;
    }
    static { this.ɵfac = function ExSectionIdentifierDirective_Factory(t) { return new (t || ExSectionIdentifierDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExSectionIdentifierDirective, selectors: [["", "exIdentifier", ""]], inputs: { exIdentifier: "exIdentifier", expanded: ["exIdentifierExpanded", "expanded"], hasCollapse: ["exIdentifierHasCollapse", "hasCollapse"], isCustomizable: ["exIdentifierIsCustomizable", "isCustomizable"], isHidden: ["exIdentifierIsHidden", "isHidden"], isHiddenByDefault: ["exIdentifierIsHiddenByDefault", "isHiddenByDefault"], isMandatory: ["exIdentifierIsMandatory", "isMandatory"], hasRequired: ["exIdentifierHasRequired", "hasRequired"], title: ["exIdentifierTitle", "title"], icon: ["exIdentifierIcon", "icon"], headerTemplate: ["exIdentifierHeaderTemplate", "headerTemplate"] }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: EX_SECTION_IDENTIFIER,
                    useFactory: (dir) => dir.exIdentifier,
                    deps: [ExSectionIdentifierDirective]
                }
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionIdentifierDirective, [{
        type: Directive,
        args: [{
                selector: '[exIdentifier]',
                providers: [
                    {
                        provide: EX_SECTION_IDENTIFIER,
                        useFactory: (dir) => dir.exIdentifier,
                        deps: [ExSectionIdentifierDirective]
                    }
                ]
            }]
    }], function () { return [{ type: i0.TemplateRef }]; }, { exIdentifier: [{
            type: Input
        }], expanded: [{
            type: Input,
            args: ['exIdentifierExpanded']
        }], hasCollapse: [{
            type: Input,
            args: ['exIdentifierHasCollapse']
        }], isCustomizable: [{
            type: Input,
            args: ['exIdentifierIsCustomizable']
        }], isHidden: [{
            type: Input,
            args: ['exIdentifierIsHidden']
        }], isHiddenByDefault: [{
            type: Input,
            args: ['exIdentifierIsHiddenByDefault']
        }], isMandatory: [{
            type: Input,
            args: ['exIdentifierIsMandatory']
        }], hasRequired: [{
            type: Input,
            args: ['exIdentifierHasRequired']
        }], title: [{
            type: Input,
            args: ['exIdentifierTitle']
        }], icon: [{
            type: Input,
            args: ['exIdentifierIcon']
        }], headerTemplate: [{
            type: Input,
            args: ['exIdentifierHeaderTemplate']
        }] }); })();

class ExFormFieldDirective {
    constructor(template) {
        this.template = template;
    }
    static { this.ɵfac = function ExFormFieldDirective_Factory(t) { return new (t || ExFormFieldDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFormFieldDirective, selectors: [["", "exFormField", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormFieldDirective, [{
        type: Directive,
        args: [{
                selector: '[exFormField]'
            }]
    }], function () { return [{ type: i0.TemplateRef }]; }, null); })();

class ExSectionHeaderDirective {
    constructor(template, sectionIdentifier) {
        this.template = template;
        this.sectionIdentifier = sectionIdentifier;
    }
    ngOnInit() {
        this.sectionIdentifier.headerTemplate = this.template;
    }
    static { this.ɵfac = function ExSectionHeaderDirective_Factory(t) { return new (t || ExSectionHeaderDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(ExSectionIdentifierDirective)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExSectionHeaderDirective, selectors: [["", "exSectionHeader", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[exSectionHeader]'
            }]
    }], function () { return [{ type: i0.TemplateRef }, { type: ExSectionIdentifierDirective }]; }, null); })();

class ExMultiLayoutIdentifierDirective {
    constructor(tmpl) {
        this.tmpl = tmpl;
        this.exMultiLayoutId = "";
        this.label = "";
        this.iconType = "uxf";
        this.iconName = "";
        this.switchToLayoutId = "";
    }
    get template() {
        return this.tmpl;
    }
    static { this.ɵfac = function ExMultiLayoutIdentifierDirective_Factory(t) { return new (t || ExMultiLayoutIdentifierDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExMultiLayoutIdentifierDirective, selectors: [["", "exMultiLayout", ""]], inputs: { exMultiLayoutId: ["exMultiLayout", "exMultiLayoutId"], label: ["exMultiLayoutLabel", "label"], iconType: ["exMultiLayoutIconType", "iconType"], iconName: ["exMultiLayoutIconName", "iconName"], switchToLayoutId: ["exMultiLayoutSwitchToLayoutId", "switchToLayoutId"] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMultiLayoutIdentifierDirective, [{
        type: Directive,
        args: [{
                selector: '[exMultiLayout]'
            }]
    }], function () { return [{ type: i0.TemplateRef }]; }, { exMultiLayoutId: [{
            type: Input,
            args: ['exMultiLayout']
        }], label: [{
            type: Input,
            args: ['exMultiLayoutLabel']
        }], iconType: [{
            type: Input,
            args: ['exMultiLayoutIconType']
        }], iconName: [{
            type: Input,
            args: ['exMultiLayoutIconName']
        }], switchToLayoutId: [{
            type: Input,
            args: ['exMultiLayoutSwitchToLayoutId']
        }] }); })();

class ExCarouselLayoutIdentifierDirective {
    constructor(tmpl) {
        this.tmpl = tmpl;
    }
    get template() {
        return this.tmpl;
    }
    static { this.ɵfac = function ExCarouselLayoutIdentifierDirective_Factory(t) { return new (t || ExCarouselLayoutIdentifierDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExCarouselLayoutIdentifierDirective, selectors: [["", "exCarouselLayoutItem", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCarouselLayoutIdentifierDirective, [{
        type: Directive,
        args: [{
                selector: '[exCarouselLayoutItem]'
            }]
    }], function () { return [{ type: i0.TemplateRef }]; }, null); })();

class MinValidator {
    validate(control) {
        return this.min ? Validators.min(this.min)(control) : null;
    }
    static { this.ɵfac = function MinValidator_Factory(t) { return new (t || MinValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MinValidator, selectors: [["", "min", ""]], inputs: { min: "min" }, exportAs: ["min"], features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: MinValidator, multi: true }])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MinValidator, [{
        type: Directive,
        args: [{
                selector: '[min]',
                exportAs: 'min',
                providers: [{ provide: NG_VALIDATORS, useExisting: MinValidator, multi: true }]
            }]
    }], null, { min: [{
            type: Input,
            args: ['min']
        }] }); })();

class NoResultsComponentDirective {
    constructor(template) {
        this.template = template;
    }
    static { this.ɵfac = function NoResultsComponentDirective_Factory(t) { return new (t || NoResultsComponentDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: NoResultsComponentDirective, selectors: [["", "noResultsComponent", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoResultsComponentDirective, [{
        type: Directive,
        args: [{
                selector: '[noResultsComponent]'
            }]
    }], function () { return [{ type: i0.TemplateRef }]; }, null); })();

class ExFocusDirective {
    set exFocus(focus) {
        this._hasFocus = focus;
        if (focus == true) {
            this.focusElement();
        }
        else if (focus == false) {
            this.blurElement();
        }
    }
    get hasFocus() {
        return this._hasFocus;
    }
    get element() {
        return this.elemRef;
    }
    onBlur(e) {
        this._hasFocus = false;
        this.exFocusChange.emit(this._hasFocus);
    }
    onFocus(e) {
        this._hasFocus = true;
        this.exFocusChange.emit(this._hasFocus);
    }
    constructor(elemRef, zone) {
        this.elemRef = elemRef;
        this.zone = zone;
        this.exFocusChange = new EventEmitter();
        this._hasFocus = false;
    }
    focusElement() {
        this.zone.runOutsideAngular(() => defer(() => this.elemRef?.nativeElement?.focus()));
    }
    blurElement() {
        this.elemRef?.nativeElement?.blur();
    }
    static { this.ɵfac = function ExFocusDirective_Factory(t) { return new (t || ExFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFocusDirective, selectors: [["", "exFocus", ""]], hostBindings: function ExFocusDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("focusout", function ExFocusDirective_focusout_HostBindingHandler($event) { return ctx.onBlur($event); })("focusin", function ExFocusDirective_focusin_HostBindingHandler($event) { return ctx.onFocus($event); });
        } }, inputs: { exFocus: "exFocus" }, outputs: { exFocusChange: "exFocusChange" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFocusDirective, [{
        type: Directive,
        args: [{
                selector: '[exFocus]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, { exFocus: [{
            type: Input
        }], exFocusChange: [{
            type: Output
        }], onBlur: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], onFocus: [{
            type: HostListener,
            args: ['focusin', ['$event']]
        }] }); })();

const EX_PAGE_ID = new InjectionToken('EX_PAGE_ID');
const EX_PAGE_ID_WITH_CUSTOMIZATION_PROFILE = new InjectionToken('EX_PAGE_ID_WITH_CUSTOMIZATION_PROFILE');
class ExPageIdDirective {
    set customizationProfile(value) {
        this._customizationProfile = value;
    }
    static { this.ɵfac = function ExPageIdDirective_Factory(t) { return new (t || ExPageIdDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExPageIdDirective, selectors: [["", "exPageId", ""]], inputs: { exPageId: "exPageId" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: EX_PAGE_ID,
                    useFactory: (dir) => {
                        return () => dir.exPageId;
                    },
                    deps: [ExPageIdDirective]
                },
                {
                    provide: EX_PAGE_ID_WITH_CUSTOMIZATION_PROFILE,
                    useFactory: (dir) => {
                        return () => dir.exPageId + (dir._customizationProfile ? ('__' + dir._customizationProfile) : '');
                    },
                    deps: [ExPageIdDirective]
                }
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPageIdDirective, [{
        type: Directive,
        args: [{
                selector: '[exPageId]',
                providers: [
                    {
                        provide: EX_PAGE_ID,
                        useFactory: (dir) => {
                            return () => dir.exPageId;
                        },
                        deps: [ExPageIdDirective]
                    },
                    {
                        provide: EX_PAGE_ID_WITH_CUSTOMIZATION_PROFILE,
                        useFactory: (dir) => {
                            return () => dir.exPageId + (dir._customizationProfile ? ('__' + dir._customizationProfile) : '');
                        },
                        deps: [ExPageIdDirective]
                    }
                ]
            }]
    }], null, { exPageId: [{
            type: Input
        }] }); })();

class DeepLinkModeDirective {
    constructor() { }
    static { this.ɵfac = function DeepLinkModeDirective_Factory(t) { return new (t || DeepLinkModeDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DeepLinkModeDirective, selectors: [["", "deepLinkMode", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeepLinkModeDirective, [{
        type: Directive,
        args: [{
                selector: '[deepLinkMode]'
            }]
    }], function () { return []; }, null); })();

class ExItemsLayoutTreeNodeTemplateDirective {
    constructor() { }
    static { this.ɵfac = function ExItemsLayoutTreeNodeTemplateDirective_Factory(t) { return new (t || ExItemsLayoutTreeNodeTemplateDirective)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExItemsLayoutTreeNodeTemplateDirective, selectors: [["", "treeNodeTemplate", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutTreeNodeTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[treeNodeTemplate]'
            }]
    }], function () { return []; }, null); })();

const EX_ARIA_ATTRIBUTES = new InjectionToken('EX_ARIA_ATTRIBUTES');

class ExFormAriaAttributesDirective {
    constructor(el, ariaAttributesFromInject, matCheckbox, matDatepickerToggle, ariaDescriber, cdr, translateService) {
        this.el = el;
        this.ariaAttributesFromInject = ariaAttributesFromInject;
        this.matCheckbox = matCheckbox;
        this.matDatepickerToggle = matDatepickerToggle;
        this.ariaDescriber = ariaDescriber;
        this.cdr = cdr;
        this.translateService = translateService;
        this.subscription = new Subscription();
        this.errorDescription = "";
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    ngAfterViewInit() {
        // Get the input element
        let inputEl = this.el.nativeElement;
        if (this.matDatepickerToggle) {
            inputEl = this.matDatepickerToggle._button._elementRef.nativeElement;
        }
        // Get the parent form field using the injector
        const attributes = this.ariaAttributesFromInject;
        if (attributes?.getAriaChanged$()) {
            this.subscription = attributes.getAriaChanged$().subscribe(() => {
                this.SetAriaAttributes(attributes, inputEl);
                this.ariaDescriber.removeDescription(inputEl, this.errorDescription);
                if (attributes.getErrorLabel()) {
                    this.errorDescription = this.translateService.instant(attributes.getErrorLabel());
                    this.ariaDescriber.describe(inputEl, this.errorDescription);
                }
            });
        }
        setTimeout(() => this.SetAriaAttributes(attributes, inputEl));
    }
    SetAriaAttributes(attributes, inputEl) {
        // Set the aria attributes
        if (attributes) {
            inputEl.setAttribute('aria-invalid', attributes.getInvalid());
            attributes.getLabel() && inputEl.setAttribute('aria-label', this.translateService.instant(attributes.getLabel()));
            attributes.getDescription() && this.ariaDescriber.describe(inputEl, this.translateService.instant(attributes.getDescription()));
            attributes.getRequired() && inputEl.setAttribute('aria-required', attributes.getRequired());
            if (this.matCheckbox) {
                attributes.getLabel() && (this.matCheckbox.ariaLabel = this.translateService.instant(attributes.getLabel()));
                attributes.getDescription() && (this.matCheckbox.ariaDescribedby = inputEl.getAttribute('aria-describedby'));
                setTimeout(() => this.cdr.markForCheck());
            }
        }
    }
    static { this.ɵfac = function ExFormAriaAttributesDirective_Factory(t) { return new (t || ExFormAriaAttributesDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(EX_ARIA_ATTRIBUTES, 8), i0.ɵɵdirectiveInject(i1$1.MatCheckbox, 8), i0.ɵɵdirectiveInject(i6.MatDatepickerToggle, 8), i0.ɵɵdirectiveInject(i3.AriaDescriber), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFormAriaAttributesDirective, selectors: [["", "exFormAriaAttributes", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormAriaAttributesDirective, [{
        type: Directive,
        args: [{
                selector: '[exFormAriaAttributes]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [EX_ARIA_ATTRIBUTES]
            }, {
                type: Optional
            }] }, { type: i1$1.MatCheckbox, decorators: [{
                type: Optional
            }] }, { type: i6.MatDatepickerToggle, decorators: [{
                type: Optional
            }] }, { type: i3.AriaDescriber }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, null); })();

const EX_REMOTE_EVENT_TRIGGER = new InjectionToken('EX_REMOTE_EVENT_TRIGGER');
class ExRemoteEventTriggerDirective {
    constructor(trigger, elRef) {
        this.trigger = trigger;
        this.elRef = elRef;
        this.sub = new Subscription();
    }
    ngOnInit() {
        this.initTrigger();
    }
    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
    initTrigger() {
        this._trigger = this.exRemoteEventTrigger || this.trigger;
        if (this._trigger) {
            this.sub.add(this._trigger.subscribe(editMode => this.onTriggerEmit(editMode)));
        }
    }
    onTriggerEmit(event) {
        event && this.elRef.nativeElement.click();
    }
    static { this.ɵfac = function ExRemoteEventTriggerDirective_Factory(t) { return new (t || ExRemoteEventTriggerDirective)(i0.ɵɵdirectiveInject(EX_REMOTE_EVENT_TRIGGER), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExRemoteEventTriggerDirective, selectors: [["", "exRemoteEventTrigger", ""]], inputs: { exRemoteEventTrigger: "exRemoteEventTrigger" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRemoteEventTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[exRemoteEventTrigger]'
            }]
    }], function () { return [{ type: i1$3.Observable, decorators: [{
                type: Inject,
                args: [EX_REMOTE_EVENT_TRIGGER]
            }] }, { type: i0.ElementRef }]; }, { exRemoteEventTrigger: [{
            type: Input,
            args: ['exRemoteEventTrigger']
        }] }); })();

const keyMapSpecial = {
    106: '*',
    107: '+',
    109: '-',
    110: '.',
    111: '/',
    186: ';',
    187: '=',
    188: 'comma',
    189: '-',
    190: 'period',
    191: '/',
    192: '`',
    219: '[',
    220: '\\',
    221: ']',
    222: '\'',
    8: 'backspace',
    9: 'tab',
    13: 'enter',
    16: 'shift',
    17: 'ctrl',
    18: 'alt',
    20: 'capslock',
    27: 'esc',
    32: 'space',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    45: 'ins',
    46: 'del',
    91: 'meta',
    93: 'meta',
    224: 'meta',
    96: '0',
    97: '1',
    98: '2',
    99: '3',
    100: '4',
    101: '5',
    102: '6',
    103: '7',
    104: '8',
    105: '9'
};
class ExShortcutsService {
    constructor(document, rendererFactory, scope) {
        this.document = document;
        this.rendererFactory = rendererFactory;
        this.scope = scope;
        this._applyShortcut = new Subject();
        this.applyShortcut = this._applyShortcut.asObservable();
        this.getShortcutsMap = new BehaviorSubject({});
        this.buffer = [];
        this.keyboardSub = noop;
        this.unlistener = noop;
        this.unlistener1 = noop;
        this.renderer2 = rendererFactory.createRenderer(null, null);
        this.unlistener = this.renderer2.listen(this.document, 'keydown.alt', this.handleKeyboardEventClicked.bind(this, "alt"));
        this.unlistener1 = this.renderer2.listen(this.document, 'keyup', this.handleKeyboardEventLeaved.bind(this));
    }
    refreshShortcutsTextAndPosition() {
        this.getShortcutsMap.next(this.getShortcutsMap.getValue());
    }
    handleKeyboardEventClicked(trigger, event) {
        if (this.buffer.length > 0) {
            return;
        }
        this.selectedActions = Object.entries(this.getShortcutsMap.getValue());
        this.buffer = [trigger];
        this._applyShortcut.next(this.buffer);
        this.updateHideTimeout();
        this.keyboardSub();
        this.keyboardSub = this.renderer2.listen(this.document, 'keydown', this.afterAltClicked.bind(this));
        return false;
    }
    /**
     * Handles cases where the close event fails to hide the hint bubble, ensuring its proper visibility control.
     */
    updateHideTimeout() {
        clearTimeout(this.hintBubbleTimeout);
        this.hintBubbleTimeout = setTimeout(() => {
            this.handleKeyboardEventLeaved(null);
        }, 1000);
    }
    getCharacter(code) {
        if (keyMapSpecial[code]) {
            return keyMapSpecial[code];
        }
        return String.fromCharCode(code).toLowerCase();
    }
    afterAltClicked(e) {
        if (e.key && e.key === 'Alt') {
            this.updateHideTimeout();
            return false;
        }
        clearTimeout(this.hintBubbleTimeout);
        if (e.key && e.altKey) {
            this.selectedActions = this.selectedActions.filter(([key, value]) => value.startsWith((this.getCharacter(e.which)))).map(([key, value]) => [key, value.substring(1)]);
            this.buffer.push(this.getCharacter(e.which));
            this._applyShortcut.next(this.buffer);
            if (this.selectedActions.length > 0) {
                e.preventDefault();
            }
        }
    }
    handleKeyboardEventLeaved(event) {
        if (event && this.getCharacter(event.which) !== 'alt')
            return; // just keyup.up doesn't work in case of alt+rightNumPad
        this.keyboardSub();
        this.buffer = [];
        this._applyShortcut.next(this.buffer);
        return false;
    }
    ngOnDestroy() {
        //this.unlistener();
        //this.unlistener1();
        this.keyboardSub();
    }
    static { this.ɵfac = function ExShortcutsService_Factory(t) { return new (t || ExShortcutsService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(exShortcutsScopeDirective, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExShortcutsService, factory: ExShortcutsService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExShortcutsService, [{
        type: Injectable
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i0.RendererFactory2 }, { type: exShortcutsScopeDirective, decorators: [{
                type: Optional
            }] }]; }, null); })();

class exShortcutsScopeDirective {
    constructor(service) {
        this.service = service;
    }
    focusin() {
        this.name && this.service && (this.service.scope = this);
    }
    ngOnDestroy() {
        if (this.name && this.service && this.service.scope == this) {
            this.service.scope = null;
        }
    }
    static { this.ɵfac = function exShortcutsScopeDirective_Factory(t) { return new (t || exShortcutsScopeDirective)(i0.ɵɵdirectiveInject(forwardRef(() => ExShortcutsService), 8)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: exShortcutsScopeDirective, selectors: [["", "exShortcutsScope", ""]], hostBindings: function exShortcutsScopeDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("focusin", function exShortcutsScopeDirective_focusin_HostBindingHandler() { return ctx.focusin(); });
        } }, inputs: { name: ["exShortcutsScope", "name"] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(exShortcutsScopeDirective, [{
        type: Directive,
        args: [{
                selector: '[exShortcutsScope]'
            }]
    }], function () { return [{ type: ExShortcutsService, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [forwardRef(() => ExShortcutsService)]
            }] }]; }, { name: [{
            type: Input,
            args: ['exShortcutsScope']
        }], focusin: [{
            type: HostListener,
            args: ['focusin']
        }] }); })();

class ExKeyboardShortcutDirective extends ExRemoteEventTriggerDirective {
    constructor(exShortcuts, elRef, tooltip, renderer, document, scope) {
        super(null, elRef);
        this.exShortcuts = exShortcuts;
        this.elRef = elRef;
        this.tooltip = tooltip;
        this.renderer = renderer;
        this.document = document;
        this.scope = scope;
        this.position = 'start';
        this.currentSelection = [];
        this.exRemoteEventTrigger = exShortcuts?.applyShortcut;
    }
    initTrigger() {
        if (!this.exShortcuts) {
            return;
        }
        super.initTrigger();
        this.sub.add(this.exShortcuts.getShortcutsMap.subscribe((shortcutsMap) => {
            if (this.name && shortcutsMap[this.name]) {
                if (shortcutsMap[this.name] === "number") {
                    this.hotKey = this.index.toString();
                }
                else {
                    this.hotKey = shortcutsMap[this.name] + (this.index?.toString() || "");
                }
                // we don't need to update the bubble location when they close.
                (this.currentSelection.length > 0) && this.relocateHintBubble();
            }
            if (!!this.child && !!this.text) {
                this.renderer.removeChild(this.child, this.text);
                this.setLabel();
            }
        }));
        this.child = this.renderer.createElement('div');
        this.setLabel();
        this.renderer.setStyle(this.child, 'visibility', 'hidden');
        this.renderer.addClass(this.child, "hintHotKeyTooltipNG");
        this.renderer.appendChild(this.elRef.nativeElement, this.child);
    }
    setLabel() {
        this.text = this.renderer.createText({ "comma": "<", "period": ">" }[this.hotKey] || this.hotKey?.toUpperCase?.());
        this.renderer.appendChild(this.child, this.text);
    }
    onTriggerEmit(event) {
        if (!this.hotKey) {
            return;
        }
        if ((this?.scope?.name !== this.exShortcuts?.scope?.name && this.exShortcuts?.scope?.name !== "main")
            || (this.scope && !this.scope.name)) {
            return;
        }
        if (this.elRef.nativeElement.disabled) {
            return;
        }
        if (this.currentSelection.length > 1 && this.currentSelection.slice(1).join("") === this.hotKey && event.length == 0) {
            this.elRef.nativeElement.focus();
            this.elRef.nativeElement.click();
        }
        this.currentSelection = event;
        if (event.length === 1 && event[0] === "alt") {
            // show bubble
            this.relocateHintBubble();
            this.renderer.removeStyle(this.child, 'visibility');
        }
        else if (event.length == 0) {
            // hide bubble
            this.renderer.setStyle(this.child, 'visibility', 'hidden');
        }
        else if (event.length > 1 && event[0] === "alt" && this.hotKey && this.hotKey.startsWith(event.slice(1).join(""))) {
            if (event.slice(1).join("") === this.hotKey) {
                //complete match
            }
            else {
                // start match
            }
        }
        else {
            // hide bubble due to mismatch
            this.renderer.setStyle(this.child, 'visibility', 'hidden');
        }
    }
    relocateHintBubble() {
        const { top, left, right } = this.elRef.nativeElement.getBoundingClientRect();
        /**
         * | Position\\Lang | RTL   | LTR   |
         * |----------------|-------|-------|
         * | Start          | right | left  |
         * | End            | left  | right |
         *  */
        const totalPosition = (((this.document.dir == "rtl") === (this.position === "start")) ? (right - 11) : left);
        this.renderer.setStyle(this.child, 'top', top + "px");
        this.renderer.setStyle(this.child, 'left', totalPosition + "px");
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static { this.ɵfac = function ExKeyboardShortcutDirective_Factory(t) { return new (t || ExKeyboardShortcutDirective)(i0.ɵɵdirectiveInject(ExShortcutsService, 8), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.MatTooltip, 8), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(exShortcutsScopeDirective, 8)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExKeyboardShortcutDirective, selectors: [["", "exKeyboardShortcut", ""]], inputs: { name: ["exKeyboardShortcut", "name"], index: ["exKeyboardShortcutIndex", "index"], position: ["exKeyboardShortcutPosition", "position"] }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExKeyboardShortcutDirective, [{
        type: Directive,
        args: [{
                selector: '[exKeyboardShortcut]'
            }]
    }], function () { return [{ type: ExShortcutsService, decorators: [{
                type: Optional
            }] }, { type: i0.ElementRef }, { type: i4.MatTooltip, decorators: [{
                type: Optional
            }] }, { type: i0.Renderer2 }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: exShortcutsScopeDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [exShortcutsScopeDirective]
            }] }]; }, { name: [{
            type: Input,
            args: ['exKeyboardShortcut']
        }], index: [{
            type: Input,
            args: ['exKeyboardShortcutIndex']
        }], position: [{
            type: Input,
            args: ['exKeyboardShortcutPosition']
        }] }); })();

const EX_QUICK_ACCESS = new InjectionToken('service');
const EX_QUICK_ACCESS_SCOPE = new InjectionToken('quick acssess scope');
const EX_QUICK_ACCESS_ACTIVE = new InjectionToken('quick acssess active');
var QuickAccessType;
(function (QuickAccessType) {
    QuickAccessType["SECTION"] = "Section";
    QuickAccessType["ACTION"] = "Action";
    QuickAccessType["FIELD_EDIT"] = "Field";
    QuickAccessType["FIELD_VIEW"] = "Field";
    QuickAccessType["FIELD"] = "Field";
})(QuickAccessType || (QuickAccessType = {}));

class ExQuickAccessDirective {
    constructor(quickAccessService, elRef, renderer) {
        this.quickAccessService = quickAccessService;
        this.elRef = elRef;
        this.renderer = renderer;
        this.disabled = false;
    }
    ngOnInit() {
        if (!this.quickAccessService) {
            return;
        }
        setTimeout(() => {
            this.quickAccessService?.updateData(this.name, this.type, this.disabled, this.sectionId);
        }, 1000);
        this.quickAccessService?.applyFocus.subscribe(data => this.onTriggerEmit(data));
        this.quickAccessService?.focusOut$.subscribe(event => {
            !this.elRef.nativeElement.contains(event.target) && this.resetStyles();
        });
    }
    onTriggerEmit(event) {
        if (this.elRef.nativeElement.disabled) {
            return;
        }
        if (event && event.key === this.name && event.type === this.type) {
            if (this.type == QuickAccessType.FIELD) {
                this.elRef.nativeElement.focus();
                this.renderer.setStyle(this.elRef.nativeElement, 'width', 'fit-content');
                this.renderer.setStyle(this.elRef.nativeElement, 'border', '2px solid black');
                this.renderer.setStyle(this.elRef.nativeElement, 'padding-inline', '4px');
            }
            else {
                this.elRef.nativeElement.focus();
                this.elRef.nativeElement.click();
            }
        }
    }
    resetStyles() {
        this.renderer.removeStyle(this.elRef.nativeElement, 'width');
        this.renderer.removeStyle(this.elRef.nativeElement, 'border');
        this.renderer.removeStyle(this.elRef.nativeElement, 'padding-inline');
        this.renderer.removeStyle(this.elRef.nativeElement, 'outline');
        this.renderer.removeStyle(this.elRef.nativeElement, 'outline-offset');
    }
    ngOnDestroy() {
        this.quickAccessService?.removeKey(this.name, this.type);
    }
    static { this.ɵfac = function ExQuickAccessDirective_Factory(t) { return new (t || ExQuickAccessDirective)(i0.ɵɵdirectiveInject(EX_QUICK_ACCESS, 8), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExQuickAccessDirective, selectors: [["", "exQuickAccess", ""]], inputs: { name: ["exQuickAccess", "name"], type: ["exQuickAccessType", "type"], sectionId: ["exQuickAccessSection", "sectionId"], disabled: ["exQuickAccessDisabled", "disabled"] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExQuickAccessDirective, [{
        type: Directive,
        args: [{
                selector: '[exQuickAccess]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS]
            }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { name: [{
            type: Input,
            args: ['exQuickAccess']
        }], type: [{
            type: Input,
            args: ['exQuickAccessType']
        }], sectionId: [{
            type: Input,
            args: ['exQuickAccessSection']
        }], disabled: [{
            type: Input,
            args: ['exQuickAccessDisabled']
        }] }); })();

class ResizedDirective {
    constructor(element, zone) {
        this.element = element;
        this.zone = zone;
        this.resizeCB = noop;
        this.resized = new EventEmitter();
        this.observer = new ResizeObserver(entries => this.zone.run(() => this.observe(entries)));
    }
    ngOnInit() {
        this.observer.observe(this.element.nativeElement);
    }
    ngOnDestroy() {
        this.observer.disconnect();
    }
    observe(entries) {
        const domSize = entries[0];
        const resizedEvent = new ResizedEvent(domSize.contentRect, this.oldRect);
        this.oldRect = domSize.contentRect;
        this.resized.emit(resizedEvent);
        this.resizeCB(resizedEvent);
    }
    static { this.ɵfac = function ResizedDirective_Factory(t) { return new (t || ResizedDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ResizedDirective, selectors: [["", "resized", ""]], inputs: { resizeCB: "resizeCB" }, outputs: { resized: "resized" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResizedDirective, [{
        type: Directive,
        args: [{
                selector: '[resized]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, { resizeCB: [{
            type: Input
        }], resized: [{
            type: Output
        }] }); })();

class AngularResizeEventModule {
    static { this.ɵfac = function AngularResizeEventModule_Factory(t) { return new (t || AngularResizeEventModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AngularResizeEventModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AngularResizeEventModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ResizedDirective
                ],
                imports: [],
                exports: [
                    ResizedDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AngularResizeEventModule, { declarations: [ResizedDirective], exports: [ResizedDirective] }); })();
class ResizedEvent {
    constructor(newRect, oldRect) {
        this.newRect = newRect;
        this.oldRect = oldRect;
        this.isFirst = oldRect == null;
    }
}

class IFeatureFlagsService {
    static { this.ɵfac = function IFeatureFlagsService_Factory(t) { return new (t || IFeatureFlagsService)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IFeatureFlagsService }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IFeatureFlagsService, [{
        type: Directive
    }], null, null); })();

class ExResizableDirective extends AngularResizableDirective {
    set exResizable(v) {
        this.ngResizable = v;
        if (v) {
            this.initKeyboardResizeListener();
        }
        else {
            this.removeKeyboardResizeListener();
        }
    }
    constructor(_el, _renderer, translate, ngZone, featureFlag) {
        super(_el, _renderer);
        this._el = _el;
        this._renderer = _renderer;
        this.translate = translate;
        this.ngZone = ngZone;
        this.featureFlag = featureFlag;
    }
    ngAfterViewInit() {
    }
    initKeyboardResizeListener() {
        this.featureFlag.isActive('RESIZE_ACCESSIBILITY').subscribe((res) => {
            if (res) {
                setTimeout(() => {
                    const ngResizableHandle = this._el.nativeElement.querySelector('.ng-resizable-handle');
                    this._renderer.addClass(ngResizableHandle, 'resize-handle-wrapper');
                    this._renderer.setAttribute(ngResizableHandle, 'tabindex', '0');
                    ngResizableHandle?.addEventListener('keydown', this.handleResizeKeyDown.bind(this));
                }, 1000);
            }
        });
    }
    handleResizeKeyDown(event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            this.ngZone.run(() => {
                let width = this._el.nativeElement.offsetWidth;
                let left = this._el.nativeElement.offsetLeft;
                let delta = 5;
                if (this.rzHandles == 'e') {
                    if (event.key === 'ArrowRight') {
                        width += delta;
                    }
                    else if (event.key === 'ArrowLeft') {
                        width -= delta;
                    }
                }
                else if (this.rzHandles == 'w') {
                    if (event.key === 'ArrowLeft') {
                        width += delta;
                        left -= delta;
                    }
                    else if (event.key === 'ArrowRight') {
                        width -= delta;
                        left += delta;
                    }
                }
                if (width < this.rzMaxWidth && width > this.rzMinWidth) {
                    this._renderer.setStyle(this._el.nativeElement, 'width', `${width}px`);
                    this._renderer.setStyle(this._el.nativeElement, 'left', `${left}px`);
                    event.preventDefault();
                }
            });
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.removeKeyboardResizeListener();
    }
    removeKeyboardResizeListener() {
        const ngResizableHandle = document.querySelector('.ng-resizable-handle');
        if (ngResizableHandle) {
            ngResizableHandle.removeEventListener('keydown', this.handleResizeKeyDown.bind(this));
        }
    }
    static { this.ɵfac = function ExResizableDirective_Factory(t) { return new (t || ExResizableDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(IFeatureFlagsService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExResizableDirective, selectors: [["", "exResizable", ""]], inputs: { exResizable: "exResizable" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExResizableDirective, [{
        type: Directive,
        args: [{
                selector: '[exResizable]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$2.TranslateService }, { type: i0.NgZone }, { type: IFeatureFlagsService }]; }, { exResizable: [{
            type: Input
        }] }); })();

class ExDirectivesModule {
    static { this.ɵfac = function ExDirectivesModule_Factory(t) { return new (t || ExDirectivesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDirectivesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, AngularResizeEventModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDirectivesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExClickOutsideDirective,
                    ExInViewportDirective,
                    ExTooltipDirective,
                    MinValidator,
                    EditModeComponentDirective,
                    ViewModeComponentDirective,
                    ExSectionIdentifierDirective,
                    ExFormFieldDirective,
                    ExSectionHeaderDirective,
                    ExMultiLayoutIdentifierDirective,
                    ExCarouselLayoutIdentifierDirective,
                    NoResultsComponentDirective,
                    ExFocusDirective,
                    ExPageIdDirective,
                    DeepLinkModeDirective,
                    ExItemsLayoutTreeNodeTemplateDirective,
                    ExFormAriaAttributesDirective,
                    ExRemoteEventTriggerDirective,
                    ExKeyboardShortcutDirective,
                    exShortcutsScopeDirective,
                    ExQuickAccessDirective,
                    ExResizableDirective
                ],
                exports: [
                    ExClickOutsideDirective,
                    ExInViewportDirective,
                    ExTooltipDirective,
                    MinValidator,
                    EditModeComponentDirective,
                    ViewModeComponentDirective,
                    ExSectionIdentifierDirective,
                    ExFormFieldDirective,
                    ExSectionHeaderDirective,
                    ExMultiLayoutIdentifierDirective,
                    ExCarouselLayoutIdentifierDirective,
                    NoResultsComponentDirective,
                    ExFocusDirective,
                    ExPageIdDirective,
                    DeepLinkModeDirective,
                    ExItemsLayoutTreeNodeTemplateDirective,
                    ExFormAriaAttributesDirective,
                    ExRemoteEventTriggerDirective,
                    ExKeyboardShortcutDirective,
                    exShortcutsScopeDirective,
                    ExQuickAccessDirective,
                    AngularResizeEventModule,
                    ExResizableDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDirectivesModule, { declarations: [ExClickOutsideDirective,
        ExInViewportDirective,
        ExTooltipDirective,
        MinValidator,
        EditModeComponentDirective,
        ViewModeComponentDirective,
        ExSectionIdentifierDirective,
        ExFormFieldDirective,
        ExSectionHeaderDirective,
        ExMultiLayoutIdentifierDirective,
        ExCarouselLayoutIdentifierDirective,
        NoResultsComponentDirective,
        ExFocusDirective,
        ExPageIdDirective,
        DeepLinkModeDirective,
        ExItemsLayoutTreeNodeTemplateDirective,
        ExFormAriaAttributesDirective,
        ExRemoteEventTriggerDirective,
        ExKeyboardShortcutDirective,
        exShortcutsScopeDirective,
        ExQuickAccessDirective,
        ExResizableDirective], imports: [CommonModule], exports: [ExClickOutsideDirective,
        ExInViewportDirective,
        ExTooltipDirective,
        MinValidator,
        EditModeComponentDirective,
        ViewModeComponentDirective,
        ExSectionIdentifierDirective,
        ExFormFieldDirective,
        ExSectionHeaderDirective,
        ExMultiLayoutIdentifierDirective,
        ExCarouselLayoutIdentifierDirective,
        NoResultsComponentDirective,
        ExFocusDirective,
        ExPageIdDirective,
        DeepLinkModeDirective,
        ExItemsLayoutTreeNodeTemplateDirective,
        ExFormAriaAttributesDirective,
        ExRemoteEventTriggerDirective,
        ExKeyboardShortcutDirective,
        exShortcutsScopeDirective,
        ExQuickAccessDirective,
        AngularResizeEventModule,
        ExResizableDirective] }); })();

class ExSpinnerComponent {
    /**
     * Informative label that will be displayed while the spinner appears
     */
    // @Input()
    // status: string;
    constructor() {
        /**
         * The spinner diameter. Default is 40px.
         */
        this.diameter = 40;
        /**
         * the progress spinner mode
         * indeterminate - spinner spins continuously
         * determinate - spinner progress determined according to 'progress' value
         */
        this.mode = "indeterminate";
        /**
         * the progress value of the spinner when the spinner mode is 'determinate'
         */
        this.progress = 0;
    }
    static { this.ɵfac = function ExSpinnerComponent_Factory(t) { return new (t || ExSpinnerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSpinnerComponent, selectors: [["ex-spinner"]], inputs: { diameter: "diameter", mode: "mode", progress: "progress" }, decls: 1, vars: 3, consts: [["aria-label", "progress", 1, "sel-ex-spinner", 3, "diameter", "mode", "value"]], template: function ExSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "mat-progress-spinner", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("diameter", ctx.diameter)("mode", ctx.mode)("value", ctx.progress);
        } }, dependencies: [i1$4.MatProgressSpinner], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSpinnerComponent, [{
        type: Component,
        args: [{ selector: 'ex-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-progress-spinner class=\"sel-ex-spinner\" [diameter]=\"diameter\" [mode]=\"mode\" [value]=\"progress\" aria-label=\"progress\">\n</mat-progress-spinner>\n<!-- <span>{{ status }}</span> -->" }]
    }], function () { return []; }, { diameter: [{
            type: Input
        }], mode: [{
            type: Input
        }], progress: [{
            type: Input
        }] }); })();

class ExGenerateIdPipe {
    transform(action) {
        let uniqueSelector = (action.key || action.value || action.name || action.label || action || '');
        uniqueSelector = uniqueSelector.includes(" ") ? '' : uniqueSelector;
        return "sel-id-" + uniqueSelector.replace(/\./g, '-');
    }
    static { this.ɵfac = function ExGenerateIdPipe_Factory(t) { return new (t || ExGenerateIdPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "generateHTMLId", type: ExGenerateIdPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGenerateIdPipe, [{
        type: Pipe,
        args: [{
                name: 'generateHTMLId'
            }]
    }], null, null); })();

function ExActionMenuComponent_div_0_i_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 8);
} }
function ExActionMenuComponent_div_0_ng_container_8_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r4 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
const _c0$1S = function (a0) { return { "ex-action-menu-actions-disabled": a0 }; };
function ExActionMenuComponent_div_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 10);
    i0.ɵɵlistener("click", function ExActionMenuComponent_div_0_ng_container_8_Template_button_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const action_r6 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.actionClicked.emit(action_r6.value)); });
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExActionMenuComponent_div_0_ng_container_8_ng_container_7_Template, 1, 1, "ng-container", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", action_r6.tooltip ? i0.ɵɵpipeBind1(2, 8, action_r6.tooltip) : "");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-action-menu-item ", i0.ɵɵpipeBind1(4, 10, ctx_r3.uniqueSelector ? "ex-action-menu-item-" + ctx_r3.uniqueSelector + ((action_r6 == null ? null : action_r6.value) ? action_r6 == null ? null : action_r6.value : "") : action_r6), "");
    i0.ɵɵproperty("disabled", action_r6.disabled || action_r6.loading)("ngClass", i0.ɵɵpureFunction1(14, _c0$1S, action_r6.disabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 12, action_r6.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", action_r6.loading);
} }
function ExActionMenuComponent_div_0_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 13);
} if (rf & 2) {
    i0.ɵɵproperty("mode", "indeterminate")("diameter", 15);
} }
const _c1$1f = function (a0) { return { "ex-action-menu-main-buttons-selected": a0 }; };
const _c2$S = function (a0, a1, a2) { return { "background": a0, "color": a1, "borderColor": a2 }; };
function ExActionMenuComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    i0.ɵɵlistener("mouseover", function ExActionMenuComponent_div_0_Template_button_mouseover_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.hover = true); })("mouseleave", function ExActionMenuComponent_div_0_Template_button_mouseleave_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.hover = false); })("click", function ExActionMenuComponent_div_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onMoreClicked()); })("menuOpened", function ExActionMenuComponent_div_0_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.isMenuOpen = true); })("menuClosed", function ExActionMenuComponent_div_0_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.isMenuOpen = false); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ExActionMenuComponent_div_0_i_5_Template, 1, 0, "i", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-menu", 4, 5);
    i0.ɵɵtemplate(8, ExActionMenuComponent_div_0_ng_container_8_Template, 8, 16, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExActionMenuComponent_div_0_ng_template_9_Template, 1, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(7);
    const _r4 = i0.ɵɵreference(10);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-action-menu-main-buttons ex-action-menu-more-btn ", i0.ɵɵpipeBind1(2, 13, "ex-action-menu-more-btn" + (ctx_r0.uniqueSelector ? "-" + ctx_r0.uniqueSelector : "")), "");
    i0.ɵɵproperty("exTooltip", !ctx_r0.moreActionDisabled ? i0.ɵɵpipeBind1(3, 15, "ng.general.more_actions") : "")("ngClass", i0.ɵɵpureFunction1(19, _c1$1f, ctx_r0.isSelected))("matMenuTriggerFor", _r2)("ngStyle", i0.ɵɵpureFunction3(21, _c2$S, ctx_r0.isSelected ? ctx_r0.hover ? ctx_r0.selectedHoverBackgroundColor : ctx_r0.selectedBackgroundColor : ctx_r0.hover ? ctx_r0.hoverBackgroundColor : ctx_r0.backgroundColor, ctx_r0.hover ? ctx_r0.hoverFontColor : ctx_r0.fontColor, ctx_r0.isSelected ? ctx_r0.selectedBorderColor : ctx_r0.borderColor))("disabled", ctx_r0.moreActionDisabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 17, "ng.general.more_actions"))("aria-expanded", ctx_r0.isMenuOpen);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.loading || ctx_r0.isMenuOpen)("ngIfElse", _r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.actions);
} }
class ExActionMenuComponent {
    constructor() {
        /**
         * list of actions in menu from ActionModel type
         */
        this.actions = [];
        /**
         * action button background color
         */
        this.backgroundColor = '#f2f2f2';
        /**
         * action button background color on hover
         */
        this.hoverBackgroundColor = '#e9e9e9';
        /**
         * action button background when row selected color
         */
        this.selectedBackgroundColor = '#f2f2f2';
        /**
         * action button background when selected (isSelected = true) color on hover
         */
        this.selectedHoverBackgroundColor = '#e9e9e9';
        /**
         * action button font color
         */
        this.fontColor = 'black';
        /**
         * action button font color on hover
         */
        this.hoverFontColor = 'black';
        /**
        * action button border color
        */
        this.borderColor = '#c8c8c8';
        /**
        * action button border color when selected (isSelected = true)
        */
        this.selectedBorderColor = '#c8c8c8';
        /**
        * is the record selected or not
        */
        this.isSelected = false;
        /**
        * is one of the action loading - will display a spinner on the button
        */
        this.loading = false;
        /**
         * Emits the action that has been chosen
         */
        this.actionClicked = new EventEmitter();
        this.hover = false;
        /**
         * more actions icon is disabled if all actions are loading or disabled
         */
        this.moreActionDisabled = false;
        /**
         * for Accessibility - indicates if more actions menu is open or closed
         */
        this.isMenuOpen = false;
    }
    /**
     * @ignore
     */
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('actions')) {
            this.moreActionDisabled = this.actions.filter(a => a.disabled || a.loading).length === this.actions.length;
        }
    }
    onMoreClicked() {
        event.stopPropagation();
    }
    static { this.ɵfac = function ExActionMenuComponent_Factory(t) { return new (t || ExActionMenuComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExActionMenuComponent, selectors: [["ex-action-menu"]], inputs: { actions: "actions", backgroundColor: "backgroundColor", hoverBackgroundColor: "hoverBackgroundColor", selectedBackgroundColor: "selectedBackgroundColor", selectedHoverBackgroundColor: "selectedHoverBackgroundColor", fontColor: "fontColor", hoverFontColor: "hoverFontColor", borderColor: "borderColor", selectedBorderColor: "selectedBorderColor", isSelected: "isSelected", loading: "loading", uniqueSelector: "uniqueSelector" }, outputs: { actionClicked: "actionClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "ex-action-menu-flex-center", 4, "ngIf"], [1, "ex-action-menu-flex-center"], ["mat-ripple", "", 3, "exTooltip", "ngClass", "matMenuTriggerFor", "ngStyle", "disabled", "mouseover", "mouseleave", "click", "menuOpened", "menuClosed"], ["class", "uxf-icon uxf-dot-three ex-action-menu-icon regular", 4, "ngIf", "ngIfElse"], ["xPosition", "before"], ["menu", "matMenu"], [4, "ngFor", "ngForOf"], ["actionsLoadingSpinner", ""], [1, "uxf-icon", "uxf-dot-three", "ex-action-menu-icon", "regular"], [3, "exTooltip"], ["mat-menu-item", "", 3, "disabled", "ngClass", "click"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "mode", "diameter"]], template: function ExActionMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExActionMenuComponent_div_0_Template, 11, 25, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.actions.length > 0);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i3$1.MatMenu, i3$1.MatMenuItem, i3$1.MatMenuTrigger, ExTooltipDirective, ExSpinnerComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-action-menu-actions-disabled[_ngcontent-%COMP%]{pointer-events:none}.ex-action-menu-main-buttons[_ngcontent-%COMP%]{height:30px;padding:0 10px;border-radius:4px;border:1px solid;display:flex;margin-right:1px}.ex-action-menu-more-btn[_ngcontent-%COMP%]{padding:0 5px;display:flex;justify-content:center;align-items:center;width:40px}.ex-action-menu-more-btn[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:auto}.ex-action-menu-item[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;height:30px;padding:0 10px}.ex-action-menu-item[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:10px}.ex-action-menu-disabled[_ngcontent-%COMP%]{pointer-events:none}.ex-action-menu-flex-center[_ngcontent-%COMP%]{display:flex;justify-content:center}  .mat-mdc-menu-panel{min-height:30px!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExActionMenuComponent, [{
        type: Component,
        args: [{ selector: 'ex-action-menu', template: "<div *ngIf=\"actions.length > 0\" class=\"ex-action-menu-flex-center\">\n  <button (mouseover)=\"hover=true\" (mouseleave)=\"hover=false\" mat-ripple (click)=\"onMoreClicked()\"\n    class=\"ex-action-menu-main-buttons ex-action-menu-more-btn {{('ex-action-menu-more-btn' + (uniqueSelector ? '-' + uniqueSelector : '')) | generateHTMLId}}\" [exTooltip]=\"!moreActionDisabled ? ('ng.general.more_actions' | translate) : ''\"\n    [ngClass]=\"{ 'ex-action-menu-main-buttons-selected': isSelected }\" [matMenuTriggerFor]=\"menu\" [ngStyle]=\"{'background': isSelected ? (hover ? selectedHoverBackgroundColor : selectedBackgroundColor) : (hover ? hoverBackgroundColor : backgroundColor),\n  'color': hover ? hoverFontColor : fontColor, 'borderColor': isSelected ? selectedBorderColor : borderColor}\"\n    [attr.aria-label]=\"'ng.general.more_actions' | translate\" [attr.aria-expanded]=\"isMenuOpen\"\n    (menuOpened)=\"isMenuOpen = true\" (menuClosed)=\"isMenuOpen = false\" [disabled]=\"moreActionDisabled\">\n    <i *ngIf=\"(!loading || isMenuOpen); else actionsLoadingSpinner\" class=\"uxf-icon uxf-dot-three ex-action-menu-icon regular\"></i>\n  </button>\n  <mat-menu #menu=\"matMenu\" xPosition=\"before\">\n    <ng-container *ngFor=\"let action of actions\"><div [exTooltip]=\"action.tooltip? (action.tooltip | translate) : ''\">\n        <button [disabled]=\"action.disabled || action.loading\" class=\"ex-action-menu-item {{ (uniqueSelector ? 'ex-action-menu-item-' + uniqueSelector + (action?.value ? action?.value : '') : action) | generateHTMLId}}\" mat-menu-item\n          (click)=\"actionClicked.emit(action.value)\"\n          [ngClass]=\"{'ex-action-menu-actions-disabled': action.disabled}\">{{action.label | translate}}<ng-container\n          *ngIf=\"action.loading\" [ngTemplateOutlet]=\"actionsLoadingSpinner\"></ng-container></button>\n      </div>\n    </ng-container>\n  </mat-menu>\n  <ng-template #actionsLoadingSpinner>\n    <ex-spinner [mode]=\"'indeterminate'\" [diameter]=\"15\">\n    </ex-spinner>\n  </ng-template>\n</div>\n", styles: [".ex-action-menu-actions-disabled{pointer-events:none}.ex-action-menu-main-buttons{height:30px;padding:0 10px;border-radius:4px;border:1px solid;display:flex;margin-right:1px}.ex-action-menu-more-btn{padding:0 5px;display:flex;justify-content:center;align-items:center;width:40px}.ex-action-menu-more-btn mat-icon{height:auto}.ex-action-menu-item{display:flex;align-items:center;justify-content:space-between;height:30px;padding:0 10px}.ex-action-menu-item i{margin-right:10px}.ex-action-menu-disabled{pointer-events:none}.ex-action-menu-flex-center{display:flex;justify-content:center}::ng-deep .mat-mdc-menu-panel{min-height:30px!important}\n"] }]
    }], null, { actions: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], hoverBackgroundColor: [{
            type: Input
        }], selectedBackgroundColor: [{
            type: Input
        }], selectedHoverBackgroundColor: [{
            type: Input
        }], fontColor: [{
            type: Input
        }], hoverFontColor: [{
            type: Input
        }], borderColor: [{
            type: Input
        }], selectedBorderColor: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], loading: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }] }); })();

class ExSpinnerModule {
    static { this.ɵfac = function ExSpinnerModule_Factory(t) { return new (t || ExSpinnerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSpinnerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatProgressSpinnerModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule
                ],
                declarations: [
                    ExSpinnerComponent
                ],
                exports: [
                    ExSpinnerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSpinnerModule, { declarations: [ExSpinnerComponent], imports: [CommonModule,
        MatProgressSpinnerModule], exports: [ExSpinnerComponent] }); })();

class ExTextHighlightPipe {
    transform(text, search, textStyle = 'mark', asArray = false) {
        text = String(text ?? ''); // make sure its a string
        // Remove invisible characters before processing
        text = this.removeInvisibleCharacters(text);
        if (text && search) {
            const containsPhrase = search.startsWith("\"") && search.endsWith("\"");
            search = containsPhrase ? search.substring(1, search.length - 1) : search;
            const modifiedSearch = this.removeDiacritics(this.escapeRegex(search).toLowerCase());
            const modifiedText = this.removeDiacritics(text.toLowerCase());
            const searchedWords = containsPhrase ? [modifiedSearch] : this.generateSubstrings(modifiedSearch);
            const regex = new RegExp(`(${searchedWords.join('|')})`, 'gi');
            const splitter = new GraphemeSplitter();
            const textGraphemesArr = splitter.splitGraphemes(text);
            let subStrIndex = 0;
            const textArray = [];
            modifiedText.split(regex).forEach(modifiedSubStr => {
                const originalText = this.getSubString(subStrIndex, subStrIndex + modifiedSubStr.length, textGraphemesArr);
                textArray.push(searchedWords.includes(this.escapeRegex(modifiedSubStr)) ?
                    `<${textStyle}>${originalText}</${textStyle}>`
                    : originalText);
                subStrIndex += splitter.countGraphemes(originalText);
            });
            return asArray ? textArray : textArray.join('');
        }
        return asArray ? [text] : text;
    }
    getSubString(start, end, textArr) {
        const subStringArr = [];
        for (let i = start; i < (end); i++) {
            subStringArr.push(textArr[i]);
        }
        return subStringArr.join('');
    }
    removeDiacritics(str) {
        return _.deburr(str);
    }
    escapeRegex(string) {
        return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    generateSubstrings(search) {
        // generating all possible substrings from a given search string.
        const words = search.trim().split(/\s+/).filter(word => word !== ''); // Split the search string into words
        const substrings = [];
        for (let length = 1; length <= words.length; length++) { // Loop over the words length
            for (let start = 0; start <= words.length - length; start++) { // Loop over possible starting positions of substrings
                const substring = words.slice(start, start + length).join(' '); // Extract substring and join words into a single string
                substrings.push(substring); // Add substring to the substrings array
            }
        }
        substrings.sort((a, b) => b.length - a.length); // Sort substrings by length in descending order
        return substrings;
    }
    removeInvisibleCharacters(text) {
        return text.replace(/&#8203;/g, ''); // Removes zero-width space characters (&#8203;)
    }
    static { this.ɵfac = function ExTextHighlightPipe_Factory(t) { return new (t || ExTextHighlightPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exTextHighlight", type: ExTextHighlightPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTextHighlightPipe, [{
        type: Pipe,
        args: [{
                name: 'exTextHighlight'
            }]
    }], null, null); })();

class ExInitialsPipe {
    transform(text) {
        if (text && text.length > 0) {
            return text.split(' ').map(n => n[0]).join('').toUpperCase();
        }
        else {
            return '';
        }
    }
    static { this.ɵfac = function ExInitialsPipe_Factory(t) { return new (t || ExInitialsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exInitials", type: ExInitialsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInitialsPipe, [{
        type: Pipe,
        args: [{
                name: 'exInitials'
            }]
    }], null, null); })();

/**
 * wraps the target text within the text in a span element with a style attribute which has the value "styleAttr: styleValue".
 * returns sanitized HTML.
 */
class ExTextStylePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(text, options) {
        text = this.sanitizer.sanitize(2, String(text ?? '')); // make sure its a string and sanitize
        let styledText = text;
        const { styleAttr, styleValue, delimiter, targetText } = options;
        if (text && styleAttr && styleValue) {
            const regex = new RegExp(delimiter ? `(${delimiter}.+${delimiter})` : `${targetText ?? ''}`, 'gi');
            let origTargetText = delimiter ? text.match(regex)[0] : targetText ?? '';
            styledText = text.replace(regex, `<span style="${styleAttr}:${styleValue}">${origTargetText}</span>`);
        }
        return this.sanitizer.bypassSecurityTrustHtml(styledText);
    }
    static { this.ɵfac = function ExTextStylePipe_Factory(t) { return new (t || ExTextStylePipe)(i0.ɵɵdirectiveInject(i2$2.DomSanitizer, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exTextStyle", type: ExTextStylePipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTextStylePipe, [{
        type: Pipe,
        args: [{
                name: 'exTextStyle'
            }]
    }], function () { return [{ type: i2$2.DomSanitizer }]; }, null); })();

/**
 * Returns a new object which is the result of assigning the sources objects into the target object.
 */
class ExObjectAssignPipe {
    transform(target, ...sources) {
        return Object.assign({}, target, ...sources);
    }
    static { this.ɵfac = function ExObjectAssignPipe_Factory(t) { return new (t || ExObjectAssignPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "objectAssign", type: ExObjectAssignPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExObjectAssignPipe, [{
        type: Pipe,
        args: [{ name: 'objectAssign' }]
    }], null, null); })();

class ExTextTruncatePipe {
    transform(value, length, ellipses = '...') {
        if (typeof value === 'undefined' || value === null || value.length <= length) {
            return value;
        }
        return value.substring(0, Math.min(value.length, length)) + ellipses;
    }
    static { this.ɵfac = function ExTextTruncatePipe_Factory(t) { return new (t || ExTextTruncatePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exTextTruncate", type: ExTextTruncatePipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTextTruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'exTextTruncate'
            }]
    }], null, null); })();

class ExUnderThumbnailIconsPipe {
    transform(value) {
        let iconsList = [];
        if (value?.__proto__?.underThumbnailIcon && value?.__proto__?.underThumbnailIcon?.length > 0) {
            iconsList = value.__proto__.underThumbnailIcon.map(icon => {
                return value[icon];
            });
            return iconsList;
        }
        return null;
    }
    static { this.ɵfac = function ExUnderThumbnailIconsPipe_Factory(t) { return new (t || ExUnderThumbnailIconsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exUnderThumbnailIcons", type: ExUnderThumbnailIconsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExUnderThumbnailIconsPipe, [{
        type: Pipe,
        args: [{
                name: 'exUnderThumbnailIcons'
            }]
    }], null, null); })();

class ExEscapeHtmlPipe {
    transform(text) {
        return escape(text);
    }
    static { this.ɵfac = function ExEscapeHtmlPipe_Factory(t) { return new (t || ExEscapeHtmlPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exEscapeHtml", type: ExEscapeHtmlPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEscapeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'exEscapeHtml'
            }]
    }], null, null); })();

class ExClassNameFormatPipe {
    transform(text) {
        return text?.replace(/\s/g, '')?.replace(/[^a-zA-Z0-9_-]/g, "");
    }
    static { this.ɵfac = function ExClassNameFormatPipe_Factory(t) { return new (t || ExClassNameFormatPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exClassNameFormat", type: ExClassNameFormatPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExClassNameFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'exClassNameFormat'
            }]
    }], null, null); })();

class ExIsSortableColumnPipe {
    transform(sorts, columnSortKey) {
        if (columnSortKey == undefined)
            return false;
        return sorts?.some(sort => sort.sortByOptions?.some(option => option.value == columnSortKey));
    }
    static { this.ɵfac = function ExIsSortableColumnPipe_Factory(t) { return new (t || ExIsSortableColumnPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exIsSortableColumn", type: ExIsSortableColumnPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExIsSortableColumnPipe, [{
        type: Pipe,
        args: [{
                name: 'exIsSortableColumn'
            }]
    }], null, null); })();

class ExFeatureFlagPipe {
    constructor(flagsService) {
        this.flagsService = flagsService;
    }
    transform(value) {
        let featureValue;
        if (value) {
            featureValue = this.flagsService.isActive(value);
        }
        return featureValue;
    }
    static { this.ɵfac = function ExFeatureFlagPipe_Factory(t) { return new (t || ExFeatureFlagPipe)(i0.ɵɵdirectiveInject(IFeatureFlagsService, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "featureFlagPipe", type: ExFeatureFlagPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFeatureFlagPipe, [{
        type: Pipe,
        args: [{
                name: 'featureFlagPipe'
            }]
    }], function () { return [{ type: IFeatureFlagsService }]; }, null); })();

function ExFilterComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, ctx_r0.filter.filterByLabel), ": ");
} }
const _c0$1R = function (a0) { return { "ex-filter-wrapper-flex": a0 }; };
const _c1$1e = function (a0) { return { key: a0 }; };
const _c2$R = function (a0) { return [a0]; };
const ExFilterDefaultKey = 'all';
class ExFilterComponent {
    constructor() {
        /**
         * All label
         */
        this.allLabel = 'ng.general.all';
        /**
         * should be displayed in view mode or not
         */
        this.ignoreSectionsLayoutViewMode = false;
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData
         */
        this.selectedValueChange = new EventEmitter();
        this.comboboxValues = [];
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this._setFilterValues(this.filter.values);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('filter')) {
            this._setFilterValues(changes.filter.currentValue.values);
        }
    }
    /**
     * Emits the event of a changed filter
     * @param value The value that was selected from the filter options
     */
    onSelectedValueChange(value) {
        this.filter.filterSelectedValue = value[0].key;
        this.selectedValueChange.emit(this.filter);
    }
    _setFilterValues(values) {
        this.comboboxValues = [];
        this.comboboxValues.push(this.getDefaultFilter());
        values.forEach(value => {
            this.comboboxValues.push({ key: value.value, value: value.label });
        });
    }
    getDefaultFilter() {
        return { key: this.filter.defaultValue, value: this.filter.values.filter(value => value.value == this.filter.defaultValue).map(value => value.label)[0] ?? this.allLabel };
    }
    static { this.ɵfac = function ExFilterComponent_Factory(t) { return new (t || ExFilterComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFilterComponent, selectors: [["ex-filter"]], inputs: { filter: "filter", allLabel: "allLabel", ignoreSectionsLayoutViewMode: "ignoreSectionsLayoutViewMode" }, outputs: { selectedValueChange: "selectedValueChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 13, consts: [[3, "ngClass"], ["class", "ex-filter-label", 4, "ngIf"], [3, "ariaLabel", "items", "selectedItems", "uniqueSelector", "ignoreSectionsLayoutViewMode", "selectedItemsChange"], [1, "ex-filter-label"]], template: function ExFilterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExFilterComponent_label_1_Template, 3, 3, "label", 1);
            i0.ɵɵelementStart(2, "ex-new-combobox", 2);
            i0.ɵɵlistener("selectedItemsChange", function ExFilterComponent_Template_ex_new_combobox_selectedItemsChange_2_listener($event) { return ctx.onSelectedValueChange($event); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$1R, ctx.filter.filterByLabel));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.filter.filterByLabel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ariaLabel", "ng.general.filter_by")("items", ctx.comboboxValues)("selectedItems", i0.ɵɵpureFunction1(11, _c2$R, i0.ɵɵpureFunction1(9, _c1$1e, ctx.filter.filterSelectedValue)))("uniqueSelector", "ex-filter-" + ctx.filter.filterByLabel)("ignoreSectionsLayoutViewMode", ctx.ignoreSectionsLayoutViewMode);
        } }, styles: ["[_nghost-%COMP%]{display:flex;align-items:center}.ex-filter-wrapper-flex[_ngcontent-%COMP%]{display:flex;align-items:baseline}.ex-filter-wrapper-flex[_ngcontent-%COMP%]   .ex-filter-label[_ngcontent-%COMP%]{margin-top:7px;white-space:nowrap}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFilterComponent, [{
        type: Component,
        args: [{ selector: 'ex-filter', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{'ex-filter-wrapper-flex': filter.filterByLabel }\">\n  <label *ngIf=\"filter.filterByLabel\" class=\"ex-filter-label\">{{ filter.filterByLabel | translate }}: </label>\n  <ex-new-combobox [ariaLabel]=\"'ng.general.filter_by'\" [items]=\"comboboxValues\" [selectedItems]=\"[{ key: filter.filterSelectedValue }]\"\n                   [uniqueSelector]=\"'ex-filter-' + filter.filterByLabel\" (selectedItemsChange)=\"onSelectedValueChange($event)\" [ignoreSectionsLayoutViewMode]=\"ignoreSectionsLayoutViewMode\">\n  </ex-new-combobox>\n</div>\n", styles: [":host{display:flex;align-items:center}.ex-filter-wrapper-flex{display:flex;align-items:baseline}.ex-filter-wrapper-flex .ex-filter-label{margin-top:7px;white-space:nowrap}\n"] }]
    }], function () { return []; }, { filter: [{
            type: Input
        }], allLabel: [{
            type: Input
        }], ignoreSectionsLayoutViewMode: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }] }); })();

class ListProperties {
    constructor() {
        this.pagination = new PaginationModel();
        this.sorts = [];
        this.showSortsInListHeader = true;
        this.actions = [];
        this.bulkActions = [];
        this.comboboxLists = [];
        this.filters = [];
        this.popUpActions = [];
        this.hasSearch = false;
        this.searchByFields = [];
        this.combinedResultsStatus = false;
        this.showDateFilter = false;
        this.hasDrag = false;
        this.hasIndex = true;
        this.hasPickup = false;
        this.hasPickupCount = false;
        this.hasToggle = false;
        this.showToggle = true;
        this.hasCheckIcon = false;
        this.isLoading = false;
        this.hasDiselect = false;
        this.hasExport = true;
        this.isDarkTheme = false;
        this.emptyRowHeight = 7;
        this.placeHolderRowsNumber = 0;
        this.canSelectRow = true;
        this.layoutMode = 'list';
        this.leftSide = 60;
        this.rightSide = 40;
        this.density = 'normal';
        this.hideHeaderOnScroll = true;
        this.hideHeader = false;
        this.showSpinner = false;
        this.enableCustomization = true;
        this.hasTitle = false;
        this.hasSectionsCombobox = false;
        this.needToRefresh = false;
        this.hasRefreshButton = false;
        this.deepLinkMode = false;
        this.isExPickup = false;
        this.isMultiSelect = true;
        this.inExSidepanePickup = false;
        /**
         * Set the default view setting to Full page mode
         */
        this.isFullPage = false;
        this.showGridHeader = true;
        this.isSearchList = false;
        this.showSearchPlaceholder = false;
        this.isSingleSave = false;
        this.saveIsItemOpen = true;
        this.showAddAllButton = true;
        this.viewMode = ViewModes.SPLIT;
        this.isItemOpen = false;
        this.expandActionsOnAllSpace = true;
        this.showCreateSetButton = false;
        /*
        * Whether to show the Sets Bulk Actions - relevant for SearchListComponent
        * If showSetsBulkActions = true, the flags following it are relevant to determine which actions to display individually
        * */
        this.showSetsBulkActions = false;
        this.showRunAJobBulkAction = null;
        this.showCreateItemizedSetBulkAction = null;
        this.showAddToItemizedSetBulkAction = null;
        this.galleryLayoutEnabled = false;
        this.quickAccessEnabled = false;
        this.headerResponsivenessOrderConfig = { actions: 0, content1: 1, content2: 2, content3: 3, filter: 4, dateRange: 5, sort: 6, search: 7, icons: 8 };
    }
}
class PaginationModel {
    constructor() {
        this.selectedPage = 1;
        this.pageSize = 20;
        this.pageSizeOptions = [10, 20, 50];
        this.showPageSize = true;
        this.paginationChangedByUserPreference = false;
    }
    getOffset() {
        return (this.selectedPage - 1) * this.pageSize;
    }
}
class SortModel {
    constructor(sortByLabel, order, sortByOptions, selectedOption, hasOrder, disabled) {
        this.order = 'asc';
        this.sortByOptions = [];
        this.sortByLabel = 'ng.general.sort.sort_by';
        this.hasOrder = true;
        this.multiLined = false;
        this.autoComplete = false;
        this.disabled = false;
        this.sortByLabel = sortByLabel ?? this.sortByLabel;
        this.order = order ?? this.order;
        this.sortByOptions = sortByOptions ?? this.sortByOptions;
        this.selectedOption = selectedOption;
        this.hasOrder = hasOrder ?? this.hasOrder;
        this.disabled = disabled;
    }
    ;
}
class ActionModel {
    constructor(initializor) {
        this.order = 2;
        /**
         * When there is no space on the screen the action can move into the actions menu (BulkActions)
         */
        this.canMinimize = true;
        /**
         * The action will be centered, colored blue,
         * even when there are children or a component no arrow will be displayed (rowActions)
         */
        this.isLink = false;
        this.hideInRightSide = false;
        /**
         * Ability to search in the children list.
         */
        this.hasSearchBox = false;
        /** Allow to select unlisted values in the combobox, if the object exists, it means we allow unlisted values  */
        this.allowUnlistedValues = false;
        this.isBulkAction = false;
        this.show = true;
        this.display = ActionsDisplayModes.BOTH;
        /** Used for bulk action indication: if true, success Filter will not appear (deleted records cannot be presented) */
        this.isActionDeletesRecords = false;
        this.label = initializor.label || '';
        this.tooltip = initializor.tooltip || '';
        this.value = initializor.value || '';
        this.icon = initializor.icon;
        this.indicator = initializor.indicator ?? false;
        this.type = initializor.type || 'action';
        this.subActions = initializor.subActions || [];
        this.standAlone = initializor.standAlone ?? true;
        this.clearPickupOnAction = initializor.clearPickupOnAction ?? false;
        this.disabled = initializor.disabled ?? false;
        this.canMinimize = initializor.canMinimize ?? true;
        this.order = initializor.order ?? 2;
        this.loading = initializor.loading ?? false;
        this.component = initializor.component;
        this.isLink = initializor.isLink;
        this.showInViewMode = initializor.showInViewMode ?? false;
        this.hideInRightSide = initializor.hideInRightSide ?? false;
        this.isBulkAction = initializor.isBulkAction ?? false;
        this.roles = initializor.roles;
        this.extraData = initializor.extraData;
        this.hasSearchBox = initializor.hasSearchBox ?? false;
        this.allowUnlistedValues = initializor.allowUnlistedValues ?? false;
        this.unlistedValuesParams = initializor.unlistedValuesParams;
        this.display = initializor.display ?? ActionsDisplayModes.BOTH;
        this.isActionDeletesRecords = initializor.isActionDeletesRecords ?? false;
    }
}
/**
 * Canceled. Instead, You can create ActionModel with 'hasSearchBox' flag
 */
class ComboboxListsModel {
    constructor(id, items, placeholder, canMinimize = true, order = 3) {
        this.order = 3;
        this.canMinimize = true;
        this.id = id;
        this.items = items;
        this.placeholder = placeholder;
        this.canMinimize = canMinimize;
        this.order = order;
    }
    ;
}
class PopUpAddActionModel {
    constructor(label = '', value = '', data, iconClass, type = 'action', subActions, standAlone = true, clearPickupOnAction = false, disabled, dropdownStyle = true, canMinimize = true, order = 1) {
        this.order = 1;
        this.canMinimize = true;
        this.label = label;
        this.value = value;
        this.subActions = subActions;
        this.iconClass = iconClass;
        this.standAlone = standAlone;
        this.type = type;
        this.data = data;
        this.disabled = disabled;
        this.clearPickupOnAction = clearPickupOnAction;
        this.canMinimize = canMinimize;
        this.order = order;
    }
}
class PopUpActionModel {
    constructor(label = '', value = '', data, tooltip = '', clearPickupOnAction = false, standAlone = false, isDropdownStyle = true, canMinimize = true, order = 0, splitButton = false, type = 'action', icon) {
        this.order = 0;
        this.canMinimize = true;
        this.label = label;
        this.value = value;
        this.data = data;
        this.tooltip = tooltip;
        this.clearPickupOnAction = clearPickupOnAction;
        this.standAlone = standAlone;
        this.isDropdownStyle = isDropdownStyle;
        this.canMinimize = canMinimize;
        this.order = order;
        this.splitButton = splitButton;
        this.type = type;
        this.icon = icon;
    }
}
class FilterModel {
    constructor(type, label, values, selectedValue, defaultValue) {
        this.filterByType = type;
        this.filterByLabel = label;
        this.values = values;
        if (selectedValue) {
            this.filterSelectedValue = selectedValue;
        }
        this.defaultValue = defaultValue;
    }
    get defaultValue() {
        return this._defaultValue ?? ExFilterDefaultKey;
    }
    set defaultValue(value) {
        this._defaultValue = value;
    }
}
class HasCustomizationForType {
    constructor() {
        this.SECTIONS = true;
        this.ACTIONS = true;
        this.RECORD = true;
        this.GRID = false;
        this.FACETS = true;
    }
}
;
class LayoutCustomizationModel {
    constructor(mandatoryFieldsData, allSectionsForCustomization, allActionsForCustomization, recordForCustomization, hasCustomizationInInstLevel, allFacetsForCustomization) {
        /**
         * fields that should not be displayed on the record customization
         */
        this.recordCustomizationExcludedFields = [];
        /**
         * fields that should not be displayed on the grid customization
         */
        this.gridCustomizationExcludedFields = [];
        /**
         * that defined how many actions will be main actions in the customization config screen only.
         * set to 1 by default.
         */
        this.visibleActionsNum = 1;
        this.mandatoryFieldsData = mandatoryFieldsData;
        this.allActionsForCustomization = allActionsForCustomization;
        this.allSectionsForCustomization = allSectionsForCustomization;
        this.recordForCustomization = recordForCustomization;
        this.allFacetsForCustomization = allFacetsForCustomization;
        this.hasCustomizationInInstLevel = hasCustomizationInInstLevel || new HasCustomizationForType();
    }
}
var ViewModes;
(function (ViewModes) {
    ViewModes["SPLIT"] = "SPLIT";
    ViewModes["FULL"] = "FULL";
})(ViewModes || (ViewModes = {}));
var ActionsDisplayModes;
(function (ActionsDisplayModes) {
    ActionsDisplayModes["VIEW"] = "View";
    ActionsDisplayModes["EDIT"] = "Edit";
    ActionsDisplayModes["BOTH"] = "Both";
})(ActionsDisplayModes || (ActionsDisplayModes = {}));

class ExDisplayActionsPipe {
    transform(actions, editMode) {
        let res = [];
        res = actions.filter(action => action.display === ActionsDisplayModes.BOTH ||
            action.display == undefined ||
            (editMode ? action.display === ActionsDisplayModes.EDIT : action.display === ActionsDisplayModes.VIEW));
        return res;
    }
    static { this.ɵfac = function ExDisplayActionsPipe_Factory(t) { return new (t || ExDisplayActionsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exDisplayActions", type: ExDisplayActionsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDisplayActionsPipe, [{
        type: Pipe,
        args: [{
                name: 'exDisplayActions'
            }]
    }], null, null); })();

class EXPipesModule {
    static { this.ɵfac = function EXPipesModule_Factory(t) { return new (t || EXPipesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EXPipesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EXPipesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExTextHighlightPipe,
                    ExInitialsPipe,
                    ExTextStylePipe,
                    ExObjectAssignPipe,
                    ExTextTruncatePipe,
                    ExUnderThumbnailIconsPipe,
                    ExEscapeHtmlPipe,
                    ExClassNameFormatPipe,
                    ExIsSortableColumnPipe,
                    ExGenerateIdPipe,
                    ExFeatureFlagPipe,
                    ExDisplayActionsPipe
                ],
                exports: [
                    ExTextHighlightPipe,
                    ExInitialsPipe,
                    ExTextStylePipe,
                    ExObjectAssignPipe,
                    ExTextTruncatePipe,
                    ExUnderThumbnailIconsPipe,
                    ExEscapeHtmlPipe,
                    ExClassNameFormatPipe,
                    ExIsSortableColumnPipe,
                    ExGenerateIdPipe,
                    ExFeatureFlagPipe,
                    ExDisplayActionsPipe
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EXPipesModule, { declarations: [ExTextHighlightPipe,
        ExInitialsPipe,
        ExTextStylePipe,
        ExObjectAssignPipe,
        ExTextTruncatePipe,
        ExUnderThumbnailIconsPipe,
        ExEscapeHtmlPipe,
        ExClassNameFormatPipe,
        ExIsSortableColumnPipe,
        ExGenerateIdPipe,
        ExFeatureFlagPipe,
        ExDisplayActionsPipe], imports: [CommonModule], exports: [ExTextHighlightPipe,
        ExInitialsPipe,
        ExTextStylePipe,
        ExObjectAssignPipe,
        ExTextTruncatePipe,
        ExUnderThumbnailIconsPipe,
        ExEscapeHtmlPipe,
        ExClassNameFormatPipe,
        ExIsSortableColumnPipe,
        ExGenerateIdPipe,
        ExFeatureFlagPipe,
        ExDisplayActionsPipe] }); })();

class ExActionMenuModule {
    static { this.ɵfac = function ExActionMenuModule_Factory(t) { return new (t || ExActionMenuModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExActionMenuModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            MatIconModule,
            TranslateModule,
            ExDirectivesModule,
            ExSpinnerModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExActionMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatIconModule,
                    TranslateModule,
                    ExDirectivesModule,
                    ExSpinnerModule,
                    EXPipesModule
                ],
                declarations: [
                    ExActionMenuComponent
                ],
                exports: [
                    ExActionMenuComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExActionMenuModule, { declarations: [ExActionMenuComponent], imports: [CommonModule,
        MatMenuModule,
        MatIconModule,
        TranslateModule,
        ExDirectivesModule,
        ExSpinnerModule,
        EXPipesModule], exports: [ExActionMenuComponent] }); })();

function getValueAccessors(type) {
    return [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: type,
            multi: true
        },
        {
            provide: ExControlValueAccessor,
            useExisting: type
        },
        {
            provide: EX_ARIA_ATTRIBUTES,
            useExisting: type,
        },
        { provide: NG_VALIDATORS, useExisting: type, multi: true }
    ];
}
class ExControlValueAccessor {
    validate(control) {
        return null;
    }
    get valid() {
        return this._valid;
    }
    set valid(value) {
        this._valid = value;
        this.getAriaChanged$().next();
    }
    get hasWarnings() {
        return this._hasWarnings;
    }
    set hasWarnings(value) {
        this._hasWarnings = value;
        //this.getAriaChanged$().next(); // TODO:
    }
    get ariaDescription() {
        return this._ariaDescription;
    }
    set ariaDescription(value) {
        this._ariaDescription = value;
        this.getAriaChanged$().next();
    }
    get ariaLabel() {
        return this._ariaLabel;
    }
    set ariaLabel(value) {
        this._ariaLabel = value;
        this.getAriaChanged$().next();
    }
    get ariaRequired() {
        return this._ariaRequired;
    }
    set ariaRequired(value) {
        this._ariaRequired = value;
        this.getAriaChanged$().next();
    }
    get ariaErrorLabel() {
        return this._ariaErrorLabel;
    }
    set ariaErrorLabel(value) {
        this._ariaErrorLabel = value;
        this.getAriaChanged$().next();
    }
    set isFieldFocused(value) {
        this._isFieldFocused = value;
        this.setIsFieldFocused(value);
    }
    get isFieldFocused() {
        return this._isFieldFocused;
    }
    setIsFieldFocused(value) {
    }
    ;
    constructor(sectionLayoutViewModeObservable, _changeDetectorRef) {
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._changeDetectorRef = _changeDetectorRef;
        this._valid = true;
        this._hasWarnings = false;
        this.readOnly = false;
        this.ignoreSectionsLayoutViewMode = false;
        this.disabled = false;
        this.blur = new EventEmitter();
        this.controlOnChange = noop;
        this.controlOnTouched = noop;
        this.controlOnValidatorChange = noop;
        this.controlTouched = new Subject();
        this.controlTouched$ = this.controlTouched.asObservable();
        this._sectionsLayoutViewMode = false;
        this.ariaPropertiesChanged$ = new Subject();
        this._isFieldFocused = false;
        this._sectionsLayoutViewModeSub = this.sectionLayoutViewModeObservable?.subscribe(readOnly => {
            this.onSectionLayoutViewModeChange(readOnly);
        });
    }
    registerOnChange(fn) {
        this.controlOnChange = fn;
    }
    registerOnValidatorChange(fn) {
        this.controlOnValidatorChange = fn;
    }
    registerOnTouched(fn) {
        this.controlOnTouched = () => {
            this.controlTouched.next();
            fn();
        };
    }
    onBlur(event) {
        this.blur.emit(event);
    }
    ngOnDestroy() {
        this.controlTouched.complete();
        this.controlTouched.unsubscribe();
        this._sectionsLayoutViewModeSub?.unsubscribe();
    }
    onSectionLayoutViewModeChange(readOnly) {
        this._sectionsLayoutViewMode = readOnly;
        this._changeDetectorRef?.markForCheck();
    }
    get isReadOnly() {
        return this.readOnly || (!this.ignoreSectionsLayoutViewMode && this._sectionsLayoutViewMode == true);
    }
    // GETTERS
    getErrorLabel() {
        return this._ariaErrorLabel;
    }
    getAriaChanged$() {
        return this.ariaPropertiesChanged$;
    }
    getDescription() {
        return this._ariaDescription;
    }
    getInvalid() {
        return !this._valid;
    }
    getLabel() {
        return this._ariaLabel;
    }
    getRequired() {
        return this._ariaRequired;
    }
    // SETTERS
    setRequired(required) {
        this.ariaRequired = required;
    }
    setLabel(label) {
        this.ariaLabel = label;
    }
    setAriaDescription(string) {
        this.ariaDescription = string;
    }
    setErrorMassage(errorLabel) {
        this.ariaErrorLabel = errorLabel;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    setValidState(isValid) {
        this.valid = isValid;
    }
    setHasWarnings(hasWarnings) {
        this.hasWarnings = hasWarnings;
    }
    fieldFocus() {
        if (this.childControlValueAccessor) {
            this.childControlValueAccessor.fieldFocus();
            return;
        }
        this.isFieldFocused = true;
        this._changeDetectorRef?.markForCheck();
    }
    static { this.ɵfac = function ExControlValueAccessor_Factory(t) { return new (t || ExControlValueAccessor)(i0.ɵɵdirectiveInject(i1$3.Observable), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExControlValueAccessor, viewQuery: function ExControlValueAccessor_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(ExControlValueAccessor, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childControlValueAccessor = _t.first);
        } }, inputs: { valid: "valid", hasWarnings: "hasWarnings", ariaDescription: "ariaDescription", ariaLabel: "ariaLabel", ariaRequired: "ariaRequired", ariaErrorLabel: "ariaErrorLabel", readOnly: "readOnly", ignoreSectionsLayoutViewMode: "ignoreSectionsLayoutViewMode", disabled: "disabled" }, outputs: { blur: "blur" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExControlValueAccessor, [{
        type: Directive
    }], function () { return [{ type: i1$3.Observable }, { type: i0.ChangeDetectorRef }]; }, { childControlValueAccessor: [{
            type: ViewChild,
            args: [forwardRef(() => ExControlValueAccessor)]
        }], valid: [{
            type: Input
        }], hasWarnings: [{
            type: Input
        }], ariaDescription: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaRequired: [{
            type: Input
        }], ariaErrorLabel: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], ignoreSectionsLayoutViewMode: [{
            type: Input
        }], disabled: [{
            type: Input
        }], blur: [{
            type: Output
        }] }); })();

const Animations$b = [
    trigger('arrowFlip', [
        state('down', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('up', style({
            transform: 'rotate(-180deg)'
        })),
        transition('down <=> up', [
            animate('0.25s')
        ])
    ]),
    trigger('expendAndcollapse', [
        state('false', style({
            height: '{{collapsedHeight}}px',
        }), { params: { collapsedHeight: 300 } }),
        state('true', style({
            height: AUTO_STYLE,
        })),
        transition('false <=> true', [
            animate('0.25s ease')
        ])
    ])
];

class HepApm {
}

class ExSectionsLayoutApmService {
    constructor(apm, exPageId) {
        this.apm = apm;
        this.exPageId = exPageId;
        this.sectionSpans = {};
        this.active = false;
        this.active = !!apm;
    }
    ngOnDestroy() {
        this.transaction?.end();
    }
    trackSectionLoading(identifier, loading) {
        if (!this.isActive())
            return;
        if (!this.transaction) {
            if (!loading)
                return;
            this.startTransaction();
        }
        let sectionSpan = this.sectionSpans[identifier];
        if (!loading && sectionSpan) {
            sectionSpan.end();
            delete this.sectionSpans[identifier];
            if (Object.entries(this.sectionSpans).length === 0) {
                this.endTransaction();
                this.active = false;
            }
        }
        else if (loading && !sectionSpan) {
            sectionSpan = this.transaction.startSpan(identifier, 'record-details-section');
            sectionSpan.addLabels({ identifier });
            sectionSpan.addContext({ pageId: this.exPageId?.exPageId });
            this.sectionSpans[identifier] = sectionSpan;
        }
    }
    isActive() {
        return this.active && this.apm.isActive();
    }
    startTransaction() {
        if (!this.isActive())
            return;
        const pageId = this.exPageId?.exPageId;
        this.transaction = this.apm?.startUnmanagedTransaction(pageId?.toLowerCase(), 'ng-record-details');
        this.transaction.addLabels({ pageId });
    }
    endTransaction() {
        this.transaction.end();
    }
    static { this.ɵfac = function ExSectionsLayoutApmService_Factory(t) { return new (t || ExSectionsLayoutApmService)(i0.ɵɵinject(HepApm, 8), i0.ɵɵinject(ExPageIdDirective, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSectionsLayoutApmService, factory: ExSectionsLayoutApmService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutApmService, [{
        type: Injectable
    }], function () { return [{ type: HepApm, decorators: [{
                type: Optional
            }] }, { type: ExPageIdDirective, decorators: [{
                type: Optional
            }] }]; }, null); })();

const EX_FORM_WARNINGS_PROPERTY_NAME = 'warnings';
class ExFormValidators {
    /*
        Adds the predicate to the control validators as a warning validator.
        The warning validator sets the validation errors from the predicate to a 'warnings' property on the control and does not change the control errors or its valid state.
    */
    static addWarningValidatorToControl(control, predicate, code) {
        const _code = code ?? Object.keys(predicate?.({}) ?? {})[0];
        control.addValidators(ExFormValidators.createWarningValidator(predicate, _code));
    }
    /*
        A factory for warnings validators.
        Returns a ValidatorFn which sets the validation errors from the predicate to a 'warnings' property on the control and always returns null.
    */
    static createWarningValidator(predicate, code) {
        return (control) => {
            const result = predicate(control);
            if (!isNil(result)) {
                Object.assign(control[EX_FORM_WARNINGS_PROPERTY_NAME] ??= {}, { [code]: true });
            }
            else
                delete (control[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {})[code];
            return null;
        };
    }
    static controlIsDirty(control) {
        return control.dirty ? { 'dirty': true } : null;
    }
}

class ExFormUtil {
    static asSortedComboItems(items, defaults) {
        return this.asComboItems(items, defaults).sort((x, y) => x.itemName.value > y.itemName.value ? 1 : -1);
    }
    static asSortedNewComboboxItems(items, defaults) {
        return this.asNewComboboxItems(items, defaults).sort((x, y) => x.value > y.value ? 1 : -1);
    }
    static asComboItems(items, defaults) {
        if (this.isStringArray(items)) {
            return items.map(i => ({ ...defaults, itemName: { key: i, value: i } }));
        }
        else if (this.isKeyValueList(items)) {
            return items.map(i => ({ ...defaults, itemName: { key: i.key, value: i.value } }));
        }
        else if (this.isStringMap(items)) {
            return Object.keys(items).map(k => ({ ...defaults, itemName: { key: k, value: items[k] } }));
        }
        return [];
    }
    static asNewComboboxItems(items, defaults) {
        if (this.isStringArray(items)) {
            return items.map(i => ({ ...defaults, key: i, value: i }));
        }
        else if (this.isKeyValueList(items)) {
            return items.map(i => ({ ...defaults, key: i.key, value: i.value }));
        }
        else if (this.isStringMap(items)) {
            return Object.keys(items).map(k => ({ ...defaults, key: k, value: items[k] }));
        }
        return [];
    }
    static asComboValue(value, label) {
        if (!value)
            return undefined;
        return { item: value ?? null, value: label };
    }
    static asNewComboboxValue(value, label) {
        if (!value)
            return undefined;
        return { key: value ?? null, value: label };
    }
    static asRadioItems(items, coerceBooleans) {
        if (this.isStringArray(items)) {
            return items.map(i => ({ value: this.getValue(i, coerceBooleans), label: i }));
        }
        else if (this.isKeyValueList(items)) {
            return items.map(i => ({ value: this.getValue(i.key, coerceBooleans), label: i.value }));
        }
        else if (this.isStringMap(items)) {
            return Object.keys(items).map(k => ({ value: this.getValue(k, coerceBooleans), label: items[k] }));
        }
        return [];
    }
    static asFlexbrowseItems(items) {
        return this.asFlexbrowseValue(items);
    }
    static asFlexbrowseValue(items, defaults) {
        const def = (defaults ?? { hasChildren: true, isLoading: false });
        if (this.isStringArray(items)) {
            return items.map(i => ({ ...def, id: i, name: i }));
        }
        else if (this.isKeyValueList(items)) {
            return items.map(i => ({ ...def, id: i.key, name: i.value }));
        }
        else if (this.isStringMap(items)) {
            return Object.keys(items).filter(k => k && items[k])
                .reduce((acc, k) => acc.concat([{ ...def, id: k, name: items[k] }]), []);
        }
        return [];
    }
    static toFormattedDate(date, format) {
        return date ? moment(date).format(format) : undefined;
    }
    static fromFormattedDate(date) {
        return date ? moment(date).toDate() : undefined;
    }
    static toKeyValueMap(list) {
        return list.reduce((acc, item) => { acc[item.key] = item.value; return acc; }, {});
    }
    static isKeyValueList(list) {
        return list && Array.isArray(list) && list.length > 0 && !!list[0]?.key && !!list[0]?.value;
    }
    static isStringArray(list) {
        return list && Array.isArray(list) && list.length > 0 && typeof list[0] === 'string';
    }
    static isStringMap(map) {
        if (!map)
            return false;
        let isStringValues = true;
        const properties = Object.getOwnPropertyNames(map);
        for (let i = 0; i < properties.length; i++) {
            isStringValues = typeof map[properties[i]] === 'string';
            if (!isStringValues)
                break;
        }
        return properties.length > 0 && isStringValues;
    }
    static getValue(value, coerceBooleans = false) {
        if (coerceBooleans) {
            const v = value?.trim().toLowerCase();
            if (v === 'true')
                return true;
            if (v === 'false')
                return false;
        }
        return value;
    }
    /*
        Returns true if any of the controls in the form group have a validator or a warning validator which returns the key 'required'
    */
    static formHasRequiredControl(form) {
        if (!(form instanceof FormGroup))
            return false;
        return Object.entries(form.controls).some(([name, control]) => {
            //return control.hasValidator(Validators.required); // !!! add warning required
            const dummyControl = {};
            return !!control.validator?.(dummyControl)?.required || !!dummyControl[EX_FORM_WARNINGS_PROPERTY_NAME]?.required;
        });
    }
    /*
        Returns true if the form group or any of the controls in the form group have warnings
    */
    static formHasWarnings(form) {
        if (!(form instanceof FormGroup))
            return false;
        if (!isEmpty(form[EX_FORM_WARNINGS_PROPERTY_NAME]))
            return true;
        return Object.entries(form.controls).some(([name, control]) => {
            return ExFormUtil.controlHasWarnings(control);
        });
    }
    /*
        Returns true if the control has warnings
    */
    static controlHasWarnings(control) {
        return !isEmpty(control[EX_FORM_WARNINGS_PROPERTY_NAME]);
    }
    static formHasTouchedOrDirtyWarningsErrors(form) {
        if (!(form instanceof FormGroup))
            return false;
        if ((!isEmpty(form[EX_FORM_WARNINGS_PROPERTY_NAME]) || !isEmpty(form['errors'])) && (form.touched || form.dirty))
            return true;
        return Object.entries(form.controls).some(([name, control]) => {
            return (ExFormUtil.controlHasWarnings(control) || control.invalid) && (control.touched || control.dirty);
        });
    }
    /*
        Returns the errors and warnings for all controls in the given form group including the form group control
    */
    static getFormGroupErrorsAndWarnings(form) {
        if (!(form instanceof FormGroup))
            return null;
        let errorsAndWarnings = {};
        errorsAndWarnings['form'] = ExFormUtil.getControlErrorsAndWarnings(form);
        Object.entries(form.controls).forEach(([name, control]) => {
            errorsAndWarnings[name] = ExFormUtil.getControlErrorsAndWarnings(control);
        });
        return errorsAndWarnings;
    }
    /*
        Returns the errors and warnings for the given control
    */
    static getControlErrorsAndWarnings(control) {
        if (!control)
            return null;
        return { errors: { ...(control.errors ?? {}) }, warnings: { ...(control[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {}) } };
    }
    static clearControlWarnings(control) {
        if (control)
            control[EX_FORM_WARNINGS_PROPERTY_NAME] = null;
    }
}

class ExFormGroupDirective extends FormGroupDirective {
    constructor(formGroupDirective) {
        super(null, null);
        ExFormGroupDirective.initMethods(formGroupDirective);
        ExFormGroupDirective.initSubjects(formGroupDirective);
        return formGroupDirective;
    }
    static initMethods(dir) {
        dir.ngOnChanges = ExFormGroupDirective.getNewOnChanges(dir);
        dir.ngOnDestroy = ExFormGroupDirective.getNewOnDestroy(dir);
    }
    static initSubjects(dir) {
        ExFormGroupDirective.initSubscriptions(dir);
        ExFormGroupDirective.initChangedSubject(dir);
        ExFormGroupDirective.initFormMarkedPristineSubject(dir);
        ExFormGroupDirective.initFormMarkedDirtySubject(dir);
        ExFormGroupDirective.initFormMarkedTouchedSubject(dir); // @#@
        ExFormGroupDirective.initFormUpdatedSubject(dir);
    }
    static initSubscriptions(dir) {
        const d = dir;
        d._subscriptions = [];
    }
    static initChangedSubject(dir) {
        const d = dir;
        const sub = new Subject();
        d._exFormChanged = sub;
        d.exFormChanged$ = sub.asObservable();
    }
    static initFormMarkedPristineSubject(dir) {
        const d = dir;
        const sub = new Subject();
        d._exFormMarkedPristine = sub;
        d.exFormMarkedPristine$ = sub.asObservable();
    }
    static initFormMarkedDirtySubject(dir) {
        const d = dir;
        const sub = new Subject();
        d._exFormMarkedDirty = sub;
        d.exFormMarkedDirty$ = sub.asObservable();
    }
    static initFormMarkedTouchedSubject(dir) {
        const d = dir;
        const sub = new Subject();
        d._exFormMarkedTouched = sub;
        d.exFormMarkedTouched$ = sub.asObservable();
    }
    static initFormUpdatedSubject(dir) {
        const d = dir;
        const sub = new Subject();
        d._exFormUpdated = sub;
        d.exFormUpdated$ = sub.asObservable();
    }
    static getNewOnChanges(dir) {
        const oldOnChanges = dir.ngOnChanges;
        return (function (changes) {
            const ret = oldOnChanges.apply(this, arguments);
            if (changes.hasOwnProperty('form')) {
                dir._exFormChanged.next();
                dir.form.markAsPristine = ExFormGroupDirective.getNewMarkAsPristine(dir);
                dir.form.markAsDirty = ExFormGroupDirective.getNewMarkAsDirty(dir);
                dir.form.markAsTouched = ExFormGroupDirective.getNewMarkAsTouched(dir); // @#@
                dir.form['formGroupObservables'] = {
                    exFormChanged: dir.exFormChanged$,
                    exFormMarkedPristine: dir.exFormMarkedPristine$,
                    exFormMarkedDirty: dir.exFormMarkedDirty$,
                    exFormMarkedTouched: dir.exFormMarkedTouched$,
                    exFormUpdated$: dir.exFormUpdated$
                };
                const d = dir;
                d._subscriptions.forEach(sub => sub.unsubscribe());
                d._subscriptions = [];
                d._subscriptions.push(dir.form.valueChanges.subscribe(() => {
                    d._exFormUpdated.next();
                }));
                d._subscriptions.push(dir.form.statusChanges.subscribe(() => {
                    d._exFormUpdated.next();
                }));
            }
            return ret;
        }).bind(dir);
    }
    static getNewMarkAsPristine(dir) {
        const markAsPristine = dir.form.markAsPristine;
        return (function () {
            const ret = markAsPristine.apply(this, arguments);
            dir._exFormMarkedPristine.next();
            return ret;
        }).bind(dir.form);
    }
    static getNewMarkAsDirty(dir) {
        const markAsDirty = dir.form.markAsDirty;
        return (function () {
            const ret = markAsDirty.apply(this, arguments);
            dir._exFormMarkedDirty.next();
            return ret;
        }).bind(dir.form);
    }
    static getNewMarkAsTouched(dir) {
        const markAsTouched = dir.form.markAsTouched;
        return (function () {
            const ret = markAsTouched.apply(this, arguments);
            dir._exFormMarkedTouched.next();
            return ret;
        }).bind(dir.form);
    }
    static getNewOnDestroy(dir) {
        const oldOnDestroy = dir.ngOnDestroy;
        return (function () {
            const ret = oldOnDestroy.apply(this, arguments);
            dir._subscriptions.forEach(sub => sub.unsubscribe());
            return ret;
        }).bind(dir);
    }
    static isExFormGroup(dir) {
        const d = dir;
        return !!d?._exFormChanged && !!d.exFormChanged$;
    }
    static { this.ɵfac = function ExFormGroupDirective_Factory(t) { return new (t || ExFormGroupDirective)(i0.ɵɵdirectiveInject(i1$6.FormGroupDirective, 2)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFormGroupDirective, selectors: [["", "formGroup", ""]], features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormGroupDirective, [{
        type: Directive,
        args: [{ selector: '[formGroup]' }]
    }], function () { return [{ type: i1$6.FormGroupDirective, decorators: [{
                type: Self
            }] }]; }, null); })();

const EX_NAVIGATE_TO_FIELD = new InjectionToken('service');

function ExCheckboxComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExCheckboxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function ExCheckboxComponent_div_0_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onWrapperClick($event)); });
    i0.ɵɵtemplate(1, ExCheckboxComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExCheckboxComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExCheckboxComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function ExCheckboxComponent_ng_template_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onWrapperClick($event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExCheckboxComponent_ng_template_1_ng_container_3_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵclassMapInterpolate1("ex-checkbox-wrapper ", ctx_r2.uniqueSelector ? i0.ɵɵpipeBind1(1, 7, "ex-checkbox-wrapper-" + ctx_r2.uniqueSelector) : "", "");
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(2, 9, ctx_r2.label));
    i0.ɵɵproperty("exQuickAccessType", ctx_r2.quickAcssessTypes.FIELD)("exQuickAccessSection", ctx_r2.sectionId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
const _c0$1Q = function (a0, a1, a2) { return { "ex-checkbox-valid": a0, "ex-checkbox-readonly": a1, "cdk-keyboard-focused": a2 }; };
const _c1$1d = function () { return { standalone: true }; };
const _c2$Q = function () { return {}; };
function ExCheckboxComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 6);
    i0.ɵɵlistener("ngModelChange", function ExCheckboxComponent_ng_template_3_Template_mat_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.checked = $event); })("exFocusChange", function ExCheckboxComponent_ng_template_3_Template_mat_checkbox_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.isFieldFocused = $event); })("change", function ExCheckboxComponent_ng_template_3_Template_mat_checkbox_change_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onChange($event)); })("indeterminateChange", function ExCheckboxComponent_ng_template_3_Template_mat_checkbox_indeterminateChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onIndeterminateChange($event)); })("focusout", function ExCheckboxComponent_ng_template_3_Template_mat_checkbox_focusout_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onBlur($event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵprojection(3);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    let tmp_7_0;
    i0.ɵɵclassMapInterpolate1("ex-checkbox-checkbox ", ctx_r4.uniqueSelector ? i0.ɵɵpipeBind1(1, 11, "ex-checkbox-checkbox" + ctx_r4.uniqueSelector) : "", "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(17, _c0$1Q, !ctx_r4.valid, ctx_r4.isReadOnly, ctx_r4.isFieldFocused))("ngModel", ctx_r4.checked)("ngModelOptions", ctx_r4.isStandalone ? i0.ɵɵpureFunction0(21, _c1$1d) : i0.ɵɵpureFunction0(22, _c2$Q))("exFocus", ctx_r4.isFieldFocused)("indeterminate", ctx_r4.indeterminate)("disabled", ctx_r4.disabled || ctx_r4.isReadOnly)("aria-label", (tmp_7_0 = ctx_r4.ariaLabel) !== null && tmp_7_0 !== undefined ? tmp_7_0 : i0.ɵɵpipeBind1(2, 13, ctx_r4.label));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 15, ctx_r4.label));
} }
const _c3$G = ["*"];
class ExCheckboxComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, sectionId, isQuickAccessScope, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.sectionId = sectionId;
        this.isQuickAccessScope = isQuickAccessScope;
        this.cdr = cdr;
        /**
         * the checkbox label
         */
        this.label = "";
        /**
         * the checked state of the checkbox
         */
        this.checked = false;
        /**
         * Whether the checkbox is indeterminate
         */
        this.indeterminate = false;
        /**
         * Whether the checkbox is isStandalone
         */
        this.isStandalone = false;
        /**
         * the checked state of the checkbox
         */
        this.checkedChange = new EventEmitter();
        /**
         * the MatCheckboxChange emitted on checkbox change
         */
        this.checkboxChange = new EventEmitter();
        /**
         * the indeterminate state of the checkbox
         */
        this.indeterminateChange = new EventEmitter();
        this.quickAcssessTypes = QuickAccessType;
    }
    onChange(event) {
        this.checkedChange.emit(this.checked);
        this.checkboxChange.emit(event);
    }
    onIndeterminateChange(value) {
        this.indeterminateChange.emit(value);
    }
    writeValue(checked) {
        this.checked = checked;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    onWrapperClick(event) {
        if (!this.isReadOnly) {
            event.stopPropagation();
        }
    }
    onClick() {
        this.matCheckbox.focus();
    }
    setIsFieldFocused(value) {
        value && this.matCheckbox.focus();
    }
    static { this.ɵfac = function ExCheckboxComponent_Factory(t) { return new (t || ExCheckboxComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(EX_SECTION_IDENTIFIER, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS_SCOPE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExCheckboxComponent, selectors: [["ex-checkbox"]], viewQuery: function ExCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatCheckbox, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matCheckbox = _t.first);
        } }, hostBindings: function ExCheckboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("checkedChange", function ExCheckboxComponent_checkedChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExCheckboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { label: "label", checked: "checked", indeterminate: "indeterminate", isStandalone: "isStandalone", uniqueSelector: "uniqueSelector" }, outputs: { checkedChange: "checkedChange", checkboxChange: "checkboxChange", indeterminateChange: "indeterminateChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExCheckboxComponent)), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$G, decls: 5, vars: 2, consts: [["class", "ex-checkbox-wrapper", 3, "click", 4, "ngIf", "ngIfElse"], ["withinSection", ""], ["content", ""], [1, "ex-checkbox-wrapper", 3, "click"], [4, "ngTemplateOutlet"], [3, "exQuickAccess", "exQuickAccessType", "exQuickAccessSection", "click"], ["exFormAriaAttributes", "", 3, "ngClass", "ngModel", "ngModelOptions", "exFocus", "indeterminate", "disabled", "aria-label", "ngModelChange", "exFocusChange", "change", "indeterminateChange", "focusout"]], template: function ExCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ExCheckboxComponent_div_0_Template, 2, 1, "div", 0);
            i0.ɵɵtemplate(1, ExCheckboxComponent_ng_template_1_Template, 4, 11, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExCheckboxComponent_ng_template_3_Template, 6, 23, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.sectionId || !ctx.isQuickAccessScope)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$6.NgControlStatus, i1$6.NgModel, i1$1.MatCheckbox, ExFocusDirective, ExFormAriaAttributesDirective, ExQuickAccessDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-checkbox-wrapper[_ngcontent-%COMP%]{padding-top:3px}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-form-field{align-items:flex-start}.ex-checkbox-wrapper.single-line[_ngcontent-%COMP%]     .mat-mdc-checkbox{display:inline}.ex-checkbox-wrapper.single-line[_ngcontent-%COMP%]     .mat-mdc-checkbox .mdc-label{text-overflow:ellipsis;white-space:nowrap}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox .mdc-checkbox__native-control{top:unset;right:unset;left:unset}.ex-checkbox-wrapper[_ngcontent-%COMP%]   .ex-checkbox-checkbox[_ngcontent-%COMP%]{width:100%}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .cdk-keyboard-focused .mdc-checkbox__background{outline:black solid 1px}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox .mdc-checkbox input:focus~.mdc-checkbox__background{outline-width:2px!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox__ripple, .ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox-ripple{top:50%;height:48px;left:50%;width:48px;transform:translate(-50%,-50%)}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox-touch-target{height:10px;width:10px}.ex-checkbox-wrapper[_ngcontent-%COMP%]   .ex-checkbox-valid[_ngcontent-%COMP%]     .mat-checkbox-frame{border:2px solid #c75757!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]   .ex-checkbox-readonly[_ngcontent-%COMP%]     .mat-checkbox-label{color:#000!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled)   .mat-checkbox-inner-container:hover .mat-checkbox-ripple .mat-ripple-element{background-color:#000!important;opacity:.1!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled).mat-checkbox-checked   .mat-checkbox-background, .ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled).mat-checkbox-indeterminate   .mat-checkbox-background{background-color:#0e7bbafa!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled   .mdc-checkbox__background{background-color:#dfdfdf!important;opacity:.5}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-checked   .mdc-checkbox__background, .ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-indeterminate   .mdc-checkbox__background{background-color:#0e7bba80!important;opacity:1!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-checked   .mat-checkbox-frame, .ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-indeterminate   .mat-checkbox-frame{opacity:0}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent   .mat-checkbox-label{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent   .mat-checkbox-frame{border-width:1px!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mat-mdc-checkbox.mat-accent   .mdc-checkbox__background{border-width:1px!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox{margin-bottom:.5rem!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox__background{position:unset!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox__mixedmark{background-color:#fafafa;width:80%!important}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox__checkmark{inset:auto!important;width:70%}.ex-checkbox-wrapper[_ngcontent-%COMP%]     .mdc-checkbox__checkmark .mdc-checkbox__checkmark-path{stroke-width:2.7px}[_nghost-%COMP%]{--mdc-checkbox-disabled-selected-icon-color: rgba(223, 223, 223, .5);--mdc-checkbox-selected-checkmark-color: #fafafa;--mdc-checkbox-selected-focus-icon-color: #0e7bbafa;--mdc-checkbox-selected-hover-icon-color: #0e7bbafa;--mdc-checkbox-selected-icon-color: #0e7bbafa;--mdc-checkbox-selected-pressed-icon-color: #0e7bbafa;--mdc-checkbox-unselected-focus-icon-color: #212121;--mdc-checkbox-unselected-hover-icon-color: #212121;--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, 1);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-selected-focus-state-layer-color: #0e7bbafa;--mdc-checkbox-selected-hover-state-layer-color: #0e7bbafa;--mdc-checkbox-selected-pressed-state-layer-color: #0e7bbafa;--mdc-checkbox-unselected-focus-state-layer-color: black;--mdc-checkbox-unselected-hover-state-layer-color: black;--mdc-checkbox-unselected-pressed-state-layer-color: black;--mdc-checkbox-disabled-unselected-icon-color: #b0b0b0}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-checkbox', host: {
                    '(checkedChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExCheckboxComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!sectionId || !isQuickAccessScope; else withinSection\" (click)=\"onWrapperClick($event)\" class=\"ex-checkbox-wrapper\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n<ng-template #withinSection>\n  <div (click)=\"onWrapperClick($event)\" class=\"ex-checkbox-wrapper {{uniqueSelector ? (('ex-checkbox-wrapper-' + uniqueSelector) | generateHTMLId) : '' }}\" exQuickAccess = \"{{label | translate}}\" [exQuickAccessType]=\"quickAcssessTypes.FIELD\" [exQuickAccessSection] =\"sectionId\"\n  ><ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </div>\n</ng-template>\n<ng-template #content>\n  <mat-checkbox class=\"ex-checkbox-checkbox {{uniqueSelector ? (('ex-checkbox-checkbox' + uniqueSelector) | generateHTMLId) : ''}}\"\n                [ngClass]=\"{'ex-checkbox-valid' : !valid, 'ex-checkbox-readonly': isReadOnly, 'cdk-keyboard-focused': isFieldFocused}\" [(ngModel)]=\"checked\"\n                [ngModelOptions]=\"isStandalone ? {standalone: true} : {}\"\n                [(exFocus)]=\"isFieldFocused\"\n                [indeterminate]=\"indeterminate\" [disabled]=\"disabled || isReadOnly\" (change)=\"onChange($event)\" [aria-label]=\"ariaLabel ?? (label | translate)\"\n                (indeterminateChange)=\"onIndeterminateChange($event)\" (focusout)=\"onBlur($event)\" exFormAriaAttributes><ng-content></ng-content>{{ label | translate }}</mat-checkbox>\n\n</ng-template>\n", styles: [".ex-checkbox-wrapper{padding-top:3px}.ex-checkbox-wrapper ::ng-deep .mdc-form-field{align-items:flex-start}.ex-checkbox-wrapper.single-line ::ng-deep .mat-mdc-checkbox{display:inline}.ex-checkbox-wrapper.single-line ::ng-deep .mat-mdc-checkbox .mdc-label{text-overflow:ellipsis;white-space:nowrap}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox .mdc-checkbox__native-control{top:unset;right:unset;left:unset}.ex-checkbox-wrapper .ex-checkbox-checkbox{width:100%}.ex-checkbox-wrapper ::ng-deep .cdk-keyboard-focused .mdc-checkbox__background{outline:black solid 1px}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox .mdc-checkbox input:focus~.mdc-checkbox__background{outline-width:2px!important}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox__ripple,.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox-ripple{top:50%;height:48px;left:50%;width:48px;transform:translate(-50%,-50%)}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox-touch-target{height:10px;width:10px}.ex-checkbox-wrapper .ex-checkbox-valid ::ng-deep .mat-checkbox-frame{border:2px solid #c75757!important}.ex-checkbox-wrapper .ex-checkbox-readonly ::ng-deep .mat-checkbox-label{color:#000!important}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled) ::ng-deep .mat-checkbox-inner-container:hover .mat-checkbox-ripple .mat-ripple-element{background-color:#000!important;opacity:.1!important}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled).mat-checkbox-checked ::ng-deep .mat-checkbox-background,.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent:not(.mat-checkbox-disabled).mat-checkbox-indeterminate ::ng-deep .mat-checkbox-background{background-color:#0e7bbafa!important}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled ::ng-deep .mdc-checkbox__background{background-color:#dfdfdf!important;opacity:.5}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-checked ::ng-deep .mdc-checkbox__background,.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-indeterminate ::ng-deep .mdc-checkbox__background{background-color:#0e7bba80!important;opacity:1!important}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-checked ::ng-deep .mat-checkbox-frame,.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent.mat-mdc-checkbox-disabled.mat-mdc-checkbox-indeterminate ::ng-deep .mat-checkbox-frame{opacity:0}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent ::ng-deep .mat-checkbox-label{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent ::ng-deep .mat-checkbox-frame{border-width:1px!important}.ex-checkbox-wrapper ::ng-deep .mat-mdc-checkbox.mat-accent ::ng-deep .mdc-checkbox__background{border-width:1px!important}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox{margin-bottom:.5rem!important}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox__background{position:unset!important}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox__mixedmark{background-color:#fafafa;width:80%!important}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox__checkmark{inset:auto!important;width:70%}.ex-checkbox-wrapper ::ng-deep .mdc-checkbox__checkmark .mdc-checkbox__checkmark-path{stroke-width:2.7px}:host{--mdc-checkbox-disabled-selected-icon-color: rgba(223, 223, 223, .5);--mdc-checkbox-selected-checkmark-color: #fafafa;--mdc-checkbox-selected-focus-icon-color: #0e7bbafa;--mdc-checkbox-selected-hover-icon-color: #0e7bbafa;--mdc-checkbox-selected-icon-color: #0e7bbafa;--mdc-checkbox-selected-pressed-icon-color: #0e7bbafa;--mdc-checkbox-unselected-focus-icon-color: #212121;--mdc-checkbox-unselected-hover-icon-color: #212121;--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, 1);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-selected-focus-state-layer-color: #0e7bbafa;--mdc-checkbox-selected-hover-state-layer-color: #0e7bbafa;--mdc-checkbox-selected-pressed-state-layer-color: #0e7bbafa;--mdc-checkbox-unselected-focus-state-layer-color: black;--mdc-checkbox-unselected-hover-state-layer-color: black;--mdc-checkbox-unselected-pressed-state-layer-color: black;--mdc-checkbox-disabled-unselected-icon-color: #b0b0b0}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS_SCOPE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { label: [{
            type: Input
        }], checked: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], isStandalone: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], checkedChange: [{
            type: Output
        }], checkboxChange: [{
            type: Output
        }], indeterminateChange: [{
            type: Output
        }], matCheckbox: [{
            type: ViewChild,
            args: [MatCheckbox]
        }] }); })();

class GeneralListLayoutComponent {
    constructor() {
        /**
         * The items of the list
         */
        this._items = [];
        this.type = "list";
        this.typeChange = new EventEmitter();
        this.dynamicComponents = false;
        this.isItemOpenDefinedByUrl = false;
        this._isItemOpen = false;
        this._viewMode = ViewModes.SPLIT;
        this.newExport = false;
        this.exportEnabled = true;
        this.hasMinimizedSearch = false;
        /**
         * Event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        /**
         * Event fired when the page size change
         */
        this.pageSizeChange = new EventEmitter();
        /**
         * Event fired when one of the sort change
         */
        this.sortChange = new EventEmitter();
        /**
         * Event fired when one of the search change
         */
        this.searchChange = new EventEmitter();
        this.searchSelectedValueChange = new EventEmitter();
        /**
         * Event fired when an action is clicked
         */
        this.actionClicked = new EventEmitter();
        /**
         * Event fired when split view toggle, true = side by side
         */
        this.splitViewOpen = new EventEmitter();
        /**
         * Fires when user changes the split view
         */
        this.viewModeChange = new EventEmitter();
        this.isItemOpenChange = new EventEmitter();
        this.comboboxItemClicked = new EventEmitter();
        /**
         * Event fired when a row is clicked, emits the index of the clicked row;
         * NOT used by ex-items-layout which uses itemSelected
         */
        this.rowClicked = new EventEmitter();
        this.rowUnClicked = new EventEmitter();
        /**
         * Event fired when an item is selected, emits the selected item
         */
        this.itemSelected = new EventEmitter();
        /**
         * Event fired when an item is deselected, emits the deselected item
         */
        this.itemDeselected = new EventEmitter();
        this.sublistClicked = new EventEmitter();
        this.loadMoreSublist = new EventEmitter();
        this.checkboxChanged = new EventEmitter();
        this.checkedItemsChange = new EventEmitter();
        this.filterChanged = new EventEmitter();
        this.datesUpdated = new EventEmitter();
        this.clearDates = new EventEmitter();
        this.fullPageModeChange = new EventEmitter();
        this.leftSideWitdhChanged = new EventEmitter();
        this.rightSideWitdhChanged = new EventEmitter();
        /**
         * Event emitted when the selected item changes, emits the index of the selected item;
         * not used by ex-items-layout which uses selectedItemObjectChange
         */
        this.selectedItemChange = new EventEmitter();
        /**
         * Event emitted when the selected item changes, emits the selected item
         */
        this.selectedItemObjectChange = new EventEmitter();
        /**
         * Event emitted when a row that was dragged is dropped
         */
        this.rowDragged = new EventEmitter();
        /**
         * Event emitted when the layout 'refresh' button is clicked
         */
        this.refreshClicked = new EventEmitter();
        /**
         * Event emitted when a target is selected for the 'move' action in a tree layout,
         * emits the items to move and the target id
         */
        this.itemsMoved = new EventEmitter();
        this.layoutStateChanged = new EventEmitter();
        this.export = new EventEmitter();
        this.gallerySlider = 180;
        this.gallerySliderChange = new EventEmitter();
        this._isExpanded = false;
    }
    get items() {
        return this._items;
    }
    set items(items) {
        this._items = items;
        this.onItemsChanged();
    }
    set isItemOpen(value) {
        if (this._isItemOpen == value || !this.listProperties?.canSelectRow) {
            return;
        }
        this._isItemOpen = value;
        this.setIsItemOpen(value);
        this.isItemOpenChange.emit(this.isItemOpen);
    }
    get isItemOpen() {
        return this._isItemOpen;
    }
    set viewMode(value) {
        if (this.viewMode == value) {
            return;
        }
        this._viewMode = value;
        this.setViewMode(value);
        this.viewModeChange.emit(value);
    }
    get viewMode() {
        return this._viewMode;
    }
    set isExpanded(val) {
        this._isExpanded = val;
        this.setIsExpanded();
    }
    get isExpanded() {
        return this.getIsExpanded();
    }
    selectItemById(id) { }
    getItemById(id) {
        return this.items.find(item => item.id === id);
    }
    ;
    getFlatItemsList() {
        return this.items;
    }
    itemsReloaded() { }
    itemsDeleted(ids) { }
    onItemsChanged() { }
    setIsItemOpen(value) { }
    setViewMode(value) { }
    getIsExpanded() {
        return this._isExpanded;
    }
    setIsExpanded() { }
    static { this.ɵfac = function GeneralListLayoutComponent_Factory(t) { return new (t || GeneralListLayoutComponent)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: GeneralListLayoutComponent, inputs: { type: "type", items: "items", listProperties: "listProperties", itemDetails: "itemDetails", htmlId: "htmlId", clearAllSubject: "clearAllSubject", dynamicComponents: "dynamicComponents", noResultsPlaceholder: "noResultsPlaceholder", noResultsHintPlaceholder: "noResultsHintPlaceholder", isItemOpen: "isItemOpen", viewMode: "viewMode", newExport: "newExport", exportEnabled: "exportEnabled", hasMinimizedSearch: "hasMinimizedSearch", gallerySlider: "gallerySlider" }, outputs: { typeChange: "typeChange", selectedPageChange: "selectedPageChange", pageSizeChange: "pageSizeChange", sortChange: "sortChange", searchChange: "searchChange", searchSelectedValueChange: "searchSelectedValueChange", actionClicked: "actionClicked", splitViewOpen: "splitViewOpen", viewModeChange: "viewModeChange", isItemOpenChange: "isItemOpenChange", comboboxItemClicked: "comboboxItemClicked", rowClicked: "rowClicked", rowUnClicked: "rowUnClicked", itemSelected: "itemSelected", itemDeselected: "itemDeselected", sublistClicked: "sublistClicked", loadMoreSublist: "loadMoreSublist", checkboxChanged: "checkboxChanged", checkedItemsChange: "checkedItemsChange", filterChanged: "filterChanged", datesUpdated: "datesUpdated", clearDates: "clearDates", fullPageModeChange: "fullPageModeChange", leftSideWitdhChanged: "leftSideWitdhChanged", rightSideWitdhChanged: "rightSideWitdhChanged", selectedItemChange: "selectedItemChange", selectedItemObjectChange: "selectedItemObjectChange", rowDragged: "rowDragged", refreshClicked: "refreshClicked", itemsMoved: "itemsMoved", layoutStateChanged: "layoutStateChanged", export: "export", gallerySliderChange: "gallerySliderChange" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeneralListLayoutComponent, [{
        type: Directive
    }], null, { type: [{
            type: Input
        }], typeChange: [{
            type: Output
        }], items: [{
            type: Input
        }], listProperties: [{
            type: Input
        }], itemDetails: [{
            type: Input
        }], htmlId: [{
            type: Input
        }], clearAllSubject: [{
            type: Input
        }], dynamicComponents: [{
            type: Input
        }], noResultsPlaceholder: [{
            type: Input
        }], noResultsHintPlaceholder: [{
            type: Input
        }], isItemOpen: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], newExport: [{
            type: Input
        }], exportEnabled: [{
            type: Input
        }], hasMinimizedSearch: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], searchSelectedValueChange: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], splitViewOpen: [{
            type: Output
        }], viewModeChange: [{
            type: Output
        }], isItemOpenChange: [{
            type: Output
        }], comboboxItemClicked: [{
            type: Output
        }], rowClicked: [{
            type: Output
        }], rowUnClicked: [{
            type: Output
        }], itemSelected: [{
            type: Output
        }], itemDeselected: [{
            type: Output
        }], sublistClicked: [{
            type: Output
        }], loadMoreSublist: [{
            type: Output
        }], checkboxChanged: [{
            type: Output
        }], checkedItemsChange: [{
            type: Output
        }], filterChanged: [{
            type: Output
        }], datesUpdated: [{
            type: Output
        }], clearDates: [{
            type: Output
        }], fullPageModeChange: [{
            type: Output
        }], leftSideWitdhChanged: [{
            type: Output
        }], rightSideWitdhChanged: [{
            type: Output
        }], selectedItemChange: [{
            type: Output
        }], selectedItemObjectChange: [{
            type: Output
        }], rowDragged: [{
            type: Output
        }], refreshClicked: [{
            type: Output
        }], itemsMoved: [{
            type: Output
        }], layoutStateChanged: [{
            type: Output
        }], export: [{
            type: Output
        }], gallerySlider: [{
            type: Input
        }], gallerySliderChange: [{
            type: Output
        }] }); })();

function ExSideBySideComponent_as_split_area_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "as-split-area", 3);
    i0.ɵɵlistener("resized", function ExSideBySideComponent_as_split_area_1_Template_as_split_area_resized_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.leftSideResized.emit($event)); });
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("minSize", ctx_r0.leftMinSize)("size", ctx_r0.leftSize)("order", 0);
} }
function ExSideBySideComponent_as_split_area_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "as-split-area", 4);
    i0.ɵɵlistener("resized", function ExSideBySideComponent_as_split_area_3_Template_as_split_area_resized_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4._rightSideHeightChange($event)); });
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("minSize", ctx_r1.rightMinSize)("size", ctx_r1.rightSize)("order", 2);
} }
const _c0$1P = [[["", "expand-button", ""]], [["", "slot-side-1", ""]], [["", "slot-side-2", ""]]];
const _c1$1c = ["[expand-button]", "[slot-side-1]", "[slot-side-2]"];
class ExSideBySideComponent {
    /**
     * @ignore
     */
    constructor() {
        /**
         * initial left side size - optional
         */
        this.leftSize = 50;
        /**
         * initial right side size - optional
         */
        this.rightSize = 50;
        /**
         * visibility of left side - optional
         */
        this.leftVisible = true;
        /**
         * visibility of left side -optional
         */
        this.rightVisible = true;
        /**
         * minimum left side size - optional
         */
        this.leftMinSize = 0;
        /**
         * minimum right side size - optional
         */
        this.rightMinSize = 0;
        /**
         * this event fires whenever the user strats to drag the gutter (mousedown)
         */
        this.gutterDragStart = new EventEmitter();
        /**
         * this event fires whenever the user stops dragging the gutter (mouseup)
         */
        this.gutterDragEnd = new EventEmitter();
        this.rightSideHeightChange = new EventEmitter();
        this.leftSideResized = new EventEmitter();
        /* temporary fix to URM-186261 */
        const fixURM186261 = setInterval(() => {
            const script = $('style:contains(\'.mat-expansion-panel-content[style*="visibility: hidden"]\')');
            if (script.length) {
                clearInterval(fixURM186261);
                const newValue = script.html().replace("*{visibility:hidden !important}", "{visibility:hidden !important}");
                script.html(newValue);
            }
        }, 2000);
        setTimeout(() => clearInterval(fixURM186261), 11000);
    }
    onDragStart(data) {
        this.gutterDragStart.emit(data);
    }
    onDragEnd(data) {
        this.gutterDragEnd.emit(data);
    }
    scrollRightSideToTop() {
        if (document.querySelector(".ex-side-by-side-right")) {
            document.querySelector(".ex-side-by-side-right").scrollTo(0, 0);
        }
    }
    _rightSideHeightChange(event) {
        if (!event.oldRect || Math.abs(event.newRect.height - event.oldRect.height) > 5) {
            this.rightSideHeightChange.emit(event.newRect.height);
        }
    }
    static { this.ɵfac = function ExSideBySideComponent_Factory(t) { return new (t || ExSideBySideComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSideBySideComponent, selectors: [["ex-side-by-side"]], inputs: { leftSize: "leftSize", rightSize: "rightSize", leftVisible: "leftVisible", rightVisible: "rightVisible", leftMinSize: "leftMinSize", rightMinSize: "rightMinSize", isRtl: "isRtl" }, outputs: { gutterDragStart: "gutterDragStart", gutterDragEnd: "gutterDragEnd", rightSideHeightChange: "rightSideHeightChange", leftSideResized: "leftSideResized" }, ngContentSelectors: _c1$1c, decls: 4, vars: 3, consts: [[1, "ex-side-by-side-split", 3, "dir", "dragEnd", "dragStart"], ["class", "sel-ex-side-by-side-split-area-left", 3, "minSize", "size", "order", "resized", 4, "ngIf"], ["class", "ex-side-by-side-right sel-ex-side-by-side-split-area-right", 3, "minSize", "size", "order", "resized", 4, "ngIf"], [1, "sel-ex-side-by-side-split-area-left", 3, "minSize", "size", "order", "resized"], [1, "ex-side-by-side-right", "sel-ex-side-by-side-split-area-right", 3, "minSize", "size", "order", "resized"]], template: function ExSideBySideComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$1P);
            i0.ɵɵelementStart(0, "as-split", 0);
            i0.ɵɵlistener("dragEnd", function ExSideBySideComponent_Template_as_split_dragEnd_0_listener($event) { return ctx.onDragEnd($event); })("dragStart", function ExSideBySideComponent_Template_as_split_dragStart_0_listener($event) { return ctx.onDragStart($event); });
            i0.ɵɵtemplate(1, ExSideBySideComponent_as_split_area_1_Template, 2, 3, "as-split-area", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, ExSideBySideComponent_as_split_area_3_Template, 2, 3, "as-split-area", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("dir", ctx.isRtl ? "rtl" : "ltr");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.leftVisible);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.rightVisible);
        } }, dependencies: [i1$5.NgIf, i2$3.SplitComponent, i2$3.SplitAreaDirective, ResizedDirective], styles: [".as-split-gutter-icon{background-color:#fff!important;border-inline-start:1px solid #ccc;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACNJREFUeNpi7Ozs/M8ABOXl5YwwNhMDRYBx1MxRM/GaCRBgAJjDNOmsv/cyAAAAAElFTkSuQmCC)!important}[_nghost-%COMP%]     .as-split-gutter{height:auto!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSideBySideComponent, [{
        type: Component,
        args: [{ selector: 'ex-side-by-side', template: "<as-split class=\"ex-side-by-side-split\" [dir]=\"isRtl ? 'rtl' : 'ltr'\" (dragEnd)=\"onDragEnd($event)\" (dragStart)=\"onDragStart($event)\">\n    <as-split-area class=\"sel-ex-side-by-side-split-area-left\" [minSize]=\"leftMinSize\" *ngIf=\"leftVisible\" [size]=\"leftSize\" [order]=\"0\" (resized)=\"leftSideResized.emit($event)\">\n        <ng-content select=\"[slot-side-1]\"></ng-content>\n    </as-split-area>\n    <ng-content select=\"[expand-button]\"></ng-content>\n    <as-split-area (resized)=\"_rightSideHeightChange($event)\" class=\"ex-side-by-side-right sel-ex-side-by-side-split-area-right\" [minSize]=\"rightMinSize\" *ngIf=\"rightVisible\" [size]=\"rightSize\" [order]=\"2\">\n        <ng-content select=\"[slot-side-2]\"></ng-content>\n    </as-split-area>\n</as-split>\n", styles: ["::ng-deep .as-split-gutter-icon{background-color:#fff!important;border-inline-start:1px solid #ccc;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACNJREFUeNpi7Ozs/M8ABOXl5YwwNhMDRYBx1MxRM/GaCRBgAJjDNOmsv/cyAAAAAElFTkSuQmCC)!important}:host ::ng-deep .as-split-gutter{height:auto!important}\n"] }]
    }], function () { return []; }, { leftSize: [{
            type: Input
        }], rightSize: [{
            type: Input
        }], leftVisible: [{
            type: Input
        }], rightVisible: [{
            type: Input
        }], leftMinSize: [{
            type: Input
        }], rightMinSize: [{
            type: Input
        }], isRtl: [{
            type: Input
        }], gutterDragStart: [{
            type: Output
        }], gutterDragEnd: [{
            type: Output
        }], rightSideHeightChange: [{
            type: Output
        }], leftSideResized: [{
            type: Output
        }] }); })();

const ExItemsLayoutAnimations = [
    trigger('expanded-header', [
        state('false', style({
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            opacity: 0
        })),
        transition('false => true', [
            style({
                overflow: 'hidden'
            }),
            animate(200)
        ]),
        transition('true => false', [
            animate(200, style({
                height: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                opacity: 0
            }))
        ])
    ])
];

class ExItemsLayoutService {
    constructor() {
        this._itemsReloaded = new Subject();
        this.itemsReloaded$ = this._itemsReloaded.asObservable();
        // Record breakpoint params
        this.WIDTH_CHANGE_THRESHOLD = 30;
        this.BREAKPOINT_3_THRESHOLD = 900;
        this.BREAKPOINT_2_THRESHOLD = 700;
        this.lastWidth = 1000;
        this.lastSplitBreakpoint = 1;
        this.lastListBreakpoint = 3;
        this.currentBreakpoint = 3;
        this.selectItemByIdSubject = new Subject();
        this.selectItemById$ = this.selectItemByIdSubject.asObservable();
        this.numCurrentItems = new Subject();
        this.numCurrentItems$ = this.numCurrentItems.asObservable();
        this.numCheckedCurrentItems = new Subject();
        this.numCheckedCurrentItems$ = this.numCheckedCurrentItems.asObservable();
        this.currentItemsChecked = new Subject();
        this.currentItemsChecked$ = this.currentItemsChecked.asObservable();
        this._hasNextItem = new BehaviorSubject(false);
        this.hasNextItem$ = this._hasNextItem.asObservable();
        this._hasPreviousItem = new BehaviorSubject(false);
        this.hasPreviousItem$ = this._hasPreviousItem.asObservable();
        this.nextClicked = new Subject();
        this.nextClicked$ = this.nextClicked.asObservable();
        this.previousClicked = new Subject();
        this.previousClicked$ = this.previousClicked.asObservable();
        this.actionPerformed = new Subject();
        this.actionPerformed$ = this.actionPerformed.asObservable();
        this.itemsDeleted = new Subject();
        this.itemsDeleted$ = this.itemsDeleted.asObservable();
        this.itemDetailsStartReached = new Subject();
        this.itemDetailsStartReached$ = this.itemDetailsStartReached.asObservable();
        this.itemDetailsEndReached = new Subject();
        this.itemDetailsEndReached$ = this.itemDetailsEndReached.asObservable();
        this.itemDetailsClosed = new Subject();
        this.itemDetailsClosed$ = this.itemDetailsClosed.asObservable();
        this.tabFromItemEnd = new Subject();
        this.tabFromItemEnd$ = this.tabFromItemEnd.asObservable();
        this.listBreakPointSubject = new ReplaySubject(1);
        this.listBreakPoint$ = this.listBreakPointSubject.asObservable();
        this.expandLeftSidenavChange = new ReplaySubject(1);
        this.expandLeftSidenavChange$ = this.expandLeftSidenavChange.asObservable();
    }
    itemsReloaded() {
        this._itemsReloaded.next();
    }
    onItemsReloaded() {
        return this.itemsReloaded$;
    }
    selectItemById(id) {
        this.selectItemByIdSubject.next(id);
    }
    onSelectItemById() {
        return this.selectItemById$;
    }
    updateNumCurrentItems(value) {
        this.numCurrentItems.next(value);
    }
    onNumCurrentItemsUpdated() {
        return this.numCurrentItems$;
    }
    updateNumCheckedCurrentItems(value) {
        this.numCheckedCurrentItems.next(value);
    }
    onNumCheckedCurrentItemsUpdated() {
        return this.numCheckedCurrentItems$;
    }
    setCurrentItemsChecked(state) {
        this.currentItemsChecked.next(state);
    }
    onSetCurrentItemsChecked() {
        return this.currentItemsChecked$;
    }
    updateHasNextItem(value) {
        this._hasNextItem.next(value);
    }
    hasNextItem() {
        return this.hasNextItem$;
    }
    updateHasPreviousItem(value) {
        this._hasPreviousItem.next(value);
    }
    hasPreviousItem() {
        return this.hasPreviousItem$;
    }
    notifyNextClicked() {
        this.nextClicked.next();
    }
    onNextClicked() {
        return this.nextClicked$;
    }
    notifyPreviousClicked() {
        this.previousClicked.next();
    }
    onPreviousClicked() {
        return this.previousClicked$;
    }
    notifyActionPerformed(key, items) {
        this.actionPerformed.next({ key: key, items: items });
    }
    onActionPerformed() {
        return this.actionPerformed$;
    }
    notifyItemsDeleted() {
        this.itemsDeleted.next();
    }
    onItemsDeleted() {
        return this.itemsDeleted$;
    }
    notifyItemDetailsStartReached() {
        this.itemDetailsStartReached.next();
    }
    onItemDetailsStartReached() {
        return this.itemDetailsStartReached$;
    }
    notifyItemDetailsEndReached() {
        this.itemDetailsEndReached.next();
    }
    onItemDetailsEndReached() {
        return this.itemDetailsEndReached$;
    }
    notifyItemDetailsClosed() {
        this.itemDetailsClosed.next();
    }
    onItemDetailsClosed() {
        return this.itemDetailsClosed$;
    }
    notifytabFromItemEnd() {
        this.tabFromItemEnd.next();
    }
    notifyExpandLeftSidenavChange(isExpanded) {
        this.expandLeftSidenavChange.next(isExpanded);
    }
    ontabFromItemEnd() {
        return this.tabFromItemEnd$;
    }
    setLayoutWrapper(elementRef) {
        this.layoutWrapperElement = elementRef;
    }
    getLayoutWrapperBoundingClientRect() {
        return this.layoutWrapperElement?.nativeElement.getBoundingClientRect();
    }
    setListBreakpoint(leftSideWidth) {
        let breakpoint = undefined;
        if (Math.abs(this.lastWidth - leftSideWidth) > this.WIDTH_CHANGE_THRESHOLD) {
            this.lastWidth = leftSideWidth;
            if (this.lastWidth > this.BREAKPOINT_3_THRESHOLD) {
                breakpoint = 3;
            }
            else if (this.lastWidth > this.BREAKPOINT_2_THRESHOLD) {
                breakpoint = 2;
            }
            else {
                breakpoint = 1;
            }
        }
        if (breakpoint) {
            this.currentBreakpoint = breakpoint;
            this.listBreakPointSubject.next(breakpoint);
        }
    }
    // used to solve the bad performance when openning split view
    fireLastBreakpoint(isSplit = true) {
        if (isSplit) {
            this.lastListBreakpoint = this.currentBreakpoint;
            this.currentBreakpoint = this.lastSplitBreakpoint;
        }
        else {
            this.lastSplitBreakpoint = this.currentBreakpoint;
            this.currentBreakpoint = this.lastListBreakpoint;
        }
        this.listBreakPointSubject.next(this.currentBreakpoint);
    }
    static { this.ɵfac = function ExItemsLayoutService_Factory(t) { return new (t || ExItemsLayoutService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExItemsLayoutService, factory: ExItemsLayoutService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutService, [{
        type: Injectable
    }], function () { return []; }, null); })();

var Status$1;
(function (Status) {
    Status["Saving"] = "SAVING";
    Status["Saved"] = "SAVED";
    Status["Error"] = "ERROR";
})(Status$1 || (Status$1 = {}));
const ItemDetailsHeaderStatus = Status$1;
const Statuses = {
    [Status$1.Saving]: {
        data: 'ng.general.saving_changes',
        iconName: 'saving',
        iconType: 'svg',
        iconColor: '#A2A2A2',
        statusTextolor: '#A2A2A2',
        iconFontSize: '18px'
    },
    [Status$1.Saved]: {
        data: 'ng.general.saved',
        iconName: 'check_circle',
        iconType: 'matIcon',
        iconColor: '#33ba8f',
        iconFontSize: '18px'
    },
    [Status$1.Error]: {
        data: 'ng.general.failed',
        iconName: 'error',
        iconType: 'matIcon',
        iconColor: '#c62726',
        iconFontSize: '18px'
    }
};
class ItemStatusService {
}
class ExItemDetailsHeaderStatusService {
    constructor() {
        this.statusSubject = new BehaviorSubject({});
        this.status$ = this.statusSubject.asObservable();
        this.statuses = {};
    }
    setSaving(id) {
        let count = this.statuses[id]?.count ?? 0;
        this.statuses[id] = { count: ++count, status: Status$1.Saving };
        this.triggerChange();
    }
    setSaved(id) {
        let count = this.statuses[id]?.count ?? 1;
        this.statuses[id] = { ...this.statuses[id], count: --count };
        if (this.statuses[id].count === 0) {
            this.statuses[id] = { ...this.statuses[id], status: Status$1.Saved };
        }
        this.triggerChange();
    }
    setError(id) {
        let count = this.statuses[id]?.count ?? 1;
        this.statuses[id] = { count: --count, status: Status$1.Error };
        this.triggerChange();
    }
    getStatusData(status) {
        return { ...Statuses[status] };
    }
    onStatusChange(id) {
        return this.status$.pipe(map(data => data[id] && ({ ...data[id] })), filter(d => !!d));
    }
    triggerChange() {
        this.statusSubject.next(this.statuses);
        Object.keys(this.statuses).forEach(k => this.statuses[k]?.count === 0 && delete this.statuses[k]);
    }
    static { this.ɵfac = function ExItemDetailsHeaderStatusService_Factory(t) { return new (t || ExItemDetailsHeaderStatusService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExItemDetailsHeaderStatusService, factory: ExItemDetailsHeaderStatusService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemDetailsHeaderStatusService, [{
        type: Injectable
    }], null, null); })();

const SINGLE_SAVE_NOT_SAVED_WARNING = {
    type: "warning",
    positiveLabel: "ng.button.continue",
    negativeLabel: "ng.general.cancel",
    title: "ng.single_save.not_saved_warning_title",
    message: "ng.single_save.not_saved_warning_message",
    list: [],
    confirmation: "ng.single_save.not_saved_warning_confirmation"
};
function SingleSaveExitWithoutSaveWarning(sectionsLayoutServicePropertyKey, dialogServicePropertyKey, predicate) {
    return function (target, propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            const predicateMet = predicate ? predicate() : true;
            const isSingleSave = this[sectionsLayoutServicePropertyKey]?.getIsSingleSave?.();
            const isDirty = sectionsStateIsDirty(this[sectionsLayoutServicePropertyKey]?.getFormsState?.());
            if (predicateMet && isSingleSave && isDirty) {
                openWarningDialog(this[dialogServicePropertyKey]).subscribe(confirmed => {
                    if (!!confirmed)
                        return originalMethod.apply(this, args);
                });
            }
            else {
                return originalMethod.apply(this, args);
            }
        };
    };
}
function sectionsStateIsDirty(state) {
    return Object.entries(state ?? {}).some(([key, value]) => value.dirty == true);
}
function openWarningDialog(dialogService) {
    if (!dialogService)
        return of(false);
    return dialogService?.showBasicConfirmationDialog?.(SINGLE_SAVE_NOT_SAVED_WARNING).afterClosed();
}

class ExSectionsLayoutListLayoutService {
    constructor() {
        this.sectionListChanged = new Subject();
        this.sectionSelected = new Subject();
        this.isFullPageChange = new BehaviorSubject(false);
        this.rightSideHeightChange = new Subject();
        this.openRightSideSubj = new Subject();
        this.openRightSide$ = this.openRightSideSubj.asObservable();
    }
    static { this.ɵfac = function ExSectionsLayoutListLayoutService_Factory(t) { return new (t || ExSectionsLayoutListLayoutService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSectionsLayoutListLayoutService, factory: ExSectionsLayoutListLayoutService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutListLayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ExSidenavPageService {
    constructor() {
        this.contentWide = new ReplaySubject(1);
        this.contentWidthChecked = new BehaviorSubject(false);
    }
    static { this.ɵfac = function ExSidenavPageService_Factory(t) { return new (t || ExSidenavPageService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSidenavPageService, factory: ExSidenavPageService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidenavPageService, [{
        type: Injectable
    }], null, null); })();

const ExDialogComponentResetCode = 'ExDialogComponentResetCode';
class ExDialogComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        /**
         * The text on the right label which will continue the action
         */
        this.positiveLabel = 'ng.general.ok';
        this.isPositiveButtonIsPrimary = false;
        /**
         * prevents autofocus inside popup - NOTE: using this input might cause focusing issues and should be handled independently.
         */
        this.preventFirstFieldAutofocus = false;
        /**
         * The dialogs type
         */
        this.type = "info";
        /**
         * The dialogs title
         */
        this.title = 'ng.dialog.title';
        /**
         * The positive button will be disabled and a spinner will appear into.
         */
        this.saveLoading = false;
        /**
         * whether the save button will appear or not, default is true
         */
        this.hasSave = true;
        this.hasReset = false;
        if (data) {
            this.title = data.title;
            this.message = data.message;
            this.negativeLabel = data.negativeLabel;
            this.positiveLabel = data.positiveLabel;
            this.list = data.list;
            this.confirmation = data.confirmation;
            this.type = data.type;
            this.isPositiveButtonIsPrimary = data.isPositiveButtonIsPrimary;
            if (data.hasSave !== undefined) {
                this.hasSave = data.hasSave;
            }
            if (data.hasReset !== undefined) {
                this.hasReset = data.hasReset;
            }
            this.component = data.component;
            this.closeSubject = data.closeSubject;
            if (this.closeSubject) {
                this.closeSubject.subscribe({ next: (value) => this.saveLoading = value, complete: () => this.dialogRef.close(true) });
            }
        }
        this.fieldNavigation = data.fieldNavigation;
        this.titleIcon = data.titleIcon;
        this.uniqueSelector = data.uniqueSelector;
        this.identifier = data.identifier;
    }
    cancelClicked() {
        this.dialogRef.close();
    }
    resetClicked() {
        this.dialogRef.close(ExDialogComponentResetCode);
    }
    saveClicked() {
        if (!this.closeSubject) {
            this.dialogRef.close(true);
        }
        else {
            this.closeSubject.next(true);
        }
    }
    static { this.ɵfac = function ExDialogComponent_Factory(t) { return new (t || ExDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA, 8), i0.ɵɵdirectiveInject(i1$7.MatDialogRef, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDialogComponent, selectors: [["ex-dialog"]], inputs: { message: "message", list: "list", confirmation: "confirmation", negativeLabel: "negativeLabel", positiveLabel: "positiveLabel", isPositiveButtonIsPrimary: "isPositiveButtonIsPrimary", preventFirstFieldAutofocus: "preventFirstFieldAutofocus", type: "type", title: "title", titleIcon: "titleIcon", saveLoading: "saveLoading", hasSave: "hasSave", component: "component", fieldNavigation: "fieldNavigation", uniqueSelector: "uniqueSelector", identifier: "identifier" }, decls: 5, vars: 28, consts: [[3, "keydown.escape"], [3, "message", "list", "confirmation", "negativeLabel", "positiveLabel", "isPositiveButtonIsPrimary", "identifier", "type", "title", "titleIcon", "saveLoading", "component", "fieldNavigation", "close"], ["exShortcutsScope", "dialog", "align", "end", 1, "ex-dialog-actions", 3, "keydown.escape"], [3, "hasDelete", "hasReset", "hasCancel", "hasSave", "saveLabel", "cancelLabel", "isSaveIsPrimary", "saveLoading", "uniqueSelector", "cancelClicked", "saveClicked", "resetClicked"]], template: function ExDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-dialog-content", 0);
            i0.ɵɵlistener("keydown.escape", function ExDialogComponent_Template_mat_dialog_content_keydown_escape_0_listener() { return !ctx.saveLoading && !!ctx.negativeLabel ? ctx.cancelClicked() : null; });
            i0.ɵɵpipe(1, "generateHTMLId");
            i0.ɵɵelementStart(2, "ex-dialog-content", 1);
            i0.ɵɵlistener("close", function ExDialogComponent_Template_ex_dialog_content_close_2_listener() { return ctx.cancelClicked(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "mat-dialog-actions", 2);
            i0.ɵɵlistener("keydown.escape", function ExDialogComponent_Template_mat_dialog_actions_keydown_escape_3_listener() { return !ctx.saveLoading && !!ctx.negativeLabel ? ctx.cancelClicked() : null; });
            i0.ɵɵelementStart(4, "ex-inline-editing-buttons", 3);
            i0.ɵɵlistener("cancelClicked", function ExDialogComponent_Template_ex_inline_editing_buttons_cancelClicked_4_listener() { return ctx.cancelClicked(); })("saveClicked", function ExDialogComponent_Template_ex_inline_editing_buttons_saveClicked_4_listener() { return ctx.saveClicked(); })("resetClicked", function ExDialogComponent_Template_ex_inline_editing_buttons_resetClicked_4_listener() { return ctx.resetClicked(); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("ex-dialog-content ", ctx.uniqueSelector ? i0.ɵɵpipeBind1(1, 26, "ex-dialog-content-" + ctx.uniqueSelector) : "", "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("message", ctx.message)("list", ctx.list)("confirmation", ctx.confirmation)("negativeLabel", ctx.negativeLabel)("positiveLabel", ctx.positiveLabel)("isPositiveButtonIsPrimary", ctx.isPositiveButtonIsPrimary)("identifier", ctx.identifier)("type", ctx.type)("title", ctx.title)("titleIcon", ctx.titleIcon)("saveLoading", ctx.saveLoading)("component", ctx.component)("fieldNavigation", ctx.fieldNavigation);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("tabindex", !ctx.isPositiveButtonIsPrimary && -1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hasDelete", false)("hasReset", ctx.hasReset)("hasCancel", !!ctx.negativeLabel && !ctx.saveLoading)("hasSave", ctx.hasSave)("saveLabel", ctx.positiveLabel)("cancelLabel", ctx.negativeLabel)("isSaveIsPrimary", ctx.isPositiveButtonIsPrimary)("saveLoading", ctx.saveLoading)("uniqueSelector", ctx.uniqueSelector);
        } }, styles: [".ex-dialog-actions[_ngcontent-%COMP%]:focus{outline:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogComponent, [{
        type: Component,
        args: [{ selector: 'ex-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-dialog-content class=\"ex-dialog-content {{uniqueSelector ? (('ex-dialog-content-' + uniqueSelector) | generateHTMLId) : '' }}\"\n  (keydown.escape)=\"(!saveLoading && !!negativeLabel) ? cancelClicked() : null\">\n      <ex-dialog-content  [message]=\"message\" [list]=\"list\" [confirmation]=\"confirmation\"\n                           [negativeLabel]=\"negativeLabel\" [positiveLabel]=\"positiveLabel\"\n                           [isPositiveButtonIsPrimary]=\"isPositiveButtonIsPrimary\" [identifier]=\"identifier\"\n                           [type]=\"type\" [title]=\"title\" [titleIcon]=\"titleIcon\" [saveLoading]=\"saveLoading\"\n                           [component]=\"component\" [fieldNavigation]=\"fieldNavigation\" (close)=\"cancelClicked()\"\n                           ></ex-dialog-content>\n</mat-dialog-content>\n<mat-dialog-actions (keydown.escape)=\"(!saveLoading && !!negativeLabel) ? cancelClicked() : null\" exShortcutsScope=\"dialog\"\nalign=\"end\" [attr.tabindex]=\"!isPositiveButtonIsPrimary && -1\" class=\"ex-dialog-actions\">\n<ex-inline-editing-buttons [hasDelete] =\"false\" [hasReset]=\"hasReset\" [hasCancel]=\"!!negativeLabel && !saveLoading\"\n                           (cancelClicked)=\"cancelClicked()\" (saveClicked)=\"saveClicked()\" (resetClicked)=\"resetClicked()\"\n                           [hasSave]=\"hasSave\" [saveLabel]=\"positiveLabel\" [cancelLabel]=\"negativeLabel\"\n                           [isSaveIsPrimary]=\"isPositiveButtonIsPrimary\" [saveLoading]=\"saveLoading\" [uniqueSelector]=\"uniqueSelector\">\n</ex-inline-editing-buttons>\n</mat-dialog-actions>\n", styles: [".ex-dialog-actions:focus{outline:none}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$7.MatDialogRef, decorators: [{
                type: Optional
            }] }]; }, { message: [{
            type: Input
        }], list: [{
            type: Input
        }], confirmation: [{
            type: Input
        }], negativeLabel: [{
            type: Input
        }], positiveLabel: [{
            type: Input
        }], isPositiveButtonIsPrimary: [{
            type: Input
        }], preventFirstFieldAutofocus: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }], titleIcon: [{
            type: Input
        }], saveLoading: [{
            type: Input
        }], hasSave: [{
            type: Input
        }], component: [{
            type: Input
        }], fieldNavigation: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], identifier: [{
            type: Input
        }] }); })();

class IUserPreferencesService {
    static { this.ɵfac = function IUserPreferencesService_Factory(t) { return new (t || IUserPreferencesService)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IUserPreferencesService }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IUserPreferencesService, [{
        type: Directive
    }], null, null); })();

var svgColors;
(function (svgColors) {
    svgColors["error"] = "#E60000";
    svgColors["info"] = "#4164A4";
    svgColors["success"] = "#378344";
    svgColors["warning"] = "#B85C1E";
})(svgColors || (svgColors = {}));
class ExDialogService {
    constructor(dialog, userPreferencesService) {
        this.dialog = dialog;
        this.userPreferencesService = userPreferencesService;
    }
    showConfirmationDialogWithPreferenceCheck(data = {}) {
        if (!data?.identifier) {
            return of(this.showBasicConfirmationDialog(data));
        }
        return this.userPreferencesService.getUserPreferences('dont_show_again', data.identifier).pipe(map$1((userPref) => {
            if (userPref !== undefined && userPref !== null && userPref === 'true') {
                return null;
            }
            return this.showBasicConfirmationDialog(data);
        }));
    }
    showBasicConfirmationDialog(data = {}) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = data?.["disableClose"] == false ? false : true;
        dialogConfig.autoFocus = (data?.["isPositiveButtonIsPrimary"] && (data?.["autoFocusOnPrimaryButton"] != false)) ? ".ex-button-primary" : ".ex-dialog-actions";
        dialogConfig.minWidth = 400;
        dialogConfig.maxWidth = 700;
        dialogConfig.data = data;
        this.normalizeData(data, { type: null, hasSave: true });
        return this.dialog.open(ExDialogComponent, dialogConfig);
    }
    normalizeData(data = {}, format = {}) {
        Object.keys(format).forEach((key) => {
            if (!data.hasOwnProperty(key)) {
                data[key] = format[key];
            }
        });
    }
    showConfirmationDialog(component, componentsInput = {}, dialogConfiguration = {}, externalMatDialogConfig = null) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = dialogConfiguration?.["disableClose"] == false ? false : true;
        dialogConfig.autoFocus = dialogConfiguration["preventFirstFieldAutofocus"] ? '' : "first-tabbable";
        dialogConfig.minWidth = 400;
        dialogConfig.maxWidth = 700;
        let mergedConfig = dialogConfig;
        if (externalMatDialogConfig) {
            this.normalizeData(externalMatDialogConfig, dialogConfig);
            mergedConfig = externalMatDialogConfig;
        }
        mergedConfig.data = { ...componentsInput, dialogConfiguration };
        this.normalizeData(dialogConfiguration, {
            negativeLabel: 'ng.general.cancel',
            positiveLabel: 'ng.general.save',
            type: null,
            isPositiveButtonIsPrimary: true,
            hasSave: true
        });
        return this.dialog.open(component, mergedConfig);
    }
    static { this.ɵfac = function ExDialogService_Factory(t) { return new (t || ExDialogService)(i0.ɵɵinject(i1$7.MatDialog), i0.ɵɵinject(IUserPreferencesService, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExDialogService, factory: ExDialogService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$7.MatDialog }, { type: IUserPreferencesService, decorators: [{
                type: Optional
            }] }]; }, null); })();

const _c0$1O = ["layoutWrapper"];
const _c1$1b = ["rightSideRef"];
const _c2$P = ["expandButtonRef"];
const _c3$F = ["paginationRef"];
const _c4$v = ["endOfList"];
const _c5$p = ["itemsLayout"];
const _c6$n = ["detailsComponentLoader"];
const _c7$j = function () { return []; };
function ExItemsLayoutComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 13)(2, "ex-list-header", 14);
    i0.ɵɵlistener("comboboxItemClicked", function ExItemsLayoutComponent_div_3_Template_ex_list_header_comboboxItemClicked_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onComboboxItemClicked($event)); })("sortChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_sortChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onSortChange($event)); })("actionClicked", function ExItemsLayoutComponent_div_3_Template_ex_list_header_actionClicked_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onActionClicked($event)); })("searchChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_searchChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onSearchChange($event)); })("selectedValueChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_selectedValueChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onSelectedSearchFieldChange($event)); })("clearCheckedItems", function ExItemsLayoutComponent_div_3_Template_ex_list_header_clearCheckedItems_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onClearCheckedItems()); })("clearPageCheckedItems", function ExItemsLayoutComponent_div_3_Template_ex_list_header_clearPageCheckedItems_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.onClearPageCheckedItems()); })("checkAllItems", function ExItemsLayoutComponent_div_3_Template_ex_list_header_checkAllItems_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.onCheckAllItems()); })("filterChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_filterChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.onFilterChanged($event)); })("datesUpdated", function ExItemsLayoutComponent_div_3_Template_ex_list_header_datesUpdated_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.onDatesUpdated($event)); })("clearDates", function ExItemsLayoutComponent_div_3_Template_ex_list_header_clearDates_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onClearDates()); })("customizationClicked", function ExItemsLayoutComponent_div_3_Template_ex_list_header_customizationClicked_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onCustomizationClicked()); })("refreshClicked", function ExItemsLayoutComponent_div_3_Template_ex_list_header_refreshClicked_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.onRefreshClicked()); })("toggleisItemOpen", function ExItemsLayoutComponent_div_3_Template_ex_list_header_toggleisItemOpen_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.toggleisItemOpen()); })("closeRightSideClicked", function ExItemsLayoutComponent_div_3_Template_ex_list_header_closeRightSideClicked_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.onCloseRightSideClicked()); })("viewModeChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_viewModeChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.onViewModeChange($event)); })("openUserResponsiveMenu", function ExItemsLayoutComponent_div_3_Template_ex_list_header_openUserResponsiveMenu_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.openUserResponsiveMenu.emit()); })("itemsLayoutTypeToggled", function ExItemsLayoutComponent_div_3_Template_ex_list_header_itemsLayoutTypeToggled_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.onLayoutTypeToggled($event)); })("gallerySliderChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_gallerySliderChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.gallerySlider = $event); })("gallerySliderChange", function ExItemsLayoutComponent_div_3_Template_ex_list_header_gallerySliderChange_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.gallerySliderChange.emit($event)); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵprojection(5, 0, ["header-slot-1", ""]);
    i0.ɵɵprojection(6, 1, ["header-slot-2", ""]);
    i0.ɵɵprojection(7, 2, ["header-slot-3", ""]);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@expanded-header", !ctx_r1._hideHeader || ctx_r1.getIsFullPage() && ctx_r1.getIsItemOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("responsivenessActive", true)("isWideScreen", ctx_r1.isWideScreen)("hasRecordCustomization", ctx_r1.hasRecordCustomization)("headerResponsivenessOrderConfig", ctx_r1.listProperties.headerResponsivenessOrderConfig)("selectedOnCurrentPage", i0.ɵɵpipeBind1(3, 49, ctx_r1.checkedOnCurrentPage$))("hasToggle", !!ctx_r1.itemDetails)("hasExport", ctx_r1.listProperties.hasExport && !ctx_r1.listProperties.inExSidepanePickup)("hasSearch", ctx_r1.listProperties.hasSearch)("responsive", ctx_r1.responsive)("popUpActions", ctx_r1.listProperties.popUpActions)("numberOfCheckedItems", ctx_r1.checkedItems.length)("pageSize", i0.ɵɵpipeBind1(4, 51, ctx_r1.numCurrentItems$))("isItemOpen", ctx_r1.getIsItemOpen())("searchByFields", ctx_r1.listProperties.searchByFields)("searchBySelectedField", ctx_r1.listProperties.searchBySelectedField)("sorts", ctx_r1.listProperties.showSortsInListHeader ? ctx_r1.listProperties.sorts : i0.ɵɵpureFunction0(53, _c7$j))("filters", ctx_r1.listProperties.filters)("hasPickup", ctx_r1.listProperties.hasPickup)("galleryLayoutEnabled", ctx_r1.listProperties.galleryLayoutEnabled)("hasPickupCount", ctx_r1.listProperties.hasPickupCount && ctx_r1.listProperties.isMultiSelect)("comboboxLists", ctx_r1.listProperties.comboboxLists)("actions", ctx_r1.listProperties.actions)("bulkActions", ctx_r1.listProperties.bulkActions)("hasBottomBorder", !ctx_r1.listProperties.hideHeaderOnScroll || !ctx_r1.items || (ctx_r1.items == null ? null : ctx_r1.items.length) === 0)("filterMaxDate", ctx_r1.listProperties.filterMaxDate)("filterMinDate", ctx_r1.listProperties.filterMinDate)("showDateFilter", ctx_r1.listProperties.showDateFilter)("searchText", ctx_r1.listProperties.searchText)("clearAllSubject", ctx_r1.clearAllSubject)("hasCustomization", ctx_r1.hasCustomization && ctx_r1.listProperties.enableCustomization)("customizationComponent", ctx_r1.customizationComponent)("isCustomized", ctx_r1.isCustomized)("isLoading", ctx_r1.listProperties.isLoading)("needToRefresh", ctx_r1.listProperties.needToRefresh)("hasRefreshButton", ctx_r1.listProperties.hasRefreshButton)("deepLinkMode", ctx_r1.listProperties.deepLinkMode)("deepLinkModeTemplate", ctx_r1.deepLinkModeTemplate)("viewMode", ctx_r1.getViewMode())("fullPage", ctx_r1.getIsItemOpen() && ctx_r1.getIsFullPage())("showToggle", ctx_r1.listProperties.showToggle)("showItemsLayoutTypeToggle", ctx_r1.gridLayoutEnabled)("itemsLayoutType", ctx_r1.type)("fullPageTitle", (ctx_r1.selectedItemObject == null ? null : ctx_r1.selectedItemObject.listItem == null ? null : ctx_r1.selectedItemObject.listItem.__proto__ == null ? null : ctx_r1.selectedItemObject.listItem.__proto__.fullPageTitle) && ctx_r1.selectedItemObject.listItem[ctx_r1.selectedItemObject.listItem.__proto__.fullPageTitle.key])("fullPageTitleIcon", (ctx_r1.selectedItemObject == null ? null : ctx_r1.selectedItemObject.listItem == null ? null : ctx_r1.selectedItemObject.listItem.__proto__ == null ? null : ctx_r1.selectedItemObject.listItem.__proto__.fullPageTitleIcon) && ctx_r1.selectedItemObject.listItem[ctx_r1.selectedItemObject.listItem.__proto__.fullPageTitleIcon.key])("floatingExport", ctx_r1.newExport)("exportEnabled", ctx_r1.exportEnabled)("hasMinimizedSearch", ctx_r1.hasMinimizedSearch)("gallerySlider", ctx_r1.gallerySlider);
} }
function ExItemsLayoutComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 17);
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r36.noResultsTemplate);
} }
function ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r40.noResultsPlaceholder), " ");
} }
function ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 3, "list-layout.no_results_your_search"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r42.getSearchText());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "list-layout.no_results_did_not_match"), " ");
} }
function ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 21);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_ng_container_1_Template, 3, 3, "ng-container", 3);
    i0.ɵɵtemplate(2, ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_ng_template_2_Template, 6, 7, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r41 = i0.ɵɵreference(3);
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.noResultsPlaceholder)("ngIfElse", _r41);
} }
function ExItemsLayoutComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "img", 19);
    i0.ɵɵtemplate(2, ExItemsLayoutComponent_ng_container_4_ng_template_2_p_2_Template, 4, 2, "p", 20);
    i0.ɵɵelementStart(3, "p", 21);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("max-height", 200, "px")("width", 200, "px");
    i0.ɵɵproperty("src", (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.searchText) || (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.persistentSearchIsAdvanced) ? "/ng/assets/svg-icons/no-search-results.svg" : "/ng/assets/svg-icons/no-items-in-list.svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.searchText) || (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.persistentSearchIsAdvanced));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx_r38.noResultsHintPlaceholder ? ctx_r38.noResultsHintPlaceholder : !(ctx_r38.listProperties == null ? null : ctx_r38.listProperties.persistentSearchType) && (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.searchText) || (ctx_r38.listProperties == null ? null : ctx_r38.listProperties.persistentSearchIsAdvanced) ? "list-layout.no_results_change_filters_hint_placeholder" : "list-layout.no_results_no_items"), " ");
} }
function ExItemsLayoutComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_container_4_ng_container_1_Template, 1, 1, "ng-container", 15);
    i0.ɵɵtemplate(2, ExItemsLayoutComponent_ng_container_4_ng_template_2_Template, 6, 9, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.noResultsTemplate != null)("ngIfElse", _r37);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34, 35);
    i0.ɵɵlistener("focusout", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template_button_focusout_0_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(!ctx_r50.getIsFullPage() && !ctx_r50.listProperties.deepLinkMode ? ctx_r50.moveFocusToRightSide($event) : null); })("click", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r52.onExpandButtonToggle(!ctx_r52.getIsFullPage())); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-icon", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", ctx_r48.getIsFullPage() ? i0.ɵɵpipeBind1(4, 6, "ng.general.return-to-split-view") : i0.ɵɵpipeBind1(5, 8, "ng.general.open-full-page"));
    i0.ɵɵattribute("aria-label", ctx_r48.getIsFullPage() ? i0.ɵɵpipeBind1(2, 2, "ng.general.return-to-split-view") : i0.ɵɵpipeBind1(3, 4, "ng.general.open-full-page"));
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template, 7, 10, "button", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ex-items-layout-expand-collapse-wrapper-rotate", ctx_r46.isRtl && !ctx_r46.getIsFullPage() || !ctx_r46.isRtl && ctx_r46.getIsFullPage());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r46.viewMode == "SPLIT" || ctx_r46.viewMode == undefined);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("focus", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_1_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r61.onItemDetailsStartFocused()); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-item-details-header", 45);
    i0.ɵɵlistener("prevClicked", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template_ex_item_details_header_prevClicked_0_listener() { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r63.onPreviousClicked()); })("nextClicked", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template_ex_item_details_header_nextClicked_0_listener() { i0.ɵɵrestoreView(_r64); const ctx_r65 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r65.onNextClicked()); })("closeClicked", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template_ex_item_details_header_closeClicked_0_listener() { i0.ɵɵrestoreView(_r64); const ctx_r66 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r66.onRightSideDetailesCloseClicked()); })("actionClicked", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template_ex_item_details_header_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r64); const ctx_r67 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r67.onRecordActionClicked($event, ctx_r67._selectedItemObject)); })("editAllClicked", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template_ex_item_details_header_editAllClicked_0_listener() { i0.ɵɵrestoreView(_r64); const ctx_r68 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r68.onEditAllClicked()); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("itemId", ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.id)("actions", (ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.disabled) ? null : ctx_r56.getRightSideActions())("headerMenus", (ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.disabled) ? null : ctx_r56.getRightSideHeaderMenus())("status", (ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.disabled) ? null : ctx_r56.getRightSideStatus())("hasPrev", i0.ɵɵpipeBind1(1, 13, ctx_r56.hasPreviousItem$))("hasNext", i0.ɵɵpipeBind1(2, 15, ctx_r56.hasNextItem$))("hasTitle", ctx_r56.listProperties.hasTitle)("hasSectionsCombobox", ctx_r56.listProperties.hasSectionsCombobox)("deepLinkMode", ctx_r56.listProperties.deepLinkMode)("singleSaveDisabled", ctx_r56.singleSaveDisabled)("isEditable", (ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.listItem == null ? null : ctx_r56._selectedItemObject.listItem[ctx_r56._selectedItemObject == null ? null : ctx_r56._selectedItemObject.listItem == null ? null : ctx_r56._selectedItemObject.listItem.__proto__.editableKey]) != false)("layoutLoading", ctx_r56.listProperties.isLoading)("expandActionsOnAllSpace", ctx_r56.expandActionsOnAllSpaceFlag && ctx_r56.listProperties.expandActionsOnAllSpace);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c8$h = function (a0, a1, a2) { return { data: a0, disabled: a1, editable: a2 }; };
const _c9$d = function () { return {}; };
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 50, 51);
} if (rf & 2) {
    const currentSelectedItem_r73 = ctx.currentSelectedItem;
    const ctx_r72 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("data", i0.ɵɵpureFunction3(3, _c8$h, currentSelectedItem_r73 == null ? null : currentSelectedItem_r73.data, ctx_r72.selectedSublistItem ? false : ctx_r72._selectedItemObject.disabled, currentSelectedItem_r73[currentSelectedItem_r73.__proto__.editableKey]))("events", ctx_r72.selectedSublistItem ? i0.ɵɵpureFunction0(7, _c9$d) : ctx_r72.itemDetails.events)("componentFactoryItem", ctx_r72.selectedSublistItem ? ctx_r72.selectedSublistItemDetails : ctx_r72.itemDetails);
} }
const _c10$a = function (a0) { return { currentSelectedItem: a0 }; };
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 47);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 29);
    i0.ɵɵtemplate(2, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_ng_template_2_Template, 2, 8, "ng-template", 48, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r71 = i0.ɵɵreference(3);
    i0.ɵɵnextContext(2);
    const _r55 = i0.ɵɵreference(5);
    const ctx_r69 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r55);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r71)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c10$a, ctx_r69.selectedSublistItem ? ctx_r69.selectedSublistItem : ctx_r69._selectedItemObject == null ? null : ctx_r69._selectedItemObject.listItem));
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_ng_container_1_Template, 4, 5, "ng-container", 46);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.selectedSublistItem && ctx_r57.selectedSublistItemDetails || !ctx_r57.selectedSublistItem && ctx_r57._selectedItemObject);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c11$8 = function (a0, a1) { return { "isLoading": a0, "noneSelected": a1 }; };
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_7_ng_container_0_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelement(1, "ex-component-loader", 52);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r55 = i0.ɵɵreference(5);
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r55);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", i0.ɵɵpureFunction2(3, _c11$8, ctx_r59.listProperties.isLoading, !ctx_r59._selectedItemObject))("componentFactoryItem", ctx_r59.itemDetails);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 53);
    i0.ɵɵlistener("focus", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_9_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r76.onItemDetailsEndFocused()); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_1_Template, 1, 0, "button", 38);
    i0.ɵɵelementStart(2, "div", 39, 40);
    i0.ɵɵtemplate(4, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_4_Template, 3, 17, "ng-template", null, 41, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_6_Template, 2, 1, "ng-container", 3);
    i0.ɵɵtemplate(7, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_7_Template, 2, 6, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(9, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_button_9_Template, 1, 0, "button", 43);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r58 = i0.ɵɵreference(8);
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("resizeCB", ctx_r47.onRightSideResizedCB);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r47.getIsFullPage() && !ctx_r47.listProperties.deepLinkMode);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-in-place-layout-right-wrapper-full-page", ctx_r47.isFullPage);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r47.listProperties.isLoading && ctx_r47._selectedItemObject)("ngIfElse", _r58);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r47.getIsFullPage() && !ctx_r47.listProperties.deepLinkMode);
} }
function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-side-by-side", 26);
    i0.ɵɵlistener("rightSideHeightChange", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_rightSideHeightChange_0_listener($event) { i0.ɵɵrestoreView(_r79); const ctx_r78 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r78.rightSideHeightChange($event)); })("leftSideResized", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_leftSideResized_0_listener($event) { i0.ɵɵrestoreView(_r79); const ctx_r80 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r80.onLeftSideResized($event)); })("gutterDragEnd", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_gutterDragEnd_0_listener($event) { i0.ɵɵrestoreView(_r79); const ctx_r81 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r81.gutterDragEnd.emit($event)); });
    i0.ɵɵelementStart(1, "div", 27, 28);
    i0.ɵɵlistener("scroll", function ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template_div_scroll_1_listener($event) { i0.ɵɵrestoreView(_r79); const ctx_r82 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r82.onScrollLeftSide($event)); });
    i0.ɵɵtemplate(3, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_ng_container_3_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_Template, 2, 3, "div", 30);
    i0.ɵɵtemplate(5, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template, 10, 7, "div", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(9);
    const _r11 = i0.ɵɵreference(15);
    const _r7 = i0.ɵɵreference(11);
    const _r9 = i0.ɵɵreference(13);
    i0.ɵɵproperty("leftVisible", !ctx_r43.getIsFullPage() || ctx_r43.getIsFullPage() && !ctx_r43.getIsItemOpen())("rightVisible", ctx_r43.getIsItemOpen())("leftSize", ctx_r43.listProperties.leftSide)("rightSize", ctx_r43.listProperties.rightSide)("leftMinSize", 35)("rightMinSize", 40)("isRtl", ctx_r43.isRtl);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-items-layout-left-open", ctx_r43.getIsItemOpen() && ctx_r43.type !== "tree");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", !ctx_r43.type || ctx_r43.type == "list" ? _r5 : ctx_r43.type == "grid" ? _r11 : ctx_r43.type == "gallery" ? _r7 : _r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.getIsItemOpen() && (ctx_r43.isWideScreen || !ctx_r43.responsive) && !ctx_r43.listProperties.deepLinkMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.getIsItemOpen());
} }
const _c12$6 = function (a0, a1) { return { "ex-items-layout-content-top-border": a0, "ex-items-layout-content-wrapper-no-header": a1 }; };
function ExItemsLayoutComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, ExItemsLayoutComponent_ng_template_5_ex_side_by_side_1_Template, 6, 12, "ex-side-by-side", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(9);
    const _r11 = i0.ɵɵreference(15);
    const _r7 = i0.ɵɵreference(11);
    const _r9 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c12$6, ctx_r4.listProperties.hideHeaderOnScroll, ctx_r4.listProperties.hideHeader));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.itemDetails)("ngIfElse", !ctx_r4.type || ctx_r4.type == "list" ? _r5 : ctx_r4.type == "grid" ? _r11 : ctx_r4.type == "gallery" ? _r7 : _r9);
} }
function ExItemsLayoutComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-items-layout-list", 54, 55);
    i0.ɵɵlistener("resizeEvent", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_resizeEvent_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r84 = i0.ɵɵnextContext(); return i0.ɵɵresetView(!ctx_r84.itemDetails && ctx_r84.onLeftSideResized($event)); })("selectedItemChange", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_selectedItemChange_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r86 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r86.onSelectedItemChange($event)); })("itemSelected", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_itemSelected_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r87 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r87.onItemSelected($event)); })("itemDeselected", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_itemDeselected_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r88 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r88.onItemDeselected($event)); })("itemClicked", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_itemClicked_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r89 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r89.onItemClicked($event)); })("sublistOpened", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_sublistOpened_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r90 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r90.onSublistOpened($event)); })("selectedSublistItemChanged", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_selectedSublistItemChanged_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r91 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r91.onSelectedSublistItemChanged($event)); })("loadMoreSublist", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_loadMoreSublist_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r92 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r92.onLoadMoreSublist($event)); })("itemActionClicked", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_itemActionClicked_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r93 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r93.onRecordActionClicked($event.key, $event.item)); })("itemCheckboxChanged", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_itemCheckboxChanged_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r94 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r94.onItemCheckboxChanged($event)); })("checkedItemsChanged", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_checkedItemsChanged_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r95 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r95.onCheckedItemsChanged($event)); })("selectedPageChange", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r96 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r96.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r97 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r97.pageSizeChange.emit($event)); })("endOfPagination", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r85); const ctx_r98 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r98.focusOnEndOfPage()); })("rowDraggedDropped", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_rowDraggedDropped_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r99 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r99.onRowDraggedDropped($event)); })("tabOutFromItemEnd", function ExItemsLayoutComponent_ng_template_8_Template_ex_items_layout_list_tabOutFromItemEnd_0_listener($event) { i0.ɵɵrestoreView(_r85); const ctx_r100 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r100.moveFocusToExpandButton($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listProperties", ctx_r6.listProperties)("items", ctx_r6.items)("selectedItem", ctx_r6._selectedItemObject)("listParametersItemIdUpdatedObservable", ctx_r6.listParametersItemIdUpdatedObservable)("checkedItems", ctx_r6.checkedItems)("readyToLoad", ctx_r6.canSplitChecked || !ctx_r6.responsive)("leftSideWidth", ctx_r6.leftSideWidth)("hasItemDetailsComponent", !!ctx_r6.itemDetails)("isItemOpen", ctx_r6.listProperties.deepLinkMode || ctx_r6.getIsItemOpen())("htmlId", ctx_r6.htmlId)("pageCustomizationData", ctx_r6.pageCustomizationData)("showThumbnail", ctx_r6.showThumbnail);
} }
function ExItemsLayoutComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-items-layout-gallery", 56, 55);
    i0.ɵɵlistener("resizeEvent", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_resizeEvent_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r102 = i0.ɵɵnextContext(); return i0.ɵɵresetView(!ctx_r102.itemDetails && ctx_r102.onLeftSideResized($event)); })("selectedItemChange", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_selectedItemChange_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r104 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r104.onSelectedItemChange($event)); })("itemSelected", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_itemSelected_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r105 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r105.onItemSelected($event)); })("itemDeselected", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_itemDeselected_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r106 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r106.onItemDeselected($event)); })("itemClicked", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_itemClicked_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r107 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r107.onItemClicked($event)); })("sublistOpened", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_sublistOpened_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r108 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r108.onSublistOpened($event)); })("selectedSublistItemChanged", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_selectedSublistItemChanged_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r109 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r109.onSelectedSublistItemChanged($event)); })("loadMoreSublist", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_loadMoreSublist_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r110 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r110.onLoadMoreSublist($event)); })("itemActionClicked", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_itemActionClicked_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r111 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r111.onRecordActionClicked($event.key, $event.item)); })("itemCheckboxChanged", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_itemCheckboxChanged_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r112 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r112.onItemCheckboxChanged($event)); })("checkedItemsChanged", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_checkedItemsChanged_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r113 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r113.onCheckedItemsChanged($event)); })("selectedPageChange", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r114 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r114.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r115 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r115.pageSizeChange.emit($event)); })("endOfPagination", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r103); const ctx_r116 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r116.focusOnEndOfPage()); })("rowDraggedDropped", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_rowDraggedDropped_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r117 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r117.onRowDraggedDropped($event)); })("tabOutFromItemEnd", function ExItemsLayoutComponent_ng_template_10_Template_ex_items_layout_gallery_tabOutFromItemEnd_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r118 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r118.moveFocusToExpandButton($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listProperties", ctx_r8.listProperties)("items", ctx_r8.items)("selectedItem", ctx_r8._selectedItemObject)("listParametersItemIdUpdatedObservable", ctx_r8.listParametersItemIdUpdatedObservable)("checkedItems", ctx_r8.checkedItems)("readyToLoad", ctx_r8.canSplitChecked || !ctx_r8.responsive)("leftSideWidth", ctx_r8.leftSideWidth)("hasItemDetailsComponent", !!ctx_r8.itemDetails)("isItemOpen", ctx_r8.listProperties.deepLinkMode || ctx_r8.getIsItemOpen())("htmlId", ctx_r8.htmlId)("pageCustomizationData", ctx_r8.pageCustomizationData)("showThumbnail", ctx_r8.showThumbnail)("gallerySlider", ctx_r8.gallerySlider);
} }
function ExItemsLayoutComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-items-layout-tree", 57, 55);
    i0.ɵɵlistener("selectedItemChange", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_selectedItemChange_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r120 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r120.onSelectedItemChange($event)); })("itemSelected", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemSelected_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r122 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r122.onItemSelected($event)); })("itemDeselected", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemDeselected_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r123 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r123.onItemDeselected($event)); })("itemClicked", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemClicked_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r124 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r124.onItemClicked($event)); })("itemActionClicked", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemActionClicked_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r125 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r125.onRecordActionClicked($event.key, $event.item)); })("itemsMoved", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemsMoved_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r126 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r126.onItemsMoved($event)); })("nodeToggled", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_nodeToggled_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r127 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r127.onNodeToggled($event)); })("itemCheckboxChanged", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_itemCheckboxChanged_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r128 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r128.onItemCheckboxChanged($event)); })("checkedItemsChanged", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_checkedItemsChanged_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r129 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r129.onCheckedItemsChanged($event)); })("selectedPageChange", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r130 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r130.onSelectedPageChange($event)); })("resizeEvent", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_resizeEvent_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r131 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r131.onLeftSideResized($event)); })("tabOutFromItemEnd", function ExItemsLayoutComponent_ng_template_12_Template_ex_items_layout_tree_tabOutFromItemEnd_0_listener($event) { i0.ɵɵrestoreView(_r121); const ctx_r132 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r132.moveFocusToExpandButton($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listProperties", ctx_r10.listProperties)("items", ctx_r10.items)("selectedItem", ctx_r10._selectedItemObject)("listParametersItemIdUpdatedObservable", ctx_r10.listParametersItemIdUpdatedObservable)("checkedItems", ctx_r10.checkedItems)("readyToLoad", ctx_r10.canSplitChecked || !ctx_r10.responsive)("onLoadExpandToLevel", ctx_r10.treeOnLoadExpandToLevel)("isItemOpen", ctx_r10.listProperties.deepLinkMode || ctx_r10.getIsItemOpen())("nodeContentTemplate", ctx_r10.treeNodeTemplate);
} }
function ExItemsLayoutComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-items-layout-grid", 58, 55);
    i0.ɵɵlistener("selectedItemChange", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_selectedItemChange_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r134 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r134.onSelectedItemChange($event)); })("itemSelected", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_itemSelected_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r136 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r136.onItemSelected($event)); })("itemDeselected", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_itemDeselected_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r137 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r137.onItemDeselected($event)); })("itemClicked", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_itemClicked_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r138 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r138.onItemClicked($event)); })("itemActionClicked", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_itemActionClicked_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r139 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r139.onRecordActionClicked($event.key, $event.item)); })("itemCheckboxChanged", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_itemCheckboxChanged_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r140 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r140.onItemCheckboxChanged($event)); })("checkedItemsChanged", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_checkedItemsChanged_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r141 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r141.onCheckedItemsChanged($event)); })("selectedPageChange", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r142 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r142.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r143 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r143.pageSizeChange.emit($event)); })("endOfPagination", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r135); const ctx_r144 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r144.focusOnEndOfPage()); })("resizeEvent", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_resizeEvent_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r145 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r145.onLeftSideResized($event)); })("rowDraggedDropped", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_rowDraggedDropped_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r146 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r146.onRowDraggedDropped($event)); })("tabOutFromItemEnd", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_tabOutFromItemEnd_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r147 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r147.moveFocusToExpandButton($event)); })("columnHeaderSortChange", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_columnHeaderSortChange_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r148 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r148.onSortChange($event)); })("layoutCustomized", function ExItemsLayoutComponent_ng_template_14_Template_ex_items_layout_grid_layoutCustomized_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r149 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r149.layoutCustomized.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listProperties", ctx_r12.listProperties)("items", ctx_r12.items)("selectedItem", ctx_r12._selectedItemObject)("listParametersItemIdUpdatedObservable", ctx_r12.listParametersItemIdUpdatedObservable)("checkedItems", ctx_r12.checkedItems)("readyToLoad", ctx_r12.canSplitChecked || !ctx_r12.responsive)("leftSideWidth", ctx_r12.leftSideWidth)("hasItemDetailsComponent", !!ctx_r12.itemDetails)("isItemOpen", ctx_r12.listProperties.deepLinkMode || ctx_r12.getIsItemOpen())("htmlId", ctx_r12.htmlId)("pageCustomizationData", ctx_r12.pageCustomizationData);
} }
const _c13$6 = [[["", "header", ""]], [["", "header-slot-2", ""]], [["", "header-slot-3", ""]]];
const _c14$6 = function (a0) { return { "ex-items-layout-animate sel-loading": a0 }; };
const _c15$6 = ["[header]", "[header-slot-2]", "[header-slot-3]"];
const SIDE_BY_SIDE_SIZES = {
    'large': { right: 40, left: 60 },
    'medium': { right: 50, left: 50 },
    'small': { right: 70, left: 30 }
};
const LAYOUT_WRAPPER_GET_BOUNDS = new InjectionToken('LAYOUT_WRAPPER_GET_BOUNDS');
const IS_SINGLE_SAVE = new InjectionToken('IS_SINGLE_SAVE');
const LAYOUT_UPDATING_PRIMARY_ENTITY = new InjectionToken('LAYOUT_UPDATING_PRIMARY_ENTITY');
class ExItemsLayoutComponent extends GeneralListLayoutComponent {
    /**
     * The selected item
     */
    set selectedItemObject(item) {
        if (this._selectedItemObject === item)
            return;
        this._selectedItemObject = item;
        if (this.sideBySide) {
            this.sideBySide.scrollRightSideToTop();
        }
        if (this.detailsComponentLoader) {
            // force the component loader re-create the details component
            this.detailsComponentLoader?.reCreateComponentOnNextChange();
            this.itemDetails = { ...this.itemDetails };
        }
    }
    get selectedItemObject() {
        return this._selectedItemObject;
    }
    /**
     * The items that are checked (including items that are not currently loaded)
     */
    set checkedItems(value) {
        this._checkedItems = value;
        this.checkedItemsChange.emit(value);
    }
    ;
    get checkedItems() {
        return this._checkedItems;
    }
    ;
    get responsive() {
        return this._responsive;
    }
    set responsive(value) {
        if (value && !this._responsive) {
            this.initResponsiveness();
        }
        this._responsive = value;
    }
    getIsFullPage() {
        return this.isFullPage || this.viewMode == ViewModes.FULL || this.isExpanded || this.listProperties.deepLinkMode;
    }
    constructor(location, exSectionsLayoutListLayoutService, router, sidenavPageService, itemsLayoutService, sectionsLayoutService, dialogService, elRef) {
        super();
        this.location = location;
        this.exSectionsLayoutListLayoutService = exSectionsLayoutListLayoutService;
        this.router = router;
        this.sidenavPageService = sidenavPageService;
        this.itemsLayoutService = itemsLayoutService;
        this.sectionsLayoutService = sectionsLayoutService;
        this.dialogService = dialogService;
        this.elRef = elRef;
        /**
         * Whether the layout is customizable (customize icon will be displayed in the header)
         */
        this.hasCustomization = false;
        this.hasRecordCustomization = false;
        /**
         * Whether the layout is customized
         */
        this.isCustomized = false;
        /**
         * whether the list layout is responsive to the window width (depends on existing in ex-sidenav-page)
         */
        this._responsive = true;
        /**
         * The level up to which the items tree will be expanded upon loading
         */
        this.treeOnLoadExpandToLevel = 0;
        /**
         *whether the list is the main element of the layout (standalone list) or is it a secondary element in the layout.
         *usecase for isStandaloneList= false: The QB test results.
         */
        this.isStandaloneList = true;
        this.customizationClicked = new EventEmitter();
        /**
         * Fires when the user stops dragging the gutter (mouseup)
         */
        this.gutterDragEnd = new EventEmitter();
        /**
         * Fires when user clicks on help link to disable responsiveness
         */
        this.openUserResponsiveMenu = new EventEmitter();
        /**
         * Fires when the layout state changes in the component
         */
        this.layoutStateChanged = new EventEmitter();
        /**
         * emits when the layout is customized from within the layout (e.g. user changes grid columns width)
         */
        this.layoutCustomized = new EventEmitter();
        /**
         * disable single save save action
         */
        this.singleSaveDisabled = false;
        this.showThumbnail = true;
        this.expandActionsOnAllSpaceFlag = false;
        this.gridLayoutEnabled = false;
        this.isSecondarySearchFlagActive = false;
        this.persistentSearchText = '';
        this.isFullPage = false;
        this._suppressedIconName = "visibility-off";
        this.leftSideWidth = 0;
        this.timeout = null;
        this._hideHeader = false;
        this.pageHeaderDisplayStyle = 'flex';
        this._ignoreScroll = false;
        this.canSplitChecked = false;
        this.closeFullPageAfterClose = false;
        this._checkedItems = [];
        this.subs = [];
        // changeCounter, in order to send event at the first time it is opened.
        this._changeCounter = 0;
        this.onLeftSideResized = throttle((event) => {
            this.leftSideWidth = event.newRect.width;
            this.itemsLayoutService.setListBreakpoint(this.leftSideWidth);
            this.leftSideWitdhChanged.emit(this.leftSideWidth);
        }, 200);
        this.onRightSideResized = throttle((event) => {
            this.rightSideWitdhChanged.emit(event.newRect.width);
        }, 50);
        this.onRightSideResizedCB = this.onRightSideResized.bind(this);
    }
    getCheckedItems() {
        return this.checkedItems;
    }
    clearCheckedItems() {
        this.checkedItems = [];
    }
    ngAfterViewInit() {
        this.itemsLayoutService.setLayoutWrapper(this.layoutWrapper);
        this.showOrHideColumnMainHeader();
    }
    ngOnInit() {
        if (this.sidenavPageService == null)
            this.canSplitChecked = true;
        if (this.viewMode == ViewModes.SPLIT && this.isItemOpen && !this.isExpanded) {
            this.switchToSideBySideInWideScreens();
        }
        if (this.viewMode == ViewModes.FULL || this.isExpanded) {
            this.isFullPage = true;
            this.fullPageModeChange.emit(true);
        }
        this.initResponsiveness();
        this.initSubscriptions();
    }
    switchToSideBySideInWideScreens() {
        if (this.responsive && !this.listProperties.deepLinkMode && this.viewMode == ViewModes.FULL) {
            this.sidenavPageService?.contentWidthChecked.pipe(filter(value => value), switchMap(() => this.sidenavPageService?.contentWide), first()).subscribe(isWide => isWide && this.openSidebySide());
        }
        else {
            this.openSidebySide();
        }
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('itemDetails')) {
            const details = changes.itemDetails;
            const { previousValue, currentValue } = details;
            if ((currentValue && previousValue !== currentValue) && (this.viewMode == ViewModes.SPLIT && this.isItemOpen && !this.isExpanded)) {
                this.switchToSideBySideInWideScreens();
            }
        }
        if (changes.hasOwnProperty('listProperties')) {
            if ((changes.listProperties.previousValue != undefined) && (changes.listProperties.currentValue['deepLinkMode'] !== changes.listProperties.previousValue['deepLinkMode'])) {
                this.showOrHideColumnMainHeader();
            }
        }
    }
    ngOnDestroy() {
        this.subs.forEach(sub => sub?.unsubscribe());
    }
    setIsItemOpen(value) {
        if (!this.isItemOpen) {
            this.isExpanded = false;
        }
        this.showOrHideColumnMainHeader();
        this.isItemOpenChange.emit(this.isItemOpen);
        if (this.isItemOpen && !this.selectedItemObject) {
            this.itemsLayout?.selectNextItem();
        }
        if (this.viewMode == ViewModes.FULL || this.isExpanded) {
            if (!value && !this.isExpanded) {
                this.itemsLayoutService.notifyItemDetailsClosed();
                this.itemsLayoutService.fireLastBreakpoint(false);
            }
        }
        value && this.onFullPageModeChange(this.viewMode === ViewModes.FULL);
    }
    setViewMode(value) {
        this.onFullPageModeChange(value === ViewModes.FULL);
    }
    getIsItemOpen() {
        return this.listProperties.deepLinkMode || this.isItemOpen;
    }
    getViewMode() {
        if (this.listProperties.deepLinkMode) {
            return ViewModes.FULL;
        }
        return this.viewMode;
    }
    initResponsiveness() {
        this.subs.push(this.sidenavPageService?.contentWide.subscribe(isWide => {
            this.isWideScreen = isWide;
            if (this.responsive) {
                if (this.listProperties.deepLinkMode || this.viewMode == ViewModes.FULL) {
                    return;
                }
                if (isWide == true && this.viewMode == ViewModes.SPLIT) {
                    if (!this.isExpanded)
                        this.onFullPageModeChange(false);
                }
                if (isWide == false) {
                    if (!this.isExpanded) {
                        this.onFullPageModeChange(true);
                    }
                }
            }
        }));
        this.subs.push(this.sidenavPageService?.contentWidthChecked.subscribe(wasChecked => {
            this.canSplitChecked = wasChecked;
        }));
    }
    initSubscriptions() {
        this.subs.push(this.exSectionsLayoutListLayoutService.openRightSide$.subscribe(() => this.openSidebySide()));
        this.subs.push(merge(this.isItemOpenChange, this.fullPageModeChange).pipe(map$1(() => {
            return this.getLayoutState();
        })).subscribe(v => this.layoutStateChanged.emit(v)));
        this.numCurrentItems$ = this.itemsLayoutService.onNumCurrentItemsUpdated();
        this.checkedOnCurrentPage$ = this.itemsLayoutService.onNumCheckedCurrentItemsUpdated();
        this.hasNextItem$ = this.itemsLayoutService.hasNextItem();
        this.hasPreviousItem$ = this.itemsLayoutService.hasPreviousItem();
    }
    getListItemIndex(item) {
        return this.items?.findIndex(currItem => currItem.id === item.id);
    }
    onSelectedItemChange(item) {
        this.selectedItemObject = item;
        this.selectedItemObjectChange.emit(this._selectedItemObject);
    }
    onItemClicked(item) {
        event.stopPropagation();
    }
    onItemSelected(event) {
        const item = event.item ?? event;
        const preventOpen = event.preventOpen ?? false;
        if (!this.listProperties.canSelectRow) {
            return;
        }
        if (this.isItemOpen != true && !!this.itemDetails && !preventOpen) {
            this._isItemOpen = true;
            this.isItemOpenChange.emit(this.isItemOpen);
            this.itemsLayoutService.fireLastBreakpoint();
        }
        this.showOrHideColumnMainHeader();
        this.itemSelected.emit(item);
    }
    onItemDeselected(item) {
        this.closeSidebySide();
        this.showOrHideColumnMainHeader();
        this.itemDeselected.emit(item);
    }
    showOrHideColumnMainHeader() {
        if (this.isStandaloneList) {
            const elements = this.elRef.nativeElement?.closest("alma-page-column")?.getElementsByClassName("alma-page-column-main-header");
            const contentElements = this.elRef.nativeElement?.closest("alma-page-column")?.getElementsByClassName("alma-page-column-content");
            if (elements && elements.length > 0) {
                const element = elements.item(0);
                if (element.style.display !== 'none') {
                    this.pageHeaderDisplayStyle = element.style.display;
                }
                if (this.listProperties.deepLinkMode || (this.isItemOpen && this.isFullPage)) {
                    element.style.setProperty('display', 'none', 'important');
                    contentElements.item(0)?.style.setProperty('margin-top', '10px', 'important');
                }
                else {
                    element.style.setProperty('display', this.pageHeaderDisplayStyle);
                }
            }
        }
    }
    moveFocusToExpandButton(e) {
        this.expandButtonRef.nativeElement.focus();
    }
    moveFocusToRightSide(e) {
        this.rightSideRef.nativeElement.focus();
    }
    onItemDetailsStartFocused() {
        this.itemsLayoutService.notifyItemDetailsStartReached();
    }
    onItemDetailsEndFocused() {
        this.itemsLayoutService.notifyItemDetailsEndReached();
    }
    onSublistOpened(data) {
        this.isItemOpen = true;
        this.sublistClicked.emit({ listInd: this.getListItemIndex(data.item), sublistInd: data.sublistIndex });
    }
    onSelectedSublistItemChanged(data) {
        // selectedSublistItem is a UIWrapper ; ListItem.listItem is a UIWrapper
        this.selectedSublistItem = data.selectedSublistItem;
        this.selectedSublistItemDetails = data.selectedSublistItemDetails;
        if (this.selectedSublistItem) {
            if (this.detailsComponentLoader) {
                // force the component loader re-create the details component - for the selectedSublistItem
                this.detailsComponentLoader?.reCreateComponentOnNextChange();
                this.selectedSublistItemDetails = { ...this.selectedSublistItemDetails };
            }
            this.isItemOpen = true;
            this.splitViewOpen.emit(this.isItemOpen);
        }
        else { // sublist was closed
            // force the component loader re-create the details component - for the selecteItem
            this.detailsComponentLoader?.reCreateComponentOnNextChange();
            this.itemDetails = { ...this.itemDetails };
        }
    }
    onNextClicked() {
        this.itemsLayoutService.notifyNextClicked();
    }
    onPreviousClicked() {
        this.itemsLayoutService.notifyPreviousClicked();
    }
    onPopState(event) {
        if ((this.isFullPage && this.isItemOpen) && event.currentTarget !== null && !event.singleSpa) {
            this.onCloseRightSideClicked();
            event.stopPropagation();
        }
    }
    onRightSideDetailesCloseClicked() {
        if (this.isFullPage && this.isItemOpen) {
            this.location.back();
        }
        this.onCloseRightSideClicked();
    }
    onCloseRightSideClicked() {
        const toSplitMode = this.closeFullPageAfterClose;
        this.isExpanded = false;
        if (this.closeFullPageAfterClose) {
            this.onFullPageModeChange(false);
        }
        else {
            this.toggleisItemOpen();
        }
        this.closeFullPageAfterClose = false;
        this.itemsLayoutService.notifyItemDetailsClosed();
        this.itemsLayoutService.fireLastBreakpoint(toSplitMode);
    }
    toggleisItemOpen() {
        this.isItemOpen = !this.isItemOpen;
        this.showOrHideColumnMainHeader();
        this.isItemOpenChange.emit(this.isItemOpen);
        if (this.isItemOpen && !this.selectedItemObject) {
            this.itemsLayout?.selectNextItem();
        }
    }
    openSidebySide() {
        if (this.isItemOpen == true && this._changeCounter > 0) {
            return;
        }
        this._changeCounter++;
        this.isItemOpen = true;
        this.isItemOpenChange.emit(true);
        if (!this.selectedItemObject && this.items?.length > 0) {
            this.itemsLayout?.selectNextItem();
        }
    }
    closeSidebySide() {
        if (this.isItemOpen == false && this._changeCounter > 0) {
            return;
        }
        this._changeCounter++;
        this.isItemOpen = false;
        this.isItemOpenChange.emit(false);
    }
    onSortChange(sort) {
        const { order, sortBy, index } = sort;
        this.listProperties.sorts[index].order = order;
        this.listProperties.sorts[index].selectedOption = sortBy;
        this.sortChange.emit(sort);
        this.itemsReloaded();
    }
    onSelectedSearchFieldChange(value) {
        this.searchSelectedValueChange.emit(value);
    }
    onSearchChange(search) {
        this.searchChange.emit(search);
        this.itemsReloaded();
    }
    onFilterChanged(event) {
        this.filterChanged.emit(event);
        this.itemsReloaded();
    }
    onDatesUpdated(e) {
        this.datesUpdated.emit(e);
        this.itemsReloaded();
    }
    onClearDates() {
        this.clearDates.emit();
        this.itemsReloaded();
    }
    onActionClicked(value) {
        this.actionClicked.emit({ value, checkedItems: [...this.checkedItems] });
        this.itemsLayoutService.notifyActionPerformed(value, [...this.checkedItems]);
        const action = this.listProperties.actions?.find(action => action.value === value) ?? this.listProperties.bulkActions?.find(action => action.value === value);
        if (action && action.clearPickupOnAction) {
            this.checkedItems = [];
        }
    }
    onRecordActionClicked(key, listItem) {
        this.actionClicked.emit({ value: key, checkedItems: [listItem] });
        this.itemsLayoutService.notifyActionPerformed(key, [listItem]);
    }
    onLoadMoreSublist(data) {
        this.loadMoreSublist.emit({ listInd: this.getListItemIndex(data.item), sublistInd: data.sublistIndex });
    }
    onComboboxItemClicked(item) {
        this.comboboxItemClicked.emit(item);
    }
    onCheckedItemsChanged(event) {
        this.checkedItemsChange.emit(event);
    }
    onItemCheckboxChanged(event) {
        this.checkboxChanged.emit({ item: event.item, value: event.checked });
        this._hideHeader = event.checked ? false : this._hideHeader;
    }
    onClearPageCheckedItems() {
        this.itemsLayoutService.setCurrentItemsChecked(false);
    }
    onClearCheckedItems() {
        this.notifyAllCheckboxesValue(false, this.checkedItems);
        this.checkedItems = [];
    }
    onCheckAllItems() {
        this.itemsLayoutService.setCurrentItemsChecked(true);
    }
    notifyAllCheckboxesValue(value, items) {
        items.forEach(item => {
            this.checkboxChanged.emit({ item: item, value: value });
        });
    }
    getRightSideActions() {
        const data = this.selectedSublistItem ?? this.selectedItemObject?.listItem; // a UIWrapper
        if (data) {
            if (data.__proto__.actions && !data.__proto__.actions.type) {
                return data.actions;
            }
            else if (data.__proto__.actions && data.__proto__.actions.type && data.actions) {
                return {
                    type: data.__proto__.actions.type,
                    actions: data.actions
                };
            }
            return null;
        }
        else {
            return null;
        }
    }
    getRightSideHeaderMenus() {
        if (this.selectedItemObject) {
            const data = this.selectedItemObject.listItem;
            if (data.__proto__.headerMenus && data.__proto__.headerMenus.type && data.headerMenus) {
                return {
                    type: data.__proto__.headerMenus.type,
                    headerMenus: data.headerMenus
                };
            }
            return null;
        }
        return null;
    }
    getRightSideStatus() {
        if (this.selectedItemObject) {
            const data = this.selectedItemObject.listItem;
            if (data.__proto__.status && data[data.__proto__.status]) {
                return data[data.__proto__.status];
            }
            return null;
        }
        return null;
    }
    onScrollLeftSide(e) {
        let hideHeaderToggled;
        if (e.target.scrollTop === 0) {
            this._hideHeader = false;
            return;
        }
        if (this._ignoreScroll || !this.listProperties.hideHeaderOnScroll || this._checkedItems.length > 0) {
            return;
        }
        if (!this._scrollTop) {
            this._scrollTop = e.target.scrollTop;
        }
        hideHeaderToggled = this._hideHeader;
        this._hideHeader = e.target.scrollTop > this._scrollTop && e.target.scrollTop > 100;
        if (this._hideHeader !== hideHeaderToggled) {
            this._ignoreScroll = true;
            setTimeout(() => {
                this._ignoreScroll = false;
            }, 500);
        }
        this._scrollTop = e.target.scrollTop;
    }
    hasHeader() {
        const { sorts, actions, searchByFields, hasExport, filters } = this.listProperties;
        return !!(sorts?.length > 0 || actions?.length > 0 || filters?.length > 0 || searchByFields?.length > 0 || hasExport);
    }
    onRowDraggedDropped(event) {
        this.rowDragged.emit(event);
    }
    focusOnEndOfPage() {
        this.endOfList.nativeElement.focus();
    }
    onCustomizationClicked() {
        this.customizationClicked.emit(null);
    }
    openCustomizationComponent(customizationComponent) {
        this.customizationClicked.emit(customizationComponent);
    }
    onFullPageModeChange(isFullPage, changeNavigation = true, closeFullPageAfterClose = false) {
        this.closeFullPageAfterClose = closeFullPageAfterClose;
        const prevIsFullPage = this.isFullPage;
        this.isFullPage = isFullPage;
        if (isFullPage) {
            this.listProperties.hasTitle = true;
            if (this.isItemOpen) {
                if (changeNavigation && !prevIsFullPage) {
                    this.location.go(this.router.url);
                }
            }
        }
        else {
            this.listProperties.hasTitle = false;
        }
        this.showOrHideColumnMainHeader();
        this.fullPageModeChange.emit(isFullPage);
        this.exSectionsLayoutListLayoutService.isFullPageChange.next(isFullPage);
    }
    rightSideHeightChange(height) {
        this.exSectionsLayoutListLayoutService.rightSideHeightChange.next(height);
    }
    onRefreshClicked() {
        this.refreshClicked.emit();
    }
    onExpandButtonToggle(isExpanded, changeNavigation = true) {
        isExpanded && this.itemsLayoutService.setListBreakpoint(this.leftSideWidth);
        this.itemsLayoutService.fireLastBreakpoint(!isExpanded);
        this.isExpanded = isExpanded;
        if (!isExpanded) {
            this.location.back();
        }
        this.onFullPageModeChange(isExpanded, changeNavigation, isExpanded);
    }
    itemsReloaded() {
        this.itemsLayoutService.itemsReloaded();
    }
    itemsDeleted(ids) {
        this.itemsLayoutService.notifyItemsDeleted();
    }
    selectItemById(id) {
        this.itemsLayoutService.selectItemById(id);
    }
    getItemById(id) {
        return this.itemsLayout?.getItemById(id);
    }
    ;
    getFlatItemsList() {
        return this.itemsLayout?.getFlatItemsList();
    }
    onNodeToggled(event) {
    }
    onItemsMoved(event) {
        this.itemsMoved.emit(event);
    }
    onEditAllClicked() {
        //this.onFullPageModeChange(true, true, true);
    }
    onSelectedPageChange($event) {
        this.selectedPageChange.emit($event);
        this._hideHeader = false;
    }
    onViewModeChange(viewMode) {
        this.viewMode = viewMode;
        this.onFullPageModeChange(!(this.viewMode == ViewModes.SPLIT));
        this.viewModeChange.emit(this.viewMode);
    }
    getLayoutState() {
        if (!this.isItemOpen) {
            return 'close';
        }
        if (this.isItemOpen) {
            if (this.responsive && this.isWideScreen != undefined && !this.isWideScreen && this.viewMode == ViewModes.SPLIT) {
                return 'openFullModeResponsive';
            }
            if (this.viewMode == ViewModes.SPLIT) {
                if (this.isExpanded) {
                    return 'openFullModeExpanded';
                }
                return 'openSideBySide';
            }
            if (this.viewMode == ViewModes.FULL) {
                return 'openFullMode';
            }
        }
    }
    onLayoutTypeToggled(event) {
        if (event === 'gallery' && this.type !== 'gallery') {
            this.type = 'gallery';
        }
        else {
            this.type = this.type == 'list' ? 'grid' : 'list';
        }
        this.typeChange.emit(this.type);
    }
    getSearchText() {
        if (this.isSecondarySearchFlagActive && this.listProperties.persistentSearchType) {
            if (this.listProperties.persistentSearchRuleSet) {
                return '';
            }
            else {
                return this.persistentSearchText;
            }
        }
        return this.listProperties?.searchText;
    }
    static { this.ɵfac = function ExItemsLayoutComponent_Factory(t) { return new (t || ExItemsLayoutComponent)(i0.ɵɵdirectiveInject(i1$5.Location), i0.ɵɵdirectiveInject(ExSectionsLayoutListLayoutService), i0.ɵɵdirectiveInject(i3$2.Router), i0.ɵɵdirectiveInject(ExSidenavPageService, 8), i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutComponent, selectors: [["ex-items-layout"]], viewQuery: function ExItemsLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1O, 5);
            i0.ɵɵviewQuery(_c1$1b, 5);
            i0.ɵɵviewQuery(_c2$P, 5);
            i0.ɵɵviewQuery(_c3$F, 5);
            i0.ɵɵviewQuery(_c4$v, 5);
            i0.ɵɵviewQuery(ExSideBySideComponent, 5);
            i0.ɵɵviewQuery(_c5$p, 5);
            i0.ɵɵviewQuery(_c6$n, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.layoutWrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightSideRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandButtonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endOfList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sideBySide = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsLayout = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailsComponentLoader = _t.first);
        } }, hostBindings: function ExItemsLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("popstate", function ExItemsLayoutComponent_popstate_HostBindingHandler($event) { return ctx.onPopState($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { selectedItemObject: "selectedItemObject", checkedItems: "checkedItems", hasCustomization: "hasCustomization", hasRecordCustomization: "hasRecordCustomization", customizationComponent: "customizationComponent", pageCustomizationData: "pageCustomizationData", isCustomized: "isCustomized", isRtl: "isRtl", responsive: "responsive", treeOnLoadExpandToLevel: "treeOnLoadExpandToLevel", deepLinkModeTemplate: "deepLinkModeTemplate", isStandaloneList: "isStandaloneList", noResultsTemplate: "noResultsTemplate", treeNodeTemplate: "treeNodeTemplate", listParametersItemIdUpdatedObservable: "listParametersItemIdUpdatedObservable", singleSaveDisabled: "singleSaveDisabled", showThumbnail: "showThumbnail", expandActionsOnAllSpaceFlag: "expandActionsOnAllSpaceFlag", gridLayoutEnabled: "gridLayoutEnabled", isSecondarySearchFlagActive: "isSecondarySearchFlagActive", persistentSearchText: "persistentSearchText" }, outputs: { customizationClicked: "customizationClicked", gutterDragEnd: "gutterDragEnd", openUserResponsiveMenu: "openUserResponsiveMenu", layoutStateChanged: "layoutStateChanged", layoutCustomized: "layoutCustomized" }, features: [i0.ɵɵProvidersFeature([
                ExItemsLayoutService,
                { provide: GeneralListLayoutComponent, useExisting: forwardRef(() => ExItemsLayoutComponent) },
                {
                    provide: forwardRef(() => LAYOUT_WRAPPER_GET_BOUNDS),
                    useFactory: (layout) => {
                        return () => layout.itemsLayoutService.getLayoutWrapperBoundingClientRect();
                    },
                    deps: [ExItemsLayoutComponent]
                }, {
                    provide: forwardRef(() => IS_SINGLE_SAVE),
                    useFactory: (exItemsLayoutComponent) => {
                        return exItemsLayoutComponent.listProperties.isSingleSave;
                    },
                    deps: [ExItemsLayoutComponent]
                },
                {
                    provide: ExItemDetailsHeaderStatusService,
                    useFactory: (existingStatusService) => {
                        return existingStatusService ?? new ExItemDetailsHeaderStatusService();
                    },
                    deps: [[new Optional(), new SkipSelf(), ExItemDetailsHeaderStatusService]],
                }
            ]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c15$6, decls: 20, vars: 13, consts: [[1, "ex-items-layout-wrapper"], ["layoutWrapper", ""], ["class", "ex-items-layout-header-wrapper", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["results", ""], [3, "ngClass"], ["list", ""], ["gallery", ""], ["tree", ""], ["grid", ""], ["tabindex", "0", 1, "ex-items-layout-hidden-button"], ["endOfList", ""], [1, "ex-items-layout-header-wrapper"], ["headerWrapper", ""], [3, "responsivenessActive", "isWideScreen", "hasRecordCustomization", "headerResponsivenessOrderConfig", "selectedOnCurrentPage", "hasToggle", "hasExport", "hasSearch", "responsive", "popUpActions", "numberOfCheckedItems", "pageSize", "isItemOpen", "searchByFields", "searchBySelectedField", "sorts", "filters", "hasPickup", "galleryLayoutEnabled", "hasPickupCount", "comboboxLists", "actions", "bulkActions", "hasBottomBorder", "filterMaxDate", "filterMinDate", "showDateFilter", "searchText", "clearAllSubject", "hasCustomization", "customizationComponent", "isCustomized", "isLoading", "needToRefresh", "hasRefreshButton", "deepLinkMode", "deepLinkModeTemplate", "viewMode", "fullPage", "showToggle", "showItemsLayoutTypeToggle", "itemsLayoutType", "fullPageTitle", "fullPageTitleIcon", "floatingExport", "exportEnabled", "hasMinimizedSearch", "gallerySlider", "comboboxItemClicked", "sortChange", "actionClicked", "searchChange", "selectedValueChange", "clearCheckedItems", "clearPageCheckedItems", "checkAllItems", "filterChange", "datesUpdated", "clearDates", "customizationClicked", "refreshClicked", "toggleisItemOpen", "closeRightSideClicked", "viewModeChange", "openUserResponsiveMenu", "itemsLayoutTypeToggled", "gallerySliderChange"], ["role", "alert", 3, "ngTemplateOutlet", 4, "ngIf", "ngIfElse"], ["defaultNoResultsTemplate", ""], ["role", "alert", 3, "ngTemplateOutlet"], ["role", "alert", 1, "ex-items-layout-no-records-found-placeholder", "ex-items-layout-no-records-flex-and-center"], [1, "sel-no-records-icon", "ex-items-layout-no-records-icon", 3, "src"], ["class", "ex-items-layout-no-records-text sel-no-records", 4, "ngIf"], [1, "ex-items-layout-no-records-text", "sel-no-records"], ["customNoResults", ""], [1, "bold-weight"], [1, "ex-items-layout-content-wrapper", 3, "ngClass"], ["class", "ex-items-layout-side-by-side", 3, "leftVisible", "rightVisible", "leftSize", "rightSize", "leftMinSize", "rightMinSize", "isRtl", "rightSideHeightChange", "leftSideResized", "gutterDragEnd", 4, "ngIf", "ngIfElse"], [1, "ex-items-layout-side-by-side", 3, "leftVisible", "rightVisible", "leftSize", "rightSize", "leftMinSize", "rightMinSize", "isRtl", "rightSideHeightChange", "leftSideResized", "gutterDragEnd"], ["cdkScrollable", "", "slot-side-1", "", 1, "ex-items-layout-left", 3, "scroll"], ["listRef", ""], [4, "ngTemplateOutlet"], ["expand-button", "", "class", "ex-items-layout-expand-collapse-wrapper", 3, "ex-items-layout-expand-collapse-wrapper-rotate", 4, "ngIf"], ["slot-side-2", "", "class", "ex-items-layout-right ex-generic-list-side-by-side", "resized", "", 3, "resizeCB", 4, "ngIf"], ["expand-button", "", 1, "ex-items-layout-expand-collapse-wrapper"], ["tabindex", "0", "class", "ex-items-layout-expand-collapse-icon", 3, "exTooltip", "focusout", "click", 4, "ngIf"], ["tabindex", "0", 1, "ex-items-layout-expand-collapse-icon", 3, "exTooltip", "focusout", "click"], ["expandButtonRef", ""], ["iconType", "fa-font", "iconName", "fa-angle-double-left", "color", "#757575"], ["slot-side-2", "", "resized", "", 1, "ex-items-layout-right", "ex-generic-list-side-by-side", 3, "resizeCB"], ["class", "ex-items-layout-hidden-button", "aria-label", "move focus to previous\n          row", 3, "focus", 4, "ngIf"], ["tabindex", "0", "role", "region", "aria-labelledby", "selectedItemInList", 1, "ex-items-layout-right-wrapper"], ["rightSideRef", ""], ["headerTemplate", ""], ["itemDetailsPlaceHolder", ""], ["class", "ex-items-layout-hidden-button", "aria-label", "move focus to next row", 3, "focus", 4, "ngIf"], ["aria-label", "move focus to previous\n          row", 1, "ex-items-layout-hidden-button", 3, "focus"], [1, "ex-items-layout-header", 3, "itemId", "actions", "headerMenus", "status", "hasPrev", "hasNext", "hasTitle", "hasSectionsCombobox", "deepLinkMode", "singleSaveDisabled", "isEditable", "layoutLoading", "expandActionsOnAllSpace", "prevClicked", "nextClicked", "closeClicked", "actionClicked", "editAllClicked"], ["exShortcutsScope", "", 4, "ngIf"], ["exShortcutsScope", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["selectedItemDetailsTmpl", ""], [1, "ex-items-layout-content", 3, "data", "events", "componentFactoryItem"], ["detailsComponentLoader", ""], [3, "data", "componentFactoryItem"], ["aria-label", "move focus to next row", 1, "ex-items-layout-hidden-button", 3, "focus"], [3, "listProperties", "items", "selectedItem", "listParametersItemIdUpdatedObservable", "checkedItems", "readyToLoad", "leftSideWidth", "hasItemDetailsComponent", "isItemOpen", "htmlId", "pageCustomizationData", "showThumbnail", "resizeEvent", "selectedItemChange", "itemSelected", "itemDeselected", "itemClicked", "sublistOpened", "selectedSublistItemChanged", "loadMoreSublist", "itemActionClicked", "itemCheckboxChanged", "checkedItemsChanged", "selectedPageChange", "pageSizeChange", "endOfPagination", "rowDraggedDropped", "tabOutFromItemEnd"], ["itemsLayout", ""], [3, "listProperties", "items", "selectedItem", "listParametersItemIdUpdatedObservable", "checkedItems", "readyToLoad", "leftSideWidth", "hasItemDetailsComponent", "isItemOpen", "htmlId", "pageCustomizationData", "showThumbnail", "gallerySlider", "resizeEvent", "selectedItemChange", "itemSelected", "itemDeselected", "itemClicked", "sublistOpened", "selectedSublistItemChanged", "loadMoreSublist", "itemActionClicked", "itemCheckboxChanged", "checkedItemsChanged", "selectedPageChange", "pageSizeChange", "endOfPagination", "rowDraggedDropped", "tabOutFromItemEnd"], [3, "listProperties", "items", "selectedItem", "listParametersItemIdUpdatedObservable", "checkedItems", "readyToLoad", "onLoadExpandToLevel", "isItemOpen", "nodeContentTemplate", "selectedItemChange", "itemSelected", "itemDeselected", "itemClicked", "itemActionClicked", "itemsMoved", "nodeToggled", "itemCheckboxChanged", "checkedItemsChanged", "selectedPageChange", "resizeEvent", "tabOutFromItemEnd"], [3, "listProperties", "items", "selectedItem", "listParametersItemIdUpdatedObservable", "checkedItems", "readyToLoad", "leftSideWidth", "hasItemDetailsComponent", "isItemOpen", "htmlId", "pageCustomizationData", "selectedItemChange", "itemSelected", "itemDeselected", "itemClicked", "itemActionClicked", "itemCheckboxChanged", "checkedItemsChanged", "selectedPageChange", "pageSizeChange", "endOfPagination", "resizeEvent", "rowDraggedDropped", "tabOutFromItemEnd", "columnHeaderSortChange", "layoutCustomized"]], template: function ExItemsLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c13$6);
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵelementContainerStart(2);
            i0.ɵɵtemplate(3, ExItemsLayoutComponent_div_3_Template, 8, 54, "div", 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(4, ExItemsLayoutComponent_ng_container_4_Template, 4, 2, "ng-container", 3);
            i0.ɵɵtemplate(5, ExItemsLayoutComponent_ng_template_5_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelement(7, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ExItemsLayoutComponent_ng_template_8_Template, 2, 12, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(10, ExItemsLayoutComponent_ng_template_10_Template, 2, 13, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(12, ExItemsLayoutComponent_ng_template_12_Template, 2, 9, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(14, ExItemsLayoutComponent_ng_template_14_Template, 2, 11, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(16, "div", 10, 11);
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("ex-items-layout-grid-rows-no-header", ctx.listProperties.hideHeader)("ng-sidebyside-or-fullpage-mode-open", ctx.getIsItemOpen() || ctx.isExpanded || ctx.listProperties.deepLinkMode);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.listProperties.hideHeader);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (!ctx.items || (ctx.items == null ? null : ctx.items.length) === 0) && !ctx.listProperties.isLoading)("ngIfElse", _r3);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c14$6, ctx.listProperties.isLoading));
            i0.ɵɵadvance(11);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 9, "ng.list-layout.end_of_list"));
        } }, styles: [".ex-items-layout-wrapper[_ngcontent-%COMP%]:focus{outline:0}.ex-items-layout-wrapper[_ngcontent-%COMP%]{display:grid;grid-template-rows:max-content 1fr;height:calc(100% - 1px);position:relative}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-header-wrapper[_ngcontent-%COMP%]{overflow:hidden}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]{position:relative;overflow:auto}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]{height:100%;overflow:auto}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-left[_ngcontent-%COMP%]{overflow:auto;height:100%}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-left-open[_ngcontent-%COMP%]{padding-inline-end:15px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]{height:100%;position:relative}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]     .ex-sections-layout-wrapper{margin-top:-43px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]     .ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper{padding-block-start:50px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-in-place-layout-right-wrapper-full-page[_ngcontent-%COMP%]{padding-inline-start:25px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]{height:100%;outline:none}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]:focus{border:black 1px solid}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]   .ex-items-layout-sections-menu[_ngcontent-%COMP%]{position:sticky;top:10px;height:100%;min-width:150px;padding-top:10px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]   .ex-items-layout-sections-menu[_ngcontent-%COMP%]   .ex-items-layout-sections-menu-item-active[_ngcontent-%COMP%]{padding-left:10px!important}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]   .ex-items-layout-sections-menu[_ngcontent-%COMP%]   .ex-items-layout-sections-menu-item[_ngcontent-%COMP%]{padding-left:14px;background:transparent;border:none;text-align:start;display:flex;padding-top:5px;padding-bottom:5px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper[_ngcontent-%COMP%]   .ex-items-layout-side-by-side[_ngcontent-%COMP%]   .ex-items-layout-right[_ngcontent-%COMP%]   .ex-items-layout-right-wrapper[_ngcontent-%COMP%]   .ex-items-layout-sections-menu[_ngcontent-%COMP%]   .ex-items-layout-sections-menu-item[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-right:10px}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-content-wrapper-no-header[_ngcontent-%COMP%]{height:100%}.ex-items-layout-wrapper[_ngcontent-%COMP%]   .ex-items-layout-header[_ngcontent-%COMP%]{display:flex;position:sticky;top:0;width:calc(100% - 20px);justify-content:flex-end;height:43px;z-index:10}.ex-items-layout-grid-rows-no-header[_ngcontent-%COMP%]{grid-template-rows:1fr}.ex-items-layout-spinner-wrapper[_ngcontent-%COMP%]{position:relative;height:100%;width:100%}.ex-items-layout-spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%}.ex-items-layout-no-records-found-placeholder[_ngcontent-%COMP%]{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-items-layout-no-records-flex-and-center[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}.ex-items-layout-no-records-flex-and-center[_ngcontent-%COMP%]   .ex-items-layout-no-records-icon[_ngcontent-%COMP%]{margin-bottom:10px}.ex-items-layout-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-items-layout-hidden-button[_ngcontent-%COMP%]{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none;outline:none}.ex-items-layout-header-toggle-div[_ngcontent-%COMP%]{display:grid;grid-template-areas:\"left right\"}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]{margin-top:10px;display:flex;align-content:center}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-items-layout-main-header-back-button[_ngcontent-%COMP%]{border:0px;padding:0 10px;width:35px}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-items-layout-main-header-back-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:20px}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-items-layout-main-header-back-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-items-layout-primary-title[_ngcontent-%COMP%]{display:flex}.ex-items-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-items-layout-primary-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#474747;margin:0;align-self:center}.ex-items-layout-expand-collapse-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.ex-items-layout-expand-collapse-wrapper[_ngcontent-%COMP%]   .ex-items-layout-expand-collapse-icon[_ngcontent-%COMP%]{width:25px;height:50px;border-top-left-radius:51px;border-bottom-left-radius:51px;border:1px solid #ccc;border-right:0;display:flex;align-items:center;justify-content:center;margin-left:-25px;z-index:10;background:#fff}.ex-items-layout-expand-collapse-wrapper[_ngcontent-%COMP%]   .ex-items-layout-expand-collapse-icon[_ngcontent-%COMP%]:hover     ex-icon i{color:#fff!important}.ex-items-layout-expand-collapse-wrapper-rotate[_ngcontent-%COMP%]   .ex-items-layout-expand-collapse-icon[_ngcontent-%COMP%]{transform:rotate(180deg);margin-left:0;border-right:1px solid #ccc;margin-right:-25px}"], data: { animation: ExItemsLayoutAnimations } }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutComponent.prototype, "onNextClicked", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutComponent.prototype, "onCloseRightSideClicked", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout', animations: ExItemsLayoutAnimations, providers: [
                    ExItemsLayoutService,
                    { provide: GeneralListLayoutComponent, useExisting: forwardRef(() => ExItemsLayoutComponent) },
                    {
                        provide: forwardRef(() => LAYOUT_WRAPPER_GET_BOUNDS),
                        useFactory: (layout) => {
                            return () => layout.itemsLayoutService.getLayoutWrapperBoundingClientRect();
                        },
                        deps: [ExItemsLayoutComponent]
                    }, {
                        provide: forwardRef(() => IS_SINGLE_SAVE),
                        useFactory: (exItemsLayoutComponent) => {
                            return exItemsLayoutComponent.listProperties.isSingleSave;
                        },
                        deps: [ExItemsLayoutComponent]
                    },
                    {
                        provide: ExItemDetailsHeaderStatusService,
                        useFactory: (existingStatusService) => {
                            return existingStatusService ?? new ExItemDetailsHeaderStatusService();
                        },
                        deps: [[new Optional(), new SkipSelf(), ExItemDetailsHeaderStatusService]],
                    }
                ], template: "<div class=\"ex-items-layout-wrapper\" #layoutWrapper\r\n     [class.ex-items-layout-grid-rows-no-header]=\"listProperties.hideHeader\"\r\n     [class.ng-sidebyside-or-fullpage-mode-open]=\"getIsItemOpen() || this.isExpanded || this.listProperties.deepLinkMode\">\r\n  <ng-container>\r\n    <div #headerWrapper *ngIf=\"!listProperties.hideHeader\" class=\"ex-items-layout-header-wrapper\"\r\n         [@expanded-header]=\"!_hideHeader || (getIsFullPage() && getIsItemOpen()) \">\r\n      <ex-list-header [responsivenessActive]=\"true\" [isWideScreen]=\"isWideScreen\" [hasRecordCustomization]=\"hasRecordCustomization\"\r\n                      [headerResponsivenessOrderConfig]=\"listProperties.headerResponsivenessOrderConfig\"\r\n                      [selectedOnCurrentPage]=\"checkedOnCurrentPage$ | async\" [hasToggle]=\"!!itemDetails\"\r\n                      (comboboxItemClicked)=\"onComboboxItemClicked($event)\"\r\n                      [hasExport]=\"listProperties.hasExport && !listProperties.inExSidepanePickup\"\r\n                      [hasSearch]=\"listProperties.hasSearch\" [responsive]=\"responsive\"\r\n                      [popUpActions]=\"listProperties.popUpActions\"\r\n                      [numberOfCheckedItems]=\"checkedItems.length\"\r\n                      [pageSize]=\"numCurrentItems$ | async\" [isItemOpen]=\"getIsItemOpen()\"\r\n                      [searchByFields]=\"listProperties.searchByFields\"\r\n                      [searchBySelectedField]=\"listProperties.searchBySelectedField\"\r\n                      [sorts]=\"listProperties.showSortsInListHeader ? listProperties.sorts : []\"\r\n                      [filters]=\"listProperties.filters\"\r\n                      [hasPickup]=\"listProperties.hasPickup\"\r\n                      [galleryLayoutEnabled]=\"listProperties.galleryLayoutEnabled\"\r\n                      [hasPickupCount]=\"listProperties.hasPickupCount && listProperties.isMultiSelect\"\r\n                      [comboboxLists]=\"listProperties.comboboxLists\" [actions]=\"listProperties.actions\"\r\n                      [bulkActions]=\"listProperties.bulkActions\"\r\n                      [hasBottomBorder]=\"!listProperties.hideHeaderOnScroll || !items || items?.length === 0\"\r\n                      [filterMaxDate]=\"listProperties.filterMaxDate\" [filterMinDate]=\"listProperties.filterMinDate\"\r\n                      [showDateFilter]=\"listProperties.showDateFilter\" [searchText]=\"listProperties.searchText\"\r\n                      (sortChange)=\"onSortChange($event)\" (actionClicked)=\"onActionClicked($event)\"\r\n                      (searchChange)=\"onSearchChange($event)\"\r\n                      (selectedValueChange)=\"onSelectedSearchFieldChange($event)\"\r\n                      (clearCheckedItems)=\"onClearCheckedItems()\" (clearPageCheckedItems)=\"onClearPageCheckedItems()\"\r\n                      [clearAllSubject]=\"clearAllSubject\" (checkAllItems)=\"onCheckAllItems()\"\r\n                      (filterChange)=\"onFilterChanged($event)\"\r\n                      (datesUpdated)=\"onDatesUpdated($event)\" (clearDates)=\"onClearDates()\"\r\n                      [hasCustomization]=\"hasCustomization && listProperties.enableCustomization\"\r\n                      [customizationComponent]=\"customizationComponent\" [isCustomized]=\"isCustomized\"\r\n                      (customizationClicked)=\"onCustomizationClicked()\" [isLoading]=\"listProperties.isLoading\"\r\n                      [needToRefresh]=\"listProperties.needToRefresh\" (refreshClicked)=\"onRefreshClicked()\"\r\n                      [hasRefreshButton]=\"listProperties.hasRefreshButton\" [deepLinkMode]=\"listProperties.deepLinkMode\"\r\n                      [deepLinkModeTemplate]=\"deepLinkModeTemplate\" (toggleisItemOpen)=\"toggleisItemOpen()\"\r\n                      (closeRightSideClicked)=\"onCloseRightSideClicked()\" [viewMode]=\"getViewMode()\"\r\n                      [fullPage]=\"getIsItemOpen() && getIsFullPage()\" (viewModeChange)=\"onViewModeChange($event)\"\r\n                      (openUserResponsiveMenu)=\"openUserResponsiveMenu.emit()\" [showToggle]=\"listProperties.showToggle\"\r\n                      [showItemsLayoutTypeToggle]=\"gridLayoutEnabled\"\r\n                      (itemsLayoutTypeToggled)=\"onLayoutTypeToggled($event)\" [itemsLayoutType]=\"type\"\r\n                      [fullPageTitle]=\"selectedItemObject?.listItem?.__proto__?.fullPageTitle && selectedItemObject.listItem[selectedItemObject.listItem.__proto__.fullPageTitle.key]\"\r\n                      [fullPageTitleIcon]=\"selectedItemObject?.listItem?.__proto__?.fullPageTitleIcon && selectedItemObject.listItem[selectedItemObject.listItem.__proto__.fullPageTitleIcon.key]\"\r\n                      [floatingExport]=\"newExport\" [exportEnabled]=\"exportEnabled\"\r\n                      [hasMinimizedSearch]=\"hasMinimizedSearch\" [(gallerySlider)]=\"gallerySlider\" (gallerySliderChange)=\"gallerySliderChange.emit($event)\">\r\n        <ng-content select=\"[header]\" header-slot-1></ng-content>\r\n        <ng-content select=\"[header-slot-2]\" header-slot-2></ng-content>\r\n        <ng-content select=\"[header-slot-3]\" header-slot-3></ng-content>\r\n      </ex-list-header>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"(!items || items?.length === 0) && !listProperties.isLoading; else results\">\r\n    <ng-container *ngIf=\"noResultsTemplate != null; else defaultNoResultsTemplate\"\r\n                  [ngTemplateOutlet]=\"noResultsTemplate\" role=\"alert\"></ng-container>\r\n    <ng-template #defaultNoResultsTemplate>\r\n      <div class=\"ex-items-layout-no-records-found-placeholder ex-items-layout-no-records-flex-and-center\" role=\"alert\">\r\n        <img\r\n          [src]=\"listProperties?.searchText || listProperties?.persistentSearchIsAdvanced?'/ng/assets/svg-icons/no-search-results.svg':'/ng/assets/svg-icons/no-items-in-list.svg'\"\r\n          [style.max-height.px]=\"200\" [style.width.px]=\"200\"\r\n          class='sel-no-records-icon ex-items-layout-no-records-icon'>\r\n        <p *ngIf=\"listProperties?.searchText || listProperties?.persistentSearchIsAdvanced\"\r\n           class=\"ex-items-layout-no-records-text sel-no-records\">\r\n          <ng-container *ngIf=\"noResultsPlaceholder; else customNoResults\">\r\n            {{ noResultsPlaceholder | translate }}\r\n          </ng-container>\r\n          <ng-template #customNoResults>\r\n            {{ 'list-layout.no_results_your_search' | translate }}\r\n            <span class=\"bold-weight\">{{getSearchText()}}</span>\r\n            {{ 'list-layout.no_results_did_not_match' | translate }}\r\n          </ng-template>\r\n        </p>\r\n        <p class=\"ex-items-layout-no-records-text sel-no-records\">\r\n          {{(noResultsHintPlaceholder ? noResultsHintPlaceholder :\r\n          (!listProperties?.persistentSearchType && listProperties?.searchText || listProperties?.persistentSearchIsAdvanced ?\r\n            'list-layout.no_results_change_filters_hint_placeholder' :\r\n            'list-layout.no_results_no_items')) | translate }}\r\n        </p>\r\n      </div>\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-template #results>\r\n    <div class=\"ex-items-layout-content-wrapper\"\r\n         [ngClass]=\"{ 'ex-items-layout-content-top-border': listProperties.hideHeaderOnScroll, 'ex-items-layout-content-wrapper-no-header' : listProperties.hideHeader}\">\r\n      <ex-side-by-side (rightSideHeightChange)=\"rightSideHeightChange($event)\"\r\n                       *ngIf=\"itemDetails; else (!type || type == 'list') ? list : (type == 'grid' ? grid : (type == 'gallery' ? gallery : tree))\"\r\n                       [leftVisible]=\"(!getIsFullPage()) || (getIsFullPage() && !getIsItemOpen())\"\r\n                       [rightVisible]=\"getIsItemOpen()\"\r\n                       [leftSize]=\"listProperties.leftSide\" [rightSize]=\"listProperties.rightSide\" [leftMinSize]=\"35\"\r\n                       [rightMinSize]=\"40\" [isRtl]=\"isRtl\" class=\"ex-items-layout-side-by-side\"\r\n                       (leftSideResized)=\"onLeftSideResized($event)\" (gutterDragEnd)=\"gutterDragEnd.emit($event)\">\r\n        <div #listRef cdkScrollable (scroll)=\"onScrollLeftSide($event)\" slot-side-1 class=\"ex-items-layout-left\"\r\n             [class.ex-items-layout-left-open]=\"getIsItemOpen() && type!=='tree'\">\r\n          <ng-container\r\n            *ngTemplateOutlet=\"(!type || type == 'list') ? list : (type == 'grid' ? grid : (type == 'gallery' ? gallery : tree))\"></ng-container>\r\n        </div>\r\n        <div expand-button *ngIf=\"getIsItemOpen() && (isWideScreen || !responsive) && !listProperties.deepLinkMode\"\r\n             class=\"ex-items-layout-expand-collapse-wrapper\"\r\n             [class.ex-items-layout-expand-collapse-wrapper-rotate]=\"(isRtl && !getIsFullPage()) || (!isRtl && getIsFullPage())\">\r\n          <button #expandButtonRef *ngIf=\"viewMode=='SPLIT' || (viewMode == undefined)\" tabindex=\"0\"  (focusout)=\"!getIsFullPage() && !listProperties.deepLinkMode ? moveFocusToRightSide($event) : null\"\r\n                  [attr.aria-label]=\"getIsFullPage() ? ('ng.general.return-to-split-view' | translate): ('ng.general.open-full-page' | translate)\"\r\n                  [exTooltip]=\"getIsFullPage() ? ('ng.general.return-to-split-view' | translate): ('ng.general.open-full-page' | translate)\"\r\n                  (click)=\"onExpandButtonToggle(!getIsFullPage())\" class=\"ex-items-layout-expand-collapse-icon\">\r\n            <ex-icon iconType=\"fa-font\" iconName=\"fa-angle-double-left\" color=\"#757575\"></ex-icon>\r\n          </button>\r\n        </div>\r\n        <div *ngIf=\"getIsItemOpen()\" slot-side-2 class=\"ex-items-layout-right ex-generic-list-side-by-side\"\r\n             resized [resizeCB]=\"onRightSideResizedCB\">\r\n          <button *ngIf=\"!getIsFullPage() && !listProperties.deepLinkMode\" class=\"ex-items-layout-hidden-button\" aria-label=\"move focus to previous\r\n          row\" (focus)=\"onItemDetailsStartFocused()\"></button>\r\n          <div class=\"ex-items-layout-right-wrapper\" [class.ex-in-place-layout-right-wrapper-full-page]=\"isFullPage\"\r\n               #rightSideRef tabindex=\"0\" role=\"region\" aria-labelledby=\"selectedItemInList\">\r\n\r\n            <ng-template #headerTemplate>\r\n              <ex-item-details-header [itemId]=\"_selectedItemObject?.id\"\r\n                                      [actions]=\"_selectedItemObject?.disabled ? null : getRightSideActions()\"\r\n                                      [headerMenus]=\"_selectedItemObject?.disabled ? null : getRightSideHeaderMenus()\"\r\n                                      [status]=\"_selectedItemObject?.disabled ? null : getRightSideStatus()\"\r\n                                      [hasPrev]=\"hasPreviousItem$ | async\" [hasNext]=\"hasNextItem$ | async\"\r\n                                      [hasTitle]=\"listProperties.hasTitle\" (prevClicked)=\"onPreviousClicked()\"\r\n                                      (nextClicked)=\"onNextClicked()\"\r\n                                      (closeClicked)=\"onRightSideDetailesCloseClicked()\" class=\"ex-items-layout-header\"\r\n                                      [hasSectionsCombobox]=\"listProperties.hasSectionsCombobox\"\r\n                                      [deepLinkMode]=\"listProperties.deepLinkMode\"\r\n                                      (actionClicked)=\"onRecordActionClicked($event, _selectedItemObject)\"\r\n                                      (editAllClicked)=\"onEditAllClicked()\" [singleSaveDisabled]=\"singleSaveDisabled\"\r\n                                      [isEditable]=\"_selectedItemObject?.listItem?.[_selectedItemObject?.listItem?.__proto__.editableKey] != false\"\r\n                                      [layoutLoading]=\"listProperties.isLoading\"\r\n                                      [expandActionsOnAllSpace]=\"expandActionsOnAllSpaceFlag && this.listProperties.expandActionsOnAllSpace\">\r\n              </ex-item-details-header>\r\n            </ng-template>\r\n\r\n            <ng-container *ngIf=\"!listProperties.isLoading && _selectedItemObject; else itemDetailsPlaceHolder\">\r\n              <ng-container exShortcutsScope\r\n                            *ngIf=\"(selectedSublistItem && selectedSublistItemDetails) || (!selectedSublistItem && _selectedItemObject)\">\r\n                <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\r\n                <ng-template #selectedItemDetailsTmpl [ngTemplateOutlet]=\"selectedItemDetailsTmpl\"\r\n                             let-currentSelectedItem=\"currentSelectedItem\"\r\n                             [ngTemplateOutletContext]=\"{ currentSelectedItem: selectedSublistItem ? selectedSublistItem : _selectedItemObject?.listItem }\">\r\n                  <ex-component-loader #detailsComponentLoader\r\n                                       [data]=\"{ data: currentSelectedItem?.data , disabled: selectedSublistItem ? false : _selectedItemObject.disabled, editable: currentSelectedItem[currentSelectedItem.__proto__.editableKey] }\"\r\n                                       [events]=\"selectedSublistItem ? {} : itemDetails.events\"\r\n                                       [componentFactoryItem]=\"selectedSublistItem ? selectedSublistItemDetails : itemDetails\"\r\n                                       class=\"ex-items-layout-content\">\r\n                  </ex-component-loader>\r\n                </ng-template>\r\n              </ng-container>\r\n            </ng-container>\r\n\r\n            <ng-template #itemDetailsPlaceHolder>\r\n              <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\r\n              <ex-component-loader\r\n                [data]=\"{ 'isLoading' : listProperties.isLoading, 'noneSelected' : !_selectedItemObject }\"\r\n                [componentFactoryItem]=\"itemDetails\">\r\n              </ex-component-loader>\r\n            </ng-template>\r\n\r\n            <button *ngIf=\"!getIsFullPage() && !listProperties.deepLinkMode\" class=\"ex-items-layout-hidden-button\" (focus)=\"onItemDetailsEndFocused()\"\r\n                    aria-label=\"move focus to next row\"></button>\r\n          </div>\r\n        </div>\r\n\r\n      </ex-side-by-side>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div [ngClass]=\"{ 'ex-items-layout-animate sel-loading' : listProperties.isLoading }\"></div>\r\n\r\n</div>\r\n\r\n<ng-template #list>\r\n  <ex-items-layout-list #itemsLayout [listProperties]=\"listProperties\" [items]=\"items\"\r\n                        [selectedItem]=\"_selectedItemObject\"\r\n                        [listParametersItemIdUpdatedObservable]=\"listParametersItemIdUpdatedObservable\"\r\n                        [checkedItems]=\"checkedItems\" [readyToLoad]=\"canSplitChecked || !responsive\"\r\n                        [leftSideWidth]=\"leftSideWidth\"\r\n                        [hasItemDetailsComponent]=\"!!itemDetails\"\r\n                        [isItemOpen]=\"listProperties.deepLinkMode || getIsItemOpen()\"\r\n                        [htmlId]=\"htmlId\" [pageCustomizationData]=\"pageCustomizationData\"\r\n                        [showThumbnail]=\"showThumbnail\"\r\n                        (resizeEvent)=\"!itemDetails && onLeftSideResized($event)\"\r\n                        (selectedItemChange)=\"onSelectedItemChange($event)\" (itemSelected)=\"onItemSelected($event)\"\r\n                        (itemDeselected)=\"onItemDeselected($event)\" (itemClicked)=\"onItemClicked($event)\"\r\n                        (sublistOpened)=\"onSublistOpened($event)\"\r\n                        (selectedSublistItemChanged)=\"onSelectedSublistItemChanged($event)\"\r\n                        (loadMoreSublist)=\"onLoadMoreSublist($event)\"\r\n                        (itemActionClicked)=\"onRecordActionClicked($event.key, $event.item)\"\r\n                        (itemCheckboxChanged)=\"onItemCheckboxChanged($event)\"\r\n                        (checkedItemsChanged)=\"onCheckedItemsChanged($event)\"\r\n                        (selectedPageChange)=\"onSelectedPageChange($event)\"\r\n                        (pageSizeChange)=\"pageSizeChange.emit($event)\"\r\n                        (endOfPagination)=\"focusOnEndOfPage()\"\r\n                        (rowDraggedDropped)=\"onRowDraggedDropped($event)\"\r\n                        (tabOutFromItemEnd)=\"moveFocusToExpandButton($event)\">\r\n  </ex-items-layout-list>\r\n</ng-template>\r\n\r\n<ng-template #gallery>\r\n  <ex-items-layout-gallery #itemsLayout [listProperties]=\"listProperties\" [items]=\"items\"\r\n                        [selectedItem]=\"_selectedItemObject\"\r\n                        [listParametersItemIdUpdatedObservable]=\"listParametersItemIdUpdatedObservable\"\r\n                        [checkedItems]=\"checkedItems\" [readyToLoad]=\"canSplitChecked || !responsive\"\r\n                        [leftSideWidth]=\"leftSideWidth\"\r\n                        [hasItemDetailsComponent]=\"!!itemDetails\"\r\n                        [isItemOpen]=\"listProperties.deepLinkMode || getIsItemOpen()\"\r\n                        [htmlId]=\"htmlId\" [pageCustomizationData]=\"pageCustomizationData\"\r\n                        [showThumbnail]=\"showThumbnail\"\r\n                        [gallerySlider]=\"gallerySlider\"\r\n                        (resizeEvent)=\"!itemDetails && onLeftSideResized($event)\"\r\n                        (selectedItemChange)=\"onSelectedItemChange($event)\" (itemSelected)=\"onItemSelected($event)\"\r\n                        (itemDeselected)=\"onItemDeselected($event)\" (itemClicked)=\"onItemClicked($event)\"\r\n                        (sublistOpened)=\"onSublistOpened($event)\"\r\n                        (selectedSublistItemChanged)=\"onSelectedSublistItemChanged($event)\"\r\n                        (loadMoreSublist)=\"onLoadMoreSublist($event)\"\r\n                        (itemActionClicked)=\"onRecordActionClicked($event.key, $event.item)\"\r\n                        (itemCheckboxChanged)=\"onItemCheckboxChanged($event)\"\r\n                        (checkedItemsChanged)=\"onCheckedItemsChanged($event)\"\r\n                        (selectedPageChange)=\"onSelectedPageChange($event)\"\r\n                        (pageSizeChange)=\"pageSizeChange.emit($event)\"\r\n                        (endOfPagination)=\"focusOnEndOfPage()\"\r\n                        (rowDraggedDropped)=\"onRowDraggedDropped($event)\"\r\n                        (tabOutFromItemEnd)=\"moveFocusToExpandButton($event)\">\r\n  </ex-items-layout-gallery>\r\n</ng-template>\r\n\r\n<ng-template #tree>\r\n  <ex-items-layout-tree #itemsLayout [listProperties]=\"listProperties\" [items]=\"items\"\r\n                        [selectedItem]=\"_selectedItemObject\"\r\n                        [listParametersItemIdUpdatedObservable]=\"listParametersItemIdUpdatedObservable\"\r\n                        [checkedItems]=\"checkedItems\" [readyToLoad]=\"canSplitChecked || !responsive\"\r\n                        [onLoadExpandToLevel]=\"treeOnLoadExpandToLevel\"\r\n                        [isItemOpen]=\"listProperties.deepLinkMode ||getIsItemOpen()\"\r\n                        [nodeContentTemplate]=\"treeNodeTemplate\" (selectedItemChange)=\"onSelectedItemChange($event)\"\r\n                        (itemSelected)=\"onItemSelected($event)\" (itemDeselected)=\"onItemDeselected($event)\"\r\n                        (itemClicked)=\"onItemClicked($event)\"\r\n                        (itemActionClicked)=\"onRecordActionClicked($event.key, $event.item)\"\r\n                        (itemsMoved)=\"onItemsMoved($event)\" (nodeToggled)=\"onNodeToggled($event)\"\r\n                        (itemCheckboxChanged)=\"onItemCheckboxChanged($event)\"\r\n                        (checkedItemsChanged)=\"onCheckedItemsChanged($event)\"\r\n                        (selectedPageChange)=\"onSelectedPageChange($event)\"\r\n                        (resizeEvent)=\"onLeftSideResized($event)\" (tabOutFromItemEnd)=\"moveFocusToExpandButton($event)\">\r\n  </ex-items-layout-tree>\r\n</ng-template>\r\n\r\n<ng-template #grid>\r\n  <ex-items-layout-grid #itemsLayout [listProperties]=\"listProperties\" [items]=\"items\"\r\n                        [selectedItem]=\"_selectedItemObject\"\r\n                        [listParametersItemIdUpdatedObservable]=\"listParametersItemIdUpdatedObservable\"\r\n                        [checkedItems]=\"checkedItems\" [readyToLoad]=\"canSplitChecked || !responsive\"\r\n                        [leftSideWidth]=\"leftSideWidth\"\r\n                        [hasItemDetailsComponent]=\"!!itemDetails\"\r\n                        [isItemOpen]=\"listProperties.deepLinkMode || getIsItemOpen()\"\r\n                        [htmlId]=\"htmlId\" [pageCustomizationData]=\"pageCustomizationData\"\r\n                        (selectedItemChange)=\"onSelectedItemChange($event)\" (itemSelected)=\"onItemSelected($event)\"\r\n                        (itemDeselected)=\"onItemDeselected($event)\" (itemClicked)=\"onItemClicked($event)\"\r\n                        (itemActionClicked)=\"onRecordActionClicked($event.key, $event.item)\"\r\n                        (itemCheckboxChanged)=\"onItemCheckboxChanged($event)\"\r\n                        (checkedItemsChanged)=\"onCheckedItemsChanged($event)\"\r\n                        (selectedPageChange)=\"onSelectedPageChange($event)\"\r\n                        (pageSizeChange)=\"pageSizeChange.emit($event)\"\r\n                        (endOfPagination)=\"focusOnEndOfPage()\" (resizeEvent)=\"onLeftSideResized($event)\"\r\n                        (rowDraggedDropped)=\"onRowDraggedDropped($event)\"\r\n                        (tabOutFromItemEnd)=\"moveFocusToExpandButton($event)\"\r\n                        (columnHeaderSortChange)=\"onSortChange($event)\"\r\n                        (layoutCustomized)=\"layoutCustomized.emit($event)\">\r\n  </ex-items-layout-grid>\r\n</ng-template>\r\n\r\n<div #endOfList tabindex=\"0\" class=\"ex-items-layout-hidden-button\">{{ 'ng.list-layout.end_of_list' | translate }}</div>\r\n", styles: [".ex-items-layout-wrapper:focus{outline:0}.ex-items-layout-wrapper{display:grid;grid-template-rows:max-content 1fr;height:calc(100% - 1px);position:relative}.ex-items-layout-wrapper .ex-items-layout-header-wrapper{overflow:hidden}.ex-items-layout-wrapper .ex-items-layout-content-wrapper{position:relative;overflow:auto}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side{height:100%;overflow:auto}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-left{overflow:auto;height:100%}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-left-open{padding-inline-end:15px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right{height:100%;position:relative}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right ::ng-deep .ex-sections-layout-wrapper{margin-top:-43px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right ::ng-deep .ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper{padding-block-start:50px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-in-place-layout-right-wrapper-full-page{padding-inline-start:25px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper{height:100%;outline:none}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper:focus{border:black 1px solid}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper .ex-items-layout-sections-menu{position:sticky;top:10px;height:100%;min-width:150px;padding-top:10px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper .ex-items-layout-sections-menu .ex-items-layout-sections-menu-item-active{padding-left:10px!important}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper .ex-items-layout-sections-menu .ex-items-layout-sections-menu-item{padding-left:14px;background:transparent;border:none;text-align:start;display:flex;padding-top:5px;padding-bottom:5px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper .ex-items-layout-side-by-side .ex-items-layout-right .ex-items-layout-right-wrapper .ex-items-layout-sections-menu .ex-items-layout-sections-menu-item ex-icon{margin-right:10px}.ex-items-layout-wrapper .ex-items-layout-content-wrapper-no-header{height:100%}.ex-items-layout-wrapper .ex-items-layout-header{display:flex;position:sticky;top:0;width:calc(100% - 20px);justify-content:flex-end;height:43px;z-index:10}.ex-items-layout-grid-rows-no-header{grid-template-rows:1fr}.ex-items-layout-spinner-wrapper{position:relative;height:100%;width:100%}.ex-items-layout-spinner{position:absolute;top:50%;left:50%}.ex-items-layout-no-records-found-placeholder{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-items-layout-no-records-flex-and-center{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}.ex-items-layout-no-records-flex-and-center .ex-items-layout-no-records-icon{margin-bottom:10px}.ex-items-layout-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-items-layout-hidden-button{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none;outline:none}.ex-items-layout-header-toggle-div{display:grid;grid-template-areas:\"left right\"}.ex-items-layout-header-title-wrapper{margin-top:10px;display:flex;align-content:center}.ex-items-layout-header-title-wrapper .ex-items-layout-main-header-back-button{border:0px;padding:0 10px;width:35px}.ex-items-layout-header-title-wrapper .ex-items-layout-main-header-back-button i{margin-right:20px}.ex-items-layout-header-title-wrapper .ex-items-layout-main-header-back-button:hover{cursor:pointer}.ex-items-layout-header-title-wrapper .ex-items-layout-primary-title{display:flex}.ex-items-layout-header-title-wrapper .ex-items-layout-primary-title h2{color:#474747;margin:0;align-self:center}.ex-items-layout-expand-collapse-wrapper{display:flex;align-items:center;justify-content:center}.ex-items-layout-expand-collapse-wrapper .ex-items-layout-expand-collapse-icon{width:25px;height:50px;border-top-left-radius:51px;border-bottom-left-radius:51px;border:1px solid #ccc;border-right:0;display:flex;align-items:center;justify-content:center;margin-left:-25px;z-index:10;background:#fff}.ex-items-layout-expand-collapse-wrapper .ex-items-layout-expand-collapse-icon:hover ::ng-deep ex-icon i{color:#fff!important}.ex-items-layout-expand-collapse-wrapper-rotate .ex-items-layout-expand-collapse-icon{transform:rotate(180deg);margin-left:0;border-right:1px solid #ccc;margin-right:-25px}\n"] }]
    }], function () { return [{ type: i1$5.Location }, { type: ExSectionsLayoutListLayoutService }, { type: i3$2.Router }, { type: ExSidenavPageService, decorators: [{
                type: Optional
            }] }, { type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }, { type: i0.ElementRef }]; }, { selectedItemObject: [{
            type: Input
        }], checkedItems: [{
            type: Input
        }], hasCustomization: [{
            type: Input
        }], hasRecordCustomization: [{
            type: Input
        }], customizationComponent: [{
            type: Input
        }], pageCustomizationData: [{
            type: Input
        }], isCustomized: [{
            type: Input
        }], isRtl: [{
            type: Input
        }], responsive: [{
            type: Input
        }], treeOnLoadExpandToLevel: [{
            type: Input
        }], deepLinkModeTemplate: [{
            type: Input
        }], isStandaloneList: [{
            type: Input
        }], customizationClicked: [{
            type: Output
        }], gutterDragEnd: [{
            type: Output
        }], openUserResponsiveMenu: [{
            type: Output
        }], layoutStateChanged: [{
            type: Output
        }], layoutCustomized: [{
            type: Output
        }], noResultsTemplate: [{
            type: Input
        }], treeNodeTemplate: [{
            type: Input
        }], listParametersItemIdUpdatedObservable: [{
            type: Input
        }], singleSaveDisabled: [{
            type: Input
        }], showThumbnail: [{
            type: Input
        }], expandActionsOnAllSpaceFlag: [{
            type: Input
        }], gridLayoutEnabled: [{
            type: Input
        }], isSecondarySearchFlagActive: [{
            type: Input
        }], persistentSearchText: [{
            type: Input
        }], layoutWrapper: [{
            type: ViewChild,
            args: ['layoutWrapper']
        }], rightSideRef: [{
            type: ViewChild,
            args: ['rightSideRef']
        }], expandButtonRef: [{
            type: ViewChild,
            args: ['expandButtonRef']
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }], endOfList: [{
            type: ViewChild,
            args: ['endOfList']
        }], sideBySide: [{
            type: ViewChild,
            args: [ExSideBySideComponent]
        }], itemsLayout: [{
            type: ViewChild,
            args: ['itemsLayout']
        }], detailsComponentLoader: [{
            type: ViewChild,
            args: ['detailsComponentLoader']
        }], onNextClicked: [], onPopState: [{
            type: HostListener,
            args: ['window:popstate', ['$event']]
        }], onCloseRightSideClicked: [] }); })();

const EX_DATE_FORMAT = new InjectionToken('EX_DATE_FORMAT');
const EX_TIME_FORMAT = new InjectionToken('EX_TIME_FORMAT');
const EX_APP_IN_SIDEPANE = new InjectionToken('EX_APP_IN_SIDEPANE');
const EX_APP_LANGUAGE = new InjectionToken('EX_APP_LANGUAGE');

const _c0$1N = function (a0, a1, a2) { return { "ex-display-text-value-text-multi": a0, "ex-display-text-value-text-placeholder": a1, "sel-display-text-value-text-multi": a2 }; };
const _c1$1a = function (a0) { return { "text-align": a0 }; };
function ExDisplayTextComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c0$1N, ctx_r0.multipleLines, !ctx_r0.value, ctx_r0.multipleLines))("ngStyle", i0.ɵɵpureFunction1(9, _c1$1a, ctx_r0.textAlign));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, ctx_r0.value ? ctx_r0.value : ctx_r0.placeholder), " ");
} }
function ExDisplayTextComponent_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$1a, ctx_r2.textAlign))("href", ctx_r2.value, i0.ɵɵsanitizeUrl)("matTooltip", ctx_r2.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.value, " ");
} }
function ExDisplayTextComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c1$1a, ctx_r3.textAlign));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 2, ctx_r3.value, ctx_r3.dateFormat), " ");
} }
function ExDisplayTextComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 4);
    i0.ɵɵtemplate(1, ExDisplayTextComponent_ng_container_2_a_1_Template, 2, 6, "a", 5);
    i0.ɵɵtemplate(2, ExDisplayTextComponent_ng_container_2_div_2_Template, 3, 7, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r1.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.typesEnum.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.typesEnum.DATE);
} }
class ExDisplayTextComponent extends ExControlValueAccessor {
    constructor(dateFormat, cdr) {
        super();
        this.cdr = cdr;
        /**
         * Display type. 'text' | 'link'. Default is 'text'
         */
        this.type = ExDisplayTextTypes.TEXT;
        /**
         * Alignment of text
         * must be a valid css 'text-align' value, default is 'center'
         */
        this.textAlign = 'start';
        /**
         * Allow text to break across multiple lines
         */
        this.multipleLines = false;
        /**
         * Placeholder to display when the input value is empty.
         */
        this.placeholder = '-'; //"ng.general.undefined_value";
        this.dateFormat = 'MM/dd/yy';
        this.typesEnum = ExDisplayTextTypes;
        this.dateFormat = dateFormat ?? this.dateFormat;
    }
    writeValue(value) {
        this.value = value;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExDisplayTextComponent_Factory(t) { return new (t || ExDisplayTextComponent)(i0.ɵɵdirectiveInject(EX_DATE_FORMAT, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDisplayTextComponent, selectors: [["ex-display-text"]], inputs: { type: "type", value: "value", textAlign: "textAlign", multipleLines: "multipleLines", placeholder: "placeholder", dateFormat: "dateFormat" }, features: [i0.ɵɵProvidersFeature([
                ...getValueAccessors(ExDisplayTextComponent),
            ]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["dir", "auto", 1, "ex-display-text-wrapper"], ["class", "ex-display-text-value ex-display-text-value-text sel-display-text-value-text", 3, "ngClass", "ngStyle", 4, "ngIf"], [3, "ngSwitch", 4, "ngIf"], [1, "ex-display-text-value", "ex-display-text-value-text", "sel-display-text-value-text", 3, "ngClass", "ngStyle"], [3, "ngSwitch"], ["class", "ex-display-text-value ex-display-text-value-link sel-display-text-value-link", "target", "_blank", "rel", "noopener", "matTooltipClass", "ex-display-text-value-link-tooltip", 3, "ngStyle", "href", "matTooltip", 4, "ngSwitchCase"], ["class", "ex-display-text-value ex-display-text-value-text sel-display-text-value-date", 3, "ngStyle", 4, "ngSwitchCase"], ["target", "_blank", "rel", "noopener", "matTooltipClass", "ex-display-text-value-link-tooltip", 1, "ex-display-text-value", "ex-display-text-value-link", "sel-display-text-value-link", 3, "ngStyle", "href", "matTooltip"], [1, "ex-display-text-value", "ex-display-text-value-text", "sel-display-text-value-date", 3, "ngStyle"]], template: function ExDisplayTextComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExDisplayTextComponent_div_1_Template, 3, 11, "div", 1);
            i0.ɵɵtemplate(2, ExDisplayTextComponent_ng_container_2_Template, 3, 3, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === ctx.typesEnum.TEXT || !ctx.value);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.value);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgStyle, i1$5.NgSwitch, i1$5.NgSwitchCase, i4.MatTooltip, i2$1.Dir, i1$5.DatePipe, i1$2.TranslatePipe], styles: [".ex-display-text-wrapper[_ngcontent-%COMP%]{min-height:32px;display:flex;align-items:center}.ex-display-text-value[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:0;border-radius:3px;width:100%;outline:none;background-color:transparent;padding:0 10px}.ex-display-text-value.ex-display-text-value-text-multi[_ngcontent-%COMP%]{white-space:break-spaces;overflow-wrap:break-word;padding-top:5.5px;padding-bottom:5.5px;unicode-bidi:plaintext}.ex-display-text-value-text[_ngcontent-%COMP%]{color:#757575}.ex-display-text-value-link[_ngcontent-%COMP%]{text-decoration:none}.ex-display-text-value-link-tooltip[_ngcontent-%COMP%]{white-space:normal!important;word-break:break-all!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDisplayTextComponent, [{
        type: Component,
        args: [{ selector: 'ex-display-text', providers: [
                    ...getValueAccessors(ExDisplayTextComponent),
                ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-display-text-wrapper\" dir=\"auto\">\n  <div *ngIf=\"type === typesEnum.TEXT || !value\"\n       class=\"ex-display-text-value ex-display-text-value-text sel-display-text-value-text\"\n       [ngClass]=\"{ 'ex-display-text-value-text-multi': multipleLines, 'ex-display-text-value-text-placeholder': !value, 'sel-display-text-value-text-multi': multipleLines }\"\n       [ngStyle]=\"{ 'text-align': textAlign }\">{{ (value ? value : placeholder) | translate }}\n  </div>\n  <ng-container *ngIf=\"value\" [ngSwitch]=\"type\">\n    <a *ngSwitchCase=\"typesEnum.LINK\"\n       class=\"ex-display-text-value ex-display-text-value-link sel-display-text-value-link\"\n       [ngStyle]=\"{ 'text-align': textAlign }\" [href]=\"value\" target=\"_blank\" rel=\"noopener\" [matTooltip]=\"value\"\n       matTooltipClass=\"ex-display-text-value-link-tooltip\">{{ value }}\n    </a>\n    <div *ngSwitchCase=\"typesEnum.DATE\"\n         class=\"ex-display-text-value ex-display-text-value-text sel-display-text-value-date\"\n         [ngStyle]=\"{ 'text-align': textAlign }\">{{ value | date:dateFormat }}\n    </div>\n  </ng-container>\n</div>\n", styles: [".ex-display-text-wrapper{min-height:32px;display:flex;align-items:center}.ex-display-text-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:0;border-radius:3px;width:100%;outline:none;background-color:transparent;padding:0 10px}.ex-display-text-value.ex-display-text-value-text-multi{white-space:break-spaces;overflow-wrap:break-word;padding-top:5.5px;padding-bottom:5.5px;unicode-bidi:plaintext}.ex-display-text-value-text{color:#757575}.ex-display-text-value-link{text-decoration:none}.ex-display-text-value-link-tooltip{white-space:normal!important;word-break:break-all!important}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_DATE_FORMAT]
            }] }, { type: i0.ChangeDetectorRef }]; }, { type: [{
            type: Input
        }], value: [{
            type: Input
        }], textAlign: [{
            type: Input
        }], multipleLines: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }] }); })();
var ExDisplayTextTypes;
(function (ExDisplayTextTypes) {
    ExDisplayTextTypes["TEXT"] = "text";
    ExDisplayTextTypes["LINK"] = "link";
    ExDisplayTextTypes["DATE"] = "date";
})(ExDisplayTextTypes || (ExDisplayTextTypes = {}));

const _c0$1M = ["confirmButton"];
function ExNoteComponent_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-svg-icon", 8);
    i0.ɵɵlistener("click", function ExNoteComponent_ex_svg_icon_1_Template_ex_svg_icon_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onCloseClicked()); })("keydown.enter", function ExNoteComponent_ex_svg_icon_1_Template_ex_svg_icon_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onCloseClicked()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵclassMap("ex-note-close-btn");
    i0.ɵɵproperty("iconName", "Delete")("tooltip", i0.ɵɵpipeBind1(2, 9, "ng.general.remove"))("size", "small")("color", "#2a5db0");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 7, "ng.general.remove"));
} }
function ExNoteComponent_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r1.noteIcon == null ? null : ctx_r1.noteIcon.iconName)("size", "small")("color", ctx_r1.noteIcon == null ? null : ctx_r1.noteIcon.iconColor)("tooltip", ctx_r1.noteIcon == null ? null : ctx_r1.noteIcon.tooltip);
} }
function ExNoteComponent_ex_editable_text_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-editable-text", 10);
    i0.ɵɵlistener("editableTextSaved", function ExNoteComponent_ex_editable_text_7_Template_ex_editable_text_editableTextSaved_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onTextSaved($event)); })("editableTextChanged", function ExNoteComponent_ex_editable_text_7_Template_ex_editable_text_editableTextChanged_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onTextChanged($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", ctx_r2.value || null)("isTextArea", true)("hasBorder", false)("textAreaMaxLength", ctx_r2.textAreaMaxLength)("autoFocus", ctx_r2.autoFocus)("ariaDescription", ctx_r2.ariaDescription)("ariaLabel", ctx_r2.ariaLabel || i0.ɵɵpipeBind1(1, 9, ctx_r2.noteTitle))("ariaRequired", ctx_r2.ariaRequired)("ariaErrorLabel", ctx_r2.ariaErrorLabel);
} }
function ExNoteComponent_ex_display_text_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-display-text", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r3.value)("type", "text")("textAlign", "start")("multipleLines", true);
} }
function ExNoteComponent_ex_confirmation_message_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-confirmation-message", 12);
    i0.ɵɵlistener("confirmClicked", function ExNoteComponent_ex_confirmation_message_10_Template_ex_confirmation_message_confirmClicked_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onCloseConfirmation(true)); })("cancelClicked", function ExNoteComponent_ex_confirmation_message_10_Template_ex_confirmation_message_cancelClicked_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onCloseConfirmation(false)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("message", ctx_r4.confirmationMessage);
} }
const _c1$19 = ["*"];
class ExNoteComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.showConfirmation = false;
        this.confirmationMessage = 'ng.ex-note.delete_note';
        this.autoFocus = false;
        /**
         * close confirmation, use black for bright notes and white for dark ones
         */
        this.closeConfirmation = 'black';
        this.color = '#fff8d1';
        this.closeClicked = new EventEmitter();
        this.showConfirmationChange = new EventEmitter();
        this.noteSaved = new EventEmitter();
        this.valueChange = new EventEmitter();
    }
    onCloseClicked() {
        if (this.closeConfirmation === 'none' || !this.value || this.value.length === 0) {
            this.closeClicked.emit();
        }
        else {
            this.showConfirmation = true;
            setTimeout(() => this.confirmButton?.nativeElement && this.confirmButton.nativeElement.focus(), 500);
            this.showConfirmationChange.emit(this.showConfirmation);
        }
    }
    onTextChanged(value) {
        this.value = value;
        this.valueChange.emit(value);
    }
    onTextSaved(value) {
        this.noteSaved.emit(value);
    }
    onCloseConfirmation(confirm) {
        if (confirm) {
            this.closeClicked.emit();
        }
        this.showConfirmation = false;
        this.showConfirmationChange.emit(this.showConfirmation);
    }
    writeValue(value) {
        this.value = value;
        this.cdr.markForCheck();
    }
    setDisabledState(disabled) {
        super.setDisabledState(disabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExNoteComponent_Factory(t) { return new (t || ExNoteComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExNoteComponent, selectors: [["ex-note"]], viewQuery: function ExNoteComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1M, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmButton = _t.first);
        } }, hostBindings: function ExNoteComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("valueChange", function ExNoteComponent_valueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("noteSaved", function ExNoteComponent_noteSaved_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { noteTitle: "noteTitle", value: "value", showConfirmation: "showConfirmation", confirmationMessage: "confirmationMessage", textAreaMaxLength: "textAreaMaxLength", autoFocus: "autoFocus", closeConfirmation: "closeConfirmation", noteIcon: "noteIcon", color: "color" }, outputs: { closeClicked: "closeClicked", showConfirmationChange: "showConfirmationChange", noteSaved: "noteSaved", valueChange: "valueChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExNoteComponent)), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$19, decls: 11, vars: 10, consts: [[1, "ex-note", "sel-note"], ["tabindex", "0", "role", "button", 3, "class", "iconName", "tooltip", "size", "color", "click", "keydown.enter", 4, "ngIf"], [1, "ex-note-title-wrapper"], ["class", "ex-note-title-icon", 3, "iconName", "size", "color", "tooltip", 4, "ngIf"], [1, "ex-note-title"], ["class", "ex-note-editable-text", 3, "text", "isTextArea", "hasBorder", "textAreaMaxLength", "autoFocus", "ariaDescription", "ariaLabel", "ariaRequired", "ariaErrorLabel", "editableTextSaved", "editableTextChanged", 4, "ngIf"], ["class", "ex-note-display-text", 3, "value", "type", "textAlign", "multipleLines", 4, "ngIf"], [3, "message", "confirmClicked", "cancelClicked", 4, "ngIf"], ["tabindex", "0", "role", "button", 3, "iconName", "tooltip", "size", "color", "click", "keydown.enter"], [1, "ex-note-title-icon", 3, "iconName", "size", "color", "tooltip"], [1, "ex-note-editable-text", 3, "text", "isTextArea", "hasBorder", "textAreaMaxLength", "autoFocus", "ariaDescription", "ariaLabel", "ariaRequired", "ariaErrorLabel", "editableTextSaved", "editableTextChanged"], [1, "ex-note-display-text", 3, "value", "type", "textAlign", "multipleLines"], [3, "message", "confirmClicked", "cancelClicked"]], template: function ExNoteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExNoteComponent_ex_svg_icon_1_Template, 3, 11, "ex-svg-icon", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, ExNoteComponent_ex_svg_icon_3_Template, 1, 4, "ex-svg-icon", 3);
            i0.ɵɵelementStart(4, "span", 4);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, ExNoteComponent_ex_editable_text_7_Template, 2, 11, "ex-editable-text", 5);
            i0.ɵɵtemplate(8, ExNoteComponent_ex_display_text_8_Template, 1, 4, "ex-display-text", 6);
            i0.ɵɵprojection(9);
            i0.ɵɵtemplate(10, ExNoteComponent_ex_confirmation_message_10_Template, 1, 1, "ex-confirmation-message", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵstyleProp("background", "linear-gradient(to left top, transparent 50%, #00000017 0) " + "no-repeat 100% 100% / 1em 1em, linear-gradient(315deg, transparent 0.7em," + ctx.color + " 0)");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly && !ctx.showConfirmation);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.noteIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, ctx.noteTitle));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isReadOnly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showConfirmation);
        } }, styles: [".ex-note[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:20px 20px 15px;position:relative;border:1px solid rgba(0,0,0,.0901960784);max-width:350px;border:none;filter:drop-shadow(0px 0px 1px rgba(0,0,0,.4784313725))}.ex-note[_ngcontent-%COMP%]   .ex-note-display-text[_ngcontent-%COMP%]{margin-inline-start:-10px}.ex-note[_ngcontent-%COMP%]   .ex-note-close-btn[_ngcontent-%COMP%]{position:absolute;top:10px;inset-inline-end:10px;display:none;cursor:pointer}.ex-note[_ngcontent-%COMP%]:hover   .ex-note-close-btn[_ngcontent-%COMP%], .ex-note[_ngcontent-%COMP%]:focus-within   .ex-note-close-btn[_ngcontent-%COMP%], .ex-note[_ngcontent-%COMP%]:focus   .ex-note-close-btn[_ngcontent-%COMP%]{display:inline}.ex-note[_ngcontent-%COMP%]   .ex-note-title-wrapper[_ngcontent-%COMP%]{display:flex;margin-bottom:7px;column-gap:5px}.ex-note[_ngcontent-%COMP%]   .ex-note-title-icon[_ngcontent-%COMP%]{margin-top:1px}.ex-note[_ngcontent-%COMP%]   .ex-note-editable-text[_ngcontent-%COMP%]     .ex-editable-text-wrapper{width:100%!important;padding-inline-start:0px!important}.ex-note[_ngcontent-%COMP%]   .ex-note-editable-text[_ngcontent-%COMP%]     .ex-editable-text-text-area-wrapper{width:100%!important;padding:0!important}.ex-note[_ngcontent-%COMP%]   .ex-note-editable-text[_ngcontent-%COMP%]     .ex-editable-text-editable-input-container{width:100%!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNoteComponent, [{
        type: Component,
        args: [{ selector: 'ex-note', host: {
                    '(valueChange)': 'controlOnChange($event)',
                    '(noteSaved)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExNoteComponent), template: "<div [style.background]=\"'linear-gradient(to left top, transparent 50%, #00000017 0) ' +\n      'no-repeat 100% 100% / 1em 1em, linear-gradient(315deg, transparent 0.7em,' + color + ' 0)'\" class=\"ex-note sel-note\">\n<ex-svg-icon tabindex=\"0\" role=\"button\" [attr.aria-label]=\"'ng.general.remove' | translate\"\n             *ngIf=\"!isReadOnly && !showConfirmation\" [class]=\"'ex-note-close-btn'\" [iconName]=\"'Delete'\"\n             (click)=\"onCloseClicked()\" (keydown.enter)=\"onCloseClicked()\" [tooltip]=\"'ng.general.remove' | translate\"\n             [size]=\"'small'\" [color]=\"'#2a5db0'\"></ex-svg-icon>\n<div class=\"ex-note-title-wrapper\">\n  <ex-svg-icon *ngIf=\"noteIcon\" class=\"ex-note-title-icon\" [iconName]=\"noteIcon?.iconName\" [size]=\"'small'\"\n               [color]=\"noteIcon?.iconColor\" [tooltip]=\"noteIcon?.tooltip\"></ex-svg-icon>\n  <span class=\"ex-note-title\">{{ noteTitle | translate }}</span>\n</div>\n<ex-editable-text *ngIf=\"!isReadOnly\" [text]=\"value || null\" [isTextArea]=\"true\" class=\"ex-note-editable-text\"\n                  (editableTextSaved)=\"onTextSaved($event)\" (editableTextChanged)=\"onTextChanged($event)\"\n                  [hasBorder]=\"false\"\n                    [textAreaMaxLength]=\"textAreaMaxLength\" [autoFocus]=\"autoFocus\"\n                    [ariaDescription]=\"ariaDescription\" [ariaLabel]=\"ariaLabel || (noteTitle | translate)\"\n                    [ariaRequired]=\"ariaRequired\" [ariaErrorLabel]=\"ariaErrorLabel\">\n</ex-editable-text>\n\n<ex-display-text *ngIf=\"isReadOnly\" class=\"ex-note-display-text\" [value]=\"value\" [type]=\"'text'\" [textAlign]=\"'start'\"\n                 [multipleLines]=\"true\">\n</ex-display-text>\n<ng-content></ng-content>\n\n<ex-confirmation-message *ngIf=\"showConfirmation\" [message]=\"confirmationMessage\"\n                         (confirmClicked)=\"onCloseConfirmation(true)\" (cancelClicked)=\"onCloseConfirmation(false)\">\n</ex-confirmation-message>\n\n</div>\n", styles: [".ex-note{display:flex;flex-direction:column;padding:20px 20px 15px;position:relative;border:1px solid rgba(0,0,0,.0901960784);max-width:350px;border:none;filter:drop-shadow(0px 0px 1px rgba(0,0,0,.4784313725))}.ex-note .ex-note-display-text{margin-inline-start:-10px}.ex-note .ex-note-close-btn{position:absolute;top:10px;inset-inline-end:10px;display:none;cursor:pointer}.ex-note:hover .ex-note-close-btn,.ex-note:focus-within .ex-note-close-btn,.ex-note:focus .ex-note-close-btn{display:inline}.ex-note .ex-note-title-wrapper{display:flex;margin-bottom:7px;column-gap:5px}.ex-note .ex-note-title-icon{margin-top:1px}.ex-note .ex-note-editable-text ::ng-deep .ex-editable-text-wrapper{width:100%!important;padding-inline-start:0px!important}.ex-note .ex-note-editable-text ::ng-deep .ex-editable-text-text-area-wrapper{width:100%!important;padding:0!important}.ex-note .ex-note-editable-text ::ng-deep .ex-editable-text-editable-input-container{width:100%!important}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { noteTitle: [{
            type: Input
        }], value: [{
            type: Input
        }], showConfirmation: [{
            type: Input
        }], confirmationMessage: [{
            type: Input
        }], textAreaMaxLength: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], closeConfirmation: [{
            type: Input
        }], noteIcon: [{
            type: Input
        }], color: [{
            type: Input
        }], closeClicked: [{
            type: Output
        }], showConfirmationChange: [{
            type: Output
        }], noteSaved: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], confirmButton: [{
            type: ViewChild,
            args: ["confirmButton"]
        }] }); })();

class FormLabels {
    constructor() {
        this.change = new ReplaySubject();
    }
    setLabels(labels) {
        this._labels = labels;
        this.change.next(this._labels);
    }
    get labels() {
        return this._labels;
    }
    onChanged() {
        return this.change.asObservable().pipe(map((x) => ({ ...x })));
    }
}

class ExFormErrorLabels extends FormLabels {
    set labels(labels) {
        this.setLabels(labels);
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExFormErrorLabels_BaseFactory; return function ExFormErrorLabels_Factory(t) { return (ɵExFormErrorLabels_BaseFactory || (ɵExFormErrorLabels_BaseFactory = i0.ɵɵgetInheritedFactory(ExFormErrorLabels)))(t || ExFormErrorLabels); }; }(); }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFormErrorLabels, selectors: [["ex-form", "formGroup", "", "formErrorLabels", ""], ["ex-form-dialog", "formGroup", "", "formErrorLabels", ""]], inputs: { labels: ["formErrorLabels", "labels"] }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormErrorLabels, [{
        type: Directive,
        args: [{ selector: 'ex-form[formGroup][formErrorLabels], ex-form-dialog[formGroup][formErrorLabels]' }]
    }], null, { labels: [{
            type: Input,
            args: ['formErrorLabels']
        }] }); })();

class ExSectionsLayoutSectionService {
    constructor(identifier, exSectionsLayoutService, exSectionsLayoutApmService) {
        this.identifier = identifier;
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.exSectionsLayoutApmService = exSectionsLayoutApmService;
        this.formRegistrationCount = 0;
    }
    setHasData(hasData) {
        this.exSectionsLayoutService.setHasDataByIdentifier(this.identifier, hasData);
    }
    setLoading(loading, hasAvatar = false) {
        this.exSectionsLayoutService.setLoadingByIdentifier(this.identifier, loading, hasAvatar);
        this.exSectionsLayoutApmService?.trackSectionLoading(this.identifier, loading);
    }
    setHeader(template) {
        this.exSectionsLayoutService.setHeaderByIdentifier(this.identifier, template);
    }
    setCount(count, additionalLabel, startIndex, endIndex) {
        this.exSectionsLayoutService.setCountByIdentifier(this.identifier, count, additionalLabel, startIndex, endIndex);
    }
    getIdentifier() {
        return this.identifier;
    }
    registerSectionForm(form, submitFunction, preSaveValidationFunction, controlsValidatorsIgnoreList, postSaveFunction) {
        let id = `${this.identifier}${SECTION_FORM_IDENTIFIER_DELIMITER}${this.formRegistrationCount}`;
        this.formRegistrationCount++;
        this.exSectionsLayoutService.registerSectionForm(id, form, submitFunction, preSaveValidationFunction, controlsValidatorsIgnoreList, postSaveFunction);
        return id;
    }
    setSectionFormFieldsNamesLabels(identifier, formFieldsNameLabels) {
        this.exSectionsLayoutService.setSectionFormFieldsNamesLabels(identifier, formFieldsNameLabels);
    }
    setSectionFormErrorLabels(identifier, formErrorLabels) {
        this.exSectionsLayoutService.setSectionFormErrorLabels(identifier, formErrorLabels);
    }
    unregisterSectionForm(identifier) {
        this.exSectionsLayoutService.unregisterSectionForm(identifier);
    }
    static { this.ɵfac = function ExSectionsLayoutSectionService_Factory(t) { return new (t || ExSectionsLayoutSectionService)(i0.ɵɵinject(EX_SECTION_IDENTIFIER), i0.ɵɵinject(ExSectionsLayoutService), i0.ɵɵinject(ExSectionsLayoutApmService, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSectionsLayoutSectionService, factory: ExSectionsLayoutSectionService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutSectionService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: ExSectionsLayoutService }, { type: ExSectionsLayoutApmService, decorators: [{
                type: Optional
            }] }]; }, null); })();

function ExFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.controlError), "\n");
} }
function ExFormComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r3.controlWarning), " ");
} }
function ExFormComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExFormComponent_ng_template_2_div_0_Template, 3, 3, "div", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.showWarnings);
} }
const _c0$1L = ["*"];
const DEFAULT_FORM_ERROR_LABELS = {
    nonPrimaryDirty: 'ng.single_save.non_primary_dirty'
};
const HAS_FORM_FIELDS_BORDERS = new InjectionToken('HAS_FORM_FIELDS_BORDERS');
class ExFormComponent {
    constructor(elRef, formErrorLabels, formParent, exSectionsLayoutSectionService, exSectionsLayoutService, exNavigateToFieldService, sectionId, quickAccessService, isLayoutSingleSave, cdr, rerender) {
        this.elRef = elRef;
        this.formErrorLabels = formErrorLabels;
        this.formParent = formParent;
        this.exSectionsLayoutSectionService = exSectionsLayoutSectionService;
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.exNavigateToFieldService = exNavigateToFieldService;
        this.sectionId = sectionId;
        this.quickAccessService = quickAccessService;
        this.isLayoutSingleSave = isLayoutSingleSave;
        this.cdr = cdr;
        this.rerender = rerender;
        this.role = 'form';
        this.hasFormFieldsBorders = true;
        this.errorLabels = {};
        this.formFieldsNameLabels = {};
        this.type = QuickAccessType.FIELD_EDIT;
        this.focusField = undefined;
        this.wasFocusedOut = false;
        this.subs = [];
    }
    ngOnInit() {
        this.errorLabels = { ...DEFAULT_FORM_ERROR_LABELS };
        this.initFormControl();
        this.initFormGroupListener();
        this.initFormErrorLabelsListener();
        this.subs.push(this.formParent?.statusChanges.subscribe(() => {
            this.cdr.markForCheck();
        }));
        this.subs.push(this.exNavigateToFieldService?.focusOnFormField$.subscribe((data) => {
            if (data.sectionId != this.sectionId)
                return;
            this.focusOnField(data.fieldId);
        }));
        this.focusoutUnlistener = this.rerender.listen(this.elRef.nativeElement, 'focusout', this.onFocusoutEvent.bind(this));
    }
    ngAfterContentInit() {
        this.initFormControlLabels();
    }
    initFormGroupListener() {
        if (ExFormGroupDirective.isExFormGroup(this.formParent)) {
            this.subs.push(this.formParent.exFormChanged$.subscribe(() => {
                const control = this.formParent.control;
                if (this.formControl === control) {
                    // TODO:
                }
                else {
                    this.formControl = control;
                    this.initFormControl();
                    this.initFormControlLabels();
                }
            }));
        }
    }
    initFormControl() {
        this.formControl = this.formParent?.control;
        if (this.exSectionsLayoutSectionService) {
            if (this._id)
                this.exSectionsLayoutSectionService.unregisterSectionForm(this._id);
            this._id = this.exSectionsLayoutSectionService.registerSectionForm(this.formParent.control, this.singleSave, this.singleSavePreSaveValidation, this.singleSaveFormControlsValidatorsIgnoreList, this.singleSavePostSave);
        }
    }
    initFormControlLabels() {
        this.formFieldsChangesSubscription && this.formFieldsChangesSubscription.unsubscribe();
        if (this.exSectionsLayoutSectionService) {
            this.formFieldsChangesSubscription = this.formFields.changes.pipe(startWith(this.formFields), filter$1(fields => fields.length > 0), map$1((fields) => this.getFormFieldNameLabels(fields)))
                .subscribe((formFieldsNameLabels) => {
                this.exSectionsLayoutSectionService.setSectionFormFieldsNamesLabels(this._id, formFieldsNameLabels);
                this.createQuickAccessMap(formFieldsNameLabels);
            });
        }
    }
    ngAfterViewInit() {
        this.subs.push(this.quickAccessService?.applyFocusOnFieldView.subscribe(data => {
            (this.isLayoutSingleSave && !this.exSectionsLayoutService.isEditMode()) && this.applyQuickAccessFocus(data, false);
        }));
        this.subs.push(this.quickAccessService?.applyFocus.subscribe(data => {
            (!this.isLayoutSingleSave || this.exSectionsLayoutService.isEditMode()) && this.applyQuickAccessFocus(data, true);
        }));
        this.subs.push(this.quickAccessService?.focusOut$.subscribe(event => this.onFocusOut(event)));
    }
    getFormFieldNameLabels(fields) {
        let formFieldsNameLabels = {};
        Object.keys(this.formControl?.getRawValue() ?? {}).forEach(controlName => {
            const field = fields.find((field) => field.controlName === controlName);
            if (field && !Array.isArray(field.controlName)) {
                formFieldsNameLabels[field.controlName] = field.getLabel();
                if (field.getLabel() == undefined && field.controlValueAccessor instanceof ExCheckboxComponent) {
                    formFieldsNameLabels[field.controlName] = field?.controlValueAccessor?.label;
                }
                if (field.getLabel() == undefined && field.controlValueAccessor instanceof ExNoteComponent) {
                    formFieldsNameLabels[field.controlName] = field?.controlValueAccessor?.noteTitle;
                }
            }
        });
        return formFieldsNameLabels;
    }
    ngOnDestroy() {
        (!this.isLayoutSingleSave || this.exSectionsLayoutService.isEditMode()) && this.removeQuickAccessMap();
        this.exSectionsLayoutSectionService?.unregisterSectionForm(this._id);
        this.subs?.forEach(sub => sub?.unsubscribe());
        this.formFieldsChangesSubscription && this.formFieldsChangesSubscription.unsubscribe();
        this.focusoutUnlistener();
    }
    get showErrors() {
        return this.isControlInvalid && !!this.errorLabels && this.wasFocusedOut;
    }
    get controlError() {
        const error = Object.keys(this.formParent?.errors ?? {})[0];
        return this.errorLabels?.[error];
    }
    get isControlInvalid() {
        return this.formParent?.invalid && (this.formParent.dirty || this.formParent.touched);
    }
    get showWarnings() {
        return this.controlHasWarnings && !this.isControlInvalid && !!this.errorLabels && this.wasFocusedOut;
    }
    get controlWarning() {
        const warning = Object.keys(this.formParent?.control?.[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {})[0];
        return this.errorLabels?.[warning];
    }
    get controlHasWarnings() {
        return Object.keys(this.formParent?.control?.[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {}).length > 0 && (this.formParent?.control.dirty || this.formParent?.control.touched);
    }
    initFormErrorLabelsListener() {
        this.subs.push(this.formErrorLabels?.onChanged().subscribe(labels => {
            this.errorLabels = { ...this.errorLabels, ...labels };
            this.exSectionsLayoutSectionService?.setSectionFormErrorLabels(this._id, { ...this.errorLabels });
            this.cdr.markForCheck();
        }));
    }
    onFocusoutEvent(e) {
        let cdkContainerIsOpen = Array.from(document.getElementsByClassName('cdk-overlay-container')).some(el => el.children.length > 0);
        if (!this.elRef.nativeElement.contains(e.relatedTarget) && !cdkContainerIsOpen) {
            this.wasFocusedOut = true;
            this.cdr.markForCheck();
        }
    }
    focusOnField(fieldId) {
        const field = this.formFields.find((field) => field.controlName === fieldId);
        field?.focus();
        this.cdr.markForCheck();
    }
    createQuickAccessMap(formFieldsNameLabels) {
        let type = (this.isLayoutSingleSave && !this.exSectionsLayoutService.isEditMode()) ? QuickAccessType.FIELD_VIEW : QuickAccessType.FIELD_EDIT;
        this.formFieldsNameLabels = formFieldsNameLabels;
        Object.values(formFieldsNameLabels).forEach(val => {
            this.quickAccessService?.updateData(val, type, false, this.sectionId);
        });
    }
    removeQuickAccessMap() {
        this.type == QuickAccessType.FIELD_EDIT && Object.values(this.formFieldsNameLabels).forEach(val => {
            this.quickAccessService?.removeKey(val, this.type);
        });
    }
    applyQuickAccessFocus(data, edit) {
        const entry = Object.entries(this.formFieldsNameLabels).find(([key, val]) => val === data.key);
        if (!entry || !entry[0])
            return;
        let fieldId = entry[0];
        edit = edit && this.checkIfFieldFocusable(fieldId);
        edit ? this.focusOnField(fieldId) : this.focusOnFieldView(fieldId);
    }
    focusOnFieldView(fieldId) {
        let i = this.formFields.toArray().findIndex(field => field.controlName === fieldId);
        this.focusField = this.formFieldsElements.find((field, index) => index == i);
        this.rerender.setStyle(this.focusField?.nativeElement, 'outline', '2px solid black');
        this.rerender.setStyle(this.focusField?.nativeElement, 'outline-offset', 'px');
        this.cdr.markForCheck();
    }
    checkIfFieldFocusable(fieldId) {
        const field = this.formFields.find((field) => field.controlName === fieldId);
        return !(field?.controlValueAccessor.disabled || (field?.controlValueAccessor instanceof ExDisplayTextComponent));
    }
    onFocusOut(event) {
        if (!this.focusField || this.focusField.nativeElement.contains(event.target))
            return;
        this.rerender.removeStyle(this.focusField?.nativeElement, 'outline');
        this.rerender.removeStyle(this.focusField?.nativeElement, 'outline-offset');
        this.focusField = undefined;
    }
    static { this.ɵfac = function ExFormComponent_Factory(t) { return new (t || ExFormComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ExFormErrorLabels, 10), i0.ɵɵdirectiveInject(i1$6.ControlContainer, 10), i0.ɵɵdirectiveInject(ExSectionsLayoutSectionService, 8), i0.ɵɵdirectiveInject(ExSectionsLayoutService, 8), i0.ɵɵdirectiveInject(EX_NAVIGATE_TO_FIELD, 8), i0.ɵɵdirectiveInject(EX_SECTION_IDENTIFIER, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS, 8), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFormComponent, selectors: [["ex-form"]], contentQueries: function ExFormComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExFormFieldComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, ExFormFieldComponent, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formFields = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formFieldsElements = _t);
        } }, hostAttrs: ["tabindex", "-1"], hostVars: 1, hostBindings: function ExFormComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
        } }, inputs: { singleSave: "singleSave", singleSavePreSaveValidation: "singleSavePreSaveValidation", singleSaveFormControlsValidatorsIgnoreList: "singleSaveFormControlsValidatorsIgnoreList", singleSavePostSave: "singleSavePostSave", hasFormFieldsBorders: "hasFormFieldsBorders" }, features: [i0.ɵɵProvidersFeature([{
                    provide: HAS_FORM_FIELDS_BORDERS,
                    useFactory: (exFormComponent) => {
                        return () => {
                            return exFormComponent.hasFormFieldsBorders;
                        };
                    },
                    deps: [ExFormComponent]
                }])], ngContentSelectors: _c0$1L, decls: 4, vars: 2, consts: [["class", "ex-form-errors", 4, "ngIf", "ngIfElse"], ["warnings", ""], [1, "ex-form-errors"], ["class", "ex-form-errors ex-form-warnings", 4, "ngIf"], [1, "ex-form-errors", "ex-form-warnings"]], template: function ExFormComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, ExFormComponent_div_1_Template, 3, 3, "div", 0);
            i0.ɵɵtemplate(2, ExFormComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showErrors)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgIf, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{flex:1}[_nghost-%COMP%]   .ex-form-errors[_ngcontent-%COMP%]{margin:10px 0 0 5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormComponent, [{
        type: Component,
        args: [{ selector: 'ex-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [{
                        provide: HAS_FORM_FIELDS_BORDERS,
                        useFactory: (exFormComponent) => {
                            return () => {
                                return exFormComponent.hasFormFieldsBorders;
                            };
                        },
                        deps: [ExFormComponent]
                    }], host: { tabindex: '-1' }, template: "<ng-content></ng-content>\n<div class=\"ex-form-errors\" *ngIf=\"showErrors; else warnings\">\n    {{ controlError | translate }}\n</div>\n<ng-template #warnings>\n    <div class=\"ex-form-errors ex-form-warnings\" *ngIf=\"showWarnings\">\n        {{ controlWarning | translate }}\n    </div>\n</ng-template>", styles: [":host{flex:1}:host .ex-form-errors{margin:10px 0 0 5px}\n"] }]
    }], function () { return [{ type: i0.ElementRef }, { type: ExFormErrorLabels, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: i1$6.ControlContainer, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: ExSectionsLayoutSectionService, decorators: [{
                type: Optional
            }] }, { type: ExSectionsLayoutService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_NAVIGATE_TO_FIELD]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], singleSave: [{
            type: Input
        }], singleSavePreSaveValidation: [{
            type: Input
        }], singleSaveFormControlsValidatorsIgnoreList: [{
            type: Input
        }], singleSavePostSave: [{
            type: Input
        }], hasFormFieldsBorders: [{
            type: Input
        }], formFields: [{
            type: ContentChildren,
            args: [forwardRef(() => ExFormFieldComponent), { descendants: true }]
        }], formFieldsElements: [{
            type: ContentChildren,
            args: [forwardRef(() => ExFormFieldComponent), { descendants: true, read: ElementRef }]
        }] }); })();

function ExFormFieldComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFormFieldComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFormFieldComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
const _c0$1K = function () { return {}; };
function ExFormFieldComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_0_0;
    let tmp_1_0;
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind2(1, 2, ctx_r1.controlError, (tmp_0_0 = ctx_r1.control == null ? null : ctx_r1.control.errors[ctx_r1.error].errorParams) !== null && tmp_0_0 !== undefined ? tmp_0_0 : i0.ɵɵpureFunction0(8, _c0$1K)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, ctx_r1.controlError, (tmp_1_0 = ctx_r1.control == null ? null : ctx_r1.control.errors[ctx_r1.error].errorParams) !== null && tmp_1_0 !== undefined ? tmp_1_0 : i0.ɵɵpureFunction0(9, _c0$1K)), " ");
} }
function ExFormFieldComponent_ng_template_7_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 2, ctx_r7.controlError));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r7.controlWarning), " ");
} }
function ExFormFieldComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExFormFieldComponent_ng_template_7_div_0_Template, 4, 6, "div", 8);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.showWarnings);
} }
function ExFormFieldComponent_ng_template_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r8.seperator, " ");
} }
function ExFormFieldComponent_ng_template_9_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function ExFormFieldComponent_ng_template_9_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", ctx_r10.hint);
} }
function ExFormFieldComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExFormFieldComponent_ng_template_9_ng_container_3_Template, 2, 1, "ng-container", 1);
    i0.ɵɵtemplate(4, ExFormFieldComponent_ng_template_9_span_4_Template, 2, 0, "span", 10);
    i0.ɵɵtemplate(5, ExFormFieldComponent_ng_template_9_div_5_Template, 2, 1, "div", 11);
    i0.ɵɵelementStart(6, "div", 12);
    i0.ɵɵprojection(7, 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 4, ctx_r5.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.labelPosition === "left");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5._disabled && ctx_r5.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r5.hint == null ? null : ctx_r5.hint.length) > 0);
} }
const _c1$18 = ["*", [["", "additional-label-content", ""]]];
const _c2$O = function (a0, a1) { return { "form-field-wrapper--changed": a0, "ex-form-field-highlight": a1 }; };
const _c3$E = ["*", "[additional-label-content]"];
const DEFAULT_ERROR_LABELS = {
    required: 'form.validation.required',
    pattern: 'form.validation.pattern',
    notfound: 'form.validation.notfound',
    maxlength: 'form.validation.maxlength',
    minlength: 'form.validation.minlength'
};
const EX_FORM_FIELD_LABEL = new InjectionToken('EX_FORM_FIELD_LABEL');
class ExFormFieldComponent {
    constructor(formErrorLabels, formParent, hasFormFieldsBorders, cdr, translateService, exFormGroupDirective) {
        this.formErrorLabels = formErrorLabels;
        this.formParent = formParent;
        this.hasFormFieldsBorders = hasFormFieldsBorders;
        this.cdr = cdr;
        this.translateService = translateService;
        this.exFormGroupDirective = exFormGroupDirective;
        /**
         * The position of the label in relation to the input element.
         * For a label positioned to the left of the input element, a seperator will be displayed between the label and the input element.
         * Default is 'above'.
         */
        this.labelPosition = 'above';
        /**
         * The separator displayed for label with position 'left'
         */
        this.seperator = ':';
        this.hasFormFieldBorder = true;
        this.changed = false;
        this.disabled = false;
        this.required = false;
        this.errorLabels = { ...DEFAULT_ERROR_LABELS };
        this.sub = new Subscription();
        this.controlSub = new Subscription();
        this._hasFormFieldsBorders = true;
        this.fieldFocus = false;
        this.formTouchedSub = new Subscription();
        this.initFormErrorLabelsListener();
        this.initFormGroupListener();
        this.initFormGroupDirectiveListener();
    }
    initFormErrorLabelsListener() {
        this.sub.add(this.formErrorLabels?.onChanged().subscribe(labels => {
            this.errorLabels = { ...this.errorLabels, ...labels };
            this.cdr.markForCheck();
        }));
    }
    initFormGroupListener() {
        if (ExFormGroupDirective.isExFormGroup(this.formParent)) {
            this.sub.add(this.formParent.exFormChanged$.subscribe(() => {
                if (!this.controlName)
                    return;
                const control = this.formParent.control.get(this.controlName);
                if (this.control === control) {
                    this.resetFlags();
                }
                else {
                    this.ngControl = null;
                    this.control = control;
                    this.initControl();
                }
            }));
            // @#@ markForCheck() on this.formParent.exFormUpdated$ redundant since the form control will be updated and will mark for check
        }
    }
    initFormGroupDirectiveListener() {
        if (this.exFormGroupDirective && ExFormGroupDirective.isExFormGroup(this.exFormGroupDirective)) {
            this.formTouchedSub = this.exFormGroupDirective?.exFormMarkedTouched$?.subscribe(() => {
                this.cdr.markForCheck();
            });
        }
    }
    ngAfterContentInit() {
        this.initControl();
        if (this.hasFormFieldsBorders) {
            this._hasFormFieldsBorders = this.hasFormFieldsBorders();
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.controlSub.unsubscribe();
        this.formTouchedSub?.unsubscribe();
    }
    get showErrors() {
        return this.isControlInvalid && !!this.errorLabels;
    }
    get _disabled() {
        return this.disabled;
    }
    get controlError() {
        this.error = Object.keys(this.control?.errors ?? {})[0];
        return this.errorLabels?.[`${this.controlName}.${this.error}`] ?? this.errorLabels?.[this.error];
    }
    get isControlInvalid() {
        return this.control?.invalid && (this.control.dirty || this.control.touched);
    }
    get showWarnings() {
        return this.controlHasWarnings && !this.isControlInvalid && !!this.errorLabels;
    }
    get controlWarning() {
        const warning = Object.keys(this.control?.[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {})[0];
        return this.errorLabels?.[`${this.controlName}.${warning}`] ?? this.errorLabels?.[warning];
    }
    get controlHasWarnings() {
        return Object.keys(this.control?.[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {}).length > 0 && (this.control.dirty || this.control.touched);
    }
    get hasLabel() {
        return this.label?.length > 0;
    }
    initControl() {
        this.control = this.ngControl?.control ?? this.control;
        this.controlName = this.ngControl?.name ?? this.controlName;
        if (!this.control)
            return;
        this.resetFlags();
        this.resetControlSubscription();
        this.setPropertiesToValueAccessor();
        this.patchControlSetValidatorsFunc();
        this.patchControlClearValidatorsFunc();
    }
    patchControlSetValidatorsFunc() {
        const originalSetControlValidatorsFunc = this.control.setValidators.bind(this.control);
        this.control.setValidators = (validators) => {
            originalSetControlValidatorsFunc(validators);
            this.setRequired();
            this.cdr.markForCheck();
        };
    }
    patchControlClearValidatorsFunc() {
        const originalClearControlValidatorsFunc = this.control.clearValidators.bind(this.control);
        this.control.clearValidators = () => {
            originalClearControlValidatorsFunc();
            ExFormUtil.clearControlWarnings(this.control);
            this.setRequired();
            this.cdr.markForCheck();
        };
    }
    resetFlags() {
        this.changed = this.control.dirty;
        this.disabled = this.control.disabled;
        this.setRequired();
        this.cdr.markForCheck();
    }
    setRequired() {
        const dummyControl = {};
        this.required = !!this.control.validator?.(dummyControl)?.required || !!dummyControl[EX_FORM_WARNINGS_PROPERTY_NAME]?.required;
    }
    resetControlSubscription() {
        this.controlSub.unsubscribe();
        this.controlSub = merge(this.control.statusChanges, this.control.valueChanges, this.controlValueAccessor.controlTouched$, this.formParent.exFormMarkedPristine$ ?? of()).pipe(debounceTime(100), tap(() => {
            this.disabled = this.control.disabled;
            this.changed = this.control.dirty && !this.isControlInvalid;
            this.setPropertiesToValueAccessor();
            this.controlValueAccessor.setValidState(!this.isControlInvalid);
            this.controlValueAccessor.setDisabledState(this.control.disabled);
            this.controlValueAccessor.setHasWarnings(ExFormUtil.controlHasWarnings(this.control));
            this.cdr.markForCheck();
        })).subscribe();
    }
    setPropertiesToValueAccessor() {
        // we don't want to override the properties from the element with empty value.
        if (!this.controlValueAccessor)
            return;
        this.setControlValueAccessorDescription();
        this.controlValueAccessor.setErrorMassage(this.getErrorLabel());
        this.controlValueAccessor.setRequired(this.getRequired());
        this.getLabel() && this.controlValueAccessor.setLabel(this.getLabel());
    }
    setControlValueAccessorDescription() {
        let desc = this.getDescription();
        if (ExFormUtil.controlHasWarnings(this.control))
            desc = `${desc ? `${desc}'. '` : ''}${this.translateService.instant(this.controlWarning)}${'.'}`;
        desc && this.controlValueAccessor.setAriaDescription(desc);
    }
    getDescription() {
        return this.hint;
    }
    getErrorLabel() {
        return this.controlError;
    }
    getLabel() {
        return this.label;
    }
    getRequired() {
        return this.required;
    }
    ngOnChanges(changes) {
        if (changes.label || changes.hint) {
            this.setPropertiesToValueAccessor();
        }
    }
    focus() {
        this.fieldFocus = true;
        this.cdr.markForCheck();
        this.controlValueAccessor.fieldFocus();
        setTimeout(() => {
            this.fieldFocus = false;
            this.cdr.markForCheck();
        }, 1000);
    }
    static { this.ɵfac = function ExFormFieldComponent_Factory(t) { return new (t || ExFormFieldComponent)(i0.ɵɵdirectiveInject(ExFormErrorLabels, 12), i0.ɵɵdirectiveInject(i1$6.ControlContainer, 13), i0.ɵɵdirectiveInject(HAS_FORM_FIELDS_BORDERS, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExFormGroupDirective, 13)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFormFieldComponent, selectors: [["ex-form-field"]], contentQueries: function ExFormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExControlValueAccessor, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.controlValueAccessor = _t.first);
        } }, hostVars: 2, hostBindings: function ExFormFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("column-span", ctx.isFullWidth && "all");
        } }, inputs: { label: "label", hint: "hint", labelPosition: "labelPosition", seperator: "seperator", hasFormFieldBorder: "hasFormFieldBorder", isFullWidth: "isFullWidth" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false }]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3$E, decls: 11, vars: 16, consts: [[1, "form-field-wrapper", 3, "ngClass"], [4, "ngIf"], [1, "ex-form-field-error-wrapper"], ["class", "form-field-error", 3, "exTooltip", 4, "ngIf", "ngIfElse"], ["warnings", ""], ["labelTemplate", ""], [4, "ngTemplateOutlet"], [1, "form-field-error", 3, "exTooltip"], ["class", "form-field-error", 3, "exTooltip", 4, "ngIf"], [1, "form-field-label"], ["style", "color: red", 4, "ngIf"], ["class", "form-field-help", 3, "exTooltip", 4, "ngIf"], [1, "additional-label-content"], [2, "color", "red"], [1, "form-field-help", 3, "exTooltip"], [1, "uxf-icon", "uxf-info-circle"]], template: function ExFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$18);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExFormFieldComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div");
            i0.ɵɵpipe(4, "generateHTMLId");
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, ExFormFieldComponent_div_6_Template, 4, 10, "div", 3);
            i0.ɵɵtemplate(7, ExFormFieldComponent_ng_template_7_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, ExFormFieldComponent_ng_template_9_Template, 8, 6, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(8);
            i0.ɵɵclassMap(ctx.hasLabel ? "form-field-wrapper--" + ctx.labelPosition : "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c2$O, ctx.changed, ctx.fieldFocus));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("ex-form-field-content-wrapper ", ctx.label && ctx.label.indexOf(".") ? i0.ɵɵpipeBind1(4, 11, ctx.label) : "", "");
            i0.ɵɵclassProp("ex-form-field-border", ctx._hasFormFieldsBorders && ctx.hasFormFieldBorder);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showErrors)("ngIfElse", _r2);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, ExTooltipDirective, ExGenerateIdPipe, i1$2.TranslatePipe], styles: [".form-field-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;flex-direction:column}.form-field-wrapper[_ngcontent-%COMP%]     .ex-radio-buttons-wrapper{margin-inline-start:10px;min-height:32px}.form-field-wrapper[_ngcontent-%COMP%]     .ex-checkbox-wrapper{margin-inline-start:10px;min-height:33px}.form-field-wrapper.form-field-wrapper--above[_ngcontent-%COMP%]{min-height:53px;padding-inline-start:2px}.form-field-wrapper.form-field-wrapper--above[_ngcontent-%COMP%]   .form-field-label[_ngcontent-%COMP%]{min-width:unset;max-width:unset;margin-inline-start:5px;margin-bottom:0!important;padding-inline-start:5px}.form-field-wrapper.form-field-wrapper--above[_ngcontent-%COMP%] >   ex-checkbox{padding:5px 15px}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]{flex-direction:row;min-height:32px;justify-content:space-between}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]   .form-field-label[_ngcontent-%COMP%]{margin-inline-end:5px;margin-top:7px;padding-inline-start:5px;align-self:center;display:flex}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]   .ex-form-field-error-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]   .ex-form-field-error-wrapper[_ngcontent-%COMP%]   .ex-form-field-content-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;min-height:32px;justify-content:space-between}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]   .ex-form-field-error-wrapper[_ngcontent-%COMP%]   .form-field-error[_ngcontent-%COMP%]{text-align:end}.form-field-wrapper.form-field-wrapper--left[_ngcontent-%COMP%]   .ex-form-field-error-wrapper[_ngcontent-%COMP%]   ex-editable-text[_ngcontent-%COMP%]{display:flex}.form-field-wrapper.form-field-wrapper--right[_ngcontent-%COMP%]{flex-direction:row-reverse;justify-content:flex-end;min-height:32px;align-items:center}.form-field-wrapper.form-field-wrapper--right[_ngcontent-%COMP%]   .form-field-label[_ngcontent-%COMP%]{margin-inline-start:5px!important;margin-top:6px;align-self:center}.form-field-label[_ngcontent-%COMP%]{white-space:auto;min-width:-moz-fit-content;min-width:fit-content;margin-inline-start:5px;margin-inline-start:0px!important;padding-inline-start:0px!important}.form-field-wrapper[_ngcontent-%COMP%]:not(.form-field-wrapper--left){position:relative;width:100%;padding-inline-start:2px}.form-field-wrapper[_ngcontent-%COMP%]:not(.form-field-wrapper--left)   .form-field-error[_ngcontent-%COMP%]{position:absolute;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%}.form-field-help[_ngcontent-%COMP%]{display:inline-block;font-size:.8em;color:#999;cursor:pointer;margin:0 5px}.form-field-help[_ngcontent-%COMP%]:hover{color:#7a7a7a}.form-field-help[_ngcontent-%COMP%] > i.uxf-icon[_ngcontent-%COMP%]{vertical-align:top}.additional-label-content[_ngcontent-%COMP%]{display:inline-block;padding-inline-start:5px}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;min-height:35px;border-radius:3px}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper.alma-combobox-readonly{border:none!important;background:#e7eaeb}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper:not(.alma-combobox-disabled):not(.alma-combobox-readonly):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper.alma-combobox-not-valid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper ex-new-combobox:not(:only-child){max-width:calc(100% - 40px)!important}.ex-form-field-border[_ngcontent-%COMP%]     .alma-combobox-wrapper ex-new-combobox:first-child:nth-last-child(3){max-width:calc(100% - 40px)!important}.ex-form-field-border[_ngcontent-%COMP%]    >ex-new-combobox   .ex-combobox-button{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px}.ex-form-field-border[_ngcontent-%COMP%]    >ex-new-combobox   .ex-combobox-button:not(.ex-combobox-button-disabled):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]    >ex-new-combobox   .ex-combobox-button:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]    >ex-new-combobox   .ex-combobox-button:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]    >ex-new-combobox   .ex-combobox-button.ex-combobox-not-valid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper.ex-editable-text-readonly{border:none!important;background:#e7eaeb}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:not(.ex-editable-text-invalid):not(.ex-editable-text-no-border):not(.ex-editable-text-readonly){border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:not(.ex-editable-text-invalid):not(.ex-editable-text-disabled):not(.ex-editable-text-readonly):not(:focus-within):hover:not(.ex-editable-text-no-border){border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper.ex-editable-text-disabled{background:#e9ecef!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper.ex-editable-text-invalid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-editable-text-editable-input-container{justify-content:space-between!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-editable-text-editable-input-container .ex-editable-text-button-edit{visibility:hidden}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-editable-text-editable-input-container .ex-editable-text-button-container{margin-inline-end:5px}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:not(.ex-editable-text-disabled):not(.ex-editable-text-readonly):not(:focus-within):hover:not(.ex-editable-text-no-border){background:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:focus-within:not(.ex-editable-text-no-border):not(.ex-editable-text-invalid){border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;transition:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:focus:not(.ex-editable-text-no-border):not(.ex-editable-text-invalid){border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;transition:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-display-text-value{padding:0 10px!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper:hover .ex-editable-text-button-aligned-center{visibility:hidden!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-editable-text-text-area-wrapper{width:100%!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-editable-text-wrapper .ex-editable-text-input{width:100%!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-display-text-wrapper .ex-display-text-value{padding:0}.ex-form-field-border[_ngcontent-%COMP%]     .ex-display-text-wrapper .ex-display-text-value-text{color:#000!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-combobox-button{transition:none!important;width:100%!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-combobox-button:enabled:hover{background:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-combobox-button:focus-within{outline:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-combobox-button.ex-combobox-button-disabled{background:#e9ecef!important;color:inherit;opacity:.5}.ex-form-field-border[_ngcontent-%COMP%]     .ex-combobox-button.ex-combobox-not-valid{border:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper{border-radius:3px}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-invalid){border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-invalid):hover{background-color:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-invalid):hover:not(.ex-date-picker-readonly){border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-invalid):focus-within{border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;outline:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper.ex-date-picker-invalid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper.ex-date-picker-hover{background-color:#fff!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper .ex-date-picker-hover{background-color:#fff!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper .ex-date-picker-input{border:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-readonly) .ex-date-picker-clear{margin-inline-start:auto}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper:not(.ex-date-picker-readonly) .ex-date-picker-clear.ex-date-picker-clear-hidden{display:initial!important;visibility:hidden}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper.ex-date-picker-readonly mat-datepicker-toggle{display:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper.ex-date-picker-readonly ex-icon{display:none!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-date-picker-wrapper .ex-display-text-value{padding:0 10px!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-checkbox-wrapper{margin-inline-start:0px!important;height:auto;display:flex;align-content:center;align-items:center;border-radius:3px;padding-top:6px!important;margin-top:2px}.ex-form-field-border[_ngcontent-%COMP%]     .ex-checkbox-wrapper label{margin-bottom:0!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-new-combobox ex-combobox-trigger{width:92%!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-new-combobox ex-combobox-trigger .ex-combobox-trigger-selected-value{white-space:nowrap!important}.ex-form-field-border[_ngcontent-%COMP%]     .ex-radio-buttons-wrapper{margin-inline-start:0px!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-combobox   .ex-combobox-button{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px;width:100%!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-combobox   .ex-combobox-button:not(:disabled):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-combobox   .ex-combobox-button:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-combobox   .ex-combobox-button:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border[_ngcontent-%COMP%]     ex-combobox.ng-invalid   .ex-combobox-button{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormFieldComponent, [{
        type: Component,
        args: [{ selector: 'ex-form-field', changeDetection: ChangeDetectionStrategy.OnPush, providers: [{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false }], host: {
                    '[style.columnSpan]': 'isFullWidth && "all"',
                }, template: "<div class=\"form-field-wrapper\"\n     [ngClass]=\"{  'form-field-wrapper--changed': changed , 'ex-form-field-highlight': fieldFocus}\"\n     [class]=\"hasLabel ? ('form-field-wrapper--' + labelPosition) : ''\">\n  <ng-container *ngIf=\"hasLabel\">\n    <ng-container *ngTemplateOutlet=\"labelTemplate\">\n    </ng-container>\n  </ng-container>\n  <div class=\"ex-form-field-error-wrapper\">\n    <div class=\"ex-form-field-content-wrapper {{label && label.indexOf('.') ? (label | generateHTMLId) : ''}}\"\n         [class.ex-form-field-border]=\"_hasFormFieldsBorders && hasFormFieldBorder\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"form-field-error\" *ngIf=\"showErrors; else warnings\" [exTooltip]=\"controlError | translate:control?.errors[error].errorParams ?? {}\">\n      {{ controlError | translate:control?.errors[error].errorParams ?? {} }}\n    </div>\n    <ng-template #warnings>\n      <div class=\"form-field-error\" *ngIf=\"showWarnings\" [exTooltip]=\"controlError | translate\">\n        {{ controlWarning | translate }}\n      </div>\n    </ng-template>\n  </div>\n</div>\n\n<ng-template #labelTemplate>\n  <label class=\"form-field-label\">{{label | translate}}<ng-container *ngIf=\"labelPosition === 'left'\">{{seperator}}\n    </ng-container>\n    <span style=\"color: red\" *ngIf=\"!_disabled && required\">*</span>\n    <div class=\"form-field-help\" *ngIf=\"hint?.length > 0\" [exTooltip]=\"hint\">\n      <i class=\"uxf-icon uxf-info-circle\"></i>\n    </div>\n    <div class=\"additional-label-content\">\n      <ng-content select=\"[additional-label-content]\"></ng-content>\n    </div>\n  </label>\n</ng-template>\n", styles: [".form-field-wrapper{width:100%;display:flex;flex-direction:column}.form-field-wrapper ::ng-deep .ex-radio-buttons-wrapper{margin-inline-start:10px;min-height:32px}.form-field-wrapper ::ng-deep .ex-checkbox-wrapper{margin-inline-start:10px;min-height:33px}.form-field-wrapper.form-field-wrapper--above{min-height:53px;padding-inline-start:2px}.form-field-wrapper.form-field-wrapper--above .form-field-label{min-width:unset;max-width:unset;margin-inline-start:5px;margin-bottom:0!important;padding-inline-start:5px}.form-field-wrapper.form-field-wrapper--above>::ng-deep ex-checkbox{padding:5px 15px}.form-field-wrapper.form-field-wrapper--left{flex-direction:row;min-height:32px;justify-content:space-between}.form-field-wrapper.form-field-wrapper--left .form-field-label{margin-inline-end:5px;margin-top:7px;padding-inline-start:5px;align-self:center;display:flex}.form-field-wrapper.form-field-wrapper--left .ex-form-field-error-wrapper{display:flex;flex-direction:column;flex:1}.form-field-wrapper.form-field-wrapper--left .ex-form-field-error-wrapper .ex-form-field-content-wrapper{display:flex;flex-direction:row;min-height:32px;justify-content:space-between}.form-field-wrapper.form-field-wrapper--left .ex-form-field-error-wrapper .form-field-error{text-align:end}.form-field-wrapper.form-field-wrapper--left .ex-form-field-error-wrapper ex-editable-text{display:flex}.form-field-wrapper.form-field-wrapper--right{flex-direction:row-reverse;justify-content:flex-end;min-height:32px;align-items:center}.form-field-wrapper.form-field-wrapper--right .form-field-label{margin-inline-start:5px!important;margin-top:6px;align-self:center}.form-field-label{white-space:auto;min-width:-moz-fit-content;min-width:fit-content;margin-inline-start:5px;margin-inline-start:0px!important;padding-inline-start:0px!important}.form-field-wrapper:not(.form-field-wrapper--left){position:relative;width:100%;padding-inline-start:2px}.form-field-wrapper:not(.form-field-wrapper--left) .form-field-error{position:absolute;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%}.form-field-help{display:inline-block;font-size:.8em;color:#999;cursor:pointer;margin:0 5px}.form-field-help:hover{color:#7a7a7a}.form-field-help>i.uxf-icon{vertical-align:top}.additional-label-content{display:inline-block;padding-inline-start:5px}.ex-form-field-border ::ng-deep .alma-combobox-wrapper{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;min-height:35px;border-radius:3px}.ex-form-field-border ::ng-deep .alma-combobox-wrapper.alma-combobox-readonly{border:none!important;background:#e7eaeb}.ex-form-field-border ::ng-deep .alma-combobox-wrapper:not(.alma-combobox-disabled):not(.alma-combobox-readonly):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep .alma-combobox-wrapper:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep .alma-combobox-wrapper:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep .alma-combobox-wrapper.alma-combobox-not-valid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border ::ng-deep .alma-combobox-wrapper ex-new-combobox:not(:only-child){max-width:calc(100% - 40px)!important}.ex-form-field-border ::ng-deep .alma-combobox-wrapper ex-new-combobox:first-child:nth-last-child(3){max-width:calc(100% - 40px)!important}.ex-form-field-border ::ng-deep>ex-new-combobox ::ng-deep .ex-combobox-button{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px}.ex-form-field-border ::ng-deep>ex-new-combobox ::ng-deep .ex-combobox-button:not(.ex-combobox-button-disabled):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep>ex-new-combobox ::ng-deep .ex-combobox-button:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep>ex-new-combobox ::ng-deep .ex-combobox-button:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep>ex-new-combobox ::ng-deep .ex-combobox-button.ex-combobox-not-valid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper.ex-editable-text-readonly{border:none!important;background:#e7eaeb}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:not(.ex-editable-text-invalid):not(.ex-editable-text-no-border):not(.ex-editable-text-readonly){border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:not(.ex-editable-text-invalid):not(.ex-editable-text-disabled):not(.ex-editable-text-readonly):not(:focus-within):hover:not(.ex-editable-text-no-border){border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper.ex-editable-text-disabled{background:#e9ecef!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper.ex-editable-text-invalid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-editable-input-container{justify-content:space-between!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-editable-input-container .ex-editable-text-button-edit{visibility:hidden}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-editable-input-container .ex-editable-text-button-container{margin-inline-end:5px}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:not(.ex-editable-text-disabled):not(.ex-editable-text-readonly):not(:focus-within):hover:not(.ex-editable-text-no-border){background:none!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:focus-within:not(.ex-editable-text-no-border):not(.ex-editable-text-invalid){border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;transition:none!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:focus:not(.ex-editable-text-no-border):not(.ex-editable-text-invalid){border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;transition:none!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-display-text-value{padding:0 10px!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper:hover .ex-editable-text-button-aligned-center{visibility:hidden!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-text-area-wrapper{width:100%!important}.ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-input{width:100%!important}.ex-form-field-border ::ng-deep .ex-display-text-wrapper .ex-display-text-value{padding:0}.ex-form-field-border ::ng-deep .ex-display-text-wrapper .ex-display-text-value-text{color:#000!important}.ex-form-field-border ::ng-deep .ex-combobox-button{transition:none!important;width:100%!important}.ex-form-field-border ::ng-deep .ex-combobox-button:enabled:hover{background:none!important}.ex-form-field-border ::ng-deep .ex-combobox-button:focus-within{outline:none!important}.ex-form-field-border ::ng-deep .ex-combobox-button.ex-combobox-button-disabled{background:#e9ecef!important;color:inherit;opacity:.5}.ex-form-field-border ::ng-deep .ex-combobox-button.ex-combobox-not-valid{border:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper{border-radius:3px}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-invalid){border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-invalid):hover{background-color:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-invalid):hover:not(.ex-date-picker-readonly){border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-invalid):focus-within{border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important;outline:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper.ex-date-picker-invalid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper.ex-date-picker-hover{background-color:#fff!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper .ex-date-picker-hover{background-color:#fff!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper .ex-date-picker-input{border:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-readonly) .ex-date-picker-clear{margin-inline-start:auto}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper:not(.ex-date-picker-readonly) .ex-date-picker-clear.ex-date-picker-clear-hidden{display:initial!important;visibility:hidden}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper.ex-date-picker-readonly mat-datepicker-toggle{display:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper.ex-date-picker-readonly ex-icon{display:none!important}.ex-form-field-border ::ng-deep .ex-date-picker-wrapper .ex-display-text-value{padding:0 10px!important}.ex-form-field-border ::ng-deep .ex-checkbox-wrapper{margin-inline-start:0px!important;height:auto;display:flex;align-content:center;align-items:center;border-radius:3px;padding-top:6px!important;margin-top:2px}.ex-form-field-border ::ng-deep .ex-checkbox-wrapper label{margin-bottom:0!important}.ex-form-field-border ::ng-deep ex-new-combobox ex-combobox-trigger{width:92%!important}.ex-form-field-border ::ng-deep ex-new-combobox ex-combobox-trigger .ex-combobox-trigger-selected-value{white-space:nowrap!important}.ex-form-field-border ::ng-deep .ex-radio-buttons-wrapper{margin-inline-start:0px!important}.ex-form-field-border ::ng-deep ex-combobox ::ng-deep .ex-combobox-button{border:1px solid #ccc!important;box-shadow:0 0 0 1px transparent!important;border-radius:3px;width:100%!important}.ex-form-field-border ::ng-deep ex-combobox ::ng-deep .ex-combobox-button:not(:disabled):not(:focus-within):hover{border:1px solid #898989!important;box-shadow:0 0 0 1px transparent!important}.ex-form-field-border ::ng-deep ex-combobox ::ng-deep .ex-combobox-button:focus{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep ex-combobox ::ng-deep .ex-combobox-button:focus-within{outline:none!important;border:1px solid rgba(14,123,186,.9803921569)!important;box-shadow:0 0 0 1px #0e7bbafa!important}.ex-form-field-border ::ng-deep ex-combobox.ng-invalid ::ng-deep .ex-combobox-button{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}\n"] }]
    }], function () { return [{ type: ExFormErrorLabels, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: i1$6.ControlContainer, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [HAS_FORM_FIELDS_BORDERS]
            }] }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }, { type: ExFormGroupDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }]; }, { controlValueAccessor: [{
            type: ContentChild,
            args: [ExControlValueAccessor]
        }], label: [{
            type: Input
        }], hint: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], seperator: [{
            type: Input
        }], hasFormFieldBorder: [{
            type: Input
        }], isFullWidth: [{
            type: Input
        }] }); })();

const SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT = {
    title: "ng.single_save.save_confirmation_title",
    message: "ng.single_save.save_confirmation_message",
    negativeLabel: "ng.general.cancel",
    positiveLabel: "ng.general.save",
    list: [],
    confirmation: "ng.single_save.save_confirmation_confirmation",
    type: "info",
    displayAlways: false,
};
const SECTION_FORM_IDENTIFIER_DELIMITER = '#';
const SINGLE_SAVE_FORM_CONTROL_VALIDATION_ERROR_LABEL_PREFIX = 'single_save_form_control_validation_error_label';
const SCROLLING_ELEMENT_SELECTOR = 'ex-sections-layout-section-wrapper';
class ExSectionsLayoutService {
    constructor(exSectionsLayoutListLayoutService, dialog, translate) {
        this.exSectionsLayoutListLayoutService = exSectionsLayoutListLayoutService;
        this.dialog = dialog;
        this.translate = translate;
        this.headers = {};
        this.sections = [];
        this.sectionsHasData = {};
        this.openedFormsBySections = {};
        this.openCloseSectionsState = {};
        this.sectionComboboxListChanged = new Subject();
        this.sectionComboboxListChanged$ = this.sectionComboboxListChanged.asObservable();
        this.sectionListChanged = new Subject();
        this.sectionListChanged$ = this.sectionListChanged.asObservable();
        this.sectionSelected = new Subject();
        this.sectionSelected$ = this.sectionSelected.asObservable();
        this.scrolledToSection = new Subject();
        this.scrolledToSection$ = this.scrolledToSection.asObservable();
        this.sectionsHasDataChanged = new Subject();
        this.sectionsHasDataChanged$ = this.sectionsHasDataChanged.asObservable();
        this.sectionsLoadingChanged = new Subject();
        this.sectionsLoadingChanged$ = this.sectionsLoadingChanged.asObservable();
        this.sectionsHeaderChanged = new Subject();
        this.sectionsHeaderChanged$ = this.sectionsHeaderChanged.asObservable();
        this.sectionsCountChanged = new Subject();
        this.sectionsCountChanged$ = this.sectionsCountChanged.asObservable();
        this.sectionsValidChanged = new Subject();
        this.sectionsValidChanged$ = this.sectionsValidChanged.asObservable();
        this.openedFormsChanged = new Subject();
        this.openedFormsChanged$ = this.openedFormsChanged.asObservable();
        this.sectionsFormsStateChange = new BehaviorSubject({});
        this.sectionsFormsStateChange$ = this.sectionsFormsStateChange.asObservable();
        this.saveAllSections = new Subject();
        this.saveAllSections$ = this.saveAllSections.asObservable();
        this.singleSaveComplete = new Subject(); // value is true if single save completed successfully, false if completed unsuccessfully or aborted
        this.singleSaveComplete$ = this.singleSaveComplete.asObservable();
        this.cancelAllSections = new Subject();
        this.cancelAllSections$ = this.cancelAllSections.asObservable();
        this.sectionsEditMode = new BehaviorSubject(false);
        this.sectionsEditMode$ = this.sectionsEditMode.asObservable();
        this.sectionsLayoutViewMode = new Subject();
        this.sectionsLayoutViewMode$ = this.sectionsLayoutViewMode.asObservable();
        this.sectionsLayoutInitialized = new Subject();
        this.sectionsLayoutInitialized$ = this.sectionsLayoutInitialized.asObservable();
        // used to open snackbar messages via AlmaSectionsLayoutComponent since cannot use snackbar service directly
        this.snackbarMessages = new Subject();
        this.snackbarMessages$ = this.snackbarMessages.asObservable();
        this.subs = new Subscription();
        this.formSubs = {};
        this.sectionsFormsFieldsNameLabels = {};
        this.sectionsFormsErrorLabels = {};
        this.isSingleSave = false;
        this.singleSaveInProgress = false;
        this.FORM_WARNING_CODE_NON_PRIMARY_DIRTY = "nonPrimaryDirty";
        this.fieldsNavigationMap = new Map();
        this.notifyFormStatusChange = debounce(() => {
            this.sectionsFormsStateChange.next(this.getFormsState());
        }, 200);
        this.sectionListChanged.subscribe(sections => {
            this.sections = sections;
        });
    }
    ngOnDestroy() {
        this.sectionComboboxListChanged.complete();
        this.sectionListChanged.complete();
        this.sectionSelected.complete();
        this.sectionsHasDataChanged.complete();
        this.sectionsLoadingChanged.complete();
        this.subs.unsubscribe();
        this.unsubscribeAllFormsSubscriptions();
        this.observer && this.observer.disconnect();
    }
    changeSectionsComboboxList(sectionsList) {
        this.sectionComboboxListChanged.next(sectionsList);
    }
    getSectionTitle(identifier) {
        return this.translate.instant(this.sections.find(section => section.exIdentifier == identifier)?.title ||
            ('ng.general.section.title.' + identifier));
    }
    changeSectionsList(sectionsList) {
        this.sectionListChanged.next(sectionsList);
    }
    updateScrollLocation(s) {
        this.scrolledToSection.next(s);
    }
    selectSection(identifier, selector = SCROLLING_ELEMENT_SELECTOR) {
        this.observer = new MutationObserver((mutations, obs) => {
            const rightSideElem = document.getElementsByClassName(selector);
            if (rightSideElem.length) {
                obs.disconnect();
                const sectionSelectedAndClearInterval = () => {
                    if (this.sections.findIndex((section) => section.exIdentifier == identifier) > -1) {
                        this.sectionSelected.next(identifier);
                        clearInterval(interval);
                        interval = null;
                    }
                };
                let interval = setInterval(sectionSelectedAndClearInterval, 750);
                setTimeout(sectionSelectedAndClearInterval);
                // Sets max time for the interval to run
                setTimeout(() => clearInterval(interval), 10 * 1000);
            }
        });
        this.observer.observe(document, {
            childList: true,
            subtree: true
        });
    }
    setHasDataByIdentifier(identifier, hasData) {
        if (hasData) {
            this.setValidByIdentifier(identifier, true);
        }
        this.sectionsHasData[identifier] = hasData;
        this.sectionsHasDataChanged.next({ identifier, hasData });
    }
    setLoadingByIdentifier(identifier, loading, hasAvatar = false) {
        this.sectionsLoadingChanged.next({ identifier, loading, hasAvatar });
    }
    setHeaderByIdentifier(identifier, template) {
        this.sectionsHeaderChanged.next({ identifier, template });
    }
    setCountByIdentifier(identifier, count, additionalLabel, startIndex, endIndex) {
        this.sectionsCountChanged.next({ identifier, count, additionalLabel, startIndex, endIndex });
    }
    setValidByIdentifier(identifier, valid) {
        this.sectionsValidChanged.next({ identifier, valid });
    }
    validateSections(markSections = true) {
        const errors = [];
        this.sections.forEach(section => {
            const { exIdentifier, isMandatory } = section;
            if (isMandatory && this.sectionsHasData[exIdentifier] === false) {
                errors.push(exIdentifier);
                if (markSections) {
                    this.setValidByIdentifier(exIdentifier, false);
                }
            }
            else {
                if (markSections) {
                    this.setValidByIdentifier(exIdentifier, true);
                }
            }
        });
        return errors;
    }
    clearErrors() {
        this.sections.forEach(section => {
            const { exIdentifier } = section;
            this.setValidByIdentifier(exIdentifier, true);
        });
    }
    cleanData() {
        this.headers = {};
        this.sections = [];
        this.sectionsHasData = {};
        this.openedFormsBySections = {};
        this.resetSectionsEdit();
    }
    setIsSingleSave(isSingleSave) {
        this.isSingleSave = isSingleSave;
    }
    getIsSingleSave() {
        return this.isSingleSave;
    }
    setSingleSaveUpdateFunctionRetriever(updateFuncFactory) {
        this.singleSaveUpdateFunctionRetriever = updateFuncFactory;
    }
    setSingleSavePreSaveValidationFunction(validationFunction) {
        this.singleSavePreSaveValidationFunction = validationFunction;
    }
    setSingleSavePostSaveFunction(postSaveFunction) {
        this.singleSavePostSaveFunction = postSaveFunction;
    }
    initSectionsLayoutViewModeSubject(obs) {
        this.subs.add(obs.subscribe(viewMode => this.sectionsLayoutViewMode.next(viewMode)));
    }
    notifySectionsLayoutInitialized() {
        this.sectionsLayoutInitialized.next();
    }
    isEditMode() {
        return this.sectionsEditMode.getValue();
    }
    registerSectionForm(identifier, form, submitFunction, preSaveValidationFunction, controlsValidatorsIgnoreList, postSaveFunction) {
        this.sectionsForms[identifier] = {
            form: form,
            submitFunction: submitFunction,
            preSaveValidationFunction: preSaveValidationFunction,
            formControlsValidatorsIgnoreList: controlsValidatorsIgnoreList,
            postSaveFunction: postSaveFunction
        };
        this.initFormSubscriptions(identifier, form);
        if (this.isSingleSave && !submitFunction)
            this.addNonPrimaryEntityDirtyValidator(form);
        this.notifyFormStatusChange();
    }
    initFormSubscriptions(identifier, form) {
        if (this.formSubs[identifier])
            this.unsubscribeFormSubscriptions(identifier);
        this.formSubs[identifier] ??= new Subscription();
        this.formSubs[identifier].add(merge(form.statusChanges, form.valueChanges, form['formGroupObservables']?.['exFormMarkedTouched'] ?? EMPTY).subscribe(() => this.notifyFormStatusChange()));
    }
    setSectionFormFieldsNamesLabels(identifier, formFieldsNameLabels) {
        this.sectionsFormsFieldsNameLabels[identifier] = formFieldsNameLabels;
    }
    setSectionFormErrorLabels(identifier, formErrorLabels) {
        this.sectionsFormsErrorLabels[identifier] = formErrorLabels;
    }
    unsubscribeFormSubscriptions(identifier) {
        this.formSubs[identifier]?.unsubscribe();
        delete this.formSubs[identifier];
    }
    unsubscribeAllFormsSubscriptions() {
        Object.entries(this.formSubs).forEach(([key, value]) => this.unsubscribeFormSubscriptions(key));
    }
    getFormsState() {
        return Object.entries(this.sectionsForms ?? {}).reduce((stateMap, [key, value]) => {
            const { form } = value;
            stateMap[key] = {
                touched: form.touched,
                dirty: form.dirty,
                hasTouchedOrDirtyWarningsErrors: ExFormUtil.formHasTouchedOrDirtyWarningsErrors(form),
                hasRequired: ExFormUtil.formHasRequiredControl(form),
                loading: false,
                isSingleSave: !!value.submitFunction
            };
            return stateMap;
        }, {});
    }
    unregisterSectionForm(identifier) {
        this.unsubscribeFormSubscriptions(identifier);
        delete this.sectionsForms[identifier];
        delete this.sectionsFormsFieldsNameLabels[identifier];
        delete this.sectionsFormsErrorLabels[identifier];
        this.notifyFormStatusChange();
    }
    addNonPrimaryEntityDirtyValidator(form) {
        ExFormValidators.addWarningValidatorToControl(form, ExFormValidators.controlIsDirty, this.FORM_WARNING_CODE_NON_PRIMARY_DIRTY);
        form.updateValueAndValidity();
    }
    doEditAllSections() {
        this.sectionsEditMode.next(true);
    }
    doSaveAllSections(saveParameter, options = {}) {
        if (this.singleSaveInProgress)
            return;
        this.onSingleSaveStarted();
        const { closeEditOnCompletion, treatFormWarningsAsErrors, skipFormValidations, sectionsFormControlsValidatorsIgnoreList, confirmationConfiguration } = options;
        let entityId;
        this.getSingleSaveSubmitData()
            .pipe(take(1), tap$1((updatedEntity) => entityId = updatedEntity?.['id']), mergeMap((updatedEntity) => this.doPreSaveValidation(updatedEntity, saveParameter, skipFormValidations, sectionsFormControlsValidatorsIgnoreList)), mergeMap((data) => this.checkPreSaveValidationErrors(data.entity, data.validationMessages, !!treatFormWarningsAsErrors)), mergeMap((data) => this.preSaveConfirmation(data.entity, data.validationMessages, confirmationConfiguration)), tap$1(res => !res.confirmed && this.onSingleSaveCompleted(false)), filter$1(res => !!res.confirmed), mergeMap((data) => this.doSave(data.entity, saveParameter)), mergeMap((res) => this.doPostSave(res)), tap$1({ error: res => this.onSingleSaveError(entityId) }))
            .subscribe((res) => {
            this.onSingleSaveCompleted(true);
            if (closeEditOnCompletion != false)
                this.sectionsEditMode.next(false);
        });
    }
    onSingleSaveStarted() {
        this.singleSaveInProgress = true;
        this.saveAllSections.next(null);
    }
    onSingleSaveCompleted(success) {
        this.singleSaveInProgress = false;
        this.singleSaveComplete.next(success);
    }
    onSingleSaveError(entityId) {
        this.onSingleSaveCompleted(false);
    }
    getSingleSaveSubmitData() {
        const submitObservables = this.getSingleSaveSubmitFunctionsObservables();
        if (!(submitObservables.length > 0))
            return EMPTY;
        return forkJoin(submitObservables)
            .pipe(take(1), map$1((submitData) => this.mergeSubmitData(submitData)));
    }
    getSingleSaveSubmitFunctionsObservables() {
        return Object.entries(this.sectionsForms)
            .filter(([key, value]) => !!value.submitFunction)
            .sort((a, b) => {
            return a[0] > b[0] ? 1 : -1;
        })
            .map(([key, value]) => value.submitFunction());
    }
    mergeSubmitData(submitData) {
        const id = submitData[0].id;
        const updatedObj = submitData.reduce((m, p) => {
            (p.mergedProperties ?? []).forEach(prop => p.updatedObjProperties[prop] = Array.isArray(p.updatedObjProperties[prop]) ? [...(m.obj[prop] ?? []), ...(p.updatedObjProperties[prop] ?? [])] : { ...(m.obj[prop] ?? {}), ...(p.updatedObjProperties[prop] ?? {}) });
            return p.id == id ? {
                id: m.id,
                obj: Object.assign({}, m.obj, p.updatedObjProperties),
                updatedObjProperties: null
            } : m;
        }, submitData[0]).obj;
        return updatedObj;
    }
    doPreSaveValidation(entity, saveParameter, skipFormValidations = false, sectionsFormControlsValidatorsIgnoreList) {
        const formsValidationObservables = skipFormValidations ? of([]) : this.getSectionsFormsControlsValidationObservables(saveParameter, sectionsFormControlsValidatorsIgnoreList);
        const sectionsValidationObservables = [...this.getSectionsFormsPreSaveValidationFunctionsObservables(entity, saveParameter), this.singleSavePreSaveValidationFunction?.(entity, saveParameter) ?? of([])];
        return formsValidationObservables.pipe(mergeMap((formsErrorMessages) => {
            return iif(() => formsErrorMessages.some(m => m.type == 'error'), of(formsErrorMessages), defer$1(() => forkJoin(sectionsValidationObservables).pipe(map$1(messages => [...formsErrorMessages, ...messages].flat()))))
                .pipe(map$1(messages => {
                return { entity: entity, validationMessages: messages.filter(m => !!m) };
            }));
        }));
    }
    getSectionsFormsPreSaveValidationFunctionsObservables(entity, saveParameter) {
        return Object.entries(this.sectionsForms)
            .filter(([key, value]) => !!value.preSaveValidationFunction)
            .map(([key, value]) => value.preSaveValidationFunction(entity, saveParameter));
    }
    getSectionsFormsControlsValidationObservables(saveParameter, sectionsFormControlsValidatorsIgnoreList) {
        let formsValidationMessages = [];
        Object.entries(this.sectionsForms).forEach(([sectionFormKey, value]) => {
            const formControlName = '__form__';
            let controls = { [formControlName]: value.form };
            if (value.form instanceof FormGroup) {
                controls = { ...controls, ...value.form.controls };
            }
            Object.entries(controls).forEach(([name, control]) => {
                const controlValidatorsIgnoreList = this.getFormControlValidatorsIgnoreList(sectionFormKey, name, sectionsFormControlsValidatorsIgnoreList);
                const { errors, warnings } = ExFormUtil.getControlErrorsAndWarnings(control);
                if (Object.keys(errors).length || Object.keys(warnings).length) {
                    control.markAsTouched();
                }
                Object.entries(errors ?? {}).filter(([errorCode, value]) => !controlValidatorsIgnoreList.some(error => error === errorCode)).forEach(([errorCode, value]) => formsValidationMessages.push({
                    ...this.constructFormControlValidationMessage('error', sectionFormKey, name != formControlName ? name : null, errorCode, value),
                    fieldId: name != formControlName ? name : null,
                    sectionId: sectionFormKey
                }));
                Object.entries(warnings ?? {}).filter(([warningCode, value]) => !controlValidatorsIgnoreList.some(warning => warning === warningCode)).forEach(([warningCode, value]) => formsValidationMessages.push({
                    ...this.constructFormControlValidationMessage('warning', sectionFormKey, name != formControlName ? name : null, warningCode, value),
                    fieldId: name != formControlName ? name : null,
                    sectionId: sectionFormKey
                }));
            });
        });
        return of(formsValidationMessages);
    }
    /**
     * Returns a list of error codes for the given form control from the given section.
     * The error code list is taken from sectionsFormControlsValidatorsIgnoreList if it is not undefined and from the sectionsForms otherwise.
     */
    getFormControlValidatorsIgnoreList(sectionFormKey, controlName, sectionsFormControlsValidatorsIgnoreList) {
        return (sectionsFormControlsValidatorsIgnoreList ? sectionsFormControlsValidatorsIgnoreList[this.getSectionIdFromSectionFormKey(sectionFormKey)]?.[controlName] : this.sectionsForms[sectionFormKey].formControlsValidatorsIgnoreList?.[controlName]) ?? [];
    }
    constructFormControlValidationMessage(type, sectionFormKey, fieldKey, validationCode, value) {
        return {
            type: type,
            message: this.getValidationMessageBySectionAndControl(sectionFormKey, fieldKey, validationCode, value)
        };
    }
    getValidationMessageBySectionAndControl(sectionFormKey, fieldKey, validationCode, value) {
        const formControlLabelKey = fieldKey ? fieldKey : this.getSectionIdFromSectionFormKey(sectionFormKey);
        const message = this.sectionsFormsErrorLabels[sectionFormKey]?.[`${SINGLE_SAVE_FORM_CONTROL_VALIDATION_ERROR_LABEL_PREFIX}.${formControlLabelKey}.${validationCode}`];
        return message ? this.translate.instant(message) : this.getValidationMessageDefault(sectionFormKey, fieldKey, validationCode, value);
    }
    getValidationMessageDefault(sectionFormKey, fieldKey, validationCode, value) {
        const sectionName = this.getSectionTitle(this.getSectionIdFromSectionFormKey(sectionFormKey));
        const fieldName = fieldKey ? this.translate.instant(this.sectionsFormsFieldsNameLabels[sectionFormKey]?.[fieldKey] ?? fieldKey) : null;
        const errorLabel = this.sectionsFormsErrorLabels[sectionFormKey]?.[`${fieldKey}.${validationCode}`] ?? this.sectionsFormsErrorLabels[sectionFormKey]?.[`${validationCode}`] ?? DEFAULT_ERROR_LABELS[`${validationCode}`] ?? validationCode;
        return `${fieldName ? `The field op:${fieldName}:op in s` : 'S'}ection ${sectionName} has an error: ${this.translate.instant(errorLabel, value?.errorParams ?? {})}`;
    }
    getSectionIdFromSectionFormKey(sectionFormKey) {
        return sectionFormKey.slice(0, sectionFormKey.lastIndexOf(SECTION_FORM_IDENTIFIER_DELIMITER));
    }
    checkPreSaveValidationErrors(entity, validationMessages, treatFormWarningsAsErrors) {
        this.setFieldNavigationMap(validationMessages);
        const errorMessages = validationMessages.filter(message => treatFormWarningsAsErrors == true || message.type === 'error').map(message => message.message);
        if (errorMessages.length > 0) {
            this.displaySingleSaveErrors(errorMessages);
            return throwError(() => "single save validation errors exist");
        }
        return of({ entity: entity, validationMessages: validationMessages });
    }
    setFieldNavigationMap(validationMessages) {
        validationMessages.forEach(message => {
            this.addMessageToFieldNavigationMap(this.getMessageKey(message.message), message.fieldId, message.sectionId);
        });
    }
    getMessageKey(message) {
        if (message.lastIndexOf('op:') == -1)
            return '';
        return message.substring(message.lastIndexOf('op:') + 3, message.lastIndexOf(':op'));
    }
    addMessageToFieldNavigationMap(fieldName, fieldKey, sectionFormKey) {
        if (!fieldName || fieldName == '' || !fieldKey || fieldKey == '' || !sectionFormKey || sectionFormKey == '')
            return;
        const sectionKey = (sectionFormKey.lastIndexOf('#') == -1) ? sectionFormKey : sectionFormKey.substring(0, sectionFormKey.indexOf("#"));
        this.fieldsNavigationMap.set(fieldName, sectionKey + "/" + fieldKey);
    }
    /* Display error messages in snackbar */
    displaySingleSaveErrors(validationErrorMessages) {
        this.snackbarMessages.next({
            messages: validationErrorMessages,
            type: 'error',
            fieldNavigation: this.fieldsNavigationMap
        });
    }
    preSaveConfirmation(entity, validationMessages, confirmationConfiguration) {
        if (!confirmationConfiguration?.displayAlways && validationMessages.length == 0)
            return of({
                entity: entity,
                confirmed: true
            });
        return this.dialog.showBasicConfirmationDialog({
            isPositiveButtonIsPrimary: true,
            type: confirmationConfiguration?.type ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.type,
            positiveLabel: confirmationConfiguration?.positiveLabel ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.positiveLabel,
            negativeLabel: confirmationConfiguration?.negativeLabel ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.negativeLabel,
            title: confirmationConfiguration?.title ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.title,
            message: confirmationConfiguration?.message ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.message,
            list: confirmationConfiguration?.list ?? validationMessages.filter(message => !!message).map(message => message.message),
            confirmation: confirmationConfiguration?.confirmation ?? SINGLE_SAVE_CONFIRMATION_CONFIGURATION_DEFAULT.confirmation,
            fieldNavigation: this.fieldsNavigationMap
        }).afterClosed().pipe(map$1((ret) => {
            return { entity: entity, confirmed: ret };
        }));
    }
    doSave(entity, saveParameter) {
        if (!entity?.['id'])
            return throwError(() => "single save empty entity or entity missing id"); // TODO: handle cases where entity id is not in property named 'id'
        return this.singleSaveUpdateFunctionRetriever?.(saveParameter)(entity['id'], entity);
    }
    doPostSave(data) {
        return forkJoin(this.getSingleSavePostSaveFunctionsObservables(data)).pipe(map$1(() => of(data)));
    }
    getSingleSavePostSaveFunctionsObservables(data) {
        const sectionsFormsPostSaveObservables = Object.entries(this.sectionsForms)
            .filter(([key, value]) => !!value.postSaveFunction)
            .map(([key, value]) => value.postSaveFunction(data));
        return [...sectionsFormsPostSaveObservables, this.singleSavePostSaveFunction?.(data) ?? of(null)];
    }
    doCancelAllSections() {
        this.cancelAllSections.next(null);
        this.sectionsEditMode.next(false);
        this.clearFormsWarnings();
    }
    resetSectionsEdit() {
        this.sectionsEditMode.next(false);
        this.clearFormsWarnings();
        this.unsubscribeAllFormsSubscriptions();
        this.sectionsForms = {};
        this.sectionsFormsFieldsNameLabels = {};
        this.sectionsFormsErrorLabels = {};
    }
    clearFormsWarnings() {
        Object.entries(this.sectionsForms ?? {}).forEach(([key, value]) => {
            delete (value.form[EX_FORM_WARNINGS_PROPERTY_NAME] ?? {})[this.FORM_WARNING_CODE_NON_PRIMARY_DIRTY];
        });
    }
    openFormByIdentifier(identifier) {
        if (this.openedFormsBySections[identifier]) {
            this.openedFormsBySections[identifier] += 1;
        }
        else {
            this.openedFormsBySections[identifier] = 1;
        }
        this.changeOpenedForm();
    }
    closeFormByIdentifier(identifier) {
        if (this.openedFormsBySections[identifier]) {
            this.openedFormsBySections[identifier] -= 1;
        }
        else {
            this.openedFormsBySections[identifier] = 0;
        }
        this.changeOpenedForm();
    }
    changeOpenedForm() {
        const identifiersArray = Object.keys(this.openedFormsBySections).filter(key => this.openedFormsBySections[key] > 0);
        this.openedFormsChanged.next(identifiersArray);
    }
    openRightSide() {
        this.exSectionsLayoutListLayoutService.openRightSideSubj.next();
    }
    static { this.ɵfac = function ExSectionsLayoutService_Factory(t) { return new (t || ExSectionsLayoutService)(i0.ɵɵinject(ExSectionsLayoutListLayoutService), i0.ɵɵinject(ExDialogService), i0.ɵɵinject(i1$2.TranslateService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSectionsLayoutService, factory: ExSectionsLayoutService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ExSectionsLayoutListLayoutService }, { type: ExDialogService }, { type: i1$2.TranslateService }]; }, null); })();

const Animations$a = [
    trigger('arrowFlip', [
        state('collapse', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('expand', style({
            transform: 'rotate(180deg)'
        })),
        transition('collapse <=> expand', [
            animate('0.25s')
        ])
    ]),
    trigger('transform', [
        state('show', style({
            'visibility': 'visible',
            'width': '40px',
        })),
        state('hide', style({
            'box-shadow': 'none',
            'visibility': 'hidden',
            'width': '0px',
            'margin-inline-end': '0px'
        })),
        transition('void => *', []),
        transition('show <=> hide', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ]),
    trigger('blockInitialAnimation', [
        transition(":enter", [])
    ])
];

const _c0$1J = ["rightSidenav"];
const _c1$17 = ["leftSidenav"];
const _c2$N = function (a0) { return { sidenav: a0, side: "left" }; };
function ExSidenavPageComponent_mat_sidenav_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(1);
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(21);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2$N, _r11));
} }
const _c3$D = function (a0) { return { "ex-sidenav-page-hide-left-sidenav": a0 }; };
const _c4$u = function (a0) { return { "width.px": a0 }; };
function ExSidenavPageComponent_mat_sidenav_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-sidenav", 18, 19);
    i0.ɵɵlistener("openedChange", function ExSidenavPageComponent_mat_sidenav_1_Template_mat_sidenav_openedChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onLeftSideNavOpenedChange($event)); })("rzStop", function ExSidenavPageComponent_mat_sidenav_1_Template_mat_sidenav_rzStop_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onResizeStop($event)); });
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵprojection(4, 3, ["#ngContent", ""]);
    i0.ɵɵtemplate(5, ExSidenavPageComponent_mat_sidenav_1_ng_container_5_Template, 2, 4, "ng-container", 21);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ex-sidenav-page-left-sidenav-has-resizable", !!ctx_r0.hasNgContent[ctx_r0.SectionKeys.leftSidenavResizable]);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c3$D, !ctx_r0.showLeftSidnav))("exResizable", !!ctx_r0.hasNgContent[ctx_r0.SectionKeys.leftSidenavResizable])("rzHandles", ctx_r0.direction == "ltr" ? "e" : "w")("rzMinWidth", ctx_r0.leftSidenavMinWidth)("rzMaxWidth", ctx_r0.leftSidenavMaxWidth)("mode", ctx_r0.showLeftSidenavCollapseBtn && ctx_r0.sideNavToOverMode ? "over" : "side")("opened", !ctx_r0.showLeftSidenavCollapseBtn || ctx_r0.expandLeftSidenav && !ctx_r0.sideNavToOverMode)("ngStyle", i0.ɵɵpureFunction1(17, _c4$u, ctx_r0.leftSidenavWidth));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("display", i0.ɵɵpipeBind1(3, 13, ctx_r0.expandLeftSidenavChangeWithDelay) || ctx_r0.expandLeftSidenav ? "" : "none");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.showLeftSidenavCollapseBtn);
} }
function ExSidenavPageComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22, 23);
    i0.ɵɵprojection(2, 4);
    i0.ɵɵelementEnd();
} }
function ExSidenavPageComponent_div_8_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r18.activeFacetsNumber, ")");
} }
function ExSidenavPageComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22, 23)(2, "ex-dot-wrapper", 24)(3, "p", 25);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExSidenavPageComponent_div_8_span_7_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵprojection(8, 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("displayDot", ctx_r3.activeFacetsNumber && ctx_r3.activeFacetsNumber > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", ctx_r3.activeFacetsToolTip);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 5, ctx_r3.leftSidenavLabel) + (ctx_r3.activeFacetsNumber && ctx_r3.activeFacetsNumber > 0 ? "(" + ctx_r3.activeFacetsNumber + ")" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 7, ctx_r3.leftSidenavLabel), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.activeFacetsNumber && ctx_r3.activeFacetsNumber > 0);
} }
function ExSidenavPageComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26, 23);
    i0.ɵɵelement(2, "ex-summary-sections-collapsed", 27);
    i0.ɵɵprojection(3, 6, ["#collapsedFooter", ""]);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("summarySections", ctx_r6.rightSidenavSections)("showWarningIcon", ctx_r6.showWarningIcon);
} }
const _c5$o = function (a0) { return { sidenav: a0, side: "right" }; };
function ExSidenavPageComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$o, ctx_r7.rightSidenav));
} }
function ExSidenavPageComponent_mat_sidenav_19_div_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r20 = i0.ɵɵreference(1);
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$o, _r20));
} }
function ExSidenavPageComponent_mat_sidenav_19_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32, 33);
    i0.ɵɵprojection(2, 7, ["#ngContent", ""]);
    i0.ɵɵprojection(3, 8, ["#footer", ""]);
    i0.ɵɵtemplate(4, ExSidenavPageComponent_mat_sidenav_19_div_2_ng_container_4_Template, 1, 4, "ng-container", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r21.showRightSidenavCollapseBtn);
} }
const _c6$m = function (a0) { return { "ex-sidenav-page-overlap-right-sidenav-collapse-pin": a0 }; };
function ExSidenavPageComponent_mat_sidenav_19_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", null, 23)(2, "div", 36, 37);
    i0.ɵɵelement(4, "ex-icon", 38);
    i0.ɵɵelementStart(5, "span", 39);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "uppercase");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "ex-button", 40);
    i0.ɵɵlistener("click", function ExSidenavPageComponent_mat_sidenav_19_div_3_div_3_Template_ex_button_click_9_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.setPinOverlapRightSidenav()); });
    i0.ɵɵelement(10, "ex-icon", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "ex-button", 42);
    i0.ɵɵlistener("click", function ExSidenavPageComponent_mat_sidenav_19_div_3_div_3_Template_ex_button_click_11_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.setOverlapRightSidenav(false)); });
    i0.ɵɵelement(12, "ex-icon", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 44, 45);
    i0.ɵɵelement(15, "ex-component-loader", 46);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("background", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].color);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconType", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].iconType)("iconName", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].iconName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 9, i0.ɵɵpipeBind1(8, 11, ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].title)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c6$m, !ctx_r26.pinOverlapRightSidenav));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("componentFactoryItem", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection] == null ? null : ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].editSidePaneComponent)("data", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection] == null ? null : ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].editSidePaneInputs)("events", ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection] == null ? null : ctx_r26.rightSidenavSectionsArray[ctx_r26.rightSidenavOpenedSection].editSidePaneEvents);
} }
function ExSidenavPageComponent_mat_sidenav_19_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34, 35);
    i0.ɵɵlistener("keydown.escape", function ExSidenavPageComponent_mat_sidenav_19_div_3_Template_div_keydown_escape_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.setOverlapRightSidenav(false)); });
    i0.ɵɵprojection(2, 9, ["#ngContent", ""]);
    i0.ɵɵtemplate(3, ExSidenavPageComponent_mat_sidenav_19_div_3_div_3_Template, 16, 15, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r22.hasNgContent[ctx_r22.SectionKeys.overlapRightSidenav]);
} }
function ExSidenavPageComponent_mat_sidenav_19_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-sidenav", 28, 29);
    i0.ɵɵlistener("rzStart", function ExSidenavPageComponent_mat_sidenav_19_Template_mat_sidenav_rzStart_0_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.onStarted($event)); })("openedChange", function ExSidenavPageComponent_mat_sidenav_19_Template_mat_sidenav_openedChange_0_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.expandRightSidenav = $event); });
    i0.ɵɵtemplate(2, ExSidenavPageComponent_mat_sidenav_19_div_2_Template, 5, 1, "div", 30);
    i0.ɵɵtemplate(3, ExSidenavPageComponent_mat_sidenav_19_div_3_Template, 4, 1, "div", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exResizable", ctx_r8.overlapRightSidenav)("rzHandles", ctx_r8.direction == "ltr" ? "w" : "e")("rzMinWidth", ctx_r8.rightSidenavWidth)("rzMaxWidth", 900)("mode", !ctx_r8.pinOverlapRightSidenav && (ctx_r8.overlapRightSidenav || ctx_r8.sideNavToOverMode) ? "over" : "side")("opened", ctx_r8.expandRightSidenav && (!ctx_r8.sideNavToOverMode || ctx_r8.overlapRightSidenav))("ngStyle", i0.ɵɵpureFunction1(9, _c4$u, !ctx_r8.overlapRightSidenav ? ctx_r8.rightSidenavWidth : 400));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r8.overlapRightSidenav);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.overlapRightSidenav);
} }
const _c7$i = function (a0, a1) { return [a0, a1]; };
const _c8$g = function (a0, a1, a2, a3) { return { "flex-direction": a0, "margin-inline-end": a1, "margin-inline-start": a2, "background": a3 }; };
function ExSidenavPageComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "button", 48);
    i0.ɵɵlistener("click", function ExSidenavPageComponent_ng_template_20_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const sidenav_r38 = restoredCtx.sidenav; const side_r39 = restoredCtx.side; const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.onSidenavToggled(sidenav_r38, side_r39)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "i", 49);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sidenav_r38 = ctx.sidenav;
    const side_r39 = ctx.side;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 7, (sidenav_r38 == null ? null : sidenav_r38.opened) ? "ng.general.collapse" : "ng.general.expand") + " " + i0.ɵɵpipeBind1(3, 9, side_r39 === "left" ? ctx_r10.leftSidenavLabel : "ng.general.sidebar"))("ngClass", i0.ɵɵpureFunction2(15, _c7$i, ctx_r10.displayLeftArrow(sidenav_r38) ? "sel-ex-sidnav-left-arrow" : "sel-ex-sidnav-right-arrow", (sidenav_r38 == null ? null : sidenav_r38.opened) ? "ex-sidenav-arrows-opened" : ""))("ngStyle", i0.ɵɵpureFunction4(18, _c8$g, side_r39 === "left" ? "row-reverse" : "row", side_r39 !== "left" && (sidenav_r38 == null ? null : sidenav_r38.opened) ? "10px" : "0px", (sidenav_r38 == null ? null : sidenav_r38.opened) ? "10px" : "0px", !(sidenav_r38 == null ? null : sidenav_r38.opened) ? "transparent" : ""));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 11, (sidenav_r38 == null ? null : sidenav_r38.opened) ? "ng.general.collapse" : "ng.general.expand") + " " + i0.ɵɵpipeBind1(5, 13, side_r39 === "left" ? ctx_r10.leftSidenavLabel : "ng.general.sidebar"))("aria-expanded", sidenav_r38 == null ? null : sidenav_r38.opened);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("@arrowFlip", (sidenav_r38 == null ? null : sidenav_r38.opened) ? "collapse" : "expand")("ngClass", ctx_r10.displayLeftArrow(sidenav_r38) ? "fa-angle-double-left" : "fa-angle-double-right");
} }
const _c9$c = [[["", "collapsed-left-sidenav-content", ""]], [["", "sidenav-page-content", ""]], [["", "collapsed-right-sidenav-content", ""]], [["", "left-sidenav-content", ""]], [["", "collapsed-left-sidenav-smallbox-content", ""]], [["", "collapsed-left-sidenav-smallbox-content-after-label", ""]], [["", "collapsed-footer-content", ""]], [["", "right-sidenav-content", ""]], [["", "footer-content", ""]], [["", "overlap-right-sidenav-content", ""]]];
const _c10$9 = function (a0) { return { "padding-inline-end": a0 }; };
const _c11$7 = ["[collapsed-left-sidenav-content]", "[sidenav-page-content]", "[collapsed-right-sidenav-content]", "[left-sidenav-content]", "[collapsed-left-sidenav-smallbox-content]", "[collapsed-left-sidenav-smallbox-content-after-label]", "[collapsed-footer-content]", "[right-sidenav-content]", "[footer-content]", "[overlap-right-sidenav-content]"];
var sidenavKeys;
(function (sidenavKeys) {
    sidenavKeys["end"] = "summary_section_opened";
    sidenavKeys["start"] = "facet_opened";
    sidenavKeys["sectionsMenu"] = "sidepane_section_menu_opened";
    sidenavKeys["facets_size"] = "facets_size";
})(sidenavKeys || (sidenavKeys = {}));
var SectionKeys;
(function (SectionKeys) {
    SectionKeys["leftSidenav"] = "left";
    SectionKeys["rightSidenav"] = "right";
    SectionKeys["overlapRightSidenav"] = "overlapRight";
    SectionKeys["collapsedLeftSidenav"] = "collapsedLeft";
    SectionKeys["collapsedRightSidenav"] = "collapsedRight";
    SectionKeys["leftSidenavResizable"] = "leftSidenavResizable";
})(SectionKeys || (SectionKeys = {}));
class ExSidenavPageComponent {
    constructor(sidenavPageService, exItemsLayoutService, changeDetector, rerender, ngZone, translate) {
        this.sidenavPageService = sidenavPageService;
        this.exItemsLayoutService = exItemsLayoutService;
        this.changeDetector = changeDetector;
        this.rerender = rerender;
        this.ngZone = ngZone;
        this.translate = translate;
        /**
         * Show the collapse button on the left sidenav
         */
        this.showLeftSidenavCollapseBtn = true;
        /**
         * The Sidenavs will be collapsed and will open in over mode
         */
        this.sideNavToOverMode = false;
        /**
         * Is the list layout (if exists) in full page mode
         */
        this.isFullPageMode = false;
        /**
         * Is the list layout (if exists) in side by side mode (split view)
         */
        this.isItemOpen = false;
        this.hasNgContent = {};
        this.showLeftSidnav = true;
        this.expandRightSidenavChange = new EventEmitter();
        this.expandLeftSidenavChange = new EventEmitter();
        this.leftSidenavWidthChange = new EventEmitter();
        this.expandLeftSidenavForAccessibility = new EventEmitter();
        this.expandRightSidenavForAccessibility = new EventEmitter();
        this.overlapRightSidenav = false;
        this.pinOverlapRightSidenav = false;
        this.disableAnimation = false;
        this.ANIMATION_DURATION = 1000;
        this.subs = new Subscription();
    }
    ngOnInit() {
        let dir = document.documentElement.getAttribute('dir');
        this.direction = dir === "rtl" ? "rtl" : "ltr";
        this.expandLeftSidenavChangeWithDelay = this.expandLeftSidenavForAccessibility.pipe(startWith$1(this.expandLeftSidenav), switchMap(x => timer(x ? 0 : this.ANIMATION_DURATION).pipe(map(_ => x))));
        this.subscribeToCloseOverLeftSideNavWhenClickOutside();
    }
    subscribeToCloseOverLeftSideNavWhenClickOutside() {
        this.ngZone.runOutsideAngular(() => {
            this.subs.add(this.expandLeftSidenavForAccessibility.subscribe(this.subscribeToFocusOut.bind(this, "left")));
            this.subs.add(this.expandRightSidenavForAccessibility.subscribe(this.subscribeToFocusOut.bind(this, "right")));
        });
    }
    subscribeToFocusOut(side, isOpen) {
        const nativeElement = (side === 'left') ? this.leftSidenavRef?.nativeElement : this.rightSidenavRef?.nativeElement;
        this.unlistenSideNavFocusOut && this.unlistenSideNavFocusOut();
        if (isOpen && this.sideNavToOverMode && nativeElement) {
            this.unlistenSideNavFocusOut =
                this.rerender.listen(nativeElement, 'focusout', (event) => {
                    if (!nativeElement.contains(event.relatedTarget)) {
                        (side === 'left') ? this.leftSidenav.close() : (!(this.pinOverlapRightSidenav || this.overlapRightSidenav) && this.rightSidenav.close());
                        this.unlistenSideNavFocusOut();
                    }
                });
        }
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('rightSidenavSections')) {
            this.rightSidenavSectionsArray = this.rightSidenavSections.toArray();
            this.rightSidenavSections.forEach((rightSidenavSection, i) => {
                this.subs.add(rightSidenavSection.onEditClicked.subscribe(() => {
                    this.rightSidenavOpenedSection = i;
                    this.setOverlapRightSidenav(true);
                }));
            });
        }
        if (changes.hasOwnProperty('sideNavToOverMode')) {
            if (changes.sideNavToOverMode.currentValue) {
                this.exItemsLayoutService?.notifyExpandLeftSidenavChange(false);
            }
            else {
                this.leftSidenav && this.exItemsLayoutService?.notifyExpandLeftSidenavChange(this.leftSidenav.opened);
            }
        }
    }
    ngAfterViewInit() {
        !this.sideNavToOverMode && this.exItemsLayoutService?.notifyExpandLeftSidenavChange(this.leftSidenav.opened);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
        if (this.unlistenSideNavFocusOut) {
            this.unlistenSideNavFocusOut();
        }
    }
    onStarted(event) {
        this.rightSidenavNativeElement = event.host;
    }
    get SectionKeys() {
        return SectionKeys;
    }
    setOverlapRightSidenav(opened) {
        if (!opened && this.rightSidenavNativeElement) {
            // We have to remove the left style that the ngResizable directive put on the element,
            // because it does not remove it, and that causes undesired behavior.
            this.rerender.removeStyle(this.rightSidenavNativeElement, 'left');
        }
        this._setDisableAnimation();
        this.overlapRightSidenav = opened;
    }
    setPinOverlapRightSidenav() {
        this._setDisableAnimation();
        this.pinOverlapRightSidenav = !this.pinOverlapRightSidenav;
    }
    _setDisableAnimation() {
        this.disableAnimation = true;
        setTimeout(() => {
            this.disableAnimation = false;
        }, 20);
    }
    onLeftSideNavOpenedChange(isOpened) {
        this.expandLeftSidenav = isOpened;
        !this.sideNavToOverMode && this.exItemsLayoutService?.notifyExpandLeftSidenavChange(isOpened);
    }
    onResizeStop(event) {
        this.leftSidenavWidth = event.size.width;
        this.leftSidenavWidthChange.emit(event.size.width);
    }
    onSidenavToggled(sidenav, side) {
        if (!this.sideNavToOverMode) {
            // we don't want to store the state in hover mode.
            side === 'right' && this.expandRightSidenavChange.emit(!this.expandRightSidenav);
            side === 'left' && this.expandLeftSidenavChange.emit(!this.expandLeftSidenav);
        }
        side === 'right' && this.expandRightSidenavForAccessibility.emit(!this.expandRightSidenav);
        side === 'left' && this.expandLeftSidenavForAccessibility.emit(!this.expandLeftSidenav);
        sidenav.toggle();
        this.changeDetector.detectChanges();
    }
    displayLeftArrow(sidenav) {
        if (!sidenav)
            return false;
        let position = sidenav.position;
        let expanded = sidenav.opened;
        return (this.direction === 'ltr' && ((position === 'start' && expanded) || (position === 'start' && !expanded))) ||
            (this.direction === 'rtl' && ((position === 'end' && expanded) || (position === 'end' && !expanded)));
    }
    collapseSidenavs() {
        !this.overlapRightSidenav && this.rightSidenav?.close();
        this.showLeftSidenavCollapseBtn && this.leftSidenav?.close();
    }
    showCollapsedSidenav(side) {
        if (side == 'right')
            return this.hasNgContent[SectionKeys.rightSidenav] && this.rightSidenav && (!this.rightSidenav.opened || (this.sideNavToOverMode && !this.pinOverlapRightSidenav));
        if (side == 'left')
            return this.showLeftSidenavCollapseBtn && this.hasNgContent[SectionKeys.leftSidenav] && this.leftSidenav && (!this.leftSidenav.opened || this.sideNavToOverMode);
    }
    static { this.ɵfac = function ExSidenavPageComponent_Factory(t) { return new (t || ExSidenavPageComponent)(i0.ɵɵdirectiveInject(ExSidenavPageService, 8), i0.ɵɵdirectiveInject(ExItemsLayoutService, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSidenavPageComponent, selectors: [["ex-sidenav-page"]], viewQuery: function ExSidenavPageComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1J, 5);
            i0.ɵɵviewQuery(_c1$17, 5);
            i0.ɵɵviewQuery(_c1$17, 5, ElementRef);
            i0.ɵɵviewQuery(_c0$1J, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightSidenav = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leftSidenav = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leftSidenavRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightSidenavRef = _t.first);
        } }, inputs: { leftSidenavLabel: "leftSidenavLabel", leftSidenavMaxWidth: "leftSidenavMaxWidth", rightSidenavWidth: "rightSidenavWidth", leftSidenavWidth: "leftSidenavWidth", leftSidenavMinWidth: "leftSidenavMinWidth", expandLeftSidenav: "expandLeftSidenav", expandRightSidenav: "expandRightSidenav", showRightSidenavCollapseBtn: "showRightSidenavCollapseBtn", showLeftSidenavCollapseBtn: "showLeftSidenavCollapseBtn", showWarningIcon: "showWarningIcon", sideNavToOverMode: "sideNavToOverMode", rightSidenavSections: "rightSidenavSections", isFullPageMode: "isFullPageMode", isItemOpen: "isItemOpen", hasNgContent: "hasNgContent", showLeftSidnav: "showLeftSidnav", activeFacetsToolTip: "activeFacetsToolTip", activeFacetsNumber: "activeFacetsNumber" }, outputs: { expandRightSidenavChange: "expandRightSidenavChange", expandLeftSidenavChange: "expandLeftSidenavChange", leftSidenavWidthChange: "leftSidenavWidthChange" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c11$7, decls: 22, vars: 21, consts: [["autosize", "", "hasBackdrop", "false", 1, "ex-sidenav-page-container", 3, "dir"], ["disableClose", "", "class", "ex-sidenav-page-left-sidenav sel-sidenav-page-left-sidenav", 3, "ngClass", "exResizable", "rzHandles", "rzMinWidth", "rzMaxWidth", "mode", "opened", "ex-sidenav-page-left-sidenav-has-resizable", "ngStyle", "openedChange", "rzStop", 4, "ngIf"], [1, "ex-sidenav-page-content-wrapper"], [1, "ex-sidenav-page-left-sidenav-collapsed", 3, "ngClass"], ["collapsedLeftSidenav", ""], ["class", "ex-sidenav-page-left-sidenav-collapsed-button-content", 4, "ngIf"], [1, "ex-sidenav-page-left-sidenav-collapsed-button", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-sidenav-page-content", 3, "ngStyle"], ["pageContent", ""], ["role", "complementary", 1, "ex-sidenav-page-right-sidenav-collapsed"], ["collpasedRightSidenav", ""], [1, "ex-sidenav-page-right-sidenav-collapsed-button", 3, "click"], ["class", "ex-sidenav-page-collapsed-right-sidenav-default-content", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["position", "end", "disableClose", "", "class", " ex-sidenav-page-right-sidenav", 3, "exResizable", "rzHandles", "rzMinWidth", "rzMaxWidth", "mode", "opened", "ngStyle", "rzStart", "openedChange", 4, "ngIf"], [",", ""], ["arrows", ""], ["disableClose", "", 1, "ex-sidenav-page-left-sidenav", "sel-sidenav-page-left-sidenav", 3, "ngClass", "exResizable", "rzHandles", "rzMinWidth", "rzMaxWidth", "mode", "opened", "ngStyle", "openedChange", "rzStop"], ["leftSidenav", ""], [1, "ex-sidenav-page-left-sidenav-content"], [4, "ngIf"], [1, "ex-sidenav-page-left-sidenav-collapsed-button-content"], ["defaultContent", ""], [1, "ex-sidenav-page-left-sidenav-collapsed-button-dot-wrapper", 3, "displayDot"], ["role", "heading", "aria-level", "1", "matTooltipClass", "ex-sidenav-page-left-sidenav-toolTip", 1, "ex-sidenav-page-left-sidenav-label", 3, "exTooltip"], [1, "ex-sidenav-page-collapsed-right-sidenav-default-content"], [1, "ex-sidenav-page-ex-summary-sections-collapsed", 3, "summarySections", "showWarningIcon"], ["position", "end", "disableClose", "", 1, "ex-sidenav-page-right-sidenav", 3, "exResizable", "rzHandles", "rzMinWidth", "rzMaxWidth", "mode", "opened", "ngStyle", "rzStart", "openedChange"], ["rightSidenav", ""], ["role", "complementary", "class", "ex-sidenav-page-right-sidenav-content", 4, "ngIf"], ["role", "complementary", "class", "ex-sidenav-page-overlap-right-sidenav", 3, "keydown.escape", 4, "ngIf"], ["role", "complementary", 1, "ex-sidenav-page-right-sidenav-content"], ["rightSidenavContent", ""], ["role", "complementary", 1, "ex-sidenav-page-overlap-right-sidenav", 3, "keydown.escape"], ["overlapRightSidenavContent", ""], [1, "ex-sidenav-page-overlap-right-sidenav-header"], ["header", ""], ["color", "white", "sizePx", "18px", 3, "iconType", "iconName"], [1, "ex-sidenav-page-overlap-right-sidenav-label"], [1, "ex-sidenav-page-button", 3, "ngClass", "click"], ["iconType", "uxf", "color", "white", "iconName", "uxf-pin", "sizePx", "13px"], [1, "ex-sidenav-page-button", 3, "click"], ["iconType", "uxf", "color", "white", "iconName", "uxf-resize-small", "sizePx", "17px"], [1, "ex-sidenav-page-overlap-right-sidenav-content"], ["content", ""], [3, "componentFactoryItem", "data", "events"], [1, "ex-sidenav-page-arrow-wrapper"], [1, "ex-sidenav-page-arrows", 3, "exTooltip", "ngClass", "ngStyle", "click"], [1, "fa", "fa-lg", 3, "ngClass"]], template: function ExSidenavPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c9$c);
            i0.ɵɵelementStart(0, "mat-sidenav-container", 0);
            i0.ɵɵtemplate(1, ExSidenavPageComponent_mat_sidenav_1_Template, 6, 19, "mat-sidenav", 1);
            i0.ɵɵelementStart(2, "mat-sidenav-content", 2)(3, "div", 3, 4);
            i0.ɵɵtemplate(5, ExSidenavPageComponent_div_5_Template, 3, 0, "div", 5);
            i0.ɵɵelementStart(6, "button", 6);
            i0.ɵɵlistener("click", function ExSidenavPageComponent_Template_button_click_6_listener() { return ctx.onSidenavToggled(ctx.leftSidenav, "left"); });
            i0.ɵɵprojection(7, 0, ["#ngContent", ""]);
            i0.ɵɵtemplate(8, ExSidenavPageComponent_div_8_Template, 9, 9, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainer(9, 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 8, 9);
            i0.ɵɵprojection(12, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 10, 11)(15, "button", 12);
            i0.ɵɵlistener("click", function ExSidenavPageComponent_Template_button_click_15_listener() { return ctx.onSidenavToggled(ctx.rightSidenav, "right"); });
            i0.ɵɵprojection(16, 2, ["#ngContent", ""]);
            i0.ɵɵtemplate(17, ExSidenavPageComponent_div_17_Template, 4, 2, "div", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(18, ExSidenavPageComponent_ng_container_18_Template, 1, 4, "ng-container", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(19, ExSidenavPageComponent_mat_sidenav_19_Template, 4, 11, "mat-sidenav", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, ExSidenavPageComponent_ng_template_20_Template, 7, 23, "ng-template", 16, 17, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r9 = i0.ɵɵreference(21);
            i0.ɵɵproperty("@.disabled", ctx.disableAnimation)("dir", ctx.direction);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.hasNgContent[ctx.SectionKeys.leftSidenav]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("@blockInitialAnimation", undefined);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("@transform", ctx.showCollapsedSidenav("left") ? "show" : "hide")("ngClass", i0.ɵɵpureFunction1(15, _c3$D, !ctx.showLeftSidnav));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.hasNgContent[ctx.SectionKeys.collapsedLeftSidenav]);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.hasNgContent[ctx.SectionKeys.collapsedLeftSidenav]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(17, _c2$N, ctx.leftSidenav));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c10$9, ctx.overlapRightSidenav && !ctx.showCollapsedSidenav("right") ? ctx.pinOverlapRightSidenav ? "10px" : "300px" : "0px"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("@transform", ctx.showCollapsedSidenav("right") ? "show" : "hide");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.hasNgContent[ctx.SectionKeys.collapsedRightSidenav]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showRightSidenavCollapseBtn);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasNgContent[ctx.SectionKeys.rightSidenav]);
        } }, styles: ["[_ngcontent-%COMP%]:dir(rtl)     .ex-dot-wrapper-style:after{inset-inline-end:7%!important;writing-mode:vertical-rl}.ex-sidenav-page-container[_ngcontent-%COMP%]{display:flex;height:100%}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-hide-left-sidenav[_ngcontent-%COMP%]{display:none!important}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav[_ngcontent-%COMP%]{border:none;position:absolute;overflow:hidden;background:#f2f2f2}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav.ex-sidenav-page-left-sidenav-has-resizable[_ngcontent-%COMP%]{padding-inline-end:10px}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-content[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column;position:relative;background:#f2f2f2}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-content[_ngcontent-%COMP%]:not(.ex-sidenav-page-left-sidenav-has-title){justify-content:space-between}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]{background:#f2f2f2;display:flex;flex:1;height:100%;overflow:hidden}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed.ng-animating[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn linear 2s}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button[_ngcontent-%COMP%]{flex:1;width:40px;display:flex;flex-direction:column;outline:none;border:none;border-radius:5px;background:#f2f2f2}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button[_ngcontent-%COMP%]:focus{border:1px solid black!important}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button-content[_ngcontent-%COMP%]{align-self:center}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button-content[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed-button-dot-wrapper[_ngcontent-%COMP%] >   .ex-dot-wrapper-style:after{inset-inline-end:max(-20%,3px);bottom:max(-20%,-6px)}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-left-sidenav-label[_ngcontent-%COMP%]{writing-mode:vertical-rl;display:flex;align-items:center;width:100%;margin-top:15px}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-content[_ngcontent-%COMP%]{width:100%}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;cursor:pointer}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed.ng-animating[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn linear 2s}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed-button[_ngcontent-%COMP%]{width:40px!important;flex:1;border:none;outline:none;background:#f2f2f2;display:flex;align-self:stretch;overflow:hidden}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed-button[_ngcontent-%COMP%]   .ex-sidenav-page-collapsed-right-sidenav-default-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;justify-content:space-between}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-content-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-collapsed-button[_ngcontent-%COMP%]   .ex-sidenav-page-collapsed-right-sidenav-default-content[_ngcontent-%COMP%]   .ex-sidenav-page-ex-summary-sections-collapsed[_ngcontent-%COMP%]{align-self:stretch;overflow:hidden}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]{border:none;position:absolute}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-content[_ngcontent-%COMP%]{background:#f2f2f2;position:relative;justify-content:flex-end;display:flex;flex-direction:column;min-height:100%}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]{width:100%}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:20px;position:sticky;top:0;z-index:10000}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-header[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-label[_ngcontent-%COMP%]{color:#fff;padding-inline-start:10px;flex:1}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-header[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-collapse-pin[_ngcontent-%COMP%]     i{transform:rotate(45deg)}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav-content[_ngcontent-%COMP%]{padding:20px;background:#fff}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-overlap-right-sidenav[_ngcontent-%COMP%]   .ex-sidenav-page-button[_ngcontent-%COMP%]     button{background-color:transparent!important;min-height:22px!important}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-right-sidenav-not-resizable[_ngcontent-%COMP%]{width:300px!important;inset-inline-start:auto!important}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-arrow-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:sticky;bottom:0;width:-webkit-fill-available}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-arrow-wrapper.ex-sidenav-page-arrow-sticky-top[_ngcontent-%COMP%]{bottom:unset;top:0}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-arrow-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-arrows[_ngcontent-%COMP%]{display:flex;padding:12px;background:#e5e5e5;justify-content:space-between;border-radius:5px;margin-bottom:5px}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-arrow-wrapper[_ngcontent-%COMP%]   .ex-sidenav-page-arrows[_ngcontent-%COMP%]:not(:focus){border-color:transparent}.ex-sidenav-page-container[_ngcontent-%COMP%]   .ex-sidenav-page-arrow-wrapper[_ngcontent-%COMP%]   .ex-sidenav-arrows-opened[_ngcontent-%COMP%]:hover{background:#dfdfdf!important}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}  .ex-sidenav-page-left-sidenav-toolTip{white-space:pre-line!important}  .resize-handle-wrapper{height:100%;width:50%}  .ng-resizable-handle:focus-within .resize-handle-wrapper{border:1px solid black}  .ng-resizable-handle:focus{outline:none}"], data: { animation: Animations$a } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidenavPageComponent, [{
        type: Component,
        args: [{ selector: 'ex-sidenav-page', animations: Animations$a, template: "<mat-sidenav-container autosize hasBackdrop=\"false\" class=\"ex-sidenav-page-container\" [@.disabled]=\"disableAnimation\" [dir]=\"direction\">\n  <mat-sidenav [ngClass]=\"{ 'ex-sidenav-page-hide-left-sidenav' : !showLeftSidnav}\" #leftSidenav\n               *ngIf=\"!!hasNgContent[SectionKeys.leftSidenav]\"\n               [exResizable]=\"!!hasNgContent[SectionKeys.leftSidenavResizable]\"\n               [rzHandles]=\"direction == 'ltr' ? 'e': 'w'\"\n               [rzMinWidth]=\"leftSidenavMinWidth\" [rzMaxWidth]=\"leftSidenavMaxWidth\"\n               [mode]=\"(showLeftSidenavCollapseBtn && sideNavToOverMode) ? 'over' : 'side'\"\n               disableClose [opened]=\"!showLeftSidenavCollapseBtn || (expandLeftSidenav && !sideNavToOverMode)\"\n               (openedChange)=\"onLeftSideNavOpenedChange($event)\"\n               (rzStop)=\"onResizeStop($event)\"\n               class=\"ex-sidenav-page-left-sidenav sel-sidenav-page-left-sidenav\"\n               [class.ex-sidenav-page-left-sidenav-has-resizable]=\"!!hasNgContent[SectionKeys.leftSidenavResizable]\"\n               [ngStyle]=\"{'width.px': leftSidenavWidth}\">\n    <div class=\"ex-sidenav-page-left-sidenav-content\"\n         [style.display]=\"((expandLeftSidenavChangeWithDelay | async) || expandLeftSidenav)?'':'none'\">\n      <ng-content #ngContent select=\"[left-sidenav-content]\"></ng-content>\n      <ng-container *ngIf=\"showLeftSidenavCollapseBtn\">\n        <ng-container [ngTemplateOutlet]=\"arrows\" [ngTemplateOutletContext]=\"{ sidenav: leftSidenav, side: 'left'}\">\n        </ng-container>\n      </ng-container>\n    </div>\n  </mat-sidenav>\n  <mat-sidenav-content class=\"ex-sidenav-page-content-wrapper\" [@blockInitialAnimation]>\n    <div #collapsedLeftSidenav [@transform]=\"showCollapsedSidenav('left')?'show':'hide'\"\n         class=\"ex-sidenav-page-left-sidenav-collapsed\"\n         [ngClass]=\"{ 'ex-sidenav-page-hide-left-sidenav' : !showLeftSidnav}\">\n      <div #defaultContent *ngIf=\"!hasNgContent[SectionKeys.collapsedLeftSidenav]\"\n           class=\"ex-sidenav-page-left-sidenav-collapsed-button-content\">\n        <ng-content select=\"[collapsed-left-sidenav-smallbox-content]\"></ng-content>\n      </div>\n      <button (click)=\"onSidenavToggled(leftSidenav,'left')\" class=\"ex-sidenav-page-left-sidenav-collapsed-button\">\n        <ng-content #ngContent select=\"[collapsed-left-sidenav-content]\"></ng-content>\n        <div #defaultContent *ngIf=\"!hasNgContent[SectionKeys.collapsedLeftSidenav]\"\n             class=\"ex-sidenav-page-left-sidenav-collapsed-button-content\">\n          <ex-dot-wrapper class=\"ex-sidenav-page-left-sidenav-collapsed-button-dot-wrapper\"\n                          [displayDot]=\"activeFacetsNumber && activeFacetsNumber>0\">\n            <p class=\"ex-sidenav-page-left-sidenav-label\" role=\"heading\" aria-level=\"1\"\n               [exTooltip]=\"activeFacetsToolTip\"\n               [attr.aria-label]=\"(leftSidenavLabel | translate) + (activeFacetsNumber && activeFacetsNumber > 0 ? '(' + activeFacetsNumber + ')' : '') \"\n               matTooltipClass=\"ex-sidenav-page-left-sidenav-toolTip\">{{leftSidenavLabel | translate}}\n              <span *ngIf=\"activeFacetsNumber && activeFacetsNumber>0\">&nbsp;({{activeFacetsNumber}})</span>\n            </p>\n          </ex-dot-wrapper>\n\n          <ng-content select=\"[collapsed-left-sidenav-smallbox-content-after-label]\"></ng-content>\n        </div>\n      </button>\n      <ng-container [ngTemplateOutlet]=\"arrows\" [ngTemplateOutletContext]=\"{ sidenav: leftSidenav, side: 'left'}\">\n      </ng-container>\n\n    </div>\n    <div #pageContent class=\"ex-sidenav-page-content\"\n         [ngStyle]=\"{'padding-inline-end': overlapRightSidenav && !showCollapsedSidenav('right')?  (pinOverlapRightSidenav? '10px': '300px'): '0px'}\">\n      <ng-content select=\"[sidenav-page-content]\"></ng-content>\n    </div>\n    <div role=\"complementary\" #collpasedRightSidenav [@transform]=\"showCollapsedSidenav('right')? 'show':'hide'\"\n         class=\"ex-sidenav-page-right-sidenav-collapsed\">\n      <button (click)=\"onSidenavToggled(rightSidenav,'right')\" class=\"ex-sidenav-page-right-sidenav-collapsed-button\">\n        <ng-content #ngContent select=\"[collapsed-right-sidenav-content]\"></ng-content>\n        <div #defaultContent *ngIf=\"!hasNgContent[SectionKeys.collapsedRightSidenav]\"\n             class=\"ex-sidenav-page-collapsed-right-sidenav-default-content\">\n          <ex-summary-sections-collapsed class=\"ex-sidenav-page-ex-summary-sections-collapsed\"\n                                         [summarySections]=\"rightSidenavSections\" [showWarningIcon]=\"showWarningIcon\">\n          </ex-summary-sections-collapsed>\n          <ng-content #collapsedFooter select=\"[collapsed-footer-content]\"></ng-content>\n        </div>\n      </button>\n      <ng-container *ngIf=\"showRightSidenavCollapseBtn\" [ngTemplateOutlet]=\"arrows\"\n                    [ngTemplateOutletContext]=\"{ sidenav: rightSidenav, side: 'right'}\">\n      </ng-container>\n    </div>\n  </mat-sidenav-content>\n  <mat-sidenav #rightSidenav *ngIf=\"hasNgContent[SectionKeys.rightSidenav]\" (rzStart)=\"onStarted($event)\"\n               [exResizable]=\"overlapRightSidenav\" [rzHandles]=\"direction == 'ltr' ? 'w': 'e'\"\n               [rzMinWidth]=\"rightSidenavWidth\"\n               [rzMaxWidth]=\"900\" position=\"end\"\n               [mode]=\"!pinOverlapRightSidenav && (overlapRightSidenav || sideNavToOverMode) ? 'over' : 'side'\"\n               disableClose\n               [opened]=\"expandRightSidenav && (!sideNavToOverMode || overlapRightSidenav)\"\n               (openedChange)=\"expandRightSidenav = $event\" class=\" ex-sidenav-page-right-sidenav\"\n               [ngStyle]=\"{'width.px': !overlapRightSidenav? rightSidenavWidth : 400}\">\n    <div role=\"complementary\" #rightSidenavContent *ngIf=\"!overlapRightSidenav\"\n         class=\"ex-sidenav-page-right-sidenav-content\">\n      <ng-content #ngContent select=\"[right-sidenav-content]\"></ng-content>\n      <ng-content #footer select=\"[footer-content]\"></ng-content>\n      <ng-container *ngIf=\"showRightSidenavCollapseBtn\" [ngTemplateOutlet]=\"arrows\"\n                    [ngTemplateOutletContext]=\"{ sidenav: rightSidenav, side: 'right'}\">\n      </ng-container>\n    </div>\n    <div role=\"complementary\" #overlapRightSidenavContent *ngIf=\"overlapRightSidenav\"\n         (keydown.escape)=\"setOverlapRightSidenav(false)\"\n         class=\"ex-sidenav-page-overlap-right-sidenav\">\n      <ng-content #ngContent select=\"[overlap-right-sidenav-content]\"></ng-content>\n      <div #defaultContent *ngIf=\"!hasNgContent[SectionKeys.overlapRightSidenav]\">\n        <div #header [style.background]=\"rightSidenavSectionsArray[rightSidenavOpenedSection].color\"\n             class=\"ex-sidenav-page-overlap-right-sidenav-header\">\n          <ex-icon [iconType]=\"rightSidenavSectionsArray[rightSidenavOpenedSection].iconType\"\n                   [iconName]=\"rightSidenavSectionsArray[rightSidenavOpenedSection].iconName\" color=\"white\"\n                   sizePx=\"18px\">\n          </ex-icon>\n          <span\n            class=\"ex-sidenav-page-overlap-right-sidenav-label\">{{ rightSidenavSectionsArray[rightSidenavOpenedSection].title | translate | uppercase }}</span>\n          <ex-button class=\"ex-sidenav-page-button\" (click)=\"setPinOverlapRightSidenav()\"\n                     [ngClass]=\"{ 'ex-sidenav-page-overlap-right-sidenav-collapse-pin' : !pinOverlapRightSidenav }\">\n            <ex-icon iconType=\"uxf\" color=\"white\" iconName=\"uxf-pin\" sizePx=\"13px\">\n            </ex-icon>\n          </ex-button>\n          <ex-button class=\"ex-sidenav-page-button\" (click)=\"setOverlapRightSidenav(false)\">\n            <ex-icon iconType=\"uxf\" color=\"white\" iconName=\"uxf-resize-small\" sizePx=\"17px\">\n            </ex-icon>\n          </ex-button>\n        </div>\n        <div #content class=\"ex-sidenav-page-overlap-right-sidenav-content\">\n          <ex-component-loader\n            [componentFactoryItem]=\"rightSidenavSectionsArray[rightSidenavOpenedSection]?.editSidePaneComponent\"\n            [data]=\"rightSidenavSectionsArray[rightSidenavOpenedSection]?.editSidePaneInputs\"\n            [events]=\"rightSidenavSectionsArray[rightSidenavOpenedSection]?.editSidePaneEvents\">\n          </ex-component-loader>\n        </div>\n      </div>\n    </div>\n  </mat-sidenav>\n</mat-sidenav-container>\n\n<ng-template #arrows let-sidenav=\"sidenav\" , let-side=\"side\">\n  <div class=\"ex-sidenav-page-arrow-wrapper\">\n    <button\n      [exTooltip]=\"((sidenav?.opened? 'ng.general.collapse': 'ng.general.expand') | translate) + ' ' + ((side === 'left' ? leftSidenavLabel : 'ng.general.sidebar') | translate)\"\n      [attr.aria-label]=\"((sidenav?.opened? 'ng.general.collapse': 'ng.general.expand') | translate) + ' ' + ((side === 'left' ? leftSidenavLabel : 'ng.general.sidebar') | translate)\"\n      (click)=\"onSidenavToggled(sidenav,side)\" class=\"ex-sidenav-page-arrows\"\n      [ngClass]=\"[displayLeftArrow(sidenav) ? 'sel-ex-sidnav-left-arrow': 'sel-ex-sidnav-right-arrow', sidenav?.opened ? 'ex-sidenav-arrows-opened' : '']\"\n      [ngStyle]=\"{'flex-direction':  side === 'left' ? 'row-reverse' : 'row',\n      'margin-inline-end': (side !== 'left' && sidenav?.opened) ? '10px' : '0px' , 'margin-inline-start': sidenav?.opened ? '10px' : '0px', 'background': !sidenav?.opened? 'transparent' : '' }\"\n      [attr.aria-expanded]=\"sidenav?.opened\">\n      <i [@arrowFlip]=\"sidenav?.opened? 'collapse' : 'expand'\"\n         [ngClass]=\"displayLeftArrow(sidenav)? 'fa-angle-double-left': 'fa-angle-double-right'\" class=\"fa fa-lg\"></i>\n    </button>\n  </div>\n</ng-template>\n", styles: [":dir(rtl) ::ng-deep .ex-dot-wrapper-style:after{inset-inline-end:7%!important;writing-mode:vertical-rl}.ex-sidenav-page-container{display:flex;height:100%}.ex-sidenav-page-container .ex-sidenav-page-hide-left-sidenav{display:none!important}.ex-sidenav-page-container .ex-sidenav-page-left-sidenav{border:none;position:absolute;overflow:hidden;background:#f2f2f2}.ex-sidenav-page-container .ex-sidenav-page-left-sidenav.ex-sidenav-page-left-sidenav-has-resizable{padding-inline-end:10px}.ex-sidenav-page-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content{height:100%;display:flex;flex-direction:column;position:relative;background:#f2f2f2}.ex-sidenav-page-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content:not(.ex-sidenav-page-left-sidenav-has-title){justify-content:space-between}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper{background:#f2f2f2;display:flex;flex:1;height:100%;overflow:hidden}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed{position:relative;display:flex;flex-direction:column}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed.ng-animating{animation:fadeIn linear 2s}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button{flex:1;width:40px;display:flex;flex-direction:column;outline:none;border:none;border-radius:5px;background:#f2f2f2}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button:focus{border:1px solid black!important}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button .ex-sidenav-page-left-sidenav-collapsed-button-content{align-self:center}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button .ex-sidenav-page-left-sidenav-collapsed-button-content .ex-sidenav-page-left-sidenav-collapsed-button-dot-wrapper>::ng-deep .ex-dot-wrapper-style:after{inset-inline-end:max(-20%,3px);bottom:max(-20%,-6px)}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-label{writing-mode:vertical-rl;display:flex;align-items:center;width:100%;margin-top:15px}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-content{width:100%}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-right-sidenav-collapsed{position:relative;display:flex;flex-direction:column;cursor:pointer}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-right-sidenav-collapsed.ng-animating{animation:fadeIn linear 2s}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-right-sidenav-collapsed .ex-sidenav-page-right-sidenav-collapsed-button{width:40px!important;flex:1;border:none;outline:none;background:#f2f2f2;display:flex;align-self:stretch;overflow:hidden}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-right-sidenav-collapsed .ex-sidenav-page-right-sidenav-collapsed-button .ex-sidenav-page-collapsed-right-sidenav-default-content{display:flex;flex-direction:column;height:100%;justify-content:space-between}.ex-sidenav-page-container .ex-sidenav-page-content-wrapper .ex-sidenav-page-right-sidenav-collapsed .ex-sidenav-page-right-sidenav-collapsed-button .ex-sidenav-page-collapsed-right-sidenav-default-content .ex-sidenav-page-ex-summary-sections-collapsed{align-self:stretch;overflow:hidden}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav{border:none;position:absolute}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-right-sidenav-content{background:#f2f2f2;position:relative;justify-content:flex-end;display:flex;flex-direction:column;min-height:100%}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav{width:100%}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav .ex-sidenav-page-overlap-right-sidenav-header{display:flex;justify-content:space-between;padding:20px;position:sticky;top:0;z-index:10000}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav .ex-sidenav-page-overlap-right-sidenav-header .ex-sidenav-page-overlap-right-sidenav-label{color:#fff;padding-inline-start:10px;flex:1}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav .ex-sidenav-page-overlap-right-sidenav-header .ex-sidenav-page-overlap-right-sidenav-collapse-pin ::ng-deep i{transform:rotate(45deg)}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav .ex-sidenav-page-overlap-right-sidenav-content{padding:20px;background:#fff}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav .ex-sidenav-page-overlap-right-sidenav .ex-sidenav-page-button ::ng-deep button{background-color:transparent!important;min-height:22px!important}.ex-sidenav-page-container .ex-sidenav-page-right-sidenav-not-resizable{width:300px!important;inset-inline-start:auto!important}.ex-sidenav-page-container .ex-sidenav-page-arrow-wrapper{display:flex;flex-direction:column;position:sticky;bottom:0;width:-webkit-fill-available}.ex-sidenav-page-container .ex-sidenav-page-arrow-wrapper.ex-sidenav-page-arrow-sticky-top{bottom:unset;top:0}.ex-sidenav-page-container .ex-sidenav-page-arrow-wrapper .ex-sidenav-page-arrows{display:flex;padding:12px;background:#e5e5e5;justify-content:space-between;border-radius:5px;margin-bottom:5px}.ex-sidenav-page-container .ex-sidenav-page-arrow-wrapper .ex-sidenav-page-arrows:not(:focus){border-color:transparent}.ex-sidenav-page-container .ex-sidenav-page-arrow-wrapper .ex-sidenav-arrows-opened:hover{background:#dfdfdf!important}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}::ng-deep .ex-sidenav-page-left-sidenav-toolTip{white-space:pre-line!important}::ng-deep .resize-handle-wrapper{height:100%;width:50%}::ng-deep .ng-resizable-handle:focus-within .resize-handle-wrapper{border:1px solid black}::ng-deep .ng-resizable-handle:focus{outline:none}\n"] }]
    }], function () { return [{ type: ExSidenavPageService, decorators: [{
                type: Optional
            }] }, { type: ExItemsLayoutService, decorators: [{
                type: Optional
            }] }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: i1$2.TranslateService }]; }, { leftSidenavLabel: [{
            type: Input
        }], leftSidenavMaxWidth: [{
            type: Input
        }], rightSidenavWidth: [{
            type: Input
        }], leftSidenavWidth: [{
            type: Input
        }], leftSidenavMinWidth: [{
            type: Input
        }], expandLeftSidenav: [{
            type: Input
        }], expandRightSidenav: [{
            type: Input
        }], showRightSidenavCollapseBtn: [{
            type: Input
        }], showLeftSidenavCollapseBtn: [{
            type: Input
        }], showWarningIcon: [{
            type: Input
        }], sideNavToOverMode: [{
            type: Input
        }], rightSidenavSections: [{
            type: Input
        }], isFullPageMode: [{
            type: Input
        }], isItemOpen: [{
            type: Input
        }], hasNgContent: [{
            type: Input
        }], showLeftSidnav: [{
            type: Input
        }], activeFacetsToolTip: [{
            type: Input
        }], activeFacetsNumber: [{
            type: Input
        }], expandRightSidenavChange: [{
            type: Output
        }], expandLeftSidenavChange: [{
            type: Output
        }], leftSidenavWidthChange: [{
            type: Output
        }], rightSidenav: [{
            type: ViewChild,
            args: ['rightSidenav', { static: false }]
        }], leftSidenav: [{
            type: ViewChild,
            args: ['leftSidenav']
        }], leftSidenavRef: [{
            type: ViewChild,
            args: ["leftSidenav", { read: ElementRef }]
        }], rightSidenavRef: [{
            type: ViewChild,
            args: ["rightSidenav", { read: ElementRef }]
        }] }); })();

const _c0$1I = ["sectionMenu"];
const _c1$16 = ["scrollerElement"];
const _c2$M = ["section"];
const _c3$C = ["sectionMenuItem"];
const _c4$t = ["expansionPanel"];
function ExSectionsLayoutComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExSectionsLayoutComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function ExSectionsLayoutComponent_div_4_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 11);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("iconName", "rejected")("color", "#f44336")("exTooltip", i0.ɵɵpipeBind1(1, 3, "ng.sections_layout.sections_with_error"));
} }
function ExSectionsLayoutComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_div_4_ex_svg_icon_1_Template, 2, 5, "ex-svg-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", true);
} }
function ExSectionsLayoutComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExSectionsLayoutComponent_ng_template_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ex-section-placeholder", 17)(2, "ex-section-placeholder", 17)(3, "ex-section-placeholder", 17)(4, "ex-section-placeholder", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("active", true)("showThumbnail", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("active", true)("showThumbnail", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("active", true)("showThumbnail", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("active", true)("showThumbnail", false);
} }
function ExSectionsLayoutComponent_ng_template_7_ng_content_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngIf", "displaySections || !showGenericPlaceHolder"]);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 31);
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r25.sectionsHeader[section_r13.exIdentifier]);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 31);
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", section_r13.header);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_ng_container_1_Template, 1, 1, "ng-container", 24);
    i0.ɵɵtemplate(2, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_ng_container_2_Template, 1, 1, "ng-container", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.sectionsHeader[section_r13.exIdentifier]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r13.header);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_dot_wrapper_5_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 35);
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("iconName", section_r13.icon.iconName);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_dot_wrapper_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-dot-wrapper", 33);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_dot_wrapper_5_ex_svg_icon_1_Template, 1, 1, "ex-svg-icon", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("displayDot", (section_r13.icon == null ? null : section_r13.icon.statusColor) != undefined)("color", section_r13.icon == null ? null : section_r13.icon.statusColor);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r13.icon != undefined);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", ctx_r22.getCountLabel(section_r13.exIdentifier), ") ");
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ex-svg-icon", 37);
    i0.ɵɵelementStart(2, "span", 38);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "ng.general.view-only"));
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_section_placeholder_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-section-placeholder", 17);
} if (rf & 2) {
    i0.ɵɵproperty("active", true)("showThumbnail", false);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-expansion-panel", 25, 26);
    i0.ɵɵlistener("expandedChange", function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template_mat_expansion_panel_expandedChange_0_listener($event) { i0.ɵɵrestoreView(_r36); const section_r13 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView(section_r13.expanded = $event); });
    i0.ɵɵelementStart(2, "mat-expansion-panel-header", 27);
    i0.ɵɵlistener("keydown.enter", function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template_mat_expansion_panel_header_keydown_enter_2_listener($event) { return $event.stopPropagation(); })("keydown.space", function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template_mat_expansion_panel_header_keydown_space_2_listener($event) { return $event.stopPropagation(); })("click", function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template_mat_expansion_panel_header_click_2_listener() { i0.ɵɵrestoreView(_r36); const section_r13 = i0.ɵɵnextContext(2).$implicit; const ctx_r39 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r39.onExpandSection(section_r13.exIdentifier, section_r13.expanded)); });
    i0.ɵɵtemplate(3, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_3_Template, 3, 2, "ng-container", 15);
    i0.ɵɵelementStart(4, "mat-panel-title", 28);
    i0.ɵɵtemplate(5, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_dot_wrapper_5_Template, 2, 3, "ex-dot-wrapper", 29);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_div_8_Template, 2, 1, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ng_container_9_Template, 5, 3, "ng-container", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainer(10, 31);
    i0.ɵɵtemplate(11, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_ex_section_placeholder_11_Template, 1, 2, "ex-section-placeholder", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(1);
    const section_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("mat-expansion-panel", false)("ex-sections-new-design", ctx_r17.newSectionsDesign);
    i0.ɵɵproperty("expanded", section_r13.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ex-sections-new-design", ctx_r17.newSectionsDesign);
    i0.ɵɵattribute("aria-expanded", _r19.expanded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r19.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", section_r13.icon != undefined && ctx_r17.newSectionsDesign);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 15, ctx_r17.getDisplayTitle(section_r13.exIdentifier)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r17.sectionsCount[section_r13.exIdentifier] == null ? null : ctx_r17.sectionsCount[section_r13.exIdentifier].count) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.newSectionsDesign && ctx_r17.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", section_r13.template);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r17.sectionsLoading[section_r13.exIdentifier] == null ? null : ctx_r17.sectionsLoading[section_r13.exIdentifier].loading) === true);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 31);
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", section_r13.template);
} }
const _c5$n = function (a0, a1, a2, a3) { return { "ex-sections-layout-highlighted-section": a0, "ex-sections-layout-selected-section": a1, "ex-sections-layout-not-valid-section": a2, "ex-sections-new-design": a3 }; };
function ExSectionsLayoutComponent_ng_template_7_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_mat_expansion_panel_1_Template, 12, 17, "mat-expansion-panel", 23);
    i0.ɵɵtemplate(2, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_ng_container_2_Template, 1, 1, "ng-container", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("display", (ctx_r15.sectionsLoading[section_r13.exIdentifier] == null ? null : ctx_r15.sectionsLoading[section_r13.exIdentifier].loading) === true || !ctx_r15.displaySections && ctx_r15.showGenericPlaceHolder ? "none" : "block");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(5, _c5$n, ctx_r15.sectionsHighlight[section_r13.exIdentifier], ctx_r15.sectionFocusedIdentifier === section_r13.exIdentifier, ctx_r15.sectionsValid[section_r13.exIdentifier] === false, ctx_r15.newSectionsDesign));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r13.hasCollapse);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !section_r13.hasCollapse);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_ex_section_placeholder_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-section-placeholder", 39);
} if (rf & 2) {
    const section_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("active", true)("showThumbnail", ctx_r16.sectionsLoading[section_r13.exIdentifier] == null ? null : ctx_r16.sectionsLoading[section_r13.exIdentifier].hasAvatar)("isExpanded", section_r13.expanded);
} }
function ExSectionsLayoutComponent_ng_template_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18, 19);
    i0.ɵɵlistener("focusout", function ExSectionsLayoutComponent_ng_template_7_div_5_Template_div_focusout_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r46); const section_r13 = restoredCtx.$implicit; const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.onSectionUnFocused(section_r13.exIdentifier)); })("focusin", function ExSectionsLayoutComponent_ng_template_7_div_5_Template_div_focusin_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r46); const section_r13 = restoredCtx.$implicit; const ctx_r47 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r47.onSectionFocused(section_r13.exIdentifier)); });
    i0.ɵɵtemplate(2, ExSectionsLayoutComponent_ng_template_7_div_5_div_2_Template, 3, 10, "div", 20);
    i0.ɵɵtemplate(3, ExSectionsLayoutComponent_ng_template_7_div_5_ex_section_placeholder_3_Template, 1, 3, "ex-section-placeholder", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r13 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-sections-new-design", ctx_r12.newSectionsDesign);
    i0.ɵɵproperty("id", section_r13.exIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.sectionsHasData[section_r13.exIdentifier] === true || ctx_r12.sectionsHasData[section_r13.exIdentifier] === undefined || ctx_r12.sectionsSelected[section_r13.exIdentifier] === true || section_r13.isMandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r12.sectionsLoading[section_r13.exIdentifier] == null ? null : ctx_r12.sectionsLoading[section_r13.exIdentifier].loading) === true);
} }
function ExSectionsLayoutComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 13);
    i0.ɵɵlistener("scroll", function ExSectionsLayoutComponent_ng_template_7_Template_div_scroll_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r48.onContainerScroll($event)); });
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵtemplate(3, ExSectionsLayoutComponent_ng_template_7_ng_container_3_Template, 5, 8, "ng-container", 15);
    i0.ɵɵtemplate(4, ExSectionsLayoutComponent_ng_template_7_ng_content_4_Template, 1, 0, "ng-content", 15);
    i0.ɵɵtemplate(5, ExSectionsLayoutComponent_ng_template_7_div_5_Template, 4, 5, "div", 16);
    i0.ɵɵprojection(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r4.displaySections && ctx_r4.showGenericPlaceHolder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.displaySections || !ctx_r4.showGenericPlaceHolder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.sortedSections);
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_ex_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 55);
} if (rf & 2) {
    const section_r56 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("iconType", section_r56.iconType)("iconName", section_r56.iconName)("color", section_r56.color);
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_ex_svg_icon_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 11);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("iconName", "rejected")("color", "#f44336")("exTooltip", i0.ɵɵpipeBind1(1, 3, "ng.sections_layout.section_with_error"));
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49, 50);
    i0.ɵɵlistener("click", function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); const section_r56 = ctx_r65.$implicit; const i_r57 = ctx_r65.index; const ctx_r64 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r64.onSectionSelected(section_r56.identifier, i_r57, true)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "div", 51);
    i0.ɵɵtemplate(6, ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_ex_icon_6_Template, 1, 3, "ex-icon", 52);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_span_10_Template, 2, 0, "span", 53);
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 54);
    i0.ɵɵtemplate(14, ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_ex_svg_icon_14_Template, 2, 5, "ex-svg-icon", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext();
    const section_r56 = ctx_r67.$implicit;
    const i_r57 = ctx_r67.index;
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("ex-sections-layout-sections-menu-item ", i0.ɵɵpipeBind1(2, 19, section_r56.identifier), "");
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(3, 21, ctx_r58.getDisplayTitle(section_r56.identifier)));
    i0.ɵɵproperty("exQuickAccessType", ctx_r58.quickAcssessTypes.SECTION)("exTooltip", i0.ɵɵpipeBind1(4, 23, ctx_r58.getDisplayTitle(section_r56.identifier)))("matTooltipPositionAtOrigin", true)("exKeyboardShortcutIndex", i_r57 + 1);
    i0.ɵɵattribute("aria-current", ctx_r58.currentActive === i_r57);
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("ex-sections-layout-sections-menu-item-active", ctx_r58.currentActive === i_r57);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r56.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("sel-section-menu-link-", section_r56.identifier, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 25, ctx_r58.getDisplayTitle(section_r56.identifier)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.displaySectionsStateIndications && ((ctx_r58.sectionsState[section_r56.identifier] == null ? null : ctx_r58.sectionsState[section_r56.identifier].hasRequired) || section_r56.hasRequired));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r58.sectionsCount[section_r56.identifier] == null ? null : ctx_r58.sectionsCount[section_r56.identifier].count) > 0 ? " (" + (ctx_r58.sectionsCount[section_r56.identifier] == null ? null : ctx_r58.sectionsCount[section_r56.identifier].count) + ")" : "", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.displaySectionsStateIndications && (ctx_r58.sectionsState[section_r56.identifier] == null ? null : ctx_r58.sectionsState[section_r56.identifier].hasTouchedOrDirtyWarningsErrors));
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_button_1_Template, 15, 27, "button", 48);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r56 = ctx.$implicit;
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r53.displayAllSections && !ctx_r53.viewMode || !section_r56.iconName);
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57)(1, "button", 58);
    i0.ɵɵlistener("click", function ExSectionsLayoutComponent_ng_template_9_div_0_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r68.displayAllClicked()); });
    i0.ɵɵelement(2, "ex-icon", 59);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", ctx_r54.displayAllSections ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", !ctx_r54.displayAllSections ? "Display empty sections" : "Hide empty sections", " ");
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_ex_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 60);
    i0.ɵɵlistener("click", function ExSectionsLayoutComponent_ng_template_9_div_0_ex_button_7_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r71); const ctx_r70 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r70.openQuickAccess()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "ex-svg-icon", 61);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("uniqueSelector", "ex-sections-layout-menu-quick-access")("tooltip", i0.ɵɵpipeBind1(1, 4, "ng.general.quick_access.tooltip"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", "Bolt");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "ng.general.quick_access.title"), " ");
} }
function ExSectionsLayoutComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "div", 43, 7);
    i0.ɵɵtemplate(3, ExSectionsLayoutComponent_ng_template_9_div_0_ng_container_3_Template, 2, 1, "ng-container", 44);
    i0.ɵɵelementStart(4, "div", 45);
    i0.ɵɵprojection(5, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExSectionsLayoutComponent_ng_template_9_div_0_div_6_Template, 4, 2, "div", 46);
    i0.ɵɵtemplate(7, ExSectionsLayoutComponent_ng_template_9_div_0_ex_button_7_Template, 5, 8, "ex-button", 47);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r50.sectionsList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r50.haveEmptySections && !ctx_r50.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r50.quickAccessActive == null ? null : ctx_r50.quickAccessActive());
} }
function ExSectionsLayoutComponent_ng_template_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵelement(1, "div", 63)(2, "span", 64)(3, "span", 64)(4, "span", 64)(5, "span", 64)(6, "span", 64);
    i0.ɵɵelementEnd();
} }
function ExSectionsLayoutComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExSectionsLayoutComponent_ng_template_9_div_0_Template, 8, 3, "div", 40);
    i0.ɵɵtemplate(1, ExSectionsLayoutComponent_ng_template_9_div_1_Template, 7, 0, "div", 41);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r6.hasMenu && !ctx_r6.sectionsMenuLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.hasMenu && ctx_r6.sectionsMenuLoading);
} }
const _c6$l = [[["", "section-bottom-content", ""]], "*", [["", "links", ""]]];
const _c7$h = function (a0) { return { left: a0, leftSidenavResizable: false }; };
const _c8$f = ["[section-bottom-content]", "*", "[links]"];
const VIEW_MODE = new InjectionToken('VIEW_MODE');
const VIEW_MODE_OBSERVABLE = new InjectionToken('VIEW_MODE_OBSERVABLE');
const NEW_SECTIONS_DESIGN = new InjectionToken('NEW_SECTIONS_DESIGN');
const MINIMUM_CONTENT_SIZE = 700;
const MAX_SEC_WAITING_FOR_SECTION_LOADING = 10 * 2000;
const DELAY_BEFORE_SHOW_MENU = 1500;
const DELAY_BEFORE_SHOW_CONTENT = 750;
class ExSectionsLayoutComponent {
    static { this.lastResponsiveState = false; }
    set order(order) {
        this._order = order;
        this.sortedSections = Array.from(this.sections ?? []);
        this.sortAndFilterSections();
        this.setComboboxOptions();
    }
    get order() {
        return this._order;
    }
    ;
    set viewMode(mode) {
        this._viewMode = mode;
        this._viewModeSubject.next(this._viewMode);
    }
    get viewMode() {
        return this._viewMode;
    }
    get displaySections() {
        return this.afterInitWaiting && !this.waitToSection;
    }
    constructor(translate, exSectionsLayoutService, exSectionsLayoutListLayoutService, element, cdRef, exNavigateToFieldService, isSingleSave, quickAccessService, quickAccessActive, exShortcuts, ngZone) {
        this.translate = translate;
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.exSectionsLayoutListLayoutService = exSectionsLayoutListLayoutService;
        this.element = element;
        this.cdRef = cdRef;
        this.exNavigateToFieldService = exNavigateToFieldService;
        this.isSingleSave = isSingleSave;
        this.quickAccessService = quickAccessService;
        this.quickAccessActive = quickAccessActive;
        this.exShortcuts = exShortcuts;
        this.ngZone = ngZone;
        /**
         * This feature creates a menu in the left side of the section.
         * It consist a menu for jump to sections. it presents in full screen (of the list) mode only
         */
        this.hasSectionsMenuInFullViewMode = true;
        /**
         * This feature creates a side nav in the left side of the section. It consist a menu for jump to sections.
         * it doesn't present in full screen (of the list) mode
         */
        this.showSectionsMenuInSidenav = false;
        this.showGenericPlaceHolder = true;
        this.waitToSection = false;
        this._viewMode = false;
        this.quickAcssessTypes = QuickAccessType;
        this.newSectionsDesign = true;
        this.responsive = true;
        /**
         * when the state of the section changed
         */
        this.expandSectionChange = new EventEmitter();
        /**
         * when the state of the sidepane changed
         */
        this.expandLeftSidenavChange = new EventEmitter();
        this.sectionsList = [];
        this.sectionsHasData = {};
        this.sectionsSelected = {};
        this.sectionsLoading = {};
        this.sectionsHeader = {};
        this.sectionsCount = {};
        this.sectionsState = {};
        this.displaySectionsStateIndications = true;
        this.sectionsHighlight = {};
        this.sectionsValid = {};
        this.selectedClicked = false;
        this.currentActive = 0;
        this.isFullPage = false;
        this.lastScrollTop = 0;
        this.sectionClicked = -1;
        this.displayAllSections = false;
        this.haveEmptySections = false;
        this.afterInitWaiting = false;
        this.sectionFocusedIdentifier = '';
        /**
         *  whether the sidepane of the sections takes its place or works in over mode
         */
        this.responsiveSideNavMenu = ExSectionsLayoutComponent.lastResponsiveState;
        this.sectionsMenuLoading = true;
        this.leftSidenavWidth = 200;
        this.scrollSectionsWithAnimation = false;
        this.subs = new Subscription();
        this._viewModeSubject = new BehaviorSubject(false);
        this.viewModeSubject$ = this._viewModeSubject.asObservable();
        this.onResized = (entries) => {
            const domSize = entries[0];
            const newRect = domSize.contentRect;
            if (newRect.width < MINIMUM_CONTENT_SIZE != this.responsiveSideNavMenu) {
                this.responsiveSideNavMenu = newRect.width < MINIMUM_CONTENT_SIZE;
                this.cdRef.markForCheck();
                if (ExSectionsLayoutComponent.lastResponsiveState && !this.responsiveSideNavMenu) { // workaround for open the sidenav when responsive is change to false.
                    let lastExpandState = this.expandLeftSidenavByUserPreferences;
                    this.expandLeftSidenavByUserPreferences = false;
                    this.cdRef.detectChanges();
                    this.expandLeftSidenavByUserPreferences = lastExpandState;
                    this.cdRef.detectChanges();
                }
            }
            ExSectionsLayoutComponent.lastResponsiveState = this.responsiveSideNavMenu;
        };
        this.exSectionsLayoutService.cleanData();
    }
    ngAfterContentInit() {
        this.initSections();
        this.sections.changes.subscribe(() => {
            this.initSections();
        });
        this.resizeObserver = new ResizeObserver(entries => this.onResized(entries));
        this.resizeObserver.observe(this.element.nativeElement);
        this.isLoading != true && this.exSectionsLayoutService.notifySectionsLayoutInitialized();
    }
    get showSideNav() {
        return (this.showSectionsMenuInSidenav && !this.isFullPage) || (this.hasSectionsMenuInFullViewMode && this.isFullPage);
    }
    ngOnInit() {
        let dir = document.documentElement.getAttribute('dir');
        this.directionClassIcon = dir === "rtl" ? 'fa-angle-double-left' : 'fa-angle-double-right';
        if (this.isLoading) {
            return;
        }
        this.subs.add(this.exSectionsLayoutService.sectionsHasDataChanged$.subscribe(({ identifier, hasData }) => {
            if (!hasData && this.sectionsHasData[identifier] == true)
                this.sectionsHasData[identifier] = true;
            else
                this.sectionsHasData[identifier] = hasData;
            if (!this.selectedClicked) {
                this.sectionsSelected[identifier] = false;
            }
            this.selectedClicked = false;
            this.setComboboxOptions();
        }));
        this.subs.add(this.exSectionsLayoutService.sectionsLoadingChanged$.subscribe(({ identifier, loading, hasAvatar }) => {
            this.sectionsLoading[identifier] = { loading, hasAvatar };
            this.setComboboxOptions();
        }));
        this.subs.add(this.exSectionsLayoutService.sectionsHeaderChanged$.subscribe(({ identifier, template }) => {
            defer(() => {
                this.sectionsHeader[identifier] = template;
            });
        }));
        this.subs.add(this.exSectionsLayoutService.sectionsCountChanged$.subscribe(({ identifier, count, additionalLabel, startIndex, endIndex }) => {
            defer(() => {
                this.sectionsCount[identifier] = { count, additionalLabel, startIndex, endIndex };
            });
        }));
        this.subs.add(this.exSectionsLayoutService.sectionSelected$.subscribe(id => {
            const i = this.sectionsList.findIndex(({ identifier }) => identifier === id);
            this.onSectionSelected(id, i);
        }));
        this.subs.add(this.exSectionsLayoutService.sectionsValidChanged$.subscribe(({ identifier, valid }) => {
            this.sectionsValid[identifier] = valid;
        }));
        this.subs.add(this.exSectionsLayoutService.sectionsFormsStateChange$.subscribe(formsState => {
            this.setSectionsState(formsState);
        }));
        this.subs.add(this.exSectionsLayoutListLayoutService.isFullPageChange.subscribe(isFullPage => {
            this.isFullPage = isFullPage;
        }));
        this.subs.add(this.exNavigateToFieldService?.focusOnFormField$.subscribe((data) => {
            this.openCollapsedSection(data.sectionId);
        }));
        this.subs.add(this.quickAccessService?.openSection$.subscribe((sectionId) => {
            this.openCollapsedSection(sectionId);
            this.scrollToSection(sectionId);
        }));
        if (this.isSingleSave)
            this.initSingleSaveEditModeSubscription();
        this.ngZone.runOutsideAngular(() => {
            this.timeoutDelayAfterInit = setTimeout(() => {
                this.afterInitWaiting = true;
            }, DELAY_BEFORE_SHOW_CONTENT);
        });
        setTimeout(() => {
            this.sectionsMenuLoading = false;
        }, DELAY_BEFORE_SHOW_MENU);
    }
    initSingleSaveEditModeSubscription() {
        this.subs.add(this.exSectionsLayoutService.sectionsEditMode$.subscribe(editMode => {
            this.displaySectionsStateIndications = editMode;
            if (editMode == true)
                this.expandSectionByIdentifier(undefined);
            this.scrollToActiveSectionAfterEditModeChange();
        }));
    }
    setSectionsState(formsState) {
        let sectionsState = {};
        Object.entries(formsState).forEach(([key, value]) => {
            const sectionIdentifier = key.slice(0, key.lastIndexOf(SECTION_FORM_IDENTIFIER_DELIMITER));
            const { touched, dirty, hasTouchedOrDirtyWarningsErrors, hasRequired } = sectionsState[sectionIdentifier] ?? {};
            sectionsState[sectionIdentifier] = {
                touched: !!touched || !!value.touched,
                dirty: !!dirty || !!value.dirty,
                hasTouchedOrDirtyWarningsErrors: !!hasTouchedOrDirtyWarningsErrors || !!value.hasTouchedOrDirtyWarningsErrors,
                hasRequired: !!hasRequired || !!value.hasRequired
            };
        });
        this.sectionsState = sectionsState;
    }
    get hasSectionWithError() {
        return Object.entries(this.sectionsState).some(([sectionId, state]) => state.hasTouchedOrDirtyWarningsErrors);
    }
    initSections() {
        this.sortedSections = Array.from(this.sections);
        this.exSectionsLayoutService.changeSectionsList(this.sortedSections);
        this.sortAndFilterSections();
        this.setComboboxOptions();
        this.responsiveSideNavMenu = this.element.nativeElement.offsetWidth < MINIMUM_CONTENT_SIZE;
        ExSectionsLayoutComponent.lastResponsiveState = this.responsiveSideNavMenu;
    }
    ngOnDestroy() {
        this.exSectionsLayoutService.resetSectionsEdit();
        this.resizeObserver.disconnect();
        this.subs.unsubscribe();
        clearInterval(this.scrollInterval);
    }
    onContainerScroll(event) {
        if (this.sectionsElements.length > 0 && !Object.keys(this.sectionsLoading).some(key => this.sectionsLoading[key]?.loading)) {
            this.checkOffsetTop(event);
        }
    }
    checkOffsetTop(e) {
        if (this.sectionClicked !== -1) {
            this.currentActive = this.sectionClicked;
            return;
        }
        const arr = this.sectionsElements.toArray();
        if (e.target.scrollTop > this.lastScrollTop) { //scroll down
            for (let i = 0; i < arr.length; i++) {
                if (e.target.scrollTop >= arr[i].nativeElement.offsetTop - (this.newSectionsDesign ? 100 : 50) && (i == arr.length - 1 || e.target.scrollTop < arr[i + 1].nativeElement.offsetTop - (this.newSectionsDesign ? 100 : 50))) {
                    this.setCurrentActive(i);
                    break;
                }
            }
            //scroller is at bottom of div
            if (Math.abs(e.srcElement.scrollTop - (e.srcElement.scrollHeight - e.srcElement.offsetHeight)) < 2) {
                let z = arr.length - 1;
                while (this.sectionsList[z] && this.sectionsList[z].iconName !== null) {
                    z = z - 1;
                }
                this.setCurrentActive(z);
            }
        }
        else { //scroll up
            for (let i = 0; i < arr.length - 1; i++) {
                if (e.target.scrollTop >= arr[i].nativeElement.offsetTop + 43 && e.target.scrollTop < arr[i + 1].nativeElement.offsetTop + 43) {
                    let z = i + 1;
                    while (this.sectionsList[z] && this.sectionsList[z].iconName !== null) {
                        z = z + 1;
                    }
                    if (z < this.currentActive) {
                        this.setCurrentActive(z);
                    }
                    break;
                }
            }
            //scroller is at top of div
            if (e.target.scrollTop < 50) {
                let z = 0;
                while (this.sectionsList[z] && this.sectionsList[z].iconName !== null) {
                    z = z + 1;
                }
                this.setCurrentActive(z);
            }
        }
        this.lastScrollTop = e.target.scrollTop;
    }
    setCurrentActive(cur) {
        if (!!this.sectionsList[cur]?.identifier && this.currentActive != cur) {
            this.currentActive = cur;
            this.exSectionsLayoutService.updateScrollLocation(this.sectionsList[cur].identifier);
        }
    }
    sortAndFilterSections() {
        if (this.sortedSections && this.order) {
            this.sortedSections = this.sortedSections
                .filter(section => this.order[section.exIdentifier] !== -1)
                .sort((section1, section2) => {
                return this.order[section1.exIdentifier] - this.order[section2.exIdentifier];
            });
        }
    }
    setComboboxOptions() {
        if (this.sortedSections) {
            this.haveEmptySections = false;
            this.sectionsList = this.sortedSections.map(item => {
                let iconType = 'uxf';
                let iconName = 'uxf-plus-circle';
                if (this.sectionsHasData[item.exIdentifier] === true
                    || this.sectionsHasData[item.exIdentifier] === undefined
                    || this.sectionsSelected[item.exIdentifier] === true
                    || item.isMandatory) {
                    iconType = 'none';
                    iconName = null;
                }
                else {
                    this.haveEmptySections = true;
                }
                return {
                    identifier: item.exIdentifier,
                    value: this.translate.instant(this.getDisplayTitle(item.exIdentifier)),
                    iconType,
                    iconName,
                    iconColor: '#4164a4',
                    hasRequired: item.hasRequired,
                    title: item.title
                };
            });
            this.exSectionsLayoutService.changeSectionsComboboxList(this.sectionsList.filter(item => item.iconName === null || !this.viewMode));
        }
    }
    onExpandSection(sectionId, isExpanded) {
        this.expandSectionChange.emit({ sectionId, isExpanded });
    }
    onSectionSelected(id, i, scrollSectionsWithAnimation = false) {
        this.scrollSectionsWithAnimation = scrollSectionsWithAnimation;
        if (this.responsiveSideNavMenu && !this.isFullPage && this.exSidenavPage) {
            this.exSidenavPage.collapseSidenavs();
        }
        this.sectionsSelected[id] = true;
        this.sectionsHighlight[id] = true;
        this.sectionFocusedIdentifier = id;
        setTimeout(() => {
            this.sectionsHighlight[id] = false;
        }, 3000);
        this.selectedClicked = true;
        this.setComboboxOptions();
        this.sectionClicked = i;
        this.openCollapsedSection(id);
        this.setCurrentActive(this.sectionClicked);
        this.scrollWithWait(id);
        setTimeout(() => {
            this.sectionClicked = -1;
        }, 500);
    }
    openCollapsedSection(id) {
        this.expPanelsRef.toArray().map(panelRef => this.getIdFromPanelRef(panelRef)).forEach((key, index) => {
            if (key === id) {
                this.expPanels.toArray()[index].open();
            }
        });
    }
    getIdFromPanelRef(panelRef) {
        return panelRef?.nativeElement?.parentElement?.parentElement?.id;
    }
    /**
     * expands the panel of the section with the given identifier.
     * If identifier is undefined, expands all panels.
     */
    expandSectionByIdentifier(identifier) {
        this.sortedSections.some((section) => {
            const _isNil = isNil(identifier);
            const isThisSection = identifier == section.exIdentifier;
            if (_isNil || isThisSection) {
                section.expanded = true;
                return !_isNil && isThisSection;
            }
            else
                return false;
        });
    }
    scrollToActiveSectionAfterEditModeChange() {
        const activeSectionBeforeEdit = this.sectionsList[this.currentActive]?.identifier;
        if (activeSectionBeforeEdit) {
            setTimeout(() => {
                this.scrollWithWait(activeSectionBeforeEdit);
            }, 200);
        }
    }
    scrollWithWait(identifier) {
        clearInterval(this.scrollInterval);
        const scrolled = this.intervalFunc(identifier);
        if (!scrolled) {
            this.scrollInterval = setInterval(() => {
                if (this.intervalFunc(identifier)) {
                    clearInterval(this.scrollInterval);
                    this.scrollInterval = null;
                }
            }, 100);
            //Setting a max time for the interval function to run
            setTimeout(() => {
                if (this.scrollInterval != null) {
                    clearInterval(this.scrollInterval);
                    this.waitToSection = false;
                }
            }, MAX_SEC_WAITING_FOR_SECTION_LOADING);
        }
    }
    intervalFunc(identifier) {
        if (!this.afterInitWaiting && !this.waitToSection) {
            if (this.sectionsLoading[identifier]?.loading) {
                clearTimeout(this.timeoutDelayAfterInit);
                this.waitToSection = true;
                this.afterInitWaiting = true;
                this.cdRef.markForCheck();
            }
            return false;
        }
        if (this.sectionsLoading[identifier]?.loading) {
            // don't remove the shimmer until the section will load
            this.waitToSection = true;
            return false;
        }
        else {
            this.waitToSection = false;
            this.scrollToSection(identifier);
            return true;
        }
    }
    scrollToSection(identifier) {
        const elementIndex = this.sectionsList.findIndex((current) => current.identifier === identifier);
        const selectedSection = this.sectionsElements.get(elementIndex);
        if (this.scrollerElement && selectedSection) {
            this.waitToSection = false;
            setTimeout(() => {
                if (this.scrollSectionsWithAnimation) {
                    const scroller = $(this.scrollerElement.nativeElement);
                    scroller?.animate({ scrollTop: selectedSection.nativeElement.offsetTop - (this.newSectionsDesign ? 50 : 0) }, 500, 'easeOutExpo');
                    selectedSection.nativeElement.focus();
                }
                else {
                    selectedSection.nativeElement.focus();
                    this.scrollerElement.nativeElement.scrollTo(0, (selectedSection.nativeElement.offsetTop - (this.newSectionsDesign ? 50 : 0)));
                }
            });
        }
    }
    get hasMenu() {
        return (this.sectionsList?.length > 0 || this.isLoading)
            && (this.showSectionsMenuInSidenav || (this.hasSectionsMenuInFullViewMode && this.isFullPage));
    }
    displayAllClicked() {
        this.displayAllSections = !this.displayAllSections;
    }
    getCountLabel(identifier) {
        let countLabel;
        if (this.sectionsCount[identifier].startIndex > 0 && this.sectionsCount[identifier].endIndex > 0) {
            const paramLabels = {
                startIndex: this.sectionsCount[identifier].startIndex,
                endIndex: this.sectionsCount[identifier].endIndex,
                count: this.sectionsCount[identifier].count
            };
            countLabel = this.translate.instant('ng.general.section_pagination', paramLabels);
        }
        else
            countLabel = this.sectionsCount[identifier].count;
        if (this.sectionsCount[identifier].additionalLabel) {
            countLabel += this.sectionsCount[identifier].additionalLabel;
        }
        return countLabel;
    }
    onSectionFocused(id) {
        const i = this.sectionsList.findIndex(({ identifier }) => identifier === id);
        this.setCurrentActive(i);
    }
    onSectionUnFocused(id) {
        this.sectionFocusedIdentifier = '';
    }
    openQuickAccess() {
        this.quickAccessService?.openDialog();
    }
    getDisplayTitle(identifier) {
        return this.exSectionsLayoutService.getSectionTitle(identifier);
    }
    handleKeyDown(event) {
        if (this.quickAccessActive?.() && event.key === '.' && !((document?.activeElement?.tagName === 'INPUT' || document?.activeElement?.tagName === 'TEXTAREA') && document?.activeElement?.type.includes('text')) && this.exShortcuts?.scope?.name == "main") {
            this.quickAccessService?.openDialog();
        }
    }
    onFocusOut(event) {
        this.quickAccessActive?.() && this.quickAccessService?.focusOut.next(event);
    }
    static { this.ɵfac = function ExSectionsLayoutComponent_Factory(t) { return new (t || ExSectionsLayoutComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutListLayoutService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(EX_NAVIGATE_TO_FIELD, 8), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS_ACTIVE, 8), i0.ɵɵdirectiveInject(ExShortcutsService, 8), i0.ɵɵdirectiveInject(i0.NgZone)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSectionsLayoutComponent, selectors: [["ex-sections-layout"]], contentQueries: function ExSectionsLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExSectionIdentifierDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sections = _t);
        } }, viewQuery: function ExSectionsLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1I, 5);
            i0.ɵɵviewQuery(ExSidenavPageComponent, 5);
            i0.ɵɵviewQuery(_c1$16, 5);
            i0.ɵɵviewQuery(_c2$M, 5);
            i0.ɵɵviewQuery(_c3$C, 5);
            i0.ɵɵviewQuery(_c4$t, 5);
            i0.ɵɵviewQuery(_c4$t, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sectionsMenuElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.exSidenavPage = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollerElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sectionsElements = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sectionsMenuElements = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expPanels = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expPanelsRef = _t);
        } }, hostBindings: function ExSectionsLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function ExSectionsLayoutComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyDown($event); }, false, i0.ɵɵresolveWindow)("click", function ExSectionsLayoutComponent_click_HostBindingHandler($event) { return ctx.onFocusOut($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { hasSectionsMenuInFullViewMode: "hasSectionsMenuInFullViewMode", showSectionsMenuInSidenav: "showSectionsMenuInSidenav", showGenericPlaceHolder: "showGenericPlaceHolder", isLoading: "isLoading", order: "order", viewMode: "viewMode", expandLeftSidenavByUserPreferences: "expandLeftSidenavByUserPreferences", newSectionsDesign: "newSectionsDesign", responsive: "responsive" }, outputs: { expandSectionChange: "expandSectionChange", expandLeftSidenavChange: "expandLeftSidenavChange" }, features: [i0.ɵɵProvidersFeature([
                ExSectionsLayoutApmService,
                {
                    provide: VIEW_MODE,
                    useFactory: (sections) => {
                        return () => sections.viewMode;
                    },
                    deps: [ExSectionsLayoutComponent]
                },
                {
                    provide: VIEW_MODE_OBSERVABLE,
                    useFactory: (sections) => {
                        return sections.viewModeSubject$;
                    },
                    deps: [ExSectionsLayoutComponent]
                },
                {
                    provide: NEW_SECTIONS_DESIGN,
                    useFactory: (sections) => {
                        return sections.newSectionsDesign;
                    },
                    deps: [ExSectionsLayoutComponent]
                },
                { provide: EX_QUICK_ACCESS_SCOPE, useValue: true }
            ])], ngContentSelectors: _c8$f, decls: 11, vars: 13, consts: [[1, "ex-sections-layout-wrapper"], [3, "hasNgContent", "leftSidenavLabel", "leftSidenavWidth", "sideNavToOverMode", "showLeftSidenavCollapseBtn", "expandLeftSidenav", "expandLeftSidenavChange"], ["left-sidenav-content", "", 4, "ngIf"], ["collapsed-left-sidenav-smallbox-content-after-label", "", "class", "ex-sections-layout-sections-menu-collapsed-has-invalid", 4, "ngIf"], ["sidenav-page-content", ""], [4, "ngTemplateOutlet"], ["sections", ""], ["sectionMenu", ""], ["left-sidenav-content", ""], ["collapsed-left-sidenav-smallbox-content-after-label", "", 1, "ex-sections-layout-sections-menu-collapsed-has-invalid"], [3, "iconName", "color", "exTooltip", 4, "ngIf"], [3, "iconName", "color", "exTooltip"], ["role", "main", "aria-labelledby", "selectedItemInList", "tabindex", "-1", 1, "ex-sections-layout-sections-wrapper-scroller", 3, "scroll"], ["scrollerElement", ""], [1, "ex-sections-layout-sections-wrapper"], [4, "ngIf"], ["class", "ex-sections-layout-section-wrapper", "tabindex", "-1", 3, "id", "ex-sections-new-design", "focusout", "focusin", 4, "ngFor", "ngForOf"], [3, "active", "showThumbnail"], ["tabindex", "-1", 1, "ex-sections-layout-section-wrapper", 3, "id", "focusout", "focusin"], ["section", ""], ["class", "ex-sections-layout-section", 3, "display", "ngClass", 4, "ngIf"], [3, "active", "showThumbnail", "isExpanded", 4, "ngIf"], [1, "ex-sections-layout-section", 3, "ngClass"], ["class", "ex-sections-layout-section-expansion-panel mat-content-density back-color no-shadow", 3, "mat-expansion-panel", "ex-sections-new-design", "expanded", "expandedChange", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], [1, "ex-sections-layout-section-expansion-panel", "mat-content-density", "back-color", "no-shadow", 3, "expanded", "expandedChange"], ["expansionPanel", "matExpansionPanel"], ["tabindex", "0", "aria-disabled", "false", 1, "ex-sections-layout-section-expansion-header", "mat-header-density", 3, "keydown.enter", "keydown.space", "click"], ["role", "heading", "aria-level", "3", 1, "ex-sections-layout-title"], ["class", "ex-sections-layout-title-list-icon", 3, "displayDot", "color", 4, "ngIf"], ["id", "items_count", "class", "ex-sections-items-count", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "active", "showThumbnail", 4, "ngIf"], [1, "ex-sections-layout-title-list-icon", 3, "displayDot", "color"], [3, "iconName", 4, "ngIf"], [3, "iconName"], ["id", "items_count", 1, "ex-sections-items-count"], ["iconName", "View-Icon", "color", "'#666666'"], [1, "ex-sections-layout-title-view-only"], [3, "active", "showThumbnail", "isExpanded"], ["role", "navigation", "exShortcutsScope", "main", "class", "ex-sections-layout-sections-menu-wrapper", 4, "ngIf"], ["class", "ex-sections-layout-placeholder-list ex-sections-layout-sections-menu-wrapper", 4, "ngIf"], ["role", "navigation", "exShortcutsScope", "main", 1, "ex-sections-layout-sections-menu-wrapper"], [1, "ex-sections-layout-sections-menu"], [4, "ngFor", "ngForOf"], [1, "ex-sections-layout-menu-links"], ["class", "ex-sections-layout-sections-footer", 4, "ngIf"], ["class", "ex-sections-layout-menu-quick-access-wrapper", "type", "action", 3, "uniqueSelector", "tooltip", "click", 4, "ngIf"], ["matTooltipPosition", "after", "exKeyboardShortcut", "TabNavigation", 3, "exQuickAccess", "exQuickAccessType", "class", "exTooltip", "matTooltipPositionAtOrigin", "exKeyboardShortcutIndex", "click", 4, "ngIf"], ["matTooltipPosition", "after", "exKeyboardShortcut", "TabNavigation", 3, "exQuickAccess", "exQuickAccessType", "exTooltip", "matTooltipPositionAtOrigin", "exKeyboardShortcutIndex", "click"], ["sectionMenuItem", ""], [1, "ex-sections-layout-sections-menu-item-line"], ["sizePx", "16px", 3, "iconType", "iconName", "color", 4, "ngIf"], ["class", "ex-sections-layout-sections-menu-has-required", 4, "ngIf"], [1, "ex-sections-layout-sections-menu-is-invalid"], ["sizePx", "16px", 3, "iconType", "iconName", "color"], [1, "ex-sections-layout-sections-menu-has-required"], [1, "ex-sections-layout-sections-footer"], [3, "click"], ["iconType", "matIcon", 3, "iconName"], ["type", "action", 1, "ex-sections-layout-menu-quick-access-wrapper", 3, "uniqueSelector", "tooltip", "click"], [1, "ex-sections-layout-menu-quick-access-icon", 3, "iconName"], [1, "ex-sections-layout-placeholder-list", "ex-sections-layout-sections-menu-wrapper"], [1, "ex-sections-layout-placeholder-list-animate"], [1, "ex-sections-layout-placeholder-list-line"]], template: function ExSectionsLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c6$l);
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-sidenav-page", 1);
            i0.ɵɵlistener("expandLeftSidenavChange", function ExSectionsLayoutComponent_Template_ex_sidenav_page_expandLeftSidenavChange_1_listener($event) { return ctx.expandLeftSidenavChange.emit($event); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtemplate(3, ExSectionsLayoutComponent_ng_container_3_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(4, ExSectionsLayoutComponent_div_4_Template, 2, 1, "div", 3);
            i0.ɵɵelementContainerStart(5, 4);
            i0.ɵɵtemplate(6, ExSectionsLayoutComponent_ng_container_6_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, ExSectionsLayoutComponent_ng_template_7_Template, 7, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, ExSectionsLayoutComponent_ng_template_9_Template, 2, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(8);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hasNgContent", i0.ɵɵpureFunction1(11, _c7$h, ctx.showSideNav))("leftSidenavLabel", i0.ɵɵpipeBind1(2, 9, "ng.general.sections"))("leftSidenavWidth", ctx.leftSidenavWidth)("sideNavToOverMode", ctx.responsive && ctx.responsiveSideNavMenu && !ctx.isFullPage)("showLeftSidenavCollapseBtn", !ctx.isFullPage)("expandLeftSidenav", ctx.expandLeftSidenavByUserPreferences || ctx.isFullPage);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showSideNav);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasSectionWithError);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", _r3);
        } }, styles: ["[_nghost-%COMP%]{display:block;width:100%;height:100%}.ex-sections-layout-wrapper[_ngcontent-%COMP%]{height:100%;margin-top:-43px;position:relative}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container{background:transparent!important;z-index:unset!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container .ex-sidenav-page-left-sidenav{background:#fff!important;z-index:23!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container .ex-sidenav-page-left-sidenav .mat-drawer-inner-container{overflow-x:hidden!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content{background:transparent!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content .ex-sidenav-page-arrow-wrapper{z-index:21}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content .ex-sidenav-page-arrow-wrapper .ex-sidenav-page-arrows{margin-inline-start:0!important;margin-inline-end:10px!important;background:#f2f2f2!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content{background:transparent!important;z-index:unset!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed{max-width:30px!important;z-index:22!important;margin-inline-end:15px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button{width:30px!important;background:#fff!important;border-inline-end:1px solid #e0e0e0!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button .ex-sidenav-page-left-sidenav-collapsed-button-content{margin-inline-start:-10px!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-arrow-wrapper{border-inline-end:1px solid #e0e0e0!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]     mat-sidenav-container mat-sidenav-content .ex-sidenav-page-content{display:flex!important;width:unset!important;overflow:hidden!important;flex:1}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper-has-mask[_ngcontent-%COMP%]{-webkit-mask-image:linear-gradient(to bottom,#fff 80%,#fff0);mask-image:linear-gradient(to bottom,#fff 80%,#fff0)}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]{padding-top:50px;overflow:auto;overflow-x:hidden;margin-inline-end:10px;margin-bottom:1px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]{width:190px;padding-inline-end:3px;scrollbar-width:none;-ms-overflow-style:none;overflow:auto}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]{background:transparent;border:none;text-align:start;width:90%;justify-content:space-between;display:flex;flex-direction:row;outline:none}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item-line[_ngcontent-%COMP%]{padding-inline-start:10px;padding-top:5px;padding-bottom:5px;border-inline-start:4px solid transparent;padding-inline-end:3px;display:flex;min-width:0px;gap:2px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item-line[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item-line[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-of-type{min-width:-moz-fit-content;min-width:fit-content}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item-invalid[_ngcontent-%COMP%], .ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item-warnings[_ngcontent-%COMP%]{color:red}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-dirty[_ngcontent-%COMP%]{position:relative}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-dirty[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:25%;height:10px;width:10px;border-radius:50%;border:2px solid #fff;background:gray}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-has-required[_ngcontent-%COMP%]{color:#f44336}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-is-invalid[_ngcontent-%COMP%]{display:flex;align-items:center}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-item[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]   .ex-sections-layout-menu-links[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:6px;margin:10px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-footer[_ngcontent-%COMP%]{display:flex;align-items:center;height:50px;border-top:1px solid #ccc;margin-top:15px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:transparent;border:none;color:#4164a4;font-weight:400;padding:10px;display:flex}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-right:5px;margin-top:2px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu[_ngcontent-%COMP%]::-webkit-scrollbar{width:0;height:0}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-placeholder-list[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;padding-inline-end:3px;padding-inline-start:16px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-placeholder-list[_ngcontent-%COMP%]   .ex-sections-layout-placeholder-list-line[_ngcontent-%COMP%]{width:80%;height:21px;background:#f3f5f4 0 0 no-repeat padding-box;border-radius:3px;opacity:1;margin-top:7px;margin-bottom:7px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-placeholder-list[_ngcontent-%COMP%]   .ex-sections-layout-placeholder-list-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;inset:0;position:absolute}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]{overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:row;width:100%}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:15px;padding-inline-start:5px;flex:1;width:100%;padding-block-start:50px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-combobox[_ngcontent-%COMP%]{position:absolute;top:10px;z-index:1000}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]:not(.ex-sections-new-design){padding-top:45px;margin-top:-45px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper.ex-sections-new-design[_ngcontent-%COMP%]{padding-bottom:24px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]{position:relative}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]:not(.ex-sections-new-design)     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-body{margin-top:5px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]:not(.ex-sections-new-design)     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-content{margin-inline-start:5px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section.ex-sections-new-design[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header{padding:9px 0!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section.ex-sections-new-design[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-content{margin-inline-start:16px!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header{height:-moz-fit-content!important;height:fit-content!important;padding:7px 0;align-items:unset;color:#000000de!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-content{flex-wrap:wrap;align-items:center;margin-inline-start:5px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-expansion-indicator{align-self:flex-start;padding:0 16px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-expansion-indicator:after{margin-bottom:5px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-body{padding:0!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-content{font-size:inherit}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header{cursor:pointer}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:not(.ex-sections-new-design){border-top:1px solid;border-color:#e0e0e0}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header.ex-sections-new-design{border:1px solid rgba(196,196,196,.5019607843);border-radius:4px;background-color:#eaf2f6}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header.ex-sections-new-design.mat-expanded{border-radius:4px 4px 0 0!important;border-bottom:none}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:hover{background:#e8edf0}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:hover:not(.ex-sections-new-design){border-radius:0 0 5px 5px;background:#0000000a}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus-visible{background:#0000000a;border:1px solid #898989!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus-visible:not(.ex-sections-new-design){border-radius:0 0 5px 5px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus:not(.ex-sections-new-design){outline:black solid 1px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header .ex-sections-layout-title .ex-sections-layout-title-list-icon{height:16px;margin-inline-end:10px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header .ex-sections-layout-title-view-only{font-weight:400;font-size:14px;color:#666;margin-inline-start:2px}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section[_ngcontent-%COMP%]     mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header   .ex-button-action:hover{background-color:inherit!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-not-valid-section[_ngcontent-%COMP%]{border:1px solid #c62726;border-radius:5px;padding-right:5px;box-shadow:0 0 5px #c62726;transform:scale(1);animation:pulse 2s ease-in}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-highlighted-section[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_highlighted-section-fade 3s;animation-timing-function:ease-out}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-highlighted-section[_ngcontent-%COMP%]     .ex-section-wrapper{animation:_ngcontent-%COMP%_highlighted-section-fade 3s;animation-timing-function:ease-out}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-selected-section.ex-sections-new-design[_ngcontent-%COMP%]     .ex-section-wrapper:not(.first){border-color:#0e7cbb!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper-scroller[_ngcontent-%COMP%]   .ex-sections-layout-sections-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-section-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-selected-section.ex-sections-new-design[_ngcontent-%COMP%]     .ex-section-content-wrapper{border-color:#0e7cbb!important}.ex-sections-layout-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-sections-menu-collapsed-has-invalid[_ngcontent-%COMP%]{margin-top:15px}.ex-sections-layout-section-expansion-panel.mat-expanded[_ngcontent-%COMP%]:not(.ex-sections-new-design)    >div.mat-expansion-panel-content{margin-bottom:15px}.ex-sections-layout-section-expansion-panel.mat-expanded[_ngcontent-%COMP%]    >div.mat-expansion-panel-content{height:unset!important;visibility:visible!important}.ex-sections-layout-section-expansion-panel[_ngcontent-%COMP%]:not(.mat-expanded)    >div.mat-expansion-panel-content{overflow:hidden}@keyframes _ngcontent-%COMP%_highlighted-section-fade{0%{background-color:#fff9d6}}.expansion-icons[_ngcontent-%COMP%]{height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content;padding:0;margin-right:1px;margin-top:1px}.ex-sections-items-count[_ngcontent-%COMP%]{display:flex;margin-inline-start:3px}.ex-sections-layout-left-side[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:sticky;top:20px;z-index:20;min-width:200px;overflow:auto}.ex-sections-collapsed-left-sidenav-smallbox-arrow[_ngcontent-%COMP%]{margin-top:10px}[_nghost-%COMP%]  .ng-animating.mat-expansion-panel-content{overflow:hidden}.ex-sections-layout-menu-quick-access-wrapper[_ngcontent-%COMP%]{border-top:1px solid #e0e0e0;padding-inline-end:17px;margin-inline-start:3px}.ex-sections-layout-menu-quick-access-wrapper[_ngcontent-%COMP%]   .ex-sections-layout-menu-quick-access-icon[_ngcontent-%COMP%]{margin-inline-end:7px}.ex-sections-layout-menu-quick-access[_ngcontent-%COMP%]{color:#4164a4}.ex-sections-layout-menu-quick-access[_ngcontent-%COMP%]:hover{color:#1b3c72;text-decoration-line:underline}"], data: { animation: [Animations$b] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-sections-layout', animations: [Animations$b], providers: [
                    ExSectionsLayoutApmService,
                    {
                        provide: VIEW_MODE,
                        useFactory: (sections) => {
                            return () => sections.viewMode;
                        },
                        deps: [ExSectionsLayoutComponent]
                    },
                    {
                        provide: VIEW_MODE_OBSERVABLE,
                        useFactory: (sections) => {
                            return sections.viewModeSubject$;
                        },
                        deps: [ExSectionsLayoutComponent]
                    },
                    {
                        provide: NEW_SECTIONS_DESIGN,
                        useFactory: (sections) => {
                            return sections.newSectionsDesign;
                        },
                        deps: [ExSectionsLayoutComponent]
                    },
                    { provide: EX_QUICK_ACCESS_SCOPE, useValue: true }
                ], template: "<div class=\"ex-sections-layout-wrapper\">\n  <ex-sidenav-page [hasNgContent]=\"{left:showSideNav, leftSidenavResizable:false}\"\n                   [leftSidenavLabel]=\"'ng.general.sections' | translate\" [leftSidenavWidth]=\"leftSidenavWidth\"\n                   [sideNavToOverMode]=\"responsive && responsiveSideNavMenu && !isFullPage\"\n                   [showLeftSidenavCollapseBtn]=\"!isFullPage\"\n                   [expandLeftSidenav]=\"expandLeftSidenavByUserPreferences || isFullPage\"\n                   (expandLeftSidenavChange)=\"expandLeftSidenavChange.emit($event)\">\n    <ng-container left-sidenav-content *ngIf=\"showSideNav\">\n      <ng-container *ngTemplateOutlet=\"sectionMenu\"></ng-container>\n    </ng-container>\n    <div *ngIf=\"hasSectionWithError\" collapsed-left-sidenav-smallbox-content-after-label\n         class=\"ex-sections-layout-sections-menu-collapsed-has-invalid\">\n      <ex-svg-icon *ngIf=\"true\" [iconName]=\"'rejected'\" [color]=\"'#f44336'\"\n                   [exTooltip]=\"'ng.sections_layout.sections_with_error' | translate\"></ex-svg-icon>\n    </div>\n    <ng-container sidenav-page-content>\n      <ng-container *ngTemplateOutlet=\"sections\"></ng-container>\n    </ng-container>\n  </ex-sidenav-page>\n</div>\n\n<ng-template #sections>\n  <div role=\"main\" aria-labelledby=\"selectedItemInList\" class=\"ex-sections-layout-sections-wrapper-scroller\"\n       (scroll)=\"onContainerScroll($event)\" #scrollerElement tabindex=\"-1\">\n    <div class=\"ex-sections-layout-sections-wrapper\">\n      <ng-container *ngIf=\"!displaySections && showGenericPlaceHolder\">\n        <ex-section-placeholder [active]=\"true\" [showThumbnail]=\"true\"></ex-section-placeholder>\n        <ex-section-placeholder [active]=\"true\" [showThumbnail]=\"false\"></ex-section-placeholder>\n        <ex-section-placeholder [active]=\"true\" [showThumbnail]=\"false\"></ex-section-placeholder>\n        <ex-section-placeholder [active]=\"true\" [showThumbnail]=\"false\"></ex-section-placeholder>\n      </ng-container>\n      <ng-content *ngIf=\"displaySections || !showGenericPlaceHolder\"></ng-content>\n      <div #section *ngFor=\"let section of sortedSections\" [id]=\"section.exIdentifier\"\n           class=\"ex-sections-layout-section-wrapper\" tabindex=\"-1\"\n           (focusout)=\"onSectionUnFocused(section.exIdentifier)\" (focusin)=\"onSectionFocused(section.exIdentifier)\"\n           [class.ex-sections-new-design]=\"newSectionsDesign\">\n        <div\n          *ngIf=\"sectionsHasData[section.exIdentifier] === true || sectionsHasData[section.exIdentifier] === undefined || sectionsSelected[section.exIdentifier] === true || section.isMandatory\"\n          [style.display]=\"sectionsLoading[section.exIdentifier]?.loading === true || (!displaySections && showGenericPlaceHolder) ? 'none' : 'block'\"\n          class=\"ex-sections-layout-section\"\n          [ngClass]=\"{ 'ex-sections-layout-highlighted-section': sectionsHighlight[section.exIdentifier], 'ex-sections-layout-selected-section': sectionFocusedIdentifier === section.exIdentifier, 'ex-sections-layout-not-valid-section': sectionsValid[section.exIdentifier] === false ,'ex-sections-new-design':newSectionsDesign}\">\n          <mat-expansion-panel #expansionPanel=\"matExpansionPanel\" *ngIf=\"section.hasCollapse\"\n                               [class.mat-expansion-panel]=\"false\"\n                               class=\"ex-sections-layout-section-expansion-panel mat-content-density back-color no-shadow\"\n                               [class.ex-sections-new-design]=\"newSectionsDesign\"\n                               [(expanded)]=\"section.expanded\">\n            <mat-expansion-panel-header class=\"ex-sections-layout-section-expansion-header mat-header-density\"\n                                        [class.ex-sections-new-design]=\"newSectionsDesign\"\n                                        (keydown.enter)=\"$event.stopPropagation()\"\n                                        (keydown.space)=\"$event.stopPropagation()\" tabindex=\"0\"\n                                        [attr.aria-expanded]=\"expansionPanel.expanded\" aria-disabled=\"false\"\n                                        (click)=\"onExpandSection(section.exIdentifier, section.expanded)\">\n              <ng-container *ngIf=\"expansionPanel.expanded\">\n                <ng-container *ngIf=\"sectionsHeader[section.exIdentifier]\"\n                              [ngTemplateOutlet]=\"sectionsHeader[section.exIdentifier]\">\n                </ng-container>\n                <ng-container *ngIf=\"section.header\" [ngTemplateOutlet]=\"section.header\">\n                </ng-container>\n              </ng-container>\n              <mat-panel-title class=\"ex-sections-layout-title\" role=\"heading\" aria-level=\"3\">\n                <ex-dot-wrapper *ngIf=\"section.icon !=undefined && newSectionsDesign\"\n                                class=\"ex-sections-layout-title-list-icon\"\n                                [displayDot]=\"section.icon?.statusColor != undefined\"\n                                [color]=\"section.icon?.statusColor\">\n                  <ex-svg-icon *ngIf=\"section.icon !=undefined\" [iconName]=\"section.icon.iconName\"></ex-svg-icon>\n                </ex-dot-wrapper>\n                {{ getDisplayTitle(section.exIdentifier)  | translate }}\n                <div id=\"items_count\" class=\"ex-sections-items-count\"\n                     *ngIf=\"sectionsCount[section.exIdentifier]?.count > 0\">\n                  ({{getCountLabel(section.exIdentifier)}})\n                </div>\n              </mat-panel-title>\n              <ng-container *ngIf=\"newSectionsDesign && viewMode\">\n                <ex-svg-icon iconName=\"View-Icon\" color=\"'#666666'\"></ex-svg-icon>\n                <span class=\"ex-sections-layout-title-view-only\">{{'ng.general.view-only'| translate}}</span>\n              </ng-container>\n            </mat-expansion-panel-header>\n\n            <ng-container [ngTemplateOutlet]=\"section.template\"></ng-container>\n            <ex-section-placeholder *ngIf=\"sectionsLoading[section.exIdentifier]?.loading === true\" [active]=\"true\"\n                                    [showThumbnail]=\"false\"></ex-section-placeholder>\n          </mat-expansion-panel>\n\n          <ng-container *ngIf=\"!section.hasCollapse\" [ngTemplateOutlet]=\"section.template\"></ng-container>\n        </div>\n        <ex-section-placeholder *ngIf=\"sectionsLoading[section.exIdentifier]?.loading === true\" [active]=\"true\"\n                                [showThumbnail]=\"sectionsLoading[section.exIdentifier]?.hasAvatar\"\n                                [isExpanded]=\"section.expanded\"></ex-section-placeholder>\n      </div>\n      <ng-content select=\"[section-bottom-content]\">\n      </ng-content>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #sectionMenu>\n  <div role=\"navigation\" exShortcutsScope=\"main\" *ngIf=\"hasMenu && !sectionsMenuLoading\"\n       class=\"ex-sections-layout-sections-menu-wrapper\">\n    <div #sectionMenu class=\"ex-sections-layout-sections-menu\">\n      <ng-container *ngFor=\"let section of sectionsList; let i = index\">\n        <button exQuickAccess=\"{{getDisplayTitle(section.identifier) | translate }}\"\n                [exQuickAccessType]=\"quickAcssessTypes.SECTION\"\n                *ngIf=\"(displayAllSections && !viewMode) || !section.iconName\" #sectionMenuItem\n                class=\"ex-sections-layout-sections-menu-item {{section.identifier | generateHTMLId}}\"\n                (click)=\"onSectionSelected(section.identifier, i, true)\"\n                [exTooltip]=\"getDisplayTitle(section.identifier) | translate\" matTooltipPosition=\"after\" [matTooltipPositionAtOrigin]=\"true\"\n                exKeyboardShortcut=\"TabNavigation\" [exKeyboardShortcutIndex]=\"i+1\" [attr.aria-current]=\"currentActive === i\">\n          <div\n            [class.ex-sections-layout-sections-menu-item-active]=\"currentActive === i\"\n            class=\"ex-sections-layout-sections-menu-item-line\">\n            <ex-icon *ngIf=\"section.iconName\" [iconType]=\"section.iconType\" [iconName]=\"section.iconName\"\n                     [color]=\"section.color\" sizePx=\"16px\">\n            </ex-icon>\n            <div class=\"sel-section-menu-link-{{section.identifier}}\">\n              {{getDisplayTitle(section.identifier) | translate }}\n            </div>\n            <span\n              *ngIf=\"displaySectionsStateIndications && (sectionsState[section.identifier]?.hasRequired || section.hasRequired)\"\n              class=\"ex-sections-layout-sections-menu-has-required\">*</span>\n            <div>\n              {{ (sectionsCount[section.identifier]?.count > 0 ? (\" (\" + sectionsCount[section.identifier]?.count + \")\")\n              : \"\") }}\n            </div>\n            <!-- <span *ngIf=\"sectionsState[section.identifier]?.dirty\"\n                class=\"ex-sections-layout-sections-menu-dirty\"></span> -->\n            <span class=\"ex-sections-layout-sections-menu-is-invalid\">\n              <ex-svg-icon\n                *ngIf=\"displaySectionsStateIndications && sectionsState[section.identifier]?.hasTouchedOrDirtyWarningsErrors\"\n                [iconName]=\"'rejected'\" [color]=\"'#f44336'\"\n                [exTooltip]=\"'ng.sections_layout.section_with_error' | translate\"></ex-svg-icon>\n            </span>\n          </div>\n        </button>\n      </ng-container>\n      <div class=\"ex-sections-layout-menu-links\">\n        <ng-content select=\"[links]\"></ng-content>\n      </div>\n      <div *ngIf=\"haveEmptySections && !viewMode\" class=\"ex-sections-layout-sections-footer\">\n        <button (click)=\"displayAllClicked()\">\n          <ex-icon [iconName]=\"displayAllSections ? 'visibility_off' : 'visibility'\" iconType=\"matIcon\"></ex-icon>\n          {{ !displayAllSections ? 'Display empty sections' : 'Hide empty sections' }}\n        </button>\n      </div>\n      <ex-button class=\"ex-sections-layout-menu-quick-access-wrapper\" *ngIf=\"quickAccessActive?.()\" type=\"action\"\n                 [uniqueSelector]=\"'ex-sections-layout-menu-quick-access'\"\n                 (click)=\"openQuickAccess()\" [tooltip]=\"'ng.general.quick_access.tooltip' | translate\">\n        <ex-svg-icon class=\"ex-sections-layout-menu-quick-access-icon\" [iconName]=\"'Bolt'\"></ex-svg-icon>\n        {{'ng.general.quick_access.title'| translate}}\n      </ex-button>\n    </div>\n  </div>\n  <div *ngIf=\"hasMenu && sectionsMenuLoading\"\n       class=\"ex-sections-layout-placeholder-list ex-sections-layout-sections-menu-wrapper\">\n    <div class=\"ex-sections-layout-placeholder-list-animate\"></div>\n    <span class=\"ex-sections-layout-placeholder-list-line\"></span>\n    <span class=\"ex-sections-layout-placeholder-list-line\"></span>\n    <span class=\"ex-sections-layout-placeholder-list-line\"></span>\n    <span class=\"ex-sections-layout-placeholder-list-line\"></span>\n    <span class=\"ex-sections-layout-placeholder-list-line\"></span>\n  </div>\n</ng-template>\n", styles: [":host{display:block;width:100%;height:100%}.ex-sections-layout-wrapper{height:100%;margin-top:-43px;position:relative}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container{background:transparent!important;z-index:unset!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container .ex-sidenav-page-left-sidenav{background:#fff!important;z-index:23!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container .ex-sidenav-page-left-sidenav .mat-drawer-inner-container{overflow-x:hidden!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content{background:transparent!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content .ex-sidenav-page-arrow-wrapper{z-index:21}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container .ex-sidenav-page-left-sidenav .ex-sidenav-page-left-sidenav-content .ex-sidenav-page-arrow-wrapper .ex-sidenav-page-arrows{margin-inline-start:0!important;margin-inline-end:10px!important;background:#f2f2f2!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content{background:transparent!important;z-index:unset!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed{max-width:30px!important;z-index:22!important;margin-inline-end:15px}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button{width:30px!important;background:#fff!important;border-inline-end:1px solid #e0e0e0!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-left-sidenav-collapsed-button .ex-sidenav-page-left-sidenav-collapsed-button-content{margin-inline-start:-10px!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content .ex-sidenav-page-left-sidenav-collapsed .ex-sidenav-page-arrow-wrapper{border-inline-end:1px solid #e0e0e0!important}.ex-sections-layout-wrapper ::ng-deep mat-sidenav-container mat-sidenav-content .ex-sidenav-page-content{display:flex!important;width:unset!important;overflow:hidden!important;flex:1}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper-has-mask{-webkit-mask-image:linear-gradient(to bottom,#fff 80%,#fff0);mask-image:linear-gradient(to bottom,#fff 80%,#fff0)}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper{padding-top:50px;overflow:auto;overflow-x:hidden;margin-inline-end:10px;margin-bottom:1px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu{width:190px;padding-inline-end:3px;scrollbar-width:none;-ms-overflow-style:none;overflow:auto}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item{background:transparent;border:none;text-align:start;width:90%;justify-content:space-between;display:flex;flex-direction:row;outline:none}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-item-line{padding-inline-start:10px;padding-top:5px;padding-bottom:5px;border-inline-start:4px solid transparent;padding-inline-end:3px;display:flex;min-width:0px;gap:2px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-item-line div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-item-line div:last-of-type{min-width:-moz-fit-content;min-width:fit-content}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-item-invalid,.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-item-warnings{color:red}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-dirty{position:relative}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-dirty:after{content:\"\";position:absolute;top:25%;height:10px;width:10px;border-radius:50%;border:2px solid #fff;background:gray}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-has-required{color:#f44336}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item .ex-sections-layout-sections-menu-is-invalid{display:flex;align-items:center}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-sections-menu-item ex-icon{margin-inline-end:10px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-menu .ex-sections-layout-menu-links{display:flex;flex-direction:column;gap:6px;margin:10px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-footer{display:flex;align-items:center;height:50px;border-top:1px solid #ccc;margin-top:15px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-footer button{background:transparent;border:none;color:#4164a4;font-weight:400;padding:10px;display:flex}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-wrapper .ex-sections-layout-sections-footer button ex-icon{margin-right:5px;margin-top:2px}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu::-webkit-scrollbar{width:0;height:0}.ex-sections-layout-wrapper .ex-sections-layout-placeholder-list{position:relative;display:flex;flex-direction:column;padding-inline-end:3px;padding-inline-start:16px}.ex-sections-layout-wrapper .ex-sections-layout-placeholder-list .ex-sections-layout-placeholder-list-line{width:80%;height:21px;background:#f3f5f4 0 0 no-repeat padding-box;border-radius:3px;opacity:1;margin-top:7px;margin-bottom:7px}.ex-sections-layout-wrapper .ex-sections-layout-placeholder-list .ex-sections-layout-placeholder-list-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;inset:0;position:absolute}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller{overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:row;width:100%}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper{display:flex;flex-direction:column;padding:15px;padding-inline-start:5px;flex:1;width:100%;padding-block-start:50px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-combobox{position:absolute;top:10px;z-index:1000}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper:not(.ex-sections-new-design){padding-top:45px;margin-top:-45px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper.ex-sections-new-design{padding-bottom:24px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section{position:relative}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section:not(.ex-sections-new-design) ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-body{margin-top:5px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section:not(.ex-sections-new-design) ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-content{margin-inline-start:5px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section.ex-sections-new-design ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header{padding:9px 0!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section.ex-sections-new-design ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-content{margin-inline-start:16px!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header{height:-moz-fit-content!important;height:fit-content!important;padding:7px 0;align-items:unset;color:#000000de!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-content{flex-wrap:wrap;align-items:center;margin-inline-start:5px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-expansion-indicator{align-self:flex-start;padding:0 16px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-header .mat-expansion-indicator:after{margin-bottom:5px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-body{padding:0!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .mat-expansion-panel-content{font-size:inherit}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header{cursor:pointer}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:not(.ex-sections-new-design){border-top:1px solid;border-color:#e0e0e0}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header.ex-sections-new-design{border:1px solid rgba(196,196,196,.5019607843);border-radius:4px;background-color:#eaf2f6}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header.ex-sections-new-design.mat-expanded{border-radius:4px 4px 0 0!important;border-bottom:none}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:hover{background:#e8edf0}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:hover:not(.ex-sections-new-design){border-radius:0 0 5px 5px;background:#0000000a}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus-visible{background:#0000000a;border:1px solid #898989!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus-visible:not(.ex-sections-new-design){border-radius:0 0 5px 5px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header:focus:not(.ex-sections-new-design){outline:black solid 1px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header .ex-sections-layout-title .ex-sections-layout-title-list-icon{height:16px;margin-inline-end:10px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header .ex-sections-layout-title-view-only{font-weight:400;font-size:14px;color:#666;margin-inline-start:2px}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-section ::ng-deep mat-expansion-panel.ex-sections-layout-section-expansion-panel .ex-sections-layout-section-expansion-header ::ng-deep .ex-button-action:hover{background-color:inherit!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-not-valid-section{border:1px solid #c62726;border-radius:5px;padding-right:5px;box-shadow:0 0 5px #c62726;transform:scale(1);animation:pulse 2s ease-in}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-highlighted-section{animation:highlighted-section-fade 3s;animation-timing-function:ease-out}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-highlighted-section ::ng-deep .ex-section-wrapper{animation:highlighted-section-fade 3s;animation-timing-function:ease-out}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-selected-section.ex-sections-new-design ::ng-deep .ex-section-wrapper:not(.first){border-color:#0e7cbb!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper-scroller .ex-sections-layout-sections-wrapper .ex-sections-layout-section-wrapper .ex-sections-layout-selected-section.ex-sections-new-design ::ng-deep .ex-section-content-wrapper{border-color:#0e7cbb!important}.ex-sections-layout-wrapper .ex-sections-layout-sections-menu-collapsed-has-invalid{margin-top:15px}.ex-sections-layout-section-expansion-panel.mat-expanded:not(.ex-sections-new-design) ::ng-deep>div.mat-expansion-panel-content{margin-bottom:15px}.ex-sections-layout-section-expansion-panel.mat-expanded ::ng-deep>div.mat-expansion-panel-content{height:unset!important;visibility:visible!important}.ex-sections-layout-section-expansion-panel:not(.mat-expanded) ::ng-deep>div.mat-expansion-panel-content{overflow:hidden}@keyframes highlighted-section-fade{0%{background-color:#fff9d6}}.expansion-icons{height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content;padding:0;margin-right:1px;margin-top:1px}.ex-sections-items-count{display:flex;margin-inline-start:3px}.ex-sections-layout-left-side{display:flex;flex-direction:column;position:sticky;top:20px;z-index:20;min-width:200px;overflow:auto}.ex-sections-collapsed-left-sidenav-smallbox-arrow{margin-top:10px}:host::ng-deep .ng-animating.mat-expansion-panel-content{overflow:hidden}.ex-sections-layout-menu-quick-access-wrapper{border-top:1px solid #e0e0e0;padding-inline-end:17px;margin-inline-start:3px}.ex-sections-layout-menu-quick-access-wrapper .ex-sections-layout-menu-quick-access-icon{margin-inline-end:7px}.ex-sections-layout-menu-quick-access{color:#4164a4}.ex-sections-layout-menu-quick-access:hover{color:#1b3c72;text-decoration-line:underline}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: ExSectionsLayoutService }, { type: ExSectionsLayoutListLayoutService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_NAVIGATE_TO_FIELD]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS_ACTIVE]
            }] }, { type: ExShortcutsService, decorators: [{
                type: Optional
            }] }, { type: i0.NgZone }]; }, { hasSectionsMenuInFullViewMode: [{
            type: Input
        }], showSectionsMenuInSidenav: [{
            type: Input
        }], showGenericPlaceHolder: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], order: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], expandLeftSidenavByUserPreferences: [{
            type: Input
        }], newSectionsDesign: [{
            type: Input
        }], responsive: [{
            type: Input
        }], expandSectionChange: [{
            type: Output
        }], expandLeftSidenavChange: [{
            type: Output
        }], sections: [{
            type: ContentChildren,
            args: [ExSectionIdentifierDirective, { descendants: true }]
        }], sectionsElements: [{
            type: ViewChildren,
            args: ['section']
        }], sectionsMenuElements: [{
            type: ViewChildren,
            args: ['sectionMenuItem']
        }], sectionsMenuElement: [{
            type: ViewChild,
            args: ['sectionMenu']
        }], exSidenavPage: [{
            type: ViewChild,
            args: [ExSidenavPageComponent]
        }], scrollerElement: [{
            type: ViewChild,
            args: ['scrollerElement']
        }], expPanels: [{
            type: ViewChildren,
            args: ["expansionPanel"]
        }], expPanelsRef: [{
            type: ViewChildren,
            args: ["expansionPanel", { read: ElementRef }]
        }], handleKeyDown: [{
            type: HostListener,
            args: ['window:keydown', ['$event']]
        }], onFocusOut: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

const _c0$1H = ["input"];
function ExAutocompleteComponent_ng_container_0_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 15);
} }
function ExAutocompleteComponent_ng_container_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ExAutocompleteComponent_ng_container_0_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.onClear()); });
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementEnd();
} }
function ExAutocompleteComponent_ng_container_0_ex_spinner_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 18);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExAutocompleteComponent_ng_container_0_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r7.warningLabel));
} }
function ExAutocompleteComponent_ng_container_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r9.hasMoreResLable));
} }
function ExAutocompleteComponent_ng_container_0_mat_option_13_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 25);
    i0.ɵɵpipe(1, "exTextHighlight");
} if (rf & 2) {
    const option_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", option_r13.value)("innerHTML", i0.ɵɵpipeBind2(1, 2, option_r13.value, ctx_r14.searchText), i0.ɵɵsanitizeHtml);
} }
function ExAutocompleteComponent_ng_container_0_mat_option_13_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1$15 = function (a0, a1) { return { $implicit: a0, searchText: a1 }; };
function ExAutocompleteComponent_ng_container_0_mat_option_13_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExAutocompleteComponent_ng_container_0_mat_option_13_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 26);
} if (rf & 2) {
    const option_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r16.customOptionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1$15, option_r13, ctx_r16.searchText));
} }
function ExAutocompleteComponent_ng_container_0_mat_option_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 22);
    i0.ɵɵtemplate(1, ExAutocompleteComponent_ng_container_0_mat_option_13_label_1_Template, 2, 5, "label", 23);
    i0.ɵɵtemplate(2, ExAutocompleteComponent_ng_container_0_mat_option_13_ng_template_2_Template, 1, 5, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    const _r15 = i0.ɵɵreference(3);
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", option_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.customOptionTemplate)("ngIfElse", _r15);
} }
const _c2$L = function (a0, a1, a2) { return { "ex-autocomplete-focus": a0, "ex-autocomplete-warning": a1, "sel-autocomplete-warning": a2 }; };
function ExAutocompleteComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2, 3);
    i0.ɵɵtemplate(3, ExAutocompleteComponent_ng_container_0_i_3_Template, 1, 0, "i", 4);
    i0.ɵɵelementStart(4, "input", 5, 6);
    i0.ɵɵlistener("keydown", function ExAutocompleteComponent_ng_container_0_Template_input_keydown_4_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.handleKeyboardEvent($event)); })("ngModelChange", function ExAutocompleteComponent_ng_container_0_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.searchTextChange($event)); })("focus", function ExAutocompleteComponent_ng_container_0_Template_input_focus_4_listener() { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.onFocus()); })("blur", function ExAutocompleteComponent_ng_container_0_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r21); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.onBlur()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExAutocompleteComponent_ng_container_0_button_6_Template, 2, 0, "button", 7);
    i0.ɵɵtemplate(7, ExAutocompleteComponent_ng_container_0_ex_spinner_7_Template, 1, 1, "ex-spinner", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ExAutocompleteComponent_ng_container_0_div_8_Template, 4, 3, "div", 9);
    i0.ɵɵelementStart(9, "mat-autocomplete", 10, 11);
    i0.ɵɵlistener("optionSelected", function ExAutocompleteComponent_ng_container_0_Template_mat_autocomplete_optionSelected_9_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.selectedValueChanged($event)); });
    i0.ɵɵtemplate(11, ExAutocompleteComponent_ng_container_0_div_11_Template, 3, 3, "div", 12);
    i0.ɵɵelementStart(12, "div", 13);
    i0.ɵɵtemplate(13, ExAutocompleteComponent_ng_container_0_mat_option_13_Template, 4, 3, "mat-option", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(2);
    const _r8 = i0.ɵɵreference(10);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(18, _c2$L, ctx_r0.isFocus, !ctx_r0.isValid, !ctx_r0.isValid));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isFocus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("autofocus", ctx_r0.autoFocus)("placeholder", ctx_r0.isFocus ? ctx_r0.focusPlaceholder : ctx_r0.placeholder)("matAutocomplete", _r8)("matAutocompleteConnectedTo", _r2)("ngModel", ctx_r0.searchText)("readonly", ctx_r0.isReadOnly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading && ctx_r0.selectedValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isValid && ctx_r0.warningLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r0.classList);
    i0.ɵɵproperty("autoActiveFirstOption", true)("displayWith", ctx_r0.displayFn)("autoActiveFirstOption", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.hasMore);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function ExAutocompleteComponent_ex_display_text_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-display-text", 27);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.selectedValue == null ? null : ctx_r1.selectedValue.value)("type", "text")("textAlign", "left");
} }
class ExAutocompleteComponent extends ExControlValueAccessor {
    constructor(httpClient, translate, sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.httpClient = httpClient;
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * api response must be an array from type {key: key, value: value}[]
         * and must get 'searchText' as @QueryParam
         */
        this.apiUrl = '';
        /**
         * url @QueryParam name, defualt is "searchText"
         */
        this.queryParamName = 'searchText';
        /**
         * additional parameters that send to server in every request
         * for example: { mailIncluded: 'true' }
         */
        this.additionalParams = {};
        /**
         *  placeholder for the searchbox
         *  default is empty
         */
        this.placeholder = '';
        /**
         *  warning label when input is invalid, appears under the text box
         */
        this.warningLabel = "qb.invalid_input";
        /**
         *  minimum text length to search, default is 3
         */
        this.minLength = 3;
        /**
         *  show no values found label when search is empty
         */
        this.noValidOptionsFlag = true;
        /**
         *  search box should automatically get focus when the component loads
         */
        this.autoFocus = true;
        /**
         *  Free text that does not exist in the suggested list is invalid.
         *  User can't send an answer that isn't on the list.
         */
        this.forceSelectionFromList = true;
        /**
         *  list of keys of the options that the user can't choose them
         */
        this.keysToDisable = [];
        /**
         * is there are more results
         */
        this.hasMore = false;
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: { key: any, value: string }
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * event fired when clear button clicked or the user manually deleted full text
         */
        this.selectionCleared = new EventEmitter();
        /**
         * Autocpmlete input blur(out of focus), emits the current search text
         */
        this.blur = new EventEmitter();
        this.isLoading = false;
        this.isFocus = false;
        this.isValid = true;
        this.searchText = '';
        this.hasMoreResLable = 'ng.general.query_builder.more_results';
        this.search = new Subject();
        this.focusPlaceholder = this.translate.instant('ex-ui.ex-autocompelte.look_up_or_select');
        this.emptyResLabel = this.translate.instant('ex-ui.ex-autocompelte.no_values_found');
    }
    ngOnInit() {
        this.isFocus = this.autoFocus;
        this.minLength = this.minLength <= 0 ? 3 : this.minLength;
        this.searchText = this.selectedValue?.value;
        this.initFilter();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.search.complete();
    }
    handleKeyboardEvent(event) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            this.cdr.detectChanges(); // since our configuration ignore keyDown event we have to run the CD manually
            event.stopPropagation();
        }
    }
    displayFn(item) {
        return item && item.value ? item.value : item; // item: string | {key: string, value: string}. will be an object after choosing an item from the list
    }
    searchTextChange(text) {
        !text && this.onClear();
        const textVal = text?.value ? text.value : text; // text: string | {key: string, value: string}. will be an object after choosing an item from the list
        this.items = [];
        this.searchText = textVal;
        this.search.next();
        if (!this.forceSelectionFromList) {
            this.selectedValue = { key: textVal, value: textVal };
            this.selectedValueChange.emit(this.selectedValue);
        }
    }
    selectedValueChanged(e) {
        this.isValid = true;
        if (this.isDisabled(e.option.value.key)) {
            this.isValid = false;
        }
        else if (e.option.value.key === '-1') {
            this.onClear(); // empty option
        }
        else {
            this.selectedValue = e.option.value;
            this.searchText = this.selectedValue.value;
            this.selectedValueChange.emit(this.selectedValue);
        }
    }
    onFocus() {
        this.isFocus = true;
    }
    onBlur() {
        this.isFocus = false;
        this.blur.emit(this.searchText);
    }
    onClear() {
        this.searchText = '';
        this.selectedValue = undefined;
        this.isValid = true;
        this.selectedValueChange.emit(this.selectedValue);
        this.selectionCleared.emit();
    }
    isDisabled(key) {
        return this.keysToDisable.indexOf(key) !== -1;
    }
    // use this function from outside (viewchild) when you want to force the input to focus
    forceFocus() {
        setTimeout(() => {
            this.inputElement.nativeElement.focus();
            this.cdr.markForCheck();
        }, 0);
    }
    writeValue(value) {
        this.selectedValue = value;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        this.valid = isValid;
        this.cdr.markForCheck();
    }
    initFilter() {
        this.search.pipe(debounceTime(250), filter(() => this.isFocus && this.searchText?.length >= this.minLength), tap(() => {
            this.isLoading = true;
            this.cdr.markForCheck();
        }), switchMap(() => this.getSearch().pipe(catchError(e => of(console.error(e))))), finalize(() => {
            this.isLoading = false;
        })).subscribe((data) => {
            this.isLoading = false;
            this.items = data ?? [];
            this.items.length === 0 && this.setNoValidOptions();
            this.cdr.markForCheck();
        });
    }
    getSearch() {
        if (this.apiUrl) {
            return this.getSearchByUrl();
        }
        return this.datasource?.(this.searchText) ?? of([]);
    }
    getSearchByUrl() {
        let apiUrl = this.apiUrl;
        if (!apiUrl?.startsWith('http')) {
            apiUrl = `${location.origin}${apiUrl}`;
        }
        const url = new URL(apiUrl);
        url.searchParams.set(this.queryParamName, this.searchText);
        Object.entries(this.additionalParams).forEach(([key, value]) => {
            url.searchParams.set(key, value);
        });
        return this.httpClient.get(`${url.pathname}${url.search}`);
    }
    setNoValidOptions() {
        if (this.noValidOptionsFlag) {
            const option = { key: '-1', value: this.emptyResLabel };
            this.items.push(option);
        }
    }
    static { this.ɵfac = function ExAutocompleteComponent_Factory(t) { return new (t || ExAutocompleteComponent)(i0.ɵɵdirectiveInject(i1$8.HttpClient), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExAutocompleteComponent, selectors: [["ex-autocomplete"]], contentQueries: function ExAutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customOptionTemplate = _t.first);
        } }, viewQuery: function ExAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1H, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
        } }, hostBindings: function ExAutocompleteComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedValueChange", function ExAutocompleteComponent_selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExAutocompleteComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { apiUrl: "apiUrl", queryParamName: "queryParamName", additionalParams: "additionalParams", datasource: "datasource", placeholder: "placeholder", focusPlaceholder: "focusPlaceholder", warningLabel: "warningLabel", selectedValue: "selectedValue", minLength: "minLength", noValidOptionsFlag: "noValidOptionsFlag", autoFocus: "autoFocus", forceSelectionFromList: "forceSelectionFromList", keysToDisable: "keysToDisable", classList: "classList", hasMore: "hasMore" }, outputs: { selectedValueChange: "selectedValueChange", selectionCleared: "selectionCleared", blur: "blur" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExAutocompleteComponent)), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "value", "type", "textAlign", 4, "ngIf"], ["matAutocompleteOrigin", "", 1, "ex-autocomplete-wrapper", "sel-ex-autocomplete", 3, "ngClass"], ["origin", "matAutocompleteOrigin"], ["class", "ex-autocomplete-icon uxf-icon uxf-search", 4, "ngIf"], ["type", "text", "matInput", "", 3, "autofocus", "placeholder", "matAutocomplete", "matAutocompleteConnectedTo", "ngModel", "readonly", "keydown", "ngModelChange", "focus", "blur"], ["input", ""], ["class", "ex-autocomplete-clear-button", 3, "click", 4, "ngIf"], [3, "diameter", 4, "ngIf"], ["class", "ex-autocomplete-warning-wrapper", 4, "ngIf"], [3, "autoActiveFirstOption", "displayWith", "optionSelected"], ["auto", "matAutocomplete"], ["class", "ex-autocomplete-has-more-results", 4, "ngIf"], [1, "mat-autocomplete-wrapper"], ["class", "ex-autocomplete-mat-option sel-ex-autocomplete-option", 3, "value", 4, "ngFor", "ngForOf"], [1, "ex-autocomplete-icon", "uxf-icon", "uxf-search"], [1, "ex-autocomplete-clear-button", 3, "click"], [1, "uxf-icon", "uxf-close"], [3, "diameter"], [1, "ex-autocomplete-warning-wrapper"], ["role", "alert", 1, "ex-autocomplete-warning-label", "sel-autocomplete-warning-label"], [1, "ex-autocomplete-has-more-results"], [1, "ex-autocomplete-mat-option", "sel-ex-autocomplete-option", 3, "value"], ["class", "ex-autocomplete-mat-option-label", 3, "exTooltip", "innerHTML", 4, "ngIf", "ngIfElse"], ["customOptionTmpl", ""], [1, "ex-autocomplete-mat-option-label", 3, "exTooltip", "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "value", "type", "textAlign"]], template: function ExAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExAutocompleteComponent_ng_container_0_Template, 14, 22, "ng-container", 0);
            i0.ɵɵtemplate(1, ExAutocompleteComponent_ex_display_text_1_Template, 1, 3, "ex-display-text", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isReadOnly);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExTooltipDirective, i5.MatAutocomplete, i6$1.MatOption, i5.MatAutocompleteTrigger, i5.MatAutocompleteOrigin, i7.MatInput, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExSpinnerComponent, i10.AutofocusFixDirective, ExDisplayTextComponent, ExTextHighlightPipe, i1$2.TranslatePipe], styles: [".ex-autocomplete-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;border-radius:4px;padding-left:10px;padding-right:10px;justify-content:stretch}.ex-autocomplete-wrapper[_ngcontent-%COMP%]   .ex-autocomplete-icon[_ngcontent-%COMP%]{margin-right:5px}.ex-autocomplete-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:0px;cursor:pointer}.ex-autocomplete-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:0px;display:flex;flex:1;min-width:0}.ex-autocomplete-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline-width:0}.ex-autocomplete-mat-option[_ngcontent-%COMP%]{height:auto!important;line-height:20px!important;padding:5px 20px;border-top:1px solid transparent;border-bottom:1px solid transparent}.ex-autocomplete-mat-option[_ngcontent-%COMP%]:hover, .ex-autocomplete-mat-option[_ngcontent-%COMP%]:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}  .mat-mdc-option.mat-active{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-autocomplete-mat-option-label[_ngcontent-%COMP%]{margin:0!important}.ex-autocomplete-has-more-results[_ngcontent-%COMP%]{padding:5px 20px;font-family:Roboto-italic;font-size:13px;position:sticky;top:0;background:#fff;z-index:1}.ex-autocomplete-warning-wrapper[_ngcontent-%COMP%]{margin-top:5px;margin-left:2px}.mat-autocomplete-wrapper[_ngcontent-%COMP%]{max-height:200px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAutocompleteComponent, [{
        type: Component,
        args: [{ selector: 'ex-autocomplete', host: {
                    '(selectedValueChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExAutocompleteComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!isReadOnly\">\n    <div class=\"ex-autocomplete-wrapper sel-ex-autocomplete\"\n        [ngClass]=\"{ 'ex-autocomplete-focus': isFocus,  'ex-autocomplete-warning': !isValid, 'sel-autocomplete-warning': !isValid }\"\n        matAutocompleteOrigin #origin=\"matAutocompleteOrigin\">\n        <i *ngIf=\"isFocus\" class=\"ex-autocomplete-icon uxf-icon uxf-search\"></i>\n        <input #input type=\"text\" [autofocus]=\"autoFocus\" [placeholder]=\"isFocus? focusPlaceholder: placeholder\"\n            matInput [matAutocomplete]=\"auto\" [matAutocompleteConnectedTo]=\"origin\"\n            (keydown)=\"handleKeyboardEvent($event)\" [ngModel]=\"searchText\" (ngModelChange)=\"searchTextChange($event)\"\n            (focus)=\"onFocus()\" (blur)=\"onBlur()\" [readonly]=\"isReadOnly\">\n        <button *ngIf=\"!isLoading && selectedValue\" class=\"ex-autocomplete-clear-button\" (click)=\"onClear()\">\n            <i class=\"uxf-icon uxf-close\"></i>\n        </button>\n        <ex-spinner [diameter]=\"15\" *ngIf=\"isLoading\"></ex-spinner>\n    </div>\n    <div *ngIf=\"!isValid && warningLabel\" class=\"ex-autocomplete-warning-wrapper\">\n        <span role=\"alert\"\n            class=\"ex-autocomplete-warning-label sel-autocomplete-warning-label\">{{ warningLabel | translate }}</span>\n    </div>\n\n    <mat-autocomplete #auto=\"matAutocomplete\" [autoActiveFirstOption]=true [displayWith]=\"displayFn\"\n        (optionSelected)=\"selectedValueChanged($event)\" [autoActiveFirstOption]=\"false\" [class]=\"classList\">\n        <div class=\"ex-autocomplete-has-more-results\" *ngIf=\"hasMore\">{{ hasMoreResLable | translate }}</div>\n        <div class=\"mat-autocomplete-wrapper\">\n            <mat-option class=\"ex-autocomplete-mat-option sel-ex-autocomplete-option\" *ngFor=\"let option of items\"\n                [value]=\"option\">\n                <label *ngIf=\"!customOptionTemplate; else customOptionTmpl\" class=\"ex-autocomplete-mat-option-label\"\n                    [exTooltip]=\"option.value\" [innerHTML]=\"option.value | exTextHighlight: searchText\"></label>\n                <ng-template #customOptionTmpl>\n                    <ng-container\n                        *ngTemplateOutlet=\"customOptionTemplate; context: { $implicit: option, searchText: searchText }\">\n                    </ng-container>\n                </ng-template>\n            </mat-option>\n        </div>\n    </mat-autocomplete>\n\n</ng-container>\n\n<ex-display-text *ngIf=\"isReadOnly\" [value]=\"selectedValue?.value\" [type]=\"'text'\" [textAlign]=\"'left'\">\n</ex-display-text>\n", styles: [".ex-autocomplete-wrapper{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;border-radius:4px;padding-left:10px;padding-right:10px;justify-content:stretch}.ex-autocomplete-wrapper .ex-autocomplete-icon{margin-right:5px}.ex-autocomplete-wrapper button{border:0px;cursor:pointer}.ex-autocomplete-wrapper input{border:0px;display:flex;flex:1;min-width:0}.ex-autocomplete-wrapper input:focus{outline-width:0}.ex-autocomplete-mat-option{height:auto!important;line-height:20px!important;padding:5px 20px;border-top:1px solid transparent;border-bottom:1px solid transparent}.ex-autocomplete-mat-option:hover,.ex-autocomplete-mat-option:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}::ng-deep .mat-mdc-option.mat-active{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-autocomplete-mat-option-label{margin:0!important}.ex-autocomplete-has-more-results{padding:5px 20px;font-family:Roboto-italic;font-size:13px;position:sticky;top:0;background:#fff;z-index:1}.ex-autocomplete-warning-wrapper{margin-top:5px;margin-left:2px}.mat-autocomplete-wrapper{max-height:200px}\n"] }]
    }], function () { return [{ type: i1$8.HttpClient }, { type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { apiUrl: [{
            type: Input
        }], queryParamName: [{
            type: Input
        }], additionalParams: [{
            type: Input
        }], datasource: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], focusPlaceholder: [{
            type: Input
        }], warningLabel: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], minLength: [{
            type: Input
        }], noValidOptionsFlag: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], forceSelectionFromList: [{
            type: Input
        }], keysToDisable: [{
            type: Input
        }], classList: [{
            type: Input
        }], hasMore: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], selectionCleared: [{
            type: Output
        }], blur: [{
            type: Output
        }], inputElement: [{
            type: ViewChild,
            args: ['input']
        }], customOptionTemplate: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class ExDisplayTextModule {
    static { this.ɵfac = function ExDisplayTextModule_Factory(t) { return new (t || ExDisplayTextModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDisplayTextModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDisplayTextModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    TranslateModule
                ],
                declarations: [
                    ExDisplayTextComponent
                ],
                exports: [
                    ExDisplayTextComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDisplayTextModule, { declarations: [ExDisplayTextComponent], imports: [CommonModule,
        MatTooltipModule,
        TranslateModule], exports: [ExDisplayTextComponent] }); })();

// Angular Imports
class ExAutocompleteModule {
    static { this.ɵfac = function ExAutocompleteModule_Factory(t) { return new (t || ExAutocompleteModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExAutocompleteModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: AutofocusFixConfig,
                useValue: new AutofocusFixConfig({
                    async: false,
                    smartEmptyCheck: false,
                    triggerDetectChanges: false
                }),
            }
        ], imports: [CommonModule,
            MatButtonModule,
            MatTooltipModule,
            ExDirectivesModule,
            MatAutocompleteModule,
            MatInputModule,
            FormsModule,
            EXPipesModule,
            ExSpinnerModule,
            AutofocusFixModule,
            ExDisplayTextModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAutocompleteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    MatAutocompleteModule,
                    MatInputModule,
                    FormsModule,
                    EXPipesModule,
                    ExSpinnerModule,
                    AutofocusFixModule,
                    ExDisplayTextModule,
                    TranslateModule
                ],
                declarations: [
                    ExAutocompleteComponent,
                ],
                exports: [
                    ExAutocompleteComponent,
                ],
                providers: [
                    {
                        provide: AutofocusFixConfig,
                        useValue: new AutofocusFixConfig({
                            async: false,
                            smartEmptyCheck: false,
                            triggerDetectChanges: false
                        }),
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExAutocompleteModule, { declarations: [ExAutocompleteComponent], imports: [CommonModule,
        MatButtonModule,
        MatTooltipModule,
        ExDirectivesModule,
        MatAutocompleteModule,
        MatInputModule,
        FormsModule,
        EXPipesModule,
        ExSpinnerModule,
        AutofocusFixModule,
        ExDisplayTextModule,
        TranslateModule], exports: [ExAutocompleteComponent] }); })();

const MaterialIconCodepointsRegular = {
    "10k": "e951",
    "10mp": "e952",
    "11mp": "e953",
    "12mp": "e954",
    "13mp": "e955",
    "14mp": "e956",
    "15mp": "e957",
    "16mp": "e958",
    "17mp": "e959",
    "18mp": "e95a",
    "19mp": "e95b",
    "1k": "e95c",
    "1k_plus": "e95d",
    "20mp": "e95e",
    "21mp": "e95f",
    "22mp": "e960",
    "23mp": "e961",
    "24mp": "e962",
    "2k": "e963",
    "2k_plus": "e964",
    "2mp": "e965",
    "360": "e577",
    "3d_rotation": "e84d",
    "3k": "e966",
    "3k_plus": "e967",
    "3mp": "e968",
    "4k": "e072",
    "4k_plus": "e969",
    "4mp": "e96a",
    "5g": "ef38",
    "5k": "e96b",
    "5k_plus": "e96c",
    "5mp": "e96d",
    "6_ft_apart": "f21e",
    "6k": "e96e",
    "6k_plus": "e96f",
    "6mp": "e970",
    "7k": "e971",
    "7k_plus": "e972",
    "7mp": "e973",
    "8k": "e974",
    "8k_plus": "e975",
    "8mp": "e976",
    "9k": "e977",
    "9k_plus": "e978",
    "9mp": "e979",
    "ac_unit": "eb3b",
    "access_alarm": "e190",
    "access_alarms": "e191",
    "access_time": "e192",
    "accessibility": "e84e",
    "accessibility_new": "e92c",
    "accessible": "e914",
    "accessible_forward": "e934",
    "account_balance": "e84f",
    "account_balance_wallet": "e850",
    "account_box": "e851",
    "account_circle": "e853",
    "account_tree": "e97a",
    "ad_units": "ef39",
    "adb": "e60e",
    "add": "e145",
    "add_a_photo": "e439",
    "add_alarm": "e193",
    "add_alert": "e003",
    "add_box": "e146",
    "add_business": "e729",
    "add_call": "e0e8",
    "add_chart": "e97b",
    "add_circle": "e147",
    "add_circle_outline": "e148",
    "add_comment": "e266",
    "add_ic_call": "e97c",
    "add_link": "e178",
    "add_location": "e567",
    "add_location_alt": "ef3a",
    "add_moderator": "e97d",
    "add_photo_alternate": "e43e",
    "add_road": "ef3b",
    "add_shopping_cart": "e854",
    "add_task": "f23a",
    "add_to_drive": "e65c",
    "add_to_home_screen": "e1fe",
    "add_to_photos": "e39d",
    "add_to_queue": "e05c",
    "addchart": "ef3c",
    "adjust": "e39e",
    "admin_panel_settings": "ef3d",
    "agriculture": "ea79",
    "airline_seat_flat": "e630",
    "airline_seat_flat_angled": "e631",
    "airline_seat_individual_suite": "e632",
    "airline_seat_legroom_extra": "e633",
    "airline_seat_legroom_normal": "e634",
    "airline_seat_legroom_reduced": "e635",
    "airline_seat_recline_extra": "e636",
    "airline_seat_recline_normal": "e637",
    "airplanemode_active": "e195",
    "airplanemode_inactive": "e194",
    "airplanemode_off": "e194",
    "airplanemode_on": "e195",
    "airplay": "e055",
    "airport_shuttle": "eb3c",
    "alarm": "e855",
    "alarm_add": "e856",
    "alarm_off": "e857",
    "alarm_on": "e858",
    "album": "e019",
    "align_horizontal_center": "e00f",
    "align_horizontal_left": "e00d",
    "align_horizontal_right": "e010",
    "align_vertical_bottom": "e015",
    "align_vertical_center": "e011",
    "align_vertical_top": "e00c",
    "all_inbox": "e97f",
    "all_inclusive": "eb3d",
    "all_out": "e90b",
    "alt_route": "f184",
    "alternate_email": "e0e6",
    "amp_stories": "ea13",
    "analytics": "ef3e",
    "anchor": "f1cd",
    "android": "e859",
    "animation": "e71c",
    "announcement": "e85a",
    "apartment": "ea40",
    "api": "f1b7",
    "app_blocking": "ef3f",
    "app_registration": "ef40",
    "app_settings_alt": "ef41",
    "approval": "e982",
    "apps": "e5c3",
    "architecture": "ea3b",
    "archive": "e149",
    "arrow_back": "e5c4",
    "arrow_back_ios": "e5e0",
    "arrow_circle_down": "f181",
    "arrow_circle_up": "f182",
    "arrow_downward": "e5db",
    "arrow_drop_down": "e5c5",
    "arrow_drop_down_circle": "e5c6",
    "arrow_drop_up": "e5c7",
    "arrow_forward": "e5c8",
    "arrow_forward_ios": "e5e1",
    "arrow_left": "e5de",
    "arrow_right": "e5df",
    "arrow_right_alt": "e941",
    "arrow_upward": "e5d8",
    "art_track": "e060",
    "article": "ef42",
    "aspect_ratio": "e85b",
    "assessment": "e85c",
    "assignment": "e85d",
    "assignment_ind": "e85e",
    "assignment_late": "e85f",
    "assignment_return": "e860",
    "assignment_returned": "e861",
    "assignment_turned_in": "e862",
    "assistant": "e39f",
    "assistant_direction": "e988",
    "assistant_navigation": "e989",
    "assistant_photo": "e3a0",
    "atm": "e573",
    "attach_email": "ea5e",
    "attach_file": "e226",
    "attach_money": "e227",
    "attachment": "e2bc",
    "attractions": "ea52",
    "audiotrack": "e3a1",
    "auto_awesome": "e65f",
    "auto_awesome_mosaic": "e660",
    "auto_awesome_motion": "e661",
    "auto_delete": "ea4c",
    "auto_fix_high": "e663",
    "auto_fix_normal": "e664",
    "auto_fix_off": "e665",
    "auto_stories": "e666",
    "autorenew": "e863",
    "av_timer": "e01b",
    "baby_changing_station": "f19b",
    "backpack": "f19c",
    "backspace": "e14a",
    "backup": "e864",
    "backup_table": "ef43",
    "badge": "ea67",
    "bakery_dining": "ea53",
    "ballot": "e172",
    "bar_chart": "e26b",
    "batch_prediction": "f0f5",
    "bathtub": "ea41",
    "battery_alert": "e19c",
    "battery_charging_full": "e1a3",
    "battery_full": "e1a4",
    "battery_std": "e1a5",
    "battery_unknown": "e1a6",
    "beach_access": "eb3e",
    "bedtime": "ef44",
    "beenhere": "e52d",
    "bento": "f1f4",
    "bike_scooter": "ef45",
    "biotech": "ea3a",
    "block": "e14b",
    "block_flipped": "ef46",
    "bluetooth": "e1a7",
    "bluetooth_audio": "e60f",
    "bluetooth_connected": "e1a8",
    "bluetooth_disabled": "e1a9",
    "bluetooth_searching": "e1aa",
    "blur_circular": "e3a2",
    "blur_linear": "e3a3",
    "blur_off": "e3a4",
    "blur_on": "e3a5",
    "bolt": "ea0b",
    "book": "e865",
    "book_online": "f217",
    "bookmark": "e866",
    "bookmark_border": "e867",
    "bookmark_outline": "e867",
    "bookmarks": "e98b",
    "border_all": "e228",
    "border_bottom": "e229",
    "border_clear": "e22a",
    "border_color": "e22b",
    "border_horizontal": "e22c",
    "border_inner": "e22d",
    "border_left": "e22e",
    "border_outer": "e22f",
    "border_right": "e230",
    "border_style": "e231",
    "border_top": "e232",
    "border_vertical": "e233",
    "branding_watermark": "e06b",
    "breakfast_dining": "ea54",
    "brightness_1": "e3a6",
    "brightness_2": "e3a7",
    "brightness_3": "e3a8",
    "brightness_4": "e3a9",
    "brightness_5": "e3aa",
    "brightness_6": "e3ab",
    "brightness_7": "e3ac",
    "brightness_auto": "e1ab",
    "brightness_high": "e1ac",
    "brightness_low": "e1ad",
    "brightness_medium": "e1ae",
    "broken_image": "e3ad",
    "browser_not_supported": "ef47",
    "brunch_dining": "ea73",
    "brush": "e3ae",
    "bubble_chart": "e6dd",
    "bug_report": "e868",
    "build": "e869",
    "build_circle": "ef48",
    "burst_mode": "e43c",
    "bus_alert": "e98f",
    "business": "e0af",
    "business_center": "eb3f",
    "cached": "e86a",
    "cake": "e7e9",
    "calculate": "ea5f",
    "calendar_today": "e935",
    "calendar_view_day": "e936",
    "call": "e0b0",
    "call_end": "e0b1",
    "call_made": "e0b2",
    "call_merge": "e0b3",
    "call_missed": "e0b4",
    "call_missed_outgoing": "e0e4",
    "call_received": "e0b5",
    "call_split": "e0b6",
    "call_to_action": "e06c",
    "camera": "e3af",
    "camera_alt": "e3b0",
    "camera_enhance": "e8fc",
    "camera_front": "e3b1",
    "camera_rear": "e3b2",
    "camera_roll": "e3b3",
    "campaign": "ef49",
    "cancel": "e5c9",
    "cancel_presentation": "e0e9",
    "cancel_schedule_send": "ea39",
    "car_rental": "ea55",
    "car_repair": "ea56",
    "card_giftcard": "e8f6",
    "card_membership": "e8f7",
    "card_travel": "e8f8",
    "carpenter": "f1f8",
    "cases": "e992",
    "casino": "eb40",
    "cast": "e307",
    "cast_connected": "e308",
    "cast_for_education": "efec",
    "category": "e574",
    "celebration": "ea65",
    "cell_wifi": "e0ec",
    "center_focus_strong": "e3b4",
    "center_focus_weak": "e3b5",
    "change_history": "e86b",
    "charging_station": "f19d",
    "chat": "e0b7",
    "chat_bubble": "e0ca",
    "chat_bubble_outline": "e0cb",
    "check": "e5ca",
    "check_box": "e834",
    "check_box_outline_blank": "e835",
    "check_circle": "e86c",
    "check_circle_outline": "e92d",
    "checkroom": "f19e",
    "chevron_left": "e5cb",
    "chevron_right": "e5cc",
    "child_care": "eb41",
    "child_friendly": "eb42",
    "chrome_reader_mode": "e86d",
    "circle": "ef4a",
    "circle_notifications": "e994",
    "class": "e86e",
    "clean_hands": "f21f",
    "cleaning_services": "f0ff",
    "clear": "e14c",
    "clear_all": "e0b8",
    "close": "e5cd",
    "close_fullscreen": "f1cf",
    "closed_caption": "e01c",
    "closed_caption_disabled": "f1dc",
    "closed_caption_off": "e996",
    "cloud": "e2bd",
    "cloud_circle": "e2be",
    "cloud_done": "e2bf",
    "cloud_download": "e2c0",
    "cloud_off": "e2c1",
    "cloud_queue": "e2c2",
    "cloud_upload": "e2c3",
    "code": "e86f",
    "collections": "e3b6",
    "collections_bookmark": "e431",
    "color_lens": "e3b7",
    "colorize": "e3b8",
    "comment": "e0b9",
    "comment_bank": "ea4e",
    "commute": "e940",
    "compare": "e3b9",
    "compare_arrows": "e915",
    "compass_calibration": "e57c",
    "compress": "e94d",
    "computer": "e30a",
    "confirmation_num": "e638",
    "confirmation_number": "e638",
    "connect_without_contact": "f223",
    "connected_tv": "e998",
    "construction": "ea3c",
    "contact_mail": "e0d0",
    "contact_page": "f22e",
    "contact_phone": "e0cf",
    "contact_support": "e94c",
    "contactless": "ea71",
    "contacts": "e0ba",
    "content_copy": "e14d",
    "content_cut": "e14e",
    "content_paste": "e14f",
    "control_camera": "e074",
    "control_point": "e3ba",
    "control_point_duplicate": "e3bb",
    "copyright": "e90c",
    "coronavirus": "f221",
    "corporate_fare": "f1d0",
    "countertops": "f1f7",
    "create": "e150",
    "create_new_folder": "e2cc",
    "credit_card": "e870",
    "crop": "e3be",
    "crop_16_9": "e3bc",
    "crop_3_2": "e3bd",
    "crop_5_4": "e3bf",
    "crop_7_5": "e3c0",
    "crop_din": "e3c1",
    "crop_free": "e3c2",
    "crop_landscape": "e3c3",
    "crop_original": "e3c4",
    "crop_portrait": "e3c5",
    "crop_rotate": "e437",
    "crop_square": "e3c6",
    "dangerous": "e99a",
    "dashboard": "e871",
    "dashboard_customize": "e99b",
    "data_usage": "e1af",
    "date_range": "e916",
    "deck": "ea42",
    "dehaze": "e3c7",
    "delete": "e872",
    "delete_forever": "e92b",
    "delete_outline": "e92e",
    "delete_sweep": "e16c",
    "delivery_dining": "ea72",
    "departure_board": "e576",
    "description": "e873",
    "design_services": "f10a",
    "desktop_access_disabled": "e99d",
    "desktop_mac": "e30b",
    "desktop_windows": "e30c",
    "details": "e3c8",
    "developer_board": "e30d",
    "developer_mode": "e1b0",
    "device_hub": "e335",
    "device_thermostat": "e1ff",
    "device_unknown": "e339",
    "devices": "e1b1",
    "devices_other": "e337",
    "dialer_sip": "e0bb",
    "dialpad": "e0bc",
    "dinner_dining": "ea57",
    "directions": "e52e",
    "directions_bike": "e52f",
    "directions_boat": "e532",
    "directions_bus": "e530",
    "directions_car": "e531",
    "directions_ferry": "e532",
    "directions_off": "f10f",
    "directions_railway": "e534",
    "directions_run": "e566",
    "directions_subway": "e533",
    "directions_train": "e534",
    "directions_transit": "e535",
    "directions_walk": "e536",
    "dirty_lens": "ef4b",
    "disabled_by_default": "f230",
    "disc_full": "e610",
    "dnd_forwardslash": "e611",
    "dns": "e875",
    "do_not_disturb": "e612",
    "do_not_disturb_alt": "e611",
    "do_not_disturb_off": "e643",
    "do_not_disturb_on": "e644",
    "do_not_step": "f19f",
    "do_not_touch": "f1b0",
    "dock": "e30e",
    "domain": "e7ee",
    "domain_disabled": "e0ef",
    "domain_verification": "ef4c",
    "done": "e876",
    "done_all": "e877",
    "done_outline": "e92f",
    "donut_large": "e917",
    "donut_small": "e918",
    "double_arrow": "ea50",
    "drafts": "e151",
    "drag_handle": "e25d",
    "drag_indicator": "e945",
    "drive_eta": "e613",
    "drive_file_move": "e675",
    "drive_file_move_outline": "e9a1",
    "drive_file_rename_outline": "e9a2",
    "drive_folder_upload": "e9a3",
    "dry": "f1b3",
    "dry_cleaning": "ea58",
    "duo": "e9a5",
    "dvr": "e1b2",
    "dynamic_feed": "ea14",
    "dynamic_form": "f1bf",
    "east": "f1df",
    "eco": "ea35",
    "edit": "e3c9",
    "edit_attributes": "e578",
    "edit_location": "e568",
    "edit_off": "e950",
    "edit_road": "ef4d",
    "eject": "e8fb",
    "elderly": "f21a",
    "electric_bike": "eb1b",
    "electric_car": "eb1c",
    "electric_moped": "eb1d",
    "electric_rickshaw": "eb1e",
    "electric_scooter": "eb1f",
    "electrical_services": "f102",
    "elevator": "f1a0",
    "email": "e0be",
    "emoji_emotions": "ea22",
    "emoji_events": "ea23",
    "emoji_flags": "ea1a",
    "emoji_food_beverage": "ea1b",
    "emoji_nature": "ea1c",
    "emoji_objects": "ea24",
    "emoji_people": "ea1d",
    "emoji_symbols": "ea1e",
    "emoji_transportation": "ea1f",
    "engineering": "ea3d",
    "enhance_photo_translate": "e8fc",
    "enhanced_encryption": "e63f",
    "equalizer": "e01d",
    "error": "e000",
    "error_outline": "e001",
    "escalator": "f1a1",
    "escalator_warning": "f1ac",
    "euro": "ea15",
    "euro_symbol": "e926",
    "ev_station": "e56d",
    "event": "e878",
    "event_available": "e614",
    "event_busy": "e615",
    "event_note": "e616",
    "event_seat": "e903",
    "exit_to_app": "e879",
    "expand": "e94f",
    "expand_less": "e5ce",
    "expand_more": "e5cf",
    "explicit": "e01e",
    "explore": "e87a",
    "explore_off": "e9a8",
    "exposure": "e3ca",
    "exposure_minus_1": "e3cb",
    "exposure_minus_2": "e3cc",
    "exposure_neg_1": "e3cb",
    "exposure_neg_2": "e3cc",
    "exposure_plus_1": "e3cd",
    "exposure_plus_2": "e3ce",
    "exposure_zero": "e3cf",
    "extension": "e87b",
    "face": "e87c",
    "face_retouching_natural": "ef4e",
    "facebook": "f234",
    "fact_check": "f0c5",
    "family_restroom": "f1a2",
    "fast_forward": "e01f",
    "fast_rewind": "e020",
    "fastfood": "e57a",
    "favorite": "e87d",
    "favorite_border": "e87e",
    "favorite_outline": "e87e",
    "featured_play_list": "e06d",
    "featured_video": "e06e",
    "feedback": "e87f",
    "fence": "f1f6",
    "festival": "ea68",
    "fiber_dvr": "e05d",
    "fiber_manual_record": "e061",
    "fiber_new": "e05e",
    "fiber_pin": "e06a",
    "fiber_smart_record": "e062",
    "file_copy": "e173",
    "file_download": "e2c4",
    "file_download_done": "e9aa",
    "file_present": "ea0e",
    "file_upload": "e2c6",
    "filter": "e3d3",
    "filter_1": "e3d0",
    "filter_2": "e3d1",
    "filter_3": "e3d2",
    "filter_4": "e3d4",
    "filter_5": "e3d5",
    "filter_6": "e3d6",
    "filter_7": "e3d7",
    "filter_8": "e3d8",
    "filter_9": "e3d9",
    "filter_9_plus": "e3da",
    "filter_alt": "ef4f",
    "filter_b_and_w": "e3db",
    "filter_center_focus": "e3dc",
    "filter_drama": "e3dd",
    "filter_frames": "e3de",
    "filter_hdr": "e3df",
    "filter_list": "e152",
    "filter_list_alt": "e94e",
    "filter_none": "e3e0",
    "filter_tilt_shift": "e3e2",
    "filter_vintage": "e3e3",
    "find_in_page": "e880",
    "find_replace": "e881",
    "fingerprint": "e90d",
    "fire_extinguisher": "f1d8",
    "fire_hydrant": "f1a3",
    "fireplace": "ea43",
    "first_page": "e5dc",
    "fit_screen": "ea10",
    "fitness_center": "eb43",
    "flag": "e153",
    "flaky": "ef50",
    "flare": "e3e4",
    "flash_auto": "e3e5",
    "flash_off": "e3e6",
    "flash_on": "e3e7",
    "flight": "e539",
    "flight_land": "e904",
    "flight_takeoff": "e905",
    "flip": "e3e8",
    "flip_camera_android": "ea37",
    "flip_camera_ios": "ea38",
    "flip_to_back": "e882",
    "flip_to_front": "e883",
    "folder": "e2c7",
    "folder_open": "e2c8",
    "folder_shared": "e2c9",
    "folder_special": "e617",
    "follow_the_signs": "f222",
    "font_download": "e167",
    "food_bank": "f1f2",
    "format_align_center": "e234",
    "format_align_justify": "e235",
    "format_align_left": "e236",
    "format_align_right": "e237",
    "format_bold": "e238",
    "format_clear": "e239",
    "format_color_fill": "e23a",
    "format_color_reset": "e23b",
    "format_color_text": "e23c",
    "format_indent_decrease": "e23d",
    "format_indent_increase": "e23e",
    "format_italic": "e23f",
    "format_line_spacing": "e240",
    "format_list_bulleted": "e241",
    "format_list_numbered": "e242",
    "format_list_numbered_rtl": "e267",
    "format_paint": "e243",
    "format_quote": "e244",
    "format_shapes": "e25e",
    "format_size": "e245",
    "format_strikethrough": "e246",
    "format_textdirection_l_to_r": "e247",
    "format_textdirection_r_to_l": "e248",
    "format_underline": "e249",
    "format_underlined": "e249",
    "forum": "e0bf",
    "forward": "e154",
    "forward_10": "e056",
    "forward_30": "e057",
    "forward_5": "e058",
    "forward_to_inbox": "f187",
    "foundation": "f200",
    "free_breakfast": "eb44",
    "fullscreen": "e5d0",
    "fullscreen_exit": "e5d1",
    "functions": "e24a",
    "g_translate": "e927",
    "gamepad": "e30f",
    "games": "e021",
    "gavel": "e90e",
    "gesture": "e155",
    "get_app": "e884",
    "gif": "e908",
    "goat": "10fffd",
    "golf_course": "eb45",
    "gps_fixed": "e1b3",
    "gps_not_fixed": "e1b4",
    "gps_off": "e1b5",
    "grade": "e885",
    "gradient": "e3e9",
    "grading": "ea4f",
    "grain": "e3ea",
    "graphic_eq": "e1b8",
    "grass": "f205",
    "grid_off": "e3eb",
    "grid_on": "e3ec",
    "grid_view": "e9b0",
    "group": "e7ef",
    "group_add": "e7f0",
    "group_work": "e886",
    "groups": "f233",
    "hail": "e9b1",
    "handyman": "f10b",
    "hardware": "ea59",
    "hd": "e052",
    "hdr_enhanced_select": "ef51",
    "hdr_off": "e3ed",
    "hdr_on": "e3ee",
    "hdr_strong": "e3f1",
    "hdr_weak": "e3f2",
    "headset": "e310",
    "headset_mic": "e311",
    "headset_off": "e33a",
    "healing": "e3f3",
    "hearing": "e023",
    "hearing_disabled": "f104",
    "height": "ea16",
    "help": "e887",
    "help_center": "f1c0",
    "help_outline": "e8fd",
    "high_quality": "e024",
    "highlight": "e25f",
    "highlight_alt": "ef52",
    "highlight_off": "e888",
    "highlight_remove": "e888",
    "history": "e889",
    "history_edu": "ea3e",
    "history_toggle_off": "f17d",
    "home": "e88a",
    "home_filled": "e9b2",
    "home_repair_service": "f100",
    "home_work": "ea09",
    "horizontal_distribute": "e014",
    "horizontal_rule": "f108",
    "horizontal_split": "e947",
    "hot_tub": "eb46",
    "hotel": "e53a",
    "hourglass_bottom": "ea5c",
    "hourglass_disabled": "ef53",
    "hourglass_empty": "e88b",
    "hourglass_full": "e88c",
    "hourglass_top": "ea5b",
    "house": "ea44",
    "house_siding": "f202",
    "how_to_reg": "e174",
    "how_to_vote": "e175",
    "http": "e902",
    "https": "e88d",
    "hvac": "f10e",
    "icecream": "ea69",
    "image": "e3f4",
    "image_aspect_ratio": "e3f5",
    "image_not_supported": "f116",
    "image_search": "e43f",
    "imagesearch_roller": "e9b4",
    "import_contacts": "e0e0",
    "import_export": "e0c3",
    "important_devices": "e912",
    "inbox": "e156",
    "indeterminate_check_box": "e909",
    "info": "e88e",
    "info_outline": "e88f",
    "input": "e890",
    "insert_chart": "e24b",
    "insert_chart_outlined": "e26a",
    "insert_comment": "e24c",
    "insert_drive_file": "e24d",
    "insert_emoticon": "e24e",
    "insert_invitation": "e24f",
    "insert_link": "e250",
    "insert_photo": "e251",
    "insights": "f092",
    "integration_instructions": "ef54",
    "inventory": "e179",
    "invert_colors": "e891",
    "invert_colors_off": "e0c4",
    "invert_colors_on": "e891",
    "ios_share": "e6b8",
    "iso": "e3f6",
    "keyboard": "e312",
    "keyboard_arrow_down": "e313",
    "keyboard_arrow_left": "e314",
    "keyboard_arrow_right": "e315",
    "keyboard_arrow_up": "e316",
    "keyboard_backspace": "e317",
    "keyboard_capslock": "e318",
    "keyboard_control": "e5d3",
    "keyboard_hide": "e31a",
    "keyboard_return": "e31b",
    "keyboard_tab": "e31c",
    "keyboard_voice": "e31d",
    "king_bed": "ea45",
    "kitchen": "eb47",
    "label": "e892",
    "label_important": "e937",
    "label_important_outline": "e948",
    "label_off": "e9b6",
    "label_outline": "e893",
    "landscape": "e3f7",
    "language": "e894",
    "laptop": "e31e",
    "laptop_chromebook": "e31f",
    "laptop_mac": "e320",
    "laptop_windows": "e321",
    "last_page": "e5dd",
    "launch": "e895",
    "layers": "e53b",
    "layers_clear": "e53c",
    "leaderboard": "f20c",
    "leak_add": "e3f8",
    "leak_remove": "e3f9",
    "leave_bags_at_home": "f21b",
    "legend_toggle": "f11b",
    "lens": "e3fa",
    "library_add": "e02e",
    "library_add_check": "e9b7",
    "library_books": "e02f",
    "library_music": "e030",
    "lightbulb": "e0f0",
    "lightbulb_outline": "e90f",
    "line_style": "e919",
    "line_weight": "e91a",
    "linear_scale": "e260",
    "link": "e157",
    "link_off": "e16f",
    "linked_camera": "e438",
    "liquor": "ea60",
    "list": "e896",
    "list_alt": "e0ee",
    "live_help": "e0c6",
    "live_tv": "e639",
    "local_activity": "e53f",
    "local_airport": "e53d",
    "local_atm": "e53e",
    "local_attraction": "e53f",
    "local_bar": "e540",
    "local_cafe": "e541",
    "local_car_wash": "e542",
    "local_convenience_store": "e543",
    "local_dining": "e556",
    "local_drink": "e544",
    "local_fire_department": "ef55",
    "local_florist": "e545",
    "local_gas_station": "e546",
    "local_grocery_store": "e547",
    "local_hospital": "e548",
    "local_hotel": "e549",
    "local_laundry_service": "e54a",
    "local_library": "e54b",
    "local_mall": "e54c",
    "local_movies": "e54d",
    "local_offer": "e54e",
    "local_parking": "e54f",
    "local_pharmacy": "e550",
    "local_phone": "e551",
    "local_pizza": "e552",
    "local_play": "e553",
    "local_police": "ef56",
    "local_post_office": "e554",
    "local_print_shop": "e555",
    "local_printshop": "e555",
    "local_restaurant": "e556",
    "local_see": "e557",
    "local_shipping": "e558",
    "local_taxi": "e559",
    "location_city": "e7f1",
    "location_disabled": "e1b6",
    "location_history": "e55a",
    "location_off": "e0c7",
    "location_on": "e0c8",
    "location_pin": "f1db",
    "location_searching": "e1b7",
    "lock": "e897",
    "lock_clock": "ef57",
    "lock_open": "e898",
    "lock_outline": "e899",
    "login": "ea77",
    "logout": "e9ba",
    "looks": "e3fc",
    "looks_3": "e3fb",
    "looks_4": "e3fd",
    "looks_5": "e3fe",
    "looks_6": "e3ff",
    "looks_one": "e400",
    "looks_two": "e401",
    "loop": "e028",
    "loupe": "e402",
    "low_priority": "e16d",
    "loyalty": "e89a",
    "luggage": "f235",
    "lunch_dining": "ea61",
    "mail": "e158",
    "mail_outline": "e0e1",
    "map": "e55b",
    "maps_ugc": "ef58",
    "margin": "e9bb",
    "mark_as_unread": "e9bc",
    "mark_chat_read": "f18b",
    "mark_chat_unread": "f189",
    "mark_email_read": "f18c",
    "mark_email_unread": "f18a",
    "markunread": "e159",
    "markunread_mailbox": "e89b",
    "masks": "f218",
    "maximize": "e930",
    "mediation": "efa7",
    "medical_services": "f109",
    "meeting_room": "eb4f",
    "memory": "e322",
    "menu": "e5d2",
    "menu_book": "ea19",
    "menu_open": "e9bd",
    "merge_type": "e252",
    "message": "e0c9",
    "messenger": "e0ca",
    "messenger_outline": "e0cb",
    "mic": "e029",
    "mic_external_off": "ef59",
    "mic_external_on": "ef5a",
    "mic_none": "e02a",
    "mic_off": "e02b",
    "microwave": "f204",
    "military_tech": "ea3f",
    "minimize": "e931",
    "miscellaneous_services": "f10c",
    "missed_video_call": "e073",
    "mms": "e618",
    "mobile_friendly": "e200",
    "mobile_off": "e201",
    "mobile_screen_share": "e0e7",
    "mode_comment": "e253",
    "mode_edit": "e254",
    "model_training": "f0cf",
    "monetization_on": "e263",
    "money": "e57d",
    "money_off": "e25c",
    "monitor": "ef5b",
    "monochrome_photos": "e403",
    "mood": "e7f2",
    "mood_bad": "e7f3",
    "moped": "eb28",
    "more": "e619",
    "more_horiz": "e5d3",
    "more_time": "ea5d",
    "more_vert": "e5d4",
    "motion_photos_off": "e9c0",
    "motion_photos_on": "e9c1",
    "motion_photos_pause": "f227",
    "motion_photos_paused": "e9c2",
    "motorcycle": "e91b",
    "mouse": "e323",
    "move_to_inbox": "e168",
    "movie": "e02c",
    "movie_creation": "e404",
    "movie_filter": "e43a",
    "mp": "e9c3",
    "multiline_chart": "e6df",
    "multiple_stop": "f1b9",
    "multitrack_audio": "e1b8",
    "museum": "ea36",
    "music_note": "e405",
    "music_off": "e440",
    "music_video": "e063",
    "my_library_add": "e02e",
    "my_library_books": "e02f",
    "my_library_music": "e030",
    "my_location": "e55c",
    "nat": "ef5c",
    "nature": "e406",
    "nature_people": "e407",
    "navigate_before": "e408",
    "navigate_next": "e409",
    "navigation": "e55d",
    "near_me": "e569",
    "near_me_disabled": "f1ef",
    "network_cell": "e1b9",
    "network_check": "e640",
    "network_locked": "e61a",
    "network_wifi": "e1ba",
    "new_releases": "e031",
    "next_plan": "ef5d",
    "next_week": "e16a",
    "nfc": "e1bb",
    "night_shelter": "f1f1",
    "nightlife": "ea62",
    "nightlight_round": "ef5e",
    "nights_stay": "ea46",
    "no_backpack": "f237",
    "no_cell": "f1a4",
    "no_drinks": "f1a5",
    "no_encryption": "e641",
    "no_flash": "f1a6",
    "no_food": "f1a7",
    "no_luggage": "f23b",
    "no_meals": "f1d6",
    "no_meals_ouline": "f229",
    "no_meeting_room": "eb4e",
    "no_photography": "f1a8",
    "no_sim": "e0cc",
    "no_stroller": "f1af",
    "no_transfer": "f1d5",
    "north": "f1e0",
    "north_east": "f1e1",
    "north_west": "f1e2",
    "not_accessible": "f0fe",
    "not_interested": "e033",
    "not_listed_location": "e575",
    "not_started": "f0d1",
    "note": "e06f",
    "note_add": "e89c",
    "notes": "e26c",
    "notification_important": "e004",
    "notifications": "e7f4",
    "notifications_active": "e7f7",
    "notifications_none": "e7f5",
    "notifications_off": "e7f6",
    "notifications_on": "e7f7",
    "notifications_paused": "e7f8",
    "now_wallpaper": "e1bc",
    "now_widgets": "e1bd",
    "offline_bolt": "e932",
    "offline_pin": "e90a",
    "offline_share": "e9c5",
    "ondemand_video": "e63a",
    "online_prediction": "f0eb",
    "opacity": "e91c",
    "open_in_browser": "e89d",
    "open_in_full": "f1ce",
    "open_in_new": "e89e",
    "open_with": "e89f",
    "outbond": "f228",
    "outbox": "ef5f",
    "outdoor_grill": "ea47",
    "outgoing_mail": "f0d2",
    "outlet": "f1d4",
    "outlined_flag": "e16e",
    "padding": "e9c8",
    "pages": "e7f9",
    "pageview": "e8a0",
    "palette": "e40a",
    "pan_tool": "e925",
    "panorama": "e40b",
    "panorama_fish_eye": "e40c",
    "panorama_fisheye": "e40c",
    "panorama_horizontal": "e40d",
    "panorama_horizontal_select": "ef60",
    "panorama_photosphere": "e9c9",
    "panorama_photosphere_select": "e9ca",
    "panorama_vertical": "e40e",
    "panorama_vertical_select": "ef61",
    "panorama_wide_angle": "e40f",
    "panorama_wide_angle_select": "ef62",
    "park": "ea63",
    "party_mode": "e7fa",
    "pause": "e034",
    "pause_circle_filled": "e035",
    "pause_circle_outline": "e036",
    "pause_presentation": "e0ea",
    "payment": "e8a1",
    "payments": "ef63",
    "pedal_bike": "eb29",
    "pending": "ef64",
    "pending_actions": "f1bb",
    "people": "e7fb",
    "people_alt": "ea21",
    "people_outline": "e7fc",
    "perm_camera_mic": "e8a2",
    "perm_contact_cal": "e8a3",
    "perm_contact_calendar": "e8a3",
    "perm_data_setting": "e8a4",
    "perm_device_info": "e8a5",
    "perm_device_information": "e8a5",
    "perm_identity": "e8a6",
    "perm_media": "e8a7",
    "perm_phone_msg": "e8a8",
    "perm_scan_wifi": "e8a9",
    "person": "e7fd",
    "person_add": "e7fe",
    "person_add_alt": "ea4d",
    "person_add_alt_1": "ef65",
    "person_add_disabled": "e9cb",
    "person_outline": "e7ff",
    "person_pin": "e55a",
    "person_pin_circle": "e56a",
    "person_remove": "ef66",
    "person_remove_alt_1": "ef67",
    "person_search": "f106",
    "personal_video": "e63b",
    "pest_control": "f0fa",
    "pest_control_rodent": "f0fd",
    "pets": "e91d",
    "phone": "e0cd",
    "phone_android": "e324",
    "phone_bluetooth_speaker": "e61b",
    "phone_callback": "e649",
    "phone_disabled": "e9cc",
    "phone_enabled": "e9cd",
    "phone_forwarded": "e61c",
    "phone_in_talk": "e61d",
    "phone_iphone": "e325",
    "phone_locked": "e61e",
    "phone_missed": "e61f",
    "phone_paused": "e620",
    "phonelink": "e326",
    "phonelink_erase": "e0db",
    "phonelink_lock": "e0dc",
    "phonelink_off": "e327",
    "phonelink_ring": "e0dd",
    "phonelink_setup": "e0de",
    "photo": "e410",
    "photo_album": "e411",
    "photo_camera": "e412",
    "photo_camera_back": "ef68",
    "photo_camera_front": "ef69",
    "photo_filter": "e43b",
    "photo_library": "e413",
    "photo_size_select_actual": "e432",
    "photo_size_select_large": "e433",
    "photo_size_select_small": "e434",
    "picture_as_pdf": "e415",
    "picture_in_picture": "e8aa",
    "picture_in_picture_alt": "e911",
    "pie_chart": "e6c4",
    "pie_chart_outlined": "e6c5",
    "pin_drop": "e55e",
    "pivot_table_chart": "e9ce",
    "place": "e55f",
    "plagiarism": "ea5a",
    "play_arrow": "e037",
    "play_circle_fill": "e038",
    "play_circle_filled": "e038",
    "play_circle_outline": "e039",
    "play_disabled": "ef6a",
    "play_for_work": "e906",
    "playlist_add": "e03b",
    "playlist_add_check": "e065",
    "playlist_play": "e05f",
    "plumbing": "f107",
    "plus_one": "e800",
    "point_of_sale": "f17e",
    "policy": "ea17",
    "poll": "e801",
    "polymer": "e8ab",
    "pool": "eb48",
    "portable_wifi_off": "e0ce",
    "portrait": "e416",
    "post_add": "ea20",
    "power": "e63c",
    "power_input": "e336",
    "power_off": "e646",
    "power_settings_new": "e8ac",
    "pregnant_woman": "e91e",
    "present_to_all": "e0df",
    "preview": "f1c5",
    "print": "e8ad",
    "print_disabled": "e9cf",
    "priority_high": "e645",
    "privacy_tip": "f0dc",
    "psychology": "ea4a",
    "public": "e80b",
    "public_off": "f1ca",
    "publish": "e255",
    "published_with_changes": "f232",
    "push_pin": "f10d",
    "qr_code": "ef6b",
    "qr_code_2": "e00a",
    "qr_code_scanner": "f206",
    "query_builder": "e8ae",
    "question_answer": "e8af",
    "queue": "e03c",
    "queue_music": "e03d",
    "queue_play_next": "e066",
    "quick_contacts_dialer": "e0cf",
    "quick_contacts_mail": "e0d0",
    "quickreply": "ef6c",
    "radio": "e03e",
    "radio_button_checked": "e837",
    "radio_button_off": "e836",
    "radio_button_on": "e837",
    "radio_button_unchecked": "e836",
    "railway_alert": "e9d1",
    "ramen_dining": "ea64",
    "rate_review": "e560",
    "read_more": "ef6d",
    "receipt": "e8b0",
    "receipt_long": "ef6e",
    "recent_actors": "e03f",
    "recommend": "e9d2",
    "record_voice_over": "e91f",
    "redeem": "e8b1",
    "redo": "e15a",
    "reduce_capacity": "f21c",
    "refresh": "e5d5",
    "remove": "e15b",
    "remove_circle": "e15c",
    "remove_circle_outline": "e15d",
    "remove_done": "e9d3",
    "remove_from_queue": "e067",
    "remove_moderator": "e9d4",
    "remove_red_eye": "e417",
    "remove_shopping_cart": "e928",
    "reorder": "e8fe",
    "repeat": "e040",
    "repeat_on": "e9d6",
    "repeat_one": "e041",
    "repeat_one_on": "e9d7",
    "replay": "e042",
    "replay_10": "e059",
    "replay_30": "e05a",
    "replay_5": "e05b",
    "replay_circle_filled": "e9d8",
    "reply": "e15e",
    "reply_all": "e15f",
    "report": "e160",
    "report_off": "e170",
    "report_problem": "e8b2",
    "request_page": "f22c",
    "request_quote": "f1b6",
    "reset_tv": "e9d9",
    "restaurant": "e56c",
    "restaurant_menu": "e561",
    "restore": "e8b3",
    "restore_from_trash": "e938",
    "restore_page": "e929",
    "rice_bowl": "f1f5",
    "ring_volume": "e0d1",
    "roofing": "f201",
    "room": "e8b4",
    "room_preferences": "f1b8",
    "room_service": "eb49",
    "rotate_90_degrees_ccw": "e418",
    "rotate_left": "e419",
    "rotate_right": "e41a",
    "rounded_corner": "e920",
    "router": "e328",
    "rowing": "e921",
    "rss_feed": "e0e5",
    "rtt": "e9ad",
    "rule": "f1c2",
    "rule_folder": "f1c9",
    "run_circle": "ef6f",
    "rv_hookup": "e642",
    "sanitizer": "f21d",
    "satellite": "e562",
    "save": "e161",
    "save_alt": "e171",
    "saved_search": "ea11",
    "scanner": "e329",
    "scatter_plot": "e268",
    "schedule": "e8b5",
    "schedule_send": "ea0a",
    "school": "e80c",
    "science": "ea4b",
    "score": "e269",
    "screen_lock_landscape": "e1be",
    "screen_lock_portrait": "e1bf",
    "screen_lock_rotation": "e1c0",
    "screen_rotation": "e1c1",
    "screen_search_desktop": "ef70",
    "screen_share": "e0e2",
    "sd": "e9dd",
    "sd_card": "e623",
    "sd_storage": "e1c2",
    "search": "e8b6",
    "search_off": "ea76",
    "security": "e32a",
    "segment": "e94b",
    "select_all": "e162",
    "self_improvement": "ea78",
    "send": "e163",
    "send_and_archive": "ea0c",
    "send_to_mobile": "f05c",
    "sensor_door": "f1b5",
    "sensor_window": "f1b4",
    "sentiment_dissatisfied": "e811",
    "sentiment_neutral": "e812",
    "sentiment_satisfied": "e813",
    "sentiment_satisfied_alt": "e0ed",
    "sentiment_very_dissatisfied": "e814",
    "sentiment_very_satisfied": "e815",
    "set_meal": "f1ea",
    "settings": "e8b8",
    "settings_applications": "e8b9",
    "settings_backup_restore": "e8ba",
    "settings_bluetooth": "e8bb",
    "settings_brightness": "e8bd",
    "settings_cell": "e8bc",
    "settings_display": "e8bd",
    "settings_ethernet": "e8be",
    "settings_input_antenna": "e8bf",
    "settings_input_component": "e8c0",
    "settings_input_composite": "e8c1",
    "settings_input_hdmi": "e8c2",
    "settings_input_svideo": "e8c3",
    "settings_overscan": "e8c4",
    "settings_phone": "e8c5",
    "settings_power": "e8c6",
    "settings_remote": "e8c7",
    "settings_system_daydream": "e1c3",
    "settings_voice": "e8c8",
    "share": "e80d",
    "shield": "e9e0",
    "shop": "e8c9",
    "shop_two": "e8ca",
    "shopping_bag": "f1cc",
    "shopping_basket": "e8cb",
    "shopping_cart": "e8cc",
    "short_text": "e261",
    "show_chart": "e6e1",
    "shuffle": "e043",
    "shuffle_on": "e9e1",
    "shutter_speed": "e43d",
    "sick": "f220",
    "signal_cellular_0_bar": "f0a8",
    "signal_cellular_4_bar": "e1c8",
    "signal_cellular_alt": "e202",
    "signal_cellular_connected_no_internet_4_bar": "e1cd",
    "signal_cellular_no_sim": "e1ce",
    "signal_cellular_null": "e1cf",
    "signal_cellular_off": "e1d0",
    "signal_wifi_0_bar": "f0b0",
    "signal_wifi_4_bar": "e1d8",
    "signal_wifi_4_bar_lock": "e1d9",
    "signal_wifi_off": "e1da",
    "sim_card": "e32b",
    "sim_card_alert": "e624",
    "single_bed": "ea48",
    "skip_next": "e044",
    "skip_previous": "e045",
    "slideshow": "e41b",
    "slow_motion_video": "e068",
    "smart_button": "f1c1",
    "smartphone": "e32c",
    "smoke_free": "eb4a",
    "smoking_rooms": "eb4b",
    "sms": "e625",
    "sms_failed": "e626",
    "snippet_folder": "f1c7",
    "snooze": "e046",
    "soap": "f1b2",
    "sort": "e164",
    "sort_by_alpha": "e053",
    "source": "f1c4",
    "south": "f1e3",
    "south_east": "f1e4",
    "south_west": "f1e5",
    "spa": "eb4c",
    "space_bar": "e256",
    "speaker": "e32d",
    "speaker_group": "e32e",
    "speaker_notes": "e8cd",
    "speaker_notes_off": "e92a",
    "speaker_phone": "e0d2",
    "speed": "e9e4",
    "spellcheck": "e8ce",
    "sports": "ea30",
    "sports_bar": "f1f3",
    "sports_baseball": "ea51",
    "sports_basketball": "ea26",
    "sports_cricket": "ea27",
    "sports_esports": "ea28",
    "sports_football": "ea29",
    "sports_golf": "ea2a",
    "sports_handball": "ea33",
    "sports_hockey": "ea2b",
    "sports_kabaddi": "ea34",
    "sports_mma": "ea2c",
    "sports_motorsports": "ea2d",
    "sports_rugby": "ea2e",
    "sports_soccer": "ea2f",
    "sports_tennis": "ea32",
    "sports_volleyball": "ea31",
    "square_foot": "ea49",
    "stacked_bar_chart": "e9e6",
    "stacked_line_chart": "f22b",
    "stairs": "f1a9",
    "star": "e838",
    "star_border": "e83a",
    "star_half": "e839",
    "star_outline": "e83a",
    "star_rate": "f0ec",
    "stars": "e8d0",
    "stay_current_landscape": "e0d3",
    "stay_current_portrait": "e0d4",
    "stay_primary_landscape": "e0d5",
    "stay_primary_portrait": "e0d6",
    "sticky_note_2": "f1fc",
    "stop": "e047",
    "stop_circle": "ef71",
    "stop_screen_share": "e0e3",
    "storage": "e1db",
    "store": "e8d1",
    "store_mall_directory": "e563",
    "storefront": "ea12",
    "straighten": "e41c",
    "stream": "e9e9",
    "streetview": "e56e",
    "strikethrough_s": "e257",
    "stroller": "f1ae",
    "style": "e41d",
    "subdirectory_arrow_left": "e5d9",
    "subdirectory_arrow_right": "e5da",
    "subject": "e8d2",
    "subscript": "f111",
    "subscriptions": "e064",
    "subtitles": "e048",
    "subtitles_off": "ef72",
    "subway": "e56f",
    "superscript": "f112",
    "supervised_user_circle": "e939",
    "supervisor_account": "e8d3",
    "support": "ef73",
    "support_agent": "f0e2",
    "surround_sound": "e049",
    "swap_calls": "e0d7",
    "swap_horiz": "e8d4",
    "swap_horizontal_circle": "e933",
    "swap_vert": "e8d5",
    "swap_vert_circle": "e8d6",
    "swap_vertical_circle": "e8d6",
    "swipe": "e9ec",
    "switch_account": "e9ed",
    "switch_camera": "e41e",
    "switch_left": "f1d1",
    "switch_right": "f1d2",
    "switch_video": "e41f",
    "sync": "e627",
    "sync_alt": "ea18",
    "sync_disabled": "e628",
    "sync_problem": "e629",
    "system_update": "e62a",
    "system_update_alt": "e8d7",
    "system_update_tv": "e8d7",
    "tab": "e8d8",
    "tab_unselected": "e8d9",
    "table_chart": "e265",
    "table_rows": "f101",
    "table_view": "f1be",
    "tablet": "e32f",
    "tablet_android": "e330",
    "tablet_mac": "e331",
    "tag": "e9ef",
    "tag_faces": "e420",
    "takeout_dining": "ea74",
    "tap_and_play": "e62b",
    "tapas": "f1e9",
    "taxi_alert": "ef74",
    "terrain": "e564",
    "text_fields": "e262",
    "text_format": "e165",
    "text_rotate_up": "e93a",
    "text_rotate_vertical": "e93b",
    "text_rotation_angledown": "e93c",
    "text_rotation_angleup": "e93d",
    "text_rotation_down": "e93e",
    "text_rotation_none": "e93f",
    "text_snippet": "f1c6",
    "textsms": "e0d8",
    "texture": "e421",
    "theater_comedy": "ea66",
    "theaters": "e8da",
    "thumb_down": "e8db",
    "thumb_down_alt": "e816",
    "thumb_down_off_alt": "e9f2",
    "thumb_up": "e8dc",
    "thumb_up_alt": "e817",
    "thumb_up_off_alt": "e9f3",
    "thumbs_up_down": "e8dd",
    "time_to_leave": "e62c",
    "timelapse": "e422",
    "timeline": "e922",
    "timer": "e425",
    "timer_10": "e423",
    "timer_3": "e424",
    "timer_off": "e426",
    "title": "e264",
    "toc": "e8de",
    "today": "e8df",
    "toggle_off": "e9f5",
    "toggle_on": "e9f6",
    "toll": "e8e0",
    "tonality": "e427",
    "topic": "f1c8",
    "touch_app": "e913",
    "tour": "ef75",
    "toys": "e332",
    "track_changes": "e8e1",
    "traffic": "e565",
    "train": "e570",
    "tram": "e571",
    "transfer_within_a_station": "e572",
    "transform": "e428",
    "transit_enterexit": "e579",
    "translate": "e8e2",
    "trending_down": "e8e3",
    "trending_flat": "e8e4",
    "trending_neutral": "e8e4",
    "trending_up": "e8e5",
    "trip_origin": "e57b",
    "tty": "f1aa",
    "tune": "e429",
    "turned_in": "e8e6",
    "turned_in_not": "e8e7",
    "tv": "e333",
    "tv_off": "e647",
    "two_wheeler": "e9f9",
    "umbrella": "f1ad",
    "unarchive": "e169",
    "undo": "e166",
    "unfold_less": "e5d6",
    "unfold_more": "e5d7",
    "unpublished": "f236",
    "unsubscribe": "e0eb",
    "update": "e923",
    "update_disabled": "e075",
    "upgrade": "f0fb",
    "upload_file": "e9fc",
    "usb": "e1e0",
    "verified": "ef76",
    "verified_user": "e8e8",
    "vertical_align_bottom": "e258",
    "vertical_align_center": "e259",
    "vertical_align_top": "e25a",
    "vertical_distribute": "e076",
    "vertical_split": "e949",
    "vibration": "e62d",
    "video_call": "e070",
    "video_collection": "e04a",
    "video_label": "e071",
    "video_library": "e04a",
    "video_settings": "ea75",
    "videocam": "e04b",
    "videocam_off": "e04c",
    "videogame_asset": "e338",
    "view_agenda": "e8e9",
    "view_array": "e8ea",
    "view_carousel": "e8eb",
    "view_column": "e8ec",
    "view_comfortable": "e42a",
    "view_comfy": "e42a",
    "view_compact": "e42b",
    "view_day": "e8ed",
    "view_headline": "e8ee",
    "view_in_ar": "e9fe",
    "view_list": "e8ef",
    "view_module": "e8f0",
    "view_quilt": "e8f1",
    "view_sidebar": "f114",
    "view_stream": "e8f2",
    "view_week": "e8f3",
    "vignette": "e435",
    "visibility": "e8f4",
    "visibility_off": "e8f5",
    "voice_chat": "e62e",
    "voice_over_off": "e94a",
    "voicemail": "e0d9",
    "volume_down": "e04d",
    "volume_mute": "e04e",
    "volume_off": "e04f",
    "volume_up": "e050",
    "volunteer_activism": "ea70",
    "vpn_key": "e0da",
    "vpn_lock": "e62f",
    "wallet_giftcard": "e8f6",
    "wallet_membership": "e8f7",
    "wallet_travel": "e8f8",
    "wallpaper": "e1bc",
    "warning": "e002",
    "wash": "f1b1",
    "watch": "e334",
    "watch_later": "e924",
    "water_damage": "f203",
    "waterfall_chart": "ea00",
    "waves": "e176",
    "wb_auto": "e42c",
    "wb_cloudy": "e42d",
    "wb_incandescent": "e42e",
    "wb_iridescent": "e436",
    "wb_shade": "ea01",
    "wb_sunny": "e430",
    "wb_twighlight": "ea02",
    "wc": "e63d",
    "web": "e051",
    "web_asset": "e069",
    "weekend": "e16b",
    "west": "f1e6",
    "whatshot": "e80e",
    "wheelchair_pickup": "f1ab",
    "where_to_vote": "e177",
    "widgets": "e1bd",
    "wifi": "e63e",
    "wifi_calling": "ef77",
    "wifi_lock": "e1e1",
    "wifi_off": "e648",
    "wifi_protected_setup": "f0fc",
    "wifi_tethering": "e1e2",
    "wine_bar": "f1e8",
    "work": "e8f9",
    "work_off": "e942",
    "work_outline": "e943",
    "workspaces_filled": "ea0d",
    "workspaces_outline": "ea0f",
    "wrap_text": "e25b",
    "wrong_location": "ef78",
    "wysiwyg": "f1c3",
    "youtube_searched_for": "e8fa",
    "zoom_in": "e8ff",
    "zoom_out": "e900",
    "zoom_out_map": "e56b"
};

const _c0$1G = function (a0, a1) { return { color: a0, "font-size": a1 }; };
function ExIconComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 7, ctx_r0.tooltip))("ngStyle", i0.ɵɵpureFunction2(9, _c0$1G, ctx_r0.color, ctx_r0.sizePx))("innerHTML", ctx_r0.getMaterialCodepoint(ctx_r0.iconName), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-hidden", ctx_r0.ariaHidden)("aria-label", i0.ɵɵpipeBind1(1, 5, ctx_r0.ariaLabel));
} }
const _c1$14 = function (a0, a1, a2, a3) { return { top: a0, color: a1, width: a2, height: a3 }; };
function ExIconComponent_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 5);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("svgIcon", ctx_r1.iconName)("exTooltip", i0.ɵɵpipeBind1(2, 7, ctx_r1.tooltip))("ngStyle", i0.ɵɵpureFunction4(9, _c1$14, ctx_r1.top, ctx_r1.color, ctx_r1.widthPx || (ctx_r1.heightPx ? "auto" : ctx_r1.sizePx), ctx_r1.heightPx || (ctx_r1.widthPx ? "auto" : ctx_r1.sizePx)));
    i0.ɵɵattribute("aria-hidden", ctx_r1.ariaHidden)("aria-label", i0.ɵɵpipeBind1(1, 5, ctx_r1.ariaLabel));
} }
function ExIconComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 6);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("fa ", ctx_r2.iconName, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(8, _c0$1G, ctx_r2.color, ctx_r2.sizePx));
    i0.ɵɵattribute("aria-hidden", ctx_r2.ariaHidden)("aria-label", i0.ɵɵpipeBind1(1, 6, ctx_r2.ariaLabel));
} }
function ExIconComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 6);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("uxf-icon ", ctx_r3.iconName, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(8, _c0$1G, ctx_r3.color, ctx_r3.sizePx));
    i0.ɵɵattribute("aria-hidden", ctx_r3.ariaHidden)("aria-label", i0.ɵɵpipeBind1(1, 6, ctx_r3.ariaLabel));
} }
const _c2$K = function (a0) { return { "action-button-bg": a0 }; };
const _c3$B = function (a0, a1) { return { width: a0, height: a1 }; };
var IconType;
(function (IconType) {
    IconType["matIcon"] = "matIcon";
    IconType["mat"] = "mat";
    IconType["svg"] = "svg";
    IconType["font"] = "fa-font";
    IconType["uxf"] = "uxf";
})(IconType || (IconType = {}));
class ExIconComponent {
    constructor(iconRegistry, sanitizer) {
        this.iconRegistry = iconRegistry;
        this.sanitizer = sanitizer;
        this.ariaLabel = '';
        this.ariaHidden = true;
        this.top = '3px';
        this.sizePx = '16px';
        this.isActionButton = false;
        this.materialCodepoints = MaterialIconCodepointsRegular;
    }
    ngOnInit() {
        if (this.arguments) {
            this.iconName = this.arguments.iconName;
            this.color = this.arguments.iconColor;
            this.iconType = this.arguments.iconType;
            this.sizePx = this.arguments.iconSize;
            this.tooltip = this.arguments.tooltip;
        }
    }
    ngOnChanges(changes) {
        if ((changes.hasOwnProperty('iconName') || changes.hasOwnProperty('iconType'))
            && IconType[this.iconType] === IconType.svg && !!this.iconName) {
            const svgPath = '/ng/assets/svg-icons/' + this.iconName + '.svg';
            this.iconRegistry.addSvgIcon(this.iconName, this.sanitizer.bypassSecurityTrustResourceUrl(svgPath));
        }
    }
    get IconType() {
        return IconType;
    }
    getMaterialCodepoint(icon) {
        const cp = this.materialCodepoints[icon];
        return cp ? `&#x${cp};` : this.sanitizer.sanitize(SecurityContext.HTML, icon);
    }
    static { this.ɵfac = function ExIconComponent_Factory(t) { return new (t || ExIconComponent)(i0.ɵɵdirectiveInject(i1$9.MatIconRegistry), i0.ɵɵdirectiveInject(i2$2.DomSanitizer)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExIconComponent, selectors: [["ex-icon"]], inputs: { iconType: "iconType", iconName: "iconName", ariaLabel: "ariaLabel", ariaHidden: "ariaHidden", color: "color", top: "top", sizePx: "sizePx", widthPx: "widthPx", heightPx: "heightPx", tooltip: "tooltip", arguments: "arguments", isActionButton: "isActionButton" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 11, consts: [[3, "ngClass", "ngStyle"], ["class", "material-icons", 3, "exTooltip", "ngStyle", "innerHTML", 4, "ngIf"], ["class", "ex-icon-mat", 3, "svgIcon", "exTooltip", "ngStyle", 4, "ngIf"], [3, "class", "ngStyle", 4, "ngIf"], [1, "material-icons", 3, "exTooltip", "ngStyle", "innerHTML"], [1, "ex-icon-mat", 3, "svgIcon", "exTooltip", "ngStyle"], [3, "ngStyle"]], template: function ExIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExIconComponent_i_1_Template, 3, 12, "i", 1);
            i0.ɵɵtemplate(2, ExIconComponent_mat_icon_2_Template, 3, 14, "mat-icon", 2);
            i0.ɵɵtemplate(3, ExIconComponent_i_3_Template, 2, 11, "i", 3);
            i0.ɵɵtemplate(4, ExIconComponent_i_4_Template, 2, 11, "i", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$K, ctx.isActionButton))("ngStyle", i0.ɵɵpureFunction2(8, _c3$B, ctx.isActionButton ? ctx.sizePx : "", ctx.isActionButton ? ctx.sizePx : ""));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconType === ctx.IconType.matIcon || ctx.iconType === ctx.IconType.mat);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconType === ctx.IconType.svg);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconType === ctx.IconType.font);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconType === ctx.IconType.uxf);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgStyle, i1$9.MatIcon, ExTooltipDirective, i1$2.TranslatePipe], styles: [".ex-icon-mat[_ngcontent-%COMP%]{display:flex}.material-icons[_ngcontent-%COMP%]{vertical-align:middle}.action-button-bg[_ngcontent-%COMP%]{box-sizing:content-box;padding:5px;border-radius:50%;display:flex;justify-content:center;align-items:center}.action-button-bg[_ngcontent-%COMP%]:hover{background-color:#a8a8a8}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-icon', template: "<div [ngClass]=\"{ 'action-button-bg': isActionButton }\" [ngStyle]=\"{ width: (isActionButton ? this.sizePx : '' ), \n      height: (isActionButton ? this.sizePx : '' ) }\">\n<i\n  *ngIf=\"iconType === IconType.matIcon || iconType === IconType.mat\"\n  [attr.aria-hidden]=\"ariaHidden\"\n  [attr.aria-label]=\"ariaLabel | translate\"\n  class=\"material-icons\"\n  [exTooltip]=\"tooltip | translate\"\n  [ngStyle]=\"{ color: color, 'font-size': sizePx }\"\n  [innerHTML]=\"getMaterialCodepoint(iconName)\"\n>\n</i>\n\n<mat-icon\n  *ngIf=\"iconType === IconType.svg\"\n  [svgIcon]=\"iconName\"\n  [attr.aria-hidden]=\"ariaHidden\"\n  [attr.aria-label]=\"ariaLabel | translate\"\n  class=\"ex-icon-mat\"\n  [exTooltip]=\"tooltip | translate\"\n  [ngStyle]=\"{top: top, color: color, width: widthPx || (heightPx ? 'auto' : sizePx), height: heightPx || (widthPx ? 'auto' : sizePx) }\"\n></mat-icon>\n\n<i\n  *ngIf=\"iconType === IconType.font\"\n  [attr.aria-hidden]=\"ariaHidden\"\n  [attr.aria-label]=\"ariaLabel | translate\"\n  class=\"fa {{ iconName }}\"\n  [ngStyle]=\"{ color: color, 'font-size': sizePx }\"\n></i>\n\n  <i *ngIf=\"iconType === IconType.uxf\" \n      [attr.aria-hidden]=\"ariaHidden\" \n      [attr.aria-label]=\"ariaLabel | translate\"\n      class=\"uxf-icon {{ iconName }}\" \n      [ngStyle]=\"{ color: color, 'font-size': sizePx }\"\n  ></i>\n</div>", styles: [".ex-icon-mat{display:flex}.material-icons{vertical-align:middle}.action-button-bg{box-sizing:content-box;padding:5px;border-radius:50%;display:flex;justify-content:center;align-items:center}.action-button-bg:hover{background-color:#a8a8a8}\n"] }]
    }], function () { return [{ type: i1$9.MatIconRegistry }, { type: i2$2.DomSanitizer }]; }, { iconType: [{
            type: Input
        }], iconName: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaHidden: [{
            type: Input
        }], color: [{
            type: Input
        }], top: [{
            type: Input
        }], sizePx: [{
            type: Input
        }], widthPx: [{
            type: Input
        }], heightPx: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], arguments: [{
            type: Input
        }], isActionButton: [{
            type: Input
        }] }); })();

class ExIconModule {
    static { this.ɵfac = function ExIconModule_Factory(t) { return new (t || ExIconModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExIconModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatIconModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExIconModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExIconComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule
                ],
                exports: [
                    ExIconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExIconModule, { declarations: [ExIconComponent], imports: [CommonModule,
        MatIconModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule], exports: [ExIconComponent] }); })();

function ExAvatarComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExAvatarComponent_ng_container_0_ex_spinner_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 7);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("diameter", ctx_r4.diameter);
} }
function ExAvatarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 2);
    i0.ɵɵtemplate(2, ExAvatarComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelement(3, "ex-icon", 4);
    i0.ɵɵtemplate(4, ExAvatarComponent_ng_container_0_ex_spinner_4_Template, 1, 1, "ex-spinner", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 6);
    i0.ɵɵlistener("change", function ExAvatarComponent_ng_container_0_Template_input_change_5_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onImageFileChange($event.target.files)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.loading);
} }
function ExAvatarComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r7.diameter, "px")("width", ctx_r7.diameter, "px")("background-image", "url(" + ctx_r7.imgSrc + ")");
} }
function ExAvatarComponent_ng_template_1_ex_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 11);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", ctx_r8.reversedIcon ? "account-circle-reversed" : "account-circle")("color", ctx_r8.placeholderColor)("sizePx", ctx_r8.diameter + "px");
} }
function ExAvatarComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExAvatarComponent_ng_template_1_div_0_Template, 1, 6, "div", 8);
    i0.ɵɵtemplate(1, ExAvatarComponent_ng_template_1_ex_icon_1_Template, 1, 3, "ex-icon", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.showImage && ctx_r2.imgSrc && ctx_r2.isLoaded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.showImage || !ctx_r2.isLoaded);
} }
class ExAvatarComponent {
    set imgSrc(imgSrc) {
        this._imgSrc = imgSrc;
        this._imgSrc && this.preload();
    }
    get imgSrc() {
        return this._imgSrc;
    }
    constructor(cdr) {
        this.cdr = cdr;
        this.diameter = 20;
        this.loading = false;
        this.placeholderColor = '#66686b';
        this.hasEdit = false;
        this.reversedIcon = false;
        this.showImage = true;
        this.imageFileChanged = new EventEmitter();
        this.isLoaded = false;
    }
    ngOnInit() {
    }
    onImageFileChange(files) {
        files?.length > 0 && this.imageFileChanged.emit(files);
    }
    preload() {
        this.isLoaded = false;
        const img = new Image();
        img.onload = () => { this.isLoaded = true; this.cdr.markForCheck(); };
        img.onerror = () => { this.isLoaded = false; this.cdr.markForCheck(); };
        img.src = this._imgSrc;
    }
    static { this.ɵfac = function ExAvatarComponent_Factory(t) { return new (t || ExAvatarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExAvatarComponent, selectors: [["ex-avatar"]], inputs: { diameter: "diameter", loading: "loading", placeholderColor: "placeholderColor", hasEdit: "hasEdit", reversedIcon: "reversedIcon", showImage: "showImage", imgSrc: "imgSrc" }, outputs: { imageFileChanged: "imageFileChanged" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["avatar", ""], ["for", "file-input", 1, "ex-avatar-edit-container"], [4, "ngTemplateOutlet"], ["color", "#4164a4", "iconName", "uxf-camera", "iconType", "fa-font", 1, "ex-avatar-camera-icon"], [3, "diameter", 4, "ngIf"], ["id", "file-input", "accept", ".jpg,.jpeg,.png,.gif,.bmp", "type", "file", 2, "display", "none", 3, "disabled", "change"], [3, "diameter"], ["class", "image-cropper", 3, "height", "width", "background-image", 4, "ngIf"], ["class", "ex-avatar-placeholder", "iconType", "svg", 3, "iconName", "color", "sizePx", 4, "ngIf"], [1, "image-cropper"], ["iconType", "svg", 1, "ex-avatar-placeholder", 3, "iconName", "color", "sizePx"]], template: function ExAvatarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExAvatarComponent_ng_container_0_Template, 6, 3, "ng-container", 0);
            i0.ɵɵtemplate(1, ExAvatarComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.hasEdit)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgIf, i1$5.NgTemplateOutlet, ExIconComponent, ExSpinnerComponent], styles: ["ex-spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;justify-content:center}.image-cropper[_ngcontent-%COMP%]{overflow:hidden;border-radius:50%;background-size:cover;background-position:center}.ex-avatar-placeholder[_ngcontent-%COMP%]     i{margin-inline-start:-3px;vertical-align:middle}.ex-avatar-edit-container[_ngcontent-%COMP%]{position:relative;cursor:pointer}.ex-avatar-edit-container[_ngcontent-%COMP%]:hover   .ex-avatar-camera-icon[_ngcontent-%COMP%]{visibility:visible}.ex-avatar-edit-container[_ngcontent-%COMP%]   .ex-avatar-camera-icon[_ngcontent-%COMP%]{padding:3px 8px;border-radius:50%;position:absolute;bottom:-5px;inset-inline-end:-5px;visibility:hidden;background:#fff;display:flex;align-items:center;justify-content:center}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAvatarComponent, [{
        type: Component,
        args: [{ selector: 'ex-avatar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"hasEdit; else avatar\">\r\n    <label for=\"file-input\" class=\"ex-avatar-edit-container\">\r\n        <ng-container *ngTemplateOutlet=\"avatar\"></ng-container>\r\n        <ex-icon class=\"ex-avatar-camera-icon\" color=\"#4164a4\" iconName=\"uxf-camera\" iconType=\"fa-font\"></ex-icon>\r\n        <ex-spinner [diameter]=\"diameter\" *ngIf=\"loading\"></ex-spinner>\r\n    </label>\r\n    <input id=\"file-input\" accept=\".jpg,.jpeg,.png,.gif,.bmp\" type=\"file\" style=\"display: none;\"\r\n        (change)=\"onImageFileChange($any($event.target).files)\" [disabled]=\"loading\" />\r\n</ng-container>\r\n\r\n<ng-template #avatar>\r\n    <div *ngIf=\"showImage && imgSrc && isLoaded\" class=\"image-cropper\" [style.height.px]=\"diameter\"\r\n        [style.width.px]=\"diameter\" [style.background-image]=\"'url(' + imgSrc + ')'\">\r\n    </div>\r\n    <ex-icon *ngIf=\"!showImage || !isLoaded\" class=\"ex-avatar-placeholder\" iconType=\"svg\"\r\n        [iconName]=\"reversedIcon ? 'account-circle-reversed' : 'account-circle'\" [color]=\"placeholderColor\"\r\n        [sizePx]=\"diameter + 'px'\">\r\n    </ex-icon>\r\n</ng-template>", styles: ["ex-spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;justify-content:center}.image-cropper{overflow:hidden;border-radius:50%;background-size:cover;background-position:center}.ex-avatar-placeholder ::ng-deep i{margin-inline-start:-3px;vertical-align:middle}.ex-avatar-edit-container{position:relative;cursor:pointer}.ex-avatar-edit-container:hover .ex-avatar-camera-icon{visibility:visible}.ex-avatar-edit-container .ex-avatar-camera-icon{padding:3px 8px;border-radius:50%;position:absolute;bottom:-5px;inset-inline-end:-5px;visibility:hidden;background:#fff;display:flex;align-items:center;justify-content:center}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { diameter: [{
            type: Input
        }], loading: [{
            type: Input
        }], placeholderColor: [{
            type: Input
        }], hasEdit: [{
            type: Input
        }], reversedIcon: [{
            type: Input
        }], showImage: [{
            type: Input
        }], imgSrc: [{
            type: Input
        }], imageFileChanged: [{
            type: Output
        }] }); })();

class ExAvatarModule {
    static { this.ɵfac = function ExAvatarModule_Factory(t) { return new (t || ExAvatarModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExAvatarModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            ExSpinnerModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAvatarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    ExSpinnerModule
                ],
                declarations: [
                    ExAvatarComponent
                ],
                exports: [
                    ExAvatarComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExAvatarModule, { declarations: [ExAvatarComponent], imports: [CommonModule,
        ExIconModule,
        ExSpinnerModule], exports: [ExAvatarComponent] }); })();

const Animations$9 = [
    trigger('expand', [
        state('*', style({
            height: AUTO_STYLE,
            width: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('void', style({
            height: '30px',
            width: '200px',
            overflow: 'hidden',
            paddingTop: '0px',
            paddingBottom: '0px'
        }), { params: { width: '1000px' } }),
        transition('void <=> *', [
            animate('0.3s')
        ])
    ])
];

const iconSizes = {
    'xxsmall': '10px',
    'xsmall': '12px',
    'small': '14px',
    'medium': '16px',
    'large': '20px',
    'xlarge': '24px',
    'xxlarge': '30px'
};
function getIconSizeInPx(iconSize) {
    return iconSizes[iconSize] ?? '16px';
}
class IconModel {
    constructor(iconName, iconType, iconColor, iconSize, iconSizePx, iconStyle, tooltip, callback, statusColor) {
        this.iconName = iconName;
        this.iconType = iconType;
        this.iconColor = iconColor;
        this.iconSize = iconSize;
        this.iconSizePx = iconSizePx;
        this.iconStyle = iconStyle;
        this.tooltip = tooltip;
        this.callback = callback;
        this.statusColor = statusColor;
    }
}

function ExSvgIconComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, (tmp_0_0 = ctx_r0.tooltip) !== null && tmp_0_0 !== undefined ? tmp_0_0 : ctx_r0.ariaLabel), "\n");
} }
const _c0$1F = function (a0) { return { "ex-svg-icon-clickable": a0 }; };
const _c1$13 = function (a0) { return { color: a0 }; };
class ExSvgIconComponent {
    set size(size) {
        this._size = size;
        this.iconSize = getIconSizeInPx(size);
    }
    get size() {
        return this._size;
    }
    constructor(iconRegistry, sanitizer) {
        this.iconRegistry = iconRegistry;
        this.sanitizer = sanitizer;
        this.ariaLabel = '';
        this.ariaHidden = true;
        this.useThemeColor = false;
        this._size = 'medium';
        this.iconSize = '16px';
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('iconName')) {
            const svgPath = '/ng/assets/svg-icons/' + this.iconName + '.svg';
            this.iconRegistry.addSvgIcon(this.iconName, this.sanitizer.bypassSecurityTrustResourceUrl(svgPath));
        }
    }
    onClick() {
        if (this.callback) {
            event?.stopPropagation();
            this.callback();
        }
    }
    static { this.ɵfac = function ExSvgIconComponent_Factory(t) { return new (t || ExSvgIconComponent)(i0.ɵɵdirectiveInject(i1$9.MatIconRegistry), i0.ɵɵdirectiveInject(i2$2.DomSanitizer)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSvgIconComponent, selectors: [["ex-svg-icon"]], hostVars: 2, hostBindings: function ExSvgIconComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("--ex-svg-icon-size", ctx.iconSize);
        } }, inputs: { iconName: "iconName", ariaLabel: "ariaLabel", ariaHidden: "ariaHidden", tooltip: "tooltip", color: "color", useThemeColor: "useThemeColor", callback: "callback", size: "size" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 25, consts: [[3, "svgIcon", "exTooltip", "ngClass", "ngStyle", "click", "keydown.enter"], ["class", "cdk-visually-hidden", "role", "tooltip", 4, "ngIf"], ["role", "tooltip", 1, "cdk-visually-hidden"]], template: function ExSvgIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-icon", 0);
            i0.ɵɵlistener("click", function ExSvgIconComponent_Template_mat_icon_click_0_listener() { return ctx.onClick(); })("keydown.enter", function ExSvgIconComponent_Template_mat_icon_keydown_enter_0_listener() { return ctx.onClick(); });
            i0.ɵɵpipe(1, "generateHTMLId");
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExSvgIconComponent_span_4_Template, 3, 3, "span", 1);
        } if (rf & 2) {
            let tmp_9_0;
            i0.ɵɵclassMapInterpolate2("ex-svg-icon-mat ", ctx._size, " ", ctx.iconName && ctx.iconName != "" ? i0.ɵɵpipeBind1(1, 15, "ex-svg-icon-" + ctx.iconName) : "", "");
            i0.ɵɵclassProp("theme-color-icon", ctx.useThemeColor);
            i0.ɵɵproperty("svgIcon", ctx.iconName)("exTooltip", i0.ɵɵpipeBind1(3, 19, ctx.tooltip))("ngClass", i0.ɵɵpureFunction1(21, _c0$1F, ctx.callback))("ngStyle", i0.ɵɵpureFunction1(23, _c1$13, ctx.color));
            i0.ɵɵattribute("role", ctx.callback || ctx.tooltip ? "button" : null)("tabindex", ctx.callback || ctx.tooltip ? "0" : null)("aria-hidden", ctx.ariaHidden)("aria-label", i0.ɵɵpipeBind1(2, 17, (tmp_9_0 = ctx.ariaLabel) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ctx.tooltip));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.tooltip || ctx.ariaLabel);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgStyle, i1$9.MatIcon, ExTooltipDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-svg-icon-mat[_ngcontent-%COMP%]{display:flex}.mat-icon[_ngcontent-%COMP%]{font-size:14px;margin:auto;transform:translateY(20%)}.ex-svg-icon-clickable[_ngcontent-%COMP%]{cursor:pointer}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSvgIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-svg-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-icon [attr.role]=\"callback || tooltip? 'button' : null\" [attr.tabindex]=\"callback || tooltip ? '0' : null\" [svgIcon]=\"iconName\"\n  [attr.aria-hidden]=\"ariaHidden\" [attr.aria-label]=\"(ariaLabel ?? tooltip) | translate\" (click)=\"onClick()\" (keydown.enter)=\"onClick()\"\n  class=\"ex-svg-icon-mat {{_size}} {{(iconName && iconName!='') ? ('ex-svg-icon-' + iconName | generateHTMLId) : ''}}\" [exTooltip]=\"tooltip | translate\"\n  [ngClass]=\"{'ex-svg-icon-clickable': callback}\" [ngStyle]=\"{ color: color }\" [class.theme-color-icon]=\"useThemeColor\"></mat-icon>\n\n<!-- Tooltip content -->\n<span *ngIf=\"tooltip || ariaLabel\" class=\"cdk-visually-hidden\" role=\"tooltip\">\n  {{(tooltip ?? ariaLabel) | translate}}\n</span>\n", styles: [".ex-svg-icon-mat{display:flex}.mat-icon{font-size:14px;margin:auto;transform:translateY(20%)}.ex-svg-icon-clickable{cursor:pointer}\n"] }]
    }], function () { return [{ type: i1$9.MatIconRegistry }, { type: i2$2.DomSanitizer }]; }, { iconName: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaHidden: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], color: [{
            type: Input
        }], useThemeColor: [{
            type: Input
        }], callback: [{
            type: Input
        }], size: [{
            type: Input
        }], iconSize: [{
            type: HostBinding,
            args: ['style.--ex-svg-icon-size']
        }] }); })();

const _c0$1E = ["button"];
class ExCloseComponent {
    constructor() {
        /**
         * Tooltip for X button
         */
        this.tooltip = 'ng.general.close';
        /**
         * Size for X button
         */
        this.size = 'medium';
        /**
         * Whether the X button is disabled
         */
        this.disabled = false;
        /**
         * Emits close clicked
         */
        this.closeClicked = new EventEmitter();
    }
    focus() {
        this.button.nativeElement.focus();
    }
    getIconSize(size) {
        return size === 'small' ? 'xxsmall' : size === 'medium' ? 'small' : size;
    }
    static { this.ɵfac = function ExCloseComponent_Factory(t) { return new (t || ExCloseComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExCloseComponent, selectors: [["ex-close"]], viewQuery: function ExCloseComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1E, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
        } }, inputs: { tooltip: "tooltip", size: "size", disabled: "disabled" }, outputs: { closeClicked: "closeClicked" }, decls: 5, vars: 8, consts: [["mat-ripple", "", 1, "ex-close", "sel-ex-close", 3, "exTooltip", "disabled", "click", "keyup.enter"], ["button", ""], ["iconName", "close", 1, "ex-close-icon", "sel-ex-close-icon", 3, "size"]], template: function ExCloseComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0, 1);
            i0.ɵɵlistener("click", function ExCloseComponent_Template_button_click_0_listener() { return ctx.closeClicked.emit(); })("keyup.enter", function ExCloseComponent_Template_button_keyup_enter_0_listener() { return ctx.closeClicked.emit(); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelement(4, "ex-svg-icon", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate("exTooltip", i0.ɵɵpipeBind1(2, 4, ctx.tooltip));
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 6, ctx.tooltip));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("size", ctx.getIconSize(ctx.size));
        } }, dependencies: [ExTooltipDirective, ExSvgIconComponent, i1$2.TranslatePipe], styles: [".ex-close[_ngcontent-%COMP%]{cursor:pointer;padding:0 10px;min-height:30px;display:inline-flex;align-items:center;justify-content:center}button[_ngcontent-%COMP%]{border:0;background-color:transparent}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCloseComponent, [{
        type: Component,
        args: [{ selector: 'ex-close', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button #button exTooltip=\"{{tooltip | translate}}\" class=\"ex-close sel-ex-close\" mat-ripple\n  [disabled]=\"disabled\" (click)=\"closeClicked.emit()\" (keyup.enter)=\"closeClicked.emit()\"\n  attr.aria-label=\"{{tooltip | translate}}\">\n  <ex-svg-icon [size]=\"getIconSize(size)\"\n    class=\"ex-close-icon sel-ex-close-icon\" iconName=\"close\"></ex-svg-icon>\n</button>\n", styles: [".ex-close{cursor:pointer;padding:0 10px;min-height:30px;display:inline-flex;align-items:center;justify-content:center}button{border:0;background-color:transparent}\n"] }]
    }], null, { tooltip: [{
            type: Input
        }], size: [{
            type: Input
        }], disabled: [{
            type: Input
        }], closeClicked: [{
            type: Output
        }], button: [{
            type: ViewChild,
            args: ['button']
        }] }); })();

function ExBadgeComponent_ex_avatar_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-avatar", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("imgSrc", ctx_r1.avatarURL)("diameter", 30);
} }
function ExBadgeComponent_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", ctx_r2.iconBackground || "default")("color", ctx_r2.iconColor || "transparent");
    i0.ɵɵproperty("iconName", ctx_r2.iconName);
} }
function ExBadgeComponent_ex_icon_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-icon", 10);
    i0.ɵɵlistener("click", function ExBadgeComponent_ex_icon_6_Template_ex_icon_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.openPopup()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r7 = ctx.$implicit;
    i0.ɵɵproperty("iconType", icon_r7.type)("iconName", icon_r7.name)("color", icon_r7.color);
} }
function ExBadgeComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1, "|");
    i0.ɵɵelementEnd();
} }
function ExBadgeComponent_ex_close_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 12);
    i0.ɵɵlistener("closeClicked", function ExBadgeComponent_ex_close_8_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onRemoveClicked()); });
    i0.ɵɵelementEnd();
} }
const _c0$1D = function (a0) { return { width: a0 }; };
const _c1$12 = function (a0, a1) { return { value: a0, params: a1 }; };
function ExBadgeComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("clickOutside", function ExBadgeComponent_div_9_Template_div_clickOutside_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.closePopupClick()); });
    i0.ɵɵelementStart(1, "div", 14)(2, "div", 15);
    i0.ɵɵelement(3, "ex-avatar", 8);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "i", 16);
    i0.ɵɵlistener("click", function ExBadgeComponent_div_9_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.closePopupClick()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 17);
    i0.ɵɵprojection(8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵstyleProp("background", ctx_r6.backgroundColor || "default");
    i0.ɵɵproperty("@expand", i0.ɵɵpureFunction2(8, _c1$12, ctx_r6.popupOpen ? "true" : "false", i0.ɵɵpureFunction1(6, _c0$1D, _r0.offsetWidth)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("imgSrc", ctx_r6.avatarURL)("diameter", 30);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.title);
} }
const _c2$J = function (a0) { return { "ex-badge-view-mode": a0 }; };
const _c3$A = ["*"];
class ExBadgeComponent {
    constructor() {
        /**
         * the list of icons you want on the badge
         */
        this.icons = [];
        /**
         * whether the popup is opened or not
         */
        this.popupOpen = false;
        /**
         * set to false id you don't want an avatar on the badge - if you don't set it to false and don't provide the avatarURL input a default avatar will be shown
         */
        this.showAvatar = true;
        /**
         * event fired when clicking on the x icon
         */
        this.removeClicked = new EventEmitter();
        this.dontClosePopup = false;
    }
    openPopup() {
        this.popupOpen = true;
        this.dontClosePopup = true;
    }
    closePopupClick() {
        if (!this.dontClosePopup) {
            this.popupOpen = false;
        }
        this.dontClosePopup = false;
    }
    onRemoveClicked() {
        this.removeClicked.emit();
    }
    static { this.ɵfac = function ExBadgeComponent_Factory(t) { return new (t || ExBadgeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExBadgeComponent, selectors: [["ex-badge"]], inputs: { avatarURL: "avatarURL", icons: "icons", backgroundColor: "backgroundColor", title: "title", popupOpen: "popupOpen", showAvatar: "showAvatar", viewMode: "viewMode", iconName: "iconName", iconBackground: "iconBackground", iconColor: "iconColor" }, outputs: { removeClicked: "removeClicked" }, ngContentSelectors: _c3$A, decls: 10, vars: 12, consts: [[1, "ex-badge", "sel-ex-badge", 3, "ngClass"], ["container", ""], ["class", "ex-badge-avatar", 3, "imgSrc", "diameter", 4, "ngIf"], ["class", "ex-badge-avatar icon-cropper", "size", "large", 3, "iconName", "background", "color", 4, "ngIf"], ["class", "ex-badge-icon", "sizePx", "14px", 3, "iconType", "iconName", "color", "click", 4, "ngFor", "ngForOf"], ["class", "ex-badge-divider", 4, "ngIf"], ["class", "ex-badge-remove", "size", "small", "tooltip", "ng.general.remove", 3, "closeClicked", 4, "ngIf"], ["class", "ex-badge-popup", 3, "background", "clickOutside", 4, "ngIf"], [1, "ex-badge-avatar", 3, "imgSrc", "diameter"], ["size", "large", 1, "ex-badge-avatar", "icon-cropper", 3, "iconName"], ["sizePx", "14px", 1, "ex-badge-icon", 3, "iconType", "iconName", "color", "click"], [1, "ex-badge-divider"], ["size", "small", "tooltip", "ng.general.remove", 1, "ex-badge-remove", 3, "closeClicked"], [1, "ex-badge-popup", 3, "clickOutside"], [1, "ex-badge-popup-header"], [1, "ex-badge-popup-user-details"], [1, "uxf-icon", "uxf-resize-small", "ex-badge-resize-icon", 3, "click"], [1, "ex-badge-popup-body"]], template: function ExBadgeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵtemplate(2, ExBadgeComponent_ex_avatar_2_Template, 1, 2, "ex-avatar", 2);
            i0.ɵɵtemplate(3, ExBadgeComponent_ex_svg_icon_3_Template, 1, 5, "ex-svg-icon", 3);
            i0.ɵɵelementStart(4, "span");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, ExBadgeComponent_ex_icon_6_Template, 1, 3, "ex-icon", 4);
            i0.ɵɵtemplate(7, ExBadgeComponent_span_7_Template, 2, 0, "span", 5);
            i0.ɵɵtemplate(8, ExBadgeComponent_ex_close_8_Template, 1, 0, "ex-close", 6);
            i0.ɵɵtemplate(9, ExBadgeComponent_div_9_Template, 9, 11, "div", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.backgroundColor || "default");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$J, ctx.viewMode));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showAvatar);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconName);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.icons);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.viewMode && ctx.icons && ctx.icons.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.viewMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.popupOpen);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExCloseComponent, ExAvatarComponent, ExClickOutsideDirective, ExSvgIconComponent, ExIconComponent], styles: [".ex-badge[_ngcontent-%COMP%]{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:30px;align-items:center;padding:0 15px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-avatar[_ngcontent-%COMP%]{margin-inline-end:5px;margin-inline-start:-15px}.ex-badge[_ngcontent-%COMP%]   .icon-cropper[_ngcontent-%COMP%]{overflow:hidden;border-radius:50%;background-size:cover;width:30px;height:30px;background-position:center}.ex-badge[_ngcontent-%COMP%]   .ex-badge-name[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-icon[_ngcontent-%COMP%]{color:#4164a4;cursor:pointer;margin-inline-start:5px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-icon-view-mode[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.ex-badge[_ngcontent-%COMP%]   .ex-badge-remove[_ngcontent-%COMP%]{margin-bottom:4px;margin-inline-end:-10px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-divider[_ngcontent-%COMP%]{margin-inline-start:8px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]{position:absolute;inset-inline-start:0px;top:0;border-radius:15px;background:#f0f5f8;z-index:5;padding:5px;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-header[_ngcontent-%COMP%]   .ex-badge-popup-user-details[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;margin-top:-5px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-header[_ngcontent-%COMP%]   .ex-badge-popup-user-details[_ngcontent-%COMP%]   .ex-badge-avatar[_ngcontent-%COMP%]{margin-inline-start:-5px}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-header[_ngcontent-%COMP%]   .ex-badge-resize-icon[_ngcontent-%COMP%]{margin-top:5px;margin-inline-end:5px;color:#4164a4;cursor:pointer}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-body[_ngcontent-%COMP%]{padding:10px;display:flex;flex-direction:column}.ex-badge[_ngcontent-%COMP%]   .ex-badge-popup[_ngcontent-%COMP%]   .ex-badge-popup-body[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-badge-view-mode[_ngcontent-%COMP%]{pointer-events:none}"], data: { animation: [Animations$9] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBadgeComponent, [{
        type: Component,
        args: [{ selector: 'ex-badge', animations: [Animations$9], template: "<div class=\"ex-badge sel-ex-badge\" [ngClass]=\"{ 'ex-badge-view-mode': viewMode }\" #container\n    [style.background]=\"backgroundColor || 'default'\">\n    <ex-avatar class=\"ex-badge-avatar\" *ngIf=\"showAvatar\" [imgSrc]=\"avatarURL\" [diameter]=\"30\">\n    </ex-avatar>\n\n    <ex-svg-icon *ngIf=\"iconName\" class=\"ex-badge-avatar icon-cropper\" size=\"large\" [iconName]=\"iconName\" [style.background]=\"iconBackground || 'default'\" [style.color]=\"iconColor || 'transparent'\" >\n    </ex-svg-icon>\n\n    <span>{{ title }}</span> \n    <ex-icon *ngFor=\"let icon of icons\" class=\"ex-badge-icon\" [iconType]=\"icon.type\" [iconName]=\"icon.name\"\n        [color]=\"icon.color\" sizePx=\"14px\" (click)=\"openPopup()\"></ex-icon>\n    <span *ngIf=\"!viewMode && icons && icons.length > 0\" class=\"ex-badge-divider\">|</span>\n    <ex-close *ngIf=\"!viewMode\" class=\"ex-badge-remove\" size=\"small\" (closeClicked)=\"onRemoveClicked()\"\n        tooltip='ng.general.remove'>\n    </ex-close>\n\n    <div *ngIf=\"popupOpen\" [@expand]=\"{ value: popupOpen? 'true' : 'false', params: { width: container.offsetWidth } }\"\n        (clickOutside)=\"closePopupClick()\" class=\"ex-badge-popup\" [style.background]=\"backgroundColor || 'default'\">\n        <div class=\"ex-badge-popup-header\">\n            <div class=\"ex-badge-popup-user-details\">\n                <ex-avatar class=\"ex-badge-avatar\" [imgSrc]=\"avatarURL\" [diameter]=\"30\">\n                </ex-avatar>\n                <span>{{ title }}</span>\n            </div>\n            <i class=\"uxf-icon uxf-resize-small ex-badge-resize-icon\" (click)=\"closePopupClick()\"></i>\n        </div>\n        <div class=\"ex-badge-popup-body\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>", styles: [".ex-badge{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:30px;align-items:center;padding:0 15px}.ex-badge .ex-badge-avatar{margin-inline-end:5px;margin-inline-start:-15px}.ex-badge .icon-cropper{overflow:hidden;border-radius:50%;background-size:cover;width:30px;height:30px;background-position:center}.ex-badge .ex-badge-name{margin-inline-end:5px}.ex-badge .ex-badge-icon{color:#4164a4;cursor:pointer;margin-inline-start:5px}.ex-badge .ex-badge-icon-view-mode{cursor:default;pointer-events:none}.ex-badge .ex-badge-remove{margin-bottom:4px;margin-inline-end:-10px}.ex-badge .ex-badge-divider{margin-inline-start:8px}.ex-badge .ex-badge-popup{position:absolute;inset-inline-start:0px;top:0;border-radius:15px;background:#f0f5f8;z-index:5;padding:5px;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.ex-badge .ex-badge-popup .ex-badge-popup-header{display:flex;flex-direction:row;justify-content:space-between}.ex-badge .ex-badge-popup .ex-badge-popup-header .ex-badge-popup-user-details{display:flex;flex-direction:row;align-items:center;margin-top:-5px}.ex-badge .ex-badge-popup .ex-badge-popup-header .ex-badge-popup-user-details .ex-badge-avatar{margin-inline-start:-5px}.ex-badge .ex-badge-popup .ex-badge-popup-header .ex-badge-resize-icon{margin-top:5px;margin-inline-end:5px;color:#4164a4;cursor:pointer}.ex-badge .ex-badge-popup .ex-badge-popup-body{padding:10px;display:flex;flex-direction:column}.ex-badge .ex-badge-popup .ex-badge-popup-body ex-icon{margin-inline-end:5px}.ex-badge-view-mode{pointer-events:none}\n"] }]
    }], null, { avatarURL: [{
            type: Input
        }], icons: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], title: [{
            type: Input
        }], popupOpen: [{
            type: Input
        }], showAvatar: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], iconName: [{
            type: Input
        }], iconBackground: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], removeClicked: [{
            type: Output
        }] }); })();

class ExSvgIconModule {
    static { this.ɵfac = function ExSvgIconModule_Factory(t) { return new (t || ExSvgIconModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSvgIconModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatIconModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSvgIconModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExSvgIconComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    EXPipesModule
                ],
                exports: [
                    ExSvgIconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSvgIconModule, { declarations: [ExSvgIconComponent], imports: [CommonModule,
        MatIconModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        EXPipesModule], exports: [ExSvgIconComponent] }); })();

class ExCloseModule {
    static { this.ɵfac = function ExCloseModule_Factory(t) { return new (t || ExCloseModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExCloseModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCloseModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExCloseComponent
                ],
                exports: [
                    ExCloseComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExCloseModule, { declarations: [ExCloseComponent], imports: [CommonModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        ExSvgIconModule], exports: [ExCloseComponent] }); })();

class ExBadgeModule {
    static { this.ɵfac = function ExBadgeModule_Factory(t) { return new (t || ExBadgeModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExBadgeModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExCloseModule,
            ExAvatarModule,
            ExDirectivesModule,
            ExSvgIconModule,
            ExIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBadgeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExCloseModule,
                    ExAvatarModule,
                    ExDirectivesModule,
                    ExSvgIconModule,
                    ExIconModule
                ],
                declarations: [
                    ExBadgeComponent
                ],
                exports: [
                    ExBadgeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExBadgeModule, { declarations: [ExBadgeComponent], imports: [CommonModule,
        ExCloseModule,
        ExAvatarModule,
        ExDirectivesModule,
        ExSvgIconModule,
        ExIconModule], exports: [ExBadgeComponent] }); })();

class MenuItemService {
    constructor() {
        this.closeMenuSubject = new Subject();
        this.closeMenuSubject$ = this.closeMenuSubject.asObservable();
    }
    closeMenu() {
        this.closeMenuSubject.next();
    }
    static { this.ɵfac = function MenuItemService_Factory(t) { return new (t || MenuItemService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MenuItemService, factory: MenuItemService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const _c0$1C = ["floatingContent"];
const _c1$11 = ["childMenu"];
const _c2$I = ["matMenuContent"];
function MenuItemComponent_ng_container_4_ex_component_loader_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 11);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("componentFactoryItem", ctx_r6.dynamicComponent)("events", ctx_r6.dynamicComponent.events)("data", ctx_r6.dynamicComponent.data);
} }
const _c3$z = function () { return []; };
function MenuItemComponent_ng_container_4_ex_new_combobox_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 12);
    i0.ɵɵlistener("itemAdded", function MenuItemComponent_ng_container_4_ex_new_combobox_4_Template_ex_new_combobox_itemAdded_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8._actionClickedFromCombobox(ctx_r8.items, $event)); });
    i0.ɵɵpipe(1, "menuItemsToCombobox");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(1, 6, ctx_r7.items))("allowUnlistedValues", !!ctx_r7.unlistedValuesParams)("unlistedValueSuffix", ctx_r7.unlistedValuesParams == null ? null : ctx_r7.unlistedValuesParams.suffix)("getNewItemKey", ctx_r7.unlistedValuesParams == null ? null : ctx_r7.unlistedValuesParams.getNewItemKey)("selectedItems", i0.ɵɵpureFunction0(8, _c3$z))("isAlwaysOpen", true);
} }
function MenuItemComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6, 7);
    i0.ɵɵlistener("keydown", function MenuItemComponent_ng_container_4_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.blockTabPropagation($event)); })("keydown.escape", function MenuItemComponent_ng_container_4_Template_div_keydown_escape_1_listener($event) { i0.ɵɵrestoreView(_r11); i0.ɵɵnextContext(); const _r0 = i0.ɵɵreference(1); _r0.closed.emit("keydown"); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵtemplate(3, MenuItemComponent_ng_container_4_ex_component_loader_3_Template, 1, 3, "ex-component-loader", 8);
    i0.ɵɵtemplate(4, MenuItemComponent_ng_container_4_ex_new_combobox_4_Template, 2, 9, "ex-new-combobox", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵlistener("focus", function MenuItemComponent_ng_container_4_Template_div_focus_5_listener($event) { i0.ɵɵrestoreView(_r11); i0.ɵɵnextContext(); const _r0 = i0.ɵɵreference(1); _r0.closed.emit("keydown"); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.dynamicComponent != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasSearch);
} }
const _c4$s = function (a0) { return { "ex-record-actions-disabled": a0 }; };
function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("menuOpened", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_button_3_Template_button_menuOpened_0_listener() { i0.ɵɵrestoreView(_r23); i0.ɵɵnextContext(); const _r21 = i0.ɵɵreference(6); return i0.ɵɵresetView(_r21.setFocus()); })("click", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_button_3_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r23); const action_r15 = i0.ɵɵnextContext(2).$implicit; const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24._actionClicked(action_r15, $event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r21 = i0.ɵɵreference(6);
    const action_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ex-record-actions-item sel-record-actions-button ", i0.ɵɵpipeBind1(1, 8, action_r15), "");
    i0.ɵɵproperty("disabled", action_r15.disabled)("ngClass", i0.ɵɵpureFunction1(12, _c4$s, action_r15.disabled))("matMenuTriggerFor", _r21.childMenu);
    i0.ɵɵattribute("aria-describedby", ctx_r19.ariaDescribedBy);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 10, action_r15.label), " ");
} }
function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r31); const action_r15 = i0.ɵɵnextContext(3).$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29._actionClicked(action_r15, $event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵelementStart(2, "span", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 25);
    i0.ɵɵelementStart(6, "button", 26);
    i0.ɵɵlistener("menuOpened", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_button_1_Template_button_menuOpened_6_listener() { i0.ɵɵrestoreView(_r31); i0.ɵɵnextContext(2); const _r21 = i0.ɵɵreference(6); return i0.ɵɵresetView(_r21.setFocus()); })("click", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_button_1_Template_button_click_6_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r33.onClick($event)); });
    i0.ɵɵelementStart(7, "i", 27);
    i0.ɵɵtext(8, "arrow_drop_down");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r21 = i0.ɵɵreference(6);
    const action_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ex-record-actions-item menu-item-split-type sel-record-actions-button ", i0.ɵɵpipeBind1(1, 8, action_r15), "");
    i0.ɵɵproperty("disabled", action_r15.disabled)("ngClass", i0.ɵɵpureFunction1(12, _c4$s, action_r15.disabled));
    i0.ɵɵattribute("aria-describedby", ctx_r27.ariaDescribedBy);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, action_r15.label), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matMenuTriggerFor", _r21.childMenu);
} }
const _c5$m = function (a0, a1) { return { "ex-record-actions-disabled": a0, "menu-item-horizontal-seperator": a1 }; };
function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "button", 29);
    i0.ɵɵlistener("click", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_div_2_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r35.onClick($event)); })("menuOpened", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_div_2_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r36); i0.ɵɵnextContext(2); const _r21 = i0.ɵɵreference(6); return i0.ɵɵresetView(_r21.setFocus()); });
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r21 = i0.ɵɵreference(6);
    const action_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", action_r15.disabled)("matMenuTriggerFor", _r21.childMenu)("ngClass", i0.ɵɵpureFunction2(7, _c5$m, action_r15.disabled, ctx_r28.items.length > 1));
    i0.ɵɵattribute("aria-describedby", ctx_r28.ariaDescribedBy);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, action_r15.label), " ");
} }
function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_button_1_Template, 9, 14, "button", 21);
    i0.ɵɵtemplate(2, MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_div_2_Template, 5, 10, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r15 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !action_r15.isLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", action_r15.isLink);
} }
function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_button_3_Template, 4, 14, "button", 16);
    i0.ɵɵtemplate(4, MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_ng_container_4_Template, 3, 2, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "menu-item", 18, 19);
    i0.ɵɵlistener("actionClicked", function MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_Template_menu_item_actionClicked_5_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); ctx_r40.actionClicked.emit($event); return i0.ɵɵresetView(ctx_r40.trigger == null ? null : ctx_r40.trigger.closeMenu()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 7, action_r15.tooltip));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !action_r15.component);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", action_r15.component);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r16.isMenuItem(action_r15) ? action_r15.children : action_r15.subActions)("dynamicComponent", action_r15.component)("hasSearch", action_r15.hasSearchBox)("unlistedValuesParams", ctx_r16.asAction(action_r15).unlistedValuesParams);
} }
const _c6$k = function (a0, a1) { return { "iconColor": a0, "iconStyle": a1 }; };
function MenuItemComponent_ng_template_5_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "button", 32);
    i0.ɵɵlistener("click", function MenuItemComponent_ng_template_5_ng_container_0_ng_template_2_Template_button_click_2_listener($event) { i0.ɵɵrestoreView(_r45); const action_r15 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(2); ctx_r43._actionClicked(action_r15, $event); return i0.ɵɵresetView(ctx_r43.trigger == null ? null : ctx_r43.trigger.closeMenu()); });
    i0.ɵɵpipe(3, "generateHTMLId");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "ex-label", 33);
    i0.ɵɵpipe(6, "objectAssign");
    i0.ɵɵpipe(7, "objectAssign");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const action_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", action_r15.disabled ? i0.ɵɵpipeBind1(1, 18, action_r15.tooltip) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-record-actions-item sel-record-actions-button ", i0.ɵɵpipeBind1(3, 20, action_r15), "");
    i0.ɵɵclassProp("copy-cell-value-action", action_r15.value === "ex_copy_cell_value" && ctx_r18.items.length > 1);
    i0.ɵɵproperty("disabled", action_r15.disabled)("ngClass", i0.ɵɵpureFunction1(30, _c4$s, action_r15.disabled))("exTooltip", i0.ɵɵpipeBind1(4, 22, action_r15.tooltip));
    i0.ɵɵattribute("aria-describedby", ctx_r18.ariaDescribedBy);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlId", ctx_r18.isMenuItem(action_r15) && action_r15.key || action_r15.value || action_r15.label)("svgIcon", (action_r15.icon == null ? null : action_r15.icon.iconType) !== "svg" ? undefined : i0.ɵɵpipeBind2(6, 24, action_r15.icon, i0.ɵɵpureFunction2(32, _c6$k, (action_r15 == null ? null : action_r15.disabled) ? "#b1a9a9" : action_r15.icon == null ? null : action_r15.icon.iconColor, i0.ɵɵpipeBind2(7, 27, ctx_r18.IgnoreLegacyTransform, action_r15.icon == null ? null : action_r15.icon.iconStyle))))("iconType", action_r15.icon == null ? null : action_r15.icon.iconType)("iconName", action_r15.icon == null ? null : action_r15.icon.iconName)("iconColor", (action_r15 == null ? null : action_r15.disabled) ? "#b1a9a9" : action_r15.icon == null ? null : action_r15.icon.iconColor)("iconSize", action_r15.icon == null ? null : action_r15.icon.iconSize)("iconStyle", action_r15.icon == null ? null : action_r15.icon.iconStyle)("value", action_r15 == null ? null : action_r15.label);
} }
function MenuItemComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MenuItemComponent_ng_template_5_ng_container_0_ng_container_1_Template, 7, 9, "ng-container", 4);
    i0.ɵɵtemplate(2, MenuItemComponent_ng_template_5_ng_container_0_ng_template_2_Template, 8, 35, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r15 = ctx.$implicit;
    const _r17 = i0.ɵɵreference(3);
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.isMenuItem(action_r15) && action_r15.children && action_r15.children.length > 0 || (ctx_r14.isAction(action_r15) && (action_r15.subActions && action_r15.subActions.length > 0) || action_r15.hasSearchBox && ctx_r14.asAction(action_r15).unlistedValuesParams) || action_r15.component)("ngIfElse", _r17);
} }
function MenuItemComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemComponent_ng_template_5_ng_container_0_Template, 4, 2, "ng-container", 13);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r4.items);
} }
const IgnoreLegacyTransform = { 'ignore-legacy-transform': true };
class MenuItemComponent {
    constructor(menuItemService) {
        this.menuItemService = menuItemService;
        this.IgnoreLegacyTransform = IgnoreLegacyTransform;
        this.position = 'after';
        this.hasSearch = false;
        this.dynamicComponent = null;
        /**
         * for Accessibility
         */
        this.ariaDescribedBy = null;
        this.actionClicked = new EventEmitter();
        this.subs = new Subscription();
    }
    ngOnInit() {
        this.subs.add(this.menuItemService.closeMenuSubject$.subscribe(() => {
            this.trigger?.closeMenu();
        }));
    }
    onClick(event) {
        event.stopPropagation();
    }
    setFocus() {
        if (!this.floatingContent?.nativeElement)
            return;
        setTimeout(() => {
            const res = this.floatingContent.nativeElement.querySelectorAll(this.dynamicComponent?.autoFocusClass || ".sel-search-input");
            if (res?.length === 1) {
                res[0].focus();
            }
            else {
                this.floatingContent.nativeElement.focus();
            }
        });
    }
    blockTabPropagation(event) {
        if (event.keyCode == TAB) {
            event.stopImmediatePropagation();
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    _actionClickedFromCombobox(actions, selectedKey) {
        const e = actions.find(action => action.value === selectedKey);
        this.actionClicked.emit(selectedKey);
        if (e && e.hasOwnProperty('onClick')) {
            e.onClick(selectedKey);
        }
    }
    _actionClicked(action, event) {
        if (action) {
            if (action.hasOwnProperty('value')) { // action is of type ActionModel
                this.actionClicked.emit(action.value);
            }
            else { // action is of type MenuItemModel
                const act = action;
                this.actionClicked.emit(act.key);
                if (act.onClick) {
                    act.onClick(event);
                }
            }
        }
        this.childMenu.closed.emit('keydown');
    }
    isMenuItem(menu) {
        return menu && !!menu.children;
    }
    isAction(action) {
        return action && !!action.subActions;
    }
    asAction(action) {
        return action;
    }
    static { this.ɵfac = function MenuItemComponent_Factory(t) { return new (t || MenuItemComponent)(i0.ɵɵdirectiveInject(MenuItemService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MenuItemComponent, selectors: [["menu-item"]], viewQuery: function MenuItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1C, 5);
            i0.ɵɵviewQuery(_c1$11, 7);
            i0.ɵɵviewQuery(_c2$I, 5, ElementRef);
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.floatingContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matMenuContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
        } }, inputs: { items: "items", position: "position", hasSearch: "hasSearch", dynamicComponent: "dynamicComponent", unlistedValuesParams: "unlistedValuesParams", ariaDescribedBy: "ariaDescribedBy" }, outputs: { actionClicked: "actionClicked" }, decls: 7, vars: 5, consts: [[3, "xPosition"], ["childMenu", "matMenu"], [1, "menu-item-wrapper", "sel-menu", 3, "keydown.escape"], ["matMenuContent", ""], [4, "ngIf", "ngIfElse"], ["subMenu", ""], ["tabindex", "-1", 3, "keydown", "keydown.escape"], ["floatingContent", ""], [3, "componentFactoryItem", "events", "data", 4, "ngIf"], [3, "items", "allowUnlistedValues", "unlistedValueSuffix", "getNewItemKey", "selectedItems", "isAlwaysOpen", "itemAdded", 4, "ngIf"], ["tabindex", "0", "aria-hidden", "true", 1, "ex-floating-component-accessibility-dummy", 3, "focus"], [3, "componentFactoryItem", "events", "data"], [3, "items", "allowUnlistedValues", "unlistedValueSuffix", "getNewItemKey", "selectedItems", "isAlwaysOpen", "itemAdded"], [4, "ngFor", "ngForOf"], ["leaf", ""], ["mat-button-wrapper", "", 3, "exTooltip"], ["mat-menu-item", "", 3, "disabled", "class", "ngClass", "matMenuTriggerFor", "menuOpened", "click", 4, "ngIf"], [4, "ngIf"], [3, "items", "dynamicComponent", "hasSearch", "unlistedValuesParams", "actionClicked"], ["menu", ""], ["mat-menu-item", "", 3, "disabled", "ngClass", "matMenuTriggerFor", "menuOpened", "click"], ["mat-menu-item", "", 3, "disabled", "class", "ngClass", "click", 4, "ngIf"], ["class", "menu-item-link-button-wrapper", 4, "ngIf"], ["mat-menu-item", "", 3, "disabled", "ngClass", "click"], [1, "menu-item-split-type-label"], [1, "menu-item-vertical-seperator"], ["mat-menu-item", "", 1, "menu-item-arrow-wrapper", 3, "matMenuTriggerFor", "menuOpened", "click"], [1, "material-icons"], [1, "menu-item-link-button-wrapper"], ["mat-menu-item", "", 1, "ex-record-actions-item", 3, "disabled", "matMenuTriggerFor", "ngClass", "click", "menuOpened"], [1, "menu-item-link-type-label"], [3, "exTooltip"], ["mat-menu-item", "", 3, "disabled", "ngClass", "exTooltip", "click"], [3, "htmlId", "svgIcon", "iconType", "iconName", "iconColor", "iconSize", "iconStyle", "value"]], template: function MenuItemComponent_Template(rf, ctx) { if (rf & 1) {
            const _r47 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-menu", 0, 1)(2, "div", 2, 3);
            i0.ɵɵlistener("keydown.escape", function MenuItemComponent_Template_div_keydown_escape_2_listener() { i0.ɵɵrestoreView(_r47); const _r0 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r0.closed.emit("keydown")); });
            i0.ɵɵtemplate(4, MenuItemComponent_ng_container_4_Template, 6, 2, "ng-container", 4);
            i0.ɵɵtemplate(5, MenuItemComponent_ng_template_5_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(6);
            i0.ɵɵclassMap(ctx.dynamicComponent != null && "ex-floating-component-max-width");
            i0.ɵɵproperty("xPosition", ctx.position);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.dynamicComponent != null || ctx.hasSearch)("ngIfElse", _r3);
        } }, styles: [".menu-item-wrapper[_ngcontent-%COMP%]   .ex-record-actions-item[_ngcontent-%COMP%]{display:flex;align-items:center;height:30px!important;padding:0 10px;font-size:inherit}.menu-item-wrapper[_ngcontent-%COMP%]   .menu-item-link-button-wrapper[_ngcontent-%COMP%]   .menu-item-horizontal-seperator[_ngcontent-%COMP%]{border-top:1px solid gray}.menu-item-wrapper[_ngcontent-%COMP%]   .menu-item-link-button-wrapper[_ngcontent-%COMP%]   .menu-item-link-type-label[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding-inline-start:10px}.menu-item-wrapper[_ngcontent-%COMP%]   .menu-item-link-button-wrapper[_ngcontent-%COMP%]     .mat-mdc-menu-item-submenu-trigger:after{color:transparent!important}.menu-item-wrapper[_ngcontent-%COMP%]   .ex-record-actions-item[_ngcontent-%COMP%]:hover, .menu-item-wrapper[_ngcontent-%COMP%]   .ex-record-actions-item[_ngcontent-%COMP%]:focus{border:1px solid #898989;border-right:none;border-left:none}.menu-item-wrapper[_ngcontent-%COMP%]   .ex-record-actions-disabled[_ngcontent-%COMP%]{pointer-events:none}.menu-item-split-type[_ngcontent-%COMP%]{padding-inline-start:0px!important;padding-inline-end:5px!important}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-split-type-label[_ngcontent-%COMP%]{padding-left:10px;height:30px;width:calc(100% - 27px)}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-split-type-label[_ngcontent-%COMP%]:hover{background-color:#0000000a}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-vertical-seperator[_ngcontent-%COMP%]{border-left:1px solid gray;height:20px;margin-inline-start:5px}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-arrow-wrapper[_ngcontent-%COMP%]{padding-top:10px}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-arrow-wrapper[_ngcontent-%COMP%]     .mat-menu-submenu-icon{display:none}.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-arrow-wrapper[_ngcontent-%COMP%]:hover{background-color:#0000000a}button.menu-item-split-type[_ngcontent-%COMP%]   .menu-item-arrow-wrapper[_ngcontent-%COMP%]{padding:10px 0 0!important;width:-moz-fit-content;width:fit-content}button.menu-item-split-type.mat-mdc-menu-item[_ngcontent-%COMP%]:hover, button.menu-item-link-button-wrapper.mat-mdc-button[_ngcontent-%COMP%]{background:none!important}  .mat-mdc-menu-panel{min-height:30px!important}  .mat-mdc-menu-item mat-icon{margin-right:0!important}  .mat-mdc-menu-item-submenu-trigger{padding-right:32px!important}.copy-cell-value-action[_ngcontent-%COMP%]{border-top:solid #e9ecef 1px;margin-top:5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemComponent, [{
        type: Component,
        args: [{ selector: 'menu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-menu #childMenu=\"matMenu\" [xPosition]=\"position\"\n  [class]='(dynamicComponent != null) && \"ex-floating-component-max-width\"'>\n  <div #matMenuContent class=\"menu-item-wrapper sel-menu\" (keydown.escape)=\"childMenu.closed.emit('keydown');\">\n    <ng-container *ngIf=\"dynamicComponent != null || hasSearch; else subMenu\">\n      <div #floatingContent tabindex=\"-1\" (keydown)=\"blockTabPropagation($event)\" (keydown.escape)=\"childMenu.closed.emit('keydown');$event.stopPropagation()\">\n        <ex-component-loader *ngIf=\"dynamicComponent != null\" [componentFactoryItem]=\"dynamicComponent\"\n          [events]=\"dynamicComponent.events\" [data]=\"dynamicComponent.data\">\n        </ex-component-loader>\n        <ex-new-combobox *ngIf=\"hasSearch\" [items]=\"items | menuItemsToCombobox\" [allowUnlistedValues]=\"!!this.unlistedValuesParams\" [unlistedValueSuffix]=\"unlistedValuesParams?.suffix\" [getNewItemKey]=\"unlistedValuesParams?.getNewItemKey\" [selectedItems]=\"[]\"\n         [isAlwaysOpen]=\"true\" (itemAdded)=\"_actionClickedFromCombobox(items, $event);\">\n        </ex-new-combobox>\n      </div>\n      <div tabindex=\"0\" (focus)=\"childMenu.closed.emit('keydown');$event.stopPropagation()\"\n        class=\"ex-floating-component-accessibility-dummy\" aria-hidden=\"true\"></div>\n    </ng-container>\n    <ng-template #subMenu>\n      <ng-container *ngFor=\"let action of items\" >\n        <!-- Handle branch node menu items -->\n        <ng-container *ngIf=\"((isMenuItem(action) && action.children && action.children.length > 0)\n          || (isAction(action) && (action.subActions && action.subActions.length > 0) || (action.hasSearchBox && asAction(action).unlistedValuesParams))) || action.component; else leaf\">\n          <span [exTooltip]=\"action.tooltip | translate\" mat-button-wrapper>\n\n            <button *ngIf=\"!action.component\" [disabled]=\"action.disabled\" (menuOpened)=\"menu.setFocus()\"\n              [attr.aria-describedby]=\"ariaDescribedBy\" class=\"ex-record-actions-item sel-record-actions-button {{action | generateHTMLId }}\"\n              mat-menu-item (click)=\"_actionClicked(action, $event)\"\n              [ngClass]=\"{'ex-record-actions-disabled': action.disabled }\" [matMenuTriggerFor]=\"menu.childMenu\">\n              {{action.label | translate}}\n            </button>\n            <ng-container *ngIf=\"action.component\">\n              <button *ngIf=\"!action.isLink\" [disabled]=\"action.disabled\" [attr.aria-describedby]=\"ariaDescribedBy\"\n                class=\"ex-record-actions-item menu-item-split-type sel-record-actions-button {{action | generateHTMLId }}\" mat-menu-item\n                (click)=\"_actionClicked(action, $event)\" [ngClass]=\"{'ex-record-actions-disabled': action.disabled }\">\n                <span class=\"menu-item-split-type-label\">\n                  {{action.label | translate}}\n                </span>\n                <span class=\"menu-item-vertical-seperator\"></span>\n                <button mat-menu-item class=\"menu-item-arrow-wrapper\" [matMenuTriggerFor]=\"menu.childMenu\" (menuOpened)=\"menu.setFocus()\"\n                  (click)=\"onClick($event)\" >\n                  <i class=\"material-icons\">arrow_drop_down</i>\n                </button>\n              </button>\n\n\n              <div *ngIf=\"action.isLink\" class=\"menu-item-link-button-wrapper\">\n                <button mat-menu-item [disabled]=\"action.disabled\" [attr.aria-describedby]=\"ariaDescribedBy\"\n                  class=\"ex-record-actions-item \" [matMenuTriggerFor]=\"menu.childMenu\" (click)=\"onClick($event)\"\n                  (menuOpened)=\"menu.setFocus()\"\n                  [ngClass]=\"{'ex-record-actions-disabled': action.disabled, 'menu-item-horizontal-seperator': items.length > 1 }\">\n                  <div class=\"menu-item-link-type-label\">\n                    {{action.label | translate}}\n                  </div>\n\n                </button>\n              </div>\n            </ng-container>\n          </span>\n\n          <menu-item #menu [items]=\"isMenuItem(action) ? action.children : action.subActions\"\n            [dynamicComponent]=\"action.component\" (actionClicked)=\"actionClicked.emit($event);trigger?.closeMenu()\"\n            [hasSearch]=\"action.hasSearchBox\" [unlistedValuesParams]=\"asAction(action).unlistedValuesParams\"></menu-item>\n        </ng-container>\n\n        <!-- Handle leaf node menu items -->\n        <ng-template #leaf>\n          <span [exTooltip]=\"action.disabled ? (action.tooltip | translate) : null\">\n            <button [disabled]=\"action.disabled\" class=\"ex-record-actions-item sel-record-actions-button {{action | generateHTMLId }}\" mat-menu-item\n              [attr.aria-describedby]=\"ariaDescribedBy\" (click)=\"_actionClicked(action, $event);trigger?.closeMenu()\"\n              [class.copy-cell-value-action]=\"action.value === 'ex_copy_cell_value' && items.length > 1\"\n              [ngClass]=\"{'ex-record-actions-disabled': action.disabled}\" [exTooltip]=\"action.tooltip | translate\">\n              <ex-label [htmlId]=\"isMenuItem(action) && action.key || action.value || action.label\"\n                         [svgIcon]=\"action.icon?.iconType !== 'svg' ? undefined : action.icon | objectAssign : { 'iconColor': action?.disabled ? '#b1a9a9' : action.icon?.iconColor, 'iconStyle': (IgnoreLegacyTransform | objectAssign : action.icon?.iconStyle) }\"\n                         [iconType]=\"action.icon?.iconType\" [iconName]=\"action.icon?.iconName\" [iconColor]=\"action?.disabled ? '#b1a9a9' : action.icon?.iconColor\"\n                         [iconSize]=\"action.icon?.iconSize\" [iconStyle]=\"action.icon?.iconStyle\" [value]=\"action?.label\">\n              </ex-label>\n            </button>\n          </span>\n        </ng-template>\n      </ng-container>\n    </ng-template>\n  </div>\n</mat-menu>\n", styles: [".menu-item-wrapper .ex-record-actions-item{display:flex;align-items:center;height:30px!important;padding:0 10px;font-size:inherit}.menu-item-wrapper .menu-item-link-button-wrapper .menu-item-horizontal-seperator{border-top:1px solid gray}.menu-item-wrapper .menu-item-link-button-wrapper .menu-item-link-type-label{display:flex;justify-content:space-between;align-items:center;padding-inline-start:10px}.menu-item-wrapper .menu-item-link-button-wrapper ::ng-deep .mat-mdc-menu-item-submenu-trigger:after{color:transparent!important}.menu-item-wrapper .ex-record-actions-item:hover,.menu-item-wrapper .ex-record-actions-item:focus{border:1px solid #898989;border-right:none;border-left:none}.menu-item-wrapper .ex-record-actions-disabled{pointer-events:none}.menu-item-split-type{padding-inline-start:0px!important;padding-inline-end:5px!important}.menu-item-split-type .menu-item-split-type-label{padding-left:10px;height:30px;width:calc(100% - 27px)}.menu-item-split-type .menu-item-split-type-label:hover{background-color:#0000000a}.menu-item-split-type .menu-item-vertical-seperator{border-left:1px solid gray;height:20px;margin-inline-start:5px}.menu-item-split-type .menu-item-arrow-wrapper{padding-top:10px}.menu-item-split-type .menu-item-arrow-wrapper ::ng-deep .mat-menu-submenu-icon{display:none}.menu-item-split-type .menu-item-arrow-wrapper:hover{background-color:#0000000a}button.menu-item-split-type .menu-item-arrow-wrapper{padding:10px 0 0!important;width:-moz-fit-content;width:fit-content}button.menu-item-split-type.mat-mdc-menu-item:hover,button.menu-item-link-button-wrapper.mat-mdc-button{background:none!important}::ng-deep .mat-mdc-menu-panel{min-height:30px!important}::ng-deep .mat-mdc-menu-item mat-icon{margin-right:0!important}::ng-deep .mat-mdc-menu-item-submenu-trigger{padding-right:32px!important}.copy-cell-value-action{border-top:solid #e9ecef 1px;margin-top:5px}\n"] }]
    }], function () { return [{ type: MenuItemService }]; }, { items: [{
            type: Input
        }], position: [{
            type: Input
        }], hasSearch: [{
            type: Input
        }], dynamicComponent: [{
            type: Input
        }], unlistedValuesParams: [{
            type: Input
        }], floatingContent: [{
            type: ViewChild,
            args: ['floatingContent']
        }], ariaDescribedBy: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], childMenu: [{
            type: ViewChild,
            args: ['childMenu', { static: true }]
        }], matMenuContent: [{
            type: ViewChild,
            args: ['matMenuContent', { read: ElementRef }]
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }] }); })();

const _c0$1B = ["singleButton"];
const _c1$10 = ["multiButton"];
const _c2$H = ["matMenuTrigger"];
const _c3$y = ["menu"];
function ExButtonComponent_button_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExButtonComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7, 8);
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "generateHTMLId");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵlistener("click", function ExButtonComponent_button_0_Template_div_click_6_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onClick($event)); });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExButtonComponent_button_0_ng_container_8_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassMapInterpolate2("ex-button-wrapper sel-ex-button\n", ctx_r0.uniqueSelector ? i0.ɵɵpipeBind1(2, 18, "ex-button-" + ctx_r0.uniqueSelector) : "", " ", ctx_r0.uniqueSelectorState ? i0.ɵɵpipeBind1(3, 20, "ex-button-state-" + ctx_r0.uniqueSelectorState) : "", "");
    i0.ɵɵstyleProp("flex", ctx_r0.full ? 1 : "initial")("flex-direction", ctx_r0.iconSide === "right" ? "row-reverse" : "row");
    i0.ɵɵproperty("ngClass", "ex-button-" + ctx_r0.type)("disabled", ctx_r0.disabled || ctx_r0.loading)("dir", ctx_r0._dir)("exTooltip", i0.ɵɵpipeBind1(5, 24, ctx_r0.tooltip));
    i0.ɵɵattribute("aria-haspopup", ctx_r0.ariaHasPopup)("aria-current", ctx_r0.ariaCurrent)("aria-label", i0.ɵɵpipeBind1(4, 22, ctx_r0.ariaLabel))("aria-pressed", ctx_r0.ariaPressed);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(7, 26, ctx_r0.disabled ? ctx_r0.disabledTooltip : null));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExButtonComponent_ng_container_1_button_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExButtonComponent_ng_container_1_button_1_ex_svg_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 17);
} }
function ExButtonComponent_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13, 14);
    i0.ɵɵlistener("menuOpened", function ExButtonComponent_ng_container_1_button_1_Template_button_menuOpened_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.setFocus()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "generateHTMLId");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵlistener("click", function ExButtonComponent_ng_container_1_button_1_Template_div_click_6_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onClick($event)); });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExButtonComponent_ng_container_1_button_1_ng_container_8_Template, 1, 0, "ng-container", 10);
    i0.ɵɵtemplate(9, ExButtonComponent_ng_container_1_button_1_ex_svg_icon_9_Template, 1, 0, "ex-svg-icon", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(7);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassMapInterpolate2("ex-button-wrapper sel-button-multi-button sel-ex-button ", ctx_r10.uniqueSelector ? i0.ɵɵpipeBind1(2, 18, "ex-button-multi-" + ctx_r10.uniqueSelector) : "", " ", ctx_r10.uniqueSelectorState ? i0.ɵɵpipeBind1(3, 20, "ex-button-state-" + ctx_r10.uniqueSelectorState) : "", "");
    i0.ɵɵstyleProp("flex", ctx_r10.full ? 1 : "initial")("flex-direction", ctx_r10.iconSide === "right" ? "row-reverse" : "row");
    i0.ɵɵproperty("ngClass", "ex-button-" + ctx_r10.type)("matMenuTriggerFor", _r5.childMenu)("disabled", ctx_r10.disabled || ctx_r10.loading)("dir", ctx_r10._dir)("exTooltip", i0.ɵɵpipeBind1(5, 24, ctx_r10.tooltip));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 22, ctx_r10.ariaLabel))("aria-pressed", ctx_r10.ariaPressed);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(7, 26, ctx_r10.disabled ? ctx_r10.disabledTooltip : null));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.displayArrow);
} }
function ExButtonComponent_ng_container_1_button_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c4$r = function (a0, a1) { return { "ex-button-arrow-icon-right": a0, "ex-button-arrow-icon-left": a1 }; };
function ExButtonComponent_ng_container_1_button_2_ex_svg_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 20);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c4$r, ctx_r20._dir === "ltr", ctx_r20._dir !== "ltr"));
} }
function ExButtonComponent_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18, 14);
    i0.ɵɵlistener("click", function ExButtonComponent_ng_container_1_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); i0.ɵɵnextContext(2); const _r2 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r2.openMenu()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "generateHTMLId");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵlistener("click", function ExButtonComponent_ng_container_1_button_2_Template_div_click_6_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onClick($event)); });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExButtonComponent_ng_container_1_button_2_ng_container_8_Template, 1, 0, "ng-container", 10);
    i0.ɵɵtemplate(9, ExButtonComponent_ng_container_1_button_2_ex_svg_icon_9_Template, 1, 4, "ex-svg-icon", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassMapInterpolate2("ex-button-wrapper sel-button-multi-button sel-ex-button ", ctx_r11.uniqueSelector ? i0.ɵɵpipeBind1(2, 17, "ex-button-multi-" + ctx_r11.uniqueSelector) : "", " ", ctx_r11.uniqueSelectorState ? i0.ɵɵpipeBind1(3, 19, "ex-button-state-" + ctx_r11.uniqueSelectorState) : "", "");
    i0.ɵɵstyleProp("flex", ctx_r11.full ? 1 : "initial")("flex-direction", ctx_r11.iconSide === "right" ? "row-reverse" : "row");
    i0.ɵɵproperty("ngClass", "ex-button-" + ctx_r11.type)("disabled", ctx_r11.disabled || ctx_r11.loading)("dir", ctx_r11._dir)("exTooltip", i0.ɵɵpipeBind1(5, 23, ctx_r11.tooltip));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 21, ctx_r11.ariaLabel))("aria-pressed", ctx_r11.ariaPressed);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(7, 25, ctx_r11.disabled ? ctx_r11.disabledTooltip : null));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.displayArrow);
} }
function ExButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExButtonComponent_ng_container_1_button_1_Template, 10, 28, "button", 11);
    i0.ɵɵtemplate(2, ExButtonComponent_ng_container_1_button_2_Template, 10, 27, "button", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.openToSide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.openToSide);
} }
function ExButtonComponent_ng_template_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
} }
const _c5$l = function (a0, a1) { return { "uxf-plus-circle": a0, "uxf-minus-circle": a1 }; };
function ExButtonComponent_ng_template_4_div_2_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 27);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5$l, ctx_r29.type === "add", ctx_r29.type === "remove"))("dir", ctx_r29._dir);
} }
function ExButtonComponent_ng_template_4_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c6$j = function (a0, a1) { return { "ex-button-icon-left": a0, "ex-button-icon-right": a1 }; };
function ExButtonComponent_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, ExButtonComponent_ng_template_4_div_2_i_1_Template, 1, 5, "i", 26);
    i0.ɵɵtemplate(2, ExButtonComponent_ng_template_4_div_2_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r24 = i0.ɵɵreference(1);
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c6$j, ctx_r26.iconSide === "left", ctx_r26.iconSide === "right"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.type !== "action" && ctx_r26.type !== "conf-action");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r24);
} }
function ExButtonComponent_ng_template_4_ex_spinner_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 28);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExButtonComponent_ng_template_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "ng.ex-button.process_action"), "");
} }
function ExButtonComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExButtonComponent_ng_template_4_ng_template_0_Template, 1, 0, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(2, ExButtonComponent_ng_template_4_div_2_Template, 3, 6, "div", 22);
    i0.ɵɵprojection(3);
    i0.ɵɵtemplate(4, ExButtonComponent_ng_template_4_ex_spinner_4_Template, 1, 1, "ex-spinner", 23);
    i0.ɵɵtemplate(5, ExButtonComponent_ng_template_4_div_5_Template, 3, 3, "div", 24);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.iconSide);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.loading);
} }
const _c7$g = ["*", [["", "icon", ""]]];
const _c8$e = function (a0) { return { "ex-button-side-trigger-start": a0 }; };
const _c9$b = ["*", "[icon]"];
class ExButtonComponent {
    /**
     * For when there are conflicts with directives with similar input names
     */
    set type2(type) {
        this.type = type;
    }
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * Type of the button
         * secondary bt default
         */
        this.type = 'secondary';
        /**
         * Is the button disabled or not
         * false by default
         */
        this.disabled = false;
        /**
         * the tooltip text
         * optional
         */
        this.tooltip = null;
        /**
         * the tooltip text to display when button is disabled
         * optional
         */
        this.disabledTooltip = null;
        /**
         * if true the button will take all the remaining place of its container
         */
        this.full = false;
        /**
         * disable button and display loading spinner on top of content
         */
        this.loading = false;
        /**
         * indicates icon side (right/left) - MUST populate to display icon!
         * affects the icon margin side, not the side of the icon in relation to the content.
         * margins inverted when rtl is 'rtl'.
         */
        this.iconSide = null;
        /**
         * optional sub action that will be opened as a menu when clicking on the button
         */
        this.children = [];
        /**
         * the value for the aria-HasPopup (menu, listbox, tree, grid, dialog, or true)
         * attribute needed for accessibility.
         * Indicates the availability and type of interactive popup element that can be triggered.
         */
        this.ariaHasPopup = null;
        /**
         * exposes the option to focus on the button from the outside,
         */
        /**
         * the value for the aria-current (page, step, location, date, time, true, false)
         * attribute needed for accessibility.
         * Indicates the element that represents the current item within a container or set of related
         * elements
         */
        this.ariaCurrent = null;
        this.openToSide = false;
        this.hasSearchBox = false;
        /**
         *  option to display an arrow on the button if has children
         */
        this.displayArrow = true;
        this.childClicked = new EventEmitter();
        this._dir = 'ltr';
        this.triggerAtStart = false;
        this.triggerSideToggled = false;
    }
    focus() {
        if (this.singleButton) {
            this.singleButton.nativeElement.focus();
        }
        else if (this.multiButton) {
            this.multiButton.nativeElement.focus();
        }
        this.cdr.markForCheck();
    }
    onClick(event) {
        if (this.disabled) {
            event.stopPropagation();
        }
    }
    ngOnInit() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
    }
    setFocus() {
        if (this.hasSearchBox) {
            this.menu.setFocus();
        }
    }
    actionClicked(value) {
        this.trigger?.closeMenu();
        this.childClicked.emit(value);
    }
    ngAfterViewInit() {
        if (this.autoFocus) {
            this.focus();
        }
    }
    setLoading(isLoading) {
        this.loading = isLoading;
        this.cdr.markForCheck();
    }
    onSideMenuOpened() {
        if (this.triggerSideToggled) {
            this.triggerSideToggled = false;
            return;
        }
        const matMenuPanel = document.getElementById(this.menu.childMenu.panelId);
        if (matMenuPanel)
            matMenuPanel.style.visibility = "hidden";
        let triggerElemRect;
        let menuElemRect;
        setTimeout(() => {
            menuElemRect = this.elementBounds(this.menu.matMenuContent.nativeElement);
            triggerElemRect = this.elementBounds(this.triggerElem.nativeElement);
            if (this._dir == "ltr" ? (menuElemRect?.left - triggerElemRect?.left) < -1 : (menuElemRect?.right - triggerElemRect?.right) > 1) {
                this.toggleTriggerSide();
            }
            if (matMenuPanel)
                matMenuPanel.style.visibility = "visible";
        }, 0);
    }
    toggleTriggerSide() {
        this.trigger.closeMenu();
        this.triggerAtStart = !this.triggerAtStart;
        this.triggerSideToggled = true;
        this.trigger.openMenu();
    }
    onSideMenuClosed() {
        this.triggerAtStart = false;
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { left, right } = el.getBoundingClientRect();
        return {
            right: right,
            left: left,
        };
    }
    static { this.ɵfac = function ExButtonComponent_Factory(t) { return new (t || ExButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExButtonComponent, selectors: [["ex-button"]], viewQuery: function ExButtonComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1B, 5);
            i0.ɵɵviewQuery(_c1$10, 5);
            i0.ɵɵviewQuery(_c2$H, 5);
            i0.ɵɵviewQuery(_c2$H, 5, ElementRef);
            i0.ɵɵviewQuery(_c3$y, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
        } }, hostVars: 2, hostBindings: function ExButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("ex-button-fit-content", !ctx.full);
        } }, inputs: { type: "type", type2: "type2", disabled: "disabled", tooltip: "tooltip", disabledTooltip: "disabledTooltip", full: "full", loading: "loading", iconSide: "iconSide", children: "children", autoFocus: "autoFocus", ariaLabel: "ariaLabel", ariaPressed: "ariaPressed", ariaHasPopup: "ariaHasPopup", ariaCurrent: "ariaCurrent", openToSide: "openToSide", hasSearchBox: "hasSearchBox", unlistedValuesParams: "unlistedValuesParams", uniqueSelector: "uniqueSelector", uniqueSelectorState: "uniqueSelectorState", displayArrow: "displayArrow" }, outputs: { childClicked: "childClicked" }, ngContentSelectors: _c9$b, decls: 8, vars: 10, consts: [["mat-ripple", "", 3, "class", "ngClass", "flex", "flex-direction", "disabled", "dir", "exTooltip", 4, "ngIf"], [4, "ngIf"], ["aria-hidden", "true", 1, "ex-button-side-trigger", 3, "matMenuTriggerFor", "ngClass", "menuOpened", "menuClosed"], ["matMenuTrigger", "matMenuTrigger"], ["contentTemplate", ""], [3, "hasSearch", "items", "unlistedValuesParams", "dir", "actionClicked"], ["menu", ""], ["mat-ripple", "", 3, "ngClass", "disabled", "dir", "exTooltip"], ["singleButton", ""], [1, "tooltip-wrapper", "sel-single-tooltip-wrapper", 3, "exTooltip", "click"], [4, "ngTemplateOutlet"], ["mat-ripple", "", "aria-haspopup", "menu", 3, "class", "ngClass", "matMenuTriggerFor", "flex", "flex-direction", "disabled", "dir", "exTooltip", "menuOpened", 4, "ngIf"], ["mat-ripple", "", 3, "class", "ngClass", "flex", "flex-direction", "disabled", "dir", "exTooltip", "click", 4, "ngIf"], ["mat-ripple", "", "aria-haspopup", "menu", 3, "ngClass", "matMenuTriggerFor", "disabled", "dir", "exTooltip", "menuOpened"], ["multiButton", ""], [1, "tooltip-wrapper", "sel-multi-tooltip-wrapper", 3, "exTooltip", "click"], ["iconName", "arrow", "class", "ex-button-arrow-icon", 4, "ngIf"], ["iconName", "arrow", 1, "ex-button-arrow-icon"], ["mat-ripple", "", 3, "ngClass", "disabled", "dir", "exTooltip", "click"], ["iconName", "arrow", "class", "ex-button-arrow-icon", 3, "ngClass", 4, "ngIf"], ["iconName", "arrow", 1, "ex-button-arrow-icon", 3, "ngClass"], ["icon", ""], [3, "ngClass", 4, "ngIf"], ["class", "ex-button-loading-spinner", 3, "diameter", 4, "ngIf"], ["role", "alert", "class", "ex-button-hidden-status sel-ex-button-hidden-status", 4, "ngIf"], [3, "ngClass"], ["class", "uxf-icon", 3, "ngClass", "dir", 4, "ngIf"], [1, "uxf-icon", 3, "ngClass", "dir"], [1, "ex-button-loading-spinner", 3, "diameter"], ["role", "alert", 1, "ex-button-hidden-status", "sel-ex-button-hidden-status"]], template: function ExButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c7$g);
            i0.ɵɵtemplate(0, ExButtonComponent_button_0_Template, 9, 28, "button", 0);
            i0.ɵɵtemplate(1, ExButtonComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
            i0.ɵɵelementStart(2, "div", 2, 3);
            i0.ɵɵlistener("menuOpened", function ExButtonComponent_Template_div_menuOpened_2_listener() { ctx.onSideMenuOpened(); return ctx.setFocus(); })("menuClosed", function ExButtonComponent_Template_div_menuClosed_2_listener() { return ctx.onSideMenuClosed(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExButtonComponent_ng_template_4_Template, 6, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "menu-item", 5, 6);
            i0.ɵɵlistener("actionClicked", function ExButtonComponent_Template_menu_item_actionClicked_6_listener($event) { return ctx.actionClicked($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r5 = i0.ɵɵreference(7);
            i0.ɵɵproperty("ngIf", !ctx.children || (ctx.children == null ? null : ctx.children.length) === 0 && !ctx.unlistedValuesParams);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.children == null ? null : ctx.children.length) > 0 || ctx.unlistedValuesParams);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matMenuTriggerFor", _r5.childMenu)("ngClass", i0.ɵɵpureFunction1(8, _c8$e, ctx.triggerAtStart));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hasSearch", ctx.hasSearchBox)("items", ctx.children)("unlistedValuesParams", ctx.unlistedValuesParams)("dir", ctx._dir);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i6$1.MatRipple, i2$1.Dir, ExTooltipDirective, ExSpinnerComponent, MenuItemComponent, i3$1.MatMenuTrigger, ExSvgIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-button-wrapper[_ngcontent-%COMP%]{min-height:32px;padding:0 10px;background:transparent;border-radius:3px;border:0px;display:flex;flex-direction:row;align-items:center;justify-content:center;margin:1px}.ex-button-wrapper[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]{position:absolute;top:0}.ex-button-wrapper[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]:not(.ex-button-side-trigger-start){inset-inline-end:-1px}.ex-button-wrapper[_ngcontent-%COMP%]   .mat-mdc-menu-trigger.ex-button-side-trigger-start[_ngcontent-%COMP%]{inset-inline-start:-1px}.ex-button-wrapper[_ngcontent-%COMP%]   .ex-button-icon-left[_ngcontent-%COMP%]{margin-right:10px}.ex-button-wrapper[_ngcontent-%COMP%]   .ex-button-icon-right[_ngcontent-%COMP%]{margin-left:10px}.ex-button-wrapper[_ngcontent-%COMP%]   .ex-button-loading-spinner[_ngcontent-%COMP%]{position:absolute}.tooltip-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]{display:flex}.ex-button-wrapper[_ngcontent-%COMP%]     i{margin:0!important}.ex-button-link[_ngcontent-%COMP%]{background:none!important;border:none;cursor:pointer}.ex-button-list-action[_ngcontent-%COMP%]{background-color:#f2f2f2;color:#4164a4;cursor:pointer}.ex-button-link[_ngcontent-%COMP%]:hover{text-decoration:underline}.ex-button-fit-content[_nghost-%COMP%]{width:-moz-fit-content;width:fit-content}[dir=rtl].ex-button-wrapper[_ngcontent-%COMP%]   .ex-button-icon-left[_ngcontent-%COMP%]{margin-left:10px;margin-right:0}[dir=rtl].ex-button-wrapper[_ngcontent-%COMP%]   .ex-button-icon-right[_ngcontent-%COMP%]{margin-right:10px;margin-left:0}.ex-button-hidden-status[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-button-arrow-icon[_ngcontent-%COMP%]{margin-inline-start:5px}.ex-button-arrow-icon-right[_ngcontent-%COMP%]{transform:rotate(-90deg)}.ex-button-arrow-icon-left[_ngcontent-%COMP%]{transform:rotate(90deg)}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExButtonComponent, [{
        type: Component,
        args: [{ selector: 'ex-button', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                    "[class.ex-button-fit-content]": "!full"
                }, template: "<button #singleButton *ngIf=\"!children || (children?.length === 0 && !unlistedValuesParams)\" mat-ripple class=\"ex-button-wrapper sel-ex-button\n{{uniqueSelector ? (('ex-button-' + uniqueSelector) | generateHTMLId) : ''}} {{uniqueSelectorState ? (('ex-button-state-' + uniqueSelectorState) | generateHTMLId) : ''}}\"\n  [ngClass]=\"'ex-button-' + type\" [style.flex]=\"full ? 1 : 'initial'\" [attr.aria-haspopup]=\"ariaHasPopup\" [attr.aria-current]=\"ariaCurrent\"\n  [style.flex-direction]=\"iconSide === 'right' ? 'row-reverse' : 'row'\" [disabled]=\"disabled || loading\"\n  [attr.aria-label]=\"ariaLabel | translate\" [dir]=\"_dir\" [attr.aria-pressed]=\"ariaPressed\" [exTooltip]=\"tooltip | translate\">\n  <div class=\"tooltip-wrapper sel-single-tooltip-wrapper\" (click)=\"onClick($event)\" [exTooltip]=\"(disabled ? disabledTooltip : null) | translate\">\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n  </div>\n</button>\n\n<ng-container *ngIf=\"children?.length > 0 || unlistedValuesParams\">\n  <button *ngIf=\"!openToSide\" #multiButton mat-ripple class=\"ex-button-wrapper sel-button-multi-button sel-ex-button {{uniqueSelector ? (('ex-button-multi-' + uniqueSelector) | generateHTMLId) : ''}} {{uniqueSelectorState ? (('ex-button-state-' + uniqueSelectorState) | generateHTMLId) : ''}}\"\n    [ngClass]=\"'ex-button-' + type\" [matMenuTriggerFor]=\"menu.childMenu\" [style.flex]=\"full ? 1 : 'initial'\"\n    [style.flex-direction]=\"iconSide === 'right' ? 'row-reverse' : 'row'\" [disabled]=\"disabled || loading\"\n    [attr.aria-label]=\"ariaLabel | translate\" [attr.aria-pressed]=\"ariaPressed\" [dir]=\"_dir\" (menuOpened)=\"setFocus()\" [exTooltip]=\"tooltip | translate\"\n    aria-haspopup=\"menu\">\n    <div class=\"tooltip-wrapper sel-multi-tooltip-wrapper\" (click)=\"onClick($event)\" [exTooltip]=\"(disabled ? disabledTooltip : null) | translate\">\n      <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n      <ex-svg-icon *ngIf=\"this.displayArrow\" iconName=\"arrow\" class=\"ex-button-arrow-icon\"></ex-svg-icon>\n    </div>\n  </button>\n  <button *ngIf=\"openToSide\" #multiButton mat-ripple class=\"ex-button-wrapper sel-button-multi-button sel-ex-button {{uniqueSelector ? (('ex-button-multi-' + uniqueSelector) | generateHTMLId) : ''}} {{uniqueSelectorState ? (('ex-button-state-' + uniqueSelectorState) | generateHTMLId) : ''}}\"\n    [ngClass]=\"'ex-button-' + type\" [style.flex]=\"full ? 1 : 'initial'\"\n    [style.flex-direction]=\"iconSide === 'right' ? 'row-reverse' : 'row'\" [disabled]=\"disabled || loading\"\n    [attr.aria-label]=\"ariaLabel | translate\" [attr.aria-pressed]=\"ariaPressed\" [dir]=\"_dir\"\n    (click)=\"matMenuTrigger.openMenu()\" [exTooltip]=\"tooltip | translate\">\n    <div class=\"tooltip-wrapper sel-multi-tooltip-wrapper\" (click)=\"onClick($event)\" [exTooltip]=\"(disabled ? disabledTooltip : null) | translate\">\n      <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n      <ex-svg-icon *ngIf=\"this.displayArrow\" iconName=\"arrow\" class=\"ex-button-arrow-icon\" [ngClass]=\"{ 'ex-button-arrow-icon-right': _dir === 'ltr',\n      'ex-button-arrow-icon-left': _dir !== 'ltr' }\"></ex-svg-icon>\n    </div>\n  </button>\n</ng-container>\n<!-- The next element is in the outer scoop to make sure @viewchild catches it\n  (to close the menu after the action is performed) -->\n<div aria-hidden=\"true\" #matMenuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"menu.childMenu\" class=\"ex-button-side-trigger\"\n  [ngClass]=\"{ 'ex-button-side-trigger-start': triggerAtStart}\" (menuOpened)=\"onSideMenuOpened();setFocus()\"\n  (menuClosed)=\"onSideMenuClosed()\">\n</div>\n\n<ng-template #contentTemplate>\n  <ng-template #icon>\n    <ng-content select=\"[icon]\"></ng-content>\n  </ng-template>\n\n  <div *ngIf=\"iconSide\"\n    [ngClass]=\"{'ex-button-icon-left': iconSide === 'left', 'ex-button-icon-right': iconSide === 'right'}\">\n    <i *ngIf=\"type !== 'action' && type !== 'conf-action'\"\n      [ngClass]=\"{'uxf-plus-circle': type==='add', 'uxf-minus-circle' : type === 'remove'}\" class=\"uxf-icon\"\n      [dir]=\"_dir\"></i>\n    <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n  </div>\n  <ng-content></ng-content>\n\n  <ex-spinner *ngIf=\"loading\" class=\"ex-button-loading-spinner\" [diameter]=\"15\"></ex-spinner>\n  <div *ngIf=\"loading\" role=\"alert\" class=\"ex-button-hidden-status sel-ex-button-hidden-status\">\n    {{'ng.ex-button.process_action' | translate}}</div>\n</ng-template>\n\n<menu-item #menu [hasSearch]=\"hasSearchBox\" [items]=\"children\" [unlistedValuesParams]=\"unlistedValuesParams\" [dir]=\"_dir\" (actionClicked)=\"actionClicked($event);\">\n</menu-item>\n", styles: [".ex-button-wrapper{min-height:32px;padding:0 10px;background:transparent;border-radius:3px;border:0px;display:flex;flex-direction:row;align-items:center;justify-content:center;margin:1px}.ex-button-wrapper .mat-mdc-menu-trigger{position:absolute;top:0}.ex-button-wrapper .mat-mdc-menu-trigger:not(.ex-button-side-trigger-start){inset-inline-end:-1px}.ex-button-wrapper .mat-mdc-menu-trigger.ex-button-side-trigger-start{inset-inline-start:-1px}.ex-button-wrapper .ex-button-icon-left{margin-right:10px}.ex-button-wrapper .ex-button-icon-right{margin-left:10px}.ex-button-wrapper .ex-button-loading-spinner{position:absolute}.tooltip-wrapper{display:flex;justify-content:center;align-items:center}:host{display:flex}.ex-button-wrapper ::ng-deep i{margin:0!important}.ex-button-link{background:none!important;border:none;cursor:pointer}.ex-button-list-action{background-color:#f2f2f2;color:#4164a4;cursor:pointer}.ex-button-link:hover{text-decoration:underline}:host.ex-button-fit-content{width:-moz-fit-content;width:fit-content}[dir=rtl].ex-button-wrapper .ex-button-icon-left{margin-left:10px;margin-right:0}[dir=rtl].ex-button-wrapper .ex-button-icon-right{margin-right:10px;margin-left:0}.ex-button-hidden-status{width:0;height:0;overflow:hidden;border:transparent}.ex-button-arrow-icon{margin-inline-start:5px}.ex-button-arrow-icon-right{transform:rotate(-90deg)}.ex-button-arrow-icon-left{transform:rotate(90deg)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { singleButton: [{
            type: ViewChild,
            args: ['singleButton']
        }], multiButton: [{
            type: ViewChild,
            args: ['multiButton']
        }], type: [{
            type: Input
        }], type2: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], disabledTooltip: [{
            type: Input
        }], full: [{
            type: Input
        }], loading: [{
            type: Input
        }], iconSide: [{
            type: Input
        }], children: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaPressed: [{
            type: Input
        }], ariaHasPopup: [{
            type: Input
        }], ariaCurrent: [{
            type: Input
        }], openToSide: [{
            type: Input
        }], hasSearchBox: [{
            type: Input
        }], unlistedValuesParams: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], uniqueSelectorState: [{
            type: Input
        }], displayArrow: [{
            type: Input
        }], childClicked: [{
            type: Output
        }], trigger: [{
            type: ViewChild,
            args: ['matMenuTrigger']
        }], triggerElem: [{
            type: ViewChild,
            args: ['matMenuTrigger', { read: ElementRef }]
        }], menu: [{
            type: ViewChild,
            args: ['menu']
        }] }); })();

function ExBannerComponent_div_0_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconType", ctx_r1.banner.icon.iconType)("iconName", ctx_r1.banner.icon.iconName)("color", ctx_r1.banner.icon.iconColor)("sizePx", ctx_r1.banner.icon.iconSizePx);
} }
function ExBannerComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r2.banner.title));
} }
function ExBannerComponent_div_0_ex_button_9_ex_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 13);
} if (rf & 2) {
    const action_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconType", action_r4.icon.iconType)("iconName", action_r4.icon.iconName)("color", action_r4.icon.iconColor)("sizePx", action_r4.icon.iconSizePx);
} }
function ExBannerComponent_div_0_ex_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 11);
    i0.ɵɵlistener("click", function ExBannerComponent_div_0_ex_button_9_Template_ex_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const action_r4 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7._actionClicked(action_r4.value)); });
    i0.ɵɵtemplate(1, ExBannerComponent_div_0_ex_button_9_ex_icon_1_Template, 1, 4, "ex-icon", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r4 = ctx.$implicit;
    i0.ɵɵproperty("type", action_r4.type)("full", true)("disabled", action_r4.disabled)("tooltip", action_r4.tooltip)("disabledTooltip", action_r4.tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", action_r4 == null ? null : action_r4.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, action_r4.label), " ");
} }
const _c0$1A = function (a0) { return { "background": a0 }; };
function ExBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, ExBannerComponent_div_0_ex_icon_2_Template, 1, 4, "ex-icon", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, ExBannerComponent_div_0_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 7);
    i0.ɵɵtemplate(9, ExBannerComponent_div_0_ex_button_9_Template, 4, 9, "ex-button", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0$1A, ctx_r0.banner.backgroundColor ? ctx_r0.banner.backgroundColor : "#F0F5F8"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.banner.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.banner.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, ctx_r0.banner.message));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.banner == null ? null : ctx_r0.banner.actions);
} }
class ExBannerComponent {
    constructor(translate) {
        this.translate = translate;
        /**
         * fires an event when the action button is clicked (if exist)
         */
        this.actionClicked = new EventEmitter();
    }
    ngOnInit() {
        // lets you break your sentence wherever you want
        if (this.banner) {
            this.banner.message = this.translate.instant(this.banner.message);
            this.banner.message = this.banner.message.replace('</br>', '\n');
        }
    }
    _actionClicked(value) {
        this.actionClicked.emit(value);
    }
    static { this.ɵfac = function ExBannerComponent_Factory(t) { return new (t || ExBannerComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExBannerComponent, selectors: [["ex-banner"]], inputs: { banner: "banner" }, outputs: { actionClicked: "actionClicked" }, decls: 1, vars: 1, consts: [["class", "ex-banner-wrapper", 3, "ngStyle", 4, "ngIf"], [1, "ex-banner-wrapper", 3, "ngStyle"], [1, "ex-banner-header"], ["class", "ex-banner-icon sel-ex-banner-icon", 3, "iconType", "iconName", "color", "sizePx", 4, "ngIf"], [1, "ex-banner-title-description-wrapper"], ["class", "ex-banner-title", 4, "ngIf"], [1, "ex-banner-text"], [1, "ex-banner-actions"], ["class", "ex-banner-btn sel-ex-banner-btn", 3, "type", "full", "disabled", "tooltip", "disabledTooltip", "click", 4, "ngFor", "ngForOf"], [1, "ex-banner-icon", "sel-ex-banner-icon", 3, "iconType", "iconName", "color", "sizePx"], [1, "ex-banner-title"], [1, "ex-banner-btn", "sel-ex-banner-btn", 3, "type", "full", "disabled", "tooltip", "disabledTooltip", "click"], ["class", "ex-banner-action-icon", 3, "iconType", "iconName", "color", "sizePx", 4, "ngIf"], [1, "ex-banner-action-icon", 3, "iconType", "iconName", "color", "sizePx"]], template: function ExBannerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExBannerComponent_div_0_Template, 10, 9, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.banner);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, i1$5.NgStyle, ExIconComponent, ExButtonComponent, i1$2.TranslatePipe], styles: [".ex-banner-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;padding:20px 10px;align-items:center;margin:15px 0;border-radius:5px}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-header[_ngcontent-%COMP%]{display:flex;min-width:350px;flex-shrink:1;flex-grow:3;align-items:center}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-header[_ngcontent-%COMP%]   .ex-banner-icon[_ngcontent-%COMP%]{padding:0 30px}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-header[_ngcontent-%COMP%]   .ex-banner-title-description-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-header[_ngcontent-%COMP%]   .ex-banner-title[_ngcontent-%COMP%]{font-size:1.2em;font-weight:700;margin-right:10px}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-header[_ngcontent-%COMP%]   .ex-banner-text[_ngcontent-%COMP%]{align-self:center;flex:1;white-space:pre-line}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-actions[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:row;flex-wrap:wrap;flex-grow:1;flex-shrink:1}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-actions[_ngcontent-%COMP%]   .ex-banner-btn[_ngcontent-%COMP%]{padding:0 30px;width:250px}.ex-banner-wrapper[_ngcontent-%COMP%]   .ex-banner-actions[_ngcontent-%COMP%]   .ex-banner-btn[_ngcontent-%COMP%]   .ex-banner-action-icon[_ngcontent-%COMP%]{padding:0 10px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBannerComponent, [{
        type: Component,
        args: [{ selector: 'ex-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"banner\" class=\"ex-banner-wrapper\"\r\n    [ngStyle]=\"{ 'background': banner.backgroundColor ? banner.backgroundColor : '#F0F5F8' }\">\r\n    <div class=\"ex-banner-header\">\r\n        <ex-icon *ngIf=\"banner.icon\" class=\"ex-banner-icon sel-ex-banner-icon\" [iconType]=\"banner.icon.iconType\"\r\n            [iconName]=\"banner.icon.iconName\" [color]=\"banner.icon.iconColor\" [sizePx]=\"banner.icon.iconSizePx\">\r\n        </ex-icon>\r\n        <div class=\"ex-banner-title-description-wrapper\">\r\n            <span class=\"ex-banner-title\" *ngIf=\"banner.title\">{{ banner.title | translate }}</span>\r\n            <span class=\"ex-banner-text\">{{ banner.message | translate }}</span>\r\n        </div>\r\n    </div>\r\n    <div class=\"ex-banner-actions\">\r\n        <ex-button *ngFor=\"let action of banner?.actions\" class=\"ex-banner-btn sel-ex-banner-btn\" [type]=\"action.type\"\r\n            [full]=\"true\" [disabled]=\"action.disabled\" (click)=\"_actionClicked(action.value)\" [tooltip] = \"action.tooltip\"\r\n            [disabledTooltip]=\"action.tooltip\">\r\n            <ex-icon *ngIf=\"action?.icon\" class=\"ex-banner-action-icon\" [iconType]=\"action.icon.iconType\"\r\n                [iconName]=\"action.icon.iconName\" [color]=\"action.icon.iconColor\" [sizePx]=\"action.icon.iconSizePx\">\r\n            </ex-icon>\r\n            {{ action.label | translate }}\r\n        </ex-button>\r\n    </div>\r\n</div>\r\n", styles: [".ex-banner-wrapper{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;padding:20px 10px;align-items:center;margin:15px 0;border-radius:5px}.ex-banner-wrapper .ex-banner-header{display:flex;min-width:350px;flex-shrink:1;flex-grow:3;align-items:center}.ex-banner-wrapper .ex-banner-header .ex-banner-icon{padding:0 30px}.ex-banner-wrapper .ex-banner-header .ex-banner-title-description-wrapper{display:flex;flex-direction:column}.ex-banner-wrapper .ex-banner-header .ex-banner-title{font-size:1.2em;font-weight:700;margin-right:10px}.ex-banner-wrapper .ex-banner-header .ex-banner-text{align-self:center;flex:1;white-space:pre-line}.ex-banner-wrapper .ex-banner-actions{display:flex;justify-content:center;flex-direction:row;flex-wrap:wrap;flex-grow:1;flex-shrink:1}.ex-banner-wrapper .ex-banner-actions .ex-banner-btn{padding:0 30px;width:250px}.ex-banner-wrapper .ex-banner-actions .ex-banner-btn .ex-banner-action-icon{padding:0 10px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { banner: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }] }); })();

class ExInjectionDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static { this.ɵfac = function ExInjectionDirective_Factory(t) { return new (t || ExInjectionDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExInjectionDirective, selectors: [["", "injection", ""]] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInjectionDirective, [{
        type: Directive,
        args: [{
                selector: '[injection]'
            }]
    }], function () { return [{ type: i0.ViewContainerRef }]; }, null); })();

function ExComponentLoaderComponent_ng_template_0_Template(rf, ctx) { }
/** @dynamic */
class ExComponentLoaderComponent {
    /**
     * @ignore
     */
    constructor(componentFactoryResolver, injector, document) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.document = document;
        this.sub = new Subscription;
        this.events = {};
        this._data = {};
        this.reCreate = false;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('componentFactoryItem') && !changes.componentFactoryItem.isFirstChange() &&
            changes.componentFactoryItem.currentValue?.component != changes.componentFactoryItem.previousValue?.component) {
            this.ngOnInit();
        }
        if (this.reCreate) {
            this.reCreate = false;
            this.ngOnInit();
        }
    }
    /**
     * Used to pass the component item for the loader to display
     */
    set componentFactoryItem(componentFactoryItem) {
        this._componentFactoryItem = componentFactoryItem;
        if (componentFactoryItem && componentFactoryItem != this._componentFactoryItem) {
            this.createComponent();
        }
        if (!this.reCreate)
            this.loadComponent();
    }
    get componentFactoryItem() {
        return this._componentFactoryItem;
    }
    set data(data) {
        this._data = data;
        if (!this.reCreate)
            this.loadComponent();
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this.createComponent();
        this.loadComponent();
        if (this.events) {
            Object.keys(this.events).forEach(key => {
                if (this.componentRef.instance[key]) {
                    this.sub.add(this.componentRef.instance[key].subscribe(e => this.events[key](e)));
                }
            });
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    createComponent() {
        let component = this._componentFactoryItem?.component;
        if (!component)
            component = this._componentFactoryItem;
        if (!component)
            return;
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const viewContainerRef = this.injectionHost.viewContainerRef;
        viewContainerRef.clear();
        let ngContent = [];
        if (this.content) {
            ngContent = this.resolveNgContent(this.content);
        }
        const componentRef = viewContainerRef.createComponent(componentFactory, 0, undefined, ngContent);
        this.componentRef = componentRef;
    }
    focus() {
        this.componentRef?.instance?.focus();
    }
    /**
     * This function injects the given component into the DOM, on the element where the injection directive is on.
     * It creates the component dynamically and injects data into the new component.
     */
    loadComponent() {
        if (!this.componentRef || !this._componentFactoryItem) {
            return;
        }
        if (this._data) {
            [...Object.keys(this._data), ...(this._componentFactoryItem?.data ? Object.keys(this._componentFactoryItem.data) : [])].
                forEach(key => {
                if (this.componentRef.componentType['ɵcmp']?.inputs[key]) {
                    this.componentRef.setInput(key, Object.keys(this._data).includes(key) ? this._data[key] : this._componentFactoryItem.data[key]);
                }
            });
            this.componentRef.injector.get(ChangeDetectorRef)?.markForCheck();
        }
    }
    resolveNgContent(content) {
        if (typeof content === 'string') {
            const element = this.document.createTextNode(content);
            return [[element]];
        }
        if (content instanceof TemplateRef) {
            const viewRef = content.createEmbeddedView(null);
            return [viewRef.rootNodes];
        }
        const factory = this.componentFactoryResolver.resolveComponentFactory(content);
        const componentRef = factory.create(this.injector);
        return [[componentRef.location.nativeElement]];
    }
    /** Called to force re-creation of the component on the run of ngOnChanges() */
    reCreateComponentOnNextChange() {
        this.reCreate = true;
    }
    static { this.ɵfac = function ExComponentLoaderComponent_Factory(t) { return new (t || ExComponentLoaderComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComponentLoaderComponent, selectors: [["ex-component-loader"]], viewQuery: function ExComponentLoaderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(ExInjectionDirective, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.injectionHost = _t.first);
        } }, inputs: { componentFactoryItem: "componentFactoryItem", data: "data", content: "content", events: "events" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["injection", ""]], template: function ExComponentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExComponentLoaderComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
        } }, dependencies: [ExInjectionDirective], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComponentLoaderComponent, [{
        type: Component,
        args: [{ selector: 'ex-component-loader', template: "<ng-template injection></ng-template>" }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { componentFactoryItem: [{
            type: Input
        }], data: [{
            type: Input
        }], content: [{
            type: Input
        }], events: [{
            type: Input
        }], injectionHost: [{
            type: ViewChild,
            args: [ExInjectionDirective, { static: true }]
        }] }); })();

function ExComponentFormLoaderComponent_ng_template_0_Template(rf, ctx) { }
/** @dynamic */
class ExComponentFormLoaderComponent extends ExControlValueAccessor {
    writeValue(obj) {
    }
    /**
     * @ignore
     */
    constructor(componentFactoryResolver, injector, document) {
        super();
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.document = document;
        this._selectedValuesChange = new EventEmitter();
        this._selectedValueChange = new EventEmitter();
        this.events = {};
        this._data = {};
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('componentFactoryItem') && !changes.componentFactoryItem.isFirstChange() &&
            changes.componentFactoryItem.currentValue?.component != changes.componentFactoryItem.previousValue?.component) {
            this.ngOnInit();
        }
    }
    /**
     * Used to pass the component item for the loader to display
     */
    set componentFactoryItem(componentFactoryItem) {
        this._componentFactoryItem = componentFactoryItem;
        if (componentFactoryItem && componentFactoryItem != this._componentFactoryItem) {
            this.createComponent();
        }
        this.loadComponent();
    }
    get componentFactoryItem() {
        return this._componentFactoryItem;
    }
    set data(data) {
        this._data = data;
        this.loadComponent();
    }
    /**
     * @ignore
     */
    ngOnInit() {
        this.createComponent();
        this.loadComponent();
        Object.keys(this.events).forEach(key => {
            if (this.componentRef.instance[key]) {
                this.componentRef.instance[key].subscribe((e) => {
                    this.events[key](e);
                    this.controlOnChange(e);
                });
            }
        });
        this.componentRef.instance['_selectedValueChange']?.subscribe(e => this._selectedValueChange.emit(e));
        this.componentRef.instance['_selectedValuesChange']?.subscribe(e => this._selectedValueChange.emit(e));
        this.componentRef.instance['selectedValueChange']?.subscribe(e => this._selectedValueChange.emit(e));
        this.componentRef.instance['selectedValuesChange']?.subscribe(e => this._selectedValueChange.emit(e));
        this.componentRef.instance['blur']?.subscribe(e => this.blur.emit(e));
    }
    createComponent() {
        let component = this._componentFactoryItem?.component;
        if (!component)
            component = this._componentFactoryItem;
        if (!component)
            return;
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const viewContainerRef = this.injectionHost.viewContainerRef;
        viewContainerRef.clear();
        let ngContent = [];
        if (this.content) {
            ngContent = this.resolveNgContent(this.content);
        }
        const componentRef = viewContainerRef.createComponent(componentFactory, 0, undefined, ngContent);
        this.componentRef = componentRef;
    }
    focus() {
        this.componentRef?.instance?.focus();
    }
    /**
     * This function injects the given component into the DOM, on the element where the injection directive is on.
     * It creates the component dynamically and injects data into the new component.
     */
    loadComponent() {
        if (!this.componentRef || !this._componentFactoryItem) {
            return;
        }
        if (this._data) {
            [...Object.keys(this._data), ...(this._componentFactoryItem?.data ? Object.keys(this._componentFactoryItem.data) : [])].
                forEach(key => this.componentRef.instance[key] = this._data[key] ? this._data[key] : this._componentFactoryItem.data[key]);
        }
    }
    resolveNgContent(content) {
        if (typeof content === 'string') {
            const element = this.document.createTextNode(content);
            return [[element]];
        }
        if (content instanceof TemplateRef) {
            const viewRef = content.createEmbeddedView(null);
            return [viewRef.rootNodes];
        }
        const factory = this.componentFactoryResolver.resolveComponentFactory(content);
        const componentRef = factory.create(this.injector);
        return [[componentRef.location.nativeElement]];
    }
    static { this.ɵfac = function ExComponentFormLoaderComponent_Factory(t) { return new (t || ExComponentFormLoaderComponent)(i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComponentFormLoaderComponent, selectors: [["ex-component-form-loader"]], viewQuery: function ExComponentFormLoaderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(ExInjectionDirective, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.injectionHost = _t.first);
        } }, hostBindings: function ExComponentFormLoaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("_selectedValueChange", function ExComponentFormLoaderComponent__selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("_selectedValuesChange", function ExComponentFormLoaderComponent__selectedValuesChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("valueChange", function ExComponentFormLoaderComponent_valueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("selectedValuesChange", function ExComponentFormLoaderComponent_selectedValuesChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("selectedValueChange", function ExComponentFormLoaderComponent_selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExComponentFormLoaderComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { componentFactoryItem: "componentFactoryItem", data: "data", content: "content", events: "events" }, outputs: { _selectedValuesChange: "_selectedValuesChange", _selectedValueChange: "_selectedValueChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExComponentFormLoaderComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["injection", ""]], template: function ExComponentFormLoaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExComponentFormLoaderComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
        } }, dependencies: [ExInjectionDirective], encapsulation: 2, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComponentFormLoaderComponent, [{
        type: Component,
        args: [{ selector: 'ex-component-form-loader', host: {
                    '(_selectedValueChange)': 'controlOnChange($event)',
                    '(_selectedValuesChange)': 'controlOnChange($event)',
                    '(valueChange)': 'controlOnChange($event)',
                    '(selectedValuesChange)': 'controlOnChange($event)',
                    '(selectedValueChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExComponentFormLoaderComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template injection></ng-template> " }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _selectedValuesChange: [{
            type: Output
        }], _selectedValueChange: [{
            type: Output
        }], componentFactoryItem: [{
            type: Input
        }], data: [{
            type: Input
        }], content: [{
            type: Input
        }], events: [{
            type: Input
        }], injectionHost: [{
            type: ViewChild,
            args: [ExInjectionDirective, { static: true }]
        }] }); })();

class ExComponentLoaderModule {
    static { this.ɵfac = function ExComponentLoaderModule_Factory(t) { return new (t || ExComponentLoaderModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExComponentLoaderModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComponentLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExComponentLoaderComponent,
                    ExInjectionDirective,
                    ExComponentFormLoaderComponent
                ],
                exports: [
                    ExComponentLoaderComponent,
                    ExComponentFormLoaderComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExComponentLoaderModule, { declarations: [ExComponentLoaderComponent,
        ExInjectionDirective,
        ExComponentFormLoaderComponent], imports: [CommonModule], exports: [ExComponentLoaderComponent,
        ExComponentFormLoaderComponent] }); })();

function ExLabelComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$1z = function (a0) { return { "ex-label-disabled": a0 }; };
function ExLabelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ExLabelComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$1z, ctx_r0.isStrikeThrough));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function ExLabelComponent_ng_template_1_span_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComponent_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_1_span_0_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExLabelComponent_ng_template_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function ExLabelComponent_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r14.labelStyle);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 3, ctx_r14.label), "", ctx_r14.hasColon ? ":" : "", "");
} }
function ExLabelComponent_ng_template_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function ExLabelComponent_ng_template_1_span_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComponent_ng_template_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_1_span_5_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("matTooltip", ctx_r16.tooltip || (ctx_r16.displayTooltip ? "" + ctx_r16.value : ""))("id", ctx_r16.htmlId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function ExLabelComponent_ng_template_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function ExLabelComponent_ng_template_1_span_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComponent_ng_template_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_1_span_7_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExLabelComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComponent_ng_template_1_span_0_Template, 2, 1, "span", 8);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_1_span_1_Template, 2, 0, "span", 9);
    i0.ɵɵelementStart(2, "span", 10);
    i0.ɵɵtemplate(3, ExLabelComponent_ng_template_1_span_3_Template, 3, 5, "span", 11);
    i0.ɵɵtemplate(4, ExLabelComponent_ng_template_1_span_4_Template, 2, 0, "span", 9);
    i0.ɵɵtemplate(5, ExLabelComponent_ng_template_1_span_5_Template, 2, 3, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExLabelComponent_ng_template_1_span_6_Template, 2, 0, "span", 9);
    i0.ɵɵtemplate(7, ExLabelComponent_ng_template_1_span_7_Template, 2, 1, "span", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngIf", ((ctx_r2.svgIcon == null ? null : ctx_r2.svgIcon.iconName) || ctx_r2.iconName) && ctx_r2.iconSide === "left");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.iconName && ctx_r2.iconSide === "left");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", ctx_r2.style);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.htmlId != undefined)("ngIfElse", _r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.iconName && ctx_r2.iconSide === "right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.iconSide === "right");
} }
function ExLabelComponent_ng_template_3_ex_icon_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 20);
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r22.iconStyle)("ngStyle", ctx_r22.iconStyle)("iconType", ctx_r22.iconType)("iconName", ctx_r22.iconName)("color", ctx_r22.iconColor)("ariaHidden", true)("sizePx", ctx_r22.iconSize);
} }
function ExLabelComponent_ng_template_3_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 21);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r23.svgIcon.iconStyle)("ngStyle", ctx_r23.svgIcon.iconStyle)("iconName", ctx_r23.svgIcon.iconName)("color", ctx_r23.svgIcon.iconColor)("ariaHidden", true)("size", ctx_r23.svgIcon.iconSize)("tooltip", ctx_r23.svgIcon.tooltip);
} }
function ExLabelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComponent_ng_template_3_ex_icon_0_Template, 1, 7, "ex-icon", 18);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_3_ex_svg_icon_1_Template, 1, 7, "ex-svg-icon", 19);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r4.svgIcon && ctx_r4.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.svgIcon && ctx_r4.svgIcon.iconName);
} }
function ExLabelComponent_ng_template_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_5_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("matTooltip", ctx_r6.tooltip || (ctx_r6.displayTooltip ? "" + ctx_r6.value : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function ExLabelComponent_ng_template_7_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1$$ = function (a0, a1) { return { "ex-label-value-bold": a0, "ex-label-value-title": a1 }; };
function ExLabelComponent_ng_template_7_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
} if (rf & 2) {
    const text_r26 = i0.ɵɵnextContext().$implicit;
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerText", text_r26)("ngClass", i0.ɵɵpureFunction2(3, _c1$$, ctx_r29.isBold || ctx_r29.isTitle, ctx_r29.isTitle))("ngStyle", ctx_r29.valueStyle);
} }
function ExLabelComponent_ng_template_7_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
} if (rf & 2) {
    const text_r26 = i0.ɵɵnextContext().$implicit;
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", text_r26, i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction2(3, _c1$$, ctx_r31.isBold || ctx_r31.isTitle, ctx_r31.isTitle))("ngStyle", ctx_r31.valueStyle);
} }
function ExLabelComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComponent_ng_template_7_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 24);
    i0.ɵɵtemplate(2, ExLabelComponent_ng_template_7_ng_container_0_ng_template_2_Template, 1, 6, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, ExLabelComponent_ng_template_7_ng_container_0_ng_template_4_Template, 1, 6, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const text_r26 = ctx.$implicit;
    const _r28 = i0.ɵɵreference(3);
    const _r30 = i0.ɵɵreference(5);
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", text_r26.startsWith("<" + ctx_r25._highlightedTextStyle + ">"))("ngIfThen", _r30)("ngIfElse", _r28);
} }
function ExLabelComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComponent_ng_template_7_ng_container_0_Template, 6, 3, "ng-container", 23);
    i0.ɵɵpipe(1, "exTextHighlight");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(1, 1, i0.ɵɵpipeBind1(2, 6, "" + ctx_r8.value), ctx_r8.highlightedText, ctx_r8._highlightedTextStyle, true));
} }
function ExLabelComponent_ng_template_9_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, ExLabelComponent_ng_template_9_div_0_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(1, 5, ctx_r34.label));
    i0.ɵɵproperty("exQuickAccessType", ctx_r34.quickAcssessTypes.FIELD)("exQuickAccessSection", ctx_r34.sectionId)("ngClass", i0.ɵɵpureFunction1(7, _c0$1z, ctx_r34.isStrikeThrough));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function ExLabelComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComponent_ng_template_9_div_0_Template, 3, 9, "div", 29);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.value && ctx_r10.sectionId && ctx_r10.isQuickAccessScope);
} }
class ExLabelComponent {
    constructor(sectionId, isQuickAccessScope) {
        this.sectionId = sectionId;
        this.isQuickAccessScope = isQuickAccessScope;
        this.iconSize = '16px';
        this.iconSide = 'left';
        this.hasColon = false;
        this._highlightedTextStyle = 'mark';
        this.quickAcssessTypes = QuickAccessType;
    }
    ngOnInit() {
        if (this.arguments) {
            this.value = this.arguments.value;
            this.label = this.arguments.label;
            this.iconName = this.arguments.iconName;
            this.iconColor = this.arguments.iconColor;
            this.iconType = this.arguments.iconType;
            this.iconSize = this.arguments.iconSize;
            this.style = this.arguments.style;
            this.labelStyle = this.arguments.labelStyle;
            this.valueStyle = this.arguments.valueStyle;
            this.tooltip = this.arguments.tooltip;
            if (this.arguments.hasOwnProperty('displayTooltip')) {
                this.displayTooltip = this.arguments.displayTooltip;
            }
        }
    }
    static { this.ɵfac = function ExLabelComponent_Factory(t) { return new (t || ExLabelComponent)(i0.ɵɵdirectiveInject(EX_SECTION_IDENTIFIER, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS_SCOPE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLabelComponent, selectors: [["ex-label"]], inputs: { label: "label", tooltip: "tooltip", value: "value", isBold: "isBold", svgIcon: "svgIcon", iconType: "iconType", iconName: "iconName", iconColor: "iconColor", iconSize: "iconSize", iconSide: "iconSide", highlightedText: "highlightedText", isStrikeThrough: "isStrikeThrough", style: "style", labelStyle: "labelStyle", valueStyle: "valueStyle", iconStyle: "iconStyle", hasColon: "hasColon", htmlId: "htmlId", displayTooltip: "displayTooltip", isTitle: "isTitle", arguments: "arguments" }, decls: 11, vars: 2, consts: [["dir", "auto", "class", "ex-label-wrapper", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["content", ""], ["icon", ""], ["spanWithoutId", ""], ["innerSpan", ""], ["withinSection", ""], ["dir", "auto", 1, "ex-label-wrapper", 3, "ngClass"], [4, "ngTemplateOutlet"], ["class", "ex-label-icon-left", 4, "ngIf"], [4, "ngIf"], [1, "ex-label-value", 3, "ngStyle"], ["class", "sel-label ex-label-value-bold", 3, "ngStyle", 4, "ngIf"], ["class", "sel-value ex-label-value-span", 3, "matTooltip", "id", 4, "ngIf", "ngIfElse"], ["class", "ex-label-icon-right", 4, "ngIf"], [1, "ex-label-icon-left"], [1, "sel-label", "ex-label-value-bold", 3, "ngStyle"], [1, "sel-value", "ex-label-value-span", 3, "matTooltip", "id"], [1, "ex-label-icon-right"], [3, "ngClass", "ngStyle", "iconType", "iconName", "color", "ariaHidden", "sizePx", 4, "ngIf"], [3, "ngClass", "ngStyle", "iconName", "color", "ariaHidden", "size", "tooltip", 4, "ngIf"], [3, "ngClass", "ngStyle", "iconType", "iconName", "color", "ariaHidden", "sizePx"], [3, "ngClass", "ngStyle", "iconName", "color", "ariaHidden", "size", "tooltip"], [1, "sel-value", "ex-label-value-span", 3, "matTooltip"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["innerTextTmpl", ""], ["innerHTMLTmpl", ""], [3, "innerText", "ngClass", "ngStyle"], [3, "innerHTML", "ngClass", "ngStyle"], ["class", "ex-label-wrapper", 3, "exQuickAccess", "exQuickAccessType", "exQuickAccessSection", "ngClass", 4, "ngIf"], [1, "ex-label-wrapper", 3, "exQuickAccess", "exQuickAccessType", "exQuickAccessSection", "ngClass"]], template: function ExLabelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExLabelComponent_div_0_Template, 2, 4, "div", 0);
            i0.ɵɵtemplate(1, ExLabelComponent_ng_template_1_Template, 8, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExLabelComponent_ng_template_3_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ExLabelComponent_ng_template_5_Template, 2, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, ExLabelComponent_ng_template_7_Template, 3, 8, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, ExLabelComponent_ng_template_9_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r9 = i0.ɵɵreference(10);
            i0.ɵɵproperty("ngIf", ctx.value && (!ctx.sectionId || !ctx.isQuickAccessScope))("ngIfElse", _r9);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, ExIconComponent, ExSvgIconComponent, i4.MatTooltip, i2$1.Dir, ExQuickAccessDirective, i1$2.TranslatePipe, ExTextHighlightPipe], styles: [".ex-label-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.ex-label-wrapper[_ngcontent-%COMP%]   .ex-label-icon-right[_ngcontent-%COMP%]{margin-inline-start:5px}.ex-label-wrapper[_ngcontent-%COMP%]   .ex-label-icon-left[_ngcontent-%COMP%]{margin-inline-end:5px;align-self:flex-start;padding-top:1px}.ex-label-wrapper[_ngcontent-%COMP%]   .ex-label-value[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.ex-label-disabled[_ngcontent-%COMP%]{text-decoration-line:line-through;cursor:not-allowed}.ex-label-disabled[_ngcontent-%COMP%]     a{-webkit-text-decoration:line-through #d8d8d8 solid;text-decoration:line-through #d8d8d8 solid;pointer-events:none}.ex-label-disabled[_ngcontent-%COMP%]     a:hover{text-decoration-line:line-through}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLabelComponent, [{
        type: Component,
        args: [{ selector: 'ex-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div dir=\"auto\" *ngIf=\"value && (!sectionId || !isQuickAccessScope); else withinSection\" class=\"ex-label-wrapper\"\n     [ngClass]=\"{ 'ex-label-disabled': isStrikeThrough }\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n<ng-template #content>\n  <span *ngIf=\"(svgIcon?.iconName || iconName) && iconSide === 'left'\" class=\"ex-label-icon-left\">\n      <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n    </span>\n  <span *ngIf=\"iconName && iconSide === 'left'\">&nbsp;</span>\n  <span [ngStyle]=\"style\" class=\"ex-label-value\">\n        <span *ngIf=\"label\" class=\"sel-label ex-label-value-bold\" [ngStyle]=\"labelStyle\">{{ label | translate }}{{\n            hasColon ? ':' : ''\n          }}</span>\n        <span *ngIf=\"label\">&nbsp;</span>\n    <!-- if text is highlighted bind to innerHTML; if text not highlighted bind to innerText -->\n\n  <span *ngIf=\"htmlId != undefined; else spanWithoutId\" [matTooltip]=\"tooltip || (displayTooltip ? '' + value : '')\"\n        [id]=\"htmlId\" class=\"sel-value ex-label-value-span\"><ng-container *ngTemplateOutlet=\"innerSpan\"></ng-container></span>\n  </span>\n  <span *ngIf=\"iconName && iconSide === 'right'\">&nbsp;</span>\n  <span *ngIf=\"iconSide === 'right'\" class=\"ex-label-icon-right\">\n      <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n    </span>\n</ng-template>\n<ng-template #icon>\n  <ex-icon *ngIf=\"!svgIcon && iconName\" [ngClass]=\"iconStyle\" [ngStyle]=\"iconStyle\" [iconType]=\"iconType\"\n           [iconName]=\"iconName\" [color]=\"iconColor\" [ariaHidden]=\"true\" [sizePx]=\"iconSize\">\n  </ex-icon>\n  <ex-svg-icon *ngIf=\"svgIcon && svgIcon.iconName\" [ngClass]=\"svgIcon.iconStyle\" [ngStyle]=\"svgIcon.iconStyle\"\n               [iconName]=\"svgIcon.iconName\" [color]=\"svgIcon.iconColor\" [ariaHidden]=\"true\" [size]=\"svgIcon.iconSize\"\n               [tooltip]=\"svgIcon.tooltip\">\n  </ex-svg-icon>\n</ng-template>\n\n<ng-template #spanWithoutId>\n  <span [matTooltip]=\"tooltip || (displayTooltip ? '' + value : '')\" class=\"sel-value ex-label-value-span\"><ng-container\n    *ngTemplateOutlet=\"innerSpan\"></ng-container></span>\n</ng-template>\n\n<ng-template #innerSpan>\n  <ng-container\n    *ngFor=\"let text of ('' + value | translate | exTextHighlight: highlightedText : _highlightedTextStyle : true)\">\n    <ng-container\n      *ngIf=\"text.startsWith('<'+_highlightedTextStyle+'>'); then innerHTMLTmpl; else innerTextTmpl\">\n    </ng-container>\n    <ng-template #innerTextTmpl>\n                    <span [innerText]=\"text\" [ngClass]=\"{ 'ex-label-value-bold': isBold || isTitle, 'ex-label-value-title': isTitle }\"\n                          [ngStyle]=\"valueStyle\"></span>\n    </ng-template>\n    <ng-template #innerHTMLTmpl>\n                    <span [innerHTML]=\"text\" [ngClass]=\"{ 'ex-label-value-bold': isBold || isTitle, 'ex-label-value-title': isTitle }\"\n                          [ngStyle]=\"valueStyle\"></span>\n    </ng-template>\n  </ng-container>\n</ng-template>\n<ng-template #withinSection>\n  <div *ngIf=\"value && sectionId && isQuickAccessScope\" class=\"ex-label-wrapper\" exQuickAccess=\"{{label | translate}}\"\n       [exQuickAccessType]=\"quickAcssessTypes.FIELD\" [exQuickAccessSection]=\"sectionId\"\n       [ngClass]=\"{ 'ex-label-disabled': isStrikeThrough }\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </div>\n</ng-template>\n", styles: [".ex-label-wrapper{display:flex;flex-direction:row;align-items:center}.ex-label-wrapper .ex-label-icon-right{margin-inline-start:5px}.ex-label-wrapper .ex-label-icon-left{margin-inline-end:5px;align-self:flex-start;padding-top:1px}.ex-label-wrapper .ex-label-value{overflow:hidden;text-overflow:ellipsis}.ex-label-disabled{text-decoration-line:line-through;cursor:not-allowed}.ex-label-disabled ::ng-deep a{-webkit-text-decoration:line-through #d8d8d8 solid;text-decoration:line-through #d8d8d8 solid;pointer-events:none}.ex-label-disabled ::ng-deep a:hover{text-decoration-line:line-through}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS_SCOPE]
            }] }]; }, { label: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], value: [{
            type: Input
        }], isBold: [{
            type: Input
        }], svgIcon: [{
            type: Input
        }], iconType: [{
            type: Input
        }], iconName: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], iconSide: [{
            type: Input
        }], highlightedText: [{
            type: Input
        }], isStrikeThrough: [{
            type: Input
        }], style: [{
            type: Input
        }], labelStyle: [{
            type: Input
        }], valueStyle: [{
            type: Input
        }], iconStyle: [{
            type: Input
        }], hasColon: [{
            type: Input
        }], htmlId: [{
            type: Input
        }], displayTooltip: [{
            type: Input
        }], isTitle: [{
            type: Input
        }], arguments: [{
            type: Input
        }] }); })();

class ExLabelModule {
    static { this.ɵfac = function ExLabelModule_Factory(t) { return new (t || ExLabelModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExLabelModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            ExSvgIconModule,
            TranslateModule,
            EXPipesModule,
            MatTooltipModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    ExSvgIconModule,
                    TranslateModule,
                    EXPipesModule,
                    MatTooltipModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExLabelComponent
                ],
                exports: [
                    ExLabelComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExLabelModule, { declarations: [ExLabelComponent], imports: [CommonModule,
        ExIconModule,
        ExSvgIconModule,
        TranslateModule,
        EXPipesModule,
        MatTooltipModule,
        ExDirectivesModule], exports: [ExLabelComponent] }); })();

const _c0$1y = ["input"];
function ExSearchComponent_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 8);
} if (rf & 2) {
    i0.ɵɵproperty("iconName", "search");
} }
const _c1$_ = function (a0) { return { "ex-search-hide-close": a0 }; };
function ExSearchComponent_ex_close_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 9);
    i0.ɵɵlistener("closeClicked", function ExSearchComponent_ex_close_7_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onClear()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("size", "small")("tooltip", "ng.general.clear")("ngClass", i0.ɵɵpureFunction1(3, _c1$_, !(!ctx_r2.isLoading && ctx_r2.searchText && (ctx_r2.searchText == null ? null : ctx_r2.searchText.length) !== 0)));
} }
function ExSearchComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ExSearchComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onSearch()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "ng.general.search"))("aria-label", i0.ɵɵpipeBind1(2, 4, "ng.general.search"));
} }
function ExSearchComponent_ex_spinner_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 12);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExSearchComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r5.errorMessage), "\n");
} }
const _c2$G = function (a0, a1) { return { "ex-search-focus": a0, "ex-search-change-color-effect": a1 }; };
const _c3$x = function (a0) { return { "ex-search-change-color-effect": a0 }; };
class ExSearchComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         *  event fired whenever the search button is clicked or when the user type - depend on the incremental parameter
         */
        this.searchTriggered = new EventEmitter();
        this.compositionupdate = new EventEmitter();
        /**
         *  define if the search is an incremental search (the event is fired every time the user types)
         *  or the event is fired by clicking on the search icon/press Enter
         *  default is false
         */
        this.incremental = false;
        /**
         *  set the background of the searchbox
         *  default is white
         */
        this.background = '#fff';
        /**
         *  change the background color with effect
         *  false is default
         */
        this.backgroundEffect = false;
        /**
         *  placeholder for the searchbox
         *  default is empty
         */
        this.placeholder = '';
        /**
         * value of the text box
         */
        this.searchText = '';
        /**
         * define if the search box should have a blue border on focus
         * by default - false
         */
        this.blueOnFocus = true;
        /**
         * defines if to show the search icon
         */
        this.showSearchIcon = true;
        /**
         * should the search button be shown
         * default - true
         * // todo: config to choose side (left, right, none)
         */
        this.showSearchButton = true;
        this.isLoading = false;
        this.disableWhenLoading = true;
        this.autoFocus = false;
        this.inputAriaLabel = null;
        this.inputAriaControlsId = null;
        this.inputAriaActiveDescendant = null;
        this.isValid = true;
        this.hasClearButton = true;
        this.maxlength = 0;
        /**
         * indicates rtl state. Defaults left to right
         */
        this.rtl = 'ltr';
        /**
         * event triggered whenever the value change
         */
        this.searchTextChange = new EventEmitter();
        this.enterKeyup = new EventEmitter();
        this.blur = new EventEmitter();
        this.isFocus = false;
    }
    ngAfterViewInit() {
        if (this.autoFocus) {
            setTimeout(() => this.focus(), 0);
        }
    }
    onEnterKeyup() {
        this.onSearch();
        this.enterKeyup.emit();
    }
    onCompositionUpdate() {
        this.compositionupdate.emit(true);
    }
    onCompositionEnd() {
        this.compositionupdate.emit(false);
    }
    onSearch() {
        if (!this.incremental) {
            this.searchTriggered.emit(this.searchText);
        }
    }
    //Replace onKeyup to support Chinese input
    onKeyup(event) {
        if (this.incremental && event.key != 'Tab') {
            this.searchTriggered.emit(this.searchText);
        }
    }
    onInput(event) {
        if (this.incremental) {
            this.searchTriggered.emit(event.target.value);
        }
    }
    onClear() {
        this.searchText = '';
        this.searchTextChange.emit(this.searchText);
        this.searchTriggered.emit(this.searchText);
    }
    onFocus() {
        this.isFocus = true;
    }
    onBlur() {
        this.isFocus = false;
        this.blur.emit(event);
    }
    _searchTextChange(text) {
        this.searchText = text.trim();
        this.searchTextChange.emit(text.trim());
    }
    focus() {
        this.input.nativeElement.focus();
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExSearchComponent_Factory(t) { return new (t || ExSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSearchComponent, selectors: [["ex-search"]], viewQuery: function ExSearchComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1y, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        } }, inputs: { incremental: "incremental", background: "background", backgroundEffect: "backgroundEffect", placeholder: "placeholder", searchText: "searchText", blueOnFocus: "blueOnFocus", showSearchIcon: "showSearchIcon", errorMessage: "errorMessage", showSearchButton: "showSearchButton", isLoading: "isLoading", disableWhenLoading: "disableWhenLoading", autoFocus: "autoFocus", inputAriaLabel: "inputAriaLabel", inputAriaControlsId: "inputAriaControlsId", inputAriaActiveDescendant: "inputAriaActiveDescendant", isValid: "isValid", hasClearButton: "hasClearButton", maxlength: "maxlength", rtl: "rtl" }, outputs: { searchTriggered: "searchTriggered", compositionupdate: "compositionupdate", searchTextChange: "searchTextChange", enterKeyup: "enterKeyup", blur: "blur" }, decls: 11, vars: 33, consts: [[1, "ex-search-search-wrapper", 3, "ngClass"], ["class", "ex-search-search-icon", 3, "iconName", 4, "ngIf"], ["aria-autocomplete", "list", 1, "sel-search-input", "ex-search-input", 3, "placeholder", "ngModel", "ngClass", "disabled", "ngModelChange", "keyup.enter", "input", "focus", "blur", "compositionupdate", "compositionend"], ["input", ""], ["class", "ex-search-clear-button-margin", 3, "size", "tooltip", "ngClass", "closeClicked", 4, "ngIf"], ["class", "ex-search-search-button", 3, "click", 4, "ngIf"], [3, "diameter", 4, "ngIf"], ["class", "ex-search-error", 4, "ngIf"], [1, "ex-search-search-icon", 3, "iconName"], [1, "ex-search-clear-button-margin", 3, "size", "tooltip", "ngClass", "closeClicked"], [1, "ex-search-search-button", 3, "click"], [1, "uxf-icon", "uxf-search"], [3, "diameter"], [1, "ex-search-error"]], template: function ExSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExSearchComponent_ex_svg_icon_1_Template, 1, 1, "ex-svg-icon", 1);
            i0.ɵɵelementStart(2, "input", 2, 3);
            i0.ɵɵlistener("ngModelChange", function ExSearchComponent_Template_input_ngModelChange_2_listener($event) { return ctx._searchTextChange($event); })("keyup.enter", function ExSearchComponent_Template_input_keyup_enter_2_listener() { return ctx.onEnterKeyup(); })("input", function ExSearchComponent_Template_input_input_2_listener($event) { return ctx.onInput($event); })("focus", function ExSearchComponent_Template_input_focus_2_listener() { return ctx.onFocus(); })("blur", function ExSearchComponent_Template_input_blur_2_listener() { return ctx.onBlur(); })("compositionupdate", function ExSearchComponent_Template_input_compositionupdate_2_listener() { return ctx.onCompositionUpdate(); })("compositionend", function ExSearchComponent_Template_input_compositionend_2_listener() { return ctx.onCompositionEnd(); });
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ExSearchComponent_ex_close_7_Template, 1, 5, "ex-close", 4);
            i0.ɵɵtemplate(8, ExSearchComponent_button_8_Template, 4, 6, "button", 5);
            i0.ɵɵtemplate(9, ExSearchComponent_ex_spinner_9_Template, 1, 1, "ex-spinner", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, ExSearchComponent_div_10_Template, 3, 3, "div", 7);
        } if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.background);
            i0.ɵɵclassProp("search-combobox-not-valid", !ctx.isValid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(28, _c2$G, ctx.blueOnFocus && ctx.isFocus, ctx.backgroundEffect));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.incremental && ctx.showSearchIcon);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("background", ctx.background);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 22, ctx.placeholder))("ngModel", ctx.searchText)("ngClass", i0.ɵɵpureFunction1(31, _c3$x, ctx.backgroundEffect))("disabled", ctx.isLoading && ctx.disableWhenLoading);
            i0.ɵɵattribute("aria-invalid", !ctx.isValid)("aria-description", i0.ɵɵpipeBind1(5, 24, !ctx.isValid && ctx.errorMessage))("aria-controls", ctx.inputAriaControlsId)("aria-activedescendant", ctx.inputAriaActiveDescendant)("maxlength", ctx.maxlength ? ctx.maxlength : false)("aria-label", ctx.inputAriaLabel ? ctx.inputAriaLabel : i0.ɵɵpipeBind1(6, 26, "ng.search.enter_to_search"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.hasClearButton);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isLoading && !ctx.incremental && ctx.showSearchButton);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isLoading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isValid);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExSpinnerComponent, ExSvgIconComponent, ExCloseComponent, i1$2.TranslatePipe], styles: [".ex-search-change-color-effect[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_color-change 1.5s linear infinite alternate both}.ex-search-search-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;border-start-end-radius:3px;border-start-start-radius:3px;border-end-start-radius:3px;border-end-end-radius:3px;padding-left:10px;padding-right:10px;justify-content:stretch;z-index:0}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-search-icon[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-input[_ngcontent-%COMP%]{border:0px;display:flex;flex:1;min-width:0;direction:inherit}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder{color:#898989}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-input[_ngcontent-%COMP%]:focus{outline-width:0}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-input[_ngcontent-%COMP%]:placeholder-shown{text-overflow:ellipsis}.ex-search-search-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:0px;cursor:pointer;display:flex}.ex-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-search-button[_ngcontent-%COMP%]{margin-inline-start:10px;color:#4164a4}.ex-search-search-wrapper.search-combobox-not-valid[_ngcontent-%COMP%]{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}[dir=rtl].ex-search-search-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{direction:inherit}.ex-search-hide-close[_ngcontent-%COMP%]{visibility:hidden;display:none}.ex-search-clear-button-margin[_ngcontent-%COMP%]{margin-inline-end:-10px}@keyframes _ngcontent-%COMP%_color-change{0%{background:#fff}10%{background:#fff9d6}90%{background:#fff9d6}to{background:#fff}}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSearchComponent, [{
        type: Component,
        args: [{ selector: 'ex-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-search-search-wrapper\"\n  [ngClass]=\"{ 'ex-search-focus': blueOnFocus && isFocus, 'ex-search-change-color-effect': backgroundEffect }\"\n  [style.background]=\"background\" [class.search-combobox-not-valid]=\"!isValid\">\n  <ex-svg-icon *ngIf=\"incremental && showSearchIcon\" class=\"ex-search-search-icon\" [iconName]=\"'search'\"></ex-svg-icon>\n  <input #input [placeholder]=\"placeholder | translate\" [ngModel]=\"searchText\" [attr.aria-invalid]=\"!isValid\"\n    [attr.aria-description]=\"!isValid && errorMessage | translate\"\n    (ngModelChange)=\"_searchTextChange($event)\" [ngClass]=\"{ 'ex-search-change-color-effect': backgroundEffect }\"\n    [disabled]=\"isLoading && disableWhenLoading\" (keyup.enter)=\"onEnterKeyup()\" (input)=\"onInput($event)\"\n    [style.background]=\"background\" (focus)=\"onFocus()\" (blur)=\"onBlur()\" [attr.aria-controls]=\"inputAriaControlsId\"\n    [attr.aria-activedescendant]=\"inputAriaActiveDescendant\" aria-autocomplete=\"list\" (compositionupdate)=\"onCompositionUpdate()\"\n    (compositionend)=\"onCompositionEnd()\" class=\"sel-search-input ex-search-input\" [attr.maxlength]=\"maxlength ? maxlength : false\"\n    [attr.aria-label]=\"inputAriaLabel ? inputAriaLabel : 'ng.search.enter_to_search' | translate\">\n  <ex-close *ngIf=\"hasClearButton\" (closeClicked)=\"onClear()\" [size]=\"'small'\" [tooltip]=\"'ng.general.clear'\" class=\"ex-search-clear-button-margin\"\n            [ngClass]=\"{ 'ex-search-hide-close': !(!isLoading && searchText && searchText?.length !== 0) }\"></ex-close>\n  <button [attr.aria-label]=\"'ng.general.search' | translate\" *ngIf=\"!isLoading && !incremental && showSearchButton\"\n    class=\"ex-search-search-button\" (click)=\"onSearch()\" [attr.aria-label]=\"'ng.general.search' | translate\">\n    <i class=\"uxf-icon uxf-search\"></i>\n  </button>\n  <ex-spinner [diameter]=\"15\" *ngIf=\"isLoading\"></ex-spinner>\n</div>\n<div class=\"ex-search-error\" *ngIf=\"!isValid\">\n  {{ errorMessage | translate }}\n</div>\n", styles: [".ex-search-change-color-effect{animation:color-change 1.5s linear infinite alternate both}.ex-search-search-wrapper{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;border-start-end-radius:3px;border-start-start-radius:3px;border-end-start-radius:3px;border-end-end-radius:3px;padding-left:10px;padding-right:10px;justify-content:stretch;z-index:0}.ex-search-search-wrapper .ex-search-search-icon{margin-inline-end:5px}.ex-search-search-wrapper .ex-search-input{border:0px;display:flex;flex:1;min-width:0;direction:inherit}.ex-search-search-wrapper .ex-search-input input::placeholder{color:#898989}.ex-search-search-wrapper .ex-search-input:focus{outline-width:0}.ex-search-search-wrapper .ex-search-input:placeholder-shown{text-overflow:ellipsis}.ex-search-search-wrapper button{border:0px;cursor:pointer;display:flex}.ex-search-search-wrapper .ex-search-search-button{margin-inline-start:10px;color:#4164a4}.ex-search-search-wrapper.search-combobox-not-valid{border:1px solid #c62726!important;box-shadow:0 0 0 1px #c62726!important}[dir=rtl].ex-search-search-wrapper input{direction:inherit}.ex-search-hide-close{visibility:hidden;display:none}.ex-search-clear-button-margin{margin-inline-end:-10px}@keyframes color-change{0%{background:#fff}10%{background:#fff9d6}90%{background:#fff9d6}to{background:#fff}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { searchTriggered: [{
            type: Output
        }], compositionupdate: [{
            type: Output
        }], incremental: [{
            type: Input
        }], background: [{
            type: Input
        }], backgroundEffect: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], searchText: [{
            type: Input
        }], blueOnFocus: [{
            type: Input
        }], showSearchIcon: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], showSearchButton: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], disableWhenLoading: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], inputAriaLabel: [{
            type: Input
        }], inputAriaControlsId: [{
            type: Input
        }], inputAriaActiveDescendant: [{
            type: Input
        }], isValid: [{
            type: Input
        }], hasClearButton: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], rtl: [{
            type: Input
        }], searchTextChange: [{
            type: Output
        }], enterKeyup: [{
            type: Output
        }], blur: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();

class ExSearchModule {
    static { this.ɵfac = function ExSearchModule_Factory(t) { return new (t || ExSearchModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSearchModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            MatIconModule,
            FormsModule,
            ExSpinnerModule,
            ExSvgIconModule,
            ExCloseModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSearchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    MatIconModule,
                    FormsModule,
                    ExSpinnerModule,
                    ExSvgIconModule,
                    ExCloseModule
                ],
                declarations: [
                    ExSearchComponent
                ],
                exports: [
                    ExSearchComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSearchModule, { declarations: [ExSearchComponent], imports: [CommonModule,
        TranslateModule,
        MatIconModule,
        FormsModule,
        ExSpinnerModule,
        ExSvgIconModule,
        ExCloseModule], exports: [ExSearchComponent] }); })();

const Animations$8 = [
    trigger('arrowFlip', [
        state('down', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('up', style({
            transform: 'rotate(-90deg)'
        })),
        transition('down <=> up', [
            animate('0.25s')
        ])
    ]),
    trigger('expendAndcollapse', [
        state('expanded', style({
            height: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('collapsed', style({
            height: '0px',
            overflow: 'hidden'
        })),
        transition('expanded <=> collapsed', [
            animate('0.25s')
        ])
    ])
];

const Animations$7 = [
    trigger('arrowFlip', [
        state('down', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('up', style({
            transform: 'rotate(-90deg)'
        })),
        transition('down <=> up', [
            animate('0.25s')
        ])
    ]),
    trigger('expendAndcollapse', [
        state('expanded', style({
            height: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('collapsed', style({
            height: '0px',
            overflow: 'hidden'
        })),
        transition('expanded <=> collapsed', [
            animate('0.25s')
        ])
    ])
];

const _c0$1x = function (a0) { return { "ex-combobox-sticky": a0 }; };
function ExGroupOutletComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵlistener("click", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const i_r7 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onHeaderClicked(i_r7)); })("keydown", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_div_keydown_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r9); const item_r6 = restoredCtx.$implicit; const i_r7 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onHeaderKeydown($event, item_r6.expanded, i_r7)); });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6)(7, "ex-group-outlet", 7);
    i0.ɵɵlistener("selectedValueChange", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_ex_group_outlet_selectedValueChange_7_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.selectedValueChanged($event)); })("selectedOptionIdChange", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_ex_group_outlet_selectedOptionIdChange_7_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.selectedOptionIdChanged($event)); })("activeOptionIdChange", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_ex_group_outlet_activeOptionIdChange_7_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.activeOptionIdChanged($event.comboboxId, $event.groupIndex, $event.i)); })("itemClick", function ExGroupOutletComponent_ng_container_0_ng_container_1_Template_ex_group_outlet_itemClick_7_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.itemClicked($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r5.comboboxId, "Group_", i_r7, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c0$1x, ctx_r5.hasStickyHeaders));
    i0.ɵɵattribute("aria-expanded", item_r6.expanded);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-combobox-title sel-combobox-group-", item_r6.itemName.value, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 23, item_r6.itemName.value));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("@arrowFlip", item_r6.expanded ? "down" : "up");
    i0.ɵɵadvance(1);
    i0.ɵɵattributeInterpolate2("aria-labelledby", "", ctx_r5.comboboxId, "Group_", i_r7, "");
    i0.ɵɵproperty("@expendAndcollapse", item_r6.expanded ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", item_r6.subItems)("sort", ctx_r5.sort)("hasStickyHeaders", ctx_r5.hasStickyHeaders)("searchText", ctx_r5.searchText)("groupName", item_r6.itemName.value)("groupIndex", i_r7)("comboboxId", ctx_r5.comboboxId)("selectedOptionId", ctx_r5.selectedOptionId)("highlightSelected", ctx_r5.highlightSelected)("showCheckOnSelected", ctx_r5.showCheckOnSelected)("disableAutoClose", ctx_r5.disableAutoClose);
} }
function ExGroupOutletComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent_ng_container_0_ng_container_1_Template, 8, 27, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function ExGroupOutletComponent_ng_template_1_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExGroupOutletComponent_ng_template_1_ng_container_0_hr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 10);
} }
const _c1$Z = function (a0, a1, a2, a3) { return { item: a0, isLast: a1, i: a2, groupIndex: a3 }; };
function ExGroupOutletComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent_ng_template_1_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(2, ExGroupOutletComponent_ng_template_1_ng_container_0_hr_2_Template, 1, 0, "hr", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    const isLast_r18 = ctx.last;
    const i_r19 = ctx.index;
    const ctx_r15 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c1$Z, item_r17, isLast_r18, i_r19, ctx_r15.groupIndex));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLast_r18);
} }
function ExGroupOutletComponent_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExGroupOutletComponent_ng_template_1_ng_container_1_hr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 12);
} }
const _c2$F = function (a0, a1, a2, a3, a4) { return { item: a0, isLast: a1, i: a2, groupIndex: a3, comboboxId: a4 }; };
function ExGroupOutletComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(2, ExGroupOutletComponent_ng_template_1_ng_container_1_hr_2_Template, 1, 0, "hr", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const isLast_r23 = ctx.last;
    const i_r24 = ctx.index;
    const ctx_r16 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction5(3, _c2$F, item_r22, isLast_r23, i_r24, ctx_r16.groupIndex, ctx_r16.comboboxId));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLast_r23 && ctx_r16.description);
} }
function ExGroupOutletComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExGroupOutletComponent_ng_template_1_ng_container_0_Template, 3, 8, "ng-container", 3);
    i0.ɵɵtemplate(1, ExGroupOutletComponent_ng_template_1_ng_container_1_Template, 3, 9, "ng-container", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.historyItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
} }
function ExGroupOutletComponent_ng_template_3_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
} }
function ExGroupOutletComponent_ng_template_3_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().item;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r27.description));
} }
function ExGroupOutletComponent_ng_template_3_i_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
} }
function ExGroupOutletComponent_ng_template_3_ex_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 23);
} if (rf & 2) {
    const item_r27 = i0.ɵɵnextContext().item;
    i0.ɵɵstyleProp("color", item_r27.color);
    i0.ɵɵproperty("iconName", item_r27.iconName)("iconType", item_r27.iconType || "svg");
} }
const _c3$w = function (a0, a1, a2, a3) { return { "ex-combobox-disabled-item": a0, "no-left-padding": a1, "ex-group-outlet-selected": a2, "ex-combobox-menu-option-one-line": a3 }; };
const _c4$q = function (a0, a1, a2) { return { "ex-group-outlet-value": a0, "margin-empty-icon": a1, "ex-combobox-none-option": a2 }; };
function ExGroupOutletComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function ExGroupOutletComponent_ng_template_3_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r39); const item_r27 = restoredCtx.item; const comboboxId_r31 = restoredCtx.comboboxId; const groupIndex_r30 = restoredCtx.groupIndex; const i_r29 = restoredCtx.i; const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.onItemClicked(item_r27, comboboxId_r31 + "_" + groupIndex_r30 + "_" + i_r29)); })("keyup.enter", function ExGroupOutletComponent_ng_template_3_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r39); const item_r27 = restoredCtx.item; const comboboxId_r31 = restoredCtx.comboboxId; const groupIndex_r30 = restoredCtx.groupIndex; const i_r29 = restoredCtx.i; const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.onItemClicked(item_r27, comboboxId_r31 + "_" + groupIndex_r30 + "_" + i_r29)); })("keydown", function ExGroupOutletComponent_ng_template_3_Template_div_keydown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r39); const isLast_r28 = restoredCtx.isLast; const ctx_r41 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r41.onKeyDown($event, isLast_r28)); })("focus", function ExGroupOutletComponent_ng_template_3_Template_div_focus_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r39); const comboboxId_r31 = restoredCtx.comboboxId; const groupIndex_r30 = restoredCtx.groupIndex; const i_r29 = restoredCtx.i; const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.activeOptionIdChanged(comboboxId_r31, groupIndex_r30, i_r29)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵtemplate(3, ExGroupOutletComponent_ng_template_3_i_3_Template, 1, 0, "i", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵpipe(6, "exTextHighlight");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, ExGroupOutletComponent_ng_template_3_span_8_Template, 3, 3, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExGroupOutletComponent_ng_template_3_i_9_Template, 1, 0, "i", 19);
    i0.ɵɵtemplate(10, ExGroupOutletComponent_ng_template_3_ex_icon_10_Template, 1, 4, "ex-icon", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r27 = ctx.item;
    const i_r29 = ctx.i;
    const groupIndex_r30 = ctx.groupIndex;
    const comboboxId_r31 = ctx.comboboxId;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", item_r27.tooltip ? i0.ɵɵpipeBind1(1, 10, item_r27.tooltip) : "")("id", groupIndex_r30 !== null ? comboboxId_r31 + "_" + groupIndex_r30 + "_" + i_r29 : comboboxId_r31 + "_" + i_r29)("ngClass", i0.ɵɵpureFunction4(17, _c3$w, item_r27.disabled, item_r27.iconName, ctx_r4.selectedValue && ctx_r4.selectedValue.item == item_r27.itemName.key && ctx_r4.highlightSelected, !ctx_r4.description));
    i0.ɵɵattribute("aria-selected", item_r27.isSelected ? item_r27.isSelected : false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.showCheckOnSelected && item_r27.isSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(22, _c4$q, ctx_r4.description, item_r27.iconType == "none", item_r27.itemName.value === "ng.general.none"))("innerHTML", i0.ɵɵpipeBind2(6, 12, i0.ɵɵpipeBind1(7, 15, item_r27.itemName.value), ctx_r4.searchText), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r27.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.isHistoryItem);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r27.iconName);
} }
class ExGroupOutletComponent {
    constructor() {
        /**
         * data format: {group?: string, item: string}
         * for multi-level send both and single level only item
         */
        this.selectedValue = null;
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData
         */
        this.itemClick = new EventEmitter();
        /**
         * Accessibility - event fires whenever an item inside the dropdown is clicked with the item id
         */
        this.selectedOptionIdChange = new EventEmitter();
        /**
         * Accessibility - event fired whenever an item inside the dropdown is activated by keyboard navigation with the item id
         */
        this.activeOptionIdChange = new EventEmitter();
        /**
         * Accessibility - event fired when we want to focus on the search box
         */
        this.focusSeachBox = new EventEmitter();
        /**
         * items group name === direct father.itemName.value
         */
        this.groupName = '';
        /**
         * the text to highlight
         */
        this.searchText = '';
        /**
         * highlight selected option
         */
        this.highlightSelected = false;
        /**
         * display a check mark next to selected item/s
         */
        this.showCheckOnSelected = false;
        this.disableAutoClose = false;
        /**
         * Accessibility - combobox unique id
         */
        this.comboboxId = null;
        /**
         * Accessibility - index of group
         */
        this.groupIndex = null;
        /**
         * Accessibility - id of current selected item
         */
        this.selectedOptionId = null;
        this.multiLevel = false;
        this.comboboxTextToolTip = '';
    }
    initHistoryItems() {
        if (this.items.length > 0) {
            this.historyItems = [];
            this.items.forEach(item => {
                if (item.isHistoryItem) {
                    this.historyItems.push(item);
                }
            });
            this.historyItems = [...this.historyItems];
            this.items = this.items.filter(item => item.isHistoryItem != true);
        }
    }
    ngOnChanges(changes) {
        for (const item of this.items) {
            if (item.subItems != null && item.subItems.length !== 0) {
                this.multiLevel = true;
                break;
            }
        }
        if (changes.hasOwnProperty('items')) {
            this.sortGroupsAndItems();
        }
    }
    onItemClicked(item, itemId) {
        event.stopPropagation();
        this.itemClick.emit({ group: this.groupName, option: item.itemName.value, key: item.itemName.key });
        this.selectedValueChange.emit({ itemName: { key: item.itemName.key, value: item.itemName.value }, isHistoryItem: item.isHistoryItem, subItems: item.subItems });
        this.selectedOptionIdChange.emit(itemId);
    }
    onHeaderClicked(idx) {
        event.stopPropagation();
        this.items[idx].expanded = !this.items[idx].expanded;
    }
    selectedValueChanged(e) {
        this.selectedValueChange.emit(e);
    }
    selectedOptionIdChanged(e) {
        this.selectedOptionIdChange.emit(e);
    }
    itemClicked(e) {
        this.itemClick.emit(e);
    }
    sortGroupsAndItems() {
        if (this.sort) {
            this.items.sort((n1, n2) => {
                if (n1.itemName.value > n2.itemName.value) {
                    return 1;
                }
                if (n1.itemName.value < n2.itemName.value) {
                    return -1;
                }
                return 0;
            });
        }
        this.initHistoryItems();
    }
    onKeyDown($event, isLast) {
        if ($event.key === "Tab" && ($event.shiftKey || !isLast)) {
            $event.stopPropagation();
        }
    }
    ///// Accessibility functions ///////
    // the current item that has the keyboards focus
    activeOptionIdChanged(comboboxId, groupIndex, i) {
        this.activeOptionIdChange.emit({ comboboxId: comboboxId, groupIndex: groupIndex, i: i });
    }
    // manages the Up and Down keyboard navigation of the GROUP HEADERS level 
    onHeaderKeydown(event, isHeaderExpanded, groupIndex) {
        event.stopPropagation();
        switch (event.key) {
            case "ArrowUp":
                if (groupIndex === 0) {
                    this.focusSeachBox.emit();
                }
                else {
                    let prevHeaderId = this.comboboxId + 'Group_' + (groupIndex - 1);
                    if (document.getElementById(prevHeaderId).attributes.getNamedItem("aria-expanded")?.value === "true") {
                        let prevListFirstItemId = this.comboboxId + '_' + (groupIndex - 1) + '_0';
                        let prevListItems = document.getElementById(prevListFirstItemId).parentElement.children;
                        prevListItems[prevListItems.length - 1]?.focus();
                    }
                    else {
                        let nextActiveElement = document.getElementById(this.comboboxId + 'Group_' + (groupIndex - 1));
                        nextActiveElement?.focus();
                    }
                }
                break;
            case "ArrowDown":
                if (isHeaderExpanded) {
                    let activeOptionId = this.comboboxId + '_' + groupIndex + '_0';
                    this.activeOptionIdChange.emit({ comboboxId: this.comboboxId, groupIndex: groupIndex, i: '0' });
                    document.getElementById(activeOptionId)?.focus();
                }
                else {
                    let nextActiveElement = document.getElementById(this.comboboxId + 'Group_' + (groupIndex + 1));
                    nextActiveElement?.focus();
                }
                break;
            case "Enter":
                this.onHeaderClicked(groupIndex);
                break;
        }
    }
    static { this.ɵfac = function ExGroupOutletComponent_Factory(t) { return new (t || ExGroupOutletComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExGroupOutletComponent, selectors: [["ex-group-outlet"]], inputs: { items: "items", selectedValue: "selectedValue", groupName: "groupName", sort: "sort", hasStickyHeaders: "hasStickyHeaders", searchText: "searchText", highlightSelected: "highlightSelected", showCheckOnSelected: "showCheckOnSelected", disableAutoClose: "disableAutoClose", description: "description", comboboxId: "comboboxId", groupIndex: "groupIndex", selectedOptionId: "selectedOptionId" }, outputs: { selectedValueChange: "selectedValueChange", itemClick: "itemClick", selectedOptionIdChange: "selectedOptionIdChange", activeOptionIdChange: "activeOptionIdChange", focusSeachBox: "focusSeachBox" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["singleLevel", ""], ["option", ""], [4, "ngFor", "ngForOf"], ["tabindex", "0", "role", "option", 1, "ex-combobox-expandable-header", 3, "ngClass", "id", "click", "keydown"], [1, "fa", "fa-angle-down"], ["role", "group"], [3, "items", "sort", "hasStickyHeaders", "searchText", "groupName", "groupIndex", "comboboxId", "selectedOptionId", "highlightSelected", "showCheckOnSelected", "disableAutoClose", "selectedValueChange", "selectedOptionIdChange", "activeOptionIdChange", "itemClick"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "last-history-entry", 4, "ngIf"], [1, "last-history-entry"], ["class", "ex-group-outlet-hr", 4, "ngIf"], [1, "ex-group-outlet-hr"], ["tabindex", "0", "role", "option", 1, "ex-combobox-menu-option", "sel-menu-option", 3, "exTooltip", "id", "ngClass", "click", "keyup.enter", "keydown", "focus"], [1, "ex-group-outler-check-container"], ["class", "uxf-icon uxf-check", 4, "ngIf"], [1, "ex-combobox-menu-option-text-wrapper"], [1, "ex-combobox-outlet-option-description", "sel-combobox-option", 3, "ngClass", "innerHTML"], [4, "ngIf"], ["class", "uxf-icon uxf-back-in-time", 4, "ngIf"], [3, "color", "iconName", "iconType", 4, "ngIf"], [1, "uxf-icon", "uxf-check"], [1, "uxf-icon", "uxf-back-in-time"], [3, "iconName", "iconType"]], template: function ExGroupOutletComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExGroupOutletComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵtemplate(1, ExGroupOutletComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExGroupOutletComponent_ng_template_3_Template, 11, 26, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.multiLevel)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExTooltipDirective, ExIconComponent, ExGroupOutletComponent, ExTextHighlightPipe, i1$2.TranslatePipe], styles: [".ex-combobox-menu-option[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;padding:5px 20px 5px 5px;border-top:1px solid transparent;border-bottom:1px solid transparent;outline:none!important}.ex-combobox-menu-option[_ngcontent-%COMP%]   .ex-group-outler-check-container[_ngcontent-%COMP%]{min-width:14px;margin-right:1px}.ex-combobox-menu-option[_ngcontent-%COMP%]   .ex-group-outler-check-container[_ngcontent-%COMP%]   .uxf-icon[_ngcontent-%COMP%]{font-size:.7em;color:#aaa}.ex-combobox-menu-option[_ngcontent-%COMP%]   .ex-combobox-menu-option-text-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:2}.ex-combobox-menu-option-one-line[_ngcontent-%COMP%]{line-height:20px}.ex-combobox-menu-option[_ngcontent-%COMP%]:hover, .ex-combobox-menu-option[_ngcontent-%COMP%]:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-combobox-expandable-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding-left:15px;padding-right:15px;height:-moz-fit-content;height:fit-content;line-height:30px}.ex-combobox-expandable-header[_ngcontent-%COMP%]:hover, .ex-combobox-expandable-header[_ngcontent-%COMP%]:focus{background:#f5f5f5;border-top:1px solid #898989!important;border-bottom:1px solid #898989!important}.ex-combobox-sticky[_ngcontent-%COMP%]{position:sticky;z-index:1;top:0}.ex-combobox-disabled-item[_ngcontent-%COMP%]{cursor:not-allowed!important;opacity:.4}.ex-group-outlet-hr[_ngcontent-%COMP%]{margin-bottom:0!important;margin-top:0!important;margin-right:10px;margin-left:10px}.last-history-entry[_ngcontent-%COMP%]{border-bottom:1px solid #ccc;margin:0}.ex-combobox-outlet-option-description[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.ex-combobox-none-option[_ngcontent-%COMP%]{font-family:roboto-light-italic,Fallback,sans-serif}"], data: { animation: Animations$7 } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGroupOutletComponent, [{
        type: Component,
        args: [{ selector: 'ex-group-outlet', animations: Animations$7, template: "<ng-container *ngIf=\"multiLevel; else singleLevel\">\n  <ng-container *ngFor=\"let item of items; let i = index\">\n\n      <div (click)=\"onHeaderClicked(i)\" class=\"ex-combobox-expandable-header\" tabindex=\"0\" role=\"option\"  (keydown)=\"onHeaderKeydown($event,item.expanded,i)\"\n        [ngClass]=\"{ 'ex-combobox-sticky': hasStickyHeaders }\" [attr.aria-expanded]=\"item.expanded\"\n        id=\"{{comboboxId}}Group_{{i}}\">\n        <span\n          class=\"ex-combobox-title sel-combobox-group-{{ item.itemName.value }}\">{{ item.itemName.value | translate }}</span>\n        <i [@arrowFlip]=\"item.expanded ? 'down' : 'up'\" class=\"fa fa-angle-down\"></i>\n      </div>\n\n      <div [@expendAndcollapse]=\"item.expanded ? 'expanded' : 'collapsed'\" role=\"group\"\n        attr.aria-labelledby=\"{{comboboxId}}Group_{{i}}\">\n        <ex-group-outlet [items]=\"item.subItems\" (selectedValueChange)=\"selectedValueChanged($event)\"\n          (selectedOptionIdChange)=\"selectedOptionIdChanged($event)\"\n          (activeOptionIdChange)=\"activeOptionIdChanged($event.comboboxId, $event.groupIndex, $event.i)\"\n          (itemClick)=\"itemClicked($event)\" [sort]=\"sort\" [hasStickyHeaders]=\"hasStickyHeaders\"\n          [searchText]=\"searchText\" [groupName]=\"item.itemName.value\" [groupIndex]=\"i\" [comboboxId]=\"comboboxId\"\n          [selectedOptionId]=\"selectedOptionId\" [highlightSelected]=\"highlightSelected\" [showCheckOnSelected]=\"showCheckOnSelected\" [disableAutoClose]=\"disableAutoClose\">\n        </ex-group-outlet>\n      </div>\n  </ng-container>\n</ng-container>\n\n<ng-template #singleLevel>\n  <ng-container *ngFor=\"let item of historyItems; last as isLast; index as i\">\n    <ng-container *ngTemplateOutlet=\"option;context: {item: item, isLast: isLast, i:i,groupIndex:groupIndex}\">\n    </ng-container>\n    <hr *ngIf=\"isLast\" class=\"last-history-entry\">\n  </ng-container>\n\n\n  <ng-container *ngFor=\"let item of items; last as isLast; index as i\">\n    <ng-container\n      *ngTemplateOutlet=\"option;context: {item: item, isLast: isLast, i:i,groupIndex:groupIndex,comboboxId:comboboxId}\">\n    </ng-container>\n    <hr *ngIf=\"!isLast && description\" class=\"ex-group-outlet-hr\">\n  </ng-container>\n</ng-template>\n\n<ng-template #option let-item=\"item\" let-isLast=\"isLast\" let-i=\"i\" let-groupIndex=\"groupIndex\"\n  let-comboboxId=\"comboboxId\">\n  <div [exTooltip]=\"item.tooltip? (item.tooltip | translate) : ''\"\n    (click)=\"onItemClicked(item, comboboxId + '_' + groupIndex + '_' + i)\"\n    (keyup.enter)=\"onItemClicked(item, comboboxId + '_' + groupIndex + '_' + i)\" tabindex=\"0\"\n    (keydown)=\"onKeyDown($event, isLast)\" role=\"option\" class=\"ex-combobox-menu-option sel-menu-option\"\n    [id]=\"(groupIndex!== null) ? (comboboxId + '_' + groupIndex + '_' + i) : (comboboxId + '_' + i)\"\n    (focus)=\"activeOptionIdChanged(comboboxId, groupIndex, i)\"\n    [attr.aria-selected]=\"item.isSelected ? item.isSelected : false\"\n    [ngClass]=\"{'ex-combobox-disabled-item' : item.disabled, 'no-left-padding': item.iconName ,\n    'ex-group-outlet-selected': (selectedValue && selectedValue.item == item.itemName.key && highlightSelected), 'ex-combobox-menu-option-one-line': !description}\">\n    <div class=\"ex-group-outler-check-container\">\n      <i *ngIf=\"showCheckOnSelected && item.isSelected\" class=\"uxf-icon uxf-check\"></i>\n    </div>\n    <div class=\"ex-combobox-menu-option-text-wrapper\">\n      <span class=\"ex-combobox-outlet-option-description sel-combobox-option\"\n        [ngClass]=\"{'ex-group-outlet-value': description , 'margin-empty-icon' : item.iconType=='none', 'ex-combobox-none-option' : item.itemName.value === 'ng.general.none'}\"\n        [innerHTML]=\"(item.itemName.value | translate) | exTextHighlight: searchText\"></span>\n      <span *ngIf=\"item.description\">{{ item.description | translate }}</span>\n    </div>\n    <i *ngIf=\"item.isHistoryItem\" class=\"uxf-icon uxf-back-in-time\"></i>\n    <ex-icon *ngIf=\"item.iconName\" [style.color]=\"item.color\" [iconName]=\"item.iconName\"\n      [iconType]=\"item.iconType || 'svg'\"></ex-icon>\n  </div>\n</ng-template>\n", styles: [".ex-combobox-menu-option{display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;padding:5px 20px 5px 5px;border-top:1px solid transparent;border-bottom:1px solid transparent;outline:none!important}.ex-combobox-menu-option .ex-group-outler-check-container{min-width:14px;margin-right:1px}.ex-combobox-menu-option .ex-group-outler-check-container .uxf-icon{font-size:.7em;color:#aaa}.ex-combobox-menu-option .ex-combobox-menu-option-text-wrapper{display:flex;flex-direction:column;flex-grow:2}.ex-combobox-menu-option-one-line{line-height:20px}.ex-combobox-menu-option:hover,.ex-combobox-menu-option:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-combobox-expandable-header{display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding-left:15px;padding-right:15px;height:-moz-fit-content;height:fit-content;line-height:30px}.ex-combobox-expandable-header:hover,.ex-combobox-expandable-header:focus{background:#f5f5f5;border-top:1px solid #898989!important;border-bottom:1px solid #898989!important}.ex-combobox-sticky{position:sticky;z-index:1;top:0}.ex-combobox-disabled-item{cursor:not-allowed!important;opacity:.4}.ex-group-outlet-hr{margin-bottom:0!important;margin-top:0!important;margin-right:10px;margin-left:10px}.last-history-entry{border-bottom:1px solid #ccc;margin:0}.ex-combobox-outlet-option-description{overflow:hidden;text-overflow:ellipsis}.ex-combobox-none-option{font-family:roboto-light-italic,Fallback,sans-serif}\n"] }]
    }], function () { return []; }, { items: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], itemClick: [{
            type: Output
        }], selectedOptionIdChange: [{
            type: Output
        }], activeOptionIdChange: [{
            type: Output
        }], focusSeachBox: [{
            type: Output
        }], groupName: [{
            type: Input
        }], sort: [{
            type: Input
        }], hasStickyHeaders: [{
            type: Input
        }], searchText: [{
            type: Input
        }], highlightSelected: [{
            type: Input
        }], showCheckOnSelected: [{
            type: Input
        }], disableAutoClose: [{
            type: Input
        }], description: [{
            type: Input
        }], comboboxId: [{
            type: Input
        }], groupIndex: [{
            type: Input
        }], selectedOptionId: [{
            type: Input
        }] }); })();

const _c0$1w = ["input"];
const _c1$Y = ["menuTrigger"];
const _c2$E = ["menu"];
const _c3$v = ["matMenuContent"];
const _c4$p = ["tooltip"];
const _c5$k = function (a0) { return { "ex-combobox-multi-label": a0 }; };
function ExComboboxComponent_div_0_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 11);
    i0.ɵɵlistener("click", function ExComboboxComponent_div_0_label_1_Template_label_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r6.comboboxId, "LabelId");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c5$k, ctx_r6.isMultiSelect));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, ctx_r6.label), ":");
} }
const _c6$i = function (a0, a1, a2, a3) { return { "ex-combobox-warning": a0, "sel-combobox-warning": a1, "ex-combobox-multi-select": a2, "ex-combobox-button-border": a3 }; };
function ExComboboxComponent_div_0_ng_template_3_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13, 14);
    i0.ɵɵlistener("mouseenter", function ExComboboxComponent_div_0_ng_template_3_button_0_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.isHovered = true); })("mouseleave", function ExComboboxComponent_div_0_ng_template_3_button_0_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.isHovered = false); })("menuClosed", function ExComboboxComponent_div_0_ng_template_3_button_0_Template_button_menuClosed_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.reset()); })("menuOpened", function ExComboboxComponent_div_0_ng_template_3_button_0_Template_button_menuOpened_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.focus()); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementContainer(4, 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(1);
    i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(8);
    const ctx_r14 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵstyleProp("width", ctx_r14.full ? "100%" : "initial")("border-width", ctx_r14.hasBorder ? "1px" : "0px");
    i0.ɵɵclassProp("ex-combobox-border", ctx_r14.hasBorder);
    i0.ɵɵproperty("matMenuTriggerFor", _r3)("exTooltip", ctx_r14.isMultiSelect ? "" : i0.ɵɵpipeBind1(3, 14, ctx_r14.comboboxTextToolTip))("disabled", ctx_r14.disabled)("ngClass", i0.ɵɵpureFunction4(16, _c6$i, ctx_r14.showWarning, ctx_r14.showWarning, (ctx_r14.isHovered || (_r15 == null ? null : _r15.menuOpen)) && ctx_r14.selectedCodesDisplay.length > 0, ctx_r14.isMultiSelect));
    i0.ɵɵattribute("aria-labelledby", ctx_r14.inputAriaLabel.length > 0 ? null : ctx_r14.comboboxId + "LabelId")("aria-label", ctx_r14.inputAriaLabel.length > 0 ? ctx_r14.inputAriaLabel : null)("aria-activedescendant", ctx_r14.selectedItemID);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
function ExComboboxComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExComboboxComponent_div_0_ng_template_3_button_0_Template, 5, 21, "button", 12);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", !(ctx_r8.viewMode || ctx_r8.isReadOnly))("ngIfElse", _r1);
} }
const _c7$f = function (a0) { return { "ex-combobox-side-trigger-start": a0 }; };
function ExComboboxComponent_div_0_ng_template_5_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 17);
    i0.ɵɵlistener("mouseenter", function ExComboboxComponent_div_0_ng_template_5_button_0_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r25.isHovered = true); })("mouseleave", function ExComboboxComponent_div_0_ng_template_5_button_0_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r27.isHovered = false); })("click", function ExComboboxComponent_div_0_ng_template_5_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(5); return i0.ɵɵresetView(_r24.openMenu()); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainer(3, 4);
    i0.ɵɵelementStart(4, "div", 18, 19);
    i0.ɵɵlistener("menuOpened", function ExComboboxComponent_div_0_ng_template_5_button_0_Template_div_menuOpened_4_listener() { i0.ɵɵrestoreView(_r26); const ctx_r29 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r29.onSideMenuOpened()); })("menuClosed", function ExComboboxComponent_div_0_ng_template_5_button_0_Template_div_menuClosed_4_listener() { i0.ɵɵrestoreView(_r26); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.onSideMenuClosed()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r24 = i0.ɵɵreference(5);
    i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(8);
    const ctx_r22 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵstyleProp("width", ctx_r22.full ? "100%" : "initial")("border-width", ctx_r22.hasBorder ? "1px" : "0px");
    i0.ɵɵproperty("exTooltip", ctx_r22.isMultiSelect ? "" : i0.ɵɵpipeBind1(2, 11, ctx_r22.comboboxTextToolTip))("disabled", ctx_r22.disabled)("ngClass", i0.ɵɵpureFunction4(13, _c6$i, ctx_r22.showWarning, ctx_r22.showWarning, (ctx_r22.isHovered || (_r24 == null ? null : _r24.menuOpen)) && ctx_r22.selectedCodesDisplay.length > 0, ctx_r22.isMultiSelect));
    i0.ɵɵattribute("aria-activedescendant", ctx_r22.selectedItemID);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r3)("ngClass", i0.ɵɵpureFunction1(18, _c7$f, ctx_r22.triggerAtStart));
} }
function ExComboboxComponent_div_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExComboboxComponent_div_0_ng_template_5_button_0_Template, 6, 20, "button", 15);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", !(ctx_r10.viewMode || ctx_r10.isReadOnly))("ngIfElse", _r1);
} }
function ExComboboxComponent_div_0_ng_template_7_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "!openToSide"]);
} }
function ExComboboxComponent_div_0_ng_template_7_label_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 27);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c8$d = function (a0) { return { "sel-combobox-selected-value-placeholder-disabled": a0 }; };
function ExComboboxComponent_div_0_ng_template_7_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c8$d, ctx_r34.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r34.placeholder), "");
} }
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("sel-combobox-multi-selected-", i0.ɵɵpipeBind1(1, 4, selected_r42.group), "-group-value");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 6, selected_r42.group), ":");
} }
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_ex_close_7_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 36);
    i0.ɵɵlistener("closeClicked", function ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_ex_close_7_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r48); const selected_r42 = i0.ɵɵnextContext().$implicit; const ctx_r46 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r46.remove(selected_r42)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.remove"));
} }
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label");
    i0.ɵɵtemplate(2, ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_span_2_Template, 4, 8, "span", 34);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_ex_close_7_Template, 2, 3, "ex-close", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r42 = ctx.$implicit;
    const ctx_r41 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap(ctx_r41.noGroup ? "ex-combobox-selected-no-group-chip-wrapper" : "ex-combobox-selected-chip-wrapper");
    i0.ɵɵstyleProp("background", selected_r42.color || "default");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r41.noGroup ? "ex-combobox-chip-no-group-label" : "ex-combobox-chip-label");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.multiLevel && ctx_r41.showGroupLabel || !ctx_r41.noGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("sel-combobox-multi-selected-", i0.ɵɵpipeBind1(4, 12, selected_r42.group), "-option-value");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 14, selected_r42.option));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r41.viewMode || ctx_r41.isReadOnly || ctx_r41.disabled));
} }
const _c9$a = function (a0) { return { "no-group-combo-list": a0 }; };
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 31)(2, "div", 32);
    i0.ɵɵtemplate(3, ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_div_3_Template, 8, 16, "div", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c9$a, ctx_r38.noGroup));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r38.selectedCodesDisplay);
} }
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_ng_template_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, ctx_r49.selectedGroup), ": ");
} }
const _c10$8 = function (a0) { return { "ex-combobox-disabled": a0 }; };
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtemplate(1, ExComboboxComponent_div_0_ng_template_7_ng_template_7_ng_template_1_span_1_Template, 3, 3, "span", 38);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c10$8, ctx_r40.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.multiLevel && ctx_r40.showSelectedGroupName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r40.selectedOption), " ");
} }
function ExComboboxComponent_div_0_ng_template_7_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExComboboxComponent_div_0_ng_template_7_ng_template_7_div_0_Template, 4, 4, "div", 29);
    i0.ɵɵtemplate(1, ExComboboxComponent_div_0_ng_template_7_ng_template_7_ng_template_1_Template, 4, 7, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(2);
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r36.isMultiSelect)("ngIfElse", _r39);
} }
function ExComboboxComponent_div_0_ng_template_7_i_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 40);
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ex-combobox-arrow-multi", ctx_r37.selectedCodesDisplay.length > 0)("ex-combobox-arrow", ctx_r37.iconCss == "uxf-down-caret");
    i0.ɵɵproperty("ngClass", ctx_r37.openToSide ? ctx_r37._dir === "ltr" ? "uxf-right-caret" : "uxf-left-caret" : ctx_r37.iconCss);
} }
const _c11$6 = function (a0, a1) { return { "ex-combobox-selected-wrapper-multi": a0, "ex-comboBox-reverese": a1, selectedFontSize: true }; };
const _c12$5 = function (a0) { return { "ex-combobox-multi-text-wrapper": a0 }; };
function ExComboboxComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20, 17);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExComboboxComponent_div_0_ng_template_7_ng_content_3_Template, 1, 0, "ng-content", 21);
    i0.ɵɵelementStart(4, "span", 22);
    i0.ɵɵtemplate(5, ExComboboxComponent_div_0_ng_template_7_label_5_Template, 2, 0, "label", 23);
    i0.ɵɵtemplate(6, ExComboboxComponent_div_0_ng_template_7_span_6_Template, 3, 6, "span", 24);
    i0.ɵɵtemplate(7, ExComboboxComponent_div_0_ng_template_7_ng_template_7_Template, 3, 2, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExComboboxComponent_div_0_ng_template_7_i_9_Template, 1, 5, "i", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r35 = i0.ɵɵreference(8);
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("ex-" + ctx_r12.iconCss);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c11$6, ctx_r12.selectedCodesDisplay.length > 0, ctx_r12.iconSide == "left"))("exTooltip", ctx_r12.disabled ? i0.ɵɵpipeBind1(2, 10, ctx_r12.disabledTooltip) : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r12.openToSide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c12$5, ctx_r12.selectedCodesDisplay.length > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.placeholder && !ctx_r12.selectedOption && ctx_r12.selectedCodesDisplay.length === 0 || ctx_r12.isMultiSelect && ctx_r12.selectedValues.length === 0 || ctx_r12.showOnlyPlaceholder)("ngIfElse", _r35);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r12.isHovered || (ctx_r12.menuTrigger == null ? null : ctx_r12.menuTrigger.menuOpen)) && ctx_r12.isMultiSelect || ctx_r12.selectedCodesDisplay.length === 0);
} }
const _c13$5 = function (a0) { return { "ex-combobox-flex-wrapper": a0 }; };
function ExComboboxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ExComboboxComponent_div_0_label_1_Template, 3, 7, "label", 7);
    i0.ɵɵelementContainer(2, 4);
    i0.ɵɵtemplate(3, ExComboboxComponent_div_0_ng_template_3_Template, 1, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ExComboboxComponent_div_0_ng_template_5_Template, 1, 2, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ExComboboxComponent_div_0_ng_template_7_Template, 10, 17, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(4);
    const _r9 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c13$5, ctx_r0.label))("id", ctx_r0.comboboxId);
    i0.ɵɵattribute("aria-expanded", ctx_r0.isMenuOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.openToSide ? _r9 : _r7);
} }
function ExComboboxComponent_ng_template_1_span_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r53.selectedGroup, ":");
} }
function ExComboboxComponent_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵtemplate(1, ExComboboxComponent_ng_template_1_span_0_span_1_Template, 2, 1, "span", 44);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r50.multiLevel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r50.selectedOption), " ");
} }
function ExComboboxComponent_ng_template_1_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r54.notDefinedLabelViewMode));
} }
function ExComboboxComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExComboboxComponent_ng_template_1_ng_template_1_span_0_Template, 3, 3, "span", 45);
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r52.notDefinedLabelViewMode);
} }
function ExComboboxComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExComboboxComponent_ng_template_1_span_0_Template, 4, 4, "span", 41);
    i0.ɵɵtemplate(1, ExComboboxComponent_ng_template_1_ng_template_1_Template, 1, 1, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r51 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.selectedOption)("ngIfElse", _r51);
} }
function ExComboboxComponent_ng_template_6_ex_search_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-search", 51, 52);
    i0.ɵɵlistener("enterKeyup", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_enterKeyup_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r57.onEnterPressed()); })("keydown.tab", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_keydown_tab_0_listener($event) { return $event.stopPropagation(); })("click", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_click_0_listener($event) { return $event.stopPropagation(); })("keydown", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_keydown_0_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r61 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r61.searchKeyDown($event)); })("searchTriggered", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_searchTriggered_0_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r62 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r62.searchTextChange($event)); })("searchTextChange", function ExComboboxComponent_ng_template_6_ex_search_1_Template_ex_search_searchTextChange_0_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r63 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r63.searchText = $event); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 6, "ng.combobox-search-placeholder"));
    i0.ɵɵproperty("incremental", true)("inputAriaActiveDescendant", ctx_r55.activeOptionId)("isLoading", ctx_r55.searchLoading)("disableWhenLoading", false)("searchText", ctx_r55.searchText);
} }
function ExComboboxComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, ExComboboxComponent_ng_template_6_ex_search_1_Template, 3, 8, "ex-search", 48);
    i0.ɵɵelementStart(2, "div", 49);
    i0.ɵɵlistener("keydown", function ExComboboxComponent_ng_template_6_Template_div_keydown_2_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r64.onKeydown($event)); });
    i0.ɵɵelementStart(3, "ex-group-outlet", 50);
    i0.ɵɵlistener("selectedValueChange", function ExComboboxComponent_ng_template_6_Template_ex_group_outlet_selectedValueChange_3_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r66.selectedValueChanged($event)); })("itemClick", function ExComboboxComponent_ng_template_6_Template_ex_group_outlet_itemClick_3_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r67 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r67.onItemClicked($event)); })("selectedOptionIdChange", function ExComboboxComponent_ng_template_6_Template_ex_group_outlet_selectedOptionIdChange_3_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r68 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r68.selectedOptionIdChanged($event)); })("focusSeachBox", function ExComboboxComponent_ng_template_6_Template_ex_group_outlet_focusSeachBox_3_listener() { i0.ɵɵrestoreView(_r65); const ctx_r69 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r69.focus()); })("activeOptionIdChange", function ExComboboxComponent_ng_template_6_Template_ex_group_outlet_activeOptionIdChange_3_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r70 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r70.activeOptionIdChanged($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.displaySearchBox);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-labelledby", ctx_r5.inputAriaLabel.length > 0 ? null : ctx_r5.comboboxId + "LabelId")("aria-label", ctx_r5.inputAriaLabel.length > 0 ? ctx_r5.inputAriaLabel : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r5.filteredItems)("sort", ctx_r5.sort)("hasStickyHeaders", ctx_r5.hasStickyHeaders)("searchText", ctx_r5.searchText)("selectedOptionId", ctx_r5.selectedOptionId)("selectedValue", ctx_r5.selectedValue)("highlightSelected", ctx_r5.highlightSelected)("showCheckOnSelected", ctx_r5.showCheckOnSelected)("description", ctx_r5.description)("comboboxId", ctx_r5.comboboxId)("disableAutoClose", ctx_r5.disableAutoClose);
} }
const _c14$5 = [[["", "icon", ""]]];
const _c15$5 = ["[icon]"];
class ExComboboxComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
          * The items of the combobox
          * the data format is as following:
          * {
          *   itemName: { key: string, value: string },
          *   subItems?: ComboboxItemData[],
          *   expanded?: boolean
          * }[]; - for all types - multi and single levels
          */
        this.items = [];
        /**
         * data format: {group?: string, item: string}
         * for multi-level send both and single level only item
         */
        this.selectedValue = null;
        /**
         * data format: {group?: string, item: string}[]
         * for multi-level send both and single level only item, in case of multi-selection
         */
        this.selectedValues = [];
        /**
         * combo box icon style
         */
        this.iconCss = 'uxf-down-caret';
        /**
         * combo box icon side right/left
         */
        this.iconSide = 'right';
        /**
         * true if a blank "None" line is wanted
         */
        this.addBlankOption = false;
        /**
         * shall the headers stick to the top
         */
        this.hasStickyHeaders = false;
        /**
         * use for a combobox with multi-selection
         * */
        this.isMultiSelect = false;
        /**
         * display a check mark next to selected item/s
         */
        this.showCheckOnSelected = false;
        /**
         * disable the drawer auto close behavior
         */
        this.disableAutoClose = false;
        this.placeholder = 'ng.general.select_value';
        this.showOnlyPlaceholder = false;
        this.showOnlyAutoSelect = false;
        /**
         * selected value change control from lib component(true)
         * or from calling component(false) and change by selectedValue Input value
         */
        this.selectedChangeControl = true;
        /**
         * if true the button will take all the remaining place of its container
         */
        this.full = false;
        /**
         * if true the combobox will have a border
         */
        this.hasBorder = false;
        /**
         * set to true to display group label
         */
        this.showGroupLabel = false;
        /**
         * if user must choose a value
         */
        this.mandatory = false;
        /**
         * highlight selected option
         */
        this.highlightSelected = false;
        /**
         * display search box and supports search filter
         */
        this.displaySearchBox = true;
        /**
         * display search box and supports search filter
         */
        this.selectedFontSize = 'regular';
        /**
         * if true a red border will be shown
         */
        this.showWarning = false;
        /**
         * display selected group and option in view mode (simple label)
         */
        this.viewMode = false;
        /**
         * Combobox width
         */
        this.width = "";
        /**
         * label to display in view mode when there is no selected option
         */
        this.notDefinedLabelViewMode = 'ng.general.undefined_value';
        /**
         * display group name on multi-level selected item
         */
        this.showSelectedGroupName = true;
        this.allowUnlistedValues = false;
        this.inputAriaLabel = '';
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData
         */
        this.selectedValueChange = new EventEmitter();
        this._selectedValueChange = new EventEmitter();
        /**
         * event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData, in multise
         */
        this.selectedValuesChange = new EventEmitter();
        this._selectedValuesChange = new EventEmitter();
        /**
         * used in multi-selection with a remove button on the items
         */
        this.selectedValueRemoved = new EventEmitter();
        /**
         * event fired whenever the search button is clicked or when the user type - depend on the incremental parameter
         */
        this.searchTriggered = new EventEmitter();
        this.comboboxTextToolTip = '';
        this.selectedOption = null;
        this.selectedGroup = null;
        this.isHovered = false;
        this.isFocused = false;
        this.selectedCodesDisplay = [];
        this.multiLevel = false;
        this.searchText = '';
        this.searchLoading = false;
        this.filteredItems = [];
        this.selectedItemID = '';
        /**
         * whether to open the mat-menu to the side of the trigger
         */
        this.openToSide = false;
        this._dir = "ltr";
        this.triggerAtStart = false;
        this.triggerSideToggled = false;
        this.search = new Subject();
        // for accessibility
        this.comboboxId = null;
        this.selectedOptionId = null;
        this.activeOptionId = null;
        this.activeOptionIdData = null;
        this.isMenuOpen = false;
        this.filterItems = (opt, value) => {
            const filterValue = value.toLowerCase();
            return opt.filter(item => item.itemName.value.toLowerCase().indexOf(filterValue) !== -1);
        };
        console.warn('the ex-combobox component is deprecated please use ex-new-combobox instead');
    }
    ngOnInit() {
        if (this.addBlankOption) {
            this.items.unshift({ itemName: { key: null, value: 'ng.general.none' } });
        }
        this.initDatasource();
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.handleItemsChanged();
        }
        if (changes.hasOwnProperty('selectedValue')) {
            this.handleSelectedValueChanged();
        }
        if (changes.hasOwnProperty('selectedValues')) {
            this.handleSelectedValuesChanged();
        }
    }
    initDatasource() {
        if (!this.datasource)
            return;
        this.search.pipe(debounceTime(200), filter(() => this.searchText?.length >= 3), tap(() => this.searchLoading = true), switchMap(() => this.datasource(this.searchText).pipe(catchError(e => of(console.error(e))))), finalize(() => this.searchLoading = false)).subscribe((items) => {
            this.items = items ?? [];
            this.handleItemsChanged();
            this.searchLoading = false;
        });
    }
    handleItemsChanged() {
        this.filter(null);
        this.expandIfOnlyOneGroup();
        if (this.items && !this.datasource) {
            this.findSelectedOption(this.items);
        }
        this.setComboboxId();
    }
    handleSelectedValueChanged() {
        for (const item of this.items) {
            if (item.subItems != null && item.subItems.length !== 0) {
                this.multiLevel = true;
            }
        }
        if (this.selectedValues && this.selectedValues.length > 0) {
            this.handleSelectedValuesChanged();
        }
        if (this.selectedValue) {
            if (!this.multiLevel) {
                this.findSelectedOption(this.items);
            }
            else {
                const group = this.findSelectedGroup(this.items, this.selectedValue.group);
                this.findSelectedOption(group);
            }
            this.comboboxTextToolTip = this.selectedOption;
            this.selectedOptionId = this.selectedOption?.toString().replace(' ', '_');
        }
        else {
            this.selectedGroup = null;
            this.selectedOption = null;
            this.comboboxTextToolTip = '';
        }
    }
    handleSelectedValuesChanged() {
        this.findSelectedDisplayOption();
    }
    findSelectedDisplayOption() {
        this.selectedCodesDisplay = [];
        this.selectedValues.forEach((element) => {
            let selectedGroup;
            if (element.group) {
                selectedGroup = this.items.find(item => item.subItems && item.subItems.length !== 0 &&
                    (item.itemName.key === element.group
                        || item.itemName.value === element.group));
            }
            if (selectedGroup) {
                const selectedOption = selectedGroup.subItems.find(item => item.itemName.key === element.item
                    || item.itemName.value === element.item);
                if (selectedOption) {
                    this.selectedCodesDisplay.push({ option: selectedOption.itemName.value, group: selectedGroup.itemName.value, color: element.color, key: selectedOption.itemName.key });
                }
            }
            else if (this.noGroup && !element.group) {
                let selectedOption;
                this.items.forEach((item) => {
                    if (item.subItems && item.subItems.length !== 0) {
                        let tmpSelectedOption = item.subItems.find(subItem => subItem.itemName.key === element.item);
                        if (tmpSelectedOption) {
                            selectedOption = tmpSelectedOption;
                            selectedGroup = {
                                itemName: {
                                    key: item.itemName.key,
                                    value: item.itemName.value
                                }
                            };
                        }
                    }
                });
                if (selectedGroup && selectedOption) {
                    this.selectedCodesDisplay.push({ option: selectedOption.itemName.value, group: selectedGroup.itemName.value, color: element.color, key: selectedOption.itemName.key });
                }
            }
            if (this.noGroup) {
                const selectedOption = this.items.find(item => item.itemName.key === element.item
                    || item.itemName.value === element.item);
                if (selectedOption) {
                    this.selectedCodesDisplay.push({ option: selectedOption.itemName.value, group: selectedOption.itemName.value, key: selectedOption.itemName.key });
                }
            }
        });
    }
    findSelectedOption(items) {
        if (!this.selectedValue)
            return;
        const selectedOption = items?.find(group => group.itemName.key === this.selectedValue.item
            || group.itemName.value === this.selectedValue.item);
        this.selectedOption = selectedOption?.itemName.value;
        if (!this.selectedOption) {
            const { item, value } = this.selectedValue;
            this.selectedOption = value ?? item;
        }
    }
    findSelectedGroup(items, value) {
        for (const item of items) {
            if (item.subItems && item.subItems.length !== 0) {
                if (item.itemName.key === value) {
                    this.selectedGroup = item.itemName.value;
                    return item.subItems;
                }
                const group = this.findSelectedGroup(item.subItems, value);
                if (group) {
                    return group;
                }
            }
        }
    }
    selectedValueChanged(e) {
        //For closing the menu on selected value
        !this.disableAutoClose && this.menuTrigger.closeMenu();
        const { key: item, value } = e?.itemName;
        const isHistoryItem = e?.isHistoryItem;
        if (this.selectedChangeControl) {
            this.comboboxTextToolTip = value;
        }
        if (this.selectedValue != null) {
            this.selectedValue.item = e.itemName.key;
        }
        const emitValue = { group: this.selectedGroup, item, value, isHistoryItem };
        if (!this.isMultiSelect) {
            this.selectedValueChange.emit(e);
            if (item != null) {
                this._selectedValueChange.emit(emitValue);
            }
            else {
                this._selectedValueChange.emit(null);
            }
        }
        else {
            this.selectedValuesChange.emit(emitValue);
            // this._selectedValuesChange.emit();
        }
    }
    onItemClicked(e) {
        if (!this.selectedChangeControl)
            return;
        this.selectedGroup = e.group;
        this.selectedOption = e.option;
        if (this.isMultiSelect) {
            if (this.noGroup) {
                const itemIndex = this.selectedCodesDisplay.findIndex(repCode => repCode.option === e.option);
                if (itemIndex !== -1) {
                    this.selectedCodesDisplay[itemIndex].option = e.option;
                }
                else {
                    this.selectedCodesDisplay.push({ group: e.group, option: e.option, key: e.key });
                    this.selectedCodesDisplay.sort((a, b) => a.group.localeCompare(b.group));
                }
            }
            else {
                const index = this.selectedCodesDisplay.findIndex(repCode => repCode.group === e.group);
                if (index !== -1) {
                    this.selectedCodesDisplay[index].option = e.option;
                }
                else {
                    this.selectedCodesDisplay.push({ group: e.group, option: e.option, key: e.key });
                    this.selectedCodesDisplay.sort((a, b) => a.group.localeCompare(b.group));
                }
            }
        }
    }
    onKeyDown(event) {
        if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90)) {
            event.stopPropagation();
        }
        if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90)) {
            event.stopPropagation();
        }
    }
    searchTextChange(text) {
        this.searchText = text;
        this.filter(text);
        this.searchTriggered.emit(this.searchText);
        this.search.next();
    }
    reset() {
        this.searchTextChange('');
        this.isMenuOpen = false;
    }
    focus() {
        if (this.displaySearchBox && this.searchBox) {
            this.searchBox.input.nativeElement.focus();
        }
        this.isMenuOpen = true;
    }
    filter(value) {
        if (value?.length > 0) {
            this.filteredItems = JSON.parse(JSON.stringify(this.items));
            this.filteredItems = this.filterLevels(value, this.filteredItems);
        }
        else {
            this.filteredItems = this.items;
        }
    }
    filterLevels(value, items) {
        for (const item of items) {
            if (!item.subItems || item.subItems.length === 0) {
                return items = this.filterItems(items, value);
            }
            item.subItems = this.filterLevels(value, item.subItems);
            items = items.filter(group => group.subItems.length > 0);
            items.map(group => group.expanded = true);
        }
        return items;
    }
    expandIfOnlyOneGroup() {
        if (this.items.length === 1) {
            this.items[0].expanded = true;
        }
    }
    remove(selected) {
        event.stopPropagation();
        event.preventDefault();
        const index = this.selectedCodesDisplay.findIndex(repCode => repCode.group === selected.group);
        this.selectedValueRemoved.emit({ group: selected.group, item: selected.item, key: selected.key });
        this.selectedOption = null;
        this.comboboxTextToolTip = '';
    }
    open() {
        this.menuTrigger.openMenu();
    }
    onClose() {
        if (this.datasource) {
            this.items = [];
            this.handleItemsChanged();
        }
        this.onBlur();
    }
    writeValue(value) {
        if (!value && !this.selectedValue && !this.selectedValues)
            return;
        if (this.isMultiSelect) {
            this.selectedValues = value;
            this.handleSelectedValuesChanged();
        }
        else {
            this.selectedValue = value;
            this.handleSelectedValueChanged();
        }
    }
    setValidState(isValid) {
        this.showWarning = !isValid;
    }
    onEnterPressed() {
        if (this.allowUnlistedValues
            && this.displaySearchBox
            && this.searchText?.trim().length > 0) {
            const value = this.searchText.trim();
            this.selectedValue = { item: value, value };
            this.selectedOption = this.selectedValue.value;
            this.selectedValueChanged({ itemName: { key: value, value } });
            this.handleSelectedValueChanged();
            if (!this.disableAutoClose) {
                this.menuTrigger.closeMenu();
                this.reset();
            }
        }
    }
    onSideMenuOpened() {
        if (this.triggerSideToggled) {
            this.focus();
            this.triggerSideToggled = false;
            return;
        }
        const matMenuPanel = document.getElementById(this.matMenu.panelId);
        if (matMenuPanel)
            matMenuPanel.style.visibility = "hidden";
        let triggerElemRect;
        let menuElemRect;
        setTimeout(() => {
            menuElemRect = this.elementBounds(this.menuContentElem.nativeElement);
            triggerElemRect = this.elementBounds(this.triggerElem.nativeElement);
            if (this._dir == "ltr" ? (menuElemRect?.left - triggerElemRect?.left) < -1 : (menuElemRect?.right - triggerElemRect?.right) > 1) {
                this.toggleTriggerSide();
            }
            else {
                setTimeout(() => {
                    this.focus();
                }, 0);
            }
            if (matMenuPanel)
                matMenuPanel.style.visibility = "visible";
        }, 0);
    }
    toggleTriggerSide() {
        this.trigger.closeMenu();
        this.triggerAtStart = !this.triggerAtStart;
        this.triggerSideToggled = true;
        this.trigger.openMenu();
    }
    onSideMenuClosed() {
        this.triggerAtStart = false;
        this.reset();
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { left, right } = el.getBoundingClientRect();
        return {
            right: right,
            left: left,
        };
    }
    ///////// Accessibility functions ////////
    // the selected option that appears on the combobox
    selectedOptionIdChanged(selectedId) {
        this.selectedOptionId = selectedId;
    }
    // the current item that has the keyboards focus
    activeOptionIdChanged(data) {
        this.activeOptionIdData = data;
        this.activeOptionId = data.comboboxId;
        if (data.groupIndex !== null) {
            this.activeOptionId += ('_' + data.groupIndex);
        }
        this.activeOptionId += '_' + data.i;
    }
    // manages the Up and Down keyboard navigation of the LOWEST level
    onKeydown(event) {
        let activeElement = document.getElementById(this.activeOptionId);
        switch (event.key) {
            case "ArrowUp":
                // if this is not the first item in the list
                if (activeElement.previousElementSibling) {
                    activeElement.previousElementSibling?.focus();
                }
                else {
                    // if this is the first item in the list that is under a group then moving focus to group header. else - moving focus to search box
                    if (this.activeOptionIdData.groupIndex !== null) {
                        let nextActiveHeader = this.comboboxId + 'Group_' + (this.activeOptionIdData.groupIndex);
                        document.getElementById(nextActiveHeader)?.focus();
                    }
                    else {
                        this.focus();
                    }
                }
                break;
            case "ArrowDown":
                // if this is not the last item in the list
                if (activeElement.nextElementSibling) {
                    activeElement.nextElementSibling?.focus();
                }
                else {
                    // if this is the last item in the list that is under a group then moving focus to next group header.
                    if (this.activeOptionIdData.groupIndex !== null) {
                        let nextActiveHeader = this.comboboxId + 'Group_' + (this.activeOptionIdData.groupIndex + 1);
                        document.getElementById(nextActiveHeader)?.focus();
                    }
                }
                break;
        }
    }
    // we need to create a unique ID for combobox - would be the label if there is no label the first item and if no items would be the placeholder
    setComboboxId() {
        if (this.label) {
            this.comboboxId = this.label.replace(' ', '');
        }
        else if (this.items.length > 0) {
            this.comboboxId = this.items[0].itemName.key.toString().replace(' ', '');
        }
        else {
            if (this.placeholder) {
                this.comboboxId = this.placeholder.replace(' ', '');
            }
        }
        this.selectedItemID = this.comboboxId + this.items.findIndex(item => item.itemName.key === this.selectedValue?.item);
    }
    // handles the keyboard navigation from the search box to the list
    searchKeyDown(e) {
        if (e.code === "ArrowDown") {
            // if we have groups moving focus to first group header
            if (!this.multiLevel) {
                document.getElementById(this.comboboxId + '_0').focus();
                this.activeOptionId = this.comboboxId + '_0';
            }
            else {
                // if there are no groups moving focus to first item in the list
                document.getElementById(this.comboboxId + 'Group_0').focus();
                this.activeOptionId = this.comboboxId + 'Group_0';
            }
        }
    }
    static { this.ɵfac = function ExComboboxComponent_Factory(t) { return new (t || ExComboboxComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComboboxComponent, selectors: [["ex-combobox"]], viewQuery: function ExComboboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1w, 5);
            i0.ɵɵviewQuery(_c1$Y, 5);
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(_c1$Y, 5, ElementRef);
            i0.ɵɵviewQuery(_c2$E, 5);
            i0.ɵɵviewQuery(_c3$v, 5, ElementRef);
            i0.ɵɵviewQuery(_c4$p, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuContentElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t);
        } }, hostBindings: function ExComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("_selectedValueChange", function ExComboboxComponent__selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("_selectedValuesChange", function ExComboboxComponent__selectedValuesChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExComboboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { items: "items", datasource: "datasource", selectedValue: "selectedValue", selectedValues: "selectedValues", iconCss: "iconCss", iconSide: "iconSide", addBlankOption: "addBlankOption", hasStickyHeaders: "hasStickyHeaders", isMultiSelect: "isMultiSelect", showCheckOnSelected: "showCheckOnSelected", disableAutoClose: "disableAutoClose", placeholder: "placeholder", showOnlyPlaceholder: "showOnlyPlaceholder", showOnlyAutoSelect: "showOnlyAutoSelect", selectedChangeControl: "selectedChangeControl", full: "full", hasBorder: "hasBorder", sort: "sort", disabledTooltip: "disabledTooltip", noGroup: "noGroup", showGroupLabel: "showGroupLabel", mandatory: "mandatory", highlightSelected: "highlightSelected", displaySearchBox: "displaySearchBox", selectedFontSize: "selectedFontSize", label: "label", description: "description", showWarning: "showWarning", viewMode: "viewMode", width: "width", notDefinedLabelViewMode: "notDefinedLabelViewMode", showSelectedGroupName: "showSelectedGroupName", allowUnlistedValues: "allowUnlistedValues", inputAriaLabel: "inputAriaLabel", openToSide: "openToSide" }, outputs: { selectedValueChange: "selectedValueChange", _selectedValueChange: "_selectedValueChange", selectedValuesChange: "selectedValuesChange", _selectedValuesChange: "_selectedValuesChange", selectedValueRemoved: "selectedValueRemoved", searchTriggered: "searchTriggered" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExComboboxComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c15$5, decls: 8, vars: 3, consts: [["attr.aria-haspopup", "listbox", "attr.aria-ownes", "listboxId", 3, "ngClass", "id", 4, "ngIf", "ngIfElse"], ["view", ""], [3, "close"], ["menu", "matMenu"], [3, "ngTemplateOutlet"], ["matMenuContent", ""], ["attr.aria-haspopup", "listbox", "attr.aria-ownes", "listboxId", 3, "ngClass", "id"], ["class", "ex-combobox-label", 3, "id", "ngClass", "click", 4, "ngIf"], ["triggerButtonVertical", ""], ["triggerButtonHorizontal", ""], ["buttonContent", ""], [1, "ex-combobox-label", 3, "id", "ngClass", "click"], ["role", "combobox", "mat-button", "", "class", "ex-combobox-button sel-ex-combobox-selected-button", 3, "ex-combobox-border", "matMenuTriggerFor", "exTooltip", "width", "disabled", "border-width", "ngClass", "mouseenter", "mouseleave", "menuClosed", "menuOpened", 4, "ngIf", "ngIfElse"], ["role", "combobox", "mat-button", "", 1, "ex-combobox-button", "sel-ex-combobox-selected-button", 3, "matMenuTriggerFor", "exTooltip", "disabled", "ngClass", "mouseenter", "mouseleave", "menuClosed", "menuOpened"], ["menuTrigger", "matMenuTrigger", "tooltip", "exTooltip"], ["role", "combobox", "mat-button", "", "class", "ex-combobox-button button-side-trigger sel-ex-combobox-selected-button", 3, "exTooltip", "width", "disabled", "border-width", "ngClass", "mouseenter", "mouseleave", "click", 4, "ngIf", "ngIfElse"], ["role", "combobox", "mat-button", "", 1, "ex-combobox-button", "button-side-trigger", "sel-ex-combobox-selected-button", 3, "exTooltip", "disabled", "ngClass", "mouseenter", "mouseleave", "click"], ["tooltip", "exTooltip"], [1, "ex-combobox-side-trigger", 3, "matMenuTriggerFor", "ngClass", "menuOpened", "menuClosed"], ["menuTrigger", "matMenuTrigger"], [1, "ex-combobox-selected-wrapper", 3, "ngClass", "exTooltip"], [4, "ngIf"], [1, "ex-combobox-selected-text-wrapper", 3, "ngClass"], ["class", "ex-combobox-mandatory-asterisk", 4, "ngIf"], ["class", "sel-combobox-selected-value sel-combobox-selected-value-placeholder", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["selected", ""], ["class", "uxf-icon  sel-combobox-arrow ", 3, "ex-combobox-arrow-multi", "ex-combobox-arrow", "ngClass", 4, "ngIf"], [1, "ex-combobox-mandatory-asterisk"], [1, "sel-combobox-selected-value", "sel-combobox-selected-value-placeholder", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["singleSelection", ""], [1, "ex-combobox-selected-list-wrapper"], [1, "ex-combobox-selected-list-chips", 3, "ngClass"], [3, "class", "background", 4, "ngFor", "ngForOf"], [3, "class", 4, "ngIf"], ["class", "ex-combobox-selected-remove", "size", "small", 3, "tooltip", "closeClicked", 4, "ngIf"], ["size", "small", 1, "ex-combobox-selected-remove", 3, "tooltip", "closeClicked"], [1, "ex-combobox-selected", "sel-combobox-selected-value", 3, "ngClass"], ["class", "ex-combobox-selected-group  sel-combobox-selected-group-value", 4, "ngIf"], [1, "ex-combobox-selected-group", "sel-combobox-selected-group-value"], [1, "uxf-icon", "sel-combobox-arrow", 3, "ngClass"], ["class", "ex-combobox-view-mode  sel-combobox-selected-value", 4, "ngIf", "ngIfElse"], ["notSelected", ""], [1, "ex-combobox-view-mode", "sel-combobox-selected-value"], ["class", "ex-combobox-selected-group sel-combobox-selected-group-value", 4, "ngIf"], ["class", "ex-combobox-view-mode ex-combobox-view-mode-not-defined", 4, "ngIf"], [1, "ex-combobox-view-mode", "ex-combobox-view-mode-not-defined"], [1, "ex-combobox-menu-wrapper"], ["class", "ex-combobox-textbox", "inputAriaControlsId", "listboxId", 3, "incremental", "inputAriaActiveDescendant", "isLoading", "disableWhenLoading", "searchText", "placeholder", "enterKeyup", "keydown.tab", "click", "keydown", "searchTriggered", "searchTextChange", 4, "ngIf"], ["role", "listbox", "id", "listboxId", 1, "ex-combobox-options-wrapper", 3, "keydown"], [3, "items", "sort", "hasStickyHeaders", "searchText", "selectedOptionId", "selectedValue", "highlightSelected", "showCheckOnSelected", "description", "comboboxId", "disableAutoClose", "selectedValueChange", "itemClick", "selectedOptionIdChange", "focusSeachBox", "activeOptionIdChange"], ["inputAriaControlsId", "listboxId", 1, "ex-combobox-textbox", 3, "incremental", "inputAriaActiveDescendant", "isLoading", "disableWhenLoading", "searchText", "placeholder", "enterKeyup", "keydown.tab", "click", "keydown", "searchTriggered", "searchTextChange"], ["input", ""]], template: function ExComboboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c14$5);
            i0.ɵɵtemplate(0, ExComboboxComponent_div_0_Template, 9, 7, "div", 0);
            i0.ɵɵtemplate(1, ExComboboxComponent_ng_template_1_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(3, "mat-menu", 2, 3);
            i0.ɵɵlistener("close", function ExComboboxComponent_Template_mat_menu_close_3_listener() { return ctx.onClose(); });
            i0.ɵɵelementContainer(5, 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, ExComboboxComponent_ng_template_6_Template, 4, 14, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r4 = i0.ɵɵreference(7);
            i0.ɵɵproperty("ngIf", !ctx.showOnlyAutoSelect)("ngIfElse", _r4);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngTemplateOutlet", _r4);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i3$3.MatButton, i3$1.MatMenu, i3$1.MatMenuTrigger, ExTooltipDirective, ExSearchComponent, ExCloseComponent, ExGroupOutletComponent, i1$2.TranslatePipe], styles: [".ex-combobox-flex-wrapper[_ngcontent-%COMP%]{display:flex;align-items:baseline}.ex-combobox-warning[_ngcontent-%COMP%]{border-width:2px!important;border-style:solid!important}.ex-combobox-label[_ngcontent-%COMP%]{margin-top:7px}.no-group-combo-list[_ngcontent-%COMP%]{display:flex;flex-direction:row!important}.ex-combobox-multi-label[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-combobox-button[_ngcontent-%COMP%]{max-width:100%;overflow:hidden;text-align:left;border-style:solid;min-width:unset}.ex-combobox-arrow-multi[_ngcontent-%COMP%]{margin-top:5px!important;inset-inline-end:0px}.ex-combobox-view-mode[_ngcontent-%COMP%]{padding:5px 10px;display:flex;line-height:19px}.ex-combobox-view-mode-not-defined[_ngcontent-%COMP%]{font-style:italic;color:#9c9c9c}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;align-items:flex-start}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]{display:flex;overflow:hidden;align-items:center;white-space:normal}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   .ex-combobox-mandatory-asterisk[_ngcontent-%COMP%]{margin-bottom:0!important}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-icon[_ngcontent-%COMP%]{margin-inline-start:5px}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;line-height:normal;padding-block:8px}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected.ex-combobox-disabled[_ngcontent-%COMP%]{opacity:.5}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-arrow[_ngcontent-%COMP%]{margin-inline-start:5px;direction:inherit;align-self:flex-start;margin-block-start:8px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-textbox[_ngcontent-%COMP%]{padding:10px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-options-wrapper[_ngcontent-%COMP%]{width:280px;padding-bottom:5px;max-height:270px;max-width:300px;overflow-y:auto;overflow-x:hidden}.ex-combobox-selected-list-wrapper[_ngcontent-%COMP%]{min-height:34px;margin-bottom:2px;cursor:pointer;padding:3px 0 0;display:flex;max-height:300px}.ex-combobox-selected-wrapper-multi[_ngcontent-%COMP%]{padding:0!important}.ex-comboBox-reverese[_ngcontent-%COMP%]{flex-direction:row-reverse;margin-inline-end:10px}.ex-uxf-plus-circle[_ngcontent-%COMP%]{color:#4164a4}.ex-combobox-button-border[_ngcontent-%COMP%]{border-width:1px!important;border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent!important;border-style:solid;padding-inline-start:0px!important}.ex-combobox-border[_ngcontent-%COMP%]{border:1px solid #ccc!important;border-radius:5px!important}.ex-combobox-border[_ngcontent-%COMP%]:hover{border:1px solid #898989!important}.ex-combobox-border[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba!important;outline:none!important}.ex-combobox-border[_ngcontent-%COMP%]:focus-within{border:2px solid #0e7bba!important;outline:none!important}.ex-combobox-multi-select[_ngcontent-%COMP%]{border-color:#ccc9!important}.ex-combobox-multi-text-wrapper[_ngcontent-%COMP%]{min-width:248px;width:-moz-fit-content;width:fit-content}.ex-combobox-selected-list-chips[_ngcontent-%COMP%]{flex:1;flex-wrap:wrap;flex-direction:column}.ex-combobox-selected-list-chips[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:pointer!important}.ex-combobox-selected-list-chips[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:5px}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;line-height:21px;align-items:center;margin-bottom:1px}.ex-combobox-selected-no-group-chip-wrapper[_ngcontent-%COMP%]{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:30px;align-items:center;margin-inline-end:12px;margin-bottom:12px}.ex-combobox-chip-label[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding-right:5px;padding-left:5px;margin:5px;margin-inline-end:0px;cursor:pointer!important}.ex-combobox-chip-no-group-label[_ngcontent-%COMP%]{justify-content:space-between;padding-inline-start:5px;margin:5px;margin-inline-end:0px;cursor:pointer!important}.ex-combobox-selected-remove[_ngcontent-%COMP%]{margin-bottom:4px}.sel-ex-combobox-selected-button[_ngcontent-%COMP%]:enabled:hover{background-color:#e5e5e5}.ex-combobox-button.button-side-trigger[_ngcontent-%COMP%]{position:relative;width:100%!important;padding-inline-end:0px!important}.ex-combobox-button.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]{position:absolute;top:0}.ex-combobox-button.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]:not(.ex-combobox-side-trigger-start){inset-inline-end:-1px}.ex-combobox-button.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger.ex-combobox-side-trigger-start[_ngcontent-%COMP%]{inset-inline-start:-1px}"], data: { animation: Animations$8 } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-combobox', animations: Animations$8, host: {
                    '(_selectedValueChange)': 'controlOnChange($event)',
                    '(_selectedValuesChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExComboboxComponent), template: "<div *ngIf=\"!showOnlyAutoSelect;else matMenuContent\" [ngClass]=\"{ 'ex-combobox-flex-wrapper': label }\" [attr.aria-expanded]=\"isMenuOpen\"\n  attr.aria-haspopup=\"listbox\" [id]=\"comboboxId\"\n  attr.aria-ownes=\"listboxId\">\n  <label *ngIf=\"label\" class=\"ex-combobox-label\" (click)=\"$event.stopPropagation();\" id=\"{{comboboxId}}LabelId\"\n    [ngClass]=\"{'ex-combobox-multi-label': isMultiSelect}\">{{ label | translate }}:</label>\n\n  <ng-container [ngTemplateOutlet]=\"openToSide ? triggerButtonHorizontal : triggerButtonVertical \"></ng-container>\n\n  <ng-template #triggerButtonVertical>\n    <button role=\"combobox\" *ngIf=\"!(viewMode || isReadOnly); else view\" #menuTrigger=\"matMenuTrigger\" mat-button\n      (mouseenter)=\"isHovered = true\" (mouseleave)=\"isHovered = false\" [class.ex-combobox-border]=\"hasBorder\"\n      class=\"ex-combobox-button sel-ex-combobox-selected-button\" [matMenuTriggerFor]=\"menu\" (menuClosed)=\"reset()\"\n      (menuOpened)=\"focus()\" [exTooltip]=\"isMultiSelect? '' : comboboxTextToolTip | translate\"\n      [style.width]=\"full ? '100%' : 'initial'\" #tooltip=\"exTooltip\" [disabled]=\"disabled\"\n      [style.border-width]=\"hasBorder ? '1px' : '0px'\" [ngClass]=\"{'ex-combobox-warning': showWarning, 'sel-combobox-warning': showWarning,\n      'ex-combobox-multi-select': (isHovered || menuTrigger?.menuOpen) && selectedCodesDisplay.length > 0,\n      'ex-combobox-button-border' : isMultiSelect }\"\n      [attr.aria-labelledby]=\"inputAriaLabel.length > 0 ? null : comboboxId + 'LabelId'\" [attr.aria-label]=\"inputAriaLabel.length > 0 ? inputAriaLabel : null\"\n      [attr.aria-activedescendant]=\"selectedItemID\" >\n\n      <ng-container [ngTemplateOutlet]=\"buttonContent\"></ng-container>\n\n    </button>\n  </ng-template>\n\n  <ng-template #triggerButtonHorizontal>\n    <button role=\"combobox\" *ngIf=\"!(viewMode || isReadOnly); else view\" mat-button (mouseenter)=\"isHovered = true\" (mouseleave)=\"isHovered = false\"\n      class=\"ex-combobox-button button-side-trigger sel-ex-combobox-selected-button\" (click)=\"menuTrigger.openMenu()\"\n      [exTooltip]=\"isMultiSelect? '' : comboboxTextToolTip | translate\" [style.width]=\"full ? '100%' : 'initial'\"\n      #tooltip=\"exTooltip\" [disabled]=\"disabled\" [style.border-width]=\"hasBorder ? '1px' : '0px'\" [ngClass]=\"{'ex-combobox-warning': showWarning, 'sel-combobox-warning': showWarning,\n      'ex-combobox-multi-select': (isHovered || menuTrigger?.menuOpen) && selectedCodesDisplay.length > 0,\n      'ex-combobox-button-border' : isMultiSelect }\" [attr.aria-activedescendant]=\"selectedItemID\">\n\n      <ng-container [ngTemplateOutlet]=\"buttonContent\"></ng-container>\n\n      <div #menuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"menu\" class=\"ex-combobox-side-trigger\"\n        [ngClass]=\"{ 'ex-combobox-side-trigger-start': triggerAtStart }\" (menuOpened)=\"onSideMenuOpened()\"\n        (menuClosed)=\"onSideMenuClosed()\">\n      </div>\n    </button>\n  </ng-template>\n\n  <ng-template #buttonContent>\n    <div class=\"ex-combobox-selected-wrapper\" [class]=\"'ex-'+iconCss\"\n      [ngClass]=\"{'ex-combobox-selected-wrapper-multi' : selectedCodesDisplay.length > 0,'ex-comboBox-reverese' : iconSide == 'left',selectedFontSize : true}\"\n      [exTooltip]=\"disabled ? (disabledTooltip | translate) : null\" #tooltip=\"exTooltip\">\n      <ng-content *ngIf=\"!openToSide\" select=\"[icon]\"></ng-content>\n      <span class=\"ex-combobox-selected-text-wrapper\"\n        [ngClass]=\"{'ex-combobox-multi-text-wrapper' : selectedCodesDisplay.length > 0 }\">\n        <label *ngIf=\"mandatory\" class=\"ex-combobox-mandatory-asterisk\">*</label>\n        <span class=\"sel-combobox-selected-value sel-combobox-selected-value-placeholder\"\n          *ngIf=\"(placeholder && !selectedOption && selectedCodesDisplay.length === 0) || (isMultiSelect && selectedValues.length === 0) || showOnlyPlaceholder; else selected\"\n          [ngClass]=\"{ 'sel-combobox-selected-value-placeholder-disabled': disabled }\">\n          {{ placeholder | translate }}</span>\n        <ng-template #selected>\n          <div *ngIf=\"isMultiSelect; else singleSelection\">\n            <div class=\"ex-combobox-selected-list-wrapper\">\n              <div [ngClass]=\"{'no-group-combo-list': noGroup}\" class=\"ex-combobox-selected-list-chips\">\n                <div *ngFor=\"let selected of selectedCodesDisplay\" [class]=\"noGroup ?'ex-combobox-selected-no-group-chip-wrapper':\n              'ex-combobox-selected-chip-wrapper'\" [style.background]=\"selected.color || 'default'\">\n                  <label [class]=\"noGroup ?'ex-combobox-chip-no-group-label':\n                'ex-combobox-chip-label'\">\n                    <span *ngIf=\"(multiLevel && showGroupLabel) || !noGroup\"\n                      class=\"sel-combobox-multi-selected-{{ selected.group | translate }}-group-value\">{{ selected.group | translate }}:</span>\n                    <span\n                      class=\"sel-combobox-multi-selected-{{ selected.group | translate }}-option-value\">{{ selected.option | translate }}</span></label>\n                  <ex-close *ngIf=\"!(viewMode || isReadOnly || disabled)\" class=\"ex-combobox-selected-remove\" size=\"small\"\n                    (closeClicked)=\"remove(selected)\" [tooltip]=\"'ng.general.remove' | translate\"></ex-close>\n                </div>\n              </div>\n            </div>\n          </div>\n          <ng-template #singleSelection>\n            <span class=\"ex-combobox-selected sel-combobox-selected-value\"\n              [ngClass]=\"{ 'ex-combobox-disabled': disabled }\">\n              <span class=\"ex-combobox-selected-group  sel-combobox-selected-group-value\"\n                *ngIf=\"multiLevel && showSelectedGroupName\">{{ selectedGroup | translate }}: </span>\n              {{ selectedOption | translate }}\n            </span>\n          </ng-template>\n        </ng-template>\n      </span>\n      <i *ngIf=\"((isHovered || menuTrigger?.menuOpen) && isMultiSelect) || selectedCodesDisplay.length === 0\"\n        class=\"uxf-icon  sel-combobox-arrow \" [class.ex-combobox-arrow-multi]=\"selectedCodesDisplay.length > 0\"\n        [class.ex-combobox-arrow]=\"iconCss == 'uxf-down-caret'\"\n        [ngClass]=\"openToSide ? (_dir === 'ltr' ? 'uxf-right-caret' : 'uxf-left-caret') : iconCss\"></i>\n    </div>\n  </ng-template>\n</div>\n<ng-template #view>\n  <span *ngIf=\"selectedOption; else notSelected\" class=\"ex-combobox-view-mode  sel-combobox-selected-value\">\n    <span class=\"ex-combobox-selected-group sel-combobox-selected-group-value\" *ngIf=\"multiLevel\">{{ selectedGroup }}:</span>\n    {{ selectedOption | translate }}\n  </span>\n  <ng-template #notSelected>\n    <span *ngIf=\"notDefinedLabelViewMode\"\n      class=\"ex-combobox-view-mode ex-combobox-view-mode-not-defined\">{{ notDefinedLabelViewMode | translate }}</span>\n  </ng-template>\n</ng-template>\n\n\n<mat-menu #menu=\"matMenu\" (close)=\"onClose()\" >\n  <ng-container [ngTemplateOutlet]=\"matMenuContent\"></ng-container>\n</mat-menu>\n\n<ng-template #matMenuContent>\n<div class=\"ex-combobox-menu-wrapper\">\n  <ex-search #input *ngIf=\"displaySearchBox\" class=\"ex-combobox-textbox\" [incremental]=\"true\" inputAriaControlsId = \"listboxId\"\n  [inputAriaActiveDescendant]=\"activeOptionId\"\n    (enterKeyup)=\"onEnterPressed()\" (keydown.tab)=\"$event.stopPropagation()\" (click)=\"$event.stopPropagation()\"\n    (keydown)=\"searchKeyDown($event)\" [isLoading]=\"searchLoading\" [disableWhenLoading]=\"false\"\n    (searchTriggered)=\"searchTextChange($event)\" [(searchText)]=\"searchText\"\n    placeholder=\"{{ 'ng.combobox-search-placeholder' | translate }}\"></ex-search>\n  <div class=\"ex-combobox-options-wrapper\" role=\"listbox\" id=\"listboxId\" (keydown)=\"onKeydown($event)\" [attr.aria-labelledby]=\"inputAriaLabel.length > 0 ? null : comboboxId + 'LabelId'\"\n       [attr.aria-label]=\"inputAriaLabel.length > 0 ? inputAriaLabel : null\">\n    <ex-group-outlet [items]=\"filteredItems\" (selectedValueChange)=\"selectedValueChanged($event)\"\n      (itemClick)=\"onItemClicked($event)\" [sort]=\"sort\" [hasStickyHeaders]=\"hasStickyHeaders\"\n      (selectedOptionIdChange)=\"selectedOptionIdChanged($event)\" (focusSeachBox)=\"focus()\"\n      (activeOptionIdChange)=\"activeOptionIdChanged($event)\" [searchText]=\"searchText\"\n      [selectedOptionId]=\"selectedOptionId\" [selectedValue]=\"selectedValue\" [highlightSelected]=\"highlightSelected\" [showCheckOnSelected]=\"showCheckOnSelected\"\n      [description]=\"description\" [comboboxId]=\"comboboxId\" [disableAutoClose]=\"disableAutoClose\">\n    </ex-group-outlet>\n  </div>\n</div>\n</ng-template>\n", styles: [".ex-combobox-flex-wrapper{display:flex;align-items:baseline}.ex-combobox-warning{border-width:2px!important;border-style:solid!important}.ex-combobox-label{margin-top:7px}.no-group-combo-list{display:flex;flex-direction:row!important}.ex-combobox-multi-label{margin-inline-end:5px}.ex-combobox-button{max-width:100%;overflow:hidden;text-align:left;border-style:solid;min-width:unset}.ex-combobox-arrow-multi{margin-top:5px!important;inset-inline-end:0px}.ex-combobox-view-mode{padding:5px 10px;display:flex;line-height:19px}.ex-combobox-view-mode-not-defined{font-style:italic;color:#9c9c9c}.ex-combobox-selected-wrapper{width:100%;display:flex;justify-content:space-between;align-items:flex-start}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper{display:flex;overflow:hidden;align-items:center;white-space:normal}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper .ex-combobox-mandatory-asterisk{margin-bottom:0!important}.ex-combobox-selected-wrapper .ex-combobox-icon{margin-inline-start:5px}.ex-combobox-selected-wrapper .ex-combobox-selected{overflow:hidden;text-overflow:ellipsis;line-height:normal;padding-block:8px}.ex-combobox-selected-wrapper .ex-combobox-selected.ex-combobox-disabled{opacity:.5}.ex-combobox-selected-wrapper .ex-combobox-arrow{margin-inline-start:5px;direction:inherit;align-self:flex-start;margin-block-start:8px}.ex-combobox-menu-wrapper{display:flex;flex-direction:column}.ex-combobox-menu-wrapper .ex-combobox-textbox{padding:10px}.ex-combobox-menu-wrapper .ex-combobox-options-wrapper{width:280px;padding-bottom:5px;max-height:270px;max-width:300px;overflow-y:auto;overflow-x:hidden}.ex-combobox-selected-list-wrapper{min-height:34px;margin-bottom:2px;cursor:pointer;padding:3px 0 0;display:flex;max-height:300px}.ex-combobox-selected-wrapper-multi{padding:0!important}.ex-comboBox-reverese{flex-direction:row-reverse;margin-inline-end:10px}.ex-uxf-plus-circle{color:#4164a4}.ex-combobox-button-border{border-width:1px!important;border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent!important;border-style:solid;padding-inline-start:0px!important}.ex-combobox-border{border:1px solid #ccc!important;border-radius:5px!important}.ex-combobox-border:hover{border:1px solid #898989!important}.ex-combobox-border:focus{border:2px solid #0e7bba!important;outline:none!important}.ex-combobox-border:focus-within{border:2px solid #0e7bba!important;outline:none!important}.ex-combobox-multi-select{border-color:#ccc9!important}.ex-combobox-multi-text-wrapper{min-width:248px;width:-moz-fit-content;width:fit-content}.ex-combobox-selected-list-chips{flex:1;flex-wrap:wrap;flex-direction:column}.ex-combobox-selected-list-chips *{cursor:pointer!important}.ex-combobox-selected-list-chips *:not(:last-child){margin-inline-end:5px}.ex-combobox-selected-chip-wrapper{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;line-height:21px;align-items:center;margin-bottom:1px}.ex-combobox-selected-no-group-chip-wrapper{position:relative;display:flex;background:#f0f5f8;border-radius:15px;width:-moz-fit-content;width:fit-content;height:30px;align-items:center;margin-inline-end:12px;margin-bottom:12px}.ex-combobox-chip-label{display:flex;justify-content:space-between;padding-right:5px;padding-left:5px;margin:5px;margin-inline-end:0px;cursor:pointer!important}.ex-combobox-chip-no-group-label{justify-content:space-between;padding-inline-start:5px;margin:5px;margin-inline-end:0px;cursor:pointer!important}.ex-combobox-selected-remove{margin-bottom:4px}.sel-ex-combobox-selected-button:enabled:hover{background-color:#e5e5e5}.ex-combobox-button.button-side-trigger{position:relative;width:100%!important;padding-inline-end:0px!important}.ex-combobox-button.button-side-trigger .mat-mdc-menu-trigger{position:absolute;top:0}.ex-combobox-button.button-side-trigger .mat-mdc-menu-trigger:not(.ex-combobox-side-trigger-start){inset-inline-end:-1px}.ex-combobox-button.button-side-trigger .mat-mdc-menu-trigger.ex-combobox-side-trigger-start{inset-inline-start:-1px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { items: [{
            type: Input
        }], datasource: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], selectedValues: [{
            type: Input
        }], iconCss: [{
            type: Input
        }], iconSide: [{
            type: Input
        }], addBlankOption: [{
            type: Input
        }], hasStickyHeaders: [{
            type: Input
        }], isMultiSelect: [{
            type: Input
        }], showCheckOnSelected: [{
            type: Input
        }], disableAutoClose: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], showOnlyPlaceholder: [{
            type: Input
        }], showOnlyAutoSelect: [{
            type: Input
        }], tooltip: [{
            type: ViewChildren,
            args: ['tooltip']
        }], selectedChangeControl: [{
            type: Input
        }], full: [{
            type: Input
        }], hasBorder: [{
            type: Input
        }], sort: [{
            type: Input
        }], disabledTooltip: [{
            type: Input
        }], noGroup: [{
            type: Input
        }], showGroupLabel: [{
            type: Input
        }], mandatory: [{
            type: Input
        }], highlightSelected: [{
            type: Input
        }], displaySearchBox: [{
            type: Input
        }], selectedFontSize: [{
            type: Input
        }], label: [{
            type: Input
        }], description: [{
            type: Input
        }], showWarning: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], width: [{
            type: Input
        }], notDefinedLabelViewMode: [{
            type: Input
        }], showSelectedGroupName: [{
            type: Input
        }], allowUnlistedValues: [{
            type: Input
        }], inputAriaLabel: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], _selectedValueChange: [{
            type: Output
        }], selectedValuesChange: [{
            type: Output
        }], _selectedValuesChange: [{
            type: Output
        }], selectedValueRemoved: [{
            type: Output
        }], searchTriggered: [{
            type: Output
        }], searchBox: [{
            type: ViewChild,
            args: ['input']
        }], menuTrigger: [{
            type: ViewChild,
            args: ['menuTrigger']
        }], openToSide: [{
            type: Input
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], triggerElem: [{
            type: ViewChild,
            args: ['menuTrigger', { read: ElementRef }]
        }], matMenu: [{
            type: ViewChild,
            args: ['menu']
        }], menuContentElem: [{
            type: ViewChild,
            args: ['matMenuContent', { read: ElementRef }]
        }] }); })();

const _c0$1v = function (a0) { return { "withBorder": a0 }; };
const MULTI_SELECT_ALL = '.SELECT.ALL';
class ExComboboxMultiselectComponent extends ExComboboxComponent {
    constructor(translate, sectionLayoutViewModeObservable, _cdr) {
        super(sectionLayoutViewModeObservable, _cdr);
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._cdr = _cdr;
        /**
         * Mark as true when handling (and adding) 'select all' option is needed
         * In case user chooses an 'ALL' option,
         * the selected value will reflect only it and should be handled outside this component, testing against AppConstants.MULTI_SELECT_ALL
        */
        this.addSelectAllOption = false;
        this.itemsToDisplay = [];
        this.itemToParentMap = {};
        this.keyToItemMap = {};
        this.hiddenSelectedItems = {};
        console.warn('the ex-combobox-multiselect component is deprecated please use ex-new-combobox instead');
    }
    ngOnInit() {
        this.itemsToDisplay = JSON.parse(JSON.stringify(this.items));
        if (this.addSelectAllOption) {
            this.addSelectAllValues();
        }
        this.mapItemToParent();
        this.mapKeyToItem();
        this.updateSelected();
    }
    onSelectedValuesChange(e) {
        e.group = this.itemToParentMap[e.item]?.itemName.key;
        const removedItem = this.removeSelectedByKey(e.item);
        if (removedItem === null) { //if the item was not removed it was not in the selected items list
            if (this.hiddenSelectedItems[e.item] !== undefined) { // an iten is in hidden list when select-all was selected
                this.updateItemRemovedFromSelectAll(e.item);
            }
            else {
                this.selectedValues.push(e);
            }
        }
        this.updateSelected();
        if (this.addSelectAllOption) {
            if (e.item.indexOf(MULTI_SELECT_ALL) > -1) {
                this.updateSiblings(e.item);
            }
            else if (this.multiLevel) {
                this.checkAllSiblingsSelected(e.item);
            }
        }
    }
    onSelectedValueRemoved(e) {
        this.removeSelectedByKey(e.key);
        this.updateSelected();
        if (this.addSelectAllOption && e.key.indexOf(MULTI_SELECT_ALL) > -1) {
            this.updateSiblings(e.key);
        }
    }
    /**
     * Remove an ExComboboxValue item from the selected items list by key and returns it
     * @param itemKey
     */
    removeSelectedByKey(itemKey) {
        let removedItem = null;
        let selectedVal = this.selectedValues.findIndex(val => val.item === itemKey);
        if (selectedVal > -1) {
            removedItem = this.selectedValues.splice(selectedVal, 1);
            this.selectedValues = this.selectedValues.slice();
        }
        return removedItem;
    }
    removeSeveralKeys(itemKeys) {
        let removedItem = null;
        itemKeys.forEach(key => {
            let selectedVal = this.selectedValues.findIndex(val => val.item === key);
            if (selectedVal > -1) {
                removedItem = this.selectedValues.splice(selectedVal, 1);
            }
        });
        if (removedItem !== null) {
            this.selectedValues = this.selectedValues.slice();
        }
    }
    updateSelected() {
        this.itemsToDisplay = this.itemsToDisplay.map(this.findMatchingSelected, this);
        this.selectedValuesChange.emit(this.selectedValues);
    }
    findMatchingSelected(item) {
        item.isSelected = this.hiddenSelectedItems[item.itemName.key] !== undefined || this.selectedValues.findIndex(val => val.item === item.itemName.key) > -1;
        item.subItems && item.subItems.map(this.findMatchingSelected, this);
        return item;
    }
    checkAllSiblingsSelected(itemKey) {
        const parent = this.itemToParentMap[itemKey];
        let allSelected = parent.subItems.reduce((accumulator, currentValue) => {
            if (currentValue.itemName.key.indexOf(MULTI_SELECT_ALL) === -1) {
                return accumulator && currentValue.isSelected;
            }
            return accumulator;
        }, true);
        if (allSelected) {
            var selectAllItem = this.keyToItemMap[parent.itemName.key + MULTI_SELECT_ALL];
            this.onSelectedValuesChange({ item: selectAllItem.itemName.key, value: selectAllItem.itemName.value, group: parent.itemName.key });
        }
    }
    updateSiblings(itemKey) {
        const parent = this.itemToParentMap[itemKey];
        const itemSelectState = this.keyToItemMap[itemKey].isSelected;
        const itemsToRemove = [];
        parent.subItems.forEach(subItem => {
            if (subItem.itemName.key !== itemKey) {
                subItem.isSelected = itemSelectState;
                if (itemSelectState) {
                    this.hiddenSelectedItems[subItem.itemName.key] = subItem;
                    itemsToRemove.push(subItem.itemName.key);
                }
                else {
                    delete this.hiddenSelectedItems[subItem.itemName.key];
                }
            }
            ;
        });
        this.removeSeveralKeys(itemsToRemove);
    }
    updateItemRemovedFromSelectAll(itemKey) {
        const parent = this.itemToParentMap[itemKey];
        let selectAllKey = '';
        parent.subItems.forEach(subItem => {
            delete this.hiddenSelectedItems[subItem.itemName.key];
            if (subItem.itemName.key !== itemKey) {
                if (subItem.itemName.key.indexOf(MULTI_SELECT_ALL) > -1) {
                    selectAllKey = subItem.itemName.key;
                }
                else {
                    this.selectedValues.push({ item: subItem.itemName.key, value: subItem.itemName.value, group: parent.itemName.key });
                }
            }
        });
        this.removeSelectedByKey(selectAllKey);
    }
    addSelectAllValues() {
        this.itemsToDisplay.forEach(item => {
            if (item.subItems && item.subItems.length > 0) {
                var allItem = {
                    itemName: {
                        key: item.itemName.key + MULTI_SELECT_ALL,
                        value: this.translate.instant('ng.general.select_multiple.display.value')
                    },
                };
                item.subItems.unshift(allItem);
            }
            return item;
        });
    }
    mapItemToParent() {
        this.itemsToDisplay.forEach(item => item.hasOwnProperty('subItems') && item.subItems.forEach(subItem => {
            this.itemToParentMap[subItem.itemName.key] = item;
            this.multiLevel = true;
        }));
    }
    mapKeyToItem() {
        this.itemsToDisplay.forEach(item => {
            this.keyToItemMap[item.itemName.key] = item;
            item.hasOwnProperty('subItems') && item.subItems.forEach(subItem => this.keyToItemMap[subItem.itemName.key] = subItem);
        });
    }
    static { this.ɵfac = function ExComboboxMultiselectComponent_Factory(t) { return new (t || ExComboboxMultiselectComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComboboxMultiselectComponent, selectors: [["ex-combobox-multiselect"]], inputs: { addSelectAllOption: "addSelectAllOption" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 31, consts: [[3, "items", "selectedValues", "viewMode", "label", "placeholder", "description", "notDefinedLabelViewMode", "width", "full", "iconCss", "iconSide", "hasStickyHeaders", "showOnlyPlaceholder", "addBlankOption", "selectedChangeControl", "hasBorder", "mandatory", "displaySearchBox", "selectedFontSize", "showWarning", "openToSide", "highlightSelected", "sort", "isMultiSelect", "noGroup", "showCheckOnSelected", "disableAutoClose", "showGroupLabel", "ngClass", "selectedValuesChange", "selectedValueRemoved"]], template: function ExComboboxMultiselectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-combobox", 0);
            i0.ɵɵlistener("selectedValuesChange", function ExComboboxMultiselectComponent_Template_ex_combobox_selectedValuesChange_0_listener($event) { return ctx.onSelectedValuesChange($event); })("selectedValueRemoved", function ExComboboxMultiselectComponent_Template_ex_combobox_selectedValueRemoved_0_listener($event) { return ctx.onSelectedValueRemoved($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("items", ctx.itemsToDisplay)("selectedValues", ctx.selectedValues)("viewMode", ctx.viewMode)("label", ctx.label)("placeholder", ctx.placeholder)("description", ctx.description)("notDefinedLabelViewMode", ctx.notDefinedLabelViewMode)("width", ctx.width)("full", ctx.full)("iconCss", ctx.iconCss)("iconSide", ctx.iconSide)("hasStickyHeaders", ctx.hasStickyHeaders)("showOnlyPlaceholder", ctx.showOnlyPlaceholder)("addBlankOption", ctx.addBlankOption)("selectedChangeControl", ctx.selectedChangeControl)("hasBorder", ctx.hasBorder)("mandatory", ctx.mandatory)("displaySearchBox", ctx.displaySearchBox)("selectedFontSize", ctx.selectedFontSize)("showWarning", ctx.showWarning)("openToSide", ctx.openToSide)("highlightSelected", ctx.highlightSelected)("sort", ctx.sort)("isMultiSelect", true)("noGroup", true)("showCheckOnSelected", true)("disableAutoClose", true)("showGroupLabel", true)("ngClass", i0.ɵɵpureFunction1(29, _c0$1v, ctx.hasBorder));
        } }, dependencies: [i1$5.NgClass, ExComboboxComponent], styles: [".withBorder[_ngcontent-%COMP%]     button.ex-combobox-button.ex-combobox-button-border{border-color:#ccc!important}  .ex-combobox-selected-list-wrapper .ex-combobox-selected-list-chips div.ex-combobox-selected-no-group-chip-wrapper{height:-moz-fit-content;height:fit-content;line-height:20px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxMultiselectComponent, [{
        type: Component,
        args: [{ selector: 'ex-combobox-multiselect', template: "<ex-combobox [items]=\"itemsToDisplay\" [selectedValues]=\"selectedValues\"\r\n    (selectedValuesChange)=\"onSelectedValuesChange($event)\" (selectedValueRemoved)=\"onSelectedValueRemoved($event)\"\r\n    [viewMode]=\"viewMode\" [label]=\"label\" [placeholder]=\"placeholder\" [description]=\"description\"\r\n    [notDefinedLabelViewMode]=\"notDefinedLabelViewMode\" [width]=\"width\" [full]=\"full\" [iconCss]=\"iconCss\"\r\n    [iconSide]=\"iconSide\" [hasStickyHeaders]=\"hasStickyHeaders\" [showOnlyPlaceholder]=\"showOnlyPlaceholder\"\r\n    [addBlankOption]=\"addBlankOption\" [selectedChangeControl]=\"selectedChangeControl\" [hasBorder]=\"hasBorder\"\r\n    [mandatory]=\"mandatory\" [displaySearchBox]=\"displaySearchBox\" [selectedFontSize]=\"selectedFontSize\"\r\n    [showWarning]=\"showWarning\" [openToSide]=\"openToSide\" [highlightSelected]=\"highlightSelected\" [sort]=\"sort\"\r\n    [isMultiSelect]=\"true\" [noGroup]=\"true\" [showCheckOnSelected]=\"true\" [disableAutoClose]=\"true\"\r\n    [showGroupLabel]=\"true\" [ngClass]=\"{'withBorder': hasBorder}\">\r\n</ex-combobox>", styles: [".withBorder ::ng-deep button.ex-combobox-button.ex-combobox-button-border{border-color:#ccc!important}::ng-deep .ex-combobox-selected-list-wrapper .ex-combobox-selected-list-chips div.ex-combobox-selected-no-group-chip-wrapper{height:-moz-fit-content;height:fit-content;line-height:20px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { addSelectAllOption: [{
            type: Input
        }] }); })();

class ExComboboxModule {
    static { this.ɵfac = function ExComboboxModule_Factory(t) { return new (t || ExComboboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExComboboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            MatMenuModule,
            MatTooltipModule,
            ExDirectivesModule,
            FormsModule,
            EXPipesModule,
            ExSearchModule,
            ExCloseModule,
            TranslateModule,
            ExIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    FormsModule,
                    EXPipesModule,
                    ExSearchModule,
                    ExCloseModule,
                    TranslateModule,
                    ExIconModule
                ],
                declarations: [
                    ExComboboxComponent,
                    ExGroupOutletComponent,
                    ExComboboxMultiselectComponent
                ],
                exports: [
                    ExComboboxComponent,
                    ExComboboxMultiselectComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExComboboxModule, { declarations: [ExComboboxComponent,
        ExGroupOutletComponent,
        ExComboboxMultiselectComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        ExDirectivesModule,
        FormsModule,
        EXPipesModule,
        ExSearchModule,
        ExCloseModule,
        TranslateModule,
        ExIconModule], exports: [ExComboboxComponent,
        ExComboboxMultiselectComponent] }); })();

class MenuItemsToCombobox {
    transform(values) {
        return values.map(({ value, label, icon, disabled }) => ({ key: value, value: label, icon: icon, disabled: disabled }));
    }
    static { this.ɵfac = function MenuItemsToCombobox_Factory(t) { return new (t || MenuItemsToCombobox)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "menuItemsToCombobox", type: MenuItemsToCombobox, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemsToCombobox, [{
        type: Pipe,
        args: [{
                name: 'menuItemsToCombobox'
            }]
    }], null, null); })();

const _c0$1u = ["menuTrigger"];
const _c1$X = ["tooltip"];
class ExGenericCombobox extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, changeDetectorRef, hasFormFieldsBorder) {
        super(sectionLayoutViewModeObservable, changeDetectorRef);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.changeDetectorRef = changeDetectorRef;
        this.hasFormFieldsBorder = hasFormFieldsBorder;
        /**
         * The items to be displayed in the combobox
         */
        this.items = [];
        /**
         * The selected items which were chosen */
        this.selectedItems = [];
        /**
         * If to add an option to select all
         */
        this.hasSelectAll = true;
        /**
         * The search inputs placeholder
         */
        this.placeholder = 'ng.general.select_value';
        /**
         * If the search is loading
         */
        this.searchLoading = false;
        /**
         * If to add a blank option
         */
        this.addBlankOption = false;
        /**
         * If to to emit the selected values change every time
         */
        this.selectedChangeControl = true;
        /**
         * If to allow the selection of values which are not on the list of items
         */
        this.allowUnlistedValues = false;
        /**
         * Suffix added visually to all unlisted values entered
         */
        this.unlistedValueSuffix = "";
        /**
         * The recent selected items which were chosen
         */
        this.historyItems = [];
        /**
         * If to allow just one item per group or multiple
         */
        this.allowSingleSelectionInGroup = false;
        /**
         * Start to make the search after input length of char
         */
        this.minimumSearchLength = 0;
        /**
         * if to display no results placeholder
         */
        this.showNoResultsPlaceholder = true;
        /**
         * Whether the combobox items are already filtered; If true, items will not be filtered by the search text.
         */
        this.externalFiltering = false;
        this.customTrigger = false;
        /**
         * Emits when the selected items change
         */
        this.selectedItemsChange = new EventEmitter();
        /**
         * Emits when the search text change firing the searched text
         */
        this.searchTextChange = new EventEmitter();
        /**
         * Emits when the menu closes
         */
        this.menuClosed = new EventEmitter();
        /**
         * Emits when the selected item change
         */
        this.itemAdded = new EventEmitter();
        this.favoriteItemChange = new EventEmitter();
        this.searchText = '';
        this.lastIndex = 0;
        this.selectedItemsTransformed = [];
        this._isMultiSelect = false;
        this.isCompositionIsVisible = false;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.recalculateMenu();
        }
    }
    writeValue(value) {
        if (value && !Array.isArray(value)) {
            return;
        }
        if (value) {
            this.selectedItems = [...value];
        }
        else {
            this.selectedItems = [];
        }
        this.changeDetectorRef.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.changeDetectorRef.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.changeDetectorRef.markForCheck();
    }
    _searchTextChange(text) {
        this.searchText = text;
        if (this.searchTextChanged()) {
            this.searchTextChange.emit(text);
            this.openMenu();
        }
    }
    _itemAdded(item, emitChange = true) {
        let initialSelected = [...this.selectedItems];
        if (!this._isMultiSelect) {
            this.selectedItems = [];
            this.closeMenu();
        }
        const ind = this.selectedItems.findIndex(i => {
            return i.key === item.key;
        });
        if (ind === -1) {
            this.selectedItems = [...this.selectedItems, item];
            this.recalculateMenu();
        }
        if (emitChange) {
            this.saveChanges(initialSelected);
        }
        this.itemAdded.emit(item.key);
    }
    itemRemoved(key, emitChange = true) {
        this.selectedItems = this.selectedItems.filter(i => {
            return i.key !== key;
        });
        this.recalculateMenu();
        if (emitChange) {
            this.saveChanges();
        }
    }
    itemsAdded(items, emitChange = true) {
        items.forEach((item, index) => {
            if (item.subItems && item.subItems.length > 0) {
                this.itemsAdded(item.subItems);
            }
            else {
                const selectedItem = { key: item.key, value: item.value, color: item.color };
                this._itemAdded(selectedItem, emitChange && index === items.length - 1);
            }
        });
    }
    itemsRemoved(items, emitChange = true) {
        items.forEach((item, index) => {
            if (item.subItems && item.subItems.length > 0) {
                this.itemsRemoved(item.subItems);
            }
            else {
                this.itemRemoved(item.key, emitChange && index === items.length - 1);
            }
        });
    }
    saveChanges(initialSelected) {
        this.selectedItemsChange.emit(this.selectedItems);
        this.searchText = '';
        this.onBlur();
        if (!this.selectedChangeControl) {
            this.selectedItems = initialSelected;
        }
    }
    blankOptionClicked() {
        this.selectedItems = [];
        this.saveChanges();
    }
    recalculateMenu() {
        setTimeout(() => {
            // get the OverlayRef from MatMenuTrigger
            const overlayRef = this.menuTrigger?._overlayRef;
            if (overlayRef) {
                // get the FlexibleConnectedPositionStrategy from OverlayRef
                const overlayConfig = overlayRef.getConfig();
                // repeat what was done in the resize event handler
                overlayConfig.positionStrategy._isInitialRender = true;
                overlayConfig.positionStrategy.apply();
            }
        }, 50);
    }
    onMenuClosed() {
        this.searchText = '';
        this.searchTextChange.emit(this.searchText);
        this.menuClosed.emit();
        this.onBlur();
    }
    onMenuOpened() {
        if (this.isAlwaysOpen) {
            this.onMenuOpenedSetFocus();
        }
        else {
            setTimeout(() => {
                this.onMenuOpenedSetFocus();
            }, 200); //waiting for the animation to finish
        }
        this.recalculateMenu();
    }
    onMenuOpenedSetFocus() {
        if (this.searchBox) {
            this.focusSearch();
        }
        else {
            this.keyDownNavigation({ code: "ArrowDown" }, -1);
        }
    }
    keyDownNavigation(_event, focusedIndex) {
        if (this.isCompositionIsVisible) {
            return true;
        }
        if (_event.code === "ArrowDown") {
            if (this.isAlwaysOpen) {
                event?.stopPropagation();
                event?.preventDefault();
            }
            let elem = null;
            while ((elem === null || elem.disabled) && focusedIndex !== this.lastIndex) {
                focusedIndex++;
                elem = document.getElementById('ex-combobox-' + focusedIndex);
            }
            elem?.focus();
            this.changeDetectorRef.detectChanges();
        }
        else if (_event.code === "ArrowUp") {
            if (this.isAlwaysOpen) {
                event?.stopPropagation();
                event?.preventDefault();
            }
            let elem = null;
            while ((elem === null || elem.disabled) && focusedIndex > -1) {
                focusedIndex--;
                elem = document.getElementById('ex-combobox-' + focusedIndex);
            }
            elem?.focus();
            this.changeDetectorRef.detectChanges();
            if (!elem) {
                this.focusSearch();
            }
        }
    }
    focusSearch() {
        if ((getSelection() || "").toString().length > 0) {
            //Focus isn't taken because that selecting of text is detected
            return;
        }
        setTimeout(() => {
            this.searchBox?.input.nativeElement.focus();
        }, 0);
    }
    onSearchKeyDown(event) {
        this.keyDownNavigation(event, -1);
    }
    onMenuKeyDown(event) {
        let focusedIndex = Number(document.activeElement.closest('[id^="ex-combobox"]').id.replace('ex-combobox-', ''));
        if (isNaN(focusedIndex)) {
            focusedIndex = -1;
        }
        this.keyDownNavigation(event, focusedIndex);
    }
    lastIndexChanged(lastIndex) {
        this.lastIndex = lastIndex + this.historyItems?.length;
    }
    searchTextChanged() {
        return this.searchText.length >= this.minimumSearchLength;
    }
    openMenu() {
        this.menuTrigger ? this.menuTrigger.openMenu() : null;
    }
    closeMenu() {
        this.menuTrigger ? this.menuTrigger.closeMenu() : null;
    }
    onCompositionUpdate(isCompositionIsVisible) {
        this.isCompositionIsVisible = isCompositionIsVisible;
    }
    static { this.ɵfac = function ExGenericCombobox_Factory(t) { return new (t || ExGenericCombobox)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(HAS_FORM_FIELDS_BORDERS, 8)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExGenericCombobox, viewQuery: function ExGenericCombobox_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1u, 5);
            i0.ɵɵviewQuery(ExSearchComponent, 5);
            i0.ɵɵviewQuery(_c1$X, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t);
        } }, inputs: { items: "items", selectedItems: "selectedItems", hasSelectAll: "hasSelectAll", placeholder: "placeholder", searchLoading: "searchLoading", addBlankOption: "addBlankOption", selectedChangeControl: "selectedChangeControl", allowUnlistedValues: "allowUnlistedValues", unlistedValueSuffix: "unlistedValueSuffix", historyItems: "historyItems", allowSingleSelectionInGroup: "allowSingleSelectionInGroup", minimumSearchLength: "minimumSearchLength", showNoResultsPlaceholder: "showNoResultsPlaceholder", externalFiltering: "externalFiltering", isAlwaysOpen: "isAlwaysOpen", customTrigger: "customTrigger" }, outputs: { selectedItemsChange: "selectedItemsChange", searchTextChange: "searchTextChange", menuClosed: "menuClosed", itemAdded: "itemAdded", favoriteItemChange: "favoriteItemChange" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGenericCombobox, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [HAS_FORM_FIELDS_BORDERS]
            }] }]; }, { items: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], hasSelectAll: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], searchLoading: [{
            type: Input
        }], addBlankOption: [{
            type: Input
        }], selectedChangeControl: [{
            type: Input
        }], allowUnlistedValues: [{
            type: Input
        }], unlistedValueSuffix: [{
            type: Input
        }], historyItems: [{
            type: Input
        }], allowSingleSelectionInGroup: [{
            type: Input
        }], minimumSearchLength: [{
            type: Input
        }], showNoResultsPlaceholder: [{
            type: Input
        }], externalFiltering: [{
            type: Input
        }], isAlwaysOpen: [{
            type: Input
        }], customTrigger: [{
            type: Input
        }], selectedItemsChange: [{
            type: Output
        }], searchTextChange: [{
            type: Output
        }], menuClosed: [{
            type: Output
        }], itemAdded: [{
            type: Output
        }], favoriteItemChange: [{
            type: Output
        }], menuTrigger: [{
            type: ViewChild,
            args: ['menuTrigger']
        }], searchBox: [{
            type: ViewChild,
            args: [ExSearchComponent]
        }], tooltip: [{
            type: ViewChildren,
            args: ['tooltip']
        }] }); })();

const Animations$6 = [
    trigger('arrowFlip2', [
        state('down', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('up', style({
            transform: 'rotate(-90deg)'
        })),
        transition('down <=> up', [
            animate('0.25s')
        ])
    ]),
    trigger('expendAndcollapse2', [
        state('expanded', style({
            height: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('collapsed', style({
            height: '0px',
            overflow: 'hidden'
        })),
        transition('expanded <=> collapsed', [
            animate('0.25s')
        ])
    ])
];

class ExLiveAnnouncerService {
    announce(text) {
        var el = document.createElement('div');
        var id = 'speak-' + Date.now();
        el.setAttribute('id', id);
        el.setAttribute('aria-live', 'polite');
        el.classList.add('ex-live-announcer');
        document.body.appendChild(el);
        window.setTimeout(function () {
            document.getElementById(id).innerHTML = text;
        }, 100);
        window.setTimeout(function () {
            document.body.removeChild(document.getElementById(id));
        }, 1000);
    }
    static { this.ɵfac = function ExLiveAnnouncerService_Factory(t) { return new (t || ExLiveAnnouncerService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExLiveAnnouncerService, factory: ExLiveAnnouncerService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLiveAnnouncerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const _c0$1t = ["searchResults"];
function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_ex_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 13);
    i0.ɵɵlistener("checkboxChange", function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_ex_checkbox_3_Template_ex_checkbox_checkboxChange_0_listener() { i0.ɵɵrestoreView(_r13); const item_r7 = i0.ɵɵnextContext(2).$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onItemClicked(ctx_r12.historyMap[item_r7.key].item)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r10.itemsMap[item_r7.key] == null ? null : ctx_r10.itemsMap[item_r7.key].all)("disabled", ctx_r10.historyMap[item_r7.key].item == null ? null : ctx_r10.historyMap[item_r7.key].item.disabled)("uniqueSelector", "ex-group-outlet-history-checkbox-" + item_r7.key + (ctx_r10.uniqueSelector ? "-" + ctx_r10.uniqueSelector : ""))("ariaLabel", ctx_r10.historyMap[item_r7.key].item.value);
} }
function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const parent_r16 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", parent_r16, ": ");
} }
function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵlistener("click", function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r18); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onItemClicked(ctx_r17.historyMap[item_r7.key].item)); })("keyup.space", function ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_Template_div_keyup_space_1_listener() { i0.ɵɵrestoreView(_r18); const item_r7 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onItemClicked(ctx_r20.historyMap[item_r7.key].item)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵtemplate(3, ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_ex_checkbox_3_Template, 1, 4, "ex-checkbox", 9);
    i0.ɵɵelementStart(4, "span", 10);
    i0.ɵɵtemplate(5, ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_span_5_Template, 2, 1, "span", 11);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "ex-svg-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const item_r7 = ctx_r22.$implicit;
    const index_r8 = ctx_r22.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-group-outlet-history ", i0.ɵɵpipeBind1(2, 9, "ex-group-outlet-history-" + item_r7.key + (ctx_r9.uniqueSelector ? "-" + ctx_r9.uniqueSelector : "")), "");
    i0.ɵɵclassProp("ex-group-outlet-history-disabled", ctx_r9.historyMap[item_r7.key].item == null ? null : ctx_r9.historyMap[item_r7.key].item.disabled);
    i0.ɵɵproperty("id", "ex-combobox-" + index_r8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.isMultiSelect && !ctx_r9.allowSingleSelectionInGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r9.historyMap[item_r7.key].parentValue);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.historyMap[item_r7.key].item.value);
} }
function ExGroupOutletComponent2_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent2_div_0_ng_container_1_ng_container_1_Template, 9, 11, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.historyMap[item_r7.key]);
} }
function ExGroupOutletComponent2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ExGroupOutletComponent2_div_0_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.historyItems);
} }
function ExGroupOutletComponent2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function ExGroupOutletComponent2_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23._blankOptionClicked()); })("keydown.enter", function ExGroupOutletComponent2_div_1_Template_div_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25._blankOptionClicked()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_2_0;
    i0.ɵɵclassMapInterpolate1("ex-group-outlet-menu-option ", i0.ɵɵpipeBind1(1, 7, "ex-group-outlet-blank-option" + (ctx_r1.uniqueSelector ? "-" + ctx_r1.uniqueSelector : "")), "");
    i0.ɵɵclassProp("ex-group-outlet-menu-option-blank", ctx_r1.hasFavorite);
    i0.ɵɵproperty("id", "ex-combobox-" + ((tmp_2_0 = ctx_r1.historyItems == null ? null : ctx_r1.historyItems.length) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, "ng.general.none"), "\n");
} }
function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_checkbox_9_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 26);
    i0.ɵɵlistener("checkboxChange", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_checkbox_9_Template_ex_checkbox_checkboxChange_0_listener() { i0.ɵɵrestoreView(_r35); const item_r26 = i0.ɵɵnextContext(2).$implicit; const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.onHeaderCheckboxClicked(item_r26)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r31 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r31.itemsMap[item_r26.key].all)("indeterminate", ctx_r31.itemsMap[item_r26.key].some && !ctx_r31.itemsMap[item_r26.key].all)("uniqueSelector", "ex-group-outlet-expandable-header-checkbox-" + item_r26.key + (ctx_r31.uniqueSelector ? "-" + ctx_r31.uniqueSelector : ""))("ariaLabel", i0.ɵɵpipeBind1(1, 4, item_r26.value));
} }
function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-group-outlet-2", 27);
    i0.ɵɵlistener("itemsAdded", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template_ex_group_outlet_2_itemsAdded_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r37.itemsAdded.emit($event)); })("itemsRemoved", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template_ex_group_outlet_2_itemsRemoved_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r39 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r39.itemsRemoved.emit($event)); })("itemAdded", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template_ex_group_outlet_2_itemAdded_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.itemAdded.emit($event)); })("itemRemoved", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template_ex_group_outlet_2_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r41 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r41.itemRemoved.emit($event)); })("itemRemovedWithoutEmit", function ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template_ex_group_outlet_2_itemRemovedWithoutEmit_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r42 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r42.itemRemovedWithoutEmit.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", item_r26.subItems)("searchText", ctx_r32.searchText)("isMultiSelect", ctx_r32.isMultiSelect)("hasSelectAll", ctx_r32.hasSelectAll)("selectedItems", ctx_r32.selectedItems)("historyItems", ctx_r32.historyItems)("level", ctx_r32.level + 1)("itemsMap", ctx_r32.itemsMap)("allowSingleSelectionInGroup", ctx_r32.allowSingleSelectionInGroup)("uniqueSelector", "ex-group-outlet-level-" + ctx_r32.level + "-" + (ctx_r32.uniqueSelector ? ctx_r32.uniqueSelector + "-" + item_r26.key : item_r26.key))("minimumSearchLength", ctx_r32.minimumSearchLength);
} }
function ExGroupOutletComponent2_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "button", 19);
    i0.ɵɵlistener("keydown.ArrowRight", function ExGroupOutletComponent2_ng_container_4_ng_container_1_Template_button_keydown_ArrowRight_3_listener() { i0.ɵɵrestoreView(_r46); const index_r27 = i0.ɵɵnextContext().index; const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.onHeaderClicked(index_r27)); })("keydown.ArrowLeft", function ExGroupOutletComponent2_ng_container_4_ng_container_1_Template_button_keydown_ArrowLeft_3_listener() { i0.ɵɵrestoreView(_r46); const index_r27 = i0.ɵɵnextContext().index; const ctx_r47 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r47.onHeaderClicked(index_r27)); })("keyup.enter", function ExGroupOutletComponent2_ng_container_4_ng_container_1_Template_button_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r46); const item_r26 = i0.ɵɵnextContext().$implicit; const ctx_r49 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r49.onHeaderCheckboxClicked(item_r26)); })("click", function ExGroupOutletComponent2_ng_container_4_ng_container_1_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r46); const index_r27 = i0.ɵɵnextContext().index; const ctx_r51 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r51.onHeaderClicked(index_r27)); });
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "div", 20);
    i0.ɵɵtemplate(9, ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_checkbox_9_Template, 2, 6, "ex-checkbox", 21);
    i0.ɵɵelement(10, "span", 22);
    i0.ɵɵpipe(11, "exTextHighlight");
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "i", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 24);
    i0.ɵɵtemplate(15, ExGroupOutletComponent2_ng_container_4_ng_container_1_ex_group_outlet_2_15_Template, 1, 11, "ex-group-outlet-2", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext().$implicit;
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(2, 16, item_r26.tooltip));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-group-outlet-expandable-header ", i0.ɵɵpipeBind1(4, 18, ctx_r28.uniqueSelector ? ctx_r28.uniqueSelector + "-" + item_r26.key : item_r26), "");
    i0.ɵɵstyleProp("padding-inline-start", 20 * ctx_r28.level, "px");
    i0.ɵɵproperty("id", "ex-combobox-" + (ctx_r28.itemsMap[item_r26.key].index + (ctx_r28.historyItems == null ? null : ctx_r28.historyItems.length)))("disabled", item_r26.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 20, item_r26.value) + " " + i0.ɵɵpipeBind1(6, 22, item_r26.expanded ? "ng.general.group-outlet.expanded" : "ng.general.group-outlet.collapsed") + " " + i0.ɵɵpipeBind1(7, 24, "ng.general.group-outlet.level") + " " + ctx_r28.level)("aria-checked", ctx_r28.isMultiSelect && !ctx_r28.allowSingleSelectionInGroup && ctx_r28.hasSelectAll ? ctx_r28.itemsMap[item_r26.key] == null ? null : ctx_r28.itemsMap[item_r26.key].all : "");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r28.isMultiSelect && !ctx_r28.allowSingleSelectionInGroup && ctx_r28.hasSelectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(11, 26, i0.ɵɵpipeBind1(12, 29, item_r26.value), ctx_r28.searchText), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("@arrowFlip2", item_r26.expanded ? "down" : "up");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@expendAndcollapse2", item_r26.expanded ? "expanded" : "collapsed");
    i0.ɵɵattribute("aria-labelledby", "ex-combobox-" + (ctx_r28.itemsMap[item_r26.key].index + (ctx_r28.historyItems == null ? null : ctx_r28.historyItems.length)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r26.expanded);
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 38);
    i0.ɵɵlistener("checkboxChange", function ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_ex_checkbox_1_Template_ex_checkbox_checkboxChange_0_listener() { i0.ɵɵrestoreView(_r62); const item_r26 = i0.ɵɵnextContext(3).$implicit; const ctx_r60 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r60.onItemClicked(item_r26)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r58 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r58.itemsMap[item_r26.key].all)("uniqueSelector", "ex-group-outlet-combobox-option-" + item_r26.key + (ctx_r58.uniqueSelector ? "-" + ctx_r58.uniqueSelector : ""))("ariaLabel", i0.ɵɵpipeBind1(1, 4, ctx_r58.getValue(item_r26)))("isStandalone", ctx_r58.isCheckboxStandaloneInLeaf);
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 39);
    i0.ɵɵlistener("change", function ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_mat_radio_button_2_Template_mat_radio_button_change_0_listener() { i0.ɵɵrestoreView(_r66); const item_r26 = i0.ɵɵnextContext(3).$implicit; const ctx_r64 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r64.onItemClicked(item_r26)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("value", item_r26.key);
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_ex_checkbox_1_Template, 2, 6, "ex-checkbox", 36);
    i0.ɵɵtemplate(2, ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_mat_radio_button_2_Template, 1, 1, "mat-radio-button", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r54.allowSingleSelectionInGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.allowSingleSelectionInGroup);
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_8_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-svg-icon", 40);
    i0.ɵɵlistener("keydown.tab", function ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_8_Template_ex_svg_icon_keydown_tab_0_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(2); const item_r26 = ctx_r69.$implicit; const index_r27 = ctx_r69.index; const ctx_r68 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r68.navigateToIcon($event, item_r26, index_r27)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    const item_r26 = ctx_r71.$implicit;
    const index_r27 = ctx_r71.index;
    const ctx_r55 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ex-group-outlet-favorite-hidden", !(item_r26.hover || item_r26.favorite));
    i0.ɵɵproperty("id", ctx_r55.favoriteId + index_r27)("ariaHidden", false)("tooltip", item_r26.favorite ? "ng.general.default" : "ng.general.set_to_default")("ariaLabel", item_r26.favorite ? "ng.general.default" : "ng.general.set_to_default")("callback", ctx_r55.onfavoriteClicked.bind(ctx_r55, item_r26))("color", item_r26.favorite ? "#337ab7" : "#898989");
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_14_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-svg-icon", 41);
    i0.ɵɵlistener("keydown.tab", function ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_14_Template_ex_svg_icon_keydown_tab_0_listener($event) { i0.ɵɵrestoreView(_r74); const ctx_r73 = i0.ɵɵnextContext(2); const item_r26 = ctx_r73.$implicit; const index_r27 = ctx_r73.index; const ctx_r72 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r72.navigateToItem($event, item_r26, index_r27)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(2);
    const item_r26 = ctx_r75.$implicit;
    const index_r27 = ctx_r75.index;
    i0.ɵɵclassProp("ex-group-outlet-menu-option-icon-hide", !!item_r26.icon.callback && !item_r26.hover);
    i0.ɵɵproperty("id", "icon" + index_r27)("ariaHidden", false)("color", item_r26.icon.iconColor)("iconName", item_r26.icon.iconName)("callback", item_r26.icon.callback)("tooltip", item_r26.icon == null ? null : item_r26.icon.tooltip)("ariaLabel", item_r26.icon.tooltip);
    i0.ɵɵattribute("role", !!item_r26.icon.callback ? "button" : undefined);
} }
function ExGroupOutletComponent2_ng_container_4_ng_template_2_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 42);
    i0.ɵɵpipe(1, "exTextHighlight");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r57 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, i0.ɵɵpipeBind1(2, 4, item_r26.description), ctx_r57.searchText), i0.ɵɵsanitizeHtml);
} }
const _c1$W = function (a0) { return { "ex-group-outlet-hasBorder": a0 }; };
function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵlistener("mouseenter", function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r79); const item_r26 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(item_r26.hover = true); })("mouseleave", function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r79); const item_r26 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(item_r26.hover = false); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "button", 29);
    i0.ɵɵlistener("keydown.tab", function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template_button_keydown_tab_2_listener($event) { i0.ɵɵrestoreView(_r79); const ctx_r83 = i0.ɵɵnextContext(); const item_r26 = ctx_r83.$implicit; const index_r27 = ctx_r83.index; const ctx_r82 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r82.navigateToFavorite($event, item_r26, index_r27)); })("keydown.space", function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template_button_keydown_space_2_listener($event) { i0.ɵɵrestoreView(_r79); const item_r26 = i0.ɵɵnextContext().$implicit; const ctx_r84 = i0.ɵɵnextContext(); ctx_r84.onItemClicked(item_r26, !ctx_r84.isMultiSelect); return i0.ɵɵresetView(ctx_r84.isMultiSelect && $event.preventDefault()); })("click", function ExGroupOutletComponent2_ng_container_4_ng_template_2_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r79); const item_r26 = i0.ɵɵnextContext().$implicit; const ctx_r86 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r86.onItemClicked(item_r26, true)); });
    i0.ɵɵpipe(3, "exClassNameFormat");
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExGroupOutletComponent2_ng_container_4_ng_template_2_ng_container_7_Template, 3, 2, "ng-container", 7);
    i0.ɵɵtemplate(8, ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_8_Template, 1, 8, "ex-svg-icon", 30);
    i0.ɵɵelementStart(9, "div", 31)(10, "div", 32);
    i0.ɵɵelement(11, "span", 33);
    i0.ɵɵpipe(12, "exTextHighlight");
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, ExGroupOutletComponent2_ng_container_4_ng_template_2_ex_svg_icon_14_Template, 1, 10, "ex-svg-icon", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ExGroupOutletComponent2_ng_container_4_ng_template_2_span_15_Template, 3, 6, "span", 35);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r26 = i0.ɵɵnextContext().$implicit;
    const ctx_r30 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(1, 20, item_r26.tooltip));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c1$W, item_r26.hasBorder));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate2("ex-group-outlet-menu-option sel-menu-option sel-combobox-option-", i0.ɵɵpipeBind1(3, 22, item_r26.key), " ", i0.ɵɵpipeBind1(4, 24, ctx_r30.uniqueSelector ? ctx_r30.uniqueSelector + "-" + item_r26.key : item_r26), "");
    i0.ɵɵstyleProp("padding-left", 20 * (ctx_r30.isMultiSelect && ctx_r30.allowSingleSelectionInGroup ? ctx_r30.level - 1 : ctx_r30.level), "px");
    i0.ɵɵproperty("id", "ex-combobox-" + (ctx_r30.itemsMap[item_r26.key].index + (ctx_r30.historyItems == null ? null : ctx_r30.historyItems.length)))("disabled", item_r26.disabled);
    i0.ɵɵattribute("aria-selected", !(ctx_r30.isMultiSelect && !ctx_r30.allowSingleSelectionInGroup) ? ctx_r30.itemsMap[item_r26.key].all : "")("aria-label", i0.ɵɵpipeBind1(5, 26, ctx_r30.getValue(item_r26)) + " " + i0.ɵɵpipeBind1(6, 28, "ng.general.group-outlet.level") + " " + ctx_r30.level)("aria-checked", ctx_r30.isMultiSelect && !ctx_r30.allowSingleSelectionInGroup ? ctx_r30.itemsMap[item_r26.key] == null ? null : ctx_r30.itemsMap[item_r26.key].all : "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r30.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.hasFavorite);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("ex-group-outlet-menu-option-title-bold", !!item_r26.description);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(12, 30, i0.ɵɵpipeBind1(13, 33, ctx_r30.getValue(item_r26)), ctx_r30.searchText), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", item_r26.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r26.description);
} }
function ExGroupOutletComponent2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGroupOutletComponent2_ng_container_4_ng_container_1_Template, 16, 31, "ng-container", 16);
    i0.ɵɵtemplate(2, ExGroupOutletComponent2_ng_container_4_ng_template_2_Template, 16, 37, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r26 = ctx.$implicit;
    const _r29 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r26.subItems && item_r26.subItems.length > 0)("ngIfElse", _r29);
} }
function ExGroupOutletComponent2_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 43);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r4.noResultsLabel), "\n");
} }
function ExGroupOutletComponent2_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 43);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r5.notReadyForDisplayLabel), "\n");
} }
class ExGroupOutletComponent2 {
    constructor(liveAnnouncer, translateService) {
        this.liveAnnouncer = liveAnnouncer;
        this.translateService = translateService;
        this.items = [];
        this.historyItems = [];
        /**
         * whether to show also history items which are not included in the item
         */
        this.showAllHistory = false;
        this.searchText = '';
        this.isMultiSelect = false;
        this.hasSelectAll = false;
        this.selectedItems = [];
        this.addBlankOption = false;
        this.level = 1;
        this.itemsMap = {};
        this.unlistedValueSuffix = "";
        this.allowSingleSelectionInGroup = false;
        this.minimumSearchLength = 0;
        this.showNoResultsPlaceholder = true;
        this.isCheckboxStandaloneInLeaf = false;
        this.hasFavorite = false;
        this.itemAdded = new EventEmitter();
        this.itemRemoved = new EventEmitter();
        this.itemRemovedWithoutEmit = new EventEmitter();
        this.itemsAdded = new EventEmitter();
        this.itemsRemoved = new EventEmitter();
        this.leafClicked = new EventEmitter();
        this.blankOptionClicked = new EventEmitter();
        this.lastIndexChanged = new EventEmitter();
        this.favoriteClicked = new EventEmitter();
        this.noResultsLabel = 'ng.group-outlet.no-results';
        this.notReadyForDisplayLabel = 'ng.group-outlet.not-ready-for-display';
        this.historyMap = {};
        this.selectedItemsValues = {};
        this.favoriteId = 'favoriteId';
    }
    ngAfterViewInit() {
        this.searchResults?.nativeElement.setAttribute("role", "presentation");
    }
    ngOnChanges(changes) {
        if ((changes.hasOwnProperty('items') || changes.hasOwnProperty('selectedItems'))) {
            this.selectedItems?.forEach(selected => {
                const item = this.items.find(item => item.key === selected.key);
                if (item) {
                    this.selectedItem = item.key;
                }
            });
        }
        if (this.level === 1) {
            if ((changes.hasOwnProperty('items') || changes.hasOwnProperty('selectedItems'))) {
                this.itemsMap = {};
                this.initializeSelectedItemsValues();
                const lastIndex = this.items?.length > 0 ? this.prepareData(this.items, 1).index : 0;
                this.lastIndexChanged.emit(lastIndex);
            }
            if (changes.hasOwnProperty('items') || changes.hasOwnProperty('historyItems')) {
                let text = this._getStatusText(changes);
                this.liveAnnouncer.announce(text);
                this.historyMap = {};
                this.prepareHistory(this.items);
                const lastIndex = this.items?.length > 0 ? this.prepareData(this.items, 1).index : 0;
                this.lastIndexChanged.emit(lastIndex);
            }
        }
    }
    _getStatusText(changes) {
        let text = '';
        const amount = changes['items']?.currentValue?.length + (changes['historyItems']?.currentValue?.length ?? 0);
        if (amount > 1) {
            text = this.translateService.instant('ng.general.combobox_results_found', { amount });
        }
        if (amount === 1) {
            text = this.translateService.instant('ng.general.combobox_1_result_found');
        }
        if (!amount) {
            text = this.translateService.instant('recent.entities.no.search.results');
        }
        return text;
    }
    initializeSelectedItemsValues() {
        this.selectedItems.forEach(selected => {
            for (const item of this.items) {
                let foundItem;
                if (item.subItems?.length > 0)
                    foundItem = item.subItems.find(item => item.key === selected.key);
                else if (item.key === selected.key)
                    foundItem = item;
                if (foundItem) {
                    this.selectedItemsValues[selected.key] = foundItem.value;
                    break;
                }
            }
        });
    }
    prepareData(items, index) {
        let all = true;
        let some = false;
        items.forEach(item => {
            this.itemsMap[item.key] = { index, all: true, some: true };
            index++;
            if (item.subItems?.length > 0) {
                const obj = this.prepareData(item.subItems, index);
                index = obj.index;
                this.itemsMap[item.key].all = obj.all;
                this.itemsMap[item.key].some = obj.some;
            }
            else {
                if (item.isNew)
                    this.itemsMap[item.key].all = this.selectedItems.findIndex(selected => this.selectedItemsValues[selected.key] === item.value) !== -1;
                else
                    this.itemsMap[item.key].all = this.selectedItems.findIndex(selected => selected.key === item.key) !== -1;
                this.itemsMap[item.key].some = this.itemsMap[item.key].all;
            }
            all = all && this.itemsMap[item.key].all;
            some = some || this.itemsMap[item.key].some;
        });
        return { index, all, some };
    }
    prepareHistory(items) {
        this.buildHistoryMap(items, []);
        if (this.showAllHistory) {
            this.expandHistoryMapWithExternalHistory();
            this.expandItemsMapWithExternalHistory();
        }
    }
    buildHistoryMap(items, parentValue) {
        (items ?? []).forEach(item => {
            if (this.historyItems?.some(hItem => hItem.key == item.key)) {
                this.historyMap[item.key] = { parentValue, item };
            }
            if (item.subItems && item.subItems.length > 0) {
                this.buildHistoryMap(item.subItems, [...parentValue, item.value]);
            }
        });
    }
    /**
     * Adds to the history map history items that are not included in the combobox items and were not added to the history map by buildHistoryMap
     */
    expandHistoryMapWithExternalHistory() {
        (this.historyItems ?? []).forEach(historyItem => {
            if (!this.historyMap[historyItem.key] && historyItem.value)
                this.historyMap[historyItem.key] = { parentValue: [], item: { key: historyItem.key, value: historyItem.value } };
        });
    }
    /**
     * Adds to the items map history items that are not included in the combobox items
     */
    expandItemsMapWithExternalHistory() {
        (this.historyItems ?? []).forEach(item => {
            if (!this.itemsMap[item.key])
                this.itemsMap[item.key] = { index: null, all: this.selectedItems.some(selected => selected.key === item.key) };
        });
    }
    onHeaderClicked(index) {
        event.stopPropagation();
        this.items[index].expanded = !this.items[index].expanded;
    }
    onHeaderCheckboxClicked(item) {
        if (!this.itemsMap[item.key].all) {
            this.itemsAdded.emit(item.subItems);
        }
        else {
            this.itemsRemoved.emit(item.subItems);
        }
    }
    onItemClicked(item, isTextClicked = false) {
        if (this.isMultiSelect && this.allowSingleSelectionInGroup) {
            event.stopPropagation();
            this.selectedItems.find(selected => {
                const selectedElement = this.items.find(element => element.key === selected.key && element.key !== item.key);
                if (selectedElement) { //we already have selected on this level
                    this.itemRemovedWithoutEmit.emit(selectedElement.key);
                    this.leafClicked.emit(isTextClicked);
                }
            });
            const selectedItem = { key: item.key, value: item.value, color: item.color };
            this.itemAdded.emit(selectedItem);
            this.leafClicked.emit(isTextClicked);
        }
        else if (!this.isMultiSelect || !this.itemsMap[item.key].all) {
            const selectedItem = { key: item.key, value: item.value, color: item.color };
            this.itemAdded.emit(selectedItem);
            this.leafClicked.emit(isTextClicked);
        }
        else {
            this.itemRemoved.emit(item.key);
            this.leafClicked.emit(isTextClicked);
        }
    }
    _blankOptionClicked() {
        this.blankOptionClicked.emit();
    }
    readyForDisplay() {
        return this.searchText.length >= this.minimumSearchLength;
    }
    getValue(item) {
        if (item.isNew)
            return `${item.value}${this.unlistedValueSuffix.length > 0 ? " " : ""}${this.unlistedValueSuffix}`;
        return item.value;
    }
    navigateToFavorite(event, item, index) {
        if (this.hasFavorite) {
            document.getElementById(this.favoriteId + index).focus();
            event.stopPropagation();
        }
        else
            this.navigateToIcon(event, item, index);
    }
    navigateToIcon(event, item, index) {
        if (!!item?.icon) {
            document.getElementById('icon' + index).focus();
            event.stopPropagation();
        }
    }
    navigateToItem(event, item, index) {
        if (this.hasFavorite) {
            document.getElementById('ex-combobox-' + (this.itemsMap[item.key].index + this.historyItems?.length)).focus();
            event.stopPropagation();
        }
    }
    onfavoriteClicked(item) {
        this.favoriteClicked.emit(item);
    }
    static { this.ɵfac = function ExGroupOutletComponent2_Factory(t) { return new (t || ExGroupOutletComponent2)(i0.ɵɵdirectiveInject(ExLiveAnnouncerService), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExGroupOutletComponent2, selectors: [["ex-group-outlet-2"]], viewQuery: function ExGroupOutletComponent2_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1t, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchResults = _t.first);
        } }, inputs: { items: "items", historyItems: "historyItems", showAllHistory: "showAllHistory", searchText: "searchText", isMultiSelect: "isMultiSelect", hasSelectAll: "hasSelectAll", selectedItems: "selectedItems", addBlankOption: "addBlankOption", level: "level", itemsMap: "itemsMap", unlistedValueSuffix: "unlistedValueSuffix", allowSingleSelectionInGroup: "allowSingleSelectionInGroup", minimumSearchLength: "minimumSearchLength", showNoResultsPlaceholder: "showNoResultsPlaceholder", isCheckboxStandaloneInLeaf: "isCheckboxStandaloneInLeaf", hasFavorite: "hasFavorite", uniqueSelector: "uniqueSelector" }, outputs: { itemAdded: "itemAdded", itemRemoved: "itemRemoved", itemRemovedWithoutEmit: "itemRemovedWithoutEmit", itemsAdded: "itemsAdded", itemsRemoved: "itemsRemoved", leafClicked: "leafClicked", blankOptionClicked: "blankOptionClicked", lastIndexChanged: "lastIndexChanged", favoriteClicked: "favoriteClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 6, consts: [["class", "ex-group-outlet-history-container", 4, "ngIf"], ["tabindex", "0", "role", "option", 3, "ex-group-outlet-menu-option-blank", "id", "class", "click", "keydown.enter", 4, "ngIf"], [3, "ngModel", "ngModelChange"], ["searchResults", ""], [4, "ngFor", "ngForOf"], ["class", "ex-group-outlet-placeholder", 4, "ngIf"], [1, "ex-group-outlet-history-container"], [4, "ngIf"], ["tabindex", "0", "role", "option", 3, "id", "click", "keyup.space"], [3, "checked", "disabled", "uniqueSelector", "ariaLabel", "checkboxChange", 4, "ngIf"], [1, "ex-group-outlet-history-text"], ["class", "ex-group-outlet-history-title", 4, "ngFor", "ngForOf"], ["iconName", "recent", "tooltip", "ng.ui.group-outlet.recent-icon-alt-text", 1, "ex-group-outlet-history-icon"], [3, "checked", "disabled", "uniqueSelector", "ariaLabel", "checkboxChange"], [1, "ex-group-outlet-history-title"], ["tabindex", "0", "role", "option", 3, "id", "click", "keydown.enter"], [4, "ngIf", "ngIfElse"], ["leaf", ""], [3, "matTooltip"], ["role", "option", 3, "id", "disabled", "keydown.ArrowRight", "keydown.ArrowLeft", "keyup.enter", "click"], [1, "ex-group-outlet-expandable-header-title-wrapper"], [3, "checked", "indeterminate", "uniqueSelector", "ariaLabel", "checkboxChange", 4, "ngIf"], [1, "ex-group-outlet-expandable-header-title", 3, "innerHtml"], [1, "ex-group-outlet-expandable-header-arrow", "fa", "fa-angle-down"], ["role", "group"], [3, "items", "searchText", "isMultiSelect", "hasSelectAll", "selectedItems", "historyItems", "level", "itemsMap", "allowSingleSelectionInGroup", "uniqueSelector", "minimumSearchLength", "itemsAdded", "itemsRemoved", "itemAdded", "itemRemoved", "itemRemovedWithoutEmit", 4, "ngIf"], [3, "checked", "indeterminate", "uniqueSelector", "ariaLabel", "checkboxChange"], [3, "items", "searchText", "isMultiSelect", "hasSelectAll", "selectedItems", "historyItems", "level", "itemsMap", "allowSingleSelectionInGroup", "uniqueSelector", "minimumSearchLength", "itemsAdded", "itemsRemoved", "itemAdded", "itemRemoved", "itemRemovedWithoutEmit"], [3, "matTooltip", "ngClass", "mouseenter", "mouseleave"], ["role", "option", 3, "id", "disabled", "keydown.tab", "keydown.space", "click"], ["role", "button", "tabindex", "0", "iconName", "Star_checkbox_full", "class", "ex-group-outlet-favorite", 3, "id", "ariaHidden", "tooltip", "ariaLabel", "callback", "ex-group-outlet-favorite-hidden", "color", "keydown.tab", 4, "ngIf"], [1, "sel-menu-option", "ex-group-outlet-menu-option-text-wrapper"], [1, "ex-group-outlet-menu-option-text-and-icon-wrppaer"], [1, "ex-group-outlet-menu-option-text", 3, "innerHTML"], ["class", "ex-group-outlet-menu-option-icon", "tabindex", "0", 3, "id", "ariaHidden", "ex-group-outlet-menu-option-icon-hide", "color", "iconName", "callback", "tooltip", "ariaLabel", "keydown.tab", 4, "ngIf"], ["class", "ex-group-outlet-menu-option-text-description", 3, "innerHTML", 4, "ngIf"], [3, "checked", "uniqueSelector", "ariaLabel", "isStandalone", "checkboxChange", 4, "ngIf"], [3, "value", "change", 4, "ngIf"], [3, "checked", "uniqueSelector", "ariaLabel", "isStandalone", "checkboxChange"], [3, "value", "change"], ["role", "button", "tabindex", "0", "iconName", "Star_checkbox_full", 1, "ex-group-outlet-favorite", 3, "id", "ariaHidden", "tooltip", "ariaLabel", "callback", "color", "keydown.tab"], ["tabindex", "0", 1, "ex-group-outlet-menu-option-icon", 3, "id", "ariaHidden", "color", "iconName", "callback", "tooltip", "ariaLabel", "keydown.tab"], [1, "ex-group-outlet-menu-option-text-description", 3, "innerHTML"], [1, "ex-group-outlet-placeholder"]], template: function ExGroupOutletComponent2_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExGroupOutletComponent2_div_0_Template, 2, 1, "div", 0);
            i0.ɵɵtemplate(1, ExGroupOutletComponent2_div_1_Template, 4, 11, "div", 1);
            i0.ɵɵelementStart(2, "mat-radio-group", 2, 3);
            i0.ɵɵlistener("ngModelChange", function ExGroupOutletComponent2_Template_mat_radio_group_ngModelChange_2_listener($event) { return ctx.selectedItem = $event; });
            i0.ɵɵtemplate(4, ExGroupOutletComponent2_ng_container_4_Template, 4, 2, "ng-container", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ExGroupOutletComponent2_p_5_Template, 3, 3, "p", 5);
            i0.ɵɵtemplate(6, ExGroupOutletComponent2_p_6_Template, 3, 3, "p", 5);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.level == 1 && ctx.searchText === "" && (ctx.historyItems == null ? null : ctx.historyItems.length) > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.addBlankOption && ctx.searchText.length === 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.selectedItem);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.items);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.readyForDisplay() && (ctx.items == null ? null : ctx.items.length) < 1 && (ctx.showNoResultsPlaceholder || !ctx.showNoResultsPlaceholder && ctx.searchText != ""));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.readyForDisplay());
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i4.MatTooltip, ExCheckboxComponent, ExSvgIconComponent, i1$6.NgControlStatus, i1$6.NgModel, i8.MatRadioGroup, i8.MatRadioButton, ExGroupOutletComponent2, i1$2.TranslatePipe, ExTextHighlightPipe, ExClassNameFormatPipe, ExGenerateIdPipe], styles: [".ex-group-outlet-expandable-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding-left:10px;padding-right:10px;height:-moz-fit-content;height:fit-content;line-height:normal;padding-block:5px;background:#f2f2f2;border-top:1px solid #fff;border-bottom:1px solid #fff;width:100%;border-right:transparent;border-left:transparent;outline-width:0}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-title-wrapper[_ngcontent-%COMP%]{display:flex;overflow:hidden;align-items:center}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-title-wrapper[_ngcontent-%COMP%]   ex-checkbox[_ngcontent-%COMP%]{margin-right:10px}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-title-wrapper[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-title[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;text-align:start}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-title-wrapper[_ngcontent-%COMP%]   .ex-group-outlet-expandable-header-arrow[_ngcontent-%COMP%]{align-self:flex-start;margin-top:6px}.ex-group-outlet-placeholder[_ngcontent-%COMP%]{font-family:Roboto-light-italic;padding-inline-start:10px;padding-top:4px}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]:hover:not(:disabled), .ex-group-outlet-expandable-header[_ngcontent-%COMP%]:focus{background:#f5f5f5;border-top:1px solid #898989!important;border-bottom:1px solid #898989!important}.ex-group-outlet-expandable-header[_ngcontent-%COMP%]:disabled{opacity:.5}.ex-group-outlet-menu-option[_ngcontent-%COMP%]{padding:5px;padding-inline-start:20px;border-top:1px solid transparent;border-bottom:1px solid transparent;display:flex;background:transparent;width:100%;border-right:transparent;border-left:transparent;outline-width:0;text-align:inherit;align-items:flex-start}.ex-group-outlet-menu-option[_ngcontent-%COMP%]   ex-checkbox[_ngcontent-%COMP%]{margin-right:10px}.ex-group-outlet-menu-option[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-text-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;overflow:hidden;flex-grow:1}.ex-group-outlet-menu-option[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-text-wrapper[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-text-and-icon-wrppaer[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.ex-group-outlet-menu-option[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-text-wrapper[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-text[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;word-break:break-word}.ex-group-outlet-menu-option[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-icon[_ngcontent-%COMP%]{padding:2px 15px 0 10px;color:#222!important}.ex-group-outlet-menu-option[_ngcontent-%COMP%]:hover:not(:disabled), .ex-group-outlet-menu-option[_ngcontent-%COMP%]:focus{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-group-outlet-menu-option[_ngcontent-%COMP%]:disabled{opacity:.5}.ex-group-outlet-history-container[_ngcontent-%COMP%]{border-bottom:1px solid #ccc}.ex-group-outlet-history-container[_ngcontent-%COMP%]   .ex-group-outlet-history[_ngcontent-%COMP%]{padding:5px;padding-inline-start:20px;border-top:1px solid transparent;border-bottom:1px solid transparent;height:-moz-fit-content;height:fit-content;line-height:20px;display:flex;justify-content:space-between;flex-wrap:wrap}.ex-group-outlet-history-container[_ngcontent-%COMP%]   .ex-group-outlet-history[_ngcontent-%COMP%]   ex-checkbox[_ngcontent-%COMP%]{margin-right:10px}.ex-group-outlet-history-container[_ngcontent-%COMP%]   .ex-group-outlet-history[_ngcontent-%COMP%]   .ex-group-outlet-history-text[_ngcontent-%COMP%]{flex:1;word-break:break-word}.ex-group-outlet-history-container[_ngcontent-%COMP%]   .ex-group-outlet-history[_ngcontent-%COMP%]   .ex-group-outlet-history-icon[_ngcontent-%COMP%]{padding-right:5px}.ex-group-outlet-history-disabled[_ngcontent-%COMP%]{opacity:.5;cursor:default;pointer-events:none}.ex-group-outlet-history[_ngcontent-%COMP%]:hover, .ex-group-outlet-history[_ngcontent-%COMP%]:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-group-outlet-hasBorder[_ngcontent-%COMP%]{border-bottom:1px solid #ddd}.ex-group-outlet-favorite[_ngcontent-%COMP%]{cursor:pointer;padding-inline-end:10px}.ex-group-outlet-favorite[_ngcontent-%COMP%]:hover     .mat-icon{color:#555!important}.ex-group-outlet-favorite-hidden[_ngcontent-%COMP%]:not(:focus){visibility:hidden}.ex-group-outlet-menu-option-icon-hide[_ngcontent-%COMP%]{visibility:hidden}.ex-group-outlet-menu-option[_ngcontent-%COMP%]:focus-within   .ex-group-outlet-favorite-hidden[_ngcontent-%COMP%], .ex-group-outlet-menu-option[_ngcontent-%COMP%]   focus[_ngcontent-%COMP%]   .ex-group-outlet-favorite-hidden[_ngcontent-%COMP%]{visibility:visible!important}.ex-group-outlet-menu-option[_ngcontent-%COMP%]:focus-within   .ex-group-outlet-menu-option-icon-hide[_ngcontent-%COMP%], .ex-group-outlet-menu-option[_ngcontent-%COMP%]   focus[_ngcontent-%COMP%]   .ex-group-outlet-menu-option-icon-hide[_ngcontent-%COMP%]{visibility:visible!important}.ex-group-outlet-menu-option[_ngcontent-%COMP%]:focus-within     .ex-group-outlet-favorite-hidden, .ex-group-outlet-menu-option[_ngcontent-%COMP%]   focus[_ngcontent-%COMP%]     .ex-group-outlet-favorite-hidden{visibility:visible!important}.ex-group-outlet-menu-option-blank[_ngcontent-%COMP%]{padding-inline-start:45px!important}"], data: { animation: Animations$6 }, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGroupOutletComponent2, [{
        type: Component,
        args: [{ selector: 'ex-group-outlet-2', animations: Animations$6, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"level == 1 && searchText === '' && historyItems?.length > 0\" class=\"ex-group-outlet-history-container\">\n  <ng-container *ngFor=\"let item of historyItems; let index = index\">\n    <ng-container *ngIf=\"historyMap[item.key]\">\n      <div class=\"ex-group-outlet-history {{('ex-group-outlet-history-' + item.key  + (uniqueSelector ? '-' + uniqueSelector : '')) | generateHTMLId}}\" tabindex=\"0\" role=\"option\" [id]=\"'ex-combobox-'+ index\"\n           (click)=\"onItemClicked(historyMap[item.key].item)\" [class.ex-group-outlet-history-disabled]=\"historyMap[item.key].item?.disabled\"\n            (keyup.space)=\"onItemClicked(historyMap[item.key].item)\">\n        <ex-checkbox *ngIf=\"isMultiSelect &&!allowSingleSelectionInGroup\" [checked]=\"itemsMap[item.key]?.all\"\n                     (checkboxChange)=\"onItemClicked(historyMap[item.key].item)\" [disabled]=\"historyMap[item.key].item?.disabled\"\n                     [uniqueSelector]=\"'ex-group-outlet-history-checkbox-'+ item.key + (uniqueSelector ? '-' + uniqueSelector : '')\"\n                     [ariaLabel]=\"historyMap[item.key].item.value\">\n        </ex-checkbox>\n        <span class=\"ex-group-outlet-history-text\">\n                    <span *ngFor=\"let parent of historyMap[item.key].parentValue\"\n                          class=\"ex-group-outlet-history-title\">{{parent}}: </span>\n                    <span>{{ historyMap[item.key].item.value }}</span>\n                </span>\n        <ex-svg-icon class=\"ex-group-outlet-history-icon\" iconName=\"recent\" tooltip=\"ng.ui.group-outlet.recent-icon-alt-text\"></ex-svg-icon>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n\n<div *ngIf=\"addBlankOption && searchText.length === 0\" tabindex=\"0\"\n     [class.ex-group-outlet-menu-option-blank]=\"hasFavorite\"\n     role=\"option\" [id]=\"'ex-combobox-' + (historyItems?.length ?? 0)\" class=\"ex-group-outlet-menu-option {{('ex-group-outlet-blank-option' + (uniqueSelector ? '-' + uniqueSelector : '')) | generateHTMLId}}\"\n     (click)=\"_blankOptionClicked()\" (keydown.enter)=\"_blankOptionClicked()\">\n  {{ 'ng.general.none' | translate }}\n</div>\n\n<mat-radio-group [(ngModel)]=\"selectedItem\" #searchResults>\n  <ng-container *ngFor=\"let item of items; let index = index\">\n    <ng-container *ngIf=\"item.subItems && item.subItems.length > 0; else leaf\">\n      <div matTooltip=\"{{ item.tooltip | translate }}\">\n        <button role=\"option\" [id]=\"'ex-combobox-' + (itemsMap[item.key].index + historyItems?.length)\"\n                class=\"ex-group-outlet-expandable-header {{(uniqueSelector ? uniqueSelector + '-' + item.key : item) | generateHTMLId}}\" (keydown.ArrowRight)=\"onHeaderClicked(index)\"\n                (keydown.ArrowLeft)=\"onHeaderClicked(index)\" (keyup.enter)=\"onHeaderCheckboxClicked(item)\"\n                (click)=\"onHeaderClicked(index)\" [style.padding-inline-start.px]=\"20 * level\"\n                [disabled]=\"item.disabled\" [attr.aria-label]=\"(item.value | translate) + ' '\n                 + ((item.expanded ? 'ng.general.group-outlet.expanded' : 'ng.general.group-outlet.collapsed') | translate) + ' '\n                 + ('ng.general.group-outlet.level' | translate) + ' ' + level\"\n                [attr.aria-checked]=\"isMultiSelect && !allowSingleSelectionInGroup && hasSelectAll ? itemsMap[item.key]?.all : ''\">\n          <div class=\"ex-group-outlet-expandable-header-title-wrapper\">\n            <ex-checkbox *ngIf=\"isMultiSelect && !allowSingleSelectionInGroup && hasSelectAll\"\n                         [checked]=\"itemsMap[item.key].all\" [indeterminate]=\"itemsMap[item.key].some && !itemsMap[item.key].all\" (checkboxChange)=\"onHeaderCheckboxClicked(item)\"\n                         [uniqueSelector]=\"'ex-group-outlet-expandable-header-checkbox-'+ item.key + (uniqueSelector ? '-' + uniqueSelector : '')\"\n                         [ariaLabel]=\"item.value | translate\">\n            </ex-checkbox>\n            <span class=\"ex-group-outlet-expandable-header-title\"\n                  [innerHtml]=\"item.value | translate | exTextHighlight: searchText\"></span>\n          </div>\n          <i [@arrowFlip2]=\"item.expanded ? 'down' : 'up'\"\n             class=\"ex-group-outlet-expandable-header-arrow fa fa-angle-down\"></i>\n        </button>\n      </div>\n      <div role=\"group\" [attr.aria-labelledby]=\"'ex-combobox-' + (itemsMap[item.key].index + historyItems?.length)\"\n           [@expendAndcollapse2]=\"item.expanded ? 'expanded' : 'collapsed'\">\n        <ex-group-outlet-2 *ngIf=\"item.expanded\" [items]=\"item.subItems\" [searchText]=\"searchText\"\n                           [isMultiSelect]=\"isMultiSelect\" [hasSelectAll]=\"hasSelectAll\" [selectedItems]=\"selectedItems\"\n                           [historyItems]=\"historyItems\" [level]=\"level + 1\" [itemsMap]=\"itemsMap\"\n                           [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\"\n                           [uniqueSelector]=\"'ex-group-outlet-level-' + level + '-' + (uniqueSelector ? uniqueSelector + '-' + item.key : item.key)\"\n                           (itemsAdded)=\"itemsAdded.emit($event)\"\n                           [minimumSearchLength]=\"minimumSearchLength\" (itemsRemoved)=\"itemsRemoved.emit($event)\"\n                           (itemAdded)=\"itemAdded.emit($event)\" (itemRemoved)=\"itemRemoved.emit($event)\"\n                           (itemRemovedWithoutEmit)=\"itemRemovedWithoutEmit.emit($event)\">\n        </ex-group-outlet-2>\n      </div>\n    </ng-container>\n    <ng-template #leaf>\n      <div matTooltip=\"{{ item.tooltip | translate }}\" [ngClass]=\"{'ex-group-outlet-hasBorder': item.hasBorder}\"\n           (mouseenter)=\"item.hover = true\" (mouseleave)=\"item.hover = false\"\n      >\n        <button [id]=\"'ex-combobox-' + (itemsMap[item.key].index + historyItems?.length)\" role=\"option\"\n                (keydown.tab)=\"navigateToFavorite($event,item, index)\"\n                [attr.aria-selected]=\"!(isMultiSelect && !allowSingleSelectionInGroup) ? itemsMap[item.key].all : ''\"\n                class=\"ex-group-outlet-menu-option sel-menu-option sel-combobox-option-{{item.key | exClassNameFormat }} {{(uniqueSelector ? uniqueSelector + '-' + item.key : item) | generateHTMLId}}\"\n                [style.padding-left.px]=\"20 * (isMultiSelect && allowSingleSelectionInGroup ? level -1 : level )\"\n                (keydown.space)=\"onItemClicked(item,!isMultiSelect);isMultiSelect && $event.preventDefault()\"\n                (click)=\"onItemClicked(item, true)\" [disabled]=\"item.disabled\"\n                [attr.aria-label]=\"(getValue(item) | translate) + ' ' + ('ng.general.group-outlet.level' | translate) + ' ' + level\"\n                [attr.aria-checked]=\"isMultiSelect && !allowSingleSelectionInGroup ? itemsMap[item.key]?.all : ''\">\n          <ng-container *ngIf=\"isMultiSelect\">\n            <ex-checkbox *ngIf=\"!allowSingleSelectionInGroup\" [checked]=\"itemsMap[item.key].all\"\n                         [uniqueSelector]=\"'ex-group-outlet-combobox-option-'+ item.key + (uniqueSelector ? '-' + uniqueSelector : '')\"\n                         (checkboxChange)=\"onItemClicked(item)\" [ariaLabel]=\"getValue(item) | translate\"\n                         [isStandalone]=\"isCheckboxStandaloneInLeaf\">\n            </ex-checkbox>\n            <mat-radio-button *ngIf=\"allowSingleSelectionInGroup\" (change)=\"onItemClicked(item)\"\n                              [value]=\"item.key\">\n            </mat-radio-button>\n          </ng-container>\n          <ex-svg-icon [id]=\"favoriteId + index\" *ngIf=\"hasFavorite\" role=\"button\"\n                       (keydown.tab)=\"navigateToIcon($event,item, index)\" [ariaHidden]=\"false\"\n                       [tooltip]=\"item.favorite? 'ng.general.default' : 'ng.general.set_to_default'\"\n                       [ariaLabel]=\"item.favorite? 'ng.general.default' : 'ng.general.set_to_default'\"\n                       tabindex=\"0\" iconName=\"Star_checkbox_full\" [callback]=\"onfavoriteClicked.bind(this,item)\"\n                       [class.ex-group-outlet-favorite-hidden]=\"!(item.hover || item.favorite)\"\n                       [color]=\"item.favorite? '#337ab7': '#898989'\" class=\"ex-group-outlet-favorite\"></ex-svg-icon>\n\n          <div class=\"sel-menu-option ex-group-outlet-menu-option-text-wrapper\">\n            <div class=\"ex-group-outlet-menu-option-text-and-icon-wrppaer\">\n                            <span class=\"ex-group-outlet-menu-option-text\"\n                                  [innerHTML]=\"(getValue(item) | translate) | exTextHighlight: searchText\"\n                                  [class.ex-group-outlet-menu-option-title-bold]=\"!!item.description\"></span>\n              <ex-svg-icon class=\"ex-group-outlet-menu-option-icon\" tabindex=\"0\" [id]=\"'icon' + index\"\n                           [attr.role]=\"!!item.icon.callback? 'button' : undefined\"\n                           (keydown.tab)=\"navigateToItem($event,item, index)\" [ariaHidden]=\"false\"\n                           [class.ex-group-outlet-menu-option-icon-hide]=\"!!item.icon.callback && !item.hover\"\n                           *ngIf=\"item.icon\"\n                           [color]=\"item.icon.iconColor\" [iconName]=\"item.icon.iconName\"\n                           [callback]=\"item.icon.callback\" [tooltip]=\"item.icon?.tooltip\"\n                           [ariaLabel]=\"item.icon.tooltip\"></ex-svg-icon>\n            </div>\n            <span class=\"ex-group-outlet-menu-option-text-description\" *ngIf=\"item.description\"\n                  [innerHTML]=\"(item.description | translate) | exTextHighlight: searchText\"></span>\n          </div>\n        </button>\n      </div>\n    </ng-template>\n  </ng-container>\n</mat-radio-group>\n\n<p *ngIf=\"readyForDisplay() &&  items?.length < 1 && (showNoResultsPlaceholder || (!showNoResultsPlaceholder && (searchText != '')))\" class=\"ex-group-outlet-placeholder\">\n  {{ noResultsLabel | translate }}\n</p>\n\n<p *ngIf=\"!readyForDisplay()\" class=\"ex-group-outlet-placeholder\">\n  {{ notReadyForDisplayLabel | translate }}\n</p>\n", styles: [".ex-group-outlet-expandable-header{display:flex;justify-content:space-between;align-items:center;padding-left:10px;padding-right:10px;height:-moz-fit-content;height:fit-content;line-height:normal;padding-block:5px;background:#f2f2f2;border-top:1px solid #fff;border-bottom:1px solid #fff;width:100%;border-right:transparent;border-left:transparent;outline-width:0}.ex-group-outlet-expandable-header .ex-group-outlet-expandable-header-title-wrapper{display:flex;overflow:hidden;align-items:center}.ex-group-outlet-expandable-header .ex-group-outlet-expandable-header-title-wrapper ex-checkbox{margin-right:10px}.ex-group-outlet-expandable-header .ex-group-outlet-expandable-header-title-wrapper .ex-group-outlet-expandable-header-title{overflow:hidden;text-overflow:ellipsis;text-align:start}.ex-group-outlet-expandable-header .ex-group-outlet-expandable-header-title-wrapper .ex-group-outlet-expandable-header-arrow{align-self:flex-start;margin-top:6px}.ex-group-outlet-placeholder{font-family:Roboto-light-italic;padding-inline-start:10px;padding-top:4px}.ex-group-outlet-expandable-header:hover:not(:disabled),.ex-group-outlet-expandable-header:focus{background:#f5f5f5;border-top:1px solid #898989!important;border-bottom:1px solid #898989!important}.ex-group-outlet-expandable-header:disabled{opacity:.5}.ex-group-outlet-menu-option{padding:5px;padding-inline-start:20px;border-top:1px solid transparent;border-bottom:1px solid transparent;display:flex;background:transparent;width:100%;border-right:transparent;border-left:transparent;outline-width:0;text-align:inherit;align-items:flex-start}.ex-group-outlet-menu-option ex-checkbox{margin-right:10px}.ex-group-outlet-menu-option .ex-group-outlet-menu-option-text-wrapper{display:flex;flex-direction:column;overflow:hidden;flex-grow:1}.ex-group-outlet-menu-option .ex-group-outlet-menu-option-text-wrapper .ex-group-outlet-menu-option-text-and-icon-wrppaer{display:flex;flex-direction:row;justify-content:space-between}.ex-group-outlet-menu-option .ex-group-outlet-menu-option-text-wrapper .ex-group-outlet-menu-option-text{overflow:hidden;text-overflow:ellipsis;word-break:break-word}.ex-group-outlet-menu-option .ex-group-outlet-menu-option-icon{padding:2px 15px 0 10px;color:#222!important}.ex-group-outlet-menu-option:hover:not(:disabled),.ex-group-outlet-menu-option:focus{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-group-outlet-menu-option:disabled{opacity:.5}.ex-group-outlet-history-container{border-bottom:1px solid #ccc}.ex-group-outlet-history-container .ex-group-outlet-history{padding:5px;padding-inline-start:20px;border-top:1px solid transparent;border-bottom:1px solid transparent;height:-moz-fit-content;height:fit-content;line-height:20px;display:flex;justify-content:space-between;flex-wrap:wrap}.ex-group-outlet-history-container .ex-group-outlet-history ex-checkbox{margin-right:10px}.ex-group-outlet-history-container .ex-group-outlet-history .ex-group-outlet-history-text{flex:1;word-break:break-word}.ex-group-outlet-history-container .ex-group-outlet-history .ex-group-outlet-history-icon{padding-right:5px}.ex-group-outlet-history-disabled{opacity:.5;cursor:default;pointer-events:none}.ex-group-outlet-history:hover,.ex-group-outlet-history:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.ex-group-outlet-hasBorder{border-bottom:1px solid #ddd}.ex-group-outlet-favorite{cursor:pointer;padding-inline-end:10px}.ex-group-outlet-favorite:hover ::ng-deep .mat-icon{color:#555!important}.ex-group-outlet-favorite-hidden:not(:focus){visibility:hidden}.ex-group-outlet-menu-option-icon-hide{visibility:hidden}.ex-group-outlet-menu-option:focus-within .ex-group-outlet-favorite-hidden,.ex-group-outlet-menu-option focus .ex-group-outlet-favorite-hidden{visibility:visible!important}.ex-group-outlet-menu-option:focus-within .ex-group-outlet-menu-option-icon-hide,.ex-group-outlet-menu-option focus .ex-group-outlet-menu-option-icon-hide{visibility:visible!important}.ex-group-outlet-menu-option:focus-within ::ng-deep .ex-group-outlet-favorite-hidden,.ex-group-outlet-menu-option focus ::ng-deep .ex-group-outlet-favorite-hidden{visibility:visible!important}.ex-group-outlet-menu-option-blank{padding-inline-start:45px!important}\n"] }]
    }], function () { return [{ type: ExLiveAnnouncerService }, { type: i1$2.TranslateService }]; }, { items: [{
            type: Input
        }], historyItems: [{
            type: Input
        }], showAllHistory: [{
            type: Input
        }], searchText: [{
            type: Input
        }], isMultiSelect: [{
            type: Input
        }], hasSelectAll: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], addBlankOption: [{
            type: Input
        }], level: [{
            type: Input
        }], itemsMap: [{
            type: Input
        }], unlistedValueSuffix: [{
            type: Input
        }], allowSingleSelectionInGroup: [{
            type: Input
        }], minimumSearchLength: [{
            type: Input
        }], showNoResultsPlaceholder: [{
            type: Input
        }], isCheckboxStandaloneInLeaf: [{
            type: Input
        }], hasFavorite: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], itemAdded: [{
            type: Output
        }], itemRemoved: [{
            type: Output
        }], itemRemovedWithoutEmit: [{
            type: Output
        }], itemsAdded: [{
            type: Output
        }], itemsRemoved: [{
            type: Output
        }], leafClicked: [{
            type: Output
        }], blankOptionClicked: [{
            type: Output
        }], lastIndexChanged: [{
            type: Output
        }], favoriteClicked: [{
            type: Output
        }], searchResults: [{
            type: ViewChild,
            args: ['searchResults', { read: ElementRef }]
        }] }); })();

function ExComboboxTriggerComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    i0.ɵɵclassProp("ex-combobox-trigger-group", !last_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 4, item_r1), "", !last_r2 ? ":" : "", "");
} }
class ExComboboxTriggerComponent {
    constructor() {
        this.disabled = false;
        this.flatValue = [];
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedItems')) {
            this.flatValue = [];
            this.flatternValue(this.selectedItems[0]);
        }
    }
    flatternValue(value) {
        this.flatValue.push(value.value);
        if (value.subItems && value.subItems.length > 0) {
            this.flatternValue(value.subItems[0]);
        }
    }
    static { this.ɵfac = function ExComboboxTriggerComponent_Factory(t) { return new (t || ExComboboxTriggerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComboboxTriggerComponent, selectors: [["ex-combobox-trigger"]], inputs: { selectedItems: "selectedItems", disabled: "disabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [[1, "ex-combobox-trigger-selected-value", 3, "exTooltip"], ["class", "sel-combobox-selected-value", 3, "ex-combobox-trigger-group", 4, "ngFor", "ngForOf"], [1, "sel-combobox-selected-value"]], template: function ExComboboxTriggerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵtemplate(2, ExComboboxTriggerComponent_span_2_Template, 3, 6, "span", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("exTooltip", !ctx.disabled ? i0.ɵɵpipeBind1(1, 2, ctx.flatValue[ctx.flatValue.length - 1]) : null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.flatValue);
        } }, dependencies: [i1$5.NgForOf, ExTooltipDirective, i1$2.TranslatePipe], styles: [".ex-combobox-trigger-group[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}.ex-combobox-trigger-selected-value[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:break-spaces;line-height:normal}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxTriggerComponent, [{
        type: Component,
        args: [{ selector: 'ex-combobox-trigger', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-combobox-trigger-selected-value\" [exTooltip]=\"!disabled ? (flatValue[flatValue.length - 1] | translate) : null\">\r\n    <span *ngFor=\"let item of flatValue; let last = last\" [class.ex-combobox-trigger-group]=\"!last\"\r\n        class=\"sel-combobox-selected-value\">{{ item | translate }}{{ !last ? ':' : ''}}</span>\r\n</div>\r\n", styles: [".ex-combobox-trigger-group:not(:last-child){margin-right:5px}.ex-combobox-trigger-selected-value{overflow:hidden;text-overflow:ellipsis;white-space:break-spaces;line-height:normal}\n"] }]
    }], function () { return []; }, { selectedItems: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

function ExChipComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("font-weight", ctx_r1.fontWeight);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.value);
} }
function ExChipComponent_ng_content_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngSwitchDefault", ""]);
} }
const _c0$1s = [[["", "icon-left", ""]], [["", "icon-right", ""]], [["", "text", ""]]];
const _c1$V = function (a0, a1, a2, a3) { return { "background": a0, "border-color": a1, "color": a2, "border-radius": a3 }; };
const _c2$D = function (a0, a1, a2, a3, a4, a5, a6, a7, a8) { return { "ex-chip-has-border": a0, "ex-chip-has-text": a1, "ex-chip-text-extra-small": a2, "ex-chip-text-small": a3, "ex-chip-text-normal": a4, "ex-chip-text-large": a5, "ex-chip-rounded-radius": a6, "ex-chip-normal-radius": a7, "ex-chip-square": a8 }; };
const _c3$u = ["[icon-left]", "[icon-right]", "[text]"];
class ExChipComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * Label text value
         */
        this.value = "";
        /**
         * Background color of the whole chip
         */
        this.background = 'white';
        /**
         * font color of the whole chip
         */
        this.fontColor = 'black';
        /**
         * Chip size
         */
        this.size = 'normal';
        /**
         * Border color of the whole chip
         */
        this.borderColor = 'inherit';
        /**
         * Indicates if there will be a border around the chip
         */
        this.hasBorder = true;
        /**
         * Indicates if the chip will be completely round
         */
        this.rounded = false;
        /**
         * Indicates if the chip will have the same height and width
         */
        this.square = false;
        /**
         * Indicates the chip border radius
         */
        this.borderRadius = '3px';
        this.fontWeight = 300;
        this.ariaLabel = null;
        this.tooltip = null;
        /**
         * Emits an event of the whole chip click
         */
        this.chipClicked = new EventEmitter();
    }
    ngAfterViewInit() {
        this.cdr.markForCheck();
    }
    onChipClick() {
        this.chipClicked.emit();
    }
    static { this.ɵfac = function ExChipComponent_Factory(t) { return new (t || ExChipComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExChipComponent, selectors: [["ex-chip"]], inputs: { value: "value", background: "background", fontColor: "fontColor", size: "size", borderColor: "borderColor", hasBorder: "hasBorder", rounded: "rounded", square: "square", borderRadius: "borderRadius", fontWeight: "fontWeight", ariaLabel: "ariaLabel", tooltip: "tooltip" }, outputs: { chipClicked: "chipClicked" }, ngContentSelectors: _c3$u, decls: 11, vars: 23, consts: [[1, "ex-chip-chip-wrapper", "sel-ex-chip-chip-wrapper", 3, "exTooltip", "ngStyle", "ngClass", "click"], [1, "ex-chip-icon", "ex-chip-icon-left"], [1, "ex-chip-text"], [1, "ex-chip-text-value", 3, "ngSwitch"], ["text", ""], [3, "font-weight", 4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "ex-chip-icon", "ex-chip-icon-right", "ex-chip-icon-right-with-text", "sel-ex-chip-chip-right-icon"]], template: function ExChipComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$1s);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExChipComponent_Template_div_click_0_listener() { return ctx.onChipClick(); });
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2)(5, "div", 3, 4);
            i0.ɵɵtemplate(7, ExChipComponent_span_7_Template, 2, 3, "span", 5);
            i0.ɵɵtemplate(8, ExChipComponent_ng_content_8_Template, 1, 0, "ng-content", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 7);
            i0.ɵɵprojection(10, 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r0 = i0.ɵɵreference(6);
            i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 6, ctx.tooltip))("ngStyle", i0.ɵɵpureFunction4(8, _c1$V, ctx.background, ctx.borderColor, ctx.fontColor, ctx.rounded ? "50%" : ctx.borderRadius))("ngClass", i0.ɵɵpureFunctionV(13, _c2$D, [ctx.hasBorder == true, (ctx.value == null ? null : ctx.value.length) > 0 || _r0.children.length > 0, ctx.size == "extra-small", ctx.size == "small", ctx.size == "normal", ctx.size == "large", ctx.rounded, !ctx.rounded, ctx.square]));
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngSwitch", !!ctx.value);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitchCase", true);
        } }, dependencies: [i1$5.NgClass, i1$5.NgStyle, i1$5.NgSwitch, i1$5.NgSwitchCase, i1$5.NgSwitchDefault, ExTooltipDirective, i1$2.TranslatePipe], styles: [".ex-chip-chip-wrapper[_ngcontent-%COMP%]{display:flex;overflow:hidden;align-items:center;min-height:20px;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-chip-chip-wrapper[_ngcontent-%COMP%]   .ex-chip-text[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:column;overflow:hidden}.ex-chip-chip-wrapper[_ngcontent-%COMP%]   .ex-chip-text[_ngcontent-%COMP%] > .ex-chip-text-value[_ngcontent-%COMP%]{overflow:hidden;white-space:pre-line;text-overflow:ellipsis}.ex-chip-chip-wrapper.ex-chip-has-text[_ngcontent-%COMP%]   .ex-chip-icon[_ngcontent-%COMP%]{display:flex}.ex-chip-chip-wrapper.ex-chip-has-text[_ngcontent-%COMP%]   .ex-chip-icon-left[_ngcontent-%COMP%]    >:first-child{margin-inline-end:5px}.ex-chip-chip-wrapper.ex-chip-has-text[_ngcontent-%COMP%]   .ex-chip-icon-right[_ngcontent-%COMP%]    >:first-child{margin-inline-start:5px}.ex-chip-square[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.ex-chip-text-extra-small.ex-chip-square[_ngcontent-%COMP%]{min-height:17px;min-width:17px;padding:1px 0}.ex-chip-text-small[_ngcontent-%COMP%]{padding:1px 6px}.ex-chip-text-small.ex-chip-square[_ngcontent-%COMP%]{min-height:22px;min-width:22px;padding:1px 0}.ex-chip-text-normal[_ngcontent-%COMP%]{padding:1px 9px}.ex-chip-text-normal.ex-chip-square[_ngcontent-%COMP%]{min-height:28px;min-width:28px;padding:1px 0}.ex-chip-text-large[_ngcontent-%COMP%]{padding:1px 11px}.ex-chip-text-large.ex-chip-square[_ngcontent-%COMP%]{min-height:32px;min-width:32px;padding:1px 0}.ex-chip-has-border[_ngcontent-%COMP%]{border-style:solid;border-width:1px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChipComponent, [{
        type: Component,
        args: [{ selector: 'ex-chip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-chip-chip-wrapper sel-ex-chip-chip-wrapper\" [exTooltip]=\"tooltip | translate\"\n    [ngStyle]=\"{'background': background, 'border-color': borderColor, 'color': fontColor, 'border-radius':  rounded? '50%' : borderRadius}\"\n    [ngClass]=\"{'ex-chip-has-border': hasBorder == true,\n                'ex-chip-has-text': value?.length > 0 || text.children.length > 0,\n                'ex-chip-text-extra-small': size == 'extra-small',\n                'ex-chip-text-small': size == 'small',\n                'ex-chip-text-normal': size == 'normal',\n                'ex-chip-text-large': size == 'large',\n                'ex-chip-rounded-radius' : rounded,\n                'ex-chip-normal-radius': !rounded,\n                'ex-chip-square': square }\" (click)=\"onChipClick()\">\n    <div class=\"ex-chip-icon ex-chip-icon-left\" [attr.aria-label]=\"ariaLabel\">\n        <ng-content select=\"[icon-left]\"></ng-content>\n    </div>\n    <div class=\"ex-chip-text\" >\n        <div [ngSwitch]=\"!!value\" class=\"ex-chip-text-value\" #text>\n            <span *ngSwitchCase=\"true\" [style.font-weight]=\"fontWeight\">{{value}}</span>\n            <ng-content *ngSwitchDefault select=\"[text]\"></ng-content>\n        </div>\n    </div>\n    <div class=\"ex-chip-icon ex-chip-icon-right ex-chip-icon-right-with-text sel-ex-chip-chip-right-icon\">\n        <ng-content select=\"[icon-right]\"></ng-content>\n    </div>\n</div>\n", styles: [".ex-chip-chip-wrapper{display:flex;overflow:hidden;align-items:center;min-height:20px;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-chip-chip-wrapper .ex-chip-text{display:flex;justify-content:center;flex-direction:column;overflow:hidden}.ex-chip-chip-wrapper .ex-chip-text>.ex-chip-text-value{overflow:hidden;white-space:pre-line;text-overflow:ellipsis}.ex-chip-chip-wrapper.ex-chip-has-text .ex-chip-icon{display:flex}.ex-chip-chip-wrapper.ex-chip-has-text .ex-chip-icon-left ::ng-deep>:first-child{margin-inline-end:5px}.ex-chip-chip-wrapper.ex-chip-has-text .ex-chip-icon-right ::ng-deep>:first-child{margin-inline-start:5px}.ex-chip-square{display:flex;align-items:center;justify-content:center}.ex-chip-text-extra-small.ex-chip-square{min-height:17px;min-width:17px;padding:1px 0}.ex-chip-text-small{padding:1px 6px}.ex-chip-text-small.ex-chip-square{min-height:22px;min-width:22px;padding:1px 0}.ex-chip-text-normal{padding:1px 9px}.ex-chip-text-normal.ex-chip-square{min-height:28px;min-width:28px;padding:1px 0}.ex-chip-text-large{padding:1px 11px}.ex-chip-text-large.ex-chip-square{min-height:32px;min-width:32px;padding:1px 0}.ex-chip-has-border{border-style:solid;border-width:1px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { value: [{
            type: Input
        }], background: [{
            type: Input
        }], fontColor: [{
            type: Input
        }], size: [{
            type: Input
        }], borderColor: [{
            type: Input
        }], hasBorder: [{
            type: Input
        }], rounded: [{
            type: Input
        }], square: [{
            type: Input
        }], borderRadius: [{
            type: Input
        }], fontWeight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], chipClicked: [{
            type: Output,
            args: ['chipClicked']
        }] }); })();

const _c0$1r = function (a0) { return { selectedItem: a0 }; };
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_chip_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_chip_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const selected_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onRemoveClicked(selected_r1)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    const selected_r1 = ctx_r12.$implicit;
    const indexOfelement_r2 = ctx_r12.index;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 3, "ng.general.remove"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 5, "ng.general.remove_selected_item", i0.ɵɵpureFunction1(10, _c0$1r, i0.ɵɵpipeBind1(3, 8, selected_r1.value))))("aria-describedby", ctx_r8.unique + "-" + indexOfelement_r2);
} }
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_chip_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 7);
    i0.ɵɵtemplate(1, ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_chip_2_button_1_Template, 5, 12, "button", 8);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("square", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.isReadOnly);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "ng.general.all"));
} }
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_combobox_multiselect_trigger_chip_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-combobox-multiselect-trigger-chip", 12);
    i0.ɵɵlistener("itemRemoved", function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_combobox_multiselect_trigger_chip_3_Template_ex_combobox_multiselect_trigger_chip_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.itemRemoved.emit($event)); })("itemsRemoved", function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_combobox_multiselect_trigger_chip_3_Template_ex_combobox_multiselect_trigger_chip_itemsRemoved_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.itemsRemoved.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedItems", selected_r1.subItems)("isReadOnly", ctx_r7.isReadOnly)("allowSingleSelectionInGroup", ctx_r7.allowSingleSelectionInGroup);
} }
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementContainer(1, 4);
    i0.ɵɵtemplate(2, ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_chip_2_Template, 5, 5, "ex-chip", 5);
    i0.ɵɵtemplate(3, ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_ex_combobox_multiselect_trigger_chip_3_Template, 1, 3, "ex-combobox-multiselect-trigger-chip", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r1 = i0.ɵɵnextContext().$implicit;
    const _r4 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.allowSingleSelectionInGroup && selected_r1.all);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.allowSingleSelectionInGroup || !selected_r1.all);
} }
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_ng_template_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ExComboboxMultiselectTriggerChipComponent_ng_container_0_ng_template_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const selected_r1 = i0.ɵɵnextContext(2).$implicit; const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onRemoveClicked(selected_r1)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    const selected_r1 = ctx_r22.$implicit;
    const indexOfelement_r2 = ctx_r22.index;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 3, "ng.general.remove"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 5, "ng.general.remove_selected_item", i0.ɵɵpureFunction1(10, _c0$1r, i0.ɵɵpipeBind1(3, 8, selected_r1.value))))("aria-describedby", ctx_r18.unique + "-" + indexOfelement_r2);
} }
const _c1$U = function (a0) { return { "ex-combobox-multiselect-trigger-chip-leaf": a0 }; };
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 13);
    i0.ɵɵtemplate(1, ExComboboxMultiselectTriggerChipComponent_ng_container_0_ng_template_2_button_1_Template, 5, 12, "button", 8);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    const selected_r1 = ctx_r23.$implicit;
    const indexOfelement_r2 = ctx_r23.index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$U, !selected_r1.subItems || selected_r1.subItems.length === 0))("background", !selected_r1.subItems || selected_r1.subItems.length === 0 ? "#F4F4F4" : "white")("square", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isReadOnly && !ctx_r5.isGroup(selected_r1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r5.unique + "-" + indexOfelement_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 7, selected_r1.value), "", ctx_r5.isGroup(selected_r1) ? ":" : "", "");
} }
function ExComboboxMultiselectTriggerChipComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExComboboxMultiselectTriggerChipComponent_ng_container_0_div_1_Template, 4, 3, "div", 1);
    i0.ɵɵtemplate(2, ExComboboxMultiselectTriggerChipComponent_ng_container_0_ng_template_2_Template, 5, 11, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selected_r1 = ctx.$implicit;
    const _r4 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isGroup(selected_r1))("ngIfElse", _r4);
} }
class ExComboboxMultiselectTriggerChipComponent {
    constructor() {
        this.unique = this.constructor['ɵcmp'].id;
        this.isReadOnly = false;
        this.allowSingleSelectionInGroup = false;
        this.itemRemoved = new EventEmitter();
        this.itemsRemoved = new EventEmitter();
    }
    ngOnInit() {
    }
    onRemoveClicked(item) {
        event.stopPropagation();
        if (item.subItems && item.subItems.length > 0) {
            this.itemsRemoved.emit(item.subItems);
        }
        else {
            this.itemRemoved.emit(item.key);
        }
    }
    isGroup(item) {
        return item.subItems && item.subItems.length > 0;
    }
    static { this.ɵfac = function ExComboboxMultiselectTriggerChipComponent_Factory(t) { return new (t || ExComboboxMultiselectTriggerChipComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComboboxMultiselectTriggerChipComponent, selectors: [["ex-combobox-multiselect-trigger-chip"]], inputs: { selectedItems: "selectedItems", isReadOnly: "isReadOnly", allowSingleSelectionInGroup: "allowSingleSelectionInGroup" }, outputs: { itemRemoved: "itemRemoved", itemsRemoved: "itemsRemoved" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["class", "ex-combobox-multiselect-trigger-chip-group-wrapper", 4, "ngIf", "ngIfElse"], ["chip", ""], [1, "ex-combobox-multiselect-trigger-chip-group-wrapper"], [3, "ngTemplateOutlet"], ["class", "ex-combobox-multiselect-trigger-chip ex-combobox-multiselect-trigger-chip-leaf", "background", "#F4F4F4", "fontColor", "#222", "size", "small", "borderColor", "#dedede", 3, "square", 4, "ngIf"], ["class", "ex-combobox-multiselect-trigger-wrapper-chip", 3, "selectedItems", "isReadOnly", "allowSingleSelectionInGroup", "itemRemoved", "itemsRemoved", 4, "ngIf"], ["background", "#F4F4F4", "fontColor", "#222", "size", "small", "borderColor", "#dedede", 1, "ex-combobox-multiselect-trigger-chip", "ex-combobox-multiselect-trigger-chip-leaf", 3, "square"], ["icon-right", "", "class", "ex-combobox-multiselect-trigger-chip-remove", 3, "exTooltip", "click", 4, "ngIf"], ["text", ""], ["icon-right", "", 1, "ex-combobox-multiselect-trigger-chip-remove", 3, "exTooltip", "click"], [1, "uxf-icon", "uxf-close"], [1, "ex-combobox-multiselect-trigger-wrapper-chip", 3, "selectedItems", "isReadOnly", "allowSingleSelectionInGroup", "itemRemoved", "itemsRemoved"], ["fontColor", "#222", "size", "small", "borderColor", "#dedede", 1, "ex-combobox-multiselect-trigger-chip", 3, "ngClass", "background", "square"], ["text", "", 3, "id"]], template: function ExComboboxMultiselectTriggerChipComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExComboboxMultiselectTriggerChipComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.selectedItems);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExChipComponent, ExTooltipDirective, ExComboboxMultiselectTriggerChipComponent, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{display:flex;flex-wrap:wrap;overflow:hidden;flex-direction:column}.ex-combobox-multiselect-trigger-chip-group-wrapper[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.ex-combobox-multiselect-trigger-chip-group-wrapper[_ngcontent-%COMP%]   .ex-combobox-multiselect-trigger-wrapper-chip[_ngcontent-%COMP%]{display:contents}.ex-combobox-multiselect-trigger-chip[_ngcontent-%COMP%]{margin-inline-end:5px;margin-bottom:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ex-combobox-multiselect-trigger-chip[_ngcontent-%COMP%]     .ex-chip-chip-wrapper{padding-inline-start:5px!important;padding-inline-end:5px!important}.ex-combobox-multiselect-trigger-chip[_ngcontent-%COMP%]   .ex-combobox-multiselect-trigger-chip-remove[_ngcontent-%COMP%]{background:#8e8f8e;border-radius:50%;padding:3px;display:flex;align-items:center;justify-content:center;border:none;margin-inline-start:5px}.ex-combobox-multiselect-trigger-chip[_ngcontent-%COMP%]   .ex-combobox-multiselect-trigger-chip-remove[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#fff;font-size:8px;margin-bottom:1px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxMultiselectTriggerChipComponent, [{
        type: Component,
        args: [{ selector: 'ex-combobox-multiselect-trigger-chip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let selected of selectedItems;let indexOfelement=index;\">\n  <div *ngIf=\"isGroup(selected); else chip\" class=\"ex-combobox-multiselect-trigger-chip-group-wrapper\">\n    <ng-container [ngTemplateOutlet]=\"chip\"></ng-container>\n    <ex-chip *ngIf=\"!allowSingleSelectionInGroup && selected.all\"\n             class=\"ex-combobox-multiselect-trigger-chip ex-combobox-multiselect-trigger-chip-leaf\"\n             background=\"#F4F4F4\" fontColor=\"#222\" size=\"small\" [square]=\"true\" borderColor=\"#dedede\">\n      <button *ngIf=\"!isReadOnly\" icon-right class=\"ex-combobox-multiselect-trigger-chip-remove\"\n              [exTooltip]=\"'ng.general.remove' | translate\"\n              [attr.aria-label]=\"'ng.general.remove_selected_item' | translate :{ selectedItem: selected.value | translate }\"\n              (click)=\"onRemoveClicked(selected)\" [attr.aria-describedby]=\"unique+'-'+indexOfelement\">\n        <i class=\"uxf-icon uxf-close\"></i>\n      </button>\n      <span text>{{ 'ng.general.all' | translate }}</span>\n    </ex-chip>\n\n    <ex-combobox-multiselect-trigger-chip\n      class=\"ex-combobox-multiselect-trigger-wrapper-chip\"\n      *ngIf=\"allowSingleSelectionInGroup || !selected.all\"\n      [selectedItems]=\"selected.subItems\" [isReadOnly]=\"isReadOnly\" [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\"\n      (itemRemoved)=\"itemRemoved.emit($event)\" (itemsRemoved)=\"itemsRemoved.emit($event)\"\n    >\n    </ex-combobox-multiselect-trigger-chip>\n  </div>\n  <ng-template #chip>\n    <ex-chip class=\"ex-combobox-multiselect-trigger-chip\" [ngClass]=\"{'ex-combobox-multiselect-trigger-chip-leaf': !selected.subItems || selected.subItems.length === 0 }\"\n        [background]=\"!selected.subItems || selected.subItems.length === 0 ? '#F4F4F4': 'white'\" fontColor=\"#222\"\n        size=\"small\" [square]=\"true\" borderColor=\"#dedede\">\n        <button *ngIf=\"!isReadOnly && !isGroup(selected)\" icon-right\n            class=\"ex-combobox-multiselect-trigger-chip-remove\" (click)=\"onRemoveClicked(selected)\" [exTooltip]=\"'ng.general.remove' | translate\"\n                [attr.aria-label]=\"'ng.general.remove_selected_item' | translate :{ selectedItem: selected.value | translate }\" [attr.aria-describedby]=\"unique+'-'+indexOfelement\">\n            <i class=\"uxf-icon uxf-close\"></i>\n        </button>\n        <span [id]=\"unique+'-'+indexOfelement\"\n            text>{{ selected.value | translate }}{{ isGroup(selected) ? ':' : '' }}</span>\n    </ex-chip>\n  </ng-template>\n</ng-container>\n", styles: [":host{display:flex;flex-wrap:wrap;overflow:hidden;flex-direction:column}.ex-combobox-multiselect-trigger-chip-group-wrapper{display:flex;flex-wrap:wrap}.ex-combobox-multiselect-trigger-chip-group-wrapper .ex-combobox-multiselect-trigger-wrapper-chip{display:contents}.ex-combobox-multiselect-trigger-chip{margin-inline-end:5px;margin-bottom:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ex-combobox-multiselect-trigger-chip ::ng-deep .ex-chip-chip-wrapper{padding-inline-start:5px!important;padding-inline-end:5px!important}.ex-combobox-multiselect-trigger-chip .ex-combobox-multiselect-trigger-chip-remove{background:#8e8f8e;border-radius:50%;padding:3px;display:flex;align-items:center;justify-content:center;border:none;margin-inline-start:5px}.ex-combobox-multiselect-trigger-chip .ex-combobox-multiselect-trigger-chip-remove i{color:#fff;font-size:8px;margin-bottom:1px}\n"] }]
    }], function () { return []; }, { selectedItems: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], allowSingleSelectionInGroup: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], itemsRemoved: [{
            type: Output
        }] }); })();

class ExComboboxMultiselectTriggerComponent {
    constructor() {
        this.isReadOnly = false;
        this.allowSingleSelectionInGroup = false;
        this.itemRemoved = new EventEmitter();
        this.itemsRemoved = new EventEmitter();
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ExComboboxMultiselectTriggerComponent_Factory(t) { return new (t || ExComboboxMultiselectTriggerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExComboboxMultiselectTriggerComponent, selectors: [["ex-combobox-multiselect-trigger"]], inputs: { selectedItems: "selectedItems", isReadOnly: "isReadOnly", allowSingleSelectionInGroup: "allowSingleSelectionInGroup" }, outputs: { itemRemoved: "itemRemoved", itemsRemoved: "itemsRemoved" }, decls: 2, vars: 3, consts: [[1, "ex-combobox-multiselect-trigger-wrapper", "sel-combobox-multi-selected-value"], [1, "ex-combobox-multiselect-trigger-wrapper-chip", 3, "isReadOnly", "selectedItems", "allowSingleSelectionInGroup", "itemRemoved", "itemsRemoved"]], template: function ExComboboxMultiselectTriggerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-combobox-multiselect-trigger-chip", 1);
            i0.ɵɵlistener("itemRemoved", function ExComboboxMultiselectTriggerComponent_Template_ex_combobox_multiselect_trigger_chip_itemRemoved_1_listener($event) { return ctx.itemRemoved.emit($event); })("itemsRemoved", function ExComboboxMultiselectTriggerComponent_Template_ex_combobox_multiselect_trigger_chip_itemsRemoved_1_listener($event) { return ctx.itemsRemoved.emit($event); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("isReadOnly", ctx.isReadOnly)("selectedItems", ctx.selectedItems)("allowSingleSelectionInGroup", ctx.allowSingleSelectionInGroup);
        } }, dependencies: [ExComboboxMultiselectTriggerChipComponent], styles: ["[_nghost-%COMP%]{overflow:hidden}[_nghost-%COMP%]   .ex-combobox-multiselect-trigger-wrapper[_ngcontent-%COMP%]{display:flex;padding-top:5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExComboboxMultiselectTriggerComponent, [{
        type: Component,
        args: [{ selector: 'ex-combobox-multiselect-trigger', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-combobox-multiselect-trigger-wrapper sel-combobox-multi-selected-value\">\n    <ex-combobox-multiselect-trigger-chip class=\"ex-combobox-multiselect-trigger-wrapper-chip\" [isReadOnly]=\"isReadOnly\" [selectedItems]=\"selectedItems\"\n        [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\" (itemRemoved)=\"itemRemoved.emit($event)\"\n        (itemsRemoved)=\"itemsRemoved.emit($event)\">\n    </ex-combobox-multiselect-trigger-chip>\n</div>\n", styles: [":host{overflow:hidden}:host .ex-combobox-multiselect-trigger-wrapper{display:flex;padding-top:5px}\n"] }]
    }], function () { return []; }, { selectedItems: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], allowSingleSelectionInGroup: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], itemsRemoved: [{
            type: Output
        }] }); })();

class FilterItemsPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(items, value, allowUnlisted = false, selectableRowsOnly = true, getNewItemKey = (search) => search) {
        let filteredItems = [];
        if (value && value !== '') {
            filteredItems = this.filter(items, value, selectableRowsOnly);
            if (allowUnlisted && !this.valueListed(filteredItems, value))
                filteredItems.push({ key: getNewItemKey(value), value: value, isNew: true });
            return filteredItems;
        }
        return [...items.map(item => Object({ ...item }))];
    }
    valueListed(items, value) {
        let listed = false;
        for (const item of items) {
            if (!item.subItems || item.subItems.length === 0) {
                if (this.translateService.instant(item.value || "") === value) {
                    listed = true;
                    break;
                }
            }
            else {
                return this.valueListed(item.subItems, value);
            }
        }
        return listed;
    }
    filter(items, value, selectableRowsOnly) {
        let filteredItems = [];
        outerLoop: for (const item of items) {
            if (this.translateService.instant(item.value || "").toLowerCase().indexOf(value.toLowerCase()) !== -1 || (item.description && this.translateService.instant(item.description).toLowerCase().indexOf(value.toLowerCase()) !== -1)) {
                if (!selectableRowsOnly || !(item?.subItems?.length > 0)) {
                    filteredItems.push({ ...item, expanded: true });
                    if (!selectableRowsOnly) {
                        continue outerLoop;
                    }
                }
            }
            if (item.subItems?.length > 0) {
                const subItems = this.filter(item.subItems, value, selectableRowsOnly);
                if (subItems.length > 0) {
                    filteredItems.push({ ...item, subItems, expanded: true });
                }
            }
        }
        return filteredItems;
    }
    static { this.ɵfac = function FilterItemsPipe_Factory(t) { return new (t || FilterItemsPipe)(i0.ɵɵdirectiveInject(i1$2.TranslateService, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterItems", type: FilterItemsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterItemsPipe, [{
        type: Pipe,
        args: [{ name: 'filterItems' }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, null); })();
class FilterItemsByKeyPipe {
    transform(items, values) {
        let filteredItems = [];
        if (values?.length) {
            return this.filter(items, values);
        }
        else {
            return items;
        }
    }
    filter(items, values) {
        let filteredItems = [];
        outerLoop: for (const item of items) {
            if (values.findIndex(i => i === item?.key) != -1) {
                if (!(item?.subItems?.length > 0)) {
                    filteredItems.push({ ...item, expanded: true });
                    continue outerLoop;
                }
            }
            if (item.subItems?.length > 0) {
                const subItems = this.filter(item.subItems, values);
                if (subItems.length > 0) {
                    filteredItems.push({ ...item, subItems, expanded: true });
                }
            }
        }
        return filteredItems;
    }
    static { this.ɵfac = function FilterItemsByKeyPipe_Factory(t) { return new (t || FilterItemsByKeyPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterItemsByKeyList", type: FilterItemsByKeyPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterItemsByKeyPipe, [{
        type: Pipe,
        args: [{ name: 'filterItemsByKeyList' }]
    }], null, null); })();
class SelectedItemsTransformPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(selectedItems, items, unlistedValueSuffix = "") {
        let itemsKeys = [];
        const ret = this.transformValue(selectedItems, items, itemsKeys, "");
        selectedItems.filter(item => !itemsKeys.find(key => key == item.key)).forEach(item => {
            let ind = selectedItems.findIndex(selected => selected.key === item.key);
            ret.push({ key: item.key, value: `${this.translateService.instant(item.value || item.key || " ")}${unlistedValueSuffix.length > 0 ? " " : ""}${unlistedValueSuffix}`, all: true, ind });
        });
        ret.sort((previousValue, currentValue) => previousValue.ind > currentValue.ind ? 1 : -1);
        return ret;
    }
    transformValue(selectedItems, items, itemsKeys, father) {
        const ret = [];
        items?.forEach(item => {
            if (item.subItems && item.subItems.length > 0) {
                const arr = this.transformValue(selectedItems, item.subItems, itemsKeys, this.translateService.instant(item.value || ""));
                if (arr.length > 0) {
                    const all = arr.length === item.subItems.length && arr.every(el => el.all);
                    const minItem = arr.reduce((previousValue, currentValue) => previousValue.ind < currentValue.ind ? previousValue : currentValue);
                    ret.push({ ...item, subItems: arr, all, ind: minItem.ind, father });
                }
            }
            else {
                const ind = selectedItems.findIndex(selected => selected.key === item.key);
                if (ind !== -1) {
                    ret.push({ ...item, all: true, ind, father });
                    itemsKeys.push(item.key);
                }
            }
        });
        ret.sort((previousValue, currentValue) => previousValue.ind > currentValue.ind ? 1 : -1);
        return ret;
    }
    static { this.ɵfac = function SelectedItemsTransformPipe_Factory(t) { return new (t || SelectedItemsTransformPipe)(i0.ɵɵdirectiveInject(i1$2.TranslateService, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "selectedItemsTransform", type: SelectedItemsTransformPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedItemsTransformPipe, [{
        type: Pipe,
        args: [{ name: 'selectedItemsTransform' }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, null); })();

const _c0$1q = ["comboMenuWrapper"];
const _c1$T = ["menuContent"];
function ExNewComboboxComponent_ng_container_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("line-height", "normal");
    i0.ɵɵclassProp("ex-combobox-placeholder", !ctx_r6.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.isReadOnly ? i0.ɵɵpipeBind1(2, 5, "-") : i0.ɵɵpipeBind1(3, 7, ctx_r6.placeholder), "");
} }
function ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_trigger_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-combobox-trigger", 14);
    i0.ɵɵpipe(1, "selectedItemsTransform");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedItems", i0.ɵɵpipeBind3(1, 2, ctx_r12.selectedItems, ctx_r12.items, i0.ɵɵpipeBind1(2, 6, ctx_r12.unlistedValueSuffix)))("disabled", ctx_r12.disabled);
} }
function ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_multiselect_trigger_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-combobox-multiselect-trigger", 15);
    i0.ɵɵlistener("itemRemoved", function ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_multiselect_trigger_1_Template_ex_combobox_multiselect_trigger_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.itemRemoved($event)); })("itemsRemoved", function ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_multiselect_trigger_1_Template_ex_combobox_multiselect_trigger_itemsRemoved_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.itemsRemoved($event)); });
    i0.ɵɵpipe(1, "selectedItemsTransform");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedItems", i0.ɵɵpipeBind2(1, 3, ctx_r13.selectedItems, ctx_r13.items))("allowSingleSelectionInGroup", ctx_r13.allowSingleSelectionInGroup)("isReadOnly", ctx_r13.isReadOnly);
} }
function ExNewComboboxComponent_ng_container_0_ng_template_10_ng_content_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "customTrigger"]);
} }
function ExNewComboboxComponent_ng_container_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_trigger_0_Template, 3, 8, "ex-combobox-trigger", 11);
    i0.ɵɵtemplate(1, ExNewComboboxComponent_ng_container_0_ng_template_10_ex_combobox_multiselect_trigger_1_Template, 2, 6, "ex-combobox-multiselect-trigger", 12);
    i0.ɵɵtemplate(2, ExNewComboboxComponent_ng_container_0_ng_template_10_ng_content_2_Template, 1, 0, "ng-content", 13);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r8.customTrigger && !ctx_r8.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.customTrigger && ctx_r8.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.customTrigger);
} }
function ExNewComboboxComponent_ng_container_0_i_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 16);
} }
function ExNewComboboxComponent_ng_container_0_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 17);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function ExNewComboboxComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 2, 3);
    i0.ɵɵlistener("exFocusChange", function ExNewComboboxComponent_ng_container_0_Template_button_exFocusChange_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.isFieldFocused = $event); })("menuOpened", function ExNewComboboxComponent_ng_container_0_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onMenuOpened()); })("menuClosed", function ExNewComboboxComponent_ng_container_0_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onMenuClosed()); });
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "div", 4, 5);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵtemplate(9, ExNewComboboxComponent_ng_container_0_div_9_Template, 4, 9, "div", 6);
    i0.ɵɵtemplate(10, ExNewComboboxComponent_ng_container_0_ng_template_10_Template, 3, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(12, ExNewComboboxComponent_ng_container_0_i_12_Template, 1, 0, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "mat-menu", null, 9);
    i0.ɵɵtemplate(15, ExNewComboboxComponent_ng_container_0_ng_container_15_Template, 1, 1, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(11);
    const _r10 = i0.ɵɵreference(14);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-combobox-button sel-ex-combobox-selected-button ", ctx_r0.uniqueSelector ? i0.ɵɵpipeBind1(4, 31, "ex-combobox-selected-button-" + ctx_r0.uniqueSelector) : "", "");
    i0.ɵɵstyleProp("width", ctx_r0.matchButtonWidth && ctx_r0.buttonWidthOverride ? ctx_r0.buttonWidthOverride : ctx_r0.full ? "100%" : "initial");
    i0.ɵɵclassProp("ex-combobox-border", ctx_r0.hasBorder)("ex-combobox-not-valid", !ctx_r0.valid || ctx_r0.hasWarnings)("sel-combobox-warning", !ctx_r0.valid)("ex-combobox-view-mode", ctx_r0.isReadOnly)("ex-combobox-button-disabled", ctx_r0.disabled);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.getListId());
    i0.ɵɵproperty("matMenuTriggerFor", ctx_r0.disabled || ctx_r0.isReadOnly ? null : _r10)("disabled", ctx_r0.disabled)("autofocus", ctx_r0.autoFocus)("exFocus", ctx_r0.isFieldFocused);
    i0.ɵɵattribute("readonly", ctx_r0.isReadOnly)("aria-label", ctx_r0.disabled ? i0.ɵɵpipeBind1(5, 33, ctx_r0.disabledTooltip) : null);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("exTooltip", ctx_r0.disabled ? i0.ɵɵpipeBind1(8, 35, ctx_r0.disabledTooltip) : null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.selectedItems || ctx_r0.selectedItems.length === 0)("ngIfElse", _r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("menu-wrapper-no-limited-height", ctx_r0.fullHeight)("ex-combobox-menu-width-as-button-width", ctx_r0.matchMenuWidthToButtonWidth);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.menuOpen);
} }
function ExNewComboboxComponent_ng_template_1_ex_search_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-search", 24, 25);
    i0.ɵɵlistener("searchTextChange", function ExNewComboboxComponent_ng_template_1_ex_search_2_Template_ex_search_searchTextChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.searchText = $event); })("click", function ExNewComboboxComponent_ng_template_1_ex_search_2_Template_ex_search_click_0_listener($event) { return $event.stopPropagation(); })("searchTriggered", function ExNewComboboxComponent_ng_template_1_ex_search_2_Template_ex_search_searchTriggered_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30._searchTextChange($event)); })("keydown", function ExNewComboboxComponent_ng_template_1_ex_search_2_Template_ex_search_keydown_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.onSearchKeyDown($event)); })("compositionupdate", function ExNewComboboxComponent_ng_template_1_ex_search_2_Template_ex_search_compositionupdate_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.onCompositionUpdate($event)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 6, ctx_r24.searchPlaceholder));
    i0.ɵɵproperty("incremental", true)("isLoading", ctx_r24.searchLoading)("disableWhenLoading", false)("searchText", ctx_r24.searchText);
    i0.ɵɵattribute("aria-activedescendant", ctx_r24.getListId() + "_listbox");
} }
function ExNewComboboxComponent_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "ng.general.query_builder.more_results"), "");
} }
const _c2$C = function (a0, a1, a2, a3, a4) { return [a0, a1, a2, a3, a4]; };
function ExNewComboboxComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18, 19);
    i0.ɵɵtemplate(2, ExNewComboboxComponent_ng_template_1_ex_search_2_Template, 3, 8, "ex-search", 20);
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵlistener("keydown", function ExNewComboboxComponent_ng_template_1_Template_div_keydown_3_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.onMenuKeyDown($event)); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ExNewComboboxComponent_ng_template_1_div_5_Template, 3, 3, "div", 22);
    i0.ɵɵelementStart(6, "ex-group-outlet-2", 23);
    i0.ɵɵlistener("itemsAdded", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_itemsAdded_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.itemsAdded($event)); })("itemsRemoved", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_itemsRemoved_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.itemsRemoved($event)); })("itemAdded", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_itemAdded_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37._itemAdded($event)); })("itemRemoved", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_itemRemoved_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.itemRemoved($event)); })("itemRemovedWithoutEmit", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_itemRemovedWithoutEmit_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r39 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r39.itemRemoved($event, false)); })("blankOptionClicked", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_blankOptionClicked_6_listener() { i0.ɵɵrestoreView(_r34); const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.blankOptionClicked()); })("lastIndexChanged", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_lastIndexChanged_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r41 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r41.lastIndexChanged($event)); })("favoriteClicked", function ExNewComboboxComponent_ng_template_1_Template_ex_group_outlet_2_favoriteClicked_6_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.onFavoriteClicked($event)); });
    i0.ɵɵpipe(7, "filterItems");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r2.matchMenuWidthToButtonWidth ? ctx_r2.comboMenuWrapper == null ? null : ctx_r2.comboMenuWrapper.nativeElement == null ? null : ctx_r2.comboMenuWrapper.nativeElement.offsetWidth : ctx_r2.widthOverride, "px");
    i0.ɵɵclassProp("ex-combobox-menu-wrapper-max-width", !ctx_r2.matchMenuWidthToButtonWidth)("ex-combobox-menu-wrapper-limited-height", !ctx_r2.fullHeight)("ex-combobox-menu-wrapper-min-width", ctx_r2.displaySearchBox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.displaySearchBox);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-combobox-options-wrapper", !ctx_r2.matchMenuWidthToButtonWidth)("ex-combobox-options-wrapper-no-width", ctx_r2.matchButtonWidth);
    i0.ɵɵproperty("id", ctx_r2.getListId() + "_listbox");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 30, "ng.analytics.searchResults"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.hasMoreResults);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r2.searchTextChanged() ? ctx_r2.externalFiltering ? ctx_r2.items : i0.ɵɵpipeBindV(7, 32, i0.ɵɵpureFunction5(38, _c2$C, ctx_r2.items, ctx_r2.searchText, ctx_r2.allowUnlistedValues, ctx_r2.selectableRowsOnly, ctx_r2.getNewItemKey)) : null)("searchText", ctx_r2.searchText)("hasSelectAll", ctx_r2.hasSelectAll)("isMultiSelect", ctx_r2.isMultiSelect)("selectedItems", ctx_r2.selectedItems)("unlistedValueSuffix", ctx_r2.unlistedValueSuffix)("showNoResultsPlaceholder", ctx_r2.showNoResultsPlaceholder)("historyItems", ctx_r2.historyItems)("showAllHistory", ctx_r2.externalHistory)("addBlankOption", ctx_r2.addBlankOption)("allowSingleSelectionInGroup", ctx_r2.allowSingleSelectionInGroup)("minimumSearchLength", ctx_r2.minimumSearchLength)("uniqueSelector", ctx_r2.uniqueSelector)("hasFavorite", ctx_r2.hasFavorite);
} }
const _c3$t = [[["", "custom-trigger", ""]]];
const _c4$o = ["[custom-trigger]"];
class ExNewComboboxComponent extends ExGenericCombobox {
    constructor() {
        super(...arguments);
        /**
         * If to display the search box
         */
        this.displaySearchBox = true;
        /**
         * If to display the menu in full width
         */
        this.full = false;
        /**
         * If to display the menu in full height
         */
        this.fullHeight = false;
        /**
         * Limit dropdown width to button width
         */
        this.matchMenuWidthToButtonWidth = false;
        /**
         * Limit button width to dropdown width
         */
        this.matchButtonWidth = false;
        /**
         * If to surround the combobox with a border
         */
        this.hasBorder = false;
        /**
         * Show a message above the first result
         */
        this.hasMoreResults = false;
        /**
         * Show a placeholder text in the search input
         */
        this.searchPlaceholder = 'ng.combobox-search-placeholder';
        /* In some cases, we might want to send the unlistedValuesSuffix as part of what's being emitted on click, in order to provide more info about the button **/
        this.getNewItemKey = (search) => search;
        /**
         * Show the selection area only
         */
        this.autoFocus = false;
        /**
         * If to open the menu by default
         */
        this.openMenuOnOInit = false;
        /**
         * whether to show also history items which are not included in the item
         */
        this.externalHistory = false;
        /**
         * Identifier of the element, and used to create a relationship between the search element and the results
         */
        this.listId = "";
        this._listId = 0;
        /**
         * if to filter selecrable tows only, if false the items will be filtered also by the group name value
         */
        this.selectableRowsOnly = true;
        /**
         * If it have favorite option (star icon)
         */
        this.hasFavorite = false;
        this.buttonWidthOverride = null;
        this.menuOpen = false;
    }
    /**
     * If to support multi selection
     */
    set isMultiSelect(value) {
        this._isMultiSelect = value;
    }
    get isMultiSelect() {
        return this._isMultiSelect;
    }
    static { this._listIdCounter = 0; }
    ngOnInit() {
        if (this.hasFormFieldsBorder)
            this.matchMenuWidthToButtonWidth = this.hasFormFieldsBorder();
        this._listId = ExNewComboboxComponent._listIdCounter;
        ExNewComboboxComponent._listIdCounter++;
    }
    ngAfterViewInit() {
        this.comboMenuWrapper?.nativeElement.setAttribute("role", "combobox");
        this.comboMenuWrapper?.nativeElement.setAttribute("aria-expanded", "false");
        this.isAlwaysOpen && this.onMenuOpened();
        this.openMenuOnOInit && this.openMenu();
    }
    onMenuOpened() {
        this.menuOpen = true;
        if (this.matchButtonWidth) {
            const longestOption = this.items.reduce((prev, curr) => {
                return prev.length > curr.value.length ? prev : curr.value;
            }, '');
            this.buttonWidthOverride = this.widthOverride = getTextWidth(this.comboMenuWrapper?.nativeElement, longestOption, 20);
            this.buttonWidthOverride = !this.matchMenuWidthToButtonWidth && parseInt(this.buttonWidthOverride) > 300 ? '300px' : this.buttonWidthOverride + 'px';
            this.changeDetectorRef.detectChanges();
        }
        setTimeout(() => {
            // Angular v16 clean up here - remove the .mat-menu-panel
            (this.menuContent?.nativeElement?.closest(".mat-menu-panel") || this.menuContent?.nativeElement?.closest(".mat-mdc-menu-panel"))?.removeAttribute("role");
            this.menuContent?.nativeElement.removeAttribute("role");
            const matMenuRipple = (document.getElementsByClassName("mat-menu-ripple")[0] || document.getElementsByClassName("mat-mdc-menu-ripple")[0]);
            if (matMenuRipple && matMenuRipple.parentNode === this.menuContent?.nativeElement) {
                this.menuContent?.nativeElement.removeChild(matMenuRipple);
            }
            this.changeDetectorRef.detectChanges();
        }, 100);
        super.onMenuOpened();
    }
    onMenuClosed() {
        if (this.matchButtonWidth) {
            this.buttonWidthOverride = null;
            this.changeDetectorRef.detectChanges();
        }
        super.onMenuClosed();
        setTimeout(() => {
            // to fix blinking empty box on closing dropdown
            this.menuOpen = false;
            this.comboMenuWrapper?.nativeElement.setAttribute("aria-expanded", "false");
        });
    }
    getListId() {
        if (this.listId.length != 0) {
            return this.listId;
        }
        else {
            return "combobox_" + this._listId;
        }
    }
    onFavoriteClicked(item) {
        item.favorite = !item.favorite;
        this.favoriteItemChange.emit(item.key);
        this.closeMenu();
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExNewComboboxComponent_BaseFactory; return function ExNewComboboxComponent_Factory(t) { return (ɵExNewComboboxComponent_BaseFactory || (ɵExNewComboboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExNewComboboxComponent)))(t || ExNewComboboxComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExNewComboboxComponent, selectors: [["ex-new-combobox"]], viewQuery: function ExNewComboboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1q, 5, ElementRef);
            i0.ɵɵviewQuery(_c1$T, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.comboMenuWrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuContent = _t.first);
        } }, hostBindings: function ExNewComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedItemsChange", function ExNewComboboxComponent_selectedItemsChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExNewComboboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { displaySearchBox: "displaySearchBox", full: "full", fullHeight: "fullHeight", matchMenuWidthToButtonWidth: "matchMenuWidthToButtonWidth", matchButtonWidth: "matchButtonWidth", hasBorder: "hasBorder", disabledTooltip: "disabledTooltip", hasMoreResults: "hasMoreResults", searchPlaceholder: "searchPlaceholder", getNewItemKey: "getNewItemKey", isMultiSelect: "isMultiSelect", autoFocus: "autoFocus", openMenuOnOInit: "openMenuOnOInit", externalHistory: "externalHistory", listId: "listId", selectableRowsOnly: "selectableRowsOnly", uniqueSelector: "uniqueSelector", hasFavorite: "hasFavorite" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExNewComboboxComponent)), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4$o, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["selectArea", ""], ["mat-button", "", "exFormAriaAttributes", "", "aria-expanded", "false", 3, "id", "matMenuTriggerFor", "disabled", "autofocus", "exFocus", "exFocusChange", "menuOpened", "menuClosed"], ["comboMenuWrapper", "", "menuTrigger", "matMenuTrigger"], [1, "ex-combobox-trigger-wrapper", 3, "exTooltip"], ["toolTip", "exTooltip"], [3, "line-height", "ex-combobox-placeholder", 4, "ngIf", "ngIfElse"], ["trigger", ""], ["aria-hidden", "true", "class", "uxf-icon uxf-down-caret sel-combobox-arrow ex-combobox-arrow", 4, "ngIf"], ["menu", "matMenu"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "ex-combobox-trigger", 3, "selectedItems", "disabled", 4, "ngIf"], [3, "selectedItems", "allowSingleSelectionInGroup", "isReadOnly", "itemRemoved", "itemsRemoved", 4, "ngIf"], [4, "ngIf"], [1, "ex-combobox-trigger", 3, "selectedItems", "disabled"], [3, "selectedItems", "allowSingleSelectionInGroup", "isReadOnly", "itemRemoved", "itemsRemoved"], ["aria-hidden", "true", 1, "uxf-icon", "uxf-down-caret", "sel-combobox-arrow", "ex-combobox-arrow"], [3, "ngTemplateOutlet"], ["mat-menu-item", "", 1, "ex-combobox-menu-wrapper"], ["menuContent", ""], ["class", "ex-combobox-search", 3, "incremental", "isLoading", "disableWhenLoading", "searchText", "placeholder", "searchTextChange", "click", "searchTriggered", "keydown", "compositionupdate", 4, "ngIf"], ["role", "listbox", 1, "ex-combobox-options-wrapper-scroll", 3, "id", "keydown"], ["class", "ex-combobox-has-more-results", 4, "ngIf"], [3, "items", "searchText", "hasSelectAll", "isMultiSelect", "selectedItems", "unlistedValueSuffix", "showNoResultsPlaceholder", "historyItems", "showAllHistory", "addBlankOption", "allowSingleSelectionInGroup", "minimumSearchLength", "uniqueSelector", "hasFavorite", "itemsAdded", "itemsRemoved", "itemAdded", "itemRemoved", "itemRemovedWithoutEmit", "blankOptionClicked", "lastIndexChanged", "favoriteClicked"], [1, "ex-combobox-search", 3, "incremental", "isLoading", "disableWhenLoading", "searchText", "placeholder", "searchTextChange", "click", "searchTriggered", "keydown", "compositionupdate"], ["search", ""], [1, "ex-combobox-has-more-results"]], template: function ExNewComboboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c3$t);
            i0.ɵɵtemplate(0, ExNewComboboxComponent_ng_container_0_Template, 16, 37, "ng-container", 0);
            i0.ɵɵtemplate(1, ExNewComboboxComponent_ng_template_1_Template, 8, 44, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.isAlwaysOpen)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgIf, i1$5.NgTemplateOutlet, i3$3.MatButton, i3$1.MatMenu, i3$1.MatMenuItem, i3$1.MatMenuTrigger, ExTooltipDirective, ExFocusDirective, ExFormAriaAttributesDirective, ExSearchComponent, i10.AutofocusFixDirective, ExGroupOutletComponent2, ExComboboxTriggerComponent, ExComboboxMultiselectTriggerComponent, i1$2.TranslatePipe, ExGenerateIdPipe, FilterItemsPipe, SelectedItemsTransformPipe], styles: [".ex-combobox-has-more-results[_ngcontent-%COMP%]{padding:5px 20px;font-family:Roboto-italic}.ex-combobox-trigger-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;align-items:flex-start;justify-content:space-between;text-align:initial;padding-block:8px}.ex-combobox-trigger-wrapper[_ngcontent-%COMP%]   .ex-combobox-trigger[_ngcontent-%COMP%]{width:100%}.ex-combobox-trigger-wrapper[_ngcontent-%COMP%]   .ex-combobox-placeholder[_ngcontent-%COMP%]{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic;font-stretch:normal;line-height:normal}.ex-combobox-trigger-wrapper[_ngcontent-%COMP%]   .ex-combobox-arrow[_ngcontent-%COMP%]{margin-top:2px;margin-inline-start:5px}.ex-combobox-button[_ngcontent-%COMP%]{max-width:100%;width:100%;overflow:hidden;font-size:inherit;-webkit-user-select:text;user-select:text;border:none;background:transparent;padding-inline-end:10px;padding-inline-start:10px}.ex-combobox-button[_ngcontent-%COMP%]:enabled:hover{background-color:#e5e5e5}.ex-combobox-button.ex-combobox-button-disabled[_ngcontent-%COMP%]{color:#d7d7d7;pointer-events:auto!important;--mat-mdc-button-persistent-ripple-color: none !important}.ex-combobox-border[_ngcontent-%COMP%]{border:1px solid #ccc}.ex-combobox-view-mode[_ngcontent-%COMP%]{pointer-events:none}.ex-combobox-not-valid[_ngcontent-%COMP%]{border:2px solid #c75757!important}  .mat-mdc-menu-panel{max-width:none!important}  .ex-combobox-menu-wrapper.mat-mdc-menu-item{white-space:unset!important;text-overflow:unset!important;line-height:inherit!important;height:-moz-fit-content!important;height:fit-content!important;padding:0!important}.ex-combobox-menu-wrapper-min-width[_ngcontent-%COMP%]{min-width:160px}  .ex-combobox-menu-wrapper.mat-mdc-menu-item:hover:not([disabled]){background:inherit!important}.ex-combobox-menu-width-as-button-width[_ngcontent-%COMP%]     .mat-mdc-menu-panel{max-width:none!important}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]:not(.ex-combobox-menu-wrapper-limited-height){max-height:calc(100vh - 58px)}.ex-combobox-menu-wrapper.ex-combobox-menu-wrapper-limited-height[_ngcontent-%COMP%]{max-height:540px;min-width:115px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-options-wrapper-scroll[_ngcontent-%COMP%]{padding-bottom:5px;padding-top:5px;overflow-y:auto;overflow-x:hidden;width:100%}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-options-wrapper[_ngcontent-%COMP%]{width:280px;max-width:300px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-options-wrapper.ex-combobox-options-wrapper-no-width[_ngcontent-%COMP%]{width:100%}.ex-combobox-menu-wrapper-max-width[_ngcontent-%COMP%]{max-width:300px}.ex-combobox-search[_ngcontent-%COMP%]{padding:10px;display:block;width:100%}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNewComboboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-new-combobox', host: {
                    '(selectedItemsChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExNewComboboxComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!isAlwaysOpen;else selectArea\">\n    <button mat-button id=\"{{getListId()}}\" #comboMenuWrapper\n        [matMenuTriggerFor]=\"disabled || isReadOnly ? null : menu\" #menuTrigger=\"matMenuTrigger\" [disabled]=\"disabled\" [attr.readonly]=\"isReadOnly\"\n        [autofocus]=\"autoFocus\" [(exFocus)]=\"isFieldFocused\" (menuOpened)=\"onMenuOpened()\" (menuClosed)=\"onMenuClosed()\"\n        [style.width]=\"(matchButtonWidth && buttonWidthOverride) ? buttonWidthOverride : full ? '100%' : 'initial'\"\n        [class.ex-combobox-border]=\"hasBorder\" [class.ex-combobox-not-valid]=\"!valid || hasWarnings\"\n        [class.sel-combobox-warning]=\"!valid\" [class.ex-combobox-view-mode]=\"isReadOnly\" [attr.aria-label] = \"disabled ? (disabledTooltip | translate) : null\"\n        [class.ex-combobox-button-disabled]=\"disabled\" class=\"ex-combobox-button sel-ex-combobox-selected-button {{uniqueSelector ? (('ex-combobox-selected-button-' + uniqueSelector) | generateHTMLId) : ''}}\"\n        exFormAriaAttributes aria-expanded=\"false\">\n        <div class=\"ex-combobox-trigger-wrapper\" [exTooltip]=\"disabled ? (disabledTooltip | translate) : null\"\n            #toolTip=\"exTooltip\">\n            <div *ngIf=\"!selectedItems || selectedItems.length === 0; else trigger\" [style.line-height]=\"'normal'\"\n                [class.ex-combobox-placeholder]=\"!isReadOnly\">\n                {{ isReadOnly ? ('-' | translate) : (placeholder | translate) }}</div>\n            <ng-template #trigger>\n                <ex-combobox-trigger class=\"ex-combobox-trigger\" *ngIf=\"!customTrigger && !isMultiSelect\"\n                    [selectedItems]=\"selectedItems | selectedItemsTransform : items : (unlistedValueSuffix | translate)\"\n                    [disabled]=\"disabled\">\n                </ex-combobox-trigger>\n                <ex-combobox-multiselect-trigger *ngIf=\"!customTrigger && isMultiSelect\"\n                    [selectedItems]=\"selectedItems | selectedItemsTransform : items\"\n                    [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\" (itemRemoved)=\"itemRemoved($event)\"\n                    (itemsRemoved)=\"itemsRemoved($event)\" [isReadOnly]=\"isReadOnly\">\n                </ex-combobox-multiselect-trigger>\n              <ng-content *ngIf=\"customTrigger\" select=\"[custom-trigger]\"></ng-content>\n            </ng-template>\n            <i aria-hidden=true *ngIf=\"!isReadOnly\" class=\"uxf-icon uxf-down-caret sel-combobox-arrow ex-combobox-arrow\"></i>\n        </div>\n    </button>\n\n    <mat-menu #menu=\"matMenu\" [class.menu-wrapper-no-limited-height]=\"fullHeight\"\n        [class.ex-combobox-menu-width-as-button-width]=\"matchMenuWidthToButtonWidth\">\n        <ng-container *ngIf=\"menuOpen\" [ngTemplateOutlet]=\"selectArea\"></ng-container>\n    </mat-menu>\n</ng-container>\n\n<ng-template #selectArea let-menuWidth=\"widthOverride\">\n    <div #menuContent mat-menu-item class=\"ex-combobox-menu-wrapper\" [class.ex-combobox-menu-wrapper-max-width]=\"!matchMenuWidthToButtonWidth\" [class.ex-combobox-menu-wrapper-limited-height]=\"!fullHeight\"\n         [class.ex-combobox-menu-wrapper-min-width]=\"displaySearchBox\"\n        [style.width.px]=\"matchMenuWidthToButtonWidth? comboMenuWrapper?.nativeElement?.offsetWidth: widthOverride\">\n        <ex-search #search *ngIf=\"displaySearchBox\" class=\"ex-combobox-search\" [incremental]=\"true\"\n            [isLoading]=\"searchLoading\" [disableWhenLoading]=\"false\" [(searchText)]=\"searchText\"\n            placeholder=\"{{ searchPlaceholder | translate }}\" (click)=\"$event.stopPropagation()\"\n            (searchTriggered)=\"_searchTextChange($event)\" (keydown)=\"onSearchKeyDown($event)\"\n            (compositionupdate)=\"onCompositionUpdate($event)\" attr.aria-activedescendant=\"{{getListId()+'_listbox'}}\"></ex-search>\n        <div class='ex-combobox-options-wrapper-scroll' [class.ex-combobox-options-wrapper]=\"!matchMenuWidthToButtonWidth\"\n            [class.ex-combobox-options-wrapper-no-width]=\"matchButtonWidth\" role=\"listbox\"\n            (keydown)=\"onMenuKeyDown($event)\" [id]=\"getListId()+'_listbox'\"\n             [attr.aria-label]=\"('ng.analytics.searchResults' | translate)\">\n            <div *ngIf=\"hasMoreResults\" class=\"ex-combobox-has-more-results\"> {{ 'ng.general.query_builder.more_results'\n                | translate }}</div>\n            <ex-group-outlet-2\n                [items]=\"searchTextChanged()? ( externalFiltering ? items : (items | filterItems: searchText: allowUnlistedValues: selectableRowsOnly: getNewItemKey) ) : null\"\n                [searchText]=\"searchText\" [hasSelectAll]=\"hasSelectAll\" [isMultiSelect]=\"isMultiSelect\"\n                [selectedItems]=\"selectedItems\" [unlistedValueSuffix]=\"unlistedValueSuffix\" [showNoResultsPlaceholder]=\"showNoResultsPlaceholder\"\n                [historyItems]=\"historyItems\" [showAllHistory]=\"externalHistory\" [addBlankOption]=\"addBlankOption\"\n                [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\" [minimumSearchLength]=\"minimumSearchLength\" [uniqueSelector]=\"uniqueSelector\"\n                (itemsAdded)=\"itemsAdded($event)\" (itemsRemoved)=\"itemsRemoved($event)\" (itemAdded)=\"_itemAdded($event)\"\n                (itemRemoved)=\"itemRemoved($event)\" (itemRemovedWithoutEmit)=\"itemRemoved($event, false)\"\n                (blankOptionClicked)=\"blankOptionClicked()\" (lastIndexChanged)=\"lastIndexChanged($event)\"\n                [hasFavorite]=\"hasFavorite\" (favoriteClicked)=\"onFavoriteClicked($event)\">\n            </ex-group-outlet-2>\n        </div>\n    </div>\n</ng-template>\n", styles: [".ex-combobox-has-more-results{padding:5px 20px;font-family:Roboto-italic}.ex-combobox-trigger-wrapper{width:100%;display:flex;align-items:flex-start;justify-content:space-between;text-align:initial;padding-block:8px}.ex-combobox-trigger-wrapper .ex-combobox-trigger{width:100%}.ex-combobox-trigger-wrapper .ex-combobox-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic;font-stretch:normal;line-height:normal}.ex-combobox-trigger-wrapper .ex-combobox-arrow{margin-top:2px;margin-inline-start:5px}.ex-combobox-button{max-width:100%;width:100%;overflow:hidden;font-size:inherit;-webkit-user-select:text;user-select:text;border:none;background:transparent;padding-inline-end:10px;padding-inline-start:10px}.ex-combobox-button:enabled:hover{background-color:#e5e5e5}.ex-combobox-button.ex-combobox-button-disabled{color:#d7d7d7;pointer-events:auto!important;--mat-mdc-button-persistent-ripple-color: none !important}.ex-combobox-border{border:1px solid #ccc}.ex-combobox-view-mode{pointer-events:none}.ex-combobox-not-valid{border:2px solid #c75757!important}::ng-deep .mat-mdc-menu-panel{max-width:none!important}::ng-deep .ex-combobox-menu-wrapper.mat-mdc-menu-item{white-space:unset!important;text-overflow:unset!important;line-height:inherit!important;height:-moz-fit-content!important;height:fit-content!important;padding:0!important}.ex-combobox-menu-wrapper-min-width{min-width:160px}::ng-deep .ex-combobox-menu-wrapper.mat-mdc-menu-item:hover:not([disabled]){background:inherit!important}.ex-combobox-menu-width-as-button-width ::ng-deep .mat-mdc-menu-panel{max-width:none!important}.ex-combobox-menu-wrapper{display:flex;flex-direction:column}.ex-combobox-menu-wrapper:not(.ex-combobox-menu-wrapper-limited-height){max-height:calc(100vh - 58px)}.ex-combobox-menu-wrapper.ex-combobox-menu-wrapper-limited-height{max-height:540px;min-width:115px}.ex-combobox-menu-wrapper .ex-combobox-options-wrapper-scroll{padding-bottom:5px;padding-top:5px;overflow-y:auto;overflow-x:hidden;width:100%}.ex-combobox-menu-wrapper .ex-combobox-options-wrapper{width:280px;max-width:300px}.ex-combobox-menu-wrapper .ex-combobox-options-wrapper.ex-combobox-options-wrapper-no-width{width:100%}.ex-combobox-menu-wrapper-max-width{max-width:300px}.ex-combobox-search{padding:10px;display:block;width:100%}\n"] }]
    }], null, { displaySearchBox: [{
            type: Input
        }], full: [{
            type: Input
        }], fullHeight: [{
            type: Input
        }], matchMenuWidthToButtonWidth: [{
            type: Input
        }], matchButtonWidth: [{
            type: Input
        }], hasBorder: [{
            type: Input
        }], disabledTooltip: [{
            type: Input
        }], hasMoreResults: [{
            type: Input
        }], searchPlaceholder: [{
            type: Input
        }], getNewItemKey: [{
            type: Input
        }], isMultiSelect: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], openMenuOnOInit: [{
            type: Input
        }], externalHistory: [{
            type: Input
        }], listId: [{
            type: Input
        }], selectableRowsOnly: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], hasFavorite: [{
            type: Input
        }], comboMenuWrapper: [{
            type: ViewChild,
            args: ['comboMenuWrapper', { read: ElementRef }]
        }], menuContent: [{
            type: ViewChild,
            args: ['menuContent', { read: ElementRef }]
        }] }); })();

class ExChipModule {
    static { this.ɵfac = function ExChipModule_Factory(t) { return new (t || ExChipModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExChipModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExDirectivesModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExDirectivesModule,
                    TranslateModule
                ],
                declarations: [
                    ExChipComponent
                ],
                exports: [
                    ExChipComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExChipModule, { declarations: [ExChipComponent], imports: [CommonModule,
        ExDirectivesModule,
        TranslateModule], exports: [ExChipComponent] }); })();

class ExCheckboxModule {
    static { this.ɵfac = function ExCheckboxModule_Factory(t) { return new (t || ExCheckboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExCheckboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatCheckboxModule,
            TranslateModule,
            ExDirectivesModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatCheckboxModule,
                    TranslateModule,
                    ExDirectivesModule,
                    EXPipesModule
                ],
                declarations: [
                    ExCheckboxComponent
                ],
                exports: [
                    ExCheckboxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExCheckboxModule, { declarations: [ExCheckboxComponent], imports: [CommonModule,
        FormsModule,
        MatCheckboxModule,
        TranslateModule,
        ExDirectivesModule,
        EXPipesModule], exports: [ExCheckboxComponent] }); })();

class ExNewComboboxModule {
    static { this.ɵfac = function ExNewComboboxModule_Factory(t) { return new (t || ExNewComboboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExNewComboboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: AutofocusFixConfig,
                useValue: new AutofocusFixConfig({
                    async: false,
                    smartEmptyCheck: false,
                    triggerDetectChanges: false
                }),
            }
        ], imports: [CommonModule,
            MatButtonModule,
            MatMenuModule,
            MatTooltipModule,
            TranslateModule,
            ExChipModule,
            ExDirectivesModule,
            EXPipesModule,
            ExCheckboxModule,
            ExSearchModule,
            ExCloseModule,
            ExSvgIconModule,
            FormsModule,
            MatRadioModule,
            ExIconModule,
            AutofocusFixModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNewComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatTooltipModule,
                    TranslateModule,
                    ExChipModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    ExCheckboxModule,
                    ExSearchModule,
                    ExCloseModule,
                    ExSvgIconModule,
                    FormsModule,
                    MatRadioModule,
                    ExIconModule,
                    AutofocusFixModule,
                    EXPipesModule
                ],
                declarations: [
                    ExNewComboboxComponent,
                    ExGroupOutletComponent2,
                    FilterItemsPipe,
                    ExComboboxTriggerComponent,
                    ExComboboxMultiselectTriggerComponent,
                    SelectedItemsTransformPipe,
                    ExComboboxMultiselectTriggerChipComponent,
                    FilterItemsByKeyPipe
                ],
                exports: [
                    ExNewComboboxComponent,
                    FilterItemsPipe,
                    SelectedItemsTransformPipe,
                    ExGroupOutletComponent2,
                    ExComboboxMultiselectTriggerComponent,
                    FilterItemsByKeyPipe
                ],
                providers: [
                    {
                        provide: AutofocusFixConfig,
                        useValue: new AutofocusFixConfig({
                            async: false,
                            smartEmptyCheck: false,
                            triggerDetectChanges: false
                        }),
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExNewComboboxModule, { declarations: [ExNewComboboxComponent,
        ExGroupOutletComponent2,
        FilterItemsPipe,
        ExComboboxTriggerComponent,
        ExComboboxMultiselectTriggerComponent,
        SelectedItemsTransformPipe,
        ExComboboxMultiselectTriggerChipComponent,
        FilterItemsByKeyPipe], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        TranslateModule,
        ExChipModule,
        ExDirectivesModule,
        EXPipesModule,
        ExCheckboxModule,
        ExSearchModule,
        ExCloseModule,
        ExSvgIconModule,
        FormsModule,
        MatRadioModule,
        ExIconModule,
        AutofocusFixModule,
        EXPipesModule], exports: [ExNewComboboxComponent,
        FilterItemsPipe,
        SelectedItemsTransformPipe,
        ExGroupOutletComponent2,
        ExComboboxMultiselectTriggerComponent,
        FilterItemsByKeyPipe] }); })();

class MenuItemModule {
    static { this.ɵfac = function MenuItemModule_Factory(t) { return new (t || MenuItemModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MenuItemModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExComponentLoaderModule,
            ExLabelModule,
            TranslateModule,
            ExComboboxModule,
            ExNewComboboxModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuItemModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExComponentLoaderModule,
                    ExLabelModule,
                    TranslateModule,
                    ExComboboxModule,
                    ExNewComboboxModule,
                    EXPipesModule
                ],
                declarations: [
                    MenuItemComponent,
                    MenuItemsToCombobox
                ],
                exports: [
                    MenuItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MenuItemModule, { declarations: [MenuItemComponent,
        MenuItemsToCombobox], imports: [CommonModule,
        MatMenuModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExComponentLoaderModule,
        ExLabelModule,
        TranslateModule,
        ExComboboxModule,
        ExNewComboboxModule,
        EXPipesModule], exports: [MenuItemComponent] }); })();
i0.ɵɵsetComponentScope(MenuItemComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i3$1.MatMenu, i3$1.MatMenuItem, i3$1.MatMenuTrigger, ExTooltipDirective, ExComponentLoaderComponent, ExLabelComponent, ExNewComboboxComponent, MenuItemComponent], [i1$2.TranslatePipe, ExObjectAssignPipe, ExGenerateIdPipe, MenuItemsToCombobox]);

class ExButtonModule {
    static { this.ɵfac = function ExButtonModule_Factory(t) { return new (t || ExButtonModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExButtonModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatRippleModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExSpinnerModule,
            MenuItemModule,
            MatMenuModule,
            MatButtonModule,
            TranslateModule,
            ExSvgIconModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatRippleModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExSpinnerModule,
                    MenuItemModule,
                    MatMenuModule,
                    MatButtonModule,
                    TranslateModule,
                    ExSvgIconModule,
                    EXPipesModule
                ],
                declarations: [
                    ExButtonComponent
                ],
                exports: [
                    ExButtonComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExButtonModule, { declarations: [ExButtonComponent], imports: [CommonModule,
        MatRippleModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExSpinnerModule,
        MenuItemModule,
        MatMenuModule,
        MatButtonModule,
        TranslateModule,
        ExSvgIconModule,
        EXPipesModule], exports: [ExButtonComponent] }); })();

class ExBannerModule {
    static { this.ɵfac = function ExBannerModule_Factory(t) { return new (t || ExBannerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExBannerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            ExIconModule,
            ExButtonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBannerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    ExIconModule,
                    ExButtonModule
                ],
                declarations: [
                    ExBannerComponent
                ],
                exports: [
                    ExBannerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExBannerModule, { declarations: [ExBannerComponent], imports: [CommonModule,
        TranslateModule,
        ExIconModule,
        ExButtonModule], exports: [ExBannerComponent] }); })();

class ExAreaChartComponent extends AreaChartComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExAreaChartComponent_BaseFactory; return function ExAreaChartComponent_Factory(t) { return (ɵExAreaChartComponent_BaseFactory || (ɵExAreaChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExAreaChartComponent)))(t || ExAreaChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExAreaChartComponent, selectors: [["ex-area-chart"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 35, consts: [[3, "view", "results", "scheme", "schemeType", "customColors", "animations", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "timeline", "autoScale", "curve", "gradient", "tooltipDisabled", "xScaleMin", "xScaleMax", "yScaleMin", "yScaleMax", "select", "activate", "deactivate"]], template: function ExAreaChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ngx-charts-area-chart", 0);
            i0.ɵɵlistener("select", function ExAreaChartComponent_Template_ngx_charts_area_chart_select_0_listener($event) { return ctx.select.emit($event); })("activate", function ExAreaChartComponent_Template_ngx_charts_area_chart_activate_0_listener($event) { return ctx.activate.emit($event); })("deactivate", function ExAreaChartComponent_Template_ngx_charts_area_chart_deactivate_0_listener($event) { return ctx.deactivate.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("view", ctx.view)("results", ctx.results)("scheme", ctx.scheme)("schemeType", ctx.schemeType)("customColors", ctx.customColors)("animations", ctx.animations)("legend", ctx.legend)("legendTitle", ctx.legendTitle)("legendPosition", ctx.legendPosition)("xAxis", ctx.xAxis)("yAxis", ctx.yAxis)("showGridLines", ctx.showGridLines)("roundDomains", ctx.roundDomains)("showXAxisLabel", ctx.showXAxisLabel)("showYAxisLabel", ctx.showYAxisLabel)("xAxisLabel", ctx.xAxisLabel)("yAxisLabel", ctx.yAxisLabel)("trimXAxisTicks", ctx.trimXAxisTicks)("trimYAxisTicks", ctx.trimYAxisTicks)("rotateXAxisTicks", ctx.rotateXAxisTicks)("maxXAxisTickLength", ctx.maxXAxisTickLength)("maxYAxisTickLength", ctx.maxYAxisTickLength)("xAxisTickFormatting", ctx.xAxisTickFormatting)("yAxisTickFormatting", ctx.yAxisTickFormatting)("xAxisTicks", ctx.xAxisTicks)("yAxisTicks", ctx.yAxisTicks)("timeline", ctx.timeline)("autoScale", ctx.autoScale)("curve", ctx.curve)("gradient", ctx.gradient)("tooltipDisabled", ctx.tooltipDisabled)("xScaleMin", ctx.xScaleMin)("xScaleMax", ctx.xScaleMax)("yScaleMin", ctx.yScaleMin)("yScaleMax", ctx.yScaleMax);
        } }, dependencies: [i1$a.AreaChartComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAreaChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-area-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-charts-area-chart [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [schemeType]=\"schemeType\"\n  [customColors]=\"customColors\" [animations]=\"animations\" [legend]=\"legend\" [legendTitle]=\"legendTitle\"\n  [legendPosition]=\"legendPosition\" [xAxis]=\"xAxis\" [yAxis]=\"yAxis\" [showGridLines]=\"showGridLines\"\n  [roundDomains]=\"roundDomains\" [showXAxisLabel]=\"showXAxisLabel\" [showYAxisLabel]=\"showYAxisLabel\"\n  [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\" [trimXAxisTicks]=\"trimXAxisTicks\"\n  [trimYAxisTicks]=\"trimYAxisTicks\" [rotateXAxisTicks]=\"rotateXAxisTicks\" [maxXAxisTickLength]=\"maxXAxisTickLength\"\n  [maxYAxisTickLength]=\"maxYAxisTickLength\" [xAxisTickFormatting]=\"xAxisTickFormatting\"\n  [yAxisTickFormatting]=\"yAxisTickFormatting\" [xAxisTicks]=\"xAxisTicks\" [yAxisTicks]=\"yAxisTicks\" [timeline]=\"timeline\"\n  [autoScale]=\"autoScale\" [curve]=\"curve\" [gradient]=\"gradient\" [tooltipDisabled]=\"tooltipDisabled\"\n  [xScaleMin]=\"xScaleMin\" [xScaleMax]=\"xScaleMax\" [yScaleMin]=\"yScaleMin\" [yScaleMax]=\"yScaleMax\"\n  (select)=\"select.emit($event)\" (activate)=\"activate.emit($event)\" (deactivate)=\"deactivate.emit($event)\">\n</ngx-charts-area-chart>" }]
    }], null, null); })();

function ExBarChartComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ngx-charts-bar-vertical", 2);
    i0.ɵɵlistener("select", function ExBarChartComponent_ng_container_0_Template_ngx_charts_bar_vertical_select_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.select.emit($event)); })("activate", function ExBarChartComponent_ng_container_0_Template_ngx_charts_bar_vertical_activate_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.activate.emit($event)); })("deactivate", function ExBarChartComponent_ng_container_0_Template_ngx_charts_bar_vertical_deactivate_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.deactivate.emit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("view", ctx_r0.view)("results", ctx_r0.results)("scheme", ctx_r0.scheme)("schemeType", ctx_r0.schemeType)("customColors", ctx_r0.customColors)("animations", ctx_r0.animations)("legend", ctx_r0.legend)("legendTitle", ctx_r0.legendTitle)("legendPosition", ctx_r0.legendPosition)("xAxis", ctx_r0.xAxis)("yAxis", ctx_r0.yAxis)("showGridLines", ctx_r0.showGridLines)("roundDomains", ctx_r0.roundDomains)("showXAxisLabel", ctx_r0.showXAxisLabel)("showYAxisLabel", ctx_r0.showYAxisLabel)("xAxisLabel", ctx_r0.xAxisLabel)("yAxisLabel", ctx_r0.yAxisLabel)("trimXAxisTicks", ctx_r0.trimXAxisTicks)("trimYAxisTicks", ctx_r0.trimYAxisTicks)("rotateXAxisTicks", ctx_r0.rotateXAxisTicks)("maxXAxisTickLength", ctx_r0.maxXAxisTickLength)("maxYAxisTickLength", ctx_r0.maxYAxisTickLength)("xAxisTickFormatting", ctx_r0.xAxisTickFormatting)("yAxisTickFormatting", ctx_r0.yAxisTickFormatting)("xAxisTicks", ctx_r0.xAxisTicks)("yAxisTicks", ctx_r0.yAxisTicks)("showDataLabel", ctx_r0.showDataLabel)("noBarWhenZero", ctx_r0.noBarWhenZero)("gradient", ctx_r0.gradient)("barPadding", ctx_r0.barPadding)("tooltipDisabled", ctx_r0.tooltipDisabled)("yScaleMax", ctx_r0.yScaleMax)("yScaleMin", ctx_r0.yScaleMin)("roundEdges", ctx_r0.roundEdges);
} }
function ExBarChartComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-charts-bar-vertical-stacked", 3);
    i0.ɵɵlistener("select", function ExBarChartComponent_ng_template_1_Template_ngx_charts_bar_vertical_stacked_select_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.select.emit($event)); })("activate", function ExBarChartComponent_ng_template_1_Template_ngx_charts_bar_vertical_stacked_activate_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.activate.emit($event)); })("deactivate", function ExBarChartComponent_ng_template_1_Template_ngx_charts_bar_vertical_stacked_deactivate_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.deactivate.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("view", ctx_r2.view)("results", ctx_r2.results)("scheme", ctx_r2.scheme)("schemeType", ctx_r2.schemeType)("customColors", ctx_r2.customColors)("animations", ctx_r2.animations)("legend", ctx_r2.legend)("legendTitle", ctx_r2.legendTitle)("legendPosition", ctx_r2.legendPosition)("xAxis", ctx_r2.xAxis)("yAxis", ctx_r2.yAxis)("showGridLines", ctx_r2.showGridLines)("roundDomains", ctx_r2.roundDomains)("showXAxisLabel", ctx_r2.showXAxisLabel)("showYAxisLabel", ctx_r2.showYAxisLabel)("xAxisLabel", ctx_r2.xAxisLabel)("yAxisLabel", ctx_r2.yAxisLabel)("trimXAxisTicks", ctx_r2.trimXAxisTicks)("trimYAxisTicks", ctx_r2.trimYAxisTicks)("rotateXAxisTicks", ctx_r2.rotateXAxisTicks)("maxXAxisTickLength", ctx_r2.maxXAxisTickLength)("maxYAxisTickLength", ctx_r2.maxYAxisTickLength)("xAxisTickFormatting", ctx_r2.xAxisTickFormatting)("yAxisTickFormatting", ctx_r2.yAxisTickFormatting)("xAxisTicks", ctx_r2.xAxisTicks)("yAxisTicks", ctx_r2.yAxisTicks)("showDataLabel", ctx_r2.showDataLabel)("noBarWhenZero", ctx_r2.noBarWhenZero)("gradient", ctx_r2.gradient)("barPadding", ctx_r2.barPadding)("tooltipDisabled", ctx_r2.tooltipDisabled)("yScaleMax", ctx_r2.yScaleMax);
} }
class ExBarChartComponent extends BarVerticalComponent {
    constructor() {
        super(...arguments);
        this.stacked = false;
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExBarChartComponent_BaseFactory; return function ExBarChartComponent_Factory(t) { return (ɵExBarChartComponent_BaseFactory || (ɵExBarChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExBarChartComponent)))(t || ExBarChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExBarChartComponent, selectors: [["ex-bar-chart"]], inputs: { stacked: "stacked" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["stackedChart", ""], [3, "view", "results", "scheme", "schemeType", "customColors", "animations", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "showDataLabel", "noBarWhenZero", "gradient", "barPadding", "tooltipDisabled", "yScaleMax", "yScaleMin", "roundEdges", "select", "activate", "deactivate"], [3, "view", "results", "scheme", "schemeType", "customColors", "animations", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "showDataLabel", "noBarWhenZero", "gradient", "barPadding", "tooltipDisabled", "yScaleMax", "select", "activate", "deactivate"]], template: function ExBarChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExBarChartComponent_ng_container_0_Template, 2, 34, "ng-container", 0);
            i0.ɵɵtemplate(1, ExBarChartComponent_ng_template_1_Template, 1, 32, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.stacked)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgIf, i1$a.BarVerticalComponent, i1$a.BarVerticalStackedComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBarChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-bar-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!stacked; else stackedChart\">\n  <ngx-charts-bar-vertical [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [schemeType]=\"schemeType\"\n                           [customColors]=\"customColors\" [animations]=\"animations\" [legend]=\"legend\"\n                           [legendTitle]=\"legendTitle\"\n                           [legendPosition]=\"legendPosition\" [xAxis]=\"xAxis\" [yAxis]=\"yAxis\"\n                           [showGridLines]=\"showGridLines\"\n                           [roundDomains]=\"roundDomains\" [showXAxisLabel]=\"showXAxisLabel\"\n                           [showYAxisLabel]=\"showYAxisLabel\"\n                           [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\" [trimXAxisTicks]=\"trimXAxisTicks\"\n                           [trimYAxisTicks]=\"trimYAxisTicks\" [rotateXAxisTicks]=\"rotateXAxisTicks\"\n                           [maxXAxisTickLength]=\"maxXAxisTickLength\"\n                           [maxYAxisTickLength]=\"maxYAxisTickLength\" [xAxisTickFormatting]=\"xAxisTickFormatting\"\n                           [yAxisTickFormatting]=\"yAxisTickFormatting\" [xAxisTicks]=\"xAxisTicks\"\n                           [yAxisTicks]=\"yAxisTicks\"\n                           [showDataLabel]=\"showDataLabel\" [noBarWhenZero]=\"noBarWhenZero\" [gradient]=\"gradient\"\n                           [barPadding]=\"barPadding\"\n                           [tooltipDisabled]=\"tooltipDisabled\" [yScaleMax]=\"yScaleMax\" [yScaleMin]=\"yScaleMin\"\n                           [roundEdges]=\"roundEdges\"\n                           (select)=\"select.emit($event)\" (activate)=\"activate.emit($event)\"\n                           (deactivate)=\"deactivate.emit($event)\">\n  </ngx-charts-bar-vertical>\n</ng-container>\n<ng-template #stackedChart>\n  <ngx-charts-bar-vertical-stacked [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [schemeType]=\"schemeType\"\n                                   [customColors]=\"customColors\" [animations]=\"animations\" [legend]=\"legend\"\n                                   [legendTitle]=\"legendTitle\"\n                                   [legendPosition]=\"legendPosition\" [xAxis]=\"xAxis\" [yAxis]=\"yAxis\"\n                                   [showGridLines]=\"showGridLines\"\n                                   [roundDomains]=\"roundDomains\" [showXAxisLabel]=\"showXAxisLabel\"\n                                   [showYAxisLabel]=\"showYAxisLabel\"\n                                   [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\" [trimXAxisTicks]=\"trimXAxisTicks\"\n                                   [trimYAxisTicks]=\"trimYAxisTicks\" [rotateXAxisTicks]=\"rotateXAxisTicks\"\n                                   [maxXAxisTickLength]=\"maxXAxisTickLength\"\n                                   [maxYAxisTickLength]=\"maxYAxisTickLength\" [xAxisTickFormatting]=\"xAxisTickFormatting\"\n                                   [yAxisTickFormatting]=\"yAxisTickFormatting\" [xAxisTicks]=\"xAxisTicks\"\n                                   [yAxisTicks]=\"yAxisTicks\"\n                                   [showDataLabel]=\"showDataLabel\" [noBarWhenZero]=\"noBarWhenZero\" [gradient]=\"gradient\"\n                                   [barPadding]=\"barPadding\"\n                                   [tooltipDisabled]=\"tooltipDisabled\" [yScaleMax]=\"yScaleMax\"\n                                   (select)=\"select.emit($event)\" (activate)=\"activate.emit($event)\"\n                                   (deactivate)=\"deactivate.emit($event)\">\n  </ngx-charts-bar-vertical-stacked>\n</ng-template>\n" }]
    }], null, { stacked: [{
            type: Input
        }] }); })();

class ExBubbleChartComponent extends BubbleChartComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExBubbleChartComponent_BaseFactory; return function ExBubbleChartComponent_Factory(t) { return (ɵExBubbleChartComponent_BaseFactory || (ɵExBubbleChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExBubbleChartComponent)))(t || ExBubbleChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExBubbleChartComponent, selectors: [["ex-bubble-chart"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 28, consts: [[3, "view", "results", "scheme", "schemeType", "customColors", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "rotateXAxisTicks", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "minRadius", "maxRadius", "tooltipDisabled", "xScaleMin", "xScaleMax", "yScaleMin", "yScaleMax", "select", "activate", "deactivate"]], template: function ExBubbleChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ngx-charts-bubble-chart", 0);
            i0.ɵɵlistener("select", function ExBubbleChartComponent_Template_ngx_charts_bubble_chart_select_0_listener($event) { return ctx.select.emit($event); })("activate", function ExBubbleChartComponent_Template_ngx_charts_bubble_chart_activate_0_listener($event) { return ctx.activate.emit($event); })("deactivate", function ExBubbleChartComponent_Template_ngx_charts_bubble_chart_deactivate_0_listener($event) { return ctx.deactivate.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("view", ctx.view)("results", ctx.results)("scheme", ctx.scheme)("schemeType", ctx.schemeType)("customColors", ctx.customColors)("legend", ctx.legend)("legendTitle", ctx.legendTitle)("legendPosition", ctx.legendPosition)("xAxis", ctx.xAxis)("yAxis", ctx.yAxis)("showGridLines", ctx.showGridLines)("roundDomains", ctx.roundDomains)("showXAxisLabel", ctx.showXAxisLabel)("showYAxisLabel", ctx.showYAxisLabel)("xAxisLabel", ctx.xAxisLabel)("yAxisLabel", ctx.yAxisLabel)("rotateXAxisTicks", ctx.rotateXAxisTicks)("xAxisTickFormatting", ctx.xAxisTickFormatting)("yAxisTickFormatting", ctx.yAxisTickFormatting)("xAxisTicks", ctx.xAxisTicks)("yAxisTicks", ctx.yAxisTicks)("minRadius", ctx.minRadius)("maxRadius", ctx.maxRadius)("tooltipDisabled", ctx.tooltipDisabled)("xScaleMin", ctx.xScaleMin)("xScaleMax", ctx.xScaleMax)("yScaleMin", ctx.yScaleMin)("yScaleMax", ctx.yScaleMax);
        } }, dependencies: [i1$a.BubbleChartComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBubbleChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-bubble-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-charts-bubble-chart [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [schemeType]=\"schemeType\"\n  [customColors]=\"customColors\" [legend]=\"legend\" [legendTitle]=\"legendTitle\" [legendPosition]=\"legendPosition\"\n  [xAxis]=\"xAxis\" [yAxis]=\"yAxis\" [showGridLines]=\"showGridLines\" [roundDomains]=\"roundDomains\"\n  [showXAxisLabel]=\"showXAxisLabel\" [showYAxisLabel]=\"showYAxisLabel\" [xAxisLabel]=\"xAxisLabel\"\n  [yAxisLabel]=\"yAxisLabel\" [rotateXAxisTicks]=\"rotateXAxisTicks\" [xAxisTickFormatting]=\"xAxisTickFormatting\"\n  [yAxisTickFormatting]=\"yAxisTickFormatting\" [xAxisTicks]=\"xAxisTicks\" [yAxisTicks]=\"yAxisTicks\"\n  [minRadius]=\"minRadius\" [maxRadius]=\"maxRadius\" [tooltipDisabled]=\"tooltipDisabled\" [xScaleMin]=\"xScaleMin\"\n  [xScaleMax]=\"xScaleMax\" [yScaleMin]=\"yScaleMin\" [yScaleMax]=\"yScaleMax\" (select)=\"select.emit($event)\"\n  (activate)=\"activate.emit($event)\" (deactivate)=\"deactivate.emit($event)\">\n</ngx-charts-bubble-chart>" }]
    }], null, null); })();

class ExLineChartComponent extends LineChartComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExLineChartComponent_BaseFactory; return function ExLineChartComponent_Factory(t) { return (ɵExLineChartComponent_BaseFactory || (ɵExLineChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExLineChartComponent)))(t || ExLineChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLineChartComponent, selectors: [["ex-line-chart"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 38, consts: [[3, "view", "results", "scheme", "customColors", "animations", "rangeFillOpacity", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "trimXAxisTicks", "trimYAxisTicks", "rotateXAxisTicks", "maxXAxisTickLength", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "xAxisTicks", "yAxisTicks", "timeline", "autoScale", "curve", "gradient", "tooltipDisabled", "referenceLines", "showRefLines", "showRefLabels", "xScaleMin", "xScaleMax", "yScaleMin", "yScaleMax", "select", "activate", "deactivate"]], template: function ExLineChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ngx-charts-line-chart", 0);
            i0.ɵɵlistener("select", function ExLineChartComponent_Template_ngx_charts_line_chart_select_0_listener($event) { return ctx.select.emit($event); })("activate", function ExLineChartComponent_Template_ngx_charts_line_chart_activate_0_listener($event) { return ctx.activate.emit($event); })("deactivate", function ExLineChartComponent_Template_ngx_charts_line_chart_deactivate_0_listener($event) { return ctx.deactivate.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("view", ctx.view)("results", ctx.results)("scheme", ctx.scheme)("customColors", ctx.customColors)("animations", ctx.animations)("rangeFillOpacity", ctx.rangeFillOpacity)("legend", ctx.legend)("legendTitle", ctx.legendTitle)("legendPosition", ctx.legendPosition)("xAxis", ctx.xAxis)("yAxis", ctx.yAxis)("showGridLines", ctx.showGridLines)("roundDomains", ctx.roundDomains)("showXAxisLabel", ctx.showXAxisLabel)("showYAxisLabel", ctx.showYAxisLabel)("xAxisLabel", ctx.xAxisLabel)("yAxisLabel", ctx.yAxisLabel)("trimXAxisTicks", ctx.trimXAxisTicks)("trimYAxisTicks", ctx.trimYAxisTicks)("rotateXAxisTicks", ctx.rotateXAxisTicks)("maxXAxisTickLength", ctx.maxXAxisTickLength)("maxYAxisTickLength", ctx.maxYAxisTickLength)("xAxisTickFormatting", ctx.xAxisTickFormatting)("yAxisTickFormatting", ctx.yAxisTickFormatting)("xAxisTicks", ctx.xAxisTicks)("yAxisTicks", ctx.yAxisTicks)("timeline", ctx.timeline)("autoScale", ctx.autoScale)("curve", ctx.curve)("gradient", ctx.gradient)("tooltipDisabled", ctx.tooltipDisabled)("referenceLines", ctx.referenceLines)("showRefLines", ctx.showRefLines)("showRefLabels", ctx.showRefLabels)("xScaleMin", ctx.xScaleMin)("xScaleMax", ctx.xScaleMax)("yScaleMin", ctx.yScaleMin)("yScaleMax", ctx.yScaleMax);
        } }, dependencies: [i1$a.LineChartComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLineChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-line-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-charts-line-chart [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [customColors]=\"customColors\"\n  [animations]=\"animations\" [rangeFillOpacity]=\"rangeFillOpacity\" [legend]=\"legend\" [legendTitle]=\"legendTitle\"\n  [legendPosition]=\"legendPosition\" [xAxis]=\"xAxis\" [yAxis]=\"yAxis\" [showGridLines]=\"showGridLines\"\n  [roundDomains]=\"roundDomains\" [showXAxisLabel]=\"showXAxisLabel\" [showYAxisLabel]=\"showYAxisLabel\"\n  [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\" [trimXAxisTicks]=\"trimXAxisTicks\"\n  [trimYAxisTicks]=\"trimYAxisTicks\" [rotateXAxisTicks]=\"rotateXAxisTicks\" [maxXAxisTickLength]=\"maxXAxisTickLength\"\n  [maxYAxisTickLength]=\"maxYAxisTickLength\" [xAxisTickFormatting]=\"xAxisTickFormatting\"\n  [yAxisTickFormatting]=\"yAxisTickFormatting\" [xAxisTicks]=\"xAxisTicks\" [yAxisTicks]=\"yAxisTicks\" [timeline]=\"timeline\"\n  [autoScale]=\"autoScale\" [curve]=\"curve\" [gradient]=\"gradient\" [tooltipDisabled]=\"tooltipDisabled\"\n  [referenceLines]=\"referenceLines\" [showRefLines]=\"showRefLines\" [showRefLabels]=\"showRefLabels\"\n  [xScaleMin]=\"xScaleMin\" [xScaleMax]=\"xScaleMax\" [yScaleMin]=\"yScaleMin\" [yScaleMax]=\"yScaleMax\"\n  (select)=\"select.emit($event)\" (activate)=\"activate.emit($event)\" (deactivate)=\"deactivate.emit($event)\">\n</ngx-charts-line-chart>" }]
    }], null, null); })();

class ExNewPieChartComponent extends PieChartComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExNewPieChartComponent_BaseFactory; return function ExNewPieChartComponent_Factory(t) { return (ɵExNewPieChartComponent_BaseFactory || (ɵExNewPieChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExNewPieChartComponent)))(t || ExNewPieChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExNewPieChartComponent, selectors: [["ex-pie2-chart"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 18, consts: [[3, "view", "results", "scheme", "customColors", "animations", "labels", "labelFormatting", "trimLabels", "maxLabelLength", "legend", "legendTitle", "legendPosition", "explodeSlices", "doughnut", "arcWidth", "gradient", "tooltipDisabled", "tooltipText", "select", "activate", "deactivate"]], template: function ExNewPieChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ngx-charts-pie-chart", 0);
            i0.ɵɵlistener("select", function ExNewPieChartComponent_Template_ngx_charts_pie_chart_select_0_listener($event) { return ctx.select.emit($event); })("activate", function ExNewPieChartComponent_Template_ngx_charts_pie_chart_activate_0_listener($event) { return ctx.activate.emit($event); })("deactivate", function ExNewPieChartComponent_Template_ngx_charts_pie_chart_deactivate_0_listener($event) { return ctx.deactivate.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("view", ctx.view)("results", ctx.results)("scheme", ctx.scheme)("customColors", ctx.customColors)("animations", ctx.animations)("labels", ctx.labels)("labelFormatting", ctx.labelFormatting)("trimLabels", ctx.trimLabels)("maxLabelLength", ctx.maxLabelLength)("legend", ctx.legend)("legendTitle", ctx.legendTitle)("legendPosition", ctx.legendPosition)("explodeSlices", ctx.explodeSlices)("doughnut", ctx.doughnut)("arcWidth", ctx.arcWidth)("gradient", ctx.gradient)("tooltipDisabled", ctx.tooltipDisabled)("tooltipText", ctx.tooltipText);
        } }, dependencies: [i1$a.PieChartComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNewPieChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-pie2-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-charts-pie-chart [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [customColors]=\"customColors\"\n  [animations]=\"animations\" [labels]=\"labels\" [labelFormatting]=\"labelFormatting\" [trimLabels]=\"trimLabels\"\n  [maxLabelLength]=\"maxLabelLength\" [legend]=\"legend\" [legendTitle]=\"legendTitle\" [legendPosition]=\"legendPosition\"\n  [explodeSlices]=\"explodeSlices\" [doughnut]=\"doughnut\" [arcWidth]=\"arcWidth\" [gradient]=\"gradient\"\n  [tooltipDisabled]=\"tooltipDisabled\" [tooltipText]=\"tooltipText\" (select)=\"select.emit($event)\"\n  (activate)=\"activate.emit($event)\" (deactivate)=\"deactivate.emit($event)\">\n</ngx-charts-pie-chart>" }]
    }], null, null); })();

class ExPolarChartComponent extends PolarChartComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExPolarChartComponent_BaseFactory; return function ExPolarChartComponent_Factory(t) { return (ɵExPolarChartComponent_BaseFactory || (ɵExPolarChartComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExPolarChartComponent)))(t || ExPolarChartComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExPolarChartComponent, selectors: [["ex-polar-chart"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 29, consts: [[3, "view", "results", "scheme", "schemeType", "customColors", "animations", "rangeFillOpacity", "legend", "legendTitle", "legendPosition", "xAxis", "yAxis", "showGridLines", "roundDomains", "showXAxisLabel", "showYAxisLabel", "xAxisLabel", "yAxisLabel", "labelTrim", "labelTrimSize", "trimYAxisTicks", "maxYAxisTickLength", "xAxisTickFormatting", "yAxisTickFormatting", "autoScale", "curve", "tooltipDisabled", "showSeriesOnHover", "yAxisMinScale", "select", "activate", "deactivate"]], template: function ExPolarChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ngx-charts-polar-chart", 0);
            i0.ɵɵlistener("select", function ExPolarChartComponent_Template_ngx_charts_polar_chart_select_0_listener($event) { return ctx.select.emit($event); })("activate", function ExPolarChartComponent_Template_ngx_charts_polar_chart_activate_0_listener($event) { return ctx.activate.emit($event); })("deactivate", function ExPolarChartComponent_Template_ngx_charts_polar_chart_deactivate_0_listener($event) { return ctx.deactivate.emit($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("view", ctx.view)("results", ctx.results)("scheme", ctx.scheme)("schemeType", ctx.schemeType)("customColors", ctx.customColors)("animations", ctx.animations)("rangeFillOpacity", ctx.rangeFillOpacity)("legend", ctx.legend)("legendTitle", ctx.legendTitle)("legendPosition", ctx.legendPosition)("xAxis", ctx.xAxis)("yAxis", ctx.yAxis)("showGridLines", ctx.showGridLines)("roundDomains", ctx.roundDomains)("showXAxisLabel", ctx.showXAxisLabel)("showYAxisLabel", ctx.showYAxisLabel)("xAxisLabel", ctx.xAxisLabel)("yAxisLabel", ctx.yAxisLabel)("labelTrim", ctx.labelTrim)("labelTrimSize", ctx.labelTrimSize)("trimYAxisTicks", ctx.trimYAxisTicks)("maxYAxisTickLength", ctx.maxYAxisTickLength)("xAxisTickFormatting", ctx.xAxisTickFormatting)("yAxisTickFormatting", ctx.yAxisTickFormatting)("autoScale", ctx.autoScale)("curve", ctx.curve)("tooltipDisabled", ctx.tooltipDisabled)("showSeriesOnHover", ctx.showSeriesOnHover)("yAxisMinScale", ctx.yAxisMinScale);
        } }, dependencies: [i1$a.PolarChartComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPolarChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-polar-chart', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-charts-polar-chart [view]=\"view\" [results]=\"results\" [scheme]=\"scheme\" [schemeType]=\"schemeType\"\n  [customColors]=\"customColors\" [animations]=\"animations\" [rangeFillOpacity]=\"rangeFillOpacity\" [legend]=\"legend\"\n  [legendTitle]=\"legendTitle\" [legendPosition]=\"legendPosition\" [xAxis]=\"xAxis\" [yAxis]=\"yAxis\"\n  [showGridLines]=\"showGridLines\" [roundDomains]=\"roundDomains\" [showXAxisLabel]=\"showXAxisLabel\"\n  [showYAxisLabel]=\"showYAxisLabel\" [xAxisLabel]=\"xAxisLabel\" [yAxisLabel]=\"yAxisLabel\" [labelTrim]=\"labelTrim\"\n  [labelTrimSize]=\"labelTrimSize\" [trimYAxisTicks]=\"trimYAxisTicks\" [maxYAxisTickLength]=\"maxYAxisTickLength\"\n  [xAxisTickFormatting]=\"xAxisTickFormatting\" [yAxisTickFormatting]=\"yAxisTickFormatting\" [autoScale]=\"autoScale\"\n  [curve]=\"curve\" [tooltipDisabled]=\"tooltipDisabled\" [showSeriesOnHover]=\"showSeriesOnHover\"\n  [yAxisMinScale]=\"yAxisMinScale\" (select)=\"select.emit($event)\" (activate)=\"activate.emit($event)\"\n  (deactivate)=\"deactivate.emit($event)\">\n</ngx-charts-polar-chart>" }]
    }], null, null); })();

class ExChartsModule {
    static { this.ɵfac = function ExChartsModule_Factory(t) { return new (t || ExChartsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExChartsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [NgxChartsModule,
            CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChartsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NgxChartsModule,
                    CommonModule
                ],
                declarations: [
                    ExAreaChartComponent,
                    ExBarChartComponent,
                    ExBubbleChartComponent,
                    ExLineChartComponent,
                    ExNewPieChartComponent,
                    ExPolarChartComponent
                ],
                exports: [
                    ExAreaChartComponent,
                    ExBarChartComponent,
                    ExBubbleChartComponent,
                    ExLineChartComponent,
                    ExNewPieChartComponent,
                    ExPolarChartComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExChartsModule, { declarations: [ExAreaChartComponent,
        ExBarChartComponent,
        ExBubbleChartComponent,
        ExLineChartComponent,
        ExNewPieChartComponent,
        ExPolarChartComponent], imports: [NgxChartsModule,
        CommonModule], exports: [ExAreaChartComponent,
        ExBarChartComponent,
        ExBubbleChartComponent,
        ExLineChartComponent,
        ExNewPieChartComponent,
        ExPolarChartComponent] }); })();

function ExConfirmationMessageComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.message), " ");
} }
function ExConfirmationMessageComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "button", 5);
    i0.ɵɵlistener("keydown.escape", function ExConfirmationMessageComponent_div_2_Template_button_keydown_escape_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onCancelClicked()); })("click", function ExConfirmationMessageComponent_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onConfirmClicked()); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-icon", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 7);
    i0.ɵɵlistener("keydown.escape", function ExConfirmationMessageComponent_div_2_Template_button_keydown_escape_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onCancelClicked()); })("click", function ExConfirmationMessageComponent_div_2_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onCancelClicked()); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-icon", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(2, 5, "ng.general.accept"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sizePx", ctx_r1.isSmall ? "20px" : "30px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("autofocus", true)("matTooltip", i0.ɵɵpipeBind1(5, 7, "ng.general.decline"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sizePx", ctx_r1.isSmall ? "20px" : "30px");
} }
class ExConfirmationMessageComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * Event that fired after the user clicked on confirm
         */
        this.confirmClicked = new EventEmitter();
        /**
         * Event that fired after the user clicked on cancel
         */
        this.cancelClicked = new EventEmitter();
        this.isSmall = true;
        this.showText = false;
    }
    ngOnInit() {
        setTimeout(() => {
            this.showText = true;
            this.cdr.markForCheck();
        }, 10);
    }
    onConfirmClicked() {
        this.confirmClicked.emit();
    }
    onCancelClicked() {
        this.cancelClicked.emit();
    }
    onResize(event) {
        if (event.newRect.height < 120) {
            this.isSmall = true;
        }
        else {
            this.isSmall = false;
        }
    }
    static { this.ɵfac = function ExConfirmationMessageComponent_Factory(t) { return new (t || ExConfirmationMessageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExConfirmationMessageComponent, selectors: [["ex-confirmation-message"]], inputs: { message: "message" }, outputs: { confirmClicked: "confirmClicked", cancelClicked: "cancelClicked" }, decls: 3, vars: 4, consts: [["cdkTrapFocus", "", 1, "ex-confirmation-message", "sel-confirmation-message", 3, "resized"], ["class", "ex-confirmation-message-title sel-confirmation-message-title", 4, "ngIf"], ["class", "ex-confirmation-message-buttons", 4, "ngIf"], [1, "ex-confirmation-message-title", "sel-confirmation-message-title"], [1, "ex-confirmation-message-buttons"], [1, "sel-confirmation-message-confirm", 3, "matTooltip", "keydown.escape", "click"], ["iconType", "fa-font", "iconName", "fa fa-check", 3, "sizePx"], [1, "ex-confirmation-message-cancel", "sel-confirmation-message-cancel", 3, "autofocus", "matTooltip", "keydown.escape", "click"], ["iconType", "fa-font", "iconName", "fa fa-times", 3, "sizePx"]], template: function ExConfirmationMessageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("resized", function ExConfirmationMessageComponent_Template_div_resized_0_listener($event) { return ctx.onResize($event); });
            i0.ɵɵtemplate(1, ExConfirmationMessageComponent_div_1_Template, 3, 3, "div", 1);
            i0.ɵɵtemplate(2, ExConfirmationMessageComponent_div_2_Template, 7, 9, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("ex-confirmation-message-small", ctx.isSmall);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showText);
        } }, dependencies: [i3.CdkTrapFocus, i1$5.NgIf, ExIconComponent, i4.MatTooltip, ResizedDirective, i10.AutofocusFixDirective, i1$2.TranslatePipe], styles: [".ex-confirmation-message[_ngcontent-%COMP%]{padding:5px;color:#fff!important;flex-direction:column;font-size:14px;position:absolute!important;inset:0;display:flex;align-items:center;justify-content:center;background:#696868c2;z-index:100000}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-title[_ngcontent-%COMP%]{margin-bottom:15px;text-align:center}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;height:50px;width:50px;border-radius:50%;border:solid 1px;display:flex;align-items:center;justify-content:center}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(:last-child){margin-right:25px}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]     ex-icon div{display:flex}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background:#fff;outline:none}.ex-confirmation-message[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover     ex-icon i{color:#555}.ex-confirmation-message-small[_ngcontent-%COMP%]   .ex-confirmation-message-title[_ngcontent-%COMP%]{margin-bottom:5px!important}.ex-confirmation-message-small[_ngcontent-%COMP%]   .ex-confirmation-message-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;height:30px;width:30px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExConfirmationMessageComponent, [{
        type: Component,
        args: [{ selector: 'ex-confirmation-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (resized)=\"onResize($event)\" cdkTrapFocus class=\"ex-confirmation-message sel-confirmation-message\" [class.ex-confirmation-message-small]=\"isSmall\">\r\n    <div *ngIf=\"showText\" class=\"ex-confirmation-message-title sel-confirmation-message-title\">\r\n        {{ message | translate }}\r\n    </div>\r\n    <div *ngIf=\"showText\" class=\"ex-confirmation-message-buttons\">\r\n        <button (keydown.escape)=\"onCancelClicked()\" class=\"sel-confirmation-message-confirm\" [matTooltip]=\"'ng.general.accept' | translate\" (click)=\"onConfirmClicked()\">\r\n            <ex-icon [sizePx]=\"isSmall ? '20px' : '30px'\" iconType=\"fa-font\" iconName=\"fa fa-check\"></ex-icon>\r\n        </button>\r\n        <button [autofocus]=\"true\" (keydown.escape)=\"onCancelClicked()\" [matTooltip]=\"'ng.general.decline' | translate\" class=\"ex-confirmation-message-cancel sel-confirmation-message-cancel\"\r\n            (click)=\"onCancelClicked()\">\r\n            <ex-icon [sizePx]=\"isSmall ? '20px' : '30px'\" iconType=\"fa-font\" iconName=\"fa fa-times\"></ex-icon>\r\n        </button>\r\n    </div>\r\n</div>", styles: [".ex-confirmation-message{padding:5px;color:#fff!important;flex-direction:column;font-size:14px;position:absolute!important;inset:0;display:flex;align-items:center;justify-content:center;background:#696868c2;z-index:100000}.ex-confirmation-message .ex-confirmation-message-title{margin-bottom:15px;text-align:center}.ex-confirmation-message .ex-confirmation-message-buttons{display:flex;flex-direction:row}.ex-confirmation-message .ex-confirmation-message-buttons button{background:none;height:50px;width:50px;border-radius:50%;border:solid 1px;display:flex;align-items:center;justify-content:center}.ex-confirmation-message .ex-confirmation-message-buttons button:not(:last-child){margin-right:25px}.ex-confirmation-message .ex-confirmation-message-buttons button ::ng-deep ex-icon div{display:flex}.ex-confirmation-message .ex-confirmation-message-buttons button:hover{background:#fff;outline:none}.ex-confirmation-message .ex-confirmation-message-buttons button:hover ::ng-deep ex-icon i{color:#555}.ex-confirmation-message-small .ex-confirmation-message-title{margin-bottom:5px!important}.ex-confirmation-message-small .ex-confirmation-message-buttons button{background:none;height:30px;width:30px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { message: [{
            type: Input
        }], confirmClicked: [{
            type: Output
        }], cancelClicked: [{
            type: Output
        }] }); })();

class ExConfirmationMessageModule {
    static { this.ɵfac = function ExConfirmationMessageModule_Factory(t) { return new (t || ExConfirmationMessageModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExConfirmationMessageModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: AutofocusFixConfig,
                useValue: new AutofocusFixConfig({
                    async: false,
                    smartEmptyCheck: false,
                    triggerDetectChanges: false
                }),
            }
        ], imports: [A11yModule,
            CommonModule,
            TranslateModule,
            ExIconModule,
            MatTooltipModule,
            AngularResizeEventModule,
            AutofocusFixModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExConfirmationMessageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    A11yModule,
                    CommonModule,
                    TranslateModule,
                    ExIconModule,
                    MatTooltipModule,
                    AngularResizeEventModule,
                    AutofocusFixModule
                ],
                declarations: [
                    ExConfirmationMessageComponent
                ],
                exports: [
                    ExConfirmationMessageComponent
                ],
                providers: [
                    {
                        provide: AutofocusFixConfig,
                        useValue: new AutofocusFixConfig({
                            async: false,
                            smartEmptyCheck: false,
                            triggerDetectChanges: false
                        }),
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExConfirmationMessageModule, { declarations: [ExConfirmationMessageComponent], imports: [A11yModule,
        CommonModule,
        TranslateModule,
        ExIconModule,
        MatTooltipModule,
        AngularResizeEventModule,
        AutofocusFixModule], exports: [ExConfirmationMessageComponent] }); })();

const _c0$1p = ["content"];
const _c1$S = ["*"];
var dotColor;
(function (dotColor) {
    dotColor["green"] = "green";
    dotColor["orange"] = "orange";
    dotColor["red"] = "red";
    dotColor["gray"] = "gray";
})(dotColor || (dotColor = {}));
class ExDotWrapperComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.color = dotColor.green;
        this.displayDot = true;
    }
    ngAfterViewInit() {
        this.setStyle();
        this.cdr.detectChanges();
    }
    ngOnChanges(changes) {
        this.setStyle();
    }
    getSizeClass() {
        if (this.content) {
            const size = this.content.nativeElement.offsetHeight;
            if (size <= 18) {
                return 'small';
            }
            if (size <= 25) {
                return 'medium';
            }
            else {
                return 'large';
            }
        }
    }
    getColorClass() {
        if (this.color == dotColor.gray) {
            return 'gray';
        }
        if (this.color == dotColor.orange) {
            return 'orange';
        }
        if (this.color == dotColor.red) {
            return 'red';
        }
        return 'green';
    }
    setStyle() {
        this.styleClass = this.displayDot ? 'ex-dot-wrapper-color-' + this.getColorClass() + ' ' + 'ex-dot-wrapper-size-' + this.getSizeClass() + ' ' + 'ex-dot-wrapper-style' : '';
    }
    static { this.ɵfac = function ExDotWrapperComponent_Factory(t) { return new (t || ExDotWrapperComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDotWrapperComponent, selectors: [["ex-dot-wrapper"]], viewQuery: function ExDotWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1p, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        } }, inputs: { color: "color", displayDot: "displayDot" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$S, decls: 3, vars: 1, consts: [[1, "ex-dot-wrapper", 3, "ngClass"], ["content", ""]], template: function ExDotWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.styleClass);
        } }, dependencies: [i1$5.NgClass], styles: [".ex-dot-wrapper[_ngcontent-%COMP%]{display:flex}.ex-dot-wrapper-style[_ngcontent-%COMP%]{position:relative}.ex-dot-wrapper-style[_ngcontent-%COMP%]:after{content:\"\";border-radius:50%;position:absolute;inset-inline-end:max(-20%,-3px);bottom:max(-20%,-2px)}.ex-dot-wrapper-color-green[_ngcontent-%COMP%]:after{background:#2eb82e}.ex-dot-wrapper-color-orange[_ngcontent-%COMP%]:after{background:orange}.ex-dot-wrapper-color-gray[_ngcontent-%COMP%]:after{background:#5f5f5f}.ex-dot-wrapper-color-red[_ngcontent-%COMP%]:after{background:#e24343}.ex-dot-wrapper-size-small[_ngcontent-%COMP%]:after{height:50%;width:50%;border:1px solid #fff}.ex-dot-wrapper-size-medium[_ngcontent-%COMP%]:after{height:60%;width:60%;border:2px solid #fff}.ex-dot-wrapper-size-large[_ngcontent-%COMP%]:after{height:13px;width:13px;border:2px solid #fff}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDotWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-dot-wrapper', template: "<div class=\"ex-dot-wrapper\" #content [ngClass]=\"styleClass\">\n    <ng-content></ng-content>\n</div>\n", styles: [".ex-dot-wrapper{display:flex}.ex-dot-wrapper-style{position:relative}.ex-dot-wrapper-style:after{content:\"\";border-radius:50%;position:absolute;inset-inline-end:max(-20%,-3px);bottom:max(-20%,-2px)}.ex-dot-wrapper-color-green:after{background:#2eb82e}.ex-dot-wrapper-color-orange:after{background:orange}.ex-dot-wrapper-color-gray:after{background:#5f5f5f}.ex-dot-wrapper-color-red:after{background:#e24343}.ex-dot-wrapper-size-small:after{height:50%;width:50%;border:1px solid #fff}.ex-dot-wrapper-size-medium:after{height:60%;width:60%;border:2px solid #fff}.ex-dot-wrapper-size-large:after{height:13px;width:13px;border:2px solid #fff}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { color: [{
            type: Input
        }], displayDot: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content']
        }] }); })();

const _c0$1o = function (a0) { return { "ex-action-icon-disabled": a0 }; };
function ExActionIconMenuComponent_div_1_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ExActionIconMenuComponent_div_1_ng_container_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const action_r2 = i0.ɵɵnextContext().$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onActionClicked(action_r2.value)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "ex-dot-wrapper", 7);
    i0.ɵɵelement(3, "ex-svg-icon", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r3.disabled || action_r2.disabled)("ngClass", i0.ɵɵpureFunction1(12, _c0$1o, action_r2.disabled));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 10, action_r2.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("displayDot", action_r2.indicator);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", action_r2.icon == null ? null : action_r2.icon.iconName)("ariaLabel", action_r2.label)("tooltip", action_r2.label)("size", "medium")("color", action_r2.icon.iconColor)("ngClass", "ex-action-icon-name-" + (action_r2.icon == null ? null : action_r2.icon.iconName));
} }
function ExActionIconMenuComponent_div_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 9);
    i0.ɵɵlistener("click", function ExActionIconMenuComponent_div_1_ng_container_1_ng_template_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const action_r2 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onActionClicked(action_r2.value)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r5.disabled || action_r2.disabled)("loading", action_r2.loading)("ariaLabel", action_r2.label)("tooltip", action_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, action_r2.label), " ");
} }
function ExActionIconMenuComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExActionIconMenuComponent_div_1_ng_container_1_button_1_Template, 4, 14, "button", 4);
    i0.ɵɵtemplate(2, ExActionIconMenuComponent_div_1_ng_container_1_ng_template_2_Template, 3, 7, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r2 = ctx.$implicit;
    const _r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", action_r2.icon == null ? null : action_r2.icon.iconName)("ngIfElse", _r4);
} }
function ExActionIconMenuComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ExActionIconMenuComponent_div_1_ng_container_1_Template, 4, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.actions);
} }
class ExActionIconMenuComponent {
    constructor(sectionLayoutViewModeObservable) {
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        /**
         * list of actions
         */
        this.actions = [];
        /**
         * disable all actions
         */
        this.disabled = false;
        /**
         * Emits the key of the action that was clicked
         */
        this.actionClicked = new EventEmitter();
    }
    onActionClicked(key) {
        this.actionClicked.emit(key);
    }
    static { this.ɵfac = function ExActionIconMenuComponent_Factory(t) { return new (t || ExActionIconMenuComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExActionIconMenuComponent, selectors: [["ex-action-icon-menu"]], inputs: { actions: "actions", disabled: "disabled" }, outputs: { actionClicked: "actionClicked" }, decls: 3, vars: 3, consts: [[1, "ex-action-icons-wrapper"], ["class", "ex-action-icons-icons-container", 4, "ngIf"], [1, "ex-action-icons-icons-container"], [4, "ngFor", "ngForOf"], ["class", "ex-action-icon", 3, "disabled", "ngClass", "click", 4, "ngIf", "ngIfElse"], ["label", ""], [1, "ex-action-icon", 3, "disabled", "ngClass", "click"], [3, "displayDot"], [3, "iconName", "ariaLabel", "tooltip", "size", "color", "ngClass"], ["type", "action", 1, "ex-action-icon-button", 3, "disabled", "loading", "ariaLabel", "tooltip", "click"]], template: function ExActionIconMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExActionIconMenuComponent_div_1_Template, 2, 1, "div", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 1, ctx.sectionLayoutViewModeObservable));
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExSvgIconComponent, ExButtonComponent, ExDotWrapperComponent, i1$5.AsyncPipe, i1$2.TranslatePipe], styles: [".ex-action-icons-wrapper[_ngcontent-%COMP%]{height:100%}.ex-action-icons-wrapper[_ngcontent-%COMP%]   .ex-action-icons-icons-container[_ngcontent-%COMP%]{height:100%;display:flex;justify-content:center;align-items:center}.ex-action-icons-wrapper[_ngcontent-%COMP%]   .ex-action-icon[_ngcontent-%COMP%]{margin:0 3px;padding:5px;background:transparent;border:0;border-radius:50%;display:flex}.ex-action-icons-wrapper[_ngcontent-%COMP%]   .ex-action-icon[_ngcontent-%COMP%]:hover{background-color:#a8a8a8}.ex-action-icons-wrapper[_ngcontent-%COMP%]   .ex-action-icon[_ngcontent-%COMP%]   ex-svg-icon[_ngcontent-%COMP%]{display:inline-block}.ex-action-icons-wrapper[_ngcontent-%COMP%]   .ex-action-icon-button[_ngcontent-%COMP%]     .ex-button-wrapper.ex-button-action{background:transparent}.action-button-bg[_ngcontent-%COMP%]{box-sizing:content-box;border-radius:50%;display:flex;justify-content:center;align-items:center}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExActionIconMenuComponent, [{
        type: Component,
        args: [{ selector: 'ex-action-icon-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-action-icons-wrapper\">\n  <div *ngIf=\"!(sectionLayoutViewModeObservable | async)\" class=\"ex-action-icons-icons-container\">\n    <ng-container *ngFor=\"let action of actions\">\n      <button *ngIf=\"action.icon?.iconName; else label\" class=\"ex-action-icon\" [disabled]=\"disabled || action.disabled\"\n        [ngClass]=\"{ 'ex-action-icon-disabled': action.disabled}\" (click)=\"onActionClicked(action.value)\" [attr.aria-label]=\"action.label | translate\">\n        <ex-dot-wrapper [displayDot]=\"action.indicator\">\n          <ex-svg-icon [iconName]=\"action.icon?.iconName\" [ariaLabel]=\"action.label\" [tooltip]=\"action.label\"\n            [size]=\"'medium'\" [color]=\"action.icon.iconColor\"\n            [ngClass]=\"'ex-action-icon-name-' + action.icon?.iconName\">\n          </ex-svg-icon>\n        </ex-dot-wrapper>\n      </button>\n      <ng-template #label>\n        <ex-button class=\"ex-action-icon-button\" type=\"action\" [disabled]=\"disabled || action.disabled\"\n          [loading]=\"action.loading\" [ariaLabel]=\"action.label\" [tooltip]=\"action.label\"\n          (click)=\"onActionClicked(action.value)\">\n          {{ action.label | translate}}\n        </ex-button>\n      </ng-template>\n    </ng-container>\n  </div>\n</div>", styles: [".ex-action-icons-wrapper{height:100%}.ex-action-icons-wrapper .ex-action-icons-icons-container{height:100%;display:flex;justify-content:center;align-items:center}.ex-action-icons-wrapper .ex-action-icon{margin:0 3px;padding:5px;background:transparent;border:0;border-radius:50%;display:flex}.ex-action-icons-wrapper .ex-action-icon:hover{background-color:#a8a8a8}.ex-action-icons-wrapper .ex-action-icon ex-svg-icon{display:inline-block}.ex-action-icons-wrapper .ex-action-icon-button ::ng-deep .ex-button-wrapper.ex-button-action{background:transparent}.action-button-bg{box-sizing:content-box;border-radius:50%;display:flex;justify-content:center;align-items:center}\n"] }]
    }], function () { return [{ type: i1$3.Observable, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }]; }, { actions: [{
            type: Input
        }], disabled: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }] }); })();

const _c0$1n = ["input"];
const _c1$R = ["textarea"];
function ExEditableTextComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵlistener("exFocusChange", function ExEditableTextComponent_ng_container_3_Template_div_exFocusChange_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.isActionFocused = $event); });
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(4, 0, ["slot", "[before-actions-slot]"]);
    i0.ɵɵelementStart(5, "ex-action-icon-menu", 7);
    i0.ɵɵlistener("actionClicked", function ExEditableTextComponent_ng_container_3_Template_ex_action_icon_menu_actionClicked_5_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onActionClicked($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exFocus", ctx_r0.isActionFocused);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("actions", !ctx_r0.readOnly ? ctx_r0.actions : ctx_r0.readOnlyActions)("disabled", ctx_r0.disabled);
} }
const _c2$B = function (a0) { return { "sel-input-empty": a0 }; };
const _c3$s = function (a0) { return { "text-align": a0 }; };
function ExEditableTextComponent_ng_template_4_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 13, 14);
    i0.ɵɵlistener("exFocusChange", function ExEditableTextComponent_ng_template_4_input_1_Template_input_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.onExFocusChange($event)); })("ngModelChange", function ExEditableTextComponent_ng_template_4_input_1_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.text = $event); })("input", function ExEditableTextComponent_ng_template_4_input_1_Template_input_input_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onInputEventDebounced($event)); })("change", function ExEditableTextComponent_ng_template_4_input_1_Template_input_change_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onInputChange($event)); })("keyup.enter", function ExEditableTextComponent_ng_template_4_input_1_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.isInputFocused = false); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r8.inputId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$B, !ctx_r8.text))("exFocus", ctx_r8.isInputFocused || ctx_r8.isFieldFocused)("ngModel", ctx_r8.text)("disabled", ctx_r8.disabled)("placeholder", i0.ɵɵpipeBind1(2, 8, ctx_r8.placeholder))("ngStyle", i0.ɵɵpureFunction1(12, _c3$s, ctx_r8.textAlign));
    i0.ɵɵattribute("maxlength", ctx_r8.textAreaMaxLength);
} }
const _c4$n = function (a0) { return { "ex-editable-text-text-area-with-counter": a0 }; };
function ExEditableTextComponent_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function ExEditableTextComponent_ng_template_4_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onTextAreaWrapperClicked()); });
    i0.ɵɵelementStart(1, "textarea", 16, 17);
    i0.ɵɵlistener("exFocusChange", function ExEditableTextComponent_ng_template_4_div_2_Template_textarea_exFocusChange_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.onExFocusChange($event)); })("ngModelChange", function ExEditableTextComponent_ng_template_4_div_2_Template_textarea_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.text = $event); })("input", function ExEditableTextComponent_ng_template_4_div_2_Template_textarea_input_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.onInputEventDebounced($event)); })("change", function ExEditableTextComponent_ng_template_4_div_2_Template_textarea_change_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onInputChange($event)); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4, "        ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", ctx_r9.inputId);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4$n, ctx_r9.isTextArea && ctx_r9.textAreaMaxLength > 0 && !ctx_r9.disabled))("minRows", 1)("exFocus", ctx_r9.isInputFocused || ctx_r9.isFieldFocused)("ngModel", ctx_r9.text)("disabled", ctx_r9.disabled)("placeholder", i0.ɵɵpipeBind1(3, 9, ctx_r9.placeholder))("ngStyle", i0.ɵɵpureFunction1(13, _c3$s, ctx_r9.textAlign));
    i0.ɵɵattribute("maxlength", ctx_r9.textAreaMaxLength);
} }
function ExEditableTextComponent_ng_template_4_div_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function ExEditableTextComponent_ng_template_4_div_3_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r28.onEditButtonClicked($event)); });
    i0.ɵɵelement(1, "ex-svg-icon", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("exFocus", ctx_r26.isButtonFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "edit")("color", "#2a5db0")("size", "medium");
} }
function ExEditableTextComponent_ng_template_4_div_3_ex_close_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 23);
    i0.ɵɵlistener("exFocusChange", function ExEditableTextComponent_ng_template_4_div_3_ex_close_2_Template_ex_close_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.isButtonFocused = $event); })("closeClicked", function ExEditableTextComponent_ng_template_4_div_3_ex_close_2_Template_ex_close_closeClicked_0_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.onClearButtonClicked($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("size", "small")("exFocus", ctx_r27.isButtonFocused)("tooltip", "ng.general.clear");
} }
const _c5$j = function (a0) { return { "ex-editable-text-button-aligned-center": a0 }; };
const _c6$h = function () { return { "visibility": "visible" }; };
const _c7$e = function () { return {}; };
function ExEditableTextComponent_ng_template_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, ExEditableTextComponent_ng_template_4_div_3_button_1_Template, 2, 4, "button", 19);
    i0.ɵɵtemplate(2, ExEditableTextComponent_ng_template_4_div_3_ex_close_2_Template, 1, 3, "ex-close", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5$j, ctx_r10.textAlign === "center"))("ngStyle", (ctx_r10.isInputFocused || ctx_r10.isButtonFocused) && ctx_r10.text && !ctx_r10.isTextArea ? i0.ɵɵpureFunction0(6, _c6$h) : i0.ɵɵpureFunction0(7, _c7$e));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showEditIcon && !ctx_r10.showClearButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showClearButton);
} }
function ExEditableTextComponent_ng_template_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", (ctx_r11.text == null ? null : ctx_r11.text.length) ? ctx_r11.text.length : 0, "/", ctx_r11.textAreaMaxLength, " ");
} }
function ExEditableTextComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, ExEditableTextComponent_ng_template_4_input_1_Template, 3, 14, "input", 9);
    i0.ɵɵtemplate(2, ExEditableTextComponent_ng_template_4_div_2_Template, 5, 15, "div", 10);
    i0.ɵɵtemplate(3, ExEditableTextComponent_ng_template_4_div_3_Template, 3, 8, "div", 11);
    i0.ɵɵtemplate(4, ExEditableTextComponent_ng_template_4_span_4_Template, 2, 2, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isTextArea);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isTextArea);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.disabled && !(ctx_r2.textAlign === "center" && (ctx_r2.isInputFocused || ctx_r2.isButtonFocused)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isTextArea && ctx_r2.textAreaMaxLength > 0 && !ctx_r2.disabled && ctx_r2.isInputFocused);
} }
function ExEditableTextComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "ex-display-text", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r4.text != null ? ctx_r4.text : "")("placeholder", ctx_r4.readOnlyPlaceholder)("type", "text")("textAlign", "inherit")("multipleLines", ctx_r4.isTextArea);
} }
const _c8$c = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { "ex-editable-text-disabled": a0, "ex-editable-text-readonly": a1, "ex-editable-text-focused": a2, "ex-editable-text-invalid": a3, "ex-editable-text-has-warnings": a4, "ex-editable-text-no-border": a5, "ex-editable-text-is-text-area": a6, "ex-editable-text-max-width": a7 }; };
const _c9$9 = ["*"];
class ExEditableTextComponent extends ExControlValueAccessor {
    /**
     * The text displayed in the input/text area
     */
    set text(text) {
        this._text = isNil(text) ? '' : String(text);
    }
    get text() {
        return this._text;
    }
    constructor(cdRef, elementRef, renderer, sectionLayoutViewModeObservable) {
        super(sectionLayoutViewModeObservable, cdRef);
        this.cdRef = cdRef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._text = '';
        /**
         * indicates if to display regular input element or textarea element
         */
        this.isTextArea = false;
        /**
         * the actions associated with this input displayed as icons beside the input
         */
        this.actions = [];
        /**
         * the maximal length of string the uset can write into the text-area. any characters beyond won't be written/saved.
         */
        this.textAreaMaxLength = null;
        /**
         * Whether the component width will take up all available space
         */
        this.isMaxWidth = false;
        /**
         * A placeholder to show when the input is empty
         */
        this.placeholder = 'ng.general.enter_text_here';
        /**
         * align text to 'start' or 'center'; default is 'start'.
         */
        this.textAlign = 'start';
        /**
         * indicates if the input/textarea is auto focus when page component loaded, defualt false
         */
        this.autoFocus = false;
        this.readOnlyPlaceholder = '-';
        /**
         * indicates if the input/textarea have border
         */
        this.hasBorder = true;
        /**
         * if you want the pen icon on the top right corner
         */
        this.showEditIcon = true;
        /**
         * indicating font size of the input element
         */
        this.fontSize = 'regular';
        /**
         * indicates if to display a tooltip or not
         */
        this.hasTooltip = true;
        /**
         * Add id to input element
         */
        this.inputId = "";
        this.selectAll = false;
        /**
         * DEPRECATED - use textChange event instead.
         * this event fires whenever the text in editable text component changes
         */
        this.editableTextChanged = new EventEmitter();
        /**
         * event emitted whenever the text in editable text component changes
         * can be used in two-way binding with the 'text' input
         */
        this.textChange = new EventEmitter();
        /**
         * this event fires whenever the text in editable text component is saved
         */
        this.editableTextSaved = new EventEmitter();
        /**
         * event emitted when an action icon is clicked with the value of the action
         */
        this.actionClicked = new EventEmitter();
        this.isInputFocused = false;
        this.isButtonFocused = false;
        this.isActionFocused = false;
        this.readOnlyActions = [];
        this.onInputEventDebounced = debounce(this.onInputEvent, 150);
    }
    ngOnInit() {
        this.isInputFocused = this.autoFocus ? true : false;
    }
    ngAfterViewInit() {
        if (this.selectAll) {
            const options = {
                root: null,
                threshold: 0 // Fire when any part of the element is visible
            };
            const observer = new IntersectionObserver(entries => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        observer.disconnect();
                        this._selectAll();
                    }
                }
            }, options);
            observer.observe(this.elementRef?.nativeElement);
        }
    }
    _selectAll() {
        const element = this.inputElement ?? this.textAreaElement;
        this.renderer.setProperty(element.nativeElement, 'selectionStart', 0);
        this.renderer.setProperty(element.nativeElement, 'selectionEnd', element.nativeElement.value.length);
        element.nativeElement.select();
    }
    ngOnChanges(change) {
        if (change.hasOwnProperty('actions')) {
            this.readOnlyActions = (change.actions.currentValue ?? []).filter(action => {
                return action.enabledWhenReadOnly == true;
            });
        }
    }
    onTextAreaWrapperClicked() {
        this.isInputFocused = true;
    }
    onInputChange(event) {
        this.editableTextSaved.emit(this.text);
    }
    onInputEvent(event) {
        this.editableTextChanged.emit(this.text);
        this.textChange.emit(this.text);
    }
    onEditButtonClicked(event) {
        this.isButtonFocused = false;
        this.isInputFocused = true;
    }
    get showClearButton() {
        return !this.isTextArea && (this.isInputFocused || this.isButtonFocused);
    }
    onClearButtonClicked(event) {
        this.text = "";
        this.onInputEvent(undefined);
        this.onInputChange(undefined);
        this.isButtonFocused = false;
        this.isInputFocused = true;
    }
    writeValue(text) {
        this.text = text;
        this.cdRef.markForCheck();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdRef.markForCheck();
    }
    onActionClicked(key) {
        this.actionClicked.emit(key);
    }
    focus(selectall = false) {
        this.isInputFocused = true;
        selectall && this._selectAll();
        this.cdRef.markForCheck();
    }
    onExFocusChange(focused) {
        this.isInputFocused = focused;
        this.isFieldFocused = focused;
    }
    static { this.ɵfac = function ExEditableTextComponent_Factory(t) { return new (t || ExEditableTextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExEditableTextComponent, selectors: [["ex-editable-text"]], viewQuery: function ExEditableTextComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1n, 5);
            i0.ɵɵviewQuery(_c1$R, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textAreaElement = _t.first);
        } }, hostBindings: function ExEditableTextComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("editableTextChanged", function ExEditableTextComponent_editableTextChanged_HostBindingHandler($event) { return ctx.controlOnChange($event); })("focusout", function ExEditableTextComponent_focusout_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { text: "text", isTextArea: "isTextArea", actions: "actions", textAreaMaxLength: "textAreaMaxLength", isMaxWidth: "isMaxWidth", placeholder: "placeholder", textAlign: "textAlign", autoFocus: "autoFocus", readOnlyPlaceholder: "readOnlyPlaceholder", hasBorder: "hasBorder", showEditIcon: "showEditIcon", fontSize: "fontSize", hasTooltip: "hasTooltip", toolTipPrefix: "toolTipPrefix", inputId: "inputId", selectAll: "selectAll" }, outputs: { editableTextChanged: "editableTextChanged", textChange: "textChange", editableTextSaved: "editableTextSaved", actionClicked: "actionClicked" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExEditableTextComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c9$9, decls: 8, vars: 17, consts: [[1, "ex-editable-text-wrapper", 3, "ngClass", "exTooltip"], [3, "ngTemplateOutlet"], [4, "ngIf"], ["inputDisplay", ""], ["readOnlyDisplay", ""], [1, "ex-editable-text-actions-wrapper", 3, "exFocus", "exFocusChange"], [1, "ex-editable-text-actions-divider"], [1, "ex-editable-text-actions", 3, "actions", "disabled", "actionClicked"], [1, "ex-editable-text-editable-input-container"], ["class", "ex-editable-text-input sel-input", "exFormAriaAttributes", "", "autoSizeInput", "", 3, "id", "ngClass", "exFocus", "ngModel", "disabled", "placeholder", "ngStyle", "exFocusChange", "ngModelChange", "input", "change", "keyup.enter", 4, "ngIf"], ["class", "ex-editable-text-text-area-wrapper", 3, "click", 4, "ngIf"], ["class", "ex-editable-text-button-container", 3, "ngClass", "ngStyle", 4, "ngIf"], ["class", "ex-editable-text-character-counter", 4, "ngIf"], ["exFormAriaAttributes", "", "autoSizeInput", "", 1, "ex-editable-text-input", "sel-input", 3, "id", "ngClass", "exFocus", "ngModel", "disabled", "placeholder", "ngStyle", "exFocusChange", "ngModelChange", "input", "change", "keyup.enter"], ["input", ""], [1, "ex-editable-text-text-area-wrapper", 3, "click"], ["exFormAriaAttributes", "", "autosize", "", 1, "ex-editable-text-text-area", "sel-textarea", 3, "id", "ngClass", "minRows", "exFocus", "ngModel", "disabled", "placeholder", "ngStyle", "exFocusChange", "ngModelChange", "input", "change"], ["textarea", ""], [1, "ex-editable-text-button-container", 3, "ngClass", "ngStyle"], ["class", "ex-editable-text-button ex-editable-text-button-edit", 3, "exFocus", "click", 4, "ngIf"], ["class", "ex-editable-text-clear-button", 3, "size", "exFocus", "tooltip", "exFocusChange", "closeClicked", 4, "ngIf"], [1, "ex-editable-text-button", "ex-editable-text-button-edit", 3, "exFocus", "click"], [1, "ex-editable-text-icon", "ex-editable-text-icon-edit", 3, "iconName", "color", "size"], [1, "ex-editable-text-clear-button", 3, "size", "exFocus", "tooltip", "exFocusChange", "closeClicked"], [1, "ex-editable-text-character-counter"], [1, "ex-editable-text-readonly-display"], [3, "value", "placeholder", "type", "textAlign", "multipleLines"]], template: function ExEditableTextComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵelementContainer(2, 1);
            i0.ɵɵtemplate(3, ExEditableTextComponent_ng_container_3_Template, 6, 3, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExEditableTextComponent_ng_template_4_Template, 5, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(6, ExEditableTextComponent_ng_template_6_Template, 2, 5, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(5);
            const _r3 = i0.ɵɵreference(7);
            i0.ɵɵclassMap("ex-editable-text-font-size-" + ctx.fontSize);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(8, _c8$c, ctx.disabled, ctx.isReadOnly, ctx.isInputFocused || ctx.isButtonFocused || ctx.isActionFocused, !ctx.valid, ctx.hasWarnings, !ctx.hasBorder, ctx.isTextArea, ctx.isMaxWidth))("exTooltip", !ctx.isTextArea && ctx.hasTooltip && ctx.text ? (ctx.toolTipPrefix ? i0.ɵɵpipeBind1(1, 6, ctx.toolTipPrefix) + ": " : "") + ctx.text : null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", !ctx.isReadOnly ? _r1 : _r3);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.disabled && (!ctx.readOnly ? ctx.actions && ctx.actions.length > 0 : ctx.readOnlyActions && ctx.readOnlyActions.length > 0));
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExTooltipDirective, ExFocusDirective, ExFormAriaAttributesDirective, ExSvgIconComponent, ExDisplayTextComponent, ExActionIconMenuComponent, i9.AutoSizeInputDirective, i10$1.AutosizeDirective, ExCloseComponent, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{max-width:100%}.ex-editable-text-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:1;flex-grow:5;border-radius:2px;padding-inline-start:5px;padding-inline-end:5px;justify-content:stretch;min-height:32px;transition:border .5s;position:relative;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-editable-text-wrapper[_ngcontent-%COMP%]:not(.ex-editable-text-disabled, .ex-editable-text-readonly)[_ngcontent-%COMP%]:not(:focus-within):hover:not(.ex-editable-text-no-border){background-color:#e5e5e5}.ex-editable-text-wrapper[_ngcontent-%COMP%]:not(.ex-editable-text-disabled, .ex-editable-text-readonly)[_ngcontent-%COMP%]:not(:focus-within):hover   .ex-editable-text-button-container[_ngcontent-%COMP%]{visibility:visible}.ex-editable-text-wrapper[_ngcontent-%COMP%]:not(.ex-editable-text-disabled, .ex-editable-text-readonly)[_ngcontent-%COMP%]:focus-within:not(.ex-editable-text-no-border){box-shadow:0 0 0 2px #0e7bbafa}.ex-editable-text-wrapper[_ngcontent-%COMP%]:not(.ex-editable-text-disabled, .ex-editable-text-readonly)[_ngcontent-%COMP%]:focus-within   .ex-editable-text-button-container.ex-editable-text-button-aligned-center[_ngcontent-%COMP%]{background-image:linear-gradient(to right,transparent 0%,rgba(255,255,255,.5) 25%,rgb(255,255,255) 50%,rgb(255,255,255) 100%)}.ex-editable-text-wrapper.ex-editable-text-invalid[_ngcontent-%COMP%], .ex-editable-text-wrapper.ex-editable-text-has-warnings[_ngcontent-%COMP%]{box-shadow:0 0 5px 2px #c62726,0 0 0 2px #c62726!important;transform:scale(1);animation:pulse 2s ease-in}.ex-editable-text-wrapper.ex-editable-text-disabled[_ngcontent-%COMP%]   .ex-editable-text-input[_ngcontent-%COMP%], .ex-editable-text-wrapper.ex-editable-text-disabled[_ngcontent-%COMP%]   .ex-editable-text-text-area[_ngcontent-%COMP%]{opacity:.5}.ex-editable-text-wrapper.ex-editable-text-readonly[_ngcontent-%COMP%]{flex-wrap:nowrap;padding-inline-start:0px}.ex-editable-text-wrapper[_ngcontent-%COMP%]   .ex-editable-text-editable-input-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:stretch;position:relative;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-editable-text-wrapper.ex-editable-text-is-text-area[_ngcontent-%COMP%]   .ex-editable-text-editable-input-container[_ngcontent-%COMP%]{align-items:flex-start}.ex-editable-text-wrapper.ex-editable-text-max-width[_ngcontent-%COMP%]{width:100%}.ex-editable-text-wrapper.ex-editable-text-max-width[_ngcontent-%COMP%]   .ex-editable-text-editable-input-container[_ngcontent-%COMP%]{width:100%;justify-content:center}.ex-editable-text-input[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:0;border-radius:3px;outline:none;background-color:transparent;padding:0 5px;min-width:100px;direction:inherit;unicode-bidi:plaintext}.ex-editable-text-text-area-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;padding:5.5px 5px 5px;cursor:text}.ex-editable-text-text-area-wrapper[_ngcontent-%COMP%]   .ex-editable-text-text-area[_ngcontent-%COMP%]{resize:none;border:0;border-radius:3px;width:100%;height:100%;white-space:normal;outline:none;background-color:transparent;box-sizing:content-box;white-space:pre-wrap;direction:inherit;unicode-bidi:plaintext}.ex-editable-text-text-area-wrapper[_ngcontent-%COMP%]   .ex-editable-text-text-area-with-counter[_ngcontent-%COMP%]{margin-bottom:10px}.ex-editable-text-button-container[_ngcontent-%COMP%]{margin-inline-start:5px;margin-inline-end:3px;display:flex;visibility:hidden}.ex-editable-text-button-container[_ngcontent-%COMP%]   .ex-editable-text-button[_ngcontent-%COMP%]{background:transparent;border:0;border-radius:3px;outline:none;display:flex;justify-content:flex-end;align-items:center;min-width:16px;color:#2a5db0;width:100%}.ex-editable-text-button-container[_ngcontent-%COMP%]   .ex-editable-text-button[_ngcontent-%COMP%]:focus   .ex-editable-text-icon-close[_ngcontent-%COMP%]{outline:1px solid #222}.ex-editable-text-button-container.ex-editable-text-button-aligned-center[_ngcontent-%COMP%]{position:absolute;inset-inline-end:0;top:0;min-height:32px;padding-inline-end:5px;background-image:linear-gradient(to right,transparent 0%,rgba(229,229,229,.5) 25%,rgb(229,229,229) 50%,rgb(229,229,229) 100%);justify-content:flex-end}.ex-editable-text-actions-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.ex-editable-text-actions-wrapper[_ngcontent-%COMP%]   .ex-editable-text-actions-divider[_ngcontent-%COMP%]{border-left:1px solid #999;height:60%;margin-inline-start:5px}.ex-editable-text-readonly-display[_ngcontent-%COMP%]{overflow:hidden;width:100%}.ex-editable-text-clear-button[_ngcontent-%COMP%]{display:flex;margin-inline-end:-10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditableTextComponent, [{
        type: Component,
        args: [{ selector: 'ex-editable-text', host: {
                    '(editableTextChanged)': 'controlOnChange($event)',
                    '(focusout)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExEditableTextComponent), template: "<div class=\"ex-editable-text-wrapper\" [ngClass]=\"{\n    'ex-editable-text-disabled': disabled,\n    'ex-editable-text-readonly': isReadOnly,\n    'ex-editable-text-focused': isInputFocused || isButtonFocused || isActionFocused,\n    'ex-editable-text-invalid': !valid,\n    'ex-editable-text-has-warnings': hasWarnings,\n    'ex-editable-text-no-border': !hasBorder,\n    'ex-editable-text-is-text-area': isTextArea,\n    'ex-editable-text-max-width': isMaxWidth\n    }\" [class]=\"'ex-editable-text-font-size-' + fontSize\"\n    [exTooltip]=\"(!isTextArea && hasTooltip && text) ? (toolTipPrefix ? (toolTipPrefix | translate) + ': ' : '') + text : null\">\n\n    <ng-container [ngTemplateOutlet]=\"!isReadOnly ? inputDisplay : readOnlyDisplay\"></ng-container>\n\n    <ng-container\n        *ngIf=\"!disabled && (!readOnly ? actions && actions.length > 0 : readOnlyActions && readOnlyActions.length > 0)\">\n        <div class=\"ex-editable-text-actions-wrapper\" [(exFocus)]=\"isActionFocused\">\n            <div class=\"ex-editable-text-actions-divider\">&nbsp;</div>\n            <ng-content slot=\"[before-actions-slot]\"></ng-content>\n            <ex-action-icon-menu class=\"ex-editable-text-actions\" [actions]=\"!readOnly ? actions : readOnlyActions\"\n                [disabled]=\"disabled\" (actionClicked)=\"onActionClicked($event)\">\n            </ex-action-icon-menu>\n        </div>\n    </ng-container>\n\n</div>\n\n<ng-template #inputDisplay>\n    <div class=\"ex-editable-text-editable-input-container\">\n\n        <input #input *ngIf=\"!isTextArea\" id=\"{{inputId}}\" class=\"ex-editable-text-input sel-input\"\n            [ngClass]=\"{'sel-input-empty': !text}\" exFormAriaAttributes autoSizeInput\n               [exFocus]=\"isInputFocused || isFieldFocused\" (exFocusChange) = \"onExFocusChange($event)\" [(ngModel)]=\"text\" [disabled]=\"disabled\"\n            [placeholder]=\"placeholder | translate\" (input)=\"onInputEventDebounced($event)\"\n            (change)=\"onInputChange($event)\" (keyup.enter)=\"isInputFocused = false\"\n            [ngStyle]=\" {'text-align': textAlign}\" [attr.maxlength]=\"textAreaMaxLength\">\n        <div *ngIf=\"isTextArea\" class=\"ex-editable-text-text-area-wrapper\" (click)=\"onTextAreaWrapperClicked()\">\n            <textarea #textarea id=\"{{inputId}}\" class=\"ex-editable-text-text-area sel-textarea\" exFormAriaAttributes autosize\n                [ngClass]=\"{'ex-editable-text-text-area-with-counter': (isTextArea && textAreaMaxLength > 0 && !disabled)}\"\n                [minRows]=\"1\" [exFocus]=\"isInputFocused || isFieldFocused\" (exFocusChange) = \"onExFocusChange($event)\" [(ngModel)]=\"text\" [disabled]=\"disabled\"\n                [placeholder]=\"placeholder | translate\" (input)=\"onInputEventDebounced($event)\"\n                (change)=\"onInputChange($event)\" [ngStyle]=\" {'text-align': textAlign}\"\n                [attr.maxlength]=\"textAreaMaxLength\">\n        </textarea>\n        </div>\n\n        <!-- don't show clear button when aligned to center: !(textAlign === 'center' && (isInputFocused || isButtonFocused)) -->\n        <div *ngIf=\"!disabled && !(textAlign === 'center' && (isInputFocused || isButtonFocused))\"\n            class=\"ex-editable-text-button-container\"\n            [ngClass]=\"{ 'ex-editable-text-button-aligned-center': textAlign === 'center' }\"\n            [ngStyle]=\"((isInputFocused || isButtonFocused) && text && !isTextArea) ? {'visibility': 'visible'} : {}\">\n            <button *ngIf=\"showEditIcon && !showClearButton\"\n                class=\"ex-editable-text-button ex-editable-text-button-edit\"  [exFocus]=\"isButtonFocused\"\n                (click)=\"onEditButtonClicked($event)\">\n                <ex-svg-icon class=\"ex-editable-text-icon ex-editable-text-icon-edit\" [iconName]=\"'edit'\" [color]=\"'#2a5db0'\"\n                    [size]=\"'medium'\"></ex-svg-icon>\n            </button>\n\n           <ex-close *ngIf=\"showClearButton\" class=\"ex-editable-text-clear-button\" [size]=\"'small'\" [(exFocus)]=\"isButtonFocused\"\n                    (closeClicked)=\"onClearButtonClicked($event)\"\n                    [tooltip]=\"'ng.general.clear'\"></ex-close>\n        </div>\n\n        <span *ngIf=\"isTextArea && textAreaMaxLength > 0 && !disabled && isInputFocused\"\n            class=\"ex-editable-text-character-counter\">\n            {{ text?.length ? text.length : 0 }}/{{ textAreaMaxLength }}\n        </span>\n\n    </div>\n</ng-template>\n\n<ng-template #readOnlyDisplay>\n    <div class=\"ex-editable-text-readonly-display\">\n        <ex-display-text [value]=\"text != null ? text : ''\" [placeholder] = \"readOnlyPlaceholder\" [type]=\"'text'\" [textAlign]=\"'inherit'\"\n            [multipleLines]=\"isTextArea\">\n        </ex-display-text>\n    </div>\n</ng-template>\n", styles: [":host{max-width:100%}.ex-editable-text-wrapper{display:flex;flex-direction:row;flex:1;flex-grow:5;border-radius:2px;padding-inline-start:5px;padding-inline-end:5px;justify-content:stretch;min-height:32px;transition:border .5s;position:relative;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-editable-text-wrapper:not(.ex-editable-text-disabled,.ex-editable-text-readonly):not(:focus-within):hover:not(.ex-editable-text-no-border){background-color:#e5e5e5}.ex-editable-text-wrapper:not(.ex-editable-text-disabled,.ex-editable-text-readonly):not(:focus-within):hover .ex-editable-text-button-container{visibility:visible}.ex-editable-text-wrapper:not(.ex-editable-text-disabled,.ex-editable-text-readonly):focus-within:not(.ex-editable-text-no-border){box-shadow:0 0 0 2px #0e7bbafa}.ex-editable-text-wrapper:not(.ex-editable-text-disabled,.ex-editable-text-readonly):focus-within .ex-editable-text-button-container.ex-editable-text-button-aligned-center{background-image:linear-gradient(to right,transparent 0%,rgba(255,255,255,.5) 25%,rgb(255,255,255) 50%,rgb(255,255,255) 100%)}.ex-editable-text-wrapper.ex-editable-text-invalid,.ex-editable-text-wrapper.ex-editable-text-has-warnings{box-shadow:0 0 5px 2px #c62726,0 0 0 2px #c62726!important;transform:scale(1);animation:pulse 2s ease-in}.ex-editable-text-wrapper.ex-editable-text-disabled .ex-editable-text-input,.ex-editable-text-wrapper.ex-editable-text-disabled .ex-editable-text-text-area{opacity:.5}.ex-editable-text-wrapper.ex-editable-text-readonly{flex-wrap:nowrap;padding-inline-start:0px}.ex-editable-text-wrapper .ex-editable-text-editable-input-container{display:flex;flex-direction:row;justify-content:stretch;position:relative;width:-moz-fit-content;width:fit-content;max-width:100%}.ex-editable-text-wrapper.ex-editable-text-is-text-area .ex-editable-text-editable-input-container{align-items:flex-start}.ex-editable-text-wrapper.ex-editable-text-max-width{width:100%}.ex-editable-text-wrapper.ex-editable-text-max-width .ex-editable-text-editable-input-container{width:100%;justify-content:center}.ex-editable-text-input{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:0;border-radius:3px;outline:none;background-color:transparent;padding:0 5px;min-width:100px;direction:inherit;unicode-bidi:plaintext}.ex-editable-text-text-area-wrapper{width:100%;display:flex;padding:5.5px 5px 5px;cursor:text}.ex-editable-text-text-area-wrapper .ex-editable-text-text-area{resize:none;border:0;border-radius:3px;width:100%;height:100%;white-space:normal;outline:none;background-color:transparent;box-sizing:content-box;white-space:pre-wrap;direction:inherit;unicode-bidi:plaintext}.ex-editable-text-text-area-wrapper .ex-editable-text-text-area-with-counter{margin-bottom:10px}.ex-editable-text-button-container{margin-inline-start:5px;margin-inline-end:3px;display:flex;visibility:hidden}.ex-editable-text-button-container .ex-editable-text-button{background:transparent;border:0;border-radius:3px;outline:none;display:flex;justify-content:flex-end;align-items:center;min-width:16px;color:#2a5db0;width:100%}.ex-editable-text-button-container .ex-editable-text-button:focus .ex-editable-text-icon-close{outline:1px solid #222}.ex-editable-text-button-container.ex-editable-text-button-aligned-center{position:absolute;inset-inline-end:0;top:0;min-height:32px;padding-inline-end:5px;background-image:linear-gradient(to right,transparent 0%,rgba(229,229,229,.5) 25%,rgb(229,229,229) 50%,rgb(229,229,229) 100%);justify-content:flex-end}.ex-editable-text-actions-wrapper{display:flex;justify-content:center;align-items:center}.ex-editable-text-actions-wrapper .ex-editable-text-actions-divider{border-left:1px solid #999;height:60%;margin-inline-start:5px}.ex-editable-text-readonly-display{overflow:hidden;width:100%}.ex-editable-text-clear-button{display:flex;margin-inline-end:-10px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }]; }, { text: [{
            type: Input
        }], isTextArea: [{
            type: Input
        }], actions: [{
            type: Input
        }], textAreaMaxLength: [{
            type: Input
        }], isMaxWidth: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], textAlign: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], readOnlyPlaceholder: [{
            type: Input
        }], hasBorder: [{
            type: Input
        }], showEditIcon: [{
            type: Input
        }], fontSize: [{
            type: Input
        }], hasTooltip: [{
            type: Input
        }], toolTipPrefix: [{
            type: Input
        }], inputId: [{
            type: Input
        }], selectAll: [{
            type: Input
        }], editableTextChanged: [{
            type: Output
        }], textChange: [{
            type: Output
        }], editableTextSaved: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], inputElement: [{
            type: ViewChild,
            args: ['input']
        }], textAreaElement: [{
            type: ViewChild,
            args: ['textarea']
        }] }); })();

const _c0$1m = ["input"];
const _c1$Q = ["picker"];
const _c2$A = ["timePicker"];
const _c3$r = function (a0) { return { "ex-date-picker-read-only": a0 }; };
function ExDatePickerComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 9, 10);
    i0.ɵɵlistener("blur", function ExDatePickerComponent_input_1_Template_input_blur_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onBlur($event)); })("dateChange", function ExDatePickerComponent_input_1_Template_input_dateChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onDateChange($event.value)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("placeholder", "", i0.ɵɵpipeBind1(2, 5, ctx_r0.placeholder), " ");
    i0.ɵɵproperty("ngModel", !ctx_r0.hasApply ? ctx_r0._date : ctx_r0._tmpDate)("matDatepicker", ctx_r0.picker)("min", ctx_r0.minDate)("ngClass", i0.ɵɵpureFunction1(7, _c3$r, ctx_r0.isReadOnly));
} }
function ExDatePickerComponent_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 11, 10);
    i0.ɵɵlistener("blur", function ExDatePickerComponent_input_2_Template_input_blur_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onBlur($event)); })("dateChange", function ExDatePickerComponent_input_2_Template_input_dateChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onDateChange($event.value)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("placeholder", "", i0.ɵɵpipeBind1(2, 5, ctx_r1.placeholder), " ");
    i0.ɵɵproperty("ngModel", !ctx_r1.hasApply ? ctx_r1._date : ctx_r1._tmpDate)("ngxMatDatetimePicker", ctx_r1.timePicker)("min", ctx_r1.minDate)("ngClass", i0.ɵɵpureFunction1(7, _c3$r, ctx_r1.isReadOnly));
} }
function ExDatePickerComponent_ex_display_text_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-display-text", 12);
    i0.ɵɵlistener("click", function ExDatePickerComponent_ex_display_text_3_Template_ex_display_text_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onInputClick()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r2._formattedDate)("placeholder", i0.ɵɵpipeBind1(1, 3, ctx_r2.placeholder))("ngClass", i0.ɵɵpureFunction1(5, _c3$r, ctx_r2.isReadOnly));
} }
function ExDatePickerComponent_ex_editable_text_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-editable-text", 13);
    i0.ɵɵlistener("editableTextSaved", function ExDatePickerComponent_ex_editable_text_4_Template_ex_editable_text_editableTextSaved_0_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.textSaved($event)); })("focusout", function ExDatePickerComponent_ex_editable_text_4_Template_ex_editable_text_focusout_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onBlur()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("placeholder", "", i0.ɵɵpipeBind1(1, 7, ctx_r3.dateFormat), " ");
    i0.ɵɵproperty("text", ctx_r3._formattedDate)("hasBorder", false)("ariaDescription", ctx_r3.ariaDescription)("ariaLabel", ctx_r3.ariaLabel)("ariaRequired", ctx_r3.ariaRequired)("ariaErrorLabel", ctx_r3.ariaErrorLabel);
} }
const _c4$m = function (a0) { return { "visibility": a0 }; };
function ExDatePickerComponent_mat_datepicker_toggle_6_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-datepicker-toggle", 14);
    i0.ɵɵlistener("exFocusChange", function ExDatePickerComponent_mat_datepicker_toggle_6_Template_mat_datepicker_toggle_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.isFieldFocused = $event); });
    i0.ɵɵelement(1, "ex-icon", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exFocus", ctx_r4.isFieldFocused)("for", ctx_r4.picker)("disabled", ctx_r4.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isActionButton", !ctx_r4.isReadOnly)("ngStyle", i0.ɵɵpureFunction1(5, _c4$m, ctx_r4.isReadOnly ? "hidden" : "visible"));
} }
function ExDatePickerComponent_mat_datepicker_toggle_7_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-datepicker-toggle", 14);
    i0.ɵɵlistener("exFocusChange", function ExDatePickerComponent_mat_datepicker_toggle_7_Template_mat_datepicker_toggle_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.isFieldFocused = $event); });
    i0.ɵɵelement(1, "ex-icon", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exFocus", ctx_r5.isFieldFocused)("for", ctx_r5.timePicker)("disabled", ctx_r5.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isActionButton", !ctx_r5.isReadOnly)("ngStyle", i0.ɵɵpureFunction1(5, _c4$m, ctx_r5.isReadOnly ? "hidden" : "visible"));
} }
function ExDatePickerComponent_mat_datepicker_8_mat_datepicker_actions_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-datepicker-actions")(1, "ex-button", 19);
    i0.ɵɵlistener("click", function ExDatePickerComponent_mat_datepicker_8_mat_datepicker_actions_2_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r28); i0.ɵɵnextContext(); const _r25 = i0.ɵɵreference(1); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onApplyClicked(_r25)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "ng.general.apply"));
} }
function ExDatePickerComponent_mat_datepicker_8_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-datepicker", 16, 17);
    i0.ɵɵlistener("closed", function ExDatePickerComponent_mat_datepicker_8_Template_mat_datepicker_closed_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onClosed($event)); })("yearSelected", function ExDatePickerComponent_mat_datepicker_8_Template_mat_datepicker_yearSelected_0_listener($event) { i0.ɵɵrestoreView(_r30); const _r25 = i0.ɵɵreference(1); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.onYearSelected($event, _r25)); })("monthSelected", function ExDatePickerComponent_mat_datepicker_8_Template_mat_datepicker_monthSelected_0_listener($event) { i0.ɵɵrestoreView(_r30); const _r25 = i0.ɵɵreference(1); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.onMonthSelected($event, _r25)); });
    i0.ɵɵtemplate(2, ExDatePickerComponent_mat_datepicker_8_mat_datepicker_actions_2_Template, 4, 3, "mat-datepicker-actions", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("startAt", ctx_r6._date)("startView", ctx_r6.startView);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.hasApply);
} }
function ExDatePickerComponent_ngx_mat_datetime_picker_9_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-mat-datetime-picker", 20, 21);
    i0.ɵɵlistener("closed", function ExDatePickerComponent_ngx_mat_datetime_picker_9_Template_ngx_mat_datetime_picker_closed_0_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.onClosed($event)); });
    i0.ɵɵelementStart(2, "ngx-mat-datepicker-actions")(3, "ex-button", 22)(4, "mat-icon", 23);
    i0.ɵɵtext(5, "done");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showSeconds", ctx_r7.showSeconds)("hideTime", !ctx_r7.withTime)("startAt", ctx_r7._date)("startView", ctx_r7.startView);
} }
const _c5$i = function (a0, a1, a2) { return { "ex-date-picker-hover": a0, "ex-date-picker-invalid": a1, "ex-date-picker-readonly": a2 }; };
const _c6$g = function (a0) { return { "ex-date-picker-clear-hidden": a0 }; };
const _c7$d = function (a0) { return { "cursor": a0 }; };
momentJDate(moment);
const _moment = moment;
class ExDatePickerComponent extends ExControlValueAccessor {
    /**
     * Date value
     */
    set date(_date) {
        this._date = _date === null ? undefined : _date;
        if (this._date && this.dateFormat) {
            this._formattedDate = _moment(_date).formatWithJDF(this.dateFormat);
        }
    }
    get date() {
        return this._date;
    }
    constructor(sectionLayoutViewModeObservable, cdr, dateAdapter, ngxMatDateAdapter, lang) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.dateAdapter = dateAdapter;
        this.ngxMatDateAdapter = ngxMatDateAdapter;
        this.lang = lang;
        /**
         * The mode of the date input; whether the date input represents year only, year and month, or year and month and day
         */
        this.dateMode = 'day';
        /**
         * Set this to true to disable partial date select.
         * Should be used when all parts (year, month, day) are needed
         */
        this.fullDate = false;
        /**
         * the system date format
         */
        this.dateFormat = "dd/MM/yyyy";
        /**
         * add border on the element
         */
        this.border = false;
        this.startView = 'month';
        this.pickerMode = 'day';
        this.placeholder = 'ng.general.choose_date';
        /**
         * disable all dates before today
         */
        this.disablePast = false;
        /**
         * if to display apply button
         */
        this.hasApply = false;
        /**
         * if to display option to enter text
         */
        this.showInput = true;
        this.withTime = false;
        this.dateChange = new EventEmitter();
        this.dateSelected = new EventEmitter();
        this.isHovered = false;
        this.selectionMade = false;
        this.minDate = null;
        this._date = undefined;
        this._mode = "day";
        this._dateFormat = "dd/MM/yyyy";
        this._formattedDate = "";
        this._isInitialDate = false;
        this.pickerLocale = "";
        this.YEAR = "year";
        this.MONTH = "month";
        this.DAY = "day";
    }
    ngOnInit() {
        this.configDatePickerLocale();
        if (this.disablePast) {
            this.minDate = new Date();
        }
    }
    configDatePickerLocale() {
        this.pickerLocale = this.lang;
        this.dateAdapter.setLocale(this.lang);
        this.ngxMatDateAdapter.setLocale(this.lang);
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                if (propName === "dateMode") {
                    this._isInitialDate = true;
                    if (!changes["dateMode"].currentValue) {
                        this._mode = this.DAY;
                    }
                    else {
                        this._mode = changes["dateMode"].currentValue;
                    }
                    this.setDateFormat();
                    this._isInitialDate = false;
                }
                else if (propName === "dateFormat") {
                    this.setDateFormat();
                }
            }
        }
    }
    cleanDate() {
        if (!this.isReadOnly) {
            this._date = undefined;
            this._formattedDate = "";
            this.dateChange.emit(undefined);
            this.dateSelected.emit({ date: undefined, mode: this._mode, dateFormat: this._dateFormat });
        }
    }
    writeValue(value) {
        this._date = value;
        if (this._date && this.dateFormat) {
            this._formattedDate = _moment(this._date).formatWithJDF(this.dateFormat);
        }
        else {
            this._formattedDate = "";
        }
        this.cdr.markForCheck();
    }
    setDisabledState(disabled) {
        this.readOnly = disabled;
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    validate(control) {
        if (control.value == undefined) {
            return null;
        }
        const date = new Date(control.value);
        return control.value && this.isValidDate(date) ? null : { pattern: true };
    }
    isValidDate(d) {
        return (d instanceof Date && !isNaN(d)) || d == undefined;
    }
    onYearSelected(date, datepicker) {
        if (this.fullDate) {
            return;
        }
        this.setDate(date);
        this._mode = this.YEAR;
        this.setDateFormat();
        if (this.pickerMode === this.YEAR) {
            if (!this.hasApply) {
                datepicker.close();
            }
        }
    }
    onMonthSelected(date, datepicker) {
        if (this.fullDate) {
            return;
        }
        this.setDate(date);
        this._mode = this.MONTH;
        this.setDateFormat();
        if (this.pickerMode === this.MONTH) {
            if (!this.hasApply) {
                datepicker.close();
            }
        }
    }
    textSaved(date) {
        if (date == "") {
            this.cleanDate();
        }
        else {
            this.onDateChange(moment(date, _moment().toMomentFormatString(this.dateFormat)).toDate());
        }
    }
    onDateChange(date) {
        if (this.hasApply && ((this._date === undefined || date === null) || (date instanceof Date && this._date instanceof Date && date.getTime() === this._date.getTime()))) {
            return;
        }
        this.setDate(date);
        this._mode = this.DAY;
        this.setDateFormat();
        this.dateChange.emit(this._date);
    }
    setDate(date) {
        if (moment.isMoment(date)) {
            date = date.toDate();
        }
        if (this.hasApply) {
            this._tmpDate = date;
        }
        else {
            this._date = date;
            if (this._date) {
                this._formattedDate = _moment(this._date).formatWithJDF(this.dateFormat);
            }
            else {
                this._formattedDate = "";
            }
        }
        this.selectionMade = true;
    }
    /**
     * assumes date fomrat includes only characters of 'd', 'D', 'm', 'M', 'y', 'Y', and seperators
     */
    setDateFormat() {
        switch (this._mode) {
            case this.DAY: {
                if (this.hasApply && !this._isInitialDate) {
                    this._tmpFormat = this.dateFormat;
                }
                else {
                    this._dateFormat = this.dateFormat;
                }
                break;
            }
            case this.MONTH: {
                if (this.hasApply && !this._isInitialDate) {
                    this._tmpFormat = this.dateFormat.replace(/(^(d|D)+[^mMyY])|([^mMyYdD](d|D)+)/, "");
                }
                else {
                    this._dateFormat = this.dateFormat.replace(/(^(d|D)+[^mMyY])|([^mMyYdD](d|D)+)/, "");
                }
                break;
            }
            case this.YEAR: {
                let match = this.dateFormat.match(/(y|Y)+/);
                if (this.hasApply && !this._isInitialDate) {
                    this._tmpFormat = match && match.length > 0 ? match[0] : null;
                }
                else {
                    this._dateFormat = match && match.length > 0 ? match[0] : null;
                }
                break;
            }
            default: {
                if (this.hasApply && !this._isInitialDate) {
                    this._tmpFormat = this.dateFormat;
                }
                else {
                    this._dateFormat = this.dateFormat;
                }
                break;
            }
        }
        if (!this.hasApply && !this._dateFormat) {
            this._dateFormat = this.dateFormat;
        }
        if (this._date && this.dateFormat) {
            this._formattedDate = _moment(this._date).formatWithJDF(this.dateFormat);
        }
    }
    onClosed($event) {
        if (this.pickerMode == this.DAY && (!this.withTime || this._date)) {
            this.onDateChange(this._date);
        }
        if (this.selectionMade) {
            this.dateChange.emit(this._date);
            this.dateSelected.emit({ date: this._date, mode: this._mode, dateFormat: this._dateFormat });
            this.selectionMade = false;
        }
        this.onBlur(this._date);
        this._tmpDate = null;
        this._tmpFormat = null;
    }
    onInputClick() {
        if (!this.isReadOnly)
            this.picker.open();
    }
    onApplyClicked(datepicker) {
        this._date = this._tmpDate;
        if (this.pickerMode === this.YEAR) {
            let match = this.dateFormat.match(/(y|Y)+/);
            this._tmpFormat = match && match.length > 0 ? match[0] : null;
        }
        if (this.pickerMode === this.MONTH) {
            this._tmpFormat = this.dateFormat.replace(/(^(d|D)+[^mMyY])|([^mMyYdD](d|D)+)/, "");
        }
        this._dateFormat = this._tmpFormat;
        this._formattedDate = _moment(this._date).formatWithJDF(this._dateFormat);
        datepicker.close();
    }
    static { this.ɵfac = function ExDatePickerComponent_Factory(t) { return new (t || ExDatePickerComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6$1.DateAdapter), i0.ɵɵdirectiveInject(i2$4.NgxMatDateAdapter), i0.ɵɵdirectiveInject(EX_APP_LANGUAGE)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDatePickerComponent, selectors: [["ex-date-picker"]], viewQuery: function ExDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1m, 5);
            i0.ɵɵviewQuery(_c1$Q, 5);
            i0.ɵɵviewQuery(_c2$A, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timePicker = _t.first);
        } }, hostBindings: function ExDatePickerComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("dateChange", function ExDatePickerComponent_dateChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExDatePickerComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { label: "label", date: "date", dateMode: "dateMode", fullDate: "fullDate", dateFormat: "dateFormat", border: "border", startView: "startView", pickerMode: "pickerMode", placeholder: "placeholder", disablePast: "disablePast", hasApply: "hasApply", showInput: "showInput", maxDate: "maxDate", withTime: "withTime", showSeconds: "showSeconds" }, outputs: { dateChange: "dateChange", dateSelected: "dateSelected" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExDatePickerComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 10, vars: 20, consts: [[1, "ex-date-picker-wrapper", 3, "ngClass", "mouseenter", "mouseleave"], ["matInput", "", "readonly", "", "class", "ex-date-picker-input", 3, "ngModel", "matDatepicker", "min", "placeholder", "ngClass", "blur", "dateChange", 4, "ngIf"], ["matInput", "", "readonly", "", "class", "ex-date-picker-input", 3, "ngModel", "ngxMatDatetimePicker", "min", "placeholder", "ngClass", "blur", "dateChange", 4, "ngIf"], [3, "value", "placeholder", "ngClass", "click", 4, "ngIf"], ["class", "ex-date-picker-editable-text", 3, "text", "placeholder", "hasBorder", "ariaDescription", "ariaLabel", "ariaRequired", "ariaErrorLabel", "editableTextSaved", "focusout", 4, "ngIf"], ["tabindex", "0", "iconType", "uxf", "iconName", "uxf-close", "sizePx", "14px", "tooltip", "ng.general.remove", "color", "#4164A4", 1, "ex-date-picker-clear", 3, "ngClass", "ngStyle", "isActionButton", "click", "keydown.enter"], ["matSuffix", "", "exFormAriaAttributes", "", 3, "exFocus", "for", "disabled", "exFocusChange", 4, "ngIf"], [3, "startAt", "startView", "closed", "yearSelected", "monthSelected", 4, "ngIf"], [3, "showSeconds", "hideTime", "startAt", "startView", "closed", 4, "ngIf"], ["matInput", "", "readonly", "", 1, "ex-date-picker-input", 3, "ngModel", "matDatepicker", "min", "placeholder", "ngClass", "blur", "dateChange"], ["input", ""], ["matInput", "", "readonly", "", 1, "ex-date-picker-input", 3, "ngModel", "ngxMatDatetimePicker", "min", "placeholder", "ngClass", "blur", "dateChange"], [3, "value", "placeholder", "ngClass", "click"], [1, "ex-date-picker-editable-text", 3, "text", "placeholder", "hasBorder", "ariaDescription", "ariaLabel", "ariaRequired", "ariaErrorLabel", "editableTextSaved", "focusout"], ["matSuffix", "", "exFormAriaAttributes", "", 3, "exFocus", "for", "disabled", "exFocusChange"], ["matDatepickerToggleIcon", "", "iconName", "calendar_today", "iconType", "matIcon", "color", "#4164A4", 1, "ex-date-range-picker-date-icon", 3, "isActionButton", "ngStyle"], [3, "startAt", "startView", "closed", "yearSelected", "monthSelected"], ["picker", ""], [4, "ngIf"], ["matDatepickerApply", "", "type", "primary", 3, "click"], [3, "showSeconds", "hideTime", "startAt", "startView", "closed"], ["timePicker", ""], ["type", "primary", "ngxMatDatepickerApply", ""], ["role", "img", "aria-hidden", "true", "data-mat-icon-type", "font", 1, "mat-icon", "notranslate", "material-icons", "mat-ligature-font", "mat-icon-no-color"]], template: function ExDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("mouseenter", function ExDatePickerComponent_Template_div_mouseenter_0_listener() { return ctx.isHovered = true; })("mouseleave", function ExDatePickerComponent_Template_div_mouseleave_0_listener() { return ctx.isHovered = false; });
            i0.ɵɵtemplate(1, ExDatePickerComponent_input_1_Template, 3, 9, "input", 1);
            i0.ɵɵtemplate(2, ExDatePickerComponent_input_2_Template, 3, 9, "input", 2);
            i0.ɵɵtemplate(3, ExDatePickerComponent_ex_display_text_3_Template, 2, 7, "ex-display-text", 3);
            i0.ɵɵtemplate(4, ExDatePickerComponent_ex_editable_text_4_Template, 2, 9, "ex-editable-text", 4);
            i0.ɵɵelementStart(5, "ex-icon", 5);
            i0.ɵɵlistener("click", function ExDatePickerComponent_Template_ex_icon_click_5_listener() { return ctx.cleanDate(); })("keydown.enter", function ExDatePickerComponent_Template_ex_icon_keydown_enter_5_listener() { return ctx.cleanDate(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, ExDatePickerComponent_mat_datepicker_toggle_6_Template, 2, 7, "mat-datepicker-toggle", 6);
            i0.ɵɵtemplate(7, ExDatePickerComponent_mat_datepicker_toggle_7_Template, 2, 7, "mat-datepicker-toggle", 6);
            i0.ɵɵtemplate(8, ExDatePickerComponent_mat_datepicker_8_Template, 3, 3, "mat-datepicker", 7);
            i0.ɵɵtemplate(9, ExDatePickerComponent_ngx_mat_datetime_picker_9_Template, 6, 4, "ngx-mat-datetime-picker", 8);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c5$i, ctx.isHovered && !ctx.isReadOnly, !ctx.valid, ctx.isReadOnly));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.withTime);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.withTime);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.showInput);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showInput);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c6$g, ctx.isReadOnly || !ctx._date))("ngStyle", i0.ɵɵpureFunction1(18, _c7$d, ctx.isReadOnly ? "default" : "pointer"))("isActionButton", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.withTime);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.withTime);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.withTime);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.withTime);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgStyle, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, i1$9.MatIcon, i6.MatDatepicker, i6.MatDatepickerInput, i6.MatDatepickerToggle, i6.MatDatepickerToggleIcon, i6.MatDatepickerActions, i6.MatDatepickerApply, ExIconComponent, ExButtonComponent, ExDisplayTextComponent, MinValidator, ExFocusDirective, ExFormAriaAttributesDirective, ExEditableTextComponent, i2$4.NgxMatDatetimepicker, i2$4.NgxMatDatepickerInput, i2$4.NgxMatDatepickerActions, i2$4.NgxMatDatepickerApply, i1$2.TranslatePipe], styles: [".ex-date-picker-wrapper[_ngcontent-%COMP%]{display:flex;align-items:baseline;height:32px;width:-moz-fit-content;width:fit-content;border-radius:3px}.ex-date-picker-wrapper.ex-date-picker-invalid[_ngcontent-%COMP%]{border:2px solid #c75757!important}.ex-date-picker-hover[_ngcontent-%COMP%]{background-color:#e5e5e5}.ex-date-picker-clear[_ngcontent-%COMP%]{cursor:pointer}.ex-date-picker-clear.ex-date-picker-clear-hidden[_ngcontent-%COMP%]{display:none}mat-datepicker-toggle[_ngcontent-%COMP%]     button.mat-mdc-icon-button{top:3px;height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content}.ex-date-range-picker-date-icon[_ngcontent-%COMP%]{line-height:initial}.ex-date-range-picker-date-icon[_ngcontent-%COMP%]     i{line-height:inherit}  .action-button-bg:hover{background-color:#d9d9d9!important}  .action-button-bg:hover>i{color:#07447f!important}  .action-button-bg:hover>i{color:#0e7bba}.ex-date-picker-wrapper[_ngcontent-%COMP%]{position:relative;align-items:center}.ex-date-picker-wrapper[_ngcontent-%COMP%]   ex-display-text[_ngcontent-%COMP%]{cursor:pointer;overflow:hidden}.ex-date-picker-wrapper[_ngcontent-%COMP%]   ex-display-text[_ngcontent-%COMP%]     .ex-display-text-value-text{color:#222}.ex-date-picker-wrapper[_ngcontent-%COMP%]   ex-display-text[_ngcontent-%COMP%]     .ex-display-text-value-text.ex-display-text-value-text-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-date-picker-wrapper[_ngcontent-%COMP%]   ex-display-text.ex-date-picker-read-only[_ngcontent-%COMP%]     .ex-display-text-value-text{opacity:.5;cursor:default}.ex-date-picker-wrapper[_ngcontent-%COMP%]   .ex-date-picker-input[_ngcontent-%COMP%]{visibility:hidden;width:0px;overflow:hidden;border:0px}.ex-date-picker-wrapper[_ngcontent-%COMP%]   .ex-date-picker-editable-text[_ngcontent-%COMP%]{width:100%}.ex-date-picker-wrapper[_ngcontent-%COMP%]   .ex-date-picker-editable-text[_ngcontent-%COMP%]     .ex-editable-text-icon, .ex-date-picker-wrapper[_ngcontent-%COMP%]   .ex-date-picker-editable-text[_ngcontent-%COMP%]     .ex-editable-text-clear-button{display:none}  .ngx-mat-timepicker-spacer{padding-bottom:21px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDatePickerComponent, [{
        type: Component,
        args: [{ selector: 'ex-date-picker', host: {
                    '(dateChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExDatePickerComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-date-picker-wrapper\" (mouseenter)=\"isHovered = true\" (mouseleave)=\"isHovered = false\"\n    [ngClass]=\"{'ex-date-picker-hover': isHovered && !isReadOnly, 'ex-date-picker-invalid': !valid,'ex-date-picker-readonly': isReadOnly }\">\n   <input matInput readonly *ngIf=\"!withTime\" [ngModel]=\"!hasApply? _date: _tmpDate\" #input [matDatepicker]=\"picker\" [min]=\"minDate\"\n        placeholder=\"{{ placeholder | translate}} \" class=\"ex-date-picker-input\"\n        [ngClass]=\"{ 'ex-date-picker-read-only': isReadOnly }\" (blur)=\"onBlur($event)\"\n        (dateChange)=\"onDateChange($event.value)\">\n  <input matInput readonly *ngIf=\"withTime\" [ngModel]=\"!hasApply? _date: _tmpDate\" #input [ngxMatDatetimePicker]=\"timePicker\" [min]=\"minDate\"\n         placeholder=\"{{ placeholder | translate}} \" class=\"ex-date-picker-input\"\n         [ngClass]=\"{ 'ex-date-picker-read-only': isReadOnly }\" (blur)=\"onBlur($event)\"\n         (dateChange)=\"onDateChange($event.value)\">\n    <ex-display-text *ngIf=\"!showInput\" [value]=\"_formattedDate\" [placeholder]=\"placeholder | translate\"\n        [ngClass]=\"{ 'ex-date-picker-read-only': isReadOnly }\" (click)=\"onInputClick()\"></ex-display-text>\n    <ex-editable-text *ngIf=\"showInput\" class=\"ex-date-picker-editable-text\" [text]=\"_formattedDate\"\n        placeholder=\"{{ dateFormat | translate}} \" [hasBorder]=\"false\" (editableTextSaved)=\"textSaved($event)\"\n        [ariaDescription]=\"ariaDescription\" [ariaLabel]=\"ariaLabel\" [ariaRequired]=\"ariaRequired\"\n        [ariaErrorLabel]=\"ariaErrorLabel\" (focusout)=\"onBlur()\">\n    </ex-editable-text>\n    <ex-icon tabindex=\"0\" class=\"ex-date-picker-clear\"\n        [ngClass]=\"{ 'ex-date-picker-clear-hidden':( isReadOnly || !_date )  }\"\n        [ngStyle]=\"{ 'cursor': isReadOnly ? 'default' : 'pointer' }\" iconType=\"uxf\" iconName=\"uxf-close\" sizePx=\"14px\"\n        tooltip=\"ng.general.remove\" color=\"#4164A4\" [isActionButton]=\"!isReadOnly\" (click)=\"cleanDate()\"\n        (keydown.enter)=\"cleanDate()\">\n    </ex-icon>\n\n    <mat-datepicker-toggle *ngIf=\"!withTime\" [(exFocus)]=\"isFieldFocused\" matSuffix [for]=\"picker\" [disabled]=\"isReadOnly\"\n        exFormAriaAttributes>\n        <ex-icon matDatepickerToggleIcon class=\"ex-date-range-picker-date-icon\" iconName=\"calendar_today\"\n            iconType=\"matIcon\" color=\"#4164A4\" [isActionButton]=\"!isReadOnly\"\n            [ngStyle]=\"{ 'visibility': isReadOnly ? 'hidden' : 'visible' }\"></ex-icon>\n    </mat-datepicker-toggle>\n  <mat-datepicker-toggle *ngIf=\"withTime\" [(exFocus)]=\"isFieldFocused\" matSuffix [for]=\"$any(timePicker)\" [disabled]=\"isReadOnly\"\n                         exFormAriaAttributes>\n    <ex-icon matDatepickerToggleIcon class=\"ex-date-range-picker-date-icon\" iconName=\"calendar_today\"\n             iconType=\"matIcon\" color=\"#4164A4\" [isActionButton]=\"!isReadOnly\"\n             [ngStyle]=\"{ 'visibility': isReadOnly ? 'hidden' : 'visible' }\"></ex-icon>\n  </mat-datepicker-toggle>\n\n    <mat-datepicker *ngIf=\"!withTime\" #picker [startAt]=\"_date\" [startView]=\"startView\" (closed)=\"onClosed($event)\"\n        (yearSelected)=\"onYearSelected($event, picker)\" (monthSelected)=\"onMonthSelected($event, picker)\">\n        <mat-datepicker-actions *ngIf=\"hasApply\">\n            <ex-button matDatepickerApply type=\"primary\" (click)=\"onApplyClicked(picker)\">{{ 'ng.general.apply' |\n                translate }}</ex-button>\n        </mat-datepicker-actions>\n    </mat-datepicker>\n\n    <ngx-mat-datetime-picker #timePicker *ngIf=\"withTime\" [showSeconds]=\"showSeconds\"\n                             [hideTime]=\"!withTime\" [startAt]=\"_date\" [startView]=\"startView\" (closed)=\"onClosed($event)\">\n    <ngx-mat-datepicker-actions>\n      <ex-button type=\"primary\" ngxMatDatepickerApply>\n        <mat-icon role=\"img\" class=\"mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color\" aria-hidden=\"true\" data-mat-icon-type=\"font\">done</mat-icon>\n      </ex-button>\n    </ngx-mat-datepicker-actions>\n    </ngx-mat-datetime-picker>\n\n\n</div>\n", styles: [".ex-date-picker-wrapper{display:flex;align-items:baseline;height:32px;width:-moz-fit-content;width:fit-content;border-radius:3px}.ex-date-picker-wrapper.ex-date-picker-invalid{border:2px solid #c75757!important}.ex-date-picker-hover{background-color:#e5e5e5}.ex-date-picker-clear{cursor:pointer}.ex-date-picker-clear.ex-date-picker-clear-hidden{display:none}mat-datepicker-toggle ::ng-deep button.mat-mdc-icon-button{top:3px;height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content}.ex-date-range-picker-date-icon{line-height:initial}.ex-date-range-picker-date-icon ::ng-deep i{line-height:inherit}::ng-deep .action-button-bg:hover{background-color:#d9d9d9!important}::ng-deep .action-button-bg:hover>i{color:#07447f!important}::ng-deep .action-button-bg:hover>i{color:#0e7bba}.ex-date-picker-wrapper{position:relative;align-items:center}.ex-date-picker-wrapper ex-display-text{cursor:pointer;overflow:hidden}.ex-date-picker-wrapper ex-display-text ::ng-deep .ex-display-text-value-text{color:#222}.ex-date-picker-wrapper ex-display-text ::ng-deep .ex-display-text-value-text.ex-display-text-value-text-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-date-picker-wrapper ex-display-text.ex-date-picker-read-only ::ng-deep .ex-display-text-value-text{opacity:.5;cursor:default}.ex-date-picker-wrapper .ex-date-picker-input{visibility:hidden;width:0px;overflow:hidden;border:0px}.ex-date-picker-wrapper .ex-date-picker-editable-text{width:100%}.ex-date-picker-wrapper .ex-date-picker-editable-text ::ng-deep .ex-editable-text-icon,.ex-date-picker-wrapper .ex-date-picker-editable-text ::ng-deep .ex-editable-text-clear-button{display:none}::ng-deep .ngx-mat-timepicker-spacer{padding-bottom:21px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: i6$1.DateAdapter }, { type: i2$4.NgxMatDateAdapter }, { type: undefined, decorators: [{
                type: Inject,
                args: [EX_APP_LANGUAGE]
            }] }]; }, { label: [{
            type: Input
        }], date: [{
            type: Input
        }], dateMode: [{
            type: Input
        }], fullDate: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], border: [{
            type: Input
        }], startView: [{
            type: Input
        }], pickerMode: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disablePast: [{
            type: Input
        }], hasApply: [{
            type: Input
        }], showInput: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], withTime: [{
            type: Input
        }], showSeconds: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], dateSelected: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }], picker: [{
            type: ViewChild,
            args: ['picker']
        }], timePicker: [{
            type: ViewChild,
            args: ['timePicker']
        }] }); })();

class ExDotWrapperModule {
    static { this.ɵfac = function ExDotWrapperModule_Factory(t) { return new (t || ExDotWrapperModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDotWrapperModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDotWrapperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    ExDotWrapperComponent
                ],
                exports: [
                    ExDotWrapperComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDotWrapperModule, { declarations: [ExDotWrapperComponent], imports: [CommonModule], exports: [ExDotWrapperComponent] }); })();

class ExActionIconMenuModule {
    static { this.ɵfac = function ExActionIconMenuModule_Factory(t) { return new (t || ExActionIconMenuModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExActionIconMenuModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            MatIconModule,
            TranslateModule,
            ExSvgIconModule,
            ExButtonModule,
            ExDotWrapperModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExActionIconMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatIconModule,
                    TranslateModule,
                    ExSvgIconModule,
                    ExButtonModule,
                    ExDotWrapperModule
                ],
                declarations: [
                    ExActionIconMenuComponent
                ],
                exports: [
                    ExActionIconMenuComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExActionIconMenuModule, { declarations: [ExActionIconMenuComponent], imports: [CommonModule,
        MatMenuModule,
        MatIconModule,
        TranslateModule,
        ExSvgIconModule,
        ExButtonModule,
        ExDotWrapperModule], exports: [ExActionIconMenuComponent] }); })();

class ExEditableTextModule {
    static { this.ɵfac = function ExEditableTextModule_Factory(t) { return new (t || ExEditableTextModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExEditableTextModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExSpinnerModule,
            ExSvgIconModule,
            TranslateModule,
            ExDisplayTextModule,
            ExActionIconMenuModule,
            AutoSizeInputModule,
            AutosizeModule,
            ExCloseModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditableTextModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExSpinnerModule,
                    ExSvgIconModule,
                    TranslateModule,
                    ExDisplayTextModule,
                    ExActionIconMenuModule,
                    AutoSizeInputModule,
                    AutosizeModule,
                    ExCloseModule
                ],
                declarations: [
                    ExEditableTextComponent
                ],
                exports: [
                    ExEditableTextComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExEditableTextModule, { declarations: [ExEditableTextComponent], imports: [CommonModule,
        FormsModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExSpinnerModule,
        ExSvgIconModule,
        TranslateModule,
        ExDisplayTextModule,
        ExActionIconMenuModule,
        AutoSizeInputModule,
        AutosizeModule,
        ExCloseModule], exports: [ExEditableTextComponent] }); })();

class ExDatePickerModule {
    static { this.ɵfac = function ExDatePickerModule_Factory(t) { return new (t || ExDatePickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDatePickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
            { provide: DateAdapter, useClass: MomentDateAdapter },
            { provide: NgxMatDateAdapter, useClass: NgxMatMomentAdapter },
            { provide: NGX_MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        ], imports: [CommonModule,
            FormsModule,
            MatIconModule,
            TranslateModule,
            MatDatepickerModule,
            MatNativeDateModule,
            NgxMatNativeDateModule,
            ExCloseModule,
            ExIconModule,
            ExButtonModule,
            ExDisplayTextModule,
            ExDirectivesModule,
            ExEditableTextModule,
            NgxMatDatetimePickerModule,
            MatMomentDateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDatePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatIconModule,
                    TranslateModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    NgxMatNativeDateModule,
                    ExCloseModule,
                    ExIconModule,
                    ExButtonModule,
                    ExDisplayTextModule,
                    ExDirectivesModule,
                    ExEditableTextModule,
                    NgxMatDatetimePickerModule,
                    MatMomentDateModule
                ],
                declarations: [
                    ExDatePickerComponent
                ],
                providers: [
                    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
                    { provide: DateAdapter, useClass: MomentDateAdapter },
                    { provide: NgxMatDateAdapter, useClass: NgxMatMomentAdapter },
                    { provide: NGX_MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
                ],
                exports: [
                    ExDatePickerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDatePickerModule, { declarations: [ExDatePickerComponent], imports: [CommonModule,
        FormsModule,
        MatIconModule,
        TranslateModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatNativeDateModule,
        ExCloseModule,
        ExIconModule,
        ExButtonModule,
        ExDisplayTextModule,
        ExDirectivesModule,
        ExEditableTextModule,
        NgxMatDatetimePickerModule,
        MatMomentDateModule], exports: [ExDatePickerComponent] }); })();

const LOCALE_CONFIG = new InjectionToken('daterangepicker.config');
/**
 *  DefaultLocaleConfig
 */
const DefaultLocaleConfig = {
    direction: 'ltr',
    separator: ' - ',
    weekLabel: 'W',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    customRangeLabel: 'Custom range',
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: moment.localeData().firstDayOfWeek()
};

class LocaleService {
    constructor(_config) {
        this._config = _config;
    }
    get config() {
        if (!this._config) {
            return DefaultLocaleConfig;
        }
        return { ...DefaultLocaleConfig, ...this._config };
    }
    static { this.ɵfac = function LocaleService_Factory(t) { return new (t || LocaleService)(i0.ɵɵinject(LOCALE_CONFIG)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocaleService, factory: LocaleService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LOCALE_CONFIG]
            }] }]; }, null); })();

const _c0$1l = ["pickerContainer"];
const _c1$P = function (a0) { return { "active": a0 }; };
function DaterangepickerComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 8);
    i0.ɵɵlistener("click", function DaterangepickerComponent_li_5_Template_button_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const range_r5 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.clickRange($event, range_r5)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const range_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.disableRange(range_r5))("ngClass", i0.ɵɵpureFunction1(3, _c1$P, range_r5 === ctx_r1.chosenRange));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(range_r5);
} }
function DaterangepickerComponent_div_6_table_2_th_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th");
} }
function DaterangepickerComponent_div_6_table_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 20);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_6_table_2_ng_container_4_Template_th_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.clickPrev(ctx_r20.sideEnum.left)); })("keydown.enter", function DaterangepickerComponent_div_6_table_2_ng_container_4_Template_th_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r22.clickPrev(ctx_r22.sideEnum.left)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "ng.general.previous"));
} }
function DaterangepickerComponent_div_6_table_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
} }
function DaterangepickerComponent_div_6_table_2_ng_container_7_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r25 = ctx.$implicit;
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r23.calendarVariables.left.dropdowns.inMinYear && m_r25 < ctx_r23.calendarVariables.left.minDate.month() || ctx_r23.calendarVariables.left.dropdowns.inMaxYear && m_r25 > ctx_r23.calendarVariables.left.maxDate.month())("value", m_r25)("selected", ctx_r23.calendarVariables.left.dropdowns.currentMonth == m_r25);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.locale.monthNames[m_r25], " ");
} }
function DaterangepickerComponent_div_6_table_2_ng_container_7_option_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const y_r26 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r26 === ctx_r24.calendarVariables.left.dropdowns.currentYear);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", y_r26, " ");
} }
function DaterangepickerComponent_div_6_table_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "select", 22);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_6_table_2_ng_container_7_Template_select_change_3_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r27.monthChanged($event, ctx_r27.sideEnum.left)); });
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_6_table_2_ng_container_7_option_4_Template, 2, 4, "option", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementStart(7, "select", 24);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_6_table_2_ng_container_7_Template_select_change_7_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r29.yearChanged($event, ctx_r29.sideEnum.left)); });
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_6_table_2_ng_container_7_option_8_Template, 2, 2, "option", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.locale.monthNames[ctx_r13.calendarVariables == null ? null : ctx_r13.calendarVariables.left == null ? null : ctx_r13.calendarVariables.left.calendar[1][1].month()], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r13.calendarVariables.left.dropdowns.monthArrays);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.calendarVariables == null ? null : ctx_r13.calendarVariables.left == null ? null : ctx_r13.calendarVariables.left.calendar[1][1].format(" YYYY"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r13.calendarVariables.left.dropdowns.yearArrays);
} }
function DaterangepickerComponent_div_6_table_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r14.locale.monthNames[ctx_r14.calendarVariables == null ? null : ctx_r14.calendarVariables.left == null ? null : ctx_r14.calendarVariables.left.calendar[1][1].month()], " ", ctx_r14.calendarVariables == null ? null : ctx_r14.calendarVariables.left == null ? null : ctx_r14.calendarVariables.left.calendar[1][1].format(" YYYY"), " ");
} }
function DaterangepickerComponent_div_6_table_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 28);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_6_table_2_ng_container_9_Template_th_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.clickNext(ctx_r30.sideEnum.left)); })("keydown.enter", function DaterangepickerComponent_div_6_table_2_ng_container_9_Template_th_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.clickNext(ctx_r32.sideEnum.left)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "ng.general.next"));
} }
function DaterangepickerComponent_div_6_table_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
} }
function DaterangepickerComponent_div_6_table_2_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 29)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r17.locale.weekLabel);
} }
function DaterangepickerComponent_div_6_table_2_th_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dayofweek_r33 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r33);
} }
function DaterangepickerComponent_div_6_table_2_tr_15_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r35.calendarVariables.left.calendar[row_r34][0].week());
} }
function DaterangepickerComponent_div_6_table_2_tr_15_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r36.calendarVariables.left.calendar[row_r34][0].isoWeek());
} }
function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("keydown.enter", function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template_td_keydown_enter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r42); const col_r40 = restoredCtx.$implicit; const row_r34 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r41.clickDate($event, ctx_r41.sideEnum.left, row_r34, col_r40)); })("click", function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template_td_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r42); const col_r40 = restoredCtx.$implicit; const row_r34 = i0.ɵɵnextContext().$implicit; const ctx_r44 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r44.clickDate($event, ctx_r44.sideEnum.left, row_r34, col_r40)); })("mouseenter", function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template_td_mouseenter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r42); const col_r40 = restoredCtx.$implicit; const row_r34 = i0.ɵɵnextContext().$implicit; const ctx_r46 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r46.hoverDate($event, ctx_r46.sideEnum.left, row_r34, col_r40)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r40 = ctx.$implicit;
    const row_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r37.calendarVariables.left.classes[row_r34][col_r40]);
    i0.ɵɵattribute("aria-disabled", (ctx_r37.calendarVariables.left.classes[row_r34][col_r40] == null ? null : ctx_r37.calendarVariables.left.classes[row_r34][col_r40].includes("disabled")) ? true : false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r37.calendarVariables.left.calendar[row_r34][col_r40].date());
} }
function DaterangepickerComponent_div_6_table_2_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 30);
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_6_table_2_tr_15_td_1_Template, 3, 1, "td", 31);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_6_table_2_tr_15_td_2_Template, 3, 1, "td", 31);
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template, 3, 4, "td", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r34 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r19.calendarVariables.left.classes[row_r34].classList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.showWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r19.calendarVariables.left.calCols);
} }
function DaterangepickerComponent_div_6_table_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 13)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_table_2_th_3_Template, 1, 0, "th", 14);
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_6_table_2_ng_container_4_Template, 3, 3, "ng-container", 14);
    i0.ɵɵtemplate(5, DaterangepickerComponent_div_6_table_2_ng_container_5_Template, 2, 0, "ng-container", 14);
    i0.ɵɵelementStart(6, "th", 15);
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_6_table_2_ng_container_7_Template, 9, 4, "ng-container", 14);
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_6_table_2_ng_container_8_Template, 2, 2, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_6_table_2_ng_container_9_Template, 3, 3, "ng-container", 14);
    i0.ɵɵtemplate(10, DaterangepickerComponent_div_6_table_2_ng_container_10_Template, 2, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 16);
    i0.ɵɵtemplate(12, DaterangepickerComponent_div_6_table_2_th_12_Template, 3, 1, "th", 17);
    i0.ɵɵtemplate(13, DaterangepickerComponent_div_6_table_2_th_13_Template, 3, 1, "th", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "tbody", 18);
    i0.ɵɵtemplate(15, DaterangepickerComponent_div_6_table_2_tr_15_Template, 4, 5, "tr", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r8.showWeekNumbers || ctx_r8.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.calendarVariables.left.minDate || ctx_r8.calendarVariables.left.minDate.isBefore(ctx_r8.calendarVariables.left.calendar.firstDay) && (!ctx_r8.linkedCalendars || true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(!ctx_r8.calendarVariables.left.minDate || ctx_r8.calendarVariables.left.minDate.isBefore(ctx_r8.calendarVariables.left.calendar.firstDay) && (!ctx_r8.linkedCalendars || true)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.showDropdowns && ctx_r8.calendarVariables.left.dropdowns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.showDropdowns || !ctx_r8.calendarVariables.left.dropdowns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r8.calendarVariables.left.maxDate || ctx_r8.calendarVariables.left.maxDate.isAfter(ctx_r8.calendarVariables.left.calendar.lastDay)) && (!ctx_r8.linkedCalendars || ctx_r8.singleDatePicker));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((!ctx_r8.calendarVariables.left.maxDate || ctx_r8.calendarVariables.left.maxDate.isAfter(ctx_r8.calendarVariables.left.calendar.lastDay)) && (!ctx_r8.linkedCalendars || ctx_r8.singleDatePicker)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.showWeekNumbers || ctx_r8.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.locale.daysOfWeek);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r8.calendarVariables.left.calRows);
} }
function DaterangepickerComponent_div_6_div_3_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r53 = ctx.$implicit;
    const ctx_r49 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r53)("disabled", ctx_r49.timepickerVariables.left.disabledHours.indexOf(i_r53) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i_r53);
} }
function DaterangepickerComponent_div_6_div_3_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r54 = ctx.$implicit;
    const index_r55 = ctx.index;
    const ctx_r50 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r54)("disabled", ctx_r50.timepickerVariables.left.disabledMinutes.indexOf(i_r54) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r50.timepickerVariables.left.minutesLabel[index_r55], "");
} }
function DaterangepickerComponent_div_6_div_3_select_10_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r57 = ctx.$implicit;
    const index_r58 = ctx.index;
    const ctx_r56 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r57)("disabled", ctx_r56.timepickerVariables.left.disabledSeconds.indexOf(i_r57) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r56.timepickerVariables.left.secondsLabel[index_r58], "");
} }
function DaterangepickerComponent_div_6_div_3_select_10_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 45);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_select_10_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r59.timepickerVariables.left.selectedSecond = $event); })("ngModelChange", function DaterangepickerComponent_div_6_div_3_select_10_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r61.timeChanged($event, ctx_r61.sideEnum.left)); });
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_6_div_3_select_10_option_1_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", !ctx_r51.startDate)("ngModel", ctx_r51.timepickerVariables.left.selectedSecond);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r51.timepickerVariables.left.seconds);
} }
function DaterangepickerComponent_div_6_div_3_select_14_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 46);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_select_14_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r62.timepickerVariables.left.ampmModel = $event); })("ngModelChange", function DaterangepickerComponent_div_6_div_3_select_14_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r64 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r64.timeChanged($event, ctx_r64.sideEnum.left)); });
    i0.ɵɵelementStart(1, "option", 47);
    i0.ɵɵtext(2, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 48);
    i0.ɵɵtext(4, "PM");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngModel", ctx_r52.timepickerVariables.left.ampmModel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r52.timepickerVariables.left.amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r52.timepickerVariables.left.pmDisabled);
} }
function DaterangepickerComponent_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "select", 37);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r65.timepickerVariables.left.selectedHour = $event); })("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r67.timeChanged($event, ctx_r67.sideEnum.left)); });
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_div_3_option_3_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 36)(5, "select", 39);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r68 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r68.timepickerVariables.left.selectedMinute = $event); })("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r69 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r69.timeChanged($event, ctx_r69.sideEnum.left)); });
    i0.ɵɵtemplate(6, DaterangepickerComponent_div_6_div_3_option_6_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 40)(8, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 36);
    i0.ɵɵtemplate(10, DaterangepickerComponent_div_6_div_3_select_10_Template, 2, 3, "select", 42);
    i0.ɵɵelement(11, "span", 40)(12, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 36);
    i0.ɵɵtemplate(14, DaterangepickerComponent_div_6_div_3_select_14_Template, 5, 3, "select", 43);
    i0.ɵɵelement(15, "span", 40)(16, "span", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r9.startDate)("ngModel", ctx_r9.timepickerVariables.left.selectedHour);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.timepickerVariables.left.hours);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r9.startDate)("ngModel", ctx_r9.timepickerVariables.left.selectedMinute);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.timepickerVariables.left.minutes);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r9.timePickerSeconds);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r9.timePicker24Hour);
} }
const _c2$z = function (a0, a1) { return { right: a0, left: a1 }; };
function DaterangepickerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_6_table_2_Template, 16, 10, "table", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_div_3_Template, 17, 8, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2$z, ctx_r2.singleDatePicker, !ctx_r2.singleDatePicker));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.calendarVariables);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.timePicker);
} }
function DaterangepickerComponent_div_7_table_2_th_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th");
} }
function DaterangepickerComponent_div_7_table_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 20);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_7_table_2_ng_container_4_Template_th_click_1_listener() { i0.ɵɵrestoreView(_r83); const ctx_r82 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r82.clickPrev(ctx_r82.sideEnum.right)); })("keydown.enter", function DaterangepickerComponent_div_7_table_2_ng_container_4_Template_th_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r83); const ctx_r84 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r84.clickPrev(ctx_r84.sideEnum.right)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "ng.general.previous"));
} }
function DaterangepickerComponent_div_7_table_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
} }
function DaterangepickerComponent_div_7_table_2_ng_container_7_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r87 = ctx.$implicit;
    const ctx_r85 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r85.calendarVariables.right.dropdowns.inMinYear && ctx_r85.calendarVariables.right.minDate && m_r87 < ctx_r85.calendarVariables.right.minDate.month() || ctx_r85.calendarVariables.right.dropdowns.inMaxYear && ctx_r85.calendarVariables.right.maxDate && m_r87 > ctx_r85.calendarVariables.right.maxDate.month())("value", m_r87)("selected", ctx_r85.calendarVariables.right.dropdowns.currentMonth == m_r87);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r85.locale.monthNames[m_r87], " ");
} }
function DaterangepickerComponent_div_7_table_2_ng_container_7_option_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const y_r88 = ctx.$implicit;
    const ctx_r86 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r88 === ctx_r86.calendarVariables.right.dropdowns.currentYear);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", y_r88, " ");
} }
function DaterangepickerComponent_div_7_table_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "select", 22);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_7_table_2_ng_container_7_Template_select_change_3_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r89 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r89.monthChanged($event, ctx_r89.sideEnum.right)); });
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_7_table_2_ng_container_7_option_4_Template, 2, 4, "option", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementStart(7, "select", 24);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_7_table_2_ng_container_7_Template_select_change_7_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r91 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r91.yearChanged($event, ctx_r91.sideEnum.right)); });
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_7_table_2_ng_container_7_option_8_Template, 2, 2, "option", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r75.locale.monthNames[ctx_r75.calendarVariables == null ? null : ctx_r75.calendarVariables.right == null ? null : ctx_r75.calendarVariables.right.calendar[1][1].month()], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r75.calendarVariables.right.dropdowns.monthArrays);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r75.calendarVariables == null ? null : ctx_r75.calendarVariables.right == null ? null : ctx_r75.calendarVariables.right.calendar[1][1].format(" YYYY"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r75.calendarVariables.right.dropdowns.yearArrays);
} }
function DaterangepickerComponent_div_7_table_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r76.locale.monthNames[ctx_r76.calendarVariables == null ? null : ctx_r76.calendarVariables.right == null ? null : ctx_r76.calendarVariables.right.calendar[1][1].month()], " ", ctx_r76.calendarVariables == null ? null : ctx_r76.calendarVariables.right == null ? null : ctx_r76.calendarVariables.right.calendar[1][1].format(" YYYY"), " ");
} }
function DaterangepickerComponent_div_7_table_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 28);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_7_table_2_ng_container_9_Template_th_click_1_listener() { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r92.clickNext(ctx_r92.sideEnum.right)); })("keydown.enter", function DaterangepickerComponent_div_7_table_2_ng_container_9_Template_th_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r93); const ctx_r94 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r94.clickNext(ctx_r94.sideEnum.right)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "ng.general.next"));
} }
function DaterangepickerComponent_div_7_table_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
} }
function DaterangepickerComponent_div_7_table_2_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 29)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r79.locale.weekLabel);
} }
function DaterangepickerComponent_div_7_table_2_th_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const dayofweek_r95 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r95);
} }
function DaterangepickerComponent_div_7_table_2_tr_15_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r96 = i0.ɵɵnextContext().$implicit;
    const ctx_r97 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r97.calendarVariables.right.calendar[row_r96][0].week());
} }
function DaterangepickerComponent_div_7_table_2_tr_15_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r96 = i0.ɵɵnextContext().$implicit;
    const ctx_r98 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r98.calendarVariables.right.calendar[row_r96][0].isoWeek());
} }
function DaterangepickerComponent_div_7_table_2_tr_15_td_3_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("keydown.enter", function DaterangepickerComponent_div_7_table_2_tr_15_td_3_Template_td_keydown_enter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r104); const col_r102 = restoredCtx.$implicit; const row_r96 = i0.ɵɵnextContext().$implicit; const ctx_r103 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r103.clickDate($event, ctx_r103.sideEnum.right, row_r96, col_r102)); })("click", function DaterangepickerComponent_div_7_table_2_tr_15_td_3_Template_td_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r104); const col_r102 = restoredCtx.$implicit; const row_r96 = i0.ɵɵnextContext().$implicit; const ctx_r106 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r106.clickDate($event, ctx_r106.sideEnum.right, row_r96, col_r102)); })("mouseenter", function DaterangepickerComponent_div_7_table_2_tr_15_td_3_Template_td_mouseenter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r104); const col_r102 = restoredCtx.$implicit; const row_r96 = i0.ɵɵnextContext().$implicit; const ctx_r108 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r108.hoverDate($event, ctx_r108.sideEnum.right, row_r96, col_r102)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r102 = ctx.$implicit;
    const row_r96 = i0.ɵɵnextContext().$implicit;
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r99.calendarVariables.right.classes[row_r96][col_r102]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r99.calendarVariables.right.calendar[row_r96][col_r102].date());
} }
function DaterangepickerComponent_div_7_table_2_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 30);
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_7_table_2_tr_15_td_1_Template, 3, 1, "td", 31);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_7_table_2_tr_15_td_2_Template, 3, 1, "td", 31);
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_7_table_2_tr_15_td_3_Template, 3, 3, "td", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r96 = ctx.$implicit;
    const ctx_r81 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r81.calendarVariables.right.classes[row_r96].classList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.showWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r81.calendarVariables.right.calCols);
} }
function DaterangepickerComponent_div_7_table_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 13)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_7_table_2_th_3_Template, 1, 0, "th", 14);
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_7_table_2_ng_container_4_Template, 3, 3, "ng-container", 14);
    i0.ɵɵtemplate(5, DaterangepickerComponent_div_7_table_2_ng_container_5_Template, 2, 0, "ng-container", 14);
    i0.ɵɵelementStart(6, "th", 50);
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_7_table_2_ng_container_7_Template, 9, 4, "ng-container", 14);
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_7_table_2_ng_container_8_Template, 2, 2, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_7_table_2_ng_container_9_Template, 3, 3, "ng-container", 14);
    i0.ɵɵtemplate(10, DaterangepickerComponent_div_7_table_2_ng_container_10_Template, 2, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 16);
    i0.ɵɵtemplate(12, DaterangepickerComponent_div_7_table_2_th_12_Template, 3, 1, "th", 17);
    i0.ɵɵtemplate(13, DaterangepickerComponent_div_7_table_2_th_13_Template, 3, 1, "th", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "tbody", 51);
    i0.ɵɵtemplate(15, DaterangepickerComponent_div_7_table_2_tr_15_Template, 4, 5, "tr", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r70.showWeekNumbers || ctx_r70.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r70.calendarVariables.right.minDate || ctx_r70.calendarVariables.right.minDate.isBefore(ctx_r70.calendarVariables.right.calendar.firstDay)) && !ctx_r70.linkedCalendars);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((!ctx_r70.calendarVariables.right.minDate || ctx_r70.calendarVariables.right.minDate.isBefore(ctx_r70.calendarVariables.right.calendar.firstDay)) && !ctx_r70.linkedCalendars));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r70.showDropdowns && ctx_r70.calendarVariables.right.dropdowns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r70.showDropdowns || !ctx_r70.calendarVariables.right.dropdowns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r70.calendarVariables.right.maxDate || ctx_r70.calendarVariables.right.maxDate.isAfter(ctx_r70.calendarVariables.right.calendar.lastDay) && (!ctx_r70.linkedCalendars || ctx_r70.singleDatePicker || true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(!ctx_r70.calendarVariables.right.maxDate || ctx_r70.calendarVariables.right.maxDate.isAfter(ctx_r70.calendarVariables.right.calendar.lastDay) && (!ctx_r70.linkedCalendars || ctx_r70.singleDatePicker || true)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r70.showWeekNumbers || ctx_r70.showISOWeekNumbers);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r70.locale.daysOfWeek);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r70.calendarVariables.right.calRows);
} }
function DaterangepickerComponent_div_7_div_3_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r115 = ctx.$implicit;
    const ctx_r111 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r115)("disabled", ctx_r111.timepickerVariables.right.disabledHours.indexOf(i_r115) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i_r115);
} }
function DaterangepickerComponent_div_7_div_3_option_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r116 = ctx.$implicit;
    const index_r117 = ctx.index;
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r116)("disabled", ctx_r112.timepickerVariables.right.disabledMinutes.indexOf(i_r116) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r112.timepickerVariables.right.minutesLabel[index_r117], "");
} }
function DaterangepickerComponent_div_7_div_3_select_12_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r119 = ctx.$implicit;
    const index_r120 = ctx.index;
    const ctx_r118 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r119)("disabled", ctx_r118.timepickerVariables.right.disabledSeconds.indexOf(i_r119) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r118.timepickerVariables.right.secondsLabel[index_r120], "");
} }
function DaterangepickerComponent_div_7_div_3_select_12_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 45);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_7_div_3_select_12_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r122); const ctx_r121 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r121.timepickerVariables.right.selectedSecond = $event); })("ngModelChange", function DaterangepickerComponent_div_7_div_3_select_12_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r122); const ctx_r123 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r123.timeChanged($event, ctx_r123.sideEnum.right)); });
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_7_div_3_select_12_option_1_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", !ctx_r113.startDate)("ngModel", ctx_r113.timepickerVariables.right.selectedSecond);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r113.timepickerVariables.right.seconds);
} }
function DaterangepickerComponent_div_7_div_3_select_16_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 46);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_7_div_3_select_16_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r124 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r124.timepickerVariables.right.ampmModel = $event); })("ngModelChange", function DaterangepickerComponent_div_7_div_3_select_16_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r125); const ctx_r126 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r126.timeChanged($event, ctx_r126.sideEnum.right)); });
    i0.ɵɵelementStart(1, "option", 47);
    i0.ɵɵtext(2, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "option", 48);
    i0.ɵɵtext(4, "PM");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngModel", ctx_r114.timepickerVariables.right.ampmModel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r114.timepickerVariables.right.amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r114.timepickerVariables.right.pmDisabled);
} }
function DaterangepickerComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r128 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "select", 52);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_7_div_3_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r127 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r127.timepickerVariables.right.selectedHour = $event); })("ngModelChange", function DaterangepickerComponent_div_7_div_3_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r129 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r129.timeChanged($event, ctx_r129.sideEnum.right)); });
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_7_div_3_option_3_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 40)(5, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 36)(7, "select", 39);
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_7_div_3_Template_select_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r130 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r130.timepickerVariables.right.selectedMinute = $event); })("ngModelChange", function DaterangepickerComponent_div_7_div_3_Template_select_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r131 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r131.timeChanged($event, ctx_r131.sideEnum.right)); });
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_7_div_3_option_8_Template, 2, 3, "option", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "span", 40)(10, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 36);
    i0.ɵɵtemplate(12, DaterangepickerComponent_div_7_div_3_select_12_Template, 2, 3, "select", 42);
    i0.ɵɵelement(13, "span", 40)(14, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 36);
    i0.ɵɵtemplate(16, DaterangepickerComponent_div_7_div_3_select_16_Template, 5, 3, "select", 43);
    i0.ɵɵelement(17, "span", 40)(18, "span", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r71.startDate)("ngModel", ctx_r71.timepickerVariables.right.selectedHour);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r71.timepickerVariables.right.hours);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r71.startDate)("ngModel", ctx_r71.timepickerVariables.right.selectedMinute);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r71.timepickerVariables.right.minutes);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r71.timePickerSeconds);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r71.timePicker24Hour);
} }
function DaterangepickerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49)(1, "div", 10);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_7_table_2_Template, 16, 10, "table", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_7_div_3_Template, 19, 8, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.calendarVariables);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.timePicker);
} }
function DaterangepickerComponent_div_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 58);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_8_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r135); const ctx_r134 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r134.clear()); });
    i0.ɵɵtext(1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 59);
    i0.ɵɵelement(3, "path", 60);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r132.locale.clearLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r132.locale.clearLabel, " ");
} }
function DaterangepickerComponent_div_8_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r137 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 61);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_8_button_3_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r137); const ctx_r136 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r136.clickCancel($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r133 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r133.locale.cancelLabel);
} }
function DaterangepickerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r139 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53)(1, "div", 54);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_8_button_2_Template, 4, 2, "button", 55);
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_8_button_3_Template, 2, 1, "button", 56);
    i0.ɵɵelementStart(4, "button", 57);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_8_Template_button_click_4_listener($event) { i0.ɵɵrestoreView(_r139); const ctx_r138 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r138.clickApply($event)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.showClearButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showCancel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.applyBtn.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.locale.applyLabel);
} }
const _c3$q = function (a0, a1) { return { "shown": a0, "hidden": a1 }; };
const _c4$l = function (a0, a1, a2, a3, a4, a5, a6) { return { ltr: a0, rtl: a1, "shown": a2, "hidden": a3, "inline": a4, "double": a5, "show-ranges": a6 }; };
var SideEnum;
(function (SideEnum) {
    SideEnum["left"] = "left";
    SideEnum["right"] = "right";
})(SideEnum || (SideEnum = {}));
class DaterangepickerComponent {
    set locale(value) {
        this._locale = { ...this._localeService.config, ...value };
    }
    get locale() {
        return this._locale;
    }
    set ranges(value) {
        this._ranges = value;
        this.renderRanges();
    }
    get ranges() {
        return this._ranges;
    }
    constructor(el, _ref, _localeService) {
        this.el = el;
        this._ref = _ref;
        this._localeService = _localeService;
        this._old = { start: null, end: null };
        this.calendarVariables = { left: {}, right: {} };
        this.tooltiptext = []; // for storing tooltiptext
        this.timepickerVariables = { left: {}, right: {} };
        this.daterangepicker = { start: new UntypedFormControl(), end: new UntypedFormControl() };
        this.applyBtn = { disabled: false };
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.dateLimit = null;
        /**
         * used in template for compile time support of enum values.
         */
        this.sideEnum = SideEnum;
        this.minDate = null;
        this.maxDate = null;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.linkedCalendars = false;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.maxSpan = false;
        this.lockStartDate = false;
        /**
         * timepicker variables
         */
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        /**
         *  end of timepicker variables
         */
        this.showClearButton = false;
        this.firstMonthDayClass = null;
        this.lastMonthDayClass = null;
        this.emptyWeekRowClass = null;
        this.emptyWeekColumnClass = null;
        this.firstDayOfNextMonthClass = null;
        this.lastDayOfPreviousMonthClass = null;
        this._locale = {};
        // custom ranges
        this._ranges = {};
        this.showCancel = false;
        this.keepCalendarOpeningWithRange = false;
        this.showRangeLabelOnInput = false;
        this.customRangeDirection = false;
        this.rangesArray = [];
        // some state information
        this.isShown = false;
        this.inline = true;
        this.leftCalendar = {};
        this.rightCalendar = {};
        this.showCalInRanges = false;
        this.nowHoveredDate = null;
        this.pickingDate = false;
        this.options = {}; // should get some opt from user
        this.closeOnAutoApply = true;
        this.choosedDate = new EventEmitter();
        this.rangeClicked = new EventEmitter();
        this.datesUpdated = new EventEmitter();
        this.startDateChanged = new EventEmitter();
        this.endDateChanged = new EventEmitter();
        this.escapeClick = new EventEmitter();
    }
    ngOnInit() {
        this._buildLocale();
        const daysOfWeek = [...this.locale.daysOfWeek];
        this.locale.firstDay = this.locale.firstDay % 7;
        if (this.locale.firstDay !== 0) {
            let iterator = this.locale.firstDay;
            while (iterator > 0) {
                daysOfWeek.push(daysOfWeek.shift());
                iterator--;
            }
        }
        this.locale.daysOfWeek = daysOfWeek;
        if (this.inline) {
            this._old.start = this.startDate.clone();
            this._old.end = this.endDate.clone();
        }
        if (this.startDate && this.timePicker) {
            this.setStartDate(this.startDate);
            this.renderTimePicker(SideEnum.left);
        }
        if (this.endDate && this.timePicker) {
            this.setEndDate(this.endDate);
            this.renderTimePicker(SideEnum.right);
        }
        this.updateMonthsInView();
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
        this.renderRanges();
    }
    renderRanges() {
        this.rangesArray = [];
        let start, end;
        if (typeof this.ranges === 'object') {
            for (const range in this.ranges) {
                if (this.ranges[range]) {
                    if (typeof this.ranges[range][0] === 'string') {
                        start = moment(this.ranges[range][0], this.locale.format);
                    }
                    else {
                        start = moment(this.ranges[range][0]);
                    }
                    if (typeof this.ranges[range][1] === 'string') {
                        end = moment(this.ranges[range][1], this.locale.format);
                    }
                    else {
                        end = moment(this.ranges[range][1]);
                    }
                    // If the start or end date exceed those allowed by the minDate or maxSpan
                    // options, shorten the range to the allowable period.
                    if (this.minDate && start.isBefore(this.minDate)) {
                        start = this.minDate.clone();
                    }
                    let maxDate = this.maxDate;
                    if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) {
                        maxDate = start.clone().add(this.maxSpan);
                    }
                    if (maxDate && end.isAfter(maxDate)) {
                        end = maxDate.clone();
                    }
                    // If the end of the range is before the minimum or the start of the range is
                    // after the maximum, don't display this range option at all.
                    if ((this.minDate && end.isBefore(this.minDate, this.timePicker ? 'minute' : 'day'))
                        || (maxDate && start.isAfter(maxDate, this.timePicker ? 'minute' : 'day'))) {
                        continue;
                    }
                    // Support unicode chars in the range names.
                    const elem = document.createElement('textarea');
                    elem.innerHTML = range;
                    const rangeHtml = elem.value;
                    this.ranges[rangeHtml] = [start, end];
                }
            }
            for (const range in this.ranges) {
                if (this.ranges[range]) {
                    this.rangesArray.push(range);
                }
            }
            if (this.showCustomRangeLabel) {
                this.rangesArray.push(this.locale.customRangeLabel);
            }
            this.showCalInRanges = (!this.rangesArray.length) || this.alwaysShowCalendars;
            if (!this.timePicker) {
                this.startDate = this.startDate.startOf('day');
                this.endDate = this.endDate.endOf('day');
            }
        }
    }
    renderTimePicker(side) {
        let selected, minDate;
        const maxDate = this.maxDate;
        if (side === SideEnum.left) {
            selected = this.startDate.clone(),
                minDate = this.minDate;
        }
        else if (side === SideEnum.right && this.endDate) {
            selected = this.endDate.clone(),
                minDate = this.startDate;
        }
        else if (side === SideEnum.right && !this.endDate) {
            // don't have an end date, use the start date then put the selected time for the right side as the time
            selected = this._getDateWithTime(this.startDate, SideEnum.right);
            if (selected.isBefore(this.startDate)) {
                selected = this.startDate.clone(); //set it back to the start date the time was backwards
            }
            minDate = this.startDate;
        }
        const start = this.timePicker24Hour ? 0 : 1;
        const end = this.timePicker24Hour ? 23 : 12;
        this.timepickerVariables[side] = {
            hours: [],
            minutes: [],
            minutesLabel: [],
            seconds: [],
            secondsLabel: [],
            disabledHours: [],
            disabledMinutes: [],
            disabledSeconds: [],
            selectedHour: 0,
            selectedMinute: 0,
            selectedSecond: 0,
        };
        // generate hours
        for (let i = start; i <= end; i++) {
            let i_in_24 = i;
            if (!this.timePicker24Hour) {
                i_in_24 = selected.hour() >= 12 ? (i === 12 ? 12 : i + 12) : (i === 12 ? 0 : i);
            }
            const time = selected.clone().hour(i_in_24);
            let disabled = false;
            if (minDate && time.minute(59).isBefore(minDate)) {
                disabled = true;
            }
            if (maxDate && time.minute(0).isAfter(maxDate)) {
                disabled = true;
            }
            this.timepickerVariables[side].hours.push(i);
            if (i_in_24 === selected.hour() && !disabled) {
                this.timepickerVariables[side].selectedHour = i;
            }
            else if (disabled) {
                this.timepickerVariables[side].disabledHours.push(i);
            }
        }
        // generate minutes
        for (let i = 0; i < 60; i += this.timePickerIncrement) {
            const padded = i < 10 ? '0' + i : i;
            const time = selected.clone().minute(i);
            let disabled = false;
            if (minDate && time.second(59).isBefore(minDate)) {
                disabled = true;
            }
            if (maxDate && time.second(0).isAfter(maxDate)) {
                disabled = true;
            }
            this.timepickerVariables[side].minutes.push(i);
            this.timepickerVariables[side].minutesLabel.push(padded);
            if (selected.minute() === i && !disabled) {
                this.timepickerVariables[side].selectedMinute = i;
            }
            else if (disabled) {
                this.timepickerVariables[side].disabledMinutes.push(i);
            }
        }
        // generate seconds
        if (this.timePickerSeconds) {
            for (let i = 0; i < 60; i++) {
                const padded = i < 10 ? '0' + i : i;
                const time = selected.clone().second(i);
                let disabled = false;
                if (minDate && time.isBefore(minDate)) {
                    disabled = true;
                }
                if (maxDate && time.isAfter(maxDate)) {
                    disabled = true;
                }
                this.timepickerVariables[side].seconds.push(i);
                this.timepickerVariables[side].secondsLabel.push(padded);
                if (selected.second() === i && !disabled) {
                    this.timepickerVariables[side].selectedSecond = i;
                }
                else if (disabled) {
                    this.timepickerVariables[side].disabledSeconds.push(i);
                }
            }
        }
        // generate AM/PM
        if (!this.timePicker24Hour) {
            const am_html = '';
            const pm_html = '';
            if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) {
                this.timepickerVariables[side].amDisabled = true;
            }
            if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) {
                this.timepickerVariables[side].pmDisabled = true;
            }
            if (selected.hour() >= 12) {
                this.timepickerVariables[side].ampmModel = 'PM';
            }
            else {
                this.timepickerVariables[side].ampmModel = 'AM';
            }
        }
        this.timepickerVariables[side].selected = selected;
    }
    renderCalendar(side) {
        const mainCalendar = (side === SideEnum.left) ? this.leftCalendar : this.rightCalendar;
        const month = mainCalendar.month.month();
        const year = mainCalendar.month.year();
        const hour = mainCalendar.month.hour();
        const minute = mainCalendar.month.minute();
        const second = mainCalendar.month.second();
        const daysInMonth = moment([year, month]).daysInMonth();
        const firstDay = moment([year, month, 1]);
        const lastDay = moment([year, month, daysInMonth]);
        const lastMonth = moment(firstDay).subtract(1, 'month').month();
        const lastYear = moment(firstDay).subtract(1, 'month').year();
        const daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
        const dayOfWeek = firstDay.day();
        // initialize a 6 rows x 7 columns array for the calendar
        const calendar = [];
        calendar.firstDay = firstDay;
        calendar.lastDay = lastDay;
        for (let i = 0; i < 6; i++) {
            calendar[i] = [];
        }
        // populate the calendar with date objects
        let startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
        if (startDay > daysInLastMonth) {
            startDay -= 7;
        }
        if (dayOfWeek === this.locale.firstDay) {
            startDay = daysInLastMonth - 6;
        }
        let curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
        for (let i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
            if (i > 0 && col % 7 === 0) {
                col = 0;
                row++;
            }
            calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
            curDate.hour(12);
            if (this.minDate && calendar[row][col].format('YYYY-MM-DD') === this.minDate.format('YYYY-MM-DD') &&
                calendar[row][col].isBefore(this.minDate) && side === 'left') {
                calendar[row][col] = this.minDate.clone();
            }
            if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') === this.maxDate.format('YYYY-MM-DD') &&
                calendar[row][col].isAfter(this.maxDate) && side === 'right') {
                calendar[row][col] = this.maxDate.clone();
            }
        }
        // make the calendar object available to hoverDate/clickDate
        if (side === SideEnum.left) {
            this.leftCalendar.calendar = calendar;
        }
        else {
            this.rightCalendar.calendar = calendar;
        }
        //
        // Display the calendar
        //
        const minDate = side === 'left' ? this.minDate : this.startDate;
        let maxDate = this.maxDate;
        // adjust maxDate to reflect the dateLimit setting in order to
        // grey out end dates beyond the dateLimit
        if (this.endDate === null && this.dateLimit) {
            const maxLimit = this.startDate.clone().add(this.dateLimit, 'day').endOf('day');
            if (!maxDate || maxLimit.isBefore(maxDate)) {
                maxDate = maxLimit;
            }
        }
        this.calendarVariables[side] = {
            month: month,
            year: year,
            hour: hour,
            minute: minute,
            second: second,
            daysInMonth: daysInMonth,
            firstDay: firstDay,
            lastDay: lastDay,
            lastMonth: lastMonth,
            lastYear: lastYear,
            daysInLastMonth: daysInLastMonth,
            dayOfWeek: dayOfWeek,
            // other vars
            calRows: Array.from(Array(6).keys()),
            calCols: Array.from(Array(7).keys()),
            classes: {},
            minDate: minDate,
            maxDate: maxDate,
            calendar: calendar
        };
        if (this.showDropdowns) {
            const currentMonth = calendar[1][1].month();
            const currentYear = calendar[1][1].year();
            const realCurrentYear = moment().year();
            const maxYear = (maxDate && maxDate.year()) || (realCurrentYear + 5);
            const minYear = (minDate && minDate.year()) || (realCurrentYear - 50);
            const inMinYear = currentYear === minYear;
            const inMaxYear = currentYear === maxYear;
            const years = [];
            for (let y = minYear; y <= maxYear; y++) {
                years.push(y);
            }
            this.calendarVariables[side].dropdowns = {
                currentMonth: currentMonth,
                currentYear: currentYear,
                maxYear: maxYear,
                minYear: minYear,
                inMinYear: inMinYear,
                inMaxYear: inMaxYear,
                monthArrays: Array.from(Array(12).keys()),
                yearArrays: years
            };
        }
        this._buildCells(calendar, side);
    }
    setStartDate(startDate) {
        if (typeof startDate === 'string') {
            this.startDate = moment(startDate, this.locale.format);
        }
        if (typeof startDate === 'object') {
            this.pickingDate = true;
            this.startDate = moment(startDate);
        }
        if (!this.timePicker) {
            this.pickingDate = true;
            this.startDate = this.startDate.startOf('day');
        }
        if (this.timePicker && this.timePickerIncrement) {
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (this.minDate && this.startDate.isBefore(this.minDate)) {
            this.startDate = this.minDate.clone();
            if (this.timePicker && this.timePickerIncrement) {
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
        }
        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
            this.startDate = this.maxDate.clone();
            if (this.timePicker && this.timePickerIncrement) {
                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
        }
        if (!this.isShown) {
            this.updateElement();
        }
        this.startDateChanged.emit({ startDate: this.startDate });
        this.updateMonthsInView();
    }
    setEndDate(endDate) {
        if (typeof endDate === 'string') {
            this.endDate = moment(endDate, this.locale.format);
        }
        if (typeof endDate === 'object') {
            this.pickingDate = false;
            this.endDate = moment(endDate);
        }
        if (!this.timePicker) {
            this.pickingDate = false;
            this.endDate = this.endDate.add(1, 'd').startOf('day').subtract(1, 'second');
        }
        if (this.timePicker && this.timePickerIncrement) {
            this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        if (this.endDate.isBefore(this.startDate)) {
            this.endDate = this.startDate.clone();
        }
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) {
            this.endDate = this.maxDate.clone();
        }
        if (this.dateLimit && this.startDate.clone().add(this.dateLimit, 'day').isBefore(this.endDate)) {
            this.endDate = this.startDate.clone().add(this.dateLimit, 'day');
        }
        if (!this.isShown) {
            // this.updateElement();
        }
        this.endDateChanged.emit({ endDate: this.endDate });
        this.updateMonthsInView();
    }
    isInvalidDate(date) {
        return false;
    }
    isCustomDate(date) {
        return false;
    }
    isTooltipDate(date) {
        return null;
    }
    updateView() {
        if (this.timePicker) {
            this.renderTimePicker(SideEnum.left);
            this.renderTimePicker(SideEnum.right);
        }
        this.updateMonthsInView();
        this.updateCalendars();
    }
    updateMonthsInView() {
        if (this.endDate) {
            // if both dates are visible already, do nothing
            if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                ((this.startDate && this.leftCalendar && this.startDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM')) ||
                    (this.startDate && this.rightCalendar && this.startDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM')))
                &&
                    (this.endDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') ||
                        this.endDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
                return;
            }
            if (this.startDate) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() !== this.startDate.month() ||
                    this.endDate.year() !== this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                }
                else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
        }
        else {
            if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM') &&
                this.rightCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM')) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
        }
        if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
            this.rightCalendar.month = this.maxDate.clone().date(2);
            this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
        }
    }
    /**
     *  This is responsible for updating the calendars
     */
    updateCalendars() {
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
        if (this.endDate === null) {
            return;
        }
        this.calculateChosenLabel();
    }
    updateElement() {
        const format = this.locale.displayFormat ? this.locale.displayFormat : this.locale.format;
        if (!this.singleDatePicker && this.autoUpdateInput) {
            if (this.startDate && this.endDate) {
                // if we use ranges and should show range label on input
                if (this.rangesArray.length && this.showRangeLabelOnInput === true && this.chosenRange &&
                    this.locale.customRangeLabel !== this.chosenRange) {
                    this.chosenLabel = this.chosenRange;
                }
                else {
                    this.chosenLabel = this.startDate.format(format) +
                        this.locale.separator + this.endDate.format(format);
                }
            }
        }
        else if (this.autoUpdateInput) {
            this.chosenLabel = this.startDate.format(format);
        }
    }
    remove() {
        this.isShown = false;
    }
    /**
     * this should calculate the label
     */
    calculateChosenLabel() {
        if (!this.locale || !this.locale.separator) {
            this._buildLocale();
        }
        let customRange = true;
        let i = 0;
        if (this.rangesArray.length > 0) {
            for (const range in this.ranges) {
                if (this.ranges[range]) {
                    if (this.timePicker) {
                        const format = this.timePickerSeconds ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm';
                        // ignore times when comparing dates if time picker seconds is not enabled
                        if (this.startDate.format(format) === this.ranges[range][0].format(format)
                            && this.endDate.format(format) === this.ranges[range][1].format(format)) {
                            customRange = false;
                            this.chosenRange = this.rangesArray[i];
                            break;
                        }
                    }
                    else {
                        // ignore times when comparing dates if time picker is not enabled
                        if (this.startDate.format('YYYY-MM-DD') === this.ranges[range][0].format('YYYY-MM-DD')
                            && this.endDate.format('YYYY-MM-DD') === this.ranges[range][1].format('YYYY-MM-DD')) {
                            customRange = false;
                            this.chosenRange = this.rangesArray[i];
                            break;
                        }
                    }
                    i++;
                }
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenRange = this.locale.customRangeLabel;
                }
                else {
                    this.chosenRange = null;
                }
                // if custom label: show calendar
                this.showCalInRanges = true;
            }
        }
        this.updateElement();
    }
    clickApply(e) {
        if (!this.singleDatePicker && this.startDate && !this.endDate) {
            this.endDate = this._getDateWithTime(this.startDate, SideEnum.right);
            this.calculateChosenLabel();
        }
        if (this.isInvalidDate && this.startDate && this.endDate) {
            // get if there are invalid date between range
            const d = this.startDate.clone();
            while (d.isBefore(this.endDate)) {
                if (this.isInvalidDate(d)) {
                    this.endDate = d.subtract(1, 'days');
                    this.calculateChosenLabel();
                    break;
                }
                d.add(1, 'days');
            }
        }
        if (this.chosenLabel) {
            this.choosedDate.emit({ chosenLabel: this.chosenLabel, startDate: this.startDate, endDate: this.endDate });
        }
        this.datesUpdated.emit({ startDate: this.startDate, endDate: this.endDate });
        if (e || (this.closeOnAutoApply && !e)) {
            this.hide();
        }
    }
    clickCancel(e) {
        this.startDate = this._old.start;
        this.endDate = this._old.end;
        if (this.inline) {
            this.updateView();
        }
        this.hide();
    }
    /**
     * called when month is changed
     * @param monthEvent get value in event.target.value
     * @param side left or right
     */
    monthChanged(monthEvent, side) {
        const year = this.calendarVariables[side].dropdowns.currentYear;
        const month = parseInt(monthEvent.target.value, 10);
        this.monthOrYearChanged(month, year, side);
    }
    /**
     * called when year is changed
     * @param yearEvent get value in event.target.value
     * @param side left or right
     */
    yearChanged(yearEvent, side) {
        const month = this.calendarVariables[side].dropdowns.currentMonth;
        const year = parseInt(yearEvent.target.value, 10);
        this.monthOrYearChanged(month, year, side);
    }
    /**
     * called when time is changed
     * @param timeEvent  an event
     * @param side left or right
     */
    timeChanged(timeEvent, side) {
        let hour = parseInt(this.timepickerVariables[side].selectedHour, 10);
        const minute = parseInt(this.timepickerVariables[side].selectedMinute, 10);
        const second = this.timePickerSeconds ? parseInt(this.timepickerVariables[side].selectedSecond, 10) : 0;
        if (!this.timePicker24Hour) {
            const ampm = this.timepickerVariables[side].ampmModel;
            if (ampm === 'PM' && hour < 12) {
                hour += 12;
            }
            if (ampm === 'AM' && hour === 12) {
                hour = 0;
            }
        }
        if (side === SideEnum.left) {
            const start = this.startDate.clone();
            start.hour(hour);
            start.minute(minute);
            start.second(second);
            this.setStartDate(start);
            if (this.singleDatePicker) {
                this.endDate = this.startDate.clone();
            }
            else if (this.endDate && this.endDate.format('YYYY-MM-DD') === start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                this.setEndDate(start.clone());
            }
            else if (!this.endDate && this.timePicker) {
                const startClone = this._getDateWithTime(start, SideEnum.right);
                if (startClone.isBefore(start)) {
                    this.timepickerVariables[SideEnum.right].selectedHour = hour;
                    this.timepickerVariables[SideEnum.right].selectedMinute = minute;
                    this.timepickerVariables[SideEnum.right].selectedSecond = second;
                }
            }
        }
        else if (this.endDate) {
            const end = this.endDate.clone();
            end.hour(hour);
            end.minute(minute);
            end.second(second);
            this.setEndDate(end);
        }
        // update the calendars so all clickable dates reflect the new time component
        this.updateCalendars();
        // re-render the time pickers because changing one selection can affect what's enabled in another
        this.renderTimePicker(SideEnum.left);
        this.renderTimePicker(SideEnum.right);
        if (this.autoApply) {
            this.clickApply();
        }
    }
    /**
     *  call when month or year changed
     * @param month month number 0 -11
     * @param year year eg: 1995
     * @param side left or right
     */
    monthOrYearChanged(month, year, side) {
        const isLeft = side === SideEnum.left;
        if (!isLeft) {
            if (year < this.startDate.year() || (year === this.startDate.year() && month < this.startDate.month())) {
                month = this.startDate.month();
                year = this.startDate.year();
            }
        }
        if (this.minDate) {
            if (year < this.minDate.year() || (year === this.minDate.year() && month < this.minDate.month())) {
                month = this.minDate.month();
                year = this.minDate.year();
            }
        }
        if (this.maxDate) {
            if (year > this.maxDate.year() || (year === this.maxDate.year() && month > this.maxDate.month())) {
                month = this.maxDate.month();
                year = this.maxDate.year();
            }
        }
        this.calendarVariables[side].dropdowns.currentYear = year;
        this.calendarVariables[side].dropdowns.currentMonth = month;
        if (isLeft) {
            this.leftCalendar.month.month(month).year(year);
            if (this.linkedCalendars) {
                this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            }
        }
        else {
            this.rightCalendar.month.month(month).year(year);
            if (this.linkedCalendars) {
                this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
        }
        this.updateCalendars();
    }
    /**
     * Click on previous month
     * @param side left or right calendar
     */
    clickPrev(side) {
        if (side === SideEnum.left) {
            this.leftCalendar.month.subtract(1, 'month');
            if (this.linkedCalendars) {
                this.rightCalendar.month.subtract(1, 'month');
            }
        }
        else {
            this.rightCalendar.month.subtract(1, 'month');
        }
        this.updateCalendars();
    }
    /**
     * Click on next month
     * @param side left or right calendar
     */
    clickNext(side) {
        if (side === SideEnum.left) {
            this.leftCalendar.month.add(1, 'month');
        }
        else {
            this.rightCalendar.month.add(1, 'month');
            if (this.linkedCalendars) {
                this.leftCalendar.month.add(1, 'month');
            }
        }
        this.updateCalendars();
    }
    /**
     * When hovering a date
     * @param e event: get value by e.target.value
     * @param side left or right
     * @param row row position of the current date clicked
     * @param col col position of the current date clicked
     */
    hoverDate(e, side, row, col) {
        const leftCalDate = this.calendarVariables.left.calendar[row][col];
        const rightCalDate = this.calendarVariables.right.calendar[row][col];
        if (this.pickingDate) {
            this.nowHoveredDate = side === SideEnum.left ? leftCalDate : rightCalDate;
            this.renderCalendar(SideEnum.left);
            this.renderCalendar(SideEnum.right);
        }
        const tooltip = side === SideEnum.left ? this.tooltiptext[leftCalDate] : this.tooltiptext[rightCalDate];
        if (tooltip.length > 0) {
            e.target.setAttribute('title', tooltip);
        }
    }
    /**
     * When selecting a date
     * @param e event: get value by e.target.value
     * @param side left or right
     * @param row row position of the current date clicked
     * @param col col position of the current date clicked
     */
    clickDate(e, side, row, col) {
        if (e.target.tagName === 'TD') {
            if (!e.target.classList.contains('available')) {
                return;
            }
        }
        else if (e.target.tagName === 'SPAN') {
            if (!e.target.parentElement.classList.contains('available')) {
                return;
            }
        }
        if (this.rangesArray.length) {
            this.chosenRange = this.locale.customRangeLabel;
        }
        let date = side === SideEnum.left ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
        if ((this.endDate || (date.isBefore(this.startDate, 'day')
            && this.customRangeDirection === false)) && this.lockStartDate === false) { // picking start
            if (this.timePicker) {
                date = this._getDateWithTime(date, SideEnum.left);
            }
            this.endDate = null;
            this.setStartDate(date.clone());
        }
        else if (!this.endDate && date.isBefore(this.startDate) && this.customRangeDirection === false) {
            // special case: clicking the same date for start/end,
            // but the time of the end date is before the start date
            this.setEndDate(this.startDate.clone());
        }
        else { // picking end
            if (this.timePicker) {
                date = this._getDateWithTime(date, SideEnum.right);
            }
            if (date.isBefore(this.startDate, 'day') === true && this.customRangeDirection === true) {
                this.setEndDate(this.startDate);
                this.setStartDate(date.clone());
            }
            else {
                this.setEndDate(date.clone());
            }
            if (this.autoApply) {
                this.calculateChosenLabel();
            }
        }
        if (this.singleDatePicker) {
            this.setEndDate(this.startDate);
            this.updateElement();
            if (this.autoApply) {
                this.clickApply();
            }
        }
        this.updateView();
        if (this.autoApply && this.startDate && this.endDate) {
            this.clickApply();
        }
        // This is to cancel the blur event handler if the mouse was in one of the inputs
        e.stopPropagation();
    }
    /**
     *  Click on the custom range
     * @param e: Event
     * @param label
     */
    clickRange(e, label) {
        this.chosenRange = label;
        if (label === this.locale.customRangeLabel) {
            this.isShown = true; // show calendars
            this.showCalInRanges = true;
        }
        else {
            const dates = this.ranges[label];
            this.startDate = dates[0].clone();
            this.endDate = dates[1].clone();
            if (this.showRangeLabelOnInput && label !== this.locale.customRangeLabel) {
                this.chosenLabel = label;
            }
            else {
                this.calculateChosenLabel();
            }
            this.showCalInRanges = (!this.rangesArray.length) || this.alwaysShowCalendars;
            if (!this.timePicker) {
                this.startDate.startOf('day');
                this.endDate.endOf('day');
            }
            if (!this.alwaysShowCalendars) {
                this.isShown = false; // hide calendars
            }
            this.rangeClicked.emit({ label: label, dates: dates });
            if (!this.keepCalendarOpeningWithRange || this.autoApply) {
                this.clickApply();
            }
            else {
                if (!this.alwaysShowCalendars) {
                    return this.clickApply();
                }
                if (this.maxDate && this.maxDate.isSame(dates[0], 'month')) {
                    this.rightCalendar.month.month(dates[0].month());
                    this.rightCalendar.month.year(dates[0].year());
                    this.leftCalendar.month.month(dates[0].month() - 1);
                    this.leftCalendar.month.year(dates[1].year());
                }
                else {
                    this.leftCalendar.month.month(dates[0].month());
                    this.leftCalendar.month.year(dates[0].year());
                    // get the next year
                    const nextMonth = dates[0].clone().add(1, 'month');
                    this.rightCalendar.month.month(nextMonth.month());
                    this.rightCalendar.month.year(nextMonth.year());
                }
                this.updateCalendars();
                if (this.timePicker) {
                    this.renderTimePicker(SideEnum.left);
                    this.renderTimePicker(SideEnum.right);
                }
            }
        }
    }
    show(e) {
        if (this.isShown) {
            return;
        }
        this._old.start = this.startDate.clone();
        this._old.end = this.endDate.clone();
        this.isShown = true;
        if (this.isShown || this.inline) {
            var elm = document.getElementById("datePickerContainer");
            elm.classList.remove('hidden');
            elm.classList.add('shown');
        }
        this.updateView();
        this.pickerContainer.nativeElement.focus();
    }
    hide(e) {
        if (!this.isShown) {
            return;
        }
        // incomplete date selection, revert to last values
        if (!this.endDate) {
            if (this._old.start) {
                this.startDate = this._old.start.clone();
            }
            if (this._old.end) {
                this.endDate = this._old.end.clone();
            }
        }
        // if a new date range was selected, invoke the user callback function
        if (!this.startDate.isSame(this._old.start) || !this.endDate.isSame(this._old.end)) {
            // this.callback(this.startDate, this.endDate, this.chosenLabel);
        }
        // if picker is attached to a text input, update it
        this.updateElement();
        this.isShown = false;
        this._ref.detectChanges();
    }
    /**
     * handle click on all element in the component, useful for outside of click
     * @param e event
     */
    handleInternalClick(e) {
        e.stopPropagation();
    }
    /**
     * update the locale options
     * @param locale
     */
    updateLocale(locale) {
        for (const key in locale) {
            if (locale.hasOwnProperty(key)) {
                this.locale[key] = locale[key];
                if (key === 'customRangeLabel') {
                    this.renderRanges();
                }
            }
        }
    }
    /**
     *  clear the daterange picker
     */
    clear() {
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.choosedDate.emit({ chosenLabel: '', startDate: null, endDate: null });
        this.datesUpdated.emit({ startDate: null, endDate: null });
        this.hide();
    }
    /**
     * Find out if the selected range should be disabled if it doesn't
     * fit into minDate and maxDate limitations.
     */
    disableRange(range) {
        if (range === this.locale.customRangeLabel) {
            return false;
        }
        const rangeMarkers = this.ranges[range];
        const areBothBefore = rangeMarkers.every(date => {
            if (!this.minDate) {
                return false;
            }
            return date.isBefore(this.minDate);
        });
        const areBothAfter = rangeMarkers.every(date => {
            if (!this.maxDate) {
                return false;
            }
            return date.isAfter(this.maxDate);
        });
        return (areBothBefore || areBothAfter);
    }
    /**
     *
     * @param date the date to add time
     * @param side left or right
     */
    _getDateWithTime(date, side) {
        let hour = parseInt(this.timepickerVariables[side].selectedHour, 10);
        if (!this.timePicker24Hour) {
            const ampm = this.timepickerVariables[side].ampmModel;
            if (ampm === 'PM' && hour < 12) {
                hour += 12;
            }
            if (ampm === 'AM' && hour === 12) {
                hour = 0;
            }
        }
        const minute = parseInt(this.timepickerVariables[side].selectedMinute, 10);
        const second = this.timePickerSeconds ? parseInt(this.timepickerVariables[side].selectedSecond, 10) : 0;
        return date.clone().hour(hour).minute(minute).second(second);
    }
    /**
     *  build the locale config
     */
    _buildLocale() {
        this.locale = { ...this._localeService.config, ...this.locale };
        if (!this.locale.format) {
            if (this.timePicker) {
                this.locale.format = moment.localeData().longDateFormat('lll');
            }
            else {
                this.locale.format = moment.localeData().longDateFormat('L');
            }
        }
    }
    _buildCells(calendar, side) {
        for (let row = 0; row < 6; row++) {
            this.calendarVariables[side].classes[row] = {};
            const rowClasses = [];
            if (this.emptyWeekRowClass &&
                Array.from(Array(7).keys()).some(i => calendar[row][i].month() !== this.calendarVariables[side].month)) {
                rowClasses.push(this.emptyWeekRowClass);
            }
            for (let col = 0; col < 7; col++) {
                const classes = [];
                // empty week row class
                if (this.emptyWeekColumnClass) {
                    if (calendar[row][col].month() !== this.calendarVariables[side].month) {
                        classes.push(this.emptyWeekColumnClass);
                    }
                }
                // highlight today's date
                if (calendar[row][col].isSame(new Date(), 'day')) {
                    classes.push('today');
                }
                // highlight weekends
                if (calendar[row][col].isoWeekday() > 5) {
                    classes.push('weekend');
                }
                // grey out the dates in other months displayed at beginning and end of this calendar
                if (calendar[row][col].month() !== calendar[1][1].month()) {
                    classes.push('off');
                    // mark the last day of the previous month in this calendar
                    if (this.lastDayOfPreviousMonthClass && (calendar[row][col].month() < calendar[1][1].month() ||
                        calendar[1][1].month() === 0) && calendar[row][col].date() === this.calendarVariables[side].daysInLastMonth) {
                        classes.push(this.lastDayOfPreviousMonthClass);
                    }
                    // mark the first day of the next month in this calendar
                    if (this.firstDayOfNextMonthClass && (calendar[row][col].month() > calendar[1][1].month() ||
                        calendar[row][col].month() === 0) && calendar[row][col].date() === 1) {
                        classes.push(this.firstDayOfNextMonthClass);
                    }
                }
                // mark the first day of the current month with a custom class
                if (this.firstMonthDayClass && calendar[row][col].month() === calendar[1][1].month() &&
                    calendar[row][col].date() === calendar.firstDay.date()) {
                    classes.push(this.firstMonthDayClass);
                }
                // mark the last day of the current month with a custom class
                if (this.lastMonthDayClass && calendar[row][col].month() === calendar[1][1].month() &&
                    calendar[row][col].date() === calendar.lastDay.date()) {
                    classes.push(this.lastMonthDayClass);
                }
                // don't allow selection of dates before the minimum date
                if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) {
                    classes.push('off', 'disabled');
                }
                // don't allow selection of dates after the maximum date
                if (this.calendarVariables[side].maxDate && calendar[row][col].isAfter(this.calendarVariables[side].maxDate, 'day')) {
                    classes.push('off', 'disabled');
                }
                // don't allow selection of date if a custom function decides it's invalid
                if (this.isInvalidDate(calendar[row][col])) {
                    classes.push('off', 'disabled', 'invalid');
                }
                // highlight the currently selected start date
                if (this.startDate && calendar[row][col].format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD')) {
                    classes.push('active', 'start-date');
                }
                // highlight the currently selected end date
                if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD')) {
                    classes.push('active', 'end-date');
                }
                // highlight dates in-between the selected dates
                if (((this.nowHoveredDate != null && this.pickingDate) || this.endDate != null) &&
                    (calendar[row][col] > this.startDate &&
                        (calendar[row][col] < this.endDate || (calendar[row][col] < this.nowHoveredDate && this.pickingDate))) &&
                    (!classes.find(el => el === 'off'))) {
                    classes.push('in-range');
                }
                // apply custom classes for this date
                const isCustom = this.isCustomDate(calendar[row][col]);
                if (isCustom !== false) {
                    if (typeof isCustom === 'string') {
                        classes.push(isCustom);
                    }
                    else {
                        Array.prototype.push.apply(classes, isCustom);
                    }
                }
                // apply custom tooltip for this date
                const isTooltip = this.isTooltipDate(calendar[row][col]);
                if (isTooltip) {
                    if (typeof isTooltip === 'string') {
                        this.tooltiptext[calendar[row][col]] = isTooltip; // setting tooltiptext for custom date
                    }
                    else {
                        this.tooltiptext[calendar[row][col]] = 'Put the tooltip as the returned value of isTooltipDate';
                    }
                }
                else {
                    this.tooltiptext[calendar[row][col]] = '';
                }
                // store classes var
                let cname = '', disabled = false;
                for (let i = 0; i < classes.length; i++) {
                    cname += classes[i] + ' ';
                    if (classes[i] === 'disabled') {
                        disabled = true;
                    }
                }
                if (!disabled) {
                    cname += 'available';
                }
                this.calendarVariables[side].classes[row][col] = cname.replace(/^\s+|\s+$/g, '');
            }
            this.calendarVariables[side].classes[row].classList = rowClasses.join(' ');
        }
    }
    onEscape() {
        this.hide();
        this.escapeClick.emit();
    }
    static { this.ɵfac = function DaterangepickerComponent_Factory(t) { return new (t || DaterangepickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(LocaleService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DaterangepickerComponent, selectors: [["ngx-daterangepicker-material"]], viewQuery: function DaterangepickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1l, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pickerContainer = _t.first);
        } }, hostBindings: function DaterangepickerComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function DaterangepickerComponent_click_HostBindingHandler($event) { return ctx.handleInternalClick($event); });
        } }, inputs: { startDate: "startDate", endDate: "endDate", dateLimit: "dateLimit", minDate: "minDate", maxDate: "maxDate", autoApply: "autoApply", singleDatePicker: "singleDatePicker", showDropdowns: "showDropdowns", showWeekNumbers: "showWeekNumbers", showISOWeekNumbers: "showISOWeekNumbers", linkedCalendars: "linkedCalendars", autoUpdateInput: "autoUpdateInput", alwaysShowCalendars: "alwaysShowCalendars", maxSpan: "maxSpan", lockStartDate: "lockStartDate", timePicker: "timePicker", timePicker24Hour: "timePicker24Hour", timePickerIncrement: "timePickerIncrement", timePickerSeconds: "timePickerSeconds", showClearButton: "showClearButton", firstMonthDayClass: "firstMonthDayClass", lastMonthDayClass: "lastMonthDayClass", emptyWeekRowClass: "emptyWeekRowClass", emptyWeekColumnClass: "emptyWeekColumnClass", firstDayOfNextMonthClass: "firstDayOfNextMonthClass", lastDayOfPreviousMonthClass: "lastDayOfPreviousMonthClass", locale: "locale", ranges: "ranges", showCustomRangeLabel: "showCustomRangeLabel", showCancel: "showCancel", keepCalendarOpeningWithRange: "keepCalendarOpeningWithRange", showRangeLabelOnInput: "showRangeLabelOnInput", customRangeDirection: "customRangeDirection", drops: "drops", opens: "opens", closeOnAutoApply: "closeOnAutoApply", isInvalidDate: "isInvalidDate", isCustomDate: "isCustomDate", isTooltipDate: "isTooltipDate" }, outputs: { choosedDate: "choosedDate", rangeClicked: "rangeClicked", datesUpdated: "datesUpdated", startDateChanged: "startDateChanged", endDateChanged: "endDateChanged", escapeClick: "escapeClick" }, features: [i0.ɵɵProvidersFeature([{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => DaterangepickerComponent),
                    multi: true
                }])], decls: 10, vars: 23, consts: [["tabindex", "0", "aria-hidden", "true", 1, "daterangepicker-accessibility-dummy", 3, "ngClass", "focus"], ["tabindex", "0", "id", "datePickerContainer", 1, "md-drppicker", 3, "ngClass", "keydown.escape"], ["pickerContainer", ""], [1, "ranges"], [4, "ngFor", "ngForOf"], ["class", "calendar", 3, "ngClass", 4, "ngIf"], ["class", "calendar right", 4, "ngIf"], ["class", "buttons", 4, "ngIf"], ["type", "button", 3, "disabled", "ngClass", "click"], [1, "calendar", 3, "ngClass"], [1, "calendar-table"], ["class", "table-condensed", 4, "ngIf"], ["class", "calendar-time", 4, "ngIf"], [1, "table-condensed"], [4, "ngIf"], ["colspan", "5", 1, "month", "drp-animate"], [1, "week-days"], ["class", "week", 4, "ngIf"], ["role", "rowgroup", 1, "drp-animate"], ["role", "row", 3, "class", 4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 1, "prev", "available", 3, "click", "keydown.enter"], [1, "dropdowns"], [1, "monthselect", 3, "change"], [3, "disabled", "value", "selected", 4, "ngFor", "ngForOf"], [1, "yearselect", 3, "change"], [3, "selected", 4, "ngFor", "ngForOf"], [3, "disabled", "value", "selected"], [3, "selected"], ["role", "button", "tabindex", "0", 1, "next", "available", 3, "click", "keydown.enter"], [1, "week"], ["role", "row"], ["role", "gridcell", "class", "week", 4, "ngIf"], ["role", "gridcell", "tabindex", "0", "role", "button", 3, "class", "keydown.enter", "click", "mouseenter", 4, "ngFor", "ngForOf"], ["role", "gridcell", 1, "week"], ["role", "gridcell", "tabindex", "0", "role", "button", 3, "keydown.enter", "click", "mouseenter"], [1, "calendar-time"], [1, "select"], [1, "hourselect", "select-item", 3, "disabled", "ngModel", "ngModelChange"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], [1, "select-item", "minuteselect", 3, "disabled", "ngModel", "ngModelChange"], [1, "select-highlight"], [1, "select-bar"], ["class", "select-item secondselect", 3, "disabled", "ngModel", "ngModelChange", 4, "ngIf"], ["class", "select-item ampmselect", 3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "value", "disabled"], [1, "select-item", "secondselect", 3, "disabled", "ngModel", "ngModelChange"], [1, "select-item", "ampmselect", 3, "ngModel", "ngModelChange"], ["value", "AM", 3, "disabled"], ["value", "PM", 3, "disabled"], [1, "calendar", "right"], ["colspan", "5", 1, "month"], ["role", "rowgroup"], [1, "select-item", "hourselect", 3, "disabled", "ngModel", "ngModelChange"], [1, "buttons"], [1, "buttons_input"], ["class", "btn btn-default clear", "type", "button", 3, "title", "click", 4, "ngIf"], ["class", "btn btn-default", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-default", "clear", 3, "title", "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "30", "height", "30", "viewBox", "0 -5 24 24"], ["d", "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"], ["type", "button", 1, "btn", "btn-default", 3, "click"]], template: function DaterangepickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("focus", function DaterangepickerComponent_Template_div_focus_0_listener() { return ctx.onEscape(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 1, 2);
            i0.ɵɵlistener("keydown.escape", function DaterangepickerComponent_Template_div_keydown_escape_1_listener() { return ctx.onEscape(); });
            i0.ɵɵelementStart(3, "div", 3)(4, "ul");
            i0.ɵɵtemplate(5, DaterangepickerComponent_li_5_Template, 3, 5, "li", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, DaterangepickerComponent_div_6_Template, 4, 6, "div", 5);
            i0.ɵɵtemplate(7, DaterangepickerComponent_div_7_Template, 4, 2, "div", 6);
            i0.ɵɵtemplate(8, DaterangepickerComponent_div_8_Template, 6, 4, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 0);
            i0.ɵɵlistener("focus", function DaterangepickerComponent_Template_div_focus_9_listener() { return ctx.onEscape(); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c3$q, ctx.isShown || ctx.inline, !ctx.isShown && !ctx.inline));
            i0.ɵɵadvance(1);
            i0.ɵɵclassMap("drops-" + ctx.drops + "-" + ctx.opens);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(12, _c4$l, ctx.locale.direction === "ltr", ctx.locale.direction === "rtl", ctx.isShown || ctx.inline, !ctx.isShown && !ctx.inline, ctx.inline, !ctx.singleDatePicker && ctx.showCalInRanges, ctx.rangesArray.length));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.rangesArray);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showCalInRanges);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showCalInRanges && !ctx.singleDatePicker);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.autoApply && (!ctx.rangesArray.length || ctx.showCalInRanges && !ctx.singleDatePicker));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(20, _c3$q, ctx.isShown || ctx.inline, !ctx.isShown && !ctx.inline));
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$6.NgSelectOption, i1$6.ɵNgSelectMultipleOption, i1$6.SelectControlValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, i1$2.TranslatePipe], styles: [".md-drppicker{position:absolute;font-family:Roboto,sans-serif;color:inherit;border-radius:4px;width:278px;padding:4px;margin-top:-10px;overflow:hidden;z-index:1000;background-color:#fff;box-shadow:0 2px 4px #00000029,0 2px 8px #0000001f}.md-drppicker.double{width:auto}.md-drppicker.inline{position:relative;display:inline-block}.md-drppicker:before,.md-drppicker:after{position:absolute;display:inline-block;border-bottom-color:#0003;content:\"\"}.md-drppicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.openscenter:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.single .ranges,.md-drppicker.single .calendar{float:none}.md-drppicker.shown{transform:scale(1);transition:all .1s ease-in-out;transform-origin:0 0;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.md-drppicker.shown.drops-up-left{transform-origin:100% 100%}.md-drppicker.shown.drops-up-right{transform-origin:0 100%}.md-drppicker.shown.drops-down-left{transform-origin:100% 0}.md-drppicker.shown.drops-down-right{transform-origin:0 0}.md-drppicker.shown.drops-down-center{transform-origin:calc(NaN * 1%)}.md-drppicker.shown.drops-up-center{transform-origin:50%}.md-drppicker.shown .calendar{display:block}.md-drppicker.hidden{transition:all .1s ease;transform:scale(0);transform-origin:0 0;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.md-drppicker.hidden.drops-up-left{transform-origin:100% 100%}.md-drppicker.hidden.drops-up-right{transform-origin:0 100%}.md-drppicker.hidden.drops-down-left{transform-origin:100% 0}.md-drppicker.hidden.drops-down-right{transform-origin:0 0}.md-drppicker.hidden.drops-down-center{transform-origin:50% 0}.md-drppicker.hidden.drops-up-center{transform-origin:50% 100%}.md-drppicker.hidden .calendar{display:none}.md-drppicker .calendar{max-width:270px;margin:4px}.md-drppicker .calendar.single .calendar-table{border:none}.md-drppicker .calendar th,.md-drppicker .calendar td{padding:0;white-space:nowrap;text-align:center;min-width:32px}.md-drppicker .calendar th span,.md-drppicker .calendar td span{pointer-events:none}.md-drppicker .calendar-table{border:1px solid #fff;padding:4px;border-radius:4px;background-color:#fff}.md-drppicker table{width:100%;margin:0}.md-drppicker th{color:#000000de}.md-drppicker td,.md-drppicker th{text-align:center;width:20px;height:20px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer;height:2em;width:2em}.md-drppicker td.available.prev,.md-drppicker th.available.prev{display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;transition:background-color .2s ease;border-radius:2em}.md-drppicker td.available.prev:hover,.md-drppicker td.available.prev:focus,.md-drppicker th.available.prev:hover,.md-drppicker th.available.prev:focus{margin:0}.md-drppicker td.available.next,.md-drppicker th.available.next{transform:rotate(180deg);display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;transition:background-color .2s ease;border-radius:2em}.md-drppicker td.available.next:hover,.md-drppicker td.available.next:focus,.md-drppicker th.available.next:hover,.md-drppicker th.available.next:focus{margin:0;transform:rotate(180deg)}.md-drppicker td.available:hover,.md-drppicker td.available:focus,.md-drppicker th.available:hover,.md-drppicker th.available:focus{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.available:focus,.md-drppicker th.available:focus{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.week,.md-drppicker th.week{font-size:80%;color:#ccc}.md-drppicker td{margin:.25em 0;opacity:.8;transition:background-color .2s ease;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.off,.md-drppicker td.off.in-range,.md-drppicker td.off.start-date,.md-drppicker td.off.end-date{background-color:#fff;border-color:transparent;color:#999}.md-drppicker td.off.available:focus{background-color:#eee!important;border-color:transparent!important;color:inherit!important;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.in-range{background-color:#dde2e4;border-color:transparent;color:#000;border-radius:0}.md-drppicker td.start-date{border-radius:2em 0 0 2em}.md-drppicker td.end-date{border-radius:0 2em 2em 0}.md-drppicker td.start-date.end-date{border-radius:4px}.md-drppicker td.active{transition:background .3s ease-out;background:#0000001a;opacity:1}.md-drppicker td.active,.md-drppicker td.active:hover,.md-drppicker td.active:focus{background-color:#3f51b5;border-color:transparent;color:#fff}.md-drppicker th.month{width:auto}.md-drppicker td.disabled,.md-drppicker option.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.md-drppicker .dropdowns{background-repeat:no-repeat;background-size:10px;background-position-y:center;background-position-x:right;width:50px;background-image:url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDI1NSAyNTUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NSAyNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iYXJyb3ctZHJvcC1kb3duIj4KCQk8cG9seWdvbiBwb2ludHM9IjAsNjMuNzUgMTI3LjUsMTkxLjI1IDI1NSw2My43NSAgICIgZmlsbD0iIzk4OGM4YyIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=)}.md-drppicker .dropdowns select{display:inline-block;background-color:#ffffffe6;width:100%;padding:5px;border:1px solid #f2f2f2;border-radius:2px;height:3rem}.md-drppicker .dropdowns select.monthselect,.md-drppicker .dropdowns select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.md-drppicker .dropdowns select.hourselect,.md-drppicker .dropdowns select.minuteselect,.md-drppicker .dropdowns select.secondselect,.md-drppicker .dropdowns select.ampmselect{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.md-drppicker .dropdowns select.monthselect,.md-drppicker .dropdowns select.yearselect{cursor:pointer;opacity:0;position:absolute;top:0;left:0;margin:0;padding:0}.md-drppicker th.month>div{position:relative;display:inline-block}.md-drppicker .calendar-time{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.md-drppicker .calendar-time .select{display:inline}.md-drppicker .calendar-time .select .select-item{display:inline-block;width:auto;position:relative;font-family:inherit;background-color:transparent;padding:10px 10px 10px 0;font-size:18px;border-radius:0;border:none;border-bottom:1px solid rgba(0,0,0,.12)}.md-drppicker .calendar-time .select .select-item:after{position:absolute;top:18px;right:10px;width:0;height:0;padding:0;content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid rgba(0,0,0,.12);pointer-events:none}.md-drppicker .calendar-time .select .select-item:focus{outline:none}.md-drppicker .calendar-time .select .select-item .select-label{color:#00000042;font-size:16px;font-weight:400;position:absolute;pointer-events:none;left:0;top:10px;transition:.2s ease all}.md-drppicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.md-drppicker .label-input{border:1px solid #ccc;border-radius:4px;color:#222;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 auto 5px;padding:0 0 0 28px;width:100%}.md-drppicker .label-input.active{border:1px solid #08c;border-radius:4px}.md-drppicker .md-drppicker_input{position:relative;padding:0 30px 0 0}.md-drppicker .md-drppicker_input i,.md-drppicker .md-drppicker_input svg{position:absolute;left:8px;top:8px}.md-drppicker.rtl .label-input{padding-right:28px;padding-left:6px}.md-drppicker.rtl .md-drppicker_input i,.md-drppicker.rtl .md-drppicker_input svg{left:auto;right:8px}.md-drppicker .show-ranges .drp-calendar.left{border-left:1px solid #ddd}.md-drppicker .ranges{float:none;text-align:left;margin:0}.md-drppicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.md-drppicker .ranges ul li{font-size:12px}.md-drppicker .ranges ul li button{padding:8px 12px;width:100%;background:none;border:none;text-align:left;cursor:pointer}.md-drppicker .ranges ul li button.active{background-color:#3f51b5;color:#fff}.md-drppicker .ranges ul li button[disabled]{opacity:.3}.md-drppicker .ranges ul li button:active{background:transparent}.md-drppicker .ranges ul li:hover,.md-drppicker .ranges ul li:focus{background-color:#eee}.md-drppicker .show-calendar .ranges{margin-top:8px}.md-drppicker [hidden]{display:none}.md-drppicker .buttons{text-align:right;margin:0 5px 5px 0}.md-drppicker .btn{position:relative;overflow:hidden;border-width:0;outline:none;padding:0 6px;cursor:pointer;border-radius:2px;box-shadow:0 1px 4px #0009;background-color:#3f51b5;color:#ecf0f1;transition:background-color .4s;height:auto;text-transform:uppercase;line-height:36px;border:none}.md-drppicker .btn:hover,.md-drppicker .btn:focus{background-color:#3f51b5}.md-drppicker .btn>*{position:relative}.md-drppicker .btn span{display:block;padding:12px 24px}.md-drppicker .btn:before{content:\"\";position:absolute;top:50%;left:50%;display:block;width:0;padding-top:0;border-radius:100%;background-color:#ecf0f14d;transform:translate(-50%,-50%)}.md-drppicker .btn:active:before{width:120%;padding-top:120%;transition:width .2s ease-out,padding-top .2s ease-out}.md-drppicker .btn:disabled{opacity:.5}.md-drppicker .btn.btn-default{color:#000;background-color:#dcdcdc}.md-drppicker .clear{box-shadow:none;background-color:#fff!important}.md-drppicker .clear svg{color:#eb3232;fill:currentColor}@media (min-width: 564px){.md-drppicker{width:auto}.md-drppicker.single .calendar.left{clear:none}.md-drppicker.ltr{direction:ltr;text-align:left}.md-drppicker.ltr .calendar.left{clear:left}.md-drppicker.ltr .calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.md-drppicker.ltr .calendar.right{margin-left:0}.md-drppicker.ltr .calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.ltr .left .md-drppicker_input,.md-drppicker.ltr .right .md-drppicker_input{padding-right:35px}.md-drppicker.ltr .calendar.left .calendar-table{padding-right:12px}.md-drppicker.ltr .ranges,.md-drppicker.ltr .calendar{float:left}.md-drppicker.rtl{direction:rtl;text-align:right}.md-drppicker.rtl .calendar.left{clear:right;margin-left:0}.md-drppicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.rtl .calendar.right{margin-right:0}.md-drppicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.md-drppicker.rtl .left .md-drppicker_input,.md-drppicker.rtl .calendar.left .calendar-table{padding-left:12px}.md-drppicker.rtl .ranges,.md-drppicker.rtl .calendar{text-align:right;float:right}.drp-animate{transform:translate(0);transition:transform .2s ease,opacity .2s ease}.drp-animate.drp-picker-site-this{transition-timing-function:linear}.drp-animate.drp-animate-right{transform:translate(10%);opacity:0}.drp-animate.drp-animate-left{transform:translate(-10%);opacity:0}}@media (min-width: 730px){.md-drppicker .ranges{width:auto}.md-drppicker.ltr .ranges{float:left}.md-drppicker.rtl .ranges{float:right}.md-drppicker .calendar.left{clear:none!important}}.daterangepicker-accessibility-dummy{width:0;height:0;overflow:hidden;border:transparent}\n"], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DaterangepickerComponent, [{
        type: Component,
        args: [{ selector: 'ngx-daterangepicker-material', host: {
                    '(click)': 'handleInternalClick($event)',
                }, encapsulation: ViewEncapsulation.None, providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DaterangepickerComponent),
                        multi: true
                    }], template: "<div tabindex=\"0\" (focus)=\"onEscape()\" class=\"daterangepicker-accessibility-dummy\" aria-hidden=\"true\" [ngClass]=\"{  'shown': isShown || inline,\n'hidden': !isShown && !inline}\"></div>\n<div class=\"md-drppicker\" #pickerContainer tabindex=\"0\" id=\"datePickerContainer\" (keydown.escape)=\"onEscape()\"\n    [ngClass]=\"{\n    ltr: locale.direction === 'ltr',\n    rtl: this.locale.direction === 'rtl',\n    'shown': isShown || inline,\n    'hidden': !isShown && !inline,\n    'inline': inline,\n    'double': !singleDatePicker && showCalInRanges,\n    'show-ranges': rangesArray.length\n}\" [class]=\"'drops-' + drops + '-' + opens\">\n    <div class=\"ranges\">\n        <ul>\n            <li *ngFor=\"let range of rangesArray\">\n                <button type=\"button\" (click)=\"clickRange($event, range)\" [disabled]=\"disableRange(range)\"\n                    [ngClass]=\"{'active': range === chosenRange}\">{{range}}</button>\n            </li>\n        </ul>\n    </div>\n    <div class=\"calendar\" [ngClass]=\"{right: singleDatePicker, left: !singleDatePicker}\" *ngIf=\"showCalInRanges\">\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                        <ng-container\n                            *ngIf=\"!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true)\">\n                            <th role=\"button\" tabindex=\"0\" (click)=\"clickPrev(sideEnum.left)\" class=\"prev available\"\n                                (keydown.enter)=\"clickPrev(sideEnum.left)\" [attr.aria-label]=\"'ng.general.previous' | translate\">\n                            </th>\n                        </ng-container>\n                        <ng-container\n                            *ngIf=\"!(!calendarVariables.left.minDate || calendarVariables.left.minDate.isBefore(calendarVariables.left.calendar.firstDay) && (!this.linkedCalendars || true))\">\n                            <th></th>\n                        </ng-container>\n                        <th colspan=\"5\" class=\"month drp-animate\">\n                            <ng-container *ngIf=\"showDropdowns && calendarVariables.left.dropdowns\">\n                                <div class=\"dropdowns\">\n                                    {{this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()]}}\n                                    <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.left)\">\n                                        <option\n                                            [disabled]=\"(calendarVariables.left.dropdowns.inMinYear && m < calendarVariables.left.minDate.month()) || (calendarVariables.left.dropdowns.inMaxYear && m > calendarVariables.left.maxDate.month())\"\n                                            *ngFor=\"let m of calendarVariables.left.dropdowns.monthArrays\" [value]=\"m\"\n                                            [selected]=\"calendarVariables.left.dropdowns.currentMonth == m\">\n                                            {{locale.monthNames[m]}}\n                                        </option>\n                                    </select>\n                                </div>\n                                <div class=\"dropdowns\">\n                                    {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\")}}\n                                    <select class=\"yearselect\" (change)=\"yearChanged($event, sideEnum.left)\">\n                                        <option *ngFor=\"let y of calendarVariables.left.dropdowns.yearArrays\"\n                                            [selected]=\"y === calendarVariables.left.dropdowns.currentYear\">\n                                            {{y}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </ng-container>\n                            <ng-container *ngIf=\"!showDropdowns || !calendarVariables.left.dropdowns\">\n                                {{this.locale.monthNames[calendarVariables?.left?.calendar[1][1].month()]}}\n                                {{ calendarVariables?.left?.calendar[1][1].format(\" YYYY\")}}\n                            </ng-container>\n                        </th>\n                        <ng-container\n                            *ngIf=\"(!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker )\">\n                            <th class=\"next available\" (click)=\"clickNext(sideEnum.left)\" role=\"button\" tabindex=\"0\"\n                                (keydown.enter)=\"clickNext(sideEnum.left)\" [attr.aria-label]=\"'ng.general.next' | translate\">\n                            </th>\n                        </ng-container>\n                        <ng-container\n                            *ngIf=\"!((!calendarVariables.left.maxDate || calendarVariables.left.maxDate.isAfter(calendarVariables.left.calendar.lastDay)) && (!linkedCalendars || singleDatePicker ))\">\n                            <th></th>\n                        </ng-container>\n                    </tr>\n                    <tr class='week-days'>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\">\n                            <span>{{this.locale.weekLabel}}</span></th>\n                        <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{dayofweek}}</span></th>\n                    </tr>\n                </thead>\n                <tbody class=\"drp-animate\" role=\"rowgroup\">\n                    <tr role=\"row\" *ngFor=\"let row of calendarVariables.left.calRows\"\n                        [class]=\"calendarVariables.left.classes[row].classList\">\n                        <td role=\"gridcell\" class=\"week\" *ngIf=\"showWeekNumbers\">\n                            <span>{{calendarVariables.left.calendar[row][0].week()}}</span>\n                        </td>\n                        <td role=\"gridcell\" class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                            <span>{{calendarVariables.left.calendar[row][0].isoWeek()}}</span>\n                        </td>\n\n                        <td role=\"gridcell\" tabindex=\"0\" role=\"button\"\n                            [attr.aria-disabled]=\"calendarVariables.left.classes[row][col]?.includes('disabled')?true:false\"\n                            (keydown.enter)=\"clickDate($event, sideEnum.left, row, col)\"\n                            *ngFor=\"let col of calendarVariables.left.calCols\"\n                            [class]=\"calendarVariables.left.classes[row][col]\"\n                            (click)=\"clickDate($event, sideEnum.left, row, col)\"\n                            (mouseenter)=\"hoverDate($event, sideEnum.left, row, col)\">\n                            <span>{{calendarVariables.left.calendar[row][col].date()}}</span>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <div class=\"select\">\n                <select class=\"hourselect select-item\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.left.selectedHour\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                    <option *ngFor=\"let i of timepickerVariables.left.hours\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledHours.indexOf(i) > -1\">{{i}}</option>\n                </select>\n            </div>\n            <div class=\"select\">\n                <select class=\"select-item minuteselect\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.left.selectedMinute\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                    <option *ngFor=\"let i of timepickerVariables.left.minutes; let index = index;\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledMinutes.indexOf(i) > -1\">\n                        {{timepickerVariables.left.minutesLabel[index]}}</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n            <div class=\"select\">\n                <select class=\"select-item secondselect\" *ngIf=\"timePickerSeconds\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.left.selectedSecond\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                    <option *ngFor=\"let i of timepickerVariables.left.seconds; let index = index;\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.left.disabledSeconds.indexOf(i) > -1\">\n                        {{timepickerVariables.left.secondsLabel[index]}}</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n            <div class=\"select\">\n                <select class=\"select-item ampmselect\" *ngIf=\"!timePicker24Hour\"\n                    [(ngModel)]=\"timepickerVariables.left.ampmModel\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.left)\">\n                    <option value=\"AM\" [disabled]=\"timepickerVariables.left.amDisabled\">AM</option>\n                    <option value=\"PM\" [disabled]=\"timepickerVariables.left.pmDisabled\">PM</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"calendar right\" *ngIf=\"showCalInRanges && !singleDatePicker\">\n        <div class=\"calendar-table\">\n            <table class=\"table-condensed\" *ngIf=\"calendarVariables\">\n                <thead>\n                    <tr>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\"></th>\n                        <ng-container\n                            *ngIf=\"(!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars)\">\n                            <th role=\"button\" tabindex=\"0\" (click)=\"clickPrev(sideEnum.right)\" class=\"prev available\"\n                                (keydown.enter)=\"clickPrev(sideEnum.right)\" [attr.aria-label]=\"'ng.general.previous' | translate\">\n                            </th>\n                        </ng-container>\n                        <ng-container\n                            *ngIf=\"!((!calendarVariables.right.minDate || calendarVariables.right.minDate.isBefore(calendarVariables.right.calendar.firstDay)) && (!this.linkedCalendars))\">\n                            <th></th>\n                        </ng-container>\n                        <th colspan=\"5\" class=\"month\">\n                            <ng-container *ngIf=\"showDropdowns && calendarVariables.right.dropdowns\">\n                                <div class=\"dropdowns\">\n                                    {{this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()]}}\n                                    <select class=\"monthselect\" (change)=\"monthChanged($event, sideEnum.right)\">\n                                        <option\n                                            [disabled]=\"(calendarVariables.right.dropdowns.inMinYear && calendarVariables.right.minDate && m < calendarVariables.right.minDate.month()) || (calendarVariables.right.dropdowns.inMaxYear && calendarVariables.right.maxDate && m > calendarVariables.right.maxDate.month())\"\n                                            *ngFor=\"let m of calendarVariables.right.dropdowns.monthArrays\" [value]=\"m\"\n                                            [selected]=\"calendarVariables.right.dropdowns.currentMonth == m\">\n                                            {{locale.monthNames[m]}}\n                                        </option>\n                                    </select>\n                                </div>\n                                <div class=\"dropdowns\">\n                                    {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\")}}\n                                    <select class=\"yearselect\" (change)=\"yearChanged($event, sideEnum.right)\">\n                                        <option *ngFor=\"let y of calendarVariables.right.dropdowns.yearArrays\"\n                                            [selected]=\"y === calendarVariables.right.dropdowns.currentYear\">\n                                            {{y}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </ng-container>\n                            <ng-container *ngIf=\"!showDropdowns || !calendarVariables.right.dropdowns\">\n                                {{this.locale.monthNames[calendarVariables?.right?.calendar[1][1].month()]}}\n                                {{ calendarVariables?.right?.calendar[1][1].format(\" YYYY\")}}\n                            </ng-container>\n                        </th>\n                        <ng-container\n                            *ngIf=\"!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true)\">\n                            <th class=\"next available\" (click)=\"clickNext(sideEnum.right)\" role=\"button\" tabindex=\"0\"\n                                (keydown.enter)=\"clickNext(sideEnum.right)\" [attr.aria-label]=\"'ng.general.next' | translate\">\n                            </th>\n                        </ng-container>\n                        <ng-container\n                            *ngIf=\"!(!calendarVariables.right.maxDate || calendarVariables.right.maxDate.isAfter(calendarVariables.right.calendar.lastDay) && (!linkedCalendars || singleDatePicker || true))\">\n                            <th></th>\n                        </ng-container>\n                    </tr>\n\n                    <tr class='week-days'>\n                        <th *ngIf=\"showWeekNumbers || showISOWeekNumbers\" class=\"week\">\n                            <span>{{this.locale.weekLabel}}</span></th>\n                        <th *ngFor=\"let dayofweek of locale.daysOfWeek\"><span>{{dayofweek}}</span></th>\n                    </tr>\n                </thead>\n                <tbody role=\"rowgroup\">\n                    <tr role=\"row\" *ngFor=\"let row of calendarVariables.right.calRows\"\n                        [class]=\"calendarVariables.right.classes[row].classList\">\n                        <td role=\"gridcell\" class=\"week\" *ngIf=\"showWeekNumbers\">\n                            <span>{{calendarVariables.right.calendar[row][0].week()}}</span>\n                        </td>\n                        <td role=\"gridcell\" class=\"week\" *ngIf=\"showISOWeekNumbers\">\n                            <span>{{calendarVariables.right.calendar[row][0].isoWeek()}}</span>\n                        </td>\n                        <td role=\"gridcell\" tabindex=\"0\" role=\"button\"\n                            (keydown.enter)=\"clickDate($event, sideEnum.right, row, col)\"\n                            *ngFor=\"let col of calendarVariables.right.calCols\"\n                            [class]=\"calendarVariables.right.classes[row][col]\"\n                            (click)=\"clickDate($event, sideEnum.right, row, col)\"\n                            (mouseenter)=\"hoverDate($event, sideEnum.right, row, col)\">\n                            <span>{{calendarVariables.right.calendar[row][col].date()}}</span>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class=\"calendar-time\" *ngIf=\"timePicker\">\n            <div class=\"select\">\n                <select class=\"select-item hourselect\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.right.selectedHour\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                    <option *ngFor=\"let i of timepickerVariables.right.hours\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledHours.indexOf(i) > -1\">{{i}}</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n            <div class=\"select\">\n                <select class=\"select-item minuteselect\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.right.selectedMinute\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                    <option *ngFor=\"let i of timepickerVariables.right.minutes; let index = index;\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledMinutes.indexOf(i) > -1\">\n                        {{timepickerVariables.right.minutesLabel[index]}}</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n            <div class=\"select\">\n                <select *ngIf=\"timePickerSeconds\" class=\"select-item secondselect\" [disabled]=\"!startDate\"\n                    [(ngModel)]=\"timepickerVariables.right.selectedSecond\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                    <option *ngFor=\"let i of timepickerVariables.right.seconds; let index = index;\" [value]=\"i\"\n                        [disabled]=\"timepickerVariables.right.disabledSeconds.indexOf(i) > -1\">\n                        {{timepickerVariables.right.secondsLabel[index]}}</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n            <div class=\"select\">\n                <select *ngIf=\"!timePicker24Hour\" class=\"select-item ampmselect\"\n                    [(ngModel)]=\"timepickerVariables.right.ampmModel\"\n                    (ngModelChange)=\"timeChanged($event, sideEnum.right)\">\n                    <option value=\"AM\" [disabled]=\"timepickerVariables.right.amDisabled\">AM</option>\n                    <option value=\"PM\" [disabled]=\"timepickerVariables.right.pmDisabled\">PM</option>\n                </select>\n                <span class=\"select-highlight\"></span>\n                <span class=\"select-bar\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"buttons\" *ngIf=\"!autoApply && ( !rangesArray.length || (showCalInRanges && !singleDatePicker))\">\n        <div class=\"buttons_input\">\n            <button *ngIf=\"showClearButton\" class=\"btn btn-default clear\" type=\"button\" (click)=\"clear()\"\n                [title]=\"locale.clearLabel\">\n                {{locale.clearLabel}}\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 -5 24 24\">\n                    <path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\" /></svg>\n            </button>\n            <button class=\"btn btn-default\" *ngIf=\"showCancel\" type=\"button\"\n                (click)=\"clickCancel($event)\">{{locale.cancelLabel}}</button>\n            <button class=\"btn\" [disabled]=\"applyBtn.disabled\" type=\"button\"\n                (click)=\"clickApply($event)\">{{locale.applyLabel}}</button>\n        </div>\n    </div>\n</div>\n<div tabindex=\"0\" (focus)=\"onEscape()\" class=\"daterangepicker-accessibility-dummy\" aria-hidden=\"true\" [ngClass]=\"{  'shown': isShown || inline,\n'hidden': !isShown && !inline}\"></div>", styles: [".md-drppicker{position:absolute;font-family:Roboto,sans-serif;color:inherit;border-radius:4px;width:278px;padding:4px;margin-top:-10px;overflow:hidden;z-index:1000;background-color:#fff;box-shadow:0 2px 4px #00000029,0 2px 8px #0000001f}.md-drppicker.double{width:auto}.md-drppicker.inline{position:relative;display:inline-block}.md-drppicker:before,.md-drppicker:after{position:absolute;display:inline-block;border-bottom-color:#0003;content:\"\"}.md-drppicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.openscenter:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.single .ranges,.md-drppicker.single .calendar{float:none}.md-drppicker.shown{transform:scale(1);transition:all .1s ease-in-out;transform-origin:0 0;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.md-drppicker.shown.drops-up-left{transform-origin:100% 100%}.md-drppicker.shown.drops-up-right{transform-origin:0 100%}.md-drppicker.shown.drops-down-left{transform-origin:100% 0}.md-drppicker.shown.drops-down-right{transform-origin:0 0}.md-drppicker.shown.drops-down-center{transform-origin:calc(NaN * 1%)}.md-drppicker.shown.drops-up-center{transform-origin:50%}.md-drppicker.shown .calendar{display:block}.md-drppicker.hidden{transition:all .1s ease;transform:scale(0);transform-origin:0 0;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.md-drppicker.hidden.drops-up-left{transform-origin:100% 100%}.md-drppicker.hidden.drops-up-right{transform-origin:0 100%}.md-drppicker.hidden.drops-down-left{transform-origin:100% 0}.md-drppicker.hidden.drops-down-right{transform-origin:0 0}.md-drppicker.hidden.drops-down-center{transform-origin:50% 0}.md-drppicker.hidden.drops-up-center{transform-origin:50% 100%}.md-drppicker.hidden .calendar{display:none}.md-drppicker .calendar{max-width:270px;margin:4px}.md-drppicker .calendar.single .calendar-table{border:none}.md-drppicker .calendar th,.md-drppicker .calendar td{padding:0;white-space:nowrap;text-align:center;min-width:32px}.md-drppicker .calendar th span,.md-drppicker .calendar td span{pointer-events:none}.md-drppicker .calendar-table{border:1px solid #fff;padding:4px;border-radius:4px;background-color:#fff}.md-drppicker table{width:100%;margin:0}.md-drppicker th{color:#000000de}.md-drppicker td,.md-drppicker th{text-align:center;width:20px;height:20px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer;height:2em;width:2em}.md-drppicker td.available.prev,.md-drppicker th.available.prev{display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;transition:background-color .2s ease;border-radius:2em}.md-drppicker td.available.prev:hover,.md-drppicker td.available.prev:focus,.md-drppicker th.available.prev:hover,.md-drppicker th.available.prev:focus{margin:0}.md-drppicker td.available.next,.md-drppicker th.available.next{transform:rotate(180deg);display:block;background-image:url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMy43IDYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMuNyA2IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0zLjcsMC43TDEuNCwzbDIuMywyLjNMMyw2TDAsM2wzLTNMMy43LDAuN3oiLz4NCjwvZz4NCjwvc3ZnPg0K);background-repeat:no-repeat;background-size:.5em;background-position:center;opacity:.8;transition:background-color .2s ease;border-radius:2em}.md-drppicker td.available.next:hover,.md-drppicker td.available.next:focus,.md-drppicker th.available.next:hover,.md-drppicker th.available.next:focus{margin:0;transform:rotate(180deg)}.md-drppicker td.available:hover,.md-drppicker td.available:focus,.md-drppicker th.available:hover,.md-drppicker th.available:focus{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.available:focus,.md-drppicker th.available:focus{background-color:#eee;border-color:transparent;color:inherit;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.week,.md-drppicker th.week{font-size:80%;color:#ccc}.md-drppicker td{margin:.25em 0;opacity:.8;transition:background-color .2s ease;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.off,.md-drppicker td.off.in-range,.md-drppicker td.off.start-date,.md-drppicker td.off.end-date{background-color:#fff;border-color:transparent;color:#999}.md-drppicker td.off.available:focus{background-color:#eee!important;border-color:transparent!important;color:inherit!important;background-repeat:no-repeat;background-size:.5em;background-position:center;margin:.25em 0;opacity:.8;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.in-range{background-color:#dde2e4;border-color:transparent;color:#000;border-radius:0}.md-drppicker td.start-date{border-radius:2em 0 0 2em}.md-drppicker td.end-date{border-radius:0 2em 2em 0}.md-drppicker td.start-date.end-date{border-radius:4px}.md-drppicker td.active{transition:background .3s ease-out;background:#0000001a;opacity:1}.md-drppicker td.active,.md-drppicker td.active:hover,.md-drppicker td.active:focus{background-color:#3f51b5;border-color:transparent;color:#fff}.md-drppicker th.month{width:auto}.md-drppicker td.disabled,.md-drppicker option.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.md-drppicker .dropdowns{background-repeat:no-repeat;background-size:10px;background-position-y:center;background-position-x:right;width:50px;background-image:url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDI1NSAyNTUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NSAyNTU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iYXJyb3ctZHJvcC1kb3duIj4KCQk8cG9seWdvbiBwb2ludHM9IjAsNjMuNzUgMTI3LjUsMTkxLjI1IDI1NSw2My43NSAgICIgZmlsbD0iIzk4OGM4YyIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=)}.md-drppicker .dropdowns select{display:inline-block;background-color:#ffffffe6;width:100%;padding:5px;border:1px solid #f2f2f2;border-radius:2px;height:3rem}.md-drppicker .dropdowns select.monthselect,.md-drppicker .dropdowns select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.md-drppicker .dropdowns select.hourselect,.md-drppicker .dropdowns select.minuteselect,.md-drppicker .dropdowns select.secondselect,.md-drppicker .dropdowns select.ampmselect{width:50px;margin:0 auto;background:#eee;border:1px solid #eee;padding:2px;outline:0;font-size:12px}.md-drppicker .dropdowns select.monthselect,.md-drppicker .dropdowns select.yearselect{cursor:pointer;opacity:0;position:absolute;top:0;left:0;margin:0;padding:0}.md-drppicker th.month>div{position:relative;display:inline-block}.md-drppicker .calendar-time{text-align:center;margin:4px auto 0;line-height:30px;position:relative}.md-drppicker .calendar-time .select{display:inline}.md-drppicker .calendar-time .select .select-item{display:inline-block;width:auto;position:relative;font-family:inherit;background-color:transparent;padding:10px 10px 10px 0;font-size:18px;border-radius:0;border:none;border-bottom:1px solid rgba(0,0,0,.12)}.md-drppicker .calendar-time .select .select-item:after{position:absolute;top:18px;right:10px;width:0;height:0;padding:0;content:\"\";border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid rgba(0,0,0,.12);pointer-events:none}.md-drppicker .calendar-time .select .select-item:focus{outline:none}.md-drppicker .calendar-time .select .select-item .select-label{color:#00000042;font-size:16px;font-weight:400;position:absolute;pointer-events:none;left:0;top:10px;transition:.2s ease all}.md-drppicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.md-drppicker .label-input{border:1px solid #ccc;border-radius:4px;color:#222;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 auto 5px;padding:0 0 0 28px;width:100%}.md-drppicker .label-input.active{border:1px solid #08c;border-radius:4px}.md-drppicker .md-drppicker_input{position:relative;padding:0 30px 0 0}.md-drppicker .md-drppicker_input i,.md-drppicker .md-drppicker_input svg{position:absolute;left:8px;top:8px}.md-drppicker.rtl .label-input{padding-right:28px;padding-left:6px}.md-drppicker.rtl .md-drppicker_input i,.md-drppicker.rtl .md-drppicker_input svg{left:auto;right:8px}.md-drppicker .show-ranges .drp-calendar.left{border-left:1px solid #ddd}.md-drppicker .ranges{float:none;text-align:left;margin:0}.md-drppicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.md-drppicker .ranges ul li{font-size:12px}.md-drppicker .ranges ul li button{padding:8px 12px;width:100%;background:none;border:none;text-align:left;cursor:pointer}.md-drppicker .ranges ul li button.active{background-color:#3f51b5;color:#fff}.md-drppicker .ranges ul li button[disabled]{opacity:.3}.md-drppicker .ranges ul li button:active{background:transparent}.md-drppicker .ranges ul li:hover,.md-drppicker .ranges ul li:focus{background-color:#eee}.md-drppicker .show-calendar .ranges{margin-top:8px}.md-drppicker [hidden]{display:none}.md-drppicker .buttons{text-align:right;margin:0 5px 5px 0}.md-drppicker .btn{position:relative;overflow:hidden;border-width:0;outline:none;padding:0 6px;cursor:pointer;border-radius:2px;box-shadow:0 1px 4px #0009;background-color:#3f51b5;color:#ecf0f1;transition:background-color .4s;height:auto;text-transform:uppercase;line-height:36px;border:none}.md-drppicker .btn:hover,.md-drppicker .btn:focus{background-color:#3f51b5}.md-drppicker .btn>*{position:relative}.md-drppicker .btn span{display:block;padding:12px 24px}.md-drppicker .btn:before{content:\"\";position:absolute;top:50%;left:50%;display:block;width:0;padding-top:0;border-radius:100%;background-color:#ecf0f14d;transform:translate(-50%,-50%)}.md-drppicker .btn:active:before{width:120%;padding-top:120%;transition:width .2s ease-out,padding-top .2s ease-out}.md-drppicker .btn:disabled{opacity:.5}.md-drppicker .btn.btn-default{color:#000;background-color:#dcdcdc}.md-drppicker .clear{box-shadow:none;background-color:#fff!important}.md-drppicker .clear svg{color:#eb3232;fill:currentColor}@media (min-width: 564px){.md-drppicker{width:auto}.md-drppicker.single .calendar.left{clear:none}.md-drppicker.ltr{direction:ltr;text-align:left}.md-drppicker.ltr .calendar.left{clear:left}.md-drppicker.ltr .calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.md-drppicker.ltr .calendar.right{margin-left:0}.md-drppicker.ltr .calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.ltr .left .md-drppicker_input,.md-drppicker.ltr .right .md-drppicker_input{padding-right:35px}.md-drppicker.ltr .calendar.left .calendar-table{padding-right:12px}.md-drppicker.ltr .ranges,.md-drppicker.ltr .calendar{float:left}.md-drppicker.rtl{direction:rtl;text-align:right}.md-drppicker.rtl .calendar.left{clear:right;margin-left:0}.md-drppicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.md-drppicker.rtl .calendar.right{margin-right:0}.md-drppicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.md-drppicker.rtl .left .md-drppicker_input,.md-drppicker.rtl .calendar.left .calendar-table{padding-left:12px}.md-drppicker.rtl .ranges,.md-drppicker.rtl .calendar{text-align:right;float:right}.drp-animate{transform:translate(0);transition:transform .2s ease,opacity .2s ease}.drp-animate.drp-picker-site-this{transition-timing-function:linear}.drp-animate.drp-animate-right{transform:translate(10%);opacity:0}.drp-animate.drp-animate-left{transform:translate(-10%);opacity:0}}@media (min-width: 730px){.md-drppicker .ranges{width:auto}.md-drppicker.ltr .ranges{float:left}.md-drppicker.rtl .ranges{float:right}.md-drppicker .calendar.left{clear:none!important}}.daterangepicker-accessibility-dummy{width:0;height:0;overflow:hidden;border:transparent}\n"] }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: LocaleService }]; }, { startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], dateLimit: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], autoApply: [{
            type: Input
        }], singleDatePicker: [{
            type: Input
        }], showDropdowns: [{
            type: Input
        }], showWeekNumbers: [{
            type: Input
        }], showISOWeekNumbers: [{
            type: Input
        }], linkedCalendars: [{
            type: Input
        }], autoUpdateInput: [{
            type: Input
        }], alwaysShowCalendars: [{
            type: Input
        }], maxSpan: [{
            type: Input
        }], lockStartDate: [{
            type: Input
        }], timePicker: [{
            type: Input
        }], timePicker24Hour: [{
            type: Input
        }], timePickerIncrement: [{
            type: Input
        }], timePickerSeconds: [{
            type: Input
        }], showClearButton: [{
            type: Input
        }], firstMonthDayClass: [{
            type: Input
        }], lastMonthDayClass: [{
            type: Input
        }], emptyWeekRowClass: [{
            type: Input
        }], emptyWeekColumnClass: [{
            type: Input
        }], firstDayOfNextMonthClass: [{
            type: Input
        }], lastDayOfPreviousMonthClass: [{
            type: Input
        }], locale: [{
            type: Input
        }], ranges: [{
            type: Input
        }], showCustomRangeLabel: [{
            type: Input
        }], showCancel: [{
            type: Input
        }], keepCalendarOpeningWithRange: [{
            type: Input
        }], showRangeLabelOnInput: [{
            type: Input
        }], customRangeDirection: [{
            type: Input
        }], drops: [{
            type: Input
        }], opens: [{
            type: Input
        }], closeOnAutoApply: [{
            type: Input
        }], choosedDate: [{
            type: Output
        }], rangeClicked: [{
            type: Output
        }], datesUpdated: [{
            type: Output
        }], startDateChanged: [{
            type: Output
        }], endDateChanged: [{
            type: Output
        }], escapeClick: [{
            type: Output
        }], pickerContainer: [{
            type: ViewChild,
            args: ['pickerContainer', { static: true }]
        }], isInvalidDate: [{
            type: Input
        }], isCustomDate: [{
            type: Input
        }], isTooltipDate: [{
            type: Input
        }] }); })();

class DaterangepickerDirective {
    set locale(value) {
        this._locale = { ...this._localeService.config, ...value };
    }
    get locale() {
        return this._locale;
    }
    set startKey(value) {
        if (value !== null) {
            this._startKey = value;
        }
        else {
            this._startKey = 'startDate';
        }
    }
    set endKey(value) {
        if (value !== null) {
            this._endKey = value;
        }
        else {
            this._endKey = 'endDate';
        }
    }
    get value() {
        return this._value || null;
    }
    set value(val) {
        this._value = val;
        this._onChange(val);
        this._changeDetectorRef.markForCheck();
    }
    get disabled() { return this._disabled; }
    constructor(viewContainerRef, _changeDetectorRef, _componentFactoryResolver, _el, _renderer, differs, _localeService, elementRef, layoutWrapperGetBounds) {
        this.viewContainerRef = viewContainerRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._el = _el;
        this._renderer = _renderer;
        this.differs = differs;
        this._localeService = _localeService;
        this.elementRef = elementRef;
        this.layoutWrapperGetBounds = layoutWrapperGetBounds;
        this._onChange = Function.prototype;
        this._onTouched = Function.prototype;
        this._validatorChange = Function.prototype;
        this.dateLimit = null;
        this.showCancel = false;
        this.lockStartDate = false;
        // timepicker variables
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.closeOnAutoApply = true;
        this._locale = {};
        this._endKey = 'endDate';
        this._startKey = 'startDate';
        this.notForChangesProperty = [
            'locale',
            'endKey',
            'startKey'
        ];
        this.onChange = new EventEmitter();
        this.rangeClicked = new EventEmitter();
        this.datesUpdated = new EventEmitter();
        this.startDateChanged = new EventEmitter();
        this.endDateChanged = new EventEmitter();
        this.escapeClick = new EventEmitter();
        this.drops = 'down';
        this.opens = 'auto';
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(DaterangepickerComponent);
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        this.picker = componentRef.instance;
        this.picker.inline = false; // set inline to false for all directive usage
    }
    ngOnInit() {
        this.picker.startDateChanged.asObservable().subscribe((itemChanged) => {
            this.startDateChanged.emit(itemChanged);
        });
        this.picker.endDateChanged.asObservable().subscribe((itemChanged) => {
            this.endDateChanged.emit(itemChanged);
        });
        this.picker.escapeClick.asObservable().subscribe((itemChanged) => {
            this.escapeClick.emit(itemChanged);
        });
        this.picker.rangeClicked.asObservable().subscribe((range) => {
            this.rangeClicked.emit(range);
        });
        this.picker.datesUpdated.asObservable().subscribe((range) => {
            this.datesUpdated.emit(range);
        });
        this.picker.choosedDate.asObservable().subscribe((change) => {
            if (change) {
                const value = {};
                value[this._startKey] = change.startDate;
                value[this._endKey] = change.endDate;
                this.value = value;
                this.onChange.emit(value);
                if (typeof change.chosenLabel === 'string') {
                    this._el.nativeElement.value = change.chosenLabel;
                }
            }
        });
        this.picker.firstMonthDayClass = this.firstMonthDayClass;
        this.picker.lastMonthDayClass = this.lastMonthDayClass;
        this.picker.emptyWeekRowClass = this.emptyWeekRowClass;
        this.picker.emptyWeekColumnClass = this.emptyWeekColumnClass;
        this.picker.firstDayOfNextMonthClass = this.firstDayOfNextMonthClass;
        this.picker.lastDayOfPreviousMonthClass = this.lastDayOfPreviousMonthClass;
        this.picker.drops = this.drops;
        this.picker.opens = this.opens;
        this.localeDiffer = this.differs.find(this.locale).create();
        this.picker.closeOnAutoApply = this.closeOnAutoApply;
    }
    ngOnChanges(changes) {
        for (const change in changes) {
            if (changes.hasOwnProperty(change)) {
                if (this.notForChangesProperty.indexOf(change) === -1) {
                    this.picker[change] = changes[change].currentValue;
                }
            }
        }
    }
    ngDoCheck() {
        if (this.localeDiffer) {
            const changes = this.localeDiffer.diff(this.locale);
            if (changes) {
                this.picker.updateLocale(this.locale);
            }
        }
    }
    onBlur() {
        this._onTouched();
    }
    open(event) {
        if (this.disabled) {
            return;
        }
        this.picker.show(event);
        setTimeout(() => {
            this.setPosition();
        });
    }
    hide(e) {
        this.picker.hide(e);
    }
    toggle(e) {
        if (this.picker.isShown) {
            this.hide(e);
        }
        else {
            this.open(e);
        }
    }
    clear() {
        this.picker.clear();
    }
    writeValue(value) {
        this.setValue(value);
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(state) {
        this._disabled = state;
    }
    setValue(val) {
        if (val) {
            this.value = val;
            if (val[this._startKey]) {
                this.picker.setStartDate(val[this._startKey]);
            }
            if (val[this._endKey]) {
                this.picker.setEndDate(val[this._endKey]);
            }
            this.picker.calculateChosenLabel();
            if (this.picker.chosenLabel) {
                this._el.nativeElement.value = this.picker.chosenLabel;
            }
        }
        else {
            this.picker.clear();
        }
    }
    /**
     * Set position of the calendar
     */
    setPosition() {
        const left = this.layoutWrapperGetBounds ? this.layoutWrapperGetBounds().left : 0;
        let style;
        let containerTop;
        const container = this.picker.pickerContainer.nativeElement;
        const element = this._el.nativeElement;
        if (this.drops && this.drops === 'up') {
            containerTop = (element.offsetTop - container.clientHeight) + 'px';
        }
        else {
            containerTop = 'auto';
        }
        if (this.opens === 'left') {
            style = {
                top: containerTop,
                left: (left + (element.offsetLeft - container.clientWidth + element.clientWidth)) + 'px',
                right: 'auto',
                position: 'fixed'
            };
        }
        else if (this.opens === 'center') {
            style = {
                top: containerTop,
                left: left +
                    ((element.offsetLeft + element.clientWidth / 2
                        - container.clientWidth / 2)) + 'px',
                right: 'auto',
                position: 'fixed'
            };
        }
        else if (this.opens === 'right') {
            style = {
                top: containerTop,
                left: (left + element.offsetLeft) + 'px',
                right: 'auto',
                position: 'fixed'
            };
        }
        else {
            const position = element.offsetLeft + element.clientWidth / 2 - container.clientWidth / 2;
            if (position < 0) {
                style = {
                    top: containerTop,
                    left: (left + element.offsetLeft) + 'px',
                    right: 'auto',
                    position: 'fixed'
                };
            }
            else {
                style = {
                    top: containerTop,
                    left: position + 'px',
                    right: 'auto',
                    position: 'fixed'
                };
            }
        }
        if (style) {
            this._renderer.setStyle(container, 'top', style.top);
            this._renderer.setStyle(container, 'left', style.left);
            this._renderer.setStyle(container, 'right', style.right);
            this._renderer.setStyle(container, 'position', style.position);
        }
    }
    inputChanged(e) {
        if (e.target.tagName.toLowerCase() !== 'input') {
            return;
        }
        if (!e.target.value.length) {
            return;
        }
        const dateString = e.target.value.split(this.picker.locale.separator);
        let start = null, end = null;
        if (dateString.length === 2) {
            start = moment(dateString[0], this.picker.locale.format);
            end = moment(dateString[1], this.picker.locale.format);
        }
        if (this.singleDatePicker || start === null || end === null) {
            start = moment(e.target.value, this.picker.locale.format);
            end = start;
        }
        if (!start.isValid() || !end.isValid()) {
            return;
        }
        this.picker.setStartDate(start);
        this.picker.setEndDate(end);
        this.picker.updateView();
    }
    /**
     * For click outside of the calendar's container
     * @param event event object
     */
    outsideClick(event) {
        if (!event.target) {
            return;
        }
        if (event.target.classList.contains('ngx-daterangepicker-action') || event.target.classList.contains('material-icons')) {
            return;
        }
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.hide();
        }
    }
    static { this.ɵfac = function DaterangepickerDirective_Factory(t) { return new (t || DaterangepickerDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.KeyValueDiffers), i0.ɵɵdirectiveInject(LocaleService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LAYOUT_WRAPPER_GET_BOUNDS, 8)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DaterangepickerDirective, selectors: [["input", "ngxDaterangepickerMd", ""]], hostVars: 1, hostBindings: function DaterangepickerDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown.escape", function DaterangepickerDirective_keydown_escape_HostBindingHandler() { return ctx.hide(); })("blur", function DaterangepickerDirective_blur_HostBindingHandler() { return ctx.onBlur(); })("click", function DaterangepickerDirective_click_HostBindingHandler() { return ctx.open(); })("keyup", function DaterangepickerDirective_keyup_HostBindingHandler($event) { return ctx.inputChanged($event); })("click", function DaterangepickerDirective_click_HostBindingHandler($event) { return ctx.outsideClick($event); }, false, i0.ɵɵresolveDocument);
        } if (rf & 2) {
            i0.ɵɵhostProperty("disabled", ctx.disabled);
        } }, inputs: { minDate: "minDate", maxDate: "maxDate", autoApply: "autoApply", alwaysShowCalendars: "alwaysShowCalendars", showCustomRangeLabel: "showCustomRangeLabel", linkedCalendars: "linkedCalendars", dateLimit: "dateLimit", singleDatePicker: "singleDatePicker", showWeekNumbers: "showWeekNumbers", showISOWeekNumbers: "showISOWeekNumbers", showDropdowns: "showDropdowns", isInvalidDate: "isInvalidDate", isCustomDate: "isCustomDate", isTooltipDate: "isTooltipDate", showClearButton: "showClearButton", customRangeDirection: "customRangeDirection", ranges: "ranges", opens: "opens", drops: "drops", lastMonthDayClass: "lastMonthDayClass", emptyWeekRowClass: "emptyWeekRowClass", emptyWeekColumnClass: "emptyWeekColumnClass", firstDayOfNextMonthClass: "firstDayOfNextMonthClass", lastDayOfPreviousMonthClass: "lastDayOfPreviousMonthClass", keepCalendarOpeningWithRange: "keepCalendarOpeningWithRange", showRangeLabelOnInput: "showRangeLabelOnInput", showCancel: "showCancel", lockStartDate: "lockStartDate", timePicker: "timePicker", timePicker24Hour: "timePicker24Hour", timePickerIncrement: "timePickerIncrement", timePickerSeconds: "timePickerSeconds", closeOnAutoApply: "closeOnAutoApply", locale: "locale", _endKey: "_endKey", startKey: "startKey", endKey: "endKey" }, outputs: { onChange: "change", rangeClicked: "rangeClicked", datesUpdated: "datesUpdated", startDateChanged: "startDateChanged", endDateChanged: "endDateChanged", escapeClick: "escapeClick" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => DaterangepickerDirective), multi: true
                }
            ]), i0.ɵɵNgOnChangesFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DaterangepickerDirective, [{
        type: Directive,
        args: [{
                selector: 'input[ngxDaterangepickerMd]',
                host: {
                    '(keydown.escape)': 'hide()',
                    '(blur)': 'onBlur()',
                    '(click)': 'open()',
                    '(keyup)': 'inputChanged($event)'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DaterangepickerDirective), multi: true
                    }
                ]
            }]
    }], function () { return [{ type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }, { type: i0.ComponentFactoryResolver }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.KeyValueDiffers }, { type: LocaleService }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [LAYOUT_WRAPPER_GET_BOUNDS]
            }] }]; }, { minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], autoApply: [{
            type: Input
        }], alwaysShowCalendars: [{
            type: Input
        }], showCustomRangeLabel: [{
            type: Input
        }], linkedCalendars: [{
            type: Input
        }], dateLimit: [{
            type: Input
        }], singleDatePicker: [{
            type: Input
        }], showWeekNumbers: [{
            type: Input
        }], showISOWeekNumbers: [{
            type: Input
        }], showDropdowns: [{
            type: Input
        }], isInvalidDate: [{
            type: Input
        }], isCustomDate: [{
            type: Input
        }], isTooltipDate: [{
            type: Input
        }], showClearButton: [{
            type: Input
        }], customRangeDirection: [{
            type: Input
        }], ranges: [{
            type: Input
        }], opens: [{
            type: Input
        }], drops: [{
            type: Input
        }], lastMonthDayClass: [{
            type: Input
        }], emptyWeekRowClass: [{
            type: Input
        }], emptyWeekColumnClass: [{
            type: Input
        }], firstDayOfNextMonthClass: [{
            type: Input
        }], lastDayOfPreviousMonthClass: [{
            type: Input
        }], keepCalendarOpeningWithRange: [{
            type: Input
        }], showRangeLabelOnInput: [{
            type: Input
        }], showCancel: [{
            type: Input
        }], lockStartDate: [{
            type: Input
        }], timePicker: [{
            type: Input
        }], timePicker24Hour: [{
            type: Input
        }], timePickerIncrement: [{
            type: Input
        }], timePickerSeconds: [{
            type: Input
        }], closeOnAutoApply: [{
            type: Input
        }], locale: [{
            type: Input
        }], _endKey: [{
            type: Input
        }], startKey: [{
            type: Input
        }], endKey: [{
            type: Input
        }], onChange: [{
            type: Output,
            args: ['change']
        }], rangeClicked: [{
            type: Output,
            args: ['rangeClicked']
        }], datesUpdated: [{
            type: Output,
            args: ['datesUpdated']
        }], startDateChanged: [{
            type: Output
        }], endDateChanged: [{
            type: Output
        }], escapeClick: [{
            type: Output
        }], disabled: [{
            type: HostBinding,
            args: ['disabled']
        }], outsideClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

const _c0$1k = ["input"];
function ExDateRangePickerComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ExDateRangePickerComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onClearDates()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "i", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-date-range-picker-clear-button ", ctx_r1.uniqueSelector ? i0.ɵɵpipeBind1(1, 4, "ex-date-range-picker-clear-button-" + ctx_r1.uniqueSelector) : "", "");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "ng.general.clear"));
} }
const _c1$O = function (a0, a1) { return { "ex-date-range-picker-focus": a0, "ex-date-range-picker-no-border": a1 }; };
class ExDateRangePickerComponent {
    constructor(translate) {
        this.translate = translate;
        /**
         * blue border on focus
         */
        this.blueOnFocus = true;
        this.inListHeader = false;
        this.showInput = true;
        /**
         * emits the selected dates
         */
        this.datesUpdated = new EventEmitter();
        /**
         * emits clear dates event
         */
        this.clearDates = new EventEmitter();
        this.locale = { format: 'MM/dd/yyyy'.toUpperCase() };
        this.isFocus = false;
    }
    ngOnInit() {
        this.selected = null;
        this.datesPlaceholder = this.translate.instant('ng_alma_date_range_picker.filter_dates');
        this.initDateRanges();
    }
    initDateRanges() {
        const today = this.translate.instant('ng.general.today');
        const yesterday = this.translate.instant('ng.general.yesterday');
        const last7Days = this.translate.instant('ng_alma_date_range_picker.last_7_Days');
        const last30Days = this.translate.instant('ng_alma_date_range_picker.last_30_Days');
        const thisMonth = this.translate.instant('ng_alma_date_range_picker.this_month');
        const lastMonth = this.translate.instant('ng_alma_date_range_picker.last_month');
        const thisYear = this.translate.instant('ng_alma_date_range_picker.this_year');
        this.ranges = {
            [today]: [moment(), moment()],
            [yesterday]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            [last7Days]: [moment().subtract(6, 'days'), moment()],
            [last30Days]: [moment().subtract(29, 'days'), moment()],
            [thisMonth]: [moment().startOf('month'), moment().endOf('month')],
            [lastMonth]: [
                moment()
                    .subtract(1, 'month')
                    .startOf('month'),
                moment()
                    .subtract(1, 'month')
                    .endOf('month')
            ],
            [thisYear]: [moment().startOf('year'), moment().endOf('year')]
        };
    }
    onDatesUpdated(e) {
        if (this.inListHeader) {
            if (e?.startDate && e?.endDate)
                this.showInput = true;
            else
                this.showInput = false;
        }
        e && this.datesUpdated.emit(e);
    }
    onClearDates() {
        this.selected = null;
        this.clearDates.emit();
    }
    onFocus() {
        this.isFocus = true;
    }
    onBlur() {
        this.isFocus = false;
    }
    handleKeyboardEvent(event) {
        if (event.key === 'Enter') {
            this.onDatesUpdated(this.selected);
            this.pickerDirective.open();
        }
    }
    onOpenDateRangePicker() {
        this.onFocus();
        this.input.nativeElement.focus();
        this.pickerDirective.open();
    }
    escapeClicked() {
        this.onFocus();
        this.input.nativeElement.focus();
    }
    static { this.ɵfac = function ExDateRangePickerComponent_Factory(t) { return new (t || ExDateRangePickerComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDateRangePickerComponent, selectors: [["ex-date-range-picker"]], viewQuery: function ExDateRangePickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1k, 5);
            i0.ɵɵviewQuery(DaterangepickerDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pickerDirective = _t.first);
        } }, inputs: { blueOnFocus: "blueOnFocus", maxDate: "maxDate", minDate: "minDate", inListHeader: "inListHeader", uniqueSelector: "uniqueSelector" }, outputs: { datesUpdated: "datesUpdated", clearDates: "clearDates" }, decls: 11, vars: 28, consts: [[1, "ex-date-rane-picker-wrapper"], ["for", "dateInput", 1, "ex-date-rane-picker-filter-dates"], [1, "ex-date-range-picker", 3, "ngClass"], ["id", "dateInput", "type", "text", "ngxDaterangepickerMd", "", "opens", "center", 3, "autoApply", "ngModel", "ranges", "alwaysShowCalendars", "locale", "maxDate", "minDate", "showDropdowns", "ngModelChange", "keyup", "focus", "blur", "escapeClick"], ["input", ""], [3, "class", "click", 4, "ngIf"], [3, "click"], ["iconName", "calendar_today", "iconType", "matIcon", 1, "ex-date-range-picker-date-icon"], [1, "uxf-icon", "uxf-close"]], template: function ExDateRangePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "input", 3, 4);
            i0.ɵɵlistener("ngModelChange", function ExDateRangePickerComponent_Template_input_ngModelChange_4_listener($event) { return ctx.selected = $event; })("ngModelChange", function ExDateRangePickerComponent_Template_input_ngModelChange_4_listener($event) { return ctx.onDatesUpdated($event); })("keyup", function ExDateRangePickerComponent_Template_input_keyup_4_listener($event) { return ctx.handleKeyboardEvent($event); })("focus", function ExDateRangePickerComponent_Template_input_focus_4_listener() { return ctx.onFocus(); })("blur", function ExDateRangePickerComponent_Template_input_blur_4_listener() { return ctx.onBlur(); })("escapeClick", function ExDateRangePickerComponent_Template_input_escapeClick_4_listener() { return ctx.escapeClicked(); });
            i0.ɵɵpipe(6, "generateHTMLId");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ExDateRangePickerComponent_button_7_Template, 4, 8, "button", 5);
            i0.ɵɵelementStart(8, "button", 6);
            i0.ɵɵlistener("click", function ExDateRangePickerComponent_Template_button_click_8_listener() { return ctx.onOpenDateRangePicker(); });
            i0.ɵɵpipe(9, "generateHTMLId");
            i0.ɵɵelement(10, "ex-icon", 7);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.datesPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(25, _c1$O, ctx.blueOnFocus && ctx.isFocus, !ctx.showInput));
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("form-control ex-date-range-picker-input ", ctx.uniqueSelector ? i0.ɵɵpipeBind1(6, 21, "ex-date-range-picker-input-" + ctx.uniqueSelector) : "", "");
            i0.ɵɵclassProp("ex-date-range-picker-input-hidden", !ctx.showInput);
            i0.ɵɵproperty("autoApply", true)("ngModel", ctx.selected)("ranges", ctx.ranges)("alwaysShowCalendars", true)("locale", ctx.locale)("maxDate", ctx.maxDate)("minDate", ctx.minDate)("showDropdowns", true);
            i0.ɵɵattribute("aria-label", ctx.datesPlaceholder);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.selected && ctx.selected.startDate && ctx.selected.endDate);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("ngx-daterangepicker-action ex-date-range-picker-calendar-icon ", ctx.uniqueSelector ? i0.ɵɵpipeBind1(9, 23, "ex-date-range-picker-calendar-icon-" + ctx.uniqueSelector) : "", "");
            i0.ɵɵattribute("aria-label", ctx.datesPlaceholder);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExIconComponent, DaterangepickerDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-date-rane-picker-wrapper[_ngcontent-%COMP%]{margin-inline-start:15px;display:flex;flex-direction:row;align-items:center}.ex-date-rane-picker-wrapper[_ngcontent-%COMP%]   .ex-date-rane-picker-filter-dates[_ngcontent-%COMP%]{color:#000;padding-right:5px}.ex-date-range-picker[_ngcontent-%COMP%]{display:flex;border:1px solid #d7d7d7;margin:1px;align-items:center;border-radius:3px}.ex-date-range-picker-focus[_ngcontent-%COMP%]{border:2px solid rgba(14,123,186,.9803921569)!important;margin:0}.ex-date-range-picker-no-border[_ngcontent-%COMP%]{border:none!important}.ex-date-range-picker-clear-button[_ngcontent-%COMP%]{color:#818181;border:0px;cursor:pointer;background-color:Transparent}.ex-date-range-picker-clear-button[_ngcontent-%COMP%]:hover{color:#2a5db0}.ex-date-range-picker-date-icon[_ngcontent-%COMP%]{margin:5px 6px 0}.ex-date-range-picker-input[_ngcontent-%COMP%]{border:none;box-shadow:none;height:32px}.ex-date-range-picker-input[_ngcontent-%COMP%]:focus{border:none;box-shadow:none;height:32px}.ex-date-range-picker-input[_ngcontent-%COMP%]::placeholder{opacity:1}.ex-date-range-picker-calendar-icon[_ngcontent-%COMP%]{border:0;background-color:transparent;display:flex;margin-bottom:5px}.ex-date-range-picker-input-hidden[_ngcontent-%COMP%]{width:0px!important;padding:0!important;border:none!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDateRangePickerComponent, [{
        type: Component,
        args: [{ selector: 'ex-date-range-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-date-rane-picker-wrapper\">\n  <label class=\"ex-date-rane-picker-filter-dates\" for=\"dateInput\">{{datesPlaceholder}}</label>\n  <div class=\"ex-date-range-picker\" [ngClass]=\"{ 'ex-date-range-picker-focus': blueOnFocus && isFocus, 'ex-date-range-picker-no-border': !showInput }\">\n    <input #input id=\"dateInput\" type=\"text\" ngxDaterangepickerMd [autoApply]=\"true\" [(ngModel)]=\"selected\" [class.ex-date-range-picker-input-hidden]=\"!showInput\"\n      (ngModelChange)=\"onDatesUpdated($event)\" (keyup)=\"handleKeyboardEvent($event)\" [ranges]=\"ranges\"\n      class=\"form-control ex-date-range-picker-input {{ uniqueSelector ? (('ex-date-range-picker-input-' + uniqueSelector) | generateHTMLId) : ''}}\" [alwaysShowCalendars]=\"true\" opens=\"center\" [locale]=\"locale\"\n      [maxDate]=\"maxDate\" [minDate]=\"minDate\" [showDropdowns]=\"true\" (focus)=\"onFocus()\" (blur)=\"onBlur()\"\n      [attr.aria-label]=\"datesPlaceholder\" (escapeClick)=\"escapeClicked()\" />\n    <button *ngIf=\"selected && selected.startDate && selected.endDate\" class=\"ex-date-range-picker-clear-button {{ uniqueSelector ? (('ex-date-range-picker-clear-button-' + uniqueSelector) | generateHTMLId) : ''}}\"\n      [attr.aria-label]=\"'ng.general.clear' | translate\" (click)=\"onClearDates()\">\n      <i class=\"uxf-icon uxf-close\"></i>\n    </button>\n    <button class=\"ngx-daterangepicker-action ex-date-range-picker-calendar-icon {{ uniqueSelector ? (('ex-date-range-picker-calendar-icon-' + uniqueSelector) | generateHTMLId) : ''}}\" (click)=\"onOpenDateRangePicker()\"\n      [attr.aria-label]=\"datesPlaceholder\">\n      <ex-icon class=\"ex-date-range-picker-date-icon\" iconName=\"calendar_today\" iconType=\"matIcon\">\n      </ex-icon>\n    </button>\n  </div>\n</div>\n", styles: [".ex-date-rane-picker-wrapper{margin-inline-start:15px;display:flex;flex-direction:row;align-items:center}.ex-date-rane-picker-wrapper .ex-date-rane-picker-filter-dates{color:#000;padding-right:5px}.ex-date-range-picker{display:flex;border:1px solid #d7d7d7;margin:1px;align-items:center;border-radius:3px}.ex-date-range-picker-focus{border:2px solid rgba(14,123,186,.9803921569)!important;margin:0}.ex-date-range-picker-no-border{border:none!important}.ex-date-range-picker-clear-button{color:#818181;border:0px;cursor:pointer;background-color:Transparent}.ex-date-range-picker-clear-button:hover{color:#2a5db0}.ex-date-range-picker-date-icon{margin:5px 6px 0}.ex-date-range-picker-input{border:none;box-shadow:none;height:32px}.ex-date-range-picker-input:focus{border:none;box-shadow:none;height:32px}.ex-date-range-picker-input::placeholder{opacity:1}.ex-date-range-picker-calendar-icon{border:0;background-color:transparent;display:flex;margin-bottom:5px}.ex-date-range-picker-input-hidden{width:0px!important;padding:0!important;border:none!important}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { blueOnFocus: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], minDate: [{
            type: Input
        }], inListHeader: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], datesUpdated: [{
            type: Output
        }], clearDates: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }], pickerDirective: [{
            type: ViewChild,
            args: [DaterangepickerDirective, { static: false }]
        }] }); })();

class NgxDaterangepickerMd {
    constructor() {
    }
    static forRoot(config = {}) {
        return {
            ngModule: NgxDaterangepickerMd,
            providers: [
                { provide: LOCALE_CONFIG, useValue: config },
                { provide: LocaleService, useClass: LocaleService, deps: [LOCALE_CONFIG] }
            ]
        };
    }
    static { this.ɵfac = function NgxDaterangepickerMd_Factory(t) { return new (t || NgxDaterangepickerMd)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NgxDaterangepickerMd }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxDaterangepickerMd, [{
        type: NgModule,
        args: [{
                declarations: [
                    DaterangepickerComponent,
                    DaterangepickerDirective
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TranslateModule
                ],
                providers: [],
                exports: [
                    DaterangepickerComponent,
                    DaterangepickerDirective
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NgxDaterangepickerMd, { declarations: [DaterangepickerComponent,
        DaterangepickerDirective], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule], exports: [DaterangepickerComponent,
        DaterangepickerDirective] }); })();

class ExDateRangePickerModule {
    static { this.ɵfac = function ExDateRangePickerModule_Factory(t) { return new (t || ExDateRangePickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDateRangePickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExIconModule,
            NgxDaterangepickerMd,
            TranslateModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDateRangePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExIconModule,
                    NgxDaterangepickerMd,
                    TranslateModule,
                    EXPipesModule
                ],
                declarations: [
                    ExDateRangePickerComponent,
                ],
                exports: [
                    ExDateRangePickerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDateRangePickerModule, { declarations: [ExDateRangePickerComponent], imports: [CommonModule,
        FormsModule,
        ExIconModule,
        NgxDaterangepickerMd,
        TranslateModule,
        EXPipesModule], exports: [ExDateRangePickerComponent] }); })();

function ExInlineEditingButtonsComponent_div_0_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 7);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_0_ex_button_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onDeleteClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("uniqueSelector", ctx_r2.uniqueSelector ? "delete-button-" + ctx_r2.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "ng.general.delete"), " ");
} }
function ExInlineEditingButtonsComponent_div_0_ex_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 8);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_0_ex_button_3_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onClearFormClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "link")("uniqueSelector", ctx_r3.uniqueSelector ? "clear-form-button-" + ctx_r3.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r3.clearFormLabel));
} }
function ExInlineEditingButtonsComponent_div_0_ex_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 9);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_0_ex_button_4_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.onResetClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r4.resetDisabled)("uniqueSelector", ctx_r4.uniqueSelector ? "reset-button-" + ctx_r4.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r4.resetLabel));
} }
function ExInlineEditingButtonsComponent_div_0_ex_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 10);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_0_ex_button_5_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13._cancelClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("uniqueSelector", ctx_r5.uniqueSelector ? "cancel-button-" + ctx_r5.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r5.cancelLabel));
} }
function ExInlineEditingButtonsComponent_div_0_ex_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 11);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_0_ex_button_6_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.onSaveClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r6.isSaveIsPrimary ? "primary" : "secondary")("loading", ctx_r6.saveLoading)("disabled", ctx_r6.saveDisabled || ctx_r6.saveLoading)("uniqueSelector", ctx_r6.uniqueSelector ? "confirm-button-" + ctx_r6.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 5, ctx_r6.saveLabel));
} }
function ExInlineEditingButtonsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵtemplate(2, ExInlineEditingButtonsComponent_div_0_ex_button_2_Template, 3, 4, "ex-button", 2);
    i0.ɵɵtemplate(3, ExInlineEditingButtonsComponent_div_0_ex_button_3_Template, 3, 5, "ex-button", 3);
    i0.ɵɵtemplate(4, ExInlineEditingButtonsComponent_div_0_ex_button_4_Template, 3, 5, "ex-button", 4);
    i0.ɵɵtemplate(5, ExInlineEditingButtonsComponent_div_0_ex_button_5_Template, 3, 4, "ex-button", 5);
    i0.ɵɵtemplate(6, ExInlineEditingButtonsComponent_div_0_ex_button_6_Template, 3, 7, "ex-button", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-inline-editing-buttons-wrapper sel-inline-editing-buttons-wrapper ", ctx_r0.uniqueSelector ? i0.ɵɵpipeBind1(1, 8, "ex-inline-editing-buttons-wrapper-" + ctx_r0.uniqueSelector) : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.hasDelete);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasClearForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showReset);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasCancel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasSave);
} }
function ExInlineEditingButtonsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14)(5, "button", 15);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onRemoveConfirmed()); })("keydown.escape", function ExInlineEditingButtonsComponent_div_1_Template_button_keydown_escape_5_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onRemoveCanceled()); });
    i0.ɵɵpipe(6, "generateHTMLId");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "ex-icon", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 17);
    i0.ɵɵlistener("click", function ExInlineEditingButtonsComponent_div_1_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onRemoveCanceled()); })("keydown.escape", function ExInlineEditingButtonsComponent_div_1_Template_button_keydown_escape_9_listener() { i0.ɵɵrestoreView(_r18); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onRemoveCanceled()); });
    i0.ɵɵpipe(10, "generateHTMLId");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelement(12, "ex-icon", 18);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 10, "ng.general.delete_confirmation_message"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("sel-inline-editing-buttons-confirm ", ctx_r1.uniqueSelector ? i0.ɵɵpipeBind1(6, 12, "ex-inline-editing-buttons-confirm-" + ctx_r1.uniqueSelector) : "", "");
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(7, 14, "ng.general.accept"));
    i0.ɵɵadvance(4);
    i0.ɵɵclassMapInterpolate1("ex-inline-editing-buttons-remove-cancel sel-inline-editing-buttons-decline ", ctx_r1.uniqueSelector ? i0.ɵɵpipeBind1(10, 16, "ex-inline-editing-buttons-decline-" + ctx_r1.uniqueSelector) : "", "");
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(11, 18, "ng.general.decline"))("exFocus", ctx_r1.deleteConfirmationOpened);
} }
class ExInlineEditingButtonsComponent {
    constructor(formParent, layoutUpdatingEntityObservable, sectionLayoutViewModeObservable, cdr) {
        this.formParent = formParent;
        this.layoutUpdatingEntityObservable = layoutUpdatingEntityObservable;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * whether the delete button will appear or not
         */
        this.hasDelete = false;
        /**
         * whether the cancel button will appear or not, default is false */
        this.hasCancel = false;
        /**
         * whether the save button will appear or not, default is true */
        this.hasSave = true;
        /**
         * The text that will appear on the cancel button */
        this.cancelLabel = 'ng.general.cancel';
        /**
         * whether the save button is loading
         */
        this.saveLoading = false;
        /**
         * The text that will appear on the save button
         */
        this.saveLabel = 'ng.general.save';
        /**
         * The save button is primary or not
         */
        this.isSaveIsPrimary = true;
        /**
         * whether the reset button will appear or not
         */
        this.hasReset = undefined;
        /**
         * The text that will appear on the reset button
         */
        this.resetLabel = 'ng.general.reset';
        this.hasClearForm = undefined;
        /**
         * The text that will appear on the clear form button
         */
        this.clearFormLabel = 'ng.accessibility.clear-form-btn';
        this.readOnly = false;
        /**
         * whether to disable save when the layout is updating the primary entity
         */
        this.disableOnLayoutUpdate = false;
        this._layoutUpdating = false;
        /**
         * event fired whenever the cancel button is clicked
         */
        this.cancelClicked = new EventEmitter();
        /**
         * event fired whenever the save button is clicked
         */
        this.saveClicked = new EventEmitter();
        /**
         * event fired whenever the delete button is clicked
         */
        this.deleteClicked = new EventEmitter();
        /**
        * event fired whenever the reset button is clicked
        */
        this.resetClicked = new EventEmitter();
        /**
         * event fired whenever the clear form button is clicked
         */
        this.clearFormClicked = new EventEmitter();
        this.deleteConfirmationOpened = false;
        this._sectionLayoutViewModeValue = false;
        this.sub = new Subscription();
    }
    ngOnInit() {
        this.initFormGroupListener();
        this.initSectionsLayoutListeners();
    }
    initFormGroupListener() {
        if (ExFormGroupDirective.isExFormGroup(this.formParent)) {
            this.initialFormValue = this.getFormRawValue();
            this.sub.add(this.formParent.exFormChanged$.subscribe(() => {
                this.initialFormValue = this.getFormRawValue();
                this.cdr.markForCheck();
            }));
            this.sub.add(merge(this.formParent.exFormUpdated$, this.formParent.exFormMarkedDirty$, this.formParent.exFormMarkedPristine$).subscribe(() => {
                this.cdr.markForCheck();
            }));
        }
    }
    _cancelClicked() {
        this.cancelClicked.emit();
    }
    getFormRawValue() {
        return this.formParent?.form.getRawValue?.() ?
            JSON.parse(JSON.stringify(this.formParent.form.getRawValue())) :
            undefined;
    }
    initSectionsLayoutListeners() {
        this.sub.add(this.sectionLayoutViewModeObservable?.subscribe((readOnly) => {
            this._sectionLayoutViewModeValue = readOnly;
            this.cdr.markForCheck();
        }));
        if (this.disableOnLayoutUpdate && this.layoutUpdatingEntityObservable) {
            this.sub.add(this.layoutUpdatingEntityObservable.subscribe(updating => {
                this._layoutUpdating = updating;
                this.cdr.markForCheck();
            }));
        }
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    onSaveClicked() {
        this.saveClicked.emit();
    }
    onDeleteClicked() {
        this.deleteConfirmationOpened = true;
    }
    onRemoveConfirmed() {
        this.deleteConfirmationOpened = false;
        this.deleteClicked.emit();
    }
    onRemoveCanceled() {
        this.deleteConfirmationOpened = false;
    }
    onResetClicked() {
        this.formParent?.reset(JSON.parse(JSON.stringify(this.initialFormValue)));
        this.resetClicked.emit();
    }
    onClearFormClicked() {
        this.clearFormClicked.emit();
    }
    get showReset() {
        if (this.hasReset === undefined) {
            return !!this.formParent && !!this.initialFormValue;
        }
        return this.hasReset;
    }
    get resetDisabled() {
        return this.formParent ? !this.formParent.dirty : false;
    }
    get saveDisabled() {
        if (this._layoutUpdating)
            return true;
        if (this.formParent) {
            return !(this.formParent?.dirty && this.formParent.valid);
        }
        return false;
    }
    get isReadOnly() {
        return this.readOnly || this._sectionLayoutViewModeValue;
    }
    static { this.ɵfac = function ExInlineEditingButtonsComponent_Factory(t) { return new (t || ExInlineEditingButtonsComponent)(i0.ɵɵdirectiveInject(i1$6.ControlContainer, 13), i0.ɵɵdirectiveInject(LAYOUT_UPDATING_PRIMARY_ENTITY, 8), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExInlineEditingButtonsComponent, selectors: [["ex-inline-editing-buttons"]], inputs: { hasDelete: "hasDelete", hasCancel: "hasCancel", hasSave: "hasSave", cancelLabel: "cancelLabel", saveLoading: "saveLoading", saveLabel: "saveLabel", isSaveIsPrimary: "isSaveIsPrimary", hasReset: "hasReset", resetLabel: "resetLabel", hasClearForm: "hasClearForm", clearFormLabel: "clearFormLabel", readOnly: "readOnly", disableOnLayoutUpdate: "disableOnLayoutUpdate", uniqueSelector: "uniqueSelector" }, outputs: { cancelClicked: "cancelClicked", saveClicked: "saveClicked", deleteClicked: "deleteClicked", resetClicked: "resetClicked", clearFormClicked: "clearFormClicked" }, decls: 2, vars: 2, consts: [[3, "class", 4, "ngIf"], ["cdkTrapFocus", "", "class", "ex-inline-editing-buttons-remove-confirmation sel-inline-editing-buttons-remove-confirmation", 4, "ngIf"], ["type", "warn", 3, "uniqueSelector", "click", 4, "ngIf"], [3, "type", "uniqueSelector", "click", 4, "ngIf"], [3, "disabled", "uniqueSelector", "click", 4, "ngIf"], ["class", "sel-cancel-button", 3, "uniqueSelector", "click", 4, "ngIf"], ["class", "sel-confirm-button", 3, "type", "loading", "disabled", "uniqueSelector", "click", 4, "ngIf"], ["type", "warn", 3, "uniqueSelector", "click"], [3, "type", "uniqueSelector", "click"], [3, "disabled", "uniqueSelector", "click"], [1, "sel-cancel-button", 3, "uniqueSelector", "click"], [1, "sel-confirm-button", 3, "type", "loading", "disabled", "uniqueSelector", "click"], ["cdkTrapFocus", "", 1, "ex-inline-editing-buttons-remove-confirmation", "sel-inline-editing-buttons-remove-confirmation"], [1, "ex-inline-editing-buttons-remove-confirmation-title"], [1, "ex-inline-editing-buttons-remove-confirmation-buttons"], [3, "matTooltip", "click", "keydown.escape"], ["sizePx", "30px", "iconType", "fa-font", "iconName", "fa fa-check"], [3, "matTooltip", "exFocus", "click", "keydown.escape"], ["sizePx", "30px", "iconType", "fa-font", "iconName", "fa fa-times"]], template: function ExInlineEditingButtonsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExInlineEditingButtonsComponent_div_0_Template, 7, 10, "div", 0);
            i0.ɵɵtemplate(1, ExInlineEditingButtonsComponent_div_1_Template, 13, 20, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.deleteConfirmationOpened);
        } }, dependencies: [i1$5.NgIf, i4.MatTooltip, ExButtonComponent, ExIconComponent, i3.CdkTrapFocus, ExFocusDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-inline-editing-buttons-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.ex-inline-editing-buttons-wrapper[_ngcontent-%COMP%]   ex-button[_ngcontent-%COMP%]{margin-left:10px}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]{color:#fff!important;flex-direction:column;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#7b7b7bd6;z-index:2}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-title[_ngcontent-%COMP%]{margin-bottom:15px;text-align:center}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background:none;height:50px;width:50px;border-radius:50%;border:solid 1px;display:flex;align-items:center;justify-content:center}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(:last-child){margin-right:25px}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover, .ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:#000 solid 2px}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover     ex-icon i, .ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus     ex-icon i{color:#555}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-cancel[_ngcontent-%COMP%]{background:#fff;outline:none}.ex-inline-editing-buttons-remove-confirmation[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-confirmation-buttons[_ngcontent-%COMP%]   .ex-inline-editing-buttons-remove-cancel[_ngcontent-%COMP%]     ex-icon i{color:#555}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInlineEditingButtonsComponent, [{
        type: Component,
        args: [{ selector: 'ex-inline-editing-buttons', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!isReadOnly\" class=\"ex-inline-editing-buttons-wrapper sel-inline-editing-buttons-wrapper {{uniqueSelector ? (('ex-inline-editing-buttons-wrapper-' + uniqueSelector) | generateHTMLId) : '' }}\">\r\n    <ex-button type=\"warn\" *ngIf=\"hasDelete\" (click)=\"onDeleteClicked()\" [uniqueSelector]=\"uniqueSelector ? 'delete-button-' + uniqueSelector : null\">{{ 'ng.general.delete' | translate }}\r\n    </ex-button>\r\n  <ex-button *ngIf=\"hasClearForm\" (click)=\"onClearFormClicked()\" [type]=\"'link'\" [uniqueSelector]=\"uniqueSelector ? 'clear-form-button-' + uniqueSelector : null\">{{ clearFormLabel | translate\r\n    }}</ex-button>\r\n    <ex-button *ngIf=\"showReset\" (click)=\"onResetClicked()\" [disabled]=\"resetDisabled\" [uniqueSelector]=\"uniqueSelector ? 'reset-button-' + uniqueSelector : null\">{{ resetLabel | translate\r\n        }}</ex-button>\r\n\r\n    <ex-button class=\"sel-cancel-button\" *ngIf=\"hasCancel\" (click)=\"_cancelClicked()\" [uniqueSelector]=\"uniqueSelector ? 'cancel-button-' + uniqueSelector : null\">{{ cancelLabel| translate }}</ex-button>\r\n\r\n    <ex-button class=\"sel-confirm-button\" *ngIf=\"hasSave\" [type]=\"isSaveIsPrimary ? 'primary' : 'secondary'\" [loading]=\"saveLoading\" (click)=\"onSaveClicked()\"\r\n        [disabled]=\"saveDisabled || saveLoading\" [uniqueSelector]=\"uniqueSelector ? 'confirm-button-' + uniqueSelector : null\">{{ saveLabel | translate }}</ex-button>\r\n</div>\r\n\r\n<div *ngIf=\"deleteConfirmationOpened\" cdkTrapFocus\r\n    class=\"ex-inline-editing-buttons-remove-confirmation sel-inline-editing-buttons-remove-confirmation\">\r\n    <div class=\"ex-inline-editing-buttons-remove-confirmation-title\">\r\n        {{ 'ng.general.delete_confirmation_message' | translate }}\r\n    </div>\r\n    <div class=\"ex-inline-editing-buttons-remove-confirmation-buttons\">\r\n        <button class=\"sel-inline-editing-buttons-confirm {{uniqueSelector ? (('ex-inline-editing-buttons-confirm-' + uniqueSelector) | generateHTMLId) : '' }}\" [matTooltip]=\"'ng.general.accept' | translate\"\r\n            (click)=\"onRemoveConfirmed()\" (keydown.escape)=\"onRemoveCanceled()\">\r\n            <ex-icon sizePx=\"30px\" iconType=\"fa-font\" iconName=\"fa fa-check\"></ex-icon>\r\n        </button>\r\n        <button [matTooltip]=\"'ng.general.decline' | translate\"\r\n            class=\"ex-inline-editing-buttons-remove-cancel sel-inline-editing-buttons-decline {{uniqueSelector ? (('ex-inline-editing-buttons-decline-' + uniqueSelector) | generateHTMLId) : '' }}\"\r\n            (click)=\"onRemoveCanceled()\" (keydown.escape)=\"onRemoveCanceled()\" [exFocus]=\"deleteConfirmationOpened\">\r\n            <ex-icon sizePx=\"30px\" iconType=\"fa-font\" iconName=\"fa fa-times\"></ex-icon>\r\n        </button>\r\n    </div>\r\n</div>\r\n", styles: [".ex-inline-editing-buttons-wrapper{display:flex;justify-content:flex-end}.ex-inline-editing-buttons-wrapper ex-button{margin-left:10px}.ex-inline-editing-buttons-remove-confirmation{color:#fff!important;flex-direction:column;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#7b7b7bd6;z-index:2}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-title{margin-bottom:15px;text-align:center}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons{display:flex;flex-direction:row}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button{background:none;height:50px;width:50px;border-radius:50%;border:solid 1px;display:flex;align-items:center;justify-content:center}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button:not(:last-child){margin-right:25px}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button:hover,.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button:focus{outline:#000 solid 2px}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button:hover ::ng-deep ex-icon i,.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons button:focus ::ng-deep ex-icon i{color:#555}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons .ex-inline-editing-buttons-remove-cancel{background:#fff;outline:none}.ex-inline-editing-buttons-remove-confirmation .ex-inline-editing-buttons-remove-confirmation-buttons .ex-inline-editing-buttons-remove-cancel ::ng-deep ex-icon i{color:#555}\n"] }]
    }], function () { return [{ type: i1$6.ControlContainer, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: i1$3.Observable, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [LAYOUT_UPDATING_PRIMARY_ENTITY]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { hasDelete: [{
            type: Input
        }], hasCancel: [{
            type: Input
        }], hasSave: [{
            type: Input
        }], cancelLabel: [{
            type: Input
        }], saveLoading: [{
            type: Input
        }], saveLabel: [{
            type: Input
        }], isSaveIsPrimary: [{
            type: Input
        }], hasReset: [{
            type: Input
        }], resetLabel: [{
            type: Input
        }], hasClearForm: [{
            type: Input
        }], clearFormLabel: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], disableOnLayoutUpdate: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], cancelClicked: [{
            type: Output
        }], saveClicked: [{
            type: Output
        }], deleteClicked: [{
            type: Output
        }], resetClicked: [{
            type: Output
        }], clearFormClicked: [{
            type: Output
        }] }); })();

class ExInlineEditingButtonsModule {
    static { this.ɵfac = function ExInlineEditingButtonsModule_Factory(t) { return new (t || ExInlineEditingButtonsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExInlineEditingButtonsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            MatTooltipModule,
            ExButtonModule,
            ExIconModule,
            A11yModule,
            ExDirectivesModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInlineEditingButtonsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExButtonModule,
                    ExIconModule,
                    A11yModule,
                    ExDirectivesModule,
                    EXPipesModule
                ],
                declarations: [
                    ExInlineEditingButtonsComponent
                ],
                exports: [
                    ExInlineEditingButtonsComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExInlineEditingButtonsModule, { declarations: [ExInlineEditingButtonsComponent], imports: [CommonModule,
        TranslateModule,
        MatTooltipModule,
        ExButtonModule,
        ExIconModule,
        A11yModule,
        ExDirectivesModule,
        EXPipesModule], exports: [ExInlineEditingButtonsComponent] }); })();

const overrideOnChanges = function (dir, exFormField) {
    const oldOnChanges = dir.ngOnChanges;
    dir.ngOnChanges = (function () {
        if (exFormField.ngControl !== this) {
            exFormField.ngControl = this;
        }
        return oldOnChanges.apply(this, arguments);
    }).bind(dir);
};
class ExFormControlName extends FormControlName {
    constructor(formControlName, exFormField) {
        super(null, null, null, null, null);
        exFormField && overrideOnChanges(formControlName, exFormField);
        return formControlName;
    }
    static { this.ɵfac = function ExFormControlName_Factory(t) { return new (t || ExFormControlName)(i0.ɵɵdirectiveInject(i1$6.FormControlName, 2), i0.ɵɵdirectiveInject(ExFormFieldComponent, 9)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExFormControlName, selectors: [["", "formControlName", ""]], features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormControlName, [{
        type: Directive,
        args: [{ selector: '[formControlName]' }]
    }], function () { return [{ type: i1$6.FormControlName, decorators: [{
                type: Self
            }] }, { type: ExFormFieldComponent, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, null); })();

const _c0$1j = ["*"];
class ExFormActionsComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function ExFormActionsComponent_Factory(t) { return new (t || ExFormActionsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFormActionsComponent, selectors: [["ex-form-actions"]], ngContentSelectors: _c0$1j, decls: 1, vars: 0, template: function ExFormActionsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormActionsComponent, [{
        type: Component,
        args: [{ selector: 'ex-form-actions', template: "<ng-content></ng-content>" }]
    }], function () { return []; }, null); })();

function ExFormFieldsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelement(2, "ex-label", 2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(3, 4, ctx_r0.header))("isBold", true)("isTitle", true);
    i0.ɵɵattribute("aria-level", "3");
} }
const _c0$1i = ["*"];
class ExFormFieldsComponent {
    constructor() { }
    ngOnInit() {
    }
    get showBorder() {
        return this.hasBottomBorder;
    }
    static { this.ɵfac = function ExFormFieldsComponent_Factory(t) { return new (t || ExFormFieldsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFormFieldsComponent, selectors: [["ex-form-fields"]], hostVars: 2, hostBindings: function ExFormFieldsComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("with-bottom-border", ctx.showBorder);
        } }, inputs: { header: "header", hasBottomBorder: "hasBottomBorder" }, ngContentSelectors: _c0$1i, decls: 2, vars: 1, consts: [[4, "ngIf"], [1, "ex-form-fields-title"], ["role", "heading", 3, "value", "isBold", "isTitle"]], template: function ExFormFieldsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ExFormFieldsComponent_ng_container_0_Template, 4, 6, "ng-container", 0);
            i0.ɵɵprojection(1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.header);
        } }, dependencies: [i1$5.NgIf, ExLabelComponent, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{display:block;columns:250px;column-count:3;column-gap:2em}.with-bottom-border[_nghost-%COMP%]{border-block-end:1px solid #e0e0e0;margin-block-end:20px}[_nghost-%COMP%]     ex-form-field{display:block;margin-bottom:14px;padding-bottom:1px;page-break-inside:avoid;break-inside:avoid}@supports (-moz-appearance: none){[_nghost-%COMP%]     ex-form-field{display:block ruby}}[_nghost-%COMP%]     .mat-checkbox-layout{position:relative}[_nghost-%COMP%]     .mat-radio-label{position:relative}[_nghost-%COMP%]     ex-form-field{margin-bottom:20px!important}[_nghost-%COMP%]     ex-form-field:not(:has(label))   .ex-form-field-border   .ex-checkbox-wrapper{padding-top:16.5px!important;padding-bottom:16.5px!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-radio-buttons-group{display:flex;margin-bottom:15px}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-editable-text-wrapper{width:100%!important;min-height:35px}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-editable-text-wrapper   .ex-editable-text-text-area-wrapper{width:100%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-editable-text-wrapper   .ex-editable-text-input{width:100%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-editable-text-wrapper .ex-editable-text-editable-input-container{width:100%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-display-text-wrapper{min-height:35px}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-display-text-wrapper .ex-display-text-value-text{width:100%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-combobox-button{width:100%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   .ex-date-picker-wrapper{width:100%!important;min-height:35px}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   ex-new-combobox{width:100%}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   ex-new-combobox ex-combobox-trigger{width:92%!important}[_nghost-%COMP%]     ex-form-field   .ex-form-field-border   ex-combobox   .ex-combobox-button{min-height:35px}.ex-form-fields-title[_ngcontent-%COMP%]{display:inline-block;margin-block-end:15px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormFieldsComponent, [{
        type: Component,
        args: [{ selector: 'ex-form-fields', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"header\">\n    <div class=\"ex-form-fields-title\">\n        <ex-label [value]=\"header | translate\" [isBold]=\"true\" role=\"heading\" [isTitle]=\"true\" [attr.aria-level]=\"'3'\"></ex-label>\n    </div>\n</ng-container>\n<ng-content></ng-content>\n", styles: [":host{display:block;columns:250px;column-count:3;column-gap:2em}:host.with-bottom-border{border-block-end:1px solid #e0e0e0;margin-block-end:20px}:host ::ng-deep ex-form-field{display:block;margin-bottom:14px;padding-bottom:1px;page-break-inside:avoid;break-inside:avoid}@supports (-moz-appearance: none){:host ::ng-deep ex-form-field{display:block ruby}}:host ::ng-deep .mat-checkbox-layout{position:relative}:host ::ng-deep .mat-radio-label{position:relative}:host ::ng-deep ex-form-field{margin-bottom:20px!important}:host ::ng-deep ex-form-field:not(:has(label)) ::ng-deep .ex-form-field-border ::ng-deep .ex-checkbox-wrapper{padding-top:16.5px!important;padding-bottom:16.5px!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-radio-buttons-group{display:flex;margin-bottom:15px}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-editable-text-wrapper{width:100%!important;min-height:35px}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-editable-text-wrapper ::ng-deep .ex-editable-text-text-area-wrapper{width:100%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-editable-text-wrapper ::ng-deep .ex-editable-text-input{width:100%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-editable-text-wrapper .ex-editable-text-editable-input-container{width:100%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-display-text-wrapper{min-height:35px}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-display-text-wrapper .ex-display-text-value-text{width:100%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-combobox-button{width:100%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep .ex-date-picker-wrapper{width:100%!important;min-height:35px}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep ex-new-combobox{width:100%}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep ex-new-combobox ex-combobox-trigger{width:92%!important}:host ::ng-deep ex-form-field ::ng-deep .ex-form-field-border ::ng-deep ex-combobox ::ng-deep .ex-combobox-button{min-height:35px}.ex-form-fields-title{display:inline-block;margin-block-end:15px}\n"] }]
    }], function () { return []; }, { header: [{
            type: Input
        }], hasBottomBorder: [{
            type: Input
        }], showBorder: [{
            type: HostBinding,
            args: ['class.with-bottom-border']
        }] }); })();

class ExFormsModule {
    static { this.ɵfac = function ExFormsModule_Factory(t) { return new (t || ExFormsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFormsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExDirectivesModule,
            EXPipesModule,
            TranslateModule,
            ExComboboxModule,
            ExLabelModule, ReactiveFormsModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExFormComponent,
                    ExFormFieldComponent,
                    ExFormFieldsComponent,
                    ExFormActionsComponent,
                    ExFormGroupDirective,
                    ExFormErrorLabels,
                    ExFormControlName
                ],
                imports: [
                    CommonModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    TranslateModule,
                    ExComboboxModule,
                    ExLabelModule
                ],
                exports: [
                    ReactiveFormsModule,
                    ExFormComponent,
                    ExFormFieldComponent,
                    ExFormFieldsComponent,
                    ExFormActionsComponent,
                    ExFormGroupDirective,
                    ExFormErrorLabels,
                    ExFormControlName
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFormsModule, { declarations: [ExFormComponent,
        ExFormFieldComponent,
        ExFormFieldsComponent,
        ExFormActionsComponent,
        ExFormGroupDirective,
        ExFormErrorLabels,
        ExFormControlName], imports: [CommonModule,
        ExDirectivesModule,
        EXPipesModule,
        TranslateModule,
        ExComboboxModule,
        ExLabelModule], exports: [ReactiveFormsModule,
        ExFormComponent,
        ExFormFieldComponent,
        ExFormFieldsComponent,
        ExFormActionsComponent,
        ExFormGroupDirective,
        ExFormErrorLabels,
        ExFormControlName] }); })();

class ExBreakLinePipe {
    transform(text) {
        return (text || "").replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    static { this.ɵfac = function ExBreakLinePipe_Factory(t) { return new (t || ExBreakLinePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exBreakLine", type: ExBreakLinePipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBreakLinePipe, [{
        type: Pipe,
        args: [{
                name: 'exBreakLine'
            }]
    }], null, null); })();

function ExDialogContentComponent_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r0.titleIcon.iconName)("color", ctx_r0.titleIcon.iconColor)("ariaLabel", ctx_r0.titleIcon.iconName)("size", ctx_r0.titleIcon.iconSize);
} }
function ExDialogContentComponent_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r1.iconName)("ariaLabel", ctx_r1.iconName)("color", ctx_r1.iconColor);
} }
function ExDialogContentComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "exBreakLine");
    i0.ɵɵpipe(2, "exEscapeHtml");
    i0.ɵɵpipe(3, "translate");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(3, 5, ctx_r2.message))), i0.ɵɵsanitizeHtml);
} }
function ExDialogContentComponent_ul_6_li_1_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 9);
} if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", item_r8 == null ? null : item_r8.icon)("ariaLabel", ctx_r9.iconName)("color", ctx_r9.svgColors[item_r8 == null ? null : item_r8.icon]);
} }
function ExDialogContentComponent_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ExDialogContentComponent_ul_6_li_1_ex_svg_icon_1_Template, 1, 3, "ex-svg-icon", 2);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵlistener("click", function ExDialogContentComponent_ul_6_li_1_Template_div_click_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r8 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.onListItemClicked($event, item_r8.text)); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    i0.ɵɵclassProp("ex-dialog-list-with-icon", item_r8 == null ? null : item_r8.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r8 == null ? null : item_r8.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 4, item_r8.text), i0.ɵɵsanitizeHtml);
} }
function ExDialogContentComponent_ul_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 11);
    i0.ɵɵtemplate(1, ExDialogContentComponent_ul_6_li_1_Template, 4, 6, "li", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.list);
} }
function ExDialogContentComponent_ex_component_loader_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 14);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("componentFactoryItem", ctx_r4.component);
} }
function ExDialogContentComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "exBreakLine");
    i0.ɵɵpipe(2, "exEscapeHtml");
    i0.ɵɵpipe(3, "translate");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(3, 5, ctx_r5.confirmation))), i0.ɵɵsanitizeHtml);
} }
function ExDialogContentComponent_ex_checkbox_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 16);
    i0.ɵɵlistener("click", function ExDialogContentComponent_ex_checkbox_9_Template_ex_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("checkboxChange", function ExDialogContentComponent_ex_checkbox_9_Template_ex_checkbox_checkboxChange_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.checkboxClicked($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "slidepane.open.dont_show_again"));
} }
class ExDialogContentComponent {
    /**
     *  A list to be displayed under the message
     */
    set _list(value) {
        if (Array.isArray(value)) {
            this.list = value.map(v => (typeof v === 'string') ? ({ text: v }) : (v));
        }
    }
    ;
    set fieldNavigation(value) {
        this._fieldNavigation = value;
        if (value) {
            this.list = this.list.map(item => {
                let linkIdentifier = this.getLinkIdentifer(item.text);
                if (linkIdentifier.length > 0) {
                    let splittingLink = this.getSplittingLink(item.text);
                    if (item.icon)
                        return {
                            text: '<span>' + splittingLink[0] + '<a>' + linkIdentifier + '</a>' + splittingLink[1] + '</span>',
                            icon: item.icon
                        };
                    return { text: '<span>' + splittingLink[0] + '<a>' + linkIdentifier + '</a>' + splittingLink[1] + '</span>' };
                }
                return item;
            });
        }
    }
    constructor(exNavigateToFieldService, userPreferencesService) {
        this.exNavigateToFieldService = exNavigateToFieldService;
        this.userPreferencesService = userPreferencesService;
        this.svgColors = svgColors;
        this.list = [];
        this.close = new EventEmitter();
    }
    ngOnInit() {
        this.iconName = this.type;
        this.iconColor = svgColors[this.type];
    }
    onListItemClicked($event, text) {
        if ($event.target.tagName === 'A') {
            let navigationString = this._fieldNavigation.get($event.target.innerHTML);
            if (navigationString.length > 0) {
                let sectionId = navigationString.split('/')[0];
                let fieldId = navigationString.split('/')[1];
                this.exNavigateToFieldService.focusOnField(sectionId, fieldId);
            }
            this.close.emit();
        }
    }
    getLinkIdentifer(message) {
        if (message.lastIndexOf('op:') == -1)
            return '';
        return message.toString().substring(message.lastIndexOf('op:') + 3, message.lastIndexOf(':op'));
    }
    getSplittingLink(message) {
        return message.toString().split('op:' + this.getLinkIdentifer(message) + ':op');
    }
    checkboxClicked($event) {
        this.userPreferencesService.setUserPreferences('dont_show_again', this.identifier, $event.checked.toString());
    }
    static { this.ɵfac = function ExDialogContentComponent_Factory(t) { return new (t || ExDialogContentComponent)(i0.ɵɵdirectiveInject(EX_NAVIGATE_TO_FIELD, 8), i0.ɵɵdirectiveInject(IUserPreferencesService, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDialogContentComponent, selectors: [["ex-dialog-content"]], inputs: { message: "message", identifier: "identifier", _list: ["list", "_list"], confirmation: "confirmation", negativeLabel: "negativeLabel", positiveLabel: "positiveLabel", isPositiveButtonIsPrimary: "isPositiveButtonIsPrimary", type: "type", title: "title", titleIcon: "titleIcon", saveLoading: "saveLoading", component: "component", fieldNavigation: "fieldNavigation" }, outputs: { close: "close" }, decls: 10, vars: 10, consts: [["cdkDrag", "", "cdkDragRootElement", ".cdk-overlay-pane", "cdkDragBoundary", ".cdk-overlay-container", "cdkDragHandle", "", "id", "title", "mat-dialog-title", "", 1, "ex-dialog-title", "sel-dialog-title"], [3, "iconName", "color", "ariaLabel", "size", 4, "ngIf"], ["class", "ex-dialog-icon", 3, "iconName", "ariaLabel", "color", 4, "ngIf"], ["id", "message", "class", "ex-dialog-message sel-dialog-message", 3, "innerHTML", 4, "ngIf"], ["id", "list", "class", "ex-dialog-list", 4, "ngIf"], ["class", "ex-dialog-component-loader", 3, "componentFactoryItem", 4, "ngIf"], ["id", "confirmation", "class", "ex-dialog-confirmation sel-dialog-confirmation", 3, "innerHTML", 4, "ngIf"], ["class", "ex-dialog-checkbox", 3, "click", "checkboxChange", 4, "ngIf"], [3, "iconName", "color", "ariaLabel", "size"], [1, "ex-dialog-icon", 3, "iconName", "ariaLabel", "color"], ["id", "message", 1, "ex-dialog-message", "sel-dialog-message", 3, "innerHTML"], ["id", "list", 1, "ex-dialog-list"], [3, "ex-dialog-list-with-icon", 4, "ngFor", "ngForOf"], [3, "innerHTML", "click"], [1, "ex-dialog-component-loader", 3, "componentFactoryItem"], ["id", "confirmation", 1, "ex-dialog-confirmation", "sel-dialog-confirmation", 3, "innerHTML"], [1, "ex-dialog-checkbox", 3, "click", "checkboxChange"]], template: function ExDialogContentComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExDialogContentComponent_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExDialogContentComponent_ex_svg_icon_4_Template, 1, 3, "ex-svg-icon", 2);
            i0.ɵɵtemplate(5, ExDialogContentComponent_div_5_Template, 4, 7, "div", 3);
            i0.ɵɵtemplate(6, ExDialogContentComponent_ul_6_Template, 2, 1, "ul", 4);
            i0.ɵɵtemplate(7, ExDialogContentComponent_ex_component_loader_7_Template, 1, 1, "ex-component-loader", 5);
            i0.ɵɵtemplate(8, ExDialogContentComponent_div_8_Template, 4, 7, "div", 6);
            i0.ɵɵtemplate(9, ExDialogContentComponent_ex_checkbox_9_Template, 3, 3, "ex-checkbox", 7);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.titleIcon);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, ctx.title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.iconName);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.message);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.list && ctx.list.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.component);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.confirmation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.identifier != undefined);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, i1$7.MatDialogTitle, ExSvgIconComponent, ExComponentLoaderComponent, ExCheckboxComponent, i15.CdkDrag, i15.CdkDragHandle, i1$2.TranslatePipe, ExEscapeHtmlPipe, ExBreakLinePipe], styles: ["[_nghost-%COMP%]{display:grid;grid-template-columns:min-content;overflow:hidden}.ex-dialog-title[_ngcontent-%COMP%]{grid-row:1/2;grid-column:1/4;margin-bottom:20px;cursor:move;margin-inline-start:-5px}.ex-dialog-icon[_ngcontent-%COMP%]{align-self:center;margin-inline-end:7px;grid-row:2/3;grid-column:1/2}.ex-dialog-message[_ngcontent-%COMP%]{grid-row:2/3;grid-column:span 2}.ex-dialog-list[_ngcontent-%COMP%]{grid-row:3/4;grid-column:2/3;padding-block:10px}.ex-dialog-list[_ngcontent-%COMP%]   .ex-dialog-list-with-icon[_ngcontent-%COMP%]{display:flex}.ex-dialog-list[_ngcontent-%COMP%]     a{color:#4164a4;cursor:pointer;white-space:nowrap}.ex-dialog-list[_ngcontent-%COMP%]     a:hover{text-decoration:underline;color:#4164a4}.ex-dialog-component-loader[_ngcontent-%COMP%]{grid-row:4/5;grid-column:1/4}.ex-dialog-confirmation[_ngcontent-%COMP%]{grid-row:4/5;grid-column:2/3}.ex-dialog-button[_ngcontent-%COMP%]{padding-inline-end:15px}.ex-dialog-title[_ngcontent-%COMP%]{display:flex;align-items:center;column-gap:4px}.ex-dialog-checkbox[_ngcontent-%COMP%]{grid-column:span 2;margin-top:10px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogContentComponent, [{
        type: Component,
        args: [{ selector: 'ex-dialog-content', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div cdkDrag cdkDragRootElement=\".cdk-overlay-pane\" cdkDragBoundary=\".cdk-overlay-container\" cdkDragHandle id=\"title\" class=\"ex-dialog-title sel-dialog-title\" mat-dialog-title><ex-svg-icon *ngIf=\"titleIcon\" [iconName]=\"titleIcon.iconName\" [color]=\"titleIcon.iconColor\" [ariaLabel]=\"titleIcon.iconName\" [size]=\"titleIcon.iconSize\"> </ex-svg-icon>{{ title | translate }}</div>\n<ex-svg-icon *ngIf=\"iconName\" [iconName]=\"iconName\" [ariaLabel]=\"iconName\" [color]=\"iconColor\" class=\"ex-dialog-icon\"> </ex-svg-icon>\n<div id=\"message\" *ngIf=\"message\" class=\"ex-dialog-message sel-dialog-message\" [innerHTML]=\"message | translate | exEscapeHtml | exBreakLine\"></div>\n<ul id=\"list\" *ngIf=\"list  && (list.length > 0)\" class=\"ex-dialog-list\">\n    <li *ngFor=\"let item of list\" [class.ex-dialog-list-with-icon]=\"item?.icon\">\n      <ex-svg-icon *ngIf=\"item?.icon\" [iconName]=\"item?.icon\" [ariaLabel]=\"iconName\" [color]=\"svgColors[item?.icon]\" class=\"ex-dialog-icon\"> </ex-svg-icon>\n      <div [innerHTML]=\"item.text |translate\" (click)=\"onListItemClicked($event,item.text)\"></div>\n    </li>\n</ul>\n<ex-component-loader class=\"ex-dialog-component-loader\" *ngIf=\"component\" [componentFactoryItem]=\"component\"></ex-component-loader>\n<div id=\"confirmation\" *ngIf=\"confirmation\" class=\"ex-dialog-confirmation sel-dialog-confirmation\" [innerHTML]=\"confirmation | translate | exEscapeHtml | exBreakLine\"></div>\n<ex-checkbox *ngIf=\"identifier != undefined\" class=\"ex-dialog-checkbox\" (click)=\"$event.stopPropagation()\"\n             (checkboxChange)=\"checkboxClicked($event)\">{{'slidepane.open.dont_show_again' | translate}}</ex-checkbox>\n", styles: [":host{display:grid;grid-template-columns:min-content;overflow:hidden}.ex-dialog-title{grid-row:1/2;grid-column:1/4;margin-bottom:20px;cursor:move;margin-inline-start:-5px}.ex-dialog-icon{align-self:center;margin-inline-end:7px;grid-row:2/3;grid-column:1/2}.ex-dialog-message{grid-row:2/3;grid-column:span 2}.ex-dialog-list{grid-row:3/4;grid-column:2/3;padding-block:10px}.ex-dialog-list .ex-dialog-list-with-icon{display:flex}.ex-dialog-list ::ng-deep a{color:#4164a4;cursor:pointer;white-space:nowrap}.ex-dialog-list ::ng-deep a:hover{text-decoration:underline;color:#4164a4}.ex-dialog-component-loader{grid-row:4/5;grid-column:1/4}.ex-dialog-confirmation{grid-row:4/5;grid-column:2/3}.ex-dialog-button{padding-inline-end:15px}.ex-dialog-title{display:flex;align-items:center;column-gap:4px}.ex-dialog-checkbox{grid-column:span 2;margin-top:10px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_NAVIGATE_TO_FIELD]
            }] }, { type: IUserPreferencesService, decorators: [{
                type: Optional
            }] }]; }, { message: [{
            type: Input
        }], identifier: [{
            type: Input
        }], _list: [{
            type: Input,
            args: ["list"]
        }], confirmation: [{
            type: Input
        }], negativeLabel: [{
            type: Input
        }], positiveLabel: [{
            type: Input
        }], isPositiveButtonIsPrimary: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }], titleIcon: [{
            type: Input
        }], saveLoading: [{
            type: Input
        }], component: [{
            type: Input
        }], fieldNavigation: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();

const _c0$1h = ["*"];
class ExFormDialogComponent extends ExDialogComponent {
    constructor(data, dialogRef) {
        super(data.dialogConfiguration, dialogRef);
        this.data = data;
        this.dialogRef = dialogRef;
        this.hasClearFormButton = false;
        this.saveClickedEmitter = new EventEmitter();
        this.resetClickedEmitter = new EventEmitter();
        this.clearFormClickedEmitter = new EventEmitter();
    }
    saveClicked() {
        this.saveClickedEmitter.emit(true);
    }
    resetClicked() {
        this.resetClickedEmitter.emit(true);
    }
    clearFormClicked() {
        this.clearFormClickedEmitter.emit(true);
    }
    static { this.ɵfac = function ExFormDialogComponent_Factory(t) { return new (t || ExFormDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA, 8), i0.ɵɵdirectiveInject(i1$7.MatDialogRef, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFormDialogComponent, selectors: [["ex-form-dialog"]], inputs: { formGroup: "formGroup", hasClearFormButton: "hasClearFormButton", formErrorLabels: "formErrorLabels" }, outputs: { saveClickedEmitter: "saveClicked", resetClickedEmitter: "resetClicked", clearFormClickedEmitter: "clearFormClicked" }, features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$1h, decls: 6, vars: 23, consts: [["exShortcutsScope", "dialog", 3, "formGroup", "formErrorLabels", "keydown.escape"], [1, "ex-dialog-content"], [3, "message", "list", "confirmation", "negativeLabel", "positiveLabel", "isPositiveButtonIsPrimary", "type", "title", "titleIcon", "saveLoading", "component", "identifier"], ["align", "end", 1, "ex-dialog-actions"], [3, "hasDelete", "hasClearForm", "hasReset", "hasCancel", "hasSave", "saveLabel", "cancelLabel", "isSaveIsPrimary", "saveLoading", "cancelClicked", "saveClicked", "resetClicked", "clearFormClicked"]], template: function ExFormDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ex-form", 0);
            i0.ɵɵlistener("keydown.escape", function ExFormDialogComponent_Template_ex_form_keydown_escape_0_listener() { return !ctx.saveLoading && !!ctx.negativeLabel ? ctx.cancelClicked() : null; });
            i0.ɵɵelementStart(1, "mat-dialog-content", 1);
            i0.ɵɵelement(2, "ex-dialog-content", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-dialog-actions", 3)(5, "ex-inline-editing-buttons", 4);
            i0.ɵɵlistener("cancelClicked", function ExFormDialogComponent_Template_ex_inline_editing_buttons_cancelClicked_5_listener() { return ctx.cancelClicked(); })("saveClicked", function ExFormDialogComponent_Template_ex_inline_editing_buttons_saveClicked_5_listener() { return ctx.saveClicked(); })("resetClicked", function ExFormDialogComponent_Template_ex_inline_editing_buttons_resetClicked_5_listener() { return ctx.resetClicked(); })("clearFormClicked", function ExFormDialogComponent_Template_ex_inline_editing_buttons_clearFormClicked_5_listener() { return ctx.clearFormClicked(); });
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.formGroup)("formErrorLabels", ctx.formErrorLabels);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("message", ctx.message)("list", ctx.list)("confirmation", ctx.confirmation)("negativeLabel", ctx.negativeLabel)("positiveLabel", ctx.positiveLabel)("isPositiveButtonIsPrimary", ctx.isPositiveButtonIsPrimary)("type", ctx.type)("title", ctx.title)("titleIcon", ctx.titleIcon)("saveLoading", ctx.saveLoading)("component", ctx.component)("identifier", ctx.identifier);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hasDelete", false)("hasClearForm", ctx.hasClearFormButton)("hasReset", ctx.hasReset)("hasCancel", !!ctx.negativeLabel && !ctx.saveLoading)("hasSave", ctx.hasSave)("saveLabel", ctx.positiveLabel)("cancelLabel", ctx.negativeLabel)("isSaveIsPrimary", ctx.isPositiveButtonIsPrimary)("saveLoading", ctx.saveLoading);
        } }, dependencies: [i1$7.MatDialogContent, i1$7.MatDialogActions, ExInlineEditingButtonsComponent, i1$6.NgControlStatusGroup, i1$6.FormGroupDirective, ExFormComponent, ExFormGroupDirective, ExFormErrorLabels, exShortcutsScopeDirective, ExDialogContentComponent], styles: ["ex-form-dialog[_ngcontent-%COMP%]     .ex-dialog-title{margin-bottom:30px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFormDialogComponent, [{
        type: Component,
        args: [{ selector: 'ex-form-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ex-form [formGroup]=\"formGroup\" exShortcutsScope=\"dialog\" (keydown.escape)=\"(!saveLoading && !!negativeLabel) ? cancelClicked() : null\" [formErrorLabels]=\"formErrorLabels\">\r\n  <mat-dialog-content class=\"ex-dialog-content\">\r\n    <ex-dialog-content [message]=\"message\" [list]=\"list\" [confirmation]=\"confirmation\"\r\n                         [negativeLabel]=\"negativeLabel\" [positiveLabel]=\"positiveLabel\"\r\n                         [isPositiveButtonIsPrimary]=\"isPositiveButtonIsPrimary\"\r\n                         [type]=\"type\" [title]=\"title\" [titleIcon]=\"titleIcon\" [saveLoading]=\"saveLoading\"\r\n                         [component]=\"component\" [identifier]=\"identifier\"\r\n                         ></ex-dialog-content>\r\n    <ng-content></ng-content>\r\n  </mat-dialog-content>\r\n  <mat-dialog-actions align=\"end\" class=\"ex-dialog-actions\">\r\n  <ex-inline-editing-buttons [hasDelete] =\"false\" [hasClearForm]=\"hasClearFormButton\" [hasReset]=\"hasReset\" [hasCancel]=\"!!negativeLabel && !saveLoading\"\r\n                             (cancelClicked)=\"cancelClicked()\" (saveClicked)=\"saveClicked()\" (resetClicked)=\"resetClicked()\" (clearFormClicked)=\"clearFormClicked()\"\r\n                             [hasSave]=\"hasSave\" [saveLabel]=\"positiveLabel\" [cancelLabel]=\"negativeLabel\"\r\n                             [isSaveIsPrimary]=\"isPositiveButtonIsPrimary\" [saveLoading]=\"saveLoading\">\r\n  </ex-inline-editing-buttons>\r\n  </mat-dialog-actions>\r\n</ex-form>\r\n\r\n", styles: ["ex-form-dialog ::ng-deep .ex-dialog-title{margin-bottom:30px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$7.MatDialogRef, decorators: [{
                type: Optional
            }] }]; }, { formGroup: [{
            type: Input
        }], hasClearFormButton: [{
            type: Input
        }], formErrorLabels: [{
            type: Input
        }], saveClickedEmitter: [{
            type: Output,
            args: ['saveClicked']
        }], resetClickedEmitter: [{
            type: Output,
            args: ['resetClicked']
        }], clearFormClickedEmitter: [{
            type: Output,
            args: ['clearFormClicked']
        }] }); })();

class ExDialogModule {
    static { this.ɵfac = function ExDialogModule_Factory(t) { return new (t || ExDialogModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDialogModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatDialogModule,
            MatButtonModule,
            ExSvgIconModule,
            TranslateModule,
            ExButtonModule,
            ExInlineEditingButtonsModule,
            ExFormsModule,
            ExComponentLoaderModule,
            ExDirectivesModule,
            EXPipesModule,
            ExCheckboxModule,
            DragDropModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatDialogModule,
                    MatButtonModule,
                    ExSvgIconModule,
                    TranslateModule,
                    ExButtonModule,
                    ExInlineEditingButtonsModule,
                    ExFormsModule,
                    ExComponentLoaderModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    ExCheckboxModule,
                    DragDropModule
                ],
                declarations: [
                    ExBreakLinePipe,
                    ExDialogComponent,
                    ExFormDialogComponent,
                    ExDialogContentComponent
                ],
                exports: [
                    ExDialogComponent,
                    ExFormDialogComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDialogModule, { declarations: [ExBreakLinePipe,
        ExDialogComponent,
        ExFormDialogComponent,
        ExDialogContentComponent], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule,
        ExSvgIconModule,
        TranslateModule,
        ExButtonModule,
        ExInlineEditingButtonsModule,
        ExFormsModule,
        ExComponentLoaderModule,
        ExDirectivesModule,
        EXPipesModule,
        ExCheckboxModule,
        DragDropModule], exports: [ExDialogComponent,
        ExFormDialogComponent] }); })();
i0.ɵɵsetComponentScope(ExDialogComponent, [i1$7.MatDialogContent, i1$7.MatDialogActions, ExInlineEditingButtonsComponent, exShortcutsScopeDirective, ExDialogContentComponent], [ExGenerateIdPipe]);

/**
 * Marks components which are deprecated.
 * Can be set in advance with a deprecation date to mark the component as deprecated only from that date onwards.
 *
 * @param replacementComponentSelector - the selector of the component that replaces the deprecated component.
 * @param options - Partial<{ phaseOneDate: Date, phaseTwoDate: Date }>
 *   phaseOneDate - If defined, the date from which a warning message will be displayed in the console.
 *   phaseTwoDate - if defined, the date from which a message banner will be displayed.
 */
function ExDeprecated(replacementComponentSelector, options) {
    const { phaseOneSprint, phaseTwoSprint } = options ?? {};
    const isDeprecated = !phaseOneSprint || new Date(phaseOneSprint).getTime() <= Date.now();
    const displayBanner = phaseTwoSprint && new Date(phaseTwoSprint)?.getTime() <= Date.now();
    return (Base) => {
        return class Deprecated extends Base {
            constructor(...args) {
                super(...args);
                if (isDevMode()) {
                    const selector = Deprecated.decorators?.[0]?.args[0]?.selector;
                    const message = `The component ${selector} is deprecated. Use ${replacementComponentSelector} instead.`;
                    if (isDeprecated)
                        console.warn(`%c${message}`, "font-size:30px; font-weight: bold");
                    if (displayBanner)
                        displayInBanner(message);
                }
            }
        };
    };
}
function displayInBanner(message) {
    let elem = document.getElementById('ex-ng-dev-warning-banner');
    if (!elem) {
        elem = document.createElement('div');
        elem.setAttribute('id', 'ex-ng-dev-warning-banner');
        elem.style.cssText = 'position: absolute; width: 100ppx; height: 100px; z-index:100; background: orange; width: 100%; padding-inline-start: 10px; padding-top: 10px;';
        document.body.appendChild(elem);
    }
    elem.innerHTML += message;
}
var DevSprints;
(function (DevSprints) {
    DevSprints["S2023JUL"] = "2023/04/30";
    DevSprints["S2023AUG"] = "2023/05/29";
    DevSprints["S2023SEP"] = "2023/06/26";
    DevSprints["S2023OCT"] = "2023/07/24";
    DevSprints["S2023NOV"] = "2023/08/21";
    DevSprints["S2023DEC"] = "2023/09/14";
    DevSprints["S2024JAN"] = "2023/10/22";
    DevSprints["S2024FEB"] = "2023/11/20";
    DevSprints["S2024MAR"] = "2023/12/19";
    DevSprints["S2024APR"] = "2024/01/17";
    DevSprints["S2024MAY"] = "2024/02/15";
    DevSprints["S2024JUN"] = "2024/03/17";
    DevSprints["S2024JUL"] = "2024/04/15";
    DevSprints["S2024AUG"] = "2024/05/26";
    DevSprints["S2024SEP"] = "2024/06/24";
    DevSprints["S2024OCT"] = "2024/07/24";
    DevSprints["S2024NOV"] = "2024/08/24";
    DevSprints["S2024DEC"] = "2024/09/24";
})(DevSprints || (DevSprints = {}));

var ExDropdownComponent_1;
const _c0$1g = ["status"];
const _c1$N = ["matMenuTrigger"];
const _c2$y = ["menu"];
const _c3$p = ["matMenuContent"];
function ExDropdownComponent_ng_container_0_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainer(3, 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(9);
    const _r5 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    let tmp_0_0;
    let tmp_6_0;
    let tmp_7_0;
    i0.ɵɵclassMapInterpolate1("ex-dropdown-selected sel-ex-dropdown-selected-button ", i0.ɵɵpipeBind1(1, 12, "ex-dropdown-selected-button-" + ((tmp_0_0 = ctx_r2.selected == null ? null : ctx_r2.selected.value) !== null && tmp_0_0 !== undefined ? tmp_0_0 : ctx_r2.selectedValue)), "");
    i0.ɵɵstyleProp("color", ctx_r2.selectedTextColor);
    i0.ɵɵproperty("matMenuTriggerFor", _r8)("exTooltip", ctx_r2.selected.description)("disabled", ctx_r2.disabled)("id", ctx_r2.dropdownButtonId);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 14, (tmp_6_0 = ctx_r2.buttonAriaLabel) !== null && tmp_6_0 !== undefined ? tmp_6_0 : ctx_r2.selected == null ? null : ctx_r2.selected.value == null ? null : ctx_r2.selected.value.toString()))("aria-labelledby", (tmp_7_0 = ctx_r2.ariaLabelledBy) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
const _c4$k = function (a0) { return { "ex-dropdown-side-trigger-start": a0 }; };
function ExDropdownComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function ExDropdownComponent_ng_container_0_ng_template_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const _r13 = i0.ɵɵreference(5); return i0.ɵɵresetView(_r13.openMenu()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainer(3, 14);
    i0.ɵɵelementStart(4, "div", 16, 17);
    i0.ɵɵlistener("menuOpened", function ExDropdownComponent_ng_container_0_ng_template_2_Template_div_menuOpened_4_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onSideMenuOpened()); })("menuClosed", function ExDropdownComponent_ng_container_0_ng_template_2_Template_div_menuClosed_4_listener() { i0.ɵɵrestoreView(_r15); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onSideMenuClosed()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(5);
    const _r8 = i0.ɵɵreference(9);
    const ctx_r4 = i0.ɵɵnextContext();
    let tmp_6_0;
    i0.ɵɵclassMapInterpolate1("ex-dropdown-selected button-side-trigger sel-ex-dropdown-selected-button ", i0.ɵɵpipeBind1(1, 14, "ex-dropdown-selected-button-side-" + (ctx_r4.selected == null ? null : ctx_r4.selected.value)), "");
    i0.ɵɵstyleProp("color", ctx_r4.selectedTextColor);
    i0.ɵɵattributeInterpolate2("aria-labelledby", "", ctx_r4.ariaLabelledBy, " ", ctx_r4.dropdownButtonId, "");
    i0.ɵɵproperty("exTooltip", ctx_r4.selected.description)("disabled", ctx_r4.disabled)("id", ctx_r4.dropdownButtonId);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 16, (tmp_6_0 = ctx_r4.buttonAriaLabel) !== null && tmp_6_0 !== undefined ? tmp_6_0 : ctx_r4.selected == null ? null : ctx_r4.selected.value == null ? null : ctx_r4.selected.value.toString()));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r8)("ngClass", i0.ɵɵpureFunction1(18, _c4$k, ctx_r4.triggerAtStart));
} }
function ExDropdownComponent_ng_container_0_ng_template_4_i_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 23);
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r18.buttonIcon);
} }
const _c5$h = function (a0) { return { "ex-dropdown-disabled": a0 }; };
function ExDropdownComponent_ng_container_0_ng_template_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5$h, ctx_r19.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r19.selected.value.toString()));
} }
function ExDropdownComponent_ng_container_0_ng_template_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5$h, ctx_r20.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r20.placeholder));
} }
function ExDropdownComponent_ng_container_0_ng_template_4_ex_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 26);
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("iconName", ctx_r21.selected.icon.iconName)("iconType", ctx_r21.selected.icon.iconType || "svg")("sizePx", ctx_r21.selectedFontSize);
} }
const _c6$f = function (a0, a1, a2, a3) { return { "uxf-down-caret": a0, "uxf-right-caret": a1, "uxf-left-caret": a2, "sel-dropdown-arrow-to-side": a3 }; };
function ExDropdownComponent_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExDropdownComponent_ng_container_0_ng_template_4_i_0_Template, 1, 1, "i", 18);
    i0.ɵɵtemplate(1, ExDropdownComponent_ng_container_0_ng_template_4_span_1_Template, 3, 6, "span", 19);
    i0.ɵɵtemplate(2, ExDropdownComponent_ng_container_0_ng_template_4_span_2_Template, 3, 6, "span", 20);
    i0.ɵɵtemplate(3, ExDropdownComponent_ng_container_0_ng_template_4_ex_icon_3_Template, 1, 3, "ex-icon", 21);
    i0.ɵɵelement(4, "i", 22);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r6.buttonIcon && !ctx_r6.openToSide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.selected.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.selected.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.selected.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-dropdown-disabled", ctx_r6.disabled);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(7, _c6$f, !ctx_r6.openToSide, ctx_r6.openToSide && ctx_r6._dir === "ltr", ctx_r6.openToSide && ctx_r6._dir !== "ltr", ctx_r6.openToSide));
} }
function ExDropdownComponent_ng_container_0_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r10.title));
} }
function ExDropdownComponent_ng_container_0_ng_container_13_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 34);
} }
function ExDropdownComponent_ng_container_0_ng_container_13_hr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 35);
} }
const _c7$c = function (a0) { return { "ex-dropdown-hasBorder": a0 }; };
function ExDropdownComponent_ng_container_0_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function ExDropdownComponent_ng_container_0_ng_container_13_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const item_r22 = restoredCtx.$implicit; const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onChange(item_r22)); })("keydown.enter", function ExDropdownComponent_ng_container_0_ng_container_13_Template_button_keydown_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const item_r22 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onChange(item_r22)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵelement(4, "ex-label", 30);
    i0.ɵɵelementStart(5, "div", 31);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ExDropdownComponent_ng_container_0_ng_container_13_i_7_Template, 1, 0, "i", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ExDropdownComponent_ng_container_0_ng_container_13_hr_8_Template, 1, 0, "hr", 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    const isLast_r24 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate2("ex-dropdown-item sel-dropdown-", i_r23, "-item ", i0.ɵɵpipeBind1(2, 15, "ex-dropdown-history-item-" + item_r22.value), "");
    i0.ɵɵproperty("id", item_r22.value)("ngClass", i0.ɵɵpureFunction1(17, _c7$c, item_r22.hasBorder));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconType", item_r22.icon == null ? null : item_r22.icon.iconType)("iconName", item_r22.icon == null ? null : item_r22.icon.iconName)("iconColor", item_r22.disable ? "#b1a9a9" : item_r22.icon == null ? null : item_r22.icon.iconColor)("iconSize", item_r22.icon == null ? null : item_r22.icon.iconSize)("iconStyle", item_r22.icon == null ? null : item_r22.icon.iconStyle)("value", item_r22 == null ? null : item_r22.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r22.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r22.isHistoryItem);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isLast_r24);
} }
function ExDropdownComponent_ng_container_0_ng_container_14_hr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 37);
} }
function ExDropdownComponent_ng_container_0_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function ExDropdownComponent_ng_container_0_ng_container_14_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r34); const item_r30 = restoredCtx.$implicit; const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.onChange(item_r30)); })("keydown.enter", function ExDropdownComponent_ng_container_0_ng_container_14_Template_button_keydown_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r34); const item_r30 = restoredCtx.$implicit; const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.onChange(item_r30)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵelement(4, "ex-label", 30);
    i0.ɵɵelementStart(5, "div", 31);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(7, ExDropdownComponent_ng_container_0_ng_container_14_hr_7_Template, 1, 0, "hr", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    const i_r31 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate2("ex-dropdown-item sel-dropdown-", i_r31, "-item ", i0.ɵɵpipeBind1(2, 15, "ex-dropdown-item-" + item_r30.value), "");
    i0.ɵɵproperty("id", item_r30.value)("ngClass", i0.ɵɵpureFunction1(17, _c7$c, item_r30.hasBorder));
    i0.ɵɵattribute("aria-selected", ctx_r12.selected.value === item_r30.label);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconType", item_r30.icon == null ? null : item_r30.icon.iconType)("iconName", item_r30.icon == null ? null : item_r30.icon.iconName)("iconColor", item_r30.disable ? "#b1a9a9" : item_r30.icon == null ? null : item_r30.icon.iconColor)("iconSize", item_r30.icon == null ? null : item_r30.icon.iconSize)("iconStyle", item_r30.icon == null ? null : item_r30.icon.iconStyle)("value", item_r30 == null ? null : item_r30.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r30.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.multiLined && i_r31 !== ctx_r12.values.length - 1);
} }
function ExDropdownComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExDropdownComponent_ng_container_0_button_1_Template, 4, 16, "button", 2);
    i0.ɵɵtemplate(2, ExDropdownComponent_ng_container_0_ng_template_2_Template, 6, 20, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, ExDropdownComponent_ng_container_0_ng_template_4_Template, 5, 12, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(6, "i", 5, 6);
    i0.ɵɵelementStart(8, "mat-menu", 7, 8);
    i0.ɵɵlistener("closed", function ExDropdownComponent_ng_container_0_Template_mat_menu_closed_8_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.onBlur()); });
    i0.ɵɵelementStart(10, "div", 9, 10);
    i0.ɵɵtemplate(12, ExDropdownComponent_ng_container_0_span_12_Template, 3, 3, "span", 11);
    i0.ɵɵtemplate(13, ExDropdownComponent_ng_container_0_ng_container_13_Template, 9, 19, "ng-container", 12);
    i0.ɵɵtemplate(14, ExDropdownComponent_ng_container_0_ng_container_14_Template, 8, 19, "ng-container", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.openToSide)("ngIfElse", _r3);
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("aria-label", ctx_r0.statusMsg);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-activedescendant", ctx_r0.selectedOptionId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.historyItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.values);
} }
function ExDropdownComponent_ex_display_text_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-display-text", 38);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.selected.value ? ctx_r1.selected.value.toString() : ctx_r1.placeholder)("type", "text")("textAlign", "left");
} }
let ExDropdownComponent = class ExDropdownComponent extends ExControlValueAccessor {
    static { ExDropdownComponent_1 = this; }
    /**
     * an aria-label to add on the button. can be formatted with {{ value }}
     * to include current selected value
     */
    set buttonAriaLabel(ariaLabel) {
        this._buttonAriaLabel = ariaLabel;
    }
    get buttonAriaLabel() {
        return (this._buttonAriaLabel != undefined && this._buttonAriaLabel.length > 0) ? this._buttonAriaLabel : this.placeholder;
    }
    /**
     * @ignore
     */
    constructor(translate, sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * the values to be placed in the dropdown
         * value - the value that will be sent with the selectedValueChange event
         * label - the label that will be displayed in the dropdown
         * icon - the icon - optional
         * hasBorder - determine if the item will have a bottom border - optional
         * description - the description of the item - optional
         */
        this.values = [];
        /**
         * event fired whenever an item inside the dropdown is clicked
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * event fired whenever the item selected in the dropdown changes, emits the item.
         */
        this.selectedItemChange = new EventEmitter();
        /**
         * the color of the selected text - default is #222
         */
        this.selectedTextColor = '#222';
        /**
         * the font size of the selected text - default is 16px
         */
        this.selectedFontSize = '16px';
        /**
         * indicates if the dropdown items have multilines
         */
        this.multiLined = false;
        /**
         * the placeholder to be shown if no selected value was given
         */
        this.placeholder = "ng.general.select_value";
        /**
         * prevent the placeholder from changing to the selected value after selection.
         */
        this.pinPlaceholder = false;
        this.selected = { value: null, label: null, icon: null, description: null };
        this.displayAriaLabel = this.translate.instant(this.placeholder);
        this._buttonAriaLabel = '';
        /**
         * for accessibility - if you want to associate the dropdown with an outside label pass the unique label id here
         */
        this.ariaLabelledBy = null;
        this.statusMsg = "";
        // for accessibility
        this.selectedOptionId = null;
        this.dropdownButtonId = null;
        /**
         * whether to open the mat-menu to the side of the trigger
         */
        this.openToSide = false;
        this._dir = "ltr";
        this.triggerAtStart = false;
        this.triggerSideToggled = false;
    }
    ngOnInit() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
        const selected = this.values.find(val => val.value === this.selectedValue);
        this.setSelectedValue(selected);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedValue')) {
            const selectedValue = changes.selectedValue;
            const { previousValue, currentValue } = selectedValue;
            if (previousValue !== currentValue) {
                const selected = this.values.find(val => val.value === currentValue);
                this.setSelected(selected);
            }
            this.updateButtonAriaLabel();
        }
        if (changes.hasOwnProperty('values')) {
            this.values = changes.values.currentValue;
            const selected = this.values.find(val => val.value === this.selectedValue);
            this.setSelected(selected);
            this.initHistoryItems();
        }
    }
    initHistoryItems() {
        if (this.values.length > 0) {
            this.historyItems = [];
            this.values.forEach(item => {
                if (item.isHistoryItem) {
                    this.historyItems.push(item);
                }
            });
            this.historyItems = [...this.historyItems];
            this.values = this.values.filter(item => item.isHistoryItem != true);
        }
    }
    setSelected(item) {
        if (!this.setSelectedValue(item)) {
            return;
        }
        this.selectedItemChange.emit(item);
    }
    setSelectedValue(item) {
        if (!item) {
            return false;
        }
        if (!this.pinPlaceholder) {
            if (item.icon) {
                this.selected.value = null;
                this.selected.icon = item.icon;
                if (item.description) {
                    this.selected.description = item.description;
                }
            }
            else if (item.value) {
                this.selectedOptionId = item.value;
                this.selected.icon = null;
                this.selected.value = item.label;
                this.selectedValue = item.label;
                if (item.description) {
                    this.selected.description = item.description;
                }
            }
        }
        return true;
    }
    onChange(selectedValue) {
        this.selectedOptionId = selectedValue.value;
        this.setSelected(selectedValue);
        this.statusMsg = this.translate.instant('ng.facets.status_msg.item_had_chosen_changes_applied', { value: selectedValue.value });
        this.selectedValueChange.emit(selectedValue.value);
    }
    writeValue(value) {
        this.selectedValue = value;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    updateButtonAriaLabel() {
        const value = { value: this.selected?.value?.toString() ?? '' };
        this.displayAriaLabel = this.buttonAriaLabel ? this.translate.instant(this.buttonAriaLabel, value) : this.buttonAriaLabel;
        if (this.displayAriaLabel) {
            this.dropdownButtonId = "dropdownButtonId" + this.displayAriaLabel.replace(' ', '_');
        }
    }
    onSideMenuOpened() {
        if (this.triggerSideToggled) {
            this.triggerSideToggled = false;
            return;
        }
        const matMenuPanel = document.getElementById(this.matMenu.panelId);
        if (matMenuPanel)
            matMenuPanel.style.visibility = "hidden";
        let triggerElemRect;
        let menuElemRect;
        setTimeout(() => {
            menuElemRect = this.elementBounds(this.menuContentElem.nativeElement);
            triggerElemRect = this.elementBounds(this.triggerElem.nativeElement);
            if (this._dir == "ltr" ? (menuElemRect?.left - triggerElemRect?.left) < -1 : (menuElemRect?.right - triggerElemRect?.right) > 1) {
                this.toggleTriggerSide();
            }
            if (matMenuPanel)
                matMenuPanel.style.visibility = "visible";
        }, 0);
    }
    toggleTriggerSide() {
        this.trigger.closeMenu();
        this.triggerAtStart = !this.triggerAtStart;
        this.triggerSideToggled = true;
        this.trigger.openMenu();
    }
    onSideMenuClosed() {
        this.triggerAtStart = false;
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { left, right } = el.getBoundingClientRect();
        return {
            right: right,
            left: left,
        };
    }
    static { this.ɵfac = function ExDropdownComponent_Factory(t) { return new (t || ExDropdownComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDropdownComponent, selectors: [["ex-dropdown"]], viewQuery: function ExDropdownComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1g, 5);
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(_c1$N, 5, ElementRef);
            i0.ɵɵviewQuery(_c2$y, 5);
            i0.ɵɵviewQuery(_c3$p, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.statusRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuContentElem = _t.first);
        } }, hostBindings: function ExDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedValueChange", function ExDropdownComponent_selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExDropdownComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { values: "values", selectedValue: "selectedValue", selectedTextColor: "selectedTextColor", selectedFontSize: "selectedFontSize", multiLined: "multiLined", placeholder: "placeholder", pinPlaceholder: "pinPlaceholder", buttonIcon: "buttonIcon", title: "title", buttonAriaLabel: "buttonAriaLabel", ariaLabelledBy: "ariaLabelledBy", openToSide: "openToSide" }, outputs: { selectedValueChange: "selectedValueChange", selectedItemChange: "selectedItemChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExDropdownComponent_1)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "value", "type", "textAlign", 4, "ngIf"], ["mat-button", "", "attr.aria-haspopup", "listbox", 3, "color", "class", "matMenuTriggerFor", "exTooltip", "disabled", "id", 4, "ngIf", "ngIfElse"], ["triggerSide", ""], ["buttonContent", ""], ["role", "status", "aria-live", "polite"], ["status", ""], [3, "closed"], ["menu", "matMenu"], ["role", "listbox", 1, "ex-dropdown-menu-wrapper"], ["matMenuContent", ""], ["class", "ex-dropdown-title", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["mat-button", "", "attr.aria-haspopup", "listbox", 3, "matMenuTriggerFor", "exTooltip", "disabled", "id"], [3, "ngTemplateOutlet"], ["mat-button", "", "attr.aria-haspopup", "listbox", 3, "exTooltip", "disabled", "id", "click"], [1, "ex-dropdown-side-trigger", 3, "matMenuTriggerFor", "ngClass", "menuOpened", "menuClosed"], ["matMenuTrigger", "matMenuTrigger"], [3, "ngClass", 4, "ngIf"], ["class", "ex-dropdown-value", 3, "ngClass", 4, "ngIf"], ["class", "ex-dropdown-placeholder", 3, "ngClass", 4, "ngIf"], ["class", "ex-dropdown-icon", 3, "iconName", "iconType", "sizePx", 4, "ngIf"], [1, "uxf-icon", "sel-dropdown-arrow", 3, "ngClass"], [3, "ngClass"], [1, "ex-dropdown-value", 3, "ngClass"], [1, "ex-dropdown-placeholder", 3, "ngClass"], [1, "ex-dropdown-icon", 3, "iconName", "iconType", "sizePx"], [1, "ex-dropdown-title"], ["mat-menu-item", "", "role", "menuitem", 3, "id", "ngClass", "click", "keydown.enter"], [1, "ex-dropdown-item-text-wrapper"], [3, "iconType", "iconName", "iconColor", "iconSize", "iconStyle", "value"], [1, "ex-dropdown-item-description"], ["class", "uxf-icon uxf-back-in-time history-icon", 4, "ngIf"], ["class", "last-history-entry", 4, "ngIf"], [1, "uxf-icon", "uxf-back-in-time", "history-icon"], [1, "last-history-entry"], ["class", "ex-dropdown-multilined-hr", 4, "ngIf"], [1, "ex-dropdown-multilined-hr"], [3, "value", "type", "textAlign"]], template: function ExDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExDropdownComponent_ng_container_0_Template, 15, 7, "ng-container", 0);
            i0.ɵɵtemplate(1, ExDropdownComponent_ex_display_text_1_Template, 1, 3, "ex-display-text", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isReadOnly);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i3$3.MatButton, i3$1.MatMenu, i3$1.MatMenuItem, i3$1.MatMenuTrigger, ExTooltipDirective, ExLabelComponent, ExIconComponent, ExDisplayTextComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-dropdown-selected[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;min-width:unset}.ex-dropdown-selected[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-dropdown-selected[_ngcontent-%COMP%]   .ex-dropdown-value[_ngcontent-%COMP%]{line-height:normal}.ex-dropdown-selected[_ngcontent-%COMP%]   .ex-dropdown-value.ex-dropdown-disabled[_ngcontent-%COMP%], .ex-dropdown-selected[_ngcontent-%COMP%]   span.ex-dropdown-placeholder.ex-dropdown-disabled[_ngcontent-%COMP%]{opacity:.5}.ex-dropdown-selected[_ngcontent-%COMP%]   i.sel-dropdown-arrow.sel-dropdown-arrow-to-side[_ngcontent-%COMP%]{margin:10px}.ex-dropdown-selected[_ngcontent-%COMP%]   i.sel-dropdown-arrow.ex-dropdown-disabled[_ngcontent-%COMP%]{opacity:.5}.last-history-entry[_ngcontent-%COMP%]{border-bottom:1px solid #ccc;margin:0}span.ex-dropdown-title[_ngcontent-%COMP%]{line-height:32px;margin:5px}.history-icon[_ngcontent-%COMP%]{margin-inline-start:10px}.ex-dropdown-item[_ngcontent-%COMP%]{display:flex;align-items:center;height:-moz-fit-content;height:fit-content;border-top:1px solid transparent;border-bottom:1px solid transparent;padding:5px 10px;white-space:pre-line}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ex-dropdown-item[_ngcontent-%COMP%]{height:auto!important}}@supports (-ms-ime-align: auto){.ex-dropdown-item[_ngcontent-%COMP%]{height:auto!important}}.ex-dropdown-item[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-dropdown-item[_ngcontent-%COMP%]   .ex-dropdown-item-text-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%}.ex-dropdown-item[_ngcontent-%COMP%]:hover, .ex-dropdown-item[_ngcontent-%COMP%]:focus{background:#f5f5f5;border:1px solid #898989;border-right:none;border-left:none}.ex-dropdown-multilined-hr[_ngcontent-%COMP%]{margin:0!important}.ex-dropdown-menu-wrapper[_ngcontent-%COMP%]{overflow-y:auto;overflow-x:hidden}.sel-ex-dropdown-selected-button[_ngcontent-%COMP%]:enabled:hover{background-color:#e5e5e5;outline:1px solid #898989}.sel-ex-dropdown-selected-button[_ngcontent-%COMP%]:disabled{opacity:.5}.button-side-trigger[_ngcontent-%COMP%]{width:100%;padding-inline-end:0px!important}.button-side-trigger[_ngcontent-%COMP%]     .mdc-button__label{width:100%;display:flex;justify-content:space-between;align-items:center}.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]{position:absolute;top:0}.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]:not(.ex-dropdown-side-trigger-start){inset-inline-end:-1px}.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger.ex-dropdown-side-trigger-start[_ngcontent-%COMP%]{inset-inline-start:-1px}"], changeDetection: 0 }); }
};
ExDropdownComponent = ExDropdownComponent_1 = __decorate([
    ExDeprecated('ex-new-combobox')
], ExDropdownComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDropdownComponent, [{
        type: Component,
        args: [{ selector: 'ex-dropdown', host: {
                    '(selectedValueChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExDropdownComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!isReadOnly\">\n  <button *ngIf=\"!openToSide; else triggerSide\" [style.color]=\"selectedTextColor\"\n    class=\"ex-dropdown-selected sel-ex-dropdown-selected-button {{'ex-dropdown-selected-button-'+(selected?.value ?? selectedValue) | generateHTMLId}}\" mat-button [matMenuTriggerFor]=\"menu\"\n    [exTooltip]=\"selected.description\" [disabled]=\"disabled\" [id]=\"dropdownButtonId\"\n    attr.aria-label=\"{{ (buttonAriaLabel ?? selected?.value?.toString()) | translate }}\" attr.aria-haspopup=\"listbox\"\n    attr.aria-labelledby=\"{{ariaLabelledBy ??''}}\">\n\n    <ng-container [ngTemplateOutlet]=\"buttonContent\"></ng-container>\n\n  </button>\n\n\n  <ng-template #triggerSide>\n    <button [style.color]=\"selectedTextColor\"\n      class=\"ex-dropdown-selected button-side-trigger sel-ex-dropdown-selected-button {{'ex-dropdown-selected-button-side-'+selected?.value | generateHTMLId}}\" mat-button\n      [exTooltip]=\"selected.description\" [disabled]=\"disabled\" [id]=\"dropdownButtonId\"\n      attr.aria-label=\"{{ (buttonAriaLabel ?? selected?.value?.toString()) | translate }}\" attr.aria-haspopup=\"listbox\"\n      attr.aria-labelledby=\"{{ariaLabelledBy}} {{dropdownButtonId}}\" (click)=\"matMenuTrigger.openMenu()\">\n\n      <ng-container [ngTemplateOutlet]=\"buttonContent\"></ng-container>\n\n      <div #matMenuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"menu\" class=\"ex-dropdown-side-trigger\"\n        [ngClass]=\"{ 'ex-dropdown-side-trigger-start': triggerAtStart }\" (menuOpened)=\"onSideMenuOpened()\"\n        (menuClosed)=\"onSideMenuClosed()\">\n      </div>\n    </button>\n  </ng-template>\n\n  <ng-template #buttonContent>\n    <i *ngIf=\"buttonIcon && !openToSide\" [ngClass]=\"buttonIcon\"></i>\n    <span *ngIf=\"selected.value\" class=\"ex-dropdown-value\"\n      [ngClass]=\"{ 'ex-dropdown-disabled': disabled }\">{{selected.value.toString() | translate }}</span>\n    <span class=\"ex-dropdown-placeholder\" *ngIf=\"!selected.value\" [ngClass]=\"{ 'ex-dropdown-disabled': disabled }\">{{\n      placeholder | translate }}</span>\n    <ex-icon *ngIf=\"selected.icon\" [iconName]=\"selected.icon.iconName\" [iconType]=\"selected.icon.iconType || 'svg'\"\n      class=\"ex-dropdown-icon\" [sizePx]=\"selectedFontSize\"></ex-icon>\n    <i class=\"uxf-icon sel-dropdown-arrow\" [class.ex-dropdown-disabled]=\"disabled\" [ngClass]=\"{'uxf-down-caret': !openToSide,\n    'uxf-right-caret': openToSide && _dir === 'ltr',\n    'uxf-left-caret': openToSide && _dir !== 'ltr',\n    'sel-dropdown-arrow-to-side':openToSide}\"></i>\n  </ng-template>\n\n  <i #status role=\"status\" attr.aria-label=\"{{ statusMsg }}\" aria-live=\"polite\"></i>\n\n  <mat-menu #menu=\"matMenu\" (closed)=\"onBlur()\">\n    <div #matMenuContent class=\"ex-dropdown-menu-wrapper\" role=\"listbox\"\n      [attr.aria-activedescendant]=\"selectedOptionId\">\n      <span *ngIf=\"title\" class=\"ex-dropdown-title\">{{title | translate}}</span>\n      <ng-container *ngFor=\"let item of historyItems;let i = index; last as isLast\">\n        <button [id]=\"item.value\" class=\"ex-dropdown-item sel-dropdown-{{i}}-item {{'ex-dropdown-history-item-'+item.value | generateHTMLId}}\" mat-menu-item\n          (click)=\"onChange(item)\" [ngClass]=\"{'ex-dropdown-hasBorder': item.hasBorder}\" role=\"menuitem\"\n          (keydown.enter)=\"onChange(item)\">\n          <div class=\"ex-dropdown-item-text-wrapper\">\n            <ex-label [iconType]=\"item.icon?.iconType\" [iconName]=\"item.icon?.iconName\"\n              [iconColor]=\"item.disable ? '#b1a9a9' : item.icon?.iconColor\" [iconSize]=\"item.icon?.iconSize\"\n              [iconStyle]=\"item.icon?.iconStyle\" [value]=\"item?.label\">\n            </ex-label>\n            <div class=\"ex-dropdown-item-description\">{{item.description}}</div>\n          </div>\n          <i *ngIf=\"item.isHistoryItem\" class=\"uxf-icon uxf-back-in-time history-icon\"></i>\n        </button>\n        <hr *ngIf=\"isLast\" class=\"last-history-entry\">\n      </ng-container>\n\n      <ng-container *ngFor=\"let item of values; let i = index\">\n        <button [id]=\"item.value\" class=\"ex-dropdown-item sel-dropdown-{{i}}-item {{'ex-dropdown-item-'+item.value | generateHTMLId}}\" mat-menu-item\n          (click)=\"onChange(item)\" [ngClass]=\"{'ex-dropdown-hasBorder': item.hasBorder}\" role=\"menuitem\"\n          (keydown.enter)=\"onChange(item)\" [attr.aria-selected]=\"selected.value === item.label\">\n\n          <div class=\"ex-dropdown-item-text-wrapper\">\n            <ex-label [iconType]=\"item.icon?.iconType\" [iconName]=\"item.icon?.iconName\"\n              [iconColor]=\"item.disable ? '#b1a9a9' : item.icon?.iconColor\" [iconSize]=\"item.icon?.iconSize\"\n              [iconStyle]=\"item.icon?.iconStyle\" [value]=\"item?.label\">\n            </ex-label>\n            <div class=\"ex-dropdown-item-description\">{{item.description}}</div>\n          </div>\n        </button>\n        <hr *ngIf=\"multiLined && i !== values.length - 1\" class=\"ex-dropdown-multilined-hr\">\n      </ng-container>\n    </div>\n  </mat-menu>\n</ng-container>\n<ex-display-text *ngIf=\"isReadOnly\" [value]=\"selected.value ? selected.value.toString() : placeholder\" [type]=\"'text'\"\n  [textAlign]=\"'left'\">\n</ex-display-text>\n", styles: [".ex-dropdown-selected{display:flex;align-items:center;justify-content:center;min-width:unset}.ex-dropdown-selected span{margin-inline-end:5px}.ex-dropdown-selected .ex-dropdown-value{line-height:normal}.ex-dropdown-selected .ex-dropdown-value.ex-dropdown-disabled,.ex-dropdown-selected span.ex-dropdown-placeholder.ex-dropdown-disabled{opacity:.5}.ex-dropdown-selected i.sel-dropdown-arrow.sel-dropdown-arrow-to-side{margin:10px}.ex-dropdown-selected i.sel-dropdown-arrow.ex-dropdown-disabled{opacity:.5}.last-history-entry{border-bottom:1px solid #ccc;margin:0}span.ex-dropdown-title{line-height:32px;margin:5px}.history-icon{margin-inline-start:10px}.ex-dropdown-item{display:flex;align-items:center;height:-moz-fit-content;height:fit-content;border-top:1px solid transparent;border-bottom:1px solid transparent;padding:5px 10px;white-space:pre-line}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ex-dropdown-item{height:auto!important}}@supports (-ms-ime-align: auto){.ex-dropdown-item{height:auto!important}}.ex-dropdown-item i{margin-inline-end:10px}.ex-dropdown-item .ex-dropdown-item-text-wrapper{display:flex;flex-direction:column;width:100%}.ex-dropdown-item:hover,.ex-dropdown-item:focus{background:#f5f5f5;border:1px solid #898989;border-right:none;border-left:none}.ex-dropdown-multilined-hr{margin:0!important}.ex-dropdown-menu-wrapper{overflow-y:auto;overflow-x:hidden}.sel-ex-dropdown-selected-button:enabled:hover{background-color:#e5e5e5;outline:1px solid #898989}.sel-ex-dropdown-selected-button:disabled{opacity:.5}.button-side-trigger{width:100%;padding-inline-end:0px!important}.button-side-trigger ::ng-deep .mdc-button__label{width:100%;display:flex;justify-content:space-between;align-items:center}.button-side-trigger .mat-mdc-menu-trigger{position:absolute;top:0}.button-side-trigger .mat-mdc-menu-trigger:not(.ex-dropdown-side-trigger-start){inset-inline-end:-1px}.button-side-trigger .mat-mdc-menu-trigger.ex-dropdown-side-trigger-start{inset-inline-start:-1px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { values: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], selectedItemChange: [{
            type: Output
        }], selectedTextColor: [{
            type: Input
        }], selectedFontSize: [{
            type: Input
        }], multiLined: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], pinPlaceholder: [{
            type: Input
        }], buttonIcon: [{
            type: Input
        }], title: [{
            type: Input
        }], buttonAriaLabel: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], statusRef: [{
            type: ViewChild,
            args: ["status"]
        }], openToSide: [{
            type: Input
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], triggerElem: [{
            type: ViewChild,
            args: ['matMenuTrigger', { read: ElementRef }]
        }], matMenu: [{
            type: ViewChild,
            args: ['menu']
        }], menuContentElem: [{
            type: ViewChild,
            args: ['matMenuContent', { read: ElementRef }]
        }] }); })();

class ExDropdownModule {
    static { this.ɵfac = function ExDropdownModule_Factory(t) { return new (t || ExDropdownModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDropdownModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            MatIconModule,
            MatMenuModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            ExLabelModule,
            ExIconModule,
            ExDisplayTextModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatIconModule,
                    MatMenuModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExLabelModule,
                    ExIconModule,
                    ExDisplayTextModule,
                    EXPipesModule
                ],
                declarations: [
                    ExDropdownComponent
                ],
                exports: [
                    ExDropdownComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDropdownModule, { declarations: [ExDropdownComponent], imports: [CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        ExLabelModule,
        ExIconModule,
        ExDisplayTextModule,
        EXPipesModule], exports: [ExDropdownComponent] }); })();

const SINGLE_SAVE_EDIT_ACTION_KEY = "_singleSaveEditAction_";
const PICKUP_ACTION_KEY = "_pickupAction_";
class ExItemsLayoutItems {
    /**
     * the currently selected item
     */
    set selectedItem(item) {
        this._selectedItem = item;
    }
    get selectedItem() {
        return this._selectedItem;
    }
    constructor(itemsLayoutService, exSectionsLayoutService) {
        this.itemsLayoutService = itemsLayoutService;
        this.exSectionsLayoutService = exSectionsLayoutService;
        /**
         * the collection of items
         */
        this.items = [];
        /**
         * list of all items that are checked
         */
        this.checkedItems = [];
        /**
         * whether the layout is in side-by-side mode
         */
        this.isItemOpen = false;
        /**
         * whether the layout items are ready to load
         */
        this.readyToLoad = false;
        /**
         * emits the selected item when the selected item changes
         */
        this.selectedItemChange = new EventEmitter();
        /**
         * emits the item that has beed selected by the user when the user selects an item (clicks on the item)
         */
        this.itemClicked = new EventEmitter();
        /**
         * emits the item that has beed deselected by the user when the user deselects an item
         */
        this.itemDeselected = new EventEmitter();
        /**
         * emits the item that the user has clicked when an item is clicked
         */
        this.itemSelected = new EventEmitter();
        /**
         * emits the the action key and the item for which an action was clicked when an item action is clicked
         */
        this.itemActionClicked = new EventEmitter();
        /**
         * emits the checked state and the item for which the checked state was changed when the checked state of an item changes
         */
        this.itemCheckboxChanged = new EventEmitter();
        /**
         * emits the checked items list when the checked items list changes
         */
        this.checkedItemsChanged = new EventEmitter();
        /**
         * emits when the user tabs out of an item
         */
        this.tabOutFromItemEnd = new EventEmitter();
        /**
         * emits when the items layout is resized
         */
        this.resizeEvent = new EventEmitter();
        /**
         * emits when the layout is customized from within the layout (e.g. user changes grid columns width)
         */
        this.layoutCustomized = new EventEmitter();
        this._subscription = new Subscription();
        this.SINGLE_SAVE_EDIT_ACTION_KEY = SINGLE_SAVE_EDIT_ACTION_KEY;
        this.emitResizeEventCB = this.emitResizeEvent.bind(this);
        if (this.ngOnInit !== ExItemsLayoutItems.prototype.ngOnInit) {
            throw new Error('Use onComponentInit instead of ngOnInit');
        }
        if (this.ngOnDestroy !== ExItemsLayoutItems.prototype.ngOnDestroy) {
            throw new Error('Use onComponentDestroy instead of ngOnDestroy');
        }
    }
    ngOnInit() {
        this.initSubscriptions();
        this.onComponentInit();
    }
    onComponentInit() { }
    initSubscriptions() {
        this._subscription.add(this.itemsLayoutService.onItemsReloaded().subscribe(() => this.onItemsReloaded()));
        this._subscription.add(this.itemsLayoutService.onNextClicked().subscribe(() => this.selectNextItem()));
        this._subscription.add(this.itemsLayoutService.onPreviousClicked().subscribe(() => this.selectPreviousItem()));
        this._subscription.add(this.itemsLayoutService.onSetCurrentItemsChecked().subscribe((state) => this.updateDisplayedItemsCheckedState(state)));
        this._subscription.add(this.itemsLayoutService.onActionPerformed().subscribe((action) => this.actionsHandler(action.key, action.items)));
        this._subscription.add(this.itemsLayoutService.onItemsDeleted().subscribe(() => this.onItemsDeleted()));
        this._subscription.add(merge(this.itemsLayoutService.onItemDetailsClosed(), this.itemsLayoutService.onItemDetailsStartReached()).subscribe(() => this.focusSelectedItem()));
        this._subscription.add(this.itemsLayoutService.onItemDetailsEndReached().subscribe(() => this.onItemDetailsEndReached()));
        this._subscription.add(this.itemsLayoutService.onSelectItemById().subscribe(id => this.selectItemById(id)));
        if (this.listParametersItemIdUpdatedObservable) {
            this._subscription.add(this.listParametersItemIdUpdatedObservable.subscribe(id => this.onListParametersItemIdUpdated(id)));
        }
    }
    ngOnDestroy() {
        this._subscription.unsubscribe();
    }
    onComponentDestroy() { }
    /**
     * updates the checked state of all items that are currently visible
     * @param checked - the checked state
     */
    updateDisplayedItemsCheckedState(checked) {
        this.getAllVisibleItems().forEach((item) => {
            if (item.selectable !== false)
                this.updateItemChecked(item, checked);
        });
        this.itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        this.checkedItemsChanged.emit(this.checkedItems);
    }
    /**
     * updates the checked state of the given item
     * @param item - the item for which to update the checked state
     * @param checked - the checked state
     */
    updateItemChecked(item, checked) {
        const actionFunction = checked ? this.addToCheckedItems.bind(this) : this.removeFromCheckedItems.bind(this);
        actionFunction(item) && this.itemCheckboxChanged.emit({ item, checked });
    }
    /*
    * if item exists in checkedItems, removes it.
    * returns true if item was removed, false otherwise.
    */
    removeFromCheckedItems(item) {
        const index = this.checkedItems.findIndex(curItem => curItem.id == item.id);
        if (index >= 0) {
            this.checkedItems.splice(index, 1);
            return true;
        }
        return false;
    }
    /*
    * if item does not exist in checkedItems, adds it.
    * returns true if item was added, false otherwise.
    */
    addToCheckedItems(item) {
        const index = this.checkedItems.findIndex(curItem => curItem.id == item.id);
        if (index < 0) {
            this.checkedItems.push(item);
            return true;
        }
        return false;
    }
    onActionClicked(item, key) {
        if (key === SINGLE_SAVE_EDIT_ACTION_KEY) {
            this.onSingleSaveEditClicked(item);
            return;
        }
        if (key === PICKUP_ACTION_KEY) {
            this.onItemCheckedChange(item, true);
            return;
        }
        this.itemActionClicked.emit({ item: item, key: key });
    }
    onSingleSaveEditClicked(item) {
        iif(() => this.isItemOpen && item.id == this._selectedItem.id, of(true), this.exSectionsLayoutService.sectionsLayoutInitialized$.pipe(take(1), delay(5)))
            .subscribe(() => this.exSectionsLayoutService.doEditAllSections());
    }
    isItemChecked(item) {
        return this.checkedItems.findIndex(curItem => curItem.id === item.id) !== -1;
    }
    onItemCheckedChange(item, checked) {
        event.stopImmediatePropagation();
        this.updateItemChecked(item, checked);
        this.itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        this.checkedItemsChanged.emit(this.checkedItems);
    }
    onRadioArrow(item, next) {
        let index = this.items.findIndex(curItem => curItem.id == item.id);
        const nextItem = this.items[index + next];
        this.onSingleItemCheckedChange(nextItem);
    }
    onSingleItemCheckedChange(item) {
        event.stopImmediatePropagation();
        const index = this.checkedItems.findIndex(curItem => curItem.id == item.id);
        if (index < 0) {
            this.checkedItems = [item];
        }
        this.itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        this.checkedItemsChanged.emit(this.checkedItems);
    }
    onTabFromRowEnd() {
        this.tabOutFromItemEnd.emit();
    }
    updateHasNexPrevious() {
        this.itemsLayoutService.updateHasNextItem(this.hasNextItem());
        this.itemsLayoutService.updateHasPreviousItem(this.hasPreviousItem());
    }
    onRowArrowDown(event, item = undefined) {
        if (!event)
            return;
        if (!(event.target['type'] === "radio")) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        if (event.target == event.currentTarget) {
            this.selectNextItem();
            this.focusSelectedItem();
        }
        if (this.listProperties.hasPickup && !this.listProperties.isMultiSelect && item) {
            this.onRadioArrow(item, 1);
        }
    }
    onRowArrowUp(event, item = undefined) {
        if (!event)
            return;
        if (!(event.target['type'] === "radio")) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        if (event.target == event.currentTarget) {
            this.selectPreviousItem();
            this.focusSelectedItem();
        }
        if (this.listProperties.hasPickup && !this.listProperties.isMultiSelect && item) {
            this.onRadioArrow(item, -1);
        }
    }
    emitResizeEvent(event) {
        this.resizeEvent.emit(event);
    }
    static { this.ɵfac = function ExItemsLayoutItems_Factory(t) { return new (t || ExItemsLayoutItems)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExItemsLayoutItems, inputs: { items: "items", selectedItem: "selectedItem", listParametersItemIdUpdatedObservable: "listParametersItemIdUpdatedObservable", checkedItems: "checkedItems", listProperties: "listProperties", isItemOpen: "isItemOpen", readyToLoad: "readyToLoad", pageCustomizationData: "pageCustomizationData" }, outputs: { selectedItemChange: "selectedItemChange", itemClicked: "itemClicked", itemDeselected: "itemDeselected", itemSelected: "itemSelected", itemActionClicked: "itemActionClicked", itemCheckboxChanged: "itemCheckboxChanged", checkedItemsChanged: "checkedItemsChanged", tabOutFromItemEnd: "tabOutFromItemEnd", resizeEvent: "resizeEvent", layoutCustomized: "layoutCustomized" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutItems, [{
        type: Directive
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }]; }, { items: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], listParametersItemIdUpdatedObservable: [{
            type: Input
        }], checkedItems: [{
            type: Input
        }], listProperties: [{
            type: Input
        }], isItemOpen: [{
            type: Input
        }], readyToLoad: [{
            type: Input
        }], pageCustomizationData: [{
            type: Input
        }], selectedItemChange: [{
            type: Output
        }], itemClicked: [{
            type: Output
        }], itemDeselected: [{
            type: Output
        }], itemSelected: [{
            type: Output
        }], itemActionClicked: [{
            type: Output
        }], itemCheckboxChanged: [{
            type: Output
        }], checkedItemsChanged: [{
            type: Output
        }], tabOutFromItemEnd: [{
            type: Output
        }], resizeEvent: [{
            type: Output
        }], layoutCustomized: [{
            type: Output
        }] }); })();

class ExItemsLayoutItemsFlat extends ExItemsLayoutItems {
    set selectedItem(item) {
        if (item == this._selectedItem)
            return;
        this._selectedItem = item;
        if (this._selectedItem) {
            this.scrollToSelectedItem();
        }
        this.updateHasNexPrevious();
    }
    get selectedItem() {
        return this._selectedItem;
    }
    constructor(itemsLayoutService, sectionsLayoutService, dialogService) {
        super(itemsLayoutService, sectionsLayoutService);
        this.dialogService = dialogService;
        this.leftSideWidth = 0;
        this.htmlId = '';
        this.hasItemDetailsComponent = false;
        this.selectedPageChange = new EventEmitter();
        this.pageSizeChange = new EventEmitter();
        this.endOfPagination = new EventEmitter();
        this.rowDraggedDropped = new EventEmitter();
        this._selectFirstAfterItemsChanges = false;
        this._selectLastAfterItemsChanges = false;
        this._focusSelectedItemAfterItemsChanges = false;
        this.numPlaceholderRows = 0;
        this.scrollToSelectedItem = debounce(() => {
            if (this.selectedItem) {
                const selectedIndex = this.getSelectedItemIndex();
                const selectedNativeElement = this.rowItems?.get(selectedIndex)?.nativeElement;
                if (selectedNativeElement)
                    scrollIntoView(selectedNativeElement, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        inline: 'nearest',
                    });
            }
        }, 1000);
        this.onResized = debounce((event) => {
            this.resizeEvent.emit(event);
        }, 50);
        this.onResizedCB = this.onResized.bind(this);
    }
    onComponentInit() {
        this.initPlaceholderRows();
    }
    initPlaceholderRows() {
        this.numPlaceholderRows = this.listProperties.placeHolderRowsNumber && this.listProperties.placeHolderRowsNumber > 0 ?
            this.listProperties.placeHolderRowsNumber :
            this.listProperties.pagination.pageSize;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.onItemsChanges();
            this.scrollToSelectedItem();
            this.itemsLayoutService.updateNumCurrentItems(this.numCurrentItems());
            this.itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        }
        if (changes.hasOwnProperty('checkedItems')) {
            this.itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        }
        this.componentOnChanges(changes);
    }
    // extending component can implement if needs to perform additional logic on changes
    componentOnChanges(changes) { }
    onItemsChanges() {
        if (this.items?.length > 0) {
            if (this._idToSelectAfterItemsChange) {
                this.selectItemById(this._idToSelectAfterItemsChange);
                this._idToSelectAfterItemsChange = null;
            }
            else if (this._itemsDeleted && this._nextItemAfterItemsDeleted) {
                this.selectedItem = this._nextItemAfterItemsDeleted;
                this._nextItemAfterItemsDeleted = undefined;
                this._itemsDeleted = false;
            }
            else if (this._selectFirstAfterItemsChanges) {
                this.selectedItem = this.items[0];
            }
            else if (this._selectedItem) {
                this.selectedItem = this.items.find(item => item.id == this._selectedItem.id);
            }
            if (!this._selectedItem) {
                if (this._selectLastAfterItemsChanges) {
                    this.selectedItem = this.items[this.items.length - 1];
                }
                else if (this.isItemOpen) {
                    this.selectedItem = this.items[0];
                }
            }
            this._selectFirstAfterItemsChanges = false;
            this._selectLastAfterItemsChanges = false;
            if (this._focusSelectedItemAfterItemsChanges) {
                this.rowItems.changes.pipe(take(1)).subscribe(() => this.focusSelectedItem());
                this._focusSelectedItemAfterItemsChanges = false;
            }
        }
        else {
            this.selectedItem = undefined;
        }
        //updateHasNexPrevious() // performed in selectedItem setter
        this.selectedItemChange.emit(this._selectedItem);
    }
    onItemsReloaded() {
        this._selectFirstAfterItemsChanges = true;
    }
    onListParametersItemIdUpdated(id) {
        this._idToSelectAfterItemsChange = id;
    }
    numCurrentItems() {
        return this.items?.length ?? 0;
    }
    hasNextItem() {
        return this.hasCurrentNextItem() || this.hasNextPage();
    }
    hasPreviousItem() {
        return this.hasCurrentPreviousItem() || this.hasPreviousPage();
    }
    hasCurrentNextItem() {
        return (this.items?.length > 0 && (this._selectedItem ? this._selectedItem.id != this.items[this.items.length - 1].id : true));
    }
    hasCurrentPreviousItem() {
        return (this.items?.length > 0 && this._selectedItem?.id != this.items[0].id);
    }
    hasNextPage() {
        const { pageSize, totalItemsCount, selectedPage } = this.listProperties.pagination;
        return selectedPage < Math.ceil(totalItemsCount / pageSize);
    }
    hasPreviousPage() {
        return this.listProperties.pagination.selectedPage > 1;
    }
    selectNextItem() {
        if (!this.getNextItemOnPage() && this.hasNextPage()) {
            this.onSelectedPageChange(this.listProperties.pagination.selectedPage + 1);
            this._selectFirstAfterItemsChanges = true;
        }
        this._selectedItem = this.getNextItemOnPage() ?? this._selectedItem;
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this._selectedItem);
        this.scrollToSelectedItem();
    }
    selectPreviousItem() {
        if (!this.getPreviousItemOnPage() && this.hasPreviousPage()) {
            this.onSelectedPageChange(this.listProperties.pagination.selectedPage - 1);
            this._selectLastAfterItemsChanges = true;
        }
        this._selectedItem = this.getPreviousItemOnPage() ?? this._selectedItem;
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this._selectedItem);
        this.scrollToSelectedItem();
    }
    selectItemById(itemId) {
        if (!itemId || this._selectedItem?.id == itemId)
            return;
        const item = this.items.find(item => item.id === itemId);
        this.selectedItem = item;
        // scrollToSelectedItem(), updateHasNexPrevious(); // performed in selectedItem setter
        this.selectedItemChange.emit(this._selectedItem);
    }
    getNextItemOnPage() {
        if (!this._selectedItem) {
            return this.items[0];
        }
        const selectedItemIndex = this.items.findIndex(item => item.id === this.selectedItem.id);
        return selectedItemIndex < this.items.length - 1 ? this.items[selectedItemIndex + 1] : undefined;
    }
    getPreviousItemOnPage() {
        const selectedItemIndex = this.items.findIndex(item => item.id === this.selectedItem.id);
        return selectedItemIndex > 0 ? this.items[selectedItemIndex - 1] : undefined;
    }
    getAllVisibleItems() {
        return this.items;
    }
    focusSelectedItem() {
        const selectedIndex = this.getSelectedItemIndex();
        this.rowItems?.get(selectedIndex)?.nativeElement.focus();
    }
    onItemDetailsEndReached() {
        if (this.hasCurrentNextItem()) {
            this.selectNextItem();
            this.focusSelectedItem();
        }
        else {
            this.paginationRef?.focus();
        }
    }
    numCurrentItemsChecked() {
        let numChecked = 0;
        this.items?.forEach(item => { if (this.checkedItems.find(checkedItem => item.id == checkedItem.id))
            numChecked++; });
        return numChecked;
    }
    onItemClicked(item, preventOpen) {
        if (window.getSelection().toString().length > 0 || document.activeElement?.tagName === 'INPUT') {
            return;
        }
        this.itemClicked.emit(item);
        if (this._selectedItem && item.id === this._selectedItem.id) {
            if (this.listProperties.hasDiselect) {
                this._selectedItem = undefined;
                this.itemDeselected.emit(item);
            }
            else {
                preventOpen ? this.itemSelected.emit({ item: item, preventOpen: preventOpen }) : this.itemSelected.emit(item);
                return;
            }
        }
        else {
            this._selectedItem = item;
            preventOpen ? this.itemSelected.emit({ item: item, preventOpen: preventOpen }) : this.itemSelected.emit(item);
        }
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this.selectedItem);
    }
    actionsHandler(key, items) {
        if (key == 'delete' || key == 'remove')
            this.onDeleteItemsActionPerformed(items);
    }
    onDeleteItemsActionPerformed(deletedItems) {
        if (deletedItems.find(curItem => curItem.id == this._selectedItem.id)) {
            const selectedItemIndex = this.getSelectedItemIndex();
            if (selectedItemIndex < 0) {
                this._nextItemAfterItemsDeleted = this.items[0];
                return;
            }
            let itemAfterDelete;
            let itemAfterDeleteIsDeleted = false;
            let index;
            for (index = selectedItemIndex + 1; index < this.items.length && itemAfterDeleteIsDeleted; index++) {
                itemAfterDelete = this.items[index];
                itemAfterDeleteIsDeleted = !!deletedItems.find(curItem => curItem.id == itemAfterDelete.id);
            }
            if (index >= this.items.length && itemAfterDeleteIsDeleted) {
                itemAfterDelete = undefined;
                for (index = selectedItemIndex - 1; index >= 0 && itemAfterDeleteIsDeleted; index--) {
                    itemAfterDelete = this.items[index];
                    itemAfterDeleteIsDeleted = !!deletedItems.find(curItem => curItem.id == itemAfterDelete.id);
                }
            }
            if (index < 0 && itemAfterDeleteIsDeleted)
                itemAfterDelete = undefined;
            this._nextItemAfterItemsDeleted = itemAfterDelete;
        }
        else {
            this._nextItemAfterItemsDeleted = this._selectedItem;
        }
    }
    onItemsDeleted() {
        this._itemsDeleted = true;
    }
    onSelectedPageChange(page) {
        const paginationDirection = this.listProperties.pagination.selectedPage - page;
        this.listProperties.pagination.selectedPage = page;
        if (paginationDirection < 0)
            this._selectFirstAfterItemsChanges = true;
        else
            this._selectLastAfterItemsChanges = true;
        this._focusSelectedItemAfterItemsChanges = true;
        this.selectedPageChange.emit(page);
    }
    onPageSizeChange(pageSize) {
        this.listProperties.pagination.pageSize = pageSize;
        this.numPlaceholderRows = this.numPlaceholderRows > 0 ? pageSize : this.numPlaceholderRows;
        this.pageSizeChange.emit(pageSize);
        this._selectLastAfterItemsChanges = true;
    }
    onRowStartFocused(event) {
        this.selectPreviousItem();
        this.focusSelectedItem();
    }
    onDropListDropped(event) {
        if (!this.listProperties.hasDrag) {
            return;
        }
        this.rowDraggedDropped.emit({ currentIndex: event.currentIndex, previousIndex: event.previousIndex });
    }
    getItemById(id) {
        return this.items.find(item => item.id === id);
    }
    ;
    getFlatItemsList() {
        return [...this.items];
    }
    getSelectedItemIndex() {
        return this.items.findIndex(item => item.id == this.selectedItem.id);
    }
    static { this.ɵfac = function ExItemsLayoutItemsFlat_Factory(t) { return new (t || ExItemsLayoutItemsFlat)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExItemsLayoutItemsFlat, inputs: { selectedItem: "selectedItem", leftSideWidth: "leftSideWidth", htmlId: "htmlId", hasItemDetailsComponent: "hasItemDetailsComponent" }, outputs: { selectedPageChange: "selectedPageChange", pageSizeChange: "pageSizeChange", endOfPagination: "endOfPagination", rowDraggedDropped: "rowDraggedDropped" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature] }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutItemsFlat.prototype, "onItemClicked", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutItemsFlat.prototype, "onSelectedPageChange", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutItemsFlat.prototype, "onPageSizeChange", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutItemsFlat, [{
        type: Directive
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }]; }, { selectedItem: [{
            type: Input
        }], leftSideWidth: [{
            type: Input
        }], htmlId: [{
            type: Input
        }], hasItemDetailsComponent: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], endOfPagination: [{
            type: Output
        }], rowDraggedDropped: [{
            type: Output
        }], onItemClicked: [], onSelectedPageChange: [], onPageSizeChange: [] }); })();

const _c0$1f = function (a0) { return { "ex-chip-non-count": a0 }; };
function ExChipRecordComponent_ex_chip_1_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 6);
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconType", ctx_r2.iconType)("iconName", chip_r1.icon)("ngClass", i0.ɵɵpureFunction1(3, _c0$1f, ctx_r2.breakpoint === 1 && chip_r1.count == undefined || !chip_r1.text));
} }
function ExChipRecordComponent_ex_chip_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(chip_r1.text);
} }
function ExChipRecordComponent_ex_chip_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(chip_r1.count);
} }
function ExChipRecordComponent_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 1);
    i0.ɵɵelementContainerStart(1, 2);
    i0.ɵɵtemplate(2, ExChipRecordComponent_ex_chip_1_ex_icon_2_Template, 1, 5, "ex-icon", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtemplate(4, ExChipRecordComponent_ex_chip_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(5, ExChipRecordComponent_ex_chip_1_ng_container_5_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const chip_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", chip_r1.text)("background", chip_r1.color)("hasBorder", false)("square", ctx_r0.breakpoint === 1 && (chip_r1.count == undefined || !chip_r1.icon));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", chip_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.breakpoint !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.breakpoint === 1);
} }
class ExChipRecordComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * The type of the icons displayed on the chips, can be matIcon, svg, fa-font, or uxf
         */
        this.iconType = "fa-font";
    }
    ngAfterViewInit() {
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExChipRecordComponent_Factory(t) { return new (t || ExChipRecordComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExChipRecordComponent, selectors: [["ex-chip-record"]], inputs: { breakpoint: "breakpoint", chips: "chips", iconType: "iconType", isRowDirection: "isRowDirection" }, decls: 2, vars: 5, consts: [["fontColor", "white", "size", "small", 3, "exTooltip", "background", "hasBorder", "square", 4, "ngFor", "ngForOf"], ["fontColor", "white", "size", "small", 3, "exTooltip", "background", "hasBorder", "square"], ["icon-left", ""], ["icon-left", "", "color", "white", "sizePx", "14px", 3, "iconType", "iconName", "ngClass", 4, "ngIf"], ["text", ""], [4, "ngIf"], ["icon-left", "", "color", "white", "sizePx", "14px", 3, "iconType", "iconName", "ngClass"]], template: function ExChipRecordComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, ExChipRecordComponent_ex_chip_1_Template, 6, 7, "ex-chip", 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵstyleProp("flex-direction", ctx.breakpoint === 1 || ctx.isRowDirection ? "row" : "column");
            i0.ɵɵclassProp("ex-chip-breakpoint1", ctx.breakpoint === 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.chips);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExChipComponent, ExIconComponent, ExTooltipDirective], styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}[_nghost-%COMP%] > div.ex-chip-breakpoint1[_ngcontent-%COMP%]{justify-content:flex-end}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   ex-chip[_ngcontent-%COMP%]{display:block!important;max-width:100%;margin:2px}.ex-chip-non-count[_ngcontent-%COMP%]{margin-inline-end:0px!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChipRecordComponent, [{
        type: Component,
        args: [{ selector: 'ex-chip-record', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [style.flexDirection]=\"breakpoint === 1 || isRowDirection ? 'row' : 'column'\" [class.ex-chip-breakpoint1]=\"breakpoint === 1\">\n    <ex-chip [exTooltip]=\"chip.text\" [background]=\"chip.color\" fontColor=\"white\" [hasBorder]=\"false\" size=\"small\"\n        [square]=\"breakpoint === 1 && (chip.count==undefined || !chip.icon)\" *ngFor=\"let chip of chips\">\n        <ng-container icon-left>\n            <ex-icon *ngIf=\"chip.icon\" icon-left [iconType]=\"iconType\" [iconName]=\"chip.icon\" color=\"white\" sizePx=\"14px\"\n                [ngClass]=\"{'ex-chip-non-count': breakpoint === 1 && chip.count==undefined || !chip.text}\">\n            </ex-icon>\n        </ng-container>\n        <span text>\n            <ng-container *ngIf=\"breakpoint !== 1\">{{ chip.text }}</ng-container>\n            <ng-container *ngIf=\"breakpoint === 1\">{{ chip.count }}</ng-container>\n        </span>\n    </ex-chip>\n</div>", styles: [":host>div{display:flex;flex-wrap:wrap}:host>div.ex-chip-breakpoint1{justify-content:flex-end}:host>div ex-chip{display:block!important;max-width:100%;margin:2px}.ex-chip-non-count{margin-inline-end:0px!important}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { breakpoint: [{
            type: Input
        }], chips: [{
            type: Input
        }], iconType: [{
            type: Input
        }], isRowDirection: [{
            type: Input
        }] }); })();

const _c0$1e = ["paginationRef"];
const _c1$M = ["rowItemRef"];
function ExItemsLayoutGridComponent_div_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} }
function ExItemsLayoutGridComponent_div_0_div_1_th_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_th_5_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_th_5_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("exResizeColumn", !ctx_r4.isItemOpen)("orderedColumns", ctx_r4.displayedColumns)("columnsCustomization", ctx_r4.columnsWidth);
} }
function ExItemsLayoutGridComponent_div_0_div_1_th_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 18);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_th_6_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_th_6_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("exResizeColumn", !ctx_r5.isItemOpen)("orderedColumns", ctx_r5.displayedColumns)("columnsCustomization", ctx_r5.columnsWidth);
} }
function ExItemsLayoutGridComponent_div_0_div_1_th_7_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 19);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_th_7_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_th_7_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r22.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelement(2, "ex-checkbox");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("exResizeColumn", false)("orderedColumns", ctx_r6.displayedColumns)("columnsCustomization", ctx_r6.columnsWidth);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("visibility", "hidden");
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r23 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, column_r23.label), "");
} }
const _c2$x = function (a0, a1, a2) { return { "ex-items-layout-grid-no-left-padding": a0, "ex-items-layout-grid-header-draggable": a1, "ex-items-layout-grid-selected-drag-column": a2 }; };
const _c3$o = function (a0) { return { "ex-items-layout-grid-flex-centered": a0 }; };
const _c4$j = function (a0) { return { "ex-items-layout-grid-sortable-header": a0 }; };
const _c5$g = function (a0) { return { column: a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 22);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r28.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r30.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r29); const column_r23 = i0.ɵɵnextContext().$implicit; const ctx_r31 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r31.onHeaderClicked(column_r23)); });
    i0.ɵɵpipe(4, "exIsSortableColumn");
    i0.ɵɵelementContainer(5, 25);
    i0.ɵɵtemplate(6, ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_div_6_Template, 3, 3, "div", 26);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext();
    const column_r23 = ctx_r33.$implicit;
    const i_r24 = ctx_r33.index;
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(13);
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", "sel-grid-header-" + column_r23.columnIdentifier, " ex-items-layout-grid-header-text ex-items-layout-grid-th");
    i0.ɵɵproperty("exResizeColumn", false)("orderedColumns", ctx_r25.displayedColumns)("identifier", column_r23.columnIdentifier)("columnsCustomization", ctx_r25.columnsWidth)("ngClass", i0.ɵɵpureFunction3(19, _c2$x, column_r23.isIconColumn || column_r23.isToggleColumn, !ctx_r25.isItemOpen, ctx_r25.dragSelectedColIndex === i_r24));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 14, column_r23.customTooltip || column_r23.label))("ngClass", i0.ɵɵpureFunction1(23, _c3$o, column_r23.centered && column_r23.centered === true));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c4$j, i0.ɵɵpipeBind2(4, 16, ctx_r25.listProperties == null ? null : ctx_r25.listProperties.sorts, column_r23 == null ? null : column_r23.sortKey)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(27, _c5$g, column_r23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r23.displayLabelInHeader);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_th_1_Template, 7, 29, "th", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r23 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r23.isPreRow);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("spaceClicked", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_6_Template_div_spaceClicked_0_listener($event) { i0.ɵɵrestoreView(_r42); const i_r35 = i0.ɵɵnextContext(2).index; const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.columnHeaderLabelSpaceClicked($event, i_r35)); })("blured", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_6_Template_div_blured_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r43.columnHeaderLabelBlurred()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("exDrag", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, column_r34.label), "");
} }
const _c6$e = function (a0) { return { "ex-items-layout-grid-no-left-padding": a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c6$e, column_r34.isIconColumn || column_r34.isToggleColumn));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, column_r34.label), "");
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_7_div_1_Template, 3, 6, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r34 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("width", ctx_r38.columnsWidth[column_r34.columnIdentifier] == null ? null : ctx_r38.columnsWidth[column_r34.columnIdentifier].width, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r34.displayLabelInHeader);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 36);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 29);
    i0.ɵɵlistener("cdkDragStarted", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template_th_cdkDragStarted_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r48.isDragging = true); })("cdkDragEnded", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template_th_cdkDragEnded_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.isDragging = false); })("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r51 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r51.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r52 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r52.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r49); const column_r34 = i0.ɵɵnextContext().$implicit; const ctx_r53 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r53.onHeaderClicked(column_r34)); });
    i0.ɵɵpipe(4, "exIsSortableColumn");
    i0.ɵɵelementContainer(5, 25);
    i0.ɵɵtemplate(6, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_6_Template, 3, 4, "div", 30);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_7_Template, 2, 3, "div", 31);
    i0.ɵɵtemplate(8, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_div_8_Template, 1, 0, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext();
    const column_r34 = ctx_r55.$implicit;
    const i_r35 = ctx_r55.index;
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(13);
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", "sel-grid-header-" + column_r34.columnIdentifier, " ex-items-layout-grid-header-text ex-items-layout-grid-th");
    i0.ɵɵproperty("exResizeColumn", !ctx_r36.isItemOpen)("orderedColumns", ctx_r36.displayedColumns)("identifier", column_r34.columnIdentifier)("columnsCustomization", ctx_r36.columnsWidth)("ngClass", i0.ɵɵpureFunction3(19, _c2$x, column_r34.isIconColumn || column_r34.isToggleColumn, !ctx_r36.isItemOpen, ctx_r36.dragSelectedColIndex === i_r35));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 14, column_r34.customTooltip || column_r34.label))("ngClass", i0.ɵɵpureFunction1(23, _c3$o, column_r34.centered && column_r34.centered === true));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c4$j, i0.ɵɵpipeBind2(4, 16, ctx_r36.listProperties == null ? null : ctx_r36.listProperties.sorts, column_r34 == null ? null : column_r34.sortKey)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(27, _c5$g, column_r34));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r34.displayLabelInHeader);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_th_1_Template, 9, 29, "th", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r34 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !column_r34.isPreRow);
} }
const _c7$b = function (a0, a1, a2) { return { "uxf-arrow-combo": a0, "uxf-down-caret": a1, "uxf-up-caret": a2 }; };
const _c8$b = function (a0) { return { columnName: a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_ng_template_12_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵlistener("keydown.Enter", function ExItemsLayoutGridComponent_div_0_div_1_ng_template_12_span_0_Template_span_keydown_Enter_0_listener($event) { i0.ɵɵrestoreView(_r60); const column_r56 = i0.ɵɵnextContext().column; const ctx_r58 = i0.ɵɵnextContext(3); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r58.onHeaderClicked(column_r56)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r56 = i0.ɵɵnextContext().column;
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c7$b, (ctx_r57.listProperties.sorts == null ? null : ctx_r57.listProperties.sorts[0] == null ? null : ctx_r57.listProperties.sorts[0].selectedOption) != column_r56.sortKey, (ctx_r57.listProperties.sorts == null ? null : ctx_r57.listProperties.sorts[0] == null ? null : ctx_r57.listProperties.sorts[0].selectedOption) == column_r56.sortKey && (ctx_r57.listProperties.sorts == null ? null : ctx_r57.listProperties.sorts[0] == null ? null : ctx_r57.listProperties.sorts[0].order) === "desc", (ctx_r57.listProperties.sorts == null ? null : ctx_r57.listProperties.sorts[0] == null ? null : ctx_r57.listProperties.sorts[0].selectedOption) == column_r56.sortKey && (ctx_r57.listProperties.sorts == null ? null : ctx_r57.listProperties.sorts[0] == null ? null : ctx_r57.listProperties.sorts[0].order) === "asc"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 2, "ng.general.sort-tooltip", i0.ɵɵpureFunction1(11, _c8$b, i0.ɵɵpipeBind1(2, 5, column_r56.label))));
} }
function ExItemsLayoutGridComponent_div_0_div_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_div_1_ng_template_12_span_0_Template, 3, 13, "span", 37);
    i0.ɵɵpipe(1, "exIsSortableColumn");
} if (rf & 2) {
    const column_r56 = ctx.column;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", (ctx_r10.listProperties == null ? null : ctx_r10.listProperties.showSortsInListHeader) && i0.ɵɵpipeBind2(1, 1, ctx_r10.listProperties == null ? null : ctx_r10.listProperties.sorts, column_r56 == null ? null : column_r56.sortKey));
} }
function ExItemsLayoutGridComponent_div_0_div_1_th_14_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 39);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_th_14_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r62.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_th_14_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r63); const ctx_r64 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r64.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("exResizeColumn", !ctx_r11.isItemOpen)("orderedColumns", ctx_r11.displayedColumns)("columnsCustomization", ctx_r11.columnsWidth);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("focusin", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_2_Template_button_focusin_0_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r72.onRowStartFocused($event)); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵlistener("keyup.Tab", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_4_Template_button_keyup_Tab_0_listener() { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r74.onTabFromRowEnd()); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 54);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r83.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r84); const ctx_r85 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r85.customizationFinished()); });
    i0.ɵɵelementStart(1, "ex-right-click-actions", 55);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template_ex_right_click_actions_actionClicked_1_listener($event) { i0.ɵɵrestoreView(_r84); const rowIndex_r67 = i0.ɵɵnextContext(2).index; const ctx_r86 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r86.dragActionClicked($event, rowIndex_r67)); })("contextmenu", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template_ex_right_click_actions_contextmenu_1_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelement(2, "ex-drag-accessible-icon", 56);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("exResizeColumn", !ctx_r78.isItemOpen)("isFocusable", false)("orderedColumns", ctx_r78.displayedColumns)("columnsCustomization", ctx_r78.columnsWidth);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", ctx_r78.dragActions);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_12_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 57);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_12_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r89 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r89.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_12_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r90); const ctx_r91 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r91.customizationFinished()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r79 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", !ctx_r79.isItemOpen)("isFocusable", false)("orderedColumns", ctx_r79.displayedColumns)("columnsCustomization", ctx_r79.columnsWidth);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r79.listProperties.pagination.selectedPage - 1) * ctx_r79.listProperties.pagination.pageSize + ctx_r79.items.indexOf(row_r66) + 1, " ");
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_checkbox_2_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 66);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_checkbox_2_Template_ex_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("checkedChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_checkbox_2_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r103); const row_r66 = i0.ɵɵnextContext(3).$implicit; const ctx_r101 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r101.onItemCheckedChange(row_r66, $event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r93 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("checked", ctx_r93.isItemChecked(row_r66))("disabled", row_r66.selectable === false)("ariaLabel", i0.ɵɵpipeBind1(1, 4, "ng.ex_items_layout_list_row.check_or_uncheck"))("exTooltip", row_r66.selectable !== false ? "" : i0.ɵɵpipeBind1(2, 6, row_r66.nonSelectableTooltip));
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_mat_radio_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r107 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 67);
    i0.ɵɵlistener("keydown.space", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_mat_radio_button_3_Template_mat_radio_button_keydown_space_0_listener() { i0.ɵɵrestoreView(_r107); const row_r66 = i0.ɵɵnextContext(3).$implicit; const ctx_r105 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r105.onSingleItemCheckedChange(row_r66)); })("click", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_mat_radio_button_3_Template_mat_radio_button_click_0_listener() { i0.ɵɵrestoreView(_r107); const row_r66 = i0.ɵɵnextContext(3).$implicit; const ctx_r108 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r108.onSingleItemCheckedChange(row_r66)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(3);
    const rowIndex_r67 = ctx_r110.index;
    const row_r66 = ctx_r110.$implicit;
    const ctx_r94 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate1("aria-labelledby", "row-", rowIndex_r67, "");
    i0.ɵɵproperty("checked", ctx_r94.isItemChecked(row_r66));
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 68);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("color", "#e54746")("iconName", "circ_warning")("exTooltip", i0.ɵɵpipeBind1(1, 3, row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.reason));
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 68);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("color", "#e7a141")("iconName", "warning")("exTooltip", i0.ɵɵpipeBind1(1, 3, row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.reason));
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 69);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#60c05f")("iconName", "success");
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 70);
} if (rf & 2) {
    const icon_r113 = ctx.$implicit;
    i0.ɵɵproperty("iconName", icon_r113 == null ? null : icon_r113.iconName)("color", icon_r113 == null ? null : icon_r113.iconColor)("tooltip", icon_r113 == null ? null : icon_r113.tooltip)("callback", (icon_r113 == null ? null : icon_r113.callback) ? icon_r113 == null ? null : icon_r113.callback : null);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ng_container_9_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 70);
} if (rf & 2) {
    const icon_r114 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconName", icon_r114 == null ? null : icon_r114.iconName)("color", icon_r114 == null ? null : icon_r114.iconColor)("tooltip", icon_r114 == null ? null : icon_r114.tooltip)("callback", (icon_r114 == null ? null : icon_r114.callback) ? icon_r114 == null ? null : icon_r114.callback : null);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ng_container_9_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 64);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const icon_r114 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r114);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 58);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r117.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r118); const ctx_r119 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r119.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtemplate(2, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_checkbox_2_Template, 3, 8, "ex-checkbox", 59);
    i0.ɵɵtemplate(3, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_mat_radio_button_3_Template, 1, 2, "mat-radio-button", 60);
    i0.ɵɵtemplate(4, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_4_Template, 2, 5, "ex-svg-icon", 61);
    i0.ɵɵtemplate(5, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_5_Template, 2, 5, "ex-svg-icon", 61);
    i0.ɵɵtemplate(6, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_6_Template, 1, 2, "ex-svg-icon", 62);
    i0.ɵɵelementStart(7, "div", 63);
    i0.ɵɵtemplate(8, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ex_svg_icon_8_Template, 1, 4, "ex-svg-icon", 64);
    i0.ɵɵtemplate(9, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_ng_container_9_Template, 2, 1, "ng-container", 65);
    i0.ɵɵpipe(10, "exUnderThumbnailIcons");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r80 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", false)("isFocusable", false)("orderedColumns", ctx_r80.displayedColumns)("columnsCustomization", ctx_r80.columnsWidth);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r80.listProperties.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r80.listProperties.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) === "failed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) === "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) === "success");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", row_r66 == null ? null : row_r66.listItem[row_r66 == null ? null : row_r66.listItem == null ? null : row_r66.listItem.__proto__.thumbnailIcon == null ? null : row_r66.listItem.__proto__.thumbnailIcon.key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(10, 12, row_r66 == null ? null : row_r66.listItem))("ngForTrackBy", ctx_r80.iconTrackBy);
} }
const _c9$8 = function () { return {}; };
const _c10$7 = function (a0, a1) { return { component: a0, data: a1 }; };
const _c11$5 = function (a0) { return { highlightedText: a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_ex_component_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 77);
    i0.ɵɵpipe(1, "objectAssign");
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(2).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r126 = i0.ɵɵnextContext(4);
    let tmp_1_0;
    i0.ɵɵproperty("componentFactoryItem", i0.ɵɵpureFunction2(8, _c10$7, column_r121.type, i0.ɵɵpureFunction0(7, _c9$8)))("data", (tmp_1_0 = row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].inputs) !== null && tmp_1_0 !== undefined ? tmp_1_0 : i0.ɵɵpipeBind2(1, 4, row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier], (tmp_1_0 = i0.ɵɵpureFunction1(11, _c11$5, ctx_r126.getHighlightedText(row_r66))) !== null && tmp_1_0 !== undefined ? tmp_1_0 : i0.ɵɵpureFunction0(13, _c9$8)))("content", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].content)("events", (row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].events) || i0.ɵɵpureFunction0(14, _c9$8));
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-chip-record", 78);
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(2).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("chips", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier])("iconType", "svg");
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_ex_component_loader_1_Template, 2, 15, "ex-component-loader", 75);
    i0.ɵɵtemplate(2, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_ng_template_2_Template, 1, 2, "ng-template", null, 76, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r127 = i0.ɵɵreference(3);
    const column_r121 = i0.ɵɵnextContext().$implicit;
    const ctx_r123 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (column_r121 == null ? null : column_r121.type) != ctx_r123.OtbColumnsComponentTypes.chip)("ngIfElse", _r127);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "ex-svg-icon", 84);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(2).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].iconName)("color", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].iconColor)("tooltip", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].tooltip)("size", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier] == null ? null : row_r66["listItem"][column_r121.columnIdentifier].iconSize);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 20);
    i0.ɵɵelementStart(1, "ex-slide-toggle", 86);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_ng_container_0_Template_ex_slide_toggle_click_1_listener($event) { return $event.stopPropagation(); })("toggleCheckedChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_ng_container_0_Template_ex_slide_toggle_toggleCheckedChange_1_listener() { i0.ɵɵrestoreView(_r149); const row_r66 = i0.ɵɵnextContext(5).$implicit; const ctx_r147 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r147.onActionClicked(row_r66, ctx_r147.ITEMS_LAYOUT_ITEM_TOGGLE_ACTION_KEY)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(3).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("toggleChecked", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier]);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_ng_container_0_Template, 2, 1, "ng-container", 85);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r137 = i0.ɵɵreference(4);
    const column_r121 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r121.isToggleColumn)("ngIfElse", _r137);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 20);
    i0.ɵɵelement(1, "ex-link", 87);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(3).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("arguments", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier]);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 85);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r139 = i0.ɵɵreference(6);
    const column_r121 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r121.isLinkColumn)("ngIfElse", _r139);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 20);
    i0.ɵɵelement(1, "ex-chip-record-entity-labels", 88);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(3).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("entityLabels", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier])("iconType", "svg");
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_5_ng_container_0_Template, 2, 2, "ng-container", 85);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r141 = i0.ɵɵreference(8);
    const column_r121 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r121.isEntityLabelsColumn)("ngIfElse", _r141);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 89);
    i0.ɵɵpipe(1, "exTextHighlight");
} if (rf & 2) {
    const column_r121 = i0.ɵɵnextContext(2).$implicit;
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r142 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier])("innerHTML", i0.ɵɵpipeBind2(1, 2, row_r66["listItem"] == null ? null : row_r66["listItem"][column_r121.columnIdentifier], ctx_r142.listProperties.highlightedText), i0.ɵɵsanitizeHtml);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_div_0_Template, 2, 4, "div", 79);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_1_Template, 1, 2, "ng-template", null, 80, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_3_Template, 1, 2, "ng-template", null, 81, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_5_Template, 1, 2, "ng-template", null, 82, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_ng_template_7_Template, 2, 5, "ng-template", null, 83, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r135 = i0.ɵɵreference(2);
    const column_r121 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", column_r121.isIconColumn)("ngIfElse", _r135);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r165 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 71);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_Template_td_columnsCustomizationChange_1_listener($event) { i0.ɵɵrestoreView(_r165); const ctx_r164 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r164.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_Template_td_customizationFinished_1_listener() { i0.ɵɵrestoreView(_r165); const ctx_r166 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r166.customizationFinished()); });
    i0.ɵɵelementStart(2, "div", 72);
    i0.ɵɵtemplate(3, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_container_3_Template, 4, 2, "ng-container", 73);
    i0.ɵɵtemplate(4, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_ng_template_4_Template, 9, 2, "ng-template", null, 74, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r121 = ctx.$implicit;
    const _r124 = i0.ɵɵreference(5);
    const rowIndex_r67 = i0.ɵɵnextContext(2).index;
    const ctx_r81 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", "sel-grid-body-" + column_r121.columnIdentifier, " ex-items-layout-grid-cell inline-cell");
    i0.ɵɵpropertyInterpolate1("id", "row-", rowIndex_r67, "");
    i0.ɵɵproperty("exResizeColumn", !ctx_r81.isItemOpen)("isFocusable", false)("orderedColumns", ctx_r81.displayedColumns)("identifier", column_r121.columnIdentifier)("columnsCustomization", ctx_r81.columnsWidth)("ngClass", i0.ɵɵpureFunction1(13, _c6$e, column_r121.isIconColumn || column_r121.isToggleColumn));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c3$o, column_r121.centered && column_r121.centered === true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r121.type)("ngIfElse", _r124);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_record_actions_2_Template(rf, ctx) { if (rf & 1) {
    const _r172 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-record-actions", 94);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_record_actions_2_Template_ex_record_actions_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r172); const row_r66 = i0.ɵɵnextContext(3).$implicit; const ctx_r170 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r170.onActionClicked(row_r66, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isRowSelected_r76 = i0.ɵɵnextContext(2).isRowSelected;
    const ctx_r173 = i0.ɵɵnextContext();
    const row_r66 = ctx_r173.$implicit;
    const rowIndex_r67 = ctx_r173.index;
    const ctx_r168 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("actions", row_r66.listItem[ctx_r168.schema.actions.key].actions)("visibleBtnNum", 0)("loading", row_r66.listItem[ctx_r168.schema.actions.key].loading)("isSelected", isRowSelected_r76)("index", rowIndex_r67);
} }
const _c12$4 = function (a0) { return { "selected": a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r177 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 95);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_button_3_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r177); const row_r66 = i0.ɵɵnextContext(3).$implicit; const ctx_r175 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r175.onActionClicked(row_r66, ctx_r175._SINGLE_SAVE_EDIT_ACTION_KEY)); });
    i0.ɵɵelement(1, "ex-svg-icon", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isRowSelected_r76 = i0.ɵɵnextContext(2).isRowSelected;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c12$4, isRowSelected_r76))("tooltip", "ng.general.edit");
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_Template(rf, ctx) { if (rf & 1) {
    const _r180 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 90);
    i0.ɵɵlistener("columnsCustomizationChange", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r180); const ctx_r179 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r179.columnsWidth = $event); })("customizationFinished", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r180); const ctx_r181 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r181.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 91);
    i0.ɵɵtemplate(2, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_record_actions_2_Template, 1, 5, "ex-record-actions", 92);
    i0.ɵɵtemplate(3, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_ex_button_3_Template, 2, 4, "ex-button", 93);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r66 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r82 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", !ctx_r82.isItemOpen)("isFocusable", false)("orderedColumns", ctx_r82.displayedColumns)("columnsCustomization", ctx_r82.columnsWidth);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (row_r66.listItem[ctx_r82.schema.actions.key] == null ? null : row_r66.listItem[ctx_r82.schema.actions.key].actions == null ? null : row_r66.listItem[ctx_r82.schema.actions.key].actions.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.isSingleSave && row_r66.listItem[ctx_r82.schema.editableKey] != false && !(ctx_r82.listProperties == null ? null : ctx_r82.listProperties.inExSidepanePickup));
} }
const _c13$4 = function (a0, a1) { return { "ex-items-layout-grid-odd-row": a0, "ex-items-layout-grid-selected-row": a1 }; };
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r185 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 47, 48);
    i0.ɵɵlistener("click", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r185); const row_r66 = i0.ɵɵnextContext().$implicit; const ctx_r183 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r183.onItemClicked(row_r66)); })("keydown.enter", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template_tr_keydown_enter_0_listener($event) { i0.ɵɵrestoreView(_r185); const row_r66 = i0.ɵɵnextContext().$implicit; const ctx_r186 = i0.ɵɵnextContext(4); $event.preventDefault; return i0.ɵɵresetView(ctx_r186.onItemClicked(row_r66)); })("keydown.space", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template_tr_keydown_space_0_listener($event) { i0.ɵɵrestoreView(_r185); const row_r66 = i0.ɵɵnextContext().$implicit; const ctx_r188 = i0.ɵɵnextContext(4); $event.preventDefault; return i0.ɵɵresetView(ctx_r188.onItemClicked(row_r66)); })("keydown.arrowdown", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template_tr_keydown_arrowdown_0_listener($event) { i0.ɵɵrestoreView(_r185); const row_r66 = i0.ɵɵnextContext().$implicit; const ctx_r190 = i0.ɵɵnextContext(4); $event.preventDefault; return i0.ɵɵresetView(ctx_r190.onRowArrowDown($event, row_r66)); })("keydown.arrowup", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template_tr_keydown_arrowup_0_listener($event) { i0.ɵɵrestoreView(_r185); const row_r66 = i0.ɵɵnextContext().$implicit; const ctx_r192 = i0.ɵɵnextContext(4); $event.preventDefault; return i0.ɵɵresetView(ctx_r192.onRowArrowUp($event, row_r66)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "span", 49);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_11_Template, 3, 5, "td", 50);
    i0.ɵɵtemplate(12, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_12_Template, 2, 5, "td", 51);
    i0.ɵɵtemplate(13, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_13_Template, 11, 14, "td", 52);
    i0.ɵɵtemplate(14, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_ng_container_14_Template, 6, 17, "ng-container", 11);
    i0.ɵɵpipe(15, "itemsLayoutGridColumns");
    i0.ɵɵtemplate(16, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_td_16_Template, 4, 6, "td", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isRowSelected_r76 = ctx.isRowSelected;
    const row_r66 = i0.ɵɵnextContext().$implicit;
    const ctx_r71 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r71.listProperties.hasDrag)("ngClass", i0.ɵɵpureFunction2(27, _c13$4, ctx_r71.items.indexOf(row_r66) % 2 === 0, isRowSelected_r76));
    i0.ɵɵattribute("aria-label", (ctx_r71.isItemOpen ? i0.ɵɵpipeBind1(2, 9, "ng.general.close-right-side") : i0.ɵɵpipeBind1(3, 11, "ng.general.open-right-side")) + (isRowSelected_r76 ? " " + i0.ɵɵpipeBind1(4, 13, "ng.general.selected") : ""));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) ? (row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) === "success" ? i0.ɵɵpipeBind1(7, 15, "ng.general.success") : ((row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.type) === "warning" ? i0.ɵɵpipeBind1(8, 17, "ng.general.warning") : i0.ɵɵpipeBind1(9, 19, "ng.general.failure")) + " - " + i0.ɵɵpipeBind1(10, 21, row_r66 == null ? null : row_r66.actionIndication == null ? null : row_r66.actionIndication.reason) : "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r71.listProperties.hasDrag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r71.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r71.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(15, 23, ctx_r71.schema["columns"], ctx_r71.displayedColumns, ctx_r71.columnsCustomization));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r71.isItemOpen && (ctx_r71.schema.actions || ctx_r71.isSingleSave));
} }
const _c14$4 = function (a0) { return { isRowSelected: a0 }; };
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r196 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-right-click-actions", 41);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_Template_ex_right_click_actions_actionClicked_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r196); const row_r66 = restoredCtx.$implicit; const ctx_r195 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r195.onActionClicked(row_r66, $event)); })("copyCellClicked", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_Template_ex_right_click_actions_copyCellClicked_1_listener($event) { i0.ɵɵrestoreView(_r196); const ctx_r197 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r197.onCopyCellClicked($event)); });
    i0.ɵɵtemplate(2, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_2_Template, 1, 0, "button", 42);
    i0.ɵɵelementContainer(3, 25);
    i0.ɵɵtemplate(4, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_button_4_Template, 1, 0, "button", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_ng_template_5_Template, 17, 30, "ng-template", null, 44, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r66 = ctx.$implicit;
    const _r70 = i0.ɵɵreference(6);
    const ctx_r65 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", ctx_r65.addCopyCellValueAction(row_r66.listItem.actions == null ? null : row_r66.listItem.actions.actions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.isItemOpen && (ctx_r65._selectedItem == null ? null : ctx_r65._selectedItem.id) === row_r66.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r70)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c14$4, (ctx_r65._selectedItem == null ? null : ctx_r65._selectedItem.id) == row_r66.id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.isItemOpen && (ctx_r65._selectedItem == null ? null : ctx_r65._selectedItem.id) == row_r66.id);
} }
function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_Template(rf, ctx) { if (rf & 1) {
    const _r199 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody", 40);
    i0.ɵɵlistener("cdkDropListDropped", function ExItemsLayoutGridComponent_div_0_div_1_tbody_15_Template_tbody_cdkDropListDropped_0_listener($event) { i0.ɵɵrestoreView(_r199); const ctx_r198 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r198.onDropListDropped($event)); });
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_ng_container_1_Template, 7, 7, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cdkDropListData", ctx_r12.items);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.items);
} }
function ExItemsLayoutGridComponent_div_0_div_1_ex_pagination_16_Template(rf, ctx) { if (rf & 1) {
    const _r202 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 97, 98);
    i0.ɵɵlistener("selectedPageChange", function ExItemsLayoutGridComponent_div_0_div_1_ex_pagination_16_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r202); const ctx_r201 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r201.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutGridComponent_div_0_div_1_ex_pagination_16_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r202); const ctx_r203 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r203.onPageSizeChange($event)); })("endOfPagination", function ExItemsLayoutGridComponent_div_0_div_1_ex_pagination_16_Template_ex_pagination_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r202); const ctx_r204 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r204.endOfPagination.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("numberOfResults", ctx_r13.listProperties.pagination.totalItemsCount)("pageSize", ctx_r13.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r13.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r13.listProperties.pagination.selectedPage)("doNotUpdateStateInternally", true);
} }
function ExItemsLayoutGridComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r206 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("resized", function ExItemsLayoutGridComponent_div_0_div_1_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r206); const ctx_r205 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r205.onGridResized($event)); });
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_div_1_Template, 1, 0, "div", 5);
    i0.ɵɵelementStart(2, "table", 6)(3, "thead")(4, "tr", 7);
    i0.ɵɵlistener("cdkDropListDropped", function ExItemsLayoutGridComponent_div_0_div_1_Template_tr_cdkDropListDropped_4_listener($event) { i0.ɵɵrestoreView(_r206); const ctx_r207 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r207.dropCol($event)); });
    i0.ɵɵtemplate(5, ExItemsLayoutGridComponent_div_0_div_1_th_5_Template, 1, 3, "th", 8);
    i0.ɵɵtemplate(6, ExItemsLayoutGridComponent_div_0_div_1_th_6_Template, 1, 3, "th", 9);
    i0.ɵɵtemplate(7, ExItemsLayoutGridComponent_div_0_div_1_th_7_Template, 3, 5, "th", 10);
    i0.ɵɵtemplate(8, ExItemsLayoutGridComponent_div_0_div_1_ng_container_8_Template, 2, 1, "ng-container", 11);
    i0.ɵɵpipe(9, "itemsLayoutGridColumns");
    i0.ɵɵtemplate(10, ExItemsLayoutGridComponent_div_0_div_1_ng_container_10_Template, 2, 1, "ng-container", 11);
    i0.ɵɵpipe(11, "itemsLayoutGridColumns");
    i0.ɵɵtemplate(12, ExItemsLayoutGridComponent_div_0_div_1_ng_template_12_Template, 2, 4, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(14, ExItemsLayoutGridComponent_div_0_div_1_th_14_Template, 1, 3, "th", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(15, ExItemsLayoutGridComponent_div_0_div_1_tbody_15_Template, 2, 2, "tbody", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, ExItemsLayoutGridComponent_div_0_div_1_ex_pagination_16_Template, 2, 5, "ex-pagination", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isDragging);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.gridId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkDropListSortingDisabled", ctx_r2.isItemOpen)("cdkDropListDisabled", ctx_r2.isItemOpen)("cdkDropListData", ctx_r2.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.listProperties.hasDrag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(9, 13, ctx_r2.schema["columns"], ctx_r2.displayedColumns, ctx_r2.columnsCustomization));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(11, 17, ctx_r2.schema["columns"], ctx_r2.displayedColumns, ctx_r2.columnsCustomization));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.isItemOpen && (ctx_r2.schema.actions || ctx_r2.isSingleSave));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.listProperties.isLoading && (ctx_r2.items == null ? null : ctx_r2.items.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.listProperties.pagination.totalItemsCount > 0);
} }
function ExItemsLayoutGridComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_0_div_1_Template, 17, 21, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.listProperties.isLoading);
} }
const _c15$4 = function (a0) { return { "ex-items-layout-grid-even-row": a0 }; };
function ExItemsLayoutGridComponent_div_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 102);
    i0.ɵɵelement(1, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const x_r210 = ctx.index;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c15$4, x_r210 % 2 === 1));
} }
function ExItemsLayoutGridComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "table", 99)(2, "tbody", 100);
    i0.ɵɵtemplate(3, ExItemsLayoutGridComponent_div_1_tr_3_Template, 2, 3, "tr", 101);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", " ".repeat(ctx_r1.listProperties.pagination.pageSize).split(""));
} }
var ExItemsLayoutGridColumnNames;
(function (ExItemsLayoutGridColumnNames) {
    ExItemsLayoutGridColumnNames["DRAG"] = "drag";
    ExItemsLayoutGridColumnNames["INDEX"] = "index";
    ExItemsLayoutGridColumnNames["PICKUP"] = "pickup";
    ExItemsLayoutGridColumnNames["ACTIONS"] = "actions";
})(ExItemsLayoutGridColumnNames || (ExItemsLayoutGridColumnNames = {}));
const ITEMS_LAYOUT_ITEM_TOGGLE_ACTION = "itemToggled";
const EX_IS_INSIDE_GRID = new InjectionToken('EX_IS_INSIDE_GRID');
class ExItemsLayoutGridComponent extends ExItemsLayoutItemsFlat {
    constructor(itemsLayoutService, sectionsLayoutService, dialogService, translate, changeDetectorRef, isSingleSave, exPageId) {
        super(itemsLayoutService, sectionsLayoutService, dialogService);
        this.translate = translate;
        this.changeDetectorRef = changeDetectorRef;
        this.isSingleSave = isSingleSave;
        this.exPageId = exPageId;
        this.columnHeaderSortChange = new EventEmitter();
        this.columnsCustomization = {};
        this.dragActions = [];
        this.isDragging = false;
        this.dragSelectedColIndex = -1;
        // column width needs to be in object with property 'width' for ExResizeColumnDirective
        this.columnsWidth = {};
        //all columns are defined in pixels. custom columns are scaled according to the actual size of the table.
        //preRow and OTB columns size is fixed and not scaled
        this.DEFAULT_COLUMN_WIDTH = 200;
        this.DEFAULT_COLUMN_WIDTH_DRAG = 40;
        this.DEFAULT_COLUMN_WIDTH_INDEX = 40;
        this.DEFAULT_COLUMN_WIDTH_PICKUP = 40;
        this.DEFAULT_COLUMN_WIDTH_ACTIONS = 50;
        this.NUM_DISPLAYED_WHEN_ITEM_OPEN = 1;
        this._SINGLE_SAVE_EDIT_ACTION_KEY = SINGLE_SAVE_EDIT_ACTION_KEY;
        this._PICKUP_ACTION_KEY = PICKUP_ACTION_KEY;
        /**
         * The array of ids of columns, only columns that are in this array are visible in the table.
         * The Order of columns is determined by the order in this array.
         */
        this.displayedColumns = [];
        this.numOTBColumns = 0;
        this.numPreRowColumns = 0;
        this.ITEMS_LAYOUT_ITEM_TOGGLE_ACTION_KEY = ITEMS_LAYOUT_ITEM_TOGGLE_ACTION;
        this.copyCellActionLabel = this.translate.instant('ng.grid_layout.actions.copy_cell_value');
        this.copyCellAction = { label: this.copyCellActionLabel, value: 'ex_copy_cell_value', type: 'action' };
        this.OtbColumnsComponentTypes = {
            chip: ExChipRecordComponent
        };
    }
    onComponentInit() {
        super.onComponentInit();
        this.initGridCustomizationData();
        this.gridId = `${this.exPageId?.()}-GRID-LAYOUT`;
    }
    componentOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.initSchema();
            this.setDispayedColumns();
            this.listProperties.hasDrag && this.setDragActions();
        }
        if (changes.hasOwnProperty('isItemOpen') && !changes.isItemOpen.isFirstChange()) {
            this.setDispayedColumns();
        }
    }
    onComponentDestroy() {
        super.onComponentDestroy();
    }
    initGridCustomizationData() {
        this._subscription.add(this.pageCustomizationData
            .pipe(map$1(customizationData => this.transformGridCustomizationDataArrayToMap(customizationData.grid)))
            .subscribe(columnsCustomization => {
            this.columnsCustomization = columnsCustomization;
            this.setDispayedColumns();
        }));
    }
    transformGridCustomizationDataArrayToMap(gridCustomizationData) {
        return (gridCustomizationData ?? []).reduce((map, customizationDataItem) => {
            map[customizationDataItem.itemId] = customizationDataItem;
            return map;
        }, {});
    }
    transformGridCustomizationDataMapToArray(gridCustomizationData) {
        return Object.values(gridCustomizationData ?? {});
    }
    initSchema() {
        this.schema = this.items?.[0]?.listItem?.['__proto__'] ?? {};
    }
    setDragActions() {
        if (!(this.listProperties?.pagination?.totalItemsCount > 0)) {
            this.dragActions = [];
            return;
        }
        this.dragActions = [
            {
                value: 'first',
                label: this.translate.instant('ng.general.move-to-first-page'),
                disabled: !this.hasPreviousPage(),
                loading: false
            },
            {
                value: 'previous',
                label: this.translate.instant('ng.general.move-to-previous-page'),
                disabled: !this.hasPreviousPage(),
                loading: false
            },
            {
                value: 'next',
                label: this.translate.instant('ng.general.move-to-next-page'),
                disabled: !this.hasNextPage(),
                loading: false
            },
            {
                value: 'last',
                label: this.translate.instant('ng.general.move-to-last-page'),
                disabled: !this.hasNextPage(),
                loading: false
            }
        ];
    }
    initColumnsWidth() {
        this.columnsWidth[ExItemsLayoutGridColumnNames.DRAG] = { width: this.listProperties.gridColumnsWidth?.drag ?? this.DEFAULT_COLUMN_WIDTH_DRAG };
        this.columnsWidth[ExItemsLayoutGridColumnNames.INDEX] = { width: this.listProperties.gridColumnsWidth?.index ?? this.DEFAULT_COLUMN_WIDTH_INDEX };
        this.columnsWidth[ExItemsLayoutGridColumnNames.PICKUP] = { width: this.listProperties.gridColumnsWidth?.pickup ?? this.DEFAULT_COLUMN_WIDTH_PICKUP };
        this.columnsWidth[ExItemsLayoutGridColumnNames.ACTIONS] = { width: this.listProperties.gridColumnsWidth?.rowAction ?? this.DEFAULT_COLUMN_WIDTH_ACTIONS };
        this.schema['columns']?.forEach(column => {
            this.columnsWidth[column.columnIdentifier] = { width: column.columnWidth };
        });
    }
    setDispayedColumns() {
        this.displayedColumns = [];
        if (this.schema && this.schema['columns']) {
            this.displayedColumns = this.getAllColumns();
            this.SortAndFilterDisplayedColumns();
            this.setColumnsWidth();
        }
    }
    getAllColumns() {
        let columns = [];
        // OTB columns
        if (this.listProperties.hasDrag)
            columns.push(ExItemsLayoutGridColumnNames.DRAG);
        if (this.listProperties.hasIndex)
            columns.push(ExItemsLayoutGridColumnNames.INDEX);
        if (this.listProperties.hasPickup)
            columns.push(ExItemsLayoutGridColumnNames.PICKUP);
        this.numOTBColumns = columns.length;
        //preRow columns
        this.schema['columns'].forEach(column => {
            if (column.isPreRow) {
                columns.push(column.columnIdentifier);
            }
        });
        this.numPreRowColumns = columns.length - this.numOTBColumns;
        // Custom columns
        this.schema['columns'].forEach(column => {
            if (!column.isPreRow) {
                columns.push(column.columnIdentifier);
            }
        });
        // Row actions column
        if ((this.schema.actions && !this.isItemOpen) || this.isSingleSave)
            columns.push(ExItemsLayoutGridColumnNames.ACTIONS);
        return columns;
    }
    SortAndFilterDisplayedColumns() {
        if (!this.displayedColumns)
            return;
        this.displayedColumns.sort((a, b) => {
            return (this.getColumnUiOrder(a) - this.getColumnUiOrder(b));
        });
        this.displayedColumns = this.displayedColumns.filter((key, index) => this.getColumnShow(key)).filter((key, index) => {
            return (this.isItemOpen ? index < this.numOTBColumns + this.numPreRowColumns + this.NUM_DISPLAYED_WHEN_ITEM_OPEN : true);
        });
    }
    getColumnShow(key) {
        return this.columnsCustomization[key]?.show ?? (this.schema['columns'].find(i => i.columnIdentifier == key)?.isHidden == undefined ? true : !this.schema['columns'].find(i => i.columnIdentifier == key)?.isHidden);
    }
    getColumnUiOrder(columnIdentifier) {
        if (columnIdentifier === ExItemsLayoutGridColumnNames.ACTIONS)
            return this.displayedColumns.length; // actions column always at the end
        return this.columnsCustomization[columnIdentifier]?.uiOrder ?? 0;
    }
    setColumnsWidth() {
        // numOtbColumns is known at this point
        if (!this.tableWidth || (this.displayedColumns?.length == 0))
            return;
        this.initColumnsWidth();
        const { OtbColumnsWidth, preRowColumnsWidth, customColumnsWidth } = this.setBaseColumnsWidth();
        this.scaleColumnsWidth(OtbColumnsWidth, preRowColumnsWidth, customColumnsWidth);
        this.changeDetectorRef.detectChanges();
    }
    // set base width for columns, and sum the widths
    setBaseColumnsWidth() {
        let OtbColumnsWidth = 0;
        let customColumnsWidth = 0;
        let preRowColumnsWidth = 0;
        this.displayedColumns.forEach(key => {
            this.columnsWidth[key] = {
                width: this.columnsCustomization[key]?.width ??
                    this.columnsWidth[key].width ??
                    this.DEFAULT_COLUMN_WIDTH
            };
            if (this.schema['columns'].find(c => c.columnIdentifier == key)?.isPreRow) {
                preRowColumnsWidth += this.columnsWidth[key].width;
            }
            else if (Object.values(ExItemsLayoutGridColumnNames).includes(key))
                OtbColumnsWidth += this.columnsWidth[key].width;
            else
                customColumnsWidth += this.columnsWidth[key].width;
        });
        return { OtbColumnsWidth, preRowColumnsWidth, customColumnsWidth };
    }
    // scale the column widths according to actual table width
    scaleColumnsWidth(OtbColumnsWidth, preRowColumnsWidth, customColumnsWidth) {
        let actualTotalColumnsWidth = 0;
        const scale = (this.tableWidth - 5 - OtbColumnsWidth - preRowColumnsWidth) / customColumnsWidth;
        this.displayedColumns.forEach(key => {
            // scale just custom, non-preRow columns - not otb columns
            if (!Object.values(ExItemsLayoutGridColumnNames).includes(key) && !this.schema['columns'].find(c => c.columnIdentifier == key)?.isPreRow) {
                if (!this.isItemOpen)
                    this.columnsWidth[key].width *= scale;
                else
                    this.columnsWidth[key].width = (this.columnsWidth[key].width + ((OtbColumnsWidth + preRowColumnsWidth) / (this.displayedColumns.length - this.numOTBColumns - this.numPreRowColumns))) * scale;
            }
            actualTotalColumnsWidth += this.columnsWidth[key].width;
        });
        // if actual width of all columns is smaller than tableWidth, add the variance to the last displayed column
        this.columnsWidth[this.displayedColumns[this.displayedColumns.length - 1]].width += this.tableWidth - actualTotalColumnsWidth;
        this.columnsWidth = { ...this.columnsWidth };
    }
    onGridResized(event) {
        this.onResized(event);
        this.tableWidth = event.newRect.width;
        if (!event.oldRect || event.newRect.width !== event.oldRect.width) {
            this.setColumnsWidth();
        }
    }
    onActionClicked(item, key) {
        this.onItemClicked(item, true);
        super.onActionClicked(item, key);
    }
    onHeaderClicked(column) {
        if (!this.isSortable(column))
            return;
        let sortIndex, order;
        this.listProperties.sorts.some((sort, i) => {
            const found = sort.sortByOptions.some(option => {
                if (option.value === column.sortKey) {
                    sortIndex = i;
                    return true;
                }
            });
            if (found) {
                order = sort.selectedOption === column.sortKey && sort.order === 'asc' ? 'desc' : 'asc';
                return true;
            }
        });
        !isNil(sortIndex) && this.columnHeaderSortChange.emit({ sortBy: column.sortKey, order: order, index: sortIndex });
    }
    isSortable(column) {
        return this.listProperties.sorts?.some(sort => sort.sortByOptions?.some(option => option.value == column.sortKey));
    }
    columnHeaderLabelSpaceClicked(event, colIndex) {
        this.dragSelectedColIndex = event ? colIndex : -1;
    }
    columnHeaderLabelBlurred() {
        this.dragSelectedColIndex = -1;
    }
    dropCol(event) {
        if (this.isItemOpen)
            return; // Customization not allowed when in split view
        moveItemInArray(this.displayedColumns, event.previousIndex + this.numOTBColumns + this.numPreRowColumns, event.currentIndex + this.numOTBColumns + this.numPreRowColumns);
        this.displayedColumns = [...this.displayedColumns];
        this.customizationFinished();
        this.dragSelectedColIndex = event.currentIndex;
    }
    onRowStartFocused(event) {
        if (!event.relatedTarget['className']?.includes('ex-items-layout-grid-selected-row') ||
            !this.items.findIndex(item => item.id == this.selectedItem?.id)) {
            return;
        }
        super.onRowStartFocused(event);
    }
    customizationFinished() {
        if (this.isItemOpen)
            return; // Customization not allowed when in split view
        const updatedColumnsCustomization = this.displayedColumns.map((columnKey, index) => {
            return {
                ...(this.columnsCustomization[columnKey] ?? {}),
                itemId: columnKey,
                uiOrder: index - this.numOTBColumns - this.numPreRowColumns,
                show: true,
                type: 'GRID',
                width: this.columnsWidth[columnKey].width
            };
        });
        this.layoutCustomized.emit(updatedColumnsCustomization);
    }
    dragActionClicked(key, index) {
        this.rowDraggedDropped.emit({ currentIndex: key, previousIndex: index });
    }
    addCopyCellValueAction(actions) {
        if (actions?.length == 0) {
            actions = [this.copyCellAction];
        }
        else {
            if (actions?.findIndex((action) => action.value === 'ex_copy_cell_value') < 0) {
                actions = [...actions, this.copyCellAction];
            }
        }
        return actions;
    }
    onCopyCellClicked(event) {
        let copyLinkFunc = function (e) {
            e.clipboardData.setData('text/plain', (event.targetElement.closest('td').innerText).trim());
            e.preventDefault();
            document.removeEventListener('copy', copyLinkFunc);
        };
        document.addEventListener('copy', copyLinkFunc);
        document.execCommand('copy');
    }
    iconTrackBy(index, icon) {
        return icon?.iconName;
    }
    getHighlightedText(field) {
        if (field.showHighlight) {
            return this.listProperties.highlightedText;
        }
        else {
            return null;
        }
    }
    static { this.ɵfac = function ExItemsLayoutGridComponent_Factory(t) { return new (t || ExItemsLayoutGridComponent)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(EX_PAGE_ID, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutGridComponent, selectors: [["ex-items-layout-grid"]], viewQuery: function ExItemsLayoutGridComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1e, 5);
            i0.ɵɵviewQuery(_c1$M, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItems = _t);
        } }, outputs: { columnHeaderSortChange: "columnHeaderSortChange" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_IS_INSIDE_GRID, useValue: true }]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "ex-items-layout-grid-wrapper", 4, "ngIf"], [4, "ngIf"], [1, "ex-items-layout-grid-wrapper"], ["class", "ex-items-layout-grid-table-wrapper", 3, "resized", 4, "ngIf"], [1, "ex-items-layout-grid-table-wrapper", 3, "resized"], ["class", "ex-items-layout-grid-table-blocked", 4, "ngIf"], ["cellpadding", "0", "cellspacing", "0", 1, "mat-elevation-z8", "ex-items-layout-grid-table", "sel-grid-table", "ex-items-layout-grid-table-bottom-border", 3, "id"], ["exDragList", "", "cdkDropList", "", "cdkDropListOrientation", "horizontal", "role", "row", 1, "ex-items-layout-grid-table-header", "ex-items-layout-grid-header-text", 3, "cdkDropListSortingDisabled", "cdkDropListDisabled", "cdkDropListData", "cdkDropListDropped"], ["scope", "col", "identifier", "drag", "class", "ex-items-layout-grid-index-column ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["scope", "col", "identifier", "index", "class", "ex-items-layout-grid-index-column ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "pickup", "class", "ex-items-layout-grid-checkbox ex-items-layout-grid-header-text ex-items-layout-grid-no-left-padding ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["customAndPreRowColumnHeaderContent", ""], ["scope", "col", "identifier", "actions", "class", "ex-items-layout-grid-no-left-padding ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["exDragList", "", "cdkDropList", "", "class", "ex-items-layout-grid-tbody", 3, "cdkDropListData", "cdkDropListDropped", 4, "ngIf"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination", 4, "ngIf"], [1, "ex-items-layout-grid-table-blocked"], ["scope", "col", "identifier", "drag", 1, "ex-items-layout-grid-index-column", "ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["scope", "col", "identifier", "index", 1, "ex-items-layout-grid-index-column", "ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["identifier", "pickup", 1, "ex-items-layout-grid-checkbox", "ex-items-layout-grid-header-text", "ex-items-layout-grid-no-left-padding", "ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [1, "ex-items-layout-grid-flex-centered"], ["scope", "col", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "class", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["scope", "col", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], [3, "exTooltip", "ngClass"], [1, "group-inline", 3, "ngClass", "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "inline-block", "tabindex", "0", 4, "ngIf"], ["tabindex", "0", 1, "inline-block"], ["scope", "col", "cdkDrag", "", "cdkDragLockAxis", "x", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "class", "ngClass", "cdkDragStarted", "cdkDragEnded", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["scope", "col", "cdkDrag", "", "cdkDragLockAxis", "x", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "ngClass", "cdkDragStarted", "cdkDragEnded", "columnsCustomizationChange", "customizationFinished"], ["class", "inline-block", "tabindex", "0", 3, "exDrag", "spaceClicked", "blured", 4, "ngIf"], [3, "width", 4, "cdkDragPreview"], ["class", "ex-items-layout-grid-custom-placeholder", 4, "cdkDragPlaceholder"], ["tabindex", "0", 1, "inline-block", 3, "exDrag", "spaceClicked", "blured"], ["class", "ex-items-layout-grid-header-text ex-items-layout-grid-th ex-items-layout-grid-drag-preview", 3, "ngClass", 4, "ngIf"], [1, "ex-items-layout-grid-header-text", "ex-items-layout-grid-th", "ex-items-layout-grid-drag-preview", 3, "ngClass"], [1, "ex-items-layout-grid-custom-placeholder"], ["class", "sel-grid-column-sort uxf-icon headerSortIcon ex-items-layout-grid-sort-icon", "tabindex", "0", "role", "button", 3, "ngClass", "keydown.Enter", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "sel-grid-column-sort", "uxf-icon", "headerSortIcon", "ex-items-layout-grid-sort-icon", 3, "ngClass", "keydown.Enter"], ["scope", "col", "identifier", "actions", 1, "ex-items-layout-grid-no-left-padding", "ex-items-layout-grid-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["exDragList", "", "cdkDropList", "", 1, "ex-items-layout-grid-tbody", 3, "cdkDropListData", "cdkDropListDropped"], [1, "ex-items-layout-grid-right-click-actions", 3, "actions", "actionClicked", "copyCellClicked"], ["class", "ex-items-layout-grid-row-start-button ex-items-layout-grid-hidden-button", "aria-label", "move to previous list item", 3, "focusin", 4, "ngIf"], ["class", "ex-items-layout-grid-hidden-button", "aria-label", "move focus to right side", 3, "keyup.Tab", 4, "ngIf"], ["rowsTemplate", ""], ["aria-label", "move to previous list item", 1, "ex-items-layout-grid-row-start-button", "ex-items-layout-grid-hidden-button", 3, "focusin"], ["aria-label", "move focus to right side", 1, "ex-items-layout-grid-hidden-button", 3, "keyup.Tab"], ["cdkDrag", "", "role", "row", "tabindex", "0", 1, "ex-items-layout-grid-row", 3, "cdkDragDisabled", "ngClass", "click", "keydown.enter", "keydown.space", "keydown.arrowdown", "keydown.arrowup"], ["rowItemRef", ""], [1, "sr-only"], ["identifier", "drag", "class", "ex-items-layout-grid-index-column\n      ex-items-layout-grid-no-border-bottom inline-cell ex-items-layout-grid-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "index", "class", "ex-items-layout-grid-index-column\n          ex-items-layout-grid-no-border-bottom inline-cell ex-items-layout-grid-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "pickup", "class", "ex-items-layout-grid-cell", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "actions", "class", "ex-items-layout-grid-cell ex-items-layout-grid-no-side-padding ex-items-layout-grid-center-actions", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "drag", 1, "ex-items-layout-grid-index-column", "ex-items-layout-grid-no-border-bottom", "inline-cell", "ex-items-layout-grid-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [3, "actions", "actionClicked", "contextmenu"], ["cdkDragHandle", "", 1, "ex-items-layout-grid-drag-handle"], ["identifier", "index", 1, "ex-items-layout-grid-index-column", "ex-items-layout-grid-no-border-bottom", "inline-cell", "ex-items-layout-grid-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["identifier", "pickup", 1, "ex-items-layout-grid-cell", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [3, "checked", "disabled", "ariaLabel", "exTooltip", "click", "checkedChange", 4, "ngIf"], [3, "aria-labelledby", "checked", "keydown.space", "click", 4, "ngIf"], [3, "color", "iconName", "exTooltip", 4, "ngIf"], [3, "color", "iconName", 4, "ngIf"], [1, "ex-items-layout-grid-thumbnail-icons"], [3, "iconName", "color", "tooltip", "callback", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "checked", "disabled", "ariaLabel", "exTooltip", "click", "checkedChange"], [3, "aria-labelledby", "checked", "keydown.space", "click"], [3, "color", "iconName", "exTooltip"], [3, "color", "iconName"], [3, "iconName", "color", "tooltip", "callback"], [3, "exResizeColumn", "id", "isFocusable", "orderedColumns", "identifier", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], [1, "display-content", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["simpleColumn", ""], [3, "componentFactoryItem", "data", "content", "events", 4, "ngIf", "ngIfElse"], ["chipColumn", ""], [3, "componentFactoryItem", "data", "content", "events"], [3, "chips", "iconType"], ["class", "ex-items-layout-grid-flex-centered ", 4, "ngIf", "ngIfElse"], ["toggle", ""], ["link", ""], ["entityLabels", ""], ["text", ""], [3, "iconName", "color", "tooltip", "size"], ["class", "ex-items-layout-grid-flex-centered", 4, "ngIf", "ngIfElse"], [3, "toggleChecked", "click", "toggleCheckedChange"], [3, "arguments"], [3, "entityLabels", "iconType"], [1, "inline-cell", 3, "exTooltip", "innerHTML"], ["identifier", "actions", 1, "ex-items-layout-grid-cell", "ex-items-layout-grid-no-side-padding", "ex-items-layout-grid-center-actions", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [1, "ex-items-layout-grid-actions-container"], ["class", "ex-items-layout-grid-record-actions", 3, "actions", "visibleBtnNum", "loading", "isSelected", "index", "actionClicked", 4, "ngIf"], ["class", "ex-items-layout-grid-actions-edit", "ariaLabel", "ng.general.edit", 3, "ngClass", "tooltip", "click", 4, "ngIf"], [1, "ex-items-layout-grid-record-actions", 3, "actions", "visibleBtnNum", "loading", "isSelected", "index", "actionClicked"], ["ariaLabel", "ng.general.edit", 1, "ex-items-layout-grid-actions-edit", 3, "ngClass", "tooltip", "click"], ["iconName", "edit", "color", "#4164a4"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination"], ["paginationRef", ""], [1, "mat-elevation-z8", "ex-items-layout-grid-table"], [1, "ex-items-layout-grid-animate", "sel-grid-tbody"], ["class", "ex-items-layout-grid-row br", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "ex-items-layout-grid-row", "br", 3, "ngClass"]], template: function ExItemsLayoutGridComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExItemsLayoutGridComponent_div_0_Template, 2, 1, "div", 0);
            i0.ɵɵtemplate(1, ExItemsLayoutGridComponent_div_1_Template, 4, 1, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.schema && ctx.schema["columns"]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.listProperties.isLoading);
        } }, styles: [".ex-items-layout-grid-table-wrapper[_ngcontent-%COMP%]{overflow:visible;width:calc(100% - 2.1px)}.ex-items-layout-grid-table[_ngcontent-%COMP%]{border-collapse:separate;box-shadow:none!important;table-layout:fixed;overflow:auto;border-inline-start:1px solid #efefef;border-inline-end:1px solid #efefef}.ex-items-layout-grid-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .ex-items-layout-grid-tbody[_ngcontent-%COMP%]{position:relative}.ex-items-layout-grid-no-side-padding[_ngcontent-%COMP%]{padding-right:0!important;padding-left:0!important}.ex-items-layout-grid-center-actions[_ngcontent-%COMP%]{display:flex;justify-content:center}.display-content[_ngcontent-%COMP%]{display:contents}.group-inline[_ngcontent-%COMP%]{display:flex}.inline-block[_ngcontent-%COMP%]{white-space:nowrap;display:inline-block;text-overflow:ellipsis;overflow:hidden}.inline-cell[_ngcontent-%COMP%]{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden;white-space:pre-line}.ex-items-layout-grid-cell[_ngcontent-%COMP%]{text-align:start;vertical-align:top;padding:10px;position:relative;border-inline-start:solid 1px #898989}.ex-items-layout-grid-sort-icon[_ngcontent-%COMP%]{margin-inline-end:0px;cursor:pointer}.ex-items-layout-grid-header-text[_ngcontent-%COMP%]{height:30px}.ex-items-layout-grid-table-header[_ngcontent-%COMP%]{position:sticky;z-index:10;top:0}.ex-items-layout-grid-sortable-header[_ngcontent-%COMP%]:hover{cursor:pointer;width:-moz-fit-content;width:fit-content}.ex-items-layout-grid-no-left-padding[_ngcontent-%COMP%]{padding-inline-start:0px!important}.ex-items-layout-grid-th[_ngcontent-%COMP%]{position:sticky;top:0;z-index:9;padding-inline-start:10px;border-bottom:2px solid #c5c7c6;height:50px;border-top:1px solid white;border-inline-start:solid 1px #898989}.ex-items-layout-grid-header-draggable[_ngcontent-%COMP%]{cursor:move}.ex-items-layout-grid-index-column[_ngcontent-%COMP%]{text-align:center;vertical-align:top;padding:10px!important;padding-inline-start:6px!important}.ex-items-layout-grid-table-bottom-border[_ngcontent-%COMP%]{border-bottom:2px solid #c5c7c6}.ex-items-layout-grid-no-border-bottom[_ngcontent-%COMP%]{border-bottom:0}.ex-items-layout-grid-flex-centered[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.ex-items-layout-grid-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 2s infinite linear;background:linear-gradient(135deg,#f3f5f4 49%,#fff9 50%,#f3f5f4 52%);background-size:200% 200%}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-items-layout-grid-even-row[_ngcontent-%COMP%]{background:#fff;border-inline-start-color:#fff}.ex-items-layout-grid-odd-row[_ngcontent-%COMP%]{background:#f3f5f4;border-inline-start-color:#f3f5f4}.ex-items-layout-grid-row[_ngcontent-%COMP%]{display:flex;height:min-content;min-height:42px}.ex-items-layout-grid-row[_ngcontent-%COMP%]     .ex-label-value .ex-label-value-span{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}.ex-items-layout-grid-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-bar{transform:scale(.7)!important;margin-inline-end:0px!important;margin-inline-start:5px!important}.ex-items-layout-grid-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-items-layout-grid-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-label{margin-bottom:0!important}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.ex-items-layout-grid-custom-placeholder[_ngcontent-%COMP%]{min-height:50px;transition:transform .25s cubic-bezier(0,0,.2,1);border-top:1px solid white;border-bottom:2px solid #c5c7c6}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.ex-items-layout-grid-drag-preview[_ngcontent-%COMP%]{display:flex;align-items:center;border:none!important;border-radius:3px;background:#fff}.ex-items-layout-grid-resize-holder[_ngcontent-%COMP%]{cursor:col-resize;width:10px;height:100%;position:absolute;top:0;z-index:1;margin-right:1px}.ex-items-layout-grid-resizing[_ngcontent-%COMP%]{cursor:col-resize!important}.ex-items-layout-grid-table-blocked[_ngcontent-%COMP%]{position:absolute;top:50px;left:0;height:calc(100% - 50px);width:100%;background:#fff;z-index:10000000;opacity:.5}.ex-items-layout-grid-drag-handle[_ngcontent-%COMP%]{cursor:move}.cdk-drag-preview.ex-items-layout-grid-row[_ngcontent-%COMP%]{background:#fff}.cdk-drag-preview.ex-items-layout-grid-odd-row[_ngcontent-%COMP%]{background:#f3f5f4!important}.ex-items-layout-grid-right-click-actions[_ngcontent-%COMP%]{display:flex}.ex-items-layout-grid-hidden-button[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-items-layout-grid-selected-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:1px solid #c5c7c6!important;border-bottom:1px solid #c5c7c6!important}.ex-items-layout-grid-selected-row[_ngcontent-%COMP%]{background:#ebebeb!important}.ex-items-layout-grid-selected-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{border-inline-start-color:#0e7bba!important}.ex-items-layout-grid-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{border-inline-start:4px solid transparent}.ex-items-layout-grid-row[_ngcontent-%COMP%]:hover   td[_ngcontent-%COMP%]:first-child{border-inline-start-color:#ebebeb}.ex-items-layout-grid-space-clicked[_ngcontent-%COMP%]{color:#fff!important}.ex-items-layout-grid-actions-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-inline:5px}.ex-items-layout-grid-actions-container[_ngcontent-%COMP%] > ex-button[_ngcontent-%COMP%]{align-self:flex-end}.ex-items-layout-grid-actions-container[_ngcontent-%COMP%]   .ex-items-layout-grid-record-actions[_ngcontent-%COMP%]  .ex-record-actions-more-btn{border:1px solid #c8c8c8}.ex-items-layout-grid-thumbnail-icons[_ngcontent-%COMP%]{display:flex;flex-direction:column;row-gap:5px}mat-radio-button[_ngcontent-%COMP%]     .mat-radio-label{margin:0!important;padding-inline-start:6px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutGridComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-grid', providers: [{ provide: EX_IS_INSIDE_GRID, useValue: true }], template: "<div *ngIf=\"schema && schema['columns']\" class=\"ex-items-layout-grid-wrapper\">\r\n\r\n  <div (resized)=\"onGridResized($event)\" *ngIf=\"!listProperties.isLoading\" class=\"ex-items-layout-grid-table-wrapper\">\r\n    <div *ngIf=\"isDragging\" class=\"ex-items-layout-grid-table-blocked\"></div>\r\n\r\n\r\n    <table cellpadding=\"0\" cellspacing=\"0\" [id]=\"gridId\"\r\n           class=\"mat-elevation-z8 ex-items-layout-grid-table sel-grid-table ex-items-layout-grid-table-bottom-border\">\r\n      <thead>\r\n      <!-- ### COLUMN HEADERS ### -->\r\n      <tr exDragList cdkDropList cdkDropListOrientation=\"horizontal\" [cdkDropListSortingDisabled]=\"isItemOpen\"\r\n          [cdkDropListDisabled]=\"isItemOpen\" role=\"row\"\r\n          [cdkDropListData]=\"displayedColumns\" (cdkDropListDropped)=\"dropCol($event)\"\r\n          class=\"ex-items-layout-grid-table-header ex-items-layout-grid-header-text\">\r\n\r\n        <!-- ### OTB COLUMN HEADERS ### -->\r\n        <th scope=\"col\" *ngIf=\"this.listProperties.hasDrag\" [exResizeColumn]=\"!isItemOpen\"\r\n            [orderedColumns]=\"displayedColumns\" identifier=\"drag\" [(columnsCustomization)]=\"columnsWidth\"\r\n            (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-index-column ex-items-layout-grid-th\">\r\n        </th>\r\n        <th scope=\"col\" *ngIf=\"this.listProperties.hasIndex\" [exResizeColumn]=\"!isItemOpen\" [orderedColumns]=\"displayedColumns\"\r\n            identifier=\"index\" [(columnsCustomization)]=\"columnsWidth\"\r\n            (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-index-column ex-items-layout-grid-th\">\r\n        </th>\r\n        <th *ngIf=\"this.listProperties.hasPickup\" [exResizeColumn]=\"false\" [orderedColumns]=\"displayedColumns\"\r\n            identifier=\"pickup\" [(columnsCustomization)]=\"columnsWidth\"\r\n            (customizationFinished)=\"customizationFinished()\"\r\n            class=\"ex-items-layout-grid-checkbox ex-items-layout-grid-header-text ex-items-layout-grid-no-left-padding ex-items-layout-grid-th\">\r\n          <div class=\"ex-items-layout-grid-flex-centered\">\r\n            <ex-checkbox [style.visibility]=\"'hidden'\">\r\n              <!-- checkbox to maintain correct width; actual header checkbox is in the layout header -->\r\n            </ex-checkbox>\r\n          </div>\r\n        </th>\r\n        <!-- ### PREROW COLUMN HEADERS ### -->\r\n        <ng-container\r\n          *ngFor=\"let column of schema['columns'] | itemsLayoutGridColumns : displayedColumns : columnsCustomization; let i = index\">\r\n          <th scope=\"col\" *ngIf=\"column.isPreRow\" [exResizeColumn]=\"false\"\r\n              [orderedColumns]=\"displayedColumns\" [identifier]=\"column.columnIdentifier\"\r\n              [(columnsCustomization)]=\"columnsWidth\" (customizationFinished)=\"customizationFinished()\"\r\n              class=\"{{ 'sel-grid-header-' + column.columnIdentifier }} ex-items-layout-grid-header-text ex-items-layout-grid-th\"\r\n              [ngClass]=\"{ 'ex-items-layout-grid-no-left-padding': column.isIconColumn || column.isToggleColumn, 'ex-items-layout-grid-header-draggable': !isItemOpen, 'ex-items-layout-grid-selected-drag-column': dragSelectedColIndex === i }\">\r\n            <div [exTooltip]=\"column.customTooltip || column.label | translate\"\r\n                 [ngClass]=\"{'ex-items-layout-grid-flex-centered': column.centered && column.centered === true}\">\r\n              <span class=\"group-inline\" [ngClass]=\"{'ex-items-layout-grid-sortable-header': listProperties?.sorts | exIsSortableColumn : column?.sortKey}\"\r\n                    (click)=\"$event.stopPropagation(); onHeaderClicked(column)\">\r\n                <ng-container [ngTemplateOutlet]=\"customAndPreRowColumnHeaderContent\" [ngTemplateOutletContext]=\"{column: column}\"></ng-container>\r\n                <div *ngIf=\"column.displayLabelInHeader\"\r\n                     class=\"inline-block\" tabindex=\"0\">\r\n                  {{ column.label | translate }}</div>\r\n              </span>\r\n            </div>\r\n          </th>\r\n        </ng-container>\r\n\r\n        <!-- ### CUSTOM COLUMN HEADERS ### -->\r\n        <ng-container\r\n          *ngFor=\"let column of schema['columns'] | itemsLayoutGridColumns : displayedColumns : columnsCustomization; let i = index\">\r\n          <th scope=\"col\" *ngIf=\"!column.isPreRow\" cdkDrag cdkDragLockAxis=\"x\"\r\n              (cdkDragStarted)=\"isDragging = true\" (cdkDragEnded)=\"isDragging = false\" [exResizeColumn]=\"!isItemOpen\"\r\n              [orderedColumns]=\"displayedColumns\" [identifier]=\"column.columnIdentifier\"\r\n              [(columnsCustomization)]=\"columnsWidth\" (customizationFinished)=\"customizationFinished()\"\r\n              class=\"{{ 'sel-grid-header-' + column.columnIdentifier }} ex-items-layout-grid-header-text ex-items-layout-grid-th\"\r\n              [ngClass]=\"{ 'ex-items-layout-grid-no-left-padding': column.isIconColumn || column.isToggleColumn, 'ex-items-layout-grid-header-draggable': !isItemOpen, 'ex-items-layout-grid-selected-drag-column': dragSelectedColIndex === i }\">\r\n            <div [exTooltip]=\"column.customTooltip || column.label | translate\"\r\n                 [ngClass]=\"{'ex-items-layout-grid-flex-centered': column.centered && column.centered === true}\">\r\n              <span class=\"group-inline\" [ngClass]=\"{'ex-items-layout-grid-sortable-header': listProperties?.sorts | exIsSortableColumn : column?.sortKey}\"\r\n                    (click)=\"$event.stopPropagation(); onHeaderClicked(column)\">\r\n                <ng-container [ngTemplateOutlet]=\"customAndPreRowColumnHeaderContent\" [ngTemplateOutletContext]=\"{column: column}\"></ng-container>\r\n                <div *ngIf=\"column.displayLabelInHeader\" [exDrag]=\"true\"\r\n                     class=\"inline-block\" tabindex=\"0\" (spaceClicked)=\"columnHeaderLabelSpaceClicked($event, i)\"\r\n                     (blured)=\"columnHeaderLabelBlurred()\"> <!-- TODO: drag spaceClick should be on entire column header, not on label -->\r\n                  {{ column.label | translate }}</div>\r\n              </span>\r\n            </div>\r\n            <div *cdkDragPreview\r\n                 [style.width.px]=\"columnsWidth[column.columnIdentifier]?.width\">\r\n              <div *ngIf=\"column.displayLabelInHeader\"\r\n                   class=\"ex-items-layout-grid-header-text ex-items-layout-grid-th ex-items-layout-grid-drag-preview\"\r\n                   [ngClass]=\"{ 'ex-items-layout-grid-no-left-padding': column.isIconColumn || column.isToggleColumn }\">\r\n                {{ column.label | translate }}</div>\r\n            </div>\r\n            <div *cdkDragPlaceholder class=\"ex-items-layout-grid-custom-placeholder\">\r\n            </div>\r\n          </th>\r\n        </ng-container>\r\n\r\n        <ng-template #customAndPreRowColumnHeaderContent let-column=\"column\">\r\n           <span *ngIf=\"listProperties?.showSortsInListHeader && (listProperties?.sorts | exIsSortableColumn : column?.sortKey)\"\r\n                 class=\"sel-grid-column-sort uxf-icon headerSortIcon ex-items-layout-grid-sort-icon\"\r\n                 [ngClass]=\"{'uxf-arrow-combo': listProperties.sorts?.[0]?.selectedOption != column.sortKey,\r\n                                  'uxf-down-caret': listProperties.sorts?.[0]?.selectedOption == column.sortKey && listProperties.sorts?.[0]?.order === 'desc',\r\n                                  'uxf-up-caret': listProperties.sorts?.[0]?.selectedOption == column.sortKey && listProperties.sorts?.[0]?.order === 'asc'}\"\r\n                 [attr.aria-label]=\"'ng.general.sort-tooltip' | translate: { columnName: (column.label | translate) }\"\r\n                 tabindex=\"0\" role=\"button\" (keydown.Enter)=\"$event.stopPropagation(); onHeaderClicked(column)\">\r\n           </span>\r\n        </ng-template>\r\n\r\n        <!-- ### ACTIONS COLUMN HEADERS ### -->\r\n        <th scope=\"col\" *ngIf=\"!isItemOpen && (schema.actions  || isSingleSave)\" [exResizeColumn]=\"!isItemOpen\"\r\n            [orderedColumns]=\"displayedColumns\"\r\n            identifier=\"actions\" [(columnsCustomization)]=\"columnsWidth\"\r\n            (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-no-left-padding ex-items-layout-grid-th\">\r\n        </th>\r\n      </tr>\r\n</thead>\r\n      <tbody *ngIf=\"!listProperties.isLoading && items?.length > 0\" exDragList cdkDropList class = \"ex-items-layout-grid-tbody\"\r\n             [cdkDropListData]=\"items\" (cdkDropListDropped)=\"onDropListDropped($event)\">\r\n\r\n      <!-- ### ROWS ### -->\r\n      <ng-container *ngFor=\"let row of items; let rowIndex = index\">\r\n        <ex-right-click-actions  class=\"ex-items-layout-grid-right-click-actions\"\r\n                                [actions]=\"addCopyCellValueAction(row.listItem.actions?.actions)\"\r\n                                (actionClicked)=\"onActionClicked(row, $event)\"\r\n                                (copyCellClicked)=\"onCopyCellClicked($event)\">\r\n\r\n          <button *ngIf=\"isItemOpen && _selectedItem?.id === row.id\"\r\n                  class=\"ex-items-layout-grid-row-start-button ex-items-layout-grid-hidden-button\"\r\n                  aria-label=\"move to previous list item\" (focusin)=\"onRowStartFocused($event)\"></button>\r\n          <ng-container [ngTemplateOutlet]=\"rowsTemplate\" [ngTemplateOutletContext]=\"{isRowSelected: _selectedItem?.id == row.id}\"></ng-container>\r\n          <button *ngIf=\"isItemOpen && (_selectedItem?.id == row.id)\" class=\"ex-items-layout-grid-hidden-button\"\r\n                  aria-label=\"move focus to right side\" (keyup.Tab)=\"onTabFromRowEnd()\"></button>\r\n        </ex-right-click-actions>\r\n\r\n        <ng-template #rowsTemplate let-isRowSelected=\"isRowSelected\">\r\n          <tr #rowItemRef cdkDrag [cdkDragDisabled]=\"!listProperties.hasDrag\" class=\"ex-items-layout-grid-row\"\r\n              [ngClass]=\"{'ex-items-layout-grid-odd-row': (items.indexOf(row)) % 2 === 0, 'ex-items-layout-grid-selected-row' : isRowSelected}\"\r\n              role=\"row\" tabindex=\"0\" [attr.aria-label] = \"(isItemOpen ? ('ng.general.close-right-side' | translate) : ('ng.general.open-right-side' | translate)) + (isRowSelected? ' ' + ('ng.general.selected' | translate) : '')\"\r\n              (click)=\"onItemClicked(row)\" (keydown.enter)=\"$event.preventDefault; onItemClicked(row)\"\r\n              (keydown.space)=\"$event.preventDefault; onItemClicked(row)\" (keydown.arrowdown)=\"$event.preventDefault; onRowArrowDown($event, row)\"\r\n              (keydown.arrowup)=\"$event.preventDefault; onRowArrowUp($event, row)\">\r\n            <span class=\"sr-only\">{{row?.actionIndication?.type ? (row?.actionIndication?.type === 'success' ? ('ng.general.success' | translate) : (row?.actionIndication?.type === 'warning' ? ('ng.general.warning' | translate) : ('ng.general.failure' | translate)) +' - '+ (row?.actionIndication?.reason | translate)) : ''}}</span>\r\n            <!-- ### OTB COLUMNS ### -->\r\n            <td *ngIf=\"this.listProperties.hasDrag\" [exResizeColumn]=\"!isItemOpen\" [isFocusable]=\"false\"\r\n                [orderedColumns]=\"displayedColumns\" identifier=\"drag\" [(columnsCustomization)]=\"columnsWidth\"\r\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-index-column\r\n      ex-items-layout-grid-no-border-bottom inline-cell ex-items-layout-grid-index-column\">\r\n              <ex-right-click-actions [actions]=\"dragActions\" (actionClicked)=\"dragActionClicked($event, rowIndex)\"\r\n                                      (contextmenu)=\"$event.stopPropagation()\">\r\n                <ex-drag-accessible-icon class=\"ex-items-layout-grid-drag-handle\" cdkDragHandle></ex-drag-accessible-icon>\r\n              </ex-right-click-actions>\r\n            </td>\r\n            <td *ngIf=\"this.listProperties.hasIndex\" [exResizeColumn]=\"!isItemOpen\" [isFocusable]=\"false\"\r\n                [orderedColumns]=\"displayedColumns\" identifier=\"index\" [(columnsCustomization)]=\"columnsWidth\"\r\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-index-column\r\n          ex-items-layout-grid-no-border-bottom inline-cell ex-items-layout-grid-index-column\">\r\n              {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) +\r\n              items.indexOf(row) + 1) }}\r\n            </td>\r\n            <td *ngIf=\"this.listProperties.hasPickup\" [exResizeColumn]=\"false\" [isFocusable]=\"false\"\r\n                [orderedColumns]=\"displayedColumns\" identifier=\"pickup\" [(columnsCustomization)]=\"columnsWidth\"\r\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-items-layout-grid-cell\">\r\n              <div class=\"ex-items-layout-grid-flex-centered\">\r\n                <ex-checkbox *ngIf=\"listProperties.isMultiSelect\" (click)=\"$event.stopPropagation()\"\r\n                             (checkedChange)=\"onItemCheckedChange(row, $event)\"\r\n                             [checked]=\"isItemChecked(row)\" [disabled]=\"row.selectable===false\"\r\n                             [ariaLabel]=\"'ng.ex_items_layout_list_row.check_or_uncheck' | translate\"\r\n                             [exTooltip]=\"row.selectable!==false? '':row.nonSelectableTooltip | translate\">\r\n                </ex-checkbox>\r\n                <mat-radio-button *ngIf=\"!listProperties.isMultiSelect\"  aria-labelledby=\"row-{{rowIndex}}\" (keydown.space)=\"onSingleItemCheckedChange(row)\" (click)=\"onSingleItemCheckedChange(row)\" [checked]=\"isItemChecked(row)\" >\r\n                </mat-radio-button>\r\n                <ex-svg-icon *ngIf=\"row?.actionIndication?.type === 'failed'\"  [color]=\"'#e54746'\" [iconName]=\"'circ_warning'\" [exTooltip]=\"row?.actionIndication?.reason | translate\"></ex-svg-icon>\r\n                <ex-svg-icon *ngIf=\"row?.actionIndication?.type === 'warning'\"  [color]=\"'#e7a141'\" [iconName]=\"'warning'\" [exTooltip]=\"row?.actionIndication?.reason | translate\"></ex-svg-icon>\r\n                <ex-svg-icon *ngIf=\"row?.actionIndication?.type === 'success'\"  [color]=\"'#60c05f'\" [iconName]=\"'success'\" ></ex-svg-icon>\r\n                <div class=\"ex-items-layout-grid-thumbnail-icons\">\r\n                  <ex-svg-icon   *ngIf=\"row?.listItem[this.row?.listItem?.__proto__.thumbnailIcon?.key]; let icon\" [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                                 [tooltip]=\"icon?.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                  <ng-container *ngFor=\"let icon of row?.listItem | exUnderThumbnailIcons;trackBy:iconTrackBy\">\r\n                    <ex-svg-icon *ngIf=\"icon\" [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                                 [tooltip]=\"icon?.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n            </td>\r\n\r\n            <!-- ### CUSTOM COLUMNS ### -->\r\n            <ng-container\r\n              *ngFor=\"let column of schema['columns'] | itemsLayoutGridColumns : displayedColumns : columnsCustomization; let i = index\">\r\n              <td [exResizeColumn]=\"!isItemOpen\" id=\"row-{{rowIndex}}\"\r\n                  [isFocusable]=\"false\" [orderedColumns]=\"displayedColumns\" [identifier]=\"column.columnIdentifier\"\r\n                  [(columnsCustomization)]=\"columnsWidth\" (customizationFinished)=\"customizationFinished()\"\r\n                  class=\"{{ 'sel-grid-body-' + column.columnIdentifier }} ex-items-layout-grid-cell inline-cell\"\r\n                  [ngClass]=\"{'ex-items-layout-grid-no-left-padding': column.isIconColumn || column.isToggleColumn}\">\r\n                <div class=\"display-content\"\r\n                     [ngClass]=\"{'ex-items-layout-grid-flex-centered': column.centered && column.centered === true}\">\r\n                  <ng-container *ngIf=\"column.type; else simpleColumn\">\r\n                    <ex-component-loader *ngIf=\"column?.type != OtbColumnsComponentTypes.chip; else chipColumn\" [componentFactoryItem]=\"{ component: column.type, data: {} }\"\r\n                                         [data]=\"row['listItem']?.[column.columnIdentifier]?.inputs ?? (row['listItem']?.[column.columnIdentifier] | objectAssign : { highlightedText: getHighlightedText(row) } ?? {})\"\r\n                                         [content]=\"row['listItem']?.[column.columnIdentifier]?.content\"\r\n                                         [events]=\"row['listItem']?.[column.columnIdentifier]?.events || {}\">\r\n                    </ex-component-loader>\r\n                    <ng-template #chipColumn>\r\n                      <ex-chip-record [chips]=\"row['listItem']?.[column.columnIdentifier]\" [iconType]=\"'svg'\">\r\n                      </ex-chip-record>\r\n                    </ng-template>\r\n                  </ng-container>\r\n                  <ng-template #simpleColumn>\r\n                    <div *ngIf=\"column.isIconColumn; else toggle \" class=\"ex-items-layout-grid-flex-centered \">\r\n                      <ex-svg-icon [iconName]=\"row['listItem']?.[column.columnIdentifier]?.iconName\"\r\n                                   [color]=\"row['listItem']?.[column.columnIdentifier]?.iconColor\"\r\n                                   [tooltip]=\"row['listItem']?.[column.columnIdentifier]?.tooltip\"\r\n                                   [size]=\"row['listItem']?.[column.columnIdentifier]?.iconSize\">\r\n                      </ex-svg-icon>\r\n                    </div>\r\n                    <ng-template #toggle>\r\n                      <ng-container *ngIf=\"column.isToggleColumn; else link\" class=\"ex-items-layout-grid-flex-centered\">\r\n                        <ex-slide-toggle [toggleChecked]=\"row['listItem']?.[column.columnIdentifier]\"\r\n                                         (click)=\"$event.stopPropagation()\"\r\n                                         (toggleCheckedChange)=\"onActionClicked(row, ITEMS_LAYOUT_ITEM_TOGGLE_ACTION_KEY)\"></ex-slide-toggle>\r\n                      </ng-container>\r\n                    </ng-template>\r\n                    <ng-template #link>\r\n                      <ng-container *ngIf=\"column.isLinkColumn; else entityLabels\" class=\"ex-items-layout-grid-flex-centered\">\r\n                        <ex-link [arguments]=\"row['listItem']?.[column.columnIdentifier]\">\r\n                        </ex-link>\r\n                      </ng-container>\r\n                    </ng-template>\r\n                    <ng-template #entityLabels>\r\n                      <ng-container *ngIf=\"column.isEntityLabelsColumn; else text\" class=\"ex-items-layout-grid-flex-centered\">\r\n                        <ex-chip-record-entity-labels [entityLabels]=\"row['listItem']?.[column.columnIdentifier]\" [iconType]=\"'svg'\">\r\n                        </ex-chip-record-entity-labels>\r\n                      </ng-container>\r\n                    </ng-template>\r\n                    <ng-template #text>\r\n                      <div class=\"inline-cell\" [exTooltip]=\"row['listItem']?.[column.columnIdentifier]\"\r\n                           [innerHTML]=\"row['listItem']?.[column.columnIdentifier] | exTextHighlight: listProperties.highlightedText\"></div>\r\n                    </ng-template>\r\n                  </ng-template>\r\n                </div>\r\n              </td>\r\n            </ng-container>\r\n\r\n            <!-- ### ROW ACTIONS ### -->\r\n            <td *ngIf=\"!isItemOpen && (schema.actions || isSingleSave)\" [exResizeColumn]=\"!isItemOpen\"\r\n                [isFocusable]=\"false\"\r\n                [orderedColumns]=\"displayedColumns\" identifier=\"actions\"\r\n                [(columnsCustomization)]=\"columnsWidth\" (customizationFinished)=\"customizationFinished()\"\r\n                class=\"ex-items-layout-grid-cell ex-items-layout-grid-no-side-padding ex-items-layout-grid-center-actions\">\r\n                <div class=\"ex-items-layout-grid-actions-container\">\r\n                <ex-record-actions *ngIf=\"row.listItem[schema.actions.key]?.actions?.length > 0\"\r\n                                   [actions]=\"row.listItem[schema.actions.key].actions\" [visibleBtnNum]=\"0\"\r\n                                   [loading]=\"row.listItem[schema.actions.key].loading\"\r\n                                   [isSelected]=\"isRowSelected\"\r\n                                   [index]=\"rowIndex\"\r\n                                   (actionClicked)=\"onActionClicked(row, $event)\"\r\n                                   class=\"ex-items-layout-grid-record-actions\">\r\n                </ex-record-actions>\r\n                <ex-button *ngIf=\"isSingleSave && row.listItem[schema.editableKey] != false && !listProperties?.inExSidepanePickup\"\r\n                           class=\"ex-items-layout-grid-actions-edit\" [ngClass]=\"{'selected': isRowSelected}\"\r\n                           [tooltip]=\"'ng.general.edit'\"\r\n                           (click)=\"onActionClicked(row, _SINGLE_SAVE_EDIT_ACTION_KEY)\" ariaLabel=\"ng.general.edit\">\r\n                  <ex-svg-icon iconName=\"edit\" color=\"#4164a4\"></ex-svg-icon>\r\n                </ex-button>\r\n              </div>\r\n            </td>\r\n\r\n          </tr>\r\n        </ng-template>\r\n      </ng-container>\r\n      </tbody>\r\n    </table>\r\n\r\n    <!-- ### PAGINATION ### -->\r\n    <ex-pagination #paginationRef *ngIf=\"listProperties.pagination.totalItemsCount > 0\"\r\n                   [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\r\n                   [pageSize]=\"listProperties.pagination.pageSize\"\r\n                   [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\r\n                   [selectedPage]=\"listProperties.pagination.selectedPage\"\r\n                   (selectedPageChange)=\"onSelectedPageChange($event)\" (pageSizeChange)=\"onPageSizeChange($event)\"\r\n                   (endOfPagination)=\"endOfPagination.emit()\" [doNotUpdateStateInternally]=\"true\">\r\n    </ex-pagination>\r\n  </div>\r\n\r\n\r\n</div>\r\n<!-- ### PLACEHOLDER ### -->\r\n<div *ngIf=\"listProperties.isLoading\">\r\n  <table class=\"mat-elevation-z8 ex-items-layout-grid-table\">\r\n    <tbody class=\"ex-items-layout-grid-animate sel-grid-tbody\">\r\n    <tr *ngFor=\"let dummy of ' '.repeat(listProperties.pagination.pageSize).split(''), let x = index\"\r\n        class=\"ex-items-layout-grid-row br\" [ngClass]=\"{'ex-items-layout-grid-even-row': x % 2 === 1}\">\r\n      <td></td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n", styles: [".ex-items-layout-grid-table-wrapper{overflow:visible;width:calc(100% - 2.1px)}.ex-items-layout-grid-table{border-collapse:separate;box-shadow:none!important;table-layout:fixed;overflow:auto;border-inline-start:1px solid #efefef;border-inline-end:1px solid #efefef}.ex-items-layout-grid-table td,.ex-items-layout-grid-tbody{position:relative}.ex-items-layout-grid-no-side-padding{padding-right:0!important;padding-left:0!important}.ex-items-layout-grid-center-actions{display:flex;justify-content:center}.display-content{display:contents}.group-inline{display:flex}.inline-block{white-space:nowrap;display:inline-block;text-overflow:ellipsis;overflow:hidden}.inline-cell{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden;white-space:pre-line}.ex-items-layout-grid-cell{text-align:start;vertical-align:top;padding:10px;position:relative;border-inline-start:solid 1px #898989}.ex-items-layout-grid-sort-icon{margin-inline-end:0px;cursor:pointer}.ex-items-layout-grid-header-text{height:30px}.ex-items-layout-grid-table-header{position:sticky;z-index:10;top:0}.ex-items-layout-grid-sortable-header:hover{cursor:pointer;width:-moz-fit-content;width:fit-content}.ex-items-layout-grid-no-left-padding{padding-inline-start:0px!important}.ex-items-layout-grid-th{position:sticky;top:0;z-index:9;padding-inline-start:10px;border-bottom:2px solid #c5c7c6;height:50px;border-top:1px solid white;border-inline-start:solid 1px #898989}.ex-items-layout-grid-header-draggable{cursor:move}.ex-items-layout-grid-index-column{text-align:center;vertical-align:top;padding:10px!important;padding-inline-start:6px!important}.ex-items-layout-grid-table-bottom-border{border-bottom:2px solid #c5c7c6}.ex-items-layout-grid-no-border-bottom{border-bottom:0}.ex-items-layout-grid-flex-centered{display:flex;flex-direction:column;align-items:center}.ex-items-layout-grid-animate{animation:shimmer 2s infinite linear;background:linear-gradient(135deg,#f3f5f4 49%,#fff9 50%,#f3f5f4 52%);background-size:200% 200%}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-items-layout-grid-even-row{background:#fff;border-inline-start-color:#fff}.ex-items-layout-grid-odd-row{background:#f3f5f4;border-inline-start-color:#f3f5f4}.ex-items-layout-grid-row{display:flex;height:min-content;min-height:42px}.ex-items-layout-grid-row ::ng-deep .ex-label-value .ex-label-value-span{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}.ex-items-layout-grid-toggle ::ng-deep .mat-slide-toggle-bar{transform:scale(.7)!important;margin-inline-end:0px!important;margin-inline-start:5px!important}.ex-items-layout-grid-toggle ::ng-deep .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-items-layout-grid-toggle ::ng-deep .mat-slide-toggle-label{margin-bottom:0!important}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.ex-items-layout-grid-custom-placeholder{min-height:50px;transition:transform .25s cubic-bezier(0,0,.2,1);border-top:1px solid white;border-bottom:2px solid #c5c7c6}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.ex-items-layout-grid-drag-preview{display:flex;align-items:center;border:none!important;border-radius:3px;background:#fff}.ex-items-layout-grid-resize-holder{cursor:col-resize;width:10px;height:100%;position:absolute;top:0;z-index:1;margin-right:1px}.ex-items-layout-grid-resizing{cursor:col-resize!important}.ex-items-layout-grid-table-blocked{position:absolute;top:50px;left:0;height:calc(100% - 50px);width:100%;background:#fff;z-index:10000000;opacity:.5}.ex-items-layout-grid-drag-handle{cursor:move}.cdk-drag-preview.ex-items-layout-grid-row{background:#fff}.cdk-drag-preview.ex-items-layout-grid-odd-row{background:#f3f5f4!important}.ex-items-layout-grid-right-click-actions{display:flex}.ex-items-layout-grid-hidden-button{width:0;height:0;overflow:hidden;border:transparent}.ex-items-layout-grid-selected-row td{border-top:1px solid #c5c7c6!important;border-bottom:1px solid #c5c7c6!important}.ex-items-layout-grid-selected-row{background:#ebebeb!important}.ex-items-layout-grid-selected-row td:first-child{border-inline-start-color:#0e7bba!important}.ex-items-layout-grid-row td:first-child{border-inline-start:4px solid transparent}.ex-items-layout-grid-row:hover td:first-child{border-inline-start-color:#ebebeb}.ex-items-layout-grid-space-clicked{color:#fff!important}.ex-items-layout-grid-actions-container{display:flex;flex-direction:column;padding-inline:5px}.ex-items-layout-grid-actions-container>ex-button{align-self:flex-end}.ex-items-layout-grid-actions-container .ex-items-layout-grid-record-actions::ng-deep .ex-record-actions-more-btn{border:1px solid #c8c8c8}.ex-items-layout-grid-thumbnail-icons{display:flex;flex-direction:column;row-gap:5px}mat-radio-button ::ng-deep .mat-radio-label{margin:0!important;padding-inline-start:6px}\n"] }]
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }, { type: i1$2.TranslateService }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_PAGE_ID]
            }] }]; }, { columnHeaderSortChange: [{
            type: Output
        }], rowItems: [{
            type: ViewChildren,
            args: ['rowItemRef']
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }] }); })();

// Base classes and functionality for ex-editing-list, ex-editing-entry, ex-float-labels, etc...
function hashObject(obj) {
    const str = JSON.stringify(obj);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i) | 0;
    }
    return hash.toString(16);
}
class TrackedEditableEntryComponent {
    constructor(sectionLayoutViewModeObservable, _cdr, _translate) {
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._cdr = _cdr;
        this._translate = _translate;
        this.editTitle = "ng.general.edit";
        this.editIconType = "uxf-pencil";
        this.readOnly = false;
        this.editMode = false;
        this.isToSetDefaultDeleteButton = true;
        this.actionClicked = new EventEmitter();
        this.close = new EventEmitter();
        this.save = new EventEmitter();
        this.editModeChanged = new EventEmitter();
        this.entryOpened = new EventEmitter();
        this.entryRemoved = new EventEmitter();
        this.removeKey = 'delete';
        this.editKey = 'edit';
        this._sectionsLayoutViewModeValue = false;
        this._actions = [];
        this._showConfirmationMessage = false;
    }
    ngOnInit() {
        this._sectionsLayoutViewModeSub = this.sectionLayoutViewModeObservable?.subscribe((readOnly) => {
            this._sectionsLayoutViewModeValue = readOnly;
            this._cdr.markForCheck();
        });
        this.actionChildrenButtons && this._setActionChildrensButtons();
        !this.isReadOnly && this.getDisplayActionsOnHover() && this._setBasicActions();
    }
    ngOnDestroy() {
        this._sectionsLayoutViewModeSub && this._sectionsLayoutViewModeSub.unsubscribe();
    }
    get context() {
        return {
            $implicit: this.entry.data,
            data: this.entry.data,
            properties: { ...omit(this.entry, 'data') },
            closeForm: this.closeForm.bind(this),
            index: this.index
        };
    }
    onEntryRemoved() {
        this.entryRemoved.emit();
    }
    closeForm() {
        this.editMode = false;
        this.entry.isNew = false;
        this.close.emit({ saved: true });
    }
    onEditModeChanged(editMode) {
        if (this.entry.id) {
            this.editModeChanged.emit({ id: this.entry.id, editMode });
        }
        if (editMode && !this.entry.isNew) {
            this.entryOpened.emit(this.entry.id);
        }
    }
    onCloseClicked() {
        this.close.emit({ saved: false, isNew: !!this.entry.isNew });
    }
    get isReadOnly() {
        return this.readOnly || this._sectionsLayoutViewModeValue;
    }
    getDisplayActionsOnHover() {
        return true;
    }
    onActionClicked(actionKey) {
        if (actionKey === this.removeKey) {
            this._showConfirmationMessage = true;
        }
        else {
            this.actionClicked.emit({ entry: this.entry, index: this.index, actionKey: actionKey });
        }
    }
    _setActionChildrensButtons() {
        this.actionChildrenButtons.forEach(act => {
            if ((act.action.showInViewMode || !this.isReadOnly) &&
                (!act.isVisible || (act.isVisible && act.isVisible(this.entry, this.index)))) {
                this._actions.push({ ...act.action });
            }
        });
        this._actions?.forEach(a => a.onClick = this.onActionClicked.bind(this, a.key));
    }
    _setBasicActions() {
        if (this.isToSetDefaultDeleteButton) {
            this._actions.push({
                key: this.removeKey,
                label: this._translate?.instant('ng.general.delete'),
                disabled: false,
                loading: false,
                onClick: this.onActionClicked.bind(this, this.removeKey)
            });
        }
        if (this.editModeTemplate) {
            this._actions.push({
                key: this.editKey,
                label: this._translate?.instant('ng.general.edit'),
                disabled: false,
                loading: false
            });
        }
    }
    onRemoveConfirmed() {
        this.actionClicked.emit({ entry: this.entry, index: this.index, actionKey: this.removeKey });
    }
    onRemoveCanceled() {
        this._showConfirmationMessage = false;
    }
    static { this.ɵfac = function TrackedEditableEntryComponent_Factory(t) { return new (t || TrackedEditableEntryComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TrackedEditableEntryComponent, inputs: { entry: "entry", editTitle: "editTitle", editIconType: "editIconType", index: "index", editModeTemplate: "editModeTemplate", readOnly: "readOnly", actionChildrenButtons: "actionChildrenButtons", viewModeTemplate: "viewModeTemplate", editMode: "editMode", isToSetDefaultDeleteButton: "isToSetDefaultDeleteButton" }, outputs: { actionClicked: "actionClicked", close: "close", save: "save", editModeChanged: "editModeChanged", entryOpened: "entryOpened", entryRemoved: "entryRemoved" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrackedEditableEntryComponent, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { entry: [{
            type: Input
        }], editTitle: [{
            type: Input
        }], editIconType: [{
            type: Input
        }], index: [{
            type: Input
        }], editModeTemplate: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], actionChildrenButtons: [{
            type: Input
        }], viewModeTemplate: [{
            type: Input
        }], editMode: [{
            type: Input
        }], isToSetDefaultDeleteButton: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], close: [{
            type: Output
        }], save: [{
            type: Output
        }], editModeChanged: [{
            type: Output
        }], entryOpened: [{
            type: Output
        }], entryRemoved: [{
            type: Output
        }] }); })();
class TrackedEditableEntryListComponent {
    set data(data) {
        this.initEntryTracker(data);
    }
    initEntryTracker(data) {
        const editModeTracker = {};
        this.entries = (data ?? []).map((d, i) => {
            const hash = hashObject(d ?? `${Date.now()}${(Math.random() + i) * 1000}`);
            const id = d?.id ?? hash;
            editModeTracker[id] = { hash, editMode: false };
            return { id, data: d, hash, isNew: this.entries && this.entries[i] ? this.entries[i].isNew : false, isEditableEntry: d.isEditableEntry, status: d.status, icons: d.icons, primaryIcon: d.primaryIcon, chip: d.chip };
        });
        if (this.entryAdded) {
            (this.entries.slice(-1)[0] ?? {}).isNew = true;
            if (this.singleMode)
                this.singleCardId = (this.entries.slice(-1)[0] ?? {}).id;
            this.entryAdded = false;
        }
        this.initEditModeTracker(editModeTracker);
    }
    constructor(sectionLayoutViewModeObservable, _cdr) {
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._cdr = _cdr;
        /*
         * edit mode title for adding new list entry
         */
        this.editTitleNew = "ng.general.add";
        /*
        * edit mode title for editing a list entry
        */
        this.editTitleEdit = "ng.general.edit";
        /*
        * edit mode title icon for adding a new list entry
        */
        this.editIconTypeNew = "uxf-plus-circle";
        /*
        * edit mode title icon for editing a list entry
        */
        this.editIconTypeEdit = "uxf-pencil";
        /**
       * children add buttons
       */
        this.addButtonChildren = [];
        /**
         * In case of add option set the button tooltip
         */
        this.addButtonTooltip = '';
        /**
         * Open single entity
         */
        this.singleMode = false;
        this.readOnly = false;
        /*
        * whether to hide the 'add' button.
        */
        this.hideAddButton = false;
        /*
        * whether to hide the 'delete' row action button.
        */
        this.isToSetDefaultDeleteButton = true;
        /*
        * whether to skip the default add entry functionality
        */
        this.skipDefaultAddEntry = false;
        this.exportEnabled = true;
        this.add = new EventEmitter();
        this.remove = new EventEmitter();
        this.close = new EventEmitter();
        this._sectionsLayoutViewModeValue = false;
        this.entryAdded = false;
        this.editModeTracker = {};
    }
    ngOnInit() {
        this._sectionsLayoutViewModeSub = this.sectionLayoutViewModeObservable?.subscribe((readOnly) => {
            this._sectionsLayoutViewModeValue = readOnly;
            this._cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this._sectionsLayoutViewModeSub && this._sectionsLayoutViewModeSub.unsubscribe();
    }
    addEntry(key) {
        if (!this.skipDefaultAddEntry) {
            this.entryAdded = true;
        }
        this.add.emit(key);
    }
    onEntryClosed(event, index) {
        if (!event.saved && event.isNew) {
            this.entries.splice(index, 1);
            this.remove.emit(index);
        }
        this.close.emit({ event, index });
    }
    setChildrenAddFunction(addButtonChildren) {
        addButtonChildren.forEach(child => {
            if (child.children?.length > 0) {
                this.setChildrenAddFunction(child.children);
            }
            else {
                child.onClick = this.addEntry.bind(this, child.key);
            }
        });
    }
    onEntryRemoved(index) {
        this.remove.emit(index);
    }
    onEditModeChanged(change) {
        const { id, editMode } = change;
        (this.editModeTracker[id] || {}).editMode = editMode;
    }
    isEditMode(entry, isLast) {
        if (isLast && entry.isNew && !(!this.singleCardId || (this.singleCardId && entry.id == this.singleCardId)))
            this.remove.emit(this.entries.length - 1);
        return (!!this.editModeTracker[entry.id]?.editMode || (isLast && entry.isNew))
            && (!this.singleCardId || (this.singleCardId && entry.id == this.singleCardId));
    }
    initEditModeTracker(editModeTracker) {
        Object.keys(this.editModeTracker).forEach((id, i) => {
            if (!editModeTracker[id]
                && !(i == this.entries.length - 1
                    && editModeTracker[this.entries[i].id])) {
                return;
            }
            const { hash: oldHash, editMode } = this.editModeTracker[id];
            const { hash: newHash } = editModeTracker[id] ?? { hash: undefined };
            const unchanged = oldHash === newHash;
            if (this.entries[i])
                this.entries[i].isNew = this.entries[i].isNew && unchanged;
            Object.assign(editModeTracker[id] ?? {}, { editMode: unchanged && editMode });
        });
        this.editModeTracker = editModeTracker;
    }
    singleCardOpened(id) {
        if (this.singleMode)
            this.singleCardId = id;
    }
    get isReadOnly() {
        return this.readOnly || this._sectionsLayoutViewModeValue;
    }
    static { this.ɵfac = function TrackedEditableEntryListComponent_Factory(t) { return new (t || TrackedEditableEntryListComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TrackedEditableEntryListComponent, contentQueries: function TrackedEditableEntryListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, EditModeComponentDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, ViewModeComponentDirective, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editModeTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewModeTemplate = _t.first);
        } }, inputs: { editTitleNew: "editTitleNew", editTitleEdit: "editTitleEdit", editIconTypeNew: "editIconTypeNew", editIconTypeEdit: "editIconTypeEdit", addButtonChildren: "addButtonChildren", addButtonLabel: "addButtonLabel", addButtonTooltip: "addButtonTooltip", singleMode: "singleMode", readOnly: "readOnly", hideAddButton: "hideAddButton", isToSetDefaultDeleteButton: "isToSetDefaultDeleteButton", skipDefaultAddEntry: "skipDefaultAddEntry", data: "data", exportEnabled: "exportEnabled" }, outputs: { add: "add", remove: "remove", close: "close" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrackedEditableEntryListComponent, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { editTitleNew: [{
            type: Input
        }], editTitleEdit: [{
            type: Input
        }], editIconTypeNew: [{
            type: Input
        }], editIconTypeEdit: [{
            type: Input
        }], addButtonChildren: [{
            type: Input
        }], addButtonLabel: [{
            type: Input
        }], addButtonTooltip: [{
            type: Input
        }], singleMode: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], hideAddButton: [{
            type: Input
        }], isToSetDefaultDeleteButton: [{
            type: Input
        }], skipDefaultAddEntry: [{
            type: Input
        }], editModeTemplate: [{
            type: ContentChild,
            args: [EditModeComponentDirective, { read: TemplateRef }]
        }], viewModeTemplate: [{
            type: ContentChild,
            args: [ViewModeComponentDirective, { read: TemplateRef }]
        }], data: [{
            type: Input
        }], exportEnabled: [{
            type: Input
        }], add: [{
            type: Output
        }], remove: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

class ExDragDirective {
    constructor(renderer, ref, translate, liveAnnouncer) {
        this.renderer = renderer;
        this.ref = ref;
        this.translate = translate;
        this.liveAnnouncer = liveAnnouncer;
        this.isDirective = false;
        this.dragItemDescription = '';
        this.shouldFireEvents = false;
        this.arrowUpPressed = new EventEmitter();
        this.arrowDownPressed = new EventEmitter();
        this.spaceClicked = new EventEmitter();
        this.blured = new EventEmitter();
        this.someField = false;
    }
    ngOnInit() {
        if (this.isDirective) {
            this.renderer.listen(this.ref.nativeElement, "keyup", (event) => this.onKeyUp(event));
            this.renderer.listen(this.ref.nativeElement, "keydown", (event) => this.onKeyDown(event));
            this.renderer.listen(this.ref.nativeElement, "blur", () => this._blured());
            this.renderer.listen(this.ref.nativeElement, "focus", () => this._focused());
        }
    }
    _blured() {
        this.shouldFireEvents = false;
        this.blured.emit();
    }
    _focused() {
        if (!this.shouldFireEvents) {
            this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon'));
        }
    }
    onKeyDown(event) {
        if (event.keyCode === 32) { //space
            event.preventDefault();
        }
    }
    onKeyUp(event) {
        if (event.keyCode >= 37 && event.keyCode <= 40 && this.shouldFireEvents) { //arrows
            event.preventDefault();
            if (event.keyCode <= 38) { //left or up
                this.arrowUpPressed.emit();
            }
            else if (event.keyCode > 38) { //right or down
                this.arrowDownPressed.emit();
            }
        }
        if (event.keyCode === 32) { //space
            event.preventDefault();
            this.shouldFireEvents = !this.shouldFireEvents;
            this.spaceClicked.emit(this.shouldFireEvents);
            if (this.shouldFireEvents) {
                this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon.space-clicked'));
            }
        }
    }
    static { this.ɵfac = function ExDragDirective_Factory(t) { return new (t || ExDragDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExLiveAnnouncerService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExDragDirective, selectors: [["", "exDrag", ""]], hostVars: 2, hostBindings: function ExDragDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("ex-drag-space-clicked", ctx.shouldFireEvents);
        } }, inputs: { isDirective: ["exDrag", "isDirective"], dragItemDescription: "dragItemDescription" }, outputs: { arrowUpPressed: "arrowUpPressed", arrowDownPressed: "arrowDownPressed", spaceClicked: "spaceClicked", blured: "blured" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragDirective, [{
        type: Directive,
        args: [{
                selector: '[exDrag]'
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1$2.TranslateService }, { type: ExLiveAnnouncerService }]; }, { isDirective: [{
            type: Input,
            args: ['exDrag']
        }], dragItemDescription: [{
            type: Input
        }], shouldFireEvents: [{
            type: HostBinding,
            args: ['class.ex-drag-space-clicked']
        }], arrowUpPressed: [{
            type: Output
        }], arrowDownPressed: [{
            type: Output
        }], spaceClicked: [{
            type: Output
        }], blured: [{
            type: Output
        }] }); })();

const _c0$1d = ["ref"];
class ExDragAccessibleIconComponent extends ExDragDirective {
    constructor(renderer, elementRef, translate, liveAnnouncer) {
        super(renderer, elementRef, translate, liveAnnouncer);
    }
    static { this.ɵfac = function ExDragAccessibleIconComponent_Factory(t) { return new (t || ExDragAccessibleIconComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExLiveAnnouncerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDragAccessibleIconComponent, selectors: [["ex-drag-accessible-icon"]], viewQuery: function ExDragAccessibleIconComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1d, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
        } }, features: [i0.ɵɵProvidersFeature([
                { provide: ExDragDirective, useExisting: ExDragAccessibleIconComponent }
            ]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [["role", "button", "tabindex", "0", 1, "ex-drag-accessible-icon-wrapper", 3, "keyup", "keydown", "blur", "focus"], ["ref", ""], ["color", "gray", "iconName", "icon-alma-ex-alma-move", "iconType", "fa-font", "sizePx", "14px"]], template: function ExDragAccessibleIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵlistener("keyup", function ExDragAccessibleIconComponent_Template_div_keyup_0_listener($event) { return ctx.onKeyUp($event); })("keydown", function ExDragAccessibleIconComponent_Template_div_keydown_0_listener($event) { return ctx.onKeyDown($event); })("blur", function ExDragAccessibleIconComponent_Template_div_blur_0_listener() { return ctx._blured(); })("focus", function ExDragAccessibleIconComponent_Template_div_focus_0_listener() { return ctx._focused(); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelement(3, "ex-icon", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("ex-drag-accessible-icon-wrapper-space", ctx.shouldFireEvents);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, "ng.general.drag_item") + ctx.dragItemDescription);
        } }, dependencies: [ExIconComponent, i1$2.TranslatePipe], styles: [".ex-drag-accessible-icon-wrapper[_ngcontent-%COMP%]{outline:0}.ex-drag-accessible-icon-wrapper[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]  i{color:#898989!important;padding-top:4px;padding-bottom:2px}.ex-drag-accessible-icon-wrapper[_ngcontent-%COMP%]:focus   ex-icon[_ngcontent-%COMP%]  i, .ex-drag-accessible-icon-wrapper[_ngcontent-%COMP%]:hover   ex-icon[_ngcontent-%COMP%]  i{color:#212020!important}.ex-drag-accessible-icon-wrapper-space[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]  i{color:#0e7bba!important;animation:_ngcontent-%COMP%_transform-icon-bigger .15s ease-in forwards;background:#f2f2f2;border-radius:3px}.ex-drag-accessible-icon-wrapper-space[_ngcontent-%COMP%]:focus   ex-icon[_ngcontent-%COMP%]  i{color:#0e7bba!important}@keyframes _ngcontent-%COMP%_transform-icon-bigger{to{transform:scale(1.5)}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragAccessibleIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-drag-accessible-icon', providers: [
                    { provide: ExDragDirective, useExisting: ExDragAccessibleIconComponent }
                ], template: "<div class=\"ex-drag-accessible-icon-wrapper\" role = \"button\" [attr.aria-label]=\"('ng.general.drag_item' | translate) + dragItemDescription\" [class.ex-drag-accessible-icon-wrapper-space]=\"shouldFireEvents\" #ref\n    (keyup)=\"onKeyUp($event)\" (keydown)=\"onKeyDown($event)\" (blur)=\"_blured()\" (focus)=\"_focused()\" tabindex=\"0\">\n    <ex-icon color=\"gray\" iconName=\"icon-alma-ex-alma-move\" iconType=\"fa-font\" sizePx=\"14px\"></ex-icon>\n</div>\n", styles: [".ex-drag-accessible-icon-wrapper{outline:0}.ex-drag-accessible-icon-wrapper ex-icon::ng-deep i{color:#898989!important;padding-top:4px;padding-bottom:2px}.ex-drag-accessible-icon-wrapper:focus ex-icon::ng-deep i,.ex-drag-accessible-icon-wrapper:hover ex-icon::ng-deep i{color:#212020!important}.ex-drag-accessible-icon-wrapper-space ex-icon::ng-deep i{color:#0e7bba!important;animation:transform-icon-bigger .15s ease-in forwards;background:#f2f2f2;border-radius:3px}.ex-drag-accessible-icon-wrapper-space:focus ex-icon::ng-deep i{color:#0e7bba!important}@keyframes transform-icon-bigger{to{transform:scale(1.5)}}\n"] }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1$2.TranslateService }, { type: ExLiveAnnouncerService }]; }, { ref: [{
            type: ViewChild,
            args: ['ref', { static: false }]
        }] }); })();

class ExDragGroupService {
    constructor() { }
    static { this.ɵfac = function ExDragGroupService_Factory(t) { return new (t || ExDragGroupService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExDragGroupService, factory: ExDragGroupService.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragGroupService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ExDragListDirective {
    constructor(exDragGroupService, liveAnnouncer, translate) {
        this.exDragGroupService = exDragGroupService;
        this.liveAnnouncer = liveAnnouncer;
        this.translate = translate;
        this.cdkDropListEnterPredicate = (drag) => true;
        this.cdkDropListDropped = new EventEmitter();
        this.subs = [];
    }
    ngAfterViewInit() {
        this.dragables.changes.subscribe(() => {
            if (this.to !== null && this.to !== undefined) {
                this.scrollToIndex(this.to);
            }
            if (this.exDragGroupService && this.exDragGroupService.to !== null && this.exDragGroupService.to !== undefined && this.exDragGroupService.to.id === this.id) {
                this.scrollToIndex(this.exDragGroupService.to.index);
                this.exDragGroupService.to = null;
            }
            this.subs.forEach(sub => sub.unsubscribe());
            this.subs = [];
            this.createDropList();
        });
        this.createDropList();
    }
    scrollToIndex(index) {
        if (!this.dragables.toArray()[index]) {
            return;
        }
        this.dragables.toArray()[index].ref.nativeElement.focus();
        scrollIntoView(this.dragables.toArray()[index].ref.nativeElement, {
            scrollMode: 'if-needed',
            block: 'nearest',
            inline: 'nearest'
        });
        this.dragables.toArray()[index].shouldFireEvents = true;
    }
    createDropList() {
        this.dragables.forEach((dragable, i) => {
            this.subs.push(dragable.arrowUpPressed.subscribe(() => {
                const container = { id: this.id, data: this.cdkDropListData };
                let item;
                if (this.cdkDropListData) {
                    item = { data: this.cdkDropListData[i] };
                }
                if (this.cdkDropListEnterPredicate?.({ data: this.cdkDropListData[i] })) {
                    if (i === 0) { //first element in list
                        if (this.exDragGroupService && !this.isFirst) { //not first list
                            this.moveToOtherList(this.index - 1, i, this.allLists[this.index - 1].data.length);
                            this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon.moved-to-previous-list'));
                        }
                    }
                    else {
                        this.cdkDropListDropped.emit({ currentIndex: i - 1, previousIndex: i, item, container, previousContainer: container });
                        this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon.arrow-pressed', { index1: i + 1, index2: i }));
                        this.to = i - 1;
                    }
                }
            }));
            this.subs.push(dragable.arrowDownPressed.subscribe(() => {
                const container = { id: this.id, data: this.cdkDropListData };
                let item;
                if (this.cdkDropListData) {
                    item = { data: this.cdkDropListData[i] };
                }
                if (this.cdkDropListEnterPredicate?.({ data: this.cdkDropListData[i] })) {
                    if (i === this.dragables.length - 1) { //last element in list
                        if (this.exDragGroupService && !this.isLast) { //not last list
                            this.moveToOtherList(this.index + 1, i, 0);
                            this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon.moved-to-next-list'));
                        }
                    }
                    else {
                        this.cdkDropListDropped.emit({ currentIndex: i + 1, previousIndex: i, item, container, previousContainer: container });
                        this.liveAnnouncer.announce(this.translate.instant('ng.drag.accessible-icon.arrow-pressed', { index1: i + 1, index2: i + 2 }));
                        this.to = i + 1;
                    }
                }
            }));
        });
    }
    moveToOtherList(listIndex, itemIndex, newItemIndex) {
        const container = this.allLists[listIndex];
        const previousContainer = { data: this.cdkDropListData, id: this.id };
        let item;
        if (this.cdkDropListData) {
            item = { data: this.cdkDropListData[itemIndex] };
        }
        if (!container.enterPredicate || container.enterPredicate(item)) {
            this.exDragGroupService.to = { id: container.id, index: newItemIndex };
            this.cdkDropListDropped.emit({ currentIndex: newItemIndex, previousIndex: itemIndex, item, container, previousContainer });
        }
    }
    static { this.ɵfac = function ExDragListDirective_Factory(t) { return new (t || ExDragListDirective)(i0.ɵɵdirectiveInject(ExDragGroupService, 8), i0.ɵɵdirectiveInject(ExLiveAnnouncerService), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExDragListDirective, selectors: [["", "exDragList", ""]], contentQueries: function ExDragListDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExDragDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dragables = _t);
        } }, inputs: { id: "id", cdkDropListData: "cdkDropListData", cdkDropListEnterPredicate: "cdkDropListEnterPredicate" }, outputs: { cdkDropListDropped: "cdkDropListDropped" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragListDirective, [{
        type: Directive,
        args: [{
                selector: '[exDragList]'
            }]
    }], function () { return [{ type: ExDragGroupService, decorators: [{
                type: Optional
            }] }, { type: ExLiveAnnouncerService }, { type: i1$2.TranslateService }]; }, { id: [{
            type: Input
        }], cdkDropListData: [{
            type: Input
        }], cdkDropListEnterPredicate: [{
            type: Input
        }], cdkDropListDropped: [{
            type: Output
        }], dragables: [{
            type: ContentChildren,
            args: [ExDragDirective, { descendants: true }]
        }] }); })();

const _c0$1c = ["*"];
class ExDragListComponent extends ExDragListDirective {
    constructor(exDragGroupService, liveAnnouncer, translate) {
        super(exDragGroupService, liveAnnouncer, translate);
    }
    static { this.ɵfac = function ExDragListComponent_Factory(t) { return new (t || ExDragListComponent)(i0.ɵɵdirectiveInject(ExDragGroupService, 8), i0.ɵɵdirectiveInject(ExLiveAnnouncerService), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDragListComponent, selectors: [["ex-drag-list"]], features: [i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0$1c, decls: 1, vars: 0, template: function ExDragListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragListComponent, [{
        type: Component,
        args: [{ selector: 'ex-drag-list', template: "<ng-content></ng-content>" }]
    }], function () { return [{ type: ExDragGroupService, decorators: [{
                type: Optional
            }] }, { type: ExLiveAnnouncerService }, { type: i1$2.TranslateService }]; }, null); })();

class ExComponentFactoryItem {
    /**
     * autoFocusClass - A selector of an element that will take focus when its menu opens
     */
    constructor(component, data, events = {}, autoFocusClass = null) {
        this.component = component;
        this.data = data;
        this.events = events;
        this.autoFocusClass = autoFocusClass;
    }
}

const Animations$5 = [
    trigger('arrowFlip', [
        state('left', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('right', style({
            transform: 'rotate(180deg)'
        })),
        transition('left <=> right', [
            animate('0.25s')
        ])
    ]),
    trigger('expendAndcollapse', [
        state('expanded', style({
            width: '*',
            overflow: 'hidden',
            display: 'flex'
        })),
        state('collapsed', style({
            width: '0px',
            overflow: 'hidden',
            display: 'none'
        })),
        transition('expanded <=> collapsed', [
            animate('0.25s')
        ])
    ])
];

class ExBulkActionIndicationService {
    constructor() {
        this.failedItems = [];
        this.successItems = [];
        this.warningItems = [];
        this.tempCheckedItems = [];
        this.filteredIds = [];
        this.notIncludedItemsIds = [];
        this.isStandAlone = false;
        this.showSuccessItemsFilter = true;
        this.successItemsLength = 0;
        this.failedItemsUpdated = new Subject();
        this.failedItemsUpdated$ = this.failedItemsUpdated.asObservable();
        this.filterChanged = new Subject();
        this.filterChanged$ = this.filterChanged.asObservable();
        this.showFilters = new Subject();
        this.showFilters$ = this.showFilters.asObservable();
        this.selectedFilter = new Subject();
        this.selectedFilter$ = this.selectedFilter.asObservable();
        this.snackbarsIds = {};
        this.currentSelectedFilter = 'all';
        this.actionDone = false;
    }
    reset(checkedItems) {
        if (!this.actionDone) {
            return;
        }
        this.resetInlineIndications([]);
        this.actionDone = false;
    }
    resetInlineIndications(checkedItems) {
        this.isStandAlone = false;
        this.successItemsLength = 0;
        this.tempCheckedItems = checkedItems;
        this.successItems = [];
        this.failedItems = [];
        this.warningItems = [];
        this.filteredIds = [];
        this.notIncludedItemsIds = [];
        if (!this.actionDone) {
            return;
        }
        this.showFilters.next(false);
        this.failedItemsUpdated.next([this.failedItems, this.warningItems, this.successItems]);
    }
    afterAction(failedItems, warningItems, requireRefreshOnAll = true, showSuccessItemsFilter = true) {
        this.actionDone && (requireRefreshOnAll || !requireRefreshOnAll && this.currentSelectedFilter !== 'all') && this.filterItems('all');
        this.actionDone = true;
        this.failedItems = failedItems;
        this.warningItems = warningItems;
        this.successItems = this.tempCheckedItems?.filter(item => {
            return !(this.failedItems?.some(i => i.id == item.id) || this.warningItems?.some(i => i.id == item.id));
        }).map(item => item.id);
        this.failedItemsUpdated.next([this.failedItems, this.warningItems, this.successItems]);
        this.showSuccessItemsFilter = showSuccessItemsFilter;
        this.showFilters.next(true);
    }
    filterItems(filter, showSuccessItemsFilter = true) {
        this.currentSelectedFilter = filter;
        this.selectedFilter.next(filter);
        switch (filter) {
            case 'failed': {
                this.filteredIds = this.failedItems.map(i => i.id);
                this.notIncludedItemsIds = [];
                this.filterChanged.next(undefined);
                break;
            }
            case 'warnings': {
                this.filteredIds = this.warningItems.map(i => i.id);
                this.notIncludedItemsIds = [];
                this.filterChanged.next(undefined);
                break;
            }
            case 'succeeded': {
                if (this.isStandAlone) {
                    this.notIncludedItemsIds = this.warningItems.map(i => i.id).concat(this.failedItems.map(i => i.id));
                }
                this.filteredIds = this.successItems;
                this.filterChanged.next(undefined);
                break;
            }
            case 'all': {
                this.filteredIds = [];
                this.notIncludedItemsIds = [];
                this.filterChanged.next(undefined);
            }
        }
    }
    updateSuccessItemsLength(total, notIncludedLength) {
        this.successItemsLength = total - notIncludedLength;
    }
    static { this.ɵfac = function ExBulkActionIndicationService_Factory(t) { return new (t || ExBulkActionIndicationService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExBulkActionIndicationService, factory: ExBulkActionIndicationService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExBulkActionIndicationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ExSortPipe {
    transform(arr) {
        return arr.map(({ label, value }) => ({ key: value, value: label }));
    }
    static { this.ɵfac = function ExSortPipe_Factory(t) { return new (t || ExSortPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "sortByOptionsConvert", type: ExSortPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSortPipe, [{
        type: Pipe,
        args: [{
                name: 'sortByOptionsConvert'
            }]
    }], null, null); })();

function ExSortComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.dropdownId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, ctx_r0.sortByLabel), ":");
} }
function ExSortComponent_button_7_ex_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 8);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", "asc")("iconType", "svg")("tooltip", i0.ɵɵpipeBind1(1, 3, ctx_r2.orderButtonDisabled ? ctx_r2.disabledLabel : ctx_r2.ascLabel));
} }
function ExSortComponent_button_7_ex_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 9);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", "desc")("iconType", "svg")("tooltip", i0.ɵɵpipeBind1(1, 3, ctx_r3.orderButtonDisabled ? ctx_r3.disabledLabel : ctx_r3.descLabel));
} }
function ExSortComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ExSortComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.changeOrder()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExSortComponent_button_7_ex_icon_3_Template, 2, 5, "ex-icon", 6);
    i0.ɵɵtemplate(4, ExSortComponent_button_7_ex_icon_4_Template, 2, 5, "ex-icon", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-sort-clickable-icon ", i0.ɵɵpipeBind1(1, 7, "ex-sort-clickable-icon"), "");
    i0.ɵɵproperty("disabled", ctx_r1.orderButtonDisabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 9, ctx_r1.order === "asc" ? ctx_r1.ascLabel : ctx_r1.descLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.order === "asc");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.order === "desc");
} }
const _c0$1b = function (a0) { return { key: a0 }; };
const _c1$L = function (a0) { return [a0]; };
class ExSortComponent {
    /**
     * @ignore
     */
    constructor(sectionId, translate) {
        this.sectionId = sectionId;
        this.translate = translate;
        /**
         * the initial order of the list
         */
        this.order = 'asc';
        this.hasOrder = true;
        this.sortByLabel = 'ng.general.sort.sort_by';
        this.ascLabel = 'ng.general.sort.ascending';
        this.descLabel = 'ng.general.sort.decending';
        this.multiLined = false;
        this.autoComplete = false;
        this.disabled = false;
        /**
         * event fired every time the sort by or sort order is changed
         */
        this.valueChanged = new EventEmitter();
        this.orderButtonDisabled = false;
        this.disabledLabel = "ng.page.sort.order.disabled";
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (!this.sortBy) {
            if (this.sortByLabel == null) {
                this.sortBy = this.sortByOptions[0].value;
            }
        }
        this.dropdownId = (this.translate.instant(this.sortByLabel) + 'Label' + (this.sectionId ?? '')).replace(' ', '');
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("sortBy"))
            this.orderButtonDisabled = this.sortByOptions.find(option => option.value == this.sortBy).disableOrder;
    }
    changeOrder() {
        let order;
        if (this.order === 'asc') {
            order = 'desc';
        }
        else {
            order = 'asc';
        }
        this.order = order;
        this.onChange([{ key: this.sortBy }]);
    }
    onChange(newSortBy) {
        this.sortBy = newSortBy[0].key;
        this.valueChanged.emit({ sortBy: this.sortBy, order: this.order });
    }
    static { this.ɵfac = function ExSortComponent_Factory(t) { return new (t || ExSortComponent)(i0.ɵɵdirectiveInject(EX_SECTION_IDENTIFIER, 8), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSortComponent, selectors: [["ex-sort"]], inputs: { sortByOptions: "sortByOptions", order: "order", hasOrder: "hasOrder", sortByLabel: "sortByLabel", ascLabel: "ascLabel", descLabel: "descLabel", multiLined: "multiLined", autoComplete: "autoComplete", disabled: "disabled", sortBy: "sortBy" }, outputs: { valueChanged: "valueChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 26, consts: [[1, "ex-sort-wrapper"], ["class", "ex-sort-by-label", 3, "id", 4, "ngIf"], [3, "displaySearchBox", "selectedItems", "items", "disabled", "ignoreSectionsLayoutViewMode", "ariaLabel", "uniqueSelector", "selectedChangeControl", "placeholder", "selectedItemsChange"], ["aria-live", "polite", 3, "class", "disabled", "click", 4, "ngIf"], [1, "ex-sort-by-label", 3, "id"], ["aria-live", "polite", 3, "disabled", "click"], ["class", "sel-sort-order-asc", 3, "iconName", "iconType", "tooltip", 4, "ngIf"], ["class", "sel-sort-order-desc", 3, "iconName", "iconType", "tooltip", 4, "ngIf"], [1, "sel-sort-order-asc", 3, "iconName", "iconType", "tooltip"], [1, "sel-sort-order-desc", 3, "iconName", "iconType", "tooltip"]], template: function ExSortComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExSortComponent_label_1_Template, 3, 4, "label", 1);
            i0.ɵɵelementStart(2, "ex-new-combobox", 2);
            i0.ɵɵlistener("selectedItemsChange", function ExSortComponent_Template_ex_new_combobox_selectedItemsChange_2_listener($event) { return ctx.onChange($event); });
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "sortByOptionsConvert");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ExSortComponent_button_7_Template, 5, 11, "button", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.sortBy);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("sel-sort-combobox sel-sort-by-combobox-", i0.ɵɵpipeBind1(3, 14, ctx.sortByLabel), "");
            i0.ɵɵproperty("displaySearchBox", ctx.autoComplete)("selectedItems", i0.ɵɵpureFunction1(24, _c1$L, i0.ɵɵpureFunction1(22, _c0$1b, ctx.sortBy)))("items", i0.ɵɵpipeBind1(4, 16, ctx.sortByOptions))("disabled", ctx.disabled)("ignoreSectionsLayoutViewMode", true)("ariaLabel", i0.ɵɵpipeBind1(5, 18, ctx.sortByLabel))("uniqueSelector", "ex-sort-by-combobox-" + ctx.sortByLabel)("selectedChangeControl", false)("placeholder", i0.ɵɵpipeBind1(6, 20, ctx.sortByLabel));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.hasOrder);
        } }, dependencies: [i1$5.NgIf, ExNewComboboxComponent, ExIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe, ExSortPipe], styles: [".ex-sort-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:baseline}.ex-sort-wrapper[_ngcontent-%COMP%]   .ex-sort-by-label[_ngcontent-%COMP%]{color:#000;margin-bottom:1px;white-space:nowrap}.ex-sort-wrapper[_ngcontent-%COMP%]   .ex-sort-clickable-icon[_ngcontent-%COMP%]:hover{color:#074467}.ex-sort-wrapper[_ngcontent-%COMP%]   .ex-sort-clickable-icon[_ngcontent-%COMP%]{border:0px;background:transparent;color:#4164a4;align-self:center}.ex-sort-wrapper[_ngcontent-%COMP%]   .ex-sort-clickable-icon[_ngcontent-%COMP%]:disabled{color:#d7d7d7!important;cursor:default!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSortComponent, [{
        type: Component,
        args: [{ selector: 'ex-sort', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-sort-wrapper\">\n  <label *ngIf=\"sortBy\" [id]=\"dropdownId\" class=\"ex-sort-by-label\">{{ sortByLabel | translate }}:</label>\n  <ex-new-combobox [displaySearchBox]=\"autoComplete\" [selectedItems]=\"[{ key: sortBy }]\" [items]=\"sortByOptions | sortByOptionsConvert\" [disabled]=\"disabled\"\n                   [ignoreSectionsLayoutViewMode]=\"true\" (selectedItemsChange)=\"onChange($event)\" [ariaLabel]=\"sortByLabel | translate\"\n                   [uniqueSelector]=\"'ex-sort-by-combobox-' + sortByLabel\"\n                   [selectedChangeControl]=false class=\"sel-sort-combobox sel-sort-by-combobox-{{ sortByLabel | translate }}\" [placeholder]=\"sortByLabel | translate\">\n  </ex-new-combobox>\n  <button class=\"ex-sort-clickable-icon {{'ex-sort-clickable-icon' | generateHTMLId}}\" *ngIf=\"hasOrder\" (click)=\"changeOrder()\" aria-live=\"polite\" [disabled]=\"orderButtonDisabled\"\n           [attr.aria-label]=\"(order==='asc' ? ascLabel : descLabel) | translate\">\n    <ex-icon class=\"sel-sort-order-asc\" [iconName]=\"'asc'\" [iconType]=\"'svg'\" *ngIf=\"order==='asc'\"\n             [tooltip]=\"(orderButtonDisabled ? disabledLabel : ascLabel) | translate\"></ex-icon>\n    <ex-icon class=\"sel-sort-order-desc\" [iconName]=\"'desc'\" [iconType]=\"'svg'\" *ngIf=\"order==='desc'\"\n             [tooltip]=\"(orderButtonDisabled ? disabledLabel : descLabel) | translate\"></ex-icon>\n  </button>\n</div>\n", styles: [".ex-sort-wrapper{display:flex;flex-direction:row;align-items:baseline}.ex-sort-wrapper .ex-sort-by-label{color:#000;margin-bottom:1px;white-space:nowrap}.ex-sort-wrapper .ex-sort-clickable-icon:hover{color:#074467}.ex-sort-wrapper .ex-sort-clickable-icon{border:0px;background:transparent;color:#4164a4;align-self:center}.ex-sort-wrapper .ex-sort-clickable-icon:disabled{color:#d7d7d7!important;cursor:default!important}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: i1$2.TranslateService }]; }, { sortByOptions: [{
            type: Input
        }], order: [{
            type: Input
        }], hasOrder: [{
            type: Input
        }], sortByLabel: [{
            type: Input
        }], ascLabel: [{
            type: Input
        }], descLabel: [{
            type: Input
        }], multiLined: [{
            type: Input
        }], autoComplete: [{
            type: Input
        }], disabled: [{
            type: Input
        }], valueChanged: [{
            type: Output
        }], sortBy: [{
            type: Input
        }] }); })();

function ExFiltersComponent_ex_filter_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-filter", 3);
    i0.ɵɵlistener("selectedValueChange", function ExFiltersComponent_ex_filter_1_Template_ex_filter_selectedValueChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onSelectedValueChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("filter", filter_r2)("ignoreSectionsLayoutViewMode", ctx_r0.ignoreSectionsLayoutViewMode);
} }
function ExFiltersComponent_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 4);
    i0.ɵɵlistener("click", function ExFiltersComponent_ex_button_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onClearAllClicked()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("uniqueSelector", "ex-filters-clear-all-button");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "ng.general.clear.all"));
} }
class ExFiltersComponent {
    constructor(translate) {
        this.translate = translate;
        /**
         * whether the filters' display is minimized
         */
        this.minimized = false;
        /**
         * should be displayed in view mode or not
         */
        this.ignoreSectionsLayoutViewMode = false;
        /**
         * Emits an event when a filter is changed
         */
        this.selectedValueChange = new EventEmitter();
        this.defaultFilterChange = new EventEmitter();
        this.isDefaultFilterChange = false;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('filters')) {
            this.checkIfDefaultFilterChange();
        }
    }
    onSelectedValueChange(filter) {
        this.selectedValueChange.emit(filter);
        this.checkIfDefaultFilterChange();
    }
    checkIfDefaultFilterChange() {
        this.isDefaultFilterChange = false;
        this.activeFilters = "";
        this.filters.forEach((filter) => {
            if (filter.filterSelectedValue != filter.defaultValue) {
                this.activeFilters += this.isDefaultFilterChange ? ', ' : '';
                this.isDefaultFilterChange = true;
                this.activeFilters += this.translate.instant(filter.filterByLabel);
            }
        });
        this.defaultFilterChange.emit(this.activeFilters);
    }
    onClearAllClicked() {
        this.filtersComponents?.forEach(filter => filter?.onSelectedValueChange([filter.getDefaultFilter()]));
    }
    static { this.ɵfac = function ExFiltersComponent_Factory(t) { return new (t || ExFiltersComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFiltersComponent, selectors: [["ex-filters"]], viewQuery: function ExFiltersComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(ExFilterComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filtersComponents = _t);
        } }, inputs: { allLabel: "allLabel", filters: "filters", minimized: "minimized", ignoreSectionsLayoutViewMode: "ignoreSectionsLayoutViewMode" }, outputs: { selectedValueChange: "selectedValueChange", defaultFilterChange: "defaultFilterChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[1, "ex-filters-wrapper", "sel-ex-filters"], ["class", "ex-filters-single-filter", 3, "filter", "ignoreSectionsLayoutViewMode", "selectedValueChange", 4, "ngFor", "ngForOf"], ["type", "action", 3, "uniqueSelector", "click", 4, "ngIf"], [1, "ex-filters-single-filter", 3, "filter", "ignoreSectionsLayoutViewMode", "selectedValueChange"], ["type", "action", 3, "uniqueSelector", "click"]], template: function ExFiltersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExFiltersComponent_ex_filter_1_Template, 1, 2, "ex-filter", 1);
            i0.ɵɵtemplate(2, ExFiltersComponent_ex_button_2_Template, 3, 4, "ex-button", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.filters);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.filters && ctx.filters.length > 0 && ctx.isDefaultFilterChange);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExButtonComponent, ExFilterComponent, i1$2.TranslatePipe], styles: [".ex-filters-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center}.ex-filters-wrapper[_ngcontent-%COMP%]   .ex-filters-filterIcon[_ngcontent-%COMP%]{margin-inline-end:10px;margin-bottom:2px}.ex-filters-wrapper[_ngcontent-%COMP%]   .ex-filters-single-filter[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-filters-wrapper[_ngcontent-%COMP%]   .ex-filters-icon[_ngcontent-%COMP%]{color:#474747!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFiltersComponent, [{
        type: Component,
        args: [{ selector: 'ex-filters', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-filters-wrapper sel-ex-filters\">\n    <ex-filter class=\"ex-filters-single-filter\" *ngFor=\"let filter of filters\" [filter]=\"filter\"\n        (selectedValueChange)=\"onSelectedValueChange($event)\" [ignoreSectionsLayoutViewMode]=\"ignoreSectionsLayoutViewMode\">\n    </ex-filter>\n  <ex-button *ngIf = \"filters && filters.length > 0 && isDefaultFilterChange\" type=\"action\"\n             [uniqueSelector]=\"'ex-filters-clear-all-button'\" (click)=\"onClearAllClicked()\">{{'ng.general.clear.all' | translate}}</ex-button>\n</div>\n", styles: [".ex-filters-wrapper{display:flex;align-items:center}.ex-filters-wrapper .ex-filters-filterIcon{margin-inline-end:10px;margin-bottom:2px}.ex-filters-wrapper .ex-filters-single-filter{margin-inline-end:5px}.ex-filters-wrapper .ex-filters-icon{color:#474747!important}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { allLabel: [{
            type: Input
        }], filters: [{
            type: Input
        }], minimized: [{
            type: Input
        }], ignoreSectionsLayoutViewMode: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], defaultFilterChange: [{
            type: Output
        }], filtersComponents: [{
            type: ViewChildren,
            args: [ExFilterComponent]
        }] }); })();

const _c0$1a = ["floatingContent"];
const _c1$K = ["matMenuTrigger"];
const _c2$w = ["floatingSpace"];
const _c3$n = ["triggerExButton"];
function ExFloatingComponentComponent_ex_button_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "ex-svg-icon", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", ctx_r12.icon.iconName)("color", ctx_r12.icon.iconColor);
} }
function ExFloatingComponentComponent_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 13, 14);
    i0.ɵɵlistener("menuOpened", function ExFloatingComponentComponent_ex_button_0_Template_ex_button_menuOpened_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.triggerClicked($event)); })("menuClosed", function ExFloatingComponentComponent_ex_button_0_Template_ex_button_menuClosed_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onMenuClosed()); });
    i0.ɵɵtemplate(2, ExFloatingComponentComponent_ex_button_0_div_2_Template, 2, 2, "div", 15);
    i0.ɵɵelementContainer(3, 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(7);
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("matMenuTriggerFor", _r6)("disabled", ctx_r0.disabled)("type", ctx_r0.type)("iconSide", ctx_r0.icon || (ctx_r0.type == "add" || ctx_r0.type == "remove") ? "left" : null)("tooltip", ctx_r0.tooltip)("ariaLabel", ctx_r0.ariaLabel)("ariaHasPopup", ctx_r0.ariaHasPopup)("uniqueSelector", ctx_r0.uniqueSelector ? "ex-floating-component-trigger-standard-" + ctx_r0.uniqueSelector : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
const _c4$i = function (a0) { return { "ex-floating-component-side-trigger-start": a0 }; };
function ExFloatingComponentComponent_ng_template_1_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 20);
    i0.ɵɵlistener("click", function ExFloatingComponentComponent_ng_template_1_ex_button_0_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const _r17 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r17.openMenu()); });
    i0.ɵɵelementContainer(1, 16);
    i0.ɵɵelementStart(2, "div", 21, 22);
    i0.ɵɵlistener("menuOpened", function ExFloatingComponentComponent_ng_template_1_ex_button_0_Template_div_menuOpened_2_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onSideMenuOpened()); })("menuClosed", function ExFloatingComponentComponent_ng_template_1_ex_button_0_Template_div_menuClosed_2_listener() { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.onMenuClosed()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    const _r4 = i0.ɵɵreference(5);
    const _r6 = i0.ɵɵreference(7);
    i0.ɵɵproperty("disabled", ctx_r16.disabled)("type", ctx_r16.type)("tabindex", "-1")("ariaHasPopup", ctx_r16.ariaHasPopup)("tooltip", ctx_r16.tooltip)("ariaLabel", ctx_r16.ariaLabel)("uniqueSelector", ctx_r16.uniqueSelector ? "ex-floating-component-trigger-side-" + ctx_r16.uniqueSelector : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r6)("ngClass", i0.ɵɵpureFunction1(10, _c4$i, ctx_r16.triggerAtStart));
} }
function ExFloatingComponentComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExFloatingComponentComponent_ng_template_1_ex_button_0_Template, 4, 12, "ex-button", 19);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r2.splitButton);
} }
function ExFloatingComponentComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 16);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
} }
function ExFloatingComponentComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
} }
function ExFloatingComponentComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function ExFloatingComponentComponent_div_11_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementStart(1, "ex-close", 24);
    i0.ɵɵlistener("closeClicked", function ExFloatingComponentComponent_div_11_Template_ex_close_closeClicked_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.close()); });
    i0.ɵɵelementEnd()();
} }
const _c5$f = function (a0) { return { "color": a0 }; };
function ExFloatingComponentComponent_ng_template_15_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 29);
    i0.ɵɵlistener("click", function ExFloatingComponentComponent_ng_template_15_ng_container_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r29); const _r27 = i0.ɵɵreference(6); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.disabled ? false : _r27.openMenu()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementStart(3, "ex-button", 30);
    i0.ɵɵelement(4, "i", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 21, 22);
    i0.ɵɵlistener("menuOpened", function ExFloatingComponentComponent_ng_template_15_ng_container_5_Template_div_menuOpened_5_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.onSideMenuOpened()); })("menuClosed", function ExFloatingComponentComponent_ng_template_15_ng_container_5_Template_div_menuClosed_5_listener() { i0.ɵɵrestoreView(_r29); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.onMenuClosed()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-floating-component-trigger sel-floating-component-trigger-split ", ctx_r25.uniqueSelector ? i0.ɵɵpipeBind1(2, 11, "ex-floating-component-trigger-split-to-side" + ctx_r25.uniqueSelector) : "", "");
    i0.ɵɵproperty("disabled", ctx_r25.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r25.disabled)("uniqueSelector", ctx_r25.uniqueSelector ? "ex-floating-component-trigger-split-to-side" + ctx_r25.uniqueSelector : null)("ngClass", ctx_r25.disabled ? "ex-floating-split-action-button-disabled" : "ex-floating-split-action-button");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r25.splitButtonClass)("ngStyle", i0.ɵɵpureFunction1(13, _c5$f, ctx_r25.disabled ? "#d7d7d7" : "#555"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r6)("ngClass", i0.ɵɵpureFunction1(15, _c4$i, ctx_r25.triggerAtStart));
} }
function ExFloatingComponentComponent_ng_template_15_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵlistener("menuOpened", function ExFloatingComponentComponent_ng_template_15_ng_container_6_Template_button_menuOpened_1_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.triggerClicked($event)); })("menuClosed", function ExFloatingComponentComponent_ng_template_15_ng_container_6_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.onMenuClosed()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementStart(3, "ex-button", 30);
    i0.ɵɵelement(4, "i", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-floating-component-trigger sel-floating-component-trigger-split ", ctx_r26.uniqueSelector ? i0.ɵɵpipeBind1(2, 10, "ex-floating-component-trigger-split-not-to-side" + ctx_r26.uniqueSelector) : "", "");
    i0.ɵɵproperty("matMenuTriggerFor", _r6)("disabled", ctx_r26.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r26.disabled)("uniqueSelector", ctx_r26.uniqueSelector ? "ex-floating-component-trigger-split-not-to-side" + ctx_r26.uniqueSelector : null)("ngClass", ctx_r26.disabled ? "ex-floating-split-action-button-disabled" : "ex-floating-split-action-button");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r26.splitButtonClass)("ngStyle", i0.ɵɵpureFunction1(12, _c5$f, ctx_r26.disabled ? "#d7d7d7" : "#555"));
} }
const _c6$d = function (a0) { return { "borderColor": a0 }; };
function ExFloatingComponentComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "button", 26);
    i0.ɵɵlistener("click", function ExFloatingComponentComponent_ng_template_15_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.onSplitButtonClick()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementContainer(3, 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 27);
    i0.ɵɵtemplate(5, ExFloatingComponentComponent_ng_template_15_ng_container_5_Template, 7, 17, "ng-container", 28);
    i0.ɵɵtemplate(6, ExFloatingComponentComponent_ng_template_15_ng_container_6_Template, 5, 14, "ng-container", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-floating-component-trigger button-side-trigger ", ctx_r10.uniqueSelector ? i0.ɵɵpipeBind1(2, 12, "ex-floating-component-button-side-trigger-" + ctx_r10.uniqueSelector) : "", "");
    i0.ɵɵclassProp("button-side-trigger-not-open-to-side", !ctx_r10.openToSide)("button-side-trigger-active", !ctx_r10.disabled);
    i0.ɵɵproperty("disabled", ctx_r10.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c6$d, ctx_r10.disabled ? "#d7d7d7" : "gray"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.openToSide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.openToSide);
} }
const _c7$a = [[["", "content", ""]], [["", "trigger", ""]]];
const _c8$a = ["[content]", "[trigger]"];
class ExFloatingComponentComponent {
    /**
     * @ignore
     */
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * the type of the ex-button for the trigger
         */
        this.type = "action";
        this.disabled = false;
        /**
         * the value for the aria-HasPopup (menu, listbox, tree, grid, dialog, or true)
         * attribute needed for accessibility.
         * Indicates the availability and type of interactive popup element that can be triggered.
         */
        this.ariaHasPopup = "true";
        /**
         * set to true if you don't want the close button, but want to handle it from your component instead
         */
        this.closeFromContent = false;
        /**
         * class to add to mat-menu
         */
        this.menuClass = "";
        /**
         * whether to open the mat-menu to the side of the trigger
         */
        this.openToSide = false;
        /**
         * With "splitButton" flag you can split the button -
         * half a button is an icon that opens the pop-up.
         * You should define this icon with "splitButtonClass" parameter.
         * The second half is a button that triggers the "splitButtonClick" event.
         */
        this.splitButton = false;
        this.splitButtonClass = "";
        this.splitButtonClick = new EventEmitter();
        /**
         * Position of the menu in the X axis.
         */
        this.xPosition = 'after';
        /**
         * Position of the menu in the Y axis.
         */
        this.yPosition = 'below';
        /**
         * emitted when the floating menu closes
         */
        this.menuClosed = new EventEmitter();
        /**
         * emitted when the floating menu opens
         */
        this.menuOpen = new EventEmitter();
        this._dir = "ltr";
        this.triggerAtStart = false;
        this.triggerSideToggled = false;
        this.isRtl = false;
    }
    ngOnInit() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
        this.isRtl = this._dir === "rtl";
    }
    /**
     * Closes the popup
     */
    close() {
        this.trigger.closeMenu();
    }
    /**
     * Opens the popup
     */
    open() {
        this.trigger.openMenu();
    }
    triggerClicked(event) {
        this.menuOpen.emit();
        this.floatingContent.nativeElement.focus();
    }
    onKeydown(event) {
        event.stopPropagation();
    }
    onEndOfTabNavigation() {
        this.trigger.closeMenu();
    }
    onMenuClosed() {
        this.triggerExButton?.focus();
        if (this.openToSide) {
            this.onSideMenuClosed();
            if (!this.triggerSideToggled) {
                this.menuClosed.emit();
            }
        }
        else {
            this.menuClosed.emit();
        }
    }
    onSideMenuOpened() {
        this.menuOpen.emit();
        if (this.triggerSideToggled) {
            this.triggerSideToggled = false;
            return;
        }
        const matMenuPanel = document.getElementById(this.matMenu.panelId);
        if (matMenuPanel)
            matMenuPanel.style.visibility = "hidden";
        let triggerElemRect;
        let menuElemRect;
        setTimeout(() => {
            menuElemRect = this.elementBounds(this.menuContentElem.nativeElement);
            triggerElemRect = this.elementBounds(this.triggerElem.nativeElement);
            if (this._dir == "ltr" ? (menuElemRect?.left - triggerElemRect?.left) < -1 : (menuElemRect?.right - triggerElemRect?.right) > 1) {
                this.toggleTriggerSide();
            }
            this.triggerClicked(null);
            if (matMenuPanel)
                matMenuPanel.style.visibility = "visible";
            this.cdr.markForCheck();
        }, 0);
    }
    toggleTriggerSide() {
        this.triggerSideToggled = true;
        this.trigger.closeMenu();
        this.triggerAtStart = !this.triggerAtStart;
        this.trigger.openMenu();
    }
    onSideMenuClosed() {
        this.triggerAtStart = false;
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { left, right } = el.getBoundingClientRect();
        return {
            right: right,
            left: left,
        };
    }
    onSplitButtonClick() {
        this.splitButtonClick.emit();
    }
    static { this.ɵfac = function ExFloatingComponentComponent_Factory(t) { return new (t || ExFloatingComponentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFloatingComponentComponent, selectors: [["ex-floating-component"]], viewQuery: function ExFloatingComponentComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(_c0$1a, 5);
            i0.ɵɵviewQuery(_c1$K, 5, ElementRef);
            i0.ɵɵviewQuery(_c2$w, 5);
            i0.ɵɵviewQuery(_c0$1a, 5, ElementRef);
            i0.ɵɵviewQuery(_c3$n, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.floatingContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuContentElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerExButton = _t.first);
        } }, hostBindings: function ExFloatingComponentComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("closeClicked", function ExFloatingComponentComponent_closeClicked_HostBindingHandler($event) { return ctx.close($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { type: "type", icon: "icon", disabled: "disabled", tooltip: "tooltip", ariaLabel: "ariaLabel", ariaHasPopup: "ariaHasPopup", closeFromContent: "closeFromContent", menuClass: "menuClass", openToSide: "openToSide", splitButton: "splitButton", splitButtonClass: "splitButtonClass", xPosition: "xPosition", yPosition: "yPosition", uniqueSelector: "uniqueSelector" }, outputs: { splitButtonClick: "splitButtonClick", menuClosed: "menuClosed", menuOpen: "menuOpen" }, ngContentSelectors: _c8$a, decls: 17, vars: 9, consts: [["class", "ex-floating-component-trigger sel-ex-floating-component-trigger-standard", 3, "matMenuTriggerFor", "disabled", "type", "iconSide", "tooltip", "ariaLabel", "ariaHasPopup", "uniqueSelector", "menuOpened", "menuClosed", 4, "ngIf", "ngIfElse"], ["triggerSide", ""], [3, "ngTemplateOutlet", 4, "ngIf"], ["triggerContentTmpl", ""], [1, "ex-floating-component-max-width", 3, "xPosition", "yPosition"], ["floatingSpace", "matMenu"], ["tabindex", "0", "aria-hidden", "true", 1, "ex-floating-component-accessibility-dummy", "sel-floating-component-accessibility-dummy", 3, "focus"], ["tabindex", "0", 1, "ex-floating-component-content", "sel-floating-component-content", 3, "keydown.escape", "keydown"], ["floatingContent", ""], ["class", "ex-floating-component-closing-icon-container", 3, "click", 4, "ngIf"], [1, "ex-floating-component-ng-content", 3, "ngClass", "click"], ["tabindex", "0", "aria-hidden", "true", 1, "ex-floating-component-accessibility-dummy", 3, "focus"], ["splitButtonTmpl", ""], [1, "ex-floating-component-trigger", "sel-ex-floating-component-trigger-standard", 3, "matMenuTriggerFor", "disabled", "type", "iconSide", "tooltip", "ariaLabel", "ariaHasPopup", "uniqueSelector", "menuOpened", "menuClosed"], ["triggerExButton", ""], ["icon", "", 4, "ngIf"], [3, "ngTemplateOutlet"], ["icon", ""], [3, "iconName", "color"], ["class", "ex-floating-component-trigger button-side-trigger sel-ex-floating-component-trigger-side", 3, "disabled", "type", "tabindex", "ariaHasPopup", "tooltip", "ariaLabel", "uniqueSelector", "click", 4, "ngIf"], [1, "ex-floating-component-trigger", "button-side-trigger", "sel-ex-floating-component-trigger-side", 3, "disabled", "type", "tabindex", "ariaHasPopup", "tooltip", "ariaLabel", "uniqueSelector", "click"], ["aria-hidden", "true", 1, "ex-floating-component-side-trigger", 3, "matMenuTriggerFor", "ngClass", "menuOpened", "menuClosed"], ["matMenuTrigger", "matMenuTrigger"], [1, "ex-floating-component-closing-icon-container", 3, "click"], [3, "closeClicked"], [1, "ex-floating-split-split-button"], [3, "disabled", "click"], [1, "ex-floating-split-vertical-seperator", 3, "ngStyle"], [4, "ngIf"], ["tabindex", "-1", 3, "disabled", "click"], [1, "ex-floating-split-action-button-inline", "ex-floating-split-action-button-arrow", 3, "disabled", "uniqueSelector", "ngClass"], [1, "uxf-icon", "sel-popup-action-arrow", "sel-popup-action-arrow-active", 3, "ngClass", "ngStyle"], ["tabindex", "-1", 3, "matMenuTriggerFor", "disabled", "menuOpened", "menuClosed"]], template: function ExFloatingComponentComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c7$a);
            i0.ɵɵtemplate(0, ExFloatingComponentComponent_ex_button_0_Template, 4, 10, "ex-button", 0);
            i0.ɵɵtemplate(1, ExFloatingComponentComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExFloatingComponentComponent_ng_container_3_Template, 1, 1, "ng-container", 2);
            i0.ɵɵtemplate(4, ExFloatingComponentComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "mat-menu", 4, 5)(8, "div", 6);
            i0.ɵɵlistener("focus", function ExFloatingComponentComponent_Template_div_focus_8_listener() { return ctx.onEndOfTabNavigation(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 7, 8);
            i0.ɵɵlistener("keydown.escape", function ExFloatingComponentComponent_Template_div_keydown_escape_9_listener() { return ctx.close(); })("keydown", function ExFloatingComponentComponent_Template_div_keydown_9_listener($event) { return ctx.onKeydown($event); });
            i0.ɵɵtemplate(11, ExFloatingComponentComponent_div_11_Template, 2, 0, "div", 9);
            i0.ɵɵelementStart(12, "div", 10);
            i0.ɵɵlistener("click", function ExFloatingComponentComponent_Template_div_click_12_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵprojection(13, 0, ["(closeClicked)", "close()"]);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 11);
            i0.ɵɵlistener("focus", function ExFloatingComponentComponent_Template_div_focus_14_listener() { return ctx.onEndOfTabNavigation(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, ExFloatingComponentComponent_ng_template_15_Template, 7, 16, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.splitButton && !ctx.openToSide)("ngIfElse", _r1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.splitButton);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("xPosition", ctx.xPosition)("yPosition", ctx.yPosition);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("ex-floating-component-content-rtl", ctx.isRtl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.closeFromContent);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", ctx.menuClass);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i3$1.MatMenu, i3$1.MatMenuTrigger, ExCloseComponent, ExButtonComponent, ExSvgIconComponent, ExGenerateIdPipe], styles: [".ex-floating-component-content[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-floating-component-content[_ngcontent-%COMP%]   .ex-floating-component-closing-icon-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-top:5px}.ex-floating-component-content[_ngcontent-%COMP%]   .ex-floating-component-ng-content[_ngcontent-%COMP%]{margin:5px}.ex-floating-component-content-rtl[_ngcontent-%COMP%]{display:flex;flex-direction:column;direction:rtl!important}  .ex-floating-component-max-width.mat-mdc-menu-panel{max-width:none!important}.ex-floating-component-trigger[_ngcontent-%COMP%]{position:relative;border:none}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]{width:100%}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper{width:100%;padding-inline-end:0px!important}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper .tooltip-wrapper{width:100%}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper .tooltip-wrapper .ex-list-header-popup-action-label{display:flex;width:100%;justify-content:space-between;align-items:center}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]{position:absolute;top:0}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]:not(.ex-floating-component-side-trigger-start){inset-inline-end:-1px}.ex-floating-component-trigger.button-side-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger.ex-floating-component-side-trigger-start[_ngcontent-%COMP%]{inset-inline-start:-1px}.ex-floating-component-accessibility-dummy[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-floating-split-split-button[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.ex-floating-split-split-button[_ngcontent-%COMP%]   .ex-floating-split-action-button-inline[_ngcontent-%COMP%]{display:inline-block!important}.ex-floating-split-split-button[_ngcontent-%COMP%]   .ex-floating-split-vertical-seperator[_ngcontent-%COMP%]{border-left:1px solid;height:20px}.ex-floating-split-split-button[_ngcontent-%COMP%]   .ex-floating-split-action-button-inline[_ngcontent-%COMP%]{flex-grow:2}.ex-floating-split-split-button[_ngcontent-%COMP%]   .button-side-trigger[_ngcontent-%COMP%]{min-height:32px;line-height:32px}.ex-floating-split-split-button[_ngcontent-%COMP%]   .button-side-trigger-not-open-to-side[_ngcontent-%COMP%]{padding-inline:10px}.ex-floating-split-split-button[_ngcontent-%COMP%]   .button-side-trigger-active[_ngcontent-%COMP%]:focus, .ex-floating-split-split-button[_ngcontent-%COMP%]   .button-side-trigger-active[_ngcontent-%COMP%]:hover:focus{background-color:#ddd;border-radius:3px;outline:1px solid #000}.ex-floating-split-split-button[_ngcontent-%COMP%]   .button-side-trigger-active[_ngcontent-%COMP%]:hover{background-color:#eee}.ex-floating-split-split-button[_ngcontent-%COMP%]   .ex-floating-split-action-button-arrow[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin:10px}.ex-floating-split-split-button[_ngcontent-%COMP%]   .ex-floating-split-action-button[_ngcontent-%COMP%]:hover{background-color:#eee;border-radius:3px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatingComponentComponent, [{
        type: Component,
        args: [{ selector: 'ex-floating-component', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- open down -->\n<ex-button #triggerExButton *ngIf=\"!splitButton && !openToSide; else triggerSide\" class=\"ex-floating-component-trigger sel-ex-floating-component-trigger-standard\"\n           [matMenuTriggerFor]=\"floatingSpace\" (menuOpened)=\"triggerClicked($event)\" (menuClosed)=\"onMenuClosed()\"\n           [disabled]=\"disabled\" [type]=\"type\" [iconSide]=\"icon || (type == 'add' || type == 'remove') ? 'left' : null\"\n           [tooltip]=\"tooltip\" [ariaLabel]=\"ariaLabel\" [ariaHasPopup]=\"ariaHasPopup\"\n           [uniqueSelector]=\"uniqueSelector ? 'ex-floating-component-trigger-standard-' + uniqueSelector : null\">\n  <div *ngIf=\"icon\" icon>\n    <ex-svg-icon [iconName]=\"icon.iconName\" [color]=\"icon.iconColor\"></ex-svg-icon>\n  </div>\n  <ng-container [ngTemplateOutlet]=\"triggerContentTmpl\"></ng-container>\n</ex-button>\n\n<!-- open to side -->\n<ng-template #triggerSide>\n    <ex-button *ngIf=\"!splitButton\" class=\"ex-floating-component-trigger button-side-trigger sel-ex-floating-component-trigger-side\"\n               [disabled]=\"disabled\" [type]=\"type\" [tabindex]=\"'-1'\" [ariaHasPopup]=\"ariaHasPopup\"\n               (click)=\"matMenuTrigger.openMenu()\" [tooltip]=\"tooltip\" [ariaLabel]=\"ariaLabel\"\n               [uniqueSelector]=\"uniqueSelector ? 'ex-floating-component-trigger-side-' + uniqueSelector : null\">\n      <ng-container [ngTemplateOutlet]=\"triggerContentTmpl\"></ng-container>\n      <div #matMenuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"floatingSpace\" class=\"ex-floating-component-side-trigger\"\n           aria-hidden=\"true\" [ngClass]=\"{ 'ex-floating-component-side-trigger-start': triggerAtStart }\" (menuOpened)=\"onSideMenuOpened()\"\n           (menuClosed)=\"onMenuClosed()\">\n      </div>\n    </ex-button>\n</ng-template>\n\n<!-- split button -->\n<ng-container *ngIf=\"splitButton\" [ngTemplateOutlet]=\"splitButtonTmpl\"></ng-container>\n\n<!-- trigger content -->\n<ng-template #triggerContentTmpl>\n  <ng-content select=\"[trigger]\"></ng-content>\n</ng-template>\n\n<!-- popup content -->\n<mat-menu [xPosition]=\"xPosition\" [yPosition]=\"yPosition\" #floatingSpace=\"matMenu\"\n  class=\"ex-floating-component-max-width\">\n  <div tabindex=\"0\" (focus)=\"onEndOfTabNavigation()\" class=\"ex-floating-component-accessibility-dummy sel-floating-component-accessibility-dummy\"\n    aria-hidden=\"true\"></div>\n  <div (keydown.escape)=\"close()\" (keydown)=\"onKeydown($event)\" #floatingContent class=\"ex-floating-component-content sel-floating-component-content\" [class.ex-floating-component-content-rtl]=\"isRtl\" tabindex=\"0\">\n    <div *ngIf=\"!closeFromContent\" class=\"ex-floating-component-closing-icon-container\"\n      (click)=\"$event.stopPropagation();\">\n      <ex-close (closeClicked)=\"close()\"></ex-close>\n    </div>\n    <div class=\"ex-floating-component-ng-content\" [ngClass]=\"menuClass\" (click)=\"$event.stopPropagation();\">\n      <ng-content (closeClicked)=\"close()\" select=\"[content]\"></ng-content>\n    </div>\n  </div>\n  <div tabindex=\"0\" (focus)=\"onEndOfTabNavigation()\" class=\"ex-floating-component-accessibility-dummy\"\n    aria-hidden=\"true\"></div>\n</mat-menu>\n\n<ng-template #splitButtonTmpl>\n  <div class=\"ex-floating-split-split-button\">\n    <button class=\"ex-floating-component-trigger button-side-trigger {{ uniqueSelector ? (('ex-floating-component-button-side-trigger-' + uniqueSelector) | generateHTMLId) : ''}}\"\n      [class.button-side-trigger-not-open-to-side]=\"!openToSide\" [class.button-side-trigger-active]=\"!disabled\"\n      [disabled]=\"disabled\" (click)=\"onSplitButtonClick()\">\n      <ng-container [ngTemplateOutlet]=\"triggerContentTmpl\"></ng-container>\n    </button>\n    <span class=\"ex-floating-split-vertical-seperator\"\n      [ngStyle]=\"{ 'borderColor' : disabled ? '#d7d7d7' : 'gray'  }\"></span>\n\n    <ng-container *ngIf=\"openToSide\">\n      <button (click)=\"disabled?false:matMenuTrigger.openMenu()\" class=\"ex-floating-component-trigger sel-floating-component-trigger-split {{ uniqueSelector ? (('ex-floating-component-trigger-split-to-side' + uniqueSelector) | generateHTMLId) : ''}}\"\n        [disabled]=\"disabled\" tabindex=\"-1\">\n        <ex-button class=\"ex-floating-split-action-button-inline ex-floating-split-action-button-arrow\" [disabled]=\"disabled\"\n                   [uniqueSelector]=\"uniqueSelector ? 'ex-floating-component-trigger-split-to-side' + uniqueSelector : null\"\n                   [ngClass]=\"disabled ? 'ex-floating-split-action-button-disabled' :'ex-floating-split-action-button'\">\n          <i class=\"uxf-icon sel-popup-action-arrow sel-popup-action-arrow-active\" [ngClass]=\"splitButtonClass\"\n            [ngStyle]=\"{ 'color' : disabled ? '#d7d7d7' : '#555'  }\"></i>\n        </ex-button>\n      </button>\n      <div #matMenuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"floatingSpace\"\n        class=\"ex-floating-component-side-trigger\" aria-hidden=\"true\"\n        [ngClass]=\"{ 'ex-floating-component-side-trigger-start': triggerAtStart }\" (menuOpened)=\"onSideMenuOpened()\"\n        (menuClosed)=\"onMenuClosed()\">\n      </div>\n    </ng-container>\n\n    <ng-container *ngIf=\"!openToSide\">\n      <button tabindex=\"-1\" class=\"ex-floating-component-trigger sel-floating-component-trigger-split {{ uniqueSelector ? (('ex-floating-component-trigger-split-not-to-side' + uniqueSelector) | generateHTMLId) : ''}}\"\n              [matMenuTriggerFor]=\"floatingSpace\" (menuOpened)=\"triggerClicked($event)\" (menuClosed)=\"onMenuClosed()\" [disabled]=\"disabled\">\n        <ex-button class=\"ex-floating-split-action-button-inline ex-floating-split-action-button-arrow\" [disabled]=\"disabled\"\n                   [uniqueSelector]=\"uniqueSelector ? 'ex-floating-component-trigger-split-not-to-side' + uniqueSelector : null\"\n                   [ngClass]=\"disabled ? 'ex-floating-split-action-button-disabled' :'ex-floating-split-action-button'\">\n          <i class=\"uxf-icon sel-popup-action-arrow sel-popup-action-arrow-active\" [ngClass]=\"splitButtonClass\"\n            [ngStyle]=\"{ 'color' : disabled ? '#d7d7d7' : '#555'  }\"></i>\n        </ex-button>\n      </button>\n    </ng-container>\n  </div>\n</ng-template>\n", styles: [".ex-floating-component-content{display:flex;flex-direction:column}.ex-floating-component-content .ex-floating-component-closing-icon-container{display:flex;justify-content:flex-end;margin-top:5px}.ex-floating-component-content .ex-floating-component-ng-content{margin:5px}.ex-floating-component-content-rtl{display:flex;flex-direction:column;direction:rtl!important}::ng-deep .ex-floating-component-max-width.mat-mdc-menu-panel{max-width:none!important}.ex-floating-component-trigger{position:relative;border:none}.ex-floating-component-trigger.button-side-trigger{width:100%}.ex-floating-component-trigger.button-side-trigger ::ng-deep .ex-button-wrapper{width:100%;padding-inline-end:0px!important}.ex-floating-component-trigger.button-side-trigger ::ng-deep .ex-button-wrapper .tooltip-wrapper{width:100%}.ex-floating-component-trigger.button-side-trigger ::ng-deep .ex-button-wrapper .tooltip-wrapper .ex-list-header-popup-action-label{display:flex;width:100%;justify-content:space-between;align-items:center}.ex-floating-component-trigger.button-side-trigger .mat-mdc-menu-trigger{position:absolute;top:0}.ex-floating-component-trigger.button-side-trigger .mat-mdc-menu-trigger:not(.ex-floating-component-side-trigger-start){inset-inline-end:-1px}.ex-floating-component-trigger.button-side-trigger .mat-mdc-menu-trigger.ex-floating-component-side-trigger-start{inset-inline-start:-1px}.ex-floating-component-accessibility-dummy{width:0;height:0;overflow:hidden;border:transparent}.ex-floating-split-split-button{display:flex;justify-content:space-between;align-items:center}.ex-floating-split-split-button .ex-floating-split-action-button-inline{display:inline-block!important}.ex-floating-split-split-button .ex-floating-split-vertical-seperator{border-left:1px solid;height:20px}.ex-floating-split-split-button .ex-floating-split-action-button-inline{flex-grow:2}.ex-floating-split-split-button .button-side-trigger{min-height:32px;line-height:32px}.ex-floating-split-split-button .button-side-trigger-not-open-to-side{padding-inline:10px}.ex-floating-split-split-button .button-side-trigger-active:focus,.ex-floating-split-split-button .button-side-trigger-active:hover:focus{background-color:#ddd;border-radius:3px;outline:1px solid #000}.ex-floating-split-split-button .button-side-trigger-active:hover{background-color:#eee}.ex-floating-split-split-button .ex-floating-split-action-button-arrow i{margin:10px}.ex-floating-split-split-button .ex-floating-split-action-button:hover{background-color:#eee;border-radius:3px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { type: [{
            type: Input
        }], icon: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaHasPopup: [{
            type: Input
        }], closeFromContent: [{
            type: Input
        }], menuClass: [{
            type: Input
        }], openToSide: [{
            type: Input
        }], splitButton: [{
            type: Input
        }], splitButtonClass: [{
            type: Input
        }], splitButtonClick: [{
            type: Output
        }], xPosition: [{
            type: Input
        }], yPosition: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], menuClosed: [{
            type: Output
        }], menuOpen: [{
            type: Output
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], floatingContent: [{
            type: ViewChild,
            args: ['floatingContent']
        }], triggerElem: [{
            type: ViewChild,
            args: ['matMenuTrigger', { read: ElementRef }]
        }], matMenu: [{
            type: ViewChild,
            args: ['floatingSpace']
        }], menuContentElem: [{
            type: ViewChild,
            args: ['floatingContent', { read: ElementRef }]
        }], triggerExButton: [{
            type: ViewChild,
            args: ['triggerExButton']
        }], close: [{
            type: HostListener,
            args: ['document:closeClicked', ['$event']]
        }] }); })();

const _c0$19 = ["input"];
const _c1$J = function (a0) { return { key: a0 }; };
const _c2$v = function (a0) { return [a0]; };
function ExExtendedSearchComponent_ex_new_combobox_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 3);
    i0.ɵɵlistener("selectedItemsChange", function ExExtendedSearchComponent_ex_new_combobox_1_Template_ex_new_combobox_selectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1._searchFieldChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ariaLabel", "ng.general.search.search_by")("ignoreSectionsLayoutViewMode", true)("uniqueSelector", "ex-extended-search-dropdown")("displaySearchBox", ctx_r0.searchFields.length > 10)("items", ctx_r0.searchFields)("selectedItems", i0.ɵɵpureFunction1(8, _c2$v, i0.ɵɵpureFunction1(6, _c1$J, ctx_r0.selectedSearchField)));
} }
const _c3$m = function (a0) { return { "ex-extended-search-focus": a0 }; };
class ExExtendedSearchComponent {
    constructor() {
        /**
         *  event fired whenever the search button is clicked or when the user type - depend on the incremental parameter
         */
        this.searchTriggered = new EventEmitter();
        /**
         *  define if the search is an incremental search (the event is fired every time the user types)
         *  or the event is fired by clicking on the search icon/press Enter
         *  default is false
         */
        this.incremental = false;
        /**
         *  set the background of the searchbox
         *  default is white
         */
        this.background = '#fff';
        /**
         *  placeholder for the searchbox
         *  default is empty
         */
        this.placeholder = '';
        /**
         * value of the text box
         */
        this.searchText = '';
        /**
         * define if the search box should have a blue border on focus
         * by default - false
         */
        this.blueOnFocus = true;
        /**
         * should the search button be shown
         * default - true
         * // todo: config to choose side (left, right, none)
         */
        this.showSearchButton = true;
        this.isLoading = false;
        this.autoFocus = false;
        /**
         * event triggered whenever the value change
         */
        this.searchTextChange = new EventEmitter();
        /**
         * event fired whenever an item inside the dropdown is clicked
         */
        this.selectedValueChange = new EventEmitter();
        this.isFocus = false;
    }
    onSearch() {
        if (!this.incremental) {
            this.emitSearchTriggered();
        }
    }
    _searchTextChange(text) {
        this.searchText = text;
        this.searchTextChange.emit(text);
    }
    _searchFieldChange(newSearchField) {
        this.selectedSearchField = newSearchField[0].key;
        this.selectedValueChange.emit(this.selectedSearchField);
    }
    emitSearchTriggered() {
        this.selectedSearchField ?
            this.searchTriggered.emit({ searchBy: this.selectedSearchField, searchText: this.searchText }) :
            this.searchTriggered.emit({ searchText: this.searchText });
    }
    static { this.ɵfac = function ExExtendedSearchComponent_Factory(t) { return new (t || ExExtendedSearchComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExExtendedSearchComponent, selectors: [["ex-extended-search"]], viewQuery: function ExExtendedSearchComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$19, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        } }, inputs: { incremental: "incremental", background: "background", placeholder: "placeholder", searchText: "searchText", blueOnFocus: "blueOnFocus", showSearchButton: "showSearchButton", isLoading: "isLoading", autoFocus: "autoFocus", searchFields: "searchFields", selectedSearchField: "selectedSearchField" }, outputs: { searchTriggered: "searchTriggered", searchTextChange: "searchTextChange", selectedValueChange: "selectedValueChange" }, decls: 4, vars: 13, consts: [[1, "ex-extended-search-search-wrapper", 3, "ngClass"], ["class", "ex-extended-search-dropdown sel-search-dropdown", 3, "ariaLabel", "ignoreSectionsLayoutViewMode", "uniqueSelector", "displaySearchBox", "items", "selectedItems", "selectedItemsChange", 4, "ngIf"], [1, "ex-extended-search-searchbox", 3, "showSearchButton", "blueOnFocus", "autoFocus", "searchText", "inputAriaLabel", "searchTextChange", "searchTriggered"], [1, "ex-extended-search-dropdown", "sel-search-dropdown", 3, "ariaLabel", "ignoreSectionsLayoutViewMode", "uniqueSelector", "displaySearchBox", "items", "selectedItems", "selectedItemsChange"]], template: function ExExtendedSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExExtendedSearchComponent_ex_new_combobox_1_Template, 1, 10, "ex-new-combobox", 1);
            i0.ɵɵelementStart(2, "ex-search", 2);
            i0.ɵɵlistener("searchTextChange", function ExExtendedSearchComponent_Template_ex_search_searchTextChange_2_listener($event) { return ctx.searchText = $event; })("searchTriggered", function ExExtendedSearchComponent_Template_ex_search_searchTriggered_2_listener() { return ctx.onSearch(); })("searchTextChange", function ExExtendedSearchComponent_Template_ex_search_searchTextChange_2_listener($event) { return ctx._searchTextChange($event); });
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.background);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3$m, ctx.blueOnFocus && ctx.isFocus));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.searchFields && ctx.searchFields.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("showSearchButton", ctx.showSearchButton)("blueOnFocus", ctx.blueOnFocus)("autoFocus", ctx.autoFocus)("searchText", ctx.searchText)("inputAriaLabel", i0.ɵɵpipeBind1(3, 9, "ng.ex_search.type-to-search-for") + " " + ctx.selectedSearchField);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, ExSearchComponent, ExNewComboboxComponent, i1$2.TranslatePipe], styles: [".ex-extended-search-search-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;height:34px;border-radius:3px;justify-content:stretch}.ex-extended-search-search-wrapper[_ngcontent-%COMP%]   .ex-search-search-wrapper[_ngcontent-%COMP%]{border-top-right-radius:3px;border-bottom-right-radius:3px}.ex-extended-search-search-wrapper[_ngcontent-%COMP%]   .ex-extended-search-dropdown[_ngcontent-%COMP%]{border-start-start-radius:3px;border-end-start-radius:3px;border:1px solid #898989;border-inline-end:none}.ex-extended-search-search-wrapper[_ngcontent-%COMP%]   .ex-extended-search-dropdown[_ngcontent-%COMP%]     button{height:32px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExExtendedSearchComponent, [{
        type: Component,
        args: [{ selector: 'ex-extended-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-extended-search-search-wrapper\" [ngClass]=\"{ 'ex-extended-search-focus': blueOnFocus && isFocus }\"\n     [style.background]=\"background\">\n  <ex-new-combobox [ariaLabel]=\"'ng.general.search.search_by'\" *ngIf=\"searchFields && searchFields.length > 0\" class=\"ex-extended-search-dropdown sel-search-dropdown\" [ignoreSectionsLayoutViewMode]=\"true\"\n                   [uniqueSelector]=\"'ex-extended-search-dropdown'\" [displaySearchBox]=\"searchFields.length > 10\" [items]=\"searchFields\" [selectedItems]=\"[{ key: selectedSearchField }]\" (selectedItemsChange)=\"_searchFieldChange($event)\">\n  </ex-new-combobox>\n  <ex-search class=\"ex-extended-search-searchbox\" [showSearchButton]=\"showSearchButton\" [blueOnFocus]=\"blueOnFocus\"\n             [autoFocus]=\"autoFocus\" [(searchText)]=\"searchText\" (searchTriggered)=\"onSearch()\"\n             (searchTextChange)=\"_searchTextChange($event)\" [inputAriaLabel]=\"('ng.ex_search.type-to-search-for' | translate) + ' ' + selectedSearchField\">\n  </ex-search>\n</div>\n", styles: [".ex-extended-search-search-wrapper{display:flex;flex-direction:row;align-items:center;flex:1;flex-grow:5;height:34px;border-radius:3px;justify-content:stretch}.ex-extended-search-search-wrapper .ex-search-search-wrapper{border-top-right-radius:3px;border-bottom-right-radius:3px}.ex-extended-search-search-wrapper .ex-extended-search-dropdown{border-start-start-radius:3px;border-end-start-radius:3px;border:1px solid #898989;border-inline-end:none}.ex-extended-search-search-wrapper .ex-extended-search-dropdown ::ng-deep button{height:32px}\n"] }]
    }], null, { searchTriggered: [{
            type: Output
        }], incremental: [{
            type: Input
        }], background: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], searchText: [{
            type: Input
        }], blueOnFocus: [{
            type: Input
        }], showSearchButton: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], searchFields: [{
            type: Input
        }], selectedSearchField: [{
            type: Input
        }], searchTextChange: [{
            type: Output
        }], selectedValueChange: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();

const _c0$18 = [[["", "description", ""]], "*"];
const _c1$I = ["[description]", "*"];
class ExHelpIconComponent {
    constructor(sanitizer, translate) {
        this.sanitizer = sanitizer;
        this.translate = translate;
        /**
         * menu content width
         */
        this.contentWidth = "";
        /**
         * icon ariaLabel
         */
        this.ariaLabel = null;
        /**
         * the help icon
         */
        this.icon = { iconName: 'info', iconColor: '#4164a4' };
        /**
         * the tooltip text that display on the help icon
         */
        this.helpIconTooltip = "ng.exHelpIcon.moreInformation";
    }
    ngOnChanges(changes) {
        if (changes['description']) {
            this.description = this.sanitizeHtml(this.translate.instant(this.description));
        }
    }
    onMenuOpened() {
        setTimeout(() => {
            this.closeIconElement?.focus();
        }, 100);
    }
    onCloseMenu() {
        this.menuTrigger.closeMenu();
    }
    onClickMenu($event) {
        $event?.stopPropagation();
    }
    /**
     * call this function to close the menu
     * method can be accessed via ViewChild in parent component.
     */
    closeMenu() {
        this.menuTrigger.closeMenu();
    }
    sanitizeHtml(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = function ExHelpIconComponent_Factory(t) { return new (t || ExHelpIconComponent)(i0.ɵɵdirectiveInject(i2$2.DomSanitizer), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExHelpIconComponent, selectors: [["ex-help-icon"]], viewQuery: function ExHelpIconComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(ExCloseComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeIconElement = _t.first);
        } }, inputs: { title: "title", description: "description", src: "src", contentWidth: "contentWidth", ariaLabel: "ariaLabel", icon: "icon", helpIconTooltip: "helpIconTooltip", uniqueSelector: "uniqueSelector" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1$I, decls: 19, vars: 22, consts: [[3, "exTooltip", "matMenuTriggerFor", "menuOpened"], ["menuTrigger", "matMenuTrigger"], [3, "color", "iconName"], [1, "ex-help-icon-container", 3, "overlapTrigger"], ["menu", "matMenu"], ["cdkTrapFocus", "", 3, "keydown", "keydown.escape"], [1, "ex-help-icon-content", 3, "click"], ["size", "medium", 1, "ex-help-icon-close", 3, "closeClicked"], [1, "ex-help-icon-content-texts"], [1, "ex-help-icon-title"], [1, "ex-help-icon-description", 3, "innerHTML"], [1, "ex-help-icon-img", 3, "src"]], template: function ExHelpIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$18);
            i0.ɵɵelementStart(0, "button", 0, 1);
            i0.ɵɵlistener("menuOpened", function ExHelpIconComponent_Template_button_menuOpened_0_listener() { return ctx.onMenuOpened(); });
            i0.ɵɵpipe(2, "generateHTMLId");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelement(5, "ex-svg-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-menu", 3, 4)(8, "div", 5);
            i0.ɵɵlistener("keydown", function ExHelpIconComponent_Template_div_keydown_8_listener($event) { return $event.stopPropagation(); })("keydown.escape", function ExHelpIconComponent_Template_div_keydown_escape_8_listener() { return ctx.onCloseMenu(); });
            i0.ɵɵelementStart(9, "div", 6);
            i0.ɵɵlistener("click", function ExHelpIconComponent_Template_div_click_9_listener($event) { return ctx.onClickMenu($event); });
            i0.ɵɵelementStart(10, "ex-close", 7);
            i0.ɵɵlistener("closeClicked", function ExHelpIconComponent_Template_ex_close_closeClicked_10_listener() { return ctx.onCloseMenu(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 8)(12, "div", 9);
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "div", 10);
            i0.ɵɵprojection(16);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(17, "img", 11);
            i0.ɵɵprojection(18, 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(7);
            i0.ɵɵclassMapInterpolate1("ex-help-icon-clickable-icon ", i0.ɵɵpipeBind1(2, 14, "ex-help-icon-clickable-icon-" + ctx.icon.iconName + (ctx.uniqueSelector ? "-" + ctx.uniqueSelector : "")), "");
            i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(3, 16, ctx.helpIconTooltip))("matMenuTriggerFor", _r1);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 18, ctx.ariaLabel || "ng.exHelpIcon.moreInformation"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("color", ctx.icon == null ? null : ctx.icon.iconColor)("iconName", ctx.icon == null ? null : ctx.icon.iconName);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance(5);
            i0.ɵɵstyleProp("width", ctx.contentWidth || "500px");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 20, ctx.title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", ctx.description, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("src", ctx.src, i0.ɵɵsanitizeUrl);
        } }, dependencies: [i3$1.MatMenu, i3$1.MatMenuTrigger, ExTooltipDirective, ExSvgIconComponent, ExCloseComponent, i3.CdkTrapFocus, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-help-icon-clickable-icon[_ngcontent-%COMP%]:hover{color:#074467}.ex-help-icon-clickable-icon[_ngcontent-%COMP%]{border:0px;background:transparent;color:#4164a4}  .ex-help-icon-container.mat-mdc-menu-panel{min-width:max-content!important;max-width:max-content!important;border:1px solid rgba(112,112,112,.3);border-radius:10px!important;margin-left:-55px;margin-top:12px}  .ex-help-icon-container.mat-mdc-menu-panel .ex-help-icon-close{float:right}  .ex-help-icon-container.mat-mdc-menu-panel .ex-help-icon-close   i{color:#4164a4}.ex-help-icon-content[_ngcontent-%COMP%]{padding:14px;max-height:max-content}.ex-help-icon-content[_ngcontent-%COMP%]   .ex-help-icon-content-texts[_ngcontent-%COMP%]   .ex-help-icon-title[_ngcontent-%COMP%]{margin-bottom:10px}.ex-help-icon-content[_ngcontent-%COMP%]   .ex-help-icon-content-texts[_ngcontent-%COMP%]   .ex-help-icon-description[_ngcontent-%COMP%]{white-space:pre-line}.ex-help-icon-content[_ngcontent-%COMP%]   .ex-help-icon-content-texts[_ngcontent-%COMP%]   .ex-help-icon-description[_ngcontent-%COMP%]     a{color:#4164a4;cursor:pointer;white-space:nowrap}.ex-help-icon-img[_ngcontent-%COMP%]{width:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExHelpIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-help-icon', template: "<button class=\"ex-help-icon-clickable-icon {{('ex-help-icon-clickable-icon-' + icon.iconName + (uniqueSelector ? '-' + uniqueSelector : '')) | generateHTMLId}}\" [exTooltip]=\"helpIconTooltip | translate\" [attr.aria-label]=\"(ariaLabel || 'ng.exHelpIcon.moreInformation') | translate\"\r\n  [matMenuTriggerFor]=\"menu\" #menuTrigger=\"matMenuTrigger\" (menuOpened)=\"onMenuOpened()\">\r\n  <ex-svg-icon [color]=\"icon?.iconColor\" [iconName]=\"icon?.iconName\"></ex-svg-icon>\r\n</button>\r\n\r\n<mat-menu #menu=\"matMenu\" class=\"ex-help-icon-container\" [overlapTrigger]=\"false\">\r\n  <div (keydown)=\"$event.stopPropagation()\" (keydown.escape)=\"onCloseMenu()\" cdkTrapFocus>\r\n    <div class=\"ex-help-icon-content\" (click)=\"onClickMenu($event)\">\r\n      <ex-close class=\"ex-help-icon-close\" size=\"medium\" (closeClicked)=\"onCloseMenu()\"></ex-close>\r\n      <div class=\"ex-help-icon-content-texts\" [style.width]=\"contentWidth || '500px'\">\r\n        <div class=\"ex-help-icon-title\">{{title | translate }}</div>\r\n        <div class=\"ex-help-icon-description\" [innerHTML]=\"description\"></div>\r\n        <ng-content select=\"[description]\"></ng-content>\r\n      </div>\r\n    </div>\r\n    <img [src]=\"src\" class=\"ex-help-icon-img\" />\r\n    <ng-content></ng-content>\r\n  </div>\r\n</mat-menu>\r\n", styles: [".ex-help-icon-clickable-icon:hover{color:#074467}.ex-help-icon-clickable-icon{border:0px;background:transparent;color:#4164a4}::ng-deep .ex-help-icon-container.mat-mdc-menu-panel{min-width:max-content!important;max-width:max-content!important;border:1px solid rgba(112,112,112,.3);border-radius:10px!important;margin-left:-55px;margin-top:12px}::ng-deep .ex-help-icon-container.mat-mdc-menu-panel .ex-help-icon-close{float:right}::ng-deep .ex-help-icon-container.mat-mdc-menu-panel .ex-help-icon-close ::ng-deep i{color:#4164a4}.ex-help-icon-content{padding:14px;max-height:max-content}.ex-help-icon-content .ex-help-icon-content-texts .ex-help-icon-title{margin-bottom:10px}.ex-help-icon-content .ex-help-icon-content-texts .ex-help-icon-description{white-space:pre-line}.ex-help-icon-content .ex-help-icon-content-texts .ex-help-icon-description ::ng-deep a{color:#4164a4;cursor:pointer;white-space:nowrap}.ex-help-icon-img{width:100%}\n"] }]
    }], function () { return [{ type: i2$2.DomSanitizer }, { type: i1$2.TranslateService }]; }, { title: [{
            type: Input
        }], description: [{
            type: Input
        }], src: [{
            type: Input
        }], contentWidth: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], icon: [{
            type: Input
        }], helpIconTooltip: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], menuTrigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], closeIconElement: [{
            type: ViewChild,
            args: [ExCloseComponent]
        }] }); })();

function ExLinkComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$17 = function (a2, a3, a4) { return ["ex-link-anchor", "sel-ex-link-anchor", a2, a3, a4]; };
function ExLinkComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 3);
    i0.ɵɵlistener("keydown.enter", function ExLinkComponent_ng_container_0_Template_a_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onClick($event)); })("click", function ExLinkComponent_ng_container_0_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onClick($event)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, ExLinkComponent_ng_container_0_ng_container_4_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("font-weight", ctx_r0.fontWeight);
    i0.ɵɵpropertyInterpolate("tabIndex", ctx_r0.disabled ? -1 : 0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c0$17, "ex-link-anchor-" + ctx_r0.textSize, ctx_r0.uniqueSelector ? i0.ɵɵpipeBind1(2, 8, "ex-link-" + ctx_r0.uniqueSelector) : "", ctx_r0.disabled ? "ex-link-disabled" : ""))("exTooltip", !ctx_r0.disabled ? ctx_r0.tooltip || ctx_r0.arguments : null);
    i0.ɵɵattribute("aria-disabled", ctx_r0.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.arguments, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExLinkComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLinkComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, ExLinkComponent_ng_template_1_ng_container_3_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵstyleProp("font-weight", ctx_r2.fontWeight);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c0$17, "ex-link-anchor-" + ctx_r2.textSize, ctx_r2.uniqueSelector ? i0.ɵɵpipeBind1(1, 5, "ex-link-" + ctx_r2.uniqueSelector) : "", ctx_r2.disabled ? "ex-link-disabled" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.arguments, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExLinkComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
const _c1$H = ["*"];
class ExLinkComponent {
    /**
     * @ignore
     */
    constructor() {
        this.disabled = false;
        this.viewMode = false;
        /**
         * A label for the tooltip. If there is none - the arguments value will be the tooltip.
         */
        this.tooltip = null;
        this.textSize = 'normal';
        this.linkClicked = new EventEmitter();
    }
    /**
     * The function that emits the action to the parent component
     */
    onClick(event) {
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (this.dataOutput) {
            this.dataOutput.next(this.arguments);
        }
        this.linkClicked.emit(event);
        return false;
    }
    static { this.ɵfac = function ExLinkComponent_Factory(t) { return new (t || ExLinkComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLinkComponent, selectors: [["ex-link"]], inputs: { disabled: "disabled", viewMode: "viewMode", arguments: "arguments", tooltip: "tooltip", dataOutput: "dataOutput", textSize: "textSize", fontWeight: "fontWeight", uniqueSelector: "uniqueSelector" }, outputs: { linkClicked: "linkClicked" }, ngContentSelectors: _c1$H, decls: 5, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["divBlock", ""], ["linkContent", ""], ["href", "#", "dir", "auto", 3, "tabIndex", "ngClass", "exTooltip", "keydown.enter", "click"], [4, "ngTemplateOutlet"], ["dir", "auto", 3, "ngClass"]], template: function ExLinkComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ExLinkComponent_ng_container_0_Template, 5, 14, "ng-container", 0);
            i0.ɵɵtemplate(1, ExLinkComponent_ng_template_1_Template, 4, 11, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExLinkComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.viewMode)("ngIfElse", _r1);
        } }, dependencies: [i2$1.Dir, ExTooltipDirective, i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, ExGenerateIdPipe], styles: [".ex-link-anchor[_ngcontent-%COMP%]:not(.ex-link-disabled){color:#4164a4;cursor:pointer}.ex-link-anchor[_ngcontent-%COMP%]:hover:not(.ex-link-disabled){color:#1b3c72;text-decoration:underline}.ex-link-anchor-large[_ngcontent-%COMP%]{line-height:20px}.ex-link-disabled[_ngcontent-%COMP%]{cursor:default;text-decoration:none;pointer-events:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLinkComponent, [{
        type: Component,
        args: [{ selector: 'ex-link', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!viewMode; else divBlock\">\n  <a href=\"#\" dir=\"auto\"\n     tabIndex=\"{{disabled ? -1 : 0}}\"\n     (keydown.enter)=\"onClick($event)\"\n     (click)=\"onClick($event)\"\n     [ngClass]=\"[\n    'ex-link-anchor',\n    'sel-ex-link-anchor',\n    'ex-link-anchor-' + textSize,\n    uniqueSelector ? (('ex-link-' + uniqueSelector) | generateHTMLId) : '',\n    disabled ? 'ex-link-disabled' : ''\n  ]\"\n     [attr.aria-disabled]=\"disabled\"\n     [style.font-weight]=\"fontWeight\"\n     [exTooltip]=\"!disabled ? (tooltip || arguments) : null\"\n  >\n    {{ arguments }}\n    <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </a>\n</ng-container>\n<ng-template #divBlock>\n  <div dir=\"auto\"\n  [ngClass]=\"[\n  'ex-link-anchor',\n  'sel-ex-link-anchor',\n  'ex-link-anchor-' + textSize,\n  uniqueSelector ? (('ex-link-' + uniqueSelector) | generateHTMLId) : '',\n  disabled ? 'ex-link-disabled' : ''\n  ]\"\n  [style.font-weight]=\"fontWeight\"\n  >\n  {{ arguments }}\n  <ng-container *ngTemplateOutlet=\"linkContent\"></ng-container>\n  </div>\n</ng-template>\n\n<ng-template #linkContent>\n  <ng-content></ng-content>\n</ng-template>\n", styles: [".ex-link-anchor:not(.ex-link-disabled){color:#4164a4;cursor:pointer}.ex-link-anchor:hover:not(.ex-link-disabled){color:#1b3c72;text-decoration:underline}.ex-link-anchor-large{line-height:20px}.ex-link-disabled{cursor:default;text-decoration:none;pointer-events:none}\n"] }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], arguments: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }], textSize: [{
            type: Input
        }], fontWeight: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], linkClicked: [{
            type: Output
        }] }); })();

const _c0$16 = ["floatingCustomization"];
const _c1$G = ["toggleMenu"];
const _c2$u = ["childMenu"];
const _c3$l = ["headerAll"];
const _c4$h = ["headerLeft"];
const _c5$e = ["headerRight"];
const _c6$c = ["headerLeftElementCheckbox"];
const _c7$9 = ["headerLeftElementSearch"];
const _c8$9 = ["headerLeftElementSort"];
const _c9$7 = ["headerLeftElementDateRange"];
const _c10$6 = ["headerLeftElementFilter"];
const _c11$4 = ["headerLeftElementContent1"];
const _c12$3 = ["headerLeftElementContent2"];
const _c13$3 = ["headerLeftElementContent3"];
const _c14$3 = ["headerLeftElementSortAndFilterMinimized"];
const _c15$3 = ["headerLeftElementSortAndFilterMinimizedContent"];
const _c16$3 = ["headerRightElementActionsAndIcons"];
const _c17$2 = ["headerRightElementActionsAndIconsMinimized"];
const _c18$2 = ["floatingExport"];
const _c19$2 = ["headerRightElementIcons"];
const _c20$1 = ["headerRightElementToggle"];
const _c21$1 = ["headerRightElementPickupCount"];
const _c22$1 = ["content1"];
const _c23$1 = ["content2"];
const _c24$1 = ["content3"];
const _c25$1 = ["floating"];
const _c26$1 = ["headerAction"];
function ExListHeaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "div", 14)(2, "div", 15);
    i0.ɵɵelementEnd();
} }
function ExListHeaderComponent_div_5_ex_svg_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 23);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", ctx_r11.fullPageTitleIcon.iconName);
} }
function ExListHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "div", 18)(3, "button", 19);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_5_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onCloseRightSide()); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h2")(8, "button", 21);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_5_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onCloseRightSide()); });
    i0.ɵɵpipe(9, "generateHTMLId");
    i0.ɵɵtemplate(10, ExListHeaderComponent_div_5_ex_svg_icon_10_Template, 1, 1, "ex-svg-icon", 22);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(5, 10, ctx_r2.title()));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 8, ctx_r2.title()));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2._dir === "rtl" ? "fa-angle-right" : "fa-angle-left");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(9, 12, "ex-list-header-back-to-list-button"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.fullPageTitleIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 14, ctx_r2.title()), " ");
} }
function ExListHeaderComponent_div_6_ex_button_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 53);
} }
function ExListHeaderComponent_div_6_ex_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 50);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_6_ex_button_3_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42._refreshClicked()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "i", 51);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_6_ex_button_3_div_3_Template, 1, 0, "div", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind1(1, 5, "ng.general.refresh"))("uniqueSelector", "ex-list-header-refresh-button");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("fa-spin", ctx_r16.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.needToRefresh);
} }
function ExListHeaderComponent_div_6_ex_checkbox_6_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 54);
    i0.ɵɵlistener("checkboxChange", function ExListHeaderComponent_div_6_ex_checkbox_6_Template_ex_checkbox_checkboxChange_0_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.onCheckAllChanged($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("margin-inline-start", ctx_r18.hasRefreshButton ? 0 : 36, "px");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 7, "ng.ex-list-header-check-all"))("ariaLabel", i0.ɵɵpipeBind1(2, 9, "ng.ex-list-header-check-all"))("checked", ctx_r18.selectedOnCurrentPage != 0 && ctx_r18.selectedOnCurrentPage === ctx_r18.pageSize)("indeterminate", ctx_r18.selectedOnCurrentPage > 0 && ctx_r18.selectedOnCurrentPage < ctx_r18.pageSize)("uniqueSelector", "ex-list-header-check-all");
} }
function ExListHeaderComponent_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 55);
} }
function ExListHeaderComponent_div_6_ex_button_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 59);
} }
function ExListHeaderComponent_div_6_ex_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 56);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_6_ex_button_11_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r47.minimizedSearchOpenToggle()); });
    i0.ɵɵelement(1, "ex-svg-icon", 57);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ex_button_11_div_2_Template, 1, 0, "div", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "action")("uniqueSelector", "ex-list-header-search-toolbar-button");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("size", "small");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.hasAppliedSearch);
} }
function ExListHeaderComponent_div_6_ex_extended_search_14_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-extended-search", 60);
    i0.ɵɵlistener("searchTextChange", function ExListHeaderComponent_div_6_ex_extended_search_14_Template_ex_extended_search_searchTextChange_0_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r49.searchText = $event); })("searchTriggered", function ExListHeaderComponent_div_6_ex_extended_search_14_Template_ex_extended_search_searchTriggered_0_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r51._searchChange($event)); })("selectedValueChange", function ExListHeaderComponent_div_6_ex_extended_search_14_Template_ex_extended_search_selectedValueChange_0_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r52 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r52._searchFieldChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("autoFocus", ctx_r22.minimizedSearchOpen)("searchFields", ctx_r22.searchByFields)("selectedSearchField", ctx_r22.searchBySelectedField)("blueOnFocus", true)("searchText", ctx_r22.searchText);
} }
const _c27$1 = function (a0) { return { "rtl": a0 }; };
function ExListHeaderComponent_div_6_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "ex-button", 62);
    i0.ɵɵlistener("keydown.tab", function ExListHeaderComponent_div_6_div_15_Template_ex_button_keydown_tab_1_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r53.minimizedSearchOpenToggle()); })("click", function ExListHeaderComponent_div_6_div_15_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r55.minimizedSearchOpenToggle()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", "link")("uniqueSelector", "ex-list-header-search-searchbar-minimized-close");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.close"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c27$1, ctx_r23._dir == "rtl"));
} }
function ExListHeaderComponent_div_6_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 55);
} }
function ExListHeaderComponent_div_6_ex_floating_component_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-floating-component", 64);
    i0.ɵɵelement(1, "ex-svg-icon", 65);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainer(3, 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r31 = i0.ɵɵreference(28);
    i0.ɵɵproperty("closeFromContent", true)("uniqueSelector", "ex-list-header-sort");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 4, "ng.general.sorts"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r31);
} }
function ExListHeaderComponent_div_6_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 44);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r31 = i0.ɵɵreference(28);
    i0.ɵɵproperty("ngTemplateOutlet", _r31);
} }
function ExListHeaderComponent_div_6_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 67);
} }
function ExListHeaderComponent_div_6_ex_floating_component_22_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 66);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r33 = i0.ɵɵreference(30);
    i0.ɵɵproperty("ngTemplateOutlet", _r33);
} }
const _c28$1 = function (a0) { return { activeFilters: a0 }; };
function ExListHeaderComponent_div_6_ex_floating_component_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-floating-component", 68)(1, "ex-dot-wrapper", 69);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_6_ex_floating_component_22_ng_container_5_Template, 1, 1, "ng-container", 71);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !((ctx_r29.headerResponsivenessConfiguration[ctx_r29.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r29.headerResponsivenessConfiguration[ctx_r29.RESPONSIVENESS_ID_FILTER].order) <= ctx_r29.lastMinimizedElement))("closeFromContent", true)("uniqueSelector", "ex-list-header-filter");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("displayDot", (ctx_r29.activeFilters == null ? null : ctx_r29.activeFilters.length) > 0 && (ctx_r29.filters == null ? null : ctx_r29.filters.length) > 0)("exTooltip", ctx_r29.activeFilters ? i0.ɵɵpipeBind2(2, 6, "ng.general.active-filter", i0.ɵɵpureFunction1(11, _c28$1, ctx_r29.activeFilters)) : i0.ɵɵpipeBind1(3, 9, "ng.general.filters"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r29.headerResponsivenessConfiguration[ctx_r29.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r29.headerResponsivenessConfiguration[ctx_r29.RESPONSIVENESS_ID_FILTER].order) <= ctx_r29.lastMinimizedElement);
} }
function ExListHeaderComponent_div_6_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 44);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r33 = i0.ɵɵreference(30);
    i0.ɵɵproperty("ngTemplateOutlet", _r33);
} }
const _c29$1 = function (a0) { return { "ex-list-header-sort": a0 }; };
function ExListHeaderComponent_div_6_ng_template_27_ex_sort_2_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-sort", 75);
    i0.ɵɵlistener("valueChanged", function ExListHeaderComponent_div_6_ng_template_27_ex_sort_2_Template_ex_sort_valueChanged_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r62); const i_r60 = restoredCtx.index; const ctx_r61 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r61._sortChange($event, i_r60)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sort_r59 = ctx.$implicit;
    const i_r60 = ctx.index;
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c29$1, i_r60 != ctx_r58.sorts.length - 1))("order", sort_r59.order)("sortByOptions", sort_r59.sortByOptions)("hasOrder", sort_r59.hasOrder)("disabled", sort_r59 == null ? null : sort_r59.disabled)("sortBy", sort_r59.selectedOption)("autoComplete", sort_r59.autoComplete)("multiLined", sort_r59.multiLined)("sortByLabel", sort_r59.sortByLabel);
} }
const _c30$1 = function (a0) { return { "header-element-direction-column": a0 }; };
function ExListHeaderComponent_div_6_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 72, 73);
    i0.ɵɵlistener("resized", function ExListHeaderComponent_div_6_ng_template_27_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r63.onSortsResized($event)); });
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ng_template_27_ex_sort_2_Template, 1, 11, "ex-sort", 74);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c30$1, (ctx_r32.headerResponsivenessConfiguration[ctx_r32.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r32.headerResponsivenessConfiguration[ctx_r32.RESPONSIVENESS_ID_SORT].order) <= ctx_r32.lastMinimizedElement));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r32.sorts);
} }
function ExListHeaderComponent_div_6_ng_template_29_ex_filters_2_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-filters", 82);
    i0.ɵɵlistener("selectedValueChange", function ExListHeaderComponent_div_6_ng_template_29_ex_filters_2_Template_ex_filters_selectedValueChange_0_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r69.filterChange.emit($event)); })("defaultFilterChange", function ExListHeaderComponent_div_6_ng_template_29_ex_filters_2_Template_ex_filters_defaultFilterChange_0_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r71 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r71.activeFilters = $event); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ignoreSectionsLayoutViewMode", true)("ngClass", i0.ɵɵpureFunction1(7, _c30$1, (ctx_r66.headerResponsivenessConfiguration[ctx_r66.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r66.headerResponsivenessConfiguration[ctx_r66.RESPONSIVENESS_ID_FILTER].order) <= ctx_r66.lastMinimizedElement))("minimized", (ctx_r66.headerResponsivenessConfiguration[ctx_r66.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r66.headerResponsivenessConfiguration[ctx_r66.RESPONSIVENESS_ID_FILTER].order) <= ctx_r66.lastMinimizedElement)("filters", ctx_r66.filters)("allLabel", i0.ɵɵpipeBind1(1, 5, "ng.filter.all"));
} }
function ExListHeaderComponent_div_6_ng_template_29_ex_date_range_picker_5_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-date-range-picker", 83);
    i0.ɵɵlistener("datesUpdated", function ExListHeaderComponent_div_6_ng_template_29_ex_date_range_picker_5_Template_ex_date_range_picker_datesUpdated_0_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r72._datesUpdated($event)); })("clearDates", function ExListHeaderComponent_div_6_ng_template_29_ex_date_range_picker_5_Template_ex_date_range_picker_clearDates_0_listener() { i0.ɵɵrestoreView(_r73); const ctx_r74 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r74._clearDates()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("blueOnFocus", true)("inListHeader", true)("uniqueSelector", "ex-list-header-date-range-picker")("maxDate", ctx_r68.filterMaxDate)("minDate", ctx_r68.filterMinDate);
} }
function ExListHeaderComponent_div_6_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76, 77);
    i0.ɵɵlistener("resized", function ExListHeaderComponent_div_6_ng_template_29_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r75.onFiltersResized($event)); });
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ng_template_29_ex_filters_2_Template, 2, 9, "ex-filters", 78);
    i0.ɵɵelementStart(3, "div", 79, 80);
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_6_ng_template_29_ex_date_range_picker_5_Template, 1, 5, "ex-date-range-picker", 81);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r34.filters && ctx_r34.filters.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r34.showDateFilter);
} }
function ExListHeaderComponent_div_6_ng_template_31_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 89);
} }
function ExListHeaderComponent_div_6_ng_template_31_Template(rf, ctx) { if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 84, 85);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ng_template_31_div_2_Template, 1, 0, "div", 86);
    i0.ɵɵelementStart(3, "div", 87, 88);
    i0.ɵɵlistener("resized", function ExListHeaderComponent_div_6_ng_template_31_Template_div_resized_3_listener($event) { i0.ɵɵrestoreView(_r81); const ctx_r80 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r80.onContentResized($event, "1")); });
    i0.ɵɵprojection(5, 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r36.hasContent1);
} }
function ExListHeaderComponent_div_6_ng_template_33_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 89);
} }
function ExListHeaderComponent_div_6_ng_template_33_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 84, 90);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ng_template_33_div_2_Template, 1, 0, "div", 86);
    i0.ɵɵelementStart(3, "div", 87, 91);
    i0.ɵɵlistener("resized", function ExListHeaderComponent_div_6_ng_template_33_Template_div_resized_3_listener($event) { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r85.onContentResized($event, "2")); });
    i0.ɵɵprojection(5, 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r38.hasContent2);
} }
function ExListHeaderComponent_div_6_ng_template_35_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 89);
} }
function ExListHeaderComponent_div_6_ng_template_35_Template(rf, ctx) { if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 84, 92);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_6_ng_template_35_div_2_Template, 1, 0, "div", 86);
    i0.ɵɵelementStart(3, "div", 87, 93);
    i0.ɵɵlistener("resized", function ExListHeaderComponent_div_6_ng_template_35_Template_div_resized_3_listener($event) { i0.ɵɵrestoreView(_r91); const ctx_r90 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r90.onContentResized($event, "3")); });
    i0.ɵɵprojection(5, 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.hasContent3);
} }
const _c31$1 = function (a0) { return { "ex-list-header-search-searchbar-minimized-open": a0 }; };
function ExListHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24, 25);
    i0.ɵɵprojection(2);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_6_ex_button_3_Template, 4, 7, "ex-button", 26);
    i0.ɵɵelementStart(4, "div", 27, 28);
    i0.ɵɵtemplate(6, ExListHeaderComponent_div_6_ex_checkbox_6_Template, 3, 11, "ex-checkbox", 29);
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_6_div_7_Template, 1, 0, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 31, 32)(10, "div", 33);
    i0.ɵɵtemplate(11, ExListHeaderComponent_div_6_ex_button_11_Template, 3, 4, "ex-button", 34);
    i0.ɵɵelementStart(12, "div", 35)(13, "div", 36);
    i0.ɵɵtemplate(14, ExListHeaderComponent_div_6_ex_extended_search_14_Template, 1, 5, "ex-extended-search", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ExListHeaderComponent_div_6_div_15_Template, 5, 8, "div", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, ExListHeaderComponent_div_6_div_16_Template, 1, 0, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 39, 40);
    i0.ɵɵtemplate(19, ExListHeaderComponent_div_6_ex_floating_component_19_Template, 4, 6, "ex-floating-component", 41);
    i0.ɵɵtemplate(20, ExListHeaderComponent_div_6_ng_container_20_Template, 1, 1, "ng-container", 10);
    i0.ɵɵtemplate(21, ExListHeaderComponent_div_6_div_21_Template, 1, 0, "div", 42);
    i0.ɵɵtemplate(22, ExListHeaderComponent_div_6_ex_floating_component_22_Template, 6, 13, "ex-floating-component", 43);
    i0.ɵɵtemplate(23, ExListHeaderComponent_div_6_ng_container_23_Template, 1, 1, "ng-container", 10);
    i0.ɵɵelementContainer(24, 44)(25, 44)(26, 44);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, ExListHeaderComponent_div_6_ng_template_27_Template, 3, 4, "ng-template", null, 45, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(29, ExListHeaderComponent_div_6_ng_template_29_Template, 6, 2, "ng-template", null, 46, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(31, ExListHeaderComponent_div_6_ng_template_31_Template, 6, 1, "ng-template", null, 47, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(33, ExListHeaderComponent_div_6_ng_template_33_Template, 6, 1, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(35, ExListHeaderComponent_div_6_ng_template_35_Template, 6, 1, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r35 = i0.ɵɵreference(32);
    const _r37 = i0.ɵɵreference(34);
    const _r39 = i0.ɵɵreference(36);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.hasRefreshButton);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.hasPickup && ctx_r3.hasPickupCount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.hasPickup && (!(ctx_r3.hasSearch && !(ctx_r3.sorts && ctx_r3.sorts.length > 0 && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT].order) <= ctx_r3.lastMinimizedElement)) && !(ctx_r3.showDateFilter && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_DATE_RANGE] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_DATE_RANGE].order) <= ctx_r3.lastMinimizedElement))) || ctx_r3.filters && ctx_r3.filters.length > 0 && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER].order) <= ctx_r3.lastMinimizedElement)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.hasSearch && ((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SEARCH] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SEARCH].order) <= ctx_r3.lastMinimizedElement || ctx_r3.hasMinimizedSearch));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c31$1, ctx_r3.minimizedSearchOpen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.hasSearch && (!((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SEARCH] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SEARCH].order) <= ctx_r3.lastMinimizedElement) && !ctx_r3.hasMinimizedSearch || ctx_r3.minimizedSearchOpen));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.minimizedSearchOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.hasMinimizedSearch && ctx_r3.hasSearch && ctx_r3.hasPickup && (!(!ctx_r3.hasSearch && !(ctx_r3.sorts && ctx_r3.sorts.length > 0 && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT].order) <= ctx_r3.lastMinimizedElement)) && !(ctx_r3.showDateFilter && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_DATE_RANGE] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_DATE_RANGE].order) <= ctx_r3.lastMinimizedElement))) || ctx_r3.filters && ctx_r3.filters.length > 0 && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER].order) <= ctx_r3.lastMinimizedElement)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r3.sorts == null ? null : ctx_r3.sorts.length) > 0 && (ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT].order) <= ctx_r3.lastMinimizedElement);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT].order) <= ctx_r3.lastMinimizedElement) && (ctx_r3.sorts == null ? null : ctx_r3.sorts.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.sorts == null ? null : ctx_r3.sorts.length) > 0 && (ctx_r3.filters && (ctx_r3.filters == null ? null : ctx_r3.filters.length) > 0 || ctx_r3.showDateFilter) && !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_SORT].order) <= ctx_r3.lastMinimizedElement));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.filters && (ctx_r3.filters == null ? null : ctx_r3.filters.length) > 0 || ctx_r3.showDateFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER] == null ? null : ctx_r3.headerResponsivenessConfiguration[ctx_r3.RESPONSIVENESS_ID_FILTER].order) <= ctx_r3.lastMinimizedElement) && (ctx_r3.filters && (ctx_r3.filters == null ? null : ctx_r3.filters.length) > 0 || ctx_r3.showDateFilter));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r35);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r37);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r39);
} }
function ExListHeaderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵelementContainer(1, 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r5.deepLinkModeTemplate);
} }
function ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c32$1 = function () { return { minimizedTemplate: true }; };
function ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 98);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r95 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r95)("ngTemplateOutletContext", i0.ɵɵpureFunction0(2, _c32$1));
} }
function ExListHeaderComponent_div_10_ex_floating_component_3_hr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 112);
} }
function ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 44);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r98 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", _r98);
} }
function ExListHeaderComponent_div_10_ex_floating_component_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-floating-component", 105, 106);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "div", 107);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "i", 108);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 109);
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_7_Template, 2, 3, "ng-container", 101);
    i0.ɵɵtemplate(8, ExListHeaderComponent_div_10_ex_floating_component_3_hr_8_Template, 1, 0, "hr", 110);
    i0.ɵɵelementStart(9, "div", 111);
    i0.ɵɵtemplate(10, ExListHeaderComponent_div_10_ex_floating_component_3_ng_container_10_Template, 1, 1, "ng-container", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("closeFromContent", true)("disabled", false)("uniqueSelector", "ex-list-header-actions-minimized")("menuClass", "ex-list-header-actions-minimized-floating-menu")("ariaLabel", i0.ɵɵpipeBind1(2, 9, "ng.general.list_header.actions"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(4, 11, "ng.general.list_header.actions"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ACTIONS] == null ? null : ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ACTIONS].order) <= ctx_r93.lastMinimizedElement);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ICONS].order) <= ctx_r93.lastMinimizedElement);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r93.headerResponsivenessConfiguration[ctx_r93.RESPONSIVENESS_ID_ICONS].order) <= ctx_r93.lastMinimizedElement);
} }
function ExListHeaderComponent_div_10_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 124);
} if (rf & 2) {
    const minimizedTemplate_r110 = i0.ɵɵnextContext(4).minimizedTemplate;
    const ctx_r122 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", !minimizedTemplate_r110 ? "uxf-down-caret" : ctx_r122._dir == "ltr" ? "uxf-right-caret" : "uxf-left-caret");
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_ex_component_loader_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 125);
} if (rf & 2) {
    const action_r113 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("data", action_r113.action.component.data)("componentFactoryItem", action_r113.action.component)("events", action_r113.action.component.events);
} }
const _c33$1 = function (a0) { return { "ex-list-header-popup-action-hover": a0 }; };
const _c34 = function (a0) { return { "color": a0 }; };
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_Template(rf, ctx) { if (rf & 1) {
    const _r127 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-floating-component", 119, 120);
    i0.ɵɵlistener("menuClosed", function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_Template_ex_floating_component_menuClosed_0_listener() { i0.ɵɵrestoreView(_r127); const ctx_r126 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r126.closeActionsMenu()); })("menuOpen", function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_Template_ex_floating_component_menuOpen_0_listener() { i0.ɵɵrestoreView(_r127); const ctx_r128 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r128.onOpenActionMenu()); })("splitButtonClick", function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_Template_ex_floating_component_splitButtonClick_0_listener() { i0.ɵɵrestoreView(_r127); const action_r113 = i0.ɵɵnextContext(2).$implicit; const ctx_r129 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r129._actionClicked(action_r113.action.value)); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "div", 121);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_i_7_Template, 1, 1, "i", 122);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 109);
    i0.ɵɵtemplate(9, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_ex_component_loader_9_Template, 1, 3, "ex-component-loader", 123);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext(2);
    const action_r113 = ctx_r132.$implicit;
    const i_r114 = ctx_r132.index;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r119 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-list-header-popup-action-minimized", minimizedTemplate_r110);
    i0.ɵɵproperty("openToSide", minimizedTemplate_r110)("disabled", action_r113.action.disabled || ctx_r119.numberOfCheckedItems <= 0 && !action_r113.action.standAlone || !action_r113.action.isDropdownStyle && (action_r113.action.multiLined && ctx_r119.fullPage))("ngClass", i0.ɵɵpureFunction1(21, _c33$1, ctx_r119.numberOfCheckedItems > 0 || action_r113.action.standAlone))("id", action_r113.type + "-" + i_r114)("splitButton", action_r113.action.splitButton)("splitButtonClass", action_r113.action.splitButton ? !minimizedTemplate_r110 ? "uxf-down-caret" : ctx_r119._dir == "ltr" ? "uxf-right-caret" : "uxf-left-caret" : null)("type", action_r113.action.type)("icon", action_r113.action.icon)("tooltip", action_r113.action.tooltip)("ariaLabel", i0.ɵɵpipeBind1(3, 17, action_r113.action.label))("uniqueSelector", action_r113.action.label);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(23, _c34, !minimizedTemplate_r110 && (action_r113.action.standAlone || ctx_r119.numberOfCheckedItems > 0 && !action_r113.action.standAlone) ? "#4164a4" : ctx_r119.numberOfCheckedItems <= 0 && !action_r113.action.standAlone ? "#D7D7D7" : "#000"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 19, action_r113.action.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !action_r113.action.splitButton && action_r113.action.isDropdownStyle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r119.isPopUpMenuOpen);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_ex_floating_component_1_Template, 10, 25, "ex-floating-component", 118);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext();
    const i_r114 = ctx_r134.index;
    const action_r113 = ctx_r134.$implicit;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r116 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !minimizedTemplate_r110 && (i_r114 > ctx_r116.lastMinimizedAction || !action_r113.action.canMinimize) || minimizedTemplate_r110 && (i_r114 <= ctx_r116.lastMinimizedAction && action_r113.action.canMinimize));
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 133);
    i0.ɵɵelement(1, "i", 134);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r113 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", action_r113.action.icon == null ? null : action_r113.action.icon.iconName);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r143 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-button", 131);
    i0.ɵɵlistener("childClicked", function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_container_2_Template_ex_button_childClicked_1_listener($event) { i0.ɵɵrestoreView(_r143); const ctx_r142 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r142._actionClicked($event)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_container_2_div_4_Template, 2, 1, "div", 132);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r113 = i0.ɵɵnextContext(3).$implicit;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r137 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", action_r113.action.disabled || !action_r113.action.standAlone && ctx_r137.numberOfCheckedItems === 0 || action_r113.action.multiLined && ctx_r137.fullPage)("openToSide", minimizedTemplate_r110)("children", action_r113.action.subActions)("iconSide", !minimizedTemplate_r110 && (action_r113.action.icon == null ? null : action_r113.action.icon.iconName) ? "left" : null)("uniqueSelector", "ex-list-header-multiple-actions-" + action_r113.action.label)("hasSearchBox", action_r113.action.hasSearchBox)("unlistedValuesParams", ctx_r137.getUnlistedValuesParams(action_r113.action));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, action_r113.action.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !minimizedTemplate_r110 && (action_r113.action.icon == null ? null : action_r113.action.icon.iconName));
} }
const _c35 = function (a0) { return { "ex-list-header-action-icon-button": a0 }; };
const _c36 = function (a0) { return [a0]; };
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 134);
    i0.ɵɵelement(1, "i", 134);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r113 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c35, action_r113.action.label));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c36, action_r113.action.icon == null ? null : action_r113.action.icon.iconName));
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r150 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 135);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_template_3_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r150); const action_r113 = i0.ɵɵnextContext(3).$implicit; const ctx_r148 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r148._actionClicked(action_r113.action.value)); });
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_template_3_div_1_Template, 2, 6, "div", 136);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(3);
    const last_r115 = ctx_r151.last;
    const action_r113 = ctx_r151.$implicit;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r139 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-list-header-action-button-last", last_r115)("ex-list-header-popup-action-minimized", minimizedTemplate_r110);
    i0.ɵɵproperty("id", action_r113.action.value)("type", action_r113.action.type)("iconSide", !minimizedTemplate_r110 && (action_r113.action.type === "add" || action_r113.action.type === "remove") ? "left" : null)("disabled", action_r113.action.disabled || !action_r113.action.standAlone && ctx_r139.numberOfCheckedItems === 0 || action_r113.action.multiLined && ctx_r139.fullPage)("ngClass", action_r113.action.disabled || !action_r113.action.standAlone && ctx_r139.numberOfCheckedItems === 0 || action_r113.action.multiLined && ctx_r139.fullPage ? "ex-list-header-action-button-disabled" : "ex-list-header-action-button")("loading", action_r113.action.loading)("tooltip", action_r113.action.tooltip)("uniqueSelector", "ex-list-header-single-action-" + action_r113.action.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !minimizedTemplate_r110 && (action_r113.action.icon == null ? null : action_r113.action.icon.iconName));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, action_r113.action.label), " ");
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 127, 128);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_container_2_Template, 5, 11, "ng-container", 129);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_ng_template_3_Template, 4, 16, "ng-template", null, 130, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r138 = i0.ɵɵreference(4);
    const ctx_r153 = i0.ɵɵnextContext(2);
    const action_r113 = ctx_r153.$implicit;
    const i_r114 = ctx_r153.index;
    const ctx_r135 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", action_r113.type + "-" + i_r114);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", action_r113.action.subActions && action_r113.action.subActions.length > 0 || ctx_r135.getUnlistedValuesParams(action_r113.action))("ngIfElse", _r138);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_div_1_Template, 5, 3, "div", 126);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r155 = i0.ɵɵnextContext();
    const i_r114 = ctx_r155.index;
    const action_r113 = ctx_r155.$implicit;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r117 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !minimizedTemplate_r110 && (i_r114 > ctx_r117.lastMinimizedAction || !action_r113.action.canMinimize) || minimizedTemplate_r110 && (i_r114 <= ctx_r117.lastMinimizedAction && action_r113.action.canMinimize));
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 138);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_3_div_1_Template, 1, 0, "div", 137);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r114 = i0.ɵɵnextContext().index;
    const minimizedTemplate_r110 = i0.ɵɵnextContext().minimizedTemplate;
    const ctx_r118 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r114 - 1 > ctx_r118.lastMinimizedAction && !minimizedTemplate_r110);
} }
function ExListHeaderComponent_div_10_ng_template_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 116);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 117);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 117);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 117);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r113 = ctx.$implicit;
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngSwitch", action_r113.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r112.ACTIONS_TYPE_POP_UP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r112.ACTIONS_TYPE_ACTIONS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r112.ACTIONS_TYPE_DUMMY);
} }
const _c37 = function (a0) { return { "header-element-direction-column header-element-actions-minimized": a0 }; };
function ExListHeaderComponent_div_10_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 113, 114);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_10_ng_template_5_ng_container_2_Template, 4, 4, "ng-container", 115);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const minimizedTemplate_r110 = ctx.minimizedTemplate;
    const ctx_r96 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c37, minimizedTemplate_r110 == true));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r96.headerActionsList);
} }
function ExListHeaderComponent_div_10_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 44);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r98 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", _r98);
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 148);
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_ex_button_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ng.general.list_header.export"));
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r169 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 149);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_template_8_div_2_ex_button_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r169); const ctx_r168 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r168._actionClicked(ctx_r168.floatingExport ? "export_all" : "export")); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "i", 150);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_template_8_div_2_ex_button_2_span_3_Template, 3, 3, "span", 101);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r164 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("ex-list-header-action-button-disabled", !ctx_r164.exportEnabled);
    i0.ɵɵproperty("tooltip", ctx_r164.exportEnabled ? "ng.export.tooltip" : "ng.general.export_disabled.tooltip")("ariaLabel", i0.ɵɵpipeBind1(1, 7, "ng.export.tooltip"))("disabled", !ctx_r164.exportEnabled)("uniqueSelector", "ex-list-header-export-icon");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r164.headerResponsivenessConfiguration[ctx_r164.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r164.headerResponsivenessConfiguration[ctx_r164.RESPONSIVENESS_ID_ICONS].order) <= ctx_r164.lastMinimizedElement);
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ng.general.list_header.export"));
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r178 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 158);
    i0.ɵɵelement(1, "ex-svg-icon", 159);
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_ng_template_8_Template_div_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r178); const action_r176 = restoredCtx.action; const ctx_r177 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r177.exportClicked(action_r176)); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const label_r175 = ctx.label;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "exsport-excel")("color", "#4164A4");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, label_r175));
} }
const _c38 = function () { return { label: "ng.general.export_current", action: "export_view" }; };
const _c39 = function () { return { label: "ng.general.export_all", action: "export_all" }; };
function ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-floating-component", 152, 153)(2, "div", 154);
    i0.ɵɵelement(3, "i", 150);
    i0.ɵɵtemplate(4, ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_span_4_Template, 3, 3, "span", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 155);
    i0.ɵɵelementContainer(6, 156)(7, 156);
    i0.ɵɵtemplate(8, ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_ng_template_8_Template, 5, 5, "ng-template", null, 157, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r173 = i0.ɵɵreference(9);
    const ctx_r170 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("tooltip", ctx_r170.exportEnabled ? "ng.general.export_to_excel" : "ng.general.export_disabled.tooltip")("closeFromContent", true)("uniqueSelector", "ex-list-header-floating-export")("disabled", !ctx_r170.exportEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ex-list-header-action-button-disabled", !ctx_r170.exportEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r170.headerResponsivenessConfiguration[ctx_r170.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r170.headerResponsivenessConfiguration[ctx_r170.RESPONSIVENESS_ID_ICONS].order) <= ctx_r170.lastMinimizedElement);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r173)("ngTemplateOutletContext", i0.ɵɵpureFunction0(11, _c38));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r173)("ngTemplateOutletContext", i0.ɵɵpureFunction0(12, _c39));
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_ex_floating_component_0_Template, 10, 13, "ex-floating-component", 151);
} if (rf & 2) {
    const ctx_r166 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r166.floatingExport);
} }
function ExListHeaderComponent_div_10_ng_template_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 144);
    i0.ɵɵtemplate(1, ExListHeaderComponent_div_10_ng_template_8_div_2_div_1_Template, 1, 0, "div", 145);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_10_ng_template_8_div_2_ex_button_2_Template, 4, 9, "ex-button", 146);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_template_8_div_2_ng_template_3_Template, 1, 1, "ng-template", null, 147, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r165 = i0.ɵɵreference(4);
    const ctx_r160 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r160.actions && ctx_r160.actions.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r160.floatingExport || !ctx_r160.hasRecordCustomization)("ngIfElse", _r165);
} }
function ExListHeaderComponent_div_10_ng_template_8_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 160);
    i0.ɵɵelementContainer(1, 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const _r8 = i0.ɵɵreference(13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
} }
function ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 53);
} }
function ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ng.general.customize"));
} }
function ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_Template(rf, ctx) { if (rf & 1) {
    const _r183 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-floating-component", 161, 162);
    i0.ɵɵlistener("menuClosed", function ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_Template_ex_floating_component_menuClosed_0_listener() { i0.ɵɵrestoreView(_r183); const ctx_r182 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r182.closeActionsMenu()); });
    i0.ɵɵelementStart(2, "div", 163)(3, "div", 164);
    i0.ɵɵelement(4, "i", 165);
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_div_5_Template, 1, 0, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_span_6_Template, 3, 3, "span", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 109);
    i0.ɵɵelement(8, "ex-component-loader", 125);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r162 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("openToSide", (ctx_r162.headerResponsivenessConfiguration[ctx_r162.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r162.headerResponsivenessConfiguration[ctx_r162.RESPONSIVENESS_ID_ICONS].order) <= ctx_r162.lastMinimizedElement)("uniqueSelector", "ex-list-header-floating-customization");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r162.isCustomized);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r162.headerResponsivenessConfiguration[ctx_r162.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r162.headerResponsivenessConfiguration[ctx_r162.RESPONSIVENESS_ID_ICONS].order) <= ctx_r162.lastMinimizedElement);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data", ctx_r162.customizationComponentLoader.data)("componentFactoryItem", ctx_r162.customizationComponentLoader)("events", ctx_r162.customizationComponentLoader.events);
} }
const _c40 = function (a0) { return { "header-element-icons-minimized": a0 }; };
function ExListHeaderComponent_div_10_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 139, 140);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_10_ng_template_8_div_2_Template, 5, 3, "div", 141);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_template_8_div_3_Template, 2, 1, "div", 142);
    i0.ɵɵtemplate(4, ExListHeaderComponent_div_10_ng_template_8_ex_floating_component_4_Template, 9, 7, "ex-floating-component", 143);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c40, (ctx_r99.headerResponsivenessConfiguration[ctx_r99.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r99.headerResponsivenessConfiguration[ctx_r99.RESPONSIVENESS_ID_ICONS].order) <= ctx_r99.lastMinimizedElement));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r99.hasExport);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r99.hasCustomization && !ctx_r99.isInSidePane);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r99.customizationComponent);
} }
function ExListHeaderComponent_div_10_ng_container_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r186 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 168);
    i0.ɵɵtext(1, "- ");
    i0.ɵɵelementStart(2, "mat-slider", 169)(3, "input", 170);
    i0.ɵɵlistener("ngModelChange", function ExListHeaderComponent_div_10_ng_container_10_div_3_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r186); const ctx_r185 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r185.gallerySlider = $event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(4, "+ ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r184 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("hide-slider", ctx_r184.itemsLayoutType !== "gallery");
    i0.ɵɵproperty("max", 400)("min", 150)("step", 1)("disableRipple", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r184.gallerySlider);
} }
function ExListHeaderComponent_div_10_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r188 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-button", 166);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_container_10_Template_ex_button_click_1_listener($event) { i0.ɵɵrestoreView(_r188); const ctx_r187 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r187.itemsLayoutTypeToggled.emit($event)); });
    i0.ɵɵelement(2, "ex-svg-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ng_container_10_div_3_Template, 5, 7, "div", 167);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tooltip", ctx_r100.itemsLayoutType == "list" ? "ng.items_layout.type.switch_to_table" : "ng.items_layout.type.switch_to_record")("ariaLabel", ctx_r100.itemsLayoutType == "list" ? "ng.items_layout.type.switch_to_table" : "ng.items_layout.type.switch_to_record")("uniqueSelector", "ex-list-header-layout-type-toggle")("uniqueSelectorState", ctx_r100.itemsLayoutType == "list" ? "record-layout" : "table-layout");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", ctx_r100.itemsLayoutType == "list" ? "table_view" : "record_view");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r100.galleryLayoutEnabled && ctx_r100.itemsLayoutType == "gallery");
} }
function ExListHeaderComponent_div_10_ex_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r190 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 166);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ex_button_11_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r190); const ctx_r189 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r189.itemsLayoutTypeToggled.emit("gallery")); });
    i0.ɵɵelement(1, "ex-svg-icon", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltip", "ng.items_layout.type.switch_to_gallery")("ariaLabel", "ng.items_layout.type.switch_to_gallery")("uniqueSelector", "ex-list-header-layout-type-toggle-gallery")("uniqueSelectorState", "gallery");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "grid");
} }
const _c41 = function (a0) { return { icon: a0 }; };
function ExListHeaderComponent_div_10_ng_container_12_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 156);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r103 = i0.ɵɵreference(14);
    const ctx_r192 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r103)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c41, ctx_r192.responsiveIcon));
} }
function ExListHeaderComponent_div_10_ng_container_12_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 156);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r103 = i0.ɵɵreference(14);
    const ctx_r193 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r103)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c41, ctx_r193.notResponsiveIcon));
} }
function ExListHeaderComponent_div_10_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r195 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 171, 172);
    i0.ɵɵelementStart(2, "ex-button", 173);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_container_12_Template_ex_button_click_2_listener($event) { i0.ɵɵrestoreView(_r195); const ctx_r194 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r194.onChangeView($event)); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "ex-svg-icon", 174);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExListHeaderComponent_div_10_ng_container_12_ng_container_6_Template, 1, 4, "ng-container", 175);
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_10_ng_container_12_ng_container_7_Template, 1, 4, "ng-container", 175);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r102.isWideScreen && ctx_r102.responsive)("exTooltip", i0.ɵɵpipeBind1(3, 9, !ctx_r102.isWideScreen && ctx_r102.responsive ? ctx_r102.isInSidePane ? "ng.general.split_screen_sidepane" : "ng.general.split_screen_responsive" : ctx_r102.viewMode == "SPLIT" ? "ng.general.split_screen_icon_split" : "ng.general.split_screen_icon_list"))("uniqueSelector", "ex-list-header-view-mode-toggle")("uniqueSelectorState", !(!ctx_r102.isWideScreen && ctx_r102.responsive) ? ctx_r102.viewMode == "SPLIT" ? "view-mode-split" : "view-mode-list" : null)("ariaLabel", i0.ɵɵpipeBind1(4, 11, !ctx_r102.isWideScreen && ctx_r102.responsive ? ctx_r102.isInSidePane ? "ng.general.split_screen_sidepane" : "ng.general.split_screen_responsive" : ctx_r102.viewMode == "SPLIT" ? "ng.general.split_screen_icon_split" : "ng.general.split_screen_icon_list"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconName", ctx_r102.viewMode == "SPLIT" ? "onlyList" : "mediumList")("color", !ctx_r102.isWideScreen && ctx_r102.responsive ? "gray" : "#4164A4");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r102.isWideScreen && ctx_r102.responsive);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r102.isWideScreen && !ctx_r102.responsive);
} }
function ExListHeaderComponent_div_10_ng_template_13_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r200 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-link", 179);
    i0.ɵɵlistener("linkClicked", function ExListHeaderComponent_div_10_ng_template_13_ng_container_6_Template_ex_link_linkClicked_1_listener() { i0.ɵɵrestoreView(_r200); const ctx_r199 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r199.onHelpLinkClick()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-list-header-help-icon");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "userMenu.label.UIPreferences"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "ng.general.in-user-menu"), "");
} }
function ExListHeaderComponent_div_10_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-help-icon", 176, 177);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_10_ng_template_13_Template_ex_help_icon_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementContainerStart(2, 178);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExListHeaderComponent_div_10_ng_template_13_ng_container_6_Template, 7, 7, "ng-container", 101);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r196 = ctx.icon;
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("contentWidth", "300px")("icon", icon_r196 == null ? null : icon_r196.icon);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 4, icon_r196 == null ? null : icon_r196.description), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r104.isInSidePane);
} }
const _c42 = function () { return { minimizedTemplate: false }; };
function ExListHeaderComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94)(1, "div", 95, 96);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_10_ex_floating_component_3_Template, 11, 13, "ex-floating-component", 97);
    i0.ɵɵtemplate(4, ExListHeaderComponent_div_10_ng_container_4_Template, 1, 0, "ng-container", 98);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_10_ng_template_5_Template, 3, 4, "ng-template", null, 99, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_10_ng_container_7_Template, 1, 1, "ng-container", 10);
    i0.ɵɵtemplate(8, ExListHeaderComponent_div_10_ng_template_8_Template, 5, 6, "ng-template", null, 100, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(10, ExListHeaderComponent_div_10_ng_container_10_Template, 4, 6, "ng-container", 101);
    i0.ɵɵtemplate(11, ExListHeaderComponent_div_10_ex_button_11_Template, 2, 5, "ex-button", 102);
    i0.ɵɵtemplate(12, ExListHeaderComponent_div_10_ng_container_12_Template, 8, 13, "ng-container", 103);
    i0.ɵɵtemplate(13, ExListHeaderComponent_div_10_ng_template_13_Template, 7, 6, "ng-template", null, 104, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r95 = i0.ɵɵreference(6);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ACTIONS] == null ? null : ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ACTIONS].order) <= ctx_r6.lastMinimizedElement && (ctx_r6.headerActionsList == null ? null : ctx_r6.headerActionsList.length) > 0 && ctx_r6.minimizableActionExists || (ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ICONS].order) <= ctx_r6.lastMinimizedElement && (ctx_r6.hasExport || ctx_r6.hasCustomization || ctx_r6.customizationComponent));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r95)("ngTemplateOutletContext", i0.ɵɵpureFunction0(7, _c42));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !((ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r6.headerResponsivenessConfiguration[ctx_r6.RESPONSIVENESS_ID_ICONS].order) <= ctx_r6.lastMinimizedElement));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.showItemsLayoutTypeToggle || ctx_r6.itemsLayoutType == "gallery");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.galleryLayoutEnabled && ctx_r6.itemsLayoutType !== "gallery");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.hasToggle && ctx_r6.showToggle && !ctx_r6.fullPage);
} }
function ExListHeaderComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 44);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
} }
function ExListHeaderComponent_ng_template_12_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 53);
} }
function ExListHeaderComponent_ng_template_12_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ng.general.customize"));
} }
const _c43 = function (a0) { return { "ex-list-customization-button-full-page": a0 }; };
function ExListHeaderComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r205 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 180);
    i0.ɵɵlistener("click", function ExListHeaderComponent_ng_template_12_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r205); const ctx_r204 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r204._customizationClicked()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "div", 164);
    i0.ɵɵelement(3, "i", 165);
    i0.ɵɵtemplate(4, ExListHeaderComponent_ng_template_12_div_4_Template, 1, 0, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExListHeaderComponent_ng_template_12_span_5_Template, 3, 3, "span", 101);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltip", i0.ɵɵpipeBind1(1, 5, "ng.general.customize"))("ngClass", i0.ɵɵpureFunction1(7, _c43, ctx_r9.fullPage))("uniqueSelector", "ex-list-header-customization-button");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r9.isCustomized);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.fullPage && (ctx_r9.headerResponsivenessConfiguration[ctx_r9.RESPONSIVENESS_ID_ICONS] == null ? null : ctx_r9.headerResponsivenessConfiguration[ctx_r9.RESPONSIVENESS_ID_ICONS].order) <= ctx_r9.lastMinimizedElement);
} }
const _c44 = function (a1) { return { message: "ng.general.success-tooltip", num: a1 }; };
const _c45 = function (a1, a4) { return { filter: "succeeded", label: a1, iconName: "success", iconColor: "#60c05f", tooltip: a4 }; };
function ExListHeaderComponent_div_14_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 156);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r208 = i0.ɵɵreference(4);
    const ctx_r213 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r208)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c45, i0.ɵɵpipeBind1(1, 2, "ng.general.success") + " (" + ctx_r213.succeededSum + ")", i0.ɵɵpureFunction1(4, _c44, ctx_r213.succeededSum)));
} }
const _c46 = function (a1) { return { message: "ng.general.warning-tooltip", num: a1 }; };
const _c47 = function (a1, a4) { return { filter: "warnings", label: a1, iconName: "warning", iconColor: "#e7a141", tooltip: a4 }; };
function ExListHeaderComponent_div_14_div_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 156);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r208 = i0.ɵɵreference(4);
    const ctx_r214 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r208)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c47, i0.ɵɵpipeBind1(1, 2, "ng.general.warning") + " (" + ctx_r214.warningsSum + ")", i0.ɵɵpureFunction1(4, _c46, ctx_r214.warningsSum)));
} }
const _c48 = function (a1) { return { message: "ng.general.fail-tooltip", num: a1 }; };
const _c49 = function (a1, a4) { return { filter: "failed", label: a1, iconName: "circ_warning", iconColor: "#e54746", tooltip: a4 }; };
function ExListHeaderComponent_div_14_div_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 156);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r208 = i0.ɵɵreference(4);
    const ctx_r215 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r208)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c49, i0.ɵɵpipeBind1(1, 2, "ng.general.failure") + " (" + ctx_r215.failedSum + ")", i0.ɵɵpureFunction1(4, _c48, ctx_r215.failedSum)));
} }
const _c50 = function (a1) { return { filter: "all", label: a1 }; };
function ExListHeaderComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 187);
    i0.ɵɵelementContainer(1, 156);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_14_div_2_ng_container_3_Template, 2, 9, "ng-container", 175);
    i0.ɵɵtemplate(4, ExListHeaderComponent_div_14_div_2_ng_container_4_Template, 2, 9, "ng-container", 175);
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_14_div_2_ng_container_5_Template, 2, 9, "ng-container", 175);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r208 = i0.ɵɵreference(4);
    const ctx_r207 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r208)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c50, i0.ɵɵpipeBind1(2, 5, "ng.general.all_results")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r207.succeededSum > 0 && ctx_r207.showSuccessItemsFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r207.warningsSum > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r207.failedSum > 0);
} }
function ExListHeaderComponent_div_14_ng_template_3_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 191);
} if (rf & 2) {
    const ctx_r222 = i0.ɵɵnextContext();
    const iconColor_r219 = ctx_r222.iconColor;
    const iconName_r218 = ctx_r222.iconName;
    i0.ɵɵproperty("color", iconColor_r219)("iconName", iconName_r218);
} }
const _c51 = function (a0, a1) { return { num: a0, total: a1 }; };
function ExListHeaderComponent_div_14_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r224 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 188);
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_14_ng_template_3_ex_svg_icon_3_Template, 1, 2, "ex-svg-icon", 189);
    i0.ɵɵelementStart(4, "span", 190);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_14_ng_template_3_Template_span_click_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r224); const filter_r216 = restoredCtx.filter; const ctx_r223 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r223.bulkActionsFilterChanged(filter_r216)); })("keydown.enter", function ExListHeaderComponent_div_14_ng_template_3_Template_span_keydown_enter_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r224); const filter_r216 = restoredCtx.filter; const ctx_r225 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r225.bulkActionsFilterChanged(filter_r216)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const filter_r216 = ctx.filter;
    const label_r217 = ctx.label;
    const iconName_r218 = ctx.iconName;
    const tooltip_r220 = ctx.tooltip;
    const ctx_r209 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ex-list-header-status-filter-wrapper ", i0.ɵɵpipeBind1(1, 11, "ex-list-header-status-filter-" + filter_r216), "");
    i0.ɵɵclassProp("ex-list-header-status-filter-wrapper-selected", ctx_r209.selectesStatusFilter == filter_r216);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind2(2, 13, tooltip_r220 == null ? null : tooltip_r220.message, i0.ɵɵpureFunction2(16, _c51, tooltip_r220 == null ? null : tooltip_r220.num, ctx_r209.checkedSum)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", iconName_r218);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-list-header-status-filter-selected", ctx_r209.selectesStatusFilter == filter_r216);
    i0.ɵɵattribute("aria-label", label_r217);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", label_r217, "");
} }
function ExListHeaderComponent_div_14_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 192);
} }
function ExListHeaderComponent_div_14_ng_container_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 194);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "ng.list.header.single_row_selected"), " ");
} }
function ExListHeaderComponent_div_14_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 194)(2, "span", 195);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r227 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r227.numberOfCheckedItems);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "ng.list.header.rows_selected"), " ");
} }
const _c52 = function (a0) { return { "ex-list-header-selected-rows-count-background": a0 }; };
function ExListHeaderComponent_div_14_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 193);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_14_ng_container_6_ng_container_2_Template, 4, 3, "ng-container", 101);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_14_ng_container_6_ng_container_3_Template, 6, 4, "ng-container", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r211 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-list-header-selected-rows-count-wrapper-with-filters", ctx_r211.showFilters);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c52, ctx_r211.numberOfCheckedItems > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r211.numberOfCheckedItems === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r211.numberOfCheckedItems > 1);
} }
function ExListHeaderComponent_div_14_ex_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r229 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 196);
    i0.ɵɵlistener("click", function ExListHeaderComponent_div_14_ex_button_7_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r229); const ctx_r228 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r228.onClearAll()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("uniqueSelector", "ex-list-header-clear-selection");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "ng.list.header.clear_selection"), "");
} }
function ExListHeaderComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 181, 182);
    i0.ɵɵtemplate(2, ExListHeaderComponent_div_14_div_2_Template, 6, 9, "div", 183);
    i0.ɵɵtemplate(3, ExListHeaderComponent_div_14_ng_template_3_Template, 6, 19, "ng-template", null, 184, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ExListHeaderComponent_div_14_div_5_Template, 1, 0, "div", 185);
    i0.ɵɵtemplate(6, ExListHeaderComponent_div_14_ng_container_6_Template, 4, 7, "ng-container", 101);
    i0.ɵɵtemplate(7, ExListHeaderComponent_div_14_ex_button_7_Template, 3, 4, "ex-button", 186);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r10.showFilters);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.showFilters && (ctx_r10.hasPickupCount && ctx_r10.numberOfCheckedItems > 0) && !ctx_r10.fullPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.hasPickupCount && ctx_r10.numberOfCheckedItems > 0 && !ctx_r10.fullPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.hasPickupCount && ctx_r10.numberOfCheckedItems > 0 && !ctx_r10.fullPage);
} }
const _c53 = [[["", "header-slot-0", ""]], [["", "header-slot-1", ""]], [["", "header-slot-2", ""]], [["", "header-slot-3", ""]]];
const _c54 = function (a0, a1) { return { "ex-list-header-border-bottom": a0, "ex-list-header-ex-list-layout-header-wrapper-overflow": a1 }; };
const _c55 = function (a0) { return { "ex-list-header-ex-list-layout-header-wrap": a0 }; };
const _c56 = ["[header-slot-0]", "[header-slot-1]", "[header-slot-2]", "[header-slot-3]"];
class ExListHeaderComponent {
    get selectedOnCurrentPage() {
        return this._selectedOnCurrentPage;
    }
    ;
    set selectedOnCurrentPage(value) {
        this._selectedOnCurrentPage = value;
        this.selectedOnCurrentPageChange.emit(value);
    }
    ;
    constructor(overlay, viewContainerRef, isInSidePane, location, ngZone, router, renderer, cdr, sectionsLayoutService, dialogService, bulkActionsIndicationService) {
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.isInSidePane = isInSidePane;
        this.location = location;
        this.ngZone = ngZone;
        this.router = router;
        this.renderer = renderer;
        this.cdr = cdr;
        this.sectionsLayoutService = sectionsLayoutService;
        this.dialogService = dialogService;
        this.bulkActionsIndicationService = bulkActionsIndicationService;
        this.actions = [];
        this.bulkActions = [];
        this.comboboxLists = [];
        this.popUpActions = [];
        this.hasSearch = false;
        this.isItemOpen = false;
        this.hasToggle = false;
        this.hasFileToggle = false;
        this.showToggle = true;
        this.hasExport = true;
        this.hasBottomBorder = true;
        this.numberOfCheckedItems = 0;
        this.numOfPageCheckedItems = 0;
        this.hasPickup = false;
        this.hasPickupCount = false;
        this.hasCustomization = false;
        this.hasRecordCustomization = false;
        /**
         * Whether the header elements will be minimized when the header is not wide enough to display them all
         */
        this.responsivenessActive = false;
        this.needToRefresh = false;
        this.isLoading = false;
        this.hasRefreshButton = false;
        this.deepLinkMode = false;
        this.hasMinimizedSearch = false;
        /**
         * the view of open items of the list - split or full page
         */
        this.viewMode = ViewModes.SPLIT;
        this.fullPage = false;
        this.showItemsLayoutTypeToggle = false;
        this.itemsLayoutTypeToggled = new EventEmitter();
        /**
         * Whether the split screen view will be disabled in small screens.
         */
        this.responsive = true;
        this.floatingExport = false;
        this.exportEnabled = true;
        this.toggleisItemOpen = new EventEmitter();
        this.toggleisItemOpenSized = new EventEmitter();
        this.sortChange = new EventEmitter();
        this.actionClicked = new EventEmitter();
        this.comboboxItemClicked = new EventEmitter();
        this.popupClosed = new EventEmitter();
        this.searchChange = new EventEmitter();
        this.filterChange = new EventEmitter();
        this.clearPageCheckedItems = new EventEmitter();
        this.clearCheckedItems = new EventEmitter();
        this.checkAllItems = new EventEmitter();
        this.selectedValueChange = new EventEmitter();
        this.customizationClicked = new EventEmitter();
        this.selectedOnCurrentPageChange = new EventEmitter();
        /**
         * Fires when user changes the split view
         */
        this.viewModeChange = new EventEmitter();
        /**
         * Fires when user clicks on help link to disable responsiveness
         */
        this.openUserResponsiveMenu = new EventEmitter();
        this.datesUpdated = new EventEmitter();
        this.clearDates = new EventEmitter();
        this.showDateFilter = false;
        this.searchText = '';
        this.closeRightSideClicked = new EventEmitter();
        this.refreshClicked = new EventEmitter();
        /**
         *
         * Key should be the same as the value of the corresponding RESPONSIVENESS_ID_<name> constant
         * Minimization order performed by 'order' value
         * elemRefVarName is the name of the corresponding ElementRef property
         */
        this.headerResponsivenessConfiguration = {
            'actions': { order: 0, elemRefVarName: 'headerElementActions' },
            'content1': { order: 1, elemRefVarName: 'headerElementContent1' },
            'content2': { order: 2, elemRefVarName: 'headerElementContent2' },
            'content3': { order: 3, elemRefVarName: 'headerElementContent3' },
            'filter': { order: 4, elemRefVarName: 'headerElementFilter' },
            'dateRange': { order: 5, elemRefVarName: 'headerElementDateRange' },
            'sort': { order: 6, elemRefVarName: 'headerElementSort' },
            'search': { order: 7, elemRefVarName: 'headerElementSearch' },
            'icons': { order: 8, elemRefVarName: 'headerElementIcons' }
        };
        this.headerResponsivenessProperties = [];
        this.headerResponsivenessActionsProperties = [];
        this.headerActionsList = [];
        this.headerResponsivenessPropertiesSet = false;
        this.HEADER_DISTANCE_MIN = 20;
        this.RESPONSIVENESS_ID_ACTIONS = 'actions';
        this.RESPONSIVENESS_ID_CONTENT_1 = 'content1';
        this.RESPONSIVENESS_ID_CONTENT_2 = 'content2';
        this.RESPONSIVENESS_ID_CONTENT_3 = 'content3';
        this.RESPONSIVENESS_ID_FILTER = 'filter';
        this.RESPONSIVENESS_ID_DATE_RANGE = 'dateRange';
        this.RESPONSIVENESS_ID_SORT = 'sort';
        this.RESPONSIVENESS_ID_SEARCH = 'search';
        this.RESPONSIVENESS_ID_ICONS = 'icons';
        this.ACTIONS_TYPE_ACTIONS = 'actions_action';
        this.ACTIONS_TYPE_POP_UP = 'pop_up_action';
        this.ACTIONS_TYPE_COMBOBOX = 'combobox_action';
        this.ACTIONS_TYPE_DUMMY = 'dummy_pipe';
        this.NUMBER_COMPARISON_TOLERANCE = 0.000061;
        this.SIZE_CHANGE_TOLERANCE = 3;
        this.resizedSubject$ = new Subject();
        this.lastMinimizedElement = -1;
        this.lastMinimizedAction = -1;
        this.minimizableActionExists = false;
        this.hasContent1 = false;
        this.hasContent2 = false;
        this.hasContent3 = false;
        this.headerAllHeight = 54;
        this.responsiveIcon = { icon: { iconName: 'info', iconColor: '#4164a4' }, description: this.isInSidePane ? 'ng.general.split_screen_sidepane' : 'ng.general.split-screen-disabled-help' };
        this.notResponsiveIcon = { icon: { iconName: 'alert', iconColor: '#D6801D' }, description: 'ng.general.split-screen-enabled-help' };
        this.hasAppliedSearch = false;
        /**
         * bulk action indication filters params
         */
        this.succeededSum = 0;
        this.failedSum = 0;
        this.warningsSum = 0;
        this.checkedSum = 0;
        this.showFilters = false;
        this.showSuccessItemsFilter = true;
        this.selectesStatusFilter = 'all';
        this.activeFilters = '';
        this.exlistheaderheightCssVar = 'auto';
        this.exFitlerMaxWidthCssVar = 'unset';
        this.exSortMaxWidthCssVar = 'unset';
        this.minimizedSearchOpen = false;
        // triggers the destruction of the popup component every time the menu is closed
        this.isPopUpMenuOpen = false;
        this.calculatingResponsiveness = false;
        this.checkAll = false;
        this.isToggleOptionsOpen = false;
        this._selectedOnCurrentPage = 0;
        this._dir = "ltr";
        this.gallerySliderChange = new EventEmitter();
    }
    get gallerySlider() {
        return this._gallerySlider;
    }
    set gallerySlider(value) {
        this._gallerySlider = value;
        this.gallerySliderChange.emit(value);
    }
    ngOnInit() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
        this.initHeaderResponsivenessConfig();
        this.initHeaderResponsivenessProperties();
        this.initActionsList();
        if (this.hasBottomBorder === undefined) {
            this.hasBottomBorder = true;
        }
        if (this.popUpActions) {
            this.popUpActions.forEach(action => {
                (action.data.events || {})['closePopup'] = this.closePopup.bind(this, action);
                // send popUp output via actionClicked
                (action.data.events || {})['actionClicked'] = this._actionClicked.bind(this);
                action.component = new ExComponentFactoryItem(action.data.component, action.data.inputs, action.data.events);
            });
        }
        if (this.searchByFields && this.searchByFields.length > 0 && !this.searchBySelectedField) {
            this.searchBySelectedField = this.searchByFields[0].key;
        }
        if (this.clearAllSubject) {
            this.clearAllSubject.subscribe(() => {
                this.onClearAll();
            });
        }
        this.bulkActionsIndicationService.showFilters$.subscribe(data => {
            this.showSuccessItemsFilter = this.bulkActionsIndicationService.showSuccessItemsFilter;
            this.succeededSum = this.bulkActionsIndicationService.isStandAlone ? this.bulkActionsIndicationService.successItemsLength : this.bulkActionsIndicationService.successItems?.length;
            this.warningsSum = this.bulkActionsIndicationService.warningItems?.length;
            this.failedSum = this.bulkActionsIndicationService.failedItems?.length;
            this.checkedSum = this.bulkActionsIndicationService.isStandAlone ? (this.succeededSum + this.failedSum + this.warningsSum) : this.bulkActionsIndicationService.tempCheckedItems?.length;
            this.showFilters = data && (this.bulkActionsIndicationService.showSuccessItemsFilter || this.warningsSum > 0 || this.failedSum > 0);
        });
        this.bulkActionsIndicationService.selectedFilter$.subscribe(data => {
            this.selectesStatusFilter = data;
        });
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('customizationComponent')) {
            if (changes.customizationComponent.currentValue) {
                this.customizationComponent.events.closePopup = () => {
                    this.floatingCustomization.close();
                };
                this.customizationComponent.events = { ...this.customizationComponent.events };
                this.customizationComponentLoader = new ExComponentFactoryItem(this.customizationComponent.component, this.customizationComponent.inputs, this.customizationComponent.events);
            }
        }
        if (changes.hasOwnProperty('popUpActions')) {
            this.popUpActions.forEach(action => {
                (action.data.events || {})['closePopup'] = this.closePopup.bind(this, action);
                (action.data.events || {})['actionClicked'] = this._actionClicked.bind(this);
                action.component = new ExComponentFactoryItem(action.data.component, action.data.inputs, action.data.events);
            });
        }
        if (changes.hasOwnProperty('isItemOpen')) {
            if (this.fullPage && !this.deepLinkMode) {
                this.location.go(this.router.url);
            }
            if (this.fullPage && (changes.isItemOpen.currentValue == false && changes.isItemOpen.previousValue == true)) {
                this.onResized(undefined);
            }
            if ((changes.isItemOpen.currentValue == true && changes.isItemOpen.previousValue == false)) {
                this.onResized(undefined);
            }
            if (changes.hasOwnProperty('fullPage')) {
                this.onResized(undefined);
            }
        }
        if ((changes.hasOwnProperty('popUpActions') && !changes.popUpActions.firstChange) ||
            (changes.hasOwnProperty('actions') && !changes.actions.firstChange) ||
            (changes.hasOwnProperty('bulkActions') && !changes.bulkActions.firstChange) ||
            (changes.hasOwnProperty('comboboxLists') && !changes.comboboxLists.firstChange)) {
            this.initActionsList();
            if (this.responsivenessActive) {
                this.onResized(null);
            }
        }
        if ((changes.hasOwnProperty('sorts') && !changes.sorts.firstChange) ||
            (changes.hasOwnProperty('filters') && !changes.filters.firstChange) ||
            (changes.hasOwnProperty('hasSearch') && !changes.hasSearch.firstChange) ||
            (changes.hasOwnProperty('showDateFilter') && !changes.showDateFilter.firstChange)) {
            if (this.responsivenessActive) {
                this.onResized(null);
            }
        }
        if (changes.hasOwnProperty('searchText')) {
            this.hasAppliedSearch = this.searchText !== undefined && this.searchText !== '';
        }
    }
    ngAfterViewInit() {
        if (this.responsivenessActive) {
            this.calculatingResponsiveness = true;
            this.renderer.setStyle(this.headerAll.nativeElement, 'width', 'max-content');
            this.resizedObservableSubscription$ = this.resizedSubject$.pipe(debounceTime(200)).subscribe(event => {
                this.ngZone.run(() => {
                    this.removeDropdownMaxWidthCss();
                    // if not set, set headerResponsivenessProperties
                    if (!this.headerResponsivenessPropertiesSet) {
                        this.setHeaderResponsivenessProperties();
                    }
                    // determine if has ng-content
                    this.checkHasContent();
                    this.minimizeMaximizeHeader();
                });
            });
        }
    }
    ngOnDestroy() {
        this.resizedObservableSubscription$?.unsubscribe();
    }
    initHeaderResponsivenessConfig() {
        if (this.headerResponsivenessOrderConfig) {
            for (const [key, value] of Object.entries(this.headerResponsivenessOrderConfig)) {
                this.headerResponsivenessConfiguration[key].order = value;
            }
        }
    }
    initHeaderResponsivenessProperties() {
        this.headerResponsivenessPropertiesSet = false;
        for (const [key, value] of Object.entries(this.headerResponsivenessConfiguration)) {
            this.headerResponsivenessProperties.push({ id: key, order: value.order, width: 0, elemRef: undefined });
        }
        this.headerResponsivenessProperties.sort((a, b) => {
            return a.order - b.order;
        });
    }
    initActionsList() {
        this.headerResponsivenessPropertiesSet = false;
        this.headerActionsList = [];
        this.headerResponsivenessActionsProperties = [];
        this.popUpActions.forEach((action) => {
            this.headerActionsList.push({ type: this.ACTIONS_TYPE_POP_UP, action: action });
        });
        this.actions.forEach((action) => {
            this.headerActionsList.push({ type: this.ACTIONS_TYPE_ACTIONS, action: action });
        });
        this.bulkActions?.forEach((action) => {
            this.headerActionsList.push({ type: this.ACTIONS_TYPE_ACTIONS, action: action });
        });
        this.headerActionsList.sort((a, b) => {
            return a.action.order - b.action.order;
        });
        this.headerActionsList.sort((a, b) => {
            const aStandAlone = !!a.action?.standAlone;
            const bStandAlone = !!b.action?.standAlone;
            if (aStandAlone === bStandAlone)
                return 0;
            return aStandAlone ? 1 : -1;
        });
        let dummyIndex = this.headerActionsList.findIndex(({ action }) => action.standAlone);
        dummyIndex > 0 && this.headerActionsList.splice(dummyIndex, 0, { type: this.ACTIONS_TYPE_DUMMY, action: undefined });
        this.headerActionsList.forEach((action, index) => {
            this.headerResponsivenessActionsProperties.push({ id: action.type + '-' + index, canMinimize: action.action?.canMinimize, width: 0, elemRef: undefined });
        });
    }
    setHeaderResponsivenessProperties() {
        // reset minimization
        this.lastMinimizedElement = -1;
        this.lastMinimizedAction = -1;
        try {
            this.cdr.detectChanges();
        }
        catch (e) {
            console.error(e);
        }
        // if initial header width cannot accomodate all elements in proper width, the element widths will not be correct
        // set width to max-content to get full width of elements, then return to regular style
        this.renderer.setStyle(this.headerAll.nativeElement, 'width', 'max-content');
        this.setHeaderHeight();
        // set elemRef and width of each header element
        this.headerResponsivenessProperties.forEach(elem => {
            elem.elemRef = this[this.headerResponsivenessConfiguration[elem.id]?.elemRefVarName];
            elem.width = this.elementBounds(elem.elemRef?.nativeElement).width || 0;
        });
        // set elemRef and width of each action
        this.headerResponsivenessActionsProperties.forEach(action => {
            if (action.canMinimize) {
                this.minimizableActionExists = true;
            }
            action.elemRef = this.actionElements.find(actionElem => {
                return actionElem.nativeElement.id === action.id;
            });
            action.width = this.elementBounds(action.elemRef?.nativeElement).width || 0;
        });
        this.headerResponsivenessPropertiesSet = true;
        this.renderer.removeStyle(this.headerAll.nativeElement, 'width');
    }
    setHeaderHeight() {
        this.headerAllHeight = this.headerBounds().headerAllHeight;
        let headerHeight = this.headerAllHeight ? this.headerAllHeight + 'px' : 'auto';
        this.exlistheaderheightCssVar = headerHeight;
    }
    checkHasContent() {
        this.checkHasContentSlot("1");
        this.checkHasContentSlot("2");
        this.checkHasContentSlot("3");
    }
    checkHasContentSlot(slot) {
        let slotAttrId = "hasContent" + slot;
        let elemRef;
        switch (slot) {
            case "1": {
                elemRef = this.headerContent1Element;
                break;
            }
            case "2": {
                elemRef = this.headerContent2Element;
                break;
            }
            case "3": {
                elemRef = this.headerContent3Element;
                break;
            }
            default: {
                elemRef = undefined;
            }
        }
        if (elemRef) {
            if (elemRef.nativeElement.children.length > 0) {
                this[slotAttrId] = true;
            }
            else {
                this[slotAttrId] = false;
            }
        }
        else {
            this[slotAttrId] = false;
        }
    }
    minimizeMaximizeHeader() {
        let spaceBetween = this.headerBounds().spaceBetween;
        if (spaceBetween <= this.HEADER_DISTANCE_MIN) { // minimize
            while (this.lastMinimizedElement < this.headerResponsivenessProperties.length - 1 && spaceBetween <= this.HEADER_DISTANCE_MIN) {
                if (this.lastMinimizedElement < 0 || this.headerResponsivenessProperties[this.lastMinimizedElement]?.id != this.RESPONSIVENESS_ID_ACTIONS) {
                    this.lastMinimizedElement++;
                }
                if (this.headerResponsivenessProperties[this.lastMinimizedElement]?.id == this.RESPONSIVENESS_ID_ACTIONS) {
                    this.minimizeAction();
                }
                try {
                    this.cdr.detectChanges();
                }
                catch (e) {
                    console.error(e);
                }
                spaceBetween = this.headerBounds().spaceBetween;
            }
            this.ngZone.run(() => {
                this.calculatingResponsiveness = false;
                this.cdr.markForCheck();
            });
        }
        else { // maximize
            if (this.lastMinimizedElement >= 0) {
                let calculatedWidths = this.calcElemWidthsForMaximize();
                let lastMinimizedElementCurrentWidth = calculatedWidths.lastMinimizedElementCurrentWidth;
                let lastMinimizedElementWidth = calculatedWidths.lastMinimizedElementWidth;
                let expectedSapceBetweenAfterExpanding = spaceBetween;
                while (!(this.lastMinimizedElement < 0) && (spaceBetween + lastMinimizedElementCurrentWidth - lastMinimizedElementWidth > this.HEADER_DISTANCE_MIN)) {
                    expectedSapceBetweenAfterExpanding = spaceBetween + lastMinimizedElementCurrentWidth - lastMinimizedElementWidth;
                    if (this.headerResponsivenessProperties[this.lastMinimizedElement].id == this.RESPONSIVENESS_ID_ACTIONS && this.lastMinimizedAction >= 0) {
                        this.maximizeAction();
                    }
                    else {
                        this.lastMinimizedElement--;
                    }
                    try {
                        this.cdr.detectChanges();
                    }
                    catch (e) {
                        console.error(e);
                    }
                    spaceBetween = this.headerBounds().spaceBetween;
                    if (Math.abs(spaceBetween - expectedSapceBetweenAfterExpanding) > this.NUMBER_COMPARISON_TOLERANCE) {
                        // actual space between and expected space between are not equal; reset all and perform resize in order to recalcualte widths
                        this.headerResponsivenessPropertiesSet = false;
                        this.resizedSubject$.next(null);
                        return;
                    }
                    calculatedWidths = this.calcElemWidthsForMaximize();
                    lastMinimizedElementCurrentWidth = calculatedWidths.lastMinimizedElementCurrentWidth;
                    lastMinimizedElementWidth = calculatedWidths.lastMinimizedElementWidth;
                }
            }
            this.ngZone.run(() => {
                this.calculatingResponsiveness = false;
                this.cdr.markForCheck();
            });
        }
    }
    minimizeAction() {
        if (this.lastMinimizedAction < (this.headerActionsList.length) - 1) {
            // minimize next action
            this.lastMinimizedAction++;
        }
        else {
            // all actions minimized; minimize next element
            this.lastMinimizedElement++;
        }
    }
    maximizeAction() {
        this.lastMinimizedAction--;
        if (this.lastMinimizedAction == -1) {
            // all actions maximized; maximize next element
            this.lastMinimizedElement--;
        }
    }
    calcElemWidthsForMaximize() {
        let lastMinimizedElementCurrentWidth = this.elementBounds(this.headerResponsivenessProperties[this.lastMinimizedElement]?.elemRef?.nativeElement).width || 0;
        let lastMinimizedElementWidth = this.headerResponsivenessProperties[this.lastMinimizedElement]?.width || 0;
        if (this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_CONTENT_1].order ||
            this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_CONTENT_2].order ||
            this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_CONTENT_3].order ||
            this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_DATE_RANGE].order ||
            this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_FILTER].order ||
            this.lastMinimizedElement == this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_SORT].order) {
            // maximizing sort/filter/content
            lastMinimizedElementCurrentWidth = this.sortFilterContentMinimizedWidth();
        }
        else if (this.headerResponsivenessProperties[this.lastMinimizedElement]?.id == this.RESPONSIVENESS_ID_ACTIONS && this.lastMinimizedAction >= 0) {
            // maximizing actions
            lastMinimizedElementCurrentWidth = this.actionsMinimizedWidth();
            lastMinimizedElementWidth = this.lastMinimizedActionWidth();
        }
        return {
            lastMinimizedElementCurrentWidth: lastMinimizedElementCurrentWidth,
            lastMinimizedElementWidth: lastMinimizedElementWidth
        };
    }
    sortFilterContentMinimizedWidth() {
        if (this.headerLeftElementSortAndFilterMinimizedContent) {
            if (this.headerLeftElementSortAndFilterMinimizedContent.nativeElement?.children.length == 1 && this.headerResponsivenessProperties[this.lastMinimizedElement].width > 0) {
                return this.elementBounds(this.headerLeftElementSortAndFilterMinimized?.nativeElement).width || 0;
            }
        }
        return 0;
    }
    actionsMinimizedWidth() {
        if (this.lastMinimizedAction > 0) {
            return 0;
        }
        else {
            return this.elementBounds(this.headerElementActionsMinimized?.nativeElement).width || 0;
        }
    }
    lastMinimizedActionWidth() {
        return this.headerResponsivenessActionsProperties[this.lastMinimizedAction].canMinimize ? this.headerResponsivenessActionsProperties[this.lastMinimizedAction].width : 0;
    }
    onResized(event) {
        if (this.responsivenessActive) {
            this.calculatingResponsiveness = true;
            this.resizedSubject$.next(event);
        }
    }
    onContentResized(event, slotNum) {
        let slotResponsivenessId = "RESPONSIVENESS_ID_CONTENT_" + slotNum;
        if (!this[slotResponsivenessId]) {
            return;
        }
        if (this.responsivenessActive && !this.calculatingResponsiveness) {
            if (this.headerResponsivenessConfiguration[this[slotResponsivenessId]]?.order > this.lastMinimizedElement) {
                let elem = this.headerResponsivenessProperties.find(elem => {
                    return elem.id === this[slotResponsivenessId];
                });
                if (!elem) {
                    return;
                }
                let savedWidth = elem.width;
                elem.width = this.elementBounds(elem.elemRef?.nativeElement).width || 0;
                if (Math.abs(savedWidth - elem.width) > this.SIZE_CHANGE_TOLERANCE) {
                    this.onResized(event);
                }
            }
        }
    }
    onFiltersResized(event) {
        if (this.responsivenessActive && !this.calculatingResponsiveness) {
            if (this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_FILTER]?.order > this.lastMinimizedElement) {
                let filtersElem = this.headerResponsivenessProperties.find(elem => {
                    return elem.id === this.RESPONSIVENESS_ID_FILTER;
                });
                filtersElem.width = this.elementBounds(filtersElem.elemRef?.nativeElement).width || 0;
                let spaceBetween = this.headerBounds().spaceBetween;
                if (spaceBetween <= this.HEADER_DISTANCE_MIN) {
                    let textWrappersList = filtersElem.elemRef.nativeElement.getElementsByClassName("ex-combobox-trigger-selected-value");
                    let textWarppersWidthSum = 0;
                    textWrappersList.forEach(element => {
                        textWarppersWidthSum += this.elementBounds(element).width;
                    });
                    let overflow = this.HEADER_DISTANCE_MIN - spaceBetween;
                    if (textWarppersWidthSum <= 0) {
                        textWarppersWidthSum = overflow + 30;
                    }
                    this.renderer.addClass(this.headerElementFilter.nativeElement, "header-element-filter-max-width");
                    this.exFitlerMaxWidthCssVar = String(((textWarppersWidthSum - (overflow + 1)) / textWrappersList.length)) + "px";
                }
            }
        }
    }
    onSortsResized(event) {
        if (this.responsivenessActive && !this.calculatingResponsiveness) {
            if (this.headerResponsivenessConfiguration[this.RESPONSIVENESS_ID_SORT]?.order > this.lastMinimizedElement) {
                let sortElem = this.headerResponsivenessProperties.find(elem => {
                    return elem.id === this.RESPONSIVENESS_ID_SORT;
                });
                sortElem.width = this.elementBounds(sortElem.elemRef?.nativeElement).width || 0;
                let spaceBetween = this.headerBounds().spaceBetween;
                if (spaceBetween <= this.HEADER_DISTANCE_MIN) {
                    let valueSpansList = sortElem.elemRef.nativeElement.getElementsByClassName("ex-combobox-trigger-selected-value");
                    let valueSpansWidthSum = 0;
                    valueSpansList.forEach(element => {
                        valueSpansWidthSum += this.elementBounds(element).width;
                    });
                    let overflow = this.HEADER_DISTANCE_MIN - spaceBetween;
                    if (valueSpansWidthSum <= 0) {
                        valueSpansWidthSum = overflow + 30;
                    }
                    this.renderer.addClass(this.headerElementSort.nativeElement, "header-element-sort-max-width");
                    this.exSortMaxWidthCssVar = String(((valueSpansWidthSum - (overflow + 1)) / valueSpansList.length)) + "px";
                }
            }
        }
    }
    removeDropdownMaxWidthCss() {
        this.exFitlerMaxWidthCssVar = "unset";
        if (this.headerElementFilter) {
            this.renderer.removeClass(this.headerElementFilter.nativeElement, "header-element-filter-max-width");
        }
        this.exSortMaxWidthCssVar = "unset";
        if (this.headerElementSort) {
            this.renderer.removeClass(this.headerElementSort.nativeElement, "header-element-sort-max-width");
        }
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { top, left, right, width, height } = el.getBoundingClientRect();
        return {
            top: top,
            left: left,
            right: right,
            width: width,
            height: height
        };
    }
    headerBounds() {
        const headerAllWidth = this.elementBounds(this.headerAll?.nativeElement).width || 0;
        const headerAllHeight = this.elementBounds(this.headerAll?.nativeElement).height || 0;
        const headerRightWidth = this.elementBounds(this.headerRight?.nativeElement).width || 0;
        const headerLeftWidth = this.elementBounds(this.headerLeft?.nativeElement).width || 0;
        const space = headerAllWidth - headerRightWidth - headerLeftWidth;
        return {
            spaceBetween: space,
            headerAllWidth: headerAllWidth,
            headerAllHeight: headerAllHeight,
            headerRightWidth: headerRightWidth,
            headerLeftWidth: headerLeftWidth
        };
    }
    minimizedSearchOpenToggle() {
        this.minimizedSearchOpen = !this.minimizedSearchOpen;
        this.cdr.detectChanges();
    }
    onOpenActionMenu() {
        this.isPopUpMenuOpen = true;
    }
    closeActionsMenu() {
        this.isPopUpMenuOpen = false;
        this.headerElementActionsMinimizedComponent?.close();
    }
    fileListClicked() {
    }
    fileThumbnailClicked() {
    }
    _sortChange(sort, index) {
        const { order, sortBy } = sort;
        this.sortChange.emit({ order, sortBy, index });
    }
    _searchFieldChange(searchField) {
        this.selectedValueChange.emit(searchField);
    }
    _comboboxItemClicked(item, comboboxList) {
        this.comboboxItemClicked.emit({ item, comboboxList });
        this.closeActionsMenu();
    }
    _searchChange(search) {
        const searchBy = search.searchBy;
        this.searchChange.emit({ searchBy, searchText: this.searchText });
    }
    _actionClicked(value) {
        this.actionClicked.emit(value);
        const action = this.actions.find(action => action.value === value);
        if (action && action.clearPickupOnAction) {
            this.onClearAll();
        }
        this.closeActionsMenu();
    }
    exportClicked(action) {
        this.exportMenu?.close();
        this._actionClicked(action);
    }
    _datesUpdated(e) {
        this.datesUpdated.emit(e);
    }
    _clearDates() {
        this.clearDates.emit();
    }
    closePopup(action) {
        this.floatingComponents.forEach(child => {
            child.close();
        });
        if (action && action.clearPickupOnAction) {
            this.onClearAll();
        }
    }
    onCheckAllChanged(e) {
        if (e.checked) {
            this.checkAll = true;
            this.checkAllItems.emit();
        }
        else {
            this.checkAll = false;
            this.clearPageCheckedItems.emit();
        }
    }
    onClearAll() {
        this.checkAll = false;
        this.numberOfCheckedItems = 0;
        this.clearCheckedItems.emit();
    }
    onChangeToggleOptionsOpen() {
        this.isToggleOptionsOpen = !this.isToggleOptionsOpen;
    }
    _customizationClicked() {
        this.customizationClicked.emit();
        this.closeActionsMenu();
    }
    onCloseRightSide() {
        if (this.fullPage) {
            this.location.back();
        }
        if (!this.deepLinkMode) {
            this.closeRightSideClicked.emit();
        }
    }
    title() {
        return this.fullPageTitle ?? (this.deepLinkMode ? 'error.page.action.back' : 'alma-list-layout.fullpage_view.title');
    }
    _refreshClicked() {
        this.refreshClicked.emit();
    }
    onChangeView(viewMode) {
        if (!this.isWideScreen && this.responsive) {
            return;
        }
        this.viewMode = this.viewMode == ViewModes.SPLIT ? ViewModes.FULL : ViewModes.SPLIT;
        this.viewMode == ViewModes.SPLIT ? this.splitViewOn() : this.splitViewOff();
    }
    splitViewOn() {
        if (!this.isItemOpen) {
            this.toggleisItemOpen.emit();
        }
        if (this.fullPage) {
            this.location.back();
        }
        this.fullPage = false;
        this.viewModeChange.emit(this.viewMode);
    }
    splitViewOff() {
        if (this.isItemOpen) {
            this.toggleisItemOpen.emit();
        }
        this.fullPage = false;
        this.viewModeChange.emit(this.viewMode);
    }
    onHelpLinkClick() {
        this.openUserResponsiveMenu.emit();
        this.childMenu.closeMenu();
    }
    bulkActionsFilterChanged(filterSelectedValue) {
        this.bulkActionsIndicationService.filterItems(filterSelectedValue);
    }
    getUnlistedValuesParams(action) {
        return action?.unlistedValuesParams;
    }
    static { this.ɵfac = function ExListHeaderComponent_Factory(t) { return new (t || ExListHeaderComponent)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(EX_APP_IN_SIDEPANE, 8), i0.ɵɵdirectiveInject(i1$5.Location), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i3$2.Router), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(ExBulkActionIndicationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExListHeaderComponent, selectors: [["ex-list-header"]], viewQuery: function ExListHeaderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$16, 5);
            i0.ɵɵviewQuery(_c1$G, 5);
            i0.ɵɵviewQuery(_c2$u, 5);
            i0.ɵɵviewQuery(_c3$l, 5);
            i0.ɵɵviewQuery(_c4$h, 5);
            i0.ɵɵviewQuery(_c5$e, 5);
            i0.ɵɵviewQuery(_c6$c, 5);
            i0.ɵɵviewQuery(_c7$9, 5);
            i0.ɵɵviewQuery(_c8$9, 5);
            i0.ɵɵviewQuery(_c9$7, 5);
            i0.ɵɵviewQuery(_c10$6, 5);
            i0.ɵɵviewQuery(_c11$4, 5);
            i0.ɵɵviewQuery(_c12$3, 5);
            i0.ɵɵviewQuery(_c13$3, 5);
            i0.ɵɵviewQuery(_c14$3, 5, ElementRef);
            i0.ɵɵviewQuery(_c15$3, 5);
            i0.ɵɵviewQuery(_c16$3, 5);
            i0.ɵɵviewQuery(_c16$3, 5);
            i0.ɵɵviewQuery(_c17$2, 5, ElementRef);
            i0.ɵɵviewQuery(_c17$2, 5);
            i0.ɵɵviewQuery(_c18$2, 5);
            i0.ɵɵviewQuery(_c19$2, 5);
            i0.ɵɵviewQuery(_c20$1, 5);
            i0.ɵɵviewQuery(_c21$1, 5);
            i0.ɵɵviewQuery(_c22$1, 5);
            i0.ɵɵviewQuery(_c23$1, 5);
            i0.ɵɵviewQuery(_c24$1, 5);
            i0.ɵɵviewQuery(_c25$1, 5);
            i0.ɵɵviewQuery(_c26$1, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.floatingCustomization = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerAll = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerLeft = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerRight = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementCheckbox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementSearch = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementSort = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementDateRange = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementContent1 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementContent2 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementContent3 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerLeftElementSortAndFilterMinimized = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerLeftElementSortAndFilterMinimizedContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementActionsAndIcons = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementActions = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementActionsMinimized = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementActionsMinimizedComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.exportMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementIcons = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementToggle = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElementPickupCount = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContent1Element = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContent2Element = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContent3Element = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.floatingComponents = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionElements = _t);
        } }, hostVars: 6, hostBindings: function ExListHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("--ex-list-header-height", ctx.exlistheaderheightCssVar)("--ex-filter-max-width", ctx.exFitlerMaxWidthCssVar)("--ex-sort-max-width", ctx.exSortMaxWidthCssVar);
        } }, inputs: { selectedOnCurrentPage: "selectedOnCurrentPage", sorts: "sorts", actions: "actions", bulkActions: "bulkActions", comboboxLists: "comboboxLists", popUpActions: "popUpActions", filters: "filters", hasSearch: "hasSearch", searchByFields: "searchByFields", searchBySelectedField: "searchBySelectedField", isItemOpen: "isItemOpen", hasToggle: "hasToggle", hasFileToggle: "hasFileToggle", showToggle: "showToggle", hasExport: "hasExport", hasBottomBorder: "hasBottomBorder", numberOfCheckedItems: "numberOfCheckedItems", numOfPageCheckedItems: "numOfPageCheckedItems", pageSize: "pageSize", hasPickup: "hasPickup", hasPickupCount: "hasPickupCount", clearAllSubject: "clearAllSubject", hasCustomization: "hasCustomization", hasRecordCustomization: "hasRecordCustomization", customizationComponent: "customizationComponent", isCustomized: "isCustomized", responsivenessActive: "responsivenessActive", needToRefresh: "needToRefresh", isLoading: "isLoading", hasRefreshButton: "hasRefreshButton", deepLinkMode: "deepLinkMode", hasMinimizedSearch: "hasMinimizedSearch", viewMode: "viewMode", fullPage: "fullPage", itemsLayoutType: "itemsLayoutType", showItemsLayoutTypeToggle: "showItemsLayoutTypeToggle", responsive: "responsive", isWideScreen: "isWideScreen", fullPageTitle: "fullPageTitle", fullPageTitleIcon: "fullPageTitleIcon", floatingExport: "floatingExport", exportEnabled: "exportEnabled", showDateFilter: "showDateFilter", filterMaxDate: "filterMaxDate", filterMinDate: "filterMinDate", searchText: "searchText", deepLinkModeTemplate: "deepLinkModeTemplate", headerResponsivenessOrderConfig: "headerResponsivenessOrderConfig", galleryLayoutEnabled: "galleryLayoutEnabled", gallerySlider: "gallerySlider" }, outputs: { itemsLayoutTypeToggled: "itemsLayoutTypeToggled", toggleisItemOpen: "toggleisItemOpen", toggleisItemOpenSized: "toggleisItemOpenSized", sortChange: "sortChange", actionClicked: "actionClicked", comboboxItemClicked: "comboboxItemClicked", popupClosed: "popupClosed", searchChange: "searchChange", filterChange: "filterChange", clearPageCheckedItems: "clearPageCheckedItems", clearCheckedItems: "clearCheckedItems", checkAllItems: "checkAllItems", selectedValueChange: "selectedValueChange", customizationClicked: "customizationClicked", selectedOnCurrentPageChange: "selectedOnCurrentPageChange", viewModeChange: "viewModeChange", openUserResponsiveMenu: "openUserResponsiveMenu", datesUpdated: "datesUpdated", clearDates: "clearDates", closeRightSideClicked: "closeRightSideClicked", refreshClicked: "refreshClicked", gallerySliderChange: "gallerySliderChange" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c56, decls: 15, vars: 14, consts: [[1, "ex-list-header-ex-list-layout-header-wrapper", 3, "ngClass"], ["class", "ex-list-header-responsiveness-placeholder-wrapper", 4, "ngIf"], [1, "ex-list-header-ex-list-layout-header-container", 3, "resized"], [1, "ex-list-header-ex-list-layout-header", 3, "ngClass"], ["headerAll", ""], ["class", "ex-list-header-toggle-div", 4, "ngIf"], ["class", "ex-list-header-left", 4, "ngIf"], [1, "ex-list-header-right"], ["headerRight", ""], ["class", "ex-list-header-right-actions", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], ["customizationButton", ""], ["class", "header-element-pickup-count", 4, "ngIf"], [1, "ex-list-header-responsiveness-placeholder-wrapper"], [1, "ex-list-header-responsiveness-placeholder-anim"], [1, "ex-list-header-responsiveness-placeholder"], [1, "ex-list-header-toggle-div"], [1, "ex-list-header-title-wrapper"], [1, "ex-list-primary-title"], [1, "sel-ex-list-header-back", "ex-list-main-header-back-button", 3, "exTooltip", "click"], [1, "fa", "fa-lg", 3, "ngClass"], [3, "click"], [3, "iconName", 4, "ngIf"], [3, "iconName"], [1, "ex-list-header-left"], ["headerLeft", ""], ["class", "ex-list-header-refresh-button", "type", "action", "tooltip", "ng.general.refresh", "ariaLabel", "ng.general.refresh", 3, "ariaLabel", "uniqueSelector", "click", 4, "ngIf"], [1, "header-element", "header-element-checkbox"], ["headerLeftElementCheckbox", ""], ["class", "ex-list-header-check-all sel-check-all", 3, "margin-inline-start", "exTooltip", "ariaLabel", "checked", "indeterminate", "uniqueSelector", "checkboxChange", 4, "ngIf"], ["class", "ex-list-header-checkAll-divider", 4, "ngIf"], [1, "ex-list-header-search-toolbar", "header-element", "header-element-search"], ["headerLeftElementSearch", ""], [1, "ex-list-header-left-side-wrapper"], ["ariaLabel", "ng.accessibility.search-btn", "tooltip", "ng.accessibility.search-btn", "class", "ex-list-header-search-toolbar-button", 3, "type", "uniqueSelector", "click", 4, "ngIf"], [1, "ex-list-header-search-searchbar", 3, "ngClass"], [1, "ex-list-header-search-searchbar-bg"], ["class", "ex-list-header-search-box", 3, "autoFocus", "searchFields", "selectedSearchField", "blueOnFocus", "searchText", "searchTextChange", "searchTriggered", "selectedValueChange", 4, "ngIf"], ["class", "ex-list-header-search-searchbar-minimized-close", 4, "ngIf"], [1, "header-element", "header-element-sort-and-filter"], ["headerLeftElementSortAndFilter", ""], ["class", "ex-list-header-sort-filter", 3, "closeFromContent", "uniqueSelector", 4, "ngIf"], ["class", "ex-list-header-toggle-divider", 4, "ngIf"], ["class", "ex-list-header-sort-filter ex-list-header-filter", 3, "disabled", "closeFromContent", "uniqueSelector", 4, "ngIf"], [3, "ngTemplateOutlet"], ["sortTmpl", ""], ["filterTmpl", ""], ["contentTmpl1", ""], ["contentTmpl2", ""], ["contentTmpl3", ""], ["type", "action", "tooltip", "ng.general.refresh", "ariaLabel", "ng.general.refresh", 1, "ex-list-header-refresh-button", 3, "ariaLabel", "uniqueSelector", "click"], [1, "fa", "fa-refresh"], ["class", "ex-list-header-green-dot", 4, "ngIf"], [1, "ex-list-header-green-dot"], [1, "ex-list-header-check-all", "sel-check-all", 3, "exTooltip", "ariaLabel", "checked", "indeterminate", "uniqueSelector", "checkboxChange"], [1, "ex-list-header-checkAll-divider"], ["ariaLabel", "ng.accessibility.search-btn", "tooltip", "ng.accessibility.search-btn", 1, "ex-list-header-search-toolbar-button", 3, "type", "uniqueSelector", "click"], ["iconName", "search", 1, "ex-search-search-icon", 3, "size"], ["class", "ex-list-header-green-dot ex-list-header-search-icon", 4, "ngIf"], [1, "ex-list-header-green-dot", "ex-list-header-search-icon"], [1, "ex-list-header-search-box", 3, "autoFocus", "searchFields", "selectedSearchField", "blueOnFocus", "searchText", "searchTextChange", "searchTriggered", "selectedValueChange"], [1, "ex-list-header-search-searchbar-minimized-close"], [3, "type", "uniqueSelector", "keydown.tab", "click"], [1, "ex-list-header-search-searchbar-minimized-end-fade", 3, "ngClass"], [1, "ex-list-header-sort-filter", 3, "closeFromContent", "uniqueSelector"], ["trigger", "", "iconName", "sort", 3, "exTooltip"], ["content", "", 3, "ngTemplateOutlet"], [1, "ex-list-header-toggle-divider"], [1, "ex-list-header-sort-filter", "ex-list-header-filter", 3, "disabled", "closeFromContent", "uniqueSelector"], ["trigger", "", 1, "ex-filters-filterIcon", 3, "displayDot", "exTooltip"], [1, "uxf-icon", "uxf-filter", "ex-filters-icon"], ["content", "", 3, "ngTemplateOutlet", 4, "ngIf"], [1, "header-element", "header-element-sort", 3, "ngClass", "resized"], ["headerLeftElementSort", ""], [3, "ngClass", "order", "sortByOptions", "hasOrder", "disabled", "sortBy", "autoComplete", "multiLined", "sortByLabel", "valueChanged", 4, "ngFor", "ngForOf"], [3, "ngClass", "order", "sortByOptions", "hasOrder", "disabled", "sortBy", "autoComplete", "multiLined", "sortByLabel", "valueChanged"], [1, "header-element", "header-element-filter", 3, "resized"], ["headerLeftElementFilter", ""], [3, "ignoreSectionsLayoutViewMode", "ngClass", "minimized", "filters", "allLabel", "selectedValueChange", "defaultFilterChange", 4, "ngIf"], [1, "header-element", "header-element-date"], ["headerLeftElementDateRange", ""], ["class", "ex-list-header-date-range-picker sel-date-range-picker", 3, "blueOnFocus", "inListHeader", "uniqueSelector", "maxDate", "minDate", "datesUpdated", "clearDates", 4, "ngIf"], [3, "ignoreSectionsLayoutViewMode", "ngClass", "minimized", "filters", "allLabel", "selectedValueChange", "defaultFilterChange"], [1, "ex-list-header-date-range-picker", "sel-date-range-picker", 3, "blueOnFocus", "inListHeader", "uniqueSelector", "maxDate", "minDate", "datesUpdated", "clearDates"], [1, "header-element", "header-element-content"], ["headerLeftElementContent1", ""], ["class", "ex-list-header-title-divider", 4, "ngIf"], [1, "ex-list-header-content", 3, "resized"], ["content1", ""], [1, "ex-list-header-title-divider"], ["headerLeftElementContent2", ""], ["content2", ""], ["headerLeftElementContent3", ""], ["content3", ""], [1, "ex-list-header-right-actions"], [1, "header-element", "header-element-actions-and-icons"], ["headerRightElementActionsAndIcons", ""], ["class", "ex-list-header-actions-minimized", "type", "action", "ariaHasPopup", "menu", 3, "closeFromContent", "disabled", "uniqueSelector", "menuClass", "ariaLabel", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["actionsTmpl", ""], ["iconsTmpl", ""], [4, "ngIf"], ["type", "action", 3, "tooltip", "ariaLabel", "uniqueSelector", "uniqueSelectorState", "click", 4, "ngIf"], ["class", "header-element header-element-toggle", 4, "ngIf"], ["helpIcon", ""], ["type", "action", "ariaHasPopup", "menu", 1, "ex-list-header-actions-minimized", 3, "closeFromContent", "disabled", "uniqueSelector", "menuClass", "ariaLabel"], ["headerRightElementActionsAndIconsMinimized", ""], ["trigger", "", 1, "ex-list-header-actions-minimized-button", 3, "exTooltip"], [1, "uxf-icon", "uxf-dot-three", "coolBlue"], ["content", ""], ["class", "ex-list-header-horizontal-menu-divider", 4, "ngIf"], ["header-element-actions-and-icons-icons-minimized-wrapper", ""], [1, "ex-list-header-horizontal-menu-divider"], [1, "header-element", "header-element-actions", 3, "ngClass"], ["headerRightElementActions", ""], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "openToSide", "disabled", "ex-list-header-popup-action-minimized", "ngClass", "id", "splitButton", "splitButtonClass", "type", "icon", "tooltip", "ariaLabel", "uniqueSelector", "menuClosed", "menuOpen", "splitButtonClick", 4, "ngIf"], [3, "openToSide", "disabled", "ngClass", "id", "splitButton", "splitButtonClass", "type", "icon", "tooltip", "ariaLabel", "uniqueSelector", "menuClosed", "menuOpen", "splitButtonClick"], ["floating", "", "headerAction", ""], ["trigger", "", 1, "ex-list-header-popup-action-label", 3, "ngStyle"], ["class", "uxf-icon sel-popup-action-arrow", 3, "ngClass", 4, "ngIf"], [3, "data", "componentFactoryItem", "events", 4, "ngIf"], [1, "uxf-icon", "sel-popup-action-arrow", 3, "ngClass"], [3, "data", "componentFactoryItem", "events"], ["class", "ex-list-header-actions-action", 3, "id", 4, "ngIf"], [1, "ex-list-header-actions-action", 3, "id"], ["headerAction", ""], [4, "ngIf", "ngIfElse"], ["singleAction", ""], ["type", "action", 3, "disabled", "openToSide", "children", "iconSide", "uniqueSelector", "hasSearchBox", "unlistedValuesParams", "childClicked"], ["icon", "", 4, "ngIf"], ["icon", ""], [3, "ngClass"], [3, "id", "type", "iconSide", "disabled", "ngClass", "loading", "tooltip", "uniqueSelector", "click"], [3, "ngClass", 4, "ngIf"], ["class", "ex-list-header-actions-divider", 4, "ngIf"], [1, "ex-list-header-actions-divider"], [1, "header-element", "header-element-icons", 3, "ngClass"], ["headerRightElementIcons", ""], ["class", "ex-list-header-export-icon", 4, "ngIf"], ["class", "ex-list-header-customization-icon", 4, "ngIf"], ["tooltip", "ng.general.customize", "ariaLabel", "ng.general.customize", "type", "action", "ariaHasPopup", "dialog", 3, "openToSide", "uniqueSelector", "menuClosed", 4, "ngIf"], [1, "ex-list-header-export-icon"], ["class", "ex-list-header-action-divider", 4, "ngIf"], ["id", "exportButton", "type", "action", "class", "ex-list-header-action-button sel-list-export-button", 3, "ex-list-header-action-button-disabled", "tooltip", "ariaLabel", "disabled", "uniqueSelector", "click", 4, "ngIf", "ngIfElse"], ["floatingExportTmpl", ""], [1, "ex-list-header-action-divider"], ["id", "exportButton", "type", "action", 1, "ex-list-header-action-button", "sel-list-export-button", 3, "tooltip", "ariaLabel", "disabled", "uniqueSelector", "click"], [1, "icon-alma-ex-alma-export-doc", "ex-list-header-export-icon", "ex-list-header-icon"], ["type", "action", "ariaLabel", "ng.export.tooltip", "class", "ex-list-header-export-wrapper", "ariaHasPopup", "menu", 3, "tooltip", "closeFromContent", "uniqueSelector", "disabled", 4, "ngIf"], ["type", "action", "ariaLabel", "ng.export.tooltip", "ariaHasPopup", "menu", 1, "ex-list-header-export-wrapper", 3, "tooltip", "closeFromContent", "uniqueSelector", "disabled"], ["floatingExport", ""], ["trigger", "", "id", "exportButton", 1, "ex-list-header-action-button", "sel-list-export-button"], ["content", "", "role", "list", 1, "ex-list-header-export"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["exportContent", ""], ["tabindex", "0", "role", "listitem", 1, "ex-list-header-export-content-wrapper"], [3, "iconName", "color"], [1, "ex-list-header-customization-icon"], ["tooltip", "ng.general.customize", "ariaLabel", "ng.general.customize", "type", "action", "ariaHasPopup", "dialog", 3, "openToSide", "uniqueSelector", "menuClosed"], ["floatingCustomization", ""], ["trigger", "", 1, "ex-list-header-action-button", "sel-list-customization-button"], [1, "ex-list-header-icon"], [1, "uxf-settings"], ["type", "action", 3, "tooltip", "ariaLabel", "uniqueSelector", "uniqueSelectorState", "click"], ["class", "gallery-size-slider", 4, "ngIf"], [1, "gallery-size-slider"], [1, "gallery-size-slider-mat", 3, "max", "min", "step", "disableRipple"], ["matSliderThumb", "", 3, "ngModel", "ngModelChange"], [1, "header-element", "header-element-toggle"], ["headerRightElementToggle", ""], ["type", "action", 3, "disabled", "exTooltip", "uniqueSelector", "uniqueSelectorState", "ariaLabel", "click"], [1, "ex-list-header-toggle-icon", 3, "iconName", "color"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [1, "ex-list-header-help-icon", "sel-ex-list-header-help-icon", 3, "contentWidth", "icon", "click"], ["childMenu", ""], ["description", ""], [3, "uniqueSelector", "linkClicked"], ["id", "customizationButton", "type", "action", "ariaLabel", "ng.general.customize", 1, "ex-list-header-action-button", "sel-list-customization-button", 3, "tooltip", "ngClass", "uniqueSelector", "click"], [1, "header-element-pickup-count"], ["headerRightElementPickupCount", ""], ["class", "ex-list-header-status-filter-container", 4, "ngIf"], ["statusFilter", ""], ["class", "ex-list-header-filter-vl", 4, "ngIf"], ["type", "action", "class", "ex-list-header-action-button", 3, "uniqueSelector", "click", 4, "ngIf"], [1, "ex-list-header-status-filter-container"], [3, "exTooltip"], [3, "color", "iconName", 4, "ngIf"], ["role", "button", "tabindex", "0", 1, "ex-list-header-status-filter", 3, "click", "keydown.enter"], [3, "color", "iconName"], [1, "ex-list-header-filter-vl"], [1, "ex-list-header-selected-rows-count-wrapper", 3, "ngClass"], [1, "ex-list-header-selected-rows-count", "sel-checked-items-count"], [1, "ex-list-header-selected-rows-count-bold"], ["type", "action", 1, "ex-list-header-action-button", 3, "uniqueSelector", "click"]], template: function ExListHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c53);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExListHeaderComponent_div_1_Template, 3, 0, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵlistener("resized", function ExListHeaderComponent_Template_div_resized_2_listener($event) { return ctx.onResized($event); });
            i0.ɵɵelementStart(3, "div", 3, 4);
            i0.ɵɵtemplate(5, ExListHeaderComponent_div_5_Template, 13, 16, "div", 5);
            i0.ɵɵtemplate(6, ExListHeaderComponent_div_6_Template, 37, 18, "div", 6);
            i0.ɵɵelementStart(7, "div", 7, 8);
            i0.ɵɵtemplate(9, ExListHeaderComponent_div_9_Template, 2, 1, "div", 9);
            i0.ɵɵtemplate(10, ExListHeaderComponent_div_10_Template, 15, 8, "div", 9);
            i0.ɵɵtemplate(11, ExListHeaderComponent_ng_container_11_Template, 1, 1, "ng-container", 10);
            i0.ɵɵtemplate(12, ExListHeaderComponent_ng_template_12_Template, 6, 9, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(14, ExListHeaderComponent_div_14_Template, 8, 4, "div", 12);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c54, ctx.hasBottomBorder, !ctx.calculatingResponsiveness));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.calculatingResponsiveness);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c55, !ctx.responsivenessActive || !(ctx.lastMinimizedElement < ctx.headerResponsivenessProperties.length - 1)));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.fullPage);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.fullPage);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.deepLinkMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.fullPage);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.fullPage && ctx.hasCustomization && !ctx.isInSidePane);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showFilters || ctx.hasPickupCount && ctx.numberOfCheckedItems > 0 && !ctx.fullPage);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i1$5.NgSwitch, i1$5.NgSwitchCase, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExButtonComponent, ExSortComponent, ExFiltersComponent, ExTooltipDirective, MinValidator, ResizedDirective, ExFloatingComponentComponent, ExComponentLoaderComponent, ExExtendedSearchComponent, ExDateRangePickerComponent, ExCheckboxComponent, ExSvgIconComponent, ExHelpIconComponent, ExDotWrapperComponent, ExLinkComponent, i23.MatSlider, i23.MatSliderThumb, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-list-header-ex-list-layout-header-wrapper[_ngcontent-%COMP%]{position:relative;padding-bottom:10px}.ex-list-header-ex-list-layout-header-wrapper.ex-list-header-border-bottom[_ngcontent-%COMP%]{border-bottom:1px solid #cccccc}.gallery-size-slider[_ngcontent-%COMP%]{display:flex;align-items:center;gap:8px;padding-inline:10px;border-radius:4px;border:1px solid #cccccc;font-weight:600;color:#4164a4;height:32px}.gallery-size-slider[_ngcontent-%COMP%]     .mat-mdc-slider{min-width:70px}.hide-slider[_ngcontent-%COMP%]{visibility:hidden}.ex-list-header-ex-list-layout-header-wrapper-overflow[_ngcontent-%COMP%]{overflow:auto}.ex-list-header-action-button-inline[_ngcontent-%COMP%]{flex-grow:2}.ex-list-header-action-icon-button[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;align-items:center;height:var(--ex-list-header-height)}.ex-list-header-ex-list-layout-header.ex-list-header-ex-list-layout-header-wrap[_ngcontent-%COMP%]{flex-wrap:wrap;height:auto}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-sort[_ngcontent-%COMP%]{margin-right:25px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;margin-inline-start:auto;margin-top:auto}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-popup-action[_ngcontent-%COMP%]{padding-right:10px;padding-left:10px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-popup-apply-button[_ngcontent-%COMP%]{padding:10px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-divider[_ngcontent-%COMP%]{height:25px;margin-right:10px;margin-left:10px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-toggle-layout[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-toggle-layout[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]{cursor:pointer;padding:4px 10px 2px;border:0px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-toggle-layout[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]   .ex-list-header-full-page-button[_ngcontent-%COMP%]{margin-left:5px;border-radius:3px!important}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-toggle-layout[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{border-radius:3px 0 0 3px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   .ex-list-header-toggle-layout[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{border-radius:0 3px 3px 0}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     span.ex-dropdown-placeholder{font-family:Roboto;font-style:normal;color:#4164a4}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     button:hover{outline:none!important;background-color:#eee;background:transparent}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     button:focus{outline:1px solid #000;background-color:#eee;background:transparent}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-right[_ngcontent-%COMP%] > .ex-list-header-help-icon[_ngcontent-%COMP%]{margin-inline-start:6px!important}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-title-divider[_ngcontent-%COMP%]{margin-inline-start:10px;margin-inline-end:20px;height:100%}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-action-divider[_ngcontent-%COMP%]{margin:0 5px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-checkAll-divider[_ngcontent-%COMP%]{margin:0;margin-inline-start:7px;margin-inline-end:7px;height:100%}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-content[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-direction:column}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-left[_ngcontent-%COMP%]{display:flex}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-left[_ngcontent-%COMP%]   .ex-list-header-check-all[_ngcontent-%COMP%]{display:flex;margin-inline-end:7px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-left[_ngcontent-%COMP%]   .ex-list-header-check-all[_ngcontent-%COMP%]     .ex-checkbox-wrapper{padding-top:5px}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-header-export-icon[_ngcontent-%COMP%]{display:flex}.ex-list-header-ex-list-layout-header[_ngcontent-%COMP%]   .ex-list-customization-button-full-page[_ngcontent-%COMP%]{margin-inline-end:20px}.ex-list-header-date-range-picker[_ngcontent-%COMP%]{margin-inline-end:15px}.ex-list-header-date-range-picker[_ngcontent-%COMP%]     .ex-date-rane-picker-filter-dates{white-space:nowrap;overflow:hidden;margin:0!important}.ex-list-header-search-toolbar[_ngcontent-%COMP%]{display:flex;align-items:center}.ex-list-header-search-toolbar[_ngcontent-%COMP%]   .ex-list-header-search-box[_ngcontent-%COMP%]{display:flex;flex:1;margin-inline-end:15px;margin-inline-start:8px}.ex-list-header-search-toolbar[_ngcontent-%COMP%]   .ex-list-header-left-side-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:.2;min-height:34px}.ex-list-header-search-toolbar[_ngcontent-%COMP%]   .ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-icon[_ngcontent-%COMP%]{inset-inline-end:3px}.ex-list-header-left-margin[_ngcontent-%COMP%]{margin-inline-start:10px}.ex-list-header-split-sizes-toggle[_ngcontent-%COMP%]{margin-right:5px}.ex-list-header-right-actions[_ngcontent-%COMP%]{display:flex;align-items:center}.ex-list-header-toggle-div[_ngcontent-%COMP%]{display:grid;grid-template-areas:\"left right\"}.ex-list-header-title-wrapper[_ngcontent-%COMP%]{display:flex;align-content:center}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-main-header-back-button[_ngcontent-%COMP%]{border:0px;padding:0 10px;width:35px;background:none}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-main-header-back-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-inline-end:20px}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-main-header-back-button[_ngcontent-%COMP%]:hover, .ex-list-header-title-wrapper[_ngcontent-%COMP%]   .alma-page-column-main-header-back-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-primary-title[_ngcontent-%COMP%]{display:flex}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-primary-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin:0;align-self:center}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-primary-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:transparent;border:0;cursor:pointer;display:flex;align-items:center}.ex-list-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-primary-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   ex-svg-icon[_ngcontent-%COMP%]{margin-inline-end:10px;margin-bottom:2px}.ex-list-header-green-dot[_ngcontent-%COMP%]{background:#2eb82e;height:10px;width:10px;border-radius:50%;position:absolute;inset-inline-end:7px;bottom:6px;border:2px solid white}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .user-top-menu-no-shadow[_ngcontent-%COMP%]{box-shadow:none!important;border-radius:0}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]{cursor:pointer;padding:4px 10px 2px;border:0px;margin:5px 0;background:transparent}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]   .ex-list-header-toggle-button-content[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]   .ex-list-header-toggle-button-content[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-button[_ngcontent-%COMP%]   .ex-list-header-full-page-button[_ngcontent-%COMP%]{margin-left:5px;border-radius:3px!important}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options-panel[_ngcontent-%COMP%]{box-shadow:none!important;border-radius:0}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options-panel[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]{height:auto!important;margin:5px 0;padding:0;font-size:inherit}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options-panel[_ngcontent-%COMP%]   .ex-list-header-toggle-button-content[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options-panel[_ngcontent-%COMP%]   .ex-list-header-toggle-button-content[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options-panel[_ngcontent-%COMP%]   .ex-list-header-toggle-split-options[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{border-radius:3px 0 0 3px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{border-radius:0 3px 3px 0}.ex-list-header-horizontal-menu-divider[_ngcontent-%COMP%]{width:100%;margin:0;border-top:1px solid #bebebe}ex-filters[_ngcontent-%COMP%]     .ex-filters-wrapper{flex-direction:inherit}.ex-list-header-sort-and-filter-minimized-content[_ngcontent-%COMP%]{margin:10px}.header-element[_ngcontent-%COMP%]{display:flex;align-items:center}.header-element.header-element-content[_ngcontent-%COMP%], .header-element.header-element-filter[_ngcontent-%COMP%]{height:100%}.header-element.header-element-direction-column[_ngcontent-%COMP%]{flex-direction:column;align-items:unset}.header-element.header-element-direction-column.header-element-actions-minimized[_ngcontent-%COMP%]{flex-direction:column-reverse}.header-element-toggle[_ngcontent-%COMP%]{padding-inline-start:10px;padding-inline-end:5px;background-color:#eff5f7;border-radius:3px;cursor:pointer}.header-element-toggle[_ngcontent-%COMP%]   .ex-list-header-toggle[_ngcontent-%COMP%]{padding-top:2px;margin-inline-start:-5px}.header-element-toggle[_ngcontent-%COMP%]   .ex-list-header-toggle-icon[_ngcontent-%COMP%]{color:#4164a4}.ex-list-header-help-icon[_ngcontent-%COMP%]{margin-top:5px;margin-inline-start:10px;margin-inline-end:5px}.header-element-icons-minimized[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.header-element-icons-minimized[_ngcontent-%COMP%]   .ex-list-header-icon[_ngcontent-%COMP%]{margin-inline-end:10px!important}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]{position:relative}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-bg[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]{position:absolute;top:0;inset-inline-start:0;z-index:5;display:flex}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-bg[_ngcontent-%COMP%]{background-color:#fff}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-bg[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-close[_ngcontent-%COMP%]{display:flex}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-close[_ngcontent-%COMP%]   ex-button[_ngcontent-%COMP%]{background-color:#fff}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-close[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-end-fade[_ngcontent-%COMP%]{width:50px;height:100%;background-image:linear-gradient(to right,#fff,#fff0)}.ex-list-header-left-side-wrapper[_ngcontent-%COMP%]   .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-close[_ngcontent-%COMP%]   .ex-list-header-search-searchbar-minimized-end-fade.rtl[_ngcontent-%COMP%]{background-image:linear-gradient(to left,#fff,#fff0)}.header-element-pickup-count[_ngcontent-%COMP%]{display:flex;align-items:center;background-color:#f2f2f2;margin-top:5px}.header-element-pickup-count[_ngcontent-%COMP%]   .ex-list-header-selected-rows-count-wrapper[_ngcontent-%COMP%]{padding-left:7.5px;padding-right:7.5px;border-radius:3px;margin-inline-start:35px;margin-inline-end:20px}.header-element-pickup-count[_ngcontent-%COMP%]   .ex-list-header-selected-rows-count-wrapper-with-filters[_ngcontent-%COMP%]{margin-inline-start:20px!important}.ex-list-header-responsiveness-placeholder-wrapper[_ngcontent-%COMP%]{position:absolute;left:0;top:0;z-index:2;background-color:#fff;width:100%;height:100%;overflow:hidden}.ex-list-header-responsiveness-placeholder-wrapper[_ngcontent-%COMP%]   .ex-list-header-responsiveness-placeholder-anim[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}.ex-list-header-responsiveness-placeholder-wrapper[_ngcontent-%COMP%]   .ex-list-header-responsiveness-placeholder[_ngcontent-%COMP%]{margin-top:10px;width:100%;height:65%;background:#f3f5f4 0% 0% no-repeat padding-box;border-radius:3px;opacity:1}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}[_nghost-%COMP%]{--ex-list-header-height: auto;--ex-filter-max-width: unset;--ex-sort-max-width: unset}ex-filters[_ngcontent-%COMP%]     .ex-combobox-label{white-space:nowrap;overflow:hidden}ex-sort[_ngcontent-%COMP%]     .ex-sort-by-label{white-space:nowrap;overflow:hidden}.ex-list-header-actions-divider[_ngcontent-%COMP%]{border-inline-start:1px solid #CCCCCC;height:26px;margin-inline:10px}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-popup-action-label[_ngcontent-%COMP%]{white-space:nowrap}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-popup-action-hover[_ngcontent-%COMP%]:hover{background:#fff;border-radius:3px;border:0px}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-popup-action-hover[_ngcontent-%COMP%]:hover.ex-list-header-popup-action-minimized{border-radius:0;box-shadow:0 0 0 1px #000}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-action-button[_ngcontent-%COMP%]:hover{background-color:#eee;border-radius:3px}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-action-button[_ngcontent-%COMP%]:hover.ex-list-header-popup-action-minimized{border-radius:0;box-shadow:0 0 0 1px #000}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-action-button[_ngcontent-%COMP%]{color:#4164a4!important;width:100%}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-action-button[_ngcontent-%COMP%]     button:focus{background-color:#ddd;border-radius:3px;outline:2px solid #000}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-popup-action[_ngcontent-%COMP%]     button:focus{background-color:#e5e5e5}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-actions-action[_ngcontent-%COMP%]   ex-button[_ngcontent-%COMP%]     .ex-button-wrapper{width:100%;justify-content:flex-start}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-actions-action[_ngcontent-%COMP%]   ex-button[_ngcontent-%COMP%]     .ex-button-wrapper .tooltip-wrapper{flex:1;justify-content:space-between}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-actions-action[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     button{height:auto}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-vertical-seperator[_ngcontent-%COMP%]{border-left:1px solid;height:20px}.header-element-actions[_ngcontent-%COMP%]   .ex-list-header-split-button[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-floating-component[_ngcontent-%COMP%]   .ex-list-header-popup-action-label[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding-inline-start:0px;line-height:32px}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-floating-component[_ngcontent-%COMP%]   .sel-popup-action-arrow[_ngcontent-%COMP%]{margin-inline-end:10px!important}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     .ex-dropdown-selected.button-side-trigger{font-weight:inherit}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     .ex-dropdown-selected.button-side-trigger .ex-dropdown-placeholder{font-family:Roboto;font-style:normal}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-dropdown[_ngcontent-%COMP%]     .ex-dropdown-selected.button-side-trigger i{color:#555}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-combobox[_ngcontent-%COMP%]     .ex-combobox-button.button-side-trigger{font-weight:inherit}.header-element-actions.header-element-actions-minimized[_ngcontent-%COMP%]   ex-combobox[_ngcontent-%COMP%]     .ex-combobox-button.button-side-trigger .sel-combobox-selected-value-placeholder{font-family:Roboto;font-style:normal}  .ex-list-header-actions-minimized-floating-menu{margin:0!important}.ex-list-header-refresh-button[_ngcontent-%COMP%]{margin-inline-end:5px}.header-element-sort-and-filter[_ngcontent-%COMP%]   .header-element-filter.header-element-filter-max-width[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{max-width:var(--ex-filter-max-width);white-space:nowrap}.header-element-sort-and-filter[_ngcontent-%COMP%]   .header-element-filter[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{white-space:nowrap}.header-element-sort-and-filter[_ngcontent-%COMP%]   .header-element-filter[_ngcontent-%COMP%]     .ex-combobox-selected-wrapper .ex-combobox-selected{white-space:nowrap}.header-element-sort-and-filter[_ngcontent-%COMP%]   .header-element-sort.header-element-sort-max-width[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{max-width:var(--ex-sort-max-width)}.header-element-sort-and-filter[_ngcontent-%COMP%]   .header-element-sort[_ngcontent-%COMP%]     .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]{align-self:flex-end;display:flex;width:-moz-fit-content;width:fit-content;font-family:UX-Framework}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;padding:3px 8px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{border-radius:3px 0 0 3px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;border-radius:3px 0 0 3px;padding:3px 8px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{border-radius:0 3px 3px 0}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;border-radius:0 3px 3px 0;padding:3px 8px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   .ex-multi-layout-select-button[_ngcontent-%COMP%]{padding:5px 10px;border:none}.ex-list-header-export[_ngcontent-%COMP%]{margin:0 -5px!important}.ex-list-header-export[_ngcontent-%COMP%]   .ex-list-header-export-content-wrapper[_ngcontent-%COMP%]{display:flex;column-gap:5px;align-items:center;padding:5px}.ex-list-header-export[_ngcontent-%COMP%]   .ex-list-header-export-content-wrapper[_ngcontent-%COMP%]:hover, .ex-list-header-export[_ngcontent-%COMP%]   .ex-list-header-export-content-wrapper[_ngcontent-%COMP%]:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989;padding-top:4px!important;padding-bottom:4px!important}.ex-list-header-status-filter-container[_ngcontent-%COMP%]{display:flex;align-items:center;padding-left:7.5px;margin-inline-start:22px;column-gap:20px}.ex-list-header-filter-vl[_ngcontent-%COMP%]{margin-inline-start:25px;border-right:2px solid #CCCCCC;height:25px}.ex-list-header-status-filter[_ngcontent-%COMP%]{color:#4164a4;margin-inline-start:5px;font-size:15px}.ex-list-header-status-filter[_ngcontent-%COMP%]:hover{color:#1b3c72}.ex-list-header-status-filter-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;cursor:pointer;margin-inline-start:2px;margin-top:7px;margin-bottom:5px;padding-bottom:3px}.ex-list-header-status-filter-wrapper-selected[_ngcontent-%COMP%]{border-bottom:2px solid #4164a4;padding-bottom:1px!important}.ex-list-header-status-filter-selected[_ngcontent-%COMP%]{color:#000!important;font-weight:500}.ex-list-header-action-button-disabled[_ngcontent-%COMP%]{color:#d7d7d7!important}.ex-list-header-sort-filter[_ngcontent-%COMP%]     .ex-button-wrapper:disabled{color:#535353!important}.header-element-sort[_ngcontent-%COMP%], .header-element-filter[_ngcontent-%COMP%]{margin-inline:5px}.ex-list-header-toggle-divider[_ngcontent-%COMP%]{margin-inline-start:10px;margin-inline-end:5px;border-inline-start:1px solid #ccc;height:100%}.ex-list-header-filter[_ngcontent-%COMP%]     .ex-button-wrapper{font-size:16px!important;margin-top:-2px!important}"], data: { animation: [Animations$5] } }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExListHeaderComponent.prototype, "onChangeView", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListHeaderComponent, [{
        type: Component,
        args: [{ selector: 'ex-list-header', animations: [Animations$5], template: "<div class=\"ex-list-header-ex-list-layout-header-wrapper\"\n     [ngClass]=\"{ 'ex-list-header-border-bottom': hasBottomBorder, 'ex-list-header-ex-list-layout-header-wrapper-overflow': !calculatingResponsiveness }\">\n\n  <div *ngIf=\"calculatingResponsiveness\" class=\"ex-list-header-responsiveness-placeholder-wrapper\">\n    <div class=\"ex-list-header-responsiveness-placeholder-anim\"></div>\n    <div class=\"ex-list-header-responsiveness-placeholder\"></div>\n  </div>\n\n  <div (resized)=\"onResized($event)\" class=\"ex-list-header-ex-list-layout-header-container\">\n    <div #headerAll class=\"ex-list-header-ex-list-layout-header\"\n         [ngClass]=\"{ 'ex-list-header-ex-list-layout-header-wrap': !responsivenessActive || !(lastMinimizedElement < headerResponsivenessProperties.length - 1) }\">\n\n\n      <div class=\"ex-list-header-toggle-div\" *ngIf=\"fullPage\">\n        <div class=\"ex-list-header-title-wrapper\">\n          <div class=\"ex-list-primary-title\">\n            <button (click)=\"onCloseRightSide()\" class=\"sel-ex-list-header-back ex-list-main-header-back-button\"\n                    [attr.aria-label]=\"title() | translate\" [exTooltip]=\"title() | translate\">\n              <i [ngClass]=\"_dir === 'rtl' ? 'fa-angle-right' : 'fa-angle-left'\" class=\"fa fa-lg\"></i>\n            </button>\n            <h2>\n              <button class=\"{{'ex-list-header-back-to-list-button' | generateHTMLId}}\" (click)=\"onCloseRightSide()\">\n                <ex-svg-icon *ngIf=\"fullPageTitleIcon\" [iconName]=\"fullPageTitleIcon.iconName\"></ex-svg-icon>\n                {{title() | translate}}\n              </button>\n            </h2>\n\n          </div>\n\n        </div>\n      </div>\n\n\n      <div #headerLeft class=\"ex-list-header-left\" *ngIf=\"!fullPage\">\n        <ng-content select=\"[header-slot-0]\"></ng-content>\n        <ex-button *ngIf=\"hasRefreshButton\" class=\"ex-list-header-refresh-button\" type=\"action\" [ariaLabel]=\"'ng.general.refresh' | translate\"\n                   [uniqueSelector]=\"'ex-list-header-refresh-button'\"\n                   (click)=\"_refreshClicked()\" tooltip=\"ng.general.refresh\" ariaLabel=\"ng.general.refresh\">\n          <i class=\"fa fa-refresh\" [class.fa-spin]=\"isLoading\"></i>\n          <div class=\"ex-list-header-green-dot\" *ngIf=\"needToRefresh\"></div>\n        </ex-button>\n\n        <div #headerLeftElementCheckbox class=\"header-element header-element-checkbox\">\n          <ex-checkbox *ngIf=\"hasPickup && hasPickupCount\" [style.margin-inline-start.px]=\"hasRefreshButton ? 0 : 36\"\n                       [exTooltip]=\"'ng.ex-list-header-check-all' | translate\"\n                       [ariaLabel]=\"'ng.ex-list-header-check-all' | translate\"\n                       [checked]=\"selectedOnCurrentPage!= 0 && selectedOnCurrentPage===pageSize\"\n                       [indeterminate]=\"selectedOnCurrentPage > 0 && selectedOnCurrentPage < pageSize\"\n                       [uniqueSelector]=\"'ex-list-header-check-all'\"\n                       (checkboxChange)=\"onCheckAllChanged($event)\" class=\"ex-list-header-check-all sel-check-all\"></ex-checkbox>\n          <div class=\"ex-list-header-checkAll-divider\"\n               *ngIf=\"hasPickup &&\n              (!(\n              hasSearch &&\n              !((sorts && sorts.length > 0) && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement)) &&\n              !(showDateFilter && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_DATE_RANGE]?.order <= lastMinimizedElement))\n              ) || (filters && filters.length >0 && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement))) \"></div>\n        </div>\n\n        <div #headerLeftElementSearch class=\"ex-list-header-search-toolbar header-element header-element-search\">\n          <div class=\"ex-list-header-left-side-wrapper\">\n            <ex-button ariaLabel=\"ng.accessibility.search-btn\" tooltip=\"ng.accessibility.search-btn\"\n                       *ngIf=\"hasSearch && ((headerResponsivenessConfiguration[RESPONSIVENESS_ID_SEARCH]?.order <= lastMinimizedElement) || hasMinimizedSearch)\"\n                       [type]=\"'action'\" class=\"ex-list-header-search-toolbar-button\" [uniqueSelector]=\"'ex-list-header-search-toolbar-button'\" (click)=\"minimizedSearchOpenToggle()\">\n              <ex-svg-icon class=\"ex-search-search-icon \" iconName=\"search\" [size]=\"'small'\">\n              </ex-svg-icon>\n              <div class=\"ex-list-header-green-dot ex-list-header-search-icon\" *ngIf=\"hasAppliedSearch\"></div>\n            </ex-button>\n            <div class=\"ex-list-header-search-searchbar\"\n                 [ngClass]=\"{ 'ex-list-header-search-searchbar-minimized-open': minimizedSearchOpen }\">\n              <div class=\"ex-list-header-search-searchbar-bg\">\n                <ex-extended-search\n                  *ngIf=\"hasSearch && ((!(headerResponsivenessConfiguration[RESPONSIVENESS_ID_SEARCH]?.order <= lastMinimizedElement) && !hasMinimizedSearch) || minimizedSearchOpen)\"\n                  [autoFocus]=\"minimizedSearchOpen\" [searchFields]=\"searchByFields\"\n                  [selectedSearchField]=\"searchBySelectedField\" [blueOnFocus]=\"true\" class=\"ex-list-header-search-box\"\n                  [(searchText)]=\"searchText\" (searchTriggered)=\"_searchChange($event)\"\n                  (selectedValueChange)=\"_searchFieldChange($event)\"></ex-extended-search>\n              </div>\n              <div *ngIf=\"minimizedSearchOpen\" class=\"ex-list-header-search-searchbar-minimized-close\">\n                <ex-button [type]=\"'link'\" [uniqueSelector]=\"'ex-list-header-search-searchbar-minimized-close'\" (keydown.tab)=\"minimizedSearchOpenToggle()\" (click)=\"minimizedSearchOpenToggle()\">\n                  {{ 'ng.general.close' | translate }}\n                </ex-button>\n                <div class=\"ex-list-header-search-searchbar-minimized-end-fade\" [ngClass]=\"{ 'rtl': _dir == 'rtl' }\">\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"ex-list-header-checkAll-divider\"\n               *ngIf=\"hasMinimizedSearch && hasSearch && hasPickup &&\n              (!(\n              !hasSearch &&\n              !((sorts && sorts.length > 0) && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement)) &&\n              !(showDateFilter && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_DATE_RANGE]?.order <= lastMinimizedElement))\n              ) || (filters && filters.length >0 && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement))) \"></div>\n        </div>\n\n\n        <div #headerLeftElementSortAndFilter class=\"header-element header-element-sort-and-filter\">\n\n          <ex-floating-component *ngIf=\"sorts?.length > 0 && (headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement)\"\n                                 class = \"ex-list-header-sort-filter\" [closeFromContent]=\"true\" [uniqueSelector]=\"'ex-list-header-sort'\">\n            <ex-svg-icon trigger iconName=\"sort\" [exTooltip]=\"'ng.general.sorts' | translate\"></ex-svg-icon>\n            <ng-container content [ngTemplateOutlet]=\"sortTmpl\"></ng-container>\n          </ex-floating-component>\n          <ng-container\n            *ngIf=\"!(headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement) && sorts?.length > 0\"\n            [ngTemplateOutlet]=\"sortTmpl\">\n          </ng-container>\n          <div *ngIf=\"sorts?.length > 0 && ((filters && filters?.length >0) || showDateFilter) && !(headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement)\" class =\"ex-list-header-toggle-divider\"></div>\n          <ex-floating-component *ngIf=\"(filters && filters?.length >0) || showDateFilter\" class = \"ex-list-header-sort-filter ex-list-header-filter\" [disabled] = \"!(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement)\"\n                                 [closeFromContent]=\"true\" [uniqueSelector]=\"'ex-list-header-filter'\">\n            <ex-dot-wrapper trigger\n                            [displayDot] =\"(activeFilters?.length > 0) && filters?.length > 0\" class = \"ex-filters-filterIcon\" [exTooltip]=\"activeFilters ? ('ng.general.active-filter' | translate : {activeFilters: activeFilters}):'ng.general.filters' | translate\">\n              <i class=\"uxf-icon uxf-filter ex-filters-icon\"></i>\n            </ex-dot-wrapper>\n            <ng-container *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement)\" content\n                          [ngTemplateOutlet]=\"filterTmpl\"></ng-container>\n          </ex-floating-component>\n          <ng-container  *ngIf=\"!(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement) && ((filters && filters?.length >0) || showDateFilter)\"\n                         [ngTemplateOutlet]=\"filterTmpl\">\n          </ng-container>\n          <ng-container [ngTemplateOutlet]=\"contentTmpl1\">\n          </ng-container>\n          <ng-container [ngTemplateOutlet]=\"contentTmpl2\">\n          </ng-container>\n          <ng-container [ngTemplateOutlet]=\"contentTmpl3\">\n          </ng-container>\n        </div>\n\n        <ng-template #sortTmpl>\n          <div #headerLeftElementSort class=\"header-element header-element-sort\"\n               [ngClass]=\"{'header-element-direction-column': (headerResponsivenessConfiguration[RESPONSIVENESS_ID_SORT]?.order <= lastMinimizedElement)}\"\n               (resized)=\"onSortsResized($event)\">\n            <ex-sort *ngFor=\"let sort of sorts; let i = index\" [ngClass]=\"{'ex-list-header-sort': i != sorts.length-1}\"\n                     [order]=\"sort.order\" [sortByOptions]=\"sort.sortByOptions\" [hasOrder]=\"sort.hasOrder\"\n                     [disabled]=\"sort?.disabled\" [sortBy]=\"sort.selectedOption\" [autoComplete]=\"sort.autoComplete\"\n                     [multiLined]=\"sort.multiLined\" [sortByLabel]=\"sort.sortByLabel\" (valueChanged)=\"_sortChange($event, i)\">\n            </ex-sort>\n          </div>\n        </ng-template>\n\n        <ng-template #filterTmpl>\n          <div #headerLeftElementFilter class=\"header-element header-element-filter\"\n               (resized)=\"onFiltersResized($event)\">\n            <ex-filters *ngIf=\"filters && filters.length >0\"\n                        [ignoreSectionsLayoutViewMode]=\"true\"\n                        [ngClass]=\"{'header-element-direction-column': (headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement)}\"\n                        [minimized]=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_FILTER]?.order <= lastMinimizedElement)\"\n                        [filters]=\"filters\" [allLabel]=\"'ng.filter.all' | translate\"\n                        (selectedValueChange)=\"filterChange.emit($event)\" (defaultFilterChange)=\"activeFilters = $event\"></ex-filters>\n\n            <div #headerLeftElementDateRange class=\"header-element header-element-date\">\n              <ex-date-range-picker *ngIf=\"showDateFilter\" [blueOnFocus]=\"true\" [inListHeader]=\"true\" [uniqueSelector]=\"'ex-list-header-date-range-picker'\"\n                                    class=\"ex-list-header-date-range-picker sel-date-range-picker\" [maxDate]=\"filterMaxDate\"\n                                    [minDate]=\"filterMinDate\" (datesUpdated)=\"_datesUpdated($event)\" (clearDates)=\"_clearDates()\">\n              </ex-date-range-picker>\n            </div>\n          </div>\n        </ng-template>\n\n        <ng-template #contentTmpl1>\n          <div #headerLeftElementContent1 class=\"header-element header-element-content\">\n            <div class=\"ex-list-header-title-divider\"\n                 *ngIf=\"hasContent1\">\n            </div>\n            <div class=\"ex-list-header-content\" #content1 (resized)=\"onContentResized($event, '1')\">\n              <ng-content select=\"[header-slot-1]\"></ng-content>\n            </div>\n          </div>\n        </ng-template>\n        <ng-template #contentTmpl2>\n          <div #headerLeftElementContent2 class=\"header-element header-element-content\">\n            <div class=\"ex-list-header-title-divider\"\n                 *ngIf=\"hasContent2\">\n            </div>\n            <div class=\"ex-list-header-content\" #content2 (resized)=\"onContentResized($event, '2')\">\n              <ng-content select=\"[header-slot-2]\"></ng-content>\n            </div>\n          </div>\n        </ng-template>\n        <ng-template #contentTmpl3>\n          <div #headerLeftElementContent3 class=\"header-element header-element-content\">\n            <div class=\"ex-list-header-title-divider\"\n                 *ngIf=\"hasContent3\">\n            </div>\n            <div class=\"ex-list-header-content\" #content3 (resized)=\"onContentResized($event, '3')\">\n              <ng-content select=\"[header-slot-3]\"></ng-content>\n            </div>\n          </div>\n        </ng-template>\n\n\n      </div>\n\n\n      <div #headerRight class=\"ex-list-header-right\">\n\n\n        <div class=\"ex-list-header-right-actions\" *ngIf=\"deepLinkMode\">\n          <ng-container [ngTemplateOutlet]=\"deepLinkModeTemplate\"></ng-container>\n        </div>\n\n        <div class=\"ex-list-header-right-actions\" *ngIf=\"!fullPage\">\n\n          <div #headerRightElementActionsAndIcons class=\"header-element header-element-actions-and-icons\">\n            <ex-floating-component #headerRightElementActionsAndIconsMinimized\n                                   *ngIf=\"((headerResponsivenessConfiguration[RESPONSIVENESS_ID_ACTIONS]?.order <= lastMinimizedElement) && headerActionsList?.length > 0 && minimizableActionExists) ||\n            ((headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement) && (hasExport || hasCustomization || customizationComponent))\"\n                                   class=\"ex-list-header-actions-minimized\" [closeFromContent]=\"true\" [disabled]=\"false\" [uniqueSelector]=\"'ex-list-header-actions-minimized'\"\n                                   [menuClass]=\"'ex-list-header-actions-minimized-floating-menu'\" type=\"action\"\n                                   ariaHasPopup=\"menu\" [ariaLabel]=\"'ng.general.list_header.actions' | translate\">\n              <div trigger class=\"ex-list-header-actions-minimized-button\" [exTooltip]=\"'ng.general.list_header.actions' | translate\">\n                <i class=\"uxf-icon uxf-dot-three coolBlue\"></i>\n              </div>\n              <div content>\n                <ng-container\n                  *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ACTIONS]?.order <= lastMinimizedElement)\">\n                  <ng-container *ngTemplateOutlet=\"actionsTmpl; context: { minimizedTemplate: true }\">\n                  </ng-container>\n                </ng-container>\n                <hr *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\"\n                    class=\"ex-list-header-horizontal-menu-divider\">\n                <div header-element-actions-and-icons-icons-minimized-wrapper>\n                  <ng-container\n                    *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\"\n                    [ngTemplateOutlet]=\"iconsTmpl\">\n                  </ng-container>\n                </div>\n              </div>\n            </ex-floating-component>\n\n            <ng-container *ngTemplateOutlet=\"actionsTmpl; context: { minimizedTemplate: false }\">\n            </ng-container>\n          </div>\n\n\n\n          <ng-template #actionsTmpl let-minimizedTemplate=\"minimizedTemplate\">\n            <div #headerRightElementActions class=\"header-element header-element-actions\"\n                 [ngClass]=\"{'header-element-direction-column header-element-actions-minimized': minimizedTemplate == true }\">\n\n              <ng-container *ngFor=\"let action of headerActionsList; let i = index; let last = last\"\n                            [ngSwitch]=\"action.type\">\n\n                <ng-container *ngSwitchCase=\"ACTIONS_TYPE_POP_UP\">\n                  <ex-floating-component #floating #headerAction (menuClosed)=\"closeActionsMenu()\"\n                                         [openToSide]=\"minimizedTemplate\" (menuOpen)=\"onOpenActionMenu()\"\n                                         [disabled]=\"action.action.disabled || (numberOfCheckedItems <= 0  && !action.action.standAlone) || (!action.action.isDropdownStyle && (action.action.multiLined && fullPage))\"\n                                         [class.ex-list-header-popup-action-minimized]=\"minimizedTemplate\"\n                                         [ngClass]=\"{ 'ex-list-header-popup-action-hover': numberOfCheckedItems > 0  || action.action.standAlone }\"\n                                         [id]=\"action.type+'-'+i\" *ngIf=\"(!minimizedTemplate && ((i > lastMinimizedAction) || !action.action.canMinimize)) ||\n                                          (minimizedTemplate && ((i <= lastMinimizedAction) && action.action.canMinimize))\"\n                                         [splitButton]=\"action.action.splitButton\"\n                                         [splitButtonClass]=\"action.action.splitButton?(!minimizedTemplate ? 'uxf-down-caret' : ( _dir == 'ltr' ? 'uxf-right-caret' : 'uxf-left-caret' )):null\"\n                                         (splitButtonClick)=\"_actionClicked(action.action.value)\"\n                                         [type]=\"action.action.type\" [icon]=\"action.action.icon\"\n                                         [tooltip]=\"action.action.tooltip\" [ariaLabel]=\"action.action.label | translate\"\n                                         [uniqueSelector]=\"action.action.label\">\n                    <div trigger class=\"ex-list-header-popup-action-label\"\n                         [ngStyle]=\"{ 'color' : !minimizedTemplate && (action.action.standAlone || (numberOfCheckedItems > 0 && !action.action.standAlone)) ? '#4164a4' : (numberOfCheckedItems <= 0 && !action.action.standAlone ? '#D7D7D7' : '#000') }\">\n                      {{ action.action.label | translate }}\n                      <i *ngIf=\"!action.action.splitButton && action.action.isDropdownStyle\" class=\"uxf-icon sel-popup-action-arrow\"\n                         [ngClass]=\"!minimizedTemplate ? 'uxf-down-caret' : ( _dir == 'ltr' ? 'uxf-right-caret' : 'uxf-left-caret' )\"></i>\n                    </div>\n                    <div content>\n                      <ex-component-loader *ngIf=\"isPopUpMenuOpen\" [data]=\"action.action.component.data\"\n                                           [componentFactoryItem]=\"action.action.component\" [events]=\"action.action.component.events\">\n                      </ex-component-loader>\n                    </div>\n                  </ex-floating-component>\n                </ng-container>\n\n                <ng-container *ngSwitchCase=\"ACTIONS_TYPE_ACTIONS\">\n                  <div #headerAction [id]=\"action.type+'-'+i\" *ngIf=\"(!minimizedTemplate && ((i > lastMinimizedAction) || !action.action.canMinimize)) ||\n                    (minimizedTemplate && ((i <= lastMinimizedAction) && action.action.canMinimize))\"\n                       class=\"ex-list-header-actions-action\">\n                    <ng-container\n                      *ngIf=\"(action.action.subActions && action.action.subActions.length > 0) || getUnlistedValuesParams(action.action); else singleAction\">\n                      <ex-button type=\"action\"\n                                 [disabled]=\"action.action.disabled || (!action.action.standAlone && numberOfCheckedItems === 0) || (action.action.multiLined && fullPage)\"\n                                 [openToSide]=\"minimizedTemplate\" [children]=\"action.action.subActions\"\n                                 [iconSide]=\"!minimizedTemplate && action.action.icon?.iconName ? 'left' : null\"\n                                 [uniqueSelector]=\"'ex-list-header-multiple-actions-' + action.action.label\"\n                                 (childClicked)=\"_actionClicked($event)\" [hasSearchBox]=\"action.action.hasSearchBox\" [unlistedValuesParams]=\"getUnlistedValuesParams(action.action)\">\n                        {{ action.action.label | translate }}\n                        <div *ngIf=\"!minimizedTemplate && action.action.icon?.iconName\" icon>\n                          <i [ngClass]=\"action.action.icon?.iconName\"></i>\n                        </div>\n                      </ex-button>\n                    </ng-container>\n                    <ng-template #singleAction>\n                      <ex-button [id]=\"action.action.value\" [type]=\"action.action.type\"\n                                 (click)=\"_actionClicked(action.action.value)\"\n                                 [iconSide]=\"!minimizedTemplate && (action.action.type === 'add' || action.action.type === 'remove') ? 'left' : null\"\n                                 [disabled]=\"action.action.disabled || (!action.action.standAlone && numberOfCheckedItems === 0) || (action.action.multiLined && fullPage)\"\n                                 [ngClass]=\"(action.action.disabled || (!action.action.standAlone && numberOfCheckedItems === 0) || (action.action.multiLined && fullPage)) ? 'ex-list-header-action-button-disabled' :'ex-list-header-action-button'  \"\n                                 [class.ex-list-header-action-button-last]=\"last\"\n                                 [loading]=\"action.action.loading\"\n                                 [class.ex-list-header-popup-action-minimized]=\"minimizedTemplate\"\n                                 [tooltip]=\"action.action.tooltip\"\n                                 [uniqueSelector]=\"'ex-list-header-single-action-' + action.action.label\">\n                        <div *ngIf=\"!minimizedTemplate && action.action.icon?.iconName\" [ngClass]=\"{'ex-list-header-action-icon-button': action.action.label}\">\n                          <i [ngClass]=\"[action.action.icon?.iconName]\"></i>\n                        </div>\n                        {{ action.action.label | translate }}\n                      </ex-button>\n                    </ng-template>\n                  </div>\n                </ng-container>\n\n                <ng-container *ngSwitchCase=\"ACTIONS_TYPE_DUMMY\" >\n                  <div *ngIf=\"((i-1) > lastMinimizedAction) && !minimizedTemplate\" class = \"ex-list-header-actions-divider\">\n                  </div>\n                </ng-container>\n              </ng-container>\n\n            </div>\n          </ng-template>\n\n          <ng-container\n            *ngIf=\"!(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\"\n            [ngTemplateOutlet]=\"iconsTmpl\">\n          </ng-container>\n\n          <ng-template #iconsTmpl>\n            <div #headerRightElementIcons class=\"header-element header-element-icons\"\n                 [ngClass]=\"{ 'header-element-icons-minimized': (headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement) }\">\n              <div class=\"ex-list-header-export-icon\" *ngIf=\"hasExport\">\n                <div class=\"ex-list-header-action-divider\" *ngIf=\"actions && actions.length > 0\"></div>\n                <ex-button  *ngIf = \"(!floatingExport || !hasRecordCustomization); else floatingExportTmpl\"  id=\"exportButton\" type=\"action\" [class.ex-list-header-action-button-disabled]=\"!exportEnabled\" [tooltip]=\"exportEnabled? 'ng.export.tooltip': 'ng.general.export_disabled.tooltip'\"\n                            [ariaLabel]=\"'ng.export.tooltip' | translate\"  [disabled]=\"!exportEnabled\" [uniqueSelector]=\"'ex-list-header-export-icon'\"\n                            class=\"ex-list-header-action-button sel-list-export-button\" (click)=\"_actionClicked(floatingExport ? 'export_all' : 'export')\">\n                  <i class=\"icon-alma-ex-alma-export-doc ex-list-header-export-icon ex-list-header-icon\"></i>\n                  <span\n                    *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\">{{\n                    'ng.general.list_header.export' | translate }}</span>\n                </ex-button>\n                <ng-template #floatingExportTmpl>\n                  <ex-floating-component #floatingExport *ngIf = \"floatingExport\" type=\"action\" [tooltip]=\"exportEnabled? 'ng.general.export_to_excel': 'ng.general.export_disabled.tooltip'\"\n                                         ariaLabel=\"ng.export.tooltip\" [closeFromContent]=\"true\" [uniqueSelector]=\"'ex-list-header-floating-export'\"\n                                         [disabled]=\"!exportEnabled\" class=\"ex-list-header-export-wrapper\" ariaHasPopup=\"menu\">\n                    <div trigger id=\"exportButton\"  [class.ex-list-header-action-button-disabled]=\"!exportEnabled\"  class=\"ex-list-header-action-button sel-list-export-button\">\n                      <i class=\"icon-alma-ex-alma-export-doc ex-list-header-export-icon ex-list-header-icon\"></i>\n                      <span\n                        *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\">{{\n                        'ng.general.list_header.export' | translate }}</span>\n                    </div>\n                    <div content class=\"ex-list-header-export\" role=\"list\">\n                      <ng-container [ngTemplateOutlet]=\"exportContent\"\n                                    [ngTemplateOutletContext]=\"{label:'ng.general.export_current',action:'export_view'}\">\n                      </ng-container>\n                      <ng-container [ngTemplateOutlet]=\"exportContent\"\n                                    [ngTemplateOutletContext]=\"{label:'ng.general.export_all',action:'export_all'}\">\n                      </ng-container>\n                      <ng-template #exportContent let-label=\"label\" let-action=\"action\">\n                        <div  class=\"ex-list-header-export-content-wrapper\" tabindex=\"0\" role=\"listitem\">\n                          <ex-svg-icon [iconName]=\"'exsport-excel'\"\n                                       [color]=\"'#4164A4'\">\n                          </ex-svg-icon>\n                          <div (click)=\"exportClicked(action)\">{{label | translate}}</div>\n                        </div>\n                      </ng-template>\n                    </div>\n                  </ex-floating-component>\n                </ng-template>\n              </div>\n\n              <div *ngIf=\"hasCustomization && !isInSidePane\" class=\"ex-list-header-customization-icon\">\n                <ng-container [ngTemplateOutlet]=\"customizationButton\"></ng-container>\n              </div>\n\n              <ex-floating-component #floatingCustomization *ngIf=\"customizationComponent\"\n                                     [openToSide]=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\"\n                                     [uniqueSelector]=\"'ex-list-header-floating-customization'\"\n                                     (menuClosed)=\"closeActionsMenu()\" tooltip=\"ng.general.customize\"\n                                     ariaLabel=\"ng.general.customize\" type=\"action\" ariaHasPopup=\"dialog\">\n                <div trigger class=\"ex-list-header-action-button sel-list-customization-button\">\n                  <div class=\"ex-list-header-icon\">\n                    <i class=\"uxf-settings\"></i>\n                    <div class=\"ex-list-header-green-dot\" *ngIf=\"isCustomized\"></div>\n                  </div>\n                  <span\n                    *ngIf=\"(headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\">{{\n                    'ng.general.customize' | translate }}</span>\n                </div>\n                <div content>\n                  <ex-component-loader [data]=\"customizationComponentLoader.data\"\n                                       [componentFactoryItem]=\"customizationComponentLoader\"\n                                       [events]=\"customizationComponentLoader.events\">\n                  </ex-component-loader>\n                </div>\n              </ex-floating-component>\n            </div>\n          </ng-template>\n          <ng-container *ngIf=\"showItemsLayoutTypeToggle || itemsLayoutType == 'gallery'\">\n            <ex-button type=\"action\"\n              [tooltip]=\"itemsLayoutType == 'list' ? 'ng.items_layout.type.switch_to_table' : 'ng.items_layout.type.switch_to_record'\"\n              [ariaLabel]=\"itemsLayoutType == 'list' ? 'ng.items_layout.type.switch_to_table' : 'ng.items_layout.type.switch_to_record'\"\n              [uniqueSelector]=\"'ex-list-header-layout-type-toggle'\"\n              [uniqueSelectorState]=\"itemsLayoutType == 'list' ? 'record-layout' : 'table-layout'\"\n              (click)=\"itemsLayoutTypeToggled.emit($event)\">\n              <ex-svg-icon [iconName]=\"itemsLayoutType == 'list' ? 'table_view' : 'record_view'\"></ex-svg-icon>\n            </ex-button>\n            <div class=\"gallery-size-slider\" *ngIf=\"galleryLayoutEnabled && itemsLayoutType == 'gallery'\">-\n              <mat-slider class=\"gallery-size-slider-mat\" [class.hide-slider]=\"(itemsLayoutType !== 'gallery')\"\n                          [max]=\"400\" [min]=\"150\" [step]=\"1\" [disableRipple]=\"true\">\n                <input matSliderThumb [(ngModel)]=\"gallerySlider\">\n              </mat-slider>+\n            </div>\n          </ng-container>\n          <ex-button *ngIf=\"galleryLayoutEnabled && itemsLayoutType !== 'gallery'\" type=\"action\"\n            [tooltip]=\"'ng.items_layout.type.switch_to_gallery'\"\n            [ariaLabel]=\"'ng.items_layout.type.switch_to_gallery'\"\n            [uniqueSelector]=\"'ex-list-header-layout-type-toggle-gallery'\"\n            [uniqueSelectorState]=\"'gallery'\"\n            (click)=\"itemsLayoutTypeToggled.emit('gallery')\">\n            <ex-svg-icon [iconName]=\"'grid'\"></ex-svg-icon>\n          </ex-button>\n\n\n          <ng-container #headerRightElementToggle *ngIf=\"hasToggle && showToggle && !fullPage\"\n                        class=\"header-element header-element-toggle\">\n            <ex-button [disabled]=\"!isWideScreen && responsive\" (click)=\"onChangeView($event)\"\n                       [exTooltip]=\"(!isWideScreen && responsive?isInSidePane?'ng.general.split_screen_sidepane':'ng.general.split_screen_responsive' :viewMode=='SPLIT'?'ng.general.split_screen_icon_split':'ng.general.split_screen_icon_list') | translate\"\n                       [uniqueSelector]=\"'ex-list-header-view-mode-toggle'\" [uniqueSelectorState]=\"!(!isWideScreen && responsive) ? viewMode=='SPLIT' ? 'view-mode-split' : 'view-mode-list' : null\"\n                       type=\"action\" [ariaLabel]=\"(!isWideScreen && responsive?isInSidePane?'ng.general.split_screen_sidepane':'ng.general.split_screen_responsive' :viewMode=='SPLIT'?'ng.general.split_screen_icon_split':'ng.general.split_screen_icon_list') | translate\">\n              <ex-svg-icon class=\"ex-list-header-toggle-icon\" [iconName]=\"viewMode=='SPLIT'?'onlyList':'mediumList'\" [color]=\"!isWideScreen && responsive?'gray':'#4164A4'\" >\n              </ex-svg-icon>\n            </ex-button>\n            <ng-container *ngIf=\"!isWideScreen && responsive\" [ngTemplateOutlet]=\"helpIcon\"\n                          [ngTemplateOutletContext]=\"{icon:responsiveIcon}\">\n            </ng-container>\n            <ng-container *ngIf=\"!isWideScreen && !responsive\" [ngTemplateOutlet]=\"helpIcon\"\n                          [ngTemplateOutletContext]=\"{icon:notResponsiveIcon}\">\n            </ng-container>\n          </ng-container>\n          <ng-template #helpIcon let-icon=\"icon\">\n            <ex-help-icon #childMenu class=\"ex-list-header-help-icon sel-ex-list-header-help-icon\"\n                          [contentWidth]=\"'300px'\" [icon]=\"icon?.icon\" (click)=\"$event.stopPropagation()\">\n              <ng-container description>\n                <span>{{icon?.description |translate}} </span>\n                <ng-container *ngIf=\"!isInSidePane\">\n                  <ex-link [uniqueSelector]=\"'ex-list-header-help-icon'\" (linkClicked)=\"onHelpLinkClick()\">{{'userMenu.label.UIPreferences'|translate}}</ex-link>\n                  <span> {{'ng.general.in-user-menu' |translate}}</span>\n                </ng-container>\n              </ng-container>\n            </ex-help-icon>\n          </ng-template>\n        </div>\n\n        <ng-container *ngIf=\"fullPage && hasCustomization && !isInSidePane\" [ngTemplateOutlet]=\"customizationButton\"></ng-container>\n\n        <ng-template #customizationButton>\n          <ex-button id=\"customizationButton\" type=\"action\" [tooltip]=\"'ng.general.customize' | translate\"\n                     ariaLabel=\"ng.general.customize\" class=\"ex-list-header-action-button sel-list-customization-button\"\n                     [ngClass]=\"{'ex-list-customization-button-full-page': fullPage}\"\n                     [uniqueSelector]=\"'ex-list-header-customization-button'\"\n                     (click)=\"_customizationClicked()\">\n            <div class=\"ex-list-header-icon\">\n              <i class=\"uxf-settings\"></i>\n              <div class=\"ex-list-header-green-dot\" *ngIf=\"isCustomized\"></div>\n            </div>\n            <span *ngIf=\"!fullPage && (headerResponsivenessConfiguration[RESPONSIVENESS_ID_ICONS]?.order <= lastMinimizedElement)\">{{\n              'ng.general.customize' | translate }}</span>\n          </ex-button>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n\n  <div #headerRightElementPickupCount *ngIf=\"showFilters || ((hasPickupCount && numberOfCheckedItems > 0) && !fullPage)\"\n       class=\"header-element-pickup-count\">\n    <div *ngIf=\"showFilters\" class=\"ex-list-header-status-filter-container\">\n      <ng-container [ngTemplateOutlet]=\"statusFilter\"\n                    [ngTemplateOutletContext]=\"{filter:'all',label:('ng.general.all_results' |translate) }\">\n      </ng-container>\n      <ng-container *ngIf=\"succeededSum>0 && showSuccessItemsFilter\" [ngTemplateOutlet]=\"statusFilter\"\n                    [ngTemplateOutletContext]=\"{filter:'succeeded',label:('ng.general.success' |translate) + ' (' + succeededSum +')', iconName:'success', iconColor:'#60c05f' , tooltip: {message:'ng.general.success-tooltip', num: succeededSum}}\">\n      </ng-container>\n      <ng-container *ngIf=\"warningsSum>0\" [ngTemplateOutlet]=\"statusFilter\"\n                    [ngTemplateOutletContext]=\"{filter:'warnings',label:('ng.general.warning' | translate)+ ' (' + warningsSum +')', iconName:'warning', iconColor:'#e7a141', tooltip: {message:'ng.general.warning-tooltip', num: warningsSum}}\">\n      </ng-container>\n      <ng-container *ngIf=\"failedSum>0\" [ngTemplateOutlet]=\"statusFilter\"\n                    [ngTemplateOutletContext]=\"{filter:'failed',label: ('ng.general.failure'|translate) + ' (' + failedSum +')', iconName:'circ_warning', iconColor:'#e54746', tooltip: {message:'ng.general.fail-tooltip', num: failedSum}}\">\n      </ng-container>\n    </div>\n    <ng-template #statusFilter let-filter=\"filter\" let-label=\"label\" let-iconName = \"iconName\" let-iconColor = \"iconColor\" let-tooltip = \"tooltip\">\n      <div class = \"ex-list-header-status-filter-wrapper {{('ex-list-header-status-filter-'+filter) | generateHTMLId}}\" [class.ex-list-header-status-filter-wrapper-selected] = \"selectesStatusFilter == filter\" [exTooltip]=\"tooltip?.message |translate:{num:tooltip?.num, total:checkedSum}\">\n        <ex-svg-icon *ngIf = \"iconName\" [color]=\"iconColor\" [iconName]=\"iconName\" ></ex-svg-icon>\n        <span role=\"button\" class = \"ex-list-header-status-filter\" [class.ex-list-header-status-filter-selected] = \"selectesStatusFilter == filter\" (click)=\"bulkActionsFilterChanged(filter)\"\n              (keydown.enter)=\"bulkActionsFilterChanged(filter)\" [attr.aria-label]=\"label\" tabindex=\"0\">\n          {{label}}</span>\n      </div>\n    </ng-template>\n    <div class=\"ex-list-header-filter-vl\" *ngIf=\"showFilters && (hasPickupCount && numberOfCheckedItems > 0) && !fullPage\"></div>\n    <ng-container *ngIf=\"(hasPickupCount && numberOfCheckedItems > 0) && !fullPage\">\n      <div class=\"ex-list-header-selected-rows-count-wrapper\" [class.ex-list-header-selected-rows-count-wrapper-with-filters] =\"showFilters\"\n           [ngClass]=\"{'ex-list-header-selected-rows-count-background': numberOfCheckedItems > 0}\">\n        <ng-container *ngIf=\"numberOfCheckedItems === 1\">\n          <span class=\"ex-list-header-selected-rows-count sel-checked-items-count\">\n            {{ 'ng.list.header.single_row_selected' | translate }}\n          </span>\n        </ng-container>\n        <ng-container *ngIf=\"numberOfCheckedItems > 1\">\n          <span class=\"ex-list-header-selected-rows-count sel-checked-items-count\">\n            <span class=\"ex-list-header-selected-rows-count-bold\" >{{ numberOfCheckedItems }}</span>\n            {{ 'ng.list.header.rows_selected' | translate }}\n          </span>\n        </ng-container>\n      </div>\n    </ng-container>\n    <ex-button *ngIf=\"(hasPickupCount && numberOfCheckedItems > 0) && !fullPage\" type=\"action\" class=\"ex-list-header-action-button\"\n               [uniqueSelector]=\"'ex-list-header-clear-selection'\" (click)=\"onClearAll()\">\n      {{ 'ng.list.header.clear_selection' | translate }}</ex-button>\n  </div>\n\n</div>\n\n", styles: [".ex-list-header-ex-list-layout-header-wrapper{position:relative;padding-bottom:10px}.ex-list-header-ex-list-layout-header-wrapper.ex-list-header-border-bottom{border-bottom:1px solid #cccccc}.gallery-size-slider{display:flex;align-items:center;gap:8px;padding-inline:10px;border-radius:4px;border:1px solid #cccccc;font-weight:600;color:#4164a4;height:32px}.gallery-size-slider ::ng-deep .mat-mdc-slider{min-width:70px}.hide-slider{visibility:hidden}.ex-list-header-ex-list-layout-header-wrapper-overflow{overflow:auto}.ex-list-header-action-button-inline{flex-grow:2}.ex-list-header-action-icon-button{margin-inline-end:10px}.ex-list-header-ex-list-layout-header{display:flex;flex:1;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;align-items:center;height:var(--ex-list-header-height)}.ex-list-header-ex-list-layout-header.ex-list-header-ex-list-layout-header-wrap{flex-wrap:wrap;height:auto}.ex-list-header-ex-list-layout-header .ex-list-header-sort{margin-right:25px}.ex-list-header-ex-list-layout-header .ex-list-header-right{display:flex;flex-direction:row;align-items:center;margin-inline-start:auto;margin-top:auto}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-popup-action{padding-right:10px;padding-left:10px}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-popup-apply-button{padding:10px}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-divider{height:25px;margin-right:10px;margin-left:10px}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-toggle-layout{display:flex;flex-direction:row}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-toggle-layout .ex-list-header-toggle-button{cursor:pointer;padding:4px 10px 2px;border:0px}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-toggle-layout .ex-list-header-toggle-button .ex-list-header-full-page-button{margin-left:5px;border-radius:3px!important}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-toggle-layout button:first-child{border-radius:3px 0 0 3px}.ex-list-header-ex-list-layout-header .ex-list-header-right .ex-list-header-toggle-layout button:last-child{border-radius:0 3px 3px 0}.ex-list-header-ex-list-layout-header .ex-list-header-right ex-dropdown ::ng-deep span.ex-dropdown-placeholder{font-family:Roboto;font-style:normal;color:#4164a4}.ex-list-header-ex-list-layout-header .ex-list-header-right ex-dropdown ::ng-deep button:hover{outline:none!important;background-color:#eee;background:transparent}.ex-list-header-ex-list-layout-header .ex-list-header-right ex-dropdown ::ng-deep button:focus{outline:1px solid #000;background-color:#eee;background:transparent}.ex-list-header-ex-list-layout-header .ex-list-header-right>.ex-list-header-help-icon{margin-inline-start:6px!important}.ex-list-header-ex-list-layout-header .ex-list-header-title-divider{margin-inline-start:10px;margin-inline-end:20px;height:100%}.ex-list-header-ex-list-layout-header .ex-list-header-action-divider{margin:0 5px}.ex-list-header-ex-list-layout-header .ex-list-header-checkAll-divider{margin:0;margin-inline-start:7px;margin-inline-end:7px;height:100%}.ex-list-header-ex-list-layout-header .ex-list-header-content{display:flex;justify-content:center;flex-direction:column}.ex-list-header-ex-list-layout-header .ex-list-header-left{display:flex}.ex-list-header-ex-list-layout-header .ex-list-header-left .ex-list-header-check-all{display:flex;margin-inline-end:7px}.ex-list-header-ex-list-layout-header .ex-list-header-left .ex-list-header-check-all ::ng-deep .ex-checkbox-wrapper{padding-top:5px}.ex-list-header-ex-list-layout-header .ex-list-header-export-icon{display:flex}.ex-list-header-ex-list-layout-header .ex-list-customization-button-full-page{margin-inline-end:20px}.ex-list-header-date-range-picker{margin-inline-end:15px}.ex-list-header-date-range-picker ::ng-deep .ex-date-rane-picker-filter-dates{white-space:nowrap;overflow:hidden;margin:0!important}.ex-list-header-search-toolbar{display:flex;align-items:center}.ex-list-header-search-toolbar .ex-list-header-search-box{display:flex;flex:1;margin-inline-end:15px;margin-inline-start:8px}.ex-list-header-search-toolbar .ex-list-header-left-side-wrapper{display:flex;flex-direction:row;flex:.2;min-height:34px}.ex-list-header-search-toolbar .ex-list-header-left-side-wrapper .ex-list-header-search-icon{inset-inline-end:3px}.ex-list-header-left-margin{margin-inline-start:10px}.ex-list-header-split-sizes-toggle{margin-right:5px}.ex-list-header-right-actions{display:flex;align-items:center}.ex-list-header-toggle-div{display:grid;grid-template-areas:\"left right\"}.ex-list-header-title-wrapper{display:flex;align-content:center}.ex-list-header-title-wrapper .ex-list-main-header-back-button{border:0px;padding:0 10px;width:35px;background:none}.ex-list-header-title-wrapper .ex-list-main-header-back-button i{margin-inline-end:20px}.ex-list-header-title-wrapper .ex-list-main-header-back-button:hover,.ex-list-header-title-wrapper .alma-page-column-main-header-back-button:hover{cursor:pointer}.ex-list-header-title-wrapper .ex-list-primary-title{display:flex}.ex-list-header-title-wrapper .ex-list-primary-title h2{margin:0;align-self:center}.ex-list-header-title-wrapper .ex-list-primary-title h2 button{background-color:transparent;border:0;cursor:pointer;display:flex;align-items:center}.ex-list-header-title-wrapper .ex-list-primary-title h2 button ex-svg-icon{margin-inline-end:10px;margin-bottom:2px}.ex-list-header-green-dot{background:#2eb82e;height:10px;width:10px;border-radius:50%;position:absolute;inset-inline-end:7px;bottom:6px;border:2px solid white}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized{display:flex;flex-direction:column}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .user-top-menu-no-shadow{box-shadow:none!important;border-radius:0}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-button{cursor:pointer;padding:4px 10px 2px;border:0px;margin:5px 0;background:transparent}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-button .ex-list-header-toggle-button-content{display:flex;align-items:center;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-button .ex-list-header-toggle-button-content ex-icon{margin-inline-end:10px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-button .ex-list-header-full-page-button{margin-left:5px;border-radius:3px!important}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-split-options-panel{box-shadow:none!important;border-radius:0}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-split-options-panel mat-expansion-panel-header{height:auto!important;margin:5px 0;padding:0;font-size:inherit}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-split-options-panel .ex-list-header-toggle-button-content{display:flex;align-items:center;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-split-options-panel .ex-list-header-toggle-button-content ex-icon{margin-inline-end:10px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized .ex-list-header-toggle-split-options-panel .ex-list-header-toggle-split-options{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized button:first-child{border-radius:3px 0 0 3px}.ex-list-header-toggle-layout.ex-list-header-toggle-layout-minimized button:last-child{border-radius:0 3px 3px 0}.ex-list-header-horizontal-menu-divider{width:100%;margin:0;border-top:1px solid #bebebe}ex-filters ::ng-deep .ex-filters-wrapper{flex-direction:inherit}.ex-list-header-sort-and-filter-minimized-content{margin:10px}.header-element{display:flex;align-items:center}.header-element.header-element-content,.header-element.header-element-filter{height:100%}.header-element.header-element-direction-column{flex-direction:column;align-items:unset}.header-element.header-element-direction-column.header-element-actions-minimized{flex-direction:column-reverse}.header-element-toggle{padding-inline-start:10px;padding-inline-end:5px;background-color:#eff5f7;border-radius:3px;cursor:pointer}.header-element-toggle .ex-list-header-toggle{padding-top:2px;margin-inline-start:-5px}.header-element-toggle .ex-list-header-toggle-icon{color:#4164a4}.ex-list-header-help-icon{margin-top:5px;margin-inline-start:10px;margin-inline-end:5px}.header-element-icons-minimized{flex-direction:column;align-items:flex-start;justify-content:flex-start}.header-element-icons-minimized .ex-list-header-icon{margin-inline-end:10px!important}.ex-list-header-left-side-wrapper{position:relative}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar .ex-list-header-search-searchbar-bg ::ng-deep .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open{position:absolute;top:0;inset-inline-start:0;z-index:5;display:flex}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-bg{background-color:#fff}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-bg ::ng-deep .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-minimized-close{display:flex}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-minimized-close ex-button{background-color:#fff}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-minimized-close .ex-list-header-search-searchbar-minimized-end-fade{width:50px;height:100%;background-image:linear-gradient(to right,#fff,#fff0)}.ex-list-header-left-side-wrapper .ex-list-header-search-searchbar.ex-list-header-search-searchbar-minimized-open .ex-list-header-search-searchbar-minimized-close .ex-list-header-search-searchbar-minimized-end-fade.rtl{background-image:linear-gradient(to left,#fff,#fff0)}.header-element-pickup-count{display:flex;align-items:center;background-color:#f2f2f2;margin-top:5px}.header-element-pickup-count .ex-list-header-selected-rows-count-wrapper{padding-left:7.5px;padding-right:7.5px;border-radius:3px;margin-inline-start:35px;margin-inline-end:20px}.header-element-pickup-count .ex-list-header-selected-rows-count-wrapper-with-filters{margin-inline-start:20px!important}.ex-list-header-responsiveness-placeholder-wrapper{position:absolute;left:0;top:0;z-index:2;background-color:#fff;width:100%;height:100%;overflow:hidden}.ex-list-header-responsiveness-placeholder-wrapper .ex-list-header-responsiveness-placeholder-anim{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}.ex-list-header-responsiveness-placeholder-wrapper .ex-list-header-responsiveness-placeholder{margin-top:10px;width:100%;height:65%;background:#f3f5f4 0% 0% no-repeat padding-box;border-radius:3px;opacity:1}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}:host{--ex-list-header-height: auto;--ex-filter-max-width: unset;--ex-sort-max-width: unset}ex-filters ::ng-deep .ex-combobox-label{white-space:nowrap;overflow:hidden}ex-sort ::ng-deep .ex-sort-by-label{white-space:nowrap;overflow:hidden}.ex-list-header-actions-divider{border-inline-start:1px solid #CCCCCC;height:26px;margin-inline:10px}.header-element-actions .ex-list-header-popup-action-label{white-space:nowrap}.header-element-actions .ex-list-header-popup-action-hover:hover{background:#fff;border-radius:3px;border:0px}.header-element-actions .ex-list-header-popup-action-hover:hover.ex-list-header-popup-action-minimized{border-radius:0;box-shadow:0 0 0 1px #000}.header-element-actions .ex-list-header-action-button:hover{background-color:#eee;border-radius:3px}.header-element-actions .ex-list-header-action-button:hover.ex-list-header-popup-action-minimized{border-radius:0;box-shadow:0 0 0 1px #000}.header-element-actions .ex-list-header-action-button{color:#4164a4!important;width:100%}.header-element-actions .ex-list-header-action-button ::ng-deep button:focus{background-color:#ddd;border-radius:3px;outline:2px solid #000}.header-element-actions .ex-list-header-popup-action ::ng-deep button:focus{background-color:#e5e5e5}.header-element-actions .ex-list-header-actions-action ex-button ::ng-deep .ex-button-wrapper{width:100%;justify-content:flex-start}.header-element-actions .ex-list-header-actions-action ex-button ::ng-deep .ex-button-wrapper .tooltip-wrapper{flex:1;justify-content:space-between}.header-element-actions .ex-list-header-actions-action ex-dropdown ::ng-deep button{height:auto}.header-element-actions .ex-list-header-vertical-seperator{border-left:1px solid;height:20px}.header-element-actions .ex-list-header-split-button{display:flex;justify-content:space-between;align-items:center}.header-element-actions.header-element-actions-minimized ex-floating-component .ex-list-header-popup-action-label{display:flex;justify-content:space-between;align-items:center;padding-inline-start:0px;line-height:32px}.header-element-actions.header-element-actions-minimized ex-floating-component .sel-popup-action-arrow{margin-inline-end:10px!important}.header-element-actions.header-element-actions-minimized ex-dropdown ::ng-deep .ex-dropdown-selected.button-side-trigger{font-weight:inherit}.header-element-actions.header-element-actions-minimized ex-dropdown ::ng-deep .ex-dropdown-selected.button-side-trigger .ex-dropdown-placeholder{font-family:Roboto;font-style:normal}.header-element-actions.header-element-actions-minimized ex-dropdown ::ng-deep .ex-dropdown-selected.button-side-trigger i{color:#555}.header-element-actions.header-element-actions-minimized ex-combobox ::ng-deep .ex-combobox-button.button-side-trigger{font-weight:inherit}.header-element-actions.header-element-actions-minimized ex-combobox ::ng-deep .ex-combobox-button.button-side-trigger .sel-combobox-selected-value-placeholder{font-family:Roboto;font-style:normal}::ng-deep .ex-list-header-actions-minimized-floating-menu{margin:0!important}.ex-list-header-refresh-button{margin-inline-end:5px}.header-element-sort-and-filter .header-element-filter.header-element-filter-max-width ::ng-deep .ex-combobox-trigger-selected-value{max-width:var(--ex-filter-max-width);white-space:nowrap}.header-element-sort-and-filter .header-element-filter ::ng-deep .ex-combobox-trigger-selected-value{white-space:nowrap}.header-element-sort-and-filter .header-element-filter ::ng-deep .ex-combobox-selected-wrapper .ex-combobox-selected{white-space:nowrap}.header-element-sort-and-filter .header-element-sort.header-element-sort-max-width ::ng-deep .ex-combobox-trigger-selected-value{max-width:var(--ex-sort-max-width)}.header-element-sort-and-filter .header-element-sort ::ng-deep .ex-combobox-trigger-selected-value{white-space:nowrap}.ex-multi-layout-selection-buttons{align-self:flex-end;display:flex;width:-moz-fit-content;width:fit-content;font-family:UX-Framework}.ex-multi-layout-selection-buttons :focus{outline:none!important;border:2px solid #000;padding:3px 8px}.ex-multi-layout-selection-buttons button:first-child{border-radius:3px 0 0 3px}.ex-multi-layout-selection-buttons button:first-child :focus{outline:none!important;border:2px solid #000;border-radius:3px 0 0 3px;padding:3px 8px}.ex-multi-layout-selection-buttons button:last-child{border-radius:0 3px 3px 0}.ex-multi-layout-selection-buttons button:last-child :focus{outline:none!important;border:2px solid #000;border-radius:0 3px 3px 0;padding:3px 8px}.ex-multi-layout-selection-buttons .ex-multi-layout-select-button{padding:5px 10px;border:none}.ex-list-header-export{margin:0 -5px!important}.ex-list-header-export .ex-list-header-export-content-wrapper{display:flex;column-gap:5px;align-items:center;padding:5px}.ex-list-header-export .ex-list-header-export-content-wrapper:hover,.ex-list-header-export .ex-list-header-export-content-wrapper:focus{cursor:pointer;background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989;padding-top:4px!important;padding-bottom:4px!important}.ex-list-header-status-filter-container{display:flex;align-items:center;padding-left:7.5px;margin-inline-start:22px;column-gap:20px}.ex-list-header-filter-vl{margin-inline-start:25px;border-right:2px solid #CCCCCC;height:25px}.ex-list-header-status-filter{color:#4164a4;margin-inline-start:5px;font-size:15px}.ex-list-header-status-filter:hover{color:#1b3c72}.ex-list-header-status-filter-wrapper{display:flex;align-items:center;cursor:pointer;margin-inline-start:2px;margin-top:7px;margin-bottom:5px;padding-bottom:3px}.ex-list-header-status-filter-wrapper-selected{border-bottom:2px solid #4164a4;padding-bottom:1px!important}.ex-list-header-status-filter-selected{color:#000!important;font-weight:500}.ex-list-header-action-button-disabled{color:#d7d7d7!important}.ex-list-header-sort-filter ::ng-deep .ex-button-wrapper:disabled{color:#535353!important}.header-element-sort,.header-element-filter{margin-inline:5px}.ex-list-header-toggle-divider{margin-inline-start:10px;margin-inline-end:5px;border-inline-start:1px solid #ccc;height:100%}.ex-list-header-filter ::ng-deep .ex-button-wrapper{font-size:16px!important;margin-top:-2px!important}\n"] }]
    }], function () { return [{ type: i1.Overlay }, { type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_APP_IN_SIDEPANE]
            }] }, { type: i1$5.Location }, { type: i0.NgZone }, { type: i3$2.Router }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: ExSectionsLayoutService }, { type: ExDialogService }, { type: ExBulkActionIndicationService }]; }, { selectedOnCurrentPage: [{
            type: Input
        }], sorts: [{
            type: Input
        }], actions: [{
            type: Input
        }], bulkActions: [{
            type: Input
        }], comboboxLists: [{
            type: Input
        }], popUpActions: [{
            type: Input
        }], filters: [{
            type: Input
        }], hasSearch: [{
            type: Input
        }], searchByFields: [{
            type: Input
        }], searchBySelectedField: [{
            type: Input
        }], isItemOpen: [{
            type: Input
        }], hasToggle: [{
            type: Input
        }], hasFileToggle: [{
            type: Input
        }], showToggle: [{
            type: Input
        }], hasExport: [{
            type: Input
        }], hasBottomBorder: [{
            type: Input
        }], numberOfCheckedItems: [{
            type: Input
        }], numOfPageCheckedItems: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], hasPickup: [{
            type: Input
        }], hasPickupCount: [{
            type: Input
        }], clearAllSubject: [{
            type: Input
        }], hasCustomization: [{
            type: Input
        }], hasRecordCustomization: [{
            type: Input
        }], customizationComponent: [{
            type: Input
        }], isCustomized: [{
            type: Input
        }], responsivenessActive: [{
            type: Input
        }], needToRefresh: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], hasRefreshButton: [{
            type: Input
        }], deepLinkMode: [{
            type: Input
        }], hasMinimizedSearch: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], fullPage: [{
            type: Input
        }], itemsLayoutType: [{
            type: Input
        }], showItemsLayoutTypeToggle: [{
            type: Input
        }], itemsLayoutTypeToggled: [{
            type: Output
        }], responsive: [{
            type: Input
        }], isWideScreen: [{
            type: Input
        }], fullPageTitle: [{
            type: Input
        }], fullPageTitleIcon: [{
            type: Input
        }], floatingExport: [{
            type: Input
        }], exportEnabled: [{
            type: Input
        }], toggleisItemOpen: [{
            type: Output
        }], toggleisItemOpenSized: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], comboboxItemClicked: [{
            type: Output
        }], popupClosed: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], clearPageCheckedItems: [{
            type: Output
        }], clearCheckedItems: [{
            type: Output
        }], checkAllItems: [{
            type: Output
        }], selectedValueChange: [{
            type: Output
        }], customizationClicked: [{
            type: Output
        }], selectedOnCurrentPageChange: [{
            type: Output
        }], viewModeChange: [{
            type: Output
        }], openUserResponsiveMenu: [{
            type: Output
        }], datesUpdated: [{
            type: Output
        }], clearDates: [{
            type: Output
        }], showDateFilter: [{
            type: Input
        }], filterMaxDate: [{
            type: Input
        }], filterMinDate: [{
            type: Input
        }], searchText: [{
            type: Input
        }], deepLinkModeTemplate: [{
            type: Input
        }], closeRightSideClicked: [{
            type: Output
        }], refreshClicked: [{
            type: Output
        }], floatingComponents: [{
            type: ViewChildren,
            args: ['floating']
        }], floatingCustomization: [{
            type: ViewChild,
            args: ['floatingCustomization']
        }], toggleMenu: [{
            type: ViewChild,
            args: ['toggleMenu']
        }], childMenu: [{
            type: ViewChild,
            args: ['childMenu']
        }], headerAll: [{
            type: ViewChild,
            args: ['headerAll']
        }], headerLeft: [{
            type: ViewChild,
            args: ['headerLeft']
        }], headerRight: [{
            type: ViewChild,
            args: ['headerRight']
        }], headerElementCheckbox: [{
            type: ViewChild,
            args: ['headerLeftElementCheckbox']
        }], headerElementSearch: [{
            type: ViewChild,
            args: ['headerLeftElementSearch']
        }], headerElementSort: [{
            type: ViewChild,
            args: ['headerLeftElementSort']
        }], headerElementDateRange: [{
            type: ViewChild,
            args: ['headerLeftElementDateRange']
        }], headerElementFilter: [{
            type: ViewChild,
            args: ['headerLeftElementFilter']
        }], headerElementContent1: [{
            type: ViewChild,
            args: ['headerLeftElementContent1']
        }], headerElementContent2: [{
            type: ViewChild,
            args: ['headerLeftElementContent2']
        }], headerElementContent3: [{
            type: ViewChild,
            args: ['headerLeftElementContent3']
        }], headerLeftElementSortAndFilterMinimized: [{
            type: ViewChild,
            args: ['headerLeftElementSortAndFilterMinimized', { read: ElementRef }]
        }], headerLeftElementSortAndFilterMinimizedContent: [{
            type: ViewChild,
            args: ['headerLeftElementSortAndFilterMinimizedContent']
        }], headerElementActionsAndIcons: [{
            type: ViewChild,
            args: ['headerRightElementActionsAndIcons']
        }], headerElementActions: [{
            type: ViewChild,
            args: ['headerRightElementActionsAndIcons']
        }], actionElements: [{
            type: ViewChildren,
            args: ['headerAction', { read: ElementRef }]
        }], headerElementActionsMinimized: [{
            type: ViewChild,
            args: ['headerRightElementActionsAndIconsMinimized', { read: ElementRef }]
        }], headerElementActionsMinimizedComponent: [{
            type: ViewChild,
            args: ['headerRightElementActionsAndIconsMinimized']
        }], exportMenu: [{
            type: ViewChild,
            args: ['floatingExport']
        }], headerElementIcons: [{
            type: ViewChild,
            args: ['headerRightElementIcons']
        }], headerElementToggle: [{
            type: ViewChild,
            args: ['headerRightElementToggle']
        }], headerElementPickupCount: [{
            type: ViewChild,
            args: ['headerRightElementPickupCount']
        }], headerContent1Element: [{
            type: ViewChild,
            args: ['content1']
        }], headerContent2Element: [{
            type: ViewChild,
            args: ['content2']
        }], headerContent3Element: [{
            type: ViewChild,
            args: ['content3']
        }], headerResponsivenessOrderConfig: [{
            type: Input
        }], exlistheaderheightCssVar: [{
            type: HostBinding,
            args: ['style.--ex-list-header-height']
        }], exFitlerMaxWidthCssVar: [{
            type: HostBinding,
            args: ['style.--ex-filter-max-width']
        }], exSortMaxWidthCssVar: [{
            type: HostBinding,
            args: ['style.--ex-sort-max-width']
        }], galleryLayoutEnabled: [{
            type: Input
        }], gallerySlider: [{
            type: Input
        }], gallerySliderChange: [{
            type: Output
        }], onChangeView: [] }); })();

const Animations$4 = [
    trigger('floating', [
        transition('void => *', [
            style({
                transform: 'translateY(50px)'
            }),
            animate(300)
        ])
    ])
];

function PaginationFloatingComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
const _c0$15 = function (a0) { return { "pagination-floating-button-disabled": a0 }; };
class PaginationFloatingComponent {
    /**
     * @ignore
     */
    constructor(translateService) {
        this.translateService = translateService;
        /**
         * event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        this.errorMessage = '';
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedPage') || changes.hasOwnProperty('totalPages')) {
            const paramLabels = {
                firstPage: 1,
                currentPage: this.selectedPage,
                lastPage: this.totalPages
            };
            this.pageOfTotalPagesLabel = this.translateService.instant('ng.general.pagination.page-of-total-pages', paramLabels);
            this.pageBetweenLabel = this.translateService.instant('pagination.enter_number_between', paramLabels);
        }
    }
    onPageChange() {
        if (this.page.trim() === '') {
            return;
        }
        const num = Number(this.page);
        this.page = '';
        if (Number.isInteger(num) && num > 0 && num <= this.totalPages) {
            this.selectedPageChange.emit(num);
        }
        else {
            this.errorMessage = this.pageBetweenLabel;
        }
    }
    onPrevClicked() {
        this.selectedPageChange.emit(this.selectedPage - 1);
    }
    onNextClicked() {
        this.selectedPageChange.emit(this.selectedPage + 1);
    }
    onBlur() {
        this.errorMessage = '';
    }
    static { this.ɵfac = function PaginationFloatingComponent_Factory(t) { return new (t || PaginationFloatingComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationFloatingComponent, selectors: [["pagination-floating"]], inputs: { selectedPage: "selectedPage", totalPages: "totalPages" }, outputs: { selectedPageChange: "selectedPageChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 16, vars: 46, consts: [[1, "pagination-floating"], [1, "pagination-floating-fixed-wrapper"], ["class", "pagination-floating-error-message", 4, "ngIf"], ["mat-button", "", 3, "exTooltip", "disabled", "ngClass", "exKeyboardShortcut", "click"], [1, "pagination-floating-uxf-icon", "uxf-left-open-mini"], [3, "exTooltip", "ngModel", "placeholder", "blur", "ngModelChange", "keyup.enter"], ["mat-button", "", 3, "exTooltip", "disabled", "ngClass", "exKeyboardShortcut", "exKeyboardShortcutPosition", "click"], [1, "uxf-icon", "uxf-right-open-mini"], [1, "pagination-floating-error-message"]], template: function PaginationFloatingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, PaginationFloatingComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function PaginationFloatingComponent_Template_button_click_3_listener() { return ctx.onPrevClicked(); });
            i0.ɵɵpipe(4, "generateHTMLId");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelement(7, "i", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "input", 5);
            i0.ɵɵlistener("blur", function PaginationFloatingComponent_Template_input_blur_8_listener() { return ctx.onBlur(); })("ngModelChange", function PaginationFloatingComponent_Template_input_ngModelChange_8_listener($event) { return ctx.page = $event; })("keyup.enter", function PaginationFloatingComponent_Template_input_keyup_enter_8_listener() { return ctx.onPageChange(); });
            i0.ɵɵpipe(9, "generateHTMLId");
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "button", 6);
            i0.ɵɵlistener("click", function PaginationFloatingComponent_Template_button_click_11_listener() { return ctx.onNextClicked(); });
            i0.ɵɵpipe(12, "generateHTMLId");
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelement(15, "i", 7);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("@floating", undefined);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.errorMessage !== "");
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("pagination-floating-left-button ", i0.ɵɵpipeBind1(4, 26, "pagination-floating-left-button-prev-page"), "");
            i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(5, 28, "ng.pagination.prev_page"))("disabled", ctx.selectedPage === 1)("ngClass", i0.ɵɵpureFunction1(42, _c0$15, ctx.selectedPage === 1))("exKeyboardShortcut", ctx.selectedPage === 1 ? "" : "PaginationPrev");
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 30, "ng.pagination.prev_page"));
            i0.ɵɵadvance(5);
            i0.ɵɵclassMap(i0.ɵɵpipeBind1(9, 32, "pagination-floating-input-jump-to-page"));
            i0.ɵɵpropertyInterpolate2("exTooltip", "", i0.ɵɵpipeBind1(10, 34, "ng.paging.jump_to_page"), " - ", ctx.pageBetweenLabel, "");
            i0.ɵɵproperty("ngModel", ctx.page)("placeholder", ctx.pageOfTotalPagesLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMapInterpolate1("pagination-floating-right-button ", i0.ɵɵpipeBind1(12, 36, "pagination-floating-right-button-next-page"), "");
            i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(13, 38, "ng.pagination.next_page"))("disabled", ctx.selectedPage === ctx.totalPages)("ngClass", i0.ɵɵpureFunction1(44, _c0$15, ctx.selectedPage === ctx.totalPages))("exKeyboardShortcut", ctx.selectedPage === ctx.totalPages ? "" : "PaginationNext")("exKeyboardShortcutPosition", "end");
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(14, 40, "ng.pagination.next_page"));
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i3$3.MatButton, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExTooltipDirective, ExKeyboardShortcutDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".pagination-floating[_ngcontent-%COMP%]{position:absolute;left:calc(50% - 80px);z-index:200}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]{box-shadow:0 0 16px -1px #00000096;border-radius:4px!important;position:fixed;bottom:20px;display:flex;align-items:stretch}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:34px;height:34px;border:0px;min-width:0px;padding:0!important}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding-top:6px}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   .pagination-floating-left-button[_ngcontent-%COMP%]{border-start-end-radius:0px;border-start-start-radius:4px;border-end-start-radius:4px;border-end-end-radius:0px}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   .pagination-floating-right-button[_ngcontent-%COMP%]{border-start-end-radius:4px;border-start-start-radius:0px;border-end-start-radius:0px;border-end-end-radius:4px}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   .pagination-floating-button-disabled[_ngcontent-%COMP%]{cursor:auto}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline-width:0}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{cursor:pointer}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   .pagination-floating-button-disabled[_ngcontent-%COMP%]:hover{cursor:auto}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100px;border-top:0px;border-bottom:0px;text-align:center;direction:inherit}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline-width:0}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{color:transparent}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:-moz-placeholder{color:transparent}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::-moz-placeholder{color:transparent}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-fixed-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:-ms-input-placeholder{color:transparent}.pagination-floating[_ngcontent-%COMP%]   .pagination-floating-error-message[_ngcontent-%COMP%]{position:absolute;top:-250%;border-radius:5px;padding:15px;text-align:center}"], data: { animation: Animations$4 }, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationFloatingComponent, [{
        type: Component,
        args: [{ selector: 'pagination-floating', animations: Animations$4, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pagination-floating\">\n  <div [@floating] class=\"pagination-floating-fixed-wrapper\">\n    <div class=\"pagination-floating-error-message\" *ngIf=\"errorMessage !== ''\">{{errorMessage}}</div>\n    <button [exTooltip]=\"'ng.pagination.prev_page' | translate\"\n      [attr.aria-label]=\"'ng.pagination.prev_page' | translate\" (click)=\"onPrevClicked()\"\n      [disabled]=\"selectedPage === 1\" [ngClass]=\"{ 'pagination-floating-button-disabled': selectedPage === 1 }\"\n      mat-button class=\"pagination-floating-left-button {{'pagination-floating-left-button-prev-page' | generateHTMLId}}\" [exKeyboardShortcut]=\"selectedPage === 1 ? '' : 'PaginationPrev'\"><i\n        class=\"pagination-floating-uxf-icon uxf-left-open-mini\"></i></button>\n    <input (blur)=\"onBlur()\" class=\"{{'pagination-floating-input-jump-to-page' | generateHTMLId}}\" exTooltip=\"{{ 'ng.paging.jump_to_page' | translate }} - {{ pageBetweenLabel }}\"\n      [(ngModel)]=\"page\" (keyup.enter)=\"onPageChange()\" [placeholder]=\"pageOfTotalPagesLabel\">\n    <button [exTooltip]=\"'ng.pagination.next_page' | translate\" (click)=\"onNextClicked()\"\n      [disabled]=\"selectedPage === totalPages\" [attr.aria-label]=\"'ng.pagination.next_page' | translate\"\n      [ngClass]=\"{ 'pagination-floating-button-disabled': selectedPage === totalPages }\" mat-button\n      class=\"pagination-floating-right-button {{'pagination-floating-right-button-next-page' | generateHTMLId}}\" [exKeyboardShortcut]=\"selectedPage === totalPages ? '' : 'PaginationNext'\" [exKeyboardShortcutPosition]=\"'end'\"><i class=\"uxf-icon uxf-right-open-mini\"></i></button>\n  </div>\n</div>\n", styles: [".pagination-floating{position:absolute;left:calc(50% - 80px);z-index:200}.pagination-floating .pagination-floating-fixed-wrapper{box-shadow:0 0 16px -1px #00000096;border-radius:4px!important;position:fixed;bottom:20px;display:flex;align-items:stretch}.pagination-floating .pagination-floating-fixed-wrapper button{width:34px;height:34px;border:0px;min-width:0px;padding:0!important}.pagination-floating .pagination-floating-fixed-wrapper button i{padding-top:6px}.pagination-floating .pagination-floating-fixed-wrapper .pagination-floating-left-button{border-start-end-radius:0px;border-start-start-radius:4px;border-end-start-radius:4px;border-end-end-radius:0px}.pagination-floating .pagination-floating-fixed-wrapper .pagination-floating-right-button{border-start-end-radius:4px;border-start-start-radius:0px;border-end-start-radius:0px;border-end-end-radius:4px}.pagination-floating .pagination-floating-fixed-wrapper .pagination-floating-button-disabled{cursor:auto}.pagination-floating .pagination-floating-fixed-wrapper button:focus{outline-width:0}.pagination-floating .pagination-floating-fixed-wrapper button:hover{cursor:pointer}.pagination-floating .pagination-floating-fixed-wrapper .pagination-floating-button-disabled:hover{cursor:auto}.pagination-floating .pagination-floating-fixed-wrapper input{width:100px;border-top:0px;border-bottom:0px;text-align:center;direction:inherit}.pagination-floating .pagination-floating-fixed-wrapper input:focus{outline-width:0}.pagination-floating .pagination-floating-fixed-wrapper input:focus::-webkit-input-placeholder{color:transparent}.pagination-floating .pagination-floating-fixed-wrapper input:focus:-moz-placeholder{color:transparent}.pagination-floating .pagination-floating-fixed-wrapper input:focus::-moz-placeholder{color:transparent}.pagination-floating .pagination-floating-fixed-wrapper input:focus:-ms-input-placeholder{color:transparent}.pagination-floating .pagination-floating-error-message{position:absolute;top:-250%;border-radius:5px;padding:15px;text-align:center}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { selectedPage: [{
            type: Input
        }], totalPages: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }] }); })();

const _c0$14 = function (a0) { return { "ex-editing-entry-hide-index": a0 }; };
function EXEditingEntryComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$14, ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.entryIndex);
} }
function EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 16);
    i0.ɵɵelementContainerStart(1, 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("background", ctx_r13.entry.chip.color)("hasBorder", false)("square", true)("tooltip", ctx_r13.entry.chip.tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r13.entry.chip.text);
} }
const _c1$F = function (a0) { return { i: a0 }; };
function EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ex_dot_wrapper_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-dot-wrapper", 18);
    i0.ɵɵelementContainer(1, 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    const _r9 = i0.ɵɵreference(14);
    i0.ɵɵproperty("displayDot", ctx_r14.displayDot(ctx_r14.entry == null ? null : ctx_r14.entry.status))("color", ctx_r14.entry == null ? null : ctx_r14.entry.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c1$F, (ctx_r14.entry == null ? null : ctx_r14.entry.primaryIcon) == undefined ? ctx_r14.icon : ctx_r14.entry == null ? null : ctx_r14.entry.primaryIcon));
} }
function EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-dot-wrapper", 21);
    i0.ɵɵelement(2, "ex-svg-icon", 22);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _icon_r17 = ctx.$implicit;
    const ctx_r16 = i0.ɵɵnextContext(5);
    let tmp_7_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("displayDot", ctx_r16.displayDot(_icon_r17 == null ? null : _icon_r17.statusColor))("color", _icon_r17 == null ? null : _icon_r17.statusColor);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", _icon_r17 == null ? null : _icon_r17.iconName)("color", _icon_r17 == null ? null : _icon_r17.iconColor)("size", (_icon_r17 == null ? null : _icon_r17.iconSize) ? _icon_r17 == null ? null : _icon_r17.iconSize : "medium")("tooltip", _icon_r17 == null ? null : _icon_r17.tooltip)("callback", _icon_r17 == null ? null : _icon_r17.callback)("ariaLabel", (tmp_7_0 = i0.ɵɵpipeBind1(3, 8, _icon_r17 == null ? null : _icon_r17.tooltip) + " " + ctx_r16.entryIndex.toString()) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "");
} }
function EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ng_container_3_ng_container_1_Template, 4, 10, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r15.entry.icons)("ngForTrackBy", ctx_r15.trackByIndex);
} }
function EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ex_chip_1_Template, 3, 5, "ex-chip", 14);
    i0.ɵɵtemplate(2, EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ex_dot_wrapper_2_Template, 2, 6, "ex-dot-wrapper", 15);
    i0.ɵɵtemplate(3, EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_ng_container_3_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.entry == null ? null : ctx_r12.entry.chip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.icon || (ctx_r12.entry == null ? null : ctx_r12.entry.primaryIcon));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r12.entry.icons == null ? null : ctx_r12.entry.icons.length) > 0 && ctx_r12.entry.icons);
} }
function EXEditingEntryComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_3_ng_container_1_div_1_Template, 4, 3, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r11.entry == null ? null : ctx_r11.entry.chip) || ctx_r11.icon || (ctx_r11.entry == null ? null : ctx_r11.entry.primaryIcon) || (ctx_r11.entry.icons == null ? null : ctx_r11.entry.icons.length) > 0 && ctx_r11.entry.icons);
} }
function EXEditingEntryComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.icon || (ctx_r1.entry == null ? null : ctx_r1.entry.primaryIcon) || (ctx_r1.entry.icons == null ? null : ctx_r1.entry.icons.length) > 0 && ctx_r1.entry.icons || (ctx_r1.entry == null ? null : ctx_r1.entry.chip))("ngIfElse", _r2);
} }
function EXEditingEntryComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "div", 25)(2, "div", 26);
    i0.ɵɵelementEnd();
} }
function EXEditingEntryComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EXEditingEntryComponent_ng_template_4_div_0_Template, 3, 0, "div", 23);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.isTimeLine);
} }
function EXEditingEntryComponent_ng_container_8_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EXEditingEntryComponent_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_8_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r19.viewModeTemplate)("ngTemplateOutletContext", ctx_r19.context);
} }
function EXEditingEntryComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_8_ng_container_1_Template, 2, 2, "ng-container", 27);
    i0.ɵɵelementContainerEnd();
} }
function EXEditingEntryComponent_ng_container_9_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EXEditingEntryComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_9_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r21.editModeTemplate)("ngTemplateOutletContext", ctx_r21.context);
} }
function EXEditingEntryComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_container_9_ng_container_1_Template, 2, 2, "ng-container", 29);
    i0.ɵɵelementContainerEnd();
} }
function EXEditingEntryComponent_ng_template_10_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EXEditingEntryComponent_ng_template_10_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_template_10_ng_container_0_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r24.viewModeTemplate)("ngTemplateOutletContext", ctx_r24.context);
} }
function EXEditingEntryComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EXEditingEntryComponent_ng_template_10_ng_container_0_ng_container_1_Template, 2, 2, "ng-container", 27);
    i0.ɵɵelementContainerEnd();
} }
function EXEditingEntryComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EXEditingEntryComponent_ng_template_10_ng_container_0_Template, 2, 0, "ng-container", 3);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r7.viewModeTemplate);
} }
function EXEditingEntryComponent_ex_confirmation_message_12_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-confirmation-message", 30);
    i0.ɵɵlistener("confirmClicked", function EXEditingEntryComponent_ex_confirmation_message_12_Template_ex_confirmation_message_confirmClicked_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onEntryRemoved()); })("cancelClicked", function EXEditingEntryComponent_ex_confirmation_message_12_Template_ex_confirmation_message_cancelClicked_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.onRemoveCanceled()); });
    i0.ɵɵelementEnd();
} }
function EXEditingEntryComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 31);
} if (rf & 2) {
    const i_r29 = ctx.i;
    i0.ɵɵproperty("iconName", i_r29 == null ? null : i_r29.iconName)("color", (i_r29 == null ? null : i_r29.iconColor) ? i_r29 == null ? null : i_r29.iconColor : "#4164A4")("size", (i_r29 == null ? null : i_r29.iconSize) ? i_r29 == null ? null : i_r29.iconSize : "xxlarge")("tooltip", i_r29 == null ? null : i_r29.tooltip);
} }
const _c2$t = function (a0) { return { "name": a0, "type": "uxf" }; };
class EXEditingEntryComponent extends TrackedEditableEntryComponent {
    constructor(sectionLayoutViewModeObservable, cdr, translate) {
        super(sectionLayoutViewModeObservable, cdr, translate);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.translate = translate;
        /**
         * display time line bullets when no icon
         */
        this.isTimeLine = true;
        this.entryIndex = -1;
        this.loading = true;
        this.hidePrefixPlaceHolder = false;
        /**
         * if to display the three dots containing the actions on hover
         */
        this.displayActionsOnHover = false;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    getDisplayActionsOnHover() {
        return this.displayActionsOnHover;
    }
    displayDot(entry) {
        return entry in dotColor ? true : false;
    }
    trackByIndex(index, item) {
        return index;
    }
    static { this.ɵfac = function EXEditingEntryComponent_Factory(t) { return new (t || EXEditingEntryComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EXEditingEntryComponent, selectors: [["ex-editing-entry"]], inputs: { icon: "icon", isTimeLine: "isTimeLine", entryIndex: "entryIndex", loading: "loading", hidePrefixPlaceHolder: "hidePrefixPlaceHolder", displayActionsOnHover: "displayActionsOnHover" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 15, consts: [[1, "editing-list-wrapper"], [1, "editing-entry-prefix-wrapper"], [3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["timeLine", ""], [3, "actions"], [3, "editMode", "editTitle", "isSingleSave", "editTitleIcon", "uniqueSelector", "actionChildrenButtons", "moreActionsLabel", "editModeChange", "closeClicked"], ["view", ""], ["message", "ng.general.delete-confirmation", 3, "confirmClicked", "cancelClicked", 4, "ngIf"], ["iconTemplate", ""], [3, "ngClass"], [4, "ngIf", "ngIfElse"], ["class", "editing-list-image-wrapper", 4, "ngIf"], [1, "editing-list-image-wrapper"], ["class", "ex-editing-entry-chip", "fontColor", "white", "size", "small", 3, "background", "hasBorder", "square", "tooltip", 4, "ngIf"], [3, "displayDot", "color", 4, "ngIf"], ["fontColor", "white", "size", "small", 1, "ex-editing-entry-chip", 3, "background", "hasBorder", "square", "tooltip"], ["text", ""], [3, "displayDot", "color"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "editing-list-icon", 3, "displayDot", "color"], [3, "iconName", "color", "size", "tooltip", "callback", "ariaLabel"], ["class", "editing-list-line-wrapper", 4, "ngIf"], [1, "editing-list-line-wrapper"], [1, "timeline-line-dot"], [1, "editing-list-line"], [4, "viewModeComponent"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "editModeComponent"], ["message", "ng.general.delete-confirmation", 3, "confirmClicked", "cancelClicked"], [3, "iconName", "color", "size", "tooltip"]], template: function EXEditingEntryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, EXEditingEntryComponent_span_2_Template, 2, 4, "span", 2);
            i0.ɵɵtemplate(3, EXEditingEntryComponent_ng_container_3_Template, 2, 2, "ng-container", 3);
            i0.ɵɵtemplate(4, EXEditingEntryComponent_ng_template_4_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "ex-right-click-actions", 5)(7, "ex-inline-editing", 6);
            i0.ɵɵlistener("editModeChange", function EXEditingEntryComponent_Template_ex_inline_editing_editModeChange_7_listener($event) { return ctx.editMode = $event; })("editModeChange", function EXEditingEntryComponent_Template_ex_inline_editing_editModeChange_7_listener($event) { return ctx.onEditModeChanged($event); })("closeClicked", function EXEditingEntryComponent_Template_ex_inline_editing_closeClicked_7_listener() { return ctx.onCloseClicked(); });
            i0.ɵɵtemplate(8, EXEditingEntryComponent_ng_container_8_Template, 2, 0, "ng-container", 3);
            i0.ɵɵtemplate(9, EXEditingEntryComponent_ng_container_9_Template, 2, 0, "ng-container", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, EXEditingEntryComponent_ng_template_10_Template, 1, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(12, EXEditingEntryComponent_ex_confirmation_message_12_Template, 1, 0, "ex-confirmation-message", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, EXEditingEntryComponent_ng_template_13_Template, 1, 4, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            let tmp_9_0;
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.entryIndex > -1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.hidePrefixPlaceHolder);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("actions", ctx._actions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editMode", ctx.editMode)("editTitle", ctx.editTitle)("isSingleSave", false)("editTitleIcon", i0.ɵɵpureFunction1(13, _c2$t, ctx.editIconType))("uniqueSelector", "ex-editing-entry")("actionChildrenButtons", ctx._actions)("moreActionsLabel", (tmp_9_0 = ctx.entryIndex.toString()) !== null && tmp_9_0 !== undefined ? tmp_9_0 : "");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.viewModeTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.editModeTemplate && ctx.entry.isEditableEntry != false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx._showConfirmationMessage);
        } }, styles: [".editing-list-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;min-height:40px}.editing-list-wrapper[_ngcontent-%COMP%]   .editing-entry-prefix-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;padding-bottom:4px}.editing-list-wrapper[_ngcontent-%COMP%]   .ex-editing-entry-hide-index[_ngcontent-%COMP%]{visibility:hidden}.editing-list-wrapper[_ngcontent-%COMP%]   ex-right-click-actions[_ngcontent-%COMP%]{flex:1;margin-inline-start:5px;margin-bottom:10px;margin-top:-12px}.editing-list-wrapper[_ngcontent-%COMP%]   .ex-editing-entry-chip[_ngcontent-%COMP%]{padding-top:5px;padding-bottom:5px}.editing-list-line-wrapper[_ngcontent-%COMP%]{--timeline-line-color: #c7c4c4;display:flex;flex-direction:column;padding-top:5px}.editing-list-line-wrapper[_ngcontent-%COMP%]   .editing-list-line[_ngcontent-%COMP%]{border-right:2px solid var(--timeline-line-color);width:0px;height:100%;margin-left:3px;margin-right:3px}.editing-list-line-wrapper[_ngcontent-%COMP%]   .timeline-line-dot[_ngcontent-%COMP%]{height:9px;width:9px;border-radius:50%;background:var(--timeline-line-color);margin-top:0;margin-bottom:5px;padding-bottom:9px}.editing-list-info-wrapper[_ngcontent-%COMP%]{width:100%;position:relative;margin-left:5px;margin-bottom:5px}.editing-list-info-wrapper.editing-list-info-wrapper-focus-border[_ngcontent-%COMP%]{border:2px solid #1079b3!important}.editing-list-info-wrapper.editing-list-info-wrapper-no-focus-border[_ngcontent-%COMP%]{border:2px solid transparent!important}.editing-list-info-wrapper[_ngcontent-%COMP%]   .editing-list-info-edit-button[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;background:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end;top:0;right:0}.editing-list-info-wrapper[_ngcontent-%COMP%]   .editing-list-info-edit-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-top:5px;margin-right:5px}.editing-list-info-wrapper[_ngcontent-%COMP%]   .editing-list-edit-close-button[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px}.editing-list-info-wrapper[_ngcontent-%COMP%]   .editing-list-info-delete-button[_ngcontent-%COMP%]{position:absolute;bottom:10px;right:10px;color:#4164a4!important;background-color:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end}.editing-list-information-display[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));grid-gap:.5rem;align-items:flex-start;grid-auto-flow:row;width:100%;margin-left:10px;margin-right:30px}.editing-list-information-display[_ngcontent-%COMP%]   .editing-list-information-display-row[_ngcontent-%COMP%]{margin-left:5px;grid-column:span 3}.editing-list-information-display-dates[_ngcontent-%COMP%]{display:flex;justify-content:flex-start}.editing-list-information-display-dates[_ngcontent-%COMP%]   right-pane-display-field[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.editing-list-information-display-dates[_ngcontent-%COMP%]   .date-delimiter[_ngcontent-%COMP%]{white-space:pre}.editing-list-edit-form[_ngcontent-%COMP%]{width:100%;margin:5px 10px}.editing-list-edit-form[_ngcontent-%COMP%]     .mdc-button__label{justify-content:space-between}.editing-list-image-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.editing-list-icon[_ngcontent-%COMP%]{margin-top:7px;row-gap:7px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EXEditingEntryComponent, [{
        type: Component,
        args: [{ selector: 'ex-editing-entry', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"editing-list-wrapper\">\n  <div class=\"editing-entry-prefix-wrapper\">\n      <span *ngIf=\"entryIndex > -1\" [ngClass]=\"{'ex-editing-entry-hide-index': loading}\">{{ entryIndex }}</span>\n    <ng-container *ngIf=\"!hidePrefixPlaceHolder\">\n      <ng-container *ngIf = \"icon || entry?.primaryIcon || (entry.icons?.length > 0 && entry.icons) || entry?.chip; else timeLine\">\n        <div *ngIf = \"entry?.chip || icon || entry?.primaryIcon || (entry.icons?.length > 0 && entry.icons)\" class=\"editing-list-image-wrapper\">\n          <ex-chip *ngIf=\"entry?.chip\" [background]=\"entry.chip.color\" [hasBorder]=\"false\" class = \"ex-editing-entry-chip\"\n                   [square]=\"true\" [tooltip]=\"entry.chip.tooltip\" fontColor=\"white\" size=\"small\">\n            <ng-container text>{{entry.chip.text}}</ng-container>\n          </ex-chip>\n          <ex-dot-wrapper  *ngIf = \"icon || entry?.primaryIcon\" [displayDot]=\"displayDot(entry?.status)\" [color]=\"entry?.status\">\n            <ng-container [ngTemplateOutlet]=\"iconTemplate\"\n                          [ngTemplateOutletContext]=\"{i:(entry?.primaryIcon == undefined ? icon : entry?.primaryIcon)}\">\n            </ng-container>\n          </ex-dot-wrapper>\n          <ng-container *ngIf=\"entry.icons?.length > 0 && entry.icons\">\n            <ng-container *ngFor=\"let _icon of entry.icons; trackBy:trackByIndex;\">\n              <ex-dot-wrapper [displayDot]=\"displayDot(_icon?.statusColor)\" [color]=\"_icon?.statusColor\" class=\"editing-list-icon\">\n                <ex-svg-icon [iconName]=\"_icon?.iconName\"\n                             [color]=\"_icon?.iconColor\" [size]=\"_icon?.iconSize?_icon?.iconSize:'medium'\"\n                             [tooltip]=\"_icon?.tooltip\" [callback]=\"_icon?.callback\" [ariaLabel]=\"(_icon?.tooltip | translate) +' '+entryIndex.toString()??''\"></ex-svg-icon>\n              </ex-dot-wrapper>\n            </ng-container>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n    <ng-template #timeLine>\n      <div *ngIf=\"isTimeLine\"\n           class=\"editing-list-line-wrapper\">\n        <div class=\"timeline-line-dot\"></div>\n        <div class=\"editing-list-line\"></div>\n      </div>\n    </ng-template>\n\n  </div>\n  <ex-right-click-actions [actions]=\"_actions\">\n    <ex-inline-editing [(editMode)]=\"editMode\" (editModeChange)=\"onEditModeChanged($event)\" [editTitle]=\"editTitle\"\n        [isSingleSave]=\"false\" [editTitleIcon]=\"{ 'name': editIconType, 'type': 'uxf' }\" [uniqueSelector]=\"'ex-editing-entry'\"\n        (closeClicked)=\"onCloseClicked()\" [actionChildrenButtons]=\"_actions\" [moreActionsLabel]=\"entryIndex.toString()??''\">\n        <ng-container *ngIf=\"viewModeTemplate\">\n            <ng-container *viewModeComponent>\n                <ng-container *ngTemplateOutlet=\"viewModeTemplate; context: context\">\n                </ng-container>\n            </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"editModeTemplate && entry.isEditableEntry != false\">\n            <ng-container *editModeComponent>\n                <ng-container *ngTemplateOutlet=\"editModeTemplate; context: context\">\n                </ng-container>\n            </ng-container>\n        </ng-container>\n    </ex-inline-editing>\n  </ex-right-click-actions>\n\n    <ng-template #view>\n        <ng-container *ngIf=\"viewModeTemplate\">\n            <ng-container *viewModeComponent>\n                <ng-container *ngTemplateOutlet=\"viewModeTemplate; context: context\">\n                </ng-container>\n            </ng-container>\n        </ng-container>\n    </ng-template>\n\n    <ex-confirmation-message *ngIf=\"_showConfirmationMessage\" message=\"ng.general.delete-confirmation\"\n        (confirmClicked)=\"onEntryRemoved()\" (cancelClicked)=\"onRemoveCanceled()\">\n    </ex-confirmation-message>\n</div>\n\n<ng-template #iconTemplate let-i=\"i\">\n    <ex-svg-icon [iconName]=\"i?.iconName\" [color]=\"i?.iconColor ? i?.iconColor: '#4164A4'\"\n        [size]=\"i?.iconSize? i?.iconSize : 'xxlarge'\" [tooltip]=\"i?.tooltip\">\n    </ex-svg-icon>\n</ng-template>\n", styles: [".editing-list-wrapper{display:flex;flex-direction:row;min-height:40px}.editing-list-wrapper .editing-entry-prefix-wrapper{display:flex;flex-direction:column;align-items:center;padding-bottom:4px}.editing-list-wrapper .ex-editing-entry-hide-index{visibility:hidden}.editing-list-wrapper ex-right-click-actions{flex:1;margin-inline-start:5px;margin-bottom:10px;margin-top:-12px}.editing-list-wrapper .ex-editing-entry-chip{padding-top:5px;padding-bottom:5px}.editing-list-line-wrapper{--timeline-line-color: #c7c4c4;display:flex;flex-direction:column;padding-top:5px}.editing-list-line-wrapper .editing-list-line{border-right:2px solid var(--timeline-line-color);width:0px;height:100%;margin-left:3px;margin-right:3px}.editing-list-line-wrapper .timeline-line-dot{height:9px;width:9px;border-radius:50%;background:var(--timeline-line-color);margin-top:0;margin-bottom:5px;padding-bottom:9px}.editing-list-info-wrapper{width:100%;position:relative;margin-left:5px;margin-bottom:5px}.editing-list-info-wrapper.editing-list-info-wrapper-focus-border{border:2px solid #1079b3!important}.editing-list-info-wrapper.editing-list-info-wrapper-no-focus-border{border:2px solid transparent!important}.editing-list-info-wrapper .editing-list-info-edit-button{position:absolute;width:100%;height:100%;background:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end;top:0;right:0}.editing-list-info-wrapper .editing-list-info-edit-button i{margin-top:5px;margin-right:5px}.editing-list-info-wrapper .editing-list-edit-close-button{position:absolute;top:10px;right:10px}.editing-list-info-wrapper .editing-list-info-delete-button{position:absolute;bottom:10px;right:10px;color:#4164a4!important;background-color:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end}.editing-list-information-display{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));grid-gap:.5rem;align-items:flex-start;grid-auto-flow:row;width:100%;margin-left:10px;margin-right:30px}.editing-list-information-display .editing-list-information-display-row{margin-left:5px;grid-column:span 3}.editing-list-information-display-dates{display:flex;justify-content:flex-start}.editing-list-information-display-dates right-pane-display-field{width:-moz-fit-content;width:fit-content}.editing-list-information-display-dates .date-delimiter{white-space:pre}.editing-list-edit-form{width:100%;margin:5px 10px}.editing-list-edit-form ::ng-deep .mdc-button__label{justify-content:space-between}.editing-list-image-wrapper{display:flex;flex-direction:column}.editing-list-icon{margin-top:7px;row-gap:7px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { icon: [{
            type: Input
        }], isTimeLine: [{
            type: Input
        }], entryIndex: [{
            type: Input
        }], loading: [{
            type: Input
        }], hidePrefixPlaceHolder: [{
            type: Input
        }], displayActionsOnHover: [{
            type: Input
        }] }); })();

const _c0$13 = ["editingEntry"];
function EditingListComponent_ex_list_header_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-list-header", 8);
    i0.ɵɵlistener("searchChange", function EditingListComponent_ex_list_header_0_Template_ex_list_header_searchChange_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onSearchChange($event)); })("sortChange", function EditingListComponent_ex_list_header_0_Template_ex_list_header_sortChange_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.sortChange.emit($event)); })("filterChange", function EditingListComponent_ex_list_header_0_Template_ex_list_header_filterChange_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.filterChange.emit($event)); })("refreshClicked", function EditingListComponent_ex_list_header_0_Template_ex_list_header_refreshClicked_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.refreshClicked.emit()); })("actionClicked", function EditingListComponent_ex_list_header_0_Template_ex_list_header_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.actionClicked.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("responsivenessActive", true)("sorts", ctx_r0.listProperties.sorts)("filters", ctx_r0.listProperties.filters)("hasBottomBorder", false)("searchByFields", ctx_r0.listProperties.searchByFields)("exportEnabled", ctx_r0.exportEnabled)("hasSearch", ctx_r0.listProperties.hasSearch)("hasMinimizedSearch", true)("searchText", ctx_r0.listProperties.searchText)("searchBySelectedField", ctx_r0.listProperties.searchBySelectedField)("hasExport", ctx_r0.listProperties.hasExport)("hasRefreshButton", ctx_r0.listProperties.hasRefreshButton)("needToRefresh", ctx_r0.listProperties.needToRefresh);
} }
function EditingListComponent_ng_container_2_ex_drag_accessible_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-drag-accessible-icon", 15);
} }
const _c1$E = function (a0) { return { "ex-editing-list-hide-index": a0 }; };
function EditingListComponent_ng_container_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r12 = i0.ɵɵnextContext().index;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$E, ctx_r16.listProperties.isLoading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r16.listProperties.pagination.selectedPage - 1) * ctx_r16.listProperties.pagination.pageSize + i_r12 + 1, " ");
} }
function EditingListComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 9);
    i0.ɵɵelementStart(1, "div", 10, 11);
    i0.ɵɵtemplate(3, EditingListComponent_ng_container_2_ex_drag_accessible_icon_3_Template, 1, 0, "ex-drag-accessible-icon", 12);
    i0.ɵɵtemplate(4, EditingListComponent_ng_container_2_span_4_Template, 2, 4, "span", 13);
    i0.ɵɵelementStart(5, "ex-editing-entry", 14);
    i0.ɵɵlistener("editModeChanged", function EditingListComponent_ng_container_2_Template_ex_editing_entry_editModeChanged_5_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onEditModeChanged($event)); })("close", function EditingListComponent_ng_container_2_Template_ex_editing_entry_close_5_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r19); const i_r12 = restoredCtx.index; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onEntryClosed($event, i_r12)); })("entryRemoved", function EditingListComponent_ng_container_2_Template_ex_editing_entry_entryRemoved_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const i_r12 = restoredCtx.index; const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onEntryRemoved(i_r12)); })("actionClicked", function EditingListComponent_ng_container_2_Template_ex_editing_entry_actionClicked_5_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.itemActionClicked.emit($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entry_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const isLast_r13 = ctx.last;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("editing-list-wrapper editing-list sel-editing-list-row-", i_r12 + 1, "");
    i0.ɵɵclassProp("editing-list-wrapper-odd", i_r12 % 2 === 0);
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r1.draggable || ctx_r1.isReadOnly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.draggable && !ctx_r1.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.newSectionsDesign && ctx_r1.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionChildrenButtons", ctx_r1.actionChildrenButtons)("entryIndex", ctx_r1.newSectionsDesign && ctx_r1.listProperties.hasIndex ? (ctx_r1.listProperties.pagination.selectedPage - 1) * ctx_r1.listProperties.pagination.pageSize + (i_r12 + 1) : -1)("loading", ctx_r1.listProperties.isLoading)("isToSetDefaultDeleteButton", ctx_r1.isToSetDefaultDeleteButton)("hidePrefixPlaceHolder", ctx_r1.hidePrefixPlaceHolder)("viewModeTemplate", ctx_r1._viewModeTemplate ? ctx_r1._viewModeTemplate : ctx_r1.viewModeTemplate)("editModeTemplate", ctx_r1.disableClickInViewMode && ctx_r1.isReadOnly || ctx_r1.isEntryEditable && !ctx_r1.isEntryEditable(entry_r11) ? null : ctx_r1._editModeTemplate ? ctx_r1._editModeTemplate : ctx_r1.editModeTemplate)("index", i_r12)("entry", entry_r11)("icon", ctx_r1.icon)("displayActionsOnHover", ctx_r1.displayActionsOnHover)("editMode", ctx_r1.isEditMode(entry_r11, isLast_r13))("editTitle", entry_r11.isNew ? ctx_r1.editTitleNew : ctx_r1.editTitleEdit)("editIconType", entry_r11.isNew ? ctx_r1.editIconTypeNew : ctx_r1.editIconTypeEdit)("isTimeLine", ctx_r1.isTimeLine);
} }
function EditingListComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementStart(3, "p", 19);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 1, ctx_r2.noResultsLabel), " ");
} }
function EditingListComponent_ex_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 20);
    i0.ɵɵlistener("click", function EditingListComponent_ex_button_4_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.addEntry()); })("childClicked", function EditingListComponent_ex_button_4_Template_ex_button_childClicked_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.childClicked($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-editing-list-add-button sel-editing-list-add-", ctx_r3.addButtonLabel, "");
    i0.ɵɵproperty("children", ctx_r3.addButtonChildren)("exTooltip", i0.ɵɵpipeBind1(1, 7, ctx_r3.addButtonTooltip))("uniqueSelector", "ex-editing-list-add-button");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, ctx_r3.addButtonLabel), "\n");
} }
function EditingListComponent_pagination_floating_8_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pagination-floating", 21);
    i0.ɵɵlistener("selectedPageChange", function EditingListComponent_pagination_floating_8_Template_pagination_floating_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.selectedPageChange.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("totalPages", ctx_r4.totalPages)("selectedPage", ctx_r4.listProperties.pagination.selectedPage);
} }
const _c2$s = [[["", "bottom-actions", ""]]];
const _c3$k = ["[bottom-actions]"];
const EX_EDITING_LIST = new InjectionToken('is editing list');
class EditingListComponent extends TrackedEditableEntryListComponent {
    constructor(sectionLayoutViewModeObservable, newSectionsDesign, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.newSectionsDesign = newSectionsDesign;
        this.cdr = cdr;
        this.PAGE_SIZE = 5;
        /**
         * option to hve D&D
         */
        this.draggable = false;
        /**
         * add button label
         */
        this.addButtonLabel = 'ng.general.add';
        /**
         * whether the prefix on the left will be present or not
         */
        this.hidePrefixPlaceHolder = false;
        /**
         * click will be disabled when in view mode
         */
        this.disableClickInViewMode = false;
        /**
         * if to display the three dots containing the actions on hover
         */
        this.displayActionsOnHover = false;
        /**
         * display time line bullets when no icon
         */
        this.isTimeLine = true;
        /**
         * Configuration of the list
         */
        this.listProperties = new ListProperties();
        this.noResultsLabel = 'ng.editing-list.no_results_placeholder';
        this.newExport = false;
        /**
         * In case of D&D changed will emit the updated list
         */
        this.editingListChanged = new EventEmitter();
        /**
         * entry was deleted emit the index
         */
        this.editingEntryDeleted = new EventEmitter();
        /**
         * Need to catch this one and add new entry in your component - please see md file for more information
         */
        this.editingEntryAdded = new EventEmitter();
        /**
         * Event fired when one of the search change
         */
        this.searchChange = new EventEmitter();
        /**
         * Event fired when one of the sort change
         */
        this.sortChange = new EventEmitter();
        /**
         * Event fired when one of the filter change
         */
        this.filterChange = new EventEmitter();
        /**
         * Event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        /**
         * Event emitted when 'refresh' button is clicked
         */
        this.refreshClicked = new EventEmitter();
        this.actionClicked = new EventEmitter();
        this.itemActionClicked = new EventEmitter();
        this.export = new EventEmitter();
        this.hasSearch = false;
        this.listProperties.pagination.pageSize = this.PAGE_SIZE;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('addButtonChildren')) {
            this.setChildrenAddFunction(this.addButtonChildren);
        }
    }
    get totalPages() {
        return Math.ceil(this.listProperties?.pagination.totalItemsCount / this.listProperties?.pagination.pageSize);
    }
    ;
    get showListHeader() {
        const { searchByFields, sorts, filters, hasRefreshButton } = this.listProperties;
        return ((this.hasSearch || this.entries.length > 0) && (searchByFields?.length > 0 || sorts?.length > 0 || filters?.length > 0 || hasRefreshButton));
    }
    dropEntry(event) {
        const entries = [...this.entries];
        moveItemInArray(entries, event.previousIndex, event.currentIndex);
        this.entries = entries;
        this.editingListChanged.emit(entries.map(e => e.data));
    }
    addEntry(key) {
        super.addEntry(key);
        if (this.addButtonChildren.length === 0) {
            this.scrollToLastEntry();
        }
    }
    childClicked(key) {
        this.scrollToLastEntry();
    }
    scrollToLastEntry() {
        setTimeout(() => {
            scrollIntoView(this.editingEntryItems.last.nativeElement, {
                scrollMode: 'if-needed',
                block: 'nearest',
                inline: 'nearest',
            });
            this.cdr.markForCheck();
        }, 200);
    }
    onSearchChange(search) {
        this.searchChange.emit(search);
        this.hasSearch = search.searchText?.length > 0 ? true : false;
    }
    static { this.ɵfac = function EditingListComponent_Factory(t) { return new (t || EditingListComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(NEW_SECTIONS_DESIGN, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditingListComponent, selectors: [["ex-editing-list"]], viewQuery: function EditingListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$13, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editingEntryItems = _t);
        } }, hostBindings: function EditingListComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("add", function EditingListComponent_add_HostBindingHandler($event) { return ctx.editingEntryAdded.emit($event); })("remove", function EditingListComponent_remove_HostBindingHandler($event) { return ctx.editingEntryDeleted.emit($event); });
        } }, inputs: { icon: "icon", draggable: "draggable", addButtonLabel: "addButtonLabel", hidePrefixPlaceHolder: "hidePrefixPlaceHolder", disableClickInViewMode: "disableClickInViewMode", isEntryEditable: "isEntryEditable", displayActionsOnHover: "displayActionsOnHover", isTimeLine: "isTimeLine", actionChildrenButtons: "actionChildrenButtons", listProperties: "listProperties", noResultsLabel: "noResultsLabel", newExport: "newExport", _viewModeTemplate: "_viewModeTemplate", _editModeTemplate: "_editModeTemplate" }, outputs: { editingListChanged: "editingListChanged", editingEntryDeleted: "editingEntryDeleted", editingEntryAdded: "editingEntryAdded", searchChange: "searchChange", sortChange: "sortChange", filterChange: "filterChange", selectedPageChange: "selectedPageChange", refreshClicked: "refreshClicked", actionClicked: "actionClicked", itemActionClicked: "itemActionClicked", export: "export" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false },
                { provide: EX_EDITING_LIST, useValue: true }
            ]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3$k, decls: 9, vars: 5, consts: [["class", "ex-editing-list-list-header", 3, "responsivenessActive", "sorts", "filters", "hasBottomBorder", "searchByFields", "exportEnabled", "hasSearch", "hasMinimizedSearch", "searchText", "searchBySelectedField", "hasExport", "hasRefreshButton", "needToRefresh", "searchChange", "sortChange", "filterChange", "refreshClicked", "actionClicked", 4, "ngIf"], ["cdkDropList", "", 3, "cdkDropListDropped"], ["class", "links-drag-icons", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["type", "add", "iconSide", "left", 3, "class", "children", "exTooltip", "uniqueSelector", "click", "childClicked", 4, "ngIf"], [1, "ex-editing-list-bottom-wrapper"], [1, "ex-editing-list-bottom-actions"], ["class", "ex-editing-list-pagination", 3, "totalPages", "selectedPage", "selectedPageChange", 4, "ngIf"], [1, "ex-editing-list-list-header", 3, "responsivenessActive", "sorts", "filters", "hasBottomBorder", "searchByFields", "exportEnabled", "hasSearch", "hasMinimizedSearch", "searchText", "searchBySelectedField", "hasExport", "hasRefreshButton", "needToRefresh", "searchChange", "sortChange", "filterChange", "refreshClicked", "actionClicked"], [1, "links-drag-icons"], ["cdkDrag", "", 3, "cdkDragDisabled"], ["editingEntry", ""], ["class", "editing-list-icon", "cdkDragHandle", "", 4, "ngIf"], ["class", "ex-editing-list-index", 3, "ngClass", 4, "ngIf"], [1, "sel-editing-list-editing-entry", 3, "actionChildrenButtons", "entryIndex", "loading", "isToSetDefaultDeleteButton", "hidePrefixPlaceHolder", "viewModeTemplate", "editModeTemplate", "index", "entry", "icon", "displayActionsOnHover", "editMode", "editTitle", "editIconType", "isTimeLine", "editModeChanged", "close", "entryRemoved", "actionClicked"], ["cdkDragHandle", "", 1, "editing-list-icon"], [1, "ex-editing-list-index", 3, "ngClass"], ["role", "alert", 1, "ex-editing-list-no-entities-found-placeholder", "ex-editing-list-no-entities-flex-and-center"], [1, "ex-editing-list-no-entities-icon", "fa", "fa-list-alt"], [1, "ex-editing-list-no-entities-text"], ["type", "add", "iconSide", "left", 3, "children", "exTooltip", "uniqueSelector", "click", "childClicked"], [1, "ex-editing-list-pagination", 3, "totalPages", "selectedPage", "selectedPageChange"]], template: function EditingListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$s);
            i0.ɵɵtemplate(0, EditingListComponent_ex_list_header_0_Template, 1, 13, "ex-list-header", 0);
            i0.ɵɵelementStart(1, "ex-drag-list", 1);
            i0.ɵɵlistener("cdkDropListDropped", function EditingListComponent_Template_ex_drag_list_cdkDropListDropped_1_listener($event) { return ctx.dropEntry($event); });
            i0.ɵɵtemplate(2, EditingListComponent_ng_container_2_Template, 6, 23, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, EditingListComponent_ng_container_3_Template, 6, 3, "ng-container", 3);
            i0.ɵɵtemplate(4, EditingListComponent_ex_button_4_Template, 4, 11, "ex-button", 4);
            i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, EditingListComponent_pagination_floating_8_Template, 1, 2, "pagination-floating", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showListHeader);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.entries);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !((ctx.entries == null ? null : ctx.entries.length) > 0) || !ctx.entries);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly && !ctx.hideAddButton);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.listProperties.pagination.totalItemsCount > ctx.listProperties.pagination.pageSize);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, ExTooltipDirective, ExButtonComponent, ExDragAccessibleIconComponent, ExDragListComponent, ExListHeaderComponent, PaginationFloatingComponent, EXEditingEntryComponent, i1$2.TranslatePipe], styles: [".editing-list-darggable-icon[_ngcontent-%COMP%]{cursor:pointer;float:left;visibility:hidden;margin-top:3px}.editing-list-wrapper[_ngcontent-%COMP%]{display:flex;padding-top:12px}.editing-list-wrapper[_ngcontent-%COMP%]   .editing-list-icon[_ngcontent-%COMP%]{margin-top:12px;margin-right:12px}.editing-list-wrapper[_ngcontent-%COMP%]   ex-editing-entry[_ngcontent-%COMP%]{flex:1}.ex-editing-list-add-button[_ngcontent-%COMP%]{margin-top:10px}.ex-editing-list-index[_ngcontent-%COMP%]{margin-inline-end:10px;padding-top:4px}.ex-editing-list-hide-index[_ngcontent-%COMP%]{visibility:hidden}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]{display:flex;padding-top:10px;flex-wrap:wrap}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]   .ex-editing-list-bottom-actions[_ngcontent-%COMP%]{padding-top:7px;padding-inline-start:5px;flex:1;display:flex;flex-wrap:wrap;gap:20px}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]   .ex-editing-list-bottom-actions[_ngcontent-%COMP%]     ex-link>.ex-link-anchor{color:#4164a4!important}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]   .ex-editing-list-pagination[_ngcontent-%COMP%]{height:-moz-fit-content;height:fit-content;border:1px solid #d7d7d7;border-radius:4px}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]   .ex-editing-list-pagination[_ngcontent-%COMP%]     .pagination-floating{position:static!important}.ex-editing-list-bottom-wrapper[_ngcontent-%COMP%]   .ex-editing-list-pagination[_ngcontent-%COMP%]     .pagination-floating-fixed-wrapper{box-shadow:none;border-radius:4px!important;position:static!important}.ex-editing-list-no-entities-found-placeholder[_ngcontent-%COMP%]{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-editing-list-no-entities-flex-and-center[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditingListComponent, [{
        type: Component,
        args: [{ selector: 'ex-editing-list', host: {
                    '(add)': 'editingEntryAdded.emit($event)',
                    '(remove)': 'editingEntryDeleted.emit($event)'
                }, changeDetection: ChangeDetectionStrategy.OnPush, providers: [{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false },
                    { provide: EX_EDITING_LIST, useValue: true }
                ], template: "<ex-list-header *ngIf=\"showListHeader\" class=\"ex-editing-list-list-header\" [responsivenessActive]=\"true\"\n                [sorts]=\"listProperties.sorts\" [filters]=\"listProperties.filters\" [hasBottomBorder]=\"false\"\n                [searchByFields]=\"listProperties.searchByFields\" [exportEnabled]=\"exportEnabled\"\n                [hasSearch]=\"listProperties.hasSearch\" [hasMinimizedSearch]=\"true\" [searchText]=\"listProperties.searchText\"\n                [searchBySelectedField]=\"listProperties.searchBySelectedField\" [hasExport]=\"listProperties.hasExport\"\n                [hasRefreshButton]=\"listProperties.hasRefreshButton\" [needToRefresh]=\"listProperties.needToRefresh\"\n                (searchChange)=\"onSearchChange($event)\"\n                (sortChange)=\"sortChange.emit($event)\"\n                (filterChange)=\"filterChange.emit($event)\" (refreshClicked)=\"refreshClicked.emit()\"\n                (actionClicked)=\"actionClicked.emit($event)\">\n</ex-list-header>\n\n<ex-drag-list cdkDropList (cdkDropListDropped)=\"dropEntry($event)\">\n  <ng-container class=\"links-drag-icons\" *ngFor=\"let entry of entries; index as i; last as isLast\">\n    <div #editingEntry class=\"editing-list-wrapper editing-list sel-editing-list-row-{{i+1}}\" cdkDrag\n         [cdkDragDisabled]=\"!draggable || isReadOnly\" [class.editing-list-wrapper-odd]=\"i % 2 === 0\">\n      <ex-drag-accessible-icon class=\"editing-list-icon\" *ngIf=\"draggable && !isReadOnly\" cdkDragHandle>\n      </ex-drag-accessible-icon>\n      <span *ngIf=\"!newSectionsDesign && listProperties.hasIndex\" [ngClass]=\"{'ex-editing-list-hide-index': listProperties.isLoading}\"\n            class=\"ex-editing-list-index\">\n                {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) + i + 1) }}\n            </span>\n      <ex-editing-entry class=\"sel-editing-list-editing-entry\" [actionChildrenButtons]=\"actionChildrenButtons\" [entryIndex]=\"(newSectionsDesign && listProperties.hasIndex)? (((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize)) + (i + 1)): -1\"\n                        [loading] =\"listProperties.isLoading\" [isToSetDefaultDeleteButton]=\"isToSetDefaultDeleteButton\"\n                        [hidePrefixPlaceHolder]=\"hidePrefixPlaceHolder\"\n                        [viewModeTemplate]=\"_viewModeTemplate? _viewModeTemplate: viewModeTemplate\"\n                        [editModeTemplate]=\"((disableClickInViewMode && isReadOnly) || (isEntryEditable && !isEntryEditable(entry))) ? null : _editModeTemplate? _editModeTemplate: editModeTemplate\"\n                        [index]=\"i\" [entry]=\"entry\" [icon]=\"icon\" [displayActionsOnHover]=\"displayActionsOnHover\"\n                        [editMode]=\"isEditMode(entry, isLast)\" [editTitle]=\"entry.isNew ? editTitleNew : editTitleEdit\"\n                        [editIconType]=\"entry.isNew ? editIconTypeNew : editIconTypeEdit\" [isTimeLine] = \"isTimeLine\"\n                        (editModeChanged)=\"onEditModeChanged($event)\" (close)=\"onEntryClosed($event, i)\"\n                        (entryRemoved)=\"onEntryRemoved(i)\" (actionClicked)=\"itemActionClicked.emit($event)\">\n      </ex-editing-entry>\n    </div>\n  </ng-container>\n</ex-drag-list>\n\n<ng-container\n  *ngIf=\"(!(this.entries?.length > 0) || !this.entries)\">\n  <div class=\"ex-editing-list-no-entities-found-placeholder ex-editing-list-no-entities-flex-and-center\" role=\"alert\">\n    <i class=\"ex-editing-list-no-entities-icon fa fa-list-alt\"></i>\n    <p class=\"ex-editing-list-no-entities-text\">\n      {{noResultsLabel | translate}}\n    </p>\n  </div>\n</ng-container>\n\n<ex-button *ngIf=\"!isReadOnly && !hideAddButton\" class=\"ex-editing-list-add-button sel-editing-list-add-{{addButtonLabel}}\" type=\"add\" iconSide=\"left\"\n           [children]=\"addButtonChildren\" (click)=\"addEntry()\" (childClicked)=\"childClicked($event)\" [exTooltip]=\"addButtonTooltip | translate\" [uniqueSelector]=\"'ex-editing-list-add-button'\">\n  {{ addButtonLabel | translate }}\n</ex-button>\n\n<div class=\"ex-editing-list-bottom-wrapper\">\n  <div class=\"ex-editing-list-bottom-actions\">\n    <ng-content select=\"[bottom-actions]\">\n    </ng-content>\n  </div>\n  <pagination-floating class=\"ex-editing-list-pagination\"\n                       *ngIf=\"listProperties.pagination.totalItemsCount > listProperties.pagination.pageSize\"\n                       [totalPages]=\"totalPages\"\n                       [selectedPage]=\"listProperties.pagination.selectedPage\"\n                       (selectedPageChange)=\"selectedPageChange.emit($event)\">\n  </pagination-floating>\n</div>\n", styles: [".editing-list-darggable-icon{cursor:pointer;float:left;visibility:hidden;margin-top:3px}.editing-list-wrapper{display:flex;padding-top:12px}.editing-list-wrapper .editing-list-icon{margin-top:12px;margin-right:12px}.editing-list-wrapper ex-editing-entry{flex:1}.ex-editing-list-add-button{margin-top:10px}.ex-editing-list-index{margin-inline-end:10px;padding-top:4px}.ex-editing-list-hide-index{visibility:hidden}.ex-editing-list-bottom-wrapper{display:flex;padding-top:10px;flex-wrap:wrap}.ex-editing-list-bottom-wrapper .ex-editing-list-bottom-actions{padding-top:7px;padding-inline-start:5px;flex:1;display:flex;flex-wrap:wrap;gap:20px}.ex-editing-list-bottom-wrapper .ex-editing-list-bottom-actions ::ng-deep ex-link>.ex-link-anchor{color:#4164a4!important}.ex-editing-list-bottom-wrapper .ex-editing-list-pagination{height:-moz-fit-content;height:fit-content;border:1px solid #d7d7d7;border-radius:4px}.ex-editing-list-bottom-wrapper .ex-editing-list-pagination ::ng-deep .pagination-floating{position:static!important}.ex-editing-list-bottom-wrapper .ex-editing-list-pagination ::ng-deep .pagination-floating-fixed-wrapper{box-shadow:none;border-radius:4px!important;position:static!important}.ex-editing-list-no-entities-found-placeholder{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-editing-list-no-entities-flex-and-center{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NEW_SECTIONS_DESIGN]
            }] }, { type: i0.ChangeDetectorRef }]; }, { icon: [{
            type: Input
        }], draggable: [{
            type: Input
        }], addButtonLabel: [{
            type: Input
        }], hidePrefixPlaceHolder: [{
            type: Input
        }], disableClickInViewMode: [{
            type: Input
        }], isEntryEditable: [{
            type: Input
        }], displayActionsOnHover: [{
            type: Input
        }], isTimeLine: [{
            type: Input
        }], actionChildrenButtons: [{
            type: Input
        }], listProperties: [{
            type: Input
        }], noResultsLabel: [{
            type: Input
        }], newExport: [{
            type: Input
        }], _viewModeTemplate: [{
            type: Input
        }], _editModeTemplate: [{
            type: Input
        }], editingListChanged: [{
            type: Output
        }], editingEntryDeleted: [{
            type: Output
        }], editingEntryAdded: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], selectedPageChange: [{
            type: Output
        }], refreshClicked: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], itemActionClicked: [{
            type: Output
        }], export: [{
            type: Output
        }], editingEntryItems: [{
            type: ViewChildren,
            args: ['editingEntry']
        }] }); })();

const _c0$12 = ["editMode"];
const _c1$D = ["viewMode"];
function ExInlineEditingComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 6);
    i0.ɵɵlistener("click", function ExInlineEditingComponent_div_0_ng_container_2_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onMoreClicked($event)); })("menuOpened", function ExInlineEditingComponent_div_0_ng_container_2_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.isMenuOpen = true); })("menuClosed", function ExInlineEditingComponent_div_0_ng_container_2_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.isMenuOpen = false); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 8);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "menu-item", 9, 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(10);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-inline-editing-edit-button sel-inline-editing-edit-button ", i0.ɵɵpipeBind1(2, 14, "ex-inline-editing-edit-button" + (ctx_r3.uniqueSelector ? "-" + ctx_r3.uniqueSelector : "")), "");
    i0.ɵɵclassProp("ex-inline-editing-edit-button-while-menu-open", ctx_r3.isMenuOpen);
    i0.ɵɵattributeInterpolate3("aria-label", "", i0.ɵɵpipeBind1(4, 18, "ng.general.more_actions"), " ", ctx_r3.sectionTitle, " ", i0.ɵɵpipeBind1(5, 20, ctx_r3.moreActionsLabel), "");
    i0.ɵɵproperty("matMenuTriggerFor", _r6.childMenu)("matTooltip", i0.ɵɵpipeBind1(3, 16, "ng.general.more_actions"));
    i0.ɵɵattribute("aria-expanded", ctx_r3.isMenuOpen);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("id", ctx_r3.uniqueId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.sectionTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r3.actionChildrenButtons);
} }
function ExInlineEditingComponent_div_0_ng_container_3_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("iconName", "edit")("color", "#2a5db0")("tooltip", i0.ɵɵpipeBind1(1, 4, ctx_r11.editIconTooltip) || i0.ɵɵpipeBind1(2, 6, "ng.general.edit") + " " + ctx_r11.sectionTitle)("size", "medium");
} }
function ExInlineEditingComponent_div_0_ng_container_3_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 15);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.view") + " " + ctx_r12.sectionTitle);
} }
function ExInlineEditingComponent_div_0_ng_container_3_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 16);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("iconName", "Expend-Icon")("color", "#0E7CBB")("tooltip", i0.ɵɵpipeBind1(1, 3, "ng.general.expend-view"));
} }
function ExInlineEditingComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExInlineEditingComponent_div_0_ng_container_3_ex_svg_icon_1_Template, 3, 8, "ex-svg-icon", 11);
    i0.ɵɵtemplate(2, ExInlineEditingComponent_div_0_ng_container_3_ex_icon_2_Template, 2, 3, "ex-icon", 12);
    i0.ɵɵtemplate(3, ExInlineEditingComponent_div_0_ng_container_3_ex_svg_icon_3_Template, 2, 5, "ex-svg-icon", 13);
    i0.ɵɵelementStart(4, "label", 8);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isReadOnly && !ctx_r4.newSectionsDesign);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isReadOnly && ctx_r4.newSectionsDesign);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", ctx_r4.uniqueId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r4.isReadOnly ? i0.ɵɵpipeBind1(6, 6, "ng.general.view") : i0.ɵɵpipeBind1(7, 8, "ng.general.edit"), " ", ctx_r4.sectionTitle, "");
} }
function ExInlineEditingComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExInlineEditingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2, 3);
    i0.ɵɵlistener("keydown.enter", function ExInlineEditingComponent_div_0_Template_div_keydown_enter_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onEditClicked($event)); })("click", function ExInlineEditingComponent_div_0_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onEditClicked($event)); });
    i0.ɵɵtemplate(2, ExInlineEditingComponent_div_0_ng_container_2_Template, 11, 22, "ng-container", 4);
    i0.ɵɵtemplate(3, ExInlineEditingComponent_div_0_ng_container_3_Template, 8, 10, "ng-container", 4);
    i0.ɵɵtemplate(4, ExInlineEditingComponent_div_0_ng_container_4_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", ctx_r0.viewBackgroundColor)("cursor", ctx_r0.edit ? "pointer" : "");
    i0.ɵɵclassProp("disabledClicked", !ctx_r0.activeWithoutEdit && !ctx_r0.edit && !(ctx_r0.actionChildrenButtons && (ctx_r0.actionChildrenButtons == null ? null : ctx_r0.actionChildrenButtons.length) > 0))("ex-inline-editing-readonly", ctx_r0.isReadOnly)("has-edit", ctx_r0.edit);
    i0.ɵɵattribute("tabindex", !ctx_r0.edit && !(ctx_r0.actionChildrenButtons && (ctx_r0.actionChildrenButtons == null ? null : ctx_r0.actionChildrenButtons.length) > 0) ? -1 : !ctx_r0.edit ? "" : 0)("role", ctx_r0.edit ? "button" : null)("aria-labelledby", ctx_r0.uniqueId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.actionChildrenButtons && ctx_r0.actionChildrenButtons.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.displayAlwaysEditIcon || ctx_r0.edit && ctx_r0.showEditIcon && (!ctx_r0.actionChildrenButtons || ctx_r0.actionChildrenButtons.length == 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.view);
} }
function ExInlineEditingComponent_div_1_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 23);
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", ctx_r18.editTitleIcon.name)("iconType", ctx_r18.editTitleIcon.type);
} }
function ExInlineEditingComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r19.editTitle), "");
} }
function ExInlineEditingComponent_div_1_ex_close_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 25);
    i0.ɵɵlistener("click", function ExInlineEditingComponent_div_1_ex_close_4_Template_ex_close_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onCloseEditModeClicked()); });
    i0.ɵɵelementEnd();
} }
function ExInlineEditingComponent_div_1_ex_svg_icon_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-svg-icon", 26);
    i0.ɵɵlistener("click", function ExInlineEditingComponent_div_1_ex_svg_icon_5_Template_ex_svg_icon_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onCloseEditModeClicked()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("iconName", "Collapse-Icon")("color", "#0E7CBB")("tooltip", i0.ɵɵpipeBind1(1, 3, "ng.general.collapse-view"));
} }
function ExInlineEditingComponent_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExInlineEditingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17, 18);
    i0.ɵɵtemplate(2, ExInlineEditingComponent_div_1_ex_icon_2_Template, 1, 2, "ex-icon", 19);
    i0.ɵɵtemplate(3, ExInlineEditingComponent_div_1_div_3_Template, 3, 3, "div", 20);
    i0.ɵɵtemplate(4, ExInlineEditingComponent_div_1_ex_close_4_Template, 1, 0, "ex-close", 21);
    i0.ɵɵtemplate(5, ExInlineEditingComponent_div_1_ex_svg_icon_5_Template, 2, 5, "ex-svg-icon", 22);
    i0.ɵɵtemplate(6, ExInlineEditingComponent_div_1_ng_container_6_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", ctx_r1.isReadOnly ? ctx_r1.viewBackgroundColor : ctx_r1.editBackgroundColor);
    i0.ɵɵclassProp("ex-inline-editing-edit-mode-hide", ctx_r1.loadEditMode)("ex-inline-editing-main-entity", ctx_r1.isSingleSave && ctx_r1.isLayoutSingleSave)("ex-inline-editing-readonly", ctx_r1.isReadOnly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isReadOnly && ctx_r1.editTitleIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isReadOnly && ctx_r1.editTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayClose && !ctx_r1.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isReadOnly && ctx_r1.newSectionsDesign);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.edit);
} }
class ExInlineEditingComponent {
    /**
     * whether the component is in edit mode or not
     */
    get editMode() {
        return this._editMode;
    }
    set editMode(value) {
        if (isNil(value))
            return;
        const changed = this._editMode !== value;
        this._editMode = value;
        changed && this.editModeChange.emit(value);
    }
    constructor(sectionLayoutViewModeObservable, sectionsLayoutService, isLayoutSingleSave, sectionId, newSectionsDesign, quickAccessService, isNotQuickAccessScope, translateService, cdr) {
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.sectionsLayoutService = sectionsLayoutService;
        this.isLayoutSingleSave = isLayoutSingleSave;
        this.sectionId = sectionId;
        this.newSectionsDesign = newSectionsDesign;
        this.quickAccessService = quickAccessService;
        this.isNotQuickAccessScope = isNotQuickAccessScope;
        this.translateService = translateService;
        this.cdr = cdr;
        this.readOnly = false;
        this.disableClick = false;
        /**
         * if you want the pen icon on the top right corner
         */
        this.showEditIcon = true;
        /**
         * if you want the pen icon on the top right corner
         */
        this.displayAlwaysEditIcon = false;
        /**
         * if you want to set the tooltip of the pen icon on the top right corner
         */
        this.editIconTooltip = '';
        /**
         * the background color when in view mode
         */
        this.viewBackgroundColor = 'transparent';
        /**
         * the background color when in edit mode
         */
        this.editBackgroundColor = 'transparent';
        this.actionChildrenButtons = [];
        this.displayClose = true;
        this.isSingleSave = true;
        this.moreActionsLabel = '';
        /**
         * whether the component has active design or not
         */
        this.activeWithoutEdit = false;
        this._editMode = false;
        this.uniqueId = String(Math.floor((Math.random() * 10000000) + 1));
        /**
         * event fired whenever the edit mode change
         */
        this.editModeChange = new EventEmitter();
        /**
         * event fired whenever the component pass to edit mode
         */
        this.editClicked = new EventEmitter();
        /**
         * event fired whenever the close button is clicked
         */
        this.closeClicked = new EventEmitter();
        this.editKey = 'edit';
        /**
         * for Accessibility - indicates if more actions menu is open or closed
         */
        this.isMenuOpen = false;
        this._sectionsLayoutViewModeValue = false;
        this._subs = new Subscription();
        /**
         * load edit mode component, without display it, used for quick access feature forms controls initialization
         */
        this.loadEditMode = false;
    }
    ngOnInit() {
        if (this.actionChildrenButtons?.length > 1 && this.actionChildrenButtons?.find(a => a.key == this.editKey))
            this.actionChildrenButtons.find(a => a.key == this.editKey).onClick = this.onEditClicked.bind(this);
        this._subs.add(this.sectionLayoutViewModeObservable?.subscribe((readOnly) => {
            this._sectionsLayoutViewModeValue = readOnly;
            this.cdr.markForCheck();
        }));
        if (this.isLayoutSingleSave) {
            this.initSingleSaveListeners();
        }
        if (this.sectionId) {
            this.sectionTitle = this.sectionsLayoutService?.getSectionTitle(this.sectionId);
        }
        if (this.isReadOnly && !this.isNotQuickAccessScope) {
            this.loadEditMode = true;
            setTimeout(() => {
                this.loadEditMode = false;
                this.cdr.detectChanges();
            }, 1);
        }
        this.isReadOnly && this._subs.add(this.quickAccessService?.openSection$.subscribe(data => {
            data == this.sectionId && !this.isNotQuickAccessScope && this.onEditClicked(event);
        }));
    }
    initSingleSaveListeners() {
        this._subs.add(this.sectionsLayoutService.sectionsEditMode$.subscribe((editMode) => {
            /* When isSingleSave is true, this.editMode will always be set to the sectionsEditMode editMode.
               When isSingleSave is false, this.editMode will be set to false if sectionsEditMode editMode is false and will remain unchanged if sectionsEditMode editMode is true.
            */
            this.editMode = (this.editMode && editMode) || (this.isSingleSave && editMode);
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
        if (this.sectionId && this.quickAccessService && !this.isNotQuickAccessScope)
            this.quickAccessService.removeSectionFields(this.sectionId);
    }
    editButtonExists() {
        return !!this.actionChildrenButtons.find(a => a.key === this.editKey);
    }
    onEditClicked(event) {
        if (window.getSelection().toString().length > 0 || !this.edit) {
            return;
        }
        this.editMode = true;
        this.editClicked.emit();
        event.stopPropagation();
    }
    onCloseEditModeClicked() {
        this.editMode = false;
        this.closeClicked.emit();
    }
    onMoreClicked(event) {
        event.stopPropagation();
    }
    get isReadOnly() {
        return this.readOnly || this._sectionsLayoutViewModeValue || (this.isLayoutSingleSave && !this.sectionsLayoutService.isEditMode());
    }
    static { this.ɵfac = function ExInlineEditingComponent_Factory(t) { return new (t || ExInlineEditingComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(ExSectionsLayoutService, 8), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(EX_SECTION_IDENTIFIER, 8), i0.ɵɵdirectiveInject(NEW_SECTIONS_DESIGN, 12), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS, 8), i0.ɵɵdirectiveInject(EX_EDITING_LIST, 8), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExInlineEditingComponent, selectors: [["ex-inline-editing"]], contentQueries: function ExInlineEditingComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ViewModeComponentDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, EditModeComponentDirective, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.view = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.edit = _t.first);
        } }, viewQuery: function ExInlineEditingComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$12, 5);
            i0.ɵɵviewQuery(_c1$D, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editModeWrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewModeWrapper = _t.first);
        } }, inputs: { readOnly: "readOnly", disableClick: "disableClick", showEditIcon: "showEditIcon", displayAlwaysEditIcon: "displayAlwaysEditIcon", editIconTooltip: "editIconTooltip", viewBackgroundColor: "viewBackgroundColor", editBackgroundColor: "editBackgroundColor", editTitle: "editTitle", editTitleIcon: "editTitleIcon", actionChildrenButtons: "actionChildrenButtons", displayClose: "displayClose", isSingleSave: "isSingleSave", moreActionsLabel: "moreActionsLabel", activeWithoutEdit: "activeWithoutEdit", editMode: "editMode", uniqueSelector: "uniqueSelector" }, outputs: { editModeChange: "editModeChange", editClicked: "editClicked", closeClicked: "closeClicked" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_IS_INSIDE_GRID, useValue: false }])], decls: 2, vars: 2, consts: [["class", "ex-inline-editing-view-mode sel-inline-editing-view-mode", 3, "disabledClicked", "background-color", "cursor", "ex-inline-editing-readonly", "has-edit", "keydown.enter", "click", 4, "ngIf"], ["class", "ex-inline-editing-edit-mode sel-inline-editing-edit-mode", 3, "ex-inline-editing-edit-mode-hide", "ex-inline-editing-main-entity", "background-color", "ex-inline-editing-readonly", 4, "ngIf"], [1, "ex-inline-editing-view-mode", "sel-inline-editing-view-mode", 3, "keydown.enter", "click"], ["viewMode", ""], [4, "ngIf"], [4, "ngTemplateOutlet"], ["mat-ripple", "", 3, "matMenuTriggerFor", "matTooltip", "click", "menuOpened", "menuClosed"], [1, "uxf-icon", "uxf-dot-three", "regular"], [2, "display", "none", 3, "id"], ["position", "before", 3, "items"], ["menu", ""], ["class", "ex-inline-editing-edit-button", 3, "iconName", "color", "tooltip", "size", 4, "ngIf"], ["class", "ex-inline-editing-edit-button", "iconType", "matIcon", "iconName", "visibility", "sizePx", "20px", "color", "#aaa", 3, "matTooltip", 4, "ngIf"], ["class", "ex-inline-editing-edit-expand-button", 3, "iconName", "color", "tooltip", 4, "ngIf"], [1, "ex-inline-editing-edit-button", 3, "iconName", "color", "tooltip", "size"], ["iconType", "matIcon", "iconName", "visibility", "sizePx", "20px", "color", "#aaa", 1, "ex-inline-editing-edit-button", 3, "matTooltip"], [1, "ex-inline-editing-edit-expand-button", 3, "iconName", "color", "tooltip"], [1, "ex-inline-editing-edit-mode", "sel-inline-editing-edit-mode"], ["editMode", ""], ["class", "ex-inline-editing-title-icon", "color", "#555", 3, "iconName", "iconType", 4, "ngIf"], ["class", "ex-inline-editing-title sel-inline-editing-title", 4, "ngIf"], ["class", "ex-inline-editing-close-button", 3, "click", 4, "ngIf"], ["class", "ex-inline-editing-collapse-button", 3, "iconName", "color", "tooltip", "click", 4, "ngIf"], ["color", "#555", 1, "ex-inline-editing-title-icon", 3, "iconName", "iconType"], [1, "ex-inline-editing-title", "sel-inline-editing-title"], [1, "ex-inline-editing-close-button", 3, "click"], [1, "ex-inline-editing-collapse-button", 3, "iconName", "color", "tooltip", "click"]], template: function ExInlineEditingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExInlineEditingComponent_div_0_Template, 5, 16, "div", 0);
            i0.ɵɵtemplate(1, ExInlineEditingComponent_div_1_Template, 7, 13, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.editMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.editMode || ctx.loadEditMode);
        } }, dependencies: [i1$5.NgIf, i1$5.NgTemplateOutlet, ExCloseComponent, ExIconComponent, i4.MatTooltip, MenuItemComponent, i3$1.MatMenuTrigger, ExSvgIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-inline-editing-view-mode[_ngcontent-%COMP%]{position:relative;border:2px solid transparent;border-radius:5px;padding:10px;background:transparent;text-align:unset;width:100%;transition:border 0s}.ex-inline-editing-view-mode[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #0e7bba}.ex-inline-editing-view-mode[_ngcontent-%COMP%]:hover:not(:disabled), .ex-inline-editing-view-mode[_ngcontent-%COMP%]:focus:not(:disabled), .ex-inline-editing-view-mode[_ngcontent-%COMP%]:focus-within:not(:disabled){border:2px solid #0e7bba;transition:border .25s ease .1s}.ex-inline-editing-view-mode[_ngcontent-%COMP%]:hover:not(:disabled)   .ex-inline-editing-edit-button[_ngcontent-%COMP%], .ex-inline-editing-view-mode[_ngcontent-%COMP%]:focus:not(:disabled)   .ex-inline-editing-edit-button[_ngcontent-%COMP%], .ex-inline-editing-view-mode[_ngcontent-%COMP%]:focus-within:not(:disabled)   .ex-inline-editing-edit-button[_ngcontent-%COMP%]{visibility:visible;opacity:1;transition:all .25s ease .1s}.ex-inline-editing-view-mode[_ngcontent-%COMP%]   .ex-inline-editing-edit-expand-button[_ngcontent-%COMP%]{position:absolute;top:-5px;inset-inline-end:5px}.ex-inline-editing-view-mode[_ngcontent-%COMP%]   .ex-inline-editing-edit-expand-button[_ngcontent-%COMP%]     mat-icon{color:#0e7cbb}.ex-inline-editing-view-mode[_ngcontent-%COMP%]   .ex-inline-editing-edit-expand-button[_ngcontent-%COMP%]     mat-icon:hover{color:#1c608f!important}.ex-inline-editing-view-mode.ex-inline-editing-readonly[_ngcontent-%COMP%]:hover:not(:disabled):not(:focus){border:2px solid #ccc}.ex-inline-editing-view-mode.ex-inline-editing-readonly[_ngcontent-%COMP%]:focus{border:2px solid #ccc}.ex-inline-editing-view-mode[_ngcontent-%COMP%]   .ex-inline-editing-edit-button[_ngcontent-%COMP%]{position:absolute;top:10px;inset-inline-end:5px;padding:0 10px;z-index:1;cursor:pointer;background:none;border:none;transition:all 0s}.disabledClicked[_ngcontent-%COMP%]{cursor:default}.disabledClicked[_ngcontent-%COMP%]:hover:not(.ex-inline-editing-readonly){border:none!important;transition:none!important}.disabledClicked[_ngcontent-%COMP%]:not(.ex-inline-editing-readonly){border:none!important}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]{position:relative;border-radius:5px;padding:20px;border:2px solid #0e7bba}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]:not(:focus){border:2px solid #1079b3}.ex-inline-editing-edit-mode.ex-inline-editing-readonly[_ngcontent-%COMP%]:not(:focus){border:2px solid #ccc}.ex-inline-editing-edit-mode.ex-inline-editing-readonly[_ngcontent-%COMP%]{border:2px solid #ccc;padding-top:45px}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-collapse-button[_ngcontent-%COMP%]{position:absolute;top:0;inset-inline-end:0px;cursor:pointer}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-collapse-button[_ngcontent-%COMP%]     mat-icon{color:#0e7cbb}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-collapse-button[_ngcontent-%COMP%]     mat-icon:hover{color:#1c608f!important}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity[_ngcontent-%COMP%]:not(.ex-inline-editing-readonly){border:none;padding:0;padding-inline-end:20px}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity[_ngcontent-%COMP%]:not(.ex-inline-editing-readonly)   .ex-inline-editing-title-icon[_ngcontent-%COMP%]{display:none}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity[_ngcontent-%COMP%]:not(.ex-inline-editing-readonly)   .ex-inline-editing-close-button[_ngcontent-%COMP%]{display:none}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity[_ngcontent-%COMP%]:not(.ex-inline-editing-readonly)   .ex-inline-editing-title[_ngcontent-%COMP%]{display:none}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]     .ex-display-text-value-text{color:#000!important}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-close-button[_ngcontent-%COMP%]{position:absolute;inset-block-start:20px;inset-inline-end:15px;z-index:2}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-title[_ngcontent-%COMP%]{margin-bottom:25px;margin-inline-start:25px;outline:none}.ex-inline-editing-edit-mode[_ngcontent-%COMP%]   .ex-inline-editing-title-icon[_ngcontent-%COMP%]{position:absolute;inset-block-start:20px;inset-inline-start:20px}.ex-inline-editing-edit-mode-hide[_ngcontent-%COMP%]{display:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInlineEditingComponent, [{
        type: Component,
        args: [{ selector: 'ex-inline-editing', providers: [{ provide: EX_IS_INSIDE_GRID, useValue: false }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #viewMode *ngIf=\"!editMode\"\r\n  [class.disabledClicked]=\"!activeWithoutEdit && !edit && !(actionChildrenButtons && actionChildrenButtons?.length > 0)\" [attr.tabindex]=\"(!edit && !(actionChildrenButtons && actionChildrenButtons?.length > 0))?-1:(!edit?'' : 0)\"\r\n  (keydown.enter)=\"onEditClicked($event)\" (click)=\"onEditClicked($event)\" [attr.role]=\"edit ? 'button' : null\"\r\n  class=\"ex-inline-editing-view-mode sel-inline-editing-view-mode\" [style.background-color]=\"viewBackgroundColor\" [style.cursor]=\"edit ? 'pointer' : ''\"\r\n  [class.ex-inline-editing-readonly]=\"isReadOnly\" [attr.aria-labelledby]=\"uniqueId\" [class.has-edit]=\"edit\">\r\n  <ng-container *ngIf=\"actionChildrenButtons && actionChildrenButtons.length > 0\">\r\n    <button mat-ripple (click)=\"onMoreClicked($event)\" [attr.aria-expanded]=\"isMenuOpen\" (menuOpened)=\"isMenuOpen=true\"\r\n      [class.ex-inline-editing-edit-button-while-menu-open]=\"isMenuOpen\" (menuClosed)=\"isMenuOpen = false\"\r\n      class=\"ex-inline-editing-edit-button sel-inline-editing-edit-button {{('ex-inline-editing-edit-button' + (uniqueSelector ? '-' + uniqueSelector : '')) | generateHTMLId}}\" [matMenuTriggerFor]=\"menu.childMenu\"\r\n      [matTooltip]=\"'ng.general.more_actions' | translate\" attr.aria-label=\"{{'ng.general.more_actions' | translate}} {{sectionTitle}} {{moreActionsLabel | translate}}\">\r\n      <i class=\"uxf-icon uxf-dot-three regular\"></i>\r\n    </button>\r\n    <label style=\"display:none\" id=\"{{uniqueId}}\">{{sectionTitle}}</label>\r\n    <menu-item #menu [items]=\"actionChildrenButtons\" position=\"before\"></menu-item>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"displayAlwaysEditIcon || ((edit && showEditIcon) &&  (!actionChildrenButtons || actionChildrenButtons.length == 0))\">\r\n    <ex-svg-icon *ngIf=\"!isReadOnly\" class=\"ex-inline-editing-edit-button\"  [iconName]=\"'edit'\" [color]=\"'#2a5db0'\"\r\n       [tooltip]=\"(editIconTooltip | translate) || (('ng.general.edit' | translate) + ' ' + sectionTitle)\" [size]=\"'medium'\"></ex-svg-icon>\r\n    <ex-icon *ngIf=\"isReadOnly && !newSectionsDesign\" class=\"ex-inline-editing-edit-button\" iconType=\"matIcon\" iconName=\"visibility\"\r\n      sizePx=\"20px\" [matTooltip]=\"('ng.general.view' | translate) + ' ' + sectionTitle\" color=\"#aaa\"></ex-icon>\r\n    <ex-svg-icon *ngIf=\"isReadOnly && newSectionsDesign\"  [iconName] = \"'Expend-Icon'\" [color]=\"'#0E7CBB'\" class = \"ex-inline-editing-edit-expand-button\" [tooltip]=\"'ng.general.expend-view' | translate\"></ex-svg-icon>\r\n      <label style=\"display:none\" id=\"{{uniqueId}}\">{{isReadOnly ? ('ng.general.view' | translate) : ('ng.general.edit' | translate)}}\r\n       {{sectionTitle}}</label>\r\n  </ng-container>\r\n  <ng-container *ngTemplateOutlet=\"view\"></ng-container>\r\n</div>\r\n\r\n<div #editMode *ngIf=\"editMode || loadEditMode\" [class.ex-inline-editing-edit-mode-hide] = \"loadEditMode\" class=\"ex-inline-editing-edit-mode sel-inline-editing-edit-mode\"\r\n  [class.ex-inline-editing-main-entity]=\"isSingleSave && isLayoutSingleSave\"\r\n  [style.background-color]=\"isReadOnly? viewBackgroundColor : editBackgroundColor\"\r\n  [class.ex-inline-editing-readonly]=\"isReadOnly\">\r\n  <ex-icon class=\"ex-inline-editing-title-icon\" *ngIf=\"!isReadOnly && editTitleIcon\" [iconName]=\"editTitleIcon.name\"\r\n    color=\"#555\" [iconType]=\"editTitleIcon.type\"></ex-icon>\r\n  <div *ngIf=\"!isReadOnly && editTitle\" class=\"ex-inline-editing-title sel-inline-editing-title\">\r\n    {{ editTitle | translate }}</div>\r\n  <ex-close *ngIf=\"displayClose && !isReadOnly\" class=\"ex-inline-editing-close-button\" (click)=\"onCloseEditModeClicked()\"></ex-close>\r\n  <ex-svg-icon *ngIf=\"isReadOnly && newSectionsDesign\"  [iconName] = \"'Collapse-Icon'\" [color]=\"'#0E7CBB'\" class = \"ex-inline-editing-collapse-button\" (click)=\"onCloseEditModeClicked()\" [tooltip]=\"'ng.general.collapse-view' | translate\"></ex-svg-icon>\r\n\r\n  <ng-container *ngTemplateOutlet=\"edit\"></ng-container>\r\n</div>\r\n", styles: [".ex-inline-editing-view-mode{position:relative;border:2px solid transparent;border-radius:5px;padding:10px;background:transparent;text-align:unset;width:100%;transition:border 0s}.ex-inline-editing-view-mode:focus{outline:none;border:2px solid #0e7bba}.ex-inline-editing-view-mode:hover:not(:disabled),.ex-inline-editing-view-mode:focus:not(:disabled),.ex-inline-editing-view-mode:focus-within:not(:disabled){border:2px solid #0e7bba;transition:border .25s ease .1s}.ex-inline-editing-view-mode:hover:not(:disabled) .ex-inline-editing-edit-button,.ex-inline-editing-view-mode:focus:not(:disabled) .ex-inline-editing-edit-button,.ex-inline-editing-view-mode:focus-within:not(:disabled) .ex-inline-editing-edit-button{visibility:visible;opacity:1;transition:all .25s ease .1s}.ex-inline-editing-view-mode .ex-inline-editing-edit-expand-button{position:absolute;top:-5px;inset-inline-end:5px}.ex-inline-editing-view-mode .ex-inline-editing-edit-expand-button ::ng-deep mat-icon{color:#0e7cbb}.ex-inline-editing-view-mode .ex-inline-editing-edit-expand-button ::ng-deep mat-icon:hover{color:#1c608f!important}.ex-inline-editing-view-mode.ex-inline-editing-readonly:hover:not(:disabled):not(:focus){border:2px solid #ccc}.ex-inline-editing-view-mode.ex-inline-editing-readonly:focus{border:2px solid #ccc}.ex-inline-editing-view-mode .ex-inline-editing-edit-button{position:absolute;top:10px;inset-inline-end:5px;padding:0 10px;z-index:1;cursor:pointer;background:none;border:none;transition:all 0s}.disabledClicked{cursor:default}.disabledClicked:hover:not(.ex-inline-editing-readonly){border:none!important;transition:none!important}.disabledClicked:not(.ex-inline-editing-readonly){border:none!important}.ex-inline-editing-edit-mode{position:relative;border-radius:5px;padding:20px;border:2px solid #0e7bba}.ex-inline-editing-edit-mode:not(:focus){border:2px solid #1079b3}.ex-inline-editing-edit-mode.ex-inline-editing-readonly:not(:focus){border:2px solid #ccc}.ex-inline-editing-edit-mode.ex-inline-editing-readonly{border:2px solid #ccc;padding-top:45px}.ex-inline-editing-edit-mode .ex-inline-editing-collapse-button{position:absolute;top:0;inset-inline-end:0px;cursor:pointer}.ex-inline-editing-edit-mode .ex-inline-editing-collapse-button ::ng-deep mat-icon{color:#0e7cbb}.ex-inline-editing-edit-mode .ex-inline-editing-collapse-button ::ng-deep mat-icon:hover{color:#1c608f!important}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity:not(.ex-inline-editing-readonly){border:none;padding:0;padding-inline-end:20px}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity:not(.ex-inline-editing-readonly) .ex-inline-editing-title-icon{display:none}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity:not(.ex-inline-editing-readonly) .ex-inline-editing-close-button{display:none}.ex-inline-editing-edit-mode.ex-inline-editing-main-entity:not(.ex-inline-editing-readonly) .ex-inline-editing-title{display:none}.ex-inline-editing-edit-mode ::ng-deep .ex-display-text-value-text{color:#000!important}.ex-inline-editing-edit-mode .ex-inline-editing-close-button{position:absolute;inset-block-start:20px;inset-inline-end:15px;z-index:2}.ex-inline-editing-edit-mode .ex-inline-editing-title{margin-bottom:25px;margin-inline-start:25px;outline:none}.ex-inline-editing-edit-mode .ex-inline-editing-title-icon{position:absolute;inset-block-start:20px;inset-inline-start:20px}.ex-inline-editing-edit-mode-hide{display:none}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: ExSectionsLayoutService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_SECTION_IDENTIFIER]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [NEW_SECTIONS_DESIGN]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_EDITING_LIST]
            }] }, { type: i1$2.TranslateService }, { type: i0.ChangeDetectorRef }]; }, { readOnly: [{
            type: Input
        }], disableClick: [{
            type: Input
        }], showEditIcon: [{
            type: Input
        }], displayAlwaysEditIcon: [{
            type: Input
        }], editIconTooltip: [{
            type: Input
        }], viewBackgroundColor: [{
            type: Input
        }], editBackgroundColor: [{
            type: Input
        }], editTitle: [{
            type: Input
        }], editTitleIcon: [{
            type: Input
        }], actionChildrenButtons: [{
            type: Input
        }], displayClose: [{
            type: Input
        }], isSingleSave: [{
            type: Input
        }], moreActionsLabel: [{
            type: Input
        }], activeWithoutEdit: [{
            type: Input
        }], editMode: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], editModeChange: [{
            type: Output
        }], editClicked: [{
            type: Output
        }], closeClicked: [{
            type: Output
        }], view: [{
            type: ContentChild,
            args: [ViewModeComponentDirective, { read: TemplateRef }]
        }], edit: [{
            type: ContentChild,
            args: [EditModeComponentDirective, { read: TemplateRef }]
        }], editModeWrapper: [{
            type: ViewChild,
            args: ['editMode']
        }], viewModeWrapper: [{
            type: ViewChild,
            args: ['viewMode']
        }] }); })();

class ExInlineEditingModule {
    static { this.ɵfac = function ExInlineEditingModule_Factory(t) { return new (t || ExInlineEditingModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExInlineEditingModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            ExCloseModule,
            ExIconModule,
            MatTooltipModule,
            MenuItemModule,
            MatMenuModule,
            ExDirectivesModule,
            ExSvgIconModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInlineEditingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    ExCloseModule,
                    ExIconModule,
                    MatTooltipModule,
                    MenuItemModule,
                    MatMenuModule,
                    ExDirectivesModule,
                    ExSvgIconModule,
                    EXPipesModule
                ],
                declarations: [
                    ExInlineEditingComponent
                ],
                exports: [
                    ExInlineEditingComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExInlineEditingModule, { declarations: [ExInlineEditingComponent], imports: [CommonModule,
        TranslateModule,
        ExCloseModule,
        ExIconModule,
        MatTooltipModule,
        MenuItemModule,
        MatMenuModule,
        ExDirectivesModule,
        ExSvgIconModule,
        EXPipesModule], exports: [ExInlineEditingComponent] }); })();

const _c0$11 = ["carousel"];
const _c1$C = ["carouselItem"];
const _c2$r = function (a0) { return { "ex-carousel-layout-control-button-inactive": a0 }; };
function ExCarouselLayoutComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "button", 11);
    i0.ɵɵlistener("click", function ExCarouselLayoutComponent_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.prev()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "ex-icon", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-carousel-layout-control-button ex-carousel-layout-control-button-prev ", i0.ɵɵpipeBind1(2, 10, "ex-carousel-layout-control-button-prev" + (ctx_r0.uniqueSelector ? "-" + ctx_r0.uniqueSelector : "")), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c2$r, ctx_r0.previousButtonDisabled))("disabled", ctx_r0.previousButtonDisabled)("exTooltip", i0.ɵɵpipeBind1(3, 12, "ng.general.previous"));
    i0.ɵɵattribute("aria-disabled", ctx_r0.previousButtonDisabled)("aria-label", i0.ɵɵpipeBind1(4, 14, "ng.general.previous"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("iconName", "uxf-left-open-large")("iconType", "uxf");
} }
function ExCarouselLayoutComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13, 14);
    i0.ɵɵelementContainer(2, 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", item_r8.template);
} }
const _c3$j = function (a0) { return { "rtl": a0 }; };
function ExCarouselLayoutComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3$j, ctx_r3._rtl));
} }
function ExCarouselLayoutComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "button", 11);
    i0.ɵɵlistener("click", function ExCarouselLayoutComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.next()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "ex-icon", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-carousel-layout-control-button ex-carousel-layout-control-button-next ", i0.ɵɵpipeBind1(2, 10, "ex-carousel-layout-control-button-next" + (ctx_r4.uniqueSelector ? "-" + ctx_r4.uniqueSelector : "")), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c2$r, ctx_r4.nextButtonDisabled))("disabled", ctx_r4.nextButtonDisabled)("exTooltip", i0.ɵɵpipeBind1(3, 12, "ng.general.next"));
    i0.ɵɵattribute("aria-disabled", ctx_r4.nextButtonDisabled)("aria-label", i0.ɵɵpipeBind1(4, 14, "ng.general.next"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("iconName", "uxf-right-open-large")("iconType", "uxf");
} }
const _c4$g = function (a0) { return { "ex-carousel-layout-position-indicator-selected": a0 }; };
const _c5$d = function (a0) { return { navButtonIndex: a0 }; };
function ExCarouselLayoutComponent_div_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function ExCarouselLayoutComponent_div_9_button_1_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const index_r15 = restoredCtx.index; const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onPositionIndicatorClicked(index_r15)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r15 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ex-carousel-layout-position-indicator ", i0.ɵɵpipeBind1(1, 9, "ex-carousel-layout-position-indicator" + (ctx_r13.uniqueSelector ? "-" + ctx_r13.uniqueSelector : "")), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c4$g, index_r15 == ctx_r13.currentPage));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 11, "ng.layouts.carousel.navigate", i0.ɵɵpureFunction1(16, _c5$d, index_r15 + 1)))("aria-pressed", index_r15 == ctx_r13.currentPage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconName", "uxf-dot-one")("iconType", "uxf")("sizePx", "32px");
} }
function ExCarouselLayoutComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, ExCarouselLayoutComponent_div_9_button_1_Template, 4, 18, "button", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.numDotsArray);
} }
class ExCarouselLayoutComponent {
    set carousel(carousel) {
        this._carousel = carousel;
    }
    ;
    constructor(animBuilder, cdr) {
        this.animBuilder = animBuilder;
        this.cdr = cdr;
        this.DEFAULT_ITEM_WIDTH = 300;
        this.ITEM_MARGINS = 30;
        /**
         * show 'next' and 'previous' controls on left and right of the carousel.
         * default is true.
         */
        this.showControls = true;
        /**
         * the timing of the 'next' and 'previous' animation.
         * value must be valid animation timing format.
         */
        this.timing = '250ms ease-in';
        /**
         * emitted when the carousel is scrolled.
         * emits the index of the item to which carousel was scrolled.
         */
        this.carouselScrolled = new EventEmitter();
        this.currentItemIndex = 0;
        this.itemWidth = this.DEFAULT_ITEM_WIDTH;
        this.numItemsInContainer = 1;
        this.numDotsArray = [1];
        this.currentPage = 0;
        this.nextButtonDisabled = false;
        this.previousButtonDisabled = true;
        this._rtl = false;
        this.unsub = new Subject();
        this.onResizedDebounced = debounce(this.onResized, 150);
    }
    ngOnInit() {
        let rtl = document.documentElement.getAttribute('dir');
        this._rtl = rtl === "rtl" ? true : false;
    }
    ngAfterViewInit() {
        this.items.changes.pipe(takeUntil(this.unsub)).subscribe(() => this.cdr.markForCheck());
        let itemsExist;
        if (this.carouselItems.length > 0) {
            itemsExist = true;
        }
        this.carouselItems.changes.pipe(takeUntil(this.unsub), delay$1(0)).subscribe((updatedList) => {
            this.calcItemWidth();
            if (updatedList.length > 0) {
                this.calcNumOfItemsInContainer();
                if (this.currentItemIndex >= updatedList.length) {
                    this.currentItemIndex = updatedList.length - 1;
                    this.jumpToIndex(this.currentItemIndex);
                }
                this.setButtonsState();
            }
            else if (updatedList.length == 0) {
                this.currentItemIndex = 0;
            }
        });
        if (itemsExist) {
            this.carouselItems.notifyOnChanges();
        }
    }
    ngOnDestroy() {
        this.player?.destroy();
        this.unsub.next();
        this.unsub.complete();
    }
    onResized(event) {
        this.calcNumOfItemsInContainer();
        this.setButtonsState();
        this.calcCurrentPage();
        // if all items fit in the container, move to index 0
        if (this.items.length <= this.numItemsInContainer) {
            this.jumpToFirst();
        }
        this.cdr.detectChanges();
    }
    next() {
        this.calcNumOfItemsInContainer();
        if (this.isAtEnd()) {
            this.nextButtonDisabled = true;
            this.calcCurrentPage();
            return;
        }
        let index = this.currentItemIndex + this.numItemsInContainer;
        this.moveToIndex(index);
    }
    prev() {
        this.calcNumOfItemsInContainer();
        if (this.isAtStart()) {
            this.previousButtonDisabled = true;
            this.calcCurrentPage();
            return;
        }
        let index = this.currentItemIndex >= this.numItemsInContainer ? this.currentItemIndex - this.numItemsInContainer : 0;
        this.moveToIndex(index);
    }
    onPositionIndicatorClicked(dotIndex) {
        this.calcNumOfItemsInContainer();
        if (dotIndex >= this.numDotsArray.length) {
            dotIndex = this.numDotsArray.length - 1;
        }
        else if (dotIndex < 0) {
            dotIndex = 0;
        }
        let itemIndex = dotIndex * this.numItemsInContainer;
        this.moveToIndex(itemIndex);
    }
    jumpToLast() {
        this.calcNumOfItemsInContainer();
        this.moveToIndex(this.items.length - 1);
    }
    jumpToFirst() {
        this.calcNumOfItemsInContainer();
        this.moveToIndex(0);
    }
    jumpToIndex(index) {
        this.calcNumOfItemsInContainer();
        if (index >= this.items.length || index < 0)
            return;
        this.moveToIndex(index);
    }
    moveToIndex(index) {
        this.currentItemIndex = index;
        const offset = this.currentItemIndex * this.itemWidth;
        this.setButtonsState();
        this.calcCurrentPage();
        this.moveCarousel(offset);
        this.carouselScrolled.emit(this.currentItemIndex);
    }
    moveCarousel(offset) {
        let direction = this._rtl ? "" : "-";
        const animFactory = this.animBuilder.build([
            animate(this.timing, style({ transform: `translateX(${direction}${offset}px)` }))
        ]);
        this.player = animFactory.create(this._carousel.nativeElement);
        this.player.play();
    }
    calcItemWidth() {
        const elementWidth = this.carouselItems.length > 0 ? this.carouselItems.first.nativeElement.getBoundingClientRect().width : this.DEFAULT_ITEM_WIDTH;
        this.itemWidth = elementWidth + this.ITEM_MARGINS;
    }
    calcNumOfItemsInContainer() {
        if (this.itemWidth <= this.ITEM_MARGINS) {
            this.calcItemWidth();
        }
        const listWidth = this._carousel?.nativeElement.getBoundingClientRect().width;
        this.numItemsInContainer = listWidth ? (Math.floor(listWidth / this.itemWidth) < 1 ? 1 : Math.floor(listWidth / this.itemWidth)) : 1;
        this.calcNumNavigationDots();
        this.cdr.markForCheck();
    }
    calcNumNavigationDots() {
        let numDots = Math.ceil(this.items.length / this.numItemsInContainer);
        this.numDotsArray = new Array(numDots).fill(1);
        return numDots;
    }
    calcCurrentPage() {
        this.currentPage = Math.floor(this.currentItemIndex / this.numItemsInContainer);
    }
    isAtEnd() {
        return this.currentItemIndex >= (this.items.length - this.numItemsInContainer);
    }
    isAtStart() {
        return this.currentItemIndex <= 0;
    }
    setButtonsState() {
        this.nextButtonDisabled = this.isAtEnd();
        this.previousButtonDisabled = this.isAtStart();
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExCarouselLayoutComponent_Factory(t) { return new (t || ExCarouselLayoutComponent)(i0.ɵɵdirectiveInject(i1$b.AnimationBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExCarouselLayoutComponent, selectors: [["ex-carousel-layout"]], contentQueries: function ExCarouselLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExCarouselLayoutIdentifierDirective, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
        } }, viewQuery: function ExCarouselLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$11, 5);
            i0.ɵɵviewQuery(_c1$C, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carousel = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carouselItems = _t);
        } }, inputs: { showControls: "showControls", timing: "timing", uniqueSelector: "uniqueSelector" }, outputs: { carouselScrolled: "carouselScrolled" }, exportAs: ["exCarouselLayout"], decls: 10, vars: 5, consts: [[1, "ex-carousel-layout-wrapper"], [1, "ex-carousel-layout-list-wrapper", 3, "resized"], ["class", "ex-carousel-layout-control-prev", 4, "ngIf"], [1, "ex-carousel-layout-container"], [1, "ex-carousel-layout-list"], ["carousel", ""], ["class", "ex-carousel-layout-item", 4, "ngFor", "ngForOf"], ["class", "ex-carousel-layout-end-fade", 3, "ngClass", 4, "ngIf"], ["class", "ex-carousel-layout-control-next", 4, "ngIf"], ["class", "ex-carousel-layout-position-indicators-wrapper", 4, "ngIf"], [1, "ex-carousel-layout-control-prev"], [3, "ngClass", "disabled", "exTooltip", "click"], [3, "iconName", "iconType"], [1, "ex-carousel-layout-item"], ["carouselItem", ""], [3, "ngTemplateOutlet"], [1, "ex-carousel-layout-end-fade", 3, "ngClass"], [1, "ex-carousel-layout-control-next"], [1, "ex-carousel-layout-position-indicators-wrapper"], [3, "class", "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [3, "iconName", "iconType", "sizePx"]], template: function ExCarouselLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("resized", function ExCarouselLayoutComponent_Template_div_resized_1_listener($event) { return ctx.onResizedDebounced($event); });
            i0.ɵɵtemplate(2, ExCarouselLayoutComponent_div_2_Template, 6, 18, "div", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4, 5);
            i0.ɵɵtemplate(6, ExCarouselLayoutComponent_div_6_Template, 3, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ExCarouselLayoutComponent_div_7_Template, 1, 3, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ExCarouselLayoutComponent_div_8_Template, 6, 18, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, ExCarouselLayoutComponent_div_9_Template, 2, 1, "div", 9);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showControls && ctx.items.length > ctx.numItemsInContainer && (!ctx.previousButtonDisabled || !ctx.nextButtonDisabled));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.items);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.nextButtonDisabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showControls && ctx.items.length > ctx.numItemsInContainer && (!ctx.previousButtonDisabled || !ctx.nextButtonDisabled));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.items.length > 1 && (!ctx.previousButtonDisabled || !ctx.nextButtonDisabled));
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ResizedDirective, ExIconComponent, ExTooltipDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-carousel-layout-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-carousel-layout-wrapper[_ngcontent-%COMP%]   .ex-carousel-layout-position-indicators-wrapper[_ngcontent-%COMP%]{align-self:center;display:flex}.ex-carousel-layout-list-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.ex-carousel-layout-control-prev[_ngcontent-%COMP%]{margin-inline-end:15px}.ex-carousel-layout-control-next[_ngcontent-%COMP%]{margin-inline-start:15px}.ex-carousel-layout-control-button[_ngcontent-%COMP%]{width:30px;height:30px;border:none;border-radius:50%;overflow:hidden;padding-top:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-prev[_ngcontent-%COMP%]{padding-inline-end:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-next[_ngcontent-%COMP%]{padding-inline-start:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-inactive[_ngcontent-%COMP%]{opacity:.5;cursor:auto}.ex-carousel-layout-container[_ngcontent-%COMP%]{overflow:hidden;position:relative;width:100%}.ex-carousel-layout-container[_ngcontent-%COMP%]   .ex-carousel-layout-end-fade[_ngcontent-%COMP%]{width:50px;height:100%;background-image:linear-gradient(to right,#fff0,#fff);position:absolute;inset-inline-end:0px;top:0}.ex-carousel-layout-container[_ngcontent-%COMP%]   .ex-carousel-layout-end-fade.rtl[_ngcontent-%COMP%]{background-image:linear-gradient(to left,#fff0,#fff)}.ex-carousel-layout-list[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding-bottom:10px}.ex-carousel-layout-list[_ngcontent-%COMP%]   .ex-carousel-layout-item[_ngcontent-%COMP%]{margin:5px 15px}.ex-carousel-layout-position-indicator[_ngcontent-%COMP%]{color:#0e7bba;opacity:.5;background-color:transparent;border:none;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;transition:opacity .25s ease .1s}.ex-carousel-layout-position-indicator.ex-carousel-layout-position-indicator-selected[_ngcontent-%COMP%]{opacity:1}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCarouselLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-carousel-layout', exportAs: 'exCarouselLayout', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-carousel-layout-wrapper\">\r\n    <div class=\"ex-carousel-layout-list-wrapper\" (resized)=\"onResizedDebounced($event)\">\r\n        <div *ngIf=\"showControls && items.length > numItemsInContainer && (!previousButtonDisabled || !nextButtonDisabled)\" class=\"ex-carousel-layout-control-prev\">\r\n            <button (click)=\"prev()\" class=\"ex-carousel-layout-control-button ex-carousel-layout-control-button-prev {{('ex-carousel-layout-control-button-prev' + (uniqueSelector ? '-'  + uniqueSelector : '')) | generateHTMLId}}\"\r\n                [ngClass]=\"{ 'ex-carousel-layout-control-button-inactive': previousButtonDisabled }\"\r\n                [disabled]=\"previousButtonDisabled\" [attr.aria-disabled]=\"previousButtonDisabled\"\r\n                [exTooltip]=\"'ng.general.previous' | translate\" [attr.aria-label]=\"'ng.general.previous' | translate\">\r\n                <ex-icon [iconName]=\"'uxf-left-open-large'\" [iconType]=\"'uxf'\"></ex-icon>\r\n            </button>\r\n        </div>\r\n        <div class=\"ex-carousel-layout-container\">\r\n            <div #carousel class=\"ex-carousel-layout-list\">\r\n                <div #carouselItem *ngFor=\"let item of items; let index = index\" class=\"ex-carousel-layout-item\">\r\n                    <ng-container [ngTemplateOutlet]=\"item.template\"></ng-container>\r\n                </div>\r\n            </div>\r\n            <div class=\"ex-carousel-layout-end-fade\" *ngIf=\"!nextButtonDisabled\" [ngClass]=\"{ 'rtl': _rtl }\">\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"showControls && items.length > numItemsInContainer &&(!previousButtonDisabled || !nextButtonDisabled)\" class=\"ex-carousel-layout-control-next\">\r\n            <button (click)=\"next()\" class=\"ex-carousel-layout-control-button ex-carousel-layout-control-button-next {{('ex-carousel-layout-control-button-next' + (uniqueSelector ? '-'  + uniqueSelector : '')) | generateHTMLId}}\"\r\n                [ngClass]=\"{ 'ex-carousel-layout-control-button-inactive': nextButtonDisabled }\" [disabled]=\"nextButtonDisabled\"\r\n                [attr.aria-disabled]=\"nextButtonDisabled\" [exTooltip]=\"'ng.general.next' | translate\"\r\n                [attr.aria-label]=\"'ng.general.next' | translate\">\r\n                <ex-icon [iconName]=\"'uxf-right-open-large'\" [iconType]=\"'uxf'\"></ex-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"items.length > 1 && (!previousButtonDisabled || !nextButtonDisabled)\" class=\"ex-carousel-layout-position-indicators-wrapper\">\r\n        <button *ngFor=\"let i of numDotsArray; let index = index\" class=\"ex-carousel-layout-position-indicator {{('ex-carousel-layout-position-indicator' + (uniqueSelector ? '-'  + uniqueSelector : '')) | generateHTMLId}}\"\r\n            [ngClass]=\"{ 'ex-carousel-layout-position-indicator-selected': index == currentPage }\"\r\n            [attr.aria-label]=\"'ng.layouts.carousel.navigate' | translate:{navButtonIndex: index+1}\" [attr.aria-pressed]=\"index == currentPage\"\r\n            (click)=\"onPositionIndicatorClicked(index)\">\r\n            <ex-icon [iconName]=\"'uxf-dot-one'\" [iconType]=\"'uxf'\" [sizePx]=\"'32px'\"></ex-icon>\r\n        </button>\r\n    </div>\r\n</div>\r\n", styles: [".ex-carousel-layout-wrapper{display:flex;flex-direction:column}.ex-carousel-layout-wrapper .ex-carousel-layout-position-indicators-wrapper{align-self:center;display:flex}.ex-carousel-layout-list-wrapper{display:flex;flex-direction:row;align-items:center}.ex-carousel-layout-control-prev{margin-inline-end:15px}.ex-carousel-layout-control-next{margin-inline-start:15px}.ex-carousel-layout-control-button{width:30px;height:30px;border:none;border-radius:50%;overflow:hidden;padding-top:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-prev{padding-inline-end:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-next{padding-inline-start:3px}.ex-carousel-layout-control-button.ex-carousel-layout-control-button-inactive{opacity:.5;cursor:auto}.ex-carousel-layout-container{overflow:hidden;position:relative;width:100%}.ex-carousel-layout-container .ex-carousel-layout-end-fade{width:50px;height:100%;background-image:linear-gradient(to right,#fff0,#fff);position:absolute;inset-inline-end:0px;top:0}.ex-carousel-layout-container .ex-carousel-layout-end-fade.rtl{background-image:linear-gradient(to left,#fff0,#fff)}.ex-carousel-layout-list{display:flex;flex-direction:row;padding-bottom:10px}.ex-carousel-layout-list .ex-carousel-layout-item{margin:5px 15px}.ex-carousel-layout-position-indicator{color:#0e7bba;opacity:.5;background-color:transparent;border:none;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;transition:opacity .25s ease .1s}.ex-carousel-layout-position-indicator.ex-carousel-layout-position-indicator-selected{opacity:1}\n"] }]
    }], function () { return [{ type: i1$b.AnimationBuilder }, { type: i0.ChangeDetectorRef }]; }, { showControls: [{
            type: Input
        }], timing: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], carouselScrolled: [{
            type: Output
        }], items: [{
            type: ContentChildren,
            args: [ExCarouselLayoutIdentifierDirective, { descendants: true }]
        }], carouselItems: [{
            type: ViewChildren,
            args: ['carouselItem', { read: ElementRef }]
        }], carousel: [{
            type: ViewChild,
            args: ['carousel']
        }] }); })();

function PaginationInputComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
const _c0$10 = function (a0) { return { "pagination-input-disabled": a0 }; };
class PaginationInputComponent {
    /**
     * @ignore
     */
    constructor(translateService) {
        this.translateService = translateService;
        /**
         * event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        this.page = '';
        this.errorMessage = '';
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedPage') || changes.hasOwnProperty('totalPages')) {
            const paramLabels = {
                firstPage: 1,
                currentPage: this.selectedPage,
                lastPage: this.totalPages
            };
            this.pageOfTotalPagesLabel = this.translateService.instant('ng.general.pagination.page-of-total-pages', paramLabels);
            this.pageBetweenLabel = this.translateService.instant('pagination.enter_number_between', paramLabels);
        }
    }
    onPageChange() {
        if (this.page.trim() === '') {
            return;
        }
        const num = Number(this.page);
        this.page = '';
        if (Number.isInteger(num) && num > 0 && num <= this.totalPages) {
            this.selectedPageChange.emit(num);
            this.page = '';
        }
        else {
            this.errorMessage = this.pageBetweenLabel;
        }
    }
    onBlur() {
        this.errorMessage = '';
    }
    static { this.ɵfac = function PaginationInputComponent_Factory(t) { return new (t || PaginationInputComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationInputComponent, selectors: [["pagination-input"]], inputs: { selectedPage: "selectedPage", totalPages: "totalPages" }, outputs: { selectedPageChange: "selectedPageChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 25, consts: [[1, "pagination-input-wrapper"], ["class", "pagination-input-error-message", 4, "ngIf"], [1, "pagination-input"], ["exKeyboardShortcut", "PaginationFind", 3, "exTooltip", "ngModel", "placeholder", "blur", "ngModelChange", "keyup.enter"], ["mat-button", "", 3, "disabled", "ngClass", "click"], [1, "pagination-input-error-message"]], template: function PaginationInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PaginationInputComponent_div_1_Template, 2, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "input", 3);
            i0.ɵɵlistener("blur", function PaginationInputComponent_Template_input_blur_3_listener() { return ctx.onBlur(); })("ngModelChange", function PaginationInputComponent_Template_input_ngModelChange_3_listener($event) { return ctx.page = $event; })("keyup.enter", function PaginationInputComponent_Template_input_keyup_enter_3_listener() { return ctx.onPageChange(); });
            i0.ɵɵpipe(4, "generateHTMLId");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵlistener("click", function PaginationInputComponent_Template_button_click_6_listener() { return ctx.onPageChange(); });
            i0.ɵɵpipe(7, "generateHTMLId");
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.errorMessage !== "");
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(i0.ɵɵpipeBind1(4, 15, "pagination-input-jump-to-page"));
            i0.ɵɵpropertyInterpolate2("exTooltip", "", i0.ɵɵpipeBind1(5, 17, "ng.paging.jump_to_page"), " - ", ctx.pageBetweenLabel, "");
            i0.ɵɵproperty("ngModel", ctx.page)("placeholder", ctx.pageOfTotalPagesLabel);
            i0.ɵɵattribute("aria-label", ctx.pageOfTotalPagesLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMapInterpolate1("pagination-input-go-button ", i0.ɵɵpipeBind1(7, 19, "pagination-input-go-button"), "");
            i0.ɵɵproperty("disabled", ctx.page.trim() === "")("ngClass", i0.ɵɵpureFunction1(23, _c0$10, ctx.page.trim() === ""));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 21, "ng.general.go"));
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i3$3.MatButton, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExTooltipDirective, ExKeyboardShortcutDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".pagination-input-wrapper[_ngcontent-%COMP%]{position:relative}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]{border-radius:4px!important;display:flex;align-items:stretch}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:34px;height:34px;border:0px;min-width:0px;padding:0!important;border-start-end-radius:4px;border-start-start-radius:0px;border-end-start-radius:0px;border-end-end-radius:4px}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   .pagination-input-disabled[_ngcontent-%COMP%]{cursor:auto}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline-width:0}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{cursor:pointer}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   .pagination-input-disabled[_ngcontent-%COMP%]:hover{cursor:auto}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:110px;border:0px;text-align:center;direction:unset}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline-width:0}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{color:transparent}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:-moz-placeholder{color:transparent}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::-moz-placeholder{color:transparent}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus:-ms-input-placeholder{color:transparent}.pagination-input-wrapper[_ngcontent-%COMP%]   .pagination-input-error-message[_ngcontent-%COMP%]{position:absolute;top:-250%;border-radius:5px;padding:15px;text-align:center}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationInputComponent, [{
        type: Component,
        args: [{ selector: 'pagination-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pagination-input-wrapper\">\n  <div class=\"pagination-input-error-message\" *ngIf=\"errorMessage !== ''\">{{errorMessage}}</div>\n  <div class=\"pagination-input\">\n    <input class=\"{{'pagination-input-jump-to-page' | generateHTMLId}}\" exKeyboardShortcut=\"PaginationFind\" (blur)=\"onBlur()\" exTooltip=\"{{ 'ng.paging.jump_to_page' | translate }} - {{ pageBetweenLabel }}\"\n      [(ngModel)]=\"page\" (keyup.enter)=\"onPageChange()\" [placeholder]=\"pageOfTotalPagesLabel\"\n      [attr.aria-label]=\"pageOfTotalPagesLabel\">\n    <button (click)=\"onPageChange()\" [disabled]=\"page.trim() === ''\"\n      [ngClass]=\"{ 'pagination-input-disabled': page.trim() === '' }\" mat-button\n      class=\"pagination-input-go-button {{'pagination-input-go-button' | generateHTMLId}}\">{{ 'ng.general.go' | translate }}</button>\n  </div>\n</div>\n", styles: [".pagination-input-wrapper{position:relative}.pagination-input-wrapper .pagination-input{border-radius:4px!important;display:flex;align-items:stretch}.pagination-input-wrapper .pagination-input button{width:34px;height:34px;border:0px;min-width:0px;padding:0!important;border-start-end-radius:4px;border-start-start-radius:0px;border-end-start-radius:0px;border-end-end-radius:4px}.pagination-input-wrapper .pagination-input .pagination-input-disabled{cursor:auto}.pagination-input-wrapper .pagination-input button:focus{outline-width:0}.pagination-input-wrapper .pagination-input button:hover{cursor:pointer}.pagination-input-wrapper .pagination-input .pagination-input-disabled:hover{cursor:auto}.pagination-input-wrapper .pagination-input input{width:110px;border:0px;text-align:center;direction:unset}.pagination-input-wrapper .pagination-input input:focus{outline-width:0}.pagination-input-wrapper .pagination-input input:focus::-webkit-input-placeholder{color:transparent}.pagination-input-wrapper .pagination-input input:focus:-moz-placeholder{color:transparent}.pagination-input-wrapper .pagination-input input:focus::-moz-placeholder{color:transparent}.pagination-input-wrapper .pagination-input input:focus:-ms-input-placeholder{color:transparent}.pagination-input-wrapper .pagination-input-error-message{position:absolute;top:-250%;border-radius:5px;padding:15px;text-align:center}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { selectedPage: [{
            type: Input
        }], totalPages: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }] }); })();

const Animations$3 = [];

function ExScaleComponent_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(option_r3);
} }
function ExScaleComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExScaleComponent_div_3_span_1_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showUpperLabels);
} }
const _c0$$ = function (a0) { return { "ex-scale-selected-option": a0 }; };
function ExScaleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function ExScaleComponent_div_5_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const option_r7 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onScaleChanged(option_r7)); });
    i0.ɵɵelementStart(1, "button", 9);
    i0.ɵɵlistener("focusout", function ExScaleComponent_div_5_Template_button_focusout_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const i_r8 = restoredCtx.index; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onFocusOut(i_r8)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4, " \u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("left", i_r8 / (ctx_r1.upperLabels.length - 1) * 100, "%");
    i0.ɵɵproperty("ngClass", "sel-scale-" + i_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-scale-round-button ", i0.ɵɵpipeBind1(2, 12, "ex-scale-round-button-" + option_r7), "");
    i0.ɵɵproperty("exTooltip", option_r7)("ngClass", i0.ɵɵpureFunction1(16, _c0$$, option_r7 === ctx_r1.selectedOption));
    i0.ɵɵattribute("aria-valuenow", ctx_r1.selectedOption)("aria-valuemin", ctx_r1.minValue)("aria-valuemax", ctx_r1.maxValue)("aria-label", option_r7 === ctx_r1.selectedOption ? option_r7 + "# " + i0.ɵɵpipeBind1(3, 14, "ng.general.selected") : option_r7 + "#");
} }
function ExScaleComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.leftLowLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.rightLowLabel);
} }
const _c1$B = function (a0, a1) { return { "ex-scale-bold": a0, "ex-scale-reg": a1 }; };
class ExScaleComponent {
    constructor() {
        /**
         * the labels-options of the scale
         */
        this.upperLabels = null;
        /**
         * the left lower label to display
         */
        this.leftLowLabel = null;
        /**
         * the right lower label to display
         */
        this.rightLowLabel = null;
        /**
         * if to display the upper labels or not
         */
        this.showUpperLabels = false;
        /**
         * if to display the lower labels or not
         */
        this.showLowerLabels = false;
        /**
         * the current selected option on the scale (highlighted)
         */
        this.selectedOption = null;
        /**
         * if to style the scale with bold or light colors
         */
        this.boldMode = false;
        /**
         * whether to update the state (the selectedOption) internally when a user operation is performed (i.e. the user clicks an option on the scale),
         * or to update the state only according to the input from the using component
         */
        this.doNotUpdateStateInternally = false;
        /**
         * this event fires whenever the option in the scale changes
         */
        this.scaleChanged = new EventEmitter();
        /**
         * this event is for tab navigation-fires after we focus out the last button of the scale
         */
        this.scaleEnd = new EventEmitter();
        // Accessibility
        this.minValue = null;
        this.maxValue = null;
    }
    ngOnInit() {
        if (this.upperLabels && this.upperLabels.length > 0) {
            this.minValue = this.upperLabels[0];
            this.maxValue = this.upperLabels[this.upperLabels.length - 1];
        }
    }
    onScaleChanged(option) {
        if (!this.doNotUpdateStateInternally)
            this.selectedOption = option;
        this.scaleChanged.emit(option);
    }
    onFocusOut(index) {
        if (index === this.upperLabels.length - 1) {
            this.scaleEnd.emit();
        }
    }
    static { this.ɵfac = function ExScaleComponent_Factory(t) { return new (t || ExScaleComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExScaleComponent, selectors: [["ex-scale"]], inputs: { upperLabels: "upperLabels", leftLowLabel: "leftLowLabel", rightLowLabel: "rightLowLabel", showUpperLabels: "showUpperLabels", showLowerLabels: "showLowerLabels", selectedOption: "selectedOption", boldMode: "boldMode", doNotUpdateStateInternally: "doNotUpdateStateInternally" }, outputs: { scaleChanged: "scaleChanged", scaleEnd: "scaleEnd" }, decls: 7, vars: 11, consts: [[1, "ex-scale-wrapper", 3, "ngClass"], [1, "ex-scale-option"], [1, "ex-scale-labels-wrapper"], [4, "ngFor", "ngForOf"], [3, "ngClass"], ["class", "ex-scale-round-button-wrapper", 3, "left", "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "lower-labels", 4, "ngIf"], [4, "ngIf"], [1, "ex-scale-round-button-wrapper", 3, "ngClass", "click"], ["role", "slider", 3, "exTooltip", "ngClass", "focusout"], [1, "lower-labels"]], template: function ExScaleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, ExScaleComponent_div_3_Template, 2, 1, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtemplate(5, ExScaleComponent_div_5_Template, 5, 18, "div", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, ExScaleComponent_div_6_Template, 5, 2, "div", 6);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c1$B, ctx.boldMode, !ctx.boldMode));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.upperLabels);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$B, ctx.boldMode, !ctx.boldMode));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.upperLabels);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showLowerLabels);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-scale-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-inline-start:20px;width:-moz-fit-content;width:fit-content}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]{padding-bottom:7px;position:relative}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-labels-wrapper[_ngcontent-%COMP%]{width:130px;display:flex;flex-direction:row;justify-content:space-between}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]{padding:7px;position:absolute;transform:translate(-50%,50%);bottom:0;display:flex}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]:hover{cursor:pointer}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]   .ex-scale-round-button[_ngcontent-%COMP%]{width:6px;height:6px;border-radius:50%;border-width:0}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-bold[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]:hover   .ex-scale-round-button[_ngcontent-%COMP%]{width:15px;height:15px}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-bold[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]   .ex-scale-selected-option[_ngcontent-%COMP%]{width:15px;height:15px;box-shadow:1px 1px 5px gray}.ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-reg[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]:hover   .ex-scale-round-button[_ngcontent-%COMP%], .ex-scale-wrapper[_ngcontent-%COMP%]   .ex-scale-option[_ngcontent-%COMP%]   .ex-scale-reg[_ngcontent-%COMP%]   .ex-scale-round-button-wrapper[_ngcontent-%COMP%]   .ex-scale-selected-option[_ngcontent-%COMP%]{width:10px;height:10px}.ex-scale-wrapper[_ngcontent-%COMP%]   .lower-labels[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:5px}"], data: { animation: Animations$3 } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExScaleComponent, [{
        type: Component,
        args: [{ selector: 'ex-scale', animations: Animations$3, template: "<div [ngClass]=\"{'ex-scale-bold' : boldMode, 'ex-scale-reg' : !boldMode}\" class=\"ex-scale-wrapper\">\n  <div class=\"ex-scale-option\">\n    <div class=\"ex-scale-labels-wrapper\">\n      <div *ngFor=\"let option of upperLabels; let i  = index\"><span *ngIf=\"showUpperLabels\">{{ option }}</span></div>\n    </div>\n    <div [ngClass]=\"{'ex-scale-bold' : boldMode, 'ex-scale-reg' : !boldMode}\">\n      <div *ngFor=\"let option of upperLabels; let i = index\" [style.left.%]=\"(i/(upperLabels.length-1))*100\"\n        (click)=\"onScaleChanged(option)\" [ngClass]=\"'sel-scale-'+ i\" class=\"ex-scale-round-button-wrapper\">\n        <button (focusout)=\"onFocusOut(i)\" [exTooltip]=\"option\" class=\"ex-scale-round-button {{'ex-scale-round-button-' + option | generateHTMLId}}\"\n          [ngClass]=\"{ 'ex-scale-selected-option': option === selectedOption }\" [attr.aria-valuenow]=\"selectedOption\"\n          [attr.aria-valuemin]=\"minValue\" [attr.aria-valuemax]=\"maxValue\" role=\"slider\"\n          [attr.aria-label]=\"(option === selectedOption) ? option+'# '+('ng.general.selected' | translate) : option+'#'\">\n          &nbsp;</button>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"showLowerLabels\" class=\"lower-labels\">\n    <span>{{ leftLowLabel }}</span>\n    <span>{{ rightLowLabel }}</span>\n  </div>\n</div>\n", styles: [".ex-scale-wrapper{display:flex;flex-direction:column;margin-inline-start:20px;width:-moz-fit-content;width:fit-content}.ex-scale-wrapper .ex-scale-option{padding-bottom:7px;position:relative}.ex-scale-wrapper .ex-scale-option .ex-scale-labels-wrapper{width:130px;display:flex;flex-direction:row;justify-content:space-between}.ex-scale-wrapper .ex-scale-option .ex-scale-round-button-wrapper{padding:7px;position:absolute;transform:translate(-50%,50%);bottom:0;display:flex}.ex-scale-wrapper .ex-scale-option .ex-scale-round-button-wrapper:hover{cursor:pointer}.ex-scale-wrapper .ex-scale-option .ex-scale-round-button-wrapper .ex-scale-round-button{width:6px;height:6px;border-radius:50%;border-width:0}.ex-scale-wrapper .ex-scale-option .ex-scale-bold .ex-scale-round-button-wrapper:hover .ex-scale-round-button{width:15px;height:15px}.ex-scale-wrapper .ex-scale-option .ex-scale-bold .ex-scale-round-button-wrapper .ex-scale-selected-option{width:15px;height:15px;box-shadow:1px 1px 5px gray}.ex-scale-wrapper .ex-scale-option .ex-scale-reg .ex-scale-round-button-wrapper:hover .ex-scale-round-button,.ex-scale-wrapper .ex-scale-option .ex-scale-reg .ex-scale-round-button-wrapper .ex-scale-selected-option{width:10px;height:10px}.ex-scale-wrapper .lower-labels{display:flex;justify-content:space-between;margin-top:5px}\n"] }]
    }], function () { return []; }, { upperLabels: [{
            type: Input
        }], leftLowLabel: [{
            type: Input
        }], rightLowLabel: [{
            type: Input
        }], showUpperLabels: [{
            type: Input
        }], showLowerLabels: [{
            type: Input
        }], selectedOption: [{
            type: Input
        }], boldMode: [{
            type: Input
        }], doNotUpdateStateInternally: [{
            type: Input
        }], scaleChanged: [{
            type: Output
        }], scaleEnd: [{
            type: Output
        }] }); })();

class ResultPerPageComponent {
    /**
     * @ignore
     */
    constructor() {
        /**
         * set the page size options
         */
        this.pageSizeOptions = [];
        /**
         * whether to update the state (the pageSize) internally when a user operation is performed (i.e. the user clicks an option on the scale),
         * or to update the state only according to the input from the using component
         */
        this.doNotUpdateStateInternally = false;
        /**
         * event fired when the page size change
         */
        this.pageSizeChange = new EventEmitter();
        /**
         * this is for tab navigation-fires after we focus out from the last button of page size options
         */
        this.resultsPerPageEnd = new EventEmitter();
    }
    ngOnInit() {
    }
    onPageChange(num) {
        this.pageSizeChange.emit(num);
    }
    onResultsPerPageEnd() {
        this.resultsPerPageEnd.emit();
    }
    static { this.ɵfac = function ResultPerPageComponent_Factory(t) { return new (t || ResultPerPageComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResultPerPageComponent, selectors: [["result-per-page"]], inputs: { pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", doNotUpdateStateInternally: "doNotUpdateStateInternally" }, outputs: { pageSizeChange: "pageSizeChange", resultsPerPageEnd: "resultsPerPageEnd" }, decls: 7, vars: 14, consts: [[1, "result-per-page-wrapper"], [1, "result-per-page-title"], [3, "upperLabels", "selectedOption", "showUpperLabels", "showLowerLabels", "leftLowLabel", "rightLowLabel", "doNotUpdateStateInternally", "scaleChanged", "scaleEnd"]], template: function ResultPerPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ex-scale", 2);
            i0.ɵɵlistener("scaleChanged", function ResultPerPageComponent_Template_ex_scale_scaleChanged_4_listener($event) { return ctx.onPageChange($event); })("scaleEnd", function ResultPerPageComponent_Template_ex_scale_scaleEnd_4_listener() { return ctx.onResultsPerPageEnd(); });
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, "ng.paging.results_per_page"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("upperLabels", ctx.pageSizeOptions)("selectedOption", ctx.pageSize)("showUpperLabels", true)("showLowerLabels", true)("leftLowLabel", i0.ɵɵpipeBind1(5, 10, "ng.paging.optionSize.faster"))("rightLowLabel", i0.ɵɵpipeBind1(6, 12, "ng.paging.optionSize.slower"))("doNotUpdateStateInternally", ctx.doNotUpdateStateInternally);
        } }, dependencies: [ExScaleComponent, i1$2.TranslatePipe], styles: [".result-per-page-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:flex-end}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-title[_ngcontent-%COMP%]{white-space:nowrap}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:20px}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]   .result-per-page[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;width:130px;padding-bottom:7px;position:relative}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]   .result-per-page[_ngcontent-%COMP%]   .result-per-page-round-button[_ngcontent-%COMP%]{width:6px;height:6px;border-radius:50%;position:absolute;bottom:-3px;margin-left:-4px}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]   .result-per-page[_ngcontent-%COMP%]   .result-per-page-round-button[_ngcontent-%COMP%]:hover{width:10px;height:10px;cursor:pointer;bottom:-5px}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]   .result-per-page[_ngcontent-%COMP%]   .result-per-page-selected[_ngcontent-%COMP%]{width:10px;height:10px;bottom:-5px}.result-per-page-wrapper[_ngcontent-%COMP%]   .result-per-page-inner-wrapper[_ngcontent-%COMP%]   .result-per-page-speed[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResultPerPageComponent, [{
        type: Component,
        args: [{ selector: 'result-per-page', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"result-per-page-wrapper\">\n  <span class=\"result-per-page-title\">{{ 'ng.paging.results_per_page' | translate }}</span>\n  <ex-scale [upperLabels]=\"pageSizeOptions\" (scaleChanged)=\"onPageChange($event)\" [selectedOption]=\"pageSize\"\n    [showUpperLabels]=\"true\" [showLowerLabels]=\"true\" [leftLowLabel]=\"'ng.paging.optionSize.faster' | translate\"\n    [rightLowLabel]=\"'ng.paging.optionSize.slower' | translate\" (scaleEnd)=\"onResultsPerPageEnd()\"\n            [doNotUpdateStateInternally]=\"doNotUpdateStateInternally\"></ex-scale>\n</div>\n", styles: [".result-per-page-wrapper{display:flex;flex-direction:row;align-items:center;justify-content:flex-end}.result-per-page-wrapper .result-per-page-title{white-space:nowrap}.result-per-page-wrapper .result-per-page-inner-wrapper{display:flex;flex-direction:column;margin-left:20px}.result-per-page-wrapper .result-per-page-inner-wrapper .result-per-page{display:flex;flex-direction:row;justify-content:space-between;width:130px;padding-bottom:7px;position:relative}.result-per-page-wrapper .result-per-page-inner-wrapper .result-per-page .result-per-page-round-button{width:6px;height:6px;border-radius:50%;position:absolute;bottom:-3px;margin-left:-4px}.result-per-page-wrapper .result-per-page-inner-wrapper .result-per-page .result-per-page-round-button:hover{width:10px;height:10px;cursor:pointer;bottom:-5px}.result-per-page-wrapper .result-per-page-inner-wrapper .result-per-page .result-per-page-selected{width:10px;height:10px;bottom:-5px}.result-per-page-wrapper .result-per-page-inner-wrapper .result-per-page-speed{display:flex;justify-content:space-between;margin-top:5px}\n"] }]
    }], function () { return []; }, { pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], doNotUpdateStateInternally: [{
            type: Input
        }], pageSizeChange: [{
            type: Output
        }], resultsPerPageEnd: [{
            type: Output
        }] }); })();

const _c0$_ = ["prevButtonRef"];
const _c1$A = ["button"];
function PaginationButtonsComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3, 4);
    i0.ɵɵlistener("click", function PaginationButtonsComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onPrevClicked()); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "i", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵclassMapInterpolate1("pagination-buttons-arrow-button pagination-buttons-left-button ", i0.ɵɵpipeBind1(2, 5, "pagination-buttons-prev-page"), "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(3, 7, "ng.pagination.prev_page"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 9, "ng.pagination.prev_page"));
} }
const _c2$q = function (a0, a1) { return { "pagination-buttons-selected-page": a0, "sel-selected-page": a1 }; };
function PaginationButtonsComponent_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 9);
    i0.ɵɵlistener("click", function PaginationButtonsComponent_ng_container_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const page_r6 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onPageChange(page_r6)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const page_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(2, 9, "pagination-buttons-page-number-" + page_r6));
    i0.ɵɵproperty("exTooltip", ctx_r7.getTooltip(page_r6))("exKeyboardShortcutPosition", page_r6 === 1 ? "start" : page_r6 === ctx_r7.totalPages ? "end" : null)("exKeyboardShortcut", page_r6 === 1 ? "PaginationFirst" : page_r6 === ctx_r7.totalPages ? "PaginationLast" : "")("ngClass", i0.ɵɵpureFunction2(14, _c2$q, ctx_r7.selectedPage === page_r6, ctx_r7.selectedPage === page_r6));
    i0.ɵɵattribute("aria-current", ctx_r7.selectedPage === page_r6);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 11, page_r6, "1."));
} }
function PaginationButtonsComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
} }
function PaginationButtonsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PaginationButtonsComponent_ng_container_2_button_1_Template, 6, 17, "button", 6);
    i0.ɵɵtemplate(2, PaginationButtonsComponent_ng_container_2_div_2_Template, 2, 0, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", page_r6 !== -1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", page_r6 === -1);
} }
function PaginationButtonsComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function PaginationButtonsComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onNextClicked()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵclassMapInterpolate1("pagination-buttons-arrow-button pagination-buttons-right-button ", i0.ɵɵpipeBind1(1, 6, "pagination-buttons-next-page"), "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 8, "ng.pagination.next_page"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 10, "ng.pagination.next_page"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("exKeyboardShortcutPosition", "end");
} }
class PaginationButtonsComponent {
    constructor() {
        /**
         * event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        this.pages = [];
        this._totalPages = 1;
        this._selectedPage = 1;
    }
    /**
     * set the selected page
     */
    set selectedPage(selectedPage) {
        this._selectedPage = selectedPage;
        this.updatePages();
    }
    get selectedPage() {
        return this._selectedPage;
    }
    /**
     * set the total number of pages
     */
    set totalPages(totalPages) {
        this._totalPages = totalPages;
        this.updatePages();
    }
    get totalPages() {
        return this._totalPages;
    }
    updatePages() {
        const pages = [1];
        const currentPage = this.selectedPage;
        if (currentPage > 4) {
            pages.push(-1); // for the three dots
        }
        if (currentPage - 2 > 1) {
            pages.push(currentPage - 2);
        }
        if (currentPage - 1 > 1) {
            pages.push(currentPage - 1);
        }
        if (currentPage > 1 && currentPage < this.totalPages) {
            pages.push(currentPage);
        }
        if (currentPage + 1 < this.totalPages) {
            pages.push(currentPage + 1);
        }
        if (currentPage + 2 < this.totalPages) {
            pages.push(currentPage + 2);
        }
        if (this.totalPages - currentPage > 3) {
            pages.push(-1); // for the three dots
        }
        pages.push(this.totalPages);
        this.pages = pages;
    }
    onPageChange(page) {
        this.selectedPageChange.emit(page);
    }
    onPrevClicked() {
        this.selectedPageChange.emit(this.selectedPage - 1);
    }
    onNextClicked() {
        this.selectedPageChange.emit(this.selectedPage + 1);
    }
    getTooltip(page) {
        if (page === 1) {
            return 'Alt + [';
        }
        else if (page === this.totalPages) {
            return 'Alt + ]';
        }
        else {
            return '';
        }
    }
    focus() {
        // if we are not on a first page of pagination-focus on left arrow button
        if (this.prevButtonRef) {
            this.prevButtonRef._elementRef.nativeElement.focus();
        }
        else {
            // if we are on first page of pagination-focus on the first page button
            this.pageButtonRef.toArray()[0]._elementRef.nativeElement.focus();
        }
    }
    static { this.ɵfac = function PaginationButtonsComponent_Factory(t) { return new (t || PaginationButtonsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationButtonsComponent, selectors: [["pagination-buttons"]], viewQuery: function PaginationButtonsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$_, 5);
            i0.ɵɵviewQuery(_c1$A, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevButtonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pageButtonRef = _t);
        } }, inputs: { selectedPage: "selectedPage", totalPages: "totalPages" }, outputs: { selectedPageChange: "selectedPageChange" }, decls: 4, vars: 3, consts: [[1, "pagination-buttons"], ["mat-button", "", 3, "exTooltip", "class", "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["mat-button", "", 3, "exTooltip", "click"], ["prevButtonRef", ""], ["exKeyboardShortcut", "PaginationPrev", 1, "uxf-icon", "uxf-left-open-mini"], ["mat-button", "", 3, "class", "exTooltip", "exKeyboardShortcutPosition", "exKeyboardShortcut", "ngClass", "click", 4, "ngIf"], ["class", "pagination-buttons-three-dots", 4, "ngIf"], ["mat-button", "", 3, "exTooltip", "exKeyboardShortcutPosition", "exKeyboardShortcut", "ngClass", "click"], ["button", ""], [1, "page-number-density"], [1, "pagination-buttons-three-dots"], ["exKeyboardShortcut", "PaginationNext", 1, "uxf-icon", "uxf-right-open-mini", 3, "exKeyboardShortcutPosition"]], template: function PaginationButtonsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PaginationButtonsComponent_button_1_Template, 6, 11, "button", 1);
            i0.ɵɵtemplate(2, PaginationButtonsComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
            i0.ɵɵtemplate(3, PaginationButtonsComponent_button_3_Template, 5, 12, "button", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedPage !== 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.pages);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedPage !== ctx.totalPages);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i3$3.MatButton, ExTooltipDirective, ExKeyboardShortcutDirective, i1$5.DecimalPipe, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".pagination-buttons[_ngcontent-%COMP%]{border-radius:4px!important;display:flex;align-items:flex-end;margin-inline-end:20px}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-three-dots[_ngcontent-%COMP%]{margin:5px}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{min-width:34px;height:34px;border:0px;padding:0 10px;border-radius:0}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{color:#0b6ba2;box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{color:#0b689d;box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:active{box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-arrow-button[_ngcontent-%COMP%]{padding:0!important}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-arrow-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding-top:6px}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-left-button[_ngcontent-%COMP%]{border-start-end-radius:0px;border-start-start-radius:4px;border-end-end-radius:0px;border-end-start-radius:4px}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-right-button[_ngcontent-%COMP%]{border-start-end-radius:4px;border-start-start-radius:0px;border-end-end-radius:4px;border-end-start-radius:0px}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline-width:0}.pagination-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{cursor:pointer}.pagination-buttons[_ngcontent-%COMP%]   .pagination-buttons-selected-page[_ngcontent-%COMP%]:hover{cursor:default}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationButtonsComponent, [{
        type: Component,
        args: [{ selector: 'pagination-buttons', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pagination-buttons\">\n  <button #prevButtonRef [exTooltip]=\"'ng.pagination.prev_page' | translate\" (click)=\"onPrevClicked()\" *ngIf=\"selectedPage !== 1\" mat-button\n    class=\"pagination-buttons-arrow-button pagination-buttons-left-button {{'pagination-buttons-prev-page' | generateHTMLId}}\" [attr.aria-label]=\"'ng.pagination.prev_page' | translate\"><i\n      class=\"uxf-icon uxf-left-open-mini\" exKeyboardShortcut=\"PaginationPrev\"></i></button>\n  <ng-container *ngFor=\"let page of pages\">\n    <button class=\"{{('pagination-buttons-page-number-' + page) | generateHTMLId}}\" [exTooltip]=\"getTooltip(page)\" *ngIf=\"page !== -1\" #button [exKeyboardShortcutPosition]=\"page === 1 ? 'start' : page === this.totalPages ? 'end' : null\" [exKeyboardShortcut]=\"page === 1 ? 'PaginationFirst' : page === this.totalPages ? 'PaginationLast' : ''\"\n      [ngClass]=\"{ 'pagination-buttons-selected-page': selectedPage === page, 'sel-selected-page': selectedPage === page }\"\n      (click)=\"onPageChange(page)\" mat-button [attr.aria-current]=\"selectedPage === page\"><span class=\"page-number-density\">{{page | number: '1.'}}</span></button>\n    <div *ngIf=\"page === -1\" class=\"pagination-buttons-three-dots\">...</div>\n  </ng-container>\n  <button [exTooltip]=\"'ng.pagination.next_page' | translate\" (click)=\"onNextClicked()\" *ngIf=\"selectedPage !== totalPages\" mat-button\n    class=\"pagination-buttons-arrow-button pagination-buttons-right-button {{'pagination-buttons-next-page' | generateHTMLId}}\" [attr.aria-label]=\"'ng.pagination.next_page' | translate\"><i\n      class=\"uxf-icon uxf-right-open-mini\" exKeyboardShortcut=\"PaginationNext\" [exKeyboardShortcutPosition]=\"'end'\"></i></button>\n</div>\n", styles: [".pagination-buttons{border-radius:4px!important;display:flex;align-items:flex-end;margin-inline-end:20px}.pagination-buttons .pagination-buttons-three-dots{margin:5px}.pagination-buttons button{min-width:34px;height:34px;border:0px;padding:0 10px;border-radius:0}.pagination-buttons button:hover{color:#0b6ba2;box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons button:focus{color:#0b689d;box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons button:active{box-shadow:inset 1px 0 #898989,inset -1px 0 #898989}.pagination-buttons .pagination-buttons-arrow-button{padding:0!important}.pagination-buttons .pagination-buttons-arrow-button i{padding-top:6px}.pagination-buttons .pagination-buttons-left-button{border-start-end-radius:0px;border-start-start-radius:4px;border-end-end-radius:0px;border-end-start-radius:4px}.pagination-buttons .pagination-buttons-right-button{border-start-end-radius:4px;border-start-start-radius:0px;border-end-end-radius:4px;border-end-start-radius:0px}.pagination-buttons button:focus{outline-width:0}.pagination-buttons button:hover{cursor:pointer}.pagination-buttons .pagination-buttons-selected-page:hover{cursor:default}\n"] }]
    }], null, { selectedPage: [{
            type: Input
        }], totalPages: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }], prevButtonRef: [{
            type: ViewChild,
            args: ['prevButtonRef']
        }], pageButtonRef: [{
            type: ViewChildren,
            args: ['button']
        }] }); })();

const _c0$Z = ["paginationButtonsRef"];
function ExPaginationComponent_div_0_pagination_buttons_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pagination-buttons", 4, 5);
    i0.ɵɵlistener("selectedPageChange", function ExPaginationComponent_div_0_pagination_buttons_2_Template_pagination_buttons_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onSelectedPageChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedPage", ctx_r1.selectedPage)("totalPages", ctx_r1.totalPages);
} }
function ExPaginationComponent_div_0_pagination_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pagination-input", 4);
    i0.ɵɵlistener("selectedPageChange", function ExPaginationComponent_div_0_pagination_input_3_Template_pagination_input_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onSelectedPageChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedPage", ctx_r2.selectedPage)("totalPages", ctx_r2.totalPages);
} }
function ExPaginationComponent_div_0_result_per_page_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "result-per-page", 6);
    i0.ɵɵlistener("pageSizeChange", function ExPaginationComponent_div_0_result_per_page_4_Template_result_per_page_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.pageSizeChange.emit($event)); })("resultsPerPageEnd", function ExPaginationComponent_div_0_result_per_page_4_Template_result_per_page_resultsPerPageEnd_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onResultsPerPageDone()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pageSize", ctx_r3.pageSize)("pageSizeOptions", ctx_r3.pageSizeOptions)("doNotUpdateStateInternally", ctx_r3.doNotUpdateStateInternally);
} }
function ExPaginationComponent_div_0_pagination_floating_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pagination-floating", 4);
    i0.ɵɵlistener("selectedPageChange", function ExPaginationComponent_div_0_pagination_floating_5_Template_pagination_floating_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.onSelectedPageChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedPage", ctx_r4.selectedPage)("totalPages", ctx_r4.totalPages);
} }
function ExPaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("snInViewport", function ExPaginationComponent_div_0_Template_div_snInViewport_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onInViewportChange($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, ExPaginationComponent_div_0_pagination_buttons_2_Template, 2, 2, "pagination-buttons", 2);
    i0.ɵɵtemplate(3, ExPaginationComponent_div_0_pagination_input_3_Template, 1, 2, "pagination-input", 2);
    i0.ɵɵtemplate(4, ExPaginationComponent_div_0_result_per_page_4_Template, 1, 3, "result-per-page", 3);
    i0.ɵɵtemplate(5, ExPaginationComponent_div_0_pagination_floating_5_Template, 1, 2, "pagination-floating", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 5, "ng.general.pagination_navigation"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.totalPages !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.totalPages !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.optionsVisible && ctx_r0.showPageSize);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.inViewPort && ctx_r0.totalPages !== 1 && !ctx_r0.tableOutOfView);
} }
class ExPaginationComponent {
    /**
   * @ignore
   */
    constructor(ref, translateService) {
        this.ref = ref;
        this.translateService = translateService;
        this.inViewPort = false;
        /**
         * set the page size options - optional
         */
        this.pageSizeOptions = [];
        /**
         * Flag if to display the "Results per page" div
         */
        this.showPageSize = true;
        /**
         * whether to update the state (the selectedPage) internally when a user operation is performed (e.g. the user clicks the next button),
         * or to update the state only according to the input from the using component
         */
        this.doNotUpdateStateInternally = false;
        /**
         * event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        /**
         * event fired when the page size change
         */
        this.pageSizeChange = new EventEmitter();
        /**
         * this is for tab navigation-fires after we focus out from the last button of page size options
         */
        this.endOfPagination = new EventEmitter();
        this.prevKey = null;
        this.optionsVisible = false;
    }
    ngOnChanges(changes) {
        const { numberOfResults, pageSize } = changes;
        if (!numberOfResults && !this.numberOfResults) {
            return;
        }
        if ((numberOfResults && (numberOfResults.previousValue !== numberOfResults.currentValue)) ||
            (pageSize && (pageSize.previousValue !== pageSize.currentValue))) {
            this.totalPages = Math.ceil(this.numberOfResults / this.pageSize);
        }
        // This is to determine if the options should be shown
        // It checks if options were given, and if so shows the options if the number of items is bigger then the smallest option,
        // if no options given, then check if the number of results is greater then 10.
        this.optionsVisible = this.numberOfResults && (this.pageSizeOptions && this.pageSizeOptions.length > 1 && this.numberOfResults >= this.pageSizeOptions[0]);
    }
    onInViewportChange(inViewPort) {
        this.inViewPort = inViewPort;
        this.ref.detectChanges();
    }
    focus() {
        if (this.paginationButtonsRef) {
            this.paginationButtonsRef.focus();
        }
    }
    onResultsPerPageDone() {
        this.endOfPagination.emit();
    }
    onSelectedPageChange(selectedPage) {
        if (!this.doNotUpdateStateInternally)
            this.selectedPage = selectedPage;
        this.selectedPageChange.emit(selectedPage);
    }
    static { this.ɵfac = function ExPaginationComponent_Factory(t) { return new (t || ExPaginationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExPaginationComponent, selectors: [["ex-pagination"]], viewQuery: function ExPaginationComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$Z, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationButtonsRef = _t.first);
        } }, inputs: { numberOfResults: "numberOfResults", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", selectedPage: "selectedPage", showPageSize: "showPageSize", tableOutOfView: "tableOutOfView", doNotUpdateStateInternally: "doNotUpdateStateInternally" }, outputs: { selectedPageChange: "selectedPageChange", pageSizeChange: "pageSizeChange", endOfPagination: "endOfPagination" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "ex-pagination-wrapper", "role", "navigation", 3, "snInViewport", 4, "ngIf"], ["role", "navigation", 1, "ex-pagination-wrapper", 3, "snInViewport"], [3, "selectedPage", "totalPages", "selectedPageChange", 4, "ngIf"], [3, "pageSize", "pageSizeOptions", "doNotUpdateStateInternally", "pageSizeChange", "resultsPerPageEnd", 4, "ngIf"], [3, "selectedPage", "totalPages", "selectedPageChange"], ["paginationButtonsRef", ""], [3, "pageSize", "pageSizeOptions", "doNotUpdateStateInternally", "pageSizeChange", "resultsPerPageEnd"]], template: function ExPaginationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExPaginationComponent_div_0_Template, 6, 7, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.totalPages !== 1 || ctx.optionsVisible);
        } }, dependencies: [i1$5.NgIf, ExInViewportDirective, PaginationFloatingComponent, PaginationInputComponent, ResultPerPageComponent, PaginationButtonsComponent, i1$2.TranslatePipe], styles: [".ex-pagination-wrapper[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:center;padding:20px 25px;position:relative;gap:10px}.ex-pagination-wrapper[_ngcontent-%COMP%]   .ex-pagination-inner-wrapper[_ngcontent-%COMP%]{display:flex;flex:1;padding-top:10px;padding-bottom:10px;place-content:center}.ex-pagination-wrapper[_ngcontent-%COMP%]   pagination-buttons[_ngcontent-%COMP%]{margin-inline-start:auto}.ex-pagination-wrapper[_ngcontent-%COMP%]   result-per-page[_ngcontent-%COMP%]{margin-inline-start:auto}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPaginationComponent, [{
        type: Component,
        args: [{ selector: 'ex-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"totalPages !== 1 || optionsVisible\" (snInViewport)=\"onInViewportChange($event)\"\n  class=\"ex-pagination-wrapper\" role=\"navigation\" [attr.aria-label]=\"'ng.general.pagination_navigation' | translate\">\n    <pagination-buttons #paginationButtonsRef *ngIf=\"totalPages !== 1\" [selectedPage]=\"selectedPage\"\n      [totalPages]=\"totalPages\" (selectedPageChange)=\"onSelectedPageChange($event)\"></pagination-buttons>\n    <pagination-input *ngIf=\"totalPages !== 1\" [selectedPage]=\"selectedPage\" [totalPages]=\"totalPages\"\n      (selectedPageChange)=\"onSelectedPageChange($event)\"></pagination-input>\n    <result-per-page *ngIf=\"optionsVisible && showPageSize\" [pageSize]=\"pageSize\"\n      (pageSizeChange)=\"pageSizeChange.emit($event)\" (resultsPerPageEnd)=\"onResultsPerPageDone()\"\n      [pageSizeOptions]=\"pageSizeOptions\" [doNotUpdateStateInternally]=\"doNotUpdateStateInternally\"></result-per-page>\n  <pagination-floating *ngIf=\"!inViewPort && totalPages !== 1 && !tableOutOfView\" [selectedPage]=\"selectedPage\"\n    [totalPages]=\"totalPages\" (selectedPageChange)=\"onSelectedPageChange($event)\"></pagination-floating>\n</div>\n", styles: [".ex-pagination-wrapper{display:flex;flex-wrap:wrap;justify-content:center;padding:20px 25px;position:relative;gap:10px}.ex-pagination-wrapper .ex-pagination-inner-wrapper{display:flex;flex:1;padding-top:10px;padding-bottom:10px;place-content:center}.ex-pagination-wrapper pagination-buttons{margin-inline-start:auto}.ex-pagination-wrapper result-per-page{margin-inline-start:auto}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { numberOfResults: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], selectedPage: [{
            type: Input
        }], showPageSize: [{
            type: Input
        }], tableOutOfView: [{
            type: Input
        }], doNotUpdateStateInternally: [{
            type: Input
        }], paginationButtonsRef: [{
            type: ViewChild,
            args: ['paginationButtonsRef']
        }], selectedPageChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], endOfPagination: [{
            type: Output
        }] }); })();

function ExEditingCardComponent_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExEditingCardComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, ExEditingCardComponent_ng_container_2_ng_container_3_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.getEditingCardViewClass());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.viewModeTemplate)("ngTemplateOutletContext", ctx_r0.context);
} }
function ExEditingCardComponent_ng_container_3_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$Y = function (a0) { return { "editing-card-wrapper": a0 }; };
function ExEditingCardComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "div", 6);
    i0.ɵɵtemplate(3, ExEditingCardComponent_ng_container_3_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$Y, ctx_r4.cardEditWidthCssVar != undefined));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.editModeTemplate)("ngTemplateOutletContext", ctx_r4.context);
} }
function ExEditingCardComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExEditingCardComponent_ng_container_3_ng_container_1_Template, 4, 5, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
} }
function ExEditingCardComponent_ex_confirmation_message_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-confirmation-message", 10);
    i0.ɵɵlistener("confirmClicked", function ExEditingCardComponent_ex_confirmation_message_4_Template_ex_confirmation_message_confirmClicked_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onRemoveConfirmed()); })("cancelClicked", function ExEditingCardComponent_ex_confirmation_message_4_Template_ex_confirmation_message_cancelClicked_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onRemoveCanceled()); });
    i0.ɵɵelementEnd();
} }
const _c1$z = function (a0) { return { "name": a0, "type": "uxf" }; };
class ExEditingCardComponent extends TrackedEditableEntryComponent {
    constructor(translate, sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr, translate);
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.cardWidthCssVar = 'fit-content';
        this.cardViewHeightCssVar = 'fit-content';
    }
    set cardWidth(cardWidth) {
        this.cardWidthCssVar = cardWidth;
    }
    set cardEditWidth(cardEditWidth) {
        this.cardEditWidthCssVar = cardEditWidth;
    }
    set cardViewHeight(cardViewHeight) {
        this.cardViewHeightCssVar = cardViewHeight;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    getEditingCardViewClass() {
        if (this.cardViewHeightCssVar === 'fit-content')
            return 'editing-card-view-fit-content';
        else
            return 'editing-card-view';
    }
    static { this.ɵfac = function ExEditingCardComponent_Factory(t) { return new (t || ExEditingCardComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExEditingCardComponent, selectors: [["ex-editing-card"]], hostVars: 6, hostBindings: function ExEditingCardComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("--ex-editing-card-width", ctx.cardWidthCssVar)("--ex-editing-card-edit-width", ctx.cardEditWidthCssVar)("--ex-editing-card-view-height", ctx.cardViewHeightCssVar);
        } }, inputs: { cardWidth: "cardWidth", cardEditWidth: "cardEditWidth", cardViewHeight: "cardViewHeight", uniqueSelector: "uniqueSelector" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 10, consts: [[1, "ex-editing-card-wrapper"], ["viewBackgroundColor", "#eff5f7", 1, "ex-inline-editing", 3, "editTitle", "isSingleSave", "editTitleIcon", "uniqueSelector", "actionChildrenButtons", "editMode", "closeClicked", "editModeChange"], [4, "viewModeComponent"], [4, "ngIf"], ["message", "ng.general.delete-confirmation", 3, "confirmClicked", "cancelClicked", 4, "ngIf"], [1, "editing-card", 3, "ngClass"], [1, "editing-card-details-content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "editModeComponent"], [1, "editing-card-edit", 3, "ngClass"], ["message", "ng.general.delete-confirmation", 3, "confirmClicked", "cancelClicked"]], template: function ExEditingCardComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-inline-editing", 1);
            i0.ɵɵlistener("closeClicked", function ExEditingCardComponent_Template_ex_inline_editing_closeClicked_1_listener() { return ctx.onCloseClicked(); })("editModeChange", function ExEditingCardComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.editMode = $event; })("editModeChange", function ExEditingCardComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.onEditModeChanged($event); });
            i0.ɵɵtemplate(2, ExEditingCardComponent_ng_container_2_Template, 4, 3, "ng-container", 2);
            i0.ɵɵtemplate(3, ExEditingCardComponent_ng_container_3_Template, 2, 0, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExEditingCardComponent_ex_confirmation_message_4_Template, 1, 0, "ex-confirmation-message", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editTitle", ctx.editTitle)("isSingleSave", false)("editTitleIcon", i0.ɵɵpureFunction1(8, _c1$z, ctx.editIconType))("uniqueSelector", "ex-editing-card" + (ctx.uniqueSelector ? "-" + ctx.uniqueSelector : ""))("actionChildrenButtons", ctx._actions)("editMode", ctx.editMode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.editModeTemplate);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx._showConfirmationMessage);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, EditModeComponentDirective, ViewModeComponentDirective, ExInlineEditingComponent, ExConfirmationMessageComponent], styles: ["[_nghost-%COMP%]{--ex-editing-card-width: fit-content;--ex-editing-card-view-height: fit-content}.ex-editing-card-wrapper[_ngcontent-%COMP%]{position:relative}.ex-editing-card-wrapper[_ngcontent-%COMP%]   .editing-card[_ngcontent-%COMP%]{position:relative;width:100%;max-width:100%;overflow:hidden}.ex-editing-card-wrapper[_ngcontent-%COMP%]   .editing-card-view-fit-content[_ngcontent-%COMP%]{height:-moz-fit-content;height:fit-content}.ex-editing-card-wrapper[_ngcontent-%COMP%]   .editing-card-wrapper-fit-content[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.ex-editing-card-wrapper[_ngcontent-%COMP%]     .ex-confirmation-message{border-radius:5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditingCardComponent, [{
        type: Component,
        args: [{ selector: 'ex-editing-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-editing-card-wrapper\">\n    <ex-inline-editing class=\"ex-inline-editing\" [editTitle]=\"editTitle\" [isSingleSave]=\"false\"\n        [editTitleIcon]=\"{ 'name': editIconType, 'type': 'uxf' }\" (closeClicked)=\"onCloseClicked()\"\n                       [uniqueSelector]=\"'ex-editing-card' + (uniqueSelector ? '-' + uniqueSelector : '')\"\n        [actionChildrenButtons]=\"_actions\" [(editMode)]=\"editMode\" (editModeChange)=\"onEditModeChanged($event)\"\n        viewBackgroundColor=\"#eff5f7\">\n        <ng-container *viewModeComponent>\n            <div [ngClass]=\"getEditingCardViewClass()\" class=\"editing-card\">\n                <div class=\"editing-card-details-content\">\n                    <ng-container *ngTemplateOutlet=\"viewModeTemplate; context: context\"></ng-container>\n                </div>\n            </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"this.editModeTemplate\">\n            <ng-container *editModeComponent>\n                <div class=\"editing-card-edit\" [ngClass]=\"{'editing-card-wrapper':cardEditWidthCssVar != undefined }\">\n                    <div class=\"editing-card-details-content\">\n                        <ng-container *ngTemplateOutlet=\"editModeTemplate; context: context\">\n                        </ng-container>\n                    </div>\n                </div>\n            </ng-container>\n        </ng-container>\n\n    </ex-inline-editing>\n    <ex-confirmation-message *ngIf=\"_showConfirmationMessage\" message=\"ng.general.delete-confirmation\"\n        (confirmClicked)=\"onRemoveConfirmed()\" (cancelClicked)=\"onRemoveCanceled()\">\n    </ex-confirmation-message>\n</div>\n", styles: [":host{--ex-editing-card-width: fit-content;--ex-editing-card-view-height: fit-content}.ex-editing-card-wrapper{position:relative}.ex-editing-card-wrapper .editing-card{position:relative;width:100%;max-width:100%;overflow:hidden}.ex-editing-card-wrapper .editing-card-view-fit-content{height:-moz-fit-content;height:fit-content}.ex-editing-card-wrapper .editing-card-wrapper-fit-content{width:-moz-fit-content;width:fit-content}.ex-editing-card-wrapper ::ng-deep .ex-confirmation-message{border-radius:5px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { cardWidth: [{
            type: Input
        }], cardEditWidth: [{
            type: Input
        }], cardViewHeight: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], cardWidthCssVar: [{
            type: HostBinding,
            args: ['style.--ex-editing-card-width']
        }], cardEditWidthCssVar: [{
            type: HostBinding,
            args: ['style.--ex-editing-card-edit-width']
        }], cardViewHeightCssVar: [{
            type: HostBinding,
            args: ['style.--ex-editing-card-view-height']
        }] }); })();

const _c0$X = ["carouselLayout"];
function ExEditingCardsComponent_div_1_div_3_ex_editing_card_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-editing-card", 13);
    i0.ɵɵlistener("editModeChanged", function ExEditingCardsComponent_div_1_div_3_ex_editing_card_1_Template_ex_editing_card_editModeChanged_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.onEditModeChanged($event)); })("close", function ExEditingCardsComponent_div_1_div_3_ex_editing_card_1_Template_ex_editing_card_close_0_listener($event) { i0.ɵɵrestoreView(_r15); const i_r11 = i0.ɵɵnextContext().index; const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onEntryClosed($event, i_r11)); })("actionClicked", function ExEditingCardsComponent_div_1_div_3_ex_editing_card_1_Template_ex_editing_card_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.actionFromCardsClicked.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const i_r11 = ctx_r19.index;
    const entry_r10 = ctx_r19.$implicit;
    const isLast_r12 = ctx_r19.last;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("index", i_r11)("entry", entry_r10)("viewModeTemplate", ctx_r13.viewModeTemplateInput ? ctx_r13.viewModeTemplateInput : ctx_r13.viewModeTemplate)("editModeTemplate", ctx_r13.editModeTemplateInput ? ctx_r13.editModeTemplateInput : ctx_r13.editModeTemplate)("editMode", ctx_r13.isEditMode(entry_r10, isLast_r12))("editTitle", entry_r10.isNew ? ctx_r13.editTitleNew : ctx_r13.editTitleEdit)("editIconType", entry_r10.isNew ? ctx_r13.editIconTypeNew : ctx_r13.editIconTypeEdit)("cardWidth", ctx_r13.cardWidth)("cardEditWidth", ctx_r13.cardEditWidth)("cardViewHeight", ctx_r13.cardViewHeight)("uniqueSelector", "ex-editing-cards-display-carousel" + ctx_r13.uniqueSelector ? "-" + ctx_r13.uniqueSelector : "");
} }
function ExEditingCardsComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, ExEditingCardsComponent_div_1_div_3_ex_editing_card_1_Template, 1, 11, "ex-editing-card", 12);
    i0.ɵɵelementEnd();
} }
function ExEditingCardsComponent_div_1_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExEditingCardsComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExEditingCardsComponent_div_1_ng_container_4_ng_container_1_Template, 1, 1, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
} }
function ExEditingCardsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "ex-carousel-layout", 7, 8);
    i0.ɵɵtemplate(3, ExEditingCardsComponent_div_1_div_3_Template, 2, 0, "div", 9);
    i0.ɵɵtemplate(4, ExEditingCardsComponent_div_1_ng_container_4_Template, 2, 0, "ng-container", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-editing-cards-carousel" + ctx_r0.uniqueSelector ? "-" + ctx_r0.uniqueSelector : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.fullViewEditing ? ctx_r0.fullViewEntry : ctx_r0.entries);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.displaySwitchToCard == true);
} }
function ExEditingCardsComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "ex-editing-card", 18);
    i0.ɵɵlistener("entryRemoved", function ExEditingCardsComponent_ng_template_2_div_1_Template_ex_editing_card_entryRemoved_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const i_r24 = restoredCtx.index; const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onEntryRemoved(i_r24)); })("editModeChanged", function ExEditingCardsComponent_ng_template_2_div_1_Template_ex_editing_card_editModeChanged_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.onEditModeChange($event)); })("close", function ExEditingCardsComponent_ng_template_2_div_1_Template_ex_editing_card_close_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r27); const i_r24 = restoredCtx.index; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onEntryClosed($event, i_r24)); })("entryOpened", function ExEditingCardsComponent_ng_template_2_div_1_Template_ex_editing_card_entryOpened_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.singleCardOpened($event)); })("actionClicked", function ExEditingCardsComponent_ng_template_2_div_1_Template_ex_editing_card_actionClicked_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.actionFromCardsClicked.emit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const entry_r23 = ctx.$implicit;
    const i_r24 = ctx.index;
    const isLast_r25 = ctx.last;
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionChildrenButtons", ctx_r21.actions)("index", i_r24)("entry", entry_r23)("viewModeTemplate", ctx_r21.viewModeTemplateInput ? ctx_r21.viewModeTemplateInput : ctx_r21.viewModeTemplate)("editModeTemplate", ctx_r21.editModeTemplateInput ? ctx_r21.editModeTemplateInput : ctx_r21.editModeTemplate)("editMode", ctx_r21.isEditMode(entry_r23, isLast_r25))("editTitle", entry_r23.isNew ? ctx_r21.editTitleNew : ctx_r21.editTitleEdit)("editIconType", entry_r23.isNew ? ctx_r21.editIconTypeNew : ctx_r21.editIconTypeEdit)("cardWidth", ctx_r21.cardWidth)("cardViewHeight", ctx_r21.cardViewHeight)("uniqueSelector", "ex-editing-cards-display-discrete" + ctx_r21.uniqueSelector ? "-" + ctx_r21.uniqueSelector : "");
} }
function ExEditingCardsComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExEditingCardsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ExEditingCardsComponent_ng_template_2_div_1_Template, 2, 11, "div", 9);
    i0.ɵɵtemplate(2, ExEditingCardsComponent_ng_template_2_ng_container_2_Template, 1, 1, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.entries);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.displaySwitchToCard == true);
} }
const _c1$y = function (a0) { return { "height": a0 }; };
function ExEditingCardsComponent_ng_template_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "span", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 25);
    i0.ɵɵlistener("click", function ExEditingCardsComponent_ng_template_4_ng_template_2_Template_a_click_5_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r34.onSwitchToClick()); });
    i0.ɵɵelement(6, "ex-icon", 26);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c1$y, ctx_r33.cardViewHeight));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "ng.layouts.switch_layout"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconName", ctx_r33.multiLayoutData == null ? null : ctx_r33.multiLayoutData.switchToIcon == null ? null : ctx_r33.multiLayoutData.switchToIcon.iconName)("iconType", ctx_r33.multiLayoutData == null ? null : ctx_r33.multiLayoutData.switchToIcon == null ? null : ctx_r33.multiLayoutData.switchToIcon.iconType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, ctx_r33.multiLayoutData == null ? null : ctx_r33.multiLayoutData.switchToLabel));
} }
const _c2$p = function () { return { "id": undefined, "hash": undefined, "data": undefined }; };
function ExEditingCardsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "ex-editing-card", 20);
    i0.ɵɵtemplate(2, ExEditingCardsComponent_ng_template_4_ng_template_2_Template, 10, 11, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r32 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readOnly", true)("entry", i0.ɵɵpureFunction0(6, _c2$p))("uniqueSelector", "ex-editing-cards-switch-layout" + ctx_r4.uniqueSelector ? "-" + ctx_r4.uniqueSelector : "")("viewModeTemplate", _r32)("cardWidth", ctx_r4.cardWidth)("cardViewHeight", ctx_r4.cardViewHeight);
} }
function ExEditingCardsComponent_ex_pagination_6_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 27);
    i0.ɵɵlistener("selectedPageChange", function ExEditingCardsComponent_ex_pagination_6_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36._selectedPageChange($event)); })("pageSizeChange", function ExEditingCardsComponent_ex_pagination_6_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38._pageSizeChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("numberOfResults", ctx_r5.pagination.totalItemsCount)("pageSize", ctx_r5.pagination.pageSize)("pageSizeOptions", ctx_r5.pagination.pageSizeOptions)("selectedPage", ctx_r5.pagination.selectedPage);
} }
function ExEditingCardsComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-button", 28);
    i0.ɵɵlistener("click", function ExEditingCardsComponent_div_7_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r39.addEntry()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("margin-top", (ctx_r6.entries == null ? null : ctx_r6.entries.length) > 0 ? -10 : 10, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", false)("children", ctx_r6.addButtonChildren)("uniqueSelector", "ex-editing-cards-add-button" + ctx_r6.uniqueSelector);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r6.addButtonLabel), " ");
} }
class ExEditingCardsComponent extends TrackedEditableEntryListComponent {
    set data(data) {
        super.initEntryTracker(data);
        if (this.editFullView) {
            this.hideAddButton = false;
            this.fullViewEditing = false;
            this.fullViewEntry = undefined;
        }
    }
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * in case of children button when adding new card
         */
        this.addButtonChildren = [];
        /**
         * button label
         */
        this.addButtonLabel = 'ng.general.add';
        /**
         * the width css property of all cards.
         * can be any valid css 'width' value (for example '400px', 'fit-content').
         */
        this.cardWidth = "280px";
        this.editFullView = false;
        /**
         * the height css property of all cards' view mode.
         * can be any valid css 'height' value (for example '400px', 'fit-content').
         */
        this.cardViewHeight = "256px";
        /**
         * whether to display cards in a carousel or as discrete cards.
         */
        this.carouselDisplayMode = false;
        /**
         * whether to display an additional card in the carousel layout for switching the layout.
         */
        this.displaySwitchToCard = false;
        this.cardWidthCssVar = '280px';
        this.singleMode = false;
        this.pagination = new PaginationModel();
        /**
         * Need to catch this one and add new entry in your component - please see md file for more information
         */
        this.addClicked = new EventEmitter();
        this.switchLayout = new EventEmitter();
        this.cardDeleted = new EventEmitter();
        this.editModeChanged = new EventEmitter();
        this.actionFromCardsClicked = new EventEmitter();
        /**
         * Event fired when the selected page change
         */
        this.selectedPageChange = new EventEmitter();
        /**
         * Event fired when the page size change
         */
        this.pageSizeChange = new EventEmitter();
    }
    onSwitchToClick() {
        this.multiLayoutData?.changeLayoutFunction(this.multiLayoutData.switchToLayoutId);
    }
    onResized(event) {
        this.switchLayout.emit(event);
        if (this.editFullView) {
            this.cardEditWidth = (event.newRect.width) + 'px';
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.setChildrenAddFunction(this.addButtonChildren);
        this.cardEditWidth = this.cardWidth;
    }
    onEditModeChange(event) {
        this.onEditModeChanged(event);
        this.editModeChanged.emit(event);
    }
    onEditModeChanged(event) {
        super.onEditModeChanged(event);
        //support FV card, in this case we removing all cards except the edit one and saving the recent position.
        if (event.editMode && this.editFullView && this.carousel) {
            this.fullViewEditing = true;
            this.fullViewEntry = this.entries.filter(entry => entry.id == event.id);
            this.lastCarouselIndex = this.carousel.currentItemIndex;
            this.lastCarouselPage = this.carousel.currentPage;
            this.lastCarouselItemWidth = this.carousel.itemWidth;
            this.hideAddButton = true;
        }
    }
    onEntryClosed($event, i) {
        //support FV card, in this case need to jump to the relevant page after closing the card
        if (this.editFullView && this.carousel) {
            this.fullViewEditing = false;
            this.fullViewEntry = undefined;
            this.carousel.currentPage = this.lastCarouselPage;
            this.carousel.currentItemIndex = this.lastCarouselIndex;
            this.carousel.moveCarousel(this.lastCarouselIndex * this.lastCarouselItemWidth);
            this.hideAddButton = false;
            //remove the current index in case we show single card
            if ($event?.isNew) {
                i = this.entries.length - 1;
            }
        }
        super.onEntryClosed($event, i);
    }
    addEntry(key) {
        super.addEntry(key);
        if (this.carousel) {
            this.carousel.jumpToIndex(this.entries.length);
        }
    }
    _pageSizeChange(pageSize) {
        this.pagination.pageSize = pageSize;
        this.pageSizeChange.emit(pageSize);
    }
    _selectedPageChange(page) {
        this.pagination.selectedPage = page;
        this.selectedPageChange.emit(page);
    }
    static { this.ɵfac = function ExEditingCardsComponent_Factory(t) { return new (t || ExEditingCardsComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExEditingCardsComponent, selectors: [["ex-editing-cards"]], contentQueries: function ExEditingCardsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ViewModeComponentDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, EditModeComponentDirective, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewModeTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editModeTemplate = _t.first);
        } }, viewQuery: function ExEditingCardsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$X, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carousel = _t.first);
        } }, hostVars: 2, hostBindings: function ExEditingCardsComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("add", function ExEditingCardsComponent_add_HostBindingHandler($event) { return ctx.addClicked.emit($event); })("remove", function ExEditingCardsComponent_remove_HostBindingHandler($event) { return ctx.cardDeleted.emit($event); });
        } if (rf & 2) {
            i0.ɵɵstyleProp("--cards-display-discrete-column-width", ctx.cardWidthCssVar);
        } }, inputs: { data: "data", addButtonChildren: "addButtonChildren", addButtonLabel: "addButtonLabel", cardWidth: "cardWidth", editFullView: "editFullView", cardViewHeight: "cardViewHeight", carouselDisplayMode: "carouselDisplayMode", multiLayoutData: "multiLayoutData", displaySwitchToCard: "displaySwitchToCard", viewModeTemplateInput: "viewModeTemplateInput", editModeTemplateInput: "editModeTemplateInput", singleMode: "singleMode", actions: "actions", pagination: "pagination", uniqueSelector: "uniqueSelector" }, outputs: { addClicked: "addClicked", switchLayout: "switchLayout", cardDeleted: "cardDeleted", editModeChanged: "editModeChanged", actionFromCardsClicked: "actionFromCardsClicked", selectedPageChange: "selectedPageChange", pageSizeChange: "pageSizeChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 4, consts: [[1, "cards-display", 3, "resized"], ["class", "cards-display-carousel", 4, "ngIf", "ngIfElse"], ["discreteDisplayMode", ""], ["switchLayoutCard", ""], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "selectedPageChange", "pageSizeChange", 4, "ngIf"], [3, "margin-top", 4, "ngIf"], [1, "cards-display-carousel"], [3, "uniqueSelector"], ["carouselLayout", "exCarouselLayout"], ["class", "editing-card-wrapper", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "editing-card-wrapper"], [3, "index", "entry", "viewModeTemplate", "editModeTemplate", "editMode", "editTitle", "editIconType", "cardWidth", "cardEditWidth", "cardViewHeight", "uniqueSelector", "editModeChanged", "close", "actionClicked", 4, "exCarouselLayoutItem"], [3, "index", "entry", "viewModeTemplate", "editModeTemplate", "editMode", "editTitle", "editIconType", "cardWidth", "cardEditWidth", "cardViewHeight", "uniqueSelector", "editModeChanged", "close", "actionClicked"], [3, "ngTemplateOutlet", 4, "exCarouselLayoutItem"], [3, "ngTemplateOutlet"], [1, "cards-display-discrete"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "actionChildrenButtons", "index", "entry", "viewModeTemplate", "editModeTemplate", "editMode", "editTitle", "editIconType", "cardWidth", "cardViewHeight", "uniqueSelector", "entryRemoved", "editModeChanged", "close", "entryOpened", "actionClicked"], [1, "cards-switch-layout-wrapper"], [3, "readOnly", "entry", "uniqueSelector", "viewModeTemplate", "cardWidth", "cardViewHeight"], ["switchLayoutCardView", ""], [1, "cards-switch-layout-view-wrapper", 3, "ngStyle"], [1, "cards-switch-layout-view"], [1, "cards-switch-layout-view-label"], ["href", "javascript:void(0);", 1, "cards-switch-layout-view-link", 3, "click"], [3, "iconName", "iconType"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "selectedPageChange", "pageSizeChange"], ["type", "add", "iconSide", "left", 1, "add-button", 3, "disabled", "children", "uniqueSelector", "click"]], template: function ExEditingCardsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("resized", function ExEditingCardsComponent_Template_div_resized_0_listener($event) { return ctx.onResized($event); });
            i0.ɵɵtemplate(1, ExEditingCardsComponent_div_1_Template, 5, 3, "div", 1);
            i0.ɵɵtemplate(2, ExEditingCardsComponent_ng_template_2_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(4, ExEditingCardsComponent_ng_template_4_Template, 4, 7, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(6, ExEditingCardsComponent_ex_pagination_6_Template, 1, 4, "ex-pagination", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ExEditingCardsComponent_div_7_Template, 4, 8, "div", 5);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.carouselDisplayMode)("ngIfElse", _r1);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", (ctx.pagination == null ? null : ctx.pagination.totalItemsCount) > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.hideAddButton && !ctx.isReadOnly);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, ExCarouselLayoutIdentifierDirective, ResizedDirective, ExButtonComponent, ExIconComponent, ExCarouselLayoutComponent, ExPaginationComponent, ExEditingCardComponent, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{--cards-display-discrete-column-width: 280px}.cards-display-discrete[_ngcontent-%COMP%]   .editing-card-wrapper[_ngcontent-%COMP%]{padding-bottom:20px;page-break-inside:avoid;break-inside:avoid;overflow:hidden}.editing-cards-add-button[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content;margin-top:10px}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]{padding:0 20%;text-align:center}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]   .cards-switch-layout-view-label[_ngcontent-%COMP%]{margin-inline-end:5px}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]   .cards-switch-layout-view-link[_ngcontent-%COMP%]{display:inline-flex;align-items:center;cursor:pointer;color:#4164a4;width:-moz-fit-content;width:fit-content;text-decoration:none}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]   .cards-switch-layout-view-link[_ngcontent-%COMP%]:focus{outline:black solid 1px;outline-offset:1px}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]   .cards-switch-layout-view-link[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-inline-end:5px}.cards-switch-layout-view-wrapper[_ngcontent-%COMP%]   .cards-switch-layout-view[_ngcontent-%COMP%]   .cards-switch-layout-view-link[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{word-break:break-all}ex-editing-card[_ngcontent-%COMP%]     .editing-card-view editing-card{width:100%!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditingCardsComponent, [{
        type: Component,
        args: [{ selector: 'ex-editing-cards', host: {
                    '(add)': 'addClicked.emit($event)',
                    '(remove)': 'cardDeleted.emit($event)'
                }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (resized)=\"onResized($event)\" class=\"cards-display\">\n    <div *ngIf=\"carouselDisplayMode; else discreteDisplayMode\" class=\"cards-display-carousel\">\n        <ex-carousel-layout #carouselLayout=\"exCarouselLayout\"\n                            [uniqueSelector]=\"'ex-editing-cards-carousel' + uniqueSelector ? '-' + uniqueSelector : ''\">\n            <div *ngFor=\"let entry of (fullViewEditing ? fullViewEntry : entries); index as i; last as isLast\"\n                class=\"editing-card-wrapper\">\n                <ex-editing-card *exCarouselLayoutItem [index]=\"i\" [entry]=\"entry\"\n                    [viewModeTemplate]=\"viewModeTemplateInput ? viewModeTemplateInput : viewModeTemplate\"\n                    [editModeTemplate]=\"editModeTemplateInput ? editModeTemplateInput : editModeTemplate\"\n                    [editMode]=\"isEditMode(entry, isLast)\" [editTitle]=\"entry.isNew ? editTitleNew : editTitleEdit\"\n                    [editIconType]=\"entry.isNew ? editIconTypeNew : editIconTypeEdit\" [cardWidth]=\"cardWidth\"\n                    [cardEditWidth]=\"cardEditWidth\" [cardViewHeight]=\"cardViewHeight\"\n                    [uniqueSelector]=\"'ex-editing-cards-display-carousel' + uniqueSelector ? '-' + uniqueSelector : ''\"\n                    (editModeChanged)=\"onEditModeChanged($event)\" (close)=\"onEntryClosed($event,i)\"\n                    (actionClicked)=\"actionFromCardsClicked.emit($event)\">\n                </ex-editing-card>\n            </div>\n\n            <ng-container *ngIf=\"displaySwitchToCard == true\">\n                <ng-container *exCarouselLayoutItem [ngTemplateOutlet]=\"switchLayoutCard\"></ng-container>\n            </ng-container>\n\n        </ex-carousel-layout>\n    </div>\n\n    <ng-template #discreteDisplayMode>\n        <div class=\"cards-display-discrete\">\n            <div *ngFor=\"let entry of entries; index as i; last as isLast\" class=\"editing-card-wrapper\">\n                <ex-editing-card [actionChildrenButtons]=\"actions\" (entryRemoved)=\"onEntryRemoved(i)\" [index]=\"i\"\n                    [entry]=\"entry\"\n                    [viewModeTemplate]=\"viewModeTemplateInput ? viewModeTemplateInput : viewModeTemplate\"\n                    [editModeTemplate]=\"editModeTemplateInput ? editModeTemplateInput : editModeTemplate\"\n                    [editMode]=\"isEditMode(entry, isLast)\" [editTitle]=\"entry.isNew ? editTitleNew : editTitleEdit\"\n                    [editIconType]=\"entry.isNew ? editIconTypeNew : editIconTypeEdit\" [cardWidth]=\"cardWidth\"\n                    [cardViewHeight]=\"cardViewHeight\" (editModeChanged)=\"onEditModeChange($event)\"\n                    [uniqueSelector]=\"'ex-editing-cards-display-discrete' + uniqueSelector ? '-' + uniqueSelector : ''\"\n                    (close)=\"onEntryClosed($event,i)\" (entryOpened)=\"singleCardOpened($event)\"\n                    (actionClicked)=\"actionFromCardsClicked.emit($event)\">\n                </ex-editing-card>\n            </div>\n\n            <ng-container *ngIf=\"displaySwitchToCard == true\" [ngTemplateOutlet]=\"switchLayoutCard\"></ng-container>\n\n        </div>\n    </ng-template>\n\n    <ng-template #switchLayoutCard>\n        <div class=\"cards-switch-layout-wrapper\">\n            <ex-editing-card [readOnly]=\"true\" [entry]=\"{ 'id': undefined, 'hash': undefined, 'data': undefined}\"\n                             [uniqueSelector]=\"'ex-editing-cards-switch-layout' + uniqueSelector ? '-' + uniqueSelector : ''\"\n                [viewModeTemplate]=\"switchLayoutCardView\" [cardWidth]=\"cardWidth\" [cardViewHeight]=\"cardViewHeight\">\n            </ex-editing-card>\n            <ng-template #switchLayoutCardView>\n                <div class=\"cards-switch-layout-view-wrapper\" [ngStyle]=\"{ 'height': cardViewHeight }\">\n                    <div class=\"cards-switch-layout-view\">\n                        <span class=\"cards-switch-layout-view-label\">{{ 'ng.layouts.switch_layout' | translate }}</span>\n                        <a href=\"javascript:void(0);\" (click)=\"$event.stopPropagation(); onSwitchToClick()\"\n                            class=\"cards-switch-layout-view-link\">\n                            <ex-icon [iconName]=\"multiLayoutData?.switchToIcon?.iconName\"\n                                [iconType]=\"multiLayoutData?.switchToIcon?.iconType\"></ex-icon>\n                            <span>{{ this.multiLayoutData?.switchToLabel | translate }}</span>\n                        </a>\n                    </div>\n                </div>\n            </ng-template>\n        </div>\n    </ng-template>\n    <ex-pagination *ngIf=\"pagination?.totalItemsCount > 0\" [numberOfResults]=\"pagination.totalItemsCount\"\n        [pageSize]=\"pagination.pageSize\" [pageSizeOptions]=\"pagination.pageSizeOptions\"\n        [selectedPage]=\"pagination.selectedPage\" (selectedPageChange)=\"_selectedPageChange($event)\"\n        (pageSizeChange)=\"_pageSizeChange($event)\"></ex-pagination>\n\n</div>\n<div *ngIf=\"!hideAddButton && !isReadOnly\" [style.margin-top.px]=\"entries?.length > 0 ? -10 : 10\">\n    <ex-button class=\"add-button\" type=\"add\" iconSide=\"left\" [disabled]=\"false\" [children]=\"addButtonChildren\"\n               [uniqueSelector]=\"'ex-editing-cards-add-button' + uniqueSelector\"\n        (click)=\"addEntry()\">\n        {{ addButtonLabel | translate }}\n    </ex-button>\n</div>\n", styles: [":host{--cards-display-discrete-column-width: 280px}.cards-display-discrete .editing-card-wrapper{padding-bottom:20px;page-break-inside:avoid;break-inside:avoid;overflow:hidden}.editing-cards-add-button{width:-moz-fit-content;width:fit-content;margin-top:10px}.cards-switch-layout-view-wrapper{display:flex;align-items:center}.cards-switch-layout-view-wrapper .cards-switch-layout-view{padding:0 20%;text-align:center}.cards-switch-layout-view-wrapper .cards-switch-layout-view .cards-switch-layout-view-label{margin-inline-end:5px}.cards-switch-layout-view-wrapper .cards-switch-layout-view .cards-switch-layout-view-link{display:inline-flex;align-items:center;cursor:pointer;color:#4164a4;width:-moz-fit-content;width:fit-content;text-decoration:none}.cards-switch-layout-view-wrapper .cards-switch-layout-view .cards-switch-layout-view-link:focus{outline:black solid 1px;outline-offset:1px}.cards-switch-layout-view-wrapper .cards-switch-layout-view .cards-switch-layout-view-link ex-icon{margin-inline-end:5px}.cards-switch-layout-view-wrapper .cards-switch-layout-view .cards-switch-layout-view-link span{word-break:break-all}ex-editing-card ::ng-deep .editing-card-view editing-card{width:100%!important}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { data: [{
            type: Input
        }], addButtonChildren: [{
            type: Input
        }], addButtonLabel: [{
            type: Input
        }], cardWidth: [{
            type: Input
        }], editFullView: [{
            type: Input
        }], cardViewHeight: [{
            type: Input
        }], carouselDisplayMode: [{
            type: Input
        }], multiLayoutData: [{
            type: Input
        }], displaySwitchToCard: [{
            type: Input
        }], cardWidthCssVar: [{
            type: HostBinding,
            args: ['style.--cards-display-discrete-column-width']
        }], viewModeTemplateInput: [{
            type: Input
        }], editModeTemplateInput: [{
            type: Input
        }], singleMode: [{
            type: Input
        }], actions: [{
            type: Input
        }], pagination: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], addClicked: [{
            type: Output
        }], switchLayout: [{
            type: Output
        }], cardDeleted: [{
            type: Output
        }], editModeChanged: [{
            type: Output
        }], actionFromCardsClicked: [{
            type: Output
        }], selectedPageChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], viewModeTemplate: [{
            type: ContentChild,
            args: [ViewModeComponentDirective, { read: TemplateRef }]
        }], editModeTemplate: [{
            type: ContentChild,
            args: [EditModeComponentDirective, { read: TemplateRef }]
        }], carousel: [{
            type: ViewChild,
            args: ['carouselLayout']
        }] }); })();

class ExCarouselLayoutModule {
    static { this.ɵfac = function ExCarouselLayoutModule_Factory(t) { return new (t || ExCarouselLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExCarouselLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            AngularResizeEventModule,
            TranslateModule,
            MatTooltipModule,
            ExIconModule,
            ExDirectivesModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCarouselLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AngularResizeEventModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExIconModule,
                    ExDirectivesModule,
                    EXPipesModule
                ],
                declarations: [
                    ExCarouselLayoutComponent
                ],
                exports: [
                    ExCarouselLayoutComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExCarouselLayoutModule, { declarations: [ExCarouselLayoutComponent], imports: [CommonModule,
        AngularResizeEventModule,
        TranslateModule,
        MatTooltipModule,
        ExIconModule,
        ExDirectivesModule,
        EXPipesModule], exports: [ExCarouselLayoutComponent] }); })();

class ExScaleModule {
    static { this.ɵfac = function ExScaleModule_Factory(t) { return new (t || ExScaleModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExScaleModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            TranslateModule,
            ExDirectivesModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExScaleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    TranslateModule,
                    ExDirectivesModule,
                    EXPipesModule
                ],
                declarations: [
                    ExScaleComponent
                ],
                exports: [
                    ExScaleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExScaleModule, { declarations: [ExScaleComponent], imports: [CommonModule,
        MatTooltipModule,
        TranslateModule,
        ExDirectivesModule,
        EXPipesModule], exports: [ExScaleComponent] }); })();

class ExPaginationModule {
    static { this.ɵfac = function ExPaginationModule_Factory(t) { return new (t || ExPaginationModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExPaginationModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            FormsModule,
            TranslateModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExScaleModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    FormsModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExScaleModule,
                    EXPipesModule
                ],
                declarations: [
                    ExPaginationComponent,
                    PaginationFloatingComponent,
                    PaginationInputComponent,
                    ResultPerPageComponent,
                    PaginationButtonsComponent
                ],
                exports: [
                    ExPaginationComponent,
                    PaginationFloatingComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExPaginationModule, { declarations: [ExPaginationComponent,
        PaginationFloatingComponent,
        PaginationInputComponent,
        ResultPerPageComponent,
        PaginationButtonsComponent], imports: [CommonModule,
        MatButtonModule,
        FormsModule,
        TranslateModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExScaleModule,
        EXPipesModule], exports: [ExPaginationComponent,
        PaginationFloatingComponent] }); })();

class ExEditingCardsModule {
    static { this.ɵfac = function ExEditingCardsModule_Factory(t) { return new (t || ExEditingCardsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExEditingCardsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            ExButtonModule,
            ExInlineEditingModule,
            ExIconModule,
            ExCarouselLayoutModule,
            AngularResizeEventModule,
            ExPaginationModule,
            ExConfirmationMessageModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditingCardsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExButtonModule,
                    ExInlineEditingModule,
                    ExIconModule,
                    ExCarouselLayoutModule,
                    AngularResizeEventModule,
                    ExPaginationModule,
                    ExConfirmationMessageModule
                ],
                declarations: [
                    ExEditingCardsComponent,
                    ExEditingCardComponent
                ],
                exports: [
                    ExEditingCardsComponent,
                    ExEditingCardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExEditingCardsModule, { declarations: [ExEditingCardsComponent,
        ExEditingCardComponent], imports: [CommonModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        ExButtonModule,
        ExInlineEditingModule,
        ExIconModule,
        ExCarouselLayoutModule,
        AngularResizeEventModule,
        ExPaginationModule,
        ExConfirmationMessageModule], exports: [ExEditingCardsComponent,
        ExEditingCardComponent] }); })();

const _c0$W = ["*"];
class ExDragGroupComponent {
    constructor() { }
    ngAfterViewInit() {
        this.passDataToList();
        this.lists.changes.subscribe(lists => {
            this.passDataToList();
        });
    }
    passDataToList() {
        this.lists.forEach((list, index) => {
            list.allLists = this.lists.toArray().map(list => {
                return {
                    id: list.id,
                    data: list.cdkDropListData,
                    enterPredicate: list.cdkDropListEnterPredicate
                };
            });
            list.index = index;
            list.isLast = index === this.lists.length - 1;
            list.isFirst = index === 0;
        });
    }
    static { this.ɵfac = function ExDragGroupComponent_Factory(t) { return new (t || ExDragGroupComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDragGroupComponent, selectors: [["ex-drag-group"]], contentQueries: function ExDragGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExDragListComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lists = _t);
        } }, features: [i0.ɵɵProvidersFeature([ExDragGroupService])], ngContentSelectors: _c0$W, decls: 1, vars: 0, template: function ExDragGroupComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragGroupComponent, [{
        type: Component,
        args: [{ selector: 'ex-drag-group', providers: [ExDragGroupService], template: "<ng-content></ng-content> " }]
    }], function () { return []; }, { lists: [{
            type: ContentChildren,
            args: [ExDragListComponent, { descendants: true }]
        }] }); })();

class ExDragModule {
    static { this.ɵfac = function ExDragModule_Factory(t) { return new (t || ExDragModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDragModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            TranslateModule,
            A11yModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDragModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    TranslateModule,
                    A11yModule
                ],
                declarations: [
                    ExDragAccessibleIconComponent,
                    ExDragListComponent,
                    ExDragGroupComponent,
                    ExDragDirective,
                    ExDragListDirective
                ],
                exports: [
                    ExDragAccessibleIconComponent,
                    ExDragListComponent,
                    ExDragGroupComponent,
                    ExDragDirective,
                    ExDragListDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDragModule, { declarations: [ExDragAccessibleIconComponent,
        ExDragListComponent,
        ExDragGroupComponent,
        ExDragDirective,
        ExDragListDirective], imports: [CommonModule,
        ExIconModule,
        TranslateModule,
        A11yModule], exports: [ExDragAccessibleIconComponent,
        ExDragListComponent,
        ExDragGroupComponent,
        ExDragDirective,
        ExDragListDirective] }); })();

class ExSortModule {
    static { this.ɵfac = function ExSortModule_Factory(t) { return new (t || ExSortModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSortModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExNewComboboxModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            ExIconModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSortModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExNewComboboxModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExIconModule,
                    EXPipesModule
                ],
                declarations: [
                    ExSortComponent,
                    ExSortPipe
                ],
                exports: [
                    ExSortComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSortModule, { declarations: [ExSortComponent,
        ExSortPipe], imports: [CommonModule,
        ExNewComboboxModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        ExIconModule,
        EXPipesModule], exports: [ExSortComponent] }); })();

class ExFiltersModule {
    static { this.ɵfac = function ExFiltersModule_Factory(t) { return new (t || ExFiltersModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFiltersModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            ExNewComboboxModule,
            ExDotWrapperModule,
            ExDirectivesModule,
            ExButtonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFiltersModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    ExNewComboboxModule,
                    ExDotWrapperModule,
                    ExDirectivesModule,
                    ExButtonModule
                ],
                declarations: [
                    ExFiltersComponent,
                    ExFilterComponent
                ],
                exports: [
                    ExFiltersComponent,
                    ExFilterComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFiltersModule, { declarations: [ExFiltersComponent,
        ExFilterComponent], imports: [CommonModule,
        TranslateModule,
        ExNewComboboxModule,
        ExDotWrapperModule,
        ExDirectivesModule,
        ExButtonModule], exports: [ExFiltersComponent,
        ExFilterComponent] }); })();
i0.ɵɵsetComponentScope(ExFilterComponent, [i1$5.NgClass, i1$5.NgIf, ExNewComboboxComponent], [i1$2.TranslatePipe]);

class ExFloatingComponentModule {
    static { this.ɵfac = function ExFloatingComponentModule_Factory(t) { return new (t || ExFloatingComponentModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFloatingComponentModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            ExCloseModule,
            ExButtonModule,
            ExSvgIconModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatingComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    ExCloseModule,
                    ExButtonModule,
                    ExSvgIconModule,
                    EXPipesModule
                ],
                declarations: [
                    ExFloatingComponentComponent
                ],
                exports: [
                    ExFloatingComponentComponent
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFloatingComponentModule, { declarations: [ExFloatingComponentComponent], imports: [CommonModule,
        MatMenuModule,
        ExCloseModule,
        ExButtonModule,
        ExSvgIconModule,
        EXPipesModule], exports: [ExFloatingComponentComponent] }); })();

class ExExtendedSearchModule {
    static { this.ɵfac = function ExExtendedSearchModule_Factory(t) { return new (t || ExExtendedSearchModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExExtendedSearchModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatIconModule,
            FormsModule,
            ExSpinnerModule,
            ExSearchModule,
            TranslateModule,
            ExNewComboboxModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExExtendedSearchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    FormsModule,
                    ExSpinnerModule,
                    ExSearchModule,
                    TranslateModule,
                    ExNewComboboxModule
                ],
                declarations: [
                    ExExtendedSearchComponent
                ],
                exports: [
                    ExExtendedSearchComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExExtendedSearchModule, { declarations: [ExExtendedSearchComponent], imports: [CommonModule,
        MatIconModule,
        FormsModule,
        ExSpinnerModule,
        ExSearchModule,
        TranslateModule,
        ExNewComboboxModule], exports: [ExExtendedSearchComponent] }); })();

const _c0$V = ["matMenuTrigger"];
const _c1$x = ["floatingSpace"];
const _c2$o = ["matMenuContent"];
const _c3$i = function (a0) { return [a0]; };
function ExFloatingAddComponentComponent_ex_button_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3$i, ctx_r7.action == null ? null : ctx_r7.action.iconClass));
} }
function ExFloatingAddComponentComponent_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 12);
    i0.ɵɵlistener("menuClosed", function ExFloatingAddComponentComponent_ex_button_0_Template_ex_button_menuClosed_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onMenuClosed()); })("menuOpened", function ExFloatingAddComponentComponent_ex_button_0_Template_ex_button_menuOpened_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.triggerClicked($event)); });
    i0.ɵɵtemplate(1, ExFloatingAddComponentComponent_ex_button_0_div_1_Template, 2, 3, "div", 13);
    i0.ɵɵelementContainer(2, 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(6);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("type", ctx_r0.action == null ? null : ctx_r0.action.type)("iconSide", (ctx_r0.action == null ? null : ctx_r0.action.iconClass) || (ctx_r0.action == null ? null : ctx_r0.action.type) !== "action" ? "left" : null)("matMenuTriggerFor", _r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.action == null ? null : ctx_r0.action.iconClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
const _c4$f = function (a0) { return { "ex-floating-component-side-trigger-start": a0 }; };
function ExFloatingAddComponentComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 17);
    i0.ɵɵlistener("click", function ExFloatingAddComponentComponent_ng_template_1_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const _r11 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r11.openMenu()); });
    i0.ɵɵelementContainer(1, 14);
    i0.ɵɵelementStart(2, "div", 18, 19);
    i0.ɵɵlistener("menuOpened", function ExFloatingAddComponentComponent_ng_template_1_Template_div_menuOpened_2_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onSideMenuOpened()); })("menuClosed", function ExFloatingAddComponentComponent_ng_template_1_Template_div_menuClosed_2_listener() { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onMenuClosed()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("type", ctx_r2.action == null ? null : ctx_r2.action.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r5)("ngClass", i0.ɵɵpureFunction1(4, _c4$f, ctx_r2.triggerAtStart));
} }
function ExFloatingAddComponentComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
} }
const _c5$c = [[["", "content", ""]], [["", "trigger", ""]]];
const _c6$b = ["[content]", "[trigger]"];
let ExFloatingAddComponentComponent = class ExFloatingAddComponentComponent {
    /**
     * @ignore
     */
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * whether to open the mat-menu to the side of the trigger
         */
        this.openToSide = false;
        /**
         * emitted when the floating menu closes
         */
        this.menuClosed = new EventEmitter();
        this._dir = "ltr";
        this.triggerAtStart = false;
        this.triggerSideToggled = false;
    }
    ngOnInit() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === "rtl" ? "rtl" : "ltr";
    }
    /**
     * Closes the popup
     */
    close() {
        this.trigger.closeMenu();
    }
    /**
     * Opens the popup
     */
    open() {
        this.trigger.openMenu();
    }
    onMenuClosed() {
        if (this.openToSide) {
            this.onSideMenuClosed();
            if (!this.triggerSideToggled) {
                this.menuClosed.emit();
            }
        }
        else {
            this.menuClosed.emit();
        }
    }
    onEndOfTabNavigation() {
        this.trigger.closeMenu();
    }
    onSideMenuOpened() {
        if (this.triggerSideToggled) {
            this.triggerSideToggled = false;
            return;
        }
        const matMenuPanel = document.getElementById(this.matMenu.panelId);
        if (matMenuPanel)
            matMenuPanel.style.visibility = "hidden";
        let triggerElemRect;
        let menuElemRect;
        setTimeout(() => {
            menuElemRect = this.elementBounds(this.menuContentElem.nativeElement);
            triggerElemRect = this.elementBounds(this.triggerElem.nativeElement);
            if (this._dir == "ltr" ? (menuElemRect?.left - triggerElemRect?.left) < -1 : (menuElemRect?.right - triggerElemRect?.right) > 1) {
                this.toggleTriggerSide();
            }
            this.triggerClicked(null);
            if (matMenuPanel)
                matMenuPanel.style.visibility = "visible";
            this.cdr.markForCheck();
        }, 0);
    }
    triggerClicked(event) {
        this.menuContentElem?.nativeElement?.focus();
    }
    toggleTriggerSide() {
        this.triggerSideToggled = true;
        this.trigger.closeMenu();
        this.triggerAtStart = !this.triggerAtStart;
        this.trigger.openMenu();
    }
    onSideMenuClosed() {
        this.triggerAtStart = false;
    }
    elementBounds(el) {
        if (!el)
            return {};
        const { left, right } = el.getBoundingClientRect();
        return {
            right: right,
            left: left,
        };
    }
    static { this.ɵfac = function ExFloatingAddComponentComponent_Factory(t) { return new (t || ExFloatingAddComponentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFloatingAddComponentComponent, selectors: [["ex-floating-add-component"]], viewQuery: function ExFloatingAddComponentComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(_c0$V, 5, ElementRef);
            i0.ɵɵviewQuery(_c1$x, 5);
            i0.ɵɵviewQuery(_c2$o, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuContentElem = _t.first);
        } }, inputs: { action: "action", openToSide: "openToSide" }, outputs: { menuClosed: "menuClosed" }, ngContentSelectors: _c6$b, decls: 15, vars: 2, consts: [["class", "ex-floating-add-trigger ", "tabindex", "-1", 3, "type", "iconSide", "matMenuTriggerFor", "menuClosed", "menuOpened", 4, "ngIf", "ngIfElse"], ["triggerSide", ""], ["triggerContentTmpl", ""], [1, "ex-floating-component-max-width"], ["floatingSpace", "matMenu"], ["tabindex", "0", "aria-hidden", "true", 1, "ex-floating-add-component-accessibility-dummy", "sel-floating-add-component-accessibility-dummy", 3, "focus"], ["tabindex", "0", 1, "ex-floating-component-content", 3, "keydown"], ["matMenuContent", ""], [1, "ex-floating-component-closing-icon-container", 3, "click"], [3, "closeClicked"], [1, "ex-floating-component-ng-content", 3, "click"], ["tabindex", "0", "aria-hidden", "true", 1, "ex-floating-add-component-accessibility-dummy", 3, "focus"], ["tabindex", "-1", 1, "ex-floating-add-trigger", 3, "type", "iconSide", "matMenuTriggerFor", "menuClosed", "menuOpened"], ["icon", "", 4, "ngIf"], [3, "ngTemplateOutlet"], ["icon", ""], [3, "ngClass"], [1, "ex-floating-add-trigger", "button-side-trigger", 3, "type", "click"], [1, "ex-floating-component-side-trigger", "sel-floating-component-side-trigger", 3, "matMenuTriggerFor", "ngClass", "menuOpened", "menuClosed"], ["matMenuTrigger", "matMenuTrigger"]], template: function ExFloatingAddComponentComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c5$c);
            i0.ɵɵtemplate(0, ExFloatingAddComponentComponent_ex_button_0_Template, 3, 5, "ex-button", 0);
            i0.ɵɵtemplate(1, ExFloatingAddComponentComponent_ng_template_1_Template, 4, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExFloatingAddComponentComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(5, "mat-menu", 3, 4)(7, "div", 5);
            i0.ɵɵlistener("focus", function ExFloatingAddComponentComponent_Template_div_focus_7_listener() { return ctx.onEndOfTabNavigation(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6, 7);
            i0.ɵɵlistener("keydown", function ExFloatingAddComponentComponent_Template_div_keydown_8_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵlistener("click", function ExFloatingAddComponentComponent_Template_div_click_10_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelementStart(11, "ex-close", 9);
            i0.ɵɵlistener("closeClicked", function ExFloatingAddComponentComponent_Template_ex_close_closeClicked_11_listener() { return ctx.close(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 10);
            i0.ɵɵlistener("click", function ExFloatingAddComponentComponent_Template_div_click_12_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵprojection(13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 11);
            i0.ɵɵlistener("focus", function ExFloatingAddComponentComponent_Template_div_focus_14_listener() { return ctx.onEndOfTabNavigation(); });
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.openToSide)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i3$1.MatMenu, i3$1.MatMenuTrigger, ExCloseComponent, ExButtonComponent], styles: [".ex-floating-component-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start}.ex-floating-component-content[_ngcontent-%COMP%]   .ex-floating-component-closing-icon-container[_ngcontent-%COMP%]{display:flex;align-self:flex-end;margin-top:5px}.ex-floating-component-content[_ngcontent-%COMP%]   .ex-floating-component-ng-content[_ngcontent-%COMP%]{margin:5px}.ex-floating-add-component-accessibility-dummy[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-button-icon-left[_ngcontent-%COMP%]{margin-right:10px}  .ex-floating-component-max-width.mat-mdc-menu-panel{max-width:none!important}.ex-floating-component-trigger[_ngcontent-%COMP%]{border:none;background:none}.ex-floating-add-trigger[_ngcontent-%COMP%]{color:#4164a4}.ex-floating-add-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper{width:100%;padding-inline-end:0px!important}.ex-floating-add-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper .tooltip-wrapper{width:100%}.ex-floating-add-trigger.button-side-trigger[_ngcontent-%COMP%]     .ex-button-wrapper .tooltip-wrapper .ex-list-header-popup-action-label{display:flex;width:100%;justify-content:space-between;align-items:center}.ex-floating-add-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]{position:absolute;top:0}.ex-floating-add-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger[_ngcontent-%COMP%]:not(.ex-floating-component-side-trigger-start){inset-inline-end:-1px}.ex-floating-add-trigger[_ngcontent-%COMP%]   .mat-mdc-menu-trigger.ex-floating-component-side-trigger-start[_ngcontent-%COMP%]{inset-inline-start:-1px}"], changeDetection: 0 }); }
};
ExFloatingAddComponentComponent = __decorate([
    ExDeprecated('ex-floating-component', { phaseOneSprint: DevSprints.S2023SEP, phaseTwoSprint: DevSprints.S2023SEP })
], ExFloatingAddComponentComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatingAddComponentComponent, [{
        type: Component,
        args: [{ selector: 'ex-floating-add-component', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ex-button *ngIf=\"!openToSide; else triggerSide\" [type]=\"action?.type\" class=\"ex-floating-add-trigger \"\n  [iconSide]=\"action?.iconClass || action?.type !== 'action'? 'left' : null\" [matMenuTriggerFor]=\"floatingSpace\"\n  (menuClosed)=\"onMenuClosed()\" (menuOpened)=\"triggerClicked($event)\" tabindex=\"-1\">\n\n  <div *ngIf=\"action?.iconClass\" icon>\n    <i [ngClass]=\"[action?.iconClass]\"></i>\n  </div>\n\n  <ng-container [ngTemplateOutlet]=\"triggerContentTmpl\"></ng-container>\n</ex-button>\n\n<ng-template #triggerSide>\n  <ex-button [type]=\"action?.type\" class=\"ex-floating-add-trigger button-side-trigger\" (click)=\"matMenuTrigger.openMenu()\">\n\n    <ng-container [ngTemplateOutlet]=\"triggerContentTmpl\"></ng-container>\n\n    <div #matMenuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"floatingSpace\" class=\"ex-floating-component-side-trigger sel-floating-component-side-trigger\"\n      [ngClass]=\"{ 'ex-floating-component-side-trigger-start': triggerAtStart }\" (menuOpened)=\"onSideMenuOpened()\"\n      (menuClosed)=\"onMenuClosed()\">\n    </div>\n  </ex-button>\n</ng-template>\n\n<ng-template #triggerContentTmpl>\n  <ng-content select=\"[trigger]\"></ng-content>\n</ng-template>\n\n<mat-menu #floatingSpace=\"matMenu\" class=\"ex-floating-component-max-width\">\n  <div tabindex=\"0\" (focus)=\"onEndOfTabNavigation()\" class=\"ex-floating-add-component-accessibility-dummy sel-floating-add-component-accessibility-dummy\"\n       aria-hidden=\"true\"></div>\n  <div (keydown)=\"$event.stopPropagation();\" #matMenuContent class=\"ex-floating-component-content\" tabindex=\"0\">\n    <div class=\"ex-floating-component-closing-icon-container\" (click)=\"$event.stopPropagation();\">\n      <ex-close (closeClicked)=\"close()\"></ex-close>\n    </div>\n    <div class=\"ex-floating-component-ng-content\" (click)=\"$event.stopPropagation();\">\n      <ng-content select=\"[content]\"></ng-content>\n    </div>\n  <div tabindex=\"0\" (focus)=\"onEndOfTabNavigation()\" class=\"ex-floating-add-component-accessibility-dummy\"\n       aria-hidden=\"true\"></div>\n  </div>\n</mat-menu>\n", styles: [".ex-floating-component-content{display:flex;flex-direction:column;align-items:flex-start}.ex-floating-component-content .ex-floating-component-closing-icon-container{display:flex;align-self:flex-end;margin-top:5px}.ex-floating-component-content .ex-floating-component-ng-content{margin:5px}.ex-floating-add-component-accessibility-dummy{width:0;height:0;overflow:hidden;border:transparent}.ex-button-icon-left{margin-right:10px}::ng-deep .ex-floating-component-max-width.mat-mdc-menu-panel{max-width:none!important}.ex-floating-component-trigger{border:none;background:none}.ex-floating-add-trigger{color:#4164a4}.ex-floating-add-trigger.button-side-trigger ::ng-deep .ex-button-wrapper{width:100%;padding-inline-end:0px!important}.ex-floating-add-trigger.button-side-trigger ::ng-deep .ex-button-wrapper .tooltip-wrapper{width:100%}.ex-floating-add-trigger.button-side-trigger ::ng-deep .ex-button-wrapper .tooltip-wrapper .ex-list-header-popup-action-label{display:flex;width:100%;justify-content:space-between;align-items:center}.ex-floating-add-trigger .mat-mdc-menu-trigger{position:absolute;top:0}.ex-floating-add-trigger .mat-mdc-menu-trigger:not(.ex-floating-component-side-trigger-start){inset-inline-end:-1px}.ex-floating-add-trigger .mat-mdc-menu-trigger.ex-floating-component-side-trigger-start{inset-inline-start:-1px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { action: [{
            type: Input
        }], openToSide: [{
            type: Input
        }], menuClosed: [{
            type: Output
        }], trigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], triggerElem: [{
            type: ViewChild,
            args: ['matMenuTrigger', { read: ElementRef }]
        }], matMenu: [{
            type: ViewChild,
            args: ['floatingSpace']
        }], menuContentElem: [{
            type: ViewChild,
            args: ['matMenuContent', { read: ElementRef }]
        }] }); })();

class ExFloatingAddComponentModule {
    static { this.ɵfac = function ExFloatingAddComponentModule_Factory(t) { return new (t || ExFloatingAddComponentModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFloatingAddComponentModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            ExCloseModule,
            ExButtonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatingAddComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    ExCloseModule,
                    ExButtonModule
                ],
                declarations: [
                    ExFloatingAddComponentComponent
                ],
                exports: [
                    ExFloatingAddComponentComponent
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFloatingAddComponentModule, { declarations: [ExFloatingAddComponentComponent], imports: [CommonModule,
        MatMenuModule,
        ExCloseModule,
        ExButtonModule], exports: [ExFloatingAddComponentComponent] }); })();

const _c0$U = function (a0, a1) { return { "ex-slide-toggle-btn-on": a0, "ex-slide-toggle-btn-off": a1 }; };
class ExSlideToggleComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * the checked state of the toggle
         */
        this.toggleChecked = false;
        /**
         * the toggle's tooltip
         */
        this.toggleTooltip = null;
        /**
         * the toggle's tooltip when it's disabled
         */
        this.disabledTooltip = null;
        /**
         * label to be displayed next to the toggle.
         */
        this.label = '';
        /**
         * whether to update the state (the toggleChecked) internally when a user operation is performed (i.e. the user clicks the toggle),
         * or to update the state only according to the input from the using component
         */
        this.doNotUpdateStateInternally = false;
        /**
         * the checked state of the toggle
         */
        this.toggleCheckedChange = new EventEmitter();
    }
    onToggleEvent(event) {
        event.preventDefault();
        if (!this.doNotUpdateStateInternally)
            this.toggleChecked = !this.toggleChecked;
        this.toggleCheckedChange.emit(this.toggleChecked);
    }
    writeValue(toggled) {
        this.toggleChecked = toggled;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExSlideToggleComponent_Factory(t) { return new (t || ExSlideToggleComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSlideToggleComponent, selectors: [["ex-slide-toggle"]], hostBindings: function ExSlideToggleComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("toggleCheckedChange", function ExSlideToggleComponent_toggleCheckedChange_HostBindingHandler($event) { return !ctx.doNotUpdateStateInternally && ctx.controlOnChange($event); });
        } }, inputs: { toggleChecked: "toggleChecked", toggleTooltip: "toggleTooltip", disabledTooltip: "disabledTooltip", name: "name", label: "label", doNotUpdateStateInternally: "doNotUpdateStateInternally", uniqueSelector: "uniqueSelector" }, outputs: { toggleCheckedChange: "toggleCheckedChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExSlideToggleComponent)), i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 17, consts: [[1, "ex-slide-toggle-wrapper", 3, "click"], ["type", "checkbox", 1, "ex-slide-toggle-input", "sel-slide-toggle-input", 3, "name"], ["exFormAriaAttributes", "", 3, "exFocus", "disabled", "exTooltip", "ngClass", "exFocusChange", "click", "keydown", "keyup"]], template: function ExSlideToggleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExSlideToggleComponent_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelement(1, "input", 1);
            i0.ɵɵelementStart(2, "button", 2);
            i0.ɵɵlistener("exFocusChange", function ExSlideToggleComponent_Template_button_exFocusChange_2_listener($event) { return ctx.isFieldFocused = $event; })("click", function ExSlideToggleComponent_Template_button_click_2_listener($event) { return ctx.onToggleEvent($event); })("keydown", function ExSlideToggleComponent_Template_button_keydown_2_listener($event) { return $event.stopPropagation(); })("keyup", function ExSlideToggleComponent_Template_button_keyup_2_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵpipe(3, "generateHTMLId");
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            let tmp_5_0;
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("name", ctx.name);
            i0.ɵɵattribute("aria-checked", ctx.toggleChecked);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("ex-slide-toggle-btn sel-ex-slide-toggle-button ", ctx.uniqueSelector ? i0.ɵɵpipeBind1(3, 10, "ex-slide-toggle-button" + ctx.uniqueSelector) : "", "");
            i0.ɵɵproperty("exFocus", ctx.isFieldFocused)("disabled", ctx.disabled || ctx.isReadOnly)("exTooltip", i0.ɵɵpipeBind1(4, 12, (tmp_5_0 = !ctx.disabled ? ctx.toggleTooltip : ctx.disabledTooltip) !== null && tmp_5_0 !== undefined ? tmp_5_0 : ""))("ngClass", i0.ɵɵpureFunction2(14, _c0$U, ctx.toggleChecked, !ctx.toggleChecked));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.label, "\n");
        } }, dependencies: [i1$5.NgClass, ExTooltipDirective, ExFocusDirective, ExFormAriaAttributesDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-slide-toggle-wrapper[_ngcontent-%COMP%]{padding-top:2px}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn[_ngcontent-%COMP%]{display:inline-block;outline:0;position:relative;cursor:pointer;-webkit-user-select:none;user-select:none;background:#8a8a8a;border-radius:22px;padding:2px;transition:all .4s ease;border:1px solid #e8eae9}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn[_ngcontent-%COMP%]:not(:disabled):focus-visible{outline:5px auto -webkit-focus-ring-color}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn[_ngcontent-%COMP%]:disabled{opacity:.4}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn[_ngcontent-%COMP%]:after{inset-inline-start:0;position:relative;display:block;content:\"\";width:50%;height:100%;border-radius:50%;background:#fff;transition:all .2s ease;box-shadow:0 0 0 1px #0000001a,0 4px #00000014}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn.ex-slide-toggle-btn-on[_ngcontent-%COMP%]:after{inset-inline-start:50%}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-btn.ex-slide-toggle-btn-on[_ngcontent-%COMP%]{background:#0e7bba}.ex-slide-toggle-wrapper[_ngcontent-%COMP%]   .ex-slide-toggle-input[_ngcontent-%COMP%]{display:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSlideToggleComponent, [{
        type: Component,
        args: [{ selector: 'ex-slide-toggle', host: {
                    '(toggleCheckedChange)': '!doNotUpdateStateInternally && controlOnChange($event)'
                }, providers: getValueAccessors(ExSlideToggleComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (click)=\"$event.stopPropagation()\" class=\"ex-slide-toggle-wrapper\">\n  <input [name]=\"name\" class=\"ex-slide-toggle-input sel-slide-toggle-input\" type=\"checkbox\" [attr.aria-checked]=\"toggleChecked\"/>\n  <button [(exFocus)]=\"isFieldFocused\" [disabled]=\"disabled || isReadOnly\"\n          [exTooltip]=\"((!disabled ? toggleTooltip : disabledTooltip) ?? '') | translate\"\n          (click)=\"onToggleEvent($event)\" (keydown)=\"$event.stopPropagation()\" (keyup)=\"$event.stopPropagation()\"\n          class=\"ex-slide-toggle-btn sel-ex-slide-toggle-button {{uniqueSelector ? (('ex-slide-toggle-button' + uniqueSelector) | generateHTMLId) : ''}}\"\n          [ngClass]=\"{'ex-slide-toggle-btn-on': toggleChecked, 'ex-slide-toggle-btn-off': !toggleChecked}\"\n          exFormAriaAttributes>\n  </button>\n  {{label}}\n</div>\n", styles: [".ex-slide-toggle-wrapper{padding-top:2px}.ex-slide-toggle-wrapper .ex-slide-toggle-btn{display:inline-block;outline:0;position:relative;cursor:pointer;-webkit-user-select:none;user-select:none;background:#8a8a8a;border-radius:22px;padding:2px;transition:all .4s ease;border:1px solid #e8eae9}.ex-slide-toggle-wrapper .ex-slide-toggle-btn:not(:disabled):focus-visible{outline:5px auto -webkit-focus-ring-color}.ex-slide-toggle-wrapper .ex-slide-toggle-btn:disabled{opacity:.4}.ex-slide-toggle-wrapper .ex-slide-toggle-btn:after{inset-inline-start:0;position:relative;display:block;content:\"\";width:50%;height:100%;border-radius:50%;background:#fff;transition:all .2s ease;box-shadow:0 0 0 1px #0000001a,0 4px #00000014}.ex-slide-toggle-wrapper .ex-slide-toggle-btn.ex-slide-toggle-btn-on:after{inset-inline-start:50%}.ex-slide-toggle-wrapper .ex-slide-toggle-btn.ex-slide-toggle-btn-on{background:#0e7bba}.ex-slide-toggle-wrapper .ex-slide-toggle-input{display:none}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { toggleChecked: [{
            type: Input
        }], toggleTooltip: [{
            type: Input
        }], disabledTooltip: [{
            type: Input
        }], name: [{
            type: Input
        }], label: [{
            type: Input
        }], doNotUpdateStateInternally: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], toggleCheckedChange: [{
            type: Output
        }] }); })();

class ExSlideToggleModule {
    static { this.ɵfac = function ExSlideToggleModule_Factory(t) { return new (t || ExSlideToggleModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSlideToggleModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatSlideToggleModule,
            ExDirectivesModule,
            TranslateModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSlideToggleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatSlideToggleModule,
                    ExDirectivesModule,
                    TranslateModule,
                    EXPipesModule
                ],
                declarations: [
                    ExSlideToggleComponent
                ],
                exports: [
                    ExSlideToggleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSlideToggleModule, { declarations: [ExSlideToggleComponent], imports: [CommonModule,
        FormsModule,
        MatSlideToggleModule,
        ExDirectivesModule,
        TranslateModule,
        EXPipesModule], exports: [ExSlideToggleComponent] }); })();

class ExHelpIconModule {
    static { this.ɵfac = function ExHelpIconModule_Factory(t) { return new (t || ExHelpIconModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExHelpIconModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            MatMenuModule,
            ExDirectivesModule,
            TranslateModule,
            ExSvgIconModule,
            ExCloseModule,
            A11yModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExHelpIconModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExHelpIconComponent
                ],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatMenuModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExSvgIconModule,
                    ExCloseModule,
                    A11yModule,
                    EXPipesModule,
                ],
                exports: [
                    ExHelpIconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExHelpIconModule, { declarations: [ExHelpIconComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        ExDirectivesModule,
        TranslateModule,
        ExSvgIconModule,
        ExCloseModule,
        A11yModule,
        EXPipesModule], exports: [ExHelpIconComponent] }); })();

class ExLinkModule {
    static { this.ɵfac = function ExLinkModule_Factory(t) { return new (t || ExLinkModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExLinkModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [MatTooltipModule,
            ExDirectivesModule,
            CommonModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLinkModule, [{
        type: NgModule,
        args: [{
                imports: [
                    MatTooltipModule,
                    ExDirectivesModule,
                    CommonModule,
                    EXPipesModule
                ],
                declarations: [
                    ExLinkComponent
                ],
                exports: [
                    ExLinkComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExLinkModule, { declarations: [ExLinkComponent], imports: [MatTooltipModule,
        ExDirectivesModule,
        CommonModule,
        EXPipesModule], exports: [ExLinkComponent] }); })();

class ExListHeaderModule {
    static { this.ɵfac = function ExListHeaderModule_Factory(t) { return new (t || ExListHeaderModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExListHeaderModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExButtonModule,
            ExIconModule,
            ExSortModule,
            ExFiltersModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExDropdownModule,
            ExFloatingComponentModule,
            ExFloatingAddComponentModule,
            ExComponentLoaderModule,
            MatCheckboxModule,
            TranslateModule,
            ExExtendedSearchModule,
            ExDateRangePickerModule,
            ExCheckboxModule,
            MatExpansionModule,
            MatMenuModule,
            ExSlideToggleModule,
            ExSvgIconModule,
            ExHelpIconModule,
            ExDotWrapperModule,
            ExLinkModule,
            MatSliderModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExButtonModule,
                    ExIconModule,
                    ExSortModule,
                    ExFiltersModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExDropdownModule,
                    ExFloatingComponentModule,
                    ExFloatingAddComponentModule,
                    ExComponentLoaderModule,
                    MatCheckboxModule,
                    TranslateModule,
                    ExExtendedSearchModule,
                    ExDateRangePickerModule,
                    ExCheckboxModule,
                    MatExpansionModule,
                    MatMenuModule,
                    ExSlideToggleModule,
                    ExSvgIconModule,
                    ExHelpIconModule,
                    ExDotWrapperModule,
                    ExLinkModule,
                    MatSliderModule,
                    EXPipesModule
                ],
                declarations: [
                    ExListHeaderComponent,
                ],
                exports: [
                    ExListHeaderComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExListHeaderModule, { declarations: [ExListHeaderComponent], imports: [CommonModule,
        FormsModule,
        ExButtonModule,
        ExIconModule,
        ExSortModule,
        ExFiltersModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExDropdownModule,
        ExFloatingComponentModule,
        ExFloatingAddComponentModule,
        ExComponentLoaderModule,
        MatCheckboxModule,
        TranslateModule,
        ExExtendedSearchModule,
        ExDateRangePickerModule,
        ExCheckboxModule,
        MatExpansionModule,
        MatMenuModule,
        ExSlideToggleModule,
        ExSvgIconModule,
        ExHelpIconModule,
        ExDotWrapperModule,
        ExLinkModule,
        MatSliderModule,
        EXPipesModule], exports: [ExListHeaderComponent] }); })();

const _c0$T = ["*"];
class ExRightClickActionsComponent {
    constructor(ref) {
        this.ref = ref;
        this.actions = [];
        this.actionClicked = new EventEmitter();
        this.copyCellClicked = new EventEmitter();
        this.contextMenuPosition = { x: '0px', y: '0px' };
    }
    onContextMenu(event) {
        if (this.actions?.length > 0) {
            event.preventDefault();
            const { x, y } = this.ref.nativeElement.getBoundingClientRect();
            this.clickedElement = event.target;
            this.contextMenuPosition.x = `${event.clientX - x}px`;
            this.contextMenuPosition.y = `${event.clientY - y}px`;
            this.contextMenu.openMenu();
        }
    }
    _actionClicked(key) {
        if (key == 'ex_copy_cell_value') {
            this.copyCellClicked.emit({ key: key, targetElement: this.clickedElement });
        }
        else {
            this.actionClicked.emit(key);
        }
    }
    static { this.ɵfac = function ExRightClickActionsComponent_Factory(t) { return new (t || ExRightClickActionsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRightClickActionsComponent, selectors: [["ex-right-click-actions"]], viewQuery: function ExRightClickActionsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contextMenu = _t.first);
        } }, hostBindings: function ExRightClickActionsComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("contextmenu", function ExRightClickActionsComponent_contextmenu_HostBindingHandler($event) { return ctx.onContextMenu($event); });
        } }, inputs: { actions: "actions" }, outputs: { actionClicked: "actionClicked", copyCellClicked: "copyCellClicked" }, ngContentSelectors: _c0$T, decls: 4, vars: 6, consts: [["aria-hidden", "true", 2, "position", "absolute", 3, "matMenuTriggerFor"], [3, "items", "actionClicked"], ["menu", ""]], template: function ExRightClickActionsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵelement(1, "div", 0);
            i0.ɵɵelementStart(2, "menu-item", 1, 2);
            i0.ɵɵlistener("actionClicked", function ExRightClickActionsComponent_Template_menu_item_actionClicked_2_listener($event) { return ctx._actionClicked($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r0 = i0.ɵɵreference(3);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("left", ctx.contextMenuPosition.x)("top", ctx.contextMenuPosition.y);
            i0.ɵɵproperty("matMenuTriggerFor", _r0.childMenu);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("items", ctx.actions);
        } }, dependencies: [i3$1.MatMenuTrigger, MenuItemComponent], styles: ["[_nghost-%COMP%]{position:relative}.ex-right-click-actions-item[_ngcontent-%COMP%]{line-height:30px;height:30px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRightClickActionsComponent, [{
        type: Component,
        args: [{ selector: 'ex-right-click-actions', template: "<ng-content></ng-content>\n<div aria-hidden=\"true\" style=\"position: absolute\" [style.left]=\"contextMenuPosition.x\" [style.top]=\"contextMenuPosition.y\"\n  [matMenuTriggerFor]=\"menu.childMenu\">\n</div>\n<menu-item #menu [items]=\"actions\" (actionClicked)=\"_actionClicked($event)\"></menu-item>\n", styles: [":host{position:relative}.ex-right-click-actions-item{line-height:30px;height:30px}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { actions: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], copyCellClicked: [{
            type: Output
        }], contextMenu: [{
            type: ViewChild,
            args: [MatMenuTrigger, { static: true }]
        }], onContextMenu: [{
            type: HostListener,
            args: ['contextmenu', ['$event']]
        }] }); })();

class ExRightClickActionsModule {
    static { this.ɵfac = function ExRightClickActionsModule_Factory(t) { return new (t || ExRightClickActionsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExRightClickActionsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatMenuModule,
            MatTooltipModule,
            ExDirectivesModule,
            MenuItemModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRightClickActionsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    MenuItemModule
                ],
                declarations: [
                    ExRightClickActionsComponent
                ],
                exports: [
                    ExRightClickActionsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExRightClickActionsModule, { declarations: [ExRightClickActionsComponent], imports: [CommonModule,
        MatMenuModule,
        MatTooltipModule,
        ExDirectivesModule,
        MenuItemModule], exports: [ExRightClickActionsComponent] }); })();

class ExEditingListModule {
    static { this.ɵfac = function ExEditingListModule_Factory(t) { return new (t || ExEditingListModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExEditingListModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            DragDropModule,
            ExDirectivesModule,
            TranslateModule,
            ExButtonModule,
            ExInlineEditingModule,
            ExSvgIconModule,
            ExDragModule,
            ExConfirmationMessageModule,
            ExDotWrapperModule,
            ExListHeaderModule,
            ExPaginationModule,
            ExRightClickActionsModule,
            ExChipModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEditingListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    DragDropModule,
                    ExDirectivesModule,
                    TranslateModule,
                    ExButtonModule,
                    ExInlineEditingModule,
                    ExSvgIconModule,
                    ExDragModule,
                    ExConfirmationMessageModule,
                    ExDotWrapperModule,
                    ExListHeaderModule,
                    ExPaginationModule,
                    ExRightClickActionsModule,
                    ExChipModule
                ],
                declarations: [
                    EditingListComponent,
                    EXEditingEntryComponent
                ],
                exports: [
                    EditingListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExEditingListModule, { declarations: [EditingListComponent,
        EXEditingEntryComponent], imports: [CommonModule,
        MatTooltipModule,
        DragDropModule,
        ExDirectivesModule,
        TranslateModule,
        ExButtonModule,
        ExInlineEditingModule,
        ExSvgIconModule,
        ExDragModule,
        ExConfirmationMessageModule,
        ExDotWrapperModule,
        ExListHeaderModule,
        ExPaginationModule,
        ExRightClickActionsModule,
        ExChipModule], exports: [EditingListComponent] }); })();
i0.ɵɵsetComponentScope(EXEditingEntryComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, EditModeComponentDirective, ViewModeComponentDirective, ExInlineEditingComponent, ExSvgIconComponent, ExConfirmationMessageComponent, ExDotWrapperComponent, ExRightClickActionsComponent, ExChipComponent], [i1$2.TranslatePipe]);

function ExEntityInfoComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExEntityInfoComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ExEntityInfoComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.view);
} }
function ExEntityInfoComponent_ng_container_3_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExEntityInfoComponent_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, ExEntityInfoComponent_ng_container_3_div_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.edit);
} }
function ExEntityInfoComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExEntityInfoComponent_ng_container_3_div_1_Template, 2, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} }
function ExEntityInfoComponent_ex_avatar_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-avatar", 9);
    i0.ɵɵlistener("imageFileChanged", function ExEntityInfoComponent_ex_avatar_4_Template_ex_avatar_imageFileChanged_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onImageFileChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r2.avatarLoading)("imgSrc", ctx_r2.entityImg)("diameter", 80)("hasEdit", true);
} }
const _c0$S = function (a0) { return { "name": a0, "type": "uxf" }; };
class ExEntityInfoComponent {
    constructor() {
        /**
         * Show shimmer until the image will load.
         */
        this.avatarLoading = false;
        /**
         * Show placeHolder in case there is no image
         */
        this.showAvatarPlaceholder = false;
        /**
         * Section title in edit mode
         */
        this.editTitle = "ng.general.edit";
        /**
         * The icon that display when mouse onHover on the section.
         */
        this.editIconType = "uxf-pencil";
        /**
         * flag that control the component mode
         */
        this.editMode = false;
        /**
         * Setting the component as view mode - unable the ability to switch to edit
         */
        this.readonly = false;
        /**
         * When component mode changed
         */
        this.editModeChange = new EventEmitter();
        /**
         * Url for the image
         */
        this.imageFileChanged = new EventEmitter();
        /**
         * Edit clicked
         */
        this.editClicked = new EventEmitter();
        /**
         * CLose button clicked
         */
        this.closeClicked = new EventEmitter();
    }
    ngOnInit() {
    }
    onImageFileChange(file) {
        this.imageFileChanged.emit(file);
    }
    onEditClicked() {
        this.editClicked.emit();
    }
    onCloseClicked() {
        this.closeClicked.emit();
    }
    onEditModeChanged(editMode) {
        this.editModeChange.emit(editMode);
    }
    get showAvatar() {
        return !!this.entityImg || this.showAvatarPlaceholder;
    }
    static { this.ɵfac = function ExEntityInfoComponent_Factory(t) { return new (t || ExEntityInfoComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExEntityInfoComponent, selectors: [["ex-entity-info"]], contentQueries: function ExEntityInfoComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ViewModeComponentDirective, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, EditModeComponentDirective, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.view = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.edit = _t.first);
        } }, inputs: { entityImg: "entityImg", avatarLoading: "avatarLoading", showAvatarPlaceholder: "showAvatarPlaceholder", editTitle: "editTitle", editIconType: "editIconType", editMode: "editMode", readonly: "readonly" }, outputs: { editModeChange: "editModeChange", imageFileChanged: "imageFileChanged", editClicked: "editClicked", closeClicked: "closeClicked" }, decls: 5, vars: 9, consts: [[1, "ex-entity-info-wrapper"], ["viewBackgroundColor", "#F0F5F8", 3, "editTitle", "editTitleIcon", "editMode", "closeClicked", "editClicked", "editModeChange"], ["class", "ex-entity-info-container ex-entity-info-container-view", 4, "viewModeComponent"], [4, "ngIf"], ["class", "ex-entity-info-image", 3, "loading", "imgSrc", "diameter", "hasEdit", "imageFileChanged", 4, "ngIf"], [1, "ex-entity-info-container", "ex-entity-info-container-view"], [4, "ngTemplateOutlet"], ["class", "ex-entity-info-container", 4, "editModeComponent"], [1, "ex-entity-info-container"], [1, "ex-entity-info-image", 3, "loading", "imgSrc", "diameter", "hasEdit", "imageFileChanged"]], template: function ExEntityInfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-inline-editing", 1);
            i0.ɵɵlistener("closeClicked", function ExEntityInfoComponent_Template_ex_inline_editing_closeClicked_1_listener() { return ctx.onCloseClicked(); })("editClicked", function ExEntityInfoComponent_Template_ex_inline_editing_editClicked_1_listener() { return ctx.onEditClicked(); })("editModeChange", function ExEntityInfoComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.editMode = $event; })("editModeChange", function ExEntityInfoComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.onEditModeChanged($event); });
            i0.ɵɵtemplate(2, ExEntityInfoComponent_div_2_Template, 2, 1, "div", 2);
            i0.ɵɵtemplate(3, ExEntityInfoComponent_ng_container_3_Template, 2, 0, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExEntityInfoComponent_ex_avatar_4_Template, 1, 4, "ex-avatar", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassProp("ex-entity-info-wrapper--padded", ctx.showAvatar);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editTitle", ctx.editTitle)("editTitleIcon", i0.ɵɵpureFunction1(7, _c0$S, ctx.editIconType))("editMode", ctx.editMode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.readonly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showAvatar);
        } }, dependencies: [i1$5.NgIf, i1$5.NgTemplateOutlet, ExInlineEditingComponent, ExAvatarComponent, EditModeComponentDirective, ViewModeComponentDirective], styles: [".ex-entity-info-container-view[_ngcontent-%COMP%]{display:flex}.ex-entity-info-wrapper[_ngcontent-%COMP%]{position:relative;margin-top:5px}.ex-entity-info-wrapper[_ngcontent-%COMP%]   .ex-entity-info-image[_ngcontent-%COMP%]{position:absolute;top:-15px;inset-inline-start:10px}.ex-entity-info-wrapper--padded[_ngcontent-%COMP%]   .ex-entity-info-container[_ngcontent-%COMP%]{padding-inline-start:80px}.ex-entity-info-wrapper--padded[_ngcontent-%COMP%]     .ex-inline-editing-title, .ex-entity-info-wrapper--padded[_ngcontent-%COMP%]     .ex-inline-editing-title-icon{padding-inline-start:90px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEntityInfoComponent, [{
        type: Component,
        args: [{ selector: 'ex-entity-info', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-entity-info-wrapper\" [class.ex-entity-info-wrapper--padded]=\"showAvatar\">\r\n    <ex-inline-editing viewBackgroundColor=\"#F0F5F8\" [editTitle]=\"editTitle\"\r\n        [editTitleIcon]=\"{ 'name': editIconType, 'type': 'uxf' }\" (closeClicked)=\"onCloseClicked()\"\r\n        (editClicked)=\"onEditClicked()\" [(editMode)]=\"editMode\" (editModeChange)=\"onEditModeChanged($event)\">\r\n        <div class=\"ex-entity-info-container ex-entity-info-container-view\" *viewModeComponent>\r\n            <ng-container *ngTemplateOutlet=\"view\"></ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"!readonly\">\r\n            <div class=\"ex-entity-info-container\" *editModeComponent>\r\n                <ng-container *ngTemplateOutlet=\"edit\"></ng-container>\r\n            </div>\r\n        </ng-container>\r\n    </ex-inline-editing>\r\n    <ex-avatar class=\"ex-entity-info-image\" [loading]=\"avatarLoading\" [imgSrc]=\"entityImg\" [diameter]=\"80\"\r\n        [hasEdit]=\"true\" (imageFileChanged)=\"onImageFileChange($event)\" *ngIf=\"showAvatar\"></ex-avatar>\r\n</div>", styles: [".ex-entity-info-container-view{display:flex}.ex-entity-info-wrapper{position:relative;margin-top:5px}.ex-entity-info-wrapper .ex-entity-info-image{position:absolute;top:-15px;inset-inline-start:10px}.ex-entity-info-wrapper--padded .ex-entity-info-container{padding-inline-start:80px}.ex-entity-info-wrapper--padded ::ng-deep .ex-inline-editing-title,.ex-entity-info-wrapper--padded ::ng-deep .ex-inline-editing-title-icon{padding-inline-start:90px}\n"] }]
    }], function () { return []; }, { entityImg: [{
            type: Input
        }], avatarLoading: [{
            type: Input
        }], showAvatarPlaceholder: [{
            type: Input
        }], editTitle: [{
            type: Input
        }], editIconType: [{
            type: Input
        }], editMode: [{
            type: Input
        }], readonly: [{
            type: Input
        }], editModeChange: [{
            type: Output
        }], imageFileChanged: [{
            type: Output
        }], editClicked: [{
            type: Output
        }], closeClicked: [{
            type: Output
        }], view: [{
            type: ContentChild,
            args: [ViewModeComponentDirective, { read: TemplateRef }]
        }], edit: [{
            type: ContentChild,
            args: [EditModeComponentDirective, { read: TemplateRef }]
        }] }); })();

class ExEntityInfoModule {
    static { this.ɵfac = function ExEntityInfoModule_Factory(t) { return new (t || ExEntityInfoModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExEntityInfoModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            ExInlineEditingModule,
            ExAvatarModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExEntityInfoModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    ExInlineEditingModule,
                    ExAvatarModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExEntityInfoComponent
                ],
                exports: [
                    ExEntityInfoComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExEntityInfoModule, { declarations: [ExEntityInfoComponent], imports: [CommonModule,
        TranslateModule,
        ExInlineEditingModule,
        ExAvatarModule,
        ExDirectivesModule], exports: [ExEntityInfoComponent] }); })();

const _c0$R = ["DivRef"];
const _c1$w = ["LabelRef"];
function ExExpandableLabelComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 6, 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.content, i0.ɵɵsanitizeHtml);
} }
function ExExpandableLabelComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", null, 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.content, " ");
} }
function ExExpandableLabelComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", null, 7);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
} }
function ExExpandableLabelComponent_button_7_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 10);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("@arrowFlip", ctx_r8.showMore ? "down" : "up");
    i0.ɵɵattribute("aria-label", ctx_r8.showMore ? ctx_r8.moreText : ctx_r8.lessText + " " + ctx_r8.ariaLabel);
} }
function ExExpandableLabelComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ExExpandableLabelComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.showMore ? ctx_r9.onShowMore() : ctx_r9.onShowLess()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExExpandableLabelComponent_button_7_i_4_Template, 1, 2, "i", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r4.showMore ? i0.ɵɵpipeBind1(2, 2, ctx_r4.moreText) : i0.ɵɵpipeBind1(3, 4, ctx_r4.lessText), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.hasArrow);
} }
const _c2$n = ["*"];
class ExExpandableLabelComponent {
    /**
     * @ignore
     */
    constructor(renderer, changeDetectorRef) {
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Used for defining how many rows should we allow before showing the "Show More" button and cutting the content.
         */
        this.maxLines = 4;
        /**
         * Generic message for the button that indicates we can expend the content.
         */
        this.moreText = 'ex.ui.expendable_label.show_more';
        /**
         * Generic message for the button that indicates we can shrink the content back to the max lines.
         */
        this.lessText = 'ex.ui.expendable_label.show_less';
        /**
         * Whether the show more and show less will have an arrow that will flip next to them
         */
        this.hasArrow = true;
        /**
         * The actual content that the user will see. if empty - the content will come from ng-content.
         */
        this.content = '';
        /**
         * Indicates if the content is in html format. default is false
         */
        this.innerHtml = false;
        /**
         * Whether to display the show more and show less button
         */
        this.displayShowMoreButton = true;
        /**
         * Text for aria-label
         */
        this.ariaLabel = '';
        this.showMore = false;
        this.showLess = false;
        this.expended = false;
        this.inAnimation = false;
        this.contentLoaded = false;
        this.resetDivHeight = true;
    }
    /**
     * @ignore
     */
    ngOnInit() { }
    /**
     * @ignore
     */
    ngAfterViewInit() {
        if (this.content != null) {
            this.contentLoaded = true;
        }
    }
    /**
     * Calculates the needed height if the text needs less then the maxLines
     */
    ngAfterViewChecked() {
        if (this.divRef && this.labelRef && this.resetDivHeight) {
            this.renderer.setStyle(this.divRef.nativeElement, 'height', this.maxLines * this.computedLineHeight + 'px');
            if (!this.isOverFlown() || this.expended) {
                this.renderer.setStyle(this.divRef.nativeElement, 'height', 'auto');
            }
            this.resetDivHeight = false;
            this.changeDetectorRef.detectChanges();
        }
    }
    get computedLineHeight() {
        if (this.labelRef?.nativeElement) {
            return parseFloat(window.getComputedStyle(this.labelRef.nativeElement).getPropertyValue("line-height"));
        }
        return 18;
    }
    /**
     * This function turns a flag on when expending animation has began
     */
    animationBegan() {
        this.inAnimation = true;
    }
    /**
     * This function turns a flag on when expending animation has ended and recalculates if showMore and showLess are needed
     */
    animationEnded() {
        this.inAnimation = false;
        this.showMore = this.isOverFlown();
        this.showLess = this.hasShowLess() && !this.showMore;
    }
    /**
     * This function is being called when the Show More button is clicked.
     * The function changes the amount of lines allowed before cutting to a huge number that should not cut anything.
     */
    onShowMore() {
        this.expended = true;
        this.resetDivHeight = true;
        this.changeDetectorRef.detectChanges();
    }
    /**
     * This function is being called when the Show Less button is clicked.
     * The function returns the amount of lines allowed to the predetermined max lines.
     */
    onShowLess() {
        this.expended = false;
        this.resetDivHeight = true;
        this.changeDetectorRef.detectChanges();
    }
    /**
     * This function is being called when the div changes its size.
     * The function checks if the content is overflowing the div or if the div is small enough to show the "show less button".
     * The function turns the showMore and ShowLess flags every time the div changes.
     * @param event The event that being caught, contains the old and new height and width of the resized div.
     */
    onResized(event) {
        if (this.contentLoaded && !this.inAnimation) {
            this.showMore = this.isOverFlown();
            this.showLess = this.hasShowLess() && !this.showMore;
            this.resetDivHeight = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    /**
     * This functions is calculating the if the height of the text is bigger then its containing div (overflowing).
     * @returns true if the text will be cut by the div, and false if the div is big enough to contain the whole text.
     */
    isOverFlown() {
        return this.labelRef.nativeElement.clientHeight > this.divRef.nativeElement.clientHeight;
    }
    /**
     * This functions is calculating if the div was collapsed would it overflow.
     * If it would, then we should show the "Show Less" button.
     * @returns true if the text is higher than the collapsed div,
     * and false if the div is big enough to contain the whole text when collapsed.
     */
    hasShowLess() {
        return (this.maxLines * this.computedLineHeight) < this.divRef.nativeElement.clientHeight;
    }
    static { this.ɵfac = function ExExpandableLabelComponent_Factory(t) { return new (t || ExExpandableLabelComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExExpandableLabelComponent, selectors: [["ex-expandable-label"]], viewQuery: function ExExpandableLabelComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$R, 5);
            i0.ɵɵviewQuery(_c1$w, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.divRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.labelRef = _t.first);
        } }, inputs: { maxLines: "maxLines", moreText: "moreText", lessText: "lessText", hasArrow: "hasArrow", content: "content", innerHtml: "innerHtml", displayShowMoreButton: "displayShowMoreButton", ariaLabel: "ariaLabel" }, ngContentSelectors: _c2$n, decls: 8, vars: 4, consts: [[3, "resized"], [1, "ex-expandable-label-overflow-break", "ex-epandable-label-density"], ["DivRef", ""], [3, "innerHtml", 4, "ngIf"], [4, "ngIf"], ["class", "ex-expandable-label-more-less-button", 3, "click", 4, "ngIf"], [3, "innerHtml"], ["LabelRef", ""], [1, "ex-expandable-label-more-less-button", 3, "click"], ["class", "fa fa-angle-down", 4, "ngIf"], [1, "fa", "fa-angle-down"]], template: function ExExpandableLabelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵelementStart(1, "div", 0);
            i0.ɵɵlistener("resized", function ExExpandableLabelComponent_Template_div_resized_1_listener($event) { return ctx.onResized($event); });
            i0.ɵɵelementStart(2, "div", 1, 2);
            i0.ɵɵtemplate(4, ExExpandableLabelComponent_p_4_Template, 2, 1, "p", 3);
            i0.ɵɵtemplate(5, ExExpandableLabelComponent_p_5_Template, 3, 1, "p", 4);
            i0.ɵɵtemplate(6, ExExpandableLabelComponent_p_6_Template, 3, 0, "p", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, ExExpandableLabelComponent_button_7_Template, 5, 6, "button", 5);
            i0.ɵɵelementContainerEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.innerHtml && ctx.content);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.innerHtml && ctx.content);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.content);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.displayShowMoreButton && (ctx.showLess || ctx.showMore));
        } }, dependencies: [i1$5.NgIf, ResizedDirective, i1$2.TranslatePipe], styles: [".ex-expandable-label-overflow-break[_ngcontent-%COMP%]{overflow:hidden;word-break:break-word}button[_ngcontent-%COMP%]{border:0px;background:none}"], data: { animation: [Animations$b] }, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExExpandableLabelComponent, [{
        type: Component,
        args: [{ selector: 'ex-expandable-label', animations: [Animations$b], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\n  <div (resized)=\"onResized($event)\">\n    <div #DivRef class=\"ex-expandable-label-overflow-break ex-epandable-label-density\">\n      <p #LabelRef *ngIf=\"innerHtml && content\" [innerHtml]=\"content\"></p>\n      <p #LabelRef *ngIf=\"!innerHtml && content\">\n        {{content}}\n      </p>\n      <p #LabelRef *ngIf=\"!content\">\n        <ng-content></ng-content>\n      </p>\n    </div>\n  </div>\n  <button class=\"ex-expandable-label-more-less-button\" *ngIf=\"displayShowMoreButton && (showLess || showMore)\"\n    (click)=\"showMore ? onShowMore() : onShowLess()\">{{ showMore ? (moreText | translate) : (lessText | translate)}} <i *ngIf=\"hasArrow\"\n      [@arrowFlip]=\"showMore ? 'down' : 'up'\" class=\"fa fa-angle-down\" [attr.aria-label]=\"showMore ? moreText : lessText +' ' +ariaLabel\"></i></button>\n</ng-container>\n", styles: [".ex-expandable-label-overflow-break{overflow:hidden;word-break:break-word}button{border:0px;background:none}\n"] }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }]; }, { maxLines: [{
            type: Input
        }], moreText: [{
            type: Input
        }], lessText: [{
            type: Input
        }], hasArrow: [{
            type: Input
        }], content: [{
            type: Input
        }], innerHtml: [{
            type: Input
        }], displayShowMoreButton: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], divRef: [{
            type: ViewChild,
            args: ['DivRef']
        }], labelRef: [{
            type: ViewChild,
            args: ['LabelRef']
        }] }); })();

class ExExpandableLabelModule {
    static { this.ɵfac = function ExExpandableLabelModule_Factory(t) { return new (t || ExExpandableLabelModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExExpandableLabelModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            AngularResizeEventModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExExpandableLabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AngularResizeEventModule,
                    TranslateModule
                ],
                exports: [ExExpandableLabelComponent],
                declarations: [ExExpandableLabelComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExExpandableLabelModule, { declarations: [ExExpandableLabelComponent], imports: [CommonModule,
        AngularResizeEventModule,
        TranslateModule], exports: [ExExpandableLabelComponent] }); })();

function ExFallbackIconComponent_ex_svg_icon_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r0.defaultIconName)("size", ctx_r0.iconSize);
} }
function ExFallbackIconComponent_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 3);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r1.iconName)("size", ctx_r1.iconSize);
} }
class ExFallbackIconComponent {
    constructor(http, cdr) {
        this.http = http;
        this.cdr = cdr;
        /**
         * the name of the svg icon to display
         */
        this.iconName = "";
        /**
         * icon name of icon that will be displayed if the icon of iconName is not found
         */
        this.defaultIconName = "";
        /**
         * the size of the icon
         */
        this.iconSize = "large";
        this.iconExists = false;
        this.iconChecked = false;
    }
    ngOnInit() {
        this.setFileTypeIcon();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('iconName')) {
            if (!changes['iconName'].firstChange) {
                this.iconExists = false;
                this.iconChecked = false;
                this.setFileTypeIcon();
            }
        }
    }
    setFileTypeIcon() {
        let path = '/ng/assets/svg-icons/' + this.iconName + '.svg';
        this.http.head(path, { responseType: 'blob' }).subscribe(response => {
            if (response.type === 'image/svg+xml') {
                this.iconExists = true;
            }
            this.iconChecked = true;
            this.cdr.markForCheck();
        }, error => {
            this.iconExists = false;
            this.iconChecked = true;
            this.cdr.markForCheck();
        }, () => {
        });
    }
    static { this.ɵfac = function ExFallbackIconComponent_Factory(t) { return new (t || ExFallbackIconComponent)(i0.ɵɵdirectiveInject(i1$8.HttpClient), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFallbackIconComponent, selectors: [["ex-fallback-icon"]], inputs: { iconName: "iconName", defaultIconName: "defaultIconName", iconSize: "iconSize" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "fallback-icon-default", 3, "iconName", "size", 4, "ngIf"], ["class", "fallback-icon-specified", 3, "iconName", "size", 4, "ngIf"], [1, "fallback-icon-default", 3, "iconName", "size"], [1, "fallback-icon-specified", 3, "iconName", "size"]], template: function ExFallbackIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFallbackIconComponent_ex_svg_icon_0_Template, 1, 2, "ex-svg-icon", 0);
            i0.ɵɵtemplate(1, ExFallbackIconComponent_ex_svg_icon_1_Template, 1, 2, "ex-svg-icon", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.iconChecked || ctx.iconChecked && !ctx.iconExists);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconChecked && ctx.iconExists);
        } }, dependencies: [i1$5.NgIf, ExSvgIconComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFallbackIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-fallback-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ex-svg-icon *ngIf=\"!iconChecked || (iconChecked && !iconExists)\" class=\"fallback-icon-default\" [iconName]=\"defaultIconName\"\r\n    [size]=\"iconSize\"></ex-svg-icon>\r\n<ex-svg-icon *ngIf=\"iconChecked && iconExists\" class=\"fallback-icon-specified\" [iconName]=\"iconName\" [size]=\"iconSize\">\r\n</ex-svg-icon>" }]
    }], function () { return [{ type: i1$8.HttpClient }, { type: i0.ChangeDetectorRef }]; }, { iconName: [{
            type: Input
        }], defaultIconName: [{
            type: Input
        }], iconSize: [{
            type: Input
        }] }); })();

class ExFallbackIconModule {
    static { this.ɵfac = function ExFallbackIconModule_Factory(t) { return new (t || ExFallbackIconModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFallbackIconModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFallbackIconModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExFallbackIconComponent
                ],
                exports: [
                    ExFallbackIconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFallbackIconModule, { declarations: [ExFallbackIconComponent], imports: [CommonModule,
        ExSvgIconModule], exports: [ExFallbackIconComponent] }); })();

function ExFileDropComponent_ng_template_2_div_4_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 12);
    i0.ɵɵlistener("click", function ExFileDropComponent_ng_template_2_div_4_ex_button_2_Template_ex_button_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r7.dropZoneAddButtonClicked.emit($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("iconSide", "left")("disabled", ctx_r3.disabled)("disabledTooltip", ctx_r3.disabledTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r3.dropZoneAddButtonLabel), " ");
} }
function ExFileDropComponent_ng_template_2_div_4_ex_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 13);
    i0.ɵɵlistener("click", function ExFileDropComponent_ng_template_2_div_4_ex_button_5_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const openFileSelector_r1 = i0.ɵɵnextContext(2).openFileSelector; return i0.ɵɵresetView(openFileSelector_r1()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r4.disabled)("disabledTooltip", ctx_r4.disabledTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r4.dropZoneBrowseButtonLabel), " ");
} }
function ExFileDropComponent_ng_template_2_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ex-svg-icon", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "info")("tooltip", ctx_r5.infoTooltip)("ariaLabel", ctx_r5.infoTooltip);
} }
function ExFileDropComponent_ng_template_2_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r6.description));
} }
function ExFileDropComponent_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, ExFileDropComponent_ng_template_2_div_4_ex_button_2_Template, 3, 6, "ex-button", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ExFileDropComponent_ng_template_2_div_4_ex_button_5_Template, 3, 5, "ex-button", 9);
    i0.ɵɵtemplate(6, ExFileDropComponent_ng_template_2_div_4_div_6_Template, 2, 3, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ExFileDropComponent_ng_template_2_div_4_div_7_Template, 3, 3, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDropZoneAddButton);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, ctx_r2.dropLabel()), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDropZoneBrowseButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.infoTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.description);
} }
const _c0$Q = function (a0) { return { "ex-file-drop-zone-file-over": a0 }; };
const _c1$v = function (a0) { return { "file-over": a0 }; };
function ExFileDropComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExFileDropComponent_ng_template_2_div_4_Template, 8, 7, "div", 5);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$Q, ctx_r0._fileOver));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$v, ctx_r0._fileOver));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !(ctx_r0.sectionLayoutViewModeObservable && i0.ɵɵpipeBind1(5, 3, ctx_r0.sectionLayoutViewModeObservable)));
} }
const _c2$m = ["*"];
class ExFileDropComponent extends ExControlValueAccessor {
    constructor(cdr, sectionLayoutViewModeObservable) {
        super(sectionLayoutViewModeObservable, cdr);
        this.cdr = cdr;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        /**
         * whether to allow selection of multiple files
         */
        this.multiple = true;
        /**
         * whether to display the 'browse' button in the drop zone
         */
        this.showDropZoneBrowseButton = true;
        /*
         * whether to display the 'add' button in the drop zone
         */
        this.showDropZoneAddButton = false;
        /**
         * the label for the drop zone
         */
        this.dropZoneLabel = "ng.attachment_grid.drop_files";
        /**
         * the label for the drop zone 'browse' button
         */
        this.dropZoneBrowseButtonLabel = "ng.attachment_grid.browse_files";
        /**
         * the label for the drop zone 'add' button
         */
        this.dropZoneAddButtonLabel = "ng.attachment_grid.add_attachment";
        /**
         * whether the drop zone and the buttons in it are disabled
         */
        this.disabled = false;
        /**
         * event emitted when a file is dropped in the drop zone
         */
        this.fileDropped = new EventEmitter();
        /**
         * event emitted when the drop zone 'add' button is clicked
         */
        this.dropZoneAddButtonClicked = new EventEmitter();
        /**
        * event emitted when a file is dragged over the drop zone
        */
        this.fileOver = new EventEmitter();
        /**
         * event emitted when a file is dragged out of the drop zone
         */
        this.fileLeave = new EventEmitter();
        this.files = [];
        this.filesChange = new EventEmitter();
        this._fileOver = false;
    }
    onFileDropped(files) {
        this._fileOver = false;
        this.files = files;
        this.filesChange.emit(this.files);
        for (const droppedFile of files) {
            // Is it a file?
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = droppedFile.fileEntry;
                this.fileDropped.emit({ fileEntry: fileEntry, path: droppedFile.relativePath });
                /*
                fileEntry.file((file: File) => {
                    // Here you can access the real file
                    //console.log(droppedFile.relativePath, file);
                });
                */
            }
            else {
                // It was a directory (empty directories are added, otherwise only files)
                //const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
                //console.log(droppedFile.relativePath, fileEntry);
            }
        }
    }
    onFileOver(event) {
        clearTimeout(this.fileLeaveTimeout);
        this._fileOver = true;
        this.fileOver.emit(event);
    }
    onFileLeave(event) {
        this.fileLeaveTimeout = setTimeout(() => {
            this._fileOver = false;
            this.fileLeave.emit(event);
        }, 1);
    }
    dropLabel() {
        if (this.showDropZoneAddButton) {
            if (this.showDropZoneBrowseButton) {
                return 'ng.general.drop.attachment_files';
            }
            return 'ng.general.drop.attachment';
        }
        if (this.showDropZoneBrowseButton) {
            return 'ng.general.drop.files';
        }
        return 'ng.general.drop_files';
    }
    writeValue(value) {
        this.files = value;
        this.cdr.markForCheck();
    }
    static { this.ɵfac = function ExFileDropComponent_Factory(t) { return new (t || ExFileDropComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFileDropComponent, selectors: [["ex-file-drop"]], hostBindings: function ExFileDropComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("filesChanged", function ExFileDropComponent_filesChanged_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExFileDropComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { multiple: "multiple", showDropZoneBrowseButton: "showDropZoneBrowseButton", showDropZoneAddButton: "showDropZoneAddButton", dropZoneLabel: "dropZoneLabel", dropZoneBrowseButtonLabel: "dropZoneBrowseButtonLabel", dropZoneAddButtonLabel: "dropZoneAddButtonLabel", disabled: "disabled", disabledTooltip: "disabledTooltip", description: "description", infoTooltip: "infoTooltip", files: "files" }, outputs: { fileDropped: "fileDropped", dropZoneAddButtonClicked: "dropZoneAddButtonClicked", fileOver: "fileOver", fileLeave: "fileLeave", filesChange: "filesChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExFileDropComponent)), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2$m, decls: 3, vars: 4, consts: [["dropZoneClassName", "ex-file-drop-zone", "contentClassName", "ex-file-drop-zone-content", 3, "disabled", "multiple", "focusout", "onFileDrop", "onFileOver", "onFileLeave"], ["ngx-file-drop-content-tmp", ""], [1, "ex-file-drop-zone-content-wrapper", 3, "ngClass"], [1, "ex-file-drop-zone-overlay", 3, "ngClass"], [1, "ex-file-drop-zone-content-layout"], ["class", "ex-file-drop-zone-content-add-wrapper", 4, "ngIf"], [1, "ex-file-drop-zone-content-add-wrapper"], [1, "ex-file-drop-zone-content-add", "sel-file-drop-zone-content-add"], ["class", "ex-file-drop-zone-add-button sel-file-drop-zone-add-button", "type", "add", 3, "iconSide", "disabled", "disabledTooltip", "click", 4, "ngIf"], ["class", "ex-file-drop-zone-browse-button sel-file-drop-zone-browse-button", "type", "action", 3, "disabled", "disabledTooltip", "click", 4, "ngIf"], [4, "ngIf"], ["class", "sel-description", 4, "ngIf"], ["type", "add", 1, "ex-file-drop-zone-add-button", "sel-file-drop-zone-add-button", 3, "iconSide", "disabled", "disabledTooltip", "click"], ["type", "action", 1, "ex-file-drop-zone-browse-button", "sel-file-drop-zone-browse-button", 3, "disabled", "disabledTooltip", "click"], ["color", "#2F5A9C", 3, "iconName", "tooltip", "ariaLabel"], [1, "sel-description"]], template: function ExFileDropComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "ngx-file-drop", 0);
            i0.ɵɵlistener("focusout", function ExFileDropComponent_Template_ngx_file_drop_focusout_0_listener($event) { return ctx.onBlur($event); })("onFileDrop", function ExFileDropComponent_Template_ngx_file_drop_onFileDrop_0_listener($event) { return ctx.onFileDropped($event); })("onFileOver", function ExFileDropComponent_Template_ngx_file_drop_onFileOver_0_listener($event) { return ctx.onFileOver($event); })("onFileLeave", function ExFileDropComponent_Template_ngx_file_drop_onFileLeave_0_listener($event) { return ctx.onFileLeave($event); });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, ExFileDropComponent_ng_template_2_Template, 6, 9, "ng-template", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled || ctx.sectionLayoutViewModeObservable && i0.ɵɵpipeBind1(1, 2, ctx.sectionLayoutViewModeObservable))("multiple", ctx.multiple);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i2$5.NgxFileDropComponent, i2$5.NgxFileDropContentTemplateDirective, ExButtonComponent, ExSvgIconComponent, i1$5.AsyncPipe, i1$2.TranslatePipe], styles: [".ex-file-drop-zone{margin:auto;border:0px dashed transparent;text-align:inherit}  .ex-file-drop-zone.ngx-file-drop__drop-zone--over{border:0px dashed transparent;background-color:transparent!important}  .ex-file-drop-zone .ex-file-drop-zone-content{display:flex;flex-direction:column;align-items:center;justify-content:center}.ex-file-drop-zone-content-add-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px dashed #898989;border-radius:0;margin-top:20px;padding:15px}.ex-file-drop-zone-content-add-wrapper[_ngcontent-%COMP%]   .ex-file-drop-zone-content-add[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.ex-file-drop-zone-content-add-wrapper[_ngcontent-%COMP%]   .ex-file-drop-zone-browse-button[_ngcontent-%COMP%]{margin-left:2px;margin-right:2px}.ex-file-drop-zone-content-layout[_ngcontent-%COMP%]{width:100%}.ex-file-drop-zone-content-wrapper[_ngcontent-%COMP%]{width:100%;border-radius:0;border:0px dashed transparent;position:relative}.ex-file-drop-zone-content-wrapper[_ngcontent-%COMP%]   .ex-file-drop-zone-overlay[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%}.ex-file-drop-zone-content-wrapper[_ngcontent-%COMP%]   .ex-file-drop-zone-overlay.file-over[_ngcontent-%COMP%]{z-index:10;background-color:#ffffff4d;border:2px dashed rgb(230,139,20)}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileDropComponent, [{
        type: Component,
        args: [{ selector: 'ex-file-drop', host: {
                    '(filesChanged)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExFileDropComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-file-drop dropZoneClassName=\"ex-file-drop-zone\" (focusout)=\"onBlur($event)\"\r\n    [disabled]=\"disabled || (sectionLayoutViewModeObservable && (sectionLayoutViewModeObservable | async))\"\r\n    (onFileDrop)=\"onFileDropped($event)\" (onFileOver)=\"onFileOver($event)\" [multiple]=\"multiple\"\r\n    (onFileLeave)=\"onFileLeave($event)\" contentClassName=\"ex-file-drop-zone-content\">\r\n    <ng-template ngx-file-drop-content-tmp let-openFileSelector=\"openFileSelector\">\r\n\r\n        <div class=\"ex-file-drop-zone-content-wrapper\" [ngClass]=\"{ 'ex-file-drop-zone-file-over': _fileOver }\">\r\n\r\n            <div class=\"ex-file-drop-zone-overlay\" [ngClass]=\"{'file-over': _fileOver}\"></div>\r\n\r\n            <div class=\"ex-file-drop-zone-content-layout\">\r\n                <ng-content></ng-content>\r\n            </div>\r\n\r\n            <div *ngIf=\"!(sectionLayoutViewModeObservable && (sectionLayoutViewModeObservable | async))\"\r\n                class=\"ex-file-drop-zone-content-add-wrapper\">\r\n                <div class=\"ex-file-drop-zone-content-add sel-file-drop-zone-content-add\">\r\n                    <ex-button *ngIf=\"showDropZoneAddButton\"\r\n                        class=\"ex-file-drop-zone-add-button sel-file-drop-zone-add-button\" type=\"add\"\r\n                        [iconSide]=\"'left'\" [disabled]=\"disabled\" [disabledTooltip]=\"disabledTooltip\"\r\n                        (click)=\"dropZoneAddButtonClicked.emit($event)\">\r\n                        {{ dropZoneAddButtonLabel | translate}}\r\n                    </ex-button>\r\n                    {{dropLabel() | translate}}\r\n                    <ex-button *ngIf=\"showDropZoneBrowseButton\"\r\n                        class=\"ex-file-drop-zone-browse-button sel-file-drop-zone-browse-button\" type=\"action\"\r\n                        [disabled]=\"disabled\" [disabledTooltip]=\"disabledTooltip\" (click)=\"openFileSelector()\">\r\n                        {{ dropZoneBrowseButtonLabel | translate }}\r\n                    </ex-button>\r\n                    <div *ngIf=\"infoTooltip\">\r\n                        <ex-svg-icon [iconName]=\"'info'\" color=\"#2F5A9C\" [tooltip]=\"infoTooltip\"\r\n                            [ariaLabel]=\"infoTooltip\">\r\n                        </ex-svg-icon>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"description\" class=\"sel-description\">{{ description | translate }}</div>\r\n            </div>\r\n        </div>\r\n\r\n    </ng-template>\r\n</ngx-file-drop>", styles: ["::ng-deep .ex-file-drop-zone{margin:auto;border:0px dashed transparent;text-align:inherit}::ng-deep .ex-file-drop-zone.ngx-file-drop__drop-zone--over{border:0px dashed transparent;background-color:transparent!important}::ng-deep .ex-file-drop-zone .ex-file-drop-zone-content{display:flex;flex-direction:column;align-items:center;justify-content:center}.ex-file-drop-zone-content-add-wrapper{display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px dashed #898989;border-radius:0;margin-top:20px;padding:15px}.ex-file-drop-zone-content-add-wrapper .ex-file-drop-zone-content-add{display:flex;justify-content:center;align-items:center}.ex-file-drop-zone-content-add-wrapper .ex-file-drop-zone-browse-button{margin-left:2px;margin-right:2px}.ex-file-drop-zone-content-layout{width:100%}.ex-file-drop-zone-content-wrapper{width:100%;border-radius:0;border:0px dashed transparent;position:relative}.ex-file-drop-zone-content-wrapper .ex-file-drop-zone-overlay{position:absolute;width:100%;height:100%}.ex-file-drop-zone-content-wrapper .ex-file-drop-zone-overlay.file-over{z-index:10;background-color:#ffffff4d;border:2px dashed rgb(230,139,20)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$3.Observable, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }]; }, { multiple: [{
            type: Input
        }], showDropZoneBrowseButton: [{
            type: Input
        }], showDropZoneAddButton: [{
            type: Input
        }], dropZoneLabel: [{
            type: Input
        }], dropZoneBrowseButtonLabel: [{
            type: Input
        }], dropZoneAddButtonLabel: [{
            type: Input
        }], disabled: [{
            type: Input
        }], disabledTooltip: [{
            type: Input
        }], description: [{
            type: Input
        }], infoTooltip: [{
            type: Input
        }], fileDropped: [{
            type: Output
        }], dropZoneAddButtonClicked: [{
            type: Output
        }], fileOver: [{
            type: Output
        }], fileLeave: [{
            type: Output
        }], files: [{
            type: Input
        }], filesChange: [{
            type: Output
        }] }); })();

class ExFileDropModule {
    static { this.ɵfac = function ExFileDropModule_Factory(t) { return new (t || ExFileDropModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFileDropModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            CommonModule,
            ExDirectivesModule,
            NgxFileDropModule,
            TranslateModule,
            ExButtonModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileDropModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    ExDirectivesModule,
                    NgxFileDropModule,
                    TranslateModule,
                    ExButtonModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExFileDropComponent
                ],
                exports: [
                    ExFileDropComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFileDropModule, { declarations: [ExFileDropComponent], imports: [FormsModule,
        CommonModule,
        ExDirectivesModule,
        NgxFileDropModule,
        TranslateModule,
        ExButtonModule,
        ExSvgIconModule], exports: [ExFileDropComponent] }); })();

class ExFileIconComponent {
    constructor() {
        /**
         * name of the file for which to display an icon
         */
        this.fileName = "";
        /**
         * the size of the icon
         */
        this.iconSize = "large";
        this._fileIconName = "";
        this._fileIconNameDefault = 'file_icon_generic';
    }
    ngOnInit() {
        if (this.arguments) {
            this.fileName = this.arguments.fileName;
        }
        this.setFileIconName();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('fileName')) {
            if (!changes['fileName'].firstChange) {
                this.setFileIconName();
            }
        }
    }
    setFileIconName() {
        let extention = this.fileName?.split('.')[1] || "";
        this._fileIconName = 'file_icon_' + extention;
    }
    static { this.ɵfac = function ExFileIconComponent_Factory(t) { return new (t || ExFileIconComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFileIconComponent, selectors: [["ex-file-icon"]], inputs: { fileName: "fileName", arguments: "arguments", iconSize: "iconSize" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 3, consts: [[3, "iconName", "defaultIconName", "iconSize"]], template: function ExFileIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "ex-fallback-icon", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("iconName", ctx._fileIconName)("defaultIconName", ctx._fileIconNameDefault)("iconSize", ctx.iconSize);
        } }, dependencies: [ExFallbackIconComponent], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileIconComponent, [{
        type: Component,
        args: [{ selector: 'ex-file-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ex-fallback-icon [iconName]=\"_fileIconName\" [defaultIconName]=\"_fileIconNameDefault\" [iconSize]=\"iconSize\"></ex-fallback-icon>" }]
    }], function () { return []; }, { fileName: [{
            type: Input
        }], arguments: [{
            type: Input
        }], iconSize: [{
            type: Input
        }] }); })();

class ExFileIconModule {
    static { this.ɵfac = function ExFileIconModule_Factory(t) { return new (t || ExFileIconModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFileIconModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExFallbackIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileIconModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExFallbackIconModule
                ],
                declarations: [
                    ExFileIconComponent
                ],
                exports: [
                    ExFileIconComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFileIconModule, { declarations: [ExFileIconComponent], imports: [CommonModule,
        ExFallbackIconModule], exports: [ExFileIconComponent] }); })();

class ExFileSelectComponent {
    constructor() {
        /**
         * the current file name
         */
        this.fileName = "";
        /**
         * when a file is selected, emits the change event of the input element
         * the file list is found at event.target.files
         */
        this.fileSelected = new EventEmitter();
    }
    onFileSelected(event) {
        if (event) {
            this.fileName = event.target?.files?.item(0)?.name;
        }
        this.fileSelected.emit(event);
    }
    static { this.ɵfac = function ExFileSelectComponent_Factory(t) { return new (t || ExFileSelectComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFileSelectComponent, selectors: [["ex-file-select"]], inputs: { fileName: "fileName" }, outputs: { fileSelected: "fileSelected" }, decls: 6, vars: 7, consts: [[1, "ex-file-select-wrapper"], ["for", "inputfile", 1, "ex-file-select-input-file-label"], [3, "value", "placeholder"], ["sizePx", "16px", 1, "ex-file-select-icon", 3, "iconType", "iconName", "color", "isActionButton"], ["type", "file", "name", "inputfile", "id", "inputfile", "tabindex", "-1", 1, "ex-file-select-input-file", 3, "change"]], template: function ExFileSelectComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
            i0.ɵɵelement(2, "ex-display-text", 2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelement(4, "ex-icon", 3);
            i0.ɵɵelementStart(5, "input", 4);
            i0.ɵɵlistener("change", function ExFileSelectComponent_Template_input_change_5_listener($event) { return ctx.onFileSelected($event); });
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.fileName)("placeholder", i0.ɵɵpipeBind1(3, 5, "ng.attachment_grid.select_file"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("iconType", "uxf")("iconName", "uxf-folder")("isActionButton", true);
        } }, dependencies: [ExDisplayTextComponent, ExIconComponent, i1$2.TranslatePipe], styles: [".ex-file-select-wrapper[_ngcontent-%COMP%]   ex-display-text[_ngcontent-%COMP%]{cursor:pointer;overflow:hidden}.ex-file-select-wrapper[_ngcontent-%COMP%]   ex-display-text[_ngcontent-%COMP%]     .ex-display-text-value-text.ex-display-text-value-text-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-file-select-wrapper[_ngcontent-%COMP%]   .ex-file-select-input-file-label[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-content:flex-start;border-radius:2px;cursor:pointer;line-height:32px;margin-bottom:0}.ex-file-select-wrapper[_ngcontent-%COMP%]   .ex-file-select-input-file-label[_ngcontent-%COMP%]:hover{background-color:#e5e5e5}.ex-file-select-wrapper[_ngcontent-%COMP%]   .ex-file-select-input-file[_ngcontent-%COMP%]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileSelectComponent, [{
        type: Component,
        args: [{ selector: 'ex-file-select', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-file-select-wrapper\">\r\n    <label for=\"inputfile\" class=\"ex-file-select-input-file-label\">\r\n        <ex-display-text [value]=\"fileName\" [placeholder]=\"'ng.attachment_grid.select_file' | translate\"></ex-display-text>\r\n        <ex-icon class=\"ex-file-select-icon\" [iconType]=\"'uxf'\" [iconName]=\"'uxf-folder'\" sizePx=\"16px\"\r\n            [color]=\"\" [isActionButton]=\"true\">\r\n        </ex-icon>\r\n        <input type=\"file\" name=\"inputfile\" id=\"inputfile\" class=\"ex-file-select-input-file\" tabindex=\"-1\"\r\n            (change)=\"onFileSelected($event)\">\r\n    </label>\r\n</div>", styles: [".ex-file-select-wrapper ex-display-text{cursor:pointer;overflow:hidden}.ex-file-select-wrapper ex-display-text ::ng-deep .ex-display-text-value-text.ex-display-text-value-text-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-file-select-wrapper .ex-file-select-input-file-label{display:flex;justify-content:flex-start;align-content:flex-start;border-radius:2px;cursor:pointer;line-height:32px;margin-bottom:0}.ex-file-select-wrapper .ex-file-select-input-file-label:hover{background-color:#e5e5e5}.ex-file-select-wrapper .ex-file-select-input-file{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}\n"] }]
    }], function () { return []; }, { fileName: [{
            type: Input
        }], fileSelected: [{
            type: Output
        }] }); })();

class ExFileSelectModule {
    static { this.ɵfac = function ExFileSelectModule_Factory(t) { return new (t || ExFileSelectModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFileSelectModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            MatTooltipModule,
            EXPipesModule,
            ExEditableTextModule,
            ExDisplayTextModule,
            ExIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFileSelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    MatTooltipModule,
                    EXPipesModule,
                    ExEditableTextModule,
                    ExDisplayTextModule,
                    ExIconModule
                ],
                declarations: [
                    ExFileSelectComponent
                ],
                exports: [
                    ExFileSelectComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFileSelectModule, { declarations: [ExFileSelectComponent], imports: [CommonModule,
        TranslateModule,
        MatTooltipModule,
        EXPipesModule,
        ExEditableTextModule,
        ExDisplayTextModule,
        ExIconModule], exports: [ExFileSelectComponent] }); })();

const _c0$P = ["ulToScroll"];
const _c1$u = ["searchBox"];
const _c2$l = ["searchInput"];
//This class is a base class for SelectionMenuComp and ExFlexbrowseSelectionComp. It's main purpose is avoiding code duplicate in those two similar components.
class ListSelection extends ExControlValueAccessor {
    /*
   * maximum number of items allowed to be selected; unlimited if < 0; if 0 - one selection allowed
   */
    set maxSelections(num) {
        if (!Number.isFinite(num)) {
            this._maxNumberOfSelections = -1;
        }
        else {
            this._maxNumberOfSelections = num;
        }
        this.isSingleSelection = (this._maxNumberOfSelections == 0 || this._maxNumberOfSelections == 1);
    }
    /*
    * selected items setter and getter
    * value should be of type ExFlexbrowseItemData[]
    */
    get value() {
        return this.selectedItems;
    }
    set value(value) {
        this.selectedItems = value || [];
        this.selectedItems = this.sortSelectedItems();
    }
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /*
    * placeholder string that will be displayed when the flexbrowse has no selected values
    */
        this.placeholder = 'ng.general.select_value';
        /*
        * the number of characters in the search string from which the search will be performed
        */
        this.searchThreshold = 0;
        this.backgroundColor = 'transparent';
        /**
         * The search will perform during the typing. define as false will cause the search firing only by demand.
         */
        this.incremental = true;
        /*
        * emits ExFlexbrowseItemData[] when the selected items change (addition or deletion)
        */
        this.valueChange = new EventEmitter();
        this.list = [];
        this.selectedItems = [];
        this.searchText = '';
        this.textHighlight = '';
        this._maxNumberOfSelections = -1;
        this.isSingleSelection = false;
        this.isLoading = false;
        this.searchLoading = false;
        this.isDisabled = false;
        this.searchTrigger = new Subject();
        this.destroy$ = new Subject();
        this.getId = (index, item) => {
            return item.id;
        };
    }
    init() {
        this.isLoading = true;
        this.isDisabled = true;
        this.initTopLevel().subscribe(() => this.cdr.markForCheck());
    }
    initSearch() {
        this.searchTrigger.pipe(debounceTime(250), switchMap(() => this.startSearch().pipe(catchError(e => of(console.error(e))))), takeUntil(this.destroy$)).subscribe();
    }
    onSearchTriggered() {
        this.searchTrigger.next();
    }
    checkboxToggled({ event, item }) {
        const checked = this.isSingleSelection ? event.source?.checked : event.checked;
        if (checked) {
            this.addItemToSelected(item);
        }
        else {
            this.removeItemFromSelected(item);
        }
        this.selectedItems = this.sortSelectedItems();
    }
    scrollUlToTop() {
        if (this.ulToScroll) {
            this.ulToScroll.nativeElement.scrollTop = 0;
        }
    }
    isItemSelected(itemId) {
        return Array.isArray(this.selectedItems) && this.selectedItems?.findIndex(item => item.id === itemId) > -1;
    }
    writeValue(obj) {
        this.value = obj;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        this.readOnly = isDisabled;
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    initTopLevel() {
        return this.getItemData().pipe(tap(data => {
            this.setList(data);
            this.reset();
        }));
    }
    setList(data) {
        this.list = data;
        this.resetFlags();
    }
    resetFlags() {
        this.isLoading = false;
        this.isDisabled = false;
        this.searchLoading = false;
    }
    sortSelectedItems() {
        return this.selectedItems.sort((a, b) => (a?.category || "").localeCompare((b?.category || ""))).map((item, index, arr) => {
            if (arr?.[index - 1]?.category === item?.category || !item?.category) {
                return { ...item, title: false };
            }
            return { ...item, title: true };
        });
    }
    static { this.ɵfac = function ListSelection_Factory(t) { return new (t || ListSelection)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ListSelection, viewQuery: function ListSelection_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$P, 5);
            i0.ɵɵviewQuery(_c1$u, 5);
            i0.ɵɵviewQuery(_c2$l, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ulToScroll = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t);
        } }, inputs: { placeholder: "placeholder", searchThreshold: "searchThreshold", maxSelections: "maxSelections", value: "value", datasource: "datasource", backgroundColor: "backgroundColor", incremental: "incremental" }, outputs: { valueChange: "valueChange" }, features: [i0.ɵɵInheritDefinitionFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListSelection, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { placeholder: [{
            type: Input
        }], searchThreshold: [{
            type: Input
        }], maxSelections: [{
            type: Input
        }], value: [{
            type: Input
        }], datasource: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], incremental: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], ulToScroll: [{
            type: ViewChild,
            args: ['ulToScroll']
        }], searchInput: [{
            type: ViewChildren,
            args: ['searchInput']
        }], searchBox: [{
            type: ViewChild,
            args: ['searchBox']
        }] }); })();

function ExFlexbrowseItemComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFlexbrowseItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 6);
    i0.ɵɵlistener("click", function ExFlexbrowseItemComponent_ng_template_2_Template_mat_radio_button_click_0_listener($event) { return $event.stopPropagation(); })("change", function ExFlexbrowseItemComponent_ng_template_2_Template_mat_radio_button_change_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9._checkboxClicked($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r2.isSelected);
} }
function ExFlexbrowseItemComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 7);
    i0.ɵɵlistener("checkedChange", function ExFlexbrowseItemComponent_ng_template_4_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.isSelected = $event); })("click", function ExFlexbrowseItemComponent_ng_template_4_Template_ex_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("checkboxChange", function ExFlexbrowseItemComponent_ng_template_4_Template_ex_checkbox_checkboxChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14._checkboxClicked($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "sel-flexbrowse-" + ctx_r4.selName)("checked", ctx_r4.isSelected);
} }
function ExFlexbrowseItemComponent_ng_container_6_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function ExFlexbrowseItemComponent_ng_container_6_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17._itemClicked()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "ng.general.open"));
} }
function ExFlexbrowseItemComponent_ng_container_6_ex_spinner_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 13);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExFlexbrowseItemComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵlistener("click", function ExFlexbrowseItemComponent_ng_container_6_Template_label_click_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19._itemClicked()); });
    i0.ɵɵpipe(2, "exTextHighlight");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExFlexbrowseItemComponent_ng_container_6_button_3_Template, 3, 3, "button", 9);
    i0.ɵɵtemplate(4, ExFlexbrowseItemComponent_ng_container_6_ex_spinner_4_Template, 1, 1, "ex-spinner", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", ctx_r5.item.name)("innerHTML", i0.ɵɵpipeBind2(2, 4, ctx_r5.item.name, ctx_r5.textHighlight), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r5.item.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.item.isLoading);
} }
function ExFlexbrowseItemComponent_ng_template_7_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 17);
    i0.ɵɵlistener("click", function ExFlexbrowseItemComponent_ng_template_7_label_3_Template_label_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵpipe(1, "exTextHighlight");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", ctx_r21.item == null ? null : ctx_r21.item.category)("innerHTML", i0.ɵɵpipeBind2(1, 2, ctx_r21.item == null ? null : ctx_r21.item.category, ctx_r21.textHighlight), i0.ɵɵsanitizeHtml);
} }
function ExFlexbrowseItemComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "label", 15);
    i0.ɵɵlistener("click", function ExFlexbrowseItemComponent_ng_template_7_Template_label_click_1_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵpipe(2, "exTextHighlight");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExFlexbrowseItemComponent_ng_template_7_label_3_Template, 2, 5, "label", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matTooltip", ctx_r7.item.name)("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx_r7.item.name, ctx_r7.textHighlight), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.textHighlight);
} }
const _c0$O = function (a0) { return { "flexbrowse-item-disabled": a0 }; };
class ExFlexbrowseItemComponent {
    constructor() {
        this.isSingleSelection = false;
        this.itemClicked = new EventEmitter();
        this.checkboxClicked = new EventEmitter();
        this.selName = "";
    }
    ngOnInit() {
        this.selName = this.item.name.replace(/\s/g, '');
    }
    _itemClicked() {
        event.stopPropagation();
        this.itemClicked.emit(this.item.id);
    }
    _checkboxClicked(e) {
        this.checkboxClicked.emit({ event: e, item: this.item });
    }
    static { this.ɵfac = function ExFlexbrowseItemComponent_Factory(t) { return new (t || ExFlexbrowseItemComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFlexbrowseItemComponent, selectors: [["ex-flexbrowse-item"]], inputs: { isSingleSelection: "isSingleSelection", item: "item", textHighlight: "textHighlight", isSelected: "isSelected" }, outputs: { itemClicked: "itemClicked", checkboxClicked: "checkboxClicked" }, decls: 9, vars: 8, consts: [[1, "flexbrowse-item-wrapper", 3, "ngClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["radioButton", ""], ["checkbox", ""], [4, "ngIf", "ngIfElse"], ["leaf", ""], [1, "flexbrowse-selected-path-radiobutton", 3, "checked", "click", "change"], [1, "flexbrowse-item-checkbox", 3, "ngClass", "checked", "checkedChange", "click", "checkboxChange"], ["matTooltipShowDelay", "1000", 1, "flexbrowse-item-text", 3, "matTooltip", "innerHTML", "click"], ["class", "flexbrowse-item-arrow-icon-button", 3, "click", 4, "ngIf"], ["class", "flexbrowse-item-spinner", 3, "diameter", 4, "ngIf"], [1, "flexbrowse-item-arrow-icon-button", 3, "click"], [1, "fa", "fa-angle-right", "flexbrowse-item-arrow-icon"], [1, "flexbrowse-item-spinner", 3, "diameter"], [1, "flexbrowse-item-text-container"], ["matTooltipShowDelay", "1000", 1, "flexbrowse-item-text", "flexbrowse-item-text-leaf", 3, "matTooltip", "innerHTML", "click"], ["matTooltipShowDelay", "1000", "class", "flexbrowse-item-text flexbrowse-item-text-leaf flexbrowse-item-text-leaf-description", 3, "exTooltip", "innerHTML", "click", 4, "ngIf"], ["matTooltipShowDelay", "1000", 1, "flexbrowse-item-text", "flexbrowse-item-text-leaf", "flexbrowse-item-text-leaf-description", 3, "exTooltip", "innerHTML", "click"]], template: function ExFlexbrowseItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExFlexbrowseItemComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
            i0.ɵɵtemplate(2, ExFlexbrowseItemComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(4, ExFlexbrowseItemComponent_ng_template_4_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(6, ExFlexbrowseItemComponent_ng_container_6_Template, 5, 7, "ng-container", 4);
            i0.ɵɵtemplate(7, ExFlexbrowseItemComponent_ng_template_7_Template, 4, 6, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            const _r3 = i0.ɵɵreference(5);
            const _r6 = i0.ɵɵreference(8);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$O, ctx.item.isLoading));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isSingleSelection)("ngIfThen", _r1)("ngIfElse", _r3);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.item.hasChildren)("ngIfElse", _r6);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i8.MatRadioButton, i4.MatTooltip, ExSpinnerComponent, ExTooltipDirective, ExCheckboxComponent, i1$2.TranslatePipe, ExTextHighlightPipe], styles: [".flexbrowse-item-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-start;position:relative;align-items:flex-start;padding:0 10px;border-top:1px solid transparent;border-bottom:1px solid transparent;min-height:30px;align-items:center}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-checkbox[_ngcontent-%COMP%]{margin-right:10px;margin-top:2px;align-self:flex-start}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   button.flexbrowse-item-arrow-icon-button[_ngcontent-%COMP%]{background:transparent;outline:0;border-radius:3px;height:30px;border:2px solid transparent;align-self:flex-start}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   button.flexbrowse-item-arrow-icon-button[_ngcontent-%COMP%]:hover{background:#f4f4f4}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   button.flexbrowse-item-arrow-icon-button[_ngcontent-%COMP%]:focus{border-color:#000}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   button.flexbrowse-item-arrow-icon-button[_ngcontent-%COMP%]   .flexbrowse-item-arrow-icon[_ngcontent-%COMP%]{padding-left:10px;font-size:17px;margin-top:.5rem}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-text-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;overflow:hidden}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-text[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;margin-bottom:0;flex:1}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-text-leaf[_ngcontent-%COMP%]{cursor:default}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-text-leaf-description[_ngcontent-%COMP%]{font: 300 13px/17px Roboto;opacity:.8}.flexbrowse-item-wrapper[_ngcontent-%COMP%]   .flexbrowse-item-spinner[_ngcontent-%COMP%]{margin-left:5px}.flexbrowse-item-wrapper[_ngcontent-%COMP%]:hover{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.flexbrowse-item-disabled[_ngcontent-%COMP%]{pointer-events:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFlexbrowseItemComponent, [{
        type: Component,
        args: [{ selector: 'ex-flexbrowse-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flexbrowse-item-wrapper\" [ngClass]=\"{ 'flexbrowse-item-disabled': item.isLoading }\">\n  <ng-container *ngIf=\"isSingleSelection; then radioButton; else checkbox\">\n  </ng-container>\n  <ng-template #radioButton>\n    <mat-radio-button class=\"flexbrowse-selected-path-radiobutton\" [checked]=\"isSelected\"\n      (click)=\"$event.stopPropagation()\" (change)=\"_checkboxClicked($event)\">\n    </mat-radio-button>\n  </ng-template>\n  <ng-template #checkbox>\n    <ex-checkbox class=\"flexbrowse-item-checkbox\" [ngClass]=\"'sel-flexbrowse-'+selName\" [(checked)]=\"isSelected\"\n      (click)=\"$event.stopPropagation()\" (checkboxChange)=\"_checkboxClicked($event)\"></ex-checkbox>\n  </ng-template>\n  <ng-container *ngIf=\"item.hasChildren; else leaf\">\n    <label matTooltipShowDelay=\"1000\" [matTooltip]=\"item.name\" class=\"flexbrowse-item-text\" (click)=\"_itemClicked()\"\n      [innerHTML]=\"item.name | exTextHighlight: textHighlight\"></label>\n    <button (click)=\"_itemClicked()\" *ngIf=\"!item.isLoading\" class=\"flexbrowse-item-arrow-icon-button\"\n      [attr.aria-label]=\"'ng.general.open' | translate\">\n      <i class=\"fa fa-angle-right flexbrowse-item-arrow-icon\"></i>\n    </button>\n    <ex-spinner *ngIf=\"item.isLoading\" [diameter]=\"15\" class=\"flexbrowse-item-spinner\"></ex-spinner>\n  </ng-container>\n  <ng-template #leaf>\n    <div class=\"flexbrowse-item-text-container\">\n      <label matTooltipShowDelay=\"1000\" [matTooltip]=\"item.name\" class=\"flexbrowse-item-text flexbrowse-item-text-leaf\"\n        (click)=\"$event.stopPropagation()\" [innerHTML]=\"item.name | exTextHighlight: textHighlight\"></label>\n      <label *ngIf=\"textHighlight\" matTooltipShowDelay=\"1000\" [exTooltip]=\"item?.category\"\n        class=\"flexbrowse-item-text flexbrowse-item-text-leaf flexbrowse-item-text-leaf-description\"\n        (click)=\"$event.stopPropagation()\" [innerHTML]=\"item?.category | exTextHighlight: textHighlight\"></label>\n    </div>\n  </ng-template>\n</div>", styles: [".flexbrowse-item-wrapper{display:flex;flex-direction:row;justify-content:flex-start;position:relative;align-items:flex-start;padding:0 10px;border-top:1px solid transparent;border-bottom:1px solid transparent;min-height:30px;align-items:center}.flexbrowse-item-wrapper .flexbrowse-item-checkbox{margin-right:10px;margin-top:2px;align-self:flex-start}.flexbrowse-item-wrapper label{cursor:pointer}.flexbrowse-item-wrapper button.flexbrowse-item-arrow-icon-button{background:transparent;outline:0;border-radius:3px;height:30px;border:2px solid transparent;align-self:flex-start}.flexbrowse-item-wrapper button.flexbrowse-item-arrow-icon-button:hover{background:#f4f4f4}.flexbrowse-item-wrapper button.flexbrowse-item-arrow-icon-button:focus{border-color:#000}.flexbrowse-item-wrapper button.flexbrowse-item-arrow-icon-button .flexbrowse-item-arrow-icon{padding-left:10px;font-size:17px;margin-top:.5rem}.flexbrowse-item-wrapper .flexbrowse-item-text-container{display:flex;flex-direction:column;overflow:hidden}.flexbrowse-item-wrapper .flexbrowse-item-text{overflow:hidden;text-overflow:ellipsis;margin-bottom:0;flex:1}.flexbrowse-item-wrapper .flexbrowse-item-text-leaf{cursor:default}.flexbrowse-item-wrapper .flexbrowse-item-text-leaf-description{font: 300 13px/17px Roboto;opacity:.8}.flexbrowse-item-wrapper .flexbrowse-item-spinner{margin-left:5px}.flexbrowse-item-wrapper:hover{background:#f5f5f5;border-top:1px solid #898989;border-bottom:1px solid #898989}.flexbrowse-item-disabled{pointer-events:none}\n"] }]
    }], function () { return []; }, { isSingleSelection: [{
            type: Input
        }], item: [{
            type: Input
        }], textHighlight: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], itemClicked: [{
            type: Output
        }], checkboxClicked: [{
            type: Output
        }] }); })();

function ExFlexbrowseSelectedPathComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFlexbrowseSelectedPathComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 8);
    i0.ɵɵlistener("click", function ExFlexbrowseSelectedPathComponent_ng_template_3_Template_mat_radio_button_click_0_listener($event) { return $event.stopPropagation(); })("change", function ExFlexbrowseSelectedPathComponent_ng_template_3_Template_mat_radio_button_change_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6._checkboxClicked($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r2.isSelected);
} }
function ExFlexbrowseSelectedPathComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 9);
    i0.ɵɵlistener("checkedChange", function ExFlexbrowseSelectedPathComponent_ng_template_5_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.isSelected = $event); })("click", function ExFlexbrowseSelectedPathComponent_ng_template_5_Template_ex_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("checkboxChange", function ExFlexbrowseSelectedPathComponent_ng_template_5_Template_ex_checkbox_checkboxChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11._checkboxClicked($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r4.isSelected);
} }
const _c0$N = function (a0) { return { "flexbrowse-selected-path-is-first": a0 }; };
class ExFlexbrowseSelectedPathComponent {
    constructor() {
        this.isSingleSelection = false;
        this.isSelected = true;
        this.isLast = false;
        this.itemRemoved = new EventEmitter();
        this.checkboxClicked = new EventEmitter();
    }
    ngOnInit() { }
    remove() {
        event.stopPropagation();
        this.itemRemoved.emit(this.item);
    }
    _checkboxClicked(e) {
        this.checkboxClicked.emit({ event: e, item: this.item });
    }
    static { this.ɵfac = function ExFlexbrowseSelectedPathComponent_Factory(t) { return new (t || ExFlexbrowseSelectedPathComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFlexbrowseSelectedPathComponent, selectors: [["ex-flexbrowse-selected-path"]], inputs: { isSingleSelection: "isSingleSelection", item: "item", textHighlight: "textHighlight", isSelected: "isSelected", isLast: "isLast" }, outputs: { itemRemoved: "itemRemoved", checkboxClicked: "checkboxClicked" }, decls: 12, vars: 14, consts: [[1, "flexbrowse-selected-path-selected-path", 3, "ngClass"], ["aria-hidden", "true", 1, "flexbrowse-selected-path-circle"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["radioButton", ""], ["checkbox", ""], ["matTooltipShowDelay", "1000", 1, "flexbrowse-selected-path-selected-text", 3, "matTooltip", "innerHTML", "click"], [1, "flexbrowse-selected-path-icon-button", 3, "click"], [1, "uxf-icon", "uxf-close-circle", "flexbrowse-selected-path-icon"], [1, "flexbrowse-selected-path-radiobutton", 3, "checked", "click", "change"], [1, "flexbrowse-selected-path-checkbox", 3, "checked", "checkedChange", "click", "checkboxChange"]], template: function ExFlexbrowseSelectedPathComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵtemplate(2, ExFlexbrowseSelectedPathComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
            i0.ɵɵtemplate(3, ExFlexbrowseSelectedPathComponent_ng_template_3_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ExFlexbrowseSelectedPathComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(7, "label", 5);
            i0.ɵɵlistener("click", function ExFlexbrowseSelectedPathComponent_Template_label_click_7_listener() { return ctx.remove(); });
            i0.ɵɵpipe(8, "exTextHighlight");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "button", 6);
            i0.ɵɵlistener("click", function ExFlexbrowseSelectedPathComponent_Template_button_click_9_listener() { return ctx.remove(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "i", 7);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(4);
            const _r3 = i0.ɵɵreference(6);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0$N, !ctx.isLast));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isSingleSelection)("ngIfThen", _r1)("ngIfElse", _r3);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("matTooltip", ctx.item.name)("innerHTML", i0.ɵɵpipeBind2(8, 7, ctx.item.name, ctx.textHighlight), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 10, "ng.general.close"));
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i8.MatRadioButton, i4.MatTooltip, ExCheckboxComponent, i1$2.TranslatePipe, ExTextHighlightPipe], styles: [".flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:baseline;margin-bottom:5px;padding:0 10px;cursor:pointer}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   .flexbrowse-selected-path-checkbox[_ngcontent-%COMP%]{margin-right:10px}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   .flexbrowse-selected-path-circle[_ngcontent-%COMP%]{height:9px;width:9px;border-radius:50%;background:#4164a4;margin-right:6px}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   .flexbrowse-selected-path-selected-text[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;margin-bottom:0;flex:1}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   button.flexbrowse-selected-path-icon-button[_ngcontent-%COMP%]{background:transparent;outline:0;border-radius:3px;border:2px solid transparent}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   button.flexbrowse-selected-path-icon-button[_ngcontent-%COMP%]:hover{background:#f4f4f4}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   button.flexbrowse-selected-path-icon-button[_ngcontent-%COMP%]:focus{border-color:#000}.flexbrowse-selected-path-selected-path[_ngcontent-%COMP%]   button.flexbrowse-selected-path-icon-button[_ngcontent-%COMP%]   .flexbrowse-selected-path-icon[_ngcontent-%COMP%]{color:#8c8c8c;margin-bottom:1px;margin-left:10px}.flexbrowse-selected-path-is-first[_ngcontent-%COMP%]   .flexbrowse-selected-path-circle[_ngcontent-%COMP%]{background:#9cbfde}.flexbrowse-selected-path-is-first[_ngcontent-%COMP%]   .flexbrowse-selected-path-selected-text[_ngcontent-%COMP%]{color:#4164a4}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFlexbrowseSelectedPathComponent, [{
        type: Component,
        args: [{ selector: 'ex-flexbrowse-selected-path', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flexbrowse-selected-path-selected-path\" [ngClass]=\"{ 'flexbrowse-selected-path-is-first': !isLast }\">\n  <div class=\"flexbrowse-selected-path-circle\" aria-hidden=\"true\"></div>\n  <ng-container *ngIf=\"isSingleSelection; then radioButton; else checkbox\">\n  </ng-container>\n  <ng-template #radioButton>\n    <mat-radio-button class=\"flexbrowse-selected-path-radiobutton\" [checked]=\"isSelected\"\n      (click)=\"$event.stopPropagation()\" (change)=\"_checkboxClicked($event)\">\n    </mat-radio-button>\n  </ng-template>\n  <ng-template #checkbox>\n    <ex-checkbox class=\"flexbrowse-selected-path-checkbox\" [(checked)]=\"isSelected\" (click)=\"$event.stopPropagation()\"\n      (checkboxChange)=\"_checkboxClicked($event)\"></ex-checkbox>\n  </ng-template>\n\n  <label matTooltipShowDelay=\"1000\" [matTooltip]=\"item.name\" (click)=\"remove()\"\n    class=\"flexbrowse-selected-path-selected-text\" [innerHTML]=\"item.name | exTextHighlight: textHighlight\"></label>\n  <button (click)=\"remove()\" class=\"flexbrowse-selected-path-icon-button\"\n    [attr.aria-label]=\"'ng.general.close' | translate\">\n    <i class=\"uxf-icon uxf-close-circle flexbrowse-selected-path-icon\"></i>\n  </button>\n</div>", styles: [".flexbrowse-selected-path-selected-path{display:flex;flex-direction:row;align-items:baseline;margin-bottom:5px;padding:0 10px;cursor:pointer}.flexbrowse-selected-path-selected-path label{cursor:pointer}.flexbrowse-selected-path-selected-path .flexbrowse-selected-path-checkbox{margin-right:10px}.flexbrowse-selected-path-selected-path .flexbrowse-selected-path-circle{height:9px;width:9px;border-radius:50%;background:#4164a4;margin-right:6px}.flexbrowse-selected-path-selected-path .flexbrowse-selected-path-selected-text{overflow:hidden;text-overflow:ellipsis;margin-bottom:0;flex:1}.flexbrowse-selected-path-selected-path button.flexbrowse-selected-path-icon-button{background:transparent;outline:0;border-radius:3px;border:2px solid transparent}.flexbrowse-selected-path-selected-path button.flexbrowse-selected-path-icon-button:hover{background:#f4f4f4}.flexbrowse-selected-path-selected-path button.flexbrowse-selected-path-icon-button:focus{border-color:#000}.flexbrowse-selected-path-selected-path button.flexbrowse-selected-path-icon-button .flexbrowse-selected-path-icon{color:#8c8c8c;margin-bottom:1px;margin-left:10px}.flexbrowse-selected-path-is-first .flexbrowse-selected-path-circle{background:#9cbfde}.flexbrowse-selected-path-is-first .flexbrowse-selected-path-selected-text{color:#4164a4}\n"] }]
    }], function () { return []; }, { isSingleSelection: [{
            type: Input
        }], item: [{
            type: Input
        }], textHighlight: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], isLast: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], checkboxClicked: [{
            type: Output
        }] }); })();

function ExFlexbrowseChipComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.item.category, ":");
} }
function ExFlexbrowseChipComponent_div_1_i_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 8);
} }
const _c0$M = function (a0) { return { "visibility": a0 }; };
function ExFlexbrowseChipComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 6);
    i0.ɵɵlistener("click", function ExFlexbrowseChipComponent_div_1_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.remove()); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ExFlexbrowseChipComponent_div_1_i_5_Template, 1, 0, "i", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.item.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c0$M, ctx_r1.readOnly ? "hidden" : "unset"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 4, "ng.general.remove"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.readOnly);
} }
class ExFlexbrowseChipComponent {
    constructor() {
        this.title = false;
        this.readOnly = false;
        this.removeClicked = new EventEmitter();
    }
    ngOnInit() { }
    remove() {
        if (!this.readOnly) {
            this.removeClicked.emit(this.item);
        }
    }
    static { this.ɵfac = function ExFlexbrowseChipComponent_Factory(t) { return new (t || ExFlexbrowseChipComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFlexbrowseChipComponent, selectors: [["ex-flexbrowse-chip"]], inputs: { title: "title", item: "item", readOnly: "readOnly" }, outputs: { removeClicked: "removeClicked" }, decls: 2, vars: 2, consts: [["class", "flexbrowse-chip-wrapper title-chip", 4, "ngIf"], ["class", "flexbrowse-chip-wrapper", 4, "ngIf"], [1, "flexbrowse-chip-wrapper", "title-chip"], [1, "flexbrowse-chip-title"], [1, "flexbrowse-chip-wrapper"], [1, "flexbrowse-chip-text"], [1, "flexbrowse-chip-remove-icon-button", 3, "ngStyle", "click"], ["class", "uxf-icon uxf-close-circle", 4, "ngIf"], [1, "uxf-icon", "uxf-close-circle"]], template: function ExFlexbrowseChipComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFlexbrowseChipComponent_div_0_Template, 3, 1, "div", 0);
            i0.ɵɵtemplate(1, ExFlexbrowseChipComponent_div_1_Template, 6, 8, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.title);
        } }, dependencies: [i1$5.NgIf, i1$5.NgStyle, i1$2.TranslatePipe], styles: [".flexbrowse-chip-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding-block:.2rem}.flexbrowse-chip-wrapper[_ngcontent-%COMP%]:hover{background:#f4f4f4}.flexbrowse-chip-wrapper[_ngcontent-%COMP%]   .flexbrowse-chip-text[_ngcontent-%COMP%], .flexbrowse-chip-wrapper[_ngcontent-%COMP%]   .flexbrowse-chip-title[_ngcontent-%COMP%]{margin-bottom:0;text-align:left;padding:1px}.flexbrowse-chip-wrapper[_ngcontent-%COMP%]   button.flexbrowse-chip-remove-icon-button[_ngcontent-%COMP%]{background:transparent;outline:0;border-radius:3px;height:30px;border:2px solid transparent;align-self:flex-start}.flexbrowse-chip-wrapper[_ngcontent-%COMP%]   button.flexbrowse-chip-remove-icon-button[_ngcontent-%COMP%]:focus{border-color:#000}.flexbrowse-chip-wrapper[_ngcontent-%COMP%]   button.flexbrowse-chip-remove-icon-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin:2px;color:#8c8c8c}.title-chip.flexbrowse-chip-wrapper[_ngcontent-%COMP%]{border-radius:3px;padding:0 5px;border:1px solid #ccc;margin-inline-end:5px}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFlexbrowseChipComponent, [{
        type: Component,
        args: [{ selector: 'ex-flexbrowse-chip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flexbrowse-chip-wrapper title-chip\" *ngIf=\"title\">\n  <label class=\"flexbrowse-chip-title \">{{ item.category }}:</label>\n</div>\n\n<div class=\"flexbrowse-chip-wrapper\" *ngIf=\"!title\">\n  <label class=\"flexbrowse-chip-text\">{{ item.name }}</label>\n  <button (click)=\"remove()\" class=\"flexbrowse-chip-remove-icon-button\" [attr.aria-label]=\"'ng.general.remove' | translate\"\n          [ngStyle]=\"{ 'visibility': (readOnly ? 'hidden' : 'unset') }\">\n      <i *ngIf=\"!readOnly\" class=\"uxf-icon uxf-close-circle\"></i>\n  </button>\n\n</div> ", styles: [".flexbrowse-chip-wrapper{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding-block:.2rem}.flexbrowse-chip-wrapper:hover{background:#f4f4f4}.flexbrowse-chip-wrapper .flexbrowse-chip-text,.flexbrowse-chip-wrapper .flexbrowse-chip-title{margin-bottom:0;text-align:left;padding:1px}.flexbrowse-chip-wrapper button.flexbrowse-chip-remove-icon-button{background:transparent;outline:0;border-radius:3px;height:30px;border:2px solid transparent;align-self:flex-start}.flexbrowse-chip-wrapper button.flexbrowse-chip-remove-icon-button:focus{border-color:#000}.flexbrowse-chip-wrapper button.flexbrowse-chip-remove-icon-button i{margin:2px;color:#8c8c8c}.title-chip.flexbrowse-chip-wrapper{border-radius:3px;padding:0 5px;border:1px solid #ccc;margin-inline-end:5px}\n"] }]
    }], function () { return []; }, { title: [{
            type: Input
        }], item: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], removeClicked: [{
            type: Output
        }] }); })();

const _c0$L = ["dialogRef"];
function ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 14)(2, "ex-flexbrowse-chip", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selected_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("item", selected_r15)("title", true)("readOnly", ctx_r16.isReadOnly);
} }
function ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_ng_container_1_ng_container_1_Template, 3, 3, "ng-container", 12);
    i0.ɵɵelementStart(2, "ex-flexbrowse-chip", 13);
    i0.ɵɵlistener("removeClicked", function ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_ng_container_1_Template_ex_flexbrowse_chip_removeClicked_2_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.removeItemFromSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selected_r15 = ctx.$implicit;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selected_r15.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", selected_r15)("readOnly", ctx_r14.isReadOnly);
} }
function ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_ng_container_1_Template, 3, 3, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.selectedItems)("ngForTrackBy", ctx_r11.getId);
} }
const _c1$t = function (a0) { return { "flexbrowse-selection-single-selection-disabled": a0 }; };
function ExFlexbrowseSelectionComponent_ng_template_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$t, ctx_r13.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.selectedItems[0] == null ? null : ctx_r13.selectedItems[0].name, " ");
} }
function ExFlexbrowseSelectionComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExFlexbrowseSelectionComponent_ng_template_0_ng_container_0_Template, 2, 2, "ng-container", 9);
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_0_ng_template_1_Template, 2, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSingleSelection)("ngIfElse", _r12);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_ex_flexbrowse_selected_path_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-flexbrowse-selected-path", 33);
    i0.ɵɵlistener("itemRemoved", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_ex_flexbrowse_selected_path_1_Template_ex_flexbrowse_selected_path_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r32.removeItemFromPath($event)); })("checkboxClicked", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_ex_flexbrowse_selected_path_1_Template_ex_flexbrowse_selected_path_checkboxClicked_0_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r34.checkboxToggled($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r30 = ctx.$implicit;
    const i_r31 = ctx.index;
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("item", selected_r30)("isSingleSelection", ctx_r29.isSingleSelection)("isLast", i_r31 === ctx_r29.selectedPath.length - 1)("isSelected", ctx_r29.isItemSelected(selected_r30.id))("textHighlight", ctx_r29.textHighlight);
} }
const _c2$k = function (a0) { return { "flexbrowse-selection-disabled": a0 }; };
function ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_ex_flexbrowse_selected_path_1_Template, 1, 5, "ex-flexbrowse-selected-path", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$k, ctx_r24.isDisabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r24.selectedPath);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_3_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "ex-flexbrowse-item", 34);
    i0.ɵɵlistener("itemClicked", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_li_10_Template_ex_flexbrowse_item_itemClicked_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r37); const item_r35 = restoredCtx.$implicit; const ctx_r36 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r36.itemClicked(item_r35)); })("checkboxClicked", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_li_10_Template_ex_flexbrowse_item_checkboxClicked_1_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r38.checkboxToggled($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r35 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSingleSelection", ctx_r26.isSingleSelection)("item", item_r35)("isSelected", ctx_r26.isItemSelected(item_r35.id))("textHighlight", ctx_r26.textHighlight);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_3_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelement(1, "ex-spinner", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("diameter", 25);
} }
const _c3$h = function (a0) { return { "flexbrowse-selection-list-children": a0 }; };
function ExFlexbrowseSelectionComponent_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23)(3, "ex-search", 24, 25);
    i0.ɵɵlistener("searchTextChange", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_Template_ex_search_searchTextChange_3_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.searchText = $event); })("searchTriggered", function ExFlexbrowseSelectionComponent_ng_template_2_div_3_Template_ex_search_searchTriggered_3_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.onSearchTriggered()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtemplate(6, ExFlexbrowseSelectionComponent_ng_template_2_div_3_div_6_Template, 2, 4, "div", 26);
    i0.ɵɵelementStart(7, "ul", 27, 28)(9, "div", 27);
    i0.ɵɵtemplate(10, ExFlexbrowseSelectionComponent_ng_template_2_div_3_li_10_Template, 2, 4, "li", 29);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(11, ExFlexbrowseSelectionComponent_ng_template_2_div_3_ng_template_11_Template, 2, 1, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r27 = i0.ɵɵreference(12);
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("isLoading", ctx_r20.searchLoading)("searchText", ctx_r20.searchText)("incremental", ctx_r20.incremental);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("flexbrowse-selection-selected-path-scroller", !ctx_r20.isSingleSelection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.isLoading)("ngIfElse", _r27);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$k, ctx_r20.isDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$h, ctx_r20.selectedPath.length > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.list);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_2_div_4_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ExFlexbrowseSelectionComponent_ng_template_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "ex-button", 39);
    i0.ɵɵlistener("click", function ExFlexbrowseSelectionComponent_ng_template_2_div_5_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.manualClose(false)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ex-button", 40);
    i0.ɵɵlistener("click", function ExFlexbrowseSelectionComponent_ng_template_2_div_5_Template_ex_button_click_4_listener() { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.manualClose(true)); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "ng.general.cancel"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "ng.general.done"), "");
} }
function ExFlexbrowseSelectionComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "mat-dialog-content");
    i0.ɵɵtemplate(3, ExFlexbrowseSelectionComponent_ng_template_2_div_3_Template, 13, 14, "div", 18);
    i0.ɵɵtemplate(4, ExFlexbrowseSelectionComponent_ng_template_2_div_4_Template, 2, 1, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExFlexbrowseSelectionComponent_ng_template_2_div_5_Template, 7, 6, "div", 20);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.rootId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isSingleSelection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isSingleSelection);
} }
const _c4$e = function (a0) { return { "flexbrowse-selection-placeholder-disabled": a0 }; };
function ExFlexbrowseSelectionComponent_ng_template_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4$e, ctx_r47.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r47.placeholder), " ");
} }
const _c5$b = function (a0) { return { "flexbrowse-selection-icon-disabled": a0 }; };
function ExFlexbrowseSelectionComponent_ng_template_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelement(1, "i", 46);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c5$b, ctx_r48.isReadOnly));
} }
function ExFlexbrowseSelectionComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵlistener("mouseenter", function ExFlexbrowseSelectionComponent_ng_template_4_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r49.isTriggerHovered = !ctx_r49.isReadOnly); })("mouseleave", function ExFlexbrowseSelectionComponent_ng_template_4_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r51.isTriggerHovered = false); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExFlexbrowseSelectionComponent_ng_template_4_span_3_Template, 3, 6, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExFlexbrowseSelectionComponent_ng_template_4_div_4_Template, 2, 3, "div", 43);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 5, ctx_r5.placeholder));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, ctx_r5.placeholder));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r5.placeholder && (!ctx_r5.selectedItems || ctx_r5.selectedItems.length === 0))("ngIfElse", _r0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedItems.length == 0);
} }
function ExFlexbrowseSelectionComponent_button_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c6$a = function (a0) { return { "flexbrowse-selection-menu-trigger-disabled": a0 }; };
const _c7$8 = function (a0) { return { "background": a0 }; };
function ExFlexbrowseSelectionComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 47, 48);
    i0.ɵɵtemplate(2, ExFlexbrowseSelectionComponent_button_7_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(11);
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("matMenuTriggerFor", _r9)("ngClass", i0.ɵɵpureFunction1(5, _c6$a, ctx_r6.isReadOnly))("ngStyle", i0.ɵɵpureFunction1(7, _c7$8, ctx_r6.backgroundColor))("disabled", ctx_r6.isReadOnly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function ExFlexbrowseSelectionComponent_ng_template_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c8$8 = function (a1) { return { "border": "border: 1px solid #ccc;", "background": a1 }; };
function ExFlexbrowseSelectionComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function ExFlexbrowseSelectionComponent_ng_template_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r55.dialogOpen()); });
    i0.ɵɵtemplate(1, ExFlexbrowseSelectionComponent_ng_template_8_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c6$a, ctx_r8.isReadOnly))("ngStyle", i0.ɵɵpureFunction1(7, _c8$8, ctx_r8.backgroundColor))("disabled", ctx_r8.isReadOnly);
    i0.ɵɵattribute("role", !ctx_r8.isReadOnly ? "button" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function ExFlexbrowseSelectionComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const DEFAULT_ID$1 = '__ROOT_ITEM';
class ExFlexbrowseSelectionComponent extends ListSelection {
    constructor(sectionLayoutViewModeObservable, dialog, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.dialog = dialog;
        this.cdr = cdr;
        this.selectedPath = [];
        this.selectedBeforeChanges = [];
        this.isTriggerHovered = false;
        this.flexbrowseCache = new Map();
    }
    ngOnInit() {
        if (!this.isReadOnly) {
            this.init();
            this.initSearch();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.destroy$.next();
        this.destroy$.complete();
    }
    manualClose(isConfirm) {
        if (isConfirm) {
            this.valueChange.emit(this.selectedItems.slice());
        }
        else {
            this.valueChange.emit(this.selectedBeforeChanges.slice());
        }
    }
    itemClicked(item) {
        item.isLoading = true;
        this.isDisabled = true;
        this.getItemData(item).pipe(filter(data => item.hasChildren = data?.length > 0), tap(data => {
            this.selectedPath.push(item);
            this.setList(data);
            this.scrollUlToTop();
        }), finalize(() => {
            item.isLoading = false;
            this.resetFlags();
            item = { ...item };
            this.cdr.markForCheck();
        })).subscribe();
    }
    removeItemFromPath(item) {
        this.isDisabled = true;
        const index = this.selectedPath.findIndex(p => item.id === p.id);
        const selectedPath = this.selectedPath.slice(0, index);
        if (selectedPath.length === 0 && this.searchText !== '') {
            this.startSearch().subscribe();
        }
        else {
            this.getItemData(selectedPath.slice(-1)[0]).subscribe(data => {
                this.selectedPath = selectedPath;
                this.setList(data);
                this.scrollUlToTop();
                this.cdr.markForCheck();
            });
        }
    }
    addItemToSelected(item) {
        const selectedItems = this.selectedItems.slice();
        if (this._maxNumberOfSelections < 0 || this.selectedItems.length == 0 ||
            this._maxNumberOfSelections - this.selectedItems.length > 0) {
            selectedItems.push(item);
        }
        else {
            selectedItems[this.selectedItems.length - 1] = item;
        }
        this.selectedItems = selectedItems;
        if (this.isSingleSelection) {
            this.valueChange.emit(this.selectedItems.slice());
        }
    }
    removeItemFromSelected(item) {
        event.stopPropagation();
        if (!this.isReadOnly) {
            const selectedItems = this.selectedItems.slice();
            const index = selectedItems.map(x => x.id).indexOf(item.id);
            selectedItems.splice(index, 1);
            this.selectedItems = selectedItems;
            this.selectedItems = this.sortSelectedItems();
            if (this.isSingleSelection) {
                this.valueChange.emit(this.selectedItems.slice());
            }
        }
    }
    checkCache(id) {
        if (!id) {
            id = this.rootId || DEFAULT_ID$1;
        }
        return this.flexbrowseCache.get(id) ?? [];
    }
    addToCache(data, id) {
        if (!id) {
            id = this.rootId || DEFAULT_ID$1;
        }
        this.flexbrowseCache.set(id, data);
    }
    startSearch() {
        this.searchLoading = true;
        this.cdr.detectChanges();
        return iif(() => this.searchText?.length === 0, defer$1(() => this.initTopLevel()), defer$1(() => this.doSearch())).pipe(finalize(() => {
            this.resetFlags();
            this.cdr.markForCheck();
        }));
    }
    doSearch() {
        if (this.searchText.length > this.searchThreshold) {
            return this.datasource?.getItemsBySearchString(this.searchText).pipe(tap(data => {
                this.selectedPath = [];
                this.textHighlight = this.searchText;
                if (Array.isArray(data)) {
                    this.setList(data);
                }
                this.scrollUlToTop();
                setTimeout(() => this.searchBox.focus(), 10);
            }));
        }
        return empty();
    }
    reset() {
        this.selectedPath = [];
        this.searchText = '';
        this.textHighlight = '';
        this.resetFlags();
    }
    dialogOpen() {
        this.selectedBeforeChanges = this.selectedItems.slice();
        this.dialog.open(this.dialogRef, {
            width: '60vw',
            panelClass: 'custom-flexbrowse-selection-modalbox',
            disableClose: true,
            closeOnNavigation: true
        });
        this.init();
    }
    getItemData(item) {
        return defer$1(() => of(this.checkCache(item?.id))).pipe(mergeMap$1(data => iif(() => data.length === 0, defer$1(() => this.datasource?.getItemsById(item?.id))
            .pipe(tap(data => this.addToCache(data, item?.id))), of(data))));
    }
    static { this.ɵfac = function ExFlexbrowseSelectionComponent_Factory(t) { return new (t || ExFlexbrowseSelectionComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i1$7.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFlexbrowseSelectionComponent, selectors: [["ex-flexbrowse-selection"]], viewQuery: function ExFlexbrowseSelectionComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$L, 5);
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
        } }, hostBindings: function ExFlexbrowseSelectionComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("valueChange", function ExFlexbrowseSelectionComponent_valueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); });
        } }, inputs: { rootId: "rootId" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExFlexbrowseSelectionComponent)), i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 4, consts: [["selection", ""], ["dialogRef", ""], ["mainArea", ""], [1, "flexbrowse-selection-wrapper"], ["class", "flexbrowse-selection-wrapper-button-for-menu flexbrowse-selection-menu-trigger", 3, "matMenuTriggerFor", "ngClass", "ngStyle", "disabled", 4, "ngIf", "ngIfElse"], ["multiSelection", ""], ["yPosition", "below", 3, "hasBackdrop"], ["menu", "matMenu"], [4, "ngTemplateOutlet"], [4, "ngIf", "ngIfElse"], ["singleSelectionValue", ""], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [1, "flexbrowse-selection-chip", 3, "item", "readOnly", "removeClicked"], [1, "break"], [1, "flexbrowse-selection-chip", 3, "item", "title", "readOnly"], [1, "flexbrowse-selection-single-selection", 3, "ngClass"], ["mat-dialog-title", ""], ["class", "flexbrowse-selection-menu-wrapper-wrapper flexbrowse-selection-side-by-side", 3, "click", 4, "ngIf"], ["class", "flexbrowse-selection-selected-area flexbrowse-selection-side-by-side", 4, "ngIf"], ["class", "flexbrowse-selection-dialog-buttons", 4, "ngIf"], [1, "flexbrowse-selection-menu-wrapper-wrapper", "flexbrowse-selection-side-by-side", 3, "click"], [1, "flexbrowse-selection-menu-wrapper"], [1, "flexbrowse-selection-search"], [3, "isLoading", "searchText", "incremental", "searchTextChange", "searchTriggered"], ["searchBox", ""], ["class", "flexbrowse-selection-selected-path-wrapper", 3, "ngClass", 4, "ngIf", "ngIfElse"], [3, "ngClass"], ["ulToScroll", ""], [4, "ngFor", "ngForOf"], ["spinner", ""], [1, "flexbrowse-selection-selected-path-wrapper", 3, "ngClass"], [3, "item", "isSingleSelection", "isLast", "isSelected", "textHighlight", "itemRemoved", "checkboxClicked", 4, "ngFor", "ngForOf"], [3, "item", "isSingleSelection", "isLast", "isSelected", "textHighlight", "itemRemoved", "checkboxClicked"], [3, "isSingleSelection", "item", "isSelected", "textHighlight", "itemClicked", "checkboxClicked"], [1, "flexbrowse-selection-spinner"], [1, "flexbrowse-spinner", 3, "diameter"], [1, "flexbrowse-selection-selected-area", "flexbrowse-selection-side-by-side"], [1, "flexbrowse-selection-dialog-buttons"], ["type2", "secondary", 3, "mat-dialog-close", "click"], ["type2", "primary", 3, "mat-dialog-close", "click"], [1, "flexbrowse-selection-selected-list", 3, "exTooltip", "mouseenter", "mouseleave"], ["class", "flexbrowse-selection-selected-placeholder", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["class", "flexbrowse-selection-menu-button", 4, "ngIf"], [1, "flexbrowse-selection-selected-placeholder", 3, "ngClass"], [1, "flexbrowse-selection-menu-button"], [1, "uxf-icon", "uxf-list", 3, "ngClass"], [1, "flexbrowse-selection-wrapper-button-for-menu", "flexbrowse-selection-menu-trigger", 3, "matMenuTriggerFor", "ngClass", "ngStyle", "disabled"], ["menuTrigger", "matMenuTrigger"], [1, "flexbrowse-selection-menu-trigger", 3, "ngClass", "ngStyle", "disabled", "click"]], template: function ExFlexbrowseSelectionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFlexbrowseSelectionComponent_ng_template_0_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(2, ExFlexbrowseSelectionComponent_ng_template_2_Template, 6, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(4, ExFlexbrowseSelectionComponent_ng_template_4_Template, 5, 9, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵtemplate(7, ExFlexbrowseSelectionComponent_button_7_Template, 3, 9, "button", 4);
            i0.ɵɵtemplate(8, ExFlexbrowseSelectionComponent_ng_template_8_Template, 2, 9, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(10, "mat-menu", 6, 7);
            i0.ɵɵtemplate(12, ExFlexbrowseSelectionComponent_ng_container_12_Template, 1, 0, "ng-container", 8);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(3);
            const _r7 = i0.ɵɵreference(9);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", ctx.isSingleSelection)("ngIfElse", _r7);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hasBackdrop", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", _r2);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i1$7.MatDialogClose, i1$7.MatDialogTitle, i1$7.MatDialogContent, ExSearchComponent, ExSpinnerComponent, ExTooltipDirective, ExButtonComponent, i3$1.MatMenu, i3$1.MatMenuTrigger, ExFlexbrowseItemComponent, ExFlexbrowseSelectedPathComponent, ExFlexbrowseChipComponent, i1$2.TranslatePipe], styles: [".flexbrowse-selection-wrapper[_ngcontent-%COMP%]{width:100%}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-wrapper-button-for-menu[_ngcontent-%COMP%]{width:100%;border:1px solid transparent;background:transparent}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]{width:100%;min-height:34px;border:1px solid #ccc;border-radius:5px;margin-bottom:2px;cursor:pointer;padding:0 10px;background-color:transparent;overflow:auto;display:flex;align-items:center}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-menu-button[_ngcontent-%COMP%]{background:transparent;outline:0;padding:5px 0;border-radius:3px;z-index:3;height:30px;position:sticky;margin-left:5px;border:2px solid transparent}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-menu-button[_ngcontent-%COMP%]   i.uxf-list.flexbrowse-selection-icon-disabled[_ngcontent-%COMP%]{opacity:.5}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger.flexbrowse-selection-menu-trigger-disabled[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-selected-list[_ngcontent-%COMP%]{display:flex;flex:1;flex-wrap:wrap;height:100%;column-gap:10px}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-selected-list[_ngcontent-%COMP%]   .break[_ngcontent-%COMP%]{flex-basis:100%;height:0}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-selected-list[_ngcontent-%COMP%]   .break[_ngcontent-%COMP%]:first-child{margin-top:10px}.flexbrowse-selection-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-trigger[_ngcontent-%COMP%]   .flexbrowse-selection-selected-list[_ngcontent-%COMP%]   .flexbrowse-selection-chip[_ngcontent-%COMP%]{cursor:pointer}  .flexbrowse-selection-selected-list .flexbrowse-chip-wrapper:hover{background:transparent!important}  .flexbrowse-selection-selected-list .flexbrowse-chip-wrapper .flexbrowse-chip-remove-icon-button{display:none}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-search[_ngcontent-%COMP%]{margin:10px}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]{height:calc(52vh - 40px);overflow:auto}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]   .flexbrowse-selection-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.4}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-wrapper[_ngcontent-%COMP%]{margin-top:5px}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;list-style-type:none}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .flexbrowse-selection-list-children[_ngcontent-%COMP%]{border-left:1px solid gray;margin-left:14px;padding-top:10px}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}.flexbrowse-selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-menu-wrapper[_ngcontent-%COMP%]   .flexbrowse-selection-spinner[_ngcontent-%COMP%]{align-items:center;justify-content:center;margin:15px;display:flex}  .custom-flexbrowse-selection-modalbox{position:relative!important}mat-dialog-content[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}mat-dialog-content[_ngcontent-%COMP%]   .flexbrowse-selection-selected-area[_ngcontent-%COMP%]{border:1px solid #DADEE3;border-radius:3px;margin:10px;padding:15px;height:52vh;margin-inline-end:0px}mat-dialog-content[_ngcontent-%COMP%]   .flexbrowse-selection-side-by-side[_ngcontent-%COMP%]{flex:1 0 calc(50% - 10px);overflow:auto;min-width:150px}.flexbrowse-selection-dialog-buttons[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;width:55vw;gap:.5rem}  .cdk-virtual-scroll-content-wrapper{width:100%}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFlexbrowseSelectionComponent, [{
        type: Component,
        args: [{ selector: 'ex-flexbrowse-selection', host: {
                    '(valueChange)': 'controlOnChange($event)'
                }, providers: getValueAccessors(ExFlexbrowseSelectionComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- THE SELECTED VALUES AREA-->\n<ng-template #selection>\n  <ng-container *ngIf=\"!isSingleSelection; else singleSelectionValue\">\n    <ng-container *ngFor=\"let selected of selectedItems; trackBy: getId\">\n      <ng-container *ngIf=\"selected.title\">\n        <div class=\"break\"></div>\n        <ex-flexbrowse-chip class=\"flexbrowse-selection-chip\" [item]=\"selected\" [title]=\"true\" [readOnly]=\"isReadOnly\">\n        </ex-flexbrowse-chip>\n      </ng-container>\n      <ex-flexbrowse-chip class=\"flexbrowse-selection-chip\" [item]=\"selected\" [readOnly]=\"isReadOnly\"\n        (removeClicked)=\"removeItemFromSelected($event)\"></ex-flexbrowse-chip>\n    </ng-container>\n\n  </ng-container>\n  <ng-template #singleSelectionValue>\n    <span class=\"flexbrowse-selection-single-selection\"\n      [ngClass]=\"{ 'flexbrowse-selection-single-selection-disabled': isReadOnly}\">\n      {{ selectedItems[0]?.name }} </span>\n  </ng-template>\n</ng-template>\n\n<!-- THE FLEXBROWSE AREA - PRESENTED AS A DIALOG/MENU -->\n<ng-template #dialogRef>\n  <div mat-dialog-title>{{rootId}}</div>\n  <mat-dialog-content>\n    <div class=\"flexbrowse-selection-menu-wrapper-wrapper flexbrowse-selection-side-by-side\"\n      (click)=\"$event.stopPropagation()\" *ngIf=\"!isReadOnly\">\n      <div class=\"flexbrowse-selection-menu-wrapper\">\n        <div class=\"flexbrowse-selection-search\">\n          <ex-search #searchBox [isLoading]=\"searchLoading\" [(searchText)]=\"searchText\" [incremental]=\"incremental\"\n            (searchTriggered)=\"onSearchTriggered()\">\n          </ex-search>\n        </div>\n        <div [class.flexbrowse-selection-selected-path-scroller]=\"!isSingleSelection\">\n          <div [ngClass]=\"{ 'flexbrowse-selection-disabled': isDisabled}\" *ngIf=\"!isLoading; else spinner\"\n            class=\"flexbrowse-selection-selected-path-wrapper\">\n            <ex-flexbrowse-selected-path *ngFor=\"let selected of selectedPath; let i = index\" [item]=\"selected\"\n              [isSingleSelection]=\"isSingleSelection\" [isLast]=\"i === selectedPath.length - 1\"\n              [isSelected]=\"isItemSelected(selected.id)\" (itemRemoved)=\"removeItemFromPath($event)\"\n              [textHighlight]=\"textHighlight\" (checkboxClicked)=\"checkboxToggled($event)\">\n            </ex-flexbrowse-selected-path>\n          </div>\n          <ul [ngClass]=\"{ 'flexbrowse-selection-disabled': isDisabled}\" #ulToScroll>\n            <div [ngClass]=\"{ 'flexbrowse-selection-list-children': selectedPath.length > 0}\">\n              <li *ngFor=\"let item of list\">\n                <ex-flexbrowse-item [isSingleSelection]=\"isSingleSelection\" [item]=\"item\"\n                  [isSelected]=\"isItemSelected(item.id)\" (itemClicked)=\"itemClicked(item)\"\n                  [textHighlight]=\"textHighlight\" (checkboxClicked)=\"checkboxToggled($event)\">\n                </ex-flexbrowse-item>\n              </li>\n            </div>\n          </ul>\n        </div>\n      </div>\n      <ng-template #spinner>\n        <div class=\"flexbrowse-selection-spinner\">\n          <ex-spinner [diameter]=\"25\" class=\"flexbrowse-spinner\"></ex-spinner>\n        </div>\n      </ng-template>\n    </div>\n    <div class=\"flexbrowse-selection-selected-area flexbrowse-selection-side-by-side\" *ngIf=\"!isSingleSelection\">\n      <ng-container *ngTemplateOutlet=\"selection\"></ng-container>\n    </div>\n  </mat-dialog-content>\n  <div class=\"flexbrowse-selection-dialog-buttons\" *ngIf=\"!isSingleSelection\">\n    <ex-button type2=\"secondary\" (click)=\"manualClose(false)\" [mat-dialog-close]>\n      {{'ng.general.cancel' | translate}}</ex-button>\n    <ex-button type2=\"primary\" (click)=\"manualClose(true)\" [mat-dialog-close]>\n      {{'ng.general.done' | translate}}</ex-button>\n  </div>\n</ng-template>\n\n\n<ng-template #mainArea>\n\n  <div class=\"flexbrowse-selection-selected-list\" (mouseenter)=\"isTriggerHovered = !isReadOnly\"\n    (mouseleave)=\"isTriggerHovered = false\" [exTooltip]=\"placeholder | translate\"\n    [attr.aria-label]=\"placeholder | translate\">\n    <span *ngIf=\"placeholder && (!selectedItems || selectedItems.length === 0); else selection\"\n      class=\"flexbrowse-selection-selected-placeholder\"\n      [ngClass]=\"{ 'flexbrowse-selection-placeholder-disabled': isReadOnly}\">\n      {{ placeholder | translate }} </span>\n  </div>\n  <div *ngIf=\"selectedItems.length == 0\" class=\"flexbrowse-selection-menu-button\">\n    <i class=\"uxf-icon uxf-list\" [ngClass]=\"{ 'flexbrowse-selection-icon-disabled': isReadOnly}\"></i>\n  </div>\n\n</ng-template>\n\n\n<div class=\"flexbrowse-selection-wrapper\">\n  <!-- menu for single selection mode-->\n  <button *ngIf=\"isSingleSelection else multiSelection\" #menuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"menu\"\n    [ngClass]=\"{ 'flexbrowse-selection-menu-trigger-disabled': isReadOnly }\"\n    [ngStyle]=\"{'background': backgroundColor }\"\n    class=\"flexbrowse-selection-wrapper-button-for-menu flexbrowse-selection-menu-trigger\" [disabled]=\"isReadOnly\">\n    <ng-container *ngTemplateOutlet=\"mainArea\"></ng-container>\n  </button>\n\n  <!-- dialog for multi selection mode-->\n  <ng-template #multiSelection>\n    <button class=\"flexbrowse-selection-menu-trigger\"\n      [ngClass]=\"{ 'flexbrowse-selection-menu-trigger-disabled': isReadOnly }\" (click)=\"dialogOpen()\"\n      [ngStyle]=\"{'border': 'border: 1px solid #ccc;', 'background': backgroundColor }\"\n      [attr.role]=\"!isReadOnly ? 'button' : null\" [disabled]=\"isReadOnly\">\n      <ng-container *ngTemplateOutlet=\"mainArea\"></ng-container>\n    </button>\n  </ng-template>\n\n  <mat-menu #menu=\"matMenu\" [hasBackdrop]=\"true\" yPosition=\"below\">\n    <ng-container *ngTemplateOutlet=\"dialogRef\"></ng-container>\n  </mat-menu>\n</div>", styles: [".flexbrowse-selection-wrapper{width:100%}.flexbrowse-selection-wrapper .flexbrowse-selection-wrapper-button-for-menu{width:100%;border:1px solid transparent;background:transparent}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger{width:100%;min-height:34px;border:1px solid #ccc;border-radius:5px;margin-bottom:2px;cursor:pointer;padding:0 10px;background-color:transparent;overflow:auto;display:flex;align-items:center}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-menu-button{background:transparent;outline:0;padding:5px 0;border-radius:3px;z-index:3;height:30px;position:sticky;margin-left:5px;border:2px solid transparent}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-menu-button i.uxf-list.flexbrowse-selection-icon-disabled{opacity:.5}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger.flexbrowse-selection-menu-trigger-disabled{cursor:default;pointer-events:none}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-selected-list{display:flex;flex:1;flex-wrap:wrap;height:100%;column-gap:10px}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-selected-list .break{flex-basis:100%;height:0}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-selected-list .break:first-child{margin-top:10px}.flexbrowse-selection-wrapper .flexbrowse-selection-menu-trigger .flexbrowse-selection-selected-list .flexbrowse-selection-chip{cursor:pointer}::ng-deep .flexbrowse-selection-selected-list .flexbrowse-chip-wrapper:hover{background:transparent!important}::ng-deep .flexbrowse-selection-selected-list .flexbrowse-chip-wrapper .flexbrowse-chip-remove-icon-button{display:none}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-search{margin:10px}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller{height:calc(52vh - 40px);overflow:auto}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller .flexbrowse-selection-disabled{pointer-events:none;opacity:.4}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller .flexbrowse-selection-selected-path-wrapper{margin-top:5px}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller ul{padding:0;list-style-type:none}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller ul .flexbrowse-selection-list-children{border-left:1px solid gray;margin-left:14px;padding-top:10px}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-selected-path-scroller ul li{list-style-type:none}.flexbrowse-selection-menu-wrapper-wrapper .flexbrowse-selection-menu-wrapper .flexbrowse-selection-spinner{align-items:center;justify-content:center;margin:15px;display:flex}::ng-deep .custom-flexbrowse-selection-modalbox{position:relative!important}mat-dialog-content{display:flex;flex-wrap:wrap}mat-dialog-content .flexbrowse-selection-selected-area{border:1px solid #DADEE3;border-radius:3px;margin:10px;padding:15px;height:52vh;margin-inline-end:0px}mat-dialog-content .flexbrowse-selection-side-by-side{flex:1 0 calc(50% - 10px);overflow:auto;min-width:150px}.flexbrowse-selection-dialog-buttons{display:flex;justify-content:flex-end;width:55vw;gap:.5rem}::ng-deep .cdk-virtual-scroll-content-wrapper{width:100%}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i1$7.MatDialog }, { type: i0.ChangeDetectorRef }]; }, { rootId: [{
            type: Input
        }], dialogRef: [{
            type: ViewChild,
            args: ["dialogRef"]
        }], menuTrigger: [{
            type: ViewChild,
            args: [MatMenuTrigger, { static: false }]
        }] }); })();

class ExFlexbrowseSelectionModule {
    static { this.ɵfac = function ExFlexbrowseSelectionModule_Factory(t) { return new (t || ExFlexbrowseSelectionModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFlexbrowseSelectionModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatDialogModule,
            TranslateModule,
            MatRadioModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExSearchModule,
            ExSpinnerModule,
            EXPipesModule,
            ExDirectivesModule,
            ExCheckboxModule,
            ExButtonModule,
            MatMenuModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFlexbrowseSelectionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatDialogModule,
                    TranslateModule,
                    MatRadioModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExSearchModule,
                    ExSpinnerModule,
                    EXPipesModule,
                    ExDirectivesModule,
                    ExCheckboxModule,
                    ExButtonModule,
                    MatMenuModule,
                ],
                declarations: [
                    ExFlexbrowseSelectionComponent,
                    ExFlexbrowseItemComponent,
                    ExFlexbrowseSelectedPathComponent,
                    ExFlexbrowseChipComponent
                ],
                exports: [
                    ExFlexbrowseSelectionComponent,
                    ExFlexbrowseItemComponent,
                    ExFlexbrowseSelectedPathComponent,
                    ExFlexbrowseChipComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFlexbrowseSelectionModule, { declarations: [ExFlexbrowseSelectionComponent,
        ExFlexbrowseItemComponent,
        ExFlexbrowseSelectedPathComponent,
        ExFlexbrowseChipComponent], imports: [CommonModule,
        FormsModule,
        MatDialogModule,
        TranslateModule,
        MatRadioModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExSearchModule,
        ExSpinnerModule,
        EXPipesModule,
        ExDirectivesModule,
        ExCheckboxModule,
        ExButtonModule,
        MatMenuModule], exports: [ExFlexbrowseSelectionComponent,
        ExFlexbrowseItemComponent,
        ExFlexbrowseSelectedPathComponent,
        ExFlexbrowseChipComponent] }); })();

function SelectionMenuComponent_ng_template_0_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 8)(2, "ex-flexbrowse-chip", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selected_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("item", selected_r8)("title", true)("readOnly", ctx_r9.isReadOnly);
} }
function SelectionMenuComponent_ng_template_0_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectionMenuComponent_ng_template_0_ng_container_0_ng_container_1_ng_container_1_Template, 3, 3, "ng-container", 6);
    i0.ɵɵelementStart(2, "ex-flexbrowse-chip", 7);
    i0.ɵɵlistener("removeClicked", function SelectionMenuComponent_ng_template_0_ng_container_0_ng_container_1_Template_ex_flexbrowse_chip_removeClicked_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.removeItemFromSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selected_r8 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selected_r8.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", selected_r8)("readOnly", ctx_r7.isReadOnly);
} }
function SelectionMenuComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectionMenuComponent_ng_template_0_ng_container_0_ng_container_1_Template, 3, 3, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.selectedItems)("ngForTrackBy", ctx_r4.getId);
} }
const _c0$K = function (a0) { return { "selection-menu-single-selection-disabled": a0 }; };
function SelectionMenuComponent_ng_template_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$K, ctx_r6.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedItems[0] == null ? null : ctx_r6.selectedItems[0].name, " ");
} }
function SelectionMenuComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SelectionMenuComponent_ng_template_0_ng_container_0_Template, 2, 2, "ng-container", 3);
    i0.ɵɵtemplate(1, SelectionMenuComponent_ng_template_0_ng_template_1_Template, 2, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSingleSelection)("ngIfElse", _r5);
} }
function SelectionMenuComponent_div_3_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ng.general.qb.refine_your_search"));
} }
function SelectionMenuComponent_div_3_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "ex-flexbrowse-item", 22);
    i0.ɵɵlistener("checkboxClicked", function SelectionMenuComponent_div_3_li_13_Template_ex_flexbrowse_item_checkboxClicked_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.checkboxToggled($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSingleSelection", ctx_r16.isSingleSelection)("item", item_r17)("isSelected", ctx_r16.isItemSelected(item_r17.id))("textHighlight", ctx_r16.textHighlight);
} }
const _c1$s = function (a0) { return { "selection-menu-disabled": a0 }; };
function SelectionMenuComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function SelectionMenuComponent_div_3_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13)(5, "div", 14)(6, "ex-search", 15, 16);
    i0.ɵɵlistener("searchTextChange", function SelectionMenuComponent_div_3_Template_ex_search_searchTextChange_6_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.searchText = $event); })("searchTriggered", function SelectionMenuComponent_div_3_Template_ex_search_searchTriggered_6_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.onSearchTriggered()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtemplate(9, SelectionMenuComponent_div_3_span_9_Template, 3, 3, "span", 17);
    i0.ɵɵelementStart(10, "ul", 18, 19)(12, "div");
    i0.ɵɵtemplate(13, SelectionMenuComponent_div_3_li_13_Template, 2, 4, "li", 20);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 12, ctx_r2.searchResults));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("isLoading", ctx_r2.searchLoading)("searchText", ctx_r2.searchText)("incremental", ctx_r2.incremental)("disableWhenLoading", false)("isValid", ctx_r2.isValid)("errorMessage", ctx_r2.errorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("selection-menu-selected-path-scroller", !ctx_r2.isSingleSelection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasMoreResults);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1$s, ctx_r2.isDisabled));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.list);
} }
function SelectionMenuComponent_div_4_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SelectionMenuComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 24);
    i0.ɵɵtemplate(5, SelectionMenuComponent_div_4_ng_container_5_Template, 1, 0, "ng-container", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r3.selectedResults));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
const DEFAULT_ID = '__ROOT_ITEM';
class SelectionMenuComponent extends ListSelection {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.searchResults = "selection_menu.all_results";
        this.selectedResults = "selection_menu.selected_results";
        this.isValid = true;
        this.hasMoreResults = false;
    }
    ngOnInit() {
        if (!this.isReadOnly) {
            this.init();
            this.initSearch();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.destroy$.next();
        this.destroy$.complete();
    }
    addItemToSelected(item) {
        const selectedItems = this.selectedItems.slice();
        if (this._maxNumberOfSelections < 0 || this.selectedItems.length == 0 ||
            this._maxNumberOfSelections - this.selectedItems.length > 0) {
            selectedItems.push(item);
        }
        else {
            selectedItems[this.selectedItems.length - 1] = item;
        }
        this.selectedItems = selectedItems;
        this.valueChange.emit(this.selectedItems.slice());
    }
    removeItemFromSelected(item) {
        event.stopPropagation();
        if (!this.isReadOnly) {
            const selectedItems = this.selectedItems.slice();
            const index = selectedItems.map(x => x.id).indexOf(item.id);
            selectedItems.splice(index, 1);
            this.selectedItems = selectedItems;
            this.valueChange.emit(this.selectedItems.slice());
        }
    }
    startSearch() {
        this.hasMoreResults = false;
        this.searchLoading = true;
        this.cdr.detectChanges();
        return iif(() => this.searchText?.length === 0, defer$1(() => this.initTopLevel()), defer$1(() => this.doSearch())).pipe(finalize(() => {
            this.resetFlags();
            this.cdr.markForCheck();
        }));
    }
    doSearch() {
        if (this.searchText.length > this.searchThreshold) {
            return this.datasource?.getItemsBySearchString(this.searchText).pipe(tap(data => {
                this.textHighlight = this.searchText;
                if (!Array.isArray(data)) {
                    this.setList(data?.values);
                    this.hasMoreResults = data?.hasMore;
                }
                this.scrollUlToTop();
                setTimeout(() => this.searchBox.focus(), 10);
            }));
        }
        return empty();
    }
    reset() {
        this.searchText = '';
        this.textHighlight = '';
        this.resetFlags();
    }
    getItemData(item) {
        return this.datasource?.getItemsById(item?.id);
    }
    static { this.ɵfac = function SelectionMenuComponent_Factory(t) { return new (t || SelectionMenuComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectionMenuComponent, selectors: [["selection-menu"]], hostBindings: function SelectionMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("valueChange", function SelectionMenuComponent_valueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); });
        } }, inputs: { searchResults: "searchResults", selectedResults: "selectedResults", isValid: "isValid", errorMessage: "errorMessage" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["selection", ""], ["class", "selection-menu-wrapper-wrapper selection-menu-side-by-side", 3, "click", 4, "ngIf"], ["class", "selection-menu-side-by-side", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["singleSelectionValue", ""], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [1, "selection-menu-chip", 3, "item", "readOnly", "removeClicked"], [1, "break"], [1, "selection-menu-chip", 3, "item", "title", "readOnly"], [1, "selection-menu-single-selection", 3, "ngClass"], [1, "selection-menu-wrapper-wrapper", "selection-menu-side-by-side", 3, "click"], [1, "selection-menu-area-title"], [1, "selection-menu-wrapper"], [1, "selection-menu-search"], [3, "isLoading", "searchText", "incremental", "disableWhenLoading", "isValid", "errorMessage", "searchTextChange", "searchTriggered"], ["searchBox", ""], ["class", "search-has-more-results", 4, "ngIf"], [3, "ngClass"], ["ulToScroll", ""], [4, "ngFor", "ngForOf"], [1, "search-has-more-results"], [3, "isSingleSelection", "item", "isSelected", "textHighlight", "checkboxClicked"], [1, "selection-menu-side-by-side"], [1, "selection-menu-selected-area"], [4, "ngTemplateOutlet"]], template: function SelectionMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SelectionMenuComponent_ng_template_0_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(2, "mat-dialog-content");
            i0.ɵɵtemplate(3, SelectionMenuComponent_div_3_Template, 14, 16, "div", 1);
            i0.ɵɵtemplate(4, SelectionMenuComponent_div_4_Template, 6, 4, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isSingleSelection);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$7.MatDialogContent, ExSearchComponent, ExFlexbrowseItemComponent, ExFlexbrowseChipComponent, i1$2.TranslatePipe], styles: [".selection-menu-wrapper[_ngcontent-%COMP%]{width:100%}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper-button-for-menu[_ngcontent-%COMP%]{width:100%;border:1px solid transparent;background:transparent}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]{width:100%;min-height:34px;border:1px solid #ccc;border-radius:5px;margin-bottom:2px;cursor:pointer;padding:0 10px;background-color:transparent;overflow:auto;display:flex;align-items:center}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-button[_ngcontent-%COMP%]{background:transparent;outline:0;padding:5px 0;border-radius:3px;z-index:3;height:30px;position:sticky;margin-left:5px;border:2px solid transparent}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-button[_ngcontent-%COMP%]   i.uxf-list.selection-menu-icon-disabled[_ngcontent-%COMP%]{opacity:.5}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger.selection-menu-trigger-disabled[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-selected-list[_ngcontent-%COMP%]{display:flex;flex:1;flex-wrap:wrap;height:100%;column-gap:10px}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-selected-list[_ngcontent-%COMP%]   .break[_ngcontent-%COMP%]{flex-basis:100%;height:0}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-selected-list[_ngcontent-%COMP%]   .break[_ngcontent-%COMP%]:first-child{margin-top:10px}.selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-trigger[_ngcontent-%COMP%]   .selection-menu-selected-list[_ngcontent-%COMP%]   .selection-menu-chip[_ngcontent-%COMP%]{cursor:pointer}  .selection-menu-selected-list .flexbrowse-chip-wrapper:hover{background:transparent!important}  .selection-menu-selected-list .flexbrowse-chip-wrapper .flexbrowse-chip-remove-icon-button{display:none}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-search[_ngcontent-%COMP%]{margin:10px}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]{height:calc(52vh - 40px);overflow:auto}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   .selection-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.4}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   .selection-menu-selected-path-wrapper[_ngcontent-%COMP%]{margin-top:5px}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   .search-has-more-results[_ngcontent-%COMP%]{padding:10px 20px;font-family:Roboto-italic;display:inline-block}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;list-style-type:none}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   .selection-menu-list-children[_ngcontent-%COMP%]{border-left:1px solid gray;margin-left:14px;padding-top:10px}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-selected-path-scroller[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}.selection-menu-wrapper-wrapper[_ngcontent-%COMP%]   .selection-menu-wrapper[_ngcontent-%COMP%]   .selection-menu-spinner[_ngcontent-%COMP%]{align-items:center;justify-content:center;margin:15px;display:flex}  .custom-selection-menu-modalbox{position:relative!important}mat-dialog-content[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}mat-dialog-content[_ngcontent-%COMP%]   .selection-menu-side-by-side[_ngcontent-%COMP%]{flex:1 0 calc(50% - 10px);overflow:auto;min-width:150px}mat-dialog-content[_ngcontent-%COMP%]   .selection-menu-side-by-side[_ngcontent-%COMP%]   .selection-menu-selected-area[_ngcontent-%COMP%]{overflow:auto;border:1px solid #dadee3;border-radius:3px;margin:10px;padding:15px;height:52vh;margin-inline-end:0px}mat-dialog-content[_ngcontent-%COMP%]   .selection-menu-side-by-side[_ngcontent-%COMP%]   .selection-menu-area-title[_ngcontent-%COMP%]{font-weight:500;margin-bottom:5px;margin-left:10px}mat-dialog-content[_ngcontent-%COMP%]   .selected-area-title[_ngcontent-%COMP%]{font-weight:500;margin-bottom:5px;margin-left:10px}.selection-menu-dialog-buttons[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;width:55vw;gap:.5rem}  .cdk-virtual-scroll-content-wrapper{width:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectionMenuComponent, [{
        type: Component,
        args: [{ selector: 'selection-menu', host: {
                    '(valueChange)': 'controlOnChange($event)'
                }, template: "<!-- THE SELECTED VALUES AREA-->\r\n<ng-template #selection>\r\n    <ng-container *ngIf=\"!isSingleSelection; else singleSelectionValue\">\r\n        <ng-container *ngFor=\"let selected of selectedItems; trackBy: getId\">\r\n            <ng-container *ngIf=\"selected.title\">\r\n                <div class=\"break\"></div>\r\n                <ex-flexbrowse-chip class=\"selection-menu-chip\" [item]=\"selected\" [title]=\"true\"\r\n                    [readOnly]=\"isReadOnly\">\r\n                </ex-flexbrowse-chip>\r\n            </ng-container>\r\n            <ex-flexbrowse-chip class=\"selection-menu-chip\" [item]=\"selected\" [readOnly]=\"isReadOnly\"\r\n                (removeClicked)=\"removeItemFromSelected($event)\"></ex-flexbrowse-chip>\r\n        </ng-container>\r\n\r\n    </ng-container>\r\n    <ng-template #singleSelectionValue>\r\n        <span class=\"selection-menu-single-selection\"\r\n            [ngClass]=\"{ 'selection-menu-single-selection-disabled': isReadOnly}\">\r\n            {{ selectedItems[0]?.name }} </span>\r\n    </ng-template>\r\n</ng-template>\r\n\r\n<!-- THE FLEXBROWSE AREA - PRESENTED AS A DIALOG/MENU -->\r\n<mat-dialog-content>\r\n    <div class=\"selection-menu-wrapper-wrapper selection-menu-side-by-side\" (click)=\"$event.stopPropagation()\"\r\n        *ngIf=\"!isReadOnly\">\r\n        <span class=\"selection-menu-area-title\">{{ searchResults | translate }}</span>\r\n        <div class=\"selection-menu-wrapper\">\r\n            <div class=\"selection-menu-search\">\r\n                <ex-search  #searchBox [isLoading]=\"searchLoading\" [(searchText)]=\"searchText\"\r\n                    [incremental]=\"incremental\" (searchTriggered)=\"onSearchTriggered()\" [disableWhenLoading]=\"false\" [isValid] = \"isValid\" [errorMessage] =\"errorMessage\">\r\n                </ex-search>\r\n            </div>\r\n            <div [class.selection-menu-selected-path-scroller]=\"!isSingleSelection\">\r\n                <span class=\"search-has-more-results\"\r\n                    *ngIf=\"hasMoreResults \">{{ 'ng.general.qb.refine_your_search' | translate }}</span>\r\n                <ul [ngClass]=\"{ 'selection-menu-disabled': isDisabled}\" #ulToScroll>\r\n                    <div>\r\n                        <li *ngFor=\"let item of list\">\r\n                            <ex-flexbrowse-item [isSingleSelection]=\"isSingleSelection\" [item]=\"item\"\r\n                                [isSelected]=\"isItemSelected(item.id)\" [textHighlight]=\"textHighlight\"\r\n                                (checkboxClicked)=\"checkboxToggled($event)\">\r\n                            </ex-flexbrowse-item>\r\n                        </li>\r\n                    </div>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"selection-menu-side-by-side\" *ngIf=\"!isSingleSelection\">\r\n        <span class=\"selection-menu-area-title\">{{ selectedResults | translate }}</span>\r\n        <div class=\"selection-menu-selected-area\">\r\n            <ng-container *ngTemplateOutlet=\"selection\">\r\n            </ng-container>\r\n        </div>\r\n    </div>\r\n\r\n</mat-dialog-content>\r\n", styles: [".selection-menu-wrapper{width:100%}.selection-menu-wrapper .selection-menu-wrapper-button-for-menu{width:100%;border:1px solid transparent;background:transparent}.selection-menu-wrapper .selection-menu-trigger{width:100%;min-height:34px;border:1px solid #ccc;border-radius:5px;margin-bottom:2px;cursor:pointer;padding:0 10px;background-color:transparent;overflow:auto;display:flex;align-items:center}.selection-menu-wrapper .selection-menu-trigger .selection-menu-button{background:transparent;outline:0;padding:5px 0;border-radius:3px;z-index:3;height:30px;position:sticky;margin-left:5px;border:2px solid transparent}.selection-menu-wrapper .selection-menu-trigger .selection-menu-button i.uxf-list.selection-menu-icon-disabled{opacity:.5}.selection-menu-wrapper .selection-menu-trigger.selection-menu-trigger-disabled{cursor:default;pointer-events:none}.selection-menu-wrapper .selection-menu-trigger .selection-menu-selected-list{display:flex;flex:1;flex-wrap:wrap;height:100%;column-gap:10px}.selection-menu-wrapper .selection-menu-trigger .selection-menu-selected-list .break{flex-basis:100%;height:0}.selection-menu-wrapper .selection-menu-trigger .selection-menu-selected-list .break:first-child{margin-top:10px}.selection-menu-wrapper .selection-menu-trigger .selection-menu-selected-list .selection-menu-chip{cursor:pointer}::ng-deep .selection-menu-selected-list .flexbrowse-chip-wrapper:hover{background:transparent!important}::ng-deep .selection-menu-selected-list .flexbrowse-chip-wrapper .flexbrowse-chip-remove-icon-button{display:none}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-search{margin:10px}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller{height:calc(52vh - 40px);overflow:auto}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller .selection-menu-disabled{pointer-events:none;opacity:.4}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller .selection-menu-selected-path-wrapper{margin-top:5px}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller .search-has-more-results{padding:10px 20px;font-family:Roboto-italic;display:inline-block}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller ul{padding:0;list-style-type:none}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller ul .selection-menu-list-children{border-left:1px solid gray;margin-left:14px;padding-top:10px}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-selected-path-scroller ul li{list-style-type:none}.selection-menu-wrapper-wrapper .selection-menu-wrapper .selection-menu-spinner{align-items:center;justify-content:center;margin:15px;display:flex}::ng-deep .custom-selection-menu-modalbox{position:relative!important}mat-dialog-content{display:flex;flex-wrap:wrap}mat-dialog-content .selection-menu-side-by-side{flex:1 0 calc(50% - 10px);overflow:auto;min-width:150px}mat-dialog-content .selection-menu-side-by-side .selection-menu-selected-area{overflow:auto;border:1px solid #dadee3;border-radius:3px;margin:10px;padding:15px;height:52vh;margin-inline-end:0px}mat-dialog-content .selection-menu-side-by-side .selection-menu-area-title{font-weight:500;margin-bottom:5px;margin-left:10px}mat-dialog-content .selected-area-title{font-weight:500;margin-bottom:5px;margin-left:10px}.selection-menu-dialog-buttons{display:flex;justify-content:flex-end;width:55vw;gap:.5rem}::ng-deep .cdk-virtual-scroll-content-wrapper{width:100%}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { searchResults: [{
            type: Input
        }], selectedResults: [{
            type: Input
        }], isValid: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }] }); })();

class SelectionMenuModule {
    static { this.ɵfac = function SelectionMenuModule_Factory(t) { return new (t || SelectionMenuModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SelectionMenuModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatDialogModule,
            TranslateModule,
            MatRadioModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExSearchModule,
            ExSpinnerModule,
            EXPipesModule,
            ExDirectivesModule,
            ExCheckboxModule,
            ExButtonModule,
            MatMenuModule,
            ExFlexbrowseSelectionModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectionMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatDialogModule,
                    TranslateModule,
                    MatRadioModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExSearchModule,
                    ExSpinnerModule,
                    EXPipesModule,
                    ExDirectivesModule,
                    ExCheckboxModule,
                    ExButtonModule,
                    MatMenuModule,
                    ExFlexbrowseSelectionModule
                ],
                declarations: [
                    SelectionMenuComponent
                ],
                exports: [
                    SelectionMenuComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SelectionMenuModule, { declarations: [SelectionMenuComponent], imports: [CommonModule,
        FormsModule,
        MatDialogModule,
        TranslateModule,
        MatRadioModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExSearchModule,
        ExSpinnerModule,
        EXPipesModule,
        ExDirectivesModule,
        ExCheckboxModule,
        ExButtonModule,
        MatMenuModule,
        ExFlexbrowseSelectionModule], exports: [SelectionMenuComponent] }); })();

function ExFloatLabelComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFloatLabelComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFloatLabelComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.viewModeTemplate)("ngTemplateOutletContext", ctx_r0.context);
} }
function ExFloatLabelComponent_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExFloatLabelComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFloatLabelComponent_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.editModeTemplate)("ngTemplateOutletContext", ctx_r3.context);
} }
function ExFloatLabelComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFloatLabelComponent_ng_container_2_ng_container_1_Template, 2, 2, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} }
const _c0$J = function (a0) { return { "name": a0, "type": "uxf" }; };
class ExFloatLabelComponent extends TrackedEditableEntryComponent {
    constructor(sectionLayoutViewModeObservable, cdr, translate) {
        super(sectionLayoutViewModeObservable, cdr, translate);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        this.translate = translate;
        /**
          * indicates if there is an option to delete from edit mode
          */
        this.hasDelete = false;
        this.showEditIcon = false;
    }
    static { this.ɵfac = function ExFloatLabelComponent_Factory(t) { return new (t || ExFloatLabelComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFloatLabelComponent, selectors: [["ex-float-label"]], inputs: { hasDelete: "hasDelete", backgroundColor: "backgroundColor" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 9, consts: [["editBackgroundColor", "white", 1, "inline-editing", 3, "editMode", "isSingleSave", "showEditIcon", "editTitle", "editTitleIcon", "viewBackgroundColor", "editModeChange", "closeClicked"], [4, "viewModeComponent"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "editModeComponent"]], template: function ExFloatLabelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-inline-editing", 0);
            i0.ɵɵlistener("editModeChange", function ExFloatLabelComponent_Template_ex_inline_editing_editModeChange_0_listener($event) { return ctx.editMode = $event; })("editModeChange", function ExFloatLabelComponent_Template_ex_inline_editing_editModeChange_0_listener($event) { return ctx.onEditModeChanged($event); })("closeClicked", function ExFloatLabelComponent_Template_ex_inline_editing_closeClicked_0_listener() { return ctx.onCloseClicked(); });
            i0.ɵɵtemplate(1, ExFloatLabelComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
            i0.ɵɵtemplate(2, ExFloatLabelComponent_ng_container_2_Template, 2, 0, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("editMode", ctx.editMode)("isSingleSave", false)("showEditIcon", ctx.showEditIcon)("editTitle", ctx.editTitle)("editTitleIcon", i0.ɵɵpureFunction1(7, _c0$J, ctx.editIconType))("viewBackgroundColor", ctx.backgroundColor);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.editModeTemplate);
        } }, dependencies: [i1$5.NgIf, i1$5.NgTemplateOutlet, EditModeComponentDirective, ViewModeComponentDirective, ExInlineEditingComponent], styles: [".float-label-info-wrapper[_ngcontent-%COMP%]{width:100%;position:relative;display:flex;flex-direction:row;margin-left:5px;margin-bottom:5px}.float-label-info-wrapper.float-label-info-wrapper-focus-border[_ngcontent-%COMP%]{border:2px solid #1079b3!important}.float-label-info-wrapper.float-label-info-wrapper-no-focus-border[_ngcontent-%COMP%]{border:2px solid transparent!important}.float-label-info-edit-button[_ngcontent-%COMP%]{position:absolute;width:70%;height:100%;background:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end;top:0;right:30%}.float-label-info-edit-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-top:5px;margin-right:5px}.inline-editing[_ngcontent-%COMP%]{border-radius:inherit}.inline-editing[_ngcontent-%COMP%]     .ex-inline-editing-view-mode{border-radius:inherit;padding:0}.float-label-info-delete-button[_ngcontent-%COMP%]{position:absolute;bottom:10px;right:10px;color:#4164a4!important;background-color:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end}.float-label-edit-close-button[_ngcontent-%COMP%]{position:absolute;top:10px;right:0}.timeline-entry-edit-close-button[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px}.ex-combobox-chip-label[_ngcontent-%COMP%]{justify-content:space-between;padding-right:5px;padding-left:5px;margin:5px 0 5px 5px;cursor:pointer!important}.ex-combobox-chip-label-readonly[_ngcontent-%COMP%]{padding-right:5px!important;padding-left:5px!important;margin:5px!important}.ex-combobox-selected-remove[_ngcontent-%COMP%]{margin-bottom:4px}.ex-float-label-edit-mode[_ngcontent-%COMP%]{border:2px solid #1079b3;background:#fff;padding:15px}.ex-float-label-edit-mode[_ngcontent-%COMP%]   .ex-float-label-edit-click[_ngcontent-%COMP%]{cursor:pointer}.ex-float-label-edit-mode[_ngcontent-%COMP%]   .ex-float-label-edit-mode-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.ex-float-label-edit-mode[_ngcontent-%COMP%]   .ex-float-label-edit-mode-header[_ngcontent-%COMP%]   .ex-float-label-edit-mode-header-title[_ngcontent-%COMP%]{margin-left:10px;color:#6481b5}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatLabelComponent, [{
        type: Component,
        args: [{ selector: 'ex-float-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ex-inline-editing class=\"inline-editing\" [(editMode)]=\"editMode\" (editModeChange)=\"onEditModeChanged($event)\"\n  [isSingleSave]=\"false\" [showEditIcon]=\"showEditIcon\" [editTitle]=\"editTitle\"\n  [editTitleIcon]=\"{ 'name': editIconType, 'type': 'uxf' }\" (closeClicked)=\"onCloseClicked()\"\n  [viewBackgroundColor]=\"backgroundColor\" editBackgroundColor=\"white\">\n  <ng-container *viewModeComponent>\n    <ng-container *ngTemplateOutlet=\"viewModeTemplate; context: context\">\n    </ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"this.editModeTemplate\">\n    <ng-container *editModeComponent>\n      <ng-container *ngTemplateOutlet=\"editModeTemplate; context: context\">\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</ex-inline-editing>", styles: [".float-label-info-wrapper{width:100%;position:relative;display:flex;flex-direction:row;margin-left:5px;margin-bottom:5px}.float-label-info-wrapper.float-label-info-wrapper-focus-border{border:2px solid #1079b3!important}.float-label-info-wrapper.float-label-info-wrapper-no-focus-border{border:2px solid transparent!important}.float-label-info-edit-button{position:absolute;width:70%;height:100%;background:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end;top:0;right:30%}.float-label-info-edit-button i{margin-top:5px;margin-right:5px}.inline-editing{border-radius:inherit}.inline-editing ::ng-deep .ex-inline-editing-view-mode{border-radius:inherit;padding:0}.float-label-info-delete-button{position:absolute;bottom:10px;right:10px;color:#4164a4!important;background-color:transparent;border:0;outline:none;min-width:16px;flex-direction:column;align-items:flex-end}.float-label-edit-close-button{position:absolute;top:10px;right:0}.timeline-entry-edit-close-button{position:absolute;top:10px;right:10px}.ex-combobox-chip-label{justify-content:space-between;padding-right:5px;padding-left:5px;margin:5px 0 5px 5px;cursor:pointer!important}.ex-combobox-chip-label-readonly{padding-right:5px!important;padding-left:5px!important;margin:5px!important}.ex-combobox-selected-remove{margin-bottom:4px}.ex-float-label-edit-mode{border:2px solid #1079b3;background:#fff;padding:15px}.ex-float-label-edit-mode .ex-float-label-edit-click{cursor:pointer}.ex-float-label-edit-mode .ex-float-label-edit-mode-header{display:flex;justify-content:space-between}.ex-float-label-edit-mode .ex-float-label-edit-mode-header .ex-float-label-edit-mode-header-title{margin-left:10px;color:#6481b5}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { hasDelete: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }] }); })();

function ExFloatLabelViewComponent_ex_close_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 2);
    i0.ɵɵlistener("click", function ExFloatLabelViewComponent_ex_close_3_Template_ex_close_click_0_listener($event) { return $event.stopPropagation(); })("closeClicked", function ExFloatLabelViewComponent_ex_close_3_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.remove()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.remove") + " " + ctx_r0.getData());
} }
class ExFloatLabelViewComponent {
    constructor() {
        /**
        * indicates if there is an option to delete from edit mode
        */
        this.hasDelete = false;
        /*
          * this event fires whenever the label removed
        */
        this.floatLabelRemoved = new EventEmitter();
    }
    remove() {
        this.floatLabelRemoved.emit();
    }
    getData() {
        if (this.data) {
            if (typeof this.data === 'string')
                return this.data;
            return this.data.value;
        }
    }
    static { this.ɵfac = function ExFloatLabelViewComponent_Factory(t) { return new (t || ExFloatLabelViewComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFloatLabelViewComponent, selectors: [["ex-float-label-view"]], inputs: { data: "data", hasDelete: "hasDelete" }, outputs: { floatLabelRemoved: "floatLabelRemoved" }, decls: 4, vars: 2, consts: [[1, "ex-combobox-chip-label"], ["class", "ex-combobox-selected-remove", "size", "small", 3, "tooltip", "click", "closeClicked", 4, "ngIf"], ["size", "small", 1, "ex-combobox-selected-remove", 3, "tooltip", "click", "closeClicked"]], template: function ExFloatLabelViewComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, ExFloatLabelViewComponent_ex_close_3_Template, 2, 3, "ex-close", 1);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.getData());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasDelete);
        } }, dependencies: [i1$5.NgIf, ExCloseComponent, i1$2.TranslatePipe], styles: [".ex-combobox-chip-label[_ngcontent-%COMP%]{justify-content:space-between;line-height:13px;overflow-wrap:anywhere}.ex-combobox-selected-remove[_ngcontent-%COMP%]{display:inline-block}.ex-combobox-selected-remove[_ngcontent-%COMP%]     .ex-close{padding:0}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatLabelViewComponent, [{
        type: Component,
        args: [{ selector: 'ex-float-label-view', template: "<label class=\"ex-combobox-chip-label\">\n  <span>{{ getData() }}</span>\n</label>\n<ex-close *ngIf=\"hasDelete\" class=\"ex-combobox-selected-remove\" size=\"small\" (click)=\"$event.stopPropagation()\"\n  (closeClicked)=\"remove()\" [tooltip]='(\"ng.general.remove\" | translate) + \" \" + getData()'></ex-close>", styles: [".ex-combobox-chip-label{justify-content:space-between;line-height:13px;overflow-wrap:anywhere}.ex-combobox-selected-remove{display:inline-block}.ex-combobox-selected-remove ::ng-deep .ex-close{padding:0}\n"] }]
    }], null, { data: [{
            type: Input
        }], hasDelete: [{
            type: Input
        }], floatLabelRemoved: [{
            type: Output
        }] }); })();

const _c0$I = function (a0) { return { "background": a0 }; };
function ExFloatLabelsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "ex-float-label", 5);
    i0.ɵɵlistener("editModeChanged", function ExFloatLabelsComponent_div_1_Template_ex_float_label_editModeChanged_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onEditModeChanged($event)); })("close", function ExFloatLabelsComponent_div_1_Template_ex_float_label_close_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const i_r5 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onEntryClosed($event, i_r5)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const entry_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const isLast_r6 = ctx.last;
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(10, _c0$I, ctx_r0.backgroundColor));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("entry", entry_r4)("editMode", ctx_r0.isEditMode(entry_r4, isLast_r6))("hasDelete", ctx_r0.hasDelete)("editModeTemplate", ctx_r0.editModeTemplate)("viewModeTemplate", _r2)("index", i_r5)("backgroundColor", ctx_r0.backgroundColor)("editTitle", entry_r4.isNew ? ctx_r0.editTitleNew : ctx_r0.editTitleEdit)("editIconType", entry_r4.isNew ? ctx_r0.editIconTypeNew : ctx_r0.editIconTypeEdit);
} }
function ExFloatLabelsComponent_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 6);
    i0.ɵɵlistener("click", function ExFloatLabelsComponent_ex_button_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.addEntry()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("margin-top", ctx_r1.entries.length > 0 ? 5 : 10, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r1.addButtonLabel), "\n");
} }
function ExFloatLabelsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-float-label-view", 7);
    i0.ɵɵlistener("floatLabelRemoved", function ExFloatLabelsComponent_ng_template_3_Template_ex_float_label_view_floatLabelRemoved_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const index_r13 = restoredCtx.index; const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onEntryRemoved(index_r13)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const label_r12 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", label_r12)("hasDelete", ctx_r3.hasDelete);
} }
class ExFloatLabelsComponent extends TrackedEditableEntryListComponent {
    constructor() {
        super(...arguments);
        /**
         * indicates if the input/textarea is in read only mode
        */
        this.hasDelete = false;
        /**
         * background color
         */
        this.backgroundColor = "#f2f2f2";
        /**
         * this event fires whenever the label removed
         */
        this.floatLabelRemoved = new EventEmitter();
        /**
         * this event fires whenever new label added
         */
        this.floatLabelAdded = new EventEmitter();
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExFloatLabelsComponent_BaseFactory; return function ExFloatLabelsComponent_Factory(t) { return (ɵExFloatLabelsComponent_BaseFactory || (ɵExFloatLabelsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExFloatLabelsComponent)))(t || ExFloatLabelsComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFloatLabelsComponent, selectors: [["ex-float-labels"]], hostBindings: function ExFloatLabelsComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("add", function ExFloatLabelsComponent_add_HostBindingHandler($event) { return ctx.floatLabelAdded.emit($event); })("remove", function ExFloatLabelsComponent_remove_HostBindingHandler($event) { return ctx.floatLabelRemoved.emit($event); });
        } }, inputs: { hasDelete: "hasDelete", backgroundColor: "backgroundColor", editComponent: "editComponent", editInputs: "editInputs", editDetailsComponent: "editDetailsComponent" }, outputs: { floatLabelRemoved: "floatLabelRemoved", floatLabelAdded: "floatLabelAdded" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [["role", "list", 1, "labels-wrapper"], ["class", "ex-combobox-selected-chip-wrapper", "role", "listitem", 3, "ngStyle", 4, "ngFor", "ngForOf"], ["type", "add", "iconSide", "left", 3, "margin-top", "click", 4, "ngIf"], ["viewMode", ""], ["role", "listitem", 1, "ex-combobox-selected-chip-wrapper", 3, "ngStyle"], [1, "selected-label", 3, "entry", "editMode", "hasDelete", "editModeTemplate", "viewModeTemplate", "index", "backgroundColor", "editTitle", "editIconType", "editModeChanged", "close"], ["type", "add", "iconSide", "left", 3, "click"], [1, "ex-float-labels-view", 3, "data", "hasDelete", "floatLabelRemoved"]], template: function ExFloatLabelsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExFloatLabelsComponent_div_1_Template, 2, 12, "div", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, ExFloatLabelsComponent_ex_button_2_Template, 3, 5, "ex-button", 2);
            i0.ɵɵtemplate(3, ExFloatLabelsComponent_ng_template_3_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.entries);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly && (ctx.addButtonLabel == null ? null : ctx.addButtonLabel.length) > 0);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, i1$5.NgStyle, ExButtonComponent, ExFloatLabelComponent, ExFloatLabelViewComponent, i1$2.TranslatePipe], styles: [".ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]{position:relative;display:inline-block;border-radius:20px;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;align-items:center;margin-inline-end:6px;margin-bottom:3px;margin-top:3px;height:fit-content}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]     .uxf-icon{top:0!important}.labels-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}.selected-label[_ngcontent-%COMP%]{border-radius:inherit}.selected-label[_ngcontent-%COMP%]     .inline-editing .ex-inline-editing-view-mode{padding-inline:10px;padding-block:5px}.ex-float-labels-view[_ngcontent-%COMP%]{display:grid;column-gap:6px;align-items:center}.ex-float-labels-view[_ngcontent-%COMP%]     .ex-combobox-selected-remove{grid-column:2/3}.ex-float-labels-view[_ngcontent-%COMP%]     .ex-combobox-chip-label{padding:2.5 px;line-height:20px;margin:0}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatLabelsComponent, [{
        type: Component,
        args: [{ selector: 'ex-float-labels', host: {
                    '(add)': 'floatLabelAdded.emit($event)',
                    '(remove)': 'floatLabelRemoved.emit($event)'
                }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"labels-wrapper\" role=\"list\">\n  <div *ngFor=\"let entry of entries; index as i; last as isLast\" class=\"ex-combobox-selected-chip-wrapper\"\n    [ngStyle]=\"{'background': backgroundColor}\" role=\"listitem\">\n    <ex-float-label class=\"selected-label\" [entry]=\"entry\" [editMode]=\"isEditMode(entry, isLast)\"\n      (editModeChanged)=\"onEditModeChanged($event)\" [hasDelete]=\"hasDelete\" [editModeTemplate]=\"editModeTemplate\"\n      [viewModeTemplate]=\"viewMode\" [index]=\"i\" [backgroundColor]=\"backgroundColor\"\n      [editTitle]=\"entry.isNew ? editTitleNew : editTitleEdit\"\n      [editIconType]=\"entry.isNew ? editIconTypeNew : editIconTypeEdit\" (close)=\"onEntryClosed($event,i)\">\n    </ex-float-label>\n  </div>\n</div>\n<ex-button [style.margin-top.px]=\"entries.length > 0 ? 5 : 10\" type=\"add\" iconSide=\"left\"\n  *ngIf=\"!isReadOnly && addButtonLabel?.length > 0\" (click)=\"addEntry()\">\n  {{ addButtonLabel | translate }}\n</ex-button>\n\n<ng-template #viewMode let-label let-index=\"index\">\n  <ex-float-label-view class=\"ex-float-labels-view\" (floatLabelRemoved)=\"onEntryRemoved(index)\" [data]=\"label\" [hasDelete]=\"hasDelete\">\n  </ex-float-label-view>\n</ng-template>", styles: [".ex-combobox-selected-chip-wrapper{position:relative;display:inline-block;border-radius:20px;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;align-items:center;margin-inline-end:6px;margin-bottom:3px;margin-top:3px;height:fit-content}.ex-combobox-selected-chip-wrapper ::ng-deep .uxf-icon{top:0!important}.labels-wrapper{display:flex;flex-direction:row;flex-wrap:wrap}.selected-label{border-radius:inherit}.selected-label ::ng-deep .inline-editing .ex-inline-editing-view-mode{padding-inline:10px;padding-block:5px}.ex-float-labels-view{display:grid;column-gap:6px;align-items:center}.ex-float-labels-view ::ng-deep .ex-combobox-selected-remove{grid-column:2/3}.ex-float-labels-view ::ng-deep .ex-combobox-chip-label{padding:2.5 px;line-height:20px;margin:0}\n"] }]
    }], null, { hasDelete: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], editComponent: [{
            type: Input
        }], editInputs: [{
            type: Input
        }], editDetailsComponent: [{
            type: Input
        }], floatLabelRemoved: [{
            type: Output
        }], floatLabelAdded: [{
            type: Output
        }] }); })();

class ExFloatLabelsModule {
    static { this.ɵfac = function ExFloatLabelsModule_Factory(t) { return new (t || ExFloatLabelsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFloatLabelsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            TranslateModule,
            ExSpinnerModule,
            ExButtonModule,
            ExCloseModule,
            ExComponentLoaderModule,
            ExDirectivesModule,
            ExIconModule,
            ExInlineEditingModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFloatLabelsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    TranslateModule,
                    ExSpinnerModule,
                    ExButtonModule,
                    ExCloseModule,
                    ExComponentLoaderModule,
                    ExDirectivesModule,
                    ExIconModule,
                    ExInlineEditingModule
                ],
                declarations: [
                    ExFloatLabelsComponent,
                    ExFloatLabelComponent,
                    ExFloatLabelViewComponent
                ],
                exports: [
                    ExFloatLabelsComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFloatLabelsModule, { declarations: [ExFloatLabelsComponent,
        ExFloatLabelComponent,
        ExFloatLabelViewComponent], imports: [CommonModule,
        MatTooltipModule,
        TranslateModule,
        ExSpinnerModule,
        ExButtonModule,
        ExCloseModule,
        ExComponentLoaderModule,
        ExDirectivesModule,
        ExIconModule,
        ExInlineEditingModule], exports: [ExFloatLabelsComponent] }); })();

class FlatPipe {
    transform(selectedItems) {
        let flattenedArray = [];
        this.transformValue(selectedItems, flattenedArray);
        flattenedArray.sort((previousValue, currentValue) => previousValue.ind > currentValue.ind ? 1 : -1);
        return flattenedArray;
    }
    transformValue(selectedItems, flattenedArray) {
        selectedItems?.forEach(item => {
            if (item.subItems && item.subItems.length > 0) {
                this.transformValue(item.subItems, flattenedArray);
            }
            else {
                if (item.father)
                    item.value = item.value.concat(` (${item.father})`);
                flattenedArray.push(item);
            }
        });
        return flattenedArray;
    }
    static { this.ɵfac = function FlatPipe_Factory(t) { return new (t || FlatPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "flat", type: FlatPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FlatPipe, [{
        type: Pipe,
        args: [{ name: 'flat' }]
    }], null, null); })();
class TrimPipe {
    transform(value, args) {
        return value.trim();
    }
    static { this.ɵfac = function TrimPipe_Factory(t) { return new (t || TrimPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "trim", type: TrimPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrimPipe, [{
        type: Pipe,
        args: [{
                name: 'trim'
            }]
    }], null, null); })();

const _c0$H = ["wrapper"];
const _c1$r = ["searchInput"];
function ExLabelComboboxComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComboboxComponent_ng_container_4_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c2$j = function (a0) { return { "ex-label-combobox-view-wrapper-readonly": a0 }; };
function ExLabelComboboxComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵlistener("click", function ExLabelComboboxComponent_ng_container_4_ng_container_1_Template_div_click_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.isReadOnly && $event.stopPropagation()); });
    i0.ɵɵtemplate(2, ExLabelComboboxComponent_ng_container_4_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(8);
    const _r9 = i0.ɵɵreference(12);
    const _r16 = i0.ɵɵreference(26);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$j, ctx_r18.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r18.selectedItems && ctx_r18.selectedItems.length > 0 || ctx_r18.hideSelectItemsPlaceholder == true ? ctx_r18.type === "labels" ? _r5 : _r9 : _r16);
} }
function ExLabelComboboxComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_container_4_ng_container_1_Template, 3, 4, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
} }
function ExLabelComboboxComponent_ng_container_5_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComboboxComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵlistener("resized", function ExLabelComboboxComponent_ng_container_5_ng_container_1_Template_div_resized_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); const _r1 = i0.ɵɵreference(2); return i0.ɵɵresetView(ctx_r24.onResized(_r1)); })("focusout", function ExLabelComboboxComponent_ng_container_5_ng_container_1_Template_div_focusout_1_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onFocusout($event)); });
    i0.ɵɵtemplate(2, ExLabelComboboxComponent_ng_container_5_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    const _r7 = i0.ɵɵreference(10);
    const _r5 = i0.ɵɵreference(8);
    const _r9 = i0.ɵɵreference(12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r22.editModeOnly ? _r7 : ctx_r22.type === "labels" ? _r5 : _r9);
} }
function ExLabelComboboxComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_container_5_ng_container_1_Template, 3, 1, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
} }
function ExLabelComboboxComponent_ng_template_7_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-float-labels", 20);
    i0.ɵɵlistener("floatLabelRemoved", function ExLabelComboboxComponent_ng_template_7_ng_container_0_div_1_Template_ex_float_labels_floatLabelRemoved_1_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r31.onItemRemoved(ctx_r31.selectedItems[$event].key)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const transformedItems_r29 = i0.ɵɵnextContext().ngIf;
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-label-combobox-margin-bottom", ctx_r30.editMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hasDelete", ctx_r30.editMode)("readOnly", true)("data", transformedItems_r29)("backgroundColor", ctx_r30.labelsBackgroundColor);
} }
function ExLabelComboboxComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_template_7_ng_container_0_div_1_Template, 2, 6, "div", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const transformedItems_r29 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", transformedItems_r29.length > 0);
} }
function ExLabelComboboxComponent_ng_template_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComboboxComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComboboxComponent_ng_template_7_ng_container_0_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(1, "flat");
    i0.ɵɵpipe(2, "selectedItemsTransform");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExLabelComboboxComponent_ng_template_7_ng_container_4_Template, 1, 0, "ng-container", 0);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpipeBind3(2, 4, ctx_r6.selectedItems, ctx_r6.items, i0.ɵɵpipeBind1(3, 8, ctx_r6.unlistedValueSuffix))));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function ExLabelComboboxComponent_ng_template_9_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComboboxComponent_ng_template_9_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_template_9_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
function ExLabelComboboxComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComboboxComponent_ng_template_9_ng_container_0_Template, 2, 1, "ng-container", 3);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.editMode);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_ex_chip_1_ex_close_3_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 27);
    i0.ɵɵlistener("closeClicked", function ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_ex_chip_1_ex_close_3_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r45); const item_r41 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r43.onItemRemoved(item_r41.key)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.remove") + " " + item_r41.value);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 24)(1, "span", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_ex_chip_1_ex_close_3_Template, 2, 3, "ex-close", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("background", item_r41.color ? item_r41.color : ctx_r40.newChipBackgroundColor)("hasBorder", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r41.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.editMode);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_ex_chip_1_Template, 4, 4, "ex-chip", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const transformedItems_r38 = i0.ɵɵnextContext().ngIf;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-label-combobox-margin-bottom", ctx_r39.editMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", transformedItems_r38);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_template_11_ng_container_0_div_1_Template, 2, 3, "div", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const transformedItems_r38 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (transformedItems_r38 == null ? null : transformedItems_r38.length) > 0);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLabelComboboxComponent_ng_template_11_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLabelComboboxComponent_ng_template_11_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
function ExLabelComboboxComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComboboxComponent_ng_template_11_ng_container_0_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(1, "flat");
    i0.ɵɵpipe(2, "selectedItemsTransform");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExLabelComboboxComponent_ng_template_11_ng_container_4_Template, 2, 1, "ng-container", 3);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpipeBind3(2, 4, ctx_r10.selectedItems, ctx_r10.items, i0.ɵɵpipeBind1(3, 8, ctx_r10.unlistedValueSuffix))));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r10.editModeOnly && !ctx_r10.viewModeOnly && ctx_r10.editMode);
} }
const _c3$g = function () { return { standalone: true }; };
function ExLabelComboboxComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "ex-svg-icon", 29);
    i0.ɵɵelementStart(2, "input", 30, 31);
    i0.ɵɵlistener("ngModelChange", function ExLabelComboboxComponent_ng_template_13_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r50._searchTextChange($event)); })("keydown", function ExLabelComboboxComponent_ng_template_13_Template_input_keydown_2_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r52.keydownSearch($event)); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tooltip", ctx_r12.searchLabel)("ariaLabel", ctx_r12.searchLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 6, ctx_r12.placeholder))("ngModel", ctx_r12.searchText)("ngModelOptions", i0.ɵɵpureFunction0(8, _c3$g))("disabled", ctx_r12.searchLoading);
} }
function ExLabelComboboxComponent_ng_template_15_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33)(1, "div", 34)(2, "ex-button", 35);
    i0.ɵɵlistener("click", function ExLabelComboboxComponent_ng_template_15_div_0_Template_ex_button_click_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r54.save()); });
    i0.ɵɵelement(3, "ex-svg-icon", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ex-button", 37);
    i0.ɵɵlistener("click", function ExLabelComboboxComponent_ng_template_15_div_0_Template_ex_button_click_4_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r56.cancel($event)); });
    i0.ɵɵelement(5, "ex-svg-icon", 38);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", ctx_r53.menuWidth + ctx_r53.buttonsSize, "px");
} }
function ExLabelComboboxComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExLabelComboboxComponent_ng_template_15_div_0_Template, 6, 2, "div", 32);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r14.editMode);
} }
const _c4$d = function (a0) { return { "ex-label-combobox-selected-items-placeholder-readonly": a0 }; };
function ExLabelComboboxComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "i", 40);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4$d, ctx_r17.isReadOnly));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, ctx_r17.selectItemsPlaceholderLabel), " ");
} }
const _c5$a = function (a0) { return { "ex-label-combobox-wrapper-readonly": a0 }; };
class ExLabelComboboxComponent extends ExGenericCombobox {
    constructor() {
        super(...arguments);
        /**
         * Background color for all labels
         */
        this.labelsBackgroundColor = "#efebe9";
        /**
         * Background color for new chips
         */
        this.newChipBackgroundColor = "#757575";
        /**
         * Type of "labels" which can be chips (ex-chip) or labels (ex-labels)
         */
        this.type = "labels";
        /**
         * if the component is in edit mode or not
         */
        this.editMode = false;
        /**
         * The text for the button displayed when there are no selected labels
         */
        this.selectItemsPlaceholderLabel = "ng.general.add";
        /**
         * whether to display the 'add' button/placeholder when there are no selected labels
         * TEMPORARY INPUT for backward compatibility. Will be removed.
         */
        this.hideSelectItemsPlaceholder = false;
        /**
         * in case the component is shown in view mode but emit on click.
         * used for hep-entity-labels components only.
         */
        this.viewModeOnly = false;
        /**
         * in case the component is shown in edit mode only, without view mode.
         * used for hep-entity-labels components only.
         */
        this.editModeOnly = false;
        /**
         * event fired whenever the user clicks on the save button or outside the component
         */
        this.saved = new EventEmitter();
        /**
         * event fired whenever the cancel button is clicked
         */
        this.canceled = new EventEmitter();
        /**
         * event fired whenever the component pass from edit to view or from view to edit
         */
        this.editModeChange = new EventEmitter();
        this.searchLabel = "ng.accessibility.search-btn";
        this.buttonsSize = 110;
    }
    ngOnInit() {
        this._isMultiSelect = true;
    }
    ngAfterViewInit() {
        if (this.editMode && !this.editModeOnly) {
            this.menuTrigger.openMenu();
        }
    }
    ngOnChanges(change) {
        if (change.hasOwnProperty('selectedItems')) {
            this.initialItems = this.selectedItems;
        }
        if (change.hasOwnProperty('editMode') && !this.editModeOnly) {
            if (!change.editMode.previousValue && change.editMode.currentValue) {
                this.menuTrigger?.openMenu();
            }
        }
    }
    onResized(wrapper) {
        this.menuWidth = wrapper.editModeWrapper?.nativeElement.offsetWidth - (!this.editModeOnly && !this.viewModeOnly ? this.buttonsSize : 0);
        this.changeDetectorRef.detectChanges();
    }
    onEdit() {
        if (this.viewModeOnly)
            return;
        this.search.changes.pipe(take$1(1)).subscribe(() => {
            this.focusSearch();
        });
        this.onBlur();
    }
    save() {
        this.saveChanges();
        this.saved.emit(this.selectedItems);
        this.editMode = false;
        this.searchText = '';
        this.initialItems = this.selectedItems;
        this.onBlur();
        this.menuTrigger?.closeMenu();
    }
    cancel(event) {
        event.stopPropagation();
        this.canceled.emit();
        this.editMode = false;
        this.searchText = '';
        this.onBlur();
        this.selectedItems = this.initialItems;
        this.menuTrigger?.closeMenu();
    }
    onItemRemoved(key) {
        this.itemRemoved(key, this.editModeOnly);
        this.focusSearch();
    }
    focusSearch() {
        this.search?.first?.nativeElement?.focus();
    }
    onMenuClosed() {
        super.onMenuClosed();
        this.focusSearch();
    }
    selectInputText() {
        this.search?.first?.nativeElement?.select();
    }
    keydownSearch(event) {
        this.onSearchKeyDown(event);
        this._onKeydown(event);
    }
    _onKeydown(event) {
        switch (event.code) {
            case "Enter":
                if (this.searchText.trim() === '') {
                    this.save();
                    this.menuTrigger.closeMenu();
                    this.changeDetectorRef.detectChanges();
                    break;
                }
                if (this.allowUnlistedValues) {
                    this._itemAdded({ key: this.searchText.trim(), value: this.searchText }, this.editModeOnly);
                    this.selectInputText();
                    this.changeDetectorRef.detectChanges();
                }
                break;
            case "Tab":
                this.menuTrigger.closeMenu();
                this.changeDetectorRef.detectChanges();
                break;
            case "Escape":
                if (this.menuTrigger.menuOpen) {
                    this.menuTrigger.closeMenu();
                    this.changeDetectorRef.detectChanges();
                }
                else
                    this.save();
                this.changeDetectorRef.detectChanges();
                break;
            default:
                break;
        }
    }
    onFocusout(event) {
        if (this.editModeOnly)
            return;
        if (!event.relatedTarget || this._isMenuOpened() || this._buttonClicked(event) || this._clickedInside(event))
            return;
        this.save();
    }
    _isMenuOpened() {
        return document.querySelector('.ex-label-combobox-menu-backdrop');
    }
    _buttonClicked(event) {
        return event.relatedTarget.parentElement.id === 'cancel' || event.relatedTarget.parentElement.id === 'save';
    }
    _clickedInside(event) {
        return event.currentTarget.contains(event.relatedTarget);
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExLabelComboboxComponent_BaseFactory; return function ExLabelComboboxComponent_Factory(t) { return (ɵExLabelComboboxComponent_BaseFactory || (ɵExLabelComboboxComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExLabelComboboxComponent)))(t || ExLabelComboboxComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLabelComboboxComponent, selectors: [["ex-label-combobox"]], viewQuery: function ExLabelComboboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$H, 5);
            i0.ɵɵviewQuery(_c1$r, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.search = _t);
        } }, hostBindings: function ExLabelComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedItemsChange", function ExLabelComboboxComponent_selectedItemsChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExLabelComboboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { labelsBackgroundColor: "labelsBackgroundColor", newChipBackgroundColor: "newChipBackgroundColor", type: "type", editMode: "editMode", selectItemsPlaceholderLabel: "selectItemsPlaceholderLabel", hideSelectItemsPlaceholder: "hideSelectItemsPlaceholder", viewModeOnly: "viewModeOnly", editModeOnly: "editModeOnly" }, outputs: { saved: "saved", canceled: "canceled", editModeChange: "editModeChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExLabelComboboxComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 27, vars: 36, consts: [[4, "ngTemplateOutlet"], [1, "ex-label-combobox-wrapper", 3, "displayClose", "ngClass", "exFocus", "isSingleSave", "editMode", "readOnly", "displayAlwaysEditIcon", "editIconTooltip", "activeWithoutEdit", "matMenuTriggerFor", "editClicked", "exFocusChange", "editModeChange", "menuOpened", "menuClosed"], ["wrapper", "", "menuTrigger", "matMenuTrigger"], [4, "ngIf"], [3, "ngTemplateOutlet"], ["labels", ""], ["searchContainer", ""], ["chips", ""], ["search", ""], ["buttons", ""], ["backdropClass", "ex-label-combobox-menu-backdrop", 1, "ex-label-combobox-menu-wrapper"], ["menu", "matMenu"], ["role", "listbox", 1, "ex-label-combobox-menu", 3, "keydown"], [3, "items", "searchText", "hasSelectAll", "isMultiSelect", "selectedItems", "unlistedValueSuffix", "allowSingleSelectionInGroup", "isCheckboxStandaloneInLeaf", "leafClicked", "itemAdded", "itemRemoved", "lastIndexChanged", "itemsAdded", "itemsRemoved"], ["selectedItemsPlaceholder", ""], [4, "viewModeComponent"], [1, "ex-label-combobox-view-wrapper", 3, "ngClass", "click"], [4, "editModeComponent"], ["tabindex", "0", 1, "ex-label-combobox-edit-wrapper", 3, "resized", "focusout"], [3, "ex-label-combobox-margin-bottom", 4, "ngIf"], [1, "sel-ex-label-combobox-labels", 3, "hasDelete", "readOnly", "data", "backgroundColor", "floatLabelRemoved"], ["class", "ex-label-combobox-chips-wrapper", "role", "list", 3, "ex-label-combobox-margin-bottom", 4, "ngIf"], ["role", "list", 1, "ex-label-combobox-chips-wrapper"], ["class", "sel-ex-label-combobox-chip ex-label-combobox-chip", "fontColor", "white", "size", "small", "role", "listitem", 3, "background", "hasBorder", 4, "ngFor", "ngForOf"], ["fontColor", "white", "size", "small", "role", "listitem", 1, "sel-ex-label-combobox-chip", "ex-label-combobox-chip", 3, "background", "hasBorder"], ["text", ""], ["icon-right", "", "class", "sel-ex-label-combobox-remove-chip ex-label-combobox-remove-chip", "size", "small", 3, "tooltip", "closeClicked", 4, "ngIf"], ["icon-right", "", "size", "small", 1, "sel-ex-label-combobox-remove-chip", "ex-label-combobox-remove-chip", 3, "tooltip", "closeClicked"], [1, "ex-label-combobox-search-wrapper"], ["iconName", "search", "color", "#555", "iconSize", "small", 1, "ex-label-combobox-search-svg", 3, "tooltip", "ariaLabel"], ["id", "search", "exFormAriaAttributes", "", "autocomplete", "off", 1, "ex-label-combobox-search", 3, "placeholder", "ngModel", "ngModelOptions", "disabled", "ngModelChange", "keydown"], ["searchInput", ""], ["class", "ex-label-combobox-editing-buttons-wrapper", 3, "width", 4, "ngIf"], [1, "ex-label-combobox-editing-buttons-wrapper"], [1, "ex-label-combobox-editing-buttons"], ["id", "save", "tooltip", "ng.general.save", "ariaLabel", "ng.general.save", 1, "sel-ex-label-combobox-save-button", "ex-label-combobox-button", 3, "click"], ["iconName", "check", "ariaLabel", "ng.general.save", "color", "#50B039", "iconSize", "small"], ["id", "cancel", "tooltip", "ng.general.cancel", "ariaLabel", "ng.general.cancel", 1, "ex-label-combobox-button-btn", "sel-ex-label-combobox-close-button", 3, "click"], ["iconName", "close", "ariaLabel", "ng.general.cancel", "color", "#1079b3", "iconSize", "small"], [1, "ex-label-combobox-selected-items-placeholder", 3, "ngClass"], [1, "uxf-plus-circle"]], template: function ExLabelComboboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExLabelComboboxComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
            i0.ɵɵelementStart(1, "ex-inline-editing", 1, 2);
            i0.ɵɵlistener("editClicked", function ExLabelComboboxComponent_Template_ex_inline_editing_editClicked_1_listener() { return ctx.onEdit(); })("exFocusChange", function ExLabelComboboxComponent_Template_ex_inline_editing_exFocusChange_1_listener($event) { return ctx.isFieldFocused = $event; })("editModeChange", function ExLabelComboboxComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.editMode = $event; })("editModeChange", function ExLabelComboboxComponent_Template_ex_inline_editing_editModeChange_1_listener($event) { return ctx.editModeChange.emit($event); })("menuOpened", function ExLabelComboboxComponent_Template_ex_inline_editing_menuOpened_1_listener() { return ctx.focusSearch(); })("menuClosed", function ExLabelComboboxComponent_Template_ex_inline_editing_menuClosed_1_listener() { return ctx.onMenuClosed(); });
            i0.ɵɵtemplate(4, ExLabelComboboxComponent_ng_container_4_Template, 2, 0, "ng-container", 3);
            i0.ɵɵtemplate(5, ExLabelComboboxComponent_ng_container_5_Template, 2, 0, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainer(6, 4);
            i0.ɵɵtemplate(7, ExLabelComboboxComponent_ng_template_7_Template, 5, 10, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, ExLabelComboboxComponent_ng_template_9_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(11, ExLabelComboboxComponent_ng_template_11_Template, 5, 10, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(13, ExLabelComboboxComponent_ng_template_13_Template, 5, 9, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(15, ExLabelComboboxComponent_ng_template_15_Template, 1, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(17, "mat-menu", 10, 11)(19, "div", 12);
            i0.ɵɵlistener("keydown", function ExLabelComboboxComponent_Template_div_keydown_19_listener($event) { return ctx.onMenuKeyDown($event); });
            i0.ɵɵelementStart(20, "ex-group-outlet-2", 13);
            i0.ɵɵlistener("leafClicked", function ExLabelComboboxComponent_Template_ex_group_outlet_2_leafClicked_20_listener($event) { return $event ? ctx.selectInputText() : null; })("itemAdded", function ExLabelComboboxComponent_Template_ex_group_outlet_2_itemAdded_20_listener($event) { return ctx._itemAdded($event, ctx.editModeOnly); })("itemRemoved", function ExLabelComboboxComponent_Template_ex_group_outlet_2_itemRemoved_20_listener($event) { return ctx.itemRemoved($event, ctx.editModeOnly); })("lastIndexChanged", function ExLabelComboboxComponent_Template_ex_group_outlet_2_lastIndexChanged_20_listener($event) { return ctx.lastIndexChanged($event); })("itemsAdded", function ExLabelComboboxComponent_Template_ex_group_outlet_2_itemsAdded_20_listener($event) { return ctx.itemsAdded($event, ctx.editModeOnly); })("itemsRemoved", function ExLabelComboboxComponent_Template_ex_group_outlet_2_itemsRemoved_20_listener($event) { return ctx.itemsRemoved($event, ctx.editModeOnly); });
            i0.ɵɵpipe(21, "filterItems");
            i0.ɵɵpipe(22, "trim");
            i0.ɵɵpipe(23, "trim");
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(25, ExLabelComboboxComponent_ng_template_25_Template, 5, 6, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r9 = i0.ɵɵreference(12);
            const _r13 = i0.ɵɵreference(16);
            const _r15 = i0.ɵɵreference(18);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.editModeOnly && ctx.editMode && ctx.type === "chips" ? _r9 : undefined);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("displayClose", false)("ngClass", i0.ɵɵpureFunction1(34, _c5$a, ctx.isReadOnly))("exFocus", ctx.isFieldFocused)("isSingleSave", false)("editMode", ctx.editMode)("readOnly", ctx.readOnly)("displayAlwaysEditIcon", !ctx.readOnly && ctx.viewModeOnly)("editIconTooltip", "ng.general.entity_labels.edit_labels")("activeWithoutEdit", !ctx.readOnly && ctx.viewModeOnly)("matMenuTriggerFor", ctx.viewModeOnly ? null : _r15);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.editModeOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isReadOnly && !ctx.viewModeOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngTemplateOutlet", !ctx.editModeOnly && !ctx.viewModeOnly && _r13);
            i0.ɵɵadvance(13);
            i0.ɵɵstyleProp("width", ctx.menuWidth, "px");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("items", ctx.searchTextChanged() ? ctx.externalFiltering ? ctx.items : i0.ɵɵpipeBind3(21, 24, ctx.items, i0.ɵɵpipeBind1(22, 28, ctx.searchText), ctx.allowUnlistedValues) : null)("searchText", i0.ɵɵpipeBind1(23, 30, ctx.searchText))("hasSelectAll", ctx.hasSelectAll)("isMultiSelect", ctx._isMultiSelect)("selectedItems", ctx.selectedItems)("unlistedValueSuffix", i0.ɵɵpipeBind1(24, 32, ctx.unlistedValueSuffix))("allowSingleSelectionInGroup", ctx.allowSingleSelectionInGroup)("isCheckboxStandaloneInLeaf", ctx.editModeOnly);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ResizedDirective, i3$1.MatMenu, i3$1.MatMenuTrigger, ExChipComponent, EditModeComponentDirective, ViewModeComponentDirective, ExFocusDirective, ExFormAriaAttributesDirective, ExInlineEditingComponent, ExCloseComponent, ExSvgIconComponent, ExButtonComponent, ExFloatLabelsComponent, i1$6.DefaultValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, ExGroupOutletComponent2, i1$2.TranslatePipe, FilterItemsPipe, SelectedItemsTransformPipe, FlatPipe, TrimPipe], styles: [".ex-label-combobox-chip-text[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-label-combobox-chip-text[_ngcontent-%COMP%]     .ex-chip-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-label-combobox-remove-chip[_ngcontent-%COMP%]     .ex-close-icon{color:#fff!important}.ex-label-combobox-remove-chip[_ngcontent-%COMP%]     .ex-close{min-height:18px!important}.ex-label-combobox-remove-chip[_ngcontent-%COMP%]     .ex-close-icon-hover{color:#fff!important}.ex-label-combobox-editing-buttons-wrapper[_ngcontent-%COMP%]{position:absolute;display:flex;flex-direction:row-reverse;gap:8px;z-index:1}.ex-label-combobox-editing-buttons-wrapper[_ngcontent-%COMP%]   .ex-label-combobox-editing-buttons[_ngcontent-%COMP%]{display:flex;padding:5px;border-radius:3px;box-shadow:0 3px 6px #6f6f6f7a;background:#fff}.ex-label-combobox-edit-wrapper[_ngcontent-%COMP%]:focus{outline:none}.ex-label-combobox-button[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}.ex-label-combobox-view-label[_ngcontent-%COMP%]{display:flex;flex:1;flex-wrap:wrap}.ex-label-combobox-view-label[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}.ex-label-combobox-menu[_ngcontent-%COMP%]{padding-bottom:5px;max-height:270px;overflow-y:auto;overflow-x:hidden}.ex-label-combobox-wrapper[_ngcontent-%COMP%]     .ex-search-focus{border:none!important}.ex-label-combobox-wrapper[_ngcontent-%COMP%]     .ex-inline-editing-edit-mode{padding:10px!important;width:98%;margin-inline-start:10px!important}.ex-label-combobox-wrapper[_ngcontent-%COMP%]     .ex-inline-editing-view-mode{width:98%;margin-inline-start:10px}.ex-label-combobox-wrapper[_ngcontent-%COMP%]     .ex-close{padding-inline-start:0px!important}.ex-label-combobox-wrapper-readonly[_ngcontent-%COMP%]     .ex-inline-editing-view-mode{border:none!important}.ex-label-combobox-wrapper-readonly[_ngcontent-%COMP%]     .ex-inline-editing-view-mode:hover{border:none!important}.ex-label-combobox-wrapper-readonly[_ngcontent-%COMP%]     .ex-inline-editing-view-mode:focus{border:none!important}.ex-label-combobox-search[_ngcontent-%COMP%]{width:-webkit-fill-available;border:none;outline:none}.ex-label-combobox-search[_ngcontent-%COMP%]:focus{width:-webkit-fill-available;border:none;outline:none}  .ex-label-combobox-menu-wrapper.mat-mdc-menu-panel{max-width:none}.ex-label-combobox-chips-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;margin-inline-start:10px}.ex-label-combobox-chips-wrapper[_ngcontent-%COMP%]     .ex-close{padding-inline-end:0px!important}.ex-label-combobox-chip[_ngcontent-%COMP%]{margin-inline-end:6px;margin-top:1px;margin-bottom:1px}.ex-label-combobox-view-wrapper[_ngcontent-%COMP%]{min-height:20px}.ex-label-combobox-view-wrapper.ex-label-combobox-view-wrapper-readonly[_ngcontent-%COMP%]{margin:-12px;padding:12px}.ex-label-combobox-search-wrapper[_ngcontent-%COMP%]{display:flex}.ex-label-combobox-search-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{direction:unset}.ex-label-combobox-search-svg[_ngcontent-%COMP%]{display:inline-grid;margin-inline-end:5px}.ex-label-combobox-margin-bottom[_ngcontent-%COMP%]{margin-bottom:6px}.ex-label-combobox-selected-items-placeholder[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;width:-moz-fit-content;width:fit-content;color:#4164a4;margin-inline-start:-2px}.ex-label-combobox-selected-items-placeholder[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-inline-end:10px;margin-bottom:2px}.ex-label-combobox-selected-items-placeholder.ex-label-combobox-selected-items-placeholder-readonly[_ngcontent-%COMP%]{color:#d7d7d7}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLabelComboboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-label-combobox', host: {
                    '(selectedItemsChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExLabelComboboxComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngTemplateOutlet=\"editModeOnly && editMode && type === 'chips'? chips: undefined\"></ng-container>\n\n<ex-inline-editing #wrapper class=\"ex-label-combobox-wrapper\" [displayClose]=\"false\" [ngClass]=\"{'ex-label-combobox-wrapper-readonly': isReadOnly}\" (editClicked)=\"onEdit()\"\n                   [(exFocus)]=\"isFieldFocused\" [isSingleSave]=\"false\" [(editMode)]=\"editMode\" [readOnly]=\"readOnly\"\n                   [displayAlwaysEditIcon]=\"!readOnly && viewModeOnly\" [editIconTooltip]=\"'ng.general.entity_labels.edit_labels'\"\n                   (editModeChange)=\"editModeChange.emit($event)\" (menuOpened)=\"focusSearch()\" (menuClosed)=\"onMenuClosed()\"\n                   [activeWithoutEdit]=\"!readOnly && viewModeOnly\" [matMenuTriggerFor]=\"viewModeOnly? null : menu\" #menuTrigger=\"matMenuTrigger\">\n    <ng-container *ngIf=\"!editModeOnly\">\n        <ng-container *viewModeComponent>\n            <div class=\"ex-label-combobox-view-wrapper\" [ngClass]=\"{'ex-label-combobox-view-wrapper-readonly': isReadOnly}\"\n            (click)=\"isReadOnly && $event.stopPropagation()\">\n            <ng-container\n                *ngTemplateOutlet=\"(selectedItems && selectedItems.length > 0) || hideSelectItemsPlaceholder == true ? (type === 'labels'? labels: chips) : selectedItemsPlaceholder\">\n            </ng-container>\n        </div>\n         </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"!isReadOnly && !viewModeOnly\">\n        <ng-container *editModeComponent>\n            <div class=\"ex-label-combobox-edit-wrapper\" tabindex=\"0\" (resized)=\"onResized(wrapper)\"\n                (focusout)=\"onFocusout($event)\">\n                <ng-container *ngTemplateOutlet=\"editModeOnly ? searchContainer : (type === 'labels' ? labels : chips)\"></ng-container> </div>\n        </ng-container>\n    </ng-container>\n</ex-inline-editing>\n<ng-container [ngTemplateOutlet]=\"!editModeOnly && !viewModeOnly && buttons\"></ng-container>\n\n<ng-template #labels>\n    <ng-container\n        *ngIf=\"(selectedItems | selectedItemsTransform : items : (unlistedValueSuffix | translate) | flat) as transformedItems\">\n        <div *ngIf=\"transformedItems.length > 0\" [class.ex-label-combobox-margin-bottom]=\"editMode\">\n            <ex-float-labels class=\"sel-ex-label-combobox-labels\" [hasDelete]=\"editMode\" [readOnly]=\"true\"\n                [data]=\"transformedItems\" [backgroundColor]=\"labelsBackgroundColor\"\n                (floatLabelRemoved)=\"onItemRemoved(this.selectedItems[$event].key)\">\n            </ex-float-labels>\n        </div>\n    </ng-container>\n    <ng-container *ngTemplateOutlet=\"searchContainer\"></ng-container>\n</ng-template>\n\n<ng-template #searchContainer>\n    <ng-container *ngIf=\"editMode\">\n        <ng-container *ngTemplateOutlet=\"search\"></ng-container>\n    </ng-container>\n</ng-template>\n\n<ng-template #chips>\n    <ng-container\n        *ngIf=\"(selectedItems | selectedItemsTransform : items : (unlistedValueSuffix | translate) | flat) as transformedItems\">\n        <div *ngIf=\"transformedItems?.length > 0\" class=\"ex-label-combobox-chips-wrapper\"\n            [class.ex-label-combobox-margin-bottom]=\"editMode\" role=\"list\">\n            <ex-chip *ngFor=\"let item of transformedItems\" class=\"sel-ex-label-combobox-chip ex-label-combobox-chip\"\n                fontColor=\"white\" [background]=\"item.color? item.color: newChipBackgroundColor\" [hasBorder]=\"false\"\n                size=\"small\" role=\"listitem\">\n                <span text>{{ item.value }}</span>\n                <ex-close *ngIf=\"editMode\" icon-right [tooltip]='(\"ng.general.remove\" | translate) + \" \" + item.value'\n                    class=\"sel-ex-label-combobox-remove-chip ex-label-combobox-remove-chip\" size=\"small\"\n                    (closeClicked)=\"onItemRemoved(item.key)\">\n                </ex-close>\n            </ex-chip>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"!editModeOnly && !viewModeOnly && editMode\">\n        <ng-container *ngTemplateOutlet=\"search\"></ng-container>\n    </ng-container>\n\n</ng-template>\n\n<ng-template #search>\n    <div class=\"ex-label-combobox-search-wrapper\">\n        <ex-svg-icon class=\"ex-label-combobox-search-svg\" iconName=\"search\" [tooltip]=\"searchLabel\"\n            [ariaLabel]=\"searchLabel\" color=\"#555\" iconSize=\"small\">\n        </ex-svg-icon>\n        <input id=\"search\" #searchInput class=\"ex-label-combobox-search\" [placeholder]=\"placeholder | translate\"\n            [ngModel]=\"searchText\" [ngModelOptions]=\"{standalone: true}\" (ngModelChange)=\"_searchTextChange($event)\"  [disabled]=\"searchLoading\"\n            (keydown)=\"keydownSearch($event)\" exFormAriaAttributes autocomplete=\"off\">\n    </div>\n</ng-template>\n\n<ng-template #buttons>\n    <div *ngIf=\"editMode\" class=\"ex-label-combobox-editing-buttons-wrapper\" [style.width.px]=\"menuWidth + buttonsSize\">\n        <div class=\"ex-label-combobox-editing-buttons\">\n            <ex-button (click)=\"save()\" id=\"save\" class=\"sel-ex-label-combobox-save-button ex-label-combobox-button\"\n                tooltip=\"ng.general.save\" ariaLabel=\"ng.general.save\">\n                <ex-svg-icon iconName=\"check\" ariaLabel=\"ng.general.save\" color=\"#50B039\" iconSize=\"small\">\n                </ex-svg-icon>\n            </ex-button>\n            <ex-button id=\"cancel\" tooltip=\"ng.general.cancel\" ariaLabel=\"ng.general.cancel\"\n                class=\"ex-label-combobox-button-btn sel-ex-label-combobox-close-button\" (click)=\"cancel($event)\">\n                <ex-svg-icon iconName=\"close\" ariaLabel=\"ng.general.cancel\" color=\"#1079b3\" iconSize=\"small\">\n                </ex-svg-icon>\n            </ex-button>\n        </div>\n    </div>\n</ng-template>\n\n\n<mat-menu #menu=\"matMenu\" class=\"ex-label-combobox-menu-wrapper\" backdropClass=\"ex-label-combobox-menu-backdrop\">\n    <div class=\"ex-label-combobox-menu\" [style.width.px]=\"menuWidth\" role=\"listbox\" (keydown)=\"onMenuKeyDown($event)\">\n        <ex-group-outlet-2\n            [items]=\"searchTextChanged() ? (externalFiltering ? items : (items | filterItems: (searchText | trim): allowUnlistedValues) ): null\"\n            [searchText]=\"searchText | trim\" [hasSelectAll]=\"hasSelectAll\" [isMultiSelect]=\"_isMultiSelect\"\n            [selectedItems]=\"selectedItems\" [unlistedValueSuffix]=\"unlistedValueSuffix | translate\"\n            (leafClicked)=\"$event ? selectInputText() : null\"\n            [allowSingleSelectionInGroup]=\"allowSingleSelectionInGroup\" (itemAdded)=\"_itemAdded($event,editModeOnly)\"\n            [isCheckboxStandaloneInLeaf]=\"editModeOnly\"\n            (itemRemoved)=\"itemRemoved($event, editModeOnly)\" (lastIndexChanged)=\"lastIndexChanged($event)\"\n            (itemsAdded)=\"itemsAdded($event, editModeOnly)\" (itemsRemoved)=\"itemsRemoved($event, editModeOnly)\">\n        </ex-group-outlet-2>\n    </div>\n</mat-menu>\n\n<ng-template #selectedItemsPlaceholder>\n    <div class=\"ex-label-combobox-selected-items-placeholder\"\n        [ngClass]=\"{ 'ex-label-combobox-selected-items-placeholder-readonly': isReadOnly }\">\n        <i class=\"uxf-plus-circle\"></i>\n        <span> {{ selectItemsPlaceholderLabel | translate }} </span>\n    </div>\n</ng-template>\n", styles: [".ex-label-combobox-chip-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-label-combobox-chip-text ::ng-deep .ex-chip-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-label-combobox-remove-chip ::ng-deep .ex-close-icon{color:#fff!important}.ex-label-combobox-remove-chip ::ng-deep .ex-close{min-height:18px!important}.ex-label-combobox-remove-chip ::ng-deep .ex-close-icon-hover{color:#fff!important}.ex-label-combobox-editing-buttons-wrapper{position:absolute;display:flex;flex-direction:row-reverse;gap:8px;z-index:1}.ex-label-combobox-editing-buttons-wrapper .ex-label-combobox-editing-buttons{display:flex;padding:5px;border-radius:3px;box-shadow:0 3px 6px #6f6f6f7a;background:#fff}.ex-label-combobox-edit-wrapper:focus{outline:none}.ex-label-combobox-button:not(:last-child){margin-right:5px}.ex-label-combobox-view-label{display:flex;flex:1;flex-wrap:wrap}.ex-label-combobox-view-label *:not(:last-child){margin-right:5px}.ex-label-combobox-menu{padding-bottom:5px;max-height:270px;overflow-y:auto;overflow-x:hidden}.ex-label-combobox-wrapper ::ng-deep .ex-search-focus{border:none!important}.ex-label-combobox-wrapper ::ng-deep .ex-inline-editing-edit-mode{padding:10px!important;width:98%;margin-inline-start:10px!important}.ex-label-combobox-wrapper ::ng-deep .ex-inline-editing-view-mode{width:98%;margin-inline-start:10px}.ex-label-combobox-wrapper ::ng-deep .ex-close{padding-inline-start:0px!important}.ex-label-combobox-wrapper-readonly ::ng-deep .ex-inline-editing-view-mode{border:none!important}.ex-label-combobox-wrapper-readonly ::ng-deep .ex-inline-editing-view-mode:hover{border:none!important}.ex-label-combobox-wrapper-readonly ::ng-deep .ex-inline-editing-view-mode:focus{border:none!important}.ex-label-combobox-search{width:-webkit-fill-available;border:none;outline:none}.ex-label-combobox-search:focus{width:-webkit-fill-available;border:none;outline:none}::ng-deep .ex-label-combobox-menu-wrapper.mat-mdc-menu-panel{max-width:none}.ex-label-combobox-chips-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;margin-inline-start:10px}.ex-label-combobox-chips-wrapper ::ng-deep .ex-close{padding-inline-end:0px!important}.ex-label-combobox-chip{margin-inline-end:6px;margin-top:1px;margin-bottom:1px}.ex-label-combobox-view-wrapper{min-height:20px}.ex-label-combobox-view-wrapper.ex-label-combobox-view-wrapper-readonly{margin:-12px;padding:12px}.ex-label-combobox-search-wrapper{display:flex}.ex-label-combobox-search-wrapper input{direction:unset}.ex-label-combobox-search-svg{display:inline-grid;margin-inline-end:5px}.ex-label-combobox-margin-bottom{margin-bottom:6px}.ex-label-combobox-selected-items-placeholder{display:flex;justify-content:center;align-items:center;width:-moz-fit-content;width:fit-content;color:#4164a4;margin-inline-start:-2px}.ex-label-combobox-selected-items-placeholder i{margin-inline-end:10px;margin-bottom:2px}.ex-label-combobox-selected-items-placeholder.ex-label-combobox-selected-items-placeholder-readonly{color:#d7d7d7}\n"] }]
    }], null, { labelsBackgroundColor: [{
            type: Input
        }], newChipBackgroundColor: [{
            type: Input
        }], type: [{
            type: Input
        }], editMode: [{
            type: Input
        }], selectItemsPlaceholderLabel: [{
            type: Input
        }], hideSelectItemsPlaceholder: [{
            type: Input
        }], viewModeOnly: [{
            type: Input
        }], editModeOnly: [{
            type: Input
        }], saved: [{
            type: Output
        }], canceled: [{
            type: Output
        }], editModeChange: [{
            type: Output
        }], search: [{
            type: ViewChildren,
            args: ['searchInput', { read: ElementRef }]
        }], wrapper: [{
            type: ViewChild,
            args: ['wrapper']
        }] }); })();

class ExLabelComboboxModule {
    static { this.ɵfac = function ExLabelComboboxModule_Factory(t) { return new (t || ExLabelComboboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExLabelComboboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            AngularResizeEventModule,
            MatMenuModule,
            MatTooltipModule,
            TranslateModule,
            ExChipModule,
            ExDirectivesModule,
            EXPipesModule,
            ExCheckboxModule,
            ExSearchModule,
            ExInlineEditingModule,
            ExCloseModule,
            ExSvgIconModule,
            ExButtonModule,
            ExFloatLabelsModule,
            FormsModule,
            ExNewComboboxModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLabelComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    AngularResizeEventModule,
                    MatMenuModule,
                    MatTooltipModule,
                    TranslateModule,
                    ExChipModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    ExCheckboxModule,
                    ExSearchModule,
                    ExInlineEditingModule,
                    ExCloseModule,
                    ExSvgIconModule,
                    ExButtonModule,
                    ExFloatLabelsModule,
                    FormsModule,
                    ExNewComboboxModule
                ],
                declarations: [
                    FlatPipe,
                    TrimPipe,
                    ExLabelComboboxComponent
                ],
                exports: [
                    ExLabelComboboxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExLabelComboboxModule, { declarations: [FlatPipe,
        TrimPipe,
        ExLabelComboboxComponent], imports: [CommonModule,
        MatButtonModule,
        AngularResizeEventModule,
        MatMenuModule,
        MatTooltipModule,
        TranslateModule,
        ExChipModule,
        ExDirectivesModule,
        EXPipesModule,
        ExCheckboxModule,
        ExSearchModule,
        ExInlineEditingModule,
        ExCloseModule,
        ExSvgIconModule,
        ExButtonModule,
        ExFloatLabelsModule,
        FormsModule,
        ExNewComboboxModule], exports: [ExLabelComboboxComponent] }); })();

function ExLegendComponent_div_4_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-svg-icon", 8);
    i0.ɵɵlistener("click", function ExLegendComponent_div_4_ex_svg_icon_1_Template_ex_svg_icon_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const icon_r2 = restoredCtx.$implicit; return i0.ɵɵresetView(icon_r2.onClick && icon_r2.onClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r2 = ctx.$implicit;
    i0.ɵɵstyleProp("cursor", icon_r2.onClick ? "pointer" : "default");
    i0.ɵɵproperty("iconName", icon_r2.name)("color", icon_r2.color);
} }
function ExLegendComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ExLegendComponent_div_4_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.icons);
} }
class ExLegendComponent {
    constructor() {
        this.icons = [];
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ExLegendComponent_Factory(t) { return new (t || ExLegendComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLegendComponent, selectors: [["ex-legend"]], inputs: { value: "value", percent: "percent", title: "title", subTitle: "subTitle", description: "description", icons: "icons", color: "color" }, decls: 13, vars: 11, consts: [[1, "ex-legend"], [1, "ex-legend-header"], [1, "ex-legend-title", "ex-legend-title-bold"], ["class", "ex-legend-icons", 4, "ngIf"], [1, "ex-legend-sub-title"], [1, "ex-legend-title-bold"], [1, "ex-legend-icons"], [3, "cursor", "iconName", "color", "click", 4, "ngFor", "ngForOf"], [3, "iconName", "color", "click"]], template: function ExLegendComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExLegendComponent_div_4_Template, 2, 1, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "span", 5);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "number");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵstyleProp("border-left-color", ctx.color);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.icons);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.value, " (", i0.ɵɵpipeBind2(8, 8, ctx.percent, "1.0-2"), "%) ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.subTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.description, " ");
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExSvgIconComponent, i1$5.DecimalPipe], styles: [".ex-legend[_ngcontent-%COMP%]{page-break-inside:avoid;break-inside:avoid;border-left-width:4px;border-left-style:solid;background:#eff5f7;padding:5px 10px;margin-bottom:10px;margin-right:15px}.ex-legend[_ngcontent-%COMP%]   .ex-legend-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.ex-legend[_ngcontent-%COMP%]   .ex-legend-header[_ngcontent-%COMP%]   .ex-legend-icons[_ngcontent-%COMP%]{display:flex;margin-left:5px}.ex-legend[_ngcontent-%COMP%]   .ex-legend-header[_ngcontent-%COMP%]   .ex-legend-icons[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-left:5px}.ex-legend[_ngcontent-%COMP%]   .ex-legend-title[_ngcontent-%COMP%]{color:#4164a4}.ex-legend[_ngcontent-%COMP%]   .ex-legend-sub-title[_ngcontent-%COMP%]{display:flex;margin-bottom:5px;color:#4164a4}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLegendComponent, [{
        type: Component,
        args: [{ selector: 'ex-legend', template: "<div class=\"ex-legend\" [style.border-left-color]=\"color\">\n    <div class=\"ex-legend-header\">\n        <div class=\"ex-legend-title ex-legend-title-bold\">{{ title }}</div>\n        <div *ngIf=\"icons\" class=\"ex-legend-icons\">\n            <ex-svg-icon *ngFor=\"let icon of icons\" [style.cursor]=\"icon.onClick ? 'pointer' : 'default'\"\n                [iconName]=\"icon.name\" [color]=\"icon.color\" (click)=\"icon.onClick && icon.onClick()\">\n            </ex-svg-icon>\n        </div>\n    </div>\n    <div class=\"ex-legend-sub-title\">\n        <span class=\"ex-legend-title-bold\">{{ value }}\n            ({{ percent | number : '1.0-2' }}%) </span>\n        <span>{{ subTitle }}</span>\n    </div>\n    <div>\n        {{ description }}\n    </div>\n</div>", styles: [".ex-legend{page-break-inside:avoid;break-inside:avoid;border-left-width:4px;border-left-style:solid;background:#eff5f7;padding:5px 10px;margin-bottom:10px;margin-right:15px}.ex-legend .ex-legend-header{display:flex;flex-direction:row;justify-content:space-between}.ex-legend .ex-legend-header .ex-legend-icons{display:flex;margin-left:5px}.ex-legend .ex-legend-header .ex-legend-icons ex-icon{margin-left:5px}.ex-legend .ex-legend-title{color:#4164a4}.ex-legend .ex-legend-sub-title{display:flex;margin-bottom:5px;color:#4164a4}\n"] }]
    }], function () { return []; }, { value: [{
            type: Input
        }], percent: [{
            type: Input
        }], title: [{
            type: Input
        }], subTitle: [{
            type: Input
        }], description: [{
            type: Input
        }], icons: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

class ExLegendModule {
    static { this.ɵfac = function ExLegendModule_Factory(t) { return new (t || ExLegendModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExLegendModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLegendModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExLegendComponent
                ],
                exports: [
                    ExLegendComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExLegendModule, { declarations: [ExLegendComponent], imports: [CommonModule,
        ExSvgIconModule], exports: [ExLegendComponent] }); })();

const _c0$G = ["input"];
const _c1$q = ["saveButton"];
const _c2$i = ["menuTrigger"];
function ExMultiselectComboboxComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 18);
    i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_label_1_Template_label_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, ctx_r0.label), ":");
} }
function ExMultiselectComboboxComponent_div_8_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
} if (rf & 2) {
    i0.ɵɵproperty("ngClass", "uxf-plus-circle");
} }
function ExMultiselectComboboxComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_div_8_i_1_Template, 1, 1, "i", 19);
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", "#1079b3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.placeholderIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx_r3.placeholder), "");
} }
const _c3$f = function (a0) { return { "ex-combobox-selected-colored-remove": a0 }; };
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_ex_chip_1_ex_close_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 32);
    i0.ɵɵlistener("closeClicked", function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_ex_chip_1_ex_close_4_Template_ex_close_closeClicked_0_listener($event) { i0.ɵɵrestoreView(_r24); const i_r20 = i0.ɵɵnextContext().index; const ctx_r22 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r22.remove($event, i_r20)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3$f, selected_r19.color));
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 28)(1, "span", 29)(2, "span", 30);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_ex_chip_1_ex_close_4_Template, 1, 3, "ex-close", 31);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selected_r19 = ctx.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("background", selected_r19.color);
    i0.ɵɵproperty("hasBorder", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltip", ctx_r18.getItemLabel(selected_r19));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r18.getItemLabel(selected_r19));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r18.viewMode);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_ex_chip_1_Template, 5, 5, "ex-chip", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r16.currentSelectedValues);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_2_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 34)(1, "span", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selected_r27 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", ctx_r26.getItemLabel(selected_r27))("background", selected_r27.color)("hasBorder", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.getItemLabel(selected_r27));
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_2_ex_chip_1_Template, 3, 4, "ex-chip", 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r17.selectedValues);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 26);
    i0.ɵɵtemplate(2, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.viewMode);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_0_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-float-labels", 37);
    i0.ɵɵlistener("floatLabelRemoved", function ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_0_Template_ex_float_labels_floatLabelRemoved_0_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r31.remove(null, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hasDelete", !ctx_r29.viewMode)("readOnly", true)("data", ctx_r29.currentSelectedValues)("backgroundColor", ctx_r29.labelColor);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-float-labels", 38);
    i0.ɵɵlistener("floatLabelRemoved", function ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_1_Template_ex_float_labels_floatLabelRemoved_0_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r33.floatLabelRemoved.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hasDelete", !ctx_r30.viewMode)("readOnly", true)("data", ctx_r30.selectedValues)("backgroundColor", ctx_r30.labelColor);
} }
function ExMultiselectComboboxComponent_ng_template_9_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_0_Template, 1, 4, "ex-float-labels", 35);
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_ng_template_9_ng_template_3_ex_float_labels_1_Template, 1, 4, "ex-float-labels", 36);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r15.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.viewMode);
} }
function ExMultiselectComboboxComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtemplate(2, ExMultiselectComboboxComponent_ng_template_9_ng_container_2_Template, 3, 2, "ng-container", 24);
    i0.ɵɵtemplate(3, ExMultiselectComboboxComponent_ng_template_9_ng_template_3_Template, 2, 2, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(4);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r5.isFloatLabel)("ngIfElse", _r14);
} }
function ExMultiselectComboboxComponent_ex_search_11_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-search", 39, 40);
    i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_ex_search_11_Template_ex_search_click_0_listener($event) { return $event.stopPropagation(); })("searchTriggered", function ExMultiselectComboboxComponent_ex_search_11_Template_ex_search_searchTriggered_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.searchTextChange($event)); })("keydown", function ExMultiselectComboboxComponent_ex_search_11_Template_ex_search_keydown_0_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r39 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r39.onKeydown($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("incremental", true)("searchText", ctx_r6.searchText);
} }
const _c4$c = function () { return ["uxf-icon uxf-pencil", "edit-clickable"]; };
function ExMultiselectComboboxComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "i", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r7.viewMode && ctx_r7.isHovered && ctx_r7.showEditButton ? "visible" : "hidden");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(3, _c4$c));
} }
const _c5$9 = function () { return ["uxf-icon uxf-check", "ex-close-icon"]; };
function ExMultiselectComboboxComponent_div_13_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46, 47);
    i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_div_13_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.onSaveClicked($event)); })("keydown.tab", function ExMultiselectComboboxComponent_div_13_button_1_Template_button_keydown_tab_0_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.showCloseButton ? ctx_r45.focusCloseButton($event) : ""); });
    i0.ɵɵelement(2, "i", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("color", "#50B039");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(3, _c5$9));
} }
const _c6$9 = function () { return ["uxf-icon uxf-close", "ex-close-icon"]; };
function ExMultiselectComboboxComponent_div_13_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 48);
    i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_div_13_button_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.onCloseClicked($event)); })("keyup.enter", function ExMultiselectComboboxComponent_div_13_button_2_Template_button_keyup_enter_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r48.onCloseClicked($event)); })("keydown", function ExMultiselectComboboxComponent_div_13_button_2_Template_button_keydown_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r49 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r49.onCloseKeydown($event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "i", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "ng.general.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("color", "#1079b3");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(6, _c6$9));
} }
function ExMultiselectComboboxComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_div_13_button_1_Template, 3, 4, "button", 44);
    i0.ɵɵtemplate(2, ExMultiselectComboboxComponent_div_13_button_2_Template, 3, 7, "button", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showSaveButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showCloseButton);
} }
function ExMultiselectComboboxComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_ng_container_20_Template_div_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r53); const i_r51 = restoredCtx.index; const ctx_r52 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r52.selectedValueChanged($event, i_r51)); });
    i0.ɵɵelementStart(2, "span", 50);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r50 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r10.getItemLabel(item_r50));
} }
class ExMultiselectComboboxComponent extends ExControlValueAccessor {
    constructor(translate, sectionLayoutViewModeObservable) {
        super(sectionLayoutViewModeObservable);
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        /**
         * in case of using this component in select use-case these will be the posible items that the user can choose
         */
        this.items = [];
        /**
         * the selected labels
         */
        this.selectedValues = [];
        this.placeholder = '';
        /**
         * when adding label that not exists adding this suffix to the lable for example XXXX(new label)
         */
        this.newItemSuffix = '';
        this.hasBorder = true;
        this.mandatory = false;
        this.viewMode = true;
        this.allowNew = true;
        this.placeholderIcon = false;
        this.showSaveButton = true;
        this.showCloseButton = true;
        this.showEditButton = true;
        /**
         * when this flag is true the labels will display as badge otherwise as chips
         */
        this.isFloatLabel = false;
        /**
         * in case we want to have search option
         */
        this.searchMode = true;
        this.addNew = true;
        this.labelColor = '#959595';
        this.initializeSelectedValues = new EventEmitter();
        this.searchTriggered = new EventEmitter();
        /**
         * this event fires whenever the component save the list (press on V / clickout side / Esc)
         */
        this.endEdit = new EventEmitter();
        /**
         *  this event fires whenever the float label removed
         */
        this.floatLabelRemoved = new EventEmitter();
        this.itemRemoved = new EventEmitter();
        /**
         *  event fired whenever an item inside the dropdown is clicked with the type: ComboboxItemData
         */
        this.selectedValueChange = new EventEmitter();
        this.comboboxTextToolTip = '';
        this.isHovered = false;
        this.searchText = '';
        this.filteredItems = [];
        this.currentSelectedValues = [];
        this.afterCloseEvent = false;
        this.afterRemoveEvent = false;
        this.afterAddNewEvent = false;
        this.showSearchBox = false;
        this.filter = (itemsArray, value) => {
            const filterValue = value.toLowerCase();
            return itemsArray.filter(item => item.itemName.value.toLowerCase().startsWith(filterValue));
        };
        console.warn('the ex-multiselect-combobox component is deprecated please use ex-label-combobox instead');
    }
    ngOnInit() {
        this.initializeSelectedValues.emit(this.currentSelectedValues);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.initItems();
        }
        if (changes.hasOwnProperty('selectedValues')) {
            this.initItems();
            if (this.isFloatLabel) {
                this.initFloatLabels();
            }
        }
    }
    initItems() {
        if (this.items.length > 0) {
            this.filteredItems = this.items.slice();
        }
        if (!this.isFloatLabel) {
            this.initLabelList();
        }
    }
    initFloatLabels() {
        if (this.selectedValues.length > 0) {
            this.currentSelectedValues = this.selectedValues.slice();
        }
    }
    initLabelList() {
        if (this.selectedValues.length > 0) {
            this.currentSelectedValues = this.selectedValues.slice();
            this.currentSelectedValues.forEach(selectedValue => { this.findItemAndRemove(selectedValue); });
        }
    }
    onWrapperClicked() {
        if (!this.viewMode && !this.afterRemoveEvent) {
            this.focus();
        }
        if (this.afterRemoveEvent) {
            this.afterRemoveEvent = false;
        }
    }
    onEditClicked(event) {
        if (this.viewMode == true) {
            this.viewMode = false;
            this.focus();
            event.stopPropagation();
        }
    }
    onSaveClicked(event) {
        this.viewMode = true;
        this.selectedValues = this.currentSelectedValues.slice();
        if (this.searchText && this.searchText !== "" && this.searchText !== " ") {
            this.addNewItem();
        }
        this.selectedValues = this.currentSelectedValues.slice();
        this.endEdit.emit(this.selectedValues);
        this.initItems();
        if (event) {
            event.stopPropagation();
        }
        this.onBlur();
    }
    onCloseClicked(event) {
        this.viewMode = true;
        event.stopPropagation();
        this.onBlur();
    }
    closed() {
        this.afterCloseEvent = true;
        this.focus();
    }
    searchTextChange(text) {
        this.searchText = text;
        if (text && text !== "" && text !== " ") {
            this.filteredItems = this.items.slice();
            let valueIndex = this.filteredItems.map(function (e) { return e.itemName.key; }).indexOf(text);
            this.filteredItems = this.filter(this.filteredItems, text);
            if (!(valueIndex && valueIndex > -1)) {
                let newItem = { itemName: { key: this.searchText, value: (this.searchText) }, color: this.labelColor, isNew: true };
                this.filteredItems.push(newItem);
            }
        }
        else {
            this.filteredItems = this.items.slice();
            this.searchText = "";
            this.currentSelectedValues.forEach(selectedValue => { this.findItemAndRemove(selectedValue); });
        }
        this.searchTriggered.emit(this.searchText);
    }
    selectedValueChanged(event, index) {
        let selectedValue = this.filteredItems[index];
        if (this.isFloatLabel) {
            this.currentSelectedValues.push(selectedValue.itemName);
            this.currentSelectedValues.sort((a, b) => (a.value > b.value) ? 1 : -1);
            this.currentSelectedValues = [...this.currentSelectedValues];
        }
        else {
            this.currentSelectedValues.push(selectedValue);
            this.currentSelectedValues.sort((a, b) => (a.itemName.value > b.itemName.value) ? 1 : -1);
        }
        this.selectedValueChange.emit(selectedValue);
        this.filteredItems.splice(index, 1);
        this.filteredItems.sort((a, b) => (a.itemName.value > b.itemName.value) ? 1 : -1);
        this.focus();
        this.menuTrigger.closeMenu();
        this.searchText = "";
        this.currentSelectedValues.forEach(selectedValue => { this.findItemAndRemove(selectedValue); });
        this.afterCloseEvent = false;
        event.stopPropagation();
    }
    reset() {
        this.searchTextChange('');
    }
    focus() {
        setTimeout(() => {
            this.searchBox.input.nativeElement.focus();
        }, 0);
    }
    findItemAndRemove(selectedValue) {
        if (!selectedValue.itemName?.key)
            return;
        let selectedValueIndex = this.filteredItems.map(function (e) { return e.itemName.key; }).indexOf(selectedValue.itemName.key);
        if (selectedValueIndex && selectedValueIndex > -1) {
            this.filteredItems.splice(selectedValueIndex, 1);
        }
    }
    remove(event, index) {
        let selectedValue = this.currentSelectedValues[index];
        this.filteredItems.push(selectedValue);
        this.filteredItems.sort((a, b) => (a.itemName?.value > b.itemName?.value) ? 1 : -1);
        this.currentSelectedValues.splice(index, 1);
        this.currentSelectedValues.sort((a, b) => (a.itemName?.value > b.itemName?.value) ? 1 : -1);
        this.currentSelectedValues = [...this.currentSelectedValues];
        this.afterRemoveEvent = true;
        this.itemRemoved.emit(index);
    }
    onKeydown(event) {
        if (event.shiftKey && event.code == "Tab") {
            if (this.showCloseButton && this.currentSelectedValues.length == 0) {
                this.focusCloseButton(event);
            }
            return;
        }
        if (event.code == "Tab") {
            this.menuTrigger.closeMenu();
            if (this.showSaveButton) {
                this.focusSaveButton(event);
            }
            return;
        }
        if (event.code === 'Escape') {
            if (this.menuTrigger.menuOpen) {
                this.menuTrigger.closeMenu();
            }
            else {
                this.onSaveClicked();
            }
            return;
        }
        if (this.allowNew && this.searchText && this.searchText !== "") {
            if (event.code === "Enter" || event.code === "Space") {
                this.afterAddNewEvent = true;
                this.addNewItem();
                this.filteredItems = this.items.slice();
                this.searchText = "";
                this.currentSelectedValues.forEach(selectedValue => { this.findItemAndRemove(selectedValue); });
                this.menuTrigger.closeMenu();
                this.focus();
            }
        }
        if (!this.viewMode && !this.afterAddNewEvent && this.searchMode) {
            if (event.code !== "Enter" && event.code !== "Space" && event.code !== "Tab" && event.key !== "Shift") {
                this.menuTrigger.openMenu();
                this.focus();
                if (this.searchText && this.searchText !== "" && this.searchText !== " ") {
                    this.filteredItems = this.items.slice();
                    this.filteredItems = this.filter(this.filteredItems, this.searchText);
                }
            }
        }
        else if (this.afterAddNewEvent) {
            this.afterAddNewEvent = false;
        }
    }
    addNewItem() {
        if (!this.addNew)
            return;
        if (!this.isInList(this.searchText, this.currentSelectedValues)) {
            let newItem;
            this.afterAddNewEvent = true;
            let valueIndex = this.findIndexInList(this.searchText, this.filteredItems);
            if (this.isFloatLabel) {
                newItem = { value: this.searchText };
            }
            else if (valueIndex > -1) {
                newItem = this.filteredItems[valueIndex];
            }
            else {
                newItem = { itemName: { key: this.searchText, value: (this.searchText) }, color: this.labelColor, isNew: true };
            }
            this.currentSelectedValues.push(newItem);
            this.currentSelectedValues = [...this.currentSelectedValues];
            this.selectedValueChange.emit(newItem);
        }
    }
    isInList(searchText, items) {
        return this.findIndexInList(searchText, items) > -1;
    }
    findIndexInList(searchText, items) {
        return items.findIndex(item => this.getItemKey(item) === searchText);
    }
    getItemKey(item) {
        return item.itemName?.key || item.key || item.value;
    }
    getItemLabel(item) {
        if (item.isNew) {
            let suffix = '';
            if (this.newItemSuffix && this.newItemSuffix !== '') {
                suffix = ' (';
                suffix += this.translate.instant(this.newItemSuffix);
                suffix += ')';
            }
            return (item.itemName ? item.itemName.value : item.value) + suffix;
        }
        return item.itemName ? item.itemName.value : item.value;
    }
    focusCloseButton(event) {
        event.preventDefault();
        window.setTimeout(function () {
            document.getElementById('ex-multiselect-combobox-close-btn').focus();
        }, 0);
    }
    focusSaveButton(event) {
        event.preventDefault();
        setTimeout(() => {
            this.saveButton.singleButton.nativeElement.focus();
        }, 0);
    }
    onCloseKeydown(event) {
        if (!event.shiftKey && event.code == "Tab") {
            event.preventDefault();
            this.focus();
        }
        else if (this.showSaveButton && event.shiftKey && event.code == "Tab") {
            this.focusSaveButton(event);
        }
    }
    onClickOutside() {
        if (!this.viewMode) {
            this.onSaveClicked();
        }
    }
    writeValue(value) {
        if (!value)
            return;
        this.items = value;
        this.initItems();
    }
    static { this.ɵfac = function ExMultiselectComboboxComponent_Factory(t) { return new (t || ExMultiselectComboboxComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExMultiselectComboboxComponent, selectors: [["ex-multiselect-combobox"]], viewQuery: function ExMultiselectComboboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$G, 5);
            i0.ɵɵviewQuery(_c1$q, 5);
            i0.ɵɵviewQuery(_c2$i, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
        } }, hostBindings: function ExMultiselectComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedValueChange", function ExMultiselectComboboxComponent_selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("itemRemoved", function ExMultiselectComboboxComponent_itemRemoved_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExMultiselectComboboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { items: "items", selectedValues: "selectedValues", placeholder: "placeholder", newItemSuffix: "newItemSuffix", label: "label", hasBorder: "hasBorder", mandatory: "mandatory", viewMode: "viewMode", allowNew: "allowNew", placeholderIcon: "placeholderIcon", showSaveButton: "showSaveButton", showCloseButton: "showCloseButton", showEditButton: "showEditButton", isFloatLabel: "isFloatLabel", searchMode: "searchMode", addNew: "addNew", labelColor: "labelColor" }, outputs: { initializeSelectedValues: "initializeSelectedValues", searchTriggered: "searchTriggered", endEdit: "endEdit", floatLabelRemoved: "floatLabelRemoved", itemRemoved: "itemRemoved", selectedValueChange: "selectedValueChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExMultiselectComboboxComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 21, vars: 19, consts: [[1, "ex-multiselect-combobox-general-wrapper"], ["class", "sel-multiselect-label ex-combobox-label ex-combobox-multi-label", 3, "click", 4, "ngIf"], [1, "sel-multiselect-button", "ex-multiselect-combobox-wrapper", 3, "ignoreIfCdkOverlayExists", "matMenuTriggerFor", "disabled", "clickOutside", "click", "menuClosed", "focusin", "focusout", "keyup.enter"], ["menuTrigger", "matMenuTrigger"], ["tabindex", "1", 1, "ex-multiselect-combobox-button", "sel-ex-combobox-selected-button", 3, "ngClass", "click", "mouseenter", "mouseleave", "keypress"], ["menuTriggerWrapper", ""], [1, "ex-combobox-selected-wrapper"], [1, "ex-combobox-selected-text-wrapper"], [3, "color", 4, "ngIf", "ngIfElse"], ["selected", ""], ["class", "sel-multiselect-textbox ex-combobox-textbox", "placeholder", "", 3, "incremental", "searchText", "click", "searchTriggered", "keydown", 4, "ngIf"], ["class", "sel-multiselect-edit-button ex-multiselect-combobox-edit-btn", 3, "visibility", 4, "ngIf"], ["class", "ex-multiselect-buttons-wrapper", 4, "ngIf"], ["yPosition", "below", 3, "overlapTrigger"], ["menu", "matMenu"], [1, "ex-combobox-menu-wrapper"], [1, "ex-combobox-options-wrapper"], [4, "ngFor", "ngForOf"], [1, "sel-multiselect-label", "ex-combobox-label", "ex-combobox-multi-label", 3, "click"], ["class", "uxf-icon", 3, "ngClass", 4, "ngIf"], [1, "sel-multiselect-selected-value", "sel-combobox-selected-value"], [1, "uxf-icon", 3, "ngClass"], [1, "ex-multiselect-combobox-selected-list-wrapper"], [1, "ex-multiselect-combobox-selected-list-chips"], [4, "ngIf", "ngIfElse"], ["floatLabel", ""], [4, "ngIf"], ["fontColor", "white", "class", "sel-multiselect-editable-chip ex-combobox-selected-chip-wrapper", "size", "small", 3, "background", "hasBorder", 4, "ngFor", "ngForOf"], ["fontColor", "white", "size", "small", 1, "sel-multiselect-editable-chip", "ex-combobox-selected-chip-wrapper", 3, "background", "hasBorder"], ["text", ""], [1, "sel-multiselect-label-text", "label-text", 3, "matTooltip"], ["class", " sel-multiselect-remove-label ex-combobox-selected-remove", "size", "small", 3, "ngClass", "closeClicked", 4, "ngIf"], ["size", "small", 1, "sel-multiselect-remove-label", "ex-combobox-selected-remove", 3, "ngClass", "closeClicked"], ["fontColor", "white", "class", "sel-multiselect-view-chip ex-combobox-selected-chip-wrapper", "size", "small", 3, "exTooltip", "background", "hasBorder", 4, "ngFor", "ngForOf"], ["fontColor", "white", "size", "small", 1, "sel-multiselect-view-chip", "ex-combobox-selected-chip-wrapper", 3, "exTooltip", "background", "hasBorder"], ["class", "sel-multiselect-float-label-edit ex-multiselect-combobox-selected-list-chips", 3, "hasDelete", "readOnly", "data", "backgroundColor", "floatLabelRemoved", 4, "ngIf"], ["class", "sel-multiselect-float-label-view ex-multiselect-combobox-selected-list-chips", 3, "hasDelete", "readOnly", "data", "backgroundColor", "floatLabelRemoved", 4, "ngIf"], [1, "sel-multiselect-float-label-edit", "ex-multiselect-combobox-selected-list-chips", 3, "hasDelete", "readOnly", "data", "backgroundColor", "floatLabelRemoved"], [1, "sel-multiselect-float-label-view", "ex-multiselect-combobox-selected-list-chips", 3, "hasDelete", "readOnly", "data", "backgroundColor", "floatLabelRemoved"], ["placeholder", "", 1, "sel-multiselect-textbox", "ex-combobox-textbox", 3, "incremental", "searchText", "click", "searchTriggered", "keydown"], ["input", ""], [1, "sel-multiselect-edit-button", "ex-multiselect-combobox-edit-btn"], [3, "ngClass"], [1, "ex-multiselect-buttons-wrapper"], ["class", "ex-multiselect-combobox-save-close-btn sel-multiselect-save-button", 3, "click", "keydown.tab", 4, "ngIf"], ["tabindex", "1", "id", "ex-multiselect-combobox-close-btn", "class", "ex-multiselect-combobox-save-close-btn sel-multiselect-close-button", 3, "click", "keyup.enter", "keydown", 4, "ngIf"], [1, "ex-multiselect-combobox-save-close-btn", "sel-multiselect-save-button", 3, "click", "keydown.tab"], ["saveButton", ""], ["tabindex", "1", "id", "ex-multiselect-combobox-close-btn", 1, "ex-multiselect-combobox-save-close-btn", "sel-multiselect-close-button", 3, "click", "keyup.enter", "keydown"], [1, "ex-combobox-expandable-header", 3, "click"], [1, "ex-combobox-title", "sel-multiselect-label"]], template: function ExMultiselectComboboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExMultiselectComboboxComponent_label_1_Template, 3, 3, "label", 1);
            i0.ɵɵelementStart(2, "button", 2, 3);
            i0.ɵɵlistener("clickOutside", function ExMultiselectComboboxComponent_Template_button_clickOutside_2_listener() { return ctx.onClickOutside(); })("click", function ExMultiselectComboboxComponent_Template_button_click_2_listener($event) { return ctx.onEditClicked($event); })("menuClosed", function ExMultiselectComboboxComponent_Template_button_menuClosed_2_listener() { return ctx.closed(); })("focusin", function ExMultiselectComboboxComponent_Template_button_focusin_2_listener() { return !ctx.isReadOnly && (ctx.isHovered = true); })("focusout", function ExMultiselectComboboxComponent_Template_button_focusout_2_listener() { return !ctx.isReadOnly && (ctx.isHovered = false); })("keyup.enter", function ExMultiselectComboboxComponent_Template_button_keyup_enter_2_listener($event) { return ctx.onEditClicked($event); });
            i0.ɵɵelementStart(4, "div", 4, 5);
            i0.ɵɵlistener("click", function ExMultiselectComboboxComponent_Template_div_click_4_listener() { return ctx.onWrapperClicked(); })("mouseenter", function ExMultiselectComboboxComponent_Template_div_mouseenter_4_listener() { return !ctx.isReadOnly && (ctx.isHovered = true); })("mouseleave", function ExMultiselectComboboxComponent_Template_div_mouseleave_4_listener() { return !ctx.isReadOnly && (ctx.isHovered = false); })("keypress", function ExMultiselectComboboxComponent_Template_div_keypress_4_listener($event) { return ctx.onKeydown($event); });
            i0.ɵɵelementStart(6, "div", 6)(7, "span", 7);
            i0.ɵɵtemplate(8, ExMultiselectComboboxComponent_div_8_Template, 5, 6, "div", 8);
            i0.ɵɵtemplate(9, ExMultiselectComboboxComponent_ng_template_9_Template, 5, 2, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(11, ExMultiselectComboboxComponent_ex_search_11_Template, 2, 2, "ex-search", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, ExMultiselectComboboxComponent_div_12_Template, 2, 4, "div", 11);
            i0.ɵɵtemplate(13, ExMultiselectComboboxComponent_div_13_Template, 3, 2, "div", 12);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(14, "div")(15, "mat-menu", 13, 14)(17, "div", 15)(18, "div", 16);
            i0.ɵɵelementContainerStart(19);
            i0.ɵɵtemplate(20, ExMultiselectComboboxComponent_ng_container_20_Template, 4, 1, "ng-container", 17);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            const _r2 = i0.ɵɵreference(5);
            const _r4 = i0.ɵɵreference(10);
            const _r9 = i0.ɵɵreference(16);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("cursor", !ctx.isReadOnly && ctx.viewMode ? "pointer" : "default");
            i0.ɵɵproperty("ignoreIfCdkOverlayExists", true)("matMenuTriggerFor", _r9)("disabled", ctx.isReadOnly);
            i0.ɵɵattribute("tabindex", ctx.showEditButton ? 0 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.isHovered && ctx.hasBorder || ctx.hasBorder && !ctx.viewMode ? "ex-multiselect-combobox-border" : "ex-multiselect-combobox-none-border");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.viewMode && ctx.placeholder && ctx.selectedValues.length === 0)("ngIfElse", _r4);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.viewMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.viewMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !_r1.menuOpen && !ctx.viewMode && (ctx.showSaveButton || ctx.showCloseButton));
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.searchMode ? "search" : "no-search");
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("width", _r2.offsetWidth, "px");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.filteredItems);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i3$1.MatMenu, i3$1.MatMenuTrigger, i4.MatTooltip, ExClickOutsideDirective, ExTooltipDirective, ExSearchComponent, ExCloseComponent, ExFloatLabelsComponent, ExChipComponent, i1$2.TranslatePipe], styles: [".ex-multiselect-combobox-general-wrapper[_ngcontent-%COMP%]{display:flex}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]{display:flex;align-items:baseline;position:relative;width:100%;background:transparent;border:transparent}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   ex-search[_ngcontent-%COMP%]     .ex-search-search-wrapper{border:none!important}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   ex-search[_ngcontent-%COMP%]     .uxf-close{display:none}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   ex-search[_ngcontent-%COMP%]     .uxf-search{display:none}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   ex-chip[_ngcontent-%COMP%]     .ex-close{padding-left:2px;padding-right:0}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-edit-btn[_ngcontent-%COMP%]{cursor:pointer;width:20px;padding-right:5px;background:none;border-color:transparent}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-btn-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:flex-end}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-btn-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-btn[_ngcontent-%COMP%]{z-index:100;cursor:pointer;margin:5px;width:-moz-fit-content;width:fit-content}.ex-multiselect-combobox-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-btn-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-btn[_ngcontent-%COMP%]     button{width:-moz-fit-content;width:fit-content}.ex-combobox-warning[_ngcontent-%COMP%]{border-width:2px!important;border-style:solid!important}.ex-combobox-label[_ngcontent-%COMP%]{margin-top:7px}.ex-combobox-multi-label[_ngcontent-%COMP%]{margin-right:5px}.ex-multiselect-combobox-button[_ngcontent-%COMP%]{max-width:100%;text-align:left;border-style:solid;border-radius:5px;min-width:unset;width:-webkit-fill-available}.ex-multiselect-combobox-button[_ngcontent-%COMP%]   .edit-clickable[_ngcontent-%COMP%]{color:#1079b3}.ex-combobox-arrow-multi[_ngcontent-%COMP%]{margin-top:5px!important;right:0}.ex-combobox-view-mode[_ngcontent-%COMP%]{padding:5px 10px;display:flex;line-height:19px}.ex-combobox-view-mode-not-defined[_ngcontent-%COMP%]{font-style:italic;color:#9c9c9c}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;align-items:flex-start;padding-top:5px;position:relative;min-height:30px}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]{padding-left:5px;padding-right:5px;display:inline-flex;align-items:center;line-height:19px;white-space:normal;flex-direction:column;align-items:flex-start;width:100%}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   .ex-combobox-textbox[_ngcontent-%COMP%]{width:100%!important}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   .ex-combobox-textbox[_ngcontent-%COMP%]     .ex-search-search-wrapper{padding-left:0!important;padding-right:0!important}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   .ex-combobox-textbox[_ngcontent-%COMP%]     .ex-search-clear-button{display:none!important}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   .ex-combobox-mandatory-asterisk[_ngcontent-%COMP%]{margin-bottom:0!important}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected-text-wrapper[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:5px}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-icon[_ngcontent-%COMP%]{margin-left:5px}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-selected[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.ex-combobox-selected-wrapper[_ngcontent-%COMP%]   .ex-combobox-arrow[_ngcontent-%COMP%]{margin-top:2px;margin-left:5px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-height:150px}.ex-combobox-menu-wrapper[_ngcontent-%COMP%]   .ex-combobox-options-wrapper[_ngcontent-%COMP%]{width:100%;padding-bottom:5px;max-height:270px;overflow-y:auto;overflow-x:hidden}.ex-multiselect-combobox-selected-list-wrapper[_ngcontent-%COMP%]{width:100%;margin-bottom:2px;padding:3px 0 0;max-height:300px;display:inline-block}.ex-combobox-selected-wrapper-multi[_ngcontent-%COMP%]{padding:0!important}.ex-combobox-button-border[_ngcontent-%COMP%]{border-width:1px!important;border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent!important;border-style:solid;padding-left:2px!important}.ex-combobox-multi-select[_ngcontent-%COMP%]{border-color:#ccc9!important}.ex-combobox-multi-text-wrapper[_ngcontent-%COMP%]{min-width:248px;width:-moz-fit-content;width:fit-content}.ex-multiselect-combobox-selected-list-chips[_ngcontent-%COMP%]{display:flex;flex:1;flex-wrap:wrap}.ex-multiselect-combobox-selected-list-chips[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]{max-width:100%;margin-bottom:5px}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;align-items:center}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]   .label-text[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]   .label-text[_ngcontent-%COMP%]     .ex-chip-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-combobox-selected-chip-wrapper[_ngcontent-%COMP%]     .ex-chip-chip-wrapper{max-width:100%}.ex-combobox-chip-label[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:5px;margin:5px;cursor:pointer!important}.ex-combobox-selected-remove[_ngcontent-%COMP%]{z-index:100;border:none!important;cursor:pointer;padding-left:3px}.ex-combobox-selected-remove[_ngcontent-%COMP%]     .ex-close-icon{color:#fff!important}.ex-combobox-selected-remove[_ngcontent-%COMP%]     button{display:flex;border:none!important;width:auto!important}.ex-combobox-selected-remove[_ngcontent-%COMP%]     button   .uxf-icon{position:inherit;height:9px;width:9px;font-size:9px!important}.ex-combobox-chip-label[_ngcontent-%COMP%]{color:#fff}.ex-combobox-menu-option[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:5px 15px}.ex-combobox-menu-option-one-line[_ngcontent-%COMP%]{line-height:20px}.ex-combobox-menu-option[_ngcontent-%COMP%]:hover{cursor:pointer!important;background:#fbf9f9}.ex-combobox-expandable-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding-left:15px;padding-right:15px;height:-moz-fit-content;height:fit-content;line-height:30px}.ex-combobox-sticky[_ngcontent-%COMP%]{position:sticky;z-index:1;top:0}.ex-combobox-disabled-item[_ngcontent-%COMP%]{cursor:not-allowed!important;opacity:.4}.ex-group-outlet-hr[_ngcontent-%COMP%]{margin-bottom:0!important;margin-top:0!important;margin-right:10px;margin-left:10px}.ex-combobox-outlet-option-description[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.change-mode[_ngcontent-%COMP%]{width:100%;height:-webkit-fill-available;position:absolute}.change-mode[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{right:0;top:0;margin-right:5px;position:absolute;cursor:pointer!important}.ex-multiselect-combobox-border[_ngcontent-%COMP%]{border:2px solid #1079b3!important;outline:none!important}.ex-multiselect-combobox-none-border[_ngcontent-%COMP%]{border:2px solid transparent!important;outline:none!important}  .mat-mdc-menu-panel.no-search{min-height:0px!important;height:0px!important}  .mat-mdc-menu-panel{max-width:none}.ex-multiselect-buttons-wrapper[_ngcontent-%COMP%]{position:absolute;bottom:-40px;right:0;border-radius:3px;box-shadow:0 3px 6px #6f6f6f7a;padding:5px;background:#fff;display:flex;z-index:1}.ex-multiselect-buttons-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-close-btn[_ngcontent-%COMP%]{cursor:pointer;background:0 0;border-color:transparent;background:#eee;display:flex;align-items:center;padding:5px;border-radius:3px}.ex-multiselect-buttons-wrapper[_ngcontent-%COMP%]   .ex-multiselect-combobox-save-close-btn[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMultiselectComboboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-multiselect-combobox', host: {
                    '(selectedValueChange)': 'controlOnChange($event)',
                    '(itemRemoved)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExMultiselectComboboxComponent), template: "<div class=\"ex-multiselect-combobox-general-wrapper\">\n    <label *ngIf=\"label\" class=\"sel-multiselect-label ex-combobox-label ex-combobox-multi-label\"\n        (click)=\"$event.stopPropagation();\">{{label | translate}}:</label>\n    <button (clickOutside)=\"onClickOutside()\" [ignoreIfCdkOverlayExists]=\"true\"\n        [attr.tabindex]=\"showEditButton ? 0 : -1\" class=\"sel-multiselect-button ex-multiselect-combobox-wrapper\"\n        (click)=\"onEditClicked($event)\" [style.cursor]=\"(!isReadOnly && viewMode)? 'pointer' : 'default'\"\n        #menuTrigger=\"matMenuTrigger\" [matMenuTriggerFor]=\"menu\" (menuClosed)=\"closed()\"\n        (focusin)=\"!isReadOnly && isHovered = true\" (focusout)=\"!isReadOnly && isHovered = false\"\n        (keyup.enter)=\"onEditClicked($event)\" [disabled]=\"isReadOnly\">\n        <div #menuTriggerWrapper tabindex=\"1\" (click)=\"onWrapperClicked()\"\n            (mouseenter)=\"!isReadOnly && isHovered = true\" (mouseleave)=\"!isReadOnly && isHovered = false\"\n            (keypress)=\"onKeydown($event)\" class=\"ex-multiselect-combobox-button sel-ex-combobox-selected-button\"\n            [ngClass]=\"(isHovered && hasBorder) || (hasBorder && !viewMode) ? 'ex-multiselect-combobox-border' : 'ex-multiselect-combobox-none-border'\">\n            <div class=\"ex-combobox-selected-wrapper\">\n                <span class=\"ex-combobox-selected-text-wrapper\">\n                    <div [style.color]=\"'#1079b3'\"\n                        *ngIf=\"viewMode && placeholder && selectedValues.length === 0; else selected\">\n                        <i *ngIf=\"placeholderIcon\" [ngClass]=\"'uxf-plus-circle'\" class=\"uxf-icon\"></i>\n                        <span class=\"sel-multiselect-selected-value sel-combobox-selected-value\">\n                            {{placeholder | translate}}</span>\n                    </div>\n                    <ng-template #selected>\n                        <div class=\"ex-multiselect-combobox-selected-list-wrapper\">\n                            <div class=\"ex-multiselect-combobox-selected-list-chips\">\n                                <ng-container *ngIf=\"!isFloatLabel;else floatLabel\">\n                                    <ng-container *ngIf=\"!viewMode\">\n                                        <ex-chip *ngFor=\"let selected of currentSelectedValues; let i = index\"\n                                            fontColor=\"white\"\n                                            class=\"sel-multiselect-editable-chip ex-combobox-selected-chip-wrapper\"\n                                            background={{selected.color}} [hasBorder]=\"false\" size=\"small\">\n                                            <span text>\n                                                <span class=\"sel-multiselect-label-text label-text\"\n                                                    [matTooltip]=\"getItemLabel(selected)\">{{ getItemLabel(selected)\n                                                    }}</span>\n                                                <ex-close *ngIf=\"!viewMode\"\n                                                    class=\" sel-multiselect-remove-label ex-combobox-selected-remove\"\n                                                    size=\"small\"\n                                                    [ngClass]=\"{'ex-combobox-selected-colored-remove' : selected.color }\"\n                                                    (closeClicked)=\"remove($event, i)\">\n                                                </ex-close>\n                                            </span>\n                                        </ex-chip>\n                                    </ng-container>\n                                    <ng-container *ngIf=\"viewMode\">\n                                        <ex-chip *ngFor=\"let selected of selectedValues; let i = index\"\n                                            fontColor=\"white\"\n                                            class=\"sel-multiselect-view-chip ex-combobox-selected-chip-wrapper\"\n                                            [exTooltip]=\"getItemLabel(selected)\" [background]=\"selected.color\"\n                                            [hasBorder]=\"false\" size=\"small\">\n                                            <span text>{{ getItemLabel(selected) }}</span>\n                                        </ex-chip>\n                                    </ng-container>\n                                </ng-container>\n                                <ng-template #floatLabel>\n                                    <ex-float-labels *ngIf=\"!viewMode\" [hasDelete]=\"!this.viewMode\" [readOnly]=\"true\"\n                                        class=\"sel-multiselect-float-label-edit ex-multiselect-combobox-selected-list-chips\"\n                                        [data]=\"currentSelectedValues\" [backgroundColor]=\"labelColor\"\n                                        (floatLabelRemoved)=\"remove(null,$event)\">\n                                    </ex-float-labels>\n                                    <ex-float-labels *ngIf=\"viewMode\" [hasDelete]=\"!this.viewMode\" [readOnly]=\"true\"\n                                        class=\"sel-multiselect-float-label-view ex-multiselect-combobox-selected-list-chips\"\n                                        [data]=\"selectedValues\" [backgroundColor]=\"labelColor\"\n                                        (floatLabelRemoved)=\"floatLabelRemoved.emit($event)\">\n                                    </ex-float-labels>\n                                </ng-template>\n                            </div>\n                        </div>\n                    </ng-template>\n                    <ex-search #input *ngIf=\"!viewMode\" class=\"sel-multiselect-textbox ex-combobox-textbox\"\n                        [incremental]=\"true\" (click)=\"$event.stopPropagation()\"\n                        (searchTriggered)=\"searchTextChange($event)\" [searchText]=\"searchText\" placeholder=\"\"\n                        (keydown)=\"onKeydown($event)\">\n                    </ex-search>\n                </span>\n\n                <div class=\"sel-multiselect-edit-button ex-multiselect-combobox-edit-btn\" *ngIf=\"viewMode\"\n                    [style.visibility]=\"(viewMode && isHovered && showEditButton) ? 'visible' : 'hidden'\">\n                    <i [ngClass]=\"['uxf-icon uxf-pencil', 'edit-clickable']\"></i>\n                </div>\n\n                <div *ngIf=\"!menuTrigger.menuOpen && !viewMode && (showSaveButton || showCloseButton)\"\n                    class=\"ex-multiselect-buttons-wrapper\">\n                    <button *ngIf=\"showSaveButton\" #saveButton (click)=\"onSaveClicked($event)\"\n                        class=\"ex-multiselect-combobox-save-close-btn sel-multiselect-save-button\"\n                        (keydown.tab)=\"showCloseButton ? focusCloseButton($event) : ''\">\n                        <i [ngClass]=\"['uxf-icon uxf-check', 'ex-close-icon']\" [style.color]=\"'#50B039'\"></i>\n                    </button>\n                    <button tabindex=\"1\" id=\"ex-multiselect-combobox-close-btn\"\n                        class=\"ex-multiselect-combobox-save-close-btn sel-multiselect-close-button\"\n                        *ngIf=\"showCloseButton\" (click)=\"onCloseClicked($event)\" (keyup.enter)=\"onCloseClicked($event)\"\n                        (keydown)=\"onCloseKeydown($event)\" [attr.aria-label]=\"'ng.general.close' | translate\">\n                        <i [ngClass]=\"['uxf-icon uxf-close', 'ex-close-icon']\" [style.color]=\"'#1079b3'\"></i>\n                    </button>\n                </div>\n\n            </div>\n\n        </div>\n    </button>\n</div>\n<div>\n    <mat-menu #menu=\"matMenu\" yPosition=\"below\" [class]=\"this.searchMode ?\u00A0'search'\u00A0:\u00A0'no-search'\"\n        [overlapTrigger]=\"false\">\n        <div class=\"ex-combobox-menu-wrapper\" [style.width.px]=\"menuTriggerWrapper.offsetWidth\">\n            <div class=\"ex-combobox-options-wrapper\">\n                <ng-container>\n                    <ng-container *ngFor=\"let item of filteredItems; let i = index\">\n                        <div (click)=\"selectedValueChanged($event, i)\" class=\"ex-combobox-expandable-header\">\n                            <span class=\"ex-combobox-title sel-multiselect-label\">{{ getItemLabel(item) }}</span>\n                        </div>\n                    </ng-container>\n                </ng-container>\n            </div>\n        </div>\n    </mat-menu>\n</div>", styles: [".ex-multiselect-combobox-general-wrapper{display:flex}.ex-multiselect-combobox-wrapper{display:flex;align-items:baseline;position:relative;width:100%;background:transparent;border:transparent}.ex-multiselect-combobox-wrapper ex-search ::ng-deep .ex-search-search-wrapper{border:none!important}.ex-multiselect-combobox-wrapper ex-search ::ng-deep .uxf-close{display:none}.ex-multiselect-combobox-wrapper ex-search ::ng-deep .uxf-search{display:none}.ex-multiselect-combobox-wrapper ex-chip ::ng-deep .ex-close{padding-left:2px;padding-right:0}.ex-multiselect-combobox-wrapper .ex-multiselect-combobox-edit-btn{cursor:pointer;width:20px;padding-right:5px;background:none;border-color:transparent}.ex-multiselect-combobox-wrapper .ex-multiselect-combobox-save-btn-wrapper{width:100%;display:flex;justify-content:flex-end}.ex-multiselect-combobox-wrapper .ex-multiselect-combobox-save-btn-wrapper .ex-multiselect-combobox-save-btn{z-index:100;cursor:pointer;margin:5px;width:-moz-fit-content;width:fit-content}.ex-multiselect-combobox-wrapper .ex-multiselect-combobox-save-btn-wrapper .ex-multiselect-combobox-save-btn ::ng-deep button{width:-moz-fit-content;width:fit-content}.ex-combobox-warning{border-width:2px!important;border-style:solid!important}.ex-combobox-label{margin-top:7px}.ex-combobox-multi-label{margin-right:5px}.ex-multiselect-combobox-button{max-width:100%;text-align:left;border-style:solid;border-radius:5px;min-width:unset;width:-webkit-fill-available}.ex-multiselect-combobox-button .edit-clickable{color:#1079b3}.ex-combobox-arrow-multi{margin-top:5px!important;right:0}.ex-combobox-view-mode{padding:5px 10px;display:flex;line-height:19px}.ex-combobox-view-mode-not-defined{font-style:italic;color:#9c9c9c}.ex-combobox-selected-wrapper{width:100%;display:flex;justify-content:space-between;align-items:flex-start;padding-top:5px;position:relative;min-height:30px}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper{padding-left:5px;padding-right:5px;display:inline-flex;align-items:center;line-height:19px;white-space:normal;flex-direction:column;align-items:flex-start;width:100%}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper .ex-combobox-textbox{width:100%!important}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper .ex-combobox-textbox ::ng-deep .ex-search-search-wrapper{padding-left:0!important;padding-right:0!important}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper .ex-combobox-textbox ::ng-deep .ex-search-clear-button{display:none!important}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper .ex-combobox-mandatory-asterisk{margin-bottom:0!important}.ex-combobox-selected-wrapper .ex-combobox-selected-text-wrapper i{margin-right:5px}.ex-combobox-selected-wrapper .ex-combobox-icon{margin-left:5px}.ex-combobox-selected-wrapper .ex-combobox-selected{overflow:hidden;text-overflow:ellipsis}.ex-combobox-selected-wrapper .ex-combobox-arrow{margin-top:2px;margin-left:5px}.ex-combobox-menu-wrapper{display:flex;flex-direction:column;max-height:150px}.ex-combobox-menu-wrapper .ex-combobox-options-wrapper{width:100%;padding-bottom:5px;max-height:270px;overflow-y:auto;overflow-x:hidden}.ex-multiselect-combobox-selected-list-wrapper{width:100%;margin-bottom:2px;padding:3px 0 0;max-height:300px;display:inline-block}.ex-combobox-selected-wrapper-multi{padding:0!important}.ex-combobox-button-border{border-width:1px!important;border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent!important;border-style:solid;padding-left:2px!important}.ex-combobox-multi-select{border-color:#ccc9!important}.ex-combobox-multi-text-wrapper{min-width:248px;width:-moz-fit-content;width:fit-content}.ex-multiselect-combobox-selected-list-chips{display:flex;flex:1;flex-wrap:wrap}.ex-multiselect-combobox-selected-list-chips *:not(:last-child){margin-right:5px}.ex-combobox-selected-chip-wrapper{max-width:100%;margin-bottom:5px}.ex-combobox-selected-chip-wrapper span{display:flex;align-items:center}.ex-combobox-selected-chip-wrapper .label-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-combobox-selected-chip-wrapper .label-text ::ng-deep .ex-chip-text{display:inline-block;text-overflow:ellipsis;overflow:hidden!important}.ex-combobox-selected-chip-wrapper ::ng-deep .ex-chip-chip-wrapper{max-width:100%}.ex-combobox-chip-label{display:flex;justify-content:space-between;padding:5px;margin:5px;cursor:pointer!important}.ex-combobox-selected-remove{z-index:100;border:none!important;cursor:pointer;padding-left:3px}.ex-combobox-selected-remove ::ng-deep .ex-close-icon{color:#fff!important}.ex-combobox-selected-remove ::ng-deep button{display:flex;border:none!important;width:auto!important}.ex-combobox-selected-remove ::ng-deep button ::ng-deep .uxf-icon{position:inherit;height:9px;width:9px;font-size:9px!important}.ex-combobox-chip-label{color:#fff}.ex-combobox-menu-option{display:flex;flex-direction:column;padding:5px 15px}.ex-combobox-menu-option-one-line{line-height:20px}.ex-combobox-menu-option:hover{cursor:pointer!important;background:#fbf9f9}.ex-combobox-expandable-header{display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding-left:15px;padding-right:15px;height:-moz-fit-content;height:fit-content;line-height:30px}.ex-combobox-sticky{position:sticky;z-index:1;top:0}.ex-combobox-disabled-item{cursor:not-allowed!important;opacity:.4}.ex-group-outlet-hr{margin-bottom:0!important;margin-top:0!important;margin-right:10px;margin-left:10px}.ex-combobox-outlet-option-description{overflow:hidden;text-overflow:ellipsis}.change-mode{width:100%;height:-webkit-fill-available;position:absolute}.change-mode i{right:0;top:0;margin-right:5px;position:absolute;cursor:pointer!important}.ex-multiselect-combobox-border{border:2px solid #1079b3!important;outline:none!important}.ex-multiselect-combobox-none-border{border:2px solid transparent!important;outline:none!important}::ng-deep .mat-mdc-menu-panel.no-search{min-height:0px!important;height:0px!important}::ng-deep .mat-mdc-menu-panel{max-width:none}.ex-multiselect-buttons-wrapper{position:absolute;bottom:-40px;right:0;border-radius:3px;box-shadow:0 3px 6px #6f6f6f7a;padding:5px;background:#fff;display:flex;z-index:1}.ex-multiselect-buttons-wrapper .ex-multiselect-combobox-save-close-btn{cursor:pointer;background:0 0;border-color:transparent;background:#eee;display:flex;align-items:center;padding:5px;border-radius:3px}.ex-multiselect-buttons-wrapper .ex-multiselect-combobox-save-close-btn:not(:last-child){margin-right:5px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }]; }, { items: [{
            type: Input
        }], selectedValues: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], newItemSuffix: [{
            type: Input
        }], label: [{
            type: Input
        }], hasBorder: [{
            type: Input
        }], mandatory: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], allowNew: [{
            type: Input
        }], placeholderIcon: [{
            type: Input
        }], showSaveButton: [{
            type: Input
        }], showCloseButton: [{
            type: Input
        }], showEditButton: [{
            type: Input
        }], isFloatLabel: [{
            type: Input
        }], searchMode: [{
            type: Input
        }], addNew: [{
            type: Input
        }], labelColor: [{
            type: Input
        }], initializeSelectedValues: [{
            type: Output
        }], searchTriggered: [{
            type: Output
        }], endEdit: [{
            type: Output
        }], floatLabelRemoved: [{
            type: Output
        }], itemRemoved: [{
            type: Output
        }], selectedValueChange: [{
            type: Output
        }], searchBox: [{
            type: ViewChild,
            args: ['input']
        }], saveButton: [{
            type: ViewChild,
            args: ['saveButton']
        }], menuTrigger: [{
            type: ViewChild,
            args: ['menuTrigger']
        }] }); })();

class ExMultiselectComboboxModule {
    static { this.ɵfac = function ExMultiselectComboboxModule_Factory(t) { return new (t || ExMultiselectComboboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExMultiselectComboboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            MatMenuModule,
            MatTooltipModule,
            ExDirectivesModule,
            FormsModule,
            EXPipesModule,
            ExSearchModule,
            ExCloseModule,
            ExFloatLabelsModule,
            TranslateModule,
            ReactiveFormsModule,
            MatSelectModule,
            MatAutocompleteModule,
            ExChipModule,
            ExButtonModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMultiselectComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatMenuModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    FormsModule,
                    EXPipesModule,
                    ExSearchModule,
                    ExCloseModule,
                    ExFloatLabelsModule,
                    TranslateModule,
                    ReactiveFormsModule,
                    MatSelectModule,
                    MatAutocompleteModule,
                    ExChipModule,
                    ExButtonModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExMultiselectComboboxComponent
                ],
                exports: [
                    ExMultiselectComboboxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExMultiselectComboboxModule, { declarations: [ExMultiselectComboboxComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        ExDirectivesModule,
        FormsModule,
        EXPipesModule,
        ExSearchModule,
        ExCloseModule,
        ExFloatLabelsModule,
        TranslateModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatAutocompleteModule,
        ExChipModule,
        ExButtonModule,
        ExDirectivesModule], exports: [ExMultiselectComboboxComponent] }); })();

class ExNoteModule {
    static { this.ɵfac = function ExNoteModule_Factory(t) { return new (t || ExNoteModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExNoteModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExCloseModule,
            ExEditableTextModule,
            TranslateModule,
            ExIconModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExExpandableLabelModule,
            ExSvgIconModule,
            ExConfirmationMessageModule,
            ExDisplayTextModule,
            A11yModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNoteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExCloseModule,
                    ExEditableTextModule,
                    TranslateModule,
                    ExIconModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExExpandableLabelModule,
                    ExSvgIconModule,
                    ExConfirmationMessageModule,
                    ExDisplayTextModule,
                    A11yModule
                ],
                declarations: [
                    ExNoteComponent
                ],
                exports: [
                    ExNoteComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExNoteModule, { declarations: [ExNoteComponent], imports: [CommonModule,
        ExCloseModule,
        ExEditableTextModule,
        TranslateModule,
        ExIconModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExExpandableLabelModule,
        ExSvgIconModule,
        ExConfirmationMessageModule,
        ExDisplayTextModule,
        A11yModule], exports: [ExNoteComponent] }); })();
i0.ɵɵsetComponentScope(ExNoteComponent, [i1$5.NgIf, ExEditableTextComponent, ExSvgIconComponent, ExConfirmationMessageComponent, ExDisplayTextComponent], [i1$2.TranslatePipe]);

function ExPieChartComponent__svg_ng_container_4__svg_circle_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "circle", 10);
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("stroke", "white");
    i0.ɵɵattribute("cx", ctx_r5.cxcy)("cy", ctx_r5.cxcy)("r", item_r4.radius)("stroke-width", item_r4.strokeWidth * ctx_r5.strokeWidthMultiplier)("stroke-dasharray", "0.5 99.5")("stroke-dashoffset", item_r4.strokeDashoffset);
} }
function ExPieChartComponent__svg_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "circle", 10)(2, "title");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ExPieChartComponent__svg_ng_container_4__svg_circle_4_Template, 1, 8, "circle", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("stroke", item_r4.color);
    i0.ɵɵattribute("cx", ctx_r0.cxcy)("cy", ctx_r0.cxcy)("r", item_r4.radius)("stroke-width", item_r4.strokeWidth * ctx_r0.strokeWidthMultiplier)("stroke-dasharray", item_r4.strokeDasharray)("stroke-dashoffset", item_r4.strokeDashoffset);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.finalValues.length > 1);
} }
function ExPieChartComponent__svg_text_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "text", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r1.countMiddle || ctx_r1.totalCount, "1.0-2"), " ");
} }
function ExPieChartComponent_div_9_ex_legend_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-legend", 15);
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", item_r8.value)("percent", ctx_r7.finalValues[i_r9].percent)("title", item_r8.title)("subTitle", item_r8.subTitle)("description", item_r8.description)("icons", item_r8.icons)("color", ctx_r7.finalValues[i_r9].color);
} }
function ExPieChartComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, ExPieChartComponent_div_9_ex_legend_1_Template, 1, 7, "ex-legend", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.values);
} }
function ExPieChartComponent_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "ex-chip", 18)(3, "ex-label", 19)(4, "ex-label", 20)(5, "ex-label", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltip", item_r11.tooltip)("background", ctx_r10.finalValues[i_r12].color)("hasBorder", false)("size", "normal");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", item_r11.description + ":")("tooltip", item_r11.tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isBold", true)("value", item_r11.value + "")("tooltip", item_r11.tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", "(" + ctx_r10.finalValues[i_r12].roundedPercent + "%)")("tooltip", item_r11.tooltip);
} }
function ExPieChartComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ExPieChartComponent_div_10_ng_container_1_Template, 6, 11, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.values);
} }
class ExPieChartComponent {
    /**
     * the thickness of the pie chart, it can be thin or thick, the default is thin
     */
    get thickness() {
        return this._thickness;
    }
    set thickness(thickness) {
        this._thickness = thickness;
        if (thickness === 'thick') {
            this.cxcy = "30";
            this.r = "18";
            this.viewBox = "0 0 60 60";
            this.strokeWidth = "4";
            this.strokeWidthMultiplier = 3;
        }
    }
    /**
     * the size of the pie chart (density will also be taken into consideration)
     */
    get size() {
        return this._size;
    }
    set size(size) {
        this._size = size;
        this.pieHeight = this.pieHeights[size];
    }
    constructor() {
        /**
         * all the values for the pie chart if value can have a title, sub title a description and a list of icon that will be displayed on the top right corner of the legend, each icon ca be clickable if the onClick function will be passed
         * you can also define a value as bold and then his line will be thicker and his value will be shown at the center of the pie instead of the total value
         */
        this.values = [];
        this.icons = [];
        this.hideTotalCount = false;
        /**
         * whether to display the legends
         */
        this.hasLegends = false;
        /**
         * whether to display the legends using chips
         */
        this.hasChipLegends = false;
        this._thickness = 'thin';
        this.cxcy = "21";
        this.r = "13";
        this.viewBox = "0 0 42 42";
        this.strokeWidth = "2";
        this.strokeWidthMultiplier = 1;
        this.pieHeights = {
            'small': '90px',
            'medium': '110px',
            'large': '130px',
            'huge': '300px'
        };
        this._size = 'medium';
        this.pieHeight = '110px';
        this.radius = 15.91549430918954;
        this.colors = ['#006DEB', '#AB1717', '#3D7E11', '#B35600', '#0E137C', '#C900CC', '#1C8271', '#DB00A1', '#77776E', '#AD4E00', '#7A1FA2', '#5D4138', '#C11959'];
    }
    ngOnInit() {
        this.calcTotalCount();
        let counter = 0;
        this.finalValues = this.values.map(({ value, bold, color, description }, i) => {
            // Current segment offset = Circumference − All preceding segments’ total length + First segment’s offset
            const strokeWidth = bold ? 4 : 2;
            const radius = bold ? this.radius + 1 : this.radius;
            const circumference = this.calcCircumference(radius);
            if (bold) {
                this.countMiddle = value;
            }
            const strokeDashoffset = i === 0
                ? circumference / 4
                : circumference -
                    (counter / this.totalCount) * circumference +
                    circumference / 4;
            counter += value;
            const percent = (value / this.totalCount) * 100;
            const roundedPercent = percent.toFixed(2);
            // const random = Math.floor(Math.random() * this.colors.length);
            const finalColor = color ? color : this.colors[i % this.colors.length];
            return {
                percent,
                roundedPercent: roundedPercent,
                strokeWidth,
                strokeDashoffset,
                color: finalColor,
                radius,
                tooltip: description ? description + ': ' + value + ' (' + roundedPercent + '%)' : value + ' (' + roundedPercent + '%)',
                strokeDasharray: `${(value / this.totalCount) * circumference} ${((this
                    .totalCount -
                    value) /
                    this.totalCount) *
                    circumference}`
            };
        });
    }
    calcTotalCount() {
        this.totalCount = this.values.reduce((acc, { value }) => acc + value, 0);
    }
    calcCircumference(radius) {
        return radius * 2 * Math.PI;
    }
    static { this.ɵfac = function ExPieChartComponent_Factory(t) { return new (t || ExPieChartComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExPieChartComponent, selectors: [["ex-pie-chart"]], hostVars: 2, hostBindings: function ExPieChartComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("--ex-pie-chart-height", ctx.pieHeight);
        } }, inputs: { values: "values", icons: "icons", hideTotalCount: "hideTotalCount", mainLabel: "mainLabel", hasLegends: "hasLegends", hasChipLegends: "hasChipLegends", thickness: "thickness", size: "size" }, decls: 11, vars: 10, consts: [[1, "ex-pie-chart-wrapper"], [1, "ex-pie-chart-pie"], ["height", "100%", 1, "donut"], ["fill", "transparent", "stroke", "#F2F2F2", 1, "donut-ring"], [4, "ngFor", "ngForOf"], [1, "ex-pie-chart-text"], ["x", "50%", "y", "49%", "class", "ex-pie-chart-number", 4, "ngIf"], ["x", "50%", "y", "51%", 1, "ex-pie-chart-label"], ["class", "ex-pie-chart-legends", 4, "ngIf"], ["class", "ex-pie-chart-chips-legends", 4, "ngIf"], ["fill", "transparent", 1, "donut-segment"], ["class", "donut-segment", "fill", "transparent", 3, "stroke", 4, "ngIf"], ["x", "50%", "y", "49%", 1, "ex-pie-chart-number"], [1, "ex-pie-chart-legends"], [3, "value", "percent", "title", "subTitle", "description", "icons", "color", 4, "ngFor", "ngForOf"], [3, "value", "percent", "title", "subTitle", "description", "icons", "color"], [1, "ex-pie-chart-chips-legends"], [1, "ex-pie-chart-chips-legends-element"], ["fontColor", "white", 1, "ex-pie-chart-chips-chip", 3, "tooltip", "background", "hasBorder", "size"], [3, "value", "tooltip"], [3, "isBold", "value", "tooltip"]], template: function ExPieChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2);
            i0.ɵɵelement(3, "circle", 3);
            i0.ɵɵtemplate(4, ExPieChartComponent__svg_ng_container_4_Template, 5, 10, "ng-container", 4);
            i0.ɵɵelementStart(5, "g", 5);
            i0.ɵɵtemplate(6, ExPieChartComponent__svg_text_6_Template, 3, 4, "text", 6);
            i0.ɵɵelementStart(7, "text", 7);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(9, ExPieChartComponent_div_9_Template, 2, 1, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, ExPieChartComponent_div_10_Template, 2, 1, "div", 9);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("viewBox", ctx.viewBox);
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("cx", ctx.cxcy)("cy", ctx.cxcy)("r", ctx.r)("stroke-width", ctx.strokeWidth);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.finalValues);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.hideTotalCount);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.mainLabel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasLegends);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasChipLegends);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExLegendComponent, ExChipComponent, ExLabelComponent, i1$5.DecimalPipe], styles: ["[_nghost-%COMP%]{--ex-pie-chart-height: 110px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-pie[_ngcontent-%COMP%]{margin-bottom:10px;margin-top:-12px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-pie[_ngcontent-%COMP%]   .ex-pie-chart-text[_ngcontent-%COMP%]{font-size:16px;fill:#000;transform:translateY(2px)}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-pie[_ngcontent-%COMP%]   .ex-pie-chart-text[_ngcontent-%COMP%]   .ex-pie-chart-label[_ngcontent-%COMP%]{font-size:.2em;text-transform:uppercase;text-anchor:middle;transform:translateY(.7em)}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-pie[_ngcontent-%COMP%]   .ex-pie-chart-text[_ngcontent-%COMP%]   .ex-pie-chart-number[_ngcontent-%COMP%]{font-size:6px;line-height:1;text-anchor:middle;transform:translateY(-.25em)}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]{columns:230px;column-gap:5px;flex:1;margin-left:10px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]{page-break-inside:avoid;break-inside:avoid;border-left-width:4px;border-left-style:solid;background:#eff5f7;padding:5px 10px;margin-bottom:10px;margin-right:15px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]   .ex-pie-chart-legend-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]   .ex-pie-chart-legend-header[_ngcontent-%COMP%]   .ex-pie-chart-icons[_ngcontent-%COMP%]{display:flex;margin-left:5px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]   .ex-pie-chart-legend-header[_ngcontent-%COMP%]   .ex-pie-chart-icons[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-left:5px}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]   .ex-pie-chart-legend-title[_ngcontent-%COMP%]{color:#4164a4}.ex-pie-chart-wrapper[_ngcontent-%COMP%]   .ex-pie-chart-legends[_ngcontent-%COMP%]   .ex-pie-chart-legend[_ngcontent-%COMP%]   .ex-pie-chart-legend-sub-title[_ngcontent-%COMP%]{margin-bottom:5px;color:#4164a4}.ex-pie-chart-chips-legends[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:8px;margin-top:10px}.ex-pie-chart-chips-legends-element[_ngcontent-%COMP%]{display:flex;flex-direction:row;gap:2px}.ex-pie-chart-chips-chip[_ngcontent-%COMP%]{padding-right:6px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPieChartComponent, [{
        type: Component,
        args: [{ selector: 'ex-pie-chart', template: "<div class=\"ex-pie-chart-wrapper\">\n    <div class=\"ex-pie-chart-pie\">\n        <svg height=\"100%\" [attr.viewBox]=\"viewBox\" class=\"donut\">\n            <!-- <circle class=\"donut-hole\" cx=\"21\" cy=\"21\" r=\"15.91549430918954\" fill=\"#fff\"></circle> -->\n            <circle class=\"donut-ring\" [attr.cx]=\"cxcy\" [attr.cy]=\"cxcy\" [attr.r]=\"r\" fill=\"transparent\"\n                    stroke=\"#F2F2F2\" [attr.stroke-width]=\"strokeWidth\">\n            </circle>\n\n            <ng-container *ngFor=\"let item of finalValues\">\n                <circle class=\"donut-segment\" [attr.cx]=\"cxcy\" [attr.cy]=\"cxcy\" [attr.r]=\"item.radius\"\n                        fill=\"transparent\"\n                        [style.stroke]=\"item.color\" [attr.stroke-width]=\"item.strokeWidth * strokeWidthMultiplier\"\n                    [attr.stroke-dasharray]=\"item.strokeDasharray\" [attr.stroke-dashoffset]=\"item.strokeDashoffset\">\n                    <title>{{ item.tooltip }}</title>\n                </circle>\n\n                <!-- white separator between two adjacent colors -->\n                <circle *ngIf=\"finalValues.length > 1\" class=\"donut-segment\" [attr.cx]=\"cxcy\" [attr.cy]=\"cxcy\"\n                        [attr.r]=\"item.radius\"\n                        fill=\"transparent\" [style.stroke]=\"'white'\"\n                        [attr.stroke-width]=\"item.strokeWidth * strokeWidthMultiplier\"\n                    [attr.stroke-dasharray]=\"'0.5 99.5'\" [attr.stroke-dashoffset]=\"item.strokeDashoffset\">\n                </circle>\n            </ng-container>\n\n\n            <g class=\"ex-pie-chart-text\">\n                <text *ngIf=\"!hideTotalCount\" x=\"50%\" y=\"49%\" class=\"ex-pie-chart-number\">\n                    {{ (countMiddle || totalCount) | number: '1.0-2' }}\n                </text>\n                <text x=\"50%\" y=\"51%\" class=\"ex-pie-chart-label\">\n                    {{ mainLabel }}\n                </text>\n            </g>\n        </svg>\n    </div>\n    <div *ngIf=\"hasLegends\" class=\"ex-pie-chart-legends\">\n        <ex-legend *ngFor=\"let item of values; let i = index\" [value]=\"item.value\" [percent]=\"finalValues[i].percent\"\n            [title]=\"item.title\" [subTitle]=\"item.subTitle\" [description]=\"item.description\" [icons]=\"item.icons\"\n                   [color]=\"finalValues[i].color\">\n        </ex-legend>\n    </div>\n</div>\n\n<div *ngIf=\"hasChipLegends\" class=\"ex-pie-chart-chips-legends\">\n    <ng-container *ngFor=\"let item of values; let i = index\">\n        <div class=\"ex-pie-chart-chips-legends-element\">\n            <ex-chip fontColor=\"white\" [tooltip]=\"item.tooltip\" class=\"ex-pie-chart-chips-chip\"\n                     [background]=\"finalValues[i].color\" [hasBorder]=\"false\" [size]=\"'normal'\">\n            </ex-chip>\n            <ex-label [value]=\"item.description + ':'\" [tooltip]=\"item.tooltip\"></ex-label>\n            <ex-label [isBold]=\"true\" [value]=\"item.value + ''\" [tooltip]=\"item.tooltip\"></ex-label>\n            <ex-label [value]=\"'(' + finalValues[i].roundedPercent + '%)'\" [tooltip]=\"item.tooltip\"></ex-label>\n        </div>\n    </ng-container>\n</div>", styles: [":host{--ex-pie-chart-height: 110px}.ex-pie-chart-wrapper{display:flex;justify-content:center}.ex-pie-chart-wrapper .ex-pie-chart-pie{margin-bottom:10px;margin-top:-12px}.ex-pie-chart-wrapper .ex-pie-chart-pie .ex-pie-chart-text{font-size:16px;fill:#000;transform:translateY(2px)}.ex-pie-chart-wrapper .ex-pie-chart-pie .ex-pie-chart-text .ex-pie-chart-label{font-size:.2em;text-transform:uppercase;text-anchor:middle;transform:translateY(.7em)}.ex-pie-chart-wrapper .ex-pie-chart-pie .ex-pie-chart-text .ex-pie-chart-number{font-size:6px;line-height:1;text-anchor:middle;transform:translateY(-.25em)}.ex-pie-chart-wrapper .ex-pie-chart-legends{columns:230px;column-gap:5px;flex:1;margin-left:10px}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend{page-break-inside:avoid;break-inside:avoid;border-left-width:4px;border-left-style:solid;background:#eff5f7;padding:5px 10px;margin-bottom:10px;margin-right:15px}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend .ex-pie-chart-legend-header{display:flex;flex-direction:row;justify-content:space-between}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend .ex-pie-chart-legend-header .ex-pie-chart-icons{display:flex;margin-left:5px}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend .ex-pie-chart-legend-header .ex-pie-chart-icons ex-icon{margin-left:5px}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend .ex-pie-chart-legend-title{color:#4164a4}.ex-pie-chart-wrapper .ex-pie-chart-legends .ex-pie-chart-legend .ex-pie-chart-legend-sub-title{margin-bottom:5px;color:#4164a4}.ex-pie-chart-chips-legends{display:flex;flex-direction:column;gap:8px;margin-top:10px}.ex-pie-chart-chips-legends-element{display:flex;flex-direction:row;gap:2px}.ex-pie-chart-chips-chip{padding-right:6px}\n"] }]
    }], function () { return []; }, { values: [{
            type: Input
        }], icons: [{
            type: Input
        }], hideTotalCount: [{
            type: Input
        }], mainLabel: [{
            type: Input
        }], hasLegends: [{
            type: Input
        }], hasChipLegends: [{
            type: Input
        }], thickness: [{
            type: Input
        }], size: [{
            type: Input
        }], pieHeight: [{
            type: HostBinding,
            args: ['style.--ex-pie-chart-height']
        }] }); })();

class ExPieChartModule {
    static { this.ɵfac = function ExPieChartModule_Factory(t) { return new (t || ExPieChartModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExPieChartModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            ExLegendModule,
            ExChipModule,
            ExLabelModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExPieChartModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    ExLegendModule,
                    ExChipModule,
                    ExLabelModule
                ],
                declarations: [
                    ExPieChartComponent
                ],
                exports: [
                    ExPieChartComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExPieChartModule, { declarations: [ExPieChartComponent], imports: [CommonModule,
        ExIconModule,
        ExLegendModule,
        ExChipModule,
        ExLabelModule], exports: [ExPieChartComponent] }); })();

function ExRadioButtonsComponent_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 3);
    i0.ɵɵlistener("exFocusChange", function ExRadioButtonsComponent_mat_radio_button_2_Template_mat_radio_button_exFocusChange_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onFocusChange($event)); })("focusout", function ExRadioButtonsComponent_mat_radio_button_2_Template_mat_radio_button_focusout_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onBlur($event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-radio-buttons-input-button  ", i0.ɵɵpipeBind1(1, 9, "ex-radio-buttons-input-button-" + button_r1.value.toString()), "");
    i0.ɵɵclassProp("cdk-keyboard-focused", ctx_r0.isFieldFocused);
    i0.ɵɵproperty("value", button_r1.value)("exFocus", ctx_r0.isFieldFocused && ctx_r0.selectedValue === button_r1.value)("disabled", ctx_r0.isReadOnly);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 11, button_r1.label));
} }
class ExRadioButtonsComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * the radio button options
         */
        this.radioButtons = [];
        /**
         * the position of the label in relation to the radio button
         */
        this.labelPosition = 'after';
        /**
         * whether the radio buttons will be aligned vertically or horizontally
         */
        this.direction = 'horizontal';
        /**
         * the selected option. Emitted on selection change
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * selection change event MatRadioChange. Emitted on selection change
         */
        this.radioButtonsSelectionChange = new EventEmitter();
    }
    onSelectedValueChange(event) {
        this.selectedValueChange.emit(this.selectedValue);
        this.radioButtonsSelectionChange.emit(event);
    }
    writeValue(value) {
        this.selectedValue = value;
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        super.setValidState(isValid);
        this.cdr.markForCheck();
    }
    onFocusChange(event) {
        this.isFieldFocused = event;
    }
    static { this.ɵfac = function ExRadioButtonsComponent_Factory(t) { return new (t || ExRadioButtonsComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRadioButtonsComponent, selectors: [["ex-radio-buttons"]], viewQuery: function ExRadioButtonsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatRadioButton, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matRadioGroup = _t.first);
        } }, hostBindings: function ExRadioButtonsComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedValueChange", function ExRadioButtonsComponent_selectedValueChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExRadioButtonsComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { radioButtons: "radioButtons", selectedValue: "selectedValue", labelPosition: "labelPosition", direction: "direction" }, outputs: { selectedValueChange: "selectedValueChange", radioButtonsSelectionChange: "radioButtonsSelectionChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExRadioButtonsComponent)), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 8, consts: [[1, "ex-radio-buttons-wrapper", 3, "click"], ["exFormAriaAttributes", "", 1, "ex-radio-buttons-group", 3, "disabled", "labelPosition", "ngModel", "ngModelChange", "change"], [3, "value", "exFocus", "cdk-keyboard-focused", "class", "disabled", "exFocusChange", "focusout", 4, "ngFor", "ngForOf"], [3, "value", "exFocus", "disabled", "exFocusChange", "focusout"], [1, "ex-radio-label"]], template: function ExRadioButtonsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExRadioButtonsComponent_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelementStart(1, "mat-radio-group", 1);
            i0.ɵɵlistener("ngModelChange", function ExRadioButtonsComponent_Template_mat_radio_group_ngModelChange_1_listener($event) { return ctx.selectedValue = $event; })("change", function ExRadioButtonsComponent_Template_mat_radio_group_change_1_listener($event) { return ctx.onSelectedValueChange($event); });
            i0.ɵɵtemplate(2, ExRadioButtonsComponent_mat_radio_button_2_Template, 5, 13, "mat-radio-button", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("ex-radio-buttons-group-horizontal", ctx.direction === "horizontal")("ex-radio-buttons-group-vertical", ctx.direction === "vertical");
            i0.ɵɵproperty("disabled", ctx.disabled)("labelPosition", ctx.labelPosition)("ngModel", ctx.selectedValue);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.radioButtons);
        } }, dependencies: [i1$5.NgForOf, i1$6.NgControlStatus, i1$6.NgModel, i8.MatRadioGroup, i8.MatRadioButton, ExFocusDirective, ExFormAriaAttributesDirective, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-radio-buttons-wrapper[_ngcontent-%COMP%]{padding-top:3px;padding-bottom:3px}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]   .ex-radio-label[_ngcontent-%COMP%]{white-space:normal}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]   .ex-radio-buttons-input-button[_ngcontent-%COMP%]{margin-inline-end:20px}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]     label{margin-bottom:0!important}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]     .cdk-focused .mat-radio-outer-circle, .ex-radio-buttons-wrapper[_ngcontent-%COMP%]     .cdk-focused .mdc-radio__outer-circle{outline:black 1px solid!important}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]     .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled)   .mat-radio-inner-circle{background-color:#0e7bbafa!important}  .ex-radio-buttons-wrapper   .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled).mat-radio-checked .mat-radio-outer-circle{border-color:#0e7bbafa!important}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]     .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled)   .mat-radio-container:hover .mat-radio-ripple .mat-ripple-element{background-color:#000!important;opacity:.1!important}.ex-radio-buttons-wrapper[_ngcontent-%COMP%]     .mat-mdc-radio-button.mat-accent.mat-radio-disabled   .mat-radio-inner-circle{background-color:#0e7bbaaa!important}  .ex-radio-buttons-wrapper   .mat-mdc-radio-button.mat-accent.mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle{border-color:#0e7bbaaa!important}.ex-radio-buttons-group[_ngcontent-%COMP%]{display:flex;row-gap:10px}.ex-radio-buttons-group-horizontal[_ngcontent-%COMP%]{flex-direction:row;flex-wrap:wrap}.ex-radio-buttons-group-vertical[_ngcontent-%COMP%]{flex-direction:column}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRadioButtonsComponent, [{
        type: Component,
        args: [{ selector: 'ex-radio-buttons', host: {
                    '(selectedValueChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExRadioButtonsComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<div (click)=\"$event.stopPropagation()\" class=\"ex-radio-buttons-wrapper\">\n  <mat-radio-group class=\"ex-radio-buttons-group\"\n                   [class.ex-radio-buttons-group-horizontal]=\"direction === 'horizontal'\"\n                   [class.ex-radio-buttons-group-vertical]=\"direction === 'vertical'\" exFormAriaAttributes\n                   [disabled]=\"disabled\"\n                   [labelPosition]=\"labelPosition\" [(ngModel)]=\"selectedValue\" (change)=\"onSelectedValueChange($event)\"\n                   >\n    <mat-radio-button *ngFor=\"let button of radioButtons\" [value]=\"button.value\"\n                      [exFocus]=\"isFieldFocused && selectedValue === button.value\" (exFocusChange)=\"onFocusChange($event)\" [class.cdk-keyboard-focused]=\"isFieldFocused\"\n                      class=\"ex-radio-buttons-input-button  {{'ex-radio-buttons-input-button-'+button.value.toString() | generateHTMLId}}\" (focusout)=\"onBlur($event)\" [disabled]=\"isReadOnly\">\n      <span class=\"ex-radio-label\">{{button.label | translate}}</span>\n    </mat-radio-button>\n  </mat-radio-group>\n</div>\n", styles: [".ex-radio-buttons-wrapper{padding-top:3px;padding-bottom:3px}.ex-radio-buttons-wrapper .ex-radio-label{white-space:normal}.ex-radio-buttons-wrapper .ex-radio-buttons-input-button{margin-inline-end:20px}.ex-radio-buttons-wrapper ::ng-deep label{margin-bottom:0!important}.ex-radio-buttons-wrapper ::ng-deep .cdk-focused .mat-radio-outer-circle,.ex-radio-buttons-wrapper ::ng-deep .cdk-focused .mdc-radio__outer-circle{outline:black 1px solid!important}.ex-radio-buttons-wrapper ::ng-deep .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled) ::ng-deep .mat-radio-inner-circle{background-color:#0e7bbafa!important}::ng-deep .ex-radio-buttons-wrapper ::ng-deep .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled).mat-radio-checked .mat-radio-outer-circle{border-color:#0e7bbafa!important}.ex-radio-buttons-wrapper ::ng-deep .mat-mdc-radio-button.mat-accent:not(.mat-radio-disabled) ::ng-deep .mat-radio-container:hover .mat-radio-ripple .mat-ripple-element{background-color:#000!important;opacity:.1!important}.ex-radio-buttons-wrapper ::ng-deep .mat-mdc-radio-button.mat-accent.mat-radio-disabled ::ng-deep .mat-radio-inner-circle{background-color:#0e7bbaaa!important}::ng-deep .ex-radio-buttons-wrapper ::ng-deep .mat-mdc-radio-button.mat-accent.mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle{border-color:#0e7bbaaa!important}.ex-radio-buttons-group{display:flex;row-gap:10px}.ex-radio-buttons-group-horizontal{flex-direction:row;flex-wrap:wrap}.ex-radio-buttons-group-vertical{flex-direction:column}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { radioButtons: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], direction: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], radioButtonsSelectionChange: [{
            type: Output
        }], matRadioGroup: [{
            type: ViewChild,
            args: [MatRadioButton]
        }] }); })();

class ExRadioButtonsModule {
    static { this.ɵfac = function ExRadioButtonsModule_Factory(t) { return new (t || ExRadioButtonsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExRadioButtonsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            TranslateModule,
            MatRadioModule,
            MatTooltipModule,
            EXPipesModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRadioButtonsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    MatRadioModule,
                    MatTooltipModule,
                    EXPipesModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExRadioButtonsComponent
                ],
                exports: [
                    ExRadioButtonsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExRadioButtonsModule, { declarations: [ExRadioButtonsComponent], imports: [CommonModule,
        FormsModule,
        TranslateModule,
        MatRadioModule,
        MatTooltipModule,
        EXPipesModule,
        ExDirectivesModule], exports: [ExRadioButtonsComponent] }); })();

class Froala {
}

function ExRichTextEditorComponent_container_element_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExRichTextEditorComponent_container_element_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_container_element_0_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExRichTextEditorComponent_container_element_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExRichTextEditorComponent_container_element_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_container_element_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function ExRichTextEditorComponent_container_element_0_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExRichTextEditorComponent_container_element_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_container_element_0_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function ExRichTextEditorComponent_container_element_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "container-element", 4);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_container_element_0_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(2, ExRichTextEditorComponent_container_element_0_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(3, ExRichTextEditorComponent_container_element_0_ng_container_3_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r0.mode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "view");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "edit");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "both");
} }
function ExRichTextEditorComponent_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExRichTextEditorComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExRichTextEditorComponent_ng_template_1_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExRichTextEditorComponent_ng_template_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_1_ng_container_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementStart(2, "div", 11)(3, "ex-inline-editing-buttons", 12);
    i0.ɵɵlistener("saveClicked", function ExRichTextEditorComponent_ng_template_1_ng_container_2_ng_container_1_Template_ex_inline_editing_buttons_saveClicked_3_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.save()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function ExRichTextEditorComponent_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_1_ng_container_2_ng_container_1_Template, 4, 1, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
} }
function ExRichTextEditorComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-inline-editing", 7);
    i0.ɵɵlistener("editClicked", function ExRichTextEditorComponent_ng_template_1_Template_ex_inline_editing_editClicked_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onEditClicked()); })("editModeChange", function ExRichTextEditorComponent_ng_template_1_Template_ex_inline_editing_editModeChange_0_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.editMode = $event); });
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_1_ng_container_1_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(2, ExRichTextEditorComponent_ng_template_1_ng_container_2_Template, 2, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("editMode", ctx_r2.editMode)("isSingleSave", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isReadOnly);
} }
function ExRichTextEditorComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("froalaView", ctx_r23.text);
} }
function ExRichTextEditorComponent_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.placeholderText, " ");
} }
function ExRichTextEditorComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExRichTextEditorComponent_ng_template_3_div_0_Template, 1, 1, "div", 13);
    i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_3_ng_template_1_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r24 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.text)("ngIfElse", _r24);
} }
function ExRichTextEditorComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("froalaModelChange", function ExRichTextEditorComponent_ng_template_5_Template_div_froalaModelChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.text = $event); })("froalaModelChange", function ExRichTextEditorComponent_ng_template_5_Template_div_froalaModelChange_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28._textChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("froalaEditor", ctx_r6.froalaOptions)("froalaModel", ctx_r6.text);
} }
var changeDirection = function (dir, align) {
    // Wrap block tags.
    this.selection.save();
    this.html.wrap(true, true, true, true);
    this.selection.restore();
    // Get blocks.
    var elements = this.selection.blocks();
    // Save selection to restore it later.
    this.selection.save();
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element != this.el) {
            this.$(element)
                .css('direction', dir)
                .css('text-align', align)
                .removeClass('fr-temp-div');
        }
    }
    // Unwrap temp divs.
    this.html.unwrap();
    // Restore selection.
    this.selection.restore();
};
class ExRichTextEditorComponent {
    set mode(mode) {
        this._mode = mode;
        if (mode === 'edit') {
            this.onEditClicked();
        }
    }
    get mode() {
        return this._mode;
    }
    constructor(translate, sectionLayoutViewMode) {
        this.translate = translate;
        this.sectionLayoutViewMode = sectionLayoutViewMode;
        /**
         * The mode in which th rich text editor will open - view only, edit only or inlin editing mode
         */
        this._mode = 'both';
        this.readOnly = false;
        /**
         * event fired upon typing - including the text only
         */
        this.textOnly = new EventEmitter();
        /**
         * event fired upon typing - including the html text
         */
        this.textChange = new EventEmitter();
        /**
         * event fired whenever the save button is clicked
         */
        this.saveClicked = new EventEmitter();
        this.editMode = false;
        this.placeholderText = this.translate.instant('ng.general.rich_text_editor.placeholder');
        this.tooltipSizes = {
            'small': 10,
            'medium': 12,
            'default': 18
        };
    }
    ngOnInit() {
        this.importLanguageFile().then(() => {
            this.createFroalaEditor();
        });
        FroalaEditor.DefineIconTemplate('svgIconTemplate', '<svg class="ex-rich-editor-svg"><use href="[SRC]"/></svg>');
        FroalaEditor.DefineIcon('rightToLeftIcon', { SRC: '/ng/assets/svg-icons/rtl.svg#RTL', template: 'svgIconTemplate' });
        FroalaEditor.RegisterCommand('rightToLeft', {
            title: this.translate.instant('ng.general.rich_text_editor.rtl_text_direction'),
            focus: true,
            undo: true,
            icon: 'rightToLeftIcon',
            refreshAfterCallback: true,
            callback: function () {
                changeDirection.apply(this, ['rtl', 'right']);
            }
        });
        FroalaEditor.DefineIcon('leftToRightIcon', { SRC: '/ng/assets/svg-icons/ltr.svg#LTR', template: 'svgIconTemplate' });
        FroalaEditor.RegisterCommand('leftToRight', {
            title: this.translate.instant('ng.general.rich_text_editor.ltr_text_direction'),
            focus: true,
            undo: true,
            icon: 'leftToRightIcon',
            refreshAfterCallback: true,
            callback: function () {
                changeDirection.apply(this, ['ltr', 'left']);
            }
        });
    }
    importLanguageFile() {
        return this.lang && this.lang !== 'en' ? System.import(`${location.origin}/ng/assets/js/froala/languages/${this.lang}.js`) : Promise.resolve();
    }
    onEditClicked() {
        this.observer = new MutationObserver(list => {
            if (document.getElementsByClassName('fr-tooltip')[0]) {
                this.setTooltipSize();
                this.observer.disconnect();
            }
        });
        this.observer.observe(document.body, { attributes: false, childList: true, subtree: true });
    }
    createFroalaEditor() {
        this.froalaOptions = {
            pluginsEnabled: ['link', 'align', 'charCounter', 'codeBeautifier', 'codeView', 'colors',
                'draggable', 'embedly', 'emoticons', 'entities', 'fontAwesome', 'fontFamily', 'fontSize', 'fullscreen',
                'inlineStyle', 'inlineClass', 'lineBreaker', 'lineHeight', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote',
                'save', 'table', 'url', 'wordPaste', 'track_changes', 'table',
                'specialCharacters', 'print', 'markdown', 'inline_style',
                'inlineClass', 'fullscreen', 'forms', 'editInPopup', 'draggable', 'cryptojs', 'help'],
            charCounterCount: false,
            fileUpload: false,
            imageUpload: false,
            videoUpload: false,
            videoResponsive: false,
            attribution: false,
            key: "Ne2C1sA3F4H4A11B7D8jF1QUg1Xc2OZE1ABVJRDRNGGUH1ITrA1C7A6E6E1D4A3E1B9B6==",
            toolbarSticky: false,
            language: this.lang,
            placeholderText: this.placeholderText,
            allowedImageTypes: [],
            fontFamily: {
                'Arial, Helvetica, sans-serif': 'Arial',
                '\'Courier New\',Courier,monospace': 'Courier New',
                'Georgia,serif': 'Georgia',
                'Impact,Charcoal,sans-serif': 'Impact',
                '\'Lucida Console\',Monaco, monospace': 'Lucida Console',
                'Tahoma,Geneva,sans-serif': 'Tahoma',
                '\'Times New Roman\',Times,serif': 'Times New Roman',
                'Verdana,Geneva,sans-serif': 'Verdana',
            },
            toolbarButtons: {
                'moreText': {
                    'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                },
                'moreParagraph': {
                    'buttons': ['alignLeft', 'alignCenter', 'rightToLeft', 'leftToRight', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                },
                'moreRich': {
                    'buttons': ['markdown', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
                },
                'moreMisc': {
                    'buttons': ['undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'html', 'help'],
                    'align': 'right',
                    'buttonsVisible': 2
                }
            },
            events: {
                'initialized': function () {
                    Froala.editor = this;
                }
            },
        };
    }
    setTooltipSize() {
        const tooltipSize = this.tooltipSizes[this.density ?? 'default'] ?? this.tooltipSizes['default'];
        document.getElementsByClassName('fr-tooltip')[0].setAttribute('style', `font-size: ${tooltipSize}px`);
    }
    save() {
        this.editMode = false;
        this.saveClicked.emit();
    }
    getInnerText() {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.text;
        return tempDiv.innerText;
    }
    _textChange(text) {
        this.textChange.emit(text);
        this.textOnly.emit(this.getInnerText());
    }
    get isReadOnly() {
        return this.readOnly || (this.sectionLayoutViewMode && this.sectionLayoutViewMode());
    }
    static { this.ɵfac = function ExRichTextEditorComponent_Factory(t) { return new (t || ExRichTextEditorComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRichTextEditorComponent, selectors: [["ex-rich-text-editor"]], inputs: { lang: "lang", density: "density", text: "text", mode: "mode", readOnly: "readOnly" }, outputs: { textOnly: "textOnly", textChange: "textChange", saveClicked: "saveClicked" }, decls: 7, vars: 1, consts: [[3, "ngSwitch", 4, "ngIf"], ["both", ""], ["view", ""], ["edit", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngTemplateOutlet"], [3, "editMode", "isSingleSave", "editClicked", "editModeChange"], [4, "viewModeComponent"], [4, "ngIf"], [4, "editModeComponent"], [1, "froala-buttons"], [3, "saveClicked"], [3, "froalaView", 4, "ngIf", "ngIfElse"], ["placeholder", ""], [3, "froalaView"], ["id", "froalaEditor", 1, "editor-wrapper", 3, "froalaEditor", "froalaModel", "froalaModelChange"]], template: function ExRichTextEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExRichTextEditorComponent_container_element_0_Template, 4, 4, "container-element", 0);
            i0.ɵɵtemplate(1, ExRichTextEditorComponent_ng_template_1_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExRichTextEditorComponent_ng_template_3_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ExRichTextEditorComponent_ng_template_5_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.froalaOptions);
        } }, dependencies: [EditModeComponentDirective, ViewModeComponentDirective, ExInlineEditingButtonsComponent, ExInlineEditingComponent, i6$2.FroalaEditorDirective, i6$2.FroalaViewDirective, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgSwitch, i1$5.NgSwitchCase], styles: [".fr-box.fr-basic .fr-wrapper{border:0px}.fr-second-toolbar,.fr-toolbar{border:0px!important}.fr-toolbar .fr-command.fr-btn{height:inherit}.fr-toolbar .fr-command.fr-btn .ex-rich-editor-svg{padding-top:3px;padding-inline-start:1.5px}.fr-toolbar .fr-command.fr-btn svg{margin:5px}.fr-box.fr-basic .fr-element{font-size:inherit}.fr-view{line-height:normal;padding-inline-start:5px}.froala-buttons{padding-bottom:5px;padding-right:5px;padding-top:1px}em{font-style:italic;font-weight:inherit;color:inherit}body .fr-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;color:#fff;border-radius:4px;margin:14px;max-width:250px;padding:6px 8px;overflow:hidden;text-overflow:ellipsis;background:#616161e6}\n"], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRichTextEditorComponent, [{
        type: Component,
        args: [{ selector: 'ex-rich-text-editor', encapsulation: ViewEncapsulation.None, template: "<container-element [ngSwitch]=\"mode\" *ngIf=\"froalaOptions\">\n    <ng-container *ngSwitchCase=\"'view'\">\n        <ng-container *ngTemplateOutlet=\"view\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'edit'\">\n        <ng-container *ngTemplateOutlet=\"edit\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'both'\">\n        <ng-container *ngTemplateOutlet=\"both\"></ng-container>\n    </ng-container>\n</container-element>\n\n<ng-template #both>\n    <ex-inline-editing (editClicked)=\"onEditClicked()\" [(editMode)]=\"editMode\" [isSingleSave]=\"false\">\n        <ng-container *viewModeComponent>\n            <ng-container *ngTemplateOutlet=\"view\"></ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!isReadOnly\">\n            <ng-container *editModeComponent>\n                <ng-container *ngTemplateOutlet=\"edit\"></ng-container>\n                <div class=\"froala-buttons\">\n                    <ex-inline-editing-buttons (saveClicked)=\"save()\"></ex-inline-editing-buttons>\n                </div>\n            </ng-container>\n        </ng-container>\n    </ex-inline-editing>\n</ng-template>\n\n<ng-template #view>\n    <div *ngIf=\"text; else placeholder\" [froalaView]=\"text\"></div>\n    <ng-template #placeholder>\n        {{ placeholderText }}\n    </ng-template>\n</ng-template>\n\n<ng-template #edit>\n    <div id=\"froalaEditor\" [froalaEditor]=\"froalaOptions\" class=\"editor-wrapper\" [(froalaModel)]=\"text\"\n        (froalaModelChange)=\"_textChange($event)\">\n    </div>\n</ng-template>", styles: [".fr-box.fr-basic .fr-wrapper{border:0px}.fr-second-toolbar,.fr-toolbar{border:0px!important}.fr-toolbar .fr-command.fr-btn{height:inherit}.fr-toolbar .fr-command.fr-btn .ex-rich-editor-svg{padding-top:3px;padding-inline-start:1.5px}.fr-toolbar .fr-command.fr-btn svg{margin:5px}.fr-box.fr-basic .fr-element{font-size:inherit}.fr-view{line-height:normal;padding-inline-start:5px}.froala-buttons{padding-bottom:5px;padding-right:5px;padding-top:1px}em{font-style:italic;font-weight:inherit;color:inherit}body .fr-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;color:#fff;border-radius:4px;margin:14px;max-width:250px;padding:6px 8px;overflow:hidden;text-overflow:ellipsis;background:#616161e6}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE]
            }] }]; }, { lang: [{
            type: Input
        }], density: [{
            type: Input
        }], text: [{
            type: Input
        }], mode: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], textOnly: [{
            type: Output
        }], textChange: [{
            type: Output
        }], saveClicked: [{
            type: Output
        }] }); })();

class ExRichTextEditorModule {
    static { this.ɵfac = function ExRichTextEditorModule_Factory(t) { return new (t || ExRichTextEditorModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExRichTextEditorModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ExDirectivesModule,
            ExInlineEditingButtonsModule,
            ExInlineEditingModule,
            FroalaEditorModule,
            FroalaViewModule,
            CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRichTextEditorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ExDirectivesModule,
                    ExInlineEditingButtonsModule,
                    ExInlineEditingModule,
                    FroalaEditorModule,
                    FroalaViewModule,
                    CommonModule
                ],
                declarations: [
                    ExRichTextEditorComponent
                ],
                exports: [
                    ExRichTextEditorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExRichTextEditorModule, { declarations: [ExRichTextEditorComponent], imports: [ExDirectivesModule,
        ExInlineEditingButtonsModule,
        ExInlineEditingModule,
        FroalaEditorModule,
        FroalaViewModule,
        CommonModule], exports: [ExRichTextEditorComponent] }); })();

const animations$1 = [
    trigger('expandCollapse', [
        transition(':enter', [
            query('ex-search', [
                style({ transform: 'scaleX(0)', transformOrigin: 'right', opacity: 0 }),
                animate(100, style({ transform: 'scaleX(1)', opacity: 1 }))
            ])
        ]),
        transition(':leave', [
            query('ex-search', [
                style({ transform: 'scaleX(1)', transformOrigin: 'right', opacity: 0.5 }),
                animate(100, style({ transform: 'scaleX(0)', opacity: 0 }))
            ])
        ])
    ])
];

function ExSearchToggleComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 5)(2, "ex-search", 6);
    i0.ɵɵlistener("searchTriggered", function ExSearchToggleComponent_ng_container_1_Template_ex_search_searchTriggered_2_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1._searchTriggered($event)); })("click", function ExSearchToggleComponent_ng_container_1_Template_ex_search_click_2_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@expandCollapse", undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("blueOnFocus", false)("searchText", ctx_r0.searchTerm || "")("isLoading", ctx_r0.searching)("placeholder", i0.ɵɵpipeBind1(3, 6, "ng.general.search"))("autoFocus", true);
} }
class ExSearchToggleComponent {
    constructor() {
        this.showSearch = false;
        this.showSearchChange = new EventEmitter();
        this.searchTriggered = new EventEmitter();
    }
    onSearchClicked() {
        this.showSearch = true;
        this.showSearchChange.emit(this.showSearch);
    }
    _searchTriggered(e) {
        this.searchTriggered.emit(e);
    }
    onClose() {
        this.showSearch = false;
        this.showSearchChange.emit(this.showSearch);
    }
    static { this.ɵfac = function ExSearchToggleComponent_Factory(t) { return new (t || ExSearchToggleComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSearchToggleComponent, selectors: [["ex-search-toggle"]], inputs: { showSearch: "showSearch", uniqueSelector: "uniqueSelector" }, outputs: { showSearchChange: "showSearchChange", searchTriggered: "searchTriggered" }, decls: 6, vars: 6, consts: [[1, "ex-search-toggle-wrapper"], [4, "ngIf"], ["ariaLabel", "ng.general.search", "type", "action", 1, "sel-ex-button", 3, "hidden", "uniqueSelector", "iconSide", "click"], ["icon", "", 1, "uxf-icon", "uxf-search"], ["ariaLabel", "ng.exSearchToggle.closeSearch", "type", "action", 1, "sel-ex-button-close", 3, "hidden", "iconSide", "click"], [1, "ex-search-toggle-anim"], [3, "blueOnFocus", "searchText", "isLoading", "placeholder", "autoFocus", "searchTriggered", "click"]], template: function ExSearchToggleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExSearchToggleComponent_ng_container_1_Template, 4, 8, "ng-container", 1);
            i0.ɵɵelementStart(2, "ex-button", 2);
            i0.ɵɵlistener("click", function ExSearchToggleComponent_Template_ex_button_click_2_listener() { return ctx.onSearchClicked(); });
            i0.ɵɵelement(3, "i", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ex-button", 4);
            i0.ɵɵlistener("click", function ExSearchToggleComponent_Template_ex_button_click_4_listener() { return ctx.onClose(); });
            i0.ɵɵtext(5, "Close");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showSearch);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.showSearch)("uniqueSelector", ctx.uniqueSelector)("iconSide", "left");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.showSearch)("iconSide", "left");
        } }, dependencies: [i1$5.NgIf, ExSearchComponent, ExButtonComponent, i1$2.TranslatePipe], styles: [".ex-search-toggle-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:1;justify-content:flex-end}.ex-search-toggle-wrapper[_ngcontent-%COMP%]   .ex-search-toggle-anim[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:1;justify-content:flex-end;margin-right:5px}.ex-search-toggle-wrapper[_ngcontent-%COMP%]   ex-search[_ngcontent-%COMP%]{flex:1;color:#000}.ex-search-toggle-wrapper[_ngcontent-%COMP%]     ex-button button.ex-button-wrapper{padding:0 5px;min-width:30px;color:#d8d8d8}.ex-search-toggle-wrapper[_ngcontent-%COMP%]     ex-button button.ex-button-wrapper>div.ex-button-icon-left{margin:0;margin-right:0!important;max-width:20px}.ex-search-toggle-wrapper[_ngcontent-%COMP%]     ex-button button.ex-button-wrapper>div.ex-button-icon-left i{color:#d8d8d8}.ex-search-toggle-wrapper[_ngcontent-%COMP%]     ex-button button.ex-button-wrapper:hover{color:#d8d8d8;background:transparent}.ex-search-toggle-wrapper[_ngcontent-%COMP%]   [hidden][_ngcontent-%COMP%]{display:none!important}"], data: { animation: animations$1 }, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSearchToggleComponent, [{
        type: Component,
        args: [{ selector: 'ex-search-toggle', animations: animations$1, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-search-toggle-wrapper\">\n    <ng-container *ngIf=\"showSearch\">\n        <span class=\"ex-search-toggle-anim\" @expandCollapse>\n            <ex-search [blueOnFocus]=\"false\" [searchText]=\"searchTerm || ''\" [isLoading]=\"searching\"\n                (searchTriggered)=\"_searchTriggered($event)\" (click)=\"$event.stopPropagation()\"\n                [placeholder]=\"'ng.general.search' | translate\" [autoFocus]=\"true\"></ex-search>\n        </span>\n    </ng-container>\n\n    <ex-button ariaLabel=\"ng.general.search\" [hidden]=\"showSearch\" type=\"action\" [uniqueSelector]=\"uniqueSelector\" (click)=\"onSearchClicked()\" [iconSide]=\"'left'\" class = \"sel-ex-button\">\n        <i icon class=\"uxf-icon uxf-search\"></i>\n    </ex-button>\n    <ex-button ariaLabel=\"ng.exSearchToggle.closeSearch\" [hidden]=\"!showSearch\" type=\"action\" (click)=\"onClose()\" [iconSide]=\"'left'\" class = \"sel-ex-button-close\">Close</ex-button>\n</div>\n", styles: [".ex-search-toggle-wrapper{display:flex;flex-direction:row;flex:1;justify-content:flex-end}.ex-search-toggle-wrapper .ex-search-toggle-anim{display:flex;flex-direction:row;flex:1;justify-content:flex-end;margin-right:5px}.ex-search-toggle-wrapper ex-search{flex:1;color:#000}.ex-search-toggle-wrapper ::ng-deep ex-button button.ex-button-wrapper{padding:0 5px;min-width:30px;color:#d8d8d8}.ex-search-toggle-wrapper ::ng-deep ex-button button.ex-button-wrapper>div.ex-button-icon-left{margin:0;margin-right:0!important;max-width:20px}.ex-search-toggle-wrapper ::ng-deep ex-button button.ex-button-wrapper>div.ex-button-icon-left i{color:#d8d8d8}.ex-search-toggle-wrapper ::ng-deep ex-button button.ex-button-wrapper:hover{color:#d8d8d8;background:transparent}.ex-search-toggle-wrapper [hidden]{display:none!important}\n"] }]
    }], function () { return []; }, { showSearch: [{
            type: Input
        }], uniqueSelector: [{
            type: Input
        }], showSearchChange: [{
            type: Output
        }], searchTriggered: [{
            type: Output
        }] }); })();

class ExSearchToggleModule {
    static { this.ɵfac = function ExSearchToggleModule_Factory(t) { return new (t || ExSearchToggleModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSearchToggleModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatIconModule,
            ExSearchModule,
            TranslateModule,
            ExButtonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSearchToggleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    ExSearchModule,
                    TranslateModule,
                    ExButtonModule
                ],
                declarations: [
                    ExSearchToggleComponent
                ],
                exports: [
                    ExSearchToggleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSearchToggleModule, { declarations: [ExSearchToggleComponent], imports: [CommonModule,
        MatIconModule,
        ExSearchModule,
        TranslateModule,
        ExButtonModule], exports: [ExSearchToggleComponent] }); })();

function ExSelectionListComponent_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 2);
    i0.ɵɵlistener("blur", function ExSelectionListComponent_ex_checkbox_1_Template_ex_checkbox_blur_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onBlur($event)); })("checkedChange", function ExSelectionListComponent_ex_checkbox_1_Template_ex_checkbox_checkedChange_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r3); const option_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onSelectionChange(option_r1.key, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", option_r1.value)("disabled", ctx_r0.disabled)("checked", ctx_r0.isSelected(option_r1.key));
} }
class ExSelectionListComponent extends ExControlValueAccessor {
    constructor(sectionLayoutViewModeObservable, cdr) {
        super(sectionLayoutViewModeObservable, cdr);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.cdr = cdr;
        /**
         * the options of the selection list as an array of key, value pairs.
         */
        this.selectionlistValues = [];
        /**
         * The selected list options corresponding to the key from selectionlistValues.
         */
        this.selectedValues = [];
        /**
         * The selected list options. Emitted on selection change.
         */
        this.selectedValuesChange = new EventEmitter();
    }
    isSelected(key) {
        return this.selectedValues.includes(key);
    }
    onSelectionChange(key, selected) {
        if (selected === true) {
            this.selectedValues.push(key);
        }
        else { // selected === false
            const index = this.selectedValues.indexOf(key);
            if (index > -1) {
                this.selectedValues.splice(index, 1);
            }
        }
        this.selectedValuesChange.emit(this.selectedValues);
    }
    writeValue(values) {
        this.selectedValues = values;
    }
    static { this.ɵfac = function ExSelectionListComponent_Factory(t) { return new (t || ExSelectionListComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSelectionListComponent, selectors: [["ex-selection-list"]], hostBindings: function ExSelectionListComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedValuesChange", function ExSelectionListComponent_selectedValuesChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExSelectionListComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { selectionlistValues: "selectionlistValues", selectedValues: "selectedValues" }, outputs: { selectedValuesChange: "selectedValuesChange" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExSelectionListComponent)), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[1, "ex-selection-list-wrapper", 3, "click"], ["class", "ex-selection-list-checkbox", 3, "label", "disabled", "checked", "blur", "checkedChange", 4, "ngFor", "ngForOf"], [1, "ex-selection-list-checkbox", 3, "label", "disabled", "checked", "blur", "checkedChange"]], template: function ExSelectionListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExSelectionListComponent_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵtemplate(1, ExSelectionListComponent_ex_checkbox_1_Template, 1, 3, "ex-checkbox", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.selectionlistValues);
        } }, dependencies: [i1$5.NgForOf, ExCheckboxComponent], styles: [".ex-selection-list-wrapper[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center}.ex-selection-list-wrapper[_ngcontent-%COMP%]   .ex-selection-list-checkbox[_ngcontent-%COMP%]{flex:1;margin-inline-end:10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSelectionListComponent, [{
        type: Component,
        args: [{ selector: 'ex-selection-list', host: {
                    '(selectedValuesChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExSelectionListComponent), template: "<div (click)=\"$event.stopPropagation()\" class=\"ex-selection-list-wrapper\">\r\n    <ex-checkbox *ngFor=\"let option of selectionlistValues\" class=\"ex-selection-list-checkbox\" [label]=\"option.value\"\r\n        [disabled]=\"disabled\" [checked]=\"isSelected(option.key)\" (blur)=\"onBlur($event)\"\r\n        (checkedChange)=\"onSelectionChange(option.key, $event)\">\r\n    </ex-checkbox>\r\n</div>", styles: [".ex-selection-list-wrapper{display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center}.ex-selection-list-wrapper .ex-selection-list-checkbox{flex:1;margin-inline-end:10px}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }]; }, { selectionlistValues: [{
            type: Input
        }], selectedValues: [{
            type: Input
        }], selectedValuesChange: [{
            type: Output
        }] }); })();

class ExSelectionListModule {
    static { this.ɵfac = function ExSelectionListModule_Factory(t) { return new (t || ExSelectionListModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSelectionListModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatTooltipModule,
            ExCheckboxModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSelectionListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatTooltipModule,
                    ExCheckboxModule
                ],
                declarations: [
                    ExSelectionListComponent
                ],
                exports: [
                    ExSelectionListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSelectionListModule, { declarations: [ExSelectionListComponent], imports: [CommonModule,
        FormsModule,
        MatTooltipModule,
        ExCheckboxModule], exports: [ExSelectionListComponent] }); })();

const Animations$2 = [
    trigger('arrowFlip', [
        state('down', style({
            transform: 'rotate(0deg)',
            transformOrigin: 'center center'
        })),
        state('up', style({
            transform: 'rotate(-180deg)'
        })),
        transition('down <=> up', [
            animate('0.25s')
        ])
    ]),
    trigger('expand', [
        state('*', style({
            height: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('void', style({
            height: '0px',
            overflow: 'hidden',
            paddingTop: '0px',
            paddingBottom: '0px'
        })),
        transition('void <=> *', [
            animate('0.25s')
        ])
    ])
];

function ExShowMoreLessComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function ExShowMoreLessComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.toggleDetailsShown()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", !ctx_r0.detailsShown ? i0.ɵɵpipeBind1(2, 2, ctx_r0.showMoreLable) : i0.ɵɵpipeBind1(3, 4, ctx_r0.showLessLable), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("@arrowFlip", ctx_r0.detailsShown ? "up" : "down");
} }
function ExShowMoreLessComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@expand", undefined);
} }
function ExShowMoreLessComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ExShowMoreLessComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.toggleDetailsShown()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "i", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", !ctx_r2.detailsShown ? i0.ɵɵpipeBind1(2, 2, ctx_r2.showMoreLable) : i0.ɵɵpipeBind1(3, 4, ctx_r2.showLessLable), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("@arrowFlip", ctx_r2.detailsShown ? "up" : "down");
} }
const _c0$F = ["*"];
class ExShowMoreLessComponent {
    constructor() {
        this.detailsShown = false;
        this.showMoreLable = 'ng.general.more_details';
        this.showLessLable = 'ng.general.less_details';
        this.buttonPosition = 'below';
        this.change = new EventEmitter();
    }
    toggleDetailsShown() {
        this.detailsShown = !this.detailsShown;
        this.change.emit(this.detailsShown ? 'MORE' : 'LESS');
    }
    static { this.ɵfac = function ExShowMoreLessComponent_Factory(t) { return new (t || ExShowMoreLessComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExShowMoreLessComponent, selectors: [["ex-show-more-less"]], inputs: { detailsShown: "detailsShown", showMoreLable: "showMoreLable", showLessLable: "showLessLable", buttonPosition: "buttonPosition" }, outputs: { change: "change" }, ngContentSelectors: _c0$F, decls: 3, vars: 3, consts: [["class", "ex-show-more-less-button sel-ex-show-more-less-button-above", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "ex-show-more-less-button sel-ex-show-more-less-button-below", 3, "click", 4, "ngIf"], [1, "ex-show-more-less-button", "sel-ex-show-more-less-button-above", 3, "click"], [1, "fa", "fa-angle-down"], [1, "ex-show-more-less-button", "sel-ex-show-more-less-button-below", 3, "click"]], template: function ExShowMoreLessComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ExShowMoreLessComponent_button_0_Template, 5, 6, "button", 0);
            i0.ɵɵtemplate(1, ExShowMoreLessComponent_ng_container_1_Template, 3, 1, "ng-container", 1);
            i0.ɵɵtemplate(2, ExShowMoreLessComponent_button_2_Template, 5, 6, "button", 2);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.buttonPosition === "above");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.detailsShown);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.buttonPosition === "below");
        } }, dependencies: [i1$5.NgIf, i1$2.TranslatePipe], styles: [".ex-show-more-less-button[_ngcontent-%COMP%]{border:0px;background:none}"], data: { animation: [Animations$2] }, changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExShowMoreLessComponent, [{
        type: Component,
        args: [{ selector: 'ex-show-more-less', animations: [Animations$2], changeDetection: ChangeDetectionStrategy.OnPush, template: "<button *ngIf=\"buttonPosition === 'above'\" class=\"ex-show-more-less-button sel-ex-show-more-less-button-above\"\n    (click)=\"toggleDetailsShown()\">\n    {{ !detailsShown ? (showMoreLable | translate) : (showLessLable | translate) }}\n    <i [@arrowFlip]=\"detailsShown ? 'up' : 'down'\" class=\"fa fa-angle-down\"></i>\n</button>\n\n<ng-container *ngIf=\"detailsShown\">\n    <div @expand>\n        <ng-content></ng-content>\n    </div>\n</ng-container>\n\n<button *ngIf=\"buttonPosition === 'below'\" class=\"ex-show-more-less-button sel-ex-show-more-less-button-below\"\n    (click)=\"toggleDetailsShown()\">\n    {{ !detailsShown ? (showMoreLable | translate) : (showLessLable | translate) }}\n    <i [@arrowFlip]=\"detailsShown ? 'up' : 'down'\" class=\"fa fa-angle-down\"></i>\n</button>", styles: [".ex-show-more-less-button{border:0px;background:none}\n"] }]
    }], function () { return []; }, { detailsShown: [{
            type: Input
        }], showMoreLable: [{
            type: Input
        }], showLessLable: [{
            type: Input
        }], buttonPosition: [{
            type: Input
        }], change: [{
            type: Output
        }] }); })();

class ExShowMoreLessModule {
    static { this.ɵfac = function ExShowMoreLessModule_Factory(t) { return new (t || ExShowMoreLessModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExShowMoreLessModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExShowMoreLessModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule
                ],
                declarations: [
                    ExShowMoreLessComponent
                ],
                exports: [
                    ExShowMoreLessComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExShowMoreLessModule, { declarations: [ExShowMoreLessComponent], imports: [CommonModule,
        TranslateModule], exports: [ExShowMoreLessComponent] }); })();

const _c0$E = ["*"];
class ExTabComponent {
    static { this.ɵfac = function ExTabComponent_Factory(t) { return new (t || ExTabComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExTabComponent, selectors: [["ex-tab"]], ngContentSelectors: _c0$E, decls: 2, vars: 0, template: function ExTabComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTabComponent, [{
        type: Component,
        args: [{ selector: 'ex-tab', template: "<div>\n  <ng-content></ng-content>\n</div>\n\n" }]
    }], null, null); })();

class ExTabModule {
    static { this.ɵfac = function ExTabModule_Factory(t) { return new (t || ExTabModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExTabModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTabModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    ExTabComponent
                ],
                exports: [
                    ExTabComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExTabModule, { declarations: [ExTabComponent], exports: [ExTabComponent] }); })();

function ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "ex-icon", 9);
    i0.ɵɵtext(2, " \u00A0");
    i0.ɵɵelementEnd();
} }
const _c0$D = function (a0) { return [a0]; };
function ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "i", 11);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$D, tab_r4.iconClass));
} }
function ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_span_0_Template, 3, 0, "span", 7);
    i0.ɵɵtemplate(1, ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_div_1_Template, 3, 3, "div", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const tab_r4 = ctx_r10.$implicit;
    const i_r5 = ctx_r10.index;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", tab_r4.counterFieldName && ctx_r6.hasContent(i_r5, tab_r4.counterFieldName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tab_r4.iconClass);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("sel-tab-", tab_r4.label, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, tab_r4.label));
} }
function ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab");
    i0.ɵɵtemplate(1, ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_ng_template_1_Template, 5, 8, "ng-template", 5);
    i0.ɵɵelement(2, "ex-component-loader", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("componentFactoryItem", tab_r4.tabContent)("data", tab_r4.tabContent.data);
} }
function ExTabsWrapperComponent_mat_tab_group_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab-group", 3);
    i0.ɵɵlistener("selectedTabChange", function ExTabsWrapperComponent_mat_tab_group_1_Template_mat_tab_group_selectedTabChange_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onTabChanged()); })("selectedIndexChange", function ExTabsWrapperComponent_mat_tab_group_1_Template_mat_tab_group_selectedIndexChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.selectedTab = $event); });
    i0.ɵɵtemplate(1, ExTabsWrapperComponent_mat_tab_group_1_mat_tab_1_Template, 3, 2, "mat-tab", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedIndex", ctx_r0.selectedTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.tabs);
} }
function ExTabsWrapperComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 6);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("componentFactoryItem", ctx_r2.tabs[0].tabContent)("data", ctx_r2.tabs[0].tabContent.data);
} }
class ExTabsWrapperComponent {
    constructor() {
        this.itemsCountSubject = new BehaviorSubject(0);
        /**
         * the tabs data
         */
        this.tabs = null;
        /**
         * show tabs in case of single tab
         */
        this.showTabs = null;
        /**
         * enable using export to excel
         */
        this.hasExport = false;
        /**
         * Event fired when an action is clicked
         */
        this.actionClicked = new EventEmitter();
        /**
         * Event fired when a tab changed
         */
        this.tabChange = new EventEmitter();
        /**
         * Event fired when a sort changed
         */
        this.sortChange = new EventEmitter();
        /**
         * used by the tabs' labels
         */
        this.counters = new Array(20);
        /**
         * selected tab index
         */
        this.selectedTab = 0;
        this.tabActions = [];
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('tabs') || changes.hasOwnProperty('selectedTab') || changes.hasOwnProperty('pageActions')) {
            this.initTabActions();
        }
    }
    hasContent(index, counterField) {
        if (counterField && this.compLoader) {
            var tabComponent = this.compLoader.toArray()[index];
            return (tabComponent.componentRef.instance[counterField] && tabComponent.componentRef.instance[counterField] > 0);
        }
        return false;
    }
    _actionClicked(value) {
        var isPageAction = this.pageActions.filter(x => x.value == value).length > 0;
        if (isPageAction) {
            this.actionClicked.emit(value);
        }
        else { //if a tab action, call the child component action
            var childComponent = this.compLoader.toArray()[this.selectedTab];
            childComponent.componentRef.instance.onActionClicked(value);
        }
    }
    _sortChanged(sort) {
        const { order, sortBy, index } = sort;
        var childComponent = this.compLoader.toArray()[this.selectedTab];
        this.tabs[this.selectedTab].sorts[index].selectedOption = sortBy;
        childComponent.componentRef.instance.onSortChanged(order, sortBy, index);
    }
    onTabChanged() {
        this.initTabActions();
        this.tabChange.emit({ tabContent: this.tabs[this.selectedTab], index: this.selectedTab });
    }
    initTabActions() {
        const tab = this.tabs[this.selectedTab];
        if (tab.actions && this.pageActions) {
            this.tabActions = this.tabs[this.selectedTab].actions.concat(this.pageActions);
        }
        else {
            this.tabActions = this.pageActions;
        }
    }
    static { this.ɵfac = function ExTabsWrapperComponent_Factory(t) { return new (t || ExTabsWrapperComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExTabsWrapperComponent, selectors: [["ex-tabs-wrapper"]], viewQuery: function ExTabsWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatTabGroup, 5);
            i0.ɵɵviewQuery(ExComponentLoaderComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabGroup = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.compLoader = _t);
        } }, inputs: { tabs: "tabs", showTabs: "showTabs", pageActions: "pageActions", hasExport: "hasExport", selectedTab: "selectedTab" }, outputs: { actionClicked: "actionClicked", tabChange: "tabChange", sortChange: "sortChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 5, consts: [[1, "ex-tabs-header", "ex-list-header-no-border", 3, "actions", "hasExport", "sorts", "actionClicked", "sortChange"], ["class", "mat-tab-group-density", "dynamicHeight", "", 3, "selectedIndex", "selectedTabChange", "selectedIndexChange", 4, "ngIf", "ngIfElse"], ["singleTab", ""], ["dynamicHeight", "", 1, "mat-tab-group-density", 3, "selectedIndex", "selectedTabChange", "selectedIndexChange"], [4, "ngFor", "ngForOf"], ["mat-tab-label", ""], [3, "componentFactoryItem", "data"], [4, "ngIf"], ["icon", "", 4, "ngIf"], ["iconType", "matIcon", "iconName", "lens", "sizePx", "10px", 1, "ex-tabs-content-icon"], ["icon", ""], [3, "ngClass"]], template: function ExTabsWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-list-header", 0);
            i0.ɵɵlistener("actionClicked", function ExTabsWrapperComponent_Template_ex_list_header_actionClicked_0_listener($event) { return ctx._actionClicked($event); })("sortChange", function ExTabsWrapperComponent_Template_ex_list_header_sortChange_0_listener($event) { return ctx._sortChanged($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(1, ExTabsWrapperComponent_mat_tab_group_1_Template, 2, 2, "mat-tab-group", 1);
            i0.ɵɵtemplate(2, ExTabsWrapperComponent_ng_template_2_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            i0.ɵɵproperty("actions", ctx.tabActions)("hasExport", ctx.hasExport)("sorts", ctx.tabs[ctx.selectedTab].sorts);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.tabs.length > 1 || ctx.showTabs)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i2$6.MatTabLabel, i2$6.MatTab, i2$6.MatTabGroup, ExComponentLoaderComponent, ExListHeaderComponent, ExIconComponent, i1$2.TranslatePipe], styles: ["mat-tab-group[_ngcontent-%COMP%]{height:100%}mat-tab-group[_ngcontent-%COMP%]     mat-tab-header{top:0;z-index:2;position:sticky;background:#fff;border-bottom:1px solid #ccc!important}mat-tab-group[_ngcontent-%COMP%]     mat-tab-header .mat-mdc-tab-label{font-size:18px}mat-tab-group[_ngcontent-%COMP%]     mat-tab-header .mat-mdc-tab-label.mat-mdc-tab-label-active{opacity:1}mat-tab-group[_ngcontent-%COMP%]     mat-tab-header>.mat-mdc-tab-header-pagination{display:none!important}mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-body-wrapper{height:calc(100% - 49px)}mat-tab-group[_ngcontent-%COMP%]     mat-tab-body{height:100%;overflow:hidden}mat-tab-group[_ngcontent-%COMP%]     mat-tab-body>.mat-mdc-tab-body-content{overflow-y:auto}.ex-tabs-header[_ngcontent-%COMP%]{position:absolute;right:30px;z-index:10;border-bottom:0px}.ex-list-header-no-border[_ngcontent-%COMP%]     div{border-bottom:0px!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTabsWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-tabs-wrapper', template: "<ex-list-header class=\"ex-tabs-header ex-list-header-no-border\" \n[actions]=\"tabActions\" [hasExport]=\"hasExport\" (actionClicked)=\"_actionClicked($event)\"\n[sorts]=\"tabs[selectedTab].sorts\" (sortChange)=\"_sortChanged($event)\"></ex-list-header>\n<mat-tab-group class=\"mat-tab-group-density\" (selectedTabChange)=\"onTabChanged();\" *ngIf=\"tabs.length > 1 || showTabs ;else singleTab\"[(selectedIndex)]=\"selectedTab\" dynamicHeight>\n  <mat-tab *ngFor=\"let tab of tabs; let i = index\">\n    <ng-template mat-tab-label>\n      <span *ngIf=\"tab.counterFieldName && hasContent(i, tab.counterFieldName)\">\n        <ex-icon iconType=\"matIcon\" iconName=\"lens\" class=\"ex-tabs-content-icon\" sizePx=\"10px\">\n        </ex-icon>\n        &nbsp;</span>\n      <div *ngIf=\"tab.iconClass\" icon>\n        <i [ngClass]=\"[tab.iconClass]\">&nbsp;</i>\n      </div>\n      <span class=\"sel-tab-{{ tab.label}}\">{{tab.label | translate}}</span>\n    </ng-template>\n    <ex-component-loader [componentFactoryItem]=\"tab.tabContent\" [data]=\"tab.tabContent.data\">\n    </ex-component-loader>\n  </mat-tab>\n</mat-tab-group>\n\n<ng-template #singleTab>\n  <ex-component-loader [componentFactoryItem]=\"tabs[0].tabContent\" [data]=\"tabs[0].tabContent.data\">\n  </ex-component-loader>\n</ng-template>", styles: ["mat-tab-group{height:100%}mat-tab-group ::ng-deep mat-tab-header{top:0;z-index:2;position:sticky;background:#fff;border-bottom:1px solid #ccc!important}mat-tab-group ::ng-deep mat-tab-header .mat-mdc-tab-label{font-size:18px}mat-tab-group ::ng-deep mat-tab-header .mat-mdc-tab-label.mat-mdc-tab-label-active{opacity:1}mat-tab-group ::ng-deep mat-tab-header>.mat-mdc-tab-header-pagination{display:none!important}mat-tab-group ::ng-deep .mat-mdc-tab-body-wrapper{height:calc(100% - 49px)}mat-tab-group ::ng-deep mat-tab-body{height:100%;overflow:hidden}mat-tab-group ::ng-deep mat-tab-body>.mat-mdc-tab-body-content{overflow-y:auto}.ex-tabs-header{position:absolute;right:30px;z-index:10;border-bottom:0px}.ex-list-header-no-border ::ng-deep div{border-bottom:0px!important}\n"] }]
    }], function () { return []; }, { compLoader: [{
            type: ViewChildren,
            args: [ExComponentLoaderComponent]
        }], tabs: [{
            type: Input
        }], showTabs: [{
            type: Input
        }], pageActions: [{
            type: Input
        }], hasExport: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], tabChange: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], selectedTab: [{
            type: Input
        }], tabGroup: [{
            type: ViewChild,
            args: [MatTabGroup]
        }] }); })();

class ExTabsWrapperModule {
    static { this.ɵfac = function ExTabsWrapperModule_Factory(t) { return new (t || ExTabsWrapperModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExTabsWrapperModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTabsModule,
            RouterModule,
            ExComponentLoaderModule,
            ExListHeaderModule,
            TranslateModule,
            ExIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTabsWrapperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTabsModule,
                    RouterModule,
                    ExComponentLoaderModule,
                    ExListHeaderModule,
                    TranslateModule,
                    ExIconModule
                ],
                declarations: [
                    ExTabsWrapperComponent
                ],
                exports: [
                    ExTabsWrapperComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExTabsWrapperModule, { declarations: [ExTabsWrapperComponent], imports: [CommonModule,
        MatTabsModule,
        RouterModule,
        ExComponentLoaderModule,
        ExListHeaderModule,
        TranslateModule,
        ExIconModule], exports: [ExTabsWrapperComponent] }); })();

const _c0$C = ["thumbnailImage"];
function ExThumbnailComponent_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r0.showPlaceholder || !ctx_r0.isLoaded && ctx_r0.imgSrc)("iconName", ctx_r0.icon.iconName)("color", ctx_r0.icon.iconColor)("size", ctx_r0.iconSize)("tooltip", ctx_r0.icon.tooltip)("callback", (ctx_r0.icon == null ? null : ctx_r0.icon.callback) ? ctx_r0.icon == null ? null : ctx_r0.icon.callback : null);
} }
function ExThumbnailComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "ex-avatar", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("imgSrc", ctx_r1.imgSrc)("diameter", 45);
} }
function ExThumbnailComponent_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r6.maxHeight, "px")("width", ctx_r6.fixedWidth && ctx_r6.fixedWidth + ctx_r6.fixWidthOperator);
    i0.ɵɵproperty("hidden", (!ctx_r6.showPlaceholder && ctx_r6.isLoaded || !ctx_r6.showPlaceholder && ctx_r6.imgSrc) && !ctx_r6.errorImg);
} }
function ExThumbnailComponent_ng_template_3_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-height", ctx_r7.maxHeight, "px")("width", ctx_r7.fixedWidth, "px");
    i0.ɵɵproperty("src", "/ng/assets/images/thumbnail-placeholder-user.svg", i0.ɵɵsanitizeUrl)("hidden", (!ctx_r7.showPlaceholder && ctx_r7.isLoaded || !ctx_r7.showPlaceholder && ctx_r7.imgSrc) && !ctx_r7.errorImg);
} }
function ExThumbnailComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 8, 9);
    i0.ɵɵlistener("load", function ExThumbnailComponent_ng_template_3_Template_img_load_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onLoad()); })("error", function ExThumbnailComponent_ng_template_3_Template_img_error_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onError()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ExThumbnailComponent_ng_template_3_div_2_Template, 3, 5, "div", 10);
    i0.ɵɵtemplate(3, ExThumbnailComponent_ng_template_3_img_3_Template, 1, 6, "img", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    let tmp_2_0;
    i0.ɵɵstyleProp("max-height", ctx_r3.maxHeight, "px")("width", ctx_r3.fixedWidth && ctx_r3.fixedWidth + ctx_r3.fixWidthOperator);
    i0.ɵɵproperty("src", (tmp_2_0 = (tmp_2_0 = ctx_r3.syndeticsSrc) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r3.googleImgSrc) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r3.imgSrc, i0.ɵɵsanitizeUrl)("hidden", ctx_r3.showPlaceholder || !ctx_r3.isLoaded || !ctx_r3.imgSrc);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.placeHolderType === "book-cover");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.placeHolderType === "user");
} }
function ExThumbnailComponent_div_5_ng_container_1_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 17);
} if (rf & 2) {
    const icon_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconName", icon_r12 == null ? null : icon_r12.iconName)("size", ctx_r13.iconsSize)("color", icon_r12 == null ? null : icon_r12.iconColor)("tooltip", icon_r12 == null ? null : icon_r12.tooltip)("callback", (icon_r12 == null ? null : icon_r12.callback) ? icon_r12 == null ? null : icon_r12.callback : null);
} }
function ExThumbnailComponent_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExThumbnailComponent_div_5_ng_container_1_ex_svg_icon_1_Template, 1, 5, "ex-svg-icon", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const icon_r12 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r12);
} }
function ExThumbnailComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ExThumbnailComponent_div_5_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", !ctx_r4.showPlaceholder && !ctx_r4.imgSrc ? "" : ctx_r4.fixedWidth, "px");
    i0.ɵɵproperty("hidden", ctx_r4.showPlaceholder || !ctx_r4.isLoaded && ctx_r4.imgSrc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.underThumbnailIcons)("ngForTrackBy", ctx_r4.iconTrackBy);
} }
class ExThumbnailComponent {
    set icon(value) {
        this._icon = value;
        this.iconSize = value?.iconSize ?? this.fixedWidth > 60 ? 'large' : 'small';
    }
    get icon() {
        return this._icon;
    }
    set underThumbnailIcons(value) {
        this._underThumbnailIcons = value;
        this.iconsSize = this.fixedWidth < 60 ? 'small' : this.fixedWidth < 100 ? 'medium' : 'large';
    }
    get underThumbnailIcons() {
        return this._underThumbnailIcons;
    }
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.fixedWidth = 33;
        this.fixWidthOperator = 'px';
        this.hasMaxHeight = true;
        this.placeHolderType = 'book-cover';
        this.showPlaceholder = false;
        this.isLoaded = false;
        this.errorImg = false;
        this.noImage = false;
    }
    iconTrackBy(index, icon) {
        return icon?.iconName;
    }
    ngOnInit() {
        this.noImage = !this.imgSrc;
        this.maxHeight = this.hasMaxHeight && +this.fixedWidth * 1.5;
        if (!this.syndeticsSrc && this.googleSrc) {
            this.getGoogleUrl();
        }
    }
    getGoogleUrl() {
        this.httpClient.get(this.googleSrc, { responseType: 'text' }).subscribe({
            next: (googleResponse) => {
                if (googleResponse) {
                    let googleResponseJson = googleResponse.substring(googleResponse.indexOf("{"), googleResponse.length - 1);
                    let googleResponseJsonObj = JSON.parse(googleResponseJson);
                    for (let key in googleResponseJsonObj) {
                        let thumbnail_url = googleResponseJsonObj[key].thumbnail_url;
                        if (thumbnail_url != null && thumbnail_url != 'undefined') {
                            this.googleImgSrc = thumbnail_url;
                            this.thumbnailImage.nativeElement.src = this.googleImgSrc;
                        }
                    }
                    if (!this.googleImgSrc) {
                        this.thumbnailImage.nativeElement.src = this.imgSrc;
                    }
                }
            },
            error: (error) => {
                this.thumbnailImage.nativeElement.src = this.imgSrc;
            }
        });
    }
    ;
    onLoad() {
        if (!this.syndeticsSrc || (this.syndeticsSrc && this.thumbnailImage.nativeElement.height > 1)) {
            this.isLoaded = true;
            this.errorImg = false;
        }
        else {
            this.onError();
        }
    }
    onError() {
        let currentSrcISameToImgSrc = this.thumbnailImage.nativeElement.src?.endsWith(this.imgSrc);
        if (this.syndeticsSrc && !this.googleImgSrc && this.googleSrc && !currentSrcISameToImgSrc) {
            this.getGoogleUrl();
        }
        else if (this.imgSrc && !currentSrcISameToImgSrc) {
            this.thumbnailImage.nativeElement.src = this.imgSrc;
            this.isLoaded = false;
        }
        else {
            this.placeHolderType = this.placeHolderType ?? 'book-cover';
            this.errorImg = true;
            this.isLoaded = false;
        }
    }
    static { this.ɵfac = function ExThumbnailComponent_Factory(t) { return new (t || ExThumbnailComponent)(i0.ɵɵdirectiveInject(i1$8.HttpClient)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExThumbnailComponent, selectors: [["ex-thumbnail"]], viewQuery: function ExThumbnailComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$C, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.thumbnailImage = _t.first);
        } }, inputs: { fixedWidth: "fixedWidth", fixWidthOperator: "fixWidthOperator", hasMaxHeight: "hasMaxHeight", placeHolderType: "placeHolderType", imgSrc: "imgSrc", googleSrc: "googleSrc", syndeticsSrc: "syndeticsSrc", imgType: "imgType", showPlaceholder: "showPlaceholder", icon: "icon", underThumbnailIcons: "underThumbnailIcons" }, decls: 6, vars: 6, consts: [[1, "ex-thumbnail-container"], ["class", "ex-thumbnail-icon sel-ex-thumbnail-icon", 3, "hidden", "iconName", "color", "size", "tooltip", "callback", 4, "ngIf"], ["class", "ex-avatar-icon", 4, "ngIf", "ngIfElse"], ["thumbnail", ""], ["class", "ex-thumbnail-icons-container", 3, "hidden", "width", 4, "ngIf"], [1, "ex-thumbnail-icon", "sel-ex-thumbnail-icon", 3, "hidden", "iconName", "color", "size", "tooltip", "callback"], [1, "ex-avatar-icon"], [3, "imgSrc", "diameter"], ["role", "none", 1, "ex-thumbnail-img", "sel-ex-thumbnail-img", 3, "src", "hidden", "load", "error"], ["thumbnailImage", ""], ["class", "ex-thumbnail-placeholder sel-ex-thumbnail-placeholder", 3, "height", "width", "hidden", 4, "ngIf"], ["class", "sel-ex-thumbnail-placeholder", "role", "none", 3, "src", "max-height", "width", "hidden", 4, "ngIf"], [1, "ex-thumbnail-placeholder", "sel-ex-thumbnail-placeholder", 3, "hidden"], ["role", "none", 1, "sel-ex-thumbnail-placeholder", 3, "src", "hidden"], [1, "ex-thumbnail-icons-container", 3, "hidden"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "iconName", "size", "color", "tooltip", "callback", 4, "ngIf"], [3, "iconName", "size", "color", "tooltip", "callback"]], template: function ExThumbnailComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExThumbnailComponent_ex_svg_icon_1_Template, 1, 6, "ex-svg-icon", 1);
            i0.ɵɵtemplate(2, ExThumbnailComponent_div_2_Template, 2, 2, "div", 2);
            i0.ɵɵtemplate(3, ExThumbnailComponent_ng_template_3_Template, 4, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ExThumbnailComponent_div_5_Template, 2, 5, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(4);
            i0.ɵɵclassProp("displayIconsOnly", !ctx.showPlaceholder && !ctx.imgSrc);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.imgType === "avatar")("ngIfElse", _r2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.underThumbnailIcons);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExAvatarComponent, ExSvgIconComponent], styles: [".ex-thumbnail-container[_ngcontent-%COMP%]{position:relative}.ex-thumbnail-container.displayIconsOnly[_ngcontent-%COMP%]   .ex-thumbnail-icon[_ngcontent-%COMP%]{margin-top:0;display:block;position:static}.ex-thumbnail-container[_ngcontent-%COMP%]   .ex-thumbnail-icon[_ngcontent-%COMP%]{position:absolute;inset-inline-end:10px;margin-block:-5px;border:solid;border-color:#f4f5f7;border-radius:50%;background-color:#f4f5f7}img[_ngcontent-%COMP%]{margin-inline-end:15px;flex-shrink:0}.ex-thumbnail-placeholder[_ngcontent-%COMP%]{background:#c9c9c9;padding:0 0 15%;margin-inline-end:15px;flex-shrink:0}.ex-thumbnail-placeholder[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{height:100%;background:#e5e5e5}.ex-avatar-icon[_ngcontent-%COMP%]{margin-right:15px;margin-top:-4px}.alma-icon-mat[_ngcontent-%COMP%]{display:flex;margin-right:13px}.svg-placeholder[_ngcontent-%COMP%]{background-color:#e6e6e6;border-radius:50%;max-height:102px;width:68px;height:71px;margin-right:15px}.ex-thumbnail-icons-container[_ngcontent-%COMP%]{display:flex;margin-top:2px;column-gap:4px;flex-wrap:wrap}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExThumbnailComponent, [{
        type: Component,
        args: [{ selector: 'ex-thumbnail', template: "<div class=\"ex-thumbnail-container\" [class.displayIconsOnly]=\"!showPlaceholder && !imgSrc\">\r\n  <ex-svg-icon *ngIf=\"icon\" [hidden]=\"showPlaceholder || (!isLoaded && imgSrc)\" class=\"ex-thumbnail-icon sel-ex-thumbnail-icon\"\r\n    [iconName]=\"icon.iconName\" [color]=\"icon.iconColor\" [size]=\"iconSize\" [tooltip]=\"icon.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"> </ex-svg-icon>\r\n  <div class=\"ex-avatar-icon\" *ngIf=\"imgType === 'avatar' else thumbnail\">\r\n    <ex-avatar [imgSrc]=\"imgSrc\" [diameter]=\"45\">\r\n    </ex-avatar>\r\n  </div>\r\n\r\n  <ng-template #thumbnail>\r\n    <img #thumbnailImage [src]=\"syndeticsSrc??googleImgSrc??imgSrc\" [style.max-height.px]=\"maxHeight\" [style.width]=\"fixedWidth && (fixedWidth + fixWidthOperator)\" (load)=\"onLoad()\"\r\n      (error)=\"onError()\" [hidden]=\"showPlaceholder || !isLoaded || !imgSrc\" role=\"none\"\r\n      class='ex-thumbnail-img sel-ex-thumbnail-img'>\r\n    <div *ngIf=\"placeHolderType === 'book-cover'\" [style.height.px]=\"maxHeight\" [style.width]=\"fixedWidth && (fixedWidth + fixWidthOperator)\"\r\n      class=\"ex-thumbnail-placeholder sel-ex-thumbnail-placeholder\" [hidden]=\"((!showPlaceholder && isLoaded) || (!showPlaceholder && imgSrc)) && !errorImg\">\r\n      <div>&nbsp;</div>\r\n    </div>\r\n    <img *ngIf=\"placeHolderType === 'user'\" [src]=\"'/ng/assets/images/thumbnail-placeholder-user.svg'\" [style.max-height.px]=\"maxHeight\" [style.width.px]=\"fixedWidth\"\r\n         class='sel-ex-thumbnail-placeholder'  [hidden]=\"((!showPlaceholder && isLoaded) || (!showPlaceholder && imgSrc)) && !errorImg\" role=\"none\">\r\n  </ng-template>\r\n  <div *ngIf=\"underThumbnailIcons\" [hidden]=\"showPlaceholder || (!isLoaded && imgSrc)\" [style.width.px]=\"!showPlaceholder && !imgSrc?'':fixedWidth\"\r\n    class=\"ex-thumbnail-icons-container\">\r\n    <ng-container *ngFor=\"let icon of underThumbnailIcons; trackBy:iconTrackBy\">\r\n      <ex-svg-icon *ngIf=\"icon\" [iconName]=\"icon?.iconName\" [size]=\"iconsSize\" [color]=\"icon?.iconColor\"\r\n                   [tooltip]=\"icon?.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n    </ng-container>\r\n\r\n  </div>\r\n</div>\r\n", styles: [".ex-thumbnail-container{position:relative}.ex-thumbnail-container.displayIconsOnly .ex-thumbnail-icon{margin-top:0;display:block;position:static}.ex-thumbnail-container .ex-thumbnail-icon{position:absolute;inset-inline-end:10px;margin-block:-5px;border:solid;border-color:#f4f5f7;border-radius:50%;background-color:#f4f5f7}img{margin-inline-end:15px;flex-shrink:0}.ex-thumbnail-placeholder{background:#c9c9c9;padding:0 0 15%;margin-inline-end:15px;flex-shrink:0}.ex-thumbnail-placeholder div{height:100%;background:#e5e5e5}.ex-avatar-icon{margin-right:15px;margin-top:-4px}.alma-icon-mat{display:flex;margin-right:13px}.svg-placeholder{background-color:#e6e6e6;border-radius:50%;max-height:102px;width:68px;height:71px;margin-right:15px}.ex-thumbnail-icons-container{display:flex;margin-top:2px;column-gap:4px;flex-wrap:wrap}\n"] }]
    }], function () { return [{ type: i1$8.HttpClient }]; }, { fixedWidth: [{
            type: Input
        }], fixWidthOperator: [{
            type: Input
        }], hasMaxHeight: [{
            type: Input
        }], placeHolderType: [{
            type: Input
        }], imgSrc: [{
            type: Input
        }], googleSrc: [{
            type: Input
        }], syndeticsSrc: [{
            type: Input
        }], imgType: [{
            type: Input
        }], showPlaceholder: [{
            type: Input
        }], thumbnailImage: [{
            type: ViewChild,
            args: ['thumbnailImage', { read: ElementRef, static: false }]
        }], icon: [{
            type: Input,
            args: ['icon']
        }], underThumbnailIcons: [{
            type: Input,
            args: ['underThumbnailIcons']
        }] }); })();

class ExThumbnailModule {
    static { this.ɵfac = function ExThumbnailModule_Factory(t) { return new (t || ExThumbnailModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExThumbnailModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            ExIconModule,
            ExAvatarModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExThumbnailModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    ExIconModule,
                    ExAvatarModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExThumbnailComponent,
                ],
                exports: [
                    ExThumbnailComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExThumbnailModule, { declarations: [ExThumbnailComponent], imports: [CommonModule,
        TranslateModule,
        ExIconModule,
        ExAvatarModule,
        ExSvgIconModule], exports: [ExThumbnailComponent] }); })();

function ExToggleComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "input", 3);
    i0.ɵɵlistener("change", function ExToggleComponent_div_1_Template_input_change_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const value_r1 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.changeValue(value_r1.value)); })("ngModelChange", function ExToggleComponent_div_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.selected = $event); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 4);
    i0.ɵɵlistener("click", function ExToggleComponent_div_1_Template_label_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const value_r1 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.changeValue(value_r1.value)); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-toggle-radio ", i0.ɵɵpipeBind1(2, 11, value_r1), "");
    i0.ɵɵpropertyInterpolate2("id", "ex-toggle-", i_r2, "", ctx_r0.id, "");
    i0.ɵɵpropertyInterpolate1("name", "ex-toggle-", ctx_r0.id, "");
    i0.ɵɵproperty("ngModel", ctx_r0.selected)("value", value_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("for", "ex-toggle-", i_r2, "", ctx_r0.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(value_r1.label);
} }
class ExToggleComponent {
    constructor() {
        /**
         * The values to display in the toggle
         */
        this.values = [{ value: 'on', label: 'ON' }, { value: 'off', label: 'OFF' }];
        /**
         * The pre-selected value
         */
        this.selected = 'on';
        /**
         * identity
         */
        this.id = '';
        this.selectedChange = new EventEmitter();
    }
    changeValue(value) {
        this.selectedChange.emit(value);
    }
    static { this.ɵfac = function ExToggleComponent_Factory(t) { return new (t || ExToggleComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExToggleComponent, selectors: [["ex-toggle"]], inputs: { values: "values", selected: "selected", id: "id" }, outputs: { selectedChange: "selectedChange" }, decls: 2, vars: 1, consts: [[1, "ex-toggle-wrapper"], ["mat-ripple", "", "class", "ex-toggle-radio-wrapper", 4, "ngFor", "ngForOf"], ["mat-ripple", "", 1, "ex-toggle-radio-wrapper"], ["type", "radio", 3, "ngModel", "value", "id", "name", "change", "ngModelChange"], [1, "ex-toggle-label", 3, "for", "click"]], template: function ExToggleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExToggleComponent_div_1_Template, 5, 13, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.values);
        } }, dependencies: [i1$6.DefaultValueAccessor, i1$6.RadioControlValueAccessor, i1$6.NgControlStatus, i1$6.NgModel, i1$5.NgForOf, ExGenerateIdPipe], styles: [".ex-toggle-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;border-radius:3px;position:relative}.ex-toggle-wrapper[_ngcontent-%COMP%]   .ex-toggle-radio-wrapper[_ngcontent-%COMP%]:focus-within{outline:2px solid #000;outline-offset:-2px}.ex-toggle-wrapper[_ngcontent-%COMP%]   .ex-toggle-radio[_ngcontent-%COMP%]{position:absolute;clip:rect(0,0,0,0);height:1px;width:1px;border:0;overflow:hidden}.ex-toggle-wrapper[_ngcontent-%COMP%]   .ex-toggle-label[_ngcontent-%COMP%]{width:35px;padding:4px 1px;height:100%;text-align:center;margin-bottom:0!important;border-radius:3px;cursor:pointer;display:inline-block}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExToggleComponent, [{
        type: Component,
        args: [{ selector: 'ex-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-toggle-wrapper\">\n  <div *ngFor=\"let value of values;let i = index\" mat-ripple class=\"ex-toggle-radio-wrapper\">\n    <input class=\"ex-toggle-radio {{value | generateHTMLId }}\" type=\"radio\" (change)=\"changeValue(value.value)\" [(ngModel)]=\"selected\" [value]=\"value.value\" id=\"ex-toggle-{{i}}{{id}}\" name=\"ex-toggle-{{id}}\"/>\n    <label class=\"ex-toggle-label\" (click)=\"changeValue(value.value)\" for=\"ex-toggle-{{i}}{{id}}\">{{ value.label }}</label>\n  </div>\n</div>\n", styles: [".ex-toggle-wrapper{display:flex;flex-direction:row;border-radius:3px;position:relative}.ex-toggle-wrapper .ex-toggle-radio-wrapper:focus-within{outline:2px solid #000;outline-offset:-2px}.ex-toggle-wrapper .ex-toggle-radio{position:absolute;clip:rect(0,0,0,0);height:1px;width:1px;border:0;overflow:hidden}.ex-toggle-wrapper .ex-toggle-label{width:35px;padding:4px 1px;height:100%;text-align:center;margin-bottom:0!important;border-radius:3px;cursor:pointer;display:inline-block}\n"] }]
    }], null, { values: [{
            type: Input
        }], selected: [{
            type: Input
        }], id: [{
            type: Input
        }], selectedChange: [{
            type: Output
        }] }); })();

class ExToggleModule {
    static { this.ɵfac = function ExToggleModule_Factory(t) { return new (t || ExToggleModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExToggleModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            CommonModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExToggleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    EXPipesModule
                ],
                declarations: [
                    ExToggleComponent
                ],
                exports: [
                    ExToggleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExToggleModule, { declarations: [ExToggleComponent], imports: [FormsModule,
        CommonModule,
        EXPipesModule], exports: [ExToggleComponent] }); })();

function ExTypedInputComponent_ng_container_0_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.label, ": ");
} }
const _c0$B = function (a0) { return { "sel-input-empty": a0 }; };
const _c1$p = function (a0) { return { "width": a0 }; };
function ExTypedInputComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, ExTypedInputComponent_ng_container_0_label_2_Template, 2, 1, "label", 2);
    i0.ɵɵelementStart(3, "input", 3, 4);
    i0.ɵɵlistener("keyup.enter", function ExTypedInputComponent_ng_container_0_Template_input_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r5); const _r3 = i0.ɵɵreference(4); return i0.ɵɵresetView(_r3.blur()); })("focusout", function ExTypedInputComponent_ng_container_0_Template_input_focusout_3_listener() { i0.ɵɵrestoreView(_r5); const _r3 = i0.ɵɵreference(4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onValueSaved(_r3.value)); })("focus", function ExTypedInputComponent_ng_container_0_Template_input_focus_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.isFocused = true); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$B, !ctx_r0.initialValue))("type", ctx_r0.type === "string" ? "text" : ctx_r0.type)("placeholder", ctx_r0.isFocused ? "" : i0.ɵɵpipeBind1(5, 8, ctx_r0.placeholder))("value", ctx_r0.initialValue)("readOnly", ctx_r0.disabled)("autofocus", ctx_r0.autoFocus)("ngStyle", i0.ɵɵpureFunction1(12, _c1$p, ctx_r0.disabled && ctx_r0.fitInputContent ? ctx_r0.getInputWidth(_r3.value.length) : "auto"));
} }
function ExTypedInputComponent_ng_container_1_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r8.label, ": ");
} }
const _c2$h = function (a0) { return { "ex-typed-input-disabled": a0 }; };
const _c3$e = function (a0) { return { key: a0 }; };
const _c4$b = function (a0) { return [a0]; };
function ExTypedInputComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, ExTypedInputComponent_ng_container_1_label_2_Template, 2, 1, "label", 2);
    i0.ɵɵelementStart(3, "ex-new-combobox", 7);
    i0.ɵɵlistener("selectedItemsChange", function ExTypedInputComponent_ng_container_1_Template_ex_new_combobox_selectedItemsChange_3_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onValueSaved($event[0].key)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$h, ctx_r1.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("displaySearchBox", false)("items", ctx_r1.booleanDropdownValues)("selectedItems", i0.ɵɵpureFunction1(9, _c4$b, i0.ɵɵpureFunction1(7, _c3$e, ctx_r1.selectedBoolean)));
} }
class ExTypedInputComponent {
    /**
     * @ignore
     */
    constructor(translate) {
        this.translate = translate;
        /**
         * Is the input disabled or not.
         */
        this.disabled = false;
        /**
         * If we want the input to focus at page load.
         */
        this.autoFocus = false;
        /**
         * Outputs for when using not as grid cell component.
         */
        this.valueSaved = new EventEmitter();
        /**
         * A placeholder to show when the input is empty
         */
        this.placeholder = 'ng.general.enter_text_here_placeholder';
        /**
         * If we want change the value width according the input text in readOnly mode.
         */
        this.fitInputContent = false;
        this.isFocused = false;
    }
    /**
     * @ignore
     */
    ngOnInit() {
        // Populate the values for boolean dropdowns
        this.booleanDropdownValues = [{ key: 'true', value: this.translate.instant('ng.general.true') }, { key: 'false', value: this.translate.instant('ng.general.false') }];
        if (this.arguments) {
            // Populate the inputs if built from grid layout.
            this.type = this.arguments.type;
            this.initialValue = this.arguments.initialValue;
            this.disabled = this.arguments.disabled;
            this.autoFocus = this.arguments.autoFocus;
            this.placeholder = this.arguments.placeholder;
            this.label = this.arguments.label;
        }
        if (this.type === 'boolean') {
            this.selectedBoolean = this.initialValue === 'true' ? 'true' : 'false';
        }
    }
    onValueSaved(newValue) {
        if (this.dataOutput) {
            this.dataOutput.next(newValue);
        }
        this.valueSaved.emit(newValue);
        this.isFocused = false;
    }
    getInputWidth(numOfChars) {
        return ((numOfChars + 2) * 8) + 'px';
    }
    static { this.ɵfac = function ExTypedInputComponent_Factory(t) { return new (t || ExTypedInputComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExTypedInputComponent, selectors: [["ex-typed-input"]], inputs: { type: "type", initialValue: "initialValue", disabled: "disabled", autoFocus: "autoFocus", label: "label", arguments: "arguments", dataOutput: "dataOutput", placeholder: "placeholder", fitInputContent: "fitInputContent" }, outputs: { valueSaved: "valueSaved" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "ex-typed-input-wrapper"], ["class", "sel-input-label ex-typed-input-label", 4, "ngIf"], [1, "ex-typed-input-text", "sel-input", 3, "ngClass", "type", "placeholder", "value", "readOnly", "autofocus", "ngStyle", "keyup.enter", "focusout", "focus"], ["inputField", ""], [1, "sel-input-label", "ex-typed-input-label"], [1, "ex-typed-input-wrapper", 3, "ngClass"], [1, "sel-combobox-input", 3, "displaySearchBox", "items", "selectedItems", "selectedItemsChange"]], template: function ExTypedInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExTypedInputComponent_ng_container_0_Template, 6, 14, "ng-container", 0);
            i0.ɵɵtemplate(1, ExTypedInputComponent_ng_container_1_Template, 4, 11, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.type === "string" || ctx.type === "number");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === "boolean");
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgStyle, ExNewComboboxComponent, i1$2.TranslatePipe], styles: [".ex-typed-input-text[_ngcontent-%COMP%]{padding-left:5px;margin-right:5px;width:100%;border-radius:4px}.ex-typed-input-label[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px;margin-bottom:0}.ex-typed-input-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:row}.ex-typed-input-disabled[_ngcontent-%COMP%]{pointer-events:none}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTypedInputComponent, [{
        type: Component,
        args: [{ selector: 'ex-typed-input', template: "<ng-container *ngIf=\"type === 'string' || type === 'number'\">\n  <div class=\"ex-typed-input-wrapper\">\n    <label *ngIf=\"label\" class=\"sel-input-label ex-typed-input-label\">{{label}}: </label>\n    <input #inputField class=\"ex-typed-input-text sel-input\" [ngClass]=\"{'sel-input-empty': !initialValue}\"\n           [type]=\"type === 'string' ? 'text' : type\" [placeholder]=\"isFocused ? '' : placeholder | translate\"\n           [value]=\"initialValue\" (keyup.enter)=\"inputField.blur()\" (focusout)=\"onValueSaved(inputField.value)\"\n           (focus)=\"isFocused = true\" [readOnly]=\"disabled\" [autofocus]=\"autoFocus\"\n           [ngStyle]=\"{'width': disabled && fitInputContent ? getInputWidth(inputField.value.length) : 'auto'}\">\n  </div>\n</ng-container>\n<ng-container *ngIf=\"type === 'boolean'\">\n  <div class=\"ex-typed-input-wrapper\" [ngClass]=\"{'ex-typed-input-disabled': disabled}\">\n    <label *ngIf=\"label\" class=\"sel-input-label ex-typed-input-label\">{{label}}: </label>\n    <ex-new-combobox class=\"sel-combobox-input\" [displaySearchBox]=\"false\" [items]=\"booleanDropdownValues\"\n        (selectedItemsChange)=\"onValueSaved($event[0].key)\" [selectedItems]=\"[{ key: selectedBoolean }]\">\n    </ex-new-combobox>\n  </div>\n</ng-container>\n", styles: [".ex-typed-input-text{padding-left:5px;margin-right:5px;width:100%;border-radius:4px}.ex-typed-input-label{margin-left:5px;margin-right:5px;margin-bottom:0}.ex-typed-input-wrapper{display:flex;align-items:center;flex-direction:row}.ex-typed-input-disabled{pointer-events:none}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { type: [{
            type: Input
        }], initialValue: [{
            type: Input
        }], disabled: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], label: [{
            type: Input
        }], arguments: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }], valueSaved: [{
            type: Output
        }], placeholder: [{
            type: Input
        }], fitInputContent: [{
            type: Input
        }] }); })();

class ExTypedInputModule {
    static { this.ɵfac = function ExTypedInputModule_Factory(t) { return new (t || ExTypedInputModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExTypedInputModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExEditableTextModule,
            TranslateModule,
            ExNewComboboxModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExTypedInputModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExEditableTextModule,
                    TranslateModule,
                    ExNewComboboxModule
                ],
                declarations: [
                    ExTypedInputComponent
                ],
                exports: [
                    ExTypedInputComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExTypedInputModule, { declarations: [ExTypedInputComponent], imports: [CommonModule,
        ExEditableTextModule,
        TranslateModule,
        ExNewComboboxModule], exports: [ExTypedInputComponent] }); })();

/**
 * The available facets type
 */
var ExFacetsTypes;
(function (ExFacetsTypes) {
    ExFacetsTypes["MULTI_SELECT"] = "MULTI_SELECT";
    ExFacetsTypes["SINGLE_SELECT"] = "SINGLE_SELECT";
    ExFacetsTypes["BOOLEAN"] = "BOOLEAN";
    ExFacetsTypes["RANGE"] = "RANGE";
    ExFacetsTypes["HIERARCHY"] = "HIERARCHY";
})(ExFacetsTypes || (ExFacetsTypes = {}));

const _c0$A = ["tooltip"];
function ExSelectedFacetComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 4, 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 6);
    i0.ɵɵlistener("click", function ExSelectedFacetComponent_div_0_span_4_Template_button_click_7_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const value_r2 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onRemove(value_r2)); })("mouseenter", function ExSelectedFacetComponent_div_0_span_4_Template_button_mouseenter_7_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onRemoveEnter()); });
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelement(9, "i", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate2("exTooltip", "", i0.ɵɵpipeBind1(2, 5, ctx_r1.getTitle()), ": ", i0.ɵɵpipeBind1(3, 7, ctx_r1.getStringValue(value_r2)), "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, ctx_r1.getStringValue(value_r2)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(8, 11, "ng.general.remove"));
    i0.ɵɵattribute("aria-label", value_r2);
} }
function ExSelectedFacetComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExSelectedFacetComponent_div_0_span_4_Template, 10, 13, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, ctx_r0.getTitle()), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.values);
} }
class ExSelectedFacetComponent {
    constructor() {
        /**
         * map of values and labels to display
         */
        this.valueToLabelMap = {};
        this.facetPrefixTranslate = '';
        /**
         * Sends the parent an event of removal for this item
         */
        this.itemRemoved = new EventEmitter();
    }
    getTitle() {
        return this.title ?? (this.facetPrefixTranslate + this.field);
    }
    /**
     * This function gets the click and emits the event for removal
     * @param value the value to be sent to the parent for removal
     */
    onRemove(value) {
        this.itemRemoved.emit({ field: this.field, value: String(value) });
    }
    onRemoveEnter() {
        this.tooltip.hide();
    }
    getStringValue(value) {
        return this.valueToLabelMap[String(value)] ?? value;
    }
    static { this.ɵfac = function ExSelectedFacetComponent_Factory(t) { return new (t || ExSelectedFacetComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSelectedFacetComponent, selectors: [["ex-selected-facet"]], viewQuery: function ExSelectedFacetComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$A, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
        } }, inputs: { field: "field", title: "title", values: "values", valueToLabelMap: "valueToLabelMap", facetPrefixTranslate: "facetPrefixTranslate" }, outputs: { itemRemoved: "itemRemoved" }, decls: 1, vars: 1, consts: [["class", "ex-selected-facet-wrapper", 4, "ngIf"], [1, "ex-selected-facet-wrapper"], [1, "ex-selected-facet-wrapper-title"], ["class", "ex-selected-facet-value  sel-applied-facets-label", "matTooltipPosition", "above", 3, "exTooltip", 4, "ngFor", "ngForOf"], ["matTooltipPosition", "above", 1, "ex-selected-facet-value", "sel-applied-facets-label", 3, "exTooltip"], ["tooltip", "exTooltip"], [1, "ex-selected-facet-remove-btn", 3, "exTooltip", "click", "mouseenter"], [1, "uxf-icon", "uxf-close-circle", "uxfBlueHover"]], template: function ExSelectedFacetComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExSelectedFacetComponent_div_0_Template, 5, 4, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.values == null ? null : ctx.values.length) > 0);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, i1$2.TranslatePipe], styles: [".ex-selected-facet-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.ex-selected-facet-wrapper[_ngcontent-%COMP%]   .ex-selected-facet-wrapper-title[_ngcontent-%COMP%]{margin-right:5px;margin-bottom:3px}.ex-selected-facet-wrapper[_ngcontent-%COMP%]   .ex-selected-facet-value[_ngcontent-%COMP%]{display:flex;align-items:center;padding:1px 5px;margin-bottom:3px;border-radius:3px;border-width:1px;border-style:solid}.ex-selected-facet-wrapper[_ngcontent-%COMP%]   .ex-selected-facet-value[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:5px}.ex-selected-facet-wrapper[_ngcontent-%COMP%]   .ex-selected-facet-value[_ngcontent-%COMP%]:not(:last-child){margin-right:3px}.ex-selected-facet-remove-btn[_ngcontent-%COMP%]{outline:none;background:none;color:#949594!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSelectedFacetComponent, [{
        type: Component,
        args: [{ selector: 'ex-selected-facet', template: "<div *ngIf=\"values?.length > 0\" class=\"ex-selected-facet-wrapper\">\n    <span class=\"ex-selected-facet-wrapper-title\">{{ getTitle() | translate }}:</span>\n    <span *ngFor=\"let value of values\" class=\"ex-selected-facet-value  sel-applied-facets-label\" #tooltip=\"exTooltip\"\n        matTooltipPosition=\"above\" exTooltip=\"{{ getTitle() | translate }}: {{ getStringValue(value) | translate }}\">\n        <span>{{ getStringValue(value) | translate }}</span>\n        <button [exTooltip]=\"'ng.general.remove' | translate\" class=\"ex-selected-facet-remove-btn\"\n            (click)=\"onRemove(value)\" (mouseenter)=\"onRemoveEnter()\" attr.aria-label=\"{{ value }}\">\n            <i class=\"uxf-icon uxf-close-circle uxfBlueHover\"></i>\n        </button>\n    </span>\n</div>", styles: [".ex-selected-facet-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.ex-selected-facet-wrapper .ex-selected-facet-wrapper-title{margin-right:5px;margin-bottom:3px}.ex-selected-facet-wrapper .ex-selected-facet-value{display:flex;align-items:center;padding:1px 5px;margin-bottom:3px;border-radius:3px;border-width:1px;border-style:solid}.ex-selected-facet-wrapper .ex-selected-facet-value button{margin-left:5px}.ex-selected-facet-wrapper .ex-selected-facet-value:not(:last-child){margin-right:3px}.ex-selected-facet-remove-btn{outline:none;background:none;color:#949594!important}\n"] }]
    }], null, { field: [{
            type: Input
        }], title: [{
            type: Input
        }], values: [{
            type: Input
        }], valueToLabelMap: [{
            type: Input
        }], facetPrefixTranslate: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }] }); })();

function ExSelectedFacetsWrapperComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "ex-selected-facet", 8);
    i0.ɵɵlistener("itemRemoved", function ExSelectedFacetsWrapperComponent_div_6_Template_ex_selected_facet_itemRemoved_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onRemove($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selectedFacet_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("field", selectedFacet_r1.field)("values", selectedFacet_r1.values)("title", selectedFacet_r1.title)("facetPrefixTranslate", ctx_r0.facetPrefixTranslate)("valueToLabelMap", ctx_r0.valueToLabelMap);
} }
class ExSelectedFacetsWrapperComponent {
    constructor() {
        /**
         * The event of a removal of an item.
         */
        this.itemRemoved = new EventEmitter();
        /**
         * The event for clearing all the selected facets.
         */
        this.itemsCleared = new EventEmitter();
        this.facetPrefixTranslate = '';
        /**
         * map of values and labels to display
         */
        this.valueToLabelMap = {};
        this.panelExpanded = true;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedFacets')) {
            // Deep copy the selected items so we won't change the original data
            const copiedSelected = [];
            this.selectedFacets.forEach(facet => {
                copiedSelected.push({ ...facet });
            });
            this.selectedFacets = copiedSelected;
            // set facet.value to be the latest value in hierarchy for hierarchial facets
            const hierarchyFacets = this.selectedFacets.filter(facet => facet.type === ExFacetsTypes.HIERARCHY);
            if (hierarchyFacets?.length > 0) {
                hierarchyFacets.forEach(facet => {
                    const lastLevelArr = facet.values[facet.values.length - 1];
                    const lastLevelLastPair = lastLevelArr[lastLevelArr.length - 1];
                    facet.values = [lastLevelLastPair.description];
                });
            }
        }
    }
    /**
     * This function gets the index of the selected facet that should be removed and fires the event to his parent.
     * @param facet the facet that should be removed.
     */
    onRemove(facet) {
        const fieldIndex = this.selectedFacets.findIndex(selectedFacet => selectedFacet.field === facet.field);
        const valueIndex = this.selectedFacets[fieldIndex].values.findIndex(value => value === facet.value);
        if (fieldIndex != null && valueIndex != null) {
            this.itemRemoved.emit({ fieldIndex: fieldIndex, valueIndex: valueIndex });
        }
    }
    /**
     * Emits the clear all event.
     */
    clearAll() {
        this.itemsCleared.emit();
    }
    static { this.ɵfac = function ExSelectedFacetsWrapperComponent_Factory(t) { return new (t || ExSelectedFacetsWrapperComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSelectedFacetsWrapperComponent, selectors: [["ex-selected-facets-wrapper"]], inputs: { selectedFacets: "selectedFacets", headerText: "headerText", clearAllText: "clearAllText", facetPrefixTranslate: "facetPrefixTranslate", valueToLabelMap: "valueToLabelMap" }, outputs: { itemRemoved: "itemRemoved", itemsCleared: "itemsCleared" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 8, consts: [[1, "mat-content-density", "ex-facet-wrapper-back-color", "ex-selected-facets-wrapper-no-shadow", 3, "expanded", "expandedChange"], [1, "ex-selected-facets-wrapper-header-panel", 3, "expandedHeight", "collapsedHeight"], [1, "ex-facet-wrapper-full-width"], [1, "ex-selected-facets-wrapper-header"], [1, "ex-selected-facets-wrapper-facets-container"], ["class", "ex-selected-facets-wrapper-side-margin", 4, "ngFor", "ngForOf"], [1, "ex-selected-facets-wrapper-clear-button", "sel-clear-applied-facets", 3, "click"], [1, "ex-selected-facets-wrapper-side-margin"], [3, "field", "values", "title", "facetPrefixTranslate", "valueToLabelMap", "itemRemoved"]], template: function ExSelectedFacetsWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-expansion-panel", 0);
            i0.ɵɵlistener("expandedChange", function ExSelectedFacetsWrapperComponent_Template_mat_expansion_panel_expandedChange_0_listener($event) { return ctx.panelExpanded = $event; });
            i0.ɵɵelementStart(1, "mat-expansion-panel-header", 1)(2, "mat-panel-title", 2)(3, "p", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, ExSelectedFacetsWrapperComponent_div_6_Template, 2, 5, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "button", 6);
            i0.ɵɵlistener("click", function ExSelectedFacetsWrapperComponent_Template_button_click_7_listener() { return ctx.clearAll(); });
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("expanded", ctx.panelExpanded);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("expandedHeight", "30px")("collapsedHeight", "30px");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.headerText);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.selectedFacets);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 6, ctx.clearAllText));
        } }, dependencies: [i1$5.NgForOf, i2$7.MatExpansionPanel, i2$7.MatExpansionPanelHeader, i2$7.MatExpansionPanelTitle, ExSelectedFacetComponent, i1$2.TranslatePipe], styles: [".ex-selected-facets-wrapper-header[_ngcontent-%COMP%]{margin-bottom:5px}.ex-selected-facets-wrapper-facets-container[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-selected-facets-wrapper-flex-col[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column;margin-left:24px;margin-bottom:5px}.ex-selected-facets-wrapper-flex-row[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:row}.ex-selected-facets-wrapper-hidden[_ngcontent-%COMP%]{display:none}.ex-selected-facets-wrapper-no-shadow[_ngcontent-%COMP%]{box-shadow:none!important}.ex-selected-facets-wrapper-no-shadow[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0 5px 0 24px!important}.ex-selected-facets-wrapper-clear-button[_ngcontent-%COMP%]{text-align:start;outline:none;margin-bottom:5px;margin-top:5px}.ex-selected-facets-wrapper-clear-button[_ngcontent-%COMP%]:hover{text-decoration:underline}.ex-selected-facets-wrapper-header-panel[_ngcontent-%COMP%]{border:2px solid transparent}.ex-selected-facets-wrapper-header-panel[_ngcontent-%COMP%]:focus{border:2px solid black!important}mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0 24px 0 22px}  .mat-expansion-panel-content{font-size:inherit}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSelectedFacetsWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-selected-facets-wrapper', template: "<!-- <i class=\"uxf-icon uxf-filter coolBlue\"></i> -->\n<mat-expansion-panel class=\"mat-content-density ex-facet-wrapper-back-color ex-selected-facets-wrapper-no-shadow\"\n  [(expanded)]=\"panelExpanded\">\n  <mat-expansion-panel-header class=\"mat-header-density\" [expandedHeight]=\"'30px'\" [collapsedHeight]=\"'30px'\" class=\"ex-selected-facets-wrapper-header-panel\">\n    <mat-panel-title class=\"ex-facet-wrapper-full-width\">\n      <p class=\"ex-selected-facets-wrapper-header\">{{ headerText }}</p>\n    </mat-panel-title>\n  </mat-expansion-panel-header>\n  <div class=\"ex-selected-facets-wrapper-facets-container\">\n    <div class=\"ex-selected-facets-wrapper-side-margin\" *ngFor=\"let selectedFacet of selectedFacets\">\n      <ex-selected-facet [field]=\"selectedFacet.field\" [values]=\"selectedFacet.values\" [title]=\"selectedFacet.title\"\n        [facetPrefixTranslate]=\"facetPrefixTranslate\" (itemRemoved)=\"onRemove($event)\" [valueToLabelMap]=\"valueToLabelMap\">\n      </ex-selected-facet>\n    </div>\n  </div>\n  <button class=\"ex-selected-facets-wrapper-clear-button sel-clear-applied-facets\" (click)=\"clearAll()\">{{ clearAllText | translate }}</button>\n</mat-expansion-panel>", styles: [".ex-selected-facets-wrapper-header{margin-bottom:5px}.ex-selected-facets-wrapper-facets-container{display:flex;flex-direction:column}.ex-selected-facets-wrapper-flex-col{display:flex;flex:1;flex-direction:column;margin-left:24px;margin-bottom:5px}.ex-selected-facets-wrapper-flex-row{display:flex;flex:1;flex-direction:row}.ex-selected-facets-wrapper-hidden{display:none}.ex-selected-facets-wrapper-no-shadow{box-shadow:none!important}.ex-selected-facets-wrapper-no-shadow ::ng-deep .mat-expansion-panel-body{padding:0 5px 0 24px!important}.ex-selected-facets-wrapper-clear-button{text-align:start;outline:none;margin-bottom:5px;margin-top:5px}.ex-selected-facets-wrapper-clear-button:hover{text-decoration:underline}.ex-selected-facets-wrapper-header-panel{border:2px solid transparent}.ex-selected-facets-wrapper-header-panel:focus{border:2px solid black!important}mat-expansion-panel-header{padding:0 24px 0 22px}::ng-deep .mat-expansion-panel-content{font-size:inherit}\n"] }]
    }], null, { selectedFacets: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], itemsCleared: [{
            type: Output
        }], headerText: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], facetPrefixTranslate: [{
            type: Input
        }], valueToLabelMap: [{
            type: Input
        }] }); })();

class ExFacetToggleComponent {
    constructor() {
        /**
         * data for the toggle -  checked, label, disabled, tooltip - if no tooltip transferred, the label will be used
         */
        this.toggleData = null;
        /**
         * the event fires when a toggle changes to on/off
         */
        this.toggleChanged = new EventEmitter();
    }
    onToggleChanged(value) {
        //timeout is for the animation of the toggle to be shown before the page will refresh
        setTimeout(() => {
            this.toggleChanged.emit({ checked: value, value: this.toggleData.value });
        }, 500);
    }
    static { this.ɵfac = function ExFacetToggleComponent_Factory(t) { return new (t || ExFacetToggleComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetToggleComponent, selectors: [["ex-facet-toggle"]], inputs: { toggleData: "toggleData" }, outputs: { toggleChanged: "toggleChanged" }, decls: 7, vars: 10, consts: [[1, "ex-facet-toggle-wrapper"], [1, "ex-facet-toggle-label", 3, "disabled", "exTooltip", "click"], [1, "ex-facet-toggle-wrapper-slider", 3, "toggleChecked", "disabled", "ariaLabel", "toggleCheckedChange"], ["toggle", ""]], template: function ExFacetToggleComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function ExFacetToggleComponent_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(6); _r0.toggleChecked = !_r0.toggleChecked; return i0.ɵɵresetView(ctx.onToggleChanged(_r0.toggleChecked)); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "ex-slide-toggle", 2, 3);
            i0.ɵɵlistener("toggleCheckedChange", function ExFacetToggleComponent_Template_ex_slide_toggle_toggleCheckedChange_5_listener($event) { return ctx.onToggleChanged($event); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.toggleData == null ? null : ctx.toggleData.disabled)("exTooltip", i0.ɵɵpipeBind1(2, 6, (ctx.toggleData == null ? null : ctx.toggleData.tooltip) ? ctx.toggleData == null ? null : ctx.toggleData.tooltip : ctx.toggleData == null ? null : ctx.toggleData.label));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 8, ctx.toggleData == null ? null : ctx.toggleData.label));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("toggleChecked", ctx.toggleData == null ? null : ctx.toggleData.checked)("disabled", ctx.toggleData == null ? null : ctx.toggleData.disabled)("ariaLabel", ctx.toggleData == null ? null : ctx.toggleData.label);
        } }, dependencies: [ExTooltipDirective, ExSlideToggleComponent, i1$2.TranslatePipe], styles: [".ex-facet-toggle-wrapper[_ngcontent-%COMP%]{white-space:nowrap;display:flex;flex-direction:row;justify-content:space-between}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-label[_ngcontent-%COMP%]{background:none;border:0;overflow:hidden;text-overflow:ellipsis;display:flex;flex:1;padding-bottom:5px;border:2px solid transparent}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-label[_ngcontent-%COMP%]:focus{outline:0;border-color:#000}.ex-facet-toggle-wrapper-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetToggleComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-toggle', template: "<div class=\"ex-facet-toggle-wrapper\">\n    <button class=\"ex-facet-toggle-label\"\n        (click)=\"toggle.toggleChecked = !toggle.toggleChecked; onToggleChanged(toggle.toggleChecked);\" [disabled]=\"toggleData?.disabled\"\n            [exTooltip]=\"(toggleData?.tooltip ? toggleData?.tooltip : toggleData?.label) | translate\">{{ toggleData?.label | translate }}</button>\n  <ex-slide-toggle #toggle (toggleCheckedChange)=\"onToggleChanged($event)\" [toggleChecked]=\"toggleData?.checked\"\n                   [disabled]=\"toggleData?.disabled\" [ariaLabel]=\"toggleData?.label\"\n                   class=\"ex-facet-toggle-wrapper-slider\"></ex-slide-toggle>\n</div>\n", styles: [".ex-facet-toggle-wrapper{white-space:nowrap;display:flex;flex-direction:row;justify-content:space-between}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-toggle-wrapper .ex-facet-toggle-label{background:none;border:0;overflow:hidden;text-overflow:ellipsis;display:flex;flex:1;padding-bottom:5px;border:2px solid transparent}.ex-facet-toggle-wrapper .ex-facet-toggle-label:focus{outline:0;border-color:#000}.ex-facet-toggle-wrapper-disabled{pointer-events:none;opacity:.5}\n"] }]
    }], function () { return []; }, { toggleData: [{
            type: Input
        }], toggleChanged: [{
            type: Output
        }] }); })();

class ExFacetEmptyComponent {
    constructor() { }
    static { this.ɵfac = function ExFacetEmptyComponent_Factory(t) { return new (t || ExFacetEmptyComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetEmptyComponent, selectors: [["ex-facet-empty"]], inputs: { label: "label" }, decls: 3, vars: 1, consts: [[1, "ex-facet-empty-wrapper"], [1, "ex-facet-empty-label"]], template: function ExFacetEmptyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label);
        } }, styles: [".ex-facet-empty-wrapper[_ngcontent-%COMP%]{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facet-empty-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-label[_ngcontent-%COMP%]{margin-top:5px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetEmptyComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-empty', template: "<div class=\"ex-facet-empty-wrapper\"><label class=\"ex-facet-empty-label\">{{ label }}</label></div>", styles: [".ex-facet-empty-wrapper{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facet-empty-wrapper .ex-facet-empty-label{margin-top:5px}\n"] }]
    }], function () { return []; }, { label: [{
            type: Input
        }] }); })();

function ExFacetSetTopComponent_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 2);
    i0.ɵɵlistener("click", function ExFacetSetTopComponent_ex_button_0_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleOpenClickedEvent()); });
    i0.ɵɵelementStart(1, "div", 3)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 4);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("full", true)("loading", ctx_r0.isLoading || ctx_r0.parentIsLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 4, ctx_r0.buttonHeaderLabel), "\u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedLibrariesTitleText);
} }
function ExFacetSetTopComponent_div_1_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-checkbox", 19);
    i0.ɵɵlistener("checkedChange", function ExFacetSetTopComponent_div_1_div_9_div_1_Template_ex_checkbox_checkedChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r9); const historyItem_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.handleCheckboxChange($event, historyItem_r7)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const historyItem_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r6.libraryData[historyItem_r7])("exTooltip", ctx_r6.libraryData[historyItem_r7])("checked", ctx_r6.selectedLibrariesIDs.indexOf(historyItem_r7) > -1);
} }
function ExFacetSetTopComponent_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ExFacetSetTopComponent_div_1_div_9_div_1_Template, 3, 3, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.recentItems);
} }
function ExFacetSetTopComponent_div_1_ex_checkbox_11_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 19);
    i0.ɵɵlistener("checkedChange", function ExFacetSetTopComponent_div_1_ex_checkbox_11_Template_ex_checkbox_checkedChange_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r12); const library_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.handleCheckboxChange($event, library_r10.value)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const library_r10 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", library_r10.key)("exTooltip", library_r10.key)("checked", ctx_r5.selectedLibrariesIDs.indexOf(library_r10.value) > -1);
} }
function ExFacetSetTopComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ex-button", 7);
    i0.ɵɵlistener("click", function ExFacetSetTopComponent_div_1_Template_ex_button_click_5_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.closeFacetDrawer()); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "ex-search", 9);
    i0.ɵɵlistener("searchTriggered", function ExFacetSetTopComponent_div_1_Template_ex_search_searchTriggered_8_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.handleSearchTriggered($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExFacetSetTopComponent_div_1_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵtemplate(11, ExFacetSetTopComponent_div_1_ex_checkbox_11_Template, 1, 3, "ex-checkbox", 12);
    i0.ɵɵpipe(12, "keyvalue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 13)(14, "ex-button", 14);
    i0.ɵɵlistener("click", function ExFacetSetTopComponent_div_1_Template_ex_button_click_14_listener() { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.handleClearClicked()); });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "ex-button", 15);
    i0.ɵɵlistener("click", function ExFacetSetTopComponent_div_1_Template_ex_button_click_18_listener() { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.handleApplyClicked()); });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 17, ctx_r1.fixedFacetTitle));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(6, 19, "ng.general.cancel"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("incremental", true)("autoFocus", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.recentItems !== null && ctx_r1.recentItems.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(12, 21, ctx_r1.displayList));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(15, 23, "ng.general.clear.all"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading)("disabled", ctx_r1.clearDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 25, "ng.general.clear.all"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(19, 27, "ng.general.apply"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 29, "ng.general.apply"), " ");
} }
class ExFacetSetTopComponent {
    set itemsGetterCallback(cb) {
        if (cb !== null) {
            this._itemsGetterCallback = cb;
            this._itemsGetterCallback.subscribe(response => {
                this.libraryData = response;
                this.loadingObs.next();
            });
        }
    }
    set loadSelectedCallback(cb) {
        if (cb !== null) {
            this._loadSelectedCallback = cb;
            this._loadSelectedCallback.subscribe((response) => {
                const oldCachedSelectedLibrariesIDs = this.cachedSelectedLibrariesIDs;
                if (typeof response === 'undefined' || !response.hasOwnProperty('appliedFacets')) {
                    this.cachedSelectedLibrariesIDs = [];
                }
                else {
                    const objType = Object.keys(response.appliedFacets);
                    this.cachedSelectedLibrariesIDs = objType.length ? response.appliedFacets[objType[0]].map(item => item.key) : [];
                }
                if (!isEqual(oldCachedSelectedLibrariesIDs, this.cachedSelectedLibrariesIDs)) {
                    this.facetChanged.emit({ selectedLibrariesIDs: this.cachedSelectedLibrariesIDs, reload: false });
                    this.loadingObs.next();
                }
            });
        }
    }
    set saveSelectedCallback(cb) {
        if (cb !== null) {
            this._saveSelectedCallback = cb;
        }
    }
    set loadHidtorySelectionCallback(cb) {
        if (cb !== null) {
            this._loadHidtorySelectionCallback = cb;
            this._loadHidtorySelectionCallback.subscribe(response => {
                if (typeof response === 'undefined' || response === null || response.length === 0) {
                    this.recentItems = [];
                }
                else {
                    this.recentItems = JSON.parse(response);
                }
                this.loadingObs.next();
            });
        }
    }
    set saveHidtorySelectionCallback(cb) {
        if (cb !== null) {
            this._saveHidtorySelectionCallback = cb;
        }
    }
    constructor(translate) {
        this.translate = translate;
        this._itemsGetterCallback = null;
        this._loadSelectedCallback = null;
        this._saveSelectedCallback = null;
        this._loadHidtorySelectionCallback = null;
        this._saveHidtorySelectionCallback = null;
        this.buttonHeaderLabel = '';
        this.fixedFacetTitle = '';
        this.parentIsLoading = false;
        this.facetChanged = new EventEmitter();
        this.openStateChange = new EventEmitter();
        this.isLoading = true;
        this.isOpen = false;
        this.libraryData = {};
        this.searchText = '';
        this.displayList = {};
        this.cachedSelectedLibrariesIDs = [];
        this.selectedLibrariesIDs = [];
        this.recentItems = [];
        this.selectedLibrariesTitleText = '';
        this.defaultSelectedLibrariesText = 'ng.general.all';
        this.clearDisabled = false;
        this.loadingObs = new Subject();
        this.numberOfRecentItems = 3;
        let counter = 0;
        const self = this;
        this.loadingObs.subscribe(function () {
            counter++;
            if (counter > 1) {
                self.fillAndFilterDisplayList();
                self.reloadCachedSelected();
                self.isLoading = false;
            }
        });
    }
    ngOnDestroy() {
        this.loadingObs.unsubscribe();
    }
    // Copy while filtering by search text the library list to a display list
    fillAndFilterDisplayList() {
        this.displayList = {};
        for (const libraryId in this.libraryData) {
            if (this.libraryData.hasOwnProperty(libraryId)) {
                if (this.searchText.trim().length === 0 || (this.searchText.trim().length > 0 && this.libraryData[libraryId].toLowerCase().includes(this.searchText))) {
                    this.displayList[this.libraryData[libraryId]] = libraryId;
                }
            }
        }
    }
    // Reset selected library list to saved values
    reloadCachedSelected() {
        this.selectedLibrariesIDs = this.cachedSelectedLibrariesIDs.slice();
        this.selectedLibrariesTitleText = '';
        this.clearDisabled = this.cachedSelectedLibrariesIDs.length === 0;
        for (let libraryId in this.libraryData) {
            if (this.selectedLibrariesIDs.indexOf(libraryId) > -1) {
                this.selectedLibrariesTitleText += this.libraryData[libraryId] + ', ';
            }
        }
        this.selectedLibrariesTitleText = this.selectedLibrariesTitleText.trim();
        if (this.selectedLibrariesTitleText === '') {
            this.selectedLibrariesTitleText = this.translate.instant(this.defaultSelectedLibrariesText);
        }
        else if (this.selectedLibrariesTitleText.lastIndexOf(',') === this.selectedLibrariesTitleText.length - 1) {
            this.selectedLibrariesTitleText = this.selectedLibrariesTitleText.slice(0, this.selectedLibrariesTitleText.length - 1);
        }
        //update text in box
        if (this._saveSelectedCallback !== null) {
            this._saveSelectedCallback(this.cachedSelectedLibrariesIDs, this.selectedLibrariesTitleText, false);
        }
    }
    handleOpenClickedEvent() {
        this.isOpen = true;
        this.openStateChange.emit(this.isOpen);
    }
    handleSearchTriggered(searchText) {
        this.searchText = searchText.toLowerCase().trim();
        this.fillAndFilterDisplayList();
    }
    closeFacetDrawer() {
        this.searchText = '';
        this.fillAndFilterDisplayList();
        this.reloadCachedSelected();
        this.isOpen = false;
        this.openStateChange.emit(this.isOpen);
    }
    handleCheckboxChange(newState, checkboxId) {
        const itemChangedIndex = this.selectedLibrariesIDs.indexOf(checkboxId);
        //Checkbox selected and library not in selected list then add to list
        if (newState && itemChangedIndex === -1) {
            this.selectedLibrariesIDs.push(checkboxId);
        }
        //Checkbox cleared and library in selected list then remove from list
        if (!newState && itemChangedIndex > -1) {
            this.selectedLibrariesIDs.splice(itemChangedIndex, 1);
        }
    }
    // saves selected values and update history list
    handleApplyClicked() {
        if (this._saveSelectedCallback !== null) {
            this.cachedSelectedLibrariesIDs = this.selectedLibrariesIDs;
            this._saveSelectedCallback(this.cachedSelectedLibrariesIDs);
            this.facetChanged.emit({ selectedLibrariesIDs: this.cachedSelectedLibrariesIDs, reload: true });
        }
        if (this._saveHidtorySelectionCallback !== null) {
            this.selectedLibrariesIDs.forEach(id => {
                if (!this.recentItems.includes(id)) {
                    if (this.recentItems.length > this.numberOfRecentItems - 1) {
                        this.recentItems.pop();
                    }
                    this.recentItems.unshift(id);
                }
            });
            this._saveHidtorySelectionCallback(JSON.stringify(this.recentItems));
        }
        this.closeFacetDrawer();
    }
    handleClearClicked() {
        this.selectedLibrariesIDs.length = 0;
        this.handleApplyClicked();
    }
    static { this.ɵfac = function ExFacetSetTopComponent_Factory(t) { return new (t || ExFacetSetTopComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetSetTopComponent, selectors: [["ex-facet-set-top"]], inputs: { itemsGetterCallback: "itemsGetterCallback", loadSelectedCallback: "loadSelectedCallback", saveSelectedCallback: "saveSelectedCallback", loadHidtorySelectionCallback: "loadHidtorySelectionCallback", saveHidtorySelectionCallback: "saveHidtorySelectionCallback", buttonHeaderLabel: "buttonHeaderLabel", fixedFacetTitle: "fixedFacetTitle", parentIsLoading: "parentIsLoading" }, outputs: { facetChanged: "facetChanged", openStateChange: "openStateChange" }, decls: 2, vars: 2, consts: [["type", "primary-light", "class", "ex-facet-set-top-main-button", 3, "full", "loading", "click", 4, "ngIf"], ["class", "ex-facet-set-top-scope-configuration-section", 4, "ngIf"], ["type", "primary-light", 1, "ex-facet-set-top-main-button", 3, "full", "loading", "click"], [1, "ex-facet-set-top-buttonContent"], [1, "ex-facet-set-top-boldText"], [1, "ex-facet-set-top-scope-configuration-section"], [1, "ex-facet-set-top-header"], ["ariaLabel", "ng.general.cancel", "type", "action", "iconSide", "right", 3, "tooltip", "full", "loading", "click"], ["icon", "", 1, "icon-density", "uxf-icon", "uxf-close"], ["placeholder", "Search", 1, "ex-facet-set-top-filter-bar", 3, "incremental", "autoFocus", "searchTriggered"], ["class", "ex-facet-set-top-history-options", 4, "ngIf"], [1, "ex-facet-set-top-options"], [3, "label", "exTooltip", "checked", "checkedChange", 4, "ngFor", "ngForOf"], [1, "ex-facet-set-top-apply-buttons"], ["type", "action", "ariaLabel", "ng.general.clear.all", 3, "full", "loading", "tooltip", "disabled", "click"], ["type", "primary", "ariaLabel", "ng.general.apply", 3, "full", "loading", "tooltip", "click"], [1, "ex-facet-set-top-history-options"], ["class", "ex-facet-set-top-history-item", 4, "ngFor", "ngForOf"], [1, "ex-facet-set-top-history-item"], [3, "label", "exTooltip", "checked", "checkedChange"], [1, "uxf-icon", "uxf-back-in-time"]], template: function ExFacetSetTopComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFacetSetTopComponent_ex_button_0_Template, 7, 6, "ex-button", 0);
            i0.ɵɵtemplate(1, ExFacetSetTopComponent_div_1_Template, 22, 31, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isOpen);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isOpen);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, ExButtonComponent, ExCheckboxComponent, ExSearchComponent, i1$5.KeyValuePipe, i1$2.TranslatePipe], styles: [".ex-facet-set-top-main-button[_ngcontent-%COMP%]{padding-bottom:10px;border-bottom:1px solid #aaa}.ex-facet-set-top-buttonContent[_ngcontent-%COMP%]{text-align:start;padding:5px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;width:100%}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-filter-bar[_ngcontent-%COMP%]{margin-bottom:5px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]{margin:5px 0;padding-bottom:10px;border-bottom:1px solid #c5c7c6}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]   .ex-facet-set-top-history-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:nowrap;align-items:center;align-content:center}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]   .ex-facet-set-top-history-item[_ngcontent-%COMP%]   ex-checkbox[_ngcontent-%COMP%]{min-width:0}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-options[_ngcontent-%COMP%]{margin:5px 0}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-apply-buttons[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(2,45%);justify-content:space-between;margin-top:10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetSetTopComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-set-top', template: "<ex-button type=\"primary-light\" [full]=\"true\" [loading]=\"isLoading || parentIsLoading\"\n    (click)=\"handleOpenClickedEvent()\" *ngIf=\"!isOpen\" class=\"ex-facet-set-top-main-button\">\n    <div class=\"ex-facet-set-top-buttonContent\">\n        <span>{{buttonHeaderLabel | translate}}&nbsp;</span>\n        <span class=\"ex-facet-set-top-boldText\">{{selectedLibrariesTitleText}}</span>\n    </div>\n</ex-button>\n\n<div *ngIf=\"isOpen\" class=\"ex-facet-set-top-scope-configuration-section\">\n    <div class=\"ex-facet-set-top-header\">\n        <span>{{fixedFacetTitle | translate}}</span>\n        <ex-button ariaLabel=\"ng.general.cancel\" tooltip=\"{{'ng.general.cancel' | translate}}\" type=\"action\"\n            [full]=\"true\" [loading]=\"isLoading\" (click)=\"closeFacetDrawer()\" iconSide=\"right\">\n            <i icon class=\"icon-density uxf-icon uxf-close\"></i>\n        </ex-button>\n    </div>\n    <ex-search placeholder=\"Search\" [incremental]=\"true\" [autoFocus]=\"true\" class=\"ex-facet-set-top-filter-bar\"\n        (searchTriggered)=\"handleSearchTriggered($event)\">\n    </ex-search>\n\n    <div class=\"ex-facet-set-top-history-options\" *ngIf=\"recentItems !== null && recentItems.length > 0\">\n        <div class=\"ex-facet-set-top-history-item\" *ngFor=\"let historyItem of recentItems\">\n            <ex-checkbox [label]=\"this.libraryData[historyItem]\" [exTooltip]=\"this.libraryData[historyItem]\"\n                [checked]=\"selectedLibrariesIDs.indexOf(historyItem) > -1\"\n                (checkedChange)=\"handleCheckboxChange($event, historyItem)\"></ex-checkbox>\n            <i class=\"uxf-icon uxf-back-in-time\"></i>\n        </div>\n    </div>\n\n    <div class=\"ex-facet-set-top-options\">\n        <ex-checkbox *ngFor=\"let library of displayList | keyvalue\" [label]=\"library.key\" [exTooltip]=\"library.key\"\n            [checked]=\"selectedLibrariesIDs.indexOf(library.value) > -1\"\n            (checkedChange)=\"handleCheckboxChange($event, library.value)\"></ex-checkbox>\n    </div>\n    <div class=\"ex-facet-set-top-apply-buttons\">\n        <ex-button type=\"action\" [full]=\"true\" [loading]=\"isLoading\" (click)=\"handleClearClicked()\"\n            ariaLabel=\"ng.general.clear.all\" tooltip=\"{{'ng.general.clear.all' | translate}}\"\n            [disabled]=\"clearDisabled\">\n            {{'ng.general.clear.all' | translate}}\n        </ex-button>\n\n        <ex-button type=\"primary\" [full]=\"true\" [loading]=\"isLoading\" (click)=\"handleApplyClicked()\"\n            ariaLabel=\"ng.general.apply\" tooltip=\"{{'ng.general.apply' | translate}}\">\n            {{'ng.general.apply' | translate}}\n        </ex-button>\n    </div>\n</div>", styles: [".ex-facet-set-top-main-button{padding-bottom:10px;border-bottom:1px solid #aaa}.ex-facet-set-top-buttonContent{text-align:start;padding:5px}.ex-facet-set-top-scope-configuration-section{display:flex;flex-direction:column;justify-content:flex-start;width:100%}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-filter-bar{margin-bottom:5px}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options{margin:5px 0;padding-bottom:10px;border-bottom:1px solid #c5c7c6}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options .ex-facet-set-top-history-item{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:nowrap;align-items:center;align-content:center}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options .ex-facet-set-top-history-item ex-checkbox{min-width:0}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-options{margin:5px 0}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-apply-buttons{display:grid;grid-template-columns:repeat(2,45%);justify-content:space-between;margin-top:10px}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { itemsGetterCallback: [{
            type: Input
        }], loadSelectedCallback: [{
            type: Input
        }], saveSelectedCallback: [{
            type: Input
        }], loadHidtorySelectionCallback: [{
            type: Input
        }], saveHidtorySelectionCallback: [{
            type: Input
        }], buttonHeaderLabel: [{
            type: Input
        }], fixedFacetTitle: [{
            type: Input
        }], parentIsLoading: [{
            type: Input
        }], facetChanged: [{
            type: Output
        }], openStateChange: [{
            type: Output
        }] }); })();

const _c0$z = ["OverFlowRef"];
const _c1$o = ["status"];
function ExFacetWrapperComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "ex-facet-set-top", 12);
    i0.ɵɵlistener("facetChanged", function ExFacetWrapperComponent_div_0_div_1_Template_ex_facet_set_top_facetChanged_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.handleFixedFacetChange($event)); })("openStateChange", function ExFacetWrapperComponent_div_0_div_1_Template_ex_facet_set_top_openStateChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.handleFixedFacetOpenChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("itemsGetterCallback", ctx_r2.fixedFacetItemGetterCallback)("parentIsLoading", ctx_r2.isLoading)("saveSelectedCallback", ctx_r2.fixedFacetSaveSelectedCallback)("loadSelectedCallback", ctx_r2.fixedFacetLoadSelectedCallback)("saveHidtorySelectionCallback", ctx_r2.fixedFacetSaveHistoryCallback)("loadHidtorySelectionCallback", ctx_r2.fixedFacetLoadHistoryCallback)("buttonHeaderLabel", ctx_r2.fixedFacetButtonHeaderLabel)("fixedFacetTitle", ctx_r2.fixedFacetTitle);
} }
function ExFacetWrapperComponent_div_0_div_2_ex_selected_facets_wrapper_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-selected-facets-wrapper", 15);
    i0.ɵɵlistener("itemRemoved", function ExFacetWrapperComponent_div_0_div_2_ex_selected_facets_wrapper_1_Template_ex_selected_facets_wrapper_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.selectedFacetsChanged($event)); })("itemsCleared", function ExFacetWrapperComponent_div_0_div_2_ex_selected_facets_wrapper_1_Template_ex_selected_facets_wrapper_itemsCleared_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.clearSelectedFacets()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedFacets", ctx_r12.selectedFacetsToShow)("headerText", ctx_r12.selectedFacetsHeader)("clearAllText", ctx_r12.clearAllText)("facetPrefixTranslate", ctx_r12.facetPrefixTranslate)("valueToLabelMap", ctx_r12.valueToLabelMap);
} }
function ExFacetWrapperComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_0_div_2_ex_selected_facets_wrapper_1_Template, 1, 5, "ex-selected-facets-wrapper", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedFacetsToShow && ctx_r3.selectedFacetsToShow.length > 0);
} }
function ExFacetWrapperComponent_div_0_hr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 16);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_div_7_ex_facet_toggle_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-facet-toggle", 28);
    i0.ɵɵlistener("toggleChanged", function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_div_7_ex_facet_toggle_1_Template_ex_facet_toggle_toggleChanged_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r26.onToggleChanged($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const toggle_r25 = ctx.$implicit;
    i0.ɵɵproperty("toggleData", toggle_r25)("exTooltip", toggle_r25 == null ? null : toggle_r25.tooltip);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_div_7_ex_facet_toggle_1_Template, 1, 2, "ex-facet-toggle", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r20.toggles);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_ex_component_loader_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 29);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("componentFactoryItem", item_r20)("data", ctx_r22.getData(item_r20.data));
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_ex_facet_empty_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-facet-empty", 30);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("label", item_r20.emptyLabel);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-expansion-panel", 21)(2, "mat-expansion-panel-header", 22)(3, "mat-panel-title", 23)(4, "label", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(7, ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_div_7_Template, 2, 1, "div", 19);
    i0.ɵɵtemplate(8, ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_ex_component_loader_8_Template, 1, 2, "ex-component-loader", 25);
    i0.ɵɵtemplate(9, ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_ex_facet_empty_9_Template, 1, 1, "ex-facet-empty", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("expanded", ctx_r19.panelsExpended);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("expandedHeight", "30px")("collapsedHeight", "30px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("exTooltip", item_r20.data.title)("ngClass", "sel-group-" + item_r20.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, item_r20.data.title));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r20.toggles);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r20.emptyLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r20.emptyLabel !== null);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_0_div_6_ng_container_2_ng_container_1_Template, 10, 11, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r17.facetItems);
} }
function ExFacetWrapperComponent_div_0_div_6_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelement(2, "div", 32)(3, "div", 33)(4, "div", 33)(5, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
const _c2$g = function () { return [0, 1, 2, 3, 4]; };
function ExFacetWrapperComponent_div_0_div_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_0_div_6_ng_container_3_ng_container_1_Template, 6, 0, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c2$g));
} }
const _c3$d = function (a0) { return { "ex-facet-wrapper-flex-one": a0 }; };
function ExFacetWrapperComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17, 18);
    i0.ɵɵtemplate(2, ExFacetWrapperComponent_div_0_div_6_ng_container_2_Template, 2, 1, "ng-container", 19);
    i0.ɵɵtemplate(3, ExFacetWrapperComponent_div_0_div_6_ng_container_3_Template, 2, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$d, (ctx_r6.facetItems == null ? null : ctx_r6.facetItems.length) > 0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r6.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.isLoading);
} }
function ExFacetWrapperComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "button", 35);
    i0.ɵɵlistener("click", function ExFacetWrapperComponent_div_0_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.applyChanges()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 36);
    i0.ɵɵlistener("click", function ExFacetWrapperComponent_div_0_div_7_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.clearNotAppliedChanges()); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-icon", 37);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "ng.general.apply"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 4, "ng.general.clear"));
} }
const _c4$a = function (a0) { return { "height": a0 }; };
function ExFacetWrapperComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38)(1, "p", 39);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 40);
    i0.ɵɵelement(4, "img", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c4$a, ctx_r8.noFacetsHeight));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.noFacetsText);
} }
function ExFacetWrapperComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_0_div_1_Template, 2, 8, "div", 3);
    i0.ɵɵtemplate(2, ExFacetWrapperComponent_div_0_div_2_Template, 2, 1, "div", 4);
    i0.ɵɵtemplate(3, ExFacetWrapperComponent_div_0_hr_3_Template, 1, 0, "hr", 5);
    i0.ɵɵelement(4, "i", 6, 7);
    i0.ɵɵtemplate(6, ExFacetWrapperComponent_div_0_div_6_Template, 4, 5, "div", 8);
    i0.ɵɵtemplate(7, ExFacetWrapperComponent_div_0_div_7_Template, 7, 6, "div", 9);
    i0.ɵɵtemplate(8, ExFacetWrapperComponent_div_0_div_8_Template, 5, 4, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showFixedFacet);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.fixedFacetOpenState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.fixedFacetOpenState && ctx_r0.selectedFacetsToShow && ctx_r0.selectedFacetsToShow.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r0.statusMsg);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.fixedFacetOpenState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.fixedFacetOpenState && ctx_r0.hasApply);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading && !ctx_r0.fixedFacetOpenState && ctx_r0.facetItems.length === 0);
} }
function ExFacetWrapperComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵelement(5, "img", 44);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "ng.full_page.blocked_facets_message"));
} }
class ExFacetWrapperComponent {
    /**
     * @ignore
     */
    constructor(ref, translate) {
        this.ref = ref;
        this.translate = translate;
        /**
         * If the panels should be expended on load
         */
        this.panelsExpended = true;
        /**
         * is the facetItems loading
         */
        this.isLoading = false;
        /**
         * The list of the selected facets
         * value of type { code: string, description: string }[][] will be used for hierarchy facets,
         * string[] will be used in others
         */
        this.selectedFacets = [];
        /**
         * Indicates that a facet changed his values
         */
        this.facetChanged = new EventEmitter();
        /**
         * Indicates that a selected facet has been removed
         */
        this.selectedFacetRemoved = new EventEmitter();
        /**
         * Indicates that all the selected facets has been cleared
         */
        this.selectedFacetsCleared = new EventEmitter();
        /**
         * The text of the clear all button
         */
        this.clearAllText = 'ng.general.clear.all';
        /**
         * Display facets blocked message
         */
        this.blockFacets = false;
        /**
         * The text that appears when a list can be expended.
         */
        this.showMoreText = 'facets_layout.facets.group.more';
        /**
         * The text that appears when a list can be shrunken.
         */
        this.showLessText = 'facets_layout.facets.group.less';
        /**
         * The maximum amount of items that should be available before the show more will appear
         */
        this.maxItemsPerFacet = 3;
        /**
         * map of values and labels to display
         */
        this.valueToLabelMap = {};
        /**
         *  if we have a prefix for the facet key that will be translated;
         */
        this.facetPrefixTranslate = '';
        this.fixedFacetItemGetterCallback = null;
        this.fixedFacetSaveSelectedCallback = null;
        this.fixedFacetLoadSelectedCallback = null;
        this.fixedFacetSaveHistoryCallback = null;
        this.fixedFacetLoadHistoryCallback = null;
        this.fixedFacetButtonHeaderLabel = '';
        this.fixedFacetTitle = '';
        this.fixedFacetTypeName = '';
        this.showFixedFacet = false;
        /**
         * This event fires when one any toggle changes
         */
        this.toggleChanged = new EventEmitter();
        this.hasApply = false;
        this.statusMsg = '';
        this.itemsObservables = [];
        this.aggregatedData = [];
        this.selectedFixedFacets = { facetType: '', selectedValues: [] };
        this.fixedFacetOpenState = false;
    }
    ngOnInit() {
        this.selectedFacets = this.deepCopy(this.selectedFacets);
    }
    /**
     * This function subscribes to the outputs of the facets and builds the selected facets
     */
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedFacets')) {
            this.selectedFacetsToShow = this.deepCopy(this.selectedFacets);
        }
        for (let index = 0; index < this.facetItems.length; index++) {
            // Subscribe to each of the facets outputs
            this.itemsObservables.push(this.facetItems[index].data.dataOutput.subscribe((data) => {
                this.aggregatedData[index] = data;
                if (data === undefined) {
                    return;
                }
                const itemType = data[0];
                const itemId = data[1];
                const values = data.splice(2);
                if (values.length === 0) {
                    return;
                }
                if (itemType !== ExFacetsTypes.MULTI_SELECT || values[1] === false) { // if we want the facets to refresh immediately
                    this.selectedFacets = this.deepCopy(this.selectedFacetsToShow); // we want to reset the checked checkboxes that are not applied yet
                }
                const facetsGroupIndex = this.facetItems.findIndex(item => item.data.id === itemId);
                const selectedIndex = this.selectedFacets.findIndex(facet => facet.field === this.facetItems[facetsGroupIndex].data.id);
                // Depending on the type of the facet, update the selected facets
                switch (itemType) {
                    case ExFacetsTypes.MULTI_SELECT: {
                        if (selectedIndex !== -1) {
                            this.selectedFacets[selectedIndex].values = values[0];
                        }
                        else {
                            this.selectedFacets.push({ field: this.facetItems[facetsGroupIndex].data.id, values: values[0], type: itemType, title: this.facetItems[facetsGroupIndex].data.title });
                        }
                        break;
                    }
                    case ExFacetsTypes.SINGLE_SELECT: {
                        if (selectedIndex !== -1) {
                            this.selectedFacets[selectedIndex].values = values;
                        }
                        else {
                            this.selectedFacets.push({ field: this.facetItems[facetsGroupIndex].data.id, values: values, type: itemType, title: this.facetItems[facetsGroupIndex].data.title });
                        }
                        break;
                    }
                    case ExFacetsTypes.BOOLEAN: {
                        if (selectedIndex !== -1) {
                            this.selectedFacets[selectedIndex].values = values[0];
                        }
                        else {
                            this.selectedFacets.push({
                                field: this.facetItems[facetsGroupIndex].data.id,
                                values: values[0],
                                type: itemType,
                                title: this.facetItems[facetsGroupIndex].data.title
                            });
                        }
                        break;
                    }
                    case ExFacetsTypes.RANGE: {
                        if (values[0] === undefined) {
                            values[0] = 0;
                        }
                        if (selectedIndex !== -1) {
                            this.selectedFacets[selectedIndex].values = [`${values[0]}-${values[1]} ${values[2]}`];
                        }
                        else {
                            this.selectedFacets.push({
                                field: this.facetItems[facetsGroupIndex].data.id,
                                values: [`${values[0]}-${values[1]} ${values[2]}`],
                                type: itemType,
                                title: this.facetItems[facetsGroupIndex].data.title
                            });
                        }
                        break;
                    }
                    case ExFacetsTypes.HIERARCHY: {
                        if (selectedIndex !== -1) {
                            this.selectedFacets[selectedIndex].values = values[0];
                        }
                        else {
                            this.selectedFacets.push({
                                field: this.facetItems[facetsGroupIndex].data.id,
                                values: values[0],
                                type: itemType,
                                title: this.facetItems[facetsGroupIndex].data.title
                            });
                        }
                        break;
                    }
                }
                if (itemType !== ExFacetsTypes.MULTI_SELECT || values[1] === false) { // if we want the facets to refresh immediately
                    this.applyChanges(); // Update the selected facets
                }
                else { // if we don't want the facet to refresh immediately but to have an apply button instead
                    this.hasApply = this.getHasApply();
                }
            }));
            // Set the maximum amount of items and the showMore and showLess texts
            this.facetItems[index].data.arguments.maxItems = this.maxItemsPerFacet;
            this.facetItems[index].data.arguments.showMoreText = this.showMoreText;
            this.facetItems[index].data.arguments.showLessText = this.showLessText;
        }
        if (this.facetItems.length !== 0) {
            // recalculate the height of the facets after adding the selected facet
            this.facetsHeight = 'calc(100vh - ' + this.overFlowDivRef?.nativeElement?.getBoundingClientRect().top + 'px)';
            this.ref.detectChanges();
        }
        else {
            this.facetsHeight = '0px';
            this.ref.detectChanges();
        }
    }
    /**
     * Unsubscribes to all the facets outputs
     */
    ngOnDestroy() {
        for (let index = 0; index < this.facetItems.length; index++) {
            this.itemsObservables[index].unsubscribe();
        }
    }
    /**
     * This function gets the event of removal of a selected facet, and updates the list
     * @param removedFacet the facet that should be removed from the list
     */
    selectedFacetsChanged(removedFacet) {
        const selectedFacet = this.selectedFacets[removedFacet.fieldIndex];
        selectedFacet.type === 'HIERARCHY' ? this.selectedFacets[removedFacet.fieldIndex].values = [] :
            this.selectedFacets[removedFacet.fieldIndex].values.splice(removedFacet.valueIndex, 1);
        if (this.selectedFacets[removedFacet.fieldIndex].values.length === 0) {
            this.selectedFacets.splice(removedFacet.fieldIndex, 1);
        }
        this.selectedFacetRemoved.emit({ data: this.aggregatedData, selectedFacets: this.selectedFacets, fixedFacets: this.selectedFixedFacets });
    }
    /**
     * This functions gets the event of clearing all the selected facets and clears the list
     */
    clearSelectedFacets() {
        this.selectedFacets = [];
        this.translate.get('ng.facets.status_msg.facets_cleared').subscribe(label => this.statusMsg = label);
        this.selectedFacetsCleared.emit({ data: this.aggregatedData, selectedFacets: this.selectedFacets, fixedFacets: this.selectedFixedFacets });
    }
    getData(data) {
        if (data.arguments.type === 'MULTI_SELECT' || data.arguments.type === 'BOOLEAN') {
            const selected = this.selectedFacets.find(({ field }) => field === data.id) || { values: [] };
            return { ...data, checkedItems: selected.values };
        }
        else {
            return data;
        }
    }
    applyChanges() {
        this.hasApply = false;
        this.selectedFacets = this.selectedFacets.filter(facet => facet.values?.length > 0);
        this.selectedFacetsToShow = this.deepCopy(this.selectedFacets);
        this.translate.get('ng.facets.status_msg.changes_had_applied').subscribe(label => this.statusMsg = label);
        this.facetChanged.emit({ data: this.aggregatedData, selectedFacets: this.selectedFacets, fixedFacets: this.selectedFixedFacets });
    }
    clearNotAppliedChanges() {
        this.hasApply = false;
        this.selectedFacets = this.deepCopy(this.selectedFacetsToShow);
    }
    deepCopy(array) {
        return (array || []).map(facet => {
            return {
                ...facet,
                values: [...facet.values]
            };
        });
    }
    getHasApply() {
        const check = this.selectedFacetsToShow.findIndex(facet => {
            const group = this.selectedFacets.find(selectedFacet => selectedFacet.field === facet.field);
            if (group === undefined) {
                if (facet.values?.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            if (!(group.values.length === facet.values.length && group.values.every((value, index) => value === facet.values[index]))) {
                return true;
            }
            return false;
        });
        if (check !== -1) {
            return true;
        }
        return this.selectedFacets.findIndex(facet => {
            const group = this.selectedFacetsToShow.find(selectedFacet => selectedFacet.field === facet.field);
            if (group === undefined) {
                if (facet.values?.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            if (!(group.values.length === facet.values.length && group.values.every((value, index) => value === facet.values[index]))) {
                return true;
            }
            return false;
        }) !== -1;
    }
    onToggleChanged(data) {
        this.toggleChanged.emit(data);
    }
    handleFixedFacetChange(data) {
        const { selectedLibrariesIDs, reload } = data;
        if (this.showFixedFacet && this.fixedFacetTypeName.length > 0) {
            this.clearSelectedFacets();
            this.selectedFixedFacets.facetType = this.fixedFacetTypeName;
            this.selectedFixedFacets.selectedValues = selectedLibrariesIDs;
            if (reload)
                this.applyChanges();
        }
    }
    handleFixedFacetOpenChange(state) {
        this.fixedFacetOpenState = state;
    }
    static { this.ɵfac = function ExFacetWrapperComponent_Factory(t) { return new (t || ExFacetWrapperComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetWrapperComponent, selectors: [["ex-facet-wrapper"]], viewQuery: function ExFacetWrapperComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$z, 7);
            i0.ɵɵviewQuery(_c1$o, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overFlowDivRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.statusRef = _t.first);
        } }, inputs: { facetItems: "facetItems", panelsExpended: "panelsExpended", isLoading: "isLoading", selectedFacets: "selectedFacets", noFacetsText: "noFacetsText", selectedFacetsHeader: "selectedFacetsHeader", clearAllText: "clearAllText", blockFacets: "blockFacets", showMoreText: "showMoreText", showLessText: "showLessText", maxItemsPerFacet: "maxItemsPerFacet", valueToLabelMap: "valueToLabelMap", facetPrefixTranslate: "facetPrefixTranslate", fixedFacetItemGetterCallback: "fixedFacetItemGetterCallback", fixedFacetSaveSelectedCallback: "fixedFacetSaveSelectedCallback", fixedFacetLoadSelectedCallback: "fixedFacetLoadSelectedCallback", fixedFacetSaveHistoryCallback: "fixedFacetSaveHistoryCallback", fixedFacetLoadHistoryCallback: "fixedFacetLoadHistoryCallback", fixedFacetButtonHeaderLabel: "fixedFacetButtonHeaderLabel", fixedFacetTitle: "fixedFacetTitle", fixedFacetTypeName: "fixedFacetTypeName", showFixedFacet: "showFixedFacet" }, outputs: { facetChanged: "facetChanged", selectedFacetRemoved: "selectedFacetRemoved", selectedFacetsCleared: "selectedFacetsCleared", toggleChanged: "toggleChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "ex-facet-wrapper-full-height ex-facet-wrapper-back-color", 4, "ngIf"], ["class", "ex-facet-wrapper-no-facets", 4, "ngIf"], [1, "ex-facet-wrapper-full-height", "ex-facet-wrapper-back-color"], ["class", "ex-facet-wrapper-persistent-facet", 4, "ngIf"], ["class", "ex-facet-wrapper-fixed-selected", 4, "ngIf"], ["class", "ex-facets-wrapper-selected-facets-hr", 4, "ngIf"], ["role", "status", "aria-live", "polite"], ["status", ""], ["class", "ex-facet-wrapper-overflow-auto", 3, "ngClass", 4, "ngIf"], ["class", "ex-facet-wrapper-apply-clear", 4, "ngIf"], ["class", "ex-facet-wrapper-flex-column", 3, "ngStyle", 4, "ngIf"], [1, "ex-facet-wrapper-persistent-facet"], [3, "itemsGetterCallback", "parentIsLoading", "saveSelectedCallback", "loadSelectedCallback", "saveHidtorySelectionCallback", "loadHidtorySelectionCallback", "buttonHeaderLabel", "fixedFacetTitle", "facetChanged", "openStateChange"], [1, "ex-facet-wrapper-fixed-selected"], [3, "selectedFacets", "headerText", "clearAllText", "facetPrefixTranslate", "valueToLabelMap", "itemRemoved", "itemsCleared", 4, "ngIf"], [3, "selectedFacets", "headerText", "clearAllText", "facetPrefixTranslate", "valueToLabelMap", "itemRemoved", "itemsCleared"], [1, "ex-facets-wrapper-selected-facets-hr"], [1, "ex-facet-wrapper-overflow-auto", 3, "ngClass"], ["OverFlowRef", ""], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "mat-content-density", "ex-facet-wrapper-back-color", "ex-facet-wrapper-no-shadow", 3, "expanded"], [1, "mat-header-density", 3, "expandedHeight", "collapsedHeight"], [1, "ex-facet-wrapper-full-width"], [1, "ex-facet-wrapper-panel-header-text", 3, "exTooltip", "ngClass"], [3, "componentFactoryItem", "data", 4, "ngIf"], [3, "label", 4, "ngIf"], [3, "toggleData", "exTooltip", "toggleChanged", 4, "ngFor", "ngForOf"], [3, "toggleData", "exTooltip", "toggleChanged"], [3, "componentFactoryItem", "data"], [3, "label"], [1, "ex-facet-wrapper-placeholder"], [1, "ex-facet-placeholder-header"], [1, "ex-facet-placeholder-label"], [1, "ex-facet-wrapper-apply-clear"], ["mat-ripple", "", 1, "ex-facet-wrapper-apply-button", "sel-apply-facets", 3, "click"], ["mat-ripple", "", 1, "ex-facet-wrapper-clear-button", "sel-clear-facets", 3, "click"], ["iconType", "matIcon", "iconName", "clear", "color", "white", "sizePx", "20px"], [1, "ex-facet-wrapper-flex-column", 3, "ngStyle"], [1, "ex-facet-wrapper-no-facets-header-text"], [1, "ex-facet-wrapper-no-facets-image"], ["src", "/infra/images/no-facets.png?version=March2019"], [1, "ex-facet-wrapper-no-facets"], [1, "ex-facet-wrapper-no-facet-img"], ["alt", "'ng.full_page.blocked_facets_message' | translate", "src", "/infra/images/no-facets.png?version=March2019"]], template: function ExFacetWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFacetWrapperComponent_div_0_Template, 9, 7, "div", 0);
            i0.ɵɵtemplate(1, ExFacetWrapperComponent_div_1_Template, 6, 3, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.blockFacets);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.blockFacets);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgStyle, ExComponentLoaderComponent, i2$7.MatExpansionPanel, i2$7.MatExpansionPanelHeader, i2$7.MatExpansionPanelTitle, ExTooltipDirective, i6$1.MatRipple, ExIconComponent, ExSelectedFacetsWrapperComponent, ExFacetToggleComponent, ExFacetEmptyComponent, ExFacetSetTopComponent, i1$2.TranslatePipe], styles: [".ex-facet-wrapper-full-height[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.ex-facet-wrapper-full-width[_ngcontent-%COMP%]{width:100%}.ex-facet-wrapper-panel-header-text[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0 24px 0 22px;border:2px solid transparent}mat-expansion-panel-header[_ngcontent-%COMP%]:focus{border-color:#000!important}.ex-facet-wrapper-no-shadow[_ngcontent-%COMP%]{box-shadow:none!important}.ex-facet-wrapper-no-facets-header-text[_ngcontent-%COMP%]{margin:10px 0;align-self:center}.ex-facet-wrapper-no-facets-image[_ngcontent-%COMP%]{align-self:center}.ex-facet-wrapper-flex-column[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-facet-wrapper-fixed-selected[_ngcontent-%COMP%]{overflow:auto;max-height:50%;position:sticky;top:0;width:100%;z-index:10;padding-top:15px}  .mat-expansion-panel-content{font-size:inherit}.ex-facet-wrapper-overflow-auto[_ngcontent-%COMP%]{overflow:auto}.ex-facet-wrapper-flex-one[_ngcontent-%COMP%]{padding-top:15px;flex:1}.ex-facet-wrapper-apply-clear[_ngcontent-%COMP%]{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facet-wrapper-apply-clear[_ngcontent-%COMP%]   .ex-facet-wrapper-clear-button[_ngcontent-%COMP%]{padding-bottom:4px}.ex-facet-wrapper-apply-clear[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{outline:0px}.ex-facet-wrapper-apply-button[_ngcontent-%COMP%]{flex:1}.ex-facet-placeholder-header[_ngcontent-%COMP%]{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facet-placeholder-label[_ngcontent-%COMP%]{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facet-wrapper-placeholder[_ngcontent-%COMP%]{margin:0 0 24px}.ex-facet-wrapper-clear-button[_ngcontent-%COMP%]{width:50px}.ex-facet-wrapper-clear-button[_ngcontent-%COMP%]     i{margin-top:5px}.ex-facets-wrapper-selected-facets-hr[_ngcontent-%COMP%]{height:1px;margin:0 23px;border-top:1px solid #aaa}.ex-facet-wrapper-persistent-facet[_ngcontent-%COMP%]{width:calc(100% - 48px);margin:0 24px;padding-top:15px;overflow-y:auto}.ex-facet-wrapper-no-facets[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facet-wrapper-no-facets[_ngcontent-%COMP%]   .ex-facet-wrapper-no-facet-img[_ngcontent-%COMP%]{display:flex;justify-content:center}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-wrapper', template: "<div *ngIf=\"!blockFacets\" class=\"ex-facet-wrapper-full-height ex-facet-wrapper-back-color\">\n  <div class=\"ex-facet-wrapper-persistent-facet\" *ngIf=\"showFixedFacet\">\n    <ex-facet-set-top [itemsGetterCallback]=\"fixedFacetItemGetterCallback\" [parentIsLoading]=\"isLoading\"\n      [saveSelectedCallback]=\"fixedFacetSaveSelectedCallback\" [loadSelectedCallback]=\"fixedFacetLoadSelectedCallback\"\n      [saveHidtorySelectionCallback]=\"fixedFacetSaveHistoryCallback\"\n      [loadHidtorySelectionCallback]=\"fixedFacetLoadHistoryCallback\" [buttonHeaderLabel]=\"fixedFacetButtonHeaderLabel\"\n      [fixedFacetTitle]=\"fixedFacetTitle\" (facetChanged)=\"handleFixedFacetChange($event)\"\n      (openStateChange)=\"handleFixedFacetOpenChange($event)\"></ex-facet-set-top>\n  </div>\n\n  <div class=\"ex-facet-wrapper-fixed-selected\" *ngIf=\"!fixedFacetOpenState\">\n    <ex-selected-facets-wrapper *ngIf=\"selectedFacetsToShow && selectedFacetsToShow.length > 0\"\n      [selectedFacets]=\"selectedFacetsToShow\" [headerText]=\"selectedFacetsHeader\" [clearAllText]=\"clearAllText\"\n      [facetPrefixTranslate]=\"facetPrefixTranslate\" (itemRemoved)=\"selectedFacetsChanged($event)\"\n      (itemsCleared)=\"clearSelectedFacets()\" [valueToLabelMap]=\"valueToLabelMap\"></ex-selected-facets-wrapper>\n  </div>\n  <hr class=\"ex-facets-wrapper-selected-facets-hr\"\n    *ngIf=\"!fixedFacetOpenState && selectedFacetsToShow && selectedFacetsToShow.length > 0\">\n  <i #status role=\"status\" attr.aria-label=\"{{ statusMsg }}\" aria-live=\"polite\"></i>\n  <div #OverFlowRef class=\"ex-facet-wrapper-overflow-auto\"\n    [ngClass]=\"{'ex-facet-wrapper-flex-one' : facetItems?.length > 0}\" *ngIf=\"!fixedFacetOpenState\">\n    <ng-container *ngIf=\"!isLoading\">\n      <ng-container *ngFor=\"let item of facetItems\">\n        <mat-expansion-panel class=\"mat-content-density ex-facet-wrapper-back-color ex-facet-wrapper-no-shadow\"\n          [expanded]=\"panelsExpended\">\n          <mat-expansion-panel-header [expandedHeight]=\"'30px'\" [collapsedHeight]=\"'30px'\" class=\"mat-header-density\">\n            <mat-panel-title class=\"ex-facet-wrapper-full-width\">\n              <label [exTooltip]=\"item.data.title\" class=\"ex-facet-wrapper-panel-header-text\"\n                [ngClass]=\"'sel-group-' + item.data.id\">{{ item.data.title | translate }}</label>\n            </mat-panel-title>\n          </mat-expansion-panel-header>\n          <div *ngIf=\"item.toggles\">\n            <ex-facet-toggle *ngFor=\"let toggle of item.toggles\" [toggleData]=\"toggle\"\n              (toggleChanged)=\"onToggleChanged($event)\" [exTooltip]=\"toggle?.tooltip\"></ex-facet-toggle>\n          </div>\n          <!-- if we want to show the component that was passed in ExFacetFactoryItem-->\n          <ex-component-loader *ngIf=\"!item.emptyLabel\" [componentFactoryItem]=\"item\" [data]=\"getData(item.data)\">\n          </ex-component-loader>\n          <!-- if we want to show the empty component-->\n          <ex-facet-empty *ngIf=\"item.emptyLabel !== null\" [label]=\"item.emptyLabel\"></ex-facet-empty>\n        </mat-expansion-panel>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"isLoading\">\n      <ng-container *ngFor=\"let number of [0,1,2,3,4]\">\n        <div class=\"ex-facet-wrapper-placeholder\">\n          <div class=\"ex-facet-placeholder-header\"></div>\n          <div class=\"ex-facet-placeholder-label\"></div>\n          <div class=\"ex-facet-placeholder-label\"></div>\n          <div class=\"ex-facet-placeholder-label\"></div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n  <div *ngIf=\"!fixedFacetOpenState && hasApply\" class=\"ex-facet-wrapper-apply-clear\">\n    <button mat-ripple (click)=\"applyChanges()\"\n      class=\"ex-facet-wrapper-apply-button sel-apply-facets\">{{ 'ng.general.apply' | translate }}</button>\n    <button mat-ripple (click)=\"clearNotAppliedChanges()\" class=\"ex-facet-wrapper-clear-button sel-clear-facets\"\n      [attr.aria-label]=\"'ng.general.clear' | translate\">\n      <ex-icon iconType=\"matIcon\" iconName=\"clear\" color=\"white\" sizePx=\"20px\">\n      </ex-icon>\n    </button>\n  </div>\n\n  <div class=\"ex-facet-wrapper-flex-column\" *ngIf=\"!isLoading && !fixedFacetOpenState && facetItems.length === 0\"\n    [ngStyle]=\"{'height': noFacetsHeight}\">\n    <p class=\"ex-facet-wrapper-no-facets-header-text\">{{ noFacetsText }}</p>\n    <div class=\"ex-facet-wrapper-no-facets-image\"><img src=\"/infra/images/no-facets.png?version=March2019\" /></div>\n  </div>\n</div>\n<div *ngIf=\"blockFacets\" class=\"ex-facet-wrapper-no-facets\">\n  <label>{{'ng.full_page.blocked_facets_message' | translate}}</label>\n  <div class=\"ex-facet-wrapper-no-facet-img\"><img alt=\"'ng.full_page.blocked_facets_message' | translate\"\n      src=\"/infra/images/no-facets.png?version=March2019\" /></div>\n</div>", styles: [".ex-facet-wrapper-full-height{height:100%;display:flex;flex-direction:column}.ex-facet-wrapper-full-width{width:100%}.ex-facet-wrapper-panel-header-text{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}mat-expansion-panel-header{padding:0 24px 0 22px;border:2px solid transparent}mat-expansion-panel-header:focus{border-color:#000!important}.ex-facet-wrapper-no-shadow{box-shadow:none!important}.ex-facet-wrapper-no-facets-header-text{margin:10px 0;align-self:center}.ex-facet-wrapper-no-facets-image{align-self:center}.ex-facet-wrapper-flex-column{display:flex;flex-direction:column}.ex-facet-wrapper-fixed-selected{overflow:auto;max-height:50%;position:sticky;top:0;width:100%;z-index:10;padding-top:15px}::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facet-wrapper-overflow-auto{overflow:auto}.ex-facet-wrapper-flex-one{padding-top:15px;flex:1}.ex-facet-wrapper-apply-clear{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facet-wrapper-apply-clear .ex-facet-wrapper-clear-button{padding-bottom:4px}.ex-facet-wrapper-apply-clear button{outline:0px}.ex-facet-wrapper-apply-button{flex:1}.ex-facet-placeholder-header{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facet-placeholder-label{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facet-wrapper-placeholder{margin:0 0 24px}.ex-facet-wrapper-clear-button{width:50px}.ex-facet-wrapper-clear-button ::ng-deep i{margin-top:5px}.ex-facets-wrapper-selected-facets-hr{height:1px;margin:0 23px;border-top:1px solid #aaa}.ex-facet-wrapper-persistent-facet{width:calc(100% - 48px);margin:0 24px;padding-top:15px;overflow-y:auto}.ex-facet-wrapper-no-facets{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facet-wrapper-no-facets .ex-facet-wrapper-no-facet-img{display:flex;justify-content:center}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { facetItems: [{
            type: Input
        }], panelsExpended: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], selectedFacets: [{
            type: Input
        }], facetChanged: [{
            type: Output
        }], selectedFacetRemoved: [{
            type: Output
        }], selectedFacetsCleared: [{
            type: Output
        }], overFlowDivRef: [{
            type: ViewChild,
            args: ['OverFlowRef', { static: true }]
        }], noFacetsText: [{
            type: Input
        }], selectedFacetsHeader: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], blockFacets: [{
            type: Input
        }], showMoreText: [{
            type: Input
        }], showLessText: [{
            type: Input
        }], maxItemsPerFacet: [{
            type: Input
        }], valueToLabelMap: [{
            type: Input
        }], facetPrefixTranslate: [{
            type: Input
        }], fixedFacetItemGetterCallback: [{
            type: Input
        }], fixedFacetSaveSelectedCallback: [{
            type: Input
        }], fixedFacetLoadSelectedCallback: [{
            type: Input
        }], fixedFacetSaveHistoryCallback: [{
            type: Input
        }], fixedFacetLoadHistoryCallback: [{
            type: Input
        }], fixedFacetButtonHeaderLabel: [{
            type: Input
        }], fixedFacetTitle: [{
            type: Input
        }], fixedFacetTypeName: [{
            type: Input
        }], showFixedFacet: [{
            type: Input
        }], toggleChanged: [{
            type: Output
        }], statusRef: [{
            type: ViewChild,
            args: ['status']
        }] }); })();

const _c0$y = ["status"];
function ExFacetCheckboxesComponent_ng_container_0_div_2_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const checkbox_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(checkbox_r3.icon == null ? null : checkbox_r3.icon.class);
} }
function ExFacetCheckboxesComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "ex-checkbox", 8);
    i0.ɵɵlistener("checkboxChange", function ExFacetCheckboxesComponent_ng_container_0_div_2_Template_ex_checkbox_checkboxChange_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const checkbox_r3 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onClick(checkbox_r3)); })("keyup.enter", function ExFacetCheckboxesComponent_ng_container_0_div_2_Template_ex_checkbox_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const checkbox_r3 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onClick(checkbox_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 9);
    i0.ɵɵlistener("click", function ExFacetCheckboxesComponent_ng_container_0_div_2_Template_button_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const checkbox_r3 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.facetClicked(checkbox_r3)); });
    i0.ɵɵtemplate(3, ExFacetCheckboxesComponent_ng_container_0_div_2_i_3_Template, 1, 2, "i", 10);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const checkbox_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("sel-facet-checkbox-", ctx_r1.checkboxSelValuesMap[i_r4], "");
    i0.ɵɵproperty("checked", ctx_r1.isChecked(checkbox_r3))("ngClass", ctx_r1.isChecked(checkbox_r3) ? "sel-facet-checkbox-checked-" + ctx_r1.checkboxSelValuesMap[i_r4] + "" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-facet-checkboxes-list-button sel-facet-button-", ctx_r1.checkboxSelValuesMap[i_r4], "");
    i0.ɵɵproperty("exTooltip", checkbox_r3.label ? checkbox_r3.label : checkbox_r3.value);
    i0.ɵɵattribute("aria-pressed", ctx_r1.isChecked(checkbox_r3));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!checkbox_r3.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate2("ex-facet-checkboxes-ellipsis sel-facet-value-", ctx_r1.checkboxSelValuesMap[i_r4], " sel-facet-value-", ctx_r1.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", checkbox_r3.label ? checkbox_r3.label : checkbox_r3.value, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-facet-checkboxes-side-margin sel-facet-count-", ctx_r1.checkboxSelValuesMap[i_r4], "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", checkbox_r3.count, ")");
} }
const _c1$n = function (a0) { return { display: a0 }; };
function ExFacetCheckboxesComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, ExFacetCheckboxesComponent_ng_container_0_div_2_Template, 8, 20, "div", 1);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelement(4, "i", 2, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 4);
    i0.ɵɵlistener("click", function ExFacetCheckboxesComponent_ng_container_0_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onShowMore()); });
    i0.ɵɵelement(7, "i", 5);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 4);
    i0.ɵɵlistener("click", function ExFacetCheckboxesComponent_ng_container_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onShowLess()); });
    i0.ɵɵelement(10, "i", 6);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 13, ctx_r0.checkboxesLabels, 0, ctx_r0.shownItemsCount));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.statusMsg);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-facet-checkboxes-more-less-button sel-more-", ctx_r0.id, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(17, _c1$n, ctx_r0.showMore ? "inline" : "none"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.showMoreText, " (", ctx_r0.checkboxesLabels.length - ctx_r0.shownItemsCount, ")");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-facet-checkboxes-more-less-button sel-less-", ctx_r0.id, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c1$n, ctx_r0.shownItemsCount > ctx_r0.maxItems ? "inline" : "none"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.showLessText, "");
} }
class ExFacetCheckboxesComponent {
    constructor(translate) {
        this.translate = translate;
        this.showMore = false;
        this.checkboxesLabels = [];
        this.checkboxSelValuesMap = {};
        this.checkedItems = [];
        this.statusMsg = "";
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (this.arguments.checkboxes) {
            this.checkboxesLabels = this.arguments.checkboxes;
            this.shownItemsCount = this.checkboxesLabels.length;
            this.checkboxesLabels.forEach((checkbox, index) => {
                let className = checkbox.label ? checkbox.label?.replace(/\s/g, '')?.replace(/[^a-zA-Z0-9_-]/g, "") : checkbox.value?.replace(/\s/g, '')?.replace(/[^a-zA-Z0-9_-]/g, "");
                this.checkboxSelValuesMap[index] = this.id + '-' + className;
            });
        }
        if (this.arguments.maxItems) {
            this.maxItems = this.arguments.maxItems;
        }
        if (this.checkboxesLabels.length > this.arguments.maxItems) {
            this.showMore = true;
            this.shownItemsCount = this.maxItems;
        }
        if (this.arguments.showMoreText) {
            this.showMoreText = this.arguments.showMoreText;
        }
        if (this.arguments.showLessText) {
            this.showLessText = this.arguments.showLessText;
        }
        this.checkedItemsSaved = [...this.checkedItems];
    }
    /**
     * returns if the specific checkbox is currently checked
     */
    isChecked(checkbox) {
        return this.checkedItems.indexOf(checkbox.value) !== -1;
    }
    /**
     * Click event will toggle the clicked checkbox.
     * This function will update the parent about a change.
     */
    onClick(item) {
        this.setCheckedItems(item, true);
        this.statusMsg = this.translate.instant('ng.facets.status_msg.item_had_chosen', { value: item.value });
    }
    setCheckedItems(item, hasApply) {
        if (this.checkedItems.indexOf(item.value) === -1) {
            this.checkedItems.push(item.value);
        }
        else {
            this.checkedItemsSaved.splice(this.checkedItemsSaved.indexOf(item.value), 1);
            this.checkedItems.splice(this.checkedItems.indexOf(item.value), 1);
        }
        this.dataOutput.next([ExFacetsTypes.MULTI_SELECT, this.id, this.checkedItems, hasApply]);
    }
    /**
     * This function will expend the list to show all the checkboxes.
     */
    onShowMore() {
        this.shownItemsCount = this.checkboxesLabels.length;
        this.showMore = false;
    }
    /**
     * This function will shrink the list to show only the maximum given amount of lines and will turn showMore on.
     */
    onShowLess() {
        this.shownItemsCount = this.maxItems;
        this.showMore = true;
    }
    facetClicked(checkbox) {
        this.checkedItems = [...this.checkedItemsSaved];
        this.statusMsg = this.translate.instant('ng.facets.status_msg.filter_applied', { value: checkbox.value });
        this.setCheckedItems(checkbox, false);
    }
    static { this.ɵfac = function ExFacetCheckboxesComponent_Factory(t) { return new (t || ExFacetCheckboxesComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetCheckboxesComponent, selectors: [["ex-facet-checkboxes"]], viewQuery: function ExFacetCheckboxesComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$y, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.statusRef = _t.first);
        } }, inputs: { arguments: "arguments", id: "id", dataOutput: "dataOutput", checkedItems: "checkedItems" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "ex-facet-checkboxes-facet", 4, "ngFor", "ngForOf"], ["role", "status", "aria-live", "polite"], ["status", ""], [3, "ngStyle", "click"], [1, "fa", "fa-plus"], [1, "fa", "fa-minus"], [1, "ex-facet-checkboxes-facet"], [3, "checked", "ngClass", "checkboxChange", "keyup.enter"], ["matTooltipPosition", "above", 3, "exTooltip", "click"], [3, "class", 4, "ngIf"]], template: function ExFacetCheckboxesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFacetCheckboxesComponent_ng_container_0_Template, 12, 21, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.checkboxesLabels.length > 0);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgStyle, ExTooltipDirective, ExCheckboxComponent, i1$5.SlicePipe], styles: ["button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]   .ex-facet-checkboxes-side-margin[_ngcontent-%COMP%]{margin:0 5px}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]   .ex-facet-checkboxes-list-button[_ngcontent-%COMP%]{margin-left:5px;display:flex;flex:1;justify-content:flex-start;width:100%;padding:0 5px;min-width:0;border-radius:4px}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]   .ex-facet-checkboxes-list-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:5px}.ex-facet-checkboxes-facet[_ngcontent-%COMP%]   .ex-facet-checkboxes-list-button[_ngcontent-%COMP%]   .ex-facet-checkboxes-ellipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetCheckboxesComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-checkboxes', template: "<ng-container *ngIf=\"checkboxesLabels.length > 0\">\n    <div>\n        <div class=\"ex-facet-checkboxes-facet\"\n            *ngFor=\"let checkbox of checkboxesLabels | slice:0:shownItemsCount; let i = index\">\n            <ex-checkbox [checked]=\"isChecked(checkbox)\" (checkboxChange)=\"onClick(checkbox)\"\n                (keyup.enter)=\"onClick(checkbox)\" class=\"sel-facet-checkbox-{{checkboxSelValuesMap[i]}}\"\n                [ngClass]=\"isChecked(checkbox) ? 'sel-facet-checkbox-checked-' + checkboxSelValuesMap[i] + '': '' \">\n            </ex-checkbox>\n            <button [exTooltip]=\"checkbox.label ? checkbox.label : checkbox.value\" matTooltipPosition=\"above\"\n                class=\"ex-facet-checkboxes-list-button sel-facet-button-{{checkboxSelValuesMap[i]}}\"\n                (click)=\"facetClicked(checkbox)\" [attr.aria-pressed]=\"isChecked(checkbox)\">\n                <i *ngIf=\"!!checkbox.icon\" [class]=\"checkbox.icon?.class\"></i>\n                <span\n                    class=\"ex-facet-checkboxes-ellipsis sel-facet-value-{{checkboxSelValuesMap[i]}} sel-facet-value-{{id}}\">{{ checkbox.label ? checkbox.label : checkbox.value }}\n                </span>\n                <span\n                    class=\"ex-facet-checkboxes-side-margin sel-facet-count-{{checkboxSelValuesMap[i]}}\">({{ checkbox.count }})</span>\n            </button>\n        </div>\n        <i #status role=\"status\" attr.aria-label=\"{{ statusMsg }}\" aria-live=\"polite\"></i>\n    </div>\n    <button class=\"ex-facet-checkboxes-more-less-button sel-more-{{id}}\"\n        [ngStyle]=\"{display: showMore ? 'inline': 'none'}\" (click)=\"onShowMore()\"><i class=\"fa fa-plus\"></i>\n        {{ showMoreText }}\n        ({{ checkboxesLabels.length - shownItemsCount }})</button>\n    <button class=\"ex-facet-checkboxes-more-less-button sel-less-{{id}}\"\n        [ngStyle]=\"{display: shownItemsCount > maxItems ? 'inline': 'none'}\" (click)=\"onShowLess()\"><i\n            class=\"fa fa-minus\"></i> {{ showLessText }}</button>\n</ng-container>", styles: ["button{border:0px;outline:0px}.ex-facet-checkboxes-facet{display:flex;flex-direction:row;align-items:center}.ex-facet-checkboxes-facet button{border:0px;outline:0px}.ex-facet-checkboxes-facet .ex-facet-checkboxes-side-margin{margin:0 5px}.ex-facet-checkboxes-facet .ex-facet-checkboxes-list-button{margin-left:5px;display:flex;flex:1;justify-content:flex-start;width:100%;padding:0 5px;min-width:0;border-radius:4px}.ex-facet-checkboxes-facet .ex-facet-checkboxes-list-button i{margin-right:5px}.ex-facet-checkboxes-facet .ex-facet-checkboxes-list-button .ex-facet-checkboxes-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { arguments: [{
            type: Input
        }], id: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }], checkedItems: [{
            type: Input
        }], statusRef: [{
            type: ViewChild,
            args: ["status"]
        }] }); })();

function ExFacetRangeComponent_ng_container_4_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r2, " ");
} }
function ExFacetRangeComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "select", 3);
    i0.ɵɵlistener("ngModelChange", function ExFacetRangeComponent_ng_container_4_Template_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectedOption = $event); })("change", function ExFacetRangeComponent_ng_container_4_Template_select_change_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onChange()); });
    i0.ɵɵtemplate(2, ExFacetRangeComponent_ng_container_4_option_2_Template, 2, 2, "option", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.selectedOption);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
} }
let ExFacetRangeComponent$1 = class ExFacetRangeComponent {
    /**
     * @ignore
     */
    ngOnInit() {
        if (this.arguments.lowMin) {
            this.lowMin = this.arguments.lowMin;
        }
        if (this.arguments.lowMax) {
            this.lowMax = this.arguments.lowMax;
        }
        if (this.arguments.highMin) {
            this.highMin = this.arguments.highMin;
        }
        if (this.arguments.highMax) {
            this.highMax = this.arguments.highMax;
        }
        // Loads the options and sets the selected to the first in the list
        if (this.arguments.options) {
            this.options = this.arguments.options;
            this.selectedOption = this.options[0];
        }
    }
    /**
     * When one of the input changes, this function will check the validity of the fields and sends the selection to the parent
     */
    onChange() {
        if (this.lowValue && this.highValue) {
            if (this.lowValue > this.highValue) {
                this.highValue = this.lowValue;
            }
        }
        if (this.highValue && this.selectedOption) {
            this.dataOutput.next([ExFacetsTypes.RANGE, this.id, this.lowValue, this.highValue, this.selectedOption]);
        }
    }
    static { this.ɵfac = function ExFacetRangeComponent_Factory(t) { return new (t || ExFacetRangeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetRangeComponent, selectors: [["ex-facet-range"]], inputs: { arguments: "arguments", id: "id", dataOutput: "dataOutput" }, decls: 5, vars: 7, consts: [["placeholder", "Min", "type", "number", 1, "ex-facet-range-left-input", 3, "ngModel", "min", "max", "ngModelChange", "change"], ["placeholder", "Max", "type", "number", 1, "ex-facet-range-right-input", 3, "ngModel", "min", "max", "ngModelChange", "change"], [4, "ngIf"], [1, "ex-facet-range-select", 3, "ngModel", "ngModelChange", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function ExFacetRangeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "input", 0);
            i0.ɵɵlistener("ngModelChange", function ExFacetRangeComponent_Template_input_ngModelChange_0_listener($event) { return ctx.lowValue = $event; })("change", function ExFacetRangeComponent_Template_input_change_0_listener() { return ctx.onChange(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "label");
            i0.ɵɵtext(2, "-");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "input", 1);
            i0.ɵɵlistener("ngModelChange", function ExFacetRangeComponent_Template_input_ngModelChange_3_listener($event) { return ctx.highValue = $event; })("change", function ExFacetRangeComponent_Template_input_change_3_listener() { return ctx.onChange(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExFacetRangeComponent_ng_container_4_Template, 3, 2, "ng-container", 2);
        } if (rf & 2) {
            i0.ɵɵproperty("ngModel", ctx.lowValue)("min", ctx.lowMin)("max", ctx.lowMax);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.highValue)("min", ctx.lowValue > ctx.highMin ? ctx.lowValue : ctx.highMin)("max", ctx.highMax);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.options && ctx.options.length > 0);
        } }, dependencies: [i1$6.NgSelectOption, i1$6.ɵNgSelectMultipleOption, i1$6.DefaultValueAccessor, i1$6.NumberValueAccessor, i1$6.SelectControlValueAccessor, i1$6.NgControlStatus, i1$6.MinValidator, i1$6.MaxValidator, i1$6.NgModel, i1$5.NgForOf, i1$5.NgIf, MinValidator], styles: [".ex-facet-range-left-input[_ngcontent-%COMP%]{width:30%;margin-right:5px;padding-left:5px}.ex-facet-range-right-input[_ngcontent-%COMP%]{width:30%;margin:0 5px;padding-left:5px}.ex-facet-range-select[_ngcontent-%COMP%]{width:30%;outline:none;border:0}"] }); }
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetRangeComponent$1, [{
        type: Component,
        args: [{ selector: 'ex-facet-range', template: "<input class=\"ex-facet-range-left-input\" placeholder=\"Min\" type=\"number\" [(ngModel)]=\"lowValue\" [min]=\"lowMin\" [max]=\"lowMax\"\n  (change)=\"onChange()\">\n<label>-</label>\n<input class=\"ex-facet-range-right-input\" placeholder=\"Max\" type=\"number\" [(ngModel)]=\"highValue\"\n  [min]=\"lowValue > highMin ? lowValue : highMin\" [max]=\"highMax\" (change)=\"onChange()\">\n<ng-container *ngIf=\" options && options.length > 0\">\n  <select class=\"ex-facet-range-select\" [(ngModel)]=\"selectedOption\" (change)=\"onChange()\">\n    <option *ngFor=\"let option of options\" [value]=\"option\">\n      {{option}}\n    </option>\n  </select>\n</ng-container>", styles: [".ex-facet-range-left-input{width:30%;margin-right:5px;padding-left:5px}.ex-facet-range-right-input{width:30%;margin:0 5px;padding-left:5px}.ex-facet-range-select{width:30%;outline:none;border:0}\n"] }]
    }], null, { arguments: [{
            type: Input
        }], id: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }] }); })();

const Animations$1 = [];

function ExFacetLinkComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 6);
    i0.ɵɵlistener("click", function ExFacetLinkComponent_ng_container_0_div_2_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const link_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onClick(link_r2)); });
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const link_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", link_r2.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", "sel-value-" + ctx_r1.title);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(link_r2.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", link_r2.count, ")");
} }
const _c0$x = function (a0) { return { display: a0 }; };
function ExFacetLinkComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, ExFacetLinkComponent_ng_container_0_div_2_Template, 6, 4, "div", 1);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 2);
    i0.ɵɵlistener("click", function ExFacetLinkComponent_ng_container_0_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onShowMore()); });
    i0.ɵɵelement(5, "i", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 4);
    i0.ɵɵlistener("click", function ExFacetLinkComponent_ng_container_0_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onShowLess()); });
    i0.ɵɵelement(8, "i", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 8, ctx_r0.links, 0, ctx_r0.shownItemsCount));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "sel-more-" + ctx_r0.title)("ngStyle", i0.ɵɵpureFunction1(12, _c0$x, ctx_r0.showMore ? "inline" : "none"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.showMoreText, " (", ctx_r0.links.length - ctx_r0.shownItemsCount, ")");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", "sel-less-" + ctx_r0.title)("ngStyle", i0.ɵɵpureFunction1(14, _c0$x, ctx_r0.shownItemsCount > ctx_r0.maxItems ? "inline" : "none"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.showLessText, "");
} }
class ExFacetLinkComponent {
    constructor() {
        this.showMore = false;
        this.links = [];
    }
    /**
     * @ignore
     */
    ngOnInit() {
        if (this.arguments.links) {
            this.links = this.arguments.links;
            this.shownItemsCount = this.links.length;
        }
        if (this.arguments.maxItems && this.links.length > this.arguments.maxItems) {
            this.maxItems = this.arguments.maxItems;
            this.showMore = true;
            this.shownItemsCount = this.maxItems;
        }
        if (this.arguments.showMoreText) {
            this.showMoreText = this.arguments.showMoreText;
        }
        if (this.arguments.showLessText) {
            this.showLessText = this.arguments.showLessText;
        }
    }
    /**
     * This function will update the parent when the user has clicked a link.
     */
    onClick(link) {
        this.dataOutput.next([ExFacetsTypes.SINGLE_SELECT, this.id, link.value]);
    }
    /**
    * This function will expend the list to show all the checkboxes.
    */
    onShowMore() {
        this.shownItemsCount = this.links.length;
        this.showMore = false;
    }
    /**
     * This function will shrink the list to show only the maximum given amount of lines and will turn showMore on.
     */
    onShowLess() {
        this.shownItemsCount = this.maxItems;
        this.showMore = true;
    }
    static { this.ɵfac = function ExFacetLinkComponent_Factory(t) { return new (t || ExFacetLinkComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetLinkComponent, selectors: [["ex-facet-link"]], inputs: { arguments: "arguments", id: "id", title: "title", dataOutput: "dataOutput" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "ex-facet-link-more-less-button", 3, "ngClass", "ngStyle", "click"], [1, "fa", "fa-plus"], [1, "ex-facet-link-more-less-button", "sel-facet-link-less", 3, "ngClass", "ngStyle", "click"], [1, "fa", "fa-minus"], ["matTooltipPosition", "above", 1, "ex-facet-link-list-button", 3, "exTooltip", "click"], [1, "ex-facet-link-ellipsis", 3, "ngClass"], [1, "ex-facet-link-side-margin", "sel-facet-count"]], template: function ExFacetLinkComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFacetLinkComponent_ng_container_0_Template, 10, 16, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.links.length > 0);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgStyle, ExTooltipDirective, i1$5.SlicePipe], styles: ["button[_ngcontent-%COMP%]{border:0px}.ex-facet-link-side-margin[_ngcontent-%COMP%]{margin:0 5px}.ex-facet-link-list-button[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-link-list-button[_ngcontent-%COMP%]   .ex-facet-link-ellipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}"], data: { animation: [Animations$1] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetLinkComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-link', animations: [Animations$1], template: "<ng-container *ngIf=\"links.length > 0\">\n    <div>\n        <div *ngFor=\"let link of links | slice:0:shownItemsCount\">\n            <button [exTooltip]=\"link.value\" matTooltipPosition=\"above\"\n                class=\"ex-facet-link-list-button\" (click)=\"onClick(link)\"><span\n                    class=\"ex-facet-link-ellipsis\" [ngClass]=\"'sel-value-' + title\">{{ link.value }}</span><span\n                    class=\"ex-facet-link-side-margin sel-facet-count\">({{ link.count }})</span></button>\n        </div>\n    </div>\n    <button class=\"ex-facet-link-more-less-button\" [ngClass]=\"'sel-more-' + title\"\n        [ngStyle]=\"{display: showMore ? 'inline': 'none'}\" (click)=\"onShowMore()\"><i class=\"fa fa-plus\"></i>\n        {{ showMoreText }} ({{ links.length - shownItemsCount }})</button>\n    <button class=\"ex-facet-link-more-less-button sel-facet-link-less\" [ngClass]=\"'sel-less-' + title\"\n        [ngStyle]=\"{display: shownItemsCount > maxItems ? 'inline': 'none'}\" (click)=\"onShowLess()\"><i\n            class=\"fa fa-minus\"></i> {{ showLessText }}</button>\n</ng-container>", styles: ["button{border:0px}.ex-facet-link-side-margin{margin:0 5px}.ex-facet-link-list-button{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-link-list-button .ex-facet-link-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}\n"] }]
    }], null, { arguments: [{
            type: Input
        }], id: [{
            type: Input
        }], title: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }] }); })();

const _c0$w = ["tooltip"];
const _c1$m = function (a0, a1, a2) { return { "ex-facet-hierarchy-no-click": a0, "ex-facet-hierarchy-activated-blue-icon": a1, "ex-facet-hierarchy-deactivated-blue-icon": a2 }; };
const _c2$f = function (a0, a1) { return { "ex-facet-hierarchy-no-click": a0, "ex-facet-hierarchy-selected-last": a1 }; };
function ExFacetHierarchyComponent_ng_container_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5, 6);
    i0.ɵɵlistener("click", function ExFacetHierarchyComponent_ng_container_0_li_2_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const index_r4 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onSelectedClicked(index_r4)); })("keydown.enter", function ExFacetHierarchyComponent_ng_container_0_li_2_Template_li_keydown_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const index_r4 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onSelectedClicked(index_r4)); });
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "div", 8)(4, "label", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10)(7, "button", 11);
    i0.ɵɵlistener("click", function ExFacetHierarchyComponent_ng_container_0_li_2_Template_button_click_7_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const index_r4 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onDeleteClicked(index_r4)); });
    i0.ɵɵelementStart(8, "i", 12);
    i0.ɵɵlistener("mouseenter", function ExFacetHierarchyComponent_ng_container_0_li_2_Template_i_mouseenter_8_listener() { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onRemoveEnter()); });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const selectedItem_r3 = ctx.$implicit;
    const index_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", selectedItem_r3[0].description);
    i0.ɵɵattribute("aria-pressed", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c1$m, index_r4 === ctx_r2.selectedItems.length - 1, index_r4 === ctx_r2.selectedItems.length - 1, index_r4 !== ctx_r2.selectedItems.length - 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c2$f, index_r4 === ctx_r2.selectedItems.length - 1, index_r4 === ctx_r2.selectedItems.length - 1))("ngClass", "sel-selected-value-" + ctx_r2.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", selectedItem_r3[0].description, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "sel-value-remove" + selectedItem_r3[0].description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(9, 8, "ng.general.remove"));
} }
function ExFacetHierarchyComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 2);
    i0.ɵɵtemplate(2, ExFacetHierarchyComponent_ng_container_0_li_2_Template, 10, 17, "li", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.selectedItems);
} }
function ExFacetHierarchyComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 13);
    i0.ɵɵlistener("click", function ExFacetHierarchyComponent_li_3_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const item_r11 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onNewItemSelected(item_r11.hierarchy)); });
    i0.ɵɵelementStart(2, "label", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 15);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", item_r11.hierarchy.description)("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-presses", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", "sel-value-" + ctx_r1.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r11.hierarchy.description, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" (", item_r11.count, ")");
} }
const _c3$c = function (a0) { return { "ex-facet-hierarchy-left-border": a0 }; };
class ExFacetHierarchyComponent {
    constructor() {
        /**
         * The selectedItems of previous levels
         * array of the following format:
         * [
         *    [{ code: code1, description: desc1 }, { code: code2, description: desc2 }],
         *    [{ code: code3, description: desc3 }, { code: code4, description: desc4 }, { code: code5, description: desc5 }]
         * ]
         */
        this.selectedItems = [];
        this.disabled = false;
    }
    ngOnInit() {
        if (this.arguments.items) {
            this.items = this.arguments.items;
        }
        if (this.arguments.selectedItems) {
            this.selectedItems = this.arguments.selectedItems;
        }
    }
    /**
     * This function adds, and emits the selected facets while keeping the selectedItems's format
     * @param newItem The new item to add
     */
    onNewItemSelected(newItem) {
        // to prevent double click on hierarchy facets
        this.disabled = true;
        const pair = { code: newItem.code, description: newItem.description };
        if (newItem.level === this.selectedItems.length + 1) {
            this.selectedItems.push([pair]);
        }
        else {
            this.selectedItems[newItem.level - 1].push(pair);
        }
        this.dataOutput.next([ExFacetsTypes.HIERARCHY, this.id, this.selectedItems]);
    }
    /**
     * This function removes the item from the selected index, and emits them
     * @param selectedItemIndex The index of the item to remove forward, not included .
     */
    onSelectedClicked(selectedItemIndex) {
        if (selectedItemIndex !== this.selectedItems.length - 1) {
            this.selectedItems.splice(selectedItemIndex + 1);
            this.dataOutput.next([ExFacetsTypes.HIERARCHY, this.id, this.selectedItems]);
        }
    }
    onDeleteClicked(selectedItemIndex) {
        this.selectedItems.splice(selectedItemIndex);
        this.dataOutput.next([ExFacetsTypes.HIERARCHY, this.id, this.selectedItems]);
    }
    onRemoveEnter() {
        this.tooltip.hide();
    }
    static { this.ɵfac = function ExFacetHierarchyComponent_Factory(t) { return new (t || ExFacetHierarchyComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetHierarchyComponent, selectors: [["ex-facet-hierarchy"]], viewQuery: function ExFacetHierarchyComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$w, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
        } }, inputs: { arguments: "arguments", id: "id", dataOutput: "dataOutput" }, decls: 4, vars: 5, consts: [[4, "ngIf"], [3, "ngClass"], [1, "ex-facet-hierarchy-ul"], [4, "ngFor", "ngForOf"], ["class", "ex-facet-hierarchy-li", "role", "button", "tabindex", "0", 3, "exTooltip", "click", "keydown.enter", 4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 1, "ex-facet-hierarchy-li", 3, "exTooltip", "click", "keydown.enter"], ["tooltip", "exTooltip"], [1, "fa", "fa-circle", "ex-facet-hierarchy-icon", 3, "ngClass"], [1, "ex-facet-hierarchy-selected-item-wrapper"], [1, "ex-facet-hierarchy-ellipsis", "ex-facet-hierarchy-selected", 3, "ngClass"], [1, "ex-facet-hierarchy-flex-grow-end"], [1, "ex-facet-hierarchy-remove-btn", 3, "ngClass", "click"], [1, "uxf-icon", "uxf-close-circle", "uxfBlueHover", 3, "exTooltip", "mouseenter"], ["matTooltipPosition", "above", 1, "ex-facet-hierarchy-list-button", 3, "exTooltip", "disabled", "click"], [1, "ex-facet-hierarchy-ellipsis", "ex-facet-hierarchy-inherit-color", 3, "ngClass"], [1, "ex-facet-hierarchy-side-margin", "ex-facet-hierarchy-inherit-color", "ex-facet-hierarchy-pointer", "sel-facet-count"]], template: function ExFacetHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExFacetHierarchyComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "ul", 2);
            i0.ɵɵtemplate(3, ExFacetHierarchyComponent_li_3_Template, 6, 6, "li", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.selectedItems.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$c, ctx.selectedItems.length > 0));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.items);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, i1$2.TranslatePipe], styles: ["button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-facet-hierarchy-selected[_ngcontent-%COMP%]{margin-bottom:0}.ex-facet-hierarchy-side-margin[_ngcontent-%COMP%]{margin:0 5px}.ex-facet-hierarchy-list-button[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-hierarchy-ellipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;display:inline-block;text-align:left;margin-bottom:0}.ex-facet-hierarchy-ul[_ngcontent-%COMP%]{list-style-type:none}.ex-facet-hierarchy-left-border[_ngcontent-%COMP%]{padding-left:16px;margin-left:5px}.ex-facet-hierarchy-icon[_ngcontent-%COMP%]{vertical-align:super;margin-right:10px}.ex-facet-hierarchy-li[_ngcontent-%COMP%]{white-space:nowrap;display:flex}.ex-facet-hierarchy-remove-btn[_ngcontent-%COMP%]{margin-left:5px;border:none;outline:none;background:none;display:flex}.ex-facet-hierarchy-icon-arrow[_ngcontent-%COMP%]{margin-left:5px;align-self:center}.ex-facet-hierarchy-selected-item-wrapper[_ngcontent-%COMP%]{display:flex;width:100%;overflow:hidden}.ex-facet-hierarchy-flex-grow-end[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex-grow:1}.ex-facet-hierarchy-deactivated-blue-icon[_ngcontent-%COMP%], .ex-facet-hierarchy-activated-blue-icon[_ngcontent-%COMP%]{align-self:center}.ex-facet-hierarchy-no-click[_ngcontent-%COMP%]{pointer-events:none}.ex-facet-hierarchy-pointer[_ngcontent-%COMP%]{cursor:pointer}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetHierarchyComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-hierarchy', template: "<ng-container *ngIf=\"selectedItems.length > 0\">\n  <ul class=\"ex-facet-hierarchy-ul\">\n    <li class=\"ex-facet-hierarchy-li\" *ngFor=\"let selectedItem of selectedItems; let index = index\"\n      [exTooltip]=\"selectedItem[0].description\" #tooltip=\"exTooltip\"\n      (click)=\"onSelectedClicked(index)\" (keydown.enter)=\"onSelectedClicked(index)\" role=\"button\" tabindex=\"0\" [attr.aria-pressed]=\"true\">\n      <i [ngClass]=\"{ 'ex-facet-hierarchy-no-click': index === (selectedItems.length - 1),\n                      'ex-facet-hierarchy-activated-blue-icon': index === (selectedItems.length - 1),\n                      'ex-facet-hierarchy-deactivated-blue-icon': index !== (selectedItems.length - 1) }\"\n        class=\"fa fa-circle ex-facet-hierarchy-icon\"></i>\n      <div class=\"ex-facet-hierarchy-selected-item-wrapper\">\n        <label class=\"ex-facet-hierarchy-ellipsis ex-facet-hierarchy-selected\"\n          [ngClass]=\"{'ex-facet-hierarchy-no-click': index === (selectedItems.length - 1),\n                      'ex-facet-hierarchy-selected-last': index === (selectedItems.length - 1) }\"\n          [ngClass]=\"'sel-selected-value-' + id\">\n          {{ selectedItem[0].description }}\n        </label>\n        <div class=\"ex-facet-hierarchy-flex-grow-end\">\n          <button class=\"ex-facet-hierarchy-remove-btn\" [ngClass]=\"'sel-value-remove' + selectedItem[0].description\" (click)=\"onDeleteClicked(index)\">\n            <i class=\"uxf-icon uxf-close-circle uxfBlueHover\" (mouseenter)=\"onRemoveEnter()\" [exTooltip]=\"'ng.general.remove' | translate\"></i>\n          </button>\n        </div>\n      </div>\n    </li>\n  </ul>\n</ng-container>\n\n<div [ngClass]=\"{'ex-facet-hierarchy-left-border': selectedItems.length > 0}\">\n  <ul class=\"ex-facet-hierarchy-ul\">\n    <li *ngFor=\"let item of items\">\n      <button [exTooltip]=\"item.hierarchy.description\" matTooltipPosition=\"above\" [disabled]=\"disabled\"\n        class=\"ex-facet-hierarchy-list-button\" (click)=\"onNewItemSelected(item.hierarchy)\" [attr.aria-presses]=\"false\">\n        <label class=\"ex-facet-hierarchy-ellipsis ex-facet-hierarchy-inherit-color\" [ngClass]=\"'sel-value-' + id\">\n          {{ item.hierarchy.description }}</label>\n        <label class=\"ex-facet-hierarchy-side-margin ex-facet-hierarchy-inherit-color ex-facet-hierarchy-pointer sel-facet-count\">\n          ({{ item.count }})</label>\n      </button>\n    </li>\n  </ul>\n</div>", styles: ["button{border:0px;outline:0px}.ex-facet-hierarchy-selected{margin-bottom:0}.ex-facet-hierarchy-side-margin{margin:0 5px}.ex-facet-hierarchy-list-button{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-hierarchy-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;display:inline-block;text-align:left;margin-bottom:0}.ex-facet-hierarchy-ul{list-style-type:none}.ex-facet-hierarchy-left-border{padding-left:16px;margin-left:5px}.ex-facet-hierarchy-icon{vertical-align:super;margin-right:10px}.ex-facet-hierarchy-li{white-space:nowrap;display:flex}.ex-facet-hierarchy-remove-btn{margin-left:5px;border:none;outline:none;background:none;display:flex}.ex-facet-hierarchy-icon-arrow{margin-left:5px;align-self:center}.ex-facet-hierarchy-selected-item-wrapper{display:flex;width:100%;overflow:hidden}.ex-facet-hierarchy-flex-grow-end{display:flex;justify-content:flex-end;flex-grow:1}.ex-facet-hierarchy-deactivated-blue-icon,.ex-facet-hierarchy-activated-blue-icon{align-self:center}.ex-facet-hierarchy-no-click{pointer-events:none}.ex-facet-hierarchy-pointer{cursor:pointer}\n"] }]
    }], null, { arguments: [{
            type: Input
        }], id: [{
            type: Input
        }], dataOutput: [{
            type: Input
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }] }); })();

const _c0$v = function (a0) { return { "ex-facet-condition-wrapper-disabled": a0 }; };
class ExFacetConditionWrapperComponent {
    constructor() {
        this.disabled = false;
        this.conditionChanged = new EventEmitter();
    }
    onConditionChanged(value) {
        //timeout is for the animation of the toggle to be shown before the page will refresh
        setTimeout(() => {
            this.conditionChanged.emit(value);
        }, 500);
    }
    static { this.ɵfac = function ExFacetConditionWrapperComponent_Factory(t) { return new (t || ExFacetConditionWrapperComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetConditionWrapperComponent, selectors: [["ex-facet-condition-wrapper"]], inputs: { condition: "condition", conditionChecked: "conditionChecked", disabled: "disabled" }, outputs: { conditionChanged: "conditionChanged" }, decls: 2, vars: 5, consts: [[1, "ex-facet-condition-wrapper", 3, "ngClass"], [1, "ex-facet-condition-wrapper-slider", 3, "label", "toggleChecked", "toggleCheckedChange"]], template: function ExFacetConditionWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-slide-toggle", 1);
            i0.ɵɵlistener("toggleCheckedChange", function ExFacetConditionWrapperComponent_Template_ex_slide_toggle_toggleCheckedChange_1_listener($event) { return ctx.onConditionChanged($event); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$v, ctx.disabled));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", ctx.condition)("toggleChecked", ctx.conditionChecked);
        } }, dependencies: [i1$5.NgClass, ExSlideToggleComponent], styles: [".ex-facet-condition-wrapper[_ngcontent-%COMP%]{padding:10px 0;margin-left:24px;margin-right:8px;border-bottom-width:1px;border-bottom-style:solid;margin-bottom:5px}.ex-facet-condition-wrapper[_ngcontent-%COMP%]   .ex-facet-condition-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-condition-wrapper[_ngcontent-%COMP%]   .ex-facet-condition-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-condition-wrapper[_ngcontent-%COMP%]   .ex-facet-condition-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-condition-wrapper-hr[_ngcontent-%COMP%]{height:1px;margin:0 8px 0 0}.ex-facet-condition-wrapper-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetConditionWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-condition-wrapper', template: "<div class=\"ex-facet-condition-wrapper\" [ngClass]=\"{'ex-facet-condition-wrapper-disabled' : disabled}\">\n  <ex-slide-toggle [label]=\"condition\" (toggleCheckedChange)=\"onConditionChanged($event)\" [toggleChecked]=\"conditionChecked\"\n                   class=\"ex-facet-condition-wrapper-slider\"></ex-slide-toggle>\n</div>\n", styles: [".ex-facet-condition-wrapper{padding:10px 0;margin-left:24px;margin-right:8px;border-bottom-width:1px;border-bottom-style:solid;margin-bottom:5px}.ex-facet-condition-wrapper .ex-facet-condition-wrapper-slider ::ng-deep .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-condition-wrapper .ex-facet-condition-wrapper-slider ::ng-deep .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-condition-wrapper .ex-facet-condition-wrapper-slider ::ng-deep .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-condition-wrapper-hr{height:1px;margin:0 8px 0 0}.ex-facet-condition-wrapper-disabled{pointer-events:none;opacity:.5}\n"] }]
    }], function () { return []; }, { condition: [{
            type: Input
        }], conditionChecked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], conditionChanged: [{
            type: Output
        }] }); })();

class ExFacetsModule {
    static { this.ɵfac = function ExFacetsModule_Factory(t) { return new (t || ExFacetsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExFacetsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            CommonModule,
            ExComponentLoaderModule,
            MatExpansionModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExButtonModule,
            MatRippleModule,
            ExIconModule,
            MatSlideToggleModule,
            TranslateModule,
            ExCheckboxModule,
            ExSearchModule,
            ExSlideToggleModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    ExComponentLoaderModule,
                    MatExpansionModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExButtonModule,
                    MatRippleModule,
                    ExIconModule,
                    MatSlideToggleModule,
                    TranslateModule,
                    ExCheckboxModule,
                    ExSearchModule,
                    ExSlideToggleModule
                ],
                declarations: [
                    ExFacetWrapperComponent,
                    ExFacetCheckboxesComponent,
                    ExFacetRangeComponent$1,
                    ExFacetLinkComponent,
                    ExSelectedFacetComponent,
                    ExSelectedFacetsWrapperComponent,
                    ExFacetHierarchyComponent,
                    ExFacetConditionWrapperComponent,
                    ExFacetToggleComponent,
                    ExFacetEmptyComponent,
                    ExFacetSetTopComponent
                ],
                exports: [
                    ExFacetWrapperComponent,
                    ExFacetCheckboxesComponent,
                    ExFacetRangeComponent$1,
                    ExFacetLinkComponent,
                    ExSelectedFacetComponent,
                    ExSelectedFacetsWrapperComponent,
                    ExFacetHierarchyComponent,
                    ExFacetToggleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExFacetsModule, { declarations: [ExFacetWrapperComponent,
        ExFacetCheckboxesComponent,
        ExFacetRangeComponent$1,
        ExFacetLinkComponent,
        ExSelectedFacetComponent,
        ExSelectedFacetsWrapperComponent,
        ExFacetHierarchyComponent,
        ExFacetConditionWrapperComponent,
        ExFacetToggleComponent,
        ExFacetEmptyComponent,
        ExFacetSetTopComponent], imports: [FormsModule,
        CommonModule,
        ExComponentLoaderModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExButtonModule,
        MatRippleModule,
        ExIconModule,
        MatSlideToggleModule,
        TranslateModule,
        ExCheckboxModule,
        ExSearchModule,
        ExSlideToggleModule], exports: [ExFacetWrapperComponent,
        ExFacetCheckboxesComponent,
        ExFacetRangeComponent$1,
        ExFacetLinkComponent,
        ExSelectedFacetComponent,
        ExSelectedFacetsWrapperComponent,
        ExFacetHierarchyComponent,
        ExFacetToggleComponent] }); })();

const _c0$u = ["cancelButton"];
const _c1$l = ["closeButton"];
function ExInformativeProgressBar_div_0_div_3_ex_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 20);
    i0.ɵɵlistener("click", function ExInformativeProgressBar_div_0_div_3_ex_button_10_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r9.onMinimizedClick(true)); });
    i0.ɵɵelement(1, "ex-svg-icon", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltip", "ng.general.collapse");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "Collapse-Icon")("color", "#FFFFFF");
} }
function ExInformativeProgressBar_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 16);
    i0.ɵɵtext(5, ".");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 17);
    i0.ɵɵtext(7, ".");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 18);
    i0.ɵɵtext(9, ".");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ExInformativeProgressBar_div_0_div_3_ex_button_10_Template, 2, 3, "ex-button", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r3.displayTitle));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r3.hasMinimizedMode);
} }
function ExInformativeProgressBar_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r4.desc));
} }
function ExInformativeProgressBar_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ex-icon", 23);
    i0.ɵɵelementStart(2, "span", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, ctx_r5.errorLabel));
} }
function ExInformativeProgressBar_div_0_ex_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 25, 26);
    i0.ɵɵlistener("click", function ExInformativeProgressBar_div_0_ex_button_11_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onCancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "ng.general.cancel"), "");
} }
function ExInformativeProgressBar_div_0_ex_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 27, 28);
    i0.ɵɵlistener("click", function ExInformativeProgressBar_div_0_ex_button_12_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.onCancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "ng.general.close"), "");
} }
function ExInformativeProgressBar_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2, 3)(2, "div", 4);
    i0.ɵɵtemplate(3, ExInformativeProgressBar_div_0_div_3_Template, 11, 4, "div", 5);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtemplate(5, ExInformativeProgressBar_div_0_span_5_Template, 3, 3, "span", 7);
    i0.ɵɵtemplate(6, ExInformativeProgressBar_div_0_div_6_Template, 5, 3, "div", 8);
    i0.ɵɵelementStart(7, "span", 9);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵelement(10, "mat-progress-bar", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ExInformativeProgressBar_div_0_ex_button_11_Template, 4, 3, "ex-button", 12);
    i0.ɵɵtemplate(12, ExInformativeProgressBar_div_0_ex_button_12_Template, 4, 3, "ex-button", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ex-informative-progress-bar-wrapper-has-minimized", ctx_r0.hasMinimizedMode);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0._errorMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.desc && !ctx_r0._errorMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._errorMode && ctx_r0.errorLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.value, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0._errorMode ? "ex-progress-error-color" : "ex-progress-processing-color")("value", ctx_r0.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.cancelButton && !ctx_r0._errorMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._errorMode);
} }
function ExInformativeProgressBar_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "ex-button", 20);
    i0.ɵɵlistener("click", function ExInformativeProgressBar_div_1_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onMinimizedClick(false)); });
    i0.ɵɵelement(2, "ex-svg-icon", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tooltip", "ng.general.expand");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", "Expend-Icon")("color", "#FFFFFF");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.value, "%");
} }
class ExInformativeProgressBar {
    constructor() {
        /**
         * Display cancel button
         */
        this.cancelButton = true;
        this.hasMinimizedMode = false;
        this.hide = false;
        this.doneEvent = new EventEmitter();
        this.cancelEvent = new EventEmitter();
        this.value = 0;
        this._errorMode = false;
    }
    ngOnInit() {
        this.valueSubject.subscribe(newValue => {
            if (newValue < -1) {
                return;
            }
            else if (newValue === -1) {
                this._errorMode = true;
                return;
            }
            else {
                if (newValue === 100) {
                    this.doneEvent.emit();
                }
                this.value = newValue;
            }
        });
        if (this.descSubject) {
            this.descSubject.subscribe(newDesc => {
                if (newDesc) {
                    this.desc = newDesc;
                }
            });
        }
    }
    ngAfterViewInit() {
        if (this.cancelButton != null) {
            this.cancelButtonRef.focus();
        }
        else if (this.closeButtonRef != null) {
            this.closeButtonRef.focus();
        }
    }
    onCancel() {
        this.cancelEvent.emit();
    }
    onMinimizedClick(hide) {
        this.hide = hide;
    }
    static { this.ɵfac = function ExInformativeProgressBar_Factory(t) { return new (t || ExInformativeProgressBar)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExInformativeProgressBar, selectors: [["ex-informative-progress-bar"]], viewQuery: function ExInformativeProgressBar_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$u, 5);
            i0.ɵɵviewQuery(_c1$l, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cancelButtonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeButtonRef = _t.first);
        } }, inputs: { valueSubject: "valueSubject", descSubject: "descSubject", desc: "desc", displayTitle: "displayTitle", cancelButton: "cancelButton", errorLabel: "errorLabel", hasMinimizedMode: "hasMinimizedMode" }, outputs: { doneEvent: "doneEvent", cancelEvent: "cancelEvent" }, decls: 2, vars: 2, consts: [["class", "ex-informative-progress-bar-wrapper sel-ex-informative-progress-bar", "role", "dialog", "aria-modal", "true", "tabindex", "0", 3, "ex-informative-progress-bar-wrapper-has-minimized", 4, "ngIf"], ["class", "ex-informative-progress-bar-minimized-wrapper", 4, "ngIf"], ["role", "dialog", "aria-modal", "true", "tabindex", "0", 1, "ex-informative-progress-bar-wrapper", "sel-ex-informative-progress-bar"], ["exProgressMainDiv", ""], [1, "ex-progress-flex-center", "ex-progress-title", "sel-ex-informative-progress-bar-title"], ["class", "ex-progress-title-wrapper", 4, "ngIf"], [1, "ex-progress-flex-right"], ["class", "sel-ex-informative-progress-bar-desc", 4, "ngIf"], [4, "ngIf"], [1, "ex-informative-progress-bar-font-size"], [1, "ex-progress-flex-center", "ex-informative-progress-bar-div"], ["mode", "determinate", 1, "ex-informative-progress-bar", 3, "ngClass", "value"], ["class", "ex-informative-progress-bar-cancel-button sel-ex-informative-progress-bar-cancel", "type", "action", "tabindex", "-1", 3, "click", 4, "ngIf"], ["class", "ex-informative-progress-bar-cancel-button sel-ex-informative-progress-bar-close", "type", "action", "tabindex", "-1", 3, "click", 4, "ngIf"], [1, "ex-progress-title-wrapper"], [1, "ex-informative-progress-bar-font-size", "ex-progress-title-position"], [1, "dotOne"], [1, "dotTwo"], [1, "dotThree"], ["class", "ex-informative-progress-bar-minimized-button", "tabindex", "-1", 3, "tooltip", "click", 4, "ngIf"], ["tabindex", "-1", 1, "ex-informative-progress-bar-minimized-button", 3, "tooltip", "click"], [3, "iconName", "color"], [1, "sel-ex-informative-progress-bar-desc"], ["iconType", "matIcon", "iconName", "error", "color", "#FF6161", "sizePx", "20px", 1, "ex-informative-progress-bar-error-icon"], [1, "ex-informative-progress-bar-error-label", "ex-informative-progress-bar-font-size"], ["type", "action", "tabindex", "-1", 1, "ex-informative-progress-bar-cancel-button", "sel-ex-informative-progress-bar-cancel", 3, "click"], ["cancelButton", ""], ["type", "action", "tabindex", "-1", 1, "ex-informative-progress-bar-cancel-button", "sel-ex-informative-progress-bar-close", 3, "click"], ["closeButton", ""], [1, "ex-informative-progress-bar-minimized-wrapper"]], template: function ExInformativeProgressBar_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExInformativeProgressBar_div_0_Template, 13, 10, "div", 0);
            i0.ɵɵtemplate(1, ExInformativeProgressBar_div_1_Template, 5, 4, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.hide);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hide);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i2$8.MatProgressBar, ExButtonComponent, ExIconComponent, ExSvgIconComponent, i1$2.TranslatePipe], styles: [".ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]{width:530px;color:#bfbfbf;display:flex;flex-direction:column;justify-content:center}.ex-informative-progress-bar-wrapper.ex-informative-progress-bar-wrapper-has-minimized[_ngcontent-%COMP%]{opacity:.7;border-radius:5px;padding:20px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]:not(.ex-informative-progress-bar-wrapper-has-minimized){height:300px;background-color:transparent}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-flex-center[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-flex-center[_ngcontent-%COMP%]   .ex-informative-progress-bar-error-icon[_ngcontent-%COMP%]{position:absolute;margin-top:2px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-flex-center[_ngcontent-%COMP%]   .ex-informative-progress-bar-error-label[_ngcontent-%COMP%]{margin-left:30px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-flex-right[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar-font-size[_ngcontent-%COMP%]{font-size:1.3em;color:#fff}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-title-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-title-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar-minimized-button[_ngcontent-%COMP%]{align-self:self-start}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-title-position[_ngcontent-%COMP%]{margin-left:0}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar[_ngcontent-%COMP%]{width:100%}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar-cancel-button[_ngcontent-%COMP%]{justify-content:center;margin-top:10px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-title[_ngcontent-%COMP%]{flex-direction:column}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar-div[_ngcontent-%COMP%]{margin-top:10px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-message[_ngcontent-%COMP%]{margin-bottom:20px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-processing-color[_ngcontent-%COMP%]     .mat-progress-bar-fill:after{background-color:#77e67b;background-image:linear-gradient(-45deg,#fff3 25%,#0000 25% 50%,#fff3 50% 75%,#0000 75%,#0000);animation:move 2s linear infinite;border-radius:20px 10px 10px 20px;border:1.3px solid rgb(255,255,255)!important;background-size:200px 200px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .ex-progress-error-color[_ngcontent-%COMP%]     .mat-progress-bar-fill:after{background-color:#ff6161;background-image:linear-gradient(-45deg,#fff3 25%,#0000 25% 50%,#fff3 50% 75%,#0000 75%,#0000);animation:move 2s linear infinite;border-radius:20px 10px 10px 20px;border:1.3px solid rgb(255,255,255)!important;background-size:2000px 2000px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]     .mat-progress-bar-buffer{background:#fff}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]     .mat-mdc-progress-bar{border-radius:4px;height:10px}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]     button{color:#fff!important;background:none!important;border:none;cursor:pointer;text-decoration:underline}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]     ex-button .ex-button-action:hover{color:#fff!important;background:none!important;border:none;cursor:pointer;text-decoration:underline}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotOne[_ngcontent-%COMP%], .ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotTwo[_ngcontent-%COMP%], .ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotThree[_ngcontent-%COMP%]{font-size:2rem}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotOne[_ngcontent-%COMP%], .ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   #progress[_ngcontent-%COMP%]   .dotTwo[_ngcontent-%COMP%]{-webkit-animation:_ngcontent-%COMP%_dot 1.3s infinite;opacity:0}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotOne[_ngcontent-%COMP%]{-webkit-animation-delay:0ms;animation:_ngcontent-%COMP%_dot 1.3s infinite;animation-delay:0ms;-moz-animation:dot 1.3s infinite;-moz-animation-delay:0ms}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotTwo[_ngcontent-%COMP%]{-webkit-animation-delay:.2s;animation:_ngcontent-%COMP%_dot 1.3s infinite;animation-delay:.2s;-moz-animation:dot 1.3s infinite;-moz-animation-delay:.2s}.ex-informative-progress-bar-wrapper[_ngcontent-%COMP%]   .dotThree[_ngcontent-%COMP%]{opacity:0;-webkit-animation:_ngcontent-%COMP%_dot 1.3s infinite;-webkit-animation-delay:.3s;animation:_ngcontent-%COMP%_dot 1.3s infinite;animation-delay:.3s;-moz-animation:dot 1.3s infinite;-moz-animation-delay:.3s}@keyframes _ngcontent-%COMP%_dot{0%,50%{opacity:0}to{opacity:1}}.ex-informative-progress-bar-minimized-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;padding-inline:6px;column-gap:12px;opacity:.7;border-radius:5px;padding-top:2px;padding-bottom:2px}.ex-informative-progress-bar-minimized-wrapper[_ngcontent-%COMP%]   .ex-informative-progress-bar-font-size[_ngcontent-%COMP%]{font-size:1.3em;color:#fff}.ex-informative-progress-bar-minimized-button[_ngcontent-%COMP%]{cursor:pointer}.ex-informative-progress-bar-minimized-button[_ngcontent-%COMP%]     .ex-button-secondary{background:transparent!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInformativeProgressBar, [{
        type: Component,
        args: [{ selector: 'ex-informative-progress-bar', template: "<div #exProgressMainDiv class=\"ex-informative-progress-bar-wrapper sel-ex-informative-progress-bar\" [class.ex-informative-progress-bar-wrapper-has-minimized] = \"hasMinimizedMode\" role=\"dialog\" aria-modal=\"true\" tabindex=\"0\" *ngIf=\"!hide\">\n    <div class=\"ex-progress-flex-center ex-progress-title sel-ex-informative-progress-bar-title\">\n        <div *ngIf=\"!_errorMode\" class=\"ex-progress-title-wrapper\">\n          <span class=\"ex-informative-progress-bar-font-size ex-progress-title-position\">{{displayTitle | translate}}<span class=\"dotOne\">.</span><span class=\"dotTwo\">.</span><span\n                    class=\"dotThree\">.</span></span>\n          <ex-button *ngIf=\"hasMinimizedMode\" [tooltip]=\"'ng.general.collapse'\" class=\"ex-informative-progress-bar-minimized-button\" (click)=\"onMinimizedClick(true)\" tabindex=\"-1\">\n          <ex-svg-icon [iconName]=\"'Collapse-Icon'\"\n                       [color]=\"'#FFFFFF'\"></ex-svg-icon></ex-button>\n        </div>\n        <div class=\"ex-progress-flex-right\">\n            <span class=\"sel-ex-informative-progress-bar-desc\" *ngIf=\"desc && !_errorMode\">{{desc | translate}}</span>\n            <div *ngIf=\"_errorMode && errorLabel\">\n                <ex-icon class=\"ex-informative-progress-bar-error-icon\" iconType=\"matIcon\" iconName=\"error\" color=\"#FF6161\"\n                    sizePx=\"20px\"></ex-icon>\n                <span class=\"ex-informative-progress-bar-error-label ex-informative-progress-bar-font-size\">{{errorLabel | translate}}</span>\n            </div>\n            <span class=\"ex-informative-progress-bar-font-size\">{{value}}%</span>\n        </div>\n      </div>\n    <div class=\"ex-progress-flex-center ex-informative-progress-bar-div\">\n        <mat-progress-bar [ngClass]=\"_errorMode ? 'ex-progress-error-color' : 'ex-progress-processing-color'\" class=\"ex-informative-progress-bar\" mode=\"determinate\" [value]=\"value\"></mat-progress-bar>\n    </div>\n    <ex-button #cancelButton *ngIf=\"cancelButton && !_errorMode\" class=\"ex-informative-progress-bar-cancel-button sel-ex-informative-progress-bar-cancel\"\n        type=\"action\" (click)=\"onCancel()\" tabindex=\"-1\">\n        {{'ng.general.cancel' | translate}}</ex-button>\n    <ex-button #closeButton *ngIf=\"_errorMode\" class=\"ex-informative-progress-bar-cancel-button sel-ex-informative-progress-bar-close\" type=\"action\"\n        (click)=\"onCancel()\" tabindex=\"-1\">\n        {{'ng.general.close' | translate}}</ex-button>\n</div>\n\n<div class = \"ex-informative-progress-bar-minimized-wrapper\" *ngIf=\"hide\">\n  <ex-button class=\"ex-informative-progress-bar-minimized-button\" [tooltip]=\"'ng.general.expand'\" (click)=\"onMinimizedClick(false)\" tabindex=\"-1\">\n  <ex-svg-icon [iconName]=\"'Expend-Icon'\"\n            [color]=\"'#FFFFFF'\" ></ex-svg-icon></ex-button>\n  <span class=\"ex-informative-progress-bar-font-size\">{{value}}%</span>\n</div>\n", styles: [".ex-informative-progress-bar-wrapper{width:530px;color:#bfbfbf;display:flex;flex-direction:column;justify-content:center}.ex-informative-progress-bar-wrapper.ex-informative-progress-bar-wrapper-has-minimized{opacity:.7;border-radius:5px;padding:20px}.ex-informative-progress-bar-wrapper:not(.ex-informative-progress-bar-wrapper-has-minimized){height:300px;background-color:transparent}.ex-informative-progress-bar-wrapper .ex-progress-flex-center{display:flex;justify-content:center}.ex-informative-progress-bar-wrapper .ex-progress-flex-center .ex-informative-progress-bar-error-icon{position:absolute;margin-top:2px}.ex-informative-progress-bar-wrapper .ex-progress-flex-center .ex-informative-progress-bar-error-label{margin-left:30px}.ex-informative-progress-bar-wrapper .ex-progress-flex-right{display:flex;justify-content:space-between}.ex-informative-progress-bar-wrapper .ex-informative-progress-bar-font-size{font-size:1.3em;color:#fff}.ex-informative-progress-bar-wrapper .ex-progress-title-wrapper{display:flex;justify-content:space-between;align-items:center}.ex-informative-progress-bar-wrapper .ex-progress-title-wrapper .ex-informative-progress-bar-minimized-button{align-self:self-start}.ex-informative-progress-bar-wrapper .ex-progress-title-position{margin-left:0}.ex-informative-progress-bar-wrapper .ex-informative-progress-bar{width:100%}.ex-informative-progress-bar-wrapper .ex-informative-progress-bar-cancel-button{justify-content:center;margin-top:10px}.ex-informative-progress-bar-wrapper .ex-progress-title{flex-direction:column}.ex-informative-progress-bar-wrapper .ex-informative-progress-bar-div{margin-top:10px}.ex-informative-progress-bar-wrapper .ex-progress-message{margin-bottom:20px}.ex-informative-progress-bar-wrapper .ex-progress-processing-color ::ng-deep .mat-progress-bar-fill:after{background-color:#77e67b;background-image:linear-gradient(-45deg,#fff3 25%,#0000 25% 50%,#fff3 50% 75%,#0000 75%,#0000);animation:move 2s linear infinite;border-radius:20px 10px 10px 20px;border:1.3px solid rgb(255,255,255)!important;background-size:200px 200px}.ex-informative-progress-bar-wrapper .ex-progress-error-color ::ng-deep .mat-progress-bar-fill:after{background-color:#ff6161;background-image:linear-gradient(-45deg,#fff3 25%,#0000 25% 50%,#fff3 50% 75%,#0000 75%,#0000);animation:move 2s linear infinite;border-radius:20px 10px 10px 20px;border:1.3px solid rgb(255,255,255)!important;background-size:2000px 2000px}.ex-informative-progress-bar-wrapper ::ng-deep .mat-progress-bar-buffer{background:#fff}.ex-informative-progress-bar-wrapper ::ng-deep .mat-mdc-progress-bar{border-radius:4px;height:10px}.ex-informative-progress-bar-wrapper ::ng-deep button{color:#fff!important;background:none!important;border:none;cursor:pointer;text-decoration:underline}.ex-informative-progress-bar-wrapper ::ng-deep ex-button .ex-button-action:hover{color:#fff!important;background:none!important;border:none;cursor:pointer;text-decoration:underline}.ex-informative-progress-bar-wrapper .dotOne,.ex-informative-progress-bar-wrapper .dotTwo,.ex-informative-progress-bar-wrapper .dotThree{font-size:2rem}.ex-informative-progress-bar-wrapper .dotOne,.ex-informative-progress-bar-wrapper #progress .dotTwo{-webkit-animation:dot 1.3s infinite;opacity:0}.ex-informative-progress-bar-wrapper .dotOne{-webkit-animation-delay:0ms;animation:dot 1.3s infinite;animation-delay:0ms;-moz-animation:dot 1.3s infinite;-moz-animation-delay:0ms}.ex-informative-progress-bar-wrapper .dotTwo{-webkit-animation-delay:.2s;animation:dot 1.3s infinite;animation-delay:.2s;-moz-animation:dot 1.3s infinite;-moz-animation-delay:.2s}.ex-informative-progress-bar-wrapper .dotThree{opacity:0;-webkit-animation:dot 1.3s infinite;-webkit-animation-delay:.3s;animation:dot 1.3s infinite;animation-delay:.3s;-moz-animation:dot 1.3s infinite;-moz-animation-delay:.3s}@keyframes dot{0%,50%{opacity:0}to{opacity:1}}.ex-informative-progress-bar-minimized-wrapper{display:flex;align-items:center;padding-inline:6px;column-gap:12px;opacity:.7;border-radius:5px;padding-top:2px;padding-bottom:2px}.ex-informative-progress-bar-minimized-wrapper .ex-informative-progress-bar-font-size{font-size:1.3em;color:#fff}.ex-informative-progress-bar-minimized-button{cursor:pointer}.ex-informative-progress-bar-minimized-button ::ng-deep .ex-button-secondary{background:transparent!important}\n"] }]
    }], function () { return []; }, { valueSubject: [{
            type: Input
        }], descSubject: [{
            type: Input
        }], desc: [{
            type: Input
        }], displayTitle: [{
            type: Input
        }], cancelButton: [{
            type: Input
        }], errorLabel: [{
            type: Input
        }], hasMinimizedMode: [{
            type: Input
        }], doneEvent: [{
            type: Output
        }], cancelEvent: [{
            type: Output
        }], cancelButtonRef: [{
            type: ViewChild,
            args: ['cancelButton']
        }], closeButtonRef: [{
            type: ViewChild,
            args: ['closeButton']
        }] }); })();

class ExInformativeProgressBarModule {
    static { this.ɵfac = function ExInformativeProgressBarModule_Factory(t) { return new (t || ExInformativeProgressBarModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExInformativeProgressBarModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatProgressBarModule,
            ExButtonModule,
            ExIconModule,
            TranslateModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExInformativeProgressBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressBarModule,
                    ExButtonModule,
                    ExIconModule,
                    TranslateModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExInformativeProgressBar
                ],
                exports: [
                    ExInformativeProgressBar
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExInformativeProgressBarModule, { declarations: [ExInformativeProgressBar], imports: [CommonModule,
        MatProgressBarModule,
        ExButtonModule,
        ExIconModule,
        TranslateModule,
        ExSvgIconModule], exports: [ExInformativeProgressBar] }); })();

const _c0$t = function (a0) { return { "ex-card-wrapper-selected": a0 }; };
function ExCardWrapperComponent_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵlistener("click", function ExCardWrapperComponent_a_6_Template_a_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const action_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onClick(action_r2.title)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$t, ctx_r0.selectedAction === action_r2.title));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", action_r2.title, " ");
} }
function ExCardWrapperComponent_ng_container_8_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExCardWrapperComponent_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExCardWrapperComponent_ng_container_8_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", action_r5.component);
} }
function ExCardWrapperComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExCardWrapperComponent_ng_container_8_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", action_r5.title === ctx_r1.selectedAction);
} }
class ExCardWrapperComponent {
    /**
     * @ignore
     */
    constructor() {
        /**
         * List of card tabs(one or more), each tab has a title and a loaded component
         */
        this.actions = [];
    }
    ngOnInit() {
        if (this.actions.length > 0) {
            this.selectedAction = this.actions[0].title;
        }
    }
    onClick(action) {
        this.selectedAction = action;
    }
    static { this.ɵfac = function ExCardWrapperComponent_Factory(t) { return new (t || ExCardWrapperComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExCardWrapperComponent, selectors: [["ex-card-wrapper"]], inputs: { title: "title", actions: "actions" }, decls: 9, vars: 3, consts: [[1, "ex-card-wrapper"], [1, "ex-card-wrapper-first-row"], [1, "ex-card-wrapper-title"], ["class", "ex-card-wrapper-actions", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "ex-card-wrapper-actions", 3, "ngClass", "click"], [4, "ngIf"], [4, "ngTemplateOutlet"]], template: function ExCardWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "hr");
            i0.ɵɵelementStart(1, "div", 0)(2, "div", 1)(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div");
            i0.ɵɵtemplate(6, ExCardWrapperComponent_a_6_Template, 2, 4, "a", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div");
            i0.ɵɵtemplate(8, ExCardWrapperComponent_ng_container_8_Template, 2, 1, "ng-container", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.actions);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.actions);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet], styles: [".ex-card-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 160px;width:100%;margin:0 0 15px}.ex-card-wrapper[_ngcontent-%COMP%]   .ex-card-wrapper-first-row[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.ex-card-wrapper[_ngcontent-%COMP%]   .ex-card-wrapper-first-row[_ngcontent-%COMP%]   .ex-card-wrapper-actions[_ngcontent-%COMP%]{cursor:pointer;margin-right:10px}.ex-card-wrapper[_ngcontent-%COMP%]   .ex-card-wrapper-first-row[_ngcontent-%COMP%]   .ex-card-wrapper-actions[_ngcontent-%COMP%]:last-child{margin-right:0}.ex-card-wrapper[_ngcontent-%COMP%]   .ex-card-wrapper-first-row[_ngcontent-%COMP%]   .ex-card-wrapper-selected[_ngcontent-%COMP%]{cursor:default}hr[_ngcontent-%COMP%]{margin:0 0 5px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCardWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-card-wrapper', template: "<hr>\n<div class=\"ex-card-wrapper\">\n  <div class=\"ex-card-wrapper-first-row\">\n    <span class=\"ex-card-wrapper-title\">{{title}}</span>\n    <div>\n      <a [ngClass]=\"{'ex-card-wrapper-selected': selectedAction === action.title}\" class=\"ex-card-wrapper-actions\"\n        *ngFor=\"let action of actions\" (click)=\"onClick(action.title)\">\n        {{action.title}}\n      </a>\n    </div>\n  </div>\n  <div>\n    <ng-container *ngFor=\"let action of actions\">\n      <ng-container *ngIf=\"action.title === selectedAction\">\n        <ng-container *ngTemplateOutlet=\"action.component\"></ng-container>\n      </ng-container>\n    </ng-container>\n  </div>\n</div>", styles: [".ex-card-wrapper{display:flex;flex-direction:column;flex:1 1 160px;width:100%;margin:0 0 15px}.ex-card-wrapper .ex-card-wrapper-first-row{display:flex;flex-direction:row;justify-content:space-between}.ex-card-wrapper .ex-card-wrapper-first-row .ex-card-wrapper-actions{cursor:pointer;margin-right:10px}.ex-card-wrapper .ex-card-wrapper-first-row .ex-card-wrapper-actions:last-child{margin-right:0}.ex-card-wrapper .ex-card-wrapper-first-row .ex-card-wrapper-selected{cursor:default}hr{margin:0 0 5px}\n"] }]
    }], function () { return []; }, { title: [{
            type: Input
        }], actions: [{
            type: Input
        }] }); })();

class ExCardWrapperModule {
    static { this.ɵfac = function ExCardWrapperModule_Factory(t) { return new (t || ExCardWrapperModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExCardWrapperModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCardWrapperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    ExCardWrapperComponent
                ],
                exports: [
                    ExCardWrapperComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExCardWrapperModule, { declarations: [ExCardWrapperComponent], imports: [CommonModule], exports: [ExCardWrapperComponent] }); })();

class ExResizeColumnDirective {
    constructor(renderer, el, liveAnnouncer, translate) {
        this.renderer = renderer;
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        this.translate = translate;
        this.isFocusable = true;
        this.columnsCustomizationChange = new EventEmitter();
        this.customizationFinished = new EventEmitter();
        this.isResizingRight = true;
        this.eventUnlisteners = [];
        this.spaceClicked = false;
        this.onMouseDown = (event, isResizingRight) => {
            this.pressed = true;
            this.startX = event.pageX;
            this.startWidth = this.column.offsetWidth;
            this.isResizingRight = isResizingRight;
            this.mousemoveListenerFn = this.renderer.listen(this.table, "mousemove", this.onMouseMove);
            this.mouseupListenerFn = this.renderer.listen("document", "mouseup", this.onMouseUp);
            event.stopPropagation();
        };
        this.onMouseMove = (event) => {
            if (this.pressed && event.buttons) {
                event.stopPropagation();
                this.renderer.addClass(this.table, "ex-grid-layout-resizing");
                this.renderer.addClass(this.table, "ex-items-layout-grid-resizing");
                // Calculate width of column
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (width > 50 || width > this.startWidth) {
                    this.setColumnWidthChanges(width);
                }
            }
        };
        this.onMouseUp = () => {
            if (this.pressed) {
                event.stopPropagation();
                this.pressed = false;
                this.renderer.removeClass(this.table, "ex-grid-layout-resizing");
                this.renderer.removeClass(this.table, "ex-items-layout-grid-resizing");
                if (this.mousemoveListenerFn)
                    this.mousemoveListenerFn();
                if (this.mouseupListenerFn)
                    this.mouseupListenerFn();
                this.customizationFinished.emit();
            }
        };
        this.onKeyDown = (event, isResizingRight, resizer) => {
            if (event.keyCode === 32) { //space
                event.stopPropagation();
                event.preventDefault();
                this.spaceClicked = !this.spaceClicked;
                if (this.spaceClicked) {
                    this.renderer.addClass(resizer, 'ex-grid-layout-resize-holder-clicked');
                    this.renderer.addClass(resizer, 'ex-items-layout-grid-resize-holder-clicked');
                    this.liveAnnouncer.announce(this.translate.instant('ng.general.resize-accessability-space-clicked'));
                }
                else {
                    this.renderer.removeClass(resizer, 'ex-grid-layout-resize-holder-clicked');
                    this.renderer.removeClass(resizer, 'ex-items-layout-grid-resize-holder-clicked');
                }
                return;
            }
            if (this.spaceClicked) {
                this.isResizingRight = isResizingRight;
                let width;
                if (event.keyCode === 39) { //right
                    event.stopPropagation();
                    if (isResizingRight) {
                        width = this.column.offsetWidth + 10;
                    }
                    else {
                        width = this.column.offsetWidth - 10;
                    }
                }
                if (event.keyCode === 37) { //left
                    event.stopPropagation();
                    if (isResizingRight) {
                        width = this.column.offsetWidth - 10;
                    }
                    else {
                        width = this.column.offsetWidth + 10;
                    }
                }
                if (width > 50 || width > this.column.offsetWidth) {
                    this.setColumnWidthChanges(width);
                    this.customizationFinished.emit();
                }
            }
        };
        this.onFocus = () => {
            if (!this.spaceClicked) {
                this.liveAnnouncer.announce(this.translate.instant('ng.general.resize-accessability-message'));
            }
        };
        this.onBlur = (resizer) => {
            this.renderer.removeClass(resizer, 'ex-grid-layout-resize-holder-clicked');
        };
        this.column = this.el.nativeElement;
    }
    ngOnInit() {
        const row = this.renderer.parentNode(this.column);
        const thead = this.renderer.parentNode(row);
        this.table = this.renderer.parentNode(thead);
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('resizable')) {
            if (this.resizable)
                this.initResizer();
            else
                this.removeResizers();
        }
        if (changes.hasOwnProperty('columnsCustomization')) {
            if (this.columnsCustomization) {
                this.width = this.columnsCustomization[this.identifier]?.width ?? this.width;
            }
        }
    }
    ngOnDestroy() {
        this.unlistenAll();
    }
    initResizer() {
        this.removeResizers();
        const index = this.orderedColumns.findIndex(col => col === this.identifier);
        if (index !== 0)
            this.setResizer('start');
        if (index !== this.orderedColumns.length - 1)
            this.setResizer('end');
    }
    setResizer(direction) {
        this.createAppendResizerElement(direction);
        this.addResizerListeners(direction);
    }
    createAppendResizerElement(direction) {
        const isDirectionEnd = direction === 'end';
        this[`resizer_${direction}`] = this.renderer.createElement("span");
        this.renderer.setStyle(this[`resizer_${direction}`], `inset-inline-${direction}`, '0px');
        this.renderer.addClass(this[`resizer_${direction}`], "ex-grid-layout-resize-holder");
        this.renderer.addClass(this[`resizer_${direction}`], "ex-items-layout-grid-resize-holder");
        if (isDirectionEnd && this.isFocusable)
            this.renderer.setAttribute(this[`resizer_${direction}`], "tabindex", "0");
        this.renderer.appendChild(this.column, this[`resizer_${direction}`]);
    }
    addResizerListeners(direction) {
        const isDirectionEnd = direction === 'end';
        this.eventUnlisteners.push(this.renderer.listen(this[`resizer_${direction}`], "mousedown", (event) => this.onMouseDown(event, isDirectionEnd)));
        this.eventUnlisteners.push(this.renderer.listen(this[`resizer_${direction}`], "keydown", (event) => this.onKeyDown(event, isDirectionEnd, this[`resizer_${direction}`])));
        this.eventUnlisteners.push(this.renderer.listen(this[`resizer_${direction}`], "blur", (event) => this.onBlur(this[`resizer_${direction}`])));
        this.eventUnlisteners.push(this.renderer.listen(this[`resizer_${direction}`], "click", (event) => event.stopPropagation()));
        if (isDirectionEnd)
            this.eventUnlisteners.push(this.renderer.listen(this[`resizer_${direction}`], 'focus', () => this.onFocus()));
    }
    removeResizers() {
        this.unlistenAll();
        this.resizer_start && this.renderer.removeChild(this.column, this.resizer_start);
        this.resizer_end && this.renderer.removeChild(this.column, this.resizer_end);
    }
    unlistenAll() {
        this.eventUnlisteners.forEach(unlistener => unlistener());
        this.eventUnlisteners = [];
    }
    setColumnWidthChanges(width) {
        const index = this.orderedColumns.findIndex(col => col === this.identifier);
        const orgWidth = this.columnsCustomization[this.identifier].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const secCol = this.isResizingRight ? index + 1 : index - 1;
            const secColIdentifier = this.orderedColumns[secCol];
            const oldWidth = this.columnsCustomization[secColIdentifier].width;
            const newWidth = oldWidth - dx;
            if (newWidth > 50 || newWidth > oldWidth) {
                this.columnsCustomization[this.identifier].width = width;
                this.columnsCustomization[secColIdentifier].width = newWidth;
                this.columnsCustomizationChange.emit({ ...this.columnsCustomization });
            }
        }
    }
    static { this.ɵfac = function ExResizeColumnDirective_Factory(t) { return new (t || ExResizeColumnDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ExLiveAnnouncerService), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ExResizeColumnDirective, selectors: [["", "exResizeColumn", ""]], hostVars: 2, hostBindings: function ExResizeColumnDirective_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width, "px");
        } }, inputs: { resizable: ["exResizeColumn", "resizable"], identifier: "identifier", columnsCustomization: "columnsCustomization", orderedColumns: "orderedColumns", isFocusable: "isFocusable" }, outputs: { columnsCustomizationChange: "columnsCustomizationChange", customizationFinished: "customizationFinished" }, features: [i0.ɵɵNgOnChangesFeature] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExResizeColumnDirective, [{
        type: Directive,
        args: [{
                selector: "[exResizeColumn]"
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: ExLiveAnnouncerService }, { type: i1$2.TranslateService }]; }, { resizable: [{
            type: Input,
            args: ["exResizeColumn"]
        }], identifier: [{
            type: Input
        }], columnsCustomization: [{
            type: Input
        }], orderedColumns: [{
            type: Input
        }], isFocusable: [{
            type: Input
        }], columnsCustomizationChange: [{
            type: Output
        }], customizationFinished: [{
            type: Output
        }], width: [{
            type: HostBinding,
            args: ['style.width.px']
        }] }); })();

class CustomBackgroundRowColorPipe {
    transform(value) {
        return value?.__proto__?.customBackgroundRowColor && value[value.__proto__.customBackgroundRowColor];
    }
    static { this.ɵfac = function CustomBackgroundRowColorPipe_Factory(t) { return new (t || CustomBackgroundRowColorPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "customBackgroundRowColor", type: CustomBackgroundRowColorPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomBackgroundRowColorPipe, [{
        type: Pipe,
        args: [{
                name: 'customBackgroundRowColor'
            }]
    }], null, null); })();

const _c0$s = ["rowItemRef"];
function ExGridLayoutComponent_div_0_ex_list_header_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-list-header", 8);
    i0.ɵɵlistener("actionClicked", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onActionClicked($event)); })("filterChange", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_filterChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.filterChange.emit($event)); })("searchChange", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_searchChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.searchChange.emit($event)); })("selectedValueChange", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_selectedValueChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10._searchFieldChange($event)); })("sortChange", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_sortChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.sortChange.emit($event)); })("clearCheckedItems", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_clearCheckedItems_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onClearCheckedItems()); })("datesUpdated", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_datesUpdated_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13._datesUpdated($event)); })("clearDates", function ExGridLayoutComponent_div_0_ex_list_header_3_Template_ex_list_header_clearDates_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14._clearDates()); });
    i0.ɵɵprojection(1, 0, ["header-slot-0", ""]);
    i0.ɵɵprojection(2, 1, ["header-slot-1", ""]);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("responsivenessActive", ctx_r3.responsiveHeader)("actions", ctx_r3.listProperties.actions)("sorts", ctx_r3.listProperties.showSortsInListHeader && ctx_r3.listProperties.sorts)("filters", ctx_r3.listProperties.filters)("searchByFields", ctx_r3.listProperties.searchByFields)("hasSearch", ctx_r3.listProperties.hasSearch)("popUpActions", ctx_r3.listProperties.popUpActions)("hasPickupCount", ctx_r3.listProperties.hasPickupCount)("searchBySelectedField", ctx_r3.listProperties.searchBySelectedField)("hasBottomBorder", false)("hasExport", ctx_r3.listProperties.hasExport)("clearAllSubject", ctx_r3.clearAllSubject)("numberOfCheckedItems", ctx_r3.pickupSelection.selected.length)("showDateFilter", ctx_r3.listProperties.showDateFilter)("filterMaxDate", ctx_r3.listProperties.filterMaxDate)("filterMinDate", ctx_r3.listProperties.filterMinDate)("customizationComponent", ctx_r3.customizationComponent)("isCustomized", ctx_r3.isCustomized);
} }
function ExGridLayoutComponent_div_0_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} }
const _c1$k = function (a0, a1, a2) { return { "ex-grid-layout-header-text-theme": a0, "ex-grid-layout-header-text-gray": a1, "ex-grid-layout-not-page": a2 }; };
function ExGridLayoutComponent_div_0_div_4_tr_3_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 23);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_1_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r25.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_th_1_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r27.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("orderedColumns", ctx_r19.displayedColumns)("columnsCustomization", ctx_r19.columnsCustomization)("ngClass", i0.ɵɵpureFunction3(4, _c1$k, ctx_r19.themeHeader, !ctx_r19.themeHeader, !ctx_r19.isPageGrid));
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_th_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 24);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_2_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r28.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_th_2_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r30.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("orderedColumns", ctx_r20.displayedColumns)("columnsCustomization", ctx_r20.columnsCustomization)("ngClass", i0.ɵɵpureFunction3(4, _c1$k, ctx_r20.themeHeader, !ctx_r20.themeHeader, !ctx_r20.isPageGrid));
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_th_3_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 25);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_3_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r31.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_th_3_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r33 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r33.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 26)(2, "ex-checkbox", 27);
    i0.ɵɵlistener("checkboxChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_3_Template_ex_checkbox_checkboxChange_2_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r34 = i0.ɵɵnextContext(4); return i0.ɵɵresetView($event ? ctx_r34.masterToggle() : null); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", false)("orderedColumns", ctx_r21.displayedColumns)("columnsCustomization", ctx_r21.columnsCustomization)("ngClass", i0.ɵɵpureFunction3(10, _c1$k, ctx_r21.themeHeader, !ctx_r21.themeHeader, !ctx_r21.isPageGrid));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r21.currentPageSelectedCount > 0 && ctx_r21.isAllSelected())("indeterminate", ctx_r21.currentPageSelectedCount > 0 && !ctx_r21.isAllSelected())("ariaLabel", i0.ɵɵpipeBind1(3, 8, "ng.ex-list-header-check-all"))("uniqueSelector", "ex-grid-layout-check-all-" + ctx_r21.gridId);
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_th_4_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 28);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_4_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r35.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_th_4_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r37.customizationFinished()); });
    i0.ɵɵelementStart(1, "span", 29);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("orderedColumns", ctx_r22.displayedColumns)("columnsCustomization", ctx_r22.columnsCustomization)("ngClass", i0.ɵɵpureFunction3(10, _c1$k, ctx_r22.themeHeader, !ctx_r22.themeHeader, !ctx_r22.isPageGrid));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 6, ctx_r22.checkIconColumnLabel));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 8, ctx_r22.checkIconColumnLabel), " ");
} }
const _c2$e = function (a0, a1, a2) { return { "uxf-arrow-combo": a0, "uxf-down-caret": a1, "uxf-up-caret": a2 }; };
const _c3$b = function (a0) { return { columnName: a0 }; };
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵlistener("keydown.Enter", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_span_4_Template_span_keydown_Enter_0_listener() { i0.ɵɵrestoreView(_r47); const column_r38 = i0.ɵɵnextContext(2).$implicit; const ctx_r45 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r45.onHeaderClicked(column_r38)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r38 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c2$e, column_r38.sorted === "none", column_r38.sorted === "desc", column_r38.sorted === "asc"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 2, "ng.general.sort-tooltip", i0.ɵɵpureFunction1(11, _c3$b, i0.ɵɵpipeBind1(2, 5, column_r38.label))));
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("spaceClicked", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_5_Template_div_spaceClicked_0_listener($event) { i0.ɵɵrestoreView(_r51); const i_r39 = i0.ɵɵnextContext(2).index; const ctx_r49 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r49.dragSpaceClikced($event, i_r39)); })("blured", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_5_Template_div_blured_0_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r52.blured()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r38 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("exDrag", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, column_r38.label), "");
} }
const _c4$9 = function (a0, a1, a2, a3) { return { "ex-grid-layout-header-text-theme": a0, "ex-grid-layout-header-text-gray": a1, "ex-grid-layout-not-page": a2, "ex-grid-layout-no-left-padding": a3 }; };
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r38 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r54 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(4, _c4$9, ctx_r54.themeHeader, !ctx_r54.themeHeader, !ctx_r54.isPageGrid, column_r38.isIconColumn || column_r38.isToggleColumn));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, column_r38.label), "");
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_6_div_1_Template, 3, 9, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r38 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵstyleProp("width", ctx_r43.columnsCustomization[column_r38.columnIdentifier] == null ? null : ctx_r43.columnsCustomization[column_r38.columnIdentifier].width, "px");
    i0.ɵɵproperty("ngClass", ctx_r43.themeClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r38.displayLabelInHeader);
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 44);
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(1, _c1$k, ctx_r44.themeHeader, !ctx_r44.themeHeader, !ctx_r44.isPageGrid));
} }
const _c5$8 = function (a0, a1, a2, a3, a4) { return { "ex-grid-layout-header-text-theme": a0, "ex-grid-layout-header-text-gray": a1, "ex-grid-layout-not-page": a2, "ex-grid-layout-no-left-padding": a3, "ex-grid-layout-space-clicked": a4 }; };
const _c6$8 = function (a0) { return { "ex-grid-layout-flex-centered": a0 }; };
const _c7$7 = function (a0) { return { "ex-grid-layout-sortable-header": a0 }; };
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 32);
    i0.ɵɵlistener("cdkDragStarted", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template_th_cdkDragStarted_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r57.isDragging = true); })("cdkDragEnded", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template_th_cdkDragEnded_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r59.isDragging = false); })("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r60 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r60.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r61 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r61.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵlistener("click", function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r58); const column_r38 = i0.ɵɵnextContext().$implicit; const ctx_r62 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(column_r38.sortable ? ctx_r62.onHeaderClicked(column_r38) : $event.stopPropagation()); });
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_span_4_Template, 3, 13, "span", 35);
    i0.ɵɵtemplate(5, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_5_Template, 3, 4, "div", 36);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_6_Template, 2, 4, "div", 37);
    i0.ɵɵtemplate(7, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_div_7_Template, 1, 5, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext();
    const column_r38 = ctx_r64.$implicit;
    const i_r39 = ctx_r64.index;
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMapInterpolate1("", "sel-grid-header-" + column_r38.columnIdentifier, " ex-grid-layout-header-text ex-grid-layout-header-dragable ex-grid-layout-th");
    i0.ɵɵproperty("exResizeColumn", true)("orderedColumns", ctx_r40.displayedColumns)("identifier", column_r38.columnIdentifier)("columnsCustomization", ctx_r40.columnsCustomization)("ngClass", i0.ɵɵpureFunction5(15, _c5$8, ctx_r40.themeHeader, !ctx_r40.themeHeader, !ctx_r40.isPageGrid, column_r38.isIconColumn || column_r38.isToggleColumn, ctx_r40.spaceClickedIndex === i_r39));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 13, column_r38.customTooltip || column_r38.label))("ngClass", i0.ɵɵpureFunction1(21, _c6$8, column_r38.centered && column_r38.centered === true));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c7$7, column_r38.sortable === true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r38.sortable === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r38.displayLabelInHeader);
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_th_1_Template, 8, 25, "th", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r38 = ctx.$implicit;
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.displayedColumns.includes(column_r38.columnIdentifier));
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_th_6_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 45);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tr_3_th_6_Template_th_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r65.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tr_3_th_6_Template_th_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r67.customizationFinished()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("orderedColumns", ctx_r24.displayedColumns)("columnsCustomization", ctx_r24.columnsCustomization)("ngClass", i0.ɵɵpureFunction3(4, _c1$k, ctx_r24.themeHeader, !ctx_r24.themeHeader, !ctx_r24.isPageGrid));
} }
function ExGridLayoutComponent_div_0_div_4_tr_3_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 16);
    i0.ɵɵlistener("cdkDropListDropped", function ExGridLayoutComponent_div_0_div_4_tr_3_Template_tr_cdkDropListDropped_0_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r68.dropCol($event)); });
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tr_3_th_1_Template, 1, 8, "th", 17);
    i0.ɵɵtemplate(2, ExGridLayoutComponent_div_0_div_4_tr_3_th_2_Template, 1, 8, "th", 18);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_4_tr_3_th_3_Template, 4, 14, "th", 19);
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_tr_3_th_4_Template, 6, 14, "th", 20);
    i0.ɵɵtemplate(5, ExGridLayoutComponent_div_0_div_4_tr_3_ng_container_5_Template, 2, 1, "ng-container", 21);
    i0.ɵɵtemplate(6, ExGridLayoutComponent_div_0_div_4_tr_3_th_6_Template, 1, 8, "th", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cdkDropListData", ctx_r16.displayedColumns)("ngClass", i0.ɵɵpureFunction3(8, _c1$k, ctx_r16.themeHeader, !ctx_r16.themeHeader, !ctx_r16.isPageGrid));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.listProperties.hasDrag && !ctx_r16.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.listProperties.hasCheckIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r16.schema["columns"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r16.schema.rowActions == null ? null : ctx_r16.schema.rowActions.length) > 0);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_4_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 57);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_4_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r83.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_4_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r84); const ctx_r85 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r85.customizationFinished()); });
    i0.ɵɵelementStart(1, "ex-right-click-actions", 58);
    i0.ɵɵlistener("actionClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_4_Template_ex_right_click_actions_actionClicked_1_listener($event) { i0.ɵɵrestoreView(_r84); const rowIndex_r72 = i0.ɵɵnextContext(2).index; const ctx_r86 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r86.dragActionClicked($event, rowIndex_r72)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelement(3, "ex-drag-accessible-icon", 59);
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("exResizeColumn", true)("isFocusable", true)("orderedColumns", ctx_r77.displayedColumns)("columnsCustomization", ctx_r77.columnsCustomization);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(2, 11, "ex-grid-layout-right-click-actions-drag-" + ctx_r77.gridId));
    i0.ɵɵproperty("actions", ctx_r77.dragActions);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-grid-layout-drag-handle ", i0.ɵɵpipeBind1(4, 13, "ex-grid-layout-drag-handle-" + ctx_r77.gridId), "");
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_5_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 60);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_5_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r88.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_5_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r89); const ctx_r90 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r90.customizationFinished()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r78 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("isFocusable", true)("orderedColumns", ctx_r78.displayedColumns)("columnsCustomization", ctx_r78.columnsCustomization);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r78.listProperties.pagination.selectedPage - 1) * ctx_r78.listProperties.pagination.pageSize + ctx_r78.dataSource.data.indexOf(row_r71) + 1, " ");
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 61);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r92.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r93); const ctx_r94 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r94.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 26)(2, "ex-checkbox", 62);
    i0.ɵɵlistener("click", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template_ex_checkbox_click_2_listener($event) { return $event.stopPropagation(); })("checkboxChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template_ex_checkbox_checkboxChange_2_listener($event) { i0.ɵɵrestoreView(_r93); const row_r71 = i0.ɵɵnextContext(2).$implicit; const ctx_r96 = i0.ɵɵnextContext(4); return i0.ɵɵresetView($event ? ctx_r96.onRowPickupToggle(row_r71) : null); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r79 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", false)("isFocusable", false)("orderedColumns", ctx_r79.displayedColumns)("columnsCustomization", ctx_r79.columnsCustomization);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r79.isSelected(ctx_r79.pickupSelection.selected, row_r71) !== -1)("ariaLabel", i0.ɵɵpipeBind1(3, 7, "ng.ex_items_layout_list_row.check_or_uncheck"))("uniqueSelector", "ex-grid-layout-check-or-uncheck-" + ctx_r79.gridId);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 65);
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("color", ctx_r99.checkIconColumnIconColor);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 63);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r100.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r101); const ctx_r102 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r102.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtemplate(2, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_ex_icon_2_Template, 1, 1, "ex-icon", 64);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r80 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("isFocusable", true)("orderedColumns", ctx_r80.displayedColumns)("columnsCustomization", ctx_r80.columnsCustomization);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r80.hasCheckIcon(row_r71));
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ex-component-loader", 71);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r104 = i0.ɵɵnextContext(2).$implicit;
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("componentFactoryItem", row_r71[column_r104.columnIdentifier + "ComponentRef"])("data", row_r71[column_r104.columnIdentifier + "ComponentRef"].data.inputs ? row_r71[column_r104.columnIdentifier + "ComponentRef"].data.inputs : row_r71[column_r104.columnIdentifier + "ComponentRef"].data)("events", row_r71[column_r104.columnIdentifier + "ComponentRef"].data.events);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "ex-icon", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r104 = i0.ɵɵnextContext(3).$implicit;
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r112 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconType", column_r104.iconType ? column_r104.iconType : "uxf")("iconName", row_r71[column_r104.columnIdentifier])("color", ctx_r112.iconColumnIconColor);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "ex-slide-toggle", 78);
    i0.ɵɵlistener("click", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_ng_container_0_Template_ex_slide_toggle_click_1_listener($event) { return $event.stopPropagation(); })("toggleCheckedChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_ng_container_0_Template_ex_slide_toggle_toggleCheckedChange_1_listener() { i0.ɵɵrestoreView(_r125); const row_r71 = i0.ɵɵnextContext(6).$implicit; const ctx_r123 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r123.onRowActiveToggle(row_r71)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext(6).$implicit;
    const ctx_r121 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("toggleChecked", ctx_r121.isSelected(ctx_r121.activeSelection.selected, row_r71) !== -1)("uniqueSelector", "ex-grid-layout-toggle-" + ctx_r121.gridId);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_ng_container_0_Template, 2, 2, "ng-container", 77);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r115 = i0.ɵɵreference(4);
    const column_r104 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", column_r104.isToggleColumn)("ngIfElse", _r115);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "ex-link", 79);
    i0.ɵɵlistener("linkClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_3_ng_container_0_Template_ex_link_linkClicked_1_listener() { i0.ɵɵrestoreView(_r131); const row_r71 = i0.ɵɵnextContext(6).$implicit; const ctx_r129 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r129.onLinkClicked(row_r71)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r104 = i0.ɵɵnextContext(4).$implicit;
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("arguments", row_r71[column_r104.columnIdentifier]);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 77);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r117 = i0.ɵɵreference(6);
    const column_r104 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", column_r104.isLinkColumn)("ngIfElse", _r117);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r104 = i0.ɵɵnextContext(3).$implicit;
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 2, row_r71[column_r104.columnIdentifier]));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, row_r71[column_r104.columnIdentifier]), " ");
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_div_0_Template, 2, 3, "div", 72);
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_1_Template, 1, 2, "ng-template", null, 73, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_3_Template, 1, 2, "ng-template", null, 74, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_ng_template_5_Template, 4, 6, "ng-template", null, 75, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r113 = i0.ɵɵreference(2);
    const column_r104 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", column_r104.isIconColumn)("ngIfElse", _r113);
} }
const _c8$7 = function (a0) { return { "ex-grid-layout-no-left-padding": a0 }; };
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r139 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 67);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r139); const ctx_r138 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r138.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r139); const ctx_r140 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r140.customizationFinished()); });
    i0.ɵɵelementStart(1, "div", 68);
    i0.ɵɵtemplate(2, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_container_2_Template, 2, 3, "ng-container", 69);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_ng_template_3_Template, 7, 2, "ng-template", null, 70, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r108 = i0.ɵɵreference(4);
    const column_r104 = i0.ɵɵnextContext().$implicit;
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r106 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMapInterpolate1("", "sel-grid-body-" + column_r104.columnIdentifier, " ex-grid-layout-cell inline-cell");
    i0.ɵɵproperty("exResizeColumn", true)("isFocusable", true)("orderedColumns", ctx_r106.displayedColumns)("identifier", column_r104.columnIdentifier)("columnsCustomization", ctx_r106.columnsCustomization)("ngClass", i0.ɵɵpureFunction1(12, _c8$7, column_r104.isIconColumn || column_r104.isToggleColumn));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c6$8, column_r104.centered && column_r104.centered === true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r71[column_r104.columnIdentifier + "ComponentRef"])("ngIfElse", _r108);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_td_1_Template, 5, 16, "td", 66);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r104 = ctx.$implicit;
    const ctx_r81 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.displayedColumns.includes(column_r104.columnIdentifier));
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r146 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-action-menu", 82);
    i0.ɵɵlistener("actionClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_ng_container_1_Template_ex_action_menu_actionClicked_1_listener($event) { i0.ɵɵrestoreView(_r146); const row_r71 = i0.ɵɵnextContext(3).$implicit; const ctx_r144 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r144.onRowActionClicked(row_r71, ctx_r144.dataSource.data.indexOf(row_r71), $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r147 = i0.ɵɵnextContext(3);
    const row_r71 = ctx_r147.$implicit;
    const rowIndex_r72 = ctx_r147.index;
    const ctx_r143 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", ctx_r143.getVisibleActions(row_r71.rowActions, rowIndex_r72))("isSelected", ctx_r143.selectedItem === ctx_r143.dataSource.data.indexOf(row_r71))("loading", ctx_r143.loadingMap[rowIndex_r72])("uniqueSelector", "ex-grid-layout-" + ctx_r143.gridId);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 81);
    i0.ɵɵlistener("columnsCustomizationChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_Template_td_columnsCustomizationChange_0_listener($event) { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r148.columnsCustomization = $event); })("customizationFinished", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_Template_td_customizationFinished_0_listener() { i0.ɵɵrestoreView(_r149); const ctx_r150 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r150.customizationFinished()); });
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_ng_container_1_Template, 2, 4, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r82 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exResizeColumn", true)("isFocusable", true)("orderedColumns", ctx_r82.displayedColumns)("columnsCustomization", ctx_r82.columnsCustomization);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r71.rowActions && row_r71.rowActions.length > 0);
} }
const _c9$6 = function (a0, a1, a2) { return { "ex-grid-layout-odd-row": a0, "ex-grid-layout-selected-row": a1, "ex-grid-layout-has-custom-background-color": a2 }; };
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r154 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 50, 51);
    i0.ɵɵlistener("click", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r154); const row_r71 = i0.ɵɵnextContext().$implicit; const ctx_r152 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r152.onRowSelected(ctx_r152.dataSource.data.indexOf(row_r71))); });
    i0.ɵɵpipe(2, "customBackgroundRowColor");
    i0.ɵɵpipe(3, "customBackgroundRowColor");
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_4_Template, 5, 15, "td", 52);
    i0.ɵɵtemplate(5, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_5_Template, 2, 5, "td", 53);
    i0.ɵɵtemplate(6, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_6_Template, 4, 9, "td", 54);
    i0.ɵɵtemplate(7, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_7_Template, 3, 5, "td", 55);
    i0.ɵɵtemplate(8, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_ng_container_8_Template, 2, 1, "ng-container", 21);
    i0.ɵɵtemplate(9, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_td_9_Template, 2, 5, "td", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext().$implicit;
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵstyleProp("background-color", i0.ɵɵpipeBind1(2, 10, row_r71));
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r74.listProperties.hasDrag || ctx_r74.isReadOnly)("ngClass", i0.ɵɵpureFunction3(14, _c9$6, ctx_r74.dataSource.data.indexOf(row_r71) % 2 === 0, ctx_r74.selectedItem === ctx_r74.dataSource.data.indexOf(row_r71), !!i0.ɵɵpipeBind1(3, 12, row_r71)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r74.listProperties.hasDrag && !ctx_r74.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.listProperties.hasCheckIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r74.schema["columns"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r74.schema.rowActions == null ? null : ctx_r74.schema.rowActions.length) > 0);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c10$5 = function (a0, a1, a2) { return { $implicit: a0, index: a1, closeForm: a2 }; };
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 87);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r157 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r157.editContent)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c10$5, ctx_r157.selectedItemObject, ctx_r157.selectedItem, ctx_r157.closeForm.bind(ctx_r157)));
} }
const _c11$3 = function (a0) { return { "name": a0, "type": "uxf" }; };
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_Template(rf, ctx) { if (rf & 1) {
    const _r160 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-inline-editing", 85);
    i0.ɵɵlistener("editModeChange", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_Template_ex_inline_editing_editModeChange_0_listener($event) { i0.ɵɵrestoreView(_r160); const ctx_r159 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r159.editMode = $event); })("closeClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_Template_ex_inline_editing_closeClicked_0_listener() { i0.ɵɵrestoreView(_r160); const ctx_r161 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r161.onCloseClicked()); });
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_ng_container_1_Template, 2, 6, "ng-container", 86);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r156 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("editMode", ctx_r156.editMode)("isSingleSave", false)("editTitle", ctx_r156.isNew ? ctx_r156.editTitleNew : ctx_r156.editTitleEdit)("editTitleIcon", i0.ɵɵpureFunction1(5, _c11$3, !ctx_r156.isNew ? "uxf-pencil" : "uxf-plus-circle"))("uniqueSelector", "ex-grid-layout-" + ctx_r156.gridId);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "div", 83);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_ex_inline_editing_3_Template, 2, 7, "ex-inline-editing", 84);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", ctx_r75.displayedColumns.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r75.editMode);
} }
const _c12$2 = function () { return []; };
function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r163 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-right-click-actions", 47);
    i0.ɵɵlistener("actionClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_Template_ex_right_click_actions_actionClicked_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r163); const row_r71 = restoredCtx.$implicit; const ctx_r162 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r162.onRowActionClicked(row_r71, ctx_r162.dataSource.data.indexOf(row_r71), $event)); })("copyCellClicked", function ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_Template_ex_right_click_actions_copyCellClicked_1_listener($event) { i0.ɵɵrestoreView(_r163); const ctx_r164 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r164.onCopyCellClicked($event)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelementContainer(3, 48);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_ng_template_4_Template, 10, 18, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_tr_6_Template, 4, 2, "tr", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r71 = ctx.$implicit;
    const rowIndex_r72 = ctx.index;
    const _r73 = i0.ɵɵreference(5);
    const ctx_r70 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-grid-layout-right-click-actions ", i0.ɵɵpipeBind1(2, 6, "ex-grid-layout-right-click-actions-" + ctx_r70.gridId), "");
    i0.ɵɵproperty("actions", ctx_r70.addCopyCellValueAction(row_r71.rowActions && row_r71.rowActions.length > 0 ? ctx_r70.getVisibleActions(row_r71.rowActions, rowIndex_r72) : i0.ɵɵpureFunction0(8, _c12$2)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r73);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r70.editIndex === rowIndex_r72);
} }
function ExGridLayoutComponent_div_0_div_4_tbody_4_Template(rf, ctx) { if (rf & 1) {
    const _r166 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody", 46);
    i0.ɵɵlistener("cdkDropListDropped", function ExGridLayoutComponent_div_0_div_4_tbody_4_Template_tbody_cdkDropListDropped_0_listener($event) { i0.ɵɵrestoreView(_r166); const ctx_r165 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r165.dropRow($event)); });
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_tbody_4_ng_container_1_Template, 7, 9, "ng-container", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cdkDropListData", ctx_r17.dataSource.data);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r17.dataSource.data);
} }
function ExGridLayoutComponent_div_0_div_4_ex_pagination_6_Template(rf, ctx) { if (rf & 1) {
    const _r168 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 88);
    i0.ɵɵlistener("selectedPageChange", function ExGridLayoutComponent_div_0_div_4_ex_pagination_6_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r167 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r167.onSelectedPageChange($event)); })("pageSizeChange", function ExGridLayoutComponent_div_0_div_4_ex_pagination_6_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r169 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r169.onpageSizeChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tableOutOfView", ctx_r18.tableOutOfView)("numberOfResults", ctx_r18.listProperties.pagination.totalItemsCount)("pageSize", ctx_r18.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r18.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r18.listProperties.pagination.selectedPage)("showPageSize", ctx_r18.listProperties.pagination.showPageSize);
} }
function ExGridLayoutComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r171 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("resized", function ExGridLayoutComponent_div_0_div_4_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r171); const ctx_r170 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r170.onResized($event)); });
    i0.ɵɵtemplate(1, ExGridLayoutComponent_div_0_div_4_div_1_Template, 1, 0, "div", 10);
    i0.ɵɵelementStart(2, "table", 11);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_4_tr_3_Template, 7, 12, "tr", 12);
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_tbody_4_Template, 2, 2, "tbody", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(5, 2);
    i0.ɵɵtemplate(6, ExGridLayoutComponent_div_0_div_4_ex_pagination_6_Template, 1, 6, "ex-pagination", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-grid-layout-table-wrapper-border", (ctx_r4.dataSource == null ? null : ctx_r4.dataSource.data == null ? null : ctx_r4.dataSource.data.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isDragging);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r4.gridId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.listProperties.showGridHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isLoading && ctx_r4.data && ctx_r4.data.length > 0 && (ctx_r4.dataSource == null ? null : ctx_r4.dataSource.data));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.listProperties.pagination.totalItemsCount > 0);
} }
const _c13$2 = function (a0) { return { "ex-grid-layout-even-row": a0 }; };
function ExGridLayoutComponent_div_0_div_5_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 92);
    i0.ɵɵelement(1, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const x_r174 = ctx.index;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c13$2, x_r174 % 2 === 1));
} }
function ExGridLayoutComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "table", 89)(2, "tbody", 90);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_div_5_tr_3_Template, 2, 3, "tr", 91);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", " ".repeat(ctx_r5.listProperties.pagination.pageSize).split(""));
} }
const _c14$2 = function (a0) { return { "ex-grid-layout-header-responsive": a0 }; };
function ExGridLayoutComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r176 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("snInViewport", function ExGridLayoutComponent_div_0_Template_div_snInViewport_0_listener() { i0.ɵɵrestoreView(_r176); const ctx_r175 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r175.tableViewChanged()); });
    i0.ɵɵelementStart(1, "div", 3, 4);
    i0.ɵɵtemplate(3, ExGridLayoutComponent_div_0_ex_list_header_3_Template, 3, 18, "ex-list-header", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExGridLayoutComponent_div_0_div_4_Template, 7, 7, "div", 6);
    i0.ɵɵtemplate(5, ExGridLayoutComponent_div_0_div_5_Template, 4, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c14$2, ctx_r0.responsiveHeader));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showListHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLoading);
} }
function ExGridLayoutComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r178 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 93)(1, "ex-button", 94);
    i0.ɵɵlistener("click", function ExGridLayoutComponent_div_1_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r178); const ctx_r177 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r177.addEntry()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("children", ctx_r1.addButtonChildren)("uniqueSelector", "ex-grid-layout-add-button-" + ctx_r1.gridId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r1.addButtonLabel), " ");
} }
const _c15$2 = [[["", "header-0", ""]], [["", "header-1", ""]], [["", "footer", ""]]];
const _c16$2 = ["[header-0]", "[header-1]", "[footer]"];
class ExGridLayoutComponent {
    /**
     * The selected row index
     */
    get selectedItem() {
        return this._selectedItem;
    }
    ;
    set selectedItem(value) {
        if (this._selectedItem === value)
            return;
        this._selectedItem = value;
        this.selectedItemChange.emit(value);
    }
    ;
    get data() {
        return this._data;
    }
    set data(data) {
        this._data = data;
        this.onItemsChanged();
    }
    constructor(changeDetectorRef, translate, sectionLayoutViewModeObservable) {
        this.changeDetectorRef = changeDetectorRef;
        this.translate = translate;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this._selectedItem = -1;
        this.postRowIds = [];
        /**
         * The array of ids of columns, only columns that are in this array are visible in the table.
         * The Order of columns is being determined by the order in this array.
         */
        this.displayedColumns = [];
        this.initialDisplayedColumns = [];
        /**
         * Holds the pickup selected rows from all pages
         */
        this.pickupSelection = new SelectionModel(true, []);
        this.currentPageSelectedCount = 0;
        /**
         * Holds the active rows
         */
        this.activeSelection = new SelectionModel(true, []);
        /**
         * The rows of the table
         */
        this._data = [];
        /**
         * The width of the predetermined columns in precentes
         */
        this.dragColumnWidth = 5;
        this.indexColumnWidth = 5;
        this.pickupColumnWidth = 1;
        this.checkIconColumnWidth = 5;
        this.rowActionColumnWidth = 5;
        /**
         *  the title of the internal edit inline editing
         */
        this.internalEditTitle = 'ng.general.edit';
        /**
         * The label of the active column
         */
        /**
         * The label of the checkIcon column
         */
        this.checkIconColumnLabel = 'Preferred';
        /**
         * The label of the index column
         */
        this.indexColumnLabel = 'Index';
        /**
         * The color of the checkIcon column icon */
        this.checkIconColumnIconColor = '#009e71';
        /**
         * The color of the icon column icons
         */
        this.iconColumnIconColor = '#4164A4';
        /**
         * is it a page list or nested
         */
        this.isPageGrid = true;
        /**
         * Whether the header responsiveness is active
         */
        this.responsiveHeader = false;
        /**
         * When opening the edit inside the table
         */
        this.internalEditMode = false;
        this.editMode = false;
        this.hideAddButton = true;
        this.addButtonLabel = "Add";
        this.editTitleEdit = "ng.general.edit";
        this.editTitleNew = "ng.general.add";
        this.isNew = false;
        /**
         * in case of children button when adding new card
         */
        this.addButtonChildren = [];
        this.readOnly = false;
        /**Event fired when the selected page change */
        this.selectedPageChange = new EventEmitter();
        /**
         * Event fired when the selected row index change
         */
        this.selectedItemChange = new EventEmitter();
        /**
         * Event fired when the page size change
         */
        this.pageSizeChange = new EventEmitter();
        /**
         * Event fired when one of the sort change
         */
        this.sortChange = new EventEmitter();
        /**
         * Event fired when one of the search change
         */
        this.searchChange = new EventEmitter();
        /**
         * Event fired when a filter changes in list header
         */
        this.filterChange = new EventEmitter();
        /**
         * Event fired when an action is clicked
         */
        this.actionClicked = new EventEmitter();
        /**
         * Event fired when a row action is clicked
         */
        this.rowActionClicked = new EventEmitter();
        /**
         * Event fired when a row is selected
         */
        this.rowSelected = new EventEmitter();
        /**
         * Event fired when sortable header is clicked
         */
        this.columnHeaderSortChange = new EventEmitter();
        /**
         * Event fired when an active state of a row is changed
         */
        this.rowActiveToggle = new EventEmitter();
        /**
         * Event fired when a complex cell emits data
         */
        this.cellOutput = new EventEmitter();
        /**
         * Event fired whenever an item inside the dropdown is clicked
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * Event fired whenever date range picker dates are updated
         */
        this.datesUpdated = new EventEmitter();
        /**
         * Event fired whenever date range picker dates are cleared
         */
        this.clearDates = new EventEmitter();
        /**
         * Event fired when resizing the right side causes a need to change the grid layout
         */
        this.switchLayout = new EventEmitter();
        /**
         * Event fired when the link of a user column of type 'link' is clicked
         */
        this.linkClicked = new EventEmitter();
        /**
         * Event fired whenever the customization change
         */
        this.columnsCustomizationChange = new EventEmitter();
        /**
         * Event fired as soon as the default customization is ready
         */
        this.defaultColumnsConfigurationChange = new EventEmitter();
        this.addClicked = new EventEmitter();
        this.cardDeleted = new EventEmitter();
        this.isNewChange = new EventEmitter();
        this.editModeChange = new EventEmitter();
        this.rowDragged = new EventEmitter();
        /**
         * The array of ids of columns, only columns that are in this array are visible in the table.
         * The Order of columns is being determined by the order in this array.
         */
        this.tableOutOfView = false;
        this.defaultColumnsConfiguration = {};
        this.collapseTableToCards = false;
        this.nonUserColumnsCount = 0;
        this.spaceClickedIndex = -1;
        this.isDragging = false;
        this.editIndex = -1;
        this.loadingMap = new Map();
        this._sectionsLayoutViewModeValue = false;
        this._subs = new Subscription();
        this.copyCellActionLabel = this.translate.instant('ng.grid_layout.actions.copy_cell_value');
        this.copyCellAction = new ActionModel({ label: this.copyCellActionLabel, value: 'ex_copy_cell_value', type: 'action' });
        this.dragActions = [];
        this.onItemsChanged = debounce(() => {
            if (this.isPageGrid && this.selectedItem > -1) {
                const element = this.rowItemRef?.toArray()[this.selectedItem]?.nativeElement;
                element && $(element).parents('.ex-grid-layout-table-wrapper').animate({ scrollTop: Math.max(element.offsetTop - 100, 0) }, 500, 'easeOutExpo');
            }
        }, 1000);
    }
    get showListHeader() {
        const { actions, filters, searchByFields, sorts, hasExport, showGridHeader } = this.listProperties;
        return showGridHeader ? (actions.length > 0 || filters?.length > 0 || searchByFields?.length > 0 || sorts?.length > 0
            || hasExport || this.customizationComponent) : false;
    }
    /**
    *@ignore
    */
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('dataType')) {
            if (this.dataType) {
                // instantiate the schema type
                this.schema = new this.dataType;
            }
        }
        if (changes.hasOwnProperty('data')) {
            if (this.data && this.data.length > 0) {
                this.subscribeToComplexCells();
                // Toggle the active state according to input
                this.data.filter(row => row.active === true).forEach(row => {
                    this.activeSelection.select(row);
                });
                this.dataSource = new MatTableDataSource(this.data);
                if (!this.isNew && this.editIndex >= 0) {
                    this.editIndex = -1;
                }
            }
            else {
                this.dataSource = null;
            }
            this.currentPageSelectedCount = this.getSelectedInPage().length;
            this.setDragActions();
        }
        if (changes.hasOwnProperty('columnsCustomization')) {
            if (this.columnsCustomization) {
                this.setColumnsWidth();
                this.removeHiddenColumns();
            }
        }
    }
    /**
     *@ignore
     */
    ngOnInit() {
        if (this.themeHeader === undefined) {
            this.themeHeader = true;
        }
        if (this.dragColumnWidth === undefined) {
            this.dragColumnWidth = 5;
        }
        if (this.indexColumnWidth === undefined) {
            this.indexColumnWidth = 5;
        }
        if (this.pickupColumnWidth === undefined) {
            this.pickupColumnWidth = 1;
        }
        if (this.checkIconColumnWidth === undefined) {
            this.checkIconColumnWidth = 5;
        }
        if (this.rowActionColumnWidth === undefined) {
            this.rowActionColumnWidth = 5;
        }
        this.displayedColumns = [];
        if (this.schema && this.schema['columns']) {
            // Adds the fixed columns according to the list properties
            if (this.listProperties.hasDrag) {
                this.displayedColumns.push('drag');
                this.defaultColumnsConfiguration['drag'] = {
                    width: this.dragColumnWidth,
                    canHide: false
                };
            }
            if (this.listProperties.hasIndex) {
                this.displayedColumns.push('index');
                this.defaultColumnsConfiguration['index'] = {
                    width: this.indexColumnWidth,
                    canHide: false
                };
            }
            if (this.listProperties.hasPickup) {
                this.displayedColumns.push('pickup');
                this.defaultColumnsConfiguration['pickup'] = {
                    width: this.pickupColumnWidth,
                    canHide: false
                };
            }
            if (this.listProperties.hasCheckIcon) {
                this.displayedColumns.push('checkIcon');
                this.defaultColumnsConfiguration['checkIcon'] = {
                    width: this.checkIconColumnWidth,
                    canHide: false
                };
            }
            this.nonUserColumnsCount = this.displayedColumns.length;
            // Extract the columns from the dataType
            this.schema['columns'].forEach(column => {
                this.displayedColumns.push(column.columnIdentifier);
                if (column.isPostRow) {
                    this.postRowIds.push(column.columnIdentifier);
                }
                this.defaultColumnsConfiguration[column.columnIdentifier] = {
                    width: column.columnWidth,
                    isHidden: column.isHidden,
                    label: column.label,
                    canHide: true
                };
            });
            //Add rowActions column only if at least one row has actions
            if (this.schema.rowActions && this.schema.rowActions.length > 0) {
                this.displayedColumns.push('rowActions');
                this.defaultColumnsConfiguration['rowActions'] = {
                    width: this.rowActionColumnWidth,
                    canHide: false
                };
            }
            this.displayedColumns.forEach((col, index) => {
                this.defaultColumnsConfiguration[col].order = index;
            });
            this.defaultColumnsConfigurationChange.emit(this.defaultColumnsConfiguration);
            this.initialDisplayedColumns = [...this.displayedColumns];
        }
        this._subs.add(this.sectionLayoutViewModeObservable?.subscribe((readOnly) => {
            this._sectionsLayoutViewModeValue = readOnly;
        }));
    }
    ngOnDestroy() {
        this.unSubscribeToComplexCells();
        this._subs.unsubscribe();
    }
    onResized(event) {
        this.tableWidth = event.newRect.width;
        if (!event.oldRect || event.newRect.width !== event.oldRect.width) {
            this.switchLayout.emit(event);
            this.setColumnsWidth();
        }
    }
    closeForm() {
        this.editMode = false;
        this.editModeChange.emit(false);
        this.isNew = false;
        this.editIndex = -1;
    }
    setColumnsWidth() {
        if (this.tableWidth && this.columnsCustomization) {
            let totWidth = 0;
            Object.keys(this.columnsCustomization).forEach(key => {
                if (!this.columnsCustomization[key].isHidden) {
                    totWidth += this.columnsCustomization[key].width;
                }
            });
            const scale = (this.tableWidth - 5) / totWidth;
            Object.keys(this.columnsCustomization).forEach(key => {
                this.columnsCustomization[key].width *= scale;
            });
            this.columnsCustomization = { ...this.columnsCustomization };
        }
        this.changeDetectorRef.detectChanges();
    }
    removeHiddenColumns() {
        this.displayedColumns = [...this.initialDisplayedColumns];
        Object.keys(this.columnsCustomization).forEach(key => {
            const ind = this.displayedColumns.findIndex(c => c === key);
            if (ind !== -1 && this.columnsCustomization[key].isHidden) {
                this.displayedColumns.splice(ind, 1);
            }
        });
        this.displayedColumns.sort((a, b) => {
            return this.columnsCustomization[a].order - this.columnsCustomization[b].order;
        });
        this.schema['columns'].sort((a, b) => {
            if (this.postRowIds.includes(a.columnIdentifier))
                return 1;
            return this.columnsCustomization[a.columnIdentifier].order - this.columnsCustomization[b.columnIdentifier].order;
        });
    }
    customizationFinished() {
        this.columnsCustomizationChange.emit(this.columnsCustomization);
    }
    subscribeToComplexCells() {
        const dynamicColumns = [];
        this.schema['columns'].forEach(column => {
            if (column.type) {
                dynamicColumns.push(column);
            }
        });
        this.data.forEach((row, index) => {
            dynamicColumns.forEach(column => {
                row[`${column.columnIdentifier}ComponentRef`] = new ExComponentFactoryItem(column.type, { ...row[column.columnIdentifier], arguments: row[column.columnIdentifier], dataOutput: new Subject() });
                row[`${column.columnIdentifier}ComponentRef`].data.dataOutput.subscribe(data => {
                    this.selectedItem = index;
                    this.cellOutput.emit({ row: row, columnIdentifier: column.columnIdentifier, data: data });
                });
            });
        });
    }
    unSubscribeToComplexCells() {
        const dynamicColumns = [];
        this.schema?.['columns']?.forEach(column => {
            if (column.type) {
                dynamicColumns.push(column);
            }
        });
        this.data?.forEach(row => {
            dynamicColumns.forEach(column => {
                row[`${column.columnIdentifier}ComponentRef`].data.dataOutput.unsubscribe();
            });
        });
    }
    tableViewChanged() {
        if (this.tableOutOfView)
            this.tableOutOfView = false;
        else
            this.tableOutOfView = true;
    }
    /**
     * Check if the data of a cell is simple or a dynamic component to load
     * @param data The data to check
     */
    isFactoryItem(data) {
        return data instanceof ExComponentFactoryItem;
    }
    getSelectedInPage() {
        const selected = [];
        if (this.dataSource) {
            for (let i = 0; i < this.dataSource.data.length; i++) {
                if (this.isSelected(this.pickupSelection.selected, this.dataSource.data[i]) !== -1) {
                    selected.push(this.dataSource.data[i]);
                }
            }
        }
        return selected;
    }
    /** Whether all the rows from this page are selected. */
    isAllSelected() {
        const selected = this.getSelectedInPage();
        if (this.dataSource) {
            for (let i = 0; i < this.dataSource.data.length; i++) {
                if (this.isSelected(selected, this.dataSource.data[i]) === -1) {
                    return false;
                }
            }
            return true;
        }
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        if (this.dataSource) {
            if (!this.isAllSelected()) {
                this.dataSource.data.forEach((row) => {
                    if (this.isSelected(this.pickupSelection.selected, row) === -1) {
                        this.onRowPickupToggle(row);
                    }
                });
            }
            else {
                this.dataSource.data.forEach((row) => {
                    if (this.isSelected(this.pickupSelection.selected, row) !== -1) {
                        this.onRowPickupToggle(row);
                    }
                });
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    /**
     * This function changes the selected row
     * @param index The index of the selected row
     */
    onRowSelected(index) {
        this.selectedItem = index;
        this.rowSelected.emit(index);
    }
    /**
     * This function handles the arrow keys movments in the table
     * @param event The keyboard event
     */
    handleKeyboardEvent(event) {
        if (event.key === 'ArrowUp') {
            this.selectPrevItem();
        }
        else if (event.key === 'ArrowDown') {
            this.selectNextItem();
        }
    }
    /**Change the selected item to the next one */
    selectNextItem() {
        if (this.selectedItem < this.dataSource.data.length - 1) {
            this.selectedItem = this.selectedItem + 1;
            this.onRowSelected(this.selectedItem);
        }
        else {
            if (this.hasNextPage()) {
                this.onSelectedPageChange(this.listProperties.pagination.selectedPage + 1);
                this.selectedItem = 0;
                this.onRowSelected(this.selectedItem);
            }
        }
    }
    /**Change the selected item to the previous one */
    selectPrevItem() {
        if (this.selectedItem > 0) {
            this.selectedItem = this.selectedItem - 1;
            this.onRowSelected(this.selectedItem);
        }
        else {
            if (this.hasPrevPage()) {
                this.onSelectedPageChange(this.listProperties.pagination.selectedPage - 1);
                this.selectedItem = this.listProperties.pagination.pageSize - 1;
                this.onRowSelected(this.selectedItem);
            }
        }
    }
    /**Checks if there is a previous pagination page */
    hasPrevPage() {
        return this.listProperties.pagination.selectedPage > 1;
    }
    /**Checks if there is a next pagination page */
    hasNextPage() {
        const { pageSize, totalItemsCount, selectedPage } = this.listProperties.pagination;
        return selectedPage < Math.ceil(totalItemsCount / pageSize);
    }
    /**
     * Emits pagination page change
     * @param page the new selected page
     */
    onSelectedPageChange(page) {
        this.listProperties.pagination.selectedPage = page;
        this.selectedItem = 0;
        this.currentPageSelectedCount = 0;
        this.selectedPageChange.emit(page);
        this.onRowSelected(this.selectedItem);
    }
    /**
     * Emits pagination size change
     * @param event the new size page
     */
    onpageSizeChange(event) {
        if (this.editIndex >= 0) {
            this.editIndex = -1;
        }
        this.pageSizeChange.emit(event);
    }
    /**
     * Emits the row action clicked
     * @param row the row model
     * @param actionKey the action key
     */
    onRowActionClicked(row, index, actionKey) {
        this.selectedItem = index;
        if (this.internalEditMode && actionKey == "edit") {
            //in case of edit row when new row opened without saved we want to remove it.
            if (this.isNew) {
                this.data.splice(this.selectedItem, 1);
            }
            this.selectedItemObject = this.data[this.selectedItem];
            this.editIndex = index;
            this.editMode = true;
            this.editModeChange.emit(true);
        }
        row.index = index;
        this.rowActionClicked.emit({ row: row, actionKey: actionKey });
    }
    onCopyCellClicked(event) {
        let copyLinkFunc = function (e) {
            e.clipboardData.setData('text/plain', (event.targetElement.closest('td').innerText).trim());
            e.preventDefault();
            document.removeEventListener('copy', copyLinkFunc);
        };
        document.addEventListener('copy', copyLinkFunc);
        document.execCommand('copy');
    }
    _searchFieldChange(searchField) {
        this.selectedValueChange.emit(searchField);
    }
    _datesUpdated(e) {
        this.datesUpdated.emit(e);
    }
    _clearDates() {
        this.clearDates.emit();
    }
    /**
     * Emits the sortable column header clicked
     * @param column The column that is clicked
     */
    onHeaderClicked(column) {
        if (column.sorted === 'none' || column.sorted === 'desc') {
            column.sorted = 'asc';
        }
        else if (column.sorted === 'asc') {
            column.sorted = 'desc';
        }
        this.schema['columns'].forEach(schemaColumn => {
            if (schemaColumn.columnIdentifier !== column.columnIdentifier) {
                schemaColumn.sorted = 'none';
            }
        });
        this.columnHeaderSortChange.emit(column);
    }
    /**
     * Emits the row, and current active state of the row
     * @param row The current state of the row, before changing the state
     */
    onRowActiveToggle(row) {
        const isSelected = this.toggleSelection(this.activeSelection, row);
        this.rowActiveToggle.emit({ row: row, state: isSelected });
    }
    onRowPickupToggle(row) {
        this.toggleSelection(this.pickupSelection, row) ? this.currentPageSelectedCount++ : this.currentPageSelectedCount--;
    }
    /**
     * This function extracts only the visible actions out of a row
     * @param rowActions The current row actions, that includes the visible state of each action
     */
    getVisibleActions(rowActions, index) {
        this.loadingMap[index] = false;
        const visibleActions = [];
        rowActions.forEach(action => {
            if (action.visible && (!this.isReadOnly || (this.isReadOnly && action.showInViewMode))) {
                visibleActions.push(action.action);
                if (action.action.loading) {
                    this.loadingMap[index] = true;
                }
            }
        });
        return visibleActions;
    }
    addCopyCellValueAction(actions) {
        if (actions.length == 0) {
            actions = [this.copyCellAction];
        }
        else {
            actions.push(this.copyCellAction);
        }
        return actions;
    }
    onActionClicked(actionKey) {
        this.actionClicked.emit({ value: actionKey, checkedItems: this.pickupSelection.selected });
        const action = this.listProperties.actions.find(action => action.value === actionKey);
        if (action && action.clearPickupOnAction) {
            this.pickupSelection.clear();
            this.currentPageSelectedCount = 0;
        }
    }
    onClearCheckedItems() {
        this.pickupSelection.clear();
        this.currentPageSelectedCount = 0;
    }
    isNoPagination() {
        return (!this.listProperties || !this.listProperties.pagination || !this.listProperties.pagination.totalItemsCount || this.listProperties.pagination.totalItemsCount === 0);
    }
    toggleSelection(arr, row) {
        const index = this.isSelected(arr.selected, row);
        if (index !== -1) {
            arr.deselect(arr.selected[index]);
            return false;
        }
        arr.select(row);
        return true;
    }
    isSelected(arr, row) {
        return arr.findIndex(CurRow => CurRow.id === row.id);
    }
    hasCheckIcon(row) {
        if (row.hasOwnProperty('hasCheckIcon')) {
            return row['hasCheckIcon'];
        }
        else {
            return false;
        }
    }
    onLinkClicked(row) {
        this.linkClicked.emit(row);
        return false;
    }
    get isLoading() {
        return this.listProperties.isLoading || this.isFetchingColumnsCustomization;
    }
    dropCol(event) {
        moveItemInArray(this.displayedColumns, event.previousIndex + this.nonUserColumnsCount, event.currentIndex + this.nonUserColumnsCount);
        this.displayedColumns.forEach((col, index) => {
            this.columnsCustomization[col].order = index;
        });
        this.schema['columns'].sort((a, b) => {
            return this.columnsCustomization[a.columnIdentifier].order - this.columnsCustomization[b.columnIdentifier].order;
        });
        this.schema['columns'] = [...this.schema['columns']];
        this.columnsCustomizationChange.emit(this.columnsCustomization);
        this.spaceClickedIndex = event.currentIndex;
    }
    dropRow(event) {
        this.rowDragged.emit({ currentIndex: event.currentIndex, previousIndex: event.previousIndex });
    }
    dragActionClicked(key, index) {
        this.rowDragged.emit({ currentIndex: key, previousIndex: index });
    }
    dragSpaceClikced(isSpaceClicked, index) {
        if (isSpaceClicked) {
            this.spaceClickedIndex = index;
        }
        else {
            this.spaceClickedIndex = -1;
        }
    }
    setDragActions() {
        if (this.isNoPagination()) {
            this.dragActions = [];
            return;
        }
        this.dragActions = [{
                label: this.translate.instant('ng.general.move-to-first-page'),
                key: 'first',
                disabled: !this.hasPrevPage(),
                loading: false
            }, {
                label: this.translate.instant('ng.general.move-to-previous-page'),
                key: 'previous',
                disabled: !this.hasPrevPage(),
                loading: false
            }, {
                label: this.translate.instant('ng.general.move-to-next-page'),
                key: 'next',
                disabled: !this.hasNextPage(),
                loading: false
            }, {
                label: this.translate.instant('ng.general.move-to-last-page'),
                key: 'last',
                disabled: !this.hasNextPage(),
                loading: false
            }];
    }
    blured() {
        this.spaceClickedIndex = -1;
    }
    addEntry() {
        this.addClicked.emit();
        this.isNew = true;
        this.isNewChange.emit(this.isNew);
        this.selectedItem = this.data.length - 1;
        this.selectedItemObject = this.data[this.data.length - 1];
        this.editMode = true;
        this.editModeChange.emit(true);
        this.editIndex = this.data.length - 1;
    }
    onCloseClicked() {
        if (this.isNew) {
            let selectedRow = this.selectedItemObject;
            selectedRow.index = this.selectedItem;
            //this.cardDeleted.emit(this.data.length - 1);
            this.rowActionClicked.emit({ row: selectedRow, actionKey: 'remove' });
            this.isNew = false;
            this.editIndex = -1;
        }
    }
    get isReadOnly() {
        return this.readOnly || (this._sectionsLayoutViewModeValue);
    }
    static { this.ɵfac = function ExGridLayoutComponent_Factory(t) { return new (t || ExGridLayoutComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExGridLayoutComponent, selectors: [["ex-grid-layout"]], viewQuery: function ExGridLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$s, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItemRef = _t);
        } }, hostBindings: function ExGridLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("keydown", function ExGridLayoutComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { selectedItem: "selectedItem", dataType: "dataType", data: "data", listProperties: "listProperties", dragColumnWidth: "dragColumnWidth", indexColumnWidth: "indexColumnWidth", pickupColumnWidth: "pickupColumnWidth", checkIconColumnWidth: "checkIconColumnWidth", rowActionColumnWidth: "rowActionColumnWidth", editContent: "editContent", internalEditTitle: "internalEditTitle", checkIconColumnLabel: "checkIconColumnLabel", indexColumnLabel: "indexColumnLabel", checkIconColumnIconColor: "checkIconColumnIconColor", iconColumnIconColor: "iconColumnIconColor", isPageGrid: "isPageGrid", themeHeader: "themeHeader", responsiveHeader: "responsiveHeader", clearAllSubject: "clearAllSubject", internalEditMode: "internalEditMode", editMode: "editMode", themeClass: "themeClass", toggleChanged: "toggleChanged", customizationComponent: "customizationComponent", columnsCustomization: "columnsCustomization", isCustomized: "isCustomized", isFetchingColumnsCustomization: "isFetchingColumnsCustomization", hideAddButton: "hideAddButton", addButtonLabel: "addButtonLabel", editTitleEdit: "editTitleEdit", editTitleNew: "editTitleNew", isNew: "isNew", gridId: "gridId", addButtonChildren: "addButtonChildren", readOnly: "readOnly" }, outputs: { selectedPageChange: "selectedPageChange", selectedItemChange: "selectedItemChange", pageSizeChange: "pageSizeChange", sortChange: "sortChange", searchChange: "searchChange", filterChange: "filterChange", actionClicked: "actionClicked", rowActionClicked: "rowActionClicked", rowSelected: "rowSelected", columnHeaderSortChange: "columnHeaderSortChange", rowActiveToggle: "rowActiveToggle", cellOutput: "cellOutput", selectedValueChange: "selectedValueChange", datesUpdated: "datesUpdated", clearDates: "clearDates", switchLayout: "switchLayout", linkClicked: "linkClicked", columnsCustomizationChange: "columnsCustomizationChange", defaultColumnsConfigurationChange: "defaultColumnsConfigurationChange", addClicked: "addClicked", cardDeleted: "cardDeleted", isNewChange: "isNewChange", editModeChange: "editModeChange", rowDragged: "rowDragged" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false },
                { provide: EX_IS_INSIDE_GRID, useValue: true }]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c16$2, decls: 2, vars: 2, consts: [["class", "ex-grid-layout-wrapper", 3, "snInViewport", 4, "ngIf"], ["class", "ex-grid-layout-add-button", 4, "ngIf"], [1, "ex-grid-layout-wrapper", 3, "snInViewport"], [1, "ex-grid-layout-header-wrapper", 3, "ngClass"], ["headerWrapper", ""], [3, "responsivenessActive", "actions", "sorts", "filters", "searchByFields", "hasSearch", "popUpActions", "hasPickupCount", "searchBySelectedField", "hasBottomBorder", "hasExport", "clearAllSubject", "numberOfCheckedItems", "showDateFilter", "filterMaxDate", "filterMinDate", "customizationComponent", "isCustomized", "actionClicked", "filterChange", "searchChange", "selectedValueChange", "sortChange", "clearCheckedItems", "datesUpdated", "clearDates", 4, "ngIf"], ["class", "ex-grid-layout-table-wrapper", 3, "ex-grid-layout-table-wrapper-border", "resized", 4, "ngIf"], [4, "ngIf"], [3, "responsivenessActive", "actions", "sorts", "filters", "searchByFields", "hasSearch", "popUpActions", "hasPickupCount", "searchBySelectedField", "hasBottomBorder", "hasExport", "clearAllSubject", "numberOfCheckedItems", "showDateFilter", "filterMaxDate", "filterMinDate", "customizationComponent", "isCustomized", "actionClicked", "filterChange", "searchChange", "selectedValueChange", "sortChange", "clearCheckedItems", "datesUpdated", "clearDates"], [1, "ex-grid-layout-table-wrapper", 3, "resized"], ["class", "ex-grid-layout-table-blocked", 4, "ngIf"], ["cellpadding", "0", "cellspacing", "0", 1, "mat-elevation-z8", "ex-grid-layout-table", "sel-grid-table", "ex-grid-layout-table-bottom-border", 3, "id"], ["exDragList", "", "cdkDropList", "", "cdkDropListOrientation", "horizontal", "class", "ex-grid-layout-table-header ex-grid-layout-header-text", 3, "cdkDropListData", "ngClass", "cdkDropListDropped", 4, "ngIf"], ["exDragList", "", "cdkDropList", "", 3, "cdkDropListData", "cdkDropListDropped", 4, "ngIf"], [3, "tableOutOfView", "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "showPageSize", "selectedPageChange", "pageSizeChange", 4, "ngIf"], [1, "ex-grid-layout-table-blocked"], ["exDragList", "", "cdkDropList", "", "cdkDropListOrientation", "horizontal", 1, "ex-grid-layout-table-header", "ex-grid-layout-header-text", 3, "cdkDropListData", "ngClass", "cdkDropListDropped"], ["identifier", "drag", "class", "ex-grid-layout-index-column ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "index", "class", "ex-grid-layout-index-column ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "pickup", "class", "ex-grid-layout-checkbox ex-grid-layout-header-text ex-grid-layout-no-left-padding ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "checkIcon", "class", "ex-grid-layout-header-text ex-grid-layout-no-left-padding ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["identifier", "rowActions", "class", "ex-grid-layout-no-left-padding ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "drag", 1, "ex-grid-layout-index-column", "ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], ["identifier", "index", 1, "ex-grid-layout-index-column", "ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], ["identifier", "pickup", 1, "ex-grid-layout-checkbox", "ex-grid-layout-header-text", "ex-grid-layout-no-left-padding", "ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], [1, "ex-grid-layout-flex-centered"], [3, "checked", "indeterminate", "ariaLabel", "uniqueSelector", "checkboxChange"], ["identifier", "checkIcon", 1, "ex-grid-layout-header-text", "ex-grid-layout-no-left-padding", "ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], [1, "group-inline", 3, "exTooltip"], [1, "inline-block"], ["cdkDrag", "", "cdkDragLockAxis", "x", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "class", "ngClass", "cdkDragStarted", "cdkDragEnded", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["cdkDrag", "", "cdkDragLockAxis", "x", 3, "exResizeColumn", "orderedColumns", "identifier", "columnsCustomization", "ngClass", "cdkDragStarted", "cdkDragEnded", "columnsCustomizationChange", "customizationFinished"], [3, "exTooltip", "ngClass"], [1, "group-inline", 3, "ngClass", "click"], ["class", "sel-grid-column-sort uxf-icon headerSortIcon ex-grid-layout-sort-icon", "tabindex", "0", "role", "button", 3, "ngClass", "keydown.Enter", 4, "ngIf"], ["class", "inline-block", "tabindex", "0", 3, "exDrag", "spaceClicked", "blured", 4, "ngIf"], [3, "ngClass", "width", 4, "cdkDragPreview"], ["class", "ex-grid-layout-custom-placeholder", 3, "ngClass", 4, "cdkDragPlaceholder"], ["tabindex", "0", "role", "button", 1, "sel-grid-column-sort", "uxf-icon", "headerSortIcon", "ex-grid-layout-sort-icon", 3, "ngClass", "keydown.Enter"], ["tabindex", "0", 1, "inline-block", 3, "exDrag", "spaceClicked", "blured"], [3, "ngClass"], ["class", "ex-grid-layout-header-text ex-grid-layout-header-dragable ex-grid-layout-th ex-grid-layout-drag-preview", 3, "ngClass", 4, "ngIf"], [1, "ex-grid-layout-header-text", "ex-grid-layout-header-dragable", "ex-grid-layout-th", "ex-grid-layout-drag-preview", 3, "ngClass"], [1, "ex-grid-layout-custom-placeholder", 3, "ngClass"], ["identifier", "rowActions", 1, "ex-grid-layout-no-left-padding", "ex-grid-layout-th", 3, "exResizeColumn", "orderedColumns", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], ["exDragList", "", "cdkDropList", "", 3, "cdkDropListData", "cdkDropListDropped"], [3, "actions", "actionClicked", "copyCellClicked"], [3, "ngTemplateOutlet"], ["rowsTemplate", ""], ["cdkDrag", "", 1, "ex-grid-layout-row", 3, "cdkDragDisabled", "ngClass", "click"], ["rowItemRef", ""], ["identifier", "drag", "class", "ex-grid-layout-index-column\n      ex-grid-layout-no-border-bottom inline-cell ex-grid-layout-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "index", "class", "ex-grid-layout-index-column\n          ex-grid-layout-no-border-bottom inline-cell ex-grid-layout-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "pickup", "class", "ex-grid-layout-cell", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "checkIcon", "class", "ex-grid-layout-cell ex-grid-layout-no-left-padding", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "rowActions", "class", "ex-grid-layout-cell ex-grid-layout-no-side-padding", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], ["identifier", "drag", 1, "ex-grid-layout-index-column", "ex-grid-layout-no-border-bottom", "inline-cell", "ex-grid-layout-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [3, "actions", "actionClicked"], ["cdkDragHandle", ""], ["identifier", "index", 1, "ex-grid-layout-index-column", "ex-grid-layout-no-border-bottom", "inline-cell", "ex-grid-layout-index-column", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["identifier", "pickup", 1, "ex-grid-layout-cell", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [3, "checked", "ariaLabel", "uniqueSelector", "click", "checkboxChange"], ["identifier", "checkIcon", 1, "ex-grid-layout-cell", "ex-grid-layout-no-left-padding", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], ["class", "ex-grid-check-icon", "iconType", "uxf", "iconName", "uxf-check", "sizePx", "16px", 3, "color", 4, "ngIf"], ["iconType", "uxf", "iconName", "uxf-check", "sizePx", "16px", 1, "ex-grid-check-icon", 3, "color"], [3, "exResizeColumn", "isFocusable", "orderedColumns", "identifier", "columnsCustomization", "class", "ngClass", "columnsCustomizationChange", "customizationFinished", 4, "ngIf"], [3, "exResizeColumn", "isFocusable", "orderedColumns", "identifier", "columnsCustomization", "ngClass", "columnsCustomizationChange", "customizationFinished"], [1, "display-content", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["simpleColumn", ""], [3, "componentFactoryItem", "data", "events"], ["class", "ex-grid-layout-flex-centered ", 4, "ngIf", "ngIfElse"], ["toggle", ""], ["link", ""], ["text", ""], ["sizePx", "16px", 1, "ex-grid-icon", 3, "iconType", "iconName", "color"], ["class", "ex-grid-layout-flex-centered", 4, "ngIf", "ngIfElse"], [1, "ex-grid-layout-toggle", 3, "toggleChecked", "uniqueSelector", "click", "toggleCheckedChange"], [3, "arguments", "linkClicked"], [1, "inline-cell", 3, "exTooltip"], ["identifier", "rowActions", 1, "ex-grid-layout-cell", "ex-grid-layout-no-side-padding", 3, "exResizeColumn", "isFocusable", "orderedColumns", "columnsCustomization", "columnsCustomizationChange", "customizationFinished"], [3, "actions", "isSelected", "loading", "uniqueSelector", "actionClicked"], [1, "inline-edit-container"], [3, "editMode", "isSingleSave", "editTitle", "editTitleIcon", "uniqueSelector", "editModeChange", "closeClicked", 4, "ngIf"], [3, "editMode", "isSingleSave", "editTitle", "editTitleIcon", "uniqueSelector", "editModeChange", "closeClicked"], [4, "editModeComponent"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "tableOutOfView", "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "showPageSize", "selectedPageChange", "pageSizeChange"], [1, "mat-elevation-z8", "ex-grid-layout-table"], [1, "ex-grid-layout-animate", "sel-grid-tbody"], ["class", "ex-grid-layout-row br", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "ex-grid-layout-row", "br", 3, "ngClass"], [1, "ex-grid-layout-add-button"], ["type", "add", "iconSide", "left", 1, "add-button", 3, "children", "uniqueSelector", "click"]], template: function ExGridLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c15$2);
            i0.ɵɵtemplate(0, ExGridLayoutComponent_div_0_Template, 6, 6, "div", 0);
            i0.ɵɵtemplate(1, ExGridLayoutComponent_div_1_Template, 4, 5, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.schema && ctx.schema["columns"]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.hideAddButton);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExInViewportDirective, ExTooltipDirective, EditModeComponentDirective, ResizedDirective, ExActionMenuComponent, ExPaginationComponent, ExComponentLoaderComponent, ExListHeaderComponent, ExIconComponent, ExLinkComponent, ExInlineEditingComponent, ExButtonComponent, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, i15.CdkDragPreview, i15.CdkDragPlaceholder, ExDragAccessibleIconComponent, ExDragDirective, ExDragListDirective, ExCheckboxComponent, ExRightClickActionsComponent, ExSlideToggleComponent, ExResizeColumnDirective, i1$2.TranslatePipe, ExGenerateIdPipe, CustomBackgroundRowColorPipe], styles: [".ex-grid-layout-header-wrapper.ex-grid-layout-header-responsive[_ngcontent-%COMP%]{overflow:hidden}.ex-grid-layout-checkbox[_ngcontent-%COMP%]{z-index:100000000!important}.ex-grid-layout-table[_ngcontent-%COMP%]{border-collapse:separate;box-shadow:none!important;table-layout:fixed;overflow:auto}.ex-grid-layout-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{position:relative}.table-second-header[_ngcontent-%COMP%]{visibility:hidden;height:0px}.ex-grid-layout-table-wrapper[_ngcontent-%COMP%]{overflow:auto}.ex-grid-layout-spinner[_ngcontent-%COMP%]{top:50%;left:50%}.ex-grid-layout-no-side-padding[_ngcontent-%COMP%]{padding-right:0!important;padding-left:0!important}.display-content[_ngcontent-%COMP%]{display:contents}.group-inline[_ngcontent-%COMP%]{display:flex}.inline-block[_ngcontent-%COMP%]{white-space:nowrap;display:inline-block;text-overflow:ellipsis;overflow:hidden}.inline-cell[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden}.ex-grid-layout-cell[_ngcontent-%COMP%]{text-align:start;vertical-align:top;padding:10px;position:relative}.ex-grid-layout-no-margin[_ngcontent-%COMP%]{margin:0}.ex-grid-layout-sort-icon[_ngcontent-%COMP%]{margin-inline-end:0px;cursor:pointer}.ex-grid-layout-header-text[_ngcontent-%COMP%]{height:30px}.ex-grid-layout-sortable-header[_ngcontent-%COMP%]:hover{cursor:pointer;width:-moz-fit-content;width:fit-content}.ex-grid-layout-no-left-padding[_ngcontent-%COMP%]{padding-inline-start:0px!important}.ex-grid-layout-no-right-padding[_ngcontent-%COMP%]{padding-inline-end:0px!important}.ex-grid-layout-th[_ngcontent-%COMP%]{position:sticky;top:0;z-index:9;padding-inline-start:10px;border-bottom:2px solid #c5c7c6;height:50px}.ex-grid-layout-header-dragable[_ngcontent-%COMP%]{cursor:move}.ex-grid-layout-index-column[_ngcontent-%COMP%]{text-align:center;vertical-align:top;padding:10px!important;padding-inline-start:6px!important}.inline-edit-container[_ngcontent-%COMP%]     .ex-inline-editing-edit-mode{margin-top:3px!important;margin-bottom:3px!important}.ex-grid-layout-table-bottom-border[_ngcontent-%COMP%]{border-bottom:2px solid #c5c7c6}.ex-grid-layout-no-border-bottom[_ngcontent-%COMP%]{border-bottom:0}.ex-grid-layout-flex-centered[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-grid-layout-spinner[_ngcontent-%COMP%]{flex:1;display:flex;align-items:center;justify-content:center}.ex-grid-layout-wrapper[_ngcontent-%COMP%]{flex:1;display:grid;grid-template-rows:max-content 1fr}.ex-grid-layout-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 2s infinite linear;background:linear-gradient(135deg,#f3f5f4 49%,#fff9 50%,#f3f5f4 52%);background-size:200% 200%}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-grid-layout-even-row[_ngcontent-%COMP%]{background:#fff;border-inline-start-color:#fff}.ex-grid-layout-row[_ngcontent-%COMP%]{display:flex;height:min-content;min-height:42px}.ex-grid-layout-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-bar{transform:scale(.7)!important;margin-inline-end:0px!important;margin-inline-start:5px!important}.ex-grid-layout-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-grid-layout-toggle[_ngcontent-%COMP%]     .mat-slide-toggle-label{margin-bottom:0!important}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.ex-grid-layout-custom-placeholder[_ngcontent-%COMP%]{min-height:50px;transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box[_ngcontent-%COMP%]:last-child{border:none}.ex-grid-layout-drag-preview[_ngcontent-%COMP%]{display:flex;align-items:center;border:none!important;border-radius:3px;background:#fff}.ex-grid-layout-resize-holder[_ngcontent-%COMP%]{cursor:col-resize;width:10px;height:100%;position:absolute;top:0;z-index:1;margin-right:1px}.ex-grid-layout-resizing[_ngcontent-%COMP%]{cursor:col-resize!important}.ex-grid-layout-table-blocked[_ngcontent-%COMP%]{position:absolute;top:50px;left:0;height:calc(100% - 50px);width:100%;background:#fff;z-index:10000000;opacity:.5}.ex-grid-layout-drag-handle[_ngcontent-%COMP%]{cursor:move}.cdk-drag-preview.ex-grid-layout-row[_ngcontent-%COMP%]{background:#fff}.cdk-drag-preview.ex-grid-layout-odd-row[_ngcontent-%COMP%]:not(.ex-grid-layout-has-custom-background-color){background:#f3f5f4!important}.ex-grid-layout-add-button[_ngcontent-%COMP%]{margin-top:10px}.ex-grid-layout-right-click-actions[_ngcontent-%COMP%]{display:flex}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGridLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-grid-layout', providers: [{ provide: EX_QUICK_ACCESS_SCOPE, useValue: false },
                    { provide: EX_IS_INSIDE_GRID, useValue: true }], template: "<div *ngIf=\"schema && schema['columns']\" class=\"ex-grid-layout-wrapper\" (snInViewport)=\"tableViewChanged()\">\n  <div #headerWrapper class=\"ex-grid-layout-header-wrapper\"\n       [ngClass]=\"{ 'ex-grid-layout-header-responsive' : responsiveHeader }\">\n    <ex-list-header *ngIf=\"showListHeader\" [responsivenessActive]=\"responsiveHeader\" [actions]=\"listProperties.actions\"\n                    [sorts]=\"listProperties.showSortsInListHeader && listProperties.sorts\"\n                    [filters]=\"listProperties.filters\"\n                    [searchByFields]=\"listProperties.searchByFields\" [hasSearch]=\"listProperties.hasSearch\"\n                    [popUpActions]=\"listProperties.popUpActions\" [hasPickupCount]=\"listProperties.hasPickupCount\"\n                    [searchBySelectedField]=\"listProperties.searchBySelectedField\" [hasBottomBorder]=\"false\"\n                    (actionClicked)=\"onActionClicked($event)\" (filterChange)=\"filterChange.emit($event)\"\n                    (searchChange)=\"searchChange.emit($event)\" (selectedValueChange)=\"_searchFieldChange($event)\"\n                    (sortChange)=\"sortChange.emit($event)\"\n                    [hasExport]=\"listProperties.hasExport\"\n                    (clearCheckedItems)=\"onClearCheckedItems()\" [clearAllSubject]=\"clearAllSubject\"\n                    [numberOfCheckedItems]=\"pickupSelection.selected.length\"\n                    [showDateFilter]=\"listProperties.showDateFilter\"\n                    [filterMaxDate]=\"listProperties.filterMaxDate\" [filterMinDate]=\"listProperties.filterMinDate\"\n                    (datesUpdated)=\"_datesUpdated($event)\" (clearDates)=\"_clearDates()\"\n                    [customizationComponent]=\"customizationComponent\" [isCustomized]=\"isCustomized\">\n      <ng-content select=\"[header-0]\" header-slot-0></ng-content>\n      <ng-content select=\"[header-1]\" header-slot-1></ng-content>\n    </ex-list-header>\n  </div>\n\n  <div (resized)=\"onResized($event)\" *ngIf=\"!isLoading\" class=\"ex-grid-layout-table-wrapper\"\n       [class.ex-grid-layout-table-wrapper-border]=\"dataSource?.data?.length > 0\">\n    <div *ngIf=\"isDragging\" class=\"ex-grid-layout-table-blocked\"></div>\n\n\n    <table cellpadding=\"0\" cellspacing=\"0\" [id]=\"gridId\"\n           class=\"mat-elevation-z8 ex-grid-layout-table sel-grid-table ex-grid-layout-table-bottom-border\">\n      <tr *ngIf=\"listProperties.showGridHeader\" exDragList cdkDropList cdkDropListOrientation=\"horizontal\"\n          [cdkDropListData]=\"displayedColumns\" (cdkDropListDropped)=\"dropCol($event)\"\n          class=\"ex-grid-layout-table-header ex-grid-layout-header-text\"\n          [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader, 'ex-grid-layout-header-text-gray': !themeHeader, 'ex-grid-layout-not-page': !isPageGrid}\">\n        <th *ngIf=\"this.listProperties.hasDrag && !isReadOnly\" [exResizeColumn]=\"true\"\n            [orderedColumns]=\"displayedColumns\" identifier=\"drag\" [(columnsCustomization)]=\"columnsCustomization\"\n            (customizationFinished)=\"customizationFinished()\" [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader,\n  'ex-grid-layout-header-text-gray': !themeHeader,\n  'ex-grid-layout-not-page': !isPageGrid}\" class=\"ex-grid-layout-index-column ex-grid-layout-th\">\n        </th>\n        <th *ngIf=\"this.listProperties.hasIndex\" [exResizeColumn]=\"true\" [orderedColumns]=\"displayedColumns\"\n            identifier=\"index\" [(columnsCustomization)]=\"columnsCustomization\"\n            (customizationFinished)=\"customizationFinished()\" [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader,\n          'ex-grid-layout-header-text-gray': !themeHeader,\n          'ex-grid-layout-not-page': !isPageGrid}\" class=\"ex-grid-layout-index-column ex-grid-layout-th\">\n        </th>\n        <th *ngIf=\"this.listProperties.hasPickup\" [exResizeColumn]=\"false\" [orderedColumns]=\"displayedColumns\"\n            identifier=\"pickup\" [(columnsCustomization)]=\"columnsCustomization\"\n            (customizationFinished)=\"customizationFinished()\"\n            class=\"ex-grid-layout-checkbox ex-grid-layout-header-text ex-grid-layout-no-left-padding ex-grid-layout-th\"\n            [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader,\n          'ex-grid-layout-header-text-gray': !themeHeader,\n          'ex-grid-layout-not-page': !isPageGrid}\">\n          <div class=\"ex-grid-layout-flex-centered\">\n            <ex-checkbox (checkboxChange)=\"$event ? masterToggle() : null\"\n                         [checked]=\"currentPageSelectedCount > 0 && isAllSelected()\"\n                         [indeterminate]=\"currentPageSelectedCount > 0 && !isAllSelected()\"\n                         [ariaLabel]=\"'ng.ex-list-header-check-all' | translate\"\n                         [uniqueSelector]=\"'ex-grid-layout-check-all-' + gridId\">\n            </ex-checkbox>\n          </div>\n        </th>\n\n        <th *ngIf=\"this.listProperties.hasCheckIcon\" [exResizeColumn]=\"true\" [orderedColumns]=\"displayedColumns\"\n            identifier=\"checkIcon\" [(columnsCustomization)]=\"columnsCustomization\"\n            (customizationFinished)=\"customizationFinished()\"\n            class=\"ex-grid-layout-header-text ex-grid-layout-no-left-padding ex-grid-layout-th\"\n            [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader, 'ex-grid-layout-header-text-gray': !themeHeader, 'ex-grid-layout-not-page': !isPageGrid }\">\n          <span class=\"group-inline\" [exTooltip]=\"checkIconColumnLabel | translate\">\n            <div class=\"inline-block\">\n              {{ checkIconColumnLabel | translate }}\n            </div>\n          </span>\n        </th>\n\n        <ng-container *ngFor=\"let column of schema['columns']; let i = index\">\n          <th *ngIf=\"displayedColumns.includes(column.columnIdentifier)\" cdkDrag cdkDragLockAxis=\"x\"\n              (cdkDragStarted)=\"isDragging = true\" (cdkDragEnded)=\"isDragging = false\" [exResizeColumn]=\"true\"\n              [orderedColumns]=\"displayedColumns\" [identifier]=\"column.columnIdentifier\"\n              [(columnsCustomization)]=\"columnsCustomization\" (customizationFinished)=\"customizationFinished()\"\n              class=\"{{ 'sel-grid-header-' + column.columnIdentifier }} ex-grid-layout-header-text ex-grid-layout-header-dragable ex-grid-layout-th\"\n              [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader, 'ex-grid-layout-header-text-gray': !themeHeader, 'ex-grid-layout-not-page': !isPageGrid,\n            'ex-grid-layout-no-left-padding': column.isIconColumn || column.isToggleColumn, 'ex-grid-layout-space-clicked': spaceClickedIndex === i }\">\n            <div [exTooltip]=\"column.customTooltip || column.label | translate\"\n                 [ngClass]=\"{'ex-grid-layout-flex-centered': column.centered && column.centered === true}\">\n              <span class=\"group-inline\" [ngClass]=\"{'ex-grid-layout-sortable-header': column.sortable=== true}\"\n                    (click)=\"column.sortable ? onHeaderClicked(column) : $event.stopPropagation()\">\n                <span *ngIf=\"column.sortable=== true\"\n                      class=\"sel-grid-column-sort uxf-icon headerSortIcon ex-grid-layout-sort-icon\"\n                      [ngClass]=\"{'uxf-arrow-combo': column.sorted === 'none', 'uxf-down-caret': column.sorted === 'desc', 'uxf-up-caret': column.sorted === 'asc'}\"\n                      [attr.aria-label]=\"'ng.general.sort-tooltip' | translate: { columnName: (column.label | translate) }\"\n                      tabindex=\"0\" (keydown.Enter)=\"onHeaderClicked(column)\" role=\"button\">\n                </span>\n                <div *ngIf=\"column.displayLabelInHeader\" [exDrag]=\"true\" (spaceClicked)=\"dragSpaceClikced($event, i)\"\n                     (blured)=\"blured()\" class=\"inline-block\" tabindex=\"0\">\n                  {{ column.label | translate }}</div>\n              </span>\n            </div>\n            <div *cdkDragPreview [ngClass]=\"themeClass\"\n                 [style.width.px]=\"columnsCustomization[column.columnIdentifier]?.width\">\n              <div *ngIf=\"column.displayLabelInHeader\"\n                   class=\"ex-grid-layout-header-text ex-grid-layout-header-dragable ex-grid-layout-th ex-grid-layout-drag-preview\"\n                   [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader, 'ex-grid-layout-header-text-gray': !themeHeader, 'ex-grid-layout-not-page': !isPageGrid,\n              'ex-grid-layout-no-left-padding': column.isIconColumn || column.isToggleColumn }\">\n                {{ column.label | translate }}</div>\n            </div>\n            <div *cdkDragPlaceholder class=\"ex-grid-layout-custom-placeholder\"\n                 [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader, 'ex-grid-layout-header-text-gray': !themeHeader, 'ex-grid-layout-not-page': !isPageGrid }\">\n            </div>\n          </th>\n        </ng-container>\n        <th *ngIf=\"this.schema.rowActions?.length > 0\" [exResizeColumn]=\"true\" [orderedColumns]=\"displayedColumns\"\n            identifier=\"rowActions\" [(columnsCustomization)]=\"columnsCustomization\"\n            (customizationFinished)=\"customizationFinished()\" class=\"ex-grid-layout-no-left-padding ex-grid-layout-th\"\n            [ngClass]=\"{'ex-grid-layout-header-text-theme': themeHeader,\n          'ex-grid-layout-header-text-gray': !themeHeader,\n          'ex-grid-layout-not-page': !isPageGrid}\">\n        </th>\n      </tr>\n\n      <tbody *ngIf=\"!isLoading && data && data.length > 0 && dataSource?.data\" exDragList cdkDropList\n             [cdkDropListData]=\"dataSource.data\" (cdkDropListDropped)=\"dropRow($event)\">\n      <ng-container *ngFor=\"let row of dataSource.data; let rowIndex = index\">\n\n        <ex-right-click-actions class=\"ex-grid-layout-right-click-actions {{ ('ex-grid-layout-right-click-actions-' + gridId) | generateHTMLId }}\"\n                                [actions]=\"addCopyCellValueAction(row.rowActions && row.rowActions.length > 0 ? getVisibleActions(row.rowActions, rowIndex) : [])\"\n                                (actionClicked)=\"onRowActionClicked(row, dataSource.data.indexOf(row), $event)\"\n                                (copyCellClicked)=\"onCopyCellClicked($event)\">\n          <ng-container [ngTemplateOutlet]=\"rowsTemplate\">\n          </ng-container>\n        </ex-right-click-actions>\n\n        <ng-template #rowsTemplate>\n          <tr #rowItemRef cdkDrag [cdkDragDisabled]=\"!listProperties.hasDrag || isReadOnly\" class=\"ex-grid-layout-row\"\n              [ngClass]=\"{'ex-grid-layout-odd-row': (dataSource.data.indexOf(row)) % 2 === 0,\n                          'ex-grid-layout-selected-row' : selectedItem === dataSource.data.indexOf(row),\n                          'ex-grid-layout-has-custom-background-color': !!(row | customBackgroundRowColor)}\"\n              [style.background-color]=\"row | customBackgroundRowColor\"\n              (click)=\"onRowSelected(dataSource.data.indexOf(row))\">\n            <td *ngIf=\"this.listProperties.hasDrag && !isReadOnly\" [exResizeColumn]=\"true\" [isFocusable]=\"true\"\n                [orderedColumns]=\"displayedColumns\" identifier=\"drag\" [(columnsCustomization)]=\"columnsCustomization\"\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-grid-layout-index-column\n      ex-grid-layout-no-border-bottom inline-cell ex-grid-layout-index-column\">\n              <ex-right-click-actions class=\"{{ ('ex-grid-layout-right-click-actions-drag-' + gridId) | generateHTMLId }}\" [actions]=\"dragActions\" (actionClicked)=\"dragActionClicked($event, rowIndex)\">\n                <ex-drag-accessible-icon class=\"ex-grid-layout-drag-handle {{ ('ex-grid-layout-drag-handle-' + gridId) | generateHTMLId }}\" cdkDragHandle></ex-drag-accessible-icon>\n              </ex-right-click-actions>\n            </td>\n            <td *ngIf=\"this.listProperties.hasIndex\" [exResizeColumn]=\"true\" [isFocusable]=\"true\"\n                [orderedColumns]=\"displayedColumns\" identifier=\"index\" [(columnsCustomization)]=\"columnsCustomization\"\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-grid-layout-index-column\n          ex-grid-layout-no-border-bottom inline-cell ex-grid-layout-index-column\">\n              {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) +\n              dataSource.data.indexOf(row) + 1) }}\n            </td>\n            <td *ngIf=\"this.listProperties.hasPickup\" [exResizeColumn]=\"false\" [isFocusable]=\"false\"\n                [orderedColumns]=\"displayedColumns\" identifier=\"pickup\" [(columnsCustomization)]=\"columnsCustomization\"\n                (customizationFinished)=\"customizationFinished()\" class=\"ex-grid-layout-cell\">\n              <div class=\"ex-grid-layout-flex-centered\">\n                <ex-checkbox (click)=\"$event.stopPropagation()\"\n                             (checkboxChange)=\"$event ? onRowPickupToggle(row) : null\"\n                             [checked]=\"isSelected(pickupSelection.selected, row) !== -1\"\n                             [ariaLabel]=\"'ng.ex_items_layout_list_row.check_or_uncheck' | translate\" [uniqueSelector]=\"'ex-grid-layout-check-or-uncheck-' + gridId\">\n                </ex-checkbox>\n              </div>\n            </td>\n            <td *ngIf=\"this.listProperties.hasCheckIcon\" [exResizeColumn]=\"true\" [isFocusable]=\"true\"\n                [orderedColumns]=\"displayedColumns\" identifier=\"checkIcon\"\n                [(columnsCustomization)]=\"columnsCustomization\" (customizationFinished)=\"customizationFinished()\"\n                class=\"ex-grid-layout-cell ex-grid-layout-no-left-padding\">\n              <div class=\"ex-grid-layout-flex-centered \">\n                <ex-icon *ngIf=\"hasCheckIcon(row)\" class=\"ex-grid-check-icon\" iconType=\"uxf\" iconName=\"uxf-check\"\n                         sizePx=\"16px\" [color]=\"checkIconColumnIconColor\"></ex-icon>\n              </div>\n            </td>\n\n            <ng-container *ngFor=\"let column of schema['columns']; let i = index\">\n              <td *ngIf=\"displayedColumns.includes(column.columnIdentifier)\" [exResizeColumn]=\"true\"\n                  [isFocusable]=\"true\" [orderedColumns]=\"displayedColumns\" [identifier]=\"column.columnIdentifier\"\n                  [(columnsCustomization)]=\"columnsCustomization\" (customizationFinished)=\"customizationFinished()\"\n                  class=\"{{ 'sel-grid-body-' + column.columnIdentifier }} ex-grid-layout-cell inline-cell\"\n                  [ngClass]=\"{'ex-grid-layout-no-left-padding': column.isIconColumn || column.isToggleColumn}\">\n                <div class=\"display-content\"\n                     [ngClass]=\"{'ex-grid-layout-flex-centered': column.centered && column.centered === true}\">\n                  <ng-container *ngIf=\"row[column.columnIdentifier+'ComponentRef']; else simpleColumn\">\n                    <ex-component-loader [componentFactoryItem]=\"row[column.columnIdentifier+'ComponentRef']\" [data]=\"row[column.columnIdentifier+'ComponentRef'].data.inputs?\n                                  row[column.columnIdentifier+'ComponentRef'].data.inputs:\n                                  row[column.columnIdentifier+'ComponentRef'].data\"\n                                         [events]=\"row[column.columnIdentifier+'ComponentRef'].data.events\"></ex-component-loader>\n                  </ng-container>\n                  <ng-template #simpleColumn>\n                    <div *ngIf=\"column.isIconColumn; else toggle \" class=\"ex-grid-layout-flex-centered \">\n                      <ex-icon class=\"ex-grid-icon\" [iconType]=\"column.iconType ? column.iconType : 'uxf'\"\n                               [iconName]=\"row[column.columnIdentifier]\" sizePx=\"16px\" [color]=\"iconColumnIconColor\">\n                      </ex-icon>\n                    </div>\n                    <ng-template #toggle>\n                      <ng-container *ngIf=\"column.isToggleColumn; else link\" class=\"ex-grid-layout-flex-centered\">\n                        <ex-slide-toggle (click)=\"$event.stopPropagation()\"\n                                         class=\"ex-grid-layout-toggle\"\n                                         (toggleCheckedChange)=\"onRowActiveToggle(row)\"\n                                         [toggleChecked]=\"isSelected(activeSelection.selected, row) !== -1\"\n                                         [uniqueSelector]=\"'ex-grid-layout-toggle-' + gridId\"></ex-slide-toggle>\n                      </ng-container>\n                    </ng-template>\n                    <ng-template #link>\n                      <ng-container *ngIf=\"column.isLinkColumn; else text\" class=\"ex-grid-layout-flex-centered\">\n                        <ex-link [arguments]=\"row[column.columnIdentifier]\" (linkClicked)=\"onLinkClicked(row)\">\n                        </ex-link>\n                      </ng-container>\n                    </ng-template>\n                    <ng-template #text>\n                      <div class=\"inline-cell\" [exTooltip]=\"row[column.columnIdentifier] | translate\">\n                        {{row[column.columnIdentifier] | translate }}\n                      </div>\n                    </ng-template>\n                  </ng-template>\n                </div>\n              </td>\n            </ng-container>\n            <td *ngIf=\"this.schema.rowActions?.length > 0\" [exResizeColumn]=\"true\" [isFocusable]=\"true\"\n                [orderedColumns]=\"displayedColumns\" identifier=\"rowActions\"\n                [(columnsCustomization)]=\"columnsCustomization\" (customizationFinished)=\"customizationFinished()\"\n                class=\"ex-grid-layout-cell ex-grid-layout-no-side-padding\">\n              <ng-container *ngIf=\"row.rowActions && row.rowActions.length > 0 \">\n                <ex-action-menu [actions]=\"getVisibleActions(row.rowActions, rowIndex)\"\n                                [isSelected]=\"selectedItem === dataSource.data.indexOf(row)\"\n                                [loading]=\"loadingMap[rowIndex]\"\n                                (actionClicked)=\"onRowActionClicked(row, dataSource.data.indexOf(row), $event)\"\n                                [uniqueSelector]=\"'ex-grid-layout-' + gridId\">\n                </ex-action-menu>\n              </ng-container>\n            </td>\n          </tr>\n        </ng-template>\n        <tr *ngIf=\"this.editIndex === rowIndex\">\n          <td [attr.colspan]=\"displayedColumns.length\">\n            <div class=\"inline-edit-container\">\n              <ex-inline-editing *ngIf=\"editMode\" [(editMode)]=\"editMode\" [isSingleSave]=\"false\"\n                                 [editTitle]=\"isNew ? editTitleNew : editTitleEdit\"\n                                 [editTitleIcon]=\"{ 'name': !isNew ? 'uxf-pencil' : 'uxf-plus-circle', 'type': 'uxf' }\"\n                                 (closeClicked)=\"onCloseClicked()\"\n                                 [uniqueSelector]=\"'ex-grid-layout-' + gridId\">\n                <ng-container *editModeComponent>\n                  <ng-container\n                    *ngTemplateOutlet=\"editContent; context: { $implicit: selectedItemObject, index: selectedItem, closeForm: closeForm.bind(this) }\">\n                  </ng-container>\n                </ng-container>\n              </ex-inline-editing>\n            </div>\n          </td>\n        </tr>\n\n      </ng-container>\n      </tbody>\n    </table>\n\n    <ng-content select=\"[footer]\"></ng-content>\n\n    <ex-pagination *ngIf=\"listProperties.pagination.totalItemsCount > 0\" [tableOutOfView]=\"tableOutOfView\"\n                   [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\n                   [pageSize]=\"listProperties.pagination.pageSize\"\n                   [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\n                   [selectedPage]=\"listProperties.pagination.selectedPage\"\n                   (selectedPageChange)=\"onSelectedPageChange($event)\"\n                   (pageSizeChange)=\"onpageSizeChange($event)\" [showPageSize]=\"listProperties.pagination.showPageSize\">\n    </ex-pagination>\n  </div>\n\n  <div *ngIf=\"isLoading\">\n    <table class=\"mat-elevation-z8 ex-grid-layout-table\">\n      <tbody class=\"ex-grid-layout-animate sel-grid-tbody\">\n      <tr *ngFor=\"let dummy of ' '.repeat(listProperties.pagination.pageSize).split(''), let x = index\"\n          class=\"ex-grid-layout-row br\" [ngClass]=\"{'ex-grid-layout-even-row': x % 2 === 1}\">\n        <td></td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n</div>\n\n<div *ngIf=\"!hideAddButton\" class=\"ex-grid-layout-add-button\">\n  <ex-button class=\"add-button\" type=\"add\" iconSide=\"left\" [children]=\"addButtonChildren\" [uniqueSelector]=\"'ex-grid-layout-add-button-' + gridId\" (click)=\"addEntry()\">\n    {{ addButtonLabel | translate }}\n  </ex-button>\n</div>\n", styles: [".ex-grid-layout-header-wrapper.ex-grid-layout-header-responsive{overflow:hidden}.ex-grid-layout-checkbox{z-index:100000000!important}.ex-grid-layout-table{border-collapse:separate;box-shadow:none!important;table-layout:fixed;overflow:auto}.ex-grid-layout-table td{position:relative}.table-second-header{visibility:hidden;height:0px}.ex-grid-layout-table-wrapper{overflow:auto}.ex-grid-layout-spinner{top:50%;left:50%}.ex-grid-layout-no-side-padding{padding-right:0!important;padding-left:0!important}.display-content{display:contents}.group-inline{display:flex}.inline-block{white-space:nowrap;display:inline-block;text-overflow:ellipsis;overflow:hidden}.inline-cell{text-overflow:ellipsis;overflow:hidden}.ex-grid-layout-cell{text-align:start;vertical-align:top;padding:10px;position:relative}.ex-grid-layout-no-margin{margin:0}.ex-grid-layout-sort-icon{margin-inline-end:0px;cursor:pointer}.ex-grid-layout-header-text{height:30px}.ex-grid-layout-sortable-header:hover{cursor:pointer;width:-moz-fit-content;width:fit-content}.ex-grid-layout-no-left-padding{padding-inline-start:0px!important}.ex-grid-layout-no-right-padding{padding-inline-end:0px!important}.ex-grid-layout-th{position:sticky;top:0;z-index:9;padding-inline-start:10px;border-bottom:2px solid #c5c7c6;height:50px}.ex-grid-layout-header-dragable{cursor:move}.ex-grid-layout-index-column{text-align:center;vertical-align:top;padding:10px!important;padding-inline-start:6px!important}.inline-edit-container ::ng-deep .ex-inline-editing-edit-mode{margin-top:3px!important;margin-bottom:3px!important}.ex-grid-layout-table-bottom-border{border-bottom:2px solid #c5c7c6}.ex-grid-layout-no-border-bottom{border-bottom:0}.ex-grid-layout-flex-centered{display:flex;justify-content:center}.ex-grid-layout-spinner{flex:1;display:flex;align-items:center;justify-content:center}.ex-grid-layout-wrapper{flex:1;display:grid;grid-template-rows:max-content 1fr}.ex-grid-layout-animate{animation:shimmer 2s infinite linear;background:linear-gradient(135deg,#f3f5f4 49%,#fff9 50%,#f3f5f4 52%);background-size:200% 200%}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-grid-layout-even-row{background:#fff;border-inline-start-color:#fff}.ex-grid-layout-row{display:flex;height:min-content;min-height:42px}.ex-grid-layout-toggle ::ng-deep .mat-slide-toggle-bar{transform:scale(.7)!important;margin-inline-end:0px!important;margin-inline-start:5px!important}.ex-grid-layout-toggle ::ng-deep .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-grid-layout-toggle ::ng-deep .mat-slide-toggle-label{margin-bottom:0!important}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.ex-grid-layout-custom-placeholder{min-height:50px;transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box:last-child{border:none}.ex-grid-layout-drag-preview{display:flex;align-items:center;border:none!important;border-radius:3px;background:#fff}.ex-grid-layout-resize-holder{cursor:col-resize;width:10px;height:100%;position:absolute;top:0;z-index:1;margin-right:1px}.ex-grid-layout-resizing{cursor:col-resize!important}.ex-grid-layout-table-blocked{position:absolute;top:50px;left:0;height:calc(100% - 50px);width:100%;background:#fff;z-index:10000000;opacity:.5}.ex-grid-layout-drag-handle{cursor:move}.cdk-drag-preview.ex-grid-layout-row{background:#fff}.cdk-drag-preview.ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#f3f5f4!important}.ex-grid-layout-add-button{margin-top:10px}.ex-grid-layout-right-click-actions{display:flex}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }]; }, { selectedItem: [{
            type: Input
        }], dataType: [{
            type: Input
        }], data: [{
            type: Input
        }], listProperties: [{
            type: Input
        }], dragColumnWidth: [{
            type: Input
        }], indexColumnWidth: [{
            type: Input
        }], pickupColumnWidth: [{
            type: Input
        }], checkIconColumnWidth: [{
            type: Input
        }], rowActionColumnWidth: [{
            type: Input
        }], editContent: [{
            type: Input
        }], internalEditTitle: [{
            type: Input
        }], checkIconColumnLabel: [{
            type: Input
        }], indexColumnLabel: [{
            type: Input
        }], checkIconColumnIconColor: [{
            type: Input
        }], iconColumnIconColor: [{
            type: Input
        }], isPageGrid: [{
            type: Input
        }], themeHeader: [{
            type: Input
        }], responsiveHeader: [{
            type: Input
        }], clearAllSubject: [{
            type: Input
        }], internalEditMode: [{
            type: Input
        }], editMode: [{
            type: Input
        }], themeClass: [{
            type: Input
        }], toggleChanged: [{
            type: Input
        }], customizationComponent: [{
            type: Input
        }], columnsCustomization: [{
            type: Input
        }], isCustomized: [{
            type: Input
        }], isFetchingColumnsCustomization: [{
            type: Input
        }], hideAddButton: [{
            type: Input
        }], addButtonLabel: [{
            type: Input
        }], editTitleEdit: [{
            type: Input
        }], editTitleNew: [{
            type: Input
        }], isNew: [{
            type: Input
        }], gridId: [{
            type: Input
        }], addButtonChildren: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], selectedPageChange: [{
            type: Output
        }], selectedItemChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], rowActionClicked: [{
            type: Output
        }], rowSelected: [{
            type: Output
        }], columnHeaderSortChange: [{
            type: Output
        }], rowActiveToggle: [{
            type: Output
        }], cellOutput: [{
            type: Output
        }], selectedValueChange: [{
            type: Output
        }], datesUpdated: [{
            type: Output
        }], clearDates: [{
            type: Output
        }], switchLayout: [{
            type: Output
        }], linkClicked: [{
            type: Output
        }], columnsCustomizationChange: [{
            type: Output
        }], defaultColumnsConfigurationChange: [{
            type: Output
        }], addClicked: [{
            type: Output
        }], cardDeleted: [{
            type: Output
        }], isNewChange: [{
            type: Output
        }], editModeChange: [{
            type: Output
        }], rowDragged: [{
            type: Output
        }], rowItemRef: [{
            type: ViewChildren,
            args: ['rowItemRef']
        }], handleKeyboardEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();

class ExGridLayoutModule {
    static { this.ɵfac = function ExGridLayoutModule_Factory(t) { return new (t || ExGridLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExGridLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatCheckboxModule,
            MatSlideToggleModule,
            MatTableModule,
            MatTooltipModule,
            CdkTableModule,
            ExDirectivesModule,
            ExActionMenuModule,
            ExActionIconMenuModule,
            ExSpinnerModule,
            ExPaginationModule,
            ExComponentLoaderModule,
            ExListHeaderModule,
            TranslateModule,
            ExIconModule,
            ExLinkModule,
            ExInlineEditingModule,
            ExButtonModule,
            ExIconModule,
            AngularResizeEventModule,
            DragDropModule,
            ExDragModule,
            ExCheckboxModule,
            MatTooltipModule,
            ExRightClickActionsModule,
            ExInlineEditingButtonsModule,
            ExSlideToggleModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGridLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatCheckboxModule,
                    MatSlideToggleModule,
                    MatTableModule,
                    MatTooltipModule,
                    CdkTableModule,
                    ExDirectivesModule,
                    ExActionMenuModule,
                    ExActionIconMenuModule,
                    ExSpinnerModule,
                    ExPaginationModule,
                    ExComponentLoaderModule,
                    ExListHeaderModule,
                    TranslateModule,
                    ExIconModule,
                    ExLinkModule,
                    ExInlineEditingModule,
                    ExButtonModule,
                    ExIconModule,
                    AngularResizeEventModule,
                    DragDropModule,
                    ExDragModule,
                    ExCheckboxModule,
                    MatTooltipModule,
                    ExRightClickActionsModule,
                    ExInlineEditingButtonsModule,
                    ExSlideToggleModule,
                    EXPipesModule
                ],
                declarations: [
                    ExGridLayoutComponent,
                    ExResizeColumnDirective,
                    CustomBackgroundRowColorPipe
                ],
                exports: [
                    ExGridLayoutComponent,
                    ExResizeColumnDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExGridLayoutModule, { declarations: [ExGridLayoutComponent,
        ExResizeColumnDirective,
        CustomBackgroundRowColorPipe], imports: [CommonModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatTableModule,
        MatTooltipModule,
        CdkTableModule,
        ExDirectivesModule,
        ExActionMenuModule,
        ExActionIconMenuModule,
        ExSpinnerModule,
        ExPaginationModule,
        ExComponentLoaderModule,
        ExListHeaderModule,
        TranslateModule,
        ExIconModule,
        ExLinkModule,
        ExInlineEditingModule,
        ExButtonModule,
        ExIconModule,
        AngularResizeEventModule,
        DragDropModule,
        ExDragModule,
        ExCheckboxModule,
        MatTooltipModule,
        ExRightClickActionsModule,
        ExInlineEditingButtonsModule,
        ExSlideToggleModule,
        EXPipesModule], exports: [ExGridLayoutComponent,
        ExResizeColumnDirective] }); })();

class ExSideBySideModule {
    static { this.ɵfac = function ExSideBySideModule_Factory(t) { return new (t || ExSideBySideModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSideBySideModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            AngularSplitModule,
            AngularResizeEventModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSideBySideModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AngularSplitModule,
                    AngularResizeEventModule
                ],
                declarations: [
                    ExSideBySideComponent
                ],
                exports: [
                    ExSideBySideComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSideBySideModule, { declarations: [ExSideBySideComponent], imports: [CommonModule,
        AngularSplitModule,
        AngularResizeEventModule], exports: [ExSideBySideComponent] }); })();

class ExRecordActionsService {
    constructor() {
        this.closeMenuSubject = new Subject();
        this.closeMenuSubject$ = this.closeMenuSubject.asObservable();
    }
    closeMenu() {
        this.closeMenuSubject.next();
    }
    static { this.ɵfac = function ExRecordActionsService_Factory(t) { return new (t || ExRecordActionsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExRecordActionsService, factory: ExRecordActionsService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordActionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0$r = ["moreActionsMenuTrigger"];
const _c1$j = ["wrapperActionsElem"];
const _c2$d = ["moreActionsElem"];
const _c3$a = ["actionsElem"];
const _c4$8 = function (a0, a1) { return { actionItem: a0, i: a1, hasSelClass: true }; };
function ExRecordActionsComponent_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementContainer(4, 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const action_r6 = ctx_r9.$implicit;
    const i_r7 = ctx_r9.index;
    const ctx_r8 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(3, 8, ctx_r8.getActionTooltip(action_r6)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, ctx_r8.getActionTooltip(action_r6)) + " - " + i0.ɵɵpipeBind1(2, 6, "ng.general.row") + " " + ctx_r8.index);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction2(10, _c4$8, action_r6, i_r7));
} }
function ExRecordActionsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordActionsComponent_ng_container_2_span_1_Template, 5, 13, "span", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.doDisplayAction(i_r7));
} }
const _c5$7 = function (a0, a1) { return { actionItem: a0, i: a1, hasSelClass: false }; };
function ExRecordActionsComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", null, 10);
    i0.ɵɵelementContainer(3, 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const action_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5$7, action_r11, i_r12));
} }
function ExRecordActionsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ExRecordActionsComponent_div_3_ng_container_1_Template, 4, 5, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.actions);
} }
function ExRecordActionsComponent_ng_template_4_div_0_ex_spinner_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 21);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExRecordActionsComponent_ng_template_4_div_0_ex_svg_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 22);
} if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).actionItem;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r20.asAction(action_r14).icon.iconName);
} }
const _c6$7 = function (a0) { return { "background-color": a0 }; };
const _c7$6 = function (a0, a1, a2, a3, a4) { return { "ex-record-actions-first": a0, "ex-record-actions-last": a1, "ex-record-actions-main-buttons-selected": a2, "ex-record-actions-disabled": a3, "sel-record-actions-button": a4 }; };
const _c8$6 = function (a0) { return { "ex-record-actions-loading-label": a0 }; };
function ExRecordActionsComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 12)(2, "button", 13);
    i0.ɵɵlistener("click", function ExRecordActionsComponent_ng_template_4_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onMainWithChildrenClick()); })("menuOpened", function ExRecordActionsComponent_ng_template_4_div_0_Template_button_menuOpened_2_listener() { i0.ɵɵrestoreView(_r24); const _r21 = i0.ɵɵreference(13); const action_r14 = i0.ɵɵnextContext().actionItem; const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(action_r14.component || ctx_r25.asAction(action_r14).hasSearchBox ? _r21.setFocus() : null); });
    i0.ɵɵpipe(3, "generateHTMLId");
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtemplate(5, ExRecordActionsComponent_ng_template_4_div_0_ex_spinner_5_Template, 1, 1, "ex-spinner", 15);
    i0.ɵɵtemplate(6, ExRecordActionsComponent_ng_template_4_div_0_ex_svg_icon_6_Template, 1, 1, "ex-svg-icon", 16);
    i0.ɵɵelementStart(7, "span", 17);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "i", 18);
    i0.ɵɵtext(11, "arrow_drop_down");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "menu-item", 19, 20);
    i0.ɵɵlistener("actionClicked", function ExRecordActionsComponent_ng_template_4_div_0_Template_menu_item_actionClicked_12_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onActionClicked($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r21 = i0.ɵɵreference(13);
    const ctx_r28 = i0.ɵɵnextContext();
    const action_r14 = ctx_r28.actionItem;
    const i_r15 = ctx_r28.i;
    const hasSelClass_r16 = ctx_r28.hasSelClass;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(21, _c6$7, ctx_r17.isSelected ? "#c6e9ff" : " #f2f2f2"));
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-record-actions-main-buttons  ex-record-actions-main-dynamic-action ", i0.ɵɵpipeBind1(3, 17, action_r14), "");
    i0.ɵɵproperty("disabled", action_r14.disabled || ctx_r17.disabled || action_r14.loading || ctx_r17._loading)("matMenuTriggerFor", _r21.childMenu)("ngClass", i0.ɵɵpureFunction5(23, _c7$6, i_r15 === 0, i_r15 === ctx_r17.actions.length - 1, ctx_r17.isSelected, action_r14.disabled || ctx_r17.disabled, hasSelClass_r16 == true));
    i0.ɵɵattribute("aria-describedby", ctx_r17.ariaDescribedBy);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", action_r14.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.asAction(action_r14).icon && !action_r14.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c8$6, action_r14.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 19, action_r14.label));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("items", ctx_r17.isMenuItem(action_r14) ? action_r14.children : ctx_r17.asAction(action_r14).subActions)("dynamicComponent", action_r14.component)("ariaDescribedBy", ctx_r17.ariaDescribedBy)("hasSearch", action_r14 == null ? null : action_r14.hasSearchBox)("unlistedValuesParams", ctx_r17.asAction(action_r14).unlistedValuesParams);
} }
function ExRecordActionsComponent_ng_template_4_button_1_ex_spinner_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 21);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
function ExRecordActionsComponent_ng_template_4_button_1_ex_svg_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 22);
} if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).actionItem;
    const ctx_r30 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconName", ctx_r30.asAction(action_r14).icon.iconName);
} }
function ExRecordActionsComponent_ng_template_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function ExRecordActionsComponent_ng_template_4_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); const i_r15 = i0.ɵɵnextContext().i; const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.onMainClick(i_r15)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "div", 24);
    i0.ɵɵtemplate(6, ExRecordActionsComponent_ng_template_4_button_1_ex_spinner_6_Template, 1, 1, "ex-spinner", 15);
    i0.ɵɵtemplate(7, ExRecordActionsComponent_ng_template_4_button_1_ex_svg_icon_7_Template, 1, 1, "ex-svg-icon", 16);
    i0.ɵɵelementStart(8, "span", 17);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext();
    const action_r14 = ctx_r35.actionItem;
    const i_r15 = ctx_r35.i;
    const hasSelClass_r16 = ctx_r35.hasSelClass;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-record-actions-main-buttons ", i0.ɵɵpipeBind1(1, 12, action_r14), "");
    i0.ɵɵproperty("disabled", action_r14.disabled || ctx_r18.disabled || action_r14.loading || ctx_r18._loading)("ngClass", i0.ɵɵpureFunction5(22, _c7$6, i_r15 === 0, i_r15 === ctx_r18.actions.length - 1, ctx_r18.isSelected, action_r14.disabled || ctx_r18.disabled, hasSelClass_r16 == true))("exTooltip", i0.ɵɵpipeBind1(4, 18, ctx_r18.getActionTooltip(action_r14)));
    i0.ɵɵattribute("aria-describedby", ctx_r18.ariaDescribedBy)("aria-label", i0.ɵɵpipeBind1(2, 14, action_r14.label) + " - " + i0.ɵɵpipeBind1(3, 16, "ng.general.row") + " " + ctx_r18.index);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", action_r14.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.asAction(action_r14).icon && !action_r14.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c8$6, action_r14.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 20, action_r14.label));
} }
function ExRecordActionsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExRecordActionsComponent_ng_template_4_div_0_Template, 14, 31, "div", 5);
    i0.ɵɵtemplate(1, ExRecordActionsComponent_ng_template_4_button_1_Template, 11, 30, "button", 11);
} if (rf & 2) {
    const action_r14 = ctx.actionItem;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.isMenuItem(action_r14) && (action_r14.children == null ? null : action_r14.children.length) > 0 || ctx_r4.isAction(action_r14) && (action_r14.subActions == null ? null : action_r14.subActions.length) > 0 || action_r14.component || (action_r14 == null ? null : action_r14.unlistedValuesParams));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r4.isMenuItem(action_r14) && (action_r14.children == null ? null : action_r14.children.length) > 0 || ctx_r4.isAction(action_r14) && (action_r14.subActions == null ? null : action_r14.subActions.length) > 0) && !action_r14.component && !ctx_r4.asAction(action_r14).unlistedValuesParams);
} }
function ExRecordActionsComponent_ng_container_6_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵelement(1, "ex-svg-icon", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", ctx_r38.dotsIcon);
} }
function ExRecordActionsComponent_ng_container_6_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "ex-spinner", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mode", "indeterminate")("diameter", 15);
} }
const _c9$5 = function (a0, a1, a2) { return { "ex-record-actions-main-buttons-selected": a0, "ex-record-actions-last": a1, "ex-record-actions-disabled": a2 }; };
function ExRecordActionsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 25, 26);
    i0.ɵɵlistener("click", function ExRecordActionsComponent_ng_container_6_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.onMoreClicked($event)); })("menuOpened", function ExRecordActionsComponent_ng_container_6_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.isMenuOpen = true); })("menuClosed", function ExRecordActionsComponent_ng_container_6_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r43); const ctx_r45 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r45.isMenuOpen = false); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExRecordActionsComponent_ng_container_6_span_7_Template, 2, 1, "span", 27);
    i0.ɵɵtemplate(8, ExRecordActionsComponent_ng_container_6_ng_template_8_Template, 2, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "menu-item", 29, 30);
    i0.ɵɵlistener("actionClicked", function ExRecordActionsComponent_ng_container_6_Template_menu_item_actionClicked_10_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r46 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r46.onActionClicked($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(9);
    const _r41 = i0.ɵɵreference(11);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(4, 11, "ng.general.more_actions"))("ngClass", i0.ɵɵpureFunction3(17, _c9$5, ctx_r5.isSelected, ctx_r5.visibleBtnNum > 0, ctx_r5.disabled))("matMenuTriggerFor", _r41.childMenu)("disabled", ctx_r5.disabled || ctx_r5._loading);
    i0.ɵɵattribute("aria-describedby", ctx_r5.ariaDescribedBy)("aria-expanded", ctx_r5.isMenuOpen)("aria-label", i0.ɵɵpipeBind1(5, 13, "ng.general.more_actions") + " - " + i0.ɵɵpipeBind1(6, 15, "ng.general.row") + " " + ctx_r5.index);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r5._menuLoading)("ngIfElse", _r39);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r5.hiddenActions)("ariaDescribedBy", ctx_r5.ariaDescribedBy);
} }
const _c10$4 = function (a0) { return { "ex-record-actions-wrapper-expanded": a0 }; };
class ExRecordActionsComponent {
    set actions(actions) {
        const actionsChanged = this.doActionsChanged(actions);
        this._actions = actions;
        this.calcActions(actionsChanged);
        this.isQuickAccessScope && this.setQuickAccessAction();
    }
    get actions() {
        return this._actions;
    }
    set visibleBtnNum(visibleBtnNum) {
        if (visibleBtnNum !== undefined) {
            this._visibleBtnNum = visibleBtnNum;
        }
        this.calcActions();
    }
    get visibleBtnNum() {
        return this._visibleBtnNum;
    }
    /**
     * Whether the actions are loading.
     * If true, a spinner is displayed.
     */
    set loading(value) {
        this._loading = value;
        this._menuLoading = this.actions?.some((action, index) => {
            const visibleBtnNumNew = this.expandActionsOnAllSpace ? this.indexOfFirstCollapsedOption : this.visibleBtnNum;
            return (index >= visibleBtnNumNew && action.loading == true);
        });
    }
    set expandActionsOnAllSpace(expandActionsOnAllSpace) {
        this._expandActionsOnAllSpace = expandActionsOnAllSpace;
        this.calcActions();
    }
    get expandActionsOnAllSpace() {
        return this._expandActionsOnAllSpace;
    }
    calcActions(actionsChanged = true) {
        (this.expandActionsOnAllSpace && actionsChanged) ? this.calcExpandedActions() : this.setHiddenActions();
    }
    /**
     * @ignore
     */
    constructor(exRecordActionsService, exItemsLayoutService, quickAccessService, isQuickAccessScope, element, ngZone, cdRef, translateService) {
        this.exRecordActionsService = exRecordActionsService;
        this.exItemsLayoutService = exItemsLayoutService;
        this.quickAccessService = quickAccessService;
        this.isQuickAccessScope = isQuickAccessScope;
        this.element = element;
        this.ngZone = ngZone;
        this.cdRef = cdRef;
        this.translateService = translateService;
        /**
         * enter a list of buttons, each button must have a text and onClick func.
         * the buttons will be displayed according to the list order.
         */
        this._actions = [];
        this.dotsIcon = 'ellipsis-horizontal';
        /**
         * enter the number of visible buttons, all the rest will be inside the more button menu.
         * set to 1 by default
         */
        this._visibleBtnNum = 1;
        /**
         * is the record selected or not - if true the background of the buttons will become light blue
         */
        this.isSelected = false;
        this.disabled = false;
        /**
         * for Accessibility
         */
        this.ariaDescribedBy = null;
        /**
         * do relatively expand the actions on the left side if there is places
         */
        this._expandActionsOnAllSpace = false;
        this.actionClicked = new EventEmitter();
        /**
         * for Accessibility - indicates if more actions menu is open or closed
         */
        this.isMenuOpen = false;
        this._loading = false;
        this._menuLoading = false;
        this.sub = new Subscription();
        this.indexOfFirstCollapsedOption = this.visibleBtnNum;
        this.hiddenActions = [];
        this.isSidenavExpanded = false;
        this.onResized = (entries) => {
            const domSize = entries[0];
            const newRectWidth = domSize.contentRect.width;
            if (typeof newRectWidth === 'number' && newRectWidth !== this.prevWrapperElemWidth) {
                this.prevWrapperElemWidth = newRectWidth;
                this.calcExpandedActions();
            }
        };
    }
    ngOnInit() {
        this.sub.add(this.exRecordActionsService.closeMenuSubject$.subscribe(() => {
            this.moreActionsTrigger.closeMenu();
        }));
        if (this.expandActionsOnAllSpace) {
            this.sub.add(this.exItemsLayoutService.expandLeftSidenavChange$.subscribe((res) => {
                this.isSidenavExpanded = res;
                this.calcExpandedActions();
            }));
        }
        this.isQuickAccessScope && this.sub.add(this.quickAccessService?.applyFocus.subscribe(data => {
            this.applyQuickAccessAction(data);
        }));
    }
    ngAfterViewInit() {
        if (this.expandActionsOnAllSpace) {
            this.ngZone.runOutsideAngular(() => {
                this.resizeObserver = new ResizeObserver(this.onResized);
                this.resizeObserver.observe(this.wrapperActionsElem.nativeElement);
            });
        }
    }
    doActionsChanged(actions) {
        if (this._actions.length !== actions.length)
            return true;
        return actions.find((action, i) => action.label !== this._actions[i].label) !== undefined;
    }
    onMoreClicked(event) {
        event?.stopPropagation();
    }
    onMainClick(index) {
        event?.stopPropagation();
        if (this.actions[index]) {
            if (this.actions[index].hasOwnProperty('value')) { //action is of type ActionModel
                this.ngZone.run(() => {
                    this.actionClicked.emit(this.actions[index].value);
                });
            }
            else { //action is of type MenuItemModel
                const action = this.actions[index];
                if (action.onClick) {
                    this.ngZone.run(() => {
                        action.onClick();
                    });
                }
                this.ngZone.run(() => {
                    this.actionClicked.emit(action.key);
                });
            }
        }
    }
    onMainWithChildrenClick() {
        event.stopPropagation();
    }
    setHiddenActions() {
        if (this.expandActionsOnAllSpace) {
            if (this.indexOfFirstCollapsedOption === -1) {
                if (this.hiddenActions.length) {
                    this.hiddenActions = [];
                    this.cdRef.markForCheck();
                }
            }
            else {
                this.hiddenActions = this.actions.slice(this.indexOfFirstCollapsedOption);
                this.cdRef.markForCheck();
            }
        }
        else {
            this.hiddenActions = this.actions.slice(this.visibleBtnNum);
            this.cdRef.markForCheck();
        }
    }
    onEnterKeyDown(event) {
        event.stopPropagation();
    }
    dynamicComponentArrowClick() {
        event.stopPropagation();
    }
    onActionClicked(key) {
        this.ngZone.run(() => {
            this.actionClicked.emit(key);
        });
        this.exRecordActionsService.closeMenu();
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.resizeObserver?.disconnect();
    }
    isMenuItem(menu) {
        return menu && !!menu.children;
    }
    isAction(action) {
        return action && !!action.subActions;
    }
    asAction(action) {
        return action;
    }
    calcExpandedActions() {
        this.cdRef.detectChanges();
        if (this.moreActionsElem) {
            this.moreActionsElem.nativeElement.style.display = 'none';
        }
        if (!this.wrapperActionsElem || !this.moreActionsElem || !this.actionsElems?.length)
            return;
        this.moreActionsElem.nativeElement.style.display = 'unset';
        // this.wrapperActionsElem.nativeElement.style.marginInlineStart =  this.isSidenavExpanded ? '180px' : '20px';
        const margin = 5;
        let newIndexOfFirstCollapsedOption = -1;
        let sum = 0;
        const moreActionsElemWidth = this.moreActionsElem.nativeElement.offsetWidth + margin;
        const wrapperActionsElemWidth = this.wrapperActionsElem.nativeElement.offsetWidth;
        this.actionsElems.forEach((actionElem, index) => {
            if (newIndexOfFirstCollapsedOption !== -1)
                return;
            const actionElemFullWidth = actionElem.nativeElement.offsetWidth + margin;
            const freeSpace = wrapperActionsElemWidth - sum - actionElemFullWidth;
            const isLastAndNoOptionsCollapsed = (index === this.actions.length - 1) && newIndexOfFirstCollapsedOption === -1;
            const hasEnoughSpace = (freeSpace - (isLastAndNoOptionsCollapsed ? 0 : moreActionsElemWidth)) > 0;
            if (hasEnoughSpace) {
                sum += actionElemFullWidth;
            }
            else {
                newIndexOfFirstCollapsedOption = index;
            }
        });
        this.moreActionsElem.nativeElement.style.display = newIndexOfFirstCollapsedOption === -1 ? 'none' : 'unset';
        this.indexOfFirstCollapsedOption = newIndexOfFirstCollapsedOption;
        this.cdRef.detectChanges();
        this.setHiddenActions();
    }
    doDisplayAction(i) {
        if (this.expandActionsOnAllSpace)
            return this.indexOfFirstCollapsedOption === -1 || i < this.indexOfFirstCollapsedOption;
        return i < this.visibleBtnNum;
    }
    getActionTooltip(action) {
        return this.ngZone.run(() => {
            return action.tooltip;
        });
    }
    setQuickAccessAction() {
        this.quickAccessService?.removeType(QuickAccessType.ACTION);
        this.actions.forEach(action => {
            this.quickAccessService?.updateData(this.translateService.instant(action.label), QuickAccessType.ACTION, action.disabled, undefined);
        });
    }
    applyQuickAccessAction(data) {
        if (data?.type != QuickAccessType.ACTION)
            return;
        let ind = this.actions.findIndex(action => this.translateService.instant(action.label) == data.key);
        let action = this.actions[ind];
        action && ((!((this.isMenuItem(action) && action.children?.length > 0) || (this.isAction(action) && action.subActions?.length > 0)) && !action.component) ? this.onMainClick(ind) : this.onActionClicked(action.value));
    }
    static { this.ɵfac = function ExRecordActionsComponent_Factory(t) { return new (t || ExRecordActionsComponent)(i0.ɵɵdirectiveInject(ExRecordActionsService), i0.ɵɵdirectiveInject(ExItemsLayoutService, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS, 8), i0.ɵɵdirectiveInject(EX_QUICK_ACCESS_SCOPE, 8), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRecordActionsComponent, selectors: [["ex-record-actions"]], viewQuery: function ExRecordActionsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$r, 5);
            i0.ɵɵviewQuery(_c1$j, 5);
            i0.ɵɵviewQuery(_c2$d, 5);
            i0.ɵɵviewQuery(_c3$a, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreActionsTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapperActionsElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreActionsElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionsElems = _t);
        } }, inputs: { actions: "actions", dotsIcon: "dotsIcon", visibleBtnNum: "visibleBtnNum", isSelected: "isSelected", disabled: "disabled", index: "index", loading: "loading", ariaDescribedBy: "ariaDescribedBy", expandActionsOnAllSpace: "expandActionsOnAllSpace" }, outputs: { actionClicked: "actionClicked" }, decls: 7, vars: 6, consts: [[1, "ex-record-actions-wrapper", "sel-record-actions", 3, "ngClass", "keydown.enter"], ["wrapperActionsElem", ""], [4, "ngFor", "ngForOf"], ["class", "ex-record-actions-hidden", 4, "ngIf"], ["actionTmpl", ""], [4, "ngIf"], [3, "exTooltip", 4, "ngIf"], [3, "exTooltip"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-record-actions-hidden"], ["actionsElem", ""], ["mat-ripple", "", 3, "disabled", "class", "ngClass", "exTooltip", "click", 4, "ngIf"], [1, "ex-record-actions-dynamic-component-buttons-wrapper", 3, "ngStyle"], ["mat-ripple", "", 3, "disabled", "matMenuTriggerFor", "ngClass", "click", "menuOpened"], [1, "ex-record-actions-main-buttons-with-children"], ["class", "ex-record-actions-loading-spinner", 3, "diameter", 4, "ngIf"], ["class", "ex-record-actions-icon", 3, "iconName", 4, "ngIf"], [1, "ex-record-actions-label", 3, "ngClass"], [1, "material-icons"], ["position", "before", 3, "items", "dynamicComponent", "ariaDescribedBy", "hasSearch", "unlistedValuesParams", "actionClicked"], ["mainMenu", ""], [1, "ex-record-actions-loading-spinner", 3, "diameter"], [1, "ex-record-actions-icon", 3, "iconName"], ["mat-ripple", "", 3, "disabled", "ngClass", "exTooltip", "click"], [1, "ex-record-actions-main-buttons-label-wrapper"], ["mat-ripple", "", 1, "ex-record-actions-main-buttons", "ex-record-actions-more-btn", "sel-record-actions-more-actions", 3, "exTooltip", "ngClass", "matMenuTriggerFor", "disabled", "click", "menuOpened", "menuClosed"], ["moreActionsElem", "", "moreActionsMenuTrigger", "matMenuTrigger"], ["class", "ex-record-actions-menu-icon-wrapper", 4, "ngIf", "ngIfElse"], ["actionsLoadingSpinner", ""], ["position", "before", 3, "items", "ariaDescribedBy", "actionClicked"], ["menu", ""], [1, "ex-record-actions-menu-icon-wrapper"], [3, "iconName"], [1, "ex-record-actions-loading-spinner-container"], [1, "ex-record-actions-loading-spinner", 3, "mode", "diameter"]], template: function ExRecordActionsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵlistener("keydown.enter", function ExRecordActionsComponent_Template_div_keydown_enter_0_listener($event) { return ctx.onEnterKeyDown($event); });
            i0.ɵɵtemplate(2, ExRecordActionsComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, ExRecordActionsComponent_div_3_Template, 2, 1, "div", 3);
            i0.ɵɵtemplate(4, ExRecordActionsComponent_ng_template_4_Template, 2, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(6, ExRecordActionsComponent_ng_container_6_Template, 12, 21, "ng-container", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c10$4, ctx.expandActionsOnAllSpace));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.actions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.expandActionsOnAllSpace);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.expandActionsOnAllSpace || ctx.actions.length > ctx.visibleBtnNum);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i3$1.MatMenuTrigger, ExSpinnerComponent, ExTooltipDirective, MenuItemComponent, ExSvgIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-record-actions-hidden[_ngcontent-%COMP%]{position:absolute;visibility:hidden}.ex-record-actions-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;flex-wrap:wrap}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-loading-spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-loading-spinner[_ngcontent-%COMP%]{position:absolute;right:0;left:45%;margin-left:auto;margin-right:auto}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-loading-label[_ngcontent-%COMP%]{opacity:0}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-main-buttons[_ngcontent-%COMP%]{height:30px;padding:0 10px;border-radius:0;border:0px;margin-inline-end:1px;position:relative}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-main-buttons[_ngcontent-%COMP%]   .ex-record-actions-main-buttons-with-children[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-main-buttons[_ngcontent-%COMP%]   .ex-record-actions-main-buttons-label-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-icon[_ngcontent-%COMP%]{margin-right:5px;display:flex;align-items:center}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-label[_ngcontent-%COMP%]{white-space:nowrap}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-dynamic-component-buttons-wrapper[_ngcontent-%COMP%]{margin-right:2px;display:flex;align-items:center}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-dynamic-component-buttons-wrapper[_ngcontent-%COMP%]   .ex-record-actions-arrow[_ngcontent-%COMP%]{display:flex;align-items:center;height:30px;border-radius:0;border:0px}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-dynamic-component-buttons-wrapper[_ngcontent-%COMP%]   .ex-record-actions-arrow-style[_ngcontent-%COMP%]{padding:0 8px;height:12px}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-dynamic-component-buttons-wrapper[_ngcontent-%COMP%]   .ex-record-actions-arrow[_ngcontent-%COMP%]:focus{outline:0px}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-first[_ngcontent-%COMP%]{border-start-start-radius:3px;border-end-start-radius:3px}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-last[_ngcontent-%COMP%]{border-start-end-radius:3px;border-end-end-radius:3px;border-start-start-radius:0px!important;border-end-start-radius:0px!important;margin-right:0}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-more-btn[_ngcontent-%COMP%]{padding:0 5px;width:40px;border-radius:3px}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-more-btn[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:auto;width:auto;display:flex}.ex-record-actions-wrapper[_ngcontent-%COMP%]   .ex-record-actions-more-btn[_ngcontent-%COMP%]   .ex-record-actions-menu-icon-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-record-actions-wrapper-expanded[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;justify-content:flex-start;flex-wrap:wrap;gap:4px}.ex-record-actions-wrapper-expanded[_ngcontent-%COMP%]   .ex-record-actions-main-buttons[_ngcontent-%COMP%]{border:1px solid #d8d8d8;border-radius:3px}.ex-record-actions-wrapper-expanded[_ngcontent-%COMP%]   .ex-record-actions-last[_ngcontent-%COMP%]{border-radius:3px!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordActionsComponent, [{
        type: Component,
        args: [{ selector: 'ex-record-actions', template: "<div class=\"ex-record-actions-wrapper sel-record-actions\" [ngClass]=\"{ 'ex-record-actions-wrapper-expanded' : expandActionsOnAllSpace}\" (keydown.enter)=\"onEnterKeyDown($event)\" #wrapperActionsElem>\n  <ng-container *ngFor=\"let action of actions;  let i=index\">\n    <span *ngIf=\"doDisplayAction(i)\" [attr.aria-label]=\"(getActionTooltip(action) | translate) + ' - ' + ( 'ng.general.row' | translate) + ' ' + index\" [exTooltip]=\"getActionTooltip(action) | translate\">\n      <ng-container [ngTemplateOutlet]='actionTmpl' [ngTemplateOutletContext]=\"{ actionItem: action , i , hasSelClass: true}\"></ng-container>\n    </span>\n  </ng-container>\n  <div *ngIf=\"expandActionsOnAllSpace\" class=\"ex-record-actions-hidden\">\n    <ng-container *ngFor=\"let action of actions;  let i=index\">\n      <span #actionsElem>\n        <ng-container [ngTemplateOutlet]='actionTmpl' [ngTemplateOutletContext]=\"{ actionItem: action , i, hasSelClass: false }\"></ng-container>\n      </span>\n    </ng-container>\n  </div>\n  <ng-template #actionTmpl let-action=\"actionItem\" let-i=\"i\" let-hasSelClass=\"hasSelClass\">\n    <!-- ACTION WITH CHILDREN OR COMPONENT-->\n    <div\n      *ngIf=\"(((isMenuItem(action) && action.children?.length > 0) || (isAction(action) && action.subActions?.length > 0)) || action.component || action?.unlistedValuesParams)\">\n          <span class=\"ex-record-actions-dynamic-component-buttons-wrapper\"\n                [ngStyle]=\"{'background-color': isSelected ? '#c6e9ff' : ' #f2f2f2'}\">\n            <button [disabled]=\"action.disabled || disabled || action.loading || _loading\" mat-ripple\n                    (click)=\"onMainWithChildrenClick()\" [attr.aria-describedby]=\"ariaDescribedBy\"\n                    [matMenuTriggerFor]=\"mainMenu.childMenu\"\n                    (menuOpened)=\"(action.component || asAction(action).hasSearchBox)?mainMenu.setFocus():null\"\n                    class=\"ex-record-actions-main-buttons  ex-record-actions-main-dynamic-action {{action | generateHTMLId }}\"\n                    [ngClass]=\"{ 'ex-record-actions-first' : i === 0, 'ex-record-actions-last' : i === actions.length - 1,\n                   'ex-record-actions-main-buttons-selected': isSelected, 'ex-record-actions-disabled': action.disabled || disabled, 'sel-record-actions-button': hasSelClass == true}\">\n              <div class=\"ex-record-actions-main-buttons-with-children\">\n                <ex-spinner *ngIf=\"action.loading\" class=\"ex-record-actions-loading-spinner\" [diameter]=\"15\"></ex-spinner>\n                <ex-svg-icon *ngIf=\"asAction(action).icon && !action.loading\"\n                        [iconName]=\"asAction(action).icon.iconName\"\n                        class=\"ex-record-actions-icon\">\n                </ex-svg-icon>\n                <span class=\"ex-record-actions-label\" [ngClass]=\"{'ex-record-actions-loading-label': action.loading}\">{{\n                  action.label | translate }}</span>\n                <i class=\"material-icons\">arrow_drop_down</i>\n              </div>\n            </button>\n            <menu-item #mainMenu [items]=\"isMenuItem(action) ? action.children : asAction(action).subActions\"\n                       [dynamicComponent]=\"action.component\" position=\"before\" [ariaDescribedBy]=\"ariaDescribedBy\" [hasSearch]=\"action?.hasSearchBox\"\n                       (actionClicked)=\"onActionClicked($event)\" [unlistedValuesParams]=\"asAction(action).unlistedValuesParams\"></menu-item>\n          </span>\n    </div>\n\n    <!-- ACTION WITHOUT CHILDREN -->\n    <button\n      *ngIf=\"!((isMenuItem(action) && action.children?.length > 0) || (isAction(action) && action.subActions?.length > 0)) && !action.component && !asAction(action).unlistedValuesParams\"\n      [disabled]=\"action.disabled || disabled || action.loading || _loading\" mat-ripple\n      class=\"ex-record-actions-main-buttons {{action | generateHTMLId }}\" [attr.aria-describedby]=\"ariaDescribedBy\"\n      [ngClass]=\"{ 'ex-record-actions-first' : i === 0, 'ex-record-actions-last' : i === actions.length - 1,\n        'ex-record-actions-main-buttons-selected': isSelected, 'ex-record-actions-disabled': action.disabled || disabled , 'sel-record-actions-button': hasSelClass == true}\"\n      (click)=\"onMainClick(i)\" [attr.aria-label]=\"(action.label | translate) + ' - ' + ( 'ng.general.row' | translate) + ' ' + index\"  [exTooltip]=\"getActionTooltip(action) | translate\">\n      <div class=\"ex-record-actions-main-buttons-label-wrapper\">\n        <ex-spinner *ngIf=\"action.loading\" class=\"ex-record-actions-loading-spinner\" [diameter]=\"15\"></ex-spinner>\n        <ex-svg-icon *ngIf=\"asAction(action).icon && !action.loading\"\n                [iconName]=\"asAction(action).icon.iconName\"\n                class=\"ex-record-actions-icon\">\n        </ex-svg-icon>\n        <span class=\"ex-record-actions-label\" [ngClass]=\"{'ex-record-actions-loading-label': action.loading}\">{{\n          action.label | translate}}</span>\n      </div>\n    </button>\n  </ng-template>\n  <ng-container *ngIf=\"expandActionsOnAllSpace || actions.length > visibleBtnNum\">\n    <button #moreActionsElem [exTooltip]=\"'ng.general.more_actions' | translate\" mat-ripple (click)=\"onMoreClicked($event)\"\n      [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-expanded]=\"isMenuOpen\" (menuOpened)=\"isMenuOpen = true\"\n      (menuClosed)=\"isMenuOpen = false\"\n      class=\"ex-record-actions-main-buttons ex-record-actions-more-btn sel-record-actions-more-actions\"\n      [ngClass]=\"{ 'ex-record-actions-main-buttons-selected': isSelected, 'ex-record-actions-last': visibleBtnNum > 0, 'ex-record-actions-disabled': disabled }\"\n      [matMenuTriggerFor]=\"menu.childMenu\" #moreActionsMenuTrigger=\"matMenuTrigger\"\n      [attr.aria-label]=\"('ng.general.more_actions' | translate) + ' - ' + ( 'ng.general.row' | translate) + ' ' + index\" [disabled]=\"disabled || _loading\">\n      <span *ngIf=\"!_menuLoading; else actionsLoadingSpinner\" class=\"ex-record-actions-menu-icon-wrapper\">\n        <ex-svg-icon [iconName]=\"dotsIcon\"></ex-svg-icon>\n      </span>\n      <ng-template #actionsLoadingSpinner>\n        <div class=\"ex-record-actions-loading-spinner-container\">\n          <ex-spinner class=\"ex-record-actions-loading-spinner\" [mode]=\"'indeterminate'\" [diameter]=\"15\">\n          </ex-spinner>\n        </div>\n      </ng-template>\n    </button>\n    <menu-item #menu [items]=\"hiddenActions\" position=\"before\" [ariaDescribedBy]=\"ariaDescribedBy\"\n      (actionClicked)=\"onActionClicked($event)\"></menu-item>\n  </ng-container>\n</div>\n", styles: [".ex-record-actions-hidden{position:absolute;visibility:hidden}.ex-record-actions-wrapper{display:flex;flex-direction:row;justify-content:flex-end;flex-wrap:wrap}.ex-record-actions-wrapper .ex-record-actions-loading-spinner-container{display:flex;justify-content:center;align-items:center}.ex-record-actions-wrapper .ex-record-actions-loading-spinner{position:absolute;right:0;left:45%;margin-left:auto;margin-right:auto}.ex-record-actions-wrapper .ex-record-actions-loading-label{opacity:0}.ex-record-actions-wrapper .ex-record-actions-main-buttons{height:30px;padding:0 10px;border-radius:0;border:0px;margin-inline-end:1px;position:relative}.ex-record-actions-wrapper .ex-record-actions-main-buttons .ex-record-actions-main-buttons-with-children{display:flex;flex-direction:row;align-items:center}.ex-record-actions-wrapper .ex-record-actions-main-buttons .ex-record-actions-main-buttons-label-wrapper{display:flex;flex-direction:row;align-items:center;max-width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ex-record-actions-wrapper .ex-record-actions-icon{margin-right:5px;display:flex;align-items:center}.ex-record-actions-wrapper .ex-record-actions-label{white-space:nowrap}.ex-record-actions-wrapper .ex-record-actions-dynamic-component-buttons-wrapper{margin-right:2px;display:flex;align-items:center}.ex-record-actions-wrapper .ex-record-actions-dynamic-component-buttons-wrapper .ex-record-actions-arrow{display:flex;align-items:center;height:30px;border-radius:0;border:0px}.ex-record-actions-wrapper .ex-record-actions-dynamic-component-buttons-wrapper .ex-record-actions-arrow-style{padding:0 8px;height:12px}.ex-record-actions-wrapper .ex-record-actions-dynamic-component-buttons-wrapper .ex-record-actions-arrow:focus{outline:0px}.ex-record-actions-wrapper .ex-record-actions-first{border-start-start-radius:3px;border-end-start-radius:3px}.ex-record-actions-wrapper .ex-record-actions-last{border-start-end-radius:3px;border-end-end-radius:3px;border-start-start-radius:0px!important;border-end-start-radius:0px!important;margin-right:0}.ex-record-actions-wrapper .ex-record-actions-more-btn{padding:0 5px;width:40px;border-radius:3px}.ex-record-actions-wrapper .ex-record-actions-more-btn mat-icon{height:auto;width:auto;display:flex}.ex-record-actions-wrapper .ex-record-actions-more-btn .ex-record-actions-menu-icon-wrapper{display:flex;justify-content:center}.ex-record-actions-wrapper-expanded{display:flex;flex-direction:row-reverse;justify-content:flex-start;flex-wrap:wrap;gap:4px}.ex-record-actions-wrapper-expanded .ex-record-actions-main-buttons{border:1px solid #d8d8d8;border-radius:3px}.ex-record-actions-wrapper-expanded .ex-record-actions-last{border-radius:3px!important}\n"] }]
    }], function () { return [{ type: ExRecordActionsService }, { type: ExItemsLayoutService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [EX_QUICK_ACCESS_SCOPE]
            }] }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: i1$2.TranslateService }]; }, { actions: [{
            type: Input
        }], dotsIcon: [{
            type: Input
        }], visibleBtnNum: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], index: [{
            type: Input
        }], loading: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }], expandActionsOnAllSpace: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], moreActionsTrigger: [{
            type: ViewChild,
            args: ['moreActionsMenuTrigger']
        }], wrapperActionsElem: [{
            type: ViewChild,
            args: ['wrapperActionsElem']
        }], actionsElems: [{
            type: ViewChildren,
            args: ['actionsElem']
        }], moreActionsElem: [{
            type: ViewChild,
            args: ['moreActionsElem']
        }] }); })();

class ExRecordActionsModule {
    static { this.ɵfac = function ExRecordActionsModule_Factory(t) { return new (t || ExRecordActionsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExRecordActionsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatIconModule,
            MatMenuModule,
            ExSpinnerModule,
            MatTooltipModule,
            ExDirectivesModule,
            MenuItemModule,
            TranslateModule,
            ExIconModule,
            ExComponentLoaderModule,
            ExSvgIconModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordActionsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatMenuModule,
                    ExSpinnerModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    MenuItemModule,
                    TranslateModule,
                    ExIconModule,
                    ExComponentLoaderModule,
                    ExSvgIconModule,
                    EXPipesModule
                ],
                declarations: [
                    ExRecordActionsComponent
                ],
                exports: [
                    ExRecordActionsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExRecordActionsModule, { declarations: [ExRecordActionsComponent], imports: [CommonModule,
        MatIconModule,
        MatMenuModule,
        ExSpinnerModule,
        MatTooltipModule,
        ExDirectivesModule,
        MenuItemModule,
        TranslateModule,
        ExIconModule,
        ExComponentLoaderModule,
        ExSvgIconModule,
        EXPipesModule], exports: [ExRecordActionsComponent] }); })();

const _c0$q = function (a0) { return { "ex-chip-non-count": a0 }; };
function ExChipRecordEntityLabelsComponent_ex_chip_1_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 6);
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconType", ctx_r2.iconType)("iconName", chip_r1.icon)("ngClass", i0.ɵɵpureFunction1(3, _c0$q, ctx_r2.breakpoint === 1 && chip_r1.count == undefined || !chip_r1.text));
} }
function ExChipRecordEntityLabelsComponent_ex_chip_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(chip_r1.text);
} }
function ExChipRecordEntityLabelsComponent_ex_chip_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const chip_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(chip_r1.count);
} }
function ExChipRecordEntityLabelsComponent_ex_chip_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-chip", 1);
    i0.ɵɵelementContainerStart(1, 2);
    i0.ɵɵtemplate(2, ExChipRecordEntityLabelsComponent_ex_chip_1_ex_icon_2_Template, 1, 5, "ex-icon", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtemplate(4, ExChipRecordEntityLabelsComponent_ex_chip_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(5, ExChipRecordEntityLabelsComponent_ex_chip_1_ng_container_5_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const chip_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("exTooltip", chip_r1.text)("background", chip_r1.color)("hasBorder", false)("square", ctx_r0.breakpoint === 1 && (chip_r1.count == undefined || !chip_r1.icon));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", chip_r1.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.breakpoint !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.breakpoint === 1);
} }
class ExChipRecordEntityLabelsComponent extends ExChipRecordComponent {
    constructor() {
        super(...arguments);
        this.isRowDirection = true;
    }
    set entityLabels(entities) {
        if (!!entities) {
            this.chips = entities.map(({ key, value }) => ({
                color: value,
                text: key,
                count: key[0],
                icon: null
            }));
        }
        else {
            this.chips = [];
        }
    }
    ;
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExChipRecordEntityLabelsComponent_BaseFactory; return function ExChipRecordEntityLabelsComponent_Factory(t) { return (ɵExChipRecordEntityLabelsComponent_BaseFactory || (ɵExChipRecordEntityLabelsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExChipRecordEntityLabelsComponent)))(t || ExChipRecordEntityLabelsComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExChipRecordEntityLabelsComponent, selectors: [["ex-chip-record-entity-labels"]], inputs: { isRowDirection: "isRowDirection", entityLabels: "entityLabels" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [["fontColor", "white", "size", "small", 3, "exTooltip", "background", "hasBorder", "square", 4, "ngFor", "ngForOf"], ["fontColor", "white", "size", "small", 3, "exTooltip", "background", "hasBorder", "square"], ["icon-left", ""], ["icon-left", "", "color", "white", "sizePx", "14px", 3, "iconType", "iconName", "ngClass", 4, "ngIf"], ["text", ""], [4, "ngIf"], ["icon-left", "", "color", "white", "sizePx", "14px", 3, "iconType", "iconName", "ngClass"]], template: function ExChipRecordEntityLabelsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, ExChipRecordEntityLabelsComponent_ex_chip_1_Template, 6, 7, "ex-chip", 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵstyleProp("flex-direction", ctx.breakpoint === 1 || ctx.isRowDirection ? "row" : "column");
            i0.ɵɵclassProp("ex-chip-breakpoint1", ctx.breakpoint === 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.chips);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExChipComponent, ExIconComponent, ExTooltipDirective], styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}[_nghost-%COMP%] > div.ex-chip-breakpoint1[_ngcontent-%COMP%]{justify-content:flex-end}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   ex-chip[_ngcontent-%COMP%]{display:block!important;max-width:100%;margin:2px}.ex-chip-non-count[_ngcontent-%COMP%]{margin-inline-end:0px!important}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChipRecordEntityLabelsComponent, [{
        type: Component,
        args: [{ selector: 'ex-chip-record-entity-labels', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [style.flexDirection]=\"breakpoint === 1 || isRowDirection ? 'row' : 'column'\" [class.ex-chip-breakpoint1]=\"breakpoint === 1\">\n    <ex-chip [exTooltip]=\"chip.text\" [background]=\"chip.color\" fontColor=\"white\" [hasBorder]=\"false\" size=\"small\"\n        [square]=\"breakpoint === 1 && (chip.count==undefined || !chip.icon)\" *ngFor=\"let chip of chips\">\n        <ng-container icon-left>\n            <ex-icon *ngIf=\"chip.icon\" icon-left [iconType]=\"iconType\" [iconName]=\"chip.icon\" color=\"white\" sizePx=\"14px\"\n                [ngClass]=\"{'ex-chip-non-count': breakpoint === 1 && chip.count==undefined || !chip.text}\">\n            </ex-icon>\n        </ng-container>\n        <span text>\n            <ng-container *ngIf=\"breakpoint !== 1\">{{ chip.text }}</ng-container>\n            <ng-container *ngIf=\"breakpoint === 1\">{{ chip.count }}</ng-container>\n        </span>\n    </ex-chip>\n</div>", styles: [":host>div{display:flex;flex-wrap:wrap}:host>div.ex-chip-breakpoint1{justify-content:flex-end}:host>div ex-chip{display:block!important;max-width:100%;margin:2px}.ex-chip-non-count{margin-inline-end:0px!important}\n"] }]
    }], null, { isRowDirection: [{
            type: Input
        }], entityLabels: [{
            type: Input
        }] }); })();

class FlexValueForColumns {
    transform(record, column) {
        switch (record.layout) {
            case 'extend':
                if (column == 0)
                    return 2;
                else
                    return 1;
            case 'normal':
                return 1;
            case 'customized':
                if (!record.customizedLayout)
                    record.customizedLayout = [1, 1, 1];
                return record.customizedLayout[column];
            default:
                break;
        }
    }
    static { this.ɵfac = function FlexValueForColumns_Factory(t) { return new (t || FlexValueForColumns)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "flexValueForColumns", type: FlexValueForColumns, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FlexValueForColumns, [{
        type: Pipe,
        args: [{ name: 'flexValueForColumns' }]
    }], null, null); })();
class ShowRowOnPickup {
    transform(row, isExPickup, ignoredByPickupFields) {
        if (!isExPickup || !ignoredByPickupFields || !row.key) {
            return true;
        }
        return !ignoredByPickupFields.has(row.key);
    }
    static { this.ɵfac = function ShowRowOnPickup_Factory(t) { return new (t || ShowRowOnPickup)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "showRowOnPickup", type: ShowRowOnPickup, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShowRowOnPickup, [{
        type: Pipe,
        args: [{ name: 'showRowOnPickup' }]
    }], null, null); })();
class GetHighlightedText {
    transform(field, highlightedText) {
        if (field.showHighlight) {
            return highlightedText;
        }
        else {
            return null;
        }
    }
    static { this.ɵfac = function GetHighlightedText_Factory(t) { return new (t || GetHighlightedText)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getHighlightedText", type: GetHighlightedText, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GetHighlightedText, [{
        type: Pipe,
        args: [{ name: 'getHighlightedText' }]
    }], null, null); })();
class IsDisabledInPickup {
    transform(field, data, inExSidepanePickup) {
        if (inExSidepanePickup && field.type?.name === ExSlideToggleComponent.name) {
            return true;
        }
        return data[field.key]?.inputs?.disabled;
    }
    static { this.ɵfac = function IsDisabledInPickup_Factory(t) { return new (t || IsDisabledInPickup)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isDisabledInPickup", type: IsDisabledInPickup, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IsDisabledInPickup, [{
        type: Pipe,
        args: [{ name: 'isDisabledInPickup' }]
    }], null, null); })();
class GetIsDisabled {
    transform(field, isDisabled) {
        if (field.showDisabled) {
            return isDisabled;
        }
        else {
            return false;
        }
    }
    static { this.ɵfac = function GetIsDisabled_Factory(t) { return new (t || GetIsDisabled)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getIsDisabled", type: GetIsDisabled, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GetIsDisabled, [{
        type: Pipe,
        args: [{ name: 'getIsDisabled' }]
    }], null, null); })();
class GetRowActions {
    transform(data, actions) {
        if (!data.__proto__.actions?.type) {
            return data.actions?.actions;
        }
        else { // actions component
            return actions?.last?.componentRef?.instance?.actions;
        }
    }
    static { this.ɵfac = function GetRowActions_Factory(t) { return new (t || GetRowActions)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getRowActions", type: GetRowActions, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GetRowActions, [{
        type: Pipe,
        args: [{ name: 'getRowActions' }]
    }], null, null); })();
class IsAvatarPlaceholder {
    transform(data) {
        const { type, key } = data.__proto__.thumbnail ?? {};
        return type === 'avatar' && key && !data[key];
    }
    static { this.ɵfac = function IsAvatarPlaceholder_Factory(t) { return new (t || IsAvatarPlaceholder)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isAvatarPlaceholder", type: IsAvatarPlaceholder, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IsAvatarPlaceholder, [{
        type: Pipe,
        args: [{ name: 'isAvatarPlaceholder' }]
    }], null, null); })();
class GetActionsColumnMinWidth {
    transform(data, breakpoint) {
        if (breakpoint === 1)
            return 'unset';
        if (data.__proto__?.title?.key)
            return '150px';
        return 40 + 150 * data?.__proto__?.actions?.visibleBtnNum + 'px';
    }
    static { this.ɵfac = function GetActionsColumnMinWidth_Factory(t) { return new (t || GetActionsColumnMinWidth)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getActionsColumnMinWidth", type: GetActionsColumnMinWidth, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GetActionsColumnMinWidth, [{
        type: Pipe,
        args: [{ name: 'getActionsColumnMinWidth' }]
    }], null, null); })();

const _c0$p = ["actions"];
const _c1$i = function (a0) { return { "ex-record-floating-actions": a0 }; };
function ExRecordComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "ex-right-click-actions", 4);
    i0.ɵɵlistener("actionClicked", function ExRecordComponent_div_0_Template_ex_right_click_actions_actionClicked_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onActionClicked($event)); });
    i0.ɵɵelementContainer(2, 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$i, ctx_r0.data.__proto__.actions == null ? null : ctx_r0.data.__proto__.actions.isFloating));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", ctx_r0.getRowActions());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-label", 15);
    i0.ɵɵpipe(1, "getHighlightedText");
    i0.ɵɵpipe(2, "getIsDisabled");
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    const row_r7 = ctx_r22.row;
    const isTitle_r8 = ctx_r22.isTitle;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(row_r7.style);
    i0.ɵɵclassMapInterpolate1("sel-", row_r7.key, " ex-record-label");
    i0.ɵɵpropertyInterpolate3("htmlId", "", ctx_r19.htmlId, "", ctx_r19.htmlId ? "_" : "", "", row_r7.htmlId, "");
    i0.ɵɵproperty("svgIcon", (ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].icon == null ? null : ctx_r19.data[row_r7.key].icon.iconType) == "svg" ? ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].icon : undefined)("highlightedText", i0.ɵɵpipeBind2(1, 21, row_r7, ctx_r19.highlightedText))("label", row_r7.label)("iconType", ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].icon == null ? null : ctx_r19.data[row_r7.key].icon.iconType)("iconName", ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].icon == null ? null : ctx_r19.data[row_r7.key].icon.iconName)("iconColor", ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].icon == null ? null : ctx_r19.data[row_r7.key].icon.iconColor)("value", ctx_r19.data[row_r7.key] == null ? null : ctx_r19.data[row_r7.key].value)("isBold", row_r7.isBold)("isStrikeThrough", i0.ɵɵpipeBind2(2, 24, row_r7, ctx_r19.data.isDisabled))("hasColon", row_r7.hasColon)("displayTooltip", row_r7.displayTooltip);
    i0.ɵɵattribute("role", isTitle_r8 ? "heading" : "")("aria-level", isTitle_r8 ? "3" : "4");
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_chip_record_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-chip-record", 16);
} if (rf & 2) {
    const row_r7 = i0.ɵɵnextContext(5).row;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("breakpoint", ctx_r20.breakpoint)("chips", ctx_r20.data[row_r7.key])("iconType", "svg");
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_chip_record_entity_labels_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-chip-record-entity-labels", 17);
} if (rf & 2) {
    const row_r7 = i0.ɵɵnextContext(5).row;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("breakpoint", ctx_r21.breakpoint)("entityLabels", ctx_r21.data[row_r7.key])("iconType", "svg");
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 11);
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_label_2_Template, 3, 27, "ex-label", 12);
    i0.ɵɵtemplate(3, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_chip_record_3_Template, 1, 3, "ex-chip-record", 13);
    i0.ɵɵtemplate(4, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_ex_chip_record_entity_labels_4_Template, 1, 3, "ex-chip-record-entity-labels", 14);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const row_r7 = i0.ɵɵnextContext(4).row;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", row_r7.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r16.OtbRecordFieldComponentTypes.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r16.OtbRecordFieldComponentTypes.chip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r16.OtbRecordFieldComponentTypes.entityLabels);
} }
const _c2$c = function (a0, a1, a2, a3, a4) { return { highlightedText: a0, disabled: a1, isDisabled: a2, htmlId: a3, breakpoint: a4 }; };
const _c3$9 = function () { return {}; };
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_template_2_ex_component_loader_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 19);
    i0.ɵɵpipe(1, "objectAssign");
    i0.ɵɵpipe(2, "getHighlightedText");
    i0.ɵɵpipe(3, "isDisabledInPickup");
    i0.ɵɵpipe(4, "getIsDisabled");
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(5);
    const row_r7 = ctx_r27.row;
    const isTitle_r8 = ctx_r27.isTitle;
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(row_r7.style);
    i0.ɵɵclassMapInterpolate3("ex-record-full-width sel-", row_r7.key, " sel-", row_r7.key, "-", ctx_r26.data["id"], "");
    i0.ɵɵproperty("componentFactoryItem", ctx_r26.componentFactoryItemsMap[row_r7.key])("data", i0.ɵɵpipeBind2(1, 13, ctx_r26.data[row_r7.key] == null ? null : ctx_r26.data[row_r7.key].inputs, i0.ɵɵpureFunction5(26, _c2$c, i0.ɵɵpipeBind2(2, 16, row_r7, ctx_r26.highlightedText), i0.ɵɵpipeBind3(3, 19, row_r7, ctx_r26.data, ctx_r26.inExSidepanePickup), i0.ɵɵpipeBind2(4, 23, row_r7, ctx_r26.data.isDisabled), ctx_r26.htmlId, ctx_r26.breakpoint)))("content", ctx_r26.data[row_r7.key] == null ? null : ctx_r26.data[row_r7.key].content)("events", (ctx_r26.data[row_r7.key] == null ? null : ctx_r26.data[row_r7.key].events) || i0.ɵɵpureFunction0(32, _c3$9));
    i0.ɵɵattribute("role", isTitle_r8 ? "heading" : "")("aria-level", isTitle_r8 ? "3" : "4");
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_template_2_ex_component_loader_0_Template, 5, 33, "ex-component-loader", 18);
} if (rf & 2) {
    const row_r7 = i0.ɵɵnextContext(4).row;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r18.data[row_r7.key]);
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_container_1_Template, 5, 4, "ng-container", 8);
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r17 = i0.ɵɵreference(3);
    const row_r7 = i0.ɵɵnextContext(3).row;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r7.staticInputs)("ngIfElse", _r17);
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-label", 20);
    i0.ɵɵpipe(1, "getHighlightedText");
    i0.ɵɵpipe(2, "getIsDisabled");
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    const row_r7 = ctx_r30.row;
    const isTitle_r8 = ctx_r30.isTitle;
    const ctx_r15 = i0.ɵɵnextContext();
    let tmp_5_0;
    i0.ɵɵstyleMap(row_r7.style);
    i0.ɵɵclassMapInterpolate1("sel-", row_r7.key, " ex-record-label");
    i0.ɵɵpropertyInterpolate3("htmlId", "", ctx_r15.htmlId, "", ctx_r15.htmlId ? "_" : "", "", row_r7.htmlId, "");
    i0.ɵɵproperty("highlightedText", i0.ɵɵpipeBind2(1, 21, row_r7, ctx_r15.highlightedText))("label", row_r7.label)("svgIcon", (tmp_5_0 = row_r7.icon) !== null && tmp_5_0 !== undefined ? tmp_5_0 : undefined)("iconType", row_r7.iconType)("iconName", row_r7.iconName)("iconColor", row_r7.iconColor)("value", ctx_r15.data[row_r7.key])("isBold", row_r7.isBold)("isStrikeThrough", i0.ɵɵpipeBind2(2, 24, row_r7, ctx_r15.data.isDisabled))("hasColon", row_r7.hasColon)("displayTooltip", row_r7.displayTooltip);
    i0.ɵɵattribute("role", isTitle_r8 ? "heading" : "")("aria-level", isTitle_r8 ? "3" : "4");
} }
function ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 8);
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_ng_template_2_Template, 3, 27, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(3);
    const row_r7 = i0.ɵɵnextContext(2).row;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r7.type)("ngIfElse", _r14);
} }
function ExRecordComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_1_ng_container_0_ng_container_1_Template, 4, 2, "ng-container", 8);
    i0.ɵɵpipe(2, "showRowOnPickup");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r7 = i0.ɵɵnextContext().row;
    const _r10 = i0.ɵɵreference(2);
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", row_r7 && i0.ɵɵpipeBind3(2, 2, row_r7, ctx_r9.isExPickup, ctx_r9.data == null ? null : ctx_r9.data.__proto__ == null ? null : ctx_r9.data.__proto__.pickupIgnoredField))("ngIfElse", _r10);
} }
const _c4$7 = function (a0) { return { "height.px": a0 }; };
function ExRecordComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c4$7, ctx_r11.emptyRowHeight));
} }
function ExRecordComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExRecordComponent_ng_template_1_ng_container_0_Template, 3, 6, "ng-container", 6);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_1_ng_template_1_Template, 2, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const row_r7 = ctx.row;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", row_r7.key !== (ctx_r2.data.__proto__.title == null ? null : ctx_r2.data.__proto__.title.key));
} }
const _c5$6 = function (a0) { return { row: a0 }; };
function ExRecordComponent_ng_template_3_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r42 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r42));
} }
function ExRecordComponent_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_3_div_1_div_1_Template, 2, 4, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r33.breakpoints["breakpoint" + ctx_r33.breakpoint].preRow);
} }
const _c6$6 = function (a0) { return { "ex-avatar-placeholder": a0 }; };
function ExRecordComponent_ng_template_3_ex_thumbnail_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-thumbnail", 34);
    i0.ɵɵpipe(1, "isAvatarPlaceholder");
    i0.ɵɵpipe(2, "isAvatarPlaceholder");
    i0.ɵɵpipe(3, "exUnderThumbnailIcons");
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c6$6, i0.ɵɵpipeBind1(1, 10, ctx_r34.data)))("imgSrc", ctx_r34.data[ctx_r34.data.__proto__.thumbnail.key])("googleSrc", ctx_r34.data.googleThumbnail)("syndeticsSrc", ctx_r34.data.syndeticsThumbnail)("imgType", ctx_r34.data.__proto__.thumbnail.type)("showPlaceholder", i0.ɵɵpipeBind1(2, 12, ctx_r34.data[ctx_r34.data.__proto__.thumbnail.key] == "placeHolder" || ctx_r34.data))("placeHolderType", ctx_r34.data.__proto__.thumbnail.placeHolderType)("icon", ctx_r34.data[ctx_r34.data.__proto__.thumbnailIcon == null ? null : ctx_r34.data.__proto__.thumbnailIcon.key])("fixedWidth", ctx_r34.data.__proto__.thumbnail.size === "large" ? 68 : 33)("underThumbnailIcons", i0.ɵɵpipeBind1(3, 14, ctx_r34.data));
} }
const _c7$5 = function (a0) { return { isSelected: a0 }; };
function ExRecordComponent_ng_template_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelement(1, "ex-label", 36);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵelementContainer(3, 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r38 = i0.ɵɵreference(9);
    const ctx_r35 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-record-title-and-actions-title sel-", ctx_r35.data.__proto__.title.key, "");
    i0.ɵɵproperty("highlightedText", ctx_r35.highlightedText)("value", ctx_r35.data[ctx_r35.data.__proto__.title.key])("isBold", true)("displayTooltip", true);
    i0.ɵɵattribute("role", "heading")("aria-level", "3");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("max-width", 40 + 150 * (ctx_r35.data == null ? null : ctx_r35.data.__proto__ == null ? null : ctx_r35.data.__proto__.actions == null ? null : ctx_r35.data.__proto__.actions.visibleBtnNum), "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r38)("ngTemplateOutletContext", i0.ɵɵpureFunction1(13, _c7$5, ctx_r35.isSelected));
} }
const _c8$5 = function (a0, a1) { return { row: a0, isTitle: a1 }; };
function ExRecordComponent_ng_template_3_ng_container_6_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 33);
} if (rf & 2) {
    const row_r47 = ctx.$implicit;
    const rowIndex_r48 = ctx.index;
    const colIndex_r44 = i0.ɵɵnextContext(2).index;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c8$5, row_r47, rowIndex_r48 == 0 && colIndex_r44 == 0));
} }
function ExRecordComponent_ng_template_3_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵpipe(1, "flexValueForColumns");
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_3_ng_container_6_div_1_ng_container_2_Template, 1, 5, "ng-container", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext();
    const colIndex_r44 = ctx_r50.index;
    const column_r43 = ctx_r50.$implicit;
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("sel-ex-record-column-" + (colIndex_r44 + 1));
    i0.ɵɵstyleProp("flex", i0.ɵɵpipeBind2(1, 6, ctx_r45.data.__proto__.record, colIndex_r44));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", column_r43)("ngForTrackBy", ctx_r45.trackByRowId);
} }
function ExRecordComponent_ng_template_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_3_ng_container_6_div_1_Template, 3, 9, "div", 38);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const colIndex_r44 = ctx.index;
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", colIndex_r44 < ctx_r36.breakpoint && (!ctx_r36.isGalleryLayout || colIndex_r44 !== 0));
} }
function ExRecordComponent_ng_template_3_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementContainer(2, 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r59 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r59));
} }
function ExRecordComponent_ng_template_3_div_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r60 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r55 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r55)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r60));
} }
function ExRecordComponent_ng_template_3_div_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r61 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r55 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r55)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r61));
} }
function ExRecordComponent_ng_template_3_div_7_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r62 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r55 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r55)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r62));
} }
function ExRecordComponent_ng_template_3_div_7_ng_template_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r63 = i0.ɵɵnextContext().row;
    i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r63));
} }
function ExRecordComponent_ng_template_3_div_7_ng_template_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r63 = i0.ɵɵnextContext().row;
    i0.ɵɵnextContext(3);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c5$6, row_r63));
} }
function ExRecordComponent_ng_template_3_div_7_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 11);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_3_div_7_ng_template_9_ng_container_1_Template, 2, 4, "ng-container", 46);
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_3_div_7_ng_template_9_ng_container_2_Template, 4, 4, "ng-container", 46);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r63 = ctx.row;
    i0.ɵɵproperty("ngSwitch", !!row_r63.leadingField);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", true);
} }
function ExRecordComponent_ng_template_3_div_7_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementContainer(1, 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r38 = i0.ɵɵreference(9);
    const ctx_r57 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r38)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7$5, ctx_r57.isSelected));
} }
const _c9$4 = function (a0) { return { "selected": a0 }; };
function ExRecordComponent_ng_template_3_div_7_ex_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 49);
    i0.ɵɵlistener("click", function ExRecordComponent_ng_template_3_div_7_ex_button_12_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r68.onEditClicked()); });
    i0.ɵɵelement(1, "ex-svg-icon", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c9$4, ctx_r58.isSelected))("tooltip", "ng.general.edit");
} }
const _c10$3 = function (a0) { return { "ex-record-actions-column-non-shrinked": a0 }; };
function ExRecordComponent_ng_template_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵpipe(1, "getActionsColumnMinWidth");
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_3_div_7_ng_container_2_Template, 3, 4, "ng-container", 28);
    i0.ɵɵelementStart(3, "div", 42);
    i0.ɵɵtemplate(4, ExRecordComponent_ng_template_3_div_7_ng_container_4_Template, 2, 4, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 42);
    i0.ɵɵtemplate(6, ExRecordComponent_ng_template_3_div_7_ng_container_6_Template, 2, 4, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵtemplate(8, ExRecordComponent_ng_template_3_div_7_ng_container_8_Template, 2, 4, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExRecordComponent_ng_template_3_div_7_ng_template_9_Template, 3, 3, "ng-template", null, 43, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(11, ExRecordComponent_ng_template_3_div_7_div_11_Template, 2, 4, "div", 44);
    i0.ɵɵtemplate(12, ExRecordComponent_ng_template_3_div_7_ex_button_12_Template, 2, 4, "ex-button", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("min-width", i0.ɵɵpipeBind2(1, 13, ctx_r37.data, ctx_r37.breakpoint));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c10$3, ctx_r37.breakpoint !== 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r37.breakpoints["breakpoint" + ctx_r37.breakpoint].actions)("ngForTrackBy", ctx_r37.trackByActionId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r37.breakpoints["breakpoint" + ctx_r37.breakpoint].actions_horizontal_1)("ngForTrackBy", ctx_r37.trackByActionId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r37.breakpoints["breakpoint" + ctx_r37.breakpoint].actions_horizontal_2)("ngForTrackBy", ctx_r37.trackByActionId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r37.breakpoints["breakpoint" + ctx_r37.breakpoint].actions_horizontal_3)("ngForTrackBy", ctx_r37.trackByActionId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !(ctx_r37.data.__proto__.title == null ? null : ctx_r37.data.__proto__.title.key));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.isSingleSave && ctx_r37.data[ctx_r37.data.__proto__.editableKey] != false && !ctx_r37.inExSidepanePickup && !ctx_r37.isGalleryLayout);
} }
function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ex_record_actions_2_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-record-actions", 53);
    i0.ɵɵlistener("actionClicked", function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ex_record_actions_2_Template_ex_record_actions_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r75.onActionClicked($event)); });
    i0.ɵɵpipe(1, "exDisplayActions");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isSelected_r70 = i0.ɵɵnextContext(2).isSelected;
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("actions", i0.ɵɵpipeBind2(1, 5, ctx_r72.data.actions == null ? null : ctx_r72.data.actions.actions, false))("visibleBtnNum", ctx_r72.data.__proto__.actions == null ? null : ctx_r72.data.__proto__.actions.visibleBtnNum)("loading", ctx_r72.data.actions == null ? null : ctx_r72.data.actions.loading)("isSelected", isSelected_r70)("index", ctx_r72.recordIndex);
} }
const _c11$2 = function (a0, a1, a2) { return { "isSelected": a0, "htmlId": a1, "isItemOpen": a2 }; };
function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ng_template_3_ex_component_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 56, 57);
    i0.ɵɵpipe(2, "objectAssign");
} if (rf & 2) {
    const isSelected_r70 = i0.ɵɵnextContext(3).isSelected;
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("componentFactoryItem", ctx_r78.dynamicActionsComponent)("data", i0.ɵɵpipeBind2(2, 3, ctx_r78.data.actions.inputs, i0.ɵɵpureFunction3(6, _c11$2, isSelected_r70, ctx_r78.htmlId, ctx_r78.isItemOpen)))("events", ctx_r78.data.actions.events);
} }
function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵlistener("focusin", function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ng_template_3_Template_div_focusin_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ng_template_3_ex_component_loader_1_Template, 3, 10, "ex-component-loader", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.data.__proto__.actions && ctx_r74.data[ctx_r74.data.__proto__.actions.key] !== null);
} }
function ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ex_record_actions_2_Template, 2, 8, "ex-record-actions", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_ng_template_3_Template, 2, 1, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r73 = i0.ɵɵreference(4);
    const ctx_r71 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("hidden-element", !(ctx_r71.data.__proto__.actions.displayAlways || ctx_r71.breakpoint !== 1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r71.data.__proto__.actions == null ? null : ctx_r71.data.__proto__.actions.type))("ngIfElse", _r73);
} }
function ExRecordComponent_ng_template_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExRecordComponent_ng_template_3_ng_template_8_ng_container_0_Template, 5, 4, "ng-container", 6);
    i0.ɵɵpipe(1, "showRowOnPickup");
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(1, 1, ctx_r39.data.__proto__.actions, ctx_r39.isExPickup, ctx_r39.data == null ? null : ctx_r39.data.__proto__ == null ? null : ctx_r39.data.__proto__.pickupIgnoredField) && !ctx_r39.isGalleryLayout);
} }
function ExRecordComponent_ng_template_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ex-component-loader", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("componentFactoryItem", ctx_r40.data.__proto__.footer.type)("data", ctx_r40.data[ctx_r40.data.__proto__.footer.key].inputs)("events", ctx_r40.data[ctx_r40.data.__proto__.footer.key].outputs);
} }
function ExRecordComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ExRecordComponent_ng_template_3_div_1_Template, 2, 1, "div", 23);
    i0.ɵɵtemplate(2, ExRecordComponent_ng_template_3_ex_thumbnail_2_Template, 4, 18, "ex-thumbnail", 24);
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵtemplate(4, ExRecordComponent_ng_template_3_div_4_Template, 4, 15, "div", 26);
    i0.ɵɵelementStart(5, "div", 27);
    i0.ɵɵtemplate(6, ExRecordComponent_ng_template_3_ng_container_6_Template, 2, 1, "ng-container", 28);
    i0.ɵɵtemplate(7, ExRecordComponent_ng_template_3_div_7_Template, 13, 18, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ExRecordComponent_ng_template_3_ng_template_8_Template, 2, 5, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ExRecordComponent_ng_template_3_div_10_Template, 2, 3, "div", 6);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ex-record-gallery-layout", ctx_r4.isGalleryLayout);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].preRow == null ? null : ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].preRow.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.hasThumbnail && ctx_r4.showThumbnail);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.data.__proto__.title == null ? null : ctx_r4.data.__proto__.title.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint])("ngForTrackBy", ctx_r4.trackByColumnIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r4.data.__proto__.title == null ? null : ctx_r4.data.__proto__.title.key) && (ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions == null ? null : ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions.length) > 0 || (ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_1 == null ? null : ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_1.length) > 0 || (ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_2 == null ? null : ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_2.length) > 0 || (ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_3 == null ? null : ctx_r4.breakpoints["breakpoint" + ctx_r4.breakpoint].actions_horizontal_3.length) > 0 || !(ctx_r4.data.__proto__.title == null ? null : ctx_r4.data.__proto__.title.key) && ctx_r4.data.__proto__.actions && (ctx_r4.data.__proto__.actions.displayAlways || ctx_r4.breakpoint !== 1) && ctx_r4.data[ctx_r4.data.__proto__.actions.key] !== null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.data.__proto__.footer);
} }
const ALL_COLUMNS = [0, 1, 2, 'actions', 'actions_horizontal_1', 'actions_horizontal_2', 'actions_horizontal_3', 'preRow'];
class ExRecordComponent {
    set data(data) {
        this._data = data;
        this.initComponentFactoryItems();
        this.hasThumbnail = this._hasThumbnail() || this.isAvatarPlaceholder();
    }
    get data() {
        return this._data;
    }
    constructor(itemsLayoutService, isSingleSave) {
        this.itemsLayoutService = itemsLayoutService;
        this.isSingleSave = isSingleSave;
        this.NUM_COLUMNS = 3;
        this.isItemOpen = false;
        this.isSelected = false;
        this.emptyRowHeight = 7;
        this.highlightedText = '';
        this.showThumbnail = true;
        this.width = 1000;
        this.isGalleryLayout = false;
        this.actionClicked = new EventEmitter();
        this.breakpoint = 3;
        this.hasThumbnail = false;
        this.pickupAction = [{ label: 'ng.general.select', onClick: this.onPickupSelectedClicked.bind(this), disabled: false, loading: false }];
        this.componentFactoryItemsMap = {};
        this.OtbRecordFieldComponentTypes = {
            label: ExLabelComponent,
            chip: ExChipRecordComponent,
            entityLabels: ExChipRecordEntityLabelsComponent
        };
        this.subs = new Subscription();
        this.breakpoints = {
            breakpoint1: [],
            breakpoint2: [],
            breakpoint3: []
        };
    }
    ngOnInit() {
        this.sortAndFilterColumns(null);
        this.recordCustomizationData?.subscribe(data => {
            this.sortAndFilterColumns(data);
        });
        if (!this.isGalleryLayout) {
            this.subs.add(this.itemsLayoutService.listBreakPoint$.subscribe(breakpoint => this.breakpoint = breakpoint));
        }
    }
    sortAndFilterColumns(customizedData) {
        [1, 2, 3].forEach(breakpoint => {
            this.breakpoints['breakpoint' + breakpoint] = [];
            this.sortAndFilterColumnsPerBreakpoint(breakpoint, customizedData);
        });
    }
    getColumnNum(customizedField, columnNum) {
        return customizedField.columnNum === 0 || customizedField.columnNum === 1 ? customizedField.columnNum : columnNum;
    }
    getUiOrder(customizedField, index) {
        return customizedField.columnNum === 0 || customizedField.columnNum === 1 ? customizedField.uiOrder : index;
    }
    sortAndFilterColumnsPerBreakpoint(breakpoint, customizedData) {
        const fields = [];
        ALL_COLUMNS.forEach(columnNum => {
            this.data.__proto__['columns' + breakpoint][columnNum]?.forEach((field, index) => {
                const customizedField = customizedData?.find(customizedField => {
                    return customizedField.itemId === field.key;
                });
                if (customizedField) {
                    customizedField.show && fields.push({ ...field, uiOrder: this.getUiOrder(customizedField, index), columnNum: this.getColumnNum(customizedField, columnNum) });
                }
                else {
                    if (!field.isHidden) {
                        fields.push({ ...field, uiOrder: index, columnNum });
                    }
                }
            });
        });
        fields.forEach(field => {
            if (this.breakpoints['breakpoint' + breakpoint][field.columnNum]) {
                this.breakpoints['breakpoint' + breakpoint][field.columnNum].push(field);
            }
            else {
                this.breakpoints['breakpoint' + breakpoint][field.columnNum] = [field];
            }
        });
        ALL_COLUMNS.forEach(columnNum => {
            if (this.breakpoints['breakpoint' + breakpoint][columnNum]) {
                this.breakpoints['breakpoint' + breakpoint][columnNum].sort((item1, item2) => item1.uiOrder - item2.uiOrder);
            }
        });
    }
    initComponentFactoryItems() {
        if (this.data.__proto__.actions?.type) {
            this.dynamicActionsComponent = new ExComponentFactoryItem(this.data.__proto__.actions.type, {});
        }
        for (let breakpoint = 1; breakpoint <= this.NUM_COLUMNS; breakpoint++) {
            this.createComponentFactoryItemsForBreakpoint(this.data.__proto__['columns' + breakpoint]);
        }
    }
    createComponentFactoryItemsForBreakpoint(columns) {
        if (!columns)
            return;
        for (const [key, value] of Object.entries(columns)) {
            this.createComponentFactoryItemsForColumn(value);
        }
    }
    createComponentFactoryItemsForColumn(column) {
        if (!column)
            return;
        column.forEach(field => {
            if (field.type) {
                this.componentFactoryItemsMap[field.key] = new ExComponentFactoryItem(field.type, {});
            }
        });
    }
    getRowActions() {
        if (!this.data.__proto__.actions?.type) {
            return this.data.actions?.actions;
        }
        else { // actions component
            return this.actions?.last?.componentRef?.instance?.actions;
        }
    }
    _hasThumbnail() {
        return this.data.__proto__.thumbnail && !!this.data[this.data.__proto__.thumbnail.key];
    }
    isAvatarPlaceholder() {
        const { type, key } = this.data.__proto__.thumbnail ?? {};
        return type === 'avatar' && key && !this.data[key];
    }
    setFlexValueForColumns(record, column) {
        switch (record.layout) {
            case 'extend':
                if (column == 0)
                    return 2;
                else
                    return 1;
            case 'normal':
                return 1;
            case 'customized':
                if (!record.customizedLayout)
                    record.customizedLayout = [1, 1, 1];
                return record.customizedLayout[column];
            default:
                break;
        }
    }
    getThumbnailData() {
        return this.data[this.data.__proto__.thumbnail.key];
    }
    getHighlightedText(field) {
        if (field.showHighlight) {
            return this.highlightedText;
        }
        else {
            return null;
        }
    }
    getIsDisabled(field) {
        if (field.showDisabled) {
            return this.data.isDisabled;
        }
        else {
            return false;
        }
    }
    isDisabledInPickup(field) {
        if (this.inExSidepanePickup && field.type?.name === ExSlideToggleComponent.name) {
            return true;
        }
        return this.data[field.key]?.inputs?.disabled;
    }
    getActionsColumnMinWidth() {
        if (this.breakpoint === 1)
            return 'unset';
        if (this.data.__proto__?.title?.key)
            return '150px';
        return 40 + 150 * this.data?.__proto__?.actions?.visibleBtnNum + 'px';
    }
    onActionClicked(key) {
        this.actionClicked.emit(key);
    }
    onEditClicked() {
        this.actionClicked.emit(SINGLE_SAVE_EDIT_ACTION_KEY);
    }
    onPickupSelectedClicked() {
        this.actionClicked.emit(PICKUP_ACTION_KEY);
    }
    get ignoredByPickupFields() {
        return this._data?.__proto__?.pickupIgnoredField;
    }
    showOnPickup(row) {
        if (!this.isExPickup || !this.ignoredByPickupFields || !row.key) {
            return true;
        }
        return !this.ignoredByPickupFields.has(row.key);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    trackByRowId(index, row) {
        return row?.key;
    }
    trackByColumnIndex(index, column) {
        return index;
    }
    trackByActionId(index, action) {
        return action?.key;
    }
    static { this.ɵfac = function ExRecordComponent_Factory(t) { return new (t || ExRecordComponent)(i0.ɵɵdirectiveInject(ExItemsLayoutService, 8), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRecordComponent, selectors: [["ex-record"]], viewQuery: function ExRecordComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$p, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actions = _t);
        } }, inputs: { data: "data", isItemOpen: "isItemOpen", isSelected: "isSelected", emptyRowHeight: "emptyRowHeight", highlightedText: "highlightedText", htmlId: "htmlId", isExPickup: "isExPickup", inExSidepanePickup: "inExSidepanePickup", recordCustomizationData: "recordCustomizationData", showThumbnail: "showThumbnail", recordIndex: "recordIndex", width: "width", isGalleryLayout: "isGalleryLayout", breakpoint: "breakpoint" }, outputs: { actionClicked: "actionClicked" }, decls: 5, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], ["field", ""], ["record", ""], [3, "ngClass"], [3, "actions", "actionClicked"], [3, "ngTemplateOutlet"], [4, "ngIf"], ["emptyRow", ""], [4, "ngIf", "ngIfElse"], ["customFieldText", ""], ["dynamicInputsComponent", ""], [3, "ngSwitch"], [3, "class", "svgIcon", "highlightedText", "label", "iconType", "iconName", "iconColor", "value", "isBold", "isStrikeThrough", "style", "hasColon", "displayTooltip", "htmlId", 4, "ngSwitchCase"], [3, "breakpoint", "chips", "iconType", 4, "ngSwitchCase"], [3, "breakpoint", "entityLabels", "iconType", 4, "ngSwitchCase"], [3, "svgIcon", "highlightedText", "label", "iconType", "iconName", "iconColor", "value", "isBold", "isStrikeThrough", "hasColon", "displayTooltip", "htmlId"], [3, "breakpoint", "chips", "iconType"], [3, "breakpoint", "entityLabels", "iconType"], [3, "class", "style", "componentFactoryItem", "data", "content", "events", 4, "ngIf"], [3, "componentFactoryItem", "data", "content", "events"], [3, "highlightedText", "label", "svgIcon", "iconType", "iconName", "iconColor", "value", "isBold", "isStrikeThrough", "hasColon", "displayTooltip", "htmlId"], [3, "ngStyle"], [1, "ex-record-wrapper"], ["class", "ex-record-preRow-column", 4, "ngIf"], ["class", "ex-record-thumbnail", 3, "ngClass", "imgSrc", "googleSrc", "syndeticsSrc", "imgType", "showPlaceholder", "placeHolderType", "icon", "fixedWidth", "underThumbnailIcons", 4, "ngIf"], [1, "ex-record-content-wrapper"], ["class", "ex-record-title-and-actions", 4, "ngIf"], [1, "ex-record-column-wrapper"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "ex-record-actions-column", 3, "ngClass", "minWidth", 4, "ngIf"], ["exRecordActionsComponent", ""], [1, "ex-record-preRow-column"], [4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-record-thumbnail", 3, "ngClass", "imgSrc", "googleSrc", "syndeticsSrc", "imgType", "showPlaceholder", "placeHolderType", "icon", "fixedWidth", "underThumbnailIcons"], [1, "ex-record-title-and-actions"], [3, "highlightedText", "value", "isBold", "displayTooltip"], [1, "ex-record-title-and-actions-actions"], ["class", "ex-record-column", 3, "class", "flex", 4, "ngIf"], [1, "ex-record-column"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "ex-record-actions-column", 3, "ngClass"], [1, "ex-record-actions-column-horizontal-container"], ["actionsHorizontal", ""], ["class", "ex-record-actions", 4, "ngIf"], ["class", "ex-record-actions-edit", "ariaLabel", "ng.general.edit", 3, "ngClass", "tooltip", "click", 4, "ngIf"], [4, "ngSwitchCase"], [1, "ex-record-actions-column-horizontal-divider"], [1, "ex-record-actions"], ["ariaLabel", "ng.general.edit", 1, "ex-record-actions-edit", 3, "ngClass", "tooltip", "click"], ["iconName", "edit", "color", "#4164a4"], [3, "actions", "visibleBtnNum", "loading", "isSelected", "index", "actionClicked", 4, "ngIf", "ngIfElse"], ["actionsComponentLoader", ""], [3, "actions", "visibleBtnNum", "loading", "isSelected", "index", "actionClicked"], [3, "focusin"], ["class", "ex-record-actions-loader", 3, "componentFactoryItem", "data", "events", 4, "ngIf"], [1, "ex-record-actions-loader", 3, "componentFactoryItem", "data", "events"], ["actions", ""]], template: function ExRecordComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExRecordComponent_div_0_Template, 3, 5, "div", 0);
            i0.ɵɵtemplate(1, ExRecordComponent_ng_template_1_Template, 3, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ExRecordComponent_ng_template_3_Template, 11, 9, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.__proto__);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i1$5.NgSwitch, i1$5.NgSwitchCase, ExComponentLoaderComponent, ExButtonComponent, ExChipRecordComponent, ExChipRecordEntityLabelsComponent, ExRightClickActionsComponent, ExRecordActionsComponent, ExThumbnailComponent, ExLabelComponent, ExSvgIconComponent, ExObjectAssignPipe, ExUnderThumbnailIconsPipe, ExDisplayActionsPipe, FlexValueForColumns, ShowRowOnPickup, GetHighlightedText, GetIsDisabled, IsDisabledInPickup, IsAvatarPlaceholder, GetActionsColumnMinWidth], styles: [".ex-record-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;position:relative}.ex-record-wrapper.ex-record-gallery-layout[_ngcontent-%COMP%]{width:100px}.ex-record-wrapper.ex-record-gallery-layout[_ngcontent-%COMP%]     .ex-label-wrapper{display:contents!important}.ex-record-wrapper.ex-record-gallery-layout[_ngcontent-%COMP%]   .ex-record-actions-column-horizontal-container[_ngcontent-%COMP%]{border-inline-start:1px solid rgba(0,0,0,.1215686275);width:calc(100% - 1px);justify-content:flex-end}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]   .ex-record-title-and-actions[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:1px;margin-bottom:4px}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]   .ex-record-title-and-actions[_ngcontent-%COMP%]   .ex-record-title-and-actions-title[_ngcontent-%COMP%]{margin-inline-end:8px;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]   .ex-record-title-and-actions[_ngcontent-%COMP%]   .ex-record-title-and-actions-actions[_ngcontent-%COMP%]     .ex-record-actions-wrapper{flex-wrap:unset!important}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]   .ex-record-title-and-actions[_ngcontent-%COMP%]   .ex-record-title-and-actions-actions[_ngcontent-%COMP%]     .ex-record-actions-main-buttons-label-wrapper{max-width:500px!important}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-content-wrapper[_ngcontent-%COMP%]   .ex-record-column-wrapper[_ngcontent-%COMP%]{display:flex}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1;word-break:break-word;min-width:115px;width:0}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-column[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-column[_ngcontent-%COMP%]   .ex-record-label[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-avatar-placeholder[_ngcontent-%COMP%]{margin-top:0}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-end}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]   .ex-record-actions-column-horizontal-container[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;flex-wrap:wrap}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]   .ex-record-actions-column-horizontal-container[_ngcontent-%COMP%]   .ex-record-actions-column-horizontal-divider[_ngcontent-%COMP%]{border-inline-end:1px solid rgba(0,0,0,.1215686275);margin-inline-end:4px}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]   .ex-record-actions[_ngcontent-%COMP%]{display:flex}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]   .ex-record-actions-edit[_ngcontent-%COMP%]{margin-inline-start:5px;align-self:flex-end;margin-top:auto}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column[_ngcontent-%COMP%]   .ex-record-actions-edit.selected[_ngcontent-%COMP%]     button{background-color:#c6e9ff}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-actions-column-non-shrinked[_ngcontent-%COMP%]{width:0}.ex-record-wrapper[_ngcontent-%COMP%]   .ex-record-preRow-column[_ngcontent-%COMP%]{margin-right:10px}.ex-record-thumbnail[_ngcontent-%COMP%]{margin-top:4px}.ex-record-floating-actions[_ngcontent-%COMP%]{position:relative}.ex-record-floating-actions[_ngcontent-%COMP%]   .ex-record-actions-loader[_ngcontent-%COMP%]{position:absolute;right:0;bottom:0;opacity:0}.ex-record-floating-actions[_ngcontent-%COMP%]:hover   .ex-record-actions-loader[_ngcontent-%COMP%], .ex-record-floating-actions[_ngcontent-%COMP%]:focus-within   .ex-record-actions-loader[_ngcontent-%COMP%]{opacity:1}.ex-record-full-width[_ngcontent-%COMP%]{max-width:100%}html[dir=rtl]   [_nghost-%COMP%]   .ex-record-floating-actions[_ngcontent-%COMP%]   .ex-record-actions-loader[_ngcontent-%COMP%], html[dir=rtl]   [_nghost-%COMP%]   .ex-record-floating-actions[_ngcontent-%COMP%]   .ex-record-actions[_ngcontent-%COMP%]{right:unset;left:0}.hidden-element[_ngcontent-%COMP%]{visibility:hidden;width:0;height:0;min-width:0!important;flex:0!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordComponent, [{
        type: Component,
        args: [{ selector: 'ex-record', template: "<div [ngClass]=\"{ 'ex-record-floating-actions': data.__proto__.actions?.isFloating }\" *ngIf=\"data?.__proto__\">\n  <ex-right-click-actions [actions]=\"getRowActions()\" (actionClicked)=\"onActionClicked($event)\">\n    <ng-container [ngTemplateOutlet]=\"record\">\n    </ng-container>\n  </ex-right-click-actions>\n</div>\n\n<ng-template #field let-row=\"row\" let-isTitle=\"isTitle\">\n  <ng-container *ngIf=\"row.key !== data.__proto__.title?.key\">\n    <ng-container *ngIf=\"row && (row | showRowOnPickup:isExPickup:data?.__proto__?.pickupIgnoredField); else emptyRow\">\n    <ng-container *ngIf=\"row.type; else customFieldText\">\n      <ng-container *ngIf=\"row.staticInputs; else dynamicInputsComponent\">\n\n        <!-- field using non-custom field decorator (except components from core-platform such as HepSmartLink) -->\n        <ng-container [ngSwitch]=\"row.type\">\n          <ex-label *ngSwitchCase=\"OtbRecordFieldComponentTypes.label\" class=\"sel-{{ row.key }} ex-record-label\" [svgIcon]=\"data[row.key]?.icon?.iconType == 'svg' ? data[row.key]?.icon : undefined\"\n            [highlightedText]=\"row | getHighlightedText:highlightedText\" [label]=\"row.label\" [iconType]=\"data[row.key]?.icon?.iconType\"\n            [iconName]=\"data[row.key]?.icon?.iconName\" [iconColor]=\"data[row.key]?.icon?.iconColor\"\n            [value]=\"data[row.key]?.value\" [isBold]=\"row.isBold\" [isStrikeThrough]=\"row | getIsDisabled:data.isDisabled\"\n            [style]=\"row.style\" [hasColon]=\"row.hasColon\" [displayTooltip]=\"row.displayTooltip\"\n            htmlId=\"{{ htmlId }}{{ htmlId ? '_' : '' }}{{ row.htmlId }}\"\n            [attr.role]=\"isTitle ? 'heading' : ''\" [attr.aria-level]=\"isTitle ? '3' : '4'\">\n          </ex-label>\n\n          <ex-chip-record *ngSwitchCase=\"OtbRecordFieldComponentTypes.chip\" [breakpoint]=\"breakpoint\"\n            [chips]=\"data[row.key]\" [iconType]=\"'svg'\">\n          </ex-chip-record>\n\n          <ex-chip-record-entity-labels *ngSwitchCase=\"OtbRecordFieldComponentTypes.entityLabels\" [breakpoint]=\"breakpoint\"\n            [entityLabels]=\"data[row.key]\" [iconType]=\"'svg'\">\n          </ex-chip-record-entity-labels>\n        </ng-container>\n\n      </ng-container>\n\n      <ng-template #dynamicInputsComponent>\n        <!-- field using CustomField decorator and also used for otb supported components from core-platform such as HepSmartLink -->\n        <ex-component-loader *ngIf=\"data[row.key]\" class=\"ex-record-full-width sel-{{ row.key }} sel-{{ row.key }}-{{data['id']}}\" [style]=\"row.style\"\n                             [componentFactoryItem]=\"componentFactoryItemsMap[row.key]\"\n                             [data]=\"data[row.key]?.inputs | objectAssign : { highlightedText: (row | getHighlightedText:highlightedText), disabled: (row | isDisabledInPickup: data:inExSidepanePickup), isDisabled: (row | getIsDisabled:data.isDisabled), htmlId: htmlId, breakpoint: breakpoint }\"\n          [content]=\"data[row.key]?.content\" [events]=\"data[row.key]?.events || {}\"\n          [attr.role]=\"isTitle ? 'heading' : ''\" [attr.aria-level]=\"isTitle ? '3' : '4'\">\n        </ex-component-loader>\n      </ng-template>\n    </ng-container>\n\n    <ng-template #customFieldText>\n      <!-- field using CustomField decorator without type; DEPRECATED - should use LabelField decorator instead -->\n      <ex-label class=\"sel-{{ row.key }} ex-record-label\" [highlightedText]=\"row | getHighlightedText:highlightedText\" [label]=\"row.label\" [svgIcon] = \"row.icon?? undefined\"\n        [iconType]=\"row.iconType\" [iconName]=\"row.iconName\" [iconColor]=\"row.iconColor\" [value]=\"data[row.key]\"\n        [isBold]=\"row.isBold\" [isStrikeThrough]=\"row | getIsDisabled:data.isDisabled\" [style]=\"row.style\" [hasColon]=\"row.hasColon\"\n        [displayTooltip]=\"row.displayTooltip\" htmlId=\"{{ htmlId }}{{ htmlId ? '_' : '' }}{{ row.htmlId }}\"\n        [attr.role]=\"isTitle ? 'heading' : ''\" [attr.aria-level]=\"isTitle ? '3' : '4'\">\n      </ex-label>\n    </ng-template>\n\n    </ng-container>\n  </ng-container>\n\n  <ng-template #emptyRow>\n    <span [ngStyle]=\"{'height.px': emptyRowHeight}\">&nbsp;</span>\n  </ng-template>\n</ng-template>\n\n<ng-template #record>\n  <div class=\"ex-record-wrapper\" [class.ex-record-gallery-layout]=\"isGalleryLayout\">\n\n    <!-- ### pre-row ###-->\n    <div *ngIf=\"breakpoints['breakpoint' + breakpoint].preRow?.length > 0\" class=\"ex-record-preRow-column\">\n      <div *ngFor=\"let row of breakpoints['breakpoint' + breakpoint].preRow\">\n        <ng-container [ngTemplateOutlet]=\"field\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n      </div>\n    </div>\n\n    <!-- ### thumbnail ###-->\n    <ex-thumbnail class=\"ex-record-thumbnail\" *ngIf=\"hasThumbnail && showThumbnail\"\n      [ngClass]=\"{'ex-avatar-placeholder': data | isAvatarPlaceholder}\" [imgSrc]=\"data[data.__proto__.thumbnail.key]\"\n      [googleSrc]=\"data.googleThumbnail\" [syndeticsSrc]=\"data.syndeticsThumbnail\"\n      [imgType]=\"this.data.__proto__.thumbnail.type\"\n      [showPlaceholder]=\"this.data[this.data.__proto__.thumbnail.key] == 'placeHolder' || data | isAvatarPlaceholder\"\n      [placeHolderType]=\"data.__proto__.thumbnail.placeHolderType\" [icon]=\"data[this.data.__proto__.thumbnailIcon?.key]\"\n      [fixedWidth]=\"data.__proto__.thumbnail.size === 'large' ? 68 : 33\" [underThumbnailIcons]=\"this.data | exUnderThumbnailIcons\"></ex-thumbnail>\n    <!-- ### first line and columns 1-3 ###-->\n    <div class=\"ex-record-content-wrapper\">\n      <!-- ### first line ###-->\n      <div *ngIf=\"this.data.__proto__.title?.key\" class=\"ex-record-title-and-actions\">\n        <!-- ## title ##-->\n        <ex-label class=\"ex-record-title-and-actions-title sel-{{ this.data.__proto__.title.key }}\"\n          [highlightedText]=\"highlightedText\" [value]=\"data[data.__proto__.title.key]\"\n          [isBold]=\"true\" [displayTooltip]=\"true\" [attr.role]=\"'heading'\" [attr.aria-level]=\"'3'\">\n        </ex-label>\n        <!-- ## actions ##-->\n        <div class=\"ex-record-title-and-actions-actions\" [style.maxWidth.px]=\"40 + 150 * this.data?.__proto__?.actions?.visibleBtnNum\">\n          <ng-container [ngTemplateOutlet]=\"exRecordActionsComponent\" [ngTemplateOutletContext]=\"{ isSelected: isSelected }\"></ng-container>\n        </div>\n      </div>\n\n      <!-- ### columns 1-3 ###-->\n      <div class=\"ex-record-column-wrapper\">\n    <ng-container *ngFor=\"let column of breakpoints['breakpoint' + breakpoint]; let colIndex = index; trackBy:trackByColumnIndex\">\n      <div class=\"ex-record-column\" [class]=\"'sel-ex-record-column-' + (colIndex + 1)\" [style.flex]=\"data.__proto__.record | flexValueForColumns: colIndex\"\n        *ngIf=\"colIndex < breakpoint && (!isGalleryLayout || (colIndex !== 0))\">\n        <ng-container *ngFor=\"let row of column; let rowIndex = index;trackBy:trackByRowId\" [ngTemplateOutlet]=\"field\" [ngTemplateOutletContext]=\"{ row: row, isTitle: (rowIndex == 0 && colIndex == 0) }\">\n        </ng-container>\n      </div>\n    </ng-container>\n\n    <div class=\"ex-record-actions-column\" [ngClass]=\"{'ex-record-actions-column-non-shrinked' : breakpoint !== 1}\"\n     [style.minWidth]=\"data | getActionsColumnMinWidth:breakpoint\"\n     *ngIf=\"(!this.data.__proto__.title?.key && breakpoints['breakpoint' + breakpoint].actions?.length > 0)\n      || breakpoints['breakpoint' + breakpoint].actions_horizontal_1?.length > 0\n      || breakpoints['breakpoint' + breakpoint].actions_horizontal_2?.length > 0\n      || breakpoints['breakpoint' + breakpoint].actions_horizontal_3?.length > 0\n      || (!this.data.__proto__.title?.key && data.__proto__.actions && (data.__proto__.actions.displayAlways\n      || breakpoint !== 1) && data[data.__proto__.actions.key] !== null)\">\n\n      <!-- ## actions column fields ##-->\n      <ng-container *ngFor=\"let row of breakpoints['breakpoint' + breakpoint].actions;trackBy:trackByActionId\">\n        <div>\n          <ng-container [ngTemplateOutlet]=\"field\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n        </div>\n      </ng-container>\n      <div class=\"ex-record-actions-column-horizontal-container\">\n        <ng-container *ngFor=\"let row of breakpoints['breakpoint' + breakpoint].actions_horizontal_1;trackBy:trackByActionId\">\n          <ng-container [ngTemplateOutlet]=\"actionsHorizontal\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n        </ng-container>\n      </div>\n      <div class=\"ex-record-actions-column-horizontal-container\">\n        <ng-container *ngFor=\"let row of breakpoints['breakpoint' + breakpoint].actions_horizontal_2;trackBy:trackByActionId\">\n          <ng-container [ngTemplateOutlet]=\"actionsHorizontal\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n        </ng-container>\n      </div>\n      <div class=\"ex-record-actions-column-horizontal-container\">\n        <ng-container *ngFor=\"let row of breakpoints['breakpoint' + breakpoint].actions_horizontal_3;trackBy:trackByActionId\">\n          <ng-container [ngTemplateOutlet]=\"actionsHorizontal\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n        </ng-container>\n      </div>\n\n      <ng-template #actionsHorizontal let-row=\"row\">\n        <ng-container [ngSwitch]=\"!!row.leadingField\">\n          <ng-container *ngSwitchCase=\"false\">\n            <ng-container [ngTemplateOutlet]=\"field\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"true\">\n            <ng-container [ngTemplateOutlet]=\"field\" [ngTemplateOutletContext]=\"{ row: row }\"></ng-container>\n            <div class=\"ex-record-actions-column-horizontal-divider\">&nbsp;</div>\n          </ng-container>\n        </ng-container>\n      </ng-template>\n\n      <!-- ## actions ##-->\n      <div class=\"ex-record-actions\" *ngIf=\"!this.data.__proto__.title?.key\">\n       <ng-container [ngTemplateOutlet]=\"exRecordActionsComponent\" [ngTemplateOutletContext]=\"{ isSelected: isSelected }\"></ng-container>\n      </div>\n      <ex-button *ngIf=\"isSingleSave && this.data[this.data.__proto__.editableKey] != false && !inExSidepanePickup && !isGalleryLayout\"\n        class=\"ex-record-actions-edit\" [ngClass]=\"{'selected': isSelected}\" [tooltip]=\"'ng.general.edit'\"\n        (click)=\"onEditClicked()\" ariaLabel=\"ng.general.edit\">\n        <ex-svg-icon iconName=\"edit\" color=\"#4164a4\"></ex-svg-icon>\n      </ex-button>\n        </div>\n      </div>\n      <ng-template #exRecordActionsComponent let-isSelected=\"isSelected\">\n        <ng-container *ngIf=\"(data.__proto__.actions | showRowOnPickup:isExPickup:data?.__proto__?.pickupIgnoredField) && !isGalleryLayout\">\n          <div [class.hidden-element]=\"!(data.__proto__.actions.displayAlways || breakpoint !== 1)\">\n            <ex-record-actions *ngIf=\"!data.__proto__.actions?.type; else actionsComponentLoader\"\n              [actions]=\"data.actions?.actions| exDisplayActions : false\" [visibleBtnNum]=\"this.data.__proto__.actions?.visibleBtnNum\"\n              [loading]=\"data.actions?.loading\" [isSelected]=\"isSelected\" [index]=\"recordIndex\" (actionClicked)=\"onActionClicked($event)\">\n            </ex-record-actions>\n          </div>\n          <ng-template #actionsComponentLoader>\n            <!-- URM-180768; stop focusin event to prevent ex-list-layout from changing the selected item when clicking on an action -->\n            <div (focusin)=\"$event.stopPropagation()\">\n              <ex-component-loader class=\"ex-record-actions-loader\" #actions\n                 *ngIf=\"data.__proto__.actions && data[data.__proto__.actions.key] !== null\"\n                 [componentFactoryItem]=\"dynamicActionsComponent\"\n                 [data]=\"data.actions.inputs | objectAssign : { 'isSelected': isSelected, 'htmlId': htmlId, 'isItemOpen': isItemOpen }\" [events]=\"data.actions.events\">\n              </ex-component-loader>\n            </div>\n          </ng-template>\n        </ng-container>\n      </ng-template>\n    </div>\n  </div>\n  <div *ngIf=\"data.__proto__.footer\">\n    <ex-component-loader class=\"ex-record-actions-loader\"\n       [componentFactoryItem]=\"this.data.__proto__.footer.type\"\n       [data]=\"this.data[this.data.__proto__.footer.key].inputs\"\n       [events]=\"this.data[this.data.__proto__.footer.key].outputs\">\n    </ex-component-loader>\n  </div>\n</ng-template>\n", styles: [".ex-record-wrapper{display:flex;flex-direction:row;position:relative}.ex-record-wrapper.ex-record-gallery-layout{width:100px}.ex-record-wrapper.ex-record-gallery-layout ::ng-deep .ex-label-wrapper{display:contents!important}.ex-record-wrapper.ex-record-gallery-layout .ex-record-actions-column-horizontal-container{border-inline-start:1px solid rgba(0,0,0,.1215686275);width:calc(100% - 1px);justify-content:flex-end}.ex-record-wrapper .ex-record-content-wrapper{display:flex;flex-direction:column;flex:1}.ex-record-wrapper .ex-record-content-wrapper .ex-record-title-and-actions{display:flex;justify-content:space-between;margin-top:1px;margin-bottom:4px}.ex-record-wrapper .ex-record-content-wrapper .ex-record-title-and-actions .ex-record-title-and-actions-title{margin-inline-end:8px;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.ex-record-wrapper .ex-record-content-wrapper .ex-record-title-and-actions .ex-record-title-and-actions-actions ::ng-deep .ex-record-actions-wrapper{flex-wrap:unset!important}.ex-record-wrapper .ex-record-content-wrapper .ex-record-title-and-actions .ex-record-title-and-actions-actions ::ng-deep .ex-record-actions-main-buttons-label-wrapper{max-width:500px!important}.ex-record-wrapper .ex-record-content-wrapper .ex-record-column-wrapper{display:flex}.ex-record-wrapper .ex-record-column{display:flex;flex-direction:column;flex:1;word-break:break-word;min-width:115px;width:0}.ex-record-wrapper .ex-record-column:not(:last-child){margin-inline-end:15px}.ex-record-wrapper .ex-record-column .ex-record-label{width:-moz-fit-content;width:fit-content}.ex-record-wrapper .ex-avatar-placeholder{margin-top:0}.ex-record-wrapper .ex-record-actions-column{display:flex;flex-direction:column;align-items:flex-end}.ex-record-wrapper .ex-record-actions-column .ex-record-actions-column-horizontal-container{display:flex;flex-direction:row-reverse;flex-wrap:wrap}.ex-record-wrapper .ex-record-actions-column .ex-record-actions-column-horizontal-container .ex-record-actions-column-horizontal-divider{border-inline-end:1px solid rgba(0,0,0,.1215686275);margin-inline-end:4px}.ex-record-wrapper .ex-record-actions-column .ex-record-actions{display:flex}.ex-record-wrapper .ex-record-actions-column .ex-record-actions-edit{margin-inline-start:5px;align-self:flex-end;margin-top:auto}.ex-record-wrapper .ex-record-actions-column .ex-record-actions-edit.selected ::ng-deep button{background-color:#c6e9ff}.ex-record-wrapper .ex-record-actions-column-non-shrinked{width:0}.ex-record-wrapper .ex-record-preRow-column{margin-right:10px}.ex-record-thumbnail{margin-top:4px}.ex-record-floating-actions{position:relative}.ex-record-floating-actions .ex-record-actions-loader{position:absolute;right:0;bottom:0;opacity:0}.ex-record-floating-actions:hover .ex-record-actions-loader,.ex-record-floating-actions:focus-within .ex-record-actions-loader{opacity:1}.ex-record-full-width{max-width:100%}html[dir=rtl] :host .ex-record-floating-actions .ex-record-actions-loader,html[dir=rtl] :host .ex-record-floating-actions .ex-record-actions{right:unset;left:0}.hidden-element{visibility:hidden;width:0;height:0;min-width:0!important;flex:0!important}\n"] }]
    }], function () { return [{ type: ExItemsLayoutService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }]; }, { data: [{
            type: Input
        }], isItemOpen: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], emptyRowHeight: [{
            type: Input
        }], highlightedText: [{
            type: Input
        }], htmlId: [{
            type: Input
        }], isExPickup: [{
            type: Input
        }], inExSidepanePickup: [{
            type: Input
        }], recordCustomizationData: [{
            type: Input
        }], showThumbnail: [{
            type: Input
        }], recordIndex: [{
            type: Input
        }], width: [{
            type: Input
        }], isGalleryLayout: [{
            type: Input
        }], actions: [{
            type: ViewChildren,
            args: ['actions']
        }], actionClicked: [{
            type: Output
        }], breakpoint: [{
            type: Input
        }] }); })();

class ExClickableChipComponent {
    constructor() {
        this.mode = 'transparent';
        this.tooltip = null;
        this.hover = false;
    }
    getStyles() {
        const styles = {
            'border-width': '1px',
            'border-style': 'solid',
            'border-color': this.color
        };
        if (this.hover || this.mode === 'filled') {
            styles['background-color'] = this.color;
            styles['color'] = 'white';
        }
        else {
            styles['background-color'] = 'transparent';
            styles['color'] = this.color;
        }
        return styles;
    }
    static { this.ɵfac = function ExClickableChipComponent_Factory(t) { return new (t || ExClickableChipComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExClickableChipComponent, selectors: [["ex-clickable-chip"]], inputs: { color: "color", text: "text", mode: "mode", tooltip: "tooltip" }, decls: 2, vars: 4, consts: [["mat-ripple", "", 1, "ex-clickable-chip-wrapper", 3, "exTooltip", "ngStyle", "mouseover", "mouseleave", "focus"]], template: function ExClickableChipComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("mouseover", function ExClickableChipComponent_Template_button_mouseover_0_listener() { return ctx.hover = true; })("mouseleave", function ExClickableChipComponent_Template_button_mouseleave_0_listener() { return ctx.hover = false; })("focus", function ExClickableChipComponent_Template_button_focus_0_listener() { return ctx.hover = true; });
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("exTooltip", ctx.tooltip)("ngStyle", ctx.getStyles());
            i0.ɵɵattribute("aria-pressed", ctx.mode === "filled");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(ctx.text);
        } }, dependencies: [i1$5.NgStyle, i6$1.MatRipple, ExTooltipDirective], styles: [".ex-clickable-chip-wrapper[_ngcontent-%COMP%]{padding:0 6px;border-radius:3px;font-size:12px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExClickableChipComponent, [{
        type: Component,
        args: [{ selector: 'ex-clickable-chip', template: "<button mat-ripple (mouseover)=\"hover=true\" (mouseleave)=\"hover=false\" class=\"ex-clickable-chip-wrapper\" (focus)=\"hover=true\" [exTooltip]=\"tooltip\" \n  [ngStyle]=\"getStyles()\" [attr.aria-pressed]=\"mode === 'filled'\">{{ text }}</button>", styles: [".ex-clickable-chip-wrapper{padding:0 6px;border-radius:3px;font-size:12px}\n"] }]
    }], null, { color: [{
            type: Input
        }], text: [{
            type: Input
        }], mode: [{
            type: Input
        }], tooltip: [{
            type: Input
        }] }); })();

const Animations = [
    trigger('expand', [
        state('*', style({
            height: AUTO_STYLE,
            overflow: 'hidden'
        })),
        state('void', style({
            height: '0px',
            overflow: 'hidden',
            paddingTop: '0px',
            paddingBottom: '0px'
        })),
        transition('void <=> *', [
            animate('0.5s')
        ])
    ]),
    trigger('bubbleAnim', [
        state('bubble', style({
            background: '{{ color }}',
            width: '9px',
            height: '9px',
            borderRadius: '50%',
            left: '-7px',
            top: '15px'
        }), { params: { color: 'white' } }),
        state('line', style({
            background: '#0e7bba',
            width: '3px',
            height: '100%',
            borderRadius: '3px',
            left: '-4px',
            top: '0px'
        })),
        transition('bubble => line', [
            animate('0.3s')
        ])
    ])
];

const _c0$o = ["close"];
const _c1$h = ["showMore"];
const _c2$b = ["rowItem"];
function ExExpandableSublistComponent_div_0_ng_container_14_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3$8 = function (a0, a1) { return { item: a0, i: a1 }; };
function ExExpandableSublistComponent_div_0_ng_container_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExExpandableSublistComponent_div_0_ng_container_14_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const item_r7 = ctx_r11.$implicit;
    const i_r8 = ctx_r11.index;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3$8, item_r7, i_r8));
} }
function ExExpandableSublistComponent_div_0_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExExpandableSublistComponent_div_0_ng_container_14_ng_container_1_Template, 2, 5, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r8 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r8 !== ctx_r4.list.length - 1);
} }
function ExExpandableSublistComponent_div_0_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExExpandableSublistComponent_div_0_ex_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 18, 19);
    i0.ɵɵlistener("click", function ExExpandableSublistComponent_div_0_ex_button_18_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.loadMoreSublist.emit()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "ex.ui.expendable_label.show_more"), "");
} }
function ExExpandableSublistComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "ex-chip", 5)(4, "span", 6);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 7)(11, "ex-close", 8, 9);
    i0.ɵɵlistener("click", function ExExpandableSublistComponent_div_0_Template_ex_close_click_11_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15._closeClicked()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "ul", 10);
    i0.ɵɵtemplate(14, ExExpandableSublistComponent_div_0_ng_container_14_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 12);
    i0.ɵɵlistener("resized", function ExExpandableSublistComponent_div_0_Template_div_resized_15_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onResized($event)); });
    i0.ɵɵtemplate(16, ExExpandableSublistComponent_div_0_ng_container_16_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 14);
    i0.ɵɵtemplate(18, ExExpandableSublistComponent_div_0_ex_button_18_Template, 4, 3, "ex-button", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "button", 16);
    i0.ɵɵlistener("focus", function ExExpandableSublistComponent_div_0_Template_button_focus_19_listener() { i0.ɵɵrestoreView(_r16); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.moveFocusToCloseButton()); });
    i0.ɵɵtext(20, "move focus to close button");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("@expand", undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("background", ctx_r0.color)("hasBorder", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, ctx_r0.title));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", i0.ɵɵpipeBind1(9, 11, ctx_r0.description), "");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r0.list);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction2(13, _c3$8, ctx_r0.list[ctx_r0.list.length - 1], ctx_r0.list.length - 1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.hasMore);
} }
function ExExpandableSublistComponent_ng_template_1_ex_component_loader_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 26);
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    const item_r19 = ctx_r25.item;
    const i_r20 = ctx_r25.i;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r22.getItem(item_r19.data, i_r20))("componentFactoryItem", item_r19);
} }
function ExExpandableSublistComponent_ng_template_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-record", 27);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext();
    const i_r20 = ctx_r26.i;
    const item_r19 = ctx_r26.item;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate3("htmlId", "", ctx_r24.htmlId, "", ctx_r24.htmlId ? "_" : "", "", ctx_r24.htmlId ? i_r20 : "", "");
    i0.ɵɵproperty("data", item_r19)("width", ctx_r24.width)("isSelected", ctx_r24.selectedItem === i_r20);
} }
const _c4$6 = function (a0) { return { "ex-expandable-sublist-row-item-selected": a0 }; };
const _c5$5 = function (a0) { return { color: a0 }; };
const _c6$5 = function (a0, a1) { return { value: a0, params: a1 }; };
function ExExpandableSublistComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 20)(1, "div");
    i0.ɵɵelement(2, "div", 21);
    i0.ɵɵelementStart(3, "div", 22, 23);
    i0.ɵɵlistener("keydown.enter", function ExExpandableSublistComponent_ng_template_1_Template_div_keydown_enter_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r20 = restoredCtx.i; const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onRowClicked(i_r20)); })("keydown.space", function ExExpandableSublistComponent_ng_template_1_Template_div_keydown_space_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r20 = restoredCtx.i; const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onRowClicked(i_r20)); })("focusin", function ExExpandableSublistComponent_ng_template_1_Template_div_focusin_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r20 = restoredCtx.i; const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.rowItemFocused(i_r20)); })("click", function ExExpandableSublistComponent_ng_template_1_Template_div_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r20 = restoredCtx.i; const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.onRowClicked(i_r20)); });
    i0.ɵɵtemplate(5, ExExpandableSublistComponent_ng_template_1_ex_component_loader_5_Template, 1, 2, "ex-component-loader", 24);
    i0.ɵɵtemplate(6, ExExpandableSublistComponent_ng_template_1_ng_template_6_Template, 1, 6, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(8, "button", 16);
    i0.ɵɵlistener("focus", function ExExpandableSublistComponent_ng_template_1_Template_button_focus_8_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r20 = restoredCtx.i; const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.moveFocusToNextRow(i_r20 + 2)); });
    i0.ɵɵtext(9, "move focus to next row");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const i_r20 = ctx.i;
    const _r23 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c4$6, i_r20 === ctx_r2.selectedItem));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@expand", undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@bubbleAnim", i0.ɵɵpureFunction2(11, _c6$5, i_r20 !== ctx_r2.selectedItem ? "bubble" : "line", i0.ɵɵpureFunction1(9, _c5$5, ctx_r2.color)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRippleColor", i_r20 !== ctx_r2.selectedItem ? "#eff4f74f" : "transparent");
    i0.ɵɵattribute("aria-pressed", i_r20 === ctx_r2.selectedItem);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.dynamicComponents)("ngIfElse", _r23);
} }
class ExExpandableSublistComponent {
    constructor() {
        this.selectedItem = 0;
        this.hasMore = false;
        this.showMoreLabel = 'Show More';
        this.selectedItemChange = new EventEmitter();
        this.closeClicked = new EventEmitter();
        this.loadMoreSublist = new EventEmitter();
        this.width = 0;
    }
    ngAfterViewInit() {
        this.rowItemRef.toArray()[1].nativeElement.focus();
    }
    onRowClicked(index) {
        this.selectedItemChange.emit(index);
        //this.rowItemRef.toArray()[index].nativeElement.focus();
        this.selectedItem = index;
    }
    _closeClicked() {
        this.closeClicked.emit();
    }
    onResized(event) {
        if (Math.abs(this.width - event.newRect.width) > 30) {
            this.width = event.newRect.width;
        }
    }
    getItem(item, ind) {
        return { ...item, width: this.width, isSelected: this.selectedItem === ind };
    }
    rowItemFocused(index) {
        this.selectedItem = index;
    }
    focus() {
        if (this.rowItemRef.toArray().length > 10) { // 'show more' clicked
            let rowsCount = this.rowItemRef.toArray().length;
            let moreItemsCount = (rowsCount % 10);
            let row = moreItemsCount == 1 ? 0 : (rowsCount - (rowsCount % 10) + 1);
            this.rowItemRef.toArray()[row].nativeElement.focus();
        }
        else if (this.rowItemRef.toArray()[1]) {
            this.rowItemRef.toArray()[1].nativeElement.focus();
        }
    }
    moveFocusToNextRow(row) {
        if (row === this.rowItemRef.toArray().length) {
            row = 0;
        }
        if (this.rowItemRef.toArray()[row]) {
            this.rowItemRef.toArray()[row].nativeElement.focus();
        }
        else if (this.hasMore) {
            this.showMoreRef.nativeElement.focus();
        }
        else {
            this.closeRef.focus();
        }
    }
    moveFocusToCloseButton() {
        this.closeRef.focus();
    }
    static { this.ɵfac = function ExExpandableSublistComponent_Factory(t) { return new (t || ExExpandableSublistComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExExpandableSublistComponent, selectors: [["ex-expandable-sublist"]], viewQuery: function ExExpandableSublistComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$o, 5);
            i0.ɵɵviewQuery(_c1$h, 5);
            i0.ɵɵviewQuery(_c2$b, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.showMoreRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItemRef = _t);
        } }, inputs: { list: "list", color: "color", title: "title", description: "description", selectedItem: "selectedItem", hasMore: "hasMore", showMoreLabel: "showMoreLabel", dynamicComponents: "dynamicComponents", htmlId: "htmlId" }, outputs: { selectedItemChange: "selectedItemChange", closeClicked: "closeClicked", loadMoreSublist: "loadMoreSublist" }, decls: 3, vars: 1, consts: [["class", "ex-expandable-sublist-wrapper", "tabindex", "0", 4, "ngIf"], ["row", ""], ["tabindex", "0", 1, "ex-expandable-sublist-wrapper"], [1, "ex-expandable-sublist-header"], ["role", "heading", "aria-level", "2", 1, "ex-expandable-sublist-header-description"], ["size", "small", 2, "margin-left", "-15px", 3, "background", "hasBorder"], ["text", "", 2, "color", "white"], [1, "ex-expandable-sublist-close-button"], [3, "click"], ["close", ""], [1, "ex-expandable-sublist-list-wrapper"], [4, "ngFor", "ngForOf"], [3, "resized"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-expandable-sublist-footer"], ["type", "action", 3, "click", 4, "ngIf"], [1, "ex-expandable-sublist-hidden-button", 3, "focus"], [4, "ngIf"], ["type", "action", 3, "click"], ["showMore", ""], ["role", "button", 1, "ex-expandable-sublist-row-item-wrapper", 3, "ngClass"], [1, "ex-expandable-sublist-bubble"], ["mat-ripple", "", "tabindex", "0", "role", "button", 1, "ex-expandable-sublist-row-item", 3, "matRippleColor", "keydown.enter", "keydown.space", "focusin", "click"], ["rowItem", ""], ["class", "ex-list-layout-content", 3, "data", "componentFactoryItem", 4, "ngIf", "ngIfElse"], ["exRecord", ""], [1, "ex-list-layout-content", 3, "data", "componentFactoryItem"], [3, "data", "width", "isSelected", "htmlId"]], template: function ExExpandableSublistComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExExpandableSublistComponent_div_0_Template, 21, 16, "div", 0);
            i0.ɵɵtemplate(1, ExExpandableSublistComponent_ng_template_1_Template, 10, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.list.length > 0);
        } }, styles: [".ex-expandable-sublist-wrapper[_ngcontent-%COMP%]{padding:10px 10px 10px 40px;margin-top:10px;border-bottom:1px solid #d0cfcf}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-header[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:space-between;margin-bottom:10px}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-header[_ngcontent-%COMP%]   .ex-expandable-sublist-close-button[_ngcontent-%COMP%]:hover{color:#0e7cbb}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-header[_ngcontent-%COMP%]   .ex-expandable-sublist-close-button[_ngcontent-%COMP%]{color:#878787;cursor:pointer}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-header[_ngcontent-%COMP%]   .ex-expandable-sublist-close-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:12px!important}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-header[_ngcontent-%COMP%]   .ex-expandable-sublist-header-description[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-list-wrapper[_ngcontent-%COMP%]{position:relative}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-list-wrapper[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:-10px;bottom:-15px;left:-3px;width:1px;background:#dde0e3}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-hidden-button[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-wrapper[_ngcontent-%COMP%]{cursor:pointer;background:#fff;overflow:inherit;position:relative;display:block}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-bubble[_ngcontent-%COMP%]{width:9px;height:9px;border-radius:50%;position:absolute;left:-7px;z-index:2;top:15px}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item[_ngcontent-%COMP%]{padding:10px 10px 10px 20px;border:1px solid transparent}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item[_ngcontent-%COMP%]:focus{border:1px solid black}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-wrapper[_ngcontent-%COMP%]:hover:before{content:\"\";position:absolute;top:0;bottom:0;z-index:2;left:-4px;width:3px;background:#dde0e3}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-row-item-selected[_ngcontent-%COMP%]{background:#f0f5f8}.ex-expandable-sublist-wrapper[_ngcontent-%COMP%]   .ex-expandable-sublist-footer[_ngcontent-%COMP%]{justify-content:center;display:flex}"], data: { animation: Animations } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExExpandableSublistComponent, [{
        type: Component,
        args: [{ selector: 'ex-expandable-sublist', animations: Animations, template: "<div @expand *ngIf=\"list.length > 0\" class=\"ex-expandable-sublist-wrapper\" tabindex=\"0\">\n  <div class=\"ex-expandable-sublist-header\">\n    <div class=\"ex-expandable-sublist-header-description\" role=\"heading\" aria-level=\"2\">\n      <ex-chip size=\"small\" style=\"margin-left: -15px\" [background]=\"color\" [hasBorder]=\"false\">\n        <span text style=\"color: white\">{{ title | translate}}</span>\n      </ex-chip>\n      <span>&nbsp;&nbsp;{{ description | translate }}</span>\n    </div>\n    <div class=\"ex-expandable-sublist-close-button\">\n      <ex-close #close (click)=\"_closeClicked()\"></ex-close>\n    </div>\n  </div>\n  <ul class=\"ex-expandable-sublist-list-wrapper\">\n    <ng-container *ngFor=\"let item of list; let i = index\">\n      <ng-container *ngIf=\"i !== list.length -1\">\n        <ng-container *ngTemplateOutlet=\"row;context: {item: item, i: i}\"></ng-container>\n      </ng-container>\n    </ng-container>\n  </ul>\n  <div (resized)=\"onResized($event)\">\n    <ng-container *ngTemplateOutlet=\"row;context: {item: list[list.length -1], i: list.length -1}\"></ng-container>\n  </div>\n  <div class=\"ex-expandable-sublist-footer\">\n    <ex-button #showMore type=\"action\" *ngIf=\"hasMore\" (click)=\"loadMoreSublist.emit()\">\n      {{ 'ex.ui.expendable_label.show_more' | translate }}</ex-button>\n  </div>\n  <button class=\"ex-expandable-sublist-hidden-button\" (focus)=\"moveFocusToCloseButton()\">move focus to close\n    button</button>\n</div>\n\n<ng-template #row let-item=\"item\" let-i=\"i\">\n  <!-- we need this wrapper for the ripple effect to stay inside the div -->\n  <li class=\"ex-expandable-sublist-row-item-wrapper\"\n    [ngClass]=\"{ 'ex-expandable-sublist-row-item-selected': i === selectedItem }\" role=\"button\">\n    <div @expand>\n      <div [@bubbleAnim]=\"{value: i !== selectedItem ? 'bubble' : 'line', params: { color: color }}\"\n        class=\"ex-expandable-sublist-bubble\"></div>\n      <div #rowItem class=\"ex-expandable-sublist-row-item\" mat-ripple [attr.aria-pressed]=\"i === selectedItem\"\n        tabindex=\"0\" (keydown.enter)=\"onRowClicked(i)\" (keydown.space)=\"onRowClicked(i)\" (focusin)=\"rowItemFocused(i)\"\n        [matRippleColor]=\"i !== selectedItem ? '#eff4f74f': 'transparent'\" (click)=\"onRowClicked(i)\" role=\"button\">\n        <!-- <ex-component-loader [events]=\"{ rowClicked: onRowClicked.bind(this, i) }\" [data]=\"getItem(item.data, i)\"\n            [componentFactoryItem]=\"item\" class=\"ex-list-layout-content\">\n          </ex-component-loader> -->\n\n        <ex-component-loader *ngIf=\"dynamicComponents; else exRecord\" [data]=\"getItem(item.data, i)\"\n          [componentFactoryItem]=\"item\" class=\"ex-list-layout-content\"></ex-component-loader>\n        <ng-template #exRecord>\n          <ex-record [data]=\"item\" [width]=\"width\" [isSelected]=\"selectedItem === i\"\n            htmlId=\"{{ htmlId }}{{ htmlId ? '_' : '' }}{{ htmlId ? i : '' }}\"></ex-record>\n        </ng-template>\n        <button class=\"ex-expandable-sublist-hidden-button\" (focus)=\"moveFocusToNextRow(i+2)\">move focus to\n          next\n          row</button>\n      </div>\n    </div>\n  </li>\n</ng-template>", styles: [".ex-expandable-sublist-wrapper{padding:10px 10px 10px 40px;margin-top:10px;border-bottom:1px solid #d0cfcf}.ex-expandable-sublist-wrapper .ex-expandable-sublist-header{display:flex;flex:1;justify-content:space-between;margin-bottom:10px}.ex-expandable-sublist-wrapper .ex-expandable-sublist-header .ex-expandable-sublist-close-button:hover{color:#0e7cbb}.ex-expandable-sublist-wrapper .ex-expandable-sublist-header .ex-expandable-sublist-close-button{color:#878787;cursor:pointer}.ex-expandable-sublist-wrapper .ex-expandable-sublist-header .ex-expandable-sublist-close-button i{font-size:12px!important}.ex-expandable-sublist-wrapper .ex-expandable-sublist-header .ex-expandable-sublist-header-description{display:flex;flex-direction:row}.ex-expandable-sublist-wrapper .ex-expandable-sublist-list-wrapper{position:relative}.ex-expandable-sublist-wrapper .ex-expandable-sublist-list-wrapper:before{content:\"\";position:absolute;top:-10px;bottom:-15px;left:-3px;width:1px;background:#dde0e3}.ex-expandable-sublist-wrapper .ex-expandable-sublist-hidden-button{width:0;height:0;overflow:hidden;border:transparent}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-wrapper{cursor:pointer;background:#fff;overflow:inherit;position:relative;display:block}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-wrapper .ex-expandable-sublist-bubble{width:9px;height:9px;border-radius:50%;position:absolute;left:-7px;z-index:2;top:15px}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-wrapper .ex-expandable-sublist-row-item{padding:10px 10px 10px 20px;border:1px solid transparent}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-wrapper .ex-expandable-sublist-row-item:focus{border:1px solid black}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-wrapper:hover:before{content:\"\";position:absolute;top:0;bottom:0;z-index:2;left:-4px;width:3px;background:#dde0e3}.ex-expandable-sublist-wrapper .ex-expandable-sublist-row-item-selected{background:#f0f5f8}.ex-expandable-sublist-wrapper .ex-expandable-sublist-footer{justify-content:center;display:flex}\n"] }]
    }], null, { list: [{
            type: Input
        }], color: [{
            type: Input
        }], title: [{
            type: Input
        }], description: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], hasMore: [{
            type: Input
        }], showMoreLabel: [{
            type: Input
        }], dynamicComponents: [{
            type: Input
        }], htmlId: [{
            type: Input
        }], selectedItemChange: [{
            type: Output
        }], closeClicked: [{
            type: Output
        }], loadMoreSublist: [{
            type: Output
        }], rowItemRef: [{
            type: ViewChildren,
            args: ['rowItem']
        }], closeRef: [{
            type: ViewChild,
            args: ['close']
        }], showMoreRef: [{
            type: ViewChild,
            args: ['showMore']
        }] }); })();

function ExRecordPlaceholderComponent_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-checkbox", 6);
} if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
} }
function ExRecordPlaceholderComponent_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-radio-button", 6);
} if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
} }
function ExRecordPlaceholderComponent_ex_thumbnail_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-thumbnail", 7);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showPlaceholder", true)("fixedWidth", (ctx_r2.proto.thumbnail == null ? null : ctx_r2.proto.thumbnail.size) === "large" ? 68 : 33);
} }
const _c0$n = function (a0) { return { "ex-record-placeholder-narrow": a0 }; };
function ExRecordPlaceholderComponent_ng_container_4_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const j_r11 = ctx.index;
    const column_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$n, j_r11 === column_r6.length - 1 || j_r11 === 2));
} }
function ExRecordPlaceholderComponent_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ExRecordPlaceholderComponent_ng_container_4_div_1_div_1_Template, 1, 3, "div", 10);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const i_r7 = ctx_r13.index;
    const column_r6 = ctx_r13.$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("flex", (ctx_r8.proto.record == null ? null : ctx_r8.proto.record.layout) === "extend" && i_r7 == 0 ? 2 : 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 3, column_r6, 0, ctx_r8.maxEmptyLines));
} }
function ExRecordPlaceholderComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordPlaceholderComponent_ng_container_4_div_1_Template, 3, 7, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r7 < ctx_r3.breakpoint);
} }
function ExRecordPlaceholderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 12);
    i0.ɵɵelementEnd();
} }
function ExRecordPlaceholderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementEnd();
} }
class ExRecordPlaceholderComponent {
    constructor() {
        this.maxEmptyLines = 3;
        this.emptyRowHeight = 7;
        this.hasPickup = false;
        this.isMultiSelect = true;
        this._width = 1000;
        this.breakpoint = 3;
        this.isLoading = true;
    }
    ngOnInit() {
        if (!this.proto) {
            this.proto = {
                thumbnail: {},
                columns3: [
                    [{ key: "title" }, { key: "title" }, { key: "title" }, { key: "title" }],
                ],
                columns2: [
                    [{ key: "title" }, { key: "title" }, { key: "title" }, { key: "title" }],
                ],
                columns1: [
                    [{ key: "title" }, { key: "title" }, { key: "title" }, { key: "title" }]
                ]
            };
            this.proto.columns3['actions'] = [0];
            this.proto.columns2['actions'] = [0];
            this.proto.columns1['actions'] = [0];
        }
    }
    set width(value) {
        if (Math.abs(this._width - value) > 30) {
            this._width = value;
            if (this._width > 720) {
                this.breakpoint = 3;
            }
            else if (this._width > 500) {
                this.breakpoint = 2;
            }
            else {
                this.breakpoint = 1;
            }
        }
    }
    get width() {
        return this._width;
    }
    static { this.ɵfac = function ExRecordPlaceholderComponent_Factory(t) { return new (t || ExRecordPlaceholderComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRecordPlaceholderComponent, selectors: [["ex-record-placeholder"]], inputs: { maxEmptyLines: "maxEmptyLines", emptyRowHeight: "emptyRowHeight", proto: "proto", hasPickup: "hasPickup", isMultiSelect: "isMultiSelect", width: "width" }, decls: 8, vars: 6, consts: [[1, "ex-record-placeholder-wrapper"], ["class", "ex-record-placeholder-checkbox", 4, "ngIf"], [3, "showPlaceholder", "fixedWidth", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "ex-record-placeholder-actions-column"], [4, "ngIf"], [1, "ex-record-placeholder-checkbox"], [3, "showPlaceholder", "fixedWidth"], ["class", "ex-record-placeholder-column", 3, "flex", 4, "ngIf"], [1, "ex-record-placeholder-column"], ["class", "ex-record-placeholder-label ex-record-placeholder-grey", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "ex-record-placeholder-label", "ex-record-placeholder-grey", 3, "ngClass"], [1, "ex-record-placeholder-grey", "ex-record-placeholder-info"], [1, "ex-record-placeholder-greyer", "ex-record-placeholder-action"]], template: function ExRecordPlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExRecordPlaceholderComponent_ex_checkbox_1_Template, 1, 1, "ex-checkbox", 1);
            i0.ɵɵtemplate(2, ExRecordPlaceholderComponent_mat_radio_button_2_Template, 1, 1, "mat-radio-button", 1);
            i0.ɵɵtemplate(3, ExRecordPlaceholderComponent_ex_thumbnail_3_Template, 1, 2, "ex-thumbnail", 2);
            i0.ɵɵtemplate(4, ExRecordPlaceholderComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, ExRecordPlaceholderComponent_div_6_Template, 2, 0, "div", 5);
            i0.ɵɵtemplate(7, ExRecordPlaceholderComponent_div_7_Template, 2, 0, "div", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasPickup && ctx.isMultiSelect);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasPickup && !ctx.isMultiSelect);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.proto.thumbnail);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.proto["columns" + ctx.breakpoint]);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.proto["columns" + ctx.breakpoint].actions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.proto.actions);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExThumbnailComponent, ExCheckboxComponent, i8.MatRadioButton, i1$5.SlicePipe], styles: [".ex-record-placeholder-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-checkbox[_ngcontent-%COMP%]{margin-inline-end:10px;width:24px;display:flex;flex-direction:column;text-align:center}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-inline:5px;flex:1;align-items:flex-start}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-actions-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1;width:100px}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-greyer[_ngcontent-%COMP%]{background:#ececec 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-grey[_ngcontent-%COMP%]{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-first-line[_ngcontent-%COMP%]{width:314px;height:19px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-action[_ngcontent-%COMP%]{width:40%;height:30px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-info[_ngcontent-%COMP%]{width:20%;height:15px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-label[_ngcontent-%COMP%]{width:80%;margin:5px;height:14px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-narrow[_ngcontent-%COMP%]{width:60%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordPlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'ex-record-placeholder', template: "<div class=\"ex-record-placeholder-wrapper\">\n  <ex-checkbox *ngIf=\"hasPickup && isMultiSelect\" [attr.aria-hidden] = \"true\" class=\"ex-record-placeholder-checkbox\"></ex-checkbox>\n  <mat-radio-button  *ngIf=\"hasPickup && !isMultiSelect\" [attr.aria-hidden] = \"true\" class=\"ex-record-placeholder-checkbox\">\n  </mat-radio-button>\n  <ex-thumbnail *ngIf=\"proto.thumbnail\" [showPlaceholder]=\"true\"\n    [fixedWidth]=\"proto.thumbnail?.size === 'large' ? 68 : 33\"></ex-thumbnail>\n  <ng-container *ngFor=\"let column of proto['columns' + breakpoint]; let i = index\">\n    <div class=\"ex-record-placeholder-column\" [style.flex]=\"proto.record?.layout === 'extend' && i == 0 ? 2 : 1\"\n      *ngIf=\"i < breakpoint\">\n      <div *ngFor=\"let row of column| slice:0:maxEmptyLines; let j = index\"\n        class=\"ex-record-placeholder-label ex-record-placeholder-grey\"\n        [ngClass]=\"{'ex-record-placeholder-narrow': (j === (column.length-1) || j === 2) }\">\n      </div>\n    </div>\n  </ng-container>\n  <div class=\"ex-record-placeholder-actions-column\">\n    <div *ngIf=\"proto['columns' + breakpoint].actions\">\n      <div class=\"ex-record-placeholder-grey ex-record-placeholder-info\"></div>\n    </div>\n    <div *ngIf=\"proto.actions\">\n      <div class=\"ex-record-placeholder-greyer ex-record-placeholder-action\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".ex-record-placeholder-wrapper{display:flex;flex-direction:row}.ex-record-placeholder-wrapper .ex-record-placeholder-checkbox{margin-inline-end:10px;width:24px;display:flex;flex-direction:column;text-align:center}.ex-record-placeholder-wrapper .ex-record-placeholder-column{display:flex;flex-direction:column;margin-inline:5px;flex:1;align-items:flex-start}.ex-record-placeholder-wrapper .ex-record-placeholder-actions-column{display:flex;flex-direction:column;flex:1;width:100px}.ex-record-placeholder-wrapper .ex-record-placeholder-greyer{background:#ececec 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper .ex-record-placeholder-grey{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper .ex-record-placeholder-first-line{width:314px;height:19px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper .ex-record-placeholder-action{width:40%;height:30px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper .ex-record-placeholder-info{width:20%;height:15px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper .ex-record-placeholder-label{width:80%;margin:5px;height:14px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper .ex-record-placeholder-narrow{width:60%}\n"] }]
    }], function () { return []; }, { maxEmptyLines: [{
            type: Input
        }], emptyRowHeight: [{
            type: Input
        }], proto: [{
            type: Input
        }], hasPickup: [{
            type: Input
        }], isMultiSelect: [{
            type: Input
        }], width: [{
            type: Input,
            args: ['width']
        }] }); })();

const _c0$m = ["subList"];
const _c1$g = ["paginationRef"];
const _c2$a = ["rowItemRef"];
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("focusin", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template_button_focusin_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r22.onRowStartFocused($event)); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_ex_drag_accessible_icon_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-drag-accessible-icon", 24);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_i_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 25);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    const i_r6 = ctx_r24.index;
    const item_r5 = ctx_r24.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-list-warning-icon sel-warning-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
const _c3$7 = function (a0) { return { "ex-items-layout-list-disabled-row-item": a0 }; };
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const isItemSelected_r9 = i0.ɵɵnextContext().isItemSelected;
    const ctx_r26 = i0.ɵɵnextContext();
    const item_r5 = ctx_r26.$implicit;
    const i_r6 = ctx_r26.index;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", isItemSelected_r9 ? "selectedItemInList" : null)("ngClass", i0.ɵɵpureFunction1(3, _c3$7, item_r5.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r16.listProperties.pagination.selectedPage - 1) * ctx_r16.listProperties.pagination.pageSize + i_r6 + 1, " ");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 35);
    i0.ɵɵlistener("checkedChange", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_checkbox_1_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r38); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.onItemCheckedChange(item_r5, $event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    const item_r5 = ctx_r39.$implicit;
    const i_r6 = ctx_r39.index;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", item_r5.selectable === false)("checked", ctx_r27.isItemChecked(item_r5))("exTooltip", item_r5.selectable !== false ? "" : i0.ɵɵpipeBind1(1, 5, item_r5.nonSelectableTooltip))("ariaLabel", i0.ɵɵpipeBind1(2, 7, "ng.ex_items_layout_list_row.check_or_uncheck") + " " + ((ctx_r27.listProperties.pagination.selectedPage - 1) * ctx_r27.listProperties.pagination.pageSize + i_r6 + 1));
    i0.ɵɵattribute("aria-hidden", !(!ctx_r27.listProperties.isLoading && ctx_r27.readyToLoad));
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 36);
    i0.ɵɵlistener("keydown.space", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_mat_radio_button_2_Template_mat_radio_button_keydown_space_0_listener() { i0.ɵɵrestoreView(_r42); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.onSingleItemCheckedChange(item_r5)); })("click", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_mat_radio_button_2_Template_mat_radio_button_click_0_listener() { i0.ɵɵrestoreView(_r42); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.onSingleItemCheckedChange(item_r5)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    const i_r6 = ctx_r45.index;
    const item_r5 = ctx_r45.$implicit;
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("aria-labelledby", "recordId-", i_r6, "");
    i0.ɵɵproperty("checked", ctx_r28.isItemChecked(item_r5));
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 37);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#e54746")("iconName", "circ_warning");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 37);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#e7a141")("iconName", "warning");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 37);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#60c05f")("iconName", "success");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 41);
} if (rf & 2) {
    const icon_r48 = ctx.$implicit;
    i0.ɵɵproperty("iconName", icon_r48 == null ? null : icon_r48.iconName)("color", icon_r48 == null ? null : icon_r48.iconColor)("tooltip", icon_r48 == null ? null : icon_r48.tooltip)("callback", (icon_r48 == null ? null : icon_r48.callback) ? icon_r48 == null ? null : icon_r48.callback : null);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ng_container_2_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 41);
} if (rf & 2) {
    const icon_r49 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconName", icon_r49 == null ? null : icon_r49.iconName)("color", icon_r49 == null ? null : icon_r49.iconColor)("tooltip", icon_r49 == null ? null : icon_r49.tooltip)("callback", (icon_r49 == null ? null : icon_r49.callback) ? icon_r49 == null ? null : icon_r49.callback : null);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ng_container_2_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 39);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const icon_r49 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r49);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 39);
    i0.ɵɵtemplate(2, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_ng_container_2_Template, 2, 1, "ng-container", 40);
    i0.ɵɵpipe(3, "exUnderThumbnailIcons");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.listItem[item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem.__proto__.thumbnailIcon == null ? null : item_r5.listItem.__proto__.thumbnailIcon.key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 3, item_r5 == null ? null : item_r5.listItem))("ngForTrackBy", ctx_r32.iconTrackBy);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_i_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 25);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(3);
    const i_r6 = ctx_r53.index;
    const item_r5 = ctx_r53.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-list-warning-icon sel-warning-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_i_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 25);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " check_circle ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    const i_r6 = ctx_r54.index;
    const item_r5 = ctx_r54.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-list-valid-icon sel-valid-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 42);
} if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext(3).index;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-list-suppress-icon sel-suppress-", i_r6, "");
    i0.ɵɵproperty("iconName", "visibility-off")("iconType", "svg");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("mousedown", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template_div_mousedown_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("mouseup", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template_div_mouseup_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("click", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template_div_click_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("focus", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template_div_focus_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("focusin", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template_div_focusin_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); });
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_checkbox_1_Template, 3, 9, "ex-checkbox", 28);
    i0.ɵɵtemplate(2, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_mat_radio_button_2_Template, 1, 2, "mat-radio-button", 29);
    i0.ɵɵtemplate(3, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_3_Template, 1, 2, "ex-svg-icon", 30);
    i0.ɵɵtemplate(4, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_4_Template, 1, 2, "ex-svg-icon", 30);
    i0.ɵɵtemplate(5, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_svg_icon_5_Template, 1, 2, "ex-svg-icon", 30);
    i0.ɵɵtemplate(6, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_div_6_Template, 4, 5, "div", 31);
    i0.ɵɵelementStart(7, "div", 32);
    i0.ɵɵtemplate(8, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_i_8_Template, 3, 6, "i", 33);
    i0.ɵɵtemplate(9, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_i_9_Template, 3, 6, "i", 33);
    i0.ɵɵtemplate(10, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_ex_icon_10_Template, 1, 5, "ex-icon", 34);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.listProperties.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r17.listProperties.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "failed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r17.showCustomizedThumbnail || !ctx_r17.showThumbnail);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", item_r5.mode == null ? null : item_r5.mode.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "WARNING");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "VALID");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "SUPPRESSED");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassMapInterpolate1("ex-items-layout-list-action-indication-reason-", item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 4, item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.reason), " ");
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ex_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 46);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
const _c4$5 = function (a0) { return { "ex-items-layout-list-not-selected-bubbles": a0 }; };
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ng_template_2_ex_clickable_chip_0_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-clickable-chip", 48);
    i0.ɵɵlistener("click", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ng_template_2_ex_clickable_chip_0_Template_ex_clickable_chip_click_0_listener() { i0.ɵɵrestoreView(_r72); const j_r65 = i0.ɵɵnextContext(2).index; const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r70 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r70.openSublist(item_r5, j_r65)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(2);
    const sublist_r64 = ctx_r74.$implicit;
    const j_r65 = ctx_r74.index;
    const ctx_r75 = i0.ɵɵnextContext(2);
    const isSublistOpen_r10 = ctx_r75.isSublistOpen;
    const isItemSelected_r9 = ctx_r75.isItemSelected;
    const ctx_r69 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("text", "+", sublist_r64.length, "");
    i0.ɵɵproperty("mode", isSublistOpen_r10 && ctx_r69.sublistIndex === j_r65 ? "filled" : "transparent")("ngClass", i0.ɵɵpureFunction1(9, _c4$5, !isItemSelected_r9 && !isSublistOpen_r10))("color", sublist_r64.color)("tooltip", i0.ɵɵpipeBind1(1, 5, sublist_r64.title) + " " + i0.ɵɵpipeBind1(2, 7, sublist_r64.description));
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ng_template_2_ex_clickable_chip_0_Template, 3, 11, "ex-clickable-chip", 47);
} if (rf & 2) {
    const sublist_r64 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", sublist_r64.length > 0);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ex_spinner_1_Template, 1, 1, "ex-spinner", 44);
    i0.ɵɵtemplate(2, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 45, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sublist_r64 = ctx.$implicit;
    const _r67 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sublist_r64.loading)("ngIfElse", _r67);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_ng_container_1_Template, 4, 2, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r5.sublists);
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_19_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("keyup.Tab", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_19_Template_button_keyup_Tab_0_listener() { i0.ɵɵrestoreView(_r79); const ctx_r78 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r78.onTabFromRowEnd()); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-expandable-sublist", 50, 51);
    i0.ɵɵlistener("selectedItemChange", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_20_Template_ex_expandable_sublist_selectedItemChange_1_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r81.onSublistSelectedItemChange($event)); })("loadMoreSublist", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_20_Template_ex_expandable_sublist_loadMoreSublist_1_listener() { i0.ɵɵrestoreView(_r82); const ctx_r83 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r83.onLoadMoreSublist()); })("closeClicked", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_20_Template_ex_expandable_sublist_closeClicked_1_listener() { i0.ɵɵrestoreView(_r82); const ctx_r84 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r84.onSublistCloseClicked()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(2);
    const item_r5 = ctx_r85.$implicit;
    const i_r6 = ctx_r85.index;
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("list", item_r5.sublists[ctx_r21.sublistIndex].list)("htmlId", ctx_r21.htmlId + "_" + i_r6 + "_sub")("color", item_r5.sublists[ctx_r21.sublistIndex].color)("selectedItem", ctx_r21.selectedItemInSublistIndex)("hasMore", item_r5.sublists[ctx_r21.sublistIndex].hasMore)("title", item_r5.sublists[ctx_r21.sublistIndex].title)("description", item_r5.sublists[ctx_r21.sublistIndex].description);
} }
const _c5$4 = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { "ex-items-layout-list-row-item-opened": a0, "ex-items-layout-list-row-item-disabled": a1, "ex-items-layout-list-checked": a2, "ex-items-layout-list-selected": a3, "ex-items-layout-list-hover-left-indication": a4, "ex-items-layout-list-large-density": a5, "ex-items-layout-list-row-item-dark-theme": a6, "ex-items-layout-list-selected-dark-theme": a7 }; };
const _c6$4 = function (a0, a1) { return { "ex-items-layout-list-disabled-content": a0, "ex-items-layout-list-disabled-row-item": a1 }; };
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template, 1, 0, "button", 9);
    i0.ɵɵelementStart(2, "div", 10, 11);
    i0.ɵɵlistener("click", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r86 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r86.onItemClicked(item_r5)); })("keydown.enter", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r89 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r89.onItemClicked(item_r5)); })("keydown.space", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_space_2_listener() { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r91 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r91.onItemClicked(item_r5)); })("keydown.arrowdown", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_arrowdown_2_listener($event) { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r93 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r93.onRowArrowDown($event, item_r5)); })("keydown.arrowup", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_arrowup_2_listener($event) { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r95 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r95.onRowArrowUp($event, item_r5)); });
    i0.ɵɵelementStart(4, "span", 12);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 13);
    i0.ɵɵtemplate(11, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_ex_drag_accessible_icon_11_Template, 1, 0, "ex-drag-accessible-icon", 14);
    i0.ɵɵtemplate(12, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_i_12_Template, 3, 6, "i", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_span_13_Template, 3, 5, "span", 16);
    i0.ɵɵtemplate(14, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_14_Template, 11, 10, "div", 17);
    i0.ɵɵelementStart(15, "div", 18)(16, "ex-record", 19);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template_ex_record_actionClicked_16_listener($event) { i0.ɵɵrestoreView(_r88); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r97 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r97.onActionClicked(item_r5, $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_17_Template, 3, 6, "div", 20);
    i0.ɵɵtemplate(18, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_18_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_button_19_Template, 1, 0, "button", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_div_20_Template, 3, 7, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const isItemSelected_r9 = ctx.isItemSelected;
    const isSublistOpen_r10 = ctx.isSublistOpen;
    const isOtherSublistOpen_r11 = ctx.isOtherSublistOpen;
    const ctx_r99 = i0.ɵɵnextContext();
    const i_r6 = ctx_r99.index;
    const item_r5 = ctx_r99.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("sel-row-", i_r6, "-item ex-items-layout-list-li");
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r8.listProperties.hasDrag);
    i0.ɵɵattribute("aria-hidden", isOtherSublistOpen_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isItemOpen && isItemSelected_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(43, _c5$4, isSublistOpen_r10, isOtherSublistOpen_r11, ctx_r8.isItemChecked(item_r5), ctx_r8.listProperties.canSelectRow && isItemSelected_r9, ctx_r8.listProperties.canSelectRow, ctx_r8.listProperties.density === "large", ctx_r8.listProperties.isDarkTheme, ctx_r8.listProperties.canSelectRow && isItemSelected_r9 && ctx_r8.listProperties.isDarkTheme));
    i0.ɵɵattribute("role", ctx_r8.listProperties.canSelectRow && "button")("tabindex", isOtherSublistOpen_r11 || !ctx_r8.listProperties.canSelectRow ? -1 : 0)("aria-pressed", isItemSelected_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) ? (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "success" ? i0.ɵɵpipeBind1(6, 35, "ng.general.success") : ((item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "warning" ? i0.ɵɵpipeBind1(7, 37, "ng.general.warning") : i0.ɵɵpipeBind1(8, 39, "ng.general.failure")) + " - " + i0.ɵɵpipeBind1(9, 41, item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.reason) : "");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasDrag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5.mode == null ? null : item_r5.mode.value) === "WARNING" && !ctx_r8.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(52, _c6$4, item_r5.disabled, item_r5.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "recordId-", i_r6, "");
    i0.ɵɵpropertyInterpolate3("htmlId", "", ctx_r8.htmlId, "", ctx_r8.htmlId ? "_" : "", "", ctx_r8.htmlId ? i_r6 : "", "");
    i0.ɵɵproperty("highlightedText", ctx_r8.listProperties.highlightedText)("data", item_r5.listItem)("width", ctx_r8.leftSideWidth)("recordIndex", i_r6)("isSelected", ctx_r8._selectedItem && ctx_r8._selectedItem.id === item_r5.id)("emptyRowHeight", ctx_r8.listProperties.emptyRowHeight)("isExPickup", ctx_r8.listProperties.isExPickup)("inExSidepanePickup", ctx_r8.listProperties.inExSidepanePickup)("isItemOpen", ctx_r8.isItemOpen)("recordCustomizationData", ctx_r8.recordCustomizationData)("showThumbnail", ctx_r8.showThumbnail && ctx_r8.showCustomizedThumbnail);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.reason) != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r5.disabled && (item_r5.sublists == null ? null : item_r5.sublists.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isItemOpen && isItemSelected_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isSublistOpen_r10);
} }
const _c7$4 = function (a0, a1, a2) { return { isItemSelected: a0, isSublistOpen: a1, isOtherSublistOpen: a2 }; };
function ExItemsLayoutListComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_container_0_ng_container_3_ng_template_1_Template, 21, 55, "ng-template", 6, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const _r7 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7$4, ctx_r3._selectedItem && item_r5.id === ctx_r3._selectedItem.id, ctx_r3.openedSublist && item_r5.id === ctx_r3.openedSublist.id, ctx_r3.openedSublist && item_r5.id !== ctx_r3.openedSublist.id));
} }
function ExItemsLayoutListComponent_ng_container_0_ex_pagination_4_Template(rf, ctx) { if (rf & 1) {
    const _r102 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 52, 53);
    i0.ɵɵlistener("selectedPageChange", function ExItemsLayoutListComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r102); const ctx_r101 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r101.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutListComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r102); const ctx_r103 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r103.onPageSizeChange($event)); })("endOfPagination", function ExItemsLayoutListComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r102); const ctx_r104 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r104.endOfPagination.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("numberOfResults", ctx_r4.listProperties.pagination.totalItemsCount)("pageSize", ctx_r4.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r4.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r4.listProperties.pagination.selectedPage)("doNotUpdateStateInternally", true);
} }
function ExItemsLayoutListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r106 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-drag-list", 2);
    i0.ɵɵlistener("cdkDropListDropped", function ExItemsLayoutListComponent_ng_container_0_Template_ex_drag_list_cdkDropListDropped_1_listener($event) { i0.ɵɵrestoreView(_r106); const ctx_r105 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r105.onDropListDropped($event)); });
    i0.ɵɵelementStart(2, "ul", 3);
    i0.ɵɵtemplate(3, ExItemsLayoutListComponent_ng_container_0_ng_container_3_Template, 3, 6, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ExItemsLayoutListComponent_ng_container_0_ex_pagination_4_Template, 2, 5, "ex-pagination", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("resizeCB", ctx_r0.onResized);
    i0.ɵɵattribute("aria-label", !ctx_r0.listProperties.isMultiSelect ? "ng.general.single-select-group" : "")("role", !ctx_r0.listProperties.isMultiSelect ? "radiogroup" : undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listProperties.pagination.totalItemsCount > 0);
} }
function ExItemsLayoutListComponent_ng_template_1_ng_container_3_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 60);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r112 = i0.ɵɵnextContext().index;
    const ctx_r113 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r113.listProperties.pagination.selectedPage - 1) * ctx_r113.listProperties.pagination.pageSize + i_r112 + 1, " ");
} }
const _c8$4 = function (a0) { return { "ex-items-layout-list-large-density": a0 }; };
function ExItemsLayoutListComponent_ng_template_1_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 56);
    i0.ɵɵtemplate(2, ExItemsLayoutListComponent_ng_template_1_ng_container_3_div_2_span_2_Template, 2, 1, "span", 57);
    i0.ɵɵelementStart(3, "div", 58);
    i0.ɵɵelement(4, "ex-record-placeholder", 59);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c8$4, ctx_r110.listProperties.density === "large"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r110.listProperties.hasIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("proto", ctx_r110.listProperties.proto)("hasPickup", ctx_r110.listProperties.hasPickup)("isMultiSelect", ctx_r110.listProperties.isMultiSelect)("emptyRowHeight", ctx_r110.listProperties.emptyRowHeight);
} }
function ExItemsLayoutListComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, ExItemsLayoutListComponent_ng_template_1_ng_container_3_div_2_Template, 5, 8, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r107 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("resizeCB", ctx_r107.emitResizeEventCB);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", " ".repeat(ctx_r107.numPlaceholderRows).split(""));
} }
function ExItemsLayoutListComponent_ng_template_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 61);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 50);
} }
function ExItemsLayoutListComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExItemsLayoutListComponent_ng_template_1_ng_container_3_Template, 3, 2, "ng-container", 0);
    i0.ɵɵtemplate(4, ExItemsLayoutListComponent_ng_template_1_ng_template_4_Template, 1, 1, "ng-template", null, 55, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r108 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "ng.ex-list-layout.loading_results"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.listProperties.showSpinner)("ngIfElse", _r108);
} }
const EX_THUMBNAIL_KEY$1 = 'thumbnail';
class ExItemsLayoutListComponent extends ExItemsLayoutItemsFlat {
    constructor(itemsLayoutService, sectionsLayoutService, dialogService) {
        super(itemsLayoutService, sectionsLayoutService, dialogService);
        this.showThumbnail = true;
        this.sublistOpened = new EventEmitter();
        this.selectedSublistItemChanged = new EventEmitter();
        this.loadMoreSublist = new EventEmitter();
        this.sublistIndex = -1;
        this.selectedItemInSublistIndex = -1;
        this.showCustomizedThumbnail = true;
    }
    onComponentInit() {
        super.onComponentInit();
        this.initRecordCustomizationData();
        this.initPlaceholderRows();
        this.initCustomizedThumbnail();
    }
    initRecordCustomizationData() {
        this.recordCustomizationData = this.pageCustomizationData.pipe(map$1(data => data?.record));
    }
    onItemsChanges() {
        super.onItemsChanges();
        this.openedSublist = undefined;
        this.sublistIndex = -1;
        this.selectedItemInSublistIndex = -1;
        this.selectedSublistItem = undefined;
    }
    onItemsReloaded() {
        this._selectFirstAfterItemsChanges = true;
    }
    onListParametersItemIdUpdated(id) {
        this._idToSelectAfterItemsChange = id;
    }
    numCurrentItems() {
        return this.items?.length ?? 0;
    }
    hasNextItem() {
        return this.openedSublist ? true : this.hasCurrentNextItem() || this.hasNextPage();
    }
    hasPreviousItem() {
        return this.openedSublist ? true : this.hasCurrentPreviousItem() || this.hasPreviousPage();
    }
    selectNextItem() {
        if (this.openedSublist) {
            this.selectNextSublistItemIndex();
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        else {
            super.selectNextItem();
        }
    }
    selectPreviousItem() {
        if (this.openedSublist) {
            this.selectPreviousSublistItemIndex();
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        else {
            super.selectPreviousItem();
        }
    }
    selectNextSublistItemIndex() {
        this.selectedItemInSublistIndex = (this.selectedItemInSublistIndex + 1) % this.openedSublist.sublists[this.sublistIndex].length;
    }
    selectPreviousSublistItemIndex() {
        if (this.selectedItemInSublistIndex === 0) {
            this.selectedItemInSublistIndex = this.openedSublist.sublists[this.sublistIndex].length - 1;
        }
        else {
            this.selectedItemInSublistIndex = this.selectedItemInSublistIndex - 1;
        }
    }
    selectSublistItemBySelectedSublistItemIndex() {
        const { selectedSublistItem, selectedSublistItemDetails } = this.getSelectedSublistItem();
        this.selectedSublistItem = selectedSublistItem;
        this.selectedSublistItemChanged.emit({
            selectedSublistItem: this.selectedSublistItem,
            selectedSublistItemDetails: selectedSublistItemDetails
        });
    }
    getSelectedSublistItem() {
        // sublist.list is an array of UIWrapper
        return this.selectedItemInSublistIndex >= 0 && this.selectedItemInSublistIndex < this.openedSublist.sublists[this.sublistIndex].length ?
            {
                selectedSublistItem: this.openedSublist.sublists[this.sublistIndex].list[this.selectedItemInSublistIndex],
                selectedSublistItemDetails: this.openedSublist.sublists[this.sublistIndex].listItemDetails
            } :
            { selectedSublistItem: undefined, selectedSublistItemDetails: undefined };
    }
    openSublist(item, sublistIndex) {
        event.stopPropagation();
        event.preventDefault();
        this.openedSublist = item;
        this.sublistIndex = sublistIndex;
        this.selectedItemInSublistIndex = 0;
        this.selectSublistItemBySelectedSublistItemIndex();
        this.moveFocusToSublist();
        this.sublistOpened.emit({ item, sublistIndex });
    }
    onSublistSelectedItemChange(selectedIndex) {
        this.selectedItemInSublistIndex = selectedIndex;
        this.selectSublistItemBySelectedSublistItemIndex();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onLoadMoreSublist() {
        if (this.selectedItemInSublistIndex != 0) {
            this.selectedItemInSublistIndex = 0;
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        this.loadMoreSublist.emit({ item: this.openedSublist, sublistIndex: this.sublistIndex });
        this.moveFocusToSublist(1500);
    }
    moveFocusToSublist(timeout = 500) {
        setTimeout(() => {
            this.subListRef.focus();
        }, timeout);
    }
    onSublistCloseClicked() {
        this._selectedItem = this.openedSublist;
        this.openedSublist = undefined;
        this.selectedItemInSublistIndex = -1;
        this.selectSublistItemBySelectedSublistItemIndex(); // this.selectedSublistItemChanged should emit { undefined, undefined }
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onActionClicked(item, key) {
        key != SINGLE_SAVE_EDIT_ACTION_KEY && this.onItemClicked(item, true);
        super.onActionClicked(item, key);
    }
    onItemClicked(item, preventOpen) {
        if (window.getSelection().toString().length > 0 || document.activeElement?.tagName === 'INPUT') {
            return;
        }
        this.itemClicked.emit(item);
        if (this._selectedItem && item.id === this._selectedItem.id) {
            if (this.listProperties.hasDiselect) {
                this._selectedItem = undefined;
                if (this.selectedItemInSublistIndex > -1) {
                    this.selectedItemInSublistIndex = -1;
                    this.selectSublistItemBySelectedSublistItemIndex();
                }
                this.itemDeselected.emit(item);
            }
            else {
                preventOpen ? this.itemSelected.emit({ item: item, preventOpen: preventOpen }) : this.itemSelected.emit(item);
                return;
            }
        }
        else {
            this._selectedItem = item;
            if (this.selectedItemInSublistIndex > -1) {
                this.selectedItemInSublistIndex = -1;
                this.selectSublistItemBySelectedSublistItemIndex();
            }
            preventOpen ? this.itemSelected.emit({ item: item, preventOpen: preventOpen }) : this.itemSelected.emit(item);
        }
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onRowStartFocused(event) {
        if (!event.relatedTarget['className']?.includes('ex-items-layout-list-row-item') ||
            !this.items.findIndex(item => item.id == this.selectedItem?.id)) {
            return;
        }
        super.onRowStartFocused(event);
    }
    initCustomizedThumbnail() {
        this._subscription.add(this.recordCustomizationData?.subscribe(data => {
            const customizedThumbnail = data?.find(customizedField => {
                return customizedField.itemId === EX_THUMBNAIL_KEY$1;
            });
            if (customizedThumbnail) {
                this.showCustomizedThumbnail = customizedThumbnail.show;
            }
            else {
                this.showCustomizedThumbnail = true;
            }
        }));
    }
    iconTrackBy(index, icon) {
        return icon?.iconName;
    }
    static { this.ɵfac = function ExItemsLayoutListComponent_Factory(t) { return new (t || ExItemsLayoutListComponent)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutListComponent, selectors: [["ex-items-layout-list"]], viewQuery: function ExItemsLayoutListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$m, 5);
            i0.ɵɵviewQuery(_c1$g, 5);
            i0.ɵɵviewQuery(_c2$a, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subListRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItems = _t);
        } }, inputs: { showThumbnail: "showThumbnail" }, outputs: { sublistOpened: "sublistOpened", selectedSublistItemChanged: "selectedSublistItemChanged", loadMoreSublist: "loadMoreSublist" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["loadingTmpl", ""], ["cdkDropList", "", 3, "cdkDropListDropped"], ["resized", "", 1, "ex-items-layout-list-wrapper", 3, "resizeCB"], [4, "ngFor", "ngForOf"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["itemTmpl", ""], ["cdkDrag", "", 3, "cdkDragDisabled"], ["class", "ex-items-layout-list-row-start-button ex-items-layout-list-hidden-button", "aria-label", "move\n                                to previous list item", 3, "focusin", 4, "ngIf"], [1, "ex-items-layout-list-row-item", 3, "ngClass", "click", "keydown.enter", "keydown.space", "keydown.arrowdown", "keydown.arrowup"], ["rowItemRef", ""], [1, "sr-only"], [1, "ex-items-layout-list-drag-mode-wrapper"], ["cdkDragHandle", "", "class", "ex-items-layout-list-drag-and-drop", 4, "ngIf"], [3, "class", "exTooltip", 4, "ngIf"], [4, "ngIf"], ["class", "ex-items-layout-list-pickup", 3, "mousedown", "mouseup", "click", "focus", "focusin", 4, "ngIf"], [1, "ex-items-layout-list-content", 3, "ngClass"], [3, "highlightedText", "data", "id", "width", "recordIndex", "isSelected", "emptyRowHeight", "isExPickup", "inExSidepanePickup", "htmlId", "isItemOpen", "recordCustomizationData", "showThumbnail", "actionClicked"], [3, "class", 4, "ngIf"], ["class", "ex-items-layout-list-sublist-bubbles", 4, "ngIf"], ["class", "ex-items-layout-list-hidden-button", "aria-label", "move\n                                focus to right side", 3, "keyup.Tab", 4, "ngIf"], ["aria-label", "move\n                                to previous list item", 1, "ex-items-layout-list-row-start-button", "ex-items-layout-list-hidden-button", 3, "focusin"], ["cdkDragHandle", "", 1, "ex-items-layout-list-drag-and-drop"], [3, "exTooltip"], [1, "ex-items-layout-list-index", 3, "id", "ngClass"], [1, "ex-items-layout-list-pickup", 3, "mousedown", "mouseup", "click", "focus", "focusin"], [3, "disabled", "checked", "exTooltip", "ariaLabel", "checkedChange", 4, "ngIf"], [3, "aria-labelledby", "checked", "keydown.space", "click", 4, "ngIf"], [3, "color", "iconName", 4, "ngIf"], ["class", "ex-items-layout-list-thumbnail-icons", 4, "ngIf"], [3, "ngSwitch"], [3, "class", "exTooltip", 4, "ngSwitchCase"], ["sizePx", "25px", 3, "class", "iconName", "iconType", 4, "ngSwitchCase"], [3, "disabled", "checked", "exTooltip", "ariaLabel", "checkedChange"], [3, "aria-labelledby", "checked", "keydown.space", "click"], [3, "color", "iconName"], [1, "ex-items-layout-list-thumbnail-icons"], [3, "iconName", "color", "tooltip", "callback", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "iconName", "color", "tooltip", "callback"], ["sizePx", "25px", 3, "iconName", "iconType"], [1, "ex-items-layout-list-sublist-bubbles"], [3, "diameter", 4, "ngIf", "ngIfElse"], ["bubble", ""], [3, "diameter"], ["class", "ex-items-layout-list-bubbles", 3, "mode", "ngClass", "text", "color", "tooltip", "click", 4, "ngIf"], [1, "ex-items-layout-list-bubbles", 3, "mode", "ngClass", "text", "color", "tooltip", "click"], ["aria-label", "move\n                                focus to right side", 1, "ex-items-layout-list-hidden-button", 3, "keyup.Tab"], [3, "list", "htmlId", "color", "selectedItem", "hasMore", "title", "description", "selectedItemChange", "loadMoreSublist", "closeClicked"], ["subList", ""], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination"], ["paginationRef", ""], ["role", "alert", 1, "ex-items-layout-list-hidden-button"], ["spinner", ""], ["mat-ripple", "", "matRippleColor", "transparent", 1, "ex-items-layout-list-row-item", 3, "ngClass"], ["class", "ex-items-layout-list-index", 4, "ngIf"], [1, "ex-items-layout-list-content"], [3, "proto", "hasPickup", "isMultiSelect", "emptyRowHeight"], [1, "ex-items-layout-list-index"], [1, "ex-items-layout-list-spinner", "sel-list-spinner", 3, "diameter"]], template: function ExItemsLayoutListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExItemsLayoutListComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
            i0.ɵɵtemplate(1, ExItemsLayoutListComponent_ng_template_1_Template, 6, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.listProperties.isLoading && ctx.readyToLoad)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgSwitch, i1$5.NgSwitchCase, ExRecordComponent, ExClickableChipComponent, ExExpandableSublistComponent, ExRecordPlaceholderComponent, ExPaginationComponent, i6$1.MatRipple, ExTooltipDirective, ResizedDirective, ExSpinnerComponent, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, ExDragAccessibleIconComponent, ExDragListComponent, ExIconComponent, ExSvgIconComponent, ExCheckboxComponent, i8.MatRadioButton, i1$2.TranslatePipe, ExUnderThumbnailIconsPipe], styles: [".ex-items-layout-list-li[_ngcontent-%COMP%]{display:block;position:relative}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]{margin-bottom:0;padding-bottom:10px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-hover-left-indication[_ngcontent-%COMP%]{cursor:pointer}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]:focus{border-top:1px solid black;border-inline-end:1px solid black;border-bottom:1px solid black}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]{border-top:1px solid transparent;border-inline-end:1px solid transparent;display:flex;flex-direction:row;padding:10px;outline:0}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]:hover{background:#f4f8fa}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-drag-mode-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-drag-and-drop[_ngcontent-%COMP%]{cursor:move;margin-right:10px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-index[_ngcontent-%COMP%]{margin-right:10px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-pickup[_ngcontent-%COMP%]{width:24px;margin-right:10px;display:flex;flex-direction:column;text-align:center}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-pickup[_ngcontent-%COMP%]   .ex-items-layout-list-warning-icon[_ngcontent-%COMP%], .ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-pickup[_ngcontent-%COMP%]   .ex-items-layout-list-valid-icon[_ngcontent-%COMP%], .ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-pickup[_ngcontent-%COMP%]   .ex-items-layout-list-suppress-icon[_ngcontent-%COMP%]{margin-top:5px!important}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-content[_ngcontent-%COMP%]{flex:1}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-content[_ngcontent-%COMP%]   .ex-items-layout-list-sublist-bubbles[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;margin-left:47px;margin-top:5px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-content[_ngcontent-%COMP%]   .ex-items-layout-list-sublist-bubbles[_ngcontent-%COMP%]   .ex-items-layout-list-bubbles[_ngcontent-%COMP%]{margin-right:10px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item[_ngcontent-%COMP%]   .ex-items-layout-list-content[_ngcontent-%COMP%]   .ex-items-layout-list-sublist-bubbles[_ngcontent-%COMP%]   .ex-items-layout-list-not-selected-bubbles[_ngcontent-%COMP%]{opacity:.7}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item-dark-theme[_ngcontent-%COMP%]{background:#3f4348;color:#d8d8d8;border-bottom-color:#ebebeb4a}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item-dark-theme[_ngcontent-%COMP%]:hover{background:#4a4e53}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item-dark-theme[_ngcontent-%COMP%]   mark[_ngcontent-%COMP%]{background-color:#555;color:#fff}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item-disabled[_ngcontent-%COMP%]{pointer-events:none;background:#eee;opacity:.2}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-row-item-opened[_ngcontent-%COMP%]{border-top:1px solid #d0cfcf}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-large-density[_ngcontent-%COMP%]{padding:10px}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-disabled-content[_ngcontent-%COMP%]{pointer-events:none}.ex-items-layout-list-wrapper[_ngcontent-%COMP%]   .ex-items-layout-list-disabled-row-item[_ngcontent-%COMP%]{opacity:.3}.ex-items-layout-list-spinner[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;min-height:50vh}.ex-items-layout-list-hidden-button[_ngcontent-%COMP%]{width:0;height:0;overflow:hidden;border:transparent}.ex-items-layout-list-hidden-button.ex-items-layout-list-row-start-button[_ngcontent-%COMP%]{position:absolute}.ex-items-layout-list-thumbnail-icons[_ngcontent-%COMP%]{display:flex;flex-direction:column;row-gap:5px}.ex-items-layout-list-action-indication-reason-failed[_ngcontent-%COMP%]{display:flex;align-items:center;background:#ffebee;margin-top:5px;padding:3px 5px}.ex-items-layout-list-action-indication-reason-warning[_ngcontent-%COMP%]{display:flex;align-items:center;background:#fef1df;margin-top:5px;padding:1px 5px}"] }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutListComponent.prototype, "onItemClicked", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutListComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-list', template: "<ng-container *ngIf=\"!listProperties.isLoading && readyToLoad; else loadingTmpl\">\r\n  <ex-drag-list cdkDropList (cdkDropListDropped)=\"onDropListDropped($event)\">\r\n    <ul class=\"ex-items-layout-list-wrapper\"\r\n        resized [resizeCB]=\"onResized\"\r\n        [attr.aria-label]=\"!listProperties.isMultiSelect ? 'ng.general.single-select-group' : ''\"\r\n        [attr.role]=\"!listProperties.isMultiSelect ? 'radiogroup' : undefined\">\r\n      <ng-container *ngFor=\"let item of items; let i = index\">\r\n\r\n        <ng-template #itemTmpl [ngTemplateOutlet]=\"itemTmpl\" let-isItemSelected=\"isItemSelected\"\r\n                     let-isSublistOpen=\"isSublistOpen\" let-isOtherSublistOpen=\"isOtherSublistOpen\"\r\n                     [ngTemplateOutletContext]=\"{ isItemSelected: _selectedItem && item.id === _selectedItem.id,\r\n                                                            isSublistOpen: openedSublist && item.id === openedSublist.id,\r\n                                                            isOtherSublistOpen: openedSublist && item.id !== openedSublist.id }\">\r\n\r\n          <li cdkDrag [cdkDragDisabled]=\"!listProperties.hasDrag\"\r\n              class=\"sel-row-{{i}}-item ex-items-layout-list-li\" [attr.aria-hidden]=\"isOtherSublistOpen\">\r\n            <button *ngIf=\"isItemOpen && isItemSelected\"\r\n                    class=\"ex-items-layout-list-row-start-button ex-items-layout-list-hidden-button\" aria-label=\"move\r\n                                to previous list item\" (focusin)=\"onRowStartFocused($event)\"></button>\r\n            <div #rowItemRef [attr.role]=\"listProperties.canSelectRow && 'button'\"\r\n                 [attr.tabindex]=\"(isOtherSublistOpen || !listProperties.canSelectRow) ? -1 : 0\" [attr.aria-pressed]=\"isItemSelected\"\r\n                 (click)=\"onItemClicked(item)\" (keydown.enter)=\"onItemClicked(item)\"\r\n                 (keydown.space)=\"onItemClicked(item)\" (keydown.arrowdown)=\"onRowArrowDown($event, item)\"\r\n                 (keydown.arrowup)=\"onRowArrowUp($event, item)\" class=\"ex-items-layout-list-row-item\" [ngClass]=\"{\r\n                                'ex-items-layout-list-row-item-opened': isSublistOpen,\r\n                                'ex-items-layout-list-row-item-disabled': isOtherSublistOpen,\r\n                                'ex-items-layout-list-checked': isItemChecked(item),\r\n                                'ex-items-layout-list-selected': listProperties.canSelectRow && isItemSelected,\r\n                                'ex-items-layout-list-hover-left-indication': listProperties.canSelectRow,\r\n                                'ex-items-layout-list-large-density': listProperties.density === 'large',\r\n                                'ex-items-layout-list-row-item-dark-theme': listProperties.isDarkTheme,\r\n                                'ex-items-layout-list-selected-dark-theme': listProperties.canSelectRow && isItemSelected && listProperties.isDarkTheme\r\n                            }\">\r\n              <span\r\n                class=\"sr-only\">{{ item?.actionIndication?.type ? (item?.actionIndication?.type === 'success' ? ('ng.general.success' | translate) : (item?.actionIndication?.type === 'warning' ? ('ng.general.warning' | translate) : ('ng.general.failure' | translate)) + ' - ' + (item?.actionIndication?.reason | translate)) : '' }}</span>\r\n              <div class=\"ex-items-layout-list-drag-mode-wrapper\">\r\n                <ex-drag-accessible-icon *ngIf=\"listProperties.hasDrag\" cdkDragHandle\r\n                                         class=\"ex-items-layout-list-drag-and-drop\"></ex-drag-accessible-icon>\r\n                <i *ngIf=\"item.mode?.value === 'WARNING' && !listProperties.hasPickup\"\r\n                   class=\"material-icons ex-items-layout-list-warning-icon sel-warning-{{i}}\"\r\n                   [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                  error\r\n                </i>\r\n              </div>\r\n              <span *ngIf=\"listProperties.hasIndex\">\r\n                                <span class=\"ex-items-layout-list-index\" [id]=\"isItemSelected?'selectedItemInList':null\"\r\n                                      [ngClass]=\"{'ex-items-layout-list-disabled-row-item' : item.disabled}\">\r\n                                    {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) + i + 1) }}\r\n                                </span></span>\r\n              <div class=\"ex-items-layout-list-pickup\" *ngIf=\"listProperties.hasPickup\"\r\n                   (mousedown)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                   (mouseup)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                   (click)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                   (focus)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                   (focusin)=\"$event.stopImmediatePropagation(); $event.preventDefault()\">\r\n                <!-- stopPropagation and preventDefault on mousedown, mouseup, click, focusin to prevent focusin event in parents -->\r\n                <ex-checkbox *ngIf=\"listProperties.isMultiSelect\" [disabled]=\"item.selectable===false\"\r\n                             [checked]=\"isItemChecked(item)\"\r\n                             [exTooltip]=\"item.selectable!==false? '':item.nonSelectableTooltip | translate\"\r\n                             [attr.aria-hidden]=\"!(!listProperties.isLoading && readyToLoad)\"\r\n                             (checkedChange)=\"onItemCheckedChange(item, $event)\"\r\n                             [ariaLabel]=\"('ng.ex_items_layout_list_row.check_or_uncheck' | translate) + ' ' + ((listProperties.pagination.selectedPage - 1)*(listProperties.pagination.pageSize)+i+1)\">\r\n                </ex-checkbox>\r\n                <mat-radio-button *ngIf=\"!listProperties.isMultiSelect\"\r\n                                  (keydown.space)=\"onSingleItemCheckedChange(item)\" aria-labelledby=\"recordId-{{i}}\"\r\n                                  (click)=\"onSingleItemCheckedChange(item)\" [checked]=\"isItemChecked(item)\">\r\n                </mat-radio-button>\r\n                <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='failed'\" [color]=\"'#e54746'\"\r\n                             [iconName]=\"'circ_warning'\"></ex-svg-icon>\r\n                <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='warning'\" [color]=\"'#e7a141'\"\r\n                             [iconName]=\"'warning'\"></ex-svg-icon>\r\n                <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='success'\" [color]=\"'#60c05f'\"\r\n                             [iconName]=\"'success'\"></ex-svg-icon>\r\n                <div *ngIf=\"!showCustomizedThumbnail || !showThumbnail\" class=\"ex-items-layout-list-thumbnail-icons\">\r\n                  <ex-svg-icon *ngIf=\"item?.listItem[this.item?.listItem?.__proto__.thumbnailIcon?.key]; let icon\"\r\n                               [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                               [tooltip]=\"icon?.tooltip\"\r\n                               [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                  <ng-container *ngFor=\"let icon of item?.listItem | exUnderThumbnailIcons;trackBy:iconTrackBy\">\r\n                    <ex-svg-icon *ngIf=\"icon\" [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                                 [tooltip]=\"icon?.tooltip\"\r\n                                 [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                  </ng-container>\r\n                </div>\r\n                <div [ngSwitch]=\"item.mode?.value\">\r\n                  <i *ngSwitchCase=\"'WARNING'\"\r\n                     class=\"material-icons ex-items-layout-list-warning-icon sel-warning-{{i}}\"\r\n                     [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                    error\r\n                  </i>\r\n                  <i *ngSwitchCase=\"'VALID'\"\r\n                     class=\"material-icons ex-items-layout-list-valid-icon sel-valid-{{i}}\"\r\n                     [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                    check_circle\r\n                  </i>\r\n                  <ex-icon sizePx=\"25px\" *ngSwitchCase=\"'SUPPRESSED'\"\r\n                           class=\"material-icons ex-items-layout-list-suppress-icon sel-suppress-{{i}}\"\r\n                           [iconName]=\"'visibility-off'\" [iconType]=\"'svg'\">\r\n                  </ex-icon>\r\n\r\n                </div>\r\n              </div>\r\n              <div class=\"ex-items-layout-list-content\"\r\n                   [ngClass]=\"{'ex-items-layout-list-disabled-content' : item.disabled, 'ex-items-layout-list-disabled-row-item' : item.disabled}\">\r\n                <ex-record [highlightedText]=\"listProperties.highlightedText\" [data]=\"item.listItem\" id=\"recordId-{{i}}\"\r\n                           [width]=\"leftSideWidth\" [recordIndex]=\"i\" [isSelected]=\"_selectedItem && _selectedItem.id === item.id\"\r\n                           [emptyRowHeight]=\"listProperties.emptyRowHeight\"\r\n                           [isExPickup]=\"listProperties.isExPickup\"\r\n                           [inExSidepanePickup]=\"listProperties.inExSidepanePickup\"\r\n                           htmlId=\"{{ htmlId }}{{ htmlId ? '_' : '' }}{{ htmlId ? i : '' }}\"\r\n                           [isItemOpen]=\"isItemOpen\" [recordCustomizationData]=\"recordCustomizationData\"\r\n                           [showThumbnail]=\"showThumbnail && showCustomizedThumbnail\"\r\n                           (actionClicked)=\"onActionClicked(item, $event)\">\r\n                </ex-record>\r\n                <div *ngIf=\"item?.actionIndication?.reason != ''\"\r\n                     class=\"ex-items-layout-list-action-indication-reason-{{item?.actionIndication?.type}}\">{{ item?.actionIndication?.reason | translate }}\r\n                </div>\r\n                <div *ngIf=\"!item.disabled && item.sublists?.length > 0\"\r\n                     class=\"ex-items-layout-list-sublist-bubbles\">\r\n                  <ng-container *ngFor=\"let sublist of item.sublists; let j = index\">\r\n                    <ex-spinner *ngIf=\"sublist.loading; else bubble\" [diameter]=\"15\"></ex-spinner>\r\n                    <ng-template #bubble>\r\n                      <ex-clickable-chip\r\n                        [mode]=\"(isSublistOpen && (sublistIndex === j)) ? 'filled': 'transparent'\"\r\n                        class=\"ex-items-layout-list-bubbles\"\r\n                        [ngClass]=\"{ 'ex-items-layout-list-not-selected-bubbles': !isItemSelected && !isSublistOpen}\"\r\n                        text=\"+{{ sublist.length }}\" [color]=\"sublist.color\"\r\n                        *ngIf=\"sublist.length > 0\"\r\n                        [tooltip]=\"(sublist.title | translate) + ' ' + (sublist.description | translate)\"\r\n                        (click)=\"openSublist(item, j)\">\r\n                      </ex-clickable-chip>\r\n                    </ng-template>\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n              <button *ngIf=\"isItemOpen && isItemSelected\" class=\"ex-items-layout-list-hidden-button\"\r\n                      aria-label=\"move\r\n                                focus to right side\" (keyup.Tab)=\"onTabFromRowEnd()\"></button>\r\n            </div>\r\n            <div *ngIf=\"isSublistOpen\">\r\n              <ex-expandable-sublist #subList [list]=\"item.sublists[sublistIndex].list\"\r\n                                     [htmlId]=\"htmlId + '_' + i + '_sub'\" [color]=\"item.sublists[sublistIndex].color\"\r\n                                     [selectedItem]=\"selectedItemInSublistIndex\"\r\n                                     (selectedItemChange)=\"onSublistSelectedItemChange($event)\"\r\n                                     [hasMore]=\"item.sublists[sublistIndex].hasMore\"\r\n                                     [title]=\"item.sublists[sublistIndex].title\"\r\n                                     [description]=\"item.sublists[sublistIndex].description\"\r\n                                     (loadMoreSublist)=\"onLoadMoreSublist()\" (closeClicked)=\"onSublistCloseClicked()\">\r\n              </ex-expandable-sublist>\r\n            </div>\r\n          </li>\r\n\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </ul>\r\n  </ex-drag-list>\r\n  <ex-pagination #paginationRef *ngIf=\"listProperties.pagination.totalItemsCount > 0\"\r\n              [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\r\n            [pageSize]=\"listProperties.pagination.pageSize\"\r\n            [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\r\n            [selectedPage]=\"listProperties.pagination.selectedPage\"\r\n            (selectedPageChange)=\"onSelectedPageChange($event)\" (pageSizeChange)=\"onPageSizeChange($event)\"\r\n            (endOfPagination)=\"endOfPagination.emit()\" [doNotUpdateStateInternally]=\"true\">\r\n  </ex-pagination>\r\n</ng-container>\r\n\r\n<ng-template #loadingTmpl>\r\n  <div role=\"alert\" class=\"ex-items-layout-list-hidden-button\">\r\n    {{ 'ng.ex-list-layout.loading_results' | translate }}\r\n  </div>\r\n  <ng-container *ngIf=\"!listProperties.showSpinner; else spinner\">\r\n    <div class=\"ex-items-layout-list-wrapper\" resized [resizeCB]=\"emitResizeEventCB\">\r\n      <div *ngFor=\"let dummy of ' '.repeat(numPlaceholderRows).split(''), let i = index\">\r\n        <div mat-ripple matRippleColor=\"transparent\" class=\"ex-items-layout-list-row-item\"\r\n             [ngClass]=\"{'ex-items-layout-list-large-density': listProperties.density === 'large'}\">\r\n                    <span *ngIf=\"listProperties.hasIndex\" class=\"ex-items-layout-list-index\">\r\n                        {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) + i + 1) }}\r\n                    </span>\r\n          <div class=\"ex-items-layout-list-content\">\r\n            <ex-record-placeholder [proto]=\"listProperties.proto\" [hasPickup]=\"listProperties.hasPickup\"\r\n                                   [isMultiSelect]=\"listProperties.isMultiSelect\"\r\n                                   [emptyRowHeight]=\"listProperties.emptyRowHeight\">\r\n            </ex-record-placeholder>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #spinner>\r\n    <ex-spinner class=\"ex-items-layout-list-spinner sel-list-spinner\" [diameter]=\"50\"></ex-spinner>\r\n  </ng-template>\r\n</ng-template>\r\n", styles: [".ex-items-layout-list-li{display:block;position:relative}.ex-items-layout-list-wrapper{margin-bottom:0;padding-bottom:10px}.ex-items-layout-list-wrapper .ex-items-layout-list-hover-left-indication{cursor:pointer}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item:focus{border-top:1px solid black;border-inline-end:1px solid black;border-bottom:1px solid black}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item{border-top:1px solid transparent;border-inline-end:1px solid transparent;display:flex;flex-direction:row;padding:10px;outline:0}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item:hover{background:#f4f8fa}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-drag-mode-wrapper{display:flex;flex-direction:column;align-items:center}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-drag-and-drop{cursor:move;margin-right:10px}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-index{margin-right:10px}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-pickup{width:24px;margin-right:10px;display:flex;flex-direction:column;text-align:center}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-pickup .ex-items-layout-list-warning-icon,.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-pickup .ex-items-layout-list-valid-icon,.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-pickup .ex-items-layout-list-suppress-icon{margin-top:5px!important}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-content{flex:1}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-content .ex-items-layout-list-sublist-bubbles{display:flex;flex-direction:row;align-items:center;margin-left:47px;margin-top:5px}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-content .ex-items-layout-list-sublist-bubbles .ex-items-layout-list-bubbles{margin-right:10px}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item .ex-items-layout-list-content .ex-items-layout-list-sublist-bubbles .ex-items-layout-list-not-selected-bubbles{opacity:.7}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item-dark-theme{background:#3f4348;color:#d8d8d8;border-bottom-color:#ebebeb4a}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item-dark-theme:hover{background:#4a4e53}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item-dark-theme mark{background-color:#555;color:#fff}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item-disabled{pointer-events:none;background:#eee;opacity:.2}.ex-items-layout-list-wrapper .ex-items-layout-list-row-item-opened{border-top:1px solid #d0cfcf}.ex-items-layout-list-wrapper .ex-items-layout-list-large-density{padding:10px}.ex-items-layout-list-wrapper .ex-items-layout-list-disabled-content{pointer-events:none}.ex-items-layout-list-wrapper .ex-items-layout-list-disabled-row-item{opacity:.3}.ex-items-layout-list-spinner{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;min-height:50vh}.ex-items-layout-list-hidden-button{width:0;height:0;overflow:hidden;border:transparent}.ex-items-layout-list-hidden-button.ex-items-layout-list-row-start-button{position:absolute}.ex-items-layout-list-thumbnail-icons{display:flex;flex-direction:column;row-gap:5px}.ex-items-layout-list-action-indication-reason-failed{display:flex;align-items:center;background:#ffebee;margin-top:5px;padding:3px 5px}.ex-items-layout-list-action-indication-reason-warning{display:flex;align-items:center;background:#fef1df;margin-top:5px;padding:1px 5px}\n"] }]
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }]; }, { showThumbnail: [{
            type: Input
        }], sublistOpened: [{
            type: Output
        }], selectedSublistItemChanged: [{
            type: Output
        }], loadMoreSublist: [{
            type: Output
        }], subListRef: [{
            type: ViewChild,
            args: ['subList']
        }], rowItems: [{
            type: ViewChildren,
            args: ['rowItemRef']
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }], onItemClicked: [] }); })();

function ExSectionsLayoutDropdownComponent_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 1);
    i0.ɵɵlistener("childClicked", function ExSectionsLayoutDropdownComponent_ex_button_0_Template_ex_button_childClicked_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onSectionSelected($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.buttonItems.length === 0)("openToSide", false)("children", ctx_r0.buttonItems)("hasSearchBox", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, "ng.general.sections"), "\n");
} }
class ExSectionsLayoutDropdownComponent {
    constructor(exSectionsLayoutService) {
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.sectionsList = [];
        this.subs = new Subscription();
    }
    ngOnInit() {
        this.initSectionChangeListener();
    }
    initSectionChangeListener() {
        this.subs.add(this.exSectionsLayoutService.sectionComboboxListChanged$.subscribe(sectionsList => {
            this.buttonItems = sectionsList.map((sec) => {
                return {
                    key: sec.identifier,
                    value: sec.identifier,
                    icon: {
                        iconType: sec.iconType,
                        iconName: sec.iconName ? 'add' : null,
                        iconColor: '#4164a4'
                    },
                    label: sec.value, disabled: false, loading: false
                };
            });
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onSectionSelected(key) {
        if (!!this.scrollingSelector) {
            this.exSectionsLayoutService.selectSection(key, this.scrollingSelector);
        }
        else {
            this.exSectionsLayoutService.selectSection(key);
        }
    }
    static { this.ɵfac = function ExSectionsLayoutDropdownComponent_Factory(t) { return new (t || ExSectionsLayoutDropdownComponent)(i0.ɵɵdirectiveInject(ExSectionsLayoutService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSectionsLayoutDropdownComponent, selectors: [["ex-sections-layout-dropdown"]], inputs: { scrollingSelector: "scrollingSelector" }, decls: 1, vars: 1, consts: [["class", "ex-sections-layout-dropdown-button", "type", "action", 3, "disabled", "openToSide", "children", "hasSearchBox", "childClicked", 4, "ngIf"], ["type", "action", 1, "ex-sections-layout-dropdown-button", 3, "disabled", "openToSide", "children", "hasSearchBox", "childClicked"]], template: function ExSectionsLayoutDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExSectionsLayoutDropdownComponent_ex_button_0_Template, 3, 7, "ex-button", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.buttonItems == null ? null : ctx.buttonItems.length) > 0);
        } }, dependencies: [i1$5.NgIf, ExButtonComponent, i1$2.TranslatePipe], styles: ["ex-button.ex-sections-layout-dropdown-button{padding-inline:3px}  ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper{background:#f2f2f2!important;min-height:30px!important}  ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper:hover,   ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper:focus-within{background-color:#e9e9e9!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutDropdownComponent, [{
        type: Component,
        args: [{ selector: 'ex-sections-layout-dropdown', template: "<ex-button class=\"ex-sections-layout-dropdown-button\" *ngIf=\"buttonItems?.length > 0\" type=\"action\" [disabled]=\"buttonItems.length === 0\"\n            [openToSide]=\"false\" [children]=\"buttonItems\"\n            [hasSearchBox]=\"true\" (childClicked)=\"onSectionSelected($event)\" >\n {{ 'ng.general.sections' | translate}}\n</ex-button>", styles: ["::ng-deep ex-button.ex-sections-layout-dropdown-button{padding-inline:3px}::ng-deep ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper{background:#f2f2f2!important;min-height:30px!important}::ng-deep ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper:hover,::ng-deep ex-button.ex-sections-layout-dropdown-button .ex-button-wrapper:focus-within{background-color:#e9e9e9!important}\n"] }]
    }], function () { return [{ type: ExSectionsLayoutService }]; }, { scrollingSelector: [{
            type: Input
        }] }); })();

const _c0$l = function (a0, a1) { return { "status-wrapper-sidenav-expanded": a0, "status-wrapper-btn-expanded": a1 }; };
const _c1$f = function (a0) { return { color: a0 }; };
function ExItemDetailsHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "ex-icon", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$l, i0.ɵɵpipeBind1(1, 7, ctx_r0.expandActionsOnAllSpace && (ctx_r0.exItemsLayoutService == null ? null : ctx_r0.exItemsLayoutService.expandLeftSidenavChange$)), ctx_r0.expandActionsOnAllSpace));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c1$f, ctx_r0.status.statusTextolor));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, ctx_r0.status.data), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", ctx_r0.status.iconName)("iconType", ctx_r0.status.iconType)("color", ctx_r0.status.iconColor)("sizePx", ctx_r0.status.iconFontSize);
} }
function ExItemDetailsHeaderComponent_ex_component_loader_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 13);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("componentFactoryItem", ctx_r1.getHeaderMenusDynamicComponent())("data", ctx_r1.getHeaderMenusDynamicData())("events", ctx_r1.getHeaderMenusDynamicEvents());
} }
function ExItemDetailsHeaderComponent_ex_sections_layout_dropdown_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-sections-layout-dropdown", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("scrollingSelector", ctx_r2.scrollingSelector);
} }
const _c2$9 = function (a1) { return { "isInHeader": true, expandActionsOnAllSpace: a1 }; };
function ExItemDetailsHeaderComponent_ng_template_6_ex_component_loader_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 16);
    i0.ɵɵpipe(1, "objectAssign");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-item-details-header-actions", ctx_r9.expandActionsOnAllSpace);
    i0.ɵɵproperty("componentFactoryItem", ctx_r9.dynamicActionsComponent)("data", i0.ɵɵpipeBind2(1, 5, ctx_r9.actions == null ? null : ctx_r9.actions.actions.inputs, i0.ɵɵpureFunction1(8, _c2$9, ctx_r9.expandActionsOnAllSpace)))("events", ctx_r9.actions == null ? null : ctx_r9.actions.actions.events);
} }
function ExItemDetailsHeaderComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemDetailsHeaderComponent_ng_template_6_ex_component_loader_0_Template, 2, 10, "ex-component-loader", 15);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.actions);
} }
function ExItemDetailsHeaderComponent_ex_record_actions_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-record-actions", 17);
    i0.ɵɵlistener("actionClicked", function ExItemDetailsHeaderComponent_ex_record_actions_8_Template_ex_record_actions_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onActionClicked($event)); });
    i0.ɵɵpipe(1, "exDisplayActions");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ex-item-details-header-record-actions", ctx_r5.expandActionsOnAllSpace);
    i0.ɵɵproperty("actions", i0.ɵɵpipeBind2(1, 7, ctx_r5.actionsList, i0.ɵɵpipeBind1(2, 10, ctx_r5.sectionsEditModeObservable)))("visibleBtnNum", ctx_r5.actions == null ? null : ctx_r5.actions.visibleBtnNum)("loading", ctx_r5.actions == null ? null : ctx_r5.actions.loading)("expandActionsOnAllSpace", ctx_r5.expandActionsOnAllSpace)("isSelected", false);
} }
function ExItemDetailsHeaderComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 26);
    i0.ɵɵlistener("click", function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_0_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.onEditAll()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-svg-icon", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(1, 6, "ng.general.edit"));
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(2, 8, "ng.general.edit"));
    i0.ɵɵproperty("exQuickAccessType", ctx_r16.quickAcssessTypes.ACTION);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 10, "ng.general.edit"), " ");
} }
function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 29);
    i0.ɵɵlistener("click", function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_1_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.onCancelAll()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(1, 6, "ng.general.cancel"));
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(2, 8, "ng.general.cancel"));
    i0.ɵɵproperty("exQuickAccessType", ctx_r17.quickAcssessTypes.ACTION);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 10, "ng.general.cancel"));
} }
function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 30);
    i0.ɵɵlistener("click", function ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_2_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r23.onSaveAll()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(1, 9, "ng.general.save"));
    i0.ɵɵpropertyInterpolate("exQuickAccess", i0.ɵɵpipeBind1(4, 15, "ng.general.save"));
    i0.ɵɵproperty("disabled", ctx_r18.singleSaveDisabledInit || ctx_r18.singleSaveDisabled || i0.ɵɵpipeBind1(2, 11, ctx_r18.saveDisabled))("loading", i0.ɵɵpipeBind1(3, 13, ctx_r18.saveInProgress))("disabledTooltip", ctx_r18.singleSaveDisabledTooltip)("exQuickAccessType", ctx_r18.quickAcssessTypes.ACTION);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 17, "ng.general.save"));
} }
function ExItemDetailsHeaderComponent_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_0_Template, 7, 12, "ex-button", 23);
    i0.ɵɵtemplate(1, ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_1_Template, 5, 12, "ex-button", 24);
    i0.ɵɵtemplate(2, ExItemDetailsHeaderComponent_div_9_ng_template_2_ex_button_2_Template, 7, 19, "ex-button", 25);
} if (rf & 2) {
    const sectionsEditMode_r15 = ctx.sectionsEditMode;
    i0.ɵɵproperty("ngIf", !sectionsEditMode_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sectionsEditMode_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sectionsEditMode_r15);
} }
const _c3$6 = function (a0) { return { sectionsEditMode: a0 }; };
function ExItemDetailsHeaderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, ExItemDetailsHeaderComponent_div_9_div_1_Template, 2, 0, "div", 19);
    i0.ɵɵtemplate(2, ExItemDetailsHeaderComponent_div_9_ng_template_2_Template, 3, 3, "ng-template", 20, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(3);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.actions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r13)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c3$6, i0.ɵɵpipeBind1(4, 3, ctx_r6.sectionsEditModeObservable)));
} }
function ExItemDetailsHeaderComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "button", 32);
    i0.ɵɵlistener("click", function ExItemDetailsHeaderComponent_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.prevClicked.emit()); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 34);
    i0.ɵɵlistener("click", function ExItemDetailsHeaderComponent_div_10_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.nextClicked.emit()); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "ex-svg-icon", 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 8, "ng.general.previous"))("disabled", !ctx_r7.hasPrev);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 10, "ng.general.previous"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconName", "prev");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(6, 12, "ng.general.next"))("disabled", !ctx_r7.hasNext);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 14, "ng.general.next"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconName", "next");
} }
function ExItemDetailsHeaderComponent_ex_close_11_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-close", 35);
    i0.ɵɵlistener("closeClicked", function ExItemDetailsHeaderComponent_ex_close_11_Template_ex_close_closeClicked_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.closeClicked.emit()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.close"));
} }
const _c4$4 = function (a0) { return { "ex-item-details-header-header-wrapper-sidenav-expanded": a0 }; };
const STATUS_TIMEOUT = 5000;
class ExItemDetailsHeaderComponent {
    set itemId(itemId) {
        this._itemId = itemId;
        this.initStatusChangeListener(itemId);
    }
    get itemId() {
        return this._itemId;
    }
    constructor(exSectionsLayoutService, dialogService, exItemsLayoutService, isSingleSave, statusService) {
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.dialogService = dialogService;
        this.exItemsLayoutService = exItemsLayoutService;
        this.isSingleSave = isSingleSave;
        this.statusService = statusService;
        this.hasTitle = false;
        this.status = null;
        this.deepLinkMode = false;
        this.isEditable = true;
        this.singleSaveDisabled = false;
        this.expandActionsOnAllSpace = false;
        this.nextClicked = new EventEmitter();
        this.prevClicked = new EventEmitter();
        this.closeClicked = new EventEmitter();
        this.actionClicked = new EventEmitter();
        this.editAllClicked = new EventEmitter();
        this.subs = new Subscription();
        this.statusSub = new Subscription();
        this.actionsList = [];
        this.sectionsEditModeObservable = this.exSectionsLayoutService.sectionsEditMode$;
        this.singleSaveDisabledTooltip = null;
        this.singleSaveDisabledInit = false;
        this.quickAcssessTypes = QuickAccessType;
        this.saveDisabled = this.exSectionsLayoutService.sectionsFormsStateChange$.pipe(map$1(state => {
            if (Object.entries(state).some(([key, value]) => value.isSingleSave == false && value.dirty == true))
                return true;
            return false;
        }), tap(disabled => {
            this.singleSaveDisabledTooltip = disabled ? 'ng.single_save.save_disabled_non_primary_dirty' : null;
        }));
        this.saveInProgress = merge(this.exSectionsLayoutService.saveAllSections$.pipe(map$1(_ => true)), this.exSectionsLayoutService.singleSaveComplete$.pipe(map$1(_ => false)));
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('actions')) {
            if (!this.actions?.type) {
                this.actionsList = this.actions?.actions ? this.actions?.actions.filter(action => !action.hideInRightSide) : [];
            }
            if (changes.actions.currentValue?.type && (changes.actions.currentValue?.type != changes.actions.previousValue?.type)) {
                this.dynamicActionsComponent = new ExComponentFactoryItem(this.actions.type, {});
            }
        }
    }
    initStatusChangeListener(itemId) {
        if (!this.statusService || !itemId)
            return;
        this.statusSub.unsubscribe();
        this.status = null;
        this.statusSub = this.statusService.onStatusChange(itemId).subscribe(data => {
            clearTimeout(this.statusTimeout);
            this.status = this.statusService.getStatusData(data.status);
            if (data.status === ItemDetailsHeaderStatus.Saved) {
                this.statusTimeout = setTimeout(() => this.status = null, STATUS_TIMEOUT);
            }
        });
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
        this.statusSub.unsubscribe();
    }
    getHeaderMenusDynamicComponent() {
        const data = this.getHeaderMenusDynamicData();
        return new ExComponentFactoryItem(this.headerMenus.type, data);
    }
    getHeaderMenusDynamicData() {
        const data = { ...this.headerMenus.headerMenus.inputs, isInHeader: true };
        return data;
    }
    getHeaderMenusDynamicEvents() {
        const events = { ...this.headerMenus.headerMenus.events };
        return events;
    }
    onActionClicked(key) {
        this.actionClicked.emit(key);
    }
    onEditAll() {
        this.singleSaveDisabledInit = true;
        setTimeout(() => {
            this.singleSaveDisabledInit = false;
        }, 100);
        this.exSectionsLayoutService.doEditAllSections();
        this.editAllClicked.next(null);
    }
    onSaveAll() {
        this.exSectionsLayoutService.doSaveAllSections();
    }
    onCancelAll() {
        this.exSectionsLayoutService.doCancelAllSections();
    }
    static { this.ɵfac = function ExItemDetailsHeaderComponent_Factory(t) { return new (t || ExItemDetailsHeaderComponent)(i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(ExItemsLayoutService, 8), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(ExItemDetailsHeaderStatusService, 12)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemDetailsHeaderComponent, selectors: [["ex-item-details-header"]], inputs: { itemId: "itemId", layoutLoading: "layoutLoading", hasNext: "hasNext", hasPrev: "hasPrev", hasTitle: "hasTitle", actions: "actions", headerMenus: "headerMenus", status: "status", hasSectionsCombobox: "hasSectionsCombobox", deepLinkMode: "deepLinkMode", scrollingSelector: "scrollingSelector", isEditable: "isEditable", singleSaveDisabled: "singleSaveDisabled", expandActionsOnAllSpace: "expandActionsOnAllSpace" }, outputs: { nextClicked: "nextClicked", prevClicked: "prevClicked", closeClicked: "closeClicked", actionClicked: "actionClicked", editAllClicked: "editAllClicked" }, features: [i0.ɵɵProvidersFeature([{ provide: EX_QUICK_ACCESS_SCOPE, useValue: true }]), i0.ɵɵNgOnChangesFeature], decls: 12, vars: 13, consts: [[1, "ex-item-details-header-main-wrapper"], [1, "ex-item-details-header-header-wrapper", 3, "ngClass"], ["class", "ex-item-details-header-status-wrapper", 3, "ngClass", 4, "ngIf"], ["class", "ex-item-details-header-menus", 3, "componentFactoryItem", "data", "events", 4, "ngIf"], ["class", "ex-item-details-header-sections", 3, "scrollingSelector", 4, "ngIf"], ["actionsComponentLoader", ""], [3, "ex-item-details-header-record-actions", "actions", "visibleBtnNum", "loading", "expandActionsOnAllSpace", "isSelected", "actionClicked", 4, "ngIf", "ngIfElse"], ["class", "ex-item-details-header-sections-single-save-buttons", 4, "ngIf"], ["class", "ex-item-details-header-arrows", 4, "ngIf"], [3, "tooltip", "closeClicked", 4, "ngIf"], [1, "ex-item-details-header-status-wrapper", 3, "ngClass"], [1, "ex-item-details-header-status-text", "sel-status", 3, "ngStyle"], [1, "ex-item-details-header-header-status-icon", 3, "iconName", "iconType", "color", "sizePx"], [1, "ex-item-details-header-menus", 3, "componentFactoryItem", "data", "events"], [1, "ex-item-details-header-sections", 3, "scrollingSelector"], [3, "componentFactoryItem", "ex-item-details-header-actions", "data", "events", 4, "ngIf"], [3, "componentFactoryItem", "data", "events"], [3, "actions", "visibleBtnNum", "loading", "expandActionsOnAllSpace", "isSelected", "actionClicked"], [1, "ex-item-details-header-sections-single-save-buttons"], ["class", "ex-item-details-header-actions-divider", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["singleSaveActionsTmpl", ""], [1, "ex-item-details-header-actions-divider"], ["type", "primary", "exKeyboardShortcut", "Edit", 3, "class", "exQuickAccess", "exQuickAccessType", "click", 4, "ngIf"], ["exKeyboardShortcut", "Cancel", 3, "exQuickAccess", "class", "exQuickAccessType", "click", 4, "ngIf"], ["exKeyboardShortcut", "Save", "type", "primary", 3, "class", "disabled", "loading", "disabledTooltip", "exQuickAccess", "exQuickAccessType", "click", 4, "ngIf"], ["type", "primary", "exKeyboardShortcut", "Edit", 3, "exQuickAccess", "exQuickAccessType", "click"], [1, "ex-item-details-header-sections-single-save-edit"], ["iconName", "edit", "color", "white"], ["exKeyboardShortcut", "Cancel", 3, "exQuickAccess", "exQuickAccessType", "click"], ["exKeyboardShortcut", "Save", "type", "primary", 3, "disabled", "loading", "disabledTooltip", "exQuickAccess", "exQuickAccessType", "click"], [1, "ex-item-details-header-arrows"], [1, "sel-prev", 3, "exTooltip", "disabled", "click"], [3, "iconName"], ["mat-ripple", "", 1, "sel-next", 3, "exTooltip", "disabled", "click"], [3, "tooltip", "closeClicked"]], template: function ExItemDetailsHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵtemplate(3, ExItemDetailsHeaderComponent_div_3_Template, 6, 16, "div", 2);
            i0.ɵɵtemplate(4, ExItemDetailsHeaderComponent_ex_component_loader_4_Template, 1, 3, "ex-component-loader", 3);
            i0.ɵɵtemplate(5, ExItemDetailsHeaderComponent_ex_sections_layout_dropdown_5_Template, 1, 1, "ex-sections-layout-dropdown", 4);
            i0.ɵɵtemplate(6, ExItemDetailsHeaderComponent_ng_template_6_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(8, ExItemDetailsHeaderComponent_ex_record_actions_8_Template, 3, 12, "ex-record-actions", 6);
            i0.ɵɵtemplate(9, ExItemDetailsHeaderComponent_div_9_Template, 5, 7, "div", 7);
            i0.ɵɵtemplate(10, ExItemDetailsHeaderComponent_div_10_Template, 9, 16, "div", 8);
            i0.ɵɵtemplate(11, ExItemDetailsHeaderComponent_ex_close_11_Template, 2, 3, "ex-close", 9);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(7);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4$4, i0.ɵɵpipeBind1(2, 9, ctx.exItemsLayoutService == null ? null : ctx.exItemsLayoutService.expandLeftSidenavChange$)));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.status);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.headerMenus);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasSectionsCombobox);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.layoutLoading && !(ctx.actions == null ? null : ctx.actions.type))("ngIfElse", !ctx.layoutLoading && _r3);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isSingleSave && !ctx.layoutLoading && ctx.isEditable);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.deepLinkMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.deepLinkMode);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i6$1.MatRipple, ExTooltipDirective, ExKeyboardShortcutDirective, ExQuickAccessDirective, ExComponentLoaderComponent, ExButtonComponent, ExRecordActionsComponent, ExCloseComponent, ExIconComponent, ExSvgIconComponent, ExSectionsLayoutDropdownComponent, i1$5.AsyncPipe, i1$2.TranslatePipe, ExObjectAssignPipe, ExGenerateIdPipe, ExDisplayActionsPipe], styles: [".ex-item-details-header-main-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:grid;align-content:center}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]{justify-self:flex-end;display:flex;padding:10px;padding-inline-end:0;align-items:center;max-height:53px;width:100%;min-width:330px;padding-inline-start:120px;justify-content:flex-end}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]     .ex-record-actions-main-buttons{margin-inline-end:3px!important}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-record-actions[_ngcontent-%COMP%]{flex:1}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-status-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding-right:5px;padding-top:5px;align-items:center}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-status-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-header-status-icon[_ngcontent-%COMP%]{padding-left:5px;margin-top:1px}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .status-wrapper-btn-expanded[_ngcontent-%COMP%]{margin-inline-start:-60px}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .status-wrapper-sidenav-expanded[_ngcontent-%COMP%]{margin-inline-start:-25px}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-arrows[_ngcontent-%COMP%]{margin-inline-end:5px;margin-inline-start:5px;display:flex;align-items:center}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-arrows[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:0;background-color:transparent;padding:2px}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-arrows[_ngcontent-%COMP%]   button.sel-prev[_ngcontent-%COMP%], .ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   .ex-item-details-header-arrows[_ngcontent-%COMP%]   button.sel-next[_ngcontent-%COMP%]{padding:4px}.ex-item-details-header-header-wrapper[_ngcontent-%COMP%]   ex-sections-layout-dropdown[_ngcontent-%COMP%]{display:flex}.ex-item-details-header-main-wrapper[_ngcontent-%COMP%]:after{content:\"\";position:absolute;display:flex;border-radius:inherit;height:10px;bottom:-10px;width:100%;background-image:linear-gradient(to bottom,#fff,#ffffffd9 33%,#ffffff03 99%,#fff0)}.ex-item-details-header-header-wrapper-sidenav-expanded[_ngcontent-%COMP%]{padding-inline-start:240px}.ex-item-details-header-actions[_ngcontent-%COMP%]{flex:1}.ex-item-details-header-actions-divider[_ngcontent-%COMP%]{width:1px;height:30px;margin-inline-end:9px;margin-inline-start:9px;border-inline-start:1px solid;border-inline-color:#cccccc}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]{display:flex}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]   ex-button[_ngcontent-%COMP%]{margin-inline-start:3px;margin-inline-end:3px}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]     .ex-button-wrapper{min-height:30px!important;font-size:13px!important}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]     .ex-button-wrapper:not(.ex-button-primary){color:#4664a4!important}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]   .ex-item-details-header-sections-single-save-edit[_ngcontent-%COMP%]{display:flex}.ex-item-details-header-sections-single-save-buttons[_ngcontent-%COMP%]   .ex-item-details-header-sections-single-save-edit[_ngcontent-%COMP%]   ex-svg-icon[_ngcontent-%COMP%]{margin-inline-start:5px}"] }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('exSectionsLayoutService', 'dialogService')
], ExItemDetailsHeaderComponent.prototype, "onCancelAll", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemDetailsHeaderComponent, [{
        type: Component,
        args: [{ selector: 'ex-item-details-header', providers: [{ provide: EX_QUICK_ACCESS_SCOPE, useValue: true }], template: "<div class=\"ex-item-details-header-main-wrapper\">\n  <div class=\"ex-item-details-header-header-wrapper\"\n       [ngClass]=\"{'ex-item-details-header-header-wrapper-sidenav-expanded': exItemsLayoutService?.expandLeftSidenavChange$ | async}\">\n    <div *ngIf=\"status\" class=\"ex-item-details-header-status-wrapper\"\n         [ngClass]=\"{'status-wrapper-sidenav-expanded': expandActionsOnAllSpace && exItemsLayoutService?.expandLeftSidenavChange$ | async,\n         'status-wrapper-btn-expanded': expandActionsOnAllSpace }\">\n      <span class=\"ex-item-details-header-status-text sel-status\" [ngStyle]=\"{ color: status.statusTextolor }\">\n        {{status.data | translate}}\n      </span>\n      <ex-icon [iconName]=\"status.iconName\" [iconType]=\"status.iconType\" [color]=\"status.iconColor\"\n               [sizePx]=\"status.iconFontSize\" class=\"ex-item-details-header-header-status-icon\"></ex-icon>\n    </div>\n\n    <ex-component-loader *ngIf=\"headerMenus\" [componentFactoryItem]=\"getHeaderMenusDynamicComponent()\"\n                         class=\"ex-item-details-header-menus\" [data]=\"getHeaderMenusDynamicData()\"\n                         [events]=\"getHeaderMenusDynamicEvents()\">\n    </ex-component-loader>\n    <ex-sections-layout-dropdown *ngIf=\"hasSectionsCombobox\" class=\"ex-item-details-header-sections\"\n                                 [scrollingSelector]=\"scrollingSelector\">\n    </ex-sections-layout-dropdown>\n\n    <ng-template #actionsComponentLoader>\n      <ex-component-loader *ngIf=\"actions\" [componentFactoryItem]=\"dynamicActionsComponent\"\n                           [class.ex-item-details-header-actions]=\"expandActionsOnAllSpace\"\n                           [data]=\"actions?.actions.inputs | objectAssign : { 'isInHeader': true, expandActionsOnAllSpace: expandActionsOnAllSpace }\"\n                           [events]=\"actions?.actions.events\">\n      </ex-component-loader>\n    </ng-template>\n\n    <ex-record-actions [class.ex-item-details-header-record-actions]=\"expandActionsOnAllSpace\"\n                       *ngIf=\"!layoutLoading && !actions?.type; else !layoutLoading && actionsComponentLoader\"\n                       [actions]=\"actionsList | exDisplayActions : (sectionsEditModeObservable | async)\"\n                       [visibleBtnNum]=\"actions?.visibleBtnNum\" [loading]=\"actions?.loading\"\n                       [expandActionsOnAllSpace]=\"expandActionsOnAllSpace\" (actionClicked)=\"onActionClicked($event)\"\n                       [isSelected]=\"false\">\n      <!-- isSelected is false for styling purposes -->\n    </ex-record-actions>\n\n\n    <div *ngIf=\"isSingleSave && !layoutLoading && isEditable\"\n         class=\"ex-item-details-header-sections-single-save-buttons\">\n      <div *ngIf=\"actions\" class=\"ex-item-details-header-actions-divider\">&nbsp;</div>\n      <ng-template #singleSaveActionsTmpl [ngTemplateOutlet]=\"singleSaveActionsTmpl\"\n                   let-sectionsEditMode=\"sectionsEditMode\"\n                   [ngTemplateOutletContext]=\"{ sectionsEditMode: sectionsEditModeObservable | async }\">\n        <ex-button *ngIf=\"!sectionsEditMode\" type=\"primary\" (click)=\"onEditAll() \" exKeyboardShortcut=\"Edit\" class=\"{{'ng.general.edit' | generateHTMLId }}\"\n                   exQuickAccess=\"{{'ng.general.edit' | translate}}\" [exQuickAccessType]=\"quickAcssessTypes.ACTION\">\n          <div class=\"ex-item-details-header-sections-single-save-edit\">\n            {{ 'ng.general.edit' | translate }}\n            <ex-svg-icon iconName=\"edit\" color=\"white\"></ex-svg-icon>\n          </div>\n        </ex-button>\n        <ex-button *ngIf=\"sectionsEditMode\" exKeyboardShortcut=\"Cancel\" (click)=\"onCancelAll()\"\n                   exQuickAccess=\"{{'ng.general.cancel' | translate}}\" class=\"{{'ng.general.cancel' | generateHTMLId }}\"\n                   [exQuickAccessType]=\"quickAcssessTypes.ACTION\">{{ 'ng.general.cancel' | translate}}</ex-button>\n        <ex-button *ngIf=\"sectionsEditMode\" exKeyboardShortcut=\"Save\" class=\"{{'ng.general.save' | generateHTMLId }}\"\n                   [disabled]=\"singleSaveDisabledInit || singleSaveDisabled || (saveDisabled | async)\"\n                   [loading]=\"saveInProgress | async\" [disabledTooltip]=\"singleSaveDisabledTooltip\" type=\"primary\"\n                   (click)=\"onSaveAll()\"\n                   exQuickAccess=\"{{'ng.general.save' | translate}}\"\n                   [exQuickAccessType]=\"quickAcssessTypes.ACTION\">{{ 'ng.general.save' | translate\n          }}</ex-button>\n      </ng-template>\n    </div>\n\n\n    <div *ngIf=\"!deepLinkMode\" class=\"ex-item-details-header-arrows\">\n      <button class=\"sel-prev\" [exTooltip]=\"'ng.general.previous' | translate\" [disabled]=\"!hasPrev\"\n              [attr.aria-label]=\"'ng.general.previous' | translate\" (click)=\"prevClicked.emit()\">\n        <ex-svg-icon [iconName]=\"'prev'\"></ex-svg-icon>\n      </button>\n      <button class=\"sel-next\" [exTooltip]=\"'ng.general.next' | translate\" mat-ripple [disabled]=\"!hasNext\"\n              [attr.aria-label]=\"'ng.general.next' | translate\" (click)=\"nextClicked.emit()\">\n        <ex-svg-icon [iconName]=\"'next'\"></ex-svg-icon>\n      </button>\n    </div>\n    <ex-close *ngIf=\"!deepLinkMode\" [tooltip]=\"'ng.general.close' | translate\" (closeClicked)=\"closeClicked.emit()\">\n    </ex-close>\n  </div>\n</div>\n", styles: [".ex-item-details-header-main-wrapper{width:100%;height:100%;display:grid;align-content:center}.ex-item-details-header-header-wrapper{justify-self:flex-end;display:flex;padding:10px;padding-inline-end:0;align-items:center;max-height:53px;width:100%;min-width:330px;padding-inline-start:120px;justify-content:flex-end}.ex-item-details-header-header-wrapper ::ng-deep .ex-record-actions-main-buttons{margin-inline-end:3px!important}.ex-item-details-header-header-wrapper .ex-item-details-header-record-actions{flex:1}.ex-item-details-header-header-wrapper .ex-item-details-header-status-wrapper{display:flex;flex-direction:row;padding-right:5px;padding-top:5px;align-items:center}.ex-item-details-header-header-wrapper .ex-item-details-header-status-wrapper .ex-item-details-header-header-status-icon{padding-left:5px;margin-top:1px}.ex-item-details-header-header-wrapper .status-wrapper-btn-expanded{margin-inline-start:-60px}.ex-item-details-header-header-wrapper .status-wrapper-sidenav-expanded{margin-inline-start:-25px}.ex-item-details-header-header-wrapper .ex-item-details-header-arrows{margin-inline-end:5px;margin-inline-start:5px;display:flex;align-items:center}.ex-item-details-header-header-wrapper .ex-item-details-header-arrows button{border:0;background-color:transparent;padding:2px}.ex-item-details-header-header-wrapper .ex-item-details-header-arrows button.sel-prev,.ex-item-details-header-header-wrapper .ex-item-details-header-arrows button.sel-next{padding:4px}.ex-item-details-header-header-wrapper ex-sections-layout-dropdown{display:flex}.ex-item-details-header-main-wrapper:after{content:\"\";position:absolute;display:flex;border-radius:inherit;height:10px;bottom:-10px;width:100%;background-image:linear-gradient(to bottom,#fff,#ffffffd9 33%,#ffffff03 99%,#fff0)}.ex-item-details-header-header-wrapper-sidenav-expanded{padding-inline-start:240px}.ex-item-details-header-actions{flex:1}.ex-item-details-header-actions-divider{width:1px;height:30px;margin-inline-end:9px;margin-inline-start:9px;border-inline-start:1px solid;border-inline-color:#cccccc}.ex-item-details-header-sections-single-save-buttons{display:flex}.ex-item-details-header-sections-single-save-buttons ex-button{margin-inline-start:3px;margin-inline-end:3px}.ex-item-details-header-sections-single-save-buttons ::ng-deep .ex-button-wrapper{min-height:30px!important;font-size:13px!important}.ex-item-details-header-sections-single-save-buttons ::ng-deep .ex-button-wrapper:not(.ex-button-primary){color:#4664a4!important}.ex-item-details-header-sections-single-save-buttons .ex-item-details-header-sections-single-save-edit{display:flex}.ex-item-details-header-sections-single-save-buttons .ex-item-details-header-sections-single-save-edit ex-svg-icon{margin-inline-start:5px}\n"] }]
    }], function () { return [{ type: ExSectionsLayoutService }, { type: ExDialogService }, { type: ExItemsLayoutService, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: ExItemDetailsHeaderStatusService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, { itemId: [{
            type: Input
        }], layoutLoading: [{
            type: Input
        }], hasNext: [{
            type: Input
        }], hasPrev: [{
            type: Input
        }], hasTitle: [{
            type: Input
        }], actions: [{
            type: Input
        }], headerMenus: [{
            type: Input
        }], status: [{
            type: Input
        }], hasSectionsCombobox: [{
            type: Input
        }], deepLinkMode: [{
            type: Input
        }], scrollingSelector: [{
            type: Input
        }], isEditable: [{
            type: Input
        }], singleSaveDisabled: [{
            type: Input
        }], expandActionsOnAllSpace: [{
            type: Input
        }], nextClicked: [{
            type: Output
        }], prevClicked: [{
            type: Output
        }], closeClicked: [{
            type: Output
        }], actionClicked: [{
            type: Output
        }], editAllClicked: [{
            type: Output
        }], onCancelAll: [] }); })();

const ExListLayoutAnimations = [
    trigger('expanded', [
        state('false', style({
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            opacity: 0
        })),
        transition('false => true', [
            style({
                overflow: 'hidden'
            }),
            animate(600)
        ]),
        transition('true => false', [
            animate(600, style({
                height: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                opacity: 0
            }))
        ])
    ]),
    trigger('expanded-header', [
        state('false', style({
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            opacity: 0
        })),
        transition('false => true', [
            style({
                overflow: 'hidden'
            }),
            animate(200)
        ]),
        transition('true => false', [
            animate(200, style({
                height: '0px',
                paddingTop: '0px',
                paddingBottom: '0px',
                opacity: 0
            }))
        ])
    ]),
    trigger('expand', [
        state('*', style({
            height: AUTO_STYLE,
            overflow: 'hidden',
            opacity: 1
        })),
        state('void', style({
            height: '0px',
            overflow: 'hidden',
            paddingTop: '0px',
            paddingBottom: '0px',
            opacity: 0
        })),
        transition('void <=> *', [
            animate('0.5s')
        ])
    ]),
    trigger('content-height', [
        state('false', style({
            height: 'calc(100%)'
        })),
        transition('false => true', [
            style({
                overflow: 'hidden'
            }),
            animate(200)
        ]),
        transition('true => false', [
            animate(200, style({
                height: 'calc(100%)',
            }))
        ])
    ])
];

var ExListLayoutComponent_1;
const _c0$k = ["listWrapper"];
const _c1$e = ["listRef"];
const _c2$8 = ["rightSideRef"];
const _c3$5 = ["paginationRef"];
const _c4$3 = ["endOfList"];
const _c5$3 = ["subList"];
const _c6$3 = ["rowItemRef"];
function ExListLayoutComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9, 10)(2, "ex-list-header", 11);
    i0.ɵɵlistener("selectedOnCurrentPageChange", function ExListLayoutComponent_div_3_Template_ex_list_header_selectedOnCurrentPageChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectedOnCurrentPage = $event); })("comboboxItemClicked", function ExListLayoutComponent_div_3_Template_ex_list_header_comboboxItemClicked_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onComboboxItemClicked($event)); })("toggleisItemOpen", function ExListLayoutComponent_div_3_Template_ex_list_header_toggleisItemOpen_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.toggleisItemOpen()); })("toggleisItemOpenSized", function ExListLayoutComponent_div_3_Template_ex_list_header_toggleisItemOpenSized_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.toggleisItemOpenSized($event)); })("sortChange", function ExListLayoutComponent_div_3_Template_ex_list_header_sortChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14._sortChange($event)); })("actionClicked", function ExListLayoutComponent_div_3_Template_ex_list_header_actionClicked_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15._actionClicked($event)); })("searchChange", function ExListLayoutComponent_div_3_Template_ex_list_header_searchChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16._searchChange($event)); })("selectedValueChange", function ExListLayoutComponent_div_3_Template_ex_list_header_selectedValueChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17._selectedValueChange($event)); })("clearCheckedItems", function ExListLayoutComponent_div_3_Template_ex_list_header_clearCheckedItems_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onClearCheckedItems()); })("clearPageCheckedItems", function ExListLayoutComponent_div_3_Template_ex_list_header_clearPageCheckedItems_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onClearPageCheckedItems()); })("checkAllItems", function ExListLayoutComponent_div_3_Template_ex_list_header_checkAllItems_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onCheckAllItems()); })("filterChange", function ExListLayoutComponent_div_3_Template_ex_list_header_filterChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.filterChanged.emit($event)); })("datesUpdated", function ExListLayoutComponent_div_3_Template_ex_list_header_datesUpdated_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22._datesUpdated($event)); })("clearDates", function ExListLayoutComponent_div_3_Template_ex_list_header_clearDates_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23._clearDates()); })("customizationClicked", function ExListLayoutComponent_div_3_Template_ex_list_header_customizationClicked_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24._customizationClicked()); })("closeRightSideClicked", function ExListLayoutComponent_div_3_Template_ex_list_header_closeRightSideClicked_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.onCloseRightSideClicked()); })("refreshClicked", function ExListLayoutComponent_div_3_Template_ex_list_header_refreshClicked_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26._refreshClicked()); })("viewModeChange", function ExListLayoutComponent_div_3_Template_ex_list_header_viewModeChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.onViewModeChange($event)); })("openUserResponsiveMenu", function ExListLayoutComponent_div_3_Template_ex_list_header_openUserResponsiveMenu_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.openUserResponsiveMenu.emit()); });
    i0.ɵɵprojection(3, 0, ["header-slot-1", ""]);
    i0.ɵɵprojection(4, 1, ["header-slot-2", ""]);
    i0.ɵɵprojection(5, 2, ["header-slot-3", ""]);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@expanded-header", !ctx_r1._hideHeader && ctx_r1._haveHeader() || ctx_r1.isFullPage && ctx_r1.isItemOpen);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("responsivenessActive", true)("headerResponsivenessOrderConfig", ctx_r1.listProperties.headerResponsivenessOrderConfig)("selectedOnCurrentPage", ctx_r1.selectedOnCurrentPage)("hasToggle", !!ctx_r1.itemDetails)("isWideScreen", ctx_r1.isWideScreen)("responsive", ctx_r1.responsive)("hasExport", ctx_r1.listProperties.hasExport)("hasSearch", ctx_r1.listProperties.hasSearch)("popUpActions", ctx_r1.listProperties.popUpActions)("numberOfCheckedItems", ctx_r1.checkedItems.length)("pageSize", ctx_r1.items == null ? null : ctx_r1.items.length)("isItemOpen", ctx_r1.isItemOpen)("searchByFields", ctx_r1.listProperties.searchByFields)("searchBySelectedField", ctx_r1.listProperties.searchBySelectedField)("sorts", ctx_r1.listProperties.showSortsInListHeader && ctx_r1.listProperties.sorts)("filters", ctx_r1.listProperties.filters)("hasPickup", ctx_r1.listProperties.hasPickup)("hasPickupCount", ctx_r1.listProperties.hasPickupCount && ctx_r1.listProperties.isMultiSelect)("comboboxLists", ctx_r1.listProperties.comboboxLists)("actions", ctx_r1.listProperties.actions)("bulkActions", ctx_r1.listProperties.bulkActions)("hasBottomBorder", !ctx_r1.listProperties.hideHeaderOnScroll || !ctx_r1.items || (ctx_r1.items == null ? null : ctx_r1.items.length) === 0)("filterMaxDate", ctx_r1.listProperties.filterMaxDate)("filterMinDate", ctx_r1.listProperties.filterMinDate)("showDateFilter", ctx_r1.listProperties.showDateFilter)("searchText", ctx_r1.listProperties.searchText)("clearAllSubject", ctx_r1.clearAllSubject)("floatingExport", ctx_r1.newExport)("hasCustomization", ctx_r1.hasCustomization && ctx_r1.listProperties.enableCustomization)("customizationComponent", ctx_r1.customizationComponent)("isCustomized", ctx_r1.isCustomized)("fullPage", ctx_r1.isItemOpen && ctx_r1.isFullPage || ctx_r1.isExpanded)("isLoading", ctx_r1.listProperties.isLoading)("needToRefresh", ctx_r1.listProperties.needToRefresh)("hasRefreshButton", ctx_r1.listProperties.hasRefreshButton)("deepLinkMode", ctx_r1.listProperties.deepLinkMode)("deepLinkModeTemplate", ctx_r1.deepLinkModeTemplate)("viewMode", ctx_r1.getViewMode());
} }
function ExListLayoutComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 14);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r29.noResultsTemplate);
} }
function ExListLayoutComponent_ng_container_4_ng_template_2_p_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r33.noResultsPlaceholder), " ");
} }
function ExListLayoutComponent_ng_container_4_ng_template_2_p_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 3, "list-layout.no_results_your_search"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r35.getSearchText());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "list-layout.no_results_did_not_match"), " ");
} }
function ExListLayoutComponent_ng_container_4_ng_template_2_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_container_4_ng_template_2_p_2_ng_container_1_Template, 3, 3, "ng-container", 3);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_container_4_ng_template_2_p_2_ng_template_2_Template, 6, 7, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r34 = i0.ɵɵreference(3);
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.noResultsPlaceholder)("ngIfElse", _r34);
} }
function ExListLayoutComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "img", 16);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_container_4_ng_template_2_p_2_Template, 4, 2, "p", 17);
    i0.ɵɵelementStart(3, "p", 18);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("max-height", 200, "px")("width", 200, "px");
    i0.ɵɵproperty("src", (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.searchText) || (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.persistentSearchIsAdvanced) ? "/ng/assets/svg-icons/no-search-results.svg" : "/ng/assets/svg-icons/no-items-in-list.svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.searchText) || (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.persistentSearchIsAdvanced));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx_r31.noResultsHintPlaceholder ? ctx_r31.noResultsHintPlaceholder : !(ctx_r31.listProperties == null ? null : ctx_r31.listProperties.persistentSearchType) && (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.searchText) || (ctx_r31.listProperties == null ? null : ctx_r31.listProperties.persistentSearchIsAdvanced) ? "list-layout.no_results_change_filters_hint_placeholder" : "list-layout.no_results_no_items"), " ");
} }
function ExListLayoutComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_container_4_ng_container_1_Template, 1, 1, "ng-container", 12);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_container_4_ng_template_2_Template, 6, 9, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.noResultsTemplate != null)("ngIfElse", _r30);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r42.onExpandButtonToggle(!ctx_r42.isFullPage)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-icon", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", ctx_r41.isFullPage ? i0.ɵɵpipeBind1(1, 1, "ng.general.return-to-split-view") : i0.ɵɵpipeBind1(2, 3, "ng.general.open-full-page"));
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_button_1_Template, 4, 5, "button", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ex-list-layout-expand-collapse-wrapper-rotate", ctx_r39.isRtl && !ctx_r39.isFullPage || !ctx_r39.isRtl && ctx_r39.isFullPage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.isSplitScreen || ctx_r39.isSplitScreen == undefined);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r46 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r46);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-item-details-header", 41);
    i0.ɵɵlistener("prevClicked", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template_ex_item_details_header_prevClicked_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r52.selectPrevItem()); })("nextClicked", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template_ex_item_details_header_nextClicked_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r54 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r54.selectNextItem()); })("closeClicked", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template_ex_item_details_header_closeClicked_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r55 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r55.onRightSideDetailesCloseClicked()); })("actionClicked", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template_ex_item_details_header_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r53); const ctx_r56 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r56.onRecordActionClicked($event, ctx_r56.items == null ? null : ctx_r56.items[ctx_r56.selectedItem])); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("itemId", ctx_r47.getItemId())("actions", !ctx_r47.items || (ctx_r47.items[ctx_r47.selectedItem] == null ? null : ctx_r47.items[ctx_r47.selectedItem].disabled) ? null : ctx_r47.getRightSideActions())("headerMenus", !ctx_r47.items || (ctx_r47.items[ctx_r47.selectedItem] == null ? null : ctx_r47.items[ctx_r47.selectedItem].disabled) ? null : ctx_r47.getRightSideHeaderMenus())("status", !ctx_r47.items || (ctx_r47.items[ctx_r47.selectedItem] == null ? null : ctx_r47.items[ctx_r47.selectedItem].disabled) ? null : ctx_r47.getRightSideStatus())("hasPrev", ctx_r47.openedSublist !== -1 || ctx_r47.selectedItem > 0 || ctx_r47.hasPrevPage())("hasNext", ctx_r47.openedSublist !== -1 || ctx_r47.selectedItem < (ctx_r47.items == null ? null : ctx_r47.items.length) - 1 || ctx_r47.hasNextPage())("hasTitle", ctx_r47.listProperties.hasTitle)("hasSectionsCombobox", ctx_r47.listProperties.hasSectionsCombobox)("deepLinkMode", ctx_r47.listProperties.deepLinkMode)("expandActionsOnAllSpace", ctx_r47.expandActionsOnAllSpaceFlag && ctx_r47.listProperties.expandActionsOnAllSpace);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c7$3 = function (a0) { return { data: a0 }; };
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelement(2, "ex-component-loader", 43);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const _r46 = i0.ɵɵreference(6);
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r46);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", i0.ɵɵpureFunction1(3, _c7$3, ctx_r62.dynamicComponents ? ctx_r62.items[ctx_r62.openedSublist].sublists[ctx_r62.sublistInd].list[ctx_r62._selectedItemInSublist].data.data : ctx_r62.items[ctx_r62.openedSublist].sublists[ctx_r62.sublistInd].list[ctx_r62._selectedItemInSublist].data))("componentFactoryItem", ctx_r62.items[ctx_r62.openedSublist].sublists[ctx_r62.sublistInd].listItemDetails);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_ng_container_1_Template, 3, 5, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r61 = ctx.index;
    const ctx_r59 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r59._selectedItemInSublist === i_r61);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r57.items[ctx_r57.openedSublist].sublists[ctx_r57.sublistInd].list);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c8$3 = function (a0, a1) { return { data: a0, disabled: a1 }; };
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelement(2, "ex-component-loader", 44);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(5);
    const _r46 = i0.ɵɵreference(6);
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r46);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", i0.ɵɵpureFunction2(4, _c8$3, ctx_r68.dynamicComponents ? ctx_r68.items[ctx_r68.selectedItem] == null ? null : ctx_r68.items[ctx_r68.selectedItem].listItem.data.data : ctx_r68.items[ctx_r68.selectedItem] == null ? null : ctx_r68.items[ctx_r68.selectedItem].listItem.data, ctx_r68.items[ctx_r68.selectedItem].disabled))("events", ctx_r68.itemDetails.events)("componentFactoryItem", ctx_r68.itemDetails);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_ng_container_1_Template, 3, 7, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r67 = ctx.index;
    const ctx_r65 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.selectedItem === i_r67);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r64.items);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.items[ctx_r58.selectedItem]);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 37);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_ng_container_2_Template, 2, 1, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r48._selectedItemInSublist !== -1 && ctx_r48.items[ctx_r48.openedSublist].sublists[ctx_r48.sublistInd].listItemDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r48._selectedItemInSublist === -1);
} }
const _c9$3 = function () { return { "isLoading": "true" }; };
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 45);
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("data", i0.ɵɵpureFunction0(2, _c9$3))("componentFactoryItem", ctx_r50.itemDetails);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("resized", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r70 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r70.onRightSideResized($event)); });
    i0.ɵɵelementStart(1, "button", 34);
    i0.ɵɵlistener("focus", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template_button_focus_1_listener() { i0.ɵɵrestoreView(_r71); const ctx_r72 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r72.moveFocusToPreviousRow()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 35, 36);
    i0.ɵɵtemplate(4, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_4_Template, 2, 1, "ng-container", 37);
    i0.ɵɵtemplate(5, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_5_Template, 1, 10, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_container_7_Template, 3, 2, "ng-container", 3);
    i0.ɵɵtemplate(8, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_ng_template_8_Template, 1, 3, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(10, "button", 40);
    i0.ɵɵlistener("focus", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template_button_focus_10_listener() { i0.ɵɵrestoreView(_r71); const ctx_r73 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r73.moveFocusToNextRow()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r49 = i0.ɵɵreference(9);
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ex-in-place-layout-right-wrapper-full-page", ctx_r40.isFullPage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.listProperties.isLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r40.listProperties.isLoading)("ngIfElse", _r49);
} }
function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-side-by-side", 23);
    i0.ɵɵlistener("rightSideHeightChange", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_rightSideHeightChange_0_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r74.rightSideHeightChange($event)); })("leftSideResized", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_leftSideResized_0_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r76 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r76.onLeftSideResized($event)); })("gutterDragEnd", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template_ex_side_by_side_gutterDragEnd_0_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r77 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r77.gutterDragEnd.emit($event)); });
    i0.ɵɵelementStart(1, "div", 24, 25);
    i0.ɵɵlistener("scroll", function ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template_div_scroll_1_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r78 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r78.onScrollLeftSide($event)); });
    i0.ɵɵtemplate(3, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_ng_container_3_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_4_Template, 2, 3, "div", 27);
    i0.ɵɵtemplate(5, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_div_5_Template, 11, 5, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(9);
    i0.ɵɵproperty("leftVisible", !ctx_r36.isFullPage || ctx_r36.isFullPage && !ctx_r36.isItemOpen)("rightVisible", ctx_r36.isItemOpen)("leftSize", ctx_r36.listProperties.leftSide)("rightSize", ctx_r36.listProperties.rightSide)("leftMinSize", 35)("rightMinSize", 40)("isRtl", ctx_r36.isRtl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.isItemOpen && (ctx_r36.canSplit || !ctx_r36.responsive) && !ctx_r36.listProperties.deepLinkMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.isItemOpen);
} }
const _c10$2 = function (a0, a1) { return { "ex-list-layout-content-top-border": a0, "ex-list-layout-content-wrapper-no-header": a1 }; };
function ExListLayoutComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_5_ex_side_by_side_1_Template, 6, 10, "ex-side-by-side", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c10$2, ctx_r4.listProperties.hideHeaderOnScroll, ctx_r4.listProperties.hideHeader));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.itemDetails)("ngIfElse", _r5);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ex_drag_accessible_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-drag-accessible-icon", 62);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_i_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 63);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext();
    const i_r85 = ctx_r97.index;
    const item_r84 = ctx_r97.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-list-layout-warning-icon sel-warning-", i_r85, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r84.mode == null ? null : item_r84.mode.tooltip));
} }
const _c11$1 = function (a0) { return { "ex-list-layout-disabled-row-item": a0 }; };
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 64);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext();
    const item_r84 = ctx_r98.$implicit;
    const i_r85 = ctx_r98.index;
    const ctx_r89 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c11$1, item_r84.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r89.listProperties.pagination.selectedPage - 1) * ctx_r89.listProperties.pagination.pageSize + i_r85 + 1, " ");
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 63);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(2);
    const i_r85 = ctx_r102.index;
    const item_r84 = ctx_r102.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-list-layout-warning-icon sel-warning-", i_r85, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r84.mode == null ? null : item_r84.mode.tooltip));
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_i_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 63);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " check_circle ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(2);
    const i_r85 = ctx_r103.index;
    const item_r84 = ctx_r103.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-list-layout-valid-icon sel-valid-", i_r85, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r84.mode == null ? null : item_r84.mode.tooltip));
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_ex_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 70);
} if (rf & 2) {
    const i_r85 = i0.ɵɵnextContext(2).index;
    const ctx_r101 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("material-icons ex-list-layout-suppress-icon sel-suppress-", i_r85, "");
    i0.ɵɵproperty("iconName", ctx_r101._suppressedIconName)("iconType", "svg");
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r106 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵlistener("click", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r106); const ctx_r105 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r105.onCheckBoxClicked()); });
    i0.ɵɵelementStart(1, "ex-checkbox", 66);
    i0.ɵɵlistener("checkboxChange", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_Template_ex_checkbox_checkboxChange_1_listener($event) { i0.ɵɵrestoreView(_r106); const i_r85 = i0.ɵɵnextContext().index; const ctx_r107 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r107.onCheckboxChanged($event, i_r85)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 67);
    i0.ɵɵtemplate(4, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_i_4_Template, 3, 6, "i", 68);
    i0.ɵɵtemplate(5, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_i_5_Template, 3, 6, "i", 68);
    i0.ɵɵtemplate(6, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_ex_icon_6_Template, 1, 5, "ex-icon", 69);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext();
    const i_r85 = ctx_r109.index;
    const item_r84 = ctx_r109.$implicit;
    const ctx_r90 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r90.isSelected(i_r85))("ariaLabel", i0.ɵɵpipeBind1(2, 6, "ng.ex_items_layout_list_row.check_or_uncheck"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", item_r84.mode == null ? null : item_r84.mode.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "WARNING");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "VALID");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "SUPPRESSED");
} }
const _c12$1 = function (a0, a1) { return { rowClicked: a0, rowDeleted: a1 }; };
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ex_component_loader_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 71);
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext();
    const item_r84 = ctx_r110.$implicit;
    const i_r85 = ctx_r110.index;
    const ctx_r91 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("data", ctx_r91.getItem(item_r84.listItem.data, i_r85))("events", i0.ɵɵpureFunction2(3, _c12$1, ctx_r91.onRowClicked.bind(ctx_r91, i_r85), ctx_r91.onRowRemove.bind(ctx_r91, i_r85)))("componentFactoryItem", item_r84.listItem);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-record", 72);
    i0.ɵɵlistener("actionClicked", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ng_template_11_Template_ex_record_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r113); const item_r84 = i0.ɵɵnextContext().$implicit; const ctx_r111 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r111.onRecordActionClicked($event, item_r84)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext();
    const i_r85 = ctx_r114.index;
    const item_r84 = ctx_r114.$implicit;
    const ctx_r93 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate3("htmlId", "", ctx_r93.htmlId, "", ctx_r93.htmlId ? "_" : "", "", ctx_r93.htmlId ? i_r85 : "", "");
    i0.ɵɵproperty("recordCustomizationData", ctx_r93.recordCustomizationData)("highlightedText", ctx_r93.listProperties.highlightedText)("data", item_r84.listItem)("width", ctx_r93.leftSideWidth)("isSelected", ctx_r93.selectedItem === i_r85)("emptyRowHeight", ctx_r93.listProperties.emptyRowHeight)("isExPickup", ctx_r93.listProperties.isExPickup)("isItemOpen", ctx_r93.isItemOpen);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ex_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 76);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 15);
} }
const _c13$1 = function (a0) { return { "ex-list-layout-not-selected-bubbles": a0 }; };
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ng_template_2_ex_clickable_chip_0_Template(rf, ctx) { if (rf & 1) {
    const _r124 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-clickable-chip", 78);
    i0.ɵɵlistener("click", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ng_template_2_ex_clickable_chip_0_Template_ex_clickable_chip_click_0_listener() { i0.ɵɵrestoreView(_r124); const j_r117 = i0.ɵɵnextContext(2).index; const i_r85 = i0.ɵɵnextContext(2).index; const ctx_r122 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r122.changeSublistInd(i_r85, j_r117)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r126 = i0.ɵɵnextContext(2);
    const sublist_r116 = ctx_r126.$implicit;
    const j_r117 = ctx_r126.index;
    const i_r85 = i0.ɵɵnextContext(2).index;
    const ctx_r121 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("text", "+", sublist_r116.length, "");
    i0.ɵɵproperty("mode", ctx_r121.openedSublist === i_r85 && ctx_r121.sublistInd === j_r117 ? "filled" : "transparent")("color", sublist_r116.color)("ngClass", i0.ɵɵpureFunction1(9, _c13$1, i_r85 !== ctx_r121.selectedItem && i_r85 !== ctx_r121.openedSublist))("tooltip", i0.ɵɵpipeBind1(1, 5, sublist_r116.title) + " " + i0.ɵɵpipeBind1(2, 7, sublist_r116.description));
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ng_template_2_ex_clickable_chip_0_Template, 3, 11, "ex-clickable-chip", 77);
} if (rf & 2) {
    const sublist_r116 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", sublist_r116.length > 0);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ex_spinner_1_Template, 1, 1, "ex-spinner", 74);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 75, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sublist_r116 = ctx.$implicit;
    const _r119 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sublist_r116.loading)("ngIfElse", _r119);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_ng_container_1_Template, 4, 2, "ng-container", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r84.sublists);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 79);
    i0.ɵɵlistener("keyup.Tab", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_button_14_Template_button_keyup_Tab_0_listener($event) { i0.ɵɵrestoreView(_r131); const ctx_r130 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r130.moveFocusToRightSide($event)); });
    i0.ɵɵelementEnd();
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r134 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-expandable-sublist", 80, 81);
    i0.ɵɵlistener("selectedItemChange", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_15_Template_ex_expandable_sublist_selectedItemChange_1_listener($event) { i0.ɵɵrestoreView(_r134); const ctx_r133 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r133.selectedItemInSublist = $event); })("closeClicked", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_15_Template_ex_expandable_sublist_closeClicked_1_listener() { i0.ɵɵrestoreView(_r134); const ctx_r135 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r135.closeClicked()); })("loadMoreSublist", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_15_Template_ex_expandable_sublist_loadMoreSublist_1_listener() { i0.ɵɵrestoreView(_r134); const ctx_r136 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r136._loadMoreSublist()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r84 = i0.ɵɵnextContext().$implicit;
    const ctx_r96 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@expand", undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("list", item_r84.sublists[ctx_r96.sublistInd].list)("htmlId", ctx_r96.htmlId + "_" + ctx_r96.openedSublist + "_sub")("dynamicComponents", ctx_r96.dynamicComponents)("color", item_r84.sublists[ctx_r96.sublistInd].color)("selectedItem", ctx_r96.selectedItemInSublist)("hasMore", item_r84.sublists[ctx_r96.sublistInd].hasMore)("title", item_r84.sublists[ctx_r96.sublistInd].title)("description", item_r84.sublists[ctx_r96.sublistInd].description);
} }
const _c14$1 = function (a0, a1, a2, a3, a4, a5, a6) { return { "ex-list-layout-row-item-opened": a0, "ex-list-layout-row-item-disabled": a1, "ex-list-layout-selected": a2, "ex-list-layout-hover-left-indication": a3, "ex-list-layout-large-density": a4, "ex-list-layout-row-item-dark-theme": a5, "ex-list-layout-selected-dark-theme": a6 }; };
const _c15$1 = function (a0, a1) { return { "ex-list-layout-disabled-content": a0, "ex-list-layout-disabled-row-item": a1 }; };
function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r139 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 50)(2, "div", 51, 52);
    i0.ɵɵlistener("focusin", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template_div_focusin_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r139); const i_r85 = restoredCtx.index; const ctx_r138 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r138.rowItemFocused(i_r85)); })("keydown.enter", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template_div_keydown_enter_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r139); const i_r85 = restoredCtx.index; const ctx_r140 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r140.onRowClicked(i_r85)); })("keydown.space", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template_div_keydown_space_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r139); const i_r85 = restoredCtx.index; const ctx_r141 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r141.onRowClicked(i_r85)); })("click", function ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template_div_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r139); const i_r85 = restoredCtx.index; const ctx_r142 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r142.onRowClicked(i_r85)); });
    i0.ɵɵelementStart(4, "div", 53);
    i0.ɵɵtemplate(5, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ex_drag_accessible_icon_5_Template, 1, 0, "ex-drag-accessible-icon", 54);
    i0.ɵɵtemplate(6, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_i_6_Template, 3, 6, "i", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_span_7_Template, 3, 4, "span", 37);
    i0.ɵɵtemplate(8, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_8_Template, 7, 8, "div", 56);
    i0.ɵɵelementStart(9, "div", 57);
    i0.ɵɵtemplate(10, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ex_component_loader_10_Template, 1, 6, "ex-component-loader", 58);
    i0.ɵɵtemplate(11, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_ng_template_11_Template, 1, 11, "ng-template", null, 59, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(13, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_13_Template, 2, 1, "div", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_button_14_Template, 1, 0, "button", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_div_15_Template, 3, 9, "div", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r84 = ctx.$implicit;
    const i_r85 = ctx.index;
    const _r92 = i0.ɵɵreference(12);
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("sel-row-", i_r85, "-item ex-list-layout-li");
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r82.listProperties.hasDrag)("@expanded", ctx_r82.animateRemoveIndex != i_r85);
    i0.ɵɵattribute("aria-hidden", ctx_r82.openedSublist !== i_r85 && ctx_r82.openedSublist !== -1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRippleColor", ctx_r82.itemDetails && i_r85 !== ctx_r82.selectedItem ? "#eff4f74f" : "transparent")("ngClass", i0.ɵɵpureFunction7(20, _c14$1, ctx_r82.openedSublist === i_r85, ctx_r82.openedSublist !== i_r85 && ctx_r82.openedSublist !== -1, ctx_r82.listProperties.canSelectRow && i_r85 === ctx_r82.selectedItem, ctx_r82.listProperties.canSelectRow, ctx_r82.listProperties.density === "large", ctx_r82.listProperties.isDarkTheme, ctx_r82.listProperties.canSelectRow && i_r85 === ctx_r82.selectedItem && ctx_r82.listProperties.isDarkTheme));
    i0.ɵɵattribute("tabindex", ctx_r82.openedSublist !== i_r85 && ctx_r82.openedSublist !== -1 ? -1 : 0)("aria-pressed", i_r85 === ctx_r82.selectedItem);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r82.listProperties.hasDrag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r84.mode == null ? null : item_r84.mode.value) === "WARNING" && !ctx_r82.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.listProperties.hasPickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(28, _c15$1, item_r84.disabled, item_r84.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.dynamicComponents)("ngIfElse", _r92);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !item_r84.disabled && (item_r84.sublists == null ? null : item_r84.sublists.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.isItemOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.openedSublist === i_r85);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_ex_pagination_4_Template(rf, ctx) { if (rf & 1) {
    const _r145 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 82, 83);
    i0.ɵɵlistener("selectedPageChange", function ExListLayoutComponent_ng_template_8_ng_container_0_ex_pagination_4_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r145); const ctx_r144 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r144._selectedPageChange($event)); })("pageSizeChange", function ExListLayoutComponent_ng_template_8_ng_container_0_ex_pagination_4_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r145); const ctx_r146 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r146._pageSizeChange($event)); })("endOfPagination", function ExListLayoutComponent_ng_template_8_ng_container_0_ex_pagination_4_Template_ex_pagination_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r145); const ctx_r147 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r147.focusOnEndOfPage()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("numberOfResults", ctx_r83.listProperties.pagination.totalItemsCount)("pageSize", ctx_r83.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r83.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r83.listProperties.pagination.selectedPage);
} }
function ExListLayoutComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-drag-list", 47);
    i0.ɵɵlistener("cdkDropListDropped", function ExListLayoutComponent_ng_template_8_ng_container_0_Template_ex_drag_list_cdkDropListDropped_1_listener($event) { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r148.drop($event)); });
    i0.ɵɵelementStart(2, "ul", 48);
    i0.ɵɵlistener("resized", function ExListLayoutComponent_ng_template_8_ng_container_0_Template_ul_resized_2_listener($event) { i0.ɵɵrestoreView(_r149); const ctx_r150 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r150.onLeftSideResized($event)); });
    i0.ɵɵtemplate(3, ExListLayoutComponent_ng_template_8_ng_container_0_ng_container_3_Template, 16, 31, "ng-container", 42);
    i0.ɵɵtemplate(4, ExListLayoutComponent_ng_template_8_ng_container_0_ex_pagination_4_Template, 2, 4, "ex-pagination", 49);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r79.items);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r79.listProperties.pagination.totalItemsCount > 0);
} }
function ExListLayoutComponent_ng_template_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "ng.ex-list-layout.loading_results"), "");
} }
function ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 90);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r156 = i0.ɵɵnextContext().index;
    const ctx_r157 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r157.listProperties.pagination.selectedPage - 1) * ctx_r157.listProperties.pagination.pageSize + i_r156 + 1, " ");
} }
const _c16$1 = function (a0, a1, a2) { return { "ex-list-layout-row-item-opened": a0, "ex-list-layout-row-item-disabled": a1, "ex-list-layout-large-density": a2 }; };
function ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 86);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_div_2_span_2_Template, 2, 1, "span", 87);
    i0.ɵɵelementStart(3, "div", 88);
    i0.ɵɵelement(4, "ex-record-placeholder", 89);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r156 = ctx.index;
    const ctx_r154 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("@expanded", ctx_r154.animateRemoveIndex != i_r156);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c16$1, ctx_r154.openedSublist === i_r156, ctx_r154.openedSublist !== i_r156 && ctx_r154.openedSublist !== -1, ctx_r154.listProperties.density === "large"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r154.listProperties.hasIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("proto", ctx_r154.listProperties.proto)("hasPickup", ctx_r154.listProperties.hasPickup)("emptyRowHeight", ctx_r154.listProperties.emptyRowHeight);
} }
function ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r160 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵlistener("resized", function ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_Template_div_resized_1_listener($event) { i0.ɵɵrestoreView(_r160); const ctx_r159 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r159.onLeftSideResized($event)); });
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_div_2_Template, 5, 10, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", " ".repeat(ctx_r151.placeHolderRows).split(""));
} }
function ExListLayoutComponent_ng_template_8_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 91);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 50);
} }
function ExListLayoutComponent_ng_template_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_8_ng_container_2_ng_container_1_Template, 3, 1, "ng-container", 3);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_8_ng_container_2_ng_template_2_Template, 1, 1, "ng-template", null, 85, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r152 = i0.ɵɵreference(3);
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r81.listProperties.showSpinner)("ngIfElse", _r152);
} }
function ExListLayoutComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExListLayoutComponent_ng_template_8_ng_container_0_Template, 5, 2, "ng-container", 37);
    i0.ɵɵtemplate(1, ExListLayoutComponent_ng_template_8_div_1_Template, 3, 3, "div", 46);
    i0.ɵɵtemplate(2, ExListLayoutComponent_ng_template_8_ng_container_2_Template, 4, 2, "ng-container", 37);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.listProperties.isLoading && (ctx_r6.canSplitChecked || !ctx_r6.responsive));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.listProperties.isLoading || !ctx_r6.canSplitChecked && ctx_r6.responsive);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.listProperties.isLoading || !ctx_r6.canSplitChecked && ctx_r6.responsive);
} }
const _c17$1 = [[["", "header", ""]], [["", "header-slot-2", ""]], [["", "header-slot-3", ""]]];
const _c18$1 = function (a0) { return { "ex-list-layout-animate sel-loading": a0 }; };
const _c19$1 = ["[header]", "[header-slot-2]", "[header-slot-3]"];
let ExListLayoutComponent = class ExListLayoutComponent extends GeneralListLayoutComponent {
    static { ExListLayoutComponent_1 = this; }
    get selectedItem() {
        return this._selectedItem;
    }
    ;
    set selectedItem(value) {
        if (this._selectedItem === value)
            return;
        this._selectedItem = value;
        this.selectedItemChange.emit(value);
        if (this.sideBySide) {
            this.sideBySide.scrollRightSideToTop();
        }
    }
    ;
    get checkedItems() {
        return this._checkedItems;
    }
    ;
    set checkedItems(value) {
        this._checkedItems = value;
        this.checkedItemsChange.emit(value);
    }
    ;
    set isSplitScreen(value) {
        this._isSplitScreen = value;
        this.viewMode = this._isSplitScreen ? ViewModes.SPLIT : ViewModes.FULL;
    }
    get isSplitScreen() {
        return this._isSplitScreen;
    }
    constructor(location, exSectionsLayoutListLayoutService, router, sidenavPageService, itemsLayoutService) {
        super();
        this.location = location;
        this.exSectionsLayoutListLayoutService = exSectionsLayoutListLayoutService;
        this.router = router;
        this.sidenavPageService = sidenavPageService;
        this.itemsLayoutService = itemsLayoutService;
        this.hasCustomization = false;
        /**
         * Whether the layout is customized
         */
        this.isCustomized = false;
        /**
         * whether the list layout is responsive to the window width (depends on existing in ex-sidenav-page)
         */
        this.responsive = true;
        this._isSplitScreen = true;
        this.customizationClicked = new EventEmitter();
        /**
         * Fires when the user stops dragging the gutter (mouseup)
         */
        this.gutterDragEnd = new EventEmitter();
        /**
         * Fires when user changes the split view
         */
        this.splitChange = new EventEmitter();
        /**
         * Fires when user clicks on help link to disable responsiveness
         */
        this.openUserResponsiveMenu = new EventEmitter();
        this.expandActionsOnAllSpaceFlag = false;
        this.isSecondarySearchFlagActive = false;
        this.persistentSearchText = '';
        this.selectedOnCurrentPage = 0;
        this._selectedItem = -1;
        this._suppressedIconName = "visibility-off";
        this._checkedItems = [];
        this.isFullPage = false;
        this.leftSideWidth = 0;
        /**
         * ?? which item in the items list has its sublist opened ??
         */
        this.openedSublist = -1;
        /**
         * which sublist in a specific item is opened
         */
        this.sublistInd = -1;
        /**
         * which item in the opened sublist is selected
         */
        this._selectedItemInSublist = -1;
        this.timeout = null;
        this._hideHeader = false;
        this._ignoreScroll = false;
        this.pageHeaderDisplayStyle = 'flex';
        this.canSplit = false;
        this.canSplitChecked = false;
        this.closeFullPageAfterClose = false;
        this.subs = [];
        this.onItemsChanged = debounce(() => {
            if (this.selectedItem > -1) {
                const element = this.rowItemRef?.toArray()[this.selectedItem]?.nativeElement;
                element && $(element).parents(this.itemDetails ? '.ex-list-layout-left' : '.ex-list-layout-content-wrapper').animate({ scrollTop: Math.max(element.offsetTop - 100, 0) }, 500, 'easeOutExpo');
            }
        }, 1000);
    }
    getCheckedItems() {
        return this.checkedItems;
    }
    clearCheckedItems() {
        this.checkedItems = [];
    }
    ngOnInit() {
        this.placeHolderRows = this.listProperties.placeHolderRowsNumber && this.listProperties.placeHolderRowsNumber > 0 ?
            this.listProperties.placeHolderRowsNumber :
            this.listProperties.pagination.pageSize;
        this.animateRemoveIndex = -1;
        if (this.listProperties.layoutMode === 'split') {
            this.openSidebySide();
        }
        if (this.listProperties.isFullPage)
            this.isFullPage = true;
        if (this.sidenavPageService == null)
            this.canSplitChecked = true;
        this.subs.push(this.sidenavPageService?.contentWide.subscribe(isWide => {
            this.isWideScreen = isWide;
            if (this.responsive) {
                this.canSplit = isWide;
                if (this.listProperties.deepLinkMode || !this.isSplitScreen) {
                    return;
                }
                if (isWide == true && this.isSplitScreen == true) {
                    // if (this.isFullPage && this.isItemOpen) {
                    //   this.location.back();
                    // }
                    if (!this.isExpanded)
                        this.onFullPageModeChange(this.isExpanded);
                }
                if (isWide == false) {
                    if (!this.isFullPage) {
                        this.onFullPageModeChange(true);
                    }
                }
            }
        }));
        this.subs.push(this.sidenavPageService?.contentWidthChecked.subscribe(wasChecked => {
            this.canSplitChecked = wasChecked;
        }));
        this.subs.push(this.exSectionsLayoutListLayoutService.openRightSide$.subscribe(() => this.openSidebySide()));
    }
    ngOnDestroy() {
        this.subs.forEach(sub => sub?.unsubscribe());
    }
    onRowClicked(index) {
        if (window.getSelection().toString().length > 0 || document.activeElement?.tagName === 'INPUT') {
            return;
        }
        event.stopPropagation();
        if (this.listProperties.hasDiselect && index === this.selectedItem) {
            this.selectedItem = -1;
            this.isItemOpen = false;
            this.splitViewOpen.emit(this.isItemOpen);
            this._selectedItemInSublist = -1;
            this.rowUnClicked.emit(index);
            this.clearTimeout();
        }
        else {
            this.selectedItem = index;
            if (!this.isItemOpen && this.itemDetails) {
                // fire only on side by side opens
                this.itemsLayoutService.fireLastBreakpoint(true);
            }
            this.isItemOpen = true;
            this.splitViewOpen.emit(this.isItemOpen);
            this._selectedItemInSublist = -1;
            this.rowClicked.emit(index);
            this.clearTimeout();
        }
        const elements = document.getElementsByClassName("alma-page-column-main-header");
        if (elements && elements.length === 1) {
            const element = elements.item(0);
            if (element.style.display !== 'none') {
                this.pageHeaderDisplayStyle = element.style.display;
            }
            if (this.isItemOpen && this.isFullPage) {
                element.style.setProperty('display', 'none', 'important');
            }
            else {
                element.style.setProperty('display', this.pageHeaderDisplayStyle);
            }
        }
    }
    rowItemFocused(index) {
        this.selectedItem = index;
    }
    moveFocusToRightSide(e) {
        this.rightSideRef.nativeElement.focus();
    }
    moveFocusToSublist() {
        setTimeout(() => {
            this.subListRef.focus();
        }, 500);
    }
    moveFocusToNextRow() {
        if (this.rowItemRef.toArray()[this.selectedItem + 1]) {
            this.rowItemRef.toArray()[this.selectedItem + 1].nativeElement.focus();
        }
        else {
            this.paginationRef.focus();
        }
    }
    moveFocusToPreviousRow() {
        this.rowItemRef.toArray()[this.selectedItem].nativeElement.focus();
    }
    moveFocusToSpecificRow(row) {
        this.rowItemRef.toArray()[row].nativeElement.focus();
    }
    set selectedItemInSublist(index) {
        this._selectedItemInSublist = index;
        if (index !== -1) {
            this.selectedItem = -1;
            this.isItemOpen = true;
            this.splitViewOpen.emit(this.isItemOpen);
        }
    }
    get selectedItemInSublist() {
        return this._selectedItemInSublist;
    }
    onRowRemove(index) {
        this.animateRemoveIndex = index;
    }
    getItem(item, ind) {
        return { ...item, width: this.leftSideWidth, isSelected: this.selectedItem === ind };
    }
    changeSublistInd(listInd, sublistInd) {
        event.stopPropagation();
        event.preventDefault();
        this.openedSublist = listInd;
        this.sublistInd = sublistInd;
        this.selectedItemInSublist = 0;
        this.isItemOpen = true;
        this.sublistClicked.emit({ listInd, sublistInd });
        this.moveFocusToSublist();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('checkedItems')) {
            this.selectedOnCurrentPage = 0;
        }
        this.animateRemoveIndex = -1;
        if (changes.hasOwnProperty('items')) {
            const items = changes.items;
            const { previousValue, currentValue } = items;
            this.selectedOnCurrentPage = this.countSelectedOnCurrentPage();
            if (currentValue && previousValue !== currentValue) {
                this.openedSublist = -1;
                this.sublistInd = -1;
                this._selectedItemInSublist = -1;
            }
            if (this.items && this.selectedItem >= this.items.length && (!items.firstChange || this.items.length > 0)) {
                this.selectedItem = this.items.length - 1;
            }
            if (currentValue && currentValue.length && previousValue?.length == 0 && this.isItemOpen) {
                // NGS-6448 The list loads without a default item
                this.openSidebySide();
            }
        }
        if (changes.hasOwnProperty('itemDetails')) {
            const details = changes.itemDetails;
            const { previousValue, currentValue } = details;
            if ((currentValue && previousValue !== currentValue) && (this.listProperties.layoutMode === 'split')) {
                this.openSidebySide();
            }
        }
        if (changes.hasOwnProperty('listProperties')) {
            if (changes.listProperties.currentValue !== changes.listProperties.previousValue) {
                if (this.listProperties.layoutMode === 'split') {
                    this.openSidebySide();
                }
                else {
                    this.closeSidebySide();
                }
            }
        }
    }
    countSelectedOnCurrentPage() {
        var selectedOnCurrentPage = 0;
        this.items?.forEach((item, ind) => {
            if (this.isSelected(ind)) {
                selectedOnCurrentPage++;
            }
        });
        return selectedOnCurrentPage;
    }
    selectNextItem() {
        if (this.openedSublist !== -1) {
            this.selectedItemInSublist = (this.selectedItemInSublist + 1) % this.items[this.openedSublist].sublists[this.sublistInd].length;
        }
        else {
            if (this.selectedItem < this.items.length - 1) {
                this.selectedItem = this.selectedItem + 1;
            }
            else {
                if (this.hasNextPage()) {
                    this._selectedPageChange(this.listProperties.pagination.selectedPage + 1);
                    this.selectedItem = 0;
                }
            }
            this.moveFocusToSpecificRow(this.selectedItem);
            this.clearTimeout();
            this.setTimeout();
        }
    }
    selectPrevItem() {
        if (this.openedSublist !== -1) {
            if (this.selectedItemInSublist === 0) {
                this.selectedItemInSublist = this.items[this.openedSublist].sublists[this.sublistInd].length - 1;
            }
            else {
                this.selectedItemInSublist = this.selectedItemInSublist - 1;
            }
        }
        else {
            if (this.selectedItem > 0) {
                this.selectedItem = this.selectedItem - 1;
            }
            else {
                if (this.hasPrevPage()) {
                    this._selectedPageChange(this.listProperties.pagination.selectedPage - 1);
                    this.selectedItem = this.listProperties.pagination.pageSize - 1;
                }
            }
            this.moveFocusToSpecificRow(this.selectedItem);
            this.clearTimeout();
            this.setTimeout();
        }
    }
    clearTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
    setTimeout() {
        this.timeout = setTimeout(() => {
            this.rowClicked.emit(this.selectedItem);
        }, 500);
    }
    onPopState(event) {
        if ((this.isFullPage && this.isItemOpen) && event.currentTarget !== null && !event.singleSpa) {
            this.onCloseRightSideClicked();
            event.stopPropagation();
        }
    }
    onRightSideDetailesCloseClicked() {
        if (this.isFullPage && this.isItemOpen) {
            this.location.back();
        }
        this.onCloseRightSideClicked();
    }
    onCloseRightSideClicked() {
        if (this.closeFullPageAfterClose) {
            this.onFullPageModeChange(false);
        }
        else {
            this.toggleisItemOpen();
        }
        this.closeFullPageAfterClose = false;
        this.moveFocusToSpecificRow(this.selectedItem);
    }
    toggleisItemOpen() {
        this.isItemOpen = !this.isItemOpen;
        const elements = document.getElementsByClassName("alma-page-column-main-header");
        if (elements && elements.length === 1) {
            const element = elements.item(0);
            if (element.style.display !== 'none') {
                this.pageHeaderDisplayStyle = element.style.display;
            }
            if (this.isItemOpen && this.isFullPage) {
                element.style.setProperty('display', 'none', 'important');
            }
            else {
                element.style.setProperty('display', this.pageHeaderDisplayStyle);
            }
        }
        this.itemsLayoutService.fireLastBreakpoint(this.isItemOpen);
        this.splitViewOpen.emit(this.isItemOpen);
        if (this.isItemOpen && (this.selectedItem === -1) || !this.selectedItem) {
            this.selectedItem = 0;
        }
    }
    toggleisItemOpenSized(size) {
        this.openSidebySide();
        switch (size) {
            case 'large':
                this.listProperties.rightSide = 40;
                this.listProperties.leftSide = 60;
                break;
            case 'medium':
                this.listProperties.rightSide = 50;
                this.listProperties.leftSide = 50;
                break;
            case 'small':
                this.listProperties.rightSide = 70;
                this.listProperties.leftSide = 30;
                break;
        }
        this.leftSideWitdhChanged.emit(this.listProperties.leftSide);
        this.gutterDragEnd.emit({ sizes: [this.listProperties.leftSide, this.listProperties.rightSide] });
    }
    openSidebySide() {
        this.isItemOpen = true;
        this.splitViewOpen.emit(true);
        if ((this.selectedItem === -1) || !this.selectedItem) {
            this.selectedItem = 0;
        }
    }
    closeSidebySide() {
        this.isItemOpen = false;
        this.splitViewOpen.emit(false);
    }
    onLeftSideResized(event) {
        this.leftSideWidth = event.newRect.width;
        this.leftSideWitdhChanged.emit(this.leftSideWidth);
        this.itemsLayoutService.setListBreakpoint(this.leftSideWidth);
    }
    onRightSideResized(event) {
        this.rightSideWitdhChanged.emit(event.newRect.width);
    }
    _pageSizeChange(pageSize) {
        this.listProperties.pagination.pageSize = pageSize;
        this.placeHolderRows = this.placeHolderRows > 0 ? pageSize : this.placeHolderRows;
        this.pageSizeChange.emit(pageSize);
    }
    _selectedPageChange(page) {
        this.listProperties.pagination.selectedPage = page;
        this.selectedItem = 0;
        if (this.listRef) {
            this.listRef.nativeElement.scrollTop = 0;
        }
        this.selectedPageChange.emit(page);
    }
    _sortChange(sort) {
        const { order, sortBy, index } = sort;
        this.listProperties.sorts[index].order = order;
        this.listProperties.sorts[index].selectedOption = sortBy;
        this.sortChange.emit(sort);
    }
    _searchChange(search) {
        this.searchChange.emit(search);
    }
    _selectedValueChange(value) {
        this.searchSelectedValueChange.emit(value);
    }
    onCheckBoxClicked() {
        event.stopImmediatePropagation();
    }
    getSlectedItemIndex(index) {
        return this.checkedItems.findIndex(item => item === index);
    }
    _datesUpdated(e) {
        this.datesUpdated.emit(e);
    }
    _clearDates() {
        this.clearDates.emit();
    }
    _actionClicked(value) {
        this.actionClicked.emit({ value, checkedItems: [...this.checkedItems] });
        const action = this.listProperties.actions?.find(action => action.value === value) ?? this.listProperties.bulkActions?.find(action => action.value === value);
        if (action && action.clearPickupOnAction) {
            this.checkedItems.length = 0;
            this.selectedOnCurrentPage = 0;
        }
    }
    onRecordActionClicked(key, listItem) {
        this.actionClicked.emit({ value: key, checkedItems: [listItem] });
    }
    isSelected(index) {
        return this.checkedItems.findIndex(item => item.id === this.items[index].id) !== -1;
    }
    hasPrevPage() {
        return this.listProperties.pagination.selectedPage > 1;
    }
    hasNextPage() {
        const { pageSize, totalItemsCount, selectedPage } = this.listProperties.pagination;
        return selectedPage < Math.ceil(totalItemsCount / pageSize);
    }
    _loadMoreSublist() {
        this.selectedItemInSublist = 0;
        this.loadMoreSublist.emit({ listInd: this.openedSublist, sublistInd: this.sublistInd });
        setTimeout(() => {
            this.subListRef.focus();
        }, 1500);
    }
    onComboboxItemClicked(item) {
        this.comboboxItemClicked.emit(item);
    }
    closeClicked() {
        this.selectedItem = this.openedSublist;
        this.openedSublist = -1;
        this.selectedItemInSublist = -1;
    }
    onCheckboxChanged(e, index) {
        if (e.checked) {
            this.checkedItems.push(this.items[index]);
            this.selectedOnCurrentPage++;
        }
        else {
            this.checkedItems.splice(this.checkedItems.findIndex(item => item.id === this.items[index].id), 1);
            this.selectedOnCurrentPage--;
        }
        this.checkboxChanged.emit({ item: this.items[index], value: e.checked });
        this.checkedItemsChange.emit(this._checkedItems);
    }
    onClearPageCheckedItems() {
        this.notifyAllCheckboxesValue(false, this.items);
        this.items.forEach(item => {
            this.checkedItems.splice(this.checkedItems.findIndex(checkedItem => checkedItem.id === item.id), 1);
        });
    }
    onClearCheckedItems() {
        this.notifyAllCheckboxesValue(false, this.checkedItems);
        this.checkedItems.length = 0;
    }
    onCheckAllItems() {
        this.items.forEach((item, ind) => {
            if (!this.isSelected(ind)) {
                this.checkedItems.push(item);
            }
        });
        this.notifyAllCheckboxesValue(true, this.items);
    }
    notifyAllCheckboxesValue(value, items) {
        items.forEach(item => {
            this.checkboxChanged.emit({ item: item, value: value });
        });
        if (value)
            this.selectedOnCurrentPage = items.length;
        else
            this.selectedOnCurrentPage = 0;
    }
    getItemId() {
        const selectedItem = this.items?.[this.selectedItem];
        const listItem = selectedItem?.listItem;
        const data = listItem?.data?.id;
        return selectedItem?.id ?? listItem?.id ?? data?.id;
    }
    getRightSideActions() {
        if (this.dynamicComponents) {
            return null;
        }
        else if (this._selectedItemInSublist !== -1) {
            const data = this.items[this.openedSublist].sublists[this.sublistInd].list[this._selectedItemInSublist];
            if (data.__proto__.actions && !data.__proto__.actions.type) {
                return data.actions;
            }
            else if (data.__proto__.actions && data.__proto__.actions.type && data.actions) {
                return {
                    type: data.__proto__.actions.type,
                    actions: data.actions
                };
            }
            return null;
        }
        else if (this.items[this.selectedItem]) {
            const data = this.items[this.selectedItem].listItem;
            if (data.__proto__.actions && !data.__proto__.actions.type) {
                return data.actions;
            }
            else if (data.__proto__.actions && data.__proto__.actions.type && data.actions) {
                return {
                    type: data.__proto__.actions.type,
                    actions: data.actions
                };
            }
            return null;
        }
        else {
            return null;
        }
    }
    getRightSideHeaderMenus() {
        if (this.items[this.selectedItem]) {
            const data = this.items[this.selectedItem].listItem;
            if (data.__proto__.headerMenus && data.__proto__.headerMenus.type && data.headerMenus) {
                return {
                    type: data.__proto__.headerMenus.type,
                    headerMenus: data.headerMenus
                };
            }
            return null;
        }
        return null;
    }
    getRightSideStatus() {
        if (this.items[this.selectedItem]) {
            const data = this.items[this.selectedItem].listItem;
            if (data.__proto__.status && data[data.__proto__.status]) {
                return data[data.__proto__.status];
            }
            return null;
        }
        return null;
    }
    onScrollLeftSide(e) {
        let hideHeaderToggled;
        if (e.target.scrollTop === 0) {
            this._hideHeader = false;
            return;
        }
        if (this._ignoreScroll || !this.listProperties.hideHeaderOnScroll) {
            return;
        }
        if (!this._scrollTop) {
            this._scrollTop = e.target.scrollTop;
        }
        hideHeaderToggled = this._hideHeader;
        this._hideHeader = e.target.scrollTop > this._scrollTop && e.target.scrollTop > 100;
        if (this._hideHeader !== hideHeaderToggled) {
            this._ignoreScroll = true;
            setTimeout(() => {
                this._ignoreScroll = false;
            }, 500);
        }
        this._scrollTop = e.target.scrollTop;
    }
    _haveHeader() {
        const { sorts, actions, searchByFields, hasExport, filters } = this.listProperties;
        return !!(sorts?.length > 0 || actions?.length > 0 || filters?.length > 0 || searchByFields?.length > 0 || hasExport);
    }
    drop(event) {
        if (!this.listProperties.hasDrag) {
            return;
        }
        this.rowDragged.emit({ currentIndex: event.currentIndex, previousIndex: event.previousIndex });
    }
    focusOnEndOfPage() {
        this.endOfList.nativeElement.focus();
    }
    _customizationClicked() {
        this.customizationClicked.emit(null);
    }
    openCustomizationComponent(customizationComponent) {
        this.customizationClicked.emit(customizationComponent);
    }
    onFullPageModeChange(isFullPage, changeNavigation = true, closeFullPageAfterClose = false) {
        this.closeFullPageAfterClose = closeFullPageAfterClose;
        const prevIsFullPage = this.isFullPage;
        this.isFullPage = isFullPage;
        if (this.isExpanded)
            this.isExpanded = isFullPage;
        if (isFullPage) {
            this.listProperties.hasTitle = true;
            if (this.isItemOpen) {
                if (changeNavigation && !prevIsFullPage) {
                    this.location.go(this.router.url);
                }
                const elements = document.getElementsByClassName("alma-page-column-main-header");
                if (elements && elements.length !== 0) {
                    const element = elements.item(elements.length - 1);
                    if (element.style.display != 'none') {
                        this.pageHeaderDisplayStyle = element.style.display;
                    }
                    element.style.setProperty('display', 'none', 'important');
                }
            }
        }
        else {
            this.listProperties.hasTitle = false;
            const elements = document.getElementsByClassName("alma-page-column-main-header");
            if (elements && elements.length !== 0) {
                const element = elements.item(elements.length - 1);
                element.style.setProperty('display', this.pageHeaderDisplayStyle);
            }
        }
        this.fullPageModeChange.emit(isFullPage);
        this.exSectionsLayoutListLayoutService.isFullPageChange.next(isFullPage);
    }
    rightSideHeightChange(height) {
        this.exSectionsLayoutListLayoutService.rightSideHeightChange.next(height);
    }
    _refreshClicked() {
        this.refreshClicked.emit();
    }
    onExpandButtonToggle(fullPage) {
        if (!fullPage) {
            this.location.back();
        }
        this.onFullPageModeChange(fullPage, true, fullPage);
        this.isExpanded = fullPage;
    }
    onViewModeChange(viewMode) {
        this.isSplitScreen = (viewMode == ViewModes.SPLIT);
        this.onFullPageModeChange(!this.isSplitScreen);
        this.splitChange.emit(this.isSplitScreen);
    }
    getViewMode() {
        return this.isSplitScreen ? ViewModes.SPLIT : ViewModes.FULL;
    }
    getSearchText() {
        if (this.isSecondarySearchFlagActive && this.listProperties.persistentSearchType) {
            if (this.listProperties.persistentSearchRuleSet) {
                return '';
            }
            else {
                return this.persistentSearchText;
            }
        }
        return this.listProperties?.searchText;
    }
    static { this.ɵfac = function ExListLayoutComponent_Factory(t) { return new (t || ExListLayoutComponent)(i0.ɵɵdirectiveInject(i1$5.Location), i0.ɵɵdirectiveInject(ExSectionsLayoutListLayoutService), i0.ɵɵdirectiveInject(i3$2.Router), i0.ɵɵdirectiveInject(ExSidenavPageService, 8), i0.ɵɵdirectiveInject(ExItemsLayoutService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExListLayoutComponent, selectors: [["ex-list-layout"]], viewQuery: function ExListLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$k, 5);
            i0.ɵɵviewQuery(_c1$e, 5);
            i0.ɵɵviewQuery(_c2$8, 5);
            i0.ɵɵviewQuery(_c3$5, 5);
            i0.ɵɵviewQuery(_c4$3, 5);
            i0.ɵɵviewQuery(_c5$3, 5);
            i0.ɵɵviewQuery(ExSideBySideComponent, 5);
            i0.ɵɵviewQuery(_c6$3, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listWrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightSideRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endOfList = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subListRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sideBySide = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItemRef = _t);
        } }, hostBindings: function ExListLayoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("popstate", function ExListLayoutComponent_popstate_HostBindingHandler($event) { return ctx.onPopState($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { selectedItem: "selectedItem", checkedItems: "checkedItems", animateRemoveIndex: "animateRemoveIndex", hasCustomization: "hasCustomization", customizationComponent: "customizationComponent", isCustomized: "isCustomized", isRtl: "isRtl", responsive: "responsive", recordCustomizationData: "recordCustomizationData", isSplitScreen: "isSplitScreen", noResultsTemplate: "noResultsTemplate", deepLinkModeTemplate: "deepLinkModeTemplate", expandActionsOnAllSpaceFlag: "expandActionsOnAllSpaceFlag", isSecondarySearchFlagActive: "isSecondarySearchFlagActive", persistentSearchText: "persistentSearchText" }, outputs: { customizationClicked: "customizationClicked", gutterDragEnd: "gutterDragEnd", splitChange: "splitChange", openUserResponsiveMenu: "openUserResponsiveMenu" }, features: [i0.ɵɵProvidersFeature([
                ExItemsLayoutService,
                { provide: GeneralListLayoutComponent, useExisting: forwardRef(() => ExListLayoutComponent_1) },
                {
                    provide: forwardRef(() => LAYOUT_WRAPPER_GET_BOUNDS),
                    useFactory: (layout) => {
                        return () => layout.listWrapper?.nativeElement.getBoundingClientRect();
                    },
                    deps: [ExListLayoutComponent_1]
                }
            ]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c19$1, decls: 14, vars: 11, consts: [[1, "ex-list-layout-wrapper"], ["listWrapper", ""], ["class", "ex-list-layout-header-wrapper", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["results", ""], [3, "ngClass"], ["list", ""], ["tabindex", "0", 1, "ex-list-layout-hidden-button"], ["endOfList", ""], [1, "ex-list-layout-header-wrapper"], ["headerWrapper", ""], [3, "responsivenessActive", "headerResponsivenessOrderConfig", "selectedOnCurrentPage", "hasToggle", "isWideScreen", "responsive", "hasExport", "hasSearch", "popUpActions", "numberOfCheckedItems", "pageSize", "isItemOpen", "searchByFields", "searchBySelectedField", "sorts", "filters", "hasPickup", "hasPickupCount", "comboboxLists", "actions", "bulkActions", "hasBottomBorder", "filterMaxDate", "filterMinDate", "showDateFilter", "searchText", "clearAllSubject", "floatingExport", "hasCustomization", "customizationComponent", "isCustomized", "fullPage", "isLoading", "needToRefresh", "hasRefreshButton", "deepLinkMode", "deepLinkModeTemplate", "viewMode", "selectedOnCurrentPageChange", "comboboxItemClicked", "toggleisItemOpen", "toggleisItemOpenSized", "sortChange", "actionClicked", "searchChange", "selectedValueChange", "clearCheckedItems", "clearPageCheckedItems", "checkAllItems", "filterChange", "datesUpdated", "clearDates", "customizationClicked", "closeRightSideClicked", "refreshClicked", "viewModeChange", "openUserResponsiveMenu"], ["role", "alert", 3, "ngTemplateOutlet", 4, "ngIf", "ngIfElse"], ["defaultNoResultsTemplate", ""], ["role", "alert", 3, "ngTemplateOutlet"], ["role", "alert", 1, "ex-list-layout-no-records-found-placeholder", "ex-list-layout-no-records-flex-and-center"], [1, "sel-no-records-icon", "ex-list-layout-no-records-icon", 3, "src"], ["class", "ex-list-layout-no-records-text sel-no-records", 4, "ngIf"], [1, "ex-list-layout-no-records-text", "sel-no-records"], ["customNoResults", ""], [1, "bold-weight"], [1, "ex-list-layout-content-wrapper", 3, "ngClass"], ["class", "ex-list-layout-side-by-side", 3, "leftVisible", "rightVisible", "leftSize", "rightSize", "leftMinSize", "rightMinSize", "isRtl", "rightSideHeightChange", "leftSideResized", "gutterDragEnd", 4, "ngIf", "ngIfElse"], [1, "ex-list-layout-side-by-side", 3, "leftVisible", "rightVisible", "leftSize", "rightSize", "leftMinSize", "rightMinSize", "isRtl", "rightSideHeightChange", "leftSideResized", "gutterDragEnd"], ["slot-side-1", "", 1, "ex-list-layout-left", 3, "scroll"], ["listRef", ""], [4, "ngTemplateOutlet"], ["expand-button", "", "class", "ex-list-layout-expand-collapse-wrapper", 3, "ex-list-layout-expand-collapse-wrapper-rotate", 4, "ngIf"], ["slot-side-2", "", "class", "ex-list-layout-right ex-generic-list-side-by-side", 3, "resized", 4, "ngIf"], ["expand-button", "", 1, "ex-list-layout-expand-collapse-wrapper"], ["class", "ex-list-layout-expand-collapse-icon", 3, "exTooltip", "click", 4, "ngIf"], [1, "ex-list-layout-expand-collapse-icon", 3, "exTooltip", "click"], ["iconType", "fa-font", "iconName", "fa-angle-double-left", "color", "#757575"], ["slot-side-2", "", 1, "ex-list-layout-right", "ex-generic-list-side-by-side", 3, "resized"], ["aria-label", "move focus to previous\n          row", 1, "ex-list-layout-hidden-button", 3, "focus"], ["tabindex", "0", 1, "ex-list-layout-right-wrapper"], ["rightSideRef", ""], [4, "ngIf"], ["headerTemplate", ""], ["placeHolder", ""], ["aria-label", "move focus to next row", 1, "ex-list-layout-hidden-button", 3, "focus"], [1, "ex-list-layout-header", 3, "itemId", "actions", "headerMenus", "status", "hasPrev", "hasNext", "hasTitle", "hasSectionsCombobox", "deepLinkMode", "expandActionsOnAllSpace", "prevClicked", "nextClicked", "closeClicked", "actionClicked"], [4, "ngFor", "ngForOf"], [1, "ex-list-layout-content", 3, "data", "componentFactoryItem"], [1, "ex-list-layout-content", 3, "data", "events", "componentFactoryItem"], [3, "data", "componentFactoryItem"], ["role", "alert", "class", "ex-list-layout-hidden-button", 4, "ngIf"], ["cdkDropList", "", 3, "cdkDropListDropped"], [1, "ex-list-layout-list-wrapper", 3, "resized"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "selectedPageChange", "pageSizeChange", "endOfPagination", 4, "ngIf"], ["cdkDrag", "", 3, "cdkDragDisabled"], ["role", "button", "mat-ripple", "", 1, "ex-list-layout-row-item", 3, "matRippleColor", "ngClass", "focusin", "keydown.enter", "keydown.space", "click"], ["rowItemRef", ""], [1, "ex-list-layout-drag-mode-wrapper"], ["cdkDragHandle", "", "class", "ex-list-layout-drag-and-drop", 4, "ngIf"], [3, "class", "exTooltip", 4, "ngIf"], ["class", "ex-list-layout-pickup", 3, "click", 4, "ngIf"], [1, "ex-list-layout-content", 3, "ngClass"], [3, "data", "events", "componentFactoryItem", 4, "ngIf", "ngIfElse"], ["exRecord", ""], ["class", "ex-list-layout-sublist-bubbles", 4, "ngIf"], ["class", "ex-list-layout-hidden-button", "aria-label", "move\n                focus to right side", 3, "keyup.Tab", 4, "ngIf"], ["cdkDragHandle", "", 1, "ex-list-layout-drag-and-drop"], [3, "exTooltip"], [1, "ex-list-layout-index", 3, "ngClass"], [1, "ex-list-layout-pickup", 3, "click"], [3, "checked", "ariaLabel", "checkboxChange"], [3, "ngSwitch"], [3, "class", "exTooltip", 4, "ngSwitchCase"], ["sizePx", "25px", 3, "class", "iconName", "iconType", 4, "ngSwitchCase"], ["sizePx", "25px", 3, "iconName", "iconType"], [3, "data", "events", "componentFactoryItem"], [3, "recordCustomizationData", "highlightedText", "data", "width", "isSelected", "emptyRowHeight", "isExPickup", "htmlId", "isItemOpen", "actionClicked"], [1, "ex-list-layout-sublist-bubbles"], [3, "diameter", 4, "ngIf", "ngIfElse"], ["bubble", ""], [3, "diameter"], ["class", "ex-list-layout-bubbles", 3, "mode", "text", "color", "ngClass", "tooltip", "click", 4, "ngIf"], [1, "ex-list-layout-bubbles", 3, "mode", "text", "color", "ngClass", "tooltip", "click"], ["aria-label", "move\n                focus to right side", 1, "ex-list-layout-hidden-button", 3, "keyup.Tab"], [3, "list", "htmlId", "dynamicComponents", "color", "selectedItem", "hasMore", "title", "description", "selectedItemChange", "closeClicked", "loadMoreSublist"], ["subList", ""], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "selectedPageChange", "pageSizeChange", "endOfPagination"], ["paginationRef", ""], ["role", "alert", 1, "ex-list-layout-hidden-button"], ["spinner", ""], ["mat-ripple", "", "matRippleColor", "transparent", 1, "ex-list-layout-row-item", 3, "ngClass"], ["class", "ex-list-layout-index", 4, "ngIf"], [1, "ex-list-layout-content"], [3, "proto", "hasPickup", "emptyRowHeight"], [1, "ex-list-layout-index"], [1, "ex-list-spinner", "sel-list-spinner", 3, "diameter"]], template: function ExListLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c17$1);
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵelementContainerStart(2);
            i0.ɵɵtemplate(3, ExListLayoutComponent_div_3_Template, 6, 39, "div", 2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(4, ExListLayoutComponent_ng_container_4_Template, 4, 2, "ng-container", 3);
            i0.ɵɵtemplate(5, ExListLayoutComponent_ng_template_5_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelement(7, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ExListLayoutComponent_ng_template_8_Template, 3, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(10, "div", 7, 8);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("ex-list-layout-grid-rows-no-header", ctx.listProperties.hideHeader);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.listProperties.hideHeader);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (!ctx.items || (ctx.items == null ? null : ctx.items.length) === 0) && !ctx.listProperties.isLoading)("ngIfElse", _r3);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c18$1, ctx.listProperties.isLoading));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 7, "ng.list-layout.end_of_list"));
        } }, styles: [".ex-list-layout-wrapper[_ngcontent-%COMP%]:focus{outline:0}.ex-list-layout-wrapper[_ngcontent-%COMP%]{display:grid;grid-template-rows:max-content 1fr;height:100%;position:relative}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-header-wrapper[_ngcontent-%COMP%]{overflow:hidden}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]{position:relative;overflow:auto}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]{height:100%;overflow:auto}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-left[_ngcontent-%COMP%]{overflow:auto;padding-inline-end:15px;height:100%}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]{height:100%;position:relative}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]     .ex-sections-layout-wrapper{margin-top:-43px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]     .ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper{padding-block-start:50px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-in-place-layout-right-wrapper-full-page[_ngcontent-%COMP%]{padding-inline-start:25px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-list-layout-right-wrapper[_ngcontent-%COMP%]{height:100%;overflow-y:auto}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-list-layout-right-wrapper[_ngcontent-%COMP%]   .ex-list-layout-sections-menu[_ngcontent-%COMP%]{position:sticky;top:10px;height:100%;min-width:150px;padding-top:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-list-layout-right-wrapper[_ngcontent-%COMP%]   .ex-list-layout-sections-menu[_ngcontent-%COMP%]   .ex-list-layout-sections-menu-item-active[_ngcontent-%COMP%]{padding-left:10px!important}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-list-layout-right-wrapper[_ngcontent-%COMP%]   .ex-list-layout-sections-menu[_ngcontent-%COMP%]   .ex-list-layout-sections-menu-item[_ngcontent-%COMP%]{padding-left:14px;background:transparent;border:none;text-align:start;display:flex;padding-top:5px;padding-bottom:5px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper[_ngcontent-%COMP%]   .ex-list-layout-side-by-side[_ngcontent-%COMP%]   .ex-list-layout-right[_ngcontent-%COMP%]   .ex-list-layout-right-wrapper[_ngcontent-%COMP%]   .ex-list-layout-sections-menu[_ngcontent-%COMP%]   .ex-list-layout-sections-menu-item[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{margin-right:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-li[_ngcontent-%COMP%]{display:block}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-content-wrapper-no-header[_ngcontent-%COMP%]{height:100%}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]{height:100%;margin-bottom:0;padding-bottom:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-hover-left-indication[_ngcontent-%COMP%]{cursor:pointer}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]:focus{border-top:1px solid black;border-inline-end:1px solid black;border-bottom:1px solid black}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]{border-top:1px solid transparent;border-inline-end:1px solid transparent;display:flex;flex-direction:row;padding:10px;outline:0}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]:hover{background:#f4f8fa}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-drag-mode-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-drag-and-drop[_ngcontent-%COMP%]{cursor:move;margin-right:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-index[_ngcontent-%COMP%]{margin-right:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-pickup[_ngcontent-%COMP%]{width:24px;margin-right:10px;display:flex;flex-direction:column;text-align:center}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-pickup[_ngcontent-%COMP%]   .ex-list-layout-warning-icon[_ngcontent-%COMP%], .ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-pickup[_ngcontent-%COMP%]   .ex-list-layout-valid-icon[_ngcontent-%COMP%], .ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-pickup[_ngcontent-%COMP%]   .ex-list-layout-suppress-icon[_ngcontent-%COMP%]{margin-top:5px!important}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-content[_ngcontent-%COMP%]{flex:1}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-content[_ngcontent-%COMP%]   .ex-list-layout-sublist-bubbles[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;margin-left:47px;margin-top:5px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-content[_ngcontent-%COMP%]   .ex-list-layout-sublist-bubbles[_ngcontent-%COMP%]   .ex-list-layout-bubbles[_ngcontent-%COMP%]{margin-right:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item[_ngcontent-%COMP%]   .ex-list-layout-content[_ngcontent-%COMP%]   .ex-list-layout-sublist-bubbles[_ngcontent-%COMP%]   .ex-list-layout-not-selected-bubbles[_ngcontent-%COMP%]{opacity:.7}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item-dark-theme[_ngcontent-%COMP%]{background:#3f4348;color:#d8d8d8;border-bottom-color:#ebebeb4a}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item-dark-theme[_ngcontent-%COMP%]:hover{background:#4a4e53}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item-dark-theme[_ngcontent-%COMP%]   mark[_ngcontent-%COMP%]{background-color:#555;color:#fff}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item-disabled[_ngcontent-%COMP%]{pointer-events:none;background:#eee;opacity:.2}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-row-item-opened[_ngcontent-%COMP%]{border-top:1px solid #d0cfcf}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-large-density[_ngcontent-%COMP%]{padding:10px}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-disabled-content[_ngcontent-%COMP%]{pointer-events:none}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-list-wrapper[_ngcontent-%COMP%]   .ex-list-layout-disabled-row-item[_ngcontent-%COMP%]{opacity:.3}.ex-list-layout-wrapper[_ngcontent-%COMP%]   .ex-list-layout-header[_ngcontent-%COMP%]{display:flex;position:sticky;top:0;width:calc(100% - 15px);justify-content:flex-end;height:43px;z-index:10}.ex-list-layout-grid-rows-no-header[_ngcontent-%COMP%]{grid-template-rows:1fr}.ex-list-layout-spinner-wrapper[_ngcontent-%COMP%]{position:relative;height:100%;width:100%}.ex-list-layout-spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%}.ex-list-layout-no-records-found-placeholder[_ngcontent-%COMP%]{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-list-layout-no-records-flex-and-center[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}.ex-list-layout-no-records-flex-and-center[_ngcontent-%COMP%]   .ex-list-layout-no-records-icon[_ngcontent-%COMP%]{margin-bottom:10px}.ex-list-layout-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}.ex-list-spinner[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;min-height:50vh}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-list-layout-hidden-button[_ngcontent-%COMP%]{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none}.ex-list-layout-header-toggle-div[_ngcontent-%COMP%]{display:grid;grid-template-areas:\"left right\"}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]{margin-top:10px;display:flex;align-content:center}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-layout-main-header-back-button[_ngcontent-%COMP%]{border:0px;padding:0 10px;width:35px}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-layout-main-header-back-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:20px}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-layout-main-header-back-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-layout-primary-title[_ngcontent-%COMP%]{display:flex}.ex-list-layout-header-title-wrapper[_ngcontent-%COMP%]   .ex-list-layout-primary-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#474747;margin:0;align-self:center}.ex-list-layout-expand-collapse-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.ex-list-layout-expand-collapse-wrapper[_ngcontent-%COMP%]   .ex-list-layout-expand-collapse-icon[_ngcontent-%COMP%]{width:25px;height:50px;border-top-left-radius:51px;border-bottom-left-radius:51px;border:1px solid #ccc;border-right:0;display:flex;align-items:center;justify-content:center;margin-left:-25px;z-index:10;background:#fff}.ex-list-layout-expand-collapse-wrapper[_ngcontent-%COMP%]   .ex-list-layout-expand-collapse-icon[_ngcontent-%COMP%]:hover     ex-icon i{color:#fff!important}.ex-list-layout-expand-collapse-wrapper-rotate[_ngcontent-%COMP%]   .ex-list-layout-expand-collapse-icon[_ngcontent-%COMP%]{transform:rotate(180deg);margin-left:0;border-right:1px solid #ccc;margin-right:-25px}"], data: { animation: ExListLayoutAnimations } }); }
};
ExListLayoutComponent = ExListLayoutComponent_1 = __decorate([
    ExDeprecated('hep-items-layout', { phaseOneSprint: DevSprints.S2023JUL })
], ExListLayoutComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-list-layout', animations: ExListLayoutAnimations, providers: [
                    ExItemsLayoutService,
                    { provide: GeneralListLayoutComponent, useExisting: forwardRef(() => ExListLayoutComponent) },
                    {
                        provide: forwardRef(() => LAYOUT_WRAPPER_GET_BOUNDS),
                        useFactory: (layout) => {
                            return () => layout.listWrapper?.nativeElement.getBoundingClientRect();
                        },
                        deps: [ExListLayoutComponent]
                    }
                ], template: "<div class=\"ex-list-layout-wrapper\" #listWrapper [class.ex-list-layout-grid-rows-no-header]=\"listProperties.hideHeader\">\n  <ng-container>\n    <div #headerWrapper *ngIf=\"!listProperties.hideHeader\" class=\"ex-list-layout-header-wrapper\"\n         [@expanded-header]=\"(!_hideHeader && _haveHeader()) || (isFullPage && isItemOpen) \">\n      <ex-list-header [responsivenessActive]=\"true\"\n                      [headerResponsivenessOrderConfig]=\"listProperties.headerResponsivenessOrderConfig\"\n                      [(selectedOnCurrentPage)]=\"selectedOnCurrentPage\" [hasToggle]=\"!!itemDetails\"\n                      [isWideScreen]=\"isWideScreen\"\n                      [responsive]=\"responsive\" (comboboxItemClicked)=\"onComboboxItemClicked($event)\"\n                      [hasExport]=\"listProperties.hasExport\" [hasSearch]=\"listProperties.hasSearch\"\n                      [popUpActions]=\"listProperties.popUpActions\"\n                      [numberOfCheckedItems]=\"checkedItems.length\" [pageSize]=\"items?.length\" [isItemOpen]=\"isItemOpen\"\n                      [searchByFields]=\"listProperties.searchByFields\"\n                      [searchBySelectedField]=\"listProperties.searchBySelectedField\"\n                      (toggleisItemOpen)=\"toggleisItemOpen()\" (toggleisItemOpenSized)=\"toggleisItemOpenSized($event)\"\n                      [sorts]=\"listProperties.showSortsInListHeader && listProperties.sorts\"\n                      [filters]=\"listProperties.filters\"\n                      [hasPickup]=\"listProperties.hasPickup\"\n                      [hasPickupCount]=\"listProperties.hasPickupCount && listProperties.isMultiSelect\"\n                      [comboboxLists]=\"listProperties.comboboxLists\" [actions]=\"listProperties.actions\"\n                      [bulkActions]=\"listProperties.bulkActions\"\n                      [hasBottomBorder]=\"!listProperties.hideHeaderOnScroll || !items || items?.length === 0\"\n                      [filterMaxDate]=\"listProperties.filterMaxDate\" [filterMinDate]=\"listProperties.filterMinDate\"\n                      [showDateFilter]=\"listProperties.showDateFilter\" [searchText]=\"listProperties.searchText\"\n                      (sortChange)=\"_sortChange($event)\" (actionClicked)=\"_actionClicked($event)\"\n                      (searchChange)=\"_searchChange($event)\" (selectedValueChange)=\"_selectedValueChange($event)\"\n                      (clearCheckedItems)=\"onClearCheckedItems()\" (clearPageCheckedItems)=\"onClearPageCheckedItems()\"\n                      [clearAllSubject]=\"clearAllSubject\" (checkAllItems)=\"onCheckAllItems()\"\n                      [floatingExport]=\"newExport\"\n                      (filterChange)=\"filterChanged.emit($event)\" (datesUpdated)=\"_datesUpdated($event)\"\n                      (clearDates)=\"_clearDates()\"\n                      [hasCustomization]=\"hasCustomization && listProperties.enableCustomization\"\n                      [customizationComponent]=\"customizationComponent\" [isCustomized]=\"isCustomized\"\n                      (customizationClicked)=\"_customizationClicked()\"\n                      (closeRightSideClicked)=\"onCloseRightSideClicked()\"\n                      [fullPage]=\"(isItemOpen && isFullPage) || isExpanded\" [isLoading]=\"listProperties.isLoading\"\n                      [needToRefresh]=\"listProperties.needToRefresh\" (refreshClicked)=\"_refreshClicked()\"\n                      [hasRefreshButton]=\"listProperties.hasRefreshButton\" [deepLinkMode]=\"listProperties.deepLinkMode\"\n                      [deepLinkModeTemplate]=\"deepLinkModeTemplate\" (viewModeChange)=\"onViewModeChange($event)\"\n                      [viewMode]=\"getViewMode()\" (openUserResponsiveMenu)=\"openUserResponsiveMenu.emit()\">\n\n        <ng-content select=\"[header]\" header-slot-1></ng-content>\n        <ng-content select=\"[header-slot-2]\" header-slot-2></ng-content>\n        <ng-content select=\"[header-slot-3]\" header-slot-3></ng-content>\n      </ex-list-header>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"(!items || items?.length === 0) && !listProperties.isLoading; else results\">\n    <ng-container *ngIf=\"noResultsTemplate!=null; else defaultNoResultsTemplate\" [ngTemplateOutlet]=\"noResultsTemplate\"\n                  role=\"alert\"></ng-container>\n    <ng-template #defaultNoResultsTemplate>\n      <div class=\"ex-list-layout-no-records-found-placeholder ex-list-layout-no-records-flex-and-center\" role=\"alert\">\n        <img\n          [src]=\"listProperties?.searchText || listProperties?.persistentSearchIsAdvanced ? '/ng/assets/svg-icons/no-search-results.svg':'/ng/assets/svg-icons/no-items-in-list.svg'\"\n          [style.max-height.px]=\"200\" [style.width.px]=\"200\"\n          class='sel-no-records-icon ex-list-layout-no-records-icon'>\n        <p *ngIf=\"listProperties?.searchText || listProperties?.persistentSearchIsAdvanced\"\n           class=\"ex-list-layout-no-records-text sel-no-records\">\n          <ng-container *ngIf=\"noResultsPlaceholder; else customNoResults\">\n            {{ noResultsPlaceholder | translate }}\n          </ng-container>\n          <ng-template #customNoResults>\n            {{ 'list-layout.no_results_your_search' | translate }}\n            <span class=\"bold-weight\">{{getSearchText()}}</span>\n            {{ 'list-layout.no_results_did_not_match' | translate }}\n          </ng-template>\n        </p>\n        <p class=\"ex-list-layout-no-records-text sel-no-records\">\n          {{(noResultsHintPlaceholder ? noResultsHintPlaceholder :\n          (!listProperties?.persistentSearchType && listProperties?.searchText || listProperties?.persistentSearchIsAdvanced ?\n          'list-layout.no_results_change_filters_hint_placeholder' :\n          'list-layout.no_results_no_items')) | translate }}\n        </p>\n      </div>\n    </ng-template>\n  </ng-container>\n  <ng-template #results>\n    <!--Return to the div when moving to grid layout [@content-height]=\"!_hideHeader\" (@content-height.start)=\"onContentHeightStart($event)\" (@content-height.done)=\"onContentHeightDone($event)\" -->\n    <div class=\"ex-list-layout-content-wrapper\"\n         [ngClass]=\"{ 'ex-list-layout-content-top-border': listProperties.hideHeaderOnScroll, 'ex-list-layout-content-wrapper-no-header' : listProperties.hideHeader}\">\n      <ex-side-by-side (rightSideHeightChange)=\"rightSideHeightChange($event)\" *ngIf=\"itemDetails else list\"\n                       [leftVisible]=\"(!isFullPage) || (isFullPage && !isItemOpen)\" [rightVisible]=\"isItemOpen\"\n                       [leftSize]=\"listProperties.leftSide\" [rightSize]=\"listProperties.rightSide\" [leftMinSize]=\"35\"\n                       [rightMinSize]=\"40\" [isRtl]=\"isRtl\" class=\"ex-list-layout-side-by-side\"\n                       (leftSideResized)=\"onLeftSideResized($event)\" (gutterDragEnd)=\"gutterDragEnd.emit($event)\">\n        <div #listRef (scroll)=\"onScrollLeftSide($event)\" slot-side-1 class=\"ex-list-layout-left\">\n          <ng-container *ngTemplateOutlet=\"list\"></ng-container>\n        </div>\n        <div expand-button *ngIf=\"isItemOpen && (canSplit || !responsive) && !listProperties.deepLinkMode\"\n             class=\"ex-list-layout-expand-collapse-wrapper\"\n             [class.ex-list-layout-expand-collapse-wrapper-rotate]=\"(isRtl && !isFullPage) || (!isRtl && isFullPage)\">\n          <button *ngIf=\"isSplitScreen || (isSplitScreen==undefined)\"\n                  [exTooltip]=\"isFullPage ? ('ng.general.return-to-split-view' | translate): ('ng.general.open-full-page' | translate)\"\n                  (click)=\"onExpandButtonToggle(!isFullPage)\" class=\"ex-list-layout-expand-collapse-icon\">\n            <ex-icon iconType=\"fa-font\" iconName=\"fa-angle-double-left\" color=\"#757575\"></ex-icon>\n          </button>\n        </div>\n        <div *ngIf=\"isItemOpen\" slot-side-2 class=\"ex-list-layout-right ex-generic-list-side-by-side\"\n             (resized)=\"onRightSideResized($event)\">\n          <button class=\"ex-list-layout-hidden-button\" aria-label=\"move focus to previous\n          row\" (focus)=\"moveFocusToPreviousRow()\"></button>\n          <div class=\"ex-list-layout-right-wrapper\" [class.ex-in-place-layout-right-wrapper-full-page]=\"isFullPage\"\n               #rightSideRef tabindex=\"0\">\n            <ng-container *ngIf=\"listProperties.isLoading\">\n              <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n            </ng-container>\n            <ng-template #headerTemplate>\n              <ex-item-details-header [itemId]=\"getItemId()\"\n                                      [actions]=\"!items || items[selectedItem]?.disabled ? null : getRightSideActions()\"\n                                      [headerMenus]=\"!items || items[selectedItem]?.disabled ? null : getRightSideHeaderMenus()\"\n                                      [status]=\"!items || items[selectedItem]?.disabled ? null : getRightSideStatus()\"\n                                      [hasPrev]=\"this.openedSublist !== -1 || selectedItem > 0 || hasPrevPage()\"\n                                      [hasNext]=\"this.openedSublist !== -1 || selectedItem < items?.length - 1 || hasNextPage()\"\n                                      [hasTitle]=\"listProperties.hasTitle\" (prevClicked)=\"selectPrevItem()\"\n                                      (nextClicked)=\"selectNextItem()\"\n                                      (closeClicked)=\"onRightSideDetailesCloseClicked()\" class=\"ex-list-layout-header\"\n                                      [hasSectionsCombobox]=\"listProperties.hasSectionsCombobox\"\n                                      [deepLinkMode]=\"listProperties.deepLinkMode\"\n                                      (actionClicked)=\"onRecordActionClicked($event, items?.[selectedItem])\"\n                                      [expandActionsOnAllSpace]=\"expandActionsOnAllSpaceFlag && this.listProperties.expandActionsOnAllSpace\">\n              </ex-item-details-header>\n            </ng-template>\n            <ng-container *ngIf=\"!listProperties.isLoading; else placeHolder\">\n              <ng-container\n                *ngIf=\"_selectedItemInSublist !== -1 && items[openedSublist].sublists[sublistInd].listItemDetails\">\n                <ng-container *ngFor=\"let item of items[openedSublist].sublists[sublistInd].list; let i = index;\">\n                  <ng-container *ngIf=\"_selectedItemInSublist === i\">\n                    <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n                    <ex-component-loader\n                      [data]=\"{ data: dynamicComponents? items[openedSublist].sublists[sublistInd].list[_selectedItemInSublist].data.data : items[openedSublist].sublists[sublistInd].list[_selectedItemInSublist].data }\"\n                      [componentFactoryItem]=\"items[openedSublist].sublists[sublistInd].listItemDetails\"\n                      class=\"ex-list-layout-content\"></ex-component-loader>\n                  </ng-container>\n                </ng-container>\n              </ng-container>\n\n              <ng-container *ngIf=\"_selectedItemInSublist === -1\">\n                <ng-container *ngIf=\"items[selectedItem]\">\n                  <ng-container *ngFor=\"let item of items; let i = index;\">\n                    <ng-container *ngIf=\"selectedItem === i\">\n                      <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n                      <ex-component-loader\n                        [data]=\"{ data: dynamicComponents? items[selectedItem]?.listItem.data.data: items[selectedItem]?.listItem.data , disabled: items[selectedItem].disabled}\"\n                        [events]=\"itemDetails.events\" [componentFactoryItem]=\"itemDetails\"\n                        class=\"ex-list-layout-content\"></ex-component-loader>\n                    </ng-container>\n                  </ng-container>\n                </ng-container>\n              </ng-container>\n            </ng-container>\n\n            <ng-template #placeHolder>\n              <ex-component-loader [data]=\"{ 'isLoading' : 'true' }\" [componentFactoryItem]=\"itemDetails\">\n              </ex-component-loader>\n            </ng-template>\n            <button class=\"ex-list-layout-hidden-button\" (focus)=\"moveFocusToNextRow()\"\n                    aria-label=\"move focus to next row\"></button>\n          </div>\n        </div>\n\n      </ex-side-by-side>\n    </div>\n  </ng-template>\n\n  <div [ngClass]=\"{ 'ex-list-layout-animate sel-loading' : listProperties.isLoading }\"></div>\n\n</div>\n\n<ng-template #list>\n  <ng-container *ngIf=\"!listProperties.isLoading && (canSplitChecked || !responsive) \">\n    <ex-drag-list cdkDropList (cdkDropListDropped)=\"drop($event)\">\n      <ul class=\"ex-list-layout-list-wrapper\" (resized)=\"onLeftSideResized($event)\">\n        <ng-container *ngFor=\"let item of items; let i = index\">\n          <li cdkDrag [cdkDragDisabled]=\"!listProperties.hasDrag\" [@expanded]=\"animateRemoveIndex != i\"\n              class=\"sel-row-{{i}}-item ex-list-layout-li\"\n              [attr.aria-hidden]=\"(openedSublist !== i && openedSublist !== -1)\">\n            <div #rowItemRef role=\"button\" [attr.tabindex]=\"(openedSublist !== i && openedSublist !== -1) ? -1 : 0\"\n                 (focusin)=\"rowItemFocused(i)\" (keydown.enter)=\"onRowClicked(i)\" (keydown.space)=\"onRowClicked(i)\"\n                 mat-ripple [attr.aria-pressed]=\"i === selectedItem\"\n                 [matRippleColor]=\"itemDetails && i !== selectedItem ? '#eff4f74f': 'transparent'\"\n                 (click)=\"onRowClicked(i)\" class=\"ex-list-layout-row-item\" [ngClass]=\"{\n            'ex-list-layout-row-item-opened': openedSublist === i,\n            'ex-list-layout-row-item-disabled': (openedSublist !== i && openedSublist !== -1),\n            'ex-list-layout-selected': listProperties.canSelectRow && i === selectedItem,\n            'ex-list-layout-hover-left-indication': listProperties.canSelectRow,\n            'ex-list-layout-large-density': listProperties.density === 'large',\n            'ex-list-layout-row-item-dark-theme': listProperties.isDarkTheme,\n            'ex-list-layout-selected-dark-theme': listProperties.canSelectRow && i === selectedItem && listProperties.isDarkTheme\n          }\">\n              <div class=\"ex-list-layout-drag-mode-wrapper\">\n                <ex-drag-accessible-icon *ngIf=\"listProperties.hasDrag\" cdkDragHandle\n                                         class=\"ex-list-layout-drag-and-drop\"></ex-drag-accessible-icon>\n                <i *ngIf=\"item.mode?.value === 'WARNING' && !listProperties.hasPickup\"\n                   class=\"material-icons ex-list-layout-warning-icon sel-warning-{{i}}\"\n                   [exTooltip]=\"item.mode?.tooltip | translate\">\n                  error\n                </i>\n              </div>\n              <span *ngIf=\"listProperties.hasIndex\">\n                <span class=\"ex-list-layout-index\" [ngClass]=\"{'ex-list-layout-disabled-row-item' : item.disabled}\">\n                  {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) + i + 1) }}\n                </span></span>\n              <div class=\"ex-list-layout-pickup\" *ngIf=\"listProperties.hasPickup\" (click)=\"onCheckBoxClicked()\">\n                <ex-checkbox [checked]=\"isSelected(i)\" (checkboxChange)=\"onCheckboxChanged($event, i)\"\n                             [ariaLabel]=\"'ng.ex_items_layout_list_row.check_or_uncheck' | translate\"></ex-checkbox>\n                <div [ngSwitch]=\"item.mode?.value\">\n                  <i *ngSwitchCase=\"'WARNING'\" class=\"material-icons ex-list-layout-warning-icon sel-warning-{{i}}\"\n                     [exTooltip]=\"item.mode?.tooltip | translate\">\n                    error\n                  </i>\n                  <i *ngSwitchCase=\"'VALID'\" class=\"material-icons ex-list-layout-valid-icon sel-valid-{{i}}\"\n                     [exTooltip]=\"item.mode?.tooltip | translate\">\n                    check_circle\n                  </i>\n                  <ex-icon sizePx=\"25px\" *ngSwitchCase=\"'SUPPRESSED'\"\n                           class=\"material-icons ex-list-layout-suppress-icon sel-suppress-{{i}}\"\n                           [iconName]=\"_suppressedIconName\" [iconType]=\"'svg'\">\n                  </ex-icon>\n\n                </div>\n              </div>\n              <div class=\"ex-list-layout-content\"\n                   [ngClass]=\"{'ex-list-layout-disabled-content' : item.disabled, 'ex-list-layout-disabled-row-item' : item.disabled}\">\n                <ex-component-loader *ngIf=\"dynamicComponents; else exRecord\" [data]=\"getItem(item.listItem.data, i)\"\n                                     [events]=\"{ rowClicked: onRowClicked.bind(this, i), rowDeleted: onRowRemove.bind(this, i) }\"\n                                     [componentFactoryItem]=\"item.listItem\"></ex-component-loader>\n                <ng-template #exRecord>\n                  <ex-record [recordCustomizationData]=\"recordCustomizationData\"\n                             [highlightedText]=\"listProperties.highlightedText\" [data]=\"item.listItem\"\n                             [width]=\"leftSideWidth\"\n                             [isSelected]=\"selectedItem === i\" [emptyRowHeight]=\"listProperties.emptyRowHeight\"\n                             [isExPickup]=\"listProperties.isExPickup\"\n                             htmlId=\"{{ htmlId }}{{ htmlId ? '_' : '' }}{{ htmlId ? i : '' }}\" [isItemOpen]=\"isItemOpen\"\n                             (actionClicked)=\"onRecordActionClicked($event, item)\">\n                  </ex-record>\n                </ng-template>\n                <div *ngIf=\"!item.disabled && item.sublists?.length > 0\" class=\"ex-list-layout-sublist-bubbles\">\n                  <ng-container *ngFor=\"let sublist of item.sublists; let j = index\">\n                    <ex-spinner *ngIf=\"sublist.loading; else bubble\" [diameter]=\"15\"></ex-spinner>\n                    <ng-template #bubble>\n                      <ex-clickable-chip\n                        [mode]=\"((openedSublist === i) && (sublistInd === j)) ? 'filled': 'transparent'\"\n                        class=\"ex-list-layout-bubbles\" text=\"+{{ sublist.length }}\" [color]=\"sublist.color\"\n                        *ngIf=\"sublist.length > 0\"\n                        [ngClass]=\"{ 'ex-list-layout-not-selected-bubbles': i !== selectedItem &&  i !== openedSublist}\"\n                        [tooltip]=\"(sublist.title | translate) + ' ' + (sublist.description | translate)\"\n                        (click)=\"changeSublistInd(i, j)\">\n                      </ex-clickable-chip>\n                    </ng-template>\n                  </ng-container>\n                </div>\n              </div>\n              <button *ngIf=\"isItemOpen\" class=\"ex-list-layout-hidden-button\" (keyup.Tab)=\"moveFocusToRightSide($event)\"\n                      aria-label=\"move\n                focus to right side\"></button>\n            </div>\n            <div @expand *ngIf=\"openedSublist === i\">\n              <ex-expandable-sublist #subList [list]=\"item.sublists[sublistInd].list\"\n                                     [htmlId]=\"htmlId + '_'+openedSublist+'_sub'\"\n                                     [dynamicComponents]=\"dynamicComponents\"\n                                     [color]=\"item.sublists[sublistInd].color\" [(selectedItem)]=\"selectedItemInSublist\"\n                                     [hasMore]=\"item.sublists[sublistInd].hasMore\" (closeClicked)=\"closeClicked()\"\n                                     [title]=\"item.sublists[sublistInd].title\" (loadMoreSublist)=\"_loadMoreSublist()\"\n                                     [description]=\"item.sublists[sublistInd].description\">\n              </ex-expandable-sublist>\n            </div>\n          </li>\n        </ng-container>\n        <ex-pagination #paginationRef *ngIf=\"listProperties.pagination.totalItemsCount > 0\"\n                       [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\n                       [pageSize]=\"listProperties.pagination.pageSize\"\n                       [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\n                       [selectedPage]=\"listProperties.pagination.selectedPage\"\n                       (selectedPageChange)=\"_selectedPageChange($event)\"\n                       (pageSizeChange)=\"_pageSizeChange($event)\"\n                       (endOfPagination)=\"focusOnEndOfPage()\"></ex-pagination>\n      </ul>\n\n    </ex-drag-list>\n  </ng-container>\n\n  <div *ngIf=\"listProperties.isLoading || (!canSplitChecked && responsive)\" role=\"alert\"\n       class=\"ex-list-layout-hidden-button\">\n    {{'ng.ex-list-layout.loading_results' | translate}}</div>\n  <ng-container *ngIf=\"listProperties.isLoading || (!canSplitChecked && responsive)\">\n    <ng-container *ngIf=\"!listProperties.showSpinner; else spinner\">\n      <div (resized)=\"onLeftSideResized($event)\" class=\"ex-list-layout-list-wrapper\">\n        <div *ngFor=\"let dummy of ' '.repeat(placeHolderRows).split(''), let i = index\"\n             [@expanded]=\"animateRemoveIndex != i\">\n          <div mat-ripple matRippleColor=\"transparent\" class=\"ex-list-layout-row-item\" [ngClass]=\"{\n          'ex-list-layout-row-item-opened': openedSublist === i,\n          'ex-list-layout-row-item-disabled': (openedSublist !== i && openedSublist !== -1),\n          'ex-list-layout-large-density': listProperties.density === 'large'\n        }\">\n            <span *ngIf=\"listProperties.hasIndex\" class=\"ex-list-layout-index\">\n              {{ ((listProperties.pagination.selectedPage - 1) * (listProperties.pagination.pageSize) + i + 1) }}\n            </span>\n            <div class=\"ex-list-layout-content\">\n              <ex-record-placeholder [proto]=\"listProperties.proto\" [hasPickup]=\"listProperties.hasPickup\"\n                                     [emptyRowHeight]=\"listProperties.emptyRowHeight\">\n              </ex-record-placeholder>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-template #spinner>\n      <ex-spinner class=\"ex-list-spinner sel-list-spinner\" [diameter]=\"50\"></ex-spinner>\n    </ng-template>\n  </ng-container>\n</ng-template>\n<div #endOfList tabindex=\"0\" class=\"ex-list-layout-hidden-button\">{{ 'ng.list-layout.end_of_list' | translate }}</div>\n", styles: [".ex-list-layout-wrapper:focus{outline:0}.ex-list-layout-wrapper{display:grid;grid-template-rows:max-content 1fr;height:100%;position:relative}.ex-list-layout-wrapper .ex-list-layout-header-wrapper{overflow:hidden}.ex-list-layout-wrapper .ex-list-layout-content-wrapper{position:relative;overflow:auto}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side{height:100%;overflow:auto}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-left{overflow:auto;padding-inline-end:15px;height:100%}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right{height:100%;position:relative}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right ::ng-deep .ex-sections-layout-wrapper{margin-top:-43px}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right ::ng-deep .ex-sections-layout-wrapper .ex-sections-layout-sections-wrapper{padding-block-start:50px}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-in-place-layout-right-wrapper-full-page{padding-inline-start:25px}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-list-layout-right-wrapper{height:100%;overflow-y:auto}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-list-layout-right-wrapper .ex-list-layout-sections-menu{position:sticky;top:10px;height:100%;min-width:150px;padding-top:10px}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-list-layout-right-wrapper .ex-list-layout-sections-menu .ex-list-layout-sections-menu-item-active{padding-left:10px!important}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-list-layout-right-wrapper .ex-list-layout-sections-menu .ex-list-layout-sections-menu-item{padding-left:14px;background:transparent;border:none;text-align:start;display:flex;padding-top:5px;padding-bottom:5px}.ex-list-layout-wrapper .ex-list-layout-content-wrapper .ex-list-layout-side-by-side .ex-list-layout-right .ex-list-layout-right-wrapper .ex-list-layout-sections-menu .ex-list-layout-sections-menu-item ex-icon{margin-right:10px}.ex-list-layout-wrapper .ex-list-layout-li{display:block}.ex-list-layout-wrapper .ex-list-layout-content-wrapper-no-header{height:100%}.ex-list-layout-wrapper .ex-list-layout-list-wrapper{height:100%;margin-bottom:0;padding-bottom:10px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-hover-left-indication{cursor:pointer}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item:focus{border-top:1px solid black;border-inline-end:1px solid black;border-bottom:1px solid black}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item{border-top:1px solid transparent;border-inline-end:1px solid transparent;display:flex;flex-direction:row;padding:10px;outline:0}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item:hover{background:#f4f8fa}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-drag-mode-wrapper{display:flex;flex-direction:column;align-items:center}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-drag-and-drop{cursor:move;margin-right:10px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-index{margin-right:10px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-pickup{width:24px;margin-right:10px;display:flex;flex-direction:column;text-align:center}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-pickup .ex-list-layout-warning-icon,.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-pickup .ex-list-layout-valid-icon,.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-pickup .ex-list-layout-suppress-icon{margin-top:5px!important}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-content{flex:1}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-content .ex-list-layout-sublist-bubbles{display:flex;flex-direction:row;align-items:center;margin-left:47px;margin-top:5px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-content .ex-list-layout-sublist-bubbles .ex-list-layout-bubbles{margin-right:10px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item .ex-list-layout-content .ex-list-layout-sublist-bubbles .ex-list-layout-not-selected-bubbles{opacity:.7}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item-dark-theme{background:#3f4348;color:#d8d8d8;border-bottom-color:#ebebeb4a}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item-dark-theme:hover{background:#4a4e53}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item-dark-theme mark{background-color:#555;color:#fff}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item-disabled{pointer-events:none;background:#eee;opacity:.2}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-row-item-opened{border-top:1px solid #d0cfcf}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-large-density{padding:10px}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-disabled-content{pointer-events:none}.ex-list-layout-wrapper .ex-list-layout-list-wrapper .ex-list-layout-disabled-row-item{opacity:.3}.ex-list-layout-wrapper .ex-list-layout-header{display:flex;position:sticky;top:0;width:calc(100% - 15px);justify-content:flex-end;height:43px;z-index:10}.ex-list-layout-grid-rows-no-header{grid-template-rows:1fr}.ex-list-layout-spinner-wrapper{position:relative;height:100%;width:100%}.ex-list-layout-spinner{position:absolute;top:50%;left:50%}.ex-list-layout-no-records-found-placeholder{width:100%;padding-top:15px;padding-bottom:14px;top:0;z-index:2;background-color:#fff}.ex-list-layout-no-records-flex-and-center{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:calc(100% - 47px)}.ex-list-layout-no-records-flex-and-center .ex-list-layout-no-records-icon{margin-bottom:10px}.ex-list-layout-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}.ex-list-spinner{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;min-height:50vh}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-list-layout-hidden-button{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none}.ex-list-layout-header-toggle-div{display:grid;grid-template-areas:\"left right\"}.ex-list-layout-header-title-wrapper{margin-top:10px;display:flex;align-content:center}.ex-list-layout-header-title-wrapper .ex-list-layout-main-header-back-button{border:0px;padding:0 10px;width:35px}.ex-list-layout-header-title-wrapper .ex-list-layout-main-header-back-button i{margin-right:20px}.ex-list-layout-header-title-wrapper .ex-list-layout-main-header-back-button:hover{cursor:pointer}.ex-list-layout-header-title-wrapper .ex-list-layout-primary-title{display:flex}.ex-list-layout-header-title-wrapper .ex-list-layout-primary-title h2{color:#474747;margin:0;align-self:center}.ex-list-layout-expand-collapse-wrapper{display:flex;align-items:center;justify-content:center}.ex-list-layout-expand-collapse-wrapper .ex-list-layout-expand-collapse-icon{width:25px;height:50px;border-top-left-radius:51px;border-bottom-left-radius:51px;border:1px solid #ccc;border-right:0;display:flex;align-items:center;justify-content:center;margin-left:-25px;z-index:10;background:#fff}.ex-list-layout-expand-collapse-wrapper .ex-list-layout-expand-collapse-icon:hover ::ng-deep ex-icon i{color:#fff!important}.ex-list-layout-expand-collapse-wrapper-rotate .ex-list-layout-expand-collapse-icon{transform:rotate(180deg);margin-left:0;border-right:1px solid #ccc;margin-right:-25px}\n"] }]
    }], function () { return [{ type: i1$5.Location }, { type: ExSectionsLayoutListLayoutService }, { type: i3$2.Router }, { type: ExSidenavPageService, decorators: [{
                type: Optional
            }] }, { type: ExItemsLayoutService }]; }, { selectedItem: [{
            type: Input
        }], checkedItems: [{
            type: Input
        }], animateRemoveIndex: [{
            type: Input
        }], hasCustomization: [{
            type: Input
        }], customizationComponent: [{
            type: Input
        }], isCustomized: [{
            type: Input
        }], isRtl: [{
            type: Input
        }], responsive: [{
            type: Input
        }], recordCustomizationData: [{
            type: Input
        }], isSplitScreen: [{
            type: Input
        }], customizationClicked: [{
            type: Output
        }], gutterDragEnd: [{
            type: Output
        }], splitChange: [{
            type: Output
        }], openUserResponsiveMenu: [{
            type: Output
        }], noResultsTemplate: [{
            type: Input
        }], deepLinkModeTemplate: [{
            type: Input
        }], expandActionsOnAllSpaceFlag: [{
            type: Input
        }], isSecondarySearchFlagActive: [{
            type: Input
        }], persistentSearchText: [{
            type: Input
        }], listWrapper: [{
            type: ViewChild,
            args: ['listWrapper']
        }], listRef: [{
            type: ViewChild,
            args: ['listRef']
        }], rightSideRef: [{
            type: ViewChild,
            args: ['rightSideRef']
        }], rowItemRef: [{
            type: ViewChildren,
            args: ['rowItemRef']
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }], endOfList: [{
            type: ViewChild,
            args: ['endOfList']
        }], subListRef: [{
            type: ViewChild,
            args: ['subList']
        }], sideBySide: [{
            type: ViewChild,
            args: [ExSideBySideComponent]
        }], onPopState: [{
            type: HostListener,
            args: ['window:popstate', ['$event']]
        }] }); })();

class ExChipRecordModule {
    static { this.ɵfac = function ExChipRecordModule_Factory(t) { return new (t || ExChipRecordModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExChipRecordModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExChipModule,
            ExIconModule,
            MatTooltipModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExChipRecordModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExChipModule,
                    ExIconModule,
                    MatTooltipModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExChipRecordComponent,
                    ExChipRecordEntityLabelsComponent
                ],
                exports: [
                    ExChipRecordComponent,
                    ExChipRecordEntityLabelsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExChipRecordModule, { declarations: [ExChipRecordComponent,
        ExChipRecordEntityLabelsComponent], imports: [CommonModule,
        ExChipModule,
        ExIconModule,
        MatTooltipModule,
        ExDirectivesModule], exports: [ExChipRecordComponent,
        ExChipRecordEntityLabelsComponent] }); })();

const _c0$j = ["*"];
class ExSectionComponent {
    set viewMode(mode) {
        this._viewMode = mode;
        this._viewModeSubject.next(this._viewMode);
    }
    get viewMode() {
        return this._viewMode;
    }
    constructor(sectionLayoutViewMode, sectionLayoutViewModeObservable, newSectionsDesign, exSectionsLayoutService, isSingleSave, elRef) {
        this.sectionLayoutViewMode = sectionLayoutViewMode;
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.newSectionsDesign = newSectionsDesign;
        this.exSectionsLayoutService = exSectionsLayoutService;
        this.isSingleSave = isSingleSave;
        this.elRef = elRef;
        this._viewMode = undefined;
        this._viewModeSubject = new BehaviorSubject(false);
        this.viewModeSubject$ = this._viewModeSubject.asObservable();
        this._subs = new Subscription();
        this.editMode = undefined;
        this.isSingleSave && this.newSectionsDesign && this.initSingleSaveListeners();
    }
    initSingleSaveListeners() {
        this._subs.add(this.exSectionsLayoutService.sectionsEditMode$.subscribe((editMode) => {
            this.editMode = editMode;
        }));
    }
    getIsFirstSection() {
        return !this.elRef?.nativeElement?.parentElement?.classList?.contains('mat-expansion-panel-body');
    }
    ngOnDestroy() {
        this._subs.unsubscribe();
    }
    static { this.ɵfac = function ExSectionComponent_Factory(t) { return new (t || ExSectionComponent)(i0.ɵɵdirectiveInject(VIEW_MODE, 12), i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 12), i0.ɵɵdirectiveInject(NEW_SECTIONS_DESIGN, 12), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(IS_SINGLE_SAVE, 8), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSectionComponent, selectors: [["ex-section"]], inputs: { viewMode: "viewMode" }, features: [i0.ɵɵProvidersFeature([
                ExSectionsLayoutSectionService,
                {
                    provide: VIEW_MODE,
                    useFactory: (section) => {
                        return () => (section.viewMode !== undefined && section.viewMode !== null) ? section.viewMode : section.sectionLayoutViewMode();
                    },
                    deps: [ExSectionComponent]
                },
                {
                    provide: VIEW_MODE_OBSERVABLE,
                    useFactory: (section) => {
                        return iif(() => section.viewMode !== undefined && section.viewMode !== null, section.isSingleSave ?
                            combineLatest([section.viewModeSubject$, section.exSectionsLayoutService.sectionsEditMode$]).pipe(map$1(([sectionsViewMode, singleSaveEditMode]) => {
                                return !singleSaveEditMode || sectionsViewMode;
                            }))
                            : section.viewModeSubject$, section.sectionLayoutViewModeObservable);
                    },
                    deps: [ExSectionComponent]
                },
                { provide: EX_QUICK_ACCESS_SCOPE, useFactory: (section) => { return !section?.isSingleSave; },
                    deps: [ExSectionComponent] }
            ])], ngContentSelectors: _c0$j, decls: 3, vars: 12, template: function ExSectionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div")(1, "div");
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassProp("ex-section-view", ctx.editMode == false && ctx.newSectionsDesign)("ex-section-edit", ctx.editMode == true && ctx.newSectionsDesign)("ex-section-not-in-single-save", ctx.editMode == undefined && ctx.newSectionsDesign)("ex-section-wrapper", ctx.newSectionsDesign)("first", ctx.newSectionsDesign && ctx.getIsFirstSection());
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("ex-section-content-wrapper", (ctx.editMode == false || ctx.editMode == undefined) && ctx.newSectionsDesign && !ctx.getIsFirstSection());
        } }, styles: ["[_nghost-%COMP%]{display:block}.ex-section-content-wrapper[_ngcontent-%COMP%]{border:1px solid transparent!important;border-radius:0 0 4px 4px!important;background-color:transparent;padding:15px;cursor:default!important}.ex-section-content-wrapper[_ngcontent-%COMP%]:hover{border:1px solid rgba(14,124,187,.3019607843)!important;cursor:pointer}.ex-section-content-wrapper[_ngcontent-%COMP%]:focus, .ex-section-content-wrapper[_ngcontent-%COMP%]:focus-within{border:1px solid #0E7CBB!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first){border:1px solid rgba(196,196,196,.5019607843)!important;border-radius:0 0 4px 4px!important;background-color:#eaf2f6;cursor:default!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first):hover{border:1px solid rgba(14,124,187,.3019607843)!important;cursor:pointer}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first):focus, .ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first):focus-within{border:1px solid #0E7CBB!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)){padding-inline-start:12px;padding-bottom:2px;padding-inline-end:2px}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)).editing-list-wrapper-odd{border-bottom:1px solid rgba(196,196,196,.5019607843);border-top:1px solid rgba(196,196,196,.5019607843)}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)):not(.editing-list-wrapper-odd):last-of-type{border-bottom:1px solid rgba(196,196,196,.5019607843)}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-view-mode:not(.has-edit){border:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-view-mode:not(.has-edit):hover{border:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-view-mode:not(.has-edit):focus{border:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-edit-button{border-radius:3px;border:1px solid rgba(196,196,196,.5019607843)!important;padding:2px 9PX!important;background-color:#eee!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-edit-button:hover{background-color:#ddd!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   ex-right-click-actions{margin-bottom:0!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-entry-prefix-wrapper{width:10px}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .editing-list-line-wrapper{display:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(:has(  alma-notes-view,   alma-notes-edit)).has-edit{background:#dde4e8!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(:has(  alma-notes-view,   alma-notes-edit)).has-edit:hover{border:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(:has(  alma-notes-view,   alma-notes-edit)).has-edit   ex-float-label .ex-inline-editing-view-mode{background:#fff!important;border:2px solid #cccccc!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode{background:#fff!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     td:not(:has(  ex-inline-editing)){align-items:center;display:flex}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-close-icon{color:#1079b3!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-close-button{inset-block-start:10px!important;inset-inline-end:5px!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-button{top:0!important;inset-block-start:10px!important;inset-inline-end:5px!important}.ex-section-not-in-single-save.first[_ngcontent-%COMP%]     .ex-inline-editing-view-mode.has-edit:hover{border:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:has(  alma-notes-view)   .ex-inline-editing-edit-expand-button{display:none!important}.ex-section-not-in-single-save[_ngcontent-%COMP%]:has(  alma-notes-view)   .ex-inline-editing-view-mode:not(.has-edit){pointer-events:none}.ex-section-view[_ngcontent-%COMP%]:not(.first){border:1px solid rgba(196,196,196,.5019607843)!important;border-radius:0 0 4px 4px!important;background-color:#eaf2f6;cursor:default!important}.ex-section-view[_ngcontent-%COMP%]:not(.first):hover{border:1px solid rgba(14,124,187,.3019607843)!important}.ex-section-view[_ngcontent-%COMP%]:not(.first):focus, .ex-section-view[_ngcontent-%COMP%]:not(.first):focus-within{border:1px solid #0E7CBB!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(ex-label-combobox .ex-inline-editing-view-mode){border:none!important;padding:0!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(ex-label-combobox .ex-inline-editing-view-mode):not(:has(  alma-notes-view)){background:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode){border:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode):not(:has(  alma-notes-edit)){background:none!important;padding:0}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-button{display:none}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-readonly.ex-inline-editing-edit-mode{cursor:default!important;padding-top:20px!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-close-button{display:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-editing-list-no-entities-flex-and-center{background:inherit!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)){padding:7px 2px 2px 10px;border-radius:4px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)):hover{border:2px solid rgba(14,124,187,.3019607843)!important;padding:5px 0 0 8px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)):has(.ex-inline-editing-view-mode){border:1px solid transparent;box-shadow:0 0 0 1px transparent;border-top:1px solid #ccc;border-radius:0}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit)):has(.ex-inline-editing-view-mode):hover{padding:7px 2px 2px 10px;border:1px solid rgba(14,124,187,.3019607843)!important;box-shadow:0 0 0 1px #0e7cbb4d;border-radius:4px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-view-mode{background:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-edit-expand-button{inset-block-start:20px;inset-inline-end:15px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view,   alma-notes-edit))   .ex-inline-editing-collapse-button{inset-block-start:20px;inset-inline-end:15px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:has(  alma-notes-view)   .ex-inline-editing-edit-expand-button{display:none!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     .editing-list:has(  alma-notes-view)   .ex-inline-editing-view-mode:not(.has-edit){pointer-events:none}.ex-section-view[_ngcontent-%COMP%]:not(.first)     ex-editing-list   .ex-inline-editing-readonly:not(ex-label-combobox .ex-inline-editing-view-mode){padding-top:16px!important}.ex-section-view[_ngcontent-%COMP%]:not(.first)     ex-editing-list   .ex-editing-list-index{padding-top:7px}.ex-section-view[_ngcontent-%COMP%]:not(.first)     ex-editing-list   .editing-list-image-wrapper{padding-top:7px!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first){border:2px solid rgba(14,124,187,.3019607843)!important;border-radius:0 0 4px 4px!important;padding:30px 16px 16px!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first):focus, .ex-section-edit[_ngcontent-%COMP%]:not(.first):focus-within{border:2px solid #0E7CBB!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-view-mode:not(:has(  alma-notes-view)):not(ex-label-combobox .ex-inline-editing-view-mode){padding:0!important;border:none!important;box-shadow:none!important;background:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode){border:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode).ex-inline-editing-main-entity{padding:0!important;box-shadow:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode).ex-inline-editing-main-entity:not(:has(  alma-notes-edit)){background:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-inline-editing-collapse-button{display:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)){padding:7px 2px 7px 10px;border-radius:4px}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)):hover{border:2px solid rgba(14,124,187,.3019607843)!important;padding:5px 0 5px 8px}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)):has(.ex-inline-editing-view-mode){background-color:#eaf2f6;border:1px solid transparent;box-shadow:0 0 0 1px transparent;border-top:1px solid #ccc;border-radius:0}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)):has(.ex-inline-editing-view-mode):hover{padding:7px 2px 7px 10px;border:1px solid rgba(14,124,187,.3019607843)!important;box-shadow:0 0 0 1px #0e7cbb4d;border-radius:4px}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view))   .ex-inline-editing-view-mode{background:none!important;margin-top:4px}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)):has(.ex-inline-editing-edit-mode){background-color:#fff!important;border:2px solid #0E7CBB!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view)):has(.ex-inline-editing-edit-mode):hover{padding:7px 2px 7px 10px!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view))   ex-right-click-actions{margin-bottom:0!important;margin-top:0!important}.ex-section-edit[_ngcontent-%COMP%]:not(.first)     .editing-list:not(:has(  alma-notes-view))   .ex-close-icon{color:#0e7cbb}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionComponent, [{
        type: Component,
        args: [{ selector: 'ex-section', providers: [
                    ExSectionsLayoutSectionService,
                    {
                        provide: VIEW_MODE,
                        useFactory: (section) => {
                            return () => (section.viewMode !== undefined && section.viewMode !== null) ? section.viewMode : section.sectionLayoutViewMode();
                        },
                        deps: [ExSectionComponent]
                    },
                    {
                        provide: VIEW_MODE_OBSERVABLE,
                        useFactory: (section) => {
                            return iif(() => section.viewMode !== undefined && section.viewMode !== null, section.isSingleSave ?
                                combineLatest([section.viewModeSubject$, section.exSectionsLayoutService.sectionsEditMode$]).pipe(map$1(([sectionsViewMode, singleSaveEditMode]) => {
                                    return !singleSaveEditMode || sectionsViewMode;
                                }))
                                : section.viewModeSubject$, section.sectionLayoutViewModeObservable);
                        },
                        deps: [ExSectionComponent]
                    },
                    { provide: EX_QUICK_ACCESS_SCOPE, useFactory: (section) => { return !section?.isSingleSave; },
                        deps: [ExSectionComponent]
                    }
                ], template: "<div [class.ex-section-view] = \"editMode == false && newSectionsDesign\" [class.ex-section-edit] = \"editMode == true && newSectionsDesign\" [class.ex-section-not-in-single-save] = \"editMode == undefined && newSectionsDesign\" [class.ex-section-wrapper]=\"newSectionsDesign\" [class.first]=\"newSectionsDesign && getIsFirstSection()\">\r\n  <div [class.ex-section-content-wrapper]=\"(editMode == false || editMode == undefined) && newSectionsDesign && !getIsFirstSection()\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [":host{display:block}.ex-section-content-wrapper{border:1px solid transparent!important;border-radius:0 0 4px 4px!important;background-color:transparent;padding:15px;cursor:default!important}.ex-section-content-wrapper:hover{border:1px solid rgba(14,124,187,.3019607843)!important;cursor:pointer}.ex-section-content-wrapper:focus,.ex-section-content-wrapper:focus-within{border:1px solid #0E7CBB!important}.ex-section-not-in-single-save:not(.first){border:1px solid rgba(196,196,196,.5019607843)!important;border-radius:0 0 4px 4px!important;background-color:#eaf2f6;cursor:default!important}.ex-section-not-in-single-save:not(.first):hover{border:1px solid rgba(14,124,187,.3019607843)!important;cursor:pointer}.ex-section-not-in-single-save:not(.first):focus,.ex-section-not-in-single-save:not(.first):focus-within{border:1px solid #0E7CBB!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)){padding-inline-start:12px;padding-bottom:2px;padding-inline-end:2px}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)).editing-list-wrapper-odd{border-bottom:1px solid rgba(196,196,196,.5019607843);border-top:1px solid rgba(196,196,196,.5019607843)}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)):not(.editing-list-wrapper-odd):last-of-type{border-bottom:1px solid rgba(196,196,196,.5019607843)}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-view-mode:not(.has-edit){border:none!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-view-mode:not(.has-edit):hover{border:none!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-view-mode:not(.has-edit):focus{border:none!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-edit-button{border-radius:3px;border:1px solid rgba(196,196,196,.5019607843)!important;padding:2px 9PX!important;background-color:#eee!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-edit-button:hover{background-color:#ddd!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep ex-right-click-actions{margin-bottom:0!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-entry-prefix-wrapper{width:10px}.ex-section-not-in-single-save:not(.first) ::ng-deep .editing-list-line-wrapper{display:none!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)).has-edit{background:#dde4e8!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)).has-edit:hover{border:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)).has-edit ::ng-deep ex-float-label .ex-inline-editing-view-mode{background:#fff!important;border:2px solid #cccccc!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-edit-mode{background:#fff!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-not-in-single-save:not(.first) ::ng-deep td:not(:has(::ng-deep ex-inline-editing)){align-items:center;display:flex}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-close-icon{color:#1079b3!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-close-button{inset-block-start:10px!important;inset-inline-end:5px!important}.ex-section-not-in-single-save:not(.first) ::ng-deep .ex-inline-editing-edit-button{top:0!important;inset-block-start:10px!important;inset-inline-end:5px!important}.ex-section-not-in-single-save.first ::ng-deep .ex-inline-editing-view-mode.has-edit:hover{border:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-not-in-single-save:has(::ng-deep alma-notes-view) ::ng-deep .ex-inline-editing-edit-expand-button{display:none!important}.ex-section-not-in-single-save:has(::ng-deep alma-notes-view) ::ng-deep .ex-inline-editing-view-mode:not(.has-edit){pointer-events:none}.ex-section-view:not(.first){border:1px solid rgba(196,196,196,.5019607843)!important;border-radius:0 0 4px 4px!important;background-color:#eaf2f6;cursor:default!important}.ex-section-view:not(.first):hover{border:1px solid rgba(14,124,187,.3019607843)!important}.ex-section-view:not(.first):focus,.ex-section-view:not(.first):focus-within{border:1px solid #0E7CBB!important}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(ex-label-combobox .ex-inline-editing-view-mode){border:none!important;padding:0!important}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(ex-label-combobox .ex-inline-editing-view-mode):not(:has(::ng-deep alma-notes-view)){background:none!important}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode){border:none!important}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode):not(:has(::ng-deep alma-notes-edit)){background:none!important;padding:0}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-edit-button{display:none}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-readonly.ex-inline-editing-edit-mode{cursor:default!important;padding-top:20px!important}.ex-section-view:not(.first) ::ng-deep .ex-inline-editing-close-button{display:none!important}.ex-section-view:not(.first) ::ng-deep .ex-editing-list-no-entities-flex-and-center{background:inherit!important}.ex-section-view:not(.first) ::ng-deep .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-view:not(.first) ::ng-deep .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-view:not(.first) ::ng-deep .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)){padding:7px 2px 2px 10px;border-radius:4px}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)):hover{border:2px solid rgba(14,124,187,.3019607843)!important;padding:5px 0 0 8px}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)):has(.ex-inline-editing-view-mode){border:1px solid transparent;box-shadow:0 0 0 1px transparent;border-top:1px solid #ccc;border-radius:0}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)):has(.ex-inline-editing-view-mode):hover{padding:7px 2px 2px 10px;border:1px solid rgba(14,124,187,.3019607843)!important;box-shadow:0 0 0 1px #0e7cbb4d;border-radius:4px}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-view-mode{background:none!important}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-edit-expand-button{inset-block-start:20px;inset-inline-end:15px}.ex-section-view:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view,::ng-deep alma-notes-edit)) ::ng-deep .ex-inline-editing-collapse-button{inset-block-start:20px;inset-inline-end:15px}.ex-section-view:not(.first) ::ng-deep .editing-list:has(::ng-deep alma-notes-view) ::ng-deep .ex-inline-editing-edit-expand-button{display:none!important}.ex-section-view:not(.first) ::ng-deep .editing-list:has(::ng-deep alma-notes-view) ::ng-deep .ex-inline-editing-view-mode:not(.has-edit){pointer-events:none}.ex-section-view:not(.first) ::ng-deep ex-editing-list ::ng-deep .ex-inline-editing-readonly:not(ex-label-combobox .ex-inline-editing-view-mode){padding-top:16px!important}.ex-section-view:not(.first) ::ng-deep ex-editing-list ::ng-deep .ex-editing-list-index{padding-top:7px}.ex-section-view:not(.first) ::ng-deep ex-editing-list ::ng-deep .editing-list-image-wrapper{padding-top:7px!important}.ex-section-edit:not(.first){border:2px solid rgba(14,124,187,.3019607843)!important;border-radius:0 0 4px 4px!important;padding:30px 16px 16px!important}.ex-section-edit:not(.first):focus,.ex-section-edit:not(.first):focus-within{border:2px solid #0E7CBB!important}.ex-section-edit:not(.first) ::ng-deep .ex-inline-editing-view-mode:not(:has(::ng-deep alma-notes-view)):not(ex-label-combobox .ex-inline-editing-view-mode){padding:0!important;border:none!important;box-shadow:none!important;background:none!important}.ex-section-edit:not(.first) ::ng-deep .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode){border:none!important}.ex-section-edit:not(.first) ::ng-deep .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode).ex-inline-editing-main-entity{padding:0!important;box-shadow:none!important}.ex-section-edit:not(.first) ::ng-deep .ex-inline-editing-edit-mode:not(ex-label-combobox .ex-inline-editing-edit-mode).ex-inline-editing-main-entity:not(:has(::ng-deep alma-notes-edit)){background:none!important}.ex-section-edit:not(.first) ::ng-deep .ex-inline-editing-collapse-button{display:none!important}.ex-section-edit:not(.first) ::ng-deep .ex-grid-layout-odd-row:not(.ex-grid-layout-has-custom-background-color){background:#fff!important}.ex-section-edit:not(.first) ::ng-deep .ex-grid-layout-table-wrapper-border{border-top:2px solid rgba(14,124,187,.3019607843)!important;border-bottom:2px solid rgba(14,124,187,.3019607843)!important}.ex-section-edit:not(.first) ::ng-deep .ex-grid-layout-table-bottom-border{border-bottom:none!important}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)){padding:7px 2px 7px 10px;border-radius:4px}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)):hover{border:2px solid rgba(14,124,187,.3019607843)!important;padding:5px 0 5px 8px}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)):has(.ex-inline-editing-view-mode){background-color:#eaf2f6;border:1px solid transparent;box-shadow:0 0 0 1px transparent;border-top:1px solid #ccc;border-radius:0}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)):has(.ex-inline-editing-view-mode):hover{padding:7px 2px 7px 10px;border:1px solid rgba(14,124,187,.3019607843)!important;box-shadow:0 0 0 1px #0e7cbb4d;border-radius:4px}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)) ::ng-deep .ex-inline-editing-view-mode{background:none!important;margin-top:4px}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)):has(.ex-inline-editing-edit-mode){background-color:#fff!important;border:2px solid #0E7CBB!important}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)):has(.ex-inline-editing-edit-mode):hover{padding:7px 2px 7px 10px!important}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)) ::ng-deep ex-right-click-actions{margin-bottom:0!important;margin-top:0!important}.ex-section-edit:not(.first) ::ng-deep .editing-list:not(:has(::ng-deep alma-notes-view)) ::ng-deep .ex-close-icon{color:#0e7cbb}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [VIEW_MODE]
            }] }, { type: i1$3.Observable, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [NEW_SECTIONS_DESIGN]
            }] }, { type: ExSectionsLayoutService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [IS_SINGLE_SAVE]
            }] }, { type: i0.ElementRef }]; }, { viewMode: [{
            type: Input
        }] }); })();

function ExSectionPlaceholderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
function ExSectionPlaceholderComponent_ng_container_2_ex_thumbnail_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-thumbnail", 19);
} if (rf & 2) {
    i0.ɵɵproperty("showPlaceholder", true)("fixedWidth", 100);
} }
function ExSectionPlaceholderComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, ExSectionPlaceholderComponent_ng_container_2_ex_thumbnail_2_Template, 1, 2, "ex-thumbnail", 6);
    i0.ɵɵelementStart(3, "div", 7)(4, "div", 8);
    i0.ɵɵelement(5, "span", 9)(6, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵelement(8, "span", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 13);
    i0.ɵɵelement(10, "span", 14)(11, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 16)(13, "div", 17);
    i0.ɵɵelement(14, "span", 14)(15, "span", 18)(16, "span", 18)(17, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 17);
    i0.ɵɵelement(19, "span", 14)(20, "span", 18)(21, "span", 18)(22, "span", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showThumbnail);
} }
function ExSectionPlaceholderComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 7)(2, "div", 8);
    i0.ɵɵelement(3, "span", 9)(4, "span", 10);
    i0.ɵɵelementEnd()()();
} }
class ExSectionPlaceholderComponent {
    constructor() {
        this.active = false;
        this.showThumbnail = false;
        this.isExpanded = true;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ExSectionPlaceholderComponent_Factory(t) { return new (t || ExSectionPlaceholderComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSectionPlaceholderComponent, selectors: [["ex-section-placeholder"]], inputs: { active: "active", showThumbnail: "showThumbnail", isExpanded: "isExpanded" }, decls: 5, vars: 3, consts: [[1, "ex-section-placeholder-wrapper-ph", "sel-loading"], ["class", "ex-section-placeholder-ph-animate", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["isCollapsedTemplate", ""], [1, "ex-section-placeholder-ph-animate"], [1, "ex-section-placeholder-header-ph"], [3, "showPlaceholder", "fixedWidth", 4, "ngIf"], [1, "ex-section-placeholder-summary-ph"], [1, "ex-section-placeholder-top-ph"], [1, "ex-section-placeholder-title-placeholder", "greyer-ph", "ph", "large-ph"], [1, "ex-section-placeholder-subtitle-placeholder", "ph", "grey-ph"], [1, "ex-section-placeholder-bottom-ph"], [1, "ex-section-placeholder-price-and-currency-placeholder", "ph", "grey-ph"], [1, "ex-section-placeholder-description-ph"], [1, "ex-section-placeholder-title-placeholder", "greyer-ph", "ph"], [1, "ex-section-placeholder-description-placeholder", "ph", "grey-ph"], [1, "ex-section-placeholder-responsive-ph"], [1, "ex-section-placeholder-edition-ph"], [1, "ex-section-placeholder-line-placeholder", "ph", "grey-ph"], [3, "showPlaceholder", "fixedWidth"]], template: function ExSectionPlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExSectionPlaceholderComponent_div_1_Template, 1, 0, "div", 1);
            i0.ɵɵtemplate(2, ExSectionPlaceholderComponent_ng_container_2_Template, 23, 1, "ng-container", 2);
            i0.ɵɵtemplate(3, ExSectionPlaceholderComponent_ng_template_3_Template, 5, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(4);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.active);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isExpanded)("ngIfElse", _r2);
        } }, dependencies: [i1$5.NgIf, ExThumbnailComponent], styles: [".ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]{position:relative}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-header-ph[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-header-ph[_ngcontent-%COMP%]   .ex-section-placeholder-summary-ph[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column;padding-top:5px;justify-content:space-between}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-header-ph[_ngcontent-%COMP%]   .ex-section-placeholder-summary-ph[_ngcontent-%COMP%]   .ex-section-placeholder-top-ph[_ngcontent-%COMP%], .ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-header-ph[_ngcontent-%COMP%]   .ex-section-placeholder-summary-ph[_ngcontent-%COMP%]   .ex-section-placeholder-bottom-ph[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-description-ph[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-bottom:25px;margin-top:25px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-responsive-ph[_ngcontent-%COMP%]{display:flex;flex:1;flex-wrap:wrap;flex-direction:row}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-responsive-ph[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:nowrap}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-responsive-ph[_ngcontent-%COMP%]   .ex-section-placeholder-edition-ph[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column;margin-bottom:25px;margin-right:25px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-title-placeholder[_ngcontent-%COMP%]{width:70px;height:19px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-line-placeholder[_ngcontent-%COMP%]{max-width:150px;height:13px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-subtitle-placeholder[_ngcontent-%COMP%]{max-width:140px;height:14px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-price-and-currency-placeholder[_ngcontent-%COMP%]{width:109px;height:14px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .grey-ph[_ngcontent-%COMP%]{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .greyer-ph[_ngcontent-%COMP%]{background:#ececec 0% 0% no-repeat padding-box}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ph[_ngcontent-%COMP%]{border-radius:3px;opacity:1;margin:5px}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .large-ph[_ngcontent-%COMP%]{max-width:314px;width:100%}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-description-placeholder[_ngcontent-%COMP%]{max-width:461px;height:14px;background:#f3f5f4 0% 0% no-repeat padding-box;border-radius:3px;opacity:1}.ex-section-placeholder-wrapper-ph[_ngcontent-%COMP%]   .ex-section-placeholder-ph-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;inset:0;position:absolute}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionPlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'ex-section-placeholder', template: "<div class=\"ex-section-placeholder-wrapper-ph sel-loading\">\n    <div *ngIf=\"active\" class=\"ex-section-placeholder-ph-animate\"></div>\n    <ng-container *ngIf=\"isExpanded; else isCollapsedTemplate\">\n      <div class=\"ex-section-placeholder-header-ph\">\n          <ex-thumbnail *ngIf=\"showThumbnail\" [showPlaceholder]=\"true\" [fixedWidth]=\"100\"></ex-thumbnail>\n          <div class=\"ex-section-placeholder-summary-ph\">\n              <div class=\"ex-section-placeholder-top-ph\">\n                  <span class=\"ex-section-placeholder-title-placeholder greyer-ph ph large-ph\"></span>\n                  <span class=\"ex-section-placeholder-subtitle-placeholder ph grey-ph\"></span>\n              </div>\n              <div class=\"ex-section-placeholder-bottom-ph\">\n                  <span class=\"ex-section-placeholder-price-and-currency-placeholder ph grey-ph\">\n                  </span>\n              </div>\n          </div>\n      </div>\n      <div class=\"ex-section-placeholder-description-ph\">\n          <span class=\"ex-section-placeholder-title-placeholder greyer-ph ph\"></span>\n          <span class=\"ex-section-placeholder-description-placeholder ph grey-ph\"></span>\n      </div>\n      <div class=\"ex-section-placeholder-responsive-ph\">\n          <div class=\"ex-section-placeholder-edition-ph\">\n              <span class=\"ex-section-placeholder-title-placeholder greyer-ph ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n          </div>\n          <div class=\"ex-section-placeholder-edition-ph\">\n              <span class=\"ex-section-placeholder-title-placeholder greyer-ph ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n              <span class=\"ex-section-placeholder-line-placeholder ph grey-ph\"></span>\n          </div>\n      </div>\n    </ng-container>\n    <ng-template #isCollapsedTemplate>\n      <div class=\"ex-section-placeholder-header-ph\">\n            <div class=\"ex-section-placeholder-summary-ph\">\n                  <div class=\"ex-section-placeholder-top-ph\">\n                      <span class=\"ex-section-placeholder-title-placeholder greyer-ph ph large-ph\"></span>\n                      <span class=\"ex-section-placeholder-subtitle-placeholder ph grey-ph\"></span>\n                  </div>\n              </div>\n          </div>\n    </ng-template>\n</div>\n", styles: [".ex-section-placeholder-wrapper-ph{position:relative}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-header-ph{display:flex;flex-direction:row}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-header-ph .ex-section-placeholder-summary-ph{display:flex;flex:1;flex-direction:column;padding-top:5px;justify-content:space-between}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-header-ph .ex-section-placeholder-summary-ph .ex-section-placeholder-top-ph,.ex-section-placeholder-wrapper-ph .ex-section-placeholder-header-ph .ex-section-placeholder-summary-ph .ex-section-placeholder-bottom-ph{display:flex;flex-direction:column}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-description-ph{display:flex;flex-direction:column;margin-bottom:25px;margin-top:25px}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-responsive-ph{display:flex;flex:1;flex-wrap:wrap;flex-direction:row}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-responsive-ph span{white-space:nowrap}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-responsive-ph .ex-section-placeholder-edition-ph{display:flex;flex:1;flex-direction:column;margin-bottom:25px;margin-right:25px}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-title-placeholder{width:70px;height:19px}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-line-placeholder{max-width:150px;height:13px}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-subtitle-placeholder{max-width:140px;height:14px}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-price-and-currency-placeholder{width:109px;height:14px}.ex-section-placeholder-wrapper-ph .grey-ph{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-section-placeholder-wrapper-ph .greyer-ph{background:#ececec 0% 0% no-repeat padding-box}.ex-section-placeholder-wrapper-ph .ph{border-radius:3px;opacity:1;margin:5px}.ex-section-placeholder-wrapper-ph .large-ph{max-width:314px;width:100%}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-description-placeholder{max-width:461px;height:14px;background:#f3f5f4 0% 0% no-repeat padding-box;border-radius:3px;opacity:1}.ex-section-placeholder-wrapper-ph .ex-section-placeholder-ph-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;inset:0;position:absolute}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}\n"] }]
    }], function () { return []; }, { active: [{
            type: Input
        }], showThumbnail: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }] }); })();

function ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " | ");
    i0.ɵɵelementEnd();
} }
function ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, s_r3.additionalInformationForCollapsedSidenav)));
} }
function ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " | ");
    i0.ɵɵelementEnd();
} }
function ExSummarySectionsCollapsedComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_6_Template, 2, 0, "span", 8);
    i0.ɵɵtemplate(7, ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_7_Template, 4, 5, "span", 9);
    i0.ɵɵtemplate(8, ExSummarySectionsCollapsedComponent_div_1_ng_container_3_span_8_Template, 2, 0, "span", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const s_r3 = ctx.$implicit;
    const index_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", s_r3.isTitleUpperCase ? i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind1(4, 6, s_r3.title)) : i0.ɵɵpipeBind1(5, 8, s_r3.title), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", index_r4 != ctx_r1.summarySections.length - 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", s_r3.additionalInformationForCollapsedSidenav);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", s_r3.additionalInformationForCollapsedSidenav);
} }
function ExSummarySectionsCollapsedComponent_div_1_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 12);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 1, "general.mandatory_information_is_missing"));
} }
function ExSummarySectionsCollapsedComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "ex-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExSummarySectionsCollapsedComponent_div_1_ng_container_3_Template, 9, 10, "ng-container", 5);
    i0.ɵɵtemplate(4, ExSummarySectionsCollapsedComponent_div_1_ex_svg_icon_4_Template, 2, 3, "ex-svg-icon", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("background", ctx_r0.summarySections == null ? null : ctx_r0.summarySections.first == null ? null : ctx_r0.summarySections.first.color);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconType", ctx_r0.summarySections == null ? null : ctx_r0.summarySections.first == null ? null : ctx_r0.summarySections.first.iconType)("iconName", ctx_r0.summarySections == null ? null : ctx_r0.summarySections.first == null ? null : ctx_r0.summarySections.first.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.summarySections);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showWarningIcon);
} }
class ExSummarySectionsCollapsedComponent {
    constructor() {
        this.showWarningIcon = false;
    }
    static { this.ɵfac = function ExSummarySectionsCollapsedComponent_Factory(t) { return new (t || ExSummarySectionsCollapsedComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSummarySectionsCollapsedComponent, selectors: [["ex-summary-sections-collapsed"]], inputs: { summarySections: "summarySections", showWarningIcon: "showWarningIcon" }, decls: 2, vars: 1, consts: [[1, "ex-summary-sections-collapsed-right-sidenav-sections"], ["class", "ex-summary-sections-collapsed-right-sidenav-sections-wrapper", 4, "ngIf"], [1, "ex-summary-sections-collapsed-right-sidenav-sections-wrapper"], [1, "ex-summary-sections-collapsed-right-sidenav-collapsed-icon"], ["color", "white", "sizePx", "18px", 3, "iconType", "iconName"], [4, "ngFor", "ngForOf"], ["iconName", "circ_warning", "color", "red", "size", "large", "class", "ex-summary-sections-collapsed-warning-icon sel-warning-sidenav", 3, "exTooltip", 4, "ngIf"], [1, "ex-summary-sections-collapsed-right-sidenav-collapsed-label", "ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive"], ["class", "ex-summary-sections-collapsed-right-sidenav-collapsed-label", 4, "ngIf"], ["class", "ex-summary-sections-collapsed-right-sidenav-collapsed-additional-label ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive", 4, "ngIf"], [1, "ex-summary-sections-collapsed-right-sidenav-collapsed-label"], [1, "ex-summary-sections-collapsed-right-sidenav-collapsed-additional-label", "ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive"], ["iconName", "circ_warning", "color", "red", "size", "large", 1, "ex-summary-sections-collapsed-warning-icon", "sel-warning-sidenav", 3, "exTooltip"]], template: function ExSummarySectionsCollapsedComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExSummarySectionsCollapsedComponent_div_1_Template, 5, 6, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.summarySections == null ? null : ctx.summarySections.length);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExIconComponent, ExSvgIconComponent, ExTooltipDirective, i1$5.UpperCasePipe, i1$2.TranslatePipe], styles: [".ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]{flex:1;height:100%}.ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-right-sidenav-sections-wrapper[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-warning-icon[_ngcontent-%COMP%], .ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-right-sidenav-collapsed-icon[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;padding:20px 0;cursor:pointer;width:100%}.ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-right-sidenav-collapsed-label[_ngcontent-%COMP%]{padding:10px;cursor:pointer;writing-mode:vertical-rl}.ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-right-sidenav-collapsed-additional-label[_ngcontent-%COMP%]{color:red;padding:10px;cursor:pointer;writing-mode:vertical-rl}.ex-summary-sections-collapsed-right-sidenav-sections[_ngcontent-%COMP%]   .ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive[_ngcontent-%COMP%]{flex-shrink:1;text-overflow:ellipsis;overflow:hidden;min-height:0;max-height:100%;white-space:nowrap}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSummarySectionsCollapsedComponent, [{
        type: Component,
        args: [{ selector: 'ex-summary-sections-collapsed', template: "<div class=\"ex-summary-sections-collapsed-right-sidenav-sections\">\r\n    <div class=\"ex-summary-sections-collapsed-right-sidenav-sections-wrapper\" *ngIf=\"summarySections?.length\">\r\n        <div [style.background]=\"summarySections?.first?.color\"\r\n            class=\"ex-summary-sections-collapsed-right-sidenav-collapsed-icon\">\r\n            <ex-icon [iconType]=\"summarySections?.first?.iconType\" [iconName]=\"summarySections?.first?.iconName\"\r\n                color=\"white\" sizePx=\"18px\"></ex-icon>\r\n        </div>\r\n        <ng-container *ngFor=\"let s of summarySections; let index = index\">\r\n            <span\r\n                class=\"ex-summary-sections-collapsed-right-sidenav-collapsed-label ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive\">{{ s.isTitleUpperCase ? (s.title | translate | uppercase) : (s.title | translate) }}\r\n            </span>\r\n            <span *ngIf=\"index != summarySections.length - 1\"\r\n                class=\"ex-summary-sections-collapsed-right-sidenav-collapsed-label\"> |\r\n            </span>\r\n            <span *ngIf=\"s.additionalInformationForCollapsedSidenav\"\r\n                class=\"ex-summary-sections-collapsed-right-sidenav-collapsed-additional-label ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive\">{{ s.additionalInformationForCollapsedSidenav | translate | uppercase }}</span>\r\n            <span *ngIf=\"s.additionalInformationForCollapsedSidenav\"\r\n                class=\"ex-summary-sections-collapsed-right-sidenav-collapsed-label\"> | </span>\r\n        </ng-container>\r\n        <ex-svg-icon *ngIf=\"showWarningIcon\" iconName=\"circ_warning\"\r\n            [exTooltip]=\"'general.mandatory_information_is_missing' | translate\" color=\"red\" size=\"large\"\r\n            class=\"ex-summary-sections-collapsed-warning-icon sel-warning-sidenav\"> </ex-svg-icon>\r\n    </div>\r\n</div>\r\n", styles: [".ex-summary-sections-collapsed-right-sidenav-sections{flex:1;height:100%}.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-right-sidenav-sections-wrapper{height:100%;display:flex;flex-direction:column}.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-warning-icon,.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-right-sidenav-collapsed-icon{display:flex;align-items:center;justify-content:center;padding:20px 0;cursor:pointer;width:100%}.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-right-sidenav-collapsed-label{padding:10px;cursor:pointer;writing-mode:vertical-rl}.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-right-sidenav-collapsed-additional-label{color:red;padding:10px;cursor:pointer;writing-mode:vertical-rl}.ex-summary-sections-collapsed-right-sidenav-sections .ex-summary-sections-collapsed-right-sidenav-collapsed-label-responsive{flex-shrink:1;text-overflow:ellipsis;overflow:hidden;min-height:0;max-height:100%;white-space:nowrap}\n"] }]
    }], null, { summarySections: [{
            type: Input
        }], showWarningIcon: [{
            type: Input
        }] }); })();

class ExSummarySectionsCollapsedModule {
    static { this.ɵfac = function ExSummarySectionsCollapsedModule_Factory(t) { return new (t || ExSummarySectionsCollapsedModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSummarySectionsCollapsedModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            TranslateModule,
            MatTooltipModule,
            ExSvgIconModule,
            ExLabelModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSummarySectionsCollapsedModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExSvgIconModule,
                    ExLabelModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExSummarySectionsCollapsedComponent
                ],
                exports: [
                    ExSummarySectionsCollapsedComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSummarySectionsCollapsedModule, { declarations: [ExSummarySectionsCollapsedComponent], imports: [CommonModule,
        ExIconModule,
        TranslateModule,
        MatTooltipModule,
        ExSvgIconModule,
        ExLabelModule,
        ExDirectivesModule], exports: [ExSummarySectionsCollapsedComponent] }); })();

class ExSidenavModule {
    static { this.ɵfac = function ExSidenavModule_Factory(t) { return new (t || ExSidenavModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSidenavModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            MatSidenavModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExSummarySectionsCollapsedModule,
            AngularDraggableModule,
            ExComponentLoaderModule,
            ExIconModule,
            ExSvgIconModule,
            EXPipesModule,
            TranslateModule,
            ExSpinnerModule,
            ExCloseModule,
            MatProgressSpinnerModule,
            ExButtonModule,
            ExDotWrapperModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidenavModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatSidenavModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExSummarySectionsCollapsedModule,
                    AngularDraggableModule,
                    ExComponentLoaderModule,
                    ExIconModule,
                    ExSvgIconModule,
                    EXPipesModule,
                    TranslateModule,
                    ExSpinnerModule,
                    ExCloseModule,
                    MatProgressSpinnerModule,
                    ExButtonModule,
                    ExDotWrapperModule
                ],
                declarations: [
                    ExSidenavPageComponent
                ],
                exports: [
                    ExSidenavPageComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSidenavModule, { declarations: [ExSidenavPageComponent], imports: [CommonModule,
        FormsModule,
        MatSidenavModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExSummarySectionsCollapsedModule,
        AngularDraggableModule,
        ExComponentLoaderModule,
        ExIconModule,
        ExSvgIconModule,
        EXPipesModule,
        TranslateModule,
        ExSpinnerModule,
        ExCloseModule,
        MatProgressSpinnerModule,
        ExButtonModule,
        ExDotWrapperModule], exports: [ExSidenavPageComponent] }); })();
i0.ɵɵsetComponentScope(ExSidenavPageComponent, [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i2$1.Dir, i3$4.MatSidenav, i3$4.MatSidenavContainer, i3$4.MatSidenavContent, ExTooltipDirective, ExResizableDirective, ExSummarySectionsCollapsedComponent, ExComponentLoaderComponent, ExIconComponent, ExButtonComponent, ExDotWrapperComponent], [i1$5.AsyncPipe, i1$5.UpperCasePipe, i1$2.TranslatePipe]);

class ExSectionsLayoutModule {
    static { this.ɵfac = function ExSectionsLayoutModule_Factory(t) { return new (t || ExSectionsLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSectionsLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExComponentLoaderModule,
            TranslateModule,
            ExComboboxModule,
            MatExpansionModule,
            MatDividerModule,
            ExDirectivesModule,
            ExThumbnailModule,
            ExIconModule,
            ExSvgIconModule,
            ExButtonModule,
            ExSidenavModule,
            ExDotWrapperModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSectionsLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExComponentLoaderModule,
                    TranslateModule,
                    ExComboboxModule,
                    MatExpansionModule,
                    MatDividerModule,
                    ExDirectivesModule,
                    ExThumbnailModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExButtonModule,
                    ExSidenavModule,
                    ExDotWrapperModule,
                    EXPipesModule
                ],
                declarations: [
                    ExSectionsLayoutComponent,
                    ExSectionComponent,
                    ExSectionPlaceholderComponent,
                    ExSectionsLayoutDropdownComponent,
                ],
                exports: [
                    ExSectionsLayoutComponent,
                    ExSectionComponent,
                    ExSectionPlaceholderComponent,
                    ExSectionsLayoutDropdownComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSectionsLayoutModule, { declarations: [ExSectionsLayoutComponent,
        ExSectionComponent,
        ExSectionPlaceholderComponent,
        ExSectionsLayoutDropdownComponent], imports: [CommonModule,
        ExComponentLoaderModule,
        TranslateModule,
        ExComboboxModule,
        MatExpansionModule,
        MatDividerModule,
        ExDirectivesModule,
        ExThumbnailModule,
        ExIconModule,
        ExSvgIconModule,
        ExButtonModule,
        ExSidenavModule,
        ExDotWrapperModule,
        EXPipesModule], exports: [ExSectionsLayoutComponent,
        ExSectionComponent,
        ExSectionPlaceholderComponent,
        ExSectionsLayoutDropdownComponent] }); })();
i0.ɵɵsetComponentScope(ExSectionsLayoutComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i2$7.MatExpansionPanel, i2$7.MatExpansionPanelHeader, i2$7.MatExpansionPanelTitle, ExTooltipDirective, ExKeyboardShortcutDirective, exShortcutsScopeDirective, ExQuickAccessDirective, ExIconComponent, ExSvgIconComponent, ExButtonComponent, ExSidenavPageComponent, ExDotWrapperComponent, ExSectionPlaceholderComponent], [i1$2.TranslatePipe, ExGenerateIdPipe]);

function ExRecordGalleryPlaceholderComponent_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-checkbox", 4);
} if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
} }
function ExRecordGalleryPlaceholderComponent_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-radio-button", 4);
} if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
} }
function ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.index, " ");
} }
const _c0$i = function (a0) { return { "ex-record-placeholder-narrow": a0 }; };
function ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const j_r9 = ctx.index;
    const column_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$i, j_r9 === column_r3.length - 1 || j_r9 === 2));
} }
function ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_span_1_Template, 2, 1, "span", 7);
    i0.ɵɵtemplate(2, ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_div_2_Template, 1, 3, "div", 8);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.index);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 2, column_r3, 0, ctx_r5.maxEmptyLines));
} }
function ExRecordGalleryPlaceholderComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExRecordGalleryPlaceholderComponent_ng_container_4_div_1_Template, 4, 6, "div", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r4 < ctx_r2.breakpoint);
} }
class ExRecordGalleryPlaceholderComponent extends ExRecordPlaceholderComponent {
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExRecordGalleryPlaceholderComponent_BaseFactory; return function ExRecordGalleryPlaceholderComponent_Factory(t) { return (ɵExRecordGalleryPlaceholderComponent_BaseFactory || (ɵExRecordGalleryPlaceholderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ExRecordGalleryPlaceholderComponent)))(t || ExRecordGalleryPlaceholderComponent); }; }(); }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExRecordGalleryPlaceholderComponent, selectors: [["ex-record-gallery-placeholder"]], inputs: { index: "index" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 6, consts: [[1, "ex-record-placeholder-wrapper", 2, "flex-direction", "column", "height", "100%"], ["class", "ex-record-placeholder-checkbox", 4, "ngIf"], ["fixWidthOperator", "%", 2, "flex", "7", 3, "showPlaceholder", "fixedWidth", "hasMaxHeight"], [4, "ngFor", "ngForOf"], [1, "ex-record-placeholder-checkbox"], ["class", "ex-record-placeholder-column", "style", "flex: 3; flex-direction: row;", 4, "ngIf"], [1, "ex-record-placeholder-column", 2, "flex", "3", "flex-direction", "row"], [4, "ngIf"], ["class", "ex-record-placeholder-label ex-record-placeholder-grey", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "ex-record-placeholder-label", "ex-record-placeholder-grey", 3, "ngClass"]], template: function ExRecordGalleryPlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExRecordGalleryPlaceholderComponent_ex_checkbox_1_Template, 1, 1, "ex-checkbox", 1);
            i0.ɵɵtemplate(2, ExRecordGalleryPlaceholderComponent_mat_radio_button_2_Template, 1, 1, "mat-radio-button", 1);
            i0.ɵɵelement(3, "ex-thumbnail", 2);
            i0.ɵɵtemplate(4, ExRecordGalleryPlaceholderComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasPickup && ctx.isMultiSelect);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasPickup && !ctx.isMultiSelect);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("showPlaceholder", true)("fixedWidth", 100)("hasMaxHeight", false);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.proto["columns" + ctx.breakpoint]);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExThumbnailComponent, ExCheckboxComponent, i8.MatRadioButton, i1$5.SlicePipe], styles: [".ex-record-placeholder-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-checkbox[_ngcontent-%COMP%]{margin-inline-end:10px;width:24px;display:flex;flex-direction:column;text-align:center}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-inline:5px;flex:1;align-items:flex-start}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-actions-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1;width:100px}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-greyer[_ngcontent-%COMP%]{background:#ececec 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-grey[_ngcontent-%COMP%]{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-first-line[_ngcontent-%COMP%]{width:314px;height:19px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-action[_ngcontent-%COMP%]{width:40%;height:30px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-info[_ngcontent-%COMP%]{width:20%;height:15px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-label[_ngcontent-%COMP%]{width:80%;margin:5px;height:14px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper[_ngcontent-%COMP%]   .ex-record-placeholder-narrow[_ngcontent-%COMP%]{width:60%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExRecordGalleryPlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'ex-record-gallery-placeholder', template: "<div class=\"ex-record-placeholder-wrapper\" style=\"flex-direction: column; height: 100%;\">\n  <ex-checkbox *ngIf=\"hasPickup && isMultiSelect\" [attr.aria-hidden] = \"true\" class=\"ex-record-placeholder-checkbox\"></ex-checkbox>\n  <mat-radio-button  *ngIf=\"hasPickup && !isMultiSelect\" [attr.aria-hidden] = \"true\" class=\"ex-record-placeholder-checkbox\">\n  </mat-radio-button>\n  <ex-thumbnail [showPlaceholder]=\"true\"  style=\"flex: 7\"\n    [fixedWidth]=\"100\" fixWidthOperator=\"%\" [hasMaxHeight]=\"false\"></ex-thumbnail>\n  <ng-container *ngFor=\"let column of proto['columns' + breakpoint]; let i = index\">\n    <div class=\"ex-record-placeholder-column\" style=\"flex: 3; flex-direction: row;\"\n      *ngIf=\"i < breakpoint\">\n      <span *ngIf=\"index\">\n          {{ index }}\n      </span>\n      <div *ngFor=\"let row of column| slice:0:maxEmptyLines; let j = index\"\n        class=\"ex-record-placeholder-label ex-record-placeholder-grey\"\n        [ngClass]=\"{'ex-record-placeholder-narrow': (j === (column.length-1) || j === 2) }\">\n      </div>\n    </div>\n  </ng-container>\n</div>\n", styles: [".ex-record-placeholder-wrapper{display:flex;flex-direction:row}.ex-record-placeholder-wrapper .ex-record-placeholder-checkbox{margin-inline-end:10px;width:24px;display:flex;flex-direction:column;text-align:center}.ex-record-placeholder-wrapper .ex-record-placeholder-column{display:flex;flex-direction:column;margin-inline:5px;flex:1;align-items:flex-start}.ex-record-placeholder-wrapper .ex-record-placeholder-actions-column{display:flex;flex-direction:column;flex:1;width:100px}.ex-record-placeholder-wrapper .ex-record-placeholder-greyer{background:#ececec 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper .ex-record-placeholder-grey{background:#f3f5f4 0% 0% no-repeat padding-box}.ex-record-placeholder-wrapper .ex-record-placeholder-first-line{width:314px;height:19px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper .ex-record-placeholder-action{width:40%;height:30px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper .ex-record-placeholder-info{width:20%;height:15px;border-radius:3px;margin:5px;opacity:1;float:right}.ex-record-placeholder-wrapper .ex-record-placeholder-label{width:80%;margin:5px;height:14px;border-radius:3px;opacity:1}.ex-record-placeholder-wrapper .ex-record-placeholder-narrow{width:60%}\n"] }]
    }], null, { index: [{
            type: Input
        }] }); })();

class ExListLayoutModule {
    static { this.ɵfac = function ExListLayoutModule_Factory(t) { return new (t || ExListLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExListLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExPaginationModule,
            ExSideBySideModule,
            MatRippleModule,
            ExSpinnerModule,
            ExSortModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExComponentLoaderModule,
            ExButtonModule,
            ExChipModule,
            ExChipRecordModule,
            ExFiltersModule,
            ExListHeaderModule,
            ExRightClickActionsModule,
            ExRecordActionsModule,
            ExThumbnailModule,
            ExLabelModule,
            ExCloseModule,
            TranslateModule,
            DragDropModule,
            ExIconModule,
            ExSvgIconModule,
            ExComboboxModule,
            ExDragModule,
            ExCheckboxModule,
            EXPipesModule,
            ExSectionsLayoutModule,
            MatRadioModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExPaginationModule,
                    ExSideBySideModule,
                    MatRippleModule,
                    ExSpinnerModule,
                    ExSortModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExComponentLoaderModule,
                    ExButtonModule,
                    ExChipModule,
                    ExChipRecordModule,
                    ExFiltersModule,
                    ExListHeaderModule,
                    ExRightClickActionsModule,
                    ExRecordActionsModule,
                    ExThumbnailModule,
                    ExLabelModule,
                    ExCloseModule,
                    TranslateModule,
                    DragDropModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExComboboxModule,
                    ExDragModule,
                    ExCheckboxModule,
                    EXPipesModule,
                    ExSectionsLayoutModule,
                    MatRadioModule
                ],
                declarations: [
                    ExListLayoutComponent,
                    ExItemDetailsHeaderComponent,
                    ExExpandableSublistComponent,
                    ExClickableChipComponent,
                    ExRecordComponent,
                    ExRecordPlaceholderComponent,
                    ExRecordGalleryPlaceholderComponent,
                    FlexValueForColumns,
                    ShowRowOnPickup,
                    GetHighlightedText,
                    GetIsDisabled,
                    IsDisabledInPickup,
                    GetRowActions,
                    IsAvatarPlaceholder,
                    GetActionsColumnMinWidth
                ],
                exports: [
                    ExListLayoutComponent,
                    ExItemDetailsHeaderComponent,
                    ExRecordComponent,
                    ExClickableChipComponent,
                    ExExpandableSublistComponent,
                    ExRecordPlaceholderComponent,
                    ExRecordGalleryPlaceholderComponent
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExListLayoutModule, { declarations: [ExListLayoutComponent,
        ExItemDetailsHeaderComponent,
        ExExpandableSublistComponent,
        ExClickableChipComponent,
        ExRecordComponent,
        ExRecordPlaceholderComponent,
        ExRecordGalleryPlaceholderComponent,
        FlexValueForColumns,
        ShowRowOnPickup,
        GetHighlightedText,
        GetIsDisabled,
        IsDisabledInPickup,
        GetRowActions,
        IsAvatarPlaceholder,
        GetActionsColumnMinWidth], imports: [CommonModule,
        FormsModule,
        ExPaginationModule,
        ExSideBySideModule,
        MatRippleModule,
        ExSpinnerModule,
        ExSortModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExComponentLoaderModule,
        ExButtonModule,
        ExChipModule,
        ExChipRecordModule,
        ExFiltersModule,
        ExListHeaderModule,
        ExRightClickActionsModule,
        ExRecordActionsModule,
        ExThumbnailModule,
        ExLabelModule,
        ExCloseModule,
        TranslateModule,
        DragDropModule,
        ExIconModule,
        ExSvgIconModule,
        ExComboboxModule,
        ExDragModule,
        ExCheckboxModule,
        EXPipesModule,
        ExSectionsLayoutModule,
        MatRadioModule], exports: [ExListLayoutComponent,
        ExItemDetailsHeaderComponent,
        ExRecordComponent,
        ExClickableChipComponent,
        ExExpandableSublistComponent,
        ExRecordPlaceholderComponent,
        ExRecordGalleryPlaceholderComponent] }); })();
i0.ɵɵsetComponentScope(ExListLayoutComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgSwitch, i1$5.NgSwitchCase, ExPaginationComponent, ExSideBySideComponent, i6$1.MatRipple, ExSpinnerComponent, ExTooltipDirective, DeepLinkModeDirective, ResizedDirective, ExComponentLoaderComponent, ExListHeaderComponent, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, ExIconComponent, ExDragAccessibleIconComponent, ExDragListComponent, ExCheckboxComponent, ExItemDetailsHeaderComponent,
    ExExpandableSublistComponent,
    ExClickableChipComponent,
    ExRecordComponent,
    ExRecordPlaceholderComponent], [i1$2.TranslatePipe]);
i0.ɵɵsetComponentScope(ExExpandableSublistComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i6$1.MatRipple, ResizedDirective, ExComponentLoaderComponent, ExButtonComponent, ExChipComponent, ExCloseComponent, ExRecordComponent], [i1$2.TranslatePipe]);

class ExItemsLayoutListModule {
    static { this.ɵfac = function ExItemsLayoutListModule_Factory(t) { return new (t || ExItemsLayoutListModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExItemsLayoutListModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExListLayoutModule,
            ExPaginationModule,
            MatRippleModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExComponentLoaderModule,
            ExSpinnerModule,
            ExButtonModule,
            ExChipModule,
            ExRightClickActionsModule,
            ExThumbnailModule,
            ExLabelModule,
            ExCloseModule,
            TranslateModule,
            DragDropModule,
            ExDragModule,
            ExIconModule,
            ExSvgIconModule,
            ExCheckboxModule,
            ExRecordActionsModule,
            EXPipesModule,
            MatRadioModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExListLayoutModule,
                    ExPaginationModule,
                    MatRippleModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExComponentLoaderModule,
                    ExSpinnerModule,
                    ExButtonModule,
                    ExChipModule,
                    ExRightClickActionsModule,
                    ExThumbnailModule,
                    ExLabelModule,
                    ExCloseModule,
                    TranslateModule,
                    DragDropModule,
                    ExDragModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExCheckboxModule,
                    ExRecordActionsModule,
                    EXPipesModule,
                    MatRadioModule,
                ],
                declarations: [
                    ExItemsLayoutListComponent
                ],
                exports: [
                    ExItemsLayoutListComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExItemsLayoutListModule, { declarations: [ExItemsLayoutListComponent], imports: [CommonModule,
        FormsModule,
        ExListLayoutModule,
        ExPaginationModule,
        MatRippleModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExComponentLoaderModule,
        ExSpinnerModule,
        ExButtonModule,
        ExChipModule,
        ExRightClickActionsModule,
        ExThumbnailModule,
        ExLabelModule,
        ExCloseModule,
        TranslateModule,
        DragDropModule,
        ExDragModule,
        ExIconModule,
        ExSvgIconModule,
        ExCheckboxModule,
        ExRecordActionsModule,
        EXPipesModule,
        MatRadioModule], exports: [ExItemsLayoutListComponent] }); })();

function ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_ng_template_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "label", 13);
    i0.ɵɵpipe(2, "exTextHighlight");
    i0.ɵɵtext(3, " \u00A0 ");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lastIndexOfDelimiter_r5 = i0.ɵɵnextContext().lastIndexOfDelimiter;
    const ctx_r7 = i0.ɵɵnextContext();
    const option_r1 = ctx_r7.$implicit;
    const searchText_r2 = ctx_r7.searchText;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, option_r1 == null ? null : option_r1.value == null ? null : option_r1.value.slice(0, lastIndexOfDelimiter_r5 + 1), searchText_r2), i0.ɵɵsanitizeHtml);
} }
function ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_ng_template_0_ng_container_1_Template, 4, 4, "ng-container", 11);
    i0.ɵɵelement(2, "label", 12);
    i0.ɵɵpipe(3, "exTextHighlight");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lastIndexOfDelimiter_r5 = ctx.lastIndexOfDelimiter;
    const ctx_r9 = i0.ɵɵnextContext();
    const option_r1 = ctx_r9.$implicit;
    const searchText_r2 = ctx_r9.searchText;
    i0.ɵɵproperty("exTooltip", option_r1 == null ? null : option_r1.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", lastIndexOfDelimiter_r5 >= 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 3, option_r1 == null ? null : option_r1.value == null ? null : option_r1.value.slice(lastIndexOfDelimiter_r5 + 1), searchText_r2), i0.ɵɵsanitizeHtml);
} }
const _c0$h = function (a0) { return { lastIndexOfDelimiter: a0 }; };
function ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_ng_template_0_Template, 4, 6, "ng-template", 8, 9, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const _r3 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$h, option_r1 == null ? null : option_r1.value == null ? null : option_r1.value.lastIndexOf(ctx_r0.PATH_DELIMITER)));
} }
const _c1$d = function (a0) { return { "0": a0 }; };
const _c2$7 = function (a2) { return { styleAttr: "font-weight", styleValue: "500", targetText: a2 }; };
class ExItemsLayoutTreeMoveTargetSelectionComponent {
    constructor(dialogRef, data, translate) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.translate = translate;
        this.titleText = 'item';
        this.PATH_DELIMITER = '/';
        this.autoCompleteDatasource = ((searchText) => {
            return this.data.datasource(searchText).pipe(switchMap(options => {
                return of(this.flattenOptions(options));
            }));
        }).bind(this);
    }
    ngOnInit() {
        this.initTitle();
    }
    initTitle() {
        const { itemsToMove, treeFieldKey } = this.data;
        if (itemsToMove?.length == 1) {
            this.titleText = treeFieldKey ? itemsToMove[0].listItem[treeFieldKey] : this.translate.instant('ng.items_layout.tree.item');
        }
        else if (itemsToMove?.length > 1) {
            this.titleText = `${itemsToMove.length.toString()} ${this.translate.instant('ng.items_layout.tree.items')}`;
        }
    }
    flattenOptions(optionsHierarchy) {
        let flatOptions = [];
        let stack = [];
        let curItem;
        let path = [];
        let value;
        optionsHierarchy.forEach(item => {
            stack.push(item);
            while (stack.length > 0) {
                curItem = stack.pop();
                if (curItem === null) {
                    path.pop();
                    continue;
                }
                if (curItem.canSelect || !(curItem.children?.length > 0)) { // add to options if canSelect or if is leaf
                    value = path.length > 0 ? `${path.join(' ' + this.PATH_DELIMITER + ' ')} ${this.PATH_DELIMITER} ${curItem.label}` : `${curItem.label}`;
                    flatOptions.push({ key: curItem.id, value: value });
                }
                if (curItem.children?.length > 0) {
                    stack.push(null, ...curItem.children.reverse());
                    path.push(curItem.label);
                }
            }
        });
        return flatOptions;
    }
    onCancel() {
        this.dialogRef.close();
    }
    onConfirm() {
        this.dialogRef.close(this.selectedTarget.key);
    }
    static { this.ɵfac = function ExItemsLayoutTreeMoveTargetSelectionComponent_Factory(t) { return new (t || ExItemsLayoutTreeMoveTargetSelectionComponent)(i0.ɵɵdirectiveInject(i1$7.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutTreeMoveTargetSelectionComponent, selectors: [["ex-items-layout-tree-move"]], decls: 16, vars: 26, consts: [[1, "ex-items-layout-tree-move-dialog-wrapper"], ["mat-dialog-title", "", 1, "ex-items-layout-tree-move-dialog-title"], [1, "ex-items-layout-tree-move-dialog-title-base", 3, "innerHTML"], ["mat-dialog-content", "", 1, "ex-items-layout-tree-move-dialog-content"], [3, "datasource", "placeholder", "classList", "selectedValue", "selectedValueChange"], ["mat-dialog-actions", "", "align", "end", 1, "ex-items-layout-tree-move-dialog-actions"], [1, "ex-items-layout-tree-move-dialog-button", 3, "type", "click"], [1, "ex-items-layout-tree-move-dialog-button", 3, "type", "disabled", "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["optionTmpl", ""], [1, "ex-items-layout-tree-move-option", 3, "exTooltip"], [4, "ngIf"], [1, "ex-items-layout-tree-move-option-value", 3, "innerHTML"], [1, "ex-items-layout-tree-move-option-path", 3, "innerHTML"]], template: function ExItemsLayoutTreeMoveTargetSelectionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "span", 2);
            i0.ɵɵpipe(3, "exTextStyle");
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "ex-autocomplete", 4);
            i0.ɵɵlistener("selectedValueChange", function ExItemsLayoutTreeMoveTargetSelectionComponent_Template_ex_autocomplete_selectedValueChange_6_listener($event) { return ctx.selectedTarget = $event; });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵtemplate(8, ExItemsLayoutTreeMoveTargetSelectionComponent_ng_template_8_Template, 2, 4, "ng-template");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 5)(10, "ex-button", 6);
            i0.ɵɵlistener("click", function ExItemsLayoutTreeMoveTargetSelectionComponent_Template_ex_button_click_10_listener() { return ctx.onCancel(); });
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "ex-button", 7);
            i0.ɵɵlistener("click", function ExItemsLayoutTreeMoveTargetSelectionComponent_Template_ex_button_click_13_listener() { return ctx.onConfirm(); });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 10, i0.ɵɵpipeBind2(4, 13, "ng.items_layout.tree.move_to", i0.ɵɵpureFunction1(22, _c1$d, ctx.titleText)), i0.ɵɵpureFunction1(24, _c2$7, ctx.titleText)), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("datasource", ctx.autoCompleteDatasource)("placeholder", i0.ɵɵpipeBind1(7, 16, "ng.items_layout.tree.select_target"))("classList", "ex-items-layout-tree-move")("selectedValue", ctx.selectedTarget);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("type", "secondary");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 18, "ng.general.cancel"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("type", "primary")("disabled", !ctx.selectedTarget);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 20, "ng.general.confirm"), "");
        } }, styles: [".ex-items-layout-tree-move-dialog-wrapper[_ngcontent-%COMP%]{min-width:35vw}.ex-items-layout-tree-move-dialog-button[_ngcontent-%COMP%]{margin-inline-start:10px}  .ex-items-layout-tree-move .ex-autocomplete-mat-option .mat-mdc-option-text{white-space:normal!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutTreeMoveTargetSelectionComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-tree-move', template: "<div class=\"ex-items-layout-tree-move-dialog-wrapper\">\r\n    <div mat-dialog-title class=\"ex-items-layout-tree-move-dialog-title\">\r\n        <span class=\"ex-items-layout-tree-move-dialog-title-base\"\r\n            [innerHTML]=\"'ng.items_layout.tree.move_to' | translate : { '0': titleText } | exTextStyle : { styleAttr: 'font-weight', styleValue: '500', targetText: titleText }\"></span>\r\n    </div>\r\n    <div mat-dialog-content class=\"ex-items-layout-tree-move-dialog-content\">\r\n        <ex-autocomplete [datasource]=\"autoCompleteDatasource\"\r\n            [placeholder]=\"'ng.items_layout.tree.select_target' | translate\" [classList]=\"'ex-items-layout-tree-move'\"\r\n            [(selectedValue)]=\"selectedTarget\">\r\n            <ng-template let-option let-searchText=\"searchText\">\r\n                <ng-template #optionTmpl [ngTemplateOutlet]=\"optionTmpl\" let-lastIndexOfDelimiter=\"lastIndexOfDelimiter\"\r\n                    [ngTemplateOutletContext]=\"{ lastIndexOfDelimiter: option?.value?.lastIndexOf(PATH_DELIMITER) }\">\r\n                    <span class=\"ex-items-layout-tree-move-option\" [exTooltip]=\"option?.value\">\r\n                        <ng-container *ngIf=\"lastIndexOfDelimiter >= 0\">\r\n                            <label class=\"ex-items-layout-tree-move-option-path\"\r\n                                [innerHTML]=\"option?.value?.slice(0, lastIndexOfDelimiter + 1) | exTextHighlight: searchText\"></label>\r\n                            &nbsp;\r\n                        </ng-container>\r\n                        <label class=\"ex-items-layout-tree-move-option-value\"\r\n                            [innerHTML]=\"option?.value?.slice(lastIndexOfDelimiter + 1) | exTextHighlight: searchText\"></label>\r\n                    </span>\r\n                </ng-template>\r\n            </ng-template>\r\n        </ex-autocomplete>\r\n    </div>\r\n    <div mat-dialog-actions align=\"end\" class=\"ex-items-layout-tree-move-dialog-actions\">\r\n        <ex-button class=\"ex-items-layout-tree-move-dialog-button\" [type]=\"'secondary'\" (click)=\"onCancel()\">\r\n            {{ 'ng.general.cancel'  | translate }}</ex-button>\r\n        <ex-button class=\"ex-items-layout-tree-move-dialog-button\" [type]=\"'primary'\" [disabled]=\"!selectedTarget\"\r\n            (click)=\"onConfirm()\">\r\n            {{ 'ng.general.confirm'  | translate }}</ex-button>\r\n    </div>\r\n</div>", styles: [".ex-items-layout-tree-move-dialog-wrapper{min-width:35vw}.ex-items-layout-tree-move-dialog-button{margin-inline-start:10px}::ng-deep .ex-items-layout-tree-move .ex-autocomplete-mat-option .mat-mdc-option-text{white-space:normal!important}\n"] }]
    }], function () { return [{ type: i1$7.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$2.TranslateService }]; }, null); })();

const _c0$g = function (a0) { return { "padding-inline-start": a0 }; };
const _c1$c = function (a0) { return { "ex-items-layout-tree-placeholder-toggle-hidden": a0 }; };
function ExItemsLayoutTreePlaceholderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "ex-svg-icon", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("ex-items-layout-tree-placeholder-level-" + item_r1.level);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c0$g, ctx_r0.levelPaddingStart * item_r1.level + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("iconName", ctx_r0.toggleIcon)("color", ctx_r0.toggleIconColor)("ngClass", i0.ɵɵpureFunction1(8, _c1$c, !item_r1.hasChildren));
} }
class ExItemsLayoutTreePlaceholderComponent {
    constructor() {
        this.levelPaddingStart = 40;
        this.toggleIcon = "arrow";
        this.toggleIconColor = "#ececec";
        this.placeholderStructureConfig = [
            { level: 0, hasChildren: true },
            { level: 1, hasChildren: false },
            { level: 0, hasChildren: true },
            { level: 1, hasChildren: true },
            { level: 2, hasChildren: false },
            { level: 2, hasChildren: false },
            { level: 1, hasChildren: false },
            { level: 1, hasChildren: false },
        ];
    }
    static { this.ɵfac = function ExItemsLayoutTreePlaceholderComponent_Factory(t) { return new (t || ExItemsLayoutTreePlaceholderComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutTreePlaceholderComponent, selectors: [["ex-items-layout-tree-placeholder"]], decls: 2, vars: 1, consts: [[1, "ex-items-layout-tree-placeholder"], ["class", "ex-items-layout-tree-placeholder-row", 3, "class", "ngStyle", 4, "ngFor", "ngForOf"], [1, "ex-items-layout-tree-placeholder-row", 3, "ngStyle"], [1, "ex-items-layout-tree-placeholder-toggle-icon", 3, "iconName", "color", "ngClass"], [1, "ex-items-layout-tree-placeholder-background"]], template: function ExItemsLayoutTreePlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ExItemsLayoutTreePlaceholderComponent_div_1_Template, 4, 10, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.placeholderStructureConfig);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgStyle, ExSvgIconComponent], styles: [".ex-items-layout-tree-placeholder[_ngcontent-%COMP%]{width:100%}.ex-items-layout-tree-placeholder[_ngcontent-%COMP%]   .ex-items-layout-tree-placeholder-row[_ngcontent-%COMP%]{margin-top:10px;display:flex;flex-direction:row;height:40px}.ex-items-layout-tree-placeholder[_ngcontent-%COMP%]   .ex-items-layout-tree-placeholder-background[_ngcontent-%COMP%]{background-color:#f3f5f4;width:100%}.ex-items-layout-tree-placeholder[_ngcontent-%COMP%]   .ex-items-layout-tree-placeholder-toggle-hidden[_ngcontent-%COMP%]{visibility:hidden}.ex-items-layout-tree-placeholder[_ngcontent-%COMP%]   .ex-items-layout-tree-placeholder-toggle-icon[_ngcontent-%COMP%]     svg{transform:rotate(-90deg)}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutTreePlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-tree-placeholder', template: "<div class=\"ex-items-layout-tree-placeholder\">\r\n    <div *ngFor=\"let item of placeholderStructureConfig\" class=\"ex-items-layout-tree-placeholder-row\"\r\n        [class]=\"'ex-items-layout-tree-placeholder-level-' + item.level\"\r\n        [ngStyle]=\"{ 'padding-inline-start': (levelPaddingStart * item.level)+'px' }\">\r\n        <ex-svg-icon [iconName]=\"toggleIcon\" [color]=\"toggleIconColor\"\r\n            class=\"ex-items-layout-tree-placeholder-toggle-icon\"\r\n            [ngClass]=\"{'ex-items-layout-tree-placeholder-toggle-hidden': !item.hasChildren}\">\r\n        </ex-svg-icon>\r\n        <div class=\"ex-items-layout-tree-placeholder-background\">&nbsp;</div>\r\n    </div>\r\n</div> ", styles: [".ex-items-layout-tree-placeholder{width:100%}.ex-items-layout-tree-placeholder .ex-items-layout-tree-placeholder-row{margin-top:10px;display:flex;flex-direction:row;height:40px}.ex-items-layout-tree-placeholder .ex-items-layout-tree-placeholder-background{background-color:#f3f5f4;width:100%}.ex-items-layout-tree-placeholder .ex-items-layout-tree-placeholder-toggle-hidden{visibility:hidden}.ex-items-layout-tree-placeholder .ex-items-layout-tree-placeholder-toggle-icon ::ng-deep svg{transform:rotate(-90deg)}\n"] }]
    }], null, null); })();

const _c0$f = ["scrollerElement"];
const _c1$b = ["tree"];
const _c2$6 = ["paginationRef"];
function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3$4 = function (a1, a2, a4) { return { type: "leaf", node: a1, level: a2, isExpanded: false, isSelected: a4 }; };
function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-nested-tree-node", 15)(1, "div", 16, 17);
    i0.ɵɵlistener("keydown.enter", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template_div_keydown_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const node_r14 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.onItemClicked(node_r14)); })("keydown.arrowdown", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template_div_keydown_arrowdown_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onRowArrowDown($event)); })("keydown.arrowup", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template_div_keydown_arrowup_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.onRowArrowUp($event)); })("focusin", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template_div_focusin_1_listener() { i0.ɵɵrestoreView(_r19); const _r16 = i0.ɵɵreference(2); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.scrollToSelectedItem(_r16)); });
    i0.ɵɵtemplate(3, ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_ng_container_3_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const node_r14 = ctx.$implicit;
    const level_r15 = ctx.level;
    const ctx_r12 = i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c3$4, node_r14, level_r15, ctx_r12._selectedItem && node_r14.id === ctx_r12._selectedItem.id));
} }
function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "div");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} }
const _c4$2 = function (a1, a2, a3, a4) { return { type: "expandable", node: a1, level: a2, isExpanded: a3, isSelected: a4 }; };
function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-nested-tree-node", 19, 20)(2, "div", 16, 17);
    i0.ɵɵlistener("keydown.enter", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template_div_keydown_enter_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const node_r23 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(2); ctx_r29.onItemClicked(node_r23); return i0.ɵɵresetView(ctx_r29.onTreeNodeToggled(node_r23, true)); })("keydown.arrowdown", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template_div_keydown_arrowdown_2_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.onRowArrowDown($event)); })("keydown.arrowup", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template_div_keydown_arrowup_2_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.onRowArrowUp($event)); })("focusin", function ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template_div_focusin_2_listener() { i0.ɵɵrestoreView(_r30); const _r26 = i0.ɵɵreference(3); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.scrollToSelectedItem(_r26)); });
    i0.ɵɵtemplate(4, ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_ng_container_4_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 21)(6, "div", 22)(7, "div");
    i0.ɵɵtext(8, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_div_9_Template, 3, 0, "div", 23);
    i0.ɵɵelementStart(10, "div", 24);
    i0.ɵɵelementContainer(11, 25);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const node_r23 = ctx.$implicit;
    const level_r24 = ctx.level;
    const _r25 = i0.ɵɵreference(1);
    const ctx_r13 = i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction4(5, _c4$2, node_r23, level_r24, _r25.isExpanded, ctx_r13._selectedItem && node_r23.id === ctx_r13._selectedItem.id));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", level_r24 != 0 && _r25.isExpanded && ctx_r13.isLastChild(node_r23.id));
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-items-layout-tree-group-invisible", !ctx_r13.treeControl.isExpanded(node_r23));
} }
function ExItemsLayoutTreeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "button", 9);
    i0.ɵɵlistener("click", function ExItemsLayoutTreeComponent_ng_container_2_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.collapseAll()); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "cdk-tree", 11, 12);
    i0.ɵɵtemplate(10, ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_10_Template, 4, 6, "cdk-nested-tree-node", 13);
    i0.ɵɵtemplate(11, ExItemsLayoutTreeComponent_ng_container_2_cdk_nested_tree_node_11_Template, 12, 10, "cdk-nested-tree-node", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(3, 6, "ng.items_layout.tree.collapse_all"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 8, "ng.items_layout.tree.collapse_all"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dataSource", ctx_r1.dataSource)("treeControl", ctx_r1.treeControl)("trackBy", ctx_r1.trackById);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cdkTreeNodeDefWhen", ctx_r1.hasChild);
} }
function ExItemsLayoutTreeComponent_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function ExItemsLayoutTreeComponent_ng_template_3_ex_checkbox_5_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 37);
    i0.ɵɵlistener("checkedChange", function ExItemsLayoutTreeComponent_ng_template_3_ex_checkbox_5_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r48); const node_r37 = i0.ɵɵnextContext().node; const ctx_r46 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r46.onItemCheckedChange(node_r37, $event)); })("click", function ExItemsLayoutTreeComponent_ng_template_3_ex_checkbox_5_Template_ex_checkbox_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r37 = i0.ɵɵnextContext().node;
    const ctx_r42 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r42.isItemChecked(node_r37))("disabled", node_r37.selectable === false)("exTooltip", node_r37.selectable !== false ? "" : i0.ɵɵpipeBind1(1, 4, node_r37.nonSelectableTooltip))("ariaLabel", i0.ɵɵpipeBind1(2, 6, "ng.ex_items_layout_list_row.check_or_uncheck"));
} }
function ExItemsLayoutTreeComponent_ng_template_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExItemsLayoutTreeComponent_ng_template_3_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c5$2 = function (a0, a1) { return { node: a0, isSelected: a1 }; };
function ExItemsLayoutTreeComponent_ng_template_3_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutTreeComponent_ng_template_3_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext();
    const node_r37 = ctx_r52.node;
    const isSelected_r40 = ctx_r52.isSelected;
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5$2, node_r37, isSelected_r40));
} }
function ExItemsLayoutTreeComponent_ng_template_3_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("keyup.Tab", function ExItemsLayoutTreeComponent_ng_template_3_button_9_Template_button_keyup_Tab_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r53.onTabFromRowEnd()); });
    i0.ɵɵelementEnd();
} }
const _c6$2 = function (a0, a1, a2) { return { "ex-items-layout-tree-node-expandible-container": a0, "ex-items-layout-tree-node-leaf-container": a1, "ex-items-layout-tree-node-selected": a2 }; };
const _c7$2 = function (a0) { return { visibility: a0 }; };
const _c8$2 = function (a0, a1, a2) { return { $implicit: a0, isSelected: a1, isExpanded: a2 }; };
function ExItemsLayoutTreeComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 27);
    i0.ɵɵlistener("click", function ExItemsLayoutTreeComponent_ng_template_3_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r56); const node_r37 = restoredCtx.node; const ctx_r55 = i0.ɵɵnextContext(); ctx_r55.onItemClicked(node_r37); return i0.ɵɵresetView(ctx_r55.onTreeNodeToggled(node_r37, true)); });
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵtemplate(2, ExItemsLayoutTreeComponent_ng_template_3_div_2_Template, 3, 0, "div", 29);
    i0.ɵɵelementStart(3, "button", 30);
    i0.ɵɵlistener("click", function ExItemsLayoutTreeComponent_ng_template_3_Template_button_click_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r56); const node_r37 = restoredCtx.node; const ctx_r57 = i0.ɵɵnextContext(); $event.stopPropagation(); return i0.ɵɵresetView(ctx_r57.onTreeNodeToggled(node_r37)); });
    i0.ɵɵelement(4, "ex-svg-icon", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExItemsLayoutTreeComponent_ng_template_3_ex_checkbox_5_Template, 3, 8, "ex-checkbox", 32);
    i0.ɵɵelementStart(6, "div", 33);
    i0.ɵɵtemplate(7, ExItemsLayoutTreeComponent_ng_template_3_ng_container_7_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ExItemsLayoutTreeComponent_ng_template_3_ng_container_8_Template, 2, 5, "ng-container", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, ExItemsLayoutTreeComponent_ng_template_3_button_9_Template, 1, 0, "button", 35);
} if (rf & 2) {
    const type_r36 = ctx.type;
    const node_r37 = ctx.node;
    const level_r38 = ctx.level;
    const isExpanded_r39 = ctx.isExpanded;
    const isSelected_r40 = ctx.isSelected;
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c6$2, type_r36 == "expandable", type_r36 == "leaf", isSelected_r40));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", level_r38 != 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", isExpanded_r39 ? "ex-items-layout-tree-node-expandible-group-toggle-expanded" : "ex-items-layout-tree-node-expandible-group-toggle-collapsed")("ngStyle", i0.ɵɵpureFunction1(14, _c7$2, type_r36 == "expandable" ? "visible" : "hidden"));
    i0.ɵɵattribute("aria-label", "Toggle tree node");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.listProperties.hasPickup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.nodeContentTemplate ? ctx_r3.nodeContentTemplate : _r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(16, _c8$2, node_r37, isSelected_r40, isExpanded_r39));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", isSelected_r40);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isItemOpen && isSelected_r40);
} }
const _c9$2 = function (a0) { return { "ex-items-layout-tree-node-item-selected": a0 }; };
function ExItemsLayoutTreeComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "ex-label", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r58 = ctx.$implicit;
    const isSelected_r59 = ctx.isSelected;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c9$2, isSelected_r59));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r5._treeFieldKey ? node_r58.listItem[ctx_r5._treeFieldKey] : "")("highlightedText", ctx_r5.listProperties.searchText)("isBold", isSelected_r59);
} }
function ExItemsLayoutTreeComponent_ng_template_7_ex_record_actions_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-record-actions", 43);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutTreeComponent_ng_template_7_ex_record_actions_1_Template_ex_record_actions_actionClicked_0_listener($event) { i0.ɵɵrestoreView(_r65); const node_r60 = i0.ɵɵnextContext().node; const ctx_r63 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r63.onActionClicked(node_r60, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext();
    const node_r60 = ctx_r66.node;
    const isSelected_r61 = ctx_r66.isSelected;
    i0.ɵɵproperty("actions", node_r60.listItem.actions == null ? null : node_r60.listItem.actions.actions)("visibleBtnNum", node_r60.listItem.actions == null ? null : node_r60.listItem.actions.visibleBtnNum)("loading", node_r60.listItem.actions == null ? null : node_r60.listItem.actions.loading)("isSelected", isSelected_r61);
} }
function ExItemsLayoutTreeComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ExItemsLayoutTreeComponent_ng_template_7_ex_record_actions_1_Template, 1, 4, "ex-record-actions", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r60 = ctx.node;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r60.listItem.__proto__.actions);
} }
function ExItemsLayoutTreeComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-items-layout-tree-placeholder");
} }
function ExItemsLayoutTreeComponent_ex_pagination_11_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 44, 45);
    i0.ɵɵlistener("selectedPageChange", function ExItemsLayoutTreeComponent_ex_pagination_11_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r68.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutTreeComponent_ex_pagination_11_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r70 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r70.onPageSizeChange($event)); })("endOfPagination", function ExItemsLayoutTreeComponent_ex_pagination_11_Template_ex_pagination_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r69); const ctx_r71 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r71.endOfPagination.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("numberOfResults", ctx_r10.listProperties.pagination.totalItemsCount)("pageSize", ctx_r10.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r10.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r10.listProperties.pagination.selectedPage)("doNotUpdateStateInternally", true);
} }
class ExItemsLayoutTreeComponent extends ExItemsLayoutItemsFlat {
    set selectedItem(item) {
        this._selectedItem = item;
        if (this._selectedItem) {
            this.expandToNode(this._selectedItem.id);
        }
        this.updateHasNexPrevious();
    }
    get selectedItem() {
        return this._selectedItem;
    }
    trackById(index, item) {
        return item.id;
    }
    constructor(_itemsLayoutService, sectionsLayoutService, dialogService, moveDialog) {
        super(_itemsLayoutService, sectionsLayoutService, dialogService);
        this._itemsLayoutService = _itemsLayoutService;
        this.moveDialog = moveDialog;
        this.onLoadExpandToLevel = 0;
        this.nodeToggled = new EventEmitter();
        this.itemsMoved = new EventEmitter();
        this.treeControl = new NestedTreeControl(node => node.children);
        this.dataSource = new MatTreeNestedDataSource();
        this._itemsMap = new Map();
        this._itemsReloaded = true;
        this.ACTION_KEY_MOVE = 'move';
        this.ACTION_KEY_CLONE = 'clone';
        this.hasChild = (_, node) => !!node.children && node.children.length > 0;
        this.scrollToSelectedItem = debounce((element) => {
            scrollIntoView(element, {
                scrollMode: 'if-needed',
                block: 'nearest',
                inline: 'nearest',
                behavior: 'smooth',
                boundary: this.scrollerElement.nativeElement
            });
        }, 100);
        this.onResized = debounce((event) => {
            this.resizeEvent.emit(event);
        }, 50);
    }
    onComponentInit() {
        this.initActions();
    }
    initActions() {
        // no default actions
    }
    refreshDataSource() {
        this.dataSource.data = null;
        this.dataSource.data = this.items;
    }
    initItemsMap() {
        this._itemsMap = new Map();
        this.items?.forEach(item => {
            this.buildItemsMap(item, undefined);
        });
    }
    buildItemsMap(item, parentItem) {
        item.children?.forEach(childItem => this.buildItemsMap(childItem, item));
        this._itemsMap.set(item.id, { item: item, parentItem: parentItem });
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('items')) {
            this.refreshDataSource();
            this.initItemsMap();
            this.onItemsChanges();
        }
        if (changes.hasOwnProperty('checkedItems')) {
            this._itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
        }
    }
    /*
    * when new collection of items is set (on first loading or after items renewed e.g after search/filter), no item is selected.
    * when existing collection of items is set (e.g. items updated, additional items loaded), selected item remains the same or if selected item does not exist in the collection no item is selected.
    */
    onItemsChanges() {
        this.initTreeFieldKey();
        //  _itemsMap should be already updated with new items at this point
        if (this._idToSelectAfterItemsChange) {
            this.selectItemById(this._idToSelectAfterItemsChange);
            this._idToSelectAfterItemsChange = null;
        }
        else if (this._itemsReloaded) {
            this.selectedItem = undefined;
            this._itemsReloaded = false;
        }
        else if (this._itemsDeleted && this._nextItemAfterItemsDeleted) {
            this.selectedItem = this._nextItemAfterItemsDeleted;
            this._nextItemAfterItemsDeleted = undefined;
            this._itemsDeleted = false;
        }
        else if (this._selectedItem) {
            this.selectedItem = this.items?.length > 0 ? this._itemsMap.get(this._selectedItem.id)?.item : undefined;
        }
        if (!this._selectedItem && this.isItemOpen) {
            this.selectedItem = this.items?.length > 0 ? this.items[0] : undefined;
        }
        this.selectedItemChange.emit(this._selectedItem);
        this.expandToLevel(this.onLoadExpandToLevel);
        //expandToNode(), updateHasNexPrevious() // performed in selectedItem setter
        this._itemsLayoutService.updateNumCurrentItems(this.numCurrentItems());
        this._itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
    }
    initTreeFieldKey() {
        // assume all have same UIWrapper
        this._treeFieldKey = this.items?.length > 0 && this.items[0].listItem ? this.items[0].listItem.__proto__.treeFieldKey : undefined;
    }
    onItemsReloaded() {
        this._itemsReloaded = true;
    }
    onListParametersItemIdUpdated(id) {
        this._idToSelectAfterItemsChange = id;
    }
    numCurrentItems() {
        return this.getAllVisibleItems().length;
    }
    expandToLevel(level) {
        if (!this.items?.length || level == 0)
            return;
        let curLevel = 0;
        let nodeQueue = [].concat(this.items);
        let curLevelNodeQueueLength = 0;
        let curNode;
        do {
            if (curLevel++ >= level)
                break;
            curLevelNodeQueueLength = nodeQueue.length;
            for (let i = 0; i < curLevelNodeQueueLength; i++) {
                curNode = nodeQueue.shift();
                if (curNode?.children?.length > 0) {
                    nodeQueue = nodeQueue.concat(curNode.children);
                    this.treeControl.expand(curNode);
                }
            }
        } while (nodeQueue.length > 0);
        this._itemsLayoutService.updateNumCurrentItems(this.numCurrentItems());
        this._itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
    }
    isNodeExpanded(item) {
        return this.treeControl.isExpanded(item);
    }
    isLastChild(id) {
        const parentItemChildren = this._itemsMap.get(id)?.parentItem?.children ?? this.items;
        return parentItemChildren && parentItemChildren[parentItemChildren.length - 1].id == id;
    }
    getNodeLastDescendant(item) {
        return this.treeControl.getDescendants(item).pop();
    }
    /**
     * returns true if the selected item is not the last visible item (excluding items that are children of nodes that are not expanded)
     */
    hasNextItem() {
        return this.items?.length && this._selectedItem?.id != this.getLastVisibleItem().id;
        // TODO: update for incremental loading
    }
    /**
     * returns true if the selected item is not the first item
     */
    hasPreviousItem() {
        return this.items?.length && this._selectedItem?.id != this.items[0].id;
        // TODO: update for incremental loading
    }
    selectNextItem() {
        this._selectedItem = this.getNextItem();
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this._selectedItem);
        this.scrollToItem();
    }
    selectPreviousItem() {
        this._selectedItem = this.getPreviousItem();
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this._selectedItem);
        this.scrollToItem();
    }
    scrollToItem() {
        if (this.selectedItem) {
            let element = this.cdkNodes?.find(node => node.data.id === this._selectedItem?.id)?.['_elementRef']?.nativeElement.children.item(0);
            this.scrollToSelectedItem(element);
        }
    }
    selectItemById(itemId) {
        if (!itemId || this._selectedItem?.id == itemId)
            return;
        const { item, parentItem } = this._itemsMap.get(itemId) ?? {};
        this.selectedItem = item;
        // this.expandToNode(), this.updateHasNexPrevious() // performed in selectedItem setter
        this.selectedItemChange.emit(this._selectedItem);
    }
    /**
     * if selected item is expanded, returns the first child of the selected item.
     * if selected item is not expanded, returns the next sibling of the first ancestor that is not the last of its siblings.
     */
    getNextItem() {
        if (!this._selectedItem) {
            return this.items[0];
        }
        if (this.isNodeExpanded(this._selectedItem) && this._selectedItem.children?.length > 0) {
            return this._selectedItem.children[0];
        }
        else {
            return this.findNextItemOnEqualOrGreaterLevel(this._selectedItem);
        }
    }
    /**
     * returns the next sibling, or if item has no next sibling returns the next sibling of the first ancestor that is not the last of its siblings.
     * if item is the last item, returns undefined.
     */
    findNextItemOnEqualOrGreaterLevel(item) {
        let curItem;
        let curItemParent = item; // for initialization of curItem in loop
        let curItemList;
        let curItemIndex;
        do {
            curItem = curItemParent;
            curItemParent = this._itemsMap.get(curItem?.id)?.parentItem;
            curItemList = curItemParent ? curItemParent.children : this.items;
            curItemIndex = curItemList.findIndex(currItem => currItem.id === curItem.id);
        } while (curItemIndex == curItemList.length - 1 && curItemParent);
        return curItemIndex == curItemList.length - 1 ? undefined : curItemList[curItemIndex + 1];
    }
    /**
     * if the selected item is the first of the children of its parent, returns the parent of the selected item.
     * it the selected item is not the first of the children of its parent, returns the last visible descendant of the preceeding sibling
     */
    getPreviousItem() {
        return this.findPreviousItem(this._selectedItem);
    }
    findPreviousItem(item) {
        const selectedItemParent = this._itemsMap.get(item?.id)?.parentItem;
        const selectedItemList = selectedItemParent ? selectedItemParent.children : this.items;
        const selectedItemIndex = selectedItemList.findIndex(curItem => curItem.id === item.id);
        if (selectedItemIndex == 0) {
            return selectedItemParent;
        }
        else {
            return this.getLastVisibleItemForItem(selectedItemList[selectedItemIndex - 1]);
        }
    }
    getAllVisibleItems() {
        // can't use this.treeControl.expansionModel.selected if child nodes remain expanded when parent is collapsed
        if (!this.items)
            return [];
        let visibleItems = [];
        this.items.forEach(item => visibleItems = visibleItems.concat(this.getSubtreeVisibleItems(item)));
        return visibleItems;
    }
    getSubtreeVisibleItems(item) {
        if (!item)
            return [];
        let subTreeVisibleItems = [item];
        if (this.isNodeExpanded(item))
            item.children?.forEach(childItem => subTreeVisibleItems = subTreeVisibleItems.concat(this.getSubtreeVisibleItems(childItem)));
        return subTreeVisibleItems;
    }
    /**
     * returns the last visible item of all items
     */
    getLastVisibleItem() {
        return (this.items?.length > 0) ? this.getLastVisibleItemForItem(this.items[this.items.length - 1]) : undefined;
    }
    /**
     * returns the last child of the last expanded descendant of the given item
     */
    getLastVisibleItemForItem(item) {
        let curItem = item;
        while (curItem?.children?.length > 0 && this.isNodeExpanded(curItem)) {
            curItem = curItem.children[curItem.children.length - 1];
        }
        return curItem;
    }
    expandToNode(id) {
        let parentItem = this._itemsMap.get(id)?.parentItem;
        while (parentItem) {
            this.treeControl.expand(parentItem);
            parentItem = this._itemsMap.get(parentItem.id).parentItem;
        }
        this._itemsLayoutService.updateNumCurrentItems(this.numCurrentItems());
        this._itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
    }
    focusSelectedItem() {
        this.cdkNodes?.find(node => node.data.id === this._selectedItem?.id)?.['_elementRef']?.nativeElement.children.item(0)?.focus();
    }
    onItemDetailsEndReached() {
        this.selectNextItem();
        this.focusSelectedItem();
    }
    /**
     * returns number of checked items that are currently visible
     */
    numCurrentItemsChecked() {
        let numChecked = 0;
        const allVisibleItems = this.getAllVisibleItems();
        this.checkedItems?.forEach(item => {
            if (allVisibleItems.find(visibleItem => visibleItem.id == item.id))
                numChecked++;
        });
        return numChecked;
    }
    onItemClicked(item) {
        if (window.getSelection().toString().length > 0) {
            return;
        }
        this.itemClicked.emit(item);
        if (this._selectedItem && item.id === this._selectedItem.id) {
            if (this.listProperties.hasDiselect) {
                this.selectedItem = undefined;
                this.itemDeselected.emit(item);
            }
            else {
                this.itemSelected.emit(item);
                return;
            }
        }
        else {
            this.selectedItem = item;
            this.itemSelected.emit(item);
        }
        this.selectedItemChange.emit(this.selectedItem);
    }
    onTreeNodeToggled(item, justOpen = false) {
        if (justOpen && this.isNodeExpanded(item)) //if leaf node or already expanded when justOpen
            return;
        this.treeControl.toggle(item);
        const isExpanded = this.isNodeExpanded(item);
        const isSelectedItemHidden = (this._selectedItem && !isExpanded) && this.treeControl.getDescendants(item).findIndex(curItem => curItem.id === this._selectedItem.id) >= 0;
        if (isSelectedItemHidden) {
            this._selectedItem = item;
            this.selectedItemChange.emit(this._selectedItem);
        }
        this.nodeToggled.emit({ item: item, expanded: isExpanded });
        this.updateHasNexPrevious();
        this._itemsLayoutService.updateNumCurrentItems(this.numCurrentItems());
        this._itemsLayoutService.updateNumCheckedCurrentItems(this.numCurrentItemsChecked());
    }
    actionsHandler(key, items) {
        if (key == 'delete' || key == 'remove')
            this.onDeleteItemsActionPerformed(items);
        else if (key == this.ACTION_KEY_MOVE)
            this.handleMoveAction(items);
    }
    handleMoveAction(items) {
        this.moveDialog.open(ExItemsLayoutTreeMoveTargetSelectionComponent, {
            data: {
                itemsToMove: items,
                treeFieldKey: this._treeFieldKey,
                datasource: this.listProperties.itemsLayoutTreeMoveDataSource
            }
        })
            .afterClosed().subscribe((selectedTargetId) => {
            if (selectedTargetId)
                this.onMove(items, selectedTargetId);
        });
    }
    onDeleteItemsActionPerformed(deletedItems) {
        if (deletedItems.find(curItem => curItem.id == this._selectedItem.id)) {
            let itemAfterDelete = this._selectedItem;
            let itemAfterDeleteIsDeleted = false;
            do {
                itemAfterDelete = this.findNextItemOnEqualOrGreaterLevel(itemAfterDelete);
                itemAfterDeleteIsDeleted = !!deletedItems.find(curItem => curItem.id == itemAfterDelete.id);
            } while (itemAfterDelete && itemAfterDeleteIsDeleted);
            if (!itemAfterDelete) {
                itemAfterDelete = this._selectedItem;
                do {
                    itemAfterDelete = this.findPreviousItem(itemAfterDelete);
                    itemAfterDeleteIsDeleted = !!deletedItems.find(curItem => curItem.id == itemAfterDelete.id);
                } while (itemAfterDelete && itemAfterDeleteIsDeleted);
            }
            this._nextItemAfterItemsDeleted = itemAfterDelete;
        }
        else {
            this._nextItemAfterItemsDeleted = this._selectedItem;
        }
    }
    onItemsDeleted() {
        this._itemsDeleted = true;
    }
    onMove(itemsToMove, selectedTargetId) {
        this.itemsMoved.emit({ itemsToMove: itemsToMove, moveTargetId: selectedTargetId });
    }
    collapseAll() {
        this.treeControl.collapseAll();
        this.selectedItem = undefined;
        this.selectedItemChange.emit(this._selectedItem);
    }
    getItemById(id) {
        return this._itemsMap.get(id).item;
    }
    getFlatItemsList() {
        return Array.from(this._itemsMap, ([id, entry]) => entry.item);
    }
    static { this.ɵfac = function ExItemsLayoutTreeComponent_Factory(t) { return new (t || ExItemsLayoutTreeComponent)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(i1$7.MatDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutTreeComponent, selectors: [["ex-items-layout-tree"]], viewQuery: function ExItemsLayoutTreeComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$f, 5);
            i0.ɵɵviewQuery(_c1$b, 5);
            i0.ɵɵviewQuery(_c2$6, 5);
            i0.ɵɵviewQuery(CdkNestedTreeNode, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollerElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tree = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkNodes = _t);
        } }, inputs: { selectedItem: "selectedItem", nodeContentTemplate: "nodeContentTemplate", onLoadExpandToLevel: "onLoadExpandToLevel" }, outputs: { nodeToggled: "nodeToggled", itemsMoved: "itemsMoved" }, exportAs: ["exListLayoutTree"], features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 12, vars: 3, consts: [[1, "ex-items-layout-tree-wrapper"], ["scrollerElement", ""], [4, "ngIf", "ngIfElse"], ["nodeTmpl", ""], ["defaultNodeContentTmpl", ""], ["actions", ""], ["placeholder", ""], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination", 4, "ngIf"], [1, "ex-items-layout-tree-collapse-all-button-wrapper"], [1, "ex-items-layout-tree-collapse-all-button", 3, "exTooltip", "click"], ["iconName", "expand_less"], [3, "dataSource", "treeControl", "trackBy"], ["tree", ""], ["class", "ex-items-layout-tree-node-leaf", 4, "cdkTreeNodeDef"], ["class", "ex-items-layout-tree-node-expandible", 4, "cdkTreeNodeDef", "cdkTreeNodeDefWhen"], [1, "ex-items-layout-tree-node-leaf"], ["tabindex", "0", 1, "ex-items-layout-tree-node-wrapper", 3, "keydown.enter", "keydown.arrowdown", "keydown.arrowup", "focusin"], ["nodeWrapperContainer", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-items-layout-tree-node-expandible"], ["nestedTreeNode", "cdkNestedTreeNode"], [1, "ex-items-layout-tree-node-expandible-group-container"], [1, "ex-items-layout-tree-node-expandible-group-line"], ["class", "ex-items-layout-tree-node-expandible-group-line ex-items-layout-tree-node-expandible-group-line-last-group", 4, "ngIf"], ["role", "group", 1, "ex-items-layout-tree-node-expandible-group"], ["cdkTreeNodeOutlet", ""], [1, "ex-items-layout-tree-node-expandible-group-line", "ex-items-layout-tree-node-expandible-group-line-last-group"], [1, "ex-items-layout-tree-node-list-item", 3, "click"], [3, "ngClass"], ["class", "ex-items-layout-tree-node-list-item-line", 4, "ngIf"], [1, "ex-items-layout-tree-node-expandible-group-toggle", 3, "ngClass", "ngStyle", "click"], ["iconName", "arrow", "color", "#0D7BBA", 1, "ex-items-layout-tree-arrow-icon"], [3, "checked", "disabled", "exTooltip", "ariaLabel", "checkedChange", "click", 4, "ngIf"], [1, "ex-items-layout-tree-node-template"], [4, "ngIf"], ["class", "ex-items-layout-tree-row-end-button", "aria-label", "move\n                        focus to right side", 3, "keyup.Tab", 4, "ngIf"], [1, "ex-items-layout-tree-node-list-item-line"], [3, "checked", "disabled", "exTooltip", "ariaLabel", "checkedChange", "click"], ["aria-label", "move\n                        focus to right side", 1, "ex-items-layout-tree-row-end-button", 3, "keyup.Tab"], [1, "ex-items-layout-tree-node-template-default", 3, "ngClass"], [3, "value", "highlightedText", "isBold"], [1, "ex-items-layout-tree-node-actions"], [3, "actions", "visibleBtnNum", "loading", "isSelected", "actionClicked", 4, "ngIf"], [3, "actions", "visibleBtnNum", "loading", "isSelected", "actionClicked"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination"], ["paginationRef", ""]], template: function ExItemsLayoutTreeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵtemplate(2, ExItemsLayoutTreeComponent_ng_container_2_Template, 12, 10, "ng-container", 2);
            i0.ɵɵtemplate(3, ExItemsLayoutTreeComponent_ng_template_3_Template, 10, 20, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ExItemsLayoutTreeComponent_ng_template_5_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, ExItemsLayoutTreeComponent_ng_template_7_Template, 2, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, ExItemsLayoutTreeComponent_ng_template_9_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(11, ExItemsLayoutTreeComponent_ex_pagination_11_Template, 2, 5, "ex-pagination", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r8 = i0.ɵɵreference(10);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.listProperties.isLoading)("ngIfElse", _r8);
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngIf", ctx.listProperties.pagination.totalItemsCount > 0);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i6$3.CdkNestedTreeNode, i6$3.CdkTreeNodeDef, i6$3.CdkTree, i6$3.CdkTreeNodeOutlet, ExTooltipDirective, ExPaginationComponent, ExLabelComponent, ExSvgIconComponent, ExCheckboxComponent, ExRecordActionsComponent, ExItemsLayoutTreePlaceholderComponent, i1$2.TranslatePipe], styles: [".ex-items-layout-tree-wrapper[_ngcontent-%COMP%]{padding-top:15px;padding-bottom:15px;padding-inline-start:10px;overflow:auto;height:100%}.ex-items-layout-tree-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-collapse-all-button-wrapper[_ngcontent-%COMP%]{display:flex;column-gap:5px;width:-moz-fit-content;width:fit-content;margin-bottom:5px}.ex-items-layout-tree-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-collapse-all-button-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-collapse-all-button[_ngcontent-%COMP%]{border:0}.ex-items-layout-tree-group-invisible[_ngcontent-%COMP%]{display:none}.ex-items-layout-tree-node-expandible-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle[_ngcontent-%COMP%], .ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle[_ngcontent-%COMP%]{background:transparent;border:0;margin-inline-end:5px}.ex-items-layout-tree-node-expandible-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle[_ngcontent-%COMP%]     svg, .ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle[_ngcontent-%COMP%]     svg{transform:rotate(-90deg)}.ex-items-layout-tree-node-expandible-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle.ex-items-layout-tree-node-expandible-group-toggle-expanded[_ngcontent-%COMP%]     svg, .ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-toggle.ex-items-layout-tree-node-expandible-group-toggle-expanded[_ngcontent-%COMP%]     svg{transform:rotate(-45deg)}.ex-items-layout-tree-node-expandible-group[_ngcontent-%COMP%]{padding-inline-start:22px}.ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]{display:flex}.ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-leaf-empty-toggle[_ngcontent-%COMP%]{width:0px;margin-inline-start:19px}.ex-items-layout-tree-node-expandible-container[_ngcontent-%COMP%], .ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]{padding-top:5px;padding-bottom:5px;padding-inline-end:5px;display:flex;align-items:center;height:40px}.ex-items-layout-tree-node-expandible-container[_ngcontent-%COMP%]     ex-checkbox .mat-checkbox-layout, .ex-items-layout-tree-node-leaf-container[_ngcontent-%COMP%]     ex-checkbox .mat-checkbox-layout{margin-bottom:3px}.ex-items-layout-tree-node-expandible-container.ex-items-layout-tree-node-selected[_ngcontent-%COMP%], .ex-items-layout-tree-node-leaf-container.ex-items-layout-tree-node-selected[_ngcontent-%COMP%]{border-inline-start-color:#0e7bba!important;background:#eaf2f6}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]{display:flex;min-width:-moz-fit-content;min-width:fit-content}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]{list-style-type:none;width:100%}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]:hover:enabled{cursor:pointer}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start;margin-inline-end:15px;width:100%;overflow:hidden}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template-default[_ngcontent-%COMP%]{width:100%}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template-default[_ngcontent-%COMP%]     .ex-label-value{max-width:100%}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]   .ex-items-layout-tree-node-list-item[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template[_ngcontent-%COMP%]   .ex-items-layout-tree-node-template-default[_ngcontent-%COMP%]     .ex-label-value span.sel-value>span{text-overflow:ellipsis;white-space:nowrap;max-width:100%;display:inline-block;overflow:hidden}.ex-items-layout-tree-node-wrapper[_ngcontent-%COMP%]:hover{background:#f4f8fa}ex-checkbox[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-items-layout-tree-node-expandible-group-container[_ngcontent-%COMP%]{position:relative}.ex-items-layout-tree-node-expandible-group-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-line[_ngcontent-%COMP%]{margin-inline-start:5px;padding-bottom:5px;position:absolute;height:100%;top:-15px;inset-inline-start:2px}.ex-items-layout-tree-node-expandible-group-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-line[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{height:100%;border-inline-start:1px dotted black}.ex-items-layout-tree-node-expandible-group-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-line.ex-items-layout-tree-node-expandible-group-line-last-group[_ngcontent-%COMP%]{top:-20px;inset-inline-start:-20px}.ex-items-layout-tree-node-expandible-group-container[_ngcontent-%COMP%]   .ex-items-layout-tree-node-expandible-group-line.ex-items-layout-tree-node-expandible-group-line-last-group[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{border-inline-start:1px solid white;height:101%}.ex-items-layout-tree-node-list-item-line[_ngcontent-%COMP%]{align-self:center;margin-inline-start:-15px;width:18px}.ex-items-layout-tree-node-list-item-line[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{border-top:1px dotted black;height:1px;width:80%}.ex-items-layout-tree-node-actions[_ngcontent-%COMP%]{margin-inline-start:auto}.ex-items-layout-tree-move-action-selection[_ngcontent-%COMP%]{display:none}.ex-items-layout-tree-move-action-selection[_ngcontent-%COMP%]     .flexbrowse-selection-menu-wrapper{width:-moz-fit-content;width:fit-content;min-width:400px}.ex-items-layout-tree-row-end-button[_ngcontent-%COMP%]{width:0;height:0;background:none;border:none;outline:none}  .ex-items-layout-left .ex-items-layout-tree-wrapper{padding-inline-end:15px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutTreeComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-tree', exportAs: 'exListLayoutTree', template: "<div #scrollerElement class=\"ex-items-layout-tree-wrapper\">\r\n\r\n  <ng-container *ngIf=\"!listProperties.isLoading; else placeholder\">\r\n    <div class=\"ex-items-layout-tree-collapse-all-button-wrapper\">\r\n      <button class=\"ex-items-layout-tree-collapse-all-button\"\r\n              [exTooltip]=\"'ng.items_layout.tree.collapse_all' | translate\" (click)=\"collapseAll()\">\r\n        <ex-svg-icon iconName=\"expand_less\"></ex-svg-icon>\r\n      </button>\r\n      <span>{{'ng.items_layout.tree.collapse_all' | translate}}</span>\r\n    </div>\r\n    <cdk-tree #tree [dataSource]=\"dataSource\" [treeControl]=\"treeControl\" [trackBy]=\"trackById\">\r\n      <!-- leaf node template -->\r\n      <cdk-nested-tree-node *cdkTreeNodeDef=\"let node; let level = level\" class=\"ex-items-layout-tree-node-leaf\">\r\n        <div #nodeWrapperContainer class=\"ex-items-layout-tree-node-wrapper\" tabindex=\"0\"\r\n             (keydown.enter)=\"onItemClicked(node)\" (keydown.arrowdown)=\"onRowArrowDown($event)\"\r\n             (keydown.arrowup)=\"onRowArrowUp($event)\" (focusin)=\"scrollToSelectedItem(nodeWrapperContainer)\">\r\n          <ng-container\r\n            *ngTemplateOutlet=\"nodeTmpl; context: { type: 'leaf', node: node, level: level, isExpanded: false, isSelected: _selectedItem && node.id === _selectedItem.id }\">\r\n          </ng-container>\r\n        </div>\r\n      </cdk-nested-tree-node>\r\n      <!-- expandable node template -->\r\n      <cdk-nested-tree-node *cdkTreeNodeDef=\"let node; let level = level; when: hasChild\"\r\n                            #nestedTreeNode=\"cdkNestedTreeNode\" class=\"ex-items-layout-tree-node-expandible\">\r\n        <div #nodeWrapperContainer class=\"ex-items-layout-tree-node-wrapper\" tabindex=\"0\"\r\n             (keydown.enter)=\"onItemClicked(node);onTreeNodeToggled(node,true);\" (keydown.arrowdown)=\"onRowArrowDown($event)\"\r\n             (keydown.arrowup)=\"onRowArrowUp($event)\" (focusin)=\"scrollToSelectedItem(nodeWrapperContainer)\">\r\n          <ng-container\r\n            *ngTemplateOutlet=\"nodeTmpl; context: { type: 'expandable', node: node, level: level, isExpanded: nestedTreeNode.isExpanded, isSelected: _selectedItem && node.id === _selectedItem.id }\">\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"ex-items-layout-tree-node-expandible-group-container\">\r\n          <div class=\"ex-items-layout-tree-node-expandible-group-line\">\r\n            <div>&nbsp;</div>\r\n          </div>\r\n          <div *ngIf=\"level != 0 && nestedTreeNode.isExpanded && isLastChild(node.id)\"\r\n               class=\"ex-items-layout-tree-node-expandible-group-line ex-items-layout-tree-node-expandible-group-line-last-group\">\r\n            <div>&nbsp;</div>\r\n          </div>\r\n          <div class=\"ex-items-layout-tree-node-expandible-group\"\r\n               [class.ex-items-layout-tree-group-invisible]=\"!treeControl.isExpanded(node)\" role=\"group\">\r\n            <ng-container cdkTreeNodeOutlet></ng-container>\r\n          </div>\r\n        </div>\r\n\r\n      </cdk-nested-tree-node>\r\n    </cdk-tree>\r\n  </ng-container>\r\n\r\n\r\n  <ng-template #nodeTmpl let-type=\"type\" let-node=\"node\" let-level=\"level\" let-isExpanded=\"isExpanded\"\r\n               let-isSelected=\"isSelected\">\r\n    <li class=\"ex-items-layout-tree-node-list-item\"\r\n        (click)=\"onItemClicked(node); onTreeNodeToggled(node,true)\">\r\n      <div [ngClass]=\"{'ex-items-layout-tree-node-expandible-container': type == 'expandable',\r\n                             'ex-items-layout-tree-node-leaf-container': type == 'leaf',\r\n                             'ex-items-layout-tree-node-selected' : isSelected}\">\r\n        <div *ngIf=\"level != 0\" class=\"ex-items-layout-tree-node-list-item-line\">\r\n          <div>&nbsp;</div>\r\n        </div>\r\n        <button class=\"ex-items-layout-tree-node-expandible-group-toggle\"\r\n                [ngClass]=\"isExpanded ? 'ex-items-layout-tree-node-expandible-group-toggle-expanded' : 'ex-items-layout-tree-node-expandible-group-toggle-collapsed'\"\r\n                [ngStyle]=\"{visibility: type == 'expandable' ? 'visible' : 'hidden'}\"\r\n                [attr.aria-label]=\"'Toggle tree node'\" (click)=\"$event.stopPropagation(); onTreeNodeToggled(node)\">\r\n          <ex-svg-icon iconName=\"arrow\" color=\"#0D7BBA\" class=\"ex-items-layout-tree-arrow-icon\">\r\n          </ex-svg-icon>\r\n        </button>\r\n        <ex-checkbox *ngIf=\"listProperties.hasPickup\" [checked]=\"isItemChecked(node)\" [disabled]=\"node.selectable===false\"  [exTooltip]=\"node.selectable!==false? '':node.nonSelectableTooltip | translate\"\r\n                     (checkedChange)=\"onItemCheckedChange(node, $event)\" (click)=\"$event.stopPropagation()\"\r\n                     [ariaLabel]=\"'ng.ex_items_layout_list_row.check_or_uncheck' | translate\">\r\n        </ex-checkbox>\r\n        <div class=\"ex-items-layout-tree-node-template\">\r\n          <ng-container\r\n            *ngTemplateOutlet=\"nodeContentTemplate ? nodeContentTemplate : defaultNodeContentTmpl; context: { $implicit: node, isSelected: isSelected, isExpanded: isExpanded }\">\r\n          </ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"isSelected\">\r\n          <ng-container *ngTemplateOutlet=\"actions; context: { node: node, isSelected: isSelected }\">\r\n          </ng-container>\r\n        </ng-container>\r\n      </div>\r\n    </li>\r\n    <button *ngIf=\"isItemOpen && isSelected\" class=\"ex-items-layout-tree-row-end-button\" aria-label=\"move\r\n                        focus to right side\" (keyup.Tab)=\"onTabFromRowEnd()\"></button>\r\n  </ng-template>\r\n\r\n  <ng-template #defaultNodeContentTmpl let-node let-isSelected=\"isSelected\">\r\n    <div class=\"ex-items-layout-tree-node-template-default\"\r\n         [ngClass]=\"{ 'ex-items-layout-tree-node-item-selected': isSelected }\">\r\n      <ex-label [value]=\"_treeFieldKey ? node.listItem[_treeFieldKey] : ''\"\r\n                [highlightedText]=\"listProperties.searchText\" [isBold]=\"isSelected\">\r\n      </ex-label>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #actions let-node=\"node\" let-isSelected=\"isSelected\">\r\n    <div class=\"ex-items-layout-tree-node-actions\">\r\n      <ex-record-actions *ngIf=\"node.listItem.__proto__.actions\" [actions]=\"node.listItem.actions?.actions\"\r\n                         [visibleBtnNum]=\"node.listItem.actions?.visibleBtnNum\"\r\n                         [loading]=\"node.listItem.actions?.loading\"\r\n                         [isSelected]=\"isSelected\" (actionClicked)=\"onActionClicked(node, $event)\">\r\n      </ex-record-actions>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #placeholder>\r\n    <ex-items-layout-tree-placeholder></ex-items-layout-tree-placeholder>\r\n  </ng-template>\r\n\r\n  <ex-pagination #paginationRef *ngIf=\"listProperties.pagination.totalItemsCount > 0\"\r\n                 [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\r\n                 [pageSize]=\"listProperties.pagination.pageSize\"\r\n                 [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\r\n                 [selectedPage]=\"listProperties.pagination.selectedPage\"\r\n                 (selectedPageChange)=\"onSelectedPageChange($event)\" (pageSizeChange)=\"onPageSizeChange($event)\"\r\n                 (endOfPagination)=\"endOfPagination.emit()\" [doNotUpdateStateInternally]=\"true\"></ex-pagination>\r\n</div>\r\n", styles: [".ex-items-layout-tree-wrapper{padding-top:15px;padding-bottom:15px;padding-inline-start:10px;overflow:auto;height:100%}.ex-items-layout-tree-wrapper .ex-items-layout-tree-collapse-all-button-wrapper{display:flex;column-gap:5px;width:-moz-fit-content;width:fit-content;margin-bottom:5px}.ex-items-layout-tree-wrapper .ex-items-layout-tree-collapse-all-button-wrapper .ex-items-layout-tree-collapse-all-button{border:0}.ex-items-layout-tree-group-invisible{display:none}.ex-items-layout-tree-node-expandible-container .ex-items-layout-tree-node-expandible-group-toggle,.ex-items-layout-tree-node-leaf-container .ex-items-layout-tree-node-expandible-group-toggle{background:transparent;border:0;margin-inline-end:5px}.ex-items-layout-tree-node-expandible-container .ex-items-layout-tree-node-expandible-group-toggle ::ng-deep svg,.ex-items-layout-tree-node-leaf-container .ex-items-layout-tree-node-expandible-group-toggle ::ng-deep svg{transform:rotate(-90deg)}.ex-items-layout-tree-node-expandible-container .ex-items-layout-tree-node-expandible-group-toggle.ex-items-layout-tree-node-expandible-group-toggle-expanded ::ng-deep svg,.ex-items-layout-tree-node-leaf-container .ex-items-layout-tree-node-expandible-group-toggle.ex-items-layout-tree-node-expandible-group-toggle-expanded ::ng-deep svg{transform:rotate(-45deg)}.ex-items-layout-tree-node-expandible-group{padding-inline-start:22px}.ex-items-layout-tree-node-leaf-container{display:flex}.ex-items-layout-tree-node-leaf-container .ex-items-layout-tree-node-leaf-empty-toggle{width:0px;margin-inline-start:19px}.ex-items-layout-tree-node-expandible-container,.ex-items-layout-tree-node-leaf-container{padding-top:5px;padding-bottom:5px;padding-inline-end:5px;display:flex;align-items:center;height:40px}.ex-items-layout-tree-node-expandible-container ::ng-deep ex-checkbox .mat-checkbox-layout,.ex-items-layout-tree-node-leaf-container ::ng-deep ex-checkbox .mat-checkbox-layout{margin-bottom:3px}.ex-items-layout-tree-node-expandible-container.ex-items-layout-tree-node-selected,.ex-items-layout-tree-node-leaf-container.ex-items-layout-tree-node-selected{border-inline-start-color:#0e7bba!important;background:#eaf2f6}.ex-items-layout-tree-node-wrapper{display:flex;min-width:-moz-fit-content;min-width:fit-content}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item{list-style-type:none;width:100%}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item:hover:enabled{cursor:pointer}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item .ex-items-layout-tree-node-template{display:flex;align-items:center;justify-content:flex-start;margin-inline-end:15px;width:100%;overflow:hidden}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item .ex-items-layout-tree-node-template .ex-items-layout-tree-node-template-default{width:100%}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item .ex-items-layout-tree-node-template .ex-items-layout-tree-node-template-default ::ng-deep .ex-label-value{max-width:100%}.ex-items-layout-tree-node-wrapper .ex-items-layout-tree-node-list-item .ex-items-layout-tree-node-template .ex-items-layout-tree-node-template-default ::ng-deep .ex-label-value span.sel-value>span{text-overflow:ellipsis;white-space:nowrap;max-width:100%;display:inline-block;overflow:hidden}.ex-items-layout-tree-node-wrapper:hover{background:#f4f8fa}ex-checkbox{margin-inline-end:5px}.ex-items-layout-tree-node-expandible-group-container{position:relative}.ex-items-layout-tree-node-expandible-group-container .ex-items-layout-tree-node-expandible-group-line{margin-inline-start:5px;padding-bottom:5px;position:absolute;height:100%;top:-15px;inset-inline-start:2px}.ex-items-layout-tree-node-expandible-group-container .ex-items-layout-tree-node-expandible-group-line div{height:100%;border-inline-start:1px dotted black}.ex-items-layout-tree-node-expandible-group-container .ex-items-layout-tree-node-expandible-group-line.ex-items-layout-tree-node-expandible-group-line-last-group{top:-20px;inset-inline-start:-20px}.ex-items-layout-tree-node-expandible-group-container .ex-items-layout-tree-node-expandible-group-line.ex-items-layout-tree-node-expandible-group-line-last-group div{border-inline-start:1px solid white;height:101%}.ex-items-layout-tree-node-list-item-line{align-self:center;margin-inline-start:-15px;width:18px}.ex-items-layout-tree-node-list-item-line div{border-top:1px dotted black;height:1px;width:80%}.ex-items-layout-tree-node-actions{margin-inline-start:auto}.ex-items-layout-tree-move-action-selection{display:none}.ex-items-layout-tree-move-action-selection ::ng-deep .flexbrowse-selection-menu-wrapper{width:-moz-fit-content;width:fit-content;min-width:400px}.ex-items-layout-tree-row-end-button{width:0;height:0;background:none;border:none;outline:none}::ng-deep .ex-items-layout-left .ex-items-layout-tree-wrapper{padding-inline-end:15px}\n"] }]
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }, { type: i1$7.MatDialog }]; }, { selectedItem: [{
            type: Input
        }], nodeContentTemplate: [{
            type: Input
        }], onLoadExpandToLevel: [{
            type: Input
        }], nodeToggled: [{
            type: Output
        }], itemsMoved: [{
            type: Output
        }], scrollerElement: [{
            type: ViewChild,
            args: ['scrollerElement']
        }], tree: [{
            type: ViewChild,
            args: ['tree']
        }], cdkNodes: [{
            type: ViewChildren,
            args: [CdkNestedTreeNode]
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }] }); })();

class ExItemsLayoutTreeModule {
    static { this.ɵfac = function ExItemsLayoutTreeModule_Factory(t) { return new (t || ExItemsLayoutTreeModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExItemsLayoutTreeModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: MAT_DIALOG_DEFAULT_OPTIONS,
                useValue: {
                    ...new MatDialogConfig()
                },
            }
        ], imports: [CommonModule,
            FormsModule,
            MatTreeModule,
            CdkTreeModule,
            MatDialogModule,
            ExDirectivesModule,
            ExPaginationModule,
            ExLabelModule,
            TranslateModule,
            ExSvgIconModule,
            ExDragModule,
            ExSvgIconModule,
            ExCheckboxModule,
            ExRecordActionsModule,
            ExButtonModule,
            ExAutocompleteModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutTreeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatTreeModule,
                    CdkTreeModule,
                    MatDialogModule,
                    ExDirectivesModule,
                    ExPaginationModule,
                    ExLabelModule,
                    TranslateModule,
                    ExSvgIconModule,
                    ExDragModule,
                    ExSvgIconModule,
                    ExCheckboxModule,
                    ExRecordActionsModule,
                    ExButtonModule,
                    ExAutocompleteModule,
                    EXPipesModule
                ],
                declarations: [
                    ExItemsLayoutTreeComponent,
                    ExItemsLayoutTreeMoveTargetSelectionComponent,
                    ExItemsLayoutTreePlaceholderComponent
                ],
                providers: [
                    {
                        provide: MAT_DIALOG_DEFAULT_OPTIONS,
                        useValue: {
                            ...new MatDialogConfig()
                        },
                    }
                ],
                exports: [
                    ExItemsLayoutTreeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExItemsLayoutTreeModule, { declarations: [ExItemsLayoutTreeComponent,
        ExItemsLayoutTreeMoveTargetSelectionComponent,
        ExItemsLayoutTreePlaceholderComponent], imports: [CommonModule,
        FormsModule,
        MatTreeModule,
        CdkTreeModule,
        MatDialogModule,
        ExDirectivesModule,
        ExPaginationModule,
        ExLabelModule,
        TranslateModule,
        ExSvgIconModule,
        ExDragModule,
        ExSvgIconModule,
        ExCheckboxModule,
        ExRecordActionsModule,
        ExButtonModule,
        ExAutocompleteModule,
        EXPipesModule], exports: [ExItemsLayoutTreeComponent] }); })();
i0.ɵɵsetComponentScope(ExItemsLayoutTreeMoveTargetSelectionComponent, [i1$5.NgIf, i1$5.NgTemplateOutlet, i1$7.MatDialogTitle, i1$7.MatDialogContent, i1$7.MatDialogActions, ExTooltipDirective, ExButtonComponent, ExAutocompleteComponent], [i1$2.TranslatePipe, ExTextHighlightPipe, ExTextStylePipe]);

class ExItemsLayoutGridColumnsPipe {
    /**
     * @param columns - the columns data from the grid schema
     * @param displayedColumns - an array of column identifiers, already sorted and filtered
     * @param columnsCustomization - the grid customization data
     * @return - returns the columns data for the provided displayedColumns
     */
    transform(columns, displayedColumns, columnsCustomization) {
        // Assumes displayedColumns is already sorted and filtered
        return displayedColumns.map(columnKey => columns.find(col => col.columnIdentifier === columnKey)).filter(columnData => !!columnData);
    }
    static { this.ɵfac = function ExItemsLayoutGridColumnsPipe_Factory(t) { return new (t || ExItemsLayoutGridColumnsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "itemsLayoutGridColumns", type: ExItemsLayoutGridColumnsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutGridColumnsPipe, [{
        type: Pipe,
        args: [{
                name: 'itemsLayoutGridColumns'
            }]
    }], null, null); })();

class ExItemsLayoutGridModule {
    static { this.ɵfac = function ExItemsLayoutGridModule_Factory(t) { return new (t || ExItemsLayoutGridModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExItemsLayoutGridModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatSlideToggleModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExRecordActionsModule,
            ExPaginationModule,
            ExComponentLoaderModule,
            ExListHeaderModule,
            TranslateModule,
            ExIconModule,
            ExSvgIconModule,
            ExLinkModule,
            ExButtonModule,
            DragDropModule,
            ExDragModule,
            ExCheckboxModule,
            MatTooltipModule,
            ExRightClickActionsModule,
            ExGridLayoutModule,
            ExChipRecordModule,
            ExSlideToggleModule,
            EXPipesModule,
            MatRadioModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutGridModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatSlideToggleModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExRecordActionsModule,
                    ExPaginationModule,
                    ExComponentLoaderModule,
                    ExListHeaderModule,
                    TranslateModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExLinkModule,
                    ExButtonModule,
                    DragDropModule,
                    ExDragModule,
                    ExCheckboxModule,
                    MatTooltipModule,
                    ExRightClickActionsModule,
                    ExGridLayoutModule,
                    ExChipRecordModule,
                    ExSlideToggleModule,
                    EXPipesModule,
                    MatRadioModule,
                ],
                declarations: [
                    ExItemsLayoutGridComponent,
                    ExItemsLayoutGridColumnsPipe
                ],
                exports: [
                    ExItemsLayoutGridComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExItemsLayoutGridModule, { declarations: [ExItemsLayoutGridComponent,
        ExItemsLayoutGridColumnsPipe], imports: [CommonModule,
        MatSlideToggleModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExRecordActionsModule,
        ExPaginationModule,
        ExComponentLoaderModule,
        ExListHeaderModule,
        TranslateModule,
        ExIconModule,
        ExSvgIconModule,
        ExLinkModule,
        ExButtonModule,
        DragDropModule,
        ExDragModule,
        ExCheckboxModule,
        MatTooltipModule,
        ExRightClickActionsModule,
        ExGridLayoutModule,
        ExChipRecordModule,
        ExSlideToggleModule,
        EXPipesModule,
        MatRadioModule], exports: [ExItemsLayoutGridComponent] }); })();
i0.ɵɵsetComponentScope(ExItemsLayoutGridComponent, [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExTooltipDirective, ResizedDirective, ExRecordActionsComponent, ExPaginationComponent, ExComponentLoaderComponent, ExSvgIconComponent, ExLinkComponent, ExButtonComponent, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, i15.CdkDragPreview, i15.CdkDragPlaceholder, ExDragAccessibleIconComponent, ExDragDirective, ExDragListDirective, ExCheckboxComponent, ExRightClickActionsComponent, ExResizeColumnDirective, ExChipRecordComponent, ExChipRecordEntityLabelsComponent, ExSlideToggleComponent, i8.MatRadioButton], [i1$2.TranslatePipe, ExTextHighlightPipe, ExObjectAssignPipe, ExUnderThumbnailIconsPipe, ExIsSortableColumnPipe, ExItemsLayoutGridColumnsPipe]);

class ExGalleryFieldPipe {
    transform(value) {
        let iconsList = [];
        if (value?.__proto__?.galleryField && value?.__proto__?.galleryField?.length > 0) {
            iconsList = value.__proto__.galleryField.map(icon => {
                return { ...icon, value: value[icon.key] };
            });
            return iconsList;
        }
        return null;
    }
    static { this.ɵfac = function ExGalleryFieldPipe_Factory(t) { return new (t || ExGalleryFieldPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exGalleryField", type: ExGalleryFieldPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExGalleryFieldPipe, [{
        type: Pipe,
        args: [{
                name: 'exGalleryField'
            }]
    }], null, null); })();

const _c0$e = ["subList"];
const _c1$a = ["paginationRef"];
const _c2$5 = ["rowItemRef"];
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("focusin", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template_button_focusin_0_listener($event) { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r31.onRowStartFocused($event)); });
    i0.ɵɵelementEnd();
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_9_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 37);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    const i_r6 = ctx_r34.index;
    const item_r5 = ctx_r34.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-gallery-warning-icon sel-warning-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "ex-drag-accessible-icon", 35);
    i0.ɵɵtemplate(2, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_9_i_2_Template, 3, 6, "i", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r5.mode == null ? null : item_r5.mode.value) === "WARNING" && !ctx_r14.listProperties.hasPickup);
} }
const _c3$3 = function (a0) { return { "ex-items-layout-gallery-disabled-row-item": a0 }; };
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const isItemSelected_r9 = i0.ɵɵnextContext().isItemSelected;
    const ctx_r37 = i0.ɵɵnextContext();
    const item_r5 = ctx_r37.$implicit;
    const i_r6 = ctx_r37.index;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", isItemSelected_r9 ? "selectedItemInList" : null)("ngClass", i0.ɵɵpureFunction1(3, _c3$3, item_r5.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (ctx_r15.listProperties.pagination.selectedPage - 1) * ctx_r15.listProperties.pagination.pageSize + i_r6 + 1, " ");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_ex_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 42);
    i0.ɵɵlistener("checkedChange", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_ex_checkbox_1_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r42); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.onItemCheckedChange(item_r5, $event)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    const item_r5 = ctx_r43.$implicit;
    const i_r6 = ctx_r43.index;
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", item_r5.selectable === false)("checked", ctx_r38.isItemChecked(item_r5))("exTooltip", item_r5.selectable !== false ? "" : i0.ɵɵpipeBind1(1, 5, item_r5.nonSelectableTooltip))("ariaLabel", i0.ɵɵpipeBind1(2, 7, "ng.ex_items_layout_list_row.check_or_uncheck") + " " + ((ctx_r38.listProperties.pagination.selectedPage - 1) * ctx_r38.listProperties.pagination.pageSize + i_r6 + 1));
    i0.ɵɵattribute("aria-hidden", !(!ctx_r38.listProperties.isLoading && ctx_r38.readyToLoad));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-radio-button", 43);
    i0.ɵɵlistener("keydown.space", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_mat_radio_button_2_Template_mat_radio_button_keydown_space_0_listener() { i0.ɵɵrestoreView(_r46); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.onSingleItemCheckedChange(item_r5)); })("click", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_mat_radio_button_2_Template_mat_radio_button_click_0_listener() { i0.ɵɵrestoreView(_r46); const item_r5 = i0.ɵɵnextContext(3).$implicit; const ctx_r47 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r47.onSingleItemCheckedChange(item_r5)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(3);
    const i_r6 = ctx_r49.index;
    const item_r5 = ctx_r49.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("aria-labelledby", "recordId-", i_r6, "");
    i0.ɵɵproperty("checked", ctx_r39.isItemChecked(item_r5));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵlistener("mousedown", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template_div_mousedown_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("mouseup", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template_div_mouseup_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("click", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template_div_click_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("focus", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template_div_focus_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); })("focusin", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template_div_focusin_0_listener($event) { $event.stopImmediatePropagation(); return $event.preventDefault(); });
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_ex_checkbox_1_Template, 3, 9, "ex-checkbox", 40);
    i0.ɵɵtemplate(2, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_mat_radio_button_2_Template, 1, 2, "mat-radio-button", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.listProperties.isMultiSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r16.listProperties.isMultiSelect);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 44);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#e54746")("iconName", "circ_warning");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 44);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#e7a141")("iconName", "warning");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 44);
} if (rf & 2) {
    i0.ɵɵproperty("color", "#60c05f")("iconName", "success");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_i_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 37);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " error ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    const i_r6 = ctx_r55.index;
    const item_r5 = ctx_r55.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-gallery-warning-icon sel-warning-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_i_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 37);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, " check_circle ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    const i_r6 = ctx_r56.index;
    const item_r5 = ctx_r56.$implicit;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-gallery-valid-icon sel-valid-", i_r6, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 4, item_r5.mode == null ? null : item_r5.mode.tooltip));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_icon_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 45);
} if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext(2).index;
    i0.ɵɵclassMapInterpolate1("material-icons ex-items-layout-gallery-suppress-icon sel-suppress-", i_r6, "");
    i0.ɵɵproperty("iconName", "visibility-off")("iconType", "svg");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 46);
} if (rf & 2) {
    const icon_r58 = ctx.$implicit;
    i0.ɵɵproperty("iconName", icon_r58 == null ? null : icon_r58.iconName)("color", icon_r58 == null ? null : icon_r58.iconColor)("tooltip", icon_r58 == null ? null : icon_r58.tooltip)("callback", (icon_r58 == null ? null : icon_r58.callback) ? icon_r58 == null ? null : icon_r58.callback : null);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_21_ex_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 46);
} if (rf & 2) {
    const icon_r59 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconName", icon_r59 == null ? null : icon_r59.iconName)("color", icon_r59 == null ? null : icon_r59.iconColor)("tooltip", icon_r59 == null ? null : icon_r59.tooltip)("callback", (icon_r59 == null ? null : icon_r59.callback) ? icon_r59 == null ? null : icon_r59.callback : null);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_21_ex_svg_icon_1_Template, 1, 4, "ex-svg-icon", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const icon_r59 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", icon_r59);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 47);
    i0.ɵɵlistener("click", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_button_23_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r64); const item_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r62 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r62.onActionClicked(item_r5, ctx_r62.SINGLE_SAVE_EDIT_ACTION_KEY)); });
    i0.ɵɵelement(1, "ex-svg-icon", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltip", "ng.general.edit");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ex-label", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-record-title-and-actions-title sel-", item_r5.listItem.__proto__.title.key, "");
    i0.ɵɵproperty("value", item_r5.listItem[item_r5.listItem.__proto__.title.key])("isBold", true)("displayTooltip", true);
    i0.ɵɵattribute("role", "heading")("aria-level", "3");
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_ex_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-label", 52);
} if (rf & 2) {
    const field_r66 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("ex-record-labels-rows sel-", field_r66.key, " ex-record-label");
    i0.ɵɵproperty("arguments", field_r66);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 53);
    i0.ɵɵelement(1, "ex-label", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r66 = i0.ɵɵnextContext().$implicit;
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassProp("ex-gallery-is-main-link", field_r66.isMainLink);
    i0.ɵɵproperty("routerLink", item_r5.listItem[field_r66.link]);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-record-labels-rows sel-", field_r66.key, " ex-record-label");
    i0.ɵɵproperty("arguments", field_r66);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_ex_label_1_Template, 1, 4, "ex-label", 50);
    i0.ɵɵtemplate(2, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_a_2_Template, 2, 7, "a", 51);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r66 = ctx.$implicit;
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (field_r66 == null ? null : field_r66.value) && !field_r66.link);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (field_r66 == null ? null : field_r66.value) && field_r66.link && item_r5.listItem[field_r66.link]);
} }
const _c4$1 = function (a2) { return { disabled: false, isDisabled: false, htmlId: a2, breakpoint: 1 }; };
const _c5$1 = function () { return {}; };
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_30_ex_component_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 55);
    i0.ɵɵpipe(1, "objectAssign");
} if (rf & 2) {
    const row_r73 = i0.ɵɵnextContext().$implicit;
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r74 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(row_r73.style);
    i0.ɵɵclassMapInterpolate3("ex-record-full-width sel-", row_r73.key, " sel-", row_r73.key, "-", item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem["id"], "");
    i0.ɵɵproperty("componentFactoryItem", ctx_r74.componentFactoryItemsMap[row_r73.key])("data", i0.ɵɵpipeBind2(1, 11, item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem[row_r73.key] == null ? null : item_r5.listItem[row_r73.key].inputs, i0.ɵɵpureFunction1(14, _c4$1, ctx_r74.htmlId)))("content", item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem[row_r73.key] == null ? null : item_r5.listItem[row_r73.key].content)("events", (item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem[row_r73.key] == null ? null : item_r5.listItem[row_r73.key].events) || i0.ɵɵpureFunction0(16, _c5$1));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_30_ex_component_loader_1_Template, 2, 17, "ex-component-loader", 54);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r73 = ctx.$implicit;
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem[row_r73.key]);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassMapInterpolate1("ex-items-layout-gallery-action-indication-reason-", item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.reason);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_32_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵlistener("keyup.Tab", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_32_Template_button_keyup_Tab_0_listener() { i0.ɵɵrestoreView(_r80); const ctx_r79 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r79.onTabFromRowEnd()); });
    i0.ɵɵelementEnd();
} }
const _c6$1 = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { "side-by-side-open": a0, "ex-items-layout-gallery-row-item-opened": a1, "ex-items-layout-gallery-row-item-disabled": a2, "ex-items-layout-gallery-checked": a3, "ex-items-layout-gallery-selected": a4, "ex-items-layout-gallery-large-density": a5, "ex-items-layout-gallery-row-item-dark-theme": a6, "ex-items-layout-gallery-selected-dark-theme": a7 }; };
const _c7$1 = function (a0, a1) { return { "ex-items-layout-gallery-disabled-content": a0, "ex-items-layout-gallery-disabled-row-item": a1 }; };
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_1_Template, 1, 0, "button", 9);
    i0.ɵɵelementStart(2, "div", 10, 11);
    i0.ɵɵlistener("click", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r81 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r81.onItemClicked(item_r5)); })("keydown.enter", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r84 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r84.onItemClicked(item_r5)); })("keydown.space", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_space_2_listener() { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r86 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r86.onItemClicked(item_r5)); })("keydown.arrowdown", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_arrowdown_2_listener($event) { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r88 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r88.onRowArrowDown($event, item_r5)); })("keydown.arrowup", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_div_keydown_arrowup_2_listener($event) { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r90 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r90.onRowArrowUp($event, item_r5)); });
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 13);
    i0.ɵɵelement(6, "ex-thumbnail", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 15)(8, "div", 16);
    i0.ɵɵtemplate(9, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_9_Template, 3, 1, "div", 17);
    i0.ɵɵtemplate(10, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_span_10_Template, 3, 5, "span", 18);
    i0.ɵɵtemplate(11, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_11_Template, 3, 2, "div", 19);
    i0.ɵɵelement(12, "div", 20);
    i0.ɵɵtemplate(13, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_13_Template, 1, 2, "ex-svg-icon", 21);
    i0.ɵɵtemplate(14, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_14_Template, 1, 2, "ex-svg-icon", 21);
    i0.ɵɵtemplate(15, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_15_Template, 1, 2, "ex-svg-icon", 21);
    i0.ɵɵelementContainerStart(16, 22);
    i0.ɵɵtemplate(17, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_i_17_Template, 3, 6, "i", 23);
    i0.ɵɵtemplate(18, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_i_18_Template, 3, 6, "i", 23);
    i0.ɵɵtemplate(19, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_icon_19_Template, 1, 5, "ex-icon", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(20, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_svg_icon_20_Template, 1, 4, "ex-svg-icon", 25);
    i0.ɵɵtemplate(21, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_21_Template, 2, 1, "ng-container", 26);
    i0.ɵɵpipe(22, "exUnderThumbnailIcons");
    i0.ɵɵtemplate(23, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ex_button_23_Template, 2, 1, "ex-button", 27);
    i0.ɵɵelementStart(24, "ex-record-actions", 28);
    i0.ɵɵlistener("actionClicked", function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template_ex_record_actions_actionClicked_24_listener($event) { i0.ɵɵrestoreView(_r83); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r92 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r92.onActionClicked(item_r5, $event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(25, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_25_Template, 2, 8, "div", 18);
    i0.ɵɵelementStart(26, "div", 29);
    i0.ɵɵtemplate(27, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_27_Template, 3, 2, "ng-container", 4);
    i0.ɵɵpipe(28, "exGalleryField");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 30);
    i0.ɵɵtemplate(30, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_ng_container_30_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_div_31_Template, 2, 4, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_button_32_Template, 1, 0, "button", 32);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const isItemSelected_r9 = ctx.isItemSelected;
    const isSublistOpen_r10 = ctx.isSublistOpen;
    const isOtherSublistOpen_r11 = ctx.isOtherSublistOpen;
    const ctx_r94 = i0.ɵɵnextContext();
    const i_r6 = ctx_r94.index;
    const item_r5 = ctx_r94.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("sel-row-", i_r6, "-item ex-items-layout-gallery-li");
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r8.listProperties.hasDrag);
    i0.ɵɵattribute("aria-hidden", isOtherSublistOpen_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isItemOpen && isItemSelected_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRippleColor", ctx_r8.hasItemDetailsComponent && !isItemSelected_r9 ? "#eff4f74f" : "transparent")("ngClass", i0.ɵɵpureFunction8(45, _c6$1, ctx_r8.isItemOpen, isSublistOpen_r10, isOtherSublistOpen_r11, ctx_r8.isItemChecked(item_r5), ctx_r8.listProperties.canSelectRow && isItemSelected_r9, ctx_r8.listProperties.density === "large", ctx_r8.listProperties.isDarkTheme, ctx_r8.listProperties.canSelectRow && isItemSelected_r9 && ctx_r8.listProperties.isDarkTheme));
    i0.ɵɵattribute("role", ctx_r8.listProperties.canSelectRow && "button")("tabindex", isOtherSublistOpen_r11 || !ctx_r8.listProperties.canSelectRow ? -1 : 0)("aria-pressed", isItemSelected_r9);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("hasMaxHeight", false)("imgSrc", item_r5.listItem[item_r5.listItem.__proto__.thumbnail.key])("googleSrc", item_r5.listItem.googleThumbnail)("syndeticsSrc", item_r5.listItem.syndeticsThumbnail)("imgType", item_r5.listItem.__proto__.thumbnail.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(54, _c7$1, item_r5.disabled, item_r5.disabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasDrag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.hasPickup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "failed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.type) === "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", item_r5.mode == null ? null : item_r5.mode.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "WARNING");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "VALID");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "SUPPRESSED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5 == null ? null : item_r5.listItem[item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem.__proto__.thumbnailIcon == null ? null : item_r5.listItem.__proto__.thumbnailIcon.key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(22, 41, item_r5 == null ? null : item_r5.listItem))("ngForTrackBy", ctx_r8.iconTrackBy);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.listProperties.isSingleSave && item_r5.listItem[item_r5.listItem.__proto__.editableKey] != false && !ctx_r8.listProperties.inExSidepanePickup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actions", item_r5.listItem.actions == null ? null : item_r5.listItem.actions.actions)("visibleBtnNum", 0)("loading", item_r5.listItem.actions == null ? null : item_r5.listItem.actions.loading)("dotsIcon", "ellipsis-horizontal");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5.listItem.__proto__.title == null ? null : item_r5.listItem.__proto__.title.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(28, 43, item_r5 == null ? null : item_r5.listItem));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", item_r5 == null ? null : item_r5.listItem == null ? null : item_r5.listItem.__proto__ == null ? null : item_r5.listItem.__proto__["columns1"] == null ? null : item_r5.listItem.__proto__["columns1"].actions_horizontal_1)("ngForTrackBy", ctx_r8.trackByActionId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.actionIndication == null ? null : item_r5.actionIndication.reason) != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isItemOpen && isItemSelected_r9);
} }
const _c8$1 = function (a0, a1, a2) { return { isItemSelected: a0, isSublistOpen: a1, isOtherSublistOpen: a2 }; };
function ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_ng_template_1_Template, 33, 57, "ng-template", 6, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const _r7 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c8$1, ctx_r3._selectedItem && item_r5.id === ctx_r3._selectedItem.id, ctx_r3.openedSublist && item_r5.id === ctx_r3.openedSublist.id, ctx_r3.openedSublist && item_r5.id !== ctx_r3.openedSublist.id));
} }
function ExItemsLayoutGalleryComponent_ng_container_0_ex_pagination_4_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-pagination", 57, 58);
    i0.ɵɵlistener("selectedPageChange", function ExItemsLayoutGalleryComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_selectedPageChange_0_listener($event) { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r96.onSelectedPageChange($event)); })("pageSizeChange", function ExItemsLayoutGalleryComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_pageSizeChange_0_listener($event) { i0.ɵɵrestoreView(_r97); const ctx_r98 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r98.onPageSizeChange($event)); })("endOfPagination", function ExItemsLayoutGalleryComponent_ng_container_0_ex_pagination_4_Template_ex_pagination_endOfPagination_0_listener() { i0.ɵɵrestoreView(_r97); const ctx_r99 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r99.endOfPagination.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("numberOfResults", ctx_r4.listProperties.pagination.totalItemsCount)("pageSize", ctx_r4.listProperties.pagination.pageSize)("pageSizeOptions", ctx_r4.listProperties.pagination.pageSizeOptions)("selectedPage", ctx_r4.listProperties.pagination.selectedPage)("doNotUpdateStateInternally", true);
} }
function ExItemsLayoutGalleryComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ex-drag-list", 2);
    i0.ɵɵlistener("cdkDropListDropped", function ExItemsLayoutGalleryComponent_ng_container_0_Template_ex_drag_list_cdkDropListDropped_1_listener($event) { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r100.onDropListDropped($event)); });
    i0.ɵɵelementStart(2, "ul", 3);
    i0.ɵɵlistener("resized", function ExItemsLayoutGalleryComponent_ng_container_0_Template_ul_resized_2_listener($event) { i0.ɵɵrestoreView(_r101); const ctx_r102 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r102.onResized($event)); });
    i0.ɵɵtemplate(3, ExItemsLayoutGalleryComponent_ng_container_0_ng_container_3_Template, 3, 6, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ExItemsLayoutGalleryComponent_ng_container_0_ex_pagination_4_Template, 2, 5, "ex-pagination", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("grid-template-columns", "repeat(auto-fill, minmax(" + ctx_r0.gallerySlider + "px, 1fr))")("--thumbnail-width", ctx_r0.gallerySlider + "px");
    i0.ɵɵattribute("aria-label", !ctx_r0.listProperties.isMultiSelect ? "ng.general.single-select-group" : "")("role", !ctx_r0.listProperties.isMultiSelect ? "radiogroup" : undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listProperties.pagination.totalItemsCount > 0);
} }
const _c9$1 = function (a0, a1) { return { "side-by-side-open": a0, "ex-items-layout-gallery-large-density": a1 }; };
const _c10$1 = function (a0) { return { "side-by-side-open": a0 }; };
function ExItemsLayoutGalleryComponent_ng_template_1_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 61)(2, "div", 62);
    i0.ɵɵelement(3, "ex-record-gallery-placeholder", 63);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r108 = ctx.index;
    const ctx_r106 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c9$1, ctx_r106.isItemOpen, ctx_r106.listProperties.density === "large"));
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r106.gallerySlider, "px");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r106.gallerySlider - 20, "px");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c10$1, ctx_r106.isItemOpen))("proto", ctx_r106.listProperties.proto)("hasPickup", false)("emptyRowHeight", ctx_r106.listProperties.emptyRowHeight)("maxEmptyLines", 3)("index", ctx_r106.listProperties.hasIndex && (ctx_r106.listProperties.pagination.selectedPage - 1) * ctx_r106.listProperties.pagination.pageSize + i_r108 + 1);
} }
function ExItemsLayoutGalleryComponent_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r110 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵlistener("resized", function ExItemsLayoutGalleryComponent_ng_template_1_ng_container_3_Template_div_resized_1_listener($event) { i0.ɵɵrestoreView(_r110); const ctx_r109 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r109.resizeEvent.emit($event)); });
    i0.ɵɵtemplate(2, ExItemsLayoutGalleryComponent_ng_template_1_ng_container_3_ng_container_2_Template, 4, 16, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("grid-template-columns", "repeat(auto-fill, minmax(" + ctx_r103.gallerySlider + "px, 1fr))");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", " ".repeat(ctx_r103.numPlaceholderRows).split(""));
} }
function ExItemsLayoutGalleryComponent_ng_template_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 64);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 50);
} }
function ExItemsLayoutGalleryComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ExItemsLayoutGalleryComponent_ng_template_1_ng_container_3_Template, 3, 3, "ng-container", 0);
    i0.ɵɵtemplate(4, ExItemsLayoutGalleryComponent_ng_template_1_ng_template_4_Template, 1, 1, "ng-template", null, 60, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r104 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "ng.ex-list-layout.loading_results"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.listProperties.showSpinner)("ngIfElse", _r104);
} }
const EX_THUMBNAIL_KEY = 'thumbnail';
class ExItemsLayoutGalleryComponent extends ExItemsLayoutItemsFlat {
    constructor(itemsLayoutService, sectionsLayoutService, dialogService) {
        super(itemsLayoutService, sectionsLayoutService, dialogService);
        this.showThumbnail = true;
        this.sublistOpened = new EventEmitter();
        this.selectedSublistItemChanged = new EventEmitter();
        this.loadMoreSublist = new EventEmitter();
        this.componentFactoryItemsMap = {};
        this.sublistIndex = -1;
        this.selectedItemInSublistIndex = -1;
        this.showCustomizedThumbnail = true;
    }
    onComponentInit() {
        super.onComponentInit();
        this.initRecordCustomizationData();
        this.initPlaceholderRows();
        this.initCustomizedThumbnail();
    }
    createComponentFactoryItemsForColumn(column) {
        if (!column)
            return;
        column.forEach(field => {
            if (field.type) {
                this.componentFactoryItemsMap[field.key] = new ExComponentFactoryItem(field.type, {});
            }
        });
    }
    initRecordCustomizationData() {
        this.recordCustomizationData = this.pageCustomizationData.pipe(map$1(data => data?.record));
    }
    onItemsChanges() {
        super.onItemsChanges();
        this.openedSublist = undefined;
        this.sublistIndex = -1;
        this.selectedItemInSublistIndex = -1;
        this.selectedSublistItem = undefined;
        this.items.forEach((item => {
            this.createComponentFactoryItemsForColumn(item.listItem.__proto__?.['columns1']?.actions_horizontal_1);
        }));
    }
    onItemsReloaded() {
        this._selectFirstAfterItemsChanges = true;
    }
    onListParametersItemIdUpdated(id) {
        this._idToSelectAfterItemsChange = id;
    }
    numCurrentItems() {
        return this.items?.length ?? 0;
    }
    hasNextItem() {
        return this.openedSublist ? true : this.hasCurrentNextItem() || this.hasNextPage();
    }
    hasPreviousItem() {
        return this.openedSublist ? true : this.hasCurrentPreviousItem() || this.hasPreviousPage();
    }
    selectNextItem() {
        if (this.openedSublist) {
            this.selectNextSublistItemIndex();
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        else {
            super.selectNextItem();
        }
    }
    selectPreviousItem() {
        if (this.openedSublist) {
            this.selectPreviousSublistItemIndex();
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        else {
            super.selectPreviousItem();
        }
    }
    selectNextSublistItemIndex() {
        this.selectedItemInSublistIndex = (this.selectedItemInSublistIndex + 1) % this.openedSublist.sublists[this.sublistIndex].length;
    }
    selectPreviousSublistItemIndex() {
        if (this.selectedItemInSublistIndex === 0) {
            this.selectedItemInSublistIndex = this.openedSublist.sublists[this.sublistIndex].length - 1;
        }
        else {
            this.selectedItemInSublistIndex = this.selectedItemInSublistIndex - 1;
        }
    }
    selectSublistItemBySelectedSublistItemIndex() {
        const { selectedSublistItem, selectedSublistItemDetails } = this.getSelectedSublistItem();
        this.selectedSublistItem = selectedSublistItem;
        this.selectedSublistItemChanged.emit({
            selectedSublistItem: this.selectedSublistItem,
            selectedSublistItemDetails: selectedSublistItemDetails
        });
    }
    getSelectedSublistItem() {
        // sublist.list is an array of UIWrapper
        return this.selectedItemInSublistIndex >= 0 && this.selectedItemInSublistIndex < this.openedSublist.sublists[this.sublistIndex].length ?
            {
                selectedSublistItem: this.openedSublist.sublists[this.sublistIndex].list[this.selectedItemInSublistIndex],
                selectedSublistItemDetails: this.openedSublist.sublists[this.sublistIndex].listItemDetails
            } :
            { selectedSublistItem: undefined, selectedSublistItemDetails: undefined };
    }
    openSublist(item, sublistIndex) {
        event.stopPropagation();
        event.preventDefault();
        this.openedSublist = item;
        this.sublistIndex = sublistIndex;
        this.selectedItemInSublistIndex = 0;
        this.selectSublistItemBySelectedSublistItemIndex();
        this.moveFocusToSublist();
        this.sublistOpened.emit({ item, sublistIndex });
    }
    onSublistSelectedItemChange(selectedIndex) {
        this.selectedItemInSublistIndex = selectedIndex;
        this.selectSublistItemBySelectedSublistItemIndex();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onLoadMoreSublist() {
        if (this.selectedItemInSublistIndex != 0) {
            this.selectedItemInSublistIndex = 0;
            this.selectSublistItemBySelectedSublistItemIndex();
        }
        this.loadMoreSublist.emit({ item: this.openedSublist, sublistIndex: this.sublistIndex });
        this.moveFocusToSublist(1500);
    }
    moveFocusToSublist(timeout = 500) {
        setTimeout(() => {
            this.subListRef.focus();
        }, timeout);
    }
    onSublistCloseClicked() {
        this._selectedItem = this.openedSublist;
        this.openedSublist = undefined;
        this.selectedItemInSublistIndex = -1;
        this.selectSublistItemBySelectedSublistItemIndex(); // this.selectedSublistItemChanged should emit { undefined, undefined }
        this.updateHasNexPrevious();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onItemClicked(item) {
        if (window.getSelection().toString().length > 0 || document.activeElement?.tagName === 'INPUT') {
            return;
        }
        this.itemClicked.emit(item);
        if (this._selectedItem && item.id === this._selectedItem.id) {
            if (this.listProperties.hasDiselect) {
                this._selectedItem = undefined;
                if (this.selectedItemInSublistIndex > -1) {
                    this.selectedItemInSublistIndex = -1;
                    this.selectSublistItemBySelectedSublistItemIndex();
                }
                this.itemDeselected.emit(item);
            }
            else {
                this.itemSelected.emit(item);
                return;
            }
        }
        else {
            this._selectedItem = item;
            if (this.selectedItemInSublistIndex > -1) {
                this.selectedItemInSublistIndex = -1;
                this.selectSublistItemBySelectedSublistItemIndex();
            }
            this.itemSelected.emit(item);
        }
        this.updateHasNexPrevious();
        this.scrollToSelectedItem();
        this.selectedItemChange.emit(this.selectedItem);
    }
    onRowStartFocused(event) {
        if (!event.relatedTarget['className']?.includes('ex-items-layout-gallery-row-item') ||
            !this.items.findIndex(item => item.id == this.selectedItem?.id)) {
            return;
        }
        super.onRowStartFocused(event);
    }
    initCustomizedThumbnail() {
        this._subscription.add(this.recordCustomizationData?.subscribe(data => {
            const customizedThumbnail = data?.find(customizedField => {
                return customizedField.itemId === EX_THUMBNAIL_KEY;
            });
            if (customizedThumbnail) {
                this.showCustomizedThumbnail = customizedThumbnail.show;
            }
            else {
                this.showCustomizedThumbnail = true;
            }
        }));
    }
    iconTrackBy(index, icon) {
        return icon?.iconName;
    }
    trackByActionId(index, action) {
        return action?.key;
    }
    static { this.ɵfac = function ExItemsLayoutGalleryComponent_Factory(t) { return new (t || ExItemsLayoutGalleryComponent)(i0.ɵɵdirectiveInject(ExItemsLayoutService), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExItemsLayoutGalleryComponent, selectors: [["ex-items-layout-gallery"]], viewQuery: function ExItemsLayoutGalleryComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$e, 5);
            i0.ɵɵviewQuery(_c1$a, 5);
            i0.ɵɵviewQuery(_c2$5, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subListRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginationRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowItems = _t);
        } }, inputs: { showThumbnail: "showThumbnail", gallerySlider: "gallerySlider" }, outputs: { sublistOpened: "sublistOpened", selectedSublistItemChanged: "selectedSublistItemChanged", loadMoreSublist: "loadMoreSublist" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["loadingTmpl", ""], ["cdkDropList", "", 3, "cdkDropListDropped"], [1, "ex-items-layout-gallery-wrapper", 3, "resized"], [4, "ngFor", "ngForOf"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["itemTmpl", ""], ["cdkDrag", "", 3, "cdkDragDisabled"], ["class", "ex-items-layout-gallery-row-start-button ex-items-layout-gallery-hidden-button", "aria-label", "move\n                                to previous list item", 3, "focusin", 4, "ngIf"], ["mat-ripple", "", 1, "ex-items-layout-gallery-row-item", 3, "matRippleColor", "ngClass", "click", "keydown.enter", "keydown.space", "keydown.arrowdown", "keydown.arrowup"], ["rowItemRef", ""], [1, "ex-items-layout-gallery-row-item-gallery"], [1, "ex-items-layout-gallery-image"], [3, "hasMaxHeight", "imgSrc", "googleSrc", "syndeticsSrc", "imgType"], [1, "ex-items-layout-gallery-content", 3, "ngClass"], [1, "ex-items-layout-gallery-content-first-line"], ["class", "ex-items-layout-gallery-drag-mode-wrapper", 4, "ngIf"], [4, "ngIf"], ["class", "ex-items-layout-gallery-pickup", 3, "mousedown", "mouseup", "click", "focus", "focusin", 4, "ngIf"], [1, "line-delimiter"], [3, "color", "iconName", 4, "ngIf"], [3, "ngSwitch"], [3, "class", "exTooltip", 4, "ngSwitchCase"], ["sizePx", "25px", 3, "class", "iconName", "iconType", 4, "ngSwitchCase"], [3, "iconName", "color", "tooltip", "callback", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "ex-record-actions-edit", "type", "action", "ariaLabel", "ng.general.edit", 3, "tooltip", "click", 4, "ngIf"], [3, "actions", "visibleBtnNum", "loading", "dotsIcon", "actionClicked"], [1, "ex-record-gallery-details-rows"], [1, "ex-record-actions-column-horizontal-container"], [3, "class", 4, "ngIf"], ["class", "ex-items-layout-gallery-hidden-button", "aria-label", "move\n                                focus to right side", 3, "keyup.Tab", 4, "ngIf"], ["aria-label", "move\n                                to previous list item", 1, "ex-items-layout-gallery-row-start-button", "ex-items-layout-gallery-hidden-button", 3, "focusin"], [1, "ex-items-layout-gallery-drag-mode-wrapper"], ["cdkDragHandle", "", 1, "ex-items-layout-gallery-drag-and-drop"], [3, "class", "exTooltip", 4, "ngIf"], [3, "exTooltip"], [1, "ex-items-layout-gallery-index", 3, "id", "ngClass"], [1, "ex-items-layout-gallery-pickup", 3, "mousedown", "mouseup", "click", "focus", "focusin"], [3, "disabled", "checked", "exTooltip", "ariaLabel", "checkedChange", 4, "ngIf"], [3, "aria-labelledby", "checked", "keydown.space", "click", 4, "ngIf"], [3, "disabled", "checked", "exTooltip", "ariaLabel", "checkedChange"], [3, "aria-labelledby", "checked", "keydown.space", "click"], [3, "color", "iconName"], ["sizePx", "25px", 3, "iconName", "iconType"], [3, "iconName", "color", "tooltip", "callback"], ["type", "action", "ariaLabel", "ng.general.edit", 1, "ex-record-actions-edit", 3, "tooltip", "click"], ["iconName", "edit", "color", "#000000"], [3, "value", "isBold", "displayTooltip"], [3, "class", "arguments", 4, "ngIf"], [3, "routerLink", "ex-gallery-is-main-link", 4, "ngIf"], [3, "arguments"], [3, "routerLink"], [3, "class", "style", "componentFactoryItem", "data", "content", "events", 4, "ngIf"], [3, "componentFactoryItem", "data", "content", "events"], ["aria-label", "move\n                                focus to right side", 1, "ex-items-layout-gallery-hidden-button", 3, "keyup.Tab"], [3, "numberOfResults", "pageSize", "pageSizeOptions", "selectedPage", "doNotUpdateStateInternally", "selectedPageChange", "pageSizeChange", "endOfPagination"], ["paginationRef", ""], ["role", "alert", 1, "ex-items-layout-gallery-hidden-button"], ["spinner", ""], ["mat-ripple", "", "matRippleColor", "transparent", 1, "ex-items-layout-gallery-row-item-loading", 3, "ngClass"], [1, "ex-items-layout-gallery-content", "ex-items-layout-gallery-row-item"], [1, "ex-items-layout-gallery-row-item", 3, "ngClass", "proto", "hasPickup", "emptyRowHeight", "maxEmptyLines", "index"], [1, "ex-items-layout-gallery-spinner", "sel-list-spinner", 3, "diameter"]], template: function ExItemsLayoutGalleryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExItemsLayoutGalleryComponent_ng_container_0_Template, 5, 8, "ng-container", 0);
            i0.ɵɵtemplate(1, ExItemsLayoutGalleryComponent_ng_template_1_Template, 6, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.listProperties.isLoading && ctx.readyToLoad)("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgSwitch, i1$5.NgSwitchCase, ExRecordGalleryPlaceholderComponent, ExPaginationComponent, i6$1.MatRipple, ExTooltipDirective, ResizedDirective, ExComponentLoaderComponent, ExSpinnerComponent, ExButtonComponent, ExThumbnailComponent, ExLabelComponent, i15.CdkDropList, i15.CdkDrag, i15.CdkDragHandle, ExDragAccessibleIconComponent, ExDragListComponent, ExIconComponent, ExSvgIconComponent, ExCheckboxComponent, ExRecordActionsComponent, i8.MatRadioButton, i3$2.RouterLink, i1$2.TranslatePipe, ExObjectAssignPipe, ExUnderThumbnailIconsPipe, ExGalleryFieldPipe], styles: [".ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]{display:grid;row-gap:20px;column-gap:15px;margin-top:20px;margin-inline:20px;--ex-items-layout-gallery-row-item-border-color: #dddddd;--ex-items-layout-gallery-row-item-border-color-hover: #888888;--ex-items-layout-gallery-row-item-border-color-selected: #0e7ab9;--ex-items-layout-gallery-image-background-color: #f2f2f2;--ex-items-layout-gallery-image-background-color-hover: #d9d9d9;--ex-items-layout-gallery-image-background-color-checked: #d9d9d9;--ex-items-layout-gallery-image-background-color-selected: #eaf2f6}.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item-loading[_ngcontent-%COMP%]{justify-items:center}.ex-gallery-is-main-link[_ngcontent-%COMP%]   .ex-label-wrapper[_ngcontent-%COMP%], .ex-gallery-is-main-link[_ngcontent-%COMP%]   .ex-record-label[_ngcontent-%COMP%]{display:unset!important}.ex-gallery-is-main-link[_ngcontent-%COMP%]:after{content:\" \";position:absolute;height:var(--thumbnail-width);top:0;width:100%;left:0}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]{list-style-type:none}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item[_ngcontent-%COMP%]{width:var(--thumbnail-width);height:100%;border-radius:10px;border:1px solid;border-color:var(--ex-items-layout-gallery-row-item-border-color);justify-self:center}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item.ex-items-layout-gallery-selected[_ngcontent-%COMP%]{outline:var(--ex-items-layout-gallery-row-item-border-color-selected) solid 2px!important}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item.ex-items-layout-gallery-selected[_ngcontent-%COMP%]   .ex-items-layout-gallery-image[_ngcontent-%COMP%]{background-color:var(--ex-items-layout-gallery-image-background-color-selected)}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item.ex-items-layout-gallery-checked[_ngcontent-%COMP%]   .ex-items-layout-gallery-image[_ngcontent-%COMP%]{background-color:var(--ex-items-layout-gallery-image-background-color-checked)}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item[_ngcontent-%COMP%]:hover{outline:var(--ex-items-layout-gallery-row-item-border-color-hover) solid 2px}ul.ex-items-layout-gallery-wrapper[_ngcontent-%COMP%]   .ex-items-layout-gallery-row-item[_ngcontent-%COMP%]:hover   .ex-items-layout-gallery-image[_ngcontent-%COMP%]{background-color:var(--ex-items-layout-gallery-image-background-color-hover)}.ex-items-layout-gallery-image[_ngcontent-%COMP%]{aspect-ratio:1/1;background-color:var(--ex-items-layout-gallery-image-background-color)}.ex-items-layout-gallery-image[_ngcontent-%COMP%]     .ex-thumbnail-container{display:flex;justify-content:center;align-items:center;width:100%;height:100%}.ex-items-layout-gallery-image[_ngcontent-%COMP%]     .ex-thumbnail-img{max-width:-moz-fit-content;max-width:fit-content;max-height:-moz-fit-content;max-height:fit-content;width:100%!important;height:100%;object-fit:cover;margin-inline-end:unset!important;border:unset!important}.line-delimiter[_ngcontent-%COMP%]{margin-inline-start:auto}.ex-items-layout-gallery-content[_ngcontent-%COMP%]{padding:10px 10px 5px}.ex-items-layout-gallery-content[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-block-end:5px}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-items-layout-gallery-content-first-line[_ngcontent-%COMP%]{display:flex;gap:10px;height:23px;align-items:center}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-items-layout-gallery-content-first-line[_ngcontent-%COMP%] > ex-svg-icon[_ngcontent-%COMP%]{margin-top:3px}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-items-layout-gallery-content-first-line[_ngcontent-%COMP%]     .ex-record-actions-main-buttons{background:transparent}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-items-layout-gallery-content-first-line[_ngcontent-%COMP%]   .ex-items-layout-gallery-pickup[_ngcontent-%COMP%]{padding-top:5px}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-items-layout-gallery-content-first-line[_ngcontent-%COMP%]   .ex-record-actions-edit[_ngcontent-%COMP%]     .ex-button-wrapper{min-height:21px}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-title-and-actions-title[_ngcontent-%COMP%]{margin-inline-end:8px;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-title-and-actions-title[_ngcontent-%COMP%]     .ex-label-wrapper{display:contents}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-gallery-details-rows[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:5px}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-labels-rows[_ngcontent-%COMP%]{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-labels-rows[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{display:contents}.ex-items-layout-gallery-content[_ngcontent-%COMP%]   .ex-record-actions-column-horizontal-container[_ngcontent-%COMP%]{display:flex}.ex-items-layout-gallery-hidden-button[_ngcontent-%COMP%]{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none}.ex-items-layout-gallery-content[_ngcontent-%COMP%]     .ex-record-placeholder-wrapper{border-radius:10px;border:1px solid;border-color:var(--ex-items-layout-gallery-row-item-border-color)}.ex-items-layout-gallery-content[_ngcontent-%COMP%]     .ex-record-placeholder-wrapper .ex-thumbnail-placeholder{aspect-ratio:1/1}"] }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExItemsLayoutGalleryComponent.prototype, "onItemClicked", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutGalleryComponent, [{
        type: Component,
        args: [{ selector: 'ex-items-layout-gallery', template: "<ng-container *ngIf=\"(!listProperties.isLoading && readyToLoad); else loadingTmpl\">\r\n    <ex-drag-list cdkDropList (cdkDropListDropped)=\"onDropListDropped($event)\">\r\n        <ul class=\"ex-items-layout-gallery-wrapper\" [style.grid-template-columns]=\"'repeat(auto-fill, minmax(' + gallerySlider + 'px, 1fr))'\"\r\n            (resized)=\"onResized($event)\" [attr.aria-label]=\"!listProperties.isMultiSelect ? 'ng.general.single-select-group' : ''\"\r\n            [style.--thumbnail-width]=\"gallerySlider+'px'\"  [attr.role]=\"!listProperties.isMultiSelect ? 'radiogroup' : undefined\">\r\n            <ng-container *ngFor=\"let item of items; let i = index\">\r\n\r\n                <ng-template #itemTmpl [ngTemplateOutlet]=\"itemTmpl\" let-isItemSelected=\"isItemSelected\"\r\n                    let-isSublistOpen=\"isSublistOpen\" let-isOtherSublistOpen=\"isOtherSublistOpen\"\r\n                    [ngTemplateOutletContext]=\"{ isItemSelected: _selectedItem && item.id === _selectedItem.id,\r\n                                                            isSublistOpen: openedSublist && item.id === openedSublist.id,\r\n                                                            isOtherSublistOpen: openedSublist && item.id !== openedSublist.id }\">\r\n\r\n                    <li cdkDrag [cdkDragDisabled]=\"!listProperties.hasDrag\"\r\n                        class=\"sel-row-{{i}}-item ex-items-layout-gallery-li\" [attr.aria-hidden]=\"isOtherSublistOpen\">\r\n                        <button *ngIf=\"isItemOpen && isItemSelected\"\r\n                            class=\"ex-items-layout-gallery-row-start-button ex-items-layout-gallery-hidden-button\" aria-label=\"move\r\n                                to previous list item\" (focusin)=\"onRowStartFocused($event)\"></button>\r\n                      <div #rowItemRef mat-ripple [attr.role]=\"listProperties.canSelectRow && 'button'\"\r\n                           [attr.tabindex]=\"(isOtherSublistOpen || !listProperties.canSelectRow) ? -1 : 0\" [attr.aria-pressed]=\"isItemSelected\"\r\n                           [matRippleColor]=\"hasItemDetailsComponent && !isItemSelected ? '#eff4f74f': 'transparent'\"\r\n                            (click)=\"onItemClicked(item)\" (keydown.enter)=\"onItemClicked(item)\"\r\n                            (keydown.space)=\"onItemClicked(item)\" (keydown.arrowdown)=\"onRowArrowDown($event, item)\"\r\n                            (keydown.arrowup)=\"onRowArrowUp($event, item)\"\r\n                             class=\"ex-items-layout-gallery-row-item\" [ngClass]=\"{\r\n                                'side-by-side-open': isItemOpen,\r\n                                'ex-items-layout-gallery-row-item-opened': isSublistOpen,\r\n                                'ex-items-layout-gallery-row-item-disabled': isOtherSublistOpen,\r\n                                'ex-items-layout-gallery-checked': isItemChecked(item),\r\n                                'ex-items-layout-gallery-selected': listProperties.canSelectRow && isItemSelected,\r\n                                'ex-items-layout-gallery-large-density': listProperties.density === 'large',\r\n                                'ex-items-layout-gallery-row-item-dark-theme': listProperties.isDarkTheme,\r\n                                'ex-items-layout-gallery-selected-dark-theme': listProperties.canSelectRow && isItemSelected && listProperties.isDarkTheme\r\n                            }\">\r\n                            <div class=\"ex-items-layout-gallery-row-item-gallery\">\r\n                              <div class=\"ex-items-layout-gallery-image\">\r\n                                <ex-thumbnail\r\n                                  [hasMaxHeight]=\"false\"\r\n                                  [imgSrc]=\"item.listItem[item.listItem.__proto__.thumbnail.key]\"\r\n                                  [googleSrc]=\"item.listItem.googleThumbnail\"\r\n                                  [syndeticsSrc]=\"item.listItem.syndeticsThumbnail\"\r\n                                  [imgType]=\"item.listItem.__proto__.thumbnail.type\"></ex-thumbnail>\r\n                              </div>\r\n                              <div class=\"ex-items-layout-gallery-content\"\r\n                                   [ngClass]=\"{'ex-items-layout-gallery-disabled-content' : item.disabled, 'ex-items-layout-gallery-disabled-row-item' : item.disabled}\">\r\n                                <div class=\"ex-items-layout-gallery-content-first-line\">\r\n                                  <div *ngIf=\"listProperties.hasDrag\" class=\"ex-items-layout-gallery-drag-mode-wrapper\">\r\n                                    <ex-drag-accessible-icon cdkDragHandle\r\n                                        class=\"ex-items-layout-gallery-drag-and-drop\"></ex-drag-accessible-icon>\r\n                                    <i *ngIf=\"item.mode?.value === 'WARNING' && !listProperties.hasPickup\"\r\n                                        class=\"material-icons ex-items-layout-gallery-warning-icon sel-warning-{{i}}\"\r\n                                        [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                                        error\r\n                                    </i>\r\n                                </div>\r\n\r\n                                  <span *ngIf=\"listProperties.hasIndex\">\r\n                                    <span class=\"ex-items-layout-gallery-index\"  [id]=\"isItemSelected?'selectedItemInList':null\"\r\n                                          [ngClass]=\"{'ex-items-layout-gallery-disabled-row-item' : item.disabled}\">\r\n                                      {{ ((listProperties.pagination.selectedPage - 1)*(listProperties.pagination.pageSize)+i+1) }}\r\n                                    </span>\r\n                                  </span>\r\n\r\n                                  <div class=\"ex-items-layout-gallery-pickup\" *ngIf=\"listProperties.hasPickup\"\r\n                                      (mousedown)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                                      (mouseup)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                                      (click)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                                      (focus)=\"$event.stopImmediatePropagation(); $event.preventDefault()\"\r\n                                      (focusin)=\"$event.stopImmediatePropagation(); $event.preventDefault()\">\r\n                                      <!-- stopPropagation and preventDefault on mousedown, mouseup, click, focusin to prevent focusin event in parents -->\r\n                                      <ex-checkbox *ngIf=\"listProperties.isMultiSelect\"  [disabled]=\"item.selectable===false\" [checked]=\"isItemChecked(item)\" [exTooltip]=\"item.selectable!==false? '':item.nonSelectableTooltip | translate\" [attr.aria-hidden]=\"!(!listProperties.isLoading && readyToLoad)\"\r\n                                          (checkedChange)=\"onItemCheckedChange(item, $event)\" [ariaLabel]=\"('ng.ex_items_layout_list_row.check_or_uncheck' | translate) + ' ' + ((listProperties.pagination.selectedPage - 1)*(listProperties.pagination.pageSize)+i+1)\">\r\n                                      </ex-checkbox>\r\n                                    <mat-radio-button *ngIf=\"!listProperties.isMultiSelect\" (keydown.space)=\"onSingleItemCheckedChange(item)\" aria-labelledby=\"recordId-{{i}}\" (click)=\"onSingleItemCheckedChange(item)\" [checked]=\"isItemChecked(item)\" >\r\n                                    </mat-radio-button>\r\n                                  </div>\r\n                                  <div class=\"line-delimiter\"></div>\r\n                                  <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='failed'\"  [color]=\"'#e54746'\" [iconName]=\"'circ_warning'\" ></ex-svg-icon>\r\n                                  <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='warning'\"  [color]=\"'#e7a141'\" [iconName]=\"'warning'\" ></ex-svg-icon>\r\n                                  <ex-svg-icon *ngIf=\"item?.actionIndication?.type ==='success'\"  [color]=\"'#60c05f'\" [iconName]=\"'success'\" ></ex-svg-icon>\r\n                                  <ng-container [ngSwitch]=\"item.mode?.value\">\r\n                                    <i *ngSwitchCase=\"'WARNING'\"\r\n                                       class=\"material-icons ex-items-layout-gallery-warning-icon sel-warning-{{i}}\"\r\n                                       [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                                      error\r\n                                    </i>\r\n                                    <i *ngSwitchCase=\"'VALID'\"\r\n                                       class=\"material-icons ex-items-layout-gallery-valid-icon sel-valid-{{i}}\"\r\n                                       [exTooltip]=\"item.mode?.tooltip | translate\">\r\n                                      check_circle\r\n                                    </i>\r\n                                    <ex-icon sizePx=\"25px\" *ngSwitchCase=\"'SUPPRESSED'\"\r\n                                             class=\"material-icons ex-items-layout-gallery-suppress-icon sel-suppress-{{i}}\"\r\n                                             [iconName]=\"'visibility-off'\" [iconType]=\"'svg'\">\r\n                                    </ex-icon>\r\n                                  </ng-container>\r\n                                  <ex-svg-icon   *ngIf=\"item?.listItem[this.item?.listItem?.__proto__.thumbnailIcon?.key]; let icon\" [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                                                 [tooltip]=\"icon?.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                                  <ng-container *ngFor=\"let icon of item?.listItem | exUnderThumbnailIcons;trackBy:iconTrackBy\">\r\n                                  <ex-svg-icon *ngIf=\"icon\" [iconName]=\"icon?.iconName\" [color]=\"icon?.iconColor\"\r\n                                                 [tooltip]=\"icon?.tooltip\" [callback]=\"icon?.callback? icon?.callback : null\"></ex-svg-icon>\r\n                                  </ng-container>\r\n                                  <ex-button *ngIf=\"listProperties.isSingleSave && item.listItem[item.listItem.__proto__.editableKey] != false && !listProperties.inExSidepanePickup\"\r\n                                             class=\"ex-record-actions-edit\" [tooltip]=\"'ng.general.edit'\"\r\n                                             type=\"action\" ariaLabel=\"ng.general.edit\" (click)=\"onActionClicked(item, SINGLE_SAVE_EDIT_ACTION_KEY)\">\r\n                                    <ex-svg-icon iconName=\"edit\" color=\"#000000\"></ex-svg-icon>\r\n                                  </ex-button>\r\n\r\n                                  <ex-record-actions\r\n                                    [actions]=\"item.listItem.actions?.actions\" [visibleBtnNum]=\"0\" (actionClicked)=\"onActionClicked(item, $event)\"\r\n                                    [loading]=\"item.listItem.actions?.loading\" [dotsIcon]=\"'ellipsis-horizontal'\">\r\n                                  </ex-record-actions>\r\n                                </div>\r\n                                <div *ngIf=\"item.listItem.__proto__.title?.key\">\r\n                                  <ex-label class=\"ex-record-title-and-actions-title sel-{{ item.listItem.__proto__.title.key }}\"\r\n                                            [value]=\"item.listItem[item.listItem.__proto__.title.key]\" [isBold]=\"true\" [displayTooltip]=\"true\"\r\n                                            [attr.role]=\"'heading'\" [attr.aria-level]=\"'3'\">\r\n                                  </ex-label>\r\n                                </div>\r\n\r\n                                <div class=\"ex-record-gallery-details-rows\">\r\n                                  <ng-container *ngFor=\"let field of item?.listItem | exGalleryField;\">\r\n                                    <ex-label *ngIf=\"field?.value && !field.link\" class=\"ex-record-labels-rows sel-{{ field.key }} ex-record-label\" [arguments]=\"field\"></ex-label>\r\n                                    <a *ngIf=\"field?.value && field.link && item.listItem[field.link]\" [routerLink]=\"item.listItem[field.link]\" [class.ex-gallery-is-main-link]=\"field.isMainLink\">\r\n                                        <ex-label class=\"ex-record-labels-rows sel-{{ field.key }} ex-record-label\" [arguments]=\"field\"></ex-label>\r\n                                    </a>\r\n                                  </ng-container>\r\n                                </div>\r\n\r\n                                <div class=\"ex-record-actions-column-horizontal-container\">\r\n                                  <ng-container *ngFor=\"let row of item?.listItem?.__proto__?.['columns1']?.actions_horizontal_1;trackBy:trackByActionId\">\r\n                                    <ex-component-loader *ngIf=\"item?.listItem?.[row.key]\" class=\"ex-record-full-width sel-{{ row.key }} sel-{{ row.key }}-{{item?.listItem?.['id']}}\" [style]=\"row.style\"\r\n                                                         [componentFactoryItem]=\"componentFactoryItemsMap[row.key]\"\r\n                                                         [data]=\"item?.listItem?.[row.key]?.inputs | objectAssign : { disabled: false, isDisabled: false, htmlId: htmlId, breakpoint: 1 }\"\r\n                                                         [content]=\"item?.listItem?.[row.key]?.content\" [events]=\"item?.listItem?.[row.key]?.events || {}\"\r\n                                                         >\r\n                                    </ex-component-loader>\r\n                                  </ng-container>\r\n                                </div>\r\n\r\n                                <div *ngIf=\"item?.actionIndication?.reason != ''\" class = \"ex-items-layout-gallery-action-indication-reason-{{item?.actionIndication?.type}}\">{{item?.actionIndication?.reason}}</div>\r\n                              </div>\r\n\r\n                              <button *ngIf=\"isItemOpen && isItemSelected\" class=\"ex-items-layout-gallery-hidden-button\"\r\n                                aria-label=\"move\r\n                                focus to right side\" (keyup.Tab)=\"onTabFromRowEnd()\"></button>\r\n                            </div>\r\n                        </div>\r\n                    </li>\r\n                </ng-template>\r\n            </ng-container>\r\n        </ul>\r\n    </ex-drag-list>\r\n  <ex-pagination #paginationRef *ngIf=\"listProperties.pagination.totalItemsCount > 0\"\r\n                 [numberOfResults]=\"listProperties.pagination.totalItemsCount\"\r\n                 [pageSize]=\"listProperties.pagination.pageSize\"\r\n                 [pageSizeOptions]=\"listProperties.pagination.pageSizeOptions\"\r\n                 [selectedPage]=\"listProperties.pagination.selectedPage\"\r\n                 (selectedPageChange)=\"onSelectedPageChange($event)\" (pageSizeChange)=\"onPageSizeChange($event)\"\r\n                 (endOfPagination)=\"endOfPagination.emit()\" [doNotUpdateStateInternally]=\"true\"></ex-pagination>\r\n</ng-container>\r\n\r\n<ng-template #loadingTmpl>\r\n    <div role=\"alert\" class=\"ex-items-layout-gallery-hidden-button\">\r\n        {{'ng.ex-list-layout.loading_results' | translate}}</div>\r\n    <ng-container *ngIf=\"!listProperties.showSpinner; else spinner\">\r\n        <div class=\"ex-items-layout-gallery-wrapper\" [style.grid-template-columns]=\"'repeat(auto-fill, minmax(' + gallerySlider + 'px, 1fr))'\" (resized)=\"resizeEvent.emit($event)\">\r\n            <ng-container *ngFor=\"let dummy of ' '.repeat(numPlaceholderRows).split(''), let i = index\">\r\n                <div mat-ripple matRippleColor=\"transparent\" class=\"ex-items-layout-gallery-row-item-loading\"\r\n                    [ngClass]=\"{\r\n                    'side-by-side-open': isItemOpen,\r\n                    'ex-items-layout-gallery-large-density': listProperties.density === 'large'}\">\r\n                    <div class=\"ex-items-layout-gallery-content ex-items-layout-gallery-row-item\" [style.width.px]=\"gallerySlider\">\r\n                        <ex-record-gallery-placeholder class=\"ex-items-layout-gallery-image\" [ngClass]=\"{'side-by-side-open': isItemOpen}\" [style.width.px]=\"gallerySlider - 20\" class=\"ex-items-layout-gallery-row-item\" [proto]=\"listProperties.proto\" [hasPickup]=\"false\"\r\n                            [emptyRowHeight]=\"listProperties.emptyRowHeight\" [maxEmptyLines]=\"3\" [index]=\"listProperties.hasIndex && ((listProperties.pagination.selectedPage - 1)*(listProperties.pagination.pageSize)+i+1)\">\r\n                        </ex-record-gallery-placeholder>\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </ng-container>\r\n    <ng-template #spinner>\r\n        <ex-spinner class=\"ex-items-layout-gallery-spinner sel-list-spinner\" [diameter]=\"50\"></ex-spinner>\r\n    </ng-template>\r\n</ng-template>\r\n", styles: [".ex-items-layout-gallery-wrapper{display:grid;row-gap:20px;column-gap:15px;margin-top:20px;margin-inline:20px;--ex-items-layout-gallery-row-item-border-color: #dddddd;--ex-items-layout-gallery-row-item-border-color-hover: #888888;--ex-items-layout-gallery-row-item-border-color-selected: #0e7ab9;--ex-items-layout-gallery-image-background-color: #f2f2f2;--ex-items-layout-gallery-image-background-color-hover: #d9d9d9;--ex-items-layout-gallery-image-background-color-checked: #d9d9d9;--ex-items-layout-gallery-image-background-color-selected: #eaf2f6}.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item-loading{justify-items:center}.ex-gallery-is-main-link .ex-label-wrapper,.ex-gallery-is-main-link .ex-record-label{display:unset!important}.ex-gallery-is-main-link:after{content:\" \";position:absolute;height:var(--thumbnail-width);top:0;width:100%;left:0}ul.ex-items-layout-gallery-wrapper{list-style-type:none}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item{width:var(--thumbnail-width);height:100%;border-radius:10px;border:1px solid;border-color:var(--ex-items-layout-gallery-row-item-border-color);justify-self:center}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item.ex-items-layout-gallery-selected{outline:var(--ex-items-layout-gallery-row-item-border-color-selected) solid 2px!important}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item.ex-items-layout-gallery-selected .ex-items-layout-gallery-image{background-color:var(--ex-items-layout-gallery-image-background-color-selected)}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item.ex-items-layout-gallery-checked .ex-items-layout-gallery-image{background-color:var(--ex-items-layout-gallery-image-background-color-checked)}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item:hover{outline:var(--ex-items-layout-gallery-row-item-border-color-hover) solid 2px}ul.ex-items-layout-gallery-wrapper .ex-items-layout-gallery-row-item:hover .ex-items-layout-gallery-image{background-color:var(--ex-items-layout-gallery-image-background-color-hover)}.ex-items-layout-gallery-image{aspect-ratio:1/1;background-color:var(--ex-items-layout-gallery-image-background-color)}.ex-items-layout-gallery-image ::ng-deep .ex-thumbnail-container{display:flex;justify-content:center;align-items:center;width:100%;height:100%}.ex-items-layout-gallery-image ::ng-deep .ex-thumbnail-img{max-width:-moz-fit-content;max-width:fit-content;max-height:-moz-fit-content;max-height:fit-content;width:100%!important;height:100%;object-fit:cover;margin-inline-end:unset!important;border:unset!important}.line-delimiter{margin-inline-start:auto}.ex-items-layout-gallery-content{padding:10px 10px 5px}.ex-items-layout-gallery-content>*{margin-block-end:5px}.ex-items-layout-gallery-content .ex-items-layout-gallery-content-first-line{display:flex;gap:10px;height:23px;align-items:center}.ex-items-layout-gallery-content .ex-items-layout-gallery-content-first-line>ex-svg-icon{margin-top:3px}.ex-items-layout-gallery-content .ex-items-layout-gallery-content-first-line ::ng-deep .ex-record-actions-main-buttons{background:transparent}.ex-items-layout-gallery-content .ex-items-layout-gallery-content-first-line .ex-items-layout-gallery-pickup{padding-top:5px}.ex-items-layout-gallery-content .ex-items-layout-gallery-content-first-line .ex-record-actions-edit ::ng-deep .ex-button-wrapper{min-height:21px}.ex-items-layout-gallery-content .ex-record-title-and-actions-title{margin-inline-end:8px;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.ex-items-layout-gallery-content .ex-record-title-and-actions-title ::ng-deep .ex-label-wrapper{display:contents}.ex-items-layout-gallery-content .ex-record-gallery-details-rows{display:flex;flex-direction:column;gap:5px}.ex-items-layout-gallery-content .ex-record-labels-rows{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}.ex-items-layout-gallery-content .ex-record-labels-rows *{display:contents}.ex-items-layout-gallery-content .ex-record-actions-column-horizontal-container{display:flex}.ex-items-layout-gallery-hidden-button{display:block!important;line-height:0!important;height:0!important;overflow:hidden!important;zoom:1!important;padding:0!important;margin-bottom:0;border:none}.ex-items-layout-gallery-content ::ng-deep .ex-record-placeholder-wrapper{border-radius:10px;border:1px solid;border-color:var(--ex-items-layout-gallery-row-item-border-color)}.ex-items-layout-gallery-content ::ng-deep .ex-record-placeholder-wrapper .ex-thumbnail-placeholder{aspect-ratio:1/1}\n"] }]
    }], function () { return [{ type: ExItemsLayoutService }, { type: ExSectionsLayoutService }, { type: ExDialogService }]; }, { showThumbnail: [{
            type: Input
        }], sublistOpened: [{
            type: Output
        }], selectedSublistItemChanged: [{
            type: Output
        }], loadMoreSublist: [{
            type: Output
        }], subListRef: [{
            type: ViewChild,
            args: ['subList']
        }], rowItems: [{
            type: ViewChildren,
            args: ['rowItemRef']
        }], paginationRef: [{
            type: ViewChild,
            args: ['paginationRef']
        }], gallerySlider: [{
            type: Input
        }], onItemClicked: [] }); })();

class ExItemsLayoutGalleryModule {
    static { this.ɵfac = function ExItemsLayoutGalleryModule_Factory(t) { return new (t || ExItemsLayoutGalleryModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExItemsLayoutGalleryModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExListLayoutModule,
            ExPaginationModule,
            MatRippleModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExComponentLoaderModule,
            ExSpinnerModule,
            ExButtonModule,
            ExChipModule,
            ExRightClickActionsModule,
            ExThumbnailModule,
            ExLabelModule,
            ExCloseModule,
            TranslateModule,
            DragDropModule,
            ExDragModule,
            ExIconModule,
            ExSvgIconModule,
            ExCheckboxModule,
            ExRecordActionsModule,
            EXPipesModule,
            MatRadioModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutGalleryModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExListLayoutModule,
                    ExPaginationModule,
                    MatRippleModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExComponentLoaderModule,
                    ExSpinnerModule,
                    ExButtonModule,
                    ExChipModule,
                    ExRightClickActionsModule,
                    ExThumbnailModule,
                    ExLabelModule,
                    ExCloseModule,
                    TranslateModule,
                    DragDropModule,
                    ExDragModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExCheckboxModule,
                    ExRecordActionsModule,
                    EXPipesModule,
                    MatRadioModule,
                    RouterLink,
                ],
                declarations: [
                    ExItemsLayoutGalleryComponent,
                    ExGalleryFieldPipe
                ],
                exports: [
                    ExItemsLayoutGalleryComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExItemsLayoutGalleryModule, { declarations: [ExItemsLayoutGalleryComponent,
        ExGalleryFieldPipe], imports: [CommonModule,
        FormsModule,
        ExListLayoutModule,
        ExPaginationModule,
        MatRippleModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExComponentLoaderModule,
        ExSpinnerModule,
        ExButtonModule,
        ExChipModule,
        ExRightClickActionsModule,
        ExThumbnailModule,
        ExLabelModule,
        ExCloseModule,
        TranslateModule,
        DragDropModule,
        ExDragModule,
        ExIconModule,
        ExSvgIconModule,
        ExCheckboxModule,
        ExRecordActionsModule,
        EXPipesModule,
        MatRadioModule,
        RouterLink], exports: [ExItemsLayoutGalleryComponent] }); })();

class ExItemsLayoutModule {
    static { this.ɵfac = function ExItemsLayoutModule_Factory(t) { return new (t || ExItemsLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExItemsLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ExPaginationModule,
            ExSideBySideModule,
            AngularResizeEventModule,
            MatRippleModule,
            ExSpinnerModule,
            ExSortModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExComponentLoaderModule,
            ExButtonModule,
            ExChipModule,
            ExFiltersModule,
            ExListHeaderModule,
            ExRightClickActionsModule,
            ExRecordActionsModule,
            ExThumbnailModule,
            ExLabelModule,
            ExCloseModule,
            TranslateModule,
            ExIconModule,
            ExComboboxModule,
            ExDragModule,
            ExCheckboxModule,
            ExSvgIconModule,
            ExItemsLayoutListModule,
            ExItemsLayoutTreeModule,
            ExItemsLayoutGridModule,
            ExItemsLayoutGalleryModule,
            ExListLayoutModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExItemsLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ExPaginationModule,
                    ExSideBySideModule,
                    AngularResizeEventModule,
                    MatRippleModule,
                    ExSpinnerModule,
                    ExSortModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExComponentLoaderModule,
                    ExButtonModule,
                    ExChipModule,
                    ExFiltersModule,
                    ExListHeaderModule,
                    ExRightClickActionsModule,
                    ExRecordActionsModule,
                    ExThumbnailModule,
                    ExLabelModule,
                    ExCloseModule,
                    TranslateModule,
                    ExIconModule,
                    ExComboboxModule,
                    ExDragModule,
                    ExCheckboxModule,
                    ExSvgIconModule,
                    ExItemsLayoutListModule,
                    ExItemsLayoutTreeModule,
                    ExItemsLayoutGridModule,
                    ExItemsLayoutGalleryModule,
                    ExListLayoutModule
                ],
                declarations: [
                    ExItemsLayoutComponent
                ],
                exports: [
                    ExItemsLayoutComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExItemsLayoutModule, { declarations: [ExItemsLayoutComponent], imports: [CommonModule,
        FormsModule,
        ExPaginationModule,
        ExSideBySideModule,
        AngularResizeEventModule,
        MatRippleModule,
        ExSpinnerModule,
        ExSortModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExComponentLoaderModule,
        ExButtonModule,
        ExChipModule,
        ExFiltersModule,
        ExListHeaderModule,
        ExRightClickActionsModule,
        ExRecordActionsModule,
        ExThumbnailModule,
        ExLabelModule,
        ExCloseModule,
        TranslateModule,
        ExIconModule,
        ExComboboxModule,
        ExDragModule,
        ExCheckboxModule,
        ExSvgIconModule,
        ExItemsLayoutListModule,
        ExItemsLayoutTreeModule,
        ExItemsLayoutGridModule,
        ExItemsLayoutGalleryModule,
        ExListLayoutModule], exports: [ExItemsLayoutComponent] }); })();
i0.ɵɵsetComponentScope(ExItemsLayoutComponent, [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, ExSideBySideComponent, ResizedDirective, i4$1.CdkScrollable, ExTooltipDirective, DeepLinkModeDirective, exShortcutsScopeDirective, ExComponentLoaderComponent, ExListHeaderComponent, ExIconComponent, ExItemsLayoutListComponent, ExItemsLayoutTreeComponent, ExItemsLayoutGridComponent, ExItemsLayoutGalleryComponent, ExItemDetailsHeaderComponent], [i1$5.AsyncPipe, i1$2.TranslatePipe]);

function ExLayoutCustomizationMenuComponent_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$d = function (a0) { return { $implicit: a0 }; };
function ExLayoutCustomizationMenuComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLayoutCustomizationMenuComponent_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$d, ctx_r0.layoutCustomizationPermissions.USER));
} }
function ExLayoutCustomizationMenuComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExLayoutCustomizationMenuComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExLayoutCustomizationMenuComponent_ng_container_9_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0$d, ctx_r1.layoutCustomizationPermissions.INSTITUTION));
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_ex_svg_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 15);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(1, 2, "ng.general.layout_customization.inst_customization_tooltip"));
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 4, "ng.general.layout_customization.inst_customization_tooltip"));
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_7_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
const _c1$9 = function (a0) { return { "is-customized": a0 }; };
function ExLayoutCustomizationMenuComponent_ng_template_10_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_7_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const level_r6 = i0.ɵɵnextContext().$implicit; const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onActionClicked(level_r6 == ctx_r15.layoutCustomizationPermissions.INSTITUTION ? ctx_r15.layoutCustomizationTypes.INSTITUTION_SECTIONS : ctx_r15.layoutCustomizationTypes.USER_SECTIONS)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_7_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$9, ctx_r8.hasCustomization[level_r6 + "Sections"]));
    i0.ɵɵattribute("aria-labelledby", level_r6 + "_level_label");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-sections-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "ng.general.layout_customization.sections"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.hasCustomization[level_r6 + "Sections"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_8_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_8_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r22); const level_r6 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onActionClicked(level_r6 == ctx_r20.layoutCustomizationPermissions.INSTITUTION ? ctx_r20.layoutCustomizationTypes.INSTITUTION_ACTIONS : ctx_r20.layoutCustomizationTypes.USER_ACTIONS)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_8_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$9, ctx_r9.hasCustomization[level_r6 + "Actions"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-actions-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.layout_customization.actions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.hasCustomization[level_r6 + "Actions"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_9_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_9_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r27); const level_r6 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.onActionClicked(level_r6 == ctx_r25.layoutCustomizationPermissions.INSTITUTION ? ctx_r25.layoutCustomizationTypes.INSTITUTION_RECORD : ctx_r25.layoutCustomizationTypes.USER_RECORD)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_9_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$9, ctx_r10.hasCustomization[level_r6 + "Record"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-records-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.layout_customization.records"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r10.hasCustomization[level_r6 + "Record"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_10_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_10_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r32); const level_r6 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.onActionClicked(level_r6 == ctx_r30.layoutCustomizationPermissions.INSTITUTION ? ctx_r30.layoutCustomizationTypes.INSTITUTION_GRID : ctx_r30.layoutCustomizationTypes.USER_GRID)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_10_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$9, ctx_r11.hasCustomization[level_r6 + "Grid"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-grid-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.layout_customization.grid"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.hasCustomization[level_r6 + "Grid"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_11_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_11_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r37); const level_r6 = i0.ɵɵnextContext().$implicit; const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.onActionClicked(level_r6 == ctx_r35.layoutCustomizationPermissions.INSTITUTION ? ctx_r35.layoutCustomizationTypes.INSTITUTION_FACETS : ctx_r35.layoutCustomizationTypes.USER_FACETS)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_11_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$9, ctx_r12.hasCustomization[level_r6 + "Facets"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-facets-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.layout_customization.facets"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.hasCustomization[level_r6 + "Facets"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_12_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind1(2, 1, "ng.general.customized"), ")");
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-button", 17);
    i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_ng_template_10_div_12_Template_ex_button_click_1_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.onActionClicked(ctx_r40.layoutCustomizationTypes.INSTITUTION_MANDATORY_FIELDS)); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ExLayoutCustomizationMenuComponent_ng_template_10_div_12_span_4_Template, 3, 3, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const level_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$9, ctx_r13.hasCustomization[level_r6 + "MandatoryFields"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uniqueSelector", "ex-layout-customization-menu-action-mandatory-fields-" + level_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "ng.general.layout_customization.mandatory_fields"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.hasCustomization[level_r6 + "Record"]);
} }
function ExLayoutCustomizationMenuComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "div", 10);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ExLayoutCustomizationMenuComponent_ng_template_10_ex_svg_icon_5_Template, 3, 6, "ex-svg-icon", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 12);
    i0.ɵɵtemplate(7, ExLayoutCustomizationMenuComponent_ng_template_10_div_7_Template, 5, 9, "div", 13);
    i0.ɵɵtemplate(8, ExLayoutCustomizationMenuComponent_ng_template_10_div_8_Template, 5, 8, "div", 14);
    i0.ɵɵtemplate(9, ExLayoutCustomizationMenuComponent_ng_template_10_div_9_Template, 5, 8, "div", 14);
    i0.ɵɵtemplate(10, ExLayoutCustomizationMenuComponent_ng_template_10_div_10_Template, 5, 8, "div", 14);
    i0.ɵɵtemplate(11, ExLayoutCustomizationMenuComponent_ng_template_10_div_11_Template, 5, 8, "div", 14);
    i0.ɵɵtemplate(12, ExLayoutCustomizationMenuComponent_ng_template_10_div_12_Template, 5, 8, "div", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const level_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", level_r6, "_level_label");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, level_r6 == ctx_r3.layoutCustomizationPermissions.INSTITUTION ? "ng.general.layout_customization.inst_customization" : "ng.general.layout_customization.user_customization"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", level_r6 == ctx_r3.layoutCustomizationPermissions.INSTITUTION);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.SECTIONS[level_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.ACTIONS[level_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.RECORD[level_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.GRID[level_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.FACETS[level_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.displayedCustomizationTypes.MANDATORY_FIELD[level_r6]);
} }
var LayoutCustomizationTypes;
(function (LayoutCustomizationTypes) {
    LayoutCustomizationTypes["USER_SECTIONS"] = "userSections";
    LayoutCustomizationTypes["USER_ACTIONS"] = "userActions";
    LayoutCustomizationTypes["USER_RECORD"] = "userRecord";
    LayoutCustomizationTypes["USER_GRID"] = "userGrid";
    LayoutCustomizationTypes["USER_FACETS"] = "userFacets";
    LayoutCustomizationTypes["INSTITUTION_SECTIONS"] = "institutionSections";
    LayoutCustomizationTypes["INSTITUTION_ACTIONS"] = "institutionActions";
    LayoutCustomizationTypes["INSTITUTION_RECORD"] = "institutionRecord";
    LayoutCustomizationTypes["INSTITUTION_GRID"] = "institutionGrid";
    LayoutCustomizationTypes["INSTITUTION_FACETS"] = "institutionFacets";
    LayoutCustomizationTypes["INSTITUTION_MANDATORY_FIELDS"] = "institutionMandatoryFields";
})(LayoutCustomizationTypes || (LayoutCustomizationTypes = {}));
var LayoutCustomizationPermissions;
(function (LayoutCustomizationPermissions) {
    LayoutCustomizationPermissions["USER"] = "user";
    LayoutCustomizationPermissions["INSTITUTION"] = "institution";
})(LayoutCustomizationPermissions || (LayoutCustomizationPermissions = {}));
class ExLayoutCustomizationMenuComponent {
    /**
     * the customization permissions of the user
     */
    set customizationPermissions(permissions) {
        this._customizationPermissions = permissions;
        this.setHasInstitutionPermissions();
    }
    get customizationPermissions() {
        return this._customizationPermissions;
    }
    constructor(cdr) {
        this.cdr = cdr;
        /**
         *  emitted when the user clicks on an action; emits the selected customization type
         */
        this.actionClicked = new EventEmitter();
        /**
         * close listLayoutHeader customization menu
         */
        this.closePopup = new EventEmitter();
        this.closeClicked = new EventEmitter();
        this.layoutCustomizationTypes = LayoutCustomizationTypes;
        this.layoutCustomizationPermissions = LayoutCustomizationPermissions;
        this.hasCustomization = {
            userSections: false,
            userActions: false,
            userRecord: false,
            userGrid: false,
            userFacets: false,
            institutionSections: false,
            institutionActions: false,
            institutionRecord: false,
            institutionGrid: false,
            institutionFacets: false,
            institutionMandatoryFields: false
        };
        this.hasCustomizationLevel = [];
        this.hasInstitutionPermissions = false;
        this._customizationPermissions = [LayoutCustomizationPermissions.USER];
        this.checkHasCustomization = pipe(filter(() => !!this.hasCustomizationsForPage), concatMap(() => {
            return this.hasCustomizationsForPage(this.pageId);
        }), tap((hasCustomization) => {
            this.hasCustomization = hasCustomization;
            this.setHasCustomizationLevelMap();
        }));
    }
    ngOnInit() {
        this.initHasCustomization();
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe;
    }
    ngAfterViewInit() {
        this.exCloseButton.focus();
    }
    setHasInstitutionPermissions() {
        this.hasInstitutionPermissions = this.customizationPermissions.some(val => val === LayoutCustomizationPermissions.INSTITUTION);
    }
    setHasCustomizationLevelMap() {
        this.hasCustomizationLevel[LayoutCustomizationPermissions.INSTITUTION] = this._levelExists(LayoutCustomizationPermissions.INSTITUTION);
        this.hasCustomizationLevel[LayoutCustomizationPermissions.USER] = this._levelExists(LayoutCustomizationPermissions.USER);
    }
    _levelExists(level) {
        for (const key in this.displayedCustomizationTypes) {
            const keyLevels = this.displayedCustomizationTypes[key];
            if (keyLevels[level] === true) {
                return true;
            }
        }
        return false;
    }
    initHasCustomization() {
        this.subscription = this.customizationUpdateObservable?.pipe(startWith$1(null), this.checkHasCustomization).subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    onActionClicked(type) {
        this.actionClicked.emit(type);
        this.closePopup.emit();
    }
    onCloseClicked() {
        this.closeClicked.emit();
    }
    static { this.ɵfac = function ExLayoutCustomizationMenuComponent_Factory(t) { return new (t || ExLayoutCustomizationMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExLayoutCustomizationMenuComponent, selectors: [["ex-layout-customization-menu"]], viewQuery: function ExLayoutCustomizationMenuComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(ExCloseComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.exCloseButton = _t.first);
        } }, inputs: { customizationPermissions: "customizationPermissions", customizationProfile: "customizationProfile", customizationUpdateObservable: "customizationUpdateObservable", hasCustomizationsForPage: "hasCustomizationsForPage", displayedCustomizationTypes: "displayedCustomizationTypes", pageId: "pageId" }, outputs: { actionClicked: "actionClicked", closePopup: "closePopup", closeClicked: "closeClicked" }, decls: 12, vars: 8, consts: [[1, "ex-layout-customization-header-wrapper"], [1, "ex-layout-customization-header"], ["role", "heading", "aria-level", "2", 1, "ex-layout-customization-menu-header-title"], [3, "click"], [1, "ex-layout-customization-menu-wrapper"], [4, "ngIf"], ["layoutCustomizationActionsPanel", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ex-layout-customization-menu-actions-container"], [1, "ex-layout-customization-menu-actions-title-container"], ["role", "heading", "aria-level", "3", 1, "ex-layout-customization-menu-actions-title", 3, "id"], ["class", "ex-layout-customization-menu-actions-title-icon", "iconName", "warning", "color", "#d6801d", 3, "tooltip", "ariaLabel", 4, "ngIf"], [1, "ex-layout-customization-menu-actions"], ["class", "ex-layout-customization-menu-action", "role", "group", 3, "ngClass", 4, "ngIf"], ["class", "ex-layout-customization-menu-action", 3, "ngClass", 4, "ngIf"], ["iconName", "warning", "color", "#d6801d", 1, "ex-layout-customization-menu-actions-title-icon", 3, "tooltip", "ariaLabel"], ["role", "group", 1, "ex-layout-customization-menu-action", 3, "ngClass"], ["type", "link", 3, "uniqueSelector", "click"], [1, "ex-layout-customization-menu-action", 3, "ngClass"]], template: function ExLayoutCustomizationMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "ex-close", 3);
            i0.ɵɵlistener("click", function ExLayoutCustomizationMenuComponent_Template_ex_close_click_6_listener() { return ctx.onCloseClicked(); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "div", 4);
            i0.ɵɵtemplate(8, ExLayoutCustomizationMenuComponent_ng_container_8_Template, 2, 4, "ng-container", 5);
            i0.ɵɵtemplate(9, ExLayoutCustomizationMenuComponent_ng_container_9_Template, 2, 4, "ng-container", 5);
            i0.ɵɵtemplate(10, ExLayoutCustomizationMenuComponent_ng_template_10_Template, 13, 11, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 4, ctx.customizationProfile), " ", i0.ɵɵpipeBind1(5, 6, "ng.general.customization"), "");
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.hasCustomizationLevel[ctx.layoutCustomizationPermissions.USER]);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasCustomizationLevel[ctx.layoutCustomizationPermissions.INSTITUTION] && ctx.hasInstitutionPermissions);
        } }, styles: ["[_nghost-%COMP%]{--padding-start-end: 30px}.ex-layout-customization-header-wrapper[_ngcontent-%COMP%]{border-bottom:1px solid rgba(112,112,112,.3);padding-block:15px;padding-inline:30px 0}.ex-layout-customization-header-wrapper[_ngcontent-%COMP%]   .ex-layout-customization-header[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;align-items:baseline}.ex-layout-customization-menu-wrapper[_ngcontent-%COMP%]{padding:15px}.ex-layout-customization-menu-wrapper[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions-title-container[_ngcontent-%COMP%]{display:flex}.ex-layout-customization-menu-wrapper[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions-title-container[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions-title[_ngcontent-%COMP%]{margin-bottom:5px}.ex-layout-customization-menu-wrapper[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions-title-container[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions-title-icon[_ngcontent-%COMP%]{margin-inline-start:7px;margin-top:2px}.ex-layout-customization-menu-actions-container[_ngcontent-%COMP%]{height:100%;overflow:auto;padding:15px}.ex-layout-customization-menu-actions-container[_ngcontent-%COMP%]:first-of-type{margin-top:-5px}.ex-layout-customization-menu-actions-container[_ngcontent-%COMP%]   .ex-layout-customization-menu-actions[_ngcontent-%COMP%]     button{padding-inline-start:0px!important}.ex-layout-customization-menu-action[_ngcontent-%COMP%]{position:relative;display:flex;align-items:baseline}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLayoutCustomizationMenuComponent, [{
        type: Component,
        args: [{ selector: 'ex-layout-customization-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-layout-customization-header-wrapper\">\n    <div class=\"ex-layout-customization-header\">\n        <div class=\"ex-layout-customization-menu-header-title\" role=\"heading\" aria-level=\"2\">{{ customizationProfile | translate}} {{ 'ng.general.customization' | translate}}</div>\n        <ex-close (click)=\"onCloseClicked()\"></ex-close>\n    </div>\n</div>\n\n<div class=\"ex-layout-customization-menu-wrapper\">\n    <ng-container *ngIf=\"hasCustomizationLevel[layoutCustomizationPermissions.USER]\">\n      <ng-container\n          *ngTemplateOutlet=\"layoutCustomizationActionsPanel; context: {$implicit: layoutCustomizationPermissions.USER}\">\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"hasCustomizationLevel[layoutCustomizationPermissions.INSTITUTION] && hasInstitutionPermissions\">\n        <ng-container\n            *ngTemplateOutlet=\"layoutCustomizationActionsPanel; context: {$implicit: layoutCustomizationPermissions.INSTITUTION}\">\n        </ng-container>\n    </ng-container>\n\n    <ng-template #layoutCustomizationActionsPanel let-level>\n        <div class=\"ex-layout-customization-menu-actions-container\">\n            <div class=\"ex-layout-customization-menu-actions-title-container\">\n                <div class=\"ex-layout-customization-menu-actions-title\" role=\"heading\" aria-level=\"3\" id=\"{{level}}_level_label\">\n                    {{ (level == layoutCustomizationPermissions.INSTITUTION ?\n                    'ng.general.layout_customization.inst_customization' :\n                    'ng.general.layout_customization.user_customization') | translate }}\n                    <!-- UIL -->\n                </div>\n                <ex-svg-icon *ngIf=\"level == layoutCustomizationPermissions.INSTITUTION\" class=\"ex-layout-customization-menu-actions-title-icon\"\n                             iconName=\"warning\" color=\"#d6801d\"\n                             tooltip=\"{{'ng.general.layout_customization.inst_customization_tooltip' | translate}}\"\n                             ariaLabel=\"{{'ng.general.layout_customization.inst_customization_tooltip' | translate}}\">\n                </ex-svg-icon>\n            </div>\n\n            <div class=\"ex-layout-customization-menu-actions\">\n                <div *ngIf=\"displayedCustomizationTypes.SECTIONS[level]\" class=\"ex-layout-customization-menu-action\"\n                    [ngClass]=\"{'is-customized': hasCustomization[level+'Sections']}\" role=\"group\" [attr.aria-labelledby]=\"level + '_level_label'\">\n                    <ex-button type=\"link\" [uniqueSelector]=\"'ex-layout-customization-menu-action-sections-' + level\"\n                        (click)=\"onActionClicked(level == layoutCustomizationPermissions.INSTITUTION ? layoutCustomizationTypes.INSTITUTION_SECTIONS : layoutCustomizationTypes.USER_SECTIONS)\">\n                        {{ 'ng.general.layout_customization.sections' | translate }}\n                        <!-- UIL -->\n                    </ex-button>\n                    <span *ngIf=\"hasCustomization[level+'Sections']\">({{'ng.general.customized' | translate}})</span>\n                </div>\n                <div *ngIf=\"displayedCustomizationTypes.ACTIONS[level]\" class=\"ex-layout-customization-menu-action\"\n                    [ngClass]=\"{'is-customized': hasCustomization[level+'Actions']}\">\n                    <ex-button type=\"link\" [uniqueSelector]=\"'ex-layout-customization-menu-action-actions-' + level\"\n                        (click)=\"onActionClicked(level == layoutCustomizationPermissions.INSTITUTION ? layoutCustomizationTypes.INSTITUTION_ACTIONS : layoutCustomizationTypes.USER_ACTIONS)\">\n                        {{ 'ng.general.layout_customization.actions' | translate }}\n                        <!-- UIL -->\n                    </ex-button>\n                    <span *ngIf=\"hasCustomization[level+'Actions']\">({{'ng.general.customized' | translate}})</span>\n                </div>\n                <div *ngIf=\"displayedCustomizationTypes.RECORD[level]\" class=\"ex-layout-customization-menu-action\"\n                    [ngClass]=\"{'is-customized': hasCustomization[level+'Record']}\">\n                    <ex-button type=\"link\"[uniqueSelector]=\"'ex-layout-customization-menu-action-records-' + level\"\n                        (click)=\"onActionClicked(level == layoutCustomizationPermissions.INSTITUTION ? layoutCustomizationTypes.INSTITUTION_RECORD : layoutCustomizationTypes.USER_RECORD)\">\n                        {{ 'ng.general.layout_customization.records' | translate }}\n                        <!-- UIL -->\n                    </ex-button>\n                    <span *ngIf=\"hasCustomization[level+'Record']\">({{'ng.general.customized' | translate}})</span>\n\n                </div>\n              <div *ngIf=\"displayedCustomizationTypes.GRID[level]\" class=\"ex-layout-customization-menu-action\"\n                   [ngClass]=\"{'is-customized': hasCustomization[level+'Grid']}\">\n                <ex-button type=\"link\" [uniqueSelector]=\"'ex-layout-customization-menu-action-grid-' + level\"\n                           (click)=\"onActionClicked(level == layoutCustomizationPermissions.INSTITUTION ? layoutCustomizationTypes.INSTITUTION_GRID : layoutCustomizationTypes.USER_GRID)\">\n                  {{ 'ng.general.layout_customization.grid' | translate }}\n                  <!-- UIL -->\n                </ex-button>\n                <span *ngIf=\"hasCustomization[level+'Grid']\">({{'ng.general.customized' | translate}})</span>\n\n              </div>\n\n                <div *ngIf=\"displayedCustomizationTypes.FACETS[level]\" class=\"ex-layout-customization-menu-action\"\n                     [ngClass]=\"{'is-customized': hasCustomization[level+'Facets']}\">\n                    <ex-button type=\"link\" [uniqueSelector]=\"'ex-layout-customization-menu-action-facets-' + level\"\n                      (click)=\"onActionClicked(level == layoutCustomizationPermissions.INSTITUTION ? layoutCustomizationTypes.INSTITUTION_FACETS : layoutCustomizationTypes.USER_FACETS)\">\n                      {{ 'ng.general.layout_customization.facets' | translate }}\n                      <!-- UIL -->\n                    </ex-button>\n                  <span *ngIf=\"hasCustomization[level+'Facets']\">({{'ng.general.customized' | translate}})</span>\n\n                </div>\n                <div *ngIf=\"displayedCustomizationTypes.MANDATORY_FIELD[level]\"\n                    class=\"ex-layout-customization-menu-action\"\n                    [ngClass]=\"{'is-customized': hasCustomization[level+'MandatoryFields']}\">\n                    <ex-button type=\"link\" [uniqueSelector]=\"'ex-layout-customization-menu-action-mandatory-fields-' + level\"\n                        (click)=\"onActionClicked(layoutCustomizationTypes.INSTITUTION_MANDATORY_FIELDS)\">\n                        {{ 'ng.general.layout_customization.mandatory_fields' | translate }}\n                        <!-- UIL -->\n                    </ex-button>\n                    <span *ngIf=\"hasCustomization[level+'Record']\">({{'ng.general.customized' | translate}})</span>\n\n                </div>\n            </div>\n        </div>\n    </ng-template>\n</div>\n", styles: [":host{--padding-start-end: 30px}.ex-layout-customization-header-wrapper{border-bottom:1px solid rgba(112,112,112,.3);padding-block:15px;padding-inline:30px 0}.ex-layout-customization-header-wrapper .ex-layout-customization-header{width:100%;display:flex;justify-content:space-between;align-items:baseline}.ex-layout-customization-menu-wrapper{padding:15px}.ex-layout-customization-menu-wrapper .ex-layout-customization-menu-actions-title-container{display:flex}.ex-layout-customization-menu-wrapper .ex-layout-customization-menu-actions-title-container .ex-layout-customization-menu-actions-title{margin-bottom:5px}.ex-layout-customization-menu-wrapper .ex-layout-customization-menu-actions-title-container .ex-layout-customization-menu-actions-title-icon{margin-inline-start:7px;margin-top:2px}.ex-layout-customization-menu-actions-container{height:100%;overflow:auto;padding:15px}.ex-layout-customization-menu-actions-container:first-of-type{margin-top:-5px}.ex-layout-customization-menu-actions-container .ex-layout-customization-menu-actions ::ng-deep button{padding-inline-start:0px!important}.ex-layout-customization-menu-action{position:relative;display:flex;align-items:baseline}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { customizationPermissions: [{
            type: Input
        }], customizationProfile: [{
            type: Input
        }], customizationUpdateObservable: [{
            type: Input
        }], hasCustomizationsForPage: [{
            type: Input
        }], displayedCustomizationTypes: [{
            type: Input
        }], pageId: [{
            type: Input
        }], actionClicked: [{
            type: Output
        }], closePopup: [{
            type: Output
        }], closeClicked: [{
            type: Output
        }], exCloseButton: [{
            type: ViewChild,
            args: [ExCloseComponent]
        }] }); })();

class ExLayoutCustomizationMenuModule {
    static { this.ɵfac = function ExLayoutCustomizationMenuModule_Factory(t) { return new (t || ExLayoutCustomizationMenuModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExLayoutCustomizationMenuModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            MatTooltipModule,
            MatExpansionModule,
            ExButtonModule,
            ExIconModule,
            ExSvgIconModule,
            ExDotWrapperModule,
            ExCloseModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExLayoutCustomizationMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    MatTooltipModule,
                    MatExpansionModule,
                    ExButtonModule,
                    ExIconModule,
                    ExSvgIconModule,
                    ExDotWrapperModule,
                    ExCloseModule,
                ],
                declarations: [
                    ExLayoutCustomizationMenuComponent
                ],
                exports: [
                    ExLayoutCustomizationMenuComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExLayoutCustomizationMenuModule, { declarations: [ExLayoutCustomizationMenuComponent], imports: [CommonModule,
        TranslateModule,
        MatTooltipModule,
        MatExpansionModule,
        ExButtonModule,
        ExIconModule,
        ExSvgIconModule,
        ExDotWrapperModule,
        ExCloseModule], exports: [ExLayoutCustomizationMenuComponent] }); })();
i0.ɵɵsetComponentScope(ExLayoutCustomizationMenuComponent, [i1$5.NgClass, i1$5.NgIf, i1$5.NgTemplateOutlet, ExButtonComponent, ExSvgIconComponent, ExCloseComponent], [i1$2.TranslatePipe]);

const _c0$c = [[["", "slot-header", ""]], [["", "slot-menu", ""]], [["", "slot-main-content", ""]], [["", "slot-floating-sidepane", ""]], [["", "slot-footer", ""]]];
const _c1$8 = ["[slot-header]", "[slot-menu]", "[slot-main-content]", "[slot-floating-sidepane]", "[slot-footer]"];
class ExMainLayoutComponent {
    /**
     * @ignore
     */
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function ExMainLayoutComponent_Factory(t) { return new (t || ExMainLayoutComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExMainLayoutComponent, selectors: [["ex-main-layout"]], ngContentSelectors: _c1$8, decls: 5, vars: 0, template: function ExMainLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$c);
            i0.ɵɵprojection(0);
            i0.ɵɵprojection(1, 1);
            i0.ɵɵprojection(2, 2);
            i0.ɵɵprojection(3, 3);
            i0.ɵɵprojection(4, 4);
        } } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMainLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-main-layout', template: "<ng-content select=\"[slot-header]\"></ng-content>\n<ng-content select=\"[slot-menu]\"></ng-content>\n<ng-content select=\"[slot-main-content]\"></ng-content>\n<ng-content select=\"[slot-floating-sidepane]\"></ng-content>\n<ng-content select=\"[slot-footer]\"></ng-content>\n" }]
    }], function () { return []; }, null); })();

class ExMainLayoutModule {
    static { this.ɵfac = function ExMainLayoutModule_Factory(t) { return new (t || ExMainLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExMainLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMainLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExMainLayoutComponent
                ],
                exports: [
                    ExMainLayoutComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExMainLayoutModule, { declarations: [ExMainLayoutComponent], imports: [CommonModule], exports: [ExMainLayoutComponent] }); })();

const _c0$b = [[["", "slot-main-menu", ""]]];
const _c1$7 = ["[slot-main-menu]"];
class ExMenuComponent {
    /**
     * @ignore
     */
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function ExMenuComponent_Factory(t) { return new (t || ExMenuComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExMenuComponent, selectors: [["ex-menu"]], ngContentSelectors: _c1$7, decls: 1, vars: 0, template: function ExMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$b);
            i0.ɵɵprojection(0);
        } }, styles: [".ex-menu-side-menu[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:80px;height:100vh;position:fixed}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMenuComponent, [{
        type: Component,
        args: [{ selector: 'ex-menu', template: "<ng-content select=\"[slot-main-menu]\"></ng-content>", styles: [".ex-menu-side-menu{display:flex;flex-direction:column;width:80px;height:100vh;position:fixed}\n"] }]
    }], function () { return []; }, null); })();

class ExMenuModule {
    static { this.ɵfac = function ExMenuModule_Factory(t) { return new (t || ExMenuModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExMenuModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExMenuComponent
                ],
                exports: [
                    ExMenuComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExMenuModule, { declarations: [ExMenuComponent], imports: [CommonModule], exports: [ExMenuComponent] }); })();

const _c0$a = ["toggle"];
function ExMultiLayoutComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function ExMultiLayoutComponent_ng_template_2_div_0_button_1_ex_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 10);
} if (rf & 2) {
    const layout_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconName", layout_r6.iconName)("iconType", layout_r6.iconType);
} }
function ExMultiLayoutComponent_ng_template_2_div_0_button_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-label", 11);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const layout_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(1, 1, layout_r6.label));
} }
const _c1$6 = function (a0) { return { "ex-multi-layout-selected": a0 }; };
function ExMultiLayoutComponent_ng_template_2_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ExMultiLayoutComponent_ng_template_2_div_0_button_1_Template_button_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r14); const index_r7 = restoredCtx.index; const layout_r6 = restoredCtx.$implicit; const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.onLayoutChange(index_r7, layout_r6.exMultiLayoutId, $event)); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, ExMultiLayoutComponent_ng_template_2_div_0_button_1_ex_icon_4_Template, 1, 2, "ex-icon", 8);
    i0.ɵɵtemplate(5, ExMultiLayoutComponent_ng_template_2_div_0_button_1_ng_template_5_Template, 2, 3, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const layout_r6 = ctx.$implicit;
    const index_r7 = ctx.index;
    const _r9 = i0.ɵɵreference(6);
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("ex-multi-layout-select-button ", i0.ɵɵpipeBind1(1, 9, "ex-multi-layout-select-button-" + layout_r6.exMultiLayoutId), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$6, ctx_r5._activeLayoutIndex == index_r7))("exTooltip", i0.ɵɵpipeBind1(2, 11, layout_r6.label));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 13, layout_r6.label))("aria-pressed", ctx_r5._activeLayoutIndex == index_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", layout_r6.iconName != "")("ngIfElse", _r9);
} }
function ExMultiLayoutComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ExMultiLayoutComponent_ng_template_2_div_0_button_1_Template, 7, 17, "button", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ex-multi-layout-selection-buttons-margin", !ctx_r4.sectionService);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.layouts);
} }
function ExMultiLayoutComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExMultiLayoutComponent_ng_template_2_div_0_Template, 2, 3, "div", 4);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.showToggle);
} }
function ExMultiLayoutComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c2$4 = function (a0) { return { $implicit: a0 }; };
const _c3$2 = ["*"];
class MyContext {
}
class ExMultiLayoutComponent {
    constructor(sectionService, cdr) {
        this.sectionService = sectionService;
        this.cdr = cdr;
        /**
         * the id of the active layout.
         * initial layout will be set by activeLayoutId if exists at initialization.
         */
        this.activeLayoutId = "";
        /**
         * If to show the toggle or not
         */
        this.showToggle = true;
        /**
         * on layout change, emits index and id of the selected layout.
         */
        this.layoutChange = new EventEmitter();
        this._activeLayoutIndex = 0;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        if (this.layouts?.length > 0) {
            let index = this.layouts.toArray().findIndex(layout => layout.exMultiLayoutId === this.activeLayoutId);
            if (index < 0) { //activeLayoutId not found in layouts
                index = 0;
                this.activeLayoutId = this.layouts.toArray()[index].exMultiLayoutId;
            }
            this._activeLayoutIndex = index;
            this.activeLayoutTemplate = this.layouts.toArray()[this._activeLayoutIndex].template;
            this.setSwitchToLayoutData();
        }
    }
    ngAfterViewInit() {
        if (this.sectionService && this.toggle) {
            this.sectionService.setHeader(this.toggle);
        }
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('activeLayoutId') && !changes.activeLayoutId.firstChange) {
            const id = this.activeLayoutId;
            const index = this.layouts.toArray().findIndex(layout => layout.exMultiLayoutId === id);
            if (index !== -1) {
                this.updateActiveLayout(index, id);
            }
        }
    }
    onLayoutChange(index, layoutId, $event = undefined) {
        this.updateActiveLayout(index, layoutId);
        this.layoutChange.emit({ index: index, layoutId: layoutId });
        $event?.stopPropagation();
    }
    updateActiveLayout(index, layoutId) {
        this.activeLayoutId = layoutId;
        this._activeLayoutIndex = index;
        this.activeLayoutTemplate = this.layouts.toArray()[index].template;
        this.setSwitchToLayoutData();
        this.cdr.markForCheck();
    }
    changeLayout(layoutId) {
        this.layouts.toArray().some((layout, index) => {
            if (layout.exMultiLayoutId == layoutId) {
                this.onLayoutChange(index, layoutId);
                return true;
            }
        });
    }
    setSwitchToLayoutData() {
        let switchToLayoutId = this.layouts.toArray()[this._activeLayoutIndex].switchToLayoutId;
        let switchToLayout = this.layouts.toArray().find(layout => {
            return layout.exMultiLayoutId === switchToLayoutId;
        });
        if (switchToLayout) {
            this.switchToLayoutData =
                {
                    changeLayoutFunction: this.changeLayout.bind(this),
                    switchToLayoutId: switchToLayoutId,
                    switchToIcon: { iconName: switchToLayout.iconName, iconType: switchToLayout.iconType },
                    switchToLabel: switchToLayout.label
                };
        }
    }
    static { this.ɵfac = function ExMultiLayoutComponent_Factory(t) { return new (t || ExMultiLayoutComponent)(i0.ɵɵdirectiveInject(ExSectionsLayoutSectionService, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExMultiLayoutComponent, selectors: [["ex-multi-layout"]], contentQueries: function ExMultiLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ExMultiLayoutIdentifierDirective, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.layouts = _t);
        } }, viewQuery: function ExMultiLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$a, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggle = _t.first);
        } }, inputs: { activeLayoutId: "activeLayoutId", showToggle: "showToggle" }, outputs: { layoutChange: "layoutChange" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3$2, decls: 6, vars: 5, consts: [[3, "ngTemplateOutlet", 4, "ngIf"], ["toggle", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngTemplateOutlet"], ["class", "ex-multi-layout-selection-buttons", 3, "ex-multi-layout-selection-buttons-margin", 4, "ngIf"], [1, "ex-multi-layout-selection-buttons"], [3, "class", "ngClass", "exTooltip", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "exTooltip", "click"], [3, "iconName", "iconType", 4, "ngIf", "ngIfElse"], ["displayLabel", ""], [3, "iconName", "iconType"], [3, "value"]], template: function ExMultiLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵtemplate(1, ExMultiLayoutComponent_ng_container_1_Template, 1, 1, "ng-container", 0);
            i0.ɵɵtemplate(2, ExMultiLayoutComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(4, ExMultiLayoutComponent_ng_container_4_Template, 1, 0, "ng-container", 2);
            i0.ɵɵprojection(5);
            i0.ɵɵelementContainerEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.sectionService);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.activeLayoutTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c2$4, ctx.switchToLayoutData));
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, ExIconComponent, ExTooltipDirective, ExLabelComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;align-content:flex-start}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]{align-self:flex-end;display:flex;width:-moz-fit-content;width:fit-content}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;padding:3px 8px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{border-start-start-radius:3px;border-end-start-radius:3px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;border-start-start-radius:3px;border-end-start-radius:3px;padding:3px 8px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{border-start-end-radius:3px;border-end-end-radius:3px}.ex-multi-layout-selection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child   [_ngcontent-%COMP%]:focus{outline:none!important;border:2px solid #000;border-start-end-radius:3px;border-end-end-radius:3px;padding:3px 8px}.ex-multi-layout-selection-buttons-margin[_ngcontent-%COMP%]{margin-bottom:20px}.ex-multi-layout-select-button[_ngcontent-%COMP%]{padding:5px 10px;border:none}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMultiLayoutComponent, [{
        type: Component,
        args: [{ selector: 'ex-multi-layout', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\r\n\r\n    <ng-container *ngIf=\"!this.sectionService\" [ngTemplateOutlet]=\"toggle\">\r\n    </ng-container>\r\n    <ng-template #toggle>\r\n        <div *ngIf=\"showToggle\" class=\"ex-multi-layout-selection-buttons\"\r\n            [class.ex-multi-layout-selection-buttons-margin]=\"!this.sectionService\">\r\n            <button *ngFor=\"let layout of layouts; let index = index\" class=\"ex-multi-layout-select-button {{('ex-multi-layout-select-button-' + layout.exMultiLayoutId) | generateHTMLId }}\"\r\n                [ngClass]=\"{ 'ex-multi-layout-selected': _activeLayoutIndex == index }\"\r\n                [exTooltip]=\"layout.label | translate\" [attr.aria-label]=\"layout.label | translate\"\r\n                [attr.aria-pressed]=\"_activeLayoutIndex == index\"\r\n                (click)=\"onLayoutChange(index, layout.exMultiLayoutId, $event)\">\r\n                <ex-icon *ngIf=\"layout.iconName != ''; else displayLabel\" [iconName]=\"layout.iconName\" [iconType]=\"layout.iconType\"></ex-icon>\r\n                <ng-template #displayLabel>\r\n                    <ex-label [value]=\"layout.label | translate\"></ex-label>\r\n                </ng-template>\r\n            </button>\r\n        </div>\r\n    </ng-template>\r\n    <ng-container *ngTemplateOutlet=\"activeLayoutTemplate; context: { $implicit: switchToLayoutData }\"></ng-container>\r\n\r\n    <ng-content></ng-content>\r\n</ng-container>\r\n", styles: [":host{display:flex;flex-direction:column;justify-content:flex-start;align-content:flex-start}.ex-multi-layout-selection-buttons{align-self:flex-end;display:flex;width:-moz-fit-content;width:fit-content}.ex-multi-layout-selection-buttons :focus{outline:none!important;border:2px solid #000;padding:3px 8px}.ex-multi-layout-selection-buttons button:first-child{border-start-start-radius:3px;border-end-start-radius:3px}.ex-multi-layout-selection-buttons button:first-child :focus{outline:none!important;border:2px solid #000;border-start-start-radius:3px;border-end-start-radius:3px;padding:3px 8px}.ex-multi-layout-selection-buttons button:last-child{border-start-end-radius:3px;border-end-end-radius:3px}.ex-multi-layout-selection-buttons button:last-child :focus{outline:none!important;border:2px solid #000;border-start-end-radius:3px;border-end-end-radius:3px;padding:3px 8px}.ex-multi-layout-selection-buttons-margin{margin-bottom:20px}.ex-multi-layout-select-button{padding:5px 10px;border:none}\n"] }]
    }], function () { return [{ type: ExSectionsLayoutSectionService, decorators: [{
                type: Optional
            }] }, { type: i0.ChangeDetectorRef }]; }, { activeLayoutId: [{
            type: Input
        }], showToggle: [{
            type: Input
        }], layoutChange: [{
            type: Output
        }], layouts: [{
            type: ContentChildren,
            args: [ExMultiLayoutIdentifierDirective]
        }], toggle: [{
            type: ViewChild,
            args: ['toggle']
        }] }); })();

class ExMultiLayoutModule {
    static { this.ɵfac = function ExMultiLayoutModule_Factory(t) { return new (t || ExMultiLayoutModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExMultiLayoutModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TranslateModule,
            MatTooltipModule,
            ExIconModule,
            ExDirectivesModule,
            EXPipesModule,
            ExLabelModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExMultiLayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExIconModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    ExLabelModule
                ],
                declarations: [
                    ExMultiLayoutComponent
                ],
                exports: [
                    ExMultiLayoutComponent
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExMultiLayoutModule, { declarations: [ExMultiLayoutComponent], imports: [CommonModule,
        TranslateModule,
        MatTooltipModule,
        ExIconModule,
        ExDirectivesModule,
        EXPipesModule,
        ExLabelModule], exports: [ExMultiLayoutComponent] }); })();

function ExListCustomizationComponent_div_1_div_1_ex_help_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ex-help-icon", 11);
    i0.ɵɵlistener("click", function ExListCustomizationComponent_div_1_div_1_ex_help_icon_3_Template_ex_help_icon_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("description", ctx_r8.helpDragDescribtion)("contentWidth", "350px");
} }
function ExListCustomizationComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExListCustomizationComponent_div_1_div_1_ex_help_icon_3_Template, 1, 2, "ex-help-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const list_r1 = ctx_r10.$implicit;
    const listIndex_r2 = ctx_r10.index;
    i0.ɵɵproperty("id", "ex-list-customization-title-" + list_r1.title);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, list_r1.title), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", listIndex_r2 === 0);
} }
function ExListCustomizationComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const list_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, list_r1.subTitle));
} }
function ExListCustomizationComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const list_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, list_r1.placeholderText), " ");
} }
function ExListCustomizationComponent_div_1_ng_container_5_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r15 = i0.ɵɵnextContext().index;
    const list_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", (list_r1.startingIndex || 0) + i_r15 + 1, " ");
} }
function ExListCustomizationComponent_div_1_ng_container_5_div_1_ex_checkbox_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 22);
    i0.ɵɵlistener("checkedChange", function ExListCustomizationComponent_div_1_ng_container_5_div_1_ex_checkbox_4_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r24); const item_r14 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(item_r14.show = $event); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, item_r14.text))("disabled", item_r14.isHideable !== true || ctx_r17.isReadOnly)("checked", item_r14.show)("uniqueSelector", item_r14.text);
} }
function ExListCustomizationComponent_div_1_ng_container_5_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, item_r14.text), "");
} }
function ExListCustomizationComponent_div_1_ng_container_5_div_1_ex_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 24);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const item_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconType", item_r14.icon.type)("iconName", item_r14.icon.name)("color", item_r14.icon.color)("matTooltip", i0.ɵɵpipeBind1(1, 4, item_r14.icon.tooltip));
} }
function ExListCustomizationComponent_div_1_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵpipe(2, "exClassNameFormat");
    i0.ɵɵtemplate(3, ExListCustomizationComponent_div_1_ng_container_5_div_1_div_3_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(4, ExListCustomizationComponent_div_1_ng_container_5_div_1_ex_checkbox_4_Template, 2, 6, "ex-checkbox", 18);
    i0.ɵɵtemplate(5, ExListCustomizationComponent_div_1_ng_container_5_div_1_div_5_Template, 3, 3, "div", 19);
    i0.ɵɵtemplate(6, ExListCustomizationComponent_div_1_ng_container_5_div_1_ex_icon_6_Template, 2, 6, "ex-icon", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ex-list-customization-list-item-horizontal", ctx_r13.dropListOrientation === "horizontal");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (item_r14 == null ? null : item_r14.name) && i0.ɵɵpipeBind1(2, 7, "sel-top-right-" + (item_r14 == null ? null : item_r14.name)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.showIndexes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showCheckboxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.showCheckboxes && item_r14.text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r14.icon);
} }
function ExListCustomizationComponent_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExListCustomizationComponent_div_1_ng_container_5_div_1_Template, 7, 9, "div", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const list_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", list_r1.notCustomizableItems);
} }
function ExListCustomizationComponent_div_1_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const list_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", (list_r1.startingIndex || 0) + ((list_r1.notCustomizableItems == null ? null : list_r1.notCustomizableItems.length) || 0) + i_r30 + 1, " ");
} }
function ExListCustomizationComponent_div_1_div_6_ex_checkbox_8_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 31);
    i0.ɵɵlistener("checkedChange", function ExListCustomizationComponent_div_1_div_6_ex_checkbox_8_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r41); const item_r29 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(item_r29.show = $event); })("checkedChange", function ExListCustomizationComponent_div_1_div_6_ex_checkbox_8_Template_ex_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r41); const item_r29 = i0.ɵɵnextContext().$implicit; const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.onCheckedChanged($event, item_r29)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 6, item_r29.text))("checked", item_r29.show)("disabled", !item_r29.isHideable || ctx_r32.isReadOnly)("ariaLabel", (item_r29.show ? i0.ɵɵpipeBind1(2, 8, "ng.ex-list-customization.checkbox.hide-aria-label") : i0.ɵɵpipeBind1(3, 10, "ng.ex-list-customization.checkbox.unhide-aria-label")) + " " + item_r29.text)("exTooltip", item_r29.show ? i0.ɵɵpipeBind1(4, 12, "ng.ex-list-customization.checkbox.hide") : i0.ɵɵpipeBind1(5, 14, "ng.ex-list-customization.checkbox.unhide"))("uniqueSelector", item_r29.text);
} }
function ExListCustomizationComponent_div_1_div_6_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, item_r29.text), "");
} }
function ExListCustomizationComponent_div_1_div_6_ex_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 24);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconType", item_r29.icon.type)("iconName", item_r29.icon.name)("color", item_r29.icon.color)("matTooltip", i0.ɵɵpipeBind1(1, 4, item_r29.icon.tooltip));
} }
function ExListCustomizationComponent_div_1_div_6_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r29.secondaryText));
} }
function ExListCustomizationComponent_div_1_div_6_div_11_ex_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 35);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("iconType", item_r29.secondaryIcon.type)("iconName", item_r29.secondaryIcon.name)("color", item_r29.secondaryIcon.color)("exTooltip", i0.ɵɵpipeBind1(1, 5, item_r29.secondaryIcon.tooltip));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, item_r29.secondaryIcon.tooltip));
} }
function ExListCustomizationComponent_div_1_div_6_div_11_ex_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 36);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const list_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("iconType", list_r1.secondaryIcon.type)("iconName", list_r1.secondaryIcon.name)("color", list_r1.secondaryIcon.color)("matTooltip", i0.ɵɵpipeBind1(1, 5, list_r1.secondaryIcon.tooltip));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, list_r1.secondaryIcon.tooltip));
} }
function ExListCustomizationComponent_div_1_div_6_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, ExListCustomizationComponent_div_1_div_6_div_11_div_1_Template, 3, 3, "div", 7);
    i0.ɵɵtemplate(2, ExListCustomizationComponent_div_1_div_6_div_11_ex_icon_2_Template, 3, 9, "ex-icon", 33);
    i0.ɵɵtemplate(3, ExListCustomizationComponent_div_1_div_6_div_11_ex_icon_3_Template, 3, 9, "ex-icon", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = i0.ɵɵnextContext().$implicit;
    const list_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r29.secondaryText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r29.secondaryIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", list_r1.secondaryIcon);
} }
function ExListCustomizationComponent_div_1_div_6_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = i0.ɵɵnextContext().index;
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "ng.general.customize-actions.main-action"), " ", ctx_r36.visibleActionsNum > 1 ? ctx_r36.checkedActionIndexesMap[i_r30] + 1 : "", "");
} }
function ExListCustomizationComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26);
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelement(3, "ex-drag-accessible-icon", 27);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, ExListCustomizationComponent_div_1_div_6_div_7_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(8, ExListCustomizationComponent_div_1_div_6_ex_checkbox_8_Template, 6, 16, "ex-checkbox", 28);
    i0.ɵɵtemplate(9, ExListCustomizationComponent_div_1_div_6_div_9_Template, 3, 3, "div", 19);
    i0.ɵɵtemplate(10, ExListCustomizationComponent_div_1_div_6_ex_icon_10_Template, 2, 6, "ex-icon", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ExListCustomizationComponent_div_1_div_6_div_11_Template, 4, 3, "div", 29);
    i0.ɵɵtemplate(12, ExListCustomizationComponent_div_1_div_6_div_12_Template, 3, 4, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = ctx.$implicit;
    const i_r30 = ctx.index;
    const list_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    let tmp_5_0;
    i0.ɵɵclassProp("ex-list-customization-list-item-horizontal", ctx_r7.dropListOrientation === "horizontal");
    i0.ɵɵproperty("cdkDragBoundary", ".alma-customization-container-content")("cdkDragData", item_r29);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-list-customization-list-item-left-side ", i0.ɵɵpipeBind1(2, 15, "ex-list-customization-list-item-" + item_r29.text), "");
    i0.ɵɵproperty("ngClass", (item_r29 == null ? null : item_r29.name) && "sel-top-right-" + (item_r29 == null ? null : item_r29.name));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dragItemDescription", i0.ɵɵpipeBind1(4, 17, item_r29 == null ? null : item_r29.text) + " " + i0.ɵɵpipeBind1(5, 19, (tmp_5_0 = list_r1.secondaryIcon == null ? null : list_r1.secondaryIcon.tooltip) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "") + i0.ɵɵpipeBind1(6, 21, (tmp_5_0 = item_r29.secondaryIcon == null ? null : item_r29.secondaryIcon.tooltip) !== null && tmp_5_0 !== undefined ? tmp_5_0 : ""));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r7.showIndexes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showCheckboxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.showCheckboxes && item_r29.text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r29.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", list_r1.secondaryIcon || item_r29.secondaryText || item_r29.secondaryIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.checkedActionIndexesMap[i_r30] < ctx_r7.visibleActionsNum && ctx_r7.isAction && list_r1.id === "actions");
} }
function ExListCustomizationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ExListCustomizationComponent_div_1_div_1_Template, 4, 5, "div", 3);
    i0.ɵɵtemplate(2, ExListCustomizationComponent_div_1_div_2_Template, 3, 3, "div", 4);
    i0.ɵɵelementStart(3, "ex-drag-list", 5);
    i0.ɵɵlistener("cdkDropListDropped", function ExListCustomizationComponent_div_1_Template_ex_drag_list_cdkDropListDropped_3_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r57.drop($event)); });
    i0.ɵɵtemplate(4, ExListCustomizationComponent_div_1_div_4_Template, 3, 3, "div", 6);
    i0.ɵɵtemplate(5, ExListCustomizationComponent_div_1_ng_container_5_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtemplate(6, ExListCustomizationComponent_div_1_div_6_Template, 13, 23, "div", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const list_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-labelledby", "ex-list-customization-title-" + list_r1.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", list_r1.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", list_r1.subTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-list-customization-empty-list-placeholder", !list_r1.hidePlaceholder && (list_r1.items == null ? null : list_r1.items.length) === 0)("ex-list-customization-list-items-wrapper-horizontal", ctx_r0.dropListOrientation === "horizontal");
    i0.ɵɵproperty("id", list_r1.id)("cdkDropListOrientation", ctx_r0.dropListOrientation)("cdkDropListData", list_r1.items)("cdkDropListDisabled", ctx_r0.isReadOnly)("cdkDropListEnterPredicate", ctx_r0.predicateFunction.bind(ctx_r0, list_r1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !list_r1.hidePlaceholder && (list_r1.items == null ? null : list_r1.items.length) === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", list_r1.notCustomizableItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", list_r1.items);
} }
class ExListCustomizationComponent {
    constructor(translate) {
        this.translate = translate;
        this.lists = [];
        this.dropListOrientation = 'vertical';
        this.showIndexes = true;
        this.isAction = false;
        this.predicateFunction = (list, drag) => true;
        this.showCheckboxes = false;
        this.isReadOnly = false;
        this.listChanged = new EventEmitter();
        this.checkboxChanged = new EventEmitter();
        this.checkedActionIndexesMap = {};
    }
    ngOnInit() {
        if (this.isAction) {
            this.disableOnlySelectedAction();
        }
        this.createCheckedActionIndexesMap();
        this.helpDragDescribtion = this.translate.instant('ng.drag.accessible-icon.help-icon1') + '\n' +
            this.translate.instant('ng.drag.accessible-icon.help-icon2') + '\n' +
            this.translate.instant('ng.drag.accessible-icon.help-icon3');
    }
    drop(event) {
        if (event.previousContainer === event.container) {
            const copy = [...event.container.data];
            moveItemInArray(copy, event.previousIndex, event.currentIndex);
            this.listChanged.emit({
                listId: event.previousContainer.id,
                list: copy,
                cdkEvent: event
            });
        }
        else {
            const copy1 = [...event.previousContainer.data];
            const copy2 = [...event.container.data];
            transferArrayItem(copy1, copy2, event.previousIndex, event.currentIndex);
            this.listChanged.emit({
                listId1: event.previousContainer.id,
                list1: copy1,
                listId2: event.container.id,
                list2: copy2,
                cdkEvent: event
            });
        }
    }
    createCheckedActionIndexesMap() {
        let showIndex = 0;
        this.lists[0]?.items?.forEach((item, i) => {
            if (item.show) {
                this.checkedActionIndexesMap[i] = showIndex++;
            }
            else {
                this.checkedActionIndexesMap[i] = Infinity;
            }
        });
    }
    onCheckedChanged(checked, item) {
        if (this.isAction) {
            this.disableOnlySelectedAction();
        }
        this.createCheckedActionIndexesMap();
        this.checkboxChanged.emit({ checked: checked, item: item });
    }
    disableOnlySelectedAction() {
        if (this.lists[0].items.filter(item => item.show === true).length === 1) {
            this.lists[0].items.forEach(item => {
                if (item.show) {
                    item.isHideable = false;
                }
            });
        }
        else {
            this.lists[0].items.forEach(item => item.isHideable = true);
        }
    }
    static { this.ɵfac = function ExListCustomizationComponent_Factory(t) { return new (t || ExListCustomizationComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExListCustomizationComponent, selectors: [["ex-list-customization"]], inputs: { lists: "lists", dropListOrientation: "dropListOrientation", showIndexes: "showIndexes", mandatoryFieldsData: "mandatoryFieldsData", isAction: "isAction", predicateFunction: "predicateFunction", showCheckboxes: "showCheckboxes", visibleActionsNum: "visibleActionsNum", isReadOnly: "isReadOnly" }, outputs: { listChanged: "listChanged", checkboxChanged: "checkboxChanged" }, decls: 2, vars: 1, consts: [["cdkDropListGroup", "", 1, "ex-list-customization-wrapper"], ["class", "ex-list-customization-list-wrapper", "role", "region", 4, "ngFor", "ngForOf"], ["role", "region", 1, "ex-list-customization-list-wrapper"], ["class", "ex-list-customization-list-title", "role", "heading", "aria-level", "1", 3, "id", 4, "ngIf"], ["class", "ex-list-customization-list-sub-title", 4, "ngIf"], ["cdkDropList", "", 1, "ex-list-customization-list-items-wrapper", 3, "id", "cdkDropListOrientation", "cdkDropListData", "cdkDropListDisabled", "cdkDropListEnterPredicate", "cdkDropListDropped"], ["class", "ex-list-customization-empty-list-placeholder-text", 4, "ngIf"], [4, "ngIf"], ["cdkDrag", "", "class", "ex-list-customization-list-item", 3, "cdkDragBoundary", "cdkDragData", "ex-list-customization-list-item-horizontal", 4, "ngFor", "ngForOf"], ["role", "heading", "aria-level", "1", 1, "ex-list-customization-list-title", 3, "id"], [3, "description", "contentWidth", "click", 4, "ngIf"], [3, "description", "contentWidth", "click"], [1, "ex-list-customization-list-sub-title"], [1, "ex-list-customization-empty-list-placeholder-text"], ["class", "ex-list-customization-list-item ex-list-customization-list-item-disabled", 3, "ex-list-customization-list-item-horizontal", 4, "ngFor", "ngForOf"], [1, "ex-list-customization-list-item", "ex-list-customization-list-item-disabled"], [1, "ex-list-customization-list-item-left-side", 3, "ngClass"], ["class", "ex-list-customization-index", 4, "ngIf"], [3, "label", "disabled", "checked", "uniqueSelector", "checkedChange", 4, "ngIf"], ["class", "ex-list-customization-list-item-text", 4, "ngIf"], ["sizePx", "20px", 3, "iconType", "iconName", "color", "matTooltip", 4, "ngIf"], [1, "ex-list-customization-index"], [3, "label", "disabled", "checked", "uniqueSelector", "checkedChange"], [1, "ex-list-customization-list-item-text"], ["sizePx", "20px", 3, "iconType", "iconName", "color", "matTooltip"], ["cdkDrag", "", 1, "ex-list-customization-list-item", 3, "cdkDragBoundary", "cdkDragData"], [3, "ngClass"], [1, "ex-list-customization-list-item-drag-icon", 3, "dragItemDescription"], [3, "label", "checked", "disabled", "ariaLabel", "exTooltip", "uniqueSelector", "checkedChange", 4, "ngIf"], ["class", "ex-list-customization-list-item-right-side", 4, "ngIf"], ["class", "ex-list-customization-list-item-main-action", 4, "ngIf"], [3, "label", "checked", "disabled", "ariaLabel", "exTooltip", "uniqueSelector", "checkedChange"], [1, "ex-list-customization-list-item-right-side"], ["class", "ex-list-customization-list-item-secondary-icon", "sizePx", "14px", 3, "iconType", "iconName", "color", "exTooltip", 4, "ngIf"], ["class", "ex-list-customization-list-item-secondary-icon", "sizePx", "14px", 3, "iconType", "iconName", "color", "matTooltip", 4, "ngIf"], ["sizePx", "14px", 1, "ex-list-customization-list-item-secondary-icon", 3, "iconType", "iconName", "color", "exTooltip"], ["sizePx", "14px", 1, "ex-list-customization-list-item-secondary-icon", 3, "iconType", "iconName", "color", "matTooltip"], [1, "ex-list-customization-list-item-main-action"]], template: function ExListCustomizationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-drag-group", 0);
            i0.ɵɵtemplate(1, ExListCustomizationComponent_div_1_Template, 7, 15, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.lists);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i15.CdkDropList, i15.CdkDropListGroup, i15.CdkDrag, ExIconComponent, i4.MatTooltip, ExDragAccessibleIconComponent, ExDragListComponent, ExDragGroupComponent, ExCheckboxComponent, ExTooltipDirective, ExHelpIconComponent, i1$2.TranslatePipe, ExClassNameFormatPipe, ExGenerateIdPipe], styles: [".ex-list-customization-list-wrapper[_ngcontent-%COMP%]:not(:first-child)   .ex-list-customization-list-title[_ngcontent-%COMP%]{margin-top:30px}.ex-list-customization-list-wrapper[_ngcontent-%COMP%]   .ex-list-customization-list-title[_ngcontent-%COMP%]{font-weight:700;display:flex;justify-content:space-between}.ex-list-customization-list-wrapper[_ngcontent-%COMP%]   .ex-list-customization-empty-list-placeholder[_ngcontent-%COMP%]{border:dashed 1px #555;padding:10px 0;min-height:50px;position:relative}.ex-list-customization-list-wrapper[_ngcontent-%COMP%]   .ex-list-customization-empty-list-placeholder[_ngcontent-%COMP%]   .ex-list-customization-empty-list-placeholder-text[_ngcontent-%COMP%]{position:absolute;top:50%;white-space:nowrap;left:50%;transform:translate(-50%,-50%)}.ex-list-customization-list-items-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-top:20px}.ex-list-customization-list-items-wrapper-horizontal[_ngcontent-%COMP%]{flex-direction:row}.ex-list-customization-list-item-disabled[_ngcontent-%COMP%]{padding-inline-start:25px}.ex-list-customization-list-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:space-between;margin-bottom:10px}.ex-list-customization-list-item[_ngcontent-%COMP%]:not(.ex-list-customization-list-item-disabled){cursor:move}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-left-side[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:flex-start;position:relative}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-left-side[_ngcontent-%COMP%]   .ex-list-customization-list-item-drag-icon[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-left-side[_ngcontent-%COMP%]:hover   ex-icon[_ngcontent-%COMP%]{visibility:visible}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-left-side[_ngcontent-%COMP%]   .ex-list-customization-index[_ngcontent-%COMP%]{margin-inline-end:10px}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-left-side[_ngcontent-%COMP%]   .ex-list-customization-list-item-text[_ngcontent-%COMP%]{margin-right:10px}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-right-side[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:row}.ex-list-customization-list-item[_ngcontent-%COMP%]   .ex-list-customization-list-item-right-side[_ngcontent-%COMP%]   .ex-list-customization-list-item-secondary-icon[_ngcontent-%COMP%]{margin-left:10px}.ex-list-customization-list-item-horizontal[_ngcontent-%COMP%]{margin-bottom:0;padding:0 15px}.cdk-drop-list-receiving[_ngcontent-%COMP%]   .ex-list-customization-empty-list-placeholder[_ngcontent-%COMP%], .cdk-drop-list-dragging[_ngcontent-%COMP%]   .ex-list-customization-empty-list-placeholder[_ngcontent-%COMP%]{background-color:#f5f8ff;border:dashed 1px #0d7bba}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box}.cdk-drop-list-dragging[_ngcontent-%COMP%]   .cdk-drag[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .3s cubic-bezier(0,0,.2,1)}ex-checkbox[_ngcontent-%COMP%]     .ex-checkbox-wrapper{padding-top:0}ex-checkbox[_ngcontent-%COMP%]     .ex-checkbox-wrapper .mdc-checkbox{transform:translateY(3px)}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListCustomizationComponent, [{
        type: Component,
        args: [{ selector: 'ex-list-customization', template: "<ex-drag-group class=\"ex-list-customization-wrapper\" cdkDropListGroup>\r\n    <div class=\"ex-list-customization-list-wrapper\" *ngFor=\"let list of lists; let listIndex = index\" role=\"region\"\r\n         [attr.aria-labelledby]=\"'ex-list-customization-title-'+ list.title\">\r\n        <div *ngIf=\"list.title\" class=\"ex-list-customization-list-title\" role=\"heading\" aria-level=\"1\"\r\n             [id]=\"'ex-list-customization-title-'+ list.title\" >\r\n          {{ list.title | translate }}\r\n          <ex-help-icon *ngIf=\"listIndex === 0\" [description]=\"helpDragDescribtion\" [contentWidth]=\"'350px'\" (click)=\"$event.stopPropagation()\">\r\n          </ex-help-icon>\r\n        </div>\r\n        <div *ngIf=\"list.subTitle\" class=\"ex-list-customization-list-sub-title\">{{ list.subTitle | translate }}</div>\r\n        <ex-drag-list [id]=\"list.id\" cdkDropList class=\"ex-list-customization-list-items-wrapper\"\r\n            [class.ex-list-customization-empty-list-placeholder]=\"!list.hidePlaceholder && list.items?.length === 0\"\r\n            [class.ex-list-customization-list-items-wrapper-horizontal]=\"dropListOrientation === 'horizontal'\"\r\n            [cdkDropListOrientation]=\"dropListOrientation\" [cdkDropListData]=\"list.items\" [cdkDropListDisabled]=\"isReadOnly\"\r\n            (cdkDropListDropped)=\"drop($event)\" [cdkDropListEnterPredicate]=\"predicateFunction.bind(this, list)\">\r\n            <div *ngIf=\"!list.hidePlaceholder && list.items?.length === 0\"\r\n                class=\"ex-list-customization-empty-list-placeholder-text\">{{ list.placeholderText | translate }}\r\n            </div>\r\n            <ng-container *ngIf=\"list.notCustomizableItems\">\r\n                <div *ngFor=\"let item of list.notCustomizableItems; let i = index\"\r\n                    class=\"ex-list-customization-list-item ex-list-customization-list-item-disabled\"\r\n                    [class.ex-list-customization-list-item-horizontal]=\"dropListOrientation === 'horizontal'\">\r\n                    <div class=\"ex-list-customization-list-item-left-side\" [ngClass]=\"item?.name && ('sel-top-right-'+ item?.name | exClassNameFormat)\">\r\n                        <div class=\"ex-list-customization-index\" *ngIf=\"showIndexes\">{{ (list.startingIndex || 0) + i +\r\n                            1 }}\r\n                        </div>\r\n                        <ex-checkbox *ngIf=\"showCheckboxes\" [label]=\" item.text | translate\" [disabled]=\"item.isHideable !== true || isReadOnly\"\r\n                            [(checked)]=\"item.show\" [uniqueSelector]=\"item.text\">\r\n                        </ex-checkbox>\r\n                        <div *ngIf=\"!showCheckboxes && item.text\" class=\"ex-list-customization-list-item-text\">\r\n                            {{ item.text | translate }}</div>\r\n                        <ex-icon *ngIf=\"item.icon\" [iconType]=\"item.icon.type\" [iconName]=\"item.icon.name\"\r\n                            [color]=\"item.icon.color\" sizePx=\"20px\"\r\n                            [matTooltip]=\"item.icon.tooltip | translate\"></ex-icon>\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n            <div *ngFor=\"let item of list.items; let i = index\" cdkDrag\r\n                [cdkDragBoundary]=\"'.alma-customization-container-content'\" [cdkDragData]=\"item\"\r\n                class=\"ex-list-customization-list-item\"\r\n                [class.ex-list-customization-list-item-horizontal]=\"dropListOrientation === 'horizontal'\">\r\n                <div class=\"ex-list-customization-list-item-left-side {{('ex-list-customization-list-item-' + item.text) | generateHTMLId }}\" [ngClass]=\"item?.name && ('sel-top-right-'+ item?.name)\">\r\n                    <ex-drag-accessible-icon class=\"ex-list-customization-list-item-drag-icon\" [dragItemDescription]=\"(item?.text | translate) + ' ' + (list.secondaryIcon?.tooltip??'' | translate) + (item.secondaryIcon?.tooltip??'' |translate) \">\r\n                    </ex-drag-accessible-icon>\r\n                    <div class=\"ex-list-customization-index\" *ngIf=\"showIndexes\">{{ (list.startingIndex || 0) +\r\n                        (list.notCustomizableItems?.length || 0) + i + 1 }}\r\n                    </div>\r\n                    <ex-checkbox *ngIf=\"showCheckboxes\" [label]=\" item.text | translate\" [(checked)]=\"item.show\"\r\n                                 (checkedChange)=\"onCheckedChanged($event, item)\" [disabled]=\"!item.isHideable || isReadOnly\"\r\n                                 [ariaLabel]=\"(item.show ? ('ng.ex-list-customization.checkbox.hide-aria-label' | translate)\r\n                                 : ('ng.ex-list-customization.checkbox.unhide-aria-label' | translate))  + ' ' + item.text\"\r\n                                 [exTooltip]=\"item.show ? ('ng.ex-list-customization.checkbox.hide' | translate) : ('ng.ex-list-customization.checkbox.unhide' | translate)\"\r\n                                 [uniqueSelector]=\"item.text\">\r\n                    </ex-checkbox>\r\n                    <div *ngIf=\"!showCheckboxes && item.text\" class=\"ex-list-customization-list-item-text\">\r\n                        {{ item.text | translate }}</div>\r\n                    <ex-icon *ngIf=\"item.icon\" [iconType]=\"item.icon.type\" [iconName]=\"item.icon.name\"\r\n                        [color]=\"item.icon.color\" sizePx=\"20px\" [matTooltip]=\"item.icon.tooltip | translate\"></ex-icon>\r\n                </div>\r\n                <div *ngIf=\"list.secondaryIcon || item.secondaryText || item.secondaryIcon\"\r\n                    class=\"ex-list-customization-list-item-right-side\">\r\n                    <div *ngIf=\"item.secondaryText\">{{ item.secondaryText | translate }}</div>\r\n                    <ex-icon class=\"ex-list-customization-list-item-secondary-icon\" *ngIf=\"item.secondaryIcon\"\r\n                        [iconType]=\"item.secondaryIcon.type\" [iconName]=\"item.secondaryIcon.name\"\r\n                        [color]=\"item.secondaryIcon.color\" sizePx=\"14px\"\r\n                        [exTooltip]=\"item.secondaryIcon.tooltip | translate\" [attr.aria-label]=\"item.secondaryIcon.tooltip | translate\"></ex-icon>\r\n                    <ex-icon class=\"ex-list-customization-list-item-secondary-icon\" *ngIf=\"list.secondaryIcon\"\r\n                        [iconType]=\"list.secondaryIcon.type\" [iconName]=\"list.secondaryIcon.name\"\r\n                        [color]=\"list.secondaryIcon.color\" sizePx=\"14px\"\r\n                        [matTooltip]=\"list.secondaryIcon.tooltip | translate\" [attr.aria-label]=\"list.secondaryIcon.tooltip | translate\"></ex-icon>\r\n                </div>\r\n                <div *ngIf=\"checkedActionIndexesMap[i] < visibleActionsNum && isAction && list.id === 'actions'\" class=\"ex-list-customization-list-item-main-action\">\r\n                    {{ 'ng.general.customize-actions.main-action' | translate }} {{ visibleActionsNum > 1 ? checkedActionIndexesMap[i] + 1 : '' }}</div>\r\n            </div>\r\n        </ex-drag-list>\r\n    </div>\r\n</ex-drag-group>\r\n", styles: [".ex-list-customization-list-wrapper:not(:first-child) .ex-list-customization-list-title{margin-top:30px}.ex-list-customization-list-wrapper .ex-list-customization-list-title{font-weight:700;display:flex;justify-content:space-between}.ex-list-customization-list-wrapper .ex-list-customization-empty-list-placeholder{border:dashed 1px #555;padding:10px 0;min-height:50px;position:relative}.ex-list-customization-list-wrapper .ex-list-customization-empty-list-placeholder .ex-list-customization-empty-list-placeholder-text{position:absolute;top:50%;white-space:nowrap;left:50%;transform:translate(-50%,-50%)}.ex-list-customization-list-items-wrapper{display:flex;flex-direction:column;margin-top:20px}.ex-list-customization-list-items-wrapper-horizontal{flex-direction:row}.ex-list-customization-list-item-disabled{padding-inline-start:25px}.ex-list-customization-list-item{display:flex;flex-direction:row;align-items:center;justify-content:space-between;margin-bottom:10px}.ex-list-customization-list-item:not(.ex-list-customization-list-item-disabled){cursor:move}.ex-list-customization-list-item .ex-list-customization-list-item-left-side{display:flex;flex-direction:row;align-items:flex-start;position:relative}.ex-list-customization-list-item .ex-list-customization-list-item-left-side .ex-list-customization-list-item-drag-icon{margin-inline-end:10px}.ex-list-customization-list-item .ex-list-customization-list-item-left-side:hover ex-icon{visibility:visible}.ex-list-customization-list-item .ex-list-customization-list-item-left-side .ex-list-customization-index{margin-inline-end:10px}.ex-list-customization-list-item .ex-list-customization-list-item-left-side .ex-list-customization-list-item-text{margin-right:10px}.ex-list-customization-list-item .ex-list-customization-list-item-right-side{display:flex;align-items:center;flex-direction:row}.ex-list-customization-list-item .ex-list-customization-list-item-right-side .ex-list-customization-list-item-secondary-icon{margin-left:10px}.ex-list-customization-list-item-horizontal{margin-bottom:0;padding:0 15px}.cdk-drop-list-receiving .ex-list-customization-empty-list-placeholder,.cdk-drop-list-dragging .ex-list-customization-empty-list-placeholder{background-color:#f5f8ff;border:dashed 1px #0d7bba}.cdk-drag-placeholder{opacity:0}.cdk-drag-preview{box-sizing:border-box}.cdk-drop-list-dragging .cdk-drag{transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating{transition:transform .3s cubic-bezier(0,0,.2,1)}ex-checkbox ::ng-deep .ex-checkbox-wrapper{padding-top:0}ex-checkbox ::ng-deep .ex-checkbox-wrapper .mdc-checkbox{transform:translateY(3px)}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { lists: [{
            type: Input
        }], dropListOrientation: [{
            type: Input
        }], showIndexes: [{
            type: Input
        }], mandatoryFieldsData: [{
            type: Input
        }], isAction: [{
            type: Input
        }], predicateFunction: [{
            type: Input
        }], showCheckboxes: [{
            type: Input
        }], visibleActionsNum: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], listChanged: [{
            type: Output
        }], checkboxChanged: [{
            type: Output
        }] }); })();

class ExListCustomizationModule {
    static { this.ɵfac = function ExListCustomizationModule_Factory(t) { return new (t || ExListCustomizationModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExListCustomizationModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            DragDropModule,
            ExIconModule,
            TranslateModule,
            MatTooltipModule,
            ExDragModule,
            ExCheckboxModule,
            ExDirectivesModule,
            EXPipesModule,
            ExHelpIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExListCustomizationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DragDropModule,
                    ExIconModule,
                    TranslateModule,
                    MatTooltipModule,
                    ExDragModule,
                    ExCheckboxModule,
                    ExDirectivesModule,
                    EXPipesModule,
                    ExHelpIconModule
                ],
                declarations: [
                    ExListCustomizationComponent
                ],
                exports: [
                    ExListCustomizationComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExListCustomizationModule, { declarations: [ExListCustomizationComponent], imports: [CommonModule,
        DragDropModule,
        ExIconModule,
        TranslateModule,
        MatTooltipModule,
        ExDragModule,
        ExCheckboxModule,
        ExDirectivesModule,
        EXPipesModule,
        ExHelpIconModule], exports: [ExListCustomizationComponent] }); })();

var ExNewFacetsTypes;
(function (ExNewFacetsTypes) {
    ExNewFacetsTypes["MULTI_SELECT"] = "MULTI_SELECT";
    ExNewFacetsTypes["SINGLE_SELECT"] = "SINGLE_SELECT";
    ExNewFacetsTypes["BOOLEAN"] = "BOOLEAN";
    ExNewFacetsTypes["RANGE"] = "RANGE";
    ExNewFacetsTypes["HIERARCHY"] = "HIERARCHY";
})(ExNewFacetsTypes || (ExNewFacetsTypes = {}));
var FreeTextInputTypes;
(function (FreeTextInputTypes) {
    FreeTextInputTypes["YEARS_RANGE"] = "YEARS_RANGE";
})(FreeTextInputTypes || (FreeTextInputTypes = {}));

class GetFacetsPipe {
    transform(appliedFacetsKeys, facetSections) {
        let facets;
        appliedFacetsKeys.forEach(key => {
            facets.push(this.findFacet(facetSections, key));
        });
        return facets;
    }
    findFacet(facetSections, facetKey) {
        let facet;
        for (const section of facetSections) {
            facet = section.facets?.find(facet => facet.key === facetKey);
            if (facet)
                return facet;
        }
    }
    static { this.ɵfac = function GetFacetsPipe_Factory(t) { return new (t || GetFacetsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getFacets", type: GetFacetsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GetFacetsPipe, [{
        type: Pipe,
        args: [{ name: 'getFacets' }]
    }], null, null); })();
class getFacetsLabelsPipe {
    transform(appliedFacetsKeys, facetsKeyLabel, sections, sectionKey) {
        // facetsKeyLabel can contain also old values that not must be in Sections
        let appliedFacetsLabels = {};
        // in HIERARCHY type - Only the last value should be displayed
        const section = sections.find((sec) => sec.key === sectionKey);
        if (section && section.type === ExNewFacetsTypes.HIERARCHY && appliedFacetsKeys.length > 0) {
            const lastKey = appliedFacetsKeys[appliedFacetsKeys.length - 1];
            const key = facetsKeyLabel?.[lastKey.key] ?? lastKey.key;
            appliedFacetsLabels[lastKey.key] = { label: key, isInclude: lastKey.isInclude };
            return appliedFacetsLabels;
        }
        appliedFacetsKeys?.forEach(({ key, isInclude }) => {
            const val = facetsKeyLabel?.[key] ?? key;
            appliedFacetsLabels[key] = { label: val, isInclude: isInclude };
        });
        return appliedFacetsLabels;
    }
    static { this.ɵfac = function getFacetsLabelsPipe_Factory(t) { return new (t || getFacetsLabelsPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getFacetsData", type: getFacetsLabelsPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(getFacetsLabelsPipe, [{
        type: Pipe,
        args: [{ name: 'getFacetsData' }]
    }], null, null); })();
class getSectionPipe {
    transform(sectionKey, sections) {
        return sections.find((sec) => sec.key === sectionKey);
    }
    static { this.ɵfac = function getSectionPipe_Factory(t) { return new (t || getSectionPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getSection", type: getSectionPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(getSectionPipe, [{
        type: Pipe,
        args: [{ name: 'getSection' }]
    }], null, null); })();

class ExSaveNewFacetsDialogComponent {
    constructor(data, fb, dialogRef, translate) {
        this.data = data;
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.translate = translate;
        this.saveAsDefault = false;
        this.errorLabels = {
            unique: 'ng.general.unique-error'
        };
        this.setValidator = (control) => {
            const name = control.value;
            if (this.data.groups.find(group => this.translate.instant(group) == name)) {
                return { unique: true };
            }
            return null;
        };
    }
    ngOnInit() {
        this.form = this.fb.group({
            name: ['', [Validators.required]],
        });
        this.form.controls['name'].addValidators(this.setValidator);
    }
    onSaveClicked() {
        this.dialogRef.close({ name: this.form.value.name, saveAsDefault: this.saveAsDefault });
    }
    static { this.ɵfac = function ExSaveNewFacetsDialogComponent_Factory(t) { return new (t || ExSaveNewFacetsDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$6.FormBuilder), i0.ɵɵdirectiveInject(i1$7.MatDialogRef, 8), i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSaveNewFacetsDialogComponent, selectors: [["ex-save-new-facets-dialog"]], decls: 9, vars: 12, consts: [[1, "ex-save-new-facet-dialog", 3, "formErrorLabels", "formGroup", "saveClicked"], [3, "label"], ["formControlName", "name"], [3, "checked", "label", "checkedChange"], [1, "ex-save-new-facet-dialog-default-massege", 3, "value"]], template: function ExSaveNewFacetsDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-form-dialog", 0);
            i0.ɵɵlistener("saveClicked", function ExSaveNewFacetsDialogComponent_Template_ex_form_dialog_saveClicked_0_listener() { return ctx.onSaveClicked(); });
            i0.ɵɵelementStart(1, "ex-form-fields")(2, "ex-form-field", 1);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelement(4, "ex-editable-text", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "ex-checkbox", 3);
            i0.ɵɵlistener("checkedChange", function ExSaveNewFacetsDialogComponent_Template_ex_checkbox_checkedChange_5_listener($event) { return ctx.saveAsDefault = $event; });
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "ex-label", 4);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("formErrorLabels", ctx.errorLabels)("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(3, 6, "ng.general.facets.save_as_new.name"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 8, "ng.general.facets.save_as_default"));
            i0.ɵɵproperty("checked", ctx.saveAsDefault);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", i0.ɵɵpipeBind1(8, 10, "ng.general.default-messege"));
        } }, dependencies: [i1$6.NgControlStatus, i1$6.NgControlStatusGroup, ExCheckboxComponent, ExFormDialogComponent, i1$6.FormGroupDirective, i1$6.FormControlName, ExFormFieldComponent, ExFormFieldsComponent, ExFormGroupDirective, ExFormErrorLabels, ExFormControlName, ExEditableTextComponent, ExLabelComponent, i1$2.TranslatePipe], styles: [".ex-facets-wrapper-wrapper[_ngcontent-%COMP%]{overflow:auto;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facet-wrapper-set-top-facet[_ngcontent-%COMP%]{width:auto;margin:0 18px;padding-top:15px;overflow-y:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]{position:sticky;top:0;width:100%;z-index:10}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-height:35vh;overflow-y:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-panel[_ngcontent-%COMP%]{box-shadow:none!important;width:auto;margin:15px 18px 1px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0 10px!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-start}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]{text-align:start;outline:none;margin-bottom:15px;margin-top:5px;padding-inline-end:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-button[_ngcontent-%COMP%]{margin-bottom:6px;margin-top:5px;padding-inline-end:5px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-button.waiting[_ngcontent-%COMP%]{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]:disabled{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]:hover:not([disabled]){text-decoration:underline}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]{outline:2px solid transparent;padding-top:3px;display:flex;align-items:flex-start}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-inline-start:1px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]:focus{border:2px solid black!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0 10px 0 6px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-search[_ngcontent-%COMP%]{margin:15px 18px 1px;width:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-search[_ngcontent-%COMP%]     .ex-search-search-wrapper{border:1px solid #cccccc}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-title[_ngcontent-%COMP%]{width:100%}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-section-label[_ngcontent-%COMP%]{overflow:hidden;font-weight:500!important;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-sections-wrapper[_ngcontent-%COMP%]{flex:1;padding-top:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-sections-wrapper[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]{display:block}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0;border:2px solid transparent}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]:focus{border-color:#000!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]{box-shadow:none!important;padding:0 18px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0 0 15px!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-label[_ngcontent-%COMP%]{margin:10px 0;align-self:center}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-image[_ngcontent-%COMP%]{align-self:center;padding-top:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]   .ex-facets-wrapper-apply-button[_ngcontent-%COMP%]{flex:1;border:none}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]   .ex-facets-wrapper-close-svg[_ngcontent-%COMP%]{border:0px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-placeholder[_ngcontent-%COMP%]{margin:0 0 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-placeholder-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-placeholder-header[_ngcontent-%COMP%]{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-placeholder-label[_ngcontent-%COMP%]{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-clear-button[_ngcontent-%COMP%]{width:50px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-clear-button[_ngcontent-%COMP%]     i{margin-top:5px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-range-container[_ngcontent-%COMP%]{margin-top:-15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-wrapper[_ngcontent-%COMP%]{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-label[_ngcontent-%COMP%]{margin-top:5px}.ex-facets-wrapper-saved-groups[_ngcontent-%COMP%]{margin-inline-start:-5px!important;margin-bottom:5px!important}.ex-facets-wrapper-saved-groups[_ngcontent-%COMP%]{margin-bottom:10px}.ex-applied-facets-wrapper-groups-border[_ngcontent-%COMP%]{border-top:1.5px solid rgba(85,51,85,.2);padding-top:10px}.ex-facets-wrapper-no-facets[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facets-wrapper-no-facets[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-img[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-save-new-facet-dialog[_ngcontent-%COMP%]   ex-form-fields[_ngcontent-%COMP%]{column-count:1!important}.ex-save-new-facet-dialog[_ngcontent-%COMP%]   .ex-save-new-facet-dialog-default-massege[_ngcontent-%COMP%]{font-size:smaller}.ex-facets-wrapper-saved-groups-wrapper[_ngcontent-%COMP%]{display:flex;column-gap:4px}.ex-facets-wrapper-saved-groups-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-saved-groups-label[_ngcontent-%COMP%]     .ex-label-wrapper{margin-top:6px}.ex-applied-facets-header-groups[_ngcontent-%COMP%]{margin-bottom:0!important;align-items:baseline}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSaveNewFacetsDialogComponent, [{
        type: Component,
        args: [{ selector: 'ex-save-new-facets-dialog', template: "<ex-form-dialog class=\"ex-save-new-facet-dialog\" [formErrorLabels]=\"errorLabels\"\r\n                [formGroup]=\"form\" (saveClicked)=\"onSaveClicked()\">\r\n  <ex-form-fields>\r\n    <ex-form-field label=\"{{'ng.general.facets.save_as_new.name' | translate}}\">\r\n      <ex-editable-text formControlName=\"name\"></ex-editable-text>\r\n    </ex-form-field>\r\n    <ex-checkbox [(checked)]=\"saveAsDefault\"\r\n                 label=\"{{'ng.general.facets.save_as_default' | translate}}\"></ex-checkbox>\r\n    <ex-label class=\"ex-save-new-facet-dialog-default-massege\"\r\n              [value]=\"'ng.general.default-messege' |translate\"></ex-label>\r\n  </ex-form-fields>\r\n</ex-form-dialog>\r\n", styles: [".ex-facets-wrapper-wrapper{overflow:auto;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper{height:100%;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facet-wrapper-set-top-facet{width:auto;margin:0 18px;padding-top:15px;overflow-y:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets{position:sticky;top:0;width:100%;z-index:10}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-wrapper{display:flex;flex-direction:column;max-height:35vh;overflow-y:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-panel{box-shadow:none!important;width:auto;margin:15px 18px 1px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-panel ::ng-deep .mat-expansion-panel-body{padding:0 10px!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container{display:flex;justify-content:flex-start}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear{text-align:start;outline:none;margin-bottom:15px;margin-top:5px;padding-inline-end:15px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-button{margin-bottom:6px;margin-top:5px;padding-inline-end:5px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-button.waiting{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear:disabled{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear:hover:not([disabled]){text-decoration:underline}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header{outline:2px solid transparent;padding-top:3px;display:flex;align-items:flex-start}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header p{padding-inline-start:1px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header:focus{border:2px solid black!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets mat-expansion-panel-header{padding:0 10px 0 6px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets mat-expansion-panel-header ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-search{margin:15px 18px 1px;width:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-search ::ng-deep .ex-search-search-wrapper{border:1px solid #cccccc}.ex-facets-wrapper-wrapper .ex-facets-wrapper-title{width:100%}.ex-facets-wrapper-wrapper .ex-facets-wrapper-section-label{overflow:hidden;font-weight:500!important;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}.ex-facets-wrapper-wrapper .ex-facet-sections-wrapper{flex:1;padding-top:15px}.ex-facets-wrapper-wrapper .ex-facet-sections-wrapper .mat-expansion-panel{display:block}.ex-facets-wrapper-wrapper mat-expansion-panel-header{padding:0;border:2px solid transparent}.ex-facets-wrapper-wrapper mat-expansion-panel-header:focus{border-color:#000!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel{box-shadow:none!important;padding:0 18px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel ::ng-deep .mat-expansion-panel-body{padding:0 0 15px!important}.ex-facets-wrapper-wrapper ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets-label{margin:10px 0;align-self:center}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets-image{align-self:center;padding-top:15px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets{display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply .ex-facets-wrapper-apply-button{flex:1;border:none}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply .ex-facets-wrapper-close-svg{border:0px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-placeholder{margin:0 0 24px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-placeholder-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-facets-wrapper-wrapper .ex-facet-placeholder-header{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facets-wrapper-wrapper .ex-facet-placeholder-label{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-clear-button{width:50px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-clear-button ::ng-deep i{margin-top:5px}.ex-facets-wrapper-wrapper .ex-facets-range-container{margin-top:-15px}.ex-facets-wrapper-wrapper .ex-facet-empty-wrapper{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facets-wrapper-wrapper .ex-facet-empty-wrapper .ex-facet-empty-label{margin-top:5px}.ex-facets-wrapper-saved-groups{margin-inline-start:-5px!important;margin-bottom:5px!important}.ex-facets-wrapper-saved-groups{margin-bottom:10px}.ex-applied-facets-wrapper-groups-border{border-top:1.5px solid rgba(85,51,85,.2);padding-top:10px}.ex-facets-wrapper-no-facets{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facets-wrapper-no-facets .ex-facets-wrapper-no-facets-img{display:flex;justify-content:center}.ex-save-new-facet-dialog ex-form-fields{column-count:1!important}.ex-save-new-facet-dialog .ex-save-new-facet-dialog-default-massege{font-size:smaller}.ex-facets-wrapper-saved-groups-wrapper{display:flex;column-gap:4px}.ex-facets-wrapper-saved-groups-wrapper .ex-facets-wrapper-saved-groups-label ::ng-deep .ex-label-wrapper{margin-top:6px}.ex-applied-facets-header-groups{margin-bottom:0!important;align-items:baseline}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$6.FormBuilder }, { type: i1$7.MatDialogRef, decorators: [{
                type: Optional
            }] }, { type: i1$2.TranslateService }]; }, null); })();

function ExCheckboxFacetsComponent_div_0_ex_svg_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 10);
} if (rf & 2) {
    const facet_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("iconName", facet_r2.icon.iconName)("tooltip", facet_r2.icon.iconName)("color", facet_r2.icon.iconColor);
} }
function ExCheckboxFacetsComponent_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
} if (rf & 2) {
    const facet_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "sel-value-" + ctx_r4.sectionKey)("innerHTML", facet_r2.labelAsHTML, i0.ɵɵsanitizeHtml);
} }
function ExCheckboxFacetsComponent_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
    i0.ɵɵpipe(1, "exTextHighlight");
    i0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const facet_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("ex-checkbox-facets-label sel-facet-value-", ctx_r5.facetSelNamesMap[facet_r2.key], " sel-facet-value-", ctx_r5.sectionKey, "");
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 5, i0.ɵɵpipeBind1(2, 8, facet_r2.label), ctx_r5.searchText), i0.ɵɵsanitizeHtml);
} }
function ExCheckboxFacetsComponent_div_0_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facet_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-checkbox-facets-count sel-facet-count-", ctx_r6.facetSelNamesMap[facet_r2.key], "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", facet_r2.count, ")");
} }
function ExCheckboxFacetsComponent_div_0_button_9_ex_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 16);
} }
function ExCheckboxFacetsComponent_div_0_button_9_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 17);
} }
function ExCheckboxFacetsComponent_div_0_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ExCheckboxFacetsComponent_div_0_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const facet_r2 = i0.ɵɵnextContext().$implicit; const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onExcludeChange(facet_r2.key, false)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ExCheckboxFacetsComponent_div_0_button_9_ex_svg_icon_3_Template, 1, 0, "ex-svg-icon", 14);
    i0.ɵɵtemplate(4, ExCheckboxFacetsComponent_div_0_button_9_ex_svg_icon_4_Template, 1, 0, "ex-svg-icon", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facet_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-checkbox-facets-exclude-button ex-checkbox-facets-checkbox sel-facet-checkbox-exclude-", ctx_r7.facetSelNamesMap[facet_r2.key], "");
    i0.ɵɵstyleProp("visibility", ctx_r7.selectedExcludeFacetsMap[facet_r2.key] ? "visible" : "");
    i0.ɵɵpropertyInterpolate2("exTooltip", "", i0.ɵɵpipeBind1(1, 10, "ng.general.exclude"), " ", i0.ɵɵpipeBind1(2, 12, facet_r2.label), "");
    i0.ɵɵattribute("aria-checked", ctx_r7.selectedExcludeFacetsMap[facet_r2.key]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r7.selectedExcludeFacetsMap[facet_r2.key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.selectedExcludeFacetsMap[facet_r2.key]);
} }
function ExCheckboxFacetsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "ex-checkbox", 3);
    i0.ɵɵlistener("checkboxChange", function ExCheckboxFacetsComponent_div_0_Template_ex_checkbox_checkboxChange_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const facet_r2 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onChange(facet_r2.key)); })("keyup.enter", function ExCheckboxFacetsComponent_div_0_Template_ex_checkbox_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const facet_r2 = restoredCtx.$implicit; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onChange(facet_r2.key)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 4);
    i0.ɵɵlistener("click", function ExCheckboxFacetsComponent_div_0_Template_button_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const facet_r2 = restoredCtx.$implicit; const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onChange(facet_r2.key, true)); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, ExCheckboxFacetsComponent_div_0_ex_svg_icon_5_Template, 1, 3, "ex-svg-icon", 5);
    i0.ɵɵtemplate(6, ExCheckboxFacetsComponent_div_0_span_6_Template, 1, 2, "span", 6);
    i0.ɵɵtemplate(7, ExCheckboxFacetsComponent_div_0_span_7_Template, 3, 10, "span", 7);
    i0.ɵɵtemplate(8, ExCheckboxFacetsComponent_div_0_span_8_Template, 2, 4, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExCheckboxFacetsComponent_div_0_button_9_Template, 5, 14, "button", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facet_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-checkbox-facets-checkbox sel-facet-checkbox-", ctx_r0.facetSelNamesMap[facet_r2.key], "");
    i0.ɵɵclassProp("ex-checkbox-facets-checkbox-hide", ctx_r0.isSingleSelect);
    i0.ɵɵproperty("ngClass", ctx_r0.selectedFacetsMap[facet_r2.key] ? "sel-facet-checkbox-checked-" + ctx_r0.facetSelNamesMap[facet_r2.key] + "" : "")("uniqueSelector", "ex-facet-checkbox-" + ctx_r0.facetSelNamesMap[facet_r2.key])("checked", ctx_r0.selectedFacetsMap[facet_r2.key])("ariaLabel", i0.ɵɵpipeBind1(2, 18, facet_r2.label) + " (" + facet_r2.count + ")");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-checkbox-facets-values sel-facet-button-", ctx_r0.facetSelNamesMap[facet_r2.key], "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(4, 20, facet_r2.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", facet_r2 == null ? null : facet_r2.icon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", facet_r2.labelAsHTML);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !facet_r2.labelAsHTML);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !facet_r2.hideCount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isExcludeFacets && ctx_r0.isEnableExcludeMultiSelect(facet_r2.key));
} }
function ExCheckboxFacetsComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function ExCheckboxFacetsComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.onShowMoreOrLess()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵelement(2, "ex-svg-icon", 19);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-checkbox-facets-buttons ", i0.ɵɵpipeBind1(1, 6, "ex-checkbox-facets-buttons-show-" + (ctx_r1.showMore ? "more" : "less") + "-" + ctx_r1.sectionKey), "");
    i0.ɵɵproperty("ngClass", "sel-" + (ctx_r1.showMore ? "more" : "less") + "-" + ctx_r1.sectionKey);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", ctx_r1.showMore ? "plus" : "minus");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.showMore ? i0.ɵɵpipeBind1(4, 8, ctx_r1.showMoreLabel) + " (" + (ctx_r1.facets.length - ctx_r1.numberOfFacetsToDisplay) + ")" : i0.ɵɵpipeBind1(5, 10, ctx_r1.showLessLabel), "\n");
} }
var ExCheckboxFacetsLabels;
(function (ExCheckboxFacetsLabels) {
    ExCheckboxFacetsLabels["facetClicked"] = "ng.facets.facet_clicked";
    ExCheckboxFacetsLabels["facetSelected"] = "ng.facets.facet_selected";
    ExCheckboxFacetsLabels["facetUnselected"] = "ng.facets.facet_unselected";
})(ExCheckboxFacetsLabels || (ExCheckboxFacetsLabels = {}));
class ExCheckboxFacetsComponent {
    constructor(translate, liveAnnouncer) {
        this.translate = translate;
        this.liveAnnouncer = liveAnnouncer;
        /**
         * The selected facets
         */
        this.selectedFacets = [];
        /**
         * The option to allow only single facet select
         */
        this.isSingleSelect = false;
        this.searchText = "";
        this.facetSelected = new EventEmitter();
        this.facetUnselected = new EventEmitter();
        this.selectedFacetsMap = {};
        this.selectedExcludeFacetsMap = {};
        this.excludeFacetsCounter = 0;
        this.facetSelNamesMap = {};
        this.showMore = false;
        this.showMoreLabel = 'facets_layout.facets.group.more';
        this.showLessLabel = 'facets_layout.facets.group.less';
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('numberOfFacetsToDisplay') || changes.hasOwnProperty('facets')) {
            this.showMore = false;
            if (this.numberOfFacetsToDisplay < this.facets.length) {
                this.showMore = true;
            }
        }
        if (changes.hasOwnProperty('selectedFacets')) {
            this._initializeSelectedFacetsMap();
        }
        if (changes.hasOwnProperty('facets')) {
            this._initializeFacetSelNamesMap();
            this._sortFacetValues();
        }
        if (changes.hasOwnProperty('isAlphabeticalSort')) {
            this._sortFacetValues();
        }
    }
    _sortFacetValues() {
        if (this.isAlphabeticalSort) {
            this.facets.sort((a, b) => a?.label?.localeCompare(b?.label));
        }
    }
    _initializeFacetSelNamesMap() {
        this.facetSelNamesMap = {};
        this.facets?.forEach(facet => {
            this.facetSelNamesMap[facet?.key] =
                this.sectionKey + '-' + facet?.label?.replace(/\s/g, '')?.replace(/[^a-zA-Z0-9_-]/g, "");
        });
    }
    _initializeSelectedFacetsMap() {
        this.selectedFacetsMap = {};
        this.selectedFacets?.filter(f => f.isInclude)?.forEach(facet => {
            this.selectedFacetsMap[facet.key] = true;
        });
        this.selectedExcludeFacetsMap = {};
        this.selectedFacets?.filter(f => !f.isInclude)?.forEach(facet => {
            this.selectedExcludeFacetsMap[facet.key] = true;
        });
    }
    onFacetSelected(facetKey, applyChanges, isInclude = true) {
        this.announce(applyChanges ? ExCheckboxFacetsLabels.facetClicked :
            ExCheckboxFacetsLabels.facetSelected, facetKey);
        this.facetSelected.emit({ facetKey, sectionKey: this.sectionKey, applyChanges, isInclude, removeEntireSection: (this.isSingleSelect && this.selectedFacets?.length > 0) });
    }
    onFacetUnselected(facetKey, applyChanges, isInclude = true) {
        this.announce(applyChanges ? ExCheckboxFacetsLabels.facetClicked :
            ExCheckboxFacetsLabels.facetUnselected, facetKey);
        this.facetUnselected.emit({ facetKey, sectionKey: this.sectionKey, applyChanges, isInclude });
    }
    onChange(facetKey, applyChanges = false) {
        this.selectedFacetsMap[facetKey] ? this.onFacetUnselected(facetKey, applyChanges) : this.onFacetSelected(facetKey, applyChanges);
    }
    onExcludeChange(facetKey, applyChanges = false) {
        if (this.selectedExcludeFacetsMap[facetKey]) {
            this.onFacetUnselected(facetKey, applyChanges, false);
            this.excludeFacetsCounter--;
        }
        else {
            this.onFacetSelected(facetKey, applyChanges, false);
            this.excludeFacetsCounter++;
        }
    }
    onShowMoreOrLess() {
        this.showMore = !this.showMore;
    }
    announce(label, facetKey) {
        this.liveAnnouncer.announce(this.translate.instant(label, { facetKey: facetKey }));
    }
    isEnableExcludeMultiSelect(facetKey) {
        return this.isSingleSelect == false || (this.isSingleSelect && this.excludeFacetsCounter == 0 || this.selectedExcludeFacetsMap[facetKey]);
    }
    static { this.ɵfac = function ExCheckboxFacetsComponent_Factory(t) { return new (t || ExCheckboxFacetsComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExLiveAnnouncerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExCheckboxFacetsComponent, selectors: [["ex-checkbox-facets"]], inputs: { facets: "facets", sectionKey: "sectionKey", selectedFacets: "selectedFacets", numberOfFacetsToDisplay: "numberOfFacetsToDisplay", isSingleSelect: "isSingleSelect", isExcludeFacets: "isExcludeFacets", isAlphabeticalSort: "isAlphabeticalSort", searchText: "searchText" }, outputs: { facetSelected: "facetSelected", facetUnselected: "facetUnselected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 6, consts: [["class", "ex-checkbox-facets", 4, "ngFor", "ngForOf"], [3, "class", "ngClass", "click", 4, "ngIf"], [1, "ex-checkbox-facets"], [3, "ngClass", "uniqueSelector", "checked", "ariaLabel", "checkboxChange", "keyup.enter"], ["matTooltipPosition", "above", 3, "exTooltip", "click"], ["class", "ex-checkbox-icons", 3, "iconName", "tooltip", "color", 4, "ngIf"], ["class", "ex-checkbox-facets-label-html", 3, "ngClass", "innerHTML", 4, "ngIf"], [3, "class", "innerHtml", 4, "ngIf"], [3, "class", 4, "ngIf"], ["role", "switch", 3, "class", "exTooltip", "visibility", "click", 4, "ngIf"], [1, "ex-checkbox-icons", 3, "iconName", "tooltip", "color"], [1, "ex-checkbox-facets-label-html", 3, "ngClass", "innerHTML"], [3, "innerHtml"], ["role", "switch", 3, "exTooltip", "click"], ["iconName", "Deselect", "size", "medium", 4, "ngIf"], ["iconName", "Deselect-bold", "size", "medium", 4, "ngIf"], ["iconName", "Deselect", "size", "medium"], ["iconName", "Deselect-bold", "size", "medium"], [3, "ngClass", "click"], ["color", "#4164a4", "size", "xsmall", "ariaLabel", "showMoreLabel", 3, "iconName"]], template: function ExCheckboxFacetsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExCheckboxFacetsComponent_div_0_Template, 10, 22, "div", 0);
            i0.ɵɵpipe(1, "slice");
            i0.ɵɵtemplate(2, ExCheckboxFacetsComponent_button_2_Template, 6, 12, "button", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(1, 2, ctx.facets, 0, ctx.showMore ? ctx.numberOfFacetsToDisplay : ctx.facets.length));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showMore || ctx.numberOfFacetsToDisplay < ctx.facets.length);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, ExCheckboxComponent, ExSvgIconComponent, i1$5.SlicePipe, i1$2.TranslatePipe, ExTextHighlightPipe, ExGenerateIdPipe], styles: ["@charset \"UTF-8\";button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-checkbox-facets[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:flex-start}.ex-checkbox-facets[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-checkbox[_ngcontent-%COMP%]{align-self:flex-start}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-count[_ngcontent-%COMP%]{margin:0 0 0 5px}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-values[_ngcontent-%COMP%]{margin-left:5px;display:flex;flex-basis:fit-content;justify-content:flex-start;width:100%;padding:0 5px;min-width:0;border-radius:4px}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-values[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:5px}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-values[_ngcontent-%COMP%]   .ex-checkbox-facets-label[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-values[_ngcontent-%COMP%]   .ex-checkbox-facets-label-html[_ngcontent-%COMP%]{text-align:left}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-values[_ngcontent-%COMP%]   .ex-checkbox-icons[_ngcontent-%COMP%]{margin-inline-end:5px}.ex-checkbox-facets[_ngcontent-%COMP%]:hover   .ex-checkbox-facets-exclude-button[_ngcontent-%COMP%], .ex-checkbox-facets[_ngcontent-%COMP%]:focus-within   .ex-checkbox-facets-exclude-button[_ngcontent-%COMP%]{visibility:visible}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-exclude-button[_ngcontent-%COMP%]{padding:0;flex-grow:0;flex-basis:24px;height:24px;visibility:hidden;position:relative;margin-inline-start:auto}.ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-exclude-button[_ngcontent-%COMP%]:hover   ex-svg-icon[_ngcontent-%COMP%]:after, .ex-checkbox-facets[_ngcontent-%COMP%]   .ex-checkbox-facets-exclude-button[_ngcontent-%COMP%]:active   ex-svg-icon[_ngcontent-%COMP%]:after{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none;content:\"\\a0\";background:gray;border-radius:100%;opacity:.1}.ex-checkbox-facets-buttons[_ngcontent-%COMP%]{display:flex;align-items:baseline;column-gap:4px;margin-inline-start:2px}.ex-checkbox-facets-buttons[_ngcontent-%COMP%]:focus{outline:2px solid black}.ex-checkbox-facets-checkbox-hide[_ngcontent-%COMP%]{display:none}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExCheckboxFacetsComponent, [{
        type: Component,
        args: [{ selector: 'ex-checkbox-facets', template: "<div class=\"ex-checkbox-facets\"\n    *ngFor=\" let facet of facets | slice: 0: (showMore? numberOfFacetsToDisplay : facets.length)\">\n    <ex-checkbox class=\"ex-checkbox-facets-checkbox sel-facet-checkbox-{{facetSelNamesMap[facet.key]}}\"\n        [class.ex-checkbox-facets-checkbox-hide]=\"isSingleSelect\"\n        [ngClass]=\"selectedFacetsMap[facet.key] ? 'sel-facet-checkbox-checked-' + facetSelNamesMap[facet.key] + '': '' \"\n        [uniqueSelector]=\"'ex-facet-checkbox-' + facetSelNamesMap[facet.key]\"\n        [checked]=\"selectedFacetsMap[facet.key]\" (checkboxChange)=\"onChange(facet.key)\"\n        (keyup.enter)=\"onChange(facet.key)\" [ariaLabel]=\"(facet.label | translate) + ' (' + facet.count + ')'\">\n    </ex-checkbox>\n    <button class=\"ex-checkbox-facets-values sel-facet-button-{{facetSelNamesMap[facet.key]}}\"\n        [exTooltip]=\"facet.label | translate\" matTooltipPosition=\"above\" (click)=\"onChange(facet.key, true)\"\n        >\n      <ex-svg-icon *ngIf=\"facet?.icon\" class=\"ex-checkbox-icons\" [iconName]=\"facet.icon.iconName\" [tooltip]=\"facet.icon.iconName\" [color]=\"facet.icon.iconColor\"></ex-svg-icon>\n        <span *ngIf=\"facet.labelAsHTML\" class=\"ex-checkbox-facets-label-html\" [ngClass]=\"'sel-value-'+sectionKey\"\n            [innerHTML]=\"facet.labelAsHTML\"></span>\n        <span *ngIf=\"!facet.labelAsHTML\"\n            class=\"ex-checkbox-facets-label sel-facet-value-{{facetSelNamesMap[facet.key]}} sel-facet-value-{{sectionKey}}\"\n            [innerHtml]=\"facet.label | translate | exTextHighlight: searchText\"></span>\n\n        <span *ngIf=\"!facet.hideCount\" class=\"ex-checkbox-facets-count sel-facet-count-{{facetSelNamesMap[facet.key]}}\">({{ facet.count\n            }})</span>\n    </button>\n    <button *ngIf=\"isExcludeFacets && isEnableExcludeMultiSelect(facet.key)\"\n        class=\"ex-checkbox-facets-exclude-button ex-checkbox-facets-checkbox sel-facet-checkbox-exclude-{{facetSelNamesMap[facet.key]}}\"\n        exTooltip=\"{{'ng.general.exclude' | translate}} {{facet.label | translate}}\"\n        [style.visibility]=\"selectedExcludeFacetsMap[facet.key]?'visible':''\"\n        (click)=\"onExcludeChange(facet.key, false)\" role=\"switch\"\n        [attr.aria-checked]=\"selectedExcludeFacetsMap[facet.key]\">\n        <ex-svg-icon *ngIf=\"!selectedExcludeFacetsMap[facet.key]\" iconName=\"Deselect\" size=\"medium\"></ex-svg-icon>\n        <ex-svg-icon *ngIf=\"selectedExcludeFacetsMap[facet.key]\" iconName=\"Deselect-bold\" size=\"medium\"></ex-svg-icon>\n    </button>\n</div>\n\n<button *ngIf=\"showMore || numberOfFacetsToDisplay < facets.length\" class=\"ex-checkbox-facets-buttons {{('ex-checkbox-facets-buttons-show-' + (showMore ? 'more' : 'less') + '-' + sectionKey) | generateHTMLId}}\"\n        [ngClass]=\"'sel-' + (showMore ? 'more' : 'less')  + '-' + sectionKey\" (click)=\"onShowMoreOrLess()\">\n  <ex-svg-icon color=\"#4164a4\" [iconName]=\"showMore ? 'plus' : 'minus'\" size=\"xsmall\" ariaLabel=\"showMoreLabel\"></ex-svg-icon>\n  {{ showMore ? (showMoreLabel | translate)+ \" (\" + (facets.length - numberOfFacetsToDisplay) + \")\" : showLessLabel | translate }}\n</button>\n", styles: ["@charset \"UTF-8\";button{border:0px;outline:0px}.ex-checkbox-facets{display:flex;flex-direction:row;align-items:flex-start}.ex-checkbox-facets button{border:0px;outline:0px}.ex-checkbox-facets .ex-checkbox-facets-checkbox{align-self:flex-start}.ex-checkbox-facets .ex-checkbox-facets-count{margin:0 0 0 5px}.ex-checkbox-facets .ex-checkbox-facets-values{margin-left:5px;display:flex;flex-basis:fit-content;justify-content:flex-start;width:100%;padding:0 5px;min-width:0;border-radius:4px}.ex-checkbox-facets .ex-checkbox-facets-values i{margin-right:5px}.ex-checkbox-facets .ex-checkbox-facets-values .ex-checkbox-facets-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left}.ex-checkbox-facets .ex-checkbox-facets-values .ex-checkbox-facets-label-html{text-align:left}.ex-checkbox-facets .ex-checkbox-facets-values .ex-checkbox-icons{margin-inline-end:5px}.ex-checkbox-facets:hover .ex-checkbox-facets-exclude-button,.ex-checkbox-facets:focus-within .ex-checkbox-facets-exclude-button{visibility:visible}.ex-checkbox-facets .ex-checkbox-facets-exclude-button{padding:0;flex-grow:0;flex-basis:24px;height:24px;visibility:hidden;position:relative;margin-inline-start:auto}.ex-checkbox-facets .ex-checkbox-facets-exclude-button:hover ex-svg-icon:after,.ex-checkbox-facets .ex-checkbox-facets-exclude-button:active ex-svg-icon:after{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none;content:\"\\a0\";background:gray;border-radius:100%;opacity:.1}.ex-checkbox-facets-buttons{display:flex;align-items:baseline;column-gap:4px;margin-inline-start:2px}.ex-checkbox-facets-buttons:focus{outline:2px solid black}.ex-checkbox-facets-checkbox-hide{display:none}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: ExLiveAnnouncerService }]; }, { facets: [{
            type: Input
        }], sectionKey: [{
            type: Input
        }], selectedFacets: [{
            type: Input
        }], numberOfFacetsToDisplay: [{
            type: Input
        }], isSingleSelect: [{
            type: Input
        }], isExcludeFacets: [{
            type: Input
        }], isAlphabeticalSort: [{
            type: Input
        }], searchText: [{
            type: Input
        }], facetSelected: [{
            type: Output
        }], facetUnselected: [{
            type: Output
        }] }); })();

const _c0$9 = ["tooltip"];
function ExAppliedFacetsComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3, 4);
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 5);
    i0.ɵɵlistener("click", function ExAppliedFacetsComponent_span_5_Template_button_click_11_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const item_r1 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onFacetUnapplied(item_r1.key)); })("mouseenter", function ExAppliedFacetsComponent_span_5_Template_button_mouseenter_11_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.hideDoubleTooltip()); });
    i0.ɵɵpipe(12, "generateHTMLId");
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelement(16, "ex-svg-icon", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("ex-applied-facets-label   sel-applied-facets-label  ", i0.ɵɵpipeBind1(2, 17, "ex-applied-facets-label-" + item_r1.key), "");
    i0.ɵɵpropertyInterpolate3("exTooltip", "", i0.ɵɵpipeBind1(3, 19, ctx_r0.sectionLabel || ctx_r0.sectionKey), ": ", i0.ɵɵpipeBind1(4, 21, !item_r1.isInclude ? "ng.general.not" : ""), " ", item_r1.label || item_r1.key, "");
    i0.ɵɵproperty("ngClass", ctx_r0.stickyFacetsObj[item_r1.key + item_r1.isInclude] ? "ex-selected-facet-stick-facet" : "ex-selected-facet-value-regular");
    i0.ɵɵattribute("aria-labelledby", "appliedFacetsSection_" + (ctx_r0.sectionLabel || ctx_r0.sectionKey))("aria-label", (ctx_r0.stickyFacetsObj[item_r1.key + item_r1.isInclude] ? i0.ɵɵpipeBind1(5, 23, "ng.general.facets.saved_facet") : "") + " " + i0.ɵɵpipeBind1(6, 25, ctx_r0.sectionLabel || ctx_r0.sectionKey) + ": " + i0.ɵɵpipeBind1(7, 27, !item_r1.isInclude ? "ng.general.not" : "") + " " + item_r1.label || item_r1.key);
    i0.ɵɵadvance(8);
    i0.ɵɵclassProp("ex-applied-facets-exclude", !item_r1.isInclude);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 29, item_r1.label || item_r1.key), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("ex-applied-facets-remove ", i0.ɵɵpipeBind1(12, 31, "ex-applied-facets-remove-" + item_r1.key), "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(13, 33, "ng.general.remove"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(14, 35, "ng.general.remove") + " " + i0.ɵɵpipeBind1(15, 37, !item_r1.isInclude ? "ng.general.not" : "") + " " + item_r1.label);
} }
class ExAppliedFacetsComponent {
    constructor() {
        /**
         *  The sticky facets of a specific section
         */
        this.stickyFacetsObj = {};
        /**
         * Fires when a selected facet is unselected
         */
        this.facetUnapplied = new EventEmitter();
    }
    set stickyFacetsItems(value) {
        if (Array.isArray(value)) {
            this.stickyFacetsObj = {};
            value.map(facet => this.stickyFacetsObj[facet.key + facet.isInclude] = true);
        }
    }
    ngOnInit() {
        this._transferData();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("isAlphabeticalSort")) {
            this._transferData();
        }
    }
    hideDoubleTooltip() {
        this.tooltip.hide();
    }
    onFacetUnapplied(facetKey) {
        this.facetUnapplied.emit({
            sectionKey: this.sectionKey,
            facetKey,
            applyChanges: true,
            removeEntireSection: this.removeEntireSection,
            isInclude: this.appliedFacets[facetKey].isInclude
        });
    }
    _transferData() {
        this.transferredAppliedFacets = [];
        const facetsArray = Object.entries(this.appliedFacets);
        if (this.isAlphabeticalSort) {
            facetsArray.sort((a, b) => (a[1]?.label || a[0]).localeCompare(b[1]?.label || b[0]));
        }
        facetsArray.forEach(f => {
            this.transferredAppliedFacets.push({ key: f[0], label: f[1].label, isInclude: f[1].isInclude });
        });
    }
    static { this.ɵfac = function ExAppliedFacetsComponent_Factory(t) { return new (t || ExAppliedFacetsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExAppliedFacetsComponent, selectors: [["ex-applied-facets"]], viewQuery: function ExAppliedFacetsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
        } }, inputs: { appliedFacets: "appliedFacets", stickyFacetsItems: "stickyFacetsItems", sectionKey: "sectionKey", sectionLabel: "sectionLabel", removeEntireSection: "removeEntireSection", isAlphabeticalSort: "isAlphabeticalSort" }, outputs: { facetUnapplied: "facetUnapplied" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 10, consts: [[1, "ex-applied-facets-wrapper"], [3, "id"], ["role", "group", "matTooltipPosition", "above", 3, "class", "ngClass", "exTooltip", 4, "ngFor", "ngForOf"], ["role", "group", "matTooltipPosition", "above", 3, "ngClass", "exTooltip"], ["tooltip", "exTooltip"], [3, "exTooltip", "click", "mouseenter"], ["iconName", "error", "size", "xsmall", "ariaLabel", "ng.general.remove", "color", "#4164A4", 1, "ex-applied-facets-remove-svg"]], template: function ExAppliedFacetsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵpipe(2, "generateHTMLId");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ExAppliedFacetsComponent_span_5_Template, 17, 39, "span", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("ex-applied-facets-section-label  ", i0.ɵɵpipeBind1(2, 6, "ex-applied-facets-section-label-" + (ctx.sectionLabel || ctx.sectionKey)), "");
            i0.ɵɵproperty("id", "appliedFacetsSection_" + (ctx.sectionLabel || ctx.sectionKey));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 8, ctx.sectionLabel || ctx.sectionKey), ":");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.transferredAppliedFacets);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, ExTooltipDirective, ExSvgIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: [".ex-applied-facets-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.ex-applied-facets-wrapper[_ngcontent-%COMP%]   .ex-applied-facets-section-label[_ngcontent-%COMP%]{margin-right:5px;margin-bottom:3px}.ex-applied-facets-wrapper[_ngcontent-%COMP%]   .ex-applied-facets-label[_ngcontent-%COMP%]{display:flex;align-items:center;padding:1px 5px;margin-bottom:3px;border-radius:3px;border-width:1px;border-style:solid}.ex-applied-facets-wrapper[_ngcontent-%COMP%]   .ex-applied-facets-label[_ngcontent-%COMP%]   .ex-applied-facets-exclude[_ngcontent-%COMP%]{color:#a92c41;text-decoration-line:line-through;text-decoration-color:#a92c41}.ex-applied-facets-wrapper[_ngcontent-%COMP%]   .ex-applied-facets-label[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:5px}.ex-applied-facets-wrapper[_ngcontent-%COMP%]   .ex-applied-facets-label[_ngcontent-%COMP%]:not(:last-child){margin-right:3px}.ex-applied-facets-remove[_ngcontent-%COMP%]{outline:none;background:none;color:#949594!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAppliedFacetsComponent, [{
        type: Component,
        args: [{ selector: 'ex-applied-facets', template: "<div class=\"ex-applied-facets-wrapper\">\n  <span [id]=\"'appliedFacetsSection_'+(sectionLabel || sectionKey)\" class=\"ex-applied-facets-section-label  {{'ex-applied-facets-section-label-' + (sectionLabel || sectionKey) | generateHTMLId}}\">{{ (sectionLabel || sectionKey) | translate }}:</span>\n  <span role=\"group\" class=\"ex-applied-facets-label   sel-applied-facets-label  {{'ex-applied-facets-label-' + item.key | generateHTMLId}}\"\n        [attr.aria-labelledby]=\"'appliedFacetsSection_'+(sectionLabel || sectionKey)\"\n        [ngClass]=\"stickyFacetsObj[item.key + item.isInclude]?'ex-selected-facet-stick-facet':'ex-selected-facet-value-regular'\"\n        *ngFor=\"let item of transferredAppliedFacets\" #tooltip=\"exTooltip\" matTooltipPosition=\"above\"\n        exTooltip=\"{{(sectionLabel || sectionKey) | translate }}: {{(!item.isInclude?'ng.general.not':'') | translate}} {{item.label || item.key}}\"\n        [attr.aria-label]=\"(stickyFacetsObj[item.key + item.isInclude]?('ng.general.facets.saved_facet' | translate):'')+' '+((sectionLabel || sectionKey) | translate) +\n        ': '+((!item.isInclude?'ng.general.not':'') | translate)+' '+item.label || item.key\">\n        <span [class.ex-applied-facets-exclude]=\"!item.isInclude\">\n            {{((item.label || item.key) | translate) }}\n        </span>\n        <button [exTooltip]=\"'ng.general.remove' | translate\" class=\"ex-applied-facets-remove {{'ex-applied-facets-remove-' + item.key | generateHTMLId}}\"\n                (click)=\"onFacetUnapplied(item.key)\" (mouseenter)=\"hideDoubleTooltip()\"\n                [attr.aria-label]=\"('ng.general.remove' | translate)+' '+((!item.isInclude?'ng.general.not':'') | translate)+' '+item.label\">\n            <ex-svg-icon iconName=\"error\" size=\"xsmall\" ariaLabel=\"ng.general.remove\" color=\"#4164A4\"\n                         class=\"ex-applied-facets-remove-svg\"></ex-svg-icon>\n        </button>\n    </span>\n</div>\n", styles: [".ex-applied-facets-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.ex-applied-facets-wrapper .ex-applied-facets-section-label{margin-right:5px;margin-bottom:3px}.ex-applied-facets-wrapper .ex-applied-facets-label{display:flex;align-items:center;padding:1px 5px;margin-bottom:3px;border-radius:3px;border-width:1px;border-style:solid}.ex-applied-facets-wrapper .ex-applied-facets-label .ex-applied-facets-exclude{color:#a92c41;text-decoration-line:line-through;text-decoration-color:#a92c41}.ex-applied-facets-wrapper .ex-applied-facets-label button{margin-left:5px}.ex-applied-facets-wrapper .ex-applied-facets-label:not(:last-child){margin-right:3px}.ex-applied-facets-remove{outline:none;background:none;color:#949594!important}\n"] }]
    }], null, { appliedFacets: [{
            type: Input
        }], stickyFacetsItems: [{
            type: Input
        }], sectionKey: [{
            type: Input
        }], sectionLabel: [{
            type: Input
        }], removeEntireSection: [{
            type: Input
        }], isAlphabeticalSort: [{
            type: Input
        }], facetUnapplied: [{
            type: Output
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }] }); })();

const _c0$8 = function (a0) { return { "ex-facet-toggle-wrapper-disabled": a0 }; };
class ExToggleFacetsComponent {
    constructor() {
        /**
         * data for the toggle -  checked, label, disabled, tooltip - if no tooltip transferred, the label will be used
         */
        this.toggleData = null;
        this.searchText = "";
        /**
         *  the event fires when a toggle changes to on/off
         */
        this.toggleChanged = new EventEmitter();
    }
    onToggleChanged(value) {
        //timeout is for the animation of the toggle to be shown before the page will refresh
        setTimeout(() => {
            this.toggleChanged.emit({ checked: value });
        }, 500);
    }
    static { this.ɵfac = function ExToggleFacetsComponent_Factory(t) { return new (t || ExToggleFacetsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExToggleFacetsComponent, selectors: [["ex-toggle-facets"]], inputs: { toggleData: "toggleData", searchText: "searchText" }, outputs: { toggleChanged: "toggleChanged" }, decls: 10, vars: 22, consts: [[1, "ex-facet-toggle-wrapper", 3, "ngClass"], [3, "exTooltip", "click"], [3, "innerHtml"], [1, "ex-facet-toggle-wrapper-slider", 3, "uniqueSelector", "toggleChecked", "ariaLabel", "toggleCheckedChange"], ["toggle", ""]], template: function ExToggleFacetsComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function ExToggleFacetsComponent_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(8); _r0.toggleChecked = !_r0.toggleChecked; return i0.ɵɵresetView(ctx.onToggleChanged(_r0.toggleChecked)); });
            i0.ɵɵpipe(2, "generateHTMLId");
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelement(4, "span", 2);
            i0.ɵɵpipe(5, "exTextHighlight");
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "ex-slide-toggle", 3, 4);
            i0.ɵɵlistener("toggleCheckedChange", function ExToggleFacetsComponent_Template_ex_slide_toggle_toggleCheckedChange_7_listener($event) { return ctx.onToggleChanged($event); });
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0$8, ctx.toggleData == null ? null : ctx.toggleData.disabled));
            i0.ɵɵadvance(1);
            i0.ɵɵclassMapInterpolate1("ex-facet-toggle-label ", (ctx.toggleData == null ? null : ctx.toggleData.key) ? i0.ɵɵpipeBind1(2, 9, "ex-facet-toggle-label-" + (ctx.toggleData == null ? null : ctx.toggleData.key)) : "", "");
            i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(3, 11, (ctx.toggleData == null ? null : ctx.toggleData.tooltip) ? ctx.toggleData == null ? null : ctx.toggleData.tooltip : ctx.toggleData == null ? null : ctx.toggleData.label));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(5, 13, i0.ɵɵpipeBind1(6, 16, ctx.toggleData.label), ctx.searchText), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("uniqueSelector", ctx.toggleData.key)("toggleChecked", ctx.toggleData == null ? null : ctx.toggleData.checked)("ariaLabel", i0.ɵɵpipeBind1(9, 18, ctx.toggleData == null ? null : ctx.toggleData.label));
        } }, dependencies: [i1$5.NgClass, ExTooltipDirective, ExSlideToggleComponent, i1$2.TranslatePipe, ExTextHighlightPipe, ExGenerateIdPipe], styles: [".ex-facet-toggle-wrapper[_ngcontent-%COMP%]{white-space:nowrap;display:flex;flex-direction:row;justify-content:space-between}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-wrapper-slider[_ngcontent-%COMP%]     .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-label[_ngcontent-%COMP%]{background:none;border:0;overflow:hidden;text-overflow:ellipsis;display:flex;flex:1;padding-bottom:5px;border:2px solid transparent}.ex-facet-toggle-wrapper[_ngcontent-%COMP%]   .ex-facet-toggle-label[_ngcontent-%COMP%]:focus{outline:0;border-color:#000}.ex-facet-toggle-wrapper-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExToggleFacetsComponent, [{
        type: Component,
        args: [{ selector: 'ex-toggle-facets', template: "<div class=\"ex-facet-toggle-wrapper\" [ngClass]=\"{'ex-facet-toggle-wrapper-disabled' : toggleData?.disabled}\">\n    <button class=\"ex-facet-toggle-label {{toggleData?.key ? ('ex-facet-toggle-label-' + toggleData?.key | generateHTMLId) : ''}}\" (click)=\"toggle.toggleChecked = !toggle.toggleChecked; onToggleChanged(toggle.toggleChecked);\"\n        [exTooltip]=\"(toggleData?.tooltip ? toggleData?.tooltip : toggleData?.label) | translate\">\n        <span [innerHtml]=\"toggleData.label | translate | exTextHighlight: searchText\"></span>\n    </button>\n  <ex-slide-toggle #toggle (toggleCheckedChange)=\"onToggleChanged($event)\" [uniqueSelector]=\"toggleData.key\" [toggleChecked]=\"toggleData?.checked\"\n                   [ariaLabel]=\"toggleData?.label | translate\" class=\"ex-facet-toggle-wrapper-slider\"\n  ></ex-slide-toggle>\n</div>\n", styles: [".ex-facet-toggle-wrapper{white-space:nowrap;display:flex;flex-direction:row;justify-content:space-between}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-bar{transform:scale(.7)!important;margin-right:0!important;margin-left:5px!important}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-label{flex-direction:row-reverse!important;justify-content:flex-end!important}.ex-facet-toggle-wrapper .ex-facet-toggle-wrapper-slider ::ng-deep .mat-slide-toggle-label{margin-bottom:0!important}.ex-facet-toggle-wrapper .ex-facet-toggle-label{background:none;border:0;overflow:hidden;text-overflow:ellipsis;display:flex;flex:1;padding-bottom:5px;border:2px solid transparent}.ex-facet-toggle-wrapper .ex-facet-toggle-label:focus{outline:0;border-color:#000}.ex-facet-toggle-wrapper-disabled{pointer-events:none;opacity:.5}\n"] }]
    }], function () { return []; }, { toggleData: [{
            type: Input
        }], searchText: [{
            type: Input
        }], toggleChanged: [{
            type: Output
        }] }); })();

const _c0$7 = function (a0, a1, a2) { return { "ex-facet-hierarchy-no-click": a0, "ex-facet-hierarchy-activated-blue-icon": a1, "ex-facet-hierarchy-deactivated-blue-icon": a2 }; };
const _c1$5 = function (a0, a1) { return { "ex-facet-hierarchy-no-click": a0, "ex-facet-hierarchy-selected-last": a1 }; };
function ExHierarchyFacetsComponent_ul_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5, 6);
    i0.ɵɵlistener("click", function ExHierarchyFacetsComponent_ul_2_li_1_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const selectedItem_r3 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onSelectedClicked(selectedItem_r3.key)); })("keydown.enter", function ExHierarchyFacetsComponent_ul_2_li_1_Template_li_keydown_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const selectedItem_r3 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onSelectedClicked(selectedItem_r3.key)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementStart(4, "div", 8)(5, "label", 9);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 10)(8, "button", 11);
    i0.ɵɵlistener("click", function ExHierarchyFacetsComponent_ul_2_li_1_Template_button_click_8_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const selectedItem_r3 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onSelectedClicked(selectedItem_r3.key)); });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelement(10, "i", 12);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const selectedItem_r3 = ctx.$implicit;
    const index_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("ex-facet-hierarchy-li ", i0.ɵɵpipeBind1(2, 14, selectedItem_r3), "");
    i0.ɵɵproperty("exTooltip", selectedItem_r3.label);
    i0.ɵɵattribute("aria-pressed", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(20, _c0$7, index_r4 === ctx_r2.hierarchyLength, index_r4 === ctx_r2.hierarchyLength, index_r4 !== ctx_r2.hierarchyLength));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("ex-facet-hierarchy-pointer", !ctx_r2.disabled && index_r4 !== ctx_r2.hierarchyLength);
    i0.ɵɵproperty("ngClass", "sel-selected-value-" + selectedItem_r3.key)("ngClass", i0.ɵɵpureFunction2(24, _c1$5, index_r4 === ctx_r2.hierarchyLength, index_r4 === ctx_r2.hierarchyLength));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", selectedItem_r3.label || selectedItem_r3.key, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "sel-value-remove" + selectedItem_r3.key);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 16, "ng.general.remove") + " " + selectedItem_r3.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(11, 18, "ng.general.remove"));
} }
function ExHierarchyFacetsComponent_ul_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 0);
    i0.ɵɵtemplate(1, ExHierarchyFacetsComponent_ul_2_li_1_Template, 12, 27, "li", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.selectedHierarchy);
} }
function ExHierarchyFacetsComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 13);
    i0.ɵɵlistener("click", function ExHierarchyFacetsComponent_li_6_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onChange(item_r10.key, true)); });
    i0.ɵɵpipe(2, "generateHTMLId");
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵpipe(4, "exTextHighlight");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "label", 15);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-facet-hierarchy-list-button ", i0.ɵɵpipeBind1(2, 10, item_r10), "");
    i0.ɵɵproperty("exTooltip", item_r10.label)("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-pressed", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(4, 12, i0.ɵɵpipeBind1(5, 15, item_r10.label || item_r10.key), ctx_r1.searchText), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("ex-facet-hierarchy-pointer", !ctx_r1.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", item_r10.count, ")");
} }
const _c2$3 = function (a0) { return { "ex-facet-hierarchy-left-border": a0 }; };
class ExHierarchyFacetsComponent extends ExCheckboxFacetsComponent {
    constructor(translate, liveAnnouncer) {
        super(translate, liveAnnouncer);
        this.translate = translate;
        this.liveAnnouncer = liveAnnouncer;
        this.sectionsKeyLabel = {};
        this.searchText = "";
        this.disabled = false;
        /**
         * Find the hierarchy. Store the result in variable in order to keep the pointer stable.
         */
        this._selectedHierarchy = null;
    }
    ngOnInit() {
    }
    /**
     * For move back within the exist hierarchy.
     * @param selectedItem key of the clicked item
     */
    onSelectedClicked(selectedItem) {
        if (this.disabled) {
            return;
        }
        this.disabled = true;
        // The page was initialized with selected hierarchy. User want remove it.
        if (!this.selectedFacets?.[0]?.hierarchy) {
            this.onChange(this.selectedFacets[0].key, true);
            return;
        }
        // Any item in the hierarchy clicked, remove his children from the hierarchy.
        while (this.selectedFacets?.[0]?.hierarchy?.length > 0) {
            if (selectedItem == this.selectedFacets?.[0]?.hierarchy?.pop()?.key) {
                break;
            }
        }
        // removed the clicked item from the hierarchy. (or - in case the clicked item is the root)
        this.onChange(this.selectedFacets?.[0]?.hierarchy?.pop()?.key || this.selectedFacets?.[0].key, true);
    }
    /**
     * Return the amount of items in hierarchy minus 1.
     */
    get hierarchyLength() {
        if (this.selectedFacets[0].hierarchy) {
            return this.selectedFacets[0].hierarchy?.length - 1;
        }
        // Case of initialized with selected item, should return 0;
        return this.selectedFacets.length - 1;
    }
    get selectedHierarchy() {
        if (this._selectedHierarchy)
            return this._selectedHierarchy;
        if (this.selectedFacets[0].hierarchy) {
            return this._selectedHierarchy = this.selectedFacets[0].hierarchy;
        }
        // Case of initialized with selected item, should create the base hierarchy;
        if (this.selectedFacets.length === 1) {
            return this._selectedHierarchy = [{ key: this.selectedFacets[0].key, label: this.sectionsKeyLabel[this.selectedFacets[0].key] }];
        }
        return null;
    }
    /**
     * override and redirect.
     * @param values parameters
     */
    onChange(...values) {
        this.disabled = true;
        super.onChange.apply(this, values);
    }
    /**
     * override. set the hierarchy to selected facets.
     */
    onFacetSelected(facetKey, applyChanges, isInclude = true) {
        this.facetSelected.emit({ facetKey, sectionKey: this.sectionKey, applyChanges, isInclude, hierarchy: cloneDeep(this._selectedHierarchy || []).concat({ key: facetKey, label: this.sectionsKeyLabel[facetKey] }), removeEntireSection: true });
    }
    static { this.ɵfac = function ExHierarchyFacetsComponent_Factory(t) { return new (t || ExHierarchyFacetsComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(ExLiveAnnouncerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExHierarchyFacetsComponent, selectors: [["ex-hierarchy-facets"]], inputs: { sectionsKeyLabel: "sectionsKeyLabel", searchText: "searchText" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 5, consts: [[1, "ex-facet-hierarchy-ul"], ["class", "ex-facet-hierarchy-ul", 4, "ngIf"], [3, "ngClass"], [4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 3, "class", "exTooltip", "click", "keydown.enter", 4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 3, "exTooltip", "click", "keydown.enter"], ["tooltip", "exTooltip"], [1, "fa", "fa-circle", "ex-facet-hierarchy-icon", 3, "ngClass"], [1, "ex-facet-hierarchy-selected-item-wrapper"], [1, "ex-facet-hierarchy-ellipsis", "ex-facet-hierarchy-selected", 3, "ngClass"], [1, "ex-facet-hierarchy-flex-grow-end"], [1, "ex-facet-hierarchy-remove-btn", 3, "ngClass", "click"], [1, "uxf-icon", "uxf-close-circle", "uxfBlueHover", 3, "exTooltip"], ["matTooltipPosition", "above", 3, "exTooltip", "disabled", "click"], [1, "ex-facet-hierarchy-ellipsis", "ex-facet-hierarchy-inherit-color", 3, "innerHtml"], [1, "ex-facet-hierarchy-side-margin", "ex-facet-hierarchy-inherit-color", "sel-facet-count"]], template: function ExHierarchyFacetsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 0)(1, "li");
            i0.ɵɵtemplate(2, ExHierarchyFacetsComponent_ul_2_Template, 2, 1, "ul", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "li")(4, "div", 2)(5, "ul", 0);
            i0.ɵɵtemplate(6, ExHierarchyFacetsComponent_li_6_Template, 8, 17, "li", 3);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedFacets.length > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$3, ctx.selectedFacets.length > 0));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.facets);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, i1$2.TranslatePipe, ExTextHighlightPipe, ExGenerateIdPipe], styles: ["button[_ngcontent-%COMP%]{border:0px;outline:0px}.ex-facet-hierarchy-selected[_ngcontent-%COMP%]{margin-bottom:0}.ex-facet-hierarchy-side-margin[_ngcontent-%COMP%]{margin:0 5px}.ex-facet-hierarchy-list-button[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-hierarchy-ellipsis[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left;margin-bottom:0}.ex-facet-hierarchy-ul[_ngcontent-%COMP%]{list-style-type:none}.ex-facet-hierarchy-left-border[_ngcontent-%COMP%]{padding-left:16px;margin-left:5px}.ex-facet-hierarchy-icon[_ngcontent-%COMP%]{vertical-align:super;margin-right:10px}.ex-facet-hierarchy-li[_ngcontent-%COMP%]{white-space:nowrap;display:flex}.ex-facet-hierarchy-remove-btn[_ngcontent-%COMP%]{margin-left:5px;border:none;outline:none;background:none;display:flex}.ex-facet-hierarchy-icon-arrow[_ngcontent-%COMP%]{margin-left:5px;align-self:center}.ex-facet-hierarchy-selected-item-wrapper[_ngcontent-%COMP%]{display:flex;width:100%;overflow:hidden}.ex-facet-hierarchy-flex-grow-end[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex-grow:1}.ex-facet-hierarchy-deactivated-blue-icon[_ngcontent-%COMP%], .ex-facet-hierarchy-activated-blue-icon[_ngcontent-%COMP%]{align-self:center}.ex-facet-hierarchy-no-click[_ngcontent-%COMP%]{pointer-events:none}.ex-facet-hierarchy-pointer[_ngcontent-%COMP%]{cursor:pointer}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExHierarchyFacetsComponent, [{
        type: Component,
        args: [{ selector: 'ex-hierarchy-facets', template: "<ul class=\"ex-facet-hierarchy-ul\">\n  <li>\n    <ul class=\"ex-facet-hierarchy-ul\" *ngIf=\"selectedFacets.length > 0\">\n      <li class=\"ex-facet-hierarchy-li {{selectedItem | generateHTMLId}}\"\n          *ngFor=\"let selectedItem of selectedHierarchy; let index = index\"\n          [exTooltip]=\"selectedItem.label\" #tooltip=\"exTooltip\" role=\"button\" tabindex=\"0\" [attr.aria-pressed]=\"true\"\n          (click)=\"onSelectedClicked(selectedItem.key)\" (keydown.enter)=\"onSelectedClicked(selectedItem.key)\">\n        <i [ngClass]=\"{ 'ex-facet-hierarchy-no-click': index === (hierarchyLength),\n                      'ex-facet-hierarchy-activated-blue-icon': index === (hierarchyLength),\n                      'ex-facet-hierarchy-deactivated-blue-icon': index !== (hierarchyLength) }\"\n           class=\"fa fa-circle ex-facet-hierarchy-icon\"></i>\n        <div class=\"ex-facet-hierarchy-selected-item-wrapper\">\n          <label class=\"ex-facet-hierarchy-ellipsis ex-facet-hierarchy-selected\"\n                 [class.ex-facet-hierarchy-pointer]=\"!disabled && index !== (hierarchyLength)\"\n                 [ngClass]=\"'sel-selected-value-' + selectedItem.key\" [ngClass]=\"{'ex-facet-hierarchy-no-click': index === (hierarchyLength),\n                      'ex-facet-hierarchy-selected-last': index === (hierarchyLength) }\">\n            {{ selectedItem.label || selectedItem.key }}\n          </label>\n          <div class=\"ex-facet-hierarchy-flex-grow-end\">\n            <button class=\"ex-facet-hierarchy-remove-btn\" [ngClass]=\"'sel-value-remove' + selectedItem.key\"\n                    (click)=\"onSelectedClicked(selectedItem.key)\"\n                      [attr.aria-label]=\"('ng.general.remove' | translate)+' '+selectedItem.label\">\n              <i class=\"uxf-icon uxf-close-circle uxfBlueHover\" [exTooltip]=\"'ng.general.remove' | translate\"></i>\n            </button>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </li>\n  <li>\n    <div [ngClass]=\"{'ex-facet-hierarchy-left-border': selectedFacets.length > 0}\">\n      <ul class=\"ex-facet-hierarchy-ul\">\n        <li *ngFor=\"let item of facets\">\n          <button [exTooltip]=\"item.label\" matTooltipPosition=\"above\" [disabled]=\"disabled\"\n                  class=\"ex-facet-hierarchy-list-button {{item | generateHTMLId}}\" (click)=\"onChange(item.key, true)\"\n                  [attr.aria-pressed]=\"false\">\n        <span class=\"ex-facet-hierarchy-ellipsis ex-facet-hierarchy-inherit-color\"\n              [innerHtml]=\"(item.label || item.key) | translate | exTextHighlight: searchText\"></span>\n            <label class=\"ex-facet-hierarchy-side-margin ex-facet-hierarchy-inherit-color sel-facet-count\"\n                   [class.ex-facet-hierarchy-pointer]=\"!disabled\">\n              ({{ item.count }})</label>\n          </button>\n        </li>\n      </ul>\n    </div>\n  </li>\n</ul>\n", styles: ["button{border:0px;outline:0px}.ex-facet-hierarchy-selected{margin-bottom:0}.ex-facet-hierarchy-side-margin{margin:0 5px}.ex-facet-hierarchy-list-button{display:flex;flex:1;justify-content:flex-start;width:100%;padding:2px 0}.ex-facet-hierarchy-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;text-align:left;margin-bottom:0}.ex-facet-hierarchy-ul{list-style-type:none}.ex-facet-hierarchy-left-border{padding-left:16px;margin-left:5px}.ex-facet-hierarchy-icon{vertical-align:super;margin-right:10px}.ex-facet-hierarchy-li{white-space:nowrap;display:flex}.ex-facet-hierarchy-remove-btn{margin-left:5px;border:none;outline:none;background:none;display:flex}.ex-facet-hierarchy-icon-arrow{margin-left:5px;align-self:center}.ex-facet-hierarchy-selected-item-wrapper{display:flex;width:100%;overflow:hidden}.ex-facet-hierarchy-flex-grow-end{display:flex;justify-content:flex-end;flex-grow:1}.ex-facet-hierarchy-deactivated-blue-icon,.ex-facet-hierarchy-activated-blue-icon{align-self:center}.ex-facet-hierarchy-no-click{pointer-events:none}.ex-facet-hierarchy-pointer{cursor:pointer}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: ExLiveAnnouncerService }]; }, { sectionsKeyLabel: [{
            type: Input
        }], searchText: [{
            type: Input
        }] }); })();

function ExSetTopFacetComponent_ex_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 2);
    i0.ɵɵlistener("click", function ExSetTopFacetComponent_ex_button_0_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleOpenClickedEvent()); });
    i0.ɵɵelementStart(1, "div", 3)(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("full", true)("loading", ctx_r0.isLoading || ctx_r0.parentIsLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 4, ctx_r0.buttonHeaderLabel), "\u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedLibrariesTitleText);
} }
function ExSetTopFacetComponent_div_1_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "ex-checkbox", 19);
    i0.ɵɵlistener("checkedChange", function ExSetTopFacetComponent_div_1_div_9_div_1_Template_ex_checkbox_checkedChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r9); const historyItem_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.handleCheckboxChange($event, historyItem_r7)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const historyItem_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r6.libraryData[historyItem_r7])("exTooltip", ctx_r6.libraryData[historyItem_r7])("checked", ctx_r6.selectedLibrariesIDs.indexOf(historyItem_r7) > -1);
} }
function ExSetTopFacetComponent_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ExSetTopFacetComponent_div_1_div_9_div_1_Template, 3, 3, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.recentItems);
} }
function ExSetTopFacetComponent_div_1_ex_checkbox_11_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox", 19);
    i0.ɵɵlistener("checkedChange", function ExSetTopFacetComponent_div_1_ex_checkbox_11_Template_ex_checkbox_checkedChange_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r12); const library_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.handleCheckboxChange($event, library_r10.value)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const library_r10 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", library_r10.key)("exTooltip", library_r10.key)("checked", ctx_r5.selectedLibrariesIDs.indexOf(library_r10.value) > -1);
} }
function ExSetTopFacetComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ex-button", 7);
    i0.ɵɵlistener("click", function ExSetTopFacetComponent_div_1_Template_ex_button_click_5_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.closeFacetDrawer()); });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "ex-search", 9);
    i0.ɵɵlistener("searchTriggered", function ExSetTopFacetComponent_div_1_Template_ex_search_searchTriggered_8_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.handleSearchTriggered($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ExSetTopFacetComponent_div_1_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵtemplate(11, ExSetTopFacetComponent_div_1_ex_checkbox_11_Template, 1, 3, "ex-checkbox", 12);
    i0.ɵɵpipe(12, "keyvalue");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 13)(14, "ex-button", 14);
    i0.ɵɵlistener("click", function ExSetTopFacetComponent_div_1_Template_ex_button_click_14_listener() { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.handleClearClicked()); });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "ex-button", 15);
    i0.ɵɵlistener("click", function ExSetTopFacetComponent_div_1_Template_ex_button_click_18_listener() { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.handleApplyClicked()); });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 17, ctx_r1.fixedFacetTitle));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(6, 19, "ng.general.cancel"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("incremental", true)("autoFocus", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.recentItems !== null && ctx_r1.recentItems.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(12, 21, ctx_r1.displayList));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(15, 23, "ng.general.clear.all"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading)("disabled", ctx_r1.clearDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 25, "ng.general.clear.all"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(19, 27, "ng.general.apply"));
    i0.ɵɵproperty("full", true)("loading", ctx_r1.isLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 29, "ng.general.apply"), " ");
} }
class ExSetTopFacetComponent {
    set itemsGetterCallback(cb) {
        if (cb !== null) {
            this._itemsGetterCallback = cb;
            this._itemsGetterCallback.subscribe(response => {
                this.libraryData = response;
                this.loadingObs.next();
            });
        }
    }
    set loadSelectedCallback(cb) {
        if (cb !== null) {
            this._loadSelectedCallback = cb;
            this._loadSelectedCallback.subscribe((response) => {
                const oldCachedSelectedLibrariesIDs = this.cachedSelectedLibrariesIDs;
                if (typeof response === 'undefined' || !response.hasOwnProperty('appliedFacets')) {
                    this.cachedSelectedLibrariesIDs = [];
                }
                else {
                    const objType = Object.keys(response.appliedFacets);
                    this.cachedSelectedLibrariesIDs = objType.length ? response.appliedFacets[objType[0]].map(item => item.key) : [];
                }
                if (!isEqual(oldCachedSelectedLibrariesIDs, this.cachedSelectedLibrariesIDs)) {
                    this.facetChanged.emit({ selectedLibrariesIDs: this.cachedSelectedLibrariesIDs, reload: false });
                    this.loadingObs.next();
                }
            });
        }
    }
    set saveSelectedCallback(cb) {
        if (cb !== null) {
            this._saveSelectedCallback = cb;
        }
    }
    set loadHidtorySelectionCallback(cb) {
        if (cb !== null) {
            this._loadHidtorySelectionCallback = cb;
            this._loadHidtorySelectionCallback.subscribe(response => {
                if (typeof response === 'undefined' || response === null || response.length === 0) {
                    this.recentItems = [];
                }
                else {
                    this.recentItems = JSON.parse(response);
                }
                this.loadingObs.next();
            });
        }
    }
    set saveHidtorySelectionCallback(cb) {
        if (cb !== null) {
            this._saveHidtorySelectionCallback = cb;
        }
    }
    constructor(translate) {
        this.translate = translate;
        this._itemsGetterCallback = null;
        this._loadSelectedCallback = null;
        this._saveSelectedCallback = null;
        this._loadHidtorySelectionCallback = null;
        this._saveHidtorySelectionCallback = null;
        this.buttonHeaderLabel = '';
        this.fixedFacetTitle = '';
        this.parentIsLoading = false;
        this.facetChanged = new EventEmitter();
        this.openStateChange = new EventEmitter();
        this.isLoading = true;
        this.isOpen = false;
        this.libraryData = {};
        this.searchText = '';
        this.displayList = {};
        this.cachedSelectedLibrariesIDs = [];
        this.selectedLibrariesIDs = [];
        this.recentItems = [];
        this.selectedLibrariesTitleText = '';
        this.defaultSelectedLibrariesText = 'ng.general.all';
        this.clearDisabled = false;
        this.loadingObs = new Subject();
        this.numberOfRecentItems = 3;
        let counter = 0;
        const self = this;
        this.loadingObs.subscribe(function () {
            counter++;
            if (counter > 1) {
                self.fillAndFilterDisplayList();
                self.reloadCachedSelected();
                self.isLoading = false;
            }
        });
    }
    ngOnDestroy() {
        this.loadingObs.unsubscribe();
    }
    // Copy while filtering by search text the library list to a display list
    fillAndFilterDisplayList() {
        this.displayList = {};
        for (const libraryId in this.libraryData) {
            if (this.libraryData.hasOwnProperty(libraryId)) {
                if (this.searchText.trim().length === 0 || (this.searchText.trim().length > 0 && this.libraryData[libraryId].toLowerCase().includes(this.searchText))) {
                    this.displayList[this.libraryData[libraryId]] = libraryId;
                }
            }
        }
    }
    // Reset selected library list to saved values
    reloadCachedSelected() {
        this.selectedLibrariesIDs = this.cachedSelectedLibrariesIDs.slice();
        this.selectedLibrariesTitleText = '';
        this.clearDisabled = this.cachedSelectedLibrariesIDs.length === 0;
        for (let libraryId in this.libraryData) {
            if (this.selectedLibrariesIDs.indexOf(libraryId) > -1) {
                this.selectedLibrariesTitleText += this.libraryData[libraryId] + ', ';
            }
        }
        this.selectedLibrariesTitleText = this.selectedLibrariesTitleText.trim();
        if (this.selectedLibrariesTitleText === '') {
            this.selectedLibrariesTitleText = this.translate.instant(this.defaultSelectedLibrariesText);
        }
        else if (this.selectedLibrariesTitleText.lastIndexOf(',') === this.selectedLibrariesTitleText.length - 1) {
            this.selectedLibrariesTitleText = this.selectedLibrariesTitleText.slice(0, this.selectedLibrariesTitleText.length - 1);
        }
        //update text in box
        if (this._saveSelectedCallback !== null) {
            this._saveSelectedCallback(this.cachedSelectedLibrariesIDs, this.selectedLibrariesTitleText, false);
        }
    }
    handleOpenClickedEvent() {
        this.isOpen = true;
        this.openStateChange.emit(this.isOpen);
    }
    handleSearchTriggered(searchText) {
        this.searchText = searchText.toLowerCase().trim();
        this.fillAndFilterDisplayList();
    }
    closeFacetDrawer() {
        this.searchText = '';
        this.fillAndFilterDisplayList();
        this.reloadCachedSelected();
        this.isOpen = false;
        this.openStateChange.emit(this.isOpen);
    }
    handleCheckboxChange(newState, checkboxId) {
        const itemChangedIndex = this.selectedLibrariesIDs.indexOf(checkboxId);
        //Checkbox selected and library not in selected list then add to list
        if (newState && itemChangedIndex === -1) {
            this.selectedLibrariesIDs.push(checkboxId);
        }
        //Checkbox cleared and library in selected list then remove from list
        if (!newState && itemChangedIndex > -1) {
            this.selectedLibrariesIDs.splice(itemChangedIndex, 1);
        }
    }
    // saves selected values and update history list
    handleApplyClicked() {
        if (this._saveSelectedCallback !== null) {
            this.cachedSelectedLibrariesIDs = this.selectedLibrariesIDs;
            this._saveSelectedCallback(this.cachedSelectedLibrariesIDs);
            this.facetChanged.emit({ selectedLibrariesIDs: this.cachedSelectedLibrariesIDs, reload: true });
        }
        if (this._saveHidtorySelectionCallback !== null) {
            this.selectedLibrariesIDs.forEach(id => {
                if (!this.recentItems.includes(id)) {
                    if (this.recentItems.length > this.numberOfRecentItems - 1) {
                        this.recentItems.pop();
                    }
                    this.recentItems.unshift(id);
                }
            });
            this._saveHidtorySelectionCallback(JSON.stringify(this.recentItems));
        }
        this.closeFacetDrawer();
    }
    handleClearClicked() {
        this.selectedLibrariesIDs.length = 0;
        this.handleApplyClicked();
    }
    static { this.ɵfac = function ExSetTopFacetComponent_Factory(t) { return new (t || ExSetTopFacetComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSetTopFacetComponent, selectors: [["ex-set-top-facet"]], inputs: { itemsGetterCallback: "itemsGetterCallback", loadSelectedCallback: "loadSelectedCallback", saveSelectedCallback: "saveSelectedCallback", loadHidtorySelectionCallback: "loadHidtorySelectionCallback", saveHidtorySelectionCallback: "saveHidtorySelectionCallback", buttonHeaderLabel: "buttonHeaderLabel", fixedFacetTitle: "fixedFacetTitle", parentIsLoading: "parentIsLoading" }, outputs: { facetChanged: "facetChanged", openStateChange: "openStateChange" }, decls: 2, vars: 2, consts: [["type", "primary-light", "class", "ex-facet-set-top-main-button", 3, "full", "loading", "click", 4, "ngIf"], ["class", "ex-facet-set-top-scope-configuration-section", 4, "ngIf"], ["type", "primary-light", 1, "ex-facet-set-top-main-button", 3, "full", "loading", "click"], [1, "ex-facet-set-top-buttonContent"], [1, "ex-facet-set-top-boldText"], [1, "ex-facet-set-top-scope-configuration-section"], [1, "ex-facet-set-top-header"], ["ariaLabel", "ng.general.cancel", "type", "action", "iconSide", "right", 3, "tooltip", "full", "loading", "click"], ["icon", "", 1, "icon-density", "uxf-icon", "uxf-close"], ["placeholder", "Search", 1, "ex-facet-set-top-filter-bar", 3, "incremental", "autoFocus", "searchTriggered"], ["class", "ex-facet-set-top-history-options", 4, "ngIf"], [1, "ex-facet-set-top-options"], [3, "label", "exTooltip", "checked", "checkedChange", 4, "ngFor", "ngForOf"], [1, "ex-facet-set-top-apply-buttons"], ["type", "action", "ariaLabel", "ng.general.clear.all", 3, "full", "loading", "tooltip", "disabled", "click"], ["type", "primary", "ariaLabel", "ng.general.apply", 3, "full", "loading", "tooltip", "click"], [1, "ex-facet-set-top-history-options"], ["class", "ex-facet-set-top-history-item", 4, "ngFor", "ngForOf"], [1, "ex-facet-set-top-history-item"], [3, "label", "exTooltip", "checked", "checkedChange"], [1, "uxf-icon", "uxf-back-in-time"]], template: function ExSetTopFacetComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ExSetTopFacetComponent_ex_button_0_Template, 7, 6, "ex-button", 0);
            i0.ɵɵtemplate(1, ExSetTopFacetComponent_div_1_Template, 22, 31, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isOpen);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isOpen);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, ExTooltipDirective, ExButtonComponent, ExCheckboxComponent, ExSearchComponent, i1$5.KeyValuePipe, i1$2.TranslatePipe], styles: [".ex-facet-set-top-main-button[_ngcontent-%COMP%]{padding-bottom:10px;border-bottom:1px solid #aaa}.ex-facet-set-top-buttonContent[_ngcontent-%COMP%]{text-align:start;padding:5px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;width:100%}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-filter-bar[_ngcontent-%COMP%]{margin-bottom:5px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]{margin:5px 0;padding-bottom:10px;border-bottom:1px solid #c5c7c6}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]   .ex-facet-set-top-history-item[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:nowrap;align-items:center;align-content:center}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-history-options[_ngcontent-%COMP%]   .ex-facet-set-top-history-item[_ngcontent-%COMP%]   ex-checkbox[_ngcontent-%COMP%]{min-width:0}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-options[_ngcontent-%COMP%]{margin:5px 0}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]   .ex-facet-set-top-apply-buttons[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(2,45%);justify-content:space-between;margin-top:10px}.ex-facet-set-top-scope-configuration-section[_ngcontent-%COMP%]     .mat-checkbox-layout{width:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSetTopFacetComponent, [{
        type: Component,
        args: [{ selector: 'ex-set-top-facet', template: "<ex-button type=\"primary-light\" [full]=\"true\" [loading]=\"isLoading || parentIsLoading\"\n    (click)=\"handleOpenClickedEvent()\" *ngIf=\"!isOpen\" class=\"ex-facet-set-top-main-button\">\n    <div class=\"ex-facet-set-top-buttonContent\">\n        <span class=\"ex-facet-set-top-boldText\">{{buttonHeaderLabel | translate}}&nbsp;</span>\n        <span>{{selectedLibrariesTitleText}}</span>\n    </div>\n</ex-button>\n\n<div *ngIf=\"isOpen\" class=\"ex-facet-set-top-scope-configuration-section\">\n    <div class=\"ex-facet-set-top-header\">\n        <span>{{fixedFacetTitle | translate}}</span>\n        <ex-button ariaLabel=\"ng.general.cancel\" tooltip=\"{{'ng.general.cancel' | translate}}\" type=\"action\"\n            [full]=\"true\" [loading]=\"isLoading\" (click)=\"closeFacetDrawer()\" iconSide=\"right\">\n            <i icon class=\"icon-density uxf-icon uxf-close\"></i>\n        </ex-button>\n    </div>\n    <ex-search placeholder=\"Search\" [incremental]=\"true\" [autoFocus]=\"true\" class=\"ex-facet-set-top-filter-bar\"\n        (searchTriggered)=\"handleSearchTriggered($event)\">\n    </ex-search>\n\n    <div class=\"ex-facet-set-top-history-options\" *ngIf=\"recentItems !== null && recentItems.length > 0\">\n        <div class=\"ex-facet-set-top-history-item\" *ngFor=\"let historyItem of recentItems\">\n            <ex-checkbox [label]=\"this.libraryData[historyItem]\" [exTooltip]=\"this.libraryData[historyItem]\"\n                [checked]=\"selectedLibrariesIDs.indexOf(historyItem) > -1\"\n                (checkedChange)=\"handleCheckboxChange($event, historyItem)\"></ex-checkbox>\n            <i class=\"uxf-icon uxf-back-in-time\"></i>\n        </div>\n    </div>\n\n    <div class=\"ex-facet-set-top-options\">\n        <ex-checkbox *ngFor=\"let library of displayList | keyvalue\" [label]=\"library.key\" [exTooltip]=\"library.key\"\n            [checked]=\"selectedLibrariesIDs.indexOf(library.value) > -1\"\n            (checkedChange)=\"handleCheckboxChange($event, library.value)\"></ex-checkbox>\n    </div>\n    <div class=\"ex-facet-set-top-apply-buttons\">\n        <ex-button type=\"action\" [full]=\"true\" [loading]=\"isLoading\" (click)=\"handleClearClicked()\"\n            ariaLabel=\"ng.general.clear.all\" tooltip=\"{{'ng.general.clear.all' | translate}}\"\n            [disabled]=\"clearDisabled\">\n            {{'ng.general.clear.all' | translate}}\n        </ex-button>\n\n        <ex-button type=\"primary\" [full]=\"true\" [loading]=\"isLoading\" (click)=\"handleApplyClicked()\"\n            ariaLabel=\"ng.general.apply\" tooltip=\"{{'ng.general.apply' | translate}}\">\n            {{'ng.general.apply' | translate}}\n        </ex-button>\n    </div>\n</div>\n", styles: [".ex-facet-set-top-main-button{padding-bottom:10px;border-bottom:1px solid #aaa}.ex-facet-set-top-buttonContent{text-align:start;padding:5px}.ex-facet-set-top-scope-configuration-section{display:flex;flex-direction:column;justify-content:flex-start;width:100%}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-filter-bar{margin-bottom:5px}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options{margin:5px 0;padding-bottom:10px;border-bottom:1px solid #c5c7c6}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options .ex-facet-set-top-history-item{display:flex;flex-direction:row;justify-content:space-between;flex-wrap:nowrap;align-items:center;align-content:center}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-history-options .ex-facet-set-top-history-item ex-checkbox{min-width:0}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-options{margin:5px 0}.ex-facet-set-top-scope-configuration-section .ex-facet-set-top-apply-buttons{display:grid;grid-template-columns:repeat(2,45%);justify-content:space-between;margin-top:10px}.ex-facet-set-top-scope-configuration-section ::ng-deep .mat-checkbox-layout{width:100%}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }]; }, { itemsGetterCallback: [{
            type: Input
        }], loadSelectedCallback: [{
            type: Input
        }], saveSelectedCallback: [{
            type: Input
        }], loadHidtorySelectionCallback: [{
            type: Input
        }], saveHidtorySelectionCallback: [{
            type: Input
        }], buttonHeaderLabel: [{
            type: Input
        }], fixedFacetTitle: [{
            type: Input
        }], parentIsLoading: [{
            type: Input
        }], facetChanged: [{
            type: Output
        }], openStateChange: [{
            type: Output
        }] }); })();

function ExFacetRangeComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.fromValidationErrorMessage));
} }
function ExFacetRangeComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "ng.ex-facet-range.from"), ": ", i0.ɵɵpipeBind1(3, 4, ctx_r1.fromValidationErrorMessage), "");
} }
function ExFacetRangeComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r2.toValidationErrorMessage));
} }
function ExFacetRangeComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "ng.ex-facet-range.to"), ": ", i0.ɵɵpipeBind1(3, 4, ctx_r3.toValidationErrorMessage), "");
} }
class ExFacetRangeComponent {
    constructor() {
        this.searchText = '';
        this.searchTextChange = new EventEmitter();
        this.isValid = new EventEmitter();
        this.applyClick = new EventEmitter();
        this.fromValidation = true;
        this.toValidation = true;
    }
    textChange() {
        const regex = /^\d+$/;
        this.fromValidation = !this.from || regex.test(this.from);
        if (!this.fromValidation) {
            this.fromValidationErrorMessage = 'ng.facets.range-facets-number-error';
        }
        this.toValidation = !this.to || regex.test(this.to);
        if (!this.toValidation) {
            this.toValidationErrorMessage = 'ng.facets.range-facets-number-error';
        }
        if ((this.from?.length > 0 || this.to?.length > 0) && this.fromValidation && this.toValidation) {
            this.isValid.emit(true);
        }
        else {
            this.isValid.emit(false);
        }
        if ((this.from?.length == 0 || this.to?.length == 0)) {
            this.searchText = `${this.to || this.from}`;
        }
        else {
            this.searchText = (parseInt(this.from) > parseInt(this.to)) ? `${this.to} - ${this.from}` : `${this.from} - ${this.to}`;
        }
        this.searchTextChange.emit(this.searchText);
    }
    enter() {
        if ((this.from?.length > 0 || this.to?.length > 0) && this.fromValidation && this.toValidation) {
            this.applyClick.emit();
        }
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('searchText')) {
            if (!this.searchText.length) {
                this.from = '';
                this.to = '';
            }
        }
    }
    static { this.ɵfac = function ExFacetRangeComponent_Factory(t) { return new (t || ExFacetRangeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExFacetRangeComponent, selectors: [["ex-facet-range"]], inputs: { searchText: "searchText" }, outputs: { searchTextChange: "searchTextChange", isValid: "isValid", applyClick: "applyClick" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 25, consts: [[1, "ex-facet-range-fieldset"], ["role", "heading"], ["placeholder", "ng.ex-facet-range.from", 3, "inputAriaLabel", "maxlength", "hasClearButton", "incremental", "searchText", "showSearchIcon", "isValid", "enterKeyup", "searchTextChange"], [1, "ex-facet-range-between"], ["placeholder", "ng.ex-facet-range.to", 3, "inputAriaLabel", "maxlength", "hasClearButton", "incremental", "searchText", "showSearchIcon", "isValid", "enterKeyup", "searchTextChange"], ["class", "ex-facet-range-error", 4, "ngIf"], ["role", "alert", "class", "sr-only", 4, "ngIf"], [1, "ex-facet-range-error"], ["role", "alert", 1, "sr-only"]], template: function ExFacetRangeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "fieldset", 0);
            i0.ɵɵelement(1, "legend", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "ex-search", 2);
            i0.ɵɵlistener("enterKeyup", function ExFacetRangeComponent_Template_ex_search_enterKeyup_3_listener() { return ctx.enter(); })("searchTextChange", function ExFacetRangeComponent_Template_ex_search_searchTextChange_3_listener($event) { return ctx.from = $event; })("searchTextChange", function ExFacetRangeComponent_Template_ex_search_searchTextChange_3_listener() { return ctx.textChange(); });
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "span", 3);
            i0.ɵɵtext(6, "-");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "ex-search", 4);
            i0.ɵɵlistener("enterKeyup", function ExFacetRangeComponent_Template_ex_search_enterKeyup_7_listener() { return ctx.enter(); })("searchTextChange", function ExFacetRangeComponent_Template_ex_search_searchTextChange_7_listener($event) { return ctx.to = $event; })("searchTextChange", function ExFacetRangeComponent_Template_ex_search_searchTextChange_7_listener() { return ctx.textChange(); });
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, ExFacetRangeComponent_div_9_Template, 3, 3, "div", 5);
            i0.ɵɵtemplate(10, ExFacetRangeComponent_span_10_Template, 4, 6, "span", 6);
            i0.ɵɵtemplate(11, ExFacetRangeComponent_div_11_Template, 3, 3, "div", 5);
            i0.ɵɵtemplate(12, ExFacetRangeComponent_span_12_Template, 4, 6, "span", 6);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 19, "ng.facets.range-facets-title"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("inputAriaLabel", i0.ɵɵpipeBind1(4, 21, "ng.ex-facet-range.from"))("maxlength", 4)("hasClearButton", false)("incremental", true)("searchText", ctx.from)("showSearchIcon", false)("isValid", ctx.fromValidation);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("inputAriaLabel", i0.ɵɵpipeBind1(8, 23, "ng.ex-facet-range.to"))("maxlength", 4)("hasClearButton", false)("incremental", true)("searchText", ctx.to)("showSearchIcon", false)("isValid", ctx.toValidation);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.fromValidation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.fromValidation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.toValidation && ctx.fromValidation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.toValidation && ctx.fromValidation);
        } }, dependencies: [i1$5.NgIf, ExSearchComponent, i1$2.TranslatePipe], styles: ["[_nghost-%COMP%]{display:flex;flex-wrap:wrap}.ex-facet-range-fieldset[_ngcontent-%COMP%]{display:contents}ex-search[_ngcontent-%COMP%]{width:70px}.ex-facet-range-between[_ngcontent-%COMP%]{font-size:xx-large;line-height:22px;color:#898989;padding:5px}.ex-facet-range-error[_ngcontent-%COMP%]{flex-basis:100%}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExFacetRangeComponent, [{
        type: Component,
        args: [{ selector: 'ex-facet-range', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fieldset class=\"ex-facet-range-fieldset\">\n    <legend role=\"heading\" [attr.aria-label]=\"'ng.facets.range-facets-title' | translate\"></legend>\n<ex-search [inputAriaLabel]=\"'ng.ex-facet-range.from' | translate\" (enterKeyup)=\"enter()\" [maxlength]=\"4\"\n  [hasClearButton]=\"false\" [incremental]=\"true\" [(searchText)]=\"from\" [showSearchIcon]=\"false\" [isValid]=\"fromValidation\"\n  placeholder=\"ng.ex-facet-range.from\" (searchTextChange)=\"textChange()\"></ex-search>\n<span class=\"ex-facet-range-between\">-</span>\n<ex-search [inputAriaLabel]=\"'ng.ex-facet-range.to' | translate\" (enterKeyup)=\"enter()\" [maxlength]=\"4\"\n  [hasClearButton]=\"false\" [incremental]=\"true\" [(searchText)]=\"to\" [showSearchIcon]=\"false\" [isValid]=\"toValidation\"\n  placeholder=\"ng.ex-facet-range.to\" (searchTextChange)=\"textChange()\"></ex-search>\n<div *ngIf=\"!fromValidation\" class=\"ex-facet-range-error\">{{fromValidationErrorMessage | translate}}</div>\n<span *ngIf=\"!fromValidation\" role=\"alert\" class=\"sr-only\">{{'ng.ex-facet-range.from' | translate}}: {{fromValidationErrorMessage | translate}}</span>\n<div *ngIf=\"!toValidation && fromValidation\" class=\"ex-facet-range-error\">{{toValidationErrorMessage | translate}}</div>\n<span *ngIf=\"!toValidation && fromValidation\" role=\"alert\" class=\"sr-only\">{{'ng.ex-facet-range.to' | translate}}: {{toValidationErrorMessage | translate}}</span>\n</fieldset>\n", styles: [":host{display:flex;flex-wrap:wrap}.ex-facet-range-fieldset{display:contents}ex-search{width:70px}.ex-facet-range-between{font-size:xx-large;line-height:22px;color:#898989;padding:5px}.ex-facet-range-error{flex-basis:100%}\n"] }]
    }], null, { searchText: [{
            type: Input
        }], searchTextChange: [{
            type: Output
        }], isValid: [{
            type: Output
        }], applyClick: [{
            type: Output
        }] }); })();

function ExNewFacetsWrapperComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "ex-set-top-facet", 13);
    i0.ɵɵlistener("facetChanged", function ExNewFacetsWrapperComponent_div_2_div_2_Template_ex_set_top_facet_facetChanged_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.handleFixedFacetChange($event)); })("openStateChange", function ExNewFacetsWrapperComponent_div_2_div_2_Template_ex_set_top_facet_openStateChange_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.handleFixedFacetOpenChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("itemsGetterCallback", ctx_r4.fixedFacetItemGetterCallback)("parentIsLoading", ctx_r4.isLoading)("saveSelectedCallback", ctx_r4.fixedFacetSaveSelectedCallback)("loadSelectedCallback", ctx_r4.fixedFacetLoadSelectedCallback)("saveHidtorySelectionCallback", ctx_r4.fixedFacetSaveHistoryCallback)("loadHidtorySelectionCallback", ctx_r4.fixedFacetLoadHistoryCallback)("buttonHeaderLabel", ctx_r4.fixedFacetButtonHeaderLabel)("fixedFacetTitle", ctx_r4.fixedFacetTitle);
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "ex-label", 22);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "ex-new-combobox", 23);
    i0.ɵɵlistener("favoriteItemChange", function ExNewFacetsWrapperComponent_div_2_div_3_div_2_Template_ex_new_combobox_favoriteItemChange_3_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.favoriteFacetsGroupChange.emit({ groupName: $event })); })("selectedItemsChange", function ExNewFacetsWrapperComponent_div_2_div_3_div_2_Template_ex_new_combobox_selectedItemsChange_3_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.onSavedFacetsSelectedChange($event)); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(2, 9, "ng.general.saved") + ":");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(4, 11, "ng.general.select"));
    i0.ɵɵproperty("items", ctx_r15.groupNamesList)("selectedItems", ctx_r15.selectedGroupName)("displaySearchBox", false)("isMultiSelect", false)("allowUnlistedValues", false)("hasFavorite", true)("addBlankOption", true);
} }
const _c0$6 = function () { return {}; };
function ExNewFacetsWrapperComponent_div_2_div_3_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-applied-facets", 26);
    i0.ɵɵlistener("stickyFacetsSaved", function ExNewFacetsWrapperComponent_div_2_div_3_div_8_div_1_Template_ex_applied_facets_stickyFacetsSaved_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r23.stickyFacetsSaved.emit()); })("facetUnapplied", function ExNewFacetsWrapperComponent_div_2_div_3_div_8_div_1_Template_ex_applied_facets_facetUnapplied_1_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r25.onFacetUnapplied($event)); });
    i0.ɵɵpipe(2, "getFacetsData");
    i0.ɵɵpipe(3, "getSection");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(4);
    let tmp_5_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("appliedFacets", i0.ɵɵpipeBind4(2, 6, ctx_r21.appliedFacets[item_r22.key], ctx_r21.facetsKeyLabel[item_r22.key], ctx_r21.facetSections, item_r22.key))("sectionKey", item_r22.key)("sectionLabel", ctx_r21.sectionsKeyLabel[item_r22.key])("isAlphabeticalSort", ctx_r21.hasAlphabetSortToSection[item_r22.key] && ctx_r21.alphabeticalSortTempFF)("stickyFacetsItems", ctx_r21.isStickyFacets ? ctx_r21.stickyFacetsItems == null ? null : ctx_r21.stickyFacetsItems[item_r22.key] : i0.ɵɵpureFunction0(14, _c0$6))("removeEntireSection", ((tmp_5_0 = i0.ɵɵpipeBind2(3, 11, item_r22.key, ctx_r21.facetSections)) == null ? null : tmp_5_0.type) == "HIERARCHY");
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_div_3_div_8_div_1_Template, 4, 15, "div", 25);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ex-applied-facets-wrapper-groups", ctx_r16.isStickyFacetsGroups)("ex-applied-facets-wrapper-groups-border", ctx_r16.isStickyFacetsGroups && (ctx_r16.selectedGroupName == null ? null : ctx_r16.selectedGroupName.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 5, ctx_r16.appliedFacets));
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r29.clearAppliedFacets()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, ctx_r26.clearAllLabel), " ");
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r31.reloadStickyFacets()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 2, "ng.general.facets.reload.tooltip"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, ctx_r27.reloadFacetsLabel));
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r33.onStickyFacetSave()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 3, "ng.general.facets.save.details"))("disabled", ctx_r28.stickyFacetsState === "Waiting");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, ctx_r28.saveFacetsLabel));
} }
function ExNewFacetsWrapperComponent_div_2_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_1_Template, 3, 3, "button", 28);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵtemplate(3, ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_3_Template, 4, 6, "button", 29);
    i0.ɵɵpipe(4, "json");
    i0.ɵɵtemplate(5, ExNewFacetsWrapperComponent_div_2_div_3_div_9_button_5_Template, 4, 7, "button", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx_r17.appliedFacets) != "{}");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 5, ctx_r17.appliedFacets) == "{}" && ctx_r17.stickyFacetsState !== "Clean" && ctx_r17.isStickyFacets);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r17.stickyFacetsState !== "Clean" && ctx_r17.isStickyFacets);
} }
function ExNewFacetsWrapperComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "mat-expansion-panel", 15);
    i0.ɵɵtemplate(2, ExNewFacetsWrapperComponent_div_2_div_3_div_2_Template, 5, 13, "div", 16);
    i0.ɵɵelementStart(3, "mat-expansion-panel-header", 17)(4, "mat-panel-title")(5, "p", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, ExNewFacetsWrapperComponent_div_2_div_3_div_8_Template, 3, 7, "div", 19);
    i0.ɵɵtemplate(9, ExNewFacetsWrapperComponent_div_2_div_3_div_9_Template, 6, 7, "div", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-applied-facets-panel-groups", ctx_r5.isStickyFacetsGroups);
    i0.ɵɵproperty("expanded", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isStickyFacetsGroups);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ex-applied-facets-header-groups", ctx_r5.isStickyFacetsGroups);
    i0.ɵɵproperty("expandedHeight", "35px")("collapsedHeight", "35px");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 12, ctx_r5.selectedFacetsHeaderLabel), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r5.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isStickyFacetsGroups)("ngIfElse", _r2);
} }
function ExNewFacetsWrapperComponent_div_2_ex_search_6_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-search", 34);
    i0.ɵɵlistener("searchTextChange", function ExNewFacetsWrapperComponent_div_2_ex_search_6_Template_ex_search_searchTextChange_0_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.searchText = $event); })("searchTextChange", function ExNewFacetsWrapperComponent_div_2_ex_search_6_Template_ex_search_searchTextChange_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r37._filterFacetSections()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(1, 3, "ng.general.facets.find_specific_facet"));
    i0.ɵɵproperty("incremental", true)("searchText", ctx_r6.searchText);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_8_ex_toggle_facets_1_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-toggle-facets", 48);
    i0.ɵɵlistener("toggleChanged", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_8_ex_toggle_facets_1_Template_ex_toggle_facets_toggleChanged_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r52); const toggle_r49 = restoredCtx.$implicit; const section_r40 = i0.ɵɵnextContext(2).$implicit; const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.onToggleChanged($event, section_r40, toggle_r49)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const toggle_r49 = ctx.$implicit;
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("toggleData", toggle_r49)("searchText", ctx_r48.searchText)("exTooltip", toggle_r49 == null ? null : toggle_r49.tooltip);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_8_ex_toggle_facets_1_Template, 1, 3, "ex-toggle-facets", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r41 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r41.filteredToggles[section_r40.key]);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " IN CONSTRUCTION");
    i0.ɵɵelementEnd();
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " IN CONSTRUCTION");
    i0.ɵɵelementEnd();
} }
const _c1$4 = function () { return []; };
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-hierarchy-facets", 49);
    i0.ɵɵlistener("facetUnselected", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_12_Template_ex_hierarchy_facets_facetUnselected_1_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r54.onFacetUnselected($event)); })("facetSelected", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_12_Template_ex_hierarchy_facets_facetSelected_1_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r56.onFacetSelected($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("facets", section_r40.facets)("sectionsKeyLabel", ctx_r44.facetsKeyLabel[section_r40.key])("sectionKey", section_r40.key)("selectedFacets", ctx_r44.selectedFacets && ctx_r44.selectedFacets[section_r40.key] || i0.ɵɵpureFunction0(5, _c1$4))("searchText", ctx_r44.searchText);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_ex_checkbox_facets_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-checkbox-facets", 51);
    i0.ɵɵlistener("facetUnselected", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_ex_checkbox_facets_1_Template_ex_checkbox_facets_facetUnselected_0_listener($event) { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r59.onFacetUnselected($event)); })("facetSelected", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_ex_checkbox_facets_1_Template_ex_checkbox_facets_facetSelected_0_listener($event) { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r61.onFacetSelected($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r58 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("isSingleSelect", section_r40.type === "SINGLE_SELECT")("isExcludeFacets", ctx_r58.isExcludeFacets && section_r40.isAbleToExclude)("selectedFacets", ctx_r58.selectedFacets && ctx_r58.selectedFacets[section_r40.key] || i0.ɵɵpureFunction0(8, _c1$4))("facets", section_r40.facets)("isAlphabeticalSort", section_r40.isAlphabeticalSort && ctx_r58.alphabeticalSortTempFF)("numberOfFacetsToDisplay", ctx_r58.numberOfFacetsToDisplay)("sectionKey", section_r40.key)("searchText", ctx_r58.searchText);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_ex_checkbox_facets_1_Template, 1, 9, "ex-checkbox-facets", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (section_r40.facets == null ? null : section_r40.facets.length) > 0);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52)(1, "label", 53);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(section_r40.emptyLabel);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "ex-facet-range", 54);
    i0.ɵɵlistener("applyClick", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_15_Template_ex_facet_range_applyClick_1_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r65.applyChanges()); })("searchTextChange", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_15_Template_ex_facet_range_searchTextChange_1_listener($event) { i0.ɵɵrestoreView(_r66); const section_r40 = i0.ɵɵnextContext().$implicit; const ctx_r67 = i0.ɵɵnextContext(4); return i0.ɵɵresetView((ctx_r67.freeTextValues[section_r40.key] = $event)); })("isValid", function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_15_Template_ex_facet_range_isValid_1_listener($event) { i0.ɵɵrestoreView(_r66); const section_r40 = i0.ɵɵnextContext().$implicit; const ctx_r69 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r69.validateFreeText($event, section_r40.key)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const section_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMapInterpolate1("ex-facets-range-container sel-ex-facets-range-container-", section_r40.key, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("searchText", ctx_r47.freeTextValues[section_r40.key]);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-expansion-panel", 37)(2, "mat-expansion-panel-header", 38)(3, "mat-panel-title", 39)(4, "label", 40);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_8_Template, 2, 1, "div", 41);
    i0.ɵɵelementStart(9, "div", 42);
    i0.ɵɵtemplate(10, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_10_Template, 2, 0, "div", 43);
    i0.ɵɵtemplate(11, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_11_Template, 2, 0, "div", 43);
    i0.ɵɵtemplate(12, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_12_Template, 2, 6, "div", 43);
    i0.ɵɵtemplate(13, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_13_Template, 2, 1, "div", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_14_Template, 3, 1, "div", 45);
    i0.ɵɵtemplate(15, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_div_15_Template, 2, 4, "div", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r40 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("expanded", true);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("ex-facets-wrapper-header ex-facets-wrapper-header-", section_r40.key, "");
    i0.ɵɵproperty("expandedHeight", "30px")("collapsedHeight", "30px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(5, 15, section_r40.label));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 17, section_r40.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r39.filteredToggles[section_r40.key]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", section_r40.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "RANGE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "BOOLEAN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "HIERARCHY");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (section_r40.facets == null ? null : section_r40.facets.length) < 1 && section_r40.emptyLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!section_r40.rangeFacetOptions && !(ctx_r39.selectedFacets[section_r40.key] == null ? null : ctx_r39.selectedFacets[section_r40.key].length));
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_ng_container_1_Template, 16, 19, "ng-container", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r38.filteredFacetSections);
} }
function ExNewFacetsWrapperComponent_div_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_ng_container_7_div_1_Template, 2, 1, "div", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r7.filteredFacetSections == null ? null : ctx_r7.filteredFacetSections.length) > 0 && !ctx_r7.fixedFacetOpenState);
} }
function ExNewFacetsWrapperComponent_div_2_ng_template_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 56);
    i0.ɵɵelement(2, "div", 57)(3, "div", 58)(4, "div", 58)(5, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
const _c2$2 = function () { return [0, 1, 2, 3, 4]; };
function ExNewFacetsWrapperComponent_div_2_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 55);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_div_2_ng_template_8_ng_container_1_Template, 6, 0, "ng-container", 25);
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c2$2));
} }
function ExNewFacetsWrapperComponent_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59)(1, "p", 60);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 61);
    i0.ɵɵelement(5, "img", 62);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r10.noFacetsLabel));
} }
function ExNewFacetsWrapperComponent_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63)(1, "button", 64);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_div_2_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r74.applyChanges()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 65);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_div_2_div_11_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r75); const ctx_r76 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r76.resetSelectedFacets()); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-svg-icon", 66);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "ng.general.apply"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 4, "ng.general.remove-all"));
} }
function ExNewFacetsWrapperComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵtemplate(2, ExNewFacetsWrapperComponent_div_2_div_2_Template, 2, 8, "div", 6);
    i0.ɵɵtemplate(3, ExNewFacetsWrapperComponent_div_2_div_3_Template, 10, 14, "div", 7);
    i0.ɵɵpipe(4, "json");
    i0.ɵɵpipe(5, "json");
    i0.ɵɵtemplate(6, ExNewFacetsWrapperComponent_div_2_ex_search_6_Template, 2, 5, "ex-search", 8);
    i0.ɵɵtemplate(7, ExNewFacetsWrapperComponent_div_2_ng_container_7_Template, 2, 1, "ng-container", 9);
    i0.ɵɵtemplate(8, ExNewFacetsWrapperComponent_div_2_ng_template_8_Template, 2, 2, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(10, ExNewFacetsWrapperComponent_div_2_div_10_Template, 6, 3, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ExNewFacetsWrapperComponent_div_2_div_11_Template, 7, 6, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(9);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("sel-loading", ctx_r0.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showFixedFacet);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.appliedFacets && i0.ɵɵpipeBind1(4, 9, ctx_r0.appliedFacets) != "{}" || (ctx_r0.stickyFacetsItems && i0.ɵɵpipeBind1(5, 11, ctx_r0.stickyFacetsItems) != "{}" || ctx_r0.isStickyFacetsGroups && (ctx_r0.groupNamesList == null ? null : ctx_r0.groupNamesList.length) > 0) && ctx_r0.isStickyFacets && !ctx_r0.fixedFacetOpenState) && !ctx_r0.isLoading);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading && ctx_r0.hasSearch && (ctx_r0.facetSections == null ? null : ctx_r0.facetSections.length) > 0 && !ctx_r0.fixedFacetOpenState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading)("ngIfElse", _r8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoading && (ctx_r0.facetSections == null ? null : ctx_r0.facetSections.length) === 0 && !ctx_r0.fixedFacetOpenState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasApply && !ctx_r0.fixedFacetOpenState);
} }
function ExNewFacetsWrapperComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 67);
    i0.ɵɵelement(5, "img", 68);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "ng.full_page.blocked_facets_message"));
} }
function ExNewFacetsWrapperComponent_ng_template_4_ex_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 73);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_ng_template_4_ex_button_1_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r81.clearAppliedFacets()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 2, ctx_r77.clearAllLabel));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r77.clearAllLabel), " ");
} }
function ExNewFacetsWrapperComponent_ng_template_4_ex_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 74);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_ng_template_4_ex_button_3_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r83.onStickyFacetSave()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "ex-svg-icon", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("waiting", ctx_r78.stickyFacetsState === "Waiting");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 5, "ng.general.facets.save.details"))("disabled", ctx_r78.stickyFacetsState == "Clean" || !((ctx_r78.selectedGroupName == null ? null : ctx_r78.selectedGroupName.length) > 0) || (ctx_r78.selectedGroupName == null ? null : ctx_r78.selectedGroupName[0] == null ? null : ctx_r78.selectedGroupName[0].key) == "PRE_SAVED_GROUP");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", "Save-Icon");
} }
function ExNewFacetsWrapperComponent_ng_template_4_ex_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 76);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_ng_template_4_ex_button_5_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r85.onStickyFacetSaveAsNew()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "ex-svg-icon", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("waiting", ctx_r79.stickyFacetsState === "Waiting");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 5, "ng.general.facets.save_as_new.details"))("disabled", ctx_r79.stickyFacetsState == "Clean");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconName", "save_as_new");
} }
function ExNewFacetsWrapperComponent_ng_template_4_ex_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-button", 78);
    i0.ɵɵlistener("click", function ExNewFacetsWrapperComponent_ng_template_4_ex_button_7_Template_ex_button_click_0_listener() { i0.ɵɵrestoreView(_r88); const ctx_r87 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r87.reloadStickyFacets()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 2, "ng.general.facets.reload.tooltip"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 4, ctx_r80.reloadFacetsLabel), " ");
} }
function ExNewFacetsWrapperComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, ExNewFacetsWrapperComponent_ng_template_4_ex_button_1_Template, 4, 6, "ex-button", 69);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵtemplate(3, ExNewFacetsWrapperComponent_ng_template_4_ex_button_3_Template, 3, 7, "ex-button", 70);
    i0.ɵɵpipe(4, "json");
    i0.ɵɵtemplate(5, ExNewFacetsWrapperComponent_ng_template_4_ex_button_5_Template, 3, 7, "ex-button", 71);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵtemplate(7, ExNewFacetsWrapperComponent_ng_template_4_ex_button_7_Template, 4, 6, "ex-button", 72);
    i0.ɵɵpipe(8, "json");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 4, ctx_r3.appliedFacets) != "{}");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isStickyFacets && ctx_r3.appliedFacets && i0.ɵɵpipeBind1(4, 6, ctx_r3.appliedFacets) != "{}");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isStickyFacets && ctx_r3.appliedFacets && i0.ɵɵpipeBind1(6, 8, ctx_r3.appliedFacets) != "{}");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 10, ctx_r3.appliedFacets) == "{}" && ctx_r3.stickyFacetsState !== "Clean" && ctx_r3.isStickyFacets);
} }
var ExFacetWrapperLabels;
(function (ExFacetWrapperLabels) {
    ExFacetWrapperLabels["changesMade"] = "ng.facets.status_msg.changes_had_applied";
    ExFacetWrapperLabels["facetsCleared"] = "ng.facets.status_msg.facets_cleared";
})(ExFacetWrapperLabels || (ExFacetWrapperLabels = {}));
var StickyFacetsState;
(function (StickyFacetsState) {
    StickyFacetsState["Clean"] = "Clean";
    StickyFacetsState["Dirty"] = "Dirty";
    StickyFacetsState["Waiting"] = "Waiting";
})(StickyFacetsState || (StickyFacetsState = {}));
class ExNewFacetsWrapperComponent {
    set groupNamesList(list) {
        this._groupNamesList = list.map(item => {
            return {
                ...item,
                icon: {
                    iconName: 'Delete',
                    iconColor: '337ab7',
                    callback: this.deleteGroup.bind(this, item.key),
                    tooltip: 'ng.general.delete'
                }
            };
        });
    }
    get groupNamesList() {
        return this._groupNamesList;
    }
    constructor(translate, liveAnnouncer, sectionsLayoutService, dialogService) {
        this.translate = translate;
        this.liveAnnouncer = liveAnnouncer;
        this.sectionsLayoutService = sectionsLayoutService;
        this.dialogService = dialogService;
        /**
         * The applied facets
         */
        this.appliedFacets = {};
        /**
         * The toggles would appear under a section. the section must be in facetSections array.
         */
        this.toggles = {};
        /**
         * Is the facets loading
         */
        this.isLoading = false;
        this.isStickyFacets = false;
        this.isExcludeFacets = false;
        this.stickyFacetsItems = {};
        this.blockFacets = false;
        this.alphabeticalSortTempFF = false;
        this.fixedFacetItemGetterCallback = null;
        this.fixedFacetSaveSelectedCallback = null;
        this.fixedFacetLoadSelectedCallback = null;
        this.fixedFacetSaveHistoryCallback = null;
        this.fixedFacetLoadHistoryCallback = null;
        this.fixedFacetButtonHeaderLabel = '';
        this.fixedFacetTitle = '';
        this.fixedFacetTypeName = '';
        this.showFixedFacet = false;
        this.hasSearch = false;
        /**
         * list of all saved facets groups
         */
        this._groupNamesList = [];
        /**
         * If to show the saved facets groups
         */
        this.isStickyFacetsGroups = false;
        this.stickyFacetsSaved = new EventEmitter();
        /**
         * Emits when the applied facets change
         */
        this.appliedFacetsChange = new EventEmitter();
        /**
         * Emits on init and when the applied facets change
         */
        this.appliedFacetsWithLabels = new EventEmitter();
        /**
         * Emits when the applied facets change
         */
        this.appliedTogglesChange = new EventEmitter();
        this.appliedFixedFacetsChange = new EventEmitter();
        /**
         * Emits when selected group of saved facets change
         */
        this.groupChanged = new EventEmitter();
        this.savedFacetsGroupDeleted = new EventEmitter();
        this.favoriteFacetsGroupChange = new EventEmitter();
        this.hasApply = false;
        this.selectedFacets = {};
        this.changesMade = {};
        this.facetsKeyLabel = {};
        this.sectionsKeyLabel = {};
        this.hasAlphabetSortToSection = {};
        this.filteredFacetSections = [];
        this.filteredToggles = {};
        this.saveFacetsLabel = 'ng.general.save';
        this.reloadFacetsLabel = 'ng.general.facets.reload';
        this.noFacetsLabel = 'facets_layout.facets.empty';
        this.clearAllLabel = 'ng.general.remove-all';
        this.selectedFacetsHeaderLabel = 'facets.selected-facets.active_facets';
        this.stickyFacetsState = StickyFacetsState.Clean;
        this.fixedFacetOpenState = false;
        this.selectedFixedFacets = { facetType: '', selectedValues: [] };
        this.searchText = "";
        this.freeTextValues = {};
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('appliedFacets')) {
            this.setStickyFacetsState(changes?.appliedFacets?.currentValue, this.stickyFacetsItems);
            this.selectedFacets = this.appliedFacets ? JSON.parse(JSON.stringify(this.appliedFacets)) : {};
            this.emitAppliedFacetsWithLabels();
        }
        if (changes.hasOwnProperty('stickyFacetsItems')) {
            this.setStickyFacetsState(changes?.stickyFacetsItems?.currentValue, this.appliedFacets);
            this.emitAppliedFacetsWithLabels();
        }
        if (changes.hasOwnProperty('facetSections')) {
            this._initializeKeyLabelMaps();
            this._filterFacetSections();
            this._resetChangesMade();
            this.emitAppliedFacetsWithLabels();
        }
    }
    _initializeKeyLabelMaps() {
        // during the component life - we store the labels for old values as well.
        [this.facetSections, this.allFacetSections].forEach(map => map?.forEach(section => {
            this.sectionsKeyLabel[section.key] = section.label;
            this.hasAlphabetSortToSection[section.key] = section.isAlphabeticalSort;
            if (!this.facetsKeyLabel[section.key]) {
                this.facetsKeyLabel[section.key] = {};
            }
            section.facets?.forEach(facet => {
                this.facetsKeyLabel[section.key][facet.key] = facet.label;
            });
        }));
    }
    _filterFacetSections() {
        this.filteredFacetSections = [];
        this.filteredToggles = {};
        this.facetSections?.forEach(section => {
            let filteredFacets = section.facets?.filter(facet => facet.count >= 0 && facet.label.toLowerCase().includes(this.searchText.toLowerCase()));
            let filteredToggles = this.toggles?.[section.key]?.filter(toggle => toggle.label.toLowerCase().includes(this.searchText.toLowerCase()));
            this.filteredToggles[section.key] = filteredToggles;
            if (filteredFacets?.length > 0 || this.filteredToggles?.[section.key]?.length > 0 || (section.type == ExNewFacetsTypes.HIERARCHY && this.searchText.length === 0)) {
                let filteredSection = { ...section };
                filteredSection.facets = filteredFacets;
                this.filteredFacetSections?.push(filteredSection);
            }
        });
    }
    _getDifference(arr1, arr2) {
        const arr1asSet = new Set(arr1);
        const arr2asSet = new Set(arr2);
        let difference = arr1.filter(x => !arr2asSet.has(x)).length + arr2.filter(x => !arr1asSet.has(x)).length;
        return difference > 0;
    }
    _resetChangesMade() {
        this.facetSections?.forEach(section => {
            this.changesMade[section.key] = {};
            section.facets?.forEach(facet => {
                this.changesMade[section.key][facet.key] = 0;
            });
            this.changesMade[section.key]['isFreeTextInput'] = 0;
            this.freeTextValues[section.key] = '';
        });
    }
    _addFacetToSelectedFacets(changed) {
        const { sectionKey, facetKey, isInclude, hierarchy } = changed;
        Object.assign(this.selectedFacets, {
            [sectionKey]: this.selectedFacets[sectionKey] ?
                this.selectedFacets[sectionKey].concat([{ key: facetKey, isInclude, hierarchy }]) : [{
                    key: facetKey,
                    isInclude,
                    hierarchy
                }]
        });
    }
    _addFacetToAppliedFacets(changed) {
        const { sectionKey, facetKey, isInclude, hierarchy } = changed;
        Object.assign(this.appliedFacets, {
            [sectionKey]: this.appliedFacets[sectionKey] ?
                this.appliedFacets[sectionKey].concat([{ key: facetKey, isInclude, hierarchy }]) : [{
                    key: facetKey,
                    isInclude,
                    hierarchy
                }]
        });
    }
    _removeFacet(sectionKey, facetKey, facets, removeEntireSection = false) {
        this.isStickyFacetsGroups && (this.stickyFacetsItems = { ...this.stickyFacetsItems });
        if (removeEntireSection) {
            delete facets[sectionKey];
            return;
        }
        const removedItem = facets[sectionKey]?.filter(sfk => sfk.key === facetKey)?.[0];
        if (!removedItem) {
            return removedItem;
        }
        facets[sectionKey] = facets[sectionKey].filter(sfk => sfk.key != facetKey);
        this._keyCanBeDeleted(sectionKey, facets) && delete facets[sectionKey];
        return removedItem;
    }
    _onAppliedFacetChange(labelToAnnounce) {
        this.setStickyFacetsState(this.appliedFacets, this.stickyFacetsItems);
        this.appliedFacetsChange.emit(this.appliedFacets);
        this.emitAppliedFacetsWithLabels();
        this.searchText = "";
        this._announce(labelToAnnounce);
    }
    _keyCanBeDeleted(sectionKey, facets) {
        return facets[sectionKey]?.length < 1;
    }
    _configureApplyButton(sectionKey, facetKey, pointsToAction, isFreeTextInput) {
        this.hasApply = this._changesWereMade(sectionKey, facetKey, pointsToAction, isFreeTextInput);
    }
    /**
     * We keep track of changes to know whether to display the apply button
     * @param pointsToAction include facet = 1 point. exclude facet = 2 points.
     */
    _changesWereMade(sectionKey, facetKey, pointsToAction, isFreeTextInput) {
        if (!(isFreeTextInput &&
            (((this.changesMade[sectionKey][facetKey] + pointsToAction) < 0) ||
                ((this.changesMade[sectionKey][facetKey] + pointsToAction) > 1)))) {
            this.changesMade[sectionKey][facetKey] += pointsToAction;
        }
        return Object.keys(this.changesMade).some(sectionKey => {
            return Object.keys(this.changesMade[sectionKey]).some(facetKey => this.changesMade[sectionKey][facetKey] !== 0);
        });
    }
    _announce(label) {
        this.liveAnnouncer.announce(this.translate.instant(label));
    }
    setStickyFacetsState(a, b) {
        const arr1 = Object.keys(a || {});
        const arr2 = Object.keys(b || {});
        let difference = this._getDifference(arr1, arr2);
        if (difference) {
            this.stickyFacetsState = StickyFacetsState.Dirty;
            return;
        }
        const dicOfSections = this.createDicOfSections();
        for (let key of arr1) {
            let temp1 = a?.[key].map(item => item?.key + item?.isInclude || item);
            let temp2 = b?.[key].map(item => item?.key + item?.isInclude || item);
            if (dicOfSections[key]?.type === ExNewFacetsTypes.HIERARCHY && temp1?.length && temp2?.length) {
                // in HIERARCHY type - only the last value are stored in stickyFacets. We accept this situation (temp1 = [a,b,c], temp2 = [c])
                temp1 = [temp1[temp1.length - 1]];
                temp2 = [temp2[temp2.length - 1]];
            }
            let difference = this._getDifference(temp1, temp2);
            if (difference) {
                this.stickyFacetsState = StickyFacetsState.Dirty;
                return;
            }
        }
        this.stickyFacetsState = StickyFacetsState.Clean;
    }
    createDicOfSections() {
        return this.facetSections?.reduce((prev, item) => {
            prev[item?.key || "NULL"] = item;
            return prev;
        }, {});
    }
    onStickyFacetSave() {
        this.stickyFacetsState = StickyFacetsState.Waiting;
        this.stickyFacetsSaved.emit([this.selectedGroupName?.[0].key]);
    }
    onStickyFacetSaveAsNew() {
        this.dialogService.showConfirmationDialog(ExSaveNewFacetsDialogComponent, { groups: this.groupNamesList?.map(item => item.value) }, { title: 'ng.general.facets.save_as_new.title' }).afterClosed().subscribe((data) => {
            if (data) {
                const { name, saveAsDefault } = data;
                this.stickyFacetsState = StickyFacetsState.Waiting;
                this.stickyFacetsSaved.emit([name]);
                saveAsDefault && this.favoriteFacetsGroupChange.emit({ groupName: name, isNewGroup: true });
            }
        });
    }
    deleteGroup(groupName) {
        if (this.groupNamesList.find(item => item.key === groupName)?.favorite) {
            this.favoriteFacetsGroupChange.emit({ groupName: null });
        }
        this.savedFacetsGroupDeleted.emit(groupName);
    }
    onSavedFacetsSelectedChange(data) {
        this.selectedGroupName = data;
        this.groupChanged.emit(data[0]?.key);
    }
    onToggleChanged(event, section, toggle) {
        this.appliedTogglesChange.emit({ checked: event.checked, section, toggle });
    }
    reloadStickyFacets() {
        this.selectedFacets = this.stickyFacetsItems;
        this.applyChanges();
    }
    applyChanges() {
        this.appliedFacets = JSON.parse(JSON.stringify(this.selectedFacets));
        Object.keys(this.freeTextValues).filter(key => !!this.freeTextValues[key] && this.changesMade[key]['isFreeTextInput'] > 0).forEach(key => {
            this.appliedFacets[key] = [...(this.appliedFacets[key] || []), { key: this.freeTextValues[key], isInclude: true }];
            this.freeTextValues[key] = "";
        });
        this.hasApply = false;
        this._resetChangesMade();
        this._onAppliedFacetChange(ExFacetWrapperLabels.changesMade);
    }
    resetSelectedFacets() {
        this.selectedFacets = JSON.parse(JSON.stringify(this.appliedFacets));
        this._resetChangesMade();
        this.hasApply = false;
    }
    clearAppliedFacets() {
        this.appliedFacets = {};
        this.hasApply = false;
        this._onAppliedFacetChange(ExFacetWrapperLabels.facetsCleared);
    }
    validateFreeText(isValid, sectionKey) {
        this._configureApplyButton(sectionKey, 'isFreeTextInput', isValid ? 1 : -1, true);
    }
    onFacetSelected(facetChange) {
        if (facetChange.applyChanges) {
            this.onFacetSelectedApplied(facetChange);
        }
        else {
            this.onFacetUnselected(facetChange);
            this._addFacetToSelectedFacets(facetChange);
            this._configureApplyButton(facetChange.sectionKey, facetChange.facetKey, (facetChange.isInclude ? 1 : 2));
        }
    }
    onFacetSelectedApplied(facetChange) {
        this._removeFacet(facetChange.sectionKey, facetChange.facetKey, this.appliedFacets, facetChange.removeEntireSection);
        this._addFacetToAppliedFacets(facetChange);
        this._onAppliedFacetChange(ExFacetWrapperLabels.changesMade);
        this.resetSelectedFacets();
    }
    onFacetUnselected(facetChange) {
        if (facetChange.applyChanges) {
            this.onFacetUnapplied(facetChange);
        }
        else {
            const removedItem = this._removeFacet(facetChange.sectionKey, facetChange.facetKey, this.selectedFacets, facetChange.removeEntireSection);
            removedItem && this._configureApplyButton(facetChange.sectionKey, facetChange.facetKey, (removedItem.isInclude ? -1 : -2));
        }
    }
    onFacetUnapplied(facetChange) {
        this._removeFacet(facetChange.sectionKey, facetChange.facetKey, this.appliedFacets, facetChange.removeEntireSection);
        this._onAppliedFacetChange(ExFacetWrapperLabels.changesMade);
        this.resetSelectedFacets();
    }
    handleFixedFacetChange(data) {
        const { selectedLibrariesIDs, reload } = data;
        if (this.showFixedFacet && this.fixedFacetTypeName?.length > 0) {
            this.resetSelectedFacets();
            this.selectedFixedFacets.facetType = this.fixedFacetTypeName;
            this.selectedFixedFacets.selectedValues = selectedLibrariesIDs;
            this.appliedFixedFacetsChange.emit(this.selectedFixedFacets);
            if (reload)
                this.applyChanges();
        }
    }
    handleFixedFacetOpenChange(state) {
        this.fixedFacetOpenState = state;
    }
    emitAppliedFacetsWithLabels() {
        if (Object.values(this.sectionsKeyLabel).length > 0)
            this.appliedFacetsWithLabels.emit(this.prepareFacetsData(this.appliedFacets));
    }
    prepareFacetsData(appliedFacets) {
        let keysString = '';
        let subItemsLength = 0;
        for (const group in appliedFacets) {
            if (appliedFacets.hasOwnProperty(group) && this.sectionsKeyLabel[group]) {
                let normalFacets;
                const currentFacets = appliedFacets[group];
                const facetsLabelsPipe = new getFacetsLabelsPipe();
                normalFacets = (facetsLabelsPipe.transform(currentFacets, this.facetsKeyLabel[group], this.facetSections, group));
                keysString += `${this.translate.instant(this.sectionsKeyLabel[group])}: ${Object.values(normalFacets).map(item => (item.isInclude ? '' : this.translate.instant('ng.general.not')) + ' ' + item.label).join(", ")} \n `;
                subItemsLength += currentFacets.length;
            }
        }
        return { keysString, subItemsLength };
    }
    static { this.ɵfac = function ExNewFacetsWrapperComponent_Factory(t) { return new (t || ExNewFacetsWrapperComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i3.LiveAnnouncer), i0.ɵɵdirectiveInject(ExSectionsLayoutService), i0.ɵɵdirectiveInject(ExDialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExNewFacetsWrapperComponent, selectors: [["ex-facets-wrapper"]], inputs: { facetSections: "facetSections", allFacetSections: "allFacetSections", appliedFacets: "appliedFacets", toggles: "toggles", isLoading: "isLoading", numberOfFacetsToDisplay: "numberOfFacetsToDisplay", isStickyFacets: "isStickyFacets", isExcludeFacets: "isExcludeFacets", stickyFacetsItems: "stickyFacetsItems", blockFacets: "blockFacets", alphabeticalSortTempFF: "alphabeticalSortTempFF", fixedFacetItemGetterCallback: "fixedFacetItemGetterCallback", fixedFacetSaveSelectedCallback: "fixedFacetSaveSelectedCallback", fixedFacetLoadSelectedCallback: "fixedFacetLoadSelectedCallback", fixedFacetSaveHistoryCallback: "fixedFacetSaveHistoryCallback", fixedFacetLoadHistoryCallback: "fixedFacetLoadHistoryCallback", fixedFacetButtonHeaderLabel: "fixedFacetButtonHeaderLabel", fixedFacetTitle: "fixedFacetTitle", fixedFacetTypeName: "fixedFacetTypeName", showFixedFacet: "showFixedFacet", hasSearch: "hasSearch", groupNamesList: "groupNamesList", selectedGroupName: "selectedGroupName", isStickyFacetsGroups: "isStickyFacetsGroups" }, outputs: { stickyFacetsSaved: "stickyFacetsSaved", appliedFacetsChange: "appliedFacetsChange", appliedFacetsWithLabels: "appliedFacetsWithLabels", appliedTogglesChange: "appliedTogglesChange", appliedFixedFacetsChange: "appliedFixedFacetsChange", groupChanged: "groupChanged", savedFacetsGroupDeleted: "savedFacetsGroupDeleted", favoriteFacetsGroupChange: "favoriteFacetsGroupChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 5, consts: [["tabindex", "-1", "role", "complementary", 1, "facetsHeaderWrapper"], ["class", "ex-facets-wrapper-wrapper", 4, "ngIf"], ["class", "ex-facets-wrapper-no-facets", 4, "ngIf"], ["groupsButtons", ""], [1, "ex-facets-wrapper-wrapper"], [1, "ex-facets-wrapper", "ex-facet-theme-color"], ["class", "ex-facet-wrapper-set-top-facet", 4, "ngIf"], ["class", "ex-facets-wrapper-applied-facets", 4, "ngIf"], ["class", "ex-facets-wrapper-search", 3, "incremental", "searchText", "placeholder", "searchTextChange", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["loading", ""], ["class", "ex-facets-wrapper-apply", 4, "ngIf"], [1, "ex-facet-wrapper-set-top-facet"], [3, "itemsGetterCallback", "parentIsLoading", "saveSelectedCallback", "loadSelectedCallback", "saveHidtorySelectionCallback", "loadHidtorySelectionCallback", "buttonHeaderLabel", "fixedFacetTitle", "facetChanged", "openStateChange"], [1, "ex-facets-wrapper-applied-facets"], [1, "ex-applied-facets-panel", "ex-facet-theme-color", 3, "expanded"], ["class", "ex-facets-wrapper-saved-groups-wrapper", 4, "ngIf"], [1, "ex-applied-facets-header", 3, "expandedHeight", "collapsedHeight"], [1, "ex-applied-facets-header", "ex-facets-wrapper-section-label"], ["class", "ex-applied-facets-wrapper", 3, "ex-applied-facets-wrapper-groups", "ex-applied-facets-wrapper-groups-border", 4, "ngIf"], ["class", "ex-applied-facets-actions-container", 4, "ngIf", "ngIfElse"], [1, "ex-facets-wrapper-saved-groups-wrapper"], [1, "ex-facets-wrapper-saved-groups-label", 3, "value"], [1, "ex-facets-wrapper-saved-groups", 3, "items", "selectedItems", "displaySearchBox", "isMultiSelect", "allowUnlistedValues", "hasFavorite", "addBlankOption", "placeholder", "favoriteItemChange", "selectedItemsChange"], [1, "ex-applied-facets-wrapper"], [4, "ngFor", "ngForOf"], [3, "appliedFacets", "sectionKey", "sectionLabel", "isAlphabeticalSort", "stickyFacetsItems", "removeEntireSection", "stickyFacetsSaved", "facetUnapplied"], [1, "ex-applied-facets-actions-container"], ["class", "ex-applied-facets-clear sel-clear-applied-facets", 3, "click", 4, "ngIf"], ["class", "ex-applied-facets-clear sel-restore-facets", 3, "exTooltip", "click", 4, "ngIf"], ["class", "ex-applied-facets-clear sel-save-facets", 3, "exTooltip", "disabled", "click", 4, "ngIf"], [1, "ex-applied-facets-clear", "sel-clear-applied-facets", 3, "click"], [1, "ex-applied-facets-clear", "sel-restore-facets", 3, "exTooltip", "click"], [1, "ex-applied-facets-clear", "sel-save-facets", 3, "exTooltip", "disabled", "click"], [1, "ex-facets-wrapper-search", 3, "incremental", "searchText", "placeholder", "searchTextChange"], ["class", "ex-facet-sections-wrapper", 4, "ngIf"], [1, "ex-facet-sections-wrapper"], [1, "ex-facets-wrapper-panel", "ex-facet-theme-color", 3, "expanded"], [3, "expandedHeight", "collapsedHeight"], [1, "ex-facets-wrapper-title"], [1, "ex-facets-wrapper-section-label", 3, "exTooltip"], [4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["class", "ex-facet-empty-wrapper", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "toggleData", "searchText", "exTooltip", "toggleChanged", 4, "ngFor", "ngForOf"], [3, "toggleData", "searchText", "exTooltip", "toggleChanged"], [3, "facets", "sectionsKeyLabel", "sectionKey", "selectedFacets", "searchText", "facetUnselected", "facetSelected"], [3, "isSingleSelect", "isExcludeFacets", "selectedFacets", "facets", "isAlphabeticalSort", "numberOfFacetsToDisplay", "sectionKey", "searchText", "facetUnselected", "facetSelected", 4, "ngIf"], [3, "isSingleSelect", "isExcludeFacets", "selectedFacets", "facets", "isAlphabeticalSort", "numberOfFacetsToDisplay", "sectionKey", "searchText", "facetUnselected", "facetSelected"], [1, "ex-facet-empty-wrapper"], [1, "ex-facet-empty-label"], [3, "searchText", "applyClick", "searchTextChange", "isValid"], [1, "ex-facets-wrapper-placeholder-animate"], [1, "ex-facets-wrapper-placeholder"], [1, "ex-facet-placeholder-header"], [1, "ex-facet-placeholder-label"], [1, "ex-facets-wrapper-no-facets"], [1, "ex-facets-wrapper-no-facets-label"], [1, "ex-facets-wrapper-no-facets-image"], ["src", "/infra/images/no-facets.png?version=March2019"], [1, "ex-facets-wrapper-apply"], ["mat-ripple", "", 1, "ex-facets-wrapper-apply-button", "sel-apply-facets", 3, "click"], ["mat-ripple", "", 1, "ex-facets-wrapper-clear-button", "sel-clear-facets", 3, "click"], ["ariaLabel", "ng.general.remove-all", "iconName", "close", "color", "white", "size", "xsmall", 1, "ex-facets-wrapper-close-svg"], [1, "ex-facets-wrapper-no-facets-img"], ["alt", "'ng.full_page.blocked_facets_message' | translate", "src", "/infra/images/no-facets.png?version=March2019"], ["type", "action", "class", "ex-applied-facets-button sel-clear-applied-facets", 3, "exTooltip", "click", 4, "ngIf"], ["type", "action", "class", "ex-applied-facets-button sel-save-facets", 3, "exTooltip", "disabled", "waiting", "click", 4, "ngIf"], ["type", "action", "class", "ex-applied-facets-button sel-save-as-new-facets", 3, "exTooltip", "disabled", "waiting", "click", 4, "ngIf"], ["type", "action", "class", "ex-applied-facets-button sel-restore-facets", 3, "exTooltip", "click", 4, "ngIf"], ["type", "action", 1, "ex-applied-facets-button", "sel-clear-applied-facets", 3, "exTooltip", "click"], ["type", "action", 1, "ex-applied-facets-button", "sel-save-facets", 3, "exTooltip", "disabled", "click"], ["size", "small", 3, "iconName"], ["type", "action", 1, "ex-applied-facets-button", "sel-save-as-new-facets", 3, "exTooltip", "disabled", "click"], [3, "iconName"], ["type", "action", 1, "ex-applied-facets-button", "sel-restore-facets", 3, "exTooltip", "click"]], template: function ExNewFacetsWrapperComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵtemplate(2, ExNewFacetsWrapperComponent_div_2_Template, 12, 13, "div", 1);
            i0.ɵɵtemplate(3, ExNewFacetsWrapperComponent_div_3_Template, 6, 3, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ExNewFacetsWrapperComponent_ng_template_4_Template, 9, 12, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "facets_layout.facets"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.blockFacets);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.blockFacets);
        } }, dependencies: [i1$5.NgForOf, i1$5.NgIf, i1$5.NgSwitch, i1$5.NgSwitchCase, i1$5.NgSwitchDefault, i2$7.MatExpansionPanel, i2$7.MatExpansionPanelHeader, i2$7.MatExpansionPanelTitle, ExTooltipDirective, ExButtonComponent, i6$1.MatRipple, ExSearchComponent, ExSvgIconComponent, ExNewComboboxComponent, ExLabelComponent, ExCheckboxFacetsComponent, ExAppliedFacetsComponent, ExToggleFacetsComponent, ExHierarchyFacetsComponent, ExSetTopFacetComponent, ExFacetRangeComponent, i1$5.JsonPipe, i1$5.KeyValuePipe, i1$2.TranslatePipe, getFacetsLabelsPipe, getSectionPipe], styles: [".ex-facets-wrapper-wrapper[_ngcontent-%COMP%]{overflow:auto;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facet-wrapper-set-top-facet[_ngcontent-%COMP%]{width:auto;margin:0 18px;padding-top:15px;overflow-y:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]{position:sticky;top:0;width:100%;z-index:10}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-height:35vh;overflow-y:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-panel[_ngcontent-%COMP%]{box-shadow:none!important;width:auto;margin:15px 18px 1px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0 10px!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-start}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]{text-align:start;outline:none;margin-bottom:15px;margin-top:5px;padding-inline-end:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-button[_ngcontent-%COMP%]{margin-bottom:6px;margin-top:5px;padding-inline-end:5px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-button.waiting[_ngcontent-%COMP%]{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]:disabled{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-actions-container[_ngcontent-%COMP%]   .ex-applied-facets-clear[_ngcontent-%COMP%]:hover:not([disabled]){text-decoration:underline}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]{outline:2px solid transparent;padding-top:3px;display:flex;align-items:flex-start}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-inline-start:1px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   .ex-applied-facets-header[_ngcontent-%COMP%]:focus{border:2px solid black!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0 10px 0 6px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-applied-facets[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-search[_ngcontent-%COMP%]{margin:15px 18px 1px;width:auto}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-search[_ngcontent-%COMP%]     .ex-search-search-wrapper{border:1px solid #cccccc}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-title[_ngcontent-%COMP%]{width:100%}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-section-label[_ngcontent-%COMP%]{overflow:hidden;font-weight:500!important;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-sections-wrapper[_ngcontent-%COMP%]{flex:1;padding-top:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-sections-wrapper[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]{display:block}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0;border:2px solid transparent}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]:focus{border-color:#000!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]{box-shadow:none!important;padding:0 18px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0 0 15px!important}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]     .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-label[_ngcontent-%COMP%]{margin:10px 0;align-self:center}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-image[_ngcontent-%COMP%]{align-self:center;padding-top:15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]   .ex-facets-wrapper-apply-button[_ngcontent-%COMP%]{flex:1;border:none}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-apply[_ngcontent-%COMP%]   .ex-facets-wrapper-close-svg[_ngcontent-%COMP%]{border:0px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-placeholder[_ngcontent-%COMP%]{margin:0 0 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-placeholder-animate[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes _ngcontent-%COMP%_shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-placeholder-header[_ngcontent-%COMP%]{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-placeholder-label[_ngcontent-%COMP%]{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-clear-button[_ngcontent-%COMP%]{width:50px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-clear-button[_ngcontent-%COMP%]     i{margin-top:5px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facets-range-container[_ngcontent-%COMP%]{margin-top:-15px}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-wrapper[_ngcontent-%COMP%]{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facets-wrapper-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-wrapper[_ngcontent-%COMP%]   .ex-facet-empty-label[_ngcontent-%COMP%]{margin-top:5px}.ex-facets-wrapper-saved-groups[_ngcontent-%COMP%]{margin-inline-start:-5px!important;margin-bottom:5px!important}.ex-facets-wrapper-saved-groups[_ngcontent-%COMP%]{margin-bottom:10px}.ex-applied-facets-wrapper-groups-border[_ngcontent-%COMP%]{border-top:1.5px solid rgba(85,51,85,.2);padding-top:10px}.ex-facets-wrapper-no-facets[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facets-wrapper-no-facets[_ngcontent-%COMP%]   .ex-facets-wrapper-no-facets-img[_ngcontent-%COMP%]{display:flex;justify-content:center}.ex-save-new-facet-dialog[_ngcontent-%COMP%]   ex-form-fields[_ngcontent-%COMP%]{column-count:1!important}.ex-save-new-facet-dialog[_ngcontent-%COMP%]   .ex-save-new-facet-dialog-default-massege[_ngcontent-%COMP%]{font-size:smaller}.ex-facets-wrapper-saved-groups-wrapper[_ngcontent-%COMP%]{display:flex;column-gap:4px}.ex-facets-wrapper-saved-groups-wrapper[_ngcontent-%COMP%]   .ex-facets-wrapper-saved-groups-label[_ngcontent-%COMP%]     .ex-label-wrapper{margin-top:6px}.ex-applied-facets-header-groups[_ngcontent-%COMP%]{margin-bottom:0!important;align-items:baseline}"] }); }
}
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExNewFacetsWrapperComponent.prototype, "applyChanges", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExNewFacetsWrapperComponent.prototype, "clearAppliedFacets", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExNewFacetsWrapperComponent.prototype, "onFacetSelectedApplied", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExNewFacetsWrapperComponent.prototype, "onFacetUnapplied", null);
__decorate([
    SingleSaveExitWithoutSaveWarning('sectionsLayoutService', 'dialogService')
], ExNewFacetsWrapperComponent.prototype, "handleFixedFacetChange", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNewFacetsWrapperComponent, [{
        type: Component,
        args: [{ selector: 'ex-facets-wrapper', template: "<div [attr.aria-label]=\"'facets_layout.facets' | translate\" tabindex=\"-1\" class=\"facetsHeaderWrapper\"\n  role=\"complementary\">\n  <div *ngIf=\"!blockFacets\" class=\"ex-facets-wrapper-wrapper\">\n    <div class=\"ex-facets-wrapper ex-facet-theme-color\" [class.sel-loading]=\"isLoading\">\n      <div class=\"ex-facet-wrapper-set-top-facet\" *ngIf=\"showFixedFacet\">\n        <ex-set-top-facet [itemsGetterCallback]=\"fixedFacetItemGetterCallback\" [parentIsLoading]=\"isLoading\"\n          [saveSelectedCallback]=\"fixedFacetSaveSelectedCallback\"\n          [loadSelectedCallback]=\"fixedFacetLoadSelectedCallback\"\n          [saveHidtorySelectionCallback]=\"fixedFacetSaveHistoryCallback\"\n          [loadHidtorySelectionCallback]=\"fixedFacetLoadHistoryCallback\"\n          [buttonHeaderLabel]=\"fixedFacetButtonHeaderLabel\" [fixedFacetTitle]=\"fixedFacetTitle\"\n          (facetChanged)=\"handleFixedFacetChange($event)\"\n          (openStateChange)=\"handleFixedFacetOpenChange($event)\"></ex-set-top-facet>\n      </div>\n      <div class=\"ex-facets-wrapper-applied-facets\"\n           *ngIf=\"((appliedFacets && (appliedFacets|json) != '{}') || (((stickyFacetsItems && (stickyFacetsItems|json) != '{}')|| (isStickyFacetsGroups && (groupNamesList?.length > 0))) && isStickyFacets) && !fixedFacetOpenState) && !isLoading\">\n        <mat-expansion-panel class=\"ex-applied-facets-panel ex-facet-theme-color\"\n                             [class.ex-applied-facets-panel-groups]=\"isStickyFacetsGroups\" [expanded]=\"true\">\n          <div *ngIf=\"isStickyFacetsGroups\"\n               class=\"ex-facets-wrapper-saved-groups-wrapper\">\n            <ex-label class=\"ex-facets-wrapper-saved-groups-label\"\n                      [value]=\"('ng.general.saved' | translate )+ ':'\"></ex-label>\n            <ex-new-combobox class=\"ex-facets-wrapper-saved-groups\" [items]=\"groupNamesList\"\n                           [selectedItems]=\"selectedGroupName\" [displaySearchBox]=\"false\" [isMultiSelect]=\"false\"\n                           [allowUnlistedValues]=\"false\" [hasFavorite]=\"true\"\n                             (favoriteItemChange)=\"favoriteFacetsGroupChange.emit({groupName: $event})\"\n                           (selectedItemsChange)=\"onSavedFacetsSelectedChange($event)\" [addBlankOption]=\"true\"\n                             placeholder=\"{{ 'ng.general.select' | translate }}\"></ex-new-combobox>\n          </div>\n          <mat-expansion-panel-header class=\"ex-applied-facets-header\"\n                                      [class.ex-applied-facets-header-groups]=\"isStickyFacetsGroups\"\n            [expandedHeight]=\"'35px'\" [collapsedHeight]=\"'35px'\">\n            <mat-panel-title>\n              <p class=\"ex-applied-facets-header ex-facets-wrapper-section-label\">\n                {{ selectedFacetsHeaderLabel | translate }}</p>\n            </mat-panel-title>\n          </mat-expansion-panel-header>\n          <div class=\"ex-applied-facets-wrapper\" [class.ex-applied-facets-wrapper-groups]=\"isStickyFacetsGroups\"\n               [class.ex-applied-facets-wrapper-groups-border]=\"isStickyFacetsGroups && (selectedGroupName?.length > 0)\"\n               *ngIf=\"!isLoading\">\n            <div *ngFor=\"let item of appliedFacets | keyvalue\">\n              <ex-applied-facets\n                [appliedFacets]=\"appliedFacets[item.key] | getFacetsData: facetsKeyLabel[item.key]:facetSections:item.key\"\n                [sectionKey]=\"item.key\" [sectionLabel]=\"sectionsKeyLabel[item.key]\" [isAlphabeticalSort]=\"hasAlphabetSortToSection[item.key] && alphabeticalSortTempFF\"\n                [stickyFacetsItems]=\"isStickyFacets ? stickyFacetsItems?.[item.key]: {}\"\n                (stickyFacetsSaved)=\"stickyFacetsSaved.emit()\" (facetUnapplied)=\"onFacetUnapplied($event)\"\n                [removeEntireSection]=\"(item.key | getSection:facetSections)?.type == 'HIERARCHY'\">\n              </ex-applied-facets>\n            </div>\n          </div>\n          <div class=\"ex-applied-facets-actions-container\" *ngIf=\"!isStickyFacetsGroups else groupsButtons\">\n            <button *ngIf=\"(appliedFacets|json) != '{}' \" class=\"ex-applied-facets-clear sel-clear-applied-facets\"\n                    (click)=\"clearAppliedFacets()\">{{ clearAllLabel | translate }}\n            </button>\n            <button *ngIf=\"(appliedFacets|json) == '{}'  && stickyFacetsState !== 'Clean' && isStickyFacets\"\n                    [exTooltip]=\"'ng.general.facets.reload.tooltip' | translate\"\n                    class=\"ex-applied-facets-clear sel-restore-facets\" (click)=\"reloadStickyFacets()\">{{\n                reloadFacetsLabel |\n              translate }}</button>\n            <button *ngIf=\"stickyFacetsState !== 'Clean' && isStickyFacets\"\n                    [exTooltip]=\"'ng.general.facets.save.details' | translate\"\n                    [disabled]=\"stickyFacetsState === 'Waiting'\"\n                    class=\"ex-applied-facets-clear sel-save-facets\" (click)=\"onStickyFacetSave()\">{{\n                saveFacetsLabel |\n              translate\n              }}</button>\n          </div>\n          <!--          </ng-container>-->\n        </mat-expansion-panel>\n      </div>\n      <ex-search *ngIf=\"!isLoading && hasSearch && facetSections?.length > 0 && !fixedFacetOpenState\"\n        class=\"ex-facets-wrapper-search\" [incremental]=\"true\" [(searchText)]=\"searchText\"\n        placeholder=\"{{ 'ng.general.facets.find_specific_facet' | translate }}\"\n        (searchTextChange)=\"_filterFacetSections()\"></ex-search>\n\n      <ng-container *ngIf=\"!isLoading; else loading\">\n        <div class=\"ex-facet-sections-wrapper\" *ngIf=\"((filteredFacetSections?.length > 0) && !fixedFacetOpenState)\">\n            <ng-container *ngFor=\"let section of filteredFacetSections\">\n              <mat-expansion-panel class=\"ex-facets-wrapper-panel ex-facet-theme-color\" [expanded]=\"true\">\n                <mat-expansion-panel-header class=\"ex-facets-wrapper-header ex-facets-wrapper-header-{{section.key}}\" [expandedHeight]=\"'30px'\"\n                                            [collapsedHeight]=\"'30px'\">\n                  <mat-panel-title class=\"ex-facets-wrapper-title\">\n                    <label [exTooltip]=\"section.label | translate\" class=\"ex-facets-wrapper-section-label\">{{\n                      section.label\n                        | translate }}</label>\n                  </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div *ngIf=\"filteredToggles[section.key]\">\n                  <ex-toggle-facets *ngFor=\"let toggle of filteredToggles[section.key]\" [toggleData]=\"toggle\"\n                                    [searchText]=\"searchText\" (toggleChanged)=\"onToggleChanged($event, section, toggle)\"\n                                    [exTooltip]=\"toggle?.tooltip\">\n                  </ex-toggle-facets>\n                </div>\n                <div [ngSwitch]=\"section.type\">\n                  <div *ngSwitchCase=\"'RANGE'\"> IN CONSTRUCTION</div>\n                  <div *ngSwitchCase=\"'BOOLEAN'\"> IN CONSTRUCTION</div>\n                  <div *ngSwitchCase=\"'HIERARCHY'\">\n                    <ex-hierarchy-facets [facets]=\"section.facets\" [sectionsKeyLabel]=\"facetsKeyLabel[section.key]\"\n                                         [sectionKey]=\"section.key\"\n                                         [selectedFacets]=\"selectedFacets && selectedFacets[section.key] || []\"\n                                         [searchText]=\"searchText\" (facetUnselected)=\"onFacetUnselected($event)\"\n                                         (facetSelected)=\"onFacetSelected($event)\">\n                    </ex-hierarchy-facets>\n                  </div>\n\n                  <div *ngSwitchDefault>\n                    <ex-checkbox-facets *ngIf=\"section.facets?.length > 0\"\n                                        [isSingleSelect]=\"section.type === 'SINGLE_SELECT'\"\n                                        [isExcludeFacets]=\"isExcludeFacets && section.isAbleToExclude\"\n                                        [selectedFacets]=\"selectedFacets && selectedFacets[section.key] || []\"\n                                        [facets]=\"section.facets\" [isAlphabeticalSort]=\"section.isAlphabeticalSort && alphabeticalSortTempFF\"\n                                        [numberOfFacetsToDisplay]=\"numberOfFacetsToDisplay\" [sectionKey]=\"section.key\"\n                                        [searchText]=\"searchText\" (facetUnselected)=\"onFacetUnselected($event)\"\n                                        (facetSelected)=\"onFacetSelected($event)\">\n                    </ex-checkbox-facets>\n                  </div>\n                </div>\n                <div *ngIf=\"section.facets?.length < 1 && section.emptyLabel\" class=\"ex-facet-empty-wrapper\"><label\n                  class=\"ex-facet-empty-label\">{{ section.emptyLabel }}</label></div>\n                <div *ngIf=\"!!section.rangeFacetOptions && !selectedFacets[section.key]?.length\" class=\"ex-facets-range-container sel-ex-facets-range-container-{{section.key}}\">\n                  <ex-facet-range (applyClick)=\"applyChanges()\" [(searchText)]=\"freeTextValues[section.key]\" (isValid)=\"validateFreeText($event, section.key)\"></ex-facet-range>\n                </div>\n              </mat-expansion-panel>\n            </ng-container>\n        </div>\n      </ng-container>\n      <ng-template #loading>\n        <div class=\"ex-facets-wrapper-placeholder-animate\"></div>\n        <ng-container *ngFor=\"let number of [0,1,2,3,4]\">\n          <div class=\"ex-facets-wrapper-placeholder\">\n            <div class=\"ex-facet-placeholder-header\"></div>\n            <div class=\"ex-facet-placeholder-label\"></div>\n            <div class=\"ex-facet-placeholder-label\"></div>\n            <div class=\"ex-facet-placeholder-label\"></div>\n          </div>\n        </ng-container>\n      </ng-template>\n\n      <div *ngIf=\"!isLoading && facetSections?.length === 0 && !fixedFacetOpenState\"\n        class=\"ex-facets-wrapper-no-facets\">\n        <p class=\"ex-facets-wrapper-no-facets-label\">{{ noFacetsLabel | translate }}</p>\n        <div class=\"ex-facets-wrapper-no-facets-image\"><img src=\"/infra/images/no-facets.png?version=March2019\" /></div>\n      </div>\n    </div>\n\n    <div *ngIf=\"hasApply && !fixedFacetOpenState\" class=\"ex-facets-wrapper-apply\">\n      <button mat-ripple (click)=\"applyChanges()\" class=\"ex-facets-wrapper-apply-button sel-apply-facets\">{{\n        'ng.general.apply' | translate }}</button>\n      <button mat-ripple (click)=\"resetSelectedFacets()\" class=\"ex-facets-wrapper-clear-button sel-clear-facets\"\n        [attr.aria-label]=\"'ng.general.remove-all' | translate\">\n        <ex-svg-icon ariaLabel=\"ng.general.remove-all\" iconName=\"close\" color=\"white\" size=\"xsmall\"\n          class=\"ex-facets-wrapper-close-svg\"></ex-svg-icon>\n      </button>\n    </div>\n  </div>\n\n  <div *ngIf=\"blockFacets\" class=\"ex-facets-wrapper-no-facets\">\n    <label>{{'ng.full_page.blocked_facets_message' | translate}}</label>\n    <div class=\"ex-facets-wrapper-no-facets-img\"><img alt=\"'ng.full_page.blocked_facets_message' | translate\"\n        src=\"/infra/images/no-facets.png?version=March2019\" /></div>\n  </div>\n</div>\n\n<ng-template #groupsButtons>\n  <div class=\"ex-applied-facets-actions-container \">\n    <ex-button type=\"action\" *ngIf=\"(appliedFacets|json) != '{}' \"\n               class=\"ex-applied-facets-button sel-clear-applied-facets\" [exTooltip]=\"clearAllLabel | translate\"\n               (click)=\"clearAppliedFacets()\">\n      {{ clearAllLabel | translate }}\n    </ex-button>\n    <ex-button\n      *ngIf=\"isStickyFacets && appliedFacets && (appliedFacets|json) != '{}'\"\n      type=\"action\"\n      [exTooltip]=\"'ng.general.facets.save.details' | translate\"\n      [disabled]=\"stickyFacetsState == 'Clean' || !(selectedGroupName?.length > 0) || selectedGroupName?.[0]?.key == 'PRE_SAVED_GROUP'\"\n      [class.waiting]=\"stickyFacetsState === 'Waiting'\"\n      class=\"ex-applied-facets-button sel-save-facets\" (click)=\"onStickyFacetSave()\">\n      <ex-svg-icon [iconName]=\"'Save-Icon'\" size=\"small\"></ex-svg-icon>\n    </ex-button>\n    <ex-button *ngIf=\"isStickyFacets && appliedFacets && (appliedFacets|json) != '{}'\" type=\"action\"\n               [exTooltip]=\"'ng.general.facets.save_as_new.details' | translate\"\n               [disabled]=\"stickyFacetsState == 'Clean'\" [class.waiting]=\"stickyFacetsState === 'Waiting'\"\n               class=\"ex-applied-facets-button sel-save-as-new-facets\" (click)=\"onStickyFacetSaveAsNew()\">\n      <ex-svg-icon [iconName]=\"'save_as_new'\"></ex-svg-icon>\n    </ex-button>\n    <ex-button type=\"action\" *ngIf=\"(appliedFacets|json) == '{}'  && stickyFacetsState !== 'Clean' && isStickyFacets\"\n               [exTooltip]=\"'ng.general.facets.reload.tooltip' | translate\"\n               class=\"ex-applied-facets-button sel-restore-facets\" (click)=\"reloadStickyFacets()\">{{\n        reloadFacetsLabel |\n          translate\n      }}\n    </ex-button>\n  </div>\n</ng-template>\n", styles: [".ex-facets-wrapper-wrapper{overflow:auto;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper{height:100%;display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facet-wrapper-set-top-facet{width:auto;margin:0 18px;padding-top:15px;overflow-y:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets{position:sticky;top:0;width:100%;z-index:10}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-wrapper{display:flex;flex-direction:column;max-height:35vh;overflow-y:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-panel{box-shadow:none!important;width:auto;margin:15px 18px 1px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-panel ::ng-deep .mat-expansion-panel-body{padding:0 10px!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container{display:flex;justify-content:flex-start}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear{text-align:start;outline:none;margin-bottom:15px;margin-top:5px;padding-inline-end:15px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-button{margin-bottom:6px;margin-top:5px;padding-inline-end:5px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-button.waiting{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear:disabled{opacity:.5;cursor:wait}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-actions-container .ex-applied-facets-clear:hover:not([disabled]){text-decoration:underline}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header{outline:2px solid transparent;padding-top:3px;display:flex;align-items:flex-start}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header p{padding-inline-start:1px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets .ex-applied-facets-header:focus{border:2px solid black!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets mat-expansion-panel-header{padding:0 10px 0 6px}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-applied-facets mat-expansion-panel-header ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-search{margin:15px 18px 1px;width:auto}.ex-facets-wrapper-wrapper .ex-facets-wrapper .ex-facets-wrapper-search ::ng-deep .ex-search-search-wrapper{border:1px solid #cccccc}.ex-facets-wrapper-wrapper .ex-facets-wrapper-title{width:100%}.ex-facets-wrapper-wrapper .ex-facets-wrapper-section-label{overflow:hidden;font-weight:500!important;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:0}.ex-facets-wrapper-wrapper .ex-facet-sections-wrapper{flex:1;padding-top:15px}.ex-facets-wrapper-wrapper .ex-facet-sections-wrapper .mat-expansion-panel{display:block}.ex-facets-wrapper-wrapper mat-expansion-panel-header{padding:0;border:2px solid transparent}.ex-facets-wrapper-wrapper mat-expansion-panel-header:focus{border-color:#000!important}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel{box-shadow:none!important;padding:0 18px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper-panel ::ng-deep .mat-expansion-panel-body{padding:0 0 15px!important}.ex-facets-wrapper-wrapper ::ng-deep .mat-expansion-panel-content{font-size:inherit}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets-label{margin:10px 0;align-self:center}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets-image{align-self:center;padding-top:15px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-no-facets{display:flex;flex-direction:column}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply{display:flex;justify-content:space-around;flex-direction:row;z-index:5;position:absolute;bottom:5px;width:95%;height:45px;margin-right:10px;border-radius:5px;left:10px;overflow:hidden}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply .ex-facets-wrapper-apply-button{flex:1;border:none}.ex-facets-wrapper-wrapper .ex-facets-wrapper-apply .ex-facets-wrapper-close-svg{border:0px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-placeholder{margin:0 0 24px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-placeholder-animate{animation:shimmer 1.5s infinite linear;background:linear-gradient(120deg,#0000 49%,#ffffff6b 50%,#0000 52%);background-size:200% 200%;position:absolute;inset:0}@keyframes shimmer{0%{background-position:100% 100%}to{background-position:0 0}}.ex-facets-wrapper-wrapper .ex-facet-placeholder-header{width:74px;height:19px;background:#e2e2e2 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:10px 24px}.ex-facets-wrapper-wrapper .ex-facet-placeholder-label{width:140px;height:14px;background:#e9e9e9 0% 0% no-repeat padding-box;border-radius:3px;opacity:1;margin:8px 24px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-clear-button{width:50px}.ex-facets-wrapper-wrapper .ex-facets-wrapper-clear-button ::ng-deep i{margin-top:5px}.ex-facets-wrapper-wrapper .ex-facets-range-container{margin-top:-15px}.ex-facets-wrapper-wrapper .ex-facet-empty-wrapper{background-color:#e5e5e5;display:flex;justify-content:center}.ex-facets-wrapper-wrapper .ex-facet-empty-wrapper .ex-facet-empty-label{margin-top:5px}.ex-facets-wrapper-saved-groups{margin-inline-start:-5px!important;margin-bottom:5px!important}.ex-facets-wrapper-saved-groups{margin-bottom:10px}.ex-applied-facets-wrapper-groups-border{border-top:1.5px solid rgba(85,51,85,.2);padding-top:10px}.ex-facets-wrapper-no-facets{display:flex;flex-direction:column;padding-top:15px;align-items:center;height:100%;overflow-y:hidden}.ex-facets-wrapper-no-facets .ex-facets-wrapper-no-facets-img{display:flex;justify-content:center}.ex-save-new-facet-dialog ex-form-fields{column-count:1!important}.ex-save-new-facet-dialog .ex-save-new-facet-dialog-default-massege{font-size:smaller}.ex-facets-wrapper-saved-groups-wrapper{display:flex;column-gap:4px}.ex-facets-wrapper-saved-groups-wrapper .ex-facets-wrapper-saved-groups-label ::ng-deep .ex-label-wrapper{margin-top:6px}.ex-applied-facets-header-groups{margin-bottom:0!important;align-items:baseline}\n"] }]
    }], function () { return [{ type: i1$2.TranslateService }, { type: i3.LiveAnnouncer }, { type: ExSectionsLayoutService }, { type: ExDialogService }]; }, { facetSections: [{
            type: Input
        }], allFacetSections: [{
            type: Input
        }], appliedFacets: [{
            type: Input
        }], toggles: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], numberOfFacetsToDisplay: [{
            type: Input
        }], isStickyFacets: [{
            type: Input
        }], isExcludeFacets: [{
            type: Input
        }], stickyFacetsItems: [{
            type: Input
        }], blockFacets: [{
            type: Input
        }], alphabeticalSortTempFF: [{
            type: Input
        }], fixedFacetItemGetterCallback: [{
            type: Input
        }], fixedFacetSaveSelectedCallback: [{
            type: Input
        }], fixedFacetLoadSelectedCallback: [{
            type: Input
        }], fixedFacetSaveHistoryCallback: [{
            type: Input
        }], fixedFacetLoadHistoryCallback: [{
            type: Input
        }], fixedFacetButtonHeaderLabel: [{
            type: Input
        }], fixedFacetTitle: [{
            type: Input
        }], fixedFacetTypeName: [{
            type: Input
        }], showFixedFacet: [{
            type: Input
        }], hasSearch: [{
            type: Input
        }], groupNamesList: [{
            type: Input
        }], selectedGroupName: [{
            type: Input
        }], isStickyFacetsGroups: [{
            type: Input
        }], stickyFacetsSaved: [{
            type: Output
        }], appliedFacetsChange: [{
            type: Output
        }], appliedFacetsWithLabels: [{
            type: Output
        }], appliedTogglesChange: [{
            type: Output
        }], appliedFixedFacetsChange: [{
            type: Output
        }], groupChanged: [{
            type: Output
        }], savedFacetsGroupDeleted: [{
            type: Output
        }], favoriteFacetsGroupChange: [{
            type: Output
        }], applyChanges: [], clearAppliedFacets: [], onFacetSelectedApplied: [], onFacetUnapplied: [], handleFixedFacetChange: [] }); })();

class ExNewFacetsModule {
    static { this.ɵfac = function ExNewFacetsModule_Factory(t) { return new (t || ExNewFacetsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExNewFacetsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            CommonModule,
            ExComponentLoaderModule,
            MatExpansionModule,
            MatCheckboxModule,
            MatTooltipModule,
            ExDirectivesModule,
            ExButtonModule,
            MatRippleModule,
            ExIconModule,
            MatSlideToggleModule,
            TranslateModule,
            ExCheckboxModule,
            ExSearchModule,
            ExSvgIconModule,
            ExIconModule,
            EXPipesModule,
            ExSlideToggleModule,
            ExDialogModule,
            ExFormsModule,
            ExEditableTextModule,
            ExNewComboboxModule,
            ExFloatingComponentModule,
            ExLabelModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExNewFacetsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    ExComponentLoaderModule,
                    MatExpansionModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    ExButtonModule,
                    MatRippleModule,
                    ExIconModule,
                    MatSlideToggleModule,
                    TranslateModule,
                    ExCheckboxModule,
                    ExSearchModule,
                    ExSvgIconModule,
                    ExIconModule,
                    EXPipesModule,
                    ExSlideToggleModule,
                    ExDialogModule,
                    ExFormsModule,
                    ExEditableTextModule,
                    ExNewComboboxModule,
                    ExFloatingComponentModule,
                    ExLabelModule
                ],
                declarations: [
                    ExNewFacetsWrapperComponent,
                    ExCheckboxFacetsComponent,
                    ExAppliedFacetsComponent,
                    ExToggleFacetsComponent,
                    ExHierarchyFacetsComponent,
                    GetFacetsPipe,
                    getFacetsLabelsPipe,
                    getSectionPipe,
                    ExSetTopFacetComponent,
                    ExFacetRangeComponent,
                    ExSaveNewFacetsDialogComponent
                ],
                exports: [
                    ExNewFacetsWrapperComponent,
                    ExCheckboxFacetsComponent,
                    ExAppliedFacetsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExNewFacetsModule, { declarations: [ExNewFacetsWrapperComponent,
        ExCheckboxFacetsComponent,
        ExAppliedFacetsComponent,
        ExToggleFacetsComponent,
        ExHierarchyFacetsComponent,
        GetFacetsPipe,
        getFacetsLabelsPipe,
        getSectionPipe,
        ExSetTopFacetComponent,
        ExFacetRangeComponent,
        ExSaveNewFacetsDialogComponent], imports: [FormsModule,
        CommonModule,
        ExComponentLoaderModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatTooltipModule,
        ExDirectivesModule,
        ExButtonModule,
        MatRippleModule,
        ExIconModule,
        MatSlideToggleModule,
        TranslateModule,
        ExCheckboxModule,
        ExSearchModule,
        ExSvgIconModule,
        ExIconModule,
        EXPipesModule,
        ExSlideToggleModule,
        ExDialogModule,
        ExFormsModule,
        ExEditableTextModule,
        ExNewComboboxModule,
        ExFloatingComponentModule,
        ExLabelModule], exports: [ExNewFacetsWrapperComponent,
        ExCheckboxFacetsComponent,
        ExAppliedFacetsComponent] }); })();

class ExProgressBarComponent {
    constructor() {
        /**
         * the mode of the component:
         * determinate - Operations where the percentage of the operation complete is known.
         * indeterminate - Operations where the user is asked to wait while something finishes and it’s not necessary to indicate how long it will take.
         * pending - when the operation did not start yet
         */
        this.mode = 'indeterminate';
        /**
         * time in milliseconds for the getValue callback
         */
        this.intervalTime = 5000;
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('mode')) {
            if (changes.mode.previousValue !== 'determinate' && changes.mode.currentValue === 'determinate') {
                this.startInterval();
            }
            if (changes.mode.previousValue === 'determinate' && changes.mode.currentValue !== 'determinate') {
                this.stopInterval();
            }
        }
        if (changes.hasOwnProperty('intervalTime')) {
            if (this.intervalTime < 3000) {
                throw new Error('Interval time cannot be smaller than 3000');
            }
        }
    }
    ngOnDestroy() {
        this.stopInterval();
    }
    startInterval() {
        if (this.getValue) {
            this.callGetValue();
            this.interval = setInterval(() => {
                this.callGetValue();
            }, this.intervalTime);
        }
    }
    stopInterval() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    callGetValue() {
        this.getValue().subscribe(value => {
            this.value = value;
            if (value >= 100) {
                this.stopInterval();
            }
        });
    }
    static { this.ɵfac = function ExProgressBarComponent_Factory(t) { return new (t || ExProgressBarComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExProgressBarComponent, selectors: [["ex-progress-bar"]], inputs: { mode: "mode", value: "value", getValue: "getValue", intervalTime: "intervalTime" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[1, "ex-progress-bar", 3, "mode", "value"]], template: function ExProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "mat-progress-bar", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("mode", ctx.mode === "pending" ? "buffer" : ctx.mode)("value", ctx.mode === "pending" ? 0 : ctx.value);
        } }, dependencies: [i2$8.MatProgressBar], styles: [".ex-progress-bar[_ngcontent-%COMP%]{border-radius:10px;border:1px solid #898989}.ex-progress-bar[_ngcontent-%COMP%]     .mat-progress-bar-buffer{background-color:#fff!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExProgressBarComponent, [{
        type: Component,
        args: [{ selector: 'ex-progress-bar', template: "<mat-progress-bar class=\"ex-progress-bar\" [mode]=\"mode === 'pending' ? 'buffer' : mode\"\n    [value]=\"mode === 'pending' ? 0 : value\">\n</mat-progress-bar>", styles: [".ex-progress-bar{border-radius:10px;border:1px solid #898989}.ex-progress-bar ::ng-deep .mat-progress-bar-buffer{background-color:#fff!important}\n"] }]
    }], function () { return []; }, { mode: [{
            type: Input
        }], value: [{
            type: Input
        }], getValue: [{
            type: Input
        }], intervalTime: [{
            type: Input
        }] }); })();

class ExProgressBarModule {
    static { this.ɵfac = function ExProgressBarModule_Factory(t) { return new (t || ExProgressBarModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExProgressBarModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatProgressBarModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExProgressBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressBarModule
                ],
                declarations: [
                    ExProgressBarComponent
                ],
                exports: [
                    ExProgressBarComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExProgressBarModule, { declarations: [ExProgressBarComponent], imports: [CommonModule,
        MatProgressBarModule], exports: [ExProgressBarComponent] }); })();

const QyeryBuilderAnimations = [
    trigger('fade', [
        state('void', style({
            opacity: 0
        })),
        state('*', style({
            opacity: 1
        })),
        transition('void <=> *', [
            animate(300)
        ])
    ]),
    trigger('toggleAnim', [
        state('true', style({
            opacity: 0,
            width: '55px',
            visibility: 'hidden'
        })),
        state('false', style({
            opacity: 1,
            'z-index': 3
        })),
        transition('false <=> true', [
            animate(300)
        ])
    ]),
    trigger('rowAnim', [
        state('void', style({
            opacity: 0,
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingRight: '0px',
            paddingLeft: '0px',
            marginTop: '0px',
            marginBottom: '0px',
            marginRight: '0px',
            marginLeft: '0px'
        })),
        state('*', style({
            opacity: 1
        })),
        transition('void <=> *', [
            animate(300)
        ])
    ]),
    trigger('bgAnim', [
        state('play', style({
            background: 'aliceblue'
        })),
        state('normal', style({
            background: 'white'
        })),
        state('new', style({
            background: 'oldlace'
        })),
        transition('play <=> normal', [
            animate(400)
        ]),
        transition('new <=> normal', [
            animate(400)
        ]),
        transition('new <=> play', [
            animate(400)
        ])
    ])
];

const SECONDARY_SEARCH = 'secondary_search';
const hasSecondarySearch = (searchQuery) => {
    return searchQuery?.rules?.find((rule) => rule?.extraData === SECONDARY_SEARCH);
};
const RelativeDateOperators = [
    'WITHIN_NEXT_X_DAYS',
    'WITHIN_LAST_X_DAYS',
    'OLDER_THAN_X_DAYS'
];

function ViewModeComponent_span_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.rule.operator);
} }
function ViewModeComponent_span_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.uiValue);
} }
function ViewModeComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, ViewModeComponent_span_4_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ViewModeComponent_span_4_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.rule.operator);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.uiValue != null);
} }
function ViewModeComponent_ng_template_5_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.rule.operator);
} }
const _c0$5 = function (a0, a1, a2, a3) { return { value: a0, type: a1, smallScreen: a2, hasMore: a3, readOnly: true }; };
function ViewModeComponent_ng_template_5_ex_component_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 10);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("componentFactoryItem", ctx_r6.config.fields[ctx_r6.rule.field] == null ? null : ctx_r6.config.fields[ctx_r6.rule.field].component)("data", i0.ɵɵpureFunction4(2, _c0$5, ctx_r6.rule.value, ctx_r6.config.fields[ctx_r6.rule.field] == null ? null : ctx_r6.config.fields[ctx_r6.rule.field].component.data == null ? null : ctx_r6.config.fields[ctx_r6.rule.field].component.data.type, ctx_r6.smallScreen, ctx_r6.config.fields[ctx_r6.rule.field] == null ? null : ctx_r6.config.fields[ctx_r6.rule.field].hasMore));
} }
function ViewModeComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ViewModeComponent_ng_template_5_span_0_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(1, ViewModeComponent_ng_template_5_ex_component_loader_1_Template, 1, 7, "ex-component-loader", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.rule.operator);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.config.fields[ctx_r2.rule.field] == null ? null : ctx_r2.config.fields[ctx_r2.rule.field].component) != null);
} }
//import { RialtoPlatformsService } from '-/services/rialto-platforms.service';
class ViewModeComponent {
    constructor() {
        this.viewMode = false;
        this.smallScreen = false;
        this.ruleClicked = new EventEmitter();
        this.uiValue = null;
    }
    _ruleClicked() {
        this.ruleClicked.emit();
    }
    ngOnInit() {
        this.uiValue = this.rule.value;
        if (this.config.fields[this.rule.field].componentType) {
            this.rule.componentType = this.config.fields[this.rule.field].componentType;
        }
        if (this.config.fields[this.rule.field].options) {
            this.config.fields[this.rule.field].options.forEach(option => {
                if (option.value === this.rule.value) {
                    this.rule.name = option.name;
                }
                if (this.rule.value === option.key) {
                    this.uiValue = option.value;
                }
            });
        }
        if (typeof this.rule.value == 'string')
            this.isRuleValuePlain = true;
    }
    ngOnDestroy() {
        this.rule.componentType = null;
    }
    static { this.ɵfac = function ViewModeComponent_Factory(t) { return new (t || ViewModeComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ViewModeComponent, selectors: [["view-mode"]], inputs: { rule: "rule", config: "config", backgroundColor: "backgroundColor", viewMode: "viewMode", smallScreen: "smallScreen" }, outputs: { ruleClicked: "ruleClicked" }, decls: 7, vars: 8, consts: [["role", "button", 1, "view-box-button", 3, "click", "keyup.enter", "keyup.Space"], [1, "view-box-field-text", "sel-category"], [1, "view-box-value-text"], [4, "ngIf", "ngIfElse"], ["DynamicComponent", ""], ["class", "sel-operator", 4, "ngIf"], ["class", "sel-field", 4, "ngIf"], [1, "sel-operator"], [1, "sel-field"], [3, "componentFactoryItem", "data", 4, "ngIf"], [3, "componentFactoryItem", "data"]], template: function ViewModeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ViewModeComponent_Template_div_click_0_listener() { return ctx._ruleClicked(); })("keyup.enter", function ViewModeComponent_Template_div_keyup_enter_0_listener() { return ctx._ruleClicked(); })("keyup.Space", function ViewModeComponent_Template_div_keyup_Space_0_listener() { return ctx._ruleClicked(); });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtemplate(4, ViewModeComponent_span_4_Template, 5, 2, "span", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ViewModeComponent_ng_template_5_Template, 2, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(6);
            i0.ɵɵstyleProp("width", "270px")("background", ctx.backgroundColor);
            i0.ɵɵattribute("tabindex", ctx.viewMode ? -1 : 0);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.config.fields[ctx.rule.field].value);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.rule.componentType != "dynamic")("ngIfElse", _r1);
        } }, dependencies: [i1$5.NgIf, ExComponentLoaderComponent], styles: [".view-box-button[_ngcontent-%COMP%]{max-width:100%;overflow:hidden;text-align:left;border-radius:5px;padding:10px;cursor:pointer}.view-box-value-text[_ngcontent-%COMP%]{white-space:pre-line}.view-mode-classification[_ngcontent-%COMP%]{margin-bottom:10px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewModeComponent, [{
        type: Component,
        args: [{ selector: 'view-mode', template: "<div (click)=\"_ruleClicked()\" (keyup.enter)=\"_ruleClicked()\" (keyup.Space)=\"_ruleClicked()\"[style.width]=\"'270px'\" [style.background]=\"backgroundColor\" class=\"view-box-button\" role=\"button\" [attr.tabindex]=\"viewMode ? -1 : 0\">\n  <div class=\"view-box-field-text sel-category\">{{ config.fields[rule.field].value }}</div>\n\n  <div class=\"view-box-value-text\">\n    <span *ngIf=\"rule.componentType != 'dynamic'; else DynamicComponent\">\n      <span *ngIf=\"rule.operator\" class=\"sel-operator\" >{{ rule.operator }}</span>\n      <span>&nbsp;</span>\n      <span *ngIf=\"uiValue != null\" class=\"sel-field\">{{ uiValue }}</span>\n    </span>\n  </div>\n  <ng-template #DynamicComponent>\n      <span *ngIf=\"rule.operator\" class=\"sel-operator\" >{{ rule.operator }}</span>\n      <ex-component-loader *ngIf=\"config.fields[rule.field]?.component != null\" [componentFactoryItem]=\"config.fields[rule.field]?.component\"\n                           [data]=\"{ value: rule.value, type: config.fields[rule.field]?.component.data?.type,\n                         smallScreen: smallScreen, hasMore: config.fields[rule.field]?.hasMore, readOnly:true }\">\n      </ex-component-loader>\n  </ng-template>\n</div>\n", styles: [".view-box-button{max-width:100%;overflow:hidden;text-align:left;border-radius:5px;padding:10px;cursor:pointer}.view-box-value-text{white-space:pre-line}.view-mode-classification{margin-bottom:10px}\n"] }]
    }], function () { return []; }, { rule: [{
            type: Input
        }], config: [{
            type: Input
        }], backgroundColor: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], smallScreen: [{
            type: Input
        }], ruleClicked: [{
            type: Output
        }] }); })();

class ExQueryBuilderCompositeType extends ExControlValueAccessor {
    constructor(fb, cdr) {
        super();
        this.fb = fb;
        this.cdr = cdr;
        this.justAtFirstTime = true;
        this.selfOperatorChange = new EventEmitter();
        this.index = '1';
        this.id = "1";
        this.validationRequired = true;
        this.isPlayHovered = false;
        this.isPlayClicked = { value: false, timestamp: null };
        this.level = 1;
        this.smallScreen = false;
        this.allowAddRoles = true;
        this.allowRowActions = true;
        /**
         * the translations for the query builder
         */
        this.translations = {
            addRule: 'Add rule',
            copyRule: 'Copy rule',
            removeRule: 'Remove rule',
            addGroup: 'Add group',
            removeGroup: 'Remove group',
            copyGroup: 'Copy group',
            and: 'AND',
            or: 'OR',
            play: 'Play',
            emptyMessage: 'A ruleset cannot be empty. Please add a rule or remove it all together.'
        };
        /**
         * Max levels of grouping
         */
        this.maxLevels = 10;
        /**
         * indicates if to display QB in view or edit mode
         */
        this.viewMode = false;
        this.inputsPlaceholder = 'ng.general.enter_value';
        this.conditionIsDisabled = false;
        this.shrinkedMode = false;
        this.showRunBtn = true;
        /**
         * Display run button only on main query and not in the children
         */
        this.showOnlyTopRunBtn = false;
        this.isDynamicRuleField = false;
        this.dynamicRuleFieldEvents = "{selectedValueChange: changeField.bind(this, rule, i)}";
        this.operatorsWithoutInputField = ['EMPTY', 'ALL_VALUES'];
        this.configLoading = false;
        this.dateFormat = "dd/MM/yyyy";
        this.playClicked = new EventEmitter();
        this.markPlaceholderInd = new EventEmitter();
        this.isSetDefaultValues = true;
    }
    ngOnInit() {
        if (this.config) {
            this.control = this.fb.control({
                "condition": "and",
                "rules": Object.entries(this.config.fields).map(([key, q]) => {
                    const operator = q?.defaultOperator ? q.defaultOperator :
                        (this.isOperatorExist(q, 'ALL_VALUES') ? 'ALL_VALUES' : 'OUTER_EQUAL');
                    return {
                        field: key,
                        categoryReadOnly: true,
                        outputKey: q.key,
                        operator,
                        value: this.isSetDefaultValues ? q.options?.[0]?.key : null
                    };
                }),
            });
            this.updateLastOperatorFromSelfRule();
            this.onNgModelChange(this.control);
            this.cdr.markForCheck();
        }
    }
    isOperatorExist(rule, operator) {
        return !!rule && rule.preferred_operators.find(({ op_key }) => { return op_key === operator; });
    }
    onNgModelChange(event) {
        if (!this.config)
            return;
        Object.keys(this.config?.fields).forEach((field, i) => this.checkAndUpdateFieldsDeps(this.config?.fields?.[field]?.visible, this.control.getRawValue()['rules'], i, field));
        this.controlValue = this.control.getRawValue()['rules'].filter(this.allowValuesToOutput.bind(this)).map(({ outputKey, value, operator, field }) => {
            return `${outputKey}=${value || ''}`;
        }).join('##');
        this.getSelfOperatorRule()?.operator && this.selfOperatorChange.emit(this.getSelfOperatorRule()?.operator);
        this.controlOnChange(this.controlValue);
        this.cdr.markForCheck();
        this.setFieldValidation();
        setTimeout(() => { this.setFieldValidation(); });
    }
    setFieldValidation() {
        if ((this.parentForm != undefined) && !!this.control?.getRawValue()?.['rules']) {
            let index = this.parentValue.rules.findIndex((r) => r.value == this.controlValue);
            this.parentForm.get('fields').controls[index]?.setErrors({
                'incorrect': { valid: this.getControlValidation() }
            });
        }
    }
    allowValuesToOutput(i) {
        return (!!i.value ||
            (!i.value && this.operatorsWithoutInputField.includes(i.operator)))
            && !i.isHide
            && i.operator != 'ALL_VALUES';
    }
    checkAndUpdateFieldsDeps(depsConfig, parentRules, index, fieldKey) {
        let showFieldRow = true;
        let comboboxOptions;
        let selfControl = (parentRules).find((r) => r?.field === fieldKey);
        Object.entries(_.groupBy(depsConfig, 'dependencyFieldName')).forEach(([key, orConditionsForDisplayRow]) => {
            const relatedRule = (parentRules).find((r) => r?.field === key);
            comboboxOptions = [];
            if (orConditionsForDisplayRow.some(({ dependencyFieldValue, options }) => {
                if (relatedRule?.value === dependencyFieldValue) {
                    comboboxOptions = options;
                }
                return relatedRule?.value == dependencyFieldValue;
            })) {
                if (comboboxOptions.length > 0 && selfControl?.value && !comboboxOptions.includes(selfControl?.value)) {
                    this.resetField(selfControl, comboboxOptions);
                }
            }
            else {
                showFieldRow = false;
            }
        });
        this.hideRow(fieldKey, !showFieldRow);
        this.filterValues(selfControl, comboboxOptions);
    }
    ngOnDestroy() {
    }
    resetField(i, op) {
        if (this.control.getRawValue()['rules'].find((r) => r?.field === i.field) && this.config.fields[i.field]?.type === 'category') {
            const firstOption = op?.[0];
            this.control.getRawValue()['rules'].find((r) => r?.field === i.field).value = this.isSetDefaultValues ? firstOption : null;
        }
    }
    hideRow(field, hide) {
        let rule = this.control.getRawValue()['rules'].find((r) => r?.field === field);
        rule.isHide = hide;
    }
    filterValues(i, op) {
        if (op != null && this.control.getRawValue()['rules'].find((r) => r?.field === i.field)) {
            this.control.getRawValue()['rules'].find((r) => r?.field === i.field).filterItems = op;
        }
    }
    writeValue(obj) {
        this.controlValue = obj;
        if (obj == null || !obj)
            return;
        if (!this.config)
            return;
        if (obj?.value) {
            this.controlValue = obj.value;
        }
        this.controlValue.split("##").forEach(line => {
            const item = line.split("=");
            const rules = this.control.getRawValue()['rules'].filter((r) => r?.outputKey === item[0]);
            this.updateOperatorOfEmpty(item, rules);
            this.control.getRawValue()['rules'].filter((r) => r?.outputKey === item[0]).forEach(i => i.value = item[1]);
        });
        this.onNgModelChange(this.control);
        this.cdr.markForCheck();
    }
    updateOperatorOfEmpty(item, rules) {
        if (!item[1] && this.justAtFirstTime) {
            rules.filter(r => this.isOperatorExist(this.config.fields[r.field], 'EMPTY')).forEach(i => i.operator = 'EMPTY');
            this.justAtFirstTime = false;
        }
        else if (rules.filter(r => this.isOperatorExist(this.config.fields[r.field], 'EMPTY')).length && this.justAtFirstTime) {
            rules.filter(r => this.isOperatorExist(this.config.fields[r.field], 'EMPTY')).forEach(i => i.operator = 'OUTER_EQUAL');
            this.justAtFirstTime = false;
        }
    }
    getControlValidation() {
        return this.control.getRawValue()['rules'].every(i => i.isHide || !!i.value || [...this.operatorsWithoutInputField, 'ALL_VALUES'].includes(i.operator));
    }
    ngOnChanges(changes) {
        if (changes?.selfOperator && this.selfOperator && this.control) {
            this.updateLastOperatorFromSelfRule();
            this.onNgModelChange(this.control);
        }
    }
    updateLastOperatorFromSelfRule() {
        const lastRule = this.getSelfOperatorRule();
        if (lastRule?.field && this.isOperatorExist(this.config.fields[lastRule.field], this.selfOperator)) {
            lastRule.operator = this.selfOperator;
        }
    }
    getSelfOperatorRule() {
        const key = Object.entries(this.config.fields).filter(([f, value]) => value?.preferred_operators &&
            value.preferred_operators.filter(op => !this.operatorsWithoutInputField.includes(op.op_key))?.length > 1)?.[0]?.[0];
        return this.control.getRawValue()['rules'].find(f => f.field == key);
    }
    static { this.ɵfac = function ExQueryBuilderCompositeType_Factory(t) { return new (t || ExQueryBuilderCompositeType)(i0.ɵɵdirectiveInject(i1$6.UntypedFormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExQueryBuilderCompositeType, selectors: [["ex-query-builder-composite-type"]], hostBindings: function ExQueryBuilderCompositeType_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedItemsChange", function ExQueryBuilderCompositeType_selectedItemsChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExQueryBuilderCompositeType_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { isTriggerByEnter: "isTriggerByEnter", config: "config", selfOperator: "selfOperator", index: "index", id: "id", validationRequired: "validationRequired", isPlayHovered: "isPlayHovered", isPlayClicked: "isPlayClicked", level: "level", smallScreen: "smallScreen", allowAddRoles: "allowAddRoles", allowRowActions: "allowRowActions", disabled: "disabled", translations: "translations", maxLevels: "maxLevels", operatorMap: "operatorMap", parentChangeCallback: "parentChangeCallback", parentTouchedCallback: "parentTouchedCallback", parentForm: "parentForm", parentValue: "parentValue", viewMode: "viewMode", inputsPlaceholder: "inputsPlaceholder", conditionIsDisabled: "conditionIsDisabled", shrinkedMode: "shrinkedMode", showRunBtn: "showRunBtn", showOnlyTopRunBtn: "showOnlyTopRunBtn", isDynamicRuleField: "isDynamicRuleField", dynamicRuleFieldEvents: "dynamicRuleFieldEvents", operatorsWithoutInputField: "operatorsWithoutInputField", configLoading: "configLoading", dateFormat: "dateFormat", isSetDefaultValues: "isSetDefaultValues" }, outputs: { selfOperatorChange: "selfOperatorChange", playClicked: "playClicked", markPlaceholderInd: "markPlaceholderInd" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExQueryBuilderCompositeType)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 23, consts: [[3, "config", "formControl", "allowRuleset", "conditionIsDisabled", "allowAddRoles", "allowRowActions", "disabled", "isPlayHovered", "isPlayClicked", "smallScreen", "translations", "externalValidation", "operatorMap", "shrinkedMode", "viewMode", "showRunBtn", "id", "index", "level", "isTriggerByEnter", "operatorsWithoutInputField", "ngModelChange", "playClicked", "markPlaceholderInd"]], template: function ExQueryBuilderCompositeType_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "ex-query-builder", 0);
            i0.ɵɵlistener("ngModelChange", function ExQueryBuilderCompositeType_Template_ex_query_builder_ngModelChange_0_listener($event) { return ctx.onNgModelChange($event); })("playClicked", function ExQueryBuilderCompositeType_Template_ex_query_builder_playClicked_0_listener() { return !ctx.showRunBtn && ctx.playClicked.emit(ctx.parentValue); })("markPlaceholderInd", function ExQueryBuilderCompositeType_Template_ex_query_builder_markPlaceholderInd_0_listener($event) { return ctx.markPlaceholderInd.emit($event); });
            i0.ɵɵpipe(1, "exNormalizeConfig");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("config", i0.ɵɵpipeBind1(1, 21, ctx.config))("formControl", ctx.control)("allowRuleset", false)("conditionIsDisabled", true)("allowAddRoles", false)("allowRowActions", false)("disabled", ctx.disabled)("isPlayHovered", ctx.isPlayHovered)("isPlayClicked", ctx.isPlayClicked)("smallScreen", ctx.smallScreen)("translations", ctx.translations)("externalValidation", ctx.getControlValidation())("operatorMap", ctx.operatorMap)("shrinkedMode", ctx.shrinkedMode)("viewMode", ctx.viewMode)("showRunBtn", ctx.showRunBtn)("id", ctx.id)("index", ctx.index)("level", ctx.level)("isTriggerByEnter", ctx.isTriggerByEnter)("operatorsWithoutInputField", ctx.operatorsWithoutInputField);
        } }, encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExQueryBuilderCompositeType, [{
        type: Component,
        args: [{ host: {
                    '(selectedItemsChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExQueryBuilderCompositeType), selector: 'ex-query-builder-composite-type', template: "      <ex-query-builder [config]=\"config | exNormalizeConfig\" [formControl]=\"control\" [allowRuleset]=\"false\" [conditionIsDisabled]=\"true\"\r\n      (ngModelChange)=\"onNgModelChange($event)\" [allowAddRoles]=\"false\" [allowRowActions]=\"false\"\r\n      [disabled]=\"disabled\" [isPlayHovered]=\"isPlayHovered\"\r\n      [isPlayClicked]=\"isPlayClicked\" [smallScreen]=\"smallScreen\"\r\n      [translations]=\"translations\" (playClicked)=\"!showRunBtn && playClicked.emit(parentValue)\" [externalValidation]=\"getControlValidation()\"\r\n      [operatorMap]=\"operatorMap\" [shrinkedMode]=\"shrinkedMode\" [viewMode]=\"viewMode\"\r\n      [showRunBtn]=\"showRunBtn\" [id]=\"id\" [index]=\"index\" [level]=\"level\" [isTriggerByEnter]=\"isTriggerByEnter\"\r\n      [operatorsWithoutInputField]=\"operatorsWithoutInputField\" (markPlaceholderInd)=\"markPlaceholderInd.emit($event)\">\r\n      </ex-query-builder>\r\n" }]
    }], function () { return [{ type: i1$6.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }]; }, { isTriggerByEnter: [{
            type: Input
        }], config: [{
            type: Input
        }], selfOperator: [{
            type: Input
        }], selfOperatorChange: [{
            type: Output
        }], index: [{
            type: Input
        }], id: [{
            type: Input
        }], validationRequired: [{
            type: Input
        }], isPlayHovered: [{
            type: Input
        }], isPlayClicked: [{
            type: Input
        }], level: [{
            type: Input
        }], smallScreen: [{
            type: Input
        }], allowAddRoles: [{
            type: Input
        }], allowRowActions: [{
            type: Input
        }], disabled: [{
            type: Input
        }], translations: [{
            type: Input
        }], maxLevels: [{
            type: Input
        }], operatorMap: [{
            type: Input
        }], parentChangeCallback: [{
            type: Input
        }], parentTouchedCallback: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], parentValue: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], inputsPlaceholder: [{
            type: Input
        }], conditionIsDisabled: [{
            type: Input
        }], shrinkedMode: [{
            type: Input
        }], showRunBtn: [{
            type: Input
        }], showOnlyTopRunBtn: [{
            type: Input
        }], isDynamicRuleField: [{
            type: Input
        }], dynamicRuleFieldEvents: [{
            type: Input
        }], operatorsWithoutInputField: [{
            type: Input
        }], configLoading: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], playClicked: [{
            type: Output
        }], markPlaceholderInd: [{
            type: Output
        }], isSetDefaultValues: [{
            type: Input
        }] }); })();

class ExQbPipe {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
    }
    transform(rule) {
        return this.formBuilder.control(rule);
    }
    static { this.ɵfac = function ExQbPipe_Factory(t) { return new (t || ExQbPipe)(i0.ɵɵdirectiveInject(i1$6.UntypedFormBuilder, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exqbForm", type: ExQbPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExQbPipe, [{
        type: Pipe,
        args: [{
                name: 'exqbForm',
                pure: true
            }]
    }], function () { return [{ type: i1$6.UntypedFormBuilder }]; }, null); })();
class exQbNormalizeConfigPipe {
    // The Key is used for create the output and can be same in many fields. So we have to set the uniq id to this field for display the category label well.
    // Sometimes can appear duplicates of the same item, so we remove them.
    constructor() { }
    transform(configSource) {
        if (!configSource)
            return configSource;
        const config = cloneDeep(configSource);
        Object.entries(config.fields).forEach(([key, item]) => {
            const t = item;
            t.key = key;
            if (t.type == "category") {
                config.fields[key].options = uniqBy(config.fields[key].options, (e) => e.key);
            }
        });
        return config;
    }
    static { this.ɵfac = function exQbNormalizeConfigPipe_Factory(t) { return new (t || exQbNormalizeConfigPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "exNormalizeConfig", type: exQbNormalizeConfigPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(exQbNormalizeConfigPipe, [{
        type: Pipe,
        args: [{
                name: 'exNormalizeConfig',
                pure: true
            }]
    }], function () { return []; }, null); })();

const _c0$4 = ["field"];
const _c1$3 = ["inputRow"];
function ExQueryBuilderComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_button_5_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.markPlaceHolder({ relativeLoc: "last" })); })("mouseleave", function ExQueryBuilderComponent_button_5_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.markPlaceHolder({ reset: true })); })("click", function ExQueryBuilderComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.addRule(ctx_r14.data.rules.length - 1)); })("keydown.enter", function ExQueryBuilderComponent_button_5_Template_button_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.isKeypress = true); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-svg-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "addRuleFromTop", ctx_r1.id, "");
    i0.ɵɵproperty("exTooltip", ctx_r1.translations.addRule)("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", ctx_r1.translations.addRule + " " + i0.ɵɵpipeBind1(1, 5, "ng.ex-query-builder.to") + " " + i0.ɵɵpipeBind1(2, 7, "ng.ex-query-builder.ruleSet") + " " + ctx_r1.index);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_button_6_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.markPlaceHolder({ addGroupHovered: true, relativeLoc: "last" })); })("mouseleave", function ExQueryBuilderComponent_button_6_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.markPlaceHolder({ reset: true, addGroupHovered: false })); })("click", function ExQueryBuilderComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.addRuleSet()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-svg-icon", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "addGroup", ctx_r2.id, "");
    i0.ɵɵproperty("exTooltip", ctx_r2.translations.addGroup)("disabled", ctx_r2.disabled);
    i0.ɵɵattribute("aria-label", ctx_r2.translations.addGroup + " " + i0.ɵɵpipeBind1(1, 5, "ng.ex-query-builder.to") + " " + i0.ɵɵpipeBind1(2, 7, "ng.ex-query-builder.ruleSet") + " " + ctx_r2.index);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_ng_container_7_Template_button_mouseenter_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.markPlaceholderInd.emit({ addGroupHovered: true, relativeLoc: "next" })); })("mouseleave", function ExQueryBuilderComponent_ng_container_7_Template_button_mouseleave_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.markPlaceholderInd.emit({ addGroupHovered: false, reset: true })); })("click", function ExQueryBuilderComponent_ng_container_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.copyRuleSet()); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "copyGroup", ctx_r3.id, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 5, "ng.general.duplicate-group"))("disabled", ctx_r3.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 7, "ng.general.duplicate-group"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 15);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "json");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "ex-svg-icon", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "copyGroupToClipboard", ctx_r4.id, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 6, "ng.general.copy-group"))("cdkCopyToClipboard", i0.ɵɵpipeBind1(3, 8, ctx_r4.data))("disabled", ctx_r4.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 10, "ng.general.copy-group"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_ng_container_9_Template_button_mouseenter_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.markPlaceHolder({ addGroupHovered: true, relativeLoc: "last" })); })("mouseleave", function ExQueryBuilderComponent_ng_container_9_Template_button_mouseleave_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.markPlaceHolder({ reset: true, addGroupHovered: false })); })("click", function ExQueryBuilderComponent_ng_container_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.pasteRule(ctx_r27.data.rules.length + 1)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "pasteGroup", ctx_r5.id, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(2, 5, "ng.general.paste"))("disabled", ctx_r5.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 7, "ng.general.paste"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵlistener("click", function ExQueryBuilderComponent_ng_container_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.removeRuleSet()); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "removeGroup", ctx_r6.id, "");
    i0.ɵɵproperty("exTooltip", ctx_r6.translations.removeGroup)("disabled", ctx_r6.disabled);
    i0.ɵɵattribute("aria-label", ctx_r6.translations.removeGroup + " " + i0.ɵɵpipeBind1(2, 5, "ng.ex-query-builder.from") + " " + i0.ɵɵpipeBind1(3, 7, "ng.ex-query-builder.ruleSet") + " " + ctx_r6.index);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
const _c2$1 = function (a0) { return { "ex-query-builder-disable-play": a0 }; };
function ExQueryBuilderComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_button_11_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.isPlayHovered = true); })("mouseleave", function ExQueryBuilderComponent_button_11_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.isPlayHovered = false); })("click", function ExQueryBuilderComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.play()); });
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "playButton", ctx_r7.id, "");
    i0.ɵɵproperty("exTooltip", ctx_r7.translations.play)("disabled", ctx_r7.disabled || ctx_r7.queryBuilderInvalidInputs.size > 0);
    i0.ɵɵattribute("aria-label", ctx_r7.translations.play);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$1, ctx_r7.queryBuilderInvalidInputs.size > 0));
} }
function ExQueryBuilderComponent_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_div_12_div_2_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.changeIsToggleHovered(true)); })("mouseleave", function ExQueryBuilderComponent_div_12_div_2_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.changeIsToggleHovered(false)); })("focusin", function ExQueryBuilderComponent_div_12_div_2_Template_div_focusin_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.changeIsToggleHovered(true)); })("focusout", function ExQueryBuilderComponent_div_12_div_2_Template_div_focusout_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.changeIsToggleHovered(false)); })("click", function ExQueryBuilderComponent_div_12_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.showHideToggle(!ctx_r45.isToggleVisible)); })("keyup.enter", function ExQueryBuilderComponent_div_12_div_2_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.showHideToggle(!ctx_r46.isToggleVisible)); })("keyup.Space", function ExQueryBuilderComponent_div_12_div_2_Template_div_keyup_Space_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r47 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r47.showHideToggle(!ctx_r47.isToggleVisible)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("tabindex", ctx_r34.viewMode ? -1 : 0)("aria-label", i0.ɵɵpipeBind1(1, 3, "ng.ex-query-builder.toggle") + " " + i0.ɵɵpipeBind1(2, 5, "ng.ex-query-builder.ruleSet") + " " + ctx_r34.index)("aria-expanded", ctx_r34.isToggleVisible);
} }
const _c3$1 = function (a0) { return { "ex-query-builder-connection-selected": a0 }; };
function ExQueryBuilderComponent_div_12_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3$1, ctx_r35.isToggleVisible || ctx_r35.isToggleHovered || ctx_r35.isPlayHovered || ctx_r35.isPlayClicked.value));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r59.showHideToggle(!ctx_r59.isToggleVisible)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r53.translations[ctx_r53.data.condition]);
} }
const _c4 = function (a0) { return { "ex-query-builder-connection-to-group-selected": a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_span_5_Template_span_mouseenter_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r61.changeIsToggleHovered(true)); })("mouseleave", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_span_5_Template_span_mouseleave_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r63 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r63.changeIsToggleHovered(false)); })("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_span_5_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r64 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r64.showHideToggle(!ctx_r64.isToggleVisible)); });
    i0.ɵɵelement(1, "span", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c4, ctx_r54.isToggleVisible || ctx_r54.isToggleHovered || ctx_r54.isPlayHovered || ctx_r54.isPlayClicked.value));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "span", 46);
    i0.ɵɵtext(2, "\u25E4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 47);
    i0.ɵɵtext(4, "\u25E4");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(3);
    const i_r50 = ctx_r67.index;
    const rule_r49 = ctx_r67.$implicit;
    i0.ɵɵstyleProp("left", i_r50 === rule_r49.new ? -5 : 0, "px");
    i0.ɵɵproperty("@fade", undefined);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 48);
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(3);
    const i_r50 = ctx_r68.index;
    const rule_r49 = ctx_r68.$implicit;
    i0.ɵɵstyleProp("left", i_r50 === rule_r49.new ? -5 : 0, "px");
    i0.ɵɵproperty("@fade", undefined);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_div_1_Template, 5, 3, "div", 43);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_div_2_Template, 1, 3, "div", 44);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r55.addGroupHovered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r55.addGroupHovered);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵlistener("resized", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_div_2_Template_div_resized_0_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r76.onResized($event)); });
    i0.ɵɵelementContainer(1, 55)(2, 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r71 = i0.ɵɵreference(5);
    const _r73 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r71);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r73);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelementContainer(1, 55)(2, 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r71 = i0.ɵɵreference(5);
    const _r73 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r71);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r73);
} }
const _c5 = function (a0) { return { selectedValueChange: a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_component_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-component-loader", 63);
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r85.index;
    const rule_r49 = ctx_r85.$implicit;
    const ctx_r78 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "category", ctx_r78.id, ".", i_r50, "");
    i0.ɵɵproperty("componentFactoryItem", ctx_r78.dynamicRuleFieldComponent)("events", i0.ɵɵpureFunction1(5, _c5, ctx_r78.changeField.bind(ctx_r78, rule_r49, i_r50)))("data", ctx_r78.getDynamicRuleFieldData(rule_r49));
} }
const _c6 = function (a0) { return { "ex-query-builder-hide-fields": a0 }; };
const _c7 = function (a0, a1) { return { "group": a0, "key": a1 }; };
const _c8 = function (a0) { return [a0]; };
const _c9 = function (a0) { return { "key": a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_2_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 64, 65);
    i0.ɵɵlistener("selectedItemsChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_2_Template_ex_new_combobox_selectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(4); const rule_r49 = ctx_r88.$implicit; const i_r50 = ctx_r88.index; const ctx_r87 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r87.changeField(ctx_r87.asRule(rule_r49), i_r50, $event[0].key)); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r90.index;
    const rule_r49 = ctx_r90.$implicit;
    const ctx_r79 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "category", ctx_r79.id, ".", i_r50, "");
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 10, "ng.persistent-search.chooseSearchIndex"));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c6, ctx_r79.shrinkedMode || ctx_r79.viewMode))("@bgAnim", ctx_r79.getRowState(rule_r49))("full", true)("items", ctx_r79.fieldItems)("readOnly", ctx_r79.asRule(rule_r49).categoryReadOnly)("selectedItems", ctx_r79.asRule(rule_r49).group ? i0.ɵɵpureFunction1(17, _c8, i0.ɵɵpureFunction2(14, _c7, ctx_r79.asRule(rule_r49).group, ctx_r79.asRule(rule_r49).field)) : ctx_r79.groupPerItemMap && ctx_r79.groupPerItemMap[ctx_r79.asRule(rule_r49).field] ? i0.ɵɵpureFunction1(22, _c8, i0.ɵɵpureFunction2(19, _c7, ctx_r79.groupPerItemMap[ctx_r79.asRule(rule_r49).field], ctx_r79.asRule(rule_r49).field)) : i0.ɵɵpureFunction1(26, _c8, i0.ɵɵpureFunction1(24, _c9, ctx_r79.asRule(rule_r49).field)))("historyItems", ctx_r79.recentFields);
} }
const _c10 = function (a0) { return { key: a0 }; };
const _c11 = function () { return []; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_3_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 66);
    i0.ɵɵlistener("selectedItemsChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_3_Template_ex_new_combobox_selectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(4); const rule_r49 = ctx_r92.$implicit; const i_r50 = ctx_r92.index; const ctx_r91 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r91.changeOperator($event[0].key, ctx_r91.asRule(rule_r49), i_r50)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r94.index;
    const rule_r49 = ctx_r94.$implicit;
    const ctx_r80 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "operator", ctx_r80.id, ".", i_r50, "");
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(1, 8, "ng.persistent-search.selectCompareType"));
    i0.ɵɵproperty("@bgAnim", ctx_r80.getRowState(rule_r49))("hasBorder", true)("full", true)("items", ctx_r80.getOperatorsItems(ctx_r80.asRule(rule_r49).field))("selectedItems", ctx_r80.asRule(rule_r49).operator ? i0.ɵɵpureFunction1(12, _c8, i0.ɵɵpureFunction1(10, _c10, ctx_r80.asRule(rule_r49).operator)) : i0.ɵɵpureFunction0(14, _c11));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c12 = function (a0, a1, a2) { return { rule: a0, id: a1, i: a2 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 69);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(5);
    const rule_r49 = ctx_r97.$implicit;
    const i_r50 = ctx_r97.index;
    const ctx_r95 = i0.ɵɵnextContext(3);
    const _r9 = i0.ɵɵreference(16);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c12, rule_r49, ctx_r95.id, i_r50));
} }
const _c13 = function (a0) { return { "ex-query-builder-required": a0 }; };
const _c14 = function (a0, a1, a2) { return { valueChange: a0, selectedValueChange: a1, selectedValuesChange: a2 }; };
const _c15 = function (a0, a1, a2, a3, a4, a5) { return { value: a0, backgroundColor: a1, type: a2, disabled: a3, smallScreen: a4, hasMore: a5 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 67);
    i0.ɵɵelement(1, "ex-component-form-loader", 68);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_ng_container_2_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r98.index;
    const rule_r49 = ctx_r98.$implicit;
    const ctx_r81 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r81.id, ".", i_r50, "");
    i0.ɵɵproperty("ngModel", ctx_r81.asRule(rule_r49).value)("ngClass", i0.ɵɵpureFunction1(9, _c13, ctx_r81.validationRequired && !ctx_r81.smallScreen))("componentFactoryItem", ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field] == null ? null : ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field].component)("formControlName", i_r50)("events", i0.ɵɵpureFunction3(11, _c14, ctx_r81.changeInput.bind(ctx_r81, rule_r49, i_r50), ctx_r81.changeInput.bind(ctx_r81, rule_r49, i_r50), ctx_r81.changeInput.bind(ctx_r81, rule_r49, i_r50)))("data", i0.ɵɵpureFunction6(15, _c15, ctx_r81.asRule(rule_r49).value, ctx_r81.getRowColor(rule_r49), ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field] == null ? null : ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field].component.data == null ? null : ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field].component.data.type, ctx_r81.disabled, ctx_r81.smallScreen, ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field] == null ? null : ctx_r81.config.fields[ctx_r81.asRule(rule_r49).field].hasMore));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r81.smallScreen);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_editable_text_2_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-editable-text", 83);
    i0.ɵɵlistener("textChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_editable_text_2_Template_ex_editable_text_textChange_0_listener($event) { i0.ɵɵrestoreView(_r113); const rule_r49 = i0.ɵɵnextContext(6).$implicit; const ctx_r111 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r111.asRule(rule_r49).value = $event); })("ngModelChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_editable_text_2_Template_ex_editable_text_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r113); const ctx_r115 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r115.$implicit; const i_r50 = ctx_r115.index; const ctx_r114 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r114.changeInput(ctx_r114.asRule(rule_r49), i_r50, $event)); })("keyup.enter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_editable_text_2_Template_ex_editable_text_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r113); const ctx_r116 = i0.ɵɵnextContext(9); return i0.ɵɵresetView(ctx_r116.enterPlay()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r117.index;
    const rule_r49 = ctx_r117.$implicit;
    const ctx_r100 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "searchValueTextField", ctx_r100.id, ".", i_r50, "");
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 17, "ng.persistent-search.enterSearchTerm") + " - " + i0.ɵɵpipeBind1(3, 19, ctx_r100.inputsPlaceholder));
    i0.ɵɵproperty("inputId", "field" + ctx_r100.id + "." + i_r50)("formControlName", i_r50)("@bgAnim", ctx_r100.getRowState(rule_r49))("ngModel", ctx_r100.asRule(rule_r49).value)("text", ctx_r100.asRule(rule_r49).value)("disabled", ctx_r100.disabled)("placeholder", i0.ɵɵpipeBind1(1, 15, ctx_r100.inputsPlaceholder))("isMaxWidth", true)("hasBorder", false)("textAlign", "start")("ngClass", i0.ɵɵpureFunction1(21, _c13, ctx_r100.validationRequired && !ctx_r100.smallScreen));
    i0.ɵɵattribute("aria-invalid", ctx_r100.isEditableTextMarkedInvalid(ctx_r100.id, i_r50));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_template_3_ex_new_combobox_0_Template(rf, ctx) { if (rf & 1) {
    const _r122 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 85);
    i0.ɵɵlistener("selectedItemsChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_template_3_ex_new_combobox_0_Template_ex_new_combobox_selectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r122); const ctx_r121 = i0.ɵɵnextContext(7); const rule_r49 = ctx_r121.$implicit; const i_r50 = ctx_r121.index; const ctx_r120 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r120.changeInput(ctx_r120.asRule(rule_r49), i_r50, $event[0].key)); });
    i0.ɵɵpipe(1, "filterItemsByKeyList");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const comboboxType_r118 = i0.ɵɵnextContext().comboboxType;
    const ctx_r123 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r123.index;
    const rule_r49 = ctx_r123.$implicit;
    const ctx_r119 = i0.ɵɵnextContext(3);
    let tmp_5_0;
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r119.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r119.getRowState(rule_r49))("full", true)("hasBorder", true)("items", comboboxType_r118 === "boolean" ? ctx_r119.booleanValuesOptions : i0.ɵɵpipeBind2(1, 11, ctx_r119.getCategoryOptions(ctx_r119.asRule(rule_r49).field), (tmp_5_0 = rule_r49) == null ? null : tmp_5_0.filterItems))("selectedItems", ctx_r119.getComboboxSelectedItems(rule_r49))("disabled", ctx_r119.disabled)("ngClass", i0.ɵɵpureFunction1(14, _c13, ctx_r119.validationRequired && !ctx_r119.smallScreen))("allowUnlistedValues", comboboxType_r118 === "categoryWithUnListedValues");
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_template_3_ex_new_combobox_0_Template, 2, 16, "ex-new-combobox", 84);
} if (rf & 2) {
    const comboboxType_r118 = ctx.comboboxType;
    i0.ɵɵproperty("ngSwitchCase", comboboxType_r118);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_new_combobox_5_Template(rf, ctx) { if (rf & 1) {
    const _r127 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-new-combobox", 86);
    i0.ɵɵlistener("selectedItemsChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_new_combobox_5_Template_ex_new_combobox_selectedItemsChange_0_listener($event) { i0.ɵɵrestoreView(_r127); const ctx_r126 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r126.$implicit; const i_r50 = ctx_r126.index; const ctx_r125 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r125.changeInput(ctx_r125.asRule(rule_r49), i_r50, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r128.index;
    const rule_r49 = ctx_r128.$implicit;
    const ctx_r103 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r103.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r103.getRowState(rule_r49))("full", true)("items", ctx_r103.getCategoryOptions(ctx_r103.asRule(rule_r49).field))("isMultiSelect", true)("selectedItems", ctx_r103.asRule(rule_r49).value ? ctx_r103.asRule(rule_r49).value : i0.ɵɵpureFunction0(8, _c11));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_multiselect_combobox_6_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-multiselect-combobox", 87);
    i0.ɵɵlistener("endEdit", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_multiselect_combobox_6_Template_ex_multiselect_combobox_endEdit_0_listener($event) { i0.ɵɵrestoreView(_r131); const ctx_r130 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r130.$implicit; const i_r50 = ctx_r130.index; const ctx_r129 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r129.changeInput(ctx_r129.asRule(rule_r49), i_r50, $event)); })("itemRemoved", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_multiselect_combobox_6_Template_ex_multiselect_combobox_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r131); const ctx_r133 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r133.$implicit; const i_r50 = ctx_r133.index; const ctx_r132 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r132.removeItemFromInput(ctx_r132.asRule(rule_r49), i_r50, $event, true)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r134.index;
    const rule_r49 = ctx_r134.$implicit;
    const ctx_r104 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r104.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("items", ctx_r104.getCategoryOptions(ctx_r104.asRule(rule_r49).field))("selectedValues", ctx_r104.getSelectedCetegoryOptions(ctx_r104.asRule(rule_r49).field, ctx_r104.asRule(rule_r49).value))("viewMode", true)("placeholderIcon", true)("labelColor", ctx_r104.labelColor);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_date_picker_7_Template(rf, ctx) { if (rf & 1) {
    const _r137 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-date-picker", 88);
    i0.ɵɵlistener("dateChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_date_picker_7_Template_ex_date_picker_dateChange_0_listener($event) { i0.ɵɵrestoreView(_r137); const ctx_r136 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r136.$implicit; const i_r50 = ctx_r136.index; const ctx_r135 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r135.changeInput(ctx_r135.asRule(rule_r49), i_r50, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r138 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r138.index;
    const rule_r49 = ctx_r138.$implicit;
    const ctx_r105 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r105.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("date", ctx_r105.getDate(rule_r49))("@bgAnim", ctx_r105.getRowState(rule_r49))("disabled", ctx_r105.disabled)("readOnly", ctx_r105.readOnly || rule_r49.field.readOnly)("ngClass", i0.ɵɵpureFunction1(10, _c13, ctx_r105.validationRequired && !ctx_r105.smallScreen))("ngModel", ctx_r105.getDate(rule_r49))("dateFormat", ctx_r105.dateFormat);
} }
const _c16 = function (a0, a1) { return { "key": a0, "value": a1 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_autocomplete_8_Template(rf, ctx) { if (rf & 1) {
    const _r141 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-autocomplete", 89);
    i0.ɵɵlistener("selectionCleared", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_autocomplete_8_Template_ex_autocomplete_selectionCleared_0_listener($event) { i0.ɵɵrestoreView(_r141); const ctx_r140 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r140.$implicit; const i_r50 = ctx_r140.index; const ctx_r139 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r139.removeItemFromInput(ctx_r139.asRule(rule_r49), i_r50, $event, false)); })("selectedValueChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_autocomplete_8_Template_ex_autocomplete_selectedValueChange_0_listener($event) { i0.ɵɵrestoreView(_r141); const ctx_r143 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r143.$implicit; const i_r50 = ctx_r143.index; const ctx_r142 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r142.changeInput(ctx_r142.asRule(rule_r49), i_r50, $event.key)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r144 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r144.index;
    const rule_r49 = ctx_r144.$implicit;
    const ctx_r106 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r106.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r106.getRowState(rule_r49))("selectedValue", i0.ɵɵpureFunction2(11, _c16, ctx_r106.asRule(rule_r49).value, ctx_r106.asRule(rule_r49).value))("disabled", ctx_r106.disabled)("placeholder", ctx_r106.smallScreen ? ctx_r106.autoCompletePlaceholder : "")("hasMore", ctx_r106.config.fields[ctx_r106.asRule(rule_r49).field] == null ? null : ctx_r106.config.fields[ctx_r106.asRule(rule_r49).field].hasMore)("datasource", ctx_r106.config.fields[ctx_r106.asRule(rule_r49).field] == null ? null : ctx_r106.config.fields[ctx_r106.asRule(rule_r49).field].dataSource)("forceSelectionFromList", false)("ngClass", i0.ɵɵpureFunction1(14, _c13, ctx_r106.validationRequired && !ctx_r106.smallScreen));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_9_Template(rf, ctx) { if (rf & 1) {
    const _r147 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 90);
    i0.ɵɵlistener("ngModelChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_9_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r147); const ctx_r146 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r146.$implicit; const i_r50 = ctx_r146.index; const ctx_r145 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r145.changeInput(ctx_r145.asRule(rule_r49), i_r50, $event)); })("keyup.enter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_9_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r147); const ctx_r148 = i0.ɵɵnextContext(9); return i0.ɵɵresetView(ctx_r148.enterPlay()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r149 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r149.index;
    const rule_r49 = ctx_r149.$implicit;
    const ctx_r107 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r107.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r107.getRowState(rule_r49))("ngModel", ctx_r107.asRule(rule_r49).value)("disabled", ctx_r107.disabled)("placeholder", i0.ɵɵpipeBind1(1, 10, ctx_r107.inputsPlaceholder))("disabled", ctx_r107.disabled)("ngClass", i0.ɵɵpureFunction1(14, _c13, ctx_r107.validationRequired && !ctx_r107.smallScreen));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 12, "ng.ex-query-builder.enter_edit_value"));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_10_Template(rf, ctx) { if (rf & 1) {
    const _r152 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 91);
    i0.ɵɵlistener("ngModelChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_10_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r152); const ctx_r151 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r151.$implicit; const i_r50 = ctx_r151.index; const ctx_r150 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r150.changeInput(ctx_r150.asRule(rule_r49), i_r50, $event)); })("keyup.enter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_10_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r152); const ctx_r153 = i0.ɵɵnextContext(9); return i0.ɵɵresetView(ctx_r153.enterPlay()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r154 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r154.index;
    const rule_r49 = ctx_r154.$implicit;
    const ctx_r108 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r108.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r108.getRowState(rule_r49))("min", 0)("placeholder", i0.ɵɵpipeBind1(1, 10, ctx_r108.inputsPlaceholder))("ngModel", ctx_r108.asRule(rule_r49).value)("disabled", ctx_r108.disabled)("ngClass", i0.ɵɵpureFunction1(14, _c13, ctx_r108.validationRequired && !ctx_r108.smallScreen));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 12, "ng.query-builder.enter_edit_value"));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_11_Template(rf, ctx) { if (rf & 1) {
    const _r157 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 92);
    i0.ɵɵlistener("ngModelChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_11_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r157); const ctx_r156 = i0.ɵɵnextContext(6); const rule_r49 = ctx_r156.$implicit; const i_r50 = ctx_r156.index; const ctx_r155 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r155.changeInput(ctx_r155.asRule(rule_r49), i_r50, $event)); })("keyup.enter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_11_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r157); const ctx_r158 = i0.ɵɵnextContext(9); return i0.ɵɵresetView(ctx_r158.enterPlay()); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r159 = i0.ɵɵnextContext(6);
    const i_r50 = ctx_r159.index;
    const rule_r49 = ctx_r159.$implicit;
    const ctx_r109 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "field", ctx_r109.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("@bgAnim", ctx_r109.getRowState(rule_r49))("ngModel", ctx_r109.asRule(rule_r49).value)("disabled", ctx_r109.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 7, "ng.ex-query-builder.enter_edit_value"));
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_container_12_ng_container_1_Template, 1, 0, "ng-container", 69);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r161 = i0.ɵɵnextContext(6);
    const rule_r49 = ctx_r161.$implicit;
    const i_r50 = ctx_r161.index;
    const ctx_r110 = i0.ɵɵnextContext(3);
    const _r9 = i0.ɵɵreference(16);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c12, rule_r49, ctx_r110.id, i_r50));
} }
const _c17 = function (a0) { return { comboboxType: a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 71);
    i0.ɵɵelementStart(1, "span", 72);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_editable_text_2_Template, 4, 23, "ex-editable-text", 73);
    i0.ɵɵtemplate(3, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_template_3_Template, 1, 1, "ng-template", 74, 75, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_new_combobox_5_Template, 1, 9, "ex-new-combobox", 76);
    i0.ɵɵtemplate(6, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_multiselect_combobox_6_Template, 1, 8, "ex-multiselect-combobox", 77);
    i0.ɵɵtemplate(7, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_date_picker_7_Template, 1, 12, "ex-date-picker", 78);
    i0.ɵɵtemplate(8, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ex_autocomplete_8_Template, 1, 16, "ex-autocomplete", 79);
    i0.ɵɵtemplate(9, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_9_Template, 3, 16, "input", 80);
    i0.ɵɵtemplate(10, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_10_Template, 3, 16, "input", 81);
    i0.ɵɵtemplate(11, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_input_11_Template, 2, 9, "input", 82);
    i0.ɵɵtemplate(12, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_ng_container_12_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r101 = i0.ɵɵreference(4);
    const rule_r49 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngSwitch", ctx_r99.getInputType(ctx_r99.asRule(rule_r49).field, ctx_r99.asRule(rule_r49).operator));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "string");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r101)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c17, ctx_r99.getComboboxType(rule_r49)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "multiSelect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "tags");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "date");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "autocomplete");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "number");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "positiveNumber");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r99.smallScreen);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_ng_container_0_Template, 13, 13, "ng-container", 70);
} if (rf & 2) {
    const ctx_r163 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r163.index;
    const rule_r49 = ctx_r163.$implicit;
    const ctx_r83 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r83.refreshFiledIndex !== i_r50 && !ctx_r83.shrinkedMode && !ctx_r83.viewMode && !ctx_r83.getIsDisabledInput(ctx_r83.asRule(rule_r49).operator) && (ctx_r83.config.fields[ctx_r83.asRule(rule_r49).field] == null ? null : ctx_r83.config.fields[ctx_r83.asRule(rule_r49).field].type) != "compositeSearch");
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_view_mode_7_Template(rf, ctx) { if (rf & 1) {
    const _r166 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "view-mode", 93);
    i0.ɵɵlistener("ruleClicked", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_view_mode_7_Template_view_mode_ruleClicked_0_listener() { i0.ɵɵrestoreView(_r166); const i_r50 = i0.ɵɵnextContext(4).index; const ctx_r164 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r164.shrinkedModeRuleClicked(i_r50)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r167 = i0.ɵɵnextContext(4);
    const i_r50 = ctx_r167.index;
    const rule_r49 = ctx_r167.$implicit;
    const ctx_r84 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "view-mode", ctx_r84.id, ".", i_r50, "");
    i0.ɵɵproperty("rule", rule_r49)("config", ctx_r84.config)("viewMode", ctx_r84.viewMode)("@bgAnim", ctx_r84.getRowState(rule_r49))("backgroundColor", ctx_r84.getRowColor(rule_r49))("smallScreen", ctx_r84.smallScreen);
} }
const _c18 = function (a0, a1, a2, a3) { return [a0, a1, a2, a3]; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_component_loader_1_Template, 1, 7, "ex-component-loader", 57);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_2_Template, 3, 28, "ex-new-combobox", 58);
    i0.ɵɵtemplate(3, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ex_new_combobox_3_Template, 2, 15, "ex-new-combobox", 59);
    i0.ɵɵtemplate(4, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_span_4_Template, 3, 22, "span", 60);
    i0.ɵɵtemplate(5, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_ng_template_5_Template, 1, 1, "ng-template", null, 61, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_view_mode_7_Template, 1, 8, "view-mode", 62);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r82 = i0.ɵɵreference(6);
    const ctx_r168 = i0.ɵɵnextContext(3);
    const rule_r49 = ctx_r168.$implicit;
    const i_r50 = ctx_r168.index;
    const ctx_r72 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@bgAnim", ctx_r72.getSmallScreenRowState(rule_r49))("ngClass", i0.ɵɵpureFunction4(8, _c18, ctx_r72.smallScreen ? "ex-query-builder-row-inputs-small" : "ex-query-builder-row-inputs", ctx_r72.validationRequired && ctx_r72.smallScreen ? "ex-query-builder-required" : "", ctx_r72.getControl(i_r50) != undefined && (ctx_r72.getControl(i_r50).valid === false && ctx_r72.getControl(i_r50).touched || ctx_r72.getControl(i_r50).valid === false && ctx_r72.isPlayClicked.value == true && !ctx_r72.qbForm.valid) ? "ng-touched" : "", ctx_r72.getControl(i_r50) != undefined && (ctx_r72.getControl(i_r50).valid === false && ctx_r72.getControl(i_r50).touched || ctx_r72.getControl(i_r50).valid === false && ctx_r72.isPlayClicked.value == true && !ctx_r72.qbForm.valid && !ctx_r72.shrinkedMode) ? "ng-invalid" : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.isDynamicRuleField);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r72.isDynamicRuleField);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r72.shrinkedMode && !ctx_r72.viewMode && !ctx_r72.FIELDS_WITHOUT_OPERATOR.includes(ctx_r72.asRule(rule_r49).field) && ctx_r72.getInputType(ctx_r72.asRule(rule_r49).field, ctx_r72.asRule(rule_r49).operator) !== "boolean" && (ctx_r72.config.fields[ctx_r72.asRule(rule_r49).field] == null ? null : ctx_r72.config.fields[ctx_r72.asRule(rule_r49).field].type) != "compositeSearch");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r72.config.fields[ctx_r72.asRule(rule_r49).field] == null ? null : ctx_r72.config.fields[ctx_r72.asRule(rule_r49).field].componentType) === "dynamic" && !ctx_r72.shrinkedMode && !ctx_r72.viewMode)("ngIfElse", _r82);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r72.shrinkedMode || ctx_r72.viewMode);
} }
const _c19 = function (a0) { return { "ex-query-builder-action-button-small": a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r177 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 100);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r177); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r175 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r175.markPlaceHolder({ relativeLoc: "next" }, i_r50)); })("mouseleave", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r177); const ctx_r178 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r178.markPlaceHolder({ reset: true })); })("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r177); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r179 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r179.addRule(i_r50)); })("keydown.enter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template_button_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r177); const ctx_r181 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r181.isKeypress = true); });
    i0.ɵɵelement(1, "ex-svg-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(5).index;
    const ctx_r170 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "addRule", ctx_r170.id, ".", i_r50, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c19, ctx_r170.smallScreen))("exTooltip", ctx_r170.translations.addRule)("disabled", ctx_r170.disabled);
    i0.ɵɵattribute("aria-label", ctx_r170.translations.addRule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 101);
    i0.ɵɵlistener("focusout", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template_button_focusout_0_listener() { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(8); return i0.ɵɵresetView((!!ctx_r183.parentValue || ctx_r183.data.rules.length > 1) && !ctx_r183.shrinkedMode && !ctx_r183.viewMode ? null : ctx_r183.hoveredRule = -1); })("mouseenter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r184); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r185 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r185.markPlaceHolder({ relativeLoc: "next" }, i_r50)); })("mouseleave", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r184); const ctx_r187 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r187.markPlaceHolder({ reset: true })); })("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r184); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r188 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r188.copyRule(i_r50)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-svg-icon", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(5).index;
    const ctx_r171 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "copyRule", ctx_r171.id, ".", i_r50, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 6, "ng.general.duplicate-rule"))("disabled", ctx_r171.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 8, "ng.general.duplicate-rule"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 102);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "json");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "ex-svg-icon", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(5).index;
    const ctx_r172 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "copyRuleToClipboard", ctx_r172.id, ".", i_r50, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 7, "ng.general.copy-rule"))("cdkCopyToClipboard", i0.ɵɵpipeBind1(2, 9, ctx_r172.data.rules[i_r50]))("disabled", ctx_r172.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 11, "ng.general.copy-rule"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r193 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 101);
    i0.ɵɵlistener("focusout", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template_button_focusout_0_listener() { i0.ɵɵrestoreView(_r193); const ctx_r192 = i0.ɵɵnextContext(8); return i0.ɵɵresetView((!!ctx_r192.parentValue || ctx_r192.data.rules.length > 1) && !ctx_r192.shrinkedMode && !ctx_r192.viewMode ? null : ctx_r192.hoveredRule = -1); })("mouseenter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r193); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r194 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r194.markPlaceHolder({ relativeLoc: "next" }, i_r50)); })("mouseleave", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r193); const ctx_r196 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r196.markPlaceHolder({ reset: true })); })("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r193); const i_r50 = i0.ɵɵnextContext(5).index; const ctx_r197 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r197.pasteRule(i_r50)); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "ex-svg-icon", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(5).index;
    const ctx_r173 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "pasteRule", ctx_r173.id, ".", i_r50, "");
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 6, "ng.general.paste"))("disabled", ctx_r173.disabled);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 8, "ng.general.paste"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("useThemeColor", true);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r201 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 103);
    i0.ɵɵlistener("focusout", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_5_Template_button_focusout_0_listener() { i0.ɵɵrestoreView(_r201); const ctx_r200 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r200.hoveredRule = -1); })("click", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r201); const ctx_r203 = i0.ɵɵnextContext(5); const rule_r49 = ctx_r203.$implicit; const i_r50 = ctx_r203.index; const ctx_r202 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r202.removeRule(ctx_r202.asRule(rule_r49), ctx_r202.data, i_r50)); });
    i0.ɵɵelement(1, "ex-svg-icon", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(5).index;
    const ctx_r174 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "removeRule", ctx_r174.id, ".", i_r50, "");
    i0.ɵɵproperty("exTooltip", ctx_r174.translations.removeRule)("disabled", ctx_r174.disabled);
    i0.ɵɵattribute("aria-label", ctx_r174.translations.removeRule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("useThemeColor", true);
} }
const _c20 = function (a0) { return { "ex-query-builder-row-actions-small": a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 95);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_1_Template, 2, 9, "button", 96);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_2_Template, 4, 10, "button", 97);
    i0.ɵɵtemplate(3, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_3_Template, 5, 13, "button", 98);
    i0.ɵɵtemplate(4, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_4_Template, 4, 10, "button", 97);
    i0.ɵɵtemplate(5, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_button_5_Template, 2, 6, "button", 99);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r50 = i0.ɵɵnextContext(4).index;
    const ctx_r169 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@fade", ctx_r169.hoveredRule === i_r50)("ngClass", i0.ɵɵpureFunction1(7, _c20, ctx_r169.smallScreen));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r169.shrinkedMode && !ctx_r169.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r169.shrinkedMode && !ctx_r169.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r169.shrinkedMode && !ctx_r169.viewMode && ctx_r169.allowCopyPaste);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r169.shrinkedMode && !ctx_r169.viewMode && ctx_r169.allowCopyPaste);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!!ctx_r169.parentValue || ctx_r169.data.rules.length > ctx_r169.minRules) && !ctx_r169.shrinkedMode && !ctx_r169.viewMode);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_div_0_Template, 6, 9, "div", 94);
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngIf", ctx_r74.allowRowActions);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 69);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r207 = i0.ɵɵnextContext(3);
    const rule_r49 = ctx_r207.$implicit;
    const i_r50 = ctx_r207.index;
    const ctx_r75 = i0.ɵɵnextContext(3);
    const _r9 = i0.ɵɵreference(16);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c12, rule_r49, ctx_r75.id, i_r50));
} }
const _c21 = function (a0) { return { "ex-query-builder-small": a0 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r209 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵlistener("mouseenter", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_Template_div_mouseenter_1_listener() { i0.ɵɵrestoreView(_r209); const i_r50 = i0.ɵɵnextContext(2).index; const ctx_r208 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r208.hoveredRule = i_r50); })("focusin", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_Template_div_focusin_1_listener() { i0.ɵɵrestoreView(_r209); const i_r50 = i0.ɵɵnextContext(2).index; const ctx_r211 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r211.hoveredRule = i_r50); })("mouseleave", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_Template_div_mouseleave_1_listener() { i0.ɵɵrestoreView(_r209); const ctx_r213 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r213.hoveredRule = -1); });
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_div_2_Template, 3, 2, "div", 50);
    i0.ɵɵtemplate(3, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_div_3_Template, 3, 2, "div", 51);
    i0.ɵɵtemplate(4, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_4_Template, 8, 13, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_template_6_Template, 1, 1, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_ng_container_8_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c21, ctx_r56.smallScreen));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r56.parentValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r56.parentValue);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r56.smallScreen);
} }
const _c22 = function (a1) { return { allowEmptyRulesets: false, fields: a1 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template(rf, ctx) { if (rf & 1) {
    const _r216 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-query-builder-composite-type", 104);
    i0.ɵɵlistener("selfOperatorChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template_ex_query_builder_composite_type_selfOperatorChange_0_listener($event) { i0.ɵɵrestoreView(_r216); const rule_r49 = i0.ɵɵnextContext(2).$implicit; const ctx_r214 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r214.asRule(rule_r49).operator = $event); })("ngModelChange", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template_ex_query_builder_composite_type_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r216); const ctx_r218 = i0.ɵɵnextContext(2); const rule_r49 = ctx_r218.$implicit; const i_r50 = ctx_r218.index; const ctx_r217 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r217.changeInput(ctx_r217.asRule(rule_r49), i_r50, $event)); })("playClicked", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template_ex_query_builder_composite_type_playClicked_0_listener($event) { i0.ɵɵrestoreView(_r216); const ctx_r219 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r219.playClicked.emit($event)); })("markPlaceholderInd", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template_ex_query_builder_composite_type_markPlaceholderInd_0_listener($event) { i0.ɵɵrestoreView(_r216); const i_r50 = i0.ɵɵnextContext(2).index; const ctx_r220 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r220.markPlaceHolder($event, i_r50)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r222 = i0.ɵɵnextContext(2);
    const i_r50 = ctx_r222.index;
    const rule_r49 = ctx_r222.$implicit;
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r57.id, ".", i_r50, "");
    i0.ɵɵproperty("selfOperator", ctx_r57.asRule(rule_r49).operator)("formControlName", i_r50)("config", i0.ɵɵpureFunction1(21, _c22, ctx_r57.config.fields[ctx_r57.asRule(rule_r49).field].innerfields))("ngModel", ctx_r57.asRule(rule_r49).value)("disabled", ctx_r57.disabled)("isPlayHovered", ctx_r57.isPlayHovered)("isPlayClicked", ctx_r57.isPlayClicked)("smallScreen", ctx_r57.smallScreen)("translations", ctx_r57.translations)("parentForm", ctx_r57.qbForm)("parentValue", ctx_r57.data)("operatorMap", ctx_r57.operatorMap)("isTriggerByEnter", ctx_r57.isTriggerByEnter)("shrinkedMode", ctx_r57.shrinkedMode)("viewMode", ctx_r57.viewMode)("showRunBtn", !ctx_r57.showOnlyTopRunBtn && ctx_r57.showRunBtn)("index", ctx_r57.index + "." + i_r50)("level", ctx_r57.level + 1)("operatorsWithoutInputField", ctx_r57.operatorsWithoutInputField);
} }
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_9_Template(rf, ctx) { if (rf & 1) {
    const _r224 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-query-builder", 105);
    i0.ɵɵlistener("playClicked", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_9_Template_ex_query_builder_playClicked_0_listener($event) { i0.ɵɵrestoreView(_r224); const ctx_r223 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r223.playClicked.emit($event)); })("markPlaceholderInd", function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_9_Template_ex_query_builder_markPlaceholderInd_0_listener($event) { i0.ɵɵrestoreView(_r224); const i_r50 = i0.ɵɵnextContext(2).index; const ctx_r225 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r225.markPlaceHolder($event, i_r50)); });
    i0.ɵɵpipe(1, "exqbForm");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r227 = i0.ɵɵnextContext(2);
    const i_r50 = ctx_r227.index;
    const rule_r49 = ctx_r227.$implicit;
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r58.id, ".", i_r50, "");
    i0.ɵɵproperty("formControlName", i_r50)("data", ctx_r58.asRuleSet(rule_r49))("disabled", ctx_r58.disabled)("allowCopyRuleset", ctx_r58.allowCopyRuleset)("allowCopyPaste", ctx_r58.allowCopyPaste)("isPlayHovered", ctx_r58.isPlayHovered)("isPlayClicked", ctx_r58.isPlayClicked)("smallScreen", ctx_r58.smallScreen)("formControl", i0.ɵɵpipeBind1(1, 29, rule_r49))("parentTouchedCallback", ctx_r58.parentTouchedCallback || ctx_r58.onTouchedCallback)("translations", ctx_r58.translations)("parentChangeCallback", ctx_r58.parentChangeCallback || ctx_r58.onChangeCallback)("parentValue", ctx_r58.data)("parentForm", ctx_r58.qbForm)("config", ctx_r58.config)("allowRuleset", ctx_r58.allowRuleset)("operatorMap", ctx_r58.operatorMap)("shrinkedMode", ctx_r58.shrinkedMode)("viewMode", ctx_r58.viewMode)("showRunBtn", !ctx_r58.showOnlyTopRunBtn && ctx_r58.showRunBtn)("conditionIsDisabled", ctx_r58.conditionIsDisabled)("index", ctx_r58.index + "." + i_r50)("dynamicRuleFieldComponent", ctx_r58.dynamicRuleFieldComponent)("isDynamicRuleField", ctx_r58.isDynamicRuleField)("level", ctx_r58.level + 1)("maxLevels", ctx_r58.maxLevels)("operatorsWithoutInputField", ctx_r58.operatorsWithoutInputField);
} }
const _c23 = function (a0, a1) { return { "margin-top": a0, "margin-bottom": a1 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 34);
    i0.ɵɵpipe(2, "exClassNameFormat");
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtemplate(4, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_div_4_Template, 3, 1, "div", 36);
    i0.ɵɵtemplate(5, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_span_5_Template, 2, 3, "span", 37);
    i0.ɵɵtemplate(6, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_6_Template, 3, 2, "ng-container", 6);
    i0.ɵɵtemplate(7, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ng_container_7_Template, 9, 6, "ng-container", 6);
    i0.ɵɵtemplate(8, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_composite_type_8_Template, 1, 23, "ex-query-builder-composite-type", 38);
    i0.ɵɵtemplate(9, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_ex_query_builder_9_Template, 2, 31, "ex-query-builder", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const local_r52 = ctx.ngIf;
    const ctx_r228 = i0.ɵɵnextContext();
    const rule_r49 = ctx_r228.$implicit;
    const i_r50 = ctx_r228.index;
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("hide", rule_r49.isHide);
    i0.ɵɵproperty("@rowAnim", undefined)("ngClass", i0.ɵɵpipeBind1(2, 11, "ex-query-builder-row-" + rule_r49.field));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(13, _c23, local_r52.ruleset ? ctx_r51.viewMode ? "10px" : "40px" : "0px", local_r52.ruleset && i_r50 !== ctx_r51.data.rules.length - 1 ? "30px" : "0px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r50 !== 0 && ctx_r51.isRuleSetLogicallyConnected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", local_r52.ruleset);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r50 === ctx_r51.placeholderInd && i_r50 !== ctx_r51.data.rules.length - 1 && !ctx_r51.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !local_r52.ruleset);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", local_r52.type == "compositeSearch");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", local_r52.ruleset);
} }
const _c24 = function (a0, a1, a2) { return { ruleset: a0, invalid: a1, type: a2 }; };
function ExQueryBuilderComponent_div_12_ul_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_ng_container_1_Template, 10, 16, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const rule_r49 = ctx.$implicit;
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r48.getControlSize() == ctx_r48.data.rules.length && i0.ɵɵpureFunction3(1, _c24, !!ctx_r48.asRuleSet(rule_r49).rules, !ctx_r48.config.allowEmptyRulesets && ctx_r48.asRuleSet(rule_r49).rules && ctx_r48.asRuleSet(rule_r49).rules.length === 0, ctx_r48.config.fields[ctx_r48.asRule(rule_r49).field] == null ? null : ctx_r48.config.fields[ctx_r48.asRule(rule_r49).field].type));
} }
function ExQueryBuilderComponent_div_12_ul_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 29);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ul_4_ng_container_1_Template, 2, 5, "ng-container", 30);
    i0.ɵɵelementStart(2, "span", 31)(3, "span", 32)(4, "span", 33);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 33);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 33);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r36.data.rules);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "ng.query-builder.searchIndex"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 6, "ng.query-builder.compareType"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 8, "ng.query-builder.searchValue"));
} }
function ExQueryBuilderComponent_div_12_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 106)(1, "span", 107);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r37.translations.emptyMessage);
} }
function ExQueryBuilderComponent_div_12_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 106);
    i0.ɵɵelement(1, "ex-spinner", 108);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("diameter", 20);
} }
function ExQueryBuilderComponent_div_12_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 111)(1, "span", 46);
    i0.ɵɵtext(2, "\u25E4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 47);
    i0.ɵɵtext(4, "\u25E4");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵproperty("@fade", undefined);
} }
function ExQueryBuilderComponent_div_12_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 112);
} if (rf & 2) {
    i0.ɵɵproperty("@fade", undefined);
} }
function ExQueryBuilderComponent_div_12_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ExQueryBuilderComponent_div_12_ng_container_7_div_1_Template, 5, 1, "div", 109);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_ng_container_7_div_2_Template, 1, 1, "div", 110);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.addGroupHovered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.addGroupHovered);
} }
const _c25 = function (a0) { return { "margin-top": a0 }; };
const _c26 = function (a0) { return { "playClicked": a0 }; };
function ExQueryBuilderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 22);
    i0.ɵɵtemplate(2, ExQueryBuilderComponent_div_12_div_2_Template, 3, 7, "div", 23);
    i0.ɵɵtemplate(3, ExQueryBuilderComponent_div_12_span_3_Template, 1, 3, "span", 24);
    i0.ɵɵtemplate(4, ExQueryBuilderComponent_div_12_ul_4_Template, 13, 10, "ul", 25);
    i0.ɵɵtemplate(5, ExQueryBuilderComponent_div_12_div_5_Template, 3, 1, "div", 26);
    i0.ɵɵtemplate(6, ExQueryBuilderComponent_div_12_div_6_Template, 2, 1, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ExQueryBuilderComponent_div_12_ng_container_7_Template, 3, 2, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("smallMode", ctx_r8.smallScreen)("fullScreenMode", !ctx_r8.smallScreen);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(13, _c25, !ctx_r8.parentValue ? "20px" : "0px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r8.qbForm)("ngClass", i0.ɵɵpureFunction1(15, _c26, ctx_r8.isPlayClicked.value == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isRuleSetLogicallyConnected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isRuleSetLogicallyConnected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.configLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.data.rules || ctx_r8.data.rules.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.configLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.placeholderInd !== -1 && ctx_r8.data.rules.length - 1 === ctx_r8.placeholderInd && !ctx_r8.viewMode);
} }
function ExQueryBuilderComponent_ng_template_15_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114)(1, "span", 115);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 116);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r235 = i0.ɵɵnextContext();
    const id_r232 = ctx_r235.id;
    const i_r233 = ctx_r235.i;
    const rule_r231 = ctx_r235.rule;
    i0.ɵɵpropertyInterpolate2("id", "warning", id_r232, ".", i_r233, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "ng.query-builder.validation.errorInRow") + " " + (i_r233 + 1) + ": " + (id_r232 === "advSearch" ? i0.ɵɵpipeBind1(4, 6, "ng.query-builder.searchValue") : "") + " - " + i0.ɵɵpipeBind1(5, 8, rule_r231.validationErrorMessage));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 10, rule_r231.validationErrorMessage), "");
} }
function ExQueryBuilderComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ExQueryBuilderComponent_ng_template_15_div_0_Template, 9, 12, "div", 113);
} if (rf & 2) {
    const i_r233 = ctx.i;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.getControl(i_r233) != undefined && (ctx_r10.getControl(i_r233).valid === false && ctx_r10.getControl(i_r233).touched || ctx_r10.getControl(i_r233).valid === false && ctx_r10.isPlayClicked.value == true && !ctx_r10.qbForm.valid && !ctx_r10.shrinkedMode));
} }
const _c27 = [[["", "under", ""]]];
const _c28 = function (a0) { return { "ex-query-builder-not-clickable": a0 }; };
const _c29 = function (a0) { return { "ex-query-builder-hide": a0 }; };
const _c30 = function (a1) { return { value: "and", label: a1 }; };
const _c31 = function (a1) { return { value: "or", label: a1 }; };
const _c32 = function (a0, a1) { return [a0, a1]; };
const _c33 = ["[under]"];
const CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ExQueryBuilderComponent),
    multi: true
};
const VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ExQueryBuilderComponent),
    multi: true
};
class ExQueryBuilderComponent {
    get booleanValuesOptions() {
        return this._booleanValuesOptions;
    }
    set booleanValuesOptions(values) {
        this._booleanValuesOptions = values ?? this._booleanValuesOptions;
    }
    constructor(changeDetectorRef, formBuilder, http, translate, clipboard, featureFlag) {
        this.changeDetectorRef = changeDetectorRef;
        this.formBuilder = formBuilder;
        this.http = http;
        this.translate = translate;
        this.clipboard = clipboard;
        this.featureFlag = featureFlag;
        this.isToggleVisible = false;
        this.isToggleHovered = false;
        this.hoveredRule = -1;
        this.placeholderInd = -1;
        this.addGroupHovered = false;
        this.refreshFiledIndex = -1;
        this.queryBuilderInvalidInputs = new Set();
        this.shouldFilterDateOperators = false;
        this.labelColor = '#2a7068';
        this.labelDefaults = { color: this.labelColor };
        this.DYNAMIC_FIELDS = ['language', 'binding', 'booktypename', 'pubcountry', 'genre', 'areastudies', 'ebook_license', 'ebook_platform', 'readership_flat', 'geographicarea', 'flexbrowse', 'deweybrowse', 'collectionbrowse', 'nlmbrowse', 'subject', 'award_result'];
        this.FIELDS_WITHOUT_OPERATOR = ['expanded_treatment_flat'];
        this.id = "1";
        this.validationRequired = true;
        /*
        * this three inputs are not supposed to be used they are
        * used internally for each query builder to pass it to its child (recursion structure)
        */
        this.isPlayHovered = false;
        this.isPlayClicked = { value: false, timestamp: null };
        this.level = 1;
        this.smallScreen = false;
        this.allowAddRoles = true;
        this.allowRowActions = true;
        this.isRuleSetLogicallyConnected = true;
        this.needToBeColored = false;
        this.defaultOperatorMap = {
            string: ['=', '!='],
            number: ['=', '>', '>=', '<', '<='],
            date: ['=', '>', '>=', '<', '<='],
            category: ['=', '!=', 'in', 'not in'],
            boolean: ['=']
        };
        /**
         * the data for the query builder
         * i.e. the query - each time the query will be changed it will change it also outside (two way binding)
         */
        this.data = { condition: 'and', rules: [] };
        /**
         * the translations for the query builder
         */
        this.translations = {
            addRule: 'Add rule',
            copyRule: 'Copy rule',
            removeRule: 'Remove rule',
            addGroup: 'Add group',
            removeGroup: 'Remove group',
            copyGroup: 'Copy group',
            and: 'AND',
            or: 'OR',
            play: 'Play',
            emptyMessage: 'A ruleset cannot be empty. Please add a rule or remove it all together.'
        };
        this._booleanValuesOptions = [
            { key: 'true', value: 'Include' },
            { key: 'false', value: 'Exclude' }
        ];
        /**
         * whether the rule set are allowed or not
         */
        this.allowRuleset = true;
        /**
         * whether it be possible to duplicate ruleSet
         */
        this.allowCopyRuleset = false;
        /**
         * whether it be possible to copy and paste rules/groups
         */
        this.allowCopyPaste = false;
        /**
         * Max levels of grouping
         */
        this.maxLevels = 10;
        /**
         * Minimum rules (the user is required to have at least minRules rules)
         */
        this.minRules = 1;
        /**
         * the schema configuration - fields - operators etc
         */
        this.config = { fields: [] };
        /**
         * indicates if to display QB in view or edit mode
         */
        this.viewMode = false;
        this.inputsPlaceholder = 'ng.general.enter_value';
        this.conditionIsDisabled = false;
        this.shrinkedMode = false;
        this.showRunBtn = true;
        /**
         * Display run button only on main query and not in the children
         */
        this.showOnlyTopRunBtn = false;
        this.isDynamicRuleField = false;
        this.dynamicRuleFieldEvents = "{selectedValueChange: changeField.bind(this, rule, i)}";
        this.operatorsWithoutInputField = [];
        this.shrinkedModeChange = new EventEmitter();
        this.configLoading = false;
        this.recentFields = [];
        this.dateFormat = "dd/MM/yyyy";
        /**
         * A way to skip validation to the QB instead of the original.
         */
        this.externalValidation = false;
        /**
         * an event fired whenever the play button is clicked it will pass the sub query on which the play was clicked
         */
        this.playClicked = new EventEmitter();
        this.indexSelected = new EventEmitter();
        /**
         * mark external placeHolder onMouseHover
         */
        this.markPlaceholderInd = new EventEmitter();
        this.readOnly = false;
        this.defaultEmptyList = [];
        this.levelsCounter = 1;
        this.isKeypress = false;
        this.index = '1';
        // ----------END----------
        this.getDisabledState = () => {
            return this.disabled;
        };
        this.autoCompletePlaceholder = this.translate.instant('ex-ui.ex-autocompelte.look_up_or_select');
    }
    ngOnInit() {
        if (this.qbForm === undefined) { // prevents overriding input form
            this.initForm();
        }
        if (!!this.play$) {
            this.playSubscription = this.play$.pipe(debounceTime(500)).subscribe(() => this.play());
        }
        if (!!this.validate$) {
            this.validateSubscription = this.validate$.pipe(debounceTime(500)).subscribe(() => this.validateAndWarn());
        }
        this.featureFlag?.isActive("UI_INFRA_RELATIVE_DATES_OPERATOR").subscribe((isActive) => {
            this.shouldFilterDateOperators = !isActive;
        });
        this.init();
    }
    //override in child class
    init() {
        return;
    }
    ngOnDestroy() {
        this.playSubscription?.unsubscribe();
        this.validateSubscription?.unsubscribe();
        this.destroy();
    }
    //override in child class
    destroy() {
        return;
    }
    initForm() {
        this.qbForm = new UntypedFormGroup({
            'fields': new UntypedFormArray([])
        });
        if (this.parentForm != undefined) {
            let index = this.parentValue.rules.findIndex((r) => r === this.data);
            if (index < 0) {
                console.error("cannot find the father value");
            }
            this.parentForm.get('fields').controls[index]?.setErrors(this.qbForm.valid ? null : { 'incorrect': !this.qbForm.valid });
        }
    }
    ngAfterViewInit() {
        this.toggleElementRef = { nativeElement: document.querySelector('ex-toggle input:first-of-type') };
        this.connectionToggleElementRef = { nativeElement: document.querySelector('#connectionToggleBtn') };
    }
    // ----------OnChanges Implementation----------
    ngOnChanges(changes) {
        const config = this.config;
        const type = typeof config;
        if (changes.config) {
            if (type === 'object') {
                this.fields = Object.keys(config.fields).map((key) => {
                    const field = config.fields[key];
                    field.key = field.key || key;
                    return field;
                });
                const hasGroup = Object.values(this.fields)[0].group ? true : false;
                var currentGroup = "";
                if (hasGroup) {
                    this.fieldItems = Object.values(this.fields.reduce(function (r, a) {
                        r[a.group] = r[a.group] || { key: a.group, value: a.group, subItems: [] };
                        r[a.group].subItems.push({ key: a.key, value: a.value });
                        return r;
                    }, Object.create(null))).map((group) => {
                        return group;
                    });
                    this.groupPerItemMap = [];
                    this.fields.forEach((field) => {
                        this.groupPerItemMap[field.key] = field.group;
                    });
                }
                else {
                    this.fieldItems = this.fields.map(({ key, value }) => {
                        return { key: key, value: value };
                    });
                }
                this.operatorsCache = {};
                this.operatorsCacheItems = {};
                this.categoryOptionsCache = {};
            }
            else {
                throw new Error(`Expected 'config' must be a valid object, got ${type} instead.`);
            }
        }
        if (changes.isPlayClicked) {
            if (this.needToBeColored) {
                const date = new Date();
                this.isPlayClicked = { value: true, timestamp: date.getTime() };
                this.needToBeColored = false;
            }
        }
    }
    // ----------Validator Implementation----------
    validate(control) {
        this.updateValueAndValidity();
        return this.qbForm.valid ? null : { 'incorrect': !this.qbForm.valid };
    }
    createFilledInputValidator() {
        return (control) => {
            let validationResponse = { validateField: { valid: false } };
            let fieldValue = control.value;
            if (fieldValue != null) {
                if (Array.isArray(fieldValue)) {
                    validationResponse = fieldValue.length > 0 ? null : validationResponse;
                }
                else if (typeof (fieldValue) === 'object') {
                    validationResponse = fieldValue?.item != undefined || fieldValue?.key != undefined ? null : validationResponse;
                }
                else if (typeof (fieldValue) === 'string') {
                    validationResponse = fieldValue.trim().length != 0 ? null : validationResponse;
                }
                else {
                    validationResponse = null;
                }
            }
            return validationResponse;
        };
    }
    // ----------ControlValueAccessor Implementation----------
    get value() {
        return this.data;
    }
    set value(value) {
        // When component is initialized without a formControl, null is passed to value
        this.data = value || { condition: 'and', rules: [] };
        this.initForm();
        this.handleDataChange(true, this.data.rules ?? this.data[0].rules);
    }
    writeValue(obj) {
        if (obj == null)
            return;
        this.value = obj;
    }
    registerOnChange(fn) {
        this.onChangeCallback = () => fn(this.data);
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = () => fn(this.data);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.detectChanges();
    }
    getRule(role) {
        return role;
    }
    getOperators(field) {
        if (this.operatorsCache[field]) {
            return this.operatorsCache[field];
        }
        let operators = this.defaultEmptyList;
        const fieldObject = this.config.fields[field];
        const type = fieldObject.type;
        if (fieldObject && fieldObject.type === 'boolean') {
            return this.booleanValuesOptions;
        }
        if (fieldObject && fieldObject.preferred_operators) {
            operators = this.shouldFilterDateOperators
                ? fieldObject.preferred_operators.filter(op => !RelativeDateOperators.includes(op.op_key))
                : fieldObject.preferred_operators;
        }
        else if (type) {
            operators = (this.operatorMap && this.operatorMap[type]) || this.defaultOperatorMap[type] || this.defaultEmptyList;
            if (operators.length === 0) {
                /*this.log.warn(
                  `No operators found for field '${field}' with type ${fieldObject.type}. ` +
                  `Please define an 'operators' property on the field or use the 'operatorMap' binding to fix this.`);
                */ }
            if (fieldObject.nullable) {
                operators = operators.concat(['is null', 'is not null']);
            }
        }
        else {
            //this.log.warn(`No 'type' property found on field: '${field}'`);
        }
        // Cache reference to array object, so it won't be computed next time and trigger a rerender.
        this.operatorsCache[field] = operators;
        return operators;
    }
    getOperatorsItems(field) {
        if (!this.operatorsCacheItems[field]) {
            this.operatorsCacheItems[field] = this.getOperators(field).map(op => {
                return { key: op.op_key, value: op.op_value };
            });
        }
        return this.operatorsCacheItems[field];
    }
    getCategoryOptions(field) {
        if (this.categoryOptionsCache[field] && this.categoryOptionsCache[field].length > 0) {
            return this.categoryOptionsCache[field];
        }
        const fieldObject = this.config.fields[field];
        if (!fieldObject.options[0]?.group) {
            this.categoryOptionsCache[field] = fieldObject.options;
        }
        else {
            this.categoryOptionsCache[field] = this.multiSelectReduce(fieldObject);
        }
        return this.categoryOptionsCache[field];
    }
    groupReduce(fieldObject) {
        return Object.values(fieldObject.options.reduce(function (r, a) {
            r[a.group] = r[a.group] || { itemName: { key: a.groupValue, value: a.group }, subItems: [] };
            r[a.group].subItems.push({ itemName: { key: a.key, value: a.value } });
            return r;
        }, Object.create(null))).map((group) => {
            return group;
        }).sort((a, b) => a.itemName.value.localeCompare(b.itemName.value));
    }
    multiSelectReduce(fieldObject) {
        return Object.values(fieldObject.options.reduce(function (r, a) {
            r[a.group] = r[a.group] || { key: a.groupValue, value: a.group, subItems: [] };
            r[a.group].subItems.push({ key: a.groupValue ? `${a.groupValue};;;${a.key}` : a.key, value: a.value });
            return r;
        }, Object.create(null))).map((group) => {
            return group;
        }).sort((a, b) => a.value.localeCompare(b.value));
    }
    getFields() {
        return this.fields;
    }
    updateDateOperatorType(field, operator) {
        const opKeys = this.config.fields[field].preferred_operators.map(op => op.op_key);
        if (RelativeDateOperators.every(op => opKeys.includes(op))) {
            if (RelativeDateOperators.includes(operator)) {
                this.config.fields[field].type = 'number';
            }
            else {
                this.config.fields[field].type = 'date';
            }
        }
    }
    getInputType(field, operator) {
        if (!this.config.fields[field]) {
            throw new Error(`No configuration for field '${field}' could be found! Please add it to config.fields.`);
        }
        this.updateDateOperatorType(field, operator);
        const type = this.config.fields[field].type ?? this.config.fields[field].componentType;
        switch (operator) {
            case 'is null':
            case 'is not null':
                return null; // No displayed component
            case 'in':
            case 'not in':
                return type === 'category' || type === 'boolean' ? 'multiselect' : type;
            default:
                if (this.getIsDisabledInput(operator)) {
                    return null;
                }
                return type;
        }
    }
    getComboboxType(rule) {
        const type = this.getInputType(this.asRule(rule).field, this.asRule(rule).operator);
        return (type === 'boolean' || type === 'category' || type === 'categoryWithUnListedValues' || type === 'compositeSearch') ? type : '';
    }
    getOptions(field) {
        return this.config.fields[field].options || this.defaultEmptyList;
    }
    getDefaultOperator(field) {
        if (field && field.defaultOperator !== undefined) {
            return this.getDefaultValue(field.defaultOperator);
        }
        else {
            const operators = this.getOperators(field.key);
            if (operators && operators.length) {
                return field.type === 'boolean' ? this.defaultOperatorMap['boolean'][0] : (operators.find(op => op.default) ? operators.find(op => op.default).op_key : operators[0].op_key);
            }
            else {
                /*this.log.warn(`No operators found for field '${field.value}'. ` +
                  `A 'defaultOperator' is also not specified on the field config. Operator value will default to null.`);
                */ return null;
            }
        }
    }
    addRule(i, parent) {
        this.resetPlayButton();
        if (this.disabled) {
            return;
        }
        parent = parent || this.data;
        const field = this.fields[0];
        parent.rules.splice(i + 1, 0, {
            field: field.key,
            group: field.group,
            type: field.type,
            operator: this.getDefaultOperator(field),
            value: field.type === 'boolean' ? true : this.getDefaultValue(field.defaultValue),
            validator: field.validator,
            new: true
        });
        this.handleTouched();
        this.handleDataChange(true, [parent.rules[parent.rules.length - 1]]);
        this.markPlaceHolder({ reset: true });
        if (!this.isKeypress && UI_INFRA_FOCUS_IN_ADD_RULE) {
            let id = this.id;
            this.focusOnNExtElement(id, i, 0);
        }
        this.isKeypress = false;
    }
    focusOnNExtElement(id, i, firstTime) {
        if (firstTime <= 1) {
            setTimeout(() => {
                var nextField = document.querySelector("#category" + id + "\\." + (i + 1) + " button");
                if (nextField) {
                    nextField.click();
                }
                else {
                    this.focusOnNExtElement(id, i, 1);
                }
            }, 10);
        }
    }
    copyRule(i) {
        if (this.disabled) {
            return;
        }
        // @ts-ignore
        this.data.rules.splice(i + 1, 0, this.deepcopy(this.data.rules[i]));
        let rule = this.data.rules[i];
        const control = new UntypedFormControl(rule, rule['validator'] ? [...this.getValidator(rule), rule['validator']] : this.getValidator(rule));
        this.qbForm.get('fields').insert(i + 1, control);
        this.markPlaceHolder({ reset: true });
    }
    pasteRule(i) {
        if (this.disabled) {
            return;
        }
        navigator.clipboard.readText().then((clipText) => {
            const rule = JSON.parse(clipText);
            // @ts-ignore
            const errors = [];
            const validRules = this.validateRulesInRuleset(this.config, rule, errors);
            if (validRules !== null) {
                this.data.rules.splice(i + 1, 0, this.deepcopy(validRules));
                const control = new UntypedFormControl(rule, rule['validator'] ? [...this.getValidator(rule), rule['validator']] : this.getValidator(rule));
                this.qbForm.get('fields').insert(i + 1, control);
                this.markPlaceHolder({ reset: true });
            }
        });
    }
    removeRule(rule, parent, index) {
        if (this.disabled) {
            return;
        }
        parent = parent || this.data;
        parent.rules = parent.rules.filter((r) => r !== rule);
        if (index != undefined) {
            this.qbForm.get('fields').removeAt(index);
        }
        if (parent.rules.length === 0) {
        }
        this.removeRuleFromIvalidRules(rule);
        this.handleTouched();
        this.handleDataChange();
    }
    addRuleSet(parent) {
        const date = new Date();
        this.isPlayClicked = { value: false, timestamp: date.getTime() };
        if (this.disabled) {
            return;
        }
        parent = parent || this.data;
        const field = this.fields[0];
        parent.rules = parent.rules.concat([{
                condition: 'and', rules: [
                    {
                        field: field.key,
                        group: field.group,
                        type: field.type,
                        operator: this.getDefaultOperator(field),
                        value: field.type === 'boolean' ? true : this.getDefaultValue(field.defaultValue),
                        new: true
                    },
                    {
                        field: field.key,
                        group: field.group,
                        type: field.type,
                        operator: this.getDefaultOperator(field),
                        value: field.type === 'boolean' ? true : this.getDefaultValue(field.defaultValue),
                        new: true
                    }
                ]
            }]);
        this.handleTouched();
        this.handleDataChange(true, [parent.rules[parent.rules.length - 1]], undefined, true);
        this.markPlaceHolder({ reset: true, addGroupHovered: false });
    }
    removeRuleSet(ruleset, parent) {
        if (this.disabled) {
            return;
        }
        ruleset = ruleset || this.data;
        parent = parent || this.parentValue;
        let index = parent.rules.findIndex((r) => r === ruleset);
        parent.rules = parent.rules.filter((r) => r !== ruleset);
        if (index > -1) {
            this.parentForm.get('fields').removeAt(index);
        }
        this.handleTouched();
        this.handleDataChange();
    }
    copyRuleSet(ruleset, parent) {
        const date = new Date();
        this.isPlayClicked = { value: false, timestamp: date.getTime() };
        if (this.disabled) {
            return;
        }
        ruleset = ruleset || this.data;
        parent = this.parentValue;
        const newRuleSet = this.deepcopy(this.data);
        const index = parent.rules.findIndex((r) => r === ruleset) || 0;
        parent.rules.splice(index + 1, 0, newRuleSet);
        const control = new UntypedFormControl(newRuleSet, this.getValidator(newRuleSet));
        this.parentForm.get('fields').insert(index + 1, control);
        this.handleTouched();
        this.handleDataChange();
        this.markPlaceholderInd.emit({ addGroupHovered: false, reset: true });
    }
    deepcopy(data) {
        let newData = { ...data };
        if ('rules' in data) {
            newData['rules'] = data.rules.map(rule => this.deepcopy(rule));
        }
        else {
            newData['new'] = true;
            let value = newData['value'];
            if (Array.isArray(value)) {
                newData['value'] = [...value];
            }
            else if (value !== null && value instanceof Date) {
                newData['value'] = new Date(value);
            }
            else if (typeof value === 'object' && value !== null) {
                newData['value'] = { ...value };
            }
        }
        return newData;
    }
    changeCondition(value) {
        if (this.disabled) {
            return;
        }
        this.data.condition = value;
        this.handleTouched();
        this.handleDataChange();
    }
    changeOperator(operatorValue, rule, index) {
        if (this.disabled) {
            return;
        }
        this.resetPlayButton();
        rule.operator = operatorValue;
        rule.new = false;
        rule.value = this.coerceValueForOperator(rule.operator, rule.value, rule);
        this.handleTouched();
        this.handleDataChange(true, [rule], index);
        this.refreshFiledIndex = index;
        setTimeout(() => { this.refreshFiledIndex = -1; });
    }
    coerceValueForOperator(operator, value, rule) {
        if (value === undefined || value === null) {
            return value;
        }
        if (this.operatorsWithoutInputField.indexOf(operator) > -1) {
            return null;
        }
        const inputType = this.getInputType(rule.field, operator);
        if (inputType?.toLowerCase() === 'multiselect' && !Array.isArray(value)) {
            return [value];
        }
        if (inputType?.toLowerCase() !== 'multiselect' && Array.isArray(value)) {
            return value[0];
        }
        return value;
    }
    changeInput(rule, index, value) {
        this.turnOffPlay();
        if (this.disabled || this.getIsDisabledInput(rule.operator)) {
            return;
        }
        this.resetPlayButton();
        rule.value = value;
        if (this.qbForm.get('fields').controls[index]?.dirty) {
            rule.new = false;
        }
        this.handleTouched();
        this.handleDataChange(true, [rule], index);
        this.validateInput(this.getControl(index), rule);
        this.changeDetectorRef.detectChanges();
    }
    getValidator(rule) {
        if (rule.field == undefined)
            return null;
        const type = this.getInputType(rule.field, rule.operator);
        switch (type) {
            case 'positiveNumber':
            case 'number':
                return [Validators.required, Validators.min(0)];
            case 'string':
            case 'autocomplete':
            case 'multiselect':
            case 'boolean':
            case 'category':
                return [Validators.required, this.createFilledInputValidator()];
            case 'compositeSearch':
                return [(v) => {
                        return v?.errors?.incorrect?.valid ? null : v?.errors;
                    }];
            default:
                return [];
        }
    }
    validateInput(control, rule) {
        if (control == undefined || control.errors == undefined) {
            return;
        }
        ;
        if (control.errors.min) {
            rule.validationErrorMessage = 'qb.invalid_input';
        }
        else if (control.errors.required || control.errors.validateField) {
            rule.validationErrorMessage = 'qb.required_field';
        }
    }
    /*
      validateInput(model: NgModel, rule: Rule, value: string) {
        if (model.errors && !model.pristine) {
          this.queryBuilderInvalidInputs.add(rule);
          rule.isValid = false;
          if (model.errors.pattern) {
            rule.validationErrorMessage = 'qb.invalid_input';
          }
          if (model.errors.min) {
            rule.validationErrorMessage = 'qb.invalid_input';
          }
          else if (model.errors.required && !value) {
            rule.validationErrorMessage = 'qb.required_field';
          }
        } else if (!model.errors) {
          this.removeRuleFromIvalidRules(rule);
          rule.isValid = true;
          rule.validationErrorMessage = null;
        }
      } */
    removeRuleFromIvalidRules(rule) {
        if (this.queryBuilderInvalidInputs.has(rule)) {
            this.queryBuilderInvalidInputs.delete(rule);
        }
    }
    changeField(rule, ruleIndex, fieldValue) {
        if (this.disabled) {
            return;
        }
        this.resetPlayButton();
        this.removeRuleFromIvalidRules(rule);
        rule.field = fieldValue["value"] ? fieldValue["value"] : fieldValue;
        rule.new = false;
        if (fieldValue["value"]) {
            rule.name = fieldValue["name"];
        }
        const field = this.config.fields[rule.field];
        this.indexSelected.emit(field);
        if (field && field.group !== undefined) {
            rule.group = field.group;
        }
        if (field && field.type !== undefined) {
            rule.type = field.type;
        }
        if (field && field.defaultValue !== undefined) {
            rule.value = this.getDefaultValue(field.defaultValue);
        }
        else if (field.type === 'boolean') {
            rule.value = 'true';
        }
        else if (field.componentType != 'dynamic' && field.type === 'category' && field.options && field.options[0]) {
            rule.value = field.options[0].key;
        }
        else {
            this.refreshFiledIndex = ruleIndex;
            delete rule.value;
            setTimeout(() => { this.refreshFiledIndex = -1; });
        }
        rule.operator = this.getDefaultOperator(field);
        rule.validator = field.validator;
        if (!this.DYNAMIC_FIELDS.includes(rule.field) && rule.hasOwnProperty('componentType')) {
            delete rule.componentType;
        }
        this.loadDynamicOptions(field, rule, ruleIndex);
        this.handleTouched();
        this.handleDataChange(true, [rule], ruleIndex);
    }
    loadDynamicOptions(field, rule, ruleIndex) {
        if (typeof (field.options) == "undefined") {
            field.options = [];
        }
        if (field.optionsUrl && field.options.length == 0) {
            let items;
            if (field.optionsUrl) {
                this.http.get(field.optionsUrl).subscribe((data) => {
                    field.options = data;
                    this.handleDataChange(true, [rule], ruleIndex);
                });
            }
        }
    }
    onResized(event) {
        let width = event.newRect.width;
        if (width < 730) {
            this.smallScreen = true;
        }
        else {
            this.smallScreen = false;
        }
    }
    getDefaultValue(defaultValue) {
        switch (typeof defaultValue) {
            case 'function':
                return defaultValue();
            default:
                return defaultValue;
        }
    }
    checkEmptyRuleInRuleset(ruleset) {
        if (!ruleset || !ruleset.rules || ruleset.rules.length === 0) {
            return true;
        }
        else {
            return ruleset.rules.some((item) => {
                if (item.rules) {
                    return this.checkEmptyRuleInRuleset(item);
                }
                else {
                    return false;
                }
            });
        }
    }
    validateRulesInRuleset(config, rule, errorStore) {
        if (rule && rule.rules && rule.rules.length > 0) {
            //check condition
            const retRule = { ...rule, rules: [] };
            rule.rules.forEach((item) => {
                const validatedRule = this.validateRulesInRuleset(config, item, errorStore);
                if (validatedRule) {
                    retRule.rules.push(validatedRule);
                }
            });
            return retRule.rules.length > 0 ? retRule : null;
        }
        else if (rule) {
            const field = config.fields[rule.field];
            if (!field) { //check field
                errorStore.push("field does not exist in query builder config");
                return null;
            }
            if (rule.type !== field.type) { //check type
                errorStore.push("invalid type");
                return null;
            }
            if (this.getOperators(field.key).findIndex(op => op.op_key === rule.operator) < 0) { //check operator
                errorStore.push("invalid operator");
                return null;
            }
            if (field && field.validator && field.validator.apply) {
                // const error = field.validator(rule as Rule, ruleset);
                // if (error != null) {
                //   errorStore.push(error);
                // } else {
                //   rules.push(item);
                // }
            }
            return rule;
        }
        //check unknown type
        return null;
    }
    handleDataChange(addControl, rules, index, qbElement) {
        this.changeDetectorRef.markForCheck();
        if (this.onChangeCallback) {
            this.onChangeCallback();
        }
        if (this.parentChangeCallback) {
            this.parentChangeCallback();
        }
        if (addControl) {
            if (index != undefined) {
                this.qbForm.get('fields').removeAt(index);
            }
            rules.forEach(rule => {
                const control = new UntypedFormControl(qbElement ? rule : rule.value, rule.validator ? [...this.getValidator(rule), rule.validator] : this.getValidator(rule));
                this.qbForm.get('fields').insert(index ?? this.getControlSize(), control);
                this.validateInput(control, rule);
            });
        }
    }
    getControl(index) {
        if (this.qbForm.get('fields').controls[index] != undefined) {
            return this.qbForm.get('fields').controls[index];
        }
        return null;
    }
    getControlSize() {
        return this.qbForm.get('fields').controls.length;
    }
    isEditableTextMarkedInvalid(id, index) {
        let elementId = 'searchValueTextField' + id + '.' + index;
        this.editableTextSearchValueElementRef = { nativeElement: document.getElementById(elementId) };
        if (this.editableTextSearchValueElementRef.nativeElement != null) {
            return !(this.editableTextSearchValueElementRef?.nativeElement?.getAttribute('class')?.indexOf('ng-touched') == -1);
        }
        else {
            return false;
        }
    }
    handleTouched() {
        if (this.onTouchedCallback) {
            this.onTouchedCallback();
        }
        if (this.parentTouchedCallback) {
            this.parentTouchedCallback();
        }
    }
    showHideToggle(isVisible) {
        if (this.shrinkedMode || this.conditionIsDisabled) {
            return;
        }
        this.isToggleVisible = isVisible;
        if (isVisible) {
            setTimeout(() => {
                this.toggleElementRef.nativeElement.focus();
            }, 100);
        }
    }
    changeIsToggleHovered(isHovered) {
        if (this.conditionIsDisabled) {
            return;
        }
        this.isToggleHovered = isHovered;
    }
    play() {
        this.updateValueAndValidity();
        if (!this.qbForm.valid && !this.shrinkedMode && !this.externalValidation) {
            this.isPlayClicked = { value: true, timestamp: new Date().getTime() };
            return;
        }
        this.playClicked.emit(this.data);
        if (!this.parentValue) {
            event?.stopPropagation();
            const date = new Date();
            this.isPlayClicked = { value: true, timestamp: date.getTime() };
        }
        else {
            this.needToBeColored = true;
        }
    }
    validateAndWarn() {
        this.updateValueAndValidity();
        if (!this.qbForm.valid && !this.shrinkedMode) {
            this.isPlayClicked = { value: true, timestamp: new Date().getTime() };
            return;
        }
        if (!this.parentValue) {
            event?.stopPropagation();
            const date = new Date();
            this.isPlayClicked = { value: true, timestamp: date.getTime() };
        }
        else {
            this.needToBeColored = true;
        }
    }
    updateValueAndValidity() {
        Object.keys(this.qbForm.get('fields').controls).forEach(index => {
            const control = this.getControl(index);
            control.updateValueAndValidity();
        });
    }
    turnOffPlay() {
        this.updateValueAndValidity();
        if (!this.parentValue && this.qbForm.valid) {
            this.resetPlayButton();
        }
    }
    resetPlayButton() {
        const date = new Date();
        this.isPlayClicked = { value: false, timestamp: date.getTime() };
    }
    getRowState(rule) {
        return this.isPlayHovered || this.isPlayClicked.value ? 'play' : rule.new ? 'new' : 'normal';
    }
    getSmallScreenRowState(rule) {
        if (!this.smallScreen) {
            return 'normal';
        }
        return this.isPlayHovered || this.isPlayClicked.value ? 'play' : rule.new ? 'new' : 'normal';
    }
    getRowColor(rule) {
        return this.isPlayHovered || this.isPlayClicked.value || this.viewMode ? 'aliceblue' : rule.new ? 'oldlace' : 'white';
    }
    shrinkedModeRuleClicked(ruleIndex) {
        this.shrinkedMode = false;
        this.shrinkedModeChange.emit(this.shrinkedMode);
        this.fieldsCombobox.toArray()[ruleIndex].menuTrigger.openMenu();
    }
    getIsDisabledInput(op) {
        if (this.operatorsWithoutInputField.indexOf(op) > -1) {
            return true;
        }
        return false;
    }
    getDynamicRuleFieldData(rule) {
        if (this.dynamicRuleFieldData) {
            this.dynamicRuleFieldData["selectedValue"] = { value: rule.field, name: rule.name };
        }
        else {
            this.dynamicRuleFieldData = { "selectedValue": { value: rule.field, name: rule.name } };
        }
        return this.dynamicRuleFieldData;
    }
    markPlaceHolder(event, i) {
        this.addGroupHovered = event.addGroupHovered;
        if (event.reset) {
            this.placeholderInd = -1;
        }
        switch (event.relativeLoc) {
            case "next":
                this.placeholderInd = i;
                break;
            case "last":
                this.placeholderInd = this.data.rules.length - 1;
                break;
        }
    }
    getSelectedCetegoryOptions(field, value) {
        if (value != null) {
            let tempValues = value.slice(0);
            let results = this.getCategoryOptions(field).filter((item) => {
                if (tempValues.indexOf(item.itemName.key) > -1) {
                    tempValues.splice(tempValues.indexOf(item.itemName.key), 1);
                    return item;
                }
            });
            if (tempValues.length > 0) {
                results = results.concat(ExFormUtil.asComboItems(tempValues, this.labelDefaults));
            }
            return results;
        }
        else {
            return [];
        }
    }
    removeItemFromInput(rule, index, value, isArray) {
        if (rule.value?.length >= index) {
            if (isArray) {
                rule.value?.splice(index, 1);
            }
            this.changeInput(rule, index, value);
        }
    }
    enterPlay() {
        if (this.isTriggerByEnter) {
            this.play();
        }
    }
    asRuleSet(rule) {
        return rule;
    }
    asRule(rule) {
        return rule;
    }
    getDate(rule) {
        let date = this.asRule(rule).value;
        if (!date || typeof date == 'object' || typeof date == 'number') {
            return date;
        }
        return date.replace(/Z$/, '');
    }
    convertSelectedValueToStr(value) {
        /**value in {true, 'true', 'false'}
         * value = true | 'true' => 'true'
         * value = 'false' => 'false'
         * **/
        return [{ key: value && value !== 'false' ? 'true' : 'false' }];
    }
    getComboboxSelectedItems(rule) {
        return this.asRule(rule).value ? (this.getComboboxType(rule) === 'boolean' ? this.convertSelectedValueToStr(this.asRule(rule).value) : [{ key: this.asRule(rule).value }]) : [];
    }
    closeToggle(event) {
        event.stopPropagation();
        event.preventDefault();
        this.showHideToggle(false);
        setTimeout(() => {
            this.connectionToggleElementRef.nativeElement.focus();
        }, 100);
    }
    hideToggleByTab(event) {
        this.showHideToggle(false);
    }
    static { this.ɵfac = function ExQueryBuilderComponent_Factory(t) { return new (t || ExQueryBuilderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$6.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$8.HttpClient), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i4$2.Clipboard), i0.ɵɵdirectiveInject(IFeatureFlagsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExQueryBuilderComponent, selectors: [["ex-query-builder"]], viewQuery: function ExQueryBuilderComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$4, 5);
            i0.ɵɵviewQuery(_c1$3, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldsCombobox = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowInputs = _t);
        } }, inputs: { qbForm: "qbForm", shouldFilterDateOperators: "shouldFilterDateOperators", id: "id", validationRequired: "validationRequired", isPlayHovered: "isPlayHovered", isPlayClicked: "isPlayClicked", level: "level", smallScreen: "smallScreen", allowAddRoles: "allowAddRoles", allowRowActions: "allowRowActions", isRuleSetLogicallyConnected: "isRuleSetLogicallyConnected", disabled: "disabled", data: "data", translations: "translations", booleanValuesOptions: "booleanValuesOptions", allowRuleset: "allowRuleset", allowCopyRuleset: "allowCopyRuleset", allowCopyPaste: "allowCopyPaste", maxLevels: "maxLevels", minRules: "minRules", operatorMap: "operatorMap", parentValue: "parentValue", parentForm: "parentForm", config: "config", parentChangeCallback: "parentChangeCallback", parentTouchedCallback: "parentTouchedCallback", viewMode: "viewMode", inputsPlaceholder: "inputsPlaceholder", conditionIsDisabled: "conditionIsDisabled", shrinkedMode: "shrinkedMode", showRunBtn: "showRunBtn", showOnlyTopRunBtn: "showOnlyTopRunBtn", isDynamicRuleField: "isDynamicRuleField", dynamicRuleFieldComponent: "dynamicRuleFieldComponent", dynamicRuleFieldData: "dynamicRuleFieldData", dynamicRuleFieldEvents: "dynamicRuleFieldEvents", operatorsWithoutInputField: "operatorsWithoutInputField", configLoading: "configLoading", play$: "play$", validate$: "validate$", isTriggerByEnter: "isTriggerByEnter", recentFields: "recentFields", dateFormat: "dateFormat", externalValidation: "externalValidation", index: "index", value: "value" }, outputs: { shrinkedModeChange: "shrinkedModeChange", playClicked: "playClicked", indexSelected: "indexSelected", markPlaceholderInd: "markPlaceholderInd" }, features: [i0.ɵɵProvidersFeature([CONTROL_VALUE_ACCESSOR, VALIDATOR]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c33, decls: 17, vars: 28, consts: [["role", "group", 1, "ex-query-builder-wrapper", 3, "ngClass", "click"], [1, "ex-query-builder-header"], [3, "id", "ngClass", "values", "selected", "selectedChange", "keyup.enter", "keydown.tab"], ["toggle", ""], ["class", "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "mouseenter", "mouseleave", "click", "keydown.enter", 4, "ngIf"], ["class", "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "mouseenter", "mouseleave", "click", 4, "ngIf"], [4, "ngIf"], ["class", "ex-query-builder-tree", 3, "ngStyle", "smallMode", "fullScreenMode", 4, "ngIf"], [1, "ex-query-builder-under-placeholder"], ["warnings", ""], [1, "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "mouseenter", "mouseleave", "click", "keydown.enter"], ["iconName", "add", "size", "small", 3, "useThemeColor"], [1, "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "mouseenter", "mouseleave", "click"], ["iconName", "addGroup", "size", "large", 3, "useThemeColor"], ["iconName", "duplicate", "size", "small", 3, "useThemeColor"], [1, "ex-query-builder-action-button", 3, "id", "exTooltip", "cdkCopyToClipboard", "disabled"], ["iconName", "copy", "size", "small", 3, "useThemeColor"], ["iconName", "paste", "size", "small", 3, "useThemeColor"], [1, "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "click"], ["iconName", "close", "size", "small", 3, "useThemeColor"], ["id", "playButton", 1, "uxf-icon", "uxf-play", 3, "ngClass"], [1, "ex-query-builder-tree", 3, "ngStyle"], [1, "ex-query-builder-rules-wrapper", 3, "formGroup", "ngClass"], ["id", "connectionToggleBtn", "class", "ex-query-builder-connection-toggle", "role", "button", 3, "mouseenter", "mouseleave", "focusin", "focusout", "click", "keyup.enter", "keyup.Space", 4, "ngIf"], ["class", "ex-query-builder-connection", 3, "ngClass", 4, "ngIf"], ["formArrayName", "fields", "role", "table", "class", "ex-query-builder-rows-list", 4, "ngIf"], ["class", "ex-query-builder-no-rules-box", 4, "ngIf"], ["id", "connectionToggleBtn", "role", "button", 1, "ex-query-builder-connection-toggle", 3, "mouseenter", "mouseleave", "focusin", "focusout", "click", "keyup.enter", "keyup.Space"], [1, "ex-query-builder-connection", 3, "ngClass"], ["formArrayName", "fields", "role", "table", 1, "ex-query-builder-rows-list"], [4, "ngFor", "ngForOf"], ["role", "rowgroup", 1, "sr-only"], ["role", "row", 1, "sr-only"], ["role", "columnheader", 1, "sr-only"], ["role", "row", 1, "ex-query-builder-row-wrapper", 3, "ngClass"], [1, "ex-query-builder-row", 3, "ngStyle"], ["class", "ex-query-builder-condition", 3, "click", 4, "ngIf"], ["class", "ex-query-builder-connection-to-group", 3, "mouseenter", "mouseleave", "click", 4, "ngIf"], [3, "selfOperator", "formControlName", "config", "ngModel", "disabled", "isPlayHovered", "isPlayClicked", "smallScreen", "translations", "parentForm", "parentValue", "operatorMap", "isTriggerByEnter", "shrinkedMode", "viewMode", "showRunBtn", "id", "index", "level", "operatorsWithoutInputField", "selfOperatorChange", "ngModelChange", "playClicked", "markPlaceholderInd", 4, "ngIf"], [3, "formControlName", "data", "disabled", "allowCopyRuleset", "allowCopyPaste", "isPlayHovered", "isPlayClicked", "smallScreen", "formControl", "parentTouchedCallback", "translations", "parentChangeCallback", "parentValue", "parentForm", "config", "allowRuleset", "operatorMap", "shrinkedMode", "viewMode", "showRunBtn", "id", "conditionIsDisabled", "index", "dynamicRuleFieldComponent", "isDynamicRuleField", "level", "maxLevels", "operatorsWithoutInputField", "playClicked", "markPlaceholderInd", 4, "ngIf"], [1, "ex-query-builder-condition", 3, "click"], [1, "ex-query-builder-connection-to-group", 3, "mouseenter", "mouseleave", "click"], [3, "ngClass"], ["class", "ex-query-builder-new-indicator", 3, "left", 4, "ngIf"], ["class", "ex-query-builder-new-indicator-add-group ex-query-builder-new-indicator-middel", 3, "left", 4, "ngIf"], [1, "ex-query-builder-new-indicator"], [1, "ex-query-builder-left-arrow"], [1, "ex-query-builder-right-arrow"], [1, "ex-query-builder-new-indicator-add-group", "ex-query-builder-new-indicator-middel"], [1, "ex-query-builder-row-wrapper", 3, "ngClass", "mouseenter", "focusin", "mouseleave"], ["class", "ex-query-builder-resizable", 3, "resized", 4, "ngIf"], ["class", "ex-query-builder-resizable", 4, "ngIf"], ["queryBuilder", ""], ["rowAction", ""], [1, "ex-query-builder-resizable", 3, "resized"], [3, "ngTemplateOutlet"], [1, "ex-query-builder-resizable"], ["class", "ex-query-builder-field", "role", "cell", 3, "id", "componentFactoryItem", "events", "data", 4, "ngIf"], ["class", "ex-query-builder-input ex-query-builder-border", "role", "cell", 3, "id", "ngClass", "full", "items", "readOnly", "selectedItems", "historyItems", "ariaLabel", "selectedItemsChange", 4, "ngIf"], ["class", "ex-query-builder-operator", "role", "cell", 3, "id", "hasBorder", "full", "items", "selectedItems", "ariaLabel", "selectedItemsChange", 4, "ngIf"], ["class", "ex-query-builder-input-and-validation-message loader-field-component", 4, "ngIf", "ngIfElse"], ["normal", ""], [3, "rule", "config", "viewMode", "id", "backgroundColor", "smallScreen", "ruleClicked", 4, "ngIf"], ["role", "cell", 1, "ex-query-builder-field", 3, "id", "componentFactoryItem", "events", "data"], ["role", "cell", 1, "ex-query-builder-input", "ex-query-builder-border", 3, "id", "ngClass", "full", "items", "readOnly", "selectedItems", "historyItems", "ariaLabel", "selectedItemsChange"], ["field", ""], ["role", "cell", 1, "ex-query-builder-operator", 3, "id", "hasBorder", "full", "items", "selectedItems", "ariaLabel", "selectedItemsChange"], [1, "ex-query-builder-input-and-validation-message", "loader-field-component"], [1, "ex-query-builder-input", 3, "id", "ngModel", "ngClass", "componentFactoryItem", "formControlName", "events", "data"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], [1, "ex-query-builder-input-and-validation-message"], ["class", "ex-query-builder-input ex-query-builder-text-input", "type", "text", "role", "cell", 3, "id", "inputId", "formControlName", "ngModel", "text", "disabled", "placeholder", "isMaxWidth", "hasBorder", "textAlign", "ngClass", "ariaLabel", "textChange", "ngModelChange", "keyup.enter", 4, "ngSwitchCase"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["newComboboxTmpl", ""], ["class", "ex-query-builder-input ex-query-builder-border", "type", "multi-level", "role", "cell", 3, "formControlName", "id", "full", "items", "isMultiSelect", "selectedItems", "selectedItemsChange", 4, "ngSwitchCase"], ["class", "ex-query-builder-input", "placeholder", "Add label", "role", "cell", 3, "formControlName", "id", "items", "selectedValues", "viewMode", "placeholderIcon", "labelColor", "endEdit", "itemRemoved", 4, "ngSwitchCase"], ["class", "ex-query-builder-input ex-query-builder-text-input ex-query-builder-date-input", "role", "cell", 3, "formControlName", "id", "date", "disabled", "readOnly", "ngClass", "ngModel", "dateFormat", "dateChange", 4, "ngSwitchCase"], ["class", "ex-query-builder-input ex-query-builder-border", "role", "cell", 3, "formControlName", "id", "selectedValue", "disabled", "placeholder", "hasMore", "datasource", "forceSelectionFromList", "ngClass", "selectionCleared", "selectedValueChange", 4, "ngSwitchCase"], ["class", "ex-query-builder-input ex-query-builder-text-input", "type", "number", "role", "cell", 3, "id", "formControlName", "ngModel", "disabled", "placeholder", "ngClass", "ngModelChange", "keyup.enter", 4, "ngSwitchCase"], ["class", "ex-query-builder-input ex-query-builder-text-input", "type", "number", "role", "cell", 3, "id", "formControlName", "min", "placeholder", "ngModel", "disabled", "ngClass", "ngModelChange", "keyup.enter", 4, "ngSwitchCase"], ["class", "ex-query-builder-input ex-query-builder-text-input", "type", "text", "role", "cell", 3, "formControlName", "id", "ngModel", "disabled", "ngModelChange", "keyup.enter", 4, "ngSwitchDefault"], ["type", "text", "role", "cell", 1, "ex-query-builder-input", "ex-query-builder-text-input", 3, "id", "inputId", "formControlName", "ngModel", "text", "disabled", "placeholder", "isMaxWidth", "hasBorder", "textAlign", "ngClass", "ariaLabel", "textChange", "ngModelChange", "keyup.enter"], ["class", "ex-query-builder-input", 3, "formControlName", "id", "full", "hasBorder", "items", "selectedItems", "disabled", "ngClass", "allowUnlistedValues", "selectedItemsChange", 4, "ngSwitchCase"], [1, "ex-query-builder-input", 3, "formControlName", "id", "full", "hasBorder", "items", "selectedItems", "disabled", "ngClass", "allowUnlistedValues", "selectedItemsChange"], ["type", "multi-level", "role", "cell", 1, "ex-query-builder-input", "ex-query-builder-border", 3, "formControlName", "id", "full", "items", "isMultiSelect", "selectedItems", "selectedItemsChange"], ["placeholder", "Add label", "role", "cell", 1, "ex-query-builder-input", 3, "formControlName", "id", "items", "selectedValues", "viewMode", "placeholderIcon", "labelColor", "endEdit", "itemRemoved"], ["role", "cell", 1, "ex-query-builder-input", "ex-query-builder-text-input", "ex-query-builder-date-input", 3, "formControlName", "id", "date", "disabled", "readOnly", "ngClass", "ngModel", "dateFormat", "dateChange"], ["role", "cell", 1, "ex-query-builder-input", "ex-query-builder-border", 3, "formControlName", "id", "selectedValue", "disabled", "placeholder", "hasMore", "datasource", "forceSelectionFromList", "ngClass", "selectionCleared", "selectedValueChange"], ["type", "number", "role", "cell", 1, "ex-query-builder-input", "ex-query-builder-text-input", 3, "id", "formControlName", "ngModel", "disabled", "placeholder", "ngClass", "ngModelChange", "keyup.enter"], ["type", "number", "role", "cell", 1, "ex-query-builder-input", "ex-query-builder-text-input", 3, "id", "formControlName", "min", "placeholder", "ngModel", "disabled", "ngClass", "ngModelChange", "keyup.enter"], ["type", "text", "role", "cell", 1, "ex-query-builder-input", "ex-query-builder-text-input", 3, "formControlName", "id", "ngModel", "disabled", "ngModelChange", "keyup.enter"], [3, "rule", "config", "viewMode", "id", "backgroundColor", "smallScreen", "ruleClicked"], ["class", "ex-query-builder-row-actions", 3, "ngClass", 4, "ngIf"], [1, "ex-query-builder-row-actions", 3, "ngClass"], ["class", "ex-query-builder-action-button", "role", "cell", 3, "id", "ngClass", "exTooltip", "disabled", "mouseenter", "mouseleave", "click", "keydown.enter", 4, "ngIf"], ["class", "ex-query-builder-action-button", "role", "cell", 3, "id", "exTooltip", "disabled", "focusout", "mouseenter", "mouseleave", "click", 4, "ngIf"], ["class", "ex-query-builder-action-button", "role", "cell", 3, "id", "exTooltip", "cdkCopyToClipboard", "disabled", 4, "ngIf"], ["class", "ex-query-builder-action-button", "role", "cell", 3, "id", "exTooltip", "disabled", "focusout", "click", 4, "ngIf"], ["role", "cell", 1, "ex-query-builder-action-button", 3, "id", "ngClass", "exTooltip", "disabled", "mouseenter", "mouseleave", "click", "keydown.enter"], ["role", "cell", 1, "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "focusout", "mouseenter", "mouseleave", "click"], ["role", "cell", 1, "ex-query-builder-action-button", 3, "id", "exTooltip", "cdkCopyToClipboard", "disabled"], ["role", "cell", 1, "ex-query-builder-action-button", 3, "id", "exTooltip", "disabled", "focusout", "click"], [3, "selfOperator", "formControlName", "config", "ngModel", "disabled", "isPlayHovered", "isPlayClicked", "smallScreen", "translations", "parentForm", "parentValue", "operatorMap", "isTriggerByEnter", "shrinkedMode", "viewMode", "showRunBtn", "id", "index", "level", "operatorsWithoutInputField", "selfOperatorChange", "ngModelChange", "playClicked", "markPlaceholderInd"], [3, "formControlName", "data", "disabled", "allowCopyRuleset", "allowCopyPaste", "isPlayHovered", "isPlayClicked", "smallScreen", "formControl", "parentTouchedCallback", "translations", "parentChangeCallback", "parentValue", "parentForm", "config", "allowRuleset", "operatorMap", "shrinkedMode", "viewMode", "showRunBtn", "id", "conditionIsDisabled", "index", "dynamicRuleFieldComponent", "isDynamicRuleField", "level", "maxLevels", "operatorsWithoutInputField", "playClicked", "markPlaceholderInd"], [1, "ex-query-builder-no-rules-box"], ["role", "alert"], [3, "diameter"], ["class", "ex-query-builder-new-indicator ex-query-builder-new-indicator-bottom", 4, "ngIf"], ["class", "ex-query-builder-new-indicator-add-group ex-query-builder-new-indicator-bottom", 4, "ngIf"], [1, "ex-query-builder-new-indicator", "ex-query-builder-new-indicator-bottom"], [1, "ex-query-builder-new-indicator-add-group", "ex-query-builder-new-indicator-bottom"], ["class", "ex-query-builder-invalid-input-warning-wrapper", 3, "id", 4, "ngIf"], [1, "ex-query-builder-invalid-input-warning-wrapper", 3, "id"], ["role", "alert", 1, "sr-only"], ["aria-hidden", "true", 1, "ex-query-builder-invalid-input-warning-label", "sel-invalid-input-warning-label"]], template: function ExQueryBuilderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c27);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function ExQueryBuilderComponent_Template_div_click_0_listener() { return ctx.turnOffPlay(); });
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵelementStart(2, "div", 1)(3, "ex-toggle", 2, 3);
            i0.ɵɵlistener("selectedChange", function ExQueryBuilderComponent_Template_ex_toggle_selectedChange_3_listener($event) { return ctx.changeCondition($event); })("keyup.enter", function ExQueryBuilderComponent_Template_ex_toggle_keyup_enter_3_listener($event) { return ctx.closeToggle($event); })("keydown.tab", function ExQueryBuilderComponent_Template_ex_toggle_keydown_tab_3_listener($event) { return ctx.closeToggle($event); })("selectedChange", function ExQueryBuilderComponent_Template_ex_toggle_selectedChange_3_listener($event) { return ctx.data.condition = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ExQueryBuilderComponent_button_5_Template, 4, 9, "button", 4);
            i0.ɵɵtemplate(6, ExQueryBuilderComponent_button_6_Template, 4, 9, "button", 5);
            i0.ɵɵtemplate(7, ExQueryBuilderComponent_ng_container_7_Template, 5, 9, "ng-container", 6);
            i0.ɵɵtemplate(8, ExQueryBuilderComponent_ng_container_8_Template, 6, 12, "ng-container", 6);
            i0.ɵɵtemplate(9, ExQueryBuilderComponent_ng_container_9_Template, 5, 9, "ng-container", 6);
            i0.ɵɵtemplate(10, ExQueryBuilderComponent_ng_container_10_Template, 5, 9, "ng-container", 6);
            i0.ɵɵtemplate(11, ExQueryBuilderComponent_button_11_Template, 2, 7, "button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, ExQueryBuilderComponent_div_12_Template, 8, 17, "div", 7);
            i0.ɵɵelementStart(13, "div", 8);
            i0.ɵɵprojection(14);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, ExQueryBuilderComponent_ng_template_15_Template, 1, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c28, ctx.viewMode));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 15, "ng.ex-query-builder.query_rule_group"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("id", "toggle", ctx.id, "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c29, ctx.shrinkedMode || ctx.viewMode))("@toggleAnim", !(ctx.isToggleVisible && ctx.data))("values", i0.ɵɵpureFunction2(25, _c32, i0.ɵɵpureFunction1(21, _c30, ctx.translations.and), i0.ɵɵpureFunction1(23, _c31, ctx.translations.or)))("selected", ctx.data.condition);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.shrinkedMode && !ctx.viewMode && ctx.allowAddRoles);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.allowRuleset && !ctx.shrinkedMode && !ctx.viewMode && ctx.level < ctx.maxLevels && !ctx.conditionIsDisabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.parentValue && ctx.allowRuleset && !ctx.shrinkedMode && !ctx.viewMode && ctx.allowCopyRuleset);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.shrinkedMode && !ctx.viewMode && ctx.allowCopyPaste);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.shrinkedMode && !ctx.viewMode && ctx.allowCopyPaste);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.parentValue && ctx.allowRuleset && !ctx.shrinkedMode && !ctx.viewMode);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.viewMode && ctx.showRunBtn);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.data && ctx.data.rules);
        } }, dependencies: [i1$5.NgClass, i1$5.NgForOf, i1$5.NgIf, i1$5.NgTemplateOutlet, i1$5.NgStyle, i1$5.NgSwitch, i1$5.NgSwitchCase, i1$5.NgSwitchDefault, ExDatePickerComponent, i1$6.DefaultValueAccessor, i1$6.NumberValueAccessor, i1$6.NgControlStatus, i1$6.NgControlStatusGroup, i1$6.MinValidator, i1$6.FormControlDirective, i1$6.FormGroupDirective, i1$6.FormControlName, i1$6.FormArrayName, ExToggleComponent, ExTooltipDirective, MinValidator, ResizedDirective, ExComponentLoaderComponent, ExComponentFormLoaderComponent, ExAutocompleteComponent, ExMultiselectComboboxComponent, ExSpinnerComponent, ExNewComboboxComponent, ExEditableTextComponent, ExSvgIconComponent, i4$2.CdkCopyToClipboard, ExQueryBuilderComponent, ViewModeComponent, ExQueryBuilderCompositeType, i1$5.JsonPipe, i1$2.TranslatePipe, FilterItemsByKeyPipe, ExClassNameFormatPipe, ExQbPipe], styles: ["[_nghost-%COMP%]{flex:1}.hide[_ngcontent-%COMP%]{display:none!important}.loader-field-component[_ngcontent-%COMP%]{flex:1}.ex-query-builder-wrapper[_ngcontent-%COMP%]{position:relative;margin-inline-start:4px}.ex-query-builder-wrapper[_ngcontent-%COMP%]     ex-query-builder-composite-type .ex-combobox-button.ex-combobox-view-mode{background:#e9ecef!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-under-placeholder[_ngcontent-%COMP%]{margin-top:10px;display:flex;flex-direction:row-reverse}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]{padding-inline-start:40px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-resizable[_ngcontent-%COMP%]{display:flex;width:100%}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-header[_ngcontent-%COMP%]{height:24px;display:flex;align-items:center;position:absolute;top:-12px;inset-inline-start:-4px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-button-group-shift-right[_ngcontent-%COMP%]{inset-inline-start:50px!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]{position:relative;margin-inline-start:10px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rows-list[_ngcontent-%COMP%]{padding-inline-start:0px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]{position:relative;padding:25px 0}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-connection[_ngcontent-%COMP%]{inset-inline-start:-20px;border-style:solid;width:15px;height:100%;border-inline-width:2px 0px;border-block-width:2px;position:absolute;top:0}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-connection-toggle[_ngcontent-%COMP%]{inset-inline-start:-30px;width:20px;height:100%;position:absolute;cursor:pointer;top:0;z-index:2}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-connection-to-group[_ngcontent-%COMP%]{position:absolute;inset-inline-start:0px;top:calc(50% - 6px);width:42px;cursor:pointer;padding:5px 0;display:flex;z-index:1;inset-inline-start:-7px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-connection-to-group[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{height:2px;width:100%;background:#ccc;display:inline-block;transition:.3s linear background-color}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]{padding-top:1px;margin-top:-1px;list-style:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]:not(:last-child):not(.ex-query-builder-small){margin-bottom:10px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column;position:relative}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-condition[_ngcontent-%COMP%]{position:absolute;inset-inline-start:-38px;top:calc(50% - 9px);z-index:1;width:35px;display:flex;align-items:center;justify-content:center;cursor:pointer}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-inputs-wrapper[_ngcontent-%COMP%]{flex:1}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]{display:flex;flex:1;position:relative;align-items:flex-start}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]{display:flex;flex-direction:row;position:relative;align-items:flex-start;width:calc(100% - 167px);max-width:860px;flex-shrink:0}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-input[_ngcontent-%COMP%]{flex:1;min-width:160px;max-width:350px;background:#fff}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-input[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-input[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-field[_ngcontent-%COMP%]{flex:1;min-width:160px;max-width:270px;background:#fff}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-field[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-operator[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:160px;margin-inline-end:15px;background:#fff}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-operator[_ngcontent-%COMP%]     .ex-combobox-selected-text-wrapper{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]{display:inline-block;background-image:none;border:1px solid #ccc;border-radius:4px;box-sizing:border-box;min-height:32px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]     .ex-editable-text-input{flex:1}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:hover{border:1px solid #898989}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:disabled{border-color:transparent}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input.ex-query-builder-date-input[_ngcontent-%COMP%]{padding:0}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   .ex-query-builder-text-input.ex-query-builder-date-input[_ngcontent-%COMP%]   .ex-date-picker-wrapper[_ngcontent-%COMP%]{width:100%}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs[_ngcontent-%COMP%]   input[type=number].ex-query-builder-text-input[_ngcontent-%COMP%]{padding-inline-start:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:relative;align-items:flex-start;width:273px;border:1px solid;border-radius:4px;border-color:#ccc}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]     .ex-combobox-button{border-style:none;justify-content:space-between;align-items:center}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]     .view-box-button{border-style:none!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{border:none!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]     .ex-autocomplete-wrapper{border:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]     .ex-autocomplete-wrapper:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small.ex-query-builder-required.ng-touched.ng-invalid[_ngcontent-%COMP%]{border:2px solid rgb(198,39,38)!important;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-input[_ngcontent-%COMP%]{flex:1;background:#fff;margin-inline:5px 0px;margin-block:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-input[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-field[_ngcontent-%COMP%]{flex:1;background:#fff;margin-inline:5px 0px;margin-block:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-field[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-operator[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-inline-end:15px;background:#fff;margin-inline-start:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-operator[_ngcontent-%COMP%]     .ex-combobox-selected-text-wrapper{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]{display:inline-block;padding:5px 8px;background-image:none;min-height:32px;margin-bottom:5px;border-style:none;border-radius:4px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:disabled{border-color:transparent}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-text-input[_ngcontent-%COMP%]:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-text-input.ex-query-builder-date-input[_ngcontent-%COMP%]{padding:0}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   .ex-query-builder-text-input.ex-query-builder-date-input[_ngcontent-%COMP%]   .ex-date-picker-wrapper[_ngcontent-%COMP%]{width:100%}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-inputs-small[_ngcontent-%COMP%]   input[type=number].ex-query-builder-text-input[_ngcontent-%COMP%]{padding-inline-start:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button-small[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-inline-start:0px!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-actions[_ngcontent-%COMP%]{width:100%;opacity:1;transition:.3s linear opacity;margin-inline-start:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-actions-small[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-start}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-input-and-validation-message[_ngcontent-%COMP%]{flex:1;display:flex;flex-direction:column}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-warning[_ngcontent-%COMP%]{border:1px solid;padding-bottom:30px;padding-top:30px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-row-wrapper[_ngcontent-%COMP%]   .ex-query-builder-invalid-input-warning-wrapper[_ngcontent-%COMP%]{margin-top:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-tree[_ngcontent-%COMP%]   .ex-query-builder-rules-wrapper[_ngcontent-%COMP%]   .ex-query-builder-no-rules-box[_ngcontent-%COMP%]{display:flex;width:-moz-fit-content;width:fit-content;flex-direction:column;align-items:center;padding:10px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]{background:transparent;outline:0;padding:5px 10px;border-radius:3px;z-index:3;height:30px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]:first-child{margin-inline-start:5px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]:hover{background:#f4f4f4}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]   .fa-clone[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-weight:700!important}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]   .ex-query-builder-add-group-icon[_ngcontent-%COMP%]{padding-top:2px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-action-button[_ngcontent-%COMP%]   .ex-query-builder-disable-play[_ngcontent-%COMP%]{color:#898989}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .smallMode[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%], .ex-query-builder-wrapper[_ngcontent-%COMP%]   .smallMode[_ngcontent-%COMP%]   .ex-query-builder-new-indicator-add-group[_ngcontent-%COMP%]{width:270px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .fullScreenMode[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%]{width:75%;max-width:726px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .fullScreenMode[_ngcontent-%COMP%]   .ex-query-builder-new-indicator-add-group[_ngcontent-%COMP%]{width:70%;max-width:726px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%]{height:2px;position:absolute;bottom:-6px;opacity:1;transition:.3s linear opacity}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;top:-7px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%]   .ex-query-builder-left-arrow[_ngcontent-%COMP%]{transform:rotate(135deg);inset-inline-start:-7px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator[_ngcontent-%COMP%]   .ex-query-builder-right-arrow[_ngcontent-%COMP%]{inset-inline-end:-7px;transform:rotate(-45deg)}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator-add-group[_ngcontent-%COMP%]{height:8px;position:absolute;bottom:-6px;opacity:1;transition:.3s linear opacity}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator-bottom[_ngcontent-%COMP%]{bottom:12px}.ex-query-builder-wrapper[_ngcontent-%COMP%]   .ex-query-builder-new-indicator-middel[_ngcontent-%COMP%]{bottom:-20px}.ex-query-builder-not-clickable[_ngcontent-%COMP%]{pointer-events:none}.ex-query-builder-hide[_ngcontent-%COMP%]{visibility:hidden;opacity:0!important}.ex-query-builder-hide-fields[_ngcontent-%COMP%]{visibility:hidden;display:none}input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}input[type=number][_ngcontent-%COMP%]:hover, input[type=number][_ngcontent-%COMP%]:focus{-moz-appearance:number-input}.ex-query-builder-required.ng-touched.ng-invalid[_ngcontent-%COMP%]:not(form){border-radius:5px;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-border[_ngcontent-%COMP%]{border:1px solid #ccc!important;border-radius:5px!important}.ex-query-builder-border[_ngcontent-%COMP%]:hover{border:1px solid #898989!important}.ex-query-builder-border[_ngcontent-%COMP%]:focus{border:2px solid #0e7bba!important;outline:none!important}.ex-query-builder-border[_ngcontent-%COMP%]:focus-within{border:2px solid #0e7bba!important;outline:none!important}.ex-query-builder-border[_ngcontent-%COMP%]     .ex-autocomplete-wrapper{border:none!important}.ex-query-builder-border[_ngcontent-%COMP%]     .ex-autocomplete-focus{border:none!important}.ex-query-builder-border[_ngcontent-%COMP%]     .ex-autocomplete-warning{border:none!important}.ex-query-builder-border[_ngcontent-%COMP%]     :focus{outline:none!important}.ex-query-builder-rules-wrapper.playClicked[_ngcontent-%COMP%]   .ex-query-builder-required.ng-invalid[_ngcontent-%COMP%]{border:2px solid rgb(198,39,38)!important;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-invalid-input-warning-label[_ngcontent-%COMP%]{color:#c62726!important}[_ngcontent-%COMP%]::placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;color:#222}"], data: { animation: QyeryBuilderAnimations } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExQueryBuilderComponent, [{
        type: Component,
        args: [{ selector: 'ex-query-builder', providers: [CONTROL_VALUE_ACCESSOR, VALIDATOR], animations: QyeryBuilderAnimations, template: "<div (click)=\"turnOffPlay()\" class=\"ex-query-builder-wrapper\"\n  [ngClass]=\"{ 'ex-query-builder-not-clickable': this.viewMode }\" role=\"group\"\n  [attr.aria-label]=\"'ng.ex-query-builder.query_rule_group' | translate\">\n  <div class=\"ex-query-builder-header\">\n    <ex-toggle #toggle id=\"toggle{{id}}\" [ngClass]=\"{'ex-query-builder-hide': shrinkedMode || viewMode}\"\n      [@toggleAnim]=\"!(isToggleVisible && data)\" (selectedChange)=\"changeCondition($event)\" (keyup.enter)=\"closeToggle($event)\" (keydown.tab)=\"closeToggle($event)\"\n      [values]=\"[{ value: 'and', label: translations.and }, {  value: 'or', label: translations.or }]\"\n      [(selected)]=\"data.condition\">\n    </ex-toggle>\n\n    <button id=\"addRuleFromTop{{id}}\" *ngIf=\"!shrinkedMode && !viewMode && allowAddRoles\" [exTooltip]=\"translations.addRule\"\n      (mouseenter)=\"markPlaceHolder({relativeLoc: 'last'})\" (mouseleave)=\"markPlaceHolder({reset: true})\"\n      class=\"ex-query-builder-action-button\" (click)=\"addRule(data.rules.length - 1)\" [disabled]=\"disabled\" (keydown.enter)=\"isKeypress=true\"\n            [attr.aria-label]=\"translations.addRule + ' ' + ('ng.ex-query-builder.to' | translate) + ' ' + ('ng.ex-query-builder.ruleSet' | translate) + ' ' + index\">\n      <ex-svg-icon iconName=\"add\" size=\"small\" [useThemeColor]=\"true\">\n      </ex-svg-icon>\n    </button>\n\n    <button id=\"addGroup{{id}}\"\n      *ngIf=\"allowRuleset && !shrinkedMode && !viewMode && level < maxLevels && !conditionIsDisabled\"\n      [exTooltip]=\"translations.addGroup\" (mouseenter)=\"markPlaceHolder({addGroupHovered: true, relativeLoc: 'last'})\"\n      (mouseleave)=\"markPlaceHolder({reset: true, addGroupHovered: false})\" class=\"ex-query-builder-action-button\"\n      (click)=\"addRuleSet()\" [disabled]=\"disabled\" [attr.aria-label]=\"translations.addGroup + ' ' + ('ng.ex-query-builder.to' | translate) + ' ' + ('ng.ex-query-builder.ruleSet' | translate) +' '+ index\">\n      <ex-svg-icon iconName=\"addGroup\" size=\"large\" [useThemeColor]=\"true\">\n      </ex-svg-icon>\n    </button>\n\n    <ng-container *ngIf=\"!!parentValue && allowRuleset && !shrinkedMode && !viewMode && allowCopyRuleset\">\n      <button id=\"copyGroup{{id}}\" [exTooltip]=\"'ng.general.duplicate-group' | translate\" class=\"ex-query-builder-action-button\"\n        (mouseenter)=\"markPlaceholderInd.emit({addGroupHovered: true, relativeLoc: 'next'});\"\n        (mouseleave)=\"markPlaceholderInd.emit({addGroupHovered: false, reset: true});\" (click)=\"copyRuleSet()\"\n        [disabled]=\"disabled\" [attr.aria-label]=\"'ng.general.duplicate-group' | translate\">\n        <ex-svg-icon iconName=\"duplicate\" size=\"small\" [useThemeColor]=\"true\">\n        </ex-svg-icon>\n      </button>\n    </ng-container>\n\n    <ng-container *ngIf=\"!shrinkedMode && !viewMode && allowCopyPaste\">\n      <button id=\"copyGroupToClipboard{{id}}\" [exTooltip]=\"'ng.general.copy-group' | translate\" class=\"ex-query-builder-action-button\"\n              [cdkCopyToClipboard]=\"data | json\" [disabled]=\"disabled\" [attr.aria-label]=\"'ng.general.copy-group' | translate\">\n        <ex-svg-icon iconName=\"copy\" size=\"small\" [useThemeColor]=\"true\">\n        </ex-svg-icon>\n      </button>\n    </ng-container>\n\n    <ng-container *ngIf=\"!shrinkedMode && !viewMode && allowCopyPaste\">\n      <button id=\"pasteGroup{{id}}\" [exTooltip]=\"'ng.general.paste' | translate\" class=\"ex-query-builder-action-button\"\n              (mouseenter)=\"markPlaceHolder({addGroupHovered: true, relativeLoc: 'last'})\"\n              (mouseleave)=\"markPlaceHolder({reset: true, addGroupHovered: false})\" (click)=\"pasteRule(data.rules.length + 1)\"\n              [disabled]=\"disabled\" [attr.aria-label]=\"'ng.general.paste' | translate\">\n        <ex-svg-icon iconName=\"paste\" size=\"small\" [useThemeColor]=\"true\">\n        </ex-svg-icon>\n      </button>\n    </ng-container>\n\n    <ng-container *ngIf=\"!!parentValue && allowRuleset && !shrinkedMode && !viewMode\">\n      <button id=\"removeGroup{{id}}\" [exTooltip]=\"translations.removeGroup\" class=\"ex-query-builder-action-button\"\n        (click)=\"removeRuleSet()\" [disabled]=\"disabled\" [attr.aria-label]=\"translations.removeGroup + ' ' + ('ng.ex-query-builder.from' | translate) + ' ' + ('ng.ex-query-builder.ruleSet' | translate) +' '+ index\">\n        <ex-svg-icon iconName=\"close\" size=\"small\" [useThemeColor]=\"true\">\n        </ex-svg-icon>\n      </button>\n    </ng-container>\n\n    <button *ngIf=\"!viewMode && showRunBtn\" id=\"playButton{{id}}\" (mouseenter)=\"isPlayHovered = true\"\n      (mouseleave)=\"isPlayHovered = false\" [exTooltip]=\"translations.play\" class=\"ex-query-builder-action-button\"\n      (click)=\"play()\" [disabled]=\"disabled || (queryBuilderInvalidInputs.size > 0)\"\n      [attr.aria-label]=\"translations.play\">\n      <i id=\"playButton\" class=\"uxf-icon uxf-play\"\n        [ngClass]=\"{ 'ex-query-builder-disable-play': (queryBuilderInvalidInputs.size > 0) }\"></i>\n    </button>\n  </div>\n\n  <div class=\"ex-query-builder-tree\" *ngIf=\"data && data.rules\"\n    [ngStyle]=\"{ 'margin-top': !parentValue ? '20px': '0px' }\" [class.smallMode]=\"smallScreen\"\n    [class.fullScreenMode]=\"!smallScreen\">\n    <div [formGroup]=\"qbForm\" class=\"ex-query-builder-rules-wrapper\"\n      [ngClass]=\"{'playClicked': isPlayClicked.value==true}\">\n      <div *ngIf=\"isRuleSetLogicallyConnected\" id=\"connectionToggleBtn\" (mouseenter)=\"changeIsToggleHovered(true)\" (mouseleave)=\"changeIsToggleHovered(false)\"\n        (focusin)=\"changeIsToggleHovered(true)\" (focusout)=\"changeIsToggleHovered(false)\"\n        (click)=\"showHideToggle(!isToggleVisible)\" (keyup.enter)=\"showHideToggle(!isToggleVisible)\"\n        (keyup.Space)=\"showHideToggle(!isToggleVisible)\" class=\"ex-query-builder-connection-toggle\" role=\"button\"\n        [attr.tabindex]=\"viewMode ? -1 : 0\" [attr.aria-label]=\"('ng.ex-query-builder.toggle' | translate) + ' ' + ('ng.ex-query-builder.ruleSet' | translate) +' '+ index\"\n        [attr.aria-expanded]=\"isToggleVisible\"></div>\n      <span *ngIf=\"isRuleSetLogicallyConnected\" class=\"ex-query-builder-connection\"\n        [ngClass]=\"{ 'ex-query-builder-connection-selected': isToggleVisible || isToggleHovered || isPlayHovered || isPlayClicked.value }\"></span>\n      <ul *ngIf=\"!configLoading\" formArrayName=\"fields\" role=\"table\" class=\"ex-query-builder-rows-list\">\n        <ng-container *ngFor=\"let rule of data.rules;let i=index;\">\n          <ng-container\n            *ngIf=\"getControlSize() == data.rules.length && {ruleset: !!asRuleSet(rule).rules, invalid: !config.allowEmptyRulesets && asRuleSet(rule).rules && asRuleSet(rule).rules.length === 0, type: config.fields[asRule(rule).field]?.type } as local\">\n            <li @rowAnim  role=\"row\" class=\"ex-query-builder-row-wrapper\" [ngClass]=\"'ex-query-builder-row-'+$any(rule).field | exClassNameFormat\" [class.hide]=\"$any(rule).isHide\">\n              <div class=\"ex-query-builder-row\"\n                [ngStyle]=\"{ 'margin-top': local.ruleset ? viewMode ? '10px' : '40px': '0px', 'margin-bottom': local.ruleset && i !== data.rules.length -1 ? '30px': '0px' }\">\n                <div *ngIf=\"i !== 0 && isRuleSetLogicallyConnected\" (click)=\"showHideToggle(!isToggleVisible)\" class=\"ex-query-builder-condition\">\n                  <span>{{ translations[data.condition] }}</span>\n                </div>\n                <span class=\"ex-query-builder-connection-to-group\" (mouseenter)=\"changeIsToggleHovered(true)\"\n                  (mouseleave)=\"changeIsToggleHovered(false)\" (click)=\"showHideToggle(!isToggleVisible)\"\n                  *ngIf=\"local.ruleset\">\n                  <span\n                    [ngClass]=\"{ 'ex-query-builder-connection-to-group-selected': isToggleVisible || isToggleHovered || isPlayHovered || isPlayClicked.value }\"></span>\n                </span>\n                <ng-container *ngIf=\"i === placeholderInd && i !== data.rules.length - 1 && !viewMode\">\n                  <div @fade *ngIf=\"!addGroupHovered\" class=\"ex-query-builder-new-indicator\"\n                    [style.left.px]=\"i === $any(rule).new ? -5 : 0\">\n                    <span class=\"ex-query-builder-left-arrow\">&#9700;</span>\n                    <span class=\"ex-query-builder-right-arrow\">&#9700;</span>\n                  </div>\n                  <div *ngIf=\"addGroupHovered\" @fade\n                    class=\"ex-query-builder-new-indicator-add-group ex-query-builder-new-indicator-middel\"\n                    [style.left.px]=\"i === $any(rule).new ? -5 : 0\"></div>\n                </ng-container>\n                <ng-container *ngIf=\"!local.ruleset\">\n                  <div class=\"ex-query-builder-row-wrapper\" (mouseenter)=\"hoveredRule = i\" (focusin)=\"hoveredRule = i\"\n                    (mouseleave)=\"hoveredRule = -1\" [ngClass]=\"{'ex-query-builder-small': smallScreen}\">\n                    <div class=\"ex-query-builder-resizable\" *ngIf=\"!parentValue\" (resized)=\"onResized($event)\">\n                      <ng-container [ngTemplateOutlet]=\"queryBuilder\"></ng-container>\n                      <ng-container [ngTemplateOutlet]=\"rowAction\"></ng-container>\n                    </div>\n                    <div class=\"ex-query-builder-resizable\" *ngIf=\"parentValue\">\n                      <ng-container [ngTemplateOutlet]=\"queryBuilder\"></ng-container>\n                      <ng-container [ngTemplateOutlet]=\"rowAction\"></ng-container>\n                    </div>\n                    <ng-template #queryBuilder>\n                      <div [@bgAnim]=\"getSmallScreenRowState(rule)\"\n                           [ngClass]=\"[smallScreen ? 'ex-query-builder-row-inputs-small' : 'ex-query-builder-row-inputs' , (validationRequired && smallScreen) ? 'ex-query-builder-required' : '',\n                        (getControl(i) != undefined &&  ((getControl(i).valid === false && getControl(i).touched)||  getControl(i).valid === false &&  isPlayClicked.value==true &&  !qbForm.valid)) ? 'ng-touched' : '',\n                        (getControl(i) != undefined &&  ((getControl(i).valid === false && getControl(i).touched)|| getControl(i).valid === false &&  isPlayClicked.value==true &&  !qbForm.valid  && !shrinkedMode)) ? 'ng-invalid' : '']\">\n\n                        <ex-component-loader id=\"category{{id}}.{{i}}\" class=\"ex-query-builder-field\"\n                          *ngIf=\"isDynamicRuleField\" [componentFactoryItem]=\"dynamicRuleFieldComponent\"\n                          [events]=\"{ selectedValueChange: changeField.bind(this, rule, i) }\"\n                          [data]=\"getDynamicRuleFieldData(rule)\" role=\"cell\">\n                        </ex-component-loader>\n\n                        <ex-new-combobox id=\"category{{id}}.{{i}}\" #field *ngIf=\"!isDynamicRuleField\"\n                          [ngClass]=\"{'ex-query-builder-hide-fields':shrinkedMode || viewMode}\"\n                          [@bgAnim]=\"getRowState(rule)\" class=\"ex-query-builder-input ex-query-builder-border\"\n                          [full]=\"true\" [items]=\"fieldItems\" role=\"cell\" [readOnly]=\"asRule(rule).categoryReadOnly\"\n                          [selectedItems]=\"asRule(rule).group ? [{ 'group': asRule(rule).group, 'key': asRule(rule).field }] : (groupPerItemMap && groupPerItemMap[asRule(rule).field] ?\n                        [{ 'group': groupPerItemMap[asRule(rule).field], 'key': asRule(rule).field }] : [{'key': asRule(rule).field}])\"\n                          (selectedItemsChange)=\"changeField(asRule(rule), i, $event[0].key)\" [historyItems]=\"recentFields\" ariaLabel=\"{{'ng.persistent-search.chooseSearchIndex' | translate }}\">\n                        </ex-new-combobox>\n\n                        <ex-new-combobox id=\"operator{{id}}.{{i}}\"\n                          *ngIf=\"!shrinkedMode && !viewMode && !FIELDS_WITHOUT_OPERATOR.includes(asRule(rule).field) && getInputType(asRule(rule).field, asRule(rule).operator) !== 'boolean' && config.fields[asRule(rule).field]?.type != 'compositeSearch'\"\n                          [@bgAnim]=\"getRowState(rule)\" class=\"ex-query-builder-operator\" [hasBorder]=\"true\"\n                          [full]=\"true\" [items]=\"getOperatorsItems(asRule(rule).field)\" role=\"cell\"\n                          [selectedItems]=\"asRule(rule).operator?[{key:asRule(rule).operator}]:[]\"\n                          (selectedItemsChange)=\"changeOperator($event[0].key, asRule(rule), i)\" ariaLabel=\"{{'ng.persistent-search.selectCompareType' | translate }}\">\n                        </ex-new-combobox>\n\n\n                        <span\n                          *ngIf=\"config.fields[asRule(rule).field]?.componentType === 'dynamic' && !shrinkedMode && !viewMode; else normal\"\n                          class=\"ex-query-builder-input-and-validation-message loader-field-component\">\n                          <ex-component-form-loader id=\"field{{id}}.{{i}}\" class=\"ex-query-builder-input\"\n                            [ngModel]=\"asRule(rule).value\"\n                            [ngClass]=\"{'ex-query-builder-required': validationRequired  && !smallScreen}\"\n                            [componentFactoryItem]=\"config.fields[asRule(rule).field]?.component\" [formControlName]=\"i\"\n                            [events]=\"{ valueChange: changeInput.bind(this, rule,i),  selectedValueChange: changeInput.bind(this, rule,i), selectedValuesChange: changeInput.bind(this, rule,i)}\"\n                            [data]=\"{ value: asRule(rule).value, backgroundColor: getRowColor(rule), type: config.fields[asRule(rule).field]?.component.data?.type, disabled: disabled, smallScreen: smallScreen, hasMore: config.fields[asRule(rule).field]?.hasMore }\">\n\n                          </ex-component-form-loader>\n\n                          <ng-container *ngIf=\"!smallScreen\">\n                            <ng-container *ngTemplateOutlet=\"warnings;context: {rule: rule, id: id, i:i}\">\n                            </ng-container>\n                          </ng-container>\n\n\n                        </span>\n\n                        <ng-template #normal>\n                          <ng-container\n                            *ngIf=\"refreshFiledIndex !== i && !shrinkedMode && !viewMode && !getIsDisabledInput(asRule(rule).operator) && config.fields[asRule(rule).field]?.type != 'compositeSearch'\"\n                            [ngSwitch]=\"getInputType(asRule(rule).field, asRule(rule).operator)\">\n                            <span class=\"ex-query-builder-input-and-validation-message\">\n                              <!--<input id=\"field{{id}}.{{i}}\" [formControlName]=\"i\" [@bgAnim]=\"getRowState(rule)\"\n                                *ngSwitchCase=\"'string'\" class=\"ex-query-builder-input ex-query-builder-text-input\"\n                                [ngModel]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule),i,  $event  )\"\n                                [disabled]=\"disabled\" [placeholder]=\"inputsPlaceholder | translate\" type=\"text\"\n                                [attr.aria-label]=\"'ng.ex-query-builder.enter_edit_value' | translate\"\n                                (keyup.enter)=\"enterPlay()\"\n                                [ngClass]=\"{'ex-query-builder-required': validationRequired && !smallScreen}\">\n -->\n                               <ex-editable-text id=\"searchValueTextField{{id}}.{{i}}\" [inputId]=\"'field'+id+'.'+i\" [formControlName]=\"i\" [@bgAnim]=\"getRowState(rule)\"\n                                      *ngSwitchCase=\"'string'\" class=\"ex-query-builder-input ex-query-builder-text-input\"\n                                      [ngModel]=\"asRule(rule).value\" [(text)]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule),i,  $event  )\"\n                                      [disabled]=\"disabled\" [placeholder]=\"inputsPlaceholder | translate\" type=\"text\"\n                                      (keyup.enter)=\"enterPlay()\" [isMaxWidth]=\"true\" [hasBorder]=\"false\" [textAlign]=\"'start'\"\n                                      [ngClass]=\"{'ex-query-builder-required': validationRequired && !smallScreen}\" role=\"cell\"\n                                      [attr.aria-invalid]=\"isEditableTextMarkedInvalid(id,i)\"\n                                      ariaLabel=\"{{('ng.persistent-search.enterSearchTerm' | translate) + ' - ' + (inputsPlaceholder | translate) }}\">\n                               </ex-editable-text>\n\n\n                              <ng-template #newComboboxTmpl [ngTemplateOutlet]=\"newComboboxTmpl\" let-comboboxType=\"comboboxType\"\n                                 [ngTemplateOutletContext]=\"{ comboboxType: getComboboxType(rule) }\">\n                                 <ex-new-combobox *ngSwitchCase=\"comboboxType\"\n                                    [formControlName]=\"i\" id=\"field{{id}}.{{i}}\" [@bgAnim]=\"getRowState(rule)\"\n                                    class=\"ex-query-builder-input\"\n                                    [full]=\"true\"\n                                    [hasBorder]=\"true\"\n                                    [items]=\"comboboxType === 'boolean' ? booleanValuesOptions : getCategoryOptions(asRule(rule).field) | filterItemsByKeyList : $any(rule)?.filterItems\"\n                                    [selectedItems]=\"getComboboxSelectedItems(rule)\" (selectedItemsChange)=\"changeInput(asRule(rule), i, $event[0].key)\"\n                                    [disabled]=\"disabled\"\n                                    [ngClass]=\"{'ex-query-builder-required': validationRequired  && !smallScreen}\"\n                                    [allowUnlistedValues]=\"comboboxType === 'categoryWithUnListedValues'\">\n                                 </ex-new-combobox>\n                              </ng-template>\n\n                              <!-- <ex-combobox-multiselect [formControlName]=\"i\" id=\"field{{id}}.{{i}}\"\n                                [@bgAnim]=\"getRowState(rule)\" *ngSwitchCase=\"'multiSelect'\"\n                                class=\"ex-query-builder-input\" [hasBorder]=\"true\" [full]=\"true\"\n                                [items]=\"getCategoryOptions(asRule(rule).field)\" [addSelectAllOption]=\"true\"\n                                [selectedValues]=\"asRule(rule).value?asRule(rule).value:[]\" [disabled]=\"disabled\"\n                                (selectedValuesChange)=\"changeInput(asRule(rule), i, $event)\">\n                              </ex-combobox-multiselect> -->\n\n                              <ex-new-combobox [formControlName]=\"i\" id=\"field{{id}}.{{i}}\"\n                                [@bgAnim]=\"getRowState(rule)\" *ngSwitchCase=\"'multiSelect'\"\n                                class=\"ex-query-builder-input ex-query-builder-border\" [full]=\"true\"\n                                [items]=\"getCategoryOptions(asRule(rule).field)\" type=\"multi-level\"\n                                [isMultiSelect]=\"true\" [selectedItems]=\"asRule(rule).value?asRule(rule).value:[]\" role=\"cell\"\n                                (selectedItemsChange)=\"changeInput(asRule(rule), i, $event)\">\n                              </ex-new-combobox>\n\n                              <ex-multiselect-combobox [formControlName]=\"i\" id=\"field{{id}}.{{i}}\"\n                                [items]=\"getCategoryOptions(asRule(rule).field)\"\n                                [selectedValues]=\"getSelectedCetegoryOptions(asRule(rule).field, asRule(rule).value)\"\n                                [viewMode]=\"true\" *ngSwitchCase=\"'tags'\" class=\"ex-query-builder-input\"\n                                [placeholderIcon]=\"true\" [labelColor]=\"labelColor\" placeholder=\"Add label\"\n                                (endEdit)=\"changeInput(asRule(rule), i, $event)\" role=\"cell\"\n                                (itemRemoved)=\"removeItemFromInput(asRule(rule), i, $event,true)\">\n                              </ex-multiselect-combobox>\n\n                              <ex-date-picker [formControlName]=\"i\" id=\"field{{id}}.{{i}}\" [date]=\"getDate(rule)\"\n                                [@bgAnim]=\"getRowState(rule)\" *ngSwitchCase=\"'date'\" [disabled]=\"disabled\"\n                                [readOnly]=\"readOnly || $any(rule).field.readOnly\"\n                                class=\"ex-query-builder-input ex-query-builder-text-input ex-query-builder-date-input\"\n                                [ngClass]=\"{'ex-query-builder-required': validationRequired  && !smallScreen}\" role=\"cell\"\n                                [ngModel]=\"getDate(rule)\" (dateChange)=\"changeInput(asRule(rule), i, $event)\"\n                                              [dateFormat]=\"dateFormat\">\n                              </ex-date-picker>\n\n                              <ex-autocomplete [formControlName]=\"i\" id=\"field{{id}}.{{i}}\"\n                                [@bgAnim]=\"getRowState(rule)\" *ngSwitchCase=\"'autocomplete'\"\n                                class=\"ex-query-builder-input ex-query-builder-border\"\n                                [selectedValue]=\"{ 'key': asRule(rule).value, 'value': asRule(rule).value }\"\n                                (selectionCleared)=\"removeItemFromInput(asRule(rule), i, $event,false)\"\n                                (selectedValueChange)=\"changeInput(asRule(rule), i, $event.key)\" [disabled]=\"disabled\"\n                                [placeholder]=\"smallScreen ? autoCompletePlaceholder : ''\"\n                                [hasMore]='config.fields[asRule(rule).field]?.hasMore'\n                                [datasource]=\"config.fields[asRule(rule).field]?.dataSource\"\n                                [forceSelectionFromList]=\"false\" role=\"cell\"\n                                [ngClass]=\"{'ex-query-builder-required': validationRequired  && !smallScreen}\">\n                              </ex-autocomplete>\n\n\n                              <input id=\"field{{id}}.{{i}}\" [formControlName]=\"i\" [@bgAnim]=\"getRowState(rule)\"\n                                *ngSwitchCase=\"'number'\" class=\"ex-query-builder-input ex-query-builder-text-input\"\n                                [ngModel]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule),i, $event )\"\n                                [disabled]=\"disabled\" type=\"number\" [placeholder]=\"inputsPlaceholder | translate\"\n                                [attr.aria-label]=\"'ng.ex-query-builder.enter_edit_value' | translate\"\n                                [disabled]=\"disabled\" (keyup.enter)=\"enterPlay()\" role=\"cell\"\n                                [ngClass]=\"{'ex-query-builder-required': validationRequired && !smallScreen}\">\n\n                              <input id=\"field{{id}}.{{i}}\" [formControlName]=\"i\" [@bgAnim]=\"getRowState(rule)\"\n                                *ngSwitchCase=\"'positiveNumber'\" [min]=\"0\" [placeholder]=\"inputsPlaceholder | translate\"\n                                class=\"ex-query-builder-input ex-query-builder-text-input\"\n                                [ngModel]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule),i, $event )\"\n                                type=\"number\" [attr.aria-label]=\"'ng.query-builder.enter_edit_value' | translate\"\n                                [disabled]=\"disabled\" (keyup.enter)=\"enterPlay()\" role=\"cell\"\n                                [ngClass]=\"{'ex-query-builder-required': validationRequired && !smallScreen}\">\n\n                              <input [formControlName]=\"i\" id=\"field{{id}}.{{i}}\" [@bgAnim]=\"getRowState(rule)\"\n                                *ngSwitchDefault class=\"ex-query-builder-input ex-query-builder-text-input\"\n                                [ngModel]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule), i, $event)\"\n                                [disabled]=\"disabled\" type=\"text\" (keyup.enter)=\"enterPlay()\" role=\"cell\"\n                                [attr.aria-label]=\"'ng.ex-query-builder.enter_edit_value' | translate\">\n                              <ng-container *ngIf=\"!smallScreen\">\n                                <ng-container *ngTemplateOutlet=\"warnings;context: {rule: rule, id: id, i:i}\">\n                                </ng-container>\n                              </ng-container>\n                            </span>\n                          </ng-container>\n                        </ng-template>\n\n                        <view-mode *ngIf=\"shrinkedMode || viewMode\" [rule]=\"rule\" [config]=\"config\"\n                          [viewMode]=\"viewMode\" (ruleClicked)=\"shrinkedModeRuleClicked(i)\" id=\"view-mode{{id}}.{{i}}\"\n                          [@bgAnim]=\"getRowState(rule)\" [backgroundColor]=\"getRowColor(rule)\" [smallScreen]=\"smallScreen\"></view-mode>\n                      </div>\n                    </ng-template>\n                    <ng-template #rowAction>\n                      <div [@fade]=\"hoveredRule === i\" *ngIf=\"allowRowActions\"\n                        [ngClass]=\"{ 'ex-query-builder-row-actions-small' : smallScreen }\"\n                        class=\"ex-query-builder-row-actions\">\n                        <button id=\"addRule{{id}}.{{i}}\" *ngIf=\"!shrinkedMode && !viewMode\"\n                          [ngClass]=\"{ 'ex-query-builder-action-button-small': smallScreen }\"\n                          [exTooltip]=\"translations.addRule\" (mouseenter)=\"markPlaceHolder({relativeLoc: 'next'},i)\"\n                          (mouseleave)=\"markPlaceHolder({reset: true})\" class=\"ex-query-builder-action-button\" role=\"cell\"\n                          (click)=\"addRule(i)\" (keydown.enter)=\"isKeypress=true\" [disabled]=disabled [attr.aria-label]=\"translations.addRule\">\n                          <ex-svg-icon iconName=\"add\" size=\"small\" [useThemeColor]=\"true\">\n                          </ex-svg-icon>\n                        </button>\n\n                        <button id=\"copyRule{{id}}.{{i}}\" *ngIf=\"!shrinkedMode && !viewMode\"\n                          (focusout)=\"((!!parentValue || data.rules.length > 1) && !shrinkedMode && !viewMode) ? null : hoveredRule = -1\"\n                          [exTooltip]=\"'ng.general.duplicate-rule' | translate\" (mouseenter)=\"markPlaceHolder({relativeLoc: 'next'},i)\"\n                          (mouseleave)=\"markPlaceHolder({reset: true})\" class=\"ex-query-builder-action-button\" role=\"cell\"\n                          (click)=\"copyRule(i)\" [disabled]=disabled [attr.aria-label]=\"'ng.general.duplicate-rule' | translate\">\n                          <ex-svg-icon iconName=\"duplicate\" size=\"small\" [useThemeColor]=\"true\">\n                          </ex-svg-icon>\n                        </button>\n\n                        <button id=\"copyRuleToClipboard{{id}}.{{i}}\" *ngIf=\"!shrinkedMode && !viewMode && allowCopyPaste\"\n                                [exTooltip]=\"'ng.general.copy-rule' | translate\" class=\"ex-query-builder-action-button\" role=\"cell\"\n                                [cdkCopyToClipboard]=\"data.rules[i] | json\" [disabled]=disabled [attr.aria-label]=\"'ng.general.copy-rule' | translate\">\n                          <ex-svg-icon iconName=\"copy\" size=\"small\" [useThemeColor]=\"true\">\n                          </ex-svg-icon>\n                        </button>\n\n                        <button id=\"pasteRule{{id}}.{{i}}\" *ngIf=\"!shrinkedMode && !viewMode && allowCopyPaste\"\n                                (focusout)=\"((!!parentValue || data.rules.length > 1) && !shrinkedMode && !viewMode) ? null : hoveredRule = -1\"\n                                (mouseenter)=\"markPlaceHolder({relativeLoc: 'next'},i)\"\n                                (mouseleave)=\"markPlaceHolder({reset: true})\"\n                                [exTooltip]=\"'ng.general.paste' | translate\" class=\"ex-query-builder-action-button\" role=\"cell\"\n                                (click)=\"pasteRule(i)\" [disabled]=disabled [attr.aria-label]=\"'ng.general.paste' | translate\">\n                          <ex-svg-icon iconName=\"paste\" size=\"small\" [useThemeColor]=\"true\">\n                          </ex-svg-icon>\n                        </button>\n\n                        <button id=\"removeRule{{id}}.{{i}}\" [exTooltip]=\"translations.removeRule\"\n                          (focusout)=\"hoveredRule = -1\"\n                          *ngIf=\"(!!parentValue || data.rules.length > minRules) && !shrinkedMode && !viewMode\"\n                          class=\"ex-query-builder-action-button\" (click)=\"removeRule(asRule(rule), data,i)\" role=\"cell\"\n                          [disabled]=disabled [attr.aria-label]=\"translations.removeRule\">\n                          <ex-svg-icon iconName=\"close\" size=\"small\" [useThemeColor]=\"true\"></ex-svg-icon>\n                        </button>\n                      </div>\n                    </ng-template>\n                  </div>\n                  <ng-container *ngIf=\"smallScreen\">\n                    <ng-container *ngTemplateOutlet=\"warnings;context: {rule: rule, id: id, i:i}\">\n                    </ng-container>\n                  </ng-container>\n                </ng-container>\n                <ex-query-builder-composite-type *ngIf=\"local.type == 'compositeSearch'\"\n                  [(selfOperator)]=\"asRule(rule).operator\"\n                  [formControlName]=\"i\" [config]=\"$any({allowEmptyRulesets: false, fields: this.config.fields[asRule(rule).field].innerfields})\"\n                  [ngModel]=\"asRule(rule).value\" (ngModelChange)=\"changeInput(asRule(rule),i, $event )\"\n                  [disabled]=\"disabled\" [isPlayHovered]=\"isPlayHovered\"\n                  [isPlayClicked]=\"isPlayClicked\" [smallScreen]=\"smallScreen\"\n                  [translations]=\"translations\" [parentForm]=\"qbForm\" [parentValue]=\"data\"\n                  (playClicked)=\"playClicked.emit($event)\"\n                  [operatorMap]=\"operatorMap\" [isTriggerByEnter]=\"isTriggerByEnter\"\n                  [shrinkedMode]=\"shrinkedMode\" [viewMode]=\"viewMode\" [showRunBtn]=\"!showOnlyTopRunBtn && showRunBtn\"\n                  id=\"{{id}}.{{i}}\" [index]=\"index+'.'+i\" [level]=\"level+1\"\n                  [operatorsWithoutInputField]=\"operatorsWithoutInputField\" (markPlaceholderInd)=\"markPlaceHolder($event, i)\"\n                  ></ex-query-builder-composite-type>\n                <ex-query-builder *ngIf=\"local.ruleset\" [formControlName]=\"i\" [data]=\"asRuleSet(rule)\"\n                  [disabled]=\"disabled\" [allowCopyRuleset]=\"allowCopyRuleset\" [allowCopyPaste]=\"allowCopyPaste\" [isPlayHovered]=\"isPlayHovered\"\n                  [isPlayClicked]=\"isPlayClicked\" [smallScreen]=\"smallScreen\" [formControl]=\"rule | exqbForm\"\n                  [parentTouchedCallback]=\"parentTouchedCallback || onTouchedCallback\" [translations]=\"translations\"\n                  (playClicked)=\"playClicked.emit($event)\"\n                  [parentChangeCallback]=\"parentChangeCallback || onChangeCallback\" [parentValue]=\"data\"\n                  [parentForm]=\"qbForm\" [config]=\"config\" [allowRuleset]=\"allowRuleset\" [operatorMap]=\"operatorMap\"\n                  [shrinkedMode]=\"shrinkedMode\" [viewMode]=\"viewMode\" [showRunBtn]=\"!showOnlyTopRunBtn && showRunBtn\"\n                  id=\"{{id}}.{{i}}\" [conditionIsDisabled]=\"conditionIsDisabled\" [index]=\"index+'.'+i\"\n                  [dynamicRuleFieldComponent]=\"dynamicRuleFieldComponent\" [isDynamicRuleField]=\"isDynamicRuleField\"\n                  [level]=\"level+1\" [maxLevels]=\"maxLevels\" [operatorsWithoutInputField]=\"operatorsWithoutInputField\"\n                  (markPlaceholderInd)=\"markPlaceHolder($event, i)\">\n                </ex-query-builder>\n              </div>\n            </li>\n          </ng-container>\n        </ng-container>\n        <span class=\"sr-only\" role=\"rowgroup\">\n          <span class=\"sr-only\" role=\"row\">\n            <span class=\"sr-only\" role=\"columnheader\">{{'ng.query-builder.searchIndex' | translate}}</span>\n            <span class=\"sr-only\" role=\"columnheader\">{{'ng.query-builder.compareType' | translate}}</span>\n            <span class=\"sr-only\" role=\"columnheader\">{{'ng.query-builder.searchValue' | translate}}</span>\n          </span>\n        </span>\n\n      </ul>\n      <div class=\"ex-query-builder-no-rules-box\" *ngIf=\"!data.rules || data.rules.length === 0\">\n        <span role=\"alert\">{{translations.emptyMessage}}</span>\n      </div>\n      <div class=\"ex-query-builder-no-rules-box\" *ngIf=\"configLoading\">\n        <ex-spinner [diameter]=\"20\"></ex-spinner>\n      </div>\n    </div>\n    <ng-container *ngIf=\"placeholderInd !== -1 && data.rules.length - 1 === placeholderInd   && !viewMode\">\n      <div *ngIf=\"!addGroupHovered\" @fade class=\"ex-query-builder-new-indicator ex-query-builder-new-indicator-bottom\">\n        <span class=\"ex-query-builder-left-arrow\">&#9700;</span>\n        <span class=\"ex-query-builder-right-arrow\">&#9700;</span>\n      </div>\n      <div *ngIf=\"addGroupHovered\" @fade\n        class=\"ex-query-builder-new-indicator-add-group ex-query-builder-new-indicator-bottom\"></div>\n    </ng-container>\n  </div>\n  <div class=\"ex-query-builder-under-placeholder\">\n    <ng-content select=\"[under]\"></ng-content>\n  </div>\n</div>\n\n<ng-template #warnings let-rule=\"rule\" let-id=\"id\" let-i=\"i\">\n  <div id=\"warning{{id}}.{{i}}\"\n    *ngIf=\"getControl(i) != undefined &&  ((getControl(i).valid === false && getControl(i).touched)|| getControl(i).valid === false && isPlayClicked.value==true &&  !qbForm.valid && !shrinkedMode)\"\n    class=\"ex-query-builder-invalid-input-warning-wrapper\">\n    <span role=\"alert\" class=\"sr-only\">{{ ('ng.query-builder.validation.errorInRow' | translate) + ' ' + (i + 1) + ': ' + (id === 'advSearch' ? ('ng.query-builder.searchValue' | translate ) : '') + ' - ' + (rule.validationErrorMessage | translate) }}</span>\n    <span aria-hidden=\"true\" class=\"ex-query-builder-invalid-input-warning-label sel-invalid-input-warning-label\">\n      {{ rule.validationErrorMessage | translate }}</span>\n  </div>\n</ng-template>\n", styles: [":host{flex:1}.hide{display:none!important}.loader-field-component{flex:1}.ex-query-builder-wrapper{position:relative;margin-inline-start:4px}.ex-query-builder-wrapper ::ng-deep ex-query-builder-composite-type .ex-combobox-button.ex-combobox-view-mode{background:#e9ecef!important}.ex-query-builder-wrapper .ex-query-builder-under-placeholder{margin-top:10px;display:flex;flex-direction:row-reverse}.ex-query-builder-wrapper .ex-query-builder-tree{padding-inline-start:40px}.ex-query-builder-wrapper .ex-query-builder-resizable{display:flex;width:100%}.ex-query-builder-wrapper .ex-query-builder-header{height:24px;display:flex;align-items:center;position:absolute;top:-12px;inset-inline-start:-4px}.ex-query-builder-wrapper .ex-query-builder-button-group-shift-right{inset-inline-start:50px!important}.ex-query-builder-wrapper .ex-query-builder-tree{position:relative;margin-inline-start:10px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rows-list{padding-inline-start:0px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper{position:relative;padding:25px 0}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-connection{inset-inline-start:-20px;border-style:solid;width:15px;height:100%;border-inline-width:2px 0px;border-block-width:2px;position:absolute;top:0}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-connection-toggle{inset-inline-start:-30px;width:20px;height:100%;position:absolute;cursor:pointer;top:0;z-index:2}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-connection-to-group{position:absolute;inset-inline-start:0px;top:calc(50% - 6px);width:42px;cursor:pointer;padding:5px 0;display:flex;z-index:1;inset-inline-start:-7px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-connection-to-group span{height:2px;width:100%;background:#ccc;display:inline-block;transition:.3s linear background-color}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper{padding-top:1px;margin-top:-1px;list-style:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper:not(:last-child):not(.ex-query-builder-small){margin-bottom:10px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row{display:flex;flex:1;flex-direction:column;position:relative}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-condition{position:absolute;inset-inline-start:-38px;top:calc(50% - 9px);z-index:1;width:35px;display:flex;align-items:center;justify-content:center;cursor:pointer}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-inputs-wrapper{flex:1}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper{display:flex;flex:1;position:relative;align-items:flex-start}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs{display:flex;flex-direction:row;position:relative;align-items:flex-start;width:calc(100% - 167px);max-width:860px;flex-shrink:0}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-input{flex:1;min-width:160px;max-width:350px;background:#fff}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-input:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-input:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-field{flex:1;min-width:160px;max-width:270px;background:#fff}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-field:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-operator{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:160px;margin-inline-end:15px;background:#fff}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-operator ::ng-deep .ex-combobox-selected-text-wrapper{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input{display:inline-block;background-image:none;border:1px solid #ccc;border-radius:4px;box-sizing:border-box;min-height:32px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input ::ng-deep .ex-editable-text-input{flex:1}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input:hover{border:1px solid #898989}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input:focus{border:2px solid #0e7bba}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input:disabled{border-color:transparent}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input.ex-query-builder-date-input{padding:0}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs .ex-query-builder-text-input.ex-query-builder-date-input .ex-date-picker-wrapper{width:100%}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs input[type=number].ex-query-builder-text-input{padding-inline-start:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small{display:flex;flex-direction:column;position:relative;align-items:flex-start;width:273px;border:1px solid;border-radius:4px;border-color:#ccc}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small ::ng-deep .ex-combobox-button{border-style:none;justify-content:space-between;align-items:center}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small ::ng-deep .view-box-button{border-style:none!important}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-row-inputs-small div{border:none!important}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-row-inputs-small div:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small ::ng-deep .ex-autocomplete-wrapper{border:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small ::ng-deep .ex-autocomplete-wrapper:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small.ex-query-builder-required.ng-touched.ng-invalid{border:2px solid rgb(198,39,38)!important;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-input{flex:1;background:#fff;margin-inline:5px 0px;margin-block:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-input:focus{border:2px solid #0e7bba;outline:none}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-field{flex:1;background:#fff;margin-inline:5px 0px;margin-block:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-field:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-operator{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-inline-end:15px;background:#fff;margin-inline-start:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-operator ::ng-deep .ex-combobox-selected-text-wrapper{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-text-input{display:inline-block;padding:5px 8px;background-image:none;min-height:32px;margin-bottom:5px;border-style:none;border-radius:4px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-text-input:disabled{border-color:transparent}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-text-input:not(:last-child){margin-inline-end:15px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-text-input.ex-query-builder-date-input{padding:0}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small .ex-query-builder-text-input.ex-query-builder-date-input .ex-date-picker-wrapper{width:100%}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-inputs-small input[type=number].ex-query-builder-text-input{padding-inline-start:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-action-button-small{display:flex;flex-direction:column;margin-inline-start:0px!important}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-actions{width:100%;opacity:1;transition:.3s linear opacity;margin-inline-start:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-row-actions-small{display:flex;flex-direction:column;align-items:flex-start}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row .ex-query-builder-row-wrapper .ex-query-builder-input-and-validation-message{flex:1;display:flex;flex-direction:column}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-row-warning{border:1px solid;padding-bottom:30px;padding-top:30px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-row-wrapper .ex-query-builder-invalid-input-warning-wrapper{margin-top:5px}.ex-query-builder-wrapper .ex-query-builder-tree .ex-query-builder-rules-wrapper .ex-query-builder-no-rules-box{display:flex;width:-moz-fit-content;width:fit-content;flex-direction:column;align-items:center;padding:10px}.ex-query-builder-wrapper .ex-query-builder-action-button{background:transparent;outline:0;padding:5px 10px;border-radius:3px;z-index:3;height:30px}.ex-query-builder-wrapper .ex-query-builder-action-button:first-child{margin-inline-start:5px}.ex-query-builder-wrapper .ex-query-builder-action-button:hover{background:#f4f4f4}.ex-query-builder-wrapper .ex-query-builder-action-button .fa-clone i{font-weight:700!important}.ex-query-builder-wrapper .ex-query-builder-action-button .ex-query-builder-add-group-icon{padding-top:2px}.ex-query-builder-wrapper .ex-query-builder-action-button .ex-query-builder-disable-play{color:#898989}.ex-query-builder-wrapper .smallMode .ex-query-builder-new-indicator,.ex-query-builder-wrapper .smallMode .ex-query-builder-new-indicator-add-group{width:270px}.ex-query-builder-wrapper .fullScreenMode .ex-query-builder-new-indicator{width:75%;max-width:726px}.ex-query-builder-wrapper .fullScreenMode .ex-query-builder-new-indicator-add-group{width:70%;max-width:726px}.ex-query-builder-wrapper .ex-query-builder-new-indicator{height:2px;position:absolute;bottom:-6px;opacity:1;transition:.3s linear opacity}.ex-query-builder-wrapper .ex-query-builder-new-indicator span{position:absolute;top:-7px}.ex-query-builder-wrapper .ex-query-builder-new-indicator .ex-query-builder-left-arrow{transform:rotate(135deg);inset-inline-start:-7px}.ex-query-builder-wrapper .ex-query-builder-new-indicator .ex-query-builder-right-arrow{inset-inline-end:-7px;transform:rotate(-45deg)}.ex-query-builder-wrapper .ex-query-builder-new-indicator-add-group{height:8px;position:absolute;bottom:-6px;opacity:1;transition:.3s linear opacity}.ex-query-builder-wrapper .ex-query-builder-new-indicator-bottom{bottom:12px}.ex-query-builder-wrapper .ex-query-builder-new-indicator-middel{bottom:-20px}.ex-query-builder-not-clickable{pointer-events:none}.ex-query-builder-hide{visibility:hidden;opacity:0!important}.ex-query-builder-hide-fields{visibility:hidden;display:none}input[type=number]{-moz-appearance:textfield}input[type=number]:hover,input[type=number]:focus{-moz-appearance:number-input}.ex-query-builder-required.ng-touched.ng-invalid:not(form){border-radius:5px;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-border{border:1px solid #ccc!important;border-radius:5px!important}.ex-query-builder-border:hover{border:1px solid #898989!important}.ex-query-builder-border:focus{border:2px solid #0e7bba!important;outline:none!important}.ex-query-builder-border:focus-within{border:2px solid #0e7bba!important;outline:none!important}.ex-query-builder-border ::ng-deep .ex-autocomplete-wrapper{border:none!important}.ex-query-builder-border ::ng-deep .ex-autocomplete-focus{border:none!important}.ex-query-builder-border ::ng-deep .ex-autocomplete-warning{border:none!important}.ex-query-builder-border ::ng-deep :focus{outline:none!important}.ex-query-builder-rules-wrapper.playClicked .ex-query-builder-required.ng-invalid{border:2px solid rgb(198,39,38)!important;outline:none!important;margin-inline-end:0px!important}.ex-query-builder-invalid-input-warning-label{color:#c62726!important}::placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;color:#222}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$6.UntypedFormBuilder }, { type: i1$8.HttpClient }, { type: i1$2.TranslateService }, { type: i4$2.Clipboard }, { type: IFeatureFlagsService }]; }, { qbForm: [{
            type: Input
        }], shouldFilterDateOperators: [{
            type: Input
        }], id: [{
            type: Input
        }], validationRequired: [{
            type: Input
        }], fieldsCombobox: [{
            type: ViewChildren,
            args: ['field']
        }], rowInputs: [{
            type: ViewChildren,
            args: ['inputRow']
        }], isPlayHovered: [{
            type: Input
        }], isPlayClicked: [{
            type: Input
        }], level: [{
            type: Input
        }], smallScreen: [{
            type: Input
        }], allowAddRoles: [{
            type: Input
        }], allowRowActions: [{
            type: Input
        }], isRuleSetLogicallyConnected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], data: [{
            type: Input
        }], translations: [{
            type: Input
        }], booleanValuesOptions: [{
            type: Input
        }], allowRuleset: [{
            type: Input
        }], allowCopyRuleset: [{
            type: Input
        }], allowCopyPaste: [{
            type: Input
        }], maxLevels: [{
            type: Input
        }], minRules: [{
            type: Input
        }], operatorMap: [{
            type: Input
        }], parentValue: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], config: [{
            type: Input
        }], parentChangeCallback: [{
            type: Input
        }], parentTouchedCallback: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], inputsPlaceholder: [{
            type: Input
        }], conditionIsDisabled: [{
            type: Input
        }], shrinkedMode: [{
            type: Input
        }], showRunBtn: [{
            type: Input
        }], showOnlyTopRunBtn: [{
            type: Input
        }], isDynamicRuleField: [{
            type: Input
        }], dynamicRuleFieldComponent: [{
            type: Input
        }], dynamicRuleFieldData: [{
            type: Input
        }], dynamicRuleFieldEvents: [{
            type: Input
        }], operatorsWithoutInputField: [{
            type: Input
        }], shrinkedModeChange: [{
            type: Output
        }], configLoading: [{
            type: Input
        }], play$: [{
            type: Input
        }], validate$: [{
            type: Input
        }], isTriggerByEnter: [{
            type: Input
        }], recentFields: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], externalValidation: [{
            type: Input
        }], playClicked: [{
            type: Output
        }], indexSelected: [{
            type: Output
        }], markPlaceholderInd: [{
            type: Output
        }], index: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class ExQueryBuilderModule {
    static { this.ɵfac = function ExQueryBuilderModule_Factory(t) { return new (t || ExQueryBuilderModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExQueryBuilderModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExDatePickerModule,
            ExDateRangePickerModule,
            ExComboboxModule,
            TranslateModule,
            FormsModule,
            ReactiveFormsModule,
            ExToggleModule,
            ExDirectivesModule,
            MatTooltipModule,
            ExComponentLoaderModule,
            ExAutocompleteModule,
            ExMultiselectComboboxModule,
            ExSpinnerModule,
            ExNewComboboxModule,
            ExEditableTextModule,
            ExSvgIconModule,
            EXPipesModule,
            ClipboardModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExQueryBuilderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExDatePickerModule,
                    ExDateRangePickerModule,
                    ExComboboxModule,
                    TranslateModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ExToggleModule,
                    ExDirectivesModule,
                    MatTooltipModule,
                    ExComponentLoaderModule,
                    ExAutocompleteModule,
                    ExMultiselectComboboxModule,
                    ExSpinnerModule,
                    ExNewComboboxModule,
                    ExEditableTextModule,
                    ExSvgIconModule,
                    EXPipesModule,
                    ClipboardModule
                ],
                declarations: [
                    ExQueryBuilderComponent,
                    ViewModeComponent,
                    ExQbPipe,
                    ExQueryBuilderCompositeType,
                    exQbNormalizeConfigPipe
                ],
                exports: [
                    ExQueryBuilderComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExQueryBuilderModule, { declarations: [ExQueryBuilderComponent,
        ViewModeComponent,
        ExQbPipe,
        ExQueryBuilderCompositeType,
        exQbNormalizeConfigPipe], imports: [CommonModule,
        ExDatePickerModule,
        ExDateRangePickerModule,
        ExComboboxModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ExToggleModule,
        ExDirectivesModule,
        MatTooltipModule,
        ExComponentLoaderModule,
        ExAutocompleteModule,
        ExMultiselectComboboxModule,
        ExSpinnerModule,
        ExNewComboboxModule,
        ExEditableTextModule,
        ExSvgIconModule,
        EXPipesModule,
        ClipboardModule], exports: [ExQueryBuilderComponent] }); })();
i0.ɵɵsetComponentScope(ExQueryBuilderCompositeType, [i1$6.NgControlStatus, i1$6.FormControlDirective, ExQueryBuilderComponent], [exQbNormalizeConfigPipe]);

const animations = [
    trigger('openClose', [
        state('open, open_rtl', style({ transform: 'translateX(0%)' })),
        state('closed, void', style({ transform: 'translateX(100%)', boxShadow: 'none' })),
        state('closed_rtl', style({ transform: 'translateX(-100%)', boxShadow: 'none' })),
        transition('open => closed, open_rtl => closed_rtl', [animate(100)]),
        transition('void => open, closed_rtl => open_rtl', [animate('150ms ease-out')])
    ])
];

class SidepaneRef {
    constructor(overlay, content, data) {
        this.overlay = overlay;
        this.content = content;
        this.data = data;
        this.afterClosed = new Subject();
        this.afterClosed$ = this.afterClosed.asObservable();
        this.closeWithAnimationSubject = new Subject();
        this.closeWithAnimation$ = this.closeWithAnimationSubject.asObservable();
    }
    close(value) {
        this.overlay.dispose();
        this.afterClosed.next(value);
        this.afterClosed.complete();
    }
    updateWidth(width) {
        this.overlay.updateSize({
            width: width
        });
    }
    closeWithAnimation() {
        this.closeWithAnimationSubject.next();
    }
}

const _c0$3 = ["container"];
const _c1$2 = ["handleE"];
const _c2 = ["handleW"];
function ExSidepaneComponent_div_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function ExSidepaneComponent_div_3_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.closeAndNavigate()); });
    i0.ɵɵpipe(1, "generateHTMLId");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "ex-svg-icon", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("sidepane-single-button" + (ctx_r5.isRtl ? "-rtl" : "") + " " + i0.ɵɵpipeBind1(1, 6, "sidepane-viewFullPage-button"));
    i0.ɵɵproperty("exTooltip", ctx_r5.disabledButtons ? "" : ctx_r5.isExpandEnabled ? i0.ɵɵpipeBind1(3, 10, "slidepane.open.tooltip") : !!ctx_r5.sidepaneRef.data.url ? i0.ɵɵpipeBind1(4, 12, "slidepane.open.disabled.tooltip") : i0.ɵɵpipeBind1(5, 14, "slidepane.open.disabled.tooltip.not_pickup"))("disabled", !ctx_r5.isExpandEnabled || ctx_r5.disabledButtons);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 8, "slidepane.open.tooltip"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("color", !ctx_r5.isExpandEnabled || ctx_r5.disabledButtons ? "#bebebe" : "#eee");
} }
function ExSidepaneComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
} }
function ExSidepaneComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ExSidepaneComponent_div_3_button_1_Template, 7, 16, "button", 7);
    i0.ɵɵtemplate(2, ExSidepaneComponent_div_3_div_2_Template, 1, 0, "div", 8);
    i0.ɵɵelementStart(3, "button", 9);
    i0.ɵɵlistener("click", function ExSidepaneComponent_div_3_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.close()); });
    i0.ɵɵpipe(4, "generateHTMLId");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "ex-svg-icon", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("sidepane-close-button" + (ctx_r1.isRtl ? "-rtl" : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.allowExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.allowExpand);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap("sidepane-single-button" + (ctx_r1.isRtl ? "-rtl" : "") + " " + i0.ɵɵpipeBind1(4, 11, "sidepane-close-button"));
    i0.ɵɵproperty("exTooltip", ctx_r1.disabledButtons ? "" : i0.ɵɵpipeBind1(6, 15, "slidepane.close.tooltip"))("ngClass", ctx_r1.allowExpand ? "bottom-button" : "sidepane-single-close-button")("disabled", ctx_r1.disabledButtons);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 13, "ng.general.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("color", ctx_r1.disabledButtons ? "#bebebe" : "#eee");
} }
function ExSidepaneComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14, 15);
} }
function ExSidepaneComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16, 17);
} }
function ExSidepaneComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3 = function (a0, a1) { return { e: a0, w: a1 }; };
class ExSidepaneComponent {
    constructor(sidepaneRef, _elementRef, exDialogService, document, featureFlag) {
        this.sidepaneRef = sidepaneRef;
        this._elementRef = _elementRef;
        this.exDialogService = exDialogService;
        this.document = document;
        this.featureFlag = featureFlag;
        this.isOpen = true;
        this.sub = new Subscription();
        this.minWidth = 0;
        this.maxWidth = 0;
        this.isExpandEnabled = true;
        this.disabledButtons = false;
        this.allowExpand = false;
        this.MENU_WIDTH_SMALL = 70;
        this.MENU_WIDTH_REGULAR = 94;
        this.MENU_WIDTH_BIG = 120;
        this.isRtl = this.document.documentElement.dir === 'rtl';
        this.closeButtonOnSide = this.sidepaneRef.data.closeButtonOnSide;
        this.content = this.sidepaneRef.content;
        this.isPickup = this.sidepaneRef.data?.additionalData?.pickupMode;
        this.currentDensity = this.sidepaneRef.data?.additionalData?.currentDensity;
    }
    clickedOutside(event) {
        const targetElement = event.target;
        if (event.type == "click" && targetElement['nodeName'] == "BODY")
            return; // URM-183976 fix
        if (document.querySelector('.cdk-overlay-backdrop'))
            return;
        if (document.querySelector('.cdk-drag-preview'))
            return;
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.close();
        }
    }
    updateIsPickup(event) {
        this.isExpandEnabled = !event.detail.isPickup && !!this.sidepaneRef.data.url && !this.sidepaneRef.data?.additionalData?.disableExpand;
    }
    get openClose() {
        return (this.isOpen ? 'open' : 'closed') + (this.isRtl ? '_rtl' : '');
    }
    openCloseDone() {
        if (!this.isOpen) {
            this.sidepaneRef.close();
            this.isExpandEnabled = true;
        }
        else {
            this.isExpandEnabled = this.isExpandEnabled && !!this.sidepaneRef.data.url;
        }
    }
    ngOnInit() {
        this.sub.add(this.sidepaneRef.closeWithAnimation$.subscribe(() => {
            this.close();
        }));
        if (!!this.sidepaneRef.data.elementForInert) {
            this.sidepaneRef.data.elementForInert['inert'] = true;
        }
        this.featureFlag.isActive('EXPAND_SLIDING_PANEL').subscribe(isActive => {
            this.allowExpand = isActive;
            this.allowResize = isActive;
        });
    }
    ngAfterViewInit() {
        this.setWidthConstraints();
    }
    setWidthConstraints() {
        this.minWidth = this.containerRef.nativeElement.offsetWidth;
        this.maxWidth = window.innerWidth - 50 - this.getMenuWidth();
    }
    getMenuWidth() {
        switch (this.currentDensity) {
            case 'large':
                return this.MENU_WIDTH_BIG;
            case 'small':
                return this.MENU_WIDTH_SMALL;
            default:
                return this.MENU_WIDTH_REGULAR;
        }
    }
    ngOnDestroy() {
        if (!!this.sidepaneRef.data.elementForInert) {
            this.sidepaneRef.data.elementForInert['inert'] = false;
        }
        this.sub.unsubscribe();
    }
    close() {
        this.isOpen = false;
    }
    closeAndNavigate() {
        if (this.isPickup) {
            return;
        }
        this.exDialogService.showConfirmationDialogWithPreferenceCheck({
            message: 'slidepane.open.massage',
            title: 'slidepane.open.title',
            type: 'warning',
            negativeLabel: 'ng.general.cancel',
            positiveLabel: 'ng.general.open',
            identifier: 'slidepane.expand',
            autoFocusOnPrimaryButton: true,
            isPositiveButtonIsPrimary: true,
        }).subscribe(dialog => {
            if (dialog) {
                dialog.afterClosed().subscribe(confirm => {
                    if (confirm) {
                        this.closeAndNavigateToUrl();
                    }
                });
            }
            else {
                this.closeAndNavigateToUrl();
            }
        });
    }
    closeAndNavigateToUrl() {
        this.close();
        document.dispatchEvent(new CustomEvent("closeAndNavigateClicked"));
    }
    disabledSidepaneButtons(event) {
        if (event.detail && event.detail.disabledButtons !== undefined) {
            this.disabledButtons = event.detail.disabledButtons;
        }
    }
    static { this.ɵfac = function ExSidepaneComponent_Factory(t) { return new (t || ExSidepaneComponent)(i0.ɵɵdirectiveInject(SidepaneRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ExDialogService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(IFeatureFlagsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSidepaneComponent, selectors: [["ex-sidepane"]], viewQuery: function ExSidepaneComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$3, 5);
            i0.ɵɵviewQuery(_c1$2, 7);
            i0.ɵɵviewQuery(_c2, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.handleEElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.handleWElem = _t.first);
        } }, hostVars: 1, hostBindings: function ExSidepaneComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵsyntheticHostListener("@openClose.done", function ExSidepaneComponent_animation_openClose_done_HostBindingHandler() { return ctx.openCloseDone(); });
            i0.ɵɵlistener("click", function ExSidepaneComponent_click_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, i0.ɵɵresolveDocument)("mouseup", function ExSidepaneComponent_mouseup_HostBindingHandler($event) { return ctx.clickedOutside($event); }, false, i0.ɵɵresolveDocument)("updateIsPickup", function ExSidepaneComponent_updateIsPickup_HostBindingHandler($event) { return ctx.updateIsPickup($event); }, false, i0.ɵɵresolveDocument)("disabledSidepaneButtons", function ExSidepaneComponent_disabledSidepaneButtons_HostBindingHandler($event) { return ctx.disabledSidepaneButtons($event); }, false, i0.ɵɵresolveDocument);
        } if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@openClose", ctx.openClose);
        } }, decls: 7, vars: 14, consts: [[1, "ex-sidepane-wrapper-container", 3, "exResizable", "rzHandles", "rzMinWidth", "rzMaxWidth", "rzHandleDoms"], ["container", ""], [1, "ex-sidepane-wrapper"], [3, "class", 4, "ngIf"], ["class", "ex-sidepane-custom-handle ng-resizable-handle ng-resizable-w", 4, "ngIf"], ["class", "ex-sidepane-custom-handle ng-resizable-handle ng-resizable-e", 4, "ngIf"], [4, "ngComponentOutlet"], [3, "exTooltip", "class", "disabled", "click", 4, "ngIf"], ["class", "ex-sidepane-button-separator", 4, "ngIf"], [3, "exTooltip", "ngClass", "disabled", "click"], ["iconName", "close2", "size", "xlarge", 3, "color"], [3, "exTooltip", "disabled", "click"], ["iconName", "viewFullPage", "size", "xlarge", 3, "color"], [1, "ex-sidepane-button-separator"], [1, "ex-sidepane-custom-handle", "ng-resizable-handle", "ng-resizable-w"], ["handleW", ""], [1, "ex-sidepane-custom-handle", "ng-resizable-handle", "ng-resizable-e"], ["handleE", ""]], template: function ExSidepaneComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2);
            i0.ɵɵtemplate(3, ExSidepaneComponent_div_3_Template, 8, 17, "div", 3);
            i0.ɵɵtemplate(4, ExSidepaneComponent_div_4_Template, 2, 0, "div", 4);
            i0.ɵɵtemplate(5, ExSidepaneComponent_div_5_Template, 2, 0, "div", 5);
            i0.ɵɵtemplate(6, ExSidepaneComponent_ng_container_6_Template, 1, 0, "ng-container", 6);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵstyleProp("direction", ctx.isRtl ? "rtl" : "ltr");
            i0.ɵɵproperty("exResizable", !!ctx.allowResize && ctx.closeButtonOnSide)("rzHandles", ctx.isRtl ? "e" : "w")("rzMinWidth", ctx.minWidth)("rzMaxWidth", ctx.maxWidth)("rzHandleDoms", i0.ɵɵpureFunction2(11, _c3, ctx.isRtl ? ctx.handleEElem == null ? null : ctx.handleEElem.nativeElement : null, ctx.isRtl ? null : ctx.handleWElem == null ? null : ctx.handleWElem.nativeElement));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.closeButtonOnSide);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.allowResize && !ctx.isRtl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.allowResize && ctx.isRtl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngComponentOutlet", ctx.content);
        } }, dependencies: [i1$5.NgClass, i1$5.NgComponentOutlet, i1$5.NgIf, ExTooltipDirective, ExResizableDirective, ExSvgIconComponent, i1$2.TranslatePipe, ExGenerateIdPipe], styles: ["[_nghost-%COMP%]{background:#fff;width:100%;direction:ltr}[_nghost-%COMP%]   .ng-resizable-handle[_ngcontent-%COMP%]{z-index:1000}[_nghost-%COMP%]   .ng-resizable-handle[_ngcontent-%COMP%]:not(.ex-sidepane-custom-handle){background-image:none!important}.ex-sidepane-wrapper-container[_ngcontent-%COMP%]{height:100%;box-shadow:-2px 0 15px -10px #aaa}.ex-sidepane-wrapper[_ngcontent-%COMP%]{height:100%;background:#fff;overflow:auto}.sidepane-close-button[_ngcontent-%COMP%]{left:-50px;z-index:-1}.sidepane-close-button[_ngcontent-%COMP%], .sidepane-close-button-rtl[_ngcontent-%COMP%]{position:absolute;height:150px;top:50%;transform:translateY(-50%)}.sidepane-close-button[_ngcontent-%COMP%]:empty, .sidepane-close-button-rtl[_ngcontent-%COMP%]:empty{width:0px;height:0px}.sidepane-close-button-rtl[_ngcontent-%COMP%], .sidepane-close-button-rtl-rtl[_ngcontent-%COMP%]{right:-50px}.ex-sidepane-button-separator[_ngcontent-%COMP%]{width:100%;height:1px;background-color:#fff}.sidepane-single-button[_ngcontent-%COMP%], .sidepane-single-button-rtl[_ngcontent-%COMP%]{border:none;background:#c8c8c880;color:#eee;width:50px;height:50%;align-items:center;display:flex;justify-content:center}.sidepane-single-button[_ngcontent-%COMP%]:not(:disabled):hover, .sidepane-single-button[_ngcontent-%COMP%]:not(:disabled):focus, .sidepane-single-button-rtl[_ngcontent-%COMP%]:not(:disabled):hover, .sidepane-single-button-rtl[_ngcontent-%COMP%]:not(:disabled):focus{cursor:pointer;background:#c8c8c899;color:#fff;outline:black solid 1px}.sidepane-single-button.sidepane-single-close-button[_ngcontent-%COMP%], .sidepane-single-button-rtl.sidepane-single-close-button[_ngcontent-%COMP%]{border-radius:10rem 0 0 10rem!important;padding:0!important;height:100px}.sidepane-single-button[_ngcontent-%COMP%], .sidepane-single-button-rtl[_ngcontent-%COMP%]{border-radius:10rem 0 0;padding:10px 0 0}.sidepane-single-button.bottom-button[_ngcontent-%COMP%], .sidepane-single-button-rtl.bottom-button[_ngcontent-%COMP%]{border-radius:0 0 0 10rem!important;padding:0 0 10px!important}.sidepane-single-button-rtl[_ngcontent-%COMP%]{transform:scaleX(-1)}"], data: { animation: animations } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidepaneComponent, [{
        type: Component,
        args: [{ selector: 'ex-sidepane', animations: animations, changeDetection: ChangeDetectionStrategy.Default, template: "<div #container class=\"ex-sidepane-wrapper-container\" [exResizable]=\"!!allowResize && closeButtonOnSide\" [style.direction]=\"isRtl?'rtl':'ltr'\"\n     [rzHandles]=\"isRtl ? 'e': 'w'\"\n     [rzMinWidth]=\"minWidth\" [rzMaxWidth]=\"maxWidth\" [rzHandleDoms]=\"{ e: isRtl ? handleEElem?.nativeElement : null, w: isRtl ? null :handleWElem?.nativeElement }\">\n  <div class=\"ex-sidepane-wrapper\">\n    <div *ngIf=\"closeButtonOnSide\" [class]=\"'sidepane-close-button'+ (isRtl? '-rtl':'')\">\n      <button *ngIf=\"allowExpand\"\n              [attr.aria-label]=\"'slidepane.open.tooltip' | translate\"\n              [exTooltip]=\"disabledButtons?'':isExpandEnabled?('slidepane.open.tooltip' | translate) : !!sidepaneRef.data.url?  ('slidepane.open.disabled.tooltip' | translate) : ('slidepane.open.disabled.tooltip.not_pickup' | translate)\"\n              [class]=\"'sidepane-single-button' + (isRtl ? '-rtl' : '') + ' ' + ('sidepane-viewFullPage-button' | generateHTMLId)\"\n              (click)=\"closeAndNavigate()\"\n      [disabled]=\"!isExpandEnabled || disabledButtons\">\n        <ex-svg-icon iconName=\"viewFullPage\" size=\"xlarge\"  [color]=\"(!isExpandEnabled || disabledButtons)?'#bebebe':'#eee'\"></ex-svg-icon>\n      </button>\n      <div *ngIf=\"allowExpand\" class=\"ex-sidepane-button-separator\"></div>\n      <button [attr.aria-label]=\"'ng.general.close' | translate\"\n              [exTooltip]=\"disabledButtons?'':'slidepane.close.tooltip' | translate\"\n              [class]=\"'sidepane-single-button'+ (isRtl? '-rtl':'')+ ' ' + ('sidepane-close-button' | generateHTMLId)\"\n              [ngClass]=\"allowExpand?'bottom-button' :'sidepane-single-close-button'  \"\n              [disabled]=\"disabledButtons\" (click)=\"close()\">\n        <ex-svg-icon iconName=\"close2\" size=\"xlarge\" [color]=\"disabledButtons?'#bebebe':'#eee'\"></ex-svg-icon>\n      </button>\n    </div>\n    <div *ngIf=\"!!allowResize && !isRtl\" #handleW class=\"ex-sidepane-custom-handle ng-resizable-handle ng-resizable-w\"></div>\n    <div *ngIf=\"!!allowResize && isRtl\" #handleE class=\"ex-sidepane-custom-handle ng-resizable-handle ng-resizable-e\"></div>\n    <ng-container *ngComponentOutlet=\"content\"></ng-container>\n\n  </div>\n</div>\n", styles: [":host{background:#fff;width:100%;direction:ltr}:host .ng-resizable-handle{z-index:1000}:host .ng-resizable-handle:not(.ex-sidepane-custom-handle){background-image:none!important}.ex-sidepane-wrapper-container{height:100%;box-shadow:-2px 0 15px -10px #aaa}.ex-sidepane-wrapper{height:100%;background:#fff;overflow:auto}.sidepane-close-button{left:-50px;z-index:-1}.sidepane-close-button,.sidepane-close-button-rtl{position:absolute;height:150px;top:50%;transform:translateY(-50%)}.sidepane-close-button:empty,.sidepane-close-button-rtl:empty{width:0px;height:0px}.sidepane-close-button-rtl,.sidepane-close-button-rtl-rtl{right:-50px}.ex-sidepane-button-separator{width:100%;height:1px;background-color:#fff}.sidepane-single-button,.sidepane-single-button-rtl{border:none;background:#c8c8c880;color:#eee;width:50px;height:50%;align-items:center;display:flex;justify-content:center}.sidepane-single-button:not(:disabled):hover,.sidepane-single-button:not(:disabled):focus,.sidepane-single-button-rtl:not(:disabled):hover,.sidepane-single-button-rtl:not(:disabled):focus{cursor:pointer;background:#c8c8c899;color:#fff;outline:black solid 1px}.sidepane-single-button.sidepane-single-close-button,.sidepane-single-button-rtl.sidepane-single-close-button{border-radius:10rem 0 0 10rem!important;padding:0!important;height:100px}.sidepane-single-button,.sidepane-single-button-rtl{border-radius:10rem 0 0;padding:10px 0 0}.sidepane-single-button.bottom-button,.sidepane-single-button-rtl.bottom-button{border-radius:0 0 0 10rem!important;padding:0 0 10px!important}.sidepane-single-button-rtl{transform:scaleX(-1)}\n"] }]
    }], function () { return [{ type: SidepaneRef }, { type: i0.ElementRef }, { type: ExDialogService }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: IFeatureFlagsService }]; }, { containerRef: [{
            type: ViewChild,
            args: ['container', { static: false }]
        }], handleEElem: [{
            type: ViewChild,
            args: ['handleE', { static: true }]
        }], handleWElem: [{
            type: ViewChild,
            args: ['handleW', { static: true }]
        }], clickedOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }, {
            type: HostListener,
            args: ['document:mouseup', ['$event']]
        }], updateIsPickup: [{
            type: HostListener,
            args: ['document:updateIsPickup', ['$event']]
        }], openClose: [{
            type: HostBinding,
            args: ['@openClose']
        }], openCloseDone: [{
            type: HostListener,
            args: ['@openClose.done']
        }], disabledSidepaneButtons: [{
            type: HostListener,
            args: ['document:disabledSidepaneButtons', ['$event']]
        }] }); })();

class ExSidepaneModule {
    static { this.ɵfac = function ExSidepaneModule_Factory(t) { return new (t || ExSidepaneModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSidepaneModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExCloseModule,
            A11yModule,
            TranslateModule,
            ExDirectivesModule,
            ExSvgIconModule,
            AngularDraggableModule,
            EXPipesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidepaneModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExCloseModule,
                    A11yModule,
                    TranslateModule,
                    ExDirectivesModule,
                    ExSvgIconModule,
                    AngularDraggableModule,
                    EXPipesModule
                ],
                declarations: [
                    ExSidepaneComponent
                ],
                exports: [
                    ExSidepaneComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSidepaneModule, { declarations: [ExSidepaneComponent], imports: [CommonModule,
        ExCloseModule,
        A11yModule,
        TranslateModule,
        ExDirectivesModule,
        ExSvgIconModule,
        AngularDraggableModule,
        EXPipesModule], exports: [ExSidepaneComponent] }); })();

function ExSummarySectionComponent_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("size", ctx_r0.svgIconSize)("iconName", ctx_r0.iconName)("color", ctx_r0.iconColor);
} }
function ExSummarySectionComponent_ex_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 16);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconType", ctx_r1.iconType)("iconName", ctx_r1.iconName)("color", ctx_r1.iconColor);
} }
function ExSummarySectionComponent_ex_label_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-label", 17);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r2.subTitleLabel)("value", ctx_r2.subTitleValue);
} }
function ExSummarySectionComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.count, "");
} }
function ExSummarySectionComponent_ex_spinner_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 19);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 25);
} }
function ExSummarySectionComponent_ex_icon_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-icon", 20);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("exTooltip", i0.ɵɵpipeBind1(1, 1, "ng.general.expand"));
} }
const _c0$2 = function (a0) { return { "ex-summary-section-header-hover": a0 }; };
const _c1$1 = ["*"];
class ExSummarySectionComponent {
    get iconType() {
        return this._iconType;
    }
    set iconType(value) {
        this._iconType = value || 'svg';
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
        this.elementRef.nativeElement.title = "";
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.titleColor = 'white';
        this.iconColor = 'white';
        this.svgIconSize = 'medium';
        this.additionalInformationForCollapsedSidenav = '';
        this.isLoading = false;
        this.isTitleUpperCase = true;
        this.onEditClicked = new EventEmitter();
        this._iconType = 'svg';
    }
    ngOnInit() {
    }
    editClicked() {
        this.onEditClicked.emit();
    }
    static { this.ɵfac = function ExSummarySectionComponent_Factory(t) { return new (t || ExSummarySectionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExSummarySectionComponent, selectors: [["ex-summary-section"]], inputs: { subTitleLabel: "subTitleLabel", subTitleValue: "subTitleValue", titleColor: "titleColor", iconColor: "iconColor", iconName: "iconName", svgIconSize: "svgIconSize", additionalInformationForCollapsedSidenav: "additionalInformationForCollapsedSidenav", color: "color", count: "count", isLoading: "isLoading", editSidePaneComponent: "editSidePaneComponent", editSidePaneInputs: "editSidePaneInputs", editSidePaneEvents: "editSidePaneEvents", isTitleUpperCase: "isTitleUpperCase", iconType: "iconType", title: "title" }, outputs: { onEditClicked: "onEditClicked" }, ngContentSelectors: _c1$1, decls: 20, vars: 21, consts: [[1, "ex-summary-section-wrapper"], [1, "ex-summary-section-header", 3, "ngClass", "disabled", "click"], [1, "ex-summary-section-header-overlay"], [1, "ex-summary-section-header-left"], [3, "size", "iconName", "color", 4, "ngIf"], ["sizePx", "18px", 3, "iconType", "iconName", "color", 4, "ngIf"], [1, "ex-summary-section-title-wrapper"], [1, "ex-summary-section-title"], ["class", "ex-summary-section-sub-title", 3, "label", "value", 4, "ngIf"], [1, "ex-summary-section-header-right"], ["class", "ex-summary-section-count", 4, "ngIf"], [3, "diameter", 4, "ngIf"], [1, "ex-summary-section-edit"], ["iconType", "uxf", "iconName", "uxf-resize-large", "color", "white", 3, "exTooltip", 4, "ngIf"], [1, "ex-summary-section-body"], [3, "size", "iconName", "color"], ["sizePx", "18px", 3, "iconType", "iconName", "color"], [1, "ex-summary-section-sub-title", 3, "label", "value"], [1, "ex-summary-section-count"], [3, "diameter"], ["iconType", "uxf", "iconName", "uxf-resize-large", "color", "white", 3, "exTooltip"]], template: function ExSummarySectionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function ExSummarySectionComponent_Template_button_click_1_listener() { return ctx.editSidePaneComponent ? ctx.editClicked() : ""; });
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, ExSummarySectionComponent_ex_svg_icon_4_Template, 1, 3, "ex-svg-icon", 4);
            i0.ɵɵtemplate(5, ExSummarySectionComponent_ex_icon_5_Template, 1, 3, "ex-icon", 5);
            i0.ɵɵelementStart(6, "div", 6)(7, "span", 7);
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "uppercase");
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, ExSummarySectionComponent_ex_label_12_Template, 1, 2, "ex-label", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 9);
            i0.ɵɵtemplate(14, ExSummarySectionComponent_div_14_Template, 2, 1, "div", 10);
            i0.ɵɵtemplate(15, ExSummarySectionComponent_ex_spinner_15_Template, 1, 1, "ex-spinner", 11);
            i0.ɵɵelementStart(16, "div", 12);
            i0.ɵɵtemplate(17, ExSummarySectionComponent_ex_icon_17_Template, 2, 3, "ex-icon", 13);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(18, "div", 14);
            i0.ɵɵprojection(19);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("background", ctx.color);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c0$2, ctx.editSidePaneComponent))("disabled", !ctx.editSidePaneComponent);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.iconType == "svg");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconType != "svg");
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("color", ctx.titleColor);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.isTitleUpperCase ? i0.ɵɵpipeBind1(9, 13, i0.ɵɵpipeBind1(10, 15, ctx.title)) : i0.ɵɵpipeBind1(11, 17, ctx.title));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.subTitleLabel || ctx.subTitleValue);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isLoading && ctx.count !== null && ctx.count !== undefined);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isLoading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !!ctx.editSidePaneComponent);
        } }, dependencies: [i1$5.NgClass, i1$5.NgIf, ExIconComponent, ExSpinnerComponent, ExSvgIconComponent, ExLabelComponent, ExTooltipDirective, i1$5.UpperCasePipe, i1$2.TranslatePipe], styles: [".ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]{height:55px;display:flex;border:0px;width:100%;flex-direction:row;align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;justify-content:space-between}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-left[_ngcontent-%COMP%]{display:flex;align-items:center;flex:1;padding-inline-start:17px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-left[_ngcontent-%COMP%]   ex-icon[_ngcontent-%COMP%]{display:flex}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-left[_ngcontent-%COMP%]   .ex-summary-section-title-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-inline-start:12px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-left[_ngcontent-%COMP%]   .ex-summary-section-title-wrapper[_ngcontent-%COMP%]   .ex-summary-section-title[_ngcontent-%COMP%]{align-self:flex-start;line-height:16px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-left[_ngcontent-%COMP%]   .ex-summary-section-title-wrapper[_ngcontent-%COMP%]   .ex-summary-section-sub-title[_ngcontent-%COMP%]{line-height:16px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-right[_ngcontent-%COMP%]{display:flex;align-items:center;margin-inline-end:15px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-right[_ngcontent-%COMP%]   .ex-summary-section-count[_ngcontent-%COMP%]{width:25px;height:25px;align-items:center;justify-content:center;display:flex;border:2.5px solid white;border-radius:50%;color:#fff;font-weight:400;margin-right:10px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-right[_ngcontent-%COMP%]   ex-spinner[_ngcontent-%COMP%]{margin-right:10px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-right[_ngcontent-%COMP%]   ex-spinner[_ngcontent-%COMP%]     .mat-mdc-progress-spinner svg circle{stroke:#fefefe}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header[_ngcontent-%COMP%]   .ex-summary-section-header-right[_ngcontent-%COMP%]   .ex-summary-section-edit[_ngcontent-%COMP%]{cursor:pointer}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header-hover[_ngcontent-%COMP%]{position:relative;cursor:pointer}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header-hover[_ngcontent-%COMP%]   .ex-summary-section-header-overlay[_ngcontent-%COMP%]{position:absolute}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-header-hover[_ngcontent-%COMP%]:hover   .ex-summary-section-header-overlay[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#000;opacity:.1;border-top-left-radius:5px;border-top-right-radius:5px}.ex-summary-section-wrapper[_ngcontent-%COMP%]   .ex-summary-section-body[_ngcontent-%COMP%]{background:#fff;padding:15px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSummarySectionComponent, [{
        type: Component,
        args: [{ selector: 'ex-summary-section', template: "<div class=\"ex-summary-section-wrapper\">\n    <button class=\"ex-summary-section-header\" [ngClass]=\"{ 'ex-summary-section-header-hover': editSidePaneComponent }\"\n        [style.background]=\"color\" (click)=\"editSidePaneComponent ? editClicked() : ''\"\n        [disabled]=\"!editSidePaneComponent\">\n        <div class=\"ex-summary-section-header-overlay\"></div>\n        <div class=\"ex-summary-section-header-left\">\n            <ex-svg-icon *ngIf=\"iconType=='svg'\" [size]=\"svgIconSize\" [iconName]=\"iconName\" [color]=\"iconColor\">\n            </ex-svg-icon>\n            <ex-icon *ngIf=\"iconType!='svg'\" [iconType]=\"iconType\" [iconName]=\"iconName\" [color]=\"iconColor\"\n                sizePx=\"18px\">\n            </ex-icon>\n            <div class=\"ex-summary-section-title-wrapper\" [style.color]=\"titleColor\">\n                <span class=\"ex-summary-section-title\">{{ isTitleUpperCase ? (title | translate | uppercase) : (title | translate)}}</span>\n                <ex-label *ngIf=\"subTitleLabel || subTitleValue\" class=\"ex-summary-section-sub-title\"\n                    [label]=\"subTitleLabel\" [value]=\"subTitleValue\"></ex-label>\n            </div>\n        </div>\n        <div class=\"ex-summary-section-header-right\">\n            <div class=\"ex-summary-section-count\" *ngIf=\"!isLoading && count !== null && count !== undefined\">\n                {{ count }}</div>\n            <ex-spinner *ngIf=\"isLoading\" [diameter]=\"25\"></ex-spinner>\n            <div class=\"ex-summary-section-edit\">\n                <ex-icon *ngIf=\"!!editSidePaneComponent\" [exTooltip]=\"'ng.general.expand' | translate\" iconType=\"uxf\"\n                    iconName=\"uxf-resize-large\" color=\"white\"></ex-icon>\n            </div>\n        </div>\n    </button>\n    <div class=\"ex-summary-section-body\">\n        <ng-content></ng-content>\n    </div>\n</div>\n", styles: [".ex-summary-section-wrapper .ex-summary-section-header{height:55px;display:flex;border:0px;width:100%;flex-direction:row;align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;justify-content:space-between}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-left{display:flex;align-items:center;flex:1;padding-inline-start:17px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-left ex-icon{display:flex}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-left .ex-summary-section-title-wrapper{display:flex;flex-direction:column;padding-inline-start:12px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-left .ex-summary-section-title-wrapper .ex-summary-section-title{align-self:flex-start;line-height:16px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-left .ex-summary-section-title-wrapper .ex-summary-section-sub-title{line-height:16px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-right{display:flex;align-items:center;margin-inline-end:15px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-right .ex-summary-section-count{width:25px;height:25px;align-items:center;justify-content:center;display:flex;border:2.5px solid white;border-radius:50%;color:#fff;font-weight:400;margin-right:10px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-right ex-spinner{margin-right:10px}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-right ex-spinner ::ng-deep .mat-mdc-progress-spinner svg circle{stroke:#fefefe}.ex-summary-section-wrapper .ex-summary-section-header .ex-summary-section-header-right .ex-summary-section-edit{cursor:pointer}.ex-summary-section-wrapper .ex-summary-section-header-hover{position:relative;cursor:pointer}.ex-summary-section-wrapper .ex-summary-section-header-hover .ex-summary-section-header-overlay{position:absolute}.ex-summary-section-wrapper .ex-summary-section-header-hover:hover .ex-summary-section-header-overlay{width:100%;height:100%;background-color:#000;opacity:.1;border-top-left-radius:5px;border-top-right-radius:5px}.ex-summary-section-wrapper .ex-summary-section-body{background:#fff;padding:15px}\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { subTitleLabel: [{
            type: Input
        }], subTitleValue: [{
            type: Input
        }], titleColor: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], iconName: [{
            type: Input
        }], svgIconSize: [{
            type: Input
        }], additionalInformationForCollapsedSidenav: [{
            type: Input
        }], color: [{
            type: Input
        }], count: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], editSidePaneComponent: [{
            type: Input
        }], editSidePaneInputs: [{
            type: Input
        }], editSidePaneEvents: [{
            type: Input
        }], isTitleUpperCase: [{
            type: Input
        }], onEditClicked: [{
            type: Output
        }], iconType: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

class ExSummarySectionModule {
    static { this.ɵfac = function ExSummarySectionModule_Factory(t) { return new (t || ExSummarySectionModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExSummarySectionModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ExIconModule,
            TranslateModule,
            ExSpinnerModule,
            MatTooltipModule,
            ExSvgIconModule,
            ExLabelModule,
            ExDirectivesModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSummarySectionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ExIconModule,
                    TranslateModule,
                    ExSpinnerModule,
                    MatTooltipModule,
                    ExSvgIconModule,
                    ExLabelModule,
                    ExDirectivesModule
                ],
                declarations: [
                    ExSummarySectionComponent
                ],
                exports: [
                    ExSummarySectionComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExSummarySectionModule, { declarations: [ExSummarySectionComponent], imports: [CommonModule,
        ExIconModule,
        TranslateModule,
        ExSpinnerModule,
        MatTooltipModule,
        ExSvgIconModule,
        ExLabelModule,
        ExDirectivesModule], exports: [ExSummarySectionComponent] }); })();

class ExColorPickerComponent extends ExControlValueAccessor {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        /**
         * the selected hex rgb code
         */
        this.selectedColor = '';
        /**
         * tooltip that will be displayed when overing the color input area
         */
        this.tooltip = "ng.general.color_picker_text_tooltip";
        /**
         * whether display colorTextTooltip or not
         */
        this.hasTooltip = true;
        /**
         * Emits color has changed
         */
        this.selectedColorChange = new EventEmitter();
        /**
         * Emits color has been saved
         */
        this.colorSaved = new EventEmitter();
        this.isColorValid = true;
    }
    setDisabledState(isDisabled) {
        super.setDisabledState(isDisabled);
        this.cdr.markForCheck();
    }
    setValidState(isValid) {
        this.valid = isValid;
        this.cdr.markForCheck();
    }
    writeValue(value) {
        this.selectedColor = value;
        this.cdr.markForCheck();
    }
    onColorChanged(event) {
        this.selectedColor = event;
        this.selectedColorChange.emit(event);
    }
    onColorSaved(event) {
        if (this.validateColor(event)) {
            this.selectedColor = event;
            this.colorSaved.emit(event);
        }
    }
    validateColor(color) {
        var reg = /^#([0-9A-F]{6}|[0-9A-F]{3})$/i;
        /**
         * ^          -> match beginning
         * #          -> a hash
         * [0-9A-F]   -> any integer from 0 to 9 and any letter from A to F
         * {6}        -> the previous group appears exactly 6 times
         * $          -> match end
         * i          -> ignore case
         */
        this.isColorValid = reg.test(color);
        return this.isColorValid;
    }
    static { this.ɵfac = function ExColorPickerComponent_Factory(t) { return new (t || ExColorPickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExColorPickerComponent, selectors: [["ex-color-picker"]], hostBindings: function ExColorPickerComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedColorChange", function ExColorPickerComponent_selectedColorChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExColorPickerComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { selectedColor: "selectedColor", tooltip: "tooltip", hasTooltip: "hasTooltip" }, outputs: { selectedColorChange: "selectedColorChange", colorSaved: "colorSaved" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 7, consts: [[1, "ex-color-picker-wrapper"], [1, "sel-color-text", "ex-color-picker-text", 3, "text", "valid", "hasTooltip", "toolTipPrefix", "hasBorder", "editableTextSaved", "editableTextChanged"], [1, "ex-color-picker-box"]], template: function ExColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ex-editable-text", 1);
            i0.ɵɵlistener("editableTextSaved", function ExColorPickerComponent_Template_ex_editable_text_editableTextSaved_1_listener($event) { return ctx.onColorSaved($event); })("editableTextChanged", function ExColorPickerComponent_Template_ex_editable_text_editableTextChanged_1_listener($event) { return ctx.onColorChanged($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("text", ctx.selectedColor)("valid", ctx.isColorValid)("hasTooltip", ctx.hasTooltip)("toolTipPrefix", ctx.tooltip)("hasBorder", false);
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("background-color", ctx.selectedColor);
        } }, dependencies: [ExEditableTextComponent], styles: [".ex-color-picker-box[_ngcontent-%COMP%]{margin-inline-start:30px;border:1px solid #ccc;border-radius:4px}.ex-color-picker-text[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:4px}.ex-color-picker-wrapper[_ngcontent-%COMP%]{display:flex}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExColorPickerComponent, [{
        type: Component,
        args: [{ selector: 'ex-color-picker', host: {
                    '(selectedColorChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ex-color-picker-wrapper\">\n  <ex-editable-text class=\"sel-color-text ex-color-picker-text\" [text]=\"selectedColor\"\n                    [valid]=\"isColorValid\" (editableTextSaved)=\"onColorSaved($event)\"  [hasTooltip]=\"hasTooltip\" [toolTipPrefix]=\"tooltip\"\n                    (editableTextChanged)=\"onColorChanged($event)\" [hasBorder]=\"false\">\n  </ex-editable-text>\n  <div class=\"ex-color-picker-box\" [style.background-color]=\"selectedColor\"></div>\n</div>\n", styles: [".ex-color-picker-box{margin-inline-start:30px;border:1px solid #ccc;border-radius:4px}.ex-color-picker-text{border:1px solid #ccc;border-radius:4px}.ex-color-picker-wrapper{display:flex}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { selectedColor: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], hasTooltip: [{
            type: Input
        }], selectedColorChange: [{
            type: Output
        }], colorSaved: [{
            type: Output
        }] }); })();

class ExColorPickerModule {
    static { this.ɵfac = function ExColorPickerModule_Factory(t) { return new (t || ExColorPickerModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExColorPickerModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatTooltipModule,
            ExDirectivesModule,
            TranslateModule,
            MatIconModule,
            ExIconModule,
            ExEditableTextModule,
            ExSvgIconModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExColorPickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    ExDirectivesModule,
                    TranslateModule,
                    MatIconModule,
                    ExIconModule,
                    ExEditableTextModule,
                    ExSvgIconModule
                ],
                declarations: [
                    ExColorPickerComponent
                ],
                exports: [
                    ExColorPickerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExColorPickerModule, { declarations: [ExColorPickerComponent], imports: [CommonModule,
        MatTooltipModule,
        ExDirectivesModule,
        TranslateModule,
        MatIconModule,
        ExIconModule,
        ExEditableTextModule,
        ExSvgIconModule], exports: [ExColorPickerComponent] }); })();

const _c0$1 = ["appAceEditor"];
const _c1 = function (a0) { return { "hide-cursor": a0 }; };
const defaultOptions = {
    mode: "ace/mode/xml",
    theme: "ace/theme/textmate",
    showPrintMargin: false,
    useWorker: true,
    enableKeyboardAccessibility: true,
};
class ExAceEditorComponent {
    constructor() {
        /**
         * showCursor - Indicates whether to hide or show the cursor (defaults to true)
         */
        this.showCursor = true;
        this._data = "";
        /**
         * Emits the data updated via the editor
         */
        this.onDataChanged = new EventEmitter();
        /**
         * Emits the xPath updated via the editor
         */
        this.onXPathChanged = new EventEmitter();
    }
    /**
     * data - The input data to display in the editor
     */
    set data(value) {
        this._data = value;
        if (this.aceEditor != undefined) {
            if (this._data != this.aceEditor.session.getValue()) {
                this.aceEditor.session.setValue(value);
            }
        }
    }
    get data() {
        return this._data;
    }
    /**
     * options - The Ace editor configuration options
     * See Configuring-Ace wiki<https://github.com/ajaxorg/ace/wiki/Configuring-Ace> page for detailed list of options.
     */
    set options(userOptions) {
        this._options = { ...defaultOptions, ...userOptions };
        console.log('this._options');
        console.log(this._options);
    }
    get options() {
        if (this._options == undefined) {
            this._options = defaultOptions;
        }
        return this._options;
    }
    ngAfterViewInit() {
        this._initEditors();
    }
    async _initEditors() {
        let prettyPrint = {
            name: 'prettyPrint',
            bindKey: { win: 'Ctrl-Shift-F' },
            exec: function (editor) {
                beautify.beautify(editor.session);
            },
        };
        let currentXmlPath = {
            name: 'currentXmlPath',
            bindKey: { win: 'Ctrl-Shift-H' },
            exec: (editor) => {
                this.updateXPath(editor);
            }
        };
        this.aceEditor = ace.edit(this.divEditor.nativeElement, this.options);
        console.log('aceEditor - after edit');
        console.log(this._options);
        this.aceEditor.on("change", () => {
            this.data = this.aceEditor.session.getValue();
            this.onDataChanged.emit(this.data);
        });
        if (this.onXPathChanged.observed) {
            this.aceEditor.on("click", () => {
                this.updateXPath(this.aceEditor);
            });
        }
        this.aceEditor.commands.addCommand(prettyPrint);
        this.aceEditor.commands.addCommand(currentXmlPath);
        this.aceEditor.session.setValue(this._data);
    }
    resize() {
        this.aceEditor.resize(true);
    }
    updateXPath(editor) {
        var cursor = editor.getCursorPosition();
        var currentToken = editor.getSession().getTokenAt(cursor.row, cursor.column);
        const TokenIterator = ace.require("ace/token_iterator").TokenIterator;
        var stream = new TokenIterator(editor.session, 0, 0);
        var token = stream.getCurrentToken();
        var xPath = [];
        var skipNext = false;
        while (token) {
            if (stream.getCurrentTokenRow() == cursor.row && token === currentToken) {
                if (token.type == 'string.attribute-value.xml') {
                    stream.stepBackward();
                    const parent = stream.stepBackward();
                    xPath.push('@' + parent.value);
                }
                else if (token.type == 'meta.tag.tag-name.xml' && !skipNext) {
                    xPath.push(token.value);
                }
                break;
            }
            switch (token.type) {
                case 'meta.tag.punctuation.end-tag-open.xml': {
                    skipNext = true;
                    break;
                }
                case 'meta.tag.punctuation.tag-close.xml': {
                    if (token.value == '/>') {
                        xPath.pop();
                    }
                    break;
                }
                case 'meta.tag.punctuation.tag-open.xml': {
                    skipNext = false;
                    break;
                }
                case 'meta.tag.tag-name.xml': {
                    if (!skipNext) {
                        xPath.push(token.value);
                    }
                    else {
                        while (xPath.length > 0 && xPath[xPath.length - 1] != token.value) {
                            xPath.pop();
                        }
                        if (xPath[xPath.length - 1] == token.value) {
                            xPath.pop();
                        }
                    }
                    break;
                }
            }
            token = stream.stepForward();
        }
        console.log(`xPath: ${xPath.join('/')}`);
        this.onXPathChanged.emit('/' + xPath.join('/'));
    }
    static { this.ɵfac = function ExAceEditorComponent_Factory(t) { return new (t || ExAceEditorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExAceEditorComponent, selectors: [["ex-ace-editor"]], viewQuery: function ExAceEditorComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.divEditor = _t.first);
        } }, inputs: { showCursor: "showCursor", data: "data", options: "options" }, outputs: { onDataChanged: "onDataChanged", onXPathChanged: "onXPathChanged" }, decls: 2, vars: 3, consts: [[1, "app-ace-editor", 3, "ngClass"], ["appAceEditor", ""]], template: function ExAceEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", 0, 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, !ctx.showCursor));
        } }, dependencies: [i1$5.NgClass], styles: [".app-ace-editor[_ngcontent-%COMP%]{width:100%;height:100%;border-right:1px solid #f2f2f2}.hide-cursor[_ngcontent-%COMP%]     .ace_cursor{opacity:0!important}.hide-cursor[_ngcontent-%COMP%]     .ace_hidden-cursors{opacity:0!important}.hide-cursor[_ngcontent-%COMP%]     .ace_marker-layer .ace_selection{background:none!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAceEditorComponent, [{
        type: Component,
        args: [{ selector: 'ex-ace-editor', template: "<div class=\"app-ace-editor\" #appAceEditor [ngClass]=\"{ 'hide-cursor' : !showCursor }\"></div>", styles: [".app-ace-editor{width:100%;height:100%;border-right:1px solid #f2f2f2}.hide-cursor ::ng-deep .ace_cursor{opacity:0!important}.hide-cursor ::ng-deep .ace_hidden-cursors{opacity:0!important}.hide-cursor ::ng-deep .ace_marker-layer .ace_selection{background:none!important}\n"] }]
    }], null, { showCursor: [{
            type: Input
        }], data: [{
            type: Input
        }], options: [{
            type: Input
        }], onDataChanged: [{
            type: Output
        }], onXPathChanged: [{
            type: Output
        }], divEditor: [{
            type: ViewChild,
            args: ["appAceEditor"]
        }] }); })();

class ExAceEditorModule {
    static { this.ɵfac = function ExAceEditorModule_Factory(t) { return new (t || ExAceEditorModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExAceEditorModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExAceEditorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ExAceEditorComponent
                ],
                exports: [
                    ExAceEditorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExAceEditorModule, { declarations: [ExAceEditorComponent], imports: [CommonModule], exports: [ExAceEditorComponent] }); })();

const _c0 = ["dialogRef"];
function ExDialogComboboxComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.placeholder));
} }
function ExDialogComboboxComponent_ex_svg_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-svg-icon", 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r1.disabled ? "#d7d7d7" : "#4164a4");
} }
function ExDialogComboboxComponent_ng_template_5_ex_spinner_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ex-spinner", 20);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 25);
} }
function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ex-group-outlet-2", 21);
    i0.ɵɵlistener("itemsAdded", function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template_ex_group_outlet_2_itemsAdded_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.itemsAdded($event, false)); })("itemsRemoved", function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template_ex_group_outlet_2_itemsRemoved_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.itemsRemoved($event, false)); })("itemAdded", function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template_ex_group_outlet_2_itemAdded_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9._itemAdded($event, false)); })("itemRemoved", function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template_ex_group_outlet_2_itemRemoved_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.itemRemoved($event, false)); })("itemRemovedWithoutEmit", function ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template_ex_group_outlet_2_itemRemovedWithoutEmit_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.itemRemoved($event, false)); });
    i0.ɵɵpipe(1, "filterItems");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("items", ctx_r5.searchTextChanged() ? ctx_r5.externalFiltering ? ctx_r5.items : i0.ɵɵpipeBind2(1, 5, ctx_r5.items, ctx_r5.searchText) : null)("searchText", ctx_r5.searchText)("hasSelectAll", true)("isMultiSelect", ctx_r5._isMultiSelect)("selectedItems", ctx_r5.selectedItems);
} }
function ExDialogComboboxComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-dialog-content", 9)(5, "div", 10)(6, "ex-search", 11);
    i0.ɵɵlistener("searchTextChange", function ExDialogComboboxComponent_ng_template_5_Template_ex_search_searchTextChange_6_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.searchText = $event); })("searchTriggered", function ExDialogComboboxComponent_ng_template_5_Template_ex_search_searchTriggered_6_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14._searchTextChange($event)); })("click", function ExDialogComboboxComponent_ng_template_5_Template_ex_search_click_6_listener($event) { return $event.stopPropagation(); })("keydown", function ExDialogComboboxComponent_ng_template_5_Template_ex_search_keydown_6_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onSearchKeyDown($event)); });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵlistener("keydown", function ExDialogComboboxComponent_ng_template_5_Template_div_keydown_8_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onMenuKeyDown($event)); });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtemplate(10, ExDialogComboboxComponent_ng_template_5_ex_spinner_10_Template, 1, 1, "ex-spinner", 13);
    i0.ɵɵtemplate(11, ExDialogComboboxComponent_ng_template_5_ex_group_outlet_2_11_Template, 2, 8, "ex-group-outlet-2", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 15)(13, "ex-combobox-multiselect-trigger", 16);
    i0.ɵɵlistener("itemRemoved", function ExDialogComboboxComponent_ng_template_5_Template_ex_combobox_multiselect_trigger_itemRemoved_13_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.itemRemoved($event, false)); })("itemsRemoved", function ExDialogComboboxComponent_ng_template_5_Template_ex_combobox_multiselect_trigger_itemsRemoved_13_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.itemsRemoved($event, false)); });
    i0.ɵɵpipe(14, "selectedItemsTransform");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "mat-dialog-actions", 17)(16, "ex-button", 18);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "ex-button", 19);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 14, ctx_r3.title));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 16, ctx_r3.searchPlaceholder));
    i0.ɵɵproperty("incremental", true)("searchText", ctx_r3.searchText);
    i0.ɵɵattribute("aria-activedescendant", "ex_dialog_combobox_listbox_0");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "ex_dialog_combobox_listbox_0");
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 18, "ng.general.searchResults"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.loading);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectedItems", i0.ɵɵpipeBind2(14, 20, ctx_r3.selectedItems, ctx_r3.items));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("mat-dialog-close", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 23, "ng.general.cancel"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 25, "ng.general.done"), "");
} }
class ExDialogComboboxComponent extends ExGenericCombobox {
    constructor(sectionLayoutViewModeObservable, changeDetectorRef, hasFormFieldsBorder, dialog) {
        super(sectionLayoutViewModeObservable, changeDetectorRef, hasFormFieldsBorder);
        this.sectionLayoutViewModeObservable = sectionLayoutViewModeObservable;
        this.changeDetectorRef = changeDetectorRef;
        this.hasFormFieldsBorder = hasFormFieldsBorder;
        this.dialog = dialog;
        this.searchPlaceholder = 'ng.combobox-search-placeholder';
        this.title = '';
        this.loading = false;
        this.doneClicked = new EventEmitter();
        this.selectedBeforeChanges = this.selectedItems;
        this.isDialogOpen = false;
    }
    ngOnInit() {
        this._isMultiSelect = true;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('selectedItems')) {
            this.selectedBeforeChanges = this.selectedItems.slice();
        }
    }
    openDialog() {
        this.isDialogOpen = true;
        this.dialog.open(this.dialogRef, {
            width: '60vw',
            disableClose: true,
            closeOnNavigation: true
        }).afterClosed().subscribe((res) => this.handleClose(res));
    }
    handleClose(isConfirm) {
        if (isConfirm) {
            this.saveChanges();
            this.selectedBeforeChanges = this.selectedItems.slice();
            this.doneClicked.emit(this.selectedItems);
        }
        else {
            this.selectedItems = this.selectedBeforeChanges.slice();
        }
        this.reset();
    }
    reset() {
        this.searchText = '';
        this.isDialogOpen = false;
        this.changeDetectorRef.markForCheck();
    }
    static { this.ɵfac = function ExDialogComboboxComponent_Factory(t) { return new (t || ExDialogComboboxComponent)(i0.ɵɵdirectiveInject(VIEW_MODE_OBSERVABLE, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(HAS_FORM_FIELDS_BORDERS, 8), i0.ɵɵdirectiveInject(i1$7.MatDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExDialogComboboxComponent, selectors: [["ex-dialog-combobox"]], viewQuery: function ExDialogComboboxComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogRef = _t.first);
        } }, hostBindings: function ExDialogComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("selectedItemsChange", function ExDialogComboboxComponent_selectedItemsChange_HostBindingHandler($event) { return ctx.controlOnChange($event); })("blur", function ExDialogComboboxComponent_blur_HostBindingHandler($event) { return ctx.controlOnTouched($event); });
        } }, inputs: { searchPlaceholder: "searchPlaceholder", title: "title", loading: "loading" }, outputs: { doneClicked: "doneClicked" }, features: [i0.ɵɵProvidersFeature(getValueAccessors(ExDialogComboboxComponent)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 7, vars: 10, consts: [[1, "ex-dialog-combobox-button", 3, "disabled", "click"], ["class", "ex-dialog-combobox-button-placeholder", 4, "ngIf"], [3, "selectedItems", "isReadOnly"], ["class", "ex-dialog-combobox-button-icon", "iconName", "svg-leganto", 3, "color", 4, "ngIf"], ["dialogRef", ""], [1, "ex-dialog-combobox-button-placeholder"], ["iconName", "svg-leganto", 1, "ex-dialog-combobox-button-icon", 3, "color"], ["id", "ex-dialog-combobox-control"], ["mat-dialog-title", ""], [1, "ex-dialog-combobox-content-wrapper"], [1, "ex-dialog-combobox-selection-wrapper"], [3, "incremental", "searchText", "placeholder", "searchTextChange", "searchTriggered", "click", "keydown"], ["role", "listbox", 1, "ex-dialog-combobox-selection-options-wrapper", 3, "id", "keydown"], ["class", "ex-dialog-combobox-loading-spinner", 3, "diameter", 4, "ngIf"], [3, "items", "searchText", "hasSelectAll", "isMultiSelect", "selectedItems", "itemsAdded", "itemsRemoved", "itemAdded", "itemRemoved", "itemRemovedWithoutEmit", 4, "ngIf"], [1, "ex-dialog-combobox-selected-area"], [3, "selectedItems", "itemRemoved", "itemsRemoved"], ["align", "end", 1, "ex-dialog-combobox-buttons"], ["type2", "secondary", 3, "mat-dialog-close"], ["type2", "primary", 3, "mat-dialog-close"], [1, "ex-dialog-combobox-loading-spinner", 3, "diameter"], [3, "items", "searchText", "hasSelectAll", "isMultiSelect", "selectedItems", "itemsAdded", "itemsRemoved", "itemAdded", "itemRemoved", "itemRemovedWithoutEmit"]], template: function ExDialogComboboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function ExDialogComboboxComponent_Template_button_click_0_listener() { return ctx.openDialog(); });
            i0.ɵɵtemplate(1, ExDialogComboboxComponent_span_1_Template, 3, 3, "span", 1);
            i0.ɵɵelement(2, "ex-combobox-multiselect-trigger", 2);
            i0.ɵɵpipe(3, "selectedItemsTransform");
            i0.ɵɵtemplate(4, ExDialogComboboxComponent_ex_svg_icon_4_Template, 1, 1, "ex-svg-icon", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ExDialogComboboxComponent_ng_template_5_Template, 22, 27, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.readOnly || ctx.disabled);
            i0.ɵɵattribute("aria-expanded", ctx.isDialogOpen)("aria-controls", "ex-dialog-combobox-control");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.selectedBeforeChanges == null ? null : ctx.selectedBeforeChanges.length));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("selectedItems", i0.ɵɵpipeBind2(3, 7, ctx.selectedBeforeChanges, ctx.items))("isReadOnly", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
        } }, dependencies: [i1$5.NgIf, ExSearchComponent, ExSvgIconComponent, ExGroupOutletComponent2, ExComboboxMultiselectTriggerComponent, i1$7.MatDialogClose, i1$7.MatDialogTitle, i1$7.MatDialogContent, i1$7.MatDialogActions, ExButtonComponent, ExSpinnerComponent, i1$2.TranslatePipe, FilterItemsPipe, SelectedItemsTransformPipe], styles: [".ex-dialog-combobox-button[_ngcontent-%COMP%]{background-color:#fff!important;border:1px solid #ccc;display:flex;-webkit-user-select:text;user-select:text;border-radius:3px;padding:0 10px;align-items:center;justify-content:space-between;width:-webkit-fill-available;line-height:32px}.ex-dialog-combobox-button[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square{background:none!important;border:none;border-radius:unset}.ex-dialog-combobox-button[_ngcontent-%COMP%]   .ex-dialog-combobox-button-placeholder[_ngcontent-%COMP%]{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-dialog-combobox-button[_ngcontent-%COMP%]   .ex-dialog-combobox-button-icon[_ngcontent-%COMP%]{margin-inline-start:8px}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]{display:flex;height:54vh}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1;padding-top:1px}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-options-wrapper[_ngcontent-%COMP%]{margin-top:8px;border:1px solid #e0e0e0;border-radius:3px;padding:2px;overflow-y:auto;overflow-x:hidden;height:100%;display:flex}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-options-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-loading-spinner[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex:1}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selection-options-wrapper[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:first-child{flex:1}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]{flex:1;border:1px solid #e0e0e0;border-radius:3px;padding:15px;margin-inline-start:10px;overflow:auto}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-dialog-combobox-multiselect-trigger{width:100%}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-wrapper:first-child{width:100%;flex-direction:column}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-chip{width:100%;margin-inline-end:0}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-wrapper-chip{width:100%}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-wrapper-chip .ex-combobox-multiselect-trigger-chip-group-wrapper{width:100%}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-chip-square{width:100%;justify-content:flex-start}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square{width:100%;justify-content:space-between;background:none!important;border:none;border-radius:unset;padding-inline-end:2px!important}.ex-dialog-combobox-content-wrapper[_ngcontent-%COMP%]   .ex-dialog-combobox-selected-area[_ngcontent-%COMP%]     .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square .ex-chip-icon-left{display:none}.ex-dialog-combobox-buttons[_ngcontent-%COMP%]{gap:.5rem}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogComboboxComponent, [{
        type: Component,
        args: [{ selector: 'ex-dialog-combobox', host: {
                    '(selectedItemsChange)': 'controlOnChange($event)',
                    '(blur)': 'controlOnTouched($event)'
                }, providers: getValueAccessors(ExDialogComboboxComponent), changeDetection: ChangeDetectionStrategy.OnPush, template: "<button class=\"ex-dialog-combobox-button\" [attr.aria-expanded]=\"isDialogOpen\" [attr.aria-controls]=\"'ex-dialog-combobox-control'\" (click)=\"openDialog()\" [disabled]=\"readOnly || disabled\">\n  <span *ngIf=\"!selectedBeforeChanges?.length\" class=\"ex-dialog-combobox-button-placeholder\">{{placeholder | translate}}</span>\n  <ex-combobox-multiselect-trigger\n       [selectedItems]=\"selectedBeforeChanges | selectedItemsTransform : items\" [isReadOnly]=\"true\">\n  </ex-combobox-multiselect-trigger>\n  <ex-svg-icon class=\"ex-dialog-combobox-button-icon\" *ngIf=\"!readOnly\" [color]=\"disabled ? '#d7d7d7': '#4164a4'\" iconName=\"svg-leganto\"></ex-svg-icon>\n</button>\n\n<ng-template #dialogRef>\n  <div id=\"ex-dialog-combobox-control\">\n    <div mat-dialog-title>{{title | translate}}</div>\n    <mat-dialog-content class=\"ex-dialog-combobox-content-wrapper\">\n      <div class=\"ex-dialog-combobox-selection-wrapper\">\n        <ex-search [incremental]=\"true\"\n                   [(searchText)]=\"searchText\"\n                   placeholder=\"{{ searchPlaceholder | translate }}\"\n                   (searchTriggered)=\"_searchTextChange($event)\"\n                   (click)=\"$event.stopPropagation()\"\n                   (keydown)=\"onSearchKeyDown($event)\"\n                   [attr.aria-activedescendant]=\"'ex_dialog_combobox_listbox_0'\">\n        </ex-search>\n        <div class='ex-dialog-combobox-selection-options-wrapper'\n             role=\"listbox\"\n             (keydown)=\"onMenuKeyDown($event)\"\n             [id]=\"'ex_dialog_combobox_listbox_0'\"\n             [attr.aria-label]=\"('ng.general.searchResults' | translate)\">\n          <ex-spinner *ngIf=\"loading\" class=\"ex-dialog-combobox-loading-spinner\" [diameter]=\"25\"></ex-spinner>\n          <ex-group-outlet-2\n            *ngIf=\"!loading\"\n            [items]=\"searchTextChanged() ? ( externalFiltering ? items : (items | filterItems: searchText)) : null\"\n            [searchText]=\"searchText\" [hasSelectAll]=\"true\" [isMultiSelect]=\"_isMultiSelect\"\n            [selectedItems]=\"selectedItems\"\n            (itemsAdded)=\"itemsAdded($event,false)\" (itemsRemoved)=\"itemsRemoved($event,false)\" (itemAdded)=\"_itemAdded($event,false)\"\n            (itemRemoved)=\"itemRemoved($event,false)\" (itemRemovedWithoutEmit)=\"itemRemoved($event, false)\">\n          </ex-group-outlet-2>\n        </div>\n      </div>\n      <div class=\"ex-dialog-combobox-selected-area\">\n        <ex-combobox-multiselect-trigger\n          [selectedItems]=\"selectedItems | selectedItemsTransform : items\"\n          (itemRemoved)=\"itemRemoved($event,false)\"\n          (itemsRemoved)=\"itemsRemoved($event,false)\"\n        >\n        </ex-combobox-multiselect-trigger>\n      </div>\n    </mat-dialog-content>\n    <mat-dialog-actions align=\"end\" class=\"ex-dialog-combobox-buttons\">\n      <ex-button type2=\"secondary\" [mat-dialog-close]=\"false\">\n        {{'ng.general.cancel' | translate}}</ex-button>\n      <ex-button type2=\"primary\" [mat-dialog-close]=\"true\">\n        {{'ng.general.done' | translate}}</ex-button>\n    </mat-dialog-actions>\n  </div>\n</ng-template>\n", styles: [".ex-dialog-combobox-button{background-color:#fff!important;border:1px solid #ccc;display:flex;-webkit-user-select:text;user-select:text;border-radius:3px;padding:0 10px;align-items:center;justify-content:space-between;width:-webkit-fill-available;line-height:32px}.ex-dialog-combobox-button ::ng-deep .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square{background:none!important;border:none;border-radius:unset}.ex-dialog-combobox-button .ex-dialog-combobox-button-placeholder{font-family:Roboto-light-italic,Fallback,sans-serif;font-style:italic}.ex-dialog-combobox-button .ex-dialog-combobox-button-icon{margin-inline-start:8px}.ex-dialog-combobox-content-wrapper{display:flex;height:54vh}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selection-wrapper{display:flex;flex-direction:column;flex:1;padding-top:1px}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selection-wrapper .ex-dialog-combobox-selection-options-wrapper{margin-top:8px;border:1px solid #e0e0e0;border-radius:3px;padding:2px;overflow-y:auto;overflow-x:hidden;height:100%;display:flex}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selection-wrapper .ex-dialog-combobox-selection-options-wrapper .ex-dialog-combobox-loading-spinner{display:flex;align-items:center;justify-content:center;flex:1}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selection-wrapper .ex-dialog-combobox-selection-options-wrapper :first-child{flex:1}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area{flex:1;border:1px solid #e0e0e0;border-radius:3px;padding:15px;margin-inline-start:10px;overflow:auto}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-dialog-combobox-multiselect-trigger{width:100%}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-wrapper:first-child{width:100%;flex-direction:column}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-chip{width:100%;margin-inline-end:0}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-wrapper-chip{width:100%}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-wrapper-chip .ex-combobox-multiselect-trigger-chip-group-wrapper{width:100%}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-chip-square{width:100%;justify-content:flex-start}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square{width:100%;justify-content:space-between;background:none!important;border:none;border-radius:unset;padding-inline-end:2px!important}.ex-dialog-combobox-content-wrapper .ex-dialog-combobox-selected-area ::ng-deep .ex-combobox-multiselect-trigger-chip-leaf .ex-chip-square .ex-chip-icon-left{display:none}.ex-dialog-combobox-buttons{gap:.5rem}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [VIEW_MODE_OBSERVABLE]
            }] }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [HAS_FORM_FIELDS_BORDERS]
            }] }, { type: i1$7.MatDialog }]; }, { searchPlaceholder: [{
            type: Input
        }], title: [{
            type: Input
        }], loading: [{
            type: Input
        }], doneClicked: [{
            type: Output
        }], dialogRef: [{
            type: ViewChild,
            args: ["dialogRef"]
        }] }); })();

class ExDialogComboboxModule {
    static { this.ɵfac = function ExDialogComboboxModule_Factory(t) { return new (t || ExDialogComboboxModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ExDialogComboboxModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatButtonModule,
            MatMenuModule,
            TranslateModule,
            EXPipesModule,
            ExCheckboxModule,
            ExSearchModule,
            ExCloseModule,
            ExSvgIconModule,
            FormsModule,
            ExIconModule,
            ExNewComboboxModule,
            MatDialogModule,
            ExButtonModule,
            ExSpinnerModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExDialogComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatMenuModule,
                    TranslateModule,
                    EXPipesModule,
                    ExCheckboxModule,
                    ExSearchModule,
                    ExCloseModule,
                    ExSvgIconModule,
                    FormsModule,
                    ExIconModule,
                    ExNewComboboxModule,
                    MatDialogModule,
                    ExButtonModule,
                    ExSpinnerModule
                ],
                declarations: [
                    ExDialogComboboxComponent
                ],
                exports: [
                    ExDialogComboboxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ExDialogComboboxModule, { declarations: [ExDialogComboboxComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        TranslateModule,
        EXPipesModule,
        ExCheckboxModule,
        ExSearchModule,
        ExCloseModule,
        ExSvgIconModule,
        FormsModule,
        ExIconModule,
        ExNewComboboxModule,
        MatDialogModule,
        ExButtonModule,
        ExSpinnerModule], exports: [ExDialogComboboxComponent] }); })();

class CoreUiModule {
    static forRoot() {
        return {
            ngModule: CoreUiModule,
            providers: [
                ...AutofocusFixModule.forRoot().providers,
                ...NgxDaterangepickerMd.forRoot().providers
            ]
        };
    }
    static { this.ɵfac = function CoreUiModule_Factory(t) { return new (t || CoreUiModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CoreUiModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule,
            ReactiveFormsModule,
            NgChartsModule,
            CommonModule,
            MatIconModule,
            MatMenuModule,
            AngularSplitModule,
            AutofocusFixModule,
            NgxDaterangepickerMd, EXPipesModule,
            ExActionMenuModule,
            ExAutocompleteModule,
            ExAvatarModule,
            ExButtonModule,
            ExBannerModule,
            ExCardWrapperModule,
            ExChipModule,
            ExCloseModule,
            ExColorPickerModule,
            ExComboboxModule,
            ExRichTextEditorModule,
            ExSvgIconModule,
            ExDotWrapperModule,
            ExMultiselectComboboxModule,
            ExComponentLoaderModule,
            ExDateRangePickerModule,
            ExDatePickerModule,
            ExDirectivesModule,
            ExDropdownModule,
            ExEditableTextModule,
            ExExpandableLabelModule,
            ExExtendedSearchModule,
            ExFacetsModule,
            ExNewFacetsModule,
            ExFiltersModule,
            ExFloatingComponentModule,
            ExGridLayoutModule,
            ExSectionsLayoutModule,
            ExIconModule,
            ExLabelModule,
            ExFloatLabelsModule,
            ExLinkModule,
            ExListHeaderModule,
            ExListLayoutModule,
            ExItemsLayoutModule,
            ExChipRecordModule,
            ExMainLayoutModule,
            ExMenuModule,
            ExNoteModule,
            ExPaginationModule,
            ExProgressBarModule,
            ExRecordActionsModule,
            ExRightClickActionsModule,
            ExFloatingAddComponentModule,
            ExScaleModule,
            ExSearchModule,
            ExSearchToggleModule,
            ExShowMoreLessModule,
            ExSideBySideModule,
            ExSidenavModule,
            ExSortModule,
            ExSpinnerModule,
            ExTabModule,
            ExTabsWrapperModule,
            ExThumbnailModule,
            ExTypedInputModule,
            ExSummarySectionModule,
            ExSummarySectionsCollapsedModule,
            ExPieChartModule,
            ExInlineEditingModule,
            ExEntityInfoModule,
            ExInlineEditingButtonsModule,
            ExBadgeModule,
            ExEditingListModule,
            ExEditingCardsModule,
            ExLabelComboboxModule,
            ExFlexbrowseSelectionModule,
            SelectionMenuModule,
            ExListCustomizationModule,
            ExLayoutCustomizationMenuModule,
            ExFileSelectModule,
            ExSelectionListModule,
            ExRadioButtonsModule,
            ExSidepaneModule,
            ExDisplayTextModule,
            ExCheckboxModule,
            ExFormsModule,
            ExSlideToggleModule,
            ExDragModule,
            ExMultiLayoutModule,
            ExCarouselLayoutModule,
            ExFileDropModule,
            ExFallbackIconModule,
            ExFileIconModule,
            ExConfirmationMessageModule,
            ExInformativeProgressBarModule,
            ExToggleModule,
            ExQueryBuilderModule,
            ExLegendModule,
            ExNewComboboxModule,
            ExDialogModule,
            ExChartsModule,
            ExHelpIconModule,
            ExAceEditorModule,
            ExDialogComboboxModule,
            MenuItemModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoreUiModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CoreUiComponent,
                ],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    NgChartsModule,
                    CommonModule,
                    MatIconModule,
                    MatMenuModule,
                    AngularSplitModule,
                    AutofocusFixModule,
                    NgxDaterangepickerMd,
                ],
                exports: [
                    EXPipesModule,
                    ExActionMenuModule,
                    ExAutocompleteModule,
                    ExAvatarModule,
                    ExButtonModule,
                    ExBannerModule,
                    ExCardWrapperModule,
                    ExChipModule,
                    ExCloseModule,
                    ExColorPickerModule,
                    ExComboboxModule,
                    ExRichTextEditorModule,
                    ExSvgIconModule,
                    ExDotWrapperModule,
                    ExMultiselectComboboxModule,
                    ExComponentLoaderModule,
                    ExDateRangePickerModule,
                    ExDatePickerModule,
                    ExDirectivesModule,
                    ExDropdownModule,
                    ExEditableTextModule,
                    ExExpandableLabelModule,
                    ExExtendedSearchModule,
                    ExFacetsModule,
                    ExNewFacetsModule,
                    ExFiltersModule,
                    ExFloatingComponentModule,
                    ExGridLayoutModule,
                    ExSectionsLayoutModule,
                    ExIconModule,
                    ExLabelModule,
                    ExFloatLabelsModule,
                    ExLinkModule,
                    ExListHeaderModule,
                    ExListLayoutModule,
                    ExItemsLayoutModule,
                    ExChipRecordModule,
                    ExMainLayoutModule,
                    ExMenuModule,
                    ExNoteModule,
                    ExPaginationModule,
                    ExProgressBarModule,
                    ExRecordActionsModule,
                    ExRightClickActionsModule,
                    ExFloatingAddComponentModule,
                    ExScaleModule,
                    ExSearchModule,
                    ExSearchToggleModule,
                    ExShowMoreLessModule,
                    ExSideBySideModule,
                    ExSidenavModule,
                    ExSortModule,
                    ExSpinnerModule,
                    ExTabModule,
                    ExTabsWrapperModule,
                    ExThumbnailModule,
                    ExTypedInputModule,
                    ExSummarySectionModule,
                    ExSummarySectionsCollapsedModule,
                    ExPieChartModule,
                    ExInlineEditingModule,
                    ExEntityInfoModule,
                    ExInlineEditingButtonsModule,
                    ExBadgeModule,
                    ExEditingListModule,
                    ExEditingCardsModule,
                    ExLabelComboboxModule,
                    ExFlexbrowseSelectionModule,
                    SelectionMenuModule,
                    ExListCustomizationModule,
                    ExLayoutCustomizationMenuModule,
                    ExFileSelectModule,
                    ExSelectionListModule,
                    ExRadioButtonsModule,
                    ExSidepaneModule,
                    ExDisplayTextModule,
                    ExCheckboxModule,
                    ExFormsModule,
                    ExSlideToggleModule,
                    ExDragModule,
                    ExMultiLayoutModule,
                    ExCarouselLayoutModule,
                    ExFileDropModule,
                    ExFallbackIconModule,
                    ExFileIconModule,
                    ExConfirmationMessageModule,
                    ExInformativeProgressBarModule,
                    ExToggleModule,
                    ExQueryBuilderModule,
                    ExLegendModule,
                    ExNewComboboxModule,
                    ExDialogModule,
                    ExChartsModule,
                    ExHelpIconModule,
                    ExAceEditorModule,
                    ExDialogComboboxModule,
                    MenuItemModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CoreUiModule, { declarations: [CoreUiComponent], imports: [FormsModule,
        ReactiveFormsModule,
        NgChartsModule,
        CommonModule,
        MatIconModule,
        MatMenuModule,
        AngularSplitModule,
        AutofocusFixModule,
        NgxDaterangepickerMd], exports: [EXPipesModule,
        ExActionMenuModule,
        ExAutocompleteModule,
        ExAvatarModule,
        ExButtonModule,
        ExBannerModule,
        ExCardWrapperModule,
        ExChipModule,
        ExCloseModule,
        ExColorPickerModule,
        ExComboboxModule,
        ExRichTextEditorModule,
        ExSvgIconModule,
        ExDotWrapperModule,
        ExMultiselectComboboxModule,
        ExComponentLoaderModule,
        ExDateRangePickerModule,
        ExDatePickerModule,
        ExDirectivesModule,
        ExDropdownModule,
        ExEditableTextModule,
        ExExpandableLabelModule,
        ExExtendedSearchModule,
        ExFacetsModule,
        ExNewFacetsModule,
        ExFiltersModule,
        ExFloatingComponentModule,
        ExGridLayoutModule,
        ExSectionsLayoutModule,
        ExIconModule,
        ExLabelModule,
        ExFloatLabelsModule,
        ExLinkModule,
        ExListHeaderModule,
        ExListLayoutModule,
        ExItemsLayoutModule,
        ExChipRecordModule,
        ExMainLayoutModule,
        ExMenuModule,
        ExNoteModule,
        ExPaginationModule,
        ExProgressBarModule,
        ExRecordActionsModule,
        ExRightClickActionsModule,
        ExFloatingAddComponentModule,
        ExScaleModule,
        ExSearchModule,
        ExSearchToggleModule,
        ExShowMoreLessModule,
        ExSideBySideModule,
        ExSidenavModule,
        ExSortModule,
        ExSpinnerModule,
        ExTabModule,
        ExTabsWrapperModule,
        ExThumbnailModule,
        ExTypedInputModule,
        ExSummarySectionModule,
        ExSummarySectionsCollapsedModule,
        ExPieChartModule,
        ExInlineEditingModule,
        ExEntityInfoModule,
        ExInlineEditingButtonsModule,
        ExBadgeModule,
        ExEditingListModule,
        ExEditingCardsModule,
        ExLabelComboboxModule,
        ExFlexbrowseSelectionModule,
        SelectionMenuModule,
        ExListCustomizationModule,
        ExLayoutCustomizationMenuModule,
        ExFileSelectModule,
        ExSelectionListModule,
        ExRadioButtonsModule,
        ExSidepaneModule,
        ExDisplayTextModule,
        ExCheckboxModule,
        ExFormsModule,
        ExSlideToggleModule,
        ExDragModule,
        ExMultiLayoutModule,
        ExCarouselLayoutModule,
        ExFileDropModule,
        ExFallbackIconModule,
        ExFileIconModule,
        ExConfirmationMessageModule,
        ExInformativeProgressBarModule,
        ExToggleModule,
        ExQueryBuilderModule,
        ExLegendModule,
        ExNewComboboxModule,
        ExDialogModule,
        ExChartsModule,
        ExHelpIconModule,
        ExAceEditorModule,
        ExDialogComboboxModule,
        MenuItemModule] }); })();

class CoreUiService {
    static { this.ɵfac = function CoreUiService_Factory(t) { return new (t || CoreUiService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CoreUiService, factory: CoreUiService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoreUiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ExBanner {
}

/**
 * id - A unique identifier for the item, required for the component to function.
 * name - The text displayed to the user
 * hasChildren - If TRUE, the item will be displayed with an arrow
 *            and it will be clickable for expand it and for load its children.
 * category - If you choose to fill in this field,
 *            the selected items will be automatically grouped by categories in the selected items area.
 *             In addition, when searching - under each item will appear its category.
 */
class ExFlexbrowseItemData {
}

class ExHierarchyFacet {
    constructor(level, code, description) {
        this.level = level;
        this.code = code;
        this.description = description;
    }
}

/**
 * This class represents the model of a Facet component
 * component + data - the data for the component loader
 * toggles - if you want to display toggles above the component - label, value, if disabled, tooltip.
 * emptyLbel - for showing the ex-facet-empty component when there are no results for the facet
 */
class ExFacetFactoryItem extends ExComponentFactoryItem {
    constructor(component, data, toggles = null, emptyLabel = null) {
        super(component, data);
        this.component = component;
        this.data = data;
        this.toggles = toggles;
        this.emptyLabel = emptyLabel;
    }
}

// Note: This is a workaround due to a similar bug described here:
// https://stackoverflow.com/questions/43912168/typescript-decorators-with-inheritance
function initArray(target, arrayName) {
    if (Object.getOwnPropertyDescriptor(target, arrayName) == null) {
        target[arrayName] = [];
        let parentTarget = Object.getPrototypeOf(target);
        let parentData = parentTarget[arrayName];
        if (parentData) {
            Object.keys(parentData).forEach(key => {
                if (Array.isArray(parentData[key])) {
                    target[arrayName][key] = [];
                    parentData[key].forEach(val => {
                        target[arrayName][key].push(val);
                    });
                }
                else {
                    target[arrayName].push(parentData[key]);
                }
            });
        }
    }
}

const DEFAULT_COLUMN_OPTIONS = {
    label: '',
    displayLabelInHeader: true,
    type: null,
    sortable: false,
    sorted: 'none',
    columnWidth: 15,
    centered: false,
    isIconColumn: false,
    iconType: null,
    isToggleColumn: false,
    isLinkColumn: false,
    roles: null,
    isPreRow: false,
    customTooltip: null,
    isPostRow: false,
};
function Column(options) {
    const { label, displayLabelInHeader, type, sortable, sortKey, sorted, columnWidth, centered, isIconColumn, iconType, isToggleColumn, isEntityLabelsColumn, isLinkColumn, roles, isHidden, excludeExport, isPreRow, uiOrder, customTooltip, isPostRow } = options;
    return function (target, key) {
        initArray(target, 'columns');
        let column = {
            columnIdentifier: key,
            sortable: sortable ?? DEFAULT_COLUMN_OPTIONS.sortable,
            sortKey: sortKey ?? key,
            sorted: sorted ?? DEFAULT_COLUMN_OPTIONS.sorted,
            label: label ?? key,
            columnWidth: columnWidth ?? DEFAULT_COLUMN_OPTIONS.columnWidth,
            centered: !!centered,
            isIconColumn: !!isIconColumn,
            iconType: iconType,
            type: type,
            isToggleColumn: !!isToggleColumn,
            isLinkColumn: !!isLinkColumn,
            roles: roles,
            displayLabelInHeader: displayLabelInHeader ?? DEFAULT_COLUMN_OPTIONS.displayLabelInHeader,
            isHidden: !!isHidden,
            excludeExport: !!excludeExport,
            isPreRow: !!isPreRow,
            uiOrder: uiOrder,
            customTooltip: customTooltip,
            isEntityLabelsColumn: isEntityLabelsColumn,
            isPostRow: isPostRow,
        };
        if (uiOrder === undefined || uiOrder === null) {
            target['columns'].push(column);
        }
        else {
            let ind = target['columns'].findIndex(col => (!col.uiOrder || uiOrder < col.uiOrder));
            if (ind === -1) {
                target['columns'].push(column);
            }
            else {
                target['columns'].splice(ind, 0, column);
            }
        }
    };
}

function CustomBackgroundRowColor() {
    return function (target, key) {
        target['customBackgroundRowColor'] = key;
    };
}

/**
 * This class represents the model of a grid cell component
 */
class ExGridFactoryItem extends ExComponentFactoryItem {
    constructor(component, data) {
        super(component, data);
        this.component = component;
        this.data = data;
    }
}

function Actions(options) {
    const { type, isFloating, displayAlways, visibleBtnNum = 1 } = options;
    return function (target, key) {
        target['actions'] = { type, key, isFloating, displayAlways, visibleBtnNum };
    };
}

function Field(options) {
    let { coord3, coord2, coord1, type, isBold, style, label, iconType, iconName, iconColor, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, isCustomizable, isHidden, isHideable, fieldNameLabel, icon, excludeExport } = options;
    if (isCustomizable === undefined || isCustomizable === null) {
        isCustomizable = true;
    }
    if (isHidden === undefined || isHidden === null) {
        isHidden = false;
    }
    if (isHideable === undefined || isHideable === null) {
        isHideable = true;
    }
    if (showDisabled !== false) {
        showDisabled = true;
    }
    if (showHighlight !== false) {
        showHighlight = true;
    }
    if (!style) {
        style = {};
    }
    if (!icon) {
        icon = undefined;
    }
    return function (target, key) {
        initArray(target, 'columns3');
        if (!target['columns3'][coord3.col]) {
            target['columns3'][coord3.col] = [];
        }
        target['columns3'][coord3.col].splice([coord3.row], 0, { key, type, isBold, style, label, iconType, iconName, iconColor, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, staticInputs: false, isCustomizable, isHidden, isHideable, fieldNameLabel, icon, excludeExport });
        if (coord2 !== -1) {
            if (!coord2) {
                coord2 = coord3;
            }
            initArray(target, 'columns2');
            if (!target['columns2'][coord2.col]) {
                target['columns2'][coord2.col] = [];
            }
            target['columns2'][coord2.col].splice([coord2.row], 0, { key, type, isBold, style, label, iconType, iconName, iconColor, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, staticInputs: false, isCustomizable, isHidden, isHideable, fieldNameLabel, icon, excludeExport });
        }
        if (coord1 !== -1) {
            if (!coord1) {
                coord1 = coord3;
            }
            initArray(target, 'columns1');
            if (!target['columns1'][coord1.col]) {
                target['columns1'][coord1.col] = [];
            }
            target['columns1'][coord1.col].splice([coord1.row], 0, { key, type, isBold, style, label, iconType, iconName, iconColor, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, staticInputs: false, isCustomizable, isHidden, isHideable, fieldNameLabel, icon, excludeExport });
        }
    };
}

/*
    Pass field data in UIWrapper property as object with properties { value: string, icon: IconModel }
*/
const LABEL_FIELD_POSITION_0 = 0;
const LABEL_FIELD_POSITION_1 = 1;
function LabelField(options) {
    let { column, isBold, style, label, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, isCustomizable, isHideable, isHidden, fieldNameLabel, excludeExport } = options || {};
    if (showDisabled !== false)
        showDisabled = true;
    if (showHighlight !== false)
        showHighlight = true;
    if (!style)
        style = {};
    if (isCustomizable === undefined || isCustomizable === null) {
        isCustomizable = true;
    }
    if (isHidden === undefined || isHidden === null) {
        isHidden = false;
    }
    if (isHideable === undefined || isHideable === null) {
        isHideable = true;
    }
    return function (target, key) {
        column = column != LABEL_FIELD_POSITION_1 ? LABEL_FIELD_POSITION_0 : column;
        for (let bp = 3; bp > 0; bp--) {
            if (bp > column) {
                initArray(target, `columns${bp}`);
                if (!target[`columns${bp}`][column]) {
                    target[`columns${bp}`][column] = [];
                }
                let row = getFieldRow$2(target[`columns${bp}`][column], bp);
                target[`columns${bp}`][column].splice(row, 0, { key, type: ExLabelComponent, isBold, style, label, showDisabled, showHighlight, hasColon, htmlId, displayTooltip, staticInputs: true, isCustomizable, isHidden, isHideable, fieldNameLabel, excludeExport });
            }
        }
    };
}
function getFieldRow$2(columnData, breakpoint) {
    let index = columnData.findIndex(field => field.type != ExLabelComponent && field.type != undefined);
    return index < 0 ? columnData.length : index;
}

const positionMap$1 = {
    '3': '2',
    '2': '1',
    '1': 'actions_horizontal_2',
    '3_1': '1',
    '2_1': '1',
    '1_1': 'actions_horizontal_2'
};
const CHIP_FIELD_POSITION_1$1 = 1;
const CHIP_FIELD_POSITION_DELIMITER$1 = "_";
function ChipField(options = {}) {
    const leadingChip = options?.column == CHIP_FIELD_POSITION_1$1;
    const positionKeySuffix = leadingChip ? `${CHIP_FIELD_POSITION_DELIMITER$1}${CHIP_FIELD_POSITION_1$1}` : "";
    if (options?.isCustomizable === undefined || options?.isCustomizable === null) {
        options.isCustomizable = true;
    }
    if (options?.isHidden === undefined || options?.isHidden === null) {
        options.isHidden = false;
    }
    if (options?.isHideable === undefined || options?.isHideable === null) {
        options.isHideable = true;
    }
    if (options?.excludeExport === undefined || options?.excludeExport === null) {
        options.excludeExport = false;
    }
    return function (target, key) {
        let column;
        for (let bp = 3; bp > 0; bp--) {
            initArray(target, `columns${bp}`);
            column = positionMap$1[`${bp}${positionKeySuffix}`];
            if (!target[`columns${bp}`][column]) {
                target[`columns${bp}`][column] = [];
            }
            let row = getFieldRow$1(target[`columns${bp}`][column], bp, leadingChip);
            target[`columns${bp}`][column].splice(row, 0, { key, type: ExChipRecordComponent, staticInputs: true, leadingField: leadingChip, isCustomizable: options.isCustomizable, isHidden: options.isHidden, isHideable: options.isHideable, fieldNameLabel: options.fieldNameLabel, excludeExport: options.excludeExport });
        }
    };
}
function getFieldRow$1(columnData, breakpoint, leadingChip) {
    if (leadingChip) {
        let index = columnData.findIndex(field => field.type === ExChipRecordComponent);
        return index < 0 ? columnData.length : index;
    }
    return columnData.length;
}

const positionMap = {
    '3': '2',
    '2': '1',
    '1': 'actions_horizontal_3',
    '3_1': '1',
    '2_1': '1',
    '1_1': 'actions_horizontal_3'
};
const CHIP_FIELD_POSITION_1 = 1;
const CHIP_FIELD_POSITION_DELIMITER = "_";
function EntityLabelsField(options = {}) {
    const leadingChip = options?.column == CHIP_FIELD_POSITION_1;
    const positionKeySuffix = leadingChip ? `${CHIP_FIELD_POSITION_DELIMITER}${CHIP_FIELD_POSITION_1}` : "";
    if (options?.isCustomizable === undefined || options?.isCustomizable === null) {
        options.isCustomizable = true;
    }
    if (options?.isHidden === undefined || options?.isHidden === null) {
        options.isHidden = false;
    }
    if (options?.isHideable === undefined || options?.isHideable === null) {
        options.isHideable = true;
    }
    if (options?.excludeExport === undefined || options?.excludeExport === null) {
        options.excludeExport = false;
    }
    return function (target, key) {
        let column;
        for (let bp = 3; bp > 0; bp--) {
            initArray(target, `columns${bp}`);
            column = positionMap[`${bp}${positionKeySuffix}`];
            if (!target[`columns${bp}`][column]) {
                target[`columns${bp}`][column] = [];
            }
            let row = getFieldRow(target[`columns${bp}`][column], bp, leadingChip);
            target[`columns${bp}`][column].splice(row, 0, { key, type: ExChipRecordEntityLabelsComponent, staticInputs: true, leadingField: leadingChip, isCustomizable: options.isCustomizable, isHidden: options.isHidden, isHideable: options.isHideable, fieldNameLabel: options.fieldNameLabel, excludeExport: options.excludeExport });
        }
    };
}
function getFieldRow(columnData, breakpoint, leadingChip) {
    if (leadingChip) {
        let index = columnData.findIndex(field => field.type === ExChipRecordEntityLabelsComponent);
        return index < 0 ? columnData.length : index;
    }
    return columnData.length;
}

function HeaderMenus(options) {
    const { type, isFloating, displayAlways } = options;
    return function (target, key) {
        target['headerMenus'] = { type, key, isFloating, displayAlways };
    };
}

function PickupIgnoredField() {
    return function (target, key) {
        if (!target['pickupIgnoredField']) {
            target['pickupIgnoredField'] = new Set([key]);
            return;
        }
        target['pickupIgnoredField'] = target['pickupIgnoredField'].add(key);
    };
}

function PickupSelectedKey() {
    return function (target, key) {
        target['pickupSelectedKey'] = { key };
    };
}

function PickupSelectedLabel() {
    return function (target, key) {
        target['pickupSelectedLabel'] = { key };
    };
}

//customizedLayout is an array defining a customized flex value for each column.
//Syntax: [flex_value_of_column0, column1:flex_value_of_column1,...]
function RecordLayout(record) {
    return function (target) {
        const { layout, customizedLayout, numberOfColumns } = record;
        target.prototype['record'] = { layout, customizedLayout, numberOfColumns };
    };
}

function Status() {
    return function (target, key) {
        target['status'] = key;
    };
}

function Thumbnail(size = 'normal', type, border, placeHolderType) {
    return function (target, key) {
        target['thumbnail'] = { key, size, type, border, placeHolderType };
    };
}

function ThumbnailIcon() {
    return function (target, key) {
        target['thumbnailIcon'] = { key };
    };
}
function UnderThumbnailIcon() {
    return function (target, key) {
        initArray(target, 'underThumbnailIcon');
        target['underThumbnailIcon'].push(key);
    };
}

function TreeField() {
    return function (target, key) {
        target['treeFieldKey'] = key;
    };
}

function Editable() {
    return function (target, key) {
        target['editableKey'] = key;
    };
}

function FullPageTitle() {
    return function (target, key) {
        target['fullPageTitle'] = { key };
    };
}

function FullPageTitleIcon() {
    return function (target, key) {
        target['fullPageTitleIcon'] = { key };
    };
}

function Footer({ type }) {
    return function (target, key) {
        target['footer'] = { key, type };
    };
}

function Title() {
    return function (target, key) {
        target['title'] = { key };
    };
}

function GalleryField(args) {
    return function (target, key) {
        initArray(target, 'galleryField');
        target['galleryField'].push({ key, ...args });
    };
}

class SidenavTrigger {
    constructor(title, icon, iconType, additionalText = '', background, fontColor, isCapslock = true, count = 0) {
        this.title = title;
        this.additionalText = additionalText;
        this.icon = icon;
        this.iconType = iconType;
        this.background = background;
        this.fontColor = fontColor;
        this.isCapslock = isCapslock;
        this.count = count;
    }
}
class SidenavPanel {
    constructor(trigger, component, componentName, panelTitle = '', additionalText = '', hasShadow = true, showTitle = true, background = 'transperent', width, resizeable = true, hasLoading = false, isLoading = false) {
        this.trigger = trigger;
        this.component = component;
        this.componentName = componentName;
        this.panelTitle = panelTitle;
        this.additionalText = additionalText;
        this.hasShadow = hasShadow;
        this.showTitle = showTitle;
        this.background = background;
        this.width = width;
        this.resizeable = resizeable;
        this.hasLoading = hasLoading;
        this.isLoading = isLoading;
    }
}

/*
For use Mandatory Fields you need to pass List of MandatoryFieldData.
For fields that are mandatory by default and not need to be customizable pass - isMandatory: true, isCustomizable: fasle.
For fields that are Customizable pass - isMandatory: false, isCustomizable: true.
*/
class MandatoryFieldData {
    constructor() {
        /**
         *  Is this field required by default?
         */
        this.isMandatory = false;
        /**
         *  Can the default isMandatory setting be changed by the system administrator
         */
        this.isCustomizable = true;
    }
}

class ExOverlayContainer extends OverlayContainer {
    /**
   * Create the overlay container element, which is simply a div
   * with the 'cdk-overlay-container' class on the document body.
   */
    _createContainer() {
        const containerClass = 'cdk-overlay-container';
        // TODO(crisbeto): remove the testing check once we have an overlay testing
        // module or Angular starts tearing down the testing `NgModule`. See:
        // https://github.com/angular/angular/issues/18831
        if (this._platform.isBrowser || _isTestEnvironment()) {
            const oppositePlatformContainers = this._document.querySelectorAll(`.${containerClass}[platform="server"], ` + `.${containerClass}[platform="test"]`);
            // Remove any old containers from the opposite platform.
            // This can happen when transitioning from the server to the client.
            for (let i = 0; i < oppositePlatformContainers.length; i++) {
                oppositePlatformContainers[i].remove();
            }
        }
        const container = this._document.createElement('div');
        container.classList.add(containerClass);
        // A long time ago we kept adding new overlay containers whenever a new app was instantiated,
        // but at some point we added logic which clears the duplicate ones in order to avoid leaks.
        // The new logic was a little too aggressive since it was breaking some legitimate use cases.
        // To mitigate the problem we made it so that only containers from a different platform are
        // cleared, but the side-effect was that people started depending on the overly-aggressive
        // logic to clean up their tests for them. Until we can introduce an overlay-specific testing
        // module which does the cleanup, we try to detect that we're in a test environment and we
        // always clear the container. See #17006.
        // TODO(crisbeto): remove the test environment check once we have an overlay testing module.
        if (_isTestEnvironment()) {
            container.setAttribute('platform', 'test');
        }
        else if (!this._platform.isBrowser) {
            container.setAttribute('platform', 'server');
        }
        // [local improvement]
        const contentOverlay = this._document.getElementById('ng_content') || this._document.body;
        // [local improvement] The overlay should be position before the others for make sure that ids which not unique will captured in the sidepane.
        contentOverlay.prepend(container);
        this._containerElement = container;
    }
    static { this.ɵfac = /*@__PURE__*/ function () { let ɵExOverlayContainer_BaseFactory; return function ExOverlayContainer_Factory(t) { return (ɵExOverlayContainer_BaseFactory || (ɵExOverlayContainer_BaseFactory = i0.ɵɵgetInheritedFactory(ExOverlayContainer)))(t || ExOverlayContainer); }; }(); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExOverlayContainer, factory: ExOverlayContainer.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExOverlayContainer, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*
* This service is a clone of material's Overlay (https://github.com/angular/components/blob/main/src/cdk/overlay/overlay.ts).
* The purpose is to change the scope where the overlay is placed. In the original service the position is fix to the root of the dom.
* Here we change it to be into the 'ng_content' element (if exists), which is owned by core-infra-ng.
* The position is important for handle the z-index in right way.
* For ex. the MDEdition and the menus shouldn't be covered behind the overlay (that contains the Sidepane).
* In order to change this code we had to copy the OverlayContainer service as well, and override the _createContainer function into it.
* */
class ExOverlay extends Overlay {
    constructor(
    /** Scrolling strategies that can be used when creating an overlay. */
    scrollStrategies, overlayContainer, componentFactoryResolver, positionBuilder, keyboardDispatcher, injector, ngZone, document, directionality, location, outsideClickDispatcher, animationsModuleType) {
        super(scrollStrategies, overlayContainer, componentFactoryResolver, positionBuilder, keyboardDispatcher, injector, ngZone, document, directionality, location, outsideClickDispatcher, animationsModuleType);
        this.scrollStrategies = scrollStrategies;
        this.overlayContainer = overlayContainer;
        this.componentFactoryResolver = componentFactoryResolver;
        this.positionBuilder = positionBuilder;
        this.keyboardDispatcher = keyboardDispatcher;
        this.injector = injector;
        this.ngZone = ngZone;
        this.document = document;
        this.directionality = directionality;
        this.location = location;
        this.outsideClickDispatcher = outsideClickDispatcher;
        this.animationsModuleType = animationsModuleType;
    }
    static { this.ɵfac = function ExOverlay_Factory(t) { return new (t || ExOverlay)(i0.ɵɵinject(i1.ScrollStrategyOptions), i0.ɵɵinject(ExOverlayContainer), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i1.OverlayPositionBuilder), i0.ɵɵinject(i1.OverlayKeyboardDispatcher), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i2$1.Directionality), i0.ɵɵinject(i1$5.Location), i0.ɵɵinject(i1.OverlayOutsideClickDispatcher), i0.ɵɵinject(ANIMATION_MODULE_TYPE, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExOverlay, factory: ExOverlay.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExOverlay, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ScrollStrategyOptions }, { type: ExOverlayContainer }, { type: i0.ComponentFactoryResolver }, { type: i1.OverlayPositionBuilder }, { type: i1.OverlayKeyboardDispatcher }, { type: i0.Injector }, { type: i0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i2$1.Directionality }, { type: i1$5.Location }, { type: i1.OverlayOutsideClickDispatcher }, { type: undefined, decorators: [{
                type: Inject,
                args: [ANIMATION_MODULE_TYPE]
            }, {
                type: Optional
            }] }]; }, null); })();

const HEP_SIDEPANE_CLOSE_EVENT_NAME = 'hepSidepaneClose';
class ExSidepaneService {
    constructor(overlay, injector, ngZone) {
        this.overlay = overlay;
        this.injector = injector;
        this.ngZone = ngZone;
        this._dir = 'ltr';
        this.getDirection();
    }
    open({ content, data, width = '400px', panelClass = [], backdropClass = [], hasBackdrop = false, elementForInert = null }) {
        const overlayRef = this.overlay.create({
            backdropClass: ['ex-sidepane-backdrop', ...backdropClass],
            panelClass: ['ex-sidepane-container', ...panelClass],
            width,
            hasBackdrop,
            direction: this._dir
        });
        const sidepaneRef = new SidepaneRef(overlayRef, content, Object.assign(data, { closeButtonOnSide: hasBackdrop, elementForInert }));
        this.ngZone.run(() => {
            const injector = this.createInjector(sidepaneRef, this.injector);
            overlayRef.attach(new ComponentPortal(ExSidepaneComponent, null, injector));
        });
        sidepaneRef.afterClosed$.pipe(take$1(1)).subscribe(() => {
            this.notifyCloseSidepane();
        });
        return sidepaneRef;
    }
    createInjector(sidepaneRef, injector) {
        const tokens = new WeakMap([[SidepaneRef, sidepaneRef]]);
        return new PortalInjector(injector, tokens);
    }
    getDirection() {
        let direction = document.documentElement.getAttribute('dir');
        this._dir = direction === 'rtl' ? 'rtl' : 'ltr';
    }
    notifyCloseSidepane() {
        const sidePaneCloseEvent = new CustomEvent(HEP_SIDEPANE_CLOSE_EVENT_NAME, { 'detail': {} });
        document.dispatchEvent(sidePaneCloseEvent);
    }
    static { this.ɵfac = function ExSidepaneService_Factory(t) { return new (t || ExSidepaneService)(i0.ɵɵinject(ExOverlay), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i0.NgZone)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExSidepaneService, factory: ExSidepaneService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExSidepaneService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ExOverlay }, { type: i0.Injector }, { type: i0.NgZone }]; }, null); })();

class PageColumnBase {
    constructor() {
        this.isSelectPickupDisabled = true;
        this.setButtonClicked = new EventEmitter(); //handled in search-list-component.ts
        this.onSelectClicked = new EventEmitter();
    }
    set main(main) {
        this._main = main === '' || main;
    }
    get main() {
        return this._main;
    }
    static { this.ɵfac = function PageColumnBase_Factory(t) { return new (t || PageColumnBase)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PageColumnBase, inputs: { main: "main" }, outputs: { setButtonClicked: "setButtonClicked", onSelectClicked: "onSelectClicked" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageColumnBase, [{
        type: Directive
    }], null, { setButtonClicked: [{
            type: Output
        }], onSelectClicked: [{
            type: Output
        }], main: [{
            type: Input
        }] }); })();

function menuItem(options) {
    let { order, canCustomize, visibleInMain, visibleInConfig, hidden, actionType, iconName, iconType, type } = options;
    return function (target, key) {
        if (!target['order']) {
            target['order'] = [];
        }
        if (!target['order'][order]) {
            target['order'][order] = [];
        }
        target['order'][order] = { key, canCustomize, visibleInMain, visibleInConfig, hidden, actionType, iconName, iconType, type };
    };
}

const CONFIG = {
    "allowEmptyRulesets": false,
    "fields": {
        "accompanying_material": {
            "key": "accompanying_material",
            "value": "Accompanying Material",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "additional_physical_form_available_note": {
            "key": "additional_physical_form_available_note",
            "value": "Additional Physical Form Available Note",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "date_of_publication": {
            "key": "date_of_publication",
            "value": "Additional Publication Year",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "authority_id": {
            "key": "authority_id",
            "value": "Authority Id",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "authority_vocabulary": {
            "key": "authority_vocabulary",
            "value": "Authority Vocabulary",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "type_of_record": {
            "key": "type_of_record",
            "value": "Bibliographic Format",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Cartographic material",
                    "key": "e",
                    "groupOrder": 0
                }, {
                    "value": "Computer file",
                    "key": "m",
                    "groupOrder": 0
                }, {
                    "value": "Kit",
                    "key": "o",
                    "groupOrder": 0
                }, {
                    "value": "Language material",
                    "key": "a",
                    "groupOrder": 0
                }, {
                    "value": "Manuscript cartographic material",
                    "key": "f",
                    "groupOrder": 0
                }, {
                    "value": "Manuscript language material",
                    "key": "t",
                    "groupOrder": 0
                }, {
                    "value": "Manuscript notated music",
                    "key": "d",
                    "groupOrder": 0
                }, {
                    "value": "Mixed material",
                    "key": "p",
                    "groupOrder": 0
                }, {
                    "value": "Musical sound recording",
                    "key": "j",
                    "groupOrder": 0
                }, {
                    "value": "Nonmusical sound recording",
                    "key": "i",
                    "groupOrder": 0
                }, {
                    "value": "Notated music",
                    "key": "c",
                    "groupOrder": 0
                }, {
                    "value": "Projected medium",
                    "key": "g",
                    "groupOrder": 0
                }, {
                    "value": "Three-dimensional artifact or naturally occurring\n\t\t\t\t\t\tobject",
                    "key": "r",
                    "groupOrder": 0
                }, {
                    "value": "Two-dimensional nonprojectable graphic",
                    "key": "k",
                    "groupOrder": 0
                }]
        },
        "bib_level": {
            "key": "bib_level",
            "value": "Bibliographic Level",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Collection",
                    "key": "c",
                    "groupOrder": 0
                }, {
                    "value": "Integrating resource",
                    "key": "i",
                    "groupOrder": 0
                }, {
                    "value": "Monograph/item",
                    "key": "m",
                    "groupOrder": 0
                }, {
                    "value": "Monographic component part",
                    "key": "a",
                    "groupOrder": 0
                }, {
                    "value": "Serial",
                    "key": "s",
                    "groupOrder": 0
                }, {
                    "value": "Serial component part",
                    "key": "b",
                    "groupOrder": 0
                }, {
                    "value": "Subunit",
                    "key": "d",
                    "groupOrder": 0
                }]
        },
        "mms_qualityScore": {
            "key": "mms_qualityScore",
            "value": "Bibliographic Rank",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }]
        },
        "mms_briefLevel": {
            "key": "mms_briefLevel",
            "value": "Brief Level",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }],
            "options": [{
                    "value": "01",
                    "key": "01",
                    "groupOrder": 0
                }, {
                    "value": "02",
                    "key": "02",
                    "groupOrder": 0
                }, {
                    "value": "03",
                    "key": "03",
                    "groupOrder": 0
                }, {
                    "value": "04",
                    "key": "04",
                    "groupOrder": 0
                }, {
                    "value": "05",
                    "key": "05",
                    "groupOrder": 0
                }, {
                    "value": "06",
                    "key": "06",
                    "groupOrder": 0
                }, {
                    "value": "07",
                    "key": "07",
                    "groupOrder": 0
                }, {
                    "value": "08",
                    "key": "08",
                    "groupOrder": 0
                }, {
                    "value": "09",
                    "key": "09",
                    "groupOrder": 0
                }, {
                    "value": "10",
                    "key": "10",
                    "groupOrder": 0
                }]
        },
        "carrier_type_code": {
            "key": "carrier_type_code",
            "value": "Carrier Type Code (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "ca",
                    "key": "ca",
                    "groupOrder": 0
                }, {
                    "value": "cb",
                    "key": "cb",
                    "groupOrder": 0
                }, {
                    "value": "cd",
                    "key": "cd",
                    "groupOrder": 0
                }, {
                    "value": "ce",
                    "key": "ce",
                    "groupOrder": 0
                }, {
                    "value": "cf",
                    "key": "cf",
                    "groupOrder": 0
                }, {
                    "value": "ch",
                    "key": "ch",
                    "groupOrder": 0
                }, {
                    "value": "ck",
                    "key": "ck",
                    "groupOrder": 0
                }, {
                    "value": "cr",
                    "key": "cr",
                    "groupOrder": 0
                }, {
                    "value": "cz",
                    "key": "cz",
                    "groupOrder": 0
                }, {
                    "value": "gc",
                    "key": "gc",
                    "groupOrder": 0
                }, {
                    "value": "gd",
                    "key": "gd",
                    "groupOrder": 0
                }, {
                    "value": "gf",
                    "key": "gf",
                    "groupOrder": 0
                }, {
                    "value": "gs",
                    "key": "gs",
                    "groupOrder": 0
                }, {
                    "value": "gt",
                    "key": "gt",
                    "groupOrder": 0
                }, {
                    "value": "ha",
                    "key": "ha",
                    "groupOrder": 0
                }, {
                    "value": "hb",
                    "key": "hb",
                    "groupOrder": 0
                }, {
                    "value": "hc",
                    "key": "hc",
                    "groupOrder": 0
                }, {
                    "value": "hd",
                    "key": "hd",
                    "groupOrder": 0
                }, {
                    "value": "he",
                    "key": "he",
                    "groupOrder": 0
                }, {
                    "value": "hf",
                    "key": "hf",
                    "groupOrder": 0
                }, {
                    "value": "hg",
                    "key": "hg",
                    "groupOrder": 0
                }, {
                    "value": "hh",
                    "key": "hh",
                    "groupOrder": 0
                }, {
                    "value": "hj",
                    "key": "hj",
                    "groupOrder": 0
                }, {
                    "value": "hz",
                    "key": "hz",
                    "groupOrder": 0
                }, {
                    "value": "mc",
                    "key": "mc",
                    "groupOrder": 0
                }, {
                    "value": "mf",
                    "key": "mf",
                    "groupOrder": 0
                }, {
                    "value": "mo",
                    "key": "mo",
                    "groupOrder": 0
                }, {
                    "value": "mr",
                    "key": "mr",
                    "groupOrder": 0
                }, {
                    "value": "mz",
                    "key": "mz",
                    "groupOrder": 0
                }, {
                    "value": "na",
                    "key": "na",
                    "groupOrder": 0
                }, {
                    "value": "nb",
                    "key": "nb",
                    "groupOrder": 0
                }, {
                    "value": "nc",
                    "key": "nc",
                    "groupOrder": 0
                }, {
                    "value": "nn",
                    "key": "nn",
                    "groupOrder": 0
                }, {
                    "value": "no",
                    "key": "no",
                    "groupOrder": 0
                }, {
                    "value": "nr",
                    "key": "nr",
                    "groupOrder": 0
                }, {
                    "value": "nz",
                    "key": "nz",
                    "groupOrder": 0
                }, {
                    "value": "pp",
                    "key": "pp",
                    "groupOrder": 0
                }, {
                    "value": "pz",
                    "key": "pz",
                    "groupOrder": 0
                }, {
                    "value": "sd",
                    "key": "sd",
                    "groupOrder": 0
                }, {
                    "value": "se",
                    "key": "se",
                    "groupOrder": 0
                }, {
                    "value": "sg",
                    "key": "sg",
                    "groupOrder": 0
                }, {
                    "value": "si",
                    "key": "si",
                    "groupOrder": 0
                }, {
                    "value": "sq",
                    "key": "sq",
                    "groupOrder": 0
                }, {
                    "value": "ss",
                    "key": "ss",
                    "groupOrder": 0
                }, {
                    "value": "st",
                    "key": "st",
                    "groupOrder": 0
                }, {
                    "value": "sz",
                    "key": "sz",
                    "groupOrder": 0
                }, {
                    "value": "vc",
                    "key": "vc",
                    "groupOrder": 0
                }, {
                    "value": "vd",
                    "key": "vd",
                    "groupOrder": 0
                }, {
                    "value": "vf",
                    "key": "vf",
                    "groupOrder": 0
                }, {
                    "value": "vr",
                    "key": "vr",
                    "groupOrder": 0
                }, {
                    "value": "vz",
                    "key": "vz",
                    "groupOrder": 0
                }, {
                    "value": "zu",
                    "key": "zu",
                    "groupOrder": 0
                }]
        },
        "carrier_type_term": {
            "key": "carrier_type_term",
            "value": "Carrier Type Term (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "aperture card",
                    "key": "aperture card",
                    "groupOrder": 0
                }, {
                    "value": "audio cartridge",
                    "key": "audio cartridge",
                    "groupOrder": 0
                }, {
                    "value": "audio cylinder",
                    "key": "audio cylinder",
                    "groupOrder": 0
                }, {
                    "value": "audio disc",
                    "key": "audio disc",
                    "groupOrder": 0
                }, {
                    "value": "audio roll",
                    "key": "audio roll",
                    "groupOrder": 0
                }, {
                    "value": "audiocassette",
                    "key": "audiocassette",
                    "groupOrder": 0
                }, {
                    "value": "audiotape reel",
                    "key": "audiotape reel",
                    "groupOrder": 0
                }, {
                    "value": "card",
                    "key": "card",
                    "groupOrder": 0
                }, {
                    "value": "computer card",
                    "key": "computer card",
                    "groupOrder": 0
                }, {
                    "value": "computer chip cartridge",
                    "key": "computer chip cartridge",
                    "groupOrder": 0
                }, {
                    "value": "computer disc",
                    "key": "computer disc",
                    "groupOrder": 0
                }, {
                    "value": "computer disc cartridge",
                    "key": "computer disc cartridge",
                    "groupOrder": 0
                }, {
                    "value": "computer tape cartridge",
                    "key": "computer tape cartridge",
                    "groupOrder": 0
                }, {
                    "value": "computer tape cassette",
                    "key": "computer tape cassette",
                    "groupOrder": 0
                }, {
                    "value": "computer tape reel",
                    "key": "computer tape reel",
                    "groupOrder": 0
                }, {
                    "value": "film cartridge",
                    "key": "film cartridge",
                    "groupOrder": 0
                }, {
                    "value": "film cassette",
                    "key": "film cassette",
                    "groupOrder": 0
                }, {
                    "value": "film reel",
                    "key": "film reel",
                    "groupOrder": 0
                }, {
                    "value": "film roll",
                    "key": "film roll",
                    "groupOrder": 0
                }, {
                    "value": "filmslip",
                    "key": "filmslip",
                    "groupOrder": 0
                }, {
                    "value": "filmstrip",
                    "key": "filmstrip",
                    "groupOrder": 0
                }, {
                    "value": "filmstrip cartridge",
                    "key": "filmstrip cartridge",
                    "groupOrder": 0
                }, {
                    "value": "flipchart",
                    "key": "flipchart",
                    "groupOrder": 0
                }, {
                    "value": "microfiche",
                    "key": "microfiche",
                    "groupOrder": 0
                }, {
                    "value": "microfiche cassette",
                    "key": "microfiche cassette",
                    "groupOrder": 0
                }, {
                    "value": "microfilm cartridge",
                    "key": "microfilm cartridge",
                    "groupOrder": 0
                }, {
                    "value": "microfilm cassette",
                    "key": "microfilm cassette",
                    "groupOrder": 0
                }, {
                    "value": "microfilm reel",
                    "key": "microfilm reel",
                    "groupOrder": 0
                }, {
                    "value": "microfilm roll",
                    "key": "microfilm roll",
                    "groupOrder": 0
                }, {
                    "value": "microopaque",
                    "key": "microopaque",
                    "groupOrder": 0
                }, {
                    "value": "microscope slide",
                    "key": "microscope slide",
                    "groupOrder": 0
                }, {
                    "value": "object",
                    "key": "object",
                    "groupOrder": 0
                }, {
                    "value": "online resource",
                    "key": "online resource",
                    "groupOrder": 0
                }, {
                    "value": "other",
                    "key": "other",
                    "groupOrder": 0
                }, {
                    "value": "overhead transparency",
                    "key": "overhead transparency",
                    "groupOrder": 0
                }, {
                    "value": "roll",
                    "key": "roll",
                    "groupOrder": 0
                }, {
                    "value": "sheet",
                    "key": "sheet",
                    "groupOrder": 0
                }, {
                    "value": "slide",
                    "key": "slide",
                    "groupOrder": 0
                }, {
                    "value": "sound track reel",
                    "key": "sound track reel",
                    "groupOrder": 0
                }, {
                    "value": "stereograph card",
                    "key": "stereograph card",
                    "groupOrder": 0
                }, {
                    "value": "stereograph disc",
                    "key": "stereograph disc",
                    "groupOrder": 0
                }, {
                    "value": "unspecified",
                    "key": "unspecified",
                    "groupOrder": 0
                }, {
                    "value": "video cartridge",
                    "key": "video cartridge",
                    "groupOrder": 0
                }, {
                    "value": "videocassette",
                    "key": "videocassette",
                    "groupOrder": 0
                }, {
                    "value": "videodisc",
                    "key": "videodisc",
                    "groupOrder": 0
                }, {
                    "value": "videotape reel",
                    "key": "videotape reel",
                    "groupOrder": 0
                }, {
                    "value": "volume",
                    "key": "volume",
                    "groupOrder": 0
                }]
        },
        "cartographic_mathematical_data": {
            "key": "cartographic_mathematical_data",
            "value": "Cartographic Mathematical Data",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_catalogerLevel": {
            "key": "mms_catalogerLevel",
            "value": "Cataloger Level",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }],
            "options": [{
                    "value": "Default Level",
                    "key": "00",
                    "groupOrder": 0
                }]
        },
        "classification_part": {
            "key": "classification_part",
            "value": "Classification Part",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "coded_cartographic_mathematical_data": {
            "key": "coded_cartographic_mathematical_data",
            "value": "Coded Cartographic Mathematical Data",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_memberOfDeep": {
            "key": "mms_memberOfDeep",
            "value": "Collection ID (All Sub-Levels)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_memberOf": {
            "key": "mms_memberOf",
            "value": "Collection ID (One Level)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "content_related_data": {
            "key": "content_related_data",
            "value": "Content Related Data",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "content_type_code": {
            "key": "content_type_code",
            "value": "Content Type Code",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "cod",
                    "key": "cod",
                    "groupOrder": 0
                }, {
                    "value": "cop",
                    "key": "cop",
                    "groupOrder": 0
                }, {
                    "value": "crd",
                    "key": "crd",
                    "groupOrder": 0
                }, {
                    "value": "crf",
                    "key": "crf",
                    "groupOrder": 0
                }, {
                    "value": "cri",
                    "key": "cri",
                    "groupOrder": 0
                }, {
                    "value": "crm",
                    "key": "crm",
                    "groupOrder": 0
                }, {
                    "value": "crn",
                    "key": "crn",
                    "groupOrder": 0
                }, {
                    "value": "crt",
                    "key": "crt",
                    "groupOrder": 0
                }, {
                    "value": "ntm",
                    "key": "ntm",
                    "groupOrder": 0
                }, {
                    "value": "ntv",
                    "key": "ntv",
                    "groupOrder": 0
                }, {
                    "value": "prm",
                    "key": "prm",
                    "groupOrder": 0
                }, {
                    "value": "snd",
                    "key": "snd",
                    "groupOrder": 0
                }, {
                    "value": "spw",
                    "key": "spw",
                    "groupOrder": 0
                }, {
                    "value": "sti",
                    "key": "sti",
                    "groupOrder": 0
                }, {
                    "value": "tcf",
                    "key": "tcf",
                    "groupOrder": 0
                }, {
                    "value": "tci",
                    "key": "tci",
                    "groupOrder": 0
                }, {
                    "value": "tcm",
                    "key": "tcm",
                    "groupOrder": 0
                }, {
                    "value": "tcn",
                    "key": "tcn",
                    "groupOrder": 0
                }, {
                    "value": "tct",
                    "key": "tct",
                    "groupOrder": 0
                }, {
                    "value": "tdf",
                    "key": "tdf",
                    "groupOrder": 0
                }, {
                    "value": "tdi",
                    "key": "tdi",
                    "groupOrder": 0
                }, {
                    "value": "tdm",
                    "key": "tdm",
                    "groupOrder": 0
                }, {
                    "value": "txt",
                    "key": "txt",
                    "groupOrder": 0
                }, {
                    "value": "xxx",
                    "key": "xxx",
                    "groupOrder": 0
                }, {
                    "value": "zzz",
                    "key": "zzz",
                    "groupOrder": 0
                }]
        },
        "content_type_term": {
            "key": "content_type_term",
            "value": "Content Type Term",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "cartographic dataset",
                    "key": "cartographic dataset",
                    "groupOrder": 0
                }, {
                    "value": "cartographic image",
                    "key": "cartographic image",
                    "groupOrder": 0
                }, {
                    "value": "cartographic moving image",
                    "key": "cartographic moving image",
                    "groupOrder": 0
                }, {
                    "value": "cartographic tactile image",
                    "key": "cartographic tactile image",
                    "groupOrder": 0
                }, {
                    "value": "cartographic tactile three-dimensional form",
                    "key": "cartographic tactile three-dimensional form",
                    "groupOrder": 0
                }, {
                    "value": "cartographic three-dimensional form",
                    "key": "cartographic three-dimensional form",
                    "groupOrder": 0
                }, {
                    "value": "computer dataset",
                    "key": "computer dataset",
                    "groupOrder": 0
                }, {
                    "value": "computer program",
                    "key": "computer program",
                    "groupOrder": 0
                }, {
                    "value": "notated movement",
                    "key": "notated movement",
                    "groupOrder": 0
                }, {
                    "value": "notated music",
                    "key": "notated music",
                    "groupOrder": 0
                }, {
                    "value": "other",
                    "key": "other",
                    "groupOrder": 0
                }, {
                    "value": "performed music",
                    "key": "performed music",
                    "groupOrder": 0
                }, {
                    "value": "sounds",
                    "key": "sounds",
                    "groupOrder": 0
                }, {
                    "value": "spoken word",
                    "key": "spoken word",
                    "groupOrder": 0
                }, {
                    "value": "still image",
                    "key": "still image",
                    "groupOrder": 0
                }, {
                    "value": "tactile image",
                    "key": "tactile image",
                    "groupOrder": 0
                }, {
                    "value": "tactile notated movement",
                    "key": "tactile notated movement",
                    "groupOrder": 0
                }, {
                    "value": "tactile notated music",
                    "key": "tactile notated music",
                    "groupOrder": 0
                }, {
                    "value": "tactile text",
                    "key": "tactile text",
                    "groupOrder": 0
                }, {
                    "value": "tactile three-dimensional form",
                    "key": "tactile three-dimensional form",
                    "groupOrder": 0
                }, {
                    "value": "text",
                    "key": "text",
                    "groupOrder": 0
                }, {
                    "value": "three-dimensional form",
                    "key": "three-dimensional form",
                    "groupOrder": 0
                }, {
                    "value": "three-dimensional moving image",
                    "key": "three-dimensional moving image",
                    "groupOrder": 0
                }, {
                    "value": "two-dimensional moving image",
                    "key": "two-dimensional moving image",
                    "groupOrder": 0
                }, {
                    "value": "unspecified",
                    "key": "unspecified",
                    "groupOrder": 0
                }]
        },
        "mms_contributedBy": {
            "key": "mms_contributedBy",
            "value": "Contributed By",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "copyrights_note": {
            "key": "copyrights_note",
            "value": "Copyright Note",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "country_of_publication_new": {
            "key": "country_of_publication_new",
            "value": "Country of Publication",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Afghanistan",
                    "key": "af",
                    "groupOrder": 0
                }, {
                    "value": "Alabama",
                    "key": "alu",
                    "groupOrder": 0
                }, {
                    "value": "Alaska",
                    "key": "aku",
                    "groupOrder": 0
                }, {
                    "value": "Albania",
                    "key": "Albania",
                    "groupOrder": 0
                }, {
                    "value": "Alberta",
                    "key": "abc",
                    "groupOrder": 0
                }, {
                    "value": "Algeria",
                    "key": "Algeria",
                    "groupOrder": 0
                }, {
                    "value": "American Samoa",
                    "key": "as",
                    "groupOrder": 0
                }, {
                    "value": "Andorra",
                    "key": "Andorra",
                    "groupOrder": 0
                }, {
                    "value": "Angola",
                    "key": "ao",
                    "groupOrder": 0
                }, {
                    "value": "Anguilla",
                    "key": "Anguilla",
                    "groupOrder": 0
                }, {
                    "value": "Antarctica",
                    "key": "Antarctica",
                    "groupOrder": 0
                }, {
                    "value": "Antigua and Barbuda",
                    "key": "Antigua and Barbuda",
                    "groupOrder": 0
                }, {
                    "value": "Argentina",
                    "key": "Argentina",
                    "groupOrder": 0
                }, {
                    "value": "Arizona",
                    "key": "azu",
                    "groupOrder": 0
                }, {
                    "value": "Arkansas",
                    "key": "aru",
                    "groupOrder": 0
                }, {
                    "value": "Armenia",
                    "key": "AM",
                    "groupOrder": 0
                }, {
                    "value": "Armenia (Republic)",
                    "key": "ai",
                    "groupOrder": 0
                }, {
                    "value": "Armenian S.S.R. (old code)",
                    "key": "air",
                    "groupOrder": 0
                }, {
                    "value": "Aruba",
                    "key": "aw",
                    "groupOrder": 0
                }, {
                    "value": "Ashmore and Cartier Islands",
                    "key": "-ac",
                    "groupOrder": 0
                }, {
                    "value": "Australia",
                    "key": "Australia",
                    "groupOrder": 0
                }, {
                    "value": "Australian Capital Territory",
                    "key": "aca",
                    "groupOrder": 0
                }, {
                    "value": "Austria",
                    "key": "Austria",
                    "groupOrder": 0
                }, {
                    "value": "Azerbaijan",
                    "key": "Azerbaijan",
                    "groupOrder": 0
                }, {
                    "value": "Azerbaijan S.S.R. (old code)",
                    "key": "ajr",
                    "groupOrder": 0
                }, {
                    "value": "Bahamas",
                    "key": "bf",
                    "groupOrder": 0
                }, {
                    "value": "Bahamas (the)",
                    "key": "BS",
                    "groupOrder": 0
                }, {
                    "value": "Bahrain",
                    "key": "Bahrain",
                    "groupOrder": 0
                }, {
                    "value": "Bangladesh",
                    "key": "Bangladesh",
                    "groupOrder": 0
                }, {
                    "value": "Barbados",
                    "key": "bb",
                    "groupOrder": 0
                }, {
                    "value": "Belarus",
                    "key": "Belarus",
                    "groupOrder": 0
                }, {
                    "value": "Belgium",
                    "key": "be",
                    "groupOrder": 0
                }, {
                    "value": "Belize",
                    "key": "Belize",
                    "groupOrder": 0
                }, {
                    "value": "Benin",
                    "key": "Benin",
                    "groupOrder": 0
                }, {
                    "value": "Bermuda",
                    "key": "BM",
                    "groupOrder": 0
                }, {
                    "value": "Bermuda Islands",
                    "key": "bm",
                    "groupOrder": 0
                }, {
                    "value": "Bhutan",
                    "key": "bt",
                    "groupOrder": 0
                }, {
                    "value": "Bolivia",
                    "key": "bo",
                    "groupOrder": 0
                }, {
                    "value": "Bolivia (Plurinational State of)",
                    "key": "BO",
                    "groupOrder": 0
                }, {
                    "value": "Bonaire, Sint Eustatius and Saba",
                    "key": "BQ",
                    "groupOrder": 0
                }, {
                    "value": "Bosnia and Herzegovina",
                    "key": "Bosnia and Herzegovina",
                    "groupOrder": 0
                }, {
                    "value": "Botswana",
                    "key": "Botswana",
                    "groupOrder": 0
                }, {
                    "value": "Bouvet Island",
                    "key": "bv",
                    "groupOrder": 0
                }, {
                    "value": "Brazil",
                    "key": "Brazil",
                    "groupOrder": 0
                }, {
                    "value": "British Columbia",
                    "key": "bcc",
                    "groupOrder": 0
                }, {
                    "value": "British Indian Ocean Territ",
                    "key": "bi",
                    "groupOrder": 0
                }, {
                    "value": "British Indian Ocean Territory (the)",
                    "key": "IO",
                    "groupOrder": 0
                }, {
                    "value": "British Virgin Islands",
                    "key": "vb",
                    "groupOrder": 0
                }, {
                    "value": "Brunei",
                    "key": "bx",
                    "groupOrder": 0
                }, {
                    "value": "Brunei Darussalam",
                    "key": "BN",
                    "groupOrder": 0
                }, {
                    "value": "Bulgaria",
                    "key": "Bulgaria",
                    "groupOrder": 0
                }, {
                    "value": "Burkina Faso",
                    "key": "Burkina Faso",
                    "groupOrder": 0
                }, {
                    "value": "Burma",
                    "key": "br",
                    "groupOrder": 0
                }, {
                    "value": "Burundi",
                    "key": "Burundi",
                    "groupOrder": 0
                }, {
                    "value": "Byelorussian S.S.R. (old code)",
                    "key": "bwr",
                    "groupOrder": 0
                }, {
                    "value": "Cabo Verde",
                    "key": "cv",
                    "groupOrder": 0
                }, {
                    "value": "California",
                    "key": "cau",
                    "groupOrder": 0
                }, {
                    "value": "Cambodia",
                    "key": "Cambodia",
                    "groupOrder": 0
                }, {
                    "value": "Cameroon",
                    "key": "cm",
                    "groupOrder": 0
                }, {
                    "value": "Canada",
                    "key": "Canada",
                    "groupOrder": 0
                }, {
                    "value": "Canal Zone",
                    "key": "-cz",
                    "groupOrder": 0
                }, {
                    "value": "Canton and Enderbury Islands",
                    "key": "-cp",
                    "groupOrder": 0
                }, {
                    "value": "Caribbean Netherlands",
                    "key": "ca",
                    "groupOrder": 0
                }, {
                    "value": "Catalunya",
                    "key": "spc",
                    "groupOrder": 0
                }, {
                    "value": "Cayman Islands",
                    "key": "cj",
                    "groupOrder": 0
                }, {
                    "value": "Cayman Islands (the)",
                    "key": "KY",
                    "groupOrder": 0
                }, {
                    "value": "Central African Republic",
                    "key": "cx",
                    "groupOrder": 0
                }, {
                    "value": "Central African Republic (the)",
                    "key": "CF",
                    "groupOrder": 0
                }, {
                    "value": "Central and Southern Line Is",
                    "key": "-ln",
                    "groupOrder": 0
                }, {
                    "value": "Chad",
                    "key": "Chad",
                    "groupOrder": 0
                }, {
                    "value": "Chile",
                    "key": "cl",
                    "groupOrder": 0
                }, {
                    "value": "China",
                    "key": "China",
                    "groupOrder": 0
                }, {
                    "value": "China (Republic : 1949- )",
                    "key": "ch",
                    "groupOrder": 0
                }, {
                    "value": "Christmas Island",
                    "key": "CX",
                    "groupOrder": 0
                }, {
                    "value": "Christmas Island (Indian Ocean)",
                    "key": "xa",
                    "groupOrder": 0
                }, {
                    "value": "Cocos (Keeling) Islands",
                    "key": "xb",
                    "groupOrder": 0
                }, {
                    "value": "Cocos (Keeling) Islands (the)",
                    "key": "CC",
                    "groupOrder": 0
                }, {
                    "value": "Colombia",
                    "key": "Colombia",
                    "groupOrder": 0
                }, {
                    "value": "Colorado",
                    "key": "cou",
                    "groupOrder": 0
                }, {
                    "value": "Comoros",
                    "key": "cq",
                    "groupOrder": 0
                }, {
                    "value": "Comoros (the)",
                    "key": "KM",
                    "groupOrder": 0
                }, {
                    "value": "Congo (Brazzaville)",
                    "key": "cf",
                    "groupOrder": 0
                }, {
                    "value": "Congo (Democratic Republic)",
                    "key": "cg",
                    "groupOrder": 0
                }, {
                    "value": "Congo (the Democratic Republic of the)",
                    "key": "CD",
                    "groupOrder": 0
                }, {
                    "value": "Congo (the)",
                    "key": "CG",
                    "groupOrder": 0
                }, {
                    "value": "Connecticut",
                    "key": "ctu",
                    "groupOrder": 0
                }, {
                    "value": "Cook Islands",
                    "key": "cw",
                    "groupOrder": 0
                }, {
                    "value": "Cook Islands (the)",
                    "key": "CK",
                    "groupOrder": 0
                }, {
                    "value": "Coral Sea Islands Territory",
                    "key": "xga",
                    "groupOrder": 0
                }, {
                    "value": "Costa Rica",
                    "key": "cr",
                    "groupOrder": 0
                }, {
                    "value": "Croatia",
                    "key": "Croatia",
                    "groupOrder": 0
                }, {
                    "value": "Cuba",
                    "key": "cu",
                    "groupOrder": 0
                }, {
                    "value": "Curaçao",
                    "key": "Curaçao",
                    "groupOrder": 0
                }, {
                    "value": "Cyprus",
                    "key": "cy",
                    "groupOrder": 0
                }, {
                    "value": "Czech Republic",
                    "key": "xr",
                    "groupOrder": 0
                }, {
                    "value": "Czechia",
                    "key": "CZ",
                    "groupOrder": 0
                }, {
                    "value": "Czechoslovakia",
                    "key": "-cs",
                    "groupOrder": 0
                }, {
                    "value": "Côte d'Ivoire",
                    "key": "Côte d'Ivoire",
                    "groupOrder": 0
                }, {
                    "value": "Delaware",
                    "key": "deu",
                    "groupOrder": 0
                }, {
                    "value": "Denmark",
                    "key": "dk",
                    "groupOrder": 0
                }, {
                    "value": "District of Columbia",
                    "key": "dcu",
                    "groupOrder": 0
                }, {
                    "value": "Djibouti",
                    "key": "Djibouti",
                    "groupOrder": 0
                }, {
                    "value": "Dominica",
                    "key": "Dominica",
                    "groupOrder": 0
                }, {
                    "value": "Dominican Republic",
                    "key": "dr",
                    "groupOrder": 0
                }, {
                    "value": "Dominican Republic (the)",
                    "key": "DO",
                    "groupOrder": 0
                }, {
                    "value": "Ecuador",
                    "key": "ec",
                    "groupOrder": 0
                }, {
                    "value": "Egypt",
                    "key": "Egypt",
                    "groupOrder": 0
                }, {
                    "value": "El Salvador",
                    "key": "El Salvador",
                    "groupOrder": 0
                }, {
                    "value": "England",
                    "key": "enk",
                    "groupOrder": 0
                }, {
                    "value": "Equatorial Guinea",
                    "key": "Equatorial Guinea",
                    "groupOrder": 0
                }, {
                    "value": "Eritrea",
                    "key": "Eritrea",
                    "groupOrder": 0
                }, {
                    "value": "Estonia",
                    "key": "Estonia",
                    "groupOrder": 0
                }, {
                    "value": "Estonia (old code)",
                    "key": "err",
                    "groupOrder": 0
                }, {
                    "value": "Eswatini",
                    "key": "SZ",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopia",
                    "key": "et",
                    "groupOrder": 0
                }, {
                    "value": "Falkland Islands",
                    "key": "fk",
                    "groupOrder": 0
                }, {
                    "value": "Falkland Islands (the) [Malvinas]",
                    "key": "FK",
                    "groupOrder": 0
                }, {
                    "value": "Faroe Islands",
                    "key": "fa",
                    "groupOrder": 0
                }, {
                    "value": "Faroe Islands (the)",
                    "key": "FO",
                    "groupOrder": 0
                }, {
                    "value": "Fiji",
                    "key": "fj",
                    "groupOrder": 0
                }, {
                    "value": "Finland",
                    "key": "fi",
                    "groupOrder": 0
                }, {
                    "value": "Florida",
                    "key": "flu",
                    "groupOrder": 0
                }, {
                    "value": "France",
                    "key": "fr",
                    "groupOrder": 0
                }, {
                    "value": "French Guiana",
                    "key": "French Guiana",
                    "groupOrder": 0
                }, {
                    "value": "French Polynesia",
                    "key": "French Polynesia",
                    "groupOrder": 0
                }, {
                    "value": "French Southern Territories (the)",
                    "key": "TF",
                    "groupOrder": 0
                }, {
                    "value": "Gabon",
                    "key": "Gabon",
                    "groupOrder": 0
                }, {
                    "value": "Gambia",
                    "key": "gm",
                    "groupOrder": 0
                }, {
                    "value": "Gambia (the)",
                    "key": "GM",
                    "groupOrder": 0
                }, {
                    "value": "Gaza Strip",
                    "key": "gz",
                    "groupOrder": 0
                }, {
                    "value": "Georgia",
                    "key": "gau",
                    "groupOrder": 0
                }, {
                    "value": "Georgia (Republic)",
                    "key": "gs",
                    "groupOrder": 0
                }, {
                    "value": "Georgian S.S.R. (old code)",
                    "key": "gsr",
                    "groupOrder": 0
                }, {
                    "value": "Germany",
                    "key": "Germany",
                    "groupOrder": 0
                }, {
                    "value": "Germany (East)",
                    "key": "-ge",
                    "groupOrder": 0
                }, {
                    "value": "Ghana",
                    "key": "gh",
                    "groupOrder": 0
                }, {
                    "value": "Gibraltar",
                    "key": "gi",
                    "groupOrder": 0
                }, {
                    "value": "Gilbert and Ellice Islands",
                    "key": "-gn",
                    "groupOrder": 0
                }, {
                    "value": "Greece",
                    "key": "gr",
                    "groupOrder": 0
                }, {
                    "value": "Greenland",
                    "key": "gl",
                    "groupOrder": 0
                }, {
                    "value": "Grenada",
                    "key": "gd",
                    "groupOrder": 0
                }, {
                    "value": "Guadeloupe",
                    "key": "gp",
                    "groupOrder": 0
                }, {
                    "value": "Guam",
                    "key": "gu",
                    "groupOrder": 0
                }, {
                    "value": "Guatemala",
                    "key": "gt",
                    "groupOrder": 0
                }, {
                    "value": "Guernsey",
                    "key": "gg",
                    "groupOrder": 0
                }, {
                    "value": "Guinea",
                    "key": "Guinea",
                    "groupOrder": 0
                }, {
                    "value": "Guinea-Bissau",
                    "key": "Guinea-Bissau",
                    "groupOrder": 0
                }, {
                    "value": "Guyana",
                    "key": "gy",
                    "groupOrder": 0
                }, {
                    "value": "Haiti",
                    "key": "ht",
                    "groupOrder": 0
                }, {
                    "value": "Hawaii",
                    "key": "hiu",
                    "groupOrder": 0
                }, {
                    "value": "Heard Island and McDonald Islands",
                    "key": "HM",
                    "groupOrder": 0
                }, {
                    "value": "Heard and McDonald Islands",
                    "key": "hm",
                    "groupOrder": 0
                }, {
                    "value": "Holy See (the)",
                    "key": "VA",
                    "groupOrder": 0
                }, {
                    "value": "Honduras",
                    "key": "Honduras",
                    "groupOrder": 0
                }, {
                    "value": "Hong Kong",
                    "key": "Hong Kong",
                    "groupOrder": 0
                }, {
                    "value": "Hungary",
                    "key": "hu",
                    "groupOrder": 0
                }, {
                    "value": "Iceland",
                    "key": "Iceland",
                    "groupOrder": 0
                }, {
                    "value": "Idaho",
                    "key": "idu",
                    "groupOrder": 0
                }, {
                    "value": "Illinois",
                    "key": "ilu",
                    "groupOrder": 0
                }, {
                    "value": "India",
                    "key": "India",
                    "groupOrder": 0
                }, {
                    "value": "Indiana",
                    "key": "inu",
                    "groupOrder": 0
                }, {
                    "value": "Indonesia",
                    "key": "Indonesia",
                    "groupOrder": 0
                }, {
                    "value": "Iowa",
                    "key": "iau",
                    "groupOrder": 0
                }, {
                    "value": "Iran",
                    "key": "ir",
                    "groupOrder": 0
                }, {
                    "value": "Iran (Islamic Republic of)",
                    "key": "IR",
                    "groupOrder": 0
                }, {
                    "value": "Iraq",
                    "key": "iq",
                    "groupOrder": 0
                }, {
                    "value": "Iraq-Saudi Arabia Neutral Z",
                    "key": "iy",
                    "groupOrder": 0
                }, {
                    "value": "Ireland",
                    "key": "ie",
                    "groupOrder": 0
                }, {
                    "value": "Isle of Man",
                    "key": "im",
                    "groupOrder": 0
                }, {
                    "value": "Israel",
                    "key": "Israel",
                    "groupOrder": 0
                }, {
                    "value": "Israel-Jordan Demilitarized ",
                    "key": "-iw",
                    "groupOrder": 0
                }, {
                    "value": "Israel-Syria Demilitarized Z",
                    "key": "-iu",
                    "groupOrder": 0
                }, {
                    "value": "Italy",
                    "key": "it",
                    "groupOrder": 0
                }, {
                    "value": "Jamaica",
                    "key": "jm",
                    "groupOrder": 0
                }, {
                    "value": "Jan Mayen",
                    "key": "-jn",
                    "groupOrder": 0
                }, {
                    "value": "Japan",
                    "key": "Japan",
                    "groupOrder": 0
                }, {
                    "value": "Jersey",
                    "key": "je",
                    "groupOrder": 0
                }, {
                    "value": "Johnston Atoll",
                    "key": "ji",
                    "groupOrder": 0
                }, {
                    "value": "Jordan",
                    "key": "jo",
                    "groupOrder": 0
                }, {
                    "value": "Kansas",
                    "key": "ksu",
                    "groupOrder": 0
                }, {
                    "value": "Kazakh S.S.R. (old code)",
                    "key": "kzr",
                    "groupOrder": 0
                }, {
                    "value": "Kazakhstan",
                    "key": "kz",
                    "groupOrder": 0
                }, {
                    "value": "Kentucky",
                    "key": "kyu",
                    "groupOrder": 0
                }, {
                    "value": "Kenya",
                    "key": "ke",
                    "groupOrder": 0
                }, {
                    "value": "Kirghiz S.S.R. (old code)",
                    "key": "kgr",
                    "groupOrder": 0
                }, {
                    "value": "Kiribati",
                    "key": "Kiribati",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Busan)",
                    "key": "bnk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Chungcheongbuk-do)",
                    "key": "hbk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Chungcheongnam-do)",
                    "key": "hck",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Daegu)",
                    "key": "tgk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Daejeon)",
                    "key": "tjk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Gangwon-do)",
                    "key": "gak",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Gwangju)",
                    "key": "kjk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Gyeonggi-do)",
                    "key": "ggk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Gyeongsangbuk-do)",
                    "key": "gbk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Gyeongsangnam-do_x001C_)",
                    "key": "gnk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Incheon)",
                    "key": "ick",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Jeju-do)",
                    "key": "jjk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Jeollabuk-do)",
                    "key": "jbk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Jeollanam-do)",
                    "key": "jnk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (North)",
                    "key": "kn",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Sejong)",
                    "key": "sjk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Seoul)",
                    "key": "ulk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (South)",
                    "key": "ko",
                    "groupOrder": 0
                }, {
                    "value": "Korea (Ulsan)",
                    "key": "usk",
                    "groupOrder": 0
                }, {
                    "value": "Korea (the Democratic People's Republic of)",
                    "key": "KP",
                    "groupOrder": 0
                }, {
                    "value": "Korea (the Republic of)",
                    "key": "KR",
                    "groupOrder": 0
                }, {
                    "value": "Kosovo",
                    "key": "kv",
                    "groupOrder": 0
                }, {
                    "value": "Kuwait",
                    "key": "Kuwait",
                    "groupOrder": 0
                }, {
                    "value": "Kyrgyzstan",
                    "key": "kg",
                    "groupOrder": 0
                }, {
                    "value": "Lao People's Democratic Republic (the)",
                    "key": "LA",
                    "groupOrder": 0
                }, {
                    "value": "Laos",
                    "key": "ls",
                    "groupOrder": 0
                }, {
                    "value": "Latvia",
                    "key": "Latvia",
                    "groupOrder": 0
                }, {
                    "value": "Latvia (old code)",
                    "key": "lvr",
                    "groupOrder": 0
                }, {
                    "value": "Lebanon",
                    "key": "Lebanon",
                    "groupOrder": 0
                }, {
                    "value": "Lesotho",
                    "key": "Lesotho",
                    "groupOrder": 0
                }, {
                    "value": "Liberia",
                    "key": "Liberia",
                    "groupOrder": 0
                }, {
                    "value": "Libya",
                    "key": "ly",
                    "groupOrder": 0
                }, {
                    "value": "Liechtenstein",
                    "key": "Liechtenstein",
                    "groupOrder": 0
                }, {
                    "value": "Lithuania",
                    "key": "Lithuania",
                    "groupOrder": 0
                }, {
                    "value": "Lithuania (old code)",
                    "key": "lir",
                    "groupOrder": 0
                }, {
                    "value": "Louisiana",
                    "key": "lau",
                    "groupOrder": 0
                }, {
                    "value": "Luxembourg",
                    "key": "lu",
                    "groupOrder": 0
                }, {
                    "value": "Macao",
                    "key": "Macao",
                    "groupOrder": 0
                }, {
                    "value": "Macedonia",
                    "key": "xn",
                    "groupOrder": 0
                }, {
                    "value": "Madagascar",
                    "key": "mg",
                    "groupOrder": 0
                }, {
                    "value": "Maine",
                    "key": "meu",
                    "groupOrder": 0
                }, {
                    "value": "Malawi",
                    "key": "mw",
                    "groupOrder": 0
                }, {
                    "value": "Malaysia",
                    "key": "my",
                    "groupOrder": 0
                }, {
                    "value": "Maldives",
                    "key": "Maldives",
                    "groupOrder": 0
                }, {
                    "value": "Mali",
                    "key": "ml",
                    "groupOrder": 0
                }, {
                    "value": "Malta",
                    "key": "Malta",
                    "groupOrder": 0
                }, {
                    "value": "Manitoba",
                    "key": "mbc",
                    "groupOrder": 0
                }, {
                    "value": "Marshall Islands",
                    "key": "xe",
                    "groupOrder": 0
                }, {
                    "value": "Marshall Islands (the)",
                    "key": "MH",
                    "groupOrder": 0
                }, {
                    "value": "Martinique",
                    "key": "mq",
                    "groupOrder": 0
                }, {
                    "value": "Maryland",
                    "key": "mdu",
                    "groupOrder": 0
                }, {
                    "value": "Massachusetts",
                    "key": "mau",
                    "groupOrder": 0
                }, {
                    "value": "Mauritania",
                    "key": "Mauritania",
                    "groupOrder": 0
                }, {
                    "value": "Mauritius",
                    "key": "Mauritius",
                    "groupOrder": 0
                }, {
                    "value": "Mayotte",
                    "key": "Mayotte",
                    "groupOrder": 0
                }, {
                    "value": "Mexico",
                    "key": "mx",
                    "groupOrder": 0
                }, {
                    "value": "Michigan",
                    "key": "miu",
                    "groupOrder": 0
                }, {
                    "value": "Micronesia (Federated State",
                    "key": "fm",
                    "groupOrder": 0
                }, {
                    "value": "Micronesia (Federated States of)",
                    "key": "FM",
                    "groupOrder": 0
                }, {
                    "value": "Midway Islands",
                    "key": "xf",
                    "groupOrder": 0
                }, {
                    "value": "Minnesota",
                    "key": "mnu",
                    "groupOrder": 0
                }, {
                    "value": "Mississippi",
                    "key": "msu",
                    "groupOrder": 0
                }, {
                    "value": "Missouri",
                    "key": "mou",
                    "groupOrder": 0
                }, {
                    "value": "Moldavian S.S.R. (old code)",
                    "key": "mvr",
                    "groupOrder": 0
                }, {
                    "value": "Moldova",
                    "key": "mv",
                    "groupOrder": 0
                }, {
                    "value": "Moldova (the Republic of)",
                    "key": "MD",
                    "groupOrder": 0
                }, {
                    "value": "Monaco",
                    "key": "mc",
                    "groupOrder": 0
                }, {
                    "value": "Mongolia",
                    "key": "Mongolia",
                    "groupOrder": 0
                }, {
                    "value": "Montana",
                    "key": "mtu",
                    "groupOrder": 0
                }, {
                    "value": "Montenegro",
                    "key": "Montenegro",
                    "groupOrder": 0
                }, {
                    "value": "Montserrat",
                    "key": "Montserrat",
                    "groupOrder": 0
                }, {
                    "value": "Morocco",
                    "key": "Morocco",
                    "groupOrder": 0
                }, {
                    "value": "Mozambique",
                    "key": "mz",
                    "groupOrder": 0
                }, {
                    "value": "Myanmar",
                    "key": "MM",
                    "groupOrder": 0
                }, {
                    "value": "Namibia",
                    "key": "Namibia",
                    "groupOrder": 0
                }, {
                    "value": "Nauru",
                    "key": "Nauru",
                    "groupOrder": 0
                }, {
                    "value": "Nebraska",
                    "key": "nbu",
                    "groupOrder": 0
                }, {
                    "value": "Nepal",
                    "key": "np",
                    "groupOrder": 0
                }, {
                    "value": "Netherlands",
                    "key": "ne",
                    "groupOrder": 0
                }, {
                    "value": "Netherlands (the)",
                    "key": "NL",
                    "groupOrder": 0
                }, {
                    "value": "Netherlands Antilles",
                    "key": "-na",
                    "groupOrder": 0
                }, {
                    "value": "Nevada",
                    "key": "nvu",
                    "groupOrder": 0
                }, {
                    "value": "New Brunswick",
                    "key": "nkc",
                    "groupOrder": 0
                }, {
                    "value": "New Caledonia",
                    "key": "New Caledonia",
                    "groupOrder": 0
                }, {
                    "value": "New Hampshire",
                    "key": "nhu",
                    "groupOrder": 0
                }, {
                    "value": "New Jersey",
                    "key": "nju",
                    "groupOrder": 0
                }, {
                    "value": "New Mexico",
                    "key": "nmu",
                    "groupOrder": 0
                }, {
                    "value": "New South Wales",
                    "key": "xna",
                    "groupOrder": 0
                }, {
                    "value": "New York (State)",
                    "key": "nyu",
                    "groupOrder": 0
                }, {
                    "value": "New Zealand",
                    "key": "nz",
                    "groupOrder": 0
                }, {
                    "value": "Newfoundland and Labrador",
                    "key": "nfc",
                    "groupOrder": 0
                }, {
                    "value": "Nicaragua",
                    "key": "Nicaragua",
                    "groupOrder": 0
                }, {
                    "value": "Niger",
                    "key": "ng",
                    "groupOrder": 0
                }, {
                    "value": "Niger (the)",
                    "key": "NE",
                    "groupOrder": 0
                }, {
                    "value": "Nigeria",
                    "key": "Nigeria",
                    "groupOrder": 0
                }, {
                    "value": "Niue",
                    "key": "Niue",
                    "groupOrder": 0
                }, {
                    "value": "No place, unknown, or undetermined",
                    "key": "xx",
                    "groupOrder": 0
                }, {
                    "value": "Norfolk Island",
                    "key": "Norfolk Island",
                    "groupOrder": 0
                }, {
                    "value": "North Carolina",
                    "key": "ncu",
                    "groupOrder": 0
                }, {
                    "value": "North Dakota",
                    "key": "ndu",
                    "groupOrder": 0
                }, {
                    "value": "North Macedonia",
                    "key": "MK",
                    "groupOrder": 0
                }, {
                    "value": "Northern Ireland",
                    "key": "nik",
                    "groupOrder": 0
                }, {
                    "value": "Northern Mariana Islands",
                    "key": "Northern Mariana Islands",
                    "groupOrder": 0
                }, {
                    "value": "Northern Mariana Islands (the)",
                    "key": "MP",
                    "groupOrder": 0
                }, {
                    "value": "Northern Territory",
                    "key": "xoa",
                    "groupOrder": 0
                }, {
                    "value": "Northwest Territories",
                    "key": "ntc",
                    "groupOrder": 0
                }, {
                    "value": "Norway",
                    "key": "no",
                    "groupOrder": 0
                }, {
                    "value": "Nova Scotia",
                    "key": "nsc",
                    "groupOrder": 0
                }, {
                    "value": "Nunavut",
                    "key": "nuc",
                    "groupOrder": 0
                }, {
                    "value": "Ohio",
                    "key": "ohu",
                    "groupOrder": 0
                }, {
                    "value": "Oklahoma",
                    "key": "oku",
                    "groupOrder": 0
                }, {
                    "value": "Oman",
                    "key": "Oman",
                    "groupOrder": 0
                }, {
                    "value": "Ontario",
                    "key": "onc",
                    "groupOrder": 0
                }, {
                    "value": "Oregon",
                    "key": "oru",
                    "groupOrder": 0
                }, {
                    "value": "Pakistan",
                    "key": "pk",
                    "groupOrder": 0
                }, {
                    "value": "Palau",
                    "key": "pw",
                    "groupOrder": 0
                }, {
                    "value": "Palestine, State of",
                    "key": "PS",
                    "groupOrder": 0
                }, {
                    "value": "Panama",
                    "key": "Panama",
                    "groupOrder": 0
                }, {
                    "value": "Papua New Guinea",
                    "key": "Papua New Guinea",
                    "groupOrder": 0
                }, {
                    "value": "Paracel Islands",
                    "key": "pf",
                    "groupOrder": 0
                }, {
                    "value": "Paraguay",
                    "key": "py",
                    "groupOrder": 0
                }, {
                    "value": "Pennsylvania",
                    "key": "pau",
                    "groupOrder": 0
                }, {
                    "value": "Peru",
                    "key": "pe",
                    "groupOrder": 0
                }, {
                    "value": "Philippines",
                    "key": "ph",
                    "groupOrder": 0
                }, {
                    "value": "Philippines (the)",
                    "key": "PH",
                    "groupOrder": 0
                }, {
                    "value": "Pitcairn",
                    "key": "PN",
                    "groupOrder": 0
                }, {
                    "value": "Pitcairn Island",
                    "key": "pc",
                    "groupOrder": 0
                }, {
                    "value": "Poland",
                    "key": "pl",
                    "groupOrder": 0
                }, {
                    "value": "Portugal",
                    "key": "Portugal",
                    "groupOrder": 0
                }, {
                    "value": "Portuguese Timor",
                    "key": "-pt",
                    "groupOrder": 0
                }, {
                    "value": "Prince Edward Island",
                    "key": "pic",
                    "groupOrder": 0
                }, {
                    "value": "Puerto Rico",
                    "key": "pr",
                    "groupOrder": 0
                }, {
                    "value": "Qatar",
                    "key": "qa",
                    "groupOrder": 0
                }, {
                    "value": "Queensland",
                    "key": "qea",
                    "groupOrder": 0
                }, {
                    "value": "Québec (Province)",
                    "key": "quc",
                    "groupOrder": 0
                }, {
                    "value": "Rhode Island",
                    "key": "riu",
                    "groupOrder": 0
                }, {
                    "value": "Romania",
                    "key": "Romania",
                    "groupOrder": 0
                }, {
                    "value": "Russia (Federation)",
                    "key": "ru",
                    "groupOrder": 0
                }, {
                    "value": "Russian Federation (the)",
                    "key": "RU",
                    "groupOrder": 0
                }, {
                    "value": "Russian S.F.S.R. (old code)",
                    "key": "rur",
                    "groupOrder": 0
                }, {
                    "value": "Rwanda",
                    "key": "rw",
                    "groupOrder": 0
                }, {
                    "value": "Ryukyu Islands, Southern",
                    "key": "-ry",
                    "groupOrder": 0
                }, {
                    "value": "Réunion",
                    "key": "re",
                    "groupOrder": 0
                }, {
                    "value": "Saint Barthélemy",
                    "key": "Saint Barthélemy",
                    "groupOrder": 0
                }, {
                    "value": "Saint Helena",
                    "key": "xj",
                    "groupOrder": 0
                }, {
                    "value": "Saint Helena, Ascension and Tristan da Cunha",
                    "key": "SH",
                    "groupOrder": 0
                }, {
                    "value": "Saint Kitts and Nevis",
                    "key": "KN",
                    "groupOrder": 0
                }, {
                    "value": "Saint Kitts-Nevis",
                    "key": "xd",
                    "groupOrder": 0
                }, {
                    "value": "Saint Kitts-Nevis-Anguilla",
                    "key": "-xi",
                    "groupOrder": 0
                }, {
                    "value": "Saint Lucia",
                    "key": "Saint Lucia",
                    "groupOrder": 0
                }, {
                    "value": "Saint Martin (French part)",
                    "key": "MF",
                    "groupOrder": 0
                }, {
                    "value": "Saint Pierre and Miquelon",
                    "key": "Saint Pierre and Miquelon",
                    "groupOrder": 0
                }, {
                    "value": "Saint Vincent and the Grena",
                    "key": "xm",
                    "groupOrder": 0
                }, {
                    "value": "Saint Vincent and the Grenadines",
                    "key": "VC",
                    "groupOrder": 0
                }, {
                    "value": "Saint-Martin",
                    "key": "st",
                    "groupOrder": 0
                }, {
                    "value": "Samoa",
                    "key": "ws",
                    "groupOrder": 0
                }, {
                    "value": "San Marino",
                    "key": "sm",
                    "groupOrder": 0
                }, {
                    "value": "Sao Tome and Principe",
                    "key": "Sao Tome and Principe",
                    "groupOrder": 0
                }, {
                    "value": "Saskatchewan",
                    "key": "snc",
                    "groupOrder": 0
                }, {
                    "value": "Saudi Arabia",
                    "key": "Saudi Arabia",
                    "groupOrder": 0
                }, {
                    "value": "Scotland",
                    "key": "stk",
                    "groupOrder": 0
                }, {
                    "value": "Senegal",
                    "key": "Senegal",
                    "groupOrder": 0
                }, {
                    "value": "Serbia",
                    "key": "Serbia",
                    "groupOrder": 0
                }, {
                    "value": "Serbia and Montenegro",
                    "key": "-yu",
                    "groupOrder": 0
                }, {
                    "value": "Seychelles",
                    "key": "Seychelles",
                    "groupOrder": 0
                }, {
                    "value": "Sierra Leone",
                    "key": "sl",
                    "groupOrder": 0
                }, {
                    "value": "Sikkim",
                    "key": "-sk",
                    "groupOrder": 0
                }, {
                    "value": "Singapore",
                    "key": "Singapore",
                    "groupOrder": 0
                }, {
                    "value": "Sint Maarten",
                    "key": "sn",
                    "groupOrder": 0
                }, {
                    "value": "Sint Maarten (Dutch part)",
                    "key": "SX",
                    "groupOrder": 0
                }, {
                    "value": "Slovakia",
                    "key": "Slovakia",
                    "groupOrder": 0
                }, {
                    "value": "Slovenia",
                    "key": "Slovenia",
                    "groupOrder": 0
                }, {
                    "value": "Solomon Islands",
                    "key": "Solomon Islands",
                    "groupOrder": 0
                }, {
                    "value": "Somalia",
                    "key": "so",
                    "groupOrder": 0
                }, {
                    "value": "South Africa",
                    "key": "South Africa",
                    "groupOrder": 0
                }, {
                    "value": "South Australia",
                    "key": "xra",
                    "groupOrder": 0
                }, {
                    "value": "South Carolina",
                    "key": "scu",
                    "groupOrder": 0
                }, {
                    "value": "South Dakota",
                    "key": "sdu",
                    "groupOrder": 0
                }, {
                    "value": "South Georgia and the South",
                    "key": "xs",
                    "groupOrder": 0
                }, {
                    "value": "South Georgia and the South Sandwich Islands",
                    "key": "GS",
                    "groupOrder": 0
                }, {
                    "value": "South Sudan",
                    "key": "South Sudan",
                    "groupOrder": 0
                }, {
                    "value": "Soviet Union",
                    "key": "Soviet Union",
                    "groupOrder": 0
                }, {
                    "value": "Spain",
                    "key": "Spain",
                    "groupOrder": 0
                }, {
                    "value": "Spanish North Africa",
                    "key": "sh",
                    "groupOrder": 0
                }, {
                    "value": "Spratly Island",
                    "key": "xp",
                    "groupOrder": 0
                }, {
                    "value": "Sri Lanka",
                    "key": "Sri Lanka",
                    "groupOrder": 0
                }, {
                    "value": "Sudan",
                    "key": "sj",
                    "groupOrder": 0
                }, {
                    "value": "Sudan (the)",
                    "key": "SD",
                    "groupOrder": 0
                }, {
                    "value": "Surinam",
                    "key": "sr",
                    "groupOrder": 0
                }, {
                    "value": "Suriname",
                    "key": "SR",
                    "groupOrder": 0
                }, {
                    "value": "Svalbard",
                    "key": "-sb",
                    "groupOrder": 0
                }, {
                    "value": "Svalbard and Jan Mayen",
                    "key": "SJ",
                    "groupOrder": 0
                }, {
                    "value": "Swan Islands",
                    "key": "-sv",
                    "groupOrder": 0
                }, {
                    "value": "Swaziland",
                    "key": "sq",
                    "groupOrder": 0
                }, {
                    "value": "Sweden",
                    "key": "Sweden",
                    "groupOrder": 0
                }, {
                    "value": "Switzerland",
                    "key": "Switzerland",
                    "groupOrder": 0
                }, {
                    "value": "Syria",
                    "key": "sy",
                    "groupOrder": 0
                }, {
                    "value": "Syrian Arab Republic (the)",
                    "key": "SY",
                    "groupOrder": 0
                }, {
                    "value": "Taiwan",
                    "key": "TW",
                    "groupOrder": 0
                }, {
                    "value": "Tajik S.S.R. (old code)",
                    "key": "tar",
                    "groupOrder": 0
                }, {
                    "value": "Tajikistan",
                    "key": "Tajikistan",
                    "groupOrder": 0
                }, {
                    "value": "Tanzania",
                    "key": "tz",
                    "groupOrder": 0
                }, {
                    "value": "Tanzania, the United Republic of",
                    "key": "TZ",
                    "groupOrder": 0
                }, {
                    "value": "Tasmania",
                    "key": "tma",
                    "groupOrder": 0
                }, {
                    "value": "Tennessee",
                    "key": "tnu",
                    "groupOrder": 0
                }, {
                    "value": "Terres australes et antarct",
                    "key": "fs",
                    "groupOrder": 0
                }, {
                    "value": "Texas",
                    "key": "txu",
                    "groupOrder": 0
                }, {
                    "value": "Thailand",
                    "key": "th",
                    "groupOrder": 0
                }, {
                    "value": "Timor-Leste",
                    "key": "Timor-Leste",
                    "groupOrder": 0
                }, {
                    "value": "Togo",
                    "key": "tg",
                    "groupOrder": 0
                }, {
                    "value": "Tokelau",
                    "key": "Tokelau",
                    "groupOrder": 0
                }, {
                    "value": "Tonga",
                    "key": "to",
                    "groupOrder": 0
                }, {
                    "value": "Trinidad and Tobago",
                    "key": "Trinidad and Tobago",
                    "groupOrder": 0
                }, {
                    "value": "Trust Territory of the Pacif",
                    "key": "-tt",
                    "groupOrder": 0
                }, {
                    "value": "Tunisia",
                    "key": "Tunisia",
                    "groupOrder": 0
                }, {
                    "value": "Turkey",
                    "key": "Turkey",
                    "groupOrder": 0
                }, {
                    "value": "Turkmen S.S.R. (old code)",
                    "key": "tkr",
                    "groupOrder": 0
                }, {
                    "value": "Turkmenistan",
                    "key": "Turkmenistan",
                    "groupOrder": 0
                }, {
                    "value": "Turks and Caicos Islands",
                    "key": "tc",
                    "groupOrder": 0
                }, {
                    "value": "Turks and Caicos Islands (the)",
                    "key": "TC",
                    "groupOrder": 0
                }, {
                    "value": "Tuvalu",
                    "key": "tv",
                    "groupOrder": 0
                }, {
                    "value": "Uganda",
                    "key": "ug",
                    "groupOrder": 0
                }, {
                    "value": "Ukraine",
                    "key": "Ukraine",
                    "groupOrder": 0
                }, {
                    "value": "Ukraine (old code)",
                    "key": "unr",
                    "groupOrder": 0
                }, {
                    "value": "United Arab Emirates",
                    "key": "ts",
                    "groupOrder": 0
                }, {
                    "value": "United Arab Emirates (the)",
                    "key": "AE",
                    "groupOrder": 0
                }, {
                    "value": "United Kingdom",
                    "key": "United Kingdom",
                    "groupOrder": 0
                }, {
                    "value": "United Kingdom Misc. Islands",
                    "key": "-ui",
                    "groupOrder": 0
                }, {
                    "value": "United Kingdom Misc. Islands (old code)",
                    "key": "uik",
                    "groupOrder": 0
                }, {
                    "value": "United Kingdom of Great Britain and Northern Ireland (the)",
                    "key": "GB",
                    "groupOrder": 0
                }, {
                    "value": "United States",
                    "key": "United States",
                    "groupOrder": 0
                }, {
                    "value": "United States Minor Outlying Islands (the)",
                    "key": "UM",
                    "groupOrder": 0
                }, {
                    "value": "United States Misc. Caribbe",
                    "key": "uc",
                    "groupOrder": 0
                }, {
                    "value": "United States Misc. Pacific",
                    "key": "up",
                    "groupOrder": 0
                }, {
                    "value": "United States of America (the)",
                    "key": "US",
                    "groupOrder": 0
                }, {
                    "value": "Uruguay",
                    "key": "uy",
                    "groupOrder": 0
                }, {
                    "value": "Utah",
                    "key": "utu",
                    "groupOrder": 0
                }, {
                    "value": "Uzbek S.S.R. (old code)",
                    "key": "uzr",
                    "groupOrder": 0
                }, {
                    "value": "Uzbekistan",
                    "key": "uz",
                    "groupOrder": 0
                }, {
                    "value": "Vanuatu",
                    "key": "Vanuatu",
                    "groupOrder": 0
                }, {
                    "value": "Various places",
                    "key": "vp",
                    "groupOrder": 0
                }, {
                    "value": "Vatican City",
                    "key": "vc",
                    "groupOrder": 0
                }, {
                    "value": "Venezuela",
                    "key": "ve",
                    "groupOrder": 0
                }, {
                    "value": "Venezuela (Bolivarian Republic of)",
                    "key": "VE",
                    "groupOrder": 0
                }, {
                    "value": "Vermont",
                    "key": "vtu",
                    "groupOrder": 0
                }, {
                    "value": "Victoria",
                    "key": "vra",
                    "groupOrder": 0
                }, {
                    "value": "Viet Nam",
                    "key": "VN",
                    "groupOrder": 0
                }, {
                    "value": "Vietnam",
                    "key": "vm",
                    "groupOrder": 0
                }, {
                    "value": "Vietnam, North",
                    "key": "-vn",
                    "groupOrder": 0
                }, {
                    "value": "Vietnam, South",
                    "key": "-vs",
                    "groupOrder": 0
                }, {
                    "value": "Virgin Islands (British)",
                    "key": "VG",
                    "groupOrder": 0
                }, {
                    "value": "Virgin Islands (U.S.)",
                    "key": "VI",
                    "groupOrder": 0
                }, {
                    "value": "Virgin Islands of the United States",
                    "key": "vi",
                    "groupOrder": 0
                }, {
                    "value": "Virginia",
                    "key": "vau",
                    "groupOrder": 0
                }, {
                    "value": "Wake Island",
                    "key": "wk",
                    "groupOrder": 0
                }, {
                    "value": "Wales",
                    "key": "wlk",
                    "groupOrder": 0
                }, {
                    "value": "Wallis and Futuna",
                    "key": "wf",
                    "groupOrder": 0
                }, {
                    "value": "Washington (State)",
                    "key": "wau",
                    "groupOrder": 0
                }, {
                    "value": "West Bank of the Jordan Riv",
                    "key": "wj",
                    "groupOrder": 0
                }, {
                    "value": "West Berlin",
                    "key": "-wb",
                    "groupOrder": 0
                }, {
                    "value": "West Virginia",
                    "key": "wvu",
                    "groupOrder": 0
                }, {
                    "value": "Western Australia",
                    "key": "wea",
                    "groupOrder": 0
                }, {
                    "value": "Western Sahara",
                    "key": "ss",
                    "groupOrder": 0
                }, {
                    "value": "Western Sahara*",
                    "key": "EH",
                    "groupOrder": 0
                }, {
                    "value": "Wisconsin",
                    "key": "wiu",
                    "groupOrder": 0
                }, {
                    "value": "Wyoming",
                    "key": "wyu",
                    "groupOrder": 0
                }, {
                    "value": "Yemen",
                    "key": "ye",
                    "groupOrder": 0
                }, {
                    "value": "Yemen (People's Democratic R",
                    "key": "-ys",
                    "groupOrder": 0
                }, {
                    "value": "Yukon Territory",
                    "key": "ykc",
                    "groupOrder": 0
                }, {
                    "value": "Zambia",
                    "key": "Zambia",
                    "groupOrder": 0
                }, {
                    "value": "Zimbabwe",
                    "key": "Zimbabwe",
                    "groupOrder": 0
                }, {
                    "value": "Åland Islands",
                    "key": "AX",
                    "groupOrder": 0
                }]
        },
        "local_field_999": {
            "key": "local_field_999",
            "value": "Course Restricted",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "creator": {
            "key": "creator",
            "value": "Creator",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "type_of_date": {
            "key": "type_of_date",
            "value": "Date Type Status",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Continuing resource ceased publication",
                    "key": "d",
                    "groupOrder": 0
                }, {
                    "value": "Continuing resource currently published",
                    "key": "c",
                    "groupOrder": 0
                }, {
                    "value": "Continuing resource status unknown",
                    "key": "u",
                    "groupOrder": 0
                }, {
                    "value": "Date of distribution/release/issue and production/recording session when different",
                    "key": "p",
                    "groupOrder": 0
                }, {
                    "value": "Dates unknown",
                    "key": "n",
                    "groupOrder": 0
                }, {
                    "value": "Detailed date",
                    "key": "e",
                    "groupOrder": 0
                }, {
                    "value": "Inclusive dates of collection",
                    "key": "i",
                    "groupOrder": 0
                }, {
                    "value": "Multiple dates",
                    "key": "m",
                    "groupOrder": 0
                }, {
                    "value": "No attempt to code",
                    "key": "|",
                    "groupOrder": 0
                }, {
                    "value": "No dates given; B.C. date involved",
                    "key": "b",
                    "groupOrder": 0
                }, {
                    "value": "Publication date and copyright date",
                    "key": "t",
                    "groupOrder": 0
                }, {
                    "value": "Questionable date",
                    "key": "q",
                    "groupOrder": 0
                }, {
                    "value": "Range of years of bulk of collection",
                    "key": "k",
                    "groupOrder": 0
                }, {
                    "value": "Reprint/reissue date and original date",
                    "key": "r",
                    "groupOrder": 0
                }, {
                    "value": "Single known date/probable date",
                    "key": "s",
                    "groupOrder": 0
                }]
        },
        "description": {
            "key": "description",
            "value": "Description",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dewey_decimal_class_number": {
            "key": "dewey_decimal_class_number",
            "value": "Dewey Decimal Class Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "local_field_903": {
            "key": "local_field_903",
            "value": "Digitized Version",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "digital_object_identifier": {
            "key": "digital_object_identifier",
            "value": "DOI - Digital Object Identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "alternate_complete_edition": {
            "key": "alternate_complete_edition",
            "value": "Edition",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "elocation": {
            "key": "elocation",
            "value": "Electronic Location And Note",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "event_date": {
            "key": "event_date",
            "value": "Event Date",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "genre_form": {
            "key": "genre_form",
            "value": "Genre Form",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "geographic_area_code": {
            "key": "geographic_area_code",
            "value": "Geographic Area Code",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "government_document_number": {
            "key": "government_document_number",
            "value": "Government Document Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "granular_resource_type": {
            "key": "granular_resource_type",
            "value": "Granular Resource Type",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_handle": {
            "key": "mms_handle",
            "value": "Handle Identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "has_inventory": {
            "key": "has_inventory",
            "value": "Has Inventory",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }],
            "options": [{
                    "value": "No",
                    "key": "0",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "1",
                    "groupOrder": 0
                }]
        },
        "heading_info": {
            "key": "heading_info",
            "value": "Heading Information",
            "type": "compositeSearch",
            "innerfields": {
                'auth_id': {
                    "searchType": "EQUALS_ONLY",
                    "type": "string",
                    "value": "Authority Id",
                    "fieldGroup": "0",
                    "key": "auth_id",
                    "preferred_operators": [
                        {
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        },
                        {
                            "op_key": "ALL_VALUES",
                            "op_value": "Equals Any Value"
                        },
                        {
                            "op_key": "EMPTY",
                            "op_value": "Is Empty"
                        }
                    ],
                    "visible": [
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SERIES",
                            "options": []
                        },
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES",
                            "options": []
                        },
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "CALL_NUMBER",
                            "options": []
                        },
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS",
                            "options": []
                        },
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS_WITH_MARC21_6XX",
                            "options": []
                        },
                        {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES_WITHOUT_MARC21_6XX",
                            "options": []
                        }
                    ]
                },
                "browse_type": {
                    "searchType": "EQUALS_ONLY",
                    "type": "category",
                    "value": "Heading Type",
                    "fieldGroup": "0",
                    "key": "browse_type",
                    "options": [{
                            "value": "Names",
                            "key": "NAMES",
                            "groupOrder": 0
                        }, {
                            "value": "Subjects",
                            "key": "SUBJECTS",
                            "groupOrder": 0
                        }, {
                            "value": "Series",
                            "key": "SERIES",
                            "groupOrder": 0
                        }, {
                            "value": "Title",
                            "key": "TITLE",
                            "groupOrder": 0
                        }],
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }],
                    "visible": []
                },
                "source_code": {
                    "searchType": "EQUALS_ONLY",
                    "type": "category",
                    "value": "Source Code",
                    "fieldGroup": "0",
                    "key": "source_code",
                    "options": [{
                            "value": "Corporate Name",
                            "key": "CORPORATE_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Event Name",
                            "key": "EVENT_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Meeting Name",
                            "key": "MEETING_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Personal Name",
                            "key": "PERSONAL_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Uniform Title",
                            "key": "UNIFORM_TITLE",
                            "groupOrder": 0
                        }, {
                            "value": "Corporate Name",
                            "key": "CORPORATE_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Event Name",
                            "key": "EVENT_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Meeting Name",
                            "key": "MEETING_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Personal Name",
                            "key": "PERSONAL_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Uniform Title",
                            "key": "UNIFORM_TITLE",
                            "groupOrder": 0
                        }, {
                            "value": "Additional Dewey Decimal Classification Number",
                            "key": "ADDITIONAL_DEWEY_DECIMAL_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Chinese Book Classification Call Number",
                            "key": "CHINESE_BOOK_CLASSIFICATION_CALL_NUMBER",
                            "groupOrder": 0
                        }, {
                            "value": "Chinese Library Classification",
                            "key": "CHINESE_LIBRARY_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Classification Numbers Assigned in Canada",
                            "key": "CLASSIFICATION_CANADA",
                            "groupOrder": 0
                        }, {
                            "value": "Dewey Decimal Classification Number",
                            "key": "DEWEY_DECIMAL_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Geographic Classification",
                            "key": "GEOGRAPHIC_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Government Document Classification Number",
                            "key": "GOVERNMENT_DOCUMENT_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Library Classification of Chinese Academy of Sciences",
                            "key": "LIBRARY_CLASSIFICATION_CAS",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress Call Number",
                            "key": "LOC_CL",
                            "groupOrder": 0
                        }, {
                            "value": "Local Call Number 09X (ten different options)",
                            "key": "LOCAL_CL_09X",
                            "groupOrder": 0
                        }, {
                            "value": "National Agricultural Library Call Number",
                            "key": "NATIONAL_AGRICULTURAL_CL",
                            "groupOrder": 0
                        }, {
                            "value": "National Library of Medicine Call Number",
                            "key": "NATIONAL_MEDICINE_CL",
                            "groupOrder": 0
                        }, {
                            "value": "Other Chinese Classification Number",
                            "key": "OTHER_CHINESE_CLASSIFICATION_NUMBER",
                            "groupOrder": 0
                        }, {
                            "value": "Other Classification Number",
                            "key": "OTHER_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Synthesized Classification Number Components",
                            "key": "SYNTHESIZED_CLASSIFICATION_COMPONENTS",
                            "groupOrder": 0
                        }, {
                            "value": "Universal Decimal Classification Number",
                            "key": "UNIVERSAL_DECIMAL_CLASSIFICATION",
                            "groupOrder": 0
                        }, {
                            "value": "Chronological Term",
                            "key": "CHRONOLOGICAL_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Genre/Form",
                            "key": "GENRE_FORM_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Geographic Name",
                            "key": "GEOGRAPHIC_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Medium of Performance",
                            "key": "MEDIUM_OF_PERFORMANCE",
                            "groupOrder": 0
                        }, {
                            "value": "Name Title",
                            "key": "NAME_TITLE",
                            "groupOrder": 0
                        }, {
                            "value": "Topical Term",
                            "key": "TOPICAL_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Chronological Term",
                            "key": "CHRONOLOGICAL_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Corporate Name",
                            "key": "CORPORATE_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Event Name",
                            "key": "EVENT_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Genre/Form",
                            "key": "GENRE_FORM_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Geographic Name",
                            "key": "GEOGRAPHIC_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Medium of Performance",
                            "key": "MEDIUM_OF_PERFORMANCE",
                            "groupOrder": 0
                        }, {
                            "value": "Meeting Name",
                            "key": "MEETING_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Personal Name",
                            "key": "PERSONAL_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Topical Term",
                            "key": "TOPICAL_TERM",
                            "groupOrder": 0
                        }, {
                            "value": "Uniform Title",
                            "key": "UNIFORM_TITLE",
                            "groupOrder": 0
                        }, {
                            "value": "Corporate Name",
                            "key": "CORPORATE_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Event Name",
                            "key": "EVENT_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Meeting Name",
                            "key": "MEETING_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Personal Name",
                            "key": "PERSONAL_NAME",
                            "groupOrder": 0
                        }, {
                            "value": "Uniform Title",
                            "key": "UNIFORM_TITLE",
                            "groupOrder": 0
                        }],
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }],
                    "visible": [{
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SERIES",
                            "options": ["CORPORATE_NAME", "EVENT_NAME", "MEETING_NAME", "PERSONAL_NAME", "UNIFORM_TITLE"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES",
                            "options": ["CORPORATE_NAME", "EVENT_NAME", "MEETING_NAME", "PERSONAL_NAME", "UNIFORM_TITLE"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "CALL_NUMBER",
                            "options": ["ADDITIONAL_DEWEY_DECIMAL_CLASSIFICATION", "CHINESE_BOOK_CLASSIFICATION_CALL_NUMBER", "CHINESE_LIBRARY_CLASSIFICATION", "CLASSIFICATION_CANADA", "DEWEY_DECIMAL_CLASSIFICATION", "GEOGRAPHIC_CLASSIFICATION", "GOVERNMENT_DOCUMENT_CLASSIFICATION", "LIBRARY_CLASSIFICATION_CAS", "LOC_CL", "LOCAL_CL_09X", "NATIONAL_AGRICULTURAL_CL", "NATIONAL_MEDICINE_CL", "OTHER_CHINESE_CLASSIFICATION_NUMBER", "OTHER_CLASSIFICATION", "SYNTHESIZED_CLASSIFICATION_COMPONENTS", "UNIVERSAL_DECIMAL_CLASSIFICATION"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS",
                            "options": ["CHRONOLOGICAL_TERM", "GENRE_FORM_TERM", "GEOGRAPHIC_NAME", "MEDIUM_OF_PERFORMANCE", "NAME_TITLE", "TOPICAL_TERM"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS_WITH_MARC21_6XX",
                            "options": ["CHRONOLOGICAL_TERM", "CORPORATE_NAME", "EVENT_NAME", "GENRE_FORM_TERM", "GEOGRAPHIC_NAME", "MEDIUM_OF_PERFORMANCE", "MEETING_NAME", "PERSONAL_NAME", "TOPICAL_TERM", "UNIFORM_TITLE"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES_WITHOUT_MARC21_6XX",
                            "options": ["CORPORATE_NAME", "EVENT_NAME", "MEETING_NAME", "PERSONAL_NAME", "UNIFORM_TITLE"]
                        }]
                },
                "family": {
                    "searchType": "EQUALS_ONLY",
                    "type": "category",
                    "value": "Record Format",
                    "fieldGroup": "0",
                    "key": "family",
                    "options": [{
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }, {
                            "value": "UNIMARC",
                            "key": "UNIMARC",
                            "groupOrder": 0
                        }, {
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }, {
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }, {
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }, {
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }, {
                            "value": "MARC21",
                            "key": "MARC21",
                            "groupOrder": 0
                        }],
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }],
                    "visible": [{
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SERIES",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "CALL_NUMBER",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "TITLE",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS_WITH_MARC21_6XX",
                            "options": ["MARC21"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES_WITHOUT_MARC21_6XX",
                            "options": ["MARC21"]
                        }]
                },
                "vocabulary_code_combo": {
                    "searchType": "EQUALS_ONLY",
                    "type": "category",
                    "value": "Vocabulary",
                    "fieldGroup": "0",
                    "key": "vocabulary_code",
                    "options": [{
                            "value": "Library of Congress name authority records",
                            "key": "LCNAMES",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress name authority records For 651",
                            "key": "LCNAMES_SUBJECTS",
                            "groupOrder": 0
                        }, {
                            "value": "U.S. National Library of Medicine, Medical Subject Headings 2013",
                            "key": "MESH",
                            "groupOrder": 0
                        }, {
                            "value": "German National Library Names and Subject Headings",
                            "key": "GND",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress Subject Headings",
                            "key": "LCSH",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress name authority records",
                            "key": "LCNAMES",
                            "groupOrder": 0
                        }, {
                            "value": "U.S. National Library of Medicine, Medical Subject Headings 2013",
                            "key": "MESH",
                            "groupOrder": 0
                        }, {
                            "value": "German National Library Names and Subject Headings",
                            "key": "GND",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress name authority records For 651",
                            "key": "LCNAMES_SUBJECTS",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress Subject Headings",
                            "key": "LCSH",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress name authority records For 651",
                            "key": "LCNAMES_SUBJECTS",
                            "groupOrder": 0
                        }, {
                            "value": "U.S. National Library of Medicine, Medical Subject Headings 2013",
                            "key": "MESH",
                            "groupOrder": 0
                        }, {
                            "value": "German National Library Names and Subject Headings",
                            "key": "GND",
                            "groupOrder": 0
                        }, {
                            "value": "Library of Congress Subject Headings",
                            "key": "LCSH",
                            "groupOrder": 0
                        }],
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }],
                    "visible": [{
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SERIES",
                            "options": []
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES",
                            "options": ["LCNAMES"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS",
                            "options": ["LCNAMES_SUBJECTS", "MESH", "GND", "LCSH"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "SUBJECTS_WITH_MARC21_6XX",
                            "options": ["LCNAMES", "MESH", "GND", "LCNAMES_SUBJECTS", "LCSH"]
                        }, {
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "NAMES_WITHOUT_MARC21_6XX",
                            "options": ["LCNAMES_SUBJECTS", "MESH", "GND", "LCSH"]
                        }]
                },
                "vocabulary_code_text": {
                    "searchType": "EQUALS_ONLY",
                    "type": "string",
                    "value": "Vocabulary",
                    "fieldGroup": "0",
                    "key": "vocabulary_code",
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }],
                    "visible": [{
                            "dependencyFieldName": "browse_type",
                            "dependencyFieldValue": "CALL_NUMBER",
                            "options": []
                        }, {
                            "dependencyFieldName": "source_code",
                            "dependencyFieldValue": "OTHER_CLASSIFICATION",
                            "options": []
                        }]
                },
                "filing_value": {
                    "searchType": "EQUALS_ONLY",
                    "type": "string",
                    "value": "Search Value",
                    "fieldGroup": "0",
                    "key": "filing_value",
                    "preferred_operators": [{
                            "op_key": "OUTER_EQUAL",
                            "op_value": "Equals"
                        }, {
                            "op_key": "COMPOSITE_EXACT_PHRASE_STARTING_WITH",
                            "op_value": "Exact phrase starting with"
                        }],
                    "visible": []
                }
            },
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "COMPOSITE_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Exact phrase starting with"
                }]
        },
        "stored_standard_number_024_a_ind1_3": {
            "key": "stored_standard_number_024_a_ind1_3",
            "value": "International Article Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "stored_standard_number_024_a_ind1_2": {
            "key": "stored_standard_number_024_a_ind1_2",
            "value": "International Standard Music Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "stored_standard_number_024_a_ind1_0": {
            "key": "stored_standard_number_024_a_ind1_0",
            "value": "International Standard Recording Code",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "isbn": {
            "key": "isbn",
            "value": "ISBN",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_is_handle_registered": {
            "key": "mms_is_handle_registered",
            "value": "Is Handle Registered",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "is_linked": {
            "key": "is_linked",
            "value": "Is linked",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }],
            "options": [{
                    "value": "No",
                    "key": "0",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "1",
                    "groupOrder": 0
                }]
        },
        "isni_identifier": {
            "key": "isni_identifier",
            "value": "ISNI - International Standard Name Identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "isni_real_world_object_uri": {
            "key": "isni_real_world_object_uri",
            "value": "ISNI - Real World Object URI",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "issn": {
            "key": "issn",
            "value": "ISSN",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "issn_link": {
            "key": "issn_link",
            "value": "ISSN link",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "all_for_ui": {
            "key": "all_for_ui",
            "value": "Keywords",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "language": {
            "key": "language",
            "value": "Language (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Abkhaz",
                    "key": "abk",
                    "groupOrder": 0
                }, {
                    "value": "Achinese",
                    "key": "ace",
                    "groupOrder": 0
                }, {
                    "value": "Acoli",
                    "key": "ach",
                    "groupOrder": 0
                }, {
                    "value": "Adangme",
                    "key": "ada",
                    "groupOrder": 0
                }, {
                    "value": "Adygei",
                    "key": "ady",
                    "groupOrder": 0
                }, {
                    "value": "Afar",
                    "key": "aar",
                    "groupOrder": 0
                }, {
                    "value": "Afrihili (Artificial language)",
                    "key": "afh",
                    "groupOrder": 0
                }, {
                    "value": "Afrikaans",
                    "key": "afr",
                    "groupOrder": 0
                }, {
                    "value": "Afroasiatic (Other)",
                    "key": "afa",
                    "groupOrder": 0
                }, {
                    "value": "Ainu",
                    "key": "ain",
                    "groupOrder": 0
                }, {
                    "value": "Akan",
                    "key": "aka",
                    "groupOrder": 0
                }, {
                    "value": "Akkadian",
                    "key": "akk",
                    "groupOrder": 0
                }, {
                    "value": "Albanian",
                    "key": "alb",
                    "groupOrder": 0
                }, {
                    "value": "Aleut",
                    "key": "ale",
                    "groupOrder": 0
                }, {
                    "value": "Algonquian (Other)",
                    "key": "alg",
                    "groupOrder": 0
                }, {
                    "value": "Aljamía (Old Code)",
                    "key": "ajm",
                    "groupOrder": 0
                }, {
                    "value": "Altai",
                    "key": "alt",
                    "groupOrder": 0
                }, {
                    "value": "Altaic (Other)",
                    "key": "tut",
                    "groupOrder": 0
                }, {
                    "value": "Amharic",
                    "key": "amh",
                    "groupOrder": 0
                }, {
                    "value": "Angika",
                    "key": "anp",
                    "groupOrder": 0
                }, {
                    "value": "Apache languages",
                    "key": "apa",
                    "groupOrder": 0
                }, {
                    "value": "Arabic",
                    "key": "ara",
                    "groupOrder": 0
                }, {
                    "value": "Aragonese",
                    "key": "arg",
                    "groupOrder": 0
                }, {
                    "value": "Aramaic",
                    "key": "arc",
                    "groupOrder": 0
                }, {
                    "value": "Arapaho",
                    "key": "arp",
                    "groupOrder": 0
                }, {
                    "value": "Arawak",
                    "key": "arw",
                    "groupOrder": 0
                }, {
                    "value": "Armenian",
                    "key": "arm",
                    "groupOrder": 0
                }, {
                    "value": "Aromanian",
                    "key": "rup",
                    "groupOrder": 0
                }, {
                    "value": "Artificial (Other)",
                    "key": "art",
                    "groupOrder": 0
                }, {
                    "value": "Assamese",
                    "key": "asm",
                    "groupOrder": 0
                }, {
                    "value": "Athapascan (Other)",
                    "key": "ath",
                    "groupOrder": 0
                }, {
                    "value": "Australian languages",
                    "key": "aus",
                    "groupOrder": 0
                }, {
                    "value": "Austronesian (Other)",
                    "key": "map",
                    "groupOrder": 0
                }, {
                    "value": "Avaric",
                    "key": "ava",
                    "groupOrder": 0
                }, {
                    "value": "Avestan",
                    "key": "ave",
                    "groupOrder": 0
                }, {
                    "value": "Awadhi",
                    "key": "awa",
                    "groupOrder": 0
                }, {
                    "value": "Aymara",
                    "key": "aym",
                    "groupOrder": 0
                }, {
                    "value": "Azerbaijani",
                    "key": "aze",
                    "groupOrder": 0
                }, {
                    "value": "Bable",
                    "key": "ast",
                    "groupOrder": 0
                }, {
                    "value": "Balinese",
                    "key": "ban",
                    "groupOrder": 0
                }, {
                    "value": "Baltic (Other)",
                    "key": "bat",
                    "groupOrder": 0
                }, {
                    "value": "Baluchi",
                    "key": "bal",
                    "groupOrder": 0
                }, {
                    "value": "Bambara",
                    "key": "bam",
                    "groupOrder": 0
                }, {
                    "value": "Bamileke languages",
                    "key": "bai",
                    "groupOrder": 0
                }, {
                    "value": "Banda languages",
                    "key": "bad",
                    "groupOrder": 0
                }, {
                    "value": "Bantu (Other)",
                    "key": "bnt",
                    "groupOrder": 0
                }, {
                    "value": "Basa",
                    "key": "bas",
                    "groupOrder": 0
                }, {
                    "value": "Bashkir",
                    "key": "bak",
                    "groupOrder": 0
                }, {
                    "value": "Basque",
                    "key": "baq",
                    "groupOrder": 0
                }, {
                    "value": "Batak",
                    "key": "btk",
                    "groupOrder": 0
                }, {
                    "value": "Beja",
                    "key": "bej",
                    "groupOrder": 0
                }, {
                    "value": "Belarusian",
                    "key": "bel",
                    "groupOrder": 0
                }, {
                    "value": "Bemba",
                    "key": "bem",
                    "groupOrder": 0
                }, {
                    "value": "Bengali",
                    "key": "ben",
                    "groupOrder": 0
                }, {
                    "value": "Berber (Other)",
                    "key": "ber",
                    "groupOrder": 0
                }, {
                    "value": "Bhojpuri",
                    "key": "bho",
                    "groupOrder": 0
                }, {
                    "value": "Bihari",
                    "key": "bih",
                    "groupOrder": 0
                }, {
                    "value": "Bikol",
                    "key": "bik",
                    "groupOrder": 0
                }, {
                    "value": "Bilin",
                    "key": "byn",
                    "groupOrder": 0
                }, {
                    "value": "Bislama",
                    "key": "bis",
                    "groupOrder": 0
                }, {
                    "value": "Blissymbolics",
                    "key": "zbl",
                    "groupOrder": 0
                }, {
                    "value": "Bosnian",
                    "key": "bos",
                    "groupOrder": 0
                }, {
                    "value": "Braj",
                    "key": "bra",
                    "groupOrder": 0
                }, {
                    "value": "Breton",
                    "key": "bre",
                    "groupOrder": 0
                }, {
                    "value": "Bugis",
                    "key": "bug",
                    "groupOrder": 0
                }, {
                    "value": "Bulgarian",
                    "key": "bul",
                    "groupOrder": 0
                }, {
                    "value": "Buriat",
                    "key": "bua",
                    "groupOrder": 0
                }, {
                    "value": "Burmese",
                    "key": "bur",
                    "groupOrder": 0
                }, {
                    "value": "Caddo",
                    "key": "cad",
                    "groupOrder": 0
                }, {
                    "value": "Carib",
                    "key": "car",
                    "groupOrder": 0
                }, {
                    "value": "Catalan",
                    "key": "cat",
                    "groupOrder": 0
                }, {
                    "value": "Caucasian (Other)",
                    "key": "cau",
                    "groupOrder": 0
                }, {
                    "value": "Cebuano",
                    "key": "ceb",
                    "groupOrder": 0
                }, {
                    "value": "Celtic (Other)",
                    "key": "cel",
                    "groupOrder": 0
                }, {
                    "value": "Central American Indian (Other)",
                    "key": "cai",
                    "groupOrder": 0
                }, {
                    "value": "Chagatai",
                    "key": "chg",
                    "groupOrder": 0
                }, {
                    "value": "Chamic languages",
                    "key": "cmc",
                    "groupOrder": 0
                }, {
                    "value": "Chamorro",
                    "key": "cha",
                    "groupOrder": 0
                }, {
                    "value": "Chechen",
                    "key": "che",
                    "groupOrder": 0
                }, {
                    "value": "Cherokee",
                    "key": "chr",
                    "groupOrder": 0
                }, {
                    "value": "Cheyenne",
                    "key": "chy",
                    "groupOrder": 0
                }, {
                    "value": "Chibcha",
                    "key": "chb",
                    "groupOrder": 0
                }, {
                    "value": "Chinese",
                    "key": "chi",
                    "groupOrder": 0
                }, {
                    "value": "Chinook jargon",
                    "key": "chn",
                    "groupOrder": 0
                }, {
                    "value": "Chipewyan",
                    "key": "chp",
                    "groupOrder": 0
                }, {
                    "value": "Choctaw",
                    "key": "cho",
                    "groupOrder": 0
                }, {
                    "value": "Church Slavic",
                    "key": "chu",
                    "groupOrder": 0
                }, {
                    "value": "Chuukese",
                    "key": "chk",
                    "groupOrder": 0
                }, {
                    "value": "Chuvash",
                    "key": "chv",
                    "groupOrder": 0
                }, {
                    "value": "Coptic",
                    "key": "cop",
                    "groupOrder": 0
                }, {
                    "value": "Cornish",
                    "key": "cor",
                    "groupOrder": 0
                }, {
                    "value": "Corsican",
                    "key": "cos",
                    "groupOrder": 0
                }, {
                    "value": "Cree",
                    "key": "cre",
                    "groupOrder": 0
                }, {
                    "value": "Creek",
                    "key": "mus",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins (Other)",
                    "key": "crp",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, English-based (Other)",
                    "key": "cpe",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, French-based (Other)",
                    "key": "cpf",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, Portuguese-based (Other)",
                    "key": "cpp",
                    "groupOrder": 0
                }, {
                    "value": "Crimean Tatar",
                    "key": "crh",
                    "groupOrder": 0
                }, {
                    "value": "Croatian",
                    "key": "hrv",
                    "groupOrder": 0
                }, {
                    "value": "Croatian (Old Code)",
                    "key": "scr",
                    "groupOrder": 0
                }, {
                    "value": "Cushitic (Other)",
                    "key": "cus",
                    "groupOrder": 0
                }, {
                    "value": "Czech",
                    "key": "cze",
                    "groupOrder": 0
                }, {
                    "value": "Dakota",
                    "key": "dak",
                    "groupOrder": 0
                }, {
                    "value": "Danish",
                    "key": "dan",
                    "groupOrder": 0
                }, {
                    "value": "Dargwa",
                    "key": "dar",
                    "groupOrder": 0
                }, {
                    "value": "Dayak",
                    "key": "day",
                    "groupOrder": 0
                }, {
                    "value": "Delaware",
                    "key": "del",
                    "groupOrder": 0
                }, {
                    "value": "Dinka",
                    "key": "din",
                    "groupOrder": 0
                }, {
                    "value": "Divehi",
                    "key": "div",
                    "groupOrder": 0
                }, {
                    "value": "Dogri",
                    "key": "doi",
                    "groupOrder": 0
                }, {
                    "value": "Dogrib",
                    "key": "dgr",
                    "groupOrder": 0
                }, {
                    "value": "Dravidian (Other)",
                    "key": "dra",
                    "groupOrder": 0
                }, {
                    "value": "Duala",
                    "key": "dua",
                    "groupOrder": 0
                }, {
                    "value": "Dutch",
                    "key": "dut",
                    "groupOrder": 0
                }, {
                    "value": "Dutch, Middle (ca. 1050-1350)",
                    "key": "dum",
                    "groupOrder": 0
                }, {
                    "value": "Dyula",
                    "key": "dyu",
                    "groupOrder": 0
                }, {
                    "value": "Dzongkha",
                    "key": "dzo",
                    "groupOrder": 0
                }, {
                    "value": "East Frisian",
                    "key": "frs",
                    "groupOrder": 0
                }, {
                    "value": "Edo",
                    "key": "bin",
                    "groupOrder": 0
                }, {
                    "value": "Efik",
                    "key": "efi",
                    "groupOrder": 0
                }, {
                    "value": "Egyptian",
                    "key": "egy",
                    "groupOrder": 0
                }, {
                    "value": "Ekajuk",
                    "key": "eka",
                    "groupOrder": 0
                }, {
                    "value": "Elamite",
                    "key": "elx",
                    "groupOrder": 0
                }, {
                    "value": "English",
                    "key": "eng",
                    "groupOrder": 0
                }, {
                    "value": "English, Middle (1100-1500)",
                    "key": "enm",
                    "groupOrder": 0
                }, {
                    "value": "English, Old (ca. 450-1100)",
                    "key": "ang",
                    "groupOrder": 0
                }, {
                    "value": "Erzya",
                    "key": "myv",
                    "groupOrder": 0
                }, {
                    "value": "Eskimo languages (Old Code)",
                    "key": "esk",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto",
                    "key": "epo",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto (Old Code)",
                    "key": "esp",
                    "groupOrder": 0
                }, {
                    "value": "Estonian",
                    "key": "est",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic",
                    "key": "gez",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic (Old Code)",
                    "key": "eth",
                    "groupOrder": 0
                }, {
                    "value": "Ewe",
                    "key": "ewe",
                    "groupOrder": 0
                }, {
                    "value": "Ewondo",
                    "key": "ewo",
                    "groupOrder": 0
                }, {
                    "value": "Fang",
                    "key": "fan",
                    "groupOrder": 0
                }, {
                    "value": "Fanti",
                    "key": "fat",
                    "groupOrder": 0
                }, {
                    "value": "Faroese",
                    "key": "fao",
                    "groupOrder": 0
                }, {
                    "value": "Faroese (Old Code)",
                    "key": "far",
                    "groupOrder": 0
                }, {
                    "value": "Fijian",
                    "key": "fij",
                    "groupOrder": 0
                }, {
                    "value": "Filipino",
                    "key": "fil",
                    "groupOrder": 0
                }, {
                    "value": "Finnish",
                    "key": "fin",
                    "groupOrder": 0
                }, {
                    "value": "Finno-Ugrian (Other)",
                    "key": "fiu",
                    "groupOrder": 0
                }, {
                    "value": "Fon",
                    "key": "fon",
                    "groupOrder": 0
                }, {
                    "value": "French",
                    "key": "fre",
                    "groupOrder": 0
                }, {
                    "value": "French, Middle (ca. 1300-1600)",
                    "key": "frm",
                    "groupOrder": 0
                }, {
                    "value": "French, Old (ca. 842-1300)",
                    "key": "fro",
                    "groupOrder": 0
                }, {
                    "value": "Frisian",
                    "key": "fry",
                    "groupOrder": 0
                }, {
                    "value": "Frisian (Old Code)",
                    "key": "fri",
                    "groupOrder": 0
                }, {
                    "value": "Friulian",
                    "key": "fur",
                    "groupOrder": 0
                }, {
                    "value": "Fula",
                    "key": "ful",
                    "groupOrder": 0
                }, {
                    "value": "Galician",
                    "key": "glg",
                    "groupOrder": 0
                }, {
                    "value": "Galician (Old Code)",
                    "key": "gag",
                    "groupOrder": 0
                }, {
                    "value": "Ganda",
                    "key": "lug",
                    "groupOrder": 0
                }, {
                    "value": "Gayo",
                    "key": "gay",
                    "groupOrder": 0
                }, {
                    "value": "Gbaya",
                    "key": "gba",
                    "groupOrder": 0
                }, {
                    "value": "Georgian",
                    "key": "geo",
                    "groupOrder": 0
                }, {
                    "value": "German",
                    "key": "ger",
                    "groupOrder": 0
                }, {
                    "value": "German, Middle High (ca. 1050-1500)",
                    "key": "gmh",
                    "groupOrder": 0
                }, {
                    "value": "German, Old High (ca. 750-1050)",
                    "key": "goh",
                    "groupOrder": 0
                }, {
                    "value": "Germanic (Other)",
                    "key": "gem",
                    "groupOrder": 0
                }, {
                    "value": "Gilbertese",
                    "key": "gil",
                    "groupOrder": 0
                }, {
                    "value": "Gondi",
                    "key": "gon",
                    "groupOrder": 0
                }, {
                    "value": "Gorontalo",
                    "key": "gor",
                    "groupOrder": 0
                }, {
                    "value": "Gothic",
                    "key": "got",
                    "groupOrder": 0
                }, {
                    "value": "Grebo",
                    "key": "grb",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Ancient (to 1453)",
                    "key": "grc",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Modern (1453- )",
                    "key": "gre",
                    "groupOrder": 0
                }, {
                    "value": "Guarani",
                    "key": "grn",
                    "groupOrder": 0
                }, {
                    "value": "Guarani (Old Code)",
                    "key": "gua",
                    "groupOrder": 0
                }, {
                    "value": "Gujarati",
                    "key": "guj",
                    "groupOrder": 0
                }, {
                    "value": "Gwich'in",
                    "key": "gwi",
                    "groupOrder": 0
                }, {
                    "value": "Gã",
                    "key": "gaa",
                    "groupOrder": 0
                }, {
                    "value": "Haida",
                    "key": "hai",
                    "groupOrder": 0
                }, {
                    "value": "Haitian French Creole",
                    "key": "hat",
                    "groupOrder": 0
                }, {
                    "value": "Hausa",
                    "key": "hau",
                    "groupOrder": 0
                }, {
                    "value": "Hawaiian",
                    "key": "haw",
                    "groupOrder": 0
                }, {
                    "value": "Hebrew",
                    "key": "heb",
                    "groupOrder": 0
                }, {
                    "value": "Herero",
                    "key": "her",
                    "groupOrder": 0
                }, {
                    "value": "Hiligaynon",
                    "key": "hil",
                    "groupOrder": 0
                }, {
                    "value": "Hindi",
                    "key": "hin",
                    "groupOrder": 0
                }, {
                    "value": "Hiri Motu",
                    "key": "hmo",
                    "groupOrder": 0
                }, {
                    "value": "Hittite",
                    "key": "hit",
                    "groupOrder": 0
                }, {
                    "value": "Hmong",
                    "key": "hmn",
                    "groupOrder": 0
                }, {
                    "value": "Hungarian",
                    "key": "hun",
                    "groupOrder": 0
                }, {
                    "value": "Hupa",
                    "key": "hup",
                    "groupOrder": 0
                }, {
                    "value": "Iban",
                    "key": "iba",
                    "groupOrder": 0
                }, {
                    "value": "Icelandic",
                    "key": "ice",
                    "groupOrder": 0
                }, {
                    "value": "Ido",
                    "key": "ido",
                    "groupOrder": 0
                }, {
                    "value": "Igbo",
                    "key": "ibo",
                    "groupOrder": 0
                }, {
                    "value": "Ijo",
                    "key": "ijo",
                    "groupOrder": 0
                }, {
                    "value": "Iloko",
                    "key": "ilo",
                    "groupOrder": 0
                }, {
                    "value": "Inari Sami",
                    "key": "smn",
                    "groupOrder": 0
                }, {
                    "value": "Indic (Other)",
                    "key": "inc",
                    "groupOrder": 0
                }, {
                    "value": "Indo-European (Other)",
                    "key": "ine",
                    "groupOrder": 0
                }, {
                    "value": "Indonesian",
                    "key": "ind",
                    "groupOrder": 0
                }, {
                    "value": "Ingush",
                    "key": "inh",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association)",
                    "key": "ina",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association) (Old Code)",
                    "key": "int",
                    "groupOrder": 0
                }, {
                    "value": "Interlingue",
                    "key": "ile",
                    "groupOrder": 0
                }, {
                    "value": "Inuktitut",
                    "key": "iku",
                    "groupOrder": 0
                }, {
                    "value": "Inupiaq",
                    "key": "ipk",
                    "groupOrder": 0
                }, {
                    "value": "Iranian (Other)",
                    "key": "ira",
                    "groupOrder": 0
                }, {
                    "value": "Irish",
                    "key": "gle",
                    "groupOrder": 0
                }, {
                    "value": "Irish (Old Code)",
                    "key": "iri",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Middle (ca. 1100-1550)",
                    "key": "mga",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Old (to 1100)",
                    "key": "sga",
                    "groupOrder": 0
                }, {
                    "value": "Iroquoian (Other)",
                    "key": "iro",
                    "groupOrder": 0
                }, {
                    "value": "Italian",
                    "key": "ita",
                    "groupOrder": 0
                }, {
                    "value": "Japanese",
                    "key": "jpn",
                    "groupOrder": 0
                }, {
                    "value": "Javanese",
                    "key": "jav",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Arabic",
                    "key": "jrb",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Persian",
                    "key": "jpr",
                    "groupOrder": 0
                }, {
                    "value": "Kabardian",
                    "key": "kbd",
                    "groupOrder": 0
                }, {
                    "value": "Kabyle",
                    "key": "kab",
                    "groupOrder": 0
                }, {
                    "value": "Kachin",
                    "key": "kac",
                    "groupOrder": 0
                }, {
                    "value": "Kalâtdlisut",
                    "key": "kal",
                    "groupOrder": 0
                }, {
                    "value": "Kamba",
                    "key": "kam",
                    "groupOrder": 0
                }, {
                    "value": "Kannada",
                    "key": "kan",
                    "groupOrder": 0
                }, {
                    "value": "Kanuri",
                    "key": "kau",
                    "groupOrder": 0
                }, {
                    "value": "Kara-Kalpak",
                    "key": "kaa",
                    "groupOrder": 0
                }, {
                    "value": "Karachay-Balkar",
                    "key": "krc",
                    "groupOrder": 0
                }, {
                    "value": "Karelian",
                    "key": "krl",
                    "groupOrder": 0
                }, {
                    "value": "Karen languages",
                    "key": "kar",
                    "groupOrder": 0
                }, {
                    "value": "Kashmiri",
                    "key": "kas",
                    "groupOrder": 0
                }, {
                    "value": "Kashubian",
                    "key": "csb",
                    "groupOrder": 0
                }, {
                    "value": "Kawi",
                    "key": "kaw",
                    "groupOrder": 0
                }, {
                    "value": "Kazakh",
                    "key": "kaz",
                    "groupOrder": 0
                }, {
                    "value": "Khasi",
                    "key": "kha",
                    "groupOrder": 0
                }, {
                    "value": "Khmer",
                    "key": "khm",
                    "groupOrder": 0
                }, {
                    "value": "Khmer (Old Code)",
                    "key": "cam",
                    "groupOrder": 0
                }, {
                    "value": "Khoisan (Other)",
                    "key": "khi",
                    "groupOrder": 0
                }, {
                    "value": "Khotanese",
                    "key": "kho",
                    "groupOrder": 0
                }, {
                    "value": "Kikuyu",
                    "key": "kik",
                    "groupOrder": 0
                }, {
                    "value": "Kimbundu",
                    "key": "kmb",
                    "groupOrder": 0
                }, {
                    "value": "Kinyarwanda",
                    "key": "kin",
                    "groupOrder": 0
                }, {
                    "value": "Klingon (Artificial language)",
                    "key": "tlh",
                    "groupOrder": 0
                }, {
                    "value": "Komi",
                    "key": "kom",
                    "groupOrder": 0
                }, {
                    "value": "Kongo",
                    "key": "kon",
                    "groupOrder": 0
                }, {
                    "value": "Konkani",
                    "key": "kok",
                    "groupOrder": 0
                }, {
                    "value": "Kootenai",
                    "key": "kut",
                    "groupOrder": 0
                }, {
                    "value": "Korean",
                    "key": "kor",
                    "groupOrder": 0
                }, {
                    "value": "Kpelle",
                    "key": "kpe",
                    "groupOrder": 0
                }, {
                    "value": "Kru (Other)",
                    "key": "kro",
                    "groupOrder": 0
                }, {
                    "value": "Kuanyama",
                    "key": "kua",
                    "groupOrder": 0
                }, {
                    "value": "Kumyk",
                    "key": "kum",
                    "groupOrder": 0
                }, {
                    "value": "Kurdish",
                    "key": "kur",
                    "groupOrder": 0
                }, {
                    "value": "Kurukh",
                    "key": "kru",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie",
                    "key": "kos",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie (Old Code)",
                    "key": "kus",
                    "groupOrder": 0
                }, {
                    "value": "Kyrgyz",
                    "key": "kir",
                    "groupOrder": 0
                }, {
                    "value": "Ladino",
                    "key": "lad",
                    "groupOrder": 0
                }, {
                    "value": "Lahnda",
                    "key": "lah",
                    "groupOrder": 0
                }, {
                    "value": "Lamba (Zambia and Congo)",
                    "key": "lam",
                    "groupOrder": 0
                }, {
                    "value": "Lao",
                    "key": "lao",
                    "groupOrder": 0
                }, {
                    "value": "Latin",
                    "key": "lat",
                    "groupOrder": 0
                }, {
                    "value": "Latvian",
                    "key": "lav",
                    "groupOrder": 0
                }, {
                    "value": "Lezgian",
                    "key": "lez",
                    "groupOrder": 0
                }, {
                    "value": "Limburgish",
                    "key": "lim",
                    "groupOrder": 0
                }, {
                    "value": "Lingala",
                    "key": "lin",
                    "groupOrder": 0
                }, {
                    "value": "Lithuanian",
                    "key": "lit",
                    "groupOrder": 0
                }, {
                    "value": "Lojban (Artificial language)",
                    "key": "jbo",
                    "groupOrder": 0
                }, {
                    "value": "Low German",
                    "key": "nds",
                    "groupOrder": 0
                }, {
                    "value": "Lower Sorbian",
                    "key": "dsb",
                    "groupOrder": 0
                }, {
                    "value": "Lozi",
                    "key": "loz",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Katanga",
                    "key": "lub",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Lulua",
                    "key": "lua",
                    "groupOrder": 0
                }, {
                    "value": "Luiseño",
                    "key": "lui",
                    "groupOrder": 0
                }, {
                    "value": "Lule Sami",
                    "key": "smj",
                    "groupOrder": 0
                }, {
                    "value": "Lunda",
                    "key": "lun",
                    "groupOrder": 0
                }, {
                    "value": "Luo (Kenya and Tanzania)",
                    "key": "luo",
                    "groupOrder": 0
                }, {
                    "value": "Lushai",
                    "key": "lus",
                    "groupOrder": 0
                }, {
                    "value": "Luxembourgish",
                    "key": "ltz",
                    "groupOrder": 0
                }, {
                    "value": "Macedonian",
                    "key": "mac",
                    "groupOrder": 0
                }, {
                    "value": "Madurese",
                    "key": "mad",
                    "groupOrder": 0
                }, {
                    "value": "Magahi",
                    "key": "mag",
                    "groupOrder": 0
                }, {
                    "value": "Maithili",
                    "key": "mai",
                    "groupOrder": 0
                }, {
                    "value": "Makasar",
                    "key": "mak",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy",
                    "key": "mlg",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy (Old Code)",
                    "key": "mla",
                    "groupOrder": 0
                }, {
                    "value": "Malay",
                    "key": "may",
                    "groupOrder": 0
                }, {
                    "value": "Malayalam",
                    "key": "mal",
                    "groupOrder": 0
                }, {
                    "value": "Maltese",
                    "key": "mlt",
                    "groupOrder": 0
                }, {
                    "value": "Manchu",
                    "key": "mnc",
                    "groupOrder": 0
                }, {
                    "value": "Mandar",
                    "key": "mdr",
                    "groupOrder": 0
                }, {
                    "value": "Mandingo",
                    "key": "man",
                    "groupOrder": 0
                }, {
                    "value": "Manipuri",
                    "key": "mni",
                    "groupOrder": 0
                }, {
                    "value": "Manobo languages",
                    "key": "mno",
                    "groupOrder": 0
                }, {
                    "value": "Manx",
                    "key": "glv",
                    "groupOrder": 0
                }, {
                    "value": "Manx (Old Code)",
                    "key": "max",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mao",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mri",
                    "groupOrder": 0
                }, {
                    "value": "Mapuche",
                    "key": "arn",
                    "groupOrder": 0
                }, {
                    "value": "Marathi",
                    "key": "mar",
                    "groupOrder": 0
                }, {
                    "value": "Mari",
                    "key": "chm",
                    "groupOrder": 0
                }, {
                    "value": "Marshallese",
                    "key": "mah",
                    "groupOrder": 0
                }, {
                    "value": "Marwari",
                    "key": "mwr",
                    "groupOrder": 0
                }, {
                    "value": "Masai",
                    "key": "mas",
                    "groupOrder": 0
                }, {
                    "value": "Mayan languages",
                    "key": "myn",
                    "groupOrder": 0
                }, {
                    "value": "Mende",
                    "key": "men",
                    "groupOrder": 0
                }, {
                    "value": "Micmac",
                    "key": "mic",
                    "groupOrder": 0
                }, {
                    "value": "Minangkabau",
                    "key": "min",
                    "groupOrder": 0
                }, {
                    "value": "Mirandese",
                    "key": "mwl",
                    "groupOrder": 0
                }, {
                    "value": "Miscellaneous languages",
                    "key": "mis",
                    "groupOrder": 0
                }, {
                    "value": "Mohawk",
                    "key": "moh",
                    "groupOrder": 0
                }, {
                    "value": "Moksha",
                    "key": "mdf",
                    "groupOrder": 0
                }, {
                    "value": "Moldavian (Old Code)",
                    "key": "mol",
                    "groupOrder": 0
                }, {
                    "value": "Mon-Khmer (Other)",
                    "key": "mkh",
                    "groupOrder": 0
                }, {
                    "value": "Mongo-Nkundu",
                    "key": "lol",
                    "groupOrder": 0
                }, {
                    "value": "Mongolian",
                    "key": "mon",
                    "groupOrder": 0
                }, {
                    "value": "Montenegrin",
                    "key": "cnr",
                    "groupOrder": 0
                }, {
                    "value": "Mooré",
                    "key": "mos",
                    "groupOrder": 0
                }, {
                    "value": "Multiple languages",
                    "key": "mul",
                    "groupOrder": 0
                }, {
                    "value": "Munda (Other)",
                    "key": "mun",
                    "groupOrder": 0
                }, {
                    "value": "N'Ko",
                    "key": "nqo",
                    "groupOrder": 0
                }, {
                    "value": "Nahuatl",
                    "key": "nah",
                    "groupOrder": 0
                }, {
                    "value": "Nauru",
                    "key": "nau",
                    "groupOrder": 0
                }, {
                    "value": "Navajo",
                    "key": "nav",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (South Africa)",
                    "key": "nbl",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (Zimbabwe)",
                    "key": "nde",
                    "groupOrder": 0
                }, {
                    "value": "Ndonga",
                    "key": "ndo",
                    "groupOrder": 0
                }, {
                    "value": "Neapolitan Italian",
                    "key": "nap",
                    "groupOrder": 0
                }, {
                    "value": "Nepali",
                    "key": "nep",
                    "groupOrder": 0
                }, {
                    "value": "Newari",
                    "key": "new",
                    "groupOrder": 0
                }, {
                    "value": "Newari, Old",
                    "key": "nwc",
                    "groupOrder": 0
                }, {
                    "value": "Nias",
                    "key": "nia",
                    "groupOrder": 0
                }, {
                    "value": "Niger-Kordofanian (Other)",
                    "key": "nic",
                    "groupOrder": 0
                }, {
                    "value": "Nilo-Saharan (Other)",
                    "key": "ssa",
                    "groupOrder": 0
                }, {
                    "value": "Niuean",
                    "key": "niu",
                    "groupOrder": 0
                }, {
                    "value": "No information provided",
                    "key": "   ",
                    "groupOrder": 0
                }, {
                    "value": "No linguistic content",
                    "key": "zxx",
                    "groupOrder": 0
                }, {
                    "value": "Nogai",
                    "key": "nog",
                    "groupOrder": 0
                }, {
                    "value": "None of the above",
                    "key": "|||",
                    "groupOrder": 0
                }, {
                    "value": "North American Indian (Other)",
                    "key": "nai",
                    "groupOrder": 0
                }, {
                    "value": "North Frisian",
                    "key": "frr",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sami",
                    "key": "sme",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sotho",
                    "key": "nso",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian",
                    "key": "nor",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Bokmål)",
                    "key": "nob",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Nynorsk)",
                    "key": "nno",
                    "groupOrder": 0
                }, {
                    "value": "Nubian languages",
                    "key": "nub",
                    "groupOrder": 0
                }, {
                    "value": "Nyamwezi",
                    "key": "nym",
                    "groupOrder": 0
                }, {
                    "value": "Nyanja",
                    "key": "nya",
                    "groupOrder": 0
                }, {
                    "value": "Nyankole",
                    "key": "nyn",
                    "groupOrder": 0
                }, {
                    "value": "Nyoro",
                    "key": "nyo",
                    "groupOrder": 0
                }, {
                    "value": "Nzima",
                    "key": "nzi",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500)",
                    "key": "oci",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500) (Old Code)",
                    "key": "lan",
                    "groupOrder": 0
                }, {
                    "value": "Oirat",
                    "key": "xal",
                    "groupOrder": 0
                }, {
                    "value": "Ojibwa",
                    "key": "oji",
                    "groupOrder": 0
                }, {
                    "value": "Old Norse",
                    "key": "non",
                    "groupOrder": 0
                }, {
                    "value": "Old Persian (ca. 600-400 B.C.)",
                    "key": "peo",
                    "groupOrder": 0
                }, {
                    "value": "Oriya",
                    "key": "ori",
                    "groupOrder": 0
                }, {
                    "value": "Oromo",
                    "key": "orm",
                    "groupOrder": 0
                }, {
                    "value": "Oromo (Old Code)",
                    "key": "gal",
                    "groupOrder": 0
                }, {
                    "value": "Osage",
                    "key": "osa",
                    "groupOrder": 0
                }, {
                    "value": "Ossetic",
                    "key": "oss",
                    "groupOrder": 0
                }, {
                    "value": "Otomian languages",
                    "key": "oto",
                    "groupOrder": 0
                }, {
                    "value": "Pahlavi",
                    "key": "pal",
                    "groupOrder": 0
                }, {
                    "value": "Palauan",
                    "key": "pau",
                    "groupOrder": 0
                }, {
                    "value": "Pali",
                    "key": "pli",
                    "groupOrder": 0
                }, {
                    "value": "Pampanga",
                    "key": "pam",
                    "groupOrder": 0
                }, {
                    "value": "Pangasinan",
                    "key": "pag",
                    "groupOrder": 0
                }, {
                    "value": "Panjabi",
                    "key": "pan",
                    "groupOrder": 0
                }, {
                    "value": "Papiamento",
                    "key": "pap",
                    "groupOrder": 0
                }, {
                    "value": "Papuan (Other)",
                    "key": "paa",
                    "groupOrder": 0
                }, {
                    "value": "Persian",
                    "key": "per",
                    "groupOrder": 0
                }, {
                    "value": "Philippine (Other)",
                    "key": "phi",
                    "groupOrder": 0
                }, {
                    "value": "Phoenician",
                    "key": "phn",
                    "groupOrder": 0
                }, {
                    "value": "Polish",
                    "key": "pol",
                    "groupOrder": 0
                }, {
                    "value": "Ponape",
                    "key": "pon",
                    "groupOrder": 0
                }, {
                    "value": "Portuguese",
                    "key": "por",
                    "groupOrder": 0
                }, {
                    "value": "Prakrit languages",
                    "key": "pra",
                    "groupOrder": 0
                }, {
                    "value": "Provençal (to 1500)",
                    "key": "pro",
                    "groupOrder": 0
                }, {
                    "value": "Pushto",
                    "key": "pus",
                    "groupOrder": 0
                }, {
                    "value": "Quechua",
                    "key": "que",
                    "groupOrder": 0
                }, {
                    "value": "Raeto-Romance",
                    "key": "roh",
                    "groupOrder": 0
                }, {
                    "value": "Rajasthani",
                    "key": "raj",
                    "groupOrder": 0
                }, {
                    "value": "Rapanui",
                    "key": "rap",
                    "groupOrder": 0
                }, {
                    "value": "Rarotongan",
                    "key": "rar",
                    "groupOrder": 0
                }, {
                    "value": "Romance (Other)",
                    "key": "roa",
                    "groupOrder": 0
                }, {
                    "value": "Romani",
                    "key": "rom",
                    "groupOrder": 0
                }, {
                    "value": "Romanian",
                    "key": "rum",
                    "groupOrder": 0
                }, {
                    "value": "Rundi",
                    "key": "run",
                    "groupOrder": 0
                }, {
                    "value": "Russian",
                    "key": "rus",
                    "groupOrder": 0
                }, {
                    "value": "Salishan languages",
                    "key": "sal",
                    "groupOrder": 0
                }, {
                    "value": "Samaritan Aramaic",
                    "key": "sam",
                    "groupOrder": 0
                }, {
                    "value": "Sami",
                    "key": "smi",
                    "groupOrder": 0
                }, {
                    "value": "Sami (Old Code)",
                    "key": "lap",
                    "groupOrder": 0
                }, {
                    "value": "Samoan",
                    "key": "smo",
                    "groupOrder": 0
                }, {
                    "value": "Samoan (Old Code)",
                    "key": "sao",
                    "groupOrder": 0
                }, {
                    "value": "Sandawe",
                    "key": "sad",
                    "groupOrder": 0
                }, {
                    "value": "Sango (Ubangi Creole)",
                    "key": "sag",
                    "groupOrder": 0
                }, {
                    "value": "Sanskrit",
                    "key": "san",
                    "groupOrder": 0
                }, {
                    "value": "Santali",
                    "key": "sat",
                    "groupOrder": 0
                }, {
                    "value": "Sardinian",
                    "key": "srd",
                    "groupOrder": 0
                }, {
                    "value": "Sasak",
                    "key": "sas",
                    "groupOrder": 0
                }, {
                    "value": "Scots",
                    "key": "sco",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelic",
                    "key": "gla",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelix (Old Code)",
                    "key": "gae",
                    "groupOrder": 0
                }, {
                    "value": "Selkup",
                    "key": "sel",
                    "groupOrder": 0
                }, {
                    "value": "Semitic (Other)",
                    "key": "sem",
                    "groupOrder": 0
                }, {
                    "value": "Serbian",
                    "key": "srp",
                    "groupOrder": 0
                }, {
                    "value": "Serbian (Old Code)",
                    "key": "scc",
                    "groupOrder": 0
                }, {
                    "value": "Serer",
                    "key": "srr",
                    "groupOrder": 0
                }, {
                    "value": "Shan",
                    "key": "shn",
                    "groupOrder": 0
                }, {
                    "value": "Shona",
                    "key": "sna",
                    "groupOrder": 0
                }, {
                    "value": "Shona (Old Code)",
                    "key": "sho",
                    "groupOrder": 0
                }, {
                    "value": "Sichuan Yi",
                    "key": "iii",
                    "groupOrder": 0
                }, {
                    "value": "Sicilian Italian",
                    "key": "scn",
                    "groupOrder": 0
                }, {
                    "value": "Sidamo",
                    "key": "sid",
                    "groupOrder": 0
                }, {
                    "value": "Sign languages",
                    "key": "sgn",
                    "groupOrder": 0
                }, {
                    "value": "Siksika",
                    "key": "bla",
                    "groupOrder": 0
                }, {
                    "value": "Sindhi",
                    "key": "snd",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese",
                    "key": "sin",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese (Old Code)",
                    "key": "snh",
                    "groupOrder": 0
                }, {
                    "value": "Sino-Tibetan (Other)",
                    "key": "sit",
                    "groupOrder": 0
                }, {
                    "value": "Siouan (Other)",
                    "key": "sio",
                    "groupOrder": 0
                }, {
                    "value": "Skolt Sami",
                    "key": "sms",
                    "groupOrder": 0
                }, {
                    "value": "Slave",
                    "key": "den",
                    "groupOrder": 0
                }, {
                    "value": "Slavic (Other)",
                    "key": "sla",
                    "groupOrder": 0
                }, {
                    "value": "Slovak",
                    "key": "slo",
                    "groupOrder": 0
                }, {
                    "value": "Slovenian",
                    "key": "slv",
                    "groupOrder": 0
                }, {
                    "value": "Sogdian",
                    "key": "sog",
                    "groupOrder": 0
                }, {
                    "value": "Somali",
                    "key": "som",
                    "groupOrder": 0
                }, {
                    "value": "Songhai",
                    "key": "son",
                    "groupOrder": 0
                }, {
                    "value": "Soninke",
                    "key": "snk",
                    "groupOrder": 0
                }, {
                    "value": "Sorbian (Other)",
                    "key": "wen",
                    "groupOrder": 0
                }, {
                    "value": "Sotho",
                    "key": "sot",
                    "groupOrder": 0
                }, {
                    "value": "Sotho (Old Code)",
                    "key": "sso",
                    "groupOrder": 0
                }, {
                    "value": "South American Indian (Other)",
                    "key": "sai",
                    "groupOrder": 0
                }, {
                    "value": "Southern Sami",
                    "key": "sma",
                    "groupOrder": 0
                }, {
                    "value": "Spanish",
                    "key": "spa",
                    "groupOrder": 0
                }, {
                    "value": "Sranan",
                    "key": "srn",
                    "groupOrder": 0
                }, {
                    "value": "Sukuma",
                    "key": "suk",
                    "groupOrder": 0
                }, {
                    "value": "Sumerian",
                    "key": "sux",
                    "groupOrder": 0
                }, {
                    "value": "Sundanese",
                    "key": "sun",
                    "groupOrder": 0
                }, {
                    "value": "Susu",
                    "key": "sus",
                    "groupOrder": 0
                }, {
                    "value": "Swahili",
                    "key": "swa",
                    "groupOrder": 0
                }, {
                    "value": "Swazi",
                    "key": "ssw",
                    "groupOrder": 0
                }, {
                    "value": "Swazi (Old Code)",
                    "key": "swz",
                    "groupOrder": 0
                }, {
                    "value": "Swedish",
                    "key": "swe",
                    "groupOrder": 0
                }, {
                    "value": "Swiss German",
                    "key": "gsw",
                    "groupOrder": 0
                }, {
                    "value": "Syriac",
                    "key": "syc",
                    "groupOrder": 0
                }, {
                    "value": "Syriac, Modern",
                    "key": "syr",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog",
                    "key": "tgl",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog (Old Code)",
                    "key": "tag",
                    "groupOrder": 0
                }, {
                    "value": "Tahitian",
                    "key": "tah",
                    "groupOrder": 0
                }, {
                    "value": "Tai (Other)",
                    "key": "tai",
                    "groupOrder": 0
                }, {
                    "value": "Tajik",
                    "key": "tgk",
                    "groupOrder": 0
                }, {
                    "value": "Tajik (Old Code)",
                    "key": "taj",
                    "groupOrder": 0
                }, {
                    "value": "Tamashek",
                    "key": "tmh",
                    "groupOrder": 0
                }, {
                    "value": "Tamil",
                    "key": "tam",
                    "groupOrder": 0
                }, {
                    "value": "Tatar",
                    "key": "tat",
                    "groupOrder": 0
                }, {
                    "value": "Tatar (Old Code)",
                    "key": "tar",
                    "groupOrder": 0
                }, {
                    "value": "Telugu",
                    "key": "tel",
                    "groupOrder": 0
                }, {
                    "value": "Temne",
                    "key": "tem",
                    "groupOrder": 0
                }, {
                    "value": "Terena",
                    "key": "ter",
                    "groupOrder": 0
                }, {
                    "value": "Tetum",
                    "key": "tet",
                    "groupOrder": 0
                }, {
                    "value": "Thai",
                    "key": "tha",
                    "groupOrder": 0
                }, {
                    "value": "Tibetan",
                    "key": "tib",
                    "groupOrder": 0
                }, {
                    "value": "Tigrinya",
                    "key": "tir",
                    "groupOrder": 0
                }, {
                    "value": "Tigré",
                    "key": "tig",
                    "groupOrder": 0
                }, {
                    "value": "Tiv",
                    "key": "tiv",
                    "groupOrder": 0
                }, {
                    "value": "Tlingit",
                    "key": "tli",
                    "groupOrder": 0
                }, {
                    "value": "Tok Pisin",
                    "key": "tpi",
                    "groupOrder": 0
                }, {
                    "value": "Tokelauan",
                    "key": "tkl",
                    "groupOrder": 0
                }, {
                    "value": "Tonga (Nyasa)",
                    "key": "tog",
                    "groupOrder": 0
                }, {
                    "value": "Tongan",
                    "key": "ton",
                    "groupOrder": 0
                }, {
                    "value": "Truk (Old Code)",
                    "key": "tru",
                    "groupOrder": 0
                }, {
                    "value": "Tsimshian",
                    "key": "tsi",
                    "groupOrder": 0
                }, {
                    "value": "Tsonga",
                    "key": "tso",
                    "groupOrder": 0
                }, {
                    "value": "Tswana",
                    "key": "tsn",
                    "groupOrder": 0
                }, {
                    "value": "Tswana (Old Code)",
                    "key": "tsw",
                    "groupOrder": 0
                }, {
                    "value": "Tumbuka",
                    "key": "tum",
                    "groupOrder": 0
                }, {
                    "value": "Tupi languages",
                    "key": "tup",
                    "groupOrder": 0
                }, {
                    "value": "Turkish",
                    "key": "tur",
                    "groupOrder": 0
                }, {
                    "value": "Turkish, Ottoman",
                    "key": "ota",
                    "groupOrder": 0
                }, {
                    "value": "Turkmen",
                    "key": "tuk",
                    "groupOrder": 0
                }, {
                    "value": "Tuvaluan",
                    "key": "tvl",
                    "groupOrder": 0
                }, {
                    "value": "Tuvinian",
                    "key": "tyv",
                    "groupOrder": 0
                }, {
                    "value": "Twi",
                    "key": "twi",
                    "groupOrder": 0
                }, {
                    "value": "Udmurt",
                    "key": "udm",
                    "groupOrder": 0
                }, {
                    "value": "Ugaritic",
                    "key": "uga",
                    "groupOrder": 0
                }, {
                    "value": "Uighur",
                    "key": "uig",
                    "groupOrder": 0
                }, {
                    "value": "Ukrainian",
                    "key": "ukr",
                    "groupOrder": 0
                }, {
                    "value": "Umbundu",
                    "key": "umb",
                    "groupOrder": 0
                }, {
                    "value": "Undetermined",
                    "key": "und",
                    "groupOrder": 0
                }, {
                    "value": "Upper Sorbian",
                    "key": "hsb",
                    "groupOrder": 0
                }, {
                    "value": "Urdu",
                    "key": "urd",
                    "groupOrder": 0
                }, {
                    "value": "Uzbek",
                    "key": "uzb",
                    "groupOrder": 0
                }, {
                    "value": "Vai",
                    "key": "vai",
                    "groupOrder": 0
                }, {
                    "value": "Venda",
                    "key": "ven",
                    "groupOrder": 0
                }, {
                    "value": "Vietnamese",
                    "key": "vie",
                    "groupOrder": 0
                }, {
                    "value": "Volapük",
                    "key": "vol",
                    "groupOrder": 0
                }, {
                    "value": "Votic",
                    "key": "vot",
                    "groupOrder": 0
                }, {
                    "value": "Wakashan languages",
                    "key": "wak",
                    "groupOrder": 0
                }, {
                    "value": "Walloon",
                    "key": "wln",
                    "groupOrder": 0
                }, {
                    "value": "Waray",
                    "key": "war",
                    "groupOrder": 0
                }, {
                    "value": "Washo",
                    "key": "was",
                    "groupOrder": 0
                }, {
                    "value": "Welsh",
                    "key": "wel",
                    "groupOrder": 0
                }, {
                    "value": "Western Pahari languages",
                    "key": "him",
                    "groupOrder": 0
                }, {
                    "value": "Wolayta",
                    "key": "wal",
                    "groupOrder": 0
                }, {
                    "value": "Wolof",
                    "key": "wol",
                    "groupOrder": 0
                }, {
                    "value": "Xhosa",
                    "key": "xho",
                    "groupOrder": 0
                }, {
                    "value": "Yakut",
                    "key": "sah",
                    "groupOrder": 0
                }, {
                    "value": "Yao (Africa)",
                    "key": "yao",
                    "groupOrder": 0
                }, {
                    "value": "Yapese",
                    "key": "yap",
                    "groupOrder": 0
                }, {
                    "value": "Yiddish",
                    "key": "yid",
                    "groupOrder": 0
                }, {
                    "value": "Yoruba",
                    "key": "yor",
                    "groupOrder": 0
                }, {
                    "value": "Yupik languages",
                    "key": "ypk",
                    "groupOrder": 0
                }, {
                    "value": "Zande languages",
                    "key": "znd",
                    "groupOrder": 0
                }, {
                    "value": "Zapotec",
                    "key": "zap",
                    "groupOrder": 0
                }, {
                    "value": "Zaza",
                    "key": "zza",
                    "groupOrder": 0
                }, {
                    "value": "Zenaga",
                    "key": "zen",
                    "groupOrder": 0
                }, {
                    "value": "Zhuang",
                    "key": "zha",
                    "groupOrder": 0
                }, {
                    "value": "Zulu",
                    "key": "zul",
                    "groupOrder": 0
                }, {
                    "value": "Zuni",
                    "key": "zun",
                    "groupOrder": 0
                }]
        },
        "language_of_cataloging": {
            "key": "language_of_cataloging",
            "value": "Language Of Cataloging",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Abkhaz",
                    "key": "abk",
                    "groupOrder": 0
                }, {
                    "value": "Achinese",
                    "key": "ace",
                    "groupOrder": 0
                }, {
                    "value": "Acoli",
                    "key": "ach",
                    "groupOrder": 0
                }, {
                    "value": "Adangme",
                    "key": "ada",
                    "groupOrder": 0
                }, {
                    "value": "Adygei",
                    "key": "ady",
                    "groupOrder": 0
                }, {
                    "value": "Afar",
                    "key": "aar",
                    "groupOrder": 0
                }, {
                    "value": "Afrihili (Artificial language)",
                    "key": "afh",
                    "groupOrder": 0
                }, {
                    "value": "Afrikaans",
                    "key": "afr",
                    "groupOrder": 0
                }, {
                    "value": "Afroasiatic (Other)",
                    "key": "afa",
                    "groupOrder": 0
                }, {
                    "value": "Ainu",
                    "key": "ain",
                    "groupOrder": 0
                }, {
                    "value": "Akan",
                    "key": "aka",
                    "groupOrder": 0
                }, {
                    "value": "Akkadian",
                    "key": "akk",
                    "groupOrder": 0
                }, {
                    "value": "Albanian",
                    "key": "alb",
                    "groupOrder": 0
                }, {
                    "value": "Aleut",
                    "key": "ale",
                    "groupOrder": 0
                }, {
                    "value": "Algonquian (Other)",
                    "key": "alg",
                    "groupOrder": 0
                }, {
                    "value": "Aljamía (Old Code)",
                    "key": "ajm",
                    "groupOrder": 0
                }, {
                    "value": "Altai",
                    "key": "alt",
                    "groupOrder": 0
                }, {
                    "value": "Altaic (Other)",
                    "key": "tut",
                    "groupOrder": 0
                }, {
                    "value": "Amharic",
                    "key": "amh",
                    "groupOrder": 0
                }, {
                    "value": "Angika",
                    "key": "anp",
                    "groupOrder": 0
                }, {
                    "value": "Apache languages",
                    "key": "apa",
                    "groupOrder": 0
                }, {
                    "value": "Arabic",
                    "key": "ara",
                    "groupOrder": 0
                }, {
                    "value": "Aragonese",
                    "key": "arg",
                    "groupOrder": 0
                }, {
                    "value": "Aramaic",
                    "key": "arc",
                    "groupOrder": 0
                }, {
                    "value": "Arapaho",
                    "key": "arp",
                    "groupOrder": 0
                }, {
                    "value": "Arawak",
                    "key": "arw",
                    "groupOrder": 0
                }, {
                    "value": "Armenian",
                    "key": "arm",
                    "groupOrder": 0
                }, {
                    "value": "Aromanian",
                    "key": "rup",
                    "groupOrder": 0
                }, {
                    "value": "Artificial (Other)",
                    "key": "art",
                    "groupOrder": 0
                }, {
                    "value": "Assamese",
                    "key": "asm",
                    "groupOrder": 0
                }, {
                    "value": "Athapascan (Other)",
                    "key": "ath",
                    "groupOrder": 0
                }, {
                    "value": "Australian languages",
                    "key": "aus",
                    "groupOrder": 0
                }, {
                    "value": "Austronesian (Other)",
                    "key": "map",
                    "groupOrder": 0
                }, {
                    "value": "Avaric",
                    "key": "ava",
                    "groupOrder": 0
                }, {
                    "value": "Avestan",
                    "key": "ave",
                    "groupOrder": 0
                }, {
                    "value": "Awadhi",
                    "key": "awa",
                    "groupOrder": 0
                }, {
                    "value": "Aymara",
                    "key": "aym",
                    "groupOrder": 0
                }, {
                    "value": "Azerbaijani",
                    "key": "aze",
                    "groupOrder": 0
                }, {
                    "value": "Bable",
                    "key": "ast",
                    "groupOrder": 0
                }, {
                    "value": "Balinese",
                    "key": "ban",
                    "groupOrder": 0
                }, {
                    "value": "Baltic (Other)",
                    "key": "bat",
                    "groupOrder": 0
                }, {
                    "value": "Baluchi",
                    "key": "bal",
                    "groupOrder": 0
                }, {
                    "value": "Bambara",
                    "key": "bam",
                    "groupOrder": 0
                }, {
                    "value": "Bamileke languages",
                    "key": "bai",
                    "groupOrder": 0
                }, {
                    "value": "Banda languages",
                    "key": "bad",
                    "groupOrder": 0
                }, {
                    "value": "Bantu (Other)",
                    "key": "bnt",
                    "groupOrder": 0
                }, {
                    "value": "Basa",
                    "key": "bas",
                    "groupOrder": 0
                }, {
                    "value": "Bashkir",
                    "key": "bak",
                    "groupOrder": 0
                }, {
                    "value": "Basque",
                    "key": "baq",
                    "groupOrder": 0
                }, {
                    "value": "Batak",
                    "key": "btk",
                    "groupOrder": 0
                }, {
                    "value": "Beja",
                    "key": "bej",
                    "groupOrder": 0
                }, {
                    "value": "Belarusian",
                    "key": "bel",
                    "groupOrder": 0
                }, {
                    "value": "Bemba",
                    "key": "bem",
                    "groupOrder": 0
                }, {
                    "value": "Bengali",
                    "key": "ben",
                    "groupOrder": 0
                }, {
                    "value": "Berber (Other)",
                    "key": "ber",
                    "groupOrder": 0
                }, {
                    "value": "Bhojpuri",
                    "key": "bho",
                    "groupOrder": 0
                }, {
                    "value": "Bihari",
                    "key": "bih",
                    "groupOrder": 0
                }, {
                    "value": "Bikol",
                    "key": "bik",
                    "groupOrder": 0
                }, {
                    "value": "Bilin",
                    "key": "byn",
                    "groupOrder": 0
                }, {
                    "value": "Bislama",
                    "key": "bis",
                    "groupOrder": 0
                }, {
                    "value": "Blissymbolics",
                    "key": "zbl",
                    "groupOrder": 0
                }, {
                    "value": "Bosnian",
                    "key": "bos",
                    "groupOrder": 0
                }, {
                    "value": "Braj",
                    "key": "bra",
                    "groupOrder": 0
                }, {
                    "value": "Breton",
                    "key": "bre",
                    "groupOrder": 0
                }, {
                    "value": "Bugis",
                    "key": "bug",
                    "groupOrder": 0
                }, {
                    "value": "Bulgarian",
                    "key": "bul",
                    "groupOrder": 0
                }, {
                    "value": "Buriat",
                    "key": "bua",
                    "groupOrder": 0
                }, {
                    "value": "Burmese",
                    "key": "bur",
                    "groupOrder": 0
                }, {
                    "value": "Caddo",
                    "key": "cad",
                    "groupOrder": 0
                }, {
                    "value": "Carib",
                    "key": "car",
                    "groupOrder": 0
                }, {
                    "value": "Catalan",
                    "key": "cat",
                    "groupOrder": 0
                }, {
                    "value": "Caucasian (Other)",
                    "key": "cau",
                    "groupOrder": 0
                }, {
                    "value": "Cebuano",
                    "key": "ceb",
                    "groupOrder": 0
                }, {
                    "value": "Celtic (Other)",
                    "key": "cel",
                    "groupOrder": 0
                }, {
                    "value": "Central American Indian (Other)",
                    "key": "cai",
                    "groupOrder": 0
                }, {
                    "value": "Chagatai",
                    "key": "chg",
                    "groupOrder": 0
                }, {
                    "value": "Chamic languages",
                    "key": "cmc",
                    "groupOrder": 0
                }, {
                    "value": "Chamorro",
                    "key": "cha",
                    "groupOrder": 0
                }, {
                    "value": "Chechen",
                    "key": "che",
                    "groupOrder": 0
                }, {
                    "value": "Cherokee",
                    "key": "chr",
                    "groupOrder": 0
                }, {
                    "value": "Cheyenne",
                    "key": "chy",
                    "groupOrder": 0
                }, {
                    "value": "Chibcha",
                    "key": "chb",
                    "groupOrder": 0
                }, {
                    "value": "Chinese",
                    "key": "chi",
                    "groupOrder": 0
                }, {
                    "value": "Chinook jargon",
                    "key": "chn",
                    "groupOrder": 0
                }, {
                    "value": "Chipewyan",
                    "key": "chp",
                    "groupOrder": 0
                }, {
                    "value": "Choctaw",
                    "key": "cho",
                    "groupOrder": 0
                }, {
                    "value": "Church Slavic",
                    "key": "chu",
                    "groupOrder": 0
                }, {
                    "value": "Chuukese",
                    "key": "chk",
                    "groupOrder": 0
                }, {
                    "value": "Chuvash",
                    "key": "chv",
                    "groupOrder": 0
                }, {
                    "value": "Coptic",
                    "key": "cop",
                    "groupOrder": 0
                }, {
                    "value": "Cornish",
                    "key": "cor",
                    "groupOrder": 0
                }, {
                    "value": "Corsican",
                    "key": "cos",
                    "groupOrder": 0
                }, {
                    "value": "Cree",
                    "key": "cre",
                    "groupOrder": 0
                }, {
                    "value": "Creek",
                    "key": "mus",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins (Other)",
                    "key": "crp",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, English-based (Other)",
                    "key": "cpe",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, French-based (Other)",
                    "key": "cpf",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, Portuguese-based (Other)",
                    "key": "cpp",
                    "groupOrder": 0
                }, {
                    "value": "Crimean Tatar",
                    "key": "crh",
                    "groupOrder": 0
                }, {
                    "value": "Croatian",
                    "key": "hrv",
                    "groupOrder": 0
                }, {
                    "value": "Croatian (Old Code)",
                    "key": "scr",
                    "groupOrder": 0
                }, {
                    "value": "Cushitic (Other)",
                    "key": "cus",
                    "groupOrder": 0
                }, {
                    "value": "Czech",
                    "key": "cze",
                    "groupOrder": 0
                }, {
                    "value": "Dakota",
                    "key": "dak",
                    "groupOrder": 0
                }, {
                    "value": "Danish",
                    "key": "dan",
                    "groupOrder": 0
                }, {
                    "value": "Dargwa",
                    "key": "dar",
                    "groupOrder": 0
                }, {
                    "value": "Dayak",
                    "key": "day",
                    "groupOrder": 0
                }, {
                    "value": "Delaware",
                    "key": "del",
                    "groupOrder": 0
                }, {
                    "value": "Dinka",
                    "key": "din",
                    "groupOrder": 0
                }, {
                    "value": "Divehi",
                    "key": "div",
                    "groupOrder": 0
                }, {
                    "value": "Dogri",
                    "key": "doi",
                    "groupOrder": 0
                }, {
                    "value": "Dogrib",
                    "key": "dgr",
                    "groupOrder": 0
                }, {
                    "value": "Dravidian (Other)",
                    "key": "dra",
                    "groupOrder": 0
                }, {
                    "value": "Duala",
                    "key": "dua",
                    "groupOrder": 0
                }, {
                    "value": "Dutch",
                    "key": "dut",
                    "groupOrder": 0
                }, {
                    "value": "Dutch, Middle (ca. 1050-1350)",
                    "key": "dum",
                    "groupOrder": 0
                }, {
                    "value": "Dyula",
                    "key": "dyu",
                    "groupOrder": 0
                }, {
                    "value": "Dzongkha",
                    "key": "dzo",
                    "groupOrder": 0
                }, {
                    "value": "East Frisian",
                    "key": "frs",
                    "groupOrder": 0
                }, {
                    "value": "Edo",
                    "key": "bin",
                    "groupOrder": 0
                }, {
                    "value": "Efik",
                    "key": "efi",
                    "groupOrder": 0
                }, {
                    "value": "Egyptian",
                    "key": "egy",
                    "groupOrder": 0
                }, {
                    "value": "Ekajuk",
                    "key": "eka",
                    "groupOrder": 0
                }, {
                    "value": "Elamite",
                    "key": "elx",
                    "groupOrder": 0
                }, {
                    "value": "English",
                    "key": "eng",
                    "groupOrder": 0
                }, {
                    "value": "English, Middle (1100-1500)",
                    "key": "enm",
                    "groupOrder": 0
                }, {
                    "value": "English, Old (ca. 450-1100)",
                    "key": "ang",
                    "groupOrder": 0
                }, {
                    "value": "Erzya",
                    "key": "myv",
                    "groupOrder": 0
                }, {
                    "value": "Eskimo languages (Old Code)",
                    "key": "esk",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto",
                    "key": "epo",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto (Old Code)",
                    "key": "esp",
                    "groupOrder": 0
                }, {
                    "value": "Estonian",
                    "key": "est",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic",
                    "key": "gez",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic (Old Code)",
                    "key": "eth",
                    "groupOrder": 0
                }, {
                    "value": "Ewe",
                    "key": "ewe",
                    "groupOrder": 0
                }, {
                    "value": "Ewondo",
                    "key": "ewo",
                    "groupOrder": 0
                }, {
                    "value": "Fang",
                    "key": "fan",
                    "groupOrder": 0
                }, {
                    "value": "Fanti",
                    "key": "fat",
                    "groupOrder": 0
                }, {
                    "value": "Faroese",
                    "key": "fao",
                    "groupOrder": 0
                }, {
                    "value": "Faroese (Old Code)",
                    "key": "far",
                    "groupOrder": 0
                }, {
                    "value": "Fijian",
                    "key": "fij",
                    "groupOrder": 0
                }, {
                    "value": "Filipino",
                    "key": "fil",
                    "groupOrder": 0
                }, {
                    "value": "Finnish",
                    "key": "fin",
                    "groupOrder": 0
                }, {
                    "value": "Finno-Ugrian (Other)",
                    "key": "fiu",
                    "groupOrder": 0
                }, {
                    "value": "Fon",
                    "key": "fon",
                    "groupOrder": 0
                }, {
                    "value": "French",
                    "key": "fre",
                    "groupOrder": 0
                }, {
                    "value": "French, Middle (ca. 1300-1600)",
                    "key": "frm",
                    "groupOrder": 0
                }, {
                    "value": "French, Old (ca. 842-1300)",
                    "key": "fro",
                    "groupOrder": 0
                }, {
                    "value": "Frisian",
                    "key": "fry",
                    "groupOrder": 0
                }, {
                    "value": "Frisian (Old Code)",
                    "key": "fri",
                    "groupOrder": 0
                }, {
                    "value": "Friulian",
                    "key": "fur",
                    "groupOrder": 0
                }, {
                    "value": "Fula",
                    "key": "ful",
                    "groupOrder": 0
                }, {
                    "value": "Galician",
                    "key": "glg",
                    "groupOrder": 0
                }, {
                    "value": "Galician (Old Code)",
                    "key": "gag",
                    "groupOrder": 0
                }, {
                    "value": "Ganda",
                    "key": "lug",
                    "groupOrder": 0
                }, {
                    "value": "Gayo",
                    "key": "gay",
                    "groupOrder": 0
                }, {
                    "value": "Gbaya",
                    "key": "gba",
                    "groupOrder": 0
                }, {
                    "value": "Georgian",
                    "key": "geo",
                    "groupOrder": 0
                }, {
                    "value": "German",
                    "key": "ger",
                    "groupOrder": 0
                }, {
                    "value": "German, Middle High (ca. 1050-1500)",
                    "key": "gmh",
                    "groupOrder": 0
                }, {
                    "value": "German, Old High (ca. 750-1050)",
                    "key": "goh",
                    "groupOrder": 0
                }, {
                    "value": "Germanic (Other)",
                    "key": "gem",
                    "groupOrder": 0
                }, {
                    "value": "Gilbertese",
                    "key": "gil",
                    "groupOrder": 0
                }, {
                    "value": "Gondi",
                    "key": "gon",
                    "groupOrder": 0
                }, {
                    "value": "Gorontalo",
                    "key": "gor",
                    "groupOrder": 0
                }, {
                    "value": "Gothic",
                    "key": "got",
                    "groupOrder": 0
                }, {
                    "value": "Grebo",
                    "key": "grb",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Ancient (to 1453)",
                    "key": "grc",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Modern (1453- )",
                    "key": "gre",
                    "groupOrder": 0
                }, {
                    "value": "Guarani",
                    "key": "grn",
                    "groupOrder": 0
                }, {
                    "value": "Guarani (Old Code)",
                    "key": "gua",
                    "groupOrder": 0
                }, {
                    "value": "Gujarati",
                    "key": "guj",
                    "groupOrder": 0
                }, {
                    "value": "Gwich'in",
                    "key": "gwi",
                    "groupOrder": 0
                }, {
                    "value": "Gã",
                    "key": "gaa",
                    "groupOrder": 0
                }, {
                    "value": "Haida",
                    "key": "hai",
                    "groupOrder": 0
                }, {
                    "value": "Haitian French Creole",
                    "key": "hat",
                    "groupOrder": 0
                }, {
                    "value": "Hausa",
                    "key": "hau",
                    "groupOrder": 0
                }, {
                    "value": "Hawaiian",
                    "key": "haw",
                    "groupOrder": 0
                }, {
                    "value": "Hebrew",
                    "key": "heb",
                    "groupOrder": 0
                }, {
                    "value": "Herero",
                    "key": "her",
                    "groupOrder": 0
                }, {
                    "value": "Hiligaynon",
                    "key": "hil",
                    "groupOrder": 0
                }, {
                    "value": "Hindi",
                    "key": "hin",
                    "groupOrder": 0
                }, {
                    "value": "Hiri Motu",
                    "key": "hmo",
                    "groupOrder": 0
                }, {
                    "value": "Hittite",
                    "key": "hit",
                    "groupOrder": 0
                }, {
                    "value": "Hmong",
                    "key": "hmn",
                    "groupOrder": 0
                }, {
                    "value": "Hungarian",
                    "key": "hun",
                    "groupOrder": 0
                }, {
                    "value": "Hupa",
                    "key": "hup",
                    "groupOrder": 0
                }, {
                    "value": "Iban",
                    "key": "iba",
                    "groupOrder": 0
                }, {
                    "value": "Icelandic",
                    "key": "ice",
                    "groupOrder": 0
                }, {
                    "value": "Ido",
                    "key": "ido",
                    "groupOrder": 0
                }, {
                    "value": "Igbo",
                    "key": "ibo",
                    "groupOrder": 0
                }, {
                    "value": "Ijo",
                    "key": "ijo",
                    "groupOrder": 0
                }, {
                    "value": "Iloko",
                    "key": "ilo",
                    "groupOrder": 0
                }, {
                    "value": "Inari Sami",
                    "key": "smn",
                    "groupOrder": 0
                }, {
                    "value": "Indic (Other)",
                    "key": "inc",
                    "groupOrder": 0
                }, {
                    "value": "Indo-European (Other)",
                    "key": "ine",
                    "groupOrder": 0
                }, {
                    "value": "Indonesian",
                    "key": "ind",
                    "groupOrder": 0
                }, {
                    "value": "Ingush",
                    "key": "inh",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association)",
                    "key": "ina",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association) (Old Code)",
                    "key": "int",
                    "groupOrder": 0
                }, {
                    "value": "Interlingue",
                    "key": "ile",
                    "groupOrder": 0
                }, {
                    "value": "Inuktitut",
                    "key": "iku",
                    "groupOrder": 0
                }, {
                    "value": "Inupiaq",
                    "key": "ipk",
                    "groupOrder": 0
                }, {
                    "value": "Iranian (Other)",
                    "key": "ira",
                    "groupOrder": 0
                }, {
                    "value": "Irish",
                    "key": "gle",
                    "groupOrder": 0
                }, {
                    "value": "Irish (Old Code)",
                    "key": "iri",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Middle (ca. 1100-1550)",
                    "key": "mga",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Old (to 1100)",
                    "key": "sga",
                    "groupOrder": 0
                }, {
                    "value": "Iroquoian (Other)",
                    "key": "iro",
                    "groupOrder": 0
                }, {
                    "value": "Italian",
                    "key": "ita",
                    "groupOrder": 0
                }, {
                    "value": "Japanese",
                    "key": "jpn",
                    "groupOrder": 0
                }, {
                    "value": "Javanese",
                    "key": "jav",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Arabic",
                    "key": "jrb",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Persian",
                    "key": "jpr",
                    "groupOrder": 0
                }, {
                    "value": "Kabardian",
                    "key": "kbd",
                    "groupOrder": 0
                }, {
                    "value": "Kabyle",
                    "key": "kab",
                    "groupOrder": 0
                }, {
                    "value": "Kachin",
                    "key": "kac",
                    "groupOrder": 0
                }, {
                    "value": "Kalâtdlisut",
                    "key": "kal",
                    "groupOrder": 0
                }, {
                    "value": "Kamba",
                    "key": "kam",
                    "groupOrder": 0
                }, {
                    "value": "Kannada",
                    "key": "kan",
                    "groupOrder": 0
                }, {
                    "value": "Kanuri",
                    "key": "kau",
                    "groupOrder": 0
                }, {
                    "value": "Kara-Kalpak",
                    "key": "kaa",
                    "groupOrder": 0
                }, {
                    "value": "Karachay-Balkar",
                    "key": "krc",
                    "groupOrder": 0
                }, {
                    "value": "Karelian",
                    "key": "krl",
                    "groupOrder": 0
                }, {
                    "value": "Karen languages",
                    "key": "kar",
                    "groupOrder": 0
                }, {
                    "value": "Kashmiri",
                    "key": "kas",
                    "groupOrder": 0
                }, {
                    "value": "Kashubian",
                    "key": "csb",
                    "groupOrder": 0
                }, {
                    "value": "Kawi",
                    "key": "kaw",
                    "groupOrder": 0
                }, {
                    "value": "Kazakh",
                    "key": "kaz",
                    "groupOrder": 0
                }, {
                    "value": "Khasi",
                    "key": "kha",
                    "groupOrder": 0
                }, {
                    "value": "Khmer",
                    "key": "khm",
                    "groupOrder": 0
                }, {
                    "value": "Khmer (Old Code)",
                    "key": "cam",
                    "groupOrder": 0
                }, {
                    "value": "Khoisan (Other)",
                    "key": "khi",
                    "groupOrder": 0
                }, {
                    "value": "Khotanese",
                    "key": "kho",
                    "groupOrder": 0
                }, {
                    "value": "Kikuyu",
                    "key": "kik",
                    "groupOrder": 0
                }, {
                    "value": "Kimbundu",
                    "key": "kmb",
                    "groupOrder": 0
                }, {
                    "value": "Kinyarwanda",
                    "key": "kin",
                    "groupOrder": 0
                }, {
                    "value": "Klingon (Artificial language)",
                    "key": "tlh",
                    "groupOrder": 0
                }, {
                    "value": "Komi",
                    "key": "kom",
                    "groupOrder": 0
                }, {
                    "value": "Kongo",
                    "key": "kon",
                    "groupOrder": 0
                }, {
                    "value": "Konkani",
                    "key": "kok",
                    "groupOrder": 0
                }, {
                    "value": "Kootenai",
                    "key": "kut",
                    "groupOrder": 0
                }, {
                    "value": "Korean",
                    "key": "kor",
                    "groupOrder": 0
                }, {
                    "value": "Kpelle",
                    "key": "kpe",
                    "groupOrder": 0
                }, {
                    "value": "Kru (Other)",
                    "key": "kro",
                    "groupOrder": 0
                }, {
                    "value": "Kuanyama",
                    "key": "kua",
                    "groupOrder": 0
                }, {
                    "value": "Kumyk",
                    "key": "kum",
                    "groupOrder": 0
                }, {
                    "value": "Kurdish",
                    "key": "kur",
                    "groupOrder": 0
                }, {
                    "value": "Kurukh",
                    "key": "kru",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie",
                    "key": "kos",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie (Old Code)",
                    "key": "kus",
                    "groupOrder": 0
                }, {
                    "value": "Kyrgyz",
                    "key": "kir",
                    "groupOrder": 0
                }, {
                    "value": "Ladino",
                    "key": "lad",
                    "groupOrder": 0
                }, {
                    "value": "Lahnda",
                    "key": "lah",
                    "groupOrder": 0
                }, {
                    "value": "Lamba (Zambia and Congo)",
                    "key": "lam",
                    "groupOrder": 0
                }, {
                    "value": "Lao",
                    "key": "lao",
                    "groupOrder": 0
                }, {
                    "value": "Latin",
                    "key": "lat",
                    "groupOrder": 0
                }, {
                    "value": "Latvian",
                    "key": "lav",
                    "groupOrder": 0
                }, {
                    "value": "Lezgian",
                    "key": "lez",
                    "groupOrder": 0
                }, {
                    "value": "Limburgish",
                    "key": "lim",
                    "groupOrder": 0
                }, {
                    "value": "Lingala",
                    "key": "lin",
                    "groupOrder": 0
                }, {
                    "value": "Lithuanian",
                    "key": "lit",
                    "groupOrder": 0
                }, {
                    "value": "Lojban (Artificial language)",
                    "key": "jbo",
                    "groupOrder": 0
                }, {
                    "value": "Low German",
                    "key": "nds",
                    "groupOrder": 0
                }, {
                    "value": "Lower Sorbian",
                    "key": "dsb",
                    "groupOrder": 0
                }, {
                    "value": "Lozi",
                    "key": "loz",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Katanga",
                    "key": "lub",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Lulua",
                    "key": "lua",
                    "groupOrder": 0
                }, {
                    "value": "Luiseño",
                    "key": "lui",
                    "groupOrder": 0
                }, {
                    "value": "Lule Sami",
                    "key": "smj",
                    "groupOrder": 0
                }, {
                    "value": "Lunda",
                    "key": "lun",
                    "groupOrder": 0
                }, {
                    "value": "Luo (Kenya and Tanzania)",
                    "key": "luo",
                    "groupOrder": 0
                }, {
                    "value": "Lushai",
                    "key": "lus",
                    "groupOrder": 0
                }, {
                    "value": "Luxembourgish",
                    "key": "ltz",
                    "groupOrder": 0
                }, {
                    "value": "Macedonian",
                    "key": "mac",
                    "groupOrder": 0
                }, {
                    "value": "Madurese",
                    "key": "mad",
                    "groupOrder": 0
                }, {
                    "value": "Magahi",
                    "key": "mag",
                    "groupOrder": 0
                }, {
                    "value": "Maithili",
                    "key": "mai",
                    "groupOrder": 0
                }, {
                    "value": "Makasar",
                    "key": "mak",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy",
                    "key": "mlg",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy (Old Code)",
                    "key": "mla",
                    "groupOrder": 0
                }, {
                    "value": "Malay",
                    "key": "may",
                    "groupOrder": 0
                }, {
                    "value": "Malayalam",
                    "key": "mal",
                    "groupOrder": 0
                }, {
                    "value": "Maltese",
                    "key": "mlt",
                    "groupOrder": 0
                }, {
                    "value": "Manchu",
                    "key": "mnc",
                    "groupOrder": 0
                }, {
                    "value": "Mandar",
                    "key": "mdr",
                    "groupOrder": 0
                }, {
                    "value": "Mandingo",
                    "key": "man",
                    "groupOrder": 0
                }, {
                    "value": "Manipuri",
                    "key": "mni",
                    "groupOrder": 0
                }, {
                    "value": "Manobo languages",
                    "key": "mno",
                    "groupOrder": 0
                }, {
                    "value": "Manx",
                    "key": "glv",
                    "groupOrder": 0
                }, {
                    "value": "Manx (Old Code)",
                    "key": "max",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mao",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mri",
                    "groupOrder": 0
                }, {
                    "value": "Mapuche",
                    "key": "arn",
                    "groupOrder": 0
                }, {
                    "value": "Marathi",
                    "key": "mar",
                    "groupOrder": 0
                }, {
                    "value": "Mari",
                    "key": "chm",
                    "groupOrder": 0
                }, {
                    "value": "Marshallese",
                    "key": "mah",
                    "groupOrder": 0
                }, {
                    "value": "Marwari",
                    "key": "mwr",
                    "groupOrder": 0
                }, {
                    "value": "Masai",
                    "key": "mas",
                    "groupOrder": 0
                }, {
                    "value": "Mayan languages",
                    "key": "myn",
                    "groupOrder": 0
                }, {
                    "value": "Mende",
                    "key": "men",
                    "groupOrder": 0
                }, {
                    "value": "Micmac",
                    "key": "mic",
                    "groupOrder": 0
                }, {
                    "value": "Minangkabau",
                    "key": "min",
                    "groupOrder": 0
                }, {
                    "value": "Mirandese",
                    "key": "mwl",
                    "groupOrder": 0
                }, {
                    "value": "Miscellaneous languages",
                    "key": "mis",
                    "groupOrder": 0
                }, {
                    "value": "Mohawk",
                    "key": "moh",
                    "groupOrder": 0
                }, {
                    "value": "Moksha",
                    "key": "mdf",
                    "groupOrder": 0
                }, {
                    "value": "Moldavian (Old Code)",
                    "key": "mol",
                    "groupOrder": 0
                }, {
                    "value": "Mon-Khmer (Other)",
                    "key": "mkh",
                    "groupOrder": 0
                }, {
                    "value": "Mongo-Nkundu",
                    "key": "lol",
                    "groupOrder": 0
                }, {
                    "value": "Mongolian",
                    "key": "mon",
                    "groupOrder": 0
                }, {
                    "value": "Montenegrin",
                    "key": "cnr",
                    "groupOrder": 0
                }, {
                    "value": "Mooré",
                    "key": "mos",
                    "groupOrder": 0
                }, {
                    "value": "Multiple languages",
                    "key": "mul",
                    "groupOrder": 0
                }, {
                    "value": "Munda (Other)",
                    "key": "mun",
                    "groupOrder": 0
                }, {
                    "value": "N'Ko",
                    "key": "nqo",
                    "groupOrder": 0
                }, {
                    "value": "Nahuatl",
                    "key": "nah",
                    "groupOrder": 0
                }, {
                    "value": "Nauru",
                    "key": "nau",
                    "groupOrder": 0
                }, {
                    "value": "Navajo",
                    "key": "nav",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (South Africa)",
                    "key": "nbl",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (Zimbabwe)",
                    "key": "nde",
                    "groupOrder": 0
                }, {
                    "value": "Ndonga",
                    "key": "ndo",
                    "groupOrder": 0
                }, {
                    "value": "Neapolitan Italian",
                    "key": "nap",
                    "groupOrder": 0
                }, {
                    "value": "Nepali",
                    "key": "nep",
                    "groupOrder": 0
                }, {
                    "value": "Newari",
                    "key": "new",
                    "groupOrder": 0
                }, {
                    "value": "Newari, Old",
                    "key": "nwc",
                    "groupOrder": 0
                }, {
                    "value": "Nias",
                    "key": "nia",
                    "groupOrder": 0
                }, {
                    "value": "Niger-Kordofanian (Other)",
                    "key": "nic",
                    "groupOrder": 0
                }, {
                    "value": "Nilo-Saharan (Other)",
                    "key": "ssa",
                    "groupOrder": 0
                }, {
                    "value": "Niuean",
                    "key": "niu",
                    "groupOrder": 0
                }, {
                    "value": "No information provided",
                    "key": "   ",
                    "groupOrder": 0
                }, {
                    "value": "No linguistic content",
                    "key": "zxx",
                    "groupOrder": 0
                }, {
                    "value": "Nogai",
                    "key": "nog",
                    "groupOrder": 0
                }, {
                    "value": "None of the above",
                    "key": "|||",
                    "groupOrder": 0
                }, {
                    "value": "North American Indian (Other)",
                    "key": "nai",
                    "groupOrder": 0
                }, {
                    "value": "North Frisian",
                    "key": "frr",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sami",
                    "key": "sme",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sotho",
                    "key": "nso",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian",
                    "key": "nor",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Bokmål)",
                    "key": "nob",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Nynorsk)",
                    "key": "nno",
                    "groupOrder": 0
                }, {
                    "value": "Nubian languages",
                    "key": "nub",
                    "groupOrder": 0
                }, {
                    "value": "Nyamwezi",
                    "key": "nym",
                    "groupOrder": 0
                }, {
                    "value": "Nyanja",
                    "key": "nya",
                    "groupOrder": 0
                }, {
                    "value": "Nyankole",
                    "key": "nyn",
                    "groupOrder": 0
                }, {
                    "value": "Nyoro",
                    "key": "nyo",
                    "groupOrder": 0
                }, {
                    "value": "Nzima",
                    "key": "nzi",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500)",
                    "key": "oci",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500) (Old Code)",
                    "key": "lan",
                    "groupOrder": 0
                }, {
                    "value": "Oirat",
                    "key": "xal",
                    "groupOrder": 0
                }, {
                    "value": "Ojibwa",
                    "key": "oji",
                    "groupOrder": 0
                }, {
                    "value": "Old Norse",
                    "key": "non",
                    "groupOrder": 0
                }, {
                    "value": "Old Persian (ca. 600-400 B.C.)",
                    "key": "peo",
                    "groupOrder": 0
                }, {
                    "value": "Oriya",
                    "key": "ori",
                    "groupOrder": 0
                }, {
                    "value": "Oromo",
                    "key": "orm",
                    "groupOrder": 0
                }, {
                    "value": "Oromo (Old Code)",
                    "key": "gal",
                    "groupOrder": 0
                }, {
                    "value": "Osage",
                    "key": "osa",
                    "groupOrder": 0
                }, {
                    "value": "Ossetic",
                    "key": "oss",
                    "groupOrder": 0
                }, {
                    "value": "Otomian languages",
                    "key": "oto",
                    "groupOrder": 0
                }, {
                    "value": "Pahlavi",
                    "key": "pal",
                    "groupOrder": 0
                }, {
                    "value": "Palauan",
                    "key": "pau",
                    "groupOrder": 0
                }, {
                    "value": "Pali",
                    "key": "pli",
                    "groupOrder": 0
                }, {
                    "value": "Pampanga",
                    "key": "pam",
                    "groupOrder": 0
                }, {
                    "value": "Pangasinan",
                    "key": "pag",
                    "groupOrder": 0
                }, {
                    "value": "Panjabi",
                    "key": "pan",
                    "groupOrder": 0
                }, {
                    "value": "Papiamento",
                    "key": "pap",
                    "groupOrder": 0
                }, {
                    "value": "Papuan (Other)",
                    "key": "paa",
                    "groupOrder": 0
                }, {
                    "value": "Persian",
                    "key": "per",
                    "groupOrder": 0
                }, {
                    "value": "Philippine (Other)",
                    "key": "phi",
                    "groupOrder": 0
                }, {
                    "value": "Phoenician",
                    "key": "phn",
                    "groupOrder": 0
                }, {
                    "value": "Polish",
                    "key": "pol",
                    "groupOrder": 0
                }, {
                    "value": "Ponape",
                    "key": "pon",
                    "groupOrder": 0
                }, {
                    "value": "Portuguese",
                    "key": "por",
                    "groupOrder": 0
                }, {
                    "value": "Prakrit languages",
                    "key": "pra",
                    "groupOrder": 0
                }, {
                    "value": "Provençal (to 1500)",
                    "key": "pro",
                    "groupOrder": 0
                }, {
                    "value": "Pushto",
                    "key": "pus",
                    "groupOrder": 0
                }, {
                    "value": "Quechua",
                    "key": "que",
                    "groupOrder": 0
                }, {
                    "value": "Raeto-Romance",
                    "key": "roh",
                    "groupOrder": 0
                }, {
                    "value": "Rajasthani",
                    "key": "raj",
                    "groupOrder": 0
                }, {
                    "value": "Rapanui",
                    "key": "rap",
                    "groupOrder": 0
                }, {
                    "value": "Rarotongan",
                    "key": "rar",
                    "groupOrder": 0
                }, {
                    "value": "Romance (Other)",
                    "key": "roa",
                    "groupOrder": 0
                }, {
                    "value": "Romani",
                    "key": "rom",
                    "groupOrder": 0
                }, {
                    "value": "Romanian",
                    "key": "rum",
                    "groupOrder": 0
                }, {
                    "value": "Rundi",
                    "key": "run",
                    "groupOrder": 0
                }, {
                    "value": "Russian",
                    "key": "rus",
                    "groupOrder": 0
                }, {
                    "value": "Salishan languages",
                    "key": "sal",
                    "groupOrder": 0
                }, {
                    "value": "Samaritan Aramaic",
                    "key": "sam",
                    "groupOrder": 0
                }, {
                    "value": "Sami",
                    "key": "smi",
                    "groupOrder": 0
                }, {
                    "value": "Sami (Old Code)",
                    "key": "lap",
                    "groupOrder": 0
                }, {
                    "value": "Samoan",
                    "key": "smo",
                    "groupOrder": 0
                }, {
                    "value": "Samoan (Old Code)",
                    "key": "sao",
                    "groupOrder": 0
                }, {
                    "value": "Sandawe",
                    "key": "sad",
                    "groupOrder": 0
                }, {
                    "value": "Sango (Ubangi Creole)",
                    "key": "sag",
                    "groupOrder": 0
                }, {
                    "value": "Sanskrit",
                    "key": "san",
                    "groupOrder": 0
                }, {
                    "value": "Santali",
                    "key": "sat",
                    "groupOrder": 0
                }, {
                    "value": "Sardinian",
                    "key": "srd",
                    "groupOrder": 0
                }, {
                    "value": "Sasak",
                    "key": "sas",
                    "groupOrder": 0
                }, {
                    "value": "Scots",
                    "key": "sco",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelic",
                    "key": "gla",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelix (Old Code)",
                    "key": "gae",
                    "groupOrder": 0
                }, {
                    "value": "Selkup",
                    "key": "sel",
                    "groupOrder": 0
                }, {
                    "value": "Semitic (Other)",
                    "key": "sem",
                    "groupOrder": 0
                }, {
                    "value": "Serbian",
                    "key": "srp",
                    "groupOrder": 0
                }, {
                    "value": "Serbian (Old Code)",
                    "key": "scc",
                    "groupOrder": 0
                }, {
                    "value": "Serer",
                    "key": "srr",
                    "groupOrder": 0
                }, {
                    "value": "Shan",
                    "key": "shn",
                    "groupOrder": 0
                }, {
                    "value": "Shona",
                    "key": "sna",
                    "groupOrder": 0
                }, {
                    "value": "Shona (Old Code)",
                    "key": "sho",
                    "groupOrder": 0
                }, {
                    "value": "Sichuan Yi",
                    "key": "iii",
                    "groupOrder": 0
                }, {
                    "value": "Sicilian Italian",
                    "key": "scn",
                    "groupOrder": 0
                }, {
                    "value": "Sidamo",
                    "key": "sid",
                    "groupOrder": 0
                }, {
                    "value": "Sign languages",
                    "key": "sgn",
                    "groupOrder": 0
                }, {
                    "value": "Siksika",
                    "key": "bla",
                    "groupOrder": 0
                }, {
                    "value": "Sindhi",
                    "key": "snd",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese",
                    "key": "sin",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese (Old Code)",
                    "key": "snh",
                    "groupOrder": 0
                }, {
                    "value": "Sino-Tibetan (Other)",
                    "key": "sit",
                    "groupOrder": 0
                }, {
                    "value": "Siouan (Other)",
                    "key": "sio",
                    "groupOrder": 0
                }, {
                    "value": "Skolt Sami",
                    "key": "sms",
                    "groupOrder": 0
                }, {
                    "value": "Slave",
                    "key": "den",
                    "groupOrder": 0
                }, {
                    "value": "Slavic (Other)",
                    "key": "sla",
                    "groupOrder": 0
                }, {
                    "value": "Slovak",
                    "key": "slo",
                    "groupOrder": 0
                }, {
                    "value": "Slovenian",
                    "key": "slv",
                    "groupOrder": 0
                }, {
                    "value": "Sogdian",
                    "key": "sog",
                    "groupOrder": 0
                }, {
                    "value": "Somali",
                    "key": "som",
                    "groupOrder": 0
                }, {
                    "value": "Songhai",
                    "key": "son",
                    "groupOrder": 0
                }, {
                    "value": "Soninke",
                    "key": "snk",
                    "groupOrder": 0
                }, {
                    "value": "Sorbian (Other)",
                    "key": "wen",
                    "groupOrder": 0
                }, {
                    "value": "Sotho",
                    "key": "sot",
                    "groupOrder": 0
                }, {
                    "value": "Sotho (Old Code)",
                    "key": "sso",
                    "groupOrder": 0
                }, {
                    "value": "South American Indian (Other)",
                    "key": "sai",
                    "groupOrder": 0
                }, {
                    "value": "Southern Sami",
                    "key": "sma",
                    "groupOrder": 0
                }, {
                    "value": "Spanish",
                    "key": "spa",
                    "groupOrder": 0
                }, {
                    "value": "Sranan",
                    "key": "srn",
                    "groupOrder": 0
                }, {
                    "value": "Sukuma",
                    "key": "suk",
                    "groupOrder": 0
                }, {
                    "value": "Sumerian",
                    "key": "sux",
                    "groupOrder": 0
                }, {
                    "value": "Sundanese",
                    "key": "sun",
                    "groupOrder": 0
                }, {
                    "value": "Susu",
                    "key": "sus",
                    "groupOrder": 0
                }, {
                    "value": "Swahili",
                    "key": "swa",
                    "groupOrder": 0
                }, {
                    "value": "Swazi",
                    "key": "ssw",
                    "groupOrder": 0
                }, {
                    "value": "Swazi (Old Code)",
                    "key": "swz",
                    "groupOrder": 0
                }, {
                    "value": "Swedish",
                    "key": "swe",
                    "groupOrder": 0
                }, {
                    "value": "Swiss German",
                    "key": "gsw",
                    "groupOrder": 0
                }, {
                    "value": "Syriac",
                    "key": "syc",
                    "groupOrder": 0
                }, {
                    "value": "Syriac, Modern",
                    "key": "syr",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog",
                    "key": "tgl",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog (Old Code)",
                    "key": "tag",
                    "groupOrder": 0
                }, {
                    "value": "Tahitian",
                    "key": "tah",
                    "groupOrder": 0
                }, {
                    "value": "Tai (Other)",
                    "key": "tai",
                    "groupOrder": 0
                }, {
                    "value": "Tajik",
                    "key": "tgk",
                    "groupOrder": 0
                }, {
                    "value": "Tajik (Old Code)",
                    "key": "taj",
                    "groupOrder": 0
                }, {
                    "value": "Tamashek",
                    "key": "tmh",
                    "groupOrder": 0
                }, {
                    "value": "Tamil",
                    "key": "tam",
                    "groupOrder": 0
                }, {
                    "value": "Tatar",
                    "key": "tat",
                    "groupOrder": 0
                }, {
                    "value": "Tatar (Old Code)",
                    "key": "tar",
                    "groupOrder": 0
                }, {
                    "value": "Telugu",
                    "key": "tel",
                    "groupOrder": 0
                }, {
                    "value": "Temne",
                    "key": "tem",
                    "groupOrder": 0
                }, {
                    "value": "Terena",
                    "key": "ter",
                    "groupOrder": 0
                }, {
                    "value": "Tetum",
                    "key": "tet",
                    "groupOrder": 0
                }, {
                    "value": "Thai",
                    "key": "tha",
                    "groupOrder": 0
                }, {
                    "value": "Tibetan",
                    "key": "tib",
                    "groupOrder": 0
                }, {
                    "value": "Tigrinya",
                    "key": "tir",
                    "groupOrder": 0
                }, {
                    "value": "Tigré",
                    "key": "tig",
                    "groupOrder": 0
                }, {
                    "value": "Tiv",
                    "key": "tiv",
                    "groupOrder": 0
                }, {
                    "value": "Tlingit",
                    "key": "tli",
                    "groupOrder": 0
                }, {
                    "value": "Tok Pisin",
                    "key": "tpi",
                    "groupOrder": 0
                }, {
                    "value": "Tokelauan",
                    "key": "tkl",
                    "groupOrder": 0
                }, {
                    "value": "Tonga (Nyasa)",
                    "key": "tog",
                    "groupOrder": 0
                }, {
                    "value": "Tongan",
                    "key": "ton",
                    "groupOrder": 0
                }, {
                    "value": "Truk (Old Code)",
                    "key": "tru",
                    "groupOrder": 0
                }, {
                    "value": "Tsimshian",
                    "key": "tsi",
                    "groupOrder": 0
                }, {
                    "value": "Tsonga",
                    "key": "tso",
                    "groupOrder": 0
                }, {
                    "value": "Tswana",
                    "key": "tsn",
                    "groupOrder": 0
                }, {
                    "value": "Tswana (Old Code)",
                    "key": "tsw",
                    "groupOrder": 0
                }, {
                    "value": "Tumbuka",
                    "key": "tum",
                    "groupOrder": 0
                }, {
                    "value": "Tupi languages",
                    "key": "tup",
                    "groupOrder": 0
                }, {
                    "value": "Turkish",
                    "key": "tur",
                    "groupOrder": 0
                }, {
                    "value": "Turkish, Ottoman",
                    "key": "ota",
                    "groupOrder": 0
                }, {
                    "value": "Turkmen",
                    "key": "tuk",
                    "groupOrder": 0
                }, {
                    "value": "Tuvaluan",
                    "key": "tvl",
                    "groupOrder": 0
                }, {
                    "value": "Tuvinian",
                    "key": "tyv",
                    "groupOrder": 0
                }, {
                    "value": "Twi",
                    "key": "twi",
                    "groupOrder": 0
                }, {
                    "value": "Udmurt",
                    "key": "udm",
                    "groupOrder": 0
                }, {
                    "value": "Ugaritic",
                    "key": "uga",
                    "groupOrder": 0
                }, {
                    "value": "Uighur",
                    "key": "uig",
                    "groupOrder": 0
                }, {
                    "value": "Ukrainian",
                    "key": "ukr",
                    "groupOrder": 0
                }, {
                    "value": "Umbundu",
                    "key": "umb",
                    "groupOrder": 0
                }, {
                    "value": "Undetermined",
                    "key": "und",
                    "groupOrder": 0
                }, {
                    "value": "Upper Sorbian",
                    "key": "hsb",
                    "groupOrder": 0
                }, {
                    "value": "Urdu",
                    "key": "urd",
                    "groupOrder": 0
                }, {
                    "value": "Uzbek",
                    "key": "uzb",
                    "groupOrder": 0
                }, {
                    "value": "Vai",
                    "key": "vai",
                    "groupOrder": 0
                }, {
                    "value": "Venda",
                    "key": "ven",
                    "groupOrder": 0
                }, {
                    "value": "Vietnamese",
                    "key": "vie",
                    "groupOrder": 0
                }, {
                    "value": "Volapük",
                    "key": "vol",
                    "groupOrder": 0
                }, {
                    "value": "Votic",
                    "key": "vot",
                    "groupOrder": 0
                }, {
                    "value": "Wakashan languages",
                    "key": "wak",
                    "groupOrder": 0
                }, {
                    "value": "Walloon",
                    "key": "wln",
                    "groupOrder": 0
                }, {
                    "value": "Waray",
                    "key": "war",
                    "groupOrder": 0
                }, {
                    "value": "Washo",
                    "key": "was",
                    "groupOrder": 0
                }, {
                    "value": "Welsh",
                    "key": "wel",
                    "groupOrder": 0
                }, {
                    "value": "Western Pahari languages",
                    "key": "him",
                    "groupOrder": 0
                }, {
                    "value": "Wolayta",
                    "key": "wal",
                    "groupOrder": 0
                }, {
                    "value": "Wolof",
                    "key": "wol",
                    "groupOrder": 0
                }, {
                    "value": "Xhosa",
                    "key": "xho",
                    "groupOrder": 0
                }, {
                    "value": "Yakut",
                    "key": "sah",
                    "groupOrder": 0
                }, {
                    "value": "Yao (Africa)",
                    "key": "yao",
                    "groupOrder": 0
                }, {
                    "value": "Yapese",
                    "key": "yap",
                    "groupOrder": 0
                }, {
                    "value": "Yiddish",
                    "key": "yid",
                    "groupOrder": 0
                }, {
                    "value": "Yoruba",
                    "key": "yor",
                    "groupOrder": 0
                }, {
                    "value": "Yupik languages",
                    "key": "ypk",
                    "groupOrder": 0
                }, {
                    "value": "Zande languages",
                    "key": "znd",
                    "groupOrder": 0
                }, {
                    "value": "Zapotec",
                    "key": "zap",
                    "groupOrder": 0
                }, {
                    "value": "Zaza",
                    "key": "zza",
                    "groupOrder": 0
                }, {
                    "value": "Zenaga",
                    "key": "zen",
                    "groupOrder": 0
                }, {
                    "value": "Zhuang",
                    "key": "zha",
                    "groupOrder": 0
                }, {
                    "value": "Zulu",
                    "key": "zul",
                    "groupOrder": 0
                }, {
                    "value": "Zuni",
                    "key": "zun",
                    "groupOrder": 0
                }]
        },
        "lc_class_number": {
            "key": "lc_class_number",
            "value": "LC Call Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "lccn": {
            "key": "lccn",
            "value": "LC Control No.",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "link_inst": {
            "key": "link_inst",
            "value": "Linked Institution",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Community",
                    "key": "41",
                    "groupOrder": 0
                }]
        },
        "local_field_940": {
            "key": "local_field_940",
            "value": "Local Collection",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "local_control_field_009": {
            "key": "local_control_field_009",
            "value": "Local Control Field 009",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "local_notes": {
            "key": "local_notes",
            "value": "Local Notes",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_managed_by": {
            "key": "mms_managed_by",
            "value": "Managed By Provider (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "mms_material_type": {
            "key": "mms_material_type",
            "value": "Material Type",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Book",
                    "key": "BK",
                    "groupOrder": 0
                }, {
                    "value": "Computer file",
                    "key": "CF",
                    "groupOrder": 0
                }, {
                    "value": "Journal",
                    "key": "CR",
                    "groupOrder": 0
                }, {
                    "value": "Map",
                    "key": "MP",
                    "groupOrder": 0
                }, {
                    "value": "Mixed material",
                    "key": "MX",
                    "groupOrder": 0
                }, {
                    "value": "Music",
                    "key": "MU",
                    "groupOrder": 0
                }, {
                    "value": "Visual material",
                    "key": "VM",
                    "groupOrder": 0
                }]
        },
        "mms_mdImportModificationHistory": {
            "key": "mms_mdImportModificationHistory",
            "value": "Md Import modification job id",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "media_type_code": {
            "key": "media_type_code",
            "value": "Media Type Code (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "c",
                    "key": "c",
                    "groupOrder": 0
                }, {
                    "value": "e",
                    "key": "e",
                    "groupOrder": 0
                }, {
                    "value": "g",
                    "key": "g",
                    "groupOrder": 0
                }, {
                    "value": "h",
                    "key": "h",
                    "groupOrder": 0
                }, {
                    "value": "n",
                    "key": "n",
                    "groupOrder": 0
                }, {
                    "value": "p",
                    "key": "p",
                    "groupOrder": 0
                }, {
                    "value": "s",
                    "key": "s",
                    "groupOrder": 0
                }, {
                    "value": "v",
                    "key": "v",
                    "groupOrder": 0
                }, {
                    "value": "x",
                    "key": "x",
                    "groupOrder": 0
                }, {
                    "value": "z",
                    "key": "z",
                    "groupOrder": 0
                }]
        },
        "media_type_term": {
            "key": "media_type_term",
            "value": "Media Type Term (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "audio",
                    "key": "audio",
                    "groupOrder": 0
                }, {
                    "value": "computer",
                    "key": "computer",
                    "groupOrder": 0
                }, {
                    "value": "microform",
                    "key": "microform",
                    "groupOrder": 0
                }, {
                    "value": "microscopic",
                    "key": "microscopic",
                    "groupOrder": 0
                }, {
                    "value": "other",
                    "key": "other",
                    "groupOrder": 0
                }, {
                    "value": "projected",
                    "key": "projected",
                    "groupOrder": 0
                }, {
                    "value": "stereographic",
                    "key": "stereographic",
                    "groupOrder": 0
                }, {
                    "value": "unmediated",
                    "key": "unmediated",
                    "groupOrder": 0
                }, {
                    "value": "unspecified",
                    "key": "unspecified",
                    "groupOrder": 0
                }, {
                    "value": "video",
                    "key": "video",
                    "groupOrder": 0
                }]
        },
        "mesh": {
            "key": "mesh",
            "value": "Medical Subjects (MeSH)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "medium_type": {
            "key": "medium_type",
            "value": "Medium Type",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "activity card",
                    "key": "activity card",
                    "groupOrder": 0
                }, {
                    "value": "art original",
                    "key": "art original",
                    "groupOrder": 0
                }, {
                    "value": "art reproduction",
                    "key": "art reproduction",
                    "groupOrder": 0
                }, {
                    "value": "braille",
                    "key": "braille",
                    "groupOrder": 0
                }, {
                    "value": "cartographic material",
                    "key": "cartographic material",
                    "groupOrder": 0
                }, {
                    "value": "chart",
                    "key": "chart",
                    "groupOrder": 0
                }, {
                    "value": "diorama",
                    "key": "diorama",
                    "groupOrder": 0
                }, {
                    "value": "electronic resource",
                    "key": "electronic resource",
                    "groupOrder": 0
                }, {
                    "value": "filmstrip",
                    "key": "filmstrip",
                    "groupOrder": 0
                }, {
                    "value": "flash card",
                    "key": "flash card",
                    "groupOrder": 0
                }, {
                    "value": "game",
                    "key": "game",
                    "groupOrder": 0
                }, {
                    "value": "graphic",
                    "key": "graphic",
                    "groupOrder": 0
                }, {
                    "value": "kit",
                    "key": "kit",
                    "groupOrder": 0
                }, {
                    "value": "large print",
                    "key": "large print",
                    "groupOrder": 0
                }, {
                    "value": "manuscript",
                    "key": "manuscript",
                    "groupOrder": 0
                }, {
                    "value": "microform",
                    "key": "microform",
                    "groupOrder": 0
                }, {
                    "value": "microscope slides",
                    "key": "microscope slides",
                    "groupOrder": 0
                }, {
                    "value": "model",
                    "key": "model",
                    "groupOrder": 0
                }, {
                    "value": "motion picture",
                    "key": "motion picture",
                    "groupOrder": 0
                }, {
                    "value": "music",
                    "key": "music",
                    "groupOrder": 0
                }, {
                    "value": "picture",
                    "key": "picture",
                    "groupOrder": 0
                }, {
                    "value": "realia",
                    "key": "realia",
                    "groupOrder": 0
                }, {
                    "value": "serial",
                    "key": "serial",
                    "groupOrder": 0
                }, {
                    "value": "slide",
                    "key": "slide",
                    "groupOrder": 0
                }, {
                    "value": "sound recording",
                    "key": "sound recording",
                    "groupOrder": 0
                }, {
                    "value": "technical drawing",
                    "key": "technical drawing",
                    "groupOrder": 0
                }, {
                    "value": "text",
                    "key": "text",
                    "groupOrder": 0
                }, {
                    "value": "toy",
                    "key": "toy",
                    "groupOrder": 0
                }, {
                    "value": "transparency",
                    "key": "transparency",
                    "groupOrder": 0
                }, {
                    "value": "videorecording",
                    "key": "videorecording",
                    "groupOrder": 0
                }]
        },
        "mms_createDate": {
            "key": "mms_createDate",
            "value": "MMS Creation Date (Title)",
            "type": "date",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "BEFORE",
                    "op_value": "Before"
                }, {
                    "op_key": "AFTER",
                    "op_value": "After"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_id": {
            "key": "mms_id",
            "value": "MMS ID",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }]
        },
        "mms_sip_id": {
            "key": "mms_sip_id",
            "value": "MMS SIP ID",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_modificationDate": {
            "key": "mms_modificationDate",
            "value": "Modification Date (Title)",
            "type": "date",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "BEFORE",
                    "op_value": "Before"
                }, {
                    "op_key": "AFTER",
                    "op_value": "After"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "nal_call_number": {
            "key": "nal_call_number",
            "value": "NAL Call Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "name": {
            "key": "name",
            "value": "Names",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "national_bibliography_number": {
            "key": "national_bibliography_number",
            "value": "National Bibliography Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "nlm_call_number": {
            "key": "nlm_call_number",
            "value": "NLM-type Call Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "notes": {
            "key": "notes",
            "value": "Notes",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "oclc_control_number_019_a": {
            "key": "oclc_control_number_019_a",
            "value": "OCLC Control Number (019)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "oclc_control_number_035_a": {
            "key": "oclc_control_number_035_a",
            "value": "OCLC Control Number (035a)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "oclc_control_number_035_az": {
            "key": "oclc_control_number_035_az",
            "value": "OCLC Control Number (035a+z)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "oclc_control_number_035_z": {
            "key": "oclc_control_number_035_z",
            "value": "OCLC Control Number (035z)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "open_access": {
            "key": "open_access",
            "value": "Open Access",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "orcid_identifier": {
            "key": "orcid_identifier",
            "value": "ORCID - Open Researcher and Contributor ID",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "orcid_real_world_object_uri": {
            "key": "orcid_real_world_object_uri",
            "value": "ORCID - Real World Object URI",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "original_cataloging_agency": {
            "key": "original_cataloging_agency",
            "value": "Original Cataloging Agency",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_originatingSystem": {
            "key": "mms_originatingSystem",
            "value": "Originating System",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_originatingSystemId": {
            "key": "mms_originatingSystemId",
            "value": "Originating System Id",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "other_class_number": {
            "key": "other_class_number",
            "value": "Other Classification Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "other_physical_details": {
            "key": "other_physical_details",
            "value": "Other Physical Details",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "ismn": {
            "key": "ismn",
            "value": "Other Standard ID",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "other_standard_identifier": {
            "key": "other_standard_identifier",
            "value": "Other Standard Identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "other_system_number": {
            "key": "other_system_number",
            "value": "Other System Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "peer_reviewed": {
            "key": "peer_reviewed",
            "value": "Peer Reviewed",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "category_of_material": {
            "key": "category_of_material",
            "value": "Physical Description",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Electronic resource",
                    "key": "c",
                    "groupOrder": 0
                }, {
                    "value": "Globe",
                    "key": "d",
                    "groupOrder": 0
                }, {
                    "value": "Kit",
                    "key": "o",
                    "groupOrder": 0
                }, {
                    "value": "Map",
                    "key": "a",
                    "groupOrder": 0
                }, {
                    "value": "Microform",
                    "key": "h",
                    "groupOrder": 0
                }, {
                    "value": "Motion picture",
                    "key": "m",
                    "groupOrder": 0
                }, {
                    "value": "Nonprojected graphic",
                    "key": "k",
                    "groupOrder": 0
                }, {
                    "value": "Notated music",
                    "key": "q",
                    "groupOrder": 0
                }, {
                    "value": "Projected graphic",
                    "key": "g",
                    "groupOrder": 0
                }, {
                    "value": "Remote-Sensing Image",
                    "key": "r",
                    "groupOrder": 0
                }, {
                    "value": "Sound recording",
                    "key": "s",
                    "groupOrder": 0
                }, {
                    "value": "Tactile material",
                    "key": "f",
                    "groupOrder": 0
                }, {
                    "value": "Text",
                    "key": "t",
                    "groupOrder": 0
                }, {
                    "value": "Unspecified",
                    "key": "z",
                    "groupOrder": 0
                }, {
                    "value": "Videorecording",
                    "key": "v",
                    "groupOrder": 0
                }]
        },
        "main_pub_date": {
            "key": "main_pub_date",
            "value": "Publication Year",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }]
        },
        "general_note": {
            "key": "general_note",
            "value": "Public Note (Title)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "publisher": {
            "key": "publisher",
            "value": "Publisher",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "publisher_location": {
            "key": "publisher_location",
            "value": "Publisher Location",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "publisher_number": {
            "key": "publisher_number",
            "value": "Publisher Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "real_world_object_uri": {
            "key": "real_world_object_uri",
            "value": "Real World Object URI",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "registry_id": {
            "key": "registry_id",
            "value": "Record Format",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "CNMARC",
                    "key": "9",
                    "groupOrder": 0
                }, {
                    "value": "DC",
                    "key": "2",
                    "groupOrder": 0
                }, {
                    "value": "DCAP01",
                    "key": "2001",
                    "groupOrder": 0
                }, {
                    "value": "DCAP02",
                    "key": "2002",
                    "groupOrder": 0
                }, {
                    "value": "ETD",
                    "key": "2003",
                    "groupOrder": 0
                }, {
                    "value": "KORMARC",
                    "key": "7",
                    "groupOrder": 0
                }, {
                    "value": "LC BF INSTANCE (Under Construction)",
                    "key": "28",
                    "groupOrder": 0
                }, {
                    "value": "MARC21",
                    "key": "3",
                    "groupOrder": 0
                }, {
                    "value": "MODS",
                    "key": "10",
                    "groupOrder": 0
                }, {
                    "value": "UNIMARC",
                    "key": "8",
                    "groupOrder": 0
                }]
        },
        "relator": {
            "key": "relator",
            "value": "Relator",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "mms_resource_type": {
            "key": "mms_resource_type",
            "value": "Resource Type",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "2D non-projectable graphic - Electronic",
                    "key": "2D non-projectable graphic - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "2D non-projectable graphic - Physical",
                    "key": "2D non-projectable graphic - Physical",
                    "groupOrder": 0
                }, {
                    "value": "2D non-projectable graphic – Component Part",
                    "key": "2D non-projectable graphic – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "3D artifact - Digital",
                    "key": "3D artifact - Digital",
                    "groupOrder": 0
                }, {
                    "value": "3D artifact - Physical",
                    "key": "3D artifact - Physical",
                    "groupOrder": 0
                }, {
                    "value": "3D artifact – Component Part",
                    "key": "3D artifact – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Analytic (Component Part)",
                    "key": "Analytic (Component Part)",
                    "groupOrder": 0
                }, {
                    "value": "Atlas - Electronic",
                    "key": "Atlas - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Atlas - Microfiche",
                    "key": "Atlas - Microfiche",
                    "groupOrder": 0
                }, {
                    "value": "Atlas - Microfilm",
                    "key": "Atlas - Microfilm",
                    "groupOrder": 0
                }, {
                    "value": "Atlas - Microopaque",
                    "key": "Atlas - Microopaque",
                    "groupOrder": 0
                }, {
                    "value": "Atlas - Physical",
                    "key": "Atlas - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Audio musical - Electronic",
                    "key": "Audio musical - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Audio musical - Physical",
                    "key": "Audio musical - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Audio nonmusical - Electronic",
                    "key": "Audio nonmusical - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Audio nonmusical - Physical",
                    "key": "Audio nonmusical - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Audio nonmusical – Component Part",
                    "key": "Audio nonmusical – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Book - Digital",
                    "key": "Book - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Book - Electronic",
                    "key": "Book - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Book - Physical",
                    "key": "Book - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Braille Book - Physical",
                    "key": "Braille Book - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Braille Map - Physical",
                    "key": "Braille Map - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Braille Music - Physical",
                    "key": "Braille Music - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Braille Serial - Physical",
                    "key": "Braille Serial - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Collection",
                    "key": "Collection",
                    "groupOrder": 0
                }, {
                    "value": "Computer file - Digital",
                    "key": "Computer file - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Journal (Ceased publication) - Electronic",
                    "key": "Journal (Ceased publication) - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Journal (Ceased publication) - Physical",
                    "key": "Journal (Ceased publication) - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Journal - Digital",
                    "key": "Journal - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Journal - Electronic",
                    "key": "Journal - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Journal - Physical",
                    "key": "Journal - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Kit - Physical",
                    "key": "Kit - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Kit – Component Part",
                    "key": "Kit – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Manuscript – Component Part",
                    "key": "Manuscript – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Manuscripts - Electronic",
                    "key": "Manuscripts - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Manuscripts - Physical",
                    "key": "Manuscripts - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Map - Digital",
                    "key": "Map - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Map - Electronic",
                    "key": "Map - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Map - Microfiche",
                    "key": "Map - Microfiche",
                    "groupOrder": 0
                }, {
                    "value": "Map - Microfilm",
                    "key": "Map - Microfilm",
                    "groupOrder": 0
                }, {
                    "value": "Map - Microopaque",
                    "key": "Map - Microopaque",
                    "groupOrder": 0
                }, {
                    "value": "Map - Physical",
                    "key": "Map - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Map – Component Part",
                    "key": "Map – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Microforms",
                    "key": "Microforms",
                    "groupOrder": 0
                }, {
                    "value": "Mixed material - Digital",
                    "key": "Mixed material - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Mixed materials",
                    "key": "Mixed materials",
                    "groupOrder": 0
                }, {
                    "value": "Monographic component part - Electronic",
                    "key": "Monographic component part - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Monographic component part - Physical",
                    "key": "Monographic component part - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Music - Digital",
                    "key": "Music - Digital",
                    "groupOrder": 0
                }, {
                    "value": "Music – Component Part",
                    "key": "Music – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Newspaper (Ceased publication) - Electronic",
                    "key": "Newspaper (Ceased publication) - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Newspaper (Ceased publication) - Physical",
                    "key": "Newspaper (Ceased publication) - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Newspaper - Electronic",
                    "key": "Newspaper - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Newspaper - Physical",
                    "key": "Newspaper - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Notated music - Electronic",
                    "key": "Notated music - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Notated music - Physical",
                    "key": "Notated music - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Other Serial (Ceased publication) - Electronic",
                    "key": "Other Serial (Ceased publication) - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Other Serial (Ceased publication) - Physical",
                    "key": "Other Serial (Ceased publication) - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Other Serial - Electronic",
                    "key": "Other Serial - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Other Serial - Physical",
                    "key": "Other Serial - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Other material - Electronic",
                    "key": "Other material - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Projected media – Component Part",
                    "key": "Projected media – Component Part",
                    "groupOrder": 0
                }, {
                    "value": "Projected medium - Electronic",
                    "key": "Projected medium - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Projected medium - Physical",
                    "key": "Projected medium - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Serial component part - Electronic",
                    "key": "Serial component part - Electronic",
                    "groupOrder": 0
                }, {
                    "value": "Serial component part - Physical",
                    "key": "Serial component part - Physical",
                    "groupOrder": 0
                }, {
                    "value": "Undefined",
                    "key": "Undefined",
                    "groupOrder": 0
                }, {
                    "value": "Visual material - Digital",
                    "key": "Visual material - Digital",
                    "groupOrder": 0
                }]
        },
        "stored_standard_number_024_a_ind1_4": {
            "key": "stored_standard_number_024_a_ind1_4",
            "value": "Serial Item and Contribution Identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "unique_serial_title": {
            "key": "unique_serial_title",
            "value": "Serial Title",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "series": {
            "key": "series",
            "value": "Series",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "shelving_location": {
            "key": "shelving_location",
            "value": "Shelving Location",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "source_record_id": {
            "key": "source_record_id",
            "value": "Source Record Id",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "standard_number": {
            "key": "standard_number",
            "value": "Standard Number",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "standard_number_source": {
            "key": "standard_number_source",
            "value": "Standard Number Source",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "subject_category_code": {
            "key": "subject_category_code",
            "value": "Subject Category Code",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "subjects": {
            "key": "subjects",
            "value": "Subjects",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lcsh": {
            "key": "lcsh",
            "value": "Subjects (LC)",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "sublocation": {
            "key": "sublocation",
            "value": "Sublocation",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "mms_tagSuppressed": {
            "key": "mms_tagSuppressed",
            "value": "Tag Suppressed (Title)",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "mms_tagSuppressedExternalSearch": {
            "key": "mms_tagSuppressedExternalSearch",
            "value": "Tag Suppressed From External Search",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "mms_tagSyncExternalCatalog": {
            "key": "mms_tagSyncExternalCatalog",
            "value": "Tag Sync External Catalog",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Don't publish",
                    "key": "NONE",
                    "groupOrder": 0
                }, {
                    "value": "Publish Bibliographic records",
                    "key": "BIBS",
                    "groupOrder": 0
                }, {
                    "value": "Publish holdings only",
                    "key": "HOLDINGS",
                    "groupOrder": 0
                }]
        },
        "mms_tagSyncNationalCatalog": {
            "key": "mms_tagSyncNationalCatalog",
            "value": "Tag Sync National Catalog",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Don't publish",
                    "key": "NONE",
                    "groupOrder": 0
                }, {
                    "value": "Publish Bibliographic records",
                    "key": "BIBS",
                    "groupOrder": 0
                }]
        },
        "title": {
            "key": "title",
            "value": "Title",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "title_committed_to_retain": {
            "key": "title_committed_to_retain",
            "value": "Title committed to retain",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }],
            "options": [{
                    "value": "No",
                    "key": "false",
                    "groupOrder": 0
                }, {
                    "value": "Yes",
                    "key": "true",
                    "groupOrder": 0
                }]
        },
        "universal_decimal_class_number": {
            "key": "universal_decimal_class_number",
            "value": "UDC",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "GREATER_THAN",
                    "op_value": ">"
                }, {
                    "op_key": "GREATER_EQUAL",
                    "op_value": ">="
                }, {
                    "op_key": "LESS_THAN",
                    "op_value": "<"
                }, {
                    "op_key": "LESS_EQUAL",
                    "op_value": "<="
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "CONTAINS_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Contains exact phrase starting with"
                }]
        },
        "uniform_title": {
            "key": "uniform_title",
            "value": "Uniform Title",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "stored_standard_number_024_a_ind1_1": {
            "key": "stored_standard_number_024_a_ind1_1",
            "value": "Universal Product Code",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }]
        },
        "local_field_980": {
            "key": "local_field_980",
            "value": "Vendor EOD",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_contributor": {
            "key": "dc_contributor",
            "value": "dc:contributor",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_coverage": {
            "key": "dc_coverage",
            "value": "dc:coverage",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_creator": {
            "key": "dc_creator",
            "value": "dc:creator",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_date": {
            "key": "dc_date",
            "value": "dc:date",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_description": {
            "key": "dc_description",
            "value": "dc:description",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_format": {
            "key": "dc_format",
            "value": "dc:format",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "identifier": {
            "key": "identifier",
            "value": "dc:identifier",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_language": {
            "key": "dc_language",
            "value": "dc:language",
            "type": "category",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }],
            "options": [{
                    "value": "Abkhaz",
                    "key": "abk",
                    "groupOrder": 0
                }, {
                    "value": "Achinese",
                    "key": "ace",
                    "groupOrder": 0
                }, {
                    "value": "Acoli",
                    "key": "ach",
                    "groupOrder": 0
                }, {
                    "value": "Adangme",
                    "key": "ada",
                    "groupOrder": 0
                }, {
                    "value": "Adygei",
                    "key": "ady",
                    "groupOrder": 0
                }, {
                    "value": "Afar",
                    "key": "aar",
                    "groupOrder": 0
                }, {
                    "value": "Afrihili (Artificial language)",
                    "key": "afh",
                    "groupOrder": 0
                }, {
                    "value": "Afrikaans",
                    "key": "afr",
                    "groupOrder": 0
                }, {
                    "value": "Afroasiatic (Other)",
                    "key": "afa",
                    "groupOrder": 0
                }, {
                    "value": "Ainu",
                    "key": "ain",
                    "groupOrder": 0
                }, {
                    "value": "Akan",
                    "key": "aka",
                    "groupOrder": 0
                }, {
                    "value": "Akkadian",
                    "key": "akk",
                    "groupOrder": 0
                }, {
                    "value": "Albanian",
                    "key": "alb",
                    "groupOrder": 0
                }, {
                    "value": "Aleut",
                    "key": "ale",
                    "groupOrder": 0
                }, {
                    "value": "Algonquian (Other)",
                    "key": "alg",
                    "groupOrder": 0
                }, {
                    "value": "Aljamía (Old Code)",
                    "key": "ajm",
                    "groupOrder": 0
                }, {
                    "value": "Altai",
                    "key": "alt",
                    "groupOrder": 0
                }, {
                    "value": "Altaic (Other)",
                    "key": "tut",
                    "groupOrder": 0
                }, {
                    "value": "Amharic",
                    "key": "amh",
                    "groupOrder": 0
                }, {
                    "value": "Angika",
                    "key": "anp",
                    "groupOrder": 0
                }, {
                    "value": "Apache languages",
                    "key": "apa",
                    "groupOrder": 0
                }, {
                    "value": "Arabic",
                    "key": "ara",
                    "groupOrder": 0
                }, {
                    "value": "Aragonese",
                    "key": "arg",
                    "groupOrder": 0
                }, {
                    "value": "Aramaic",
                    "key": "arc",
                    "groupOrder": 0
                }, {
                    "value": "Arapaho",
                    "key": "arp",
                    "groupOrder": 0
                }, {
                    "value": "Arawak",
                    "key": "arw",
                    "groupOrder": 0
                }, {
                    "value": "Armenian",
                    "key": "arm",
                    "groupOrder": 0
                }, {
                    "value": "Aromanian",
                    "key": "rup",
                    "groupOrder": 0
                }, {
                    "value": "Artificial (Other)",
                    "key": "art",
                    "groupOrder": 0
                }, {
                    "value": "Assamese",
                    "key": "asm",
                    "groupOrder": 0
                }, {
                    "value": "Athapascan (Other)",
                    "key": "ath",
                    "groupOrder": 0
                }, {
                    "value": "Australian languages",
                    "key": "aus",
                    "groupOrder": 0
                }, {
                    "value": "Austronesian (Other)",
                    "key": "map",
                    "groupOrder": 0
                }, {
                    "value": "Avaric",
                    "key": "ava",
                    "groupOrder": 0
                }, {
                    "value": "Avestan",
                    "key": "ave",
                    "groupOrder": 0
                }, {
                    "value": "Awadhi",
                    "key": "awa",
                    "groupOrder": 0
                }, {
                    "value": "Aymara",
                    "key": "aym",
                    "groupOrder": 0
                }, {
                    "value": "Azerbaijani",
                    "key": "aze",
                    "groupOrder": 0
                }, {
                    "value": "Bable",
                    "key": "ast",
                    "groupOrder": 0
                }, {
                    "value": "Balinese",
                    "key": "ban",
                    "groupOrder": 0
                }, {
                    "value": "Baltic (Other)",
                    "key": "bat",
                    "groupOrder": 0
                }, {
                    "value": "Baluchi",
                    "key": "bal",
                    "groupOrder": 0
                }, {
                    "value": "Bambara",
                    "key": "bam",
                    "groupOrder": 0
                }, {
                    "value": "Bamileke languages",
                    "key": "bai",
                    "groupOrder": 0
                }, {
                    "value": "Banda languages",
                    "key": "bad",
                    "groupOrder": 0
                }, {
                    "value": "Bantu (Other)",
                    "key": "bnt",
                    "groupOrder": 0
                }, {
                    "value": "Basa",
                    "key": "bas",
                    "groupOrder": 0
                }, {
                    "value": "Bashkir",
                    "key": "bak",
                    "groupOrder": 0
                }, {
                    "value": "Basque",
                    "key": "baq",
                    "groupOrder": 0
                }, {
                    "value": "Batak",
                    "key": "btk",
                    "groupOrder": 0
                }, {
                    "value": "Beja",
                    "key": "bej",
                    "groupOrder": 0
                }, {
                    "value": "Belarusian",
                    "key": "bel",
                    "groupOrder": 0
                }, {
                    "value": "Bemba",
                    "key": "bem",
                    "groupOrder": 0
                }, {
                    "value": "Bengali",
                    "key": "ben",
                    "groupOrder": 0
                }, {
                    "value": "Berber (Other)",
                    "key": "ber",
                    "groupOrder": 0
                }, {
                    "value": "Bhojpuri",
                    "key": "bho",
                    "groupOrder": 0
                }, {
                    "value": "Bihari",
                    "key": "bih",
                    "groupOrder": 0
                }, {
                    "value": "Bikol",
                    "key": "bik",
                    "groupOrder": 0
                }, {
                    "value": "Bilin",
                    "key": "byn",
                    "groupOrder": 0
                }, {
                    "value": "Bislama",
                    "key": "bis",
                    "groupOrder": 0
                }, {
                    "value": "Blissymbolics",
                    "key": "zbl",
                    "groupOrder": 0
                }, {
                    "value": "Bosnian",
                    "key": "bos",
                    "groupOrder": 0
                }, {
                    "value": "Braj",
                    "key": "bra",
                    "groupOrder": 0
                }, {
                    "value": "Breton",
                    "key": "bre",
                    "groupOrder": 0
                }, {
                    "value": "Bugis",
                    "key": "bug",
                    "groupOrder": 0
                }, {
                    "value": "Bulgarian",
                    "key": "bul",
                    "groupOrder": 0
                }, {
                    "value": "Buriat",
                    "key": "bua",
                    "groupOrder": 0
                }, {
                    "value": "Burmese",
                    "key": "bur",
                    "groupOrder": 0
                }, {
                    "value": "Caddo",
                    "key": "cad",
                    "groupOrder": 0
                }, {
                    "value": "Carib",
                    "key": "car",
                    "groupOrder": 0
                }, {
                    "value": "Catalan",
                    "key": "cat",
                    "groupOrder": 0
                }, {
                    "value": "Caucasian (Other)",
                    "key": "cau",
                    "groupOrder": 0
                }, {
                    "value": "Cebuano",
                    "key": "ceb",
                    "groupOrder": 0
                }, {
                    "value": "Celtic (Other)",
                    "key": "cel",
                    "groupOrder": 0
                }, {
                    "value": "Central American Indian (Other)",
                    "key": "cai",
                    "groupOrder": 0
                }, {
                    "value": "Chagatai",
                    "key": "chg",
                    "groupOrder": 0
                }, {
                    "value": "Chamic languages",
                    "key": "cmc",
                    "groupOrder": 0
                }, {
                    "value": "Chamorro",
                    "key": "cha",
                    "groupOrder": 0
                }, {
                    "value": "Chechen",
                    "key": "che",
                    "groupOrder": 0
                }, {
                    "value": "Cherokee",
                    "key": "chr",
                    "groupOrder": 0
                }, {
                    "value": "Cheyenne",
                    "key": "chy",
                    "groupOrder": 0
                }, {
                    "value": "Chibcha",
                    "key": "chb",
                    "groupOrder": 0
                }, {
                    "value": "Chinese",
                    "key": "chi",
                    "groupOrder": 0
                }, {
                    "value": "Chinook jargon",
                    "key": "chn",
                    "groupOrder": 0
                }, {
                    "value": "Chipewyan",
                    "key": "chp",
                    "groupOrder": 0
                }, {
                    "value": "Choctaw",
                    "key": "cho",
                    "groupOrder": 0
                }, {
                    "value": "Church Slavic",
                    "key": "chu",
                    "groupOrder": 0
                }, {
                    "value": "Chuukese",
                    "key": "chk",
                    "groupOrder": 0
                }, {
                    "value": "Chuvash",
                    "key": "chv",
                    "groupOrder": 0
                }, {
                    "value": "Coptic",
                    "key": "cop",
                    "groupOrder": 0
                }, {
                    "value": "Cornish",
                    "key": "cor",
                    "groupOrder": 0
                }, {
                    "value": "Corsican",
                    "key": "cos",
                    "groupOrder": 0
                }, {
                    "value": "Cree",
                    "key": "cre",
                    "groupOrder": 0
                }, {
                    "value": "Creek",
                    "key": "mus",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins (Other)",
                    "key": "crp",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, English-based (Other)",
                    "key": "cpe",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, French-based (Other)",
                    "key": "cpf",
                    "groupOrder": 0
                }, {
                    "value": "Creoles and Pidgins, Portuguese-based (Other)",
                    "key": "cpp",
                    "groupOrder": 0
                }, {
                    "value": "Crimean Tatar",
                    "key": "crh",
                    "groupOrder": 0
                }, {
                    "value": "Croatian",
                    "key": "hrv",
                    "groupOrder": 0
                }, {
                    "value": "Croatian (Old Code)",
                    "key": "scr",
                    "groupOrder": 0
                }, {
                    "value": "Cushitic (Other)",
                    "key": "cus",
                    "groupOrder": 0
                }, {
                    "value": "Czech",
                    "key": "cze",
                    "groupOrder": 0
                }, {
                    "value": "Dakota",
                    "key": "dak",
                    "groupOrder": 0
                }, {
                    "value": "Danish",
                    "key": "dan",
                    "groupOrder": 0
                }, {
                    "value": "Dargwa",
                    "key": "dar",
                    "groupOrder": 0
                }, {
                    "value": "Dayak",
                    "key": "day",
                    "groupOrder": 0
                }, {
                    "value": "Delaware",
                    "key": "del",
                    "groupOrder": 0
                }, {
                    "value": "Dinka",
                    "key": "din",
                    "groupOrder": 0
                }, {
                    "value": "Divehi",
                    "key": "div",
                    "groupOrder": 0
                }, {
                    "value": "Dogri",
                    "key": "doi",
                    "groupOrder": 0
                }, {
                    "value": "Dogrib",
                    "key": "dgr",
                    "groupOrder": 0
                }, {
                    "value": "Dravidian (Other)",
                    "key": "dra",
                    "groupOrder": 0
                }, {
                    "value": "Duala",
                    "key": "dua",
                    "groupOrder": 0
                }, {
                    "value": "Dutch",
                    "key": "dut",
                    "groupOrder": 0
                }, {
                    "value": "Dutch, Middle (ca. 1050-1350)",
                    "key": "dum",
                    "groupOrder": 0
                }, {
                    "value": "Dyula",
                    "key": "dyu",
                    "groupOrder": 0
                }, {
                    "value": "Dzongkha",
                    "key": "dzo",
                    "groupOrder": 0
                }, {
                    "value": "East Frisian",
                    "key": "frs",
                    "groupOrder": 0
                }, {
                    "value": "Edo",
                    "key": "bin",
                    "groupOrder": 0
                }, {
                    "value": "Efik",
                    "key": "efi",
                    "groupOrder": 0
                }, {
                    "value": "Egyptian",
                    "key": "egy",
                    "groupOrder": 0
                }, {
                    "value": "Ekajuk",
                    "key": "eka",
                    "groupOrder": 0
                }, {
                    "value": "Elamite",
                    "key": "elx",
                    "groupOrder": 0
                }, {
                    "value": "English",
                    "key": "eng",
                    "groupOrder": 0
                }, {
                    "value": "English, Middle (1100-1500)",
                    "key": "enm",
                    "groupOrder": 0
                }, {
                    "value": "English, Old (ca. 450-1100)",
                    "key": "ang",
                    "groupOrder": 0
                }, {
                    "value": "Erzya",
                    "key": "myv",
                    "groupOrder": 0
                }, {
                    "value": "Eskimo languages (Old Code)",
                    "key": "esk",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto",
                    "key": "epo",
                    "groupOrder": 0
                }, {
                    "value": "Esperanto (Old Code)",
                    "key": "esp",
                    "groupOrder": 0
                }, {
                    "value": "Estonian",
                    "key": "est",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic",
                    "key": "gez",
                    "groupOrder": 0
                }, {
                    "value": "Ethiopic (Old Code)",
                    "key": "eth",
                    "groupOrder": 0
                }, {
                    "value": "Ewe",
                    "key": "ewe",
                    "groupOrder": 0
                }, {
                    "value": "Ewondo",
                    "key": "ewo",
                    "groupOrder": 0
                }, {
                    "value": "Fang",
                    "key": "fan",
                    "groupOrder": 0
                }, {
                    "value": "Fanti",
                    "key": "fat",
                    "groupOrder": 0
                }, {
                    "value": "Faroese",
                    "key": "fao",
                    "groupOrder": 0
                }, {
                    "value": "Faroese (Old Code)",
                    "key": "far",
                    "groupOrder": 0
                }, {
                    "value": "Fijian",
                    "key": "fij",
                    "groupOrder": 0
                }, {
                    "value": "Filipino",
                    "key": "fil",
                    "groupOrder": 0
                }, {
                    "value": "Finnish",
                    "key": "fin",
                    "groupOrder": 0
                }, {
                    "value": "Finno-Ugrian (Other)",
                    "key": "fiu",
                    "groupOrder": 0
                }, {
                    "value": "Fon",
                    "key": "fon",
                    "groupOrder": 0
                }, {
                    "value": "French",
                    "key": "fre",
                    "groupOrder": 0
                }, {
                    "value": "French, Middle (ca. 1300-1600)",
                    "key": "frm",
                    "groupOrder": 0
                }, {
                    "value": "French, Old (ca. 842-1300)",
                    "key": "fro",
                    "groupOrder": 0
                }, {
                    "value": "Frisian",
                    "key": "fry",
                    "groupOrder": 0
                }, {
                    "value": "Frisian (Old Code)",
                    "key": "fri",
                    "groupOrder": 0
                }, {
                    "value": "Friulian",
                    "key": "fur",
                    "groupOrder": 0
                }, {
                    "value": "Fula",
                    "key": "ful",
                    "groupOrder": 0
                }, {
                    "value": "Galician",
                    "key": "glg",
                    "groupOrder": 0
                }, {
                    "value": "Galician (Old Code)",
                    "key": "gag",
                    "groupOrder": 0
                }, {
                    "value": "Ganda",
                    "key": "lug",
                    "groupOrder": 0
                }, {
                    "value": "Gayo",
                    "key": "gay",
                    "groupOrder": 0
                }, {
                    "value": "Gbaya",
                    "key": "gba",
                    "groupOrder": 0
                }, {
                    "value": "Georgian",
                    "key": "geo",
                    "groupOrder": 0
                }, {
                    "value": "German",
                    "key": "ger",
                    "groupOrder": 0
                }, {
                    "value": "German, Middle High (ca. 1050-1500)",
                    "key": "gmh",
                    "groupOrder": 0
                }, {
                    "value": "German, Old High (ca. 750-1050)",
                    "key": "goh",
                    "groupOrder": 0
                }, {
                    "value": "Germanic (Other)",
                    "key": "gem",
                    "groupOrder": 0
                }, {
                    "value": "Gilbertese",
                    "key": "gil",
                    "groupOrder": 0
                }, {
                    "value": "Gondi",
                    "key": "gon",
                    "groupOrder": 0
                }, {
                    "value": "Gorontalo",
                    "key": "gor",
                    "groupOrder": 0
                }, {
                    "value": "Gothic",
                    "key": "got",
                    "groupOrder": 0
                }, {
                    "value": "Grebo",
                    "key": "grb",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Ancient (to 1453)",
                    "key": "grc",
                    "groupOrder": 0
                }, {
                    "value": "Greek, Modern (1453- )",
                    "key": "gre",
                    "groupOrder": 0
                }, {
                    "value": "Guarani",
                    "key": "grn",
                    "groupOrder": 0
                }, {
                    "value": "Guarani (Old Code)",
                    "key": "gua",
                    "groupOrder": 0
                }, {
                    "value": "Gujarati",
                    "key": "guj",
                    "groupOrder": 0
                }, {
                    "value": "Gwich'in",
                    "key": "gwi",
                    "groupOrder": 0
                }, {
                    "value": "Gã",
                    "key": "gaa",
                    "groupOrder": 0
                }, {
                    "value": "Haida",
                    "key": "hai",
                    "groupOrder": 0
                }, {
                    "value": "Haitian French Creole",
                    "key": "hat",
                    "groupOrder": 0
                }, {
                    "value": "Hausa",
                    "key": "hau",
                    "groupOrder": 0
                }, {
                    "value": "Hawaiian",
                    "key": "haw",
                    "groupOrder": 0
                }, {
                    "value": "Hebrew",
                    "key": "heb",
                    "groupOrder": 0
                }, {
                    "value": "Herero",
                    "key": "her",
                    "groupOrder": 0
                }, {
                    "value": "Hiligaynon",
                    "key": "hil",
                    "groupOrder": 0
                }, {
                    "value": "Hindi",
                    "key": "hin",
                    "groupOrder": 0
                }, {
                    "value": "Hiri Motu",
                    "key": "hmo",
                    "groupOrder": 0
                }, {
                    "value": "Hittite",
                    "key": "hit",
                    "groupOrder": 0
                }, {
                    "value": "Hmong",
                    "key": "hmn",
                    "groupOrder": 0
                }, {
                    "value": "Hungarian",
                    "key": "hun",
                    "groupOrder": 0
                }, {
                    "value": "Hupa",
                    "key": "hup",
                    "groupOrder": 0
                }, {
                    "value": "Iban",
                    "key": "iba",
                    "groupOrder": 0
                }, {
                    "value": "Icelandic",
                    "key": "ice",
                    "groupOrder": 0
                }, {
                    "value": "Ido",
                    "key": "ido",
                    "groupOrder": 0
                }, {
                    "value": "Igbo",
                    "key": "ibo",
                    "groupOrder": 0
                }, {
                    "value": "Ijo",
                    "key": "ijo",
                    "groupOrder": 0
                }, {
                    "value": "Iloko",
                    "key": "ilo",
                    "groupOrder": 0
                }, {
                    "value": "Inari Sami",
                    "key": "smn",
                    "groupOrder": 0
                }, {
                    "value": "Indic (Other)",
                    "key": "inc",
                    "groupOrder": 0
                }, {
                    "value": "Indo-European (Other)",
                    "key": "ine",
                    "groupOrder": 0
                }, {
                    "value": "Indonesian",
                    "key": "ind",
                    "groupOrder": 0
                }, {
                    "value": "Ingush",
                    "key": "inh",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association)",
                    "key": "ina",
                    "groupOrder": 0
                }, {
                    "value": "Interlingua (International Auxiliary Language Association) (Old Code)",
                    "key": "int",
                    "groupOrder": 0
                }, {
                    "value": "Interlingue",
                    "key": "ile",
                    "groupOrder": 0
                }, {
                    "value": "Inuktitut",
                    "key": "iku",
                    "groupOrder": 0
                }, {
                    "value": "Inupiaq",
                    "key": "ipk",
                    "groupOrder": 0
                }, {
                    "value": "Iranian (Other)",
                    "key": "ira",
                    "groupOrder": 0
                }, {
                    "value": "Irish",
                    "key": "gle",
                    "groupOrder": 0
                }, {
                    "value": "Irish (Old Code)",
                    "key": "iri",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Middle (ca. 1100-1550)",
                    "key": "mga",
                    "groupOrder": 0
                }, {
                    "value": "Irish, Old (to 1100)",
                    "key": "sga",
                    "groupOrder": 0
                }, {
                    "value": "Iroquoian (Other)",
                    "key": "iro",
                    "groupOrder": 0
                }, {
                    "value": "Italian",
                    "key": "ita",
                    "groupOrder": 0
                }, {
                    "value": "Japanese",
                    "key": "jpn",
                    "groupOrder": 0
                }, {
                    "value": "Javanese",
                    "key": "jav",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Arabic",
                    "key": "jrb",
                    "groupOrder": 0
                }, {
                    "value": "Judeo-Persian",
                    "key": "jpr",
                    "groupOrder": 0
                }, {
                    "value": "Kabardian",
                    "key": "kbd",
                    "groupOrder": 0
                }, {
                    "value": "Kabyle",
                    "key": "kab",
                    "groupOrder": 0
                }, {
                    "value": "Kachin",
                    "key": "kac",
                    "groupOrder": 0
                }, {
                    "value": "Kalâtdlisut",
                    "key": "kal",
                    "groupOrder": 0
                }, {
                    "value": "Kamba",
                    "key": "kam",
                    "groupOrder": 0
                }, {
                    "value": "Kannada",
                    "key": "kan",
                    "groupOrder": 0
                }, {
                    "value": "Kanuri",
                    "key": "kau",
                    "groupOrder": 0
                }, {
                    "value": "Kara-Kalpak",
                    "key": "kaa",
                    "groupOrder": 0
                }, {
                    "value": "Karachay-Balkar",
                    "key": "krc",
                    "groupOrder": 0
                }, {
                    "value": "Karelian",
                    "key": "krl",
                    "groupOrder": 0
                }, {
                    "value": "Karen languages",
                    "key": "kar",
                    "groupOrder": 0
                }, {
                    "value": "Kashmiri",
                    "key": "kas",
                    "groupOrder": 0
                }, {
                    "value": "Kashubian",
                    "key": "csb",
                    "groupOrder": 0
                }, {
                    "value": "Kawi",
                    "key": "kaw",
                    "groupOrder": 0
                }, {
                    "value": "Kazakh",
                    "key": "kaz",
                    "groupOrder": 0
                }, {
                    "value": "Khasi",
                    "key": "kha",
                    "groupOrder": 0
                }, {
                    "value": "Khmer",
                    "key": "khm",
                    "groupOrder": 0
                }, {
                    "value": "Khmer (Old Code)",
                    "key": "cam",
                    "groupOrder": 0
                }, {
                    "value": "Khoisan (Other)",
                    "key": "khi",
                    "groupOrder": 0
                }, {
                    "value": "Khotanese",
                    "key": "kho",
                    "groupOrder": 0
                }, {
                    "value": "Kikuyu",
                    "key": "kik",
                    "groupOrder": 0
                }, {
                    "value": "Kimbundu",
                    "key": "kmb",
                    "groupOrder": 0
                }, {
                    "value": "Kinyarwanda",
                    "key": "kin",
                    "groupOrder": 0
                }, {
                    "value": "Klingon (Artificial language)",
                    "key": "tlh",
                    "groupOrder": 0
                }, {
                    "value": "Komi",
                    "key": "kom",
                    "groupOrder": 0
                }, {
                    "value": "Kongo",
                    "key": "kon",
                    "groupOrder": 0
                }, {
                    "value": "Konkani",
                    "key": "kok",
                    "groupOrder": 0
                }, {
                    "value": "Kootenai",
                    "key": "kut",
                    "groupOrder": 0
                }, {
                    "value": "Korean",
                    "key": "kor",
                    "groupOrder": 0
                }, {
                    "value": "Kpelle",
                    "key": "kpe",
                    "groupOrder": 0
                }, {
                    "value": "Kru (Other)",
                    "key": "kro",
                    "groupOrder": 0
                }, {
                    "value": "Kuanyama",
                    "key": "kua",
                    "groupOrder": 0
                }, {
                    "value": "Kumyk",
                    "key": "kum",
                    "groupOrder": 0
                }, {
                    "value": "Kurdish",
                    "key": "kur",
                    "groupOrder": 0
                }, {
                    "value": "Kurukh",
                    "key": "kru",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie",
                    "key": "kos",
                    "groupOrder": 0
                }, {
                    "value": "Kusaie (Old Code)",
                    "key": "kus",
                    "groupOrder": 0
                }, {
                    "value": "Kyrgyz",
                    "key": "kir",
                    "groupOrder": 0
                }, {
                    "value": "Ladino",
                    "key": "lad",
                    "groupOrder": 0
                }, {
                    "value": "Lahnda",
                    "key": "lah",
                    "groupOrder": 0
                }, {
                    "value": "Lamba (Zambia and Congo)",
                    "key": "lam",
                    "groupOrder": 0
                }, {
                    "value": "Lao",
                    "key": "lao",
                    "groupOrder": 0
                }, {
                    "value": "Latin",
                    "key": "lat",
                    "groupOrder": 0
                }, {
                    "value": "Latvian",
                    "key": "lav",
                    "groupOrder": 0
                }, {
                    "value": "Lezgian",
                    "key": "lez",
                    "groupOrder": 0
                }, {
                    "value": "Limburgish",
                    "key": "lim",
                    "groupOrder": 0
                }, {
                    "value": "Lingala",
                    "key": "lin",
                    "groupOrder": 0
                }, {
                    "value": "Lithuanian",
                    "key": "lit",
                    "groupOrder": 0
                }, {
                    "value": "Lojban (Artificial language)",
                    "key": "jbo",
                    "groupOrder": 0
                }, {
                    "value": "Low German",
                    "key": "nds",
                    "groupOrder": 0
                }, {
                    "value": "Lower Sorbian",
                    "key": "dsb",
                    "groupOrder": 0
                }, {
                    "value": "Lozi",
                    "key": "loz",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Katanga",
                    "key": "lub",
                    "groupOrder": 0
                }, {
                    "value": "Luba-Lulua",
                    "key": "lua",
                    "groupOrder": 0
                }, {
                    "value": "Luiseño",
                    "key": "lui",
                    "groupOrder": 0
                }, {
                    "value": "Lule Sami",
                    "key": "smj",
                    "groupOrder": 0
                }, {
                    "value": "Lunda",
                    "key": "lun",
                    "groupOrder": 0
                }, {
                    "value": "Luo (Kenya and Tanzania)",
                    "key": "luo",
                    "groupOrder": 0
                }, {
                    "value": "Lushai",
                    "key": "lus",
                    "groupOrder": 0
                }, {
                    "value": "Luxembourgish",
                    "key": "ltz",
                    "groupOrder": 0
                }, {
                    "value": "Macedonian",
                    "key": "mac",
                    "groupOrder": 0
                }, {
                    "value": "Madurese",
                    "key": "mad",
                    "groupOrder": 0
                }, {
                    "value": "Magahi",
                    "key": "mag",
                    "groupOrder": 0
                }, {
                    "value": "Maithili",
                    "key": "mai",
                    "groupOrder": 0
                }, {
                    "value": "Makasar",
                    "key": "mak",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy",
                    "key": "mlg",
                    "groupOrder": 0
                }, {
                    "value": "Malagasy (Old Code)",
                    "key": "mla",
                    "groupOrder": 0
                }, {
                    "value": "Malay",
                    "key": "may",
                    "groupOrder": 0
                }, {
                    "value": "Malayalam",
                    "key": "mal",
                    "groupOrder": 0
                }, {
                    "value": "Maltese",
                    "key": "mlt",
                    "groupOrder": 0
                }, {
                    "value": "Manchu",
                    "key": "mnc",
                    "groupOrder": 0
                }, {
                    "value": "Mandar",
                    "key": "mdr",
                    "groupOrder": 0
                }, {
                    "value": "Mandingo",
                    "key": "man",
                    "groupOrder": 0
                }, {
                    "value": "Manipuri",
                    "key": "mni",
                    "groupOrder": 0
                }, {
                    "value": "Manobo languages",
                    "key": "mno",
                    "groupOrder": 0
                }, {
                    "value": "Manx",
                    "key": "glv",
                    "groupOrder": 0
                }, {
                    "value": "Manx (Old Code)",
                    "key": "max",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mao",
                    "groupOrder": 0
                }, {
                    "value": "Maori",
                    "key": "mri",
                    "groupOrder": 0
                }, {
                    "value": "Mapuche",
                    "key": "arn",
                    "groupOrder": 0
                }, {
                    "value": "Marathi",
                    "key": "mar",
                    "groupOrder": 0
                }, {
                    "value": "Mari",
                    "key": "chm",
                    "groupOrder": 0
                }, {
                    "value": "Marshallese",
                    "key": "mah",
                    "groupOrder": 0
                }, {
                    "value": "Marwari",
                    "key": "mwr",
                    "groupOrder": 0
                }, {
                    "value": "Masai",
                    "key": "mas",
                    "groupOrder": 0
                }, {
                    "value": "Mayan languages",
                    "key": "myn",
                    "groupOrder": 0
                }, {
                    "value": "Mende",
                    "key": "men",
                    "groupOrder": 0
                }, {
                    "value": "Micmac",
                    "key": "mic",
                    "groupOrder": 0
                }, {
                    "value": "Minangkabau",
                    "key": "min",
                    "groupOrder": 0
                }, {
                    "value": "Mirandese",
                    "key": "mwl",
                    "groupOrder": 0
                }, {
                    "value": "Miscellaneous languages",
                    "key": "mis",
                    "groupOrder": 0
                }, {
                    "value": "Mohawk",
                    "key": "moh",
                    "groupOrder": 0
                }, {
                    "value": "Moksha",
                    "key": "mdf",
                    "groupOrder": 0
                }, {
                    "value": "Moldavian (Old Code)",
                    "key": "mol",
                    "groupOrder": 0
                }, {
                    "value": "Mon-Khmer (Other)",
                    "key": "mkh",
                    "groupOrder": 0
                }, {
                    "value": "Mongo-Nkundu",
                    "key": "lol",
                    "groupOrder": 0
                }, {
                    "value": "Mongolian",
                    "key": "mon",
                    "groupOrder": 0
                }, {
                    "value": "Montenegrin",
                    "key": "cnr",
                    "groupOrder": 0
                }, {
                    "value": "Mooré",
                    "key": "mos",
                    "groupOrder": 0
                }, {
                    "value": "Multiple languages",
                    "key": "mul",
                    "groupOrder": 0
                }, {
                    "value": "Munda (Other)",
                    "key": "mun",
                    "groupOrder": 0
                }, {
                    "value": "N'Ko",
                    "key": "nqo",
                    "groupOrder": 0
                }, {
                    "value": "Nahuatl",
                    "key": "nah",
                    "groupOrder": 0
                }, {
                    "value": "Nauru",
                    "key": "nau",
                    "groupOrder": 0
                }, {
                    "value": "Navajo",
                    "key": "nav",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (South Africa)",
                    "key": "nbl",
                    "groupOrder": 0
                }, {
                    "value": "Ndebele (Zimbabwe)",
                    "key": "nde",
                    "groupOrder": 0
                }, {
                    "value": "Ndonga",
                    "key": "ndo",
                    "groupOrder": 0
                }, {
                    "value": "Neapolitan Italian",
                    "key": "nap",
                    "groupOrder": 0
                }, {
                    "value": "Nepali",
                    "key": "nep",
                    "groupOrder": 0
                }, {
                    "value": "Newari",
                    "key": "new",
                    "groupOrder": 0
                }, {
                    "value": "Newari, Old",
                    "key": "nwc",
                    "groupOrder": 0
                }, {
                    "value": "Nias",
                    "key": "nia",
                    "groupOrder": 0
                }, {
                    "value": "Niger-Kordofanian (Other)",
                    "key": "nic",
                    "groupOrder": 0
                }, {
                    "value": "Nilo-Saharan (Other)",
                    "key": "ssa",
                    "groupOrder": 0
                }, {
                    "value": "Niuean",
                    "key": "niu",
                    "groupOrder": 0
                }, {
                    "value": "No information provided",
                    "key": "   ",
                    "groupOrder": 0
                }, {
                    "value": "No linguistic content",
                    "key": "zxx",
                    "groupOrder": 0
                }, {
                    "value": "Nogai",
                    "key": "nog",
                    "groupOrder": 0
                }, {
                    "value": "None of the above",
                    "key": "|||",
                    "groupOrder": 0
                }, {
                    "value": "North American Indian (Other)",
                    "key": "nai",
                    "groupOrder": 0
                }, {
                    "value": "North Frisian",
                    "key": "frr",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sami",
                    "key": "sme",
                    "groupOrder": 0
                }, {
                    "value": "Northern Sotho",
                    "key": "nso",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian",
                    "key": "nor",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Bokmål)",
                    "key": "nob",
                    "groupOrder": 0
                }, {
                    "value": "Norwegian (Nynorsk)",
                    "key": "nno",
                    "groupOrder": 0
                }, {
                    "value": "Nubian languages",
                    "key": "nub",
                    "groupOrder": 0
                }, {
                    "value": "Nyamwezi",
                    "key": "nym",
                    "groupOrder": 0
                }, {
                    "value": "Nyanja",
                    "key": "nya",
                    "groupOrder": 0
                }, {
                    "value": "Nyankole",
                    "key": "nyn",
                    "groupOrder": 0
                }, {
                    "value": "Nyoro",
                    "key": "nyo",
                    "groupOrder": 0
                }, {
                    "value": "Nzima",
                    "key": "nzi",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500)",
                    "key": "oci",
                    "groupOrder": 0
                }, {
                    "value": "Occitan (post 1500) (Old Code)",
                    "key": "lan",
                    "groupOrder": 0
                }, {
                    "value": "Oirat",
                    "key": "xal",
                    "groupOrder": 0
                }, {
                    "value": "Ojibwa",
                    "key": "oji",
                    "groupOrder": 0
                }, {
                    "value": "Old Norse",
                    "key": "non",
                    "groupOrder": 0
                }, {
                    "value": "Old Persian (ca. 600-400 B.C.)",
                    "key": "peo",
                    "groupOrder": 0
                }, {
                    "value": "Oriya",
                    "key": "ori",
                    "groupOrder": 0
                }, {
                    "value": "Oromo",
                    "key": "orm",
                    "groupOrder": 0
                }, {
                    "value": "Oromo (Old Code)",
                    "key": "gal",
                    "groupOrder": 0
                }, {
                    "value": "Osage",
                    "key": "osa",
                    "groupOrder": 0
                }, {
                    "value": "Ossetic",
                    "key": "oss",
                    "groupOrder": 0
                }, {
                    "value": "Otomian languages",
                    "key": "oto",
                    "groupOrder": 0
                }, {
                    "value": "Pahlavi",
                    "key": "pal",
                    "groupOrder": 0
                }, {
                    "value": "Palauan",
                    "key": "pau",
                    "groupOrder": 0
                }, {
                    "value": "Pali",
                    "key": "pli",
                    "groupOrder": 0
                }, {
                    "value": "Pampanga",
                    "key": "pam",
                    "groupOrder": 0
                }, {
                    "value": "Pangasinan",
                    "key": "pag",
                    "groupOrder": 0
                }, {
                    "value": "Panjabi",
                    "key": "pan",
                    "groupOrder": 0
                }, {
                    "value": "Papiamento",
                    "key": "pap",
                    "groupOrder": 0
                }, {
                    "value": "Papuan (Other)",
                    "key": "paa",
                    "groupOrder": 0
                }, {
                    "value": "Persian",
                    "key": "per",
                    "groupOrder": 0
                }, {
                    "value": "Philippine (Other)",
                    "key": "phi",
                    "groupOrder": 0
                }, {
                    "value": "Phoenician",
                    "key": "phn",
                    "groupOrder": 0
                }, {
                    "value": "Polish",
                    "key": "pol",
                    "groupOrder": 0
                }, {
                    "value": "Ponape",
                    "key": "pon",
                    "groupOrder": 0
                }, {
                    "value": "Portuguese",
                    "key": "por",
                    "groupOrder": 0
                }, {
                    "value": "Prakrit languages",
                    "key": "pra",
                    "groupOrder": 0
                }, {
                    "value": "Provençal (to 1500)",
                    "key": "pro",
                    "groupOrder": 0
                }, {
                    "value": "Pushto",
                    "key": "pus",
                    "groupOrder": 0
                }, {
                    "value": "Quechua",
                    "key": "que",
                    "groupOrder": 0
                }, {
                    "value": "Raeto-Romance",
                    "key": "roh",
                    "groupOrder": 0
                }, {
                    "value": "Rajasthani",
                    "key": "raj",
                    "groupOrder": 0
                }, {
                    "value": "Rapanui",
                    "key": "rap",
                    "groupOrder": 0
                }, {
                    "value": "Rarotongan",
                    "key": "rar",
                    "groupOrder": 0
                }, {
                    "value": "Romance (Other)",
                    "key": "roa",
                    "groupOrder": 0
                }, {
                    "value": "Romani",
                    "key": "rom",
                    "groupOrder": 0
                }, {
                    "value": "Romanian",
                    "key": "rum",
                    "groupOrder": 0
                }, {
                    "value": "Rundi",
                    "key": "run",
                    "groupOrder": 0
                }, {
                    "value": "Russian",
                    "key": "rus",
                    "groupOrder": 0
                }, {
                    "value": "Salishan languages",
                    "key": "sal",
                    "groupOrder": 0
                }, {
                    "value": "Samaritan Aramaic",
                    "key": "sam",
                    "groupOrder": 0
                }, {
                    "value": "Sami",
                    "key": "smi",
                    "groupOrder": 0
                }, {
                    "value": "Sami (Old Code)",
                    "key": "lap",
                    "groupOrder": 0
                }, {
                    "value": "Samoan",
                    "key": "smo",
                    "groupOrder": 0
                }, {
                    "value": "Samoan (Old Code)",
                    "key": "sao",
                    "groupOrder": 0
                }, {
                    "value": "Sandawe",
                    "key": "sad",
                    "groupOrder": 0
                }, {
                    "value": "Sango (Ubangi Creole)",
                    "key": "sag",
                    "groupOrder": 0
                }, {
                    "value": "Sanskrit",
                    "key": "san",
                    "groupOrder": 0
                }, {
                    "value": "Santali",
                    "key": "sat",
                    "groupOrder": 0
                }, {
                    "value": "Sardinian",
                    "key": "srd",
                    "groupOrder": 0
                }, {
                    "value": "Sasak",
                    "key": "sas",
                    "groupOrder": 0
                }, {
                    "value": "Scots",
                    "key": "sco",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelic",
                    "key": "gla",
                    "groupOrder": 0
                }, {
                    "value": "Scottish Gaelix (Old Code)",
                    "key": "gae",
                    "groupOrder": 0
                }, {
                    "value": "Selkup",
                    "key": "sel",
                    "groupOrder": 0
                }, {
                    "value": "Semitic (Other)",
                    "key": "sem",
                    "groupOrder": 0
                }, {
                    "value": "Serbian",
                    "key": "srp",
                    "groupOrder": 0
                }, {
                    "value": "Serbian (Old Code)",
                    "key": "scc",
                    "groupOrder": 0
                }, {
                    "value": "Serer",
                    "key": "srr",
                    "groupOrder": 0
                }, {
                    "value": "Shan",
                    "key": "shn",
                    "groupOrder": 0
                }, {
                    "value": "Shona",
                    "key": "sna",
                    "groupOrder": 0
                }, {
                    "value": "Shona (Old Code)",
                    "key": "sho",
                    "groupOrder": 0
                }, {
                    "value": "Sichuan Yi",
                    "key": "iii",
                    "groupOrder": 0
                }, {
                    "value": "Sicilian Italian",
                    "key": "scn",
                    "groupOrder": 0
                }, {
                    "value": "Sidamo",
                    "key": "sid",
                    "groupOrder": 0
                }, {
                    "value": "Sign languages",
                    "key": "sgn",
                    "groupOrder": 0
                }, {
                    "value": "Siksika",
                    "key": "bla",
                    "groupOrder": 0
                }, {
                    "value": "Sindhi",
                    "key": "snd",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese",
                    "key": "sin",
                    "groupOrder": 0
                }, {
                    "value": "Sinhalese (Old Code)",
                    "key": "snh",
                    "groupOrder": 0
                }, {
                    "value": "Sino-Tibetan (Other)",
                    "key": "sit",
                    "groupOrder": 0
                }, {
                    "value": "Siouan (Other)",
                    "key": "sio",
                    "groupOrder": 0
                }, {
                    "value": "Skolt Sami",
                    "key": "sms",
                    "groupOrder": 0
                }, {
                    "value": "Slave",
                    "key": "den",
                    "groupOrder": 0
                }, {
                    "value": "Slavic (Other)",
                    "key": "sla",
                    "groupOrder": 0
                }, {
                    "value": "Slovak",
                    "key": "slo",
                    "groupOrder": 0
                }, {
                    "value": "Slovenian",
                    "key": "slv",
                    "groupOrder": 0
                }, {
                    "value": "Sogdian",
                    "key": "sog",
                    "groupOrder": 0
                }, {
                    "value": "Somali",
                    "key": "som",
                    "groupOrder": 0
                }, {
                    "value": "Songhai",
                    "key": "son",
                    "groupOrder": 0
                }, {
                    "value": "Soninke",
                    "key": "snk",
                    "groupOrder": 0
                }, {
                    "value": "Sorbian (Other)",
                    "key": "wen",
                    "groupOrder": 0
                }, {
                    "value": "Sotho",
                    "key": "sot",
                    "groupOrder": 0
                }, {
                    "value": "Sotho (Old Code)",
                    "key": "sso",
                    "groupOrder": 0
                }, {
                    "value": "South American Indian (Other)",
                    "key": "sai",
                    "groupOrder": 0
                }, {
                    "value": "Southern Sami",
                    "key": "sma",
                    "groupOrder": 0
                }, {
                    "value": "Spanish",
                    "key": "spa",
                    "groupOrder": 0
                }, {
                    "value": "Sranan",
                    "key": "srn",
                    "groupOrder": 0
                }, {
                    "value": "Sukuma",
                    "key": "suk",
                    "groupOrder": 0
                }, {
                    "value": "Sumerian",
                    "key": "sux",
                    "groupOrder": 0
                }, {
                    "value": "Sundanese",
                    "key": "sun",
                    "groupOrder": 0
                }, {
                    "value": "Susu",
                    "key": "sus",
                    "groupOrder": 0
                }, {
                    "value": "Swahili",
                    "key": "swa",
                    "groupOrder": 0
                }, {
                    "value": "Swazi",
                    "key": "ssw",
                    "groupOrder": 0
                }, {
                    "value": "Swazi (Old Code)",
                    "key": "swz",
                    "groupOrder": 0
                }, {
                    "value": "Swedish",
                    "key": "swe",
                    "groupOrder": 0
                }, {
                    "value": "Swiss German",
                    "key": "gsw",
                    "groupOrder": 0
                }, {
                    "value": "Syriac",
                    "key": "syc",
                    "groupOrder": 0
                }, {
                    "value": "Syriac, Modern",
                    "key": "syr",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog",
                    "key": "tgl",
                    "groupOrder": 0
                }, {
                    "value": "Tagalog (Old Code)",
                    "key": "tag",
                    "groupOrder": 0
                }, {
                    "value": "Tahitian",
                    "key": "tah",
                    "groupOrder": 0
                }, {
                    "value": "Tai (Other)",
                    "key": "tai",
                    "groupOrder": 0
                }, {
                    "value": "Tajik",
                    "key": "tgk",
                    "groupOrder": 0
                }, {
                    "value": "Tajik (Old Code)",
                    "key": "taj",
                    "groupOrder": 0
                }, {
                    "value": "Tamashek",
                    "key": "tmh",
                    "groupOrder": 0
                }, {
                    "value": "Tamil",
                    "key": "tam",
                    "groupOrder": 0
                }, {
                    "value": "Tatar",
                    "key": "tat",
                    "groupOrder": 0
                }, {
                    "value": "Tatar (Old Code)",
                    "key": "tar",
                    "groupOrder": 0
                }, {
                    "value": "Telugu",
                    "key": "tel",
                    "groupOrder": 0
                }, {
                    "value": "Temne",
                    "key": "tem",
                    "groupOrder": 0
                }, {
                    "value": "Terena",
                    "key": "ter",
                    "groupOrder": 0
                }, {
                    "value": "Tetum",
                    "key": "tet",
                    "groupOrder": 0
                }, {
                    "value": "Thai",
                    "key": "tha",
                    "groupOrder": 0
                }, {
                    "value": "Tibetan",
                    "key": "tib",
                    "groupOrder": 0
                }, {
                    "value": "Tigrinya",
                    "key": "tir",
                    "groupOrder": 0
                }, {
                    "value": "Tigré",
                    "key": "tig",
                    "groupOrder": 0
                }, {
                    "value": "Tiv",
                    "key": "tiv",
                    "groupOrder": 0
                }, {
                    "value": "Tlingit",
                    "key": "tli",
                    "groupOrder": 0
                }, {
                    "value": "Tok Pisin",
                    "key": "tpi",
                    "groupOrder": 0
                }, {
                    "value": "Tokelauan",
                    "key": "tkl",
                    "groupOrder": 0
                }, {
                    "value": "Tonga (Nyasa)",
                    "key": "tog",
                    "groupOrder": 0
                }, {
                    "value": "Tongan",
                    "key": "ton",
                    "groupOrder": 0
                }, {
                    "value": "Truk (Old Code)",
                    "key": "tru",
                    "groupOrder": 0
                }, {
                    "value": "Tsimshian",
                    "key": "tsi",
                    "groupOrder": 0
                }, {
                    "value": "Tsonga",
                    "key": "tso",
                    "groupOrder": 0
                }, {
                    "value": "Tswana",
                    "key": "tsn",
                    "groupOrder": 0
                }, {
                    "value": "Tswana (Old Code)",
                    "key": "tsw",
                    "groupOrder": 0
                }, {
                    "value": "Tumbuka",
                    "key": "tum",
                    "groupOrder": 0
                }, {
                    "value": "Tupi languages",
                    "key": "tup",
                    "groupOrder": 0
                }, {
                    "value": "Turkish",
                    "key": "tur",
                    "groupOrder": 0
                }, {
                    "value": "Turkish, Ottoman",
                    "key": "ota",
                    "groupOrder": 0
                }, {
                    "value": "Turkmen",
                    "key": "tuk",
                    "groupOrder": 0
                }, {
                    "value": "Tuvaluan",
                    "key": "tvl",
                    "groupOrder": 0
                }, {
                    "value": "Tuvinian",
                    "key": "tyv",
                    "groupOrder": 0
                }, {
                    "value": "Twi",
                    "key": "twi",
                    "groupOrder": 0
                }, {
                    "value": "Udmurt",
                    "key": "udm",
                    "groupOrder": 0
                }, {
                    "value": "Ugaritic",
                    "key": "uga",
                    "groupOrder": 0
                }, {
                    "value": "Uighur",
                    "key": "uig",
                    "groupOrder": 0
                }, {
                    "value": "Ukrainian",
                    "key": "ukr",
                    "groupOrder": 0
                }, {
                    "value": "Umbundu",
                    "key": "umb",
                    "groupOrder": 0
                }, {
                    "value": "Undetermined",
                    "key": "und",
                    "groupOrder": 0
                }, {
                    "value": "Upper Sorbian",
                    "key": "hsb",
                    "groupOrder": 0
                }, {
                    "value": "Urdu",
                    "key": "urd",
                    "groupOrder": 0
                }, {
                    "value": "Uzbek",
                    "key": "uzb",
                    "groupOrder": 0
                }, {
                    "value": "Vai",
                    "key": "vai",
                    "groupOrder": 0
                }, {
                    "value": "Venda",
                    "key": "ven",
                    "groupOrder": 0
                }, {
                    "value": "Vietnamese",
                    "key": "vie",
                    "groupOrder": 0
                }, {
                    "value": "Volapük",
                    "key": "vol",
                    "groupOrder": 0
                }, {
                    "value": "Votic",
                    "key": "vot",
                    "groupOrder": 0
                }, {
                    "value": "Wakashan languages",
                    "key": "wak",
                    "groupOrder": 0
                }, {
                    "value": "Walloon",
                    "key": "wln",
                    "groupOrder": 0
                }, {
                    "value": "Waray",
                    "key": "war",
                    "groupOrder": 0
                }, {
                    "value": "Washo",
                    "key": "was",
                    "groupOrder": 0
                }, {
                    "value": "Welsh",
                    "key": "wel",
                    "groupOrder": 0
                }, {
                    "value": "Western Pahari languages",
                    "key": "him",
                    "groupOrder": 0
                }, {
                    "value": "Wolayta",
                    "key": "wal",
                    "groupOrder": 0
                }, {
                    "value": "Wolof",
                    "key": "wol",
                    "groupOrder": 0
                }, {
                    "value": "Xhosa",
                    "key": "xho",
                    "groupOrder": 0
                }, {
                    "value": "Yakut",
                    "key": "sah",
                    "groupOrder": 0
                }, {
                    "value": "Yao (Africa)",
                    "key": "yao",
                    "groupOrder": 0
                }, {
                    "value": "Yapese",
                    "key": "yap",
                    "groupOrder": 0
                }, {
                    "value": "Yiddish",
                    "key": "yid",
                    "groupOrder": 0
                }, {
                    "value": "Yoruba",
                    "key": "yor",
                    "groupOrder": 0
                }, {
                    "value": "Yupik languages",
                    "key": "ypk",
                    "groupOrder": 0
                }, {
                    "value": "Zande languages",
                    "key": "znd",
                    "groupOrder": 0
                }, {
                    "value": "Zapotec",
                    "key": "zap",
                    "groupOrder": 0
                }, {
                    "value": "Zaza",
                    "key": "zza",
                    "groupOrder": 0
                }, {
                    "value": "Zenaga",
                    "key": "zen",
                    "groupOrder": 0
                }, {
                    "value": "Zhuang",
                    "key": "zha",
                    "groupOrder": 0
                }, {
                    "value": "Zulu",
                    "key": "zul",
                    "groupOrder": 0
                }, {
                    "value": "Zuni",
                    "key": "zun",
                    "groupOrder": 0
                }]
        },
        "dc_publisher": {
            "key": "dc_publisher",
            "value": "dc:publisher",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_relation": {
            "key": "dc_relation",
            "value": "dc:relation",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_rights": {
            "key": "dc_rights",
            "value": "dc:rights",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_source": {
            "key": "dc_source",
            "value": "dc:source",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_subject": {
            "key": "dc_subject",
            "value": "dc:subject",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_title": {
            "key": "dc_title",
            "value": "dc:title",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "START_WITH",
                    "op_value": "Starts With"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_OUTER_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "dc_type": {
            "key": "dc_type",
            "value": "dc:type",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }, {
                    "op_key": "NOT_EQUAL",
                    "op_value": "Not Equals"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_context": {
            "key": "lom_context",
            "value": "lom-edu:context",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_description": {
            "key": "lom_description",
            "value": "lom-edu:description",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_difficulty": {
            "key": "lom_difficulty",
            "value": "lom-edu:difficulty",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_intendedEndUserRole": {
            "key": "lom_intendedEndUserRole",
            "value": "lom-edu:intendedEndUserRole",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_interactivityLevel": {
            "key": "lom_interactivityLevel",
            "value": "lom-edu:interactivityLevel",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_interactivityType": {
            "key": "lom_interactivityType",
            "value": "lom-edu:interactivityType",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_language": {
            "key": "lom_language",
            "value": "lom-edu:language",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_semanticDensity": {
            "key": "lom_semanticDensity",
            "value": "lom-edu:semanticDensity",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_type": {
            "key": "lom_type",
            "value": "lom-edu:type",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        },
        "lom_typicalLearningTime": {
            "key": "lom_typicalLearningTime",
            "value": "lom-edu:typicalLearningTime",
            "type": "string",
            "preferred_operators": [{
                    "op_key": "CONTAIN",
                    "op_value": "Contains Keywords"
                }, {
                    "op_key": "EQUAL",
                    "op_value": "Contains Phrase"
                }, {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }, {
                    "op_key": "NOT_CONTAIN",
                    "op_value": "Not Contains Keywords"
                }, {
                    "op_key": "NOT_EQUAL_TMP",
                    "op_value": "Not Contains Phrase"
                }, {
                    "op_key": "NOT_EMPTY",
                    "op_value": "Is Not Empty"
                }]
        }
    }
};
const BIBLE_CONFIG = {
    "allowEmptyRulesets": false,
    "fields": {
        "fathers": {
            "searchType": "EQUALS_ONLY",
            "type": "category",
            "value": "fathers",
            "fieldGroup": "0",
            "key": "fathers",
            "options": [
                {
                    "value": "AVRAHAM",
                    "key": "AVRAHAM",
                    "groupOrder": 0
                },
                {
                    "value": "ITZCHAK",
                    "key": "ITZCHAK",
                    "groupOrder": 0
                },
                {
                    "value": "IAAKOV",
                    "key": "IAAKOV",
                    "groupOrder": 0
                },
                {
                    "value": "NONE",
                    "key": "NONE",
                    "groupOrder": 0
                }
            ],
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }
            ],
            "visible": []
        },
        "wifes": {
            "searchType": "EQUALS_ONLY",
            "type": "category",
            "value": "wifes",
            "fieldGroup": "0",
            "key": "wifes",
            "options": [
                {
                    "value": "SARAH",
                    "key": "SARAH",
                    "groupOrder": 0
                }, {
                    "value": "HAGAR",
                    "key": "HAGAR",
                    "groupOrder": 0
                }, {
                    "value": "RIVKA",
                    "key": "RIVKA",
                    "groupOrder": 0
                }, {
                    "value": "LEA",
                    "key": "LEA",
                    "groupOrder": 0
                }, {
                    "value": "RAHEL",
                    "key": "RAHEL",
                    "groupOrder": 0
                }
            ],
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }
            ],
            "visible": [
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "AVRAHAM",
                    "options": [
                        "SARAH",
                        "HAGAR",
                    ]
                },
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "ITZCHAK",
                    "options": [
                        "RIVKA",
                    ]
                },
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "IAAKOV",
                    "options": [
                        "LEA",
                        "RAHEL"
                    ]
                }
            ]
        },
        "nisionot": {
            "searchType": "EQUALS_ONLY",
            "type": "category",
            "value": "nisionot",
            "fieldGroup": "0",
            "key": "nisionot",
            "options": [
                {
                    "value": "Akedat_Itchak",
                    "key": "Akedat_Itchak",
                    "groupOrder": 0
                },
                {
                    "value": "Lech_Lecha",
                    "key": "Lech_Lecha",
                    "groupOrder": 0
                }
            ],
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }
            ],
            "visible": [
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "AVRAHAM",
                    "options": []
                },
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "ITZCHAK",
                    "options": ['Akedat_Itchak']
                },
            ]
        },
        "iaakov_childern_free_text": {
            "searchType": "EQUALS_ONLY",
            "type": "string",
            "value": "iaakov_childern",
            "fieldGroup": "0",
            "key": "iaakov_childern",
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                },
                {
                    "op_key": "ALL_VALUES",
                    "op_value": "Equals Any Value"
                },
                {
                    "op_key": "EMPTY",
                    "op_value": "Is Empty"
                }
            ],
            "visible": [
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "IAAKOV",
                    "options": []
                },
                {
                    "dependencyFieldName": "wifes",
                    "dependencyFieldValue": "LEA",
                    "options": []
                }
            ]
        },
        "iaakov_childern_checkbox": {
            "searchType": "EQUALS_ONLY",
            "type": "category",
            "value": "iaakov_childern",
            "fieldGroup": "0",
            "key": "iaakov_childern",
            "options": [
                {
                    "value": "SON1",
                    "key": "SON1",
                    "groupOrder": 0
                },
                {
                    "value": "SON2",
                    "key": "SON2",
                    "groupOrder": 0
                }
            ],
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                }
            ],
            "visible": [
                {
                    "dependencyFieldName": "fathers",
                    "dependencyFieldValue": "IAAKOV",
                    "options": []
                },
                {
                    "dependencyFieldName": "wifes",
                    "dependencyFieldValue": "RAHEL",
                    "options": []
                }
            ]
        },
        "allways_show": {
            "searchType": "EQUALS_ONLY",
            "type": "string",
            "value": "Search Value",
            "fieldGroup": "0",
            "key": "allways_show",
            "preferred_operators": [
                {
                    "op_key": "OUTER_EQUAL",
                    "op_value": "Equals"
                },
                {
                    "op_key": "COMPOSITE_EXACT_PHRASE_STARTING_WITH",
                    "op_value": "Exact phrase starting with"
                }
            ],
            "visible": []
        }
    }
};
const HEADING_INFO_SIMPLE_QUERY = {
    condition: 'and',
    rules: [
        {
            field: 'heading_info',
            group: undefined,
            type: 'compositeSearch',
            operator: 'OUTER_EQUAL',
            validator: undefined,
            new: false,
            validationErrorMessage: 'qb.required_field',
            value: 'browse_type=NAMES##source_code=CORPORATE_NAME##family=MARC21##vocabulary_code=LCNAMES'
        }
    ]
};
const QUERY_BUILDER_SIMPLE_QUERY = {
    condition: 'or',
    rules: [
        {
            field: "type_of_date",
            group: undefined,
            new: false,
            operator: "OUTER_EQUAL",
            type: "category",
            validationErrorMessage: "qb.required_field",
            validator: undefined,
            value: "p"
        },
        {
            field: "mms_createDate",
            group: undefined,
            new: false,
            operator: "NOT_EQUAL",
            type: "date",
            validationErrorMessage: "qb.required_field",
            validator: undefined,
            value: null
        }
    ]
};

/*
 * Public API Surface of ex-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionModel, Actions, ActionsDisplayModes, AngularResizeEventModule, BIBLE_CONFIG, CONFIG, CONTROL_VALUE_ACCESSOR, ChipField, Column, ComboboxListsModel, CoreUiComponent, CoreUiModule, CoreUiService, CustomBackgroundRowColor, DEFAULT_ERROR_LABELS, DELAY_BEFORE_SHOW_CONTENT, DELAY_BEFORE_SHOW_MENU, DeepLinkModeDirective, EXPipesModule, EX_APP_IN_SIDEPANE, EX_APP_LANGUAGE, EX_ARIA_ATTRIBUTES, EX_DATE_FORMAT, EX_EDITING_LIST, EX_FORM_FIELD_LABEL, EX_FORM_WARNINGS_PROPERTY_NAME, EX_IS_INSIDE_GRID, EX_NAVIGATE_TO_FIELD, EX_PAGE_ID, EX_PAGE_ID_WITH_CUSTOMIZATION_PROFILE, EX_QUICK_ACCESS, EX_QUICK_ACCESS_ACTIVE, EX_QUICK_ACCESS_SCOPE, EX_REMOTE_EVENT_TRIGGER, EX_SECTION_IDENTIFIER, EX_TIME_FORMAT, EditModeComponentDirective, Editable, EditingListComponent, EntityLabelsField, ExAceEditorComponent, ExAceEditorModule, ExActionMenuComponent, ExActionMenuModule, ExAppliedFacetsComponent, ExAreaChartComponent, ExAutocompleteComponent, ExAutocompleteModule, ExAvatarComponent, ExAvatarModule, ExBadgeComponent, ExBadgeModule, ExBanner, ExBannerComponent, ExBannerModule, ExBarChartComponent, ExBubbleChartComponent, ExBulkActionIndicationService, ExButtonComponent, ExButtonModule, ExCardWrapperComponent, ExCardWrapperModule, ExCarouselLayoutComponent, ExCarouselLayoutIdentifierDirective, ExCarouselLayoutModule, ExChartsModule, ExCheckboxComponent, ExCheckboxFacetsComponent, ExCheckboxFacetsLabels, ExCheckboxModule, ExChipComponent, ExChipModule, ExChipRecordComponent, ExChipRecordEntityLabelsComponent, ExChipRecordModule, ExClassNameFormatPipe, ExClickOutsideDirective, ExClickableChipComponent, ExCloseComponent, ExCloseModule, ExColorPickerComponent, ExColorPickerModule, ExComboboxComponent, ExComboboxModule, ExComboboxMultiselectComponent, ExComboboxMultiselectTriggerComponent, ExComponentFactoryItem, ExComponentFormLoaderComponent, ExComponentLoaderComponent, ExComponentLoaderModule, ExConfirmationMessageComponent, ExConfirmationMessageModule, ExControlValueAccessor, ExDatePickerComponent, ExDatePickerModule, ExDateRangePickerComponent, ExDateRangePickerModule, ExDialogComboboxComponent, ExDialogComboboxModule, ExDialogComponent, ExDialogComponentResetCode, ExDialogModule, ExDialogService, ExDirectivesModule, ExDisplayActionsPipe, ExDisplayTextComponent, ExDisplayTextModule, ExDisplayTextTypes, ExDotWrapperComponent, ExDotWrapperModule, ExDragAccessibleIconComponent, ExDragDirective, ExDragGroupComponent, ExDragListComponent, ExDragListDirective, ExDragModule, ExDropdownComponent, ExDropdownModule, ExEditableTextComponent, ExEditableTextModule, ExEditingCardComponent, ExEditingCardsComponent, ExEditingCardsModule, ExEditingListModule, ExEntityInfoComponent, ExEntityInfoModule, ExEscapeHtmlPipe, ExExpandableLabelComponent, ExExpandableLabelModule, ExExpandableSublistComponent, ExExtendedSearchComponent, ExExtendedSearchModule, ExFacetCheckboxesComponent, ExFacetFactoryItem, ExFacetHierarchyComponent, ExFacetLinkComponent, ExFacetRangeComponent$1 as ExFacetRangeComponent, ExFacetToggleComponent, ExFacetWrapperComponent, ExFacetWrapperLabels, ExFacetsModule, ExFacetsTypes, ExFallbackIconComponent, ExFallbackIconModule, ExFeatureFlagPipe, ExFileDropComponent, ExFileDropModule, ExFileIconComponent, ExFileIconModule, ExFileSelectComponent, ExFileSelectModule, ExFilterComponent, ExFilterDefaultKey, ExFiltersComponent, ExFiltersModule, ExFlexbrowseChipComponent, ExFlexbrowseItemComponent, ExFlexbrowseItemData, ExFlexbrowseSelectedPathComponent, ExFlexbrowseSelectionComponent, ExFlexbrowseSelectionModule, ExFloatLabelComponent, ExFloatLabelsComponent, ExFloatLabelsModule, ExFloatingAddComponentComponent, ExFloatingAddComponentModule, ExFloatingComponentComponent, ExFloatingComponentModule, ExFocusDirective, ExFormActionsComponent, ExFormAriaAttributesDirective, ExFormComponent, ExFormControlName, ExFormDialogComponent, ExFormErrorLabels, ExFormFieldComponent, ExFormFieldDirective, ExFormFieldsComponent, ExFormGroupDirective, ExFormUtil, ExFormValidators, ExFormsModule, ExGenerateIdPipe, ExGridFactoryItem, ExGridLayoutComponent, ExGridLayoutModule, ExGroupOutletComponent2, ExHelpIconComponent, ExHelpIconModule, ExHierarchyFacet, ExIconComponent, ExIconModule, ExInViewportDirective, ExInformativeProgressBar, ExInformativeProgressBarModule, ExInitialsPipe, ExInlineEditingButtonsComponent, ExInlineEditingButtonsModule, ExInlineEditingComponent, ExInlineEditingModule, ExIsSortableColumnPipe, ExItemDetailsHeaderComponent, ExItemDetailsHeaderStatusService, ExItemsLayoutComponent, ExItemsLayoutGridColumnNames, ExItemsLayoutGridComponent, ExItemsLayoutModule, ExItemsLayoutService, ExItemsLayoutTreeNodeTemplateDirective, ExKeyboardShortcutDirective, ExLabelComboboxComponent, ExLabelComboboxModule, ExLabelComponent, ExLabelModule, ExLayoutCustomizationMenuComponent, ExLayoutCustomizationMenuModule, ExLegendComponent, ExLegendModule, ExLineChartComponent, ExLinkComponent, ExLinkModule, ExListCustomizationComponent, ExListCustomizationModule, ExListHeaderComponent, ExListHeaderModule, ExListLayoutComponent, ExListLayoutModule, ExLiveAnnouncerService, ExMainLayoutComponent, ExMainLayoutModule, ExMenuComponent, ExMenuModule, ExMultiLayoutComponent, ExMultiLayoutIdentifierDirective, ExMultiLayoutModule, ExMultiselectComboboxComponent, ExMultiselectComboboxModule, ExNewComboboxComponent, ExNewComboboxModule, ExNewFacetsModule, ExNewFacetsTypes, ExNewFacetsWrapperComponent, ExNewPieChartComponent, ExNoteComponent, ExNoteModule, ExObjectAssignPipe, ExOverlay, ExOverlayContainer, ExPageIdDirective, ExPaginationComponent, ExPaginationModule, ExPieChartComponent, ExPieChartModule, ExPolarChartComponent, ExProgressBarComponent, ExProgressBarModule, ExQueryBuilderComponent, ExQueryBuilderModule, ExQuickAccessDirective, ExRadioButtonsComponent, ExRadioButtonsModule, ExRecordActionsComponent, ExRecordActionsModule, ExRecordActionsService, ExRecordComponent, ExRecordGalleryPlaceholderComponent, ExRecordPlaceholderComponent, ExRemoteEventTriggerDirective, ExResizableDirective, ExResizeColumnDirective, ExRichTextEditorComponent, ExRichTextEditorModule, ExRightClickActionsComponent, ExRightClickActionsModule, ExScaleComponent, ExScaleModule, ExSearchComponent, ExSearchModule, ExSearchToggleComponent, ExSearchToggleModule, ExSectionComponent, ExSectionHeaderDirective, ExSectionIdentifierDirective, ExSectionPlaceholderComponent, ExSectionsLayoutApmService, ExSectionsLayoutComponent, ExSectionsLayoutDropdownComponent, ExSectionsLayoutListLayoutService, ExSectionsLayoutModule, ExSectionsLayoutSectionService, ExSectionsLayoutService, ExSelectedFacetComponent, ExSelectedFacetsWrapperComponent, ExSelectionListComponent, ExSelectionListModule, ExShortcutsService, ExShowMoreLessComponent, ExShowMoreLessModule, ExSideBySideComponent, ExSideBySideModule, ExSidenavModule, ExSidenavPageComponent, ExSidenavPageService, ExSidepaneComponent, ExSidepaneModule, ExSidepaneService, ExSlideToggleComponent, ExSlideToggleModule, ExSortComponent, ExSortModule, ExSpinnerComponent, ExSpinnerModule, ExSummarySectionComponent, ExSummarySectionModule, ExSummarySectionsCollapsedComponent, ExSummarySectionsCollapsedModule, ExSvgIconComponent, ExSvgIconModule, ExTabComponent, ExTabModule, ExTabsWrapperComponent, ExTabsWrapperModule, ExTextHighlightPipe, ExTextStylePipe, ExTextTruncatePipe, ExThumbnailComponent, ExThumbnailModule, ExToggleComponent, ExToggleModule, ExTooltipDirective, ExTypedInputComponent, ExTypedInputModule, ExUnderThumbnailIconsPipe, Field, FilterItemsByKeyPipe, FilterItemsPipe, FilterModel, Footer, FreeTextInputTypes, FullPageTitle, FullPageTitleIcon, GalleryField, GeneralListLayoutComponent, HAS_FORM_FIELDS_BORDERS, HEADING_INFO_SIMPLE_QUERY, HEP_SIDEPANE_CLOSE_EVENT_NAME, HasCustomizationForType, HeaderMenus, HepApm, IFeatureFlagsService, IS_SINGLE_SAVE, ITEMS_LAYOUT_ITEM_TOGGLE_ACTION, IUserPreferencesService, IconModel, IconType, IgnoreLegacyTransform, ItemDetailsHeaderStatus, ItemStatusService, LAYOUT_UPDATING_PRIMARY_ENTITY, LAYOUT_WRAPPER_GET_BOUNDS, LabelField, LayoutCustomizationModel, LayoutCustomizationPermissions, LayoutCustomizationTypes, ListProperties, MAX_SEC_WAITING_FOR_SECTION_LOADING, MINIMUM_CONTENT_SIZE, MULTI_SELECT_ALL, MandatoryFieldData, MenuItemComponent, MenuItemModule, MenuItemService, MinValidator, MyContext, NEW_SECTIONS_DESIGN, NoResultsComponentDirective, PageColumnBase, PaginationFloatingComponent, PaginationModel, PickupIgnoredField, PickupSelectedKey, PickupSelectedLabel, PopUpActionModel, PopUpAddActionModel, QUERY_BUILDER_SIMPLE_QUERY, QuickAccessType, QyeryBuilderAnimations, RecordLayout, RelativeDateOperators, ResizedDirective, ResizedEvent, SCROLLING_ELEMENT_SELECTOR, SECONDARY_SEARCH, SECTION_FORM_IDENTIFIER_DELIMITER, SINGLE_SAVE_FORM_CONTROL_VALIDATION_ERROR_LABEL_PREFIX, SectionKeys, SelectedItemsTransformPipe, SelectionMenuComponent, SelectionMenuModule, SidenavPanel, SidenavTrigger, SidepaneRef, SingleSaveExitWithoutSaveWarning, SortModel, Status, Thumbnail, ThumbnailIcon, Title, TrackedEditableEntryComponent, TrackedEditableEntryListComponent, TreeField, UnderThumbnailIcon, VALIDATOR, VIEW_MODE, VIEW_MODE_OBSERVABLE, ViewModeComponent, ViewModeComponentDirective, ViewModes, WINDOW, dotColor, exShortcutsScopeDirective, getIconSizeInPx, getValueAccessors, hasSecondarySearch, initArray, keyMapSpecial, menuItem, sidenavKeys, svgColors };
